var VA = Object.defineProperty;
var RA = (t, e, n) => e in t ? VA(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var O2 = (t, e, n) => (RA(t, typeof e != "symbol" ? e + "" : e, n), n);
import { computed as g1, getCurrentInstance as t9, defineComponent as c2, ref as D1, h as w8, onMounted as d0, watch as l3, unref as H, onUnmounted as mn, provide as Zb, toRefs as s3, nextTick as D0, isRef as Jb, inject as HA, resolveComponent as V2, openBlock as T, createElementBlock as N, mergeProps as Ht, renderSlot as J2, createBlock as v2, withCtx as Q2, normalizeClass as f2, normalizeStyle as Rt, createElementVNode as C, createCommentVNode as m2, resolveDynamicComponent as be, createTextVNode as K3, toDisplayString as pt, Fragment as I3, renderList as Ve, createVNode as _3, withModifiers as Et, getCurrentScope as Qb, onScopeDispose as eL, toRef as DA, readonly as $A, customRef as UA, resolveDirective as ku, Transition as tL, withKeys as P5, withDirectives as b6, vModelDynamic as jA, createSlots as nL, normalizeProps as on, guardReactiveProps as v8, pushScopeId as $s, popScopeId as Us, createStaticVNode as U1, withScopeId as GA, createApp as iL, vShow as Na, vModelText as WA, reactive as pc, shallowRef as YA, shallowReadonly as jr, toHandlers as Io, watchEffect as XA, onBeforeUnmount as sL, Teleport as lL, defineAsyncComponent as r5 } from "vue";
import { RouterLink as KA, useRouter as S8, useRoute as ZA } from "vue-router";
import { useI18n as js } from "vue-i18n";
import { VGridPlugin as JA } from "@revolist/vue3-datagrid";
import QA from "write-excel-file";
const rL = "4.5.8";
var ys = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function aL(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var oL = { exports: {} };
/*!
  * Stickyfill – `position: sticky` polyfill
  * v. 2.1.0 | https://github.com/wilddeer/stickyfill
  * MIT License
  */
(function(t) {
  (function(e, n) {
    var i = /* @__PURE__ */ function() {
      function z(b, x) {
        for (var k = 0; k < x.length; k++) {
          var F = x[k];
          F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(b, F.key, F);
        }
      }
      return function(b, x, k) {
        return x && z(b.prototype, x), k && z(b, k), b;
      };
    }();
    function s(z, b) {
      if (!(z instanceof b))
        throw new TypeError("Cannot call a class as a function");
    }
    var l = !1, a = typeof e < "u";
    !a || !e.getComputedStyle ? l = !0 : function() {
      var z = n.createElement("div");
      ["", "-webkit-", "-moz-", "-ms-"].some(function(b) {
        try {
          z.style.position = b + "sticky";
        } catch {
        }
        return z.style.position != "";
      }) && (l = !0);
    }();
    var o = !1, h = typeof ShadowRoot < "u", u = {
      top: null,
      left: null
    }, d = [];
    function v(z, b) {
      for (var x in b)
        b.hasOwnProperty(x) && (z[x] = b[x]);
    }
    function m(z) {
      return parseFloat(z) || 0;
    }
    function p(z) {
      for (var b = 0; z; )
        b += z.offsetTop, z = z.offsetParent;
      return b;
    }
    var _ = function() {
      function z(b) {
        if (s(this, z), !(b instanceof HTMLElement))
          throw new Error("First argument must be HTMLElement");
        if (d.some(function(x) {
          return x._node === b;
        }))
          throw new Error("Stickyfill is already applied to this node");
        this._node = b, this._stickyMode = null, this._active = !1, d.push(this), this.refresh();
      }
      return i(z, [{
        key: "refresh",
        value: function() {
          if (!(l || this._removed)) {
            this._active && this._deactivate();
            var b = this._node, x = getComputedStyle(b), k = {
              position: x.position,
              top: x.top,
              display: x.display,
              marginTop: x.marginTop,
              marginBottom: x.marginBottom,
              marginLeft: x.marginLeft,
              marginRight: x.marginRight,
              cssFloat: x.cssFloat
            };
            if (!(isNaN(parseFloat(k.top)) || k.display == "table-cell" || k.display == "none")) {
              this._active = !0;
              var F = b.style.position;
              (x.position == "sticky" || x.position == "-webkit-sticky") && (b.style.position = "static");
              var D = b.parentNode, R = h && D instanceof ShadowRoot ? D.host : D, V = b.getBoundingClientRect(), J = R.getBoundingClientRect(), K = getComputedStyle(R);
              this._parent = {
                node: R,
                styles: {
                  position: R.style.position
                },
                offsetHeight: R.offsetHeight
              }, this._offsetToWindow = {
                left: V.left,
                right: n.documentElement.clientWidth - V.right
              }, this._offsetToParent = {
                top: V.top - J.top - m(K.borderTopWidth),
                left: V.left - J.left - m(K.borderLeftWidth),
                right: -V.right + J.right - m(K.borderRightWidth)
              }, this._styles = {
                position: F,
                top: b.style.top,
                bottom: b.style.bottom,
                left: b.style.left,
                right: b.style.right,
                width: b.style.width,
                marginTop: b.style.marginTop,
                marginLeft: b.style.marginLeft,
                marginRight: b.style.marginRight
              };
              var P = m(k.top);
              this._limits = {
                start: V.top + e.pageYOffset - P,
                end: J.top + e.pageYOffset + R.offsetHeight - m(K.borderBottomWidth) - b.offsetHeight - P - m(k.marginBottom)
              };
              var O = K.position;
              O != "absolute" && O != "relative" && (R.style.position = "relative"), this._recalcPosition();
              var G = this._clone = {};
              G.node = n.createElement("div"), v(G.node.style, {
                width: V.right - V.left + "px",
                height: V.bottom - V.top + "px",
                marginTop: k.marginTop,
                marginBottom: k.marginBottom,
                marginLeft: k.marginLeft,
                marginRight: k.marginRight,
                cssFloat: k.cssFloat,
                padding: 0,
                border: 0,
                borderSpacing: 0,
                fontSize: "1em",
                position: "static"
              }), D.insertBefore(G.node, b), G.docOffsetTop = p(G.node);
            }
          }
        }
      }, {
        key: "_recalcPosition",
        value: function() {
          if (!(!this._active || this._removed)) {
            var b = u.top <= this._limits.start ? "start" : u.top >= this._limits.end ? "end" : "middle";
            if (this._stickyMode != b) {
              switch (b) {
                case "start":
                  v(this._node.style, {
                    position: "absolute",
                    left: this._offsetToParent.left + "px",
                    right: this._offsetToParent.right + "px",
                    top: this._offsetToParent.top + "px",
                    bottom: "auto",
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0
                  });
                  break;
                case "middle":
                  v(this._node.style, {
                    position: "fixed",
                    left: this._offsetToWindow.left + "px",
                    right: this._offsetToWindow.right + "px",
                    top: this._styles.top,
                    bottom: "auto",
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0
                  });
                  break;
                case "end":
                  v(this._node.style, {
                    position: "absolute",
                    left: this._offsetToParent.left + "px",
                    right: this._offsetToParent.right + "px",
                    top: "auto",
                    bottom: 0,
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0
                  });
                  break;
              }
              this._stickyMode = b;
            }
          }
        }
      }, {
        key: "_fastCheck",
        value: function() {
          !this._active || this._removed || (Math.abs(p(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) && this.refresh();
        }
      }, {
        key: "_deactivate",
        value: function() {
          var b = this;
          !this._active || this._removed || (this._clone.node.parentNode.removeChild(this._clone.node), delete this._clone, v(this._node.style, this._styles), delete this._styles, d.some(function(x) {
            return x !== b && x._parent && x._parent.node === b._parent.node;
          }) || v(this._parent.node.style, this._parent.styles), delete this._parent, this._stickyMode = null, this._active = !1, delete this._offsetToWindow, delete this._offsetToParent, delete this._limits);
        }
      }, {
        key: "remove",
        value: function() {
          var b = this;
          this._deactivate(), d.some(function(x, k) {
            if (x._node === b._node)
              return d.splice(k, 1), !0;
          }), this._removed = !0;
        }
      }]), z;
    }(), q = {
      stickies: d,
      Sticky: _,
      forceSticky: function() {
        l = !1, M(), this.refreshAll();
      },
      addOne: function(z) {
        if (!(z instanceof HTMLElement))
          if (z.length && z[0])
            z = z[0];
          else
            return;
        for (var b = 0; b < d.length; b++)
          if (d[b]._node === z)
            return d[b];
        return new _(z);
      },
      add: function(z) {
        if (z instanceof HTMLElement && (z = [z]), !!z.length) {
          for (var b = [], x = function(D) {
            var R = z[D];
            if (!(R instanceof HTMLElement))
              return b.push(void 0), "continue";
            if (d.some(function(V) {
              if (V._node === R)
                return b.push(V), !0;
            }))
              return "continue";
            b.push(new _(R));
          }, k = 0; k < z.length; k++)
            var F = x(k);
          return b;
        }
      },
      refreshAll: function() {
        d.forEach(function(z) {
          return z.refresh();
        });
      },
      removeOne: function(z) {
        if (!(z instanceof HTMLElement))
          if (z.length && z[0])
            z = z[0];
          else
            return;
        d.some(function(b) {
          if (b._node === z)
            return b.remove(), !0;
        });
      },
      remove: function(z) {
        if (z instanceof HTMLElement && (z = [z]), !!z.length)
          for (var b = function(k) {
            var F = z[k];
            d.some(function(D) {
              if (D._node === F)
                return D.remove(), !0;
            });
          }, x = 0; x < z.length; x++)
            b(x);
      },
      removeAll: function() {
        for (; d.length; )
          d[0].remove();
      }
    };
    function M() {
      if (o)
        return;
      o = !0;
      function z() {
        e.pageXOffset != u.left ? (u.top = e.pageYOffset, u.left = e.pageXOffset, q.refreshAll()) : e.pageYOffset != u.top && (u.top = e.pageYOffset, u.left = e.pageXOffset, d.forEach(function(R) {
          return R._recalcPosition();
        }));
      }
      z(), e.addEventListener("scroll", z), e.addEventListener("resize", q.refreshAll), e.addEventListener("orientationchange", q.refreshAll);
      var b = void 0;
      function x() {
        b = setInterval(function() {
          d.forEach(function(R) {
            return R._fastCheck();
          });
        }, 500);
      }
      function k() {
        clearInterval(b);
      }
      var F = void 0, D = void 0;
      "hidden" in n ? (F = "hidden", D = "visibilitychange") : "webkitHidden" in n && (F = "webkitHidden", D = "webkitvisibilitychange"), D ? (n[F] || x(), n.addEventListener(D, function() {
        n[F] ? k() : x();
      })) : x();
    }
    l || M(), t.exports ? t.exports = q : a && (e.Stickyfill = q);
  })(window, document);
})(oL);
var eF = oL.exports;
const tF = /* @__PURE__ */ aL(eF), Cw = (t, e = document) => [].slice.call(e.querySelectorAll(t)), Q5 = (t, e = document) => e.querySelector(t);
class nF {
  /**
   * Constructs a new EventManager.
   */
  constructor() {
    this.events = /* @__PURE__ */ new Map();
  }
  /**
   * Register a callback for a specific event.
   * @param {string} eventName - The name of the event.
   * @param {Function} callback - The callback function to be executed when the event is triggered.
   */
  on(e, n) {
    this.events.has(e) || this.events.set(e, []), this.events.get(e).push(n);
  }
  /**
   * Trigger an event, executing all registered callbacks for that event.
   * @param {string} eventName - The name of the event to trigger.
   * @param {any} eventData - Additional data to pass to the callbacks.
   */
  trigger(e, n) {
    const i = this.events.get(e);
    i && i.forEach((s) => {
      s(n);
    });
  }
  /**
   * Retrieve the most recently registered callback for a specific event.
   * @param {string} eventName - The name of the event.
   * @returns {Function|null} - The most recently registered callback, or null if none is registered.
   */
  getCallback(e) {
    return this.events.get(e) || [];
  }
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var cL = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Eh = /* @__PURE__ */ cL.join(","), hL = typeof Element > "u", fr = hL ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ah = !hL && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, Fh = function t(e, n) {
  var i;
  n === void 0 && (n = !0);
  var s = e == null || (i = e.getAttribute) === null || i === void 0 ? void 0 : i.call(e, "inert"), l = s === "" || s === "true", a = l || n && e && t(e.parentNode);
  return a;
}, iF = function(t) {
  var e, n = t == null || (e = t.getAttribute) === null || e === void 0 ? void 0 : e.call(t, "contenteditable");
  return n === "" || n === "true";
}, uL = function(t, e, n) {
  if (Fh(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(Eh));
  return e && fr.call(t, Eh) && i.unshift(t), i = i.filter(n), i;
}, dL = function t(e, n, i) {
  for (var s = [], l = Array.from(e); l.length; ) {
    var a = l.shift();
    if (!Fh(a, !1))
      if (a.tagName === "SLOT") {
        var o = a.assignedElements(), h = o.length ? o : a.children, u = t(h, !0, i);
        i.flatten ? s.push.apply(s, u) : s.push({
          scopeParent: a,
          candidates: u
        });
      } else {
        var d = fr.call(a, Eh);
        d && i.filter(a) && (n || !e.includes(a)) && s.push(a);
        var v = a.shadowRoot || // check for an undisclosed shadow
        typeof i.getShadowRoot == "function" && i.getShadowRoot(a), m = !Fh(v, !1) && (!i.shadowRootFilter || i.shadowRootFilter(a));
        if (v && m) {
          var p = t(v === !0 ? a.children : v.children, !0, i);
          i.flatten ? s.push.apply(s, p) : s.push({
            scopeParent: a,
            candidates: p
          });
        } else
          l.unshift.apply(l, a.children);
      }
  }
  return s;
}, fL = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Zl = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || iF(t)) && !fL(t) ? 0 : t.tabIndex;
}, sF = function(t, e) {
  var n = Zl(t);
  return n < 0 && e && !fL(t) ? 0 : n;
}, lF = function(t, e) {
  return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
}, vL = function(t) {
  return t.tagName === "INPUT";
}, rF = function(t) {
  return vL(t) && t.type === "hidden";
}, aF = function(t) {
  var e = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return e;
}, oF = function(t, e) {
  for (var n = 0; n < t.length; n++)
    if (t[n].checked && t[n].form === e)
      return t[n];
}, cF = function(t) {
  if (!t.name)
    return !0;
  var e = t.form || Ah(t), n = function(l) {
    return e.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = n(window.CSS.escape(t.name));
  else
    try {
      i = n(t.name);
    } catch (l) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", l.message), !1;
    }
  var s = oF(i, t.form);
  return !s || s === t;
}, hF = function(t) {
  return vL(t) && t.type === "radio";
}, uF = function(t) {
  return hF(t) && !cF(t);
}, dF = function(t) {
  var e, n = t && Ah(t), i = (e = n) === null || e === void 0 ? void 0 : e.host, s = !1;
  if (n && n !== t) {
    var l, a, o;
    for (s = !!((l = i) !== null && l !== void 0 && (a = l.ownerDocument) !== null && a !== void 0 && a.contains(i) || t != null && (o = t.ownerDocument) !== null && o !== void 0 && o.contains(t)); !s && i; ) {
      var h, u, d;
      n = Ah(i), i = (h = n) === null || h === void 0 ? void 0 : h.host, s = !!((u = i) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(i));
    }
  }
  return s;
}, kw = function(t) {
  var e = t.getBoundingClientRect(), n = e.width, i = e.height;
  return n === 0 && i === 0;
}, fF = function(t, e) {
  var n = e.displayCheck, i = e.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var s = fr.call(t, "details>summary:first-of-type"), l = s ? t.parentElement : t;
  if (fr.call(l, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof i == "function") {
      for (var a = t; t; ) {
        var o = t.parentElement, h = Ah(t);
        if (o && !o.shadowRoot && i(o) === !0)
          return kw(t);
        t.assignedSlot ? t = t.assignedSlot : !o && h !== t.ownerDocument ? t = h.host : t = o;
      }
      t = a;
    }
    if (dF(t))
      return !t.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return kw(t);
  return !1;
}, vF = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var e = t.parentElement; e; ) {
      if (e.tagName === "FIELDSET" && e.disabled) {
        for (var n = 0; n < e.children.length; n++) {
          var i = e.children.item(n);
          if (i.tagName === "LEGEND")
            return fr.call(e, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      e = e.parentElement;
    }
  return !1;
}, Th = function(t, e) {
  return !(e.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Fh(e) || rF(e) || fF(e, t) || // For a details element with a summary, the summary element gets the focus
  aF(e) || vF(e));
}, cy = function(t, e) {
  return !(uF(e) || Zl(e) < 0 || !Th(t, e));
}, pF = function(t) {
  var e = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(e) || e >= 0);
}, mF = function t(e) {
  var n = [], i = [];
  return e.forEach(function(s, l) {
    var a = !!s.scopeParent, o = a ? s.scopeParent : s, h = sF(o, a), u = a ? t(s.candidates) : o;
    h === 0 ? a ? n.push.apply(n, u) : n.push(o) : i.push({
      documentOrder: l,
      tabIndex: h,
      item: s,
      isScope: a,
      content: u
    });
  }), i.sort(lF).reduce(function(s, l) {
    return l.isScope ? s.push.apply(s, l.content) : s.push(l.content), s;
  }, []).concat(n);
}, gF = function(t, e) {
  e = e || {};
  var n;
  return e.getShadowRoot ? n = dL([t], e.includeContainer, {
    filter: cy.bind(null, e),
    flatten: !1,
    getShadowRoot: e.getShadowRoot,
    shadowRootFilter: pF
  }) : n = uL(t, e.includeContainer, cy.bind(null, e)), mF(n);
}, yF = function(t, e) {
  e = e || {};
  var n;
  return e.getShadowRoot ? n = dL([t], e.includeContainer, {
    filter: Th.bind(null, e),
    flatten: !0,
    getShadowRoot: e.getShadowRoot
  }) : n = uL(t, e.includeContainer, Th.bind(null, e)), n;
}, Gr = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return fr.call(t, Eh) === !1 ? !1 : cy(e, t);
}, _F = /* @__PURE__ */ cL.concat("iframe").join(","), wg = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return fr.call(t, _F) === !1 ? !1 : Th(e, t);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Ew(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Aw(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ew(Object(n), !0).forEach(function(i) {
      qF(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ew(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function qF(t, e, n) {
  return e = zF(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function wF(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e || "default");
    if (typeof i != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function zF(t) {
  var e = wF(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
var Fw = {
  activateTrap: function(t, e) {
    if (t.length > 0) {
      var n = t[t.length - 1];
      n !== e && n.pause();
    }
    var i = t.indexOf(e);
    i === -1 || t.splice(i, 1), t.push(e);
  },
  deactivateTrap: function(t, e) {
    var n = t.indexOf(e);
    n !== -1 && t.splice(n, 1), t.length > 0 && t[t.length - 1].unpause();
  }
}, MF = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, bF = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, yo = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, LF = function(t) {
  return yo(t) && !t.shiftKey;
}, xF = function(t) {
  return yo(t) && t.shiftKey;
}, Tw = function(t) {
  return setTimeout(t, 0);
}, Iw = function(t, e) {
  var n = -1;
  return t.every(function(i, s) {
    return e(i) ? (n = s, !1) : !0;
  }), n;
}, j7 = function(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
    n[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, n) : t;
}, Rc = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, SF = [], CF = function(t, e) {
  var n = (e == null ? void 0 : e.document) || document, i = (e == null ? void 0 : e.trapStack) || SF, s = Aw({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: LF,
    isKeyBackward: xF
  }, e), l = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, a, o = function(K, P, O) {
    return K && K[P] !== void 0 ? K[P] : s[O || P];
  }, h = function(K, P) {
    var O = typeof (P == null ? void 0 : P.composedPath) == "function" ? P.composedPath() : void 0;
    return l.containerGroups.findIndex(function(G) {
      var j = G.container, Q = G.tabbableNodes;
      return j.contains(K) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (O == null ? void 0 : O.includes(j)) || Q.find(function(i1) {
        return i1 === K;
      });
    });
  }, u = function(K) {
    var P = s[K];
    if (typeof P == "function") {
      for (var O = arguments.length, G = new Array(O > 1 ? O - 1 : 0), j = 1; j < O; j++)
        G[j - 1] = arguments[j];
      P = P.apply(void 0, G);
    }
    if (P === !0 && (P = void 0), !P) {
      if (P === void 0 || P === !1)
        return P;
      throw new Error("`".concat(K, "` was specified but was not a node, or did not return a node"));
    }
    var Q = P;
    if (typeof P == "string" && (Q = n.querySelector(P), !Q))
      throw new Error("`".concat(K, "` as selector refers to no known node"));
    return Q;
  }, d = function() {
    var K = u("initialFocus");
    if (K === !1)
      return !1;
    if (K === void 0 || !wg(K, s.tabbableOptions))
      if (h(n.activeElement) >= 0)
        K = n.activeElement;
      else {
        var P = l.tabbableGroups[0], O = P && P.firstTabbableNode;
        K = O || u("fallbackFocus");
      }
    if (!K)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return K;
  }, v = function() {
    if (l.containerGroups = l.containers.map(function(K) {
      var P = gF(K, s.tabbableOptions), O = yF(K, s.tabbableOptions), G = P.length > 0 ? P[0] : void 0, j = P.length > 0 ? P[P.length - 1] : void 0, Q = O.find(function(c1) {
        return Gr(c1);
      }), i1 = O.slice().reverse().find(function(c1) {
        return Gr(c1);
      }), h1 = !!P.find(function(c1) {
        return Zl(c1) > 0;
      });
      return {
        container: K,
        tabbableNodes: P,
        focusableNodes: O,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: h1,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: G,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: j,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: Q,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: i1,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(c1) {
          var M1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, y1 = P.indexOf(c1);
          return y1 < 0 ? M1 ? O.slice(O.indexOf(c1) + 1).find(function(A1) {
            return Gr(A1);
          }) : O.slice(0, O.indexOf(c1)).reverse().find(function(A1) {
            return Gr(A1);
          }) : P[y1 + (M1 ? 1 : -1)];
        }
      };
    }), l.tabbableGroups = l.containerGroups.filter(function(K) {
      return K.tabbableNodes.length > 0;
    }), l.tabbableGroups.length <= 0 && !u("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (l.containerGroups.find(function(K) {
      return K.posTabIndexesFound;
    }) && l.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, m = function K(P) {
    var O = P.activeElement;
    if (O)
      return O.shadowRoot && O.shadowRoot.activeElement !== null ? K(O.shadowRoot) : O;
  }, p = function K(P) {
    if (P !== !1 && P !== m(document)) {
      if (!P || !P.focus) {
        K(d());
        return;
      }
      P.focus({
        preventScroll: !!s.preventScroll
      }), l.mostRecentlyFocusedNode = P, MF(P) && P.select();
    }
  }, _ = function(K) {
    var P = u("setReturnFocus", K);
    return P || (P === !1 ? !1 : K);
  }, q = function(K) {
    var P = K.target, O = K.event, G = K.isBackward, j = G === void 0 ? !1 : G;
    P = P || Rc(O), v();
    var Q = null;
    if (l.tabbableGroups.length > 0) {
      var i1 = h(P, O), h1 = i1 >= 0 ? l.containerGroups[i1] : void 0;
      if (i1 < 0)
        j ? Q = l.tabbableGroups[l.tabbableGroups.length - 1].lastTabbableNode : Q = l.tabbableGroups[0].firstTabbableNode;
      else if (j) {
        var c1 = Iw(l.tabbableGroups, function(n1) {
          var f1 = n1.firstTabbableNode;
          return P === f1;
        });
        if (c1 < 0 && (h1.container === P || wg(P, s.tabbableOptions) && !Gr(P, s.tabbableOptions) && !h1.nextTabbableNode(P, !1)) && (c1 = i1), c1 >= 0) {
          var M1 = c1 === 0 ? l.tabbableGroups.length - 1 : c1 - 1, y1 = l.tabbableGroups[M1];
          Q = Zl(P) >= 0 ? y1.lastTabbableNode : y1.lastDomTabbableNode;
        } else
          yo(O) || (Q = h1.nextTabbableNode(P, !1));
      } else {
        var A1 = Iw(l.tabbableGroups, function(n1) {
          var f1 = n1.lastTabbableNode;
          return P === f1;
        });
        if (A1 < 0 && (h1.container === P || wg(P, s.tabbableOptions) && !Gr(P, s.tabbableOptions) && !h1.nextTabbableNode(P)) && (A1 = i1), A1 >= 0) {
          var $ = A1 === l.tabbableGroups.length - 1 ? 0 : A1 + 1, a1 = l.tabbableGroups[$];
          Q = Zl(P) >= 0 ? a1.firstTabbableNode : a1.firstDomTabbableNode;
        } else
          yo(O) || (Q = h1.nextTabbableNode(P));
      }
    } else
      Q = u("fallbackFocus");
    return Q;
  }, M = function(K) {
    var P = Rc(K);
    if (!(h(P, K) >= 0)) {
      if (j7(s.clickOutsideDeactivates, K)) {
        a.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: s.returnFocusOnDeactivate
        });
        return;
      }
      j7(s.allowOutsideClick, K) || K.preventDefault();
    }
  }, z = function(K) {
    var P = Rc(K), O = h(P, K) >= 0;
    if (O || P instanceof Document)
      O && (l.mostRecentlyFocusedNode = P);
    else {
      K.stopImmediatePropagation();
      var G, j = !0;
      if (l.mostRecentlyFocusedNode)
        if (Zl(l.mostRecentlyFocusedNode) > 0) {
          var Q = h(l.mostRecentlyFocusedNode), i1 = l.containerGroups[Q].tabbableNodes;
          if (i1.length > 0) {
            var h1 = i1.findIndex(function(c1) {
              return c1 === l.mostRecentlyFocusedNode;
            });
            h1 >= 0 && (s.isKeyForward(l.recentNavEvent) ? h1 + 1 < i1.length && (G = i1[h1 + 1], j = !1) : h1 - 1 >= 0 && (G = i1[h1 - 1], j = !1));
          }
        } else
          l.containerGroups.some(function(c1) {
            return c1.tabbableNodes.some(function(M1) {
              return Zl(M1) > 0;
            });
          }) || (j = !1);
      else
        j = !1;
      j && (G = q({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: l.mostRecentlyFocusedNode,
        isBackward: s.isKeyBackward(l.recentNavEvent)
      })), p(G || l.mostRecentlyFocusedNode || d());
    }
    l.recentNavEvent = void 0;
  }, b = function(K) {
    var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    l.recentNavEvent = K;
    var O = q({
      event: K,
      isBackward: P
    });
    O && (yo(K) && K.preventDefault(), p(O));
  }, x = function(K) {
    if (bF(K) && j7(s.escapeDeactivates, K) !== !1) {
      K.preventDefault(), a.deactivate();
      return;
    }
    (s.isKeyForward(K) || s.isKeyBackward(K)) && b(K, s.isKeyBackward(K));
  }, k = function(K) {
    var P = Rc(K);
    h(P, K) >= 0 || j7(s.clickOutsideDeactivates, K) || j7(s.allowOutsideClick, K) || (K.preventDefault(), K.stopImmediatePropagation());
  }, F = function() {
    if (l.active)
      return Fw.activateTrap(i, a), l.delayInitialFocusTimer = s.delayInitialFocus ? Tw(function() {
        p(d());
      }) : p(d()), n.addEventListener("focusin", z, !0), n.addEventListener("mousedown", M, {
        capture: !0,
        passive: !1
      }), n.addEventListener("touchstart", M, {
        capture: !0,
        passive: !1
      }), n.addEventListener("click", k, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", x, {
        capture: !0,
        passive: !1
      }), a;
  }, D = function() {
    if (l.active)
      return n.removeEventListener("focusin", z, !0), n.removeEventListener("mousedown", M, !0), n.removeEventListener("touchstart", M, !0), n.removeEventListener("click", k, !0), n.removeEventListener("keydown", x, !0), a;
  }, R = function(K) {
    var P = K.some(function(O) {
      var G = Array.from(O.removedNodes);
      return G.some(function(j) {
        return j === l.mostRecentlyFocusedNode;
      });
    });
    P && p(d());
  }, V = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(R) : void 0, J = function() {
    V && (V.disconnect(), l.active && !l.paused && l.containers.map(function(K) {
      V.observe(K, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return a = {
    get active() {
      return l.active;
    },
    get paused() {
      return l.paused;
    },
    activate: function(K) {
      if (l.active)
        return this;
      var P = o(K, "onActivate"), O = o(K, "onPostActivate"), G = o(K, "checkCanFocusTrap");
      G || v(), l.active = !0, l.paused = !1, l.nodeFocusedBeforeActivation = n.activeElement, P == null || P();
      var j = function() {
        G && v(), F(), J(), O == null || O();
      };
      return G ? (G(l.containers.concat()).then(j, j), this) : (j(), this);
    },
    deactivate: function(K) {
      if (!l.active)
        return this;
      var P = Aw({
        onDeactivate: s.onDeactivate,
        onPostDeactivate: s.onPostDeactivate,
        checkCanReturnFocus: s.checkCanReturnFocus
      }, K);
      clearTimeout(l.delayInitialFocusTimer), l.delayInitialFocusTimer = void 0, D(), l.active = !1, l.paused = !1, J(), Fw.deactivateTrap(i, a);
      var O = o(P, "onDeactivate"), G = o(P, "onPostDeactivate"), j = o(P, "checkCanReturnFocus"), Q = o(P, "returnFocus", "returnFocusOnDeactivate");
      O == null || O();
      var i1 = function() {
        Tw(function() {
          Q && p(_(l.nodeFocusedBeforeActivation)), G == null || G();
        });
      };
      return Q && j ? (j(_(l.nodeFocusedBeforeActivation)).then(i1, i1), this) : (i1(), this);
    },
    pause: function(K) {
      if (l.paused || !l.active)
        return this;
      var P = o(K, "onPause"), O = o(K, "onPostPause");
      return l.paused = !0, P == null || P(), D(), J(), O == null || O(), this;
    },
    unpause: function(K) {
      if (!l.paused || !l.active)
        return this;
      var P = o(K, "onUnpause"), O = o(K, "onPostUnpause");
      return l.paused = !1, P == null || P(), v(), F(), J(), O == null || O(), this;
    },
    updateContainerElements: function(K) {
      var P = [].concat(K).filter(Boolean);
      return l.containers = P.map(function(O) {
        return typeof O == "string" ? n.querySelector(O) : O;
      }), l.active && v(), J(), this;
    }
  }, a.updateContainerElements(t), a;
}, kF = Object.defineProperty, EF = (t, e, n) => e in t ? kF(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, AF = (t, e, n) => (EF(t, typeof e != "symbol" ? e + "" : e, n), n);
const FF = "@jrcb3/ecl-vue", TF = "Albinola Federico", IF = "4.4.3", OF = "Wrapper on Vue3 for Europa Component Library (ECL).", NF = "module", PF = "./dist/main.es.js", BF = "./dist/main.es.js", VF = "./dist/main.d.ts", RF = {
  ".": {
    import: "./dist/main.es.js",
    require: "./dist/main.es.js"
  },
  "./ecl.es.js": "./dist/ecl.es.js",
  "./main.css": "./dist/assets/main.css",
  "./ec-theme.css": "./dist/assets/ec-theme.css",
  "./eu-theme.css": "./dist/assets/eu-theme.css",
  "./themes/ec-theme.scss": "./dist/themes/ec-theme.scss",
  "./themes/eu-theme.scss": "./dist/themes/eu-theme.scss"
}, HF = [
  "dist/*",
  "package.json",
  "README.md"
], DF = {
  test: 'echo "Error: no test specified" && exit 1',
  serve: "vite",
  "build-npm": "vite build",
  "serve-module-federation": "vite --config vite.config.module-federation.ts",
  "build-module-federation": "vite --config vite.config.module-federation.ts build --mode os.stg",
  "build-module-federation:local": "vite --config vite.config.module-federation.ts build",
  "build-module-federation:watch": "vite --config vite.config.module-federation.ts build --watch",
  "preview-module-federation": "vite --config vite.config.module-federation.ts preview",
  "start:live": "webpack-dev-server --open --config ./config/webpack.development.cjs --live-reload --env target=local",
  "build:link": "webpack --config ./config/webpack.development.cjs --env target=link",
  "build:jrc": "webpack --config ./config/webpack.production.cjs --env target=jrc"
}, $F = {
  "@ecl/preset-ec": "^4.3.0",
  "@ecl/preset-eu": "^4.3.0",
  "@ecl/preset-reset": "^4.3.0",
  "@ecl/theme-ec": "^4.3.0",
  "@ecl/theme-eu": "^4.3.0",
  "@ecl/vanilla-component-accordion": "^4.3.0",
  "@ecl/vanilla-component-blockquote": "^4.3.0",
  "@ecl/vanilla-component-button": "^4.3.0",
  "@ecl/vanilla-component-checkbox": "^4.3.0",
  "@ecl/vanilla-component-description-list": "^4.3.0",
  "@ecl/vanilla-component-file": "^4.3.0",
  "@ecl/vanilla-component-file-upload": "^4.3.0",
  "@ecl/vanilla-component-icon": "^4.3.0",
  "@ecl/vanilla-component-inpage-navigation": "^4.3.0",
  "@ecl/vanilla-component-link": "^4.3.0",
  "@ecl/vanilla-component-menu": "^4.3.0",
  "@ecl/vanilla-component-modal": "^4.3.0",
  "@ecl/vanilla-component-ordered-list": "^4.3.0",
  "@ecl/vanilla-component-radio": "^4.3.0",
  "@ecl/vanilla-component-select": "^4.3.0",
  "@ecl/vanilla-component-site-header": "^4.3.0",
  "@ecl/vanilla-component-table": "^4.3.0",
  "@ecl/vanilla-component-text-input": "^4.3.0",
  "@ecl/vanilla-component-unordered-list": "^4.3.0",
  "@ecl/vanilla-layout-grid": "^4.3.0",
  "@ecl/vanilla-utility-typography": "^4.3.0",
  "@vueuse/components": "^10.9.0",
  "@vueuse/core": "^10.9.0",
  "dotenv-webpack": "^8.1.0",
  lodash: "^4.17.21"
}, UF = {
  vue: "^3.0.0",
  "vue-i18n": "^9.2.2",
  "vue-router": "^4.2.4"
}, jF = {
  "@babel/preset-typescript": "^7.24.1",
  "@ecl/event-manager": "^4.0.0",
  "@originjs/vite-plugin-federation": "^1.3.5",
  "@types/lodash": "^4.14.202",
  "@types/node": "^20.12.12",
  "@vitejs/plugin-vue": "^5.0.4",
  "@vue/compiler-sfc": "^3.4.27",
  "babel-loader": "^9.1.3",
  "babel-plugin-transform-vite-meta-env": "^1.0.3",
  "babel-plugin-transform-vite-meta-glob": "^1.1.2",
  "css-loader": "^7.1.1",
  "file-loader": "^6.2.0",
  "html-webpack-plugin": "^5.6.0",
  "mini-css-extract-plugin": "^2.9.0",
  "rollup-plugin-copy": "^3.5.0",
  "rollup-plugin-visualizer": "^5.12.0",
  sass: "^1.77.2",
  "sass-loader": "^14.2.1",
  "svg-loader": "^0.0.2",
  "svg-url-loader": "^8.0.0",
  "svg-vue3-loader": "^1.0.2",
  "ts-loader": "^9.5.1",
  typescript: "^5.4.5",
  vite: "^5.2.11",
  "vite-plugin-dts": "^3.7.3",
  "vite-plugin-ejs": "^1.7.0",
  "vite-plugin-remove-console": "^2.2.0",
  "vite-svg-loader": "^5.1.0",
  vue: "^3.4.27",
  "vue-i18n": "^9.13.1",
  "vue-loader": "^17.3.1",
  "vue-router": "^4.3.2",
  "vue-style-loader": "^4.1.3",
  "vue-svg-loader-2": "^0.17.1",
  "vue-tsc": "^2.0.6",
  webpack: "^5.91.0",
  "webpack-cli": "^5.1.4",
  "webpack-dev-server": "^5.0.4",
  "webpack-merge": "^5.10.0"
}, GF = {
  type: "git",
  url: "https://gitlab.jrc.ec.europa.eu/jrc-projects/udp/lib-fe-ecl-pkg.git"
}, WF = {
  name: FF,
  author: TF,
  version: IF,
  description: OF,
  type: NF,
  main: PF,
  module: BF,
  types: VF,
  exports: RF,
  files: HF,
  scripts: DF,
  dependencies: $F,
  peerDependencies: UF,
  devDependencies: jF,
  repository: GF
}, d4 = () => {
  var t, e;
  const n = t9();
  return {
    theme: ((e = (t = n == null ? void 0 : n.appContext.config.globalProperties) == null ? void 0 : t.$ecl) == null ? void 0 : e.theme) ?? "ec"
  };
};
var Ih = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ih.exports;
(function(t, e) {
  (function() {
    var n, i = "4.17.21", s = 200, l = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", o = "Invalid `variable` option passed into `_.template`", h = "__lodash_hash_undefined__", u = 500, d = "__lodash_placeholder__", v = 1, m = 2, p = 4, _ = 1, q = 2, M = 1, z = 2, b = 4, x = 8, k = 16, F = 32, D = 64, R = 128, V = 256, J = 512, K = 30, P = "...", O = 800, G = 16, j = 1, Q = 2, i1 = 3, h1 = 1 / 0, c1 = 9007199254740991, M1 = 17976931348623157e292, y1 = NaN, A1 = 4294967295, $ = A1 - 1, a1 = A1 >>> 1, n1 = [
      ["ary", R],
      ["bind", M],
      ["bindKey", z],
      ["curry", x],
      ["curryRight", k],
      ["flip", J],
      ["partial", F],
      ["partialRight", D],
      ["rearg", V]
    ], f1 = "[object Arguments]", w1 = "[object Array]", C1 = "[object AsyncFunction]", E1 = "[object Boolean]", T1 = "[object Date]", n2 = "[object DOMException]", X1 = "[object Error]", a2 = "[object Function]", d2 = "[object GeneratorFunction]", y2 = "[object Map]", B1 = "[object Number]", p1 = "[object Null]", _2 = "[object Object]", w2 = "[object Promise]", K1 = "[object Proxy]", e2 = "[object RegExp]", Z1 = "[object Set]", t2 = "[object String]", S2 = "[object Symbol]", W2 = "[object Undefined]", E2 = "[object WeakMap]", o3 = "[object WeakSet]", n3 = "[object ArrayBuffer]", c3 = "[object DataView]", G2 = "[object Float32Array]", u3 = "[object Float64Array]", g2 = "[object Int8Array]", Oe = "[object Int16Array]", q3 = "[object Int32Array]", ht = "[object Uint8Array]", E3 = "[object Uint8ClampedArray]", j3 = "[object Uint16Array]", z2 = "[object Uint32Array]", R2 = /\b__p \+= '';/g, w3 = /\b(__p \+=) '' \+/g, B3 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, G3 = /&(?:amp|lt|gt|quot|#39);/g, Se = /[&<>"']/g, _e = RegExp(G3.source), d3 = RegExp(Se.source), Z3 = /<%-([\s\S]+?)%>/g, yt = /<%([\s\S]+?)%>/g, Ce = /<%=([\s\S]+?)%>/g, tt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ut = /^\w*$/, D2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Re = /[\\^$.*+?()[\]{}|]/g, _t = RegExp(Re.source), L3 = /^\s+/, W3 = /\s/, oe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, v4 = /\{\n\/\* \[wrapped with (.+)\] \*/, wn = /,? & /, m0 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, _5 = /[()=,{}\[\]\/\s]/, q5 = /\\(\\)?/g, w5 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, X4 = /\w*$/, K4 = /^[-+]0x[0-9a-f]+$/i, H5 = /^0b[01]+$/i, F6 = /^\[object .+?Constructor\]$/, zn = /^0o[0-7]+$/i, Mn = /^(?:0|[1-9]\d*)$/, bn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Z4 = /($^)/, P8 = /['\n\r\u2028\u2029\\]/g, g0 = "\\ud800-\\udfff", Ys = "\\u0300-\\u036f", Ln = "\\ufe20-\\ufe2f", B8 = "\\u20d0-\\u20ff", mi = Ys + Ln + B8, T6 = "\\u2700-\\u27bf", gi = "a-z\\xdf-\\xf6\\xf8-\\xff", V8 = "\\xac\\xb1\\xd7\\xf7", Xs = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", xn = "\\u2000-\\u206f", Ks = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", nt = "A-Z\\xc0-\\xd6\\xd8-\\xde", Sn = "\\ufe0e\\ufe0f", Cn = V8 + Xs + xn + Ks, G0 = "['’]", yi = "[" + g0 + "]", _i = "[" + Cn + "]", Dt = "[" + mi + "]", W0 = "\\d+", S4 = "[" + T6 + "]", I6 = "[" + gi + "]", kn = "[^" + g0 + Cn + W0 + T6 + gi + nt + "]", O6 = "\\ud83c[\\udffb-\\udfff]", R8 = "(?:" + Dt + "|" + O6 + ")", qi = "[^" + g0 + "]", Y0 = "(?:\\ud83c[\\udde6-\\uddff]){2}", N6 = "[\\ud800-\\udbff][\\udc00-\\udfff]", p4 = "[" + nt + "]", wi = "\\u200d", zi = "(?:" + I6 + "|" + kn + ")", Zs = "(?:" + p4 + "|" + kn + ")", z5 = "(?:" + G0 + "(?:d|ll|m|re|s|t|ve))?", X0 = "(?:" + G0 + "(?:D|LL|M|RE|S|T|VE))?", K0 = R8 + "?", En = "[" + Sn + "]?", n4 = "(?:" + wi + "(?:" + [qi, Y0, N6].join("|") + ")" + En + K0 + ")*", Js = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", H8 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", f3 = En + K0 + n4, Qs = "(?:" + [S4, Y0, N6].join("|") + ")" + f3, el = "(?:" + [qi + Dt + "?", Dt, Y0, N6, yi].join("|") + ")", D5 = RegExp(G0, "g"), D8 = RegExp(Dt, "g"), Z0 = RegExp(O6 + "(?=" + O6 + ")|" + el + f3, "g"), An = RegExp([
      p4 + "?" + I6 + "+" + z5 + "(?=" + [_i, p4, "$"].join("|") + ")",
      Zs + "+" + X0 + "(?=" + [_i, p4 + zi, "$"].join("|") + ")",
      p4 + "?" + zi + "+" + z5,
      p4 + "+" + X0,
      H8,
      Js,
      W0,
      Qs
    ].join("|"), "g"), Mi = RegExp("[" + wi + g0 + mi + Sn + "]"), tl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, nl = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], il = -1, e3 = {};
    e3[G2] = e3[u3] = e3[g2] = e3[Oe] = e3[q3] = e3[ht] = e3[E3] = e3[j3] = e3[z2] = !0, e3[f1] = e3[w1] = e3[n3] = e3[E1] = e3[c3] = e3[T1] = e3[X1] = e3[a2] = e3[y2] = e3[B1] = e3[_2] = e3[e2] = e3[Z1] = e3[t2] = e3[E2] = !1;
    var X2 = {};
    X2[f1] = X2[w1] = X2[n3] = X2[c3] = X2[E1] = X2[T1] = X2[G2] = X2[u3] = X2[g2] = X2[Oe] = X2[q3] = X2[y2] = X2[B1] = X2[_2] = X2[e2] = X2[Z1] = X2[t2] = X2[S2] = X2[ht] = X2[E3] = X2[j3] = X2[z2] = !0, X2[X1] = X2[a2] = X2[E2] = !1;
    var J0 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, sl = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, P6 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, bi = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Fn = parseFloat, $8 = parseInt, Tn = typeof ys == "object" && ys && ys.Object === Object && ys, U8 = typeof self == "object" && self && self.Object === Object && self, D3 = Tn || U8 || Function("return this")(), P4 = e && !e.nodeType && e, qt = P4 && !0 && t && !t.nodeType && t, Li = qt && qt.exports === P4, J4 = Li && Tn.process, J3 = function() {
      try {
        var e1 = qt && qt.require && qt.require("util").types;
        return e1 || J4 && J4.binding && J4.binding("util");
      } catch {
      }
    }(), B6 = J3 && J3.isArrayBuffer, y0 = J3 && J3.isDate, xi = J3 && J3.isMap, Q0 = J3 && J3.isRegExp, Si = J3 && J3.isSet, V6 = J3 && J3.isTypedArray;
    function fe(e1, m1, u1) {
      switch (u1.length) {
        case 0:
          return e1.call(m1);
        case 1:
          return e1.call(m1, u1[0]);
        case 2:
          return e1.call(m1, u1[0], u1[1]);
        case 3:
          return e1.call(m1, u1[0], u1[1], u1[2]);
      }
      return e1.apply(m1, u1);
    }
    function j8(e1, m1, u1, R1) {
      for (var s2 = -1, N2 = e1 == null ? 0 : e1.length; ++s2 < N2; ) {
        var z3 = e1[s2];
        m1(R1, z3, u1(z3), e1);
      }
      return R1;
    }
    function qe(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length; ++u1 < R1 && m1(e1[u1], u1, e1) !== !1; )
        ;
      return e1;
    }
    function Ci(e1, m1) {
      for (var u1 = e1 == null ? 0 : e1.length; u1-- && m1(e1[u1], u1, e1) !== !1; )
        ;
      return e1;
    }
    function R6(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length; ++u1 < R1; )
        if (!m1(e1[u1], u1, e1))
          return !1;
      return !0;
    }
    function At(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length, s2 = 0, N2 = []; ++u1 < R1; ) {
        var z3 = e1[u1];
        m1(z3, u1, e1) && (N2[s2++] = z3);
      }
      return N2;
    }
    function _0(e1, m1) {
      var u1 = e1 == null ? 0 : e1.length;
      return !!u1 && J1(e1, m1, 0) > -1;
    }
    function $5(e1, m1, u1) {
      for (var R1 = -1, s2 = e1 == null ? 0 : e1.length; ++R1 < s2; )
        if (u1(m1, e1[R1]))
          return !0;
      return !1;
    }
    function t3(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length, s2 = Array(R1); ++u1 < R1; )
        s2[u1] = m1(e1[u1], u1, e1);
      return s2;
    }
    function xt(e1, m1) {
      for (var u1 = -1, R1 = m1.length, s2 = e1.length; ++u1 < R1; )
        e1[s2 + u1] = m1[u1];
      return e1;
    }
    function Q4(e1, m1, u1, R1) {
      var s2 = -1, N2 = e1 == null ? 0 : e1.length;
      for (R1 && N2 && (u1 = e1[++s2]); ++s2 < N2; )
        u1 = m1(u1, e1[s2], s2, e1);
      return u1;
    }
    function ki(e1, m1, u1, R1) {
      var s2 = e1 == null ? 0 : e1.length;
      for (R1 && s2 && (u1 = e1[--s2]); s2--; )
        u1 = m1(u1, e1[s2], s2, e1);
      return u1;
    }
    function S(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length; ++u1 < R1; )
        if (m1(e1[u1], u1, e1))
          return !0;
      return !1;
    }
    var X = y3("length");
    function v1(e1) {
      return e1.split("");
    }
    function z1(e1) {
      return e1.match(m0) || [];
    }
    function F1(e1, m1, u1) {
      var R1;
      return u1(e1, function(s2, N2, z3) {
        if (m1(s2, N2, z3))
          return R1 = N2, !1;
      }), R1;
    }
    function H1(e1, m1, u1, R1) {
      for (var s2 = e1.length, N2 = u1 + (R1 ? 1 : -1); R1 ? N2-- : ++N2 < s2; )
        if (m1(e1[N2], N2, e1))
          return N2;
      return -1;
    }
    function J1(e1, m1, u1) {
      return m1 === m1 ? b5(e1, m1, u1) : H1(e1, Z2, u1);
    }
    function F2(e1, m1, u1, R1) {
      for (var s2 = u1 - 1, N2 = e1.length; ++s2 < N2; )
        if (R1(e1[s2], m1))
          return s2;
      return -1;
    }
    function Z2(e1) {
      return e1 !== e1;
    }
    function v3(e1, m1) {
      var u1 = e1 == null ? 0 : e1.length;
      return u1 ? Xe(e1, m1) / u1 : y1;
    }
    function y3(e1) {
      return function(m1) {
        return m1 == null ? n : m1[e1];
      };
    }
    function P3(e1) {
      return function(m1) {
        return e1 == null ? n : e1[m1];
      };
    }
    function He(e1, m1, u1, R1, s2) {
      return s2(e1, function(N2, z3, Y2) {
        u1 = R1 ? (R1 = !1, N2) : m1(u1, N2, z3, Y2);
      }), u1;
    }
    function ot(e1, m1) {
      var u1 = e1.length;
      for (e1.sort(m1); u1--; )
        e1[u1] = e1[u1].value;
      return e1;
    }
    function Xe(e1, m1) {
      for (var u1, R1 = -1, s2 = e1.length; ++R1 < s2; ) {
        var N2 = m1(e1[R1]);
        N2 !== n && (u1 = u1 === n ? N2 : u1 + N2);
      }
      return u1;
    }
    function wt(e1, m1) {
      for (var u1 = -1, R1 = Array(e1); ++u1 < e1; )
        R1[u1] = m1(u1);
      return R1;
    }
    function Ft(e1, m1) {
      return t3(m1, function(u1) {
        return [u1, e1[u1]];
      });
    }
    function B4(e1) {
      return e1 && e1.slice(0, U5(e1) + 1).replace(L3, "");
    }
    function V3(e1) {
      return function(m1) {
        return e1(m1);
      };
    }
    function V4(e1, m1) {
      return t3(m1, function(u1) {
        return e1[u1];
      });
    }
    function e5(e1, m1) {
      return e1.has(m1);
    }
    function H6(e1, m1) {
      for (var u1 = -1, R1 = e1.length; ++u1 < R1 && J1(m1, e1[u1], 0) > -1; )
        ;
      return u1;
    }
    function D6(e1, m1) {
      for (var u1 = e1.length; u1-- && J1(m1, e1[u1], 0) > -1; )
        ;
      return u1;
    }
    function In(e1, m1) {
      for (var u1 = e1.length, R1 = 0; u1--; )
        e1[u1] === m1 && ++R1;
      return R1;
    }
    var Ei = P3(J0), Ai = P3(sl);
    function On(e1) {
      return "\\" + bi[e1];
    }
    function C4(e1, m1) {
      return e1 == null ? n : e1[m1];
    }
    function i4(e1) {
      return Mi.test(e1);
    }
    function Nn(e1) {
      return tl.test(e1);
    }
    function Pn(e1) {
      for (var m1, u1 = []; !(m1 = e1.next()).done; )
        u1.push(m1.value);
      return u1;
    }
    function q0(e1) {
      var m1 = -1, u1 = Array(e1.size);
      return e1.forEach(function(R1, s2) {
        u1[++m1] = [s2, R1];
      }), u1;
    }
    function s4(e1, m1) {
      return function(u1) {
        return e1(m1(u1));
      };
    }
    function $t(e1, m1) {
      for (var u1 = -1, R1 = e1.length, s2 = 0, N2 = []; ++u1 < R1; ) {
        var z3 = e1[u1];
        (z3 === m1 || z3 === d) && (e1[u1] = d, N2[s2++] = u1);
      }
      return N2;
    }
    function M5(e1) {
      var m1 = -1, u1 = Array(e1.size);
      return e1.forEach(function(R1) {
        u1[++m1] = R1;
      }), u1;
    }
    function G8(e1) {
      var m1 = -1, u1 = Array(e1.size);
      return e1.forEach(function(R1) {
        u1[++m1] = [R1, R1];
      }), u1;
    }
    function b5(e1, m1, u1) {
      for (var R1 = u1 - 1, s2 = e1.length; ++R1 < s2; )
        if (e1[R1] === m1)
          return R1;
      return -1;
    }
    function Fi(e1, m1, u1) {
      for (var R1 = u1 + 1; R1--; )
        if (e1[R1] === m1)
          return R1;
      return R1;
    }
    function R4(e1) {
      return i4(e1) ? L5(e1) : X(e1);
    }
    function it(e1) {
      return i4(e1) ? e6(e1) : v1(e1);
    }
    function U5(e1) {
      for (var m1 = e1.length; m1-- && W3.test(e1.charAt(m1)); )
        ;
      return m1;
    }
    var t5 = P3(P6);
    function L5(e1) {
      for (var m1 = Z0.lastIndex = 0; Z0.test(e1); )
        ++m1;
      return m1;
    }
    function e6(e1) {
      return e1.match(Z0) || [];
    }
    function j5(e1) {
      return e1.match(An) || [];
    }
    var w0 = function e1(m1) {
      m1 = m1 == null ? D3 : l4.defaults(D3.Object(), m1, l4.pick(D3, nl));
      var u1 = m1.Array, R1 = m1.Date, s2 = m1.Error, N2 = m1.Function, z3 = m1.Math, Y2 = m1.Object, x5 = m1.RegExp, t6 = m1.String, ke = m1.TypeError, Tt = u1.prototype, z0 = N2.prototype, $3 = Y2.prototype, te = m1["__core-js_shared__"], Ee = z0.toString, x2 = $3.hasOwnProperty, M0 = 0, G5 = function() {
        var r = /[^.]+$/.exec(te && te.keys && te.keys.IE_PROTO || "");
        return r ? "Symbol(src)_1." + r : "";
      }(), n5 = $3.toString, W8 = Ee.call(Y2), Fr = D3._, Tr = x5(
        "^" + Ee.call(x2).replace(Re, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), n6 = Li ? m1.Buffer : n, r4 = m1.Symbol, i6 = m1.Uint8Array, Y8 = n6 ? n6.allocUnsafe : n, b0 = s4(Y2.getPrototypeOf, Y2), Bn = Y2.create, m4 = $3.propertyIsEnumerable, It = Tt.splice, Vn = r4 ? r4.isConcatSpreadable : n, i5 = r4 ? r4.iterator : n, k4 = r4 ? r4.toStringTag : n, W5 = function() {
        try {
          var r = A5(Y2, "defineProperty");
          return r({}, "", {}), r;
        } catch {
        }
      }(), X8 = m1.clearTimeout !== D3.clearTimeout && m1.clearTimeout, ll = R1 && R1.now !== D3.Date.now && R1.now, Ir = m1.setTimeout !== D3.setTimeout && m1.setTimeout, L0 = z3.ceil, x0 = z3.floor, s6 = Y2.getOwnPropertySymbols, rl = n6 ? n6.isBuffer : n, al = m1.isFinite, q9 = Tt.join, Or = s4(Y2.keys, Y2), R3 = z3.max, ne = z3.min, w9 = R1.now, z9 = m1.parseInt, ol = z3.random, cl = Tt.reverse, $6 = A5(m1, "DataView"), H4 = A5(m1, "Map"), Ti = A5(m1, "Promise"), S5 = A5(m1, "Set"), Y5 = A5(m1, "WeakMap"), S0 = A5(Y2, "create"), U6 = Y5 && new Y5(), C5 = {}, M9 = F5($6), l6 = F5(H4), k5 = F5(Ti), C0 = F5(S5), b9 = F5(Y5), r6 = r4 ? r4.prototype : n, a4 = r6 ? r6.valueOf : n, E4 = r6 ? r6.toString : n;
      function A(r) {
        if (S3(r) && !p2(r) && !(r instanceof A2)) {
          if (r instanceof Ke)
            return r;
          if (x2.call(r, "__wrapped__"))
            return h7(r);
        }
        return new Ke(r);
      }
      var E5 = /* @__PURE__ */ function() {
        function r() {
        }
        return function(c) {
          if (!M3(c))
            return {};
          if (Bn)
            return Bn(c);
          r.prototype = c;
          var f = new r();
          return r.prototype = n, f;
        };
      }();
      function a6() {
      }
      function Ke(r, c) {
        this.__wrapped__ = r, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = n;
      }
      A.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Z3,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: yt,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ce,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: A
        }
      }, A.prototype = a6.prototype, A.prototype.constructor = A, Ke.prototype = E5(a6.prototype), Ke.prototype.constructor = Ke;
      function A2(r) {
        this.__wrapped__ = r, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = A1, this.__views__ = [];
      }
      function Nr() {
        var r = new A2(this.__wrapped__);
        return r.__actions__ = $e(this.__actions__), r.__dir__ = this.__dir__, r.__filtered__ = this.__filtered__, r.__iteratees__ = $e(this.__iteratees__), r.__takeCount__ = this.__takeCount__, r.__views__ = $e(this.__views__), r;
      }
      function L9() {
        if (this.__filtered__) {
          var r = new A2(this);
          r.__dir__ = -1, r.__filtered__ = !0;
        } else
          r = this.clone(), r.__dir__ *= -1;
        return r;
      }
      function K8() {
        var r = this.__wrapped__.value(), c = this.__dir__, f = p2(r), y = c < 0, L = f ? r.length : 0, I = Wd(0, L, this.__views__), U = I.start, Y = I.end, l1 = Y - U, _1 = y ? Y : U - 1, q1 = this.__iteratees__, x1 = q1.length, P1 = 0, W1 = ne(l1, this.__takeCount__);
        if (!f || !y && L == l1 && W1 == l1)
          return Dn(r, this.__actions__);
        var l2 = [];
        e:
          for (; l1-- && P1 < W1; ) {
            _1 += c;
            for (var b2 = -1, r2 = r[_1]; ++b2 < x1; ) {
              var T2 = q1[b2], B2 = T2.iteratee, lt = T2.type, Fe = B2(r2);
              if (lt == Q)
                r2 = Fe;
              else if (!Fe) {
                if (lt == j)
                  continue e;
                break e;
              }
            }
            l2[P1++] = r2;
          }
        return l2;
      }
      A2.prototype = E5(a6.prototype), A2.prototype.constructor = A2;
      function o4(r) {
        var c = -1, f = r == null ? 0 : r.length;
        for (this.clear(); ++c < f; ) {
          var y = r[c];
          this.set(y[0], y[1]);
        }
      }
      function Ii() {
        this.__data__ = S0 ? S0(null) : {}, this.size = 0;
      }
      function hl(r) {
        var c = this.has(r) && delete this.__data__[r];
        return this.size -= c ? 1 : 0, c;
      }
      function Pr(r) {
        var c = this.__data__;
        if (S0) {
          var f = c[r];
          return f === h ? n : f;
        }
        return x2.call(c, r) ? c[r] : n;
      }
      function x9(r) {
        var c = this.__data__;
        return S0 ? c[r] !== n : x2.call(c, r);
      }
      function Br(r, c) {
        var f = this.__data__;
        return this.size += this.has(r) ? 0 : 1, f[r] = S0 && c === n ? h : c, this;
      }
      o4.prototype.clear = Ii, o4.prototype.delete = hl, o4.prototype.get = Pr, o4.prototype.has = x9, o4.prototype.set = Br;
      function Ut(r) {
        var c = -1, f = r == null ? 0 : r.length;
        for (this.clear(); ++c < f; ) {
          var y = r[c];
          this.set(y[0], y[1]);
        }
      }
      function S9() {
        this.__data__ = [], this.size = 0;
      }
      function C9(r) {
        var c = this.__data__, f = b1(c, r);
        if (f < 0)
          return !1;
        var y = c.length - 1;
        return f == y ? c.pop() : It.call(c, f, 1), --this.size, !0;
      }
      function k9(r) {
        var c = this.__data__, f = b1(c, r);
        return f < 0 ? n : c[f][1];
      }
      function E9(r) {
        return b1(this.__data__, r) > -1;
      }
      function A9(r, c) {
        var f = this.__data__, y = b1(f, r);
        return y < 0 ? (++this.size, f.push([r, c])) : f[y][1] = c, this;
      }
      Ut.prototype.clear = S9, Ut.prototype.delete = C9, Ut.prototype.get = k9, Ut.prototype.has = E9, Ut.prototype.set = A9;
      function Ot(r) {
        var c = -1, f = r == null ? 0 : r.length;
        for (this.clear(); ++c < f; ) {
          var y = r[c];
          this.set(y[0], y[1]);
        }
      }
      function Z8() {
        this.size = 0, this.__data__ = {
          hash: new o4(),
          map: new (H4 || Ut)(),
          string: new o4()
        };
      }
      function F9(r) {
        var c = Wi(this, r).delete(r);
        return this.size -= c ? 1 : 0, c;
      }
      function T9(r) {
        return Wi(this, r).get(r);
      }
      function Vr(r) {
        return Wi(this, r).has(r);
      }
      function g(r, c) {
        var f = Wi(this, r), y = f.size;
        return f.set(r, c), this.size += f.size == y ? 0 : 1, this;
      }
      Ot.prototype.clear = Z8, Ot.prototype.delete = F9, Ot.prototype.get = T9, Ot.prototype.has = Vr, Ot.prototype.set = g;
      function w(r) {
        var c = -1, f = r == null ? 0 : r.length;
        for (this.__data__ = new Ot(); ++c < f; )
          this.add(r[c]);
      }
      function E(r) {
        return this.__data__.set(r, h), this;
      }
      function B(r) {
        return this.__data__.has(r);
      }
      w.prototype.add = w.prototype.push = E, w.prototype.has = B;
      function W(r) {
        var c = this.__data__ = new Ut(r);
        this.size = c.size;
      }
      function Z() {
        this.__data__ = new Ut(), this.size = 0;
      }
      function t1(r) {
        var c = this.__data__, f = c.delete(r);
        return this.size = c.size, f;
      }
      function r1(r) {
        return this.__data__.get(r);
      }
      function o1(r) {
        return this.__data__.has(r);
      }
      function d1(r, c) {
        var f = this.__data__;
        if (f instanceof Ut) {
          var y = f.__data__;
          if (!H4 || y.length < s - 1)
            return y.push([r, c]), this.size = ++f.size, this;
          f = this.__data__ = new Ot(y);
        }
        return f.set(r, c), this.size = f.size, this;
      }
      W.prototype.clear = Z, W.prototype.delete = t1, W.prototype.get = r1, W.prototype.has = o1, W.prototype.set = d1;
      function L1(r, c) {
        var f = p2(r), y = !f && T5(r), L = !f && !y && $4(r), I = !f && !y && !L && N0(r), U = f || y || L || I, Y = U ? wt(r.length, t6) : [], l1 = Y.length;
        for (var _1 in r)
          (c || x2.call(r, _1)) && !(U && // Safari 9 has enumerable `arguments.length` in strict mode.
          (_1 == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          L && (_1 == "offset" || _1 == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          I && (_1 == "buffer" || _1 == "byteLength" || _1 == "byteOffset") || // Skip index properties.
          w4(_1, l1))) && Y.push(_1);
        return Y;
      }
      function I1(r) {
        var c = r.length;
        return c ? r[f6(0, c - 1)] : n;
      }
      function O1(r, c) {
        return Yi($e(r), o2(c, 0, r.length));
      }
      function k1(r) {
        return Yi($e(r));
      }
      function G1(r, c, f) {
        (f !== n && !St(r[c], f) || f === n && !(c in r)) && $1(r, c, f);
      }
      function V1(r, c, f) {
        var y = r[c];
        (!(x2.call(r, c) && St(y, f)) || f === n && !(c in r)) && $1(r, c, f);
      }
      function b1(r, c) {
        for (var f = r.length; f--; )
          if (St(r[f][0], c))
            return f;
        return -1;
      }
      function S1(r, c, f, y) {
        return a3(r, function(L, I, U) {
          c(y, L, f(L), U);
        }), y;
      }
      function j1(r, c) {
        return r && Yt(c, ee(c), r);
      }
      function Q1(r, c) {
        return r && Yt(c, je(c), r);
      }
      function $1(r, c, f) {
        c == "__proto__" && W5 ? W5(r, c, {
          configurable: !0,
          enumerable: !0,
          value: f,
          writable: !0
        }) : r[c] = f;
      }
      function C2(r, c) {
        for (var f = -1, y = c.length, L = u1(y), I = r == null; ++f < y; )
          L[f] = I ? n : Nl(r, c[f]);
        return L;
      }
      function o2(r, c, f) {
        return r === r && (f !== n && (r = r <= f ? r : f), c !== n && (r = r >= c ? r : c)), r;
      }
      function k2(r, c, f, y, L, I) {
        var U, Y = c & v, l1 = c & m, _1 = c & p;
        if (f && (U = L ? f(r, y, L, I) : f(r)), U !== n)
          return U;
        if (!M3(r))
          return r;
        var q1 = p2(r);
        if (q1) {
          if (U = Xd(r), !Y)
            return $e(r, U);
        } else {
          var x1 = me(r), P1 = x1 == a2 || x1 == d2;
          if ($4(r))
            return Ri(r, Y);
          if (x1 == _2 || x1 == f1 || P1 && !L) {
            if (U = l1 || P1 ? {} : t7(r), !Y)
              return l1 ? Bd(r, Q1(U, r)) : Pd(r, j1(U, r));
          } else {
            if (!X2[x1])
              return L ? r : {};
            U = Kd(r, x1, Y);
          }
        }
        I || (I = new W());
        var W1 = I.get(r);
        if (W1)
          return W1;
        I.set(r, U), E7(r) ? r.forEach(function(r2) {
          U.add(k2(r2, c, f, r2, r, I));
        }) : C7(r) && r.forEach(function(r2, T2) {
          U.set(T2, k2(r2, c, f, T2, r, I));
        });
        var l2 = _1 ? l1 ? zl : wl : l1 ? je : ee, b2 = q1 ? n : l2(r);
        return qe(b2 || r, function(r2, T2) {
          b2 && (T2 = r2, r2 = r[T2]), V1(U, T2, k2(r2, c, f, T2, r, I));
        }), U;
      }
      function L2(r) {
        var c = ee(r);
        return function(f) {
          return Q3(f, r, c);
        };
      }
      function Q3(r, c, f) {
        var y = f.length;
        if (r == null)
          return !y;
        for (r = Y2(r); y--; ) {
          var L = f[y], I = c[L], U = r[L];
          if (U === n && !(L in r) || !I(U))
            return !1;
        }
        return !0;
      }
      function ie(r, c, f) {
        if (typeof r != "function")
          throw new ke(a);
        return K6(function() {
          r.apply(n, f);
        }, c);
      }
      function x3(r, c, f, y) {
        var L = -1, I = _0, U = !0, Y = r.length, l1 = [], _1 = c.length;
        if (!Y)
          return l1;
        f && (c = t3(c, V3(f))), y ? (I = $5, U = !1) : c.length >= s && (I = e5, U = !1, c = new w(c));
        e:
          for (; ++L < Y; ) {
            var q1 = r[L], x1 = f == null ? q1 : f(q1);
            if (q1 = y || q1 !== 0 ? q1 : 0, U && x1 === x1) {
              for (var P1 = _1; P1--; )
                if (c[P1] === x1)
                  continue e;
              l1.push(q1);
            } else
              I(c, x1, y) || l1.push(q1);
          }
        return l1;
      }
      var a3 = H9(le), ve = H9(jt, !0);
      function we(r, c) {
        var f = !0;
        return a3(r, function(y, L, I) {
          return f = !!c(y, L, I), f;
        }), f;
      }
      function h3(r, c, f) {
        for (var y = -1, L = r.length; ++y < L; ) {
          var I = r[y], U = c(I);
          if (U != null && (Y === n ? U === U && !st(U) : f(U, Y)))
            var Y = U, l1 = I;
        }
        return l1;
      }
      function zt(r, c, f, y) {
        var L = r.length;
        for (f = q2(f), f < 0 && (f = -f > L ? 0 : L + f), y = y === n || y > L ? L : q2(y), y < 0 && (y += L), y = f > y ? 0 : F7(y); f < y; )
          r[f++] = c;
        return r;
      }
      function c4(r, c) {
        var f = [];
        return a3(r, function(y, L, I) {
          c(y, L, I) && f.push(y);
        }), f;
      }
      function i3(r, c, f, y, L) {
        var I = -1, U = r.length;
        for (f || (f = Jd), L || (L = []); ++I < U; ) {
          var Y = r[I];
          c > 0 && f(Y) ? c > 1 ? i3(Y, c - 1, f, y, L) : xt(L, Y) : y || (L[L.length] = Y);
        }
        return L;
      }
      var Nt = D9(), se = D9(!0);
      function le(r, c) {
        return r && Nt(r, c, ee);
      }
      function jt(r, c) {
        return r && se(r, c, ee);
      }
      function Ze(r, c) {
        return At(c, function(f) {
          return z4(r[f]);
        });
      }
      function pe(r, c) {
        c = Wt(c, r);
        for (var f = 0, y = c.length; r != null && f < y; )
          r = r[Xt(c[f++])];
        return f && f == y ? r : n;
      }
      function Gt(r, c, f) {
        var y = c(r);
        return p2(r) ? y : xt(y, f(r));
      }
      function A3(r) {
        return r == null ? r === n ? W2 : p1 : k4 && k4 in Y2(r) ? Gd(r) : rf(r);
      }
      function A4(r, c) {
        return r > c;
      }
      function Pt(r, c) {
        return r != null && x2.call(r, c);
      }
      function k0(r, c) {
        return r != null && c in Y2(r);
      }
      function j6(r, c, f) {
        return r >= ne(c, f) && r < R3(c, f);
      }
      function X5(r, c, f) {
        for (var y = f ? $5 : _0, L = r[0].length, I = r.length, U = I, Y = u1(I), l1 = 1 / 0, _1 = []; U--; ) {
          var q1 = r[U];
          U && c && (q1 = t3(q1, V3(c))), l1 = ne(q1.length, l1), Y[U] = !f && (c || L >= 120 && q1.length >= 120) ? new w(U && q1) : n;
        }
        q1 = r[0];
        var x1 = -1, P1 = Y[0];
        e:
          for (; ++x1 < L && _1.length < l1; ) {
            var W1 = q1[x1], l2 = c ? c(W1) : W1;
            if (W1 = f || W1 !== 0 ? W1 : 0, !(P1 ? e5(P1, l2) : y(_1, l2, f))) {
              for (U = I; --U; ) {
                var b2 = Y[U];
                if (!(b2 ? e5(b2, l2) : y(r[U], l2, f)))
                  continue e;
              }
              P1 && P1.push(l2), _1.push(W1);
            }
          }
        return _1;
      }
      function o6(r, c, f, y) {
        return le(r, function(L, I, U) {
          c(y, f(L), I, U);
        }), y;
      }
      function ce(r, c, f) {
        c = Wt(c, r), r = l7(r, c);
        var y = r == null ? r : r[Xt(dt(c))];
        return y == null ? n : fe(y, r, f);
      }
      function Oi(r) {
        return S3(r) && A3(r) == f1;
      }
      function Rr(r) {
        return S3(r) && A3(r) == n3;
      }
      function Hr(r) {
        return S3(r) && A3(r) == T1;
      }
      function s5(r, c, f, y, L) {
        return r === c ? !0 : r == null || c == null || !S3(r) && !S3(c) ? r !== r && c !== c : Ni(r, c, f, y, s5, L);
      }
      function Ni(r, c, f, y, L, I) {
        var U = p2(r), Y = p2(c), l1 = U ? w1 : me(r), _1 = Y ? w1 : me(c);
        l1 = l1 == f1 ? _2 : l1, _1 = _1 == f1 ? _2 : _1;
        var q1 = l1 == _2, x1 = _1 == _2, P1 = l1 == _1;
        if (P1 && $4(r)) {
          if (!$4(c))
            return !1;
          U = !0, q1 = !1;
        }
        if (P1 && !q1)
          return I || (I = new W()), U || N0(r) ? J9(r, c, f, y, L, I) : Ud(r, c, l1, f, y, L, I);
        if (!(f & _)) {
          var W1 = q1 && x2.call(r, "__wrapped__"), l2 = x1 && x2.call(c, "__wrapped__");
          if (W1 || l2) {
            var b2 = W1 ? r.value() : r, r2 = l2 ? c.value() : c;
            return I || (I = new W()), L(b2, r2, f, y, I);
          }
        }
        return P1 ? (I || (I = new W()), jd(r, c, f, y, L, I)) : !1;
      }
      function J8(r) {
        return S3(r) && me(r) == y2;
      }
      function g4(r, c, f, y) {
        var L = f.length, I = L, U = !y;
        if (r == null)
          return !I;
        for (r = Y2(r); L--; ) {
          var Y = f[L];
          if (U && Y[2] ? Y[1] !== r[Y[0]] : !(Y[0] in r))
            return !1;
        }
        for (; ++L < I; ) {
          Y = f[L];
          var l1 = Y[0], _1 = r[l1], q1 = Y[1];
          if (U && Y[2]) {
            if (_1 === n && !(l1 in r))
              return !1;
          } else {
            var x1 = new W();
            if (y)
              var P1 = y(_1, q1, l1, r, c, x1);
            if (!(P1 === n ? s5(q1, _1, _ | q, y, x1) : P1))
              return !1;
          }
        }
        return !0;
      }
      function c6(r) {
        if (!M3(r) || ef(r))
          return !1;
        var c = z4(r) ? Tr : F6;
        return c.test(F5(r));
      }
      function Rn(r) {
        return S3(r) && A3(r) == e2;
      }
      function Dr(r) {
        return S3(r) && me(r) == Z1;
      }
      function Q8(r) {
        return S3(r) && e8(r.length) && !!e3[A3(r)];
      }
      function es(r) {
        return typeof r == "function" ? r : r == null ? Ge : typeof r == "object" ? p2(r) ? fl(r[0], r[1]) : dl(r) : $7(r);
      }
      function h6(r) {
        if (!X6(r))
          return Or(r);
        var c = [];
        for (var f in Y2(r))
          x2.call(r, f) && f != "constructor" && c.push(f);
        return c;
      }
      function ul(r) {
        if (!M3(r))
          return lf(r);
        var c = X6(r), f = [];
        for (var y in r)
          y == "constructor" && (c || !x2.call(r, y)) || f.push(y);
        return f;
      }
      function u6(r, c) {
        return r < c;
      }
      function G6(r, c) {
        var f = -1, y = Ue(r) ? u1(r.length) : [];
        return a3(r, function(L, I, U) {
          y[++f] = c(L, I, U);
        }), y;
      }
      function dl(r) {
        var c = bl(r);
        return c.length == 1 && c[0][2] ? i7(c[0][0], c[0][1]) : function(f) {
          return f === r || g4(f, r, c);
        };
      }
      function fl(r, c) {
        return xl(r) && n7(c) ? i7(Xt(r), c) : function(f) {
          var y = Nl(f, r);
          return y === n && y === c ? Pl(f, r) : s5(c, y, _ | q);
        };
      }
      function E0(r, c, f, y, L) {
        r !== c && Nt(c, function(I, U) {
          if (L || (L = new W()), M3(I))
            d6(r, c, U, f, E0, y, L);
          else {
            var Y = y ? y(Cl(r, U), I, U + "", r, c, L) : n;
            Y === n && (Y = I), G1(r, U, Y);
          }
        }, je);
      }
      function d6(r, c, f, y, L, I, U) {
        var Y = Cl(r, f), l1 = Cl(c, f), _1 = U.get(l1);
        if (_1) {
          G1(r, f, _1);
          return;
        }
        var q1 = I ? I(Y, l1, f + "", r, c, U) : n, x1 = q1 === n;
        if (x1) {
          var P1 = p2(l1), W1 = !P1 && $4(l1), l2 = !P1 && !W1 && N0(l1);
          q1 = l1, P1 || W1 || l2 ? p2(Y) ? q1 = Y : O3(Y) ? q1 = $e(Y) : W1 ? (x1 = !1, q1 = Ri(l1, !0)) : l2 ? (x1 = !1, q1 = P9(l1, !0)) : q1 = [] : Z6(l1) || T5(l1) ? (q1 = Y, T5(Y) ? q1 = T7(Y) : (!M3(Y) || z4(Y)) && (q1 = t7(l1))) : x1 = !1;
        }
        x1 && (U.set(l1, q1), L(q1, l1, y, I, U), U.delete(l1)), G1(r, f, q1);
      }
      function vl(r, c) {
        var f = r.length;
        if (f)
          return c += c < 0 ? f : 0, w4(c, f) ? r[c] : n;
      }
      function pl(r, c, f) {
        c.length ? c = t3(c, function(I) {
          return p2(I) ? function(U) {
            return pe(U, I.length === 1 ? I[0] : I);
          } : I;
        }) : c = [Ge];
        var y = -1;
        c = t3(c, V3(i2()));
        var L = G6(r, function(I, U, Y) {
          var l1 = t3(c, function(_1) {
            return _1(I);
          });
          return { criteria: l1, index: ++y, value: I };
        });
        return ot(L, function(I, U) {
          return Nd(I, U, f);
        });
      }
      function I9(r, c) {
        return ts(r, c, function(f, y) {
          return Pl(r, y);
        });
      }
      function ts(r, c, f) {
        for (var y = -1, L = c.length, I = {}; ++y < L; ) {
          var U = c[y], Y = pe(r, U);
          f(Y, U) && K5(I, Wt(U, r), Y);
        }
        return I;
      }
      function ns(r) {
        return function(c) {
          return pe(c, r);
        };
      }
      function Hn(r, c, f, y) {
        var L = y ? F2 : J1, I = -1, U = c.length, Y = r;
        for (r === c && (c = $e(c)), f && (Y = t3(r, V3(f))); ++I < U; )
          for (var l1 = 0, _1 = c[I], q1 = f ? f(_1) : _1; (l1 = L(Y, q1, l1, y)) > -1; )
            Y !== r && It.call(Y, l1, 1), It.call(r, l1, 1);
        return r;
      }
      function is(r, c) {
        for (var f = r ? c.length : 0, y = f - 1; f--; ) {
          var L = c[f];
          if (f == y || L !== I) {
            var I = L;
            w4(L) ? It.call(r, L, 1) : Bi(r, L);
          }
        }
        return r;
      }
      function f6(r, c) {
        return r + x0(ol() * (c - r + 1));
      }
      function ml(r, c, f, y) {
        for (var L = -1, I = R3(L0((c - r) / (f || 1)), 0), U = u1(I); I--; )
          U[y ? I : ++L] = r, r += f;
        return U;
      }
      function A0(r, c) {
        var f = "";
        if (!r || c < 1 || c > c1)
          return f;
        do
          c % 2 && (f += r), c = x0(c / 2), c && (r += r);
        while (c);
        return f;
      }
      function M2(r, c) {
        return kl(s7(r, c, Ge), r + "");
      }
      function O9(r) {
        return I1(P0(r));
      }
      function ss(r, c) {
        var f = P0(r);
        return Yi(f, o2(c, 0, f.length));
      }
      function K5(r, c, f, y) {
        if (!M3(r))
          return r;
        c = Wt(c, r);
        for (var L = -1, I = c.length, U = I - 1, Y = r; Y != null && ++L < I; ) {
          var l1 = Xt(c[L]), _1 = f;
          if (l1 === "__proto__" || l1 === "constructor" || l1 === "prototype")
            return r;
          if (L != U) {
            var q1 = Y[l1];
            _1 = y ? y(q1, l1, Y) : n, _1 === n && (_1 = M3(q1) ? q1 : w4(c[L + 1]) ? [] : {});
          }
          V1(Y, l1, _1), Y = Y[l1];
        }
        return r;
      }
      var Pi = U6 ? function(r, c) {
        return U6.set(r, c), r;
      } : Ge, v6 = W5 ? function(r, c) {
        return W5(r, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Vl(c),
          writable: !0
        });
      } : Ge;
      function $r(r) {
        return Yi(P0(r));
      }
      function Je(r, c, f) {
        var y = -1, L = r.length;
        c < 0 && (c = -c > L ? 0 : L + c), f = f > L ? L : f, f < 0 && (f += L), L = c > f ? 0 : f - c >>> 0, c >>>= 0;
        for (var I = u1(L); ++y < L; )
          I[y] = r[y + c];
        return I;
      }
      function N9(r, c) {
        var f;
        return a3(r, function(y, L, I) {
          return f = c(y, L, I), !f;
        }), !!f;
      }
      function p6(r, c, f) {
        var y = 0, L = r == null ? y : r.length;
        if (typeof c == "number" && c === c && L <= a1) {
          for (; y < L; ) {
            var I = y + L >>> 1, U = r[I];
            U !== null && !st(U) && (f ? U <= c : U < c) ? y = I + 1 : L = I;
          }
          return L;
        }
        return Z5(r, c, Ge, f);
      }
      function Z5(r, c, f, y) {
        var L = 0, I = r == null ? 0 : r.length;
        if (I === 0)
          return 0;
        c = f(c);
        for (var U = c !== c, Y = c === null, l1 = st(c), _1 = c === n; L < I; ) {
          var q1 = x0((L + I) / 2), x1 = f(r[q1]), P1 = x1 !== n, W1 = x1 === null, l2 = x1 === x1, b2 = st(x1);
          if (U)
            var r2 = y || l2;
          else
            _1 ? r2 = l2 && (y || P1) : Y ? r2 = l2 && P1 && (y || !W1) : l1 ? r2 = l2 && P1 && !W1 && (y || !b2) : W1 || b2 ? r2 = !1 : r2 = y ? x1 <= c : x1 < c;
          r2 ? L = q1 + 1 : I = q1;
        }
        return ne(I, $);
      }
      function gl(r, c) {
        for (var f = -1, y = r.length, L = 0, I = []; ++f < y; ) {
          var U = r[f], Y = c ? c(U) : U;
          if (!f || !St(Y, l1)) {
            var l1 = Y;
            I[L++] = U === 0 ? 0 : U;
          }
        }
        return I;
      }
      function ls(r) {
        return typeof r == "number" ? r : st(r) ? y1 : +r;
      }
      function De(r) {
        if (typeof r == "string")
          return r;
        if (p2(r))
          return t3(r, De) + "";
        if (st(r))
          return E4 ? E4.call(r) : "";
        var c = r + "";
        return c == "0" && 1 / r == -h1 ? "-0" : c;
      }
      function h4(r, c, f) {
        var y = -1, L = _0, I = r.length, U = !0, Y = [], l1 = Y;
        if (f)
          U = !1, L = $5;
        else if (I >= s) {
          var _1 = c ? null : Dd(r);
          if (_1)
            return M5(_1);
          U = !1, L = e5, l1 = new w();
        } else
          l1 = c ? [] : Y;
        e:
          for (; ++y < I; ) {
            var q1 = r[y], x1 = c ? c(q1) : q1;
            if (q1 = f || q1 !== 0 ? q1 : 0, U && x1 === x1) {
              for (var P1 = l1.length; P1--; )
                if (l1[P1] === x1)
                  continue e;
              c && l1.push(x1), Y.push(q1);
            } else
              L(l1, x1, f) || (l1 !== Y && l1.push(x1), Y.push(q1));
          }
        return Y;
      }
      function Bi(r, c) {
        return c = Wt(c, r), r = l7(r, c), r == null || delete r[Xt(dt(c))];
      }
      function W6(r, c, f, y) {
        return K5(r, c, f(pe(r, c)), y);
      }
      function F0(r, c, f, y) {
        for (var L = r.length, I = y ? L : -1; (y ? I-- : ++I < L) && c(r[I], I, r); )
          ;
        return f ? Je(r, y ? 0 : I, y ? I + 1 : L) : Je(r, y ? I + 1 : 0, y ? L : I);
      }
      function Dn(r, c) {
        var f = r;
        return f instanceof A2 && (f = f.value()), Q4(c, function(y, L) {
          return L.func.apply(L.thisArg, xt([y], L.args));
        }, f);
      }
      function D4(r, c, f) {
        var y = r.length;
        if (y < 2)
          return y ? h4(r[0]) : [];
        for (var L = -1, I = u1(y); ++L < y; )
          for (var U = r[L], Y = -1; ++Y < y; )
            Y != L && (I[L] = x3(I[L] || U, r[Y], c, f));
        return h4(i3(I, 1), c, f);
      }
      function J5(r, c, f) {
        for (var y = -1, L = r.length, I = c.length, U = {}; ++y < L; ) {
          var Y = y < I ? c[y] : n;
          f(U, r[y], Y);
        }
        return U;
      }
      function l5(r) {
        return O3(r) ? r : [];
      }
      function m6(r) {
        return typeof r == "function" ? r : Ge;
      }
      function Wt(r, c) {
        return p2(r) ? r : xl(r, c) ? [r] : c7(K2(r));
      }
      var Ur = M2;
      function y4(r, c, f) {
        var y = r.length;
        return f = f === n ? y : f, !c && f >= y ? r : Je(r, c, f);
      }
      var Vi = X8 || function(r) {
        return D3.clearTimeout(r);
      };
      function Ri(r, c) {
        if (c)
          return r.slice();
        var f = r.length, y = Y8 ? Y8(f) : new r.constructor(f);
        return r.copy(y), y;
      }
      function yl(r) {
        var c = new r.constructor(r.byteLength);
        return new i6(c).set(new i6(r)), c;
      }
      function Td(r, c) {
        var f = c ? yl(r.buffer) : r.buffer;
        return new r.constructor(f, r.byteOffset, r.byteLength);
      }
      function Id(r) {
        var c = new r.constructor(r.source, X4.exec(r));
        return c.lastIndex = r.lastIndex, c;
      }
      function Od(r) {
        return a4 ? Y2(a4.call(r)) : {};
      }
      function P9(r, c) {
        var f = c ? yl(r.buffer) : r.buffer;
        return new r.constructor(f, r.byteOffset, r.length);
      }
      function B9(r, c) {
        if (r !== c) {
          var f = r !== n, y = r === null, L = r === r, I = st(r), U = c !== n, Y = c === null, l1 = c === c, _1 = st(c);
          if (!Y && !_1 && !I && r > c || I && U && l1 && !Y && !_1 || y && U && l1 || !f && l1 || !L)
            return 1;
          if (!y && !I && !_1 && r < c || _1 && f && L && !y && !I || Y && f && L || !U && L || !l1)
            return -1;
        }
        return 0;
      }
      function Nd(r, c, f) {
        for (var y = -1, L = r.criteria, I = c.criteria, U = L.length, Y = f.length; ++y < U; ) {
          var l1 = B9(L[y], I[y]);
          if (l1) {
            if (y >= Y)
              return l1;
            var _1 = f[y];
            return l1 * (_1 == "desc" ? -1 : 1);
          }
        }
        return r.index - c.index;
      }
      function V9(r, c, f, y) {
        for (var L = -1, I = r.length, U = f.length, Y = -1, l1 = c.length, _1 = R3(I - U, 0), q1 = u1(l1 + _1), x1 = !y; ++Y < l1; )
          q1[Y] = c[Y];
        for (; ++L < U; )
          (x1 || L < I) && (q1[f[L]] = r[L]);
        for (; _1--; )
          q1[Y++] = r[L++];
        return q1;
      }
      function R9(r, c, f, y) {
        for (var L = -1, I = r.length, U = -1, Y = f.length, l1 = -1, _1 = c.length, q1 = R3(I - Y, 0), x1 = u1(q1 + _1), P1 = !y; ++L < q1; )
          x1[L] = r[L];
        for (var W1 = L; ++l1 < _1; )
          x1[W1 + l1] = c[l1];
        for (; ++U < Y; )
          (P1 || L < I) && (x1[W1 + f[U]] = r[L++]);
        return x1;
      }
      function $e(r, c) {
        var f = -1, y = r.length;
        for (c || (c = u1(y)); ++f < y; )
          c[f] = r[f];
        return c;
      }
      function Yt(r, c, f, y) {
        var L = !f;
        f || (f = {});
        for (var I = -1, U = c.length; ++I < U; ) {
          var Y = c[I], l1 = y ? y(f[Y], r[Y], Y, f, r) : n;
          l1 === n && (l1 = r[Y]), L ? $1(f, Y, l1) : V1(f, Y, l1);
        }
        return f;
      }
      function Pd(r, c) {
        return Yt(r, Ll(r), c);
      }
      function Bd(r, c) {
        return Yt(r, Q9(r), c);
      }
      function Hi(r, c) {
        return function(f, y) {
          var L = p2(f) ? j8 : S1, I = c ? c() : {};
          return L(f, r, i2(y, 2), I);
        };
      }
      function T0(r) {
        return M2(function(c, f) {
          var y = -1, L = f.length, I = L > 1 ? f[L - 1] : n, U = L > 2 ? f[2] : n;
          for (I = r.length > 3 && typeof I == "function" ? (L--, I) : n, U && Ae(f[0], f[1], U) && (I = L < 3 ? n : I, L = 1), c = Y2(c); ++y < L; ) {
            var Y = f[y];
            Y && r(c, Y, y, I);
          }
          return c;
        });
      }
      function H9(r, c) {
        return function(f, y) {
          if (f == null)
            return f;
          if (!Ue(f))
            return r(f, y);
          for (var L = f.length, I = c ? L : -1, U = Y2(f); (c ? I-- : ++I < L) && y(U[I], I, U) !== !1; )
            ;
          return f;
        };
      }
      function D9(r) {
        return function(c, f, y) {
          for (var L = -1, I = Y2(c), U = y(c), Y = U.length; Y--; ) {
            var l1 = U[r ? Y : ++L];
            if (f(I[l1], l1, I) === !1)
              break;
          }
          return c;
        };
      }
      function Vd(r, c, f) {
        var y = c & M, L = Y6(r);
        function I() {
          var U = this && this !== D3 && this instanceof I ? L : r;
          return U.apply(y ? f : this, arguments);
        }
        return I;
      }
      function $9(r) {
        return function(c) {
          c = K2(c);
          var f = i4(c) ? it(c) : n, y = f ? f[0] : c.charAt(0), L = f ? y4(f, 1).join("") : c.slice(1);
          return y[r]() + L;
        };
      }
      function I0(r) {
        return function(c) {
          return Q4(H7(R7(c).replace(D5, "")), r, "");
        };
      }
      function Y6(r) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new r();
            case 1:
              return new r(c[0]);
            case 2:
              return new r(c[0], c[1]);
            case 3:
              return new r(c[0], c[1], c[2]);
            case 4:
              return new r(c[0], c[1], c[2], c[3]);
            case 5:
              return new r(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new r(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new r(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var f = E5(r.prototype), y = r.apply(f, c);
          return M3(y) ? y : f;
        };
      }
      function Rd(r, c, f) {
        var y = Y6(r);
        function L() {
          for (var I = arguments.length, U = u1(I), Y = I, l1 = O0(L); Y--; )
            U[Y] = arguments[Y];
          var _1 = I < 3 && U[0] !== l1 && U[I - 1] !== l1 ? [] : $t(U, l1);
          if (I -= _1.length, I < f)
            return Y9(
              r,
              c,
              Di,
              L.placeholder,
              n,
              U,
              _1,
              n,
              n,
              f - I
            );
          var q1 = this && this !== D3 && this instanceof L ? y : r;
          return fe(q1, this, U);
        }
        return L;
      }
      function U9(r) {
        return function(c, f, y) {
          var L = Y2(c);
          if (!Ue(c)) {
            var I = i2(f, 3);
            c = ee(c), f = function(Y) {
              return I(L[Y], Y, L);
            };
          }
          var U = r(c, f, y);
          return U > -1 ? L[I ? c[U] : U] : n;
        };
      }
      function j9(r) {
        return q4(function(c) {
          var f = c.length, y = f, L = Ke.prototype.thru;
          for (r && c.reverse(); y--; ) {
            var I = c[y];
            if (typeof I != "function")
              throw new ke(a);
            if (L && !U && Gi(I) == "wrapper")
              var U = new Ke([], !0);
          }
          for (y = U ? y : f; ++y < f; ) {
            I = c[y];
            var Y = Gi(I), l1 = Y == "wrapper" ? Ml(I) : n;
            l1 && Sl(l1[0]) && l1[1] == (R | x | F | V) && !l1[4].length && l1[9] == 1 ? U = U[Gi(l1[0])].apply(U, l1[3]) : U = I.length == 1 && Sl(I) ? U[Y]() : U.thru(I);
          }
          return function() {
            var _1 = arguments, q1 = _1[0];
            if (U && _1.length == 1 && p2(q1))
              return U.plant(q1).value();
            for (var x1 = 0, P1 = f ? c[x1].apply(this, _1) : q1; ++x1 < f; )
              P1 = c[x1].call(this, P1);
            return P1;
          };
        });
      }
      function Di(r, c, f, y, L, I, U, Y, l1, _1) {
        var q1 = c & R, x1 = c & M, P1 = c & z, W1 = c & (x | k), l2 = c & J, b2 = P1 ? n : Y6(r);
        function r2() {
          for (var T2 = arguments.length, B2 = u1(T2), lt = T2; lt--; )
            B2[lt] = arguments[lt];
          if (W1)
            var Fe = O0(r2), rt = In(B2, Fe);
          if (y && (B2 = V9(B2, y, L, W1)), I && (B2 = R9(B2, I, U, W1)), T2 -= rt, W1 && T2 < _1) {
            var N3 = $t(B2, Fe);
            return Y9(
              r,
              c,
              Di,
              r2.placeholder,
              f,
              B2,
              N3,
              Y,
              l1,
              _1 - T2
            );
          }
          var Ct = x1 ? f : this, b4 = P1 ? Ct[r] : r;
          return T2 = B2.length, Y ? B2 = af(B2, Y) : l2 && T2 > 1 && B2.reverse(), q1 && l1 < T2 && (B2.length = l1), this && this !== D3 && this instanceof r2 && (b4 = b2 || Y6(b4)), b4.apply(Ct, B2);
        }
        return r2;
      }
      function G9(r, c) {
        return function(f, y) {
          return o6(f, r, c(y), {});
        };
      }
      function $i(r, c) {
        return function(f, y) {
          var L;
          if (f === n && y === n)
            return c;
          if (f !== n && (L = f), y !== n) {
            if (L === n)
              return y;
            typeof f == "string" || typeof y == "string" ? (f = De(f), y = De(y)) : (f = ls(f), y = ls(y)), L = r(f, y);
          }
          return L;
        };
      }
      function _l(r) {
        return q4(function(c) {
          return c = t3(c, V3(i2())), M2(function(f) {
            var y = this;
            return r(c, function(L) {
              return fe(L, y, f);
            });
          });
        });
      }
      function Ui(r, c) {
        c = c === n ? " " : De(c);
        var f = c.length;
        if (f < 2)
          return f ? A0(c, r) : c;
        var y = A0(c, L0(r / R4(c)));
        return i4(c) ? y4(it(y), 0, r).join("") : y.slice(0, r);
      }
      function Hd(r, c, f, y) {
        var L = c & M, I = Y6(r);
        function U() {
          for (var Y = -1, l1 = arguments.length, _1 = -1, q1 = y.length, x1 = u1(q1 + l1), P1 = this && this !== D3 && this instanceof U ? I : r; ++_1 < q1; )
            x1[_1] = y[_1];
          for (; l1--; )
            x1[_1++] = arguments[++Y];
          return fe(P1, L ? f : this, x1);
        }
        return U;
      }
      function W9(r) {
        return function(c, f, y) {
          return y && typeof y != "number" && Ae(c, f, y) && (f = y = n), c = M4(c), f === n ? (f = c, c = 0) : f = M4(f), y = y === n ? c < f ? 1 : -1 : M4(y), ml(c, f, y, r);
        };
      }
      function ji(r) {
        return function(c, f) {
          return typeof c == "string" && typeof f == "string" || (c = ft(c), f = ft(f)), r(c, f);
        };
      }
      function Y9(r, c, f, y, L, I, U, Y, l1, _1) {
        var q1 = c & x, x1 = q1 ? U : n, P1 = q1 ? n : U, W1 = q1 ? I : n, l2 = q1 ? n : I;
        c |= q1 ? F : D, c &= ~(q1 ? D : F), c & b || (c &= ~(M | z));
        var b2 = [
          r,
          c,
          L,
          W1,
          x1,
          l2,
          P1,
          Y,
          l1,
          _1
        ], r2 = f.apply(n, b2);
        return Sl(r) && r7(r2, b2), r2.placeholder = y, a7(r2, r, c);
      }
      function ql(r) {
        var c = z3[r];
        return function(f, y) {
          if (f = ft(f), y = y == null ? 0 : ne(q2(y), 292), y && al(f)) {
            var L = (K2(f) + "e").split("e"), I = c(L[0] + "e" + (+L[1] + y));
            return L = (K2(I) + "e").split("e"), +(L[0] + "e" + (+L[1] - y));
          }
          return c(f);
        };
      }
      var Dd = S5 && 1 / M5(new S5([, -0]))[1] == h1 ? function(r) {
        return new S5(r);
      } : Dl;
      function X9(r) {
        return function(c) {
          var f = me(c);
          return f == y2 ? q0(c) : f == Z1 ? G8(c) : Ft(c, r(c));
        };
      }
      function _4(r, c, f, y, L, I, U, Y) {
        var l1 = c & z;
        if (!l1 && typeof r != "function")
          throw new ke(a);
        var _1 = y ? y.length : 0;
        if (_1 || (c &= ~(F | D), y = L = n), U = U === n ? U : R3(q2(U), 0), Y = Y === n ? Y : q2(Y), _1 -= L ? L.length : 0, c & D) {
          var q1 = y, x1 = L;
          y = L = n;
        }
        var P1 = l1 ? n : Ml(r), W1 = [
          r,
          c,
          f,
          y,
          L,
          q1,
          x1,
          I,
          U,
          Y
        ];
        if (P1 && sf(W1, P1), r = W1[0], c = W1[1], f = W1[2], y = W1[3], L = W1[4], Y = W1[9] = W1[9] === n ? l1 ? 0 : r.length : R3(W1[9] - _1, 0), !Y && c & (x | k) && (c &= ~(x | k)), !c || c == M)
          var l2 = Vd(r, c, f);
        else
          c == x || c == k ? l2 = Rd(r, c, Y) : (c == F || c == (M | F)) && !L.length ? l2 = Hd(r, c, f, y) : l2 = Di.apply(n, W1);
        var b2 = P1 ? Pi : r7;
        return a7(b2(l2, W1), r, c);
      }
      function K9(r, c, f, y) {
        return r === n || St(r, $3[f]) && !x2.call(y, f) ? c : r;
      }
      function Z9(r, c, f, y, L, I) {
        return M3(r) && M3(c) && (I.set(c, r), E0(r, c, n, Z9, I), I.delete(c)), r;
      }
      function $d(r) {
        return Z6(r) ? n : r;
      }
      function J9(r, c, f, y, L, I) {
        var U = f & _, Y = r.length, l1 = c.length;
        if (Y != l1 && !(U && l1 > Y))
          return !1;
        var _1 = I.get(r), q1 = I.get(c);
        if (_1 && q1)
          return _1 == c && q1 == r;
        var x1 = -1, P1 = !0, W1 = f & q ? new w() : n;
        for (I.set(r, c), I.set(c, r); ++x1 < Y; ) {
          var l2 = r[x1], b2 = c[x1];
          if (y)
            var r2 = U ? y(b2, l2, x1, c, r, I) : y(l2, b2, x1, r, c, I);
          if (r2 !== n) {
            if (r2)
              continue;
            P1 = !1;
            break;
          }
          if (W1) {
            if (!S(c, function(T2, B2) {
              if (!e5(W1, B2) && (l2 === T2 || L(l2, T2, f, y, I)))
                return W1.push(B2);
            })) {
              P1 = !1;
              break;
            }
          } else if (!(l2 === b2 || L(l2, b2, f, y, I))) {
            P1 = !1;
            break;
          }
        }
        return I.delete(r), I.delete(c), P1;
      }
      function Ud(r, c, f, y, L, I, U) {
        switch (f) {
          case c3:
            if (r.byteLength != c.byteLength || r.byteOffset != c.byteOffset)
              return !1;
            r = r.buffer, c = c.buffer;
          case n3:
            return !(r.byteLength != c.byteLength || !I(new i6(r), new i6(c)));
          case E1:
          case T1:
          case B1:
            return St(+r, +c);
          case X1:
            return r.name == c.name && r.message == c.message;
          case e2:
          case t2:
            return r == c + "";
          case y2:
            var Y = q0;
          case Z1:
            var l1 = y & _;
            if (Y || (Y = M5), r.size != c.size && !l1)
              return !1;
            var _1 = U.get(r);
            if (_1)
              return _1 == c;
            y |= q, U.set(r, c);
            var q1 = J9(Y(r), Y(c), y, L, I, U);
            return U.delete(r), q1;
          case S2:
            if (a4)
              return a4.call(r) == a4.call(c);
        }
        return !1;
      }
      function jd(r, c, f, y, L, I) {
        var U = f & _, Y = wl(r), l1 = Y.length, _1 = wl(c), q1 = _1.length;
        if (l1 != q1 && !U)
          return !1;
        for (var x1 = l1; x1--; ) {
          var P1 = Y[x1];
          if (!(U ? P1 in c : x2.call(c, P1)))
            return !1;
        }
        var W1 = I.get(r), l2 = I.get(c);
        if (W1 && l2)
          return W1 == c && l2 == r;
        var b2 = !0;
        I.set(r, c), I.set(c, r);
        for (var r2 = U; ++x1 < l1; ) {
          P1 = Y[x1];
          var T2 = r[P1], B2 = c[P1];
          if (y)
            var lt = U ? y(B2, T2, P1, c, r, I) : y(T2, B2, P1, r, c, I);
          if (!(lt === n ? T2 === B2 || L(T2, B2, f, y, I) : lt)) {
            b2 = !1;
            break;
          }
          r2 || (r2 = P1 == "constructor");
        }
        if (b2 && !r2) {
          var Fe = r.constructor, rt = c.constructor;
          Fe != rt && "constructor" in r && "constructor" in c && !(typeof Fe == "function" && Fe instanceof Fe && typeof rt == "function" && rt instanceof rt) && (b2 = !1);
        }
        return I.delete(r), I.delete(c), b2;
      }
      function q4(r) {
        return kl(s7(r, n, f7), r + "");
      }
      function wl(r) {
        return Gt(r, ee, Ll);
      }
      function zl(r) {
        return Gt(r, je, Q9);
      }
      var Ml = U6 ? function(r) {
        return U6.get(r);
      } : Dl;
      function Gi(r) {
        for (var c = r.name + "", f = C5[c], y = x2.call(C5, c) ? f.length : 0; y--; ) {
          var L = f[y], I = L.func;
          if (I == null || I == r)
            return L.name;
        }
        return c;
      }
      function O0(r) {
        var c = x2.call(A, "placeholder") ? A : r;
        return c.placeholder;
      }
      function i2() {
        var r = A.iteratee || Rl;
        return r = r === Rl ? es : r, arguments.length ? r(arguments[0], arguments[1]) : r;
      }
      function Wi(r, c) {
        var f = r.__data__;
        return Qd(c) ? f[typeof c == "string" ? "string" : "hash"] : f.map;
      }
      function bl(r) {
        for (var c = ee(r), f = c.length; f--; ) {
          var y = c[f], L = r[y];
          c[f] = [y, L, n7(L)];
        }
        return c;
      }
      function A5(r, c) {
        var f = C4(r, c);
        return c6(f) ? f : n;
      }
      function Gd(r) {
        var c = x2.call(r, k4), f = r[k4];
        try {
          r[k4] = n;
          var y = !0;
        } catch {
        }
        var L = n5.call(r);
        return y && (c ? r[k4] = f : delete r[k4]), L;
      }
      var Ll = s6 ? function(r) {
        return r == null ? [] : (r = Y2(r), At(s6(r), function(c) {
          return m4.call(r, c);
        }));
      } : $l, Q9 = s6 ? function(r) {
        for (var c = []; r; )
          xt(c, Ll(r)), r = b0(r);
        return c;
      } : $l, me = A3;
      ($6 && me(new $6(new ArrayBuffer(1))) != c3 || H4 && me(new H4()) != y2 || Ti && me(Ti.resolve()) != w2 || S5 && me(new S5()) != Z1 || Y5 && me(new Y5()) != E2) && (me = function(r) {
        var c = A3(r), f = c == _2 ? r.constructor : n, y = f ? F5(f) : "";
        if (y)
          switch (y) {
            case M9:
              return c3;
            case l6:
              return y2;
            case k5:
              return w2;
            case C0:
              return Z1;
            case b9:
              return E2;
          }
        return c;
      });
      function Wd(r, c, f) {
        for (var y = -1, L = f.length; ++y < L; ) {
          var I = f[y], U = I.size;
          switch (I.type) {
            case "drop":
              r += U;
              break;
            case "dropRight":
              c -= U;
              break;
            case "take":
              c = ne(c, r + U);
              break;
            case "takeRight":
              r = R3(r, c - U);
              break;
          }
        }
        return { start: r, end: c };
      }
      function Yd(r) {
        var c = r.match(v4);
        return c ? c[1].split(wn) : [];
      }
      function e7(r, c, f) {
        c = Wt(c, r);
        for (var y = -1, L = c.length, I = !1; ++y < L; ) {
          var U = Xt(c[y]);
          if (!(I = r != null && f(r, U)))
            break;
          r = r[U];
        }
        return I || ++y != L ? I : (L = r == null ? 0 : r.length, !!L && e8(L) && w4(U, L) && (p2(r) || T5(r)));
      }
      function Xd(r) {
        var c = r.length, f = new r.constructor(c);
        return c && typeof r[0] == "string" && x2.call(r, "index") && (f.index = r.index, f.input = r.input), f;
      }
      function t7(r) {
        return typeof r.constructor == "function" && !X6(r) ? E5(b0(r)) : {};
      }
      function Kd(r, c, f) {
        var y = r.constructor;
        switch (c) {
          case n3:
            return yl(r);
          case E1:
          case T1:
            return new y(+r);
          case c3:
            return Td(r, f);
          case G2:
          case u3:
          case g2:
          case Oe:
          case q3:
          case ht:
          case E3:
          case j3:
          case z2:
            return P9(r, f);
          case y2:
            return new y();
          case B1:
          case t2:
            return new y(r);
          case e2:
            return Id(r);
          case Z1:
            return new y();
          case S2:
            return Od(r);
        }
      }
      function Zd(r, c) {
        var f = c.length;
        if (!f)
          return r;
        var y = f - 1;
        return c[y] = (f > 1 ? "& " : "") + c[y], c = c.join(f > 2 ? ", " : " "), r.replace(oe, `{
/* [wrapped with ` + c + `] */
`);
      }
      function Jd(r) {
        return p2(r) || T5(r) || !!(Vn && r && r[Vn]);
      }
      function w4(r, c) {
        var f = typeof r;
        return c = c ?? c1, !!c && (f == "number" || f != "symbol" && Mn.test(r)) && r > -1 && r % 1 == 0 && r < c;
      }
      function Ae(r, c, f) {
        if (!M3(f))
          return !1;
        var y = typeof c;
        return (y == "number" ? Ue(f) && w4(c, f.length) : y == "string" && c in f) ? St(f[c], r) : !1;
      }
      function xl(r, c) {
        if (p2(r))
          return !1;
        var f = typeof r;
        return f == "number" || f == "symbol" || f == "boolean" || r == null || st(r) ? !0 : ut.test(r) || !tt.test(r) || c != null && r in Y2(c);
      }
      function Qd(r) {
        var c = typeof r;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? r !== "__proto__" : r === null;
      }
      function Sl(r) {
        var c = Gi(r), f = A[c];
        if (typeof f != "function" || !(c in A2.prototype))
          return !1;
        if (r === f)
          return !0;
        var y = Ml(f);
        return !!y && r === y[0];
      }
      function ef(r) {
        return !!G5 && G5 in r;
      }
      var tf = te ? z4 : Ul;
      function X6(r) {
        var c = r && r.constructor, f = typeof c == "function" && c.prototype || $3;
        return r === f;
      }
      function n7(r) {
        return r === r && !M3(r);
      }
      function i7(r, c) {
        return function(f) {
          return f == null ? !1 : f[r] === c && (c !== n || r in Y2(f));
        };
      }
      function nf(r) {
        var c = Ji(r, function(y) {
          return f.size === u && f.clear(), y;
        }), f = c.cache;
        return c;
      }
      function sf(r, c) {
        var f = r[1], y = c[1], L = f | y, I = L < (M | z | R), U = y == R && f == x || y == R && f == V && r[7].length <= c[8] || y == (R | V) && c[7].length <= c[8] && f == x;
        if (!(I || U))
          return r;
        y & M && (r[2] = c[2], L |= f & M ? 0 : b);
        var Y = c[3];
        if (Y) {
          var l1 = r[3];
          r[3] = l1 ? V9(l1, Y, c[4]) : Y, r[4] = l1 ? $t(r[3], d) : c[4];
        }
        return Y = c[5], Y && (l1 = r[5], r[5] = l1 ? R9(l1, Y, c[6]) : Y, r[6] = l1 ? $t(r[5], d) : c[6]), Y = c[7], Y && (r[7] = Y), y & R && (r[8] = r[8] == null ? c[8] : ne(r[8], c[8])), r[9] == null && (r[9] = c[9]), r[0] = c[0], r[1] = L, r;
      }
      function lf(r) {
        var c = [];
        if (r != null)
          for (var f in Y2(r))
            c.push(f);
        return c;
      }
      function rf(r) {
        return n5.call(r);
      }
      function s7(r, c, f) {
        return c = R3(c === n ? r.length - 1 : c, 0), function() {
          for (var y = arguments, L = -1, I = R3(y.length - c, 0), U = u1(I); ++L < I; )
            U[L] = y[c + L];
          L = -1;
          for (var Y = u1(c + 1); ++L < c; )
            Y[L] = y[L];
          return Y[c] = f(U), fe(r, this, Y);
        };
      }
      function l7(r, c) {
        return c.length < 2 ? r : pe(r, Je(c, 0, -1));
      }
      function af(r, c) {
        for (var f = r.length, y = ne(c.length, f), L = $e(r); y--; ) {
          var I = c[y];
          r[y] = w4(I, f) ? L[I] : n;
        }
        return r;
      }
      function Cl(r, c) {
        if (!(c === "constructor" && typeof r[c] == "function") && c != "__proto__")
          return r[c];
      }
      var r7 = o7(Pi), K6 = Ir || function(r, c) {
        return D3.setTimeout(r, c);
      }, kl = o7(v6);
      function a7(r, c, f) {
        var y = c + "";
        return kl(r, Zd(y, of(Yd(y), f)));
      }
      function o7(r) {
        var c = 0, f = 0;
        return function() {
          var y = w9(), L = G - (y - f);
          if (f = y, L > 0) {
            if (++c >= O)
              return arguments[0];
          } else
            c = 0;
          return r.apply(n, arguments);
        };
      }
      function Yi(r, c) {
        var f = -1, y = r.length, L = y - 1;
        for (c = c === n ? y : c; ++f < c; ) {
          var I = f6(f, L), U = r[I];
          r[I] = r[f], r[f] = U;
        }
        return r.length = c, r;
      }
      var c7 = nf(function(r) {
        var c = [];
        return r.charCodeAt(0) === 46 && c.push(""), r.replace(D2, function(f, y, L, I) {
          c.push(L ? I.replace(q5, "$1") : y || f);
        }), c;
      });
      function Xt(r) {
        if (typeof r == "string" || st(r))
          return r;
        var c = r + "";
        return c == "0" && 1 / r == -h1 ? "-0" : c;
      }
      function F5(r) {
        if (r != null) {
          try {
            return Ee.call(r);
          } catch {
          }
          try {
            return r + "";
          } catch {
          }
        }
        return "";
      }
      function of(r, c) {
        return qe(n1, function(f) {
          var y = "_." + f[0];
          c & f[1] && !_0(r, y) && r.push(y);
        }), r.sort();
      }
      function h7(r) {
        if (r instanceof A2)
          return r.clone();
        var c = new Ke(r.__wrapped__, r.__chain__);
        return c.__actions__ = $e(r.__actions__), c.__index__ = r.__index__, c.__values__ = r.__values__, c;
      }
      function cf(r, c, f) {
        (f ? Ae(r, c, f) : c === n) ? c = 1 : c = R3(q2(c), 0);
        var y = r == null ? 0 : r.length;
        if (!y || c < 1)
          return [];
        for (var L = 0, I = 0, U = u1(L0(y / c)); L < y; )
          U[I++] = Je(r, L, L += c);
        return U;
      }
      function hf(r) {
        for (var c = -1, f = r == null ? 0 : r.length, y = 0, L = []; ++c < f; ) {
          var I = r[c];
          I && (L[y++] = I);
        }
        return L;
      }
      function uf() {
        var r = arguments.length;
        if (!r)
          return [];
        for (var c = u1(r - 1), f = arguments[0], y = r; y--; )
          c[y - 1] = arguments[y];
        return xt(p2(f) ? $e(f) : [f], i3(c, 1));
      }
      var df = M2(function(r, c) {
        return O3(r) ? x3(r, i3(c, 1, O3, !0)) : [];
      }), ff = M2(function(r, c) {
        var f = dt(c);
        return O3(f) && (f = n), O3(r) ? x3(r, i3(c, 1, O3, !0), i2(f, 2)) : [];
      }), vf = M2(function(r, c) {
        var f = dt(c);
        return O3(f) && (f = n), O3(r) ? x3(r, i3(c, 1, O3, !0), n, f) : [];
      });
      function pf(r, c, f) {
        var y = r == null ? 0 : r.length;
        return y ? (c = f || c === n ? 1 : q2(c), Je(r, c < 0 ? 0 : c, y)) : [];
      }
      function mf(r, c, f) {
        var y = r == null ? 0 : r.length;
        return y ? (c = f || c === n ? 1 : q2(c), c = y - c, Je(r, 0, c < 0 ? 0 : c)) : [];
      }
      function gf(r, c) {
        return r && r.length ? F0(r, i2(c, 3), !0, !0) : [];
      }
      function yf(r, c) {
        return r && r.length ? F0(r, i2(c, 3), !0) : [];
      }
      function _f(r, c, f, y) {
        var L = r == null ? 0 : r.length;
        return L ? (f && typeof f != "number" && Ae(r, c, f) && (f = 0, y = L), zt(r, c, f, y)) : [];
      }
      function u7(r, c, f) {
        var y = r == null ? 0 : r.length;
        if (!y)
          return -1;
        var L = f == null ? 0 : q2(f);
        return L < 0 && (L = R3(y + L, 0)), H1(r, i2(c, 3), L);
      }
      function d7(r, c, f) {
        var y = r == null ? 0 : r.length;
        if (!y)
          return -1;
        var L = y - 1;
        return f !== n && (L = q2(f), L = f < 0 ? R3(y + L, 0) : ne(L, y - 1)), H1(r, i2(c, 3), L, !0);
      }
      function f7(r) {
        var c = r == null ? 0 : r.length;
        return c ? i3(r, 1) : [];
      }
      function qf(r) {
        var c = r == null ? 0 : r.length;
        return c ? i3(r, h1) : [];
      }
      function wf(r, c) {
        var f = r == null ? 0 : r.length;
        return f ? (c = c === n ? 1 : q2(c), i3(r, c)) : [];
      }
      function zf(r) {
        for (var c = -1, f = r == null ? 0 : r.length, y = {}; ++c < f; ) {
          var L = r[c];
          y[L[0]] = L[1];
        }
        return y;
      }
      function v7(r) {
        return r && r.length ? r[0] : n;
      }
      function Mf(r, c, f) {
        var y = r == null ? 0 : r.length;
        if (!y)
          return -1;
        var L = f == null ? 0 : q2(f);
        return L < 0 && (L = R3(y + L, 0)), J1(r, c, L);
      }
      function bf(r) {
        var c = r == null ? 0 : r.length;
        return c ? Je(r, 0, -1) : [];
      }
      var Lf = M2(function(r) {
        var c = t3(r, l5);
        return c.length && c[0] === r[0] ? X5(c) : [];
      }), xf = M2(function(r) {
        var c = dt(r), f = t3(r, l5);
        return c === dt(f) ? c = n : f.pop(), f.length && f[0] === r[0] ? X5(f, i2(c, 2)) : [];
      }), Sf = M2(function(r) {
        var c = dt(r), f = t3(r, l5);
        return c = typeof c == "function" ? c : n, c && f.pop(), f.length && f[0] === r[0] ? X5(f, n, c) : [];
      });
      function Cf(r, c) {
        return r == null ? "" : q9.call(r, c);
      }
      function dt(r) {
        var c = r == null ? 0 : r.length;
        return c ? r[c - 1] : n;
      }
      function kf(r, c, f) {
        var y = r == null ? 0 : r.length;
        if (!y)
          return -1;
        var L = y;
        return f !== n && (L = q2(f), L = L < 0 ? R3(y + L, 0) : ne(L, y - 1)), c === c ? Fi(r, c, L) : H1(r, Z2, L, !0);
      }
      function Ef(r, c) {
        return r && r.length ? vl(r, q2(c)) : n;
      }
      var Af = M2(p7);
      function p7(r, c) {
        return r && r.length && c && c.length ? Hn(r, c) : r;
      }
      function Ff(r, c, f) {
        return r && r.length && c && c.length ? Hn(r, c, i2(f, 2)) : r;
      }
      function Tf(r, c, f) {
        return r && r.length && c && c.length ? Hn(r, c, n, f) : r;
      }
      var If = q4(function(r, c) {
        var f = r == null ? 0 : r.length, y = C2(r, c);
        return is(r, t3(c, function(L) {
          return w4(L, f) ? +L : L;
        }).sort(B9)), y;
      });
      function Of(r, c) {
        var f = [];
        if (!(r && r.length))
          return f;
        var y = -1, L = [], I = r.length;
        for (c = i2(c, 3); ++y < I; ) {
          var U = r[y];
          c(U, y, r) && (f.push(U), L.push(y));
        }
        return is(r, L), f;
      }
      function El(r) {
        return r == null ? r : cl.call(r);
      }
      function Nf(r, c, f) {
        var y = r == null ? 0 : r.length;
        return y ? (f && typeof f != "number" && Ae(r, c, f) ? (c = 0, f = y) : (c = c == null ? 0 : q2(c), f = f === n ? y : q2(f)), Je(r, c, f)) : [];
      }
      function Pf(r, c) {
        return p6(r, c);
      }
      function Bf(r, c, f) {
        return Z5(r, c, i2(f, 2));
      }
      function Vf(r, c) {
        var f = r == null ? 0 : r.length;
        if (f) {
          var y = p6(r, c);
          if (y < f && St(r[y], c))
            return y;
        }
        return -1;
      }
      function Rf(r, c) {
        return p6(r, c, !0);
      }
      function Hf(r, c, f) {
        return Z5(r, c, i2(f, 2), !0);
      }
      function Df(r, c) {
        var f = r == null ? 0 : r.length;
        if (f) {
          var y = p6(r, c, !0) - 1;
          if (St(r[y], c))
            return y;
        }
        return -1;
      }
      function $f(r) {
        return r && r.length ? gl(r) : [];
      }
      function Uf(r, c) {
        return r && r.length ? gl(r, i2(c, 2)) : [];
      }
      function jf(r) {
        var c = r == null ? 0 : r.length;
        return c ? Je(r, 1, c) : [];
      }
      function Gf(r, c, f) {
        return r && r.length ? (c = f || c === n ? 1 : q2(c), Je(r, 0, c < 0 ? 0 : c)) : [];
      }
      function Wf(r, c, f) {
        var y = r == null ? 0 : r.length;
        return y ? (c = f || c === n ? 1 : q2(c), c = y - c, Je(r, c < 0 ? 0 : c, y)) : [];
      }
      function Yf(r, c) {
        return r && r.length ? F0(r, i2(c, 3), !1, !0) : [];
      }
      function Xf(r, c) {
        return r && r.length ? F0(r, i2(c, 3)) : [];
      }
      var Kf = M2(function(r) {
        return h4(i3(r, 1, O3, !0));
      }), Zf = M2(function(r) {
        var c = dt(r);
        return O3(c) && (c = n), h4(i3(r, 1, O3, !0), i2(c, 2));
      }), Jf = M2(function(r) {
        var c = dt(r);
        return c = typeof c == "function" ? c : n, h4(i3(r, 1, O3, !0), n, c);
      });
      function Qf(r) {
        return r && r.length ? h4(r) : [];
      }
      function ev(r, c) {
        return r && r.length ? h4(r, i2(c, 2)) : [];
      }
      function tv(r, c) {
        return c = typeof c == "function" ? c : n, r && r.length ? h4(r, n, c) : [];
      }
      function Al(r) {
        if (!(r && r.length))
          return [];
        var c = 0;
        return r = At(r, function(f) {
          if (O3(f))
            return c = R3(f.length, c), !0;
        }), wt(c, function(f) {
          return t3(r, y3(f));
        });
      }
      function m7(r, c) {
        if (!(r && r.length))
          return [];
        var f = Al(r);
        return c == null ? f : t3(f, function(y) {
          return fe(c, n, y);
        });
      }
      var nv = M2(function(r, c) {
        return O3(r) ? x3(r, c) : [];
      }), iv = M2(function(r) {
        return D4(At(r, O3));
      }), sv = M2(function(r) {
        var c = dt(r);
        return O3(c) && (c = n), D4(At(r, O3), i2(c, 2));
      }), lv = M2(function(r) {
        var c = dt(r);
        return c = typeof c == "function" ? c : n, D4(At(r, O3), n, c);
      }), rv = M2(Al);
      function av(r, c) {
        return J5(r || [], c || [], V1);
      }
      function ov(r, c) {
        return J5(r || [], c || [], K5);
      }
      var cv = M2(function(r) {
        var c = r.length, f = c > 1 ? r[c - 1] : n;
        return f = typeof f == "function" ? (r.pop(), f) : n, m7(r, f);
      });
      function g7(r) {
        var c = A(r);
        return c.__chain__ = !0, c;
      }
      function hv(r, c) {
        return c(r), r;
      }
      function Xi(r, c) {
        return c(r);
      }
      var uv = q4(function(r) {
        var c = r.length, f = c ? r[0] : 0, y = this.__wrapped__, L = function(I) {
          return C2(I, r);
        };
        return c > 1 || this.__actions__.length || !(y instanceof A2) || !w4(f) ? this.thru(L) : (y = y.slice(f, +f + (c ? 1 : 0)), y.__actions__.push({
          func: Xi,
          args: [L],
          thisArg: n
        }), new Ke(y, this.__chain__).thru(function(I) {
          return c && !I.length && I.push(n), I;
        }));
      });
      function dv() {
        return g7(this);
      }
      function fv() {
        return new Ke(this.value(), this.__chain__);
      }
      function vv() {
        this.__values__ === n && (this.__values__ = A7(this.value()));
        var r = this.__index__ >= this.__values__.length, c = r ? n : this.__values__[this.__index__++];
        return { done: r, value: c };
      }
      function pv() {
        return this;
      }
      function mv(r) {
        for (var c, f = this; f instanceof a6; ) {
          var y = h7(f);
          y.__index__ = 0, y.__values__ = n, c ? L.__wrapped__ = y : c = y;
          var L = y;
          f = f.__wrapped__;
        }
        return L.__wrapped__ = r, c;
      }
      function gv() {
        var r = this.__wrapped__;
        if (r instanceof A2) {
          var c = r;
          return this.__actions__.length && (c = new A2(this)), c = c.reverse(), c.__actions__.push({
            func: Xi,
            args: [El],
            thisArg: n
          }), new Ke(c, this.__chain__);
        }
        return this.thru(El);
      }
      function yv() {
        return Dn(this.__wrapped__, this.__actions__);
      }
      var _v = Hi(function(r, c, f) {
        x2.call(r, f) ? ++r[f] : $1(r, f, 1);
      });
      function qv(r, c, f) {
        var y = p2(r) ? R6 : we;
        return f && Ae(r, c, f) && (c = n), y(r, i2(c, 3));
      }
      function wv(r, c) {
        var f = p2(r) ? At : c4;
        return f(r, i2(c, 3));
      }
      var zv = U9(u7), Mv = U9(d7);
      function bv(r, c) {
        return i3(Ki(r, c), 1);
      }
      function Lv(r, c) {
        return i3(Ki(r, c), h1);
      }
      function xv(r, c, f) {
        return f = f === n ? 1 : q2(f), i3(Ki(r, c), f);
      }
      function y7(r, c) {
        var f = p2(r) ? qe : a3;
        return f(r, i2(c, 3));
      }
      function _7(r, c) {
        var f = p2(r) ? Ci : ve;
        return f(r, i2(c, 3));
      }
      var Sv = Hi(function(r, c, f) {
        x2.call(r, f) ? r[f].push(c) : $1(r, f, [c]);
      });
      function Cv(r, c, f, y) {
        r = Ue(r) ? r : P0(r), f = f && !y ? q2(f) : 0;
        var L = r.length;
        return f < 0 && (f = R3(L + f, 0)), t8(r) ? f <= L && r.indexOf(c, f) > -1 : !!L && J1(r, c, f) > -1;
      }
      var kv = M2(function(r, c, f) {
        var y = -1, L = typeof c == "function", I = Ue(r) ? u1(r.length) : [];
        return a3(r, function(U) {
          I[++y] = L ? fe(c, U, f) : ce(U, c, f);
        }), I;
      }), Ev = Hi(function(r, c, f) {
        $1(r, f, c);
      });
      function Ki(r, c) {
        var f = p2(r) ? t3 : G6;
        return f(r, i2(c, 3));
      }
      function Av(r, c, f, y) {
        return r == null ? [] : (p2(c) || (c = c == null ? [] : [c]), f = y ? n : f, p2(f) || (f = f == null ? [] : [f]), pl(r, c, f));
      }
      var Fv = Hi(function(r, c, f) {
        r[f ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      });
      function Tv(r, c, f) {
        var y = p2(r) ? Q4 : He, L = arguments.length < 3;
        return y(r, i2(c, 4), f, L, a3);
      }
      function Iv(r, c, f) {
        var y = p2(r) ? ki : He, L = arguments.length < 3;
        return y(r, i2(c, 4), f, L, ve);
      }
      function Ov(r, c) {
        var f = p2(r) ? At : c4;
        return f(r, Qi(i2(c, 3)));
      }
      function Nv(r) {
        var c = p2(r) ? I1 : O9;
        return c(r);
      }
      function Pv(r, c, f) {
        (f ? Ae(r, c, f) : c === n) ? c = 1 : c = q2(c);
        var y = p2(r) ? O1 : ss;
        return y(r, c);
      }
      function Bv(r) {
        var c = p2(r) ? k1 : $r;
        return c(r);
      }
      function Vv(r) {
        if (r == null)
          return 0;
        if (Ue(r))
          return t8(r) ? R4(r) : r.length;
        var c = me(r);
        return c == y2 || c == Z1 ? r.size : h6(r).length;
      }
      function Rv(r, c, f) {
        var y = p2(r) ? S : N9;
        return f && Ae(r, c, f) && (c = n), y(r, i2(c, 3));
      }
      var Hv = M2(function(r, c) {
        if (r == null)
          return [];
        var f = c.length;
        return f > 1 && Ae(r, c[0], c[1]) ? c = [] : f > 2 && Ae(c[0], c[1], c[2]) && (c = [c[0]]), pl(r, i3(c, 1), []);
      }), Zi = ll || function() {
        return D3.Date.now();
      };
      function Dv(r, c) {
        if (typeof c != "function")
          throw new ke(a);
        return r = q2(r), function() {
          if (--r < 1)
            return c.apply(this, arguments);
        };
      }
      function q7(r, c, f) {
        return c = f ? n : c, c = r && c == null ? r.length : c, _4(r, R, n, n, n, n, c);
      }
      function w7(r, c) {
        var f;
        if (typeof c != "function")
          throw new ke(a);
        return r = q2(r), function() {
          return --r > 0 && (f = c.apply(this, arguments)), r <= 1 && (c = n), f;
        };
      }
      var Fl = M2(function(r, c, f) {
        var y = M;
        if (f.length) {
          var L = $t(f, O0(Fl));
          y |= F;
        }
        return _4(r, y, c, f, L);
      }), z7 = M2(function(r, c, f) {
        var y = M | z;
        if (f.length) {
          var L = $t(f, O0(z7));
          y |= F;
        }
        return _4(c, y, r, f, L);
      });
      function M7(r, c, f) {
        c = f ? n : c;
        var y = _4(r, x, n, n, n, n, n, c);
        return y.placeholder = M7.placeholder, y;
      }
      function b7(r, c, f) {
        c = f ? n : c;
        var y = _4(r, k, n, n, n, n, n, c);
        return y.placeholder = b7.placeholder, y;
      }
      function L7(r, c, f) {
        var y, L, I, U, Y, l1, _1 = 0, q1 = !1, x1 = !1, P1 = !0;
        if (typeof r != "function")
          throw new ke(a);
        c = ft(c) || 0, M3(f) && (q1 = !!f.leading, x1 = "maxWait" in f, I = x1 ? R3(ft(f.maxWait) || 0, c) : I, P1 = "trailing" in f ? !!f.trailing : P1);
        function W1(N3) {
          var Ct = y, b4 = L;
          return y = L = n, _1 = N3, U = r.apply(b4, Ct), U;
        }
        function l2(N3) {
          return _1 = N3, Y = K6(T2, c), q1 ? W1(N3) : U;
        }
        function b2(N3) {
          var Ct = N3 - l1, b4 = N3 - _1, U7 = c - Ct;
          return x1 ? ne(U7, I - b4) : U7;
        }
        function r2(N3) {
          var Ct = N3 - l1, b4 = N3 - _1;
          return l1 === n || Ct >= c || Ct < 0 || x1 && b4 >= I;
        }
        function T2() {
          var N3 = Zi();
          if (r2(N3))
            return B2(N3);
          Y = K6(T2, b2(N3));
        }
        function B2(N3) {
          return Y = n, P1 && y ? W1(N3) : (y = L = n, U);
        }
        function lt() {
          Y !== n && Vi(Y), _1 = 0, y = l1 = L = Y = n;
        }
        function Fe() {
          return Y === n ? U : B2(Zi());
        }
        function rt() {
          var N3 = Zi(), Ct = r2(N3);
          if (y = arguments, L = this, l1 = N3, Ct) {
            if (Y === n)
              return l2(l1);
            if (x1)
              return Vi(Y), Y = K6(T2, c), W1(l1);
          }
          return Y === n && (Y = K6(T2, c)), U;
        }
        return rt.cancel = lt, rt.flush = Fe, rt;
      }
      var $v = M2(function(r, c) {
        return ie(r, 1, c);
      }), Uv = M2(function(r, c, f) {
        return ie(r, ft(c) || 0, f);
      });
      function jv(r) {
        return _4(r, J);
      }
      function Ji(r, c) {
        if (typeof r != "function" || c != null && typeof c != "function")
          throw new ke(a);
        var f = function() {
          var y = arguments, L = c ? c.apply(this, y) : y[0], I = f.cache;
          if (I.has(L))
            return I.get(L);
          var U = r.apply(this, y);
          return f.cache = I.set(L, U) || I, U;
        };
        return f.cache = new (Ji.Cache || Ot)(), f;
      }
      Ji.Cache = Ot;
      function Qi(r) {
        if (typeof r != "function")
          throw new ke(a);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !r.call(this);
            case 1:
              return !r.call(this, c[0]);
            case 2:
              return !r.call(this, c[0], c[1]);
            case 3:
              return !r.call(this, c[0], c[1], c[2]);
          }
          return !r.apply(this, c);
        };
      }
      function Gv(r) {
        return w7(2, r);
      }
      var Wv = Ur(function(r, c) {
        c = c.length == 1 && p2(c[0]) ? t3(c[0], V3(i2())) : t3(i3(c, 1), V3(i2()));
        var f = c.length;
        return M2(function(y) {
          for (var L = -1, I = ne(y.length, f); ++L < I; )
            y[L] = c[L].call(this, y[L]);
          return fe(r, this, y);
        });
      }), Tl = M2(function(r, c) {
        var f = $t(c, O0(Tl));
        return _4(r, F, n, c, f);
      }), x7 = M2(function(r, c) {
        var f = $t(c, O0(x7));
        return _4(r, D, n, c, f);
      }), Yv = q4(function(r, c) {
        return _4(r, V, n, n, n, c);
      });
      function Xv(r, c) {
        if (typeof r != "function")
          throw new ke(a);
        return c = c === n ? c : q2(c), M2(r, c);
      }
      function Kv(r, c) {
        if (typeof r != "function")
          throw new ke(a);
        return c = c == null ? 0 : R3(q2(c), 0), M2(function(f) {
          var y = f[c], L = y4(f, 0, c);
          return y && xt(L, y), fe(r, this, L);
        });
      }
      function Zv(r, c, f) {
        var y = !0, L = !0;
        if (typeof r != "function")
          throw new ke(a);
        return M3(f) && (y = "leading" in f ? !!f.leading : y, L = "trailing" in f ? !!f.trailing : L), L7(r, c, {
          leading: y,
          maxWait: c,
          trailing: L
        });
      }
      function Jv(r) {
        return q7(r, 1);
      }
      function Qv(r, c) {
        return Tl(m6(c), r);
      }
      function ep() {
        if (!arguments.length)
          return [];
        var r = arguments[0];
        return p2(r) ? r : [r];
      }
      function tp(r) {
        return k2(r, p);
      }
      function np(r, c) {
        return c = typeof c == "function" ? c : n, k2(r, p, c);
      }
      function ip(r) {
        return k2(r, v | p);
      }
      function sp(r, c) {
        return c = typeof c == "function" ? c : n, k2(r, v | p, c);
      }
      function lp(r, c) {
        return c == null || Q3(r, c, ee(c));
      }
      function St(r, c) {
        return r === c || r !== r && c !== c;
      }
      var rp = ji(A4), ap = ji(function(r, c) {
        return r >= c;
      }), T5 = Oi(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Oi : function(r) {
        return S3(r) && x2.call(r, "callee") && !m4.call(r, "callee");
      }, p2 = u1.isArray, op = B6 ? V3(B6) : Rr;
      function Ue(r) {
        return r != null && e8(r.length) && !z4(r);
      }
      function O3(r) {
        return S3(r) && Ue(r);
      }
      function cp(r) {
        return r === !0 || r === !1 || S3(r) && A3(r) == E1;
      }
      var $4 = rl || Ul, hp = y0 ? V3(y0) : Hr;
      function up(r) {
        return S3(r) && r.nodeType === 1 && !Z6(r);
      }
      function dp(r) {
        if (r == null)
          return !0;
        if (Ue(r) && (p2(r) || typeof r == "string" || typeof r.splice == "function" || $4(r) || N0(r) || T5(r)))
          return !r.length;
        var c = me(r);
        if (c == y2 || c == Z1)
          return !r.size;
        if (X6(r))
          return !h6(r).length;
        for (var f in r)
          if (x2.call(r, f))
            return !1;
        return !0;
      }
      function fp(r, c) {
        return s5(r, c);
      }
      function vp(r, c, f) {
        f = typeof f == "function" ? f : n;
        var y = f ? f(r, c) : n;
        return y === n ? s5(r, c, n, f) : !!y;
      }
      function Il(r) {
        if (!S3(r))
          return !1;
        var c = A3(r);
        return c == X1 || c == n2 || typeof r.message == "string" && typeof r.name == "string" && !Z6(r);
      }
      function pp(r) {
        return typeof r == "number" && al(r);
      }
      function z4(r) {
        if (!M3(r))
          return !1;
        var c = A3(r);
        return c == a2 || c == d2 || c == C1 || c == K1;
      }
      function S7(r) {
        return typeof r == "number" && r == q2(r);
      }
      function e8(r) {
        return typeof r == "number" && r > -1 && r % 1 == 0 && r <= c1;
      }
      function M3(r) {
        var c = typeof r;
        return r != null && (c == "object" || c == "function");
      }
      function S3(r) {
        return r != null && typeof r == "object";
      }
      var C7 = xi ? V3(xi) : J8;
      function mp(r, c) {
        return r === c || g4(r, c, bl(c));
      }
      function gp(r, c, f) {
        return f = typeof f == "function" ? f : n, g4(r, c, bl(c), f);
      }
      function yp(r) {
        return k7(r) && r != +r;
      }
      function _p(r) {
        if (tf(r))
          throw new s2(l);
        return c6(r);
      }
      function qp(r) {
        return r === null;
      }
      function wp(r) {
        return r == null;
      }
      function k7(r) {
        return typeof r == "number" || S3(r) && A3(r) == B1;
      }
      function Z6(r) {
        if (!S3(r) || A3(r) != _2)
          return !1;
        var c = b0(r);
        if (c === null)
          return !0;
        var f = x2.call(c, "constructor") && c.constructor;
        return typeof f == "function" && f instanceof f && Ee.call(f) == W8;
      }
      var Ol = Q0 ? V3(Q0) : Rn;
      function zp(r) {
        return S7(r) && r >= -c1 && r <= c1;
      }
      var E7 = Si ? V3(Si) : Dr;
      function t8(r) {
        return typeof r == "string" || !p2(r) && S3(r) && A3(r) == t2;
      }
      function st(r) {
        return typeof r == "symbol" || S3(r) && A3(r) == S2;
      }
      var N0 = V6 ? V3(V6) : Q8;
      function Mp(r) {
        return r === n;
      }
      function bp(r) {
        return S3(r) && me(r) == E2;
      }
      function Lp(r) {
        return S3(r) && A3(r) == o3;
      }
      var xp = ji(u6), Sp = ji(function(r, c) {
        return r <= c;
      });
      function A7(r) {
        if (!r)
          return [];
        if (Ue(r))
          return t8(r) ? it(r) : $e(r);
        if (i5 && r[i5])
          return Pn(r[i5]());
        var c = me(r), f = c == y2 ? q0 : c == Z1 ? M5 : P0;
        return f(r);
      }
      function M4(r) {
        if (!r)
          return r === 0 ? r : 0;
        if (r = ft(r), r === h1 || r === -h1) {
          var c = r < 0 ? -1 : 1;
          return c * M1;
        }
        return r === r ? r : 0;
      }
      function q2(r) {
        var c = M4(r), f = c % 1;
        return c === c ? f ? c - f : c : 0;
      }
      function F7(r) {
        return r ? o2(q2(r), 0, A1) : 0;
      }
      function ft(r) {
        if (typeof r == "number")
          return r;
        if (st(r))
          return y1;
        if (M3(r)) {
          var c = typeof r.valueOf == "function" ? r.valueOf() : r;
          r = M3(c) ? c + "" : c;
        }
        if (typeof r != "string")
          return r === 0 ? r : +r;
        r = B4(r);
        var f = H5.test(r);
        return f || zn.test(r) ? $8(r.slice(2), f ? 2 : 8) : K4.test(r) ? y1 : +r;
      }
      function T7(r) {
        return Yt(r, je(r));
      }
      function Cp(r) {
        return r ? o2(q2(r), -c1, c1) : r === 0 ? r : 0;
      }
      function K2(r) {
        return r == null ? "" : De(r);
      }
      var kp = T0(function(r, c) {
        if (X6(c) || Ue(c)) {
          Yt(c, ee(c), r);
          return;
        }
        for (var f in c)
          x2.call(c, f) && V1(r, f, c[f]);
      }), I7 = T0(function(r, c) {
        Yt(c, je(c), r);
      }), n8 = T0(function(r, c, f, y) {
        Yt(c, je(c), r, y);
      }), Ep = T0(function(r, c, f, y) {
        Yt(c, ee(c), r, y);
      }), Ap = q4(C2);
      function Fp(r, c) {
        var f = E5(r);
        return c == null ? f : j1(f, c);
      }
      var Tp = M2(function(r, c) {
        r = Y2(r);
        var f = -1, y = c.length, L = y > 2 ? c[2] : n;
        for (L && Ae(c[0], c[1], L) && (y = 1); ++f < y; )
          for (var I = c[f], U = je(I), Y = -1, l1 = U.length; ++Y < l1; ) {
            var _1 = U[Y], q1 = r[_1];
            (q1 === n || St(q1, $3[_1]) && !x2.call(r, _1)) && (r[_1] = I[_1]);
          }
        return r;
      }), Ip = M2(function(r) {
        return r.push(n, Z9), fe(O7, n, r);
      });
      function Op(r, c) {
        return F1(r, i2(c, 3), le);
      }
      function Np(r, c) {
        return F1(r, i2(c, 3), jt);
      }
      function Pp(r, c) {
        return r == null ? r : Nt(r, i2(c, 3), je);
      }
      function Bp(r, c) {
        return r == null ? r : se(r, i2(c, 3), je);
      }
      function Vp(r, c) {
        return r && le(r, i2(c, 3));
      }
      function Rp(r, c) {
        return r && jt(r, i2(c, 3));
      }
      function Hp(r) {
        return r == null ? [] : Ze(r, ee(r));
      }
      function Dp(r) {
        return r == null ? [] : Ze(r, je(r));
      }
      function Nl(r, c, f) {
        var y = r == null ? n : pe(r, c);
        return y === n ? f : y;
      }
      function $p(r, c) {
        return r != null && e7(r, c, Pt);
      }
      function Pl(r, c) {
        return r != null && e7(r, c, k0);
      }
      var Up = G9(function(r, c, f) {
        c != null && typeof c.toString != "function" && (c = n5.call(c)), r[c] = f;
      }, Vl(Ge)), jp = G9(function(r, c, f) {
        c != null && typeof c.toString != "function" && (c = n5.call(c)), x2.call(r, c) ? r[c].push(f) : r[c] = [f];
      }, i2), Gp = M2(ce);
      function ee(r) {
        return Ue(r) ? L1(r) : h6(r);
      }
      function je(r) {
        return Ue(r) ? L1(r, !0) : ul(r);
      }
      function Wp(r, c) {
        var f = {};
        return c = i2(c, 3), le(r, function(y, L, I) {
          $1(f, c(y, L, I), y);
        }), f;
      }
      function Yp(r, c) {
        var f = {};
        return c = i2(c, 3), le(r, function(y, L, I) {
          $1(f, L, c(y, L, I));
        }), f;
      }
      var Xp = T0(function(r, c, f) {
        E0(r, c, f);
      }), O7 = T0(function(r, c, f, y) {
        E0(r, c, f, y);
      }), Kp = q4(function(r, c) {
        var f = {};
        if (r == null)
          return f;
        var y = !1;
        c = t3(c, function(I) {
          return I = Wt(I, r), y || (y = I.length > 1), I;
        }), Yt(r, zl(r), f), y && (f = k2(f, v | m | p, $d));
        for (var L = c.length; L--; )
          Bi(f, c[L]);
        return f;
      });
      function Zp(r, c) {
        return N7(r, Qi(i2(c)));
      }
      var Jp = q4(function(r, c) {
        return r == null ? {} : I9(r, c);
      });
      function N7(r, c) {
        if (r == null)
          return {};
        var f = t3(zl(r), function(y) {
          return [y];
        });
        return c = i2(c), ts(r, f, function(y, L) {
          return c(y, L[0]);
        });
      }
      function Qp(r, c, f) {
        c = Wt(c, r);
        var y = -1, L = c.length;
        for (L || (L = 1, r = n); ++y < L; ) {
          var I = r == null ? n : r[Xt(c[y])];
          I === n && (y = L, I = f), r = z4(I) ? I.call(r) : I;
        }
        return r;
      }
      function em(r, c, f) {
        return r == null ? r : K5(r, c, f);
      }
      function tm(r, c, f, y) {
        return y = typeof y == "function" ? y : n, r == null ? r : K5(r, c, f, y);
      }
      var P7 = X9(ee), B7 = X9(je);
      function nm(r, c, f) {
        var y = p2(r), L = y || $4(r) || N0(r);
        if (c = i2(c, 4), f == null) {
          var I = r && r.constructor;
          L ? f = y ? new I() : [] : M3(r) ? f = z4(I) ? E5(b0(r)) : {} : f = {};
        }
        return (L ? qe : le)(r, function(U, Y, l1) {
          return c(f, U, Y, l1);
        }), f;
      }
      function im(r, c) {
        return r == null ? !0 : Bi(r, c);
      }
      function sm(r, c, f) {
        return r == null ? r : W6(r, c, m6(f));
      }
      function lm(r, c, f, y) {
        return y = typeof y == "function" ? y : n, r == null ? r : W6(r, c, m6(f), y);
      }
      function P0(r) {
        return r == null ? [] : V4(r, ee(r));
      }
      function rm(r) {
        return r == null ? [] : V4(r, je(r));
      }
      function am(r, c, f) {
        return f === n && (f = c, c = n), f !== n && (f = ft(f), f = f === f ? f : 0), c !== n && (c = ft(c), c = c === c ? c : 0), o2(ft(r), c, f);
      }
      function om(r, c, f) {
        return c = M4(c), f === n ? (f = c, c = 0) : f = M4(f), r = ft(r), j6(r, c, f);
      }
      function cm(r, c, f) {
        if (f && typeof f != "boolean" && Ae(r, c, f) && (c = f = n), f === n && (typeof c == "boolean" ? (f = c, c = n) : typeof r == "boolean" && (f = r, r = n)), r === n && c === n ? (r = 0, c = 1) : (r = M4(r), c === n ? (c = r, r = 0) : c = M4(c)), r > c) {
          var y = r;
          r = c, c = y;
        }
        if (f || r % 1 || c % 1) {
          var L = ol();
          return ne(r + L * (c - r + Fn("1e-" + ((L + "").length - 1))), c);
        }
        return f6(r, c);
      }
      var hm = I0(function(r, c, f) {
        return c = c.toLowerCase(), r + (f ? V7(c) : c);
      });
      function V7(r) {
        return Bl(K2(r).toLowerCase());
      }
      function R7(r) {
        return r = K2(r), r && r.replace(bn, Ei).replace(D8, "");
      }
      function um(r, c, f) {
        r = K2(r), c = De(c);
        var y = r.length;
        f = f === n ? y : o2(q2(f), 0, y);
        var L = f;
        return f -= c.length, f >= 0 && r.slice(f, L) == c;
      }
      function dm(r) {
        return r = K2(r), r && d3.test(r) ? r.replace(Se, Ai) : r;
      }
      function fm(r) {
        return r = K2(r), r && _t.test(r) ? r.replace(Re, "\\$&") : r;
      }
      var vm = I0(function(r, c, f) {
        return r + (f ? "-" : "") + c.toLowerCase();
      }), pm = I0(function(r, c, f) {
        return r + (f ? " " : "") + c.toLowerCase();
      }), mm = $9("toLowerCase");
      function gm(r, c, f) {
        r = K2(r), c = q2(c);
        var y = c ? R4(r) : 0;
        if (!c || y >= c)
          return r;
        var L = (c - y) / 2;
        return Ui(x0(L), f) + r + Ui(L0(L), f);
      }
      function ym(r, c, f) {
        r = K2(r), c = q2(c);
        var y = c ? R4(r) : 0;
        return c && y < c ? r + Ui(c - y, f) : r;
      }
      function _m(r, c, f) {
        r = K2(r), c = q2(c);
        var y = c ? R4(r) : 0;
        return c && y < c ? Ui(c - y, f) + r : r;
      }
      function qm(r, c, f) {
        return f || c == null ? c = 0 : c && (c = +c), z9(K2(r).replace(L3, ""), c || 0);
      }
      function wm(r, c, f) {
        return (f ? Ae(r, c, f) : c === n) ? c = 1 : c = q2(c), A0(K2(r), c);
      }
      function zm() {
        var r = arguments, c = K2(r[0]);
        return r.length < 3 ? c : c.replace(r[1], r[2]);
      }
      var Mm = I0(function(r, c, f) {
        return r + (f ? "_" : "") + c.toLowerCase();
      });
      function bm(r, c, f) {
        return f && typeof f != "number" && Ae(r, c, f) && (c = f = n), f = f === n ? A1 : f >>> 0, f ? (r = K2(r), r && (typeof c == "string" || c != null && !Ol(c)) && (c = De(c), !c && i4(r)) ? y4(it(r), 0, f) : r.split(c, f)) : [];
      }
      var Lm = I0(function(r, c, f) {
        return r + (f ? " " : "") + Bl(c);
      });
      function xm(r, c, f) {
        return r = K2(r), f = f == null ? 0 : o2(q2(f), 0, r.length), c = De(c), r.slice(f, f + c.length) == c;
      }
      function Sm(r, c, f) {
        var y = A.templateSettings;
        f && Ae(r, c, f) && (c = n), r = K2(r), c = n8({}, c, y, K9);
        var L = n8({}, c.imports, y.imports, K9), I = ee(L), U = V4(L, I), Y, l1, _1 = 0, q1 = c.interpolate || Z4, x1 = "__p += '", P1 = x5(
          (c.escape || Z4).source + "|" + q1.source + "|" + (q1 === Ce ? w5 : Z4).source + "|" + (c.evaluate || Z4).source + "|$",
          "g"
        ), W1 = "//# sourceURL=" + (x2.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++il + "]") + `
`;
        r.replace(P1, function(r2, T2, B2, lt, Fe, rt) {
          return B2 || (B2 = lt), x1 += r.slice(_1, rt).replace(P8, On), T2 && (Y = !0, x1 += `' +
__e(` + T2 + `) +
'`), Fe && (l1 = !0, x1 += `';
` + Fe + `;
__p += '`), B2 && (x1 += `' +
((__t = (` + B2 + `)) == null ? '' : __t) +
'`), _1 = rt + r2.length, r2;
        }), x1 += `';
`;
        var l2 = x2.call(c, "variable") && c.variable;
        if (!l2)
          x1 = `with (obj) {
` + x1 + `
}
`;
        else if (_5.test(l2))
          throw new s2(o);
        x1 = (l1 ? x1.replace(R2, "") : x1).replace(w3, "$1").replace(B3, "$1;"), x1 = "function(" + (l2 || "obj") + `) {
` + (l2 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Y ? ", __e = _.escape" : "") + (l1 ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + x1 + `return __p
}`;
        var b2 = D7(function() {
          return N2(I, W1 + "return " + x1).apply(n, U);
        });
        if (b2.source = x1, Il(b2))
          throw b2;
        return b2;
      }
      function Cm(r) {
        return K2(r).toLowerCase();
      }
      function km(r) {
        return K2(r).toUpperCase();
      }
      function Em(r, c, f) {
        if (r = K2(r), r && (f || c === n))
          return B4(r);
        if (!r || !(c = De(c)))
          return r;
        var y = it(r), L = it(c), I = H6(y, L), U = D6(y, L) + 1;
        return y4(y, I, U).join("");
      }
      function Am(r, c, f) {
        if (r = K2(r), r && (f || c === n))
          return r.slice(0, U5(r) + 1);
        if (!r || !(c = De(c)))
          return r;
        var y = it(r), L = D6(y, it(c)) + 1;
        return y4(y, 0, L).join("");
      }
      function Fm(r, c, f) {
        if (r = K2(r), r && (f || c === n))
          return r.replace(L3, "");
        if (!r || !(c = De(c)))
          return r;
        var y = it(r), L = H6(y, it(c));
        return y4(y, L).join("");
      }
      function Tm(r, c) {
        var f = K, y = P;
        if (M3(c)) {
          var L = "separator" in c ? c.separator : L;
          f = "length" in c ? q2(c.length) : f, y = "omission" in c ? De(c.omission) : y;
        }
        r = K2(r);
        var I = r.length;
        if (i4(r)) {
          var U = it(r);
          I = U.length;
        }
        if (f >= I)
          return r;
        var Y = f - R4(y);
        if (Y < 1)
          return y;
        var l1 = U ? y4(U, 0, Y).join("") : r.slice(0, Y);
        if (L === n)
          return l1 + y;
        if (U && (Y += l1.length - Y), Ol(L)) {
          if (r.slice(Y).search(L)) {
            var _1, q1 = l1;
            for (L.global || (L = x5(L.source, K2(X4.exec(L)) + "g")), L.lastIndex = 0; _1 = L.exec(q1); )
              var x1 = _1.index;
            l1 = l1.slice(0, x1 === n ? Y : x1);
          }
        } else if (r.indexOf(De(L), Y) != Y) {
          var P1 = l1.lastIndexOf(L);
          P1 > -1 && (l1 = l1.slice(0, P1));
        }
        return l1 + y;
      }
      function Im(r) {
        return r = K2(r), r && _e.test(r) ? r.replace(G3, t5) : r;
      }
      var Om = I0(function(r, c, f) {
        return r + (f ? " " : "") + c.toUpperCase();
      }), Bl = $9("toUpperCase");
      function H7(r, c, f) {
        return r = K2(r), c = f ? n : c, c === n ? Nn(r) ? j5(r) : z1(r) : r.match(c) || [];
      }
      var D7 = M2(function(r, c) {
        try {
          return fe(r, n, c);
        } catch (f) {
          return Il(f) ? f : new s2(f);
        }
      }), Nm = q4(function(r, c) {
        return qe(c, function(f) {
          f = Xt(f), $1(r, f, Fl(r[f], r));
        }), r;
      });
      function Pm(r) {
        var c = r == null ? 0 : r.length, f = i2();
        return r = c ? t3(r, function(y) {
          if (typeof y[1] != "function")
            throw new ke(a);
          return [f(y[0]), y[1]];
        }) : [], M2(function(y) {
          for (var L = -1; ++L < c; ) {
            var I = r[L];
            if (fe(I[0], this, y))
              return fe(I[1], this, y);
          }
        });
      }
      function Bm(r) {
        return L2(k2(r, v));
      }
      function Vl(r) {
        return function() {
          return r;
        };
      }
      function Vm(r, c) {
        return r == null || r !== r ? c : r;
      }
      var Rm = j9(), Hm = j9(!0);
      function Ge(r) {
        return r;
      }
      function Rl(r) {
        return es(typeof r == "function" ? r : k2(r, v));
      }
      function Dm(r) {
        return dl(k2(r, v));
      }
      function $m(r, c) {
        return fl(r, k2(c, v));
      }
      var Um = M2(function(r, c) {
        return function(f) {
          return ce(f, r, c);
        };
      }), jm = M2(function(r, c) {
        return function(f) {
          return ce(r, f, c);
        };
      });
      function Hl(r, c, f) {
        var y = ee(c), L = Ze(c, y);
        f == null && !(M3(c) && (L.length || !y.length)) && (f = c, c = r, r = this, L = Ze(c, ee(c)));
        var I = !(M3(f) && "chain" in f) || !!f.chain, U = z4(r);
        return qe(L, function(Y) {
          var l1 = c[Y];
          r[Y] = l1, U && (r.prototype[Y] = function() {
            var _1 = this.__chain__;
            if (I || _1) {
              var q1 = r(this.__wrapped__), x1 = q1.__actions__ = $e(this.__actions__);
              return x1.push({ func: l1, args: arguments, thisArg: r }), q1.__chain__ = _1, q1;
            }
            return l1.apply(r, xt([this.value()], arguments));
          });
        }), r;
      }
      function Gm() {
        return D3._ === this && (D3._ = Fr), this;
      }
      function Dl() {
      }
      function Wm(r) {
        return r = q2(r), M2(function(c) {
          return vl(c, r);
        });
      }
      var Ym = _l(t3), Xm = _l(R6), Km = _l(S);
      function $7(r) {
        return xl(r) ? y3(Xt(r)) : ns(r);
      }
      function Zm(r) {
        return function(c) {
          return r == null ? n : pe(r, c);
        };
      }
      var Jm = W9(), Qm = W9(!0);
      function $l() {
        return [];
      }
      function Ul() {
        return !1;
      }
      function eg() {
        return {};
      }
      function tg() {
        return "";
      }
      function ng() {
        return !0;
      }
      function ig(r, c) {
        if (r = q2(r), r < 1 || r > c1)
          return [];
        var f = A1, y = ne(r, A1);
        c = i2(c), r -= A1;
        for (var L = wt(y, c); ++f < r; )
          c(f);
        return L;
      }
      function sg(r) {
        return p2(r) ? t3(r, Xt) : st(r) ? [r] : $e(c7(K2(r)));
      }
      function lg(r) {
        var c = ++M0;
        return K2(r) + c;
      }
      var rg = $i(function(r, c) {
        return r + c;
      }, 0), ag = ql("ceil"), og = $i(function(r, c) {
        return r / c;
      }, 1), cg = ql("floor");
      function hg(r) {
        return r && r.length ? h3(r, Ge, A4) : n;
      }
      function ug(r, c) {
        return r && r.length ? h3(r, i2(c, 2), A4) : n;
      }
      function dg(r) {
        return v3(r, Ge);
      }
      function fg(r, c) {
        return v3(r, i2(c, 2));
      }
      function vg(r) {
        return r && r.length ? h3(r, Ge, u6) : n;
      }
      function pg(r, c) {
        return r && r.length ? h3(r, i2(c, 2), u6) : n;
      }
      var mg = $i(function(r, c) {
        return r * c;
      }, 1), gg = ql("round"), yg = $i(function(r, c) {
        return r - c;
      }, 0);
      function _g(r) {
        return r && r.length ? Xe(r, Ge) : 0;
      }
      function qg(r, c) {
        return r && r.length ? Xe(r, i2(c, 2)) : 0;
      }
      return A.after = Dv, A.ary = q7, A.assign = kp, A.assignIn = I7, A.assignInWith = n8, A.assignWith = Ep, A.at = Ap, A.before = w7, A.bind = Fl, A.bindAll = Nm, A.bindKey = z7, A.castArray = ep, A.chain = g7, A.chunk = cf, A.compact = hf, A.concat = uf, A.cond = Pm, A.conforms = Bm, A.constant = Vl, A.countBy = _v, A.create = Fp, A.curry = M7, A.curryRight = b7, A.debounce = L7, A.defaults = Tp, A.defaultsDeep = Ip, A.defer = $v, A.delay = Uv, A.difference = df, A.differenceBy = ff, A.differenceWith = vf, A.drop = pf, A.dropRight = mf, A.dropRightWhile = gf, A.dropWhile = yf, A.fill = _f, A.filter = wv, A.flatMap = bv, A.flatMapDeep = Lv, A.flatMapDepth = xv, A.flatten = f7, A.flattenDeep = qf, A.flattenDepth = wf, A.flip = jv, A.flow = Rm, A.flowRight = Hm, A.fromPairs = zf, A.functions = Hp, A.functionsIn = Dp, A.groupBy = Sv, A.initial = bf, A.intersection = Lf, A.intersectionBy = xf, A.intersectionWith = Sf, A.invert = Up, A.invertBy = jp, A.invokeMap = kv, A.iteratee = Rl, A.keyBy = Ev, A.keys = ee, A.keysIn = je, A.map = Ki, A.mapKeys = Wp, A.mapValues = Yp, A.matches = Dm, A.matchesProperty = $m, A.memoize = Ji, A.merge = Xp, A.mergeWith = O7, A.method = Um, A.methodOf = jm, A.mixin = Hl, A.negate = Qi, A.nthArg = Wm, A.omit = Kp, A.omitBy = Zp, A.once = Gv, A.orderBy = Av, A.over = Ym, A.overArgs = Wv, A.overEvery = Xm, A.overSome = Km, A.partial = Tl, A.partialRight = x7, A.partition = Fv, A.pick = Jp, A.pickBy = N7, A.property = $7, A.propertyOf = Zm, A.pull = Af, A.pullAll = p7, A.pullAllBy = Ff, A.pullAllWith = Tf, A.pullAt = If, A.range = Jm, A.rangeRight = Qm, A.rearg = Yv, A.reject = Ov, A.remove = Of, A.rest = Xv, A.reverse = El, A.sampleSize = Pv, A.set = em, A.setWith = tm, A.shuffle = Bv, A.slice = Nf, A.sortBy = Hv, A.sortedUniq = $f, A.sortedUniqBy = Uf, A.split = bm, A.spread = Kv, A.tail = jf, A.take = Gf, A.takeRight = Wf, A.takeRightWhile = Yf, A.takeWhile = Xf, A.tap = hv, A.throttle = Zv, A.thru = Xi, A.toArray = A7, A.toPairs = P7, A.toPairsIn = B7, A.toPath = sg, A.toPlainObject = T7, A.transform = nm, A.unary = Jv, A.union = Kf, A.unionBy = Zf, A.unionWith = Jf, A.uniq = Qf, A.uniqBy = ev, A.uniqWith = tv, A.unset = im, A.unzip = Al, A.unzipWith = m7, A.update = sm, A.updateWith = lm, A.values = P0, A.valuesIn = rm, A.without = nv, A.words = H7, A.wrap = Qv, A.xor = iv, A.xorBy = sv, A.xorWith = lv, A.zip = rv, A.zipObject = av, A.zipObjectDeep = ov, A.zipWith = cv, A.entries = P7, A.entriesIn = B7, A.extend = I7, A.extendWith = n8, Hl(A, A), A.add = rg, A.attempt = D7, A.camelCase = hm, A.capitalize = V7, A.ceil = ag, A.clamp = am, A.clone = tp, A.cloneDeep = ip, A.cloneDeepWith = sp, A.cloneWith = np, A.conformsTo = lp, A.deburr = R7, A.defaultTo = Vm, A.divide = og, A.endsWith = um, A.eq = St, A.escape = dm, A.escapeRegExp = fm, A.every = qv, A.find = zv, A.findIndex = u7, A.findKey = Op, A.findLast = Mv, A.findLastIndex = d7, A.findLastKey = Np, A.floor = cg, A.forEach = y7, A.forEachRight = _7, A.forIn = Pp, A.forInRight = Bp, A.forOwn = Vp, A.forOwnRight = Rp, A.get = Nl, A.gt = rp, A.gte = ap, A.has = $p, A.hasIn = Pl, A.head = v7, A.identity = Ge, A.includes = Cv, A.indexOf = Mf, A.inRange = om, A.invoke = Gp, A.isArguments = T5, A.isArray = p2, A.isArrayBuffer = op, A.isArrayLike = Ue, A.isArrayLikeObject = O3, A.isBoolean = cp, A.isBuffer = $4, A.isDate = hp, A.isElement = up, A.isEmpty = dp, A.isEqual = fp, A.isEqualWith = vp, A.isError = Il, A.isFinite = pp, A.isFunction = z4, A.isInteger = S7, A.isLength = e8, A.isMap = C7, A.isMatch = mp, A.isMatchWith = gp, A.isNaN = yp, A.isNative = _p, A.isNil = wp, A.isNull = qp, A.isNumber = k7, A.isObject = M3, A.isObjectLike = S3, A.isPlainObject = Z6, A.isRegExp = Ol, A.isSafeInteger = zp, A.isSet = E7, A.isString = t8, A.isSymbol = st, A.isTypedArray = N0, A.isUndefined = Mp, A.isWeakMap = bp, A.isWeakSet = Lp, A.join = Cf, A.kebabCase = vm, A.last = dt, A.lastIndexOf = kf, A.lowerCase = pm, A.lowerFirst = mm, A.lt = xp, A.lte = Sp, A.max = hg, A.maxBy = ug, A.mean = dg, A.meanBy = fg, A.min = vg, A.minBy = pg, A.stubArray = $l, A.stubFalse = Ul, A.stubObject = eg, A.stubString = tg, A.stubTrue = ng, A.multiply = mg, A.nth = Ef, A.noConflict = Gm, A.noop = Dl, A.now = Zi, A.pad = gm, A.padEnd = ym, A.padStart = _m, A.parseInt = qm, A.random = cm, A.reduce = Tv, A.reduceRight = Iv, A.repeat = wm, A.replace = zm, A.result = Qp, A.round = gg, A.runInContext = e1, A.sample = Nv, A.size = Vv, A.snakeCase = Mm, A.some = Rv, A.sortedIndex = Pf, A.sortedIndexBy = Bf, A.sortedIndexOf = Vf, A.sortedLastIndex = Rf, A.sortedLastIndexBy = Hf, A.sortedLastIndexOf = Df, A.startCase = Lm, A.startsWith = xm, A.subtract = yg, A.sum = _g, A.sumBy = qg, A.template = Sm, A.times = ig, A.toFinite = M4, A.toInteger = q2, A.toLength = F7, A.toLower = Cm, A.toNumber = ft, A.toSafeInteger = Cp, A.toString = K2, A.toUpper = km, A.trim = Em, A.trimEnd = Am, A.trimStart = Fm, A.truncate = Tm, A.unescape = Im, A.uniqueId = lg, A.upperCase = Om, A.upperFirst = Bl, A.each = y7, A.eachRight = _7, A.first = v7, Hl(A, function() {
        var r = {};
        return le(A, function(c, f) {
          x2.call(A.prototype, f) || (r[f] = c);
        }), r;
      }(), { chain: !1 }), A.VERSION = i, qe(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(r) {
        A[r].placeholder = A;
      }), qe(["drop", "take"], function(r, c) {
        A2.prototype[r] = function(f) {
          f = f === n ? 1 : R3(q2(f), 0);
          var y = this.__filtered__ && !c ? new A2(this) : this.clone();
          return y.__filtered__ ? y.__takeCount__ = ne(f, y.__takeCount__) : y.__views__.push({
            size: ne(f, A1),
            type: r + (y.__dir__ < 0 ? "Right" : "")
          }), y;
        }, A2.prototype[r + "Right"] = function(f) {
          return this.reverse()[r](f).reverse();
        };
      }), qe(["filter", "map", "takeWhile"], function(r, c) {
        var f = c + 1, y = f == j || f == i1;
        A2.prototype[r] = function(L) {
          var I = this.clone();
          return I.__iteratees__.push({
            iteratee: i2(L, 3),
            type: f
          }), I.__filtered__ = I.__filtered__ || y, I;
        };
      }), qe(["head", "last"], function(r, c) {
        var f = "take" + (c ? "Right" : "");
        A2.prototype[r] = function() {
          return this[f](1).value()[0];
        };
      }), qe(["initial", "tail"], function(r, c) {
        var f = "drop" + (c ? "" : "Right");
        A2.prototype[r] = function() {
          return this.__filtered__ ? new A2(this) : this[f](1);
        };
      }), A2.prototype.compact = function() {
        return this.filter(Ge);
      }, A2.prototype.find = function(r) {
        return this.filter(r).head();
      }, A2.prototype.findLast = function(r) {
        return this.reverse().find(r);
      }, A2.prototype.invokeMap = M2(function(r, c) {
        return typeof r == "function" ? new A2(this) : this.map(function(f) {
          return ce(f, r, c);
        });
      }), A2.prototype.reject = function(r) {
        return this.filter(Qi(i2(r)));
      }, A2.prototype.slice = function(r, c) {
        r = q2(r);
        var f = this;
        return f.__filtered__ && (r > 0 || c < 0) ? new A2(f) : (r < 0 ? f = f.takeRight(-r) : r && (f = f.drop(r)), c !== n && (c = q2(c), f = c < 0 ? f.dropRight(-c) : f.take(c - r)), f);
      }, A2.prototype.takeRightWhile = function(r) {
        return this.reverse().takeWhile(r).reverse();
      }, A2.prototype.toArray = function() {
        return this.take(A1);
      }, le(A2.prototype, function(r, c) {
        var f = /^(?:filter|find|map|reject)|While$/.test(c), y = /^(?:head|last)$/.test(c), L = A[y ? "take" + (c == "last" ? "Right" : "") : c], I = y || /^find/.test(c);
        L && (A.prototype[c] = function() {
          var U = this.__wrapped__, Y = y ? [1] : arguments, l1 = U instanceof A2, _1 = Y[0], q1 = l1 || p2(U), x1 = function(T2) {
            var B2 = L.apply(A, xt([T2], Y));
            return y && P1 ? B2[0] : B2;
          };
          q1 && f && typeof _1 == "function" && _1.length != 1 && (l1 = q1 = !1);
          var P1 = this.__chain__, W1 = !!this.__actions__.length, l2 = I && !P1, b2 = l1 && !W1;
          if (!I && q1) {
            U = b2 ? U : new A2(this);
            var r2 = r.apply(U, Y);
            return r2.__actions__.push({ func: Xi, args: [x1], thisArg: n }), new Ke(r2, P1);
          }
          return l2 && b2 ? r.apply(this, Y) : (r2 = this.thru(x1), l2 ? y ? r2.value()[0] : r2.value() : r2);
        });
      }), qe(["pop", "push", "shift", "sort", "splice", "unshift"], function(r) {
        var c = Tt[r], f = /^(?:push|sort|unshift)$/.test(r) ? "tap" : "thru", y = /^(?:pop|shift)$/.test(r);
        A.prototype[r] = function() {
          var L = arguments;
          if (y && !this.__chain__) {
            var I = this.value();
            return c.apply(p2(I) ? I : [], L);
          }
          return this[f](function(U) {
            return c.apply(p2(U) ? U : [], L);
          });
        };
      }), le(A2.prototype, function(r, c) {
        var f = A[c];
        if (f) {
          var y = f.name + "";
          x2.call(C5, y) || (C5[y] = []), C5[y].push({ name: c, func: f });
        }
      }), C5[Di(n, z).name] = [{
        name: "wrapper",
        func: n
      }], A2.prototype.clone = Nr, A2.prototype.reverse = L9, A2.prototype.value = K8, A.prototype.at = uv, A.prototype.chain = dv, A.prototype.commit = fv, A.prototype.next = vv, A.prototype.plant = mv, A.prototype.reverse = gv, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = yv, A.prototype.first = A.prototype.head, i5 && (A.prototype[i5] = pv), A;
    }, l4 = w0();
    qt ? ((qt.exports = l4)._ = l4, P4._ = l4) : D3._ = l4;
  }).call(ys);
})(Ih, Ih.exports);
var N1 = Ih.exports;
function k6(t, e, n) {
  let i = t;
  return e && (i += "-" + e), n && (i += n), i;
}
const C8 = () => {
  let t = !1;
  return function(e) {
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
      e
    ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      e.substr(0, 4)
    )) && (t = !0);
  }(navigator.userAgent || navigator.vendor || window.opera), t;
}, pL = (t) => typeof t == "string" && (t.startsWith("http") || t.startsWith("www.") || t.startsWith("tel:") || t.startsWith("mailto:") || t.startsWith("javascript:void(0)")), n9 = (t) => !N1.isNil(t) && t.includes("self") ? "_self" : "_blank", M_ = () => {
  var t, e;
  const n = t9();
  return ((e = (t = n == null ? void 0 : n.appContext.config.globalProperties) == null ? void 0 : t.$language) == null ? void 0 : e.list) ?? [];
}, i9 = () => new URL(window.location.href).searchParams.get("lng") ?? "en", YF = () => {
  const t = i9();
  return N1.find(M_(), (e) => e.code === t);
}, mL = () => N1.filter(M_(), (t) => (t == null ? void 0 : t.extraEu) === !1), XF = () => {
  const t = N1.map(mL(), (e) => e.code);
  return N1.filter(M_(), (e) => t.includes(e.code) === !1);
}, KF = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, ZF = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24.15 11.1 22.02 9 6 25.02 22.05 41.1l2.13-2.1-12.423-12.45H42v-3H11.7z"
}, null, -1), JF = [
  ZF
];
function QF(t, e) {
  return T(), N("svg", KF, [...JF]);
}
const eT = { render: QF }, tT = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, nT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.5 3.06h-3v42h3zm-9 12h-3v18h3zm-12-6h3v30h-3zm36 23.97h3v-18h-3zm-6 6h-3v-30h3z"
}, null, -1), iT = [
  nT
];
function sT(t, e) {
  return T(), N("svg", tT, [...iT]);
}
const lT = { render: sT }, rT = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, aT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33 18H15v3h18zm-18-6h18v3H15z"
}, null, -1), oT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 45H12.45C8.88 45 6 42.3 6 39V9c0-3.3 2.88-6 6.45-6h26.4C40.59 3 42 4.35 42 6v30H12.45C10.56 36 9 37.35 9 39s1.56 3 3.45 3H42zM12.45 6C10.56 6 9 7.35 9 9v24.93c.99-.6 2.19-.93 3.45-.93H39V6z",
  "clip-rule": "evenodd"
}, null, -1), cT = [
  aT,
  oT
];
function hT(t, e) {
  return T(), N("svg", rT, [...cT]);
}
const uT = { render: hT }, dT = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, fT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 7.83h-.3L30 10.17 18.3 7.83h-.54l-12 2.4c-.69.15-1.2.75-1.2 1.47v26.94c0 .84.69 1.5 1.5 1.5h.3l11.7-2.34 11.7 2.34h.54l12-2.4c.69-.15 1.2-.75 1.2-1.47V9.33c0-.84-.69-1.5-1.5-1.5M7.5 12.96l9-1.8v23.88l-9 1.8zm12-1.8 9 1.8v23.88l-9-1.8zm21 23.88-9 1.8V12.96l9-1.8z"
}, null, -1), vT = [
  fT
];
function pT(t, e) {
  return T(), N("svg", dT, [...vT]);
}
const mT = { render: pT }, gT = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, yT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M31.5 18c0 4.14-3.36 7.5-7.5 7.5s-7.5-3.36-7.5-7.5 3.36-7.5 7.5-7.5 7.5 3.36 7.5 7.5m-3 0c0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5",
  "clip-rule": "evenodd"
}, null, -1), _T = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M15 16.53H9v3h6zm18 0h6v3h-6z"
}, null, -1), qT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 30V6h42v24zM6 9v18h36V9z",
  "clip-rule": "evenodd"
}, null, -1), wT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M6 32.97v3h36v-3zM9 42v-3h30v3z"
}, null, -1), zT = [
  yT,
  _T,
  qT,
  wT
];
function MT(t, e) {
  return T(), N("svg", gT, [...zT]);
}
const bT = { render: MT }, LT = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, xT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18 3h-3v3H9C7.35 6 6 7.35 6 9v30c0 1.65 1.35 3 3 3h30c1.65 0 3-1.35 3-3V9c0-1.65-1.35-3-3-3h-6V3h-3v3H18zm12 6H18v3h-3V9H9v7.5h30V9h-6v3h-3zm9 10.5H9V39h30z",
  "clip-rule": "evenodd"
}, null, -1), ST = [
  xT
];
function CT(t, e) {
  return T(), N("svg", LT, [...ST]);
}
const kT = { render: CT }, ET = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, AT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18 16.5c-4.98 0-9 4.02-9 9s4.02 9 9 9 9-4.02 9-9-4.02-9-9-9m0 3c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6",
  "clip-rule": "evenodd"
}, null, -1), FT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M30 13.5h9v3h-9z"
}, null, -1), TT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 7.5H6c-1.65 0-3 1.35-3 3v27c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3v-27c0-1.65-1.35-3-3-3m0 3v27H6v-27z",
  "clip-rule": "evenodd"
}, null, -1), IT = [
  AT,
  FT,
  TT
];
function OT(t, e) {
  return T(), N("svg", ET, [...IT]);
}
const NT = { render: OT }, PT = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, BT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M23.55 30.75a6.56 6.56 0 0 0 4.68 1.95c1.77 0 3.42-.69 4.68-1.95l10.56-10.56a6.627 6.627 0 0 0 0-9.36l-2.1-2.1a6.627 6.627 0 0 0-9.36 0l-5.28 5.28 2.97 2.97 5.28-5.28c.93-.93 2.49-.93 3.42 0l2.1 2.1c.93.93.93 2.49 0 3.42L29.94 27.78c-.93.9-2.52.9-3.42 0l-3.15-3.15-2.97 2.97z"
}, null, -1), VT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M6.6 39.27c1.29 1.29 3 1.92 4.68 1.92 1.71 0 3.39-.63 4.68-1.92l5.31-5.31-2.97-2.97-5.31 5.31c-.96.96-2.49.93-3.42 0l-2.1-2.1c-.93-.96-.93-2.49 0-3.42l10.56-10.56c.96-.96 2.49-.93 3.42 0l3.18 3.18 2.97-2.97-3.18-3.18a6.627 6.627 0 0 0-9.36 0L4.5 27.81a6.627 6.627 0 0 0 0 9.36z"
}, null, -1), RT = [
  BT,
  VT
];
function HT(t, e) {
  return T(), N("svg", PT, [...RT]);
}
const DT = { render: HT }, $T = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, UT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.58 3 24 3m-3.27 30.09-8.31-8.25 2.13-2.13 6.18 6.15 12.78-12.9 2.13 2.1-14.88 15.03z",
  "clip-rule": "evenodd"
}, null, -1), jT = [
  UT
];
function GT(t, e) {
  return T(), N("svg", $T, [...jT]);
}
const WT = { render: GT }, YT = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, XT = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M19.53 36.69 6 23.19l2.13-2.13 11.4 11.4L39.99 12l2.13 2.13z"
}, null, -1), KT = [
  XT
];
function ZT(t, e) {
  return T(), N("svg", YT, [...KT]);
}
const JT = { render: ZT }, QT = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, eI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m6.72 29.7-8.22-8.07V12h3v11.37l7.32 7.17-2.1 2.13z",
  "clip-rule": "evenodd"
}, null, -1), tI = [
  eI
];
function nI(t, e) {
  return T(), N("svg", QT, [...tI]);
}
const iI = { render: nI }, sI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, lI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m22.5 24.63 8.22 8.07 2.1-2.16-7.32-7.17V12h-3z"
}, null, -1), rI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 24C3 12.39 12.39 3 24 3s21 9.39 21 21-9.39 21-21 21S3 35.61 3 24m39 0c0-9.93-8.07-18-18-18S6 14.07 6 24s8.07 18 18 18 18-8.07 18-18",
  "clip-rule": "evenodd"
}, null, -1), aI = [
  lI,
  rI
];
function oI(t, e) {
  return T(), N("svg", sI, [...aI]);
}
const cI = { render: oI }, hI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, uI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21m-13.59-9.54 2.13 2.13L26.1 24l7.44 7.41-2.13 2.13L24 26.13l-7.44 7.41-2.1-2.13L21.87 24l-7.41-7.41 2.1-2.13L24 21.87z",
  "clip-rule": "evenodd"
}, null, -1), dI = [
  uI
];
function fI(t, e) {
  return T(), N("svg", hI, [...dI]);
}
const vI = { render: fI }, pI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, mI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m21.868 24.021-7.425 7.425 2.122 2.121 7.424-7.424 7.425 7.424 2.121-2.121-7.424-7.425 7.424-7.424-2.121-2.122-7.425 7.425-7.424-7.425-2.122 2.122z"
}, null, -1), gI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.42 3 3 12.42 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m0 3c9.93 0 18 8.07 18 18s-8.07 18-18 18S6 33.93 6 24 14.07 6 24 6",
  "clip-rule": "evenodd"
}, null, -1), yI = [
  mI,
  gI
];
function _I(t, e) {
  return T(), N("svg", pI, [...yI]);
}
const qI = { render: _I }, wI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, zI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 8.01 39.99 6 24 21.99 8.01 6 6 8.01 21.99 24 6 39.99 8.01 42 24 26.01 39.99 42 42 39.99 26.01 24z"
}, null, -1), MI = [
  zI
];
function bI(t, e) {
  return T(), N("svg", wI, [...MI]);
}
const LI = { render: bI }, xI = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 48 48"
}, SI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M39 10.4H18c-1.7 0-3 1.4-3 3.1v28.3c0 1.7 1.3 3.1 3 3.1h10.8c.8 0 1.6-.3 2.1-.9l10.2-10.7c.6-.6.9-1.4.9-2.2V13.5c0-1.7-1.3-3.1-3-3.1m-9 30.2V33h7.3zM18.1 42s-.1 0-.1-.2V13.4h21V30h-9c-1.7 0-3 1.3-3 3v9",
  "clip-rule": "evenodd"
}, null, -1), CI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M7.4 33.1 5.9 9.8c-.1-1.2.3-2.4 1.1-3.3S8.9 5.1 10.1 5l19.8-1.9.3 3L10.3 8c-.4 0-.8.2-1.1.5-.2.3-.3.7-.3 1.1l1.5 23.3z",
  "clip-rule": "evenodd"
}, null, -1), kI = [
  SI,
  CI
];
function EI(t, e) {
  return T(), N("svg", xI, [...kI]);
}
const AI = { render: EI }, FI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, TI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m45 30.12-2.73 2.82-18.24-18.36L5.73 33 3 30.18 24.03 9z",
  "clip-rule": "evenodd"
}, null, -1), II = [
  TI
];
function OI(t, e) {
  return T(), N("svg", FI, [...II]);
}
const NI = { render: OI }, PI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, BI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M40.5 18c0-1.8-.81-3.39-2.07-4.5 1.26-1.11 2.07-2.7 2.07-4.5 0-3.3-2.7-6-6-6h-21c-3.3 0-6 2.7-6 6 0 1.8.81 3.39 2.07 4.5C8.31 14.61 7.5 16.2 7.5 18s.81 3.39 2.07 4.5C8.31 23.61 7.5 25.2 7.5 27c0 3.3 2.7 6 6 6h9v2.82a4.9 4.9 0 0 0-3.21 3.21H9v3h10.29c.63 2.01 2.49 3.48 4.71 3.48s4.08-1.47 4.71-3.48H39v-3H28.71a4.9 4.9 0 0 0-3.21-3.21V33h9c3.3 0 6-2.7 6-6 0-1.8-.81-3.39-2.07-4.5 1.26-1.11 2.07-2.7 2.07-4.5M24 42.48c-1.08 0-1.98-.87-1.98-1.98s.87-1.98 1.98-1.98 1.98.87 1.98 1.98-.87 1.98-1.98 1.98M10.5 8.97c0-1.65 1.35-3 3-3h21c1.65 0 3 1.35 3 3s-1.35 3-3 3h-21c-1.65 0-3-1.35-3-3m27 18c0 1.65-1.35 3-3 3h-21c-1.65 0-3-1.35-3-3s1.32-2.97 2.97-3h21.06c1.65 0 2.97 1.35 2.97 3m-3-6H13.47c-1.65 0-2.97-1.35-2.97-3s1.35-3 3-3h21c1.65 0 3 1.35 3 3s-1.32 2.97-2.97 3z",
  "clip-rule": "evenodd"
}, null, -1), VI = [
  BI
];
function RI(t, e) {
  return T(), N("svg", PI, [...VI]);
}
const HI = { render: RI }, DI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, $I = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M31.77 13.5H18.63L14.28 18H6v-3h7.02l4.35-4.5h14.4c.66-2.16 2.64-3.75 5.01-3.75 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.37 0-4.35-1.59-5.01-3.75m7.26-1.5c0-1.23-1.02-2.25-2.25-2.25s-2.25 1.02-2.25 2.25 1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25m-7.26 22.5c.66-2.16 2.64-3.75 5.01-3.75 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.37 0-4.35-1.59-5.01-3.75H20.04l-2.82-6H6v-3h11.19l2.79-6.03h5.76c.63-2.16 2.64-3.78 5.01-3.78 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.34 0-4.32-1.59-4.98-3.72h-3.84l-2.1 4.56 2.1 4.47zm1.29-10.59c0-1.23-1.02-2.25-2.25-2.25s-2.25 1.02-2.25 2.25 1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25M34.53 36c0 1.23 1.02 2.25 2.25 2.25s2.25-1.02 2.25-2.25-1.02-2.25-2.25-2.25-2.25 1.02-2.25 2.25",
  "clip-rule": "evenodd"
}, null, -1), UI = [
  $I
];
function jI(t, e) {
  return T(), N("svg", DI, [...UI]);
}
const GI = { render: jI }, WI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, YI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 13.5H12v3h12zm6 6H12v3h18z"
}, null, -1), XI = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M37.5 4.74v25.29h6v7.47c0 3.3-2.91 6-6.51 6H12c-4.14 0-7.5-3.36-7.5-7.5V4.74zM12 40.5c2.58 0 5.16-1.38 5.16-4.5v-5.97H34.5V7.74h-27V36c0 2.49 1.92 4.5 4.5 4.5m24.99 0c1.95 0 3.51-1.35 3.51-3v-4.47H20.16V36c0 1.74-.54 3.27-1.5 4.5z",
  "clip-rule": "evenodd"
}, null, -1), KI = [
  YI,
  XI
];
function ZI(t, e) {
  return T(), N("svg", WI, [...KI]);
}
const JI = { render: ZI }, QI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, eO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m25.47 30.24 12.45-12.42 2.13 2.13L23.97 36 7.92 19.98l2.13-2.13L22.47 30.3V3h3zM39 42v-6h3v6c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3v-6h3v6z"
}, null, -1), tO = [
  eO
];
function nO(t, e) {
  return T(), N("svg", QI, [...tO]);
}
const iO = { render: nO }, sO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, lO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m39.54 6.81 4.53 4.53c.51.54.81 1.26.81 1.98s-.3 1.44-.81 1.95L25.98 33.36c-.33.33-.69.57-1.11.69l-7.47 1.8c-.15.09-.3.09-.48.09-.48 0-.99-.18-1.38-.57-.51-.51-.69-1.29-.48-1.98l1.74-7.26c.15-.51.39-.93.72-1.23L35.61 6.81a2.79 2.79 0 0 1 3.93 0M18.36 32.58l5.73-1.38 12.45-12.54-4.26-4.26-12.63 12.63zm19.2-23.49-3.18 3.18 4.26 4.26v.03l3.18-3.21z",
  "clip-rule": "evenodd"
}, null, -1), rO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M9 41.94h30v-15h3v15c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3v-30c0-1.65 1.35-3 3-3h15.03v3H9z"
}, null, -1), aO = [
  lO,
  rO
];
function oO(t, e) {
  return T(), N("svg", sO, [...aO]);
}
const cO = { render: oO }, hO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, uO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42.18 9H5.88A2.88 2.88 0 0 0 3 11.88v24.27a2.88 2.88 0 0 0 2.88 2.88h36.3a2.88 2.88 0 0 0 2.88-2.88V11.88A2.88 2.88 0 0 0 42.18 9m-.12 3-.12-.15h.12zm-2.07-.12L23.97 27.03 8.19 12l31.77-.12zM6.03 12l-.15.15V12zm0 24.12-.12-22.2L21.9 29.19c.57.54 1.32.84 2.07.84s1.47-.27 2.07-.81l16.05-15.15v21.96l-36.03.12z",
  "clip-rule": "evenodd"
}, null, -1), dO = [
  uO
];
function fO(t, e) {
  return T(), N("svg", hO, [...dO]);
}
const vO = { render: fO }, pO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, mO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M38.85 31.29 27.6 24.81c-.6.54-1.32.96-2.1 1.2v15.96H33v3H15v-3h7.5V26.01c-.81-.24-1.5-.66-2.1-1.2L9.15 31.29l-1.5-2.61L18.9 22.2c-.09-.39-.15-.78-.15-1.2 0-2.37 1.59-4.35 3.75-5.01V3h3v12.99c2.16.66 3.75 2.64 3.75 5.01 0 .42-.06.81-.15 1.2l11.25 6.48zM24 18.75c-1.23 0-2.25 1.02-2.25 2.25s1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25-1.02-2.25-2.25-2.25",
  "clip-rule": "evenodd"
}, null, -1), gO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M17.67 10.23c-5.07 1.29-8.16 6.45-6.87 11.52l-2.91.72C6.21 15.81 10.29 9 16.95 7.32z"
}, null, -1), yO = [
  mO,
  gO
];
function _O(t, e) {
  return T(), N("svg", pO, [...yO]);
}
const qO = { render: _O }, wO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, zO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m31.363 14.467-7.425 7.424-7.425-7.424-2.12 2.12 7.424 7.426-7.425 7.424 2.121 2.121 7.425-7.424 7.425 7.425 2.121-2.122-7.425-7.425 7.425-7.424z"
}, null, -1), MO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M14.13 6h19.65c.45 0 .84.24 1.05.6l9.81 16.8c.21.36.21.84 0 1.2l-9.81 16.8c-.24.36-.63.6-1.05.6H14.16c-.45 0-.84-.24-1.05-.6L3.3 24.6c-.21-.36-.21-.84 0-1.2l9.78-16.8c.24-.36.63-.6 1.05-.6m27.36 18L32.73 9H15.18L6.42 24l8.76 15h17.55z",
  "clip-rule": "evenodd"
}, null, -1), bO = [
  zO,
  MO
];
function LO(t, e) {
  return T(), N("svg", wO, [...bO]);
}
const xO = { render: LO }, SO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, CO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M44.67 23.4 34.86 6.6c-.21-.36-.6-.6-1.05-.6H14.19c-.42 0-.81.24-1.05.6L3.39 23.4c-.21.36-.21.84 0 1.2l9.81 16.8c.21.36.6.6 1.05.6h19.62c.42 0 .81-.24 1.05-.6l9.81-16.8c.21-.36.21-.84 0-1.2zm-11.16 8.04-2.13 2.13-7.41-7.41-7.41 7.41-2.13-2.13 7.41-7.41-7.41-7.41 2.13-2.13 7.41 7.41 7.41-7.41 2.13 2.13-7.41 7.41z",
  "clip-rule": "evenodd"
}, null, -1), kO = [
  CO
];
function EO(t, e) {
  return T(), N("svg", SO, [...kO]);
}
const AO = { render: EO }, FO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, TO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18.72 30.24c1.65 1.71 3.63 2.55 6 2.55l.03.06c2.58 0 4.74-1.05 6.6-3.21l.78-.93v4.14l-.15.12c-1.95 1.74-4.41 2.61-7.26 2.61-3.15 0-5.82-1.11-7.95-3.33-1.23-1.26-2.1-2.79-2.64-4.53h-3.69l1.17-2.76h2.01c-.06-.3-.06-.6-.06-.93 0-.139.016-.27.031-.397.015-.12.029-.236.029-.353h-3.18l1.17-2.76h2.49c.54-1.83 1.44-3.39 2.7-4.71 2.13-2.22 4.8-3.33 7.95-3.33s5.85 1.14 8.04 3.42l.21.21-1.17 2.79-.48-.54c-1.89-2.13-4.05-3.15-6.6-3.15-2.37 0-4.35.84-6 2.55-.78.81-1.35 1.71-1.77 2.73h14.1l-1.11 2.76H16.32c-.06.24-.06.48-.06.75 0 .3.03.63.06.93h13.26l-1.17 2.76h-11.4c.42.96.99 1.8 1.71 2.55"
}, null, -1), IO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3.06 24c0-11.61 9.39-21 21-21s21 9.39 21 21-9.39 21-21 21-21-9.39-21-21m39 0c0-9.93-8.07-18-18-18s-18 8.07-18 18 8.07 18 18 18 18-8.07 18-18",
  "clip-rule": "evenodd"
}, null, -1), OO = [
  TO,
  IO
];
function NO(t, e) {
  return T(), N("svg", FO, [...OO]);
}
const PO = { render: NO }, BO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, VO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18 3h-3v3H9C7.35 6 6 7.35 6 9v30c0 1.65 1.35 3 3 3h12v-3H9V9h6v3h3V9h12v3h3V9h6v12h3V9c0-1.65-1.35-3-3-3h-6V3h-3v3H18z"
}, null, -1), RO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M36.03 24h-3v9.03H24v3h9.03v9.03h3v-9.03h9.03v-3h-9.03z"
}, null, -1), HO = [
  VO,
  RO
];
function DO(t, e) {
  return T(), N("svg", BO, [...HO]);
}
const $O = { render: DO }, UO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, jO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M39 6h-6V3h-3v3H18V3h-3v3H9C7.35 6 6 7.35 6 9v30c0 1.65 1.35 3 3 3h9v-3H9V9h6v3h3V9h12v3h3V9h6v9h3V9c0-1.65-1.35-3-3-3"
}, null, -1), GO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33 21v3h6.81l-7.86 7.95 2.1 2.1L42 26.07V33h3V21z"
}, null, -1), WO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 42h15v-6h3v6c0 1.65-1.35 3-3 3H24c-1.65 0-3-1.35-3-3V27c0-1.65 1.35-3 3-3h6v3h-6z"
}, null, -1), YO = [
  jO,
  GO,
  WO
];
function XO(t, e) {
  return T(), N("svg", UO, [...YO]);
}
const KO = { render: XO }, ZO = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, JO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M30 6V3h15v15h-3V8.13L29.13 21 27 18.87 39.87 6z"
}, null, -1), QO = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M39 42V24h3v18c0 1.65-1.35 3-3 3H6c-1.65 0-3-1.35-3-3V9c0-1.65 1.35-3 3-3h18v3H6v33z"
}, null, -1), eN = [
  JO,
  QO
];
function tN(t, e) {
  return T(), N("svg", ZO, [...eN]);
}
const nN = { render: tN }, iN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, sN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M28.65 12.39c-1.26-1.05-3.06-1.56-5.31-1.56-1.68 0-3.6.48-5.7 1.44l-.27.12.09.27.84 2.13.12.3.3-.15c1.8-.84 3.3-1.26 4.44-1.26q1.89 0 2.97.9c.72.6 1.05 1.44 1.05 2.58 0 .69-.18 1.35-.48 1.95-.33.6-.87 1.23-1.59 1.83l-2.31 2.04c-1.35 1.2-2.04 2.88-2.04 4.98v1.29h3v-1.26c0-.63.06-1.17.21-1.56.15-.42.33-.75.57-1.05s.93-.9 2.04-1.83c2.67-2.22 4.02-4.41 4.02-6.51s-.66-3.6-1.92-4.65zm-6.12 19.98q-.9 0-1.53.63c-.42.42-.63.93-.63 1.56q0 .945.63 1.62c.42.45.93.69 1.53.69s1.14-.24 1.56-.69q.63-.675.63-1.62c0-.63-.21-1.14-.63-1.56s-.93-.63-1.56-.63"
}, null, -1), lN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M6 3h36c1.65 0 3 1.35 3 3v36c0 1.65-1.35 3-3 3H6c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3m36 39V6H6v36z",
  "clip-rule": "evenodd"
}, null, -1), rN = [
  sN,
  lN
];
function aN(t, e) {
  return T(), N("svg", iN, [...rN]);
}
const oN = { render: aN }, cN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, hN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.05 35.43q.405.18.81.18c.39 0 .72-.12.93-.3l11.25-6.87H34.5c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3H6C4.35 3 3 4.35 3 6v19.47c0 1.65 1.35 3 3 3h3.03v5.34c0 .69.39 1.32 1.02 1.62m.27-2.73s-.21.09-.27.18zM6 25.44V6h28.53v19.44h-12.3l-10.2 6.21v-6.21z",
  "clip-rule": "evenodd"
}, null, -1), uN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33.03 42.66c.33.27.72.42 1.14.42l-.03-.03c.27 0 .54-.06.78-.18.63-.3 1.02-.93 1.02-1.62v-5.34h6.03c1.65 0 3-1.35 3-3V11.97c0-1.65-1.35-3-3-3v23.97h-9.03V39l-9-6.06h-4.59v3h3.69zm1.68-2.46.12.09s-.06-.06-.12-.09",
  "clip-rule": "evenodd"
}, null, -1), dN = [
  hN,
  uN
];
function fN(t, e) {
  return T(), N("svg", cN, [...dN]);
}
const vN = { render: fN }, pN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, mN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M36 3H12c-1.65 0-3 1.35-3 3v36c0 1.65 1.35 3 3 3h13.77c.81 0 1.56-.33 2.13-.87L38.13 33.9c.57-.57.87-1.32.87-2.13V6c0-1.65-1.35-3-3-3m-9 37.77V33h7.77zM36 30h-9c-1.65 0-3 1.35-3 3v9H12V6h24z",
  "clip-rule": "evenodd"
}, null, -1), gN = [
  mN
];
function yN(t, e) {
  return T(), N("svg", pN, [...gN]);
}
const _N = { render: yN }, qN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, wN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33 11.7H15v2.1h18zm-18 4.98h18v2.1H15z"
}, null, -1), zN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M36 3H12c-1.65 0-3 1.35-3 3v36c0 1.65 1.35 3 3 3h13.77c.81 0 1.56-.33 2.13-.87L38.13 33.9c.57-.57.87-1.32.87-2.13V6c0-1.65-1.35-3-3-3M11.1 42V6c0-.51.39-.9.9-.9h24c.51 0 .9.39.9.9v25.14h-8.31c-1.98 0-3.6 1.62-3.6 3.63v8.13H12.03c-.51 0-.9-.39-.9-.9zm15.99-.06v-7.17c0-.84.66-1.53 1.5-1.53h7.2z",
  "clip-rule": "evenodd"
}, null, -1), MN = [
  wN,
  zN
];
function bN(t, e) {
  return T(), N("svg", qN, [...MN]);
}
const LN = { render: bN }, xN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, SN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 15H25.47l-4.38-8.16c-.27-.51-.84-.84-1.44-.84H4.59C3.69 6 3 6.66 3 7.5V39c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V18c0-1.65-1.35-3-3-3M6 9h12.84l3.21 6H6zm36 30H6V18h36z",
  "clip-rule": "evenodd"
}, null, -1), CN = [
  SN
];
function kN(t, e) {
  return T(), N("svg", xN, [...CN]);
}
const EN = { render: kN }, AN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, FN = /* @__PURE__ */ C("path", { d: "m8.22 6 10.86 10.95-2.16 2.1L6 8.01V18H3V3h15v3zM30 6V3h15v15h-3V8.01L31.05 19.05l-2.1-2.1L39.78 6zM16.95 28.95 6 39.96V30H3v14.97h15v-3H8.22l10.83-10.92zM42 39.96V30h3v14.97H30v-3h9.78L28.95 31.05l2.1-2.1z" }, null, -1), TN = [
  FN
];
function IN(t, e) {
  return T(), N("svg", AN, [...TN]);
}
const ON = { render: IN }, NN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, PN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M45 24c0-11.61-9.39-21-21-21S3 12.39 3 24c0 10.98 8.43 19.98 19.17 20.91a18 18 0 0 0 3.6 0c10.77-.9 19.2-9.93 19.2-20.91zM24.6 41.97c-.21 0-.39.03-.6.03s-.42 0-.63-.03C21.45 40.14 18.3 35.61 18 25.5h12c-.3 10.11-3.45 14.64-5.37 16.47zM41.91 22.5h-8.94c-.21-7.77-1.98-12.69-3.9-15.75C36.06 8.82 41.28 15 41.91 22.5M24.69 6.03c1.89 1.8 5.01 6.33 5.31 16.47H18c.27-10.11 3.42-14.64 5.28-16.47.24 0 .48-.03.72-.03s.45 0 .69.03m-5.79.72c-1.92 3.06-3.69 7.98-3.9 15.75H6.09C6.72 15 11.94 8.82 18.9 6.75M6.09 25.5H15c.21 7.83 2.1 12.78 3.99 15.78-7.02-2.04-12.3-8.25-12.93-15.78zm22.89 15.78c1.92-3 3.78-7.95 4.02-15.78h8.94c-.63 7.53-5.91 13.74-12.96 15.78"
}, null, -1), BN = [
  PN
];
function VN(t, e) {
  return T(), N("svg", NN, [...BN]);
}
const RN = { render: VN }, HN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, DN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.35 41.97H39v-3H10.35c-.78 0-1.38-.75-1.38-1.65V9h-3v28.32c0 2.58 1.98 4.65 4.38 4.65"
}, null, -1), $N = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 12V9h15v15h-3v-9.87L24.33 25.77l-8.28 8.28-2.1-2.1L33.87 12z"
}, null, -1), UN = [
  DN,
  $N
];
function jN(t, e) {
  return T(), N("svg", HN, [...UN]);
}
const GN = { render: jN }, WN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, YN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 12H6v3h36zm0 21H6v3h36zM6 22.5h36v3H6z"
}, null, -1), XN = [
  YN
];
function KN(t, e) {
  return T(), N("svg", WN, [...XN]);
}
const ZN = { render: KN }, JN = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, QN = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M4.543 32.97 3.013 9.66c-.09-1.2.3-2.34 1.08-3.27.78-.9 1.89-1.44 3.09-1.53L26.983 3l.27 3-19.83 1.86c-.87.06-1.5.78-1.44 1.59l1.56 23.34-3 .21z"
}, null, -1), eP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.573 26.85c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5m0-6.45c1.08 0 1.95.87 1.95 1.95s-.87 1.95-1.95 1.95-1.95-.87-1.95-1.95.87-1.95 1.95-1.95",
  "clip-rule": "evenodd"
}, null, -1), tP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M15.103 11.88h27c1.65 0 3 1.35 3 3v27c0 1.65-1.35 3-3 3h-27c-1.65 0-3-1.35-3-3v-27c0-1.65 1.35-3 3-3m0 30h27v-8.4l-6.06-6.54-8.58 8.25c-1.05 1.05-2.82 1.11-3.96.06L21.043 33l-5.94 6.45zm26.97-12.872.03.032h-.03zm-3.84-4.138 3.84 4.138V14.85h-27v20.22l3.93-4.17c1.11-1.17 2.88-1.2 4.05-.15l2.46 2.25 8.61-8.22c.51-.51 1.2-.84 2.04-.81.78.03 1.53.33 2.07.9",
  "clip-rule": "evenodd"
}, null, -1), nP = [
  QN,
  eP,
  tP
];
function iP(t, e) {
  return T(), N("svg", JN, [...nP]);
}
const sP = { render: iP }, lP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, rP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 3h12v36H3zm3 33h6V6H6zM18 9h12v30H18zm3 27h6V12h-6zm12-21v24h12V15zm9 21h-6V18h6z",
  "clip-rule": "evenodd"
}, null, -1), aP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 42h42v3H3z"
}, null, -1), oP = [
  rP,
  aP
];
function cP(t, e) {
  return T(), N("svg", lP, [...oP]);
}
const hP = { render: cP }, uP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, dP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.5 33V21h-6v3h3v9H18v3h12v-3zm-2.76-20.61c.39-.27.81-.39 1.26-.39.6 0 1.17.24 1.59.66s.66.99.66 1.59a2.31 2.31 0 0 1-1.41 2.1c-.39.15-.84.21-1.29.12-.42-.09-.84-.33-1.14-.63-.33-.3-.54-.69-.63-1.14-.09-.42-.06-.87.12-1.29s.48-.78.84-1.02"
}, null, -1), fP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 3H6C4.35 3 3 4.35 3 6v36c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3m0 39H6V6h36z",
  "clip-rule": "evenodd"
}, null, -1), vP = [
  dP,
  fP
];
function pP(t, e) {
  return T(), N("svg", uP, [...vP]);
}
const mP = { render: pP }, gP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, yP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24.03 3c-11.61 0-21 9.39-21 21s9.39 21 21 21 21-9.39 21-21-9.42-21-21-21m-2.07 10.38a2.31 2.31 0 0 1 2.1-1.41c.6 0 1.17.24 1.59.66s.66.99.66 1.59c0 .45-.12.87-.39 1.26-.24.36-.6.66-1.02.84s-.87.21-1.29.12c-.45-.09-.84-.3-1.14-.63-.3-.3-.54-.72-.63-1.14s-.03-.9.12-1.29M30.03 36h-12v-3h4.5v-9h-3v-3h6v12h4.5z",
  "clip-rule": "evenodd"
}, null, -1), _P = [
  yP
];
function qP(t, e) {
  return T(), N("svg", gP, [..._P]);
}
const wP = { render: qP }, zP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, MP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 3H6C4.35 3 3 4.35 3 6v36c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3M21.93 13.38a2.31 2.31 0 0 1 2.1-1.41c.6 0 1.17.24 1.59.66s.66.99.66 1.59c0 .45-.12.87-.39 1.26-.24.36-.6.66-1.02.84s-.87.21-1.29.12c-.45-.09-.84-.3-1.14-.63-.3-.3-.54-.72-.63-1.14s-.03-.9.12-1.29M30 36H18v-3h4.5v-9h-3v-3h6v12H30z",
  "clip-rule": "evenodd"
}, null, -1), bP = [
  MP
];
function LP(t, e) {
  return T(), N("svg", zP, [...bP]);
}
const xP = { render: LP }, SP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, CP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42.158 12h-30.24c-1.59 0-2.91 1.35-2.91 3l.06 3.87-5.58 5.4c-.66.69-.66 1.77.06 2.52l5.49 5.34V36c0 1.65 1.29 3 2.91 3h30.21c1.59 0 2.91-1.35 2.91-3V15c0-1.65-1.29-3-2.91-3m-24.12 16.5c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m9 0c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m9 0c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3",
  "clip-rule": "evenodd"
}, null, -1), kP = [
  CP
];
function EP(t, e) {
  return T(), N("svg", SP, [...kP]);
}
const AP = { render: EP }, FP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, TP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M21.038 25.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m6 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6m12-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
}, null, -1), IP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M11.918 12h30.24c1.62 0 2.91 1.35 2.91 3v21c0 1.65-1.32 3-2.91 3h-30.21c-1.62 0-2.91-1.35-2.91-3v-3.87l-5.49-5.34c-.72-.75-.72-1.83-.06-2.52l5.58-5.4-.06-3.87c0-1.65 1.32-3 2.91-3m.12 24h30l.03.06v-21h-30.12l.09 3.87c0 .78-.3 1.5-.81 2.07l-4.68 4.53 4.62 4.47c.57.6.87 1.35.87 2.13z",
  "clip-rule": "evenodd"
}, null, -1), OP = [
  TP,
  IP
];
function NP(t, e) {
  return T(), N("svg", FP, [...OP]);
}
const PP = { render: NP }, BP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, VP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.44 13.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m3.03-1.5H42v3H13.47zm0 21H42v3H13.47zM42 22.5H13.47v3H42zM8.19 26.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m2.25 8.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
}, null, -1), RP = [
  VP
];
function HP(t, e) {
  return T(), N("svg", BP, [...RP]);
}
const DP = { render: HP }, $P = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, UP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m11.415 10.875.015.015v-.03zm0 0L9.3 8.76c-8.4 8.4-8.4 22.08 0 30.48l2.13-2.13c-7.225-7.225-7.23-19.004-.015-26.235m25.155.015 2.13-2.13v.03c8.4 8.4 8.4 22.08 0 30.48l-2.13-2.13c7.23-7.23 7.23-19.02 0-26.25"
}, null, -1), jP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m33.75 14.85-2.13 2.13c3.87 3.87 3.87 10.2 0 14.1l2.13 2.13c5.04-5.04 5.04-13.26 0-18.33zm-12.72 6.18a4.183 4.183 0 0 0 0 5.94c.78.78 1.86 1.23 2.97 1.23s2.19-.45 2.97-1.23a4.183 4.183 0 0 0 0-5.94c-1.59-1.59-4.35-1.59-5.94 0m-6.81-6.18c-5.04 5.04-5.04 13.26 0 18.33l2.13-2.13c-3.87-3.87-3.87-10.2 0-14.1l-2.13-2.13z"
}, null, -1), GP = [
  UP,
  jP
];
function WP(t, e) {
  return T(), N("svg", $P, [...GP]);
}
const YP = { render: WP }, XP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, KP = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M34.17 7.83A16.5 16.5 0 0 0 22.5 3c-4.38 0-8.58 1.74-11.67 4.83A16.5 16.5 0 0 0 6 19.5a16.4 16.4 0 0 0 3.33 9.9s.45.6.51.69L22.5 45l12.66-14.94.51-.66A16.4 16.4 0 0 0 39 19.5c0-4.38-1.74-8.58-4.83-11.67M22.5 24c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6"
}, null, -1), ZP = [
  KP
];
function JP(t, e) {
  return T(), N("svg", XP, [...ZP]);
}
const QP = { render: JP }, eB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, tB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M14.97 19.5c0-4.14 3.36-7.5 7.5-7.5s7.5 3.36 7.5 7.5-3.36 7.5-7.5 7.5-7.5-3.36-7.5-7.5m12 0c0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5",
  "clip-rule": "evenodd"
}, null, -1), nB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.83 7.83C13.92 4.74 18.12 3 22.5 3s8.58 1.74 11.67 4.83S39 15.12 39 19.5a16.4 16.4 0 0 1-3.33 9.9l-.51.66L22.5 45 9.84 30.09c-.06-.09-.51-.69-.51-.69A16.4 16.4 0 0 1 6 19.5c0-4.38 1.74-8.58 4.83-11.67m21.18 2.13A13.4 13.4 0 0 0 22.485 6a13.4 13.4 0 0 0-9.525 3.96A13.4 13.4 0 0 0 9 19.5c-.03 2.88.96 5.76 2.7 8.07l.45.6 10.32 12.18 10.38-12.24c.03-.06.36-.48.36-.48l.06-.06a13.46 13.46 0 0 0 2.7-8.07c0-3.6-1.41-6.99-3.96-9.54",
  "clip-rule": "evenodd"
}, null, -1), iB = [
  tB,
  nB
];
function sB(t, e) {
  return T(), N("svg", eB, [...iB]);
}
const lB = { render: sB }, rB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, aB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M13.47 13.5c0-5.79 4.71-10.5 10.5-10.5s10.5 4.71 10.5 10.5S29.76 24 23.97 24s-10.5-4.71-10.5-10.5m18 0c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5 3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5M6 45h36.03v-5.91c0-6.66-5.07-12.09-11.25-12.09H17.25C11.04 27 6 32.43 6 39.09zm33-3H8.97v-2.91c0-5.01 3.72-9.09 8.25-9.09h13.53c4.56 0 8.25 4.08 8.25 9.09z",
  "clip-rule": "evenodd"
}, null, -1), oB = [
  aB
];
function cB(t, e) {
  return T(), N("svg", rB, [...oB]);
}
const hB = { render: cB }, uB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, dB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M13.47 13.5c0-5.79 4.71-10.5 10.5-10.5s10.5 4.71 10.5 10.5S29.76 24 23.97 24s-10.5-4.71-10.5-10.5m17.4 0a6.901 6.901 0 0 0-13.8 0 6.901 6.901 0 0 0 13.8 0",
  "clip-rule": "evenodd"
}, null, -1), fB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M38.76 45h3.6v-5.91c0-6.84-5.19-12.39-11.55-12.39H17.28c-6.36 0-11.55 5.55-11.55 12.39V45h3.6v-5.91c0-4.83 3.57-8.79 7.95-8.79h13.53c4.38 0 7.95 3.93 7.95 8.79z"
}, null, -1), vB = [
  dB,
  fB
];
function pB(t, e) {
  return T(), N("svg", uB, [...vB]);
}
const mB = { render: pB }, gB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, yB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M23.97 3c-5.79 0-10.5 4.71-10.5 10.5S18.18 24 23.97 24s10.5-4.71 10.5-10.5S29.76 3 23.97 3m0 3.6a6.901 6.901 0 0 1 0 13.8 6.901 6.901 0 0 1 0-13.8",
  "clip-rule": "evenodd"
}, null, -1), _B = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m30.69 47.07-8.97-8.97 2.55-2.55 6.42 6.42 12.03-12.03 2.55 2.55z"
}, null, -1), qB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M5.76 45h3.6v-5.91c0-4.83 3.57-8.79 7.95-8.79h15.81v-3.6H17.31c-6.36 0-11.55 5.55-11.55 12.39z"
}, null, -1), wB = [
  yB,
  _B,
  qB
];
function zB(t, e) {
  return T(), N("svg", gB, [...wB]);
}
const MB = { render: zB }, bB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, LB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M11.97 22.5h24v3h-24z"
}, null, -1), xB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M2.97 24c0-11.58 9.42-21 21-21 11.61 0 21 9.39 21 21s-9.39 21-21 21-21-9.42-21-21m39 0c0-9.93-8.07-18-18-18s-18 8.07-18 18 8.07 18 18 18 18-8.07 18-18",
  "clip-rule": "evenodd"
}, null, -1), SB = [
  LB,
  xB
];
function CB(t, e) {
  return T(), N("svg", bB, [...SB]);
}
const kB = { render: CB }, EB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, AB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 24H6v3h36z"
}, null, -1), FB = [
  AB
];
function TB(t, e) {
  return T(), N("svg", EB, [...FB]);
}
const IB = { render: TB }, OB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, NB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m6.013 9.66 1.56 23.31V33l3-.21-1.56-23.34c-.03-.39.09-.78.36-1.08.24-.3.6-.51 1.05-.51L30.253 6l-.27-3-19.8 1.86c-1.2.09-2.31.63-3.09 1.53-.78.93-1.17 2.07-1.08 3.27"
}, null, -1), PB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18.133 10.26h21c1.65 0 3 1.41 3 3.15v17.55c0 .84-.3 1.62-.87 2.22l-10.23 10.74c-.57.6-1.32.93-2.13.93h-10.77c-1.65 0-3-1.41-3-3.15V13.41c0-1.74 1.35-3.15 3-3.15m12 22.59v7.68l7.32-7.68zm-12 8.85c0 .12.06.15.06.15h8.91v-9c0-1.65 1.35-3 3-3h9V13.41c0-.09-.03-.15-.03-.15h-20.94c.03.03 0 .15 0 .15z",
  "clip-rule": "evenodd"
}, null, -1), BB = [
  NB,
  PB
];
function VB(t, e) {
  return T(), N("svg", OB, [...BB]);
}
const RB = { render: VB }, HB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, DB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M40.5 28.5h-4.89l-8.16-9H30c.81 0 1.5-.66 1.5-1.5V9c0-.84-.69-1.5-1.5-1.5H18c-.84 0-1.5.66-1.5 1.5v9c0 .84.66 1.5 1.5 1.5h2.55l-8.16 9H7.5c-.84 0-1.5.66-1.5 1.5v9c0 .81.66 1.5 1.5 1.5h12c.84 0 1.5-.69 1.5-1.5v-9c0-.84-.66-1.5-1.5-1.5h-3.03L24 20.16l7.53 8.34H28.5c-.84 0-1.5.66-1.5 1.5v9c0 .84.66 1.5 1.5 1.5h12c.84 0 1.5-.66 1.5-1.5v-9c0-.84-.66-1.5-1.5-1.5m-21-12v-6h9v6zm-1.5 15v6H9v-6zm21 6h-9v-6h9z"
}, null, -1), $B = [
  DB
];
function UB(t, e) {
  return T(), N("svg", HB, [...$B]);
}
const jB = { render: UB }, GB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, WB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M27.51 22.5H9.99v3h17.52zm-3.51 6H9.99v3H24z"
}, null, -1), YB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m38.52 3.78 5.88 8.85.03-.03c.39.57.6 1.26.6 1.95v26.97c0 1.95-1.59 3.51-3.51 3.51H6.51C4.56 45.03 3 43.44 3 41.52V14.58c0-.69.21-1.38.6-1.95l5.88-8.85c.33-.48.87-.78 1.47-.78h26.1c.6 0 1.14.3 1.47.78m2.88 9.72L36.39 6H25.5v7.5zM22.5 6H11.61L6.6 13.5h15.9zm18.99 36c.3 0 .51-.24.51-.51V16.5H6v24.99c0 .3.24.51.51.51z",
  "clip-rule": "evenodd"
}, null, -1), XB = [
  WB,
  YB
];
function KB(t, e) {
  return T(), N("svg", GB, [...XB]);
}
const ZB = { render: KB }, JB = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, QB = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m-3 30h-3V15h3zm9 0h-3V15h3z"
}, null, -1), eV = [
  QB
];
function tV(t, e) {
  return T(), N("svg", JB, [...eV]);
}
const nV = { render: tV }, iV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, sV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M21 15h-3v18h3zm6 0h3v18h-3z"
}, null, -1), lV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m0 3c9.93 0 18 8.07 18 18s-8.07 18-18 18S6 33.93 6 24 14.07 6 24 6",
  "clip-rule": "evenodd"
}, null, -1), rV = [
  sV,
  lV
];
function aV(t, e) {
  return T(), N("svg", iV, [...rV]);
}
const oV = { render: aV }, cV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, hV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M15 9h6v30h-6zm12 0h6v30h-6z"
}, null, -1), uV = [
  hV
];
function dV(t, e) {
  return T(), N("svg", cV, [...uV]);
}
const fV = { render: dV }, vV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, pV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21m-9.75-1.2-18.3-9.18v.06c-.9-.45-1.95.21-1.95 1.2v18.33c0 .99 1.05 1.65 1.95 1.2l18.3-9.18c.99-.51.99-1.92 0-2.43",
  "clip-rule": "evenodd"
}, null, -1), mV = [
  pV
];
function gV(t, e) {
  return T(), N("svg", vV, [...mV]);
}
const yV = { render: gV }, _V = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, qV = /* @__PURE__ */ C("path", { d: "m35.25 22.8-18.3-9.18v.06c-.9-.45-1.95.21-1.95 1.2v18.33c0 .99 1.05 1.65 1.95 1.2l18.3-9.18c.99-.51.99-1.92 0-2.43" }, null, -1), wV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 24C3 12.39 12.39 3 24 3s21 9.39 21 21-9.39 21-21 21S3 35.61 3 24m39 0c0-9.93-8.07-18-18-18S6 14.07 6 24s8.07 18 18 18 18-8.07 18-18",
  "clip-rule": "evenodd"
}, null, -1), zV = [
  qV,
  wV
];
function MV(t, e) {
  return T(), N("svg", _V, [...zV]);
}
const bV = { render: MV }, LV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, xV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m41.22 22.68-30-16.5C10.23 5.64 9 6.36 9 7.5v33c0 1.14 1.23 1.86 2.22 1.32l30-16.5c1.02-.57 1.02-2.04 0-2.61z",
  "clip-rule": "evenodd"
}, null, -1), SV = [
  xV
];
function CV(t, e) {
  return T(), N("svg", LV, [...SV]);
}
const kV = { render: CV }, EV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, AV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M23.97 3c-11.58 0-21 9.42-21 21s9.39 21 21 21 21-9.39 21-21-9.39-21-21-21m12 22.5h-10.5V36h-3V25.5h-10.5v-3h10.5V12h3v10.5h10.5z",
  "clip-rule": "evenodd"
}, null, -1), FV = [
  AV
];
function TV(t, e) {
  return T(), N("svg", EV, [...FV]);
}
const IV = { render: TV }, OV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, NV = /* @__PURE__ */ C("path", {
  "fill-rule": "#26324B",
  d: "M25.47 22.5V12h-3v10.5h-10.5v3h10.5V36h3V25.5h10.5v-3z"
}, null, -1), PV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M23.97 3c-11.58 0-21 9.42-21 21s9.39 21 21 21 21-9.39 21-21-9.39-21-21-21m0 3c9.93 0 18 8.07 18 18s-8.07 18-18 18-18-8.07-18-18 8.07-18 18-18",
  "clip-rule": "evenodd"
}, null, -1), BV = [
  NV,
  PV
];
function VV(t, e) {
  return T(), N("svg", OV, [...BV]);
}
const RV = { render: VV }, HV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, DV = /* @__PURE__ */ C("path", {
  "fill-rule": "#26324B",
  d: "M22.5 6h3v16.5H42v3H25.5V42h-3V25.5H6v-3h16.5z"
}, null, -1), $V = [
  DV
];
function UV(t, e) {
  return T(), N("svg", HV, [...$V]);
}
const jV = { render: UV }, GV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, WV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33 18H15v3h18zm-18-6h18v3H15z"
}, null, -1), YV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 3v3h3v21c0 1.65 1.35 3 3 3h13.5v6.96l-8.34 5.55L15.81 45l8.16-5.46L32.13 45l1.65-2.49-8.34-5.55V30h13.5c1.65 0 3-1.35 3-3V6h3V3zm36 24H9V6h30z",
  "clip-rule": "evenodd"
}, null, -1), XV = [
  WV,
  YV
];
function KV(t, e) {
  return T(), N("svg", GV, [...XV]);
}
const ZV = { render: KV }, JV = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, QV = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 15h-4.5V9c0-1.65-1.35-3-3-3h-21c-1.65 0-3 1.35-3 3v6H6c-1.65 0-3 1.35-3 3v16.5c0 1.65 1.35 3 3 3h4.5V42c0 1.65 1.35 3 3 3h21c1.65 0 3-1.35 3-3v-4.5H42c1.65 0 3-1.35 3-3V18c0-1.65-1.35-3-3-3M13.5 9h21v6h-21zm21 25.5V42h-21V30h21zm7.5 0h-4.5V27h-27v7.5H6V18h36z"
}, null, -1), eR = [
  QV
];
function tR(t, e) {
  return T(), N("svg", JV, [...eR]);
}
const nR = { render: tR }, iR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, sR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.5 9.21V3h-3v6.21C4.92 9.87 3 12.21 3 15s1.92 5.13 4.5 5.79V45h3V20.79c2.58-.66 4.5-3 4.5-5.79s-1.92-5.13-4.5-5.79m0 8.37c-.45.27-.96.42-1.5.42s-1.05-.15-1.5-.42C6.6 17.07 6 16.11 6 15s.6-2.07 1.5-2.58c.45-.27.96-.42 1.5-.42s1.05.15 1.5.42c.9.51 1.5 1.47 1.5 2.58s-.6 2.07-1.5 2.58m30 9.63V3h-3v24.21c-2.58.66-4.5 3-4.5 5.79s1.92 5.13 4.5 5.79V45h3v-6.21c2.58-.66 4.5-3 4.5-5.79s-1.92-5.13-4.5-5.79m0 8.37c-.45.27-.96.42-1.5.42s-1.05-.15-1.5-.42c-.9-.51-1.5-1.47-1.5-2.58s.6-2.07 1.5-2.58c.45-.27.96-.42 1.5-.42s1.05.15 1.5.42c.9.51 1.5 1.47 1.5 2.58s-.6 2.07-1.5 2.58M25.5 3v15.21c2.58.66 4.5 3 4.5 5.79s-1.92 5.13-4.5 5.79V45h-3V29.79c-2.58-.66-4.5-3-4.5-5.79s1.92-5.13 4.5-5.79V3zM24 27c.54 0 1.05-.15 1.5-.42.9-.51 1.5-1.47 1.5-2.58s-.6-2.07-1.5-2.58c-.45-.27-.96-.42-1.5-.42s-1.05.15-1.5.42c-.9.51-1.5 1.47-1.5 2.58s.6 2.07 1.5 2.58c.45.27.96.42 1.5.42",
  "clip-rule": "evenodd"
}, null, -1), lR = [
  sR
];
function rR(t, e) {
  return T(), N("svg", iR, [...lR]);
}
const aR = { render: rR }, oR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, cR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M12.93 9c-1.32 0-2.64.09-3.9.3v5.28c1.26-.27 2.58-.39 3.9-.39 5.58 0 10.8 2.16 14.76 6.12 3.93 3.93 6.09 9.18 6.09 14.76 0 1.32-.12 2.64-.39 3.9h5.28c.21-1.26.3-2.58.3-3.9 0-14.4-11.67-26.1-26.07-26.1z"
}, null, -1), hR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M12.93 20.25c-1.35 0-2.67.18-3.9.54v5.49a9.53 9.53 0 0 1 10.68 1.98c1.8 1.8 2.82 4.26 2.82 6.81 0 1.35-.3 2.7-.84 3.9h5.49c.39-1.23.54-2.58.54-3.93 0-8.19-6.66-14.82-14.82-14.82z"
}, null, -1), uR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M12.93 31.17c2.16 0 3.9 1.74 3.9 3.9s-1.74 3.9-3.9 3.9c-1.08 0-2.07-.42-2.76-1.14s-1.14-1.68-1.14-2.76c0-2.16 1.74-3.9 3.9-3.9M.09 37.14H0v-.36s.03.24.09.36M11.22 48c-.12 0-.36-.09-.36-.09V48z"
}, null, -1), dR = [
  cR,
  hR,
  uR
];
function fR(t, e) {
  return T(), N("svg", oR, [...dR]);
}
const vR = { render: fR }, pR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, mR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 21c0-9.93 8.07-18 18-18s18 8.07 18 18c0 4.416-1.596 8.465-4.242 11.599l11.309 11.31-2.121 2.12L32.64 34.723A17.92 17.92 0 0 1 21 39c-9.93 0-18-8.07-18-18m33 0c0-8.28-6.72-15-15-15S6 12.72 6 21s6.72 15 15 15 15-6.72 15-15",
  "clip-rule": "evenodd"
}, null, -1), gR = [
  mR
];
function yR(t, e) {
  return T(), N("svg", pR, [...gR]);
}
const _R = { render: yR }, qR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, wR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M15.473 26.003c.33 1.74 1.2 3.36 2.46 4.62h.06c.81.84 1.8 1.53 2.91 1.98 1.08.45 2.25.69 3.45.69 1.17 0 2.34-.24 3.45-.69 1.08-.45 2.07-1.14 2.91-1.98 1.26-1.26 2.1-2.88 2.46-4.62.36-1.77.18-3.57-.51-5.22a9.16 9.16 0 0 0-3.33-4.05 8.96 8.96 0 0 0-5.01-1.53c-1.77 0-3.54.54-5.01 1.53-1.5.99-2.64 2.4-3.33 4.05a8.9 8.9 0 0 0-.51 5.22m11.16-7.38c.75.33 1.41.78 1.95 1.35.57.57 1.05 1.23 1.35 1.95.33.72.48 1.5.48 2.31 0 .78-.18 1.59-.48 2.31-.33.75-.78 1.41-1.35 1.95-.57.57-1.23 1.05-1.95 1.35-.72.33-1.5.48-2.31.48-.78 0-1.59-.18-2.31-.48-.75-.33-1.41-.78-1.95-1.35-.57-.57-1.05-1.23-1.35-1.95-.33-.72-.48-1.5-.48-2.31 0-.78.18-1.59.48-2.31.33-.75.78-1.41 1.35-1.95.57-.57 1.23-1.05 1.95-1.35.72-.33 1.53-.48 2.31-.48s1.59.18 2.31.48",
  "clip-rule": "evenodd"
}, null, -1), zR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M35.213 36.773v.03l.18 3.84c.03.69-.15 1.38-.57 1.95-.42.54-1.02.96-1.68 1.14l-6.69 1.83c-.51.15-1.05.15-1.56 0s-.99-.42-1.35-.78c-.24-.21-.42-.48-.57-.78l-1.71-3.45c-.72-.15-1.47-.36-2.19-.6l-3.21 2.13c-.6.39-1.32.57-2.01.48-.69-.06-1.35-.39-1.83-.9l-5.01-5.01c-.51-.48-.81-1.14-.9-1.83-.09-.72.09-1.41.48-2.01l2.13-3.21c-.24-.72-.45-1.44-.6-2.19l-3.45-1.71c-.27-.15-.54-.33-.78-.57-.39-.39-.63-.84-.78-1.35a2.76 2.76 0 0 1 0-1.56l1.74-6.75c.18-.69.6-1.29 1.17-1.71s1.26-.63 1.98-.57l3.81.21 1.62-1.62-.18-3.84c-.03-.69.15-1.38.57-1.95.42-.54 1.02-.96 1.68-1.14l6.75-1.74a2.76 2.76 0 0 1 1.56 0c.51.15.99.42 1.35.78.27.21.48.48.63.75l1.62 3.45c.72.15 1.47.36 2.19.6l3.21-2.13c.6-.39 1.32-.57 2.01-.48.69.06 1.35.39 1.83.9l4.98 4.98c.51.48.81 1.14.9 1.83.09.72-.09 1.41-.48 2.01l-2.13 3.21c.24.72.45 1.44.6 2.19l3.45 1.71c.27.15.54.33.78.57.39.39.63.84.78 1.35s.15 1.05 0 1.56l-1.74 6.75c-.18.69-.57 1.29-1.14 1.71s-1.26.6-1.98.57l-3.84-.27zm-12 .9 2.4 4.89 6.75-1.74-.27-5.52c1.29-.9 2.43-2.04 3.33-3.33l5.46.33 1.74-6.75-4.86-2.46c-.15-1.56-.54-3.09-1.2-4.53l3.03-4.53-5.01-5.01-4.56 3.06a13.3 13.3 0 0 0-4.56-1.2l-2.4-4.89-6.75 1.74.27 5.52c-1.29.9-2.43 2.04-3.33 3.33l-5.46-.33-1.74 6.75 4.86 2.46c.15 1.56.54 3.09 1.2 4.53l-3.03 4.53 5.01 5.01 4.56-3.06c1.44.66 2.97 1.08 4.56 1.2",
  "clip-rule": "evenodd"
}, null, -1), MR = [
  wR,
  zR
];
function bR(t, e) {
  return T(), N("svg", qR, [...MR]);
}
const LR = { render: bR }, xR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, SR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M34.5 30c-2.34 0-4.41 1.11-5.79 2.79L17.67 26.1c.21-.66.33-1.38.33-2.1s-.12-1.38-.3-2.01l11.07-6.69c1.38 1.65 3.42 2.7 5.73 2.7 4.14 0 7.5-3.36 7.5-7.5S38.64 3 34.5 3 27 6.36 27 10.5c0 .75.15 1.47.36 2.16l-11.04 6.69c-1.38-1.71-3.45-2.82-5.82-2.82-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5c2.34 0 4.38-1.08 5.76-2.73l11.07 6.69c-.18.66-.33 1.32-.33 2.04 0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5-3.36-7.5-7.5-7.5z",
  "clip-rule": "evenodd"
}, null, -1), CR = [
  SR
];
function kR(t, e) {
  return T(), N("svg", xR, [...CR]);
}
const ER = { render: kR }, AR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, FR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M34.5 30c-2.34 0-4.41 1.11-5.79 2.79L17.67 26.1c.21-.66.33-1.38.33-2.1s-.12-1.38-.3-2.01l11.07-6.69c1.38 1.65 3.42 2.7 5.73 2.7 4.14 0 7.5-3.36 7.5-7.5S38.64 3 34.5 3 27 6.36 27 10.5c0 .75.15 1.47.36 2.16l-11.04 6.69c-1.38-1.71-3.45-2.82-5.82-2.82-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5c2.34 0 4.38-1.08 5.76-2.73l11.07 6.69c-.18.66-.33 1.32-.33 2.04 0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5-3.36-7.5-7.5-7.5zm0-24c2.49 0 4.5 2.01 4.5 4.5S36.99 15 34.5 15 30 12.99 30 10.5 32.01 6 34.5 6m-24 22.5C8.01 28.5 6 26.49 6 24s2.01-4.5 4.5-4.5S15 21.51 15 24s-2.01 4.5-4.5 4.5m24 13.5c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5",
  "clip-rule": "evenodd"
}, null, -1), TR = [
  FR
];
function IR(t, e) {
  return T(), N("svg", AR, [...TR]);
}
const OR = { render: IR }, NR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, PR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M44.588 19.278a3.49 3.49 0 0 0-2.647-1.217h-3.72L29.133 3l-3.077 1.86 7.978 13.237H13.929L21.943 4.86 18.866 3 9.743 18.061H6.094a3.49 3.49 0 0 0-2.647 1.217 3.87 3.87 0 0 0-.894 3.04L5.307 41.78C5.557 43.605 7.096 45 8.85 45h30.23c1.789 0 3.363-1.395 3.613-3.255l2.755-19.462a3.87 3.87 0 0 0-.894-3.041zm-5.473 22.18-30.23-.143L6.13 21.64l35.811.179-2.862 19.604z",
  "clip-rule": "evenodd"
}, null, -1), BR = [
  PR
];
function VR(t, e) {
  return T(), N("svg", NR, [...BR]);
}
const RR = { render: VR }, HR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, DR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m12 33 12-15 12 15z"
}, null, -1), $R = [
  DR
];
function UR(t, e) {
  return T(), N("svg", HR, [...$R]);
}
const jR = { render: UR }, GR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, WR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M12 21 24 6l12 15zm24 6L24 42 12 27z",
  "clip-rule": "evenodd"
}, null, -1), YR = [
  WR
];
function XR(t, e) {
  return T(), N("svg", GR, [...YR]);
}
const KR = { render: XR }, ZR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, JR = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24.03 45C16.86 45 9.78 40.98 6 34.77l3.21-1.95c3.12 5.13 8.94 8.43 14.82 8.43 9.51 0 17.25-7.74 17.25-17.25S33.54 6.75 24.03 6.75V3c11.58 0 21 9.42 21 21s-9.42 21-21 21"
}, null, -1), QR = [
  JR
];
function eH(t, e) {
  return T(), N("svg", ZR, [...QR]);
}
const tH = { render: eH }, nH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, iH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 3H6C4.35 3 3 4.35 3 6v36c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3M6 6h22.5v10.5H6zm13.5 22.5v-9h9v9zM6 19.5h10.5v9H6zM6 42V31.5h10.5V42zm36 0H19.5V31.5H42zm0-13.5H31.5v-9H42zm0-12H31.5V6H42z",
  "clip-rule": "evenodd"
}, null, -1), sH = [
  iH
];
function lH(t, e) {
  return T(), N("svg", nH, [...sH]);
}
const rH = { render: lH }, aH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, oH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m23.82 3 6.48 13.83 14.52 2.22-10.5 10.74L36.81 45l-12.99-7.17L10.83 45l2.49-15.21-10.5-10.74 14.52-2.22z"
}, null, -1), cH = [
  oH
];
function hH(t, e) {
  return T(), N("svg", aH, [...cH]);
}
const uH = { render: hH }, dH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, fH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m23.94 10.045 3.78 8.034.69 1.44 1.59.239 8.73 1.35-6.42 6.564-1.05 1.08.24 1.499 1.47 9.083-7.56-4.197-1.44-.81-1.44.81-7.56 4.197 1.47-9.084.24-1.498-1.05-1.08-6.42-6.565 8.73-1.349 1.59-.24.69-1.439L24 10.045M24 3l-6.48 13.82L3 19.038l10.5 10.763L11.01 45 24 37.835 36.99 45 34.5 29.8 45 19.039 30.48 16.82 23.94 3z"
}, null, -1), vH = [
  fH
];
function pH(t, e) {
  return T(), N("svg", dH, [...vH]);
}
const mH = { render: pH }, gH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, yH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M27.21 45.09h.016-.03zM15.016 15.03a3.75 3.75 0 0 1 5.31 0h-.03a3.75 3.75 0 0 1 0 5.31c-.72.75-1.68 1.11-2.64 1.11s-1.92-.39-2.64-1.11a3.75 3.75 0 0 1 0-5.31"
}, null, -1), _H = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.216 44.28c.536.537 1.25.807 1.994.81a3.05 3.05 0 0 0 2.146-.9l14.85-14.85c.57-.57.9-1.38.9-2.16 0-.75-.3-1.47-.84-2.01L22.906 3.81c-1.14-1.11-3-1.08-4.17.09l-2.7 2.76-7.77-.12c-.93.03-1.71.81-1.74 1.83l.09 7.65-2.73 2.73c-1.14 1.17-1.2 3.03-.06 4.17zM9.676 15.99l-.12-6.45 6.54.12c.78-.03 1.5-.36 2.04-.9l2.67-2.82 21.3 21.27-14.85 14.85-21.21-21.21 2.73-2.73c.54-.57.9-1.29.9-2.13",
  "clip-rule": "evenodd"
}, null, -1), qH = [
  yH,
  _H
];
function wH(t, e) {
  return T(), N("svg", gH, [...qH]);
}
const zH = { render: wH }, MH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, bH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M16.47 9V6c0-1.65 1.35-3 3-3h9c1.65 0 3 1.35 3 3v3h10.5v3H6V9zm12 0V6h-9v3z",
  "clip-rule": "evenodd"
}, null, -1), LH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M36 45H11.97c-1.65 0-3-1.35-3-3V13.47h3v28.56H36V13.47h3v28.56c0 1.65-1.35 3-3 3z"
}, null, -1), xH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M20.97 36V18h-3v18zm6 0V18h3v18z"
}, null, -1), SH = [
  bH,
  LH,
  xH
];
function CH(t, e) {
  return T(), N("svg", MH, [...SH]);
}
const kH = { render: CH }, EH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, AH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m24 3 16.05 16.02-2.13 2.13L25.47 8.7V36h-3V8.76L10.05 21.18l-2.13-2.13zm15 39v-6h3v6c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3v-6h3v6z"
}, null, -1), FH = [
  AH
];
function TH(t, e) {
  return T(), N("svg", EH, [...FH]);
}
const IH = { render: TH }, OH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, NH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m24 12 16.17 30H7.83zm0-5.67c-.21 0-.42.12-.54.33L3.24 44.13c-.21.39.06.87.54.87h40.41c.45 0 .75-.48.54-.87L24.51 6.66a.63.63 0 0 0-.54-.33z"
}, null, -1), PH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.5 19.44h-3v12.63h3zM24 34.89a2.01 2.01 0 0 0 0 4.02c1.11 0 2.04-.9 2.04-2.01s-.9-2.01-2.04-2.01"
}, null, -1), BH = [
  NH,
  PH
];
function VH(t, e) {
  return T(), N("svg", OH, [...BH]);
}
const RH = { render: VH }, HH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, DH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m-1.5 9.33h3v15.72h-3zM24 35.64c-1.11 0-2.04-.9-2.04-2.01s.9-2.01 2.04-2.01 2.01.9 2.01 2.01-.9 2.01-2.01 2.01",
  "clip-rule": "evenodd"
}, null, -1), $H = [
  DH
];
function UH(t, e) {
  return T(), N("svg", HH, [...$H]);
}
const jH = { render: UH }, GH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, WH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M44.73 44.13 34.59 25.35 24.51 6.66c-.24-.42-.84-.42-1.05 0L13.38 25.35 3.24 44.13c-.21.39.06.87.54.87h40.41c.45 0 .75-.48.54-.87M22.5 17.97h3V32.1h-3zM24 38.94a2.01 2.01 0 0 1 0-4.02c1.11 0 2.04.9 2.04 2.01s-.9 2.01-2.04 2.01",
  "clip-rule": "evenodd"
}, null, -1), YH = [
  WH
];
function XH(t, e) {
  return T(), N("svg", GH, [...YH]);
}
const KH = { render: XH }, ZH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, JH = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24.15 11.1 22.02 9 6 25.02 22.05 41.1l2.13-2.1-12.423-12.45H42v-3H11.7z"
}, null, -1), QH = [
  JH
];
function eD(t, e) {
  return T(), N("svg", ZH, [...QH]);
}
const tD = { render: eD }, nD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, iD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.5 3.06h-3v42h3zm-9 12h-3v18h3zm-12-6h3v30h-3zm36 23.97h3v-18h-3zm-6 6h-3v-30h3z"
}, null, -1), sD = [
  iD
];
function lD(t, e) {
  return T(), N("svg", nD, [...sD]);
}
const rD = { render: lD }, aD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, oD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33 18H15v3h18zm-18-6h18v3H15z"
}, null, -1), cD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 45H12.45C8.88 45 6 42.3 6 39V9c0-3.3 2.88-6 6.45-6h26.4C40.59 3 42 4.35 42 6v30H12.45C10.56 36 9 37.35 9 39s1.56 3 3.45 3H42zM12.45 6C10.56 6 9 7.35 9 9v24.93c.99-.6 2.19-.93 3.45-.93H39V6z",
  "clip-rule": "evenodd"
}, null, -1), hD = [
  oD,
  cD
];
function uD(t, e) {
  return T(), N("svg", aD, [...hD]);
}
const dD = { render: uD }, fD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, vD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 7.83h-.3L30 10.17 18.3 7.83h-.54l-12 2.4c-.69.15-1.2.75-1.2 1.47v26.94c0 .84.69 1.5 1.5 1.5h.3l11.7-2.34 11.7 2.34h.54l12-2.4c.69-.15 1.2-.75 1.2-1.47V9.33c0-.84-.69-1.5-1.5-1.5M7.5 12.96l9-1.8v23.88l-9 1.8zm12-1.8 9 1.8v23.88l-9-1.8zm21 23.88-9 1.8V12.96l9-1.8z"
}, null, -1), pD = [
  vD
];
function mD(t, e) {
  return T(), N("svg", fD, [...pD]);
}
const gD = { render: mD }, yD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, _D = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M31.5 18c0 4.14-3.36 7.5-7.5 7.5s-7.5-3.36-7.5-7.5 3.36-7.5 7.5-7.5 7.5 3.36 7.5 7.5m-3 0c0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5",
  "clip-rule": "evenodd"
}, null, -1), qD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M15 16.53H9v3h6zm18 0h6v3h-6z"
}, null, -1), wD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 30V6h42v24zM6 9v18h36V9z",
  "clip-rule": "evenodd"
}, null, -1), zD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M6 32.97v3h36v-3zM9 42v-3h30v3z"
}, null, -1), MD = [
  _D,
  qD,
  wD,
  zD
];
function bD(t, e) {
  return T(), N("svg", yD, [...MD]);
}
const LD = { render: bD }, xD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, SD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18 3h-3v3H9C7.35 6 6 7.35 6 9v30c0 1.65 1.35 3 3 3h30c1.65 0 3-1.35 3-3V9c0-1.65-1.35-3-3-3h-6V3h-3v3H18zm12 6H18v3h-3V9H9v7.5h30V9h-6v3h-3zm9 10.5H9V39h30z",
  "clip-rule": "evenodd"
}, null, -1), CD = [
  SD
];
function kD(t, e) {
  return T(), N("svg", xD, [...CD]);
}
const ED = { render: kD }, AD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, FD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18 16.5c-4.98 0-9 4.02-9 9s4.02 9 9 9 9-4.02 9-9-4.02-9-9-9m0 3c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6",
  "clip-rule": "evenodd"
}, null, -1), TD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M30 13.5h9v3h-9z"
}, null, -1), ID = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 7.5H6c-1.65 0-3 1.35-3 3v27c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3v-27c0-1.65-1.35-3-3-3m0 3v27H6v-27z",
  "clip-rule": "evenodd"
}, null, -1), OD = [
  FD,
  TD,
  ID
];
function ND(t, e) {
  return T(), N("svg", AD, [...OD]);
}
const PD = { render: ND }, BD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, VD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M23.55 30.75a6.56 6.56 0 0 0 4.68 1.95c1.77 0 3.42-.69 4.68-1.95l10.56-10.56a6.627 6.627 0 0 0 0-9.36l-2.1-2.1a6.627 6.627 0 0 0-9.36 0l-5.28 5.28 2.97 2.97 5.28-5.28c.93-.93 2.49-.93 3.42 0l2.1 2.1c.93.93.93 2.49 0 3.42L29.94 27.78c-.93.9-2.52.9-3.42 0l-3.15-3.15-2.97 2.97z"
}, null, -1), RD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M6.6 39.27c1.29 1.29 3 1.92 4.68 1.92 1.71 0 3.39-.63 4.68-1.92l5.31-5.31-2.97-2.97-5.31 5.31c-.96.96-2.49.93-3.42 0l-2.1-2.1c-.93-.96-.93-2.49 0-3.42l10.56-10.56c.96-.96 2.49-.93 3.42 0l3.18 3.18 2.97-2.97-3.18-3.18a6.627 6.627 0 0 0-9.36 0L4.5 27.81a6.627 6.627 0 0 0 0 9.36z"
}, null, -1), HD = [
  VD,
  RD
];
function DD(t, e) {
  return T(), N("svg", BD, [...HD]);
}
const $D = { render: DD }, UD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, jD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.58 3 24 3m-3.27 30.09-8.31-8.25 2.13-2.13 6.18 6.15 12.78-12.9 2.13 2.1-14.88 15.03z",
  "clip-rule": "evenodd"
}, null, -1), GD = [
  jD
];
function WD(t, e) {
  return T(), N("svg", UD, [...GD]);
}
const YD = { render: WD }, XD = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, KD = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M19.53 36.69 6 23.19l2.13-2.13 11.4 11.4L39.99 12l2.13 2.13z"
}, null, -1), ZD = [
  KD
];
function JD(t, e) {
  return T(), N("svg", XD, [...ZD]);
}
const QD = { render: JD }, e$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, t$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m6.72 29.7-8.22-8.07V12h3v11.37l7.32 7.17-2.1 2.13z",
  "clip-rule": "evenodd"
}, null, -1), n$ = [
  t$
];
function i$(t, e) {
  return T(), N("svg", e$, [...n$]);
}
const s$ = { render: i$ }, l$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, r$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m22.5 24.63 8.22 8.07 2.1-2.16-7.32-7.17V12h-3z"
}, null, -1), a$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 24C3 12.39 12.39 3 24 3s21 9.39 21 21-9.39 21-21 21S3 35.61 3 24m39 0c0-9.93-8.07-18-18-18S6 14.07 6 24s8.07 18 18 18 18-8.07 18-18",
  "clip-rule": "evenodd"
}, null, -1), o$ = [
  r$,
  a$
];
function c$(t, e) {
  return T(), N("svg", l$, [...o$]);
}
const h$ = { render: c$ }, u$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, d$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21m-13.59-9.54 2.13 2.13L26.1 24l7.44 7.41-2.13 2.13L24 26.13l-7.44 7.41-2.1-2.13L21.87 24l-7.41-7.41 2.1-2.13L24 21.87z",
  "clip-rule": "evenodd"
}, null, -1), f$ = [
  d$
];
function v$(t, e) {
  return T(), N("svg", u$, [...f$]);
}
const p$ = { render: v$ }, m$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, g$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m21.868 24.021-7.425 7.425 2.122 2.121 7.424-7.424 7.425 7.424 2.121-2.121-7.424-7.425 7.424-7.424-2.121-2.122-7.425 7.425-7.424-7.425-2.122 2.122z"
}, null, -1), y$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.42 3 3 12.42 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m0 3c9.93 0 18 8.07 18 18s-8.07 18-18 18S6 33.93 6 24 14.07 6 24 6",
  "clip-rule": "evenodd"
}, null, -1), _$ = [
  g$,
  y$
];
function q$(t, e) {
  return T(), N("svg", m$, [..._$]);
}
const w$ = { render: q$ }, z$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, M$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 8.01 39.99 6 24 21.99 8.01 6 6 8.01 21.99 24 6 39.99 8.01 42 24 26.01 39.99 42 42 39.99 26.01 24z"
}, null, -1), b$ = [
  M$
];
function L$(t, e) {
  return T(), N("svg", z$, [...b$]);
}
const x$ = { render: L$ }, S$ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 48 48"
}, C$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M39 10.4H18c-1.7 0-3 1.4-3 3.1v28.3c0 1.7 1.3 3.1 3 3.1h10.8c.8 0 1.6-.3 2.1-.9l10.2-10.7c.6-.6.9-1.4.9-2.2V13.5c0-1.7-1.3-3.1-3-3.1m-9 30.2V33h7.3zM18.1 42s-.1 0-.1-.2V13.4h21V30h-9c-1.7 0-3 1.3-3 3v9",
  "clip-rule": "evenodd"
}, null, -1), k$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M7.4 33.1 5.9 9.8c-.1-1.2.3-2.4 1.1-3.3S8.9 5.1 10.1 5l19.8-1.9.3 3L10.3 8c-.4 0-.8.2-1.1.5-.2.3-.3.7-.3 1.1l1.5 23.3z",
  "clip-rule": "evenodd"
}, null, -1), E$ = [
  C$,
  k$
];
function A$(t, e) {
  return T(), N("svg", S$, [...E$]);
}
const F$ = { render: A$ }, T$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, I$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m45 30.12-2.73 2.82-18.24-18.36L5.73 33 3 30.18 24.03 9z",
  "clip-rule": "evenodd"
}, null, -1), O$ = [
  I$
];
function N$(t, e) {
  return T(), N("svg", T$, [...O$]);
}
const P$ = { render: N$ }, B$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, V$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M40.5 18c0-1.8-.81-3.39-2.07-4.5 1.26-1.11 2.07-2.7 2.07-4.5 0-3.3-2.7-6-6-6h-21c-3.3 0-6 2.7-6 6 0 1.8.81 3.39 2.07 4.5C8.31 14.61 7.5 16.2 7.5 18s.81 3.39 2.07 4.5C8.31 23.61 7.5 25.2 7.5 27c0 3.3 2.7 6 6 6h9v2.82a4.9 4.9 0 0 0-3.21 3.21H9v3h10.29c.63 2.01 2.49 3.48 4.71 3.48s4.08-1.47 4.71-3.48H39v-3H28.71a4.9 4.9 0 0 0-3.21-3.21V33h9c3.3 0 6-2.7 6-6 0-1.8-.81-3.39-2.07-4.5 1.26-1.11 2.07-2.7 2.07-4.5M24 42.48c-1.08 0-1.98-.87-1.98-1.98s.87-1.98 1.98-1.98 1.98.87 1.98 1.98-.87 1.98-1.98 1.98M10.5 8.97c0-1.65 1.35-3 3-3h21c1.65 0 3 1.35 3 3s-1.35 3-3 3h-21c-1.65 0-3-1.35-3-3m27 18c0 1.65-1.35 3-3 3h-21c-1.65 0-3-1.35-3-3s1.32-2.97 2.97-3h21.06c1.65 0 2.97 1.35 2.97 3m-3-6H13.47c-1.65 0-2.97-1.35-2.97-3s1.35-3 3-3h21c1.65 0 3 1.35 3 3s-1.32 2.97-2.97 3z",
  "clip-rule": "evenodd"
}, null, -1), R$ = [
  V$
];
function H$(t, e) {
  return T(), N("svg", B$, [...R$]);
}
const D$ = { render: H$ }, $$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, U$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M31.77 13.5H18.63L14.28 18H6v-3h7.02l4.35-4.5h14.4c.66-2.16 2.64-3.75 5.01-3.75 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.37 0-4.35-1.59-5.01-3.75m7.26-1.5c0-1.23-1.02-2.25-2.25-2.25s-2.25 1.02-2.25 2.25 1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25m-7.26 22.5c.66-2.16 2.64-3.75 5.01-3.75 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.37 0-4.35-1.59-5.01-3.75H20.04l-2.82-6H6v-3h11.19l2.79-6.03h5.76c.63-2.16 2.64-3.78 5.01-3.78 2.88 0 5.25 2.37 5.25 5.25s-2.37 5.25-5.25 5.25c-2.34 0-4.32-1.59-4.98-3.72h-3.84l-2.1 4.56 2.1 4.47zm1.29-10.59c0-1.23-1.02-2.25-2.25-2.25s-2.25 1.02-2.25 2.25 1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25M34.53 36c0 1.23 1.02 2.25 2.25 2.25s2.25-1.02 2.25-2.25-1.02-2.25-2.25-2.25-2.25 1.02-2.25 2.25",
  "clip-rule": "evenodd"
}, null, -1), j$ = [
  U$
];
function G$(t, e) {
  return T(), N("svg", $$, [...j$]);
}
const W$ = { render: G$ }, Y$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, X$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 13.5H12v3h12zm6 6H12v3h18z"
}, null, -1), K$ = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M37.5 4.74v25.29h6v7.47c0 3.3-2.91 6-6.51 6H12c-4.14 0-7.5-3.36-7.5-7.5V4.74zM12 40.5c2.58 0 5.16-1.38 5.16-4.5v-5.97H34.5V7.74h-27V36c0 2.49 1.92 4.5 4.5 4.5m24.99 0c1.95 0 3.51-1.35 3.51-3v-4.47H20.16V36c0 1.74-.54 3.27-1.5 4.5z",
  "clip-rule": "evenodd"
}, null, -1), Z$ = [
  X$,
  K$
];
function J$(t, e) {
  return T(), N("svg", Y$, [...Z$]);
}
const Q$ = { render: J$ }, eU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, tU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m25.47 30.24 12.45-12.42 2.13 2.13L23.97 36 7.92 19.98l2.13-2.13L22.47 30.3V3h3zM39 42v-6h3v6c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3v-6h3v6z"
}, null, -1), nU = [
  tU
];
function iU(t, e) {
  return T(), N("svg", eU, [...nU]);
}
const sU = { render: iU }, lU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, rU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m39.54 6.81 4.53 4.53c.51.54.81 1.26.81 1.98s-.3 1.44-.81 1.95L25.98 33.36c-.33.33-.69.57-1.11.69l-7.47 1.8c-.15.09-.3.09-.48.09-.48 0-.99-.18-1.38-.57-.51-.51-.69-1.29-.48-1.98l1.74-7.26c.15-.51.39-.93.72-1.23L35.61 6.81a2.79 2.79 0 0 1 3.93 0M18.36 32.58l5.73-1.38 12.45-12.54-4.26-4.26-12.63 12.63zm19.2-23.49-3.18 3.18 4.26 4.26v.03l3.18-3.21z",
  "clip-rule": "evenodd"
}, null, -1), aU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M9 41.94h30v-15h3v15c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3v-30c0-1.65 1.35-3 3-3h15.03v3H9z"
}, null, -1), oU = [
  rU,
  aU
];
function cU(t, e) {
  return T(), N("svg", lU, [...oU]);
}
const hU = { render: cU }, uU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, dU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42.18 9H5.88A2.88 2.88 0 0 0 3 11.88v24.27a2.88 2.88 0 0 0 2.88 2.88h36.3a2.88 2.88 0 0 0 2.88-2.88V11.88A2.88 2.88 0 0 0 42.18 9m-.12 3-.12-.15h.12zm-2.07-.12L23.97 27.03 8.19 12l31.77-.12zM6.03 12l-.15.15V12zm0 24.12-.12-22.2L21.9 29.19c.57.54 1.32.84 2.07.84s1.47-.27 2.07-.81l16.05-15.15v21.96l-36.03.12z",
  "clip-rule": "evenodd"
}, null, -1), fU = [
  dU
];
function vU(t, e) {
  return T(), N("svg", uU, [...fU]);
}
const pU = { render: vU }, mU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, gU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M38.85 31.29 27.6 24.81c-.6.54-1.32.96-2.1 1.2v15.96H33v3H15v-3h7.5V26.01c-.81-.24-1.5-.66-2.1-1.2L9.15 31.29l-1.5-2.61L18.9 22.2c-.09-.39-.15-.78-.15-1.2 0-2.37 1.59-4.35 3.75-5.01V3h3v12.99c2.16.66 3.75 2.64 3.75 5.01 0 .42-.06.81-.15 1.2l11.25 6.48zM24 18.75c-1.23 0-2.25 1.02-2.25 2.25s1.02 2.25 2.25 2.25 2.25-1.02 2.25-2.25-1.02-2.25-2.25-2.25",
  "clip-rule": "evenodd"
}, null, -1), yU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M17.67 10.23c-5.07 1.29-8.16 6.45-6.87 11.52l-2.91.72C6.21 15.81 10.29 9 16.95 7.32z"
}, null, -1), _U = [
  gU,
  yU
];
function qU(t, e) {
  return T(), N("svg", mU, [..._U]);
}
const wU = { render: qU }, zU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, MU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m31.363 14.467-7.425 7.424-7.425-7.424-2.12 2.12 7.424 7.426-7.425 7.424 2.121 2.121 7.425-7.424 7.425 7.425 2.121-2.122-7.425-7.425 7.425-7.424z"
}, null, -1), bU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M14.13 6h19.65c.45 0 .84.24 1.05.6l9.81 16.8c.21.36.21.84 0 1.2l-9.81 16.8c-.24.36-.63.6-1.05.6H14.16c-.45 0-.84-.24-1.05-.6L3.3 24.6c-.21-.36-.21-.84 0-1.2l9.78-16.8c.24-.36.63-.6 1.05-.6m27.36 18L32.73 9H15.18L6.42 24l8.76 15h17.55z",
  "clip-rule": "evenodd"
}, null, -1), LU = [
  MU,
  bU
];
function xU(t, e) {
  return T(), N("svg", zU, [...LU]);
}
const SU = { render: xU }, CU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, kU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M44.67 23.4 34.86 6.6c-.21-.36-.6-.6-1.05-.6H14.19c-.42 0-.81.24-1.05.6L3.39 23.4c-.21.36-.21.84 0 1.2l9.81 16.8c.21.36.6.6 1.05.6h19.62c.42 0 .81-.24 1.05-.6l9.81-16.8c.21-.36.21-.84 0-1.2zm-11.16 8.04-2.13 2.13-7.41-7.41-7.41 7.41-2.13-2.13 7.41-7.41-7.41-7.41 2.13-2.13 7.41 7.41 7.41-7.41 2.13 2.13-7.41 7.41z",
  "clip-rule": "evenodd"
}, null, -1), EU = [
  kU
];
function AU(t, e) {
  return T(), N("svg", CU, [...EU]);
}
const FU = { render: AU }, TU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, IU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18.72 30.24c1.65 1.71 3.63 2.55 6 2.55l.03.06c2.58 0 4.74-1.05 6.6-3.21l.78-.93v4.14l-.15.12c-1.95 1.74-4.41 2.61-7.26 2.61-3.15 0-5.82-1.11-7.95-3.33-1.23-1.26-2.1-2.79-2.64-4.53h-3.69l1.17-2.76h2.01c-.06-.3-.06-.6-.06-.93 0-.139.016-.27.031-.397.015-.12.029-.236.029-.353h-3.18l1.17-2.76h2.49c.54-1.83 1.44-3.39 2.7-4.71 2.13-2.22 4.8-3.33 7.95-3.33s5.85 1.14 8.04 3.42l.21.21-1.17 2.79-.48-.54c-1.89-2.13-4.05-3.15-6.6-3.15-2.37 0-4.35.84-6 2.55-.78.81-1.35 1.71-1.77 2.73h14.1l-1.11 2.76H16.32c-.06.24-.06.48-.06.75 0 .3.03.63.06.93h13.26l-1.17 2.76h-11.4c.42.96.99 1.8 1.71 2.55"
}, null, -1), OU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3.06 24c0-11.61 9.39-21 21-21s21 9.39 21 21-9.39 21-21 21-21-9.39-21-21m39 0c0-9.93-8.07-18-18-18s-18 8.07-18 18 8.07 18 18 18 18-8.07 18-18",
  "clip-rule": "evenodd"
}, null, -1), NU = [
  IU,
  OU
];
function PU(t, e) {
  return T(), N("svg", TU, [...NU]);
}
const BU = { render: PU }, VU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, RU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18 3h-3v3H9C7.35 6 6 7.35 6 9v30c0 1.65 1.35 3 3 3h12v-3H9V9h6v3h3V9h12v3h3V9h6v12h3V9c0-1.65-1.35-3-3-3h-6V3h-3v3H18z"
}, null, -1), HU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M36.03 24h-3v9.03H24v3h9.03v9.03h3v-9.03h9.03v-3h-9.03z"
}, null, -1), DU = [
  RU,
  HU
];
function $U(t, e) {
  return T(), N("svg", VU, [...DU]);
}
const UU = { render: $U }, jU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, GU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M39 6h-6V3h-3v3H18V3h-3v3H9C7.35 6 6 7.35 6 9v30c0 1.65 1.35 3 3 3h9v-3H9V9h6v3h3V9h12v3h3V9h6v9h3V9c0-1.65-1.35-3-3-3"
}, null, -1), WU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33 21v3h6.81l-7.86 7.95 2.1 2.1L42 26.07V33h3V21z"
}, null, -1), YU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 42h15v-6h3v6c0 1.65-1.35 3-3 3H24c-1.65 0-3-1.35-3-3V27c0-1.65 1.35-3 3-3h6v3h-6z"
}, null, -1), XU = [
  GU,
  WU,
  YU
];
function KU(t, e) {
  return T(), N("svg", jU, [...XU]);
}
const ZU = { render: KU }, JU = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, QU = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M30 6V3h15v15h-3V8.13L29.13 21 27 18.87 39.87 6z"
}, null, -1), ej = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M39 42V24h3v18c0 1.65-1.35 3-3 3H6c-1.65 0-3-1.35-3-3V9c0-1.65 1.35-3 3-3h18v3H6v33z"
}, null, -1), tj = [
  QU,
  ej
];
function nj(t, e) {
  return T(), N("svg", JU, [...tj]);
}
const ij = { render: nj }, sj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, lj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M28.65 12.39c-1.26-1.05-3.06-1.56-5.31-1.56-1.68 0-3.6.48-5.7 1.44l-.27.12.09.27.84 2.13.12.3.3-.15c1.8-.84 3.3-1.26 4.44-1.26q1.89 0 2.97.9c.72.6 1.05 1.44 1.05 2.58 0 .69-.18 1.35-.48 1.95-.33.6-.87 1.23-1.59 1.83l-2.31 2.04c-1.35 1.2-2.04 2.88-2.04 4.98v1.29h3v-1.26c0-.63.06-1.17.21-1.56.15-.42.33-.75.57-1.05s.93-.9 2.04-1.83c2.67-2.22 4.02-4.41 4.02-6.51s-.66-3.6-1.92-4.65zm-6.12 19.98q-.9 0-1.53.63c-.42.42-.63.93-.63 1.56q0 .945.63 1.62c.42.45.93.69 1.53.69s1.14-.24 1.56-.69q.63-.675.63-1.62c0-.63-.21-1.14-.63-1.56s-.93-.63-1.56-.63"
}, null, -1), rj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M6 3h36c1.65 0 3 1.35 3 3v36c0 1.65-1.35 3-3 3H6c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3m36 39V6H6v36z",
  "clip-rule": "evenodd"
}, null, -1), aj = [
  lj,
  rj
];
function oj(t, e) {
  return T(), N("svg", sj, [...aj]);
}
const cj = { render: oj }, hj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, uj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.05 35.43q.405.18.81.18c.39 0 .72-.12.93-.3l11.25-6.87H34.5c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3H6C4.35 3 3 4.35 3 6v19.47c0 1.65 1.35 3 3 3h3.03v5.34c0 .69.39 1.32 1.02 1.62m.27-2.73s-.21.09-.27.18zM6 25.44V6h28.53v19.44h-12.3l-10.2 6.21v-6.21z",
  "clip-rule": "evenodd"
}, null, -1), dj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33.03 42.66c.33.27.72.42 1.14.42l-.03-.03c.27 0 .54-.06.78-.18.63-.3 1.02-.93 1.02-1.62v-5.34h6.03c1.65 0 3-1.35 3-3V11.97c0-1.65-1.35-3-3-3v23.97h-9.03V39l-9-6.06h-4.59v3h3.69zm1.68-2.46.12.09s-.06-.06-.12-.09",
  "clip-rule": "evenodd"
}, null, -1), fj = [
  uj,
  dj
];
function vj(t, e) {
  return T(), N("svg", hj, [...fj]);
}
const pj = { render: vj }, mj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, gj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M36 3H12c-1.65 0-3 1.35-3 3v36c0 1.65 1.35 3 3 3h13.77c.81 0 1.56-.33 2.13-.87L38.13 33.9c.57-.57.87-1.32.87-2.13V6c0-1.65-1.35-3-3-3m-9 37.77V33h7.77zM36 30h-9c-1.65 0-3 1.35-3 3v9H12V6h24z",
  "clip-rule": "evenodd"
}, null, -1), yj = [
  gj
];
function _j(t, e) {
  return T(), N("svg", mj, [...yj]);
}
const qj = { render: _j }, wj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, zj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33 11.7H15v2.1h18zm-18 4.98h18v2.1H15z"
}, null, -1), Mj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M36 3H12c-1.65 0-3 1.35-3 3v36c0 1.65 1.35 3 3 3h13.77c.81 0 1.56-.33 2.13-.87L38.13 33.9c.57-.57.87-1.32.87-2.13V6c0-1.65-1.35-3-3-3M11.1 42V6c0-.51.39-.9.9-.9h24c.51 0 .9.39.9.9v25.14h-8.31c-1.98 0-3.6 1.62-3.6 3.63v8.13H12.03c-.51 0-.9-.39-.9-.9zm15.99-.06v-7.17c0-.84.66-1.53 1.5-1.53h7.2z",
  "clip-rule": "evenodd"
}, null, -1), bj = [
  zj,
  Mj
];
function Lj(t, e) {
  return T(), N("svg", wj, [...bj]);
}
const xj = { render: Lj }, Sj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, Cj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 15H25.47l-4.38-8.16c-.27-.51-.84-.84-1.44-.84H4.59C3.69 6 3 6.66 3 7.5V39c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V18c0-1.65-1.35-3-3-3M6 9h12.84l3.21 6H6zm36 30H6V18h36z",
  "clip-rule": "evenodd"
}, null, -1), kj = [
  Cj
];
function Ej(t, e) {
  return T(), N("svg", Sj, [...kj]);
}
const Aj = { render: Ej }, Fj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, Tj = /* @__PURE__ */ C("path", { d: "m8.22 6 10.86 10.95-2.16 2.1L6 8.01V18H3V3h15v3zM30 6V3h15v15h-3V8.01L31.05 19.05l-2.1-2.1L39.78 6zM16.95 28.95 6 39.96V30H3v14.97h15v-3H8.22l10.83-10.92zM42 39.96V30h3v14.97H30v-3h9.78L28.95 31.05l2.1-2.1z" }, null, -1), Ij = [
  Tj
];
function Oj(t, e) {
  return T(), N("svg", Fj, [...Ij]);
}
const Nj = { render: Oj }, Pj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, Bj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M45 24c0-11.61-9.39-21-21-21S3 12.39 3 24c0 10.98 8.43 19.98 19.17 20.91a18 18 0 0 0 3.6 0c10.77-.9 19.2-9.93 19.2-20.91zM24.6 41.97c-.21 0-.39.03-.6.03s-.42 0-.63-.03C21.45 40.14 18.3 35.61 18 25.5h12c-.3 10.11-3.45 14.64-5.37 16.47zM41.91 22.5h-8.94c-.21-7.77-1.98-12.69-3.9-15.75C36.06 8.82 41.28 15 41.91 22.5M24.69 6.03c1.89 1.8 5.01 6.33 5.31 16.47H18c.27-10.11 3.42-14.64 5.28-16.47.24 0 .48-.03.72-.03s.45 0 .69.03m-5.79.72c-1.92 3.06-3.69 7.98-3.9 15.75H6.09C6.72 15 11.94 8.82 18.9 6.75M6.09 25.5H15c.21 7.83 2.1 12.78 3.99 15.78-7.02-2.04-12.3-8.25-12.93-15.78zm22.89 15.78c1.92-3 3.78-7.95 4.02-15.78h8.94c-.63 7.53-5.91 13.74-12.96 15.78"
}, null, -1), Vj = [
  Bj
];
function Rj(t, e) {
  return T(), N("svg", Pj, [...Vj]);
}
const Hj = { render: Rj }, Dj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, $j = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.35 41.97H39v-3H10.35c-.78 0-1.38-.75-1.38-1.65V9h-3v28.32c0 2.58 1.98 4.65 4.38 4.65"
}, null, -1), Uj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 12V9h15v15h-3v-9.87L24.33 25.77l-8.28 8.28-2.1-2.1L33.87 12z"
}, null, -1), jj = [
  $j,
  Uj
];
function Gj(t, e) {
  return T(), N("svg", Dj, [...jj]);
}
const Wj = { render: Gj }, Yj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, Xj = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 12H6v3h36zm0 21H6v3h36zM6 22.5h36v3H6z"
}, null, -1), Kj = [
  Xj
];
function Zj(t, e) {
  return T(), N("svg", Yj, [...Kj]);
}
const Jj = { render: Zj }, Qj = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, eG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M4.543 32.97 3.013 9.66c-.09-1.2.3-2.34 1.08-3.27.78-.9 1.89-1.44 3.09-1.53L26.983 3l.27 3-19.83 1.86c-.87.06-1.5.78-1.44 1.59l1.56 23.34-3 .21z"
}, null, -1), tG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.573 26.85c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5m0-6.45c1.08 0 1.95.87 1.95 1.95s-.87 1.95-1.95 1.95-1.95-.87-1.95-1.95.87-1.95 1.95-1.95",
  "clip-rule": "evenodd"
}, null, -1), nG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M15.103 11.88h27c1.65 0 3 1.35 3 3v27c0 1.65-1.35 3-3 3h-27c-1.65 0-3-1.35-3-3v-27c0-1.65 1.35-3 3-3m0 30h27v-8.4l-6.06-6.54-8.58 8.25c-1.05 1.05-2.82 1.11-3.96.06L21.043 33l-5.94 6.45zm26.97-12.872.03.032h-.03zm-3.84-4.138 3.84 4.138V14.85h-27v20.22l3.93-4.17c1.11-1.17 2.88-1.2 4.05-.15l2.46 2.25 8.61-8.22c.51-.51 1.2-.84 2.04-.81.78.03 1.53.33 2.07.9",
  "clip-rule": "evenodd"
}, null, -1), iG = [
  eG,
  tG,
  nG
];
function sG(t, e) {
  return T(), N("svg", Qj, [...iG]);
}
const lG = { render: sG }, rG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, aG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 3h12v36H3zm3 33h6V6H6zM18 9h12v30H18zm3 27h6V12h-6zm12-21v24h12V15zm9 21h-6V18h6z",
  "clip-rule": "evenodd"
}, null, -1), oG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 42h42v3H3z"
}, null, -1), cG = [
  aG,
  oG
];
function hG(t, e) {
  return T(), N("svg", rG, [...cG]);
}
const uG = { render: hG }, dG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, fG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.5 33V21h-6v3h3v9H18v3h12v-3zm-2.76-20.61c.39-.27.81-.39 1.26-.39.6 0 1.17.24 1.59.66s.66.99.66 1.59a2.31 2.31 0 0 1-1.41 2.1c-.39.15-.84.21-1.29.12-.42-.09-.84-.33-1.14-.63-.33-.3-.54-.69-.63-1.14-.09-.42-.06-.87.12-1.29s.48-.78.84-1.02"
}, null, -1), vG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 3H6C4.35 3 3 4.35 3 6v36c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3m0 39H6V6h36z",
  "clip-rule": "evenodd"
}, null, -1), pG = [
  fG,
  vG
];
function mG(t, e) {
  return T(), N("svg", dG, [...pG]);
}
const gG = { render: mG }, yG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, _G = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24.03 3c-11.61 0-21 9.39-21 21s9.39 21 21 21 21-9.39 21-21-9.42-21-21-21m-2.07 10.38a2.31 2.31 0 0 1 2.1-1.41c.6 0 1.17.24 1.59.66s.66.99.66 1.59c0 .45-.12.87-.39 1.26-.24.36-.6.66-1.02.84s-.87.21-1.29.12c-.45-.09-.84-.3-1.14-.63-.3-.3-.54-.72-.63-1.14s-.03-.9.12-1.29M30.03 36h-12v-3h4.5v-9h-3v-3h6v12h4.5z",
  "clip-rule": "evenodd"
}, null, -1), qG = [
  _G
];
function wG(t, e) {
  return T(), N("svg", yG, [...qG]);
}
const zG = { render: wG }, MG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, bG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 3H6C4.35 3 3 4.35 3 6v36c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3M21.93 13.38a2.31 2.31 0 0 1 2.1-1.41c.6 0 1.17.24 1.59.66s.66.99.66 1.59c0 .45-.12.87-.39 1.26-.24.36-.6.66-1.02.84s-.87.21-1.29.12c-.45-.09-.84-.3-1.14-.63-.3-.3-.54-.72-.63-1.14s-.03-.9.12-1.29M30 36H18v-3h4.5v-9h-3v-3h6v12H30z",
  "clip-rule": "evenodd"
}, null, -1), LG = [
  bG
];
function xG(t, e) {
  return T(), N("svg", MG, [...LG]);
}
const SG = { render: xG }, CG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, kG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42.158 12h-30.24c-1.59 0-2.91 1.35-2.91 3l.06 3.87-5.58 5.4c-.66.69-.66 1.77.06 2.52l5.49 5.34V36c0 1.65 1.29 3 2.91 3h30.21c1.59 0 2.91-1.35 2.91-3V15c0-1.65-1.29-3-2.91-3m-24.12 16.5c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m9 0c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m9 0c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3",
  "clip-rule": "evenodd"
}, null, -1), EG = [
  kG
];
function AG(t, e) {
  return T(), N("svg", CG, [...EG]);
}
const FG = { render: AG }, TG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, IG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M21.038 25.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m6 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6m12-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
}, null, -1), OG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M11.918 12h30.24c1.62 0 2.91 1.35 2.91 3v21c0 1.65-1.32 3-2.91 3h-30.21c-1.62 0-2.91-1.35-2.91-3v-3.87l-5.49-5.34c-.72-.75-.72-1.83-.06-2.52l5.58-5.4-.06-3.87c0-1.65 1.32-3 2.91-3m.12 24h30l.03.06v-21h-30.12l.09 3.87c0 .78-.3 1.5-.81 2.07l-4.68 4.53 4.62 4.47c.57.6.87 1.35.87 2.13z",
  "clip-rule": "evenodd"
}, null, -1), NG = [
  IG,
  OG
];
function PG(t, e) {
  return T(), N("svg", TG, [...NG]);
}
const BG = { render: PG }, VG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, RG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.44 13.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m3.03-1.5H42v3H13.47zm0 21H42v3H13.47zM42 22.5H13.47v3H42zM8.19 26.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m2.25 8.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
}, null, -1), HG = [
  RG
];
function DG(t, e) {
  return T(), N("svg", VG, [...HG]);
}
const $G = { render: DG }, UG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, jG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m11.415 10.875.015.015v-.03zm0 0L9.3 8.76c-8.4 8.4-8.4 22.08 0 30.48l2.13-2.13c-7.225-7.225-7.23-19.004-.015-26.235m25.155.015 2.13-2.13v.03c8.4 8.4 8.4 22.08 0 30.48l-2.13-2.13c7.23-7.23 7.23-19.02 0-26.25"
}, null, -1), GG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m33.75 14.85-2.13 2.13c3.87 3.87 3.87 10.2 0 14.1l2.13 2.13c5.04-5.04 5.04-13.26 0-18.33zm-12.72 6.18a4.183 4.183 0 0 0 0 5.94c.78.78 1.86 1.23 2.97 1.23s2.19-.45 2.97-1.23a4.183 4.183 0 0 0 0-5.94c-1.59-1.59-4.35-1.59-5.94 0m-6.81-6.18c-5.04 5.04-5.04 13.26 0 18.33l2.13-2.13c-3.87-3.87-3.87-10.2 0-14.1l-2.13-2.13z"
}, null, -1), WG = [
  jG,
  GG
];
function YG(t, e) {
  return T(), N("svg", UG, [...WG]);
}
const XG = { render: YG }, KG = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, ZG = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M34.17 7.83A16.5 16.5 0 0 0 22.5 3c-4.38 0-8.58 1.74-11.67 4.83A16.5 16.5 0 0 0 6 19.5a16.4 16.4 0 0 0 3.33 9.9s.45.6.51.69L22.5 45l12.66-14.94.51-.66A16.4 16.4 0 0 0 39 19.5c0-4.38-1.74-8.58-4.83-11.67M22.5 24c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6"
}, null, -1), JG = [
  ZG
];
function QG(t, e) {
  return T(), N("svg", KG, [...JG]);
}
const eW = { render: QG }, tW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, nW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M14.97 19.5c0-4.14 3.36-7.5 7.5-7.5s7.5 3.36 7.5 7.5-3.36 7.5-7.5 7.5-7.5-3.36-7.5-7.5m12 0c0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5",
  "clip-rule": "evenodd"
}, null, -1), iW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.83 7.83C13.92 4.74 18.12 3 22.5 3s8.58 1.74 11.67 4.83S39 15.12 39 19.5a16.4 16.4 0 0 1-3.33 9.9l-.51.66L22.5 45 9.84 30.09c-.06-.09-.51-.69-.51-.69A16.4 16.4 0 0 1 6 19.5c0-4.38 1.74-8.58 4.83-11.67m21.18 2.13A13.4 13.4 0 0 0 22.485 6a13.4 13.4 0 0 0-9.525 3.96A13.4 13.4 0 0 0 9 19.5c-.03 2.88.96 5.76 2.7 8.07l.45.6 10.32 12.18 10.38-12.24c.03-.06.36-.48.36-.48l.06-.06a13.46 13.46 0 0 0 2.7-8.07c0-3.6-1.41-6.99-3.96-9.54",
  "clip-rule": "evenodd"
}, null, -1), sW = [
  nW,
  iW
];
function lW(t, e) {
  return T(), N("svg", tW, [...sW]);
}
const rW = { render: lW }, aW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, oW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M13.47 13.5c0-5.79 4.71-10.5 10.5-10.5s10.5 4.71 10.5 10.5S29.76 24 23.97 24s-10.5-4.71-10.5-10.5m18 0c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5 3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5M6 45h36.03v-5.91c0-6.66-5.07-12.09-11.25-12.09H17.25C11.04 27 6 32.43 6 39.09zm33-3H8.97v-2.91c0-5.01 3.72-9.09 8.25-9.09h13.53c4.56 0 8.25 4.08 8.25 9.09z",
  "clip-rule": "evenodd"
}, null, -1), cW = [
  oW
];
function hW(t, e) {
  return T(), N("svg", aW, [...cW]);
}
const uW = { render: hW }, dW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, fW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M13.47 13.5c0-5.79 4.71-10.5 10.5-10.5s10.5 4.71 10.5 10.5S29.76 24 23.97 24s-10.5-4.71-10.5-10.5m17.4 0a6.901 6.901 0 0 0-13.8 0 6.901 6.901 0 0 0 13.8 0",
  "clip-rule": "evenodd"
}, null, -1), vW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M38.76 45h3.6v-5.91c0-6.84-5.19-12.39-11.55-12.39H17.28c-6.36 0-11.55 5.55-11.55 12.39V45h3.6v-5.91c0-4.83 3.57-8.79 7.95-8.79h13.53c4.38 0 7.95 3.93 7.95 8.79z"
}, null, -1), pW = [
  fW,
  vW
];
function mW(t, e) {
  return T(), N("svg", dW, [...pW]);
}
const gW = { render: mW }, yW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, _W = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M23.97 3c-5.79 0-10.5 4.71-10.5 10.5S18.18 24 23.97 24s10.5-4.71 10.5-10.5S29.76 3 23.97 3m0 3.6a6.901 6.901 0 0 1 0 13.8 6.901 6.901 0 0 1 0-13.8",
  "clip-rule": "evenodd"
}, null, -1), qW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m30.69 47.07-8.97-8.97 2.55-2.55 6.42 6.42 12.03-12.03 2.55 2.55z"
}, null, -1), wW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M5.76 45h3.6v-5.91c0-4.83 3.57-8.79 7.95-8.79h15.81v-3.6H17.31c-6.36 0-11.55 5.55-11.55 12.39z"
}, null, -1), zW = [
  _W,
  qW,
  wW
];
function MW(t, e) {
  return T(), N("svg", yW, [...zW]);
}
const bW = { render: MW }, LW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, xW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M11.97 22.5h24v3h-24z"
}, null, -1), SW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M2.97 24c0-11.58 9.42-21 21-21 11.61 0 21 9.39 21 21s-9.39 21-21 21-21-9.42-21-21m39 0c0-9.93-8.07-18-18-18s-18 8.07-18 18 8.07 18 18 18 18-8.07 18-18",
  "clip-rule": "evenodd"
}, null, -1), CW = [
  xW,
  SW
];
function kW(t, e) {
  return T(), N("svg", LW, [...CW]);
}
const EW = { render: kW }, AW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, FW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 24H6v3h36z"
}, null, -1), TW = [
  FW
];
function IW(t, e) {
  return T(), N("svg", AW, [...TW]);
}
const OW = { render: IW }, NW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, PW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m6.013 9.66 1.56 23.31V33l3-.21-1.56-23.34c-.03-.39.09-.78.36-1.08.24-.3.6-.51 1.05-.51L30.253 6l-.27-3-19.8 1.86c-1.2.09-2.31.63-3.09 1.53-.78.93-1.17 2.07-1.08 3.27"
}, null, -1), BW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M18.133 10.26h21c1.65 0 3 1.41 3 3.15v17.55c0 .84-.3 1.62-.87 2.22l-10.23 10.74c-.57.6-1.32.93-2.13.93h-10.77c-1.65 0-3-1.41-3-3.15V13.41c0-1.74 1.35-3.15 3-3.15m12 22.59v7.68l7.32-7.68zm-12 8.85c0 .12.06.15.06.15h8.91v-9c0-1.65 1.35-3 3-3h9V13.41c0-.09-.03-.15-.03-.15h-20.94c.03.03 0 .15 0 .15z",
  "clip-rule": "evenodd"
}, null, -1), VW = [
  PW,
  BW
];
function RW(t, e) {
  return T(), N("svg", NW, [...VW]);
}
const HW = { render: RW }, DW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, $W = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M40.5 28.5h-4.89l-8.16-9H30c.81 0 1.5-.66 1.5-1.5V9c0-.84-.69-1.5-1.5-1.5H18c-.84 0-1.5.66-1.5 1.5v9c0 .84.66 1.5 1.5 1.5h2.55l-8.16 9H7.5c-.84 0-1.5.66-1.5 1.5v9c0 .81.66 1.5 1.5 1.5h12c.84 0 1.5-.69 1.5-1.5v-9c0-.84-.66-1.5-1.5-1.5h-3.03L24 20.16l7.53 8.34H28.5c-.84 0-1.5.66-1.5 1.5v9c0 .84.66 1.5 1.5 1.5h12c.84 0 1.5-.66 1.5-1.5v-9c0-.84-.66-1.5-1.5-1.5m-21-12v-6h9v6zm-1.5 15v6H9v-6zm21 6h-9v-6h9z"
}, null, -1), UW = [
  $W
];
function jW(t, e) {
  return T(), N("svg", DW, [...UW]);
}
const GW = { render: jW }, WW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, YW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M27.51 22.5H9.99v3h17.52zm-3.51 6H9.99v3H24z"
}, null, -1), XW = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m38.52 3.78 5.88 8.85.03-.03c.39.57.6 1.26.6 1.95v26.97c0 1.95-1.59 3.51-3.51 3.51H6.51C4.56 45.03 3 43.44 3 41.52V14.58c0-.69.21-1.38.6-1.95l5.88-8.85c.33-.48.87-.78 1.47-.78h26.1c.6 0 1.14.3 1.47.78m2.88 9.72L36.39 6H25.5v7.5zM22.5 6H11.61L6.6 13.5h15.9zm18.99 36c.3 0 .51-.24.51-.51V16.5H6v24.99c0 .3.24.51.51.51z",
  "clip-rule": "evenodd"
}, null, -1), KW = [
  YW,
  XW
];
function ZW(t, e) {
  return T(), N("svg", WW, [...KW]);
}
const JW = { render: ZW }, QW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, eY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m-3 30h-3V15h3zm9 0h-3V15h3z"
}, null, -1), tY = [
  eY
];
function nY(t, e) {
  return T(), N("svg", QW, [...tY]);
}
const iY = { render: nY }, sY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, lY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M21 15h-3v18h3zm6 0h3v18h-3z"
}, null, -1), rY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m0 3c9.93 0 18 8.07 18 18s-8.07 18-18 18S6 33.93 6 24 14.07 6 24 6",
  "clip-rule": "evenodd"
}, null, -1), aY = [
  lY,
  rY
];
function oY(t, e) {
  return T(), N("svg", sY, [...aY]);
}
const cY = { render: oY }, hY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, uY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M15 9h6v30h-6zm12 0h6v30h-6z"
}, null, -1), dY = [
  uY
];
function fY(t, e) {
  return T(), N("svg", hY, [...dY]);
}
const vY = { render: fY }, pY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, mY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21m-9.75-1.2-18.3-9.18v.06c-.9-.45-1.95.21-1.95 1.2v18.33c0 .99 1.05 1.65 1.95 1.2l18.3-9.18c.99-.51.99-1.92 0-2.43",
  "clip-rule": "evenodd"
}, null, -1), gY = [
  mY
];
function yY(t, e) {
  return T(), N("svg", pY, [...gY]);
}
const _Y = { render: yY }, qY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, wY = /* @__PURE__ */ C("path", { d: "m35.25 22.8-18.3-9.18v.06c-.9-.45-1.95.21-1.95 1.2v18.33c0 .99 1.05 1.65 1.95 1.2l18.3-9.18c.99-.51.99-1.92 0-2.43" }, null, -1), zY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 24C3 12.39 12.39 3 24 3s21 9.39 21 21-9.39 21-21 21S3 35.61 3 24m39 0c0-9.93-8.07-18-18-18S6 14.07 6 24s8.07 18 18 18 18-8.07 18-18",
  "clip-rule": "evenodd"
}, null, -1), MY = [
  wY,
  zY
];
function bY(t, e) {
  return T(), N("svg", qY, [...MY]);
}
const LY = { render: bY }, xY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, SY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m41.22 22.68-30-16.5C10.23 5.64 9 6.36 9 7.5v33c0 1.14 1.23 1.86 2.22 1.32l30-16.5c1.02-.57 1.02-2.04 0-2.61z",
  "clip-rule": "evenodd"
}, null, -1), CY = [
  SY
];
function kY(t, e) {
  return T(), N("svg", xY, [...CY]);
}
const EY = { render: kY }, AY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, FY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M23.97 3c-11.58 0-21 9.42-21 21s9.39 21 21 21 21-9.39 21-21-9.39-21-21-21m12 22.5h-10.5V36h-3V25.5h-10.5v-3h10.5V12h3v10.5h10.5z",
  "clip-rule": "evenodd"
}, null, -1), TY = [
  FY
];
function IY(t, e) {
  return T(), N("svg", AY, [...TY]);
}
const OY = { render: IY }, NY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, PY = /* @__PURE__ */ C("path", {
  "fill-rule": "#26324B",
  d: "M25.47 22.5V12h-3v10.5h-10.5v3h10.5V36h3V25.5h10.5v-3z"
}, null, -1), BY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M23.97 3c-11.58 0-21 9.42-21 21s9.39 21 21 21 21-9.39 21-21-9.39-21-21-21m0 3c9.93 0 18 8.07 18 18s-8.07 18-18 18-18-8.07-18-18 8.07-18 18-18",
  "clip-rule": "evenodd"
}, null, -1), VY = [
  PY,
  BY
];
function RY(t, e) {
  return T(), N("svg", NY, [...VY]);
}
const HY = { render: RY }, DY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, $Y = /* @__PURE__ */ C("path", {
  "fill-rule": "#26324B",
  d: "M22.5 6h3v16.5H42v3H25.5V42h-3V25.5H6v-3h16.5z"
}, null, -1), UY = [
  $Y
];
function jY(t, e) {
  return T(), N("svg", DY, [...UY]);
}
const GY = { render: jY }, WY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, YY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M33 18H15v3h18zm-18-6h18v3H15z"
}, null, -1), XY = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 3v3h3v21c0 1.65 1.35 3 3 3h13.5v6.96l-8.34 5.55L15.81 45l8.16-5.46L32.13 45l1.65-2.49-8.34-5.55V30h13.5c1.65 0 3-1.35 3-3V6h3V3zm36 24H9V6h30z",
  "clip-rule": "evenodd"
}, null, -1), KY = [
  YY,
  XY
];
function ZY(t, e) {
  return T(), N("svg", WY, [...KY]);
}
const JY = { render: ZY }, QY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, eX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 15h-4.5V9c0-1.65-1.35-3-3-3h-21c-1.65 0-3 1.35-3 3v6H6c-1.65 0-3 1.35-3 3v16.5c0 1.65 1.35 3 3 3h4.5V42c0 1.65 1.35 3 3 3h21c1.65 0 3-1.35 3-3v-4.5H42c1.65 0 3-1.35 3-3V18c0-1.65-1.35-3-3-3M13.5 9h21v6h-21zm21 25.5V42h-21V30h21zm7.5 0h-4.5V27h-27v7.5H6V18h36z"
}, null, -1), tX = [
  eX
];
function nX(t, e) {
  return T(), N("svg", QY, [...tX]);
}
const iX = { render: nX }, sX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, lX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M10.5 9.21V3h-3v6.21C4.92 9.87 3 12.21 3 15s1.92 5.13 4.5 5.79V45h3V20.79c2.58-.66 4.5-3 4.5-5.79s-1.92-5.13-4.5-5.79m0 8.37c-.45.27-.96.42-1.5.42s-1.05-.15-1.5-.42C6.6 17.07 6 16.11 6 15s.6-2.07 1.5-2.58c.45-.27.96-.42 1.5-.42s1.05.15 1.5.42c.9.51 1.5 1.47 1.5 2.58s-.6 2.07-1.5 2.58m30 9.63V3h-3v24.21c-2.58.66-4.5 3-4.5 5.79s1.92 5.13 4.5 5.79V45h3v-6.21c2.58-.66 4.5-3 4.5-5.79s-1.92-5.13-4.5-5.79m0 8.37c-.45.27-.96.42-1.5.42s-1.05-.15-1.5-.42c-.9-.51-1.5-1.47-1.5-2.58s.6-2.07 1.5-2.58c.45-.27.96-.42 1.5-.42s1.05.15 1.5.42c.9.51 1.5 1.47 1.5 2.58s-.6 2.07-1.5 2.58M25.5 3v15.21c2.58.66 4.5 3 4.5 5.79s-1.92 5.13-4.5 5.79V45h-3V29.79c-2.58-.66-4.5-3-4.5-5.79s1.92-5.13 4.5-5.79V3zM24 27c.54 0 1.05-.15 1.5-.42.9-.51 1.5-1.47 1.5-2.58s-.6-2.07-1.5-2.58c-.45-.27-.96-.42-1.5-.42s-1.05.15-1.5.42c-.9.51-1.5 1.47-1.5 2.58s.6 2.07 1.5 2.58c.45.27.96.42 1.5.42",
  "clip-rule": "evenodd"
}, null, -1), rX = [
  lX
];
function aX(t, e) {
  return T(), N("svg", sX, [...rX]);
}
const oX = { render: aX }, cX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, hX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M12.93 9c-1.32 0-2.64.09-3.9.3v5.28c1.26-.27 2.58-.39 3.9-.39 5.58 0 10.8 2.16 14.76 6.12 3.93 3.93 6.09 9.18 6.09 14.76 0 1.32-.12 2.64-.39 3.9h5.28c.21-1.26.3-2.58.3-3.9 0-14.4-11.67-26.1-26.07-26.1z"
}, null, -1), uX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M12.93 20.25c-1.35 0-2.67.18-3.9.54v5.49a9.53 9.53 0 0 1 10.68 1.98c1.8 1.8 2.82 4.26 2.82 6.81 0 1.35-.3 2.7-.84 3.9h5.49c.39-1.23.54-2.58.54-3.93 0-8.19-6.66-14.82-14.82-14.82z"
}, null, -1), dX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M12.93 31.17c2.16 0 3.9 1.74 3.9 3.9s-1.74 3.9-3.9 3.9c-1.08 0-2.07-.42-2.76-1.14s-1.14-1.68-1.14-2.76c0-2.16 1.74-3.9 3.9-3.9M.09 37.14H0v-.36s.03.24.09.36M11.22 48c-.12 0-.36-.09-.36-.09V48z"
}, null, -1), fX = [
  hX,
  uX,
  dX
];
function vX(t, e) {
  return T(), N("svg", cX, [...fX]);
}
const pX = { render: vX }, mX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, gX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M3 21c0-9.93 8.07-18 18-18s18 8.07 18 18c0 4.416-1.596 8.465-4.242 11.599l11.309 11.31-2.121 2.12L32.64 34.723A17.92 17.92 0 0 1 21 39c-9.93 0-18-8.07-18-18m33 0c0-8.28-6.72-15-15-15S6 12.72 6 21s6.72 15 15 15 15-6.72 15-15",
  "clip-rule": "evenodd"
}, null, -1), yX = [
  gX
];
function _X(t, e) {
  return T(), N("svg", mX, [...yX]);
}
const qX = { render: _X }, wX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, zX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M15.473 26.003c.33 1.74 1.2 3.36 2.46 4.62h.06c.81.84 1.8 1.53 2.91 1.98 1.08.45 2.25.69 3.45.69 1.17 0 2.34-.24 3.45-.69 1.08-.45 2.07-1.14 2.91-1.98 1.26-1.26 2.1-2.88 2.46-4.62.36-1.77.18-3.57-.51-5.22a9.16 9.16 0 0 0-3.33-4.05 8.96 8.96 0 0 0-5.01-1.53c-1.77 0-3.54.54-5.01 1.53-1.5.99-2.64 2.4-3.33 4.05a8.9 8.9 0 0 0-.51 5.22m11.16-7.38c.75.33 1.41.78 1.95 1.35.57.57 1.05 1.23 1.35 1.95.33.72.48 1.5.48 2.31 0 .78-.18 1.59-.48 2.31-.33.75-.78 1.41-1.35 1.95-.57.57-1.23 1.05-1.95 1.35-.72.33-1.5.48-2.31.48-.78 0-1.59-.18-2.31-.48-.75-.33-1.41-.78-1.95-1.35-.57-.57-1.05-1.23-1.35-1.95-.33-.72-.48-1.5-.48-2.31 0-.78.18-1.59.48-2.31.33-.75.78-1.41 1.35-1.95.57-.57 1.23-1.05 1.95-1.35.72-.33 1.53-.48 2.31-.48s1.59.18 2.31.48",
  "clip-rule": "evenodd"
}, null, -1), MX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M35.213 36.773v.03l.18 3.84c.03.69-.15 1.38-.57 1.95-.42.54-1.02.96-1.68 1.14l-6.69 1.83c-.51.15-1.05.15-1.56 0s-.99-.42-1.35-.78c-.24-.21-.42-.48-.57-.78l-1.71-3.45c-.72-.15-1.47-.36-2.19-.6l-3.21 2.13c-.6.39-1.32.57-2.01.48-.69-.06-1.35-.39-1.83-.9l-5.01-5.01c-.51-.48-.81-1.14-.9-1.83-.09-.72.09-1.41.48-2.01l2.13-3.21c-.24-.72-.45-1.44-.6-2.19l-3.45-1.71c-.27-.15-.54-.33-.78-.57-.39-.39-.63-.84-.78-1.35a2.76 2.76 0 0 1 0-1.56l1.74-6.75c.18-.69.6-1.29 1.17-1.71s1.26-.63 1.98-.57l3.81.21 1.62-1.62-.18-3.84c-.03-.69.15-1.38.57-1.95.42-.54 1.02-.96 1.68-1.14l6.75-1.74a2.76 2.76 0 0 1 1.56 0c.51.15.99.42 1.35.78.27.21.48.48.63.75l1.62 3.45c.72.15 1.47.36 2.19.6l3.21-2.13c.6-.39 1.32-.57 2.01-.48.69.06 1.35.39 1.83.9l4.98 4.98c.51.48.81 1.14.9 1.83.09.72-.09 1.41-.48 2.01l-2.13 3.21c.24.72.45 1.44.6 2.19l3.45 1.71c.27.15.54.33.78.57.39.39.63.84.78 1.35s.15 1.05 0 1.56l-1.74 6.75c-.18.69-.57 1.29-1.14 1.71s-1.26.6-1.98.57l-3.84-.27zm-12 .9 2.4 4.89 6.75-1.74-.27-5.52c1.29-.9 2.43-2.04 3.33-3.33l5.46.33 1.74-6.75-4.86-2.46c-.15-1.56-.54-3.09-1.2-4.53l3.03-4.53-5.01-5.01-4.56 3.06a13.3 13.3 0 0 0-4.56-1.2l-2.4-4.89-6.75 1.74.27 5.52c-1.29.9-2.43 2.04-3.33 3.33l-5.46-.33-1.74 6.75 4.86 2.46c.15 1.56.54 3.09 1.2 4.53l-3.03 4.53 5.01 5.01 4.56-3.06c1.44.66 2.97 1.08 4.56 1.2",
  "clip-rule": "evenodd"
}, null, -1), bX = [
  zX,
  MX
];
function LX(t, e) {
  return T(), N("svg", wX, [...bX]);
}
const xX = { render: LX }, SX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, CX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M34.5 30c-2.34 0-4.41 1.11-5.79 2.79L17.67 26.1c.21-.66.33-1.38.33-2.1s-.12-1.38-.3-2.01l11.07-6.69c1.38 1.65 3.42 2.7 5.73 2.7 4.14 0 7.5-3.36 7.5-7.5S38.64 3 34.5 3 27 6.36 27 10.5c0 .75.15 1.47.36 2.16l-11.04 6.69c-1.38-1.71-3.45-2.82-5.82-2.82-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5c2.34 0 4.38-1.08 5.76-2.73l11.07 6.69c-.18.66-.33 1.32-.33 2.04 0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5-3.36-7.5-7.5-7.5z",
  "clip-rule": "evenodd"
}, null, -1), kX = [
  CX
];
function EX(t, e) {
  return T(), N("svg", SX, [...kX]);
}
const AX = { render: EX }, FX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, TX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M34.5 30c-2.34 0-4.41 1.11-5.79 2.79L17.67 26.1c.21-.66.33-1.38.33-2.1s-.12-1.38-.3-2.01l11.07-6.69c1.38 1.65 3.42 2.7 5.73 2.7 4.14 0 7.5-3.36 7.5-7.5S38.64 3 34.5 3 27 6.36 27 10.5c0 .75.15 1.47.36 2.16l-11.04 6.69c-1.38-1.71-3.45-2.82-5.82-2.82-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5c2.34 0 4.38-1.08 5.76-2.73l11.07 6.69c-.18.66-.33 1.32-.33 2.04 0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5-3.36-7.5-7.5-7.5zm0-24c2.49 0 4.5 2.01 4.5 4.5S36.99 15 34.5 15 30 12.99 30 10.5 32.01 6 34.5 6m-24 22.5C8.01 28.5 6 26.49 6 24s2.01-4.5 4.5-4.5S15 21.51 15 24s-2.01 4.5-4.5 4.5m24 13.5c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5",
  "clip-rule": "evenodd"
}, null, -1), IX = [
  TX
];
function OX(t, e) {
  return T(), N("svg", FX, [...IX]);
}
const NX = { render: OX }, PX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, BX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M44.588 19.278a3.49 3.49 0 0 0-2.647-1.217h-3.72L29.133 3l-3.077 1.86 7.978 13.237H13.929L21.943 4.86 18.866 3 9.743 18.061H6.094a3.49 3.49 0 0 0-2.647 1.217 3.87 3.87 0 0 0-.894 3.04L5.307 41.78C5.557 43.605 7.096 45 8.85 45h30.23c1.789 0 3.363-1.395 3.613-3.255l2.755-19.462a3.87 3.87 0 0 0-.894-3.041zm-5.473 22.18-30.23-.143L6.13 21.64l35.811.179-2.862 19.604z",
  "clip-rule": "evenodd"
}, null, -1), VX = [
  BX
];
function RX(t, e) {
  return T(), N("svg", PX, [...VX]);
}
const HX = { render: RX }, DX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, $X = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m12 33 12-15 12 15z"
}, null, -1), UX = [
  $X
];
function jX(t, e) {
  return T(), N("svg", DX, [...UX]);
}
const GX = { render: jX }, WX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, YX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M12 21 24 6l12 15zm24 6L24 42 12 27z",
  "clip-rule": "evenodd"
}, null, -1), XX = [
  YX
];
function KX(t, e) {
  return T(), N("svg", WX, [...XX]);
}
const ZX = { render: KX }, JX = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, QX = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24.03 45C16.86 45 9.78 40.98 6 34.77l3.21-1.95c3.12 5.13 8.94 8.43 14.82 8.43 9.51 0 17.25-7.74 17.25-17.25S33.54 6.75 24.03 6.75V3c11.58 0 21 9.42 21 21s-9.42 21-21 21"
}, null, -1), eK = [
  QX
];
function tK(t, e) {
  return T(), N("svg", JX, [...eK]);
}
const nK = { render: tK }, iK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, sK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M42 3H6C4.35 3 3 4.35 3 6v36c0 1.65 1.35 3 3 3h36c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3M6 6h22.5v10.5H6zm13.5 22.5v-9h9v9zM6 19.5h10.5v9H6zM6 42V31.5h10.5V42zm36 0H19.5V31.5H42zm0-13.5H31.5v-9H42zm0-12H31.5V6H42z",
  "clip-rule": "evenodd"
}, null, -1), lK = [
  sK
];
function rK(t, e) {
  return T(), N("svg", iK, [...lK]);
}
const aK = { render: rK }, oK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, cK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m23.82 3 6.48 13.83 14.52 2.22-10.5 10.74L36.81 45l-12.99-7.17L10.83 45l2.49-15.21-10.5-10.74 14.52-2.22z"
}, null, -1), hK = [
  cK
];
function uK(t, e) {
  return T(), N("svg", oK, [...hK]);
}
const dK = { render: uK }, fK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, vK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m23.94 10.045 3.78 8.034.69 1.44 1.59.239 8.73 1.35-6.42 6.564-1.05 1.08.24 1.499 1.47 9.083-7.56-4.197-1.44-.81-1.44.81-7.56 4.197 1.47-9.084.24-1.498-1.05-1.08-6.42-6.565 8.73-1.349 1.59-.24.69-1.439L24 10.045M24 3l-6.48 13.82L3 19.038l10.5 10.763L11.01 45 24 37.835 36.99 45 34.5 29.8 45 19.039 30.48 16.82 23.94 3z"
}, null, -1), pK = [
  vK
];
function mK(t, e) {
  return T(), N("svg", fK, [...pK]);
}
const gK = { render: mK }, yK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, _K = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M27.21 45.09h.016-.03zM15.016 15.03a3.75 3.75 0 0 1 5.31 0h-.03a3.75 3.75 0 0 1 0 5.31c-.72.75-1.68 1.11-2.64 1.11s-1.92-.39-2.64-1.11a3.75 3.75 0 0 1 0-5.31"
}, null, -1), qK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.216 44.28c.536.537 1.25.807 1.994.81a3.05 3.05 0 0 0 2.146-.9l14.85-14.85c.57-.57.9-1.38.9-2.16 0-.75-.3-1.47-.84-2.01L22.906 3.81c-1.14-1.11-3-1.08-4.17.09l-2.7 2.76-7.77-.12c-.93.03-1.71.81-1.74 1.83l.09 7.65-2.73 2.73c-1.14 1.17-1.2 3.03-.06 4.17zM9.676 15.99l-.12-6.45 6.54.12c.78-.03 1.5-.36 2.04-.9l2.67-2.82 21.3 21.27-14.85 14.85-21.21-21.21 2.73-2.73c.54-.57.9-1.29.9-2.13",
  "clip-rule": "evenodd"
}, null, -1), wK = [
  _K,
  qK
];
function zK(t, e) {
  return T(), N("svg", yK, [...wK]);
}
const MK = { render: zK }, bK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, LK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M16.47 9V6c0-1.65 1.35-3 3-3h9c1.65 0 3 1.35 3 3v3h10.5v3H6V9zm12 0V6h-9v3z",
  "clip-rule": "evenodd"
}, null, -1), xK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M36 45H11.97c-1.65 0-3-1.35-3-3V13.47h3v28.56H36V13.47h3v28.56c0 1.65-1.35 3-3 3z"
}, null, -1), SK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M20.97 36V18h-3v18zm6 0V18h3v18z"
}, null, -1), CK = [
  LK,
  xK,
  SK
];
function kK(t, e) {
  return T(), N("svg", bK, [...CK]);
}
const EK = { render: kK }, AK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, FK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m24 3 16.05 16.02-2.13 2.13L25.47 8.7V36h-3V8.76L10.05 21.18l-2.13-2.13zm15 39v-6h3v6c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3v-6h3v6z"
}, null, -1), TK = [
  FK
];
function IK(t, e) {
  return T(), N("svg", AK, [...TK]);
}
const OK = { render: IK }, NK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, PK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "m24 12 16.17 30H7.83zm0-5.67c-.21 0-.42.12-.54.33L3.24 44.13c-.21.39.06.87.54.87h40.41c.45 0 .75-.48.54-.87L24.51 6.66a.63.63 0 0 0-.54-.33z"
}, null, -1), BK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M25.5 19.44h-3v12.63h3zM24 34.89a2.01 2.01 0 0 0 0 4.02c1.11 0 2.04-.9 2.04-2.01s-.9-2.01-2.04-2.01"
}, null, -1), VK = [
  PK,
  BK
];
function RK(t, e) {
  return T(), N("svg", NK, [...VK]);
}
const HK = { render: RK }, DK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, $K = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M24 3C12.39 3 3 12.39 3 24s9.39 21 21 21 21-9.39 21-21S35.61 3 24 3m-1.5 9.33h3v15.72h-3zM24 35.64c-1.11 0-2.04-.9-2.04-2.01s.9-2.01 2.04-2.01 2.01.9 2.01 2.01-.9 2.01-2.01 2.01",
  "clip-rule": "evenodd"
}, null, -1), UK = [
  $K
];
function jK(t, e) {
  return T(), N("svg", DK, [...UK]);
}
const GK = { render: jK }, WK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
}, YK = /* @__PURE__ */ C("path", {
  "fill-rule": "evenodd",
  d: "M44.73 44.13 34.59 25.35 24.51 6.66c-.24-.42-.84-.42-1.05 0L13.38 25.35 3.24 44.13c-.21.39.06.87.54.87h40.41c.45 0 .75-.48.54-.87M22.5 17.97h3V32.1h-3zM24 38.94a2.01 2.01 0 0 1 0-4.02c1.11 0 2.04.9 2.04 2.01s-.9 2.01-2.04 2.01",
  "clip-rule": "evenodd"
}, null, -1), XK = [
  YK
];
function KK(t, e) {
  return T(), N("svg", WK, [...XK]);
}
const ZK = { render: KK }, gL = () => ({
  ec: {
    "arrow-left": eT,
    audio: lT,
    book: uT,
    brochure: mT,
    budget: bT,
    calendar: kT,
    camera: NT,
    chain: DT,
    "check-filled": WT,
    check: JT,
    "clock-filled": iI,
    clock: cI,
    "close-filled": vI,
    "close-outline": qI,
    close: LI,
    copy: AI,
    "corner-arrow": NI,
    data: HI,
    digital: GI,
    document: JI,
    download: iO,
    edit: cO,
    email: vO,
    energy: qO,
    "error-outline": xO,
    error: AO,
    euro: PO,
    event: $O,
    "external-events": KO,
    external: nN,
    faq: oN,
    feedback: vN,
    "file-blank": _N,
    file: LN,
    folder: EN,
    fullscreen: ON,
    global: RN,
    growth: GN,
    hamburger: ZN,
    image: sP,
    infographic: hP,
    "information-outline": mP,
    "information-round": wP,
    information: xP,
    "laco-filled": AP,
    laco: PP,
    list: DP,
    livestreaming: YP,
    "location-filled": QP,
    location: lB,
    "log-in-outline": hB,
    "log-in": mB,
    "logged-in": MB,
    "minus-outline": kB,
    minus: IB,
    "multiple-files": RB,
    organigram: jB,
    package: ZB,
    "pause-filled": nV,
    "pause-outline": oV,
    pause: fV,
    "play-filled": yV,
    "play-outline": bV,
    play: kV,
    "plus-filled": IV,
    "plus-outline": RV,
    plus: jV,
    presentation: ZV,
    print: nR,
    regulation: aR,
    rss: vR,
    search: _R,
    settings: LR,
    "share-filled": ER,
    share: OR,
    "shopping-bag": RR,
    "solid-arrow": jR,
    "sort-carets": KR,
    spinner: tH,
    spreadsheet: rH,
    "star-filled": uH,
    "star-outline": mH,
    tag: zH,
    trash: kH,
    upload: IH,
    "warning-outline": RH,
    "warning-round": jH,
    warning: KH
  },
  eu: {
    "arrow-left": tD,
    audio: rD,
    book: dD,
    brochure: gD,
    budget: LD,
    calendar: ED,
    camera: PD,
    chain: $D,
    "check-filled": YD,
    check: QD,
    "clock-filled": s$,
    clock: h$,
    "close-filled": p$,
    "close-outline": w$,
    close: x$,
    copy: F$,
    "corner-arrow": P$,
    data: D$,
    digital: W$,
    document: Q$,
    download: sU,
    edit: hU,
    email: pU,
    energy: wU,
    "error-outline": SU,
    error: FU,
    euro: BU,
    event: UU,
    "external-events": ZU,
    external: ij,
    faq: cj,
    feedback: pj,
    "file-blank": qj,
    file: xj,
    folder: Aj,
    fullscreen: Nj,
    global: Hj,
    growth: Wj,
    hamburger: Jj,
    image: lG,
    infographic: uG,
    "information-outline": gG,
    "information-round": zG,
    information: SG,
    "laco-filled": FG,
    laco: BG,
    list: $G,
    livestreaming: XG,
    "location-filled": eW,
    location: rW,
    "log-in-outline": uW,
    "log-in": gW,
    "logged-in": bW,
    "minus-outline": EW,
    minus: OW,
    "multiple-files": HW,
    organigram: GW,
    package: JW,
    "pause-filled": iY,
    "pause-outline": cY,
    pause: vY,
    "play-filled": _Y,
    "play-outline": LY,
    play: EY,
    "plus-filled": OY,
    "plus-outline": HY,
    plus: GY,
    presentation: JY,
    print: iX,
    regulation: oX,
    rss: pX,
    search: qX,
    settings: xX,
    "share-filled": AX,
    share: NX,
    "shopping-bag": HX,
    "solid-arrow": GX,
    "sort-carets": ZX,
    spinner: nK,
    spreadsheet: aK,
    "star-filled": dK,
    "star-outline": gK,
    tag: MK,
    trash: EK,
    upload: OK,
    "warning-outline": HK,
    "warning-round": GK,
    warning: ZK
  }
}), JK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "180",
  height: "89",
  viewBox: "0 0 180 89"
}, QK = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#BCBEC0" d="M0 32.847s53.008-6.849 54.567-7.128c2.268-.42 4.394-.839 6.236-1.398a38.9 38.9 0 0 0 11.764-5.311c3.402-2.237 6.52-5.452 9.496-9.086 1.984-2.236 3.968-5.172 5.953-8.107V.42q-3.402 5.032-6.803 8.806c-3.119 3.355-6.237 6.15-9.638 8.247-3.402 2.236-7.229 3.774-11.339 4.752-1.842.42-3.827.84-6.094 1.119-1.418.14-2.977.419-4.394.559C49.181 24.182 0 29.353 0 29.353z"></path><path fill="#BCBEC0" d="M71.15 24.042c-3.26 1.956-7.229 3.354-11.339 4.193-1.842.42-3.827.699-6.094.838-1.276.14-2.693.14-3.969.28-.709 0-1.417.14-2.126.14A3109 3109 0 0 0 0 33.966v3.354c15.307-1.817 31.606-3.774 47.764-5.59.708-.14 1.417-.14 2.126-.28 1.275-.14 2.693-.28 3.968-.42 2.268-.28 4.394-.699 6.236-1.118Q66.685 28.444 72 25.3c3.402-2.097 6.378-4.893 9.638-8.387 1.984-2.236 4.252-5.312 6.378-8.107V7.688c-2.551 3.354-4.82 6.15-7.229 8.526a43.9 43.9 0 0 1-9.637 7.828"></path><path fill="#BCBEC0" d="M80.504 23.203c-3.26 2.935-6.661 5.311-10.063 6.849-3.402 1.677-7.087 2.795-11.48 3.494-1.843.28-3.827.56-5.953.7L0 38.577v3.355L47.055 36.9l6.095-.699c2.267-.28 4.252-.559 6.094-.839 4.536-.838 8.362-2.096 11.906-3.913 3.543-1.817 7.086-4.753 10.346-7.828 2.268-2.096 4.394-4.752 6.661-7.687v-1.119c-2.692 3.355-5.244 6.01-7.653 8.387"></path><path fill="#BCBEC0" d="M67.606 40.815c-3.118 1.677-5.386 2.655-9.78 3.215-2.692.28-5.385.419-8.078.559-1.276 0-2.551.14-3.827.14-7.937.419-15.874.978-23.81 1.537L0 47.804v3.354l22.394-2.096c7.228-.7 15.59-1.398 23.81-2.097l5.953-.42c2.268-.14 4.252-.419 5.953-.559 4.536-.559 8.362-1.537 11.764-2.795 3.685-1.398 7.228-3.495 10.63-6.01 3.118-2.237 7.512-6.71 7.512-6.71v-1.258c-2.835 2.796-4.536 4.333-7.654 6.29-3.543 2.516-9.921 3.774-12.756 5.312"></path><path fill="#BCBEC0" d="M68.74 47.384c-3.401.979-7.086 1.678-11.48 1.957-1.843.14-3.685.28-5.811.42l-5.953.279c-14.74.699-29.339 1.398-45.496 2.236v3.355c15.449-1.118 30.472-2.376 45.638-3.355l5.953-.419c2.267-.14 4.11-.28 5.952-.56 4.536-.558 8.363-1.257 11.764-2.375 3.827-1.258 7.512-2.936 10.913-5.172 2.552-1.677 5.103-3.634 7.796-5.87-2.977 2.515-5.811 3.074-8.504 4.752-3.402 2.096-7.087 3.634-10.772 4.752"></path><path fill="#BCBEC0" d="M68.173 52.975c-3.401.839-6.945 1.258-11.48 1.538-1.7.14-3.543.14-5.811.28l-5.811.14C30.33 55.49 15.307 56.19 0 56.748v3.355c15.165-.979 30.189-2.097 45.213-2.935l5.81-.28c2.268-.14 4.11-.28 5.953-.42 4.536-.419 8.22-.978 11.764-1.956 3.827-.979 7.654-2.376 11.197-4.333 2.693-1.398 5.528-3.215 8.362-5.312V43.47c-3.118 2.237-5.953 4.054-8.929 5.452-3.685 1.957-7.37 3.215-11.197 4.053"></path><path fill="#BCBEC0" d="M67.748 58.566c-3.402.56-6.945.979-11.48 1.258-1.701.14-3.402.14-5.811.14L0 61.362v3.354l44.787-2.376 5.811-.28c2.268-.14 4.11-.279 5.811-.279 4.536-.28 8.22-.838 11.622-1.537 3.969-.839 7.654-1.957 11.34-3.495 2.834-1.258 5.81-2.656 8.786-4.473V50.88c-3.26 1.817-6.236 3.354-9.212 4.472-3.685 1.398-7.37 2.516-11.197 3.215"></path><path fill="#BCBEC0" d="M67.323 64.157c-6.236.839-12.614.979-18.709.979-1.417 0-2.834 0-4.252.14L0 65.974v3.355l44.362-1.957c1.418 0 2.835-.14 4.252-.14 6.236-.28 12.614-.559 18.992-1.537a58.4 58.4 0 0 0 11.339-2.796c2.976-.978 5.953-2.236 9.07-3.774v-1.258c-3.26 1.538-6.519 2.796-9.495 3.635-3.544 1.258-7.229 2.096-11.197 2.655m-.283 5.591c-5.812.42-11.764.42-17.434.42H44.22c-14.74 0-29.338.14-44.078.28v3.354c14.173-.42 29.197-.979 44.22-1.398 1.843 0 3.544-.14 5.386-.14 5.811-.14 11.764-.28 17.575-.978 4.11-.42 7.795-1.118 11.338-1.957 3.119-.699 6.378-1.817 9.496-2.935v-1.258c-3.26 1.118-6.66 2.096-9.779 2.795-3.685.979-7.37 1.538-11.339 1.817m-.283 5.452c-2.41.14-5.102.14-8.079.14h-3.401l-11.339-.14c-7.795 0-15.59-.14-22.819-.14L0 75.2v3.354l21.118-.559c7.228-.14 15.024-.42 22.819-.559l11.48-.14c3.118 0 7.229-.14 11.48-.419 4.11-.28 7.796-.699 11.481-1.258q4.89-.84 9.78-2.097v-1.258c-3.402.839-6.804 1.398-10.064 1.817-3.543.7-7.228.979-11.338 1.119m-11.48 5.451-11.339-.14c-14.598-.28-29.055-.559-43.937-.838v3.354c14.173-.14 29.055-.14 43.937-.42l11.339-.139c3.826 0 7.653-.14 11.338-.28 7.795-.279 14.882-.838 21.402-1.677v-1.118c-6.52.699-13.607 1.118-21.402 1.118-3.827.14-7.512.14-11.338.14m32.74 6.235L0 84.65v3.355h88.016zM80.22 29.493c-3.401 2.656-5.952 4.612-10.063 6.15-3.543 1.398-7.37 1.957-11.763 2.516-2.835.42-5.811.978-8.504 1.118-1.134.14-2.268.14-3.402.28L0 43.05v3.355l46.488-4.473 6.095-.56c2.267-.279 4.252-.419 6.094-.698 4.536-.699 8.362-1.817 11.906-3.355 3.543-1.537 7.228-4.193 10.63-6.989 2.267-1.956 4.535-4.333 6.944-6.988v-1.258c-2.976 3.075-5.385 5.45-7.937 7.408M125.575.56s15.874 24.88 18.708 29.492c2.835 4.613 6.237 8.107 18 10.623a3924 3924 0 0 1 16.867 3.634v.839s-7.512-1.538-17.008-3.634c-9.638-2.097-13.465-2.796-17.859-8.806-3.685-5.032-18.566-26.139-18.566-26.139V.56zm0 28.513s14.456 14.957 18.567 19.15c4.393 4.473 10.063 6.29 18 7.548a3835 3835 0 0 0 17.008 2.795v.839s-8.93-1.398-17.008-2.796c-7.937-1.397-13.465-2.096-18-6.15-4.11-3.634-18.567-17.052-18.567-17.052z"></path><path fill="#BCBEC0" d="M125.575 35.783s13.748 12.58 18.567 16.913c4.535 3.913 8.078 5.171 18 6.849a2416 2416 0 0 0 16.866 2.795v.839s-8.93-1.398-17.008-2.656c-8.079-1.258-13.181-1.817-18-5.59-5.528-4.474-18.567-15.097-18.567-15.097v-4.053z"></path><path fill="#BCBEC0" d="M125.575 42.911s15.732 12.3 18.567 14.397c2.976 2.097 6.803 4.613 18 6.29 11.197 1.538 16.866 2.376 16.866 2.376v.979s-10.063-1.398-16.866-2.237c-6.803-.838-11.906-1.258-18-5.171-5.953-3.914-18.709-12.72-18.709-12.72v-3.914z"></path><path fill="#BCBEC0" d="M125.575 49.76s15.732 10.344 18.708 12.021c2.977 1.677 6.52 4.333 18 5.731a2444 2444 0 0 1 16.867 2.097v.838s-9.496-.978-16.867-1.817c-7.37-.838-12.472-1.817-18-4.892-5.527-2.935-18.566-10.483-18.566-10.483V49.76z"></path><path fill="#BCBEC0" d="M125.575 56.75s13.89 7.407 18.567 9.784c5.244 2.655 9.78 3.774 18 4.752 8.078.978 16.866 1.817 16.866 1.817v.839s-8.22-.839-16.866-1.678c-8.646-.838-11.764-1.118-18-3.913a7510 7510 0 0 0-18.567-8.387z"></path><path fill="#BCBEC0" d="M125.575 63.738s10.913 4.613 18.708 7.688c7.654 2.935 13.323 3.215 18 3.774 1.985.28 16.867 1.677 16.867 1.677v.839s-8.788-.7-16.867-1.398c-8.078-.699-11.48-.979-18-3.075s-18.708-6.29-18.708-6.29zm0 6.989s11.055 3.354 18.708 5.311c7.512 1.957 14.457 2.796 18 2.936 3.544.28 16.867 1.258 16.867 1.258v.838s-7.654-.559-16.867-1.118c-7.511-.559-13.606-1.118-18-2.097-4.96-1.118-18.566-4.333-18.566-4.333v-2.795zm0 7.128s9.07 1.538 18.708 3.076c7.229 1.118 16.867 1.956 18 1.956.993 0 16.867 1.119 16.867 1.119v.838s-10.205-.559-16.867-.838c-7.086-.42-14.031-.84-18-1.258-8.929-.979-18.566-2.097-18.566-2.097v-2.796zm0 7.495s14.315.56 18.708.56c4.394.139 34.867 1.257 34.867 1.257v.839h-53.575zm36.567-40.761c-12.898-2.796-15.874-7.408-18-10.344S125.575 7.688 125.575 7.688v5.311c.708.839 14.598 18.87 18.567 23.902 4.393 5.591 11.338 6.849 18 8.247 6.661 1.398 16.866 3.354 16.866 3.354v-.698c.142.14-13.465-2.516-16.866-3.215"></path><path fill="#BCBEC0" d="M162.142 48.223c-10.63-2.097-14.882-5.312-18-9.365a30939 30939 0 0 0-18.567-24.042v5.032c.708.7 14.74 17.333 18.567 21.526 4.393 5.032 10.63 6.29 18 7.688 7.512 1.397 16.866 3.075 16.866 3.075v-.7c.142 0-10.772-1.956-16.866-3.214"></path><path fill="#BCBEC0" d="M162.142 52.137c-11.055-2.097-13.323-3.914-18-8.946-2.977-3.215-18-20.687-18.567-21.386v4.753s14.031 14.816 18.567 19.149c5.952 5.73 11.48 6.15 18 7.268s16.866 3.075 16.866 3.075v-.838c.142 0-12.473-2.237-16.866-3.075"></path><path fill="#004494" d="M36.567 37.12h77.102v50.879H36.567z"></path><path fill="#FAEA27" d="M75.969 44.17h2.692l-2.126 1.537.85 2.656-2.125-1.538-2.126 1.538.85-2.656-2.267-1.538h2.692l.85-2.655zm.141 33.825h2.693l-2.126 1.678.85 2.516-2.125-1.538-2.268 1.538.85-2.516-2.126-1.678h2.693l.85-2.376zm8.504-2.236h2.693l-2.126 1.677.85 2.516-2.125-1.537-2.268 1.537.85-2.516-2.126-1.677h2.693l.85-2.376zm0-29.353h2.693l-2.126 1.537.85 2.516-2.125-1.537-2.268 1.537.85-2.516-2.126-1.537h2.693l.85-2.516zm6.378 6.15h2.693l-2.268 1.677.85 2.516-2.125-1.537-2.126 1.537.85-2.516-2.126-1.677h2.551l.85-2.376zm0 17.053h2.693l-2.268 1.677.85 2.516-2.125-1.538-2.126 1.538.85-2.516-2.126-1.677h2.551l.85-2.377zm2.41-8.666h2.692l-2.267 1.677.85 2.516-2.126-1.538-2.126 1.538.85-2.516-2.267-1.677H91.7l.85-2.377zM67.323 46.406h2.693l-2.126 1.537.85 2.656-2.126-1.677-2.268 1.677.85-2.656-2.125-1.537h2.693l.85-2.516zm-6.095 6.29h2.693l-2.126 1.537.709 2.516-2.126-1.537-2.126 1.537.85-2.516-2.126-1.537h2.693l.709-2.516zm-2.268 8.386h2.694l-2.268 1.538.85 2.516-2.126-1.538-2.126 1.538.85-2.516-2.125-1.538h2.55l.851-2.516zm2.268 8.666h2.693l-2.126 1.538.709 2.516-2.126-1.538-2.126 1.538.85-2.516-2.126-1.538h2.693l.709-2.516zm6.237 6.151h2.692l-2.126 1.537.71 2.516-2.127-1.537-2.126 1.537.85-2.516-2.125-1.537h2.693l.708-2.516z"></path></g>', 1), eZ = [
  QK
];
function tZ(t, e) {
  return T(), N("svg", JK, [...eZ]);
}
const nZ = { render: tZ }, iZ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, sZ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M155 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4-.5 0-37.5 3.9-37.5 3.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="155" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 5.2h66.1V28H155z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M208.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="155" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 10.9h66.1v20.6H155z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M215.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L155 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="155" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 21.7h66.2v16.8H155z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M205.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L155 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M206.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M206.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="155" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 38.2h66.2v10.6H155z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M205.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2l-37.9 1v2.6l33.6-1.8 4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M205.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1l-33.2.6v2.6l33.3-1.4c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="155" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 49.2h66.2v6.6H155z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M205.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M205.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1l-15.8.1v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101c-10.9-.2-21.8-.399-32.9-.599v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L155 63.8v2.6h66.1zM215.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L155 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34.001-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.201 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.201 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.201 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M276.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M276.701 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" d="M182.5 66.3h57.9V27.6h-57.9z" clip-rule="evenodd"></path><path fill="#FFF100" fill-rule="evenodd" d="M212.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L209.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.401-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm-.001-22.4h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.801-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zm-19.6-11.2h2l-1.6 1.2.6 1.901-1.5-1.101-1.7 1.2.6-1.9-1.6-1.2h2l.7-1.9zm-4.602 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM199.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L196 46h2l.6-1.9zm1.699 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.701 4.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" d="M74 66.7h3.3V28H74z" clip-rule="evenodd"></path><path fill="#626366" d="M93.602 39.031q0 .195-.02.332a1.7 1.7 0 0 1-.098.342q-.547-1.221-1.62-2.52-1.192-1.435-1.876-1.435-.146 0-.293.254-.146.254-.341.254-.264 0-.83-.342a4 4 0 0 1-1.143-.996q-.576-.762-.576-1.621 0-.615.4-.615.703 0 2.197.888 1.67.987 2.803 2.305 1.397 1.611 1.397 3.154m4.042 5.108h-.595q-.82 0-1.319-.889-.595-1.074-.595-3.252 0-.156-.04-.42a4 4 0 0 1-.029-.332q-.937 2.608-1.67 3.574-.869 1.133-2.45 1.504-1.35.313-4.59.313v-.274q2.626-.79 3.916-1.367 2.08-.918 3.154-2.119 1.299-1.446 1.299-3.428 0-.956-.127-1.787a17 17 0 0 0-.332-1.7l.322-.82q.195-.478.361-.81.255 1.407.479 3.037.156 1.124.303 2.412.184 1.582.322 2.55.176 1.23.527 1.757.234.352.469.352h.595z"></path><path fill="#626366" d="M105.525 44.139h-1.015q-.654 0-1.475-.293a5.6 5.6 0 0 1-1.67-.938q-.566.694-1.162.967-.585.264-1.719.264h-1.523v-1.7h1.494q.89 0 1.582-.449.537-.351.977-.986a6.2 6.2 0 0 1 1.465-1.494q.78-.567 1.435-.723.674 1.026 1.074 1.846.537 1.113.537 1.806zm-1.123-1.924a5 5 0 0 0-.39-1.113 6 6 0 0 0-.596-.948 1.67 1.67 0 0 0-.791.44q-.215.205-.508.693.352.381.987.684.644.303 1.21.37z"></path><path fill="#626366" d="m109.588 33.318-.752 1.426-1.572-.84.722-1.426zm1.299 10.82h-6.035V42.44h5.205q0-.87-.205-1.631-.508.165-.782.234a3.2 3.2 0 0 1-.791.117q-.712 0-1.162-.361-.517-.41-.517-1.182 0-1.358.488-2.373.547-1.133 1.426-1.133 1.191 0 1.836 1.866.537 1.542.537 3.623zm-1.592-5.078a2.6 2.6 0 0 0-.44-.712q-.41-.489-.781-.489a.54.54 0 0 0-.439.225.82.82 0 0 0-.166.518q0 .78.859.78.225 0 .479-.087.254-.088.488-.235m10.234 4.493q0 1.611-1.191 3.203-1.329 1.777-3.067 1.777-.644 0-1.328-.146a13 13 0 0 1-1.298-.371q-.636-.225-1.27-.44l.166-.342 1.143.264q.605.147 1.084.147a4.5 4.5 0 0 0 2.255-.606q.83-.478 1.661-1.387.42-.459 1.191-1.494-1.318 0-1.973-.42-.741-.479-.742-1.572 0-1.005.469-1.865.546-.996 1.387-.996.85 0 1.22.986.294.77.293 2.149zm-.615-1.065q-.215-.938-.518-1.298a.81.81 0 0 0-.644-.313.7.7 0 0 0-.479.185.58.58 0 0 0-.195.45q0 .479.43.732.43.244 1.406.244"></path><path fill="#626366" d="m130.252 36.023-.742 1.416-1.582-.82.722-1.426zm6.211 8.116h-11.738q-.528 0-1.006-.176a5 5 0 0 1-.85-.44 2.5 2.5 0 0 1-.82.489q-.41.127-1.309.127h-1.885v-1.7h1.885q.791 0 1.133-.136.567-.225.566-.899 0-.283-.039-.566a7 7 0 0 0-.097-.635l.4-.586q.341 1.33.938 2.051.635.772 1.494.772.82 0 1.924-.372 1.19-.4 2.05-1.015 1.397-.996 1.709-1.192.792-.508 1.436-.722a4.9 4.9 0 0 1 1.582-.245q1.328 0 2.002.772.625.713.625 2.002zm-1.592-2.452q0-.478-.596-.742-.595-.273-1.386-.273-.976 0-2.364.654-1.103.556-2.197 1.114h4.502q1.065 0 1.553-.186t.488-.566"></path><path fill="#626366" d="M141.355 44.139h-5.566v-1.7h4.854q0-1.152-.274-1.757-.186-.42-.918-1.211l.762-1.592q.703.889.879 1.387.263.75.263 2.49zm-.048 1.953-.762 1.406-1.582-.84.732-1.396zm-2.246.879-.743 1.416-1.582-.82.723-1.417zm6.865-11.953-.762 1.406-1.582-.84.732-1.397zm-2.246.879-.742 1.416-1.583-.82.723-1.417zm3.105 5.36q0 1.378-.449 2.071-.694 1.074-2.539 1.074-.713 0-1.182-.283-.537-.322-.537-.918 0-.684.342-1.582.312-.762.635-1.533l-.147-.04.596-1.65q1.767.929 2.109 1.172 1.173.82 1.172 1.69m-.849.763q0-.372-1.075-.987a15 15 0 0 0-.986-.517q-.44.478-.527.595-.274.381-.274.723 0 .498.274.781.282.273.752.274.546 0 1.191-.303.645-.312.645-.566M99.617 53.816l-.469 1.758-.576-.283.02.889q0 1.308-.332 2.539-.361 1.347-1.143 2.666.371.684.518 1.074.225.615.224 1.25 0 .36-.02.615a5 5 0 0 1-.087.596q-1.036.234-2.217.371-1.172.127-2.285.127.01-.186.01-.312.048-.742.234-1.377a9 9 0 0 0 2.803-2.305 61 61 0 0 0-.996-1.826q-.342-.587-1.162-1.826a7 7 0 0 0-.537-.674q-.323-.342-.508-.342-.127 0-.42.146a.6.6 0 0 1-.264.078q-.215 0-.674-.43a9 9 0 0 1-.84-.937q-.35-.45-.478-.742a1.9 1.9 0 0 1-.127-.723q0-.605.078-.947.118-.517.4-.517.4 0 1.163.761.673.684 1.504 1.797.732.986 1.445 2.13l.996 1.6q.44.724.898 1.641a10 10 0 0 0 .899-2.666q.215-1.172.215-2.988l-.557-.322q0-.645.108-1.162.117-.528.322-.957l.224.058q.04.42.47.674.233.136.595.313.37.175.566.253m-2.539 9.502a1.2 1.2 0 0 0-.088-.44q-.078-.234-.361-.76-.292.38-.879.878a9 9 0 0 1-1.143.85q1.154 0 1.641-.069.83-.116.83-.459m6.856-12.314q0 .245-.303.44a3.4 3.4 0 0 1-.615.273l-1.817.625q0-.45.977-.791a2 2 0 0 1-.459-.303q-.205-.186-.205-.39 0-.303.517-.85.576-.606 1.016-.606.195 0 .332.137a.43.43 0 0 1 .146.342.8.8 0 0 1-.058.283 3 3 0 0 1-.166.313q-.303-.274-.654-.274-.216 0-.43.088-.205.088-.205.205 0 .147.449.4.459.255.781.254.215 0 .303-.01.097-.019.391-.136m-.274 10.644q0 .782-.283 1.514-.146.39-.635 1.24l-.176-.097q.03-.284.049-.655.03-.37.03-.498 0-1.015-.166-2.832a146 146 0 0 0-.381-3.808q-.136-1.201-.303-2.452.195-.429.439-.927l.479-.938q.156 1.113.391 3.047.243 1.934.38 3.486.177 1.935.176 2.92m9.483 1.905q0 1.611-1.192 3.203-1.327 1.777-3.066 1.777a6.3 6.3 0 0 1-1.328-.146 13 13 0 0 1-1.299-.371q-.635-.225-1.27-.44l.166-.342 1.143.264q.606.147 1.084.146 1.191 0 2.256-.605.83-.478 1.66-1.387.42-.459 1.191-1.494-1.318 0-1.972-.42-.743-.479-.743-1.572 0-1.005.469-1.865.547-.996 1.387-.996.849 0 1.221.986.293.77.293 2.149zm-.616-1.065q-.214-.938-.517-1.298a.81.81 0 0 0-.645-.313.7.7 0 0 0-.478.185.58.58 0 0 0-.196.45q0 .479.43.732.43.244 1.406.244m10.401 1.651q0 1.074-.918 2.226a7.5 7.5 0 0 1-1.992 1.748q-1.133.703-1.866.703-.673 0-1.455-.195-.595-.146-1.426-.459l-1.396-.527.166-.39q.645.126 1.338.253a6.7 6.7 0 0 0 1.269.137q1.25 0 2.608-.801a7.5 7.5 0 0 0 2.099-1.846q.87-1.122.87-2.021 0-.772-.45-1.621-.36-.684-1.015-1.406l.556-1.534q.801.743 1.182 1.485.43.84.43 1.875zm8.652-.586q0 1.611-1.191 3.203-1.329 1.777-3.067 1.777-.644 0-1.328-.146a13 13 0 0 1-1.299-.371q-.635-.225-1.269-.44l.166-.342 1.142.264q.606.147 1.084.146a4.5 4.5 0 0 0 2.256-.605q.83-.478 1.66-1.387.42-.459 1.192-1.494-1.319 0-1.973-.42-.742-.479-.742-1.572 0-1.005.469-1.865.547-.996 1.386-.996.85 0 1.221.986.293.77.293 2.149zm-.615-1.065q-.215-.938-.518-1.298a.81.81 0 0 0-.644-.313.7.7 0 0 0-.479.185.58.58 0 0 0-.195.45q0 .479.43.732.43.244 1.406.244"></path><path fill="#626366" d="M136.473 64.139h-5.567v-1.7h4.854q0-1.152-.274-1.757-.185-.42-.918-1.211l.762-1.592q.703.889.879 1.387.264.75.264 2.49zm-.996 2.373-.762 1.416-1.582-.82.722-1.426z"></path><path fill="#626366" d="M141.355 64.139h-5.566v-1.7h4.854q0-1.152-.274-1.757-.186-.42-.918-1.211l.762-1.592q.703.889.879 1.387.263.75.263 2.49zm-.048 1.953-.762 1.406-1.582-.84.732-1.396zm-2.246.879-.743 1.416-1.582-.82.723-1.417zm6.865-11.953-.762 1.406-1.582-.84.732-1.397zm-2.246.879-.742 1.416-1.583-.82.723-1.417zm3.105 5.36q0 1.378-.449 2.071-.694 1.074-2.539 1.074-.713 0-1.182-.283-.537-.322-.537-.918 0-.684.342-1.582.312-.762.635-1.533l-.147-.04.596-1.65q1.767.929 2.109 1.172 1.173.82 1.172 1.69m-.849.763q0-.372-1.075-.987a15 15 0 0 0-.986-.517q-.44.478-.527.595-.274.381-.274.723 0 .498.274.781.282.273.752.274.546 0 1.191-.303.645-.312.645-.566"></path>', 32), lZ = [
  sZ
];
function rZ(t, e) {
  return T(), N("svg", iZ, [...lZ]);
}
const aZ = { render: rZ }, oZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  style: { "enable-background": "new 0 0 290 72" },
  version: "1.1",
  viewBox: "0 0 290 72"
}, cZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><defs><filter id="Adobe_OpacityMaskFilter" width="134.4" height="66.3" x="0" y="0" filterUnits="userSpaceOnUse"><feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"></feColorMatrix></filter></defs><mask id="mask-4" width="134.4" height="66.3" x="0" y="0" maskUnits="userSpaceOnUse"><g style="filter:url(#Adobe_OpacityMaskFilter);"><path id="path-3" d="M0 0h253.5v66.5H0z" style="fill:#fff;"></path></g></mask><g id="Group-18-Copy" style="mask:url(#mask-4);"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st3"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st3"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st3"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st3"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st3"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st3"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st3"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st3"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st3"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st3"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st3"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st3"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st3"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st3"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13v-3.4z" class="st3"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st3"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st3"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st3"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st3"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8V48z" class="st3"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st3"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st3"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st3"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st3"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st3"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st3"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st4"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st5"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st5"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st5"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st5"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st5"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st5"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st5"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st5"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st5"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st5"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st5"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st5"></path></g></g></g></g></g></g><path d="M143.4 33.7c0-.3.1-.4.4-.4h7.1c.2 0 .4.1.4.4v1.2c0 .2-.1.3-.4.3h-5.2v3.3h4.6c.3 0 .4.1.4.3V40c0 .2-.1.3-.4.3h-4.6v3.8h5.4c.2 0 .3.1.3.4v1.2c0 .2-.1.3-.4.3h-7.2c-.3 0-.4-.1-.4-.3zm10.2 12.4c-.2 0-.3 0-.4-.1s-.1-.2-.1-.3V37c0-.1 0-.2.1-.3s.2-.1.3-.1h4.1c1.1 0 1.9.2 2.4.7s.8 1.1.8 1.9c0 .3-.1.6-.2.9q-.15.6-.9.9c.3.1.5.3.7.5s.3.4.4.6.2.4.2.6.1.4.1.6q0 .6-.3 1.2c-.3.6-.4.6-.7.9-.3.2-.6.4-1 .6-.4.1-.8.2-1.2.2h-4.3zm5.1-6.7c0-.1 0-.2-.1-.4s-.1-.2-.2-.3-.2-.2-.4-.2c-.2-.1-.4-.1-.6-.1h-2.2v2.1h2.3q.6 0 .9-.3c.3-.3.3-.6.3-.8m.3 3.7c0-.3-.1-.6-.3-.8s-.5-.4-1-.4h-2.5v2.4h2.2c.3 0 .6 0 .8-.1s.4-.2.5-.3.2-.2.2-.4c.1-.1.1-.2.1-.4m12.2-1.8c0 .8-.1 1.5-.2 2.1s-.3 1.1-.6 1.6c-.3.4-.7.7-1.2 1-.5.2-1.1.3-1.9.3-.3 0-.7 0-1.1-.1s-.8-.2-1.3-.3v3.4c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V37c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4s.5-.3.8-.4.5-.2.8-.3.6-.1.8-.1c.6 0 1.1.1 1.6.3.4.2.7.6 1 1 .2.4.4.9.5 1.5s.1 1.4.1 2.1m-2.2 0c0-.6 0-1.1-.1-1.5q-.15-.6-.3-.9c-.1-.2-.3-.3-.5-.4s-.4-.1-.7-.1c-.2 0-.4 0-.7.1-.2.1-.5.1-.7.2s-.5.2-.7.3-.4.2-.5.3v4.8l1.2.3c.4 0 .7.1 1 .1s.6 0 .9-.1c.2-.1.4-.3.6-.5.1-.2.3-.6.3-1 .2-.5.2-1 .2-1.6m12.1-.1c0 .5 0 1.1-.1 1.7s-.2 1.1-.5 1.6-.7.9-1.3 1.2-1.3.5-2.3.5-1.7-.2-2.3-.5-1-.7-1.2-1.2-.4-1-.5-1.6-.1-1.2-.1-1.7c0-.4 0-.9.1-1.5.1-.5.3-1.1.5-1.5q.45-.75 1.2-1.2c.5-.3 1.3-.5 2.2-.5s1.7.1 2.2.4 1 .6 1.3 1.1q.45.75.6 1.5c.1.6.2 1.1.2 1.7m-2.2.1c0-.5 0-1-.1-1.3s-.2-.7-.3-.9l-.6-.6c-.3-.1-.6-.2-1.1-.2-.4 0-.7.1-1 .2q-.45.15-.6.6c-.1.3-.2.6-.3 1s-.1.8-.1 1.3 0 1 .1 1.3.2.7.3.9q.15.3.6.6c.45.3.6.2 1 .2s.8-.1 1.1-.2q.45-.15.6-.6c.2-.2.3-.6.3-1 .1-.3.1-.8.1-1.3m12.3 4.4c0 .2-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-7.3h-4v7.3c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.2 0-.4-.1-.4-.4V37c0-.2.1-.4.4-.4h7.5c.1 0 .2 0 .3.1s.1.1.1.3v8.7zm4-3.8c0 .5.1.9.2 1.2s.2.6.4.8.4.3.7.4.6.1 1 .1c.3 0 .8 0 1.2-.1.5-.1.9-.1 1.3-.1h.4c.1 0 .1.1.1.3l.1.6v.3c0 .1-.1.2-.3.2-.2.1-.4.1-.7.2s-.5.1-.8.1-.6.1-.8.1h-.8c-.9 0-1.7-.1-2.2-.4-.6-.3-1-.6-1.3-1.1-.3-.4-.5-1-.6-1.5-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.5-1.6c.3-.5.7-.9 1.2-1.3.5-.3 1.3-.5 2.2-.5s1.6.1 2.1.4.9.6 1.2 1 .5.9.6 1.4.2 1 .2 1.5c0 .3 0 .6-.2.8-.1.2-.4.3-.8.3h-4.9zm1.9-3.7c-.4 0-.7.1-.9.2s-.4.2-.6.4c-.1.2-.3.4-.3.7-.1.3-.1.6-.1 1h3.8c0-.3 0-.6-.1-.8-.1-.3-.1-.5-.3-.7-.1-.2-.3-.4-.6-.5q-.3-.3-.9-.3m5.8-1.1c0-.1 0-.2.1-.3s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1s.1.2.1.3v5.6l2.5-3.4 1.7-2.3.2-.2c.1-.1.2-.1.4-.1h1c.2 0 .3 0 .3.1.1.1.1.2.1.3v8.6c0 .3-.1.4-.4.4h-1.2c-.3 0-.4-.1-.4-.4v-5.9c-.4.6-.9 1.2-1.3 1.8s-.9 1.2-1.3 1.8c-.3.4-.6.8-.8 1.1-.3.4-.6.8-.9 1.1-.1.1-.2.2-.3.2-.1.1-.2.1-.4.1h-.8c-.2 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.3zm4.2-1.3c-.6 0-1.2-.2-1.8-.5s-1-.8-1.4-1.5c-.1-.1-.1-.2-.1-.3s0-.2.1-.3l.5-.4c.1-.1.2-.1.3-.1s.1.1.2.2c.4.5.7.8 1 1q.45.3 1.2.3c.2 0 .4 0 .6-.1s.3-.1.5-.2.3-.3.5-.4l.6-.6c.2-.2.3-.2.5-.1l.5.3c.1.1.2.2.1.3s-.1.2-.1.4c-.3.7-.8 1.2-1.3 1.5-.6.3-1.2.5-1.9.5m13.4 9.4v.3c0 .1-.1.2-.3.2-.4.2-.8.3-1.4.3-.6.1-1.1.1-1.5.1-.9 0-1.6-.1-2.2-.4-.5-.3-1-.6-1.2-1.1-.3-.4-.5-1-.6-1.6s-.1-1.2-.1-1.9c0-.6 0-1.2.1-1.8s.3-1.1.6-1.6.7-.8 1.2-1.1 1.3-.4 2.1-.4h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.2.1.5.1.7.2s.3.3.3.5l-.1.8c0 .1-.1.2-.2.2h-.4c-.4 0-.8-.1-1.2-.1s-.8-.1-1.1-.1c-.8 0-1.3.2-1.6.7-.3.4-.5 1.2-.5 2.3 0 .6 0 1.1.1 1.5s.2.7.4 1c.2.2.4.4.6.5.3.1.6.1 1 .1h1.2c.5 0 .9-.1 1.3-.1h.3c.1 0 .1.1.2.3zm3.5.5c0 .1 0 .2-.1.2 0 .1-.1.1-.3.1h-1.4q-.3 0-.3-.3V37q0-.3.3-.3h1.4c.1 0 .2 0 .3.1 0 .1.1.1.1.3v3.4h1.5c.2 0 .3-.1.4-.2s.3-.2.4-.4.2-.4.4-.7l.8-2.1c.1-.1.1-.2.2-.2s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1v.3l-.7 2c-.2.6-.4 1.1-.7 1.4s-.5.6-.9.7c.4.2.8.4 1 .7s.4.7.6 1.2l.8 2.6v.3c0 .1-.1.1-.3.1H228c-.1 0-.3 0-.3-.1s-.1-.1-.2-.2l-.7-2.2c-.2-.6-.5-1-.8-1.2s-.7-.3-1-.3h-1zm13.2-.7c-.5.4-1 .7-1.6.9s-1.2.3-1.9.3c-.5 0-.9-.1-1.3-.2-.3-.1-.6-.3-.8-.6-.2-.2-.3-.5-.4-.9-.1-.3-.1-.7-.1-1.1q0-1.65.9-2.4c.9-.75 1.5-.8 2.7-.8h2.5v-.5c0-.3 0-.5-.1-.7s-.2-.4-.3-.5-.4-.2-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.6.1h-.4c-.1 0-.1-.1-.1-.2l-.2-.7v-.3c.1-.1.2-.2.4-.3s.4-.1.7-.2.6-.1.9-.1.6-.1.9-.1h.8c.8 0 1.5.1 2 .2.5.2.9.4 1.1.7.3.3.4.7.5 1.1s.1.9.1 1.5v4.2c0 .1.1.2.1.2 0 .1.1.1.2.1s.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.4c-.4 0-.8-.1-1.1-.2s-.6-.5-.7-.9m-.1-3.2h-2.3q-.75 0-1.2.3c-.3.2-.4.6-.4 1.3q0 .6.3.9c.3.3.5.2.9.2.2 0 .4 0 .7-.1s.5-.1.7-.2.5-.2.7-.3l.6-.3zm-92 24.2c0 .1 0 .2-.1.2 0 .1-.1.1-.3.1h-1.4q-.3 0-.3-.3v-8.7q0-.3.3-.3h1.4c.1 0 .2 0 .3.1 0 .1.1.1.1.3v3.4h1.5c.2 0 .3-.1.4-.2s.3-.2.4-.4.2-.4.4-.7l.8-2.1c.1-.1.1-.2.2-.2s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1v.3l-.7 2c-.2.6-.4 1.1-.7 1.4s-.5.6-.9.7c.4.2.8.4 1 .7s.4.7.6 1.2l.8 2.6v.3c0 .1-.1.1-.3.1h-1.3c-.1 0-.3 0-.3-.1s-.1-.1-.2-.2l-.7-2.2c-.2-.6-.5-1-.8-1.2s-.7-.3-1-.3h-1zm15.4-4.5c0 .5 0 1.1-.1 1.7s-.2 1.1-.5 1.6-.7.9-1.3 1.2-1.3.5-2.3.5-1.7-.2-2.3-.5-1-.7-1.2-1.2-.4-1-.5-1.6-.1-1.2-.1-1.7c0-.4 0-.9.1-1.5.1-.5.3-1.1.5-1.5q.45-.75 1.2-1.2c.5-.3 1.3-.5 2.2-.5s1.7.1 2.2.4 1 .6 1.3 1.1q.45.75.6 1.5c.2.6.2 1.1.2 1.7m-2.1.1c0-.5 0-1-.1-1.3s-.2-.7-.3-.9l-.6-.6c-.3-.1-.6-.2-1.1-.2-.4 0-.7.1-1 .2q-.45.15-.6.6c-.1.3-.2.6-.3 1s-.1.8-.1 1.3 0 1 .1 1.3.2.7.3.9q.15.3.6.6c.45.3.6.2 1 .2s.8-.1 1.1-.2q.45-.15.6-.6c.2-.2.3-.6.3-1 .1-.3.1-.8.1-1.3m11.8-.7-.8 1.6c-.2.3-.4.7-.5 1-.2.3-.4.7-.6 1.1q-.15.3-.6.3h-.7c-.2 0-.3 0-.4-.1l-.2-.2c-.2-.3-.4-.6-.5-.9-.2-.3-.3-.6-.5-.9s-.3-.6-.5-1c-.2-.3-.3-.7-.5-1v5c0 .3-.1.4-.4.4h-1.2c-.3 0-.4-.1-.4-.4v-8.6c0-.3.1-.4.4-.4h1.1c.2 0 .3 0 .4.1s.2.1.2.2c.2.4.4.7.6 1.1s.4.7.6 1.1c.3.5.6 1.1.8 1.6.3.5.5 1 .8 1.6l1.5-2.8 1.4-2.5c.1-.1.1-.2.2-.3s.2-.1.4-.1h1c.3 0 .4.1.4.4V66c0 .3-.1.4-.4.4h-1.2c-.3 0-.4-.1-.4-.4zm4.1-3.5c0-.1 0-.2.1-.3s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1s.1.2.1.3V63l2.5-3.4 1.7-2.3.2-.2c.1-.1.2-.1.4-.1h1c.2 0 .3 0 .3.1.1.1.1.2.1.3V66c0 .3-.1.4-.4.4H181c-.3 0-.4-.1-.4-.4v-5.9c-.4.6-.9 1.2-1.3 1.8s-.9 1.2-1.3 1.8c-.3.4-.6.8-.8 1.1-.3.4-.6.8-.9 1.1-.1.1-.2.2-.3.2-.1.1-.2.1-.4.1h-.8c-.2 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.3v-8.4zm17.6 8.1v.3c0 .1-.1.2-.3.2-.4.2-.8.3-1.4.3-.6.1-1.1.1-1.5.1-.9 0-1.6-.1-2.2-.4-.5-.3-1-.6-1.2-1.1-.3-.4-.5-1-.6-1.6s-.1-1.2-.1-1.9c0-.6 0-1.2.1-1.8s.3-1.1.6-1.6.7-.8 1.2-1.1 1.3-.4 2.1-.4h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.2.1.5.1.7.2s.3.3.3.5l-.1.8c0 .1-.1.2-.2.2h-.4c-.4 0-.8-.1-1.2-.1s-.8-.1-1.1-.1c-.8 0-1.3.2-1.6.7-.3.4-.5 1.2-.5 2.3 0 .6 0 1.1.1 1.5s.2.7.4 1c.2.2.4.4.6.5.3.1.6.1 1 .1h1.2c.5 0 .9-.1 1.3-.1h.3c.1 0 .1.1.2.3zm1.4-8.1c0-.1 0-.2.1-.3s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1s.1.2.1.3V63l2.5-3.4 1.7-2.3.2-.2c.1-.1.2-.1.4-.1h1c.2 0 .3 0 .3.1.1.1.1.2.1.3V66c0 .3-.1.4-.4.4H200c-.3 0-.4-.1-.4-.4v-5.9c-.4.6-.9 1.2-1.3 1.8s-.9 1.2-1.3 1.8c-.3.4-.6.8-.8 1.1-.3.4-.6.8-.9 1.1-.1.1-.2.2-.3.2-.1.1-.2.1-.4.1h-.8c-.2 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.3v-8.4zm17.8-.5c.2 0 .3 0 .4.1s.1.2.1.3v8.6c0 .3-.2.4-.5.4h-1.2c-.2 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.3v-3.3h-1.9c-.3 0-.6.1-.8.3s-.4.5-.6 1.1l-.6 1.9c-.1.2-.1.3-.2.3s-.2.1-.4.1h-1.3c-.2 0-.3 0-.3-.1v-.3l.7-2.1c.1-.4.3-.7.4-1 .2-.3.4-.5.7-.7-.3-.1-.5-.2-.7-.4s-.3-.4-.4-.6-.2-.4-.2-.7c0-.2-.1-.5-.1-.7 0-.5.1-.9.3-1.3s.4-.7.7-.9.7-.4 1.1-.6.9-.2 1.3-.2h3.9zm-5.3 3q0 .6.3.9c.2.2.6.3 1.1.3h2.2v-2.4h-2.1c-.5 0-.8.1-1.1.3s-.4.5-.4.9" style="fill:#626366;"></path><path d="M249.2 28h3.3v38.7h-3.3z" class="st4"></path>', 3);
function hZ(t, e) {
  return T(), N("svg", oZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st3{fill:#bbbdbf}.st4{fill:#034da1}.st5{fill:#fff100}")
      ]),
      _: 1
    })),
    cZ
  ]);
}
const uZ = { render: hZ }, dZ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, fZ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.901c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.201h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.801-8.6.9-1.3.1-2.6.1-4.3.201l-37.9 1v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.299c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1l-33.2.6v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.201h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.201v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6M94.201 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 26.799s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 32.201s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 42.701s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.301s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.598s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.899c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.701 39.2c-8.3-1.601-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.399 8.6 4.7 13.5 5.6s12.7 2.299 12.7 2.299v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L54.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.901-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.901-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.901-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.901-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.901-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#004494" fill-rule="evenodd" d="M226.4 66.7h3.3V28h-3.3z" clip-rule="evenodd"></path><path fill="#626366" d="M143.24 39.48q0-1.278.2-2.52.201-1.24.78-2.2.6-.979 1.64-1.58 1.06-.6 2.78-.6.36 0 .82.04.48.02.98.1.5.06.98.18.48.102.88.26.24.102.32.24.1.14.06.38l-.18.82a.44.44 0 0 1-.14.26q-.1.081-.38.04a39 39 0 0 0-1.6-.18q-.84-.08-1.62-.08-1.02 0-1.64.38t-.96 1.04q-.32.66-.42 1.54a16 16 0 0 0-.1 1.84q0 .982.12 1.84a4.5 4.5 0 0 0 .46 1.5q.34.62.94.98.62.36 1.6.36.88 0 1.64-.08a97 97 0 0 0 1.58-.18q.28-.04.38.04.1.081.16.28l.16.76q.12.442-.34.64a5 5 0 0 1-.86.28q-.48.101-1 .18a9 9 0 0 1-1 .1q-.48.04-.84.04-1.68 0-2.74-.56a4.5 4.5 0 0 1-1.64-1.52 6.2 6.2 0 0 1-.8-2.14q-.22-1.2-.22-2.48m19.571 1.46q0 .861-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.761-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.499-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.919-.1-1.78 0-.699.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.759 1.28-1.26.86-.52 2.3-.52 1.46.001 2.32.44.88.44 1.34 1.16.459.702.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.798-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2-.4.201-.64.6-.22.4-.32 1a10 10 0 0 0-.08 1.36q0 .8.08 1.4.1.581.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m18.528 4.54q0 .18-.08.28-.06.101-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.119-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1a9 9 0 0 0-.7.24 6 6 0 0 0-.66.28l-.56.28v.42q.02.261.02.6v5.66q0 .18-.08.28t-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36-.28-.439-1.04-.44a2.7 2.7 0 0 0-.6.08q-.32.081-.68.22-.34.141-.68.3-.34.161-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V36.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4a4.7 4.7 0 0 1 .72-.38q.4-.16.8-.26.4-.12.82-.14.861 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.981 0 1.56.3t.88.82q.3.5.38 1.18.08.681.08 1.42zm4.745-12.02q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4.001-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74.001.96.32.22.3.22.82m-.12 12.02q0 .161-.08.28-.06.101-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.379.4-.38h1.42q.22 0 .28.12.08.102.08.26zm9.801-2.56q0 .88-.34 1.48a2.7 2.7 0 0 1-.92.94q-.56.36-1.28.52a7 7 0 0 1-1.5.16q-.76 0-1.64-.12-.88-.098-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.239.16-.28.12-.06.36-.02.32.06.7.1l.78.08.74.04q.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.3 1.3 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.099-1.4-.26a4.5 4.5 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.519-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3.001.7.02.4.02.8.08.42.06.82.14t.72.2q.501.201.42.6l-.16.72q-.04.221-.16.28-.1.042-.38 0-.64-.08-1.4-.14-.759-.08-1.32-.08-.96 0-1.28.28-.3.261-.3.84 0 .581.38.76.4.18 1.32.32.72.1 1.36.26.66.161 1.16.48.5.32.8.86t.3 1.44m9.18 0q0 .88-.34 1.48a2.7 2.7 0 0 1-.92.94q-.56.36-1.28.52a7 7 0 0 1-1.5.16q-.76 0-1.64-.12-.88-.098-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.239.16-.28.12-.06.36-.02.32.06.7.1l.78.08.74.04q.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.3 1.3 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.099-1.4-.26a4.5 4.5 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.519-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3.001.7.02.4.02.8.08.42.06.82.14t.72.2q.5.201.42.6l-.16.72q-.04.221-.16.28-.1.042-.38 0-.64-.08-1.4-.14-.76-.08-1.32-.08-.96 0-1.28.28-.3.261-.3.84 0 .581.38.76.4.18 1.32.32.72.1 1.36.26.66.161 1.16.48.5.32.8.86t.3 1.44m4.44-9.46q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4.001-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74.001.96.32.22.3.22.82m-.12 12.02q0 .161-.08.28-.06.101-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.379.4-.38h1.42q.22 0 .28.12.08.102.08.26zm10.981-4.68q0 .861-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.761-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.499-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.919-.1-1.78 0-.699.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.759 1.28-1.26.86-.52 2.3-.52 1.46.001 2.32.44.88.44 1.34 1.16.46.702.6 1.58.16.88.16 1.76m-2.24.14q0-.798-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2-.4.201-.64.6-.22.4-.32 1-.08.581-.08 1.36 0 .8.08 1.4.1.581.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m.42-9.26q.3.16.08.44l-2.04 2.8q-.16.222-.38.12l-.78-.36q-.22-.12-.1-.38l1.6-3.1q.12-.258.44-.12zm-72.766 21.3q0-.4.4-.4h7.36q.38 0 .38.38v1.24q0 .36-.4.36h-5.46v3.44h4.84q.4 0 .4.36v1.24q0 .36-.4.36h-4.84v3.94h5.6q.36 0 .36.38v1.22q0 .36-.38.36h-7.46q-.4 0-.4-.36zm18.706 12.5q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V65l-.04-.02q-.3.201-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V56.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1a8 8 0 0 0 .78-.24q.38-.159.7-.3l.52-.26V56.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4zm4.705 0q0 .38-.38.38h-1.44q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.4 0 .4.4v.88l.04.04a4 4 0 0 1 .58-.42q.36-.24.76-.42.42-.2.84-.36t.78-.22a.5.5 0 0 1 .32.02q.12.06.16.32l.14 1.34a.7.7 0 0 1-.02.32q-.039.1-.36.16-.42.08-.88.2a10 10 0 0 0-.9.24q-.44.12-.82.24t-.64.24zm13.225-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7 17 17 0 0 1-.1-1.78q0-.699.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.759 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2-.4.201-.64.6-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.849-.04q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V56.6q0-.4.38-.4h1.42q.22 0 .28.12.08.1.08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.981 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.579-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a9 9 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.561.06 1.08.06.54 0 .9-.14.381-.159.6-.54.24-.38.34-1 .1-.64.1-1.58m6.11.68q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.621.62 1.44.18.8.2 1.6.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m12.156 3.74h-2.44q-.759 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32a6.7 6.7 0 0 1-1.72.94q-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.339.02-.72.04-.36.021-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.081-.14.42-.28.32-.12.76-.2.441-.08.9-.12.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.699 0-1.14-.26-.42-.26-.58-.96z"></path>', 26), vZ = [
  fZ
];
function pZ(t, e) {
  return T(), N("svg", dZ, [...vZ]);
}
const mZ = { render: pZ }, gZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, yZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.7c0-.3.1-.4.4-.4h7.1c.2 0 .4.1.4.4v1.2c0 .2-.1.3-.4.3h-5.2v3.3h4.6c.3 0 .4.1.4.3V40c0 .2-.1.3-.4.3h-4.6v3.8h5.4c.2 0 .3.1.3.4v1.2c0 .2-.1.3-.4.3h-7.2c-.3 0-.4-.1-.4-.3zm13.6 10s0-.2.1-.4.2-.5.2-.8c.1-.3.2-.7.4-1.1l1.5-4.5c0-.1.1-.2.1-.2s.2-.1.3-.1h1.5c.3 0 .3.1.2.4l-3.3 8.6c-.1.1-.1.2-.2.3s-.2.1-.3.1h-1.3c-.2 0-.3 0-.4-.1s-.1-.2-.2-.3l-3.3-8.6v-.3c0-.1.1-.1.2-.1h1.5c.1 0 .2 0 .3.1s.1.1.2.3l1.5 4.5c.1.4.2.7.3 1s.2.5.2.8c.4.2.4.4.5.4m8.2 2c0 .2-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4V37c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.8c.1-.1.3-.3.6-.4.2-.1.5-.3.7-.4.3-.1.5-.2.8-.3s.5-.2.7-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.3.2-.3.1-.5.1-.8.2s-.6.1-.9.2-.5.2-.8.2c-.2.1-.4.2-.6.2zm12.7-4.5c0 .5 0 1.1-.1 1.7s-.2 1.1-.5 1.6-.7.9-1.3 1.2-1.3.5-2.3.5-1.7-.2-2.3-.5-1-.7-1.2-1.2-.4-1-.5-1.6-.1-1.2-.1-1.7c0-.4 0-.9.1-1.5.1-.5.3-1.1.5-1.5q.45-.75 1.2-1.2c.5-.3 1.3-.5 2.2-.5s1.7.1 2.2.4c.6.3 1 .6 1.3 1.1q.45.75.6 1.5c.15.75.2 1.1.2 1.7m-2.2.1c0-.5 0-1-.1-1.3q-.15-.6-.3-.9l-.6-.6c-.3-.1-.6-.2-1.1-.2-.4 0-.7.1-1 .2q-.45.15-.6.6c-.1.3-.2.6-.3 1s-.1.8-.1 1.3 0 1 .1 1.3q.15.6.3.9t.6.6c.3.1.6.2 1 .2s.8-.1 1.1-.2q.45-.15.6-.6c.2-.2.3-.6.3-.9.1-.4.1-.9.1-1.4m12.4 0c0 .8-.1 1.5-.2 2.1s-.3 1.1-.6 1.6c-.3.4-.7.7-1.2 1-.5.2-1.1.3-1.9.3-.3 0-.7 0-1.1-.1s-.8-.2-1.3-.3v3.4c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1H180c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V37c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4s.5-.2.8-.3.6-.1.8-.1c.6 0 1.1.1 1.6.3.4.2.7.6 1 1s.4.9.5 1.5c0 .7.1 1.4.1 2.1m-2.2 0c0-.6 0-1.1-.1-1.5s-.2-.7-.3-.9-.3-.3-.5-.4-.4-.1-.7-.1c-.2 0-.4 0-.7.1-.2.1-.5.1-.7.2s-.5.2-.7.3-.4.2-.5.3v4.8l1.2.3c.4 0 .7.1 1 .1s.6 0 .9-.1c.2-.1.4-.3.6-.5.1-.2.3-.6.3-1 .2-.5.2-1 .2-1.6m10.9 1.9c0 .6-.1 1-.3 1.4q-.3.6-.9.9c-.4.2-.8.4-1.2.5-.5.1-.9.2-1.4.2s-1 0-1.6-.1-1-.2-1.4-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.6c0-.2.1-.2.2-.3h.3c.2 0 .4.1.7.1.2 0 .5 0 .7.1h1.3c.6 0 1.1-.1 1.3-.3s.4-.5.4-.8c0-.2 0-.4-.1-.5 0-.1-.1-.3-.2-.3-.1-.1-.3-.2-.5-.2-.2-.1-.5-.1-.8-.1-.5-.1-.9-.1-1.3-.2s-.8-.3-1.1-.5-.6-.5-.8-.8-.3-.8-.3-1.3c0-.9.3-1.7 1-2.2s1.5-.7 2.6-.7h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.3.1.5.1.7.2.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.1.3s-.2 0-.4 0c-.4-.1-.9-.1-1.3-.1-.5 0-.9-.1-1.3-.1q-.9 0-1.2.3c-.2.2-.3.4-.3.8s.1.6.4.7c.2.1.7.2 1.3.3.5.1.9.1 1.3.2s.8.3 1.1.5.6.5.8.8c.1.3.2.8.2 1.3m4-3.1 1.5-1.6 1.6-1.6c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.5c.2 0 .3 0 .3.1s0 .2-.1.3l-3.1 3.1 3.5 5.4q.15.15 0 .3c0 .1-.1.1-.3.1h-1.5c-.2 0-.4 0-.4-.1-.1-.1-.2-.2-.2-.3l-2.5-3.9-1.1 1.1v2.8c0 .1 0 .2-.1.3s-.1.1-.3.1H199c-.2 0-.4-.1-.4-.4V32.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13 4.9c-.5.4-1 .7-1.6.9s-1.2.3-1.9.3c-.5 0-.9-.1-1.3-.2-.3-.1-.6-.3-.8-.6-.2-.2-.3-.5-.4-.9-.1-.3-.1-.7-.1-1.1q0-1.65.9-2.4c.6-.5 1.5-.8 2.7-.8h2.5v-.5c0-.3 0-.5-.1-.7s-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.6.1h-.4c-.1 0-.1-.1-.1-.2l-.2-.7v-.3c.1-.1.2-.2.4-.3s.4-.1.7-.2.6-.1.9-.1.6-.1.9-.1h.8c.8 0 1.5.1 2 .2.5.2.9.4 1.1.7.3.3.4.7.5 1.1s.1.9.1 1.5v4.2c0 .1.1.2.1.2s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.4c-.4 0-.8-.1-1.1-.2s-.6-.5-.7-.9m-.1-3.2h-2.3q-.75 0-1.2.3c-.3.2-.4.6-.4 1.3q0 .6.3.9c.3.3.5.2.9.2.2 0 .4 0 .7-.1s.5-.1.7-.2.5-.2.7-.3l.6-.3zm.8-9.4c.2.1.2.2.1.4l-2 2.7c-.1.1-.2.2-.4.1l-.7-.3c-.1-.1-.2-.2-.1-.4l1.5-3c.1-.2.2-.2.4-.1z" class="st4"></path></g><g class="st3"><path d="m145.2 60.4 1.5-1.6 1.6-1.6c.1-.1.2-.2.3-.2.1-.1.2-.1.4-.1h1.5c.2 0 .3 0 .3.1s0 .2-.1.3l-3.1 3.1 3.5 5.4q.15.15 0 .3c0 .1-.1.1-.3.1h-1.5c-.2 0-.4 0-.4-.1-.1-.1-.2-.2-.2-.3l-2.5-3.9-1.1 1.1v3c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.2 0-.4-.1-.4-.4V53.2c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm15.1 1.1c0 .5 0 1.1-.1 1.7s-.2 1.1-.5 1.6-.7.9-1.3 1.2-1.3.5-2.3.5-1.7-.2-2.3-.5-1-.7-1.2-1.2-.4-1-.5-1.6-.1-1.2-.1-1.7c0-.4 0-.9.1-1.5.1-.5.3-1.1.5-1.5q.45-.75 1.2-1.2c.5-.3 1.3-.5 2.2-.5s1.7.1 2.2.4c.6.3 1 .6 1.3 1.1q.45.75.6 1.5c.1.6.2 1.1.2 1.7m-2.2.1c0-.5 0-1-.1-1.3s-.2-.7-.3-.9l-.6-.6c-.3-.1-.6-.2-1.1-.2-.4 0-.7.1-1 .2q-.45.15-.6.6c-.15.45-.2.6-.3 1s-.1.8-.1 1.3 0 1 .1 1.3q.15.6.3.9t.6.6c.3.1.6.2 1 .2s.8-.1 1.1-.2q.45-.15.6-.6c.2-.2.3-.6.3-.9s.1-.9.1-1.4m17.7 4.7c0 .1-.1.1-.3.1h-1.4c-.2 0-.4-.1-.4-.4v-5.5c0-.7-.1-1.2-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2l-.6.3c-.2.1-.4.2-.5.3V66c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.2 0-.3-.1-.3-.4v-5.5c0-.6-.1-1-.3-1.3s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.4.2-.7.3l-.6.3V66c0 .2-.1.4-.4.4h-1.4c-.2 0-.3-.1-.3-.4v-8.7c0-.3.1-.4.3-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.5 0 1.1.1 1.5.3.5.2.8.5 1.1 1.1.5-.4 1-.7 1.6-.9.6-.3 1.2-.4 1.8-.4q.9 0 1.5.3c.4.2.7.5.8.8.2.3.3.7.4 1.1s.1.9.1 1.4V66c.2.1.2.2.1.3m4.6-11.8v.4c0 .1-.1.3-.2.4s-.2.2-.3.2c-.1.1-.3.1-.6.1s-.5 0-.6-.1-.3-.1-.3-.2c-.1-.1-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8s.5-.3.9-.3q.75 0 .9.3c.2.2.2.4.2.8m-.1 11.5c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-8.7c0-.2.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.4-2.5c0 .6-.1 1-.3 1.4q-.3.6-.9.9c-.4.2-.8.4-1.2.5-.5.1-.9.2-1.4.2s-1 0-1.6-.1-1-.2-1.4-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.6c0-.2.1-.2.2-.3h.3c.2 0 .4.1.7.1.2 0 .5 0 .7.1h1.3c.6 0 1.1-.1 1.3-.3s.4-.5.4-.8c0-.2 0-.4-.1-.5 0-.1-.1-.3-.2-.3-.1-.1-.3-.2-.5-.2-.2-.1-.5-.1-.8-.1-.5-.1-.9-.1-1.3-.2s-.8-.3-1.1-.5-.6-.5-.8-.8-.3-.8-.3-1.3c0-.9.3-1.7 1-2.2s1.5-.7 2.6-.7h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.3.1.5.1.7.2.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.1.3s-.2 0-.4 0c-.4-.1-.9-.1-1.3-.1-.5 0-.9-.1-1.3-.1q-.9 0-1.2.3c-.2.2-.3.4-.3.8s.1.6.4.7c.2.1.7.2 1.3.3.5.1.9.1 1.3.2s.8.3 1.1.5.6.5.8.8c.1.3.2.8.2 1.3m3.8-1.3c0 .5.1.9.2 1.2s.2.6.4.8.4.3.7.4.6.1 1 .1c.3 0 .8 0 1.2-.1.5-.1.9-.1 1.3-.1h.4c.1 0 .1.1.1.3l.1.6v.3c0 .1-.1.2-.3.2-.2.1-.4.1-.7.2s-.5.1-.8.1-.6.1-.8.1h-.8c-.9 0-1.7-.1-2.2-.4s-1-.6-1.3-1.1c-.3-.4-.5-1-.6-1.5s-.1-1.2-.1-1.8c0-.5 0-1 .1-1.6s.3-1.1.5-1.6c.3-.5.7-.9 1.2-1.3.5-.3 1.3-.5 2.2-.5s1.6.1 2.1.4.9.6 1.2 1 .5.9.6 1.4.2 1 .2 1.5c0 .3 0 .6-.2.8-.1.2-.4.3-.8.3h-4.9zm1.9-3.7c-.4 0-.7.1-.9.2s-.4.2-.6.4c-.1.2-.3.4-.3.7-.1.3-.1.6-.1 1h3.8c0-.3 0-.6-.1-.8-.1-.3-.1-.5-.3-.7-.1-.2-.3-.4-.6-.5q-.3-.3-.9-.3" class="st4"></path></g><path d="M226.2 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function _Z(t, e) {
  return T(), N("svg", gZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    yZ
  ]);
}
const qZ = { render: _Z }, wZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, zZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m10.3 3.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm10.5-2.8q.3 0 .3.3v1q0 .3-.3.3h-5.8q-.3 0-.3-.3v-1q0-.3.3-.3z" class="st4"></path></g><g class="st3"><path d="m145.6 59.4 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V53.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm17.6 1.9c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1 0 .2-.1.3m16.6 0c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1H199c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m9.2 0q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.5-9.5v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.2 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm11-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.7 4.9c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V66c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66c.1.1.1.2.1.3m4.2-4.3c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2c-.3 0-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3 1.3-.5 2.3-.5c.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8c-.1-.2-.3-.4-.6-.5s-.7-.3-1.1-.3m14.5 8.2c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V66c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66c.2.1.2.2.1.3" class="st4"></path></g><path d="M275.2 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function MZ(t, e) {
  return T(), N("svg", wZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    zZ
  ]);
}
const bZ = { render: MZ }, LZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 273.9 75.3"
}, xZ = /* @__PURE__ */ U1('<path id="path-3" d="M0 0h264.9v69.5H0z" style="fill:#fff;"></path><g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 25.6s41.6-5.4 42.8-5.6c1.8-.3 3.4-.6 4.9-1.1 3.4-.9 6.5-2.3 9.2-4.2 2.6-1.8 5.1-4.4 7.5-7.2 1.5-1.8 3.2-4.2 4.7-6.4V0c-1.8 2.7-3.6 5-5.4 7q-3.6 4.05-7.5 6.6c-2.7 1.7-5.6 3-8.9 3.8-1.5.4-3 .7-4.8.9-1.2.2-2.3.3-3.5.4-.4.1-39 4.2-39 4.2z" class="st1"></path><path id="Fill-41" d="M55.8 18.6c-2.6 1.5-5.6 2.6-8.9 3.3-1.4.3-3 .5-4.7.7-1 .1-2.1.2-3.1.3-.6 0-1.1.1-1.7.2-12.8 1.1-25.5 2.3-37.4 3.5v2.7c12-1.5 24.7-3 37.5-4.4.6-.1 1.1-.1 1.7-.2 1-.1 2.1-.2 3.1-.4 1.8-.2 3.4-.5 4.9-.9 3.5-.8 6.6-2 9.3-3.7 2.7-1.6 5.1-3.9 7.6-6.7 1.6-1.7 3.4-4.2 5-6.5v-1c-1.9 2.7-3.8 4.9-5.6 6.8-2.5 2.7-5.1 4.8-7.7 6.3" class="st1"></path><path id="Fill-42" d="M63.1 17.9c-2.5 2.3-5.2 4.2-7.9 5.5q-3.9 1.95-9 2.7c-1.4.2-3 .4-4.7.6L0 30.2v2.7L36.9 29l4.8-.5c1.8-.2 3.4-.4 4.8-.7 3.5-.7 6.6-1.7 9.3-3.1 2.8-1.4 5.5-3.8 8.1-6.3 1.7-1.7 3.4-3.8 5.2-6.1v-.9c-2.1 2.6-4 4.7-6 6.5" class="st1"></path><path id="Fill-43" d="M53.1 32c-2.4 1.4-4.2 2.1-7.7 2.5-2.1.2-4.2.3-6.3.4-1 .1-2 .1-3 .2-6.3.4-12.4.8-18.7 1.2L0 37.5v2.7l17.5-1.6c5.7-.5 12.2-1.1 18.7-1.6l4.7-.4c1.8-.1 3.3-.3 4.7-.5 3.6-.5 6.6-1.2 9.3-2.2 2.9-1.1 5.6-2.8 8.4-4.8 2.5-1.8 5.9-5.3 5.9-5.4v-1c-2.2 2.2-3.5 3.4-6 5-3 2.1-8 3.1-10.1 4.3" class="st1"></path><path id="Fill-44" d="M54 37.2c-2.6.8-5.6 1.3-9 1.6-1.4.1-2.9.2-4.6.3l-4.6.2c-11.5.5-23 1.1-35.7 1.8v2.7c12.1-.9 23.9-1.9 35.8-2.7l4.6-.3c1.8-.1 3.3-.2 4.7-.4 3.5-.4 6.6-1 9.2-1.9 3-.9 5.9-2.3 8.6-4.1 2-1.3 4-2.8 6.2-4.7-2.3 2-4.5 2.4-6.7 3.8-2.8 1.6-5.7 2.8-8.5 3.7" class="st1"></path><path id="Fill-45" d="M53.5 41.7c-2.6.6-5.5 1-9 1.3-1.4.1-2.8.2-4.6.2l-4.6.2c-11.5.4-23.3.9-35.3 1.4v2.7c11.9-.8 23.6-1.6 35.4-2.4l4.6-.3c1.8-.1 3.3-.2 4.6-.3 3.6-.3 6.5-.8 9.2-1.5 3-.8 6-1.9 8.7-3.4 2.1-1.1 4.3-2.5 6.5-4.2v-1.2c-2.4 1.7-4.7 3.2-7 4.3-2.6 1.5-5.5 2.5-8.5 3.2" class="st1"></path><path id="Fill-46" d="M53.1 46.1c-2.6.5-5.5.8-9 1-1.3.1-2.7.1-4.5.2L0 48.3V51l35.1-1.8 4.6-.2c1.8-.1 3.2-.2 4.6-.3 3.5-.3 6.4-.7 9.1-1.2 3.1-.6 6-1.6 8.8-2.8 2.3-1 4.5-2.1 6.9-3.6V40c-2.5 1.5-4.9 2.7-7.3 3.6-2.7 1.1-5.7 2-8.7 2.5" class="st1"></path><path id="Fill-47" d="M52.8 50.5c-4.9.7-9.9.7-14.7.8-1.1 0-2.2 0-3.3.1L0 52v2.7l34.9-1.5c1.1-.1 2.2-.1 3.3-.1 4.9-.2 9.9-.4 14.8-1.2 3.1-.5 6.1-1.2 8.9-2.2q3.45-1.2 7.2-3v-1c-2.6 1.2-5.1 2.2-7.5 2.9-2.8.9-5.7 1.5-8.8 1.9" class="st1"></path><path id="Fill-48" d="M52.6 55c-4.6.4-9.2.4-13.7.4h-4.2c-11.5.1-23 .1-34.6.2v2.7c11.1-.4 22.9-.8 34.7-1.1 1.4 0 2.8-.1 4.2-.1 4.5-.1 9.2-.2 13.8-.7 3.2-.3 6.1-.9 8.9-1.6 2.4-.6 5-1.4 7.5-2.4v-1c-2.6.9-5.2 1.7-7.7 2.3-2.9.6-5.8 1-8.9 1.3" class="st1"></path><path id="Fill-49" d="M52.4 59.4c-1.9.1-4 .1-6.3.1h-2.6l-9-.1c-6.1 0-12.2-.1-17.9-.1H0V62l16.6-.4c5.7-.1 11.8-.3 17.9-.4l9-.1c2.5 0 5.7-.1 9-.3 3.2-.2 6.1-.5 9-1 2.5-.4 5.1-1 7.7-1.6v-1c-2.7.6-5.3 1.1-7.9 1.5-2.8.3-5.7.6-8.9.7" class="st1"></path><path id="Fill-50" d="m43.3 63.6-8.9-.1c-11.4-.1-22.8-.3-34.4-.6v2.7c11.1-.1 22.8-.2 34.4-.3l8.9-.1c3-.1 6-.1 8.9-.2 6.1-.2 11.6-.6 16.8-1.3v-.9c-5.2.6-10.7.9-16.8.9-2.9 0-5.9 0-8.9-.1" class="st1"></path><path id="Fill-51" d="M69.1 68.4 0 66.6v2.7h69.1z" class="st1"></path><path id="Fill-52" d="M62.9 23c-2.6 2.1-4.7 3.6-7.9 4.9-2.8 1.1-5.8 1.6-9.2 2.1-2.2.3-4.5.8-6.7.9-.9.1-1.8.1-2.7.2L0 33.8v2.7l36.5-3.6 4.7-.4c1.8-.2 3.3-.4 4.8-.6 3.5-.6 6.6-1.4 9.3-2.7 2.8-1.3 5.7-3.3 8.4-5.6 1.8-1.5 3.6-3.5 5.5-5.6v-1c-2.4 2.5-4.3 4.4-6.3 6" class="st1"></path><path id="Fill-53" d="M98.5 0s12.4 19.8 14.7 23.4 4.9 6.5 14.1 8.5 13.2 2.9 13.2 2.9v.7s-5.8-1.2-13.4-2.9-10.6-2.2-14-7c-2.9-4-14.6-20.8-14.6-20.8z" class="st1"></path><path id="Fill-54" d="M98.5 22.6s11.3 11.9 14.6 15.3c3.5 3.6 7.9 4.9 14.1 6 5.9 1.1 13.3 2.3 13.3 2.3v.7s-7-1.1-13.3-2.2c-6.2-1.1-10.6-1.7-14.1-4.9-3.2-2.9-14.6-13.6-14.6-13.6z" class="st1"></path><path id="Fill-55" d="M98.5 28s10.8 10 14.6 13.4c3.5 3.1 6.4 4.1 14.1 5.5s13.3 2.2 13.3 2.2v.7s-7-1.2-13.3-2.2-10.3-1.4-14.1-4.5c-4.4-3.5-14.6-12-14.6-12z" class="st1"></path><path id="Fill-56" d="M98.5 33.7s12.3 9.8 14.6 11.5 5.3 3.7 14.2 5c8.7 1.3 13.2 1.9 13.2 1.9v.7s-7.9-1.2-13.2-1.8c-5.3-.7-9.4-1-14.1-4.1-4.6-3.1-14.6-10.1-14.6-10.1v-3.1z" class="st1"></path><path id="Fill-57" d="M98.5 39.1s12.3 8.2 14.7 9.5c2.3 1.3 5.1 3.4 14.1 4.6s13.2 1.7 13.2 1.7v.7s-7.5-.8-13.3-1.4-9.8-1.5-14.1-3.9-14.6-8.4-14.6-8.4z" class="st1"></path><path id="Fill-58" d="M98.5 44.6s10.9 5.9 14.6 7.8c4.1 2.1 7.7 3.1 14.1 3.8 6.3.8 13.3 1.5 13.3 1.5v.7s-6.4-.7-13.3-1.3c-6.8-.6-9.2-.9-14.1-3.1-4.4-1.9-14.6-6.7-14.6-6.7z" class="st1"></path><path id="Fill-59" d="M98.5 50.2s8.6 3.7 14.7 6.1c6 2.4 10.5 2.6 14.1 3 1.6.2 13.2 1.4 13.2 1.4v.7s-6.9-.6-13.2-1.1c-6.3-.6-9-.8-14.1-2.5-5.2-1.7-14.6-5-14.6-5v-2.6z" class="st1"></path><path id="Fill-60" d="M98.5 55.8s8.7 2.7 14.6 4.3 11.4 2.2 14.1 2.4 13.2 1 13.2 1v.6s-6-.4-13.3-.9c-5.9-.4-10.7-.9-14.1-1.6-3.8-.8-14.6-3.4-14.6-3.4v-2.4z" class="st1"></path><path id="Fill-61" d="M98.5 61.4s7.1 1.2 14.6 2.5c5.6.9 13.3 1.5 14.1 1.6.8 0 13.3.9 13.3.9v.6s-8-.4-13.3-.7c-5.5-.3-11-.6-14.1-1-7-.7-14.6-1.7-14.6-1.7z" class="st1"></path><path id="Fill-62" d="M98.5 67.2s11.2.4 14.6.5 27.4 1 27.4 1v.7h-42z" class="st1"></path><path id="Fill-63" d="M127.2 35c-10.2-2.2-12.5-5.9-14.2-8.2S98.4 5.7 98.4 5.7v4.2c.5.7 11.5 15.1 14.6 19 3.5 4.5 8.9 5.5 14.1 6.6s13.3 2.7 13.3 2.7v-.6c.1 0-10.6-2.1-13.2-2.6" class="st1"></path><path id="Fill-64" d="M127.2 37.9c-8.3-1.6-11.7-4.3-14.2-7.5-2.4-3.2-14.6-19.2-14.6-19.2v4c.5.6 11.6 13.7 14.6 17.1 3.5 4 8.3 5 14.2 6.1s13.3 2.5 13.3 2.5v-.6c0 .1-8.5-1.4-13.3-2.4" class="st1"></path><path id="Fill-65" d="M127.2 41c-8.7-1.7-10.5-3.1-14.1-7.1-2.3-2.5-14.1-16.4-14.6-17v3.7s11 11.7 14.6 15.2c4.6 4.6 9 4.9 14.2 5.8s13.3 2.4 13.3 2.4v-.6c-.1 0-9.9-1.7-13.4-2.4" class="st1"></path><path id="Fill-66" d="M89.3 28.8H28.7v40.5h60.5V28.8z" class="st2"></path><path id="Fill-67" d="M59.6 34.6h2.1L60 35.9l.7 2.1-1.7-1.3-1.7 1.3.7-2.1-1.7-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-68" d="M59.7 61.6h2.1l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.7-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-69" d="M66.4 59.8h2.1l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.8-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-70" d="M66.4 36.4h2.1l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.8-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-71" d="M71.4 41.4h2.1l-1.7 1.3.7 2-1.7-1.2-1.8 1.2.7-2-1.7-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-72" d="M71.4 54.9h2.1l-1.7 1.3.7 2-1.8-1.2-1.7 1.2.7-2-1.7-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-73" d="M73.2 48h2.1l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.7-1.3H72l.6-2z" class="st3"></path><path id="Fill-74" d="M52.8 36.4h2.1l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.7-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-75" d="M48 41.4h2.1l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.7-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-76" d="M46.2 48.1h2.1l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.7-1.3H45l.6-2z" class="st3"></path><path id="Fill-77" d="M48 54.9h2.1l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.7-1.3h2.1l.6-2z" class="st3"></path><path id="Fill-78" d="M52.9 59.8H55l-1.7 1.3.7 2-1.7-1.2-1.7 1.2.7-2-1.7-1.3h2.1l.6-2z" class="st3"></path></g></g></g></g></g></g><path d="M149.8 35.2c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 12.9h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.6-.5.6m5.1-.3c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3s-.5.2-.6.2zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2q-.45.15-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.9.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1s-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V38.7c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.2-.1c0-.6 0-1.2-.1-1.5q-.15-.6-.3-.9c-.15-.3-.3-.4-.5-.4-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .2-.5.3-1 .3-1.7m10.2 3.9c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5s-.4-.2-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.75.3.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-3.6-10c-.3 0-.5 0-.6-.1s-.3-.1-.3-.3-.1-.2-.2-.4 0-.3 0-.4c0-.3.1-.6.2-.8s.4-.3.9-.3.8.1.9.3.2.5.2.8-.1.6-.2.8c-.2.2-.5.4-.9.4m3.5 6.7h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.4-6.7q-.75 0-.9-.3c-.1-.2-.2-.5-.2-.8s.1-.6.2-.8.4-.3.9-.3.8.1.9.3.2.5.2.8-.1.6-.2.8-.4.3-.9.3m6.9-1.3v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.2.1.2.3.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1c.3.1.5.1.7.2.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2s-1-.1-1.3-.1c-.6 0-1.1.1-1.3.3s-.3.5-.3.9.1.6.4.8.7.2 1.3.3c.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m9.4 2v.4c0 .1-.2.2-.3.3-.4.2-.9.3-1.4.4-.6.1-1.1.1-1.6.1-.9 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.1-1.3-.1-2c0-.6 0-1.2.2-1.8.1-.6.3-1.2.6-1.6.3-.5.7-.9 1.3-1.2s1.3-.4 2.2-.4h.8c.3 0 .5 0 .8.1.3 0 .5.1.8.2s.5.1.7.2q.3.15.3.6l-.1.8c0 .1-.1.2-.2.3h-.4c-.4 0-.8-.1-1.3-.1s-.8-.1-1.2-.1c-.8 0-1.4.2-1.7.7s-.5 1.3-.5 2.4c0 .6 0 1.1.1 1.6.1.4.2.7.4 1s.4.4.7.5.6.2 1 .2c.3 0 .7 0 1.2-.1.5 0 1-.1 1.4-.1h.4c.1 0 .1.1.2.3zm9.6.9h-1.4c-.3 0-.4-.1-.4-.4v-5.8c0-.6-.1-1-.3-1.4-.2-.3-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.2v6.8c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.4-.1-.4-.4V34.4c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v4.9c.2-.1.4-.2.6-.4.3-.1.5-.2.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.8c.3.3.1.4-.2.4m4.6-4.3c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.3.15-.4.2-.7.2-.3.1-.5.1-.8.2-.3 0-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9-.1.2-.4.3-.8.3h-5.5zm2.1-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8c-.1-.2-.3-.4-.6-.5s-.7-.3-1.1-.3m-95.7 22.5 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.15.15-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V69c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V56.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm17.6 1.9c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2q-.45.15-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.9.1-1.4m18.5 4.8c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V69c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V69c0 .3-.1.4-.4.4H172c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.2.2m16.6 0c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V69c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V69c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.2m4.8-12.3v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V57c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.3.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1c.3.1.5.1.7.2.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2s-1-.1-1.3-.1c-.6 0-1.1.1-1.3.3s-.3.5-.3.9.1.6.4.8.7.2 1.3.3c.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m9.2 0q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1c.3.1.5.1.7.2.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2s-1-.1-1.3-.1c-.6 0-1.1.1-1.3.3s-.3.5-.3.9.1.6.4.8.7.2 1.3.3c.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.5-9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V57c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.3.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm11-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2q-.45.15-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.9.1-1.4m12.7 4.8c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4s-.6-.5-1.2-.5c-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V69c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V69c.1.1.1.2.1.2" style="fill:#626366;"></path><path d="M261.4 29.2h3.5v40.5h-3.5z" class="st2"></path>', 4);
function SZ(t, e) {
  return T(), N("svg", LZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st1{fill:#bbbdbf}.st2{fill:#034da1}.st3{fill:#fff100}")
      ]),
      _: 1
    })),
    xZ
  ]);
}
const CZ = { render: SZ }, kZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, EZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm12.5 10c0 .2.1.5.3.6s.3.3.6.4.6.2 1 .2.7-.1 1-.2.5-.3.6-.4q.3-.3.3-.6c.1-.2.1-.5.1-.8v-5.7c0-.3.1-.4.4-.4h1.5c.3 0 .4.1.4.4v5.8q0 .75-.3 1.5c-.2.5-.4.9-.8 1.2s-.8.6-1.3.8-1.2.3-1.9.3c-.8 0-1.4-.1-1.9-.3s-1-.4-1.3-.8c-.3-.3-.6-.7-.7-1.2-.2-.5-.2-1-.2-1.6v-5.8c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4zm17-2c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.4-2 .4c-.3 0-.7 0-1.2-.1s-.9-.2-1.4-.3v3.6c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3v-8.3c0-1.7.4-3 1.1-3.8.8-.8 1.8-1.2 3.2-1.2.8 0 1.5.1 2.1.4.6.2 1 .6 1.4 1s.6 1 .7 1.6c.2.4.3 1.1.3 1.9m-2.3-.1c0-.6-.1-1.1-.2-1.5s-.3-.7-.4-.9-.4-.4-.7-.5-.5-.1-.8-.1q-.75 0-1.2.3c-.3.2-.5.5-.7.8-.1.3-.2.6-.3 1V44l1.2.3c.4 0 .7.1 1.1.1.3 0 .6 0 .9-.1.2-.1.5-.3.6-.5.2-.2.3-.6.4-1 .1-.6.1-1.1.1-1.8m10.8 3.8c-.2.4-.6.7-1.1 1s-1.1.4-1.7.4c-.8 0-1.4-.1-1.9-.4s-.9-.6-1.2-1.1-.5-1-.6-1.6-.2-1.2-.2-1.9c0-.5 0-1 .1-1.5s.2-1 .4-1.4.5-.9.9-1.2q.6-.6 1.5-.9c.1-.1.3-.1.4-.1s.2.1.3.2l.5.8c.1.1.1.2.1.3s-.1.2-.3.3c-.3.2-.6.5-.8.7s-.4.5-.5.8-.2.6-.2.9-.1.7-.1 1.1 0 .8.1 1.2.2.7.3 1 .3.5.5.7.5.2.8.2c.4 0 .7-.1.9-.2s.4-.3.5-.5.2-.4.2-.7c0-.2.1-.5.1-.8v-2.6c0-.3.1-.4.4-.4h1.3c.1 0 .2 0 .3.1 0 .1.1.2.1.3v2.6c0 .3 0 .5.1.8.1.2.2.5.3.7s.3.4.5.5.5.2.8.2c.6 0 1-.2 1.3-.7s.4-1.3.4-2.4c0-.5 0-.9-.1-1.2 0-.3-.1-.6-.2-.9s-.3-.5-.5-.8c-.2-.2-.5-.5-.8-.7q-.3-.15-.3-.3c0-.1 0-.2.1-.3l.4-.7c.1-.3.3-.3.6-.2q.9.3 1.5.9t.9 1.2c.3.6.4.9.4 1.4.1.5.1 1 .1 1.5 0 .7-.1 1.3-.2 1.9s-.3 1.1-.6 1.6-.7.8-1.2 1.1-1.1.4-1.9.4c-.7 0-1.3-.1-1.8-.4-.2-.2-.6-.5-.9-.9m17.4.9c0 .3-.1.4-.4.4H197c-.3 0-.4-.1-.4-.4v-7.6h-4.2v7.6c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h7.8c.1 0 .2 0 .3.1s.1.2.1.3zm10.5-2.1c0 .4 0 .6.1.7s.3.1.5.2c.1 0 .2 0 .3.1 0 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.9-.1-1.1-.3s-.5-.5-.6-1c-.5.4-1.1.7-1.6 1s-1.1.4-1.7.4-1.2-.1-1.6-.4c-.4-.2-.8-.6-1-1s-.4-1-.5-1.6-.2-1.3-.2-2.1.1-1.5.2-2.1c.2-.6.4-1.2.7-1.6.3-.5.7-.8 1.2-1.1s1.1-.4 1.8-.4c.3 0 .7.1 1.2.2s.9.3 1.4.6v-.2c0-.1 0-.2.1-.3 0-.1.2-.1.3-.1h1.4c.2 0 .3 0 .3.1s.1.2.1.3v7.1zm-6.4-2.3c0 .6 0 1.2.1 1.5q.15.6.3.9c.15.3.3.4.5.4.2.1.4.1.7.1.2 0 .4 0 .7-.1.2-.1.5-.1.8-.2s.5-.2.7-.3l.6-.3v-4.8c-.4-.2-.9-.3-1.2-.4-.4-.1-.7-.1-.9-.1-.7 0-1.3.2-1.6.7-.6.5-.7 1.4-.7 2.6m8.4-6.4c-.3 0-.5 0-.6-.1s-.3-.1-.3-.3c-.1-.1-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8q.15-.3.9-.3c.75 0 .8.1.9.3s.2.5.2.8-.1.6-.2.8-.4.4-.9.4m3 10.8c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm.9-10.8q-.75 0-.9-.3c-.1-.2-.2-.5-.2-.8s.1-.6.2-.8q.15-.3.9-.3t.9.3c.1.2.2.5.2.8s-.1.6-.2.8-.4.3-.9.3m3.9 5 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.6c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.5-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm15.9 5.8c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3v6.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.7zm-2.5-13.9c.2.1.2.3.1.4l-2 2.8c-.1.1-.1.1-.2.1h-.2l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1z" class="st4"></path></g><g class="st3"><path d="M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zM162.3 66c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-7.6h-4.2V66c0 .1 0 .2-.1.3s-.2.1-.3.1H154c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h7.8c.1 0 .2 0 .3.1s.1.2.1.3V66zm4.5 0c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm8.6-9.5c.2 0 .3 0 .3.1s.1.2.1.3V58c0 .1 0 .2-.1.3 0 .1-.2.1-.3.1H173v4.9c0 .4 0 .6.1.8s.2.3.4.4.4.1.8.1c.3 0 .7 0 1.2-.1h.4c.1 0 .1.1.1.3l.1.8c0 .2-.1.4-.3.5s-.4.2-.6.2c-.2.1-.4.1-.7.1s-.4.1-.7.1h-.6c-.5 0-.9-.1-1.2-.2s-.6-.3-.8-.5-.3-.5-.4-.8-.1-.6-.1-1v-5.7h-2c-.3 0-.4-.1-.4-.4v-1c0-.3.1-.4.4-.4zm10.5 4.9c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.4-2 .4c-.3 0-.7 0-1.2-.1s-.9-.2-1.4-.3v3.6c0 .1 0 .2-.1.3s-.1-.1-.2-.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3v-8.3c0-1.7.4-3 1.1-3.8.8-.8 1.8-1.2 3.2-1.2.8 0 1.5.1 2.1.4.6.2 1 .6 1.4 1s.6 1 .7 1.6.2 1.3.2 2.1m-2.3-.1c0-.6-.1-1.1-.2-1.5s-.3-.7-.4-.9-.4-.4-.7-.5-.5-.1-.8-.1q-.75 0-1.2.3c-.3.2-.5.5-.7.8-.1.3-.2.6-.3 1v4l1.2.3c.4 0 .7.1 1.1.1.3 0 .6 0 .9-.1.2-.1.5-.3.6-.5.2-.2.3-.6.4-1 .1-.7.1-1.2.1-1.9m12.8 0c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4M207 66c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-7.6h-4.2V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h7.8c.1 0 .2 0 .3.1s.1.2.1.3zm10.6 0c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V66c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66zm-2.4-13.9c.2.1.2.3.1.4l-2 2.8c-.1.1-.1.1-.2.1h-.2l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1z" class="st4"></path></g><path d="M244.2 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function AZ(t, e) {
  return T(), N("svg", kZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    EZ
  ]);
}
const FZ = { render: AZ }, TZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, IZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m6.2.6c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3m12.3 7.1c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm13.2 4.4c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3v6.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.8c.1 0 .1.1.1.2" class="st4"></path></g><g class="st3"><path d="M143.2 59.8c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.9.3c.2.1.3.1.3.2s.1.2.1.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.7 0-1.2.1-1.6.4s-.7.6-1 1c-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m19.7 1.5c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.6 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.3m16.5 0c0 .1-.1.1-.3.1H194c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4c.3-.1.5-.2.8-.3s.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1-.1.2-.1.3m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m9.2 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.5-9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1H222c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm11-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.7 4.9c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V66c0 .3-.1.4-.4.4H237c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66c.2.1.1.2.1.3" class="st4"></path></g><path d="M254.2 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function OZ(t, e) {
  return T(), N("svg", TZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    IZ
  ]);
}
const NZ = { render: OZ }, PZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, BZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.2 39.5c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.9.3c.2.1.3.1.3.2s.1.2.1.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.7 0-1.2.1-1.6.4s-.7.6-1 1c-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m19.7 1.5c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.6 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c-.1.2-.1.3-.1.4m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.5-9.5v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.2 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm11-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m.4-9.3c.2.1.2.3.1.4l-2 2.8c-.1.1-.2.2-.4.1l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1zM219.4 46c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3v6.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.8c.2 0 .2.1.1.2" class="st4"></path></g><g class="st3"><path d="M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4V66c-.1.2-.2.4-.5.4m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2V66zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m6.2.6c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.6.2-1 .2zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3m12.3 7.1c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M229.2 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function VZ(t, e) {
  return T(), N("svg", PZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    BZ
  ]);
}
const RZ = { render: VZ }, HZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, DZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.7-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1H193c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6.1 1.3.1 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m10.3 3.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1H206c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><g class="st3"><path d="m145.6 59.4 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V53.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm17.6 1.9c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1 0 .2-.1.3m4.8-12.4v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.2.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.9-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.6 3.2c0 .7-.1 1.2-.2 1.7s-.4.9-.8 1.3c-.4.3-.8.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.3-.1s-.2-.2-.2-.3l-.1-.9V69c0-.1.1-.1.3-.1q.75-.15 1.2-.3c.45-.15.6-.2.8-.4.2-.1.3-.3.4-.6.1-.2.1-.5.1-.9V57c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v9.6zm.1-12.7v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m10.9 7.4c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.6 4.9c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V66c0 .3-.1.4-.4.4H212c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66q.15.15 0 .3" class="st4"></path></g><path d="M229.5 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function $Z(t, e) {
  return T(), N("svg", HZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    DZ
  ]);
}
const UZ = { render: $Z }, jZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, GZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.7-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1H193c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6.1 1.3.1 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m10.3 3.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1H206c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm13.2 4.4c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3v6.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.8c.1 0 .1.1.1.2" class="st4"></path></g><g class="st3"><path d="m145.4 60.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm15.7 1.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m9.2 0q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.5-9.5v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm11-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4" class="st4"></path></g><path d="M231.7 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function WZ(t, e) {
  return T(), N("svg", jZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    GZ
  ]);
}
const YZ = { render: WZ }, XZ = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 290 72"
}, KZ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu"><g id="Site-header"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4a48 48 0 0 0 4.7-1 29.4 29.4 0 0 0 8.8-4 38.6 38.6 0 0 0 7.2-6.9A67 67 0 0 0 66.2 1V0a56 56 0 0 1-5.1 6.7 34.6 34.6 0 0 1-7.2 6.3 29.6 29.6 0 0 1-8.5 3.7c-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9Z" class="cls-1"></path><path id="Fill-41" d="M53.4 17.8a28.3 28.3 0 0 1-8.6 3.1c-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4a43 43 0 0 0 4.6-.8 28 28 0 0 0 8.9-3.5 35.3 35.3 0 0 0 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1a64 64 0 0 1-5.4 6.5 28.5 28.5 0 0 1-7.3 6.1" class="cls-1"></path><path id="Fill-42" d="M60.4 17.2a35.6 35.6 0 0 1-7.5 5.3 30 30 0 0 1-8.6 2.6c-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7a32 32 0 0 0 8.9-2.9 35.4 35.4 0 0 0 7.8-6 60 60 0 0 0 4.9-5.8v-.9a61 61 0 0 1-5.7 6.3" class="cls-1"></path><path id="Fill-43" d="M50.8 30.6a15.8 15.8 0 0 1-7.3 2.4c-2 .2-4 .3-6 .4a28 28 0 0 0-2.9.2c-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5a36.4 36.4 0 0 0 8.9-2.1 32.4 32.4 0 0 0 8-4.6 39 39 0 0 0 5.6-5.2v-.9a31.6 31.6 0 0 1-5.7 4.8c-2.9 2-7.6 3-9.7 4.1" class="cls-1"></path><path id="Fill-44" d="M51.6 35.6a47.7 47.7 0 0 1-8.6 1.5c-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4a47 47 0 0 0 8.8-1.8 34 34 0 0 0 8.2-3.9 44 44 0 0 0 5.9-4.5c-2.2 1.9-4.3 2.3-6.4 3.6a34.7 34.7 0 0 1-8.2 3.6" class="cls-1"></path><path id="Fill-45" d="M51.2 39.9a49.5 49.5 0 0 1-8.6 1.2c-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3a50 50 0 0 0 8.8-1.5 43 43 0 0 0 8.4-3.3 43 43 0 0 0 6.2-4v-1.1a45 45 0 0 1-6.7 4.1 35.4 35.4 0 0 1-8.2 3.1" class="cls-1"></path><path id="Fill-46" d="M50.8 44.1a51.7 51.7 0 0 1-8.6.9c-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3a63 63 0 0 0 8.7-1.2 42 42 0 0 0 8.5-2.7 46 46 0 0 0 6.6-3.4v-1a50 50 0 0 1-7 3.4 35.3 35.3 0 0 1-8.4 2.5" class="cls-1"></path><path id="Fill-47" d="M50.5 48.3a133 133 0 0 1-14.1.8c-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1a136 136 0 0 0 14.2-1.1 53 53 0 0 0 8.5-2.1 43.3 43.3 0 0 0 6.8-2.9v-1a59 59 0 0 1-7.2 2.8 48.6 48.6 0 0 1-8.3 1.7" class="cls-1"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7a55 55 0 0 0 8.6-1.5c2.3-.6 4.7-1.4 7.2-2.3v-.9a77 77 0 0 1-7.4 2.2 56 56 0 0 1-8.5 1.2" class="cls-1"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9a70 70 0 0 1-7.5 1.4c-2.8.2-5.5.4-8.6.5" class="cls-1"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1L0 60.2v2.6l32.9-.3 8.6-.1c2.9 0 5.7-.1 8.6-.2a152 152 0 0 0 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="cls-1"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1Z" class="cls-1"></path><path id="Fill-52" d="M60.2 22a27.9 27.9 0 0 1-7.5 4.7 39 39 0 0 1-8.8 2c-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6a32 32 0 0 0 8.9-2.6 35.8 35.8 0 0 0 8-5.3 66 66 0 0 0 5.2-5.3v-.9a73 73 0 0 1-5.9 5.6" class="cls-1"></path><path id="Fill-53" d="m94.2 0 14.1 22.4c2.2 3.5 4.7 6.2 13.5 8.1s12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9Z" class="cls-1"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6l-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7L94.3 25z" class="cls-1"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3s12.7 2.1 12.7 2.1v.7l-12.7-2.1c-6-1-9.9-1.3-13.5-4.3-4.2-3.4-14-11.4-14-11.4Z" class="cls-1"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11 5.1 3.5 13.5 4.8l12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9-14-9.7-14-9.7Z" class="cls-1"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8Z" class="cls-1"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7s12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3-8.8-.9-13.5-3c-4.2-1.9-14-6.4-14-6.4Z" class="cls-1"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8a41.4 41.4 0 0 0 13.5 2.8c1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1-8.6-.8-13.5-2.4-14-4.8-14-4.8z" class="cls-1"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1a79.7 79.7 0 0 0 13.5 2.3l12.7 1v.6l-12.7-.9a89 89 0 0 1-13.5-1.6c-3.7-.8-14-3.3-14-3.3Z" class="cls-1"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6Z" class="cls-1"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2Z" class="cls-1"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3s12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="cls-1"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1S94.3 10.9 94.3 10.9v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="cls-1"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="cls-1"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9Z" class="cls-2"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2Z" class="cls-3"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9Z" class="cls-3"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9Z" class="cls-3"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9Z" class="cls-3"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9Z" class="cls-3"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9Z" class="cls-3"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9Z" class="cls-3"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33Z" class="cls-3"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9Z" class="cls-3"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9Z" class="cls-3"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9Z" class="cls-3"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9Z" class="cls-3"></path></g></g></g></g></g></g><path d="M254.2 28h3.3v38.7h-3.3z" class="cls-2"></path><g class="cls-4"><g class="cls-4"><path d="M143.25 39.51a16 16 0 0 1 .2-2.53 6.1 6.1 0 0 1 .79-2.22 4.53 4.53 0 0 1 1.65-1.57 5.6 5.6 0 0 1 2.78-.6h.83c.32 0 .64.05 1 .1a8 8 0 0 1 1 .18 5.3 5.3 0 0 1 .88.27.74.74 0 0 1 .33.24.5.5 0 0 1 .05.38l-.18.82a.43.43 0 0 1-.14.26c-.07.06-.19.07-.38 0l-1.6-.18c-.56 0-1.11-.08-1.63-.08a3.2 3.2 0 0 0-1.65.38 2.6 2.6 0 0 0-.95 1 4.6 4.6 0 0 0-.43 1.53 16 16 0 0 0-.1 1.86 14 14 0 0 0 .12 1.85 4.4 4.4 0 0 0 .46 1.49 2.6 2.6 0 0 0 .95 1 3.13 3.13 0 0 0 1.6.36 14 14 0 0 0 1.64-.08l1.53-.07a.58.58 0 0 1 .38 0 .57.57 0 0 1 .16.29l.16.76a.5.5 0 0 1-.34.64 4 4 0 0 1-.85.27c-.33.07-.66.14-1 .19a9 9 0 0 1-1 .11h-.85a5.7 5.7 0 0 1-2.74-.57 4.46 4.46 0 0 1-1.65-1.51 6.2 6.2 0 0 1-.81-2.15 13.5 13.5 0 0 1-.21-2.42M162.88 41a16 16 0 0 1-.11 1.79 4.7 4.7 0 0 1-.55 1.7 3.45 3.45 0 0 1-1.33 1.26 5 5 0 0 1-2.44.49 4.74 4.74 0 0 1-2.36-.49 3.26 3.26 0 0 1-1.29-1.26 4.3 4.3 0 0 1-.53-1.7 16 16 0 0 1-.1-1.79 10 10 0 0 1 .13-1.56 4.3 4.3 0 0 1 .57-1.62 3.55 3.55 0 0 1 1.29-1.26 4.44 4.44 0 0 1 2.29-.51 5.1 5.1 0 0 1 2.33.44 3.4 3.4 0 0 1 1.34 1.15 4.4 4.4 0 0 1 .61 1.6 10.6 10.6 0 0 1 .15 1.76m-2.23.14a11 11 0 0 0-.08-1.39 2.6 2.6 0 0 0-.32-1 1.5 1.5 0 0 0-.67-.59 2.45 2.45 0 0 0-1.1-.21 2.24 2.24 0 0 0-1 .21 1.4 1.4 0 0 0-.63.6 2.7 2.7 0 0 0-.33 1 9 9 0 0 0-.09 1.37 9.5 9.5 0 0 0 .09 1.4 2.8 2.8 0 0 0 .32 1 1.36 1.36 0 0 0 .62.59 2.24 2.24 0 0 0 1 .21 2.7 2.7 0 0 0 1.12-.2 1.45 1.45 0 0 0 .67-.58 2.6 2.6 0 0 0 .32-1 11 11 0 0 0 .08-1.44ZM179.16 46c0 .07-.14.1-.29.1h-1.45a.34.34 0 0 1-.38-.38V40a2.64 2.64 0 0 0-.3-1.51 1.26 1.26 0 0 0-1.06-.4 2.6 2.6 0 0 0-.63.1c-.24.07-.47.15-.71.24a6 6 0 0 0-.67.29l-.56.28v6.7a.47.47 0 0 1-.08.28.35.35 0 0 1-.3.1h-1.47c-.22 0-.34-.13-.34-.38v-5.8a2.56 2.56 0 0 0-.28-1.36 1.13 1.13 0 0 0-1-.45 2.2 2.2 0 0 0-.59.09 4 4 0 0 0-.69.22q-.34.14-.69.3c-.23.1-.43.2-.62.3v6.7a.34.34 0 0 1-.38.38h-1.47c-.24 0-.36-.13-.36-.38v-9.08c0-.27.12-.4.36-.4h1.43a.35.35 0 0 1 .4.4v.58l.64-.41a5.5 5.5 0 0 1 .73-.37 6 6 0 0 1 .8-.27 3.2 3.2 0 0 1 .8-.15 4.4 4.4 0 0 1 1.58.27 2.3 2.3 0 0 1 1.17 1.13 10 10 0 0 1 1.67-1 4.35 4.35 0 0 1 1.86-.42 3.45 3.45 0 0 1 1.57.3 2.16 2.16 0 0 1 .88.81 3 3 0 0 1 .38 1.2 13 13 0 0 1 .08 1.42v5.9a.47.47 0 0 1-.03.39m16.54 0a.34.34 0 0 1-.29.1H194a.34.34 0 0 1-.38-.38V40a2.64 2.64 0 0 0-.3-1.51 1.28 1.28 0 0 0-1.07-.4 2.7 2.7 0 0 0-.63.1c-.23.07-.47.15-.7.24a5 5 0 0 0-.67.29l-.56.28v6.7a.47.47 0 0 1-.08.28.38.38 0 0 1-.3.1h-1.47c-.23 0-.34-.13-.34-.38v-5.8a2.66 2.66 0 0 0-.28-1.36 1.15 1.15 0 0 0-1-.45 2.3 2.3 0 0 0-.59.09 4 4 0 0 0-.68.22q-.34.14-.69.3c-.23.1-.44.2-.62.3v6.7a.34.34 0 0 1-.39.38h-1.44c-.24 0-.36-.13-.36-.38v-9.08c0-.27.12-.4.36-.4h1.42a.36.36 0 0 1 .41.4v.58l.64-.41a5.5 5.5 0 0 1 .73-.37 6 6 0 0 1 .79-.27 3.3 3.3 0 0 1 .83-.13 4.4 4.4 0 0 1 1.57.27 2.3 2.3 0 0 1 1.18 1.13 9.7 9.7 0 0 1 1.66-1 4.4 4.4 0 0 1 1.87-.42 3.44 3.44 0 0 1 1.56.3 2.1 2.1 0 0 1 .88.81 3 3 0 0 1 .39 1.2 13 13 0 0 1 .08 1.42v5.9a.55.55 0 0 1-.12.37m4.82-12.39a2 2 0 0 1 0 .45.7.7 0 0 1-.17.37.86.86 0 0 1-.36.25 1.7 1.7 0 0 1-.61.09 1.5 1.5 0 0 1-.63-.1.8.8 0 0 1-.36-.26.9.9 0 0 1-.16-.37 3 3 0 0 1 0-.43 1.4 1.4 0 0 1 .23-.81 1.13 1.13 0 0 1 1-.33c.49 0 .81.1 1 .31a1.36 1.36 0 0 1 .06.83m-.12 12.06a.45.45 0 0 1-.07.27.33.33 0 0 1-.29.11h-1.42c-.27 0-.41-.13-.41-.38V36.6c0-.25.14-.38.41-.38H200a.33.33 0 0 1 .29.11.45.45 0 0 1 .07.27Zm9.84-2.57a2.9 2.9 0 0 1-.35 1.48 2.7 2.7 0 0 1-.91 1 3.9 3.9 0 0 1-1.29.52 6.8 6.8 0 0 1-1.51.16 12 12 0 0 1-1.64-.11 6.2 6.2 0 0 1-1.47-.33.7.7 0 0 1-.38-.27.6.6 0 0 1 0-.39l.14-.66c0-.16.08-.26.16-.3a.7.7 0 0 1 .36 0l.71.1.79.07h1.35a2.6 2.6 0 0 0 1.39-.28 1 1 0 0 0 .42-.87 2 2 0 0 0-.07-.56.72.72 0 0 0-.25-.36 1.6 1.6 0 0 0-.49-.23 5.5 5.5 0 0 0-.8-.15c-.49-.07-1-.16-1.4-.26a4.2 4.2 0 0 1-1.18-.48 2.27 2.27 0 0 1-.81-.82 2.6 2.6 0 0 1-.3-1.33 2.66 2.66 0 0 1 1-2.26 4.53 4.53 0 0 1 2.73-.77h.7a8 8 0 0 1 .82.08c.27 0 .54.08.81.14a4 4 0 0 1 .72.2q.51.2.42.6l-.16.72q0 .22-.15.27a.67.67 0 0 1-.39 0l-1.4-.15c-.51 0-.95-.07-1.33-.07a2.07 2.07 0 0 0-1.27.27 1.09 1.09 0 0 0-.31.86.75.75 0 0 0 .39.76 5.2 5.2 0 0 0 1.31.32c.48.07.94.15 1.38.26a4 4 0 0 1 1.15.48 2.4 2.4 0 0 1 .8.87 3 3 0 0 1 .31 1.49m9.21 0a3 3 0 0 1-.34 1.48 2.8 2.8 0 0 1-.92 1 3.9 3.9 0 0 1-1.29.52 6.8 6.8 0 0 1-1.51.16 12 12 0 0 1-1.64-.11 6.2 6.2 0 0 1-1.47-.33.7.7 0 0 1-.38-.27.6.6 0 0 1 0-.39l.14-.66c0-.16.08-.26.16-.3a.7.7 0 0 1 .36 0l.72.1.78.07h1.35a2.6 2.6 0 0 0 1.39-.28 1 1 0 0 0 .42-.87 1.8 1.8 0 0 0-.07-.56.72.72 0 0 0-.25-.36 1.6 1.6 0 0 0-.49-.23 5.5 5.5 0 0 0-.8-.15c-.49-.07-1-.16-1.4-.26a4.3 4.3 0 0 1-1.21-.46 2.27 2.27 0 0 1-.81-.82 2.6 2.6 0 0 1-.3-1.33 2.66 2.66 0 0 1 1-2.26 4.53 4.53 0 0 1 2.73-.77h.71a8 8 0 0 1 .81.08c.27 0 .54.08.81.14a4 4 0 0 1 .72.2q.51.2.42.6l-.16.72q0 .22-.15.27a.67.67 0 0 1-.39 0l-1.4-.15c-.51 0-1-.07-1.33-.07a2.07 2.07 0 0 0-1.27.27 1.09 1.09 0 0 0-.31.86.75.75 0 0 0 .39.76 5.2 5.2 0 0 0 1.31.32 14 14 0 0 1 1.38.26 4 4 0 0 1 1.15.48 2.5 2.5 0 0 1 .81.87 3 3 0 0 1 .33 1.47m4.45-9.49a2 2 0 0 1 0 .45.8.8 0 0 1-.17.37.86.86 0 0 1-.36.25 1.8 1.8 0 0 1-.61.09 1.6 1.6 0 0 1-.64-.1.8.8 0 0 1-.35-.26.9.9 0 0 1-.16-.37 3 3 0 0 1 0-.43 1.4 1.4 0 0 1 .23-.81 1.13 1.13 0 0 1 1-.33c.49 0 .81.1 1 .31a1.36 1.36 0 0 1 .06.83m-.12 12.06a.45.45 0 0 1-.07.27.33.33 0 0 1-.29.11H222c-.27 0-.41-.13-.41-.38V36.6c0-.25.14-.38.41-.38h1.42a.33.33 0 0 1 .29.11.45.45 0 0 1 .07.27Zm11-4.67a16 16 0 0 1-.11 1.79 4.7 4.7 0 0 1-.55 1.7 3.45 3.45 0 0 1-1.33 1.26 5 5 0 0 1-2.44.49 4.74 4.74 0 0 1-2.36-.49 3.4 3.4 0 0 1-1.29-1.26 4.45 4.45 0 0 1-.53-1.7 16 16 0 0 1-.1-1.79 10 10 0 0 1 .13-1.56 4.7 4.7 0 0 1 .57-1.62 3.55 3.55 0 0 1 1.29-1.26 4.44 4.44 0 0 1 2.29-.51 5.2 5.2 0 0 1 2.34.44 3.35 3.35 0 0 1 1.31 1.12 4.4 4.4 0 0 1 .61 1.6 10.6 10.6 0 0 1 .17 1.79m-2.23.14a11 11 0 0 0-.08-1.39 2.5 2.5 0 0 0-.32-1 1.5 1.5 0 0 0-.66-.59 2.5 2.5 0 0 0-1.11-.21 2.24 2.24 0 0 0-1 .21 1.4 1.4 0 0 0-.63.6 2.7 2.7 0 0 0-.32 1 9 9 0 0 0-.09 1.37 9.5 9.5 0 0 0 .09 1.4 2.8 2.8 0 0 0 .31 1 1.36 1.36 0 0 0 .62.59 2.24 2.24 0 0 0 1 .21 2.7 2.7 0 0 0 1.12-.2 1.45 1.45 0 0 0 .67-.58 2.5 2.5 0 0 0 .32-1 11 11 0 0 0 .08-1.44ZM245.19 46a.35.35 0 0 1-.3.1h-1.46a.34.34 0 0 1-.39-.38v-5.64a2.9 2.9 0 0 0-.3-1.42 1.16 1.16 0 0 0-1.15-.55 3.2 3.2 0 0 0-.69.1 8 8 0 0 0-.78.26l-.74.3-.54.25v6.7a.34.34 0 0 1-.38.38h-1.42a.34.34 0 0 1-.39-.38v-9.1a.35.35 0 0 1 .39-.4h1.42c.25 0 .38.13.38.4v.6h.06a6 6 0 0 1 .68-.41 9 9 0 0 1 .83-.39 5.6 5.6 0 0 1 .93-.29 3.8 3.8 0 0 1 .94-.11 3.4 3.4 0 0 1 1.61.31 2.17 2.17 0 0 1 .89.83 3.1 3.1 0 0 1 .38 1.22 11 11 0 0 1 .08 1.45v5.82a.41.41 0 0 1-.05.35" class="cls-5"></path></g><g class="cls-4"><path d="M145.16 62a4.7 4.7 0 0 0 .17 1.26 1.73 1.73 0 0 0 .45.79 1.63 1.63 0 0 0 .74.41 3.7 3.7 0 0 0 1.06.13c.37 0 .79 0 1.29-.08l1.32-.15a.9.9 0 0 1 .39 0c.08 0 .13.15.16.34l.12.66a.8.8 0 0 1 0 .36.6.6 0 0 1-.34.26 4.5 4.5 0 0 1-.7.21q-.41.09-.84.15l-.88.1a8 8 0 0 1-.81 0 5.3 5.3 0 0 1-2.3-.42 3.3 3.3 0 0 1-1.34-1.02 4.1 4.1 0 0 1-.61-1.62 12 12 0 0 1-.15-1.89 12 12 0 0 1 .12-1.63 4.8 4.8 0 0 1 .55-1.69 3.6 3.6 0 0 1 1.29-1.31 4.27 4.27 0 0 1 2.31-.53 5 5 0 0 1 2.18.4 3.3 3.3 0 0 1 1.29 1 3.7 3.7 0 0 1 .64 1.45 10 10 0 0 1 .19 1.61 1.7 1.7 0 0 1-.18.89.88.88 0 0 1-.81.34Zm2-3.9a2.4 2.4 0 0 0-.92.16 1.5 1.5 0 0 0-.59.47 1.8 1.8 0 0 0-.33.76 5.6 5.6 0 0 0-.14 1h4a5 5 0 0 0-.08-.88 2.2 2.2 0 0 0-.29-.77 1.5 1.5 0 0 0-.6-.54 2.3 2.3 0 0 0-1.05-.16Zm14.25 8.25H160a.35.35 0 0 1-.3-.1.4.4 0 0 1-.08-.28v-.62c-.21.13-.44.27-.7.41a9 9 0 0 1-.83.39 5.7 5.7 0 0 1-.91.29 4.4 4.4 0 0 1-.94.11 3.75 3.75 0 0 1-1.61-.28 2 2 0 0 1-.89-.78 2.9 2.9 0 0 1-.39-1.19 13 13 0 0 1-.08-1.46v-5.9a.35.35 0 0 1 .39-.4h1.48c.24 0 .36.13.36.4v5.64a5 5 0 0 0 .06.82 1.5 1.5 0 0 0 .22.61 1 1 0 0 0 .44.39 1.6 1.6 0 0 0 .74.15 2.8 2.8 0 0 0 .71-.11 6 6 0 0 0 .77-.25l.7-.3.52-.25v-6.7a.43.43 0 0 1 .08-.29.35.35 0 0 1 .3-.11h1.42c.26 0 .38.13.38.4v9a.33.33 0 0 1-.43.41m5.12-.35a.34.34 0 0 1-.39.38h-1.45a.34.34 0 0 1-.39-.38v-9a.35.35 0 0 1 .39-.4h1.43a.36.36 0 0 1 .41.4v.88a6 6 0 0 1 .58-.43 8 8 0 0 1 .77-.42c.28-.13.56-.24.84-.35a4 4 0 0 1 .78-.22.48.48 0 0 1 .32 0c.08 0 .13.15.16.32l.14 1.34a.7.7 0 0 1 0 .32c0 .07-.15.12-.36.16s-.58.12-.88.2-.61.15-.91.24l-.82.25a6 6 0 0 0-.64.24Zm13.22-4.73a14 14 0 0 1-.11 1.79 4.3 4.3 0 0 1-.55 1.7 3.35 3.35 0 0 1-1.32 1.24 5 5 0 0 1-2.44.49A4.74 4.74 0 0 1 173 66a3.36 3.36 0 0 1-1.3-1.26 4.6 4.6 0 0 1-.53-1.7c-.06-.61-.1-1.21-.1-1.79a12 12 0 0 1 .13-1.56 4.7 4.7 0 0 1 .57-1.62 3.66 3.66 0 0 1 1.3-1.26 4.4 4.4 0 0 1 2.29-.51 5.1 5.1 0 0 1 2.33.44 3.35 3.35 0 0 1 1.31 1.17 4.2 4.2 0 0 1 .61 1.6 10.6 10.6 0 0 1 .14 1.76m-2.22.14a11 11 0 0 0-.08-1.39 2.6 2.6 0 0 0-.33-1 1.5 1.5 0 0 0-.66-.59 2.5 2.5 0 0 0-1.1-.21 2.3 2.3 0 0 0-1.05.21 1.5 1.5 0 0 0-.63.6 2.9 2.9 0 0 0-.32 1 9 9 0 0 0-.09 1.37 9.5 9.5 0 0 0 .09 1.4 2.8 2.8 0 0 0 .31 1 1.47 1.47 0 0 0 .62.59 2.3 2.3 0 0 0 1.05.21 2.7 2.7 0 0 0 1.11-.2 1.4 1.4 0 0 0 .67-.58 2.6 2.6 0 0 0 .33-1 11 11 0 0 0 .08-1.41m12.88-.04a12 12 0 0 1-.18 2.19 4.3 4.3 0 0 1-.63 1.63 2.9 2.9 0 0 1-1.23 1 4.8 4.8 0 0 1-2 .34 7.4 7.4 0 0 1-1.16-.1 8.3 8.3 0 0 1-1.35-.34v3.53a.6.6 0 0 1-.07.28c0 .08-.15.12-.32.12h-1.42c-.16 0-.26 0-.31-.1a.47.47 0 0 1-.07-.3v-12.7c0-.27.13-.4.38-.4h1.42a.35.35 0 0 1 .3.11.6.6 0 0 1 .07.29v.6h.06a7 7 0 0 1 .63-.39 8 8 0 0 1 .79-.39 7 7 0 0 1 .86-.3 3.4 3.4 0 0 1 .89-.12 3.3 3.3 0 0 1 1.62.36 2.67 2.67 0 0 1 1 1 4.9 4.9 0 0 1 .52 1.58 13 13 0 0 1 .2 2.11m-2.27 0a10.5 10.5 0 0 0-.09-1.54 2.4 2.4 0 0 0-.29-.9 1 1 0 0 0-.49-.44 2.1 2.1 0 0 0-.69-.11 3.2 3.2 0 0 0-.69.1q-.37.1-.75.24a5 5 0 0 0-.7.29c-.22.1-.41.2-.55.28v5a7.6 7.6 0 0 0 1.23.28 10 10 0 0 0 1.07.07 2.7 2.7 0 0 0 .92-.15 1.3 1.3 0 0 0 .6-.54 2.9 2.9 0 0 0 .33-1 10 10 0 0 0 .1-1.6Zm6.12.63a4.7 4.7 0 0 0 .17 1.26 1.73 1.73 0 0 0 .45.79 1.6 1.6 0 0 0 .75.41 3.7 3.7 0 0 0 1.06.13c.36 0 .79 0 1.28-.08l1.33-.15a.9.9 0 0 1 .39 0c.07 0 .12.15.15.34l.12.66a.7.7 0 0 1 0 .36c0 .09-.14.18-.33.26a5 5 0 0 1-.7.21c-.27.06-.55.11-.85.15l-.88.1a8 8 0 0 1-.8 0 5.4 5.4 0 0 1-2.31-.42 3.26 3.26 0 0 1-1.33-1.02 4.3 4.3 0 0 1-.62-1.62 12 12 0 0 1-.15-1.89 12 12 0 0 1 .12-1.63 4.8 4.8 0 0 1 .56-1.69 3.5 3.5 0 0 1 1.33-1.32 4.3 4.3 0 0 1 2.32-.53 5 5 0 0 1 2.18.4 3.45 3.45 0 0 1 1.29 1 3.6 3.6 0 0 1 .63 1.45 8 8 0 0 1 .19 1.61 1.53 1.53 0 0 1-.18.89.86.86 0 0 1-.8.34Zm2-3.9a2.4 2.4 0 0 0-.92.16 1.56 1.56 0 0 0-.6.47 2.1 2.1 0 0 0-.33.76 8 8 0 0 0-.14 1h4a4.2 4.2 0 0 0-.08-.88 2.2 2.2 0 0 0-.29-.77 1.5 1.5 0 0 0-.6-.54 2.3 2.3 0 0 0-1.03-.16Zm2.67-6c.2.11.23.26.08.45L197 55.37a.28.28 0 0 1-.38.12l-.78-.36c-.15-.08-.18-.2-.1-.38l1.6-3.11c.08-.17.23-.21.44-.12Zm5.53 9.9a4.7 4.7 0 0 0 .17 1.26 1.73 1.73 0 0 0 .45.79 1.63 1.63 0 0 0 .74.41 3.7 3.7 0 0 0 1.06.13c.37 0 .79 0 1.29-.08l1.32-.15a.9.9 0 0 1 .39 0c.08 0 .13.15.15.34l.12.66a.6.6 0 0 1 0 .36c0 .09-.14.18-.33.26a4.5 4.5 0 0 1-.7.21q-.41.09-.84.15l-.88.1a8 8 0 0 1-.81 0 5.3 5.3 0 0 1-2.3-.42A3.3 3.3 0 0 1 203 65a4.1 4.1 0 0 1-.61-1.62 12 12 0 0 1-.15-1.89 12 12 0 0 1 .12-1.63 4.8 4.8 0 0 1 .55-1.69 3.64 3.64 0 0 1 1.28-1.31 4.33 4.33 0 0 1 2.32-.53 5 5 0 0 1 2.18.4 3.4 3.4 0 0 1 1.29 1 3.7 3.7 0 0 1 .64 1.45 10 10 0 0 1 .19 1.61 1.7 1.7 0 0 1-.18.89.89.89 0 0 1-.81.34Zm2-3.9a2.4 2.4 0 0 0-.92.16 1.5 1.5 0 0 0-.59.47 1.8 1.8 0 0 0-.33.76 5.6 5.6 0 0 0-.14 1h4a5 5 0 0 0-.08-.88 2.2 2.2 0 0 0-.29-.77 1.5 1.5 0 0 0-.6-.54 2.3 2.3 0 0 0-1.05-.16ZM221 66.25a.35.35 0 0 1-.3.1h-1.46a.34.34 0 0 1-.39-.38v-5.64a2.9 2.9 0 0 0-.29-1.42 1.17 1.17 0 0 0-1.15-.55 3.2 3.2 0 0 0-.69.1 7 7 0 0 0-.79.26l-.73.3-.54.25V66a.34.34 0 0 1-.38.38h-1.43a.34.34 0 0 1-.38-.38v-9c0-.27.13-.4.38-.4h1.43c.25 0 .38.13.38.4v.6h.06a7 7 0 0 1 .67-.41c.27-.14.54-.27.84-.39a5.6 5.6 0 0 1 .93-.29 3.8 3.8 0 0 1 .94-.11 3.4 3.4 0 0 1 1.61.31 2.17 2.17 0 0 1 .89.83 3.1 3.1 0 0 1 .4 1.16 13 13 0 0 1 .08 1.45V66a.47.47 0 0 1-.08.25m10.61 0a.4.4 0 0 1-.31.1h-1.46a.34.34 0 0 1-.38-.38v-5.64a3 3 0 0 0-.29-1.42 1.17 1.17 0 0 0-1.15-.55 3.2 3.2 0 0 0-.7.1 6 6 0 0 0-.78.26l-.73.3-.54.25V66a.34.34 0 0 1-.39.38h-1.42a.34.34 0 0 1-.38-.38v-9c0-.27.13-.4.38-.4h1.42a.35.35 0 0 1 .39.4v.6h.06a6 6 0 0 1 .67-.41 8 8 0 0 1 .84-.39 5.5 5.5 0 0 1 .92-.29 4 4 0 0 1 .95-.11 3.44 3.44 0 0 1 1.61.31 2.14 2.14 0 0 1 .88.83 3.1 3.1 0 0 1 .39 1.22 13 13 0 0 1 .08 1.45V66a.47.47 0 0 1-.06.25m4.23-4.25a4.7 4.7 0 0 0 .16 1.3 1.73 1.73 0 0 0 .45.79 1.6 1.6 0 0 0 .75.41 3.6 3.6 0 0 0 1.06.13c.36 0 .79 0 1.28-.08l1.33-.15a.9.9 0 0 1 .39 0c.07 0 .12.15.15.34l.12.66a.7.7 0 0 1 0 .36c0 .09-.14.18-.33.26a5 5 0 0 1-.7.21c-.27.06-.55.11-.85.15l-.88.1a8 8 0 0 1-.8 0 5.3 5.3 0 0 1-2.31-.42 3.2 3.2 0 0 1-1.32-1.06 4.1 4.1 0 0 1-.62-1.62 12 12 0 0 1-.15-1.89 12 12 0 0 1 .12-1.63 4.8 4.8 0 0 1 .56-1.69 3.5 3.5 0 0 1 1.28-1.31 4.3 4.3 0 0 1 2.32-.53 5.05 5.05 0 0 1 2.18.4 3.45 3.45 0 0 1 1.29 1 3.6 3.6 0 0 1 .68 1.47 8 8 0 0 1 .19 1.61 1.53 1.53 0 0 1-.18.89.86.86 0 0 1-.8.34Zm2-3.9a2.5 2.5 0 0 0-.93.16 1.6 1.6 0 0 0-.59.47 2.1 2.1 0 0 0-.33.76 7 7 0 0 0-.14 1h4a4.2 4.2 0 0 0-.08-.88 2.2 2.2 0 0 0-.29-.77 1.5 1.5 0 0 0-.6-.54 2.3 2.3 0 0 0-1.03-.16Z" class="cls-5"></path></g></g>', 3);
function ZZ(t, e) {
  return T(), N("svg", XZ, [
    C("defs", null, [
      (T(), v2(be("style"), null, {
        default: Q2(() => [
          K3(".cls-1{fill:#bbbdbf}.cls-2{fill:#034da1}.cls-3{fill:#fff100}.cls-4{isolation:isolate}.cls-5{fill:#626366}")
        ]),
        _: 1
      }))
    ]),
    KZ
  ]);
}
const JZ = { render: ZZ }, QZ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, eJ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M144.6 45.6c-.1.2-.1.3-.2.3-.1.1-.2.1-.3.1h-1.6c-.2 0-.3-.1-.2-.4l4.1-12.5c.1-.1.1-.3.2-.3.1-.1.2-.1.4-.1h1.7c.2 0 .3 0 .4.1s.1.2.2.3l4.1 12.5c.1.2 0 .4-.2.4h-1.8c-.2 0-.3 0-.3-.1-.1-.1-.1-.2-.2-.3l-.8-2.9h-4.5zm4-7.6-.8-2.9h-.1l-.8 2.8-.8 2.9h3.4zm14.5 8c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3v6.7c0 .3-.1.4-.4.4H155c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.8c.1 0 .1.1 0 .2m8-6.5c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.9.3c.2.1.3.1.3.2s.1.2.1.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.7 0-1.2.1-1.6.4s-.7.6-1 1-.4 1-.4 1.5c-.1.6-.1 1.2-.1 1.9s0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1s-.5-1.5-.5-2.4m19.6 1.5c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m6.8-7.5v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm16.8.3c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1H204c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4H198c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4c.3-.1.5-.2.8-.3s.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c-.1.2-.1.3-.1.4m4.8-12.4v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.5-9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.2 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1H229c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm11 0c0 .3-.1.4-.4.4H240c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.4zM240 31.8c.2.1.2.3.1.4l-2 2.8c-.1.1-.2.2-.4.1l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1zM252.4 46c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3v6.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.8c.2 0 .2.1.1.2" class="st4"></path></g><g class="st3"><path d="M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.8 7.9c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m6.8 4.6c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3s-.5.2-.6.2V66zm13.4-4.6c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1s-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5q-.15-.6-.3-.9c-.1-.2-.3-.4-.5-.4-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m10.2 3.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm12.2 3.5v.4c0 .1-.2.2-.3.3-.4.2-.9.3-1.4.4-.6.1-1.1.1-1.6.1-.9 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.1-1.3-.1-2c0-.6.1-1.2.2-1.8s.3-1.2.6-1.6c.3-.5.7-.9 1.3-1.2s1.3-.4 2.2-.4h.8c.3 0 .5 0 .8.1.3 0 .5.1.8.2s.5.1.7.2q.3.15.3.6l-.1.8c0 .1-.1.2-.2.3h-.4c-.4 0-.8-.1-1.3-.1s-.8-.1-1.2-.1c-.8 0-1.4.2-1.7.7s-.5 1.3-.5 2.4c0 .6 0 1.1.1 1.6.1.4.2.7.4 1s.4.4.7.5.6.2 1 .2c.3 0 .7 0 1.2-.1.5 0 1-.1 1.4-.1h.4c.1 0 .1.1.2.3zm9.7 1h-1.4c-.3 0-.4-.1-.4-.4v-5.8c0-.6-.1-1-.3-1.4-.2-.3-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.2V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v4.9c.2-.1.4-.2.6-.4s.5-.2.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66c.2.2.1.4-.2.4" class="st4"></path></g><path d="M262.2 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function tJ(t, e) {
  return T(), N("svg", QZ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    eJ
  ]);
}
const nJ = { render: tJ }, iJ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "67",
  fill: "none",
  viewBox: "0 0 290 67"
}, sJ = /* @__PURE__ */ U1('<path fill="#004494" fill-rule="evenodd" d="M43.455 66.4h3.3V27.7h-3.3z" clip-rule="evenodd"></path><path fill="#626366" d="M147.499 33.639v8.404h-2.246v-8.428q0-2.151-.911-3.039-.898-.888-3.12-.888h-5.657V27.7h5.694q2.234 0 3.605.608 1.372.595 2.004 1.905.631 1.297.631 3.425m-9.458-.912v9.316h-2.234v-9.316zm-6.325.527v8.79h-6.811v-1.987h4.577V33.86q0-1.894-.194-2.677-.195-.807-.68-1.146-.474-.35-1.372-.35h-1.639V27.7h1.566q1.943 0 2.841.514.898.526 1.299 1.718.413 1.18.413 3.32m-8.754 6.944v1.847h-11.46v-1.987h8.68L110.603 27.7h2.792l4.626 6.054q.935-.386 1.36-1.133.424-.76.571-2.315l.279-2.606h2.307l-.243 2.56q-.158 1.612-.498 2.478a3.74 3.74 0 0 1-.959 1.414q-.62.561-1.748.993zM107.859 27.7v7.54h-2.234V27.7zm-4.723 12.356v1.987H90.134v-1.987h9.154v-6.44q0-2.152-.91-3.04-.9-.888-3.12-.888h-4.554V27.7h4.577q3.351 0 4.796 1.38 1.445 1.378 1.445 4.558v6.417zM87.026 27.7v14.343h-2.234V27.7zM70.502 39.822q-.413 1.18-1.311 1.706-.9.515-2.829.515h-.134v-1.987h.207q.838 0 1.335-.304.486-.304.692-.924.207-.63.207-1.905v-7.235h-2.307V27.7h8.05q3.35 0 4.807 1.38 1.457 1.366 1.457 4.558v8.404h-2.234v-8.428q0-2.151-.91-3.039-.9-.888-3.145-.888h-3.484v6.803q0 2.15-.401 3.33m76.997 18.16v8.405h-2.224v-8.428q0-2.151-.901-3.039-.89-.888-3.089-.888h-5.601v-1.987h5.637q2.211 0 3.57.608 1.357.596 1.983 1.905.625 1.297.625 3.425m-9.363-.911v9.316h-2.212V57.07zm-15.65 4.604-.962 4.71h-2.331l1.009-4.663q.433-2.01.794-2.829.36-.83.901-1.344.553-.514 1.478-.877l-3.473-4.628h2.728l5.421 7.258a6 6 0 0 0 1.43-1.975q.541-1.17.71-2.677l.276-2.606h2.284l-.277 2.56q-.132 1.286-.48 2.255a9 9 0 0 1-.577 1.275q-.337.596-.866 1.238-.516.643-1.346 1.438l4.339 5.576h-2.812l-6.347-8.381q-.962.456-1.37 1.578a6 6 0 0 0-.253.818q-.12.525-.276 1.274m-6.178-9.631v7.539h-2.212v-7.54zm-6.274 5.937v8.405h-2.224v-8.428q0-2.127-.89-3.027-.876-.9-3.089-.9h-4.507v-1.987h4.531q2.213 0 3.57.608 1.359.596 1.984 1.905.625 1.297.625 3.425m-13.27-5.938v14.342h-2.212V52.043zm-7.909 6.37q0-2.209-.998-3.296-.997-1.087-3.137-1.087h-3.317v4.044h2.92v1.987h-5.168v-8.018h5.59q3.22 0 4.783 1.566 1.575 1.554 1.575 4.85v.96q0 6.966-6.78 6.966h-5.036v-1.988h5.096q2.284 0 3.378-1.227 1.094-1.24 1.094-3.728zm-14.015-6.37v7.539h-2.212v-7.54zM58.986 64.164q-.409 1.18-1.298 1.706-.89.515-2.8.515h-.133v-1.988h.204q.83 0 1.322-.303.481-.304.686-.924.204-.63.204-1.905V54.03h-2.284v-1.987h7.97q3.316 0 4.759 1.379 1.442 1.367 1.442 4.559v8.404h-2.211v-8.428q0-2.151-.902-3.039-.889-.888-3.113-.888h-3.45v6.803q0 2.15-.396 3.33"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M155.499 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4-.5 0-37.5 3.9-37.5 3.9z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M208.899 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M215.899 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6l-39.8 3.2v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M206.299 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1l-16.7 1.2v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M207.099 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M206.699 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M206.299 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2l-37.9 1v2.6l33.6-1.8 4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M205.999 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1l-33.2.6v2.6l33.3-1.4c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M205.799 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2m-.2 4.2c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1l-15.8.1v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101c-10.9-.2-21.8-.399-32.9-.599v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6-66.1-1.7v2.6h66.1zm-5.9-43.5c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2l-34.9 2.5v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6M249.7 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.7 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.7 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.7 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.7 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M249.699 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S249.8 5.4 249.8 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M277.2 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M277.2 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" d="M182.999 66h57.9V28h-57.9z" clip-rule="evenodd"></path><path fill="#FFF100" fill-rule="evenodd" d="M212.6 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L210.4 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.799 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM225.6 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM206 34.8h2l-1.6 1.2.6 1.901-1.5-1.101-1.7 1.2.6-1.9-1.6-1.2h2l.7-1.9zm-4.602 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm-1.699 6.4h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.699 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.702 4.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" clip-rule="evenodd"></path>', 20), lJ = [
  sJ
];
function rJ(t, e) {
  return T(), N("svg", iJ, [...lJ]);
}
const aJ = { render: rJ }, oJ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, cJ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m11.4 2q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3s-.2 0-.4 0c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.2-3.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V32.3c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.6 5c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.4-.6v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.2-.2-.4-.5-.5-1m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><g class="st3"><path d="m145.4 60.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm15.7 1.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3s-.2 0-.4 0c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.5-9.5v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.2 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm5.3.6c0 .7-.1 1.2-.2 1.7s-.4.9-.8 1.3c-.4.3-.8.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.3-.1s-.2-.2-.2-.3l-.1-.9V69c0-.1.1-.1.3-.1q.75-.15 1.2-.3c.45-.15.6-.2.8-.4.2-.1.3-.3.4-.6.1-.2.1-.5.1-.9V57c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v9.6zm.1-12.7v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m8.6 11.3c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M231.2 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function hJ(t, e) {
  return T(), N("svg", oJ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    cJ
  ]);
}
const uJ = { render: hJ }, dJ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, fJ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m.4-9.3c.2.1.2.3.1.4l-2 2.8c-.1.1-.2.2-.4.1l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1zm12.5 9.3c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m10.3 3.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm7.3-8v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3z" class="st4"></path></g><g class="st3"><path d="M152.8 62.6c0 .6-.1 1.1-.3 1.6s-.5.9-.8 1.2c-.4.3-.8.6-1.2.8q-.75.3-1.5.3h-5.1c-.2 0-.3 0-.4-.1s-.1-.2-.1-.3V53.4c0-.3.1-.4.4-.4h4.6c1.3 0 2.3.3 3 1 .7.6 1 1.5 1 2.6 0 .2 0 .4-.1.7s-.1.5-.3.8c-.1.3-.3.5-.5.7s-.5.4-.8.6c.4.1.7.3 1 .6s.5.5.6.8l.3.9c.1.3.2.6.2.9m-2.7-5.8c0-.5-.2-.9-.5-1.3-.3-.3-.8-.5-1.5-.5h-2.4v3.5h2.6c.5 0 .9-.2 1.3-.5.3-.3.5-.7.5-1.2m.4 5.6c0-.5-.2-1-.5-1.4s-.9-.6-1.6-.6h-2.7v4h2.7c.4 0 .7-.1 1-.2s.5-.3.6-.4.3-.4.3-.6.2-.5.2-.8m6.9-8.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.3-1.5c.3 0 .4.1.4.4V66c0 .3-.1.4-.4.4h-7q-.3 0-.3-.3v-1.2c0-.1.1-.2.2-.3l4.8-6.1H160c-.3 0-.4-.1-.4-.4V57c0-.2.1-.4.4-.4h6.6c.1 0 .2 0 .3.1.1 0 .1.1.1.3v1c0 .2-.1.5-.2.7l-4.7 6h4.5zm10.7-3.2c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m10.3 4.2c0 .2 0 .4-.3.5-.2.1-.4.1-.6.2s-.5.1-.7.1-.5.1-.7.1h-.6c-.6 0-1-.1-1.4-.2-.3-.2-.6-.4-.7-.7-.2-.3-.3-.6-.3-1s-.1-.8-.1-1.2v-5h-1c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-1c0-.1 0-.2.1-.3s.2-.1.3-.1h1v-2.1c0-.1 0-.3.1-.3.1-.1.2-.1.3-.1l1.3-.4c.3-.1.4 0 .4.2v2.6h2.1c.2 0 .3 0 .3.1s.1.2.1.3v1c0 .1 0 .2-.1.3 0 .1-.2.1-.3.1h-2.1v5c0 .3 0 .5.1.6s.1.3.2.3c.1.1.2.1.4.1h1.3c.3 0 .5 0 .7-.1h.2s.1.1.1.2zm7.3 0c0 .2 0 .4-.3.5-.2.1-.4.1-.6.2s-.5.1-.7.1-.5.1-.7.1h-.6c-.6 0-1-.1-1.4-.2-.3-.2-.6-.4-.7-.7-.2-.3-.3-.6-.3-1s-.1-.8-.1-1.2v-5h-1c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-1c0-.1 0-.2.1-.3s.2-.1.3-.1h1v-2.1c0-.1 0-.3.1-.3.1-.1.2-.1.3-.1l1.3-.4c.3-.1.4 0 .4.2v2.6h2.1c.2 0 .3 0 .3.1s.1.2.1.3v1c0 .1 0 .2-.1.3 0 .1-.2.1-.3.1h-2.1v5c0 .3 0 .5.1.6s.1.3.2.3c.1.1.2.1.4.1h1.3c.3 0 .5 0 .7-.1h.2s.1.1.1.2zm8.4-2.2q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m8.1 1.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.9-9.8c.2.1.2.3.1.4l-2 2.8c-.1.1-.2.2-.4.1l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1zm8.1 4.2c.6 0 1.3 0 2 .1s1.3.2 1.8.4c.2.1.4.2.5.4s.1.3.1.5v8.5c0 .6 0 1.1-.1 1.6s-.3.9-.6 1.3-.7.6-1.3.8-1.3.3-2.3.3c-.5 0-1.1 0-1.7-.1s-1.1-.2-1.5-.4c-.2-.1-.3-.2-.4-.3s0-.2 0-.3l.2-.7c0-.2.1-.3.2-.3h.4c.5.1.9.1 1.4.2h1.3c.4 0 .8 0 1.1-.1s.5-.2.7-.3q.3-.15.3-.6c.1-.2.1-.5.1-.8V66c-.5.2-1 .3-1.4.4s-.8.1-1.1.1c-.8 0-1.5-.1-2-.4-.5-.2-.9-.6-1.2-1s-.5-1-.6-1.6-.2-1.3-.2-2c0-.8.1-1.5.2-2.1s.4-1.2.7-1.6.8-.8 1.4-1c.4-.4 1.1-.5 2-.5m-2.1 5c0 .6 0 1.1.1 1.5s.2.7.3 1c.2.2.4.4.6.5s.5.2.9.2c.3 0 .6 0 1-.1s.8-.1 1.2-.3v-5.7c-.3-.1-.6-.1-1-.1s-.7-.1-1-.1-.6 0-.9.1-.5.2-.7.4-.4.5-.5.9z" class="st4"></path></g><path d="M232.2 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function vJ(t, e) {
  return T(), N("svg", dJ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    fJ
  ]);
}
const pJ = { render: vJ }, mJ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, gJ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6M94.201 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.701 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L54.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#626366" d="M143 36.523q0-.3.314-.3h5.664q.299 0 .299.3v.98q0 .285-.314.284h-4.19v2.716h3.656q.298 0 .298.285v.979q0 .3-.314.3h-3.624v4.343q0 .3-.298.3h-1.177q-.314 0-.314-.3zm9.387 9.887q0 .3-.298.3h-1.129q-.299 0-.299-.3v-7.123q0-.316.299-.316h1.114q.313 0 .313.316v.695l.032.032q.173-.159.455-.332.282-.19.596-.332.33-.158.659-.284.33-.126.612-.174a.4.4 0 0 1 .251.016q.095.048.126.253l.11 1.058q.015.174-.016.253-.031.078-.283.126-.329.063-.69.158a8 8 0 0 0-.706.19q-.345.094-.643.19a4 4 0 0 0-.503.189zm8.462-3.222h-1.914q-.597 0-.942.285-.345.268-.345 1.042 0 .521.204.727.22.19.769.19.25 0 .549-.064.299-.063.596-.174a10 10 0 0 0 .581-.237q.282-.142.502-.268zm.094 2.622a5.2 5.2 0 0 1-1.349.742 4.2 4.2 0 0 1-1.538.285q-.628 0-1.051-.158a1.8 1.8 0 0 1-.659-.458 2 2 0 0 1-.346-.711 4 4 0 0 1-.094-.916q-.016-1.39.722-2.006.738-.632 2.228-.632h2.009v-.41q0-.348-.079-.585a.76.76 0 0 0-.251-.41 1.1 1.1 0 0 0-.502-.221 4 4 0 0 0-.8-.063 9 9 0 0 0-.471.015l-.565.032q-.282.015-.58.047a12 12 0 0 1-.518.048 1.3 1.3 0 0 1-.33.015q-.078-.031-.11-.205l-.141-.584q-.031-.159.032-.253.063-.11.329-.221.251-.095.596-.158a8 8 0 0 1 .707-.095q.36-.047.706-.063.36-.032.643-.032 1.02 0 1.616.206.612.205.926.584.314.363.408.9t.094 1.2v3.049q0 .237.016.379a.8.8 0 0 0 .078.205q.063.063.173.095t.298.047q.173.016.235.064.063.048.063.173v.664q0 .269-.376.331a5 5 0 0 1-.377.048 2 2 0 0 1-.361.031q-.549 0-.894-.205-.33-.206-.455-.758zm14.86.6q0 .143-.062.221-.048.08-.22.08h-1.13q-.298 0-.298-.3v-4.486q0-.885-.235-1.185-.235-.316-.832-.316a2 2 0 0 0-.502.08 7 7 0 0 0-.549.189 5 5 0 0 0-.518.221l-.439.221v.332q.015.206.015.474v4.47a.35.35 0 0 1-.062.22q-.063.08-.236.08h-1.145q-.267 0-.267-.3v-4.565q0-.726-.22-1.074-.219-.348-.816-.348-.204 0-.47.064-.252.063-.534.173a11 11 0 0 0-.533.237q-.267.126-.487.237v5.275q0 .3-.298.3h-1.13q-.282 0-.282-.3v-7.123q0-.316.282-.316h1.114q.315 0 .314.316v.458l.016.016q.235-.157.502-.316a3.6 3.6 0 0 1 .565-.3 5 5 0 0 1 .628-.205q.313-.095.643-.11.675 0 1.224.22.564.206.926.885a7.6 7.6 0 0 1 1.302-.774 3.4 3.4 0 0 1 1.459-.332q.77 0 1.224.237.456.237.691.648.234.395.298.931.063.537.062 1.122zm3.487-4.58 1.209-1.28 1.302-1.326q.126-.126.235-.19.11-.078.33-.078h1.255q.22 0 .251.11.047.11-.078.253l-2.511 2.574 2.825 4.454q.078.143.015.253-.047.11-.219.11h-1.209q-.25 0-.361-.079a.7.7 0 0 1-.188-.22l-2.008-3.239-.895.917v2.321a.4.4 0 0 1-.062.221q-.063.08-.236.08h-1.114q-.298 0-.298-.3V35.875q0-.316.298-.316h1.114q.173 0 .236.095a.35.35 0 0 1 .062.22v5.94zm8.919 2.938q0-.047.094-.332l.204-.648q.125-.41.299-.9l1.255-3.664a.5.5 0 0 1 .11-.19q.078-.063.251-.063h1.192q.314 0 .189.3l-2.668 7.108a.6.6 0 0 1-.157.252q-.094.08-.282.08h-1.052q-.219 0-.298-.064a.7.7 0 0 1-.141-.252l-2.667-7.108a.33.33 0 0 1-.016-.22q.031-.096.188-.096h1.24q.172 0 .235.064.078.047.141.22l1.256 3.696q.141.459.266.853.11.332.189.632.093.284.125.332zm12.899-5.938q1.051 0 1.71.315.675.316 1.036.837.376.505.502 1.153.141.648.141 1.311 0 .395-.157.648-.156.252-.612.252h-4.221q.017.6.126.995.11.38.314.616.219.222.565.316.345.08.847.08.22 0 .486-.017l.581-.031.581-.063q.282-.032.502-.064a.5.5 0 0 1 .266-.015q.11.016.157.22l.126.6q.078.348-.298.475a4 4 0 0 1-.565.173q-.33.064-.691.111-.36.048-.721.079-.346.032-.628.032-1.114 0-1.789-.3a2.5 2.5 0 0 1-1.02-.853l-.251.19-.282.173a6 6 0 0 1-1.287.568 5.6 5.6 0 0 1-1.569.206q-.644 0-1.067-.158a1.6 1.6 0 0 1-.675-.458 1.8 1.8 0 0 1-.361-.695 4 4 0 0 1-.094-.916q0-1.327.722-1.895.722-.585 2.228-.585h2.009v-.584q0-.348-.079-.585a.68.68 0 0 0-.251-.395 1.1 1.1 0 0 0-.502-.22 4 4 0 0 0-.8-.064q-.19 0-.455.016l-.565.032q-.298.015-.597.047-.282.032-.533.047a2 2 0 0 1-.267.016q-.11-.016-.157-.22l-.141-.585q-.031-.174.031-.253.063-.095.33-.205.25-.095.596-.158.346-.064.706-.11.361-.048.706-.064.361-.016.644-.016.972 0 1.538.206.58.205.894.616.377-.364.926-.585.564-.237 1.365-.237m-5.633 6.617q.235 0 .549-.08a8 8 0 0 0 .659-.189 12 12 0 0 0 .643-.268q.314-.158.549-.284a6 6 0 0 1-.109-.616 10 10 0 0 1-.047-.664h-1.883q-.675 0-1.005.269-.329.252-.329.947 0 .458.204.68.22.204.769.205m7.186-3.301a5 5 0 0 0-.078-.663 1.7 1.7 0 0 0-.236-.616 1.1 1.1 0 0 0-.455-.443q-.297-.173-.8-.173-.454 0-.753.142a1.07 1.07 0 0 0-.455.379 1.7 1.7 0 0 0-.235.6q-.079.348-.11.774zm14.301 4.265q0 .143-.062.221-.048.08-.22.08h-1.13q-.298 0-.298-.3v-4.486q0-.885-.235-1.185-.235-.316-.832-.316a2 2 0 0 0-.502.08 7 7 0 0 0-.549.189 5 5 0 0 0-.518.221l-.439.221v.332q.015.206.015.474v4.47a.35.35 0 0 1-.062.22q-.063.08-.236.08h-1.145q-.267 0-.267-.3v-4.565q0-.726-.22-1.074-.219-.348-.816-.348-.204 0-.47.064-.252.063-.534.173a11 11 0 0 0-.533.237q-.267.126-.487.237v5.275q0 .3-.298.3h-1.13q-.282 0-.282-.3v-7.123q0-.316.282-.316h1.114q.315 0 .314.316v.458l.016.016q.235-.157.502-.316a3.6 3.6 0 0 1 .565-.3q.314-.127.627-.205.315-.095.644-.11.675 0 1.224.22.564.206.926.885a7.6 7.6 0 0 1 1.302-.774 3.4 3.4 0 0 1 1.459-.332q.77 0 1.224.237.455.237.691.648.235.395.298.931.063.537.062 1.122zm8.305 0a.35.35 0 0 1-.063.221q-.048.08-.22.08h-1.13q-.282 0-.282-.285v-.505h-.031q0-.015-.016-.016-.204.142-.487.316a7 7 0 0 1-.612.3 4 4 0 0 1-.69.221q-.345.095-.69.095-.77 0-1.271-.269a2.2 2.2 0 0 1-.785-.79 3.9 3.9 0 0 1-.408-1.216 11 11 0 0 1-.11-1.626q0-.964.126-1.722.141-.774.486-1.31.345-.538.942-.806.612-.285 1.569-.285.972 0 1.946.364h.015q0-.015.016-.016v-3.27q0-.158.047-.236.062-.08.251-.08h1.114q.189 0 .235.095a.43.43 0 0 1 .048.222zm-1.711-5.812a6 6 0 0 0-.988-.205 5.6 5.6 0 0 0-.816-.063q-.424 0-.722.126a.97.97 0 0 0-.471.426q-.173.3-.251.806a8 8 0 0 0-.078 1.232q0 .758.062 1.232.079.458.236.71.156.237.376.332.22.08.534.08.236 0 .533-.08t.597-.19q.297-.11.549-.22.267-.127.439-.222zm8.164 2.59h-1.914q-.596 0-.942.285-.345.268-.345 1.042 0 .521.204.727.22.19.769.19.252 0 .549-.064.298-.063.597-.174.297-.111.58-.237.282-.142.502-.268zm.094 2.622a5.2 5.2 0 0 1-1.349.742 4.2 4.2 0 0 1-1.538.285q-.628 0-1.051-.158a1.8 1.8 0 0 1-.659-.458 1.95 1.95 0 0 1-.345-.711 4 4 0 0 1-.094-.916q-.016-1.39.721-2.006.738-.632 2.229-.632h2.008v-.41q0-.348-.078-.585a.76.76 0 0 0-.252-.41 1.1 1.1 0 0 0-.502-.221 4 4 0 0 0-.8-.063q-.188 0-.471.015l-.565.032q-.282.015-.58.047-.282.031-.518.048a1.3 1.3 0 0 1-.329.015q-.079-.031-.11-.205l-.141-.584q-.032-.159.031-.253.063-.11.329-.221.252-.095.597-.158t.706-.095q.36-.047.706-.063.361-.032.643-.032 1.02 0 1.616.206.612.205.926.584.314.363.408.9t.094 1.2v3.049q0 .237.016.379a.8.8 0 0 0 .078.205q.063.063.173.095t.298.047q.173.016.236.064.062.048.062.173v.664q0 .269-.376.331a5 5 0 0 1-.377.048 2 2 0 0 1-.361.031q-.549 0-.894-.205-.33-.206-.455-.758zm9.369-1.421q0 .694-.267 1.168a2.1 2.1 0 0 1-.722.743q-.439.285-1.004.41a5.4 5.4 0 0 1-1.177.127q-.595 0-1.287-.095-.69-.08-1.145-.253-.235-.094-.298-.205a.5.5 0 0 1-.032-.316l.11-.521q.031-.19.126-.221.095-.048.282-.016.252.048.549.079l.612.063q.315.015.581.032.282.015.486.016.754 0 1.083-.206.33-.22.33-.695 0-.268-.063-.442a.53.53 0 0 0-.188-.284 1.1 1.1 0 0 0-.393-.174 3.3 3.3 0 0 0-.612-.126 11 11 0 0 1-1.098-.206 3.5 3.5 0 0 1-.926-.363 1.94 1.94 0 0 1-.627-.648q-.236-.41-.236-1.058 0-1.168.816-1.769.816-.615 2.134-.616.236 0 .549.016.315.016.628.063.33.048.643.111.315.063.565.158.393.157.33.474l-.126.568q-.032.174-.125.221-.08.033-.298 0a24 24 0 0 0-1.099-.11 10 10 0 0 0-1.036-.063q-.753 0-1.004.22-.235.207-.235.664 0 .459.298.6.313.143 1.036.253.564.08 1.067.205.517.126.91.38.392.252.627.678.236.427.236 1.138m6.245 1.721q.046.269-.204.395a2.4 2.4 0 0 1-.487.158 5 5 0 0 1-.565.095 5 5 0 0 1-.549.063q-.251.015-.439.016-.69 0-1.083-.19a1.37 1.37 0 0 1-.565-.553 2.1 2.1 0 0 1-.235-.805 9 9 0 0 1-.047-.964v-3.964h-.785q-.172 0-.235-.063-.063-.08-.063-.237v-.774q0-.157.063-.237.063-.078.235-.079h.8v-1.626q0-.174.079-.237a.54.54 0 0 1 .22-.11l1.051-.285q.314-.08.314.19v2.068h1.679q.188 0 .235.08a.35.35 0 0 1 .063.22v.79q0 .157-.063.237-.047.063-.235.063h-1.679v3.933q0 .316.047.49a.5.5 0 0 0 .157.268.7.7 0 0 0 .329.095q.204.015.518.016a10 10 0 0 0 1.051-.064q.126-.016.189.032.062.048.094.19z"></path><path fill="#626366" d="M250.477 46.884q0 .774-.173 1.358-.173.6-.596.995-.408.411-1.083.6-.659.19-1.647.158a.5.5 0 0 1-.204-.063q-.126-.063-.141-.252l-.063-.743q-.032-.189.031-.252.048-.064.22-.095.549-.111.91-.221a1.6 1.6 0 0 0 .596-.269.9.9 0 0 0 .33-.458q.094-.269.094-.726v-7.644q0-.3.314-.3h1.098q.314 0 .314.3zm.063-9.966q0 .19-.032.363a.6.6 0 0 1-.141.285.66.66 0 0 1-.282.205 1.4 1.4 0 0 1-.471.063q-.314 0-.502-.079a.7.7 0 0 1-.267-.205.7.7 0 0 1-.126-.284 2 2 0 0 1-.031-.348q0-.378.188-.632.189-.268.738-.268.58 0 .753.253.173.237.173.647m8.562 5.797q0 .678-.094 1.405a3.5 3.5 0 0 1-.423 1.343q-.346.6-1.036.995-.69.379-1.914.379-1.177 0-1.852-.38-.675-.394-1.02-.994a3.6 3.6 0 0 1-.408-1.343 13 13 0 0 1-.078-1.405q0-.554.094-1.232.11-.68.455-1.264.345-.6 1.004-.995.674-.41 1.805-.41 1.145 0 1.82.347.69.347 1.051.916.361.553.471 1.248.125.694.125 1.39m-1.757.11a8 8 0 0 0-.063-1.09q-.062-.474-.251-.774a1.2 1.2 0 0 0-.518-.473q-.329-.159-.863-.158-.502 0-.816.158a1.2 1.2 0 0 0-.502.473q-.173.316-.251.79a8 8 0 0 0-.063 1.074q0 .632.063 1.106.078.457.251.774.172.3.487.458.314.158.816.158.533 0 .863-.143a1.2 1.2 0 0 0 .533-.458q.189-.316.251-.79.063-.473.063-1.105m.329-7.312q.236.126.063.347l-1.6 2.211q-.126.174-.298.095l-.612-.284q-.173-.096-.079-.3l1.255-2.449q.094-.205.346-.094zm4.981 10.897q0 .3-.298.3h-1.129q-.299 0-.299-.3v-7.123q0-.316.299-.316h1.114q.313 0 .313.316v.695l.032.032q.173-.159.455-.332.282-.19.596-.332.33-.158.659-.284.33-.126.612-.174a.4.4 0 0 1 .251.016q.095.048.126.253l.11 1.058q.015.174-.016.253-.031.078-.283.126-.329.063-.69.158a8 8 0 0 0-.706.19q-.345.094-.643.19a4 4 0 0 0-.503.189zm10.345 0a.35.35 0 0 1-.063.221q-.063.08-.235.08h-1.13q-.298 0-.298-.3l.016-4.439q0-.695-.236-1.121-.219-.427-.894-.427-.235 0-.549.08a5 5 0 0 0-.612.205 7 7 0 0 0-.565.237 7 7 0 0 0-.424.19v5.274q0 .3-.298.3h-1.114q-.298 0-.298-.3v-7.123q0-.316.298-.316h1.114q.298 0 .298.316v.474q.016 0 .016.016h.031q.22-.157.518-.316a6 6 0 0 1 .659-.316q.345-.142.722-.221.377-.095.737-.095.8 0 1.256.253.454.237.69.648.235.41.298.963.063.537.063 1.137zm-130 6.17q0-.325.315-.325h5.802q.3 0 .3.308v1.005q0 .292-.316.292h-4.304v2.788h3.816q.315 0 .315.291v1.005q0 .292-.315.292h-3.816v3.193h4.415q.284 0 .284.308v.989q0 .292-.3.292h-5.881q-.315 0-.315-.292zm11.199 8.444q0-.048.094-.34l.205-.665q.126-.42.3-.924l1.261-3.76a.5.5 0 0 1 .111-.195q.078-.064.252-.064h1.198q.315 0 .189.307l-2.68 7.294a.6.6 0 0 1-.158.26q-.094.08-.283.08h-1.057q-.22.001-.299-.064a.7.7 0 0 1-.142-.26l-2.68-7.293a.34.34 0 0 1-.016-.227q.031-.097.189-.097h1.246q.173 0 .236.064.08.049.142.227l1.261 3.793q.142.47.268.875.111.34.189.649.095.291.126.34zm6.748 1.686q0 .308-.3.308h-1.135q-.299 0-.299-.308V55.4q0-.324.299-.324h1.12q.315 0 .315.324v.713l.031.032q.173-.162.458-.34.284-.195.599-.34a9 9 0 0 1 .662-.292q.332-.13.615-.178.157-.033.252.016.095.048.126.26l.111 1.085a.6.6 0 0 1-.016.26q-.032.08-.284.129-.331.065-.694.162a8 8 0 0 0-.709.195q-.347.098-.647.194-.299.098-.504.195zm10.425-3.793q0 .697-.094 1.442a3.6 3.6 0 0 1-.426 1.378q-.346.615-1.041 1.021-.693.39-1.923.39-1.182 0-1.86-.39a2.8 2.8 0 0 1-1.025-1.02 3.8 3.8 0 0 1-.41-1.379 14 14 0 0 1-.079-1.442q0-.567.095-1.264.11-.697.457-1.297.346-.615 1.009-1.021.678-.422 1.813-.422 1.15 0 1.829.357.693.357 1.056.94.363.567.473 1.28.126.714.126 1.427m-1.766.113a9 9 0 0 0-.063-1.118q-.063-.486-.252-.794a1.2 1.2 0 0 0-.52-.486q-.331-.162-.867-.163-.505 0-.82.163-.315.162-.505.486a2.6 2.6 0 0 0-.252.81 8 8 0 0 0-.063 1.102q0 .648.063 1.135.08.47.252.794.174.308.489.47.316.162.82.162.535 0 .867-.145.347-.163.536-.47.189-.325.252-.811t.063-1.135m.332-7.504q.236.13.063.356l-1.609 2.27q-.125.178-.299.097l-.615-.292q-.174-.097-.079-.308l1.262-2.512q.094-.21.346-.097zm9.797 7.472q0 .99-.142 1.767t-.504 1.313a2.2 2.2 0 0 1-.962.81q-.6.276-1.529.276a6 6 0 0 1-1.971-.357l-.016.016v2.853a.4.4 0 0 1-.063.227q-.047.097-.236.097h-1.12q-.189 0-.252-.081a.5.5 0 0 1-.047-.243V55.4q0-.324.299-.324h1.12q.173 0 .22.097.063.081.063.227v.486l.048.032q.204-.146.488-.307.3-.179.631-.325.332-.145.678-.243.346-.097.694-.097.772 0 1.277.292t.788.826q.3.519.41 1.264.126.746.126 1.67m-1.782-.016q0-.779-.078-1.248-.063-.47-.221-.73a.75.75 0 0 0-.394-.34 1.3 1.3 0 0 0-.536-.097q-.237 0-.536.08-.3.083-.599.195-.285.097-.552.227-.252.13-.426.227v4.052q.536.162.962.227.441.048.851.049.426 0 .71-.114a1 1 0 0 0 .473-.437q.189-.309.268-.81.078-.519.078-1.281m9.878 3.728q0 .308-.3.308h-1.119q-.174 0-.237-.081a.36.36 0 0 1-.063-.227v-.503l-.031-.016a8 8 0 0 1-.552.34q-.3.162-.647.308a4 4 0 0 1-.725.227 2.8 2.8 0 0 1-.725.097q-.804 0-1.277-.226a1.6 1.6 0 0 1-.694-.633 2.4 2.4 0 0 1-.299-.956 10 10 0 0 1-.063-1.183V55.4q0-.324.299-.324h1.151q.284 0 .284.324v4.554q0 .373.047.665t.173.502q.127.195.347.308.22.114.584.114.252 0 .551-.081.317-.082.615-.195.3-.129.552-.243l.41-.21V55.4q0-.146.063-.227.063-.097.237-.097h1.119q.3 0 .3.324zm7.461-2.075q0 .713-.268 1.2a2.16 2.16 0 0 1-.726.761q-.44.292-1.009.422a5.3 5.3 0 0 1-1.182.13q-.599 0-1.293-.098-.693-.08-1.151-.26-.236-.096-.299-.21a.54.54 0 0 1-.032-.324l.111-.535q.032-.195.126-.227.094-.048.283-.016.254.049.552.08l.615.066q.315.015.584.032.284.016.488.016.757 0 1.088-.21.331-.228.331-.714 0-.275-.063-.453a.54.54 0 0 0-.189-.292 1.05 1.05 0 0 0-.394-.178 3.2 3.2 0 0 0-.615-.13 11 11 0 0 1-1.104-.21 3.4 3.4 0 0 1-.93-.373 2 2 0 0 1-.631-.665q-.236-.421-.236-1.086 0-1.2.82-1.815.82-.633 2.144-.633.237 0 .552.017.315.015.63.065.332.048.647.113t.567.162q.394.162.331.486l-.126.584q-.031.178-.126.227-.078.031-.299 0a24 24 0 0 0-1.104-.114 10 10 0 0 0-1.041-.065q-.756 0-1.009.227-.236.21-.236.681 0 .47.3.616.315.146 1.04.26a10 10 0 0 1 1.072.21q.52.13.915.39.394.258.63.696.237.437.237 1.167m6.243-1.232h-1.924q-.598 0-.946.292-.346.276-.346 1.07 0 .535.204.745.221.195.773.195.252 0 .552-.065a4 4 0 0 0 .599-.178q.3-.114.583-.244.284-.146.505-.275zm.094 2.69a5.2 5.2 0 0 1-1.356.763 4.2 4.2 0 0 1-1.545.291q-.63 0-1.056-.162a1.8 1.8 0 0 1-.662-.47 2 2 0 0 1-.347-.73 4.3 4.3 0 0 1-.095-.94q-.015-1.425.726-2.058.741-.648 2.238-.648h2.019v-.422q0-.356-.079-.6a.78.78 0 0 0-.253-.42 1.1 1.1 0 0 0-.504-.228 4 4 0 0 0-.804-.064q-.19 0-.473.016l-.568.032q-.283.016-.583.049-.284.032-.52.048a1.3 1.3 0 0 1-.331.017q-.08-.033-.111-.211l-.142-.6q-.031-.162.032-.259.063-.114.331-.227.252-.097.599-.162t.71-.097q.362-.049.709-.065.363-.032.646-.032 1.026 0 1.624.21.615.21.93.6.316.372.41.924.095.55.095 1.232v3.128q0 .243.016.389a.8.8 0 0 0 .079.21.4.4 0 0 0 .173.098q.11.032.3.048.173.017.236.065.063.05.063.178v.681q0 .276-.378.34a5 5 0 0 1-.379.05 2 2 0 0 1-.362.032q-.552 0-.899-.211-.331-.21-.457-.778zm14.931.617a.36.36 0 0 1-.063.227q-.047.08-.221.08h-1.135q-.299 0-.299-.307v-4.604q0-.907-.237-1.215-.236-.324-.835-.324-.222 0-.505.08a7 7 0 0 0-.552.195q-.267.097-.52.227l-.441.227v.34q.015.211.015.487v4.587a.36.36 0 0 1-.063.227q-.063.08-.236.08h-1.151q-.268 0-.268-.307v-4.684q0-.747-.221-1.103-.22-.356-.82-.356a2 2 0 0 0-.473.065 5 5 0 0 0-.536.178q-.267.113-.536.243-.267.13-.488.243v5.414q0 .308-.3.308h-1.135q-.284 0-.284-.308V55.4q0-.324.284-.324h1.119q.315 0 .316.324v.47l.015.016q.237-.162.505-.324.268-.179.567-.308a5 5 0 0 1 .631-.21q.316-.098.646-.114.678 0 1.23.227.568.21.93.907.6-.453 1.309-.794.71-.34 1.466-.34.772 0 1.23.243t.694.664q.236.406.299.957t.063 1.15zm8.486-3.728q0 .988-.158 1.767-.142.778-.52 1.312a2.45 2.45 0 0 1-1.041.827q-.662.276-1.687.276-.378 0-.804-.033a7 7 0 0 1-.82-.08 9 9 0 0 1-.772-.13 6 6 0 0 1-.647-.179q-.267-.113-.346-.308a1.1 1.1 0 0 1-.079-.405V51.915q0-.308.315-.308h1.119q.19 0 .253.097a.33.33 0 0 1 .063.211v3.404a6 6 0 0 1 1.088-.308q.487-.081.867-.081.977 0 1.592.291.615.292.962.827.362.535.489 1.28.126.747.126 1.654m-1.798.146q0-.714-.078-1.216-.08-.503-.253-.81a1.04 1.04 0 0 0-.425-.454 1.5 1.5 0 0 0-.647-.162q-.252 0-.457.016-.206 0-.426.032a5 5 0 0 0-.457.098q-.253.048-.583.13v4.684q.378.064.788.097.426.032.804.032.394 0 .71-.08.315-.082.536-.325.236-.26.362-.746t.126-1.296m8.109.275h-1.923q-.599 0-.946.292-.347.276-.347 1.07 0 .535.205.745.22.195.773.195.252 0 .551-.065t.6-.178q.299-.114.583-.244.284-.146.504-.275zm.095 2.69a5.2 5.2 0 0 1-1.356.763 4.2 4.2 0 0 1-1.545.291q-.63 0-1.056-.162a1.8 1.8 0 0 1-.662-.47 2 2 0 0 1-.347-.73 4.3 4.3 0 0 1-.095-.94q-.015-1.425.725-2.058.742-.648 2.239-.648h2.018v-.422q0-.356-.079-.6a.8.8 0 0 0-.252-.42 1.1 1.1 0 0 0-.504-.228 4 4 0 0 0-.804-.064q-.19 0-.473.016l-.568.032q-.284.016-.583.049-.285.032-.521.048a1.3 1.3 0 0 1-.331.017q-.078-.033-.11-.211l-.142-.6q-.031-.162.032-.259.063-.114.331-.227.252-.097.599-.162a8 8 0 0 1 .709-.097q.362-.049.71-.065.362-.032.646-.032 1.025 0 1.624.21.615.21.93.6.315.372.41.924.095.55.095 1.232v3.128q0 .243.015.389a.8.8 0 0 0 .079.21q.063.066.174.098t.299.048q.174.017.237.065.063.05.063.178v.681q0 .276-.379.34a5 5 0 0 1-.378.05 2 2 0 0 1-.363.032q-.551 0-.898-.211-.331-.21-.457-.778zm10.311.617a.36.36 0 0 1-.063.227q-.062.08-.236.08h-1.135q-.3 0-.3-.307l.016-4.555q0-.713-.236-1.15-.221-.438-.899-.438-.237 0-.552.08-.3.082-.615.212-.3.113-.567.243-.269.113-.426.194v5.414q0 .308-.3.308h-1.119q-.3 0-.3-.308V55.4q0-.324.3-.324h1.119q.3 0 .3.324v.486q.016 0 .016.016h.031q.22-.162.521-.324.315-.178.662-.324a4 4 0 0 1 .725-.227q.378-.097.741-.097.804 0 1.261.259.457.243.694.665.236.42.299.988.063.552.063 1.167zm8.298 0a.36.36 0 0 1-.063.227q-.047.08-.22.08h-1.136q-.283 0-.283-.291v-.519h-.032q0-.015-.016-.016-.204.145-.488.324a7 7 0 0 1-.615.308 3.7 3.7 0 0 1-.694.227 2.6 2.6 0 0 1-.694.097q-.772 0-1.277-.275a2.2 2.2 0 0 1-.788-.81 4 4 0 0 1-.41-1.249 11.6 11.6 0 0 1-.11-1.67q0-.987.126-1.766.141-.795.489-1.345.346-.55.946-.827.614-.291 1.576-.291.978 0 1.955.372h.016q0-.015.016-.016v-3.355a.5.5 0 0 1 .047-.243q.063-.081.252-.081h1.12q.19 0 .236.097.047.081.047.227zm-1.718-5.965a6 6 0 0 0-.993-.21 5.5 5.5 0 0 0-.82-.066q-.426 0-.725.13a.98.98 0 0 0-.473.438q-.174.307-.253.826a8.5 8.5 0 0 0-.078 1.265q0 .777.063 1.264.078.47.236.73a.9.9 0 0 0 .378.34q.221.08.536.08.237 0 .537-.08.299-.082.599-.195.299-.114.551-.227.268-.13.442-.227zm9.196 3.89q0 .713-.268 1.2-.268.47-.725.761a3 3 0 0 1-1.009.422q-.568.13-1.183.13a9 9 0 0 1-1.292-.098q-.695-.08-1.151-.26-.237-.096-.3-.21a.54.54 0 0 1-.031-.324l.11-.535q.031-.195.126-.227.095-.048.284-.016.252.049.552.08l.615.066q.315.015.583.032.283.016.489.016.756 0 1.087-.21.332-.228.332-.714a1.4 1.4 0 0 0-.064-.453.54.54 0 0 0-.189-.292 1 1 0 0 0-.394-.178 3.2 3.2 0 0 0-.615-.13 11 11 0 0 1-1.103-.21 3.5 3.5 0 0 1-.931-.373 2 2 0 0 1-.63-.665q-.237-.421-.237-1.086 0-1.2.82-1.815.82-.633 2.144-.633.237 0 .552.017.316.015.631.065.33.048.646.113.315.065.568.162.394.162.331.486l-.126.584q-.031.178-.126.227-.08.031-.3 0a24 24 0 0 0-1.104-.114 10 10 0 0 0-1.04-.065q-.757 0-1.009.227-.237.21-.237.681 0 .47.3.616.315.146 1.04.26a10 10 0 0 1 1.073.21q.52.13.914.39.394.258.631.696.236.437.236 1.167m3.5-7.666q0 .194-.032.372a.6.6 0 0 1-.142.292.66.66 0 0 1-.283.21 1.4 1.4 0 0 1-.473.066 1.3 1.3 0 0 1-.505-.081.7.7 0 0 1-.268-.211.7.7 0 0 1-.126-.292 2 2 0 0 1-.032-.357q0-.389.174-.648.189-.275.757-.275.584 0 .756.259.174.243.174.664m-.095 9.74a.4.4 0 0 1-.063.228q-.047.08-.221.08h-1.119q-.315 0-.315-.307v-7.327q0-.307.315-.307h1.119q.174 0 .221.097a.33.33 0 0 1 .063.21zm8.625.002a.36.36 0 0 1-.063.227q-.063.08-.236.08h-1.135q-.3 0-.3-.307l.016-4.555q0-.713-.237-1.15-.22-.438-.898-.438-.237 0-.552.08-.3.082-.615.212-.3.113-.568.243-.267.113-.425.194v5.414q0 .308-.3.308h-1.119q-.3 0-.3-.308V55.4q0-.324.3-.324h1.119q.3 0 .3.324v.486q.015 0 .015.016h.032q.221-.162.52-.324a6 6 0 0 1 .662-.324 4 4 0 0 1 .726-.227q.378-.097.741-.097.804 0 1.261.259.457.243.694.665.236.42.299.988.063.552.063 1.167zM277 60.635q0 .713-.268 1.2-.268.47-.725.761a3 3 0 0 1-1.009.422q-.568.13-1.183.13a9 9 0 0 1-1.292-.098q-.695-.08-1.151-.26-.237-.096-.3-.21a.53.53 0 0 1-.031-.324l.11-.535q.031-.195.126-.227.095-.048.284-.016.252.049.552.08l.614.066q.316.015.584.032.284.016.489.016.757 0 1.087-.21.331-.228.331-.714 0-.275-.063-.453a.54.54 0 0 0-.189-.292 1 1 0 0 0-.394-.178 3.2 3.2 0 0 0-.615-.13 11 11 0 0 1-1.103-.21 3.5 3.5 0 0 1-.931-.373 2 2 0 0 1-.63-.665q-.237-.421-.237-1.086 0-1.2.82-1.815.82-.633 2.144-.633.237 0 .552.017.315.015.631.065.33.048.646.113.315.065.568.162.393.162.331.486l-.126.584q-.031.178-.127.227-.078.031-.299 0a24 24 0 0 0-1.104-.114 10 10 0 0 0-1.04-.065q-.757 0-1.009.227-.237.21-.237.681 0 .47.3.616.315.146 1.04.26.568.08 1.072.21.52.13.915.39.394.258.631.696.236.437.236 1.167"></path><path fill="#004494" fill-rule="evenodd" d="M286 66.7h3.3V28H286z" clip-rule="evenodd"></path>', 27), yJ = [
  gJ
];
function _J(t, e) {
  return T(), N("svg", mJ, [...yJ]);
}
const qJ = { render: _J }, wJ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, zJ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.2 39.5c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.9.3c.2.1.3.1.3.2s.1.2.1.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.7 0-1.2.1-1.6.4s-.7.6-1 1c-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m19.7 1.5c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.6 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c-.1.2-.1.3-.1.4m16.5 0c0 .1-.1.1-.3.1H194c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4c.3-.1.5-.2.8-.3s.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c0 .2-.1.3-.1.4m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m9.2 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.5-9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1H222c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm11-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.7 4.9c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3v6.7c0 .3-.1.4-.4.4H237c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.8c.2 0 .1.1.1.2m4.2-4.3c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.3-.2-.7-.3-1.1-.3" class="st4"></path></g><g class="st3"><path d="M145.2 62c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2c-.3 0-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8c-.1-.2-.3-.4-.6-.5s-.7-.3-1.1-.3m14.2 8.3H160c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4V66c-.1.2-.2.4-.5.4m5.1-.4c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2V66zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1s-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1H182c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5q-.15-.6-.3-.9c-.1-.2-.3-.4-.5-.4-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m6.2.6c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.6.2-1 .2zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3m12.3 7.1c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3H206c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3z" class="st4"></path></g><path d="M265.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function MJ(t, e) {
  return T(), N("svg", wJ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    zJ
  ]);
}
const bJ = { render: MJ }, LJ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, xJ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#626366" d="M158.018 42.814h2.752c-.215 1.419-.559 2.923-.903 3.956l1.183.623c.602-1.462 1.139-3.763 1.462-5.74l-1.054-.409-.279.086h-5.698c.258-1.161.473-2.365.667-3.59l-1.613-.237c-.43 3.419-1.225 6.773-2.623 8.901.387.215 1.054.731 1.333 1.01.753-1.247 1.354-2.837 1.849-4.6h1.376v3.031c.021 1.462-.494 5.44-3.354 8.342v-1.182h-7.568V40.384h7.374v-1.483H144v17.2h1.548v-1.613h7.267q-.774.71-1.741 1.29c.279.301.752.946.924 1.29 3.677-2.258 4.988-6.192 5.246-7.998.236 1.742 1.441 5.848 4.623 7.977.215-.366.709-1.011.989-1.355-4.15-2.687-4.859-8.148-4.838-9.847zm-7.761-1.785a32 32 0 0 1-1.161 4.3 43 43 0 0 0-2.43-2.408l-.946.989a41 41 0 0 1 2.817 2.924c-.753 1.763-1.677 3.311-2.774 4.515.323.237.946.731 1.204.989 1.011-1.182 1.871-2.623 2.602-4.257.86 1.053 1.569 2.085 2.021 2.924l1.053-1.161c-.538-.946-1.419-2.107-2.429-3.29a38 38 0 0 0 1.505-5.267zm18.554-3.139v6.622c0 3.935-.365 8.191-3.827 11.395.344.28.903.817 1.161 1.204 3.806-3.526 4.236-8.213 4.236-12.599V37.89zm6.085.452V55.67h1.569V38.34zm6.364-.538v19.07h1.591v-19.07zm-14.857 4.966c-.323 1.892-1.032 4.171-1.999 5.655l1.354.602c.989-1.505 1.613-3.956 2-5.87zm4.515.882c.753 1.72 1.419 3.999 1.613 5.396l1.397-.602c-.215-1.375-.946-3.59-1.698-5.31zm6.042-.108c.967 1.678 1.956 3.935 2.322 5.333l1.354-.71c-.387-1.376-1.44-3.569-2.451-5.224zm22.403 6.966a7.5 7.5 0 0 1-2.623 2.817 87 87 0 0 0-4.924-1.053c.409-.56.817-1.162 1.226-1.764zm-4.258-2.988h1.548V43.33c2.021 2.064 5.225 3.848 8.128 4.73.193-.409.666-.99 1.01-1.334-2.558-.645-5.375-1.956-7.267-3.504h6.816V41.91h-8.687v-2.278c2.451-.237 4.752-.538 6.537-.947l-1.183-1.139c-3.161.71-9.137 1.161-14.039 1.29.129.322.322.903.344 1.247 2.15-.043 4.514-.15 6.793-.322v2.15h-8.621v1.311h6.815c-1.913 1.634-4.729 3.053-7.288 3.741.323.301.774.86.968 1.247 2.902-.903 6.127-2.752 8.126-4.88v3.934l-1.526-.409c-.43.71-.924 1.484-1.462 2.28h-5.869v1.376h4.945a115 115 0 0 1-2.172 3.031l1.484.516.451-.602c1.312.258 2.602.537 3.849.838-2.086.818-4.816 1.248-8.256 1.441.279.365.516.968.623 1.419 4.257-.344 7.504-1.01 9.89-2.3 2.709.73 5.139 1.526 6.945 2.279l.967-1.312c-1.655-.666-3.87-1.354-6.321-2.021 1.075-.881 1.892-1.956 2.494-3.29h4.472v-1.375h-11.653c.409-.602.795-1.183 1.139-1.742zm27.456-5.654h-10.169v-2.236h10.169zm1.655-3.526H210.8v4.816h13.416zm-12.727 12.513h11.932v1.548h-11.932zm0-2.645h11.932v1.505h-11.932zm0-2.645h11.932v1.506h-11.932zm13.566 8.02v-9.202h-15.158v9.202h4.021c-1.333.882-4.106 1.87-6.342 2.386.387.323.903.86 1.182 1.183 2.193-.559 4.967-1.591 6.687-2.645l-1.441-.924zm-5.891 1.075c2.258.667 5.139 1.763 6.751 2.516l1.376-1.162c-1.677-.687-4.536-1.741-6.751-2.386zm10.986-4.945h5.655c-.58 1.57-1.505 3.526-2.322 5.01-1.161.042-2.236.064-3.16.085l.214 1.57c3.677-.129 9.246-.366 14.513-.623.409.516.731 1.01.989 1.44l1.44-.882c-.989-1.59-3.074-3.912-5.052-5.611l-1.354.731c.946.838 1.956 1.892 2.837 2.902-3.01.13-6.041.237-8.707.323.86-1.505 1.784-3.354 2.537-4.945h10.084v-1.484H230.15zm3.656-5.568v1.462h10.169v-1.462zm4.128-6.601c-1.656 2.73-5.225 5.827-8.901 7.59.344.322.752.902.924 1.268 3.655-1.806 7.138-4.751 8.88-7.332 1.999 2.774 5.762 5.633 9.073 7.246.279-.473.666-1.032 1.031-1.419-3.375-1.398-7.116-4.193-9.373-7.353z"></path><path fill="#004494" fill-rule="evenodd" d="M255.941 66.7h3.3V28h-3.3z" clip-rule="evenodd"></path>', 26), SJ = [
  xJ
];
function CJ(t, e) {
  return T(), N("svg", LJ, [...SJ]);
}
const kJ = { render: CJ }, EJ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, AJ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#626366" d="M143.42 33.12q0-.4.4-.4h7.36q.38 0 .38.38v1.24q0 .36-.4.36h-5.46v3.44h4.84q.4 0 .4.36v1.24q0 .36-.4.36h-4.84v3.94h5.6q.36 0 .36.38v1.22q0 .36-.38.36h-7.46q-.4 0-.4-.36zm18.706 12.5q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V45l-.04-.02q-.3.2-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V36.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1.4-.1.78-.24.38-.16.7-.3l.52-.26V36.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4zm4.705 0q0 .38-.38.38h-1.44q-.38 0-.38-.38V36.6q0-.4.38-.4h1.42q.4 0 .4.4v.88l.04.04a4 4 0 0 1 .58-.42q.36-.24.76-.42.42-.2.84-.36t.78-.22a.5.5 0 0 1 .32.02q.12.06.16.32l.14 1.34a.7.7 0 0 1-.02.32q-.039.1-.36.16-.42.08-.88.2a10 10 0 0 0-.9.24q-.44.12-.82.24t-.64.24zm13.226-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.848-.04q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12.08.1.08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.981 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a9 9 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.561.06 1.08.06.54 0 .9-.14.381-.16.6-.54.24-.38.34-1 .1-.64.1-1.58m10.11.52h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96zm-3.62-10a1.8 1.8 0 0 1-.6-.08.85.85 0 0 1-.34-.26.9.9 0 0 1-.16-.36 4 4 0 0 1-.02-.42q0-.46.2-.76.22-.3.92-.3t.9.3q.2.28.2.76 0 .46-.2.8-.2.32-.9.32m3.88 0q-.72 0-.92-.34a1.64 1.64 0 0 1-.18-.78q0-.46.22-.76t.88-.3q.7 0 .9.3.22.28.22.76 0 .46-.2.8-.2.32-.92.32m6.421 6.84q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.64.64 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42-.861-.42-1.32-1.12t-.62-1.6a12.5 12.5 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44a8.3 8.3 0 0 1 .2 1.6q.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a6.6 6.6 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m13.416 5.26q0 .88-.34 1.48-.34.58-.92.94-.56.36-1.28.52t-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88a1.7 1.7 0 0 0-.08-.56.67.67 0 0 0-.24-.36 1.35 1.35 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.4 4.4 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.5.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.76-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m9.3 2.02q.06.22 0 .36t-.34.26q-.58.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.4 4.4 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.399.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1t.66.54q.42.14 1.02.14.459 0 1.2-.04.759-.06 1.38-.14.24-.04.36 0t.16.3zm10.025.54q0 .38-.4.38h-1.42q-.4 0-.4-.38v-2.88q.02-1.44.02-2.9 0-.84-.28-1.34-.26-.52-1.16-.52-.3 0-.7.12a10 10 0 0 0-.78.24 9 9 0 0 0-.72.3q-.34.16-.54.24v6.74a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.42q-.36 0-.36-.38V32.28q0-.38.36-.38h1.42q.4 0 .4.38v4.84q.26-.16.64-.34a7 7 0 0 1 .82-.36q.44-.18.92-.28.48-.12.94-.12 1.04 0 1.64.32.6.3.9.82.32.52.4 1.22.1.68.1 1.44zm-94.437 13.5 1.52-1.96 3.36-4.14a.8.8 0 0 1 .28-.22.8.8 0 0 1 .38-.08h1.82q.22 0 .26.12.06.12-.08.28l-4.34 5.28 4.48 7.18q.12.2.04.32-.08.1-.24.1h-1.84q-.26 0-.4-.1-.12-.1-.24-.28l-3.28-5.44-1.76 2.18v3.26q0 .16-.08.28-.06.1-.28.1h-1.5q-.4 0-.4-.38v-12.5q0-.4.4-.4h1.5q.22 0 .28.12a.44.44 0 0 1 .08.28v6zm17.562 1.82q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m18.528 4.54q0 .18-.08.28-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.339.12-.66.28l-.56.28v.42q.02.26.02.6v5.66q0 .18-.08.28t-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.26 0-.6.08-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4.34-.22.72-.38.4-.16.8-.26.4-.12.82-.14.861 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.981 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm16.485 0a.44.44 0 0 1-.08.28q-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.34.12-.66.28l-.56.28v.42q.02.26.02.6v5.66a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.261 0-.6.08a6 6 0 0 0-.68.22q-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4.339-.22.72-.38.4-.16.8-.26.4-.12.82-.14a4.2 4.2 0 0 1 1.56.28q.72.26 1.18 1.12a9.7 9.7 0 0 1 1.66-.98q.9-.42 1.86-.42.98 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.744-12.02q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26 1.8 1.8 0 0 1-.6.08q-.4 0-.64-.1a.85.85 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm9.801-2.56q0 .88-.34 1.48a2.7 2.7 0 0 1-.92.94q-.56.36-1.28.52t-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.3 1.3 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.4 4.4 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.501.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.759-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m9.18 0q0 .88-.34 1.48-.34.58-.92.94-.56.36-1.28.52t-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88a1.7 1.7 0 0 0-.08-.56.67.67 0 0 0-.24-.36 1.35 1.35 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.4 4.4 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.5.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.759-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44M224 53.6q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26 1.8 1.8 0 0 1-.6.08q-.4 0-.64-.1a.85.85 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm10.981-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7 17 17 0 0 1-.1-1.78q0-.7.12-1.56a4.6 4.6 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.689 4.54q0 .38-.38.38h-1.42q-.22 0-.3-.1a.44.44 0 0 1-.08-.28V65l-.04-.02q-.3.2-.7.42-.38.2-.82.38t-.92.28q-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V56.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1.4-.1.78-.24.38-.16.7-.3l.52-.26V56.6a.44.44 0 0 1 .08-.28q.08-.12.3-.12h1.42q.38 0 .38.4zm10.605 0a.44.44 0 0 1-.08.28q-.08.1-.3.1h-1.44q-.38 0-.38-.38l.02-5.62q0-.88-.3-1.42-.28-.54-1.14-.54-.3 0-.7.1a7 7 0 0 0-.78.26 9 9 0 0 0-.72.3 8 8 0 0 0-.54.24v6.68q0 .38-.38.38h-1.42q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.38 0 .38.4v.6q.02 0 .02.02h.04q.28-.2.66-.4.4-.22.84-.4t.92-.28q.48-.12.94-.12 1.02 0 1.6.32.58.3.88.82t.38 1.22q.08.68.08 1.44z"></path><path fill="#004494" fill-rule="evenodd" d="M265 66.7h3.3V28H265z" clip-rule="evenodd"></path>', 26), FJ = [
  AJ
];
function TJ(t, e) {
  return T(), N("svg", EJ, [...FJ]);
}
const IJ = { render: TJ }, OJ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, NJ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m12.6-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m11.5 2q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3s-.3.5-.3.9.1.6.4.8.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5" class="st4"></path></g><g class="st3"><path d="m145.6 59.4 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V53.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm17.6 1.9c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1 0 .2-.1.3m4.8-12.4v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.2.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.9-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3s-.3.5-.3.9.1.6.4.8c.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.4-9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm5.3.6c0 .7-.1 1.2-.2 1.7s-.4.9-.8 1.3c-.4.3-.8.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.3-.1s-.2-.2-.2-.3l-.1-.9V69c0-.1.1-.1.3-.1q.75-.15 1.2-.3c.45-.15.6-.2.8-.4s.3-.3.4-.6c.1-.2.1-.5.1-.9V57c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v9.6zm.1-12.7v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4 0-.3 0-.4c0-.3.1-.6.2-.8s.5-.3 1-.3.8.1 1 .3c.1.1.2.4.2.7m8.6 11.3c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.75.3.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.2-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M225.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function PJ(t, e) {
  return T(), N("svg", OJ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    NJ
  ]);
}
const BJ = { render: PJ }, VJ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, RJ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm12.9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm5 0c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m10.3 3.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm12.1 1.5q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5" class="st4"></path></g><g class="st3"><path d="m145.6 59.4 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V53.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm17.6 1.9c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1 0 .2-.1.3m4.8-12.4v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.2.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.9-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.4-9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm5.3.6c0 .7-.1 1.2-.2 1.7s-.4.9-.8 1.3c-.4.3-.8.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.3-.1s-.2-.2-.2-.3l-.1-.9V69c0-.1.1-.1.3-.1q.75-.15 1.2-.3c.45-.15.6-.2.8-.4s.3-.3.4-.6c.1-.2.1-.5.1-.9V57c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v9.6zm.1-12.7v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4 0-.3 0-.4c0-.3.1-.6.2-.8s.5-.3 1-.3.8.1 1 .3c.1.1.2.4.2.7m8.6 11.3c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.2-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M225.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function HJ(t, e) {
  return T(), N("svg", VJ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    RJ
  ]);
}
const DJ = { render: HJ }, $J = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, UJ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><path d="M279.4 28h3.3v38.7h-3.3z" class="st1"></path><path d="M143.7 33.3c0-.3.1-.4.4-.4h1.5c.3 0 .4.1.4.4v12.5c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4zm7.4 10.4c0 .3.1.5.2.6s.4.1.7.1c.1 0 .2 0 .3.1 0 0 .1.1.1.2l.1 1c0 .2-.1.3-.3.4s-.4.2-.7.2-.5.1-.6.1c-.8 0-1.3-.2-1.6-.5s-.3-.9-.3-1.6V32.5c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v11.2zm8.7-4.8q.3 0 .3.3v1q0 .3-.3.3H154q-.3 0-.3-.3v-1q0-.3.3-.3zm4.6.4 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1H170c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2v3.3c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V33.3c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm17.2 6.9h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9c-.1.6-.3.7-.5.7m16.8-.1c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4V40c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c0 .2-.1.3-.1.3m16.5 0c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1H207c-.2 0-.3-.1-.3-.4V40c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4H201c-.2 0-.4-.1-.4-.4v-9c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c-.1.2-.1.3-.2.3m4.8-12.3v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.2.1.2.3.2.7m-.1 12c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.9-2.5q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1s.5 0 .7 0h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.3.1.5.1.7.2.3.1.5.3.4.6v1c0 .1-.1.2-.2.3s-.2 0-.4 0c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3s-.3.5-.3.9.1.6.4.8.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.2.2.3.7.3 1.3m9.2 0q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1s.5 0 .7 0h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.3.1.5.1.7.2.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3s-.2 0-.4 0c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3s-.3.5-.3.9.1.6.4.8.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.4.5.5 1 .5 1.6m4.6 3.1c0 .7-.1 1.2-.2 1.7s-.4.9-.8 1.3-.8.6-1.4.8-1.3.2-2.1.2c-.1 0-.2 0-.3-.1s-.2-.2-.2-.3l-.1-.9v-.3c0-.1.1-.1.3-.1q.75-.15 1.2-.3c.3-.1.6-.2.8-.4.2-.1.3-.3.4-.6.1-.2.1-.5.1-.9v-9.7c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v9.6zm.1-12.6v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3.2.3.2.7m10.9 7.4c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.9.1-1.4m12.6 4.8c-.1.1-.2.1-.3.1H263c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.2c-.3.1-.5.2-.7.3s-.4.2-.5.2v6.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.8q.15.3 0 .3m4.8-12.3v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.3.2.7m-.1 12c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm-125.9 7.5c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4V60c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.1 7.2.9 3.1.9-3.3 1-3.5c0-.1.1-.2.1-.3.1 0 .1-.1.3-.1h1.6c.1 0 .2 0 .2.1v.3l-2.9 9c-.1.2-.2.4-.3.4H162c-.3 0-.5-.1-.5-.4l-.7-2.1-.8-2.5-.8 2.6-.7 2c-.1.3-.3.5-.6.5h-1c-.2 0-.4 0-.5-.1s-.1-.2-.2-.4l-3-8.9v-.3c0-.1.1-.1.2-.1h1.6c.1 0 .2 0 .3.1s.1.1.2.3l1 3.4 1 3.5h.1l1-3 .6-1.8-.6-2v-.3c0-.1.1-.1.2-.1h1.5c.1 0 .2 0 .3.1s.1.2.1.3zm9.2 5.3c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2-.6.2-.8.2c-.3.1-.5.2-.6.2v6.6zm13.2-4.6c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.9.1-1.4m12.9-.1c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3 0 .1-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.8c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.3.6-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6.2 1.3.2 2m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.4 0 .7.1 1.1.1s.7 0 .9-.2c.2-.1.4-.3.6-.5.2-.3.3-.6.3-1 .3-.5.3-1 .3-1.7m6.1.7c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2c-.3 0-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3 1.3-.5 2.3-.5c.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5-.7-.3-1.1-.3m12.3 7.1c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6s-.4-.5-.4-.9-.1-.7-.1-1.2c0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8s-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.2l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3s-.5-.5-.7-1m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" style="fill:#626366;"></path>', 3);
function jJ(t, e) {
  return T(), N("svg", $J, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}")
      ]),
      _: 1
    })),
    UJ
  ]);
}
const GJ = { render: jJ }, WJ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, YJ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m6.2.6c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3m13.4 5.3q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4-1.4c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3" class="st4"></path></g><g class="st3"><path d="M143.2 59.8c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.9.3c.2.1.3.1.3.2s.1.2.1.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.7 0-1.2.1-1.6.4s-.7.6-1 1c-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m19.7 1.5c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.6 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.3m16.5 0c0 .1-.1.1-.3.1H194c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4c.3-.1.5-.2.8-.3s.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1-.1.2-.1.3m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m9.2 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.5-9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1H222c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm4.5-4c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.3-.2-.6-.3-1.1-.3" class="st4"></path></g><path d="M244.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function XJ(t, e) {
  return T(), N("svg", WJ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    YJ
  ]);
}
const KJ = { render: XJ }, ZJ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, JJ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6M94.201 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.701 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L54.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#004494" fill-rule="evenodd" d="M265.4 66.7h3.3V28h-3.3z" clip-rule="evenodd"></path><path fill="#626366" d="M143.42 33.12q0-.4.4-.4h7.36q.38 0 .38.38v1.24q0 .36-.4.36h-5.46v3.44h4.84q.4 0 .4.36v1.24q0 .36-.4.36h-4.84v3.94h5.6q.36 0 .36.38v1.22q0 .36-.38.36h-7.46q-.4 0-.4-.36zm18.706 12.5q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V45l-.04-.02q-.3.2-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V36.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1.4-.1.78-.24.38-.16.7-.3l.52-.26V36.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4zm4.705 0q0 .38-.38.38h-1.44q-.38 0-.38-.38V36.6q0-.4.38-.4h1.42q.4 0 .4.4v.88l.04.04a4 4 0 0 1 .58-.42q.36-.24.76-.42.42-.201.84-.36.42-.16.78-.22a.5.5 0 0 1 .32.02q.12.06.16.32l.14 1.34a.7.7 0 0 1-.02.32q-.039.1-.36.16-.42.08-.88.2a10 10 0 0 0-.9.24q-.44.12-.82.24t-.64.24zm13.225-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.759-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.501-1.3-1.26a4.6 4.6 0 0 1-.52-1.7 17 17 0 0 1-.1-1.78q0-.7.12-1.56a4.6 4.6 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.801-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.849-.04q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12.08.1.08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.981 0 1.62.36t1 1.02q.38.639.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a9 9 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.561.06 1.08.06.54 0 .9-.14.381-.16.6-.54.24-.38.34-1 .1-.64.1-1.58m10.11.52h-2.44q-.76 0-1.2.36-.44.339-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02l-.72.04q-.36.02-.74.06-.36.039-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.459.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.039.38.06.22.02.3.08t.08.22v.84q0 .339-.48.42-.24.039-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.261-.58-.96zm-53.276 14.96 1.54-1.62 1.66-1.68q.16-.16.3-.24.14-.1.42-.1h1.6q.28 0 .32.14.06.14-.1.32l-3.2 3.26 3.6 5.64q.1.18.02.32-.06.14-.28.14h-1.54q-.32 0-.46-.1a.84.84 0 0 1-.24-.28l-2.56-4.1-1.14 1.16v2.94q0 .16-.08.28-.08.1-.3.1h-1.42q-.38 0-.38-.38V52.28q0-.4.38-.4h1.42q.22 0 .3.12a.44.44 0 0 1 .08.28v7.52zm15.693 1.12q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1a10 10 0 0 0-.08 1.36q0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m18.529 4.54a.44.44 0 0 1-.08.28q-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.34.12-.66.28l-.56.28v.42a8 8 0 0 1 .02.6v5.66a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.261 0-.6.08-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4.339-.22.72-.38.4-.16.8-.26a3.4 3.4 0 0 1 .82-.14q.86 0 1.56.28.72.26 1.18 1.12a9.7 9.7 0 0 1 1.66-.98q.9-.42 1.86-.42.98 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm16.484 0a.44.44 0 0 1-.08.28q-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.34.12-.66.28l-.56.28v.42a8 8 0 0 1 .02.6v5.66a.44.44 0 0 1-.08.28q-.08.1-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.26 0-.6.08a6 6 0 0 0-.68.22q-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4a4.7 4.7 0 0 1 .72-.38q.4-.16.8-.26.4-.12.82-.14.86 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.98 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.744-12.02q0 .24-.04.46a.76.76 0 0 1-.18.36.84.84 0 0 1-.36.26q-.219.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.5 2.5 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.741 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12a.4.4 0 0 1 .08.26zm9.802-2.56q0 .88-.34 1.48-.34.58-.92.94-.56.36-1.28.52t-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.64.64 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1l.78.08q.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.35 1.35 0 0 0-.5-.22q-.3-.1-.78-.16a14 14 0 0 1-1.4-.26 4.4 4.4 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.5.2.42.6l-.16.72q-.04.22-.16.28-.1.039-.38 0-.64-.08-1.4-.14-.76-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.399.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m4.619 3.16q0 .98-.22 1.72-.22.76-.76 1.26-.519.52-1.38.76-.84.24-2.1.2a.6.6 0 0 1-.26-.08q-.159-.08-.18-.32l-.08-.94q-.04-.24.04-.32.06-.08.28-.12.7-.14 1.16-.28.48-.12.76-.34.3-.22.42-.58.12-.34.12-.92v-9.68q0-.38.4-.38h1.4q.4 0 .4.38zm.08-12.62q0 .24-.04.46a.76.76 0 0 1-.18.36.84.84 0 0 1-.36.26q-.219.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.5 2.5 0 0 1-.04-.44q0-.48.24-.8.24-.34.94-.34.741 0 .96.32.22.3.22.82m10.914 7.34q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7 17 17 0 0 1-.1-1.78q0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.669 4.54a.44.44 0 0 1-.08.28q-.08.1-.3.1h-1.44q-.38 0-.38-.38l.02-5.62q0-.88-.3-1.42-.28-.54-1.14-.54-.3 0-.7.1a7 7 0 0 0-.78.26 9 9 0 0 0-.72.3 8 8 0 0 0-.54.24v6.68q0 .38-.38.38h-1.42q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.38 0 .38.4v.6q.02 0 .02.02h.04q.28-.2.66-.4.4-.22.84-.4t.92-.28q.48-.12.94-.12 1.02 0 1.6.32.58.3.88.82t.38 1.22q.08.68.08 1.44zm4.166-3.92q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08l1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.399.08-.84.14t-.88.1q-.44.04-.8.04-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.341 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.021.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m14.557 7.82a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.44q-.38 0-.38-.38l.02-5.62q0-.88-.3-1.42-.28-.54-1.14-.54-.3 0-.7.1a7 7 0 0 0-.78.26 9 9 0 0 0-.72.3 8 8 0 0 0-.54.24v6.68q0 .38-.38.38h-1.42q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.38 0 .38.4v.6q.02 0 .02.02h.04q.279-.2.66-.4.399-.22.84-.4t.92-.28q.48-.12.94-.12 1.02 0 1.6.32.58.3.88.82t.38 1.22q.08.68.08 1.44z"></path>', 26), QJ = [
  JJ
];
function eQ(t, e) {
  return T(), N("svg", ZJ, [...QJ]);
}
const tQ = { render: eQ }, nQ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, iQ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="m145.6 39.1 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2v3.3c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V33.1c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm17.6 1.9c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c0 .2 0 .3-.1.4m4.8-12.4v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.2.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.9-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.6 3.2c0 .7-.1 1.2-.2 1.7s-.4.9-.8 1.3c-.4.3-.8.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.3-.1s-.2-.2-.2-.3l-.1-.9v-.3c0-.1.1-.1.3-.1q.75-.15 1.2-.3c.45-.15.6-.2.8-.4.2-.1.3-.3.4-.6.1-.2.1-.5.1-.9v-9.7c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v9.6zm.1-12.7v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m8.6 11.3c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><g class="st3"><path d="M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4V66c-.1.2-.2.4-.5.4m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2V66zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m6.2.6c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.6.2-1 .2zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3m8.9 8.5c0 .7-.1 1.2-.2 1.7s-.4.9-.8 1.3c-.4.3-.8.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.3-.1s-.2-.2-.2-.3l-.1-.9V69c0-.1.1-.1.3-.1q.75-.15 1.2-.3c.45-.15.6-.2.8-.4.2-.1.3-.3.4-.6.1-.2.1-.5.1-.9V57c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v9.6zm.1-12.7v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m9.7 9.5q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.2-3.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.6 5c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M246.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function sQ(t, e) {
  return T(), N("svg", nQ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    iQ
  ]);
}
const lQ = { render: sQ }, rQ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, aQ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.2 39.5c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.9.3c.2.1.3.1.3.2s.1.2.1.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.7 0-1.2.1-1.6.4s-.7.6-1 1c-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m19.7 1.5c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.6 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c-.1.2-.1.3-.1.4m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m9.2 0q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m8.1 1.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.2-9.8c-.2 0-.5-.1-.8-.2s-.6-.2-.8-.4c-.3-.1-.6-.2-.8-.4-.3-.1-.5-.2-.7-.2-.1 0-.3 0-.5.1q-.3.15-.6.6l-.2.2s-.1 0-.3-.1l-.6-.2c-.1-.1-.2-.2-.1-.4.3-.7.6-1.2 1-1.5s.8-.4 1.2-.4c.3 0 .5.1.8.2s.6.2.8.3c.3.1.5.2.8.3.2.1.5.2.7.2.4 0 .8-.2 1-.7l.2-.2h.3l.6.3c.1 0 .2.1.2.2v.2q-.45 1.05-.9 1.5c-.5.4-.9.6-1.3.6m.1 6.5h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm13.2-.6c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4" class="st4"></path></g><g class="st3"><path d="M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4V66c-.1.2-.2.4-.5.4m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2V66zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m6.2.6c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.6.2-1 .2zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3m8.7-4.2v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm8.6-.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M233.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function oQ(t, e) {
  return T(), N("svg", rQ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    aQ
  ]);
}
const cQ = { render: oQ }, hQ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, uQ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.2 39.5c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.9.3c.2.1.3.1.3.2s.1.2.1.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.7 0-1.2.1-1.6.4s-.7.6-1 1c-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m19.7 1.5c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.6 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c-.1.2-.1.3-.1.4m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.5-9.5v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.2 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm8.7-.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><g class="st3"><path d="M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4V66c-.1.2-.2.4-.5.4m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2V66zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m6.2.6c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.6.2-1 .2zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3m12.3 7.1c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm13.2 4.4c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V66c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66c.1.1.1.2.1.3m8.3-1.1c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-1.7-9.6c-.7 0-1.3-.2-1.9-.5s-1.1-.9-1.4-1.6c-.1-.1-.1-.2-.1-.3s0-.2.1-.3l.5-.4c.1-.1.2-.1.3-.1s.1.1.2.2c.4.5.8.8 1.1 1.1s.7.3 1.2.3c.2 0 .4 0 .6-.1s.4-.1.5-.3c.2-.1.3-.3.5-.4s.4-.4.6-.6.3-.2.5-.1l.5.3c.1.1.2.2.1.3s-.1.3-.2.4c-.4.7-.8 1.2-1.4 1.6s-1.1.5-1.7.5m1.6 6.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M242.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function dQ(t, e) {
  return T(), N("svg", hQ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    uQ
  ]);
}
const fQ = { render: dQ }, vQ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, pQ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#626366" d="M143.42 33.12q0-.4.4-.4h7.36q.38 0 .38.38v1.24q0 .36-.4.36h-5.46v3.44h4.84q.4 0 .4.36v1.24q0 .36-.4.36h-4.84v3.94h5.6q.36 0 .36.38v1.22q0 .36-.38.36h-7.46q-.4 0-.4-.36zM154.086 46q-.3 0-.4-.1a.5.5 0 0 1-.1-.32v-9q0-.22.08-.3.1-.08.36-.08h4.26q1.74 0 2.54.72t.8 1.94q0 .4-.22.98t-.94.98q.441.18.72.48.28.28.44.6.16.3.22.62t.06.58q0 .66-.28 1.2-.26.54-.72.92a3.2 3.2 0 0 1-1.08.58q-.62.2-1.3.2zm5.6-3.02q0-.5-.32-.88-.3-.4-1.06-.4h-2.56v2.5h2.34q.48 0 .78-.12.32-.12.5-.3t.24-.4q.08-.22.08-.4m-.28-3.96a.9.9 0 0 0-.08-.38.73.73 0 0 0-.22-.32 1 1 0 0 0-.44-.24 1.9 1.9 0 0 0-.66-.1h-2.26v2.16h2.4q.58 0 .92-.32.34-.34.34-.8m13.017 2.02q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12a.44.44 0 0 1 .08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.98 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a8 8 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.56.06 1.08.06.54 0 .9-.14a1.24 1.24 0 0 0 .6-.54q.24-.38.34-1 .1-.64.1-1.58m12.55-.08q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.729 4.54q0 .38-.4.38h-1.42q-.38 0-.38-.38l.02-7.58h-4.2v7.58q0 .16-.08.28-.081.1-.3.1h-1.42q-.38 0-.38-.38v-9.04q0-.38.38-.38h7.8q.219 0 .3.08t.08.3zm4.184-3.92q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m6.056-1.16q0-.22.08-.32.1-.12.34-.12h1.3q.28 0 .36.12t.08.32v5.84h.04l2.62-3.56 1.78-2.36q.12-.16.24-.26.14-.1.44-.1h1.04q.24 0 .34.14.1.12.1.28v8.96q0 .42-.46.42h-1.26q-.46 0-.46-.42v-6.12h-.02q-.7.96-1.4 1.9t-1.4 1.9l-.88 1.2q-.44.58-.9 1.18-.12.16-.28.26-.14.1-.42.1h-.86q-.24 0-.34-.1-.08-.1-.08-.32zm4.4-1.36a4.05 4.05 0 0 1-1.92-.5q-.92-.52-1.4-1.58-.08-.16-.14-.34t.1-.32l.54-.44q.18-.12.28-.06a.8.8 0 0 1 .24.18q.6.72 1.08 1.06.5.34 1.24.34.34 0 .6-.08.28-.08.52-.26.26-.18.52-.44t.58-.62q.24-.28.5-.1l.54.34q.201.12.12.32a3 3 0 0 1-.14.38q-.54 1.06-1.4 1.6a3.53 3.53 0 0 1-1.86.52m13.92 9.8q.06.22 0 .36t-.34.26q-.579.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1 .261.38.66.54.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm3.665.58a.5.5 0 0 1-.06.26q-.06.08-.28.08h-1.5q-.34 0-.34-.34v-9.1q0-.36.34-.36h1.5q.22 0 .28.1a.5.5 0 0 1 .06.26v3.52h1.02q.28 0 .52-.04.26-.04.46-.18.22-.16.4-.44.2-.28.38-.74l.8-2.16a.46.46 0 0 1 .2-.24q.12-.06.36-.06h1.22q.28 0 .32.12.06.12 0 .32l-.7 2.08q-.32.94-.68 1.48t-.9.7v.02q.7.24 1.04.7.34.44.62 1.24l.88 2.68q.06.18.02.32-.04.12-.34.12h-1.34a.9.9 0 0 1-.36-.06q-.12-.06-.18-.24l-.78-2.3q-.32-.92-.84-1.2a2.25 2.25 0 0 0-1.08-.28h-1.04zm13.647-4.12h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.97.97 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28a4.4 4.4 0 0 1 .76-.2q.44-.08.9-.12.459-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48a1 1 0 0 0 .1.26.5.5 0 0 0 .22.12q.14.04.38.06.219.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96zm12.26-8.68q.28 0 .38.1.1.08.1.3v9q0 .4-.48.4h-1.26q-.26 0-.36-.1-.08-.1-.08-.3v-3.4h-2.02a1.52 1.52 0 0 0-.88.34q-.34.28-.62 1.12l-.64 1.94q-.08.24-.2.34-.12.08-.4.08h-1.32q-.28 0-.34-.1-.04-.12.02-.34l.7-2.14q.22-.6.46-1.04.24-.46.68-.7a2.1 2.1 0 0 1-.72-.42 2.3 2.3 0 0 1-.44-.6 2.7 2.7 0 0 1-.22-.7q-.06-.36-.06-.7 0-.76.28-1.32.28-.58.76-.96.48-.4 1.12-.6.66-.2 1.38-.2zm-5.54 3.08q0 .58.34.9.36.32 1.2.32h2.3v-2.5h-2.2q-.72 0-1.18.32t-.46.96M145.22 65.66a.5.5 0 0 1-.06.26q-.06.08-.28.08h-1.5q-.34 0-.34-.34v-9.1q0-.36.34-.36h1.5q.22 0 .28.1a.5.5 0 0 1 .06.26v3.52h1.02q.28 0 .52-.04.26-.04.46-.18.22-.16.4-.44.2-.28.38-.74l.8-2.16a.46.46 0 0 1 .2-.24q.12-.06.36-.06h1.22q.28 0 .32.12.06.12 0 .32l-.7 2.08q-.32.94-.68 1.48t-.9.7v.02q.7.24 1.04.7.34.44.62 1.24l.88 2.68q.06.18.02.32-.04.12-.34.12h-1.34a.9.9 0 0 1-.36-.06q-.12-.06-.18-.24l-.78-2.3q-.32-.92-.84-1.2a2.25 2.25 0 0 0-1.08-.28h-1.04zm16.087-4.72q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.288-.72-.88 1.68q-.279.54-.54 1.06-.26.5-.6 1.1-.18.34-.58.34h-.68q-.28 0-.4-.08a.6.6 0 0 1-.2-.24 26 26 0 0 0-.54-.96q-.26-.44-.5-.92-.26-.46-.52-1a17 17 0 0 0-.52-1h-.04v5.26q0 .4-.46.4h-1.24q-.42 0-.42-.4v-8.98q0-.4.4-.4h1.16q.3 0 .42.08.141.08.24.26.32.58.62 1.16.32.58.62 1.16.46.84.86 1.66.42.8.88 1.64l1.56-2.96 1.42-2.64a.66.66 0 0 1 .24-.26q.16-.1.44-.1h1.04q.4 0 .4.38v9q0 .4-.42.4h-1.26q-.44 0-.44-.4v-5.24zm4.283-3.72q0-.22.08-.32.1-.12.34-.12h1.3q.279 0 .36.12t.08.32v5.84h.04l2.62-3.56 1.78-2.36q.12-.16.24-.26.14-.1.44-.1h1.04q.24 0 .34.14.1.12.1.28v8.96q0 .42-.46.42h-1.26q-.46 0-.46-.42v-6.12h-.02q-.7.96-1.4 1.9t-1.4 1.9l-.88 1.2-.9 1.18q-.12.16-.28.26-.141.1-.42.1h-.86q-.24 0-.34-.1-.08-.1-.08-.32zm18.319 8.44q.06.22 0 .36t-.34.26q-.579.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1 .261.38.66.54.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm8.965 0q.06.22 0 .36t-.34.26q-.579.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1 .261.38.66.54.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm1.485-8.44q0-.22.08-.32.1-.12.34-.12h1.3q.28 0 .36.12t.08.32v5.84h.04l2.62-3.56 1.78-2.36q.12-.16.24-.26.14-.1.44-.1h1.04q.24 0 .34.14.1.12.1.28v8.96q0 .42-.46.42h-1.26q-.46 0-.46-.42v-6.12h-.02q-.7.96-1.4 1.9t-1.4 1.9l-.88 1.2q-.44.58-.9 1.18a1 1 0 0 1-.28.26q-.14.1-.42.1h-.86q-.24 0-.34-.1-.08-.1-.08-.32zm18.52-.46q.28 0 .38.1.1.08.1.3v9q0 .4-.48.4h-1.26q-.26 0-.36-.1-.08-.1-.08-.3v-3.4h-2.02q-.52.04-.88.34-.34.28-.62 1.12l-.64 1.94q-.08.24-.2.34-.12.08-.4.08h-1.32q-.28 0-.34-.1-.04-.12.02-.34l.7-2.14q.22-.6.46-1.04.24-.46.68-.7a2.1 2.1 0 0 1-.72-.42 2.3 2.3 0 0 1-.44-.6 2.7 2.7 0 0 1-.22-.7q-.06-.36-.06-.7 0-.76.28-1.32.28-.58.76-.96.48-.4 1.12-.6.66-.2 1.38-.2zm-5.54 3.08q0 .58.34.9.36.32 1.2.32h2.3v-2.5h-2.2q-.72 0-1.18.32t-.46.96"></path><path fill="#004494" fill-rule="evenodd" d="M263 66.7h3.3V28H263z" clip-rule="evenodd"></path>', 26), mQ = [
  pQ
];
function gQ(t, e) {
  return T(), N("svg", vQ, [...mQ]);
}
const yQ = { render: gQ }, _Q = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, qQ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m.4-9.3c.2.1.2.3.1.4l-2 2.8c-.1.1-.2.2-.4.1l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1zm12.5 9.3c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m11.4 2q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.2-3.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V32.3c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.6 5c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.4-.6v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.2-.2-.4-.5-.5-1m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><g class="st3"><path d="m145.4 60.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm15.7 1.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.5-9.5v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.2 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm8.7-.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M230.4 28h3.3v38.7h-3.3z" class="st1"></path><path d="M506.8 378.8h9.6v11.3h-9.6z"></path><path d="M506.8 378.8h9.6v11.3h-9.6z"></path>', 6);
function wQ(t, e) {
  return T(), N("svg", _Q, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    qQ
  ]);
}
const zQ = { render: wQ }, MQ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, bQ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm14.3 10.5s0-.2.1-.4.2-.5.3-.8.2-.7.4-1.1l1.6-4.7c0-.1.1-.2.2-.2.1-.1.2-.1.3-.1h1.5c.3 0 .3.1.2.4l-3.4 9c-.1.1-.1.3-.2.3-.1.1-.2.1-.4.1H157c-.2 0-.3 0-.4-.1s-.1-.2-.2-.3l-3.4-9v-.3c0-.1.1-.1.2-.1h1.6c.1 0 .3 0 .3.1.1 0 .1.1.2.3l1.6 4.7c.1.4.2.8.3 1.1s.2.5.2.8zm8.6 2.1c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3s-.5.2-.6.2v6.6zm13.2-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1s-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5q-.15-.6-.3-.9c-.1-.2-.3-.4-.5-.4-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m11.4 2q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.2-3.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V32.3c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.6 5c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.2-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><g class="st3"><path d="m145.4 60.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm15.7 1.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.8-12.4v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.3.6-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m4.5-9.5v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.2 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm5.3.6c0 .7-.1 1.2-.2 1.7s-.4.9-.8 1.3c-.4.3-.8.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.3-.1s-.2-.2-.2-.3l-.1-.9V69c0-.1.1-.1.3-.1q.75-.15 1.2-.3c.45-.15.6-.2.8-.4.2-.1.3-.3.4-.6.1-.2.1-.5.1-.9V57c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v9.6zm.1-12.7v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m8.6 11.3c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><path d="M230.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function LQ(t, e) {
  return T(), N("svg", MQ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    bQ
  ]);
}
const xQ = { render: LQ }, SQ = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 290 72"
}, CQ = /* @__PURE__ */ U1('<g id="Page-1"><g id="Version-2-menu" transform="translate(-131 -108)"><g id="Site-header" transform="translate(131 108)"><g id="logo-copy"><g id="Group-20"><g id="Group-18-Copy"><path id="Fill-40" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-3.75 2.4-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" class="st0"></path><path id="Fill-41" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" class="st0"></path><path id="Fill-42" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" class="st0"></path><path id="Fill-43" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" class="st0"></path><path id="Fill-44" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" class="st0"></path><path id="Fill-45" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" class="st0"></path><path id="Fill-46" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" class="st0"></path><path id="Fill-47" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" class="st0"></path><path id="Fill-48" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" class="st0"></path><path id="Fill-49" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5" class="st0"></path><path id="Fill-50" d="m41.5 60.9-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9z" class="st0"></path><path id="Fill-51" d="M66.1 65.5 0 63.8v2.6h66.1z" class="st0"></path><path id="Fill-52" d="M60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6" class="st0"></path><path id="Fill-53" d="M94.2 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9z" class="st0"></path><path id="Fill-54" d="M94.2 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" class="st0"></path><path id="Fill-55" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" class="st0"></path><path id="Fill-56" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" class="st0"></path><path id="Fill-57" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" class="st0"></path><path id="Fill-58" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" class="st0"></path><path id="Fill-59" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8z" class="st0"></path><path id="Fill-60" d="M94.2 53.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3z" class="st0"></path><path id="Fill-61" d="M94.2 58.7s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6z" class="st0"></path><path id="Fill-62" d="M94.2 64.3s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2z" class="st0"></path><path id="Fill-63" d="M121.7 33.4c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" class="st0"></path><path id="Fill-64" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" class="st0"></path><path id="Fill-65" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" class="st0"></path><path id="Fill-66" d="M85.4 27.6H27.5v38.7h57.9z" class="st1"></path><path id="Fill-67" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2z" class="st2"></path><path id="Fill-68" d="M57.1 58.9h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-69" d="M63.5 57.2h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-70" d="M63.5 34.8h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-71" d="M68.3 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-72" d="M68.3 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-73" d="M70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-74" d="M50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33z" class="st2"></path><path id="Fill-75" d="M45.9 39.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-76" d="M44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9z" class="st2"></path><path id="Fill-77" d="M45.9 52.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path><path id="Fill-78" d="M50.6 57.3h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" class="st2"></path></g></g></g></g></g></g><g class="st3"><path d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.1-.4c0 .3-.1.4-.4.4H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2v6.6zm13.3-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.9 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m-2.3 0c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.45.15.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m6.2.6c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.4-.2-.7-.3-1.1-.3m8.7-4.2v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.1-3.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V32.3c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.7 5c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-.2-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.3.3.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2z" class="st4"></path></g><g class="st3"><path d="m145.4 60.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.15.15-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm15.7 1.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m18.5 4.9c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.1.3m16.5 0c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1H186c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4H180c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4c.3-.1.5-.2.8-.3s.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c-.1.1-.1.2-.2.3m4.8-12.4v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.2.1.2.4.2.7m-.1 12.1c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm9.8-2.6q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m9.3 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.4-9.5v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7M222 66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm11-4.7c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.2.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m12.6 4.9c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V66c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66c.2.1.2.2.1.3m4.2-4.3c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.5.2-.9.2zm2-3.9c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5c-.3-.2-.6-.3-1.1-.3m14.6 8.2c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3V66c0 .3-.1.4-.4.4H256c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5V66c.2.1.1.2.1.3" class="st4"></path></g><path d="M273.4 28h3.3v38.7h-3.3z" class="st1"></path>', 4);
function kQ(t, e) {
  return T(), N("svg", SQ, [
    (T(), v2(be("style"), null, {
      default: Q2(() => [
        K3(".st0{fill:#bbbdbf}.st1{fill:#034da1}.st2{fill:#fff100}.st3{enable-background:new}.st4{fill:#626366}")
      ]),
      _: 1
    })),
    CQ
  ]);
}
const EQ = { render: kQ }, AQ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, FQ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" d="M27.5 66.3h57.9V27.6H27.5z" clip-rule="evenodd"></path><path fill="#FFF100" fill-rule="evenodd" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" clip-rule="evenodd"></path><path fill="#626366" d="M151.68 34.34q0 .36-.4.36h-3.18v10.92q0 .16-.08.28-.06.1-.28.1h-1.5q-.38 0-.38-.38V34.7h-3.16q-.24 0-.32-.08a.44.44 0 0 1-.08-.28V33.1a.44.44 0 0 1 .08-.28q.08-.1.3-.1h8.62q.38 0 .38.38zm9.235 11.28q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V45l-.04-.02q-.3.2-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V36.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1a8 8 0 0 0 .78-.24q.38-.16.7-.3l.52-.26V36.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4zm16.465 0q0 .18-.08.28-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1a9 9 0 0 0-.7.24 6 6 0 0 0-.66.28l-.56.28v.42q.02.26.02.6v5.66q0 .18-.08.28t-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44a2.7 2.7 0 0 0-.6.08q-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V36.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4a4.7 4.7 0 0 1 .72-.38q.4-.16.8-.26.4-.12.82-.14.861 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.981 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.225-3.92q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16a1.5 1.5 0 0 0-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m15.621 5.4q.22-.62.4-1.16.2-.54.34-.94.16-.48.3-.88l1.24-3.68a.54.54 0 0 1 .16-.26q.1-.08.32-.08h1.48q.24 0 .26.12t-.04.28l-4.66 12.72a.7.7 0 0 1-.18.28q-.1.08-.36.08h-1.36q-.24 0-.28-.12a.55.55 0 0 1 .04-.28l1.26-3.38-3.5-9.3q-.06-.16-.04-.28.04-.12.26-.12h1.54q.2 0 .28.04t.16.26l1.3 3.72 1 2.98zm11.984-1.66h-2.44q-.759 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.3 5.3 0 0 0-1.02-.08q-.24 0-.6.02-.339.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.081-.14.42-.28.32-.12.76-.2.441-.08.9-.12.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.699 0-1.14-.26-.42-.26-.58-.96zm-63.05 19.3q1.32 0 2-.72.7-.74.7-2.3v-8.02q0-.4.4-.4h1.5q.22 0 .28.12a.44.44 0 0 1 .08.28l-.02 8.02q0 .6-.08 1.2-.06.58-.28 1.16-.3.72-.78 1.22-.46.5-1.06.82t-1.3.46a6.5 6.5 0 0 1-1.44.16q-3.16 0-4.32-2.22a4.7 4.7 0 0 1-.46-1.3q-.14-.72-.14-1.5v-8.02q0-.4.38-.4h1.5q.38 0 .38.4v8.02q0 1.48.66 2.26.68.76 2 .76m9.779-.64q0 .46.2.58.22.1.74.1.22.02.28.06.08.04.12.2l.08 1.02q.02.24-.26.38a1.9 1.9 0 0 1-.66.18q-.38.06-.64.06-1.14 0-1.6-.5-.44-.52-.44-1.54V52.28q0-.38.38-.38h1.42q.38 0 .38.38zm8.933-1.98h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08a5.5 5.5 0 0 0 .76-.22q.38-.14.74-.3.36-.18.64-.34zm.12 3.32a6.7 6.7 0 0 1-1.72.94q-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.459-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.219.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96zm8.52-1.66q.22-.62.4-1.16.2-.54.34-.94.16-.48.3-.88l1.24-3.68a.55.55 0 0 1 .16-.26q.1-.08.32-.08h1.48q.24 0 .26.12t-.04.28l-4.66 12.72a.7.7 0 0 1-.18.28q-.099.08-.36.08h-1.36q-.24 0-.28-.12a.55.55 0 0 1 .04-.28l1.26-3.38-3.5-9.3q-.06-.16-.04-.28.04-.12.26-.12h1.54q.2 0 .28.04t.16.26l1.3 3.72 1 2.98zm11.985-1.66h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08a5.5 5.5 0 0 0 .76-.22q.38-.14.74-.3.36-.18.64-.34zm.12 3.32a6.7 6.7 0 0 1-1.72.94q-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.459-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.219.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96z"></path><path fill="#004494" fill-rule="evenodd" d="M223 66.7h3.3V28H223z" clip-rule="evenodd"></path>', 26), TQ = [
  FQ
];
function IQ(t, e) {
  return T(), N("svg", AQ, [...TQ]);
}
const OQ = { render: IQ }, NQ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, PQ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6M94.201 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.201 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.701 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L54.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#004494" fill-rule="evenodd" d="M245.4 66.7h3.3V28h-3.3z" clip-rule="evenodd"></path><path fill="#626366" d="M144.58 45.58q-.08.24-.2.34a.6.6 0 0 1-.34.08h-1.56q-.36 0-.22-.4l4.04-12.44a.9.9 0 0 1 .18-.32q.1-.1.38-.1h1.74q.28 0 .38.12.1.1.16.3l4.12 12.48q.1.36-.2.36h-1.76q-.24 0-.34-.1a1.2 1.2 0 0 1-.16-.32l-.84-2.88h-4.48zm4-7.6-.82-2.88h-.08l-.8 2.84-.84 2.88h3.38zm10.062 5.56q0-.06.12-.42l.26-.82q.16-.519.38-1.14l1.6-4.64a.7.7 0 0 1 .14-.24q.1-.08.32-.08h1.52q.4 0 .24.38l-3.4 9a.73.73 0 0 1-.2.32q-.12.1-.36.1h-1.34q-.28 0-.38-.08a.9.9 0 0 1-.18-.32l-3.4-9a.4.4 0 0 1-.02-.28q.04-.12.24-.12h1.58q.22 0 .3.08.1.06.18.28l1.6 4.68q.18.58.34 1.08.14.42.24.8.12.36.16.42zm8.56 2.08q0 .38-.38.38h-1.44q-.38 0-.38-.38V36.6q0-.4.38-.4h1.42q.4 0 .4.4v.88l.04.04a4 4 0 0 1 .58-.42q.36-.24.76-.42.42-.2.84-.36t.78-.22a.5.5 0 0 1 .32.02q.12.06.16.32l.14 1.34a.7.7 0 0 1-.02.32q-.039.1-.36.16-.42.08-.88.2a10 10 0 0 0-.9.24q-.44.12-.82.24t-.64.24zm13.206 0q0 .38-.38.38h-1.42q-.22 0-.3-.1a.43.43 0 0 1-.08-.28V45l-.04-.02q-.3.201-.7.42-.38.2-.82.38t-.92.28q-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V36.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1.399-.099.78-.24.38-.159.7-.3l.52-.26V36.6q0-.18.08-.28.08-.12.3-.12h1.42q.38 0 .38.4zm10.785-4.58q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12a.44.44 0 0 1 .08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.98 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.579-.28-.9-.2-.32-.5-.42a1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a8 8 0 0 0-.76.24q-.36.12-.7.28-.321.16-.54.28v5q.68.2 1.22.28.56.06 1.08.06.54 0 .9-.14a1.24 1.24 0 0 0 .6-.54q.24-.38.34-1 .1-.64.1-1.58m10.109.52h-2.44q-.759 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32a6.7 6.7 0 0 1-1.72.94q-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.339.02-.72.04-.36.021-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.081-.14.42-.28a4.5 4.5 0 0 1 .76-.2q.441-.08.9-.12.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.699 0-1.14-.26-.42-.26-.58-.96zM145.62 59.12l1.52-1.96 3.36-4.14a.8.8 0 0 1 .28-.22.8.8 0 0 1 .38-.08h1.82q.22 0 .26.12.06.12-.08.28l-4.34 5.28 4.48 7.18q.12.2.04.32-.08.1-.24.1h-1.84q-.26 0-.4-.1-.12-.1-.24-.28l-3.28-5.44-1.76 2.18v3.26q0 .16-.08.28-.06.1-.28.1h-1.5q-.4 0-.4-.38v-12.5q0-.4.4-.4h1.5q.22 0 .28.12.08.1.08.28v6zm17.562 1.82q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m18.529 4.54a.44.44 0 0 1-.08.28q-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.34.12-.66.28l-.56.28v.42a8 8 0 0 1 .02.6v5.66a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.261 0-.6.08-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4.339-.22.72-.38.4-.16.8-.26a3.4 3.4 0 0 1 .82-.14q.86 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.98 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.744-12.02q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm9.801-2.56q0 .88-.34 1.48a2.7 2.7 0 0 1-.92.94q-.56.36-1.28.52a7 7 0 0 1-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.3 1.3 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.5 4.5 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.501.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.759-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m5.76.14q.22-.62.4-1.16.2-.54.34-.94.16-.48.3-.88l1.24-3.68a.54.54 0 0 1 .16-.26q.1-.08.32-.08h1.48q.24 0 .26.12t-.04.28l-4.66 12.72a.7.7 0 0 1-.18.28q-.1.08-.36.08h-1.36q-.24 0-.28-.12a.55.55 0 0 1 .04-.28l1.26-3.38-3.5-9.3q-.06-.16-.04-.28.04-.12.26-.12h1.54q.2 0 .28.04t.16.26l1.3 3.72 1 2.98zm14.424-2.26q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.669 4.54a.44.44 0 0 1-.08.28q-.08.1-.3.1h-1.44q-.38 0-.38-.38l.02-5.62q0-.88-.3-1.42-.28-.54-1.14-.54-.3 0-.7.1a7 7 0 0 0-.78.26 9 9 0 0 0-.72.3 8 8 0 0 0-.54.24v6.68q0 .38-.38.38h-1.42q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.38 0 .38.4v.6q.02 0 .02.02h.04q.28-.2.66-.4.4-.22.84-.4t.92-.28q.48-.12.94-.12 1.02 0 1.6.32.58.3.88.82t.38 1.22q.08.68.08 1.44zm10.586 0q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V65l-.04-.02q-.3.2-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V56.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1a8 8 0 0 0 .78-.24q.38-.16.7-.3l.52-.26V56.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4z"></path>', 26), BQ = [
  PQ
];
function VQ(t, e) {
  return T(), N("svg", NQ, [...BQ]);
}
const RQ = { render: VQ }, HQ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, DQ = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#626366" d="M143.2 39.28q0-1.26.2-2.46.22-1.22.82-2.16a4.35 4.35 0 0 1 1.64-1.5q1.06-.58 2.74-.58.36 0 .84.04.5.02 1 .1.5.06.98.18.5.1.86.26.24.1.32.24t.02.4l-.16.78q-.06.4-.52.32a34 34 0 0 0-1.6-.18 18 18 0 0 0-1.66-.08q-.84 0-1.4.28-.54.28-.88.78-.34.48-.52 1.14a8.5 8.5 0 0 0-.22 1.38h4.7q.38 0 .38.36v1.18q0 .36-.38.36h-4.72q.04.86.18 1.6.14.72.48 1.26t.92.84 1.5.3q.86 0 1.66-.08t1.58-.18q.24-.04.34.04.12.08.18.26l.16.78q.1.44-.36.66-.4.16-.88.28-.48.1-.98.16-.5.08-.98.1-.48.04-.84.04-1.72 0-2.78-.58a4.55 4.55 0 0 1-1.64-1.58 6.3 6.3 0 0 1-.78-2.2q-.2-1.24-.2-2.54M154.594 46q-.3 0-.4-.1a.5.5 0 0 1-.1-.32v-9q0-.22.08-.3.1-.08.36-.08h4.26q1.74 0 2.54.72t.8 1.94q0 .4-.22.98t-.94.98q.441.18.72.48.28.28.44.6.16.3.22.62t.06.58q0 .66-.28 1.2-.26.54-.72.92a3.2 3.2 0 0 1-1.08.58q-.62.2-1.3.2zm5.6-3.02q0-.5-.32-.88-.3-.4-1.06-.4h-2.56v2.5h2.34q.48 0 .78-.12.32-.12.5-.3t.24-.4q.08-.22.08-.4m-.28-3.96a.9.9 0 0 0-.08-.38.73.73 0 0 0-.22-.32 1 1 0 0 0-.44-.24 1.9 1.9 0 0 0-.66-.1h-2.26v2.16h2.4q.58 0 .92-.32.34-.34.34-.8m13.017 2.02q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12a.44.44 0 0 1 .08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.98 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12 2.7 2.7 0 0 0-.68.1 8 8 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.56.06 1.08.06.54 0 .9-.14a1.24 1.24 0 0 0 .6-.54q.24-.38.34-1 .1-.64.1-1.58m12.55-.08q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.728 4.54q0 .38-.4.38h-1.42q-.38 0-.38-.38l.02-7.58h-4.2v7.58q0 .16-.08.28-.08.1-.3.1h-1.42q-.38 0-.38-.38v-9.04q0-.38.38-.38h7.8q.22 0 .3.08t.08.3zm4.185-3.92q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m6.056-1.16q0-.22.08-.32.1-.12.34-.12h1.3q.28 0 .36.12t.08.32v5.84h.04l2.62-3.56 1.78-2.36q.12-.16.24-.26.14-.1.44-.1h1.04q.24 0 .34.14.1.12.1.28v8.96q0 .42-.46.42h-1.26q-.46 0-.46-.42v-6.12h-.02q-.7.96-1.4 1.9t-1.4 1.9l-.88 1.2q-.44.58-.9 1.18a1 1 0 0 1-.28.26q-.14.1-.42.1h-.86q-.24 0-.34-.1-.08-.1-.08-.32zm4.4-1.36a4.05 4.05 0 0 1-1.92-.5q-.92-.52-1.4-1.58a3 3 0 0 1-.14-.34q-.06-.18.1-.32l.54-.44q.18-.12.28-.06a.8.8 0 0 1 .24.18q.6.72 1.08 1.06.5.34 1.24.34.34 0 .6-.08.28-.08.52-.26.26-.18.52-.44t.58-.62q.24-.28.5-.1l.54.34q.2.12.12.32-.06.2-.14.38-.54 1.06-1.4 1.6a3.53 3.53 0 0 1-1.86.52m13.92 9.8q.06.22 0 .36t-.34.26q-.58.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1t.66.54q.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm1.885.92q-.28 0-.34-.1t-.06-.32v-9.02q0-.22.1-.28.12-.08.38-.08h1.28q.24 0 .32.08.1.08.1.28v3.26h2.42q1.04 0 1.72.28.7.28 1.08.72.4.44.56 1t.16 1.12q0 .76-.3 1.34a2.9 2.9 0 0 1-.78.96q-.48.38-1.16.58-.66.18-1.44.18zm5.62-3.12q0-.58-.34-.92-.34-.36-1.2-.36h-2.3v2.56h2.2q.74 0 1.18-.32.46-.32.46-.96m5.886 2.78a.5.5 0 0 1-.06.26q-.06.08-.28.08h-1.5q-.34 0-.34-.34v-9.1q0-.36.34-.36h1.5q.22 0 .28.1a.5.5 0 0 1 .06.26v3.52h1.02q.28 0 .52-.04a1.1 1.1 0 0 0 .46-.18q.22-.16.4-.44.2-.28.38-.74l.8-2.16q.08-.18.2-.24t.36-.06h1.22q.28 0 .32.12.06.12 0 .32l-.7 2.08q-.32.94-.68 1.48t-.9.7v.02q.7.24 1.04.7.34.44.62 1.24l.88 2.68q.06.18.02.32-.04.12-.34.12h-1.34a.9.9 0 0 1-.36-.06q-.12-.06-.18-.24l-.78-2.3q-.32-.92-.84-1.2a2.25 2.25 0 0 0-1.08-.28h-1.04zm13.647-4.12h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96zM145.22 65.66a.5.5 0 0 1-.06.26q-.06.08-.28.08h-1.5q-.34 0-.34-.34v-9.1q0-.36.34-.36h1.5q.22 0 .28.1a.5.5 0 0 1 .06.26v3.52h1.02q.28 0 .52-.04.26-.04.46-.18.22-.16.4-.44.2-.28.38-.74l.8-2.16a.46.46 0 0 1 .2-.24q.12-.06.36-.06h1.22q.28 0 .32.12.06.12 0 .32l-.7 2.08q-.32.94-.68 1.48t-.9.7v.02q.7.24 1.04.7.34.44.62 1.24l.88 2.68q.06.18.02.32-.04.12-.34.12h-1.34a.9.9 0 0 1-.36-.06q-.12-.06-.18-.24l-.78-2.3q-.32-.92-.84-1.2a2.25 2.25 0 0 0-1.08-.28h-1.04zm16.087-4.72q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.288-.72-.88 1.68q-.279.54-.54 1.06-.26.5-.6 1.1-.18.34-.58.34h-.68q-.28 0-.4-.08a.6.6 0 0 1-.2-.24 26 26 0 0 0-.54-.96q-.26-.44-.5-.92-.26-.46-.52-1a17 17 0 0 0-.52-1h-.04v5.26q0 .4-.46.4h-1.24q-.42 0-.42-.4v-8.98q0-.4.4-.4h1.16q.3 0 .42.08.141.08.24.26.32.58.62 1.16.32.58.62 1.16.46.84.86 1.66.42.8.88 1.64l1.56-2.96 1.42-2.64a.66.66 0 0 1 .24-.26q.16-.1.44-.1h1.04q.4 0 .4.38v9q0 .4-.42.4h-1.26q-.44 0-.44-.4v-5.24zm6.903-6.76q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.85.85 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm9.921-.54q.06.22 0 .36t-.34.26q-.58.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1t.66.54q.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm4.105-11.48q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.85.85 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm10.121-9.44q.28 0 .38.1.1.08.1.3v9q0 .4-.48.4h-1.26q-.26 0-.36-.1-.08-.1-.08-.3v-3.4h-2.02a1.52 1.52 0 0 0-.88.34q-.34.28-.62 1.12l-.64 1.94q-.08.24-.2.34-.12.08-.4.08h-1.32q-.28 0-.34-.1-.04-.12.02-.34l.7-2.14q.22-.6.46-1.04.24-.46.68-.7a2.1 2.1 0 0 1-.72-.42 2.3 2.3 0 0 1-.44-.6 2.7 2.7 0 0 1-.22-.7q-.06-.36-.06-.7 0-.76.28-1.32.28-.58.76-.96a3.2 3.2 0 0 1 1.12-.6q.66-.2 1.38-.2zm-5.54 3.08q0 .58.34.9.36.32 1.2.32h2.3v-2.5h-2.2q-.72 0-1.18.32t-.46.96"></path><path fill="#004494" fill-rule="evenodd" d="M263 66.7h3.3V28H263z" clip-rule="evenodd"></path>', 26), $Q = [
  DQ
];
function UQ(t, e) {
  return T(), N("svg", HQ, [...$Q]);
}
const jQ = { render: UQ }, GQ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, WQ = /* @__PURE__ */ U1('<path fill="#626366" d="M158.018 42.76h2.752c-.215 1.419-.559 2.924-.903 3.956l1.183.623c.602-1.462 1.139-3.762 1.462-5.74l-1.054-.409-.279.086h-5.698c.258-1.16.473-2.365.667-3.59l-1.613-.237c-.43 3.419-1.225 6.773-2.623 8.901.387.215 1.054.731 1.333 1.01.753-1.246 1.354-2.837 1.849-4.6h1.376v3.031c.021 1.462-.494 5.44-3.354 8.342v-1.182h-7.568V40.33h7.374v-1.484H144v17.2h1.548v-1.613h7.267q-.774.71-1.741 1.29c.279.301.752.946.924 1.29 3.677-2.257 4.988-6.192 5.246-7.998.236 1.742 1.441 5.848 4.623 7.977.215-.366.709-1.01.989-1.355-4.15-2.687-4.859-8.148-4.838-9.847zm-7.761-1.785a32 32 0 0 1-1.161 4.3 43 43 0 0 0-2.43-2.408l-.946.99a41 41 0 0 1 2.817 2.923c-.753 1.763-1.677 3.311-2.774 4.515.323.237.946.731 1.204.99 1.011-1.183 1.871-2.624 2.602-4.258.86 1.054 1.569 2.086 2.021 2.924l1.053-1.16c-.538-.947-1.419-2.108-2.429-3.29a38 38 0 0 0 1.505-5.268zm31.024-1.548v1.892h-5.052v-1.892zm-5.16 5.031c.086-.645.108-1.29.108-1.87v-.065h5.052v1.935zm5.16 1.183v1.827c0 .258-.086.344-.387.366-.301 0-1.333.021-2.451-.022.215.387.495.946.602 1.376 1.441 0 2.43-.021 3.032-.258.58-.236.774-.645.774-1.462v-9.33h-8.084v4.428c0 1.914-.28 4.193-2.43 5.848.323.194.903.731 1.118 1.054 1.355-1.054 2.064-2.43 2.43-3.827zm-10.04-5.891v2.3h-3.892v-2.3zm-3.892 5.826v-2.279h3.892v2.28zm0 1.29h5.354v-8.428h-6.816v9.59h1.462zm1.312 4.279h2.838v3.913h-2.838zm7.159 0v3.913h-2.838v-3.913zm4.386 0v3.913h-2.902v-3.913zm1.548 3.913v-5.225h-14.598v5.225h-2.494v1.419h19.479v-1.42zm18.254-4.58c-.753 1.226-1.763 2.193-3.053 2.924a169 169 0 0 0-4.967-1.118c.473-.516.968-1.16 1.462-1.806zm1.225-2.924a10.6 10.6 0 0 1-.537 1.527h-6.235a47 47 0 0 0 .989-1.591h1.225v-4.257h8.686v-1.376h-8.686v-2.28c2.451-.214 4.73-.537 6.536-.945l-1.183-1.14c-3.16.731-9.158 1.161-14.06 1.29.15.344.322.903.344 1.269 2.15-.065 4.514-.172 6.793-.344v2.15h-8.621v1.376h6.751c-1.892 1.59-4.687 2.988-7.202 3.676.301.301.752.882.988 1.247 2.86-.903 6.085-2.73 8.084-4.859v3.827l-1.139-.3a20 20 0 0 1-1.397 2.257h-6.321v1.397h5.288a25 25 0 0 1-2.214 2.58c1.957.387 3.827.817 5.59 1.247-2.064.731-4.665 1.118-7.976 1.312.258.387.494.967.623 1.44 4.171-.3 7.353-.924 9.74-2.128 2.644.688 4.945 1.419 6.643 2.085l1.462-1.16c-1.72-.624-3.977-1.29-6.45-1.936a9.36 9.36 0 0 0 2.881-3.44h3.784v-1.397h-3.182c.108-.366.237-.731.344-1.118zm-3.891-3.268c2.644 1.075 6.127 2.688 7.869 3.698l.774-1.16c-1.828-1.033-5.311-2.538-7.869-3.548zm15.071-4.515h10.04v2.43h-10.04zm-1.677-1.419v5.268h13.48v-5.268zm5.719 10.062v1.978c0 1.72-.623 4.02-8.385 5.526.387.344.86.989 1.053 1.333 8.063-1.785 9.052-4.558 9.052-6.816v-2.02zm1.591 5.655c2.623.881 6.149 2.279 7.933 3.182l.818-1.355c-1.871-.903-5.397-2.193-7.956-3.01zm-8.063-8.514v7.912h1.656V47.06h11.696v6.256h1.72v-7.761zm20.189 4.192h6.106c-1.398 1.914-3.01 3.612-3.612 4.107-.645.623-1.14 1.032-1.591 1.118.172.473.43 1.311.538 1.655.795-.3 1.999-.387 13.33-1.333.473.645.902 1.269 1.203 1.785l1.419-.882c-.946-1.612-2.967-3.891-4.88-5.611l-1.354.73a32 32 0 0 1 2.494 2.58l-9.762.732c1.548-1.398 3.054-3.118 4.387-4.88h9.374v-1.549h-17.652zm8.836-12.276c-1.913 2.88-5.676 5.568-9.847 7.331.366.323.925.968 1.162 1.376a28 28 0 0 0 3.547-1.913v1.311h10.213v-1.483h-9.934c1.849-1.183 3.505-2.559 4.838-4.02 2.021 2.085 5.375 4.536 8.708 5.89.258-.451.752-1.096 1.117-1.419-3.461-1.182-6.944-3.547-8.901-5.547.194-.28.409-.58.624-.86z"></path><path fill="#004494" fill-rule="evenodd" d="M255.812 66.7h3.3V28h-3.3z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g>', 26), YQ = [
  WQ
];
function XQ(t, e) {
  return T(), N("svg", GQ, [...YQ]);
}
const KQ = { render: XQ }, ZQ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, JQ = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M155 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4-.5 0-37.5 3.9-37.5 3.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="155" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 5.2h66.1V28H155z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M208.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="155" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 10.9h66.1v20.6H155z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M215.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L155 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="155" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 21.7h66.2v16.8H155z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M205.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L155 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M206.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M206.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="155" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 38.2h66.2v10.6H155z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M205.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2l-37.9 1v2.6l33.6-1.8 4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M205.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1l-33.2.6v2.6l33.3-1.4c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="155" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M155 49.2h66.2v6.6H155z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M205.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M205.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1l-15.8.1v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101c-10.9-.2-21.8-.399-32.9-.599v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L155 63.8v2.6h66.1zM215.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L155 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34.001-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M249.201 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M249.201 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M249.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M249.201 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M249.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M276.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M276.701 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" d="M182.5 66.3h57.9V27.6h-57.9z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M181.5 26.6h59.9v40.7h-59.9zm2 2v36.7h55.9V28.6z" clip-rule="evenodd"></path><path fill="#FFF100" fill-rule="evenodd" d="M212.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L209.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.401-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm-.001-22.4h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.801-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zm-19.6-11.2h2l-1.6 1.2.6 1.901-1.5-1.101-1.7 1.2.6-1.9-1.6-1.2h2l.7-1.9zm-4.602 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM199.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L196 46h2l.6-1.9zm1.699 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.701 4.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M74 66.7h3.3V28H74z" clip-rule="evenodd"></path><path fill="#fff" d="M93.602 39.031q0 .195-.02.332a1.7 1.7 0 0 1-.098.342q-.547-1.221-1.62-2.52-1.192-1.435-1.876-1.435-.146 0-.293.254-.146.254-.341.254-.264 0-.83-.342a4 4 0 0 1-1.143-.996q-.576-.762-.576-1.621 0-.615.4-.615.703 0 2.197.888 1.67.987 2.803 2.305 1.397 1.611 1.397 3.154m4.042 5.108h-.595q-.82 0-1.319-.889-.595-1.074-.595-3.252 0-.156-.04-.42a4 4 0 0 1-.029-.332q-.937 2.608-1.67 3.574-.869 1.133-2.45 1.504-1.35.313-4.59.313v-.274q2.626-.79 3.916-1.367 2.08-.918 3.154-2.119 1.299-1.446 1.299-3.428 0-.956-.127-1.787a17 17 0 0 0-.332-1.7l.322-.82q.195-.478.361-.81.255 1.407.479 3.037.156 1.124.303 2.412.184 1.582.322 2.55.176 1.23.527 1.757.234.352.469.352h.595z"></path><path fill="#fff" d="M105.525 44.139h-1.015q-.654 0-1.475-.293a5.6 5.6 0 0 1-1.67-.938q-.566.694-1.162.967-.585.264-1.719.264h-1.523v-1.7h1.494q.89 0 1.582-.449.537-.351.977-.986a6.2 6.2 0 0 1 1.465-1.494q.78-.567 1.435-.723.674 1.026 1.074 1.846.537 1.113.537 1.806zm-1.123-1.924a5 5 0 0 0-.39-1.113 6 6 0 0 0-.596-.948 1.67 1.67 0 0 0-.791.44q-.215.205-.508.693.352.381.987.684.644.303 1.21.37z"></path><path fill="#fff" d="m109.588 33.318-.752 1.426-1.572-.84.722-1.426zm1.299 10.82h-6.035V42.44h5.205q0-.87-.205-1.631-.508.165-.782.234a3.2 3.2 0 0 1-.791.117q-.712 0-1.162-.361-.517-.41-.517-1.182 0-1.358.488-2.373.547-1.133 1.426-1.133 1.191 0 1.836 1.866.537 1.542.537 3.623zm-1.592-5.078a2.6 2.6 0 0 0-.44-.712q-.41-.489-.781-.489a.54.54 0 0 0-.439.225.82.82 0 0 0-.166.518q0 .78.859.78.225 0 .479-.087.254-.088.488-.235m10.234 4.493q0 1.611-1.191 3.203-1.329 1.777-3.067 1.777-.644 0-1.328-.146a13 13 0 0 1-1.298-.371q-.636-.225-1.27-.44l.166-.342 1.143.264q.605.147 1.084.147a4.5 4.5 0 0 0 2.255-.606q.83-.478 1.661-1.387.42-.459 1.191-1.494-1.318 0-1.973-.42-.741-.479-.742-1.572 0-1.005.469-1.865.546-.996 1.387-.996.85 0 1.22.986.294.77.293 2.149zm-.615-1.065q-.215-.938-.518-1.298a.81.81 0 0 0-.644-.313.7.7 0 0 0-.479.185.58.58 0 0 0-.195.45q0 .479.43.732.43.244 1.406.244"></path><path fill="#fff" d="m130.252 36.023-.742 1.416-1.582-.82.722-1.426zm6.211 8.116h-11.738q-.528 0-1.006-.176a5 5 0 0 1-.85-.44 2.5 2.5 0 0 1-.82.489q-.41.127-1.309.127h-1.885v-1.7h1.885q.791 0 1.133-.136.567-.225.566-.899 0-.283-.039-.566a7 7 0 0 0-.097-.635l.4-.586q.341 1.33.938 2.051.635.772 1.494.772.82 0 1.924-.372 1.19-.4 2.05-1.015 1.397-.996 1.709-1.192.792-.508 1.436-.722a4.9 4.9 0 0 1 1.582-.245q1.328 0 2.002.772.625.713.625 2.002zm-1.592-2.452q0-.478-.596-.742-.595-.273-1.386-.273-.976 0-2.364.654-1.103.556-2.197 1.114h4.502q1.065 0 1.553-.186t.488-.566"></path><path fill="#fff" d="M141.355 44.139h-5.566v-1.7h4.854q0-1.152-.274-1.757-.186-.42-.918-1.211l.762-1.592q.703.889.879 1.387.263.75.263 2.49zm-.048 1.953-.762 1.406-1.582-.84.732-1.396zm-2.246.879-.743 1.416-1.582-.82.723-1.417zm6.865-11.953-.762 1.406-1.582-.84.732-1.397zm-2.246.879-.742 1.416-1.583-.82.723-1.417zm3.105 5.36q0 1.378-.449 2.071-.694 1.074-2.539 1.074-.713 0-1.182-.283-.537-.322-.537-.918 0-.684.342-1.582.312-.762.635-1.533l-.147-.04.596-1.65q1.767.929 2.109 1.172 1.173.82 1.172 1.69m-.849.763q0-.372-1.075-.987a15 15 0 0 0-.986-.517q-.44.478-.527.595-.274.381-.274.723 0 .498.274.781.282.273.752.274.546 0 1.191-.303.645-.312.645-.566M99.617 53.816l-.469 1.758-.576-.283.02.889q0 1.308-.332 2.539-.361 1.347-1.143 2.666.371.684.518 1.074.225.615.224 1.25 0 .36-.02.615a5 5 0 0 1-.087.596q-1.036.234-2.217.371-1.172.127-2.285.127.01-.186.01-.312.048-.742.234-1.377a9 9 0 0 0 2.803-2.305 61 61 0 0 0-.996-1.826q-.342-.587-1.162-1.826a7 7 0 0 0-.537-.674q-.323-.342-.508-.342-.127 0-.42.146a.6.6 0 0 1-.264.078q-.215 0-.674-.43a9 9 0 0 1-.84-.937q-.35-.45-.478-.742a1.9 1.9 0 0 1-.127-.723q0-.605.078-.947.118-.517.4-.517.4 0 1.163.761.673.684 1.504 1.797.732.986 1.445 2.13l.996 1.6q.44.724.898 1.641a10 10 0 0 0 .899-2.666q.215-1.172.215-2.988l-.557-.322q0-.645.108-1.162.117-.528.322-.957l.224.058q.04.42.47.674.233.136.595.313.37.175.566.253m-2.539 9.502a1.2 1.2 0 0 0-.088-.44q-.078-.234-.361-.76-.292.38-.879.878a9 9 0 0 1-1.143.85q1.154 0 1.641-.069.83-.116.83-.459m6.856-12.314q0 .245-.303.44a3.4 3.4 0 0 1-.615.273l-1.817.625q0-.45.977-.791a2 2 0 0 1-.459-.303q-.205-.186-.205-.39 0-.303.517-.85.576-.606 1.016-.606.195 0 .332.137a.43.43 0 0 1 .146.342.8.8 0 0 1-.058.283 3 3 0 0 1-.166.313q-.303-.274-.654-.274-.216 0-.43.088-.205.088-.205.205 0 .147.449.4.459.255.781.254.215 0 .303-.01.097-.019.391-.136m-.274 10.644q0 .782-.283 1.514-.146.39-.635 1.24l-.176-.097q.03-.284.049-.655.03-.37.03-.498 0-1.015-.166-2.832a146 146 0 0 0-.381-3.808q-.136-1.201-.303-2.452.195-.429.439-.927l.479-.938q.156 1.113.391 3.047.243 1.934.38 3.486.177 1.935.176 2.92m9.483 1.905q0 1.611-1.192 3.203-1.327 1.777-3.066 1.777a6.3 6.3 0 0 1-1.328-.146 13 13 0 0 1-1.299-.371q-.635-.225-1.27-.44l.166-.342 1.143.264q.606.147 1.084.146 1.191 0 2.256-.605.83-.478 1.66-1.387.42-.459 1.191-1.494-1.318 0-1.972-.42-.743-.479-.743-1.572 0-1.005.469-1.865.547-.996 1.387-.996.849 0 1.221.986.293.77.293 2.149zm-.616-1.065q-.214-.938-.517-1.298a.81.81 0 0 0-.645-.313.7.7 0 0 0-.478.185.58.58 0 0 0-.196.45q0 .479.43.732.43.244 1.406.244m10.401 1.651q0 1.074-.918 2.226a7.5 7.5 0 0 1-1.992 1.748q-1.133.703-1.866.703-.673 0-1.455-.195-.595-.146-1.426-.459l-1.396-.527.166-.39q.645.126 1.338.253a6.7 6.7 0 0 0 1.269.137q1.25 0 2.608-.801a7.5 7.5 0 0 0 2.099-1.846q.87-1.122.87-2.021 0-.772-.45-1.621-.36-.684-1.015-1.406l.556-1.534q.801.743 1.182 1.485.43.84.43 1.875zm8.652-.586q0 1.611-1.191 3.203-1.329 1.777-3.067 1.777-.644 0-1.328-.146a13 13 0 0 1-1.299-.371q-.635-.225-1.269-.44l.166-.342 1.142.264q.606.147 1.084.146a4.5 4.5 0 0 0 2.256-.605q.83-.478 1.66-1.387.42-.459 1.192-1.494-1.319 0-1.973-.42-.742-.479-.742-1.572 0-1.005.469-1.865.547-.996 1.386-.996.85 0 1.221.986.293.77.293 2.149zm-.615-1.065q-.215-.938-.518-1.298a.81.81 0 0 0-.644-.313.7.7 0 0 0-.479.185.58.58 0 0 0-.195.45q0 .479.43.732.43.244 1.406.244"></path><path fill="#fff" d="M136.473 64.139h-5.567v-1.7h4.854q0-1.152-.274-1.757-.185-.42-.918-1.211l.762-1.592q.703.889.879 1.387.264.75.264 2.49zm-.996 2.373-.762 1.416-1.582-.82.722-1.426z"></path><path fill="#fff" d="M141.355 64.139h-5.566v-1.7h4.854q0-1.152-.274-1.757-.186-.42-.918-1.211l.762-1.592q.703.889.879 1.387.263.75.263 2.49zm-.048 1.953-.762 1.406-1.582-.84.732-1.396zm-2.246.879-.743 1.416-1.582-.82.723-1.417zm6.865-11.953-.762 1.406-1.582-.84.732-1.397zm-2.246.879-.742 1.416-1.583-.82.723-1.417zm3.105 5.36q0 1.378-.449 2.071-.694 1.074-2.539 1.074-.713 0-1.182-.283-.537-.322-.537-.918 0-.684.342-1.582.312-.762.635-1.533l-.147-.04.596-1.65q1.767.929 2.109 1.172 1.173.82 1.172 1.69m-.849.763q0-.372-1.075-.987a15 15 0 0 0-.986-.517q-.44.478-.527.595-.274.381-.274.723 0 .498.274.781.282.273.752.274.546 0 1.191-.303.645-.312.645-.566"></path>', 33), QQ = [
  JQ
];
function e11(t, e) {
  return T(), N("svg", ZQ, [...QQ]);
}
const t11 = { render: e11 }, n11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, i11 = /* @__PURE__ */ U1('<path fill="#fff" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z"></path><path fill="#fff" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1"></path><path fill="#fff" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3"></path><path fill="#fff" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1"></path><path fill="#fff" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6"></path><path fill="#fff" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1"></path><path fill="#fff" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5"></path><path fill="#fff" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7"></path><path fill="#fff" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2m-.2 4.2c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13v-3.4z"></path><path fill="#fff" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z"></path><path fill="#fff" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z"></path><path fill="#fff" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z"></path><path fill="#fff" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z"></path><path fill="#fff" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8V48zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6"></path><path fill="#fff" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4"></path><path fill="#fff" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3"></path><path fill="#004494" stroke="#fff" stroke-width="2" d="M85.4 27.6H27.5v38.7h57.9z"></path><path fill="#FFEC00" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.7c0-.3.1-.4.4-.4h7.1c.2 0 .4.1.4.4v1.2c0 .2-.1.3-.4.3h-5.2v3.3h4.6c.3 0 .4.1.4.3V40c0 .2-.1.3-.4.3h-4.6v3.8h5.4c.2 0 .3.1.3.4v1.2c0 .2-.1.3-.4.3h-7.2c-.3 0-.4-.1-.4-.3z"></path><path fill="#fff" fill-rule="evenodd" d="M153.6 46.1c-.2 0-.3 0-.4-.1s-.1-.2-.1-.3V37c0-.1 0-.2.1-.3s.2-.1.3-.1h4.1c1.1 0 1.9.2 2.4.7s.8 1.1.8 1.9c0 .3-.1.6-.2.9q-.15.6-.9.9c.3.1.5.3.7.5s.3.4.4.6.2.4.2.6c0 .1.025.2.05.3s.05.2.05.3q0 .6-.3 1.2c-.2.4-.4.6-.7.9-.3.2-.6.4-1 .6-.4.1-.8.2-1.2.2h-4.3zm5.1-6.7c0-.1 0-.2-.1-.4a1.3 1.3 0 0 0-.117-.21 1 1 0 0 0-.083-.09c-.1-.1-.2-.2-.4-.2-.2-.1-.4-.1-.6-.1h-2.2v2.1h2.3q.6 0 .9-.3c.2-.2.3-.6.3-.8m0 2.9c.2.2.3.5.3.8 0 .2 0 .3-.1.4 0 .2-.1.3-.2.4s-.3.2-.5.3-.5.1-.8.1h-2.2v-2.4h2.5c.5 0 .8.2 1 .4m12.3 1.1c.1-.6.2-1.3.2-2.1 0-.7 0-1.5-.1-2.1s-.3-1.1-.5-1.5c-.3-.4-.6-.8-1-1-.5-.2-1-.3-1.6-.3-.2 0-.5 0-.8.1-.15.05-.275.1-.4.15s-.25.1-.4.15c-.3.1-.6.2-.8.4s-.4.3-.6.4h-.1V37c0-.1 0-.2-.1-.3s-.2-.1-.3-.1h-1.4c-.3 0-.4.1-.4.4v12.3c0 .05.025.1.05.15s.05.1.05.15c0 .1.1.1.3.1h1.4c.2 0 .3 0 .3-.1.1-.1.1-.2.1-.3v-3.4c.5.1.9.2 1.3.3s.8.1 1.1.1c.8 0 1.4-.1 1.9-.3.5-.3.9-.6 1.2-1 .3-.5.5-1 .6-1.6m-2.1-3.6c.1.4.1.9.1 1.5s0 1.1-.2 1.6c0 .4-.2.8-.3 1-.2.2-.4.4-.6.5-.3.1-.6.1-.9.1-.139 0-.278-.022-.427-.045-.173-.026-.358-.055-.573-.055l-1.2-.3v-4.8c.1-.1.3-.2.5-.3.1-.05.225-.1.35-.15s.25-.1.35-.15.225-.075.35-.1.25-.05.35-.1c.3-.1.5-.1.7-.1.3 0 .5 0 .7.1s.4.2.5.4q.15.3.3.9m12.1 3.1c.1-.6.1-1.2.1-1.7 0-.524-.076-.971-.162-1.476l-.038-.224q-.15-.75-.6-1.5c-.3-.5-.8-.8-1.3-1.1s-1.3-.4-2.2-.4-1.7.2-2.2.5q-.75.45-1.2 1.2c-.2.4-.4 1-.5 1.5-.1.6-.1 1.1-.1 1.5 0 .5 0 1.1.1 1.7s.3 1.1.5 1.6q.3.75 1.2 1.2c.6.3 1.3.5 2.3.5s1.7-.2 2.3-.5 1-.7 1.3-1.2.4-1 .5-1.6m-2.2-2.9c.1.3.1.8.1 1.3s0 1-.1 1.3c0 .4-.1.8-.3 1q-.15.45-.6.6c-.3.1-.7.2-1.1.2s-.7 0-1-.2q-.45-.3-.6-.6a4 4 0 0 1-.2-.578c-.034-.11-.067-.222-.1-.322-.1-.3-.1-.8-.1-1.3s0-.9.1-1.3.2-.7.3-1q.15-.45.6-.6c.3-.1.6-.2 1-.2.5 0 .8.1 1.1.2l.6.6c.066.133.133.356.2.578.033.11.066.222.1.322" clip-rule="evenodd"></path><path fill="#fff" d="M191.2 45.7c0 .2-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-7.3h-4v7.3c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.2 0-.4-.1-.4-.4V37c0-.2.1-.4.4-.4h7.5c.1 0 .2 0 .3.1s.1.1.1.3v8.7z"></path><path fill="#fff" fill-rule="evenodd" d="M195.4 43.1c-.1-.3-.2-.7-.2-1.2v-.3h4.9c.4 0 .7-.1.8-.3.2-.2.2-.5.2-.8 0-.5-.1-1-.2-1.5s-.3-1-.6-1.4-.7-.7-1.2-1-1.2-.4-2.1-.4-1.7.2-2.2.5c-.5.4-.9.8-1.2 1.3-.2.5-.4 1-.5 1.6s-.1 1.1-.1 1.6c0 .6 0 1.2.1 1.8.1.5.3 1.1.6 1.5.3.5.7.8 1.3 1.1.5.3 1.3.4 2.2.4h.8c.09 0 .2-.02.321-.042.149-.028.314-.058.479-.058.3 0 .5 0 .8-.1.132-.044.244-.069.345-.09.13-.03.243-.054.355-.11.2 0 .3-.1.3-.2v-.3l-.1-.6c0-.2 0-.3-.1-.3h-.4c-.4 0-.8 0-1.3.1-.4.1-.9.1-1.2.1-.4 0-.7 0-1-.1s-.5-.2-.7-.4-.3-.5-.4-.8m.8-4.7c.2-.1.5-.2.9-.2q.6 0 .9.3c.3.1.5.3.6.5.146.146.186.293.235.478q.026.102.065.222c.1.2.1.5.1.8h-3.8c0-.4 0-.7.1-1 0-.218.105-.383.201-.533.036-.057.072-.112.099-.167.2-.2.4-.3.6-.4m9.1-3.1c.6.3 1.2.5 1.8.5.7 0 1.3-.2 1.9-.5.5-.3 1-.8 1.3-1.5 0-.2 0-.3.1-.4s0-.2-.1-.3l-.5-.3c-.2-.1-.3-.1-.5.1l-.6.6c-.1.05-.175.125-.25.2s-.15.15-.25.2-.175.075-.25.1-.15.05-.25.1c-.2.1-.4.1-.6.1q-.75 0-1.2-.3c-.3-.2-.6-.5-1-1-.038-.038-.061-.076-.082-.109-.032-.053-.056-.091-.118-.091-.1 0-.2 0-.3.1l-.5.4c-.1.1-.1.2-.1.3s0 .2.1.3c.4.7.8 1.2 1.4 1.5m-2.3 1.5c-.1.1-.1.2-.1.3v8.4c0 .1 0 .2.1.3 0 .1.1.1.3.1h.8c.2 0 .3 0 .4-.1.1 0 .2-.1.3-.2.3-.3.6-.7.9-1.1.2-.3.5-.7.8-1.1.2-.3.425-.6.65-.9s.45-.6.65-.9.425-.6.65-.9.45-.6.65-.9v5.9c0 .3.1.4.4.4h1.2c.3 0 .4-.1.4-.4v-8.6c0-.1 0-.2-.1-.3 0-.1-.1-.1-.3-.1h-1c-.2 0-.3 0-.4.1l-.2.2-1.7 2.3-2.5 3.4v-5.6c0-.05-.025-.1-.05-.15a.4.4 0 0 1-.05-.15c0-.1-.1-.1-.3-.1h-1.2c-.1 0-.2 0-.3.1" clip-rule="evenodd"></path><path fill="#fff" d="M220.5 45.2v.3c0 .1-.1.2-.3.2-.4.2-.8.3-1.4.3-.6.1-1.1.1-1.5.1-.9 0-1.6-.1-2.2-.4-.5-.3-1-.6-1.2-1.1-.3-.4-.5-1-.6-1.6s-.1-1.2-.1-1.9c0-.6 0-1.2.1-1.8s.3-1.1.6-1.6.7-.8 1.2-1.1 1.3-.4 2.1-.4h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.2.1.5.1.7.2s.3.3.3.5l-.1.8c0 .1-.1.2-.2.2h-.4c-.4 0-.8-.1-1.2-.1s-.8-.1-1.1-.1c-.8 0-1.3.2-1.6.7-.3.4-.5 1.2-.5 2.3 0 .6 0 1.1.1 1.5s.2.7.4 1c.2.2.4.4.6.5.3.1.6.1 1 .1h1.2c.5 0 .9-.1 1.3-.1h.3c.1 0 .1.1.2.3zm3.5.5c0 .1 0 .2-.1.2 0 .1-.1.1-.3.1h-1.4q-.3 0-.3-.3V37q0-.3.3-.3h1.4c.1 0 .2 0 .3.1 0 .1.1.1.1.3v3.4h1.5c.2 0 .3-.1.4-.2s.3-.2.4-.4.2-.4.4-.7l.8-2.1c.1-.1.1-.2.2-.2s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1v.3l-.7 2c-.2.6-.4 1.1-.7 1.4s-.5.6-.9.7c.4.2.8.4 1 .7q.3.45.6 1.2l.8 2.6v.3c0 .1-.1.1-.3.1H228c-.1 0-.3 0-.3-.1s-.1-.1-.2-.2l-.7-2.2c-.2-.6-.5-1-.8-1.2s-.7-.3-1-.3h-1z"></path><path fill="#fff" fill-rule="evenodd" d="M235.6 45.9c.6-.2 1.1-.5 1.6-.9.1.4.4.8.7.9s.7.2 1.1.2h.4c.2-.1.3-.1.5-.1.3 0 .5-.2.5-.4v-.8c0-.1 0-.2-.1-.2-.1-.1-.2-.1-.3-.1-.2-.1-.3-.1-.4-.1s-.2 0-.2-.1c0 0-.1-.1-.1-.2v-4.2c0-.6 0-1.1-.1-1.5s-.2-.8-.5-1.1c-.2-.3-.6-.5-1.1-.7-.5-.1-1.2-.2-2-.2h-.8c-.15 0-.3.025-.45.05s-.3.05-.45.05c-.3 0-.6 0-.9.1a3 3 0 0 1-.346.09 1.5 1.5 0 0 0-.354.11c-.2.1-.3.2-.4.3v.3l.2.7c0 .1 0 .2.1.2h.4c.1-.1.4-.1.6-.1.2-.1.5-.1.7-.1h1.3c.4 0 .7 0 1 .1.066.033.144.067.222.1.155.067.311.133.378.2.1.1.2.3.3.5s.1.4.1.7v.5h-2.5c-1.2 0-2.1.3-2.7.8q-.9.75-.9 2.4c0 .4 0 .8.1 1.1.1.4.2.7.4.9.2.3.5.5.8.6.4.1.8.2 1.3.2.7 0 1.3-.1 1.9-.3m-.8-4.1h2.3v1.8l-.6.3c-.1.05-.225.1-.35.15s-.25.1-.35.15c-.113.056-.225.08-.355.11a3 3 0 0 0-.345.09c-.3.1-.5.1-.7.1-.4 0-.7 0-.9-.2q-.3-.3-.3-.9c0-.7.1-1.1.4-1.3q.45-.3 1.2-.3" clip-rule="evenodd"></path><path fill="#fff" d="M145.1 66c0 .1 0 .2-.1.2 0 .1-.1.1-.3.1h-1.4q-.3 0-.3-.3v-8.7q0-.3.3-.3h1.4c.1 0 .2 0 .3.1 0 .1.1.1.1.3v3.4h1.5c.2 0 .3-.1.4-.2s.3-.2.4-.4.2-.4.4-.7l.8-2.1c.1-.1.1-.2.2-.2s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1v.3l-.7 2c-.2.6-.4 1.1-.7 1.4s-.5.6-.9.7c.4.2.8.4 1 .7q.3.45.6 1.2l.8 2.6v.3c0 .1-.1.1-.3.1h-1.3c-.1 0-.3 0-.3-.1s-.1-.1-.2-.2l-.7-2.2c-.2-.6-.5-1-.8-1.2s-.7-.3-1-.3h-1z"></path><path fill="#fff" fill-rule="evenodd" d="M160.4 63.2c.1-.6.1-1.2.1-1.7 0-.6 0-1.1-.2-1.7q-.15-.75-.6-1.5c-.3-.5-.8-.8-1.3-1.1s-1.3-.4-2.2-.4-1.7.2-2.2.5q-.75.45-1.2 1.2c-.2.4-.4 1-.5 1.5-.1.6-.1 1.1-.1 1.5 0 .5 0 1.1.1 1.7s.3 1.1.5 1.6q.3.75 1.2 1.2c.6.3 1.3.5 2.3.5s1.7-.2 2.3-.5 1-.7 1.3-1.2.4-1 .5-1.6m-2.1-2.9c.1.3.1.8.1 1.3s0 1-.1 1.3c0 .4-.1.8-.3 1q-.15.45-.6.6c-.3.1-.7.2-1.1.2s-.7 0-1-.2q-.45-.3-.6-.6c-.066-.133-.133-.356-.2-.578a9 9 0 0 0-.1-.322c-.1-.3-.1-.8-.1-1.3s0-.9.1-1.3.2-.7.3-1q.15-.45.6-.6c.3-.1.6-.2 1-.2.5 0 .8.1 1.1.2l.6.6c.067.133.134.355.2.578.034.11.067.222.1.322" clip-rule="evenodd"></path><path fill="#fff" d="m170.2 60.9-.8 1.6c-.2.3-.4.7-.5 1-.2.3-.4.7-.6 1.1q-.15.3-.6.3h-.7c-.2 0-.3 0-.4-.1l-.2-.2c-.2-.3-.4-.6-.5-.9-.2-.3-.3-.6-.5-.9s-.3-.6-.5-1c-.2-.3-.3-.7-.5-1v5c0 .3-.1.4-.4.4h-1.2c-.3 0-.4-.1-.4-.4v-8.6c0-.3.1-.4.4-.4h1.1c.2 0 .3 0 .4.1s.2.1.2.2c.2.4.4.7.6 1.1s.4.7.6 1.1c.3.5.6 1.1.8 1.6.3.5.5 1 .8 1.6l1.5-2.8 1.4-2.5c.1-.1.1-.2.2-.3s.2-.1.4-.1h1c.3 0 .4.1.4.4V66c0 .3-.1.4-.4.4h-1.2c-.3 0-.4-.1-.4-.4zm4.1-3.5c0-.1 0-.2.1-.3s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1s.1.2.1.3V63l2.5-3.4 1.7-2.3.2-.2c.1-.1.2-.1.4-.1h1c.2 0 .3 0 .3.1.1.1.1.2.1.3V66c0 .3-.1.4-.4.4H181c-.3 0-.4-.1-.4-.4v-5.9c-.4.6-.9 1.2-1.3 1.8s-.9 1.2-1.3 1.8c-.3.4-.6.8-.8 1.1-.3.4-.6.8-.9 1.1-.1.1-.2.2-.3.2-.1.1-.2.1-.4.1h-.8c-.2 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.3v-8.4zm17.6 8.1v.3c0 .1-.1.2-.3.2-.4.2-.8.3-1.4.3-.6.1-1.1.1-1.5.1-.9 0-1.6-.1-2.2-.4-.5-.3-1-.6-1.2-1.1-.3-.4-.5-1-.6-1.6s-.1-1.2-.1-1.9c0-.6 0-1.2.1-1.8s.3-1.1.6-1.6.7-.8 1.2-1.1 1.3-.4 2.1-.4h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.2.1.5.1.7.2s.3.3.3.5l-.1.8c0 .1-.1.2-.2.2h-.4c-.4 0-.8-.1-1.2-.1s-.8-.1-1.1-.1c-.8 0-1.3.2-1.6.7-.3.4-.5 1.2-.5 2.3 0 .6 0 1.1.1 1.5s.2.7.4 1c.2.2.4.4.6.5.3.1.6.1 1 .1h1.2c.5 0 .9-.1 1.3-.1h.3c.1 0 .1.1.2.3zm1.4-8.1c0-.1 0-.2.1-.3s.2-.1.3-.1h1.2c.2 0 .3 0 .3.1s.1.2.1.3V63l2.5-3.4 1.7-2.3.2-.2c.1-.1.2-.1.4-.1h1c.2 0 .3 0 .3.1.1.1.1.2.1.3V66c0 .3-.1.4-.4.4H200c-.3 0-.4-.1-.4-.4v-5.9c-.4.6-.9 1.2-1.3 1.8s-.9 1.2-1.3 1.8c-.3.4-.6.8-.8 1.1-.3.4-.6.8-.9 1.1-.1.1-.2.2-.3.2-.1.1-.2.1-.4.1h-.8c-.2 0-.3 0-.3-.1-.1-.1-.1-.2-.1-.3v-8.4z"></path><path fill="#fff" fill-rule="evenodd" d="M211.5 57c-.1-.1-.2-.1-.4-.1v-.2h-3.9c-.4 0-.9 0-1.3.2s-.8.4-1.1.6-.5.5-.7.9-.3.8-.3 1.3c0 .1.025.225.05.35s.05.25.05.35c0 .3.1.5.2.7s.2.4.4.6.4.3.7.4c-.3.2-.5.4-.7.7-.04.122-.097.243-.157.371a3.4 3.4 0 0 0-.243.629l-.7 2.1v.3c0 .1.1.1.3.1h1.3c.118 0 .2-.034.269-.063.049-.02.09-.037.131-.037.071 0 .092-.05.133-.15q.024-.061.067-.15l.6-1.9c.2-.6.4-.9.6-1.1s.5-.3.8-.3h1.9v3.3c0 .1 0 .2.1.3 0 .1.1.1.3.1h1.2c.3 0 .5-.1.5-.4v-8.6c0-.1 0-.2-.1-.3m-5.4 3.8q-.3-.3-.3-.9c0-.4.1-.7.4-.9s.6-.3 1.1-.3h2.1v2.4h-2.2c-.5 0-.9-.1-1.1-.3" clip-rule="evenodd"></path><path fill="#fff" d="M249.2 28h3.3v38.7h-3.3z"></path>', 29), s11 = [
  i11
];
function l11(t, e) {
  return T(), N("svg", n11, [...s11]);
}
const r11 = { render: l11 }, a11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, o11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6M94.201 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 26.799s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.701 39.2c-8.3-1.601-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.399 8.6 4.7 13.5 5.6s12.7 2.299 12.7 2.299v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#fff" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L54.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#fff" fill-rule="evenodd" d="M226.4 66.7h3.3V28h-3.3z" clip-rule="evenodd"></path><path fill="#fff" d="M143.24 39.48q0-1.28.2-2.52.201-1.24.78-2.2.6-.98 1.64-1.58 1.06-.6 2.78-.6.36 0 .82.04.48.02.98.1.5.06.98.18.48.1.88.26.24.1.32.24.1.14.06.38l-.18.82a.44.44 0 0 1-.14.26q-.1.08-.38.04a39 39 0 0 0-1.6-.18q-.84-.08-1.62-.08-1.02 0-1.64.38t-.96 1.04q-.32.66-.42 1.54-.1.86-.1 1.84t.12 1.84a4.5 4.5 0 0 0 .46 1.5q.34.62.94.98.62.36 1.6.36.88 0 1.64-.08a95 95 0 0 0 1.58-.18q.28-.04.38.04t.16.28l.16.76q.12.44-.34.64-.36.16-.86.28-.48.1-1 .18a9 9 0 0 1-1 .1q-.48.04-.84.04-1.68 0-2.74-.56a4.5 4.5 0 0 1-1.64-1.52 6.2 6.2 0 0 1-.8-2.14q-.22-1.2-.22-2.48m19.571 1.46q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m18.528 4.54q0 .18-.08.28-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24a6 6 0 0 0-.66.28l-.56.28v.42q.02.26.02.6v5.66q0 .18-.08.28t-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.26 0-.6.08a6 6 0 0 0-.68.22q-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V36.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4.34-.22.72-.38.4-.16.8-.26.4-.12.82-.14.861 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.981 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.745-12.02q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.85.85 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm9.801-2.56q0 .88-.34 1.48a2.7 2.7 0 0 1-.92.94q-.56.36-1.28.52t-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.3 1.3 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.5 4.5 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.501.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.759-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m9.18 0q0 .88-.34 1.48-.34.58-.92.94-.56.36-1.28.52t-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88a1.7 1.7 0 0 0-.08-.56.67.67 0 0 0-.24-.36 1.35 1.35 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.5 4.5 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.5.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.76-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m4.44-9.46q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.85.85 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm10.981-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m.42-9.26q.3.16.08.44l-2.04 2.8q-.16.22-.38.12l-.78-.36q-.22-.12-.1-.38l1.6-3.1q.12-.26.44-.12zm-72.766 21.3q0-.4.4-.4h7.36q.38 0 .38.38v1.24q0 .36-.4.36h-5.46v3.44h4.84q.4 0 .4.36v1.24q0 .36-.4.36h-4.84v3.94h5.6q.36 0 .36.38v1.22q0 .36-.38.36h-7.46q-.4 0-.4-.36zm18.706 12.5q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V65l-.04-.02q-.3.2-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V56.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1.4-.1.78-.24.38-.16.7-.3l.52-.26V56.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4zm4.705 0q0 .38-.38.38h-1.44q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.4 0 .4.4v.88l.04.04a4 4 0 0 1 .58-.42q.36-.24.76-.42.42-.201.84-.36.42-.16.78-.22a.5.5 0 0 1 .32.02q.12.06.16.32l.14 1.34a.7.7 0 0 1-.02.32q-.039.1-.36.16-.42.08-.88.2a10 10 0 0 0-.9.24q-.44.12-.82.24t-.64.24zm13.225-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.759-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.501-1.3-1.26a4.6 4.6 0 0 1-.52-1.7 17 17 0 0 1-.1-1.78q0-.7.12-1.56a4.6 4.6 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.801-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.849-.04q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V56.6q0-.4.38-.4h1.42q.22 0 .28.12.08.1.08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.981 0 1.62.36t1 1.02q.38.639.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a9 9 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.561.06 1.08.06.54 0 .9-.14.381-.16.6-.54.24-.38.34-1 .1-.64.1-1.58m6.11.68q.02.759.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16-.36.159-.6.48-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m12.156 3.74h-2.44q-.759 0-1.2.36-.44.339-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32a6.7 6.7 0 0 1-1.72.94q-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02l-.72.04q-.36.02-.74.06-.36.039-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.081-.14.42-.28a4.5 4.5 0 0 1 .76-.2q.441-.081.9-.12.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.459.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.039.38.06.22.02.3.08t.08.22v.84q0 .339-.48.42-.24.039-.48.06-.24.04-.46.04-.699 0-1.14-.26-.42-.261-.58-.96z"></path>', 26), c11 = [
  o11
];
function h11(t, e) {
  return T(), N("svg", a11, [...c11]);
}
const u11 = { render: h11 }, d11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, f11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="230" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h229.5V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.7c0-.3.1-.4.4-.4h7.1c.2 0 .4.1.4.4v1.2c0 .2-.1.3-.4.3h-5.2v3.3h4.6c.3 0 .4.1.4.3V40c0 .2-.1.3-.4.3h-4.6v3.8h5.4c.2 0 .3.1.3.4v1.2c0 .2-.1.3-.4.3h-7.2c-.3 0-.4-.1-.4-.3zm13.6 10s0-.2.1-.4.2-.5.2-.8c.1-.3.2-.7.4-1.1l1.5-4.5c0-.1.1-.2.1-.2s.2-.1.3-.1h1.5c.3 0 .3.1.2.4l-3.3 8.6c-.1.1-.1.2-.2.3s-.2.1-.3.1h-1.3c-.2 0-.3 0-.4-.1s-.1-.2-.2-.3l-3.3-8.6v-.3c0-.1.1-.1.2-.1h1.5c.1 0 .2 0 .3.1s.1.1.2.3l1.5 4.5c.1.4.2.7.3 1s.2.5.2.8c.4.2.4.4.5.4m8.2 2c0 .2-.101.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4V37c0-.3.099-.4.4-.4h1.4c.299 0 .4.1.4.4v.8c.1-.1.3-.3.6-.4.2-.1.5-.3.7-.4.3-.1.5-.2.8-.3.299-.1.5-.2.7-.2h.3c.1 0 .1.1.2.3l.099 1.3v.3c0 .1-.099.1-.299.2-.3.1-.5.1-.8.2s-.6.1-.901.2c-.299.1-.5.2-.799.2-.201.1-.4.2-.6.2zm10.501-4.4c0-.5 0-1-.101-1.3q-.149-.6-.299-.9l-.6-.6c-.3-.1-.601-.2-1.101-.2-.399 0-.699.1-1 .2a.9.9 0 0 0-.599.6c-.1.3-.2.6-.3 1-.101.4-.101.8-.101 1.3s0 1 .101 1.3q.15.6.3.9t.599.6c.301.1.601.2 1 .2.401 0 .801-.1 1.101-.2a.9.9 0 0 0 .6-.6c.2-.2.299-.6.299-.9.101-.4.101-.9.101-1.4m2.2-.1c0 .5 0 1.1-.1 1.7s-.201 1.1-.5 1.6c-.3.5-.701.9-1.3 1.2s-1.3.5-2.3.5-1.7-.2-2.3-.5q-.9-.45-1.2-1.2c-.2-.5-.4-1-.5-1.6-.101-.6-.101-1.2-.101-1.7 0-.4 0-.9.101-1.5.1-.5.3-1.1.5-1.5q.45-.75 1.2-1.2c.5-.3 1.3-.5 2.199-.5.901 0 1.701.1 2.201.4.6.3 1 .6 1.299 1.1q.45.75.601 1.5c.1.5.2 1.1.2 1.7m8 .1c0-.6 0-1.1-.101-1.5q-.15-.6-.299-.9c-.1-.2-.3-.3-.5-.4-.201-.1-.401-.1-.701-.1-.2 0-.399 0-.7.1-.199.1-.5.1-.699.2-.2.1-.5.2-.7.3s-.401.2-.5.3v4.8l1.2.3c.399 0 .699.1 1 .1.3 0 .6 0 .899-.1.201-.1.401-.3.601-.5.1-.2.3-.6.3-1 .2-.5.2-1 .2-1.6m2.199 0c0 .8-.099 1.5-.199 2.1a4.4 4.4 0 0 1-.601 1.6c-.299.4-.7.7-1.2 1-.5.2-1.099.3-1.899.3-.3 0-.7 0-1.101-.1-.399-.1-.8-.2-1.3-.3v3.4c0 .1 0 .2-.099.3 0 .1-.101.1-.3.1h-1.4c-.201 0-.3 0-.3-.1s-.101-.2-.101-.3V37c0-.3.101-.4.401-.4h1.4c.1 0 .199 0 .3.1.099.1.099.2.099.3v.6h.101c.199-.1.399-.2.6-.4.2-.1.5-.3.799-.4s.5-.2.8-.3.601-.1.801-.1c.6 0 1.1.1 1.6.3.4.2.7.6 1 1 .299.4.4.9.5 1.5 0 .7.099 1.4.099 2.1m8.7 1.9c0 .6-.1 1-.3 1.4q-.3.6-.9.9c-.4.2-.8.4-1.199.5-.5.1-.901.2-1.401.2s-1 0-1.599-.1c-.601-.1-1-.2-1.401-.3-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.6c0-.2.1-.2.201-.3h.299c.201 0 .4.1.701.1.199 0 .5 0 .699.1h1.301c.599 0 1.099-.1 1.299-.3.201-.2.4-.5.4-.8 0-.2 0-.4-.1-.5 0-.1-.099-.3-.2-.3-.1-.1-.3-.2-.5-.2-.2-.1-.5-.1-.8-.1-.5-.1-.9-.1-1.3-.2s-.799-.3-1.1-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-.9.3-1.7 1-2.2s1.5-.7 2.6-.7h.7c.3 0 .5 0 .8.1.301 0 .5.1.801.1.299.1.5.1.699.2.301.1.5.3.4.6l-.2.7c0 .1-.1.2-.1.3s-.2 0-.4 0c-.399-.1-.899-.1-1.3-.1-.5 0-.9-.1-1.3-.1q-.9 0-1.2.3c-.2.2-.3.4-.3.8s.1.6.4.7c.2.1.7.2 1.301.3.5.1.899.1 1.299.2s.8.3 1.1.5.601.5.8.8c.1.3.2.8.2 1.3m4-3.1 1.5-1.6 1.601-1.6c.099-.1.199-.2.299-.2s.201-.1.4-.1h1.5c.2 0 .301 0 .301.1s0 .2-.101.3l-3.1 3.1 3.5 5.4q.15.15 0 .3c0 .1-.1.1-.299.1h-1.5c-.201 0-.401 0-.401-.1-.099-.1-.2-.2-.2-.3l-2.5-3.9-1.1 1.1v2.8c0 .1 0 .2-.1.3s-.1.1-.3.1H199c-.2 0-.4-.1-.4-.4V32.9c0-.3.1-.4.4-.4h1.401c.099 0 .199 0 .299.1s.1.2.1.3zm13.7-7.7c.2.1.2.2.1.4l-2 2.7c-.1.1-.2.2-.4.1l-.7-.3c-.1-.1-.2-.2-.1-.4l1.5-3c.1-.2.2-.2.4-.1zm-.8 9.4h-2.3q-.75 0-1.2.3c-.3.2-.4.6-.4 1.3q0 .6.3.9c.2.2.5.2.9.2.2 0 .4 0 .7-.1s.5-.1.7-.2.5-.2.7-.3l.6-.3zm.1 3.2c-.5.4-1 .7-1.6.9s-1.2.3-1.9.3c-.5 0-.9-.1-1.3-.2-.3-.1-.6-.3-.8-.6-.2-.2-.3-.5-.4-.9-.1-.3-.1-.7-.1-1.1q0-1.65.9-2.4c.6-.5 1.5-.8 2.7-.8h2.5v-.5c0-.3 0-.5-.1-.7s-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.6.1h-.4c-.1 0-.1-.1-.1-.2l-.2-.7v-.3c.1-.1.2-.2.4-.3s.4-.1.7-.2.6-.1.9-.1.6-.1.9-.1h.8c.8 0 1.5.1 2 .2.5.2.9.4 1.1.7.3.3.4.7.5 1.1s.1.9.1 1.5v4.2c0 .1.1.2.1.2s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.4c-.4 0-.8-.1-1.1-.2s-.6-.5-.7-.9m-68.6 15.4 1.5-1.6 1.6-1.6c.1-.1.2-.2.299-.2.101-.1.201-.1.401-.1h1.5c.2 0 .3 0 .3.1s0 .2-.1.3l-3.101 3.1 3.5 5.4q.151.15 0 .3c0 .1-.099.1-.299.1h-1.5c-.201 0-.4 0-.4-.1-.1-.1-.2-.2-.2-.3l-2.5-3.9-1.1 1.1v3c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.2 0-.4-.1-.4-.4V53.2c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm12.9 1.2c0-.5 0-1-.1-1.3-.099-.3-.2-.7-.299-.9l-.601-.6c-.3-.1-.6-.2-1.1-.2-.4 0-.7.1-1 .2q-.45.15-.599.6c-.101.3-.2.6-.301 1s-.1.8-.1 1.3 0 1 .1 1.3q.15.6.301.9.15.3.599.6c.3.1.6.2 1 .2.401 0 .8-.1 1.1-.2a.9.9 0 0 0 .601-.6c.2-.2.299-.6.299-.9s.1-.9.1-1.4m2.2-.1c0 .5 0 1.1-.099 1.7-.101.6-.201 1.1-.5 1.6-.3.5-.701.9-1.3 1.2-.601.3-1.301.5-2.301.5s-1.699-.2-2.3-.5q-.9-.45-1.2-1.2c-.199-.5-.399-1-.5-1.6s-.1-1.2-.1-1.7c0-.4 0-.9.1-1.5.101-.5.301-1.1.5-1.5q.45-.75 1.2-1.2c.5-.3 1.3-.5 2.2-.5s1.701.1 2.201.4c.599.3 1 .6 1.299 1.1q.45.75.6 1.5c.101.6.2 1.1.2 1.7m15.499 4.8c0 .1-.1.1-.3.1h-1.4c-.199 0-.4-.1-.4-.4v-5.5c0-.7-.1-1.2-.299-1.4-.201-.2-.5-.4-1-.4-.201 0-.401 0-.601.1s-.399.1-.7.2l-.6.3c-.2.1-.4.2-.5.3V66c0 .1 0 .2-.099.3-.101.1-.101.1-.301.1h-1.4c-.2 0-.299-.1-.299-.4v-5.5c0-.6-.101-1-.301-1.3s-.5-.4-1-.4c-.199 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.399.2-.7.3l-.6.3V66c0 .2-.099.4-.4.4h-1.4c-.2 0-.299-.1-.299-.4v-8.7c0-.3.099-.4.299-.4h1.4c.301 0 .4.1.4.4v.6c.2-.1.401-.3.6-.4.2-.1.5-.3.7-.4s.5-.2.8-.3.5-.1.801-.1c.5 0 1.099.1 1.5.3.5.2.799.5 1.099 1.1.5-.4 1-.7 1.6-.9.6-.3 1.2-.4 1.801-.4q.898 0 1.5.3c.399.2.699.5.799.8.201.3.3.7.4 1.1s.1.9.1 1.4V66c.201.1.201.2.1.3m4.501-.3c0 .1 0 .2-.1.3s-.1.1-.299.1H178.5c-.3 0-.4-.1-.4-.4v-8.7c0-.2.1-.4.4-.4h1.401c.099 0 .199 0 .299.1s.1.2.1.3zm.101-11.5v.4c0 .1-.101.3-.201.4s-.2.2-.299.2c-.101.1-.301.1-.601.1s-.5 0-.6-.1-.299-.1-.299-.2c-.101-.1-.101-.2-.201-.4v-.4c0-.3.1-.6.201-.8.099-.2.5-.3.899-.3q.75 0 .9.3c.201.2.201.4.201.8m9.299 9c0 .6-.101 1-.3 1.4q-.3.6-.9.9c-.401.2-.8.4-1.2.5-.5.1-.9.2-1.4.2s-1 0-1.6-.1-1-.2-1.4-.3c-.2-.1-.301-.2-.4-.3s-.1-.2 0-.4l.099-.6c0-.2.101-.2.201-.3h.299c.201 0 .401.1.701.1.2 0 .5 0 .7.1h1.3c.6 0 1.1-.1 1.299-.3.201-.2.401-.5.401-.8 0-.2 0-.4-.1-.5 0-.1-.1-.3-.2-.3-.101-.1-.3-.2-.5-.2-.2-.1-.5-.1-.8-.1-.5-.1-.9-.1-1.301-.2-.399-.1-.799-.3-1.099-.5s-.6-.5-.8-.8-.3-.8-.3-1.3c0-.9.3-1.7 1-2.2.699-.5 1.5-.7 2.6-.7h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.299.1.5.1.7.2.3.1.5.3.4.6l-.2.7c0 .1-.101.2-.101.3s-.199 0-.399 0c-.4-.1-.9-.1-1.3-.1-.5 0-.9-.1-1.301-.1q-.9 0-1.199.3c-.2.2-.301.4-.301.8s.101.6.401.7c.2.1.7.2 1.3.3.5.1.9.1 1.299.2.401.1.801.3 1.101.5s.6.5.8.8c.099.3.2.8.2 1.3m5.701-5c-.4 0-.7.1-.9.2s-.401.2-.6.4c-.101.2-.301.4-.301.7-.099.3-.099.6-.099 1h3.799c0-.3 0-.6-.099-.8-.101-.3-.101-.5-.3-.7a1.03 1.03 0 0 0-.601-.5q-.3-.3-.899-.3m-1.9 3.7c0 .5.099.9.2 1.2.099.3.2.6.399.8.2.2.401.3.7.4.3.1.601.1 1 .1.3 0 .8 0 1.201-.1.5-.1.9-.1 1.299-.1h.401c.099 0 .099.1.099.3l.101.6v.3c0 .1-.101.2-.301.2-.199.1-.399.1-.699.2-.301.1-.5.1-.801.1-.3 0-.599.1-.8.1h-.799c-.901 0-1.701-.1-2.201-.4s-1-.6-1.299-1.1c-.3-.4-.5-1-.6-1.5-.101-.5-.101-1.2-.101-1.8 0-.5 0-1 .101-1.6.1-.6.3-1.1.5-1.6.3-.5.699-.9 1.199-1.3.5-.3 1.301-.5 2.2-.5.901 0 1.601.1 2.101.4s.899.6 1.199 1 .5.9.601 1.4c.099.5.2 1 .2 1.5 0 .3 0 .6-.2.8-.101.2-.401.3-.8.3h-4.9zm32.699 4.5h3.3V28h-3.3z"></path></g>', 24), v11 = [
  f11
];
function p11(t, e) {
  return T(), N("svg", d11, [...v11]);
}
const m11 = { render: p11 }, g11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, y11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="279" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h278.5V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m7.9.5h-2.4c-.5 0-.9.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.4-.1-.6-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.101-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.399c-.101 0-.101-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.599-.1.9-.1c.3 0 .6-.1.9-.1h.799q1.351 0 2.101.3c.5.2.899.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.099.2.099.3s.101.1.201.1.2 0 .4.1c.1 0 .2 0 .3.1s.099.1.099.2v.8c0 .2-.199.4-.5.4-.199 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.401-.1-.6-.4-.7-.9m10.401-6.1q.3 0 .3.3v1q0 .3-.3.3h-5.8q-.3 0-.301-.3v-1q0-.3.301-.3zM145.6 59.4l1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V53.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm15.4 2c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m16.3 5c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1 0 .2-.1.3m16.599 0c0 .1-.1.1-.3.1H194.4c-.301 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.601-.4-1.101-.4-.199 0-.399 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.099.3-.101.1-.2.1-.301.1h-1.5c-.199 0-.3-.1-.3-.4v-5.8c0-.6-.099-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.599.1-.2.1-.401.1-.7.2-.201.1-.5.2-.701.3l-.599.3V66c0 .3-.101.4-.401.4h-1.4c-.199 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.4c.3 0 .401.1.401.4v.6c.199-.1.399-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3.5-.1.8-.1c.601 0 1.101.1 1.601.3s.899.6 1.199 1.1c.5-.4 1.101-.7 1.7-1 .601-.3 1.2-.4 1.901-.4.7 0 1.2.1 1.599.3.401.2.7.5.901.8.2.3.299.7.399 1.2s.101.9.101 1.4v6c-.101.1-.101.2-.101.3m4.701-.3c0 .1 0 .2-.1.3 0 .1-.1.1-.299.1H199c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.401c.099 0 .199 0 .299.1 0 .1.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4s-.2.2-.4.3-.399.1-.6.1c-.299 0-.5 0-.6-.1-.199-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.4.201.7m9.698 9.5q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1.201.1.401 0 .6 0 .601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.2-.4a.77.77 0 0 0-.5-.2c-.199-.1-.5-.1-.8-.2-.5-.1-1-.2-1.399-.3-.401-.1-.801-.3-1.2-.5-.3-.2-.601-.5-.8-.8s-.301-.8-.301-1.3c0-1 .301-1.7 1-2.3.7-.5 1.601-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3h-.399c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.601 0-1.101.1-1.3.3q-.3.3-.301.9c0 .4.101.6.4.8s.701.2 1.3.3c.5.1.901.2 1.401.3.399.1.799.3 1.2.5.399.2.599.5.8.9.299.4.399.9.399 1.5m9.201 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.199-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1.201.1.4 0 .6 0 .601 0 1.101-.1 1.4-.3.3-.2.4-.5.4-.9 0-.2 0-.4-.1-.6-.099-.2-.099-.3-.2-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.199-.5c-.301-.2-.601-.5-.801-.8-.199-.3-.3-.8-.3-1.3 0-1 .3-1.7 1-2.3.7-.5 1.601-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.401.6l-.201.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.299-.1-.601 0-1.101.1-1.301.3q-.3.3-.3.9c0 .4.101.6.4.8s.701.2 1.3.3c.5.1.901.2 1.401.3.399.1.799.3 1.199.5s.6.5.801.9c.299.4.399.9.399 1.5m4.299 2.6c0 .1 0 .2-.1.3-.099.1-.099.1-.299.1h-1.401c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1.1.1.1.2.1.3zm.2-12.1v.5c0 .2-.099.3-.2.4-.1.1-.199.2-.399.3-.201.1-.401.1-.601.1-.3 0-.5 0-.6-.1-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2-.199-.4V54c0-.3.099-.6.199-.8.2-.2.5-.3 1-.3s.801.1 1 .3c.101.1.2.4.2.7m8.601 7.5c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6.199.6.199 1.2.199 1.8m10.501 5c-.1.1-.199.1-.3.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.301-1.4-.199-.4-.6-.5-1.199-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.401.2-.5.3V66c0 .3-.101.4-.401.4h-1.399c-.301 0-.401-.1-.401-.4v-9.1c0-.3.1-.4.401-.4h1.399c.3 0 .401.1.401.4v.6c.2-.1.399-.3.7-.4s.5-.3.8-.4l.899-.3c.301-.1.601-.1.9-.1.701 0 1.201.1 1.6.3.4.2.7.5.9.8s.3.8.401 1.2c.099.5.099.9.099 1.5V66c.1.1.1.2.1.3m6.2-8.2c-.399 0-.7.1-.899.2-.201.1-.401.3-.601.5s-.3.5-.3.8c-.099.3-.099.6-.099 1h4c0-.3 0-.6-.101-.9-.1-.3-.2-.5-.3-.8-.099-.2-.3-.4-.599-.5-.301-.1-.701-.3-1.101-.3m-2 3.9c0 .5.101.9.2 1.3.1.3.3.6.5.8s.401.3.7.4c.3.1.6.1 1.1.1.4 0 .8 0 1.3-.1s.9-.1 1.301-.1h.399c.101 0 .101.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.399.2-.7.2s-.5.1-.8.2c-.3 0-.6.1-.899.1h-.801c-1 0-1.699-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.599-1.6-.101-.6-.201-1.2-.201-1.9 0-.5 0-1 .1-1.6.101-.6.3-1.2.601-1.7.299-.5.699-1 1.299-1.3s1.3-.5 2.3-.5c.901 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9-.199.2-.4.3-.8.3h-5.5zm16.5 4.3c-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.199 0-.4 0-.699.1-.301.1-.5.2-.801.3-.3.1-.5.2-.699.3-.201.1-.401.2-.5.3V66c0 .3-.101.4-.401.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .401.1.401.4v.6c.199-.1.399-.3.699-.4.301-.1.5-.3.801-.4l.899-.3c.3-.1.601-.1.9-.1.701 0 1.201.1 1.6.3.4.2.7.5.9.8s.3.8.4 1.2c.1.5.1.9.1 1.5V66c.201.1.201.2.1.3m8.9.4h3.3V28h-3.3z"></path></g>', 24), _11 = [
  y11
];
function q11(t, e) {
  return T(), N("svg", g11, [..._11]);
}
const w11 = { render: q11 }, z11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, M11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.503s39.817-5.169 40.966-5.36c1.723-.287 3.254-.574 4.69-1.053 3.254-.861 6.221-2.201 8.805-4.02 2.489-1.723 4.882-4.211 7.179-6.891 1.436-1.723 3.063-4.02 4.499-6.126V0c-1.723 2.584-3.446 4.786-5.169 6.7q-3.445 3.876-7.179 6.317c-2.584 1.627-5.36 2.872-8.518 3.637-1.436.383-2.872.67-4.594.862-1.149.191-2.202.287-3.35.383C36.946 17.994 0 21.919 0 21.919z" clip-rule="evenodd"></path><mask id="a" width="67" height="24" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.264h66.138v22.78H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.409 17.803c-2.489 1.436-5.36 2.488-8.519 3.159-1.34.287-2.871.478-4.499.67-.957.095-2.01.19-2.967.287-.574 0-1.053.095-1.627.191A2452 2452 0 0 0 0 25.46v2.584a2362 2362 0 0 1 35.893-4.211c.574-.096 1.053-.096 1.627-.191.957-.096 2.01-.192 2.967-.383a31.6 31.6 0 0 0 4.69-.862c3.35-.765 6.317-1.914 8.902-3.541 2.584-1.532 4.881-3.733 7.274-6.413 1.531-1.627 3.254-4.02 4.786-6.221v-.958c-1.819 2.585-3.638 4.69-5.36 6.509-2.393 2.584-4.882 4.594-7.37 6.03" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M60.396 17.133c-2.393 2.201-4.977 4.02-7.562 5.264q-3.732 1.867-8.614 2.584c-1.34.192-2.871.383-4.499.575L0 28.906v2.584l35.319-3.733 4.594-.479c1.723-.191 3.254-.382 4.594-.67 3.35-.67 6.317-1.627 8.902-2.967 2.68-1.34 5.264-3.637 7.752-6.03 1.628-1.627 3.255-3.637 4.978-5.838v-.862c-2.01 2.489-3.829 4.499-5.743 6.222" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M50.824 30.629c-2.297 1.34-4.02 2.01-7.37 2.392-2.01.192-4.02.288-6.03.383-.957.096-1.914.096-2.871.192-6.03.383-11.869.765-17.899 1.148L0 35.893v2.584l16.75-1.531c5.456-.479 11.677-1.053 17.899-1.532l4.498-.383c1.723-.095 3.159-.287 4.499-.478 3.445-.479 6.317-1.149 8.901-2.106 2.776-1.053 5.36-2.68 8.04-4.594 2.393-1.723 5.647-5.073 5.647-5.169v-.957c-2.105 2.106-3.35 3.254-5.743 4.786-2.871 2.01-7.657 2.967-9.667 4.116" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.686 35.606c-2.489.766-5.36 1.244-8.615 1.531-1.34.096-2.775.192-4.402.286l-4.403.193c-11.007.478-22.015 1.053-34.17 1.722v2.585c11.581-.861 22.875-1.819 34.265-2.585l4.403-.286c1.723-.096 3.159-.193 4.499-.383 3.35-.383 6.317-.957 8.806-1.819 2.871-.861 5.647-2.201 8.231-3.924 1.914-1.244 3.829-2.68 5.934-4.499-2.201 1.915-4.307 2.297-6.413 3.638-2.68 1.53-5.455 2.68-8.135 3.54" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.207 39.913c-2.488.574-5.264.957-8.614 1.244-1.34.095-2.68.192-4.403.192l-4.403.191c-11.007.383-22.301.862-33.787 1.34v2.584c11.39-.765 22.589-1.53 33.883-2.298l4.403-.286c1.723-.096 3.158-.192 4.403-.287 3.445-.287 6.221-.766 8.805-1.436 2.872-.765 5.743-1.82 8.327-3.255a42.4 42.4 0 0 0 6.222-4.019v-1.149c-2.297 1.628-4.499 3.063-6.7 4.116-2.489 1.436-5.264 2.393-8.136 3.063" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M50.824 44.124c-2.488.478-5.264.767-8.614.957-1.244.097-2.584.097-4.307.191L0 46.23v2.584l33.596-1.722 4.403-.192c1.722-.095 3.062-.192 4.402-.287 3.35-.287 6.126-.67 8.71-1.15 2.968-.572 5.743-1.53 8.423-2.678 2.202-.957 4.307-2.011 6.605-3.447v-1.053c-2.393 1.436-4.69 2.586-6.988 3.446-2.584 1.054-5.455 1.914-8.327 2.393" clip-rule="evenodd"></path><mask id="b" width="67" height="10" x="0" y="43" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 43.741h66.138v8.615H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M50.537 48.336c-4.69.67-9.476.67-14.07.765-1.053 0-2.106 0-3.158.096L0 49.771v2.585l33.404-1.436c1.053-.096 2.106-.096 3.159-.096 4.69-.191 9.476-.383 14.166-1.148 2.967-.479 5.838-1.149 8.518-2.106q3.303-1.149 6.892-2.871v-.958c-2.489 1.149-4.882 2.106-7.179 2.776-2.68.862-5.456 1.436-8.423 1.819" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.346 52.643c-4.403.383-8.806.383-13.113.383h-4.02c-11.007.095-22.014.095-33.117.191v2.584c10.624-.382 21.918-.765 33.213-1.052 1.34 0 2.68-.096 4.02-.096 4.307-.096 8.805-.192 13.208-.67 3.063-.287 5.839-.862 8.519-1.532a56.5 56.5 0 0 0 7.178-2.297v-.957c-2.488.862-4.977 1.627-7.37 2.202-2.775.574-5.551.957-8.518 1.244" clip-rule="evenodd"></path><mask id="c" width="67" height="6" x="0" y="54" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 54.749h66.234v4.594H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.154 56.855c-1.818.095-3.828.095-6.03.095h-2.488l-8.615-.095c-5.838 0-11.677-.097-17.132-.097H0v2.585l15.889-.384c5.455-.094 11.294-.287 17.132-.382l8.615-.096c2.393 0 5.455-.095 8.614-.287 3.063-.192 5.839-.479 8.614-.957 2.393-.382 4.882-.958 7.37-1.53v-.958a117 117 0 0 1-7.561 1.436c-2.68.287-5.456.573-8.519.67" clip-rule="evenodd"></path></g><mask id="d" width="67" height="3" x="0" y="60" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 60.108h66.043v2.68H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="m41.444 60.874-8.518-.096A1913 1913 0 0 1 0 60.205v2.583c10.624-.095 21.823-.19 32.926-.287l8.518-.095c2.872-.096 5.743-.096 8.519-.192 5.838-.191 11.103-.573 16.08-1.243v-.863c-4.977.575-10.242.863-16.08.863-2.776 0-5.647 0-8.519-.097" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M66.139 65.469 0 63.745v2.584h66.139z" clip-rule="evenodd"></path><mask id="e" width="67" height="19" x="0" y="16" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 16.271h66.234v18.665H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M60.204 22.014c-2.488 2.01-4.498 3.446-7.561 4.69-2.68 1.053-5.552 1.532-8.806 2.01-2.106.287-4.307.766-6.413.862-.861.095-1.723.095-2.584.191L0 32.351v2.585l34.936-3.446 4.498-.383c1.723-.191 3.159-.383 4.595-.574 3.35-.574 6.317-1.34 8.901-2.584 2.68-1.245 5.456-3.159 8.04-5.36 1.723-1.436 3.446-3.35 5.264-5.36v-.958c-2.297 2.393-4.115 4.212-6.03 5.743" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M94.278 0s11.869 18.951 14.07 22.397 4.69 6.222 13.496 8.136a2027 2027 0 0 1 12.634 2.776v.67s-5.551-1.149-12.825-2.776c-7.275-1.627-10.146-2.106-13.4-6.7-2.776-3.829-13.975-19.909-13.975-19.909zm0 21.632s10.816 11.39 13.975 14.644c3.35 3.445 7.561 4.69 13.495 5.743 5.647 1.053 12.73 2.201 12.73 2.201v.67s-6.7-1.053-12.73-2.106c-5.934-1.053-10.145-1.627-13.495-4.69-3.063-2.775-13.975-13.017-13.975-13.017z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.278 26.8s10.337 9.571 13.975 12.826c3.35 2.967 6.125 3.924 13.495 5.264s12.73 2.106 12.73 2.106v.67s-6.7-1.149-12.73-2.106-9.858-1.34-13.495-4.307c-4.212-3.35-13.975-11.486-13.975-11.486z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.278 32.256s11.773 9.38 13.975 11.007 5.072 3.541 13.591 4.786c8.327 1.244 12.634 1.817 12.634 1.817v.671s-7.561-1.15-12.634-1.722c-5.073-.67-8.997-.958-13.496-3.925-4.403-2.967-13.974-9.667-13.974-9.667v-2.967z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.278 37.424s11.773 7.849 14.07 9.093c2.202 1.245 4.882 3.254 13.496 4.404 8.614 1.148 12.634 1.627 12.634 1.627v.669s-7.178-.766-12.73-1.34c-5.551-.575-9.38-1.435-13.495-3.733-4.116-2.296-13.975-8.04-13.975-8.04z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.278 42.688s10.433 5.647 13.975 7.467c3.924 2.009 7.37 2.966 13.495 3.637 6.03.765 12.73 1.436 12.73 1.436v.67s-6.125-.67-12.73-1.245c-6.508-.575-8.805-.861-13.495-2.968-4.212-1.818-13.975-6.413-13.975-6.413z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.278 48.049s8.232 3.541 14.07 5.838c5.743 2.297 10.05 2.489 13.496 2.872 1.531.191 12.634 1.34 12.634 1.34v.67s-6.604-.575-12.634-1.053c-6.03-.574-8.614-.766-13.496-2.393-4.977-1.628-13.974-4.786-13.974-4.786V48.05zm0 5.359s8.327 2.585 13.975 4.116c5.647 1.532 10.911 2.106 13.495 2.297 2.585.192 12.635.957 12.635.957v.575s-5.743-.383-12.73-.862c-5.648-.383-10.242-.861-13.496-1.531-3.637-.766-13.974-3.254-13.974-3.254v-2.298zm0 5.361s6.796 1.148 13.975 2.393c5.36.86 12.73 1.435 13.495 1.531.766 0 12.73.862 12.73.862v.574s-7.657-.384-12.73-.671c-5.264-.286-10.528-.573-13.495-.957-6.7-.67-13.975-1.627-13.975-1.627zm0 5.551s10.72.382 13.975.479c3.254.095 26.225.957 26.225.957v.67h-40.2zm27.47-30.82c-9.763-2.106-11.964-5.647-13.591-7.849S94.183 5.456 94.183 5.456v4.02c.478.67 11.007 14.453 13.974 18.185 3.35 4.308 8.518 5.265 13.496 6.318s12.73 2.584 12.73 2.584v-.574c.095 0-10.146-2.01-12.635-2.489" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.748 36.276c-7.944-1.532-11.198-4.116-13.591-7.179-2.297-3.063-13.974-18.377-13.974-18.377v3.829c.478.574 11.102 13.112 13.974 16.367 3.35 3.828 7.944 4.785 13.591 5.838s12.73 2.393 12.73 2.393v-.574c0 .096-8.135-1.34-12.73-2.297" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.748 39.243c-8.327-1.627-10.05-2.967-13.495-6.796-2.202-2.393-13.496-15.697-13.975-16.271v3.541s10.529 11.199 13.975 14.549c4.402 4.403 8.614 4.69 13.591 5.551 4.977.862 12.729 2.297 12.729 2.297v-.574c-.095 0-9.475-1.627-12.825-2.297" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" stroke="#fff" stroke-width="2" d="M85.336 27.566H27.47V66.33h57.907V27.566z" clip-rule="evenodd"></path><path fill="#FFF100" fill-rule="evenodd" d="M57.046 33.117h2.01l-1.627 1.245.67 2.01-1.627-1.245-1.627 1.244.67-2.01-1.627-1.244h2.01l.574-1.914zm.096 25.843h2.01l-1.627 1.245.67 1.914-1.627-1.148-1.627 1.148.67-1.914-1.628-1.245h2.01l.575-1.915zm6.412-1.723h2.01l-1.627 1.244.67 1.914-1.627-1.147-1.627 1.148.67-1.915-1.723-1.244h2.01l.574-1.914zm0-22.397h2.01l-1.627 1.244.67 1.914-1.627-1.148-1.627 1.148.67-1.914L60.3 34.84h2.01l.574-1.914zm4.786 4.786h2.01l-1.627 1.244.67 1.915-1.627-1.149-1.723 1.149.67-1.915-1.627-1.244h2.01l.574-1.914zm0 12.922h2.01l-1.627 1.244.67 1.914-1.723-1.149-1.627 1.15.67-1.915-1.627-1.245h2.01l.574-1.914zm1.723-6.605h2.01l-1.627 1.244.67 1.914-1.627-1.148L67.86 49.1l.67-1.914-1.627-1.244h2.01l.575-1.914zM50.537 34.84h2.01l-1.628 1.244.67 1.914-1.627-1.148-1.627 1.148.67-1.914-1.627-1.244h2.01l.574-1.914zm-4.594 4.786h2.01l-1.627 1.244.67 1.915-1.628-1.149-1.627 1.149.67-1.915-1.627-1.244h2.01l.575-1.914zm-1.723 6.412h2.01l-1.627 1.245.67 1.915-1.627-1.149-1.627 1.149.67-1.915-1.627-1.245h2.01l.574-1.914zm1.723 6.51h2.01l-1.627 1.244.67 1.914-1.628-1.149-1.627 1.15.67-1.915-1.627-1.245h2.01l.575-1.914zm4.69 4.689h2.01l-1.627 1.244.67 1.914-1.627-1.147-1.627 1.148.67-1.915-1.627-1.244h2.01l.574-1.914z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M143.38 33.692c0-.288.097-.383.383-.383h7.083c.288 0 .382.096.382.383v1.148c0 .192-.094.383-.382.383h-5.265v3.35h4.69c.287 0 .384.096.384.383v1.148c0 .19-.097.383-.384.383h-4.69v3.829h5.36c.193 0 .383.096.383.383v1.148c0 .19-.096.383-.383.383h-7.178c-.286 0-.383-.095-.383-.383zm17.612 12.346h-1.34c-.096 0-.192 0-.287-.095-.096-.095-.096-.192-.096-.287v-.575c-.191.097-.383.288-.67.383s-.478.287-.765.384q-.432.142-.862.287c-.287.095-.574.095-.862.095-.669 0-1.148-.095-1.531-.287-.384-.192-.67-.383-.862-.765-.191-.287-.286-.671-.382-1.15s-.097-.861-.097-1.435v-5.648c0-.287.097-.382.384-.382h1.436c.191 0 .383.095.383.382v5.361c0 .287 0 .574.095.765 0 .192.095.384.192.574.096.192.287.288.382.383s.384.096.671.096c.191 0 .383 0 .67-.096.287-.095.478-.191.765-.286a5 5 0 0 0 .67-.287c.192-.097.383-.192.479-.288v-6.413c0-.096 0-.19.095-.287.096-.096.192-.096.288-.096h1.34c.286 0 .383.096.383.383v8.71c-.097.479-.192.574-.479.574m4.88-.287c0 .287-.095.383-.382.383h-1.435c-.288 0-.384-.096-.384-.383v-8.71c0-.287.096-.383.384-.383h1.339c.287 0 .383.096.383.383v.862c.095-.096.287-.288.574-.383.191-.192.478-.287.766-.383s.574-.191.766-.383c.286-.096.479-.191.765-.191h.287c.096 0 .096.095.192.287l.095 1.244v.287c0 .096-.095.096-.382.192s-.575.096-.862.191c-.287.096-.573.191-.861.191a7 7 0 0 0-.766.288c-.192.095-.479.191-.574.191zm10.529-4.402c0-.479 0-.957-.096-1.34-.095-.383-.191-.671-.286-.957-.192-.288-.384-.479-.671-.575a2.9 2.9 0 0 0-1.053-.191c-.382 0-.765.095-.957.191a.86.86 0 0 0-.574.575 1.6 1.6 0 0 0-.287.957c-.096.383-.096.861-.096 1.34 0 .478 0 .957.096 1.339.096.384.192.67.287.957.096.288.384.478.574.575.192.096.575.192.957.192.479 0 .767-.096 1.053-.192.287-.096.479-.287.671-.575.191-.286.286-.573.286-.957 0-.382.096-.86.096-1.34m2.202-.096c0 .575 0 1.15-.096 1.724a4.7 4.7 0 0 1-.573 1.626c-.289.479-.671.863-1.246 1.245-.574.288-1.34.479-2.297.479s-1.722-.191-2.297-.479a2.62 2.62 0 0 1-1.244-1.245c-.287-.478-.479-1.052-.479-1.626-.095-.574-.095-1.149-.095-1.724 0-.479 0-.957.095-1.53a4.2 4.2 0 0 1 .574-1.532c.289-.478.67-.861 1.246-1.244.573-.287 1.243-.479 2.2-.479s1.723.096 2.202.383c.574.287.957.67 1.244 1.149.287.478.478.957.575 1.531.095.575.191 1.149.191 1.722m8.04.001c0-.575 0-1.148-.095-1.436q-.144-.574-.288-.86c-.095-.193-.287-.385-.478-.385-.192-.094-.383-.094-.67-.094-.192 0-.383 0-.67.094-.287.097-.479.097-.766.192-.191.096-.478.192-.67.287l-.574.287v4.786q.717.144 1.148.288c.288.095.67.095 1.053.095s.67-.095.862-.192c.191-.094.383-.287.574-.478.191-.287.287-.574.287-.957.192-.479.287-.958.287-1.628m2.106.097c0 .765-.096 1.436-.191 2.106-.096.573-.288 1.148-.575 1.53-.287.384-.67.766-1.148.958-.479.192-1.149.287-1.915.287-.287 0-.67 0-1.148-.095-.479-.097-.862-.192-1.34-.287v3.35c0 .094 0 .19-.096.287-.096.095-.191.095-.287.095h-1.34c-.191 0-.287 0-.287-.095 0-.097-.096-.193-.096-.287V37.042c0-.288.096-.384.383-.384h1.34c.096 0 .191 0 .287.096s.096.191.096.288v.573h.096c.191-.094.382-.191.574-.383.191-.095.478-.287.766-.382l.861-.287c.287-.096.574-.096.861-.096.67 0 1.149.096 1.532.383.383.192.766.574.957.957.191.384.383.957.479 1.531.191.575.191 1.245.191 2.011m7.944-5.935q-.718 0-.861-.287a1.8 1.8 0 0 1-.192-.766c0-.287.096-.574.192-.765q.143-.288.861-.287.718 0 .862.287c.095.191.191.478.191.765s-.096.575-.191.766q-.144.288-.862.287m-.383 6.413h-2.297c-.478 0-.861.096-1.148.383-.288.191-.383.67-.383 1.244q0 .574.287.862c.191.191.478.287.957.287.191 0 .383 0 .67-.096s.479-.096.766-.191c.287-.096.478-.192.67-.287.191-.096.478-.192.574-.288v-1.914zm-3.35-6.413c-.287 0-.478 0-.574-.095-.096-.096-.287-.096-.287-.288s-.096-.191-.192-.382c-.095-.192 0-.288 0-.383a1.8 1.8 0 0 1 .192-.766q.144-.287.861-.287.718 0 .862.287c.095.191.191.479.191.766s-.096.574-.191.765c-.192.192-.479.383-.862.383m3.446 9.572a5.3 5.3 0 0 1-1.627.861c-.574.192-1.244.383-1.914.383a4.3 4.3 0 0 1-1.245-.191c-.383-.096-.574-.288-.765-.575-.192-.191-.383-.478-.383-.861-.096-.287-.096-.67-.096-1.149 0-1.148.287-1.914.861-2.488.575-.479 1.532-.766 2.68-.766h2.489v-.479c0-.287 0-.478-.096-.765-.095-.192-.191-.383-.287-.479s-.383-.191-.574-.287c-.287-.096-.574-.096-.957-.096h-1.245c-.191 0-.478 0-.67.096-.191 0-.478 0-.67.096h-.382c-.096 0-.096-.096-.192-.287l-.191-.67v-.288c.095-.095.191-.191.383-.287.191-.095.478-.095.765-.191s.575-.096.862-.096.574-.096.861-.096h.766q1.292 0 2.01.288c.478.191.861.382 1.148.67.288.287.383.67.479 1.148.096.479.096.957.096 1.436v4.211c0 .096.095.192.095.287 0 .096.096.096.192.096s.191 0 .383.096c.095 0 .191 0 .287.096.096 0 .096.095.096.191v.766c0 .191-.192.383-.479.383-.191 0-.287 0-.479.095h-.478c-.479 0-.766-.095-1.053-.287-.287-.096-.479-.383-.67-.861m6.795.765c0 .097 0 .192-.095.287-.096.096-.096.096-.286.096h-1.341c-.288 0-.383-.096-.383-.383v-8.71c0-.287.095-.383.383-.383h1.341c.094 0 .19 0 .286.096s.095.192.095.287zm.097-11.581v.478c0 .096-.097.287-.192.383-.096.096-.192.192-.383.287-.192.096-.382.096-.574.096-.287 0-.479 0-.575-.096a1.4 1.4 0 0 1-.383-.287c-.095-.096-.095-.191-.191-.383v-.383c0-.287.096-.574.191-.765.193-.192.479-.287.958-.287.478 0 .765.095.957.287.192.096.192.287.192.67m9.283 9.093q0 .861-.287 1.436c-.192.382-.479.67-.861.957-.384.191-.766.382-1.245.479-.479.095-.957.19-1.436.19-.478 0-1.053 0-1.531-.095a20 20 0 0 1-1.436-.287c-.191-.096-.286-.191-.383-.287-.095-.097-.095-.191 0-.383l.097-.67c0-.191.095-.287.191-.287h.382c.192 0 .479.096.67.096.287 0 .479 0 .766.095.287 0 .479 0 .67.095h.574c.576 0 1.054-.095 1.34-.286.287-.193.384-.479.384-.861 0-.192 0-.383-.097-.575-.094-.192-.094-.287-.287-.383-.191-.095-.286-.191-.478-.191-.192-.097-.479-.097-.765-.191a31 31 0 0 1-1.341-.288c-.382-.096-.766-.287-1.149-.478a2.9 2.9 0 0 1-.765-.766c-.192-.288-.287-.767-.287-1.245 0-.957.287-1.626.957-2.2.671-.48 1.531-.766 2.585-.766h.67c.287 0 .479 0 .766.095.286.096.478.096.764.096.288.096.479.096.671.191.287.096.479.288.382.575l-.19.67c0 .095-.097.191-.192.287h-.383c-.382-.096-.861-.096-1.339-.192-.479-.095-.958-.095-1.246-.095-.574 0-1.053.095-1.244.287q-.287.287-.287.861c0 .383.096.575.384.766.287.192.669.192 1.244.287.479.095.86.192 1.339.287.479.096.767.286 1.149.479.287.191.575.478.765.861.383.382.479.86.479 1.436m8.998 1.914v.382c0 .097-.191.193-.287.288-.383.19-.862.288-1.34.383-.574.096-1.053.096-1.532.096-.861 0-1.627-.096-2.201-.383a3.46 3.46 0 0 1-1.244-1.053 4.2 4.2 0 0 1-.575-1.531c-.095-.575-.095-1.245-.095-1.915 0-.574 0-1.149.191-1.722.096-.575.287-1.149.574-1.532.288-.478.67-.861 1.245-1.148.574-.288 1.244-.383 2.105-.383h.766c.287 0 .479 0 .766.096.287 0 .478.095.766.19.287.097.478.097.67.192q.287.143.287.575l-.096.765c0 .096-.096.192-.191.288h-.383c-.383 0-.766-.096-1.245-.096-.478 0-.765-.096-1.148-.096-.766 0-1.34.191-1.627.67s-.479 1.244-.479 2.297c0 .575 0 1.053.096 1.532.096.383.191.67.383.957.191.287.383.383.67.478s.574.192.957.192c.287 0 .67 0 1.148-.097.479 0 .958-.095 1.34-.095h.383c.096 0 .096.095.192.288zm9.188.861h-1.339c-.288 0-.384-.095-.384-.382v-5.551c0-.575-.095-.957-.287-1.341-.192-.286-.574-.479-1.149-.479-.191 0-.382 0-.67.096-.287.097-.479.191-.766.288-.287.095-.478.19-.67.287-.19.095-.382.192-.478.192v6.508c0 .095 0 .192-.096.287-.095.095-.191.095-.286.095h-1.341c-.192 0-.382-.095-.382-.382v-12.73c0-.288.095-.384.382-.384h1.341c.286 0 .382.096.382.383v4.69c.191-.094.383-.191.575-.383a2.8 2.8 0 0 0 .765-.382l.862-.287c.287-.096.573-.096.861-.096.67 0 1.148.096 1.532.287.382.191.669.479.86.767.192.286.288.764.384 1.148.095.479.095.86.095 1.436v5.551c.287.287.097.382-.191.382m6.413-7.848c-.382 0-.67.096-.86.19-.193.097-.384.289-.576.48-.191.19-.287.478-.287.766-.094.287-.094.574-.094.957h3.828c0-.288 0-.575-.097-.861-.095-.287-.191-.479-.287-.766a.97.97 0 0 0-.573-.479c-.288-.096-.671-.287-1.054-.287m-2.01 3.732c0 .479.096.863.193 1.245.094.288.286.575.478.766.191.19.382.287.669.382.288.097.574.097 1.053.097.383 0 .766 0 1.244-.097.479-.095.863-.095 1.245-.095h.382c.096 0 .096.095.193.288l.095.67v.381q0 .145-.288.288c-.191.096-.382.191-.67.191-.287.097-.478.097-.765.191-.286 0-.575.097-.862.097h-.765c-.958 0-1.628-.097-2.202-.383a3.45 3.45 0 0 1-1.243-1.053 4.2 4.2 0 0 1-.575-1.532c-.096-.573-.192-1.149-.192-1.818 0-.478 0-.957.096-1.532.096-.573.287-1.149.574-1.627.287-.479.67-.957 1.244-1.244.575-.382 1.246-.479 2.203-.479.86 0 1.53.097 2.105.384.574.287.957.573 1.245.957.286.382.478.86.573 1.339.096.479.192 1.054.192 1.532 0 .382 0 .67-.192.86-.095.192-.383.289-.766.289h-5.264zm-89.589 17.804 1.436-1.914 3.254-4.02c.096-.097.193-.192.287-.192.097 0 .192-.095.384-.095h1.722c.096 0 .193 0 .287.095 0 .095 0 .192-.094.287l-4.213 5.072 4.307 6.892q.145.145 0 .287c-.094.097-.094.097-.191.097h-1.723c-.191 0-.287 0-.382-.097q-.144-.142-.288-.287l-3.159-5.264-1.722 2.106v3.35c0 .095 0 .192-.095.286-.097.097-.097.097-.288.097h-1.436c-.287 0-.382-.097-.382-.383v-12.06c0-.288.095-.383.382-.383h1.436c.096 0 .191 0 .288.095 0 .097.095.192.095.288zm14.645 1.914c0-.478 0-.957-.096-1.34-.095-.383-.192-.67-.287-.957-.192-.287-.383-.478-.671-.574a2.9 2.9 0 0 0-1.051-.191c-.384 0-.766.094-.958.191a.87.87 0 0 0-.575.574c-.19.286-.287.574-.287.957-.095.383-.095.862-.095 1.34s0 .957.095 1.34c.097.383.192.67.287.957.097.287.384.478.575.575.192.096.574.19.958.19.478 0 .765-.094 1.051-.19.288-.097.479-.288.671-.575a1.6 1.6 0 0 0 .287-.958c0-.382.096-.86.096-1.339m2.202-.096c0 .575 0 1.15-.097 1.723a4.7 4.7 0 0 1-.573 1.627c-.287.478-.671.862-1.245 1.244-.575.288-1.341.479-2.298.479s-1.722-.19-2.296-.479a2.6 2.6 0 0 1-1.245-1.244c-.287-.479-.479-1.052-.479-1.627-.094-.574-.094-1.148-.094-1.723 0-.479 0-.957.094-1.53a4.2 4.2 0 0 1 .576-1.533c.287-.479.67-.86 1.244-1.244.573-.287 1.243-.479 2.2-.479s1.723.097 2.202.384c.575.287.957.67 1.245 1.148.287.479.479.958.574 1.532.095.573.192 1.148.192 1.722m15.505 4.691c0 .095-.096.095-.288.095h-1.339c-.287 0-.384-.096-.384-.383v-5.455c0-.67-.094-1.245-.286-1.436-.192-.287-.574-.383-1.053-.383-.191 0-.383 0-.575.096s-.479.096-.67.19c-.19.097-.479.193-.669.288q-.287.142-.575.288v6.508c0 .095 0 .191-.095.287-.097.096-.191.096-.287.096h-1.436c-.191 0-.288-.096-.288-.383v-5.551c0-.576-.095-1.054-.287-1.34-.192-.288-.479-.383-.957-.383-.192 0-.382 0-.574.096-.191.094-.383.094-.67.19-.192.097-.478.192-.671.288l-.573.287v6.413c0 .287-.097.383-.384.383h-1.243c-.192 0-.384-.096-.384-.383v-8.71c0-.288.097-.383.384-.383h1.34c.287 0 .382.095.382.383v.574c.192-.095.384-.287.575-.383.191-.095.479-.287.669-.382.192-.097.479-.192.767-.288.287-.095.478-.095.766-.095.573 0 1.051.096 1.53.286.479.192.862.575 1.15 1.054.478-.383 1.051-.67 1.627-.957.573-.288 1.148-.383 1.817-.383.67 0 1.149.096 1.533.286.382.192.67.478.86.767.192.287.288.669.384 1.147.095.479.095.863.095 1.341v5.743c-.095.095-.095.191-.191.191m15.889.001c0 .095-.096.095-.287.095h-1.34c-.287 0-.383-.096-.383-.383v-5.455c0-.67-.096-1.245-.287-1.436-.192-.287-.575-.383-1.053-.383-.192 0-.383 0-.574.096-.192.096-.479.096-.67.19-.192.097-.479.193-.67.288q-.288.142-.575.288v6.508c0 .095 0 .191-.095.287-.096.096-.192.096-.288.096h-1.435c-.192 0-.287-.096-.287-.383v-5.551c0-.576-.096-1.054-.288-1.34-.191-.288-.478-.383-.957-.383-.191 0-.383 0-.574.096-.191.094-.383.094-.67.19-.191.097-.479.192-.67.288l-.574.287v6.413c0 .287-.096.383-.383.383h-1.34c-.192 0-.383-.096-.383-.383v-8.71c0-.288.096-.383.383-.383h1.34c.287 0 .383.095.383.383v.574c.191-.095.383-.287.574-.383.191-.095.479-.287.67-.382.191-.097.479-.192.766-.288s.478-.095.765-.095c.575 0 1.053.096 1.532.286.478.192.861.575 1.148 1.054.479-.383 1.053-.67 1.628-.957.574-.288 1.148-.383 1.818-.383s1.149.096 1.532.286c.382.192.67.478.861.767.191.287.287.669.383 1.147.096.479.096.863.096 1.341v5.743c-.096.095-.096.191-.096.191m4.499-.191c0 .096 0 .191-.097.287-.095.096-.095.096-.286.096h-1.34c-.288 0-.383-.096-.383-.383v-8.71c0-.287.095-.383.383-.383h1.34c.095 0 .191 0 .286.096.097.095.097.191.097.287zm.095-11.582v.479c0 .096-.095.287-.192.383a1.3 1.3 0 0 1-.382.287c-.191.096-.383.096-.575.096-.286 0-.479 0-.574-.096a1.3 1.3 0 0 1-.383-.287c-.095-.096-.095-.192-.191-.383v-.383c0-.287.096-.574.191-.766.192-.191.478-.287.957-.287.478 0 .766.096.957.287.097.096.192.288.192.67m9.284 9.094q0 .862-.287 1.435c-.192.382-.479.67-.862.958-.382.19-.765.381-1.244.478-.478.096-.957.19-1.436.19-.478 0-1.052 0-1.531-.094a19 19 0 0 1-1.436-.287 1.4 1.4 0 0 1-.383-.287c-.095-.097-.095-.192 0-.383l.096-.671c0-.192.096-.287.192-.287h.382c.192 0 .479.095.67.095.288 0 .479 0 .766.097.287 0 .479 0 .67.095h.574c.575 0 1.053-.095 1.34-.287s.383-.478.383-.862c0-.19 0-.382-.095-.573-.096-.193-.096-.287-.288-.384-.191-.095-.287-.19-.478-.19-.192-.097-.479-.097-.766-.192-.478-.097-.957-.191-1.34-.287-.383-.097-.766-.288-1.148-.479a2.9 2.9 0 0 1-.766-.766c-.192-.287-.287-.766-.287-1.245 0-.957.287-1.627.957-2.2.67-.479 1.531-.766 2.584-.766h.67c.287 0 .479 0 .766.095.287.097.478.097.766.097.287.095.478.095.67.19.287.097.478.288.382.575l-.191.67c0 .096-.096.19-.191.288h-.383c-.383-.097-.862-.097-1.34-.192-.479-.096-.957-.096-1.245-.096-.574 0-1.052.096-1.244.288q-.287.287-.287.86c0 .384.096.575.383.767.287.19.67.19 1.244.287.479.095.862.191 1.34.287s.766.286 1.149.478c.287.192.574.48.765.862.383.382.479.86.479 1.436m8.806 0q-.001.862-.287 1.435c-.192.382-.479.67-.862.958-.384.19-.766.381-1.244.478-.479.096-.957.19-1.436.19-.478 0-1.054 0-1.532-.094a20 20 0 0 1-1.436-.287 1.4 1.4 0 0 1-.382-.287c-.097-.097-.097-.192 0-.383l.096-.671c0-.192.096-.287.191-.287h.383c.191 0 .479.095.669.095.288 0 .479 0 .767.097.287 0 .478 0 .669.095h.575c.574 0 1.053-.095 1.339-.287.288-.192.384-.478.384-.862 0-.19 0-.382-.096-.573-.095-.193-.095-.287-.288-.384-.19-.095-.286-.19-.478-.19-.191-.097-.479-.097-.765-.192-.479-.097-.957-.191-1.34-.287-.383-.097-.767-.288-1.149-.479a2.9 2.9 0 0 1-.765-.766c-.192-.287-.289-.766-.289-1.245 0-.957.289-1.627.958-2.2.671-.479 1.532-.766 2.585-.766h.67c.287 0 .478 0 .766.095.286.097.478.097.764.097.288.095.479.095.671.19.286.097.479.288.383.575l-.191.67c0 .096-.096.19-.192.288h-.383c-.382-.097-.861-.097-1.34-.192-.478-.096-.957-.096-1.244-.096-.575 0-1.054.096-1.244.288q-.288.287-.288.86c0 .384.096.575.384.767.287.19.67.19 1.244.287.478.095.861.191 1.34.287.478.095.766.286 1.148.478.288.192.575.48.766.862.382.382.479.86.479 1.436m4.211 2.488c0 .096 0 .191-.096.287-.094.096-.094.096-.286.096h-1.341c-.287 0-.382-.096-.382-.383v-8.71c0-.287.095-.383.382-.383h1.341c.095 0 .192 0 .286.096.096.095.096.191.096.287zm.097-11.582v.479c0 .096-.097.287-.193.383a1.3 1.3 0 0 1-.383.287c-.19.096-.381.096-.574.096-.286 0-.478 0-.573-.096a1.3 1.3 0 0 1-.384-.287c-.095-.096-.095-.192-.191-.383v-.383c0-.287.096-.574.191-.766.192-.191.479-.287.957-.287.479 0 .766.096.957.287.096.096.193.288.193.67m8.23 7.179c0-.478 0-.957-.096-1.34a12 12 0 0 0-.286-.957c-.193-.287-.384-.478-.671-.574a2.9 2.9 0 0 0-1.053-.191c-.383 0-.766.094-.957.191a.86.86 0 0 0-.574.574 1.6 1.6 0 0 0-.288.957c-.095.383-.095.862-.095 1.34s0 .957.095 1.34c.096.383.193.67.288.957s.383.478.574.575.574.19.957.19c.479 0 .767-.094 1.053-.19.287-.097.478-.288.671-.575.19-.287.286-.574.286-.958 0-.382.096-.86.096-1.339m2.201-.096c0 .575 0 1.15-.096 1.723a4.7 4.7 0 0 1-.573 1.627c-.288.478-.671.862-1.245 1.244-.574.288-1.34.479-2.297.479s-1.722-.19-2.297-.479a2.6 2.6 0 0 1-1.245-1.244c-.287-.479-.478-1.052-.478-1.627-.095-.574-.095-1.148-.095-1.723 0-.479 0-.957.095-1.53a4.2 4.2 0 0 1 .574-1.533c.288-.479.67-.86 1.245-1.244.574-.287 1.244-.479 2.201-.479s1.723.097 2.201.384c.574.287.957.67 1.244 1.148.288.479.479.958.576 1.532.094.573.19 1.148.19 1.722m9.955 4.691c-.096.095-.191.095-.287.095h-1.436c-.287 0-.383-.096-.383-.383v-5.36c0-.574-.095-1.053-.287-1.34s-.574-.478-1.148-.478c-.192 0-.383 0-.67.096-.287.094-.479.19-.766.287-.287.095-.479.191-.67.286-.191.096-.383.192-.479.288v6.317c0 .287-.095.383-.382.383h-1.34c-.288 0-.383-.096-.383-.383v-8.71c0-.288.095-.383.383-.383h1.34c.287 0 .382.095.382.383v.574c.192-.095.383-.287.67-.383.288-.095.479-.287.766-.382q.43-.145.862-.288c.287-.095.574-.095.861-.095.67 0 1.149.096 1.531.286.383.192.67.478.862.767.191.287.287.765.383 1.147.095.479.095.863.095 1.436v5.648a.3.3 0 0 1 .096.191" clip-rule="evenodd"></path><mask id="f" width="254" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.713h253.547V0H0z" clip-rule="evenodd"></path></mask><g mask="url(#f)"><path fill="#fff" fill-rule="evenodd" d="M250.197 66.713h3.35V27.949h-3.35z" clip-rule="evenodd"></path></g>', 31), b11 = [
  M11
];
function L11(t, e) {
  return T(), N("svg", z11, [...b11]);
}
const x11 = { render: L11 }, S11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, C11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="248" height="71" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.128h247.5V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm12.5 10c0 .2.1.5.3.6s.3.3.599.4c.3.1.601.2 1 .2.401 0 .701-.1 1-.2s.5-.3.601-.4q.3-.3.3-.6c.099-.2.099-.5.099-.8v-5.7c0-.3.101-.4.401-.4h1.5c.3 0 .399.1.399.4v5.8q0 .75-.3 1.5c-.2.5-.399.9-.799 1.2-.401.3-.8.6-1.3.8s-1.2.3-1.901.3c-.799 0-1.399-.1-1.899-.3s-1-.4-1.301-.8c-.3-.3-.599-.7-.699-1.2-.2-.5-.2-1-.2-1.6v-5.8c0-.1 0-.2.099-.3.101-.1.201-.1.3-.1h1.401c.299 0 .4.1.4.4zm14.7-2.1c0-.6-.1-1.1-.199-1.5-.101-.4-.301-.7-.401-.9-.099-.2-.4-.4-.7-.5s-.5-.1-.8-.1q-.75 0-1.2.3c-.3.2-.5.5-.7.8-.1.3-.199.6-.3 1V44l1.2.3c.401 0 .701.1 1.1.1.301 0 .601 0 .9-.1.201-.1.5-.3.6-.5.2-.2.301-.6.4-1 .1-.6.1-1.1.1-1.8m2.301.1c0 .8-.101 1.5-.2 2.2-.101.6-.3 1.2-.601 1.6-.3.4-.699.8-1.199 1s-1.2.4-2 .4c-.301 0-.7 0-1.2-.1s-.901-.2-1.401-.3v3.6c0 .1 0 .2-.099.3-.101.1-.201.1-.3.1H164.5c-.2 0-.299 0-.299-.1s-.101-.2-.101-.3v-8.3c0-1.7.4-3 1.101-3.8.799-.8 1.799-1.2 3.2-1.2.8 0 1.5.1 2.099.4.6.2 1 .6 1.401 1 .399.4.599 1 .699 1.6.2.4.301 1.1.301 1.9m8.499 3.7c-.2.4-.601.7-1.101 1s-1.099.4-1.7.4c-.8 0-1.399-.1-1.899-.4s-.901-.6-1.2-1.1c-.3-.5-.5-1-.6-1.6-.101-.6-.2-1.2-.2-1.9 0-.5 0-1 .099-1.5.101-.5.201-1 .401-1.4s.5-.9.899-1.2q.602-.6 1.5-.9c.101-.1.301-.1.401-.1.099 0 .2.1.299.2l.5.8c.101.1.101.2.101.3q0 .15-.301.3c-.3.2-.599.5-.8.7-.2.2-.399.5-.5.8-.099.3-.2.6-.2.9s-.099.7-.099 1.1 0 .8.099 1.2c.101.4.2.7.301 1s.3.5.5.7c.199.2.5.2.8.2.399 0 .7-.1.899-.2s.401-.3.5-.5c.101-.2.2-.4.2-.7 0-.2.101-.5.101-.8v-2.6c0-.3.1-.4.399-.4h1.3c.101 0 .2 0 .301.1 0 .1.1.2.1.3v2.6c0 .3 0 .5.099.8.101.2.2.5.301.7s.3.4.5.5c.199.1.5.2.8.2.599 0 1-.2 1.3-.7.299-.5.4-1.3.4-2.4 0-.5 0-.9-.101-1.2 0-.3-.099-.6-.2-.9-.099-.3-.3-.5-.5-.8-.199-.2-.5-.5-.8-.7q-.3-.15-.299-.3c0-.1 0-.2.099-.3l.401-.7c.099-.3.299-.3.599-.2q.901.3 1.5.9.6.6.901 1.2c.2.4.4.9.4 1.4.1.5.1 1 .1 1.5 0 .7-.1 1.3-.201 1.9-.099.6-.299 1.1-.599 1.6s-.7.8-1.2 1.1-1.1.4-1.901.4c-.699 0-1.3-.1-1.8-.4-.2-.2-.599-.5-.899-.9m17.4.9c0 .3-.1.4-.399.4H197c-.3 0-.4-.1-.4-.4v-7.6h-4.199v7.6c0 .1 0 .2-.101.3-.1.1-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h7.801c.099 0 .199 0 .299.1s.1.2.1.3zm4.1-4.4c0 .6 0 1.2.1 1.5q.15.6.299.9c.101.2.3.4.5.4.201.1.401.1.701.1.2 0 .4 0 .7-.1.2-.1.5-.1.8-.2.299-.1.5-.2.7-.3l.599-.3v-4.8c-.399-.2-.899-.3-1.2-.4-.399-.1-.699-.1-.899-.1-.7 0-1.3.2-1.601.7-.599.5-.699 1.4-.699 2.6m6.399 2.3c0 .4 0 .6.101.7.1.1.3.1.5.2.1 0 .199 0 .3.1 0 0 .099.1.099.2v.8c0 .2-.2.4-.5.4-.2 0-.299 0-.5.1h-.5c-.5 0-.899-.1-1.099-.3s-.5-.5-.601-1c-.5.4-1.099.7-1.599 1s-1.1.4-1.701.4c-.599 0-1.2-.1-1.599-.4-.401-.2-.8-.6-1-1s-.401-1-.5-1.6c-.101-.6-.2-1.3-.2-2.1s.099-1.5.2-2.1c.2-.6.399-1.2.7-1.6.3-.5.699-.8 1.199-1.1s1.101-.4 1.801-.4c.3 0 .699.1 1.199.2s.901.3 1.401.6v-.2c0-.1 0-.2.099-.3 0-.1.2-.1.301-.1h1.399c.201 0 .3 0 .3.1s.101.2.101.3v7.1zm5.901-8.7q-.75 0-.9-.3c-.1-.2-.201-.5-.201-.8s.101-.6.201-.8q.15-.3.9-.3t.899.3c.101.2.201.5.201.8s-.1.6-.201.8q-.149.3-.899.3m-.9 10.8c0 .1 0 .2-.1.3-.101.1-.101.1-.3.1h-1.4c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.1 0 .199 0 .3.1s.1.2.1.3zm-3-10.8c-.3 0-.5 0-.6-.1-.101-.1-.3-.1-.3-.3-.1-.1-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8q.15-.3.9-.3t.9.3c.1.2.2.5.2.8s-.1.6-.2.8c-.101.2-.4.4-.9.4m7.8 5 1.5-1.6 1.7-1.7.3-.3c.101-.1.2-.1.4-.1h1.6c.2 0 .301 0 .301.1s0 .2-.101.3l-3.2 3.3 3.601 5.7q.148.15 0 .3c-.101.1-.101.1-.3.1H223.3c-.2 0-.399 0-.5-.1-.099-.1-.2-.2-.2-.3l-2.5-4.1-1.1 1.2v3c0 .1 0 .2-.099.3-.101.1-.2.1-.301.1h-1.399c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.399c.101 0 .2 0 .301.1.099.1.099.2.099.3zm13.4-8.1c.2.1.2.3.1.4l-2 2.8c-.1.1-.1.1-.2.1h-.2l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1zm2.5 13.9c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.2 0-.4 0-.7.1s-.5.2-.8.3-.5.2-.7.3-.4.2-.5.3v6.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.4 1.2c.1.5.1.9.1 1.5v5.7zm-91.6 7.7c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zM162.3 66c0 .3-.1.4-.399.4H160.5c-.3 0-.4-.1-.4-.4v-7.6h-4.199V66c0 .1 0 .2-.101.3-.1.1-.2.1-.3.1H154c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h7.8c.101 0 .2 0 .3.1s.1.2.1.3zm4.5 0c0 .1 0 .2-.1.3 0 .1-.1.1-.299.1H165c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.401c.099 0 .199 0 .299.1 0 .1.1.2.1.3zm8.601-9.5c.199 0 .3 0 .3.1s.099.2.099.3V58c0 .1 0 .2-.099.3 0 .1-.2.1-.3.1h-2.4v4.9c0 .4 0 .6.099.8.101.2.2.3.401.4.2.1.4.1.799.1.3 0 .701 0 1.201-.1h.4c.1 0 .1.1.1.3l.099.8c0 .2-.099.4-.3.5s-.399.2-.599.2c-.2.1-.401.1-.7.1-.3 0-.401.1-.701.1h-.599c-.5 0-.901-.1-1.2-.2-.3-.1-.6-.3-.8-.5s-.3-.5-.401-.8c-.099-.3-.099-.6-.099-1v-5.7h-2c-.3 0-.401-.1-.401-.4v-1c0-.3.101-.4.401-.4zm8.198 4.8c0-.6-.1-1.1-.199-1.5-.101-.4-.301-.7-.401-.9-.099-.2-.4-.4-.7-.5s-.5-.1-.8-.1q-.75 0-1.2.3c-.3.2-.5.5-.7.8-.1.3-.199.6-.3 1v4l1.2.3c.401 0 .701.1 1.1.1.301 0 .601 0 .9-.1.201-.1.5-.3.6-.5.2-.2.301-.6.4-1 .1-.7.1-1.2.1-1.9m2.301.1c0 .8-.101 1.5-.2 2.2-.101.6-.3 1.2-.601 1.6-.3.4-.699.8-1.199 1s-1.2.4-2 .4c-.301 0-.7 0-1.2-.1s-.901-.2-1.401-.3v3.6c0 .1 0 .2-.099.3-.101.1-.101-.1-.201-.1h-1.4c-.199 0-.3 0-.3-.1s-.099-.2-.099-.3v-8.3c0-1.7.399-3 1.099-3.8.8-.8 1.8-1.2 3.2-1.2.8 0 1.5.1 2.1.4.601.2 1 .6 1.4 1 .401.4.6 1 .701 1.6.099.6.2 1.3.2 2.1m8.3 0c0-.5 0-1-.101-1.4a12 12 0 0 0-.299-1c-.201-.3-.4-.5-.701-.6-.299-.1-.599-.2-1.099-.2-.401 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.301.6-.301 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.301 1s.4.5.6.6.599.2 1 .2c.5 0 .8-.1 1.099-.2.301-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.299-1.1.6-1.6c.3-.5.699-.9 1.3-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.299 1.2.301.5.5 1 .601 1.6.2.6.2 1.2.2 1.8M207 66c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-7.6h-4.2V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h7.8c.1 0 .2 0 .3.1s.1.2.1.3zm8.2-13.9c.2.1.2.3.1.4l-2 2.8c-.1.1-.1.1-.201.1h-.199l-.801-.4c-.099-.1-.199-.2-.099-.4l1.599-3.1c.101-.2.201-.2.401-.1zm2.399 13.9c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.6-.5-1.2-.5-.201 0-.4 0-.701.1-.299.1-.5.2-.799.3s-.5.2-.701.3c-.199.1-.399.2-.5.3V66c0 .3-.099.4-.399.4h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .399.1.399.4v.6c.201-.1.401-.3.701-.4s.5-.3.799-.4l.901-.3c.3-.1.599-.1.9-.1.699 0 1.199.1 1.6.3.4.2.7.5.9.8.199.3.3.8.4 1.2.1.5.1.9.1 1.5V66zm26.601.7h3.3V28h-3.3z"></path></g>', 24), k11 = [
  C11
];
function E11(t, e) {
  return T(), N("svg", S11, [...k11]);
}
const A11 = { render: E11 }, F11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, T11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="258" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h257.5V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m5.901-3.3c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9-.101-.3-.2-.5-.3-.8s-.301-.4-.6-.5c-.4-.2-.701-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8.199.2.4.3.699.4.301.1.601.1 1.101.1.399 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.601.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4-.601-.3-1-.7-1.3-1.1-.301-.5-.5-1-.6-1.6s-.201-1.2-.201-1.9c0-.5 0-1 .101-1.6.1-.6.3-1.2.6-1.7.299-.5.7-1 1.299-1.3.601-.4 1.301-.5 2.301-.5.9 0 1.6.1 2.199.4.601.3 1 .6 1.301 1s.5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.401.3-.8.3h-5.5zm14.199-.1h-2.4c-.5 0-.901.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .399 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.401-.1-.6-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .899-2.6.601-.5 1.601-.8 2.801-.8h2.6v-.5c0-.3 0-.5-.1-.8-.101-.2-.2-.4-.301-.5l-.599-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.399c-.101 0-.101-.1-.2-.3l-.2-.7v-.3c.099-.1.2-.2.4-.3.199-.1.5-.1.8-.2s.599-.1.899-.1.601-.1.901-.1h.799q1.351 0 2.101.3c.5.2.899.4 1.199.7s.401.7.5 1.2c.101.5.101 1 .101 1.5V44c0 .1.099.2.099.3s.101.1.201.1c.099 0 .2 0 .4.1.1 0 .199 0 .3.1.099 0 .099.1.099.2v.8c0 .2-.2.4-.5.4-.2 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.401-.1-.601-.4-.7-.9m13.1 1.1c-.1.1-.199.1-.3.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.301-1.4-.199-.4-.6-.5-1.199-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.401.2-.5.3v6.7c0 .3-.101.4-.401.4h-1.399c-.301 0-.401-.1-.401-.4v-9.1c0-.3.1-.4.401-.4h1.399c.3 0 .401.1.401.4v.6c.2-.1.399-.3.7-.4s.5-.3.8-.4l.899-.3c.301-.1.601-.1.9-.1.701 0 1.201.1 1.6.3.4.2.7.5.9.8s.3.8.401 1.2c.099.5.099.9.099 1.5v5.8c.1 0 .1.1.1.2m-78.9 13.8c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.799-.6h.801c.3 0 .6.1 1 .1.3 0 .699.1 1 .2l.9.3c.2.1.299.1.299.2s.101.2.101.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.701 0-1.201.1-1.6.4-.4.3-.7.6-1 1-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.599-.2h.401c.099.1.099.1.2.3l.2.8q.15.45-.301.6-.3.15-.899.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.701-.6c-.699-.4-1.299-.9-1.599-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m17.399 1.6c0-.5 0-1-.1-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.801.1-1 .2-.2.1-.5.3-.601.6-.2.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.1.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .1-.8.1-1.4m2.301-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.4-.5c-.6-.3-1-.7-1.3-1.3-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6.101-.6.3-1.1.601-1.6.3-.5.699-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.3 1.2s.5 1 .601 1.6c.099.6.2 1.2.2 1.8m16.3 5c0 .1-.101.1-.3.1h-1.4c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.1-.699.2-.2.1-.5.2-.7.3l-.601.3V66c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.301-1.4-.199-.3-.5-.4-1-.4-.199 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3V66c0 .3-.1.4-.401.4H165.2c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3c.301-.1.5-.1.801-.1.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.199-.4 1.9-.4 1.2.1 1.6.3.699.5.9.8c.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c-.1.1-.1.2-.1.3m16.5 0c0 .1-.101.1-.3.1H194c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.1-.699.2-.2.1-.5.2-.7.3l-.601.3V66c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.301-1.4-.199-.3-.5-.4-1-.4-.199 0-.399 0-.599.1s-.401.1-.7.2c-.3.1-.5.2-.701.3l-.599.3V66c0 .3-.1.4-.401.4H181.7c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.599-.4.201-.1.5-.3.701-.4.299-.1.5-.2.799-.3.301-.1.5-.1.801-.1.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.199-.4 1.9-.4 1.2.1 1.6.3.699.5.9.8c.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c0 .1-.1.2-.1.3m4.701-.3c0 .1 0 .2-.101.3 0 .1-.099.1-.299.1H198.6c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.101.2.101.3zm.1-12.1v.5c0 .1-.1.3-.201.4-.099.1-.2.2-.399.3-.2.1-.4.1-.601.1-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.101.1.201.4.201.7m9.7 9.5q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3a1.4 1.4 0 0 1-.399-.3c-.101-.1-.101-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.199 0 .5.1.699.1.301 0 .5 0 .801.1.3 0 .5 0 .699.1h.601c.6 0 1.1-.1 1.399-.3.301-.2.401-.5.401-.9 0-.2 0-.4-.1-.6s-.1-.3-.301-.4c-.199-.1-.299-.2-.5-.2-.199-.1-.5-.1-.799-.2-.5-.1-1-.2-1.4-.3s-.801-.3-1.2-.5c-.3-.2-.601-.5-.8-.8s-.301-.8-.301-1.3c0-1 .301-1.7 1-2.3.701-.5 1.601-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1.301 0 .5.1.701.2.299.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.901-.1-1.3-.1-.601 0-1.101.1-1.3.3q-.3.3-.301.9c0 .4.101.6.401.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.399.4.5.9.5 1.5m9.2 0q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1h.601c.6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.199-.5-.301-.2-.601-.5-.801-.8-.199-.3-.3-.8-.3-1.3 0-1 .3-1.7 1-2.3.701-.5 1.601-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.4.6l-.2.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.3-.1-.601 0-1.101.1-1.301.3q-.3.3-.3.9c0 .4.101.6.401.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.199.5c.301.2.601.5.801.9.399.4.5.9.5 1.5M223.8 66c0 .1 0 .2-.1.3 0 .1-.1.1-.299.1H222c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.401c.099 0 .199 0 .299.1 0 .1.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4s-.2.2-.4.3-.399.1-.6.1c-.299 0-.5 0-.6-.1-.199-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.4.201.7m8.599 7.5c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m2.3-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m10.401 5c-.101.1-.2.1-.3.1h-1.5c-.301 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.601-.5-1.2-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.4.2-.5.3V66c0 .3-.1.4-.4.4h-1.4c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.899-.1.701 0 1.201.1 1.601.3s.7.5.899.8c.201.3.301.8.401 1.2.099.5.099.9.099 1.5V66c.201.1.101.2.101.3m8.999.4h3.3V28h-3.3z"></path></g>', 24), I11 = [
  T11
];
function O11(t, e) {
  return T(), N("svg", F11, [...I11]);
}
const N11 = { render: O11 }, P11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, B11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="233" height="70" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70h232.5V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.2 39.5c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.799-.6h.801c.3 0 .6.1 1 .1.3 0 .699.1 1 .2l.9.3c.2.1.299.1.299.2s.101.2.101.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.701 0-1.201.1-1.6.4-.4.3-.7.6-1 1-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.599-.2h.401c.099.1.099.1.2.3l.2.8q.15.45-.301.6-.3.15-.899.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.701-.6c-.699-.4-1.299-.9-1.599-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m17.399 1.6c0-.5 0-1-.1-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.801.1-1 .2-.2.1-.5.3-.601.6-.2.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.1.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .1-.8.1-1.4m2.301-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.4-.5c-.6-.3-1-.7-1.3-1.3-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6.101-.6.3-1.1.601-1.6.3-.5.699-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.3 1.2s.5 1 .601 1.6c.099.6.2 1.2.2 1.8m16.3 5c0 .1-.101.1-.3.1h-1.4c-.3 0-.401-.1-.401-.4V40c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.1-.699.2-.2.1-.5.2-.7.3l-.601.3v6.7c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.301-1.4-.199-.3-.5-.4-1-.4-.199 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3L167 39v6.7c0 .3-.1.4-.401.4H165.2c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3c.301-.1.5-.1.801-.1.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.199-.4 1.9-.4 1.2.1 1.6.3.699.5.9.8c.2.3.299.7.4 1.2.1.5.1.9.1 1.4v5.9c-.1.2-.1.3-.1.4m4.701-.3c0 .1 0 .2-.101.3 0 .1-.099.1-.299.1H182.1c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.101.2.101.3zm.1-12.1v.5c0 .1-.1.3-.201.4-.099.1-.2.2-.399.3-.2.1-.4.1-.601.1-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.2-.4v-.4c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.101.1.201.4.201.7m9.699 9.5q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1a21 21 0 0 1-1.5-.3 1.4 1.4 0 0 1-.399-.3c-.101-.1-.101-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.199 0 .5.1.699.1.301 0 .5 0 .801.1.3 0 .5 0 .699.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.301-.2.401-.5.401-.9 0-.2 0-.4-.1-.6s-.1-.3-.2-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.699c.301 0 .5 0 .801.1.3.1.5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.201.7c0 .1-.099.2-.199.3h-.4c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8.301.2.701.2 1.301.3.5.1.9.2 1.4.3.4.1.799.3 1.2.5s.599.5.8.9c.299.4.4.9.4 1.5m4.3 2.6c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm.2-12.1v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m9-1.8c.2.1.2.3.1.4l-2 2.8c-.1.1-.201.2-.4.1l-.801-.4c-.099-.1-.199-.2-.099-.4l1.599-3.1c.101-.2.201-.2.401-.1zm-.4 9.3c0-.5 0-1-.1-1.4-.101-.4-.2-.7-.3-1-.2-.3-.4-.5-.7-.6s-.601-.2-1.101-.2c-.399 0-.799.1-1 .2-.199.1-.5.3-.599.6-.2.3-.3.6-.3 1-.101.4-.101.9-.101 1.4s0 1 .101 1.4c.1.4.2.7.3 1s.4.5.599.6c.201.1.601.2 1 .2.5 0 .801-.1 1.101-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.301 1.2-.6 1.7c-.3.5-.701.9-1.3 1.3-.6.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.3-1.3c-.301-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.299-.5 2.299-.5s1.801.1 2.301.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m10.401 5c-.101.1-.2.1-.301.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.3-1.4-.2-.4-.601-.5-1.2-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.401.2-.5.3v6.7c0 .3-.1.4-.401.4h-1.399c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.899-.1.701 0 1.201.1 1.601.3s.699.5.899.8.3.8.401 1.2c.099.5.099.9.099 1.5v5.8c.201 0 .201.1.101.2M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4V66c-.1.2-.2.4-.5.4m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m5.901-3.3c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9-.101-.3-.2-.5-.3-.8s-.301-.4-.6-.5c-.4-.2-.701-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8.199.2.4.3.699.4.301.1.601.1 1.101.1.399 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.601.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4-.601-.3-1-.7-1.3-1.1-.301-.5-.5-1-.6-1.6s-.201-1.2-.201-1.9c0-.5 0-1 .101-1.6.1-.6.3-1.2.6-1.7.299-.5.7-1 1.299-1.3.601-.4 1.301-.5 2.301-.5.9 0 1.6.1 2.199.4.601.3 1 .6 1.301 1s.5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.6.2-1 .2zm14.199-.1h-2.4c-.5 0-.901.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .399 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.401-.1-.6-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .899-2.6.601-.5 1.601-.8 2.801-.8h2.6v-.5c0-.3 0-.5-.1-.8-.101-.2-.2-.4-.301-.5l-.599-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.399c-.101 0-.101-.1-.2-.3l-.2-.7v-.3c.099-.1.2-.2.4-.3.199-.1.5-.1.8-.2s.599-.1.899-.1.601-.1.901-.1h.799q1.351 0 2.101.3c.5.2.899.4 1.199.7s.401.7.5 1.2c.101.5.101 1 .101 1.5v4.4c0 .1.099.2.099.3s.101.1.201.1c.099 0 .2 0 .4.1.1 0 .199 0 .3.1.099 0 .099.1.099.2v.8c0 .2-.2.4-.5.4-.2 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.401-.1-.601-.4-.7-.9m20.2 1.5h3.3V28h-3.3z"></path></g>', 24), V11 = [
  B11
];
function R11(t, e) {
  return T(), N("svg", P11, [...V11]);
}
const H11 = { render: R11 }, D11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, $11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="233" height="71" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.6h232.8V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.2.1c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6.199.6.199 1.2.199 1.8m8.401.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1H193c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6.1 1.3.1 2.1m7.9.5h-2.4c-.5 0-.9.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.4-.1-.6-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.101-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1H206c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.399c-.101 0-.101-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.599-.1.9-.1c.3 0 .6-.1.9-.1h.799q1.351 0 2.101.3c.5.2.899.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.099.2.099.3s.101.1.201.1.2 0 .4.1c.1 0 .2 0 .3.1s.099.1.099.2v.8c0 .2-.199.4-.5.4-.199 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.401-.1-.6-.4-.7-.9m-63.7 14.5 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V53.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm15.4 2c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m16.3 5c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1 0 .2-.1.3m4.7-.3c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.1-12.1v.5c0 .2-.1.3-.201.4-.099.1-.199.2-.399.3s-.4.1-.601.1c-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.199-.4V54c0-.3.1-.6.199-.8.201-.2.5-.3 1-.3s.801.1 1 .3c.201.1.201.4.201.7m9.8 9.5q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.899-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.399.6l-.199.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.301-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.401.8.3.1.699.2 1.3.3.5.1.899.2 1.399.3s.801.3 1.2.5c.3.2.601.5.8.9.4.4.5.9.5 1.5m4.7-9.5v.5c0 .2-.1.3-.2.4s-.199.2-.4.3c-.2.1-.4.1-.6.1-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.199-.4V54c0-.3.099-.6.199-.8.2-.2.5-.3 1-.3s.801.1 1 .3c.1.1.2.4.2.7m-.1 12.7c0 .7-.1 1.2-.2 1.7-.099.5-.4.9-.8 1.3-.4.3-.799.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.299-.1-.101-.1-.201-.2-.201-.3l-.1-.9V69c0-.1.1-.1.301-.1q.75-.15 1.199-.3c.301-.1.6-.2.801-.4.199-.1.299-.3.399-.6.101-.2.101-.5.101-.9V57c0-.3.099-.4.399-.4h1.4c.3 0 .4.1.4.4v9.6zm8.8-5.2c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m10.4 5c-.1.1-.199.1-.3.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.301-1.4-.199-.4-.6-.5-1.199-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.401.2-.5.3V66c0 .3-.101.4-.401.4H212c-.299 0-.4-.1-.4-.4v-9.1c0-.3.101-.4.4-.4h1.401c.3 0 .399.1.399.4v.6c.2-.1.401-.3.7-.4.3-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.899-.1.7 0 1.2.1 1.601.3.399.2.7.5.899.8s.301.8.4 1.2c.1.5.1.9.1 1.5V66q.151.15 0 .3m9.4.4h3.3V28h-3.3z"></path></g>', 24), U11 = [
  $11
];
function j11(t, e) {
  return T(), N("svg", D11, [...U11]);
}
const G11 = { render: j11 }, W11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, Y11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="235" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h235V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.2.1c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6.199.6.199 1.2.199 1.8m8.401.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1H193c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6.1 1.3.1 2.1m7.9.5h-2.4c-.5 0-.9.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.4-.1-.6-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.101-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1H206c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.399c-.101 0-.101-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.599-.1.9-.1c.3 0 .6-.1.9-.1h.799q1.351 0 2.101.3c.5.2.899.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.099.2.099.3s.101.1.201.1.2 0 .4.1c.1 0 .2 0 .3.1s.099.1.099.2v.8c0 .2-.199.4-.5.4-.199 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.401-.1-.6-.4-.7-.9m13.101 1.1c-.101.1-.2.1-.301.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.3-1.4-.2-.4-.601-.5-1.2-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.401.2-.5.3v6.7c0 .3-.1.4-.401.4h-1.399c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.899-.1.701 0 1.201.1 1.601.3s.699.5.899.8.3.8.401 1.2c.099.5.099.9.099 1.5v5.8c.101 0 .101.1.101.2M145.4 60.2l1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.1.1-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.5 1.2c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6s.199 1.2.199 1.8m16.301 5c0 .1-.101.1-.301.1H175.7c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1s-.5.1-.7.2-.5.2-.699.3l-.601.3V66c0 .1 0 .2-.099.3-.101.1-.2.1-.3.1h-1.5c-.2 0-.301-.1-.301-.4v-5.8c0-.6-.099-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3V66c0 .3-.101.4-.401.4H163.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.399c.3 0 .401.1.401.4v.6c.2-.1.399-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3.5-.1.8-.1c.601 0 1.101.1 1.601.3s.899.6 1.2 1.1c.5-.4 1.1-.7 1.699-1 .601-.3 1.2-.4 1.901-.4.7 0 1.2.1 1.599.3.401.2.7.5.901.8.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.7-.3c0 .1 0 .2-.1.3 0 .1-.099.1-.299.1H180.3c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4-.099.1-.2.2-.4.3-.199.1-.399.1-.6.1-.299 0-.5 0-.599-.1-.2-.1-.301-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.4.201.7m9.699 9.5q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.199-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.699-.5 1.6-.8 2.699-.8h.7c.3 0 .5 0 .8.1s.5.1.801.1c.3 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3h-.399c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8s.701.2 1.3.3c.5.1.901.2 1.401.3.4.1.799.3 1.2.5.399.2.599.5.8.9.299.4.4.9.4 1.5m9.199 0q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1.201.1.401 0 .6 0 .601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.2-.4a.77.77 0 0 0-.5-.2c-.199-.1-.5-.1-.8-.2-.5-.1-1-.2-1.399-.3-.401-.1-.801-.3-1.2-.5-.3-.2-.601-.5-.8-.8s-.301-.8-.301-1.3c0-1 .301-1.7 1-2.3.7-.5 1.601-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3h-.399c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.601 0-1.101.1-1.3.3q-.3.3-.301.9c0 .4.101.6.4.8s.701.2 1.3.3c.5.1.901.2 1.401.3.399.1.799.3 1.2.5.399.2.599.5.8.9.299.4.399.9.399 1.5M205.5 66c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm.1-12.1v.5c0 .2-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m8.6 7.5c0-.5 0-1-.101-1.4a12 12 0 0 0-.299-1c-.201-.3-.4-.5-.701-.6-.299-.1-.599-.2-1.099-.2-.401 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.301.6-.301 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.301 1s.4.5.6.6.599.2 1 .2c.5 0 .8-.1 1.099-.2.301-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.1 1.8s-.301 1.2-.6 1.7c-.3.5-.701.9-1.3 1.3-.6.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.3-1.3c-.301-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.299-.5 2.299-.5s1.801.1 2.301.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m15.2 5.4h3.3V28h-3.3z"></path></g>', 24), X11 = [
  Y11
];
function K11(t, e) {
  return T(), N("svg", W11, [...X11]);
}
const Z11 = { render: K11 }, J11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, Q11 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.6-.3 3.2-.6 4.7-1 3.1-.8 6.1-2.2 8.8-4q4.05-3 7.2-6.9c1.6-2 3.1-4 4.5-6.2V0c-1.5 2.4-3.2 4.6-5.1 6.7q-3.15 3.6-7.2 6.3c-2.6 1.7-5.5 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.7 1.5-5.6 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.5-.2 3.1-.5 4.6-.8 3.1-.6 6.2-1.8 8.9-3.5 2.7-1.8 5.2-3.9 7.3-6.4 1.5-1.7 3.2-4 4.8-6.2v-1c-1.7 2.3-3.5 4.5-5.4 6.5-2.1 2.4-4.5 4.5-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.3 2.1-4.8 3.9-7.5 5.3-2.7 1.3-5.6 2.2-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.1-.5 6.1-1.5 8.9-2.9q4.35-2.4 7.8-6c1.8-1.8 3.4-3.8 4.9-5.8v-.9q-2.7 3.3-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.2 1.4-4.7 2.2-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3-.3 6-1 8.9-2.1s5.6-2.7 8-4.6c2-1.5 3.9-3.3 5.6-5.2v-.9q-2.55 2.7-5.7 4.8c-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.8.8-5.7 1.3-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3-.3 5.9-.9 8.8-1.8s5.7-2.2 8.2-3.9c2.1-1.3 4.1-2.8 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.6 1.5-5.3 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.8.7-5.7 1.1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3-.2 5.9-.7 8.8-1.5q4.35-1.2 8.4-3.3c2.2-1.2 4.3-2.5 6.2-4v-1.1c-2.1 1.6-4.4 2.9-6.7 4.1-2.6 1.4-5.3 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.8.5-5.7.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3q4.35-.3 8.7-1.2c2.9-.6 5.8-1.5 8.5-2.7 2.3-1 4.5-2.1 6.6-3.4v-1c-2.2 1.3-4.6 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.5-9.4.8-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.1 9.5-.5 14.2-1.1 2.9-.5 5.7-1.2 8.5-2.1 2.3-.8 4.6-1.7 6.8-2.9v-1c-2.3 1.1-4.7 2-7.2 2.8-2.7.8-5.5 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 2.9-.3 5.8-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.4.9-4.9 1.6-7.4 2.2-2.8.6-5.6 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1L0 60.2v2.6l32.9-.3 8.6-.1c2.9 0 5.7-.1 8.6-.2 5.4-.1 10.8-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.2 2-4.8 3.5-7.5 4.7-2.8 1-5.8 1.7-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.1-.4 6.1-1.3 8.9-2.6 2.9-1.4 5.6-3.2 8-5.3 1.8-1.7 3.6-3.4 5.2-5.3v-.9c-1.9 2-3.8 3.8-5.9 5.6m34-22 14.1 22.4c2.2 3.5 4.7 6.2 13.5 8.1s12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6l-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7L94.3 25z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3s12.7 2.1 12.7 2.1v.7l-12.7-2.1c-6-1-9.9-1.3-13.5-4.3-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11 5.1 3.5 13.5 4.8l12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7s12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3-8.8-.9-13.5-3c-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c4.3 1.7 8.9 2.6 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1-8.6-.8-13.5-2.4-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1c4.4 1.2 8.9 1.9 13.5 2.3l12.7 1v.6l-12.7-.9c-4.5-.2-9-.7-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3s12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1S94.3 10.9 94.3 10.9v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="258" height="70" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70h257.5V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M254.2 66.7h3.3V28h-3.3zm-111-27.2c0-.8.1-1.7.2-2.5s.4-1.5.8-2.2 1-1.2 1.6-1.6c.9-.4 1.799-.6 2.799-.6h.801c.3 0 .6 0 1 .1.3 0 .699.1 1 .2l.9.3c.1 0 .2.1.299.2.101.1.101.3.101.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0l-1.6-.2c-.6 0-1.1-.1-1.6-.1-.6 0-1.1.1-1.6.4-.4.2-.7.6-.9 1-.201.5-.4 1-.4 1.5-.1.6-.1 1.2-.1 1.9 0 .6 0 1.2.1 1.8.1.5.199 1 .5 1.5.199.4.5.8.9 1 .5.3 1 .4 1.6.4.5 0 1.1 0 1.6-.1l1.5-.1h.4c.1.1.1.2.199.3l.201.8c.1.3-.1.5-.3.6l-.901.3c-.299.1-.699.1-1 .2-.299.1-.699.1-1 .1h-.899c-.9 0-1.9-.2-2.7-.6-.7-.4-1.2-.9-1.6-1.5-.4-.7-.7-1.4-.8-2.2-.3-.8-.4-1.6-.4-2.4m17.5 1.6c0-.5 0-.9-.101-1.4 0-.4-.099-.7-.299-1-.201-.3-.4-.5-.701-.6-.299-.2-.699-.2-1.099-.2-.3 0-.7.1-1 .2q-.45.15-.6.6c-.2.3-.301.6-.301 1-.099.5-.099.9-.099 1.4s0 .9.099 1.4c0 .4.201.7.301 1s.4.5.6.6c.3.1.7.2 1 .2.4 0 .8-.1 1.099-.2.301-.1.5-.3.701-.6s.299-.6.299-1 .101-.9.101-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.8 1-1.3 1.3c-.801.4-1.6.5-2.4.5s-1.6-.1-2.401-.5c-.5-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.299-1.1.6-1.6c.3-.5.8-1 1.3-1.3.7-.4 1.5-.5 2.3-.5s1.599.1 2.3.4c.5.3 1 .7 1.299 1.2.301.5.5 1 .601 1.6s.2 1.2.2 1.8m16.3 5c0 .1-.101.1-.3.1h-1.4c-.2 0-.401-.1-.401-.3V40c.101-.5-.099-1-.299-1.5-.3-.3-.701-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.2-.699.2-.2.1-.5.2-.7.3l-.601.3v6.7c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.5-.1-.9-.301-1.4-.199-.3-.599-.5-1-.5-.199 0-.399 0-.599.1s-.5.1-.7.2c-.201.1-.5.2-.701.3l-.599.3v6.7c0 .2-.1.4-.3.4h-1.601c-.199 0-.399-.1-.399-.4v-9.1c0-.3.1-.4.399-.4h1.401c.2 0 .4.1.4.3v.7l.6-.4c.2-.1.5-.3.7-.4.3-.1.5-.2.8-.3s.5-.1.8-.2c.5 0 1.1.1 1.6.3s.9.6 1.199 1.1c.5-.4 1.101-.7 1.701-1s1.2-.4 1.9-.4c.5 0 1.1.1 1.6.3.4.2.7.5.9.8.2.4.3.8.399 1.2.101.5.101.9.101 1.4zm16.5 0c-.101.1-.2.1-.3.1H194c-.2 0-.401-.1-.401-.3V40c.101-.5-.099-1-.299-1.5-.3-.3-.701-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.2-.699.2-.2.1-.5.2-.7.3l-.601.3v6.7c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.5-.1-.9-.301-1.4-.199-.3-.599-.5-1-.5-.199 0-.399 0-.599.1s-.5.1-.7.2c-.201.1-.5.2-.701.3l-.599.3v6.7c0 .2-.1.4-.3.4h-1.5c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.399c.201 0 .401.1.401.3v.7l.599-.4c.201-.1.5-.3.701-.4.299-.1.5-.2.799-.3.301-.1.5-.1.801-.1.5 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.199-.4 1.9-.4c.5 0 1.1.1 1.6.3.4.2.699.5.9.8.2.4.299.8.4 1.2.1.5.1.9.1 1.4v5.9c0 .3 0 .4-.1.5m4.701-.3c0 .1 0 .2-.101.3-.099.1-.2.1-.299.1H198.6c-.3 0-.399-.1-.399-.4v-9.1c0-.2.099-.4.399-.4h1.401c.099 0 .2 0 .299.1.101.1.101.2.101.3zm.1-12.1v.5c0 .1-.1.3-.201.4-.099.1-.2.2-.399.2-.2.1-.4.1-.601.1s-.399 0-.599-.1c-.101-.1-.3-.1-.401-.3-.099-.1-.099-.2-.2-.4v-.4c0-.3.101-.6.2-.8.3-.3.601-.4 1-.3.5 0 .8.1 1 .3.3.2.3.5.201.8m9.699 9.5c0 .5-.101 1-.4 1.5-.201.4-.5.8-.9 1s-.801.4-1.301.5-1 .2-1.5.2-1.099 0-1.599-.1c-.5 0-1-.2-1.5-.3-.2 0-.3-.1-.401-.3v-.4l.101-.7c0-.2.1-.3.2-.3h.4l.7.1.8.1h1.299c.5 0 1-.1 1.401-.3.3-.2.4-.5.4-.9 0-.2 0-.4-.1-.6 0-.1-.1-.3-.201-.4a.76.76 0 0 0-.5-.2c-.299-.1-.5-.1-.799-.2-.5-.1-1-.2-1.4-.3s-.801-.3-1.2-.5c-.3-.2-.601-.5-.8-.8a3.1 3.1 0 0 1-.301-1.3c-.099-.9.301-1.7 1-2.3.801-.5 1.801-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1.201 0 .5.1.701.2.299.1.5.3.4.6l-.2.7c0 .1-.1.2-.1.3h-.4l-1.401-.2c-.5 0-.899-.1-1.299-.1s-.9 0-1.3.3q-.3.3-.3.9c0 .3.1.6.399.8.401.2.901.3 1.301.3.5.1.9.2 1.4.3.4.1.799.3 1.1.5.3.2.6.5.8.9.5.6.6 1.1.5 1.6m9.2 0q0 .75-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1c-.5 0-1-.2-1.5-.3-.2 0-.299-.1-.399-.3v-.4l.1-.7c0-.2.099-.3.2-.3h.399l.7.1.8.1h1.301c.5 0 1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6 0-.1-.099-.3-.199-.4a.76.76 0 0 0-.5-.2c-.301-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.2-1.2-.5-.3-.2-.6-.5-.8-.8-.2-.4-.3-.9-.3-1.3-.101-.9.3-1.7 1-2.3.8-.5 1.8-.8 2.699-.8h.7c.3 0 .5 0 .8.1.301 0 .5.1.801.1.199 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1 0 .2-.099.3h-.401l-1.399-.2c-.5 0-1-.1-1.301-.1-.399 0-.899 0-1.3.3q-.3.3-.299.9c0 .3.099.6.4.8.399.2.899.3 1.3.3.5.1.899.1 1.399.3.401.1.801.3 1.101.5s.599.5.8.9c.4.6.5 1.1.4 1.6m4.4 2.6c0 .1 0 .2-.1.3s-.2.1-.299.1H222c-.3 0-.4-.1-.4-.4v-9.1c0-.2.1-.4.4-.4h1.401c.099 0 .199 0 .299.1s.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4s-.2.2-.4.2c-.2.1-.399.1-.6.1s-.4 0-.6-.1c-.1-.1-.3-.1-.4-.3-.1-.1-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.3-.3.6-.4 1-.3.5 0 .8.1 1 .3.201.2.3.5.201.8m8.699 7.5c0-.5 0-.9-.1-1.4 0-.4-.099-.7-.299-1-.201-.3-.401-.5-.701-.6-.299-.2-.7-.2-1.099-.2-.301 0-.7.1-1 .2a.9.9 0 0 0-.601.6c-.2.3-.3.6-.3 1-.099.5-.099.9-.099 1.4s0 .9.099 1.4c0 .3.1.7.3 1 .101.3.401.5.601.6.3.1.699.2 1 .2.399 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .1-.9.1-1.4m2.2-.1c0 .6 0 1.2-.099 1.8-.101.6-.3 1.2-.601 1.7-.3.5-.8 1-1.3 1.3-.8.4-1.599.5-2.399.5-.801 0-1.601-.1-2.401-.5-.5-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.101-.6-.101-1.2-.101-1.8 0-.5 0-1 .101-1.6a4.4 4.4 0 0 1 .599-1.6c.3-.5.8-1 1.3-1.3.7-.4 1.5-.5 2.301-.5.8 0 1.599.1 2.3.4.5.3 1 .6 1.299 1.1.3.5.5 1 .6 1.6.101.7.2 1.3.2 1.9m10.401 5c-.101.1-.2.1-.3.1h-1.5c-.2 0-.4-.1-.4-.3v-5.7c0-.5-.1-1-.3-1.4s-.7-.6-1.101-.5c-.199 0-.5 0-.699.1-.301.1-.5.2-.801.3l-.699.3-.5.2v6.7c0 .2-.1.4-.301.4h-1.599c-.2 0-.401-.1-.401-.3v-9.2c0-.2.101-.4.301-.4h1.5c.199 0 .4.1.4.4v.6h.1c.199-.2.4-.3.699-.4.301-.1.5-.3.801-.4l.9-.3c.299-.1.6-.1.9-.1.6 0 1.1.1 1.6.3.4.2.7.5.9.8.2.4.3.8.399 1.2.101.5.101 1 .101 1.5v5.8q.15.15 0 .3M147.2 58.1c-.3 0-.601 0-.9.2-.201.1-.4.3-.6.5s-.3.5-.3.8c-.1.3-.1.7-.1 1h4c0-.3 0-.6-.1-.9 0-.3-.101-.5-.3-.8-.1-.2-.4-.4-.6-.5-.4-.2-.8-.3-1.1-.3m-2 3.9c0 .4.1.8.2 1.3.1.3.2.6.4.8s.5.3.7.4c.3.1.7.1 1.099.1.401 0 .801 0 1.301-.1l1.3-.2h.399c.101 0 .101.2.201.3l.1.7v.4l-.301.3c-.199.1-.5.2-.699.2-.301.1-.6.1-.801.2l-.899.1h-.8c-.801 0-1.6-.1-2.3-.4-.5-.2-1-.6-1.3-1-.3-.5-.5-1-.6-1.6s-.2-1.3-.1-1.9c0-.5 0-1.1.1-1.6.1-.6.3-1.2.6-1.7s.8-1 1.3-1.3c.7-.4 1.499-.6 2.3-.5.699 0 1.5.1 2.199.4.5.2 1 .6 1.301 1q.45.6.6 1.5c.099.5.2 1.1.2 1.6 0 .3 0 .6-.2.9-.2.2-.5.4-.8.3zm16.201 4.3h-1.4c-.1 0-.201 0-.3-.1-.101-.1-.101-.2-.101-.3v-.6c-.199.1-.399.3-.699.4-.301.1-.5.3-.801.4l-.899.3c-.3.1-.601.1-.901.1a4.1 4.1 0 0 1-1.599-.3c-.401-.2-.7-.4-.901-.8-.2-.4-.299-.8-.399-1.2-.101-.5-.101-1-.101-1.5v-5.9c0-.2.101-.4.3-.4h1.601c.2 0 .399.1.399.4v5.6c0 .3 0 .5.101.8 0 .2.099.4.2.6.1.2.3.3.399.4.201.1.5.2.701.2s.5 0 .7-.1c.3-.1.5-.1.8-.2l.7-.3.5-.2v-6.7c0-.1 0-.2.099-.3.101-.1.201-.1.3-.1h1.401c.299 0 .4.1.4.4v9c.1.2 0 .4-.2.4q-.15.15-.3 0m5.099-.3c0 .2-.1.4-.3.4h-1.5c-.2 0-.4-.1-.4-.3V57c0-.2.1-.4.3-.4h1.5c.2 0 .4.1.4.3v1c.2-.2.4-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.3c.3-.1.5-.2.8-.2h.3c.1 0 .1.2.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.5.1-.8.1l-.8.2c-.2.1-.4.1-.6.2zm11-4.6c0-.5 0-.9-.1-1.4 0-.4-.2-.7-.3-1-.2-.3-.4-.5-.7-.6-.3-.2-.7-.2-1.1-.2s-.7.1-1.1.2q-.45.15-.6.6c-.2.3-.3.6-.3 1-.1.5-.1.9-.1 1.4s0 .9.1 1.4c0 .3.1.7.3 1 .1.3.4.5.6.6.3.2.7.2 1.1.2s.8-.1 1.1-.2.5-.3.7-.6.3-.6.3-1c.1-.4.1-.9.1-1.4m2.3-.1c0 .6 0 1.2-.1 1.8s-.2 1.2-.6 1.7c-.3.5-.8 1-1.3 1.2-.8.4-1.6.5-2.4.5s-1.6-.1-2.3-.5c-.5-.3-1-.7-1.3-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5.1-1 .1-1.6.1-.6.3-1.1.6-1.6s.8-1 1.3-1.3c.7-.4 1.5-.5 2.3-.5s1.6.1 2.3.4c.5.3 1 .7 1.3 1.2s.5 1 .6 1.6c0 .7.1 1.3.1 1.9m8.3.1c0-.5 0-1-.1-1.5q0-.45-.299-.9c-.101-.2-.3-.4-.5-.4-.201-.1-.5-.1-.701-.1s-.5 0-.7.1-.5.1-.8.2c-.2.1-.5.2-.7.3l-.599.3v5l1.2.3c.399 0 .699.1 1.099.1.3 0 .6 0 .901-.2.3-.1.5-.3.599-.5.201-.3.3-.6.3-1 .3-.7.3-1.2.3-1.7m2.301 0c0 .7-.101 1.5-.2 2.2a4.4 4.4 0 0 1-.601 1.6c-.3.4-.699.8-1.199 1a3.4 3.4 0 0 1-2 .3c-.401 0-.801 0-1.2-.1-.5-.1-.901-.2-1.401-.3v3.5c0 .1 0 .2-.099.3 0 .1-.101.1-.3.1H182c-.2 0-.299 0-.299-.1-.101-.1-.101-.2-.101-.3V56.9c0-.3.101-.4.4-.4h1.401c.099 0 .199 0 .3.1 0 .1.099.2.099.3v.6h.101c.199-.1.399-.3.599-.4.3-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.899-.1.601 0 1.101.1 1.601.4.399.2.799.6 1 1 .299.5.399 1 .5 1.6.099.7.2 1.4.2 2.1m8.5-9.3c.199.1.199.3.1.5l-2 2.8c-.1.1-.201.2-.401.1l-.8-.4c-.099-.1-.2-.2-.099-.4l1.599-3.1c.101-.2.201-.2.401-.1zm-2.601 6c-.299 0-.599 0-.899.2-.2.1-.4.3-.601.5s-.299.5-.299.8c-.1.3-.1.7-.1 1h4c0-.3 0-.6-.101-.9 0-.3-.099-.5-.299-.8-.1-.2-.401-.4-.6-.5-.4-.2-.801-.3-1.101-.3m-2 3.9c0 .4.101.8.201 1.3.099.3.2.6.4.8.199.2.5.3.8.4s.7.1 1.099.1c.401 0 .8 0 1.3-.1l1.301-.2h.399c.101 0 .101.2.101.3l.1.7v.4q0 .15-.3.3c-.2.1-.5.2-.7.2-.3.1-.6.1-.901.2l-.899.1h-.8c-.801 0-1.601-.1-2.301-.4-.5-.2-1-.6-1.3-1-.299-.5-.5-1-.599-1.6-.101-.6-.2-1.3-.101-1.9 0-.5 0-1.1.101-1.6.099-.6.3-1.2.599-1.7.3-.6.8-1 1.3-1.3.7-.4 1.5-.6 2.301-.5.699 0 1.5.1 2.199.4.5.2.901.6 1.301 1q.45.6.6 1.5c.099.5.2 1.1.2 1.6 0 .3 0 .6-.2.9-.201.2-.5.4-.8.3zm12.2-3.9c-.3 0-.6 0-.9.2-.2.1-.4.3-.6.5s-.3.5-.3.8c-.1.3-.1.7-.1 1h4c0-.3 0-.6-.1-.9 0-.3-.1-.5-.3-.8-.1-.2-.4-.4-.6-.5-.4-.2-.8-.3-1.1-.3m-2 3.9c0 .4.1.8.2 1.3.1.3.2.6.4.8s.5.3.7.4c.3.1.7.1 1.1.1s.8 0 1.3-.1l1.3-.2h.4c.1 0 .1.2.1.3l.1.7v.4q0 .15-.3.3c-.2.1-.5.2-.7.2-.3.1-.6.1-.8.2l-.9.1h-.8c-.8 0-1.6-.1-2.3-.4-.5-.2-1-.6-1.3-1-.3-.5-.5-1-.6-1.6s-.2-1.3-.1-1.9c0-.5 0-1.1.1-1.6.1-.6.3-1.2.6-1.7s.7-1 1.3-1.3c.7-.4 1.5-.6 2.3-.5.7 0 1.5.1 2.2.4.5.2.9.6 1.3 1q.45.6.6 1.5c.1.5.2 1.1.2 1.6 0 .3 0 .6-.2.9-.2.2-.5.4-.8.3zm16.5 4.2c-.1.1-.2.1-.3.1h-1.5c-.2 0-.4-.1-.4-.3v-5.7c0-.5-.1-1-.3-1.4s-.7-.6-1.1-.5c-.2 0-.5 0-.7.1-.3.1-.5.2-.8.3l-.7.3-.5.2V66c0 .2-.1.4-.3.4h-1.5c-.2 0-.4-.1-.4-.3V57c0-.3.1-.4.4-.4h1.4c.2 0 .4.1.4.4v.6h.1c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.6 0 1.1.1 1.6.3.4.2.7.5.9.8.2.4.3.8.4 1.2.1.5.1 1 .1 1.5V66c0 .1-.1.2-.1.2m10.6 0c-.1.1-.199.1-.3.1h-1.5c-.2 0-.399-.1-.399-.3v-5.7c0-.5-.101-1-.301-1.4s-.699-.6-1.1-.5c-.2 0-.5 0-.7.1-.3.1-.5.2-.8.3l-.7.3-.5.2V66c0 .2-.099.4-.3.4h-1.5c-.2 0-.4-.1-.4-.3V57c0-.3.101-.4.4-.4h1.401c.199 0 .399.1.399.3v.7h.101c.199-.2.399-.3.699-.4.301-.1.601-.3.801-.4l.899-.3c.3-.1.601-.1.901-.1.599 0 1.099.1 1.599.3.401.2.7.5.901.8.2.4.299.8.399 1.2.101.5.101 1 .101 1.5V66c0 .1 0 .2-.101.2m6.2-8.1c-.3 0-.6 0-.899.2-.201.1-.401.3-.601.5s-.3.5-.3.8c-.099.3-.099.7-.099 1h4c0-.3 0-.6-.101-.9 0-.3-.1-.5-.3-.8-.099-.2-.4-.4-.599-.5-.301-.2-.701-.3-1.101-.3m-2 3.9c0 .4 0 .9.2 1.3.1.3.2.6.401.8.199.2.5.3.799.4s.701.1 1.1.1.8 0 1.3-.1l1.301-.2h.399c.101 0 .101.2.101.3l.099.7v.4q0 .15-.3.3c-.2.1-.5.2-.7.2-.3.1-.599.1-.9.2l-.9.1h-.799c-.801 0-1.601-.1-2.301-.4-.5-.2-1-.6-1.3-1.1s-.5-1-.6-1.6-.2-1.3-.1-1.9c0-.5 0-1.1.1-1.6.1-.6.3-1.2.6-1.7s.7-1 1.3-1.3c.7-.4 1.5-.6 2.301-.5.699 0 1.5.1 2.199.4.5.2.9.6 1.301 1 .299.4.599.9.699 1.5.1.5.2 1.1.2 1.6 0 .3 0 .6-.2.9-.199.2-.5.4-.8.3z"></path></g>', 24), e21 = [
  Q11
];
function t21(t, e) {
  return T(), N("svg", J11, [...e21]);
}
const n21 = { render: t21 }, i21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, s21 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="266" height="70" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70h265.5V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="m148.6 38-.8-2.9h-.099l-.8 2.8-.801 2.9h3.4zm-4 7.6c-.1.2-.1.3-.2.3-.1.1-.199.1-.3.1h-1.6c-.2 0-.299-.1-.2-.4l4.101-12.5c.099-.1.099-.3.199-.3.101-.1.2-.1.4-.1h1.701c.2 0 .299 0 .399.1s.101.2.2.3l4.101 12.5c.099.2 0 .4-.2.4h-1.8c-.2 0-.301 0-.301-.1-.1-.1-.1-.2-.199-.3l-.801-2.9h-4.5zm18.5.4c-.1.1-.199.1-.3.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.301-1.4-.199-.4-.6-.5-1.199-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.401.2-.5.3v6.7c0 .3-.101.4-.401.4H155c-.299 0-.4-.1-.4-.4v-9.1c0-.3.101-.4.4-.4h1.401c.3 0 .399.1.399.4v.6c.2-.1.401-.3.7-.4.3-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.899-.1.7 0 1.2.1 1.601.3.399.2.7.5.899.8s.301.8.4 1.2c.1.5.1.9.1 1.5v5.8c.101 0 .101.1 0 .2m8-6.5c0-.9.101-1.7.2-2.5.101-.8.401-1.6.8-2.2.4-.6.9-1.2 1.601-1.6.7-.4 1.599-.6 2.799-.6h.8c.3 0 .601.1 1 .1.3 0 .7.1 1 .2l.901.3c.2.1.299.1.299.2s.1.2.1.4l-.199.8c0 .1-.101.2-.101.3-.099.1-.2.1-.399 0-.5-.1-1-.1-1.601-.2-.599-.1-1.099-.1-1.599-.1-.701 0-1.201.1-1.601.4s-.699.6-1 1c-.3.4-.399 1-.399 1.5-.101.6-.101 1.2-.101 1.9s0 1.3.101 1.8c.099.6.2 1.1.5 1.5.2.4.5.8 1 1 .399.2.899.4 1.599.4.601 0 1.101 0 1.601-.1s1-.1 1.599-.2h.401c.099.1.099.1.199.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.699.1-1 .2-.3.1-.699.1-1 .1h-.899q-1.65 0-2.701-.6c-.7-.4-1.299-.9-1.599-1.5-.401-.6-.7-1.3-.801-2.1-.1-.8-.5-1.5-.5-2.4m17.4 1.6c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m4.5 4.7c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.1-12.1v.5c0 .2-.1.3-.201.4-.099.1-.199.2-.399.3s-.4.1-.601.1c-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.199-.4v-.4c0-.3.1-.6.199-.8.201-.2.5-.3 1-.3s.801.1 1 .3c.101.1.201.4.201.7M212 46c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1H204c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4H198c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4c.3-.1.5-.2.8-.3s.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c-.1.2-.1.3-.1.4m4.7-.3c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.1-12.1v.5c0 .2-.1.3-.201.4-.099.1-.199.2-.399.3s-.4.1-.601.1c-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.199-.4v-.4c0-.3.1-.6.199-.8.201-.2.5-.3 1-.3s.801.1 1 .3c.101.1.201.4.201.7m9.7 9.5q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.3 2.6c0 .1 0 .2-.1.3 0 .1-.1.1-.299.1H229c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.401c.099 0 .199 0 .299.1 0 .1.1.2.1.3zm.2-12.1v.5c0 .1-.099.3-.2.4-.1.1-.2.2-.399.3-.201.1-.401.1-.601.1-.3 0-.5 0-.6-.1-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.101.1.2.4.2.7m9-1.8c.2.1.2.3.1.4l-2 2.8c-.1.1-.2.2-.4.1l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.2-.2.4-.1zm1.8 13.9c0 .3-.1.4-.4.4H240c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4zm10.601.3c-.101.1-.2.1-.301.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.3-1.4-.2-.4-.601-.5-1.2-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.401.2-.5.3v6.7c0 .3-.1.4-.401.4h-1.399c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.899-.1.701 0 1.201.1 1.601.3s.699.5.899.8.3.8.401 1.2c.099.5.099.9.099 1.5v5.8c.201 0 .201.1.101.2M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm16.6 8c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1 .1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m4.6 4.7c0 .3-.1.4-.399.4h-1.5c-.301 0-.401-.1-.401-.4v-9.1c0-.3.1-.4.401-.4h1.399c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.801-.4c.299-.1.5-.2.799-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.399.2-.301.1-.601.1-.901.2s-.599.2-.9.2c-.3.1-.6.2-.8.3s-.5.2-.6.2zm11.1-4.6c0-.6 0-1.2-.101-1.5q-.15-.6-.299-.9c-.1-.2-.3-.4-.5-.4-.201-.1-.401-.1-.701-.1-.2 0-.399 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.599.3v5q.75.15 1.2.3c.3.1.7.1 1.099.1.401 0 .701-.1.901-.2s.399-.3.599-.5c.201-.3.3-.6.3-1 .301-.6.301-1.1.301-1.7m2.3 0c0 .8-.101 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6-.301.4-.7.8-1.2 1s-1.2.3-2 .3c-.3 0-.7 0-1.2-.1s-.901-.2-1.401-.3v3.5c0 .1 0 .2-.099.3-.1.1-.201.1-.3.1h-1.401c-.2 0-.299 0-.299-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.399-.4h1.401c.099 0 .2 0 .3.1s.099.2.099.3v.6h.101c.2-.1.399-.2.599-.4.201-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.9-.1.699 0 1.199.1 1.6.4.4.2.799.6 1 1s.4 1 .5 1.6.2 1.3.2 2.1m7.8.5h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c.1-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m12.101.2v.4c0 .1-.2.2-.3.3-.4.2-.9.3-1.4.4-.6.1-1.1.1-1.6.1-.9 0-1.7-.1-2.301-.4-.599-.3-1-.7-1.299-1.1-.3-.5-.5-1-.6-1.6-.101-.6-.101-1.3-.101-2 0-.6.101-1.2.201-1.8s.299-1.2.6-1.6c.3-.5.699-.9 1.3-1.2.6-.3 1.3-.4 2.2-.4h.8c.3 0 .5 0 .8.1.3 0 .5.1.8.2.299.1.5.1.7.2q.3.15.3.6l-.1.8c0 .1-.101.2-.2.3h-.401c-.399 0-.799-.1-1.299-.1s-.8-.1-1.201-.1c-.799 0-1.399.2-1.699.7s-.5 1.3-.5 2.4c0 .6 0 1.1.1 1.6.099.4.2.7.4 1 .199.3.4.4.699.5.301.1.601.2 1 .2.301 0 .701 0 1.201-.1.5 0 1-.1 1.4-.1h.399c.101 0 .101.1.201.3zm9.699 1h-1.4c-.3 0-.401-.1-.401-.4v-5.8c0-.6-.099-1-.3-1.4-.2-.3-.599-.5-1.2-.5-.199 0-.399 0-.699.1-.301.1-.5.2-.801.3-.3.1-.5.2-.699.3-.2.1-.4.2-.5.2V66c0 .1 0 .2-.101.3-.099.1-.2.1-.299.1h-1.401c-.199 0-.399-.1-.399-.4V52.6c0-.3.099-.4.399-.4h1.401c.299 0 .4.1.4.4v4.9c.199-.1.399-.2.6-.4s.5-.2.799-.4l.901-.3c.3-.1.599-.1.899-.1.7 0 1.2.1 1.601.3.399.2.7.5.899.8s.301.8.401 1.2c.099.5.099.9.099 1.5V66c.2.2.101.4-.199.4m52.3.3h3.3V28h-3.3z"></path></g>', 24), l21 = [
  s21
];
function r21(t, e) {
  return T(), N("svg", i21, [...l21]);
}
const a21 = { render: r21 }, o21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "66",
  fill: "none",
  viewBox: "0 0 290 66"
}, c21 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M43.455 66h3.3V27.3h-3.3z" clip-rule="evenodd"></path><path fill="#fff" d="M147.499 33.238v8.404h-2.246v-8.428q0-2.15-.91-3.039-.898-.888-3.121-.888h-5.657V27.3h5.694q2.234 0 3.606.608 1.371.596 2.003 1.905.631 1.298.631 3.425m-9.457-.912v9.316h-2.234v-9.316zm-6.326.526v8.79h-6.811v-1.987h4.577V33.46q0-1.894-.194-2.677-.194-.806-.68-1.145-.474-.35-1.372-.35h-1.639V27.3h1.566q1.943 0 2.841.514.898.526 1.299 1.719.413 1.18.413 3.32m-8.753 6.942v1.847h-11.461v-1.987h8.68L110.603 27.3h2.793l4.625 6.055q.936-.386 1.36-1.134.425-.76.571-2.314l.279-2.607h2.307l-.243 2.56q-.158 1.612-.498 2.478a3.7 3.7 0 0 1-.959 1.414q-.62.56-1.748.994zM107.859 27.3v7.54h-2.233V27.3zm-4.722 12.355v1.987H90.134v-1.987h9.154v-6.44q0-2.15-.91-3.04-.9-.888-3.12-.888h-4.553V27.3h4.577q3.35 0 4.795 1.38 1.445 1.378 1.445 4.558v6.417zM87.026 27.3v14.342h-2.234V27.3zM70.502 39.421q-.413 1.18-1.311 1.707-.899.514-2.829.514h-.133v-1.987h.206q.838 0 1.335-.304.486-.304.693-.923.206-.631.206-1.906v-7.235h-2.307V27.3h8.05q3.35 0 4.807 1.38 1.457 1.366 1.457 4.558v8.404h-2.234v-8.428q0-2.15-.91-3.039-.899-.888-3.145-.888h-3.484v6.803q0 2.15-.4 3.331m76.996 18.159v8.404h-2.223v-8.428q0-2.15-.902-3.039-.89-.888-3.089-.888h-5.601v-1.987h5.637q2.212 0 3.57.608 1.358.596 1.983 1.905.625 1.297.625 3.425m-9.363-.912v9.316h-2.212v-9.316zm-15.65 4.605-.961 4.71h-2.332l1.009-4.663q.433-2.01.794-2.828.36-.83.901-1.345.553-.515 1.479-.876l-3.474-4.629h2.728l5.421 7.259a6 6 0 0 0 1.431-1.976q.54-1.169.709-2.676l.276-2.607h2.284l-.276 2.56q-.133 1.286-.481 2.256-.24.666-.577 1.274-.337.596-.866 1.239-.516.643-1.346 1.437l4.339 5.576h-2.812l-6.347-8.38q-.961.455-1.37 1.577-.12.293-.252.818-.12.527-.277 1.274m-6.178-9.631v7.54h-2.212v-7.54zm-6.274 5.938v8.404h-2.224v-8.428q0-2.127-.889-3.027-.878-.9-3.089-.9h-4.508v-1.987h4.532q2.211 0 3.57.608 1.358.596 1.983 1.905.625 1.297.625 3.425m-13.27-5.938v14.342h-2.212V51.642zm-7.909 6.37q0-2.209-.998-3.296-.997-1.087-3.137-1.087h-3.317v4.044h2.92v1.987h-5.168v-8.018h5.59q3.22 0 4.783 1.566 1.575 1.555 1.575 4.851v.959q0 6.966-6.78 6.966h-5.036v-1.987h5.097q2.283 0 3.377-1.227 1.094-1.24 1.094-3.73zm-14.015-6.37v7.54h-2.212v-7.54zM58.986 63.763q-.408 1.18-1.298 1.706-.89.515-2.8.515h-.133v-1.987h.204q.83 0 1.323-.304.48-.304.685-.923.204-.631.204-1.906V53.63h-2.284v-1.987h7.97q3.317 0 4.76 1.38 1.441 1.366 1.442 4.558v8.404h-2.212v-8.428q0-2.15-.901-3.039-.89-.888-3.114-.888h-3.45v6.803q0 2.15-.396 3.331m96.513-39.412s39.8-5.168 41-5.367c1.7-.298 3.3-.596 4.7-.994 3.2-.895 6.2-2.187 8.8-3.976 2.5-1.69 4.9-4.175 7.2-6.858 1.5-1.69 3-3.976 4.5-6.163V0c-1.7 2.584-3.4 4.771-5.1 6.66q-3.45 3.876-7.2 6.262a29.7 29.7 0 0 1-8.5 3.677c-1.4.398-2.9.597-4.6.895-1.1.199-2.2.298-3.3.398-.5 0-37.5 3.876-37.5 3.876z"></path><path fill="#fff" d="M208.899 17.693a28.4 28.4 0 0 1-8.6 3.081c-1.4.298-2.8.497-4.5.696l-3 .298c-.5 0-1.1.1-1.6.1-12.2 1.192-24.3 2.286-35.7 3.379v2.584c11.4-1.391 23.7-2.882 35.9-4.274.5-.1 1.1-.1 1.6-.199 1-.099 2-.198 3-.397 1.7-.199 3.3-.497 4.6-.795 3.3-.696 6.3-1.889 8.9-3.48s4.8-3.677 7.3-6.36c1.5-1.69 3.2-3.977 4.8-6.163v-.994c-1.9 2.485-3.6 4.671-5.4 6.46-2.4 2.684-4.8 4.672-7.3 6.064"></path><path fill="#fff" d="M215.899 17.096c-2.4 2.187-5 3.976-7.5 5.268-2.5 1.193-5.3 2.088-8.6 2.585-1.4.199-2.8.397-4.5.596l-39.8 3.18v2.585l35.3-3.777 4.6-.497c1.7-.199 3.2-.397 4.6-.696 3.4-.596 6.3-1.59 8.9-2.882 2.7-1.392 5.3-3.578 7.8-5.964 1.7-1.59 3.2-3.678 4.9-5.765v-.895c-2 2.485-3.8 4.473-5.7 6.262"></path><path fill="#fff" d="M206.299 30.416c-2.3 1.292-4 2.087-7.3 2.385-2 .199-4 .298-6 .398-1 0-1.9.1-2.9.199-6 .298-11.9.695-17.9 1.093l-16.7 1.193v2.584l16.8-1.59c5.4-.497 11.7-1.094 17.9-1.59l4.5-.299c1.7-.1 3.2-.298 4.5-.497 3.4-.398 6.3-1.093 8.9-2.087 2.8-.994 5.4-2.684 8-4.572 2.4-1.69 5.6-5.07 5.6-5.17v-.894c-2.1 2.088-3.4 3.28-5.7 4.771-2.9 1.988-7.6 2.982-9.7 4.076"></path><path fill="#fff" d="M207.099 35.386c-2.5.695-5.3 1.192-8.6 1.49-1.3.1-2.8.2-4.4.299l-4.4.199c-11 .496-22 1.093-34.1 1.69v2.584c11.6-.895 22.9-1.79 34.3-2.585l4.4-.298c1.7-.1 3.1-.199 4.5-.398 3.4-.397 6.3-.993 8.8-1.789 2.8-.894 5.6-2.186 8.2-3.876 1.9-1.193 3.9-2.684 5.9-4.473-2.2 1.889-4.3 2.286-6.4 3.578-2.7 1.59-5.4 2.783-8.2 3.579"></path><path fill="#fff" d="M206.699 39.66c-2.5.596-5.3.994-8.6 1.192-1.3.1-2.7.2-4.4.2l-4.4.198c-11.1.398-22.3.895-33.8 1.392v2.584c11.4-.795 22.6-1.491 33.9-2.286l4.4-.298c1.7-.1 3.1-.2 4.4-.299 3.4-.298 6.2-.795 8.8-1.49q4.35-1.194 8.4-3.28c2.1-1.094 4.1-2.386 6.2-3.977v-1.093c-2.3 1.69-4.5 2.982-6.7 4.075-2.6 1.392-5.4 2.386-8.2 3.082"></path><path fill="#fff" d="M206.299 43.834c-2.5.497-5.3.795-8.6.895-1.3.1-2.6.1-4.3.199l-37.9.994v2.584l33.6-1.79 4.4-.198c1.7-.1 3.1-.199 4.4-.298 3.4-.298 6.1-.597 8.7-1.193 2.9-.596 5.8-1.49 8.5-2.684 2.2-.894 4.3-1.988 6.6-3.38v-.993a50 50 0 0 1-7 3.38c-2.7 1.192-5.5 1.987-8.4 2.484"></path><path fill="#fff" d="M205.999 48.01c-4.7.595-9.4.695-14.1.794-1.1 0-2.1 0-3.2.1l-33.2.596v2.584l33.3-1.391c1.1 0 2.1-.1 3.2-.1 4.7-.198 9.5-.397 14.2-1.093 3-.497 5.9-1.193 8.5-2.087 2.2-.696 4.5-1.69 6.8-2.883v-.994c-2.4 1.093-4.9 2.087-7.2 2.783-2.5.696-5.3 1.392-8.3 1.69"></path><path fill="#fff" d="M205.799 52.283c-4.4.398-8.8.398-13.2.398h-4c-11 0-22 .099-33.1.198v2.585c10.6-.398 21.9-.696 33.2-1.094 1.3 0 2.7-.099 4-.099 4.3-.1 8.8-.199 13.2-.696 3.1-.298 5.9-.795 8.6-1.49 2.3-.597 4.7-1.392 7.2-2.287v-.895c-2.5.895-5 1.59-7.4 2.187-2.7.597-5.5.994-8.5 1.193m-.2 4.175c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1l-15.8.1v2.584l15.9-.397c5.5-.1 11.3-.299 17.1-.398l8.6-.1c2.4 0 5.5-.099 8.6-.298s5.9-.497 8.6-.894c2.4-.398 4.9-.895 7.4-1.491v-.895c-2.5.597-5.1 1.094-7.5 1.392-2.8.199-5.5.397-8.6.497m-8.6 4.075-8.6-.1c-10.9-.198-21.8-.397-32.9-.596v2.585c10.6-.1 21.8-.2 32.9-.298l8.6-.1c2.9 0 5.7-.1 8.6-.199 5.9-.199 11.1-.596 16.1-1.292v-.895c-4.9.498-10.2.796-16.1.895zm24.6 4.572-66.1-1.69V66h66.1zm-5.9-43.237c-2.5 1.987-4.5 3.478-7.5 4.671-2.7 1.093-5.6 1.491-8.8 1.988-2.1.298-4.3.696-6.4.895-.9.1-1.7.1-2.6.198l-34.9 2.485v2.585l34.9-3.38 4.5-.397c1.7-.2 3.2-.299 4.6-.597 3.4-.497 6.3-1.391 8.9-2.584 2.7-1.193 5.5-3.18 8-5.268 1.7-1.491 3.4-3.28 5.2-5.268V16.3c-2.2 2.187-4 4.076-5.9 5.567M249.698 0s11.9 18.786 14.1 22.265 4.7 6.163 13.5 8.051c8.8 1.889 12.6 2.684 12.6 2.684v.696s-5.6-1.193-12.8-2.783-10.1-2.088-13.4-6.66c-2.7-3.777-14-19.78-14-19.78zm0 21.47s10.8 11.232 14 14.512c3.3 3.479 7.6 4.672 13.5 5.765 5.6.994 12.7 2.187 12.7 2.187v.596s-6.7-1.093-12.7-2.087c-5.9-.994-10.1-1.59-13.5-4.672-3-2.783-13.9-12.922-13.9-12.922v-3.38z"></path><path fill="#fff" d="M249.698 26.639s10.3 9.542 14 12.723c3.4 2.981 6.1 3.876 13.5 5.267 7.4 1.293 12.7 2.088 12.7 2.088v.696s-6.7-1.094-12.7-2.088-9.9-1.292-13.5-4.274c-4.2-3.38-14-11.331-14-11.331z"></path><path fill="#fff" d="M249.698 32.006s11.8 9.244 14 10.934c2.2 1.59 5.1 3.479 13.5 4.77 8.4 1.194 12.7 1.79 12.7 1.79v.696s-7.6-1.094-12.7-1.69-9-.895-13.5-3.877c-4.4-2.882-14-9.641-14-9.641z"></path><path fill="#fff" d="M249.698 37.175s11.8 7.852 14 9.045 4.9 3.28 13.5 4.373 12.7 1.59 12.7 1.59v.697s-7.1-.796-12.7-1.392-9.4-1.392-13.5-3.678-14-7.952-14-7.952z"></path><path fill="#fff" d="M249.698 42.443s10.4 5.665 14 7.355c3.9 1.988 7.3 2.883 13.5 3.678 6.1.696 12.7 1.391 12.7 1.391v.597s-6.1-.696-12.7-1.292c-6.5-.597-8.8-.895-13.5-2.982-4.2-1.889-14-6.362-14-6.362z"></path><path fill="#fff" d="M249.699 47.71s8.2 3.48 14 5.766c5.7 2.286 10 2.485 13.5 2.783 1.5.199 12.6 1.292 12.6 1.292v.596s-6.6-.496-12.7-1.093c-6-.497-8.6-.795-13.5-2.385s-14-4.771-14-4.771V47.71zm-.001 5.368s8.3 2.585 14 4.076 10.9 2.087 13.5 2.286 12.7.994 12.7.994v.596s-5.7-.398-12.7-.895c-5.7-.397-10.2-.795-13.5-1.59-3.7-.795-14-3.28-14-3.28zm0 5.268s6.8 1.193 14 2.386c5.4.894 12.7 1.49 13.5 1.49s12.7.895 12.7.895v.597s-7.6-.398-12.7-.696c-5.3-.298-10.5-.596-13.5-.895-6.7-.695-14-1.59-14-1.59zm0 5.567s10.7.397 14 .497 26.2.994 26.2.994V66h-40.2zM277.2 33.199c-9.7-2.088-11.9-5.566-13.5-7.753S249.8 5.367 249.8 5.367v4.076c.5.596 11 14.313 14 18.09 3.3 4.274 8.5 5.268 13.5 6.262 5 1.094 12.7 2.584 12.7 2.584v-.596c-.1 0-10.3-1.988-12.8-2.584"></path><path fill="#fff" d="M277.2 36.081c-8-1.59-11.2-4.075-13.5-7.057-2.3-3.081-13.9-18.19-13.9-18.19v3.778c.5.596 11.1 13.02 13.9 16.3 3.3 3.778 7.9 4.772 13.5 5.766s12.7 2.385 12.7 2.385v-.596s-8.1-1.491-12.7-2.386"></path><path fill="#fff" d="M277.198 38.964c-8.3-1.59-10-2.883-13.5-6.76-2.2-2.385-13.5-15.605-14-16.201v3.479s10.5 11.132 13.9 14.512c4.4 4.373 8.6 4.672 13.5 5.566s12.7 2.286 12.7 2.286v-.596c.1 0-9.3-1.59-12.6-2.286"></path><path fill="#004494" d="M240.899 27.434h-57.9V65.9h57.9z"></path><path fill="#FFEC00" d="M212.6 32.9h2l-1.6 1.293.6 1.988-1.6-1.193-1.6 1.193.6-1.988-1.6-1.292h2l.6-1.988zm0 25.645h2l-1.6 1.193.6 1.889-1.6-1.193-1.6 1.193.6-1.89-1.6-1.192h2l.6-1.888zm6.4-1.69h2l-1.6 1.193.6 1.889-1.6-1.193-1.6 1.193.6-1.889-1.6-1.193h2l.6-1.888zm0-22.265h2l-1.6 1.193.6 1.889-1.6-1.193-1.6 1.292.7-1.988-1.6-1.193h2l.6-1.888zm4.799 4.771h2l-1.6 1.193.6 1.889-1.6-1.193-1.6 1.193.6-1.889-1.6-1.193h2l.6-1.888zm0 12.922h2l-1.6 1.193.6 1.888-1.6-1.192-1.6 1.192.6-1.888-1.6-1.193h2l.6-1.889zm1.801-6.56h2l-1.6 1.193.6 1.888-1.6-1.193-1.6 1.193.6-1.888-1.7-1.193h2l.6-1.889zM206 34.59h2l-1.6 1.193.6 1.889-1.5-1.094-1.7 1.193.6-1.889-1.6-1.192h2l.7-1.889zm-4.602 4.771h2l-1.6 1.193.6 1.889-1.6-1.193-1.6 1.193.6-1.889-1.6-1.193h2l.6-1.888zm-1.699 6.362h2l-1.6 1.193.6 1.888-1.6-1.193-1.6 1.193.6-1.888-1.6-1.193h2l.6-1.889zm1.699 6.56h2l-1.6 1.193.6 1.888-1.6-1.192-1.6 1.192.6-1.888-1.6-1.193h2l.6-1.889zm4.702 4.672h2l-1.6 1.193.6 1.888-1.6-1.193-1.6 1.193.6-1.888-1.6-1.193h2l.6-1.889z"></path>', 19), h21 = [
  c21
];
function u21(t, e) {
  return T(), N("svg", o21, [...h21]);
}
const d21 = { render: u21 }, f21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, v21 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="235" height="71" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.6h234.5V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m9.1 2q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1a21 21 0 0 1-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.199-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.699-.5 1.6-.8 2.699-.8h.7c.3 0 .5 0 .8.1s.5.1.801.1c.3 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3-.099.1-.199 0-.399 0-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8s.701.2 1.3.3c.5.1.901.2 1.401.3.4.1.799.3 1.2.5.399.2.599.5.8.9.299.4.4.9.4 1.5m4.2-3.2 1.5-1.6 1.7-1.7.3-.3c.101-.1.2-.1.4-.1h1.6c.2 0 .301 0 .301.1s0 .2-.101.3l-3.2 3.3 3.601 5.7q.148.15 0 .3c-.101.1-.101.1-.3.1h-1.5c-.2 0-.401 0-.5-.1-.101-.1-.2-.2-.2-.3l-2.601-4.1-1.1 1.2v3c0 .1 0 .2-.099.3-.101.1-.2.1-.301.1h-1.399c-.3 0-.401-.1-.401-.4V32.3c0-.3.101-.4.401-.4h1.399c.101 0 .2 0 .301.1.099.1.099.2.099.3zm13.499 1.7H215.2c-.5 0-.901.1-1.201.4-.299.2-.4.7-.4 1.3q0 .6.301.9c.199.2.5.3 1 .3.199 0 .399 0 .699-.1.301-.1.5-.1.801-.2.3-.1.5-.2.699-.3.2-.1.5-.2.601-.3v-2zm.101 3.3c-.5.4-1.101.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.401-.1-.601-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .899-2.6.601-.5 1.601-.8 2.8-.8h2.601v-.5c0-.3 0-.5-.101-.8-.1-.2-.199-.4-.3-.5l-.599-.3c-.3-.1-.601-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.4c-.1 0-.1-.1-.199-.3l-.401-.6v-.3c0-.1.201-.2.401-.3.199-.1.5-.1.8-.2.299-.1.599-.1.899-.1s.601-.1.9-.1h.8q1.351 0 2.101.3c.5.2.899.4 1.199.7s.4.7.5 1.2c.101.5.101 1 .101 1.5v4.4c0 .1.099.2.099.3s.101.1.2.1c.1 0 .201 0 .401.1.099 0 .199 0 .3.1.099.1.099.1.099.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.099-.3-.201-.2-.401-.5-.5-1m-72.3 15.3 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.1.1-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.5 1.2c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6s.199 1.2.199 1.8m16.301 5c0 .1-.101.1-.301.1H175.7c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1s-.5.1-.7.2-.5.2-.699.3l-.601.3V66c0 .1 0 .2-.099.3-.101.1-.2.1-.3.1h-1.5c-.2 0-.301-.1-.301-.4v-5.8c0-.6-.099-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3V66c0 .3-.101.4-.401.4H163.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.399c.3 0 .401.1.401.4v.6c.2-.1.399-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3.5-.1.8-.1c.601 0 1.101.1 1.601.3s.899.6 1.2 1.1c.5-.4 1.1-.7 1.699-1 .601-.3 1.2-.4 1.901-.4.7 0 1.2.1 1.599.3.401.2.7.5.901.8.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.7-.3c0 .1 0 .2-.1.3 0 .1-.099.1-.299.1H180.3c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4-.099.1-.2.2-.4.3-.199.1-.399.1-.6.1-.299 0-.5 0-.599-.1-.2-.1-.301-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.4.201.7m9.699 9.5q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.199-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.699-.5 1.6-.8 2.699-.8h.7c.3 0 .5 0 .8.1s.5.1.801.1c.3 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3-.099.1-.199 0-.399 0-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8s.701.2 1.3.3c.5.1.901.2 1.401.3.4.1.799.3 1.2.5.399.2.599.5.8.9.299.4.4.9.4 1.5m4.3 2.6c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.2-12.1v.5c0 .2-.1.3-.2.4-.101.1-.2.2-.4.3-.201.1-.4.1-.6.1-.3 0-.5 0-.601-.1-.199-.1-.299-.2-.399-.3s-.101-.2-.2-.4V54c0-.3.099-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m5.199 0v.5c0 .2-.1.3-.199.4-.101.1-.2.2-.401.3-.2.1-.4.1-.599.1-.301 0-.5 0-.601-.1-.2-.1-.3-.2-.399-.3-.101-.1-.101-.2-.2-.4V54c0-.3.099-.6.2-.8.199-.2.5-.3 1-.3s.8.1 1 .3c.099.1.199.4.199.7m-.1 12.7c0 .7-.099 1.2-.2 1.7-.099.5-.399.9-.8 1.3-.4.3-.799.6-1.4.8s-1.3.2-2.1.2c-.099 0-.2 0-.299-.1-.101-.1-.201-.2-.201-.3l-.099-.9V69c0-.1.099-.1.3-.1q.75-.15 1.2-.3c.3-.1.599-.2.8-.4.2-.1.299-.3.399-.6.101-.2.101-.5.101-.9V57c0-.3.099-.4.399-.4h1.4c.3 0 .401.1.401.4v9.6zm8.6-4.7H207.7c-.5 0-.901.1-1.201.4-.299.2-.4.7-.4 1.3q0 .6.301.9c.199.2.5.3 1 .3.199 0 .399 0 .699-.1.301-.1.5-.1.801-.2.3-.1.5-.2.699-.3.2-.1.5-.2.601-.3v-2zm.101 3.3c-.5.4-1.101.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.401-.1-.601-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .899-2.6.601-.5 1.601-.8 2.8-.8h2.601v-.5c0-.3 0-.5-.101-.8-.1-.2-.199-.4-.3-.5l-.599-.3c-.3-.1-.601-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.4c-.1 0-.1-.1-.199-.3l-.2-.7v-.3c0-.1.2-.2.399-.3.2-.1.5-.1.801-.2.3-.1.599-.1.899-.1s.601-.1.901-.1h.799q1.35 0 2.1.3c.5.2.9.4 1.2.7s.401.7.5 1.2c.101.5.101 1 .101 1.5v4.4c0 .1.099.2.099.3s.1.1.201.1c.099 0 .2 0 .399.1.101 0 .2 0 .301.1.099.1.099.1.099.2v.8c0 .2-.2.4-.5.4-.2 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.301-.1-.5-.4-.7-.9m21 1.5h3.3V28h-3.3z"></path></g>', 24), p21 = [
  v21
];
function m21(t, e) {
  return T(), N("svg", f21, [...p21]);
}
const g21 = { render: m21 }, y21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, _21 = /* @__PURE__ */ U1('<path fill="#fff" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z"></path><path fill="#fff" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1"></path><path fill="#fff" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3"></path><path fill="#fff" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1"></path><path fill="#fff" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6"></path><path fill="#fff" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1"></path><path fill="#fff" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5"></path><path fill="#fff" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7"></path><path fill="#fff" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2m-.2 4.2c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z"></path><path fill="#fff" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z"></path><path fill="#fff" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z"></path><path fill="#fff" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z"></path><path fill="#fff" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z"></path><path fill="#fff" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6"></path><path fill="#fff" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4"></path><path fill="#fff" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3"></path><path fill="#004494" stroke="#fff" stroke-width="2" d="M85.4 27.6H27.5v38.7h57.9z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2z"></path><path fill="#fff" fill-rule="evenodd" d="M178.4 32.2c.1-.1.1-.3-.1-.4l-1.2-.7c-.2-.1-.3-.1-.4.1l-1.6 3.1c-.1.2 0 .3.1.4l.8.4c.2.1.3 0 .4-.1zm1.8 8.8c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m-2.3.1c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m12.7 2.2c.1-.7.2-1.4.2-2.2s0-1.5-.2-2.1c-.1-.6-.3-1.2-.5-1.6s-.6-.8-1-1c-.4-.3-.9-.4-1.6-.4-.3 0-.6 0-.9.1l-.9.3c-.209.07-.418.188-.594.287q-.114.066-.206.113c-.2.2-.4.3-.6.4h-.1v-.6c0-.1 0-.2-.1-.3s-.2-.1-.3-.1h-1.4c-.3 0-.4.1-.4.4v12.7c0 .05.025.1.05.15s.05.1.05.15c0 .1.1.1.3.1h1.4c.1 0 .2 0 .3-.1s.1-.2.1-.3v-3.5c.5.1 1 .2 1.4.3.5.1.9.1 1.2.1.8 0 1.5-.1 2-.3s.9-.6 1.2-1 .5-1 .6-1.6m-2.2-3.7c.1.3.1.9.1 1.5s0 1.1-.3 1.7c0 .4-.1.7-.3 1-.2.2-.4.4-.6.5s-.5.2-.9.2-.8 0-1.1-.1q-.45-.15-1.2-.3v-5l.6-.3c.1-.05.225-.1.35-.15s.25-.1.35-.15c.15-.05.275-.075.4-.1s.25-.05.4-.1c.3-.1.5-.1.7-.1.3 0 .5 0 .7.1.2 0 .4.2.5.4.067.133.133.356.2.578.033.11.067.222.1.322m8.7 6.2c.6-.2 1.2-.5 1.7-.9.1.5.3.8.7.9.3.2.6.3 1.1.3h.5c.2-.1.3-.1.5-.1.3 0 .5-.2.5-.4v-.8c0-.042 0-.067-.008-.089-.01-.029-.034-.053-.092-.111-.1-.1-.2-.1-.3-.1-.2-.1-.3-.1-.4-.1s-.2 0-.2-.1c0-.05-.025-.1-.05-.15A.4.4 0 0 1 201 44v-4.4c0-.5 0-1-.1-1.5s-.2-.9-.5-1.2-.7-.5-1.2-.7q-.75-.3-2.1-.3h-.8c-.15 0-.3.025-.45.05s-.3.05-.45.05c-.3 0-.6 0-.9.1-.138.046-.275.07-.403.094a1.5 1.5 0 0 0-.397.106c-.2.1-.4.2-.4.3v.3l.2.7q.043.089.067.15c.042.1.062.15.133.15h.4c.2-.1.5-.1.7-.1.2-.1.5-.1.7-.1h1.3c.4 0 .7 0 1 .1l.6.3c.1.1.2.3.3.5.1.3.1.5.1.8v.5h-2.6c-1.2 0-2.2.3-2.8.8-.6.6-.9 1.4-.9 2.6 0 .5 0 .9.1 1.2 0 .4.2.7.4.9.2.3.4.5.8.6.3.1.8.2 1.3.2.7 0 1.4-.2 2-.4m-.8-4.2h2.5v2c-.067.067-.222.133-.378.2a5 5 0 0 0-.222.1c-.2.1-.4.2-.7.3-.15.05-.275.075-.4.1s-.25.05-.4.1c-.3.1-.5.1-.7.1-.5 0-.8-.1-1-.3q-.3-.3-.3-.9c0-.6.1-1.1.4-1.3.3-.3.7-.4 1.2-.4m9.701-7.5v-.5c0-.3-.1-.6-.2-.7-.2-.2-.5-.3-1-.3s-.8.1-1 .3c-.1.2-.2.5-.2.8v.4c.038.076.061.138.082.191a.5.5 0 0 0 .118.209c.1.1.2.2.4.3.1.1.3.1.6.1.2 0 .4 0 .6-.1s.3-.2.4-.3.2-.3.2-.4m-.2 11.9c.1-.1.1-.2.1-.3v-9.1c0-.05-.025-.1-.05-.15s-.05-.1-.05-.15c-.1-.1-.2-.1-.3-.1h-1.4c-.3 0-.4.1-.4.4v9.1c0 .3.1.4.4.4h1.4c.2 0 .3 0 .3-.1M152.8 62.6c0 .6-.1 1.1-.3 1.6s-.5.9-.8 1.2c-.4.3-.8.6-1.2.8q-.75.3-1.5.3h-5.1c-.2 0-.3 0-.4-.1s-.1-.2-.1-.3V53.4c0-.3.1-.4.4-.4h4.6c1.3 0 2.3.3 3 1 .7.6 1 1.5 1 2.6 0 .2 0 .4-.1.7q-.042.133-.07.247a1.6 1.6 0 0 1-.23.553c-.1.3-.3.5-.5.7s-.5.4-.8.6c.4.1.7.3 1 .6s.5.5.6.8l.3.9c.1.3.2.6.2.9m-2.7-5.8c0-.5-.2-.9-.5-1.3-.3-.3-.8-.5-1.5-.5h-2.4v3.5h2.6c.5 0 .9-.2 1.3-.5.3-.3.5-.7.5-1.2M150 61c.3.4.5.9.5 1.4 0 .165-.06.33-.115.479-.044.121-.085.231-.085.321 0 .2-.2.5-.3.6s-.3.3-.6.4-.6.2-1 .2h-2.7v-4h2.7c.7 0 1.3.2 1.6.6m7.4-6.6v-.5c0-.3-.1-.6-.2-.7-.2-.2-.5-.3-1-.3s-.8.1-1 .3c-.1.2-.2.5-.2.8v.4c.038.076.062.138.082.191.033.085.056.147.118.209.1.1.2.2.4.3.1.1.3.1.6.1.2 0 .4 0 .6-.1s.3-.2.4-.3.2-.3.2-.4m-.2 11.9c.1-.1.1-.2.1-.3v-9.1c0-.05-.025-.1-.05-.15a.4.4 0 0 1-.05-.15c-.1-.1-.2-.1-.3-.1h-1.4c-.3 0-.4.1-.4.4V66c0 .3.1.4.4.4h1.4c.2 0 .3 0 .3-.1" clip-rule="evenodd"></path><path fill="#fff" d="M166.601 64.5c.3 0 .4.1.4.4V66c0 .3-.1.4-.4.4h-7q-.3 0-.3-.3v-1.2c0-.1.1-.2.2-.3l4.8-6.1h-4.3c-.3 0-.4-.1-.4-.4V57c0-.2.1-.4.4-.4h6.6c.1 0 .2 0 .3.1.1 0 .1.1.1.3v1c0 .2-.1.5-.2.7l-4.7 6h4.5z"></path><path fill="#fff" fill-rule="evenodd" d="M177.301 61.3c0-.6 0-1.2-.2-1.8-.1-.6-.3-1.1-.6-1.6s-.7-.9-1.3-1.2c-.5-.3-1.3-.4-2.3-.4s-1.7.2-2.3.5c-.6.4-1 .8-1.3 1.3s-.5 1-.6 1.6-.1 1.1-.1 1.6c0 .6 0 1.2.1 1.8 0 .6.2 1.2.5 1.7.3.6.7 1 1.3 1.3s1.4.5 2.4.5 1.8-.2 2.4-.5c.6-.4 1-.8 1.3-1.3s.5-1.1.6-1.7.1-1.2.1-1.8m-2.3-1.3c.1.4.1.9.1 1.4 0 .33-.031.6-.058.843a5 5 0 0 0-.042.557c0 .4-.1.7-.3 1s-.4.5-.7.6-.6.2-1.1.2c-.4 0-.8-.1-1-.2s-.5-.3-.6-.6-.2-.6-.3-1-.1-.9-.1-1.4 0-1 .1-1.4c0-.4.1-.7.3-1 .1-.3.4-.5.6-.6s.6-.2 1-.2c.5 0 .8.1 1.1.2s.5.3.7.6c.1.3.2.6.3 1" clip-rule="evenodd"></path><path fill="#fff" d="M185.401 65.6c0 .2 0 .4-.3.5-.2.1-.4.1-.6.2s-.5.1-.7.1-.5.1-.7.1h-.6c-.6 0-1-.1-1.4-.2-.3-.2-.6-.4-.7-.7-.2-.3-.3-.6-.3-1s-.1-.8-.1-1.2v-5h-1c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-1c0-.1 0-.2.1-.3s.2-.1.3-.1h1v-2.1c0-.1 0-.3.1-.3.1-.1.2-.1.3-.1l1.3-.4c.3-.1.4 0 .4.2v2.6h2.1c.2 0 .3 0 .3.1s.1.2.1.3v1c0 .1 0 .2-.1.3 0 .1-.2.1-.3.1h-2.1v5c0 .3 0 .5.1.6s.1.3.2.3c.1.1.2.1.4.1h1.3c.3 0 .5 0 .7-.1h.2s.1.1.1.2zm7.299 0c0 .2 0 .4-.3.5-.2.1-.4.1-.6.2s-.5.1-.7.1-.5.1-.7.1h-.6c-.6 0-1-.1-1.4-.2-.3-.2-.6-.4-.7-.7-.2-.3-.3-.6-.3-1s-.1-.8-.1-1.2v-5h-1c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-1c0-.1 0-.2.1-.3s.2-.1.3-.1h1v-2.1c0-.1 0-.3.1-.3.1-.1.2-.1.3-.1l1.3-.4c.3-.1.4 0 .4.2v2.6h2.1c.2 0 .3 0 .3.1s.1.2.1.3v1c0 .1 0 .2-.1.3 0 .1-.2.1-.3.1h-2.1v5c0 .3 0 .5.1.6s.1.3.2.3c.1.1.2.1.4.1h1.3c.3 0 .5 0 .7-.1h.2s.1.1.1.2zm8.4-2.2q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1s.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5"></path><path fill="#fff" fill-rule="evenodd" d="M210.1 52.5c.1-.1.1-.3-.1-.4l-1.2-.7c-.2-.1-.3-.1-.4.1l-1.6 3.1c-.1.2 0 .3.1.4l.8.4c.2.1.3 0 .4-.1zm-.9 12.7c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.07 0-.091-.05-.132-.15-.018-.041-.038-.091-.068-.15l-.2-.7v-.3c.1-.1.2-.2.4-.3.109-.054.246-.079.397-.106.128-.023.266-.048.403-.094.3-.1.6-.1.9-.1.15 0 .3-.025.45-.05s.3-.05.45-.05h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .05.025.1.05.15s.05.1.05.15c0 .1.1.1.2.1s.2 0 .4.1c.1 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.3-.1-.5-.4-.7-.9m-.1-3.3h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1.15-.05.275-.075.4-.1s.25-.05.4-.1c.3-.1.5-.2.7-.3a4 4 0 0 1 .223-.1c.155-.067.311-.133.377-.2v-2zm11.001-5.5c-.7-.1-1.4-.1-2-.1-.9 0-1.6.1-2 .5-.6.2-1.1.6-1.4 1s-.6 1-.7 1.6-.2 1.3-.2 2.1c0 .7.1 1.4.2 2s.3 1.2.6 1.6.7.8 1.2 1c.5.3 1.2.4 2 .4.3 0 .7 0 1.1-.1q.116-.029.241-.058c.351-.084.755-.18 1.159-.342v.5c0 .3 0 .6-.1.8q0 .45-.3.6c-.2.1-.4.2-.7.3s-.7.1-1.1.1h-1.3a8 8 0 0 0-.7-.1c-.225-.025-.45-.05-.7-.1h-.4c-.1 0-.2.1-.2.3l-.2.7a.3.3 0 0 1-.022.1c-.023.067-.045.133.022.2.1.1.2.2.4.3.4.2.9.3 1.5.4s1.2.1 1.7.1c1 0 1.7-.1 2.3-.3s1-.4 1.3-.8.5-.8.6-1.3.1-1 .1-1.6v-8.5c0-.2 0-.3-.1-.5s-.3-.3-.5-.4c-.5-.2-1.1-.3-1.8-.4m-4 6.4c-.1-.4-.1-.9-.1-1.5v-1.7c.1-.4.3-.7.5-.9s.4-.3.7-.4.6-.1.9-.1c.139 0 .278.022.427.045.173.026.358.055.573.055.4 0 .7 0 1 .1v5.7c-.267.133-.534.178-.8.222a5 5 0 0 0-.4.078c-.4.1-.7.1-1 .1-.4 0-.7-.1-.9-.2s-.4-.3-.6-.5c-.1-.3-.2-.6-.3-1" clip-rule="evenodd"></path><path fill="#fff" d="M232.2 28h3.3v38.7h-3.3z"></path>', 25), q21 = [
  _21
];
function w21(t, e) {
  return T(), N("svg", y21, [...q21]);
}
const z21 = { render: w21 }, M21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, b21 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="24" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6M94.201 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.701 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#fff" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L54.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#fff" d="M143 36.523q0-.3.314-.3h5.664q.299 0 .299.3v.98q0 .285-.314.284h-4.19v2.716h3.656q.298 0 .298.285v.979q0 .3-.314.3h-3.624v4.343q0 .3-.298.3h-1.177q-.314 0-.314-.3zm9.387 9.887q0 .3-.298.3h-1.129q-.299 0-.299-.3v-7.123q0-.316.299-.316h1.114q.313 0 .313.316v.695l.032.032q.173-.159.455-.332.282-.19.596-.332.33-.158.659-.284.33-.126.612-.174a.4.4 0 0 1 .251.016q.095.048.126.253l.11 1.058q.015.174-.016.253-.031.078-.283.126-.329.063-.69.158a8 8 0 0 0-.706.19q-.345.094-.643.19a4 4 0 0 0-.503.189zm8.462-3.222h-1.914q-.597 0-.942.285-.345.268-.345 1.042 0 .521.204.727.22.19.769.19.25 0 .549-.064.299-.063.596-.174a10 10 0 0 0 .581-.237q.282-.142.502-.268zm.094 2.622a5.2 5.2 0 0 1-1.349.742 4.2 4.2 0 0 1-1.538.285q-.628 0-1.051-.158a1.8 1.8 0 0 1-.659-.458 2 2 0 0 1-.346-.711 4 4 0 0 1-.094-.916q-.016-1.39.722-2.006.738-.632 2.228-.632h2.009v-.41q0-.348-.079-.585a.76.76 0 0 0-.251-.41 1.1 1.1 0 0 0-.502-.221 4 4 0 0 0-.8-.063 9 9 0 0 0-.471.015l-.565.032q-.282.015-.58.047a12 12 0 0 1-.518.048 1.3 1.3 0 0 1-.33.015q-.078-.031-.11-.205l-.141-.584q-.031-.159.032-.253.063-.11.329-.221.251-.095.596-.158a8 8 0 0 1 .707-.095q.36-.047.706-.063.36-.032.643-.032 1.02 0 1.616.206.612.205.926.584.314.363.408.9t.094 1.2v3.049q0 .237.016.379a.8.8 0 0 0 .078.205q.063.063.173.095t.298.047q.173.016.235.064.063.048.063.173v.664q0 .269-.376.331a5 5 0 0 1-.377.048 2 2 0 0 1-.361.031q-.549 0-.894-.205-.33-.206-.455-.758zm14.86.6q0 .143-.062.221-.048.08-.22.08h-1.13q-.298 0-.298-.3v-4.486q0-.885-.235-1.185-.235-.316-.832-.316a2 2 0 0 0-.502.08 7 7 0 0 0-.549.189 5 5 0 0 0-.518.221l-.439.221v.332q.015.206.015.474v4.47a.35.35 0 0 1-.062.22q-.063.08-.236.08h-1.145q-.267 0-.267-.3v-4.565q0-.726-.22-1.074-.219-.348-.816-.348-.204 0-.47.064-.252.063-.534.173a11 11 0 0 0-.533.237q-.267.126-.487.237v5.275q0 .3-.298.3h-1.13q-.282 0-.282-.3v-7.123q0-.316.282-.316h1.114q.315 0 .314.316v.458l.016.016q.235-.157.502-.316a3.6 3.6 0 0 1 .565-.3 5 5 0 0 1 .628-.205q.313-.095.643-.11.675 0 1.224.22.564.206.926.885a7.6 7.6 0 0 1 1.302-.774 3.4 3.4 0 0 1 1.459-.332q.77 0 1.224.237.456.237.691.648.234.395.298.931.063.537.062 1.122zm3.487-4.58 1.209-1.28 1.302-1.326q.126-.126.235-.19.11-.078.33-.078h1.255q.22 0 .251.11.047.11-.078.253l-2.511 2.574 2.825 4.454q.078.143.015.253-.047.11-.219.11h-1.209q-.25 0-.361-.079a.7.7 0 0 1-.188-.22l-2.008-3.239-.895.917v2.321a.4.4 0 0 1-.062.221q-.063.08-.236.08h-1.114q-.298 0-.298-.3V35.875q0-.316.298-.316h1.114q.173 0 .236.095a.35.35 0 0 1 .062.22v5.94zm8.919 2.938q0-.047.094-.332l.204-.648q.125-.41.299-.9l1.255-3.664a.5.5 0 0 1 .11-.19q.078-.063.251-.063h1.192q.314 0 .189.3l-2.668 7.108a.6.6 0 0 1-.157.252q-.094.08-.282.08h-1.052q-.219 0-.298-.064a.7.7 0 0 1-.141-.252l-2.667-7.108a.33.33 0 0 1-.016-.22q.031-.096.188-.096h1.24q.172 0 .235.064.078.047.141.22l1.256 3.696q.141.459.266.853.11.332.189.632.093.284.125.332zm12.899-5.938q1.051 0 1.71.315.675.316 1.036.837.376.505.502 1.153.141.648.141 1.311 0 .395-.157.648-.156.252-.612.252h-4.221q.017.6.126.995.11.38.314.616.219.222.565.316.345.08.847.08.22 0 .486-.017l.581-.031.581-.063q.282-.032.502-.064a.5.5 0 0 1 .266-.015q.11.016.157.22l.126.6q.078.348-.298.475a4 4 0 0 1-.565.173q-.33.064-.691.111-.36.048-.721.079-.346.032-.628.032-1.114 0-1.789-.3a2.5 2.5 0 0 1-1.02-.853l-.251.19-.282.173a6 6 0 0 1-1.287.568 5.6 5.6 0 0 1-1.569.206q-.644 0-1.067-.158a1.6 1.6 0 0 1-.675-.458 1.8 1.8 0 0 1-.361-.695 4 4 0 0 1-.094-.916q0-1.327.722-1.895.722-.585 2.228-.585h2.009v-.584q0-.348-.079-.585a.68.68 0 0 0-.251-.395 1.1 1.1 0 0 0-.502-.22 4 4 0 0 0-.8-.064q-.19 0-.455.016l-.565.032q-.298.015-.597.047-.282.032-.533.047a2 2 0 0 1-.267.016q-.11-.016-.157-.22l-.141-.585q-.031-.174.031-.253.063-.095.33-.205.25-.095.596-.158.346-.064.706-.11.361-.048.706-.064.361-.016.644-.016.972 0 1.538.206.58.205.894.616.377-.364.926-.585.564-.237 1.365-.237m-5.633 6.617q.235 0 .549-.08a8 8 0 0 0 .659-.189 12 12 0 0 0 .643-.268q.314-.158.549-.284a6 6 0 0 1-.109-.616 10 10 0 0 1-.047-.664h-1.883q-.675 0-1.005.269-.329.252-.329.947 0 .458.204.68.22.204.769.205m7.186-3.301a5 5 0 0 0-.078-.663 1.7 1.7 0 0 0-.236-.616 1.1 1.1 0 0 0-.455-.443q-.297-.173-.8-.173-.454 0-.753.142a1.07 1.07 0 0 0-.455.379 1.7 1.7 0 0 0-.235.6q-.079.348-.11.774zm14.301 4.265q0 .143-.062.221-.048.08-.22.08h-1.13q-.298 0-.298-.3v-4.486q0-.885-.235-1.185-.235-.316-.832-.316a2 2 0 0 0-.502.08 7 7 0 0 0-.549.189 5 5 0 0 0-.518.221l-.439.221v.332q.015.206.015.474v4.47a.35.35 0 0 1-.062.22q-.063.08-.236.08h-1.145q-.267 0-.267-.3v-4.565q0-.726-.22-1.074-.219-.348-.816-.348-.204 0-.47.064-.252.063-.534.173a11 11 0 0 0-.533.237q-.267.126-.487.237v5.275q0 .3-.298.3h-1.13q-.282 0-.282-.3v-7.123q0-.316.282-.316h1.114q.315 0 .314.316v.458l.016.016q.235-.157.502-.316a3.6 3.6 0 0 1 .565-.3q.314-.127.627-.205.315-.095.644-.11.675 0 1.224.22.564.206.926.885a7.6 7.6 0 0 1 1.302-.774 3.4 3.4 0 0 1 1.459-.332q.77 0 1.224.237.455.237.691.648.235.395.298.931.063.537.062 1.122zm8.305 0a.35.35 0 0 1-.063.221q-.048.08-.22.08h-1.13q-.282 0-.282-.285v-.505h-.031q0-.015-.016-.016-.204.142-.487.316a7 7 0 0 1-.612.3 4 4 0 0 1-.69.221q-.345.095-.69.095-.77 0-1.271-.269a2.2 2.2 0 0 1-.785-.79 3.9 3.9 0 0 1-.408-1.216 11 11 0 0 1-.11-1.626q0-.964.126-1.722.141-.774.486-1.31.345-.538.942-.806.612-.285 1.569-.285.972 0 1.946.364h.015q0-.015.016-.016v-3.27q0-.158.047-.236.062-.08.251-.08h1.114q.189 0 .235.095a.43.43 0 0 1 .048.222zm-1.711-5.812a6 6 0 0 0-.988-.205 5.6 5.6 0 0 0-.816-.063q-.424 0-.722.126a.97.97 0 0 0-.471.426q-.173.3-.251.806a8 8 0 0 0-.078 1.232q0 .758.062 1.232.079.458.236.71.156.237.376.332.22.08.534.08.236 0 .533-.08t.597-.19q.297-.11.549-.22.267-.127.439-.222zm8.164 2.59h-1.914q-.596 0-.942.285-.345.268-.345 1.042 0 .521.204.727.22.19.769.19.252 0 .549-.064.298-.063.597-.174.297-.111.58-.237.282-.142.502-.268zm.094 2.622a5.2 5.2 0 0 1-1.349.742 4.2 4.2 0 0 1-1.538.285q-.628 0-1.051-.158a1.8 1.8 0 0 1-.659-.458 1.95 1.95 0 0 1-.345-.711 4 4 0 0 1-.094-.916q-.016-1.39.721-2.006.738-.632 2.229-.632h2.008v-.41q0-.348-.078-.585a.76.76 0 0 0-.252-.41 1.1 1.1 0 0 0-.502-.221 4 4 0 0 0-.8-.063q-.188 0-.471.015l-.565.032q-.282.015-.58.047-.282.031-.518.048a1.3 1.3 0 0 1-.329.015q-.079-.031-.11-.205l-.141-.584q-.032-.159.031-.253.063-.11.329-.221.252-.095.597-.158t.706-.095q.36-.047.706-.063.361-.032.643-.032 1.02 0 1.616.206.612.205.926.584.314.363.408.9t.094 1.2v3.049q0 .237.016.379a.8.8 0 0 0 .078.205q.063.063.173.095t.298.047q.173.016.236.064.062.048.062.173v.664q0 .269-.376.331a5 5 0 0 1-.377.048 2 2 0 0 1-.361.031q-.549 0-.894-.205-.33-.206-.455-.758zm9.369-1.421q0 .694-.267 1.168a2.1 2.1 0 0 1-.722.743q-.439.285-1.004.41a5.4 5.4 0 0 1-1.177.127q-.595 0-1.287-.095-.69-.08-1.145-.253-.235-.094-.298-.205a.5.5 0 0 1-.032-.316l.11-.521q.031-.19.126-.221.095-.048.282-.016.252.048.549.079l.612.063q.315.015.581.032.282.015.486.016.754 0 1.083-.206.33-.22.33-.695 0-.268-.063-.442a.53.53 0 0 0-.188-.284 1.1 1.1 0 0 0-.393-.174 3.3 3.3 0 0 0-.612-.126 11 11 0 0 1-1.098-.206 3.5 3.5 0 0 1-.926-.363 1.94 1.94 0 0 1-.627-.648q-.236-.41-.236-1.058 0-1.168.816-1.769.816-.615 2.134-.616.236 0 .549.016.315.016.628.063.33.048.643.111.315.063.565.158.393.157.33.474l-.126.568q-.032.174-.125.221-.08.033-.298 0a24 24 0 0 0-1.099-.11 10 10 0 0 0-1.036-.063q-.753 0-1.004.22-.235.207-.235.664 0 .459.298.6.313.143 1.036.253.564.08 1.067.205.517.126.91.38.392.252.627.678.236.427.236 1.138m6.245 1.721q.046.269-.204.395a2.4 2.4 0 0 1-.487.158 5 5 0 0 1-.565.095 5 5 0 0 1-.549.063q-.251.015-.439.016-.69 0-1.083-.19a1.37 1.37 0 0 1-.565-.553 2.1 2.1 0 0 1-.235-.805 9 9 0 0 1-.047-.964v-3.964h-.785q-.172 0-.235-.063-.063-.08-.063-.237v-.774q0-.157.063-.237.063-.078.235-.079h.8v-1.626q0-.174.079-.237a.54.54 0 0 1 .22-.11l1.051-.285q.314-.08.314.19v2.068h1.679q.188 0 .235.08a.35.35 0 0 1 .063.22v.79q0 .157-.063.237-.047.063-.235.063h-1.679v3.933q0 .316.047.49a.5.5 0 0 0 .157.268.7.7 0 0 0 .329.095q.204.015.518.016a10 10 0 0 0 1.051-.064q.126-.016.189.032.062.048.094.19z"></path><path fill="#fff" d="M250.477 46.884q0 .774-.173 1.358-.173.6-.596.995-.408.411-1.083.6-.659.19-1.647.158a.5.5 0 0 1-.204-.063q-.126-.063-.141-.252l-.063-.743q-.032-.189.031-.252.048-.064.22-.095.549-.111.91-.221a1.6 1.6 0 0 0 .596-.269.9.9 0 0 0 .33-.458q.094-.269.094-.726v-7.644q0-.3.314-.3h1.098q.314 0 .314.3zm.063-9.966q0 .19-.032.363a.6.6 0 0 1-.141.285.66.66 0 0 1-.282.205 1.4 1.4 0 0 1-.471.063q-.314 0-.502-.079a.7.7 0 0 1-.267-.205.7.7 0 0 1-.126-.284 2 2 0 0 1-.031-.348q0-.378.188-.632.189-.268.738-.268.58 0 .753.253.173.237.173.647m8.562 5.797q0 .678-.094 1.405a3.5 3.5 0 0 1-.423 1.343q-.346.6-1.036.995-.69.379-1.914.379-1.177 0-1.852-.38-.675-.394-1.02-.994a3.6 3.6 0 0 1-.408-1.343 13 13 0 0 1-.078-1.405q0-.554.094-1.232.11-.68.455-1.264.345-.6 1.004-.995.674-.41 1.805-.41 1.145 0 1.82.347.69.347 1.051.916.361.553.471 1.248.125.694.125 1.39m-1.757.11a8 8 0 0 0-.063-1.09q-.062-.474-.251-.774a1.2 1.2 0 0 0-.518-.473q-.329-.159-.863-.158-.502 0-.816.158a1.2 1.2 0 0 0-.502.473q-.173.316-.251.79a8 8 0 0 0-.063 1.074q0 .632.063 1.106.078.457.251.774.172.3.487.458.314.158.816.158.533 0 .863-.143a1.2 1.2 0 0 0 .533-.458q.189-.316.251-.79.063-.473.063-1.105m.329-7.312q.236.126.063.347l-1.6 2.211q-.126.174-.298.095l-.612-.284q-.173-.096-.079-.3l1.255-2.449q.094-.205.346-.094zm4.981 10.897q0 .3-.298.3h-1.129q-.299 0-.299-.3v-7.123q0-.316.299-.316h1.114q.313 0 .313.316v.695l.032.032q.173-.159.455-.332.282-.19.596-.332.33-.158.659-.284.33-.126.612-.174a.4.4 0 0 1 .251.016q.095.048.126.253l.11 1.058q.015.174-.016.253-.031.078-.283.126-.329.063-.69.158a8 8 0 0 0-.706.19q-.345.094-.643.19a4 4 0 0 0-.503.189zm10.345 0a.35.35 0 0 1-.063.221q-.063.08-.235.08h-1.13q-.298 0-.298-.3l.016-4.439q0-.695-.236-1.121-.219-.427-.894-.427-.235 0-.549.08a5 5 0 0 0-.612.205 7 7 0 0 0-.565.237 7 7 0 0 0-.424.19v5.274q0 .3-.298.3h-1.114q-.298 0-.298-.3v-7.123q0-.316.298-.316h1.114q.298 0 .298.316v.474q.016 0 .016.016h.031q.22-.157.518-.316a6 6 0 0 1 .659-.316q.345-.142.722-.221.377-.095.737-.095.8 0 1.256.253.454.237.69.648.235.41.298.963.063.537.063 1.137zm-130 6.17q0-.325.315-.325h5.802q.3 0 .3.308v1.005q0 .292-.316.292h-4.304v2.788h3.816q.315 0 .315.291v1.005q0 .292-.315.292h-3.816v3.193h4.415q.284 0 .284.308v.989q0 .292-.3.292h-5.881q-.315 0-.315-.292zm11.199 8.444q0-.048.094-.34l.205-.665q.126-.42.3-.924l1.261-3.76a.5.5 0 0 1 .111-.195q.078-.064.252-.064h1.198q.315 0 .189.307l-2.68 7.294a.6.6 0 0 1-.158.26q-.094.08-.283.08h-1.057q-.22.001-.299-.064a.7.7 0 0 1-.142-.26l-2.68-7.293a.34.34 0 0 1-.016-.227q.031-.097.189-.097h1.246q.173 0 .236.064.08.049.142.227l1.261 3.793q.142.47.268.875.111.34.189.649.095.291.126.34zm6.748 1.686q0 .308-.3.308h-1.135q-.299 0-.299-.308V55.4q0-.324.299-.324h1.12q.315 0 .315.324v.713l.031.032q.173-.162.458-.34.284-.195.599-.34a9 9 0 0 1 .662-.292q.332-.13.615-.178.157-.033.252.016.095.048.126.26l.111 1.085a.6.6 0 0 1-.016.26q-.032.08-.284.129-.331.065-.694.162a8 8 0 0 0-.709.195q-.347.098-.647.194-.299.098-.504.195zm10.425-3.793q0 .697-.094 1.442a3.6 3.6 0 0 1-.426 1.378q-.346.615-1.041 1.021-.693.39-1.923.39-1.182 0-1.86-.39a2.8 2.8 0 0 1-1.025-1.02 3.8 3.8 0 0 1-.41-1.379 14 14 0 0 1-.079-1.442q0-.567.095-1.264.11-.697.457-1.297.346-.615 1.009-1.021.678-.422 1.813-.422 1.15 0 1.829.357.693.357 1.056.94.363.567.473 1.28.126.714.126 1.427m-1.766.113a9 9 0 0 0-.063-1.118q-.063-.486-.252-.794a1.2 1.2 0 0 0-.52-.486q-.331-.162-.867-.163-.505 0-.82.163-.315.162-.505.486a2.6 2.6 0 0 0-.252.81 8 8 0 0 0-.063 1.102q0 .648.063 1.135.08.47.252.794.174.308.489.47.316.162.82.162.535 0 .867-.145.347-.163.536-.47.189-.325.252-.811t.063-1.135m.332-7.504q.236.13.063.356l-1.609 2.27q-.125.178-.299.097l-.615-.292q-.174-.097-.079-.308l1.262-2.512q.094-.21.346-.097zm9.797 7.472q0 .99-.142 1.767t-.504 1.313a2.2 2.2 0 0 1-.962.81q-.6.276-1.529.276a6 6 0 0 1-1.971-.357l-.016.016v2.853a.4.4 0 0 1-.063.227q-.047.097-.236.097h-1.12q-.189 0-.252-.081a.5.5 0 0 1-.047-.243V55.4q0-.324.299-.324h1.12q.173 0 .22.097.063.081.063.227v.486l.048.032q.204-.146.488-.307.3-.179.631-.325.332-.145.678-.243.346-.097.694-.097.772 0 1.277.292t.788.826q.3.519.41 1.264.126.746.126 1.67m-1.782-.016q0-.779-.078-1.248-.063-.47-.221-.73a.75.75 0 0 0-.394-.34 1.3 1.3 0 0 0-.536-.097q-.237 0-.536.08-.3.083-.599.195-.285.097-.552.227-.252.13-.426.227v4.052q.536.162.962.227.441.048.851.049.426 0 .71-.114a1 1 0 0 0 .473-.437q.189-.309.268-.81.078-.519.078-1.281m9.878 3.728q0 .308-.3.308h-1.119q-.174 0-.237-.081a.36.36 0 0 1-.063-.227v-.503l-.031-.016a8 8 0 0 1-.552.34q-.3.162-.647.308a4 4 0 0 1-.725.227 2.8 2.8 0 0 1-.725.097q-.804 0-1.277-.226a1.6 1.6 0 0 1-.694-.633 2.4 2.4 0 0 1-.299-.956 10 10 0 0 1-.063-1.183V55.4q0-.324.299-.324h1.151q.284 0 .284.324v4.554q0 .373.047.665t.173.502q.127.195.347.308.22.114.584.114.252 0 .551-.081.317-.082.615-.195.3-.129.552-.243l.41-.21V55.4q0-.146.063-.227.063-.097.237-.097h1.119q.3 0 .3.324zm7.461-2.075q0 .713-.268 1.2a2.16 2.16 0 0 1-.726.761q-.44.292-1.009.422a5.3 5.3 0 0 1-1.182.13q-.599 0-1.293-.098-.693-.08-1.151-.26-.236-.096-.299-.21a.54.54 0 0 1-.032-.324l.111-.535q.032-.195.126-.227.094-.048.283-.016.254.049.552.08l.615.066q.315.015.584.032.284.016.488.016.757 0 1.088-.21.331-.228.331-.714 0-.275-.063-.453a.54.54 0 0 0-.189-.292 1.05 1.05 0 0 0-.394-.178 3.2 3.2 0 0 0-.615-.13 11 11 0 0 1-1.104-.21 3.4 3.4 0 0 1-.93-.373 2 2 0 0 1-.631-.665q-.236-.421-.236-1.086 0-1.2.82-1.815.82-.633 2.144-.633.237 0 .552.017.315.015.63.065.332.048.647.113t.567.162q.394.162.331.486l-.126.584q-.031.178-.126.227-.078.031-.299 0a24 24 0 0 0-1.104-.114 10 10 0 0 0-1.041-.065q-.756 0-1.009.227-.236.21-.236.681 0 .47.3.616.315.146 1.04.26a10 10 0 0 1 1.072.21q.52.13.915.39.394.258.63.696.237.437.237 1.167m6.243-1.232h-1.924q-.598 0-.946.292-.346.276-.346 1.07 0 .535.204.745.221.195.773.195.252 0 .552-.065a4 4 0 0 0 .599-.178q.3-.114.583-.244.284-.146.505-.275zm.094 2.69a5.2 5.2 0 0 1-1.356.763 4.2 4.2 0 0 1-1.545.291q-.63 0-1.056-.162a1.8 1.8 0 0 1-.662-.47 2 2 0 0 1-.347-.73 4.3 4.3 0 0 1-.095-.94q-.015-1.425.726-2.058.741-.648 2.238-.648h2.019v-.422q0-.356-.079-.6a.78.78 0 0 0-.253-.42 1.1 1.1 0 0 0-.504-.228 4 4 0 0 0-.804-.064q-.19 0-.473.016l-.568.032q-.283.016-.583.049-.284.032-.52.048a1.3 1.3 0 0 1-.331.017q-.08-.033-.111-.211l-.142-.6q-.031-.162.032-.259.063-.114.331-.227.252-.097.599-.162t.71-.097q.362-.049.709-.065.363-.032.646-.032 1.026 0 1.624.21.615.21.93.6.316.372.41.924.095.55.095 1.232v3.128q0 .243.016.389a.8.8 0 0 0 .079.21.4.4 0 0 0 .173.098q.11.032.3.048.173.017.236.065.063.05.063.178v.681q0 .276-.378.34a5 5 0 0 1-.379.05 2 2 0 0 1-.362.032q-.552 0-.899-.211-.331-.21-.457-.778zm14.931.617a.36.36 0 0 1-.063.227q-.047.08-.221.08h-1.135q-.299 0-.299-.307v-4.604q0-.907-.237-1.215-.236-.324-.835-.324-.222 0-.505.08a7 7 0 0 0-.552.195q-.267.097-.52.227l-.441.227v.34q.015.211.015.487v4.587a.36.36 0 0 1-.063.227q-.063.08-.236.08h-1.151q-.268 0-.268-.307v-4.684q0-.747-.221-1.103-.22-.356-.82-.356a2 2 0 0 0-.473.065 5 5 0 0 0-.536.178q-.267.113-.536.243-.267.13-.488.243v5.414q0 .308-.3.308h-1.135q-.284 0-.284-.308V55.4q0-.324.284-.324h1.119q.315 0 .316.324v.47l.015.016q.237-.162.505-.324.268-.179.567-.308a5 5 0 0 1 .631-.21q.316-.098.646-.114.678 0 1.23.227.568.21.93.907.6-.453 1.309-.794.71-.34 1.466-.34.772 0 1.23.243t.694.664q.236.406.299.957t.063 1.15zm8.486-3.728q0 .988-.158 1.767-.142.778-.52 1.312a2.45 2.45 0 0 1-1.041.827q-.662.276-1.687.276-.378 0-.804-.033a7 7 0 0 1-.82-.08 9 9 0 0 1-.772-.13 6 6 0 0 1-.647-.179q-.267-.113-.346-.308a1.1 1.1 0 0 1-.079-.405V51.915q0-.308.315-.308h1.119q.19 0 .253.097a.33.33 0 0 1 .063.211v3.404a6 6 0 0 1 1.088-.308q.487-.081.867-.081.977 0 1.592.291.615.292.962.827.362.535.489 1.28.126.747.126 1.654m-1.798.146q0-.714-.078-1.216-.08-.503-.253-.81a1.04 1.04 0 0 0-.425-.454 1.5 1.5 0 0 0-.647-.162q-.252 0-.457.016-.206 0-.426.032a5 5 0 0 0-.457.098q-.253.048-.583.13v4.684q.378.064.788.097.426.032.804.032.394 0 .71-.08.315-.082.536-.325.236-.26.362-.746t.126-1.296m8.109.275h-1.923q-.599 0-.946.292-.347.276-.347 1.07 0 .535.205.745.22.195.773.195.252 0 .551-.065t.6-.178q.299-.114.583-.244.284-.146.504-.275zm.095 2.69a5.2 5.2 0 0 1-1.356.763 4.2 4.2 0 0 1-1.545.291q-.63 0-1.056-.162a1.8 1.8 0 0 1-.662-.47 2 2 0 0 1-.347-.73 4.3 4.3 0 0 1-.095-.94q-.015-1.425.725-2.058.742-.648 2.239-.648h2.018v-.422q0-.356-.079-.6a.8.8 0 0 0-.252-.42 1.1 1.1 0 0 0-.504-.228 4 4 0 0 0-.804-.064q-.19 0-.473.016l-.568.032q-.284.016-.583.049-.285.032-.521.048a1.3 1.3 0 0 1-.331.017q-.078-.033-.11-.211l-.142-.6q-.031-.162.032-.259.063-.114.331-.227.252-.097.599-.162a8 8 0 0 1 .709-.097q.362-.049.71-.065.362-.032.646-.032 1.025 0 1.624.21.615.21.93.6.315.372.41.924.095.55.095 1.232v3.128q0 .243.015.389a.8.8 0 0 0 .079.21q.063.066.174.098t.299.048q.174.017.237.065.063.05.063.178v.681q0 .276-.379.34a5 5 0 0 1-.378.05 2 2 0 0 1-.363.032q-.551 0-.898-.211-.331-.21-.457-.778zm10.311.617a.36.36 0 0 1-.063.227q-.062.08-.236.08h-1.135q-.3 0-.3-.307l.016-4.555q0-.713-.236-1.15-.221-.438-.899-.438-.237 0-.552.08-.3.082-.615.212-.3.113-.567.243-.269.113-.426.194v5.414q0 .308-.3.308h-1.119q-.3 0-.3-.308V55.4q0-.324.3-.324h1.119q.3 0 .3.324v.486q.016 0 .016.016h.031q.22-.162.521-.324.315-.178.662-.324a4 4 0 0 1 .725-.227q.378-.097.741-.097.804 0 1.261.259.457.243.694.665.236.42.299.988.063.552.063 1.167zm8.298 0a.36.36 0 0 1-.063.227q-.047.08-.22.08h-1.136q-.283 0-.283-.291v-.519h-.032q0-.015-.016-.016-.204.145-.488.324a7 7 0 0 1-.615.308 3.7 3.7 0 0 1-.694.227 2.6 2.6 0 0 1-.694.097q-.772 0-1.277-.275a2.2 2.2 0 0 1-.788-.81 4 4 0 0 1-.41-1.249 11.6 11.6 0 0 1-.11-1.67q0-.987.126-1.766.141-.795.489-1.345.346-.55.946-.827.614-.291 1.576-.291.978 0 1.955.372h.016q0-.015.016-.016v-3.355a.5.5 0 0 1 .047-.243q.063-.081.252-.081h1.12q.19 0 .236.097.047.081.047.227zm-1.718-5.965a6 6 0 0 0-.993-.21 5.5 5.5 0 0 0-.82-.066q-.426 0-.725.13a.98.98 0 0 0-.473.438q-.174.307-.253.826a8.5 8.5 0 0 0-.078 1.265q0 .777.063 1.264.078.47.236.73a.9.9 0 0 0 .378.34q.221.08.536.08.237 0 .537-.08.299-.082.599-.195.299-.114.551-.227.268-.13.442-.227zm9.196 3.89q0 .713-.268 1.2-.268.47-.725.761a3 3 0 0 1-1.009.422q-.568.13-1.183.13a9 9 0 0 1-1.292-.098q-.695-.08-1.151-.26-.237-.096-.3-.21a.54.54 0 0 1-.031-.324l.11-.535q.031-.195.126-.227.095-.048.284-.016.252.049.552.08l.615.066q.315.015.583.032.283.016.489.016.756 0 1.087-.21.332-.228.332-.714a1.4 1.4 0 0 0-.064-.453.54.54 0 0 0-.189-.292 1 1 0 0 0-.394-.178 3.2 3.2 0 0 0-.615-.13 11 11 0 0 1-1.103-.21 3.5 3.5 0 0 1-.931-.373 2 2 0 0 1-.63-.665q-.237-.421-.237-1.086 0-1.2.82-1.815.82-.633 2.144-.633.237 0 .552.017.316.015.631.065.33.048.646.113.315.065.568.162.394.162.331.486l-.126.584q-.031.178-.126.227-.08.031-.3 0a24 24 0 0 0-1.104-.114 10 10 0 0 0-1.04-.065q-.757 0-1.009.227-.237.21-.237.681 0 .47.3.616.315.146 1.04.26a10 10 0 0 1 1.073.21q.52.13.914.39.394.258.631.696.236.437.236 1.167m3.5-7.666q0 .194-.032.372a.6.6 0 0 1-.142.292.66.66 0 0 1-.283.21 1.4 1.4 0 0 1-.473.066 1.3 1.3 0 0 1-.505-.081.7.7 0 0 1-.268-.211.7.7 0 0 1-.126-.292 2 2 0 0 1-.032-.357q0-.389.174-.648.189-.275.757-.275.584 0 .756.259.174.243.174.664m-.095 9.74a.4.4 0 0 1-.063.228q-.047.08-.221.08h-1.119q-.315 0-.315-.307v-7.327q0-.307.315-.307h1.119q.174 0 .221.097a.33.33 0 0 1 .063.21zm8.625.002a.36.36 0 0 1-.063.227q-.063.08-.236.08h-1.135q-.3 0-.3-.307l.016-4.555q0-.713-.237-1.15-.22-.438-.898-.438-.237 0-.552.08-.3.082-.615.212-.3.113-.568.243-.267.113-.425.194v5.414q0 .308-.3.308h-1.119q-.3 0-.3-.308V55.4q0-.324.3-.324h1.119q.3 0 .3.324v.486q.015 0 .015.016h.032q.221-.162.52-.324a6 6 0 0 1 .662-.324 4 4 0 0 1 .726-.227q.378-.097.741-.097.804 0 1.261.259.457.243.694.665.236.42.299.988.063.552.063 1.167zM277 60.635q0 .713-.268 1.2-.268.47-.725.761a3 3 0 0 1-1.009.422q-.568.13-1.183.13a9 9 0 0 1-1.292-.098q-.695-.08-1.151-.26-.237-.096-.3-.21a.53.53 0 0 1-.031-.324l.11-.535q.031-.195.126-.227.095-.048.284-.016.252.049.552.08l.614.066q.316.015.584.032.284.016.489.016.757 0 1.087-.21.331-.228.331-.714 0-.275-.063-.453a.54.54 0 0 0-.189-.292 1 1 0 0 0-.394-.178 3.2 3.2 0 0 0-.615-.13 11 11 0 0 1-1.103-.21 3.5 3.5 0 0 1-.931-.373 2 2 0 0 1-.63-.665q-.237-.421-.237-1.086 0-1.2.82-1.815.82-.633 2.144-.633.237 0 .552.017.315.015.631.065.33.048.646.113.315.065.568.162.393.162.331.486l-.126.584q-.031.178-.127.227-.078.031-.299 0a24 24 0 0 0-1.104-.114 10 10 0 0 0-1.04-.065q-.757 0-1.009.227-.237.21-.237.681 0 .47.3.616.315.146 1.04.26.568.08 1.072.21.52.13.915.39.394.258.631.696.236.437.236 1.167"></path><path fill="#fff" fill-rule="evenodd" d="M286 66.7h3.3V28H286z" clip-rule="evenodd"></path>', 27), L21 = [
  b21
];
function x21(t, e) {
  return T(), N("svg", M21, [...L21]);
}
const S21 = { render: x21 }, C21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, k21 = /* @__PURE__ */ U1('<mask id="a" width="67" height="25" x="0" y="1" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 1h66.2v24.5H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M0 25.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V1c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 19 0 22.9 0 22.9z" clip-rule="evenodd"></path></g><mask id="b" width="67" height="23" x="0" y="6" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 6.2h66.1V29H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M53.4 18.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V29c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="c" width="67" height="22" x="0" y="11" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 11.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M60.4 18.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 29.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="d" width="67" height="18" x="0" y="22" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 22.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 31.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 36.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 36.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 40.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="e" width="67" height="11" x="0" y="39" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 39.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.8 45.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 47.2v2.6L33.6 48l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 49.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 50.8v2.6L33.3 52c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="f" width="67" height="7" x="0" y="50" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 50.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#f)"><path fill="#fff" fill-rule="evenodd" d="M50.3 53.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 57.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 57.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V61c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 64.8v2.6h66.1zM60.2 23c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 33.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 27.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 33.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 38.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 43.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 49s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 6.4 94.3 6.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V37c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 37.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 40.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="g" width="269" height="70" x="0" y="1" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.8h268.7V1H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#g)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 67.3h57.9V28.6H27.5z"></path><path fill="#FFF100" d="M57.1 34.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 37l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 35.8h2L50.9 37l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 34zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 47h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 47h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 59.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M265.4 67.7h3.3V29h-3.3zm-122.1-27c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.901.3c.199.1.299.1.299.2.1.1.1.2 0 .4l-.2.8c0 .1-.099.2-.099.3-.101.1-.201.1-.401 0-.5-.1-1-.1-1.599-.2-.601-.1-1.101-.1-1.601-.1-.7 0-1.2.1-1.6.4s-.7.6-1 1-.4 1-.4 1.5c-.1.6-.1 1.2-.1 1.9s0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.601.4.599 0 1.099 0 1.599-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.201.8q.15.45-.301.6-.3.15-.9.3c-.299.1-.7.1-1 .2-.299.1-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.3-.7-.4-1.6-.4-2.4m17.4 1.6c0-.5 0-1-.101-1.4a12 12 0 0 0-.299-1c-.201-.3-.4-.5-.701-.6-.299-.1-.599-.2-1.099-.2-.401 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.301.6-.301 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.301 1s.4.5.6.6.599.2 1 .2c.5 0 .8-.1 1.099-.2.301-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.9.101-1.4m2.3-.1c0 .6 0 1.2-.1 1.8s-.301 1.2-.6 1.7c-.3.5-.701.9-1.3 1.3-.6.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.3-1.3c-.301-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.299-.5 2.299-.5s1.801.1 2.301.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m16.2 4.9c0 .1-.101.1-.3.1h-1.4c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.1-.699.2-.2.1-.5.2-.7.3l-.601.3v6.7c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4V41c0-.6-.1-1.1-.301-1.4-.199-.3-.5-.4-1-.4-.199 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3v6.7c0 .3-.1.4-.401.4H165.2c-.2 0-.4-.1-.4-.4v-9c0-.3.1-.4.4-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3c.301-.1.5-.1.801-.1.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.199-.4 1.9-.4 1.2.1 1.6.3.699.5.9.8c.2.3.299.7.4 1.2.1.5.1.9.1 1.4v5.9c0 .2 0 .3-.1.3m16.6 0c0 .1-.1.1-.3.1H194c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.699.2c-.201.1-.5.2-.701.3l-.6.3v6.7c0 .1 0 .2-.1.3-.099.1-.2.1-.3.1h-1.5c-.2 0-.299-.1-.299-.4V41c0-.6-.101-1.1-.301-1.4s-.5-.4-1-.4c-.199 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.099.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9c0-.3.101-.4.4-.4h1.4c.301 0 .4.1.4.4v.6c.2-.1.401-.3.6-.4.2-.1.5-.3.7-.4s.5-.2.8-.3.5-.1.801-.1c.599 0 1.099.1 1.599.3s.901.6 1.2 1.1c.5-.4 1.1-.7 1.701-1 .599-.3 1.199-.4 1.899-.4s1.2.1 1.601.3c.399.2.699.5.899.8s.3.7.4 1.2.1.9.1 1.4zm4.7-.3c0 .1 0 .2-.1.3s-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm.1-12v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.3.2.7m9.7 9.5q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.199-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1s.5 0 .7 0h.6c.601 0 1.101-.1 1.4-.3.3-.2.4-.5.4-.9 0-.2 0-.4-.1-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.4-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.699c.301 0 .5 0 .801.1.299 0 .5.1.799.1.3.1.5.1.701.2.299.1.5.3.399.6l-.2.7c0 .1-.1.2-.199.3-.101.1-.201 0-.401 0-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.301.3c.5.1.899.2 1.399.3.4.1.8.3 1.2.5.401.2.6.5.8.9.4.5.5 1 .5 1.6m9.2 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1s.5 0 .7 0h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.3.1.5.1.7.2.3.1.5.3.4.6v1c0 .1-.1.2-.2.3s-.2 0-.4 0c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.2.2.3.7.3 1.3m4.3 2.5c0 .1 0 .2-.1.3s-.1.1-.299.1H222c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.401c.099 0 .199 0 .299.1 0 .1.1.2.1.3zm.2-12v.5c0 .1-.099.3-.2.4-.1.1-.2.2-.399.3-.201.1-.401.1-.601.1-.3 0-.5 0-.6-.1-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.101.1.2.3.2.7m8.6 7.5c0-.5 0-1-.1-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.801.1-1 .2-.2.1-.5.3-.601.6-.2.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.1.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.1-.4.1-.9.1-1.4m2.2-.1c0 .6 0 1.2-.099 1.8-.101.6-.3 1.2-.601 1.7-.3.5-.699.9-1.3 1.3-.599.3-1.399.5-2.399.5S228.6 47.3 228 47s-1-.7-1.299-1.3c-.3-.5-.5-1.1-.5-1.7-.101-.6-.101-1.2-.101-1.8 0-.5 0-1 .101-1.6.099-.6.299-1.1.599-1.6s.7-.9 1.3-1.3c.601-.3 1.301-.5 2.301-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .6 1.6.2.6.2 1.2.2 1.8m10.401 4.9c-.101.1-.2.1-.3.1h-1.5c-.301 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.601-.5-1.2-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.2-.3.1-.5.2-.7.3-.201.1-.4.2-.5.2v6.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.401-.1-.401-.4v-9c0-.3.101-.4.401-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.899-.1.701 0 1.201.1 1.601.3s.7.5.899.8c.201.3.301.8.401 1.2.099.5.099.9.099 1.5v5.8c.201.2.201.3.101.3M251.5 39c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5-.7-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2c-.3 0-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3 1.3-.5 2.3-.5c.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3zM147.201 59c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9-.101-.3-.2-.5-.3-.8s-.301-.4-.6-.5c-.3-.1-.6-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8.199.2.4.3.699.4.301.1.601.1 1.101.1.399 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2c-.3 0-.601.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3c.6-.4 1.3-.5 2.3-.5.9 0 1.6.1 2.199.4.601.3 1 .6 1.301 1s.5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.401.3-.8.3h-5.5zm16.299 4.3h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4v9c-.1.6-.3.7-.5.7m5.1-.4c0 .3-.1.4-.399.4h-1.5c-.3 0-.401-.1-.401-.4v-9c0-.3.101-.4.401-.4h1.399c.301 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.801-.4.3-.1.599-.2.8-.4.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.1 1.3v.3c0 .1-.1.1-.399.2s-.601.1-.901.2-.599.2-.899.2-.601.2-.801.2c-.3.1-.5.2-.6.2zm11-4.5c0-.5 0-1-.1-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.801.1-1 .2-.2.1-.5.3-.601.6-.2.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.1.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.1-.4.1-.9.1-1.4m2.2-.1c0 .6 0 1.2-.099 1.8-.101.6-.3 1.2-.601 1.7-.3.5-.699.9-1.3 1.3-.599.3-1.399.5-2.399.5S173.6 67.3 173 67s-1-.7-1.299-1.3c-.3-.5-.5-1.1-.5-1.7-.101-.6-.101-1.2-.101-1.8 0-.5 0-1 .101-1.6.099-.6.299-1.1.599-1.6s.7-.9 1.3-1.3c.601-.3 1.301-.5 2.301-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .6 1.6.2.6.2 1.2.2 1.8m8.4 0c0-.6 0-1.2-.101-1.5-.099-.3-.199-.7-.299-.9s-.3-.4-.5-.4c-.201-.1-.4-.1-.701-.1-.199 0-.399 0-.699.1-.301.1-.5.1-.801.2-.199.1-.5.2-.699.3l-.6.3v5q.75.15 1.2.3c.4 0 .7.1 1.099.1.401 0 .701 0 .901-.2.2-.1.4-.3.599-.5.201-.3.301-.6.301-1 .3-.5.3-1 .3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3 0 .1-.201.1-.3.1h-1.401c-.199 0-.299 0-.299-.1s-.1-.2-.1-.3V57.8c0-.3.1-.4.399-.4h1.401c.099 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.3.599-.4.201-.1.5-.3.801-.4l.9-.3c.299-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.799.6 1 1s.4 1 .5 1.6.2 1.3.2 2m5.8-3.2c-.399 0-.7.1-.899.2-.201.1-.401.3-.601.5s-.3.5-.3.8c-.099.3-.099.6-.099 1h4c0-.3 0-.6-.101-.9-.1-.3-.2-.5-.3-.8s-.3-.4-.599-.5c-.301-.1-.601-.3-1.101-.3m-2 3.9c0 .5.101.9.2 1.3.1.3.3.6.5.8s.401.3.7.4c.3.1.6.1 1.1.1.4 0 .8 0 1.3-.1s.9-.1 1.301-.1h.399c.101 0 .101.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.399.2-.7.2s-.5.1-.8.2c-.3 0-.6.1-.899.1h-.801c-1 0-1.699-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.599-1.6-.101-.6-.201-1.2-.201-1.9 0-.5 0-1 .1-1.6.101-.6.3-1.2.601-1.7.299-.5.699-1 1.299-1.3s1.3-.5 2.3-.5c.901 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9-.199.2-.4.3-.8.3h-5.5zm14.2-.1h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.2 3.3c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6s-.4-.5-.4-.9-.1-.7-.1-1.2c0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8s-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.2l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.2-.6-.5-.7-1"></path></g>', 25), E21 = [
  k21
];
function A21(t, e) {
  return T(), N("svg", C21, [...E21]);
}
const F21 = { render: A21 }, T21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, I21 = /* @__PURE__ */ U1('<path fill="#fff" d="M158.018 42.813h2.752c-.215 1.42-.559 2.924-.903 3.956l1.183.624c.602-1.462 1.139-3.763 1.462-5.74l-1.054-.41-.279.087h-5.698c.258-1.161.473-2.365.667-3.59l-1.613-.237c-.43 3.418-1.225 6.772-2.623 8.9.387.216 1.054.732 1.333 1.011.753-1.247 1.354-2.838 1.849-4.6h1.376v3.03c.021 1.463-.494 5.44-3.354 8.343v-1.183h-7.568v-12.62h7.374V38.9H144v17.2h1.548v-1.612h7.267q-.774.71-1.741 1.29c.279.3.752.946.924 1.29 3.677-2.258 4.988-6.192 5.246-7.998.236 1.741 1.441 5.848 4.623 7.976.215-.365.709-1.01.989-1.354-4.15-2.688-4.859-8.149-4.838-9.847zm-7.761-1.784a32 32 0 0 1-1.161 4.3 43 43 0 0 0-2.43-2.408l-.946.989a41 41 0 0 1 2.817 2.924c-.753 1.763-1.677 3.31-2.774 4.515.323.236.946.73 1.204.989 1.011-1.183 1.871-2.623 2.602-4.257.86 1.053 1.569 2.085 2.021 2.924l1.053-1.161c-.538-.946-1.419-2.107-2.429-3.29a38 38 0 0 0 1.505-5.267zm18.554-3.139v6.622c0 3.934-.365 8.191-3.827 11.395.344.28.903.817 1.161 1.204 3.806-3.526 4.236-8.213 4.236-12.6V37.89zm6.085.451v17.33h1.569V38.34zm6.364-.537v19.07h1.591v-19.07zm-14.857 4.966c-.323 1.892-1.032 4.171-1.999 5.655l1.354.602c.989-1.505 1.613-3.956 2-5.87zm4.515.882c.753 1.72 1.419 3.999 1.613 5.396l1.397-.602c-.215-1.376-.946-3.59-1.698-5.31zm6.042-.108c.967 1.677 1.956 3.935 2.322 5.332l1.354-.71c-.387-1.375-1.44-3.568-2.451-5.224zm22.403 6.966a7.5 7.5 0 0 1-2.623 2.817 87 87 0 0 0-4.924-1.054c.409-.559.817-1.16 1.226-1.763zm-4.258-2.988h1.548v-4.193c2.021 2.064 5.225 3.849 8.128 4.73.193-.408.666-.989 1.01-1.333-2.558-.645-5.375-1.956-7.267-3.504h6.816V41.91h-8.687v-2.279c2.451-.236 4.752-.537 6.537-.946l-1.183-1.14c-3.161.71-9.137 1.162-14.039 1.29.129.323.322.904.344 1.248 2.15-.043 4.514-.15 6.793-.323v2.15h-8.621v1.312h6.815c-1.913 1.634-4.729 3.053-7.288 3.74.323.302.774.86.968 1.248 2.902-.903 6.127-2.752 8.126-4.88v3.934l-1.526-.409c-.43.71-.924 1.484-1.462 2.28h-5.869v1.375h4.945a115 115 0 0 1-2.172 3.032l1.484.516.451-.602c1.312.258 2.602.537 3.849.838-2.086.817-4.816 1.247-8.256 1.44.279.366.516.968.623 1.42 4.257-.344 7.504-1.01 9.89-2.3 2.709.73 5.139 1.526 6.945 2.278l.967-1.311c-1.655-.667-3.87-1.355-6.321-2.021 1.075-.882 1.892-1.957 2.494-3.29h4.472v-1.376h-11.653a47 47 0 0 0 1.139-1.741zm27.456-5.655h-10.169v-2.236h10.169zm1.655-3.526H210.8v4.816h13.416zm-12.727 12.513h11.932v1.548h-11.932zm0-2.644h11.932v1.505h-11.932zm0-2.645h11.932v1.505h-11.932zm13.566 8.02v-9.202h-15.158v9.202h4.021c-1.333.881-4.106 1.87-6.342 2.386.387.323.903.86 1.182 1.183 2.193-.56 4.967-1.591 6.687-2.645l-1.441-.924zm-5.891 1.075c2.258.666 5.139 1.763 6.751 2.515l1.376-1.16c-1.677-.689-4.536-1.742-6.751-2.387zm10.986-4.945h5.655c-.58 1.57-1.505 3.526-2.322 5.01-1.161.042-2.236.064-3.16.085l.214 1.57c3.677-.13 9.246-.366 14.513-.624.409.516.731 1.01.989 1.44l1.44-.88c-.989-1.592-3.074-3.914-5.052-5.612l-1.354.73c.946.84 1.956 1.893 2.837 2.903-3.01.13-6.041.237-8.707.323.86-1.505 1.784-3.354 2.537-4.945h10.084V48.23H230.15zm3.656-5.569v1.462h10.169v-1.462zm4.128-6.6c-1.656 2.73-5.225 5.826-8.901 7.59.344.322.752.902.924 1.268 3.655-1.806 7.138-4.752 8.88-7.332 1.999 2.774 5.762 5.633 9.073 7.246.279-.473.666-1.032 1.031-1.42-3.375-1.397-7.116-4.192-9.373-7.352z"></path><path fill="#fff" fill-rule="evenodd" d="M255.942 66.7h3.3V28h-3.3zM0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="24" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.602 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.899 18.9 14.099 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.799 11.3 13.999 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.299 9.6 13.999 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.799 9.3 13.999 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.799 7.9 13.999 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.399 5.7 13.999 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.202 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm-.002 5.4s8.299 2.6 13.999 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.799 1.2 13.999 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.699.4 13.999.5 26.2 1 26.2 1v.6h-40.2zm27.501-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.699 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" d="M27.5 66.3h57.9V27.6H27.5z" clip-rule="evenodd"></path><path fill="#FFF100" fill-rule="evenodd" d="M57.098 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201-1.6 1.201.6-1.901-1.6-1.199h2l.6-1.9zm6.402-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm-.002-22.4h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.804 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.698 4.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z" clip-rule="evenodd"></path>', 26), O21 = [
  I21
];
function N21(t, e) {
  return T(), N("svg", T21, [...O21]);
}
const P21 = { render: N21 }, B21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, V21 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z"></path></g><path fill="#fff" d="M143.42 33.12q0-.4.4-.4h7.36q.38 0 .38.38v1.24q0 .36-.4.36h-5.46v3.44h4.84q.4 0 .4.36v1.24q0 .36-.4.36h-4.84v3.94h5.6q.36 0 .36.38v1.22q0 .36-.38.36h-7.46q-.4 0-.4-.36zm18.706 12.5q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V45l-.04-.02q-.3.2-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V36.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1a8 8 0 0 0 .78-.24q.38-.16.7-.3l.52-.26V36.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4zm4.705 0q0 .38-.38.38h-1.44q-.38 0-.38-.38V36.6q0-.4.38-.4h1.42q.4 0 .4.4v.88l.04.04a4 4 0 0 1 .58-.42q.36-.24.76-.42.42-.2.84-.36t.78-.22a.5.5 0 0 1 .32.02q.12.06.16.32l.14 1.34a.7.7 0 0 1-.02.32q-.039.1-.36.16-.42.08-.88.2a10 10 0 0 0-.9.24q-.44.12-.82.24t-.64.24zm13.226-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.848-.04q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12.08.1.08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.981 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a9 9 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.561.06 1.08.06.54 0 .9-.14.381-.16.6-.54.24-.38.34-1 .1-.64.1-1.58m10.11.52h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96zm-3.62-10q-.38 0-.6-.08a.85.85 0 0 1-.34-.26.9.9 0 0 1-.16-.36 4 4 0 0 1-.02-.42q0-.46.2-.76.22-.3.92-.3t.9.3q.2.28.2.76 0 .46-.2.8-.2.32-.9.32m3.88 0q-.72 0-.92-.34a1.64 1.64 0 0 1-.18-.78q0-.46.22-.76t.88-.3q.7 0 .9.3.22.28.22.76 0 .46-.2.8-.2.32-.92.32m6.421 6.84q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.64.64 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42-.861-.42-1.32-1.12t-.62-1.6a12.5 12.5 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44a8.3 8.3 0 0 1 .2 1.6q.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a6.6 6.6 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m13.416 5.26q0 .88-.34 1.48-.34.58-.92.94-.56.36-1.28.52t-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88a1.7 1.7 0 0 0-.08-.56.67.67 0 0 0-.24-.36 1.35 1.35 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.5 4.5 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.5.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.76-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m9.3 2.02q.06.22 0 .36t-.34.26q-.58.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.4 4.4 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.399.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1t.66.54q.42.14 1.02.14.459 0 1.2-.04.759-.06 1.38-.14.24-.04.36 0t.16.3zm10.025.54q0 .38-.4.38h-1.42q-.4 0-.4-.38v-2.88q.02-1.44.02-2.9 0-.84-.28-1.34-.26-.52-1.16-.52-.3 0-.7.12a10 10 0 0 0-.78.24 9 9 0 0 0-.72.3q-.34.16-.54.24v6.74a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.42q-.36 0-.36-.38V32.28q0-.38.36-.38h1.42q.4 0 .4.38v4.84a7 7 0 0 1 .64-.34 7 7 0 0 1 .82-.36q.44-.18.92-.28.48-.12.94-.12 1.04 0 1.64.32.6.3.9.82.32.52.4 1.22.1.68.1 1.44zm-94.437 13.5 1.52-1.96 3.36-4.14a.8.8 0 0 1 .28-.22.8.8 0 0 1 .38-.08h1.82q.22 0 .26.12.06.12-.08.28l-4.34 5.28 4.48 7.18q.12.2.04.32-.08.1-.24.1h-1.84q-.26 0-.4-.1-.12-.1-.24-.28l-3.28-5.44-1.76 2.18v3.26q0 .16-.08.28-.06.1-.28.1h-1.5q-.4 0-.4-.38v-12.5q0-.4.4-.4h1.5q.22 0 .28.12a.44.44 0 0 1 .08.28v6zm17.562 1.82q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1a10 10 0 0 0-.08 1.36q0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m18.528 4.54q0 .18-.08.28-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1a9 9 0 0 0-.7.24 6 6 0 0 0-.66.28l-.56.28v.42q.02.26.02.6v5.66q0 .18-.08.28t-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44a2.7 2.7 0 0 0-.6.08q-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4a4.7 4.7 0 0 1 .72-.38q.4-.16.8-.26.4-.12.82-.14.861 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.981 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm16.485 0a.44.44 0 0 1-.08.28q-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.34.12-.66.28l-.56.28v.42a8 8 0 0 1 .02.6v5.66a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.261 0-.6.08-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4.339-.22.72-.38.4-.16.8-.26a3.4 3.4 0 0 1 .82-.14q.86 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.98 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.744-12.02q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm9.802-2.56q0 .88-.34 1.48-.34.58-.92.94-.56.36-1.28.52a7 7 0 0 1-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.64.64 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1l.78.08q.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.3 1.3 0 0 0-.5-.22q-.3-.1-.78-.16a14 14 0 0 1-1.4-.26 4.4 4.4 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.5.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.76-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.399.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m9.179 0q0 .88-.34 1.48a2.7 2.7 0 0 1-.92.94q-.56.36-1.28.52a7 7 0 0 1-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.3 1.3 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.5 4.5 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.501.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.759-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44M224 53.6q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm10.981-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.689 4.54q0 .38-.38.38h-1.42q-.22 0-.3-.1a.44.44 0 0 1-.08-.28V65l-.04-.02q-.3.2-.7.42-.38.2-.82.38t-.92.28q-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V56.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1a8 8 0 0 0 .78-.24q.38-.16.7-.3l.52-.26V56.6a.44.44 0 0 1 .08-.28q.08-.12.3-.12h1.42q.38 0 .38.4zm10.605 0a.44.44 0 0 1-.08.28q-.08.1-.3.1h-1.44q-.38 0-.38-.38l.02-5.62q0-.88-.3-1.42-.28-.54-1.14-.54-.3 0-.7.1a7 7 0 0 0-.78.26 9 9 0 0 0-.72.3 8 8 0 0 0-.54.24v6.68q0 .38-.38.38h-1.42q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.38 0 .38.4v.6q.02 0 .02.02h.04q.28-.2.66-.4.4-.22.84-.4t.92-.28q.48-.12.94-.12 1.02 0 1.6.32.58.3.88.82t.38 1.22q.08.68.08 1.44z"></path><path fill="#fff" fill-rule="evenodd" d="M265 66.7h3.3V28H265z" clip-rule="evenodd"></path>', 26), R21 = [
  V21
];
function H21(t, e) {
  return T(), N("svg", B21, [...R21]);
}
const D21 = { render: H21 }, $21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, U21 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="229" height="71" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.6h228.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m8.1 0c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6.199.6.199 1.2.199 1.8m9.301 2.1q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1a21 21 0 0 1-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.199-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.699-.5 1.6-.8 2.699-.8h.7c.3 0 .5 0 .8.1s.5.1.801.1c.3 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3h-.399c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8s.701.2 1.3.3c.5.1.901.2 1.401.3.4.1.799.3 1.2.5.399.2.599.5.8.9.299.4.4.9.4 1.5m-64.8 16.3 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V53.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm15.4 2c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m16.3 5c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1 0 .2-.1.3m4.7-.3c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.1-12.1v.5c0 .2-.1.3-.201.4-.099.1-.199.2-.399.3s-.4.1-.601.1c-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.199-.4V54c0-.3.1-.6.199-.8.201-.2.5-.3 1-.3s.801.1 1 .3c.201.1.201.4.201.7m9.8 9.5q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.899-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.399.6l-.199.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.301-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.401.8.3.1.699.2 1.3.3.5.1.899.2 1.399.3s.801.3 1.2.5c.3.2.601.5.8.9.4.4.5.9.5 1.5m4.301 2.6c0 .1 0 .2-.101.3 0 .1-.099.1-.299.1H196.6c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.101.2.101.3zm.1-12.1v.5c0 .1-.1.3-.201.4-.099.1-.2.2-.399.3-.2.1-.4.1-.601.1-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.101.1.201.4.201.7m5.299 0v.5c0 .1-.1.3-.2.4s-.199.2-.4.3c-.2.1-.4.1-.6.1-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.199-.4c-.101-.2 0-.3 0-.4 0-.3.099-.6.199-.8s.5-.3 1-.3.801.1 1 .3c.1.1.2.4.2.7m-.1 12.7c0 .7-.1 1.2-.2 1.7-.099.5-.4.9-.8 1.3-.4.3-.799.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.299-.1-.101-.1-.201-.2-.201-.3l-.1-.9V69c0-.1.1-.1.301-.1q.75-.15 1.199-.3c.301-.1.6-.2.801-.4.199-.2.299-.3.399-.6.101-.2.101-.5.101-.9V57c0-.3.099-.4.399-.4h1.4c.3 0 .4.1.4.4v9.6zm8.501-4.7h-2.4c-.5 0-.9.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.2 3.3c-.5.4-1.1.7-1.7.9-.601.2-1.3.4-2 .4-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.801-.6-.199-.2-.399-.5-.399-.9-.101-.3-.101-.7-.101-1.2 0-1.2.301-2 .901-2.6.599-.5 1.599-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.201-.4-.3-.5l-.6-.3c-.301-.1-.6-.1-1-.1H209.1c-.199 0-.5 0-.699.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.201-.3l-.199-.7v-.3c.1-.1.199-.2.4-.3.2-.1.5-.1.799-.2.301-.1.601-.1.901-.1s.599-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.099 1 .099 1.5v4.4c0 .1.101.2.101.3s.1.1.2.1.199 0 .4.1c.1 0 .2 0 .299.1.101 0 .101.1.101.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.101-.3-.399-.1-.599-.4-.699-.9m12.999 1.5h3.3V28h-3.3z"></path></g>', 24), j21 = [
  U21
];
function G21(t, e) {
  return T(), N("svg", $21, [...j21]);
}
const W21 = { render: G21 }, Y21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, X21 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="229" height="71" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.6h228.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm12.8 12.6c0 .1 0 .2-.101.3 0 .1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1 0 .1.101.2.101.3zm.1-12.1v.5c0 .1-.1.3-.201.4-.099.1-.199.2-.399.3s-.4.1-.601.1c-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.199-.4v-.4c0-.3.1-.6.199-.8.201-.2.5-.3 1-.3s.801.1 1 .3c.101.1.201.4.201.7m4.9 12.1c0 .3-.101.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.301-.3.601-.4.2-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.301c.1 0 .1.1.199.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.601.2zm11-4.6c0-.5 0-1-.101-1.4a12 12 0 0 0-.299-1c-.201-.3-.4-.5-.701-.6-.299-.1-.599-.2-1.099-.2-.401 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.301.6-.301 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.301 1s.4.5.6.6.599.2 1 .2c.5 0 .8-.1 1.099-.2.301-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.1 1.8s-.301 1.2-.6 1.7c-.3.5-.701.9-1.3 1.3-.6.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.3-1.3c-.301-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.299-.5 2.299-.5s1.801.1 2.301.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.299-.9c-.101-.2-.301-.4-.5-.4-.201-.1-.401-.1-.701-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.599.3v5q.75.15 1.199.3c.301.1.7.1 1.1.1s.701-.1.9-.2.4-.3.6-.5c.201-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.199 2.2-.101.6-.301 1.2-.601 1.6s-.7.8-1.2 1-1.199.3-2 .3c-.3 0-.699 0-1.199-.1-.401-.1-.901-.2-1.401-.3v3.5c0 .1 0 .2-.099.3-.101.1-.201.1-.301.1h-1.4c-.2 0-.299 0-.299-.1s-.101-.2-.101-.3V36.6c0-.3.101-.4.4-.4h1.4c.1 0 .2 0 .301.1.099.1.099.2.099.3v.6h.1c.2-.1.4-.2.6-.4.201-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.899-.1.7 0 1.2.1 1.601.4.399.2.799.6 1 1 .199.4.399 1 .5 1.6.199.6.199 1.3.199 2.1m7.9.5h-2.4c-.5 0-.9.1-1.2.4-.3.2-.4.7-.4 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.2-.3l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.2.1.2 0 .4.1c.1 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m12-1.8q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1a21 21 0 0 1-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.399.6l-.199.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.301-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.401.8.3.1.699.2 1.3.3.5.1.899.2 1.399.3s.801.3 1.2.5c.3.2.601.5.8.9.4.4.5.9.5 1.5m-59.5 16.3 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2V66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V53.4c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm15.4 2c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m16.3 5c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-5.7c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3V66c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3V66c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v6c0 .1 0 .2-.1.3m4.7-.3c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.1-12.1v.5c0 .2-.1.3-.201.4-.099.1-.199.2-.399.3s-.4.1-.601.1c-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.199-.4V54c0-.3.1-.6.199-.8.201-.2.5-.3 1-.3s.801.1 1 .3c.201.1.201.4.201.7m9.8 9.5q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.899-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.399.6l-.199.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.301-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.401.8.3.1.699.2 1.3.3.5.1.899.2 1.399.3s.801.3 1.2.5c.3.2.601.5.8.9.4.4.5.9.5 1.5m4.301 2.6c0 .1 0 .2-.101.3 0 .1-.099.1-.299.1H196.6c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.101.2.101.3zm.1-12.1v.5c0 .1-.1.3-.201.4-.099.1-.2.2-.399.3-.2.1-.4.1-.601.1-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.101.1.201.4.201.7m5.299 0v.5c0 .1-.1.3-.2.4s-.199.2-.4.3c-.2.1-.4.1-.6.1-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.199-.4c-.101-.2 0-.3 0-.4 0-.3.099-.6.199-.8s.5-.3 1-.3.801.1 1 .3c.1.1.2.4.2.7m-.1 12.7c0 .7-.1 1.2-.2 1.7-.099.5-.4.9-.8 1.3-.4.3-.799.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.299-.1-.101-.1-.201-.2-.201-.3l-.1-.9V69c0-.1.1-.1.301-.1q.75-.15 1.199-.3c.301-.1.6-.2.801-.4.199-.2.299-.3.399-.6.101-.2.101-.5.101-.9V57c0-.3.099-.4.399-.4h1.4c.3 0 .4.1.4.4v9.6zm8.501-4.7h-2.4c-.5 0-.9.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.2 3.3c-.5.4-1.1.7-1.7.9-.601.2-1.3.4-2 .4-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.801-.6-.199-.2-.399-.5-.399-.9-.101-.3-.101-.7-.101-1.2 0-1.2.301-2 .901-2.6.599-.5 1.599-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.201-.4-.3-.5l-.6-.3c-.301-.1-.6-.1-1-.1H209.1c-.199 0-.5 0-.699.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.201-.3l-.199-.7v-.3c.1-.1.199-.2.4-.3.2-.1.5-.1.799-.2.301-.1.601-.1.901-.1s.599-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.099 1 .099 1.5v4.4c0 .1.101.2.101.3s.1.1.2.1.199 0 .4.1c.1 0 .2 0 .299.1.101 0 .101.1.101.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.101-.3-.399-.1-.599-.4-.699-.9m12.999 1.5h3.3V28h-3.3z"></path></g>', 24), K21 = [
  X21
];
function Z21(t, e) {
  return T(), N("svg", Y21, [...K21]);
}
const J21 = { render: Z21 }, Q21 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, e31 = /* @__PURE__ */ U1('<mask id="a" width="67" height="25" x="0" y="1" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 1h66.2v24.5H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M0 25.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V1c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 19 0 22.9 0 22.9z" clip-rule="evenodd"></path></g><mask id="b" width="67" height="23" x="0" y="6" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 6.2h66.1V29H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M53.4 18.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V29c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="c" width="67" height="22" x="0" y="11" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 11.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M60.4 18.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 29.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="d" width="67" height="18" x="0" y="22" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 22.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 31.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 36.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 36.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 40.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="e" width="67" height="11" x="0" y="39" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 39.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.8 45.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 47.2v2.6L33.6 48l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 49.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 50.8v2.6L33.3 52c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="f" width="67" height="7" x="0" y="50" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 50.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#f)"><path fill="#fff" fill-rule="evenodd" d="M50.3 53.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 57.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 57.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V61c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 64.8v2.6h66.1zM60.2 23c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 33.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 27.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 33.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 38.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 43.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 49s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 6.4 94.3 6.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V37c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 37.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 40.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="g" width="283" height="70" x="0" y="1" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.8h282.7V1H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#g)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 67.3h57.9V28.6H27.5z"></path><path fill="#FFF100" d="M57.1 34.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 37l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 35.8h2L50.9 37l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 34zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 47h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 47h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 59.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M279.4 67.7h3.3V29h-3.3zM143.7 34.3c0-.3.1-.4.4-.4h1.5c.3 0 .4.1.4.4v12.5c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4zm7.4 10.4c0 .3.101.5.2.6.101.1.401.1.7.1.1 0 .201 0 .3.1 0 0 .101.1.101.2l.099 1c0 .2-.099.3-.299.4-.201.1-.401.2-.701.2s-.5.1-.599.1c-.801 0-1.301-.2-1.601-.5s-.3-.9-.3-1.6V33.5c0-.3.1-.4.401-.4h1.399c.3 0 .401.1.401.4zm8.7-4.8q.3 0 .3.3v1q0 .3-.3.3H154q-.3 0-.3-.3v-1q0-.3.3-.3zm4.6.4 1.5-2 3.399-4.2c.101-.1.201-.2.3-.2.101 0 .2-.1.401-.1h1.799c.101 0 .201 0 .3.1 0 .1 0 .2-.099.3l-4.401 5.3 4.5 7.2q.151.15 0 .3c-.099.1-.099.1-.199.1H170c-.201 0-.3 0-.401-.1l-.3-.3L166 41.2l-1.8 2.2v3.3c0 .1 0 .2-.101.3-.099.1-.099.1-.3.1h-1.5c-.299 0-.399-.1-.399-.4V34.3c0-.3.1-.4.399-.4h1.5c.101 0 .201 0 .3.1 0 .1.101.2.101.3zm17.2 6.9h-1.399c-.101 0-.201 0-.3-.1-.101-.1-.101-.2-.101-.3v-.6c-.2.1-.399.3-.7.4s-.5.3-.8.4l-.899.3c-.301.1-.601.1-.901.1-.7 0-1.2-.1-1.599-.3-.401-.2-.7-.4-.901-.8-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.401-.4h1.5c.199 0 .399.1.399.4v5.6c0 .3 0 .6.101.8 0 .2.099.4.199.6.101.2.301.3.4.4s.401.1.701.1c.2 0 .399 0 .7-.1s.5-.2.8-.3c.299-.1.5-.2.7-.3s.399-.2.5-.3v-6.7c0-.1 0-.2.099-.3.1-.1.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9c-.1.6-.3.7-.5.7m16.8-.1c0 .1-.101.1-.301.1H196.7c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1s-.5.1-.7.2-.5.2-.699.3l-.601.3v6.7c0 .1 0 .2-.099.3-.101.1-.2.1-.3.1h-1.5c-.2 0-.301-.1-.301-.4V41c0-.6-.099-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3v6.7c0 .3-.101.4-.401.4H184.4c-.2 0-.4-.1-.4-.4v-9c0-.3.099-.4.4-.4h1.399c.3 0 .401.1.401.4v.6c.2-.1.399-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3.5-.1.8-.1c.601 0 1.101.1 1.601.3s.899.6 1.2 1.1c.5-.4 1.1-.7 1.699-1 .601-.3 1.2-.4 1.901-.4.7 0 1.2.1 1.599.3.401.2.7.5.901.8.2.3.299.7.4 1.2.1.5.1.9.1 1.4v5.9c0 .2-.1.3-.1.3m16.501 0c0 .1-.101.1-.301.1h-1.399c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1s-.5.1-.7.2-.5.2-.699.3l-.601.3v6.7c0 .1 0 .2-.099.3-.101.1-.2.1-.3.1h-1.4c-.201 0-.3-.1-.3-.4V41c0-.6-.101-1.1-.3-1.4-.2-.3-.5-.4-1-.4-.2 0-.4 0-.601.1s-.399.1-.7.2c-.199.1-.5.2-.699.3l-.601.3v6.7c0 .3-.099.4-.399.4h-1.4c-.201 0-.401-.1-.401-.4v-9c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.6c.201-.1.401-.3.601-.4s.5-.3.699-.4c.2-.1.5-.2.801-.3.3-.1.5-.1.8-.1.599 0 1.099.1 1.599.3s.901.6 1.201 1.1c.5-.4 1.099-.7 1.7-1 .599-.3 1.2-.4 1.899-.4s1.2.1 1.601.3c.399.2.7.5.899.8s.301.7.401 1.2c.099.5.099.9.099 1.4v5.9c-.099.2-.099.3-.199.3m4.699-.3c0 .1 0 .2-.1.3-.099.1-.099.1-.299.1H217.8c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.1.2.1.3zm.101-12v.5c0 .1-.101.3-.201.4-.099.1-.2.2-.4.3-.199.1-.399.1-.6.1-.299 0-.5 0-.599-.1-.2-.1-.301-.2-.401-.3-.099-.1-.099-.2-.2-.4v-.4c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.201.1.201.3.201.7m9.799 9.5q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1s.5 0 .7 0h.6c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.3-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1.3 0 .5.1.8.1.3.1.5.1.7.2.3.1.5.3.4.6v1c0 .1-.1.2-.2.3s-.2 0-.4 0c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.2.2.3.7.3 1.3m9.201 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1a20 20 0 0 1-1.5-.3 1.4 1.4 0 0 1-.399-.3c-.101-.1-.101-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.199 0 .5.1.699.1.301 0 .5 0 .801.1.3.1.5 0 .699 0h.601c.6 0 1.1-.1 1.399-.3.301-.2.401-.5.401-.9 0-.2 0-.4-.1-.6s-.1-.3-.301-.4c-.199-.1-.299-.2-.5-.2-.199-.1-.5-.1-.799-.2-.5-.1-1-.2-1.4-.3s-.801-.3-1.2-.5c-.3-.2-.601-.5-.8-.8s-.301-.8-.301-1.3c0-1 .301-1.7 1-2.3.701-.5 1.601-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1.301.1.5.1.701.2.299.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3s-.201 0-.4 0c-.4-.1-.9-.1-1.4-.2-.5 0-.901-.1-1.3-.1-.601 0-1.101.1-1.3.3q-.3.3-.301.9c0 .4.101.6.401.8s.7.2 1.3.3c.5.1.9.2 1.4.3.399.1.8.3 1.2.5s.6.5.8.9c.399.5.5 1 .5 1.6m4.699-9.5v.5c0 .1-.101.3-.2.4-.101.1-.2.2-.401.3-.2.1-.399.1-.599.1-.3 0-.5 0-.601-.1-.199-.1-.3-.2-.399-.3-.101-.1-.101-.2-.2-.4v-.4c0-.3.099-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3.2.3.2.7m-.101 12.6c0 .7-.099 1.2-.2 1.7-.099.5-.399.9-.8 1.3-.399.4-.799.6-1.399.8-.601.2-1.301.2-2.101.2-.099 0-.2 0-.299-.1-.1-.1-.201-.2-.201-.3l-.099-.9v-.3c0-.1.099-.1.3-.1q.75-.15 1.2-.3c.3-.1.599-.2.8-.4.2-.1.299-.3.4-.6.1-.2.1-.5.1-.9v-9.7c0-.3.099-.4.4-.4h1.399c.3 0 .401.1.401.4v9.6zm8.801-5.1c0-.5 0-1-.1-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.801.1-1 .2-.2.1-.5.3-.601.6-.2.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.1.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.1-.4.1-.9.1-1.4m2.2-.1c0 .6 0 1.2-.099 1.8-.101.6-.3 1.2-.601 1.7-.3.5-.699.9-1.3 1.3-.599.3-1.399.5-2.399.5s-1.801-.2-2.401-.5-1-.7-1.299-1.3c-.3-.5-.5-1.1-.5-1.7-.101-.6-.101-1.2-.101-1.8 0-.5 0-1 .101-1.6.099-.6.299-1.1.599-1.6s.7-.9 1.3-1.3c.601-.3 1.301-.5 2.301-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .6 1.6.2.6.2 1.2.2 1.8m10.4 4.9c-.101.1-.2.1-.3.1H263c-.3 0-.401-.1-.401-.4v-5.6c0-.6-.099-1.1-.299-1.4-.201-.4-.6-.5-1.201-.5-.199 0-.399 0-.699.1-.301.1-.5.2-.801.2-.299.1-.5.2-.699.3-.2.1-.4.2-.5.2v6.7c0 .3-.1.4-.4.4h-1.401c-.299 0-.399-.1-.399-.4v-9c0-.3.1-.4.399-.4H258c.3 0 .4.1.4.4v.6c.199-.1.4-.3.699-.4.301-.1.5-.3.801-.4l.9-.3c.299-.1.6-.1.9-.1.7 0 1.2.1 1.6.3s.7.5.9.8.3.8.399 1.2c.101.5.101.9.101 1.5v5.8q.15.3 0 .3m4.701-.3c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1H267.6c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.101.2.101.3zm.1-12v.5c0 .1-.1.3-.201.4-.099.1-.2.2-.399.3-.2.1-.4.1-.601.1-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.2-.4v-.4c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.101.1.201.3.201.7M143.5 54.3c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4V61c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V67c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.099 7.2.9 3.1.901-3.3 1-3.5c0-.1.099-.2.099-.3.1 0 .1-.1.3-.1h1.601c.099 0 .199 0 .199.1v.3l-2.899 9c-.101.2-.201.4-.3.4h-1.401c-.299 0-.5-.1-.5-.4l-.7-2.1-.8-2.5-.799 2.6-.701 2c-.099.3-.299.5-.599.5h-1c-.2 0-.401 0-.5-.1-.101-.1-.101-.2-.2-.4l-3-8.9v-.3c0-.1.099-.1.2-.1h1.599c.1 0 .201 0 .3.1.101.1.101.1.2.3l1 3.4 1 3.5h.1l1-3 .601-1.8-.601-2v-.3c0-.1.101-.1.2-.1h1.5c.101 0 .2 0 .3.1.101.1.101.2.101.3zm9.201 5.3c0 .3-.1.4-.399.4h-1.5c-.301 0-.401-.1-.401-.4v-9c0-.3.1-.4.401-.4h1.399c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.801-.4c.299-.1.5-.2.799-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.399.2-.301.1-.601.1-.901.2s-.599.2-.9.2c-.3 0-.6.2-.8.2-.3.1-.5.2-.6.2zm11-4.5c0-.5 0-1-.1-1.4s-.2-.7-.299-1c-.201-.3-.401-.5-.701-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.201.7.3 1c.1.3.401.5.6.6.2.1.6.2 1 .2.5 0 .801-.1 1.1-.2s.5-.3.701-.6c.199-.3.299-.6.299-1s.1-.9.1-1.4m2.2-.1c0 .6 0 1.2-.099 1.8-.101.6-.301 1.2-.601 1.7s-.7.9-1.3 1.3c-.599.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.299-1.3c-.301-.5-.5-1.1-.5-1.7-.101-.6-.101-1.2-.101-1.8 0-.5 0-1 .101-1.6.099-.6.299-1.1.599-1.6s.7-.9 1.3-1.3c.601-.3 1.3-.5 2.3-.5s1.801.1 2.301.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .6 1.6.101.6.2 1.2.2 1.8m8.4 0c0-.6 0-1.2-.101-1.5-.099-.3-.2-.7-.299-.9-.1-.2-.3-.4-.5-.4-.201-.1-.401-.1-.701-.1-.2 0-.399 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.599.3v5q.75.15 1.2.3c.399 0 .7.1 1.099.1.401 0 .701 0 .901-.2.2-.1.399-.3.599-.5.201-.3.3-.6.3-1 .301-.5.301-1 .301-1.7m2.3 0c0 .8-.101 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6-.301.4-.7.8-1.2 1s-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.401-.1-.901-.2-1.401-.3v3.5c0 .1 0 .2-.099.3 0 .1-.201.1-.3.1h-1.401c-.2 0-.299 0-.299-.1s-.1-.2-.1-.3V57.8c0-.3.1-.4.399-.4h1.401c.099 0 .2 0 .3.1s.099.2.099.3v.6h.101c.2-.1.399-.3.599-.4.201-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.9-.1.699 0 1.199.1 1.6.4.4.2.799.6 1 1s.4 1 .5 1.6.2 1.3.2 2m5.8-3.2c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9s-.2-.5-.3-.8-.3-.4-.6-.5-.7-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8s.4.3.7.4.6.1 1.1.1c.4 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2c-.3 0-.6.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.6-1.6s-.2-1.2-.2-1.9c0-.5 0-1 .1-1.6s.3-1.2.6-1.7.7-1 1.3-1.3 1.3-.5 2.3-.5c.9 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.4.3-.8.3h-5.5zm14.2-.1h-2.4c-.5 0-.9.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.4-.1-.6-.3-.8-.6s-.401-.5-.401-.9-.099-.7-.099-1.2c0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.101-.3-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.399c-.101 0-.101-.1-.2-.2l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.599-.1.9-.1c.3 0 .6-.1.9-.1h.799q1.351 0 2.101.3c.5.2.899.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.099.2.099.3s.101.1.201.1.2 0 .4.1c.1 0 .2 0 .3.1s.099.1.099.2v.8c0 .2-.199.4-.5.4-.199 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3s-.5-.5-.7-1"></path></g>', 25), t31 = [
  e31
];
function n31(t, e) {
  return T(), N("svg", Q21, [...t31]);
}
const i31 = { render: n31 }, s31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, l31 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="248" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h247.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m5.901-3.3c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9-.101-.3-.2-.5-.3-.8s-.301-.4-.6-.5c-.4-.2-.701-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8.199.2.4.3.699.4.301.1.601.1 1.101.1.399 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.601.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4-.601-.3-1-.7-1.3-1.1-.301-.5-.5-1-.6-1.6s-.201-1.2-.201-1.9c0-.5 0-1 .101-1.6.1-.6.3-1.2.6-1.7.299-.5.7-1 1.299-1.3.601-.4 1.301-.5 2.301-.5.9 0 1.6.1 2.199.4.601.3 1 .6 1.301 1s.5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.401.3-.8.3h-5.5zm15.399 1.4q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1a21 21 0 0 1-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.399.6l-.199.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.301-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.401.8.3.1.699.2 1.3.3.5.1.899.2 1.399.3s.801.3 1.2.5c.3.2.601.5.8.9.4.4.5.9.5 1.5m6-5.3c-.399 0-.699.1-.899.2s-.401.3-.601.5-.3.5-.3.8c-.099.3-.099.6-.099 1h4c0-.3 0-.6-.101-.9-.1-.3-.199-.5-.3-.8-.099-.3-.3-.4-.599-.5-.401-.2-.701-.3-1.101-.3m-2 3.9c0 .5.101.9.2 1.3.101.3.3.6.5.8s.401.3.7.4c.3.1.6.1 1.1.1.4 0 .801 0 1.301-.1s.899-.1 1.3-.1h.399c.101 0 .101.1.2.3l.101.7v.4q0 .15-.301.3c-.199.1-.399.2-.699.2-.301 0-.5.1-.801.2-.3.1-.6.1-.899.1h-.8c-1 0-1.7-.1-2.301-.4-.6-.3-1-.7-1.3-1.1-.3-.5-.5-1-.599-1.6-.101-.6-.201-1.2-.201-1.9 0-.5 0-1 .1-1.6.101-.6.301-1.2.601-1.7.299-.5.7-1 1.299-1.3.6-.4 1.3-.5 2.3-.5.901 0 1.601.1 2.2.4s1 .6 1.3 1 .5.9.601 1.4c.099.5.199 1.1.199 1.6 0 .4 0 .7-.199.9-.2.2-.401.3-.801.3h-5.5zm-70.9 18.1c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.799-.6h.801c.3 0 .6.1 1 .1.3 0 .699.1 1 .2l.9.3c.2.1.299.1.299.2s.101.2.101.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.701 0-1.201.1-1.6.4-.4.3-.7.6-1 1-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.599-.2h.401c.099.1.099.1.2.3l.2.8q.15.45-.301.6-.3.15-.899.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.701-.6c-.699-.4-1.299-.9-1.599-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4m17.399 1.6c0-.5 0-1-.1-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.801.1-1 .2-.2.1-.5.3-.601.6-.2.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.1.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .1-.8.1-1.4m2.301-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.4-.5c-.6-.3-1-.7-1.3-1.3-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6.101-.6.3-1.1.601-1.6.3-.5.699-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.3 1.2s.5 1 .601 1.6c.099.6.2 1.2.2 1.8m16.3 5c0 .1-.101.1-.3.1h-1.4c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.1-.699.2-.2.1-.5.2-.7.3l-.601.3V66c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.301-1.4-.199-.3-.5-.4-1-.4-.199 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3V66c0 .3-.1.4-.401.4H165.2c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3c.301-.1.5-.1.801-.1.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.199-.4 1.9-.4 1.2.1 1.6.3.699.5.9.8c.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c-.1.1-.1.2-.1.3m16.5 0c0 .1-.101.1-.3.1H194c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.1-.699.2-.2.1-.5.2-.7.3l-.601.3V66c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.301-1.4-.199-.3-.5-.4-1-.4-.199 0-.399 0-.599.1s-.401.1-.7.2c-.3.1-.5.2-.701.3l-.599.3V66c0 .3-.1.4-.401.4H181.7c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.599-.4.201-.1.5-.3.701-.4.299-.1.5-.2.799-.3.301-.1.5-.1.801-.1.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.199-.4 1.9-.4 1.2.1 1.6.3.699.5.9.8c.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c0 .1-.1.2-.1.3m4.701-.3c0 .1 0 .2-.101.3 0 .1-.099.1-.299.1H198.6c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.101.2.101.3zm.1-12.1v.5c0 .1-.1.3-.201.4-.099.1-.2.2-.399.3-.2.1-.4.1-.601.1-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.101.1.201.4.201.7m9.7 9.5q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3a1.4 1.4 0 0 1-.399-.3c-.101-.1-.101-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.199 0 .5.1.699.1.301 0 .5 0 .801.1.3 0 .5 0 .699.1h.601c.6 0 1.1-.1 1.399-.3.301-.2.401-.5.401-.9 0-.2 0-.4-.1-.6s-.1-.3-.301-.4c-.199-.1-.299-.2-.5-.2-.199-.1-.5-.1-.799-.2-.5-.1-1-.2-1.4-.3s-.801-.3-1.2-.5c-.3-.2-.601-.5-.8-.8s-.301-.8-.301-1.3c0-1 .301-1.7 1-2.3.701-.5 1.601-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1.301 0 .5.1.701.2.299.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.901-.1-1.3-.1-.601 0-1.101.1-1.3.3q-.3.3-.301.9c0 .4.101.6.401.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.399.4.5.9.5 1.5m9.2 0q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1h.601c.6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.199-.5-.301-.2-.601-.5-.801-.8-.199-.3-.3-.8-.3-1.3 0-1 .3-1.7 1-2.3.701-.5 1.601-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.4.6l-.2.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.3-.1-.601 0-1.101.1-1.301.3q-.3.3-.3.9c0 .4.101.6.401.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.199.5c.301.2.601.5.801.9.399.4.5.9.5 1.5M223.8 66c0 .1 0 .2-.1.3 0 .1-.1.1-.299.1H222c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.401c.099 0 .199 0 .299.1 0 .1.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4s-.2.2-.4.3-.399.1-.6.1c-.299 0-.5 0-.6-.1-.199-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.4.201.7m6.399 4.2c-.399 0-.7.1-.899.2-.201.1-.401.3-.601.5s-.3.5-.3.8c-.099.3-.099.6-.099 1h4c0-.3 0-.6-.101-.9-.1-.3-.2-.5-.3-.8s-.3-.4-.599-.5c-.301-.2-.601-.3-1.101-.3m-2 3.9c0 .5.101.9.2 1.3.1.3.3.6.5.8s.401.3.7.4c.3.1.6.1 1.1.1.4 0 .8 0 1.3-.1s.9-.1 1.301-.1h.399c.101 0 .101.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.399.2-.7.2s-.5.1-.8.2-.6.1-.899.1h-.801c-1 0-1.699-.1-2.3-.4s-1-.7-1.3-1.1c-.3-.5-.5-1-.599-1.6-.101-.6-.201-1.2-.201-1.9 0-.5 0-1 .1-1.6.101-.6.3-1.2.601-1.7.299-.5.699-1 1.299-1.3.6-.4 1.3-.5 2.3-.5.901 0 1.6.1 2.2.4s1 .6 1.3 1 .5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9-.199.2-.4.3-.8.3h-5.5zm16.1 4.7h3.3V28h-3.3z"></path></g>', 24), r31 = [
  l31
];
function a31(t, e) {
  return T(), N("svg", s31, [...r31]);
}
const o31 = { render: a31 }, c31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, h31 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6M94.201 0s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.201 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm.001 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6h-40.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.701 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#fff" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201L54.9 62l.6-1.901-1.6-1.199h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#fff" fill-rule="evenodd" d="M265.4 66.7h3.3V28h-3.3z" clip-rule="evenodd"></path><path fill="#fff" d="M143.42 33.12q0-.4.4-.4h7.36q.38 0 .38.38v1.24q0 .36-.4.36h-5.46v3.44h4.84q.4 0 .4.36v1.24q0 .36-.4.36h-4.84v3.94h5.6q.36 0 .36.38v1.22q0 .36-.38.36h-7.46q-.4 0-.4-.36zm18.706 12.5q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V45l-.04-.02q-.3.2-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V36.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1.4-.1.78-.24.38-.16.7-.3l.52-.26V36.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4zm4.705 0q0 .38-.38.38h-1.44q-.38 0-.38-.38V36.6q0-.4.38-.4h1.42q.4 0 .4.4v.88l.04.04a4 4 0 0 1 .58-.42q.36-.24.76-.42.42-.201.84-.36.42-.16.78-.22a.5.5 0 0 1 .32.02q.12.06.16.32l.14 1.34a.7.7 0 0 1-.02.32q-.039.1-.36.16-.42.08-.88.2a10 10 0 0 0-.9.24q-.44.12-.82.24t-.64.24zm13.225-4.68q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.759-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.501-1.3-1.26a4.6 4.6 0 0 1-.52-1.7 17 17 0 0 1-.1-1.78q0-.7.12-1.56a4.6 4.6 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.801-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.849-.04q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12.08.1.08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.981 0 1.62.36t1 1.02q.38.639.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a9 9 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.561.06 1.08.06.54 0 .9-.14.381-.16.6-.54.24-.38.34-1 .1-.64.1-1.58m10.11.52h-2.44q-.76 0-1.2.36-.44.339-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02l-.72.04q-.36.02-.74.06-.36.039-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.459.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.039.38.06.22.02.3.08t.08.22v.84q0 .339-.48.42-.24.039-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.261-.58-.96zm-53.276 14.96 1.54-1.62 1.66-1.68q.16-.16.3-.24.14-.1.42-.1h1.6q.28 0 .32.14.06.14-.1.32l-3.2 3.26 3.6 5.64q.1.18.02.32-.06.14-.28.14h-1.54q-.32 0-.46-.1a.84.84 0 0 1-.24-.28l-2.56-4.1-1.14 1.16v2.94q0 .16-.08.28-.08.1-.3.1h-1.42q-.38 0-.38-.38V52.28q0-.4.38-.4h1.42q.22 0 .3.12a.44.44 0 0 1 .08.28v7.52zm15.693 1.12q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1a10 10 0 0 0-.08 1.36q0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m18.529 4.54a.44.44 0 0 1-.08.28q-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.34.12-.66.28l-.56.28v.42a8 8 0 0 1 .02.6v5.66a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.261 0-.6.08-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4.339-.22.72-.38.4-.16.8-.26a3.4 3.4 0 0 1 .82-.14q.86 0 1.56.28.72.26 1.18 1.12a9.7 9.7 0 0 1 1.66-.98q.9-.42 1.86-.42.98 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm16.484 0a.44.44 0 0 1-.08.28q-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.34.12-.66.28l-.56.28v.42a8 8 0 0 1 .02.6v5.66a.44.44 0 0 1-.08.28q-.08.1-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.26 0-.6.08a6 6 0 0 0-.68.22q-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4a4.7 4.7 0 0 1 .72-.38q.4-.16.8-.26.4-.12.82-.14.86 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.98 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.744-12.02q0 .24-.04.46a.76.76 0 0 1-.18.36.84.84 0 0 1-.36.26q-.219.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.5 2.5 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.741 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12a.4.4 0 0 1 .08.26zm9.802-2.56q0 .88-.34 1.48-.34.58-.92.94-.56.36-1.28.52t-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.64.64 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1l.78.08q.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.35 1.35 0 0 0-.5-.22q-.3-.1-.78-.16a14 14 0 0 1-1.4-.26 4.4 4.4 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.5.2.42.6l-.16.72q-.04.22-.16.28-.1.039-.38 0-.64-.08-1.4-.14-.76-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.399.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m4.619 3.16q0 .98-.22 1.72-.22.76-.76 1.26-.519.52-1.38.76-.84.24-2.1.2a.6.6 0 0 1-.26-.08q-.159-.08-.18-.32l-.08-.94q-.04-.24.04-.32.06-.08.28-.12.7-.14 1.16-.28.48-.12.76-.34.3-.22.42-.58.12-.34.12-.92v-9.68q0-.38.4-.38h1.4q.4 0 .4.38zm.08-12.62q0 .24-.04.46a.76.76 0 0 1-.18.36.84.84 0 0 1-.36.26q-.219.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.5 2.5 0 0 1-.04-.44q0-.48.24-.8.24-.34.94-.34.741 0 .96.32.22.3.22.82m10.914 7.34q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7 17 17 0 0 1-.1-1.78q0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.669 4.54a.44.44 0 0 1-.08.28q-.08.1-.3.1h-1.44q-.38 0-.38-.38l.02-5.62q0-.88-.3-1.42-.28-.54-1.14-.54-.3 0-.7.1a7 7 0 0 0-.78.26 9 9 0 0 0-.72.3 8 8 0 0 0-.54.24v6.68q0 .38-.38.38h-1.42q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.38 0 .38.4v.6q.02 0 .02.02h.04q.28-.2.66-.4.4-.22.84-.4t.92-.28q.48-.12.94-.12 1.02 0 1.6.32.58.3.88.82t.38 1.22q.08.68.08 1.44zm4.166-3.92q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08l1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.399.08-.84.14t-.88.1q-.44.04-.8.04-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.341 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.021.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m14.557 7.82a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.44q-.38 0-.38-.38l.02-5.62q0-.88-.3-1.42-.28-.54-1.14-.54-.3 0-.7.1a7 7 0 0 0-.78.26 9 9 0 0 0-.72.3 8 8 0 0 0-.54.24v6.68q0 .38-.38.38h-1.42q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.38 0 .38.4v.6q.02 0 .02.02h.04q.279-.2.66-.4.399-.22.84-.4t.92-.28q.48-.12.94-.12 1.02 0 1.6.32.58.3.88.82t.38 1.22q.08.68.08 1.44z"></path>', 26), u31 = [
  h31
];
function d31(t, e) {
  return T(), N("svg", c31, [...u31]);
}
const f31 = { render: d31 }, v31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, p31 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="250" height="71" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.6h249.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="m145.6 39.1 1.5-2 3.4-4.2c.1-.1.2-.2.3-.2s.2-.1.4-.1h1.8c.1 0 .2 0 .3.1 0 .1 0 .2-.1.3l-4.4 5.3 4.5 7.2q.15.15 0 .3c-.1.1-.1.1-.2.1h-1.8c-.2 0-.3 0-.4-.1l-.3-.3-3.3-5.5-1.8 2.2v3.3c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.5c-.3 0-.4-.1-.4-.4V33.1c0-.3.1-.4.4-.4h1.5c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm15.4 2c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m16.3 5c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c0 .2 0 .3-.1.4m4.7-.3c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.1-12.1v.5c0 .2-.1.3-.201.4-.099.1-.199.2-.399.3s-.4.1-.601.1c-.299 0-.5 0-.599-.1-.2-.1-.3-.2-.401-.3-.099-.1-.099-.2-.199-.4v-.4c0-.3.1-.6.199-.8.201-.2.5-.3 1-.3s.801.1 1 .3c.201.1.201.4.201.7m9.8 9.5q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1a21 21 0 0 1-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.399.6l-.199.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.301-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.401.8.3.1.699.2 1.3.3.5.1.899.2 1.399.3s.801.3 1.2.5c.3.2.601.5.8.9.4.4.5.9.5 1.5m4.7-9.5v.5c0 .2-.1.3-.2.4s-.199.2-.4.3c-.2.1-.4.1-.6.1-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.199-.4v-.4c0-.3.099-.6.199-.8.2-.2.5-.3 1-.3s.801.1 1 .3c.1.1.2.4.2.7m-.1 12.7c0 .7-.1 1.2-.2 1.7-.099.5-.4.9-.8 1.3-.4.3-.799.6-1.4.8s-1.3.2-2.1.2c-.1 0-.2 0-.299-.1-.101-.1-.201-.2-.201-.3l-.1-.9v-.3c0-.1.1-.1.301-.1q.75-.15 1.199-.3c.301-.1.6-.2.801-.4.199-.1.299-.3.399-.6.101-.2.101-.5.101-.9v-9.7c0-.3.099-.4.399-.4h1.4c.3 0 .4.1.4.4v9.6zm8.6-4.7h-2.399c-.5 0-.901.1-1.201.4-.299.2-.4.7-.4 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.601-.3v-2zm.101 3.3c-.5.4-1.101.7-1.701.9s-1.299.4-2 .4c-.5 0-1-.1-1.299-.2-.401-.1-.601-.3-.801-.6-.199-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.301-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.601v-.5c0-.3 0-.5-.101-.8-.1-.2-.2-.4-.3-.5l-.599-.3c-.301-.1-.601-.1-1-.1H204.1c-.199 0-.5 0-.699.1-.201 0-.5 0-.701.1h-.4c-.1 0-.1-.1-.2-.3l-.199-.7v-.3c0-.1.199-.2.399-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.901-.1h.799q1.35 0 2.1.3c.5.2.9.4 1.2.7s.401.7.5 1.2c.1.5.1 1 .1 1.5V44c0 .1.1.2.1.3s.1.1.201.1c.099 0 .199 0 .399.1.101 0 .2 0 .3.1s.1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.1-.3-.3-.1-.5-.4-.699-.9M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4V66c-.1.2-.2.4-.5.4m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V56.9c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m5.901-3.3c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9-.101-.3-.2-.5-.3-.8s-.301-.4-.6-.5c-.4-.2-.701-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8.199.2.4.3.699.4.301.1.601.1 1.101.1.399 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.601.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4-.601-.3-1-.7-1.3-1.1-.301-.5-.5-1-.6-1.6s-.201-1.2-.201-1.9c0-.5 0-1 .101-1.6.1-.6.3-1.2.6-1.7.299-.5.7-1 1.299-1.3.601-.4 1.301-.5 2.301-.5.9 0 1.6.1 2.199.4.601.3 1 .6 1.301 1s.5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.6.2-1 .2zm10.999-8.1v.5c0 .2-.101.3-.2.4-.1.1-.2.2-.401.3-.199.1-.399.1-.599.1-.3 0-.5 0-.6-.1a1.3 1.3 0 0 1-.4-.3c-.1-.1-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.099.1.2.4.2.7m-.101 12.7c0 .7-.099 1.2-.199 1.7s-.4.9-.801 1.3c-.399.3-.799.6-1.399.8-.601.2-1.3.2-2.101.2-.099 0-.199 0-.299-.1s-.201-.2-.201-.3l-.099-.9V69c0-.1.099-.1.3-.1q.75-.15 1.2-.3c.3-.1.599-.2.8-.4.2-.1.299-.3.4-.6.1-.2.1-.5.1-.9V57c0-.3.1-.4.4-.4h1.399c.301 0 .401.1.401.4v9.6zm9.801-3.2q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.199-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.699-.5 1.6-.8 2.699-.8h.7c.3 0 .5 0 .8.1s.5.1.801.1c.3 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3h-.399c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8s.701.2 1.3.3c.5.1.901.2 1.401.3.4.1.799.3 1.2.5.399.2.599.5.8.9.299.4.4.9.4 1.5m4.2-3.2 1.5-1.6 1.7-1.7.3-.3c.101-.1.2-.1.4-.1h1.6c.2 0 .301 0 .301.1s0 .2-.101.3l-3.2 3.3 3.601 5.7q.148.15 0 .3c-.101.1-.101.1-.3.1h-1.5c-.2 0-.401 0-.5-.1-.101-.1-.2-.2-.2-.3l-2.601-4.1-1.1 1.2v3c0 .1 0 .2-.099.3-.101.1-.2.1-.301.1h-1.399c-.3 0-.401-.1-.401-.4V52.6c0-.3.101-.4.401-.4h1.399c.101 0 .2 0 .301.1.099.1.099.2.099.3zm13.499 1.7H230.7c-.5 0-.901.1-1.201.4-.299.2-.4.7-.4 1.3q0 .6.301.9c.199.2.5.3 1 .3.199 0 .399 0 .699-.1.301-.1.5-.1.801-.2.3-.1.5-.2.699-.3.2-.1.5-.2.601-.3v-2zm.101 3.3c-.5.4-1.101.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.401-.1-.601-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .899-2.6.601-.5 1.601-.8 2.8-.8h2.601v-.5c0-.3 0-.5-.101-.8-.1-.2-.199-.4-.3-.5l-.599-.3c-.3-.1-.601-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.4c-.1 0-.1-.1-.199-.3l-.2-.7v-.3c0-.1.2-.2.399-.3.2-.1.5-.1.801-.2.3-.1.599-.1.899-.1s.601-.1.901-.1h.799q1.35 0 2.1.3c.5.2.9.4 1.2.7s.401.7.5 1.2c.101.5.101 1 .101 1.5v4.4c0 .1.099.2.099.3s.1.1.201.1c.099 0 .2 0 .399.1.101 0 .2 0 .301.1.099.1.099.1.099.2v.8c0 .2-.2.4-.5.4-.2 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.401-.1-.601-.4-.7-.9m13.2 1.5h3.3V28h-3.3z"></path></g>', 24), m31 = [
  p31
];
function g31(t, e) {
  return T(), N("svg", v31, [...m31]);
}
const y31 = { render: g31 }, _31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, q31 = /* @__PURE__ */ U1('<path fill="#fff" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z"></path><path fill="#fff" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1"></path><path fill="#fff" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3"></path><path fill="#fff" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1"></path><path fill="#fff" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6"></path><path fill="#fff" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1"></path><path fill="#fff" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5"></path><path fill="#fff" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7"></path><path fill="#fff" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2m-.2 4.2c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z"></path><path fill="#fff" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z"></path><path fill="#fff" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z"></path><path fill="#fff" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z"></path><path fill="#fff" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z"></path><path fill="#fff" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6"></path><path fill="#fff" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4"></path><path fill="#fff" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3"></path><path fill="#004494" stroke="#fff" stroke-width="2" d="M85.4 27.6H27.5v38.7h57.9z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.2 39.5c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.9.3c.2.1.3.1.3.2s.1.2.1.4l-.2.8c0 .1-.1.2-.1.3-.1.1-.2.1-.4 0-.5-.1-1-.1-1.6-.2s-1.1-.1-1.6-.1c-.7 0-1.2.1-1.6.4s-.7.6-1 1c-.2.4-.4 1-.4 1.5s-.1 1.2-.1 1.9 0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.6.4.6 0 1.1 0 1.6-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.2.8q.15.45-.3.6-.3.15-.9.3c-.3.1-.7.1-1 .2s-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.4-.7-.5-1.5-.5-2.4"></path><path fill="#fff" fill-rule="evenodd" d="M162.9 41c0-.6-.1-1.2-.2-1.8s-.3-1.1-.6-1.6-.7-.9-1.3-1.2c-.5-.3-1.3-.4-2.3-.4s-1.7.2-2.3.5c-.6.4-1 .8-1.3 1.3s-.5 1-.6 1.6-.1 1.1-.1 1.6c0 .6 0 1.2.1 1.8 0 .6.2 1.2.5 1.7.3.6.7 1 1.3 1.3s1.4.5 2.4.5 1.8-.2 2.4-.5c.6-.4 1-.8 1.3-1.3s.5-1.1.6-1.7.1-1.2.1-1.8m-2.3.1c0 .33-.03.6-.057.842a5 5 0 0 0-.043.558c0 .4-.1.7-.3 1s-.4.5-.7.6-.6.2-1.1.2c-.4 0-.8-.1-1-.2s-.5-.3-.6-.6-.2-.6-.3-1-.1-.9-.1-1.4 0-1 .1-1.4c0-.4.1-.7.3-1 .1-.3.4-.5.6-.6s.6-.2 1-.2c.5 0 .8.1 1.1.2s.5.3.7.6c.1.3.2.6.3 1s.1.9.1 1.4" clip-rule="evenodd"></path><path fill="#fff" d="M179.2 46c0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V40c0-.7-.1-1.3-.3-1.5-.2-.3-.6-.4-1.1-.4-.2 0-.4 0-.6.1s-.5.1-.7.2-.5.2-.7.3l-.6.3v6.7c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4v-5.8c0-.6-.1-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.4 0-.6.1s-.4.1-.7.2c-.2.1-.5.2-.7.3l-.6.3v6.7c0 .3-.1.4-.4.4h-1.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.6-.4s.5-.3.7-.4.5-.2.8-.3.5-.1.8-.1c.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.2-.4 1.9-.4 1.2.1 1.6.3.7.5.9.8.3.7.4 1.2.1.9.1 1.4v5.9c-.1.2-.1.3-.1.4"></path><path fill="#fff" fill-rule="evenodd" d="M184.001 34.1v-.5c0-.3-.1-.6-.2-.7-.2-.2-.5-.3-1-.3s-.8.1-1 .3c-.1.2-.2.5-.2.8v.4c.038.076.061.138.082.19a.5.5 0 0 0 .118.21c.1.1.2.2.4.3.1.1.3.1.6.1.2 0 .4 0 .6-.1s.3-.2.4-.3.2-.3.2-.4m-.2 11.9c.1-.1.1-.2.1-.3v-9.1c0-.05-.025-.1-.05-.15a.4.4 0 0 1-.05-.15c-.1-.1-.2-.1-.3-.1h-1.4c-.3 0-.4.1-.4.4v9.1c0 .3.1.4.4.4h1.4c.2 0 .3 0 .3-.1" clip-rule="evenodd"></path><path fill="#fff" d="M193.7 43.1q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5m9.2 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.3-.2-.4-.3s-.1-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1s.4 0 .6 0c.6 0 1.1-.1 1.4-.3s.4-.5.4-.9c0-.2 0-.4-.1-.6s-.1-.3-.2-.4-.3-.2-.5-.2c-.2-.1-.5-.1-.8-.2-.5-.1-1-.2-1.4-.3s-.8-.3-1.2-.5c-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.7-.5 1.6-.8 2.7-.8h.7c.3 0 .5 0 .8.1s.5.1.8.1.5.1.7.2c.3.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-1-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.3.3c.5.1.9.2 1.4.3.4.1.8.3 1.2.5s.6.5.8.9c.3.4.4.9.4 1.5"></path><path fill="#fff" fill-rule="evenodd" d="M210.8 35.1c-.2 0-.5-.1-.8-.2s-.6-.2-.8-.4c-.3-.1-.6-.2-.8-.4q-.12-.041-.221-.078c-.186-.069-.332-.122-.479-.122-.1 0-.3 0-.5.1q-.3.15-.6.6l-.2.2s-.1 0-.3-.1l-.6-.2c-.1-.1-.2-.2-.1-.4.3-.7.6-1.2 1-1.5s.8-.4 1.2-.4c.238 0 .412.063.624.138l.176.062c.3.1.6.2.8.3.15.05.275.1.4.15s.25.1.4.15c.2.1.5.2.7.2.4 0 .8-.2 1-.7l.2-.2h.3l.6.3c.1 0 .2.1.2.2v.2q-.45 1.05-.9 1.5c-.5.4-.9.6-1.3.6m.2 9.8c-.5.4-1.1.7-1.7.9s-1.3.4-2 .4c-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.8-.6-.2-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.2 0-.5 0-.7.1h-.4c-.071 0-.091-.05-.133-.15a2 2 0 0 0-.067-.15l-.2-.7v-.3c0-.1.2-.2.4-.3.108-.054.246-.079.397-.106.128-.023.266-.048.403-.094.3-.1.6-.1.9-.1.15 0 .3-.025.45-.05s.3-.05.45-.05h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5V44c0 .05.025.1.05.15s.05.1.05.15c0 .1.1.1.2.1s.2 0 .4.1c.1 0 .2 0 .3.1.058.057.082.082.093.111a.3.3 0 0 1 .007.089v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.1-.3-.4-.1-.6-.4-.7-.9m-2.5-3.3h2.5v2c-.066.067-.222.133-.378.2a5 5 0 0 0-.222.1c-.2.1-.4.2-.7.3-.15.05-.275.075-.4.1s-.25.05-.4.1c-.3.1-.5.1-.7.1-.5 0-.8-.1-1-.3q-.3-.3-.3-.9c0-.6.1-1.1.4-1.3.3-.3.7-.4 1.2-.4m15.6-.6c0-.6 0-1.2-.2-1.8-.1-.6-.3-1.1-.6-1.6s-.7-.9-1.3-1.2c-.5-.3-1.3-.4-2.3-.4s-1.7.2-2.3.5c-.6.4-1 .8-1.3 1.3s-.5 1-.6 1.6-.1 1.1-.1 1.6c0 .6 0 1.2.1 1.8 0 .6.2 1.2.5 1.7.3.6.7 1 1.3 1.3s1.4.5 2.4.5 1.8-.2 2.4-.5c.6-.4 1-.8 1.3-1.3s.5-1.1.6-1.7.1-1.2.1-1.8m-2.3-1.3c.1.4.1.9.1 1.4 0 .6 0 1-.1 1.4 0 .4-.1.7-.3 1s-.4.5-.7.6-.6.2-1.1.2c-.4 0-.8-.1-1-.2s-.5-.3-.6-.6-.2-.6-.3-1-.1-.9-.1-1.4 0-1 .1-1.4c0-.4.1-.7.3-1 .1-.3.4-.5.6-.6s.6-.2 1-.2c.5 0 .8.1 1.1.2s.5.3.7.6c.1.3.2.6.3 1" clip-rule="evenodd"></path><path fill="#fff" d="M143.4 53.4c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V66c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.4c-.1 0-.2 0-.3-.1s-.1-.2-.1-.3v-.6c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.7-.4-.9-.8c-.2-.3-.3-.7-.4-1.2s-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6s.3.3.4.4.4.1.7.1c.2 0 .4 0 .7-.1s.5-.2.8-.3.5-.2.7-.3.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.2-.1.3-.1h1.4c.3 0 .4.1.4.4V66c-.1.2-.2.4-.5.4m5.101-.4c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2c-.3.1-.6.2-.8.3-.3.1-.5.2-.6.2z"></path><path fill="#fff" fill-rule="evenodd" d="M180.2 61.3c0-.6-.1-1.2-.2-1.8s-.3-1.1-.6-1.6-.7-.9-1.3-1.2c-.5-.3-1.3-.4-2.3-.4s-1.7.2-2.3.5c-.6.4-1 .8-1.3 1.3s-.5 1-.6 1.6-.1 1.1-.1 1.6c0 .6 0 1.2.1 1.8 0 .6.2 1.2.5 1.7.3.6.7 1 1.3 1.3s1.4.5 2.4.5 1.8-.2 2.4-.5c.6-.4 1-.8 1.3-1.3s.5-1.1.6-1.7.1-1.2.1-1.8m-2.3.1c0 .6 0 1-.1 1.4 0 .4-.1.7-.3 1s-.4.5-.7.6-.6.2-1.1.2c-.4 0-.8-.1-1-.2s-.5-.3-.6-.6-.2-.6-.3-1-.1-.9-.1-1.4 0-1 .1-1.4c0-.4.1-.7.3-1 .1-.3.4-.5.6-.6s.6-.2 1-.2c.5 0 .8.1 1.1.2s.5.3.7.6c.1.3.2.6.3 1s.1.9.1 1.4m12.7 2.2c.1-.7.2-1.4.2-2.2s0-1.5-.2-2.1c-.1-.6-.3-1.2-.5-1.6s-.6-.8-1-1c-.4-.3-.9-.4-1.6-.4-.3 0-.6 0-.9.1l-.9.3c-.209.07-.418.188-.594.287q-.114.066-.206.113c-.2.2-.4.3-.6.4h-.1v-.6c0-.1 0-.2-.1-.3s-.2-.1-.3-.1h-1.4c-.3 0-.4.1-.4.4v12.7c0 .05.025.1.05.15s.05.1.05.15c0 .1.1.1.3.1h1.4c.1 0 .2 0 .3-.1s.1-.2.1-.3v-3.5c.5.1 1 .2 1.4.3.5.1.9.1 1.2.1.8 0 1.5-.1 2-.3s.9-.6 1.2-1 .5-1 .6-1.6m-2.2-3.7c.1.3.1.9.1 1.5s0 1.1-.3 1.7c0 .4-.1.7-.3 1-.2.2-.4.4-.6.5s-.5.2-.9.2-.8 0-1.1-.1q-.45-.15-1.2-.3v-5l.6-.3c.1-.05.225-.1.35-.15s.25-.1.35-.15c.15-.05.275-.075.4-.1s.25-.05.4-.1c.3-.1.5-.1.7-.1.3 0 .5 0 .7.1.2 0 .4.2.5.4.067.133.133.355.2.578.033.11.067.222.1.322m6.501 3.4c-.1-.4-.2-.8-.2-1.3h5.3c.4 0 .8 0 1-.2s.2-.5.2-.9c0-.5-.1-1.1-.2-1.6s-.3-1-.6-1.4-.7-.7-1.3-1-1.3-.4-2.2-.4c-1 0-1.7.1-2.3.5-.6.3-1 .8-1.3 1.3s-.5 1.1-.6 1.7-.1 1.1-.1 1.6c0 .7.1 1.3.2 1.9s.3 1.1.6 1.6c.3.4.7.8 1.3 1.1s1.3.4 2.3.4h.8c.3 0 .6 0 .9-.1q.093-.031.176-.062c.211-.075.386-.138.624-.138.3 0 .5-.1.7-.2q.3-.15.3-.3v-.4l-.1-.7q-.043-.088-.068-.15c-.041-.1-.062-.15-.132-.15h-.4c-.4 0-.8 0-1.3.1s-.9.1-1.3.1c-.5 0-.8 0-1.1-.1s-.5-.2-.7-.4-.4-.5-.5-.8m.9-5c.2-.1.5-.2.9-.2s.7.1 1.1.3c.3.1.5.2.6.5.05.15.1.275.15.4s.1.25.15.4c.1.3.1.6.1.9h-4c0-.4 0-.7.1-1 0-.3.1-.6.3-.8s.4-.4.6-.5m9.599-3.9v-.5c0-.3-.1-.6-.2-.7-.2-.2-.5-.3-1-.3s-.8.1-1 .3c-.1.2-.2.5-.2.8v.4c.038.076.062.138.082.19.033.086.056.148.118.21.1.1.2.2.4.3.1.1.3.1.6.1.2 0 .4 0 .6-.1s.3-.2.4-.3.2-.3.2-.4m-.2 11.9c.1-.1.1-.2.1-.3v-9.1c0-.05-.025-.1-.05-.15s-.05-.1-.05-.15c-.1-.1-.2-.1-.3-.1h-1.4c-.3 0-.4.1-.4.4V66c0 .3.1.4.4.4h1.4c.2 0 .3 0 .3-.1m7.001-.2c.6-.2 1.2-.5 1.7-.9.2.5.4.8.7.9.3.2.6.3 1.1.3h.5c.2-.1.3-.1.5-.1.3 0 .5-.2.5-.4v-.8c0-.1 0-.2-.1-.2-.1-.1-.2-.1-.3-.1-.2-.1-.3-.1-.4-.1s-.2 0-.2-.1c0-.05-.025-.1-.05-.15a.4.4 0 0 1-.05-.15v-4.4c0-.5 0-1-.1-1.5s-.2-.9-.5-1.2-.7-.5-1.2-.7q-.75-.3-2.1-.3h-.8c-.15 0-.3.025-.45.05s-.3.05-.45.05c-.3 0-.6 0-.9.1-.138.046-.276.07-.404.094a1.5 1.5 0 0 0-.396.106c-.2.1-.3.2-.4.3v.3l.2.7q.042.088.067.15c.041.1.062.15.133.15h.4c.2-.1.5-.1.7-.1.2-.1.5-.1.7-.1h1.3c.4 0 .7 0 1 .1l.6.3c.1.1.2.3.3.5.1.3.1.5.1.8v.5h-2.6c-1.2 0-2.2.3-2.8.8-.6.6-.9 1.4-.9 2.6 0 .5 0 .9.1 1.2 0 .4.2.7.4.9.2.3.4.5.8.6.3.1.8.2 1.3.2.7 0 1.4-.2 2-.4m-.8-4.2h2.5v2c-.067.067-.223.133-.378.2a4 4 0 0 0-.222.1c-.2.1-.4.2-.7.3a3 3 0 0 1-.4.1c-.125.025-.25.05-.4.1-.3.1-.5.1-.7.1-.5 0-.8-.1-1-.3q-.3-.3-.3-.9c0-.6.1-1.1.4-1.3.3-.3.7-.4 1.2-.4" clip-rule="evenodd"></path><path fill="#fff" d="M233.4 28h3.3v38.7h-3.3z"></path>', 27), w31 = [
  q31
];
function z31(t, e) {
  return T(), N("svg", _31, [...w31]);
}
const M31 = { render: z31 }, b31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, L31 = /* @__PURE__ */ U1('<mask id="a" width="67" height="25" x="0" y="1" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 1h66.2v24.5H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M0 25.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V1c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 19 0 22.9 0 22.9z" clip-rule="evenodd"></path></g><mask id="b" width="67" height="23" x="0" y="6" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 6.2h66.1V29H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M53.4 18.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V29c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="c" width="67" height="22" x="0" y="11" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 11.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M60.4 18.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 29.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="d" width="67" height="18" x="0" y="22" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 22.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 31.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 36.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 36.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 40.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="e" width="67" height="11" x="0" y="39" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 39.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.8 45.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 47.2v2.6L33.6 48l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 49.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 50.8v2.6L33.3 52c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="f" width="67" height="7" x="0" y="50" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 50.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#f)"><path fill="#fff" fill-rule="evenodd" d="M50.3 53.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 57.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 57.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V61c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 64.8v2.6h66.1zM60.2 23c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 33.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 27.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 33.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 38.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 43.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 49s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 6.4 94.3 6.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V37c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 37.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 40.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="g" width="246" height="70" x="0" y="1" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.8h245.7V1H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#g)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 67.3h57.9V28.6H27.5z"></path><path fill="#FFF100" d="M57.1 34.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 37l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 35.8h2L50.9 37l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 34zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 47h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 47h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 59.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M233.3 65.8c.101 0 .2 0 .3.1s.1.1.1.2v.8m8.7.8h3.3V29h-3.3zm-99.1-27c0-.9.1-1.7.2-2.5s.4-1.6.8-2.2.9-1.2 1.6-1.6 1.6-.6 2.8-.6h.8c.3 0 .6.1 1 .1.3 0 .7.1 1 .2l.901.3c.199.1.299.1.299.2.1.1.1.2 0 .4l-.2.8c0 .1-.099.2-.099.3-.101.1-.201.1-.401 0-.5-.1-1-.1-1.599-.2-.601-.1-1.101-.1-1.601-.1-.7 0-1.2.1-1.6.4s-.7.6-1 1-.4 1-.4 1.5c-.1.6-.1 1.2-.1 1.9s0 1.3.1 1.8c.1.6.2 1.1.5 1.5.2.4.5.8 1 1 .4.2.9.4 1.601.4.599 0 1.099 0 1.599-.1s1-.1 1.6-.2h.4c.1.1.1.1.2.3l.201.8q.15.45-.301.6-.3.15-.9.3c-.299.1-.7.1-1 .2-.299.1-.7.1-1 .1h-.9q-1.65 0-2.7-.6c-.7-.4-1.3-.9-1.6-1.5-.4-.6-.7-1.3-.8-2.1-.3-.7-.4-1.6-.4-2.4m17.4 1.6c0-.5 0-1-.101-1.4a12 12 0 0 0-.299-1c-.201-.3-.4-.5-.701-.6-.299-.1-.599-.2-1.099-.2-.401 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.301.6-.301 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.301 1s.4.5.6.6.599.2 1 .2c.5 0 .8-.1 1.099-.2.301-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.9.101-1.4m2.3-.1c0 .6 0 1.2-.1 1.8s-.301 1.2-.6 1.7c-.3.5-.701.9-1.3 1.3-.6.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.3-1.3c-.301-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.299-.5 2.299-.5s1.801.1 2.301.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6.2 1.2.2 1.8m16.2 4.9c0 .1-.101.1-.3.1h-1.4c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1-.199.1-.5.1-.699.2-.2.1-.5.2-.7.3l-.601.3v6.7c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.5c-.2 0-.3-.1-.3-.4V41c0-.6-.1-1.1-.301-1.4-.199-.3-.5-.4-1-.4-.199 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3v6.7c0 .3-.1.4-.401.4H165.2c-.2 0-.4-.1-.4-.4v-9c0-.3.1-.4.4-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3c.301-.1.5-.1.801-.1.6 0 1.1.1 1.6.3s.9.6 1.2 1.1c.5-.4 1.1-.7 1.7-1s1.199-.4 1.9-.4 1.2.1 1.6.3.699.5.9.8c.2.3.299.7.4 1.2.1.5.1.9.1 1.4v5.9c0 .2 0 .3-.1.3m4.7-.3c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.401c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.101.2.101.3zm.199-12v.5c0 .1-.099.3-.199.4-.101.1-.2.2-.4.3-.201.1-.401.1-.6.1-.301 0-.5 0-.601-.1-.2-.1-.299-.2-.399-.3s-.101-.2-.2-.4v-.4c0-.3.099-.6.2-.8.199-.2.5-.3 1-.3s.8.1 1 .3c.1.1.199.3.199.7m9.701 9.5q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.199-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1s.5 0 .7 0h.6c.601 0 1.101-.1 1.4-.3.3-.2.4-.5.4-.9 0-.2 0-.4-.1-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.4-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.699c.301 0 .5 0 .801.1.299 0 .5.1.799.1.3.1.5.1.701.2.299.1.5.3.399.6l-.2.7c0 .1-.1.2-.199.3-.101.1-.201 0-.401 0-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8s.7.2 1.301.3c.5.1.899.2 1.399.3.4.1.8.3 1.2.5.401.2.6.5.8.9.4.5.5 1 .5 1.6m4.3 2.5c0 .1 0 .2-.1.3-.099.1-.099.1-.299.1H196.3c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.1.2.1.3zm.101-12v.5c0 .1-.101.3-.201.4-.099.1-.2.2-.4.3-.199.1-.399.1-.6.1-.299 0-.5 0-.599-.1-.2-.1-.301-.2-.401-.3-.099-.1-.099-.2-.2-.4v-.4c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.3.201.7m8.499 8h-2.4c-.5 0-.9.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.1 3.3c-.5.4-1.1.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.4-.1-.6-.3-.8-.6s-.401-.5-.401-.9-.099-.7-.099-1.2c0-1.2.3-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.101-.3-.2-.4-.3-.5l-.6-.3c-.3-.1-.6-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.399c-.101 0-.101-.1-.2-.2l-.2-.7v-.3c0-.1.2-.2.4-.3s.5-.1.8-.2.599-.1.9-.1c.3 0 .6-.1.9-.1h.799q1.351 0 2.101.3c.5.2.899.4 1.2.7s.4.7.5 1.2.1 1 .1 1.5v4.4c0 .1.099.2.099.3s.101.1.201.1.2 0 .4.1c.1 0 .2 0 .3.1s.099.1.099.2v.8c0 .2-.199.4-.5.4-.199 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.401-.2-.6-.5-.7-1m-63.3 8.2c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4V61c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4V67c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.401 12.9h-1.4c-.1 0-.201 0-.3-.1-.101-.1-.101-.2-.101-.3v-.6c-.199.1-.399.3-.699.4-.301.1-.5.3-.801.4l-.899.3c-.3.1-.601.1-.901.1-.7 0-1.2-.1-1.599-.3-.401-.2-.7-.4-.901-.8-.2-.3-.299-.7-.399-1.2s-.101-.9-.101-1.5v-5.9c0-.3.101-.4.401-.4h1.5c.2 0 .399.1.399.4v5.6c0 .3 0 .6.101.8 0 .2.099.4.2.6.1.2.3.3.399.4.101.1.401.1.701.1.2 0 .4 0 .7-.1s.5-.2.8-.3c.299-.1.5-.2.7-.3s.399-.2.5-.3v-6.7c0-.1 0-.2.099-.3.101-.1.201-.1.3-.1h1.401c.299 0 .4.1.4.4v9c-.101.6-.301.7-.5.7m5.099-.4c0 .3-.1.4-.4.4h-1.5c-.3 0-.4-.1-.4-.4v-9c0-.3.1-.4.4-.4h1.4c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.8-.4c.3-.1.5-.2.8-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.4.2s-.6.1-.9.2-.6.2-.9.2-.6.2-.8.2c-.3.1-.5.2-.6.2zm11-4.5c0-.5 0-1-.1-1.4s-.2-.7-.3-1c-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.2.7.3 1 .4.5.6.6.6.2 1 .2c.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.1-.4.1-.9.1-1.4m2.2-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.3-1.3c-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.3-1.1.6-1.6.7-.9 1.3-1.3c.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.3 1.2s.5 1 .6 1.6c.2.6.2 1.2.2 1.8m8.4 0c0-.6 0-1.2-.1-1.5-.099-.3-.2-.7-.299-.9-.101-.2-.3-.4-.5-.4-.201-.1-.401-.1-.701-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.599.3v5q.75.15 1.2.3c.399 0 .699.1 1.099.1.401 0 .701 0 .901-.2.199-.1.399-.3.599-.5.201-.3.3-.6.3-1 .3-.5.3-1 .3-1.7m2.301 0c0 .8-.101 1.5-.2 2.2-.101.6-.3 1.2-.601 1.6-.3.4-.699.8-1.199 1s-1.2.3-2 .3c-.301 0-.7 0-1.2-.1-.401-.1-.901-.2-1.401-.3v3.5c0 .1 0 .2-.099.3 0 .1-.201.1-.3.1H182.5c-.2 0-.299 0-.299-.1s-.101-.2-.101-.3V57.8c0-.3.101-.4.4-.4h1.401c.099 0 .199 0 .3.1.099.1.099.2.099.3v.6h.101c.199-.1.399-.3.599-.4.201-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.899-.1.7 0 1.2.1 1.601.4.399.2.799.6 1 1s.399 1 .5 1.6c.099.6.2 1.3.2 2m5.8-3.2c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9-.101-.3-.2-.5-.3-.8s-.301-.4-.6-.5c-.3-.1-.6-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8.199.2.4.3.699.4.301.1.601.1 1.101.1.399 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2c-.3 0-.601.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4-.601-.3-1-.7-1.3-1.1-.301-.5-.5-1-.6-1.6s-.201-1.2-.201-1.9c0-.5 0-1 .101-1.6.1-.6.3-1.2.6-1.7.299-.5.7-1 1.299-1.3.601-.3 1.301-.5 2.301-.5.9 0 1.6.1 2.199.4.601.3 1 .6 1.301 1s.5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.401.3-.8.3h-5.5zm14.2-.1h-2.4c-.5 0-.901.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .399 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.199 3.3c-.5.4-1.099.7-1.699.9s-1.301.4-2 .4c-.5 0-1-.1-1.301-.2-.399-.1-.599-.3-.8-.6-.2-.3-.399-.5-.399-.9s-.101-.7-.101-1.2c0-1.2.3-2 .901-2.6.599-.5 1.599-.8 2.8-.8h2.599v-.5c0-.3 0-.5-.099-.8-.1-.3-.201-.4-.3-.5l-.601-.3c-.3-.1-.599-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.199 0-.5 0-.699.1h-.4c-.1 0-.1-.1-.201-.2l-.2-.7v-.3c0-.1.2-.2.401-.3.2-.1.5-.1.799-.2s.601-.1.901-.1.599-.1.899-.1h.801q1.35 0 2.1.3c.5.2.9.4 1.2.7s.399.7.5 1.2c.099.5.099 1 .099 1.5v4.4c0 .1.101.2.101.3s.1.1.199.1c.101 0 .2 0 .401.1.099 0 .2 0 .299.1.101.1.101.1.101.2v.8c0 .2-.2.4-.5.4-.2 0-.301 0-.5.1h-.5c-.5 0-.801-.1-1.101-.3-.399-.2-.599-.5-.7-1m13 1c-.1.1-.199.1-.3.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.301-1.4-.199-.4-.6-.5-1.199-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.2-.301.1-.5.2-.7.3-.201.1-.401.2-.5.2v6.7c0 .3-.101.4-.401.4H214c-.299 0-.4-.1-.4-.4v-9c0-.3.101-.4.4-.4h1.401c.3 0 .399.1.399.4v.6c.2-.1.401-.3.7-.4.3-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.899-.1.7 0 1.2.1 1.601.3.399.2.7.5.899.8s.301.8.4 1.2c.1.5.1.9.1 1.5v5.8q.151.3 0 .3"></path><path fill="#fff" d="M230.4 62.8H228c-.5 0-.901.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .399 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm-1.7-6.3c-.7 0-1.3-.2-1.901-.5-.599-.3-1.099-.9-1.399-1.6-.101-.1-.101-.2-.101-.3s0-.2.101-.3l.5-.4c.1-.1.199-.1.3-.1.099 0 .099.1.2.2.399.5.8.8 1.1 1.1q.45.3 1.2.3c.2 0 .399 0 .599-.1.201-.1.401-.1.5-.3.201-.1.3-.3.5-.4.201-.1.401-.4.601-.6s.3-.2.5-.1l.5.3c.1.1.199.2.1.3-.1.1-.1.3-.201.4-.399.7-.799 1.2-1.399 1.6-.601.4-1 .5-1.7.5m1.8 9.6c-.5.4-1.1.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.401-.1-.6-.3-.8-.6s-.401-.5-.401-.9S224 65 224 64.5c0-1.2.299-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.599v-.5c0-.3 0-.5-.099-.8-.101-.3-.2-.4-.3-.5l-.601-.3c-.299-.1-.599-.1-1-.1H227c-.201 0-.5 0-.701.1-.2 0-.5 0-.7.1h-.399c-.101 0-.101-.1-.2-.2l-.201-.7v-.3c0-.1.201-.2.401-.3s.5-.1.8-.2c.299-.1.599-.1.9-.1.3 0 .6-.1.899-.1h.8q1.351 0 2.101.3c.5.2.899.4 1.2.7s.399.7.5 1.2.1 1 .1 1.5v4.4c0 .1.099.2.099.3s.101.1.2.1c.101 0 .201 0 .401.1.099 0 .2 0 .3.1s.099.1.099.2v.8c0 .2-.199.4-.5.4-.199 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.099-.3-.201-.2-.401-.5-.5-1"></path></g>', 25), x31 = [
  L31
];
function S31(t, e) {
  return T(), N("svg", b31, [...x31]);
}
const C31 = { render: S31 }, k31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, E31 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z"></path></g><path fill="#fff" d="M143.42 33.12q0-.4.4-.4h7.36q.38 0 .38.38v1.24q0 .36-.4.36h-5.46v3.44h4.84q.4 0 .4.36v1.24q0 .36-.4.36h-4.84v3.94h5.6q.36 0 .36.38v1.22q0 .36-.38.36h-7.46q-.4 0-.4-.36zM154.086 46q-.3 0-.4-.1a.5.5 0 0 1-.1-.32v-9q0-.22.08-.3.1-.08.36-.08h4.26q1.74 0 2.54.72t.8 1.94q0 .4-.22.98t-.94.98q.441.18.72.48.28.28.44.6.16.3.22.62t.06.58q0 .66-.28 1.2-.26.54-.72.92a3.2 3.2 0 0 1-1.08.58q-.62.2-1.3.2zm5.6-3.02q0-.5-.32-.88-.3-.4-1.06-.4h-2.56v2.5h2.34q.48 0 .78-.12.32-.12.5-.3t.24-.4q.08-.22.08-.4m-.28-3.96a.9.9 0 0 0-.08-.38.73.73 0 0 0-.22-.32 1 1 0 0 0-.44-.24 1.9 1.9 0 0 0-.66-.1h-2.26v2.16h2.4q.58 0 .92-.32.34-.34.34-.8m13.017 2.02q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12.08.1.08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.981 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a9 9 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.561.06 1.08.06.54 0 .9-.14.381-.16.6-.54.24-.38.34-1 .1-.64.1-1.58m12.55-.08q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.729 4.54q0 .38-.4.38h-1.42q-.38 0-.38-.38l.02-7.58h-4.2v7.58q0 .16-.08.28-.081.1-.3.1h-1.42q-.38 0-.38-.38v-9.04q0-.38.38-.38h7.8q.219 0 .3.08t.08.3zm4.184-3.92q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m6.056-1.16q0-.22.08-.32.1-.12.34-.12h1.3q.28 0 .36.12t.08.32v5.84h.04l2.62-3.56 1.78-2.36q.12-.16.24-.26.14-.1.44-.1h1.04q.24 0 .34.14.1.12.1.28v8.96q0 .42-.46.42h-1.26q-.46 0-.46-.42v-6.12h-.02q-.7.96-1.4 1.9t-1.4 1.9l-.88 1.2q-.44.58-.9 1.18-.12.16-.28.26-.14.1-.42.1h-.86q-.24 0-.34-.1-.08-.1-.08-.32zm4.4-1.36a4.05 4.05 0 0 1-1.92-.5q-.92-.52-1.4-1.58-.08-.16-.14-.34t.1-.32l.54-.44q.18-.12.28-.06a.8.8 0 0 1 .24.18q.6.72 1.08 1.06.5.34 1.24.34.34 0 .6-.08.28-.08.52-.26.26-.18.52-.44t.58-.62q.24-.28.5-.1l.54.34q.201.12.12.32a3 3 0 0 1-.14.38q-.54 1.06-1.4 1.6a3.53 3.53 0 0 1-1.86.52m13.92 9.8q.06.22 0 .36t-.34.26q-.579.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1 .261.38.66.54.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm3.665.58a.5.5 0 0 1-.06.26q-.06.08-.28.08h-1.5q-.34 0-.34-.34v-9.1q0-.36.34-.36h1.5q.22 0 .28.1a.5.5 0 0 1 .06.26v3.52h1.02q.28 0 .52-.04.26-.04.46-.18.22-.16.4-.44.2-.28.38-.74l.8-2.16a.46.46 0 0 1 .2-.24q.12-.06.36-.06h1.22q.28 0 .32.12.06.12 0 .32l-.7 2.08q-.32.94-.68 1.48t-.9.7v.02q.7.24 1.04.7.34.44.62 1.24l.88 2.68q.06.18.02.32-.04.12-.34.12h-1.34a.9.9 0 0 1-.36-.06q-.12-.06-.18-.24l-.78-2.3q-.32-.92-.84-1.2a2.25 2.25 0 0 0-1.08-.28h-1.04zm13.647-4.12h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.97.97 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28a4.4 4.4 0 0 1 .76-.2q.44-.08.9-.12.459-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48a1 1 0 0 0 .1.26.5.5 0 0 0 .22.12q.14.04.38.06.219.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96zm12.26-8.68q.28 0 .38.1.1.08.1.3v9q0 .4-.48.4h-1.26q-.26 0-.36-.1-.08-.1-.08-.3v-3.4h-2.02a1.52 1.52 0 0 0-.88.34q-.34.28-.62 1.12l-.64 1.94q-.08.24-.2.34-.12.08-.4.08h-1.32q-.28 0-.34-.1-.04-.12.02-.34l.7-2.14q.22-.6.46-1.04.24-.46.68-.7a2.1 2.1 0 0 1-.72-.42 2.3 2.3 0 0 1-.44-.6 2.7 2.7 0 0 1-.22-.7q-.06-.36-.06-.7 0-.76.28-1.32.28-.58.76-.96.48-.4 1.12-.6.66-.2 1.38-.2zm-5.54 3.08q0 .58.34.9.36.32 1.2.32h2.3v-2.5h-2.2q-.72 0-1.18.32t-.46.96M145.22 65.66a.5.5 0 0 1-.06.26q-.06.08-.28.08h-1.5q-.34 0-.34-.34v-9.1q0-.36.34-.36h1.5q.22 0 .28.1a.5.5 0 0 1 .06.26v3.52h1.02q.28 0 .52-.04.26-.04.46-.18.22-.16.4-.44.2-.28.38-.74l.8-2.16a.46.46 0 0 1 .2-.24q.12-.06.36-.06h1.22q.28 0 .32.12.06.12 0 .32l-.7 2.08q-.32.94-.68 1.48t-.9.7v.02q.7.24 1.04.7.34.44.62 1.24l.88 2.68q.06.18.02.32-.04.12-.34.12h-1.34a.9.9 0 0 1-.36-.06q-.12-.06-.18-.24l-.78-2.3q-.32-.92-.84-1.2a2.25 2.25 0 0 0-1.08-.28h-1.04zm16.087-4.72q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.288-.72-.88 1.68q-.279.54-.54 1.06-.26.5-.6 1.1-.18.34-.58.34h-.68q-.28 0-.4-.08a.6.6 0 0 1-.2-.24 26 26 0 0 0-.54-.96q-.26-.44-.5-.92-.26-.46-.52-1a17 17 0 0 0-.52-1h-.04v5.26q0 .4-.46.4h-1.24q-.42 0-.42-.4v-8.98q0-.4.4-.4h1.16q.3 0 .42.08.141.08.24.26.32.58.62 1.16.32.58.62 1.16.46.84.86 1.66.42.8.88 1.64l1.56-2.96 1.42-2.64a.66.66 0 0 1 .24-.26q.16-.1.44-.1h1.04q.4 0 .4.38v9q0 .4-.42.4h-1.26q-.44 0-.44-.4v-5.24zm4.283-3.72q0-.22.08-.32.1-.12.34-.12h1.3q.279 0 .36.12t.08.32v5.84h.04l2.62-3.56 1.78-2.36q.12-.16.24-.26.14-.1.44-.1h1.04q.24 0 .34.14.1.12.1.28v8.96q0 .42-.46.42h-1.26q-.46 0-.46-.42v-6.12h-.02q-.7.96-1.4 1.9t-1.4 1.9l-.88 1.2-.9 1.18q-.12.16-.28.26-.141.1-.42.1h-.86q-.24 0-.34-.1-.08-.1-.08-.32zm18.32 8.44q.06.22 0 .36t-.34.26q-.58.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.4 4.4 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.399.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1t.66.54q.42.14 1.02.14.459 0 1.2-.04.759-.06 1.38-.14.24-.04.36 0t.16.3zm8.964 0q.06.22 0 .36t-.34.26q-.579.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1 .261.38.66.54.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm1.485-8.44q0-.22.08-.32.1-.12.34-.12h1.3q.28 0 .36.12t.08.32v5.84h.04l2.62-3.56 1.78-2.36q.12-.16.24-.26.14-.1.44-.1h1.04q.24 0 .34.14.1.12.1.28v8.96q0 .42-.46.42h-1.26q-.46 0-.46-.42v-6.12h-.02q-.7.96-1.4 1.9t-1.4 1.9l-.88 1.2q-.44.58-.9 1.18a1 1 0 0 1-.28.26q-.14.1-.42.1h-.86q-.24 0-.34-.1-.08-.1-.08-.32zm18.52-.46q.28 0 .38.1.1.08.1.3v9q0 .4-.48.4h-1.26q-.26 0-.36-.1-.08-.1-.08-.3v-3.4h-2.02q-.52.04-.88.34-.34.28-.62 1.12l-.64 1.94q-.08.24-.2.34-.12.08-.4.08h-1.32q-.28 0-.34-.1-.04-.12.02-.34l.7-2.14q.22-.6.46-1.04.24-.46.68-.7a2.1 2.1 0 0 1-.72-.42 2.3 2.3 0 0 1-.44-.6 2.7 2.7 0 0 1-.22-.7q-.06-.36-.06-.7 0-.76.28-1.32.28-.58.76-.96.48-.4 1.12-.6.66-.2 1.38-.2zm-5.54 3.08q0 .58.34.9.36.32 1.2.32h2.3v-2.5h-2.2q-.72 0-1.18.32t-.46.96"></path><path fill="#fff" fill-rule="evenodd" d="M263 66.7h3.3V28H263z" clip-rule="evenodd"></path>', 26), A31 = [
  E31
];
function F31(t, e) {
  return T(), N("svg", k31, [...A31]);
}
const T31 = { render: F31 }, I31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, O31 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="234" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h233.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zM178.3 31.8c.2.1.2.3.101.4l-2 2.8c-.101.1-.201.2-.401.1l-.8-.4c-.1-.1-.2-.2-.1-.4l1.6-3.1c.1-.2.201-.2.4-.1zm-.399 9.3c0-.5 0-1-.101-1.4-.1-.4-.2-.7-.3-1-.2-.3-.4-.5-.7-.6s-.6-.2-1.1-.2c-.4 0-.799.1-1 .2s-.5.3-.6.6c-.199.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4c.101.4.2.7.3 1s.4.5.6.6c.201.1.6.2 1 .2.5 0 .8-.1 1.1-.2s.5-.3.7-.6.3-.6.3-1c.101-.4.101-.8.101-1.4m2.299-.1c0 .6 0 1.2-.1 1.8s-.3 1.2-.6 1.7-.7.9-1.3 1.3c-.6.3-1.4.5-2.4.5s-1.8-.2-2.399-.5c-.601-.3-1-.7-1.301-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6s.301-1.1.6-1.6c.3-.5.701-.9 1.3-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.6.3 1 .7 1.301 1.2.299.5.5 1 .599 1.6.1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m9.1 2q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1a21 21 0 0 1-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.199-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.699-.5 1.6-.8 2.699-.8h.7c.3 0 .5 0 .8.1s.5.1.801.1c.3 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3h-.399c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8s.701.2 1.3.3c.5.1.901.2 1.401.3.4.1.799.3 1.2.5.399.2.599.5.8.9.299.4.4.9.4 1.5m4.2-3.2 1.5-1.6 1.7-1.7.3-.3c.101-.1.2-.1.4-.1h1.6c.2 0 .301 0 .301.1s0 .2-.101.3l-3.2 3.3 3.601 5.7q.148.15 0 .3c-.101.1-.101.1-.3.1h-1.5c-.2 0-.401 0-.5-.1-.101-.1-.2-.2-.2-.3l-2.601-4.1-1.1 1.2v3c0 .1 0 .2-.099.3-.101.1-.2.1-.301.1h-1.399c-.3 0-.401-.1-.401-.4V32.3c0-.3.101-.4.401-.4h1.399c.101 0 .2 0 .301.1.099.1.099.2.099.3zm13.499 1.7H215.2c-.5 0-.901.1-1.201.4-.299.2-.4.7-.4 1.3q0 .6.301.9c.199.2.5.3 1 .3.199 0 .399 0 .699-.1.301-.1.5-.1.801-.2.3-.1.5-.2.699-.3.2-.1.5-.2.601-.3v-2zm.101 3.3c-.5.4-1.101.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.401-.1-.601-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .899-2.6.601-.5 1.601-.8 2.8-.8h2.601v-.5c0-.3 0-.5-.101-.8-.1-.2-.199-.4-.3-.5l-.599-.3c-.3-.1-.601-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.4c-.1 0-.1-.1-.199-.3l-.401-.6v-.3c0-.1.201-.2.401-.3.199-.1.5-.1.8-.2.299-.1.599-.1.899-.1s.601-.1.9-.1h.8q1.351 0 2.101.3c.5.2.899.4 1.199.7s.4.7.5 1.2c.101.5.101 1 .101 1.5v4.4c0 .1.099.2.099.3s.101.1.2.1c.1 0 .201 0 .401.1.099 0 .199 0 .3.1.099.1.099.1.099.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.099-.3-.201-.2-.401-.5-.5-1m-72.3 15.3 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.1.1-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.5 1.2c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6s.199 1.2.199 1.8m16.301 5c0 .1-.101.1-.301.1H175.7c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1s-.5.1-.7.2-.5.2-.699.3l-.601.3V66c0 .1 0 .2-.099.3-.101.1-.2.1-.3.1h-1.5c-.2 0-.301-.1-.301-.4v-5.8c0-.6-.099-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3V66c0 .3-.101.4-.401.4H163.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.399c.3 0 .401.1.401.4v.6c.2-.1.399-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3.5-.1.8-.1c.601 0 1.101.1 1.601.3s.899.6 1.2 1.1c.5-.4 1.1-.7 1.699-1 .601-.3 1.2-.4 1.901-.4.7 0 1.2.1 1.599.3.401.2.7.5.901.8.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.7-.3c0 .1 0 .2-.1.3 0 .1-.099.1-.299.1H180.3c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4-.099.1-.2.2-.4.3-.199.1-.399.1-.6.1-.299 0-.5 0-.599-.1-.2-.1-.301-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.4.201.7m9.699 9.5q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.199-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.699-.5 1.6-.8 2.699-.8h.7c.3 0 .5 0 .8.1s.5.1.801.1c.3 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3h-.399c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8s.701.2 1.3.3c.5.1.901.2 1.401.3.4.1.799.3 1.2.5.399.2.599.5.8.9.299.4.4.9.4 1.5m4.3 2.6c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.2-12.1v.5c0 .2-.1.3-.2.4-.101.1-.2.2-.4.3-.201.1-.4.1-.6.1-.3 0-.5 0-.601-.1-.199-.1-.299-.2-.399-.3s-.101-.2-.2-.4V54c0-.3.099-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m8.4 8h-2.399c-.5 0-.901.1-1.201.4-.299.2-.4.7-.4 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.601-.3v-2zm.101 3.3c-.5.4-1.101.7-1.701.9s-1.299.4-2 .4c-.5 0-1-.1-1.299-.2-.401-.1-.601-.3-.801-.6-.199-.2-.4-.5-.4-.9-.1-.3-.1-.7-.1-1.2 0-1.2.301-2 .9-2.6.6-.5 1.6-.8 2.8-.8h2.601v-.5c0-.3 0-.5-.101-.8-.1-.2-.2-.4-.3-.5l-.599-.3c-.301-.1-.601-.1-1-.1H201.6c-.199 0-.5 0-.699.1-.201 0-.5 0-.701.1h-.4c-.1 0-.1-.1-.2-.3l-.199-.7v-.3c.099-.1.199-.2.399-.3s.5-.1.8-.2.6-.1.9-.1.6-.1.901-.1h.799q1.35 0 2.1.3c.5.2.9.4 1.2.7s.401.7.5 1.2c.1.5.1 1 .1 1.5v4.4c0 .1.1.2.1.3s.1.1.201.1c.099 0 .199 0 .399.1.101 0 .2 0 .3.1.1 0 .1.1.1.2v.8c0 .2-.2.4-.5.4-.2 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.1-.3-.3-.1-.5-.4-.699-.9m25.499 1.5h3.3V28h-3.3z"></path></g>', 24), N31 = [
  O31
];
function P31(t, e) {
  return T(), N("svg", I31, [...N31]);
}
const B31 = { render: P31 }, V31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "76",
  fill: "none",
  viewBox: "0 0 290 76"
}, R31 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="234" height="71" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 70.6h233.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm14.3 10.5s0-.2.1-.4.2-.5.299-.8c.101-.3.201-.7.401-1.1l1.599-4.7c0-.1.101-.2.201-.2.1-.1.2-.1.299-.1h1.5c.301 0 .301.1.201.4l-3.4 9c-.1.1-.1.3-.2.3-.101.1-.2.1-.4.1H157c-.2 0-.3 0-.401-.1-.099-.1-.099-.2-.199-.3l-3.4-9v-.3c0-.1.099-.1.2-.1h1.6c.1 0 .299 0 .299.1.101 0 .101.1.201.3l1.6 4.7c.1.4.199.8.3 1.1s.2.5.2.8zm8.6 2.1c0 .3-.1.4-.399.4h-1.5c-.301 0-.401-.1-.401-.4v-9.1c0-.3.1-.4.401-.4h1.399c.3 0 .4.1.4.4v.9c.1-.1.3-.3.6-.4.2-.2.5-.3.8-.4s.6-.2.801-.4c.299-.1.5-.2.799-.2h.3c.1 0 .1.1.2.3l.1 1.3v.3c0 .1-.1.1-.399.2-.301.1-.601.1-.901.2s-.599.2-.9.2c-.3.1-.6.2-.8.3s-.5.2-.6.2zm11-4.6c0-.5 0-1-.1-1.4s-.2-.7-.299-1c-.201-.3-.401-.5-.701-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.201.7.3 1c.1.3.401.5.6.6.2.1.6.2 1 .2.5 0 .801-.1 1.1-.2s.5-.3.701-.6c.199-.3.299-.6.299-1s.1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.099 1.8-.101.6-.301 1.2-.601 1.7s-.7.9-1.3 1.3c-.599.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.299-1.3c-.301-.5-.5-1.1-.5-1.7-.101-.6-.101-1.2-.101-1.8 0-.5 0-1 .101-1.6a4.4 4.4 0 0 1 .599-1.6c.3-.5.7-.9 1.3-1.3.601-.3 1.3-.5 2.3-.5s1.801.1 2.301.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .6 1.6.2.6.2 1.2.2 1.8m8.4.1c0-.6 0-1.2-.101-1.5q-.15-.6-.299-.9c-.1-.2-.3-.4-.5-.4-.201-.1-.401-.1-.701-.1-.2 0-.399 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.599.3v5q.75.15 1.2.3c.3.1.7.1 1.099.1.401 0 .701-.1.901-.2s.399-.3.599-.5c.201-.3.3-.6.3-1 .301-.6.301-1.1.301-1.7m2.3 0c0 .8-.101 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6-.301.4-.7.8-1.2 1s-1.2.3-2 .3c-.3 0-.7 0-1.2-.1s-.901-.2-1.401-.3v3.5c0 .1 0 .2-.099.3-.1.1-.201.1-.3.1h-1.401c-.2 0-.299 0-.299-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.399-.4h1.401c.099 0 .2 0 .3.1s.099.2.099.3v.6h.101c.2-.1.399-.2.599-.4.201-.1.5-.3.8-.4l.901-.3c.299-.1.599-.1.9-.1.699 0 1.199.1 1.6.4.4.2.799.6 1 1s.4 1 .5 1.6.2 1.3.2 2.1m9.1 2q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.4.2-.8.4-1.3.5s-1 .2-1.5.2-1.1 0-1.6-.1q-.9-.15-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.199-.3h.4c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.601 0 1.101-.1 1.4-.3.3-.2.4-.5.4-.9 0-.2 0-.4-.1-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.4-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.699c.301 0 .5 0 .801.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.399.6l-.2.7c0 .1-.1.2-.199.3H198c-.4-.1-.9-.1-1.4-.2-.5 0-.9-.1-1.3-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.4.8.301.1.7.2 1.301.3.5.1.899.2 1.399.3s.8.3 1.2.5c.3.2.6.5.8.9.4.4.5.9.5 1.5m4.2-3.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.1.1-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V32.3c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.401 1.7h-2.4c-.5 0-.901.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .399 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.199 3.3c-.5.4-1.099.7-1.699.9s-1.301.4-2 .4c-.5 0-1-.1-1.301-.2-.399-.1-.599-.3-.8-.6-.2-.2-.399-.5-.399-.9-.101-.3-.101-.7-.101-1.2 0-1.2.3-2 .901-2.6.599-.5 1.599-.8 2.8-.8h2.599v-.5c0-.3 0-.5-.099-.8-.1-.2-.201-.4-.3-.5l-.601-.3c-.3-.1-.599-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.199 0-.5 0-.699.1h-.4c-.1 0-.1-.1-.201-.3l-.2-.7v-.3c.101-.1.2-.2.401-.3.2-.1.5-.1.799-.2s.601-.1.901-.1.599-.1.899-.1h.801q1.35 0 2.1.3c.5.2.9.4 1.2.7s.399.7.5 1.2c.099.5.099 1 .099 1.5V44c0 .1.101.2.101.3s.1.1.199.1c.101 0 .2 0 .401.1.099 0 .2 0 .299.1.101 0 .101.1.101.2v.8c0 .2-.2.4-.5.4-.2 0-.301 0-.5.1h-.5c-.5 0-.801-.1-1.101-.3-.399-.1-.599-.4-.7-.9m-71.7 15.3 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.1.1-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.5 1.2c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6s.199 1.2.199 1.8m16.301 5c0 .1-.101.1-.301.1H175.7c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1s-.5.1-.7.2-.5.2-.699.3l-.601.3V66c0 .1 0 .2-.099.3-.101.1-.2.1-.3.1h-1.5c-.2 0-.301-.1-.301-.4v-5.8c0-.6-.099-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3V66c0 .3-.101.4-.401.4H163.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.399c.3 0 .401.1.401.4v.6c.2-.1.399-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3.5-.1.8-.1c.601 0 1.101.1 1.601.3s.899.6 1.2 1.1c.5-.4 1.1-.7 1.699-1 .601-.3 1.2-.4 1.901-.4.7 0 1.2.1 1.599.3.401.2.7.5.901.8.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c-.1.1-.1.2-.1.3m4.7-.3c0 .1 0 .2-.1.3 0 .1-.099.1-.299.1H180.3c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1 0 .1.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4-.099.1-.2.2-.4.3-.199.1-.399.1-.6.1-.299 0-.5 0-.599-.1-.2-.1-.301-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.4.201.7m9.699 9.5q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1.201.1.401 0 .601 0 .6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.199-.4a.77.77 0 0 0-.5-.2c-.2-.1-.5-.1-.801-.2-.5-.1-1-.2-1.399-.3-.401-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.699-.5 1.6-.8 2.699-.8h.7c.3 0 .5 0 .8.1s.5.1.801.1c.3 0 .5.1.699.2.301.1.5.3.401.6l-.201.7c0 .1-.099.2-.2.3h-.399c-.401-.1-.901-.1-1.401-.2-.5 0-1-.1-1.299-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.399.8s.701.2 1.3.3c.5.1.901.2 1.401.3.4.1.799.3 1.2.5.399.2.599.5.8.9.299.4.4.9.4 1.5m4.3 2.6c0 .1 0 .2-.101.3-.099.1-.099.1-.299.1h-1.4c-.301 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.4c.1 0 .2 0 .299.1.101.1.101.2.101.3zm.2-12.1v.5c0 .2-.1.3-.2.4-.101.1-.2.2-.4.3-.201.1-.4.1-.6.1-.3 0-.5 0-.601-.1-.199-.1-.299-.2-.399-.3s-.101-.2-.2-.4V54c0-.3.099-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m5.199 0v.5c0 .2-.1.3-.199.4-.101.1-.2.2-.401.3-.2.1-.4.1-.599.1-.301 0-.5 0-.601-.1-.2-.1-.3-.2-.399-.3-.101-.1-.101-.2-.2-.4V54c0-.3.099-.6.2-.8.199-.2.5-.3 1-.3s.8.1 1 .3c.099.1.199.4.199.7m-.1 12.7c0 .7-.099 1.2-.2 1.7-.099.5-.399.9-.8 1.3-.4.3-.799.6-1.4.8s-1.3.2-2.1.2c-.099 0-.2 0-.299-.1-.101-.1-.201-.2-.201-.3l-.099-.9V69c0-.1.099-.1.3-.1q.75-.15 1.2-.3c.3-.1.599-.2.8-.4.2-.1.299-.3.399-.6.101-.2.101-.5.101-.9V57c0-.3.099-.4.399-.4h1.4c.3 0 .401.1.401.4v9.6zm8.6-4.7H207.7c-.5 0-.901.1-1.201.4-.299.2-.4.7-.4 1.3q0 .6.301.9c.199.2.5.3 1 .3.199 0 .399 0 .699-.1.301-.1.5-.1.801-.2.3-.1.5-.2.699-.3.2-.1.5-.2.601-.3v-2zm.101 3.3c-.5.4-1.101.7-1.701.9-.599.2-1.299.4-2 .4-.5 0-1-.1-1.299-.2-.401-.1-.601-.3-.8-.6-.2-.2-.401-.5-.401-.9-.099-.3-.099-.7-.099-1.2 0-1.2.3-2 .899-2.6.601-.5 1.601-.8 2.8-.8h2.601v-.5c0-.3 0-.5-.101-.8-.1-.2-.199-.4-.3-.5l-.599-.3c-.3-.1-.601-.1-1-.1h-1.3c-.2 0-.5 0-.7.1-.201 0-.5 0-.701.1h-.4c-.1 0-.1-.1-.199-.3l-.2-.7v-.3c.099-.1.2-.2.399-.3.2-.1.5-.1.801-.2.3-.1.599-.1.899-.1s.601-.1.901-.1h.799q1.35 0 2.1.3c.5.2.9.4 1.2.7s.401.7.5 1.2c.101.5.101 1 .101 1.5v4.4c0 .1.099.2.099.3s.1.1.201.1c.099 0 .2 0 .399.1.101 0 .2 0 .301.1.099 0 .099.1.099.2v.8c0 .2-.2.4-.5.4-.2 0-.299 0-.5.1h-.5c-.5 0-.799-.1-1.099-.3-.301-.1-.5-.4-.7-.9m20.2 1.5h3.3V28h-3.3z"></path></g>', 24), H31 = [
  R31
];
function D31(t, e) {
  return T(), N("svg", V31, [...H31]);
}
const $31 = { render: D31 }, U31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, j31 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.201 3.5 14.001 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" stroke="#fff" stroke-width="2" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M143.4 33.1c0-.3.1-.4.4-.4h7.4c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-5.5v3.5h4.9c.3 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-4.9v4h5.6c.2 0 .4.1.4.4v1.2c0 .2-.1.4-.4.4h-7.5c-.3 0-.4-.1-.4-.4zm18.4 13h-1.399c-.101 0-.201 0-.301-.1s-.1-.2-.1-.3V45c-.2.1-.4.3-.7.4s-.5.3-.8.4l-.9.3c-.3.1-.6.1-.9.1-.7 0-1.2-.1-1.6-.3s-.699-.4-.9-.8c-.2-.3-.299-.7-.4-1.2-.1-.5-.1-.9-.1-1.5v-5.9c0-.3.1-.4.4-.4h1.5c.2 0 .4.1.4.4v5.6c0 .3 0 .6.1.8 0 .2.1.4.2.6.101.2.3.3.4.4s.4.1.701.1c.199 0 .399 0 .699-.1.301-.1.5-.2.801-.3.299-.1.5-.2.699-.3.2-.1.4-.2.5-.3v-6.7c0-.1 0-.2.1-.3s.201-.1.3-.1h1.401c.299 0 .399.1.399.4v9.1c-.1.5-.2.7-.5.7m5.101-.4c0 .3-.101.4-.4.4h-1.5c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.9c.101-.1.3-.3.601-.4.199-.2.5-.3.8-.4s.599-.2.8-.4c.299-.1.5-.2.799-.2h.3c.101 0 .101.1.2.3l.101 1.3v.3c0 .1-.101.1-.4.2s-.6.1-.901.2c-.3.1-.599.2-.899.2-.3.1-.601.2-.8.3-.301.1-.5.2-.601.2zm10.999-4.6c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1c.101-.4.101-.8.101-1.4m2.3-.1c0 .6 0 1.2-.101 1.8-.099.6-.3 1.2-.599 1.7-.3.5-.701.9-1.3 1.3-.601.3-1.401.5-2.401.5s-1.799-.2-2.399-.5-1-.7-1.301-1.3c-.3-.5-.5-1.1-.5-1.7-.099-.6-.099-1.2-.099-1.8 0-.5 0-1 .099-1.6a4.4 4.4 0 0 1 .601-1.6c.3-.5.7-.9 1.3-1.3.599-.3 1.299-.5 2.299-.5s1.8.1 2.3.4c.601.3 1 .7 1.301 1.2s.5 1 .6 1.6.2 1.2.2 1.8m8.3.1c0-.6 0-1.2-.1-1.5s-.2-.7-.3-.9-.3-.4-.5-.4c-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.7.1s-.5.1-.8.2c-.2.1-.5.2-.7.3l-.6.3v5q.75.15 1.2.3c.3.1.7.1 1.1.1s.7-.1.9-.2.4-.3.6-.5c.2-.3.3-.6.3-1 .3-.6.3-1.1.3-1.7m2.3 0c0 .8-.1 1.5-.2 2.2-.1.6-.3 1.2-.6 1.6s-.7.8-1.2 1-1.2.3-2 .3c-.3 0-.7 0-1.2-.1-.4-.1-.9-.2-1.4-.3v3.5c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.2 0-.3 0-.3-.1s-.1-.2-.1-.3V36.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3v.6h.1c.2-.1.4-.2.6-.4.2-.1.5-.3.8-.4l.9-.3c.3-.1.6-.1.9-.1.7 0 1.2.1 1.6.4.4.2.8.6 1 1s.4 1 .5 1.6c.2.6.2 1.3.2 2.1m5.901-3.3c-.4 0-.7.1-.9.2s-.4.3-.6.5-.3.5-.3.8c-.1.3-.1.6-.1 1h4c0-.3 0-.6-.1-.9-.101-.3-.2-.5-.3-.8s-.301-.4-.6-.5c-.4-.2-.701-.3-1.1-.3m-2 3.9c0 .5.1.9.2 1.3.1.3.3.6.5.8.199.2.4.3.699.4.301.1.601.1 1.101.1.399 0 .8 0 1.3-.1s.9-.1 1.3-.1h.4c.1 0 .1.1.2.3l.1.7v.4q0 .15-.3.3c-.2.1-.4.2-.7.2s-.5.1-.8.2-.601.1-.9.1h-.8c-1 0-1.7-.1-2.3-.4-.601-.3-1-.7-1.3-1.1-.301-.5-.5-1-.6-1.6s-.201-1.2-.201-1.9c0-.5 0-1 .101-1.6.1-.6.3-1.2.6-1.7.299-.5.7-1 1.299-1.3.601-.4 1.301-.5 2.301-.5.9 0 1.6.1 2.199.4.601.3 1 .6 1.301 1s.5.9.6 1.4.2 1.1.2 1.6c0 .4 0 .7-.2.9s-.401.3-.8.3h-5.5zm10.599 4c0 .1 0 .2-.1.3 0 .1-.1.1-.299.1H203.5c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.401c.099 0 .199 0 .299.1 0 .1.1.2.1.3zm.101-12.1v.5c0 .1-.101.3-.201.4s-.2.2-.4.3-.399.1-.6.1c-.299 0-.5 0-.6-.1-.199-.1-.3-.2-.4-.3s-.1-.2-.2-.4v-.4c0-.3.1-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.1.1.201.4.201.7m9.699 9.5q0 .9-.3 1.5c-.2.4-.5.7-.899 1-.401.2-.801.4-1.301.5s-1 .2-1.5.2-1.1 0-1.6-.1a21 21 0 0 1-1.5-.3c-.2-.1-.299-.2-.4-.3-.1-.1-.1-.2 0-.4l.101-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.3 0 .5 0 .7.1h.6c.601 0 1.101-.1 1.4-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.2-.5-.3-.2-.6-.5-.8-.8s-.3-.8-.3-1.3c0-1 .3-1.7 1-2.3.701-.5 1.6-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.399.6l-.199.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.301-.1-.6 0-1.1.1-1.3.3q-.3.3-.3.9c0 .4.1.6.401.8.3.1.699.2 1.3.3.5.1.899.2 1.399.3s.801.3 1.2.5c.3.2.601.5.8.9.4.4.5.9.5 1.5m4.1-3.2 1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.399-.1h1.601c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.1.1-.1.1-.3.1h-1.5c-.2 0-.401 0-.5-.1-.1-.1-.2-.2-.2-.3l-2.6-4.1-1.101 1.2v3c0 .1 0 .2-.099.3-.1.1-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V32.3c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.099.2.099.3zm13.501 1.7h-2.4c-.5 0-.9.1-1.201.4-.299.2-.399.7-.399 1.3q0 .6.3.9c.2.2.5.3 1 .3.2 0 .4 0 .7-.1s.5-.1.8-.2.5-.2.7-.3.5-.2.6-.3v-2zm.2 3.3c-.5.4-1.1.7-1.7.9-.601.2-1.3.4-2 .4-.5 0-1-.1-1.3-.2-.4-.1-.6-.3-.801-.6-.199-.2-.399-.5-.399-.9-.101-.3-.101-.7-.101-1.2 0-1.2.301-2 .901-2.6.599-.5 1.599-.8 2.8-.8h2.6v-.5c0-.3 0-.5-.1-.8-.1-.2-.201-.4-.3-.5l-.6-.3c-.301-.1-.6-.1-1-.1H229.6c-.199 0-.5 0-.699.1-.2 0-.5 0-.7.1h-.4c-.1 0-.1-.1-.201-.3l-.199-.7v-.3c.1-.1.199-.2.4-.3.2-.1.5-.1.799-.2.301-.1.601-.1.901-.1s.599-.1.9-.1h.8q1.35 0 2.1.3c.5.2.9.4 1.2.7s.4.7.5 1.2.099 1 .099 1.5V44c0 .1.101.2.101.3s.1.1.2.1.199 0 .4.1c.1 0 .2 0 .299.1.101 0 .101.1.101.2v.8c0 .2-.2.4-.5.4-.2 0-.3 0-.5.1h-.5c-.5 0-.8-.1-1.101-.3-.399-.1-.599-.4-.699-.9M145.4 60.2l1.5-1.6 1.7-1.7.3-.3c.1-.1.2-.1.4-.1h1.6c.2 0 .3 0 .3.1s0 .2-.1.3l-3.2 3.3 3.6 5.7q.15.15 0 .3c-.1.1-.1.1-.3.1h-1.5c-.2 0-.4 0-.5-.1s-.2-.2-.2-.3l-2.6-4.1-1.1 1.2v3c0 .1 0 .2-.1.3s-.2.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4V52.6c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1s.1.2.1.3zm13.5 1.2c0-.5 0-1-.101-1.4-.099-.4-.2-.7-.299-1-.201-.3-.401-.5-.701-.6s-.599-.2-1.099-.2c-.401 0-.8.1-1 .2s-.5.3-.601.6c-.199.3-.3.6-.3 1-.099.4-.099.9-.099 1.4s0 1 .099 1.4c.101.4.201.7.3 1 .101.3.401.5.601.6s.599.2 1 .2c.5 0 .8-.1 1.099-.2.3-.1.5-.3.701-.6s.299-.6.299-1 .101-.8.101-1.4m2.199-.1c0 .6 0 1.2-.099 1.8-.1.6-.3 1.2-.6 1.7-.301.5-.7.9-1.301 1.3-.599.3-1.399.5-2.399.5s-1.8-.2-2.401-.5c-.599-.3-1-.7-1.299-1.3-.3-.5-.5-1.1-.5-1.7-.1-.6-.1-1.2-.1-1.8 0-.5 0-1 .1-1.6a4.4 4.4 0 0 1 .599-1.6c.301-.5.7-.9 1.301-1.3.6-.3 1.3-.5 2.3-.5s1.8.1 2.3.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .601 1.6s.199 1.2.199 1.8m16.301 5c0 .1-.101.1-.301.1H175.7c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1s-.5.1-.7.2-.5.2-.699.3l-.601.3V66c0 .1 0 .2-.099.3-.101.1-.2.1-.3.1h-1.5c-.2 0-.301-.1-.301-.4v-5.8c0-.6-.099-1.1-.3-1.4s-.5-.4-1-.4c-.2 0-.399 0-.599.1s-.401.1-.7.2c-.201.1-.5.2-.701.3l-.599.3V66c0 .3-.101.4-.401.4H163.4c-.2 0-.4-.1-.4-.4v-9.1c0-.3.099-.4.4-.4h1.399c.3 0 .401.1.401.4v.6c.2-.1.399-.3.599-.4.201-.1.5-.3.701-.4s.5-.2.799-.3.5-.1.8-.1c.601 0 1.101.1 1.601.3s.899.6 1.2 1.1c.5-.4 1.1-.7 1.699-1 .601-.3 1.2-.4 1.901-.4.7 0 1.2.1 1.599.3.401.2.7.5.901.8.2.3.299.7.4 1.2.1.5.1.9.1 1.4v6c-.1.1-.1.2-.1.3m16.501 0c0 .1-.101.1-.301.1h-1.399c-.3 0-.401-.1-.401-.4v-5.7c0-.7-.099-1.3-.299-1.5-.201-.3-.6-.4-1.1-.4-.2 0-.4 0-.601.1s-.5.1-.7.2-.5.2-.699.3l-.601.3V66c0 .1 0 .2-.099.3-.101.1-.2.1-.3.1h-1.4c-.201 0-.3-.1-.3-.4v-5.8c0-.6-.101-1.1-.3-1.4-.2-.3-.5-.4-1-.4-.2 0-.4 0-.601.1s-.399.1-.7.2-.5.2-.699.3l-.601.3V66c0 .3-.099.4-.399.4h-1.4c-.201 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .399.1.399.4v.6c.201-.1.401-.3.601-.4s.5-.3.699-.4c.301-.1.5-.2.801-.3.3-.1.5-.1.8-.1.599 0 1.099.1 1.599.3s.901.6 1.201 1.1c.5-.4 1.099-.7 1.7-1 .599-.3 1.2-.4 1.899-.4s1.2.1 1.601.3c.399.2.7.5.899.8s.301.7.401 1.2c.099.5.099.9.099 1.4v6c-.099.1-.099.2-.199.3m4.699-.3c0 .1 0 .2-.1.3-.099.1-.099.1-.299.1H196.8c-.3 0-.399-.1-.399-.4v-9.1c0-.3.099-.4.399-.4h1.401c.099 0 .2 0 .299.1.1.1.1.2.1.3zm.101-12.1v.5c0 .2-.101.3-.201.4-.099.1-.2.2-.4.3-.199.1-.399.1-.6.1-.299 0-.5 0-.599-.1-.2-.1-.301-.2-.401-.3-.099-.1-.099-.2-.2-.4V54c0-.3.101-.6.2-.8.201-.2.5-.3 1-.3s.8.1 1 .3c.201.1.201.4.201.7m9.7 9.5q0 .9-.301 1.5c-.199.4-.5.7-.899 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3c-.2-.1-.299-.2-.399-.3s-.101-.2 0-.4l.1-.7c0-.2.099-.3.2-.3h.399c.2 0 .5.1.7.1.3 0 .5 0 .8.1.301 0 .5 0 .7.1h.601c.6 0 1.1-.1 1.399-.3.3-.2.401-.5.401-.9 0-.2 0-.4-.101-.6-.099-.2-.099-.3-.3-.4s-.299-.2-.5-.2c-.2-.1-.5-.1-.799-.2-.5-.1-1-.2-1.401-.3-.399-.1-.8-.3-1.199-.5-.301-.2-.601-.5-.801-.8-.199-.3-.3-.8-.3-1.3 0-1 .3-1.7 1-2.3.701-.5 1.601-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1s.5.1.701.2c.299.1.5.3.4.6l-.2.7c0 .1-.101.2-.2.3h-.401c-.399-.1-.899-.1-1.399-.2-.5 0-.901-.1-1.3-.1-.601 0-1.101.1-1.301.3q-.3.3-.3.9c0 .4.101.6.401.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.199.5c.301.2.601.5.801.9.399.4.5.9.5 1.5m9.3 0q0 .9-.3 1.5c-.2.4-.5.7-.9 1-.401.2-.8.4-1.3.5s-1 .2-1.5.2-1.101 0-1.601-.1q-.898-.15-1.5-.3a1.4 1.4 0 0 1-.399-.3c-.101-.1-.101-.2 0-.4l.1-.7c0-.2.1-.3.2-.3h.4c.199 0 .5.1.699.1.301 0 .5 0 .801.1.3 0 .5 0 .699.1h.601c.6 0 1.1-.1 1.399-.3.301-.2.401-.5.401-.9 0-.2 0-.4-.1-.6s-.1-.3-.301-.4c-.199-.1-.299-.2-.5-.2-.199-.1-.5-.1-.799-.2-.5-.1-1-.2-1.4-.3s-.801-.3-1.2-.5c-.3-.2-.601-.5-.8-.8s-.301-.8-.301-1.3c0-1 .301-1.7 1-2.3.701-.5 1.601-.8 2.701-.8h.7c.3 0 .5 0 .8.1.299 0 .5.1.799.1.301 0 .5.1.701.2.299.1.5.3.4.6l-.2.7c0 .1-.1.2-.2.3h-.4c-.4-.1-.9-.1-1.4-.2-.5 0-.901-.1-1.3-.1-.601 0-1.101.1-1.3.3q-.3.3-.301.9c0 .4.101.6.401.8.3.1.7.2 1.3.3.5.1.9.2 1.4.3s.8.3 1.2.5c.3.2.6.5.8.9.399.4.5.9.5 1.5M222 66c0 .1 0 .2-.1.3 0 .1-.1.1-.3.1h-1.4c-.3 0-.4-.1-.4-.4v-9.1c0-.3.1-.4.4-.4h1.4c.1 0 .2 0 .3.1 0 .1.1.2.1.3zm.1-12.1v.5c0 .1-.1.3-.2.4s-.2.2-.4.3-.4.1-.6.1c-.3 0-.5 0-.6-.1-.2-.1-.3-.2-.4-.3s-.1-.2-.2-.4V54c0-.3.1-.6.2-.8.2-.2.5-.3 1-.3s.8.1 1 .3c.1.1.2.4.2.7m8.7 7.5c0-.5 0-1-.1-1.4s-.2-.7-.299-1c-.201-.3-.401-.5-.701-.6s-.6-.2-1.1-.2c-.4 0-.8.1-1 .2s-.5.3-.6.6c-.2.3-.3.6-.3 1-.1.4-.1.9-.1 1.4s0 1 .1 1.4.201.7.3 1c.1.3.401.5.6.6.2.1.6.2 1 .2.5 0 .801-.1 1.1-.2s.5-.3.701-.6c.199-.3.299-.6.299-1s.1-.8.1-1.4m2.2-.1c0 .6 0 1.2-.099 1.8-.101.6-.301 1.2-.601 1.7s-.7.9-1.3 1.3c-.599.3-1.4.5-2.4.5s-1.8-.2-2.4-.5-1-.7-1.299-1.3c-.301-.5-.5-1.1-.5-1.7-.101-.6-.101-1.2-.101-1.8 0-.5 0-1 .101-1.6a4.4 4.4 0 0 1 .599-1.6c.3-.5.7-.9 1.3-1.3.601-.3 1.3-.5 2.3-.5s1.801.1 2.301.4c.599.3 1 .7 1.299 1.2.3.5.5 1 .6 1.6.101.6.2 1.2.2 1.8m10.401 5c-.101.1-.2.1-.301.1h-1.5c-.3 0-.399-.1-.399-.4v-5.6c0-.6-.101-1.1-.3-1.4-.2-.4-.601-.5-1.2-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.401.2-.5.3V66c0 .3-.1.4-.401.4h-1.399c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.399c.301 0 .401.1.401.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.899-.1.701 0 1.201.1 1.601.3s.699.5.899.8.3.8.401 1.2c.099.5.099.9.099 1.5V66c.201.1.201.2.101.3m6.199-8.2c-.399 0-.699.1-.899.2s-.401.3-.601.5-.3.5-.3.8c-.099.3-.099.6-.099 1h4c0-.3 0-.6-.101-.9-.1-.3-.199-.5-.3-.8-.099-.3-.3-.4-.599-.5-.3-.2-.601-.3-1.101-.3m-2 3.9c0 .5.101.9.2 1.3.101.3.3.6.5.8s.401.3.7.4c.3.1.6.1 1.1.1.4 0 .801 0 1.301-.1s.899-.1 1.3-.1h.399c.101 0 .101.1.2.3l.101.7v.4q0 .15-.301.3c-.199.1-.399.2-.699.2-.301 0-.5.1-.801.2-.3.1-.6.1-.899.1h-.8c-1 0-1.7-.1-2.301-.4-.6-.3-1-.7-1.3-1.1-.3-.5-.5-1-.599-1.6-.101-.6-.201-1.2-.201-1.9 0-.5 0-1 .1-1.6.101-.6.301-1.2.601-1.7.299-.5.7-1 1.299-1.3.6-.4 1.3-.5 2.3-.5.901 0 1.601.1 2.2.4s1 .6 1.3 1 .5.9.601 1.4c.099.5.199 1.1.199 1.6 0 .4 0 .7-.199.9-.2.2-.5.2-.901.2zm16.601 4.3c-.101.1-.2.1-.3.1h-1.5c-.301 0-.4-.1-.4-.4v-5.6c0-.6-.1-1.1-.3-1.4-.2-.4-.601-.5-1.2-.5-.2 0-.401 0-.7.1-.3.1-.5.2-.8.3s-.5.2-.7.3c-.201.1-.4.2-.5.3V66c0 .3-.1.4-.4.4h-1.4c-.3 0-.401-.1-.401-.4v-9.1c0-.3.101-.4.401-.4h1.4c.3 0 .4.1.4.4v.6c.2-.1.4-.3.7-.4s.5-.3.8-.4l.9-.3c.3-.1.6-.1.899-.1.701 0 1.201.1 1.601.3s.7.5.899.8c.201.3.301.8.401 1.2.099.5.099.9.099 1.5V66c.201.1.101.2.101.3m9.199.4h3.3V28h-3.3z"></path></g>', 24), G31 = [
  j31
];
function W31(t, e) {
  return T(), N("svg", U31, [...G31]);
}
const Y31 = { render: W31 }, X31 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, K31 = /* @__PURE__ */ U1('<path fill="#BBBDBF" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#BBBDBF" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#BBBDBF" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#BBBDBF" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#BBBDBF" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#BBBDBF" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" d="M27.5 66.3h57.9V27.6H27.5z" clip-rule="evenodd"></path><path fill="#FFF100" fill-rule="evenodd" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" clip-rule="evenodd"></path><path fill="#fff" d="M151.68 34.34q0 .36-.4.36h-3.18v10.92q0 .16-.08.28-.06.1-.28.1h-1.5q-.38 0-.38-.38V34.7h-3.16q-.24 0-.32-.08a.44.44 0 0 1-.08-.28V33.1a.44.44 0 0 1 .08-.28q.08-.1.3-.1h8.62q.38 0 .38.38zm9.236 11.28q0 .38-.38.38h-1.42q-.22 0-.3-.1a.43.43 0 0 1-.08-.28V45l-.04-.02q-.3.2-.7.42-.38.2-.82.38t-.92.28q-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V36.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1.399-.1.78-.24.38-.16.7-.3l.52-.26V36.6q0-.18.08-.28.08-.12.3-.12h1.42q.38 0 .38.4zm16.465 0a.44.44 0 0 1-.08.28q-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1-.34.1-.7.24-.34.12-.66.28l-.56.28v.42a8 8 0 0 1 .02.6v5.66a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44q-.261 0-.6.08-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V36.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4.339-.22.72-.38.4-.16.8-.26a3.4 3.4 0 0 1 .82-.14q.86 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.98 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.224-3.92q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16a1.5 1.5 0 0 0-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m15.621 5.4q.22-.62.4-1.16.2-.54.34-.94.16-.48.3-.88l1.24-3.68a.54.54 0 0 1 .16-.26q.1-.08.32-.08h1.48q.24 0 .26.12t-.04.28l-4.66 12.72a.7.7 0 0 1-.18.28q-.1.08-.36.08h-1.36q-.24 0-.28-.12a.55.55 0 0 1 .04-.28l1.26-3.38-3.5-9.3q-.06-.16-.04-.28.04-.12.26-.12h1.54q.2 0 .28.04t.16.26l1.3 3.72 1 2.98zm11.984-1.66h-2.44q-.759 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.3 5.3 0 0 0-1.02-.08q-.24 0-.6.02-.339.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.081-.14.42-.28.32-.12.76-.2.441-.08.9-.12.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.699 0-1.14-.26-.42-.26-.58-.96zm-63.05 19.3q1.32 0 2-.72.7-.74.7-2.3v-8.02q0-.4.4-.4h1.5q.22 0 .28.12a.44.44 0 0 1 .08.28l-.02 8.02q0 .6-.08 1.2-.06.58-.28 1.16-.3.72-.78 1.22-.46.5-1.06.82t-1.3.46a6.5 6.5 0 0 1-1.44.16q-3.16 0-4.32-2.22a4.7 4.7 0 0 1-.46-1.3q-.14-.72-.14-1.5v-8.02q0-.4.38-.4h1.5q.38 0 .38.4v8.02q0 1.48.66 2.26.68.76 2 .76m9.779-.64q0 .46.2.58.22.1.74.1.22.02.28.06.08.04.12.2l.08 1.02q.02.24-.26.38a1.9 1.9 0 0 1-.66.18q-.38.06-.64.06-1.14 0-1.6-.5-.44-.52-.44-1.54V52.28q0-.38.38-.38h1.42q.38 0 .38.38zm8.933-1.98h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08a5.5 5.5 0 0 0 .76-.22q.38-.14.74-.3.36-.18.64-.34zm.12 3.32a6.7 6.7 0 0 1-1.72.94q-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.459-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.219.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96zm8.52-1.66q.22-.62.4-1.16.2-.54.34-.94.16-.48.3-.88l1.24-3.68a.55.55 0 0 1 .16-.26q.1-.08.32-.08h1.48q.24 0 .26.12t-.04.28l-4.66 12.72a.7.7 0 0 1-.18.28q-.099.08-.36.08h-1.36q-.24 0-.28-.12a.55.55 0 0 1 .04-.28l1.26-3.38-3.5-9.3q-.06-.16-.04-.28.04-.12.26-.12h1.54q.2 0 .28.04t.16.26l1.3 3.72 1 2.98zm11.985-1.66h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08a5.5 5.5 0 0 0 .76-.22q.38-.14.74-.3.36-.18.64-.34zm.12 3.32a6.7 6.7 0 0 1-1.72.94q-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.459-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.219.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96z"></path><path fill="#fff" fill-rule="evenodd" d="M223 66.7h3.3V28H223z" clip-rule="evenodd"></path><path fill="#fff" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z"></path><path fill="#fff" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1"></path><path fill="#fff" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3"></path><path fill="#fff" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1"></path><path fill="#fff" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6"></path><path fill="#fff" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1"></path><path fill="#fff" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5"></path><path fill="#fff" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7"></path><path fill="#fff" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2m-.2 4.2c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.899 18.9 14.099 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.799 11.3 13.999 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13v-3.4z"></path><path fill="#fff" d="M94.2 26.8s10.299 9.6 13.999 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z"></path><path fill="#fff" d="M94.2 32.2s11.799 9.3 13.999 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z"></path><path fill="#fff" d="M94.2 37.4s11.799 7.9 13.999 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z"></path><path fill="#fff" d="M94.2 42.7s10.399 5.7 13.999 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z"></path><path fill="#fff" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8V48zm0 5.4s8.299 2.6 13.999 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.799 1.2 13.999 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.699.4 13.999.5 26.2 1 26.2 1v.6h-40.2zm27.501-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6"></path><path fill="#fff" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4"></path><path fill="#fff" d="M121.699 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3"></path><path fill="#004494" stroke="#fff" stroke-width="2" d="M85.4 27.6H27.5v38.7h57.9z"></path><path fill="#FFEC00" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path>', 44), Z31 = [
  K31
];
function J31(t, e) {
  return T(), N("svg", X31, [...Z31]);
}
const Q31 = { render: J31 }, ee1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, te1 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path></g><path fill="#fff" fill-rule="evenodd" d="M245.4 66.7h3.3V28h-3.3z" clip-rule="evenodd"></path><path fill="#fff" d="M144.58 45.58q-.08.24-.2.34a.6.6 0 0 1-.34.08h-1.56q-.36 0-.22-.4l4.04-12.44a.9.9 0 0 1 .18-.32q.1-.1.38-.1h1.74q.28 0 .38.12.1.1.16.3l4.12 12.48q.1.36-.2.36h-1.76q-.24 0-.34-.1a1.2 1.2 0 0 1-.16-.32l-.84-2.88h-4.48zm4-7.6-.82-2.88h-.08l-.8 2.84-.84 2.88h3.38zm10.062 5.56q0-.06.12-.42l.26-.82q.16-.52.38-1.14l1.6-4.64a.7.7 0 0 1 .14-.24q.1-.08.32-.08h1.52q.4 0 .24.38l-3.4 9a.73.73 0 0 1-.2.32q-.12.1-.36.1h-1.34q-.28 0-.38-.08a.9.9 0 0 1-.18-.32l-3.4-9a.4.4 0 0 1-.02-.28q.04-.12.24-.12h1.58q.22 0 .3.08.1.06.18.28l1.6 4.68q.18.58.34 1.08.14.42.24.8.12.36.16.42zm8.561 2.08q0 .38-.38.38h-1.44q-.38 0-.38-.38V36.6q0-.4.38-.4h1.42q.4 0 .4.4v.88l.04.04q.22-.2.58-.42.36-.24.76-.42.42-.2.84-.36t.78-.22a.5.5 0 0 1 .32.02q.12.06.16.32l.14 1.34a.8.8 0 0 1-.02.32q-.04.1-.36.16-.42.08-.88.2a10 10 0 0 0-.9.24q-.44.12-.82.24t-.64.24zm13.205 0q0 .38-.38.38h-1.42q-.22 0-.3-.1a.43.43 0 0 1-.08-.28V45l-.04-.02q-.3.2-.7.42-.38.2-.82.38t-.92.28q-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V36.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1.399-.1.78-.24.38-.16.7-.3l.52-.26V36.6q0-.18.08-.28.08-.12.3-.12h1.42q.38 0 .38.4zm10.785-4.58q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12a.44.44 0 0 1 .08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.98 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9t-.5-.42a1.7 1.7 0 0 0-.68-.12 2.7 2.7 0 0 0-.68.1 8 8 0 0 0-.76.24q-.36.12-.7.28-.321.16-.54.28v5q.68.2 1.22.28.56.06 1.08.06.54 0 .9-.14a1.24 1.24 0 0 0 .6-.54q.24-.38.34-1 .1-.64.1-1.58m10.109.52h-2.44q-.759 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32a6.7 6.7 0 0 1-1.72.94q-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.339.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.081-.14.42-.28.32-.12.76-.2.441-.08.9-.12.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.699 0-1.14-.26-.42-.26-.58-.96zM145.62 59.12l1.52-1.96 3.36-4.14a.8.8 0 0 1 .28-.22.8.8 0 0 1 .38-.08h1.82q.22 0 .26.12.06.12-.08.28l-4.34 5.28 4.48 7.18q.12.2.04.32-.08.1-.24.1h-1.84q-.26 0-.4-.1-.12-.1-.24-.28l-3.28-5.44-1.76 2.18v3.26q0 .16-.08.28-.06.1-.28.1h-1.5q-.4 0-.4-.38v-12.5q0-.4.4-.4h1.5q.22 0 .28.12a.44.44 0 0 1 .08.28v6zm17.562 1.82q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1a10 10 0 0 0-.08 1.36q0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m18.528 4.54q0 .18-.08.28-.06.1-.28.1h-1.44q-.38 0-.38-.38v-5.68q0-1.12-.3-1.5-.3-.4-1.06-.4-.28 0-.64.1a9 9 0 0 0-.7.24 6 6 0 0 0-.66.28l-.56.28v.42q.02.26.02.6v5.66q0 .18-.08.28t-.3.1h-1.46q-.34 0-.34-.38v-5.78q0-.92-.28-1.36t-1.04-.44a2.7 2.7 0 0 0-.6.08q-.32.08-.68.22-.34.14-.68.3t-.62.3v6.68q0 .38-.38.38h-1.44q-.36 0-.36-.38V56.6q0-.4.36-.4h1.42q.4 0 .4.4v.58l.02.02q.3-.2.64-.4a4.7 4.7 0 0 1 .72-.38q.4-.16.8-.26.4-.12.82-.14.861 0 1.56.28.72.26 1.18 1.12.76-.56 1.66-.98t1.86-.42q.981 0 1.56.3t.88.82q.3.5.38 1.18t.08 1.42zm4.745-12.02q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm9.801-2.56q0 .88-.34 1.48a2.7 2.7 0 0 1-.92.94q-.56.36-1.28.52a7 7 0 0 1-1.5.16q-.76 0-1.64-.12-.88-.1-1.46-.32-.3-.12-.38-.26a.65.65 0 0 1-.04-.4l.14-.66q.04-.24.16-.28.12-.06.36-.02.32.06.7.1.4.04.78.08.4.02.74.04.36.02.62.02.96 0 1.38-.26.42-.28.42-.88 0-.34-.08-.56a.67.67 0 0 0-.24-.36 1.3 1.3 0 0 0-.5-.22q-.3-.1-.78-.16-.74-.1-1.4-.26a4.5 4.5 0 0 1-1.18-.46 2.5 2.5 0 0 1-.8-.82q-.3-.52-.3-1.34 0-1.48 1.04-2.24 1.04-.78 2.72-.78.3 0 .7.02t.8.08q.42.06.82.14t.72.2q.5.2.42.6l-.16.72q-.04.22-.16.28-.1.04-.38 0-.64-.08-1.4-.14-.76-.08-1.32-.08-.96 0-1.28.28-.3.26-.3.84t.38.76q.4.18 1.32.32.72.1 1.36.26.66.16 1.16.48t.8.86.3 1.44m5.76.14q.22-.62.4-1.16.2-.54.34-.94.16-.48.3-.88l1.24-3.68a.54.54 0 0 1 .16-.26q.1-.08.32-.08h1.48q.24 0 .26.12t-.04.28l-4.66 12.72a.7.7 0 0 1-.18.28q-.1.08-.36.08h-1.36q-.24 0-.28-.12a.55.55 0 0 1 .04-.28l1.26-3.38-3.5-9.3q-.06-.16-.04-.28.04-.12.26-.12h1.54q.2 0 .28.04t.16.26l1.3 3.72 1 2.98zm14.424-2.26q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.44.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.46.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.669 4.54a.44.44 0 0 1-.08.28q-.081.1-.3.1h-1.44q-.38 0-.38-.38l.02-5.62q0-.88-.3-1.42-.28-.54-1.14-.54-.3 0-.7.1a7 7 0 0 0-.78.26 9 9 0 0 0-.72.3 8 8 0 0 0-.54.24v6.68q0 .38-.38.38h-1.42q-.38 0-.38-.38V56.6q0-.4.38-.4h1.42q.38 0 .38.4v.6q.02 0 .02.02h.04q.279-.2.66-.4.399-.22.84-.4t.92-.28q.48-.12.94-.12 1.02 0 1.6.32.58.3.88.82t.38 1.22q.08.68.08 1.44zm10.586 0q0 .38-.38.38h-1.42q-.219 0-.3-.1a.44.44 0 0 1-.08-.28V65l-.04-.02q-.3.2-.7.42a9 9 0 0 1-.82.38q-.44.18-.92.28-.46.12-.92.12-1.02 0-1.62-.28a2 2 0 0 1-.88-.78 2.9 2.9 0 0 1-.38-1.18q-.08-.68-.08-1.46V56.6q0-.4.38-.4h1.46q.36 0 .36.4v5.62q0 .46.06.82t.22.62q.16.24.44.38t.74.14q.32 0 .7-.1a8 8 0 0 0 .78-.24q.38-.16.7-.3l.52-.26V56.6a.44.44 0 0 1 .08-.28q.081-.12.3-.12h1.42q.38 0 .38.4z"></path><path fill="#fff" fill-rule="evenodd" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z" clip-rule="evenodd"></path>', 27), ne1 = [
  te1
];
function ie1(t, e) {
  return T(), N("svg", ee1, [...ne1]);
}
const se1 = { render: ie1 }, le1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, re1 = /* @__PURE__ */ U1('<path fill="#fff" fill-rule="evenodd" d="M0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="23" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.6 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.1c-10.9-.2-21.8-.4-32.9-.6v2.6c10.6-.1 21.8-.2 32.9-.3l8.6-.1c2.9 0 5.7-.1 8.6-.2 5.9-.2 11.1-.6 16.1-1.3V60c-4.9.5-10.2.8-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.9 18.9 14.1 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.8 11.3 14 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.3 9.6 14 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.8 9.3 14 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.8 7.9 14 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.4 5.7 14 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm0 5.4s8.3 2.6 14 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.8 1.2 14 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.7.4 14 .5 26.2 1 26.2 1v.6H94.2zm27.5-30.9c-9.7-2.1-11.9-5.6-13.5-7.8S94.3 5.4 94.3 5.4v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.7 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><mask id="f" width="277" height="67" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 66.7h276.7V0H0z" clip-rule="evenodd"></path></mask><g fill-rule="evenodd" clip-rule="evenodd" mask="url(#f)"><path fill="#004494" d="M27.5 66.3h57.9V27.6H27.5z"></path><path fill="#FFF100" d="M57.1 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm6.4-1.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0-22.4h2L63.9 36l.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.8 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm1.8-6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.9-1.5-1.1-1.7 1.2.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.7 4.7h2L51 58.5l.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z"></path><path fill="#fff" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z"></path></g><path fill="#fff" d="M143.2 39.28q0-1.26.2-2.46.22-1.22.82-2.16t1.64-1.5q1.06-.58 2.74-.58.36 0 .84.04.5.02 1 .1.5.06.98.18.5.1.86.26.24.1.32.24t.02.4l-.16.78q-.06.4-.52.32a34 34 0 0 0-1.6-.18 18 18 0 0 0-1.66-.08q-.84 0-1.4.28-.54.28-.88.78-.34.48-.52 1.14a8.5 8.5 0 0 0-.22 1.38h4.7q.38 0 .38.36v1.18q0 .36-.38.36h-4.72q.04.86.18 1.6.14.72.48 1.26t.92.84 1.5.3q.86 0 1.66-.08t1.58-.18q.24-.04.34.04.12.08.18.26l.16.78q.1.44-.36.66-.4.16-.88.28-.48.1-.98.16-.5.08-.98.1-.48.04-.84.04-1.72 0-2.78-.58a4.55 4.55 0 0 1-1.64-1.58 6.3 6.3 0 0 1-.78-2.2q-.2-1.24-.2-2.54M154.594 46q-.3 0-.4-.1a.5.5 0 0 1-.1-.32v-9q0-.22.08-.3.1-.08.36-.08h4.26q1.74 0 2.54.72t.8 1.94q0 .4-.22.98t-.94.98q.441.18.72.48.28.28.44.6.16.3.22.62t.06.58q0 .66-.28 1.2-.26.54-.72.92a3.2 3.2 0 0 1-1.08.58q-.62.2-1.3.2zm5.6-3.02q0-.5-.32-.88-.3-.4-1.06-.4h-2.56v2.5h2.34q.48 0 .78-.12.32-.12.5-.3t.24-.4q.08-.22.08-.4m-.28-3.96a.9.9 0 0 0-.08-.38.73.73 0 0 0-.22-.32 1 1 0 0 0-.44-.24 1.9 1.9 0 0 0-.66-.1h-2.26v2.16h2.4q.58 0 .92-.32.34-.34.34-.8m13.017 2.02q0 1.22-.18 2.18t-.64 1.62q-.44.66-1.22 1-.76.34-1.94.34a7.9 7.9 0 0 1-2.5-.44l-.02.02v3.52q0 .16-.08.28-.06.12-.3.12h-1.42q-.24 0-.32-.1a.6.6 0 0 1-.06-.3V36.6q0-.4.38-.4h1.42q.22 0 .28.12a.44.44 0 0 1 .08.28v.6l.06.04q.26-.18.62-.38.38-.22.8-.4t.86-.3.88-.12q.98 0 1.62.36t1 1.02q.38.64.52 1.56.16.92.16 2.06m-2.26-.02q0-.96-.1-1.54-.08-.58-.28-.9a.94.94 0 0 0-.5-.42 1.7 1.7 0 0 0-.68-.12q-.3 0-.68.1a8 8 0 0 0-.76.24q-.36.12-.7.28-.32.16-.54.28v5q.68.2 1.22.28.56.06 1.08.06.54 0 .9-.14a1.24 1.24 0 0 0 .6-.54q.24-.38.34-1 .1-.64.1-1.58m12.55-.08q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58.16.88.16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1-.08.58-.08 1.36 0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.728 4.54q0 .38-.4.38h-1.42q-.38 0-.38-.38l.02-7.58h-4.2v7.58q0 .16-.08.28-.08.1-.3.1h-1.42q-.38 0-.38-.38v-9.04q0-.38.38-.38h7.8q.22 0 .3.08t.08.3zm4.185-3.92q.02.76.16 1.26.16.5.46.8.3.28.74.4t1.06.12q.54 0 1.28-.08t1.32-.14q.28-.04.38.02.12.04.16.32l.12.66a.63.63 0 0 1-.02.36q-.04.14-.32.26-.3.12-.7.22-.4.08-.84.14t-.88.1-.8.04q-1.44 0-2.3-.42t-1.32-1.12-.62-1.6a13 13 0 0 1-.14-1.9q0-.72.12-1.62t.54-1.68q.44-.78 1.28-1.3.86-.54 2.32-.54 1.34 0 2.16.4.84.4 1.3 1.04.46.62.62 1.44.18.8.2 1.6.02.54-.18.88t-.8.34zm2-3.9q-.56 0-.92.16t-.6.48q-.22.3-.32.76a7 7 0 0 0-.14 1h3.96q0-.46-.08-.88a2.1 2.1 0 0 0-.3-.78 1.4 1.4 0 0 0-.6-.54q-.38-.2-1-.2m6.056-1.16q0-.22.08-.32.1-.12.34-.12h1.3q.28 0 .36.12t.08.32v5.84h.04l2.62-3.56 1.78-2.36q.12-.16.24-.26.14-.1.44-.1h1.04q.24 0 .34.14.1.12.1.28v8.96q0 .42-.46.42h-1.26q-.46 0-.46-.42v-6.12h-.02q-.7.96-1.4 1.9t-1.4 1.9l-.88 1.2q-.44.58-.9 1.18-.12.16-.28.26-.14.1-.42.1h-.86q-.24 0-.34-.1-.08-.1-.08-.32zm4.4-1.36a4.05 4.05 0 0 1-1.92-.5q-.92-.52-1.4-1.58-.08-.16-.14-.34t.1-.32l.54-.44q.18-.12.28-.06a.8.8 0 0 1 .24.18q.6.72 1.08 1.06.5.34 1.24.34.34 0 .6-.08.28-.08.52-.26.26-.18.52-.44t.58-.62q.24-.28.5-.1l.54.34q.2.12.12.32a3 3 0 0 1-.14.38q-.54 1.06-1.4 1.6a3.53 3.53 0 0 1-1.86.52m13.92 9.8q.06.22 0 .36t-.34.26q-.58.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1t.66.54q.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm1.885.92q-.28 0-.34-.1t-.06-.32v-9.02q0-.22.1-.28.12-.08.38-.08h1.28q.24 0 .32.08.1.08.1.28v3.26h2.42q1.04 0 1.72.28.699.28 1.08.72.4.44.56 1t.16 1.12q0 .76-.3 1.34a2.9 2.9 0 0 1-.78.96q-.48.38-1.16.58-.66.18-1.44.18zm5.62-3.12q0-.58-.34-.92-.34-.36-1.2-.36h-2.3v2.56h2.2q.74 0 1.18-.32.46-.32.46-.96m5.886 2.78a.5.5 0 0 1-.06.26q-.06.08-.28.08h-1.5q-.34 0-.34-.34v-9.1q0-.36.34-.36h1.5q.22 0 .28.1a.5.5 0 0 1 .06.26v3.52h1.02q.28 0 .52-.04.26-.04.46-.18.22-.16.4-.44.2-.28.38-.74l.8-2.16q.08-.18.2-.24t.36-.06h1.22q.28 0 .32.12.06.12 0 .32l-.7 2.08q-.32.94-.68 1.48t-.9.7v.02q.7.24 1.04.7.34.44.62 1.24l.88 2.68q.06.18.02.32-.04.12-.34.12h-1.34a.9.9 0 0 1-.36-.06q-.12-.06-.18-.24l-.78-2.3q-.32-.92-.84-1.2a2.25 2.25 0 0 0-1.08-.28h-1.04zm13.647-4.12h-2.44q-.76 0-1.2.36-.44.34-.44 1.32 0 .66.26.92.28.24.98.24.32 0 .7-.08t.76-.22.74-.3q.36-.18.64-.34zm.12 3.32q-.76.58-1.72.94-.94.36-1.96.36-.8 0-1.34-.2a2.3 2.3 0 0 1-.84-.58 2.5 2.5 0 0 1-.44-.9 5.2 5.2 0 0 1-.12-1.16q-.02-1.76.92-2.54.94-.8 2.84-.8h2.56v-.52q0-.44-.1-.74a.96.96 0 0 0-.32-.52 1.4 1.4 0 0 0-.64-.28 5.4 5.4 0 0 0-1.02-.08q-.24 0-.6.02-.34.02-.72.04-.36.02-.74.06-.36.04-.66.06-.3.04-.42.02-.1-.04-.14-.26l-.18-.74q-.04-.2.04-.32.08-.14.42-.28.32-.12.76-.2t.9-.12q.46-.06.9-.08.46-.04.82-.04 1.3 0 2.06.26.78.26 1.18.74.4.46.52 1.14t.12 1.52v3.86q0 .3.02.48.04.16.1.26a.5.5 0 0 0 .22.12q.14.04.38.06.22.02.3.08t.08.22v.84q0 .34-.48.42-.24.04-.48.06-.24.04-.46.04-.7 0-1.14-.26-.42-.26-.58-.96zM145.22 65.66a.5.5 0 0 1-.06.26q-.06.08-.28.08h-1.5q-.34 0-.34-.34v-9.1q0-.36.34-.36h1.5q.22 0 .28.1a.5.5 0 0 1 .06.26v3.52h1.02q.28 0 .52-.04.26-.04.46-.18.22-.16.4-.44.2-.28.38-.74l.8-2.16a.46.46 0 0 1 .2-.24q.12-.06.36-.06h1.22q.28 0 .32.12.06.12 0 .32l-.7 2.08q-.32.94-.68 1.48t-.9.7v.02q.7.24 1.04.7.34.44.62 1.24l.88 2.68q.06.18.02.32-.04.12-.34.12h-1.34a.9.9 0 0 1-.36-.06q-.12-.06-.18-.24l-.78-2.3q-.32-.92-.84-1.2a2.25 2.25 0 0 0-1.08-.28h-1.04zm16.087-4.72q0 .86-.12 1.78a4.4 4.4 0 0 1-.54 1.7q-.441.76-1.32 1.26-.88.48-2.44.48-1.5 0-2.36-.48-.86-.5-1.3-1.26a4.6 4.6 0 0 1-.52-1.7q-.1-.92-.1-1.78 0-.7.12-1.56a4.5 4.5 0 0 1 .58-1.6q.44-.76 1.28-1.26.86-.52 2.3-.52 1.46 0 2.32.44.88.44 1.34 1.16.459.7.6 1.58a10 10 0 0 1 .16 1.76m-2.24.14q0-.8-.08-1.38-.08-.6-.32-.98a1.5 1.5 0 0 0-.66-.6q-.42-.2-1.1-.2-.64 0-1.04.2t-.64.6q-.22.4-.32 1a10 10 0 0 0-.08 1.36q0 .8.08 1.4.1.58.32.98.22.38.62.58t1.04.2q.68 0 1.1-.18.44-.2.68-.58.24-.4.32-1t.08-1.4m12.288-.72-.88 1.68q-.279.54-.54 1.06-.26.5-.6 1.1-.18.34-.58.34h-.68q-.28 0-.4-.08a.6.6 0 0 1-.2-.24 26 26 0 0 0-.54-.96q-.26-.44-.5-.92-.26-.46-.52-1a17 17 0 0 0-.52-1h-.04v5.26q0 .4-.46.4h-1.24q-.42 0-.42-.4v-8.98q0-.4.4-.4h1.16q.3 0 .42.08.141.08.24.26.32.58.62 1.16.32.58.62 1.16.46.84.86 1.66.42.8.88 1.64l1.56-2.96 1.42-2.64a.66.66 0 0 1 .24-.26q.16-.1.44-.1h1.04q.4 0 .4.38v9q0 .4-.42.4h-1.26q-.44 0-.44-.4v-5.24zm6.903-6.76q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm9.921-.54q.06.22 0 .36t-.34.26q-.58.24-1.44.34-.86.12-1.6.12-1.4 0-2.26-.42-.84-.42-1.3-1.12a4.2 4.2 0 0 1-.58-1.62q-.14-.94-.14-1.96 0-.92.14-1.82a4.5 4.5 0 0 1 .6-1.62q.46-.72 1.3-1.16.86-.44 2.24-.44.34 0 .74.02a8 8 0 0 1 1.62.24q.4.08.72.22.36.16.3.56l-.14.8q-.06.22-.2.26a1.3 1.3 0 0 1-.42.02q-.62-.06-1.28-.12-.64-.06-1.16-.06-1.22 0-1.7.7t-.48 2.36q0 .94.1 1.56.12.62.38 1t.66.54q.42.14 1.02.14.46 0 1.2-.04.76-.06 1.38-.14.24-.04.36 0t.16.3zm4.105-11.48q0 .24-.04.46a.8.8 0 0 1-.18.36.84.84 0 0 1-.36.26q-.22.08-.6.08-.4 0-.64-.1a.86.86 0 0 1-.34-.26.9.9 0 0 1-.16-.36 2.4 2.4 0 0 1-.04-.44q0-.48.22-.8.24-.34.96-.34.74 0 .96.32.22.3.22.82m-.12 12.02q0 .16-.08.28-.06.1-.28.1h-1.42q-.4 0-.4-.38v-9.04q0-.38.4-.38h1.42q.22 0 .28.12.08.1.08.26zm10.121-9.44q.28 0 .38.1.1.08.1.3v9q0 .4-.48.4h-1.26q-.26 0-.36-.1-.08-.1-.08-.3v-3.4h-2.02a1.52 1.52 0 0 0-.88.34q-.34.28-.62 1.12l-.64 1.94q-.08.24-.2.34-.12.08-.4.08h-1.32q-.28 0-.34-.1-.04-.12.02-.34l.7-2.14q.22-.6.46-1.04.24-.46.68-.7a2.1 2.1 0 0 1-.72-.42 2.3 2.3 0 0 1-.44-.6 2.7 2.7 0 0 1-.22-.7q-.06-.36-.06-.7 0-.76.28-1.32.28-.58.76-.96a3.2 3.2 0 0 1 1.12-.6q.66-.2 1.38-.2zm-5.54 3.08q0 .58.34.9.36.32 1.2.32h2.3v-2.5h-2.2q-.72 0-1.18.32t-.46.96"></path><path fill="#fff" fill-rule="evenodd" d="M263 66.7h3.3V28H263z" clip-rule="evenodd"></path>', 26), ae1 = [
  re1
];
function oe1(t, e) {
  return T(), N("svg", le1, [...ae1]);
}
const ce1 = { render: oe1 }, he1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "72",
  fill: "none",
  viewBox: "0 0 290 72"
}, ue1 = /* @__PURE__ */ U1('<path fill="#fff" d="M158.018 42.76h2.752c-.215 1.419-.559 2.924-.903 3.956l1.183.623c.602-1.462 1.139-3.762 1.462-5.74l-1.054-.409-.279.086h-5.698c.258-1.16.473-2.365.667-3.59l-1.613-.237c-.43 3.419-1.225 6.773-2.623 8.901.387.215 1.054.731 1.333 1.01.753-1.246 1.354-2.837 1.849-4.6h1.376v3.031c.021 1.462-.494 5.44-3.354 8.342v-1.182h-7.568V40.33h7.374v-1.484H144v17.2h1.548v-1.613h7.267q-.774.71-1.741 1.29c.279.301.752.946.924 1.29 3.677-2.257 4.988-6.192 5.246-7.998.236 1.742 1.441 5.848 4.623 7.977.215-.366.709-1.01.989-1.355-4.15-2.687-4.859-8.148-4.838-9.847zm-7.761-1.785a32 32 0 0 1-1.161 4.3 43 43 0 0 0-2.43-2.408l-.946.99a41 41 0 0 1 2.817 2.923c-.753 1.763-1.677 3.311-2.774 4.515.323.237.946.731 1.204.99 1.011-1.183 1.871-2.624 2.602-4.258.86 1.054 1.569 2.086 2.021 2.924l1.053-1.16c-.538-.947-1.419-2.108-2.429-3.29a38 38 0 0 0 1.505-5.268zm31.024-1.548v1.892h-5.052v-1.892zm-5.16 5.031c.086-.645.108-1.29.108-1.87v-.065h5.052v1.935zm5.16 1.183v1.827c0 .258-.086.344-.387.366-.301 0-1.333.021-2.451-.022.215.387.495.946.602 1.376 1.441 0 2.43-.021 3.032-.258.58-.236.774-.645.774-1.462v-9.33h-8.084v4.428c0 1.914-.28 4.193-2.43 5.848.323.194.903.731 1.118 1.054 1.355-1.054 2.064-2.43 2.43-3.827zm-10.04-5.891v2.3h-3.892v-2.3zm-3.892 5.826v-2.279h3.892v2.28zm0 1.29h5.354v-8.428h-6.816v9.59h1.462zm1.312 4.279h2.838v3.913h-2.838zm7.159 0v3.913h-2.838v-3.913zm4.386 0v3.913h-2.902v-3.913zm1.548 3.913v-5.225h-14.598v5.225h-2.494v1.419h19.479v-1.42zm18.254-4.58c-.753 1.226-1.763 2.193-3.053 2.924a169 169 0 0 0-4.967-1.118c.473-.516.968-1.16 1.462-1.806zm1.225-2.924a10.6 10.6 0 0 1-.537 1.527h-6.235a47 47 0 0 0 .989-1.591h1.225v-4.257h8.686v-1.376h-8.686v-2.28c2.451-.214 4.73-.537 6.536-.945l-1.183-1.14c-3.16.731-9.158 1.161-14.06 1.29.15.344.322.903.344 1.269 2.15-.065 4.514-.172 6.793-.344v2.15h-8.621v1.376h6.751c-1.892 1.59-4.687 2.988-7.202 3.676.301.301.752.882.988 1.247 2.86-.903 6.085-2.73 8.084-4.859v3.827l-1.139-.3a20 20 0 0 1-1.397 2.257h-6.321v1.397h5.288a25 25 0 0 1-2.214 2.58c1.957.387 3.827.817 5.59 1.247-2.064.731-4.665 1.118-7.976 1.312.258.387.494.967.623 1.44 4.171-.3 7.353-.924 9.74-2.128 2.644.688 4.945 1.419 6.643 2.085l1.462-1.16c-1.72-.624-3.977-1.29-6.45-1.936a9.36 9.36 0 0 0 2.881-3.44h3.784v-1.397h-3.182c.108-.366.237-.731.344-1.118zm-3.891-3.268c2.644 1.075 6.127 2.688 7.869 3.698l.774-1.16c-1.828-1.033-5.311-2.538-7.869-3.548zm15.071-4.515h10.04v2.43h-10.04zm-1.677-1.419v5.268h13.48v-5.268zm5.719 10.062v1.978c0 1.72-.623 4.02-8.385 5.526.387.344.86.989 1.053 1.333 8.063-1.785 9.052-4.558 9.052-6.816v-2.02zm1.591 5.655c2.623.881 6.149 2.279 7.933 3.182l.818-1.355c-1.871-.903-5.397-2.193-7.956-3.01zm-8.063-8.514v7.912h1.656V47.06h11.696v6.256h1.72v-7.761zm20.189 4.192h6.106c-1.398 1.914-3.01 3.612-3.612 4.107-.645.623-1.14 1.032-1.591 1.118.172.473.43 1.311.538 1.655.795-.3 1.999-.387 13.33-1.333.473.645.902 1.269 1.203 1.785l1.419-.882c-.946-1.612-2.967-3.891-4.88-5.611l-1.354.73a32 32 0 0 1 2.494 2.58l-9.762.732c1.548-1.398 3.054-3.118 4.387-4.88h9.374v-1.549h-17.652zm8.836-12.276c-1.913 2.88-5.676 5.568-9.847 7.331.366.323.925.968 1.162 1.376a28 28 0 0 0 3.547-1.913v1.311h10.213v-1.483h-9.934c1.849-1.183 3.505-2.559 4.838-4.02 2.021 2.085 5.375 4.536 8.708 5.89.258-.451.752-1.096 1.117-1.419-3.461-1.182-6.944-3.547-8.901-5.547.194-.28.409-.58.624-.86z"></path><path fill="#fff" fill-rule="evenodd" d="M255.812 66.7h3.3V28h-3.3zM0 24.5s39.8-5.2 41-5.4c1.7-.3 3.3-.6 4.7-1 3.2-.9 6.2-2.2 8.8-4 2.5-1.7 4.9-4.2 7.2-6.9 1.5-1.7 3-4 4.5-6.2V0c-1.7 2.6-3.4 4.8-5.1 6.7q-3.45 3.9-7.2 6.3c-2.5 1.6-5.4 2.9-8.5 3.7-1.4.4-2.9.6-4.6.9-1.1.2-2.2.3-3.3.4C37 18 0 21.9 0 21.9z" clip-rule="evenodd"></path><mask id="a" width="67" height="24" x="0" y="5" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 5.2h66.1V28H0z" clip-rule="evenodd"></path></mask><g mask="url(#a)"><path fill="#fff" fill-rule="evenodd" d="M53.4 17.8c-2.5 1.4-5.4 2.5-8.6 3.1-1.4.3-2.8.5-4.5.7l-3 .3c-.5 0-1.1.1-1.6.1-12.2 1.2-24.3 2.3-35.7 3.4V28c11.4-1.4 23.7-2.9 35.9-4.3.5-.1 1.1-.1 1.6-.2 1-.1 2-.2 3-.4 1.7-.2 3.3-.5 4.6-.8 3.3-.7 6.3-1.9 8.9-3.5s4.8-3.7 7.3-6.4c1.5-1.7 3.2-4 4.8-6.2v-1c-1.9 2.5-3.6 4.7-5.4 6.5-2.4 2.7-4.8 4.7-7.3 6.1" clip-rule="evenodd"></path></g><mask id="b" width="67" height="22" x="0" y="10" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 10.9h66.1v20.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M60.4 17.2c-2.4 2.2-5 4-7.5 5.3-2.5 1.2-5.3 2.1-8.6 2.6-1.4.2-2.8.4-4.5.6L0 28.9v2.6l35.3-3.8 4.6-.5c1.7-.2 3.2-.4 4.6-.7 3.4-.6 6.3-1.6 8.9-2.9 2.7-1.4 5.3-3.6 7.8-6 1.7-1.6 3.2-3.7 4.9-5.8v-.9c-2 2.5-3.8 4.5-5.7 6.3" clip-rule="evenodd"></path></g><mask id="c" width="67" height="18" x="0" y="21" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 21.7h66.2v16.8H0z" clip-rule="evenodd"></path></mask><g mask="url(#c)"><path fill="#fff" fill-rule="evenodd" d="M50.8 30.6c-2.3 1.3-4 2.1-7.3 2.4-2 .2-4 .3-6 .4-1 0-1.9.1-2.9.2-6 .3-11.9.7-17.9 1.1L0 35.9v2.6l16.8-1.6c5.4-.5 11.7-1.1 17.9-1.6l4.5-.3c1.7-.1 3.2-.3 4.5-.5 3.4-.4 6.3-1.1 8.9-2.1 2.8-1 5.4-2.7 8-4.6 2.4-1.7 5.6-5.1 5.6-5.2v-.9c-2.1 2.1-3.4 3.3-5.7 4.8-2.9 2-7.6 3-9.7 4.1" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M51.602 35.6c-2.5.7-5.3 1.2-8.6 1.5-1.3.1-2.8.2-4.4.3l-4.4.2c-11 .5-22 1.1-34.1 1.7v2.6c11.6-.9 22.9-1.8 34.3-2.6l4.4-.3c1.7-.1 3.1-.2 4.5-.4 3.4-.4 6.3-1 8.8-1.8 2.8-.9 5.6-2.2 8.2-3.9 1.9-1.2 3.9-2.7 5.9-4.5-2.2 1.9-4.3 2.3-6.4 3.6-2.7 1.6-5.4 2.8-8.2 3.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M51.2 39.9c-2.5.6-5.3 1-8.6 1.2-1.3.1-2.7.2-4.4.2l-4.4.2c-11.1.4-22.3.9-33.8 1.4v2.6c11.4-.8 22.6-1.5 33.9-2.3l4.4-.3c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.2-.8 8.8-1.5q4.35-1.2 8.4-3.3c2.1-1.1 4.1-2.4 6.2-4v-1.1c-2.3 1.7-4.5 3-6.7 4.1-2.6 1.4-5.4 2.4-8.2 3.1" clip-rule="evenodd"></path><mask id="d" width="67" height="11" x="0" y="38" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 38.2h66.2v10.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#d)"><path fill="#fff" fill-rule="evenodd" d="M50.8 44.1c-2.5.5-5.3.8-8.6.9-1.3.1-2.6.1-4.3.2L0 46.2v2.6L33.6 47l4.4-.2c1.7-.1 3.1-.2 4.4-.3 3.4-.3 6.1-.6 8.7-1.2 2.9-.6 5.8-1.5 8.5-2.7 2.2-.9 4.3-2 6.6-3.4v-1c-2.4 1.4-4.7 2.5-7 3.4-2.7 1.2-5.5 2-8.4 2.5" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.5 48.3c-4.7.6-9.4.7-14.1.8-1.1 0-2.1 0-3.2.1L0 49.8v2.6L33.3 51c1.1 0 2.1-.1 3.2-.1 4.7-.2 9.5-.4 14.2-1.1 3-.5 5.9-1.2 8.5-2.1 2.2-.7 4.5-1.7 6.8-2.9v-1c-2.4 1.1-4.9 2.1-7.2 2.8-2.5.7-5.3 1.4-8.3 1.7" clip-rule="evenodd"></path><mask id="e" width="67" height="7" x="0" y="49" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><path fill="#fff" fill-rule="evenodd" d="M0 49.2h66.2v6.6H0z" clip-rule="evenodd"></path></mask><g mask="url(#e)"><path fill="#fff" fill-rule="evenodd" d="M50.3 52.6c-4.4.4-8.8.4-13.2.4h-4c-11 0-22 .1-33.1.2v2.6c10.6-.4 21.9-.7 33.2-1.1 1.3 0 2.7-.1 4-.1 4.3-.1 8.8-.2 13.2-.7 3.1-.3 5.9-.8 8.6-1.5 2.3-.6 4.7-1.4 7.2-2.3v-.9c-2.5.9-5 1.6-7.4 2.2-2.7.6-5.5 1-8.5 1.2" clip-rule="evenodd"></path></g><path fill="#fff" fill-rule="evenodd" d="M50.1 56.8c-1.8.1-3.8.1-6 .1h-2.5l-8.6-.1c-5.9 0-11.7-.1-17.2-.1L0 56.8v2.6l15.9-.4c5.5-.1 11.3-.3 17.1-.4l8.6-.1c2.4 0 5.5-.1 8.6-.3s5.9-.5 8.6-.9c2.4-.4 4.9-.9 7.4-1.5v-.9c-2.5.6-5.1 1.1-7.5 1.4-2.8.2-5.5.4-8.6.5m-8.6 4.1-8.6-.101C22 60.599 11.1 60.4 0 60.2v2.599c10.6-.099 21.8-.2 32.9-.299l8.6-.1c2.9 0 5.7-.101 8.6-.2 5.9-.2 11.1-.601 16.1-1.3V60c-4.9.5-10.2.799-16.1.9zm24.6 4.6L0 63.8v2.6h66.1zM60.2 22c-2.5 2-4.5 3.5-7.5 4.7-2.7 1.1-5.6 1.5-8.8 2-2.1.3-4.3.7-6.4.9-.9.1-1.7.1-2.6.2L0 32.3v2.6l34.9-3.4 4.5-.4c1.7-.2 3.2-.3 4.6-.6 3.4-.5 6.3-1.4 8.9-2.6 2.7-1.2 5.5-3.2 8-5.3 1.7-1.5 3.4-3.3 5.2-5.3v-.9c-2.2 2.2-4 4.1-5.9 5.6m34-22s11.899 18.9 14.099 22.4 4.7 6.2 13.5 8.1 12.6 2.7 12.6 2.7v.7s-5.6-1.2-12.8-2.8-10.1-2.1-13.4-6.7c-2.7-3.8-14-19.9-14-19.9zm0 21.6s10.799 11.3 13.999 14.6c3.3 3.5 7.6 4.7 13.5 5.8 5.6 1 12.7 2.2 12.7 2.2v.6s-6.7-1.1-12.7-2.1c-5.9-1-10.1-1.6-13.5-4.7-3-2.8-13.9-13-13.9-13z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 26.8s10.299 9.6 13.999 12.8c3.4 3 6.1 3.9 13.5 5.3 7.4 1.3 12.7 2.1 12.7 2.1v.7s-6.7-1.1-12.7-2.1-9.9-1.3-13.5-4.3c-4.2-3.4-14-11.4-14-11.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 32.2s11.799 9.3 13.999 11c2.2 1.6 5.1 3.5 13.5 4.8 8.4 1.2 12.7 1.8 12.7 1.8v.7s-7.6-1.1-12.7-1.7-9-.9-13.5-3.9c-4.4-2.9-14-9.7-14-9.7z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 37.4s11.799 7.9 13.999 9.1 4.9 3.3 13.5 4.4 12.7 1.6 12.7 1.6v.7s-7.1-.8-12.7-1.4-9.4-1.4-13.5-3.7-14-8-14-8z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.2 42.7s10.399 5.7 13.999 7.4c3.9 2 7.3 2.9 13.5 3.7 6.1.7 12.7 1.4 12.7 1.4v.6s-6.1-.7-12.7-1.3c-6.5-.6-8.8-.9-13.5-3-4.2-1.9-14-6.4-14-6.4z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M94.202 48s8.2 3.5 14 5.8c5.7 2.3 10 2.5 13.5 2.8 1.5.2 12.6 1.3 12.6 1.3v.6s-6.6-.5-12.7-1.1c-6-.5-8.6-.8-13.5-2.4s-14-4.8-14-4.8zm-.002 5.4s8.299 2.6 13.999 4.1 10.9 2.1 13.5 2.3 12.7 1 12.7 1v.6s-5.7-.4-12.7-.9c-5.7-.4-10.2-.8-13.5-1.6-3.7-.8-14-3.3-14-3.3zm0 5.3s6.799 1.2 13.999 2.4c5.4.9 12.7 1.5 13.5 1.5s12.7.9 12.7.9v.6s-7.6-.4-12.7-.7c-5.3-.3-10.5-.6-13.5-.9-6.7-.7-14-1.6-14-1.6zm0 5.6s10.699.4 13.999.5 26.2 1 26.2 1v.6h-40.2zm27.501-30.9c-9.7-2.1-11.9-5.6-13.5-7.8s-13.9-20.2-13.9-20.2v4.1c.5.6 11 14.4 14 18.2 3.3 4.3 8.5 5.3 13.5 6.3 5 1.1 12.7 2.6 12.7 2.6V36c-.1 0-10.3-2-12.8-2.6" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.701 36.3c-8-1.6-11.2-4.1-13.5-7.1-2.3-3.1-13.9-18.3-13.9-18.3v3.8c.5.6 11.1 13.1 13.9 16.4 3.3 3.8 7.9 4.8 13.5 5.8s12.7 2.4 12.7 2.4v-.6s-8.1-1.5-12.7-2.4" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M121.699 39.2c-8.3-1.6-10-2.9-13.5-6.8-2.2-2.4-13.5-15.7-14-16.3v3.5s10.5 11.2 13.9 14.6c4.4 4.4 8.6 4.7 13.5 5.6s12.7 2.3 12.7 2.3v-.6c.1 0-9.3-1.6-12.6-2.3" clip-rule="evenodd"></path><path fill="#004494" fill-rule="evenodd" d="M27.5 66.7h57.9V28H27.5z" clip-rule="evenodd"></path><path fill="#FFF100" fill-rule="evenodd" d="M57.098 33.1h2l-1.6 1.3.6 2-1.6-1.2-1.6 1.2.6-2-1.6-1.3h2l.6-2zm0 25.8h2l-1.6 1.199.6 1.901-1.6-1.201-1.6 1.201.6-1.901-1.6-1.199h2l.6-1.9zm6.402-1.7h2l-1.6 1.2.6 1.9-1.6-1.201-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm-.002-22.4h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.3.7-2-1.6-1.2h2l.6-1.9zm4.804 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm0 13h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM70.1 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.7-1.2h2l.6-1.9zM50.5 34.8h2L50.9 36l.6 1.901L50 36.8 48.3 38l.6-1.9-1.6-1.2h2L50 33zm-4.6 4.8h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zM44.2 46h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9L41 46h2l.6-1.9zm1.7 6.6h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9zm4.698 4.7h2l-1.6 1.2.6 1.9-1.6-1.2-1.6 1.2.6-1.9-1.6-1.2h2l.6-1.9z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M26.5 26.6h59.9v40.7H26.5zm2 2v36.7h55.9V28.6z" clip-rule="evenodd"></path>', 26), de1 = [
  ue1
];
function fe1(t, e) {
  return T(), N("svg", he1, [...de1]);
}
const ve1 = { render: fe1 }, pe1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "66",
  height: "44",
  viewBox: "0 0 66 44"
}, me1 = /* @__PURE__ */ C("g", { fill: "none" }, [
  /* @__PURE__ */ C("path", {
    fill: "#039",
    d: "M0 0h66v44H0z"
  }),
  /* @__PURE__ */ C("path", {
    fill: "#FC0",
    d: "M32.138 8.168 30.745 7.15h1.723L33 5.5l.532 1.65h1.723l-1.393 1.018.531 1.659L33 8.8l-1.393 1.027zm1.724 28.682.531 1.65L33 37.483 31.607 38.5l.531-1.65-1.393-1.017h1.723l.532-1.66.532 1.66h1.723zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm7.984-13.017.532 1.65-1.393-1.008-1.394 1.018.532-1.65-1.393-1.018h1.723l.532-1.65.531 1.65h1.724zm-6.572 4.235.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm-1.76 14.337h1.76l.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.018-1.403 1.018.532-1.65-1.394-1.027zm6.609 6.27-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.09-12.412.532 1.65-1.393-1.026-1.412 1.026.532-1.65-1.403-1.026h1.788l.532-1.65.531 1.65H49.5zm-8.845-12.43-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm5.5 4.226.54-1.65.532 1.65h1.724L46.2 15.345l.532 1.65-1.394-1.027-1.402 1.027.532-1.65-1.385-1.027zm1.072 14.346h1.724L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65.532 1.65zm-3.456 5.262-1.393 1.008.532 1.65-1.393-1.018-1.394 1.018.532-1.65-1.394-1.008h1.724l.532-1.65.531 1.65z"
  })
], -1), ge1 = [
  me1
];
function ye1(t, e) {
  return T(), N("svg", pe1, [...ge1]);
}
const _e1 = { render: ye1 }, qe1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, we1 = /* @__PURE__ */ U1('<path fill="#515560" d="M15.52 28.44q0-.46.08-1.08t.3-1.4a12.5 12.5 0 0 1 .66-1.78l2.46.86q-.22.62-.38 1.14a8 8 0 0 0-.24.94q-.08.42-.08.84 0 .66.28 1.18.3.54.86.9.56.38 1.36.58.82.2 1.88.2 1.1 0 1.96-.1.88-.1 1.48-.3.62-.2.94-.52.32-.3.32-.7a.5.5 0 0 0-.14-.34q-.12-.16-.42-.34a5 5 0 0 0-.76-.38q-.46-.2-1.12-.44l.66-2.82q.86.36 1.62.64.78.26 1.48.44.7.16 1.32.26.62.08 1.16.08.76 0 1.08.4.32.38.32.96 0 .62-.42 1.04-.42.4-1.18.4h-.92q.04.2.04.34v.3q0 .66-.46 1.34-.44.68-1.38 1.26t-2.4.92q-1.44.36-3.44.36-2.16 0-3.72-.56-1.54-.54-2.38-1.7-.82-1.14-.82-2.92m8.88 9.82q-.58 0-1-.42a1.3 1.3 0 0 1-.4-.96q0-.58.4-1 .42-.42 1-.42.56 0 .96.42t.4 1q0 .56-.4.96-.4.42-.96.42m-3.46 0q-.58 0-1-.42a1.3 1.3 0 0 1-.4-.96q0-.58.4-1 .42-.42 1-.42.56 0 .96.42t.4 1q0 .56-.4.96-.4.42-.96.42"></path><path fill="#515560" d="m30.996 29.1.2-2.8q.88 0 1.38-.12.52-.12.74-.44.22-.34.22-.96 0-.56-.16-1.34a17 17 0 0 0-.38-1.62q-.24-.84-.48-1.54l2.76-.76a21 21 0 0 1 .88 3.44q.18.94.18 1.82 0 1.1-.28 1.86a3.5 3.5 0 0 1-.78 1.24q-.48.48-1.16.76-.66.26-1.46.36t-1.66.1m2.46 4.6a1.4 1.4 0 0 1-1-.4 1.33 1.33 0 0 1-.4-.98q0-.58.4-1.02.42-.42 1-.42t.98.42q.42.44.42 1.02t-.42.98q-.4.4-.98.4m5.028-.1-.58-2.8a22 22 0 0 0 2.48-.44q1.06-.24 1.78-.68t1.08-1.2q.36-.78.36-2 0-.44-.08-.88a4 4 0 0 0-.24-.84 1.8 1.8 0 0 0-.42-.62.8.8 0 0 0-.58-.24.9.9 0 0 0-.64.26q-.28.24-.44.62-.16.36-.16.74 0 .28.14.48.14.18.42.28.28.08.7.08.48 0 .98-.1.52-.12.94-.32l.08 2.18q-.48.38-1.1.68-.621.28-1.5.28-.72 0-1.34-.16-.62-.18-1.1-.54a2.5 2.5 0 0 1-.72-.92q-.26-.58-.26-1.38 0-.98.32-1.9t.88-1.64a4.5 4.5 0 0 1 1.32-1.16 3.15 3.15 0 0 1 1.6-.44q.999 0 1.74.5.759.5 1.26 1.32.5.8.76 1.74a6.8 6.8 0 0 1 .26 1.8q0 2.26-.96 3.84t-2.74 2.44q-1.78.88-4.24 1.02m9.141 0-1.02-2.56q1.72-.6 2.78-1.32 1.08-.72 1.58-1.54.52-.82.52-1.7 0-.56-.16-1.16a8.5 8.5 0 0 0-.46-1.3 15 15 0 0 0-.68-1.42l2.62-1.26q.699 1.34 1.08 2.56.4 1.22.4 2.28 0 .98-.26 1.88-.24.9-.76 1.68a6.8 6.8 0 0 1-1.3 1.5q-.8.7-1.88 1.28-1.08.6-2.46 1.08m9.003 0-.58-2.8q1.42-.18 2.48-.44 1.06-.24 1.78-.68t1.08-1.2q.36-.78.36-2 0-.44-.08-.88a4 4 0 0 0-.24-.84 1.8 1.8 0 0 0-.42-.62.8.8 0 0 0-.58-.24.9.9 0 0 0-.64.26q-.28.24-.44.62-.16.36-.16.74 0 .28.14.48.141.18.42.28.28.08.7.08.48 0 .98-.1.52-.12.94-.32l.08 2.18q-.48.38-1.1.68-.62.28-1.5.28-.72 0-1.34-.16a3.4 3.4 0 0 1-1.1-.54 2.5 2.5 0 0 1-.72-.92q-.26-.58-.26-1.38 0-.98.32-1.9t.88-1.64q.58-.74 1.32-1.16a3.15 3.15 0 0 1 1.6-.44q1 0 1.74.5a4.1 4.1 0 0 1 1.26 1.32q.5.8.76 1.74a6.8 6.8 0 0 1 .26 1.8q0 2.26-.96 3.84t-2.74 2.44q-1.78.88-4.24 1.02M73.33 18.28q0-.66-.08-1.32-.06-.66-.16-1.24a71 71 0 0 0-.18-1.04l2.8-.4q.08.4.16 1.06t.14 1.4q.06.72.06 1.38a10 10 0 0 1-.18 1.96 8.3 8.3 0 0 1-.54 1.74 8.6 8.6 0 0 1-.9 1.54l-.36.48q-.52.64-1.22 1.26-.681.62-1.5 1.2h1.3q.68 0 1.04-.08t.48-.22a.53.53 0 0 0 .14-.36q0-.36-.62-1.06-.62-.72-1.72-1.64a35 35 0 0 0-2.58-1.98 54 54 0 0 0-3.16-2.12l1.46-2.14q2.36 1.46 3.98 2.68 1.64 1.22 2.68 2.22 1.06 1 1.64 1.82t.8 1.48q.22.64.22 1.16 0 .58-.18 1.12-.18.52-.58.94-.4.4-1.04.64t-1.58.24h-5.88v-2.68q2.06-1.48 3.26-2.8 1.22-1.32 1.76-2.6a6.7 6.7 0 0 0 .54-2.64m-7.26-1.88-.34-1.4q.7-.12 1.04-.2.36-.08.76-.18l-.2.5q-.52-.18-1-.7a1.83 1.83 0 0 1-.46-1.22q0-.72.32-1.16t.82-.64 1.04-.2q.3 0 .56.04.28.04.5.12l-.16 1.44-.4-.08a2.3 2.3 0 0 0-.44-.04.74.74 0 0 0-.48.18.5.5 0 0 0-.2.4q0 .34.24.6t.56.42q.34.14.56.16l-1.1.12q.54-.14 1.02-.28.48-.16.9-.32l.4 1.34q-.5.18-1.18.4-.66.2-1.38.38-.7.18-1.38.32M80.291 29l-.42-14.64h2.8l.42 14.64zm9.765-.8.98-2.54q.74.32 1.42.48t1.36.16q.7 0 1.16-.12.48-.14.72-.4t.24-.62q0-.34-.22-.94-.2-.6-.74-1.56-.54-.98-1.58-2.42l2.38-1.58a26 26 0 0 1 1.66 2.66 15.3 15.3 0 0 1 1.08 2.4q.4 1.1.4 1.94 0 1.04-.56 1.82-.54.76-1.62 1.2-1.06.44-2.62.44-.58 0-1.3-.1t-1.46-.3a6 6 0 0 1-1.3-.52m15.972.9q-1.86 0-2.88-.38-1-.38-1.4-1.18-.4-.82-.46-2.06l-.42-11.12h2.8l.42 9.78q.04.92.2 1.38a.96.96 0 0 0 .6.62q.46.16 1.34.16.759 0 1.08.4.34.38.34.96 0 .62-.42 1.04-.42.4-1.2.4"></path><path fill="#515560" d="M119.135 29.1a10 10 0 0 1-1.72-.14 5.1 5.1 0 0 1-1.44-.48 4.1 4.1 0 0 1-1.18-.98q-.501-.62-.84-1.56l1.58-1.26q.36.64.88 1 .52.34 1.24.48t1.68.14q.759 0 1.08.4.32.38.32.96 0 .62-.42 1.04-.4.4-1.18.4m-13.08 0 .2-2.8q1.08 0 2.14-.12t2.06-.36 1.9-.62a9.7 9.7 0 0 0 1.72-.92q-.6-.36-1.3-.62a7.5 7.5 0 0 0-1.5-.38 9.4 9.4 0 0 0-1.66-.14q-.32 0-.68.02-.34.02-.7.08-.36.04-.72.12l-.4-2.74q.58-.16 1.22-.22.66-.08 1.16-.08 1.08 0 1.98.24a9.6 9.6 0 0 1 1.68.6q.78.36 1.44.72.68.36 1.28.6.62.24 1.2.24h.74l.32 2.66a5 5 0 0 0-1.62.34 9.4 9.4 0 0 0-1.48.72q-.72.42-1.56.88a14 14 0 0 1-1.86.86q-1.041.4-2.4.66-1.36.26-3.16.26"></path><path fill="#515560" d="m119.141 29.1.2-2.8q1.2 0 1.84-.12t.88-.44q.26-.34.26-.96 0-.56-.16-1.34-.14-.78-.38-1.62a17 17 0 0 0-.48-1.54l2.76-.76q.26.68.5 1.58t.4 1.86q.16.94.16 1.82 0 1.36-.44 2.22-.44.84-1.24 1.3-.78.46-1.88.64-1.1.16-2.42.16m5.42-11.2a1.4 1.4 0 0 1-1-.4q-.4-.42-.4-.98 0-.58.4-1 .42-.42 1-.42.56 0 .96.42t.4 1q0 .56-.4.98a1.3 1.3 0 0 1-.96.4m-3.46-.02a1.4 1.4 0 0 1-1-.4q-.4-.42-.4-.98 0-.58.4-1 .42-.42 1-.42.56 0 .96.42t.4 1q0 .56-.4.98a1.3 1.3 0 0 1-.96.4m13.107.4q0-.66-.08-1.32-.06-.66-.16-1.24-.1-.6-.18-1.04l2.8-.4q.08.4.16 1.06t.14 1.4q.06.72.06 1.38a10 10 0 0 1-.18 1.96 8.3 8.3 0 0 1-.54 1.74 8.6 8.6 0 0 1-.9 1.54l-.36.48q-.52.64-1.22 1.26a16 16 0 0 1-1.5 1.2h1.3q.68 0 1.04-.08t.48-.22a.53.53 0 0 0 .14-.36q0-.36-.62-1.06-.62-.72-1.72-1.64a35 35 0 0 0-2.58-1.98 54 54 0 0 0-3.16-2.12l1.46-2.14q2.36 1.46 3.98 2.68 1.64 1.22 2.68 2.22 1.06 1 1.64 1.82t.8 1.48q.22.64.22 1.16 0 .58-.18 1.12a2.6 2.6 0 0 1-.58.94q-.4.4-1.04.64t-1.58.24h-5.88v-2.68q2.06-1.48 3.26-2.8 1.22-1.32 1.76-2.6a6.7 6.7 0 0 0 .54-2.64M140.565 29l-.42-14.64h2.8l.42 14.64z"></path><path fill="#039" d="M153 0h66v44h-66z"></path><path fill="#FC0" fill-rule="evenodd" d="m183.745 7.15 1.393 1.018-.531 1.659L186 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L186 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.018h-1.723l-.532-1.66-.532 1.66h-1.723l1.393 1.017-.531 1.65L186 37.482zm-15.638-15.4-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.027.531 1.65-1.393-1.027zm8.516-11.367-.532-1.65 1.394-1.008h-1.724l-.531-1.65-.532 1.65h-1.723l1.393 1.017-.532 1.65 1.394-1.017zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm0 14.337h-1.779l1.394 1.026-.532 1.65 1.403-1.017 1.402 1.018-.532-1.65 1.394-1.027h-1.678l-.541-1.65zm4.849 6.27-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.761-.531-1.65 1.393-1.027h-1.687l-.531-1.65-.532 1.65h-1.787l1.402 1.027-.532 1.65 1.412-1.027zm-9.377-14.08-1.393-1.01h1.723l.532-1.65.531 1.65h1.724l-1.394 1.01.532 1.65-1.393-1.01-1.394 1.018.532-1.65zm6.041 2.575-.541 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.577 15.996h1.678L199.2 29.68l.532 1.65-1.394-1.017-1.402 1.018.532-1.65-1.385-1.027h1.724l.541-1.65zm-4.895 6.27 1.394-1.008h-1.724l-.531-1.65-.532 1.65h-1.723l1.393 1.008-.532 1.65 1.394-1.018 1.393 1.018z" clip-rule="evenodd"></path>', 6), ze1 = [
  we1
];
function Me1(t, e) {
  return T(), N("svg", qe1, [...ze1]);
}
const be1 = { render: Me1 }, Le1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "202",
  height: "48",
  viewBox: "0 0 202 48"
}, xe1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="m93.062 34.7-2.705.489q-.137-.81-.62-1.22-.483-.411-1.255-.411-1.026 0-1.636.708-.61.709-.61 2.369 0 1.845.62 2.607t1.665.762q.78 0 1.279-.445.498-.444.703-1.528l2.696.459q-.421 1.855-1.612 2.803-1.19.946-3.193.947-2.276 0-3.628-1.435t-1.352-3.975q0-2.568 1.357-4 1.358-1.43 3.672-1.43 1.894 0 3.013.816 1.118.815 1.606 2.485m7.168 5.566h2.549q1.2 0 1.543-.386a1.36 1.36 0 0 0 .342-.932q0-.753-.581-1.036-.582-.283-2.076-.283h-1.777zm-6.133-8.633h6.133v4.307h2.734q1.65 0 2.495.224.845.225 1.436 1.001.59.777.59 1.812 0 1.327-.868 2.178-.87.85-3.272.85h-5.86V33.85h-3.388zm25.269 1.905q-1.142 0-1.665.732-.524.733-.523 2.334 0 2.051.562 2.769.561.718 1.704.718 1.054-.001 1.582-.806.528-.806.528-2.417 0-1.973-.572-2.651-.572-.68-1.616-.68m-9.863-1.904h2.744v4.189h2.187q.216-1.992 1.509-3.208 1.294-1.215 3.462-1.216 2.187 0 3.584 1.416 1.396 1.416 1.397 4.082 0 1.563-.523 2.735a4.4 4.4 0 0 1-1.597 1.889q-1.073.718-2.802.718-2.49 0-3.711-1.352t-1.32-2.886h-2.186v4.004h-2.744zm19.892 6.114V35.96q.713 0 1.035-.093.322-.092.611-.45.288-.355.288-.815 0-.487-.357-.903-.356-.415-1.069-.415a2 2 0 0 0-.977.234q-.43.235-.781 1.114l-2.324-.498q.35-1.367 1.504-2.051 1.151-.684 2.627-.684 1.875 0 2.905.86 1.03.858 1.03 2.158 0 .81-.444 1.343-.445.532-1.402.99 1.153.313 1.724.948t.571 1.582q0 1.211-1.132 2.085-1.133.874-3.262.874-3.71 0-4.541-2.9l2.51-.46q.605 1.524 2.002 1.524.77 0 1.235-.405t.464-.952q0-.606-.484-.952-.483-.347-1.264-.347zM84.03 20.326V6.01h10.616v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm16.114-1.758h2.168q1.172 0 1.709-.283.537-.284.537-1.016 0-.762-.615-1.05t-2.393-.288h-1.406zm0-4.307h1.768q1.278 0 1.85-.322.571-.322.571-1.016 0-.654-.532-.932-.531-.279-1.889-.278h-1.768zM97.38 9.955h6.006q1.846 0 2.764.674.918.673.918 2.031 0 .869-.503 1.513-.503.645-1.265.86 1.074.264 1.602.986a2.63 2.63 0 0 1 .527 1.582q0 1.211-.889 1.968-.888.757-2.626.757H97.38zm14.903 5.01q0 1.749.693 2.582.694.836 1.69.835.957 0 1.592-.767.633-.765.634-2.513 0-1.633-.654-2.422-.654-.791-1.621-.791-1.007 0-1.67.776t-.664 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.489q1.806 0 3.067 1.416 1.259 1.418 1.259 3.945 0 2.6-1.27 4.038-1.269 1.443-3.075 1.442a3.5 3.5 0 0 1-1.558-.343q-.698-.342-1.47-1.171v5.224h-2.744zm14.572 5.185q0 1.544.732 2.363.734.82 1.807.821 1.073 0 1.802-.82.727-.821.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m12.645-5.039h9.21v10.37h-2.745v-8.153h-3.72v8.154h-2.745zm18.35 4.297q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.526 1.505-1.665 2.29-1.138.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528t1.28 4.683h-6.875q.028 1.22.664 1.899.634.68 1.582.679.643 0 1.084-.352.44-.351.664-1.133m11.621-11.279h1.338q-.118 1.327-.933 2.085-.816.756-2.114.757-1.299 0-2.114-.757-.816-.757-.933-2.085h1.338q.069.693.488 1.05.42.356 1.22.356t1.222-.356q.42-.357.488-1.05m-6.572 4.209h2.636v6.514l4.219-6.514h2.696v10.37h-2.637v-6.63l-4.278 6.63h-2.636zm21.605 3.066-2.704.488q-.137-.81-.62-1.22t-1.255-.41q-1.026 0-1.636.707-.61.709-.61 2.37 0 1.844.62 2.606t1.665.762q.78 0 1.279-.445.498-.444.703-1.528l2.696.46q-.421 1.854-1.612 2.802-1.19.947-3.193.947-2.276 0-3.628-1.435t-1.352-3.975q0-2.569 1.357-3.999 1.358-1.43 3.672-1.43 1.894 0 3.013.815 1.117.815 1.606 2.485m1.972-3.066h2.734v4.238q.685-.078.967-.42.284-.342.684-1.494.526-1.533 1.152-1.963t1.641-.43q.313 0 1.084.049l.01 1.817q-1.084 0-1.387.205-.303.215-.655 1.279-.479 1.436-1.376 1.768 1.299.36 2.197 2.256.048.097.107.205l1.533 2.86h-2.949l-1.367-2.997q-.42-.908-.728-1.167-.307-.259-.913-.26v4.425h-2.734zm10.249 0h2.637v6.514l4.218-6.514h2.696v10.37h-2.637v-6.63l-4.277 6.63h-2.637z"></path></g>', 1), Se1 = [
  xe1
];
function Ce1(t, e) {
  return T(), N("svg", Le1, [...Se1]);
}
const ke1 = { render: Ce1 }, Ee1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, Ae1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), Fe1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), Te1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M77.293 6.115h2.601v6.979q0 1.66.097 2.153.168.79.791 1.274.633.475 1.723.475 1.107 0 1.67-.448.562-.457.677-1.116.114-.66.114-2.189V6.115h2.601v6.768q0 2.32-.21 3.278-.212.958-.783 1.617-.563.66-1.511 1.055-.95.387-2.479.387-1.845 0-2.804-.422-.949-.43-1.503-1.108-.553-.685-.73-1.432-.255-1.107-.254-3.27zM98.791 19h-2.47v-4.764q0-1.512-.158-1.95a1.36 1.36 0 0 0-.519-.695 1.45 1.45 0 0 0-.852-.246 2 2 0 0 0-1.151.351q-.51.352-.704.932-.184.58-.184 2.145V19h-2.47V9.666h2.294v1.371q1.222-1.582 3.076-1.582.817 0 1.494.299.677.29 1.02.747.351.457.483 1.037.141.58.141 1.661zm2.514-10.6V6.115h2.469V8.4zm0 10.6V9.666h2.469V19zm4.438-4.799q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.758q1.117-.606 2.488-.606 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.125-.607-2.734m2.531.132q0 1.389.66 2.127.659.738 1.626.738t1.617-.738q.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m1.038-5.81 1.212-2.627h2.769l-2.417 2.627zM77.309 38V25.115h9.553v2.18H79.91v2.856h6.469v2.171H79.91v3.507h7.198V38zm18.131 0v-1.398q-.51.748-1.344 1.178-.826.43-1.75.43-.94 0-1.687-.412a2.44 2.44 0 0 1-1.08-1.16q-.335-.747-.335-2.066v-5.906h2.47v4.29q0 1.968.132 2.416.14.44.5.703.36.255.915.255.633 0 1.133-.343.501-.351.686-.861.185-.518.185-2.523v-3.937h2.47V38zm7.225 0h-2.47v-9.334h2.294v1.327q.589-.94 1.055-1.24a1.97 1.97 0 0 1 1.072-.298q.845 0 1.626.466l-.764 2.153q-.624-.405-1.161-.404a1.36 1.36 0 0 0-.879.29q-.36.282-.571 1.028-.202.747-.202 3.13zm4.078-4.799q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.758q1.117-.606 2.488-.606 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.531.132q0 1.389.66 2.127.659.738 1.626.738t1.617-.738q.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m8.974-4.667h2.303v1.371q.448-.704 1.213-1.142a3.34 3.34 0 0 1 1.696-.44q1.626 0 2.76 1.275t1.134 3.55q0 2.338-1.143 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.318-1.054v4.702h-2.47zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.861 0 1.433-.686.57-.693.571-2.267 0-1.468-.589-2.18-.59-.711-1.459-.712-.905 0-1.503.703-.598.695-.598 2.066m14.037 1.855 2.46.412q-.474 1.354-1.502 2.066-1.02.703-2.558.703-2.434 0-3.604-1.59-.922-1.275-.922-3.218 0-2.32 1.212-3.63 1.214-1.317 3.068-1.318 2.083 0 3.287 1.38 1.204 1.37 1.151 4.21h-6.187q.026 1.099.597 1.714.572.606 1.424.606.58 0 .976-.316.396-.317.598-1.02m.14-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.808 0-1.336.589-.527.588-.518 1.6zm6.32-1.018-2.242-.405q.378-1.353 1.301-2.004.923-.65 2.742-.65 1.653 0 2.461.396.809.386 1.134.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.238-.73 5 5 0 0 0-.087-.29q-.633.615-1.354.923-.72.308-1.538.308-1.442 0-2.276-.782-.827-.783-.827-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.399-.606v-.246q0-.711-.351-1.01-.352-.309-1.328-.308-.659 0-1.028.263-.369.255-.597.906m3.304 2.004q-.474.158-1.503.377-1.028.22-1.344.431-.484.343-.484.87 0 .519.387.897t.984.378q.668 0 1.275-.44.447-.334.589-.817.096-.316.096-1.204z"
}, null, -1), Ie1 = [
  Ae1,
  Fe1,
  Te1
];
function Oe1(t, e) {
  return T(), N("svg", Ee1, [...Ie1]);
}
const Ne1 = { render: Oe1 }, Pe1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "48",
  viewBox: "0 0 173 48"
}, Be1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M90.846 42.006v-1.553q-.567.83-1.49 1.308a4.2 4.2 0 0 1-1.948.478q-1.044.001-1.874-.458a2.7 2.7 0 0 1-1.202-1.29q-.37-.829-.371-2.294v-6.563h2.744v4.767q0 2.186.152 2.68.151.494.55.78.402.29 1.017.29a2.16 2.16 0 0 0 1.26-.387q.556-.386.762-.957.204-.571.205-2.797v-4.375h2.744v10.37zm14.524 0h-2.744v-5.294q0-1.68-.176-2.172a1.53 1.53 0 0 0-.57-.767q-.397-.274-.953-.274-.714 0-1.28.392-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V31.633h2.55v1.523q1.356-1.756 3.417-1.756.909 0 1.66.326.752.328 1.138.835.385.508.537 1.153.15.644.151 1.845zm2.583-.001h2.744V31.634h-2.744zm0-11.777h2.744v-2.539h-2.744zm11.719 5.703q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9.001-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.46q-.526 1.504-1.665 2.29-1.139.785-2.847.786-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.578 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528 1.338 1.53 1.28 4.683h-6.875q.028 1.22.664 1.9.634.678 1.582.678.643 0 1.084-.352.44-.351.664-1.133M84.03 20.326V6.01h10.615v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm15.872 0-4.18-10.371h2.881l1.953 5.293.567 1.767q.225-.674.283-.888.136-.44.293-.88l1.973-5.292h2.822l-4.12 10.37zm11.099 0h-2.744V9.955h2.549v1.475q.654-1.045 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.316-.63 1.147t-.229 3.477zm7.533-5.186q0 1.544.732 2.363.734.82 1.807.821 1.073 0 1.802-.82.727-.821.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.189-.029q0 1.748.693 2.582.694.836 1.69.835.958 0 1.592-.767.633-.765.634-2.513 0-1.632-.654-2.422t-1.62-.791q-1.008 0-1.67.776-.665.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.489q1.806 0 3.067 1.416 1.26 1.417 1.26 3.946 0 2.597-1.27 4.038-1.27 1.44-3.076 1.44a3.5 3.5 0 0 1-1.558-.341q-.698-.344-1.47-1.172v5.224h-2.744zm11.529 7.412 2.754-.42q.175.8.713 1.216.537.415 1.504.415 1.065 0 1.6-.391a.87.87 0 0 0 .363-.732.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.732-4.21-1.338-1.23-.84-1.23-2.334 0-1.348 1.065-2.266t3.3-.917q2.13 0 3.165.693 1.035.694 1.426 2.05l-2.588.479q-.165-.606-.63-.928t-1.323-.322q-1.084 0-1.553.303-.312.215-.312.557 0 .292.273.498.37.273 2.564.77 2.193.5 3.06 1.222.86.732.86 2.04 0 1.426-1.191 2.452t-3.525 1.025q-2.12 0-3.355-.86a3.96 3.96 0 0 1-1.616-2.333m11.692 2.959V6.01h2.744v7.597l3.213-3.652h3.379l-3.545 3.789 3.799 6.582h-2.959l-2.608-4.658-1.279 1.338v3.32zM165.39 8.685l1.349-2.92h3.076l-2.686 2.92zm2.97 6.66q-.528.176-1.67.42-1.143.244-1.494.48-.538.379-.537.965 0 .578.429.996.43.42 1.094.42.743 0 1.416-.488.498-.37.654-.908.108-.351.108-1.338zm-3.672-2.226-2.49-.45q.419-1.503 1.445-2.226t3.047-.723q1.836 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.131.65.493 1.392h-2.715a11 11 0 0 1-.264-.81 6 6 0 0 0-.097-.323q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.524-.869-.923-.87-.923-2.197 0-.88.42-1.568t1.177-1.054q.758-.367 2.183-.64 1.923-.36 2.666-.674v-.273q0-.792-.391-1.128-.391-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.011"></path></g>', 1), Ve1 = [
  Be1
];
function Re1(t, e) {
  return T(), N("svg", Pe1, [...Ve1]);
}
const He1 = { render: Re1 }, De1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "239",
  height: "48",
  viewBox: "0 0 239 48"
}, $e1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84.02 27.69h2.89v7.753q0 1.845.107 2.392a2.32 2.32 0 0 0 .884 1.412q.698.532 1.91.532 1.23 0 1.854-.503.625-.504.752-1.235.127-.733.127-2.432v-7.92h2.891v7.52q0 2.578-.234 3.642-.235 1.066-.865 1.797-.629.732-1.684 1.167t-2.754.435q-2.05 0-3.11-.474t-1.675-1.23q-.615-.758-.81-1.587-.284-1.23-.284-3.633zm23.277 14.316h-2.744v-5.294q-.001-1.68-.176-2.172a1.53 1.53 0 0 0-.571-.767q-.396-.274-.952-.274-.714 0-1.28.392-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V31.633h2.549v1.523q1.357-1.756 3.418-1.756.908 0 1.66.326.75.328 1.138.835.385.508.537 1.153.15.644.15 1.845zm2.283-.001h2.744V31.634h-2.744zm0-11.777h2.744v-2.539h-2.744zm7.234 6.592q0 1.543.732 2.363.734.82 1.807.821 1.073 0 1.802-.821.727-.82.727-2.383 0-1.522-.727-2.343-.728-.82-1.802-.821-1.074 0-1.807.821-.732.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528t1.504 3.863q0 2.353-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.245-.674-3.032m21.786 5.332h-2.744v-5.294q-.001-1.68-.176-2.172a1.53 1.53 0 0 0-.571-.767q-.396-.274-.952-.274-.713 0-1.28.392-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V31.633h2.549v1.523q1.357-1.756 3.418-1.756.908 0 1.66.326.75.328 1.138.835.385.508.537 1.153.15.644.15 1.845zM86.91 8.431v9.482h2.159q1.212 0 1.748-.136.704-.176 1.167-.596.465-.42.757-1.382.293-.96.293-2.622 0-1.66-.293-2.549-.294-.888-.82-1.386-.528-.498-1.338-.674-.605-.138-2.373-.137zM84.02 6.01h5.284q1.786 0 2.724.274 1.26.371 2.158 1.318.899.947 1.368 2.32.468 1.371.468 3.383 0 1.767-.44 3.047-.536 1.562-1.532 2.53-.753.731-2.032 1.142-.956.302-2.558.303h-5.44zm20.596 8.242q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.899 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.527 1.505-1.665 2.29-1.138.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.528t1.28 4.683h-6.875q.029 1.22.664 1.899.634.68 1.582.679.644 0 1.084-.352.44-.351.664-1.133m14.25 3.301h-2.743v-5.293q-.001-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.714 0-1.28.39t-.776 1.036-.21 2.383v4.697h-2.744V9.955h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327.75.327 1.138.835.385.507.537 1.152.15.645.15 1.846zm8.76 0V6.01h10.614v2.42h-7.724v3.175h7.188v2.412h-7.187v3.897h7.998v2.412zm19.646 0v-1.553q-.567.83-1.489 1.309a4.2 4.2 0 0 1-1.949.478q-1.044.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.371-2.295V9.955h2.744v4.766q0 2.188.152 2.68.151.494.551.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798V9.955h2.744v10.37zm8.018 0h-2.744V9.955h2.549v1.475q.654-1.046 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.29-.45-.576 0-.976.318-.399.316-.63 1.147t-.23 3.477zm7.034-5.186q0 1.544.732 2.363.732.82 1.807.821 1.074 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82q-.732.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.189-.029q0 1.748.693 2.582.694.836 1.69.835.957 0 1.592-.767.634-.765.634-2.513 0-1.632-.654-2.422t-1.621-.791q-1.007 0-1.67.776t-.664 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.259 1.415 1.259 3.944 0 2.6-1.27 4.039-1.269 1.44-3.075 1.44a3.5 3.5 0 0 1-1.558-.341q-.698-.344-1.47-1.172v5.224h-2.744zm24.891 4.277q-.06-.86-.234-1.24a1.9 1.9 0 0 0-.738-.86q-.495-.312-1.157-.312-.577 0-1.012.268-.435.27-.687.806-.342.712-.313 1.338zm-6.905 1.133q-2.255.595-2.45.664-.656.215-.915.517-.257.303-.257.713 0 .567.423.967.426.4 1.11.401.721 0 1.357-.459.47-.342.6-.855.133-.512.132-1.948m6.798 1.65 2.685.48q-.557 1.531-1.69 2.3-1.133.765-2.89.765a5.6 5.6 0 0 1-2.021-.356 5.1 5.1 0 0 1-1.68-1.07q-.693.595-1.792 1.011a6.3 6.3 0 0 1-2.261.415q-1.66 0-2.589-.864-.926-.864-.926-2.183 0-.79.327-1.406.325-.614.79-.962.464-.345 1.294-.6.39-.127 2.325-.528.966-.205 1.65-.43v-.273q0-.75-.41-1.123-.41-.371-1.3-.37-.78 0-1.24.316-.458.319-.653.982l-2.492-.479q.49-1.504 1.54-2.212t3.198-.708q1.015 0 1.81.24.797.24 1.363.717a4.2 4.2 0 0 1 1.303-.717q.709-.24 1.52-.24 1.563 0 2.642.66t1.698 1.943q.621 1.284.61 3.628h-6.893q.166 1.328.742 1.924.575.595 1.416.595.694 0 1.18-.356.49-.357.744-1.099m4.894 3.311h2.744V9.955h-2.744zm0-11.778h2.744V6.009h-2.744zm4.59 8.819 2.754-.42q.174.8.713 1.216.537.415 1.504.415 1.065 0 1.6-.391a.87.87 0 0 0 .363-.732.72.72 0 0 0-.196-.518q-.205-.195-.918-.361-3.322-.732-4.21-1.338-1.23-.84-1.23-2.334 0-1.347 1.065-2.266 1.065-.917 3.3-.917 2.13 0 3.165.693t1.425 2.05l-2.587.479q-.165-.606-.63-.928t-1.323-.322q-1.085 0-1.553.303-.312.215-.312.557 0 .292.273.498.37.273 2.563.77 2.194.5 3.061 1.222.86.732.86 2.04 0 1.425-1.191 2.452t-3.525 1.025q-2.12 0-3.356-.86a3.96 3.96 0 0 1-1.615-2.333m11.692 2.959V6.01h2.744v7.597l3.213-3.652h3.379l-3.545 3.789 3.799 6.582h-2.96l-2.607-4.658-1.28 1.338v3.32zm17.083-6.074q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.526 1.505-1.665 2.29-1.138.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528t1.28 4.683h-6.875q.028 1.22.664 1.899.634.68 1.582.679.643 0 1.084-.352.44-.351.664-1.133"></path></g>', 1), Ue1 = [
  $e1
];
function je1(t, e) {
  return T(), N("svg", De1, [...Ue1]);
}
const Ge1 = { render: je1 }, We1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "202",
  height: "48",
  viewBox: "0 0 202 48"
}, Ye1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 27.69h2.891v7.753q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.412q.698.532 1.909.532 1.23 0 1.855-.503.625-.504.752-1.235.127-.733.127-2.432v-7.92h2.891v7.52q0 2.578-.234 3.642-.235 1.066-.865 1.797-.63.732-1.684 1.167-1.055.435-2.754.435-2.05 0-3.11-.474t-1.675-1.23-.811-1.587q-.282-1.23-.283-3.633zm23.277 14.316h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.714 0-1.28.39t-.776 1.036-.21 2.383v4.697h-2.744V31.635h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.283 0h2.745V31.635h-2.744zm0-11.778h2.745v-2.539h-2.744zm7.235 6.592q0 1.544.732 2.363.733.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.245-.674-3.032m21.786 5.332h-2.744v-5.293q-.001-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V31.635h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327.75.327 1.138.835.385.507.537 1.152.15.645.15 1.846zM84.01 20.326V6.01h10.616v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897H94.9v2.412zm19.647 0v-1.553a4 4 0 0 1-1.489 1.309 4.2 4.2 0 0 1-1.949.478q-1.043.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.829-.37-2.295V9.955h2.743v4.766q0 2.188.152 2.68.151.494.551.78.4.29 1.016.29.705 0 1.26-.386.556-.386.762-.957.204-.572.205-2.798V9.955h2.744v10.37zm8.018 0h-2.744V9.955h2.549v1.475q.654-1.046 1.176-1.377a2.17 2.17 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.29-.45-.576 0-.976.318-.399.319-.63 1.147-.23.831-.23 3.477zm7.034-5.186q0 1.544.732 2.363.733.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.367.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.189-.03q0 1.748.693 2.583.694.835 1.69.835.957 0 1.592-.767.634-.765.634-2.514 0-1.631-.654-2.422t-1.621-.79q-1.007 0-1.67.775-.664.777-.664 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.259 1.417 1.259 3.945 0 2.599-1.269 4.038-1.27 1.441-3.076 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.744zm17.263-1.835h2.363V5.765h-2.363zm.654 7.226q-.527.176-1.67.42t-1.494.479q-.537.38-.537.966 0 .578.43.996.429.42 1.094.42.743 0 1.416-.488.498-.37.654-.908.106-.351.107-1.338zm-4.853-7.226h2.354V5.765h-2.354zm1.182 5-2.491-.45q.42-1.503 1.446-2.226 1.025-.723 3.047-.723 1.835 0 2.734.435.898.435 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.369.132 2.017.132.65.493 1.392h-2.714a10 10 0 0 1-.264-.811 5 5 0 0 0-.098-.322 4.9 4.9 0 0 1-1.504 1.025 4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869t-.923-2.197q0-.88.42-1.568a2.74 2.74 0 0 1 1.177-1.054q.757-.367 2.182-.64 1.923-.36 2.666-.674v-.273q0-.792-.39-1.128-.391-.337-1.475-.337-.733 0-1.142.288-.41.288-.664 1.011m9.272 7.207h2.744V9.955h-2.744zm0-11.778h2.744V6.009h-2.744zm4.79 8.819 2.754-.42q.175.802.713 1.216.537.415 1.504.415 1.065 0 1.6-.391a.87.87 0 0 0 .363-.732.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.732-4.21-1.338-1.23-.84-1.23-2.334 0-1.347 1.065-2.266 1.065-.917 3.3-.917 2.13 0 3.165.693 1.035.694 1.426 2.05l-2.588.479q-.165-.605-.63-.928-.464-.322-1.323-.322-1.084 0-1.553.303-.312.215-.312.557 0 .292.273.498.37.273 2.564.77 2.193.5 3.06 1.222.86.733.86 2.04 0 1.427-1.191 2.452t-3.525 1.025q-2.12 0-3.355-.86a3.96 3.96 0 0 1-1.616-2.333m20.832-4.347-2.704.489q-.137-.81-.62-1.22-.483-.411-1.255-.411-1.026 0-1.636.708-.61.709-.61 2.369 0 1.845.62 2.607t1.665.762q.78 0 1.279-.445.498-.444.703-1.528l2.696.459q-.421 1.856-1.612 2.803-1.19.948-3.193.947-2.276 0-3.628-1.435t-1.352-3.975q0-2.568 1.357-4 1.358-1.429 3.672-1.43 1.894 0 3.013.816 1.117.816 1.606 2.485m4.513-7.011v5.263q1.328-1.553 3.174-1.553.947 0 1.71.351.761.353 1.146.9.385.546.528 1.21.141.665.141 2.06v6.084h-2.744v-5.478q0-1.63-.156-2.07a1.37 1.37 0 0 0-.552-.699q-.396-.258-.99-.258a2.3 2.3 0 0 0-1.222.332q-.537.332-.786 1.001t-.249 1.977v5.195h-2.744V6.01zm15.546 8.241q-.03-1.19-.616-1.812a1.9 1.9 0 0 0-1.426-.62q-.899.001-1.484.655-.585.655-.577 1.777zm-.157 2.773 2.734.46q-.526 1.503-1.665 2.29-1.138.786-2.847.786-2.704 0-4.003-1.768-1.026-1.415-1.026-3.574 0-2.578 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.528 1.339 1.53 1.28 4.683h-6.875q.03 1.22.664 1.9.634.678 1.582.678.645 0 1.084-.352.44-.35.664-1.133"></path></g>', 1), Xe1 = [
  Ye1
];
function Ke1(t, e) {
  return T(), N("svg", We1, [...Xe1]);
}
const Ze1 = { render: Ke1 }, Je1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "194",
  height: "48",
  viewBox: "0 0 194 48"
}, Qe1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M89.85 42.006V27.69h10.615v2.42h-7.734v3.175h7.197v2.412h-7.197v3.897h8.008v2.412zM84 30.229l1.563-2.54h3.642l-3.212 2.54zm22.022 11.777-4.18-10.371h2.88l1.954 5.293.567 1.767q.224-.674.283-.888.135-.44.293-.88l1.973-5.292h2.822l-4.121 10.37zm9.072-10.371h2.617q-1.278 2.665-1.279 5.468 0 1.602.571 2.285.572.684 1.353.684.537 0 .942-.333.405-.33.523-.82.117-.488.117-1.493V34.28h2.744v3.145q0 .967.112 1.476.112.506.528.838.414.334.942.334.82 0 1.372-.714.552-.712.552-2.364 0-1.112-.332-2.606a12.4 12.4 0 0 0-.948-2.755h2.618q.546.909 1.01 2.486t.464 2.896q0 2.284-1.21 3.755-1.212 1.469-3.184 1.468-2.364 0-3.29-2.176-.94 2.175-3.302 2.176-1.982 0-3.189-1.473-1.205-1.474-1.206-3.75 0-1.319.464-2.896.465-1.577 1.011-2.485m18.233 5.185q0 1.485.713 2.334.713.85 1.826.85 1.074 0 1.802-.82.727-.822.727-2.413 0-1.406-.693-2.27t-1.836-.865q-1.125 0-1.831.85-.708.849-.708 2.334m9.639-5.186v2.276h-2.51a5.57 5.57 0 0 1 .762 2.871q0 2.266-1.48 3.862t-3.911 1.597q-2.373 0-3.843-1.484-1.47-1.485-1.47-3.887 0-2.383 1.44-3.926 1.441-1.543 3.95-1.543.734 0 1.69.234zm11.308 14.316h-2.744v-9.237q0-1.387-.112-1.95a1.57 1.57 0 0 0-.528-.912q-.415-.351-1.06-.351-.771 0-1.347.439a2 2 0 0 0-.747 1.128q-.171.689-.171 2.24v4.699h-2.744V31.635h2.549v1.523q1.358-1.758 3.427-1.758 1.2 0 2.032.518.83.517 1.137 1.318t.308 2.324zM84.03 20.326V6.01h10.615v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zM96.567 9.955h2.744v5.312q0 1.905.537 2.48.539.577 1.387.577.986 0 1.455-.67.47-.668.47-2.387V9.955h2.743v4.873q0 2.09-.459 3.247a3.65 3.65 0 0 1-1.563 1.82q-1.102.666-2.607.665-1.62 0-2.729-.693-1.109-.694-1.543-1.846-.435-1.152-.435-3.193zm14.185 5.498q0 1.289.654 2.08.655.79 1.778.79 1.102.001 1.787-.883t.683-2.32q0-1.464-.63-2.313t-1.811-.85q-1.026 0-1.743.767-.719.765-.718 2.729m0 4.238v4.58h-2.744v-8.164q-.001-2.206.454-3.501t1.645-2.09q1.192-.795 2.88-.795 2.511 0 3.995 1.62 1.485 1.62 1.485 3.897 0 2.227-1.431 3.775-1.43 1.546-3.511 1.547-1.377 0-2.773-.87m10.913-9.735h2.617q-1.279 2.665-1.28 5.469 0 1.602.572 2.285.57.683 1.353.684.537 0 .942-.333.405-.331.523-.82t.117-1.494V12.6h2.744v3.145q0 .967.112 1.475.112.507.528.839.414.333.942.333.82 0 1.372-.713t.552-2.364q0-1.113-.332-2.607a12.4 12.4 0 0 0-.948-2.754h2.618q.546.908 1.01 2.485.465 1.578.464 2.896 0 2.285-1.211 3.755-1.21 1.47-3.183 1.469-2.363 0-3.291-2.177-.938 2.176-3.301 2.177-1.982 0-3.19-1.474-1.204-1.475-1.205-3.75 0-1.319.464-2.896.465-1.577 1.01-2.485m15.328.001h14.365v2.275h-2.754v8.096h-2.744V12.23h-3.37v8.096h-2.743V12.23h-2.754zm18.618 5.215q0 1.435.61 2.329.611.894 1.587.894.938 0 1.533-.791.596-.791.596-2.432 0-1.611-.635-2.441-.634-.83-1.533-.83-.937 0-1.548.859-.61.86-.61 2.412m5.713-5.215h2.353q-.555 1.133-.932 2.896-.376 1.763-.376 2.465 0 .909.342 2.374.34 1.464.86 2.636h-2.306a6 6 0 0 0-.175-.547 13 13 0 0 1-.352-1.171q-1.2 1.953-3.428 1.953-2.1 0-3.305-1.704-1.207-1.705-1.207-3.98 0-2.149 1.202-3.652 1.2-1.504 3.34-1.504 2.109 0 3.408 2.02.176-.712.576-1.786m6.937-1.836h2.363V5.765h-2.363zm-2.294 12.207h2.744V9.955h-2.744zm-1.905-12.207h2.354V5.765h-2.354zm7.613 1.836h2.744v3.594l3.203-3.594h3.35l-4.17 4.395 4.492 5.976h-3.213l-3.037-4.141-.625.665v3.476h-2.744zm14.575-1.27 1.348-2.92h3.076l-2.686 2.92zm6.23 15.586h-2.744v-9.238q0-1.387-.112-1.949a1.57 1.57 0 0 0-.527-.913q-.415-.35-1.06-.35-.772 0-1.348.438a2 2 0 0 0-.747 1.128q-.171.69-.171 2.241v4.698h-2.744V9.956h2.549v1.522q1.358-1.758 3.428-1.758 1.2 0 2.03.518.832.517 1.139 1.318.307.802.307 2.324z"></path></g>', 1), et1 = [
  Qe1
];
function tt1(t, e) {
  return T(), N("svg", Je1, [...et1]);
}
const nt1 = { render: tt1 }, it1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "172",
  height: "48",
  viewBox: "0 0 172 48"
}, st1 = /* @__PURE__ */ C("g", { fill: "none" }, [
  /* @__PURE__ */ C("path", {
    fill: "#039",
    d: "M0 0h72v48H0z"
  }),
  /* @__PURE__ */ C("path", {
    fill: "#FC0",
    d: "M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"
  }),
  /* @__PURE__ */ C("path", {
    fill: "#515560",
    d: "M84 27.69h2.89v7.75a16.4 16.4 0 0 0 .11 2.4 2.35 2.35 0 0 0 .88 1.41 3.12 3.12 0 0 0 1.91.53 3 3 0 0 0 1.86-.5 2.06 2.06 0 0 0 .77-1.28 17 17 0 0 0 .12-2.43v-7.88h2.9v7.52a19 19 0 0 1-.24 3.64 4.1 4.1 0 0 1-.86 1.8 4.4 4.4 0 0 1-1.69 1.17 7.5 7.5 0 0 1-2.75.43 8 8 0 0 1-3.11-.47 4.5 4.5 0 0 1-1.68-1.23A4 4 0 0 1 84.3 39a17.3 17.3 0 0 1-.3-3.67zM107.3 42h-2.75v-5.3a8.6 8.6 0 0 0-.17-2.17 1.6 1.6 0 0 0-.57-.77 1.7 1.7 0 0 0-1-.27 2.2 2.2 0 0 0-1.28.39 2 2 0 0 0-.77 1 9 9 0 0 0-.21 2.38V42h-2.71V31.63h2.55v1.53a4.17 4.17 0 0 1 3.42-1.76 4.1 4.1 0 0 1 1.66.33 2.8 2.8 0 0 1 1.14.83c.252.344.432.735.53 1.15a8 8 0 0 1 .16 1.85zm2.28-11.77v-2.54h2.74v2.54zm0 11.78V31.63h2.74V42zm4.42-5.34a5.6 5.6 0 0 1 .68-2.64 4.55 4.55 0 0 1 1.9-2 5.8 5.8 0 0 1 2.76-.67 5.18 5.18 0 0 1 3.86 1.53 5.28 5.28 0 0 1 1.5 3.86 5.34 5.34 0 0 1-1.51 3.9 5.16 5.16 0 0 1-3.83 1.55 6 6 0 0 1-2.72-.64 4.37 4.37 0 0 1-2-1.89 6.3 6.3 0 0 1-.64-3m2.81.15a3.4 3.4 0 0 0 .74 2.36 2.39 2.39 0 0 0 3.6 0 3.44 3.44 0 0 0 .73-2.38 3.38 3.38 0 0 0-.73-2.34 2.39 2.39 0 0 0-3.6 0 3.4 3.4 0 0 0-.74 2.36M135.79 42H133v-5.3a8.6 8.6 0 0 0-.17-2.17 1.6 1.6 0 0 0-.57-.77 1.7 1.7 0 0 0-1-.27 2.2 2.2 0 0 0-1.28.39 2 2 0 0 0-.77 1 9 9 0 0 0-.21 2.38V42h-2.75V31.63h2.55v1.53a4.17 4.17 0 0 1 3.42-1.76 4.1 4.1 0 0 1 1.66.33 2.8 2.8 0 0 1 1.14.83c.251.346.434.736.54 1.15a8.7 8.7 0 0 1 .15 1.85zM84 20.33V6h10.65v2.43h-7.73v3.18h7.19V14h-7.19v3.89h8v2.42zm19.9 0v-1.56a4 4 0 0 1-1.49 1.31 4.2 4.2 0 0 1-2 .48 3.8 3.8 0 0 1-1.88-.46 2.68 2.68 0 0 1-1.2-1.29 5.9 5.9 0 0 1-.33-2.29V10h2.75v4.77c-.04.896.01 1.794.15 2.68.088.316.282.591.55.78.295.198.645.3 1 .29a2.13 2.13 0 0 0 1.25-.39 1.9 1.9 0 0 0 .77-.95c.18-.922.247-1.862.2-2.8V10h2.75v10.33zm7.71 0h-2.74V10h2.55v1.48a4.4 4.4 0 0 1 1.18-1.38 2.14 2.14 0 0 1 1.18-.33 3.44 3.44 0 0 1 1.81.52l-.85 2.39a2.4 2.4 0 0 0-1.29-.45 1.56 1.56 0 0 0-1 .32 2.24 2.24 0 0 0-.63 1.15 16.4 16.4 0 0 0-.23 3.47zm4.23-5.33a5.6 5.6 0 0 1 .67-2.64 4.63 4.63 0 0 1 1.91-2 5.64 5.64 0 0 1 2.76-.67 5.2 5.2 0 0 1 3.82 1.56 5.28 5.28 0 0 1 1.5 3.86A5.35 5.35 0 0 1 125 19a5.14 5.14 0 0 1-3.82 1.55 6 6 0 0 1-2.72-.64 4.45 4.45 0 0 1-2-1.89 6.3 6.3 0 0 1-.62-3.02m2.81.15a3.4 3.4 0 0 0 .73 2.36 2.4 2.4 0 0 0 3.61 0 3.44 3.44 0 0 0 .73-2.38 3.38 3.38 0 0 0-.73-2.34 2.4 2.4 0 0 0-3.61 0 3.4 3.4 0 0 0-.73 2.35zm9.62-5.15h2.56v1.53c.337-.53.8-.966 1.35-1.27.57-.33 1.22-.5 1.88-.49a3.94 3.94 0 0 1 3.07 1.42 5.72 5.72 0 0 1 1.26 3.94 6 6 0 0 1-1.27 4 4 4 0 0 1-3.12 1.43 3.5 3.5 0 0 1-1.56-.34 5.5 5.5 0 0 1-1.44-1.17v5.22h-2.74zm2.73 5a4 4 0 0 0 .7 2.59 2.12 2.12 0 0 0 1.69.83 2 2 0 0 0 1.59-.76 4 4 0 0 0 .63-2.52 3.72 3.72 0 0 0-.65-2.42 2 2 0 0 0-1.62-.79 2.12 2.12 0 0 0-1.67.77A3.5 3.5 0 0 0 131 15m15.37 2 2.73.45a4.4 4.4 0 0 1-1.66 2.29 4.86 4.86 0 0 1-2.85.79 4.64 4.64 0 0 1-4-1.77 5.94 5.94 0 0 1-1-3.57 5.72 5.72 0 0 1 1.35-4 4.46 4.46 0 0 1 3.41-1.46 4.6 4.6 0 0 1 3.65 1.52 6.77 6.77 0 0 1 1.28 4.68h-6.87a2.78 2.78 0 0 0 .66 1.9c.404.444.98.692 1.58.68a1.74 1.74 0 0 0 1.09-.35 2.2 2.2 0 0 0 .63-1.16m.16-2.78a2.65 2.65 0 0 0-.62-1.81 1.9 1.9 0 0 0-1.42-.62 1.93 1.93 0 0 0-1.49.65 2.53 2.53 0 0 0-.57 1.78zm7.01-1.1-2.49-.45a3.9 3.9 0 0 1 1.44-2.23 5.3 5.3 0 0 1 3-.72 6.7 6.7 0 0 1 2.73.43c.53.225.976.614 1.27 1.11.303.78.43 1.616.37 2.45v3.21q-.027 1.007.13 2a6 6 0 0 0 .49 1.4h-2.71a28 28 0 0 1-.27-.81c0-.17-.08-.27-.09-.33a4.9 4.9 0 0 1-1.51 1 4.25 4.25 0 0 1-1.71.34 3.5 3.5 0 0 1-2.52-.87 3.1 3.1 0 0 1-.5-3.76 2.8 2.8 0 0 1 1.17-1.06 9.4 9.4 0 0 1 2.18-.64 14.6 14.6 0 0 0 2.67-.67v-.28a1.41 1.41 0 0 0-.39-1.12 2.3 2.3 0 0 0-1.47-.34 2 2 0 0 0-1.15.29 2 2 0 0 0-.64 1.05m3.67 2.23c-.35.11-.91.25-1.67.42a5.1 5.1 0 0 0-1.49.47 1.16 1.16 0 0 0-.54 1 1.35 1.35 0 0 0 .43 1 1.5 1.5 0 0 0 1.09.42 2.42 2.42 0 0 0 1.42-.49 1.7 1.7 0 0 0 .65-.91c.092-.44.129-.89.11-1.34zm14.71 4.98h-2.74V15a8 8 0 0 0-.18-2.17 1.48 1.48 0 0 0-.57-.77 1.64 1.64 0 0 0-1-.27 2.2 2.2 0 0 0-1.28.39 1.9 1.9 0 0 0-.77 1 9 9 0 0 0-.21 2.38v4.7h-2.75V10H165v1.53a4.16 4.16 0 0 1 3.42-1.76 4.1 4.1 0 0 1 1.66.33 2.8 2.8 0 0 1 1.14.83c.252.344.432.735.53 1.15a8.7 8.7 0 0 1 .15 1.85z"
  })
], -1), lt1 = [
  st1
];
function rt1(t, e) {
  return T(), N("svg", it1, [...lt1]);
}
const at1 = { render: rt1 }, ot1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "161",
  height: "48",
  viewBox: "0 0 161 48"
}, ct1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 42.006V27.69h10.615v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm19.866 0v-1.553q-.567.83-1.489 1.309a4.2 4.2 0 0 1-1.949.478q-1.043.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.37-2.295v-6.562h2.743V36.4q0 2.187.152 2.68.151.494.551.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798v-4.375h2.744v10.37zm7.718 0h-2.744V31.635h2.549v1.475q.654-1.046 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.316-.63 1.147t-.229 3.477zm7.034-5.186q0 1.544.732 2.363.734.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.245-.674-3.032m15.149-.029q0 1.749.693 2.582.694.836 1.69.836.958 0 1.592-.767t.634-2.514q0-1.632-.654-2.422t-1.62-.791q-1.008 0-1.67.776-.665.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.26 1.416 1.26 3.944 0 2.598-1.27 4.038-1.27 1.442-3.076 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.341-1.47-1.172v5.226h-2.744zm18.257 4.297q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.899 0-1.484.655-.585.654-.577 1.777zm-.156 2.773 2.734.459q-.526 1.505-1.665 2.29-1.138.786-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.528 1.339 1.529 1.28 4.683h-6.875q.03 1.22.664 1.899.634.68 1.582.679.645 0 1.084-.352.44-.351.664-1.133m10.84-1.68q-.528.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .578.43.996.429.42 1.093.42.743 0 1.416-.488.498-.371.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.923-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01M84 6.01h2.891v7.753q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.412q.698.532 1.909.532 1.23 0 1.855-.503t.752-1.235q.127-.733.127-2.432V6.01h2.891v7.52q0 2.578-.234 3.642-.235 1.066-.865 1.797-.63.732-1.684 1.167-1.055.435-2.754.435-2.05 0-3.11-.474t-1.675-1.23-.811-1.587q-.282-1.23-.283-3.633zm23.277 14.316h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.714 0-1.28.39t-.776 1.036-.21 2.383v4.697h-2.744V9.955h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.283 0h2.745V9.955h-2.745zm0-11.778h2.745V6.009h-2.745zm8.387.137 1.348-2.92h3.076l-2.686 2.92zm-1.152 6.455q0 1.544.732 2.363.732.82 1.807.821 1.074 0 1.801-.82.728-.822.728-2.383 0-1.524-.728-2.344-.727-.82-1.8-.82-1.076 0-1.808.82t-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.6 4.6 0 0 1 1.91-1.953q1.234-.674 2.758-.674 2.354 0 3.857 1.528 1.504 1.53 1.504 3.863 0 2.355-1.518 3.901-1.519 1.548-3.824 1.548-1.426 0-2.719-.645a4.4 4.4 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m21.985 5.332h-2.744v-5.293q-.001-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V9.955h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327.75.327 1.138.835.385.507.537 1.152.15.645.15 1.846z"></path></g>', 1), ht1 = [
  ct1
];
function ut1(t, e) {
  return T(), N("svg", ot1, [...ht1]);
}
const dt1 = { render: ut1 }, ft1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "163",
  height: "48",
  viewBox: "0 0 163 48"
}, vt1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84.117 42.006v-14.2h2.891v11.788h7.187v2.412zm12.119 0h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zm5.557 11.778h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zm10.312 1.407v2.188h-1.875v4.179q0 1.27.054 1.48t.244.346a.77.77 0 0 0 .464.137q.381 0 1.103-.264l.235 2.129q-.956.41-2.168.41-.742 0-1.338-.25-.597-.248-.874-.643-.28-.395-.386-1.07-.088-.477-.088-1.933v-4.521h-1.26v-2.188h1.26v-2.061l2.754-1.601v3.662zM84.03 20.326V6.01h10.615v2.421h-7.724v3.174h7.187v2.412h-7.187v3.897h7.998v2.412zm19.866 0v-1.553q-.567.83-1.489 1.31a4.2 4.2 0 0 1-1.949.477q-1.043 0-1.874-.459a2.7 2.7 0 0 1-1.202-1.289q-.37-.83-.37-2.295V9.955h2.743v4.766q0 2.188.152 2.68.151.495.551.781.4.289 1.016.29a2.16 2.16 0 0 0 1.26-.387q.556-.386.762-.957.204-.571.205-2.798V9.955h2.744v10.371zm7.718 0h-2.744V9.956h2.549v1.474q.654-1.046 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.317-.63 1.147t-.229 3.477zm7.034-5.186q0 1.544.732 2.363.734.821 1.807.822 1.074 0 1.802-.822.727-.819.727-2.383 0-1.521-.727-2.342-.728-.822-1.802-.822t-1.807.822-.732 2.362m-2.813-.145q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.527 1.504 1.53 1.504 3.864 0 2.353-1.519 3.9-1.52 1.549-3.823 1.549a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.89q-.674-1.245-.674-3.031m14.73.145q0 1.544.732 2.363.734.821 1.807.822 1.073 0 1.802-.822.727-.819.727-2.383 0-1.521-.727-2.342-.728-.822-1.802-.822t-1.807.822-.732 2.362m-2.812-.145q0-1.368.673-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.527 1.504 1.53 1.504 3.864 0 2.353-1.519 3.9-1.52 1.549-3.823 1.549a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.89q-.673-1.245-.673-3.031m15.148-.03q0 1.748.693 2.583.694.835 1.69.835.958 0 1.592-.767t.634-2.514q0-1.632-.654-2.422-.654-.792-1.62-.791-1.008 0-1.67.776-.665.777-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.26 1.416 1.26 3.945 0 2.598-1.27 4.038t-3.076 1.44a3.5 3.5 0 0 1-1.558-.341q-.698-.343-1.47-1.172v5.225h-2.744zm17.818 5.391q-.528.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .578.43.996.429.42 1.093.42.743 0 1.416-.488.498-.372.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.45q.42-1.502 1.445-2.225t3.047-.723q1.837 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.39h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.321q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.87-.923-.869-.923-2.197 0-.878.42-1.567.418-.689 1.176-1.055t2.183-.64q1.923-.36 2.666-.673v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288t-.664 1.01"></path></g>', 1), pt1 = [
  vt1
];
function mt1(t, e) {
  return T(), N("svg", ft1, [...pt1]);
}
const gt1 = { render: mt1 }, yt1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "175",
  height: "48",
  viewBox: "0 0 175 48"
}, _t1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M90.845 42.006v-1.553q-.567.83-1.49 1.309a4.2 4.2 0 0 1-1.948.478q-1.044.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.371-2.295v-6.562h2.744V36.4q0 2.187.152 2.68.151.494.55.78.402.29 1.017.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798v-4.375h2.744v10.37zm14.825 0h-2.745v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.714 0-1.28.39t-.776 1.036-.21 2.383v4.697h-2.744V31.635h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.282 0h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zm7.235 6.592q0 1.544.732 2.363.733.82 1.807.821 1.074 0 1.802-.82.727-.822.727-2.384 0-1.522-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.675-1.244-.674-3.032m21.786 5.332h-2.745v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V31.635h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.783 0h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zM84.03 20.326V6.01h10.616v2.421h-7.724v3.174h7.187v2.412h-7.187v3.897h7.998v2.412zm19.867 0v-1.553q-.566.83-1.49 1.309a4.2 4.2 0 0 1-1.948.478q-1.044 0-1.874-.459a2.7 2.7 0 0 1-1.202-1.289q-.37-.83-.371-2.295V9.955h2.744v4.766q0 2.187.152 2.68.151.494.55.781.402.288 1.017.289a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798V9.955h2.744v10.371zm7.718 0h-2.744V9.955h2.549v1.475q.654-1.046 1.175-1.377a2.16 2.16 0 0 1 1.188-.332q.938 0 1.806.517l-.85 2.393q-.694-.45-1.288-.45-.576 0-.977.318-.4.317-.63 1.147t-.23 3.477zm7.034-5.186q0 1.544.732 2.363.733.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m14.73.146q0 1.544.732 2.363.732.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.729-.82-1.802-.82-1.074 0-1.807.82t-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.675-1.244-.674-3.032m15.149-.029q0 1.748.693 2.583.694.835 1.69.835.957 0 1.592-.767.634-.767.634-2.514 0-1.632-.654-2.422t-1.621-.791q-1.007 0-1.67.776-.663.777-.664 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.259 1.416 1.259 3.945 0 2.598-1.27 4.038-1.269 1.44-3.075 1.44a3.5 3.5 0 0 1-1.558-.341q-.698-.343-1.47-1.172v5.225h-2.744zm17.817 5.391q-.528.175-1.67.42-1.143.243-1.494.477-.537.383-.537.968 0 .578.43.995.43.42 1.093.42.743 0 1.416-.488.498-.372.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.45q.42-1.502 1.445-2.226 1.026-.723 3.047-.723 1.836 0 2.734.435.9.435 1.265 1.104.366.668.366 2.456l-.029 3.203q0 1.368.132 2.017.132.65.493 1.39h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.703.683-1.504 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.869t-.923-2.198q0-.877.42-1.566t1.176-1.056q.758-.366 2.183-.639 1.923-.36 2.666-.674v-.274q0-.79-.39-1.127-.391-.336-1.475-.337-.733 0-1.143.288-.41.289-.664 1.01m18.706 7.208h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.391-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V9.955h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846z"></path></g>', 1), qt1 = [
  _t1
];
function wt1(t, e) {
  return T(), N("svg", yt1, [...qt1]);
}
const zt1 = { render: wt1 }, Mt1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "194",
  height: "48",
  viewBox: "0 0 194 48"
}, bt1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M90.182 35.932q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.654-.586.654-.577 1.777zm-.156 2.772 2.734.46q-.527 1.504-1.665 2.29-1.138.785-2.847.786-2.705 0-4.004-1.768-1.025-1.416-1.026-3.574 0-2.578 1.349-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.529t1.28 4.682h-6.875q.028 1.221.664 1.9.634.678 1.582.678.642 0 1.084-.352.44-.351.664-1.133m11.542 3.302v-1.553q-.567.83-1.489 1.309a4.2 4.2 0 0 1-1.949.478q-1.043.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.37-2.295v-6.562h2.743V36.4q0 2.187.152 2.68.151.494.551.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.557-.386.762-.957.205-.572.205-2.798v-4.375h2.744v10.37zm7.718 0h-2.744V31.635h2.549v1.475q.654-1.046 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.316-.63 1.147t-.229 3.477zm7.034-5.186q0 1.544.732 2.363.734.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.522-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.149-.03q0 1.748.693 2.583.694.835 1.69.835.958 0 1.592-.767.633-.766.634-2.514 0-1.632-.654-2.422t-1.62-.79q-1.008 0-1.67.775-.665.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.26 1.417 1.26 3.945 0 2.598-1.27 4.038t-3.076 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.744zm14.751-1.269 1.348-2.92h3.076l-2.686 2.92zm3.506 5.566q-.03-1.191-.615-1.81a1.9 1.9 0 0 0-1.426-.62q-.898 0-1.485.653-.586.655-.576 1.777zm-.156 2.774 2.734.46q-.527 1.502-1.665 2.29-1.138.785-2.847.785-2.704 0-4.004-1.768-1.025-1.415-1.025-3.574 0-2.579 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.528 1.339 1.53 1.28 4.683h-6.876q.03 1.22.665 1.9.633.678 1.582.678.645 0 1.084-.35.44-.353.664-1.134m11.279-2.773q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.899 0-1.484.654t-.577 1.777zm-.156 2.772 2.734.46q-.526 1.504-1.665 2.29-1.138.785-2.847.786-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.578 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.529 1.339 1.528 1.28 4.682h-6.875q.03 1.221.664 1.9t1.582.678q.645 0 1.084-.352.44-.351.664-1.133m14.15 3.302h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V31.635h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm11.717 0h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V31.635h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm8.746-6.074q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.899 0-1.484.654t-.577 1.777zm-.156 2.772 2.734.46q-.526 1.504-1.665 2.29-1.138.785-2.847.786-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.578 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.529 1.339 1.528 1.28 4.682h-6.875q.03 1.221.664 1.9t1.582.678q.645 0 1.084-.352.44-.351.664-1.133M84.01 6.01h2.892v7.754q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.412q.697.532 1.909.532 1.23 0 1.855-.503t.752-1.235q.127-.735.127-2.432V6.01h2.89v7.52q0 2.578-.233 3.642-.235 1.065-.865 1.797t-1.684 1.167-2.754.435q-2.05 0-3.11-.474t-1.675-1.231-.811-1.586q-.282-1.232-.283-3.633zm23.278 14.316h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.714 0-1.28.391-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V9.955h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327t1.138.835.537 1.152.151 1.846zm2.283 0h2.744V9.955h-2.744zm0-11.777h2.744V6.01h-2.744zm7.235 6.591q0 1.544.732 2.363.732.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m21.785 5.332h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.391-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V9.955h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846z"></path></g>', 1), Lt1 = [
  bt1
];
function xt1(t, e) {
  return T(), N("svg", Mt1, [...Lt1]);
}
const St1 = { render: xt1 }, Ct1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "186",
  height: "48",
  viewBox: "0 0 186 48"
}, kt1 = /* @__PURE__ */ C("g", { fill: "none" }, [
  /* @__PURE__ */ C("path", {
    fill: "#039",
    d: "M0 0h72v48H0z"
  }),
  /* @__PURE__ */ C("path", {
    fill: "#FC0",
    d: "M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"
  }),
  /* @__PURE__ */ C("path", {
    fill: "#515560",
    d: "M84 42.316V28h10.615v2.421h-7.724v3.174h7.187v2.412h-7.187v3.897h7.998v2.412zm14.899-5.186q0 1.544.731 2.364.734.82 1.808.82t1.801-.82q.728-.82.727-2.383.001-1.522-.727-2.343-.728-.82-1.802-.821-1.073 0-1.806.82-.733.821-.733 2.364m-2.812-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.234-.675 2.757-.674 2.354 0 3.858 1.528t1.505 3.863q0 2.353-1.52 3.9-1.52 1.55-3.822 1.549a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.89q-.675-1.245-.675-3.031m14.98 5.331h-2.745v-10.37h2.55v1.474q.653-1.045 1.175-1.377a2.16 2.16 0 0 1 1.188-.332q.937 0 1.806.517l-.85 2.393q-.693-.45-1.288-.45-.576 0-.977.318-.4.317-.63 1.147t-.23 3.477zm7.792-5.361q0 1.748.693 2.583.694.835 1.69.835.958 0 1.592-.767.633-.766.634-2.514 0-1.632-.654-2.422t-1.62-.79q-1.008 0-1.67.775-.665.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.26 1.417 1.26 3.945 0 2.598-1.27 4.038t-3.076 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.744zm17.918 5.391q-.527.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .577.43.996.429.42 1.093.42.743 0 1.416-.488.498-.371.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.836 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.924-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.923-.362 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288t-.664 1.01m17.615-.097-2.705.488q-.137-.81-.62-1.22-.483-.411-1.255-.411-1.026 0-1.636.708-.61.709-.61 2.369 0 1.845.62 2.607t1.665.762q.78 0 1.279-.445.499-.444.703-1.528l2.696.459q-.421 1.855-1.612 2.803-1.19.946-3.193.947-2.276 0-3.628-1.435t-1.352-3.975q0-2.568 1.357-4 1.357-1.43 3.672-1.43 1.894 0 3.013.816 1.117.815 1.606 2.485M152.617 28v5.264q1.328-1.553 3.174-1.553.947 0 1.71.351.761.352 1.146.899t.528 1.211q.141.664.141 2.06v6.084h-2.744v-5.478q0-1.631-.156-2.07a1.37 1.37 0 0 0-.552-.699q-.396-.258-.99-.258-.684 0-1.222.332t-.786 1.001-.249 1.977v5.195h-2.744V28zM90.87 15.336q-.527.175-1.67.42-1.143.244-1.494.478-.537.382-.537.967 0 .578.43.996.43.42 1.093.42.743 0 1.416-.488.498-.372.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.45q.42-1.502 1.445-2.225T89.2 9.71q1.837 0 2.734.435.9.434 1.265 1.103.366.67.366 2.456l-.029 3.203q0 1.368.132 2.017.132.65.493 1.39h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.321q-.703.683-1.504 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.87-.923-.869-.923-2.197 0-.879.42-1.567.42-.689 1.176-1.055.758-.366 2.183-.64 1.923-.36 2.666-.673v-.274q0-.79-.39-1.127-.391-.337-1.475-.337-.733 0-1.143.288t-.664 1.01m18.315 7.208h-2.744v-5.293q-.001-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.713 0-1.28.391-.567.39-.776 1.035t-.21 2.383v4.697H96.06V9.945h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327.75.327 1.138.835.385.507.537 1.152.15.645.15 1.846zm13.495-10.371v2.188h-1.875v4.179q0 1.27.054 1.48t.244.346a.77.77 0 0 0 .464.137q.381 0 1.103-.264l.235 2.129q-.957.41-2.168.41-.743 0-1.338-.25-.597-.248-.874-.643-.28-.395-.386-1.07-.089-.477-.088-1.933v-4.521h-1.26V9.945h1.26V7.884l2.754-1.601v3.662zm9.912 4.707-1.973-5.312-1.933 5.312zm5.322 5.664h-3.144l-1.25-3.252h-5.723l-1.182 3.252h-3.066L125.453 6h3.057zm3.192-5.186q0 1.544.732 2.363.733.822 1.807.822t1.802-.822q.727-.819.727-2.382 0-1.524-.727-2.344-.728-.82-1.802-.82t-1.807.82q-.732.82-.732 2.364m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.675 2.758-.675 2.354 0 3.858 1.528 1.504 1.53 1.504 3.864 0 2.353-1.52 3.9-1.518 1.55-3.822 1.549a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.89q-.674-1.245-.674-3.031m21.785 5.331h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.391-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V9.945h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm7.539-10.371v2.188h-1.875v4.179q0 1.27.054 1.48t.244.346a.77.77 0 0 0 .464.137q.381 0 1.103-.264l.235 2.129q-.957.41-2.168.41-.742 0-1.338-.25-.597-.248-.874-.643-.28-.395-.386-1.07-.088-.477-.088-1.933v-4.521h-1.26V9.945h1.26V7.884l2.754-1.601v3.662zm7.827 5.391q-.526.175-1.67.42-1.142.244-1.494.478-.536.382-.536.967-.001.578.43.996.428.42 1.092.42.743 0 1.416-.488.498-.372.656-.908.105-.352.106-1.338zm-3.671-2.227-2.49-.45q.42-1.502 1.445-2.225t3.047-.723q1.836 0 2.733.435.9.434 1.265 1.103.367.67.367 2.456l-.03 3.203q0 1.368.132 2.017.132.65.494 1.39h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.321q-.704.683-1.505 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.87-.923-.869-.923-2.197 0-.879.42-1.567.42-.689 1.176-1.055.758-.366 2.183-.64 1.924-.36 2.666-.673v-.274q0-.79-.39-1.127t-1.475-.337q-.733 0-1.143.288t-.663 1.01m8.105 4.248 2.754-.42q.175.802.713 1.216.538.415 1.504.415 1.064 0 1.601-.39a.87.87 0 0 0 .362-.733.72.72 0 0 0-.196-.518q-.204-.195-.918-.36-3.32-.733-4.209-1.339-1.23-.84-1.23-2.334 0-1.347 1.064-2.266 1.065-.916 3.301-.917 2.13 0 3.164.693 1.036.693 1.426 2.051l-2.588.478q-.165-.606-.63-.928t-1.323-.322q-1.084 0-1.553.303-.312.216-.312.557 0 .293.273.498.37.274 2.564.771 2.193.499 3.061 1.221.86.732.86 2.041 0 1.425-1.192 2.451t-3.525 1.025q-2.12 0-3.355-.859a3.96 3.96 0 0 1-1.616-2.334"
  })
], -1), Et1 = [
  kt1
];
function At1(t, e) {
  return T(), N("svg", Ct1, [...Et1]);
}
const Ft1 = { render: At1 }, Tt1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, It1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M93.336 8.99h-1.791v8.89h-3.05V8.99h-6.297V6.361h11.138zm5.146-2.628v11.519h-3.138V6.362zm13.7 11.518h-3.04v-6.046q0-1.51-.662-2.291-.662-.782-2.432-.782-.944 0-1.574.12v9h-3.05V6.59a25 25 0 0 1 4.244-.36q2.748 0 4.072.674 1.335.673 1.888 1.791.555 1.107.554 2.964zm6.08-11.518v6.427h-3.138V6.362zm10.682 6.622 3.474 4.897h-3.583l-4.027-5.69q-.76.75-.956 3.399l-.173 2.29h-2.953l.217-2.442q.217-2.486.847-3.572t1.596-1.682l-2.682-3.822h3.572l3.333 4.712q.846-.62 1.031-2.823l.152-1.889h2.822l-.13 1.4q-.228 2.444-.847 3.485a5.4 5.4 0 0 1-1.693 1.737M145 17.88h-3.04v-5.427q0-2.118-1.053-2.92-1.042-.816-3.148-.815-1.574 0-3.431.271l-.217-2.442q1.77-.315 4.18-.315 2.616 0 4.049.76 1.434.75 2.041 1.889.62 1.129.619 3.126zm-7.708-5.981v5.982h-3.05v-5.982zM81.46 26.076v6.427h-3.138v-6.427zm2.855.358a16 16 0 0 1 4.18-.553q3.027 0 4.82 1.596 1.8 1.585 1.801 4.114 0 2.941-1.954 4.56-1.954 1.617-5.113 1.617-1.986 0-4.028-.727l.598-2.052q1.65.63 3.137.63 1.9 0 3.04-.977 1.14-.99 1.14-2.92 0-1.77-.923-2.78t-2.595-1.01q-.608 0-1.237.12v1.335q0 1.585 1.27 1.585.174 0 .39-.022l.51 1.89a4.3 4.3 0 0 1-1.682.325 4.2 4.2 0 0 1-1.596-.304q-.738-.303-1.248-1.075-.51-.77-.51-2.66zm16.273-.358v11.518H97.45V26.076zm11.714 11.518h-3.04v-5.667q0-1.846-.923-2.638-.912-.792-2.909-.792-1.021 0-2.704.206l-.227-2.399q1.563-.358 3.604-.358 3.093 0 4.646 1.292 1.553 1.291 1.553 4.136zm5.96-11.518v6.427h-3.138v-6.427zm10.682 6.622 3.474 4.896h-3.583l-4.027-5.688q-.76.75-.956 3.398l-.173 2.29h-2.953l.217-2.442q.217-2.486.847-3.572t1.596-1.683l-2.682-3.821h3.572l3.333 4.712q.846-.62 1.031-2.823l.152-1.889h2.822l-.13 1.4q-.228 2.443-.847 3.485a5.4 5.4 0 0 1-1.693 1.737M145 37.594h-3.04v-5.428q0-2.116-1.053-2.92-1.042-.814-3.148-.814-1.574 0-3.431.271l-.217-2.442q1.77-.315 4.18-.315 2.616 0 4.049.76 1.434.75 2.041 1.889.62 1.129.619 3.126zm-7.708-5.981v5.981h-3.05v-5.981z"
}, null, -1), Ot1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M153 0h66v44h-66z"
}, null, -1), Nt1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m183.745 7.15 1.393 1.018-.531 1.659L186 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L186 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.018h-1.723l-.532-1.66-.532 1.66h-1.723l1.393 1.017-.531 1.65L186 37.482zm-15.638-15.4-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.027.531 1.65-1.393-1.027zm8.516-11.367-.532-1.65 1.394-1.008h-1.724l-.531-1.65-.532 1.65h-1.723l1.393 1.017-.532 1.65 1.394-1.017zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm0 14.337h-1.779l1.394 1.026-.532 1.65 1.403-1.017 1.402 1.018-.532-1.65 1.394-1.027h-1.678l-.541-1.65zm4.849 6.27-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.761-.531-1.65 1.393-1.027h-1.687l-.531-1.65-.532 1.65h-1.787l1.402 1.027-.532 1.65 1.412-1.027zm-9.377-14.08-1.393-1.01h1.723l.532-1.65.531 1.65h1.724l-1.394 1.01.532 1.65-1.393-1.01-1.394 1.018.532-1.65zm6.041 2.575-.541 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.577 15.996h1.678L199.2 29.68l.532 1.65-1.394-1.017-1.402 1.018.532-1.65-1.385-1.027h1.724l.541-1.65zm-4.895 6.27 1.394-1.008h-1.724l-.531-1.65-.532 1.65h-1.723l1.393 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), Pt1 = [
  It1,
  Ot1,
  Nt1
];
function Bt1(t, e) {
  return T(), N("svg", Tt1, [...Pt1]);
}
const Vt1 = { render: Bt1 }, Rt1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "48",
  viewBox: "0 0 173 48"
}, Ht1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M90.846 42.006v-1.553q-.567.83-1.49 1.308a4.2 4.2 0 0 1-1.948.478q-1.044.001-1.874-.458a2.7 2.7 0 0 1-1.202-1.29q-.37-.829-.371-2.294v-6.563h2.744v4.767q0 2.186.152 2.68.151.494.55.78.402.29 1.017.29a2.16 2.16 0 0 0 1.26-.387q.556-.386.762-.957.204-.571.205-2.797v-4.375h2.744v10.37zm14.524 0h-2.744v-5.294q0-1.68-.176-2.172a1.53 1.53 0 0 0-.571-.767q-.396-.274-.952-.274-.714 0-1.28.392-.567.39-.776 1.035t-.21 2.383v4.697h-2.744V31.633h2.549v1.523q1.357-1.756 3.418-1.756.908 0 1.66.326.752.328 1.138.835.385.508.537 1.153.15.644.151 1.845zm2.583-.001h2.744V31.634h-2.744zm0-11.777h2.744v-2.539h-2.744zm5.498 0h2.744v-2.539h-2.744zm2.744 1.406v10.049q0 1.983-.259 2.798a2.27 2.27 0 0 1-.996 1.275q-.737.458-1.88.458-.41 0-.883-.073a10 10 0 0 1-1.021-.219l.479-2.344q.194.039.366.063.171.025.317.025.42 0 .689-.181a.87.87 0 0 0 .356-.435q.088-.254.088-1.523v-9.893zm8.594 5.391q-.528.175-1.67.42-1.143.244-1.494.478-.537.382-.537.967 0 .578.43.996.429.42 1.093.42.742 0 1.416-.488.498-.371.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.923-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.922-.362 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288t-.664 1.01M84.03 20.326V6.01h10.615v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm19.866 0v-1.553q-.567.83-1.489 1.309a4.2 4.2 0 0 1-1.949.478q-1.043.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.37-2.295V9.955h2.743v4.766q0 2.188.152 2.68.151.494.551.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798V9.955h2.744v10.37zm7.718 0h-2.744V9.955h2.55v1.475q.653-1.045 1.175-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.316-.63 1.147t-.229 3.477zm7.034-5.186q0 1.544.732 2.363.734.82 1.807.821 1.073 0 1.802-.82.727-.821.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.149-.029q0 1.748.693 2.582.694.836 1.69.835.958 0 1.592-.767.633-.765.634-2.513 0-1.632-.654-2.422t-1.62-.791q-1.008 0-1.67.776-.665.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.807 0 3.067 1.415 1.26 1.417 1.26 3.946 0 2.597-1.27 4.038-1.27 1.44-3.076 1.44a3.5 3.5 0 0 1-1.558-.341q-.698-.344-1.47-1.172v5.225h-2.744zm11.128 7.412 2.754-.42q.175.8.713 1.216t1.504.415q1.065 0 1.601-.391a.87.87 0 0 0 .362-.732.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.732-4.209-1.338-1.23-.84-1.23-2.334 0-1.348 1.064-2.266t3.301-.917q2.13 0 3.164.693 1.036.694 1.426 2.05l-2.588.479q-.165-.606-.63-.928-.463-.322-1.323-.322-1.084 0-1.553.303-.312.215-.312.557 0 .292.273.498.37.273 2.564.77 2.193.5 3.061 1.222.86.732.86 2.04 0 1.426-1.192 2.452t-3.525 1.025q-2.12 0-3.355-.86a3.96 3.96 0 0 1-1.616-2.333m11.593 2.959V6.01h2.743v7.597l3.213-3.652h3.38l-3.546 3.789 3.8 6.582h-2.96l-2.608-4.658-1.279 1.338v3.32zm16.943-4.981q-.528.175-1.67.42-1.144.244-1.494.478-.537.382-.537.967 0 .578.43.996.428.42 1.093.42.742 0 1.416-.488.498-.372.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226 1.024-.723 3.046-.723 1.838 0 2.734.435.9.434 1.266 1.103.365.67.365 2.456l-.029 3.203q0 1.368.132 2.017.133.65.494 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.924-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.922-.361 2.666-.674v-.274q0-.79-.392-1.127-.39-.337-1.474-.337-.731 0-1.142.288-.41.289-.665 1.01"></path></g>', 1), Dt1 = [
  Ht1
];
function $t1(t, e) {
  return T(), N("svg", Rt1, [...Dt1]);
}
const Ut1 = { render: $t1 }, jt1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "156",
  height: "48",
  viewBox: "0 0 156 48"
}, Gt1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84.02 27.69h2.89v7.753q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.413q.698.532 1.91.532 1.23 0 1.854-.504t.752-1.235.127-2.431v-7.92h2.891v7.52q0 2.577-.234 3.642t-.865 1.797q-.629.732-1.684 1.166-1.054.436-2.754.436-2.05 0-3.11-.474-1.06-.475-1.675-1.232-.615-.755-.81-1.586-.284-1.23-.284-3.633zm23.277 14.316h-2.745v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.396-.274-.953-.274-.712 0-1.28.39-.565.39-.775 1.036-.21.645-.21 2.383v4.697h-2.745V31.635h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.283 0h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zm8.386.137 1.348-2.92h3.076l-2.686 2.92zm-1.152 6.455q0 1.544.732 2.363.733.82 1.807.821 1.074 0 1.801-.82.729-.822.728-2.383 0-1.524-.728-2.344-.727-.82-1.8-.82-1.076 0-1.808.82t-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.6 4.6 0 0 1 1.91-1.953q1.234-.674 2.758-.674 2.354 0 3.857 1.528 1.504 1.53 1.504 3.863 0 2.355-1.518 3.901-1.519 1.548-3.824 1.548-1.425 0-2.719-.645a4.4 4.4 0 0 1-1.968-1.889q-.674-1.245-.674-3.032M84.03 20.326V6.01h10.616v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm19.867 0v-1.553q-.567.83-1.489 1.309a4.2 4.2 0 0 1-1.949.478q-1.044.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.371-2.295V9.955h2.744v4.766q0 2.188.152 2.68.151.494.551.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798V9.955h2.744v10.37zm7.718 0h-2.744V9.955h2.549v1.475q.654-1.046 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.29-.45-.576 0-.976.318-.399.316-.63 1.147t-.23 3.477zm8.186-11.641 1.348-2.92h3.076l-2.686 2.92zm-1.152 6.455q0 1.544.732 2.363.732.82 1.807.821 1.074 0 1.801-.82.728-.822.728-2.383 0-1.524-.728-2.344t-1.8-.82q-1.076 0-1.808.82t-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.6 4.6 0 0 1 1.91-1.953q1.233-.674 2.758-.674 2.354 0 3.857 1.528 1.504 1.53 1.504 3.863 0 2.355-1.518 3.901-1.519 1.548-3.824 1.548-1.425 0-2.719-.645a4.4 4.4 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.149-.03q0 1.748.693 2.583.694.835 1.69.835.957 0 1.592-.767.634-.766.634-2.514 0-1.632-.654-2.422t-1.621-.79q-1.007 0-1.67.775-.664.777-.664 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.259 1.417 1.259 3.945 0 2.598-1.27 4.038-1.269 1.441-3.075 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.744zm17.818 5.391q-.528.176-1.67.42-1.144.244-1.495.478-.536.382-.536.967-.001.578.43.996.428.42 1.093.42.741 0 1.416-.488.498-.372.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226 1.024-.723 3.046-.723 1.837 0 2.734.435.9.434 1.265 1.103.367.67.367 2.456l-.03 3.203q0 1.368.132 2.017.132.65.494 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.505 1.025a4.3 4.3 0 0 1-1.709.342q-1.6 0-2.524-.869-.923-.87-.923-2.198 0-.879.42-1.567t1.176-1.055q.757-.366 2.184-.639 1.922-.361 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.475-.337-.733 0-1.143.288-.41.289-.663 1.01m9.272 7.208h2.744V9.955h-2.744zm0-11.778h2.744V6.009h-2.744z"></path></g>', 1), Wt1 = [
  Gt1
];
function Yt1(t, e) {
  return T(), N("svg", jt1, [...Wt1]);
}
const Xt1 = { render: Yt1 }, Kt1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, Zt1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), Jt1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), Qt1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M77.309 19V6.115h9.553v2.18H79.91v2.856h6.469v2.171H79.91v3.507h7.198V19zm14.554 0-3.761-9.334h2.592l1.758 4.764.51 1.59q.203-.605.255-.8.123-.395.264-.79l1.775-4.764h2.54L94.086 19zm9.818 0h-2.47V9.666h2.294v1.327q.588-.94 1.055-1.24.474-.297 1.072-.298.843 0 1.626.466l-.765 2.153q-.624-.405-1.16-.404-.519 0-.879.29-.36.281-.571 1.028-.202.747-.202 3.13zm4.078-4.799q0-1.23.606-2.382a4.2 4.2 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.12 0 3.472 1.38 1.353 1.37 1.354 3.472 0 2.118-1.371 3.515-1.363 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.767-1.696q-.606-1.125-.606-2.734m2.531.132q0 1.389.659 2.127.66.738 1.626.738.967 0 1.617-.738.66-.738.66-2.145 0-1.371-.66-2.109-.65-.738-1.617-.738-.966 0-1.626.738t-.659 2.127m1.037-5.81 1.213-2.627h2.769l-2.417 2.627zm7.937 1.143h2.302v1.371q.449-.704 1.213-1.142a3.34 3.34 0 0 1 1.697-.44q1.626 0 2.759 1.274t1.134 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.319-1.054v4.702h-2.469zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.86 0 1.432-.686.571-.694.571-2.267 0-1.468-.588-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066M134.481 19v-1.398q-.51.748-1.344 1.178a3.7 3.7 0 0 1-1.749.43 3.43 3.43 0 0 1-1.688-.412 2.44 2.44 0 0 1-1.081-1.16q-.334-.747-.334-2.066V9.666h2.47v4.29q0 1.968.132 2.416.14.44.501.703.36.255.914.255.633 0 1.134-.343a1.8 1.8 0 0 0 .685-.861q.185-.519.185-2.523V9.667h2.469V19zm3.991-2.663 2.478-.378q.159.72.642 1.099.483.369 1.353.369.958 0 1.442-.352a.78.78 0 0 0 .325-.659.65.65 0 0 0-.176-.466q-.184-.175-.826-.325-2.988-.659-3.788-1.204-1.107-.756-1.108-2.1 0-1.214.958-2.04.958-.825 2.971-.826 1.917 0 2.848.624.932.624 1.283 1.846l-2.329.43q-.15-.544-.571-.835-.413-.29-1.187-.29-.975 0-1.397.273-.282.194-.282.5 0 .265.246.45.335.245 2.303.694 1.978.448 2.76 1.098.773.66.773 1.837 0 1.282-1.072 2.206t-3.173.923q-1.907 0-3.023-.773a3.57 3.57 0 0 1-1.45-2.101m12.735-3.823-2.241-.405q.377-1.353 1.301-2.004.923-.65 2.742-.65 1.652 0 2.461.396.808.386 1.134.993.334.597.334 2.206l-.027 2.883q0 1.23.114 1.819.123.58.449 1.248h-2.444a9 9 0 0 1-.237-.73 4 4 0 0 0-.088-.29q-.633.615-1.353.923a3.9 3.9 0 0 1-1.539.308q-1.44 0-2.276-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.968-.58 1.732-.324 2.4-.606v-.246q0-.712-.352-1.01-.352-.309-1.327-.308-.659 0-1.028.263-.37.255-.598.906m3.305 2.004q-.476.158-1.503.377-1.029.22-1.345.431-.483.343-.483.87 0 .519.386.897.387.378.985.378.668 0 1.274-.44.448-.334.589-.817.096-.316.097-1.204zm4.684-4.852h2.277v1.274q1.221-1.485 2.909-1.485.896 0 1.556.37.658.368 1.081 1.115.615-.747 1.327-1.116.711-.369 1.52-.369 1.029 0 1.74.422.713.413 1.064 1.222.255.598.255 1.933V19h-2.47v-5.335q0-1.388-.255-1.793-.343-.527-1.054-.527-.519 0-.976.316-.457.317-.659.932-.202.606-.202 1.925V19h-2.47v-5.115q0-1.362-.132-1.758t-.413-.589q-.273-.193-.747-.193-.572 0-1.028.307a1.7 1.7 0 0 0-.66.888q-.193.58-.193 1.925V19h-2.47zM77.188 38V25.115h2.47v4.64q1.14-1.3 2.706-1.3 1.705 0 2.822 1.24 1.116 1.23 1.116 3.541 0 2.391-1.143 3.683-1.134 1.292-2.76 1.292-.8 0-1.582-.396a3.8 3.8 0 0 1-1.336-1.186V38zm2.452-4.87q0 1.451.457 2.145.641.985 1.705.985.818 0 1.388-.695.58-.703.58-2.206 0-1.6-.58-2.302-.579-.712-1.485-.712-.888 0-1.477.694-.588.685-.588 2.092m10.503-1.617-2.242-.405q.378-1.353 1.301-2.004.923-.65 2.742-.65 1.653 0 2.461.396.81.386 1.134.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.237-.73 4 4 0 0 0-.088-.29q-.633.615-1.354.923-.72.308-1.538.308-1.441 0-2.276-.782-.826-.783-.826-1.978 0-.79.377-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.4-.606v-.246q0-.711-.352-1.01-.352-.309-1.327-.308-.66 0-1.029.263-.369.255-.597.906m3.304 2.004q-.474.158-1.503.377-1.028.22-1.344.431-.484.343-.484.87 0 .519.387.897t.984.378q.668 0 1.275-.44.448-.334.589-.817.096-.316.096-1.204zM106.807 38h-2.47v-4.764q0-1.512-.158-1.95a1.37 1.37 0 0 0-.519-.695q-.351-.246-.852-.246-.642 0-1.152.351-.51.352-.703.932-.184.58-.184 2.145V38h-2.47v-9.334h2.294v1.371q1.222-1.582 3.076-1.582.818 0 1.494.299.676.29 1.02.747.351.457.483 1.037.141.58.141 1.661zm11.074 0h-2.294v-1.371q-.571.8-1.354 1.195a3.46 3.46 0 0 1-1.564.387q-1.608 0-2.76-1.292-1.142-1.3-1.142-3.621 0-2.373 1.116-3.604 1.116-1.239 2.821-1.239 1.564 0 2.707 1.3v-4.64h2.47zm-6.592-4.87q0 1.496.413 2.163.598.967 1.67.967.853 0 1.45-.72.598-.73.598-2.172 0-1.608-.58-2.311-.58-.712-1.486-.712-.878 0-1.476.703-.59.694-.589 2.083m9.035-5.731v-2.285h2.47V27.4zm0 10.6v-9.334h2.47V38zm6.636-12.885h2.575q.5.387.958.783l1.591-.783.395.862-1.265.588q1.688 1.697 2.417 3.41.738 1.705.738 3.226 0 2.268-1.353 3.648-1.355 1.37-3.498 1.37-2.065 0-3.411-1.362-1.335-1.37-1.336-3.542 0-2.135 1.424-3.506 1.187-1.143 2.672-1.143.475 0 .958.14.353.106.993.466-.343-.615-.571-.957-.228-.344-.712-.95l-2.197 1.046-.378-.844 1.916-.905a20 20 0 0 0-1.916-1.547m.387 8.227q0 1.396.632 2.136.642.729 1.565.729.94 0 1.6-.738.659-.738.659-2.04 0-1.308-.677-2.065-.676-.756-1.6-.756-.905 0-1.547.721-.632.713-.632 2.013"
}, null, -1), e41 = [
  Zt1,
  Jt1,
  Qt1
];
function t41(t, e) {
  return T(), N("svg", Kt1, [...e41]);
}
const n41 = { render: t41 }, i41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "160",
  height: "48",
  viewBox: "0 0 160 48"
}, s41 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M90.182 35.932q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.526 1.505-1.665 2.29-1.139.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528t1.28 4.683h-6.875q.028 1.22.664 1.899.634.68 1.582.679.643 0 1.084-.352.44-.351.664-1.133m11.643 3.301v-1.553q-.566.83-1.49 1.309a4.2 4.2 0 0 1-1.948.478q-1.044.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.371-2.295v-6.562h2.744V36.4q0 2.187.152 2.68.151.494.55.78.402.29 1.017.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798v-4.375h2.744v10.37zm7.718 0h-2.744V31.635h2.549v1.475q.654-1.046 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.29-.45-.576 0-.976.318-.399.316-.63 1.147t-.23 3.477zm7.033-5.186q0 1.544.732 2.363.733.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.245-.674-3.032m15.149-.029q0 1.749.693 2.582.694.836 1.69.836.957 0 1.592-.767.634-.767.634-2.514 0-1.632-.654-2.422-.654-.792-1.621-.791-1.007 0-1.67.776t-.664 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.489q1.806 0 3.067 1.417 1.259 1.416 1.259 3.944 0 2.599-1.27 4.038-1.269 1.442-3.075 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.341-1.47-1.172v5.226h-2.744zm18.257 4.297q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.527 1.505-1.665 2.29-1.138.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528t1.28 4.683h-6.875q.028 1.22.664 1.899.634.68 1.582.679.643 0 1.084-.352.44-.351.664-1.133m10.839-1.68q-.528.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .577.43.996t1.093.42q.743 0 1.416-.488.498-.371.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.9.435 1.265 1.103.366.67.366 2.456l-.029 3.203q0 1.368.132 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.703.683-1.504 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.869-.923-.87-.923-2.198 0-.879.42-1.567t1.176-1.055q.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.39-1.127-.391-.337-1.475-.337-.733 0-1.143.288-.41.289-.664 1.01M84.01 6.01h2.892v7.753q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.412q.697.532 1.909.532 1.23 0 1.855-.503t.752-1.235q.127-.733.127-2.432V6.01h2.89v7.52q0 2.578-.233 3.642-.235 1.066-.865 1.797-.63.733-1.684 1.167t-2.754.435q-2.05 0-3.11-.474t-1.675-1.23-.811-1.587q-.282-1.23-.283-3.633zm23.278 14.316h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766 1.64 1.64 0 0 0-.952-.274q-.714 0-1.28.39a1.97 1.97 0 0 0-.776 1.036q-.21.645-.21 2.383v4.697h-2.744V9.955h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327.752.328 1.138.835.385.508.537 1.152.15.645.151 1.846zm2.283 0h2.744V9.955h-2.744zm0-11.778h2.744V6.009h-2.744zm7.235 6.592q0 1.544.732 2.363.732.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.367.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m21.785 5.332h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766 1.64 1.64 0 0 0-.953-.274q-.713 0-1.28.39a1.97 1.97 0 0 0-.776 1.036q-.21.645-.21 2.383v4.697h-2.744V9.955h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.328 1.138.835.385.508.537 1.152.15.645.151 1.846zm8.946-6.075q-.03-1.19-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9.001-1.484.655-.586.655-.577 1.777zm-.156 2.773 2.734.46q-.526 1.503-1.665 2.29-1.138.786-2.847.786-2.704 0-4.003-1.768-1.026-1.415-1.026-3.574 0-2.578 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528 1.338 1.53 1.28 4.683h-6.875q.028 1.22.664 1.9.634.678 1.582.678.643 0 1.084-.352.44-.35.664-1.133"></path></g>', 1), l41 = [
  s41
];
function r41(t, e) {
  return T(), N("svg", i41, [...l41]);
}
const a41 = { render: r41 }, o41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, c41 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), h41 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), u41 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M80.112 19.772c.936.864 1.92 1.872 2.856 2.904-.768 1.8-1.728 3.384-2.856 4.608zm13.848-1.32h2.472c-.24 1.464-.552 2.976-.888 4.08l1.632.888c.696-1.68 1.296-4.296 1.656-6.576l-1.512-.576-.36.144h-5.736c.288-1.272.528-2.592.72-3.912l-2.232-.36c-.48 3.792-1.344 7.512-2.904 9.84.552.288 1.464 1.056 1.824 1.416.84-1.32 1.512-3.024 2.064-4.944h1.08v3.096c.024 1.776-.576 5.928-3.576 9v-1.272h-8.088v-1.944c.456.336 1.296 1.008 1.608 1.392 1.032-1.2 1.92-2.664 2.688-4.296.864 1.056 1.56 2.064 2.04 2.928l1.416-1.656c-.552-.984-1.488-2.184-2.568-3.408.672-1.776 1.2-3.696 1.608-5.712l-2.04-.336a34 34 0 0 1-1.128 4.344 56 56 0 0 0-2.448-2.376l-1.176 1.296v-3.816h7.92v-2.064H78v19.464h2.112v-1.728h7.2c-.408.336-.84.648-1.32.936.408.408 1.032 1.368 1.296 1.824 3.72-2.304 5.256-6.456 5.568-8.496.312 1.968 1.656 6.312 4.944 8.496.336-.528.984-1.44 1.392-1.92-4.392-2.928-5.232-8.568-5.232-10.656zm11.712-5.88v7.44c0 4.272-.432 9-4.296 12.432.48.384 1.272 1.176 1.584 1.728 4.392-3.888 4.92-9.216 4.92-14.16v-7.44zm6.72.528v19.488h2.184V13.1zm6.96-.6v21.432h2.232V12.5zm-16.536 5.496c-.336 2.184-1.056 4.752-2.064 6.432l1.92.792c1.032-1.704 1.656-4.488 2.064-6.696zm5.232 1.128c.816 1.992 1.584 4.536 1.776 6.12l1.92-.864c-.216-1.56-1.032-4.032-1.896-5.952zm6.672-.048c1.056 1.872 2.112 4.392 2.472 5.976l1.824-1.008c-.36-1.536-1.512-3.96-2.616-5.832zm19.8 4.512v-1.584h3.144v1.584zm0-4.68h3.144v1.56h-3.144zm8.544 0v1.56h-3.24v-1.56zm0 4.68h-3.24v-1.584h3.24zm-5.4 7.368h2.16v-2.52h6.864v-1.824h-6.864v-1.416h5.376v-7.872h-5.376v-1.368h6.528v-1.848h-6.528v-1.944h-2.16v1.944h-6.24v1.848h6.24v1.368h-5.208v7.872h5.208v1.416h-6.576v1.824h6.576zm-6.816-14.352c-.72-1.176-2.4-2.76-3.792-3.84l-1.704 1.248c1.416 1.152 3.024 2.808 3.696 4.008zm-.648 4.872h-5.016v2.064h2.88v5.784a33 33 0 0 1-3.144 2.448l1.104 2.208a82 82 0 0 0 3.24-2.976c1.464 1.848 3.528 2.64 6.504 2.76 2.784.096 7.872.048 10.632-.072.12-.648.456-1.68.72-2.184-3.048.216-8.616.288-11.328.168-2.664-.12-4.56-.864-5.592-2.52zm35.016 5.112v4.704h-10.32v-4.704zm-12.504 7.632h2.184v-.936h10.32v.936h2.28v-9.648h-14.784zm1.848-14.352c2.256-1.728 4.176-3.696 5.4-5.472 1.344 1.848 3.408 3.792 5.664 5.472zm4.152-7.656c-1.824 3-5.76 6.6-9.864 8.688.456.456 1.104 1.248 1.368 1.776 1.32-.72 2.64-1.536 3.864-2.448v1.632h11.952v-1.704a31 31 0 0 0 3.888 2.424c.384-.672.912-1.44 1.464-1.992-3.768-1.632-7.824-4.8-10.392-8.376z"
}, null, -1), d41 = [
  c41,
  h41,
  u41
];
function f41(t, e) {
  return T(), N("svg", o41, [...d41]);
}
const v41 = { render: f41 }, p41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, m41 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M78.018 18.5V5.615h9.553v2.18H80.62v2.856h6.469v2.171H80.62v3.507h7.198V18.5zm18.132 0v-1.398q-.51.748-1.345 1.178-.826.43-1.75.43-.94 0-1.687-.412a2.44 2.44 0 0 1-1.08-1.16q-.335-.747-.335-2.066V9.166h2.47v4.29q0 1.968.132 2.416.14.44.5.703.36.255.915.255.633 0 1.133-.343.502-.351.686-.861.185-.518.185-2.522V9.166h2.47V18.5zm7.224 0h-2.47V9.166h2.294v1.327q.589-.94 1.055-1.24a1.97 1.97 0 0 1 1.072-.298q.844 0 1.626.466l-.764 2.153q-.624-.405-1.161-.404a1.36 1.36 0 0 0-.879.29q-.36.281-.571 1.028-.202.747-.202 3.13zm4.078-4.799q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.757q1.117-.607 2.488-.607 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.125-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m8.974-4.667h2.303v1.371q.448-.704 1.213-1.142a3.34 3.34 0 0 1 1.696-.44q1.626 0 2.76 1.274t1.133 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.318-1.054v4.702h-2.47zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.861 0 1.433-.686.57-.694.571-2.267 0-1.468-.589-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.597.695-.598 2.066m10.477-1.661-2.241-.405q.377-1.353 1.301-2.004.923-.65 2.742-.65 1.652 0 2.461.396.809.386 1.133.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.449 1.248H135.7a9 9 0 0 1-.237-.73 4 4 0 0 0-.088-.29 4.5 4.5 0 0 1-1.354.923q-.72.308-1.538.308-1.441 0-2.276-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.054-.95q.687-.333 1.969-.58 1.732-.324 2.4-.606v-.246q0-.712-.352-1.01-.352-.309-1.327-.308-.66 0-1.028.263-.37.255-.598.906m3.305 2.004q-.476.158-1.503.377-1.029.22-1.345.431-.483.344-.483.87 0 .519.386.897.387.378.985.378.668 0 1.274-.44.448-.334.589-.817.096-.316.097-1.204zm-4.369-6.504V5.396h2.119v2.118zm3.78 0V5.396h2.127v2.118zm10.863 8.016 2.461.412q-.474 1.354-1.503 2.066-1.02.703-2.558.703-2.435 0-3.603-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.067-1.318 2.084 0 3.287 1.38 1.204 1.37 1.152 4.21h-6.188q.027 1.098.598 1.714.571.606 1.424.606.58 0 .975-.316.396-.316.598-1.02m.141-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.809 0-1.336.589-.528.588-.519 1.6zm3.603 2.805 2.479-.378q.158.72.641 1.099.484.369 1.354.369.958 0 1.441-.352a.78.78 0 0 0 .325-.659.65.65 0 0 0-.175-.466q-.185-.175-.827-.325-2.987-.659-3.788-1.204-1.107-.756-1.107-2.1 0-1.214.958-2.04t2.971-.826q1.915 0 2.847.624t1.284 1.846l-2.33.43a1.43 1.43 0 0 0-.571-.835q-.413-.29-1.186-.29-.977 0-1.398.273-.28.194-.281.5 0 .265.246.45.334.245 2.303.694 1.977.448 2.76 1.098.773.66.773 1.837 0 1.282-1.072 2.206t-3.173.923q-1.907 0-3.024-.773a3.57 3.57 0 0 1-1.45-2.101m19.029-3.911-2.435.44q-.123-.73-.563-1.1-.43-.368-1.125-.368-.923 0-1.476.641-.545.632-.545 2.127 0 1.661.554 2.347.563.685 1.503.685.702 0 1.151-.395.448-.405.633-1.38l2.426.413q-.378 1.67-1.451 2.522-1.071.853-2.874.853-2.048 0-3.269-1.292-1.213-1.292-1.213-3.577 0-2.312 1.222-3.595 1.221-1.292 3.304-1.292 1.705 0 2.707.738 1.011.73 1.451 2.233m4.341-6.311v4.737q1.195-1.397 2.857-1.397.852 0 1.538.316.686.317 1.028.81.352.49.475 1.089.132.598.132 1.854V18.5h-2.47v-4.93q0-1.469-.141-1.864a1.2 1.2 0 0 0-.501-.624q-.351-.237-.887-.237-.616 0-1.099.299-.484.298-.712.905-.22.597-.22 1.775V18.5h-2.469V5.615zm-94.57 20h2.602v6.979q0 1.66.096 2.153.168.79.791 1.275.633.474 1.723.474 1.107 0 1.67-.448.562-.457.677-1.116.114-.66.114-2.189v-7.128h2.601v6.768q0 2.32-.21 3.278-.212.959-.783 1.617-.563.66-1.512 1.055-.949.387-2.478.387-1.845 0-2.804-.422-.948-.43-1.503-1.108-.553-.685-.73-1.432Q78 34.65 78 32.488zM99.498 38.5h-2.47v-4.764q0-1.512-.158-1.95a1.36 1.36 0 0 0-.518-.695 1.45 1.45 0 0 0-.853-.246 2 2 0 0 0-1.151.351q-.51.352-.704.932-.184.58-.184 2.145V38.5h-2.47v-9.334h2.294v1.371q1.222-1.582 3.076-1.582.817 0 1.495.299.675.29 1.019.747.351.457.483 1.037.141.58.141 1.661zm2.514-10.6v-2.285h2.469V27.9zm0 10.6v-9.334h2.469V38.5zm4.438-4.799q0-1.23.607-2.382a4.16 4.16 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m15.188 4.667v-1.398q-.51.748-1.345 1.178a3.7 3.7 0 0 1-1.749.43 3.4 3.4 0 0 1-1.687-.412 2.44 2.44 0 0 1-1.081-1.16q-.334-.747-.334-2.066v-5.906h2.469v4.29q0 1.968.132 2.416.141.44.501.703.36.255.914.255.633 0 1.134-.343.501-.351.686-.861.184-.518.184-2.523v-3.937h2.47V38.5zm13.351 0h-2.47v-4.764q0-1.512-.158-1.95a1.37 1.37 0 0 0-.519-.695 1.45 1.45 0 0 0-.852-.246q-.642 0-1.152.351-.51.352-.703.932-.185.58-.185 2.145V38.5h-2.469v-9.334h2.294v1.371q1.221-1.582 3.076-1.582.817 0 1.494.299.677.29 1.02.747.351.457.483 1.037.141.58.141 1.661z"
}, null, -1), g41 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), y41 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), _41 = [
  m41,
  g41,
  y41
];
function q41(t, e) {
  return T(), N("svg", p41, [..._41]);
}
const w41 = { render: q41 }, z41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "163",
  height: "48",
  viewBox: "0 0 163 48"
}, M41 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="m83.306 37.348 2.814-.273q.251 1.415 1.03 2.08.775.664 2.093.664 1.397 0 2.106-.591.707-.591.707-1.382 0-.507-.297-.864-.298-.357-1.04-.62-.509-.177-2.314-.625-2.325-.577-3.263-1.416-1.318-1.182-1.317-2.881 0-1.094.62-2.046.619-.952 1.787-1.45 1.166-.498 2.817-.498 2.695 0 4.057 1.18 1.364 1.183 1.43 3.156l-2.89.127q-.186-1.104-.796-1.587-.61-.484-1.83-.484-1.26 0-1.974.518a1.04 1.04 0 0 0-.459.888q0 .508.43.87.547.459 2.657.957 2.108.498 3.12 1.03 1.01.532 1.582 1.455.571.922.572 2.28 0 1.23-.684 2.305-.685 1.075-1.934 1.597-1.252.522-3.115.522-2.715 0-4.17-1.255t-1.739-3.657m22.242 4.658a2 2 0 0 0-.337.317q-.15.18-.26.386a2 2 0 0 0-.165.415q-.059.21-.058.405 0 .323.17.542.172.22.572.22.176 0 .395-.063l.415-.122v1.63q-.82.39-1.474.39-.547 0-.947-.145a1.9 1.9 0 0 1-.67-.401 1.6 1.6 0 0 1-.4-.591 1.9 1.9 0 0 1-.132-.717q0-.567.342-1.182t.918-1.084zm-2.666-4.98q-.528.176-1.67.419-1.143.245-1.494.479-.537.38-.537.967 0 .576.43.996.429.42 1.093.42.742 0 1.416-.49.498-.37.655-.907.106-.351.107-1.338zm-3.672-2.227-2.49-.45q.42-1.503 1.445-2.226t3.047-.722q1.837 0 2.734.434.898.435 1.265 1.104.366.668.366 2.456l-.03 3.203q0 1.366.133 2.016.132.65.493 1.392h-2.715a11 11 0 0 1-.264-.811 5 5 0 0 0-.097-.322q-.704.684-1.504 1.026a4.3 4.3 0 0 1-1.71.34q-1.6.001-2.523-.868-.923-.87-.923-2.197 0-.879.42-1.567a2.74 2.74 0 0 1 1.176-1.055q.758-.367 2.183-.64 1.922-.36 2.666-.674v-.273q0-.79-.391-1.128-.39-.337-1.474-.337-.734 0-1.143.288t-.664 1.01m9.513-4.57h2.744v-2.539h-2.744zm2.745 1.407v10.049q0 1.982-.259 2.797a2.27 2.27 0 0 1-.996 1.275q-.737.459-1.88.459-.411 0-.884-.073a10 10 0 0 1-1.02-.22l.478-2.344q.195.039.366.064.172.024.318.024.42 0 .688-.181a.87.87 0 0 0 .357-.434q.087-.255.087-1.524v-9.892zm9.197 10.371v-1.553q-.567.83-1.49 1.309a4.2 4.2 0 0 1-1.948.478q-1.044.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.371-2.295v-6.562h2.744V36.4q0 2.187.152 2.68.151.494.55.78.402.29 1.017.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798v-4.375h2.744v10.37zm14.325 0h-2.745v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V31.635h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm4.58-5.401q0 1.65.64 2.417t1.577.767q1.006 0 1.7-.787.692-.785.692-2.329.001-1.61-.664-2.392a2.11 2.11 0 0 0-1.679-.78q-.987 0-1.626.765-.64.767-.64 2.34m-2.45 6.083 3.134.381q.077.547.361.752.392.293 1.23.293 1.074 0 1.612-.323.361-.215.547-.693.127-.342.127-1.26v-1.513q-1.23 1.68-3.106 1.68-2.09 0-3.31-1.768-.958-1.396-.958-3.477 0-2.607 1.255-3.984t3.12-1.377q1.924 0 3.174 1.69v-1.456h2.57v9.307q0 1.837-.304 2.744-.303.909-.85 1.426t-1.46.81-2.309.293q-2.637 0-3.74-.903-1.104-.904-1.104-2.29 0-.136.01-.332m17.993-5.664q-.527.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .578.43.996.43.42 1.093.42.743 0 1.416-.488.498-.371.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.9.435 1.265 1.103.366.67.366 2.456l-.029 3.203q0 1.368.132 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.703.683-1.504 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.869-.924-.87-.923-2.198 0-.879.42-1.567t1.176-1.055q.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.39-1.127-.391-.337-1.475-.337-.733 0-1.143.288-.41.289-.664 1.01M84.03 20.326V6.01h10.615v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm19.866 0v-1.553a4 4 0 0 1-1.489 1.309 4.2 4.2 0 0 1-1.949.478q-1.043.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.829-.37-2.295V9.955h2.743v4.766q0 2.188.152 2.68.151.494.551.78.4.29 1.016.29.705 0 1.26-.386.556-.386.762-.957.204-.572.205-2.798V9.955h2.744v10.37zm7.718 0h-2.744V9.955h2.55v1.475q.653-1.046 1.175-1.377a2.17 2.17 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.319-.63 1.147-.23.831-.229 3.477zm7.034-5.186q0 1.544.732 2.363.734.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.367.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.149-.03q0 1.748.693 2.583.694.835 1.69.835.958 0 1.592-.767.633-.765.634-2.514 0-1.631-.654-2.422t-1.62-.79q-1.008 0-1.67.775-.665.777-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.807 0 3.067 1.416 1.26 1.417 1.26 3.945 0 2.599-1.27 4.038-1.27 1.441-3.076 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.744zm14.273 5.186q0 1.544.732 2.363.733.82 1.807.821 1.074 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82q-.732.82-.732 2.363m-2.813-.146q0-1.367.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m11.885 2.373 2.754-.42q.175.802.713 1.216.538.415 1.504.415 1.065 0 1.601-.391a.87.87 0 0 0 .362-.732.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.732-4.209-1.338-1.23-.84-1.23-2.334 0-1.347 1.064-2.266 1.065-.917 3.301-.917 2.13 0 3.164.693 1.036.694 1.426 2.05l-2.588.479q-.165-.605-.63-.928-.464-.322-1.323-.322-1.084 0-1.553.303-.312.215-.312.557 0 .292.273.498.37.273 2.564.77 2.193.5 3.061 1.222.86.733.86 2.04 0 1.427-1.192 2.452t-3.525 1.025q-2.12 0-3.355-.86a3.96 3.96 0 0 1-1.616-2.333"></path></g>', 1), b41 = [
  M41
];
function L41(t, e) {
  return T(), N("svg", z41, [...b41]);
}
const x41 = { render: L41 }, S41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "48",
  viewBox: "0 0 173 48"
}, C41 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="m83.306 37.347 2.814-.273q.251 1.415 1.03 2.08.775.664 2.093.664 1.397 0 2.106-.59.707-.593.707-1.383 0-.507-.297-.864-.298-.357-1.04-.62-.509-.177-2.314-.625-2.325-.577-3.263-1.416-1.318-1.182-1.317-2.88 0-1.095.62-2.047.619-.952 1.787-1.45 1.166-.498 2.817-.498 2.695 0 4.057 1.181 1.364 1.182 1.43 3.155l-2.89.127q-.186-1.104-.796-1.587-.61-.484-1.83-.484-1.26 0-1.974.518a1.04 1.04 0 0 0-.459.888q0 .51.43.87.547.459 2.657.957 2.108.498 3.12 1.03 1.01.532 1.582 1.455.571.922.572 2.28 0 1.232-.684 2.305-.685 1.075-1.934 1.597-1.252.522-3.115.522-2.715 0-4.17-1.255t-1.739-3.657m19.276-.322q-.528.175-1.67.42-1.143.244-1.494.478-.537.382-.537.967 0 .578.43.996.429.42 1.093.42.742 0 1.416-.488.498-.371.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.923-.87-.923-2.198 0-.879.42-1.567.419-.688 1.176-1.055.758-.366 2.183-.639 1.922-.362 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288t-.664 1.01m11.324 7.208-4.18-10.372h2.881l1.953 5.294.567 1.767q.225-.674.283-.889.136-.438.293-.878l1.973-5.293h2.822l-4.12 10.37zm7.971-.001h2.744V31.634h-2.744zm0-11.777h2.744v-2.539h-2.744zm11.219 5.703q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9.001-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.46q-.527 1.504-1.665 2.29-1.138.785-2.847.786-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.578 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528 1.338 1.53 1.28 4.683h-6.875q.028 1.22.664 1.9.634.678 1.582.678.643 0 1.084-.352.44-.351.664-1.133m14.05 3.302h-2.744v-5.294q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.392-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V31.633h2.55v1.523q1.356-1.756 3.417-1.756.909-.001 1.66.326.752.328 1.138.835.385.508.537 1.153.15.644.151 1.845zm2.283-.001h2.744V31.634h-2.744zm-1.806-12.079h6.289v-1.807h-6.289zm9.971 6.669q0 1.612.508 2.383.712 1.094 1.894 1.094.907 0 1.548-.777.64-.776.64-2.446 0-1.778-.645-2.564-.645-.785-1.65-.786-.986 0-1.642.767-.654.766-.654 2.33m-2.725 5.41V27.69h2.745v5.156q1.268-1.445 3.007-1.445 1.894 0 3.135 1.372 1.24 1.371 1.24 3.94-.001 2.657-1.264 4.092-1.266 1.436-3.072 1.436a3.8 3.8 0 0 1-1.753-.445q-.864-.444-1.49-1.313v1.523zm17.858-4.981q-.527.175-1.67.42-1.143.244-1.494.478-.537.382-.537.967 0 .578.43.996.43.42 1.093.42.743 0 1.416-.488.498-.371.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.9.434 1.265 1.103.366.67.366 2.456l-.029 3.203q0 1.368.132 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.703.683-1.504 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.869-.924-.87-.923-2.198 0-.879.42-1.567t1.176-1.055q.758-.366 2.183-.639 1.923-.362 2.666-.674v-.274q0-.79-.39-1.127-.391-.337-1.475-.337-.733 0-1.143.288t-.664 1.01M84.03 20.326V6.01h10.615v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm13.04 0h2.744V9.955H97.07zm0-11.778h2.744V6.009H97.07zm8.384 11.778h-2.744V9.955h2.549v1.475q.654-1.045 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.316-.63 1.147t-.229 3.477zm7.034-5.186q0 1.544.732 2.363.734.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.149-.029q0 1.748.693 2.582.694.836 1.69.835.958 0 1.592-.767.634-.765.634-2.513 0-1.632-.654-2.422t-1.62-.791q-1.008 0-1.67.776-.665.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.26 1.415 1.26 3.944 0 2.6-1.27 4.039-1.27 1.44-3.076 1.44a3.5 3.5 0 0 1-1.558-.341q-.698-.344-1.47-1.172v5.224h-2.744zm17.818 5.39q-.528.176-1.67.42-1.143.244-1.494.478-.537.382-.537.967 0 .578.43.996.429.42 1.093.42.743 0 1.416-.488.498-.372.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.923-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01m8.305 4.249 2.754-.42q.175.8.713 1.216t1.504.415q1.065 0 1.601-.391a.87.87 0 0 0 .362-.732.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.732-4.209-1.338-1.23-.84-1.23-2.334 0-1.348 1.064-2.266t3.301-.917q2.13 0 3.164.693 1.036.694 1.426 2.05l-2.588.479q-.165-.606-.63-.928t-1.323-.322q-1.084 0-1.553.303-.312.215-.312.557 0 .292.273.498.37.273 2.564.77 2.193.5 3.061 1.222.86.732.86 2.04 0 1.426-1.192 2.452t-3.525 1.025q-2.12 0-3.355-.86a3.96 3.96 0 0 1-1.616-2.333"></path></g>', 1), k41 = [
  C41
];
function E41(t, e) {
  return T(), N("svg", S41, [...k41]);
}
const A41 = { render: E41 }, F41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "166",
  height: "48",
  viewBox: "0 0 166 48"
}, T41 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84.039 42.006V27.69h10.615v2.42H86.93v3.175h7.187v2.412H86.93v3.897h7.998v2.412zm15.254 0-3.281-10.371h2.666l1.943 6.797 1.787-6.797h2.647l1.728 6.797 1.983-6.797h2.705l-3.33 10.37h-2.637l-1.787-6.67-1.758 6.67zm16.25 0h-2.744V31.635h2.549v1.475q.654-1.046 1.176-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.29-.45-.576 0-.976.318-.399.316-.63 1.147t-.23 3.477zm7.034-5.186q0 1.544.732 2.363.734.82 1.807.821 1.074 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.245-.674-3.032m15.149-.029q0 1.748.693 2.583.694.835 1.69.835.958 0 1.592-.767.633-.767.634-2.514 0-1.632-.654-2.422t-1.62-.791q-1.008 0-1.67.776-.665.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.807 0 3.067 1.416t1.26 3.945q0 2.598-1.27 4.038t-3.076 1.44a3.5 3.5 0 0 1-1.558-.341q-.698-.343-1.47-1.172v5.225h-2.744zm18.257 4.297q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.899 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.526 1.505-1.665 2.29-1.138.786-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.528t1.28 4.683h-6.875q.029 1.22.664 1.899.634.68 1.582.679.644 0 1.084-.352.44-.351.664-1.133m10.84-1.68q-.528.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .578.43.996.429.42 1.093.42.743 0 1.416-.488.498-.371.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.923-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01"></path><g fill="#515560"><path fill-rule="nonzero" d="M84 20.316V6h2.744v14.316zm5.244-3.818v-2.744h5.39v2.744z"></path><path d="M97 6.01h2.891v7.753q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.412q.698.532 1.909.532 1.23 0 1.855-.503t.752-1.235q.127-.733.127-2.432V6.01h2.891v7.52q0 2.578-.234 3.642-.235 1.066-.865 1.797-.63.732-1.684 1.167t-2.754.435q-2.05 0-3.11-.474t-1.675-1.23-.811-1.587Q97 16.05 97 13.646zm23.277 14.316h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.39t-.776 1.036-.21 2.383v4.697h-2.744V9.955h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.225-11.778h2.744V6.009h-2.744zm2.744 1.407v10.048q0 1.983-.259 2.798a2.27 2.27 0 0 1-.996 1.275q-.736.459-1.88.459-.41 0-.884-.074a10 10 0 0 1-1.02-.219l.478-2.344q.195.039.366.063.172.025.318.025.42 0 .688-.181a.87.87 0 0 0 .357-.434q.088-.255.088-1.524V9.955zm4.549 5.185q0 1.544.732 2.363.733.82 1.807.821 1.074 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82q-.732.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m21.785 5.332h-2.743v-5.293q0-1.68-.177-2.173a1.53 1.53 0 0 0-.57-.766q-.396-.274-.952-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V9.955h2.548v1.523q1.358-1.758 3.418-1.757.91 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.583 0h2.744V9.955h-2.744zm0-11.778h2.744V6.009h-2.744z"></path></g></g>', 1), I41 = [
  T41
];
function O41(t, e) {
  return T(), N("svg", F41, [...I41]);
}
const N41 = { render: O41 }, P41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "48",
  viewBox: "0 0 173 48"
}, B41 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84.019 27.69h2.89v7.753q.001 1.845.108 2.392.186.88.885 1.412.697.532 1.908.532 1.23 0 1.855-.503.627-.504.752-1.235.128-.733.127-2.432v-7.92h2.89v7.52q0 2.578-.233 3.642-.235 1.066-.864 1.797-.63.732-1.685 1.167-1.054.435-2.754.435-2.05 0-3.11-.474t-1.675-1.23q-.615-.758-.811-1.587-.282-1.23-.283-3.633zm23.277 14.316h-2.744v-5.293q-.001-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.396-.274-.953-.274a2.2 2.2 0 0 0-1.28.39 1.96 1.96 0 0 0-.775 1.036q-.211.645-.211 2.383v4.697h-2.744V31.635h2.549v1.523q1.359-1.758 3.418-1.757.909 0 1.66.327.752.327 1.139.835.383.507.537 1.152.15.645.15 1.846zm2.283 0h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zm11.418 5.703q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.898.001-1.484.655-.585.654-.577 1.777zm-.156 2.773 2.734.46q-.526 1.504-1.664 2.29-1.138.785-2.848.786-2.703 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.578 1.348-4.038t3.408-1.46q2.316 0 3.652 1.528 1.34 1.53 1.28 4.683h-6.875q.03 1.22.664 1.9.635.678 1.582.678.645 0 1.084-.352.44-.351.664-1.133M84.03 20.326V6.01h10.616v2.42H86.92v3.175h7.187v2.412H86.92v3.897h7.998v2.412zm19.867 0v-1.553q-.568.83-1.49 1.309a4.2 4.2 0 0 1-1.948.478q-1.046.001-1.875-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.37-2.295V9.955h2.743v4.766q0 2.188.153 2.68.15.494.55.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.557-.386.763-.957.203-.572.204-2.798V9.955h2.745v10.37zm7.717 0h-2.744V9.955h2.55v1.475q.653-1.046 1.175-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.316-.63 1.147t-.229 3.477zm7.035-5.186q0 1.544.731 2.363.734.82 1.808.821 1.073 0 1.801-.82.728-.822.727-2.384.001-1.523-.727-2.343t-1.802-.82-1.806.82q-.733.82-.733 2.363m-2.812-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.234-.674 2.757-.674 2.354 0 3.858 1.528 1.505 1.53 1.505 3.863 0 2.355-1.52 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.149-.029q0 1.748.693 2.583.694.835 1.69.835.958 0 1.592-.767.633-.767.634-2.514 0-1.632-.654-2.422t-1.62-.791q-1.008 0-1.67.776-.665.777-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.26 1.416 1.26 3.945 0 2.598-1.27 4.038t-3.076 1.44a3.5 3.5 0 0 1-1.558-.341q-.698-.343-1.47-1.172v5.225h-2.744zm18.257 4.297q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.899 0-1.484.655-.585.654-.577 1.777zm-.156 2.773 2.734.459q-.526 1.505-1.665 2.29-1.138.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.528 1.339 1.529 1.28 4.683h-6.875q.03 1.22.664 1.899.634.68 1.582.679.645 0 1.084-.352.44-.351.664-1.133m4.15.342 2.754-.42q.176.8.714 1.216.536.415 1.504.415 1.065 0 1.6-.391a.87.87 0 0 0 .362-.732.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.732-4.208-1.338-1.23-.84-1.23-2.334-.001-1.347 1.064-2.266 1.065-.917 3.3-.917 2.13 0 3.165.693t1.425 2.05l-2.587.479q-.165-.606-.63-.928t-1.324-.322q-1.083 0-1.553.303-.312.215-.312.557 0 .292.274.498.37.273 2.564.77 2.192.5 3.06 1.222.86.732.86 2.04 0 1.425-1.191 2.452t-3.525 1.025q-2.12 0-3.355-.86a3.96 3.96 0 0 1-1.617-2.333m17.953-3.115q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.526 1.505-1.665 2.29-1.138.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528t1.28 4.683h-6.875q.028 1.22.664 1.899.634.68 1.582.679.643 0 1.084-.352.44-.351.664-1.133"></path></g>', 1), V41 = [
  B41
];
function R41(t, e) {
  return T(), N("svg", P41, [...V41]);
}
const H41 = { render: R41 }, D41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, $41 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), U41 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), j41 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "m82.696 16.03 2.461.412q-.474 1.354-1.503 2.066-1.02.703-2.557.703-2.435 0-3.604-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.068-1.318 2.082 0 3.287 1.38 1.203 1.37 1.151 4.21h-6.187q.025 1.098.597 1.714.572.606 1.424.606.58 0 .976-.316.394-.316.597-1.02m.14-2.497q-.025-1.073-.553-1.626A1.7 1.7 0 0 0 81 11.345q-.809 0-1.336.589-.527.588-.519 1.6zM93.454 19v-1.398q-.51.748-1.345 1.178-.825.43-1.749.43-.941 0-1.687-.412a2.44 2.44 0 0 1-1.081-1.16q-.334-.747-.334-2.066V9.666h2.47v4.29q0 1.968.131 2.416.141.44.501.703.36.255.914.255.633 0 1.134-.343.501-.351.686-.861.184-.519.184-2.523V9.667h2.47V19zm7.225 0h-2.47V9.666h2.294v1.327q.589-.94 1.055-1.24.474-.297 1.072-.298.843 0 1.626.466l-.765 2.153q-.624-.405-1.16-.404-.519 0-.879.29-.36.281-.571 1.028-.202.747-.202 3.13zm4.078-4.799q0-1.23.606-2.382a4.2 4.2 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.12 0 3.472 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.363 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.767-1.696q-.606-1.125-.606-2.734m2.531.132q0 1.389.659 2.127.66.738 1.626.738.968 0 1.617-.738.66-.738.66-2.145 0-1.371-.66-2.109-.65-.738-1.617-.738-.966 0-1.626.738t-.659 2.127m8.974-4.667h2.302v1.371q.449-.704 1.213-1.142a3.35 3.35 0 0 1 1.697-.44q1.626 0 2.759 1.274t1.134 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.319-1.054v4.702h-2.469zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.86 0 1.432-.686.572-.694.572-2.267 0-1.468-.589-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066m14.036 1.855 2.461.412q-.474 1.354-1.503 2.066-1.019.703-2.557.703-2.435 0-3.604-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.068-1.318 2.082 0 3.287 1.38 1.203 1.37 1.151 4.21h-6.188q.027 1.098.598 1.714.572.606 1.424.606.58 0 .976-.316.394-.316.597-1.02m.141-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.808 0-1.336.589-.527.588-.519 1.6zm4.473-5.132V6.115h2.47V8.4zm0 10.6V9.666h2.47V19zm4.14-2.663 2.479-.378q.158.72.641 1.099.484.369 1.354.369.958 0 1.441-.352a.78.78 0 0 0 .325-.659.65.65 0 0 0-.175-.466q-.185-.175-.827-.325-2.987-.659-3.788-1.204-1.107-.756-1.107-2.1 0-1.214.958-2.04.958-.825 2.971-.826 1.916 0 2.847.624.932.624 1.283 1.846l-2.329.43a1.43 1.43 0 0 0-.571-.835q-.413-.29-1.186-.29-.977 0-1.398.273-.28.194-.281.5 0 .265.246.45.334.245 2.303.694 1.977.448 2.759 1.098.774.66.774 1.837 0 1.282-1.072 2.206t-3.173.923q-1.908 0-3.024-.773a3.57 3.57 0 0 1-1.45-2.101M152.297 19V6.115h2.47v6.838l2.891-3.287h3.041l-3.19 3.41L160.928 19h-2.663l-2.347-4.192-1.151 1.204V19zm15.513-2.97 2.461.412q-.476 1.354-1.503 2.066-1.02.703-2.558.703-2.434 0-3.604-1.59-.922-1.275-.922-3.218 0-2.32 1.212-3.63 1.214-1.318 3.068-1.318 2.083 0 3.287 1.38 1.205 1.37 1.151 4.21h-6.187q.026 1.098.597 1.714.572.606 1.424.606.58 0 .976-.316t.598-1.02m.14-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.808 0-1.336.589-.527.588-.518 1.6zM83.435 38v-1.398q-.51.748-1.345 1.178a3.7 3.7 0 0 1-1.75.43 3.43 3.43 0 0 1-1.687-.412 2.44 2.44 0 0 1-1.08-1.16q-.335-.747-.335-2.066v-5.906h2.47v4.29q0 1.968.132 2.416.14.44.5.703.362.255.915.255.633 0 1.134-.343.5-.351.685-.861.185-.518.185-2.523v-3.937h2.47V38zm13.35 0h-2.47v-4.764q0-1.512-.158-1.95a1.36 1.36 0 0 0-.518-.695 1.45 1.45 0 0 0-.853-.246 2 2 0 0 0-1.151.351q-.51.352-.703.932-.185.58-.185 2.145V38h-2.47v-9.334h2.294v1.371q1.222-1.582 3.076-1.582.817 0 1.495.299.675.29 1.02.747.35.457.482 1.037.141.58.141 1.661zm2.514-10.6v-2.285h2.47V27.4zm0 10.6v-9.334h2.47V38zm4.438-4.799q0-1.23.607-2.382a4.16 4.16 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.118 0 3.472 1.38 1.353 1.37 1.353 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.532.132q0 1.389.659 2.127t1.626.738q.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.659 2.127M123.803 38h-2.47v-4.764q0-1.512-.158-1.95a1.37 1.37 0 0 0-.519-.695q-.351-.246-.852-.246-.642 0-1.152.351-.51.352-.703.932-.184.58-.184 2.145V38h-2.47v-9.334h2.294v1.371q1.221-1.582 3.076-1.582.817 0 1.494.299.676.29 1.02.747.351.457.483 1.037.141.58.141 1.661z"
}, null, -1), G41 = [
  $41,
  U41,
  j41
];
function W41(t, e) {
  return T(), N("svg", D41, [...G41]);
}
const Y41 = { render: W41 }, X41 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "189",
  height: "48",
  viewBox: "0 0 189 48"
}, K41 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84.038 42.006V27.688h10.615v2.422H86.93v3.174h7.188v2.412H86.93v3.896h7.997v2.412zm19.867 0v-1.553q-.567.83-1.49 1.308a4.2 4.2 0 0 1-1.948.478q-1.044.001-1.874-.458a2.7 2.7 0 0 1-1.202-1.29q-.37-.829-.371-2.294v-6.563h2.744v4.767q0 2.186.152 2.68.151.494.55.78.402.29 1.017.29a2.16 2.16 0 0 0 1.26-.387q.556-.386.762-.957.204-.571.205-2.797v-4.375h2.744v10.37zm7.717 0h-2.744V31.633h2.55v1.475q.653-1.046 1.175-1.376a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.392q-.693-.45-1.289-.45-.576 0-.977.319-.399.316-.63 1.146-.23.831-.229 3.477zm7.035-5.186q0 1.543.732 2.363t1.807.82q1.073 0 1.802-.82.727-.82.727-2.383 0-1.523-.727-2.343-.728-.82-1.802-.821-1.074 0-1.807.82-.732.821-.732 2.364m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.675 2.758-.674 2.354 0 3.858 1.528t1.504 3.863q0 2.354-1.52 3.9-1.518 1.55-3.822 1.549a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.89q-.674-1.245-.674-3.031m15.149-.03q0 1.748.692 2.583.694.835 1.69.835.958 0 1.593-.767.633-.766.633-2.514.001-1.632-.654-2.422-.653-.791-1.62-.79-1.007 0-1.67.775-.665.776-.665 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.258 1.417 1.258 3.945 0 2.598-1.269 4.038t-3.076 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.743zm18.258 4.297q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.427-.62q-.899.001-1.483.655-.587.654-.577 1.777zm-.156 2.773 2.734.46q-.526 1.504-1.666 2.29-1.137.785-2.846.786-2.704 0-4.004-1.768-1.025-1.416-1.025-3.574 0-2.578 1.347-4.038t3.408-1.46q2.316 0 3.653 1.528 1.338 1.53 1.28 4.683h-6.875q.029 1.22.663 1.9.634.678 1.582.678.645 0 1.084-.352.439-.351.665-1.133m5.058-8.476h2.744v-2.539h-2.744zm2.744 1.406v10.049q0 1.983-.259 2.798a2.27 2.27 0 0 1-.996 1.274q-.737.46-1.88.459a6 6 0 0 1-.884-.073 10 10 0 0 1-1.02-.219l.478-2.344q.195.039.367.063.17.025.317.025.42 0 .689-.181a.88.88 0 0 0 .356-.435q.088-.254.088-1.523v-9.893zm1.904 7.413 2.754-.42q.175.8.713 1.215t1.504.416q1.065 0 1.601-.392a.87.87 0 0 0 .362-.731.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.733-4.209-1.338-1.23-.84-1.23-2.334 0-1.349 1.064-2.267 1.065-.916 3.301-.916 2.13 0 3.164.692 1.036.693 1.426 2.051l-2.588.479q-.165-.606-.63-.928t-1.323-.322q-1.084 0-1.553.303-.312.214-.312.556 0 .293.273.498.37.274 2.564.772 2.193.497 3.061 1.22.86.733.86 2.041 0 1.426-1.192 2.452-1.192 1.024-3.525 1.024-2.12 0-3.355-.858a3.96 3.96 0 0 1-1.616-2.334m11.592 2.959V27.688h2.744v7.598l3.213-3.652h3.38l-3.546 3.788 3.8 6.582h-2.96l-2.608-4.658-1.279 1.338v3.32zm16.943-4.981q-.526.175-1.67.42-1.142.244-1.493.478-.537.382-.537.967 0 .578.43.996.428.42 1.093.42.741 0 1.415-.488.498-.371.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.446-2.226 1.025-.723 3.047-.723 1.836 0 2.734.435.898.434 1.264 1.103.366.67.366 2.456l-.029 3.203q0 1.368.132 2.017.133.65.493 1.391h-2.714a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.505 1.025a4.3 4.3 0 0 1-1.708.342q-1.602 0-2.524-.869-.924-.87-.923-2.198 0-.879.42-1.567.419-.688 1.175-1.055.759-.366 2.184-.639 1.922-.362 2.665-.674v-.274q0-.79-.39-1.127t-1.475-.337q-.731 0-1.142.288t-.665 1.01M84.011 6.01h2.891v7.753q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.412q.698.532 1.91.532 1.23 0 1.854-.503t.752-1.235.127-2.432V6.01h2.891v7.52q0 2.578-.234 3.642-.235 1.066-.865 1.797-.629.732-1.684 1.167t-2.754.435q-2.05 0-3.11-.474t-1.675-1.23-.81-1.587q-.284-1.23-.284-3.633zm23.278 14.316h-2.745v-5.293q0-1.68-.175-2.173a1.53 1.53 0 0 0-.572-.766q-.394-.274-.951-.274-.715 0-1.28.39-.568.39-.776 1.036-.21.645-.21 2.383v4.697h-2.745V9.955h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.753.327 1.138.835.386.507.538 1.152.15.645.15 1.846zm2.283 0h2.744V9.955h-2.744zm0-11.778h2.744V6.009h-2.744zm10.978 6.797q-.528.176-1.67.42-1.143.244-1.494.478-.537.382-.537.967 0 .578.43.996.43.42 1.093.42.742 0 1.416-.488.498-.372.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.9.434 1.265 1.103.366.67.366 2.456l-.029 3.203q0 1.368.132 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.703.683-1.504 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.869-.923-.87-.923-2.198 0-.879.42-1.567t1.176-1.055q.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.39-1.127-.391-.337-1.475-.337-.733 0-1.143.288-.41.289-.664 1.01"></path></g>', 1), Z41 = [
  K41
];
function J41(t, e) {
  return T(), N("svg", X41, [...Z41]);
}
const Q41 = { render: J41 }, e51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "167",
  height: "48",
  viewBox: "0 0 167 48"
}, t51 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84.04 42.006V27.69h10.614v2.42H86.93v3.175h7.187v2.412H86.93v3.897h7.998v2.412zm19.864 0v-1.553q-.566.83-1.488 1.309a4.2 4.2 0 0 1-1.95.478q-1.043.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.37-2.295v-6.562h2.743V36.4q0 2.187.153 2.68.151.494.55.78.401.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798v-4.375h2.744v10.37zm7.719 0h-2.744V31.635h2.549v1.475q.654-1.046 1.175-1.377.524-.333 1.188-.332.937 0 1.807.517l-.85 2.393q-.695-.45-1.289-.45-.578 0-.977.318-.4.316-.63 1.147t-.229 3.477zm7.033-5.186q0 1.544.732 2.363.735.82 1.807.821 1.074 0 1.803-.82.726-.822.726-2.384 0-1.522-.726-2.343-.729-.82-1.803-.82t-1.807.82q-.732.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.356 0 3.858 1.528 1.505 1.53 1.504 3.863 0 2.355-1.518 3.901-1.52 1.548-3.824 1.548a6 6 0 0 1-2.719-.645 4.42 4.42 0 0 1-1.969-1.889q-.674-1.244-.674-3.032m15.149-.03q0 1.748.693 2.583.694.835 1.69.835.958 0 1.592-.767.634-.766.634-2.514.001-1.632-.654-2.422-.653-.791-1.62-.79-1.006 0-1.67.775-.664.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.807 0 3.067 1.416 1.26 1.417 1.26 3.945 0 2.598-1.27 4.038-1.268 1.441-3.076 1.441a3.5 3.5 0 0 1-1.557-.342q-.699-.342-1.47-1.172v5.225h-2.745zm18.258 4.298q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.654-.586.654-.577 1.777zm-.156 2.772 2.734.46q-.525 1.504-1.666 2.29-1.137.785-2.846.786-2.706 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.578 1.348-4.038 1.346-1.46 3.408-1.46 2.314 0 3.652 1.529t1.28 4.682h-6.875q.029 1.221.664 1.9.633.678 1.582.678.645 0 1.084-.352.439-.351.664-1.133m5.017 3.302h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zm11.178 6.797q-.528.175-1.67.42-1.143.244-1.494.478-.536.381-.537.967 0 .577.43.996.431.42 1.093.42.743 0 1.416-.488.498-.371.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.449q.421-1.503 1.445-2.226 1.026-.723 3.047-.723 1.838 0 2.734.435.9.434 1.266 1.103.365.67.365 2.456l-.029 3.203q0 1.368.133 2.017.132.65.492 1.391h-2.715q-.105-.273-.264-.81a4 4 0 0 0-.097-.322 5 5 0 0 1-1.504 1.025 4.3 4.3 0 0 1-1.709.342q-1.6 0-2.523-.869-.924-.87-.924-2.198 0-.879.42-1.567t1.177-1.055 2.182-.639q1.925-.361 2.666-.674v-.274q0-.79-.39-1.127-.391-.337-1.475-.337-.733 0-1.143.288-.41.289-.664 1.01M84.01 6.01h2.892v7.754q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.412q.697.532 1.909.532 1.23 0 1.855-.503t.752-1.235q.127-.735.127-2.432V6.01h2.89v7.52q0 2.578-.233 3.642-.235 1.065-.865 1.797t-1.684 1.167-2.754.435q-2.05 0-3.11-.474t-1.675-1.231-.811-1.586q-.282-1.232-.283-3.633zm23.278 14.316h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.714 0-1.28.391-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V9.955h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.283 0h2.744V9.955h-2.744zm0-11.777h2.744V6.01h-2.744zm10.779 6.797q-.526.174-1.67.42-1.142.243-1.493.478-.537.38-.537.966 0 .578.43.996.429.42 1.093.42.743 0 1.416-.488.498-.372.655-.908.106-.352.107-1.338zm-3.69-6.787h-1.25a8 8 0 0 1-.01-.352q0-1.026.498-1.578.498-.55 1.279-.551.342 0 .635.073.293.074 1.069.42.777.347 1.216.346a.74.74 0 0 0 .523-.194q.209-.196.268-.654h1.27q-.01 1.318-.494 1.883a1.56 1.56 0 0 1-1.245.568q-.332 0-.654-.07-.225-.057-1.123-.4-.899-.342-1.31-.342-.311 0-.487.191-.177.19-.185.66m.019 4.56-2.49-.45q.42-1.502 1.445-2.226 1.025-.722 3.047-.723 1.837 0 2.734.435.898.435 1.265 1.104.366.668.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.39h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.343q-1.6 0-2.523-.87-.924-.869-.923-2.197 0-.878.42-1.567.419-.689 1.176-1.055.758-.366 2.183-.64 1.923-.36 2.666-.674v-.274q0-.79-.391-1.127-.39-.336-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01m10.949 2.022q0 1.544.732 2.363.733.82 1.807.821 1.074 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82q-.732.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032"></path></g>', 1), n51 = [
  t51
];
function i51(t, e) {
  return T(), N("svg", e51, [...n51]);
}
const s51 = { render: i51 }, l51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "185",
  height: "48",
  viewBox: "0 0 185 48"
}, r51 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84.039 42.006V27.688h10.615v2.422H86.93v3.174h7.187v2.412H86.93v3.896h7.998v2.412zm19.866 0v-1.553q-.567.83-1.489 1.308a4.2 4.2 0 0 1-1.949.478q-1.043.001-1.874-.458a2.7 2.7 0 0 1-1.202-1.29q-.37-.829-.37-2.294v-6.563h2.743v4.767q0 2.186.152 2.68.151.494.551.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.387q.556-.386.762-.957.204-.571.205-2.797v-4.375h2.744v10.37zm7.718 0h-2.744V31.633h2.549v1.475q.654-1.046 1.176-1.376a2.16 2.16 0 0 1 1.187-.332q.938-.001 1.807.517l-.85 2.392q-.693-.45-1.289-.45-.576 0-.977.319-.399.316-.63 1.146-.23.831-.229 3.477zm7.034-5.186q0 1.543.732 2.363.734.82 1.807.821 1.073 0 1.802-.821.727-.82.727-2.383 0-1.522-.727-2.343-.728-.82-1.802-.821-1.074 0-1.807.821-.732.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528t1.504 3.863q0 2.353-1.519 3.901-1.52 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.245-.674-3.032m15.149-.03q0 1.748.693 2.583.694.835 1.69.835.958 0 1.592-.767.634-.766.634-2.514 0-1.632-.654-2.422t-1.62-.79q-1.008 0-1.67.775-.665.776-.665 2.3m-2.715-5.01h2.56v1.524a3.8 3.8 0 0 1 1.346-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.26 1.417 1.26 3.945 0 2.598-1.27 4.038t-3.076 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.744zm18.257 4.297q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.899.001-1.484.655t-.577 1.777zm-.156 2.773 2.734.46q-.526 1.504-1.665 2.29-1.138.785-2.847.786-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.578 1.348-4.038 1.347-1.46 3.408-1.46 2.315 0 3.652 1.528 1.339 1.53 1.28 4.683h-6.875q.03 1.22.664 1.9.634.678 1.582.678.645 0 1.084-.352.44-.351.664-1.133m10.84-1.679q-.528.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .578.43.996.429.42 1.093.42.743 0 1.416-.488.498-.371.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.435 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.923-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01m18.386 7.208h-2.744v-5.294q0-1.68-.177-2.172a1.53 1.53 0 0 0-.57-.767q-.397-.274-.952-.274-.714 0-1.28.392-.568.39-.777 1.035t-.21 2.383v4.697h-2.744V31.633h2.55v1.523q1.356-1.756 3.418-1.756.908-.001 1.66.326.75.328 1.138.835.384.508.536 1.153.15.644.151 1.845zm8.005-4.981q-.528.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .578.43.996.43.42 1.093.42.743 0 1.416-.488.498-.371.655-.908.107-.352.107-1.338zm.098-9.58h1.338q-.118 1.328-.933 2.085t-2.114.757-2.115-.757-.932-2.085h1.338q.068.693.488 1.05.42.356 1.221.356.8 0 1.22-.356.42-.357.49-1.05m-3.77 7.353-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.9.435 1.265 1.103.366.67.366 2.456l-.029 3.203q0 1.368.132 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.703.683-1.504 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.869-.924-.87-.923-2.198 0-.879.42-1.567t1.176-1.055q.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.39-1.127-.391-.337-1.475-.337-.733 0-1.143.288-.41.289-.664 1.01M84.01 6.01h2.892v7.753q0 1.846.107 2.392a2.32 2.32 0 0 0 .884 1.412q.697.532 1.909.532 1.23 0 1.855-.503t.752-1.235.127-2.432V6.01h2.89v7.52q0 2.578-.233 3.642-.235 1.066-.865 1.797-.63.732-1.684 1.167t-2.754.435q-2.05 0-3.11-.474t-1.675-1.23-.811-1.587q-.282-1.23-.283-3.633zm23.278 14.316h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.714 0-1.28.39t-.776 1.036-.21 2.383v4.697h-2.744V9.955h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327t1.138.835.537 1.152.151 1.846zm2.283 0h2.744V9.955h-2.744zm0-11.778h2.744V6.009h-2.744zm11.883 11.778v-1.553q-.567.83-1.489 1.309a4.2 4.2 0 0 1-1.949.478q-1.044.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.371-2.295V9.955h2.744v4.766q0 2.188.152 2.68.151.494.551.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798V9.955h2.744v10.37zm14.523 0h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V9.955h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm8.946-6.074q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.527 1.505-1.665 2.29-1.138.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528t1.28 4.683h-6.875q.028 1.22.664 1.899.634.68 1.582.679.643 0 1.084-.352.44-.351.664-1.133m10.839-1.68q-.528.175-1.67.42-1.143.244-1.494.478-.537.382-.537.967 0 .578.43.996.43.42 1.093.42.743 0 1.416-.488.498-.372.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.9.434 1.265 1.103.366.67.366 2.456l-.029 3.203q0 1.368.132 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.703.683-1.504 1.025a4.3 4.3 0 0 1-1.709.342q-1.601 0-2.524-.869-.923-.87-.923-2.198 0-.879.42-1.567t1.176-1.055q.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.39-1.127-.391-.337-1.475-.337-.733 0-1.143.288-.41.289-.664 1.01"></path></g>', 1), a51 = [
  r51
];
function o51(t, e) {
  return T(), N("svg", l51, [...a51]);
}
const c51 = { render: o51 }, h51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, u51 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M78.563 18.5V5.615h9.553v2.18h-6.952v2.856h6.469v2.171h-6.469v3.507h7.198V18.5zm12.014-9.334h5.405q1.662 0 2.488.606.825.607.826 1.829 0 .781-.457 1.362a2.13 2.13 0 0 1-1.134.773q.967.238 1.442.888.474.65.474 1.424 0 1.09-.8 1.775-.8.677-2.364.677h-5.88zm2.487 3.876h1.591q1.152 0 1.661-.29.519-.29.519-.914 0-.59-.483-.835-.475-.255-1.697-.255h-1.59zm0 3.876h1.952q1.054 0 1.538-.255.483-.255.483-.914 0-.685-.554-.94-.554-.264-2.153-.264h-1.266zm8.491-7.752h2.302v1.371q.449-.704 1.213-1.142a3.35 3.35 0 0 1 1.697-.44q1.626 0 2.759 1.274t1.134 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.319-1.054v4.702h-2.469zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.86 0 1.432-.686.571-.694.571-2.267 0-1.468-.588-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066m8.06.026q0-1.23.606-2.382a4.17 4.17 0 0 1 1.714-1.757q1.116-.607 2.487-.607 2.118 0 3.472 1.38 1.353 1.37 1.353 3.472 0 2.118-1.371 3.515-1.362 1.389-3.436 1.389a5.44 5.44 0 0 1-2.452-.58 4 4 0 0 1-1.767-1.696q-.606-1.125-.606-2.734m2.531.132q0 1.389.659 2.127.66.738 1.626.738.968 0 1.617-.738.66-.738.659-2.145 0-1.371-.659-2.109-.65-.738-1.617-.738t-1.626.738-.659 2.127m8.947-4.667h8.288V18.5h-2.47v-7.339h-3.348V18.5h-2.47zm16.383 6.364 2.461.412q-.476 1.354-1.503 2.066-1.02.703-2.558.703-2.435 0-3.603-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.067-1.318 2.084 0 3.287 1.38 1.204 1.37 1.152 4.21h-6.188q.027 1.098.598 1.714.571.606 1.424.606.58 0 .975-.316.396-.316.598-1.02m.141-2.497q-.027-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.809 0-1.336.589-.528.588-.519 1.6zm4.412-3.866h2.373v5.862l3.797-5.862h2.425V18.5h-2.373v-5.968l-3.849 5.968h-2.373zm5.915-3.788h1.204q-.106 1.196-.844 1.88-.73.678-1.898.678-1.17 0-1.908-.677-.729-.686-.835-1.881h1.205q.061.624.439.95.378.316 1.099.316.72 0 1.098-.317.378-.325.44-.95m13.359 6.549-2.434.44q-.124-.73-.563-1.1-.43-.368-1.125-.368-.922 0-1.477.641-.544.632-.544 2.127 0 1.661.553 2.347.563.685 1.503.685.704 0 1.152-.395.447-.405.632-1.38l2.426.413q-.378 1.67-1.45 2.522-1.073.853-2.874.853-2.047 0-3.27-1.292-1.212-1.292-1.213-3.577 0-2.312 1.222-3.595 1.222-1.292 3.305-1.292 1.705 0 2.707.738 1.01.73 1.45 2.233m1.784-2.76h2.461v3.814q.615-.069.87-.378.255-.307.616-1.344.474-1.38 1.037-1.767t1.476-.387q.282 0 .976.044l.009 1.635q-.977 0-1.248.185-.273.193-.589 1.151-.43 1.292-1.24 1.591 1.17.325 1.978 2.03.044.088.097.185l1.38 2.575h-2.655l-1.23-2.698q-.378-.818-.659-1.046-.273-.237-.818-.237V18.5h-2.461zm9.053 0h2.373v5.862l3.797-5.862h2.426V18.5h-2.373v-5.968l-3.85 5.968h-2.373zm11.074 0h2.373v5.862l3.797-5.862h2.426V18.5h-2.373v-5.968l-3.85 5.968h-2.373zm5.915-3.788h1.204q-.105 1.196-.843 1.88-.73.678-1.899.678t-1.907-.677q-.73-.686-.835-1.881h1.204q.062.624.44.95.378.316 1.098.316t1.099-.317q.378-.325.439-.95M86.684 31.926l-2.435.44q-.123-.73-.562-1.1-.432-.368-1.126-.368-.922 0-1.476.641-.545.632-.545 2.127 0 1.661.554 2.347.563.685 1.503.685.702 0 1.151-.395.449-.405.633-1.38l2.426.413q-.379 1.67-1.45 2.522-1.072.853-2.875.853-2.047 0-3.27-1.292Q78 36.127 78 33.842q0-2.312 1.222-3.595 1.221-1.292 3.304-1.292 1.706 0 2.707.738 1.012.73 1.45 2.233m1.31 1.775q0-1.23.607-2.382a4.17 4.17 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.119 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.66-.738.659-2.145 0-1.371-.66-2.109-.65-.738-1.616-.738-.968 0-1.626.738-.66.738-.66 2.127m9.026-4.667h2.471v3.77h1.968q.193-1.793 1.354-2.882 1.168-1.1 3.12-1.099 1.969 0 3.225 1.275t1.257 3.673q0 1.407-.474 2.461a3.93 3.93 0 0 1-1.433 1.705q-.966.642-2.522.642-2.242 0-3.34-1.213-1.099-1.222-1.187-2.601h-1.968V38.5h-2.47zm8.878 1.714q-1.029 0-1.503.66-.466.659-.466 2.1 0 1.845.501 2.496.51.64 1.538.641.949 0 1.424-.72.474-.73.474-2.18 0-1.776-.518-2.382-.51-.615-1.45-.615m9.035 3.788V33.06q.642 0 .932-.08.29-.087.544-.404a1.14 1.14 0 0 0 .264-.738q0-.44-.325-.809-.316-.378-.958-.378-.492 0-.879.211-.387.21-.703 1.002l-2.092-.448q.316-1.23 1.354-1.846 1.036-.615 2.364-.615 1.688 0 2.61.774.932.773.932 1.942 0 .729-.404 1.213-.396.474-1.257.888 1.037.28 1.547.852.518.57.518 1.424 0 1.09-1.019 1.88-1.02.783-2.936.783-3.34 0-4.087-2.61l2.259-.413q.545 1.37 1.802 1.37.695 0 1.107-.36.422-.369.422-.861a.98.98 0 0 0-.439-.853q-.431-.316-1.134-.316z"
}, null, -1), d51 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), f51 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), v51 = [
  u51,
  d51,
  f51
];
function p51(t, e) {
  return T(), N("svg", h51, [...v51]);
}
const m51 = { render: p51 }, g51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "172",
  height: "48",
  viewBox: "0 0 172 48"
}, y51 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="m87.29 30.365 1.349-2.92h3.076l-2.686 2.92zm3.556 11.64v-1.552a4 4 0 0 1-1.49 1.308 4.2 4.2 0 0 1-1.948.479q-1.044 0-1.875-.46a2.7 2.7 0 0 1-1.201-1.288q-.37-.83-.371-2.295v-6.562h2.744V36.4q0 2.188.15 2.68.154.494.553.782.4.288 1.016.288.703 0 1.26-.386.556-.386.76-.957.206-.57.206-2.797v-4.375h2.745v10.37zm14.224.001h-2.744v-5.294q0-1.68-.176-2.172a1.53 1.53 0 0 0-.571-.767q-.396-.274-.952-.274-.714 0-1.28.392-.566.39-.776 1.035t-.21 2.383v4.697h-2.744V31.634h2.549v1.522q1.357-1.756 3.418-1.756.908 0 1.66.326.752.328 1.138.835.385.508.537 1.153.15.644.151 1.846zm2.283-.001h2.744V31.634h-2.744zm0-11.777h2.744v-2.539h-2.744zm10.78 6.797q-.527.175-1.67.42-1.143.244-1.494.478-.537.382-.537.967-.001.578.43.996.429.42 1.093.42.743 0 1.415-.488.498-.371.655-.908.108-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.434 1.264 1.103.367.67.367 2.456l-.03 3.203q0 1.368.132 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.263-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.925-.87-.924-2.198 0-.879.42-1.567t1.177-1.055 2.182-.639q1.925-.362 2.666-.674v-.274q0-.79-.39-1.127-.391-.337-1.474-.337-.734 0-1.144.288t-.663 1.01M84.03 20.326V6.01h10.615v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm19.867 0v-1.553q-.568.83-1.49 1.309a4.2 4.2 0 0 1-1.948.478q-1.046.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.371-.83-.37-2.295V9.955h2.743v4.766q0 2.188.151 2.68.151.494.552.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.557-.386.762-.957.205-.572.205-2.798V9.955h2.744v10.37zm7.717 0h-2.744V9.955h2.549v1.475q.654-1.045 1.177-1.377a2.16 2.16 0 0 1 1.186-.332q.938 0 1.807.517l-.85 2.393q-.691-.45-1.29-.45-.574 0-.976.318-.398.316-.63 1.147-.23.831-.23 3.477zm8.187-11.641 1.348-2.92h3.076l-2.686 2.92zm-1.152 6.455q0 1.544.732 2.363.732.82 1.807.821 1.073 0 1.801-.82.728-.822.728-2.383 0-1.524-.728-2.344t-1.8-.82q-1.076 0-1.808.82t-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.908-1.953q1.236-.674 2.76-.674 2.351 0 3.857 1.528 1.504 1.53 1.504 3.863 0 2.355-1.519 3.901-1.519 1.548-3.823 1.548a6 6 0 0 1-2.72-.645 4.4 4.4 0 0 1-1.967-1.889q-.674-1.244-.674-3.032m15.149-.029q0 1.748.693 2.582.693.836 1.69.835.956 0 1.592-.767.633-.765.634-2.513 0-1.632-.654-2.422-.655-.791-1.621-.791-1.008 0-1.67.776-.664.776-.664 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.489q1.806 0 3.067 1.416 1.259 1.417 1.259 3.946 0 2.597-1.269 4.038-1.272 1.44-3.076 1.44a3.5 3.5 0 0 1-1.559-.341q-.698-.344-1.469-1.172v5.224h-2.744zm11.127 7.412 2.754-.42q.176.8.713 1.216.539.415 1.504.415 1.066 0 1.601-.391a.87.87 0 0 0 .362-.732.72.72 0 0 0-.196-.518q-.202-.195-.918-.361-3.319-.732-4.209-1.338-1.23-.84-1.23-2.334 0-1.348 1.064-2.266 1.066-.917 3.301-.917 2.13 0 3.164.693 1.037.694 1.426 2.05l-2.588.479q-.165-.606-.629-.928t-1.324-.322q-1.084 0-1.553.303-.311.215-.312.557 0 .292.273.498.371.273 2.565.77 2.192.5 3.06 1.222.86.732.86 2.04 0 1.426-1.192 2.452-1.19 1.026-3.525 1.025-2.12 0-3.354-.86a3.96 3.96 0 0 1-1.617-2.333m11.493 2.959V6.01h2.743v7.597l3.213-3.652h3.38l-3.546 3.789 3.8 6.582h-2.96l-2.608-4.658-1.279 1.338v3.32zm16.943-4.981q-.527.175-1.67.42-1.143.244-1.494.478-.536.382-.537.967 0 .578.43.996.431.42 1.093.42.743 0 1.416-.488.498-.372.655-.908.107-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.838 0 2.734.435.9.434 1.266 1.103.366.67.365 2.456l-.03 3.203q.001 1.368.134 2.017.132.65.492 1.391h-2.715q-.105-.273-.264-.81a4 4 0 0 0-.097-.322 5 5 0 0 1-1.504 1.025 4.3 4.3 0 0 1-1.71.342q-1.599 0-2.522-.869-.924-.87-.924-2.198 0-.879.42-1.567.418-.688 1.177-1.055.757-.366 2.182-.639 1.925-.361 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01"></path></g>', 1), _51 = [
  y51
];
function q51(t, e) {
  return T(), N("svg", g51, [..._51]);
}
const w51 = { render: q51 }, z51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "172",
  height: "48",
  viewBox: "0 0 172 48"
}, M51 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M90.846 42.006v-1.553q-.567.83-1.49 1.309a4.2 4.2 0 0 1-1.948.478q-1.044.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.371-2.295v-6.562h2.744V36.4q0 2.187.152 2.68.151.494.55.78.402.29 1.017.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798v-4.375h2.744v10.37zm14.524 0h-2.744v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.714 0-1.28.39t-.776 1.036-.21 2.383v4.697h-2.744V31.635h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327t1.138.835q.385.507.537 1.152.15.645.151 1.846zm2.583 0h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zm5.498 0h2.744v-2.539h-2.744zm2.744 1.407v10.049q0 1.982-.259 2.797a2.26 2.26 0 0 1-.996 1.275q-.737.459-1.88.459-.41 0-.883-.073a10 10 0 0 1-1.021-.22l.479-2.344q.195.04.366.064t.317.024q.42 0 .689-.181a.87.87 0 0 0 .356-.434q.088-.254.088-1.524v-9.892zm8.594 5.39q-.528.175-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .578.43.996.429.42 1.093.42.742 0 1.416-.488.498-.371.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.923-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.922-.361 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01M84.03 20.326V6.01h10.615v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm15.892 0-4.18-10.371h2.88l1.954 5.293.567 1.767q.224-.674.283-.888.135-.44.293-.88l1.973-5.292h2.822l-4.121 10.37zm11.098 0h-2.744V9.955h2.55v1.475q.653-1.046 1.175-1.377a2.16 2.16 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.289-.45-.576 0-.977.318-.399.316-.63 1.147t-.229 3.477zm7.035-5.186q0 1.544.732 2.363.733.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.244-.674-3.032m15.148-.03q0 1.748.694 2.583.693.835 1.69.835.956 0 1.591-.767.634-.766.635-2.514 0-1.632-.654-2.422t-1.621-.79q-1.007 0-1.67.775-.664.777-.665 2.3m-2.714-5.01h2.558v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.886-.488q1.805 0 3.066 1.416 1.26 1.417 1.26 3.945 0 2.598-1.27 4.038-1.269 1.441-3.076 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.744zm11.128 7.413 2.754-.42q.175.8.713 1.216.537.415 1.504.415 1.065 0 1.6-.391a.87.87 0 0 0 .363-.732.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.732-4.21-1.338-1.23-.84-1.23-2.334 0-1.348 1.065-2.266t3.3-.917q2.13 0 3.165.693 1.035.694 1.426 2.05l-2.588.479q-.165-.606-.63-.928t-1.323-.322q-1.084 0-1.553.303-.312.215-.312.557 0 .292.273.498.37.273 2.564.77 2.193.5 3.06 1.222.86.732.86 2.04 0 1.425-1.191 2.452t-3.525 1.025q-2.12 0-3.355-.86a3.96 3.96 0 0 1-1.616-2.333m11.591 2.959V6.01h2.744v7.597l3.213-3.652h3.38l-3.546 3.789 3.8 6.582h-2.96l-2.608-4.658-1.279 1.338v3.32zm16.944-4.981q-.528.175-1.67.42-1.143.244-1.494.478-.537.382-.537.967 0 .578.43.996.429.42 1.093.42.743 0 1.416-.488.498-.372.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.434 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.683-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869-.923-.87-.923-2.198 0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.923-.361 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01"></path></g>', 1), b51 = [
  M51
];
function L51(t, e) {
  return T(), N("svg", z51, [...b51]);
}
const x51 = { render: L51 }, S51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "189",
  height: "48",
  viewBox: "0 0 189 48"
}, C51 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M90.845 42.006v-1.553q-.567.83-1.489 1.309a4.2 4.2 0 0 1-1.949.478q-1.043.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.83-.37-2.295v-6.562h2.743V36.4q0 2.187.152 2.68.151.494.551.78.4.29 1.016.29a2.16 2.16 0 0 0 1.26-.386q.556-.386.762-.957.204-.572.205-2.798v-4.375h2.744v10.37zm14.825 0h-2.745v-5.293q0-1.68-.176-2.173a1.53 1.53 0 0 0-.57-.766q-.397-.274-.953-.274-.713 0-1.28.39t-.776 1.036q-.21.645-.21 2.383v4.697h-2.744V31.635h2.55v1.523q1.356-1.758 3.417-1.757.909 0 1.66.327.752.327 1.138.835.385.507.537 1.152.15.645.151 1.846zm2.283 0h2.744V31.635h-2.744zm0-11.778h2.744v-2.539h-2.744zm7.234 6.592q0 1.544.732 2.363.733.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.368.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.674-1.245-.674-3.032m21.786 5.332h-2.744v-5.293q-.001-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V31.635h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327.75.327 1.138.835.385.507.537 1.152.15.645.15 1.846zm8.945-6.074q-.03-1.191-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9 0-1.484.655-.586.654-.577 1.777zm-.156 2.773 2.734.459q-.527 1.505-1.665 2.29-1.138.787-2.847.787-2.704 0-4.003-1.768-1.026-1.416-1.026-3.574 0-2.58 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528t1.28 4.683h-6.875q.028 1.22.664 1.899.634.68 1.582.679.643 0 1.084-.352.44-.351.664-1.133m14.251 3.301h-2.744v-5.293q-.001-1.68-.176-2.173a1.53 1.53 0 0 0-.571-.766q-.396-.274-.952-.274-.713 0-1.28.39-.566.39-.776 1.036-.21.645-.21 2.383v4.697h-2.744V31.635h2.549v1.523q1.357-1.758 3.418-1.757.908 0 1.66.327.75.327 1.138.835.385.507.537 1.152.15.645.15 1.846zm-73.17-21.68V6.01h10.616v2.42h-7.724v3.175h7.187v2.412h-7.187v3.897h7.998v2.412zm19.867 0v-1.553a4 4 0 0 1-1.49 1.309 4.2 4.2 0 0 1-1.948.478q-1.044.001-1.874-.46a2.7 2.7 0 0 1-1.202-1.288q-.37-.829-.371-2.295V9.955h2.744v4.766q0 2.188.152 2.68.151.494.55.78.402.29 1.017.29.703 0 1.26-.386.556-.386.762-.957.204-.572.205-2.798V9.955h2.744v10.37zm7.718 0h-2.744V9.955h2.549v1.475q.654-1.046 1.176-1.377a2.17 2.17 0 0 1 1.187-.332q.938 0 1.807.517l-.85 2.393q-.693-.45-1.29-.45-.576 0-.976.318-.399.319-.63 1.147-.23.831-.23 3.477zm7.034-5.186q0 1.544.732 2.363.733.82 1.807.821 1.073 0 1.802-.82.727-.822.727-2.384 0-1.523-.727-2.343-.728-.82-1.802-.82t-1.807.82-.732 2.363m-2.813-.146q0-1.367.674-2.647a4.63 4.63 0 0 1 1.91-1.953q1.235-.674 2.758-.674 2.354 0 3.858 1.528 1.504 1.53 1.504 3.863 0 2.355-1.52 3.901-1.518 1.548-3.822 1.548a6 6 0 0 1-2.72-.645 4.42 4.42 0 0 1-1.968-1.889q-.675-1.244-.674-3.032m15.149-.03q0 1.748.693 2.583.694.835 1.69.835.957 0 1.592-.767.633-.765.634-2.514 0-1.631-.654-2.422t-1.621-.79q-1.007 0-1.67.775-.663.777-.664 2.3m-2.715-5.01h2.559v1.524a3.8 3.8 0 0 1 1.347-1.27 3.7 3.7 0 0 1 1.885-.488q1.806 0 3.067 1.416 1.259 1.417 1.259 3.945 0 2.599-1.27 4.038-1.269 1.441-3.075 1.441a3.5 3.5 0 0 1-1.558-.342q-.698-.342-1.47-1.172v5.225h-2.744zm18.257 4.297q-.03-1.19-.615-1.812a1.9 1.9 0 0 0-1.426-.62q-.9.001-1.484.655-.586.655-.577 1.777zm-.156 2.773 2.734.46q-.526 1.503-1.665 2.29-1.138.786-2.847.786-2.704 0-4.003-1.768-1.026-1.415-1.026-3.574 0-2.578 1.348-4.038 1.347-1.46 3.408-1.46 2.314 0 3.652 1.528 1.338 1.53 1.28 4.683h-6.875q.028 1.22.664 1.9.634.678 1.582.678.643 0 1.084-.352.44-.35.664-1.133m5.017 3.302h2.744V9.955h-2.744zm0-11.778h2.744V6.009h-2.744zm4.19 8.819 2.754-.42q.175.802.713 1.216.537.415 1.504.415 1.065 0 1.6-.391a.87.87 0 0 0 .363-.732.72.72 0 0 0-.196-.518q-.204-.195-.918-.361-3.32-.732-4.21-1.338-1.23-.84-1.23-2.334 0-1.347 1.065-2.266 1.065-.917 3.3-.917 2.13 0 3.165.693 1.035.694 1.426 2.05l-2.588.479q-.165-.605-.63-.928-.464-.322-1.323-.322-1.084 0-1.553.303-.312.215-.312.557 0 .292.273.498.37.273 2.564.77 2.193.5 3.06 1.222.86.733.86 2.04 0 1.427-1.191 2.452t-3.525 1.025q-2.12 0-3.355-.86a3.96 3.96 0 0 1-1.616-2.333m11.592 2.959V6.01h2.743v7.597l3.213-3.652h3.38l-3.546 3.789 3.8 6.582h-2.96l-2.608-4.658-1.279 1.338v3.32zm16.943-4.981q-.528.176-1.67.42-1.143.244-1.494.478-.537.381-.537.967 0 .578.43.996.429.42 1.093.42.743 0 1.416-.488.498-.37.655-.908.106-.352.107-1.338zm-3.672-2.227-2.49-.449q.42-1.503 1.445-2.226t3.047-.723q1.837 0 2.734.435.898.435 1.265 1.103.366.67.366 2.456l-.03 3.203q0 1.368.133 2.017.132.65.493 1.391h-2.715a11 11 0 0 1-.264-.81 5 5 0 0 0-.097-.322q-.704.684-1.504 1.025a4.3 4.3 0 0 1-1.71.342q-1.6 0-2.523-.869t-.923-2.198q0-.879.42-1.567.418-.688 1.176-1.055.758-.366 2.183-.639 1.922-.36 2.666-.674v-.274q0-.79-.391-1.127-.39-.337-1.474-.337-.734 0-1.143.288-.41.289-.664 1.01"></path></g>', 1), k51 = [
  C51
];
function E51(t, e) {
  return T(), N("svg", S51, [...k51]);
}
const A51 = { render: E51 }, F51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, T51 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M77.292 5.615h2.602v6.979q0 1.66.096 2.153.167.79.791 1.274.633.475 1.723.475 1.107 0 1.67-.448.562-.457.677-1.116.114-.66.114-2.189V5.615h2.601v6.768q0 2.32-.21 3.278-.212.958-.783 1.617-.563.66-1.511 1.055-.95.387-2.479.387-1.845 0-2.804-.422-.948-.43-1.503-1.108-.553-.685-.73-1.432-.254-1.107-.254-3.27zm12.823 3.551h2.277v1.274q1.221-1.485 2.909-1.485.896 0 1.555.37.66.368 1.082 1.115.615-.747 1.327-1.116.711-.369 1.52-.369 1.029 0 1.74.422.712.413 1.064 1.222.255.598.255 1.933V18.5h-2.47v-5.335q0-1.388-.255-1.793-.342-.527-1.055-.527-.518 0-.975.316-.458.317-.66.932-.201.606-.201 1.925V18.5h-2.47v-5.115q0-1.362-.132-1.758t-.413-.589q-.272-.193-.747-.193a1.8 1.8 0 0 0-1.028.307q-.458.307-.66.888-.193.58-.193 1.925V18.5h-2.47zm15.627 4.535q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.757q1.117-.607 2.488-.607 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.125-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m8.992-5.933V5.615h2.469V7.9zm2.469 1.266v9.044q0 1.784-.237 2.514a2.02 2.02 0 0 1-.896 1.151q-.66.413-1.688.413-.37 0-.8-.07a8 8 0 0 1-.914-.194l.431-2.109q.175.035.334.053.149.026.281.026.378 0 .615-.167a.76.76 0 0 0 .326-.387q.079-.228.079-1.37V9.165zm4.439 2.848-2.241-.405q.378-1.353 1.3-2.004.924-.65 2.743-.65 1.651 0 2.461.396.809.386 1.133.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.124.58.448 1.248h-2.443a9 9 0 0 1-.237-.73 5 5 0 0 0-.088-.29 4.5 4.5 0 0 1-1.354.923q-.72.308-1.538.308-1.441 0-2.276-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.054-.95q.686-.333 1.969-.58 1.731-.324 2.4-.606v-.246q0-.712-.352-1.01-.352-.309-1.327-.308-.66 0-1.028.263-.37.255-.598.906m3.305 2.004q-.475.158-1.503.377-1.029.22-1.345.431-.484.344-.484.87 0 .519.387.897t.985.378q.668 0 1.274-.44.448-.334.589-.817.096-.316.097-1.204zm11.619 4.482-2.953-9.334h2.399l1.749 6.117 1.608-6.117h2.382l1.556 6.117 1.784-6.117h2.435L147.06 18.5h-2.373l-1.609-6.003-1.582 6.003zm14.115-6.486-2.241-.405q.378-1.353 1.3-2.004.924-.65 2.743-.65 1.652 0 2.461.396.809.386 1.133.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.449 1.248h-2.444a9 9 0 0 1-.237-.73 4 4 0 0 0-.088-.29 4.5 4.5 0 0 1-1.354.923q-.72.308-1.538.308-1.441 0-2.276-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.054-.95q.686-.333 1.969-.58 1.731-.324 2.4-.606v-.246q0-.712-.352-1.01-.352-.309-1.327-.308-.66 0-1.028.263-.37.255-.598.906m3.305 2.004q-.476.158-1.503.377-1.029.22-1.345.431-.483.344-.483.87 0 .519.386.897.387.378.985.378.668 0 1.274-.44.448-.334.589-.817.096-.316.097-1.204zM77.292 25.615h2.602v6.979q0 1.66.096 2.153.167.79.791 1.275.633.474 1.723.474 1.107 0 1.67-.448.562-.457.677-1.116.114-.66.114-2.189v-7.128h2.601v6.768q0 2.32-.21 3.278-.212.959-.783 1.617-.563.66-1.511 1.055-.95.387-2.479.387-1.845 0-2.804-.422-.948-.43-1.503-1.108-.553-.685-.73-1.432-.254-1.108-.254-3.27zM90.3 38.5V25.615h2.47V38.5zm6.855-6.486-2.24-.405q.377-1.353 1.3-2.004.923-.65 2.742-.65 1.653 0 2.461.396.808.386 1.134.993.333.597.334 2.206l-.027 2.883q0 1.23.115 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.238-.73 4 4 0 0 0-.088-.29q-.633.615-1.353.923t-1.538.308q-1.442 0-2.277-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.399-.606v-.246q0-.711-.352-1.01-.35-.309-1.327-.308-.66 0-1.028.263-.369.255-.598.906m3.305 2.004q-.474.158-1.503.377-1.028.22-1.345.431-.483.343-.483.87 0 .519.387.897.386.378.984.378.668 0 1.274-.44.449-.334.589-.817.097-.316.097-1.204zm3.7-4.852h2.628l2.233 6.627 2.179-6.627h2.558l-3.296 8.982-.589 1.626q-.325.817-.624 1.249a2.6 2.6 0 0 1-.677.694 2.8 2.8 0 0 1-.94.422q-.553.15-1.257.15-.712 0-1.397-.15l-.22-1.934q.58.114 1.046.114.861 0 1.274-.51.413-.5.633-1.283zm13.034 2.848-2.241-.405q.378-1.353 1.301-2.004.922-.65 2.742-.65 1.653 0 2.461.396.808.386 1.134.993.333.597.334 2.206l-.027 2.883q0 1.23.115 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.238-.73 4 4 0 0 0-.088-.29q-.632.615-1.353.923a3.9 3.9 0 0 1-1.538.308q-1.442 0-2.277-.782-.825-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.399-.606v-.246q0-.711-.352-1.01-.35-.309-1.327-.308-.659 0-1.028.263-.369.255-.598.906m3.305 2.004q-.474.158-1.503.377-1.028.22-1.345.431-.483.343-.483.87 0 .519.387.897.386.378.984.378.668 0 1.274-.44.449-.334.589-.817.097-.316.097-1.204z"
}, null, -1), I51 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), O51 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.018h-1.723L33 34.172l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.482zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.027.531 1.65-1.393-1.027zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.017-.532 1.65 1.393-1.017zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm0 14.337h-1.779l1.394 1.026-.532 1.65 1.402-1.017 1.403 1.018-.532-1.65 1.394-1.027h-1.678l-.54-1.65zm4.849 6.27-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.761-.531-1.65 1.393-1.027h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.027-.532 1.65 1.412-1.027zm-9.377-14.08-1.394-1.01h1.724l.532-1.65.531 1.65h1.723l-1.393 1.01.532 1.65-1.393-1.01-1.394 1.018.532-1.65zm6.04 2.575-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.68l.532 1.65-1.394-1.017-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), N51 = [
  T51,
  I51,
  O51
];
function P51(t, e) {
  return T(), N("svg", F51, [...N51]);
}
const B51 = { render: P51 }, V51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, R51 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), H51 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), D51 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M88.929 19h-2.83l-1.125-2.927h-5.15L78.76 19H76l5.019-12.885h2.75zm-4.79-5.098-1.776-4.78-1.74 4.78zM92.198 19l-3.761-9.334h2.592l1.758 4.764.51 1.59q.203-.605.255-.8.123-.395.263-.79l1.776-4.764h2.54L94.42 19zm9.818 0h-2.47V9.666h2.294v1.327q.588-.94 1.055-1.24.474-.297 1.072-.298.843 0 1.626.466l-.765 2.153q-.624-.405-1.16-.404-.519 0-.879.29-.36.281-.571 1.028-.202.747-.202 3.13zm10.793 0v-1.398q-.51.748-1.345 1.178a3.7 3.7 0 0 1-1.749.43 3.43 3.43 0 0 1-1.688-.412 2.44 2.44 0 0 1-1.081-1.16q-.333-.747-.334-2.066V9.666h2.47v4.29q0 1.968.132 2.416.141.44.501.703.36.255.914.255.633 0 1.134-.343a1.8 1.8 0 0 0 .685-.861q.185-.519.185-2.523V9.667h2.47V19zm4.79-9.334h2.302v1.371q.448-.704 1.213-1.142a3.34 3.34 0 0 1 1.697-.44q1.626 0 2.759 1.274t1.134 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.319-1.054v4.702h-2.469zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.86 0 1.432-.686.571-.694.571-2.267 0-1.468-.588-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066m10.477-1.661-2.242-.405q.378-1.353 1.301-2.004.923-.65 2.742-.65 1.653 0 2.461.396.809.386 1.134.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.238-.73 5 5 0 0 0-.087-.29 4.5 4.5 0 0 1-1.354.923q-.72.308-1.538.308-1.442 0-2.276-.782-.827-.783-.827-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.399-.606v-.246q0-.712-.351-1.01-.352-.309-1.327-.308-.66 0-1.029.263-.369.255-.597.906m3.304 2.004q-.474.158-1.503.377-1.028.22-1.344.431-.484.343-.484.87 0 .519.387.897t.984.378q.668 0 1.275-.44.448-.334.589-.817.096-.316.096-1.204zM77.318 25.115h5.15q1.53 0 2.277.132a3.3 3.3 0 0 1 1.345.527q.598.405.993 1.081.395.669.395 1.503 0 .906-.492 1.662a3 3 0 0 1-1.318 1.133q1.178.343 1.81 1.17.633.825.633 1.942 0 .879-.413 1.713-.404.827-1.116 1.328-.704.492-1.74.606-.651.07-3.138.088h-4.386zm2.602 2.145v2.98h1.705q1.521 0 1.89-.045.668-.078 1.046-.457.386-.387.386-1.01 0-.598-.334-.967-.325-.379-.975-.457-.388-.044-2.224-.044zm0 5.124v3.445h2.408q1.407 0 1.784-.079.58-.105.94-.51.37-.412.37-1.098 0-.58-.281-.985t-.818-.589q-.527-.184-2.302-.184zM90.3 27.4v-2.285h2.47V27.4zm0 10.6v-9.334h2.47V38zm7.374 0h-2.47v-9.334h2.294v1.327q.589-.94 1.055-1.24a1.97 1.97 0 0 1 1.072-.298q.844 0 1.626.466l-.765 2.153q-.623-.405-1.16-.404-.518 0-.879.29-.36.282-.571 1.028-.202.747-.202 3.13zm4.649 0V25.115h2.47V38zm5.01-10.6v-2.285h2.47V27.4zm0 10.6v-9.334h2.47V38zm4.781.615 2.822.343q.07.492.325.677.351.263 1.107.263.967 0 1.45-.29.325-.192.493-.624.114-.308.114-1.133v-1.363Q117.318 38 115.63 38q-1.88 0-2.98-1.59-.861-1.258-.861-3.13 0-2.346 1.125-3.586 1.134-1.239 2.813-1.239 1.731 0 2.856 1.52v-1.309h2.312v8.376q0 1.653-.273 2.47-.272.817-.765 1.283-.492.466-1.318.73-.817.263-2.074.263-2.373 0-3.366-.817-.994-.81-.994-2.057 0-.123.009-.299m2.206-5.475q0 1.484.572 2.18.58.684 1.423.685.906 0 1.53-.703.624-.712.624-2.1 0-1.451-.598-2.154a1.9 1.9 0 0 0-1.512-.703q-.887 0-1.467.694-.572.686-.572 2.1m3.534-8.245h1.204q-.106 1.195-.844 1.881-.729.677-1.899.677t-1.907-.677q-.729-.686-.835-1.88h1.204q.062.623.44.949.378.316 1.098.316t1.099-.316q.377-.326.44-.95m5.493 2.506v-2.285h2.469V27.4zm0 10.6v-9.334h2.469V38z"
}, null, -1), $51 = [
  R51,
  H51,
  D51
];
function U51(t, e) {
  return T(), N("svg", V51, [...$51]);
}
const j51 = { render: U51 }, G51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, W51 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M84.794 10.994v2.162H80.75q.22 1.731 1.028 2.55a2.7 2.7 0 0 0 1.969.808q1.186 0 1.96-.703.774-.712.95-2.04l2.61.81q-.45 1.923-1.811 3.031-1.362 1.108-3.542 1.108-2.232 0-3.524-1.055-1.284-1.055-1.837-2.434-.555-1.38-.554-3.103 0-3.024 1.59-4.878t4.378-1.854q2.152 0 3.498 1.019 1.353 1.02 1.766 2.76l-2.575.589q-.28-1.011-1.037-1.565a2.84 2.84 0 0 0-1.723-.553q-1.388 0-2.197.958-.8.949-.949 2.39zm6.566-1.828h5.405q1.66 0 2.487.606.825.607.826 1.829 0 .781-.457 1.362a2.13 2.13 0 0 1-1.134.773q.967.238 1.442.888.474.65.474 1.424 0 1.09-.8 1.775-.799.677-2.364.677h-5.88zm2.487 3.876h1.59q1.152 0 1.662-.29.518-.29.518-.914 0-.59-.483-.835-.475-.255-1.697-.255h-1.59zm0 3.876h1.95q1.056 0 1.539-.255t.483-.914q0-.685-.553-.94-.554-.264-2.154-.264h-1.265zm8.49-7.752h2.303v1.371q.448-.704 1.213-1.142a3.34 3.34 0 0 1 1.696-.44q1.626 0 2.76 1.274t1.133 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.318-1.054v4.702h-2.47zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.861 0 1.432-.686.572-.694.572-2.267 0-1.468-.589-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066m8.06.026q0-1.23.606-2.382a4.2 4.2 0 0 1 1.714-1.757q1.116-.607 2.487-.607 2.12 0 3.472 1.38 1.353 1.37 1.354 3.472 0 2.118-1.371 3.515-1.363 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.767-1.696q-.606-1.125-.606-2.734m2.531.132q0 1.389.659 2.127.66.738 1.626.738.967 0 1.617-.738.66-.738.66-2.145 0-1.371-.66-2.109-.65-.738-1.617-.738-.966 0-1.626.738t-.659 2.127m8.947-4.667h8.288V18.5h-2.469v-7.339h-3.349V18.5h-2.47zm16.383 6.364 2.461.412q-.474 1.354-1.503 2.066-1.02.703-2.557.703-2.435 0-3.604-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.067-1.318 2.083 0 3.288 1.38 1.203 1.37 1.151 4.21h-6.188q.027 1.098.598 1.714.572.606 1.424.606.58 0 .976-.316.394-.316.597-1.02m.141-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.808 0-1.336.589-.527.588-.519 1.6zm4.412-3.866h2.373v5.862l3.797-5.862h2.426V18.5h-2.373v-5.968l-3.85 5.968h-2.373zm5.915-3.788h1.204q-.106 1.196-.844 1.88-.73.678-1.898.678-1.169 0-1.907-.677-.73-.686-.835-1.881h1.204q.061.624.439.95.378.316 1.099.316.72 0 1.098-.317.378-.325.44-.95m13.359 6.549-2.434.44q-.123-.73-.563-1.1-.43-.368-1.125-.368-.923 0-1.476.641-.546.632-.545 2.127 0 1.661.553 2.347.563.685 1.503.685.704 0 1.152-.395.448-.405.633-1.38l2.425.413q-.378 1.67-1.45 2.522-1.073.853-2.874.853-2.048 0-3.269-1.292-1.213-1.292-1.213-3.577 0-2.312 1.221-3.595 1.222-1.292 3.305-1.292 1.705 0 2.707.738 1.01.73 1.45 2.233m1.934-2.76h2.47v3.876h2.478q1.46 0 2.241.21.783.212 1.301.915.519.695.519 1.617 0 1.353-.932 2.04-.923.675-2.777.676h-5.3zm2.47 7.77h2.302q1.082 0 1.38-.352.308-.352.308-.835 0-.677-.527-.932-.519-.255-1.855-.255h-1.608zm8.455-7.77h2.461v3.814q.615-.069.87-.378.255-.307.615-1.344.474-1.38 1.037-1.767t1.477-.387q.28 0 .975.044l.009 1.635q-.975 0-1.248.185-.273.193-.589 1.151-.43 1.292-1.239 1.591 1.168.325 1.977 2.03l.097.185 1.38 2.575h-2.654l-1.231-2.698q-.378-.818-.659-1.046-.273-.237-.817-.237V18.5h-2.461zm9.052 0h2.373v5.862l3.797-5.862h2.426V18.5h-2.373v-5.968l-3.85 5.968h-2.373zm11.075 0h2.373v5.862l3.797-5.862h2.425V18.5h-2.373v-5.968l-3.849 5.968h-2.373zm5.915-3.788h1.204q-.106 1.196-.844 1.88-.73.678-1.898.678-1.17 0-1.908-.677-.729-.686-.835-1.881h1.205q.061.624.439.95.378.316 1.099.316.72 0 1.098-.317.378-.325.44-.95M86.78 33.763l2.522.8q-.58 2.11-1.934 3.137-1.344 1.02-3.419 1.02-2.566 0-4.218-1.75-1.653-1.756-1.653-4.798 0-3.218 1.661-4.992 1.662-1.785 4.368-1.785 2.365 0 3.841 1.398.88.826 1.319 2.373l-2.576.615q-.228-1.002-.958-1.582-.72-.58-1.757-.58-1.434 0-2.33 1.029-.887 1.028-.887 3.33 0 2.445.879 3.481t2.285 1.037q1.037 0 1.784-.66.748-.658 1.072-2.073m4.175-.062q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.758q1.117-.606 2.488-.606 2.119 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.531.132q0 1.389.66 2.127.659.738 1.626.738t1.617-.738q.66-.738.659-2.145 0-1.371-.66-2.109-.65-.738-1.617-.738-.966 0-1.626.738t-.659 2.127m9.027-4.667h2.469v3.77h1.969q.193-1.793 1.354-2.882 1.169-1.1 3.12-1.099 1.969 0 3.225 1.275t1.257 3.673q0 1.407-.474 2.461a3.93 3.93 0 0 1-1.433 1.705q-.967.642-2.522.642-2.242 0-3.34-1.213-1.099-1.222-1.187-2.601h-1.969V38.5h-2.469zm8.877 1.714q-1.029 0-1.503.66-.466.659-.466 2.1 0 1.845.501 2.496.51.64 1.538.641.949 0 1.424-.72.474-.73.474-2.18 0-1.776-.518-2.382-.51-.615-1.45-.615m9.035 3.788V33.06q.642 0 .931-.08.29-.087.545-.404a1.14 1.14 0 0 0 .264-.738q0-.44-.325-.809-.316-.378-.958-.378-.492 0-.879.211-.387.21-.703 1.002l-2.092-.448q.316-1.23 1.354-1.846 1.036-.615 2.364-.615 1.687 0 2.61.774.932.773.932 1.942 0 .729-.405 1.213-.395.474-1.256.888 1.037.28 1.547.852.518.57.518 1.424 0 1.09-1.019 1.88-1.02.783-2.936.783-3.34 0-4.087-2.61l2.259-.413q.545 1.37 1.802 1.37.694 0 1.107-.36.422-.369.422-.861a.98.98 0 0 0-.44-.853q-.43-.316-1.133-.316z"
}, null, -1), Y51 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), X51 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), K51 = [
  W51,
  Y51,
  X51
];
function Z51(t, e) {
  return T(), N("svg", G51, [...K51]);
}
const J51 = { render: Z51 }, Q51 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, e01 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), t01 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), n01 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M107.183 14.803c-.888-.72-2.664-1.752-3.936-2.4l-1.296 1.608c1.296.744 3.024 1.848 3.84 2.592zm-.912 6.192c-.936-.648-2.76-1.632-4.056-2.256l-1.272 1.632c1.344.696 3.144 1.752 4.008 2.448zm-2.856 12.888c1.008-2.232 2.16-5.064 3.024-7.584l-1.824-1.176c-.96 2.736-2.256 5.76-3.216 7.608zm8.376-14.04V12.74h-2.112v8.136c0 1.032-.024 2.04-.072 3.072a32 32 0 0 0-1.512-4.68l-1.608.576c.672 1.752 1.368 4.104 1.536 5.64l1.488-.552c-.264 2.856-1.008 5.592-2.88 7.944.576.264 1.44.888 1.872 1.296 2.952-3.792 3.288-8.616 3.288-13.296v-.552c.624 1.608 1.2 3.576 1.416 4.872l1.608-.624c-.288-1.392-.96-3.576-1.68-5.232zm8.136-7.128v10.56c-.504-1.344-1.296-2.976-2.064-4.296l-.96.432V13.1h-2.064v20.496h2.064V20.731c.768 1.536 1.512 3.312 1.824 4.536l1.2-.576v9.48h2.136V12.715zm19.68 3.336c-.432-1.008-1.416-2.472-2.376-3.552l-1.8.84c.912 1.128 1.872 2.664 2.28 3.72zm-8.16 2.088h-3.192v-2.976h3.192zm-3.192 6.72h3.192v2.544c-1.08.192-2.184.36-3.192.528zm3.192-1.848h-3.192v-3.024h3.192zm2.976-7.848v-2.016h-9.216v2.016h1.128v13.08c-.576.072-1.08.144-1.56.216l.336 2.112c1.8-.36 4.056-.768 6.336-1.2v4.824h1.92V15.163zm12.48 10.032V23.18h-5.688c.072-.768.096-1.536.096-2.16v-1.896h4.992v-2.04h-3.192c.768-1.152 1.608-2.616 2.328-3.984l-2.28-.6c-.528 1.392-1.464 3.288-2.304 4.584h-6.048v2.04h4.248v1.848c0 .624 0 1.392-.072 2.208h-4.608v2.016h4.296c-.528 2.472-1.824 5.232-4.944 7.56.576.336 1.368 1.008 1.752 1.464 3.456-2.736 4.872-6.096 5.448-9.024zm-6.048 2.472c1.704 2.016 3.744 4.776 4.656 6.456l1.68-1.32c-.936-1.68-3.048-4.344-4.776-6.288zm26.448-13.007v1.8h-4.944v-1.8zm-5.064 5.207c.072-.624.12-1.248.12-1.824h4.944v1.824zm5.064 1.608v1.632c0 .312-.12.408-.456.408-.312 0-1.392.024-2.544-.024.312.504.696 1.296.816 1.872 1.56 0 2.688-.048 3.432-.36.72-.312.96-.84.96-1.896V12.883h-9.192v4.872c0 2.112-.264 4.68-2.616 6.456.456.288 1.248 1.032 1.56 1.464 1.464-1.128 2.256-2.664 2.664-4.2zm-11.112-6.456v2.184h-3.744V15.02zm-3.744 6.072v-2.184h3.744v2.184zm0 1.752h5.76v-9.576h-7.8v10.824h2.04zm1.488 4.896h2.688v3.84h-2.688zm7.44 0v3.84h-2.712v-3.84zm4.776 0v3.84h-2.736v-3.84zm2.16 3.84v-5.592h-16.464v5.592h-2.784v1.944h21.888V31.58zM80.112 19.472c.936.864 1.92 1.872 2.856 2.904-.768 1.8-1.728 3.384-2.856 4.608zm13.848-1.32h2.472c-.24 1.464-.552 2.976-.888 4.08l1.632.888c.696-1.68 1.296-4.296 1.656-6.576l-1.512-.576-.36.144h-5.736c.288-1.272.528-2.592.72-3.912l-2.232-.36c-.48 3.792-1.344 7.512-2.904 9.84.552.288 1.464 1.056 1.824 1.416.84-1.32 1.512-3.024 2.064-4.944h1.08v3.096c.024 1.776-.576 5.928-3.576 9v-1.272h-8.088v-1.944c.456.336 1.296 1.008 1.608 1.392 1.032-1.2 1.92-2.664 2.688-4.296.864 1.056 1.56 2.064 2.04 2.928l1.416-1.656c-.552-.984-1.488-2.184-2.568-3.408.672-1.776 1.2-3.696 1.608-5.712l-2.04-.336a34 34 0 0 1-1.128 4.344 56 56 0 0 0-2.448-2.376l-1.176 1.296v-3.816h7.92v-2.064H78v19.464h2.112v-1.728h7.2c-.408.336-.84.648-1.32.936.408.408 1.032 1.368 1.296 1.824 3.72-2.304 5.256-6.456 5.568-8.496.312 1.968 1.656 6.312 4.944 8.496.336-.528.984-1.44 1.392-1.92-4.392-2.928-5.232-8.568-5.232-10.656z"
}, null, -1), i01 = [
  e01,
  t01,
  n01
];
function s01(t, e) {
  return T(), N("svg", Q51, [...i01]);
}
const l01 = { render: s01 }, r01 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, a01 = /* @__PURE__ */ U1('<path fill="#fff" d="M16.52 28.44q0-.46.08-1.08t.3-1.4a12.5 12.5 0 0 1 .66-1.78l2.46.86q-.22.62-.38 1.14a8 8 0 0 0-.24.94q-.08.42-.08.84 0 .66.28 1.18.3.54.86.9.56.38 1.36.58.82.2 1.88.2 1.1 0 1.96-.1.88-.1 1.48-.3.62-.2.94-.52.32-.3.32-.7a.5.5 0 0 0-.14-.34q-.12-.16-.42-.34a5 5 0 0 0-.76-.38q-.46-.2-1.12-.44l.66-2.82q.86.36 1.62.64.78.26 1.48.44.7.16 1.32.26.62.08 1.16.08.76 0 1.08.4.32.38.32.96 0 .62-.42 1.04-.42.4-1.18.4h-.92q.04.2.04.34v.3q0 .66-.46 1.34-.44.68-1.38 1.26t-2.4.92q-1.44.36-3.44.36-2.16 0-3.72-.56-1.54-.54-2.38-1.7-.82-1.14-.82-2.92m8.88 9.82q-.58 0-1-.42a1.3 1.3 0 0 1-.4-.96q0-.58.4-1 .42-.42 1-.42.56 0 .96.42t.4 1q0 .56-.4.96-.4.42-.96.42m-3.46 0q-.58 0-1-.42a1.3 1.3 0 0 1-.4-.96q0-.58.4-1 .42-.42 1-.42.56 0 .96.42t.4 1q0 .56-.4.96-.4.42-.96.42"></path><path fill="#fff" d="m31.996 29.1.2-2.8q.88 0 1.38-.12.52-.12.74-.44.22-.34.22-.96 0-.56-.16-1.34a17 17 0 0 0-.38-1.62q-.24-.84-.48-1.54l2.76-.76a21 21 0 0 1 .88 3.44q.18.94.18 1.82 0 1.1-.28 1.86a3.5 3.5 0 0 1-.78 1.24q-.48.48-1.16.76-.66.26-1.46.36t-1.66.1m2.46 4.6a1.4 1.4 0 0 1-1-.4 1.33 1.33 0 0 1-.4-.98q0-.58.4-1.02.42-.42 1-.42t.98.42q.42.44.42 1.02t-.42.98q-.4.4-.98.4m5.028-.1-.58-2.8a22 22 0 0 0 2.48-.44q1.06-.24 1.78-.68t1.08-1.2q.36-.78.36-2 0-.44-.08-.88a4 4 0 0 0-.24-.84 1.8 1.8 0 0 0-.42-.62.8.8 0 0 0-.58-.24.9.9 0 0 0-.64.26q-.28.24-.44.62-.16.36-.16.74 0 .28.14.48.14.18.42.28.28.08.7.08.48 0 .98-.1.52-.12.94-.32l.08 2.18q-.48.38-1.1.68-.621.28-1.5.28-.72 0-1.34-.16-.62-.18-1.1-.54a2.5 2.5 0 0 1-.72-.92q-.26-.58-.26-1.38 0-.98.32-1.9t.88-1.64a4.5 4.5 0 0 1 1.32-1.16 3.15 3.15 0 0 1 1.6-.44q.999 0 1.74.5.759.5 1.26 1.32.5.8.76 1.74a6.8 6.8 0 0 1 .26 1.8q0 2.26-.96 3.84t-2.74 2.44q-1.78.88-4.24 1.02m9.141 0-1.02-2.56q1.72-.6 2.78-1.32 1.08-.72 1.58-1.54.52-.82.52-1.7 0-.56-.16-1.16a8.5 8.5 0 0 0-.46-1.3 15 15 0 0 0-.68-1.42l2.62-1.26q.699 1.34 1.08 2.56.4 1.22.4 2.28 0 .98-.26 1.88-.24.9-.76 1.68a6.8 6.8 0 0 1-1.3 1.5q-.8.7-1.88 1.28-1.08.6-2.46 1.08m9.003 0-.58-2.8q1.42-.18 2.48-.44 1.06-.24 1.78-.68t1.08-1.2q.36-.78.36-2 0-.44-.08-.88a4 4 0 0 0-.24-.84 1.8 1.8 0 0 0-.42-.62.8.8 0 0 0-.58-.24.9.9 0 0 0-.64.26q-.28.24-.44.62-.16.36-.16.74 0 .28.14.48.141.18.42.28.28.08.7.08.48 0 .98-.1.52-.12.94-.32l.08 2.18q-.48.38-1.1.68-.62.28-1.5.28-.72 0-1.34-.16a3.4 3.4 0 0 1-1.1-.54 2.5 2.5 0 0 1-.72-.92q-.26-.58-.26-1.38 0-.98.32-1.9t.88-1.64q.58-.74 1.32-1.16a3.15 3.15 0 0 1 1.6-.44q1 0 1.74.5a4.1 4.1 0 0 1 1.26 1.32q.5.8.76 1.74a6.8 6.8 0 0 1 .26 1.8q0 2.26-.96 3.84t-2.74 2.44q-1.78.88-4.24 1.02M74.33 18.28q0-.66-.08-1.32-.06-.66-.16-1.24a71 71 0 0 0-.18-1.04l2.8-.4q.08.4.16 1.06t.14 1.4q.06.72.06 1.38a10 10 0 0 1-.18 1.96 8.3 8.3 0 0 1-.54 1.74 8.6 8.6 0 0 1-.9 1.54l-.36.48q-.52.64-1.22 1.26-.681.62-1.5 1.2h1.3q.68 0 1.04-.08t.48-.22a.53.53 0 0 0 .14-.36q0-.36-.62-1.06-.62-.72-1.72-1.64a35 35 0 0 0-2.58-1.98 54 54 0 0 0-3.16-2.12l1.46-2.14q2.36 1.46 3.98 2.68 1.64 1.22 2.68 2.22 1.06 1 1.64 1.82t.8 1.48q.22.64.22 1.16 0 .58-.18 1.12-.18.52-.58.94-.4.4-1.04.64t-1.58.24h-5.88v-2.68q2.06-1.48 3.26-2.8 1.22-1.32 1.76-2.6a6.7 6.7 0 0 0 .54-2.64m-7.26-1.88-.34-1.4q.7-.12 1.04-.2.36-.08.76-.18l-.2.5q-.52-.18-1-.7a1.83 1.83 0 0 1-.46-1.22q0-.72.32-1.16t.82-.64 1.04-.2q.3 0 .56.04.28.04.5.12l-.16 1.44-.4-.08a2.3 2.3 0 0 0-.44-.04.74.74 0 0 0-.48.18.5.5 0 0 0-.2.4q0 .34.24.6t.56.42q.34.14.56.16l-1.1.12q.54-.14 1.02-.28.48-.16.9-.32l.4 1.34q-.5.18-1.18.4-.66.2-1.38.38-.7.18-1.38.32M81.291 29l-.42-14.64h2.8l.42 14.64zm9.765-.8.98-2.54q.74.32 1.42.48t1.36.16q.7 0 1.16-.12.48-.14.72-.4t.24-.62q0-.34-.22-.94-.2-.6-.74-1.56-.54-.98-1.58-2.42l2.38-1.58a26 26 0 0 1 1.66 2.66 15.3 15.3 0 0 1 1.08 2.4q.4 1.1.4 1.94 0 1.04-.56 1.82-.54.76-1.62 1.2-1.06.44-2.62.44-.58 0-1.3-.1t-1.46-.3a6 6 0 0 1-1.3-.52m15.972.9q-1.86 0-2.88-.38-1-.38-1.4-1.18-.4-.82-.46-2.06l-.42-11.12h2.8l.42 9.78q.04.92.2 1.38a.96.96 0 0 0 .6.62q.46.16 1.34.16.759 0 1.08.4.34.38.34.96 0 .62-.42 1.04-.42.4-1.2.4"></path><path fill="#fff" d="M120.135 29.1a10 10 0 0 1-1.72-.14 5.1 5.1 0 0 1-1.44-.48 4.1 4.1 0 0 1-1.18-.98q-.501-.62-.84-1.56l1.58-1.26q.36.64.88 1 .52.34 1.24.48t1.68.14q.759 0 1.08.4.32.38.32.96 0 .62-.42 1.04-.4.4-1.18.4m-13.08 0 .2-2.8q1.08 0 2.14-.12t2.06-.36 1.9-.62a9.7 9.7 0 0 0 1.72-.92q-.6-.36-1.3-.62a7.5 7.5 0 0 0-1.5-.38 9.4 9.4 0 0 0-1.66-.14q-.32 0-.68.02-.34.02-.7.08-.36.04-.72.12l-.4-2.74q.58-.16 1.22-.22.66-.08 1.16-.08 1.08 0 1.98.24a9.6 9.6 0 0 1 1.68.6q.78.36 1.44.72.68.36 1.28.6.62.24 1.2.24h.74l.32 2.66a5 5 0 0 0-1.62.34 9.4 9.4 0 0 0-1.48.72q-.72.42-1.56.88a14 14 0 0 1-1.86.86q-1.041.4-2.4.66-1.36.26-3.16.26"></path><path fill="#fff" d="m120.141 29.1.2-2.8q1.2 0 1.84-.12t.88-.44q.26-.34.26-.96 0-.56-.16-1.34-.14-.78-.38-1.62a17 17 0 0 0-.48-1.54l2.76-.76q.26.68.5 1.58t.4 1.86q.16.94.16 1.82 0 1.36-.44 2.22-.44.84-1.24 1.3-.78.46-1.88.64-1.1.16-2.42.16m5.42-11.2a1.4 1.4 0 0 1-1-.4q-.4-.42-.4-.98 0-.58.4-1 .42-.42 1-.42.56 0 .96.42t.4 1q0 .56-.4.98a1.3 1.3 0 0 1-.96.4m-3.46-.02a1.4 1.4 0 0 1-1-.4q-.4-.42-.4-.98 0-.58.4-1 .42-.42 1-.42.56 0 .96.42t.4 1q0 .56-.4.98a1.3 1.3 0 0 1-.96.4m13.107.4q0-.66-.08-1.32-.06-.66-.16-1.24-.1-.6-.18-1.04l2.8-.4q.08.4.16 1.06t.14 1.4q.06.72.06 1.38a10 10 0 0 1-.18 1.96 8.3 8.3 0 0 1-.54 1.74 8.6 8.6 0 0 1-.9 1.54l-.36.48q-.52.64-1.22 1.26a16 16 0 0 1-1.5 1.2h1.3q.68 0 1.04-.08t.48-.22a.53.53 0 0 0 .14-.36q0-.36-.62-1.06-.62-.72-1.72-1.64a35 35 0 0 0-2.58-1.98 54 54 0 0 0-3.16-2.12l1.46-2.14q2.36 1.46 3.98 2.68 1.64 1.22 2.68 2.22 1.06 1 1.64 1.82t.8 1.48q.22.64.22 1.16 0 .58-.18 1.12a2.6 2.6 0 0 1-.58.94q-.4.4-1.04.64t-1.58.24h-5.88v-2.68q2.06-1.48 3.26-2.8 1.22-1.32 1.76-2.6a6.7 6.7 0 0 0 .54-2.64M141.565 29l-.42-14.64h2.8l.42 14.64z"></path><path fill="#039" d="M154.878.88h63.243v42.24h-63.243z"></path><path fill="#FC0" fill-rule="evenodd" d="m184.339 7.744 1.335.977-.509 1.593 1.335-.986 1.335.986-.509-1.593 1.335-.977h-1.652L186.5 6.16l-.509 1.584zm3.496 30.096-.509-1.584 1.335-.977h-1.652l-.509-1.593-.509 1.593h-1.652l1.335.977-.509 1.584 1.335-.977zM172.85 23.057l-1.335.985.509-1.584-1.335-.95h1.652l.509-1.584.509 1.584h1.661l-1.344.985.509 1.584-1.335-.985zm8.16-10.913-.509-1.584 1.335-.968h-1.652l-.509-1.584-.509 1.584h-1.652l1.335.977-.509 1.584 1.335-.977zm-6.807 2.482.509-1.584.518 1.584h1.608l-1.335.986.509 1.584-1.344-.986-1.344.986.51-1.584-1.335-.986zm0 13.763h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.509-1.584 1.335-.985h-1.608l-.518-1.584zm4.646 6.02-1.335-.969h1.652l.509-1.584.509 1.584h1.652l-1.335.968.509 1.584-1.335-.976-1.335.976zm22.636-10.332-.509-1.584 1.335-.985h-1.616l-.51-1.584-.509 1.584h-1.713l1.344.985-.51 1.584 1.353-.985zm-8.986-13.517-1.335-.968h1.652l.509-1.584.509 1.584h1.652l-1.335.968.509 1.584-1.335-.968-1.335.977.509-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.986-.51 1.584 1.344-.986 1.335.986-.509-1.584 1.3-.995h-1.652zm.553 15.356h1.608l-1.3.985.509 1.584-1.335-.976-1.344.976.51-1.584-1.327-.985h1.652l.518-1.584zm-4.69 6.02 1.335-.969h-1.652l-.509-1.584-.509 1.584h-1.652l1.335.968-.509 1.584 1.335-.976 1.335.976z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M219 44h-65V0h65zM218.122.88h-63.244v42.24h63.244z" clip-rule="evenodd"></path>', 7), o01 = [
  a01
];
function c01(t, e) {
  return T(), N("svg", r01, [...o01]);
}
const h01 = { render: c01 }, u01 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, d01 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), f01 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), v01 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.636 24.367H77.3v6.823q0 1.624.094 2.105.163.774.778 1.242.613.47 1.678.469 1.081 0 1.631-.443.551-.443.661-1.087.113-.645.112-2.14v-6.97h2.542v6.618q0 2.269-.206 3.205-.206.938-.76 1.581-.554.645-1.481 1.027-.927.383-2.422.383-1.803 0-2.734-.417-.932-.417-1.473-1.083a3.5 3.5 0 0 1-.713-1.396q-.249-1.083-.25-3.197zm20.468 12.598h-2.413v-4.658q0-1.478-.155-1.912a1.34 1.34 0 0 0-.501-.674 1.43 1.43 0 0 0-.838-.241q-.626 0-1.126.344-.497.343-.681.91-.186.568-.186 2.098v4.133h-2.412v-9.126h2.24v1.34q1.197-1.547 3.006-1.546.799 0 1.46.287.662.288 1.002.735a2.7 2.7 0 0 1 .472 1.014q.131.567.132 1.624zm2.007 0h2.413V28.72h-2.413zm0-10.364h2.413v-2.235h-2.413zm10.04 5.019q-.026-1.049-.541-1.595a1.66 1.66 0 0 0-1.253-.546q-.79 0-1.305.577-.515.575-.508 1.564zm-.137 2.44 2.404.404q-.464 1.324-1.463 2.015t-2.504.692q-2.377 0-3.52-1.555-.903-1.247-.902-3.145 0-2.27 1.185-3.554 1.185-1.285 2.997-1.285 2.035 0 3.211 1.345 1.177 1.345 1.125 4.121h-6.045q.026 1.074.584 1.671.558.598 1.391.598.566 0 .953-.31t.584-.997M74.768 18.767V6.169h9.334v2.13H77.31v2.793h6.32v2.123h-6.32v3.43h7.033v2.122zm17.469 0V17.4a3.5 3.5 0 0 1-1.31 1.152 3.7 3.7 0 0 1-1.714.42q-.917.001-1.647-.403a2.38 2.38 0 0 1-1.057-1.135q-.327-.73-.326-2.02V9.64h2.412v4.194q0 1.925.134 2.359.133.435.484.687.353.254.894.254.618 0 1.108-.34.49-.339.67-.841.18-.504.18-2.463V9.64h2.413v9.127zm6.786 0H96.61V9.64h2.242v1.298q.574-.92 1.033-1.212a1.9 1.9 0 0 1 1.044-.292q.825 0 1.589.455l-.747 2.106q-.61-.396-1.134-.396-.506 0-.859.28-.35.28-.554 1.01-.201.73-.201 3.06zm6.185-4.563q0 1.358.644 2.079t1.589.723q.944 0 1.584-.723.64-.721.639-2.097 0-1.34-.639-2.062-.64-.722-1.584-.722t-1.589.722-.644 2.08m-2.473-.129q0-1.203.592-2.33a4.07 4.07 0 0 1 1.68-1.718q1.085-.593 2.425-.593 2.07 0 3.392 1.345t1.323 3.399q0 2.07-1.336 3.433t-3.362 1.362q-1.253 0-2.391-.567a3.9 3.9 0 0 1-1.731-1.663q-.592-1.095-.592-2.668m13.32-.026q0 1.538.61 2.273t1.486.735q.841 0 1.399-.675.558-.674.558-2.213 0-1.435-.575-2.131-.575-.697-1.426-.696a1.85 1.85 0 0 0-1.468.683q-.584.684-.584 2.024m-2.387-4.409h2.25v1.341q.438-.687 1.184-1.117a3.27 3.27 0 0 1 1.658-.43q1.588 0 2.697 1.246 1.107 1.245 1.107 3.472 0 2.286-1.116 3.553-1.117 1.268-2.705 1.268-.755 0-1.37-.3-.613-.302-1.292-1.032v4.598h-2.413zm16.054 3.782q-.027-1.049-.541-1.595a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.305.577-.516.574-.507 1.563zm-.138 2.44 2.404.404q-.462 1.324-1.464 2.015-1 .692-2.503.692-2.377 0-3.52-1.555-.902-1.247-.902-3.146 0-2.269 1.185-3.553t2.997-1.285q2.036 0 3.211 1.345 1.177 1.345 1.126 4.12h-6.046q.026 1.075.584 1.672.558.598 1.391.598.567 0 .953-.31.387-.31.584-.997m3.65.301 2.421-.37q.154.705.627 1.07.472.366 1.323.366.936 0 1.407-.345a.77.77 0 0 0 .319-.644.63.63 0 0 0-.173-.456q-.179-.171-.807-.317-2.92-.644-3.701-1.178-1.081-.738-1.081-2.054 0-1.185.935-1.994.936-.806 2.903-.807 1.871 0 2.782.61.91.61 1.254 1.805l-2.276.42q-.145-.532-.554-.816-.407-.283-1.163-.283-.954 0-1.366.266-.274.19-.274.49 0 .258.24.439.326.24 2.255.678t2.691 1.075q.756.644.756 1.796 0 1.254-1.048 2.157-1.048.902-3.099.902-1.865 0-2.951-.756a3.5 3.5 0 0 1-1.42-2.054m15.785-2.741q-.026-1.049-.541-1.595a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.304.577-.516.574-.508 1.563zm-.137 2.44 2.404.404q-.464 1.324-1.464 2.015t-2.503.692q-2.379 0-3.52-1.555-.903-1.247-.903-3.146 0-2.269 1.186-3.553 1.184-1.284 2.996-1.285 2.036 0 3.212 1.345t1.125 4.12h-6.045q.026 1.075.584 1.672.558.598 1.391.598.566 0 .953-.31t.584-.997",
  "clip-rule": "evenodd"
}, null, -1), p01 = [
  d01,
  f01,
  v01
];
function m01(t, e) {
  return T(), N("svg", u01, [...p01]);
}
const g01 = { render: m01 }, y01 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, _01 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), q01 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), w01 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), z01 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M77.292 6.115h2.602v6.979q0 1.66.096 2.153.167.79.791 1.274.633.475 1.723.475 1.107 0 1.67-.448.562-.457.677-1.116.114-.66.114-2.189V6.115h2.601v6.768q0 2.32-.21 3.278-.212.958-.783 1.617-.563.66-1.511 1.055-.95.387-2.479.387-1.845 0-2.804-.422-.948-.43-1.503-1.108-.553-.685-.73-1.432-.254-1.107-.254-3.27zM98.79 19h-2.47v-4.764q0-1.512-.158-1.95a1.36 1.36 0 0 0-.518-.695 1.45 1.45 0 0 0-.853-.246 2 2 0 0 0-1.151.351q-.51.352-.704.932-.184.58-.184 2.145V19h-2.47V9.666h2.294v1.371q1.222-1.582 3.076-1.582.817 0 1.495.299.675.29 1.019.747.351.457.483 1.037.141.58.141 1.661zm2.514-10.6V6.115h2.469V8.4zm0 10.6V9.666h2.469V19zm4.438-4.799q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.758q1.117-.606 2.488-.606 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.125-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m1.038-5.81 1.212-2.627h2.769l-2.417 2.627zM77.31 38V25.115h9.553v2.18h-6.952v2.856h6.469v2.171h-6.47v3.507h7.198V38zm18.131 0v-1.398q-.51.748-1.344 1.178-.826.43-1.75.43-.94 0-1.687-.412a2.44 2.44 0 0 1-1.08-1.16q-.335-.747-.335-2.066v-5.906h2.47v4.29q0 1.968.132 2.416.14.44.5.703.36.255.915.255.633 0 1.133-.343.502-.351.686-.861.185-.518.185-2.523v-3.937h2.47V38zm7.225 0h-2.47v-9.334h2.294v1.327q.589-.94 1.055-1.24a1.97 1.97 0 0 1 1.072-.298q.845 0 1.626.466l-.764 2.153q-.625-.405-1.161-.404a1.36 1.36 0 0 0-.879.29q-.36.282-.571 1.028-.202.747-.202 3.13zm4.078-4.799q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.758q1.117-.606 2.488-.606 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m8.974-4.667h2.303v1.371q.448-.704 1.213-1.142a3.34 3.34 0 0 1 1.696-.44q1.626 0 2.76 1.275t1.133 3.55q0 2.338-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.318-1.054v4.702h-2.47zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.861 0 1.433-.686.57-.693.571-2.267 0-1.468-.589-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.597.695-.598 2.066m14.037 1.855 2.46.412q-.474 1.354-1.502 2.066-1.02.703-2.558.703-2.434 0-3.604-1.59-.922-1.275-.922-3.218 0-2.32 1.212-3.63 1.213-1.317 3.068-1.318 2.082 0 3.287 1.38 1.204 1.37 1.151 4.21h-6.187q.026 1.099.597 1.714.572.606 1.424.606.58 0 .976-.316.396-.317.598-1.02m.14-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.808 0-1.336.589-.527.588-.518 1.6zm6.319-1.018-2.241-.405q.378-1.353 1.301-2.004.923-.65 2.742-.65 1.653 0 2.461.396.808.386 1.134.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.238-.73 5 5 0 0 0-.087-.29q-.633.615-1.354.923-.72.308-1.538.308-1.442 0-2.276-.782-.827-.783-.827-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.399-.606v-.246q0-.711-.351-1.01-.352-.309-1.328-.308-.659 0-1.028.263-.369.255-.598.906m3.305 2.004q-.474.158-1.503.377-1.028.22-1.344.431-.484.343-.484.87 0 .519.387.897t.984.378q.668 0 1.275-.44.448-.334.588-.817.097-.316.097-1.204z"
}, null, -1), M01 = [
  _01,
  q01,
  w01,
  z01
];
function b01(t, e) {
  return T(), N("svg", y01, [...M01]);
}
const L01 = { render: b01 }, x01 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "240",
  height: "44",
  fill: "none",
  viewBox: "0 0 240 44"
}, S01 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), C01 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), k01 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zM80.76 37.845v-1.367a3.5 3.5 0 0 1-1.309 1.152q-.81.42-1.713.42-.918.001-1.648-.403a2.38 2.38 0 0 1-1.057-1.134q-.326-.73-.326-2.02v-5.775h2.413v4.195q0 1.925.133 2.358.132.436.485.687.352.255.893.255a1.9 1.9 0 0 0 1.108-.34q.49-.34.67-.842.18-.504.18-2.463v-3.85h2.413v9.127zm12.772 0H91.12v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.628 0-1.126.344t-.682.91q-.185.568-.185 2.098v4.133H85.22v-9.127h2.242v1.34q1.193-1.545 3.005-1.546.799 0 1.46.288t1 .735.473 1.014q.131.568.132 1.624zm2.272-.001h2.412v-9.126h-2.412zm0-10.363h2.412v-2.235h-2.412zm10.304 5.019q-.027-1.049-.541-1.595a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.305.577-.514.575-.507 1.564zm-.137 2.44 2.404.404q-.463 1.324-1.464 2.015t-2.504.692q-2.377 0-3.519-1.555-.903-1.247-.903-3.145 0-2.27 1.186-3.554 1.184-1.285 2.996-1.285 2.036 0 3.212 1.345t1.125 4.121h-6.045q.026 1.074.584 1.671.557.598 1.391.598.566 0 .953-.31.386-.31.584-.997M74.768 18.767V6.169h9.334v2.13H77.31v2.793h6.32v2.123h-6.32v3.43h7.033v2.122zm13.957 0L85.049 9.64h2.533l1.718 4.658.498 1.555q.197-.592.249-.781.12-.387.258-.774l1.734-4.658h2.482l-3.624 9.127zm9.759 0H96.07V9.64h2.241v1.298q.575-.92 1.034-1.212a1.9 1.9 0 0 1 1.044-.292q.825 0 1.589.455l-.748 2.106q-.61-.396-1.133-.396-.507 0-.859.28-.351.28-.554 1.01-.202.73-.201 3.06zm6.624-4.564q0 1.359.643 2.08.645.722 1.589.722t1.585-.722q.639-.722.639-2.097 0-1.34-.639-2.062-.641-.722-1.585-.723-.944 0-1.589.723-.643.721-.643 2.08m-2.474-.129q0-1.204.593-2.33a4.07 4.07 0 0 1 1.679-1.718q1.087-.593 2.425-.593 2.07 0 3.393 1.345t1.322 3.399q0 2.07-1.335 3.433-1.336 1.362-3.362 1.362-1.254 0-2.392-.568a3.9 3.9 0 0 1-1.73-1.662q-.593-1.095-.593-2.668m13.356-.026q0 1.538.609 2.273.611.735 1.486.735.842 0 1.4-.675.557-.674.558-2.213 0-1.435-.575-2.131-.576-.697-1.426-.696a1.85 1.85 0 0 0-1.468.683q-.584.684-.584 2.024m-2.387-4.409h2.25v1.341q.438-.687 1.184-1.117a3.27 3.27 0 0 1 1.658-.43q1.588 0 2.697 1.246 1.106 1.245 1.107 3.472 0 2.286-1.116 3.553-1.117 1.268-2.705 1.268-.756 0-1.37-.3-.614-.302-1.293-1.032v4.598h-2.412zm10.137 6.523 2.421-.37q.154.705.627 1.07.472.366 1.323.366.936 0 1.408-.345a.77.77 0 0 0 .318-.644.64.64 0 0 0-.172-.456q-.18-.171-.808-.317-2.918-.644-3.701-1.178-1.081-.738-1.081-2.054 0-1.185.935-1.994.937-.806 2.903-.807 1.872 0 2.782.61t1.254 1.805l-2.276.42a1.4 1.4 0 0 0-.554-.816q-.407-.283-1.163-.283-.953 0-1.366.266-.274.19-.274.49 0 .258.24.439.326.24 2.255.678 1.927.438 2.691 1.075.757.644.757 1.796 0 1.254-1.049 2.157-1.048.902-3.099.902-1.865 0-2.95-.756a3.48 3.48 0 0 1-1.421-2.054m10.281 2.604V6.169h2.413v6.685l2.825-3.214h2.971l-3.117 3.335 3.341 5.792h-2.602l-2.294-4.1-1.124 1.178v2.922zm12.288-10.244 1.185-2.57h2.705l-2.362 2.57zm2.611 5.86q-.465.156-1.469.37-1.005.216-1.313.422-.474.335-.473.85 0 .508.378.876.378.37.962.37.652 0 1.245-.43.438-.325.575-.798.095-.31.095-1.178zm-3.229-1.958-2.19-.396q.37-1.323 1.271-1.959t2.679-.636q1.615 0 2.404.383.79.381 1.113.97.321.59.321 2.161l-.025 2.82q0 1.203.116 1.774.116.572.434 1.225h-2.388a10 10 0 0 1-.232-.714 5 5 0 0 0-.085-.283q-.619.6-1.323.902-.704.3-1.502.301-1.409 0-2.221-.765-.81-.765-.811-1.933a2.6 2.6 0 0 1 .369-1.38 2.4 2.4 0 0 1 1.035-.928q.666-.322 1.92-.563 1.69-.318 2.344-.593v-.24q0-.697-.344-.993t-1.296-.296q-.645 0-1.005.253-.36.255-.584.89",
  "clip-rule": "evenodd"
}, null, -1), E01 = [
  S01,
  C01,
  k01
];
function A01(t, e) {
  return T(), N("svg", x01, [...E01]);
}
const F01 = { render: A01 }, T01 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, I01 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), O01 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), N01 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.624 24.367h2.542v6.823q0 1.624.094 2.105.163.774.777 1.242.614.47 1.678.469 1.082 0 1.631-.443.55-.443.661-1.087.112-.645.112-2.14v-6.97h2.542v6.618q0 2.269-.206 3.205-.207.938-.76 1.581-.555.645-1.481 1.027-.927.383-2.421.383-1.803 0-2.735-.417t-1.472-1.083-.713-1.396q-.248-1.083-.249-3.197zM95.21 37.845h-2.412v-4.658q0-1.479-.154-1.912a1.34 1.34 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.627 0-1.126.344t-.682.91q-.184.568-.184 2.098v4.133H86.9v-9.127h2.241v1.34q1.194-1.545 3.005-1.546.798 0 1.46.288.66.288 1 .735.338.446.472 1.014.132.568.133 1.624zm2.008-.001h2.413v-9.126h-2.413zm0-10.363h2.413v-2.235h-2.413zm6.36 5.801q0 1.358.644 2.079.645.722 1.589.723.944 0 1.584-.723.639-.721.639-2.097 0-1.34-.639-2.062-.64-.722-1.584-.722t-1.589.722q-.644.721-.644 2.08m-2.473-.129q0-1.204.593-2.33a4.07 4.07 0 0 1 1.679-1.718q1.086-.593 2.425-.593 2.07 0 3.392 1.345t1.322 3.399q0 2.07-1.336 3.433-1.335 1.362-3.361 1.362-1.253 0-2.391-.567a3.9 3.9 0 0 1-1.73-1.663q-.593-1.095-.593-2.668m19.153 4.692h-2.412v-4.658q0-1.479-.155-1.912a1.35 1.35 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.627 0-1.125.344a1.73 1.73 0 0 0-.682.91q-.185.568-.185 2.098v4.133h-2.412v-9.127h2.241v1.34q1.193-1.545 3.005-1.546a3.6 3.6 0 0 1 1.459.288q.661.288 1.001.735.338.446.472 1.014.132.568.132 1.624zM77.288 8.3v8.344h1.898q1.065 0 1.536-.12A2.34 2.34 0 0 0 81.748 16q.41-.37.666-1.217.257-.846.257-2.307t-.257-2.243-.721-1.22q-.465-.438-1.176-.593-.532-.12-2.087-.12zm-2.541-2.132h4.645q1.571 0 2.395.241a4.2 4.2 0 0 1 1.897 1.16q.79.834 1.203 2.04.412 1.209.412 2.979 0 1.555-.387 2.681-.472 1.375-1.347 2.226-.661.644-1.787 1.005-.84.266-2.249.267h-4.782zm18.107 7.254q-.026-1.049-.54-1.595a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.305.577-.516.574-.507 1.563zm-.137 2.44 2.404.404q-.463 1.324-1.464 2.015t-2.503.692q-2.377 0-3.52-1.555-.901-1.247-.902-3.146 0-2.269 1.186-3.553 1.184-1.284 2.996-1.285 2.035 0 3.21 1.345 1.177 1.345 1.126 4.12h-6.044q.025 1.075.583 1.672.558.598 1.391.598.566 0 .953-.31.386-.31.584-.997m12.529 2.905h-2.413v-4.658q0-1.479-.154-1.912a1.35 1.35 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241 1.94 1.94 0 0 0-1.126.344 1.73 1.73 0 0 0-.682.91q-.184.568-.184 2.098v4.133h-2.413V9.64h2.241v1.34q1.194-1.546 3.005-1.546a3.6 3.6 0 0 1 1.459.288q.662.288 1.001.735.338.445.472 1.014.132.568.133 1.624zm7.7 0V6.169h9.333v2.13h-6.791v2.793h6.318v2.123h-6.318v3.43h7.031v2.122zm17.273 0V17.4a3.5 3.5 0 0 1-1.309 1.152q-.812.42-1.714.42-.918.001-1.647-.403a2.38 2.38 0 0 1-1.057-1.134q-.326-.73-.326-2.02V9.64h2.412v4.195q0 1.925.134 2.358.133.436.484.687.353.255.893.255.62 0 1.108-.34a1.73 1.73 0 0 0 .67-.842q.18-.504.18-2.463V9.64h2.413v9.127zm7.049 0h-2.413V9.64h2.241v1.298q.575-.92 1.034-1.211a1.9 1.9 0 0 1 1.044-.293q.824 0 1.588.455l-.747 2.106q-.61-.396-1.133-.396-.507 0-.859.28-.351.28-.554 1.01-.202.73-.201 3.06zm6.184-4.563q0 1.358.643 2.079.645.722 1.589.723.944 0 1.584-.723.64-.721.639-2.097 0-1.34-.639-2.062-.64-.722-1.584-.722t-1.589.722q-.643.721-.643 2.08m-2.473-.129q0-1.203.592-2.33a4.07 4.07 0 0 1 1.679-1.718q1.086-.593 2.425-.593 2.07 0 3.392 1.345t1.322 3.399q0 2.07-1.335 3.433-1.336 1.362-3.361 1.362-1.254 0-2.392-.567a3.9 3.9 0 0 1-1.73-1.663q-.592-1.095-.592-2.668m13.353-.026q0 1.538.61 2.273t1.485.735q.842 0 1.4-.675.557-.674.557-2.213.001-1.435-.575-2.131-.575-.697-1.425-.696a1.85 1.85 0 0 0-1.468.683q-.584.684-.584 2.024m-2.387-4.409h2.25v1.341q.438-.687 1.184-1.117a3.27 3.27 0 0 1 1.658-.43q1.587 0 2.696 1.246 1.107 1.245 1.107 3.472 0 2.286-1.116 3.553-1.116 1.268-2.704 1.268-.756 0-1.37-.3-.614-.302-1.292-1.032v4.598h-2.413zm21.883 3.764q-.05-.756-.205-1.09a1.7 1.7 0 0 0-.649-.758 1.86 1.86 0 0 0-1.017-.274q-.507 0-.889.236a1.6 1.6 0 0 0-.605.709q-.3.627-.275 1.177zm-6.069.997q-1.985.524-2.155.585-.576.189-.804.455a.94.94 0 0 0-.227.627q0 .499.373.851.374.353.975.353.635 0 1.193-.404.412-.3.529-.752.116-.452.116-1.715m5.975 1.452 2.361.422q-.489 1.349-1.485 2.024-.996.674-2.542.674a4.9 4.9 0 0 1-1.776-.313 4.5 4.5 0 0 1-1.477-.942q-.61.524-1.576.89a5.6 5.6 0 0 1-1.988.365q-1.46 0-2.275-.76-.815-.761-.815-1.921 0-.696.287-1.238.287-.54.696-.846.408-.306 1.138-.53.342-.11 2.043-.463.849-.18 1.45-.378v-.24q0-.661-.36-.989t-1.142-.326q-.686 0-1.09.279t-.575.864l-2.19-.422q.428-1.322 1.353-1.946.922-.623 2.811-.623.894 0 1.593.21t1.198.632q.524-.42 1.145-.631.623-.21 1.336-.211 1.374 0 2.323.58t1.493 1.71.537 3.193h-6.061q.145 1.169.652 1.693t1.245.524q.609 0 1.038-.314.43-.313.653-.967m4.303 2.914h2.413V9.64h-2.413zm0-10.365h2.413V6.168h-2.413zm4.035 7.761 2.422-.37q.153.705.626 1.07t1.323.366q.936 0 1.407-.344a.77.77 0 0 0 .319-.645.63.63 0 0 0-.173-.455q-.178-.172-.807-.318-2.919-.645-3.7-1.178-1.082-.738-1.082-2.053 0-1.186.936-1.995.936-.806 2.902-.807 1.871 0 2.782.61.91.61 1.253 1.805l-2.275.42q-.145-.533-.554-.816-.407-.283-1.163-.283-.953 0-1.365.266-.275.19-.275.49 0 .258.24.439.326.24 2.255.678 1.927.438 2.691 1.075.755.644.756 1.796 0 1.254-1.048 2.157t-3.099.902q-1.864 0-2.95-.756a3.5 3.5 0 0 1-1.421-2.054m10.28 2.604V6.169h2.412v6.685l2.825-3.214h2.971l-3.117 3.335 3.34 5.792h-2.601l-2.293-4.1-1.125 1.178v2.922zm15.019-5.345q-.027-1.049-.541-1.595a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.304.577-.516.574-.508 1.563zm-.137 2.44 2.403.404q-.462 1.324-1.464 2.015-1 .692-2.503.692-2.377 0-3.519-1.555-.902-1.247-.902-3.146 0-2.269 1.185-3.553t2.996-1.285q2.036 0 3.211 1.345 1.177 1.345 1.126 4.12h-6.045q.026 1.075.584 1.672.558.598 1.391.598.566 0 .953-.31.386-.31.584-.997",
  "clip-rule": "evenodd"
}, null, -1), P01 = [
  I01,
  O01,
  N01
];
function B01(t, e) {
  return T(), N("svg", T01, [...P01]);
}
const V01 = { render: B01 }, R01 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, H01 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), D01 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), $01 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm11.356 24.367h2.536v6.823q0 1.625.094 2.105.164.774.776 1.243.612.468 1.675.468 1.08 0 1.628-.443.548-.442.66-1.087t.111-2.14v-6.97h2.537v6.618q0 2.269-.206 3.205-.206.937-.759 1.582-.552.644-1.477 1.027-.926.382-2.417.382-1.8 0-2.729-.417-.93-.417-1.47-1.083t-.711-1.396q-.248-1.083-.248-3.197zm20.425 12.598h-2.408v-4.658q0-1.477-.155-1.912a1.34 1.34 0 0 0-.5-.674 1.43 1.43 0 0 0-.836-.241q-.626 0-1.123.344a1.73 1.73 0 0 0-.681.91q-.184.569-.184 2.098v4.133h-2.408V28.72h2.236v1.34q1.192-1.547 3-1.546.796 0 1.456.287.66.288.999.735.337.447.471 1.014.132.568.133 1.624zm2.003 0h2.408V28.72h-2.408zm0-10.364h2.408v-2.235h-2.408zm6.348 5.801q0 1.357.642 2.08.643.721 1.586.722.941 0 1.581-.723.638-.721.638-2.097 0-1.34-.638-2.062-.64-.721-1.581-.722-.943 0-1.586.723-.642.72-.642 2.079m-2.469-.129q0-1.203.592-2.329a4.07 4.07 0 0 1 1.676-1.719q1.083-.593 2.42-.593 2.065 0 3.385 1.345t1.32 3.4q0 2.07-1.333 3.432t-3.355 1.362q-1.25 0-2.386-.567a3.9 3.9 0 0 1-1.727-1.662q-.592-1.095-.592-2.669m19.116 4.692h-2.407v-4.658q0-1.477-.155-1.912a1.34 1.34 0 0 0-.501-.674 1.43 1.43 0 0 0-.835-.241q-.627 0-1.123.344a1.73 1.73 0 0 0-.681.91q-.185.569-.185 2.098v4.133h-2.407V28.72h2.236v1.34q1.191-1.547 2.999-1.546.797 0 1.457.287.66.288.999.735.337.447.471 1.014.131.568.132 1.624zM75.487 18.767V6.168h9.314v2.13h-6.777v2.794h6.306v2.123h-6.306v3.429h7.018v2.123zm17.239 0V17.4a3.5 3.5 0 0 1-1.306 1.152q-.81.42-1.71.42-.917.001-1.645-.403a2.37 2.37 0 0 1-1.055-1.135q-.325-.73-.325-2.02V9.64h2.407v4.194q0 1.926.134 2.359.133.435.483.687.352.255.892.254.617.001 1.106-.34.488-.338.668-.842.18-.503.18-2.462V9.64h2.408v9.127zm7.035 0h-2.408V9.64h2.237v1.298q.575-.92 1.032-1.212a1.9 1.9 0 0 1 1.041-.292 3.05 3.05 0 0 1 1.586.455l-.746 2.106q-.608-.395-1.131-.396-.506 0-.857.28-.35.28-.553 1.01-.2.73-.2 3.059zm6.172-4.564q0 1.358.642 2.08.644.722 1.586.722t1.581-.722.638-2.097q0-1.34-.638-2.062-.639-.723-1.581-.723t-1.586.723q-.642.722-.642 2.08m-2.468-.13q0-1.202.591-2.328a4.07 4.07 0 0 1 1.676-1.72q1.084-.591 2.42-.592 2.066 0 3.385 1.344 1.32 1.346 1.32 3.4 0 2.07-1.333 3.433t-3.354 1.362q-1.252 0-2.387-.568a3.9 3.9 0 0 1-1.727-1.662q-.591-1.096-.591-2.668m13.327-.026q0 1.538.609 2.273.608.735 1.482.735.84 0 1.397-.675t.557-2.213q0-1.434-.574-2.131t-1.423-.696q-.882 0-1.465.683t-.583 2.024m-2.382-4.41h2.246v1.342q.437-.687 1.181-1.118a3.26 3.26 0 0 1 1.654-.429q1.586 0 2.692 1.246 1.104 1.246 1.104 3.472 0 2.286-1.113 3.553-1.115 1.268-2.699 1.268-.755 0-1.367-.3-.613-.302-1.29-1.032v4.598h-2.408zm15.147-1.614h2.074V5.953h-2.074zm.574 6.359q-.462.155-1.464.37-1.003.214-1.312.42-.471.336-.471.85 0 .51.377.877.376.371.96.37.651 0 1.243-.43.436-.325.573-.799.094-.309.094-1.177zm-4.258-6.36h2.065v-2.07h-2.065zm1.037 4.4-2.186-.395q.37-1.323 1.269-1.96.899-.635 2.674-.635 1.61 0 2.399.382.787.384 1.11.971.321.59.321 2.161l-.026 2.819q0 1.204.115 1.775.116.573.433 1.225h-2.381a8 8 0 0 1-.232-.714 5 5 0 0 0-.086-.283 4.3 4.3 0 0 1-1.32.902 3.75 3.75 0 0 1-1.499.3q-1.405 0-2.215-.764-.81-.765-.81-1.933a2.6 2.6 0 0 1 .369-1.38 2.4 2.4 0 0 1 1.032-.928q.664-.323 1.915-.563 1.689-.317 2.339-.593v-.24q0-.697-.342-.993-.343-.297-1.294-.296-.643 0-1.002.253-.361.254-.583.89m8.136 6.342h2.408V9.64h-2.408zm0-10.365h2.408V6.168h-2.408zm4.203 7.761 2.416-.37q.154.705.626 1.07.471.365 1.32.365.933 0 1.405-.344a.77.77 0 0 0 .317-.644.64.64 0 0 0-.172-.456q-.179-.171-.805-.317-2.914-.644-3.694-1.178-1.079-.738-1.079-2.054 0-1.184.934-1.994.934-.807 2.896-.807 1.868 0 2.777.61.908.61 1.251 1.805l-2.271.42q-.145-.532-.553-.816-.406-.282-1.161-.283-.951.001-1.362.266a.57.57 0 0 0-.274.49q0 .258.239.439.326.24 2.25.678t2.686 1.075q.755.644.755 1.796-.001 1.254-1.046 2.156t-3.093.902q-1.86 0-2.944-.755a3.5 3.5 0 0 1-1.418-2.054m18.28-3.824-2.374.429q-.119-.713-.544-1.074-.423-.36-1.101-.361-.9 0-1.435.623-.536.624-.536 2.084 0 1.624.544 2.295.545.67 1.461.67.685 0 1.123-.392.437-.39.616-1.344l2.366.404q-.37 1.633-1.414 2.466-1.046.835-2.802.834-1.997 0-3.183-1.263-1.187-1.264-1.187-3.498 0-2.26 1.191-3.52 1.191-1.258 3.222-1.258 1.662 0 2.644.718.98.717 1.409 2.187m3.96-6.171V10.8q1.166-1.366 2.785-1.366.832 0 1.5.309.669.31 1.006.79.339.482.464 1.067.123.585.123 1.812v5.354h-2.407v-4.82q0-1.435-.137-1.822a1.2 1.2 0 0 0-.485-.615q-.347-.227-.869-.227-.6 0-1.072.292-.471.292-.689.88-.219.59-.219 1.74v4.572h-2.407V6.168zm13.64 7.253q-.026-1.048-.539-1.594a1.66 1.66 0 0 0-1.252-.546q-.787 0-1.302.576-.514.576-.506 1.564zm-.137 2.44 2.399.404q-.462 1.325-1.461 2.016-.998.693-2.498.692-2.373 0-3.512-1.556-.9-1.245-.9-3.145 0-2.27 1.182-3.553 1.182-1.284 2.991-1.285 2.031 0 3.204 1.345 1.175 1.345 1.123 4.12h-6.032q.025 1.075.583 1.672.556.597 1.388.597.565 0 .951-.31.386-.307.582-.997",
  "clip-rule": "evenodd"
}, null, -1), U01 = [
  H01,
  D01,
  $01
];
function j01(t, e) {
  return T(), N("svg", R01, [...U01]);
}
const G01 = { render: j01 }, W01 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, Y01 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), X01 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), K01 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm13.713 36.965V25.247h9.309v2.13h-6.782v2.793h6.31v2.123h-6.31v3.43h7.022v2.122zm-5.13-10.364 1.37-2.234h3.195l-2.817 2.234zm19.312 10.364-3.666-9.127h2.527l1.712 4.658.498 1.555q.195-.592.248-.781.12-.387.257-.774l1.73-4.658h2.474l-3.613 9.127zm7.955-9.127h2.295q-1.12 2.346-1.121 4.813 0 1.41.5 2.01.502.602 1.187.603.47 0 .826-.293a1.3 1.3 0 0 0 .459-.722q.102-.43.102-1.314v-2.768h2.407v2.768q0 .851.098 1.297.098.447.463.739.363.293.826.293.718 0 1.203-.628.484-.628.484-2.08 0-.98-.291-2.294a11 11 0 0 0-.831-2.424h2.295q.48.8.886 2.187.407 1.389.407 2.549 0 2.01-1.062 3.304-1.062 1.293-2.791 1.293-2.072-.001-2.886-1.916-.823 1.916-2.895 1.916-1.738 0-2.796-1.297-1.058-1.298-1.058-3.3 0-1.16.407-2.549.408-1.387.886-2.187m15.989 4.564q0 1.306.625 2.054.626.748 1.601.748.941 0 1.581-.723.637-.722.637-2.122 0-1.238-.608-1.998-.607-.762-1.61-.761-.985 0-1.605.748-.621.747-.621 2.054m8.452-4.564v2.003h-2.201a4.9 4.9 0 0 1 .669 2.526q-.001 1.995-1.298 3.399-1.297 1.405-3.43 1.405-2.081 0-3.37-1.306-1.288-1.306-1.289-3.42 0-2.098 1.264-3.455 1.262-1.358 3.464-1.358.641 0 1.482.206zm9.917 12.599h-2.406v-8.13q0-1.22-.099-1.715a1.38 1.38 0 0 0-.463-.803q-.363-.31-.928-.31-.678 0-1.182.387a1.75 1.75 0 0 0-.655.993q-.15.606-.15 1.972v4.134h-2.407V28.72h2.236v1.34q1.19-1.547 3.005-1.547 1.053 0 1.782.456.727.455.997 1.16t.27 2.045zm-59.765-22.55V6.169h9.308v2.13H77.1v2.793h6.303v2.123H77.1v3.43h7.014v2.122zM85.559 9.64h2.406v4.675q0 1.676.471 2.183.472.507 1.216.507.865 0 1.276-.589.412-.588.412-2.101V9.64h2.406v4.288q0 1.84-.403 2.858a3.2 3.2 0 0 1-1.37 1.602q-.967.585-2.287.585-1.42 0-2.393-.61t-1.353-1.625q-.381-1.013-.381-2.81zm12.439 4.839q0 1.134.573 1.83.575.696 1.559.696.968 0 1.567-.778.6-.777.599-2.04 0-1.29-.552-2.037-.552-.748-1.588-.748-.9 0-1.529.675-.63.675-.63 2.402m0 3.729v4.03h-2.406v-7.184q0-1.941.399-3.08.398-1.14 1.442-1.84 1.046-.7 2.526-.7 2.202 0 3.503 1.427 1.302 1.425 1.302 3.428 0 1.96-1.255 3.322t-3.079 1.362q-1.207 0-2.431-.765m9.57-8.568h2.295q-1.122 2.346-1.122 4.813 0 1.41.501 2.01.5.602 1.186.603.47 0 .826-.293.356-.292.459-.722.102-.43.102-1.315V11.97h2.407v2.767q0 .851.098 1.298.099.447.463.739.363.293.826.293.72 0 1.203-.628t.484-2.08q0-.98-.291-2.294a11 11 0 0 0-.831-2.424h2.296q.478.8.885 2.187.407 1.388.407 2.549 0 2.01-1.062 3.304-1.062 1.293-2.791 1.293-2.072-.001-2.886-1.916-.823 1.916-2.895 1.916-1.738 0-2.796-1.297t-1.058-3.3q0-1.16.407-2.549.408-1.388.887-2.187m13.44-.001h12.597v2.002h-2.415v7.125h-2.406v-7.125h-2.954v7.125h-2.407v-7.125h-2.415zm16.327 4.59q0 1.261.535 2.049.536.787 1.392.787.822 0 1.344-.697.523-.696.523-2.14 0-1.418-.557-2.148-.555-.73-1.345-.73-.821 0-1.357.756-.535.757-.535 2.122m5.01-4.589h2.063q-.487.997-.817 2.549-.33 1.551-.33 2.169 0 .8.3 2.089.299 1.288.754 2.32h-2.022a6 6 0 0 0-.153-.482 12 12 0 0 1-.309-1.03q-1.053 1.718-3.006 1.718-1.841 0-2.898-1.5t-1.059-3.501q0-1.89 1.054-3.214 1.053-1.324 2.929-1.324 1.85 0 2.989 1.779.153-.627.505-1.573m6.083-1.615h2.072V5.953h-2.072zm-2.012 10.742h2.407V9.64h-2.407zm-1.67-10.742h2.064V5.953h-2.064zm6.676 1.615h2.406v3.163l2.809-3.163h2.937l-3.657 3.868 3.94 5.259h-2.818l-2.663-3.644-.548.585v3.059h-2.406zm12.781-1.117 1.182-2.57h2.697l-2.355 2.57zm5.463 13.716h-2.406v-8.13q0-1.22-.098-1.715a1.38 1.38 0 0 0-.463-.803q-.364-.31-.929-.31-.678 0-1.182.387a1.76 1.76 0 0 0-.655.993q-.15.606-.15 1.972v4.134h-2.407V9.641h2.236v1.34q1.19-1.547 3.006-1.547 1.052 0 1.781.456.728.455.998 1.16t.269 2.045z",
  "clip-rule": "evenodd"
}, null, -1), Z01 = [
  Y01,
  X01,
  K01
];
function J01(t, e) {
  return T(), N("svg", W01, [...Z01]);
}
const Q01 = { render: J01 }, e61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, t61 = /* @__PURE__ */ U1('<path fill="#039" d="M.878.88h63.243v42.24H.878z"></path><path fill="#FC0" fill-rule="evenodd" d="m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M65 44H0V0h65zM64.122.88H.878v42.24h63.244z" clip-rule="evenodd"></path><path fill="#fff" d="M74.682 25.247h2.54v6.82q-.03 1.06.096 2.112c.098.494.373.935.773 1.241a2.74 2.74 0 0 0 1.678.466 2.63 2.63 0 0 0 1.634-.44c.359-.277.6-.679.677-1.126q.129-1.066.105-2.138v-6.935h2.548v6.618a16.6 16.6 0 0 1-.21 3.203 3.6 3.6 0 0 1-.756 1.584 3.9 3.9 0 0 1-1.485 1.03 6.6 6.6 0 0 1-2.416.378 7 7 0 0 1-2.733-.414 4 4 0 0 1-1.476-1.082 3.5 3.5 0 0 1-.711-1.364 15.3 15.3 0 0 1-.264-3.23zM95.154 37.84h-2.416v-4.664a7.6 7.6 0 0 0-.15-1.91 1.4 1.4 0 0 0-.5-.677 1.5 1.5 0 0 0-.88-.238 1.95 1.95 0 0 0-1.124.343 1.76 1.76 0 0 0-.676.88 8 8 0 0 0-.185 2.095v4.171h-2.381v-9.126h2.24v1.347a3.66 3.66 0 0 1 3.005-1.549 3.6 3.6 0 0 1 1.459.29c.39.155.735.406 1.001.73a2.8 2.8 0 0 1 .466 1.013 7 7 0 0 1 .14 1.628z"></path><path fill="#fff" fill-rule="evenodd" d="M97.157 25.247v2.235h2.407v-2.235zm0 3.467v9.135l2.407-.009v-9.126zm4.481 2.112a4.9 4.9 0 0 0-.598 2.324c-.032.913.161 1.82.563 2.64a3.84 3.84 0 0 0 1.757 1.663c.741.373 1.56.566 2.39.563a4.53 4.53 0 0 0 3.365-1.364 4.7 4.7 0 0 0 1.327-3.432 4.65 4.65 0 0 0-1.318-3.397 4.55 4.55 0 0 0-3.392-1.346 5.1 5.1 0 0 0-2.425.59 4 4 0 0 0-1.669 1.76m2.522 4.532a3 3 0 0 1-.651-2.076c-.05-.75.182-1.49.651-2.077a2.097 2.097 0 0 1 3.163 0 2.98 2.98 0 0 1 .641 2.059 3.03 3.03 0 0 1-.641 2.094 2.1 2.1 0 0 1-3.163 0" clip-rule="evenodd"></path><path fill="#fff" d="M120.185 37.84h-2.451v-4.664a7.6 7.6 0 0 0-.149-1.91 1.4 1.4 0 0 0-.501-.677 1.5 1.5 0 0 0-.879-.238 1.95 1.95 0 0 0-1.124.343 1.76 1.76 0 0 0-.677.88 7.8 7.8 0 0 0-.184 2.095v4.171h-2.417v-9.126h2.241v1.347a3.66 3.66 0 0 1 3.005-1.549c.501-.007.998.092 1.458.29.391.155.735.406 1.002.73.22.305.381.648.474 1.013a7.7 7.7 0 0 1 .132 1.628zM74.682 18.77V6.16h9.357v2.138h-6.791v2.799h6.317V13.2h-6.317v3.423h7.029v2.13zm17.485 0v-1.372a3.5 3.5 0 0 1-1.31 1.152 3.7 3.7 0 0 1-1.757.423 3.3 3.3 0 0 1-1.652-.405 2.36 2.36 0 0 1-1.054-1.135 5.2 5.2 0 0 1-.29-2.015V9.68h2.416v4.198c-.035.788.009 1.578.132 2.358.077.278.248.52.483.686.26.175.567.264.879.256a1.87 1.87 0 0 0 1.098-.344c.311-.196.549-.49.677-.835.157-.812.217-1.64.175-2.465V9.68h2.417v9.09zm6.773 0h-2.407V9.68h2.24v1.302a3.9 3.9 0 0 1 1.037-1.214c.31-.196.671-.297 1.037-.29a3 3 0 0 1 1.59.457l-.746 2.103a2.1 2.1 0 0 0-1.134-.396 1.37 1.37 0 0 0-.878.282 1.97 1.97 0 0 0-.554 1.012 14.5 14.5 0 0 0-.202 3.054z"></path><path fill="#fff" fill-rule="evenodd" d="M103.246 11.757a4.9 4.9 0 0 0-.589 2.323 5.55 5.55 0 0 0 .545 2.658 3.9 3.9 0 0 0 1.757 1.663c.741.373 1.56.566 2.39.563a4.5 4.5 0 0 0 3.356-1.364 4.7 4.7 0 0 0 1.318-3.423 4.65 4.65 0 0 0-1.318-3.397 4.56 4.56 0 0 0-3.356-1.373 4.95 4.95 0 0 0-2.425.59 4.07 4.07 0 0 0-1.678 1.76m2.521 4.532a3 3 0 0 1-.641-2.077v-.009a3 3 0 0 1 .641-2.068 2.11 2.11 0 0 1 3.172 0c.464.582.693 1.317.642 2.06.054.753-.174 1.5-.642 2.094a2.106 2.106 0 0 1-3.172 0m10.061-6.609h-2.25l-.008 12.558h2.407v-4.594c.361.412.788.76 1.265 1.03a3.1 3.1 0 0 0 1.371.299 3.51 3.51 0 0 0 2.741-1.258 5.3 5.3 0 0 0 1.116-3.52 5.04 5.04 0 0 0-1.107-3.468 3.46 3.46 0 0 0-2.697-1.25 3.2 3.2 0 0 0-1.652.432 3.3 3.3 0 0 0-1.186 1.117zm.764 6.68a3.52 3.52 0 0 1-.615-2.28c-.048-.723.16-1.44.589-2.024.36-.438.9-.687 1.467-.677a1.75 1.75 0 0 1 1.423.695 3.27 3.27 0 0 1 .571 2.13 3.52 3.52 0 0 1-.553 2.217 1.76 1.76 0 0 1-1.397.669 1.86 1.86 0 0 1-1.485-.73m15.288-.124-2.399-.396a1.94 1.94 0 0 1-.553 1.02 1.53 1.53 0 0 1-.958.309 1.83 1.83 0 0 1-1.388-.599 2.45 2.45 0 0 1-.58-1.671h6.036a5.97 5.97 0 0 0-1.125-4.119 4.04 4.04 0 0 0-3.207-1.338 3.92 3.92 0 0 0-2.996 1.285 5.04 5.04 0 0 0-1.186 3.52 5.24 5.24 0 0 0 .879 3.142 4.07 4.07 0 0 0 3.514 1.558 4.26 4.26 0 0 0 2.504-.696 3.88 3.88 0 0 0 1.459-2.015m-2.803-4.435c.373.444.568 1.012.545 1.593h-3.602a2.23 2.23 0 0 1 .5-1.567c.331-.374.81-.583 1.309-.572a1.66 1.66 0 0 1 1.248.546m4.516.229 2.188.396c.086-.36.282-.683.562-.924a1.76 1.76 0 0 1 1.011-.256 2 2 0 0 1 1.291.3c.253.262.379.622.343.985v.247c-.762.27-1.547.467-2.346.59a8.2 8.2 0 0 0-1.916.562c-.424.206-.781.53-1.028.933a2.73 2.73 0 0 0 .44 3.309 3.08 3.08 0 0 0 2.214.766 3.7 3.7 0 0 0 1.502-.3 4.3 4.3 0 0 0 1.327-.88q.006.026.023.063a.5.5 0 0 1 .056.228q.15.465.237.713h2.381a5.3 5.3 0 0 1-.43-1.232 9.6 9.6 0 0 1-.114-1.76v-2.825a5 5 0 0 0-.325-2.156 2.4 2.4 0 0 0-1.116-.977 5.9 5.9 0 0 0-2.399-.378 4.67 4.67 0 0 0-2.636.633 3.43 3.43 0 0 0-1.265 1.963m3.945 2.728c.668-.15 1.16-.273 1.467-.37v.502c.017.395-.016.791-.096 1.179a1.5 1.5 0 0 1-.571.8c-.36.273-.797.424-1.248.432a1.32 1.32 0 0 1-.958-.37 1.2 1.2 0 0 1-.378-.88 1.02 1.02 0 0 1 .475-.88 4.5 4.5 0 0 1 1.309-.413" clip-rule="evenodd"></path><path fill="#fff" d="M151.93 18.77h-2.408v-4.69a7 7 0 0 0-.158-1.91 1.3 1.3 0 0 0-.501-.677 1.44 1.44 0 0 0-.878-.238 1.95 1.95 0 0 0-1.125.343 1.67 1.67 0 0 0-.676.88 8 8 0 0 0-.185 2.095v4.136h-2.416V9.68h2.267v1.347a3.65 3.65 0 0 1 3.005-1.55c.501-.005.997.094 1.458.291.39.154.735.406 1.002.73.221.303.379.647.465 1.013a7.7 7.7 0 0 1 .132 1.628z"></path>', 8), n61 = [
  t61
];
function i61(t, e) {
  return T(), N("svg", e61, [...n61]);
}
const s61 = { render: i61 }, l61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, r61 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), a61 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), o61 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.483 36.965V25.247h9.312v2.13h-6.776v2.794h6.305v2.122h-6.305v3.43h7.016v2.122zm17.428 0v-1.367a3.5 3.5 0 0 1-1.306 1.152q-.81.421-1.71.421-.916 0-1.644-.404a2.38 2.38 0 0 1-1.055-1.134q-.325-.73-.325-2.02V28.72H88.4v4.194q0 1.925.134 2.358.132.436.483.687.352.255.891.255.618 0 1.106-.34a1.73 1.73 0 0 0 .668-.842q.18-.503.18-2.462v-3.85h2.407v9.126zm6.771 0h-2.407V28.72h2.236v1.298q.574-.921 1.032-1.212a1.9 1.9 0 0 1 1.041-.292q.822 0 1.585.455l-.745 2.105q-.609-.396-1.131-.396-.506 0-.857.28-.35.28-.553 1.01-.201.73-.201 3.06zm6.171-4.563q0 1.357.642 2.08.643.721 1.586.722.941 0 1.581-.723.637-.721.637-2.097 0-1.34-.637-2.062-.64-.722-1.581-.722-.943 0-1.586.722-.642.722-.642 2.08m-2.468-.129q0-1.203.592-2.329a4.06 4.06 0 0 1 1.675-1.719q1.083-.593 2.42-.593 2.065 0 3.384 1.345 1.32 1.345 1.32 3.4 0 2.07-1.333 3.432t-3.354 1.362q-1.25 0-2.386-.567a3.9 3.9 0 0 1-1.726-1.663q-.591-1.096-.592-2.668m13.291-.026q0 1.538.607 2.273.61.735 1.483.735.84 0 1.397-.675.555-.675.556-2.212.001-1.437-.574-2.132-.573-.696-1.422-.696-.883 0-1.465.683t-.582 2.024m-2.382-4.409h2.245v1.342q.437-.688 1.181-1.118a3.25 3.25 0 0 1 1.654-.43q1.585 0 2.691 1.247 1.104 1.246 1.104 3.471 0 2.286-1.113 3.554-1.114 1.268-2.699 1.268-.754 0-1.366-.301-.613-.3-1.29-1.032v4.598h-2.407zm16.016 3.782q-.026-1.048-.539-1.595a1.66 1.66 0 0 0-1.251-.545q-.789 0-1.302.576-.514.576-.506 1.564zm-.136 2.44 2.398.404q-.462 1.325-1.461 2.015-.997.692-2.497.693-2.372-.001-3.512-1.556-.9-1.245-.9-3.145 0-2.269 1.182-3.554t2.99-1.284q2.032 0 3.204 1.344 1.174 1.345 1.123 4.121h-6.031q.025 1.075.582 1.671.557.598 1.388.598.565 0 .951-.31.385-.309.583-.997m9.509-1.478q-.462.154-1.465.37-1.002.215-1.311.42-.471.336-.471.851 0 .509.378.877.376.37.958.37.652 0 1.243-.43a1.52 1.52 0 0 0 .574-.799q.094-.31.094-1.177zm-3.221-1.96-2.185-.395q.37-1.322 1.268-1.958.9-.637 2.673-.637 1.611 0 2.399.383.788.381 1.109.97.322.59.322 2.162l-.026 2.819q0 1.203.116 1.775.115.57.432 1.224h-2.381a9 9 0 0 1-.232-.713 5 5 0 0 0-.085-.283q-.617.6-1.32.902-.702.3-1.499.3-1.405 0-2.214-.764-.81-.765-.81-1.934 0-.774.368-1.38a2.4 2.4 0 0 1 1.032-.928q.665-.322 1.915-.562 1.688-.318 2.339-.593v-.241q0-.696-.343-.992t-1.293-.297q-.643 0-1.003.254-.36.253-.582.889M74.58 6.168h2.536v6.824q0 1.623.094 2.105.163.773.776 1.242.611.469 1.674.468 1.08 0 1.628-.442.547-.444.66-1.087.11-.645.11-2.14v-6.97h2.537v6.618q0 2.267-.205 3.205-.206.937-.76 1.581-.552.645-1.477 1.027-.924.383-2.416.383-1.799 0-2.728-.417-.93-.418-1.47-1.084-.54-.665-.711-1.395-.248-1.084-.248-3.197zm20.421 12.599h-2.407v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.5-.675 1.43 1.43 0 0 0-.836-.24q-.625 0-1.123.343a1.73 1.73 0 0 0-.68.911q-.185.568-.185 2.097v4.134h-2.407V9.64h2.236v1.34q1.19-1.546 2.999-1.546.796 0 1.456.288.66.287.998.735.338.446.471 1.013.133.568.133 1.625zm2.003 0h2.407V9.64h-2.407zm0-10.365h2.407V6.168h-2.407zm7.358.121 1.182-2.57h2.699l-2.356 2.57zm-1.011 5.68q0 1.358.642 2.08t1.586.722q.941 0 1.58-.722.638-.722.638-2.097 0-1.34-.638-2.062-.638-.723-1.58-.723-.944 0-1.586.723-.642.721-.642 2.08m-2.468-.128q0-1.204.592-2.33a4.06 4.06 0 0 1 1.674-1.718q1.084-.593 2.421-.593 2.064 0 3.384 1.344 1.32 1.346 1.319 3.4 0 2.07-1.332 3.433t-3.354 1.362q-1.251 0-2.386-.568a3.88 3.88 0 0 1-1.726-1.662q-.591-1.096-.592-2.668m19.287 4.691h-2.407v-4.658q0-1.479-.154-1.912a1.35 1.35 0 0 0-.501-.675 1.43 1.43 0 0 0-.836-.24q-.626 0-1.122.343a1.73 1.73 0 0 0-.681.911q-.184.568-.184 2.097v4.134h-2.408V9.64h2.236v1.34q1.191-1.546 2.999-1.546.797 0 1.456.288.66.287.999.735.337.446.471 1.013.132.568.132 1.625z",
  "clip-rule": "evenodd"
}, null, -1), c61 = [
  r61,
  a61,
  o61
];
function h61(t, e) {
  return T(), N("svg", l61, [...c61]);
}
const u61 = { render: h61 }, d61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, f61 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), v61 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), p61 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.615 36.965V25.35h2.538v10.372h6.31v2.123zm10.641 0h2.41V28.72h-2.41zm0-10.364h2.41v-2.235h-2.41zm4.879 10.364h2.41V28.72h-2.41zm0-10.364h2.41v-2.235h-2.41zm9.055 1.238v1.925h-1.647v3.678q0 1.117.048 1.302a.53.53 0 0 0 .214.304q.167.12.408.12.335 0 .968-.231l.206 1.873q-.84.36-1.903.36-.652 0-1.175-.218-.525-.219-.767-.567-.246-.348-.34-.94-.077-.422-.077-1.703v-3.978h-1.106v-1.925h1.106v-1.814l2.418-1.409v3.223zM74.66 18.767V6.169h9.321v2.13h-6.782v2.794h6.31v2.122H77.2v3.43h7.023v2.122zm17.444 0V17.4a3.5 3.5 0 0 1-1.307 1.152q-.81.42-1.712.42-.916.001-1.645-.403a2.38 2.38 0 0 1-1.055-1.134q-.326-.73-.326-2.02V9.641h2.41v4.194q0 1.925.133 2.358.132.436.483.687.352.255.892.255.618 0 1.107-.34.488-.34.669-.842.18-.503.18-2.462V9.64h2.41v9.126zm6.776 0h-2.409V9.64h2.239v1.298q.574-.92 1.032-1.211a1.9 1.9 0 0 1 1.042-.292q.824-.001 1.587.455l-.746 2.105q-.61-.396-1.132-.396-.506 0-.858.28-.35.28-.553 1.01-.202.73-.201 3.06zm6.177-4.563q0 1.357.643 2.08.644.721 1.586.722.943 0 1.583-.723.638-.721.638-2.097 0-1.34-.638-2.062-.64-.722-1.583-.722-.942 0-1.586.722-.643.722-.643 2.08m-2.47-.129q0-1.202.592-2.33a4.06 4.06 0 0 1 1.677-1.718q1.084-.593 2.422-.593 2.066 0 3.387 1.345t1.321 3.4q0 2.07-1.334 3.432t-3.357 1.362q-1.252 0-2.388-.567a3.9 3.9 0 0 1-1.728-1.663q-.591-1.096-.592-2.668m12.934.129q0 1.357.642 2.08.644.721 1.587.722.943 0 1.582-.723.639-.721.639-2.097 0-1.34-.639-2.062t-1.582-.722-1.587.722q-.642.722-.642 2.08m-2.469-.129q0-1.202.591-2.33a4.06 4.06 0 0 1 1.677-1.718q1.084-.593 2.421-.593 2.068 0 3.388 1.345t1.32 3.4q0 2.07-1.333 3.432-1.334 1.362-3.357 1.362-1.253 0-2.388-.567a3.9 3.9 0 0 1-1.728-1.663q-.592-1.096-.591-2.668m13.3-.026q0 1.538.609 2.273t1.484.735q.84 0 1.397-.675t.557-2.212q.001-1.437-.574-2.132-.574-.696-1.423-.696-.885 0-1.467.683-.583.684-.583 2.024m-2.384-4.409h2.247v1.341q.438-.687 1.183-1.117a3.25 3.25 0 0 1 1.655-.43q1.586 0 2.693 1.246 1.105 1.246 1.105 3.472 0 2.286-1.114 3.553-1.114 1.269-2.701 1.269-.755 0-1.368-.301-.613-.302-1.29-1.032v4.598h-2.41zm15.645 4.744q-.463.154-1.466.37-1.004.215-1.312.42-.471.336-.472.851 0 .509.378.877.377.37.96.37.651 0 1.243-.43.437-.327.575-.799.094-.31.094-1.177zm-3.224-1.96-2.187-.395q.37-1.322 1.269-1.959.9-.636 2.676-.636 1.612 0 2.4.383.79.381 1.111.97.321.59.321 2.162l-.025 2.819q0 1.203.116 1.774.115.573.433 1.225h-2.384a9 9 0 0 1-.232-.713 5 5 0 0 0-.085-.284 4.4 4.4 0 0 1-1.321.902q-.703.301-1.5.301-1.406 0-2.217-.764-.81-.765-.81-1.935 0-.772.369-1.379a2.4 2.4 0 0 1 1.032-.928q.666-.322 1.917-.562 1.689-.318 2.341-.593v-.242q0-.695-.343-.991t-1.295-.297q-.643 0-1.003.254t-.583.888",
  "clip-rule": "evenodd"
}, null, -1), m61 = [
  f61,
  v61,
  p61
];
function g61(t, e) {
  return T(), N("svg", d61, [...m61]);
}
const y61 = { render: g61 }, _61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, q61 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), w61 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), z61 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm16.764 36.965v-1.367q-.5.73-1.311 1.152a3.7 3.7 0 0 1-1.717.42q-.92.001-1.65-.403a2.38 2.38 0 0 1-1.059-1.134q-.326-.73-.326-2.02v-5.775h2.416v4.195q0 1.925.134 2.358.133.436.485.687.354.255.895.255.62 0 1.11-.34t.67-.842q.18-.504.181-2.462v-3.85h2.417v9.126zm13.056 0h-2.417v-4.658q0-1.478-.155-1.912a1.35 1.35 0 0 0-.503-.674 1.44 1.44 0 0 0-.838-.241q-.63 0-1.127.344-.499.343-.684.91-.185.568-.185 2.098v4.133h-2.416v-9.126h2.244v1.34q1.195-1.547 3.01-1.546.8 0 1.463.287.66.288 1.002.735.338.447.473 1.014.133.567.133 1.624zm2.01 0h2.417V28.72h-2.417zm0-10.364h2.417v-2.235h-2.417zm6.372 5.801q0 1.357.644 2.08.646.721 1.592.722.945 0 1.587-.723.64-.721.64-2.097 0-1.34-.64-2.062-.642-.722-1.587-.722-.946 0-1.592.722-.645.722-.644 2.08m-2.478-.129q0-1.203.594-2.33a4.07 4.07 0 0 1 1.682-1.718q1.088-.593 2.429-.593 2.073 0 3.397 1.345 1.325 1.345 1.325 3.4 0 2.07-1.338 3.432t-3.367 1.362q-1.255 0-2.395-.567a3.9 3.9 0 0 1-1.733-1.663q-.594-1.096-.594-2.668m19.186 4.692h-2.416v-4.658q0-1.478-.155-1.912a1.34 1.34 0 0 0-.503-.674 1.44 1.44 0 0 0-.839-.241q-.628 0-1.127.344t-.683.91q-.185.568-.185 2.098v4.133h-2.417v-9.126h2.245v1.34q1.195-1.547 3.01-1.546.8 0 1.462.287.662.288 1.002.735t.473 1.014.133 1.624zm2.452 0h2.416V28.72h-2.416zm0-10.364h2.416v-2.235h-2.416zm-46.599-8.714V6.169h9.348v2.13h-6.802v2.793h6.33v2.123h-6.33v3.43h7.044v2.122zm17.495 0V17.4q-.499.73-1.31 1.152-.814.42-1.717.42-.92.001-1.65-.403a2.38 2.38 0 0 1-1.06-1.134q-.326-.73-.326-2.02V9.64h2.417v4.195q0 1.925.134 2.358.132.436.485.687.352.255.895.255.618 0 1.11-.34.49-.34.67-.842.18-.504.18-2.463V9.64h2.417v9.127zm6.798 0H96.76V9.64h2.245v1.298q.576-.92 1.035-1.211a1.9 1.9 0 0 1 1.046-.293q.826 0 1.591.455l-.748 2.106q-.61-.396-1.136-.396a1.34 1.34 0 0 0-.86.28q-.352.28-.555 1.01-.202.73-.202 3.06zm6.194-4.563q0 1.358.645 2.079.646.722 1.591.723.946 0 1.587-.723.641-.721.641-2.097 0-1.34-.641-2.062t-1.587-.722-1.591.722-.645 2.08m-2.477-.129q0-1.203.594-2.33a4.07 4.07 0 0 1 1.682-1.718q1.088-.593 2.429-.593 2.073 0 3.397 1.345 1.326 1.345 1.325 3.399 0 2.07-1.338 3.433t-3.367 1.362q-1.255 0-2.395-.567a3.9 3.9 0 0 1-1.733-1.663q-.594-1.095-.594-2.668m12.972.129q0 1.358.645 2.079.646.722 1.591.723.946 0 1.587-.723.641-.721.641-2.097 0-1.34-.641-2.062t-1.587-.722q-.945 0-1.591.722-.645.721-.645 2.08m-2.477-.129q0-1.203.594-2.33a4.07 4.07 0 0 1 1.682-1.718q1.087-.593 2.429-.593 2.073 0 3.397 1.345 1.326 1.345 1.325 3.399 0 2.07-1.338 3.433t-3.367 1.362q-1.255 0-2.395-.567a3.9 3.9 0 0 1-1.733-1.663q-.594-1.095-.594-2.668m13.342-.026q0 1.538.61 2.273t1.488.735q.844 0 1.402-.675.559-.674.559-2.213 0-1.436-.576-2.13-.576-.698-1.428-.697-.886 0-1.471.683-.584.684-.584 2.024M124.34 9.64h2.254v1.341q.44-.687 1.186-1.117.75-.43 1.66-.43 1.592 0 2.702 1.246 1.108 1.246 1.108 3.472 0 2.286-1.117 3.553-1.119 1.269-2.709 1.268-.758 0-1.372-.3-.615-.302-1.295-1.032v4.598h-2.417zm15.692 4.744q-.465.154-1.471.37-1.006.214-1.316.42-.472.336-.472.851 0 .509.378.877.379.37.963.37.654 0 1.247-.43.438-.326.577-.8.094-.309.094-1.177zm-3.234-1.96-2.193-.395q.37-1.322 1.273-1.959.903-.636 2.683-.636 1.617 0 2.408.383.792.381 1.114.97.322.59.322 2.162l-.025 2.818q0 1.204.116 1.775.117.572.434 1.224h-2.391a9 9 0 0 1-.232-.712 4 4 0 0 0-.086-.284q-.62.601-1.324.902a3.8 3.8 0 0 1-1.505.301q-1.41 0-2.223-.764-.814-.765-.813-1.935-.001-.773.37-1.379a2.4 2.4 0 0 1 1.036-.928q.666-.322 1.922-.562 1.694-.318 2.348-.593v-.242q0-.695-.344-.991t-1.299-.297q-.645 0-1.006.254-.362.253-.585.888m16.474 6.343h-2.416v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.503-.674 1.44 1.44 0 0 0-.839-.241q-.628 0-1.127.344-.499.342-.683.91t-.185 2.098v4.133h-2.417V9.64h2.245v1.34q1.195-1.546 3.01-1.546.8 0 1.462.288t1.002.735q.34.445.473 1.014.132.568.133 1.624z",
  "clip-rule": "evenodd"
}, null, -1), M61 = [
  q61,
  w61,
  z61
];
function b61(t, e) {
  return T(), N("svg", _61, [...M61]);
}
const L61 = { render: b61 }, x61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, S61 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), C61 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), k61 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zM79.96 32.5q-.027-1.048-.54-1.595a1.66 1.66 0 0 0-1.25-.545q-.789 0-1.302.576-.514.576-.506 1.564zm-.138 2.44 2.398.404q-.462 1.325-1.46 2.015-.998.692-2.497.693-2.37-.001-3.51-1.556-.9-1.245-.9-3.145 0-2.269 1.182-3.554t2.989-1.285q2.03 0 3.202 1.345t1.123 4.121h-6.03q.027 1.074.583 1.671.556.598 1.388.598.564 0 .95-.31.385-.309.582-.997m10.123 2.905v-1.367a3.5 3.5 0 0 1-1.306 1.152q-.81.42-1.71.42-.915.001-1.643-.403a2.38 2.38 0 0 1-1.054-1.134q-.325-.73-.325-2.02v-5.775h2.406v4.195q0 1.925.133 2.358.133.436.484.687.351.255.89.255.618 0 1.106-.34a1.73 1.73 0 0 0 .668-.842q.18-.504.18-2.462v-3.85h2.406v9.126zm6.767 0h-2.406v-9.126h2.235v1.298q.574-.921 1.032-1.212a1.9 1.9 0 0 1 1.04-.292q.823 0 1.585.455l-.745 2.105q-.608-.396-1.13-.396-.506 0-.857.28-.35.28-.553 1.01-.2.73-.2 3.06zm6.169-4.563q0 1.357.642 2.08.643.721 1.584.722.941 0 1.581-.723.637-.721.637-2.097 0-1.34-.637-2.062-.64-.722-1.581-.722t-1.584.722q-.642.722-.642 2.08m-2.467-.129q0-1.203.591-2.33a4.07 4.07 0 0 1 1.675-1.718q1.084-.593 2.419-.593 2.064 0 3.383 1.345t1.319 3.4q0 2.07-1.332 3.432t-3.353 1.362q-1.25 0-2.385-.567a3.9 3.9 0 0 1-1.726-1.663q-.591-1.096-.591-2.668m13.284-.026q0 1.539.608 2.273t1.482.735q.84 0 1.396-.675t.556-2.212q0-1.436-.573-2.132-.574-.697-1.422-.696-.883 0-1.464.683-.583.684-.583 2.024m-2.38-4.409h2.244v1.341q.437-.687 1.181-1.117a3.25 3.25 0 0 1 1.653-.43q1.585 0 2.689 1.246t1.104 3.472q0 2.287-1.112 3.553-1.114 1.268-2.698 1.268-.753 0-1.366-.3-.612-.302-1.289-1.032v4.598h-2.406zm12.935-1.117 1.182-2.57h2.698l-2.356 2.57zm3.075 4.898q-.027-1.048-.54-1.593a1.65 1.65 0 0 0-1.25-.546 1.67 1.67 0 0 0-1.302.576q-.514.575-.505 1.563zm-.137 2.441 2.397.404q-.461 1.323-1.46 2.016-.998.69-2.496.691-2.371 0-3.511-1.556-.899-1.245-.899-3.145 0-2.269 1.182-3.553 1.18-1.285 2.988-1.285 2.03 0 3.203 1.345t1.121 4.12h-6.028q.026 1.075.583 1.673.555.596 1.387.596.565 0 .951-.309.385-.309.582-.996m9.891-2.441q-.027-1.048-.54-1.595a1.65 1.65 0 0 0-1.25-.545q-.788 0-1.301.576-.515.576-.506 1.564zm-.137 2.44 2.397.404q-.46 1.325-1.46 2.015-.998.692-2.496.693-2.371-.001-3.511-1.556-.899-1.245-.899-3.145 0-2.269 1.182-3.554 1.18-1.285 2.988-1.285 2.03 0 3.203 1.345t1.122 4.121h-6.029q.026 1.074.583 1.671.556.598 1.387.598.565 0 .951-.31.385-.309.582-.997m12.408 2.905h-2.406v-4.658q0-1.477-.154-1.912a1.34 1.34 0 0 0-.501-.674 1.42 1.42 0 0 0-.835-.241q-.625 0-1.122.344a1.73 1.73 0 0 0-.681.91q-.184.568-.184 2.098v4.133h-2.406v-9.126h2.235v1.34q1.191-1.547 2.997-1.546.797 0 1.456.287.66.288.998.735t.471 1.014q.132.568.132 1.624zm10.275 0h-2.406v-4.658q0-1.477-.154-1.912a1.35 1.35 0 0 0-.501-.674 1.43 1.43 0 0 0-.835-.241q-.626 0-1.122.344a1.73 1.73 0 0 0-.681.91q-.184.568-.184 2.098v4.133h-2.406v-9.126h2.235v1.34q1.19-1.547 2.997-1.546.797 0 1.456.287.659.288.998.735.337.447.471 1.014.131.568.132 1.624zm7.67-5.345q-.027-1.048-.54-1.595a1.65 1.65 0 0 0-1.25-.545q-.788 0-1.301.576-.515.576-.506 1.564zm-.137 2.44 2.397.404q-.46 1.325-1.46 2.015-.997.692-2.496.693-2.371-.001-3.511-1.556-.899-1.245-.899-3.145 0-2.269 1.182-3.554t2.988-1.285q2.031 0 3.203 1.345 1.174 1.345 1.122 4.121h-6.028q.025 1.074.582 1.671.556.598 1.387.598.565 0 .951-.31.385-.309.582-.997M74.548 6.168h2.535v6.824q0 1.624.094 2.105.162.774.775 1.243.613.468 1.674.468 1.079 0 1.627-.443.547-.443.66-1.087.11-.645.11-2.14v-6.97h2.536v6.618q0 2.269-.205 3.205-.206.938-.759 1.581-.552.645-1.477 1.027-.924.384-2.415.383-1.799 0-2.727-.417-.93-.417-1.469-1.083-.54-.666-.711-1.396-.248-1.083-.248-3.197zM94.96 18.767h-2.406v-4.658q0-1.478-.154-1.912a1.34 1.34 0 0 0-.501-.674 1.43 1.43 0 0 0-.835-.241q-.625 0-1.122.344a1.73 1.73 0 0 0-.68.91q-.186.568-.185 2.098v4.133H86.67V9.64h2.235v1.34q1.19-1.545 2.997-1.545.796 0 1.456.287.66.288.998.735.337.445.47 1.014.132.568.133 1.624zm2.002 0h2.407V9.64h-2.407zm0-10.364h2.407V6.17h-2.407zm6.345 5.801q0 1.358.641 2.079.643.722 1.585.723.941 0 1.58-.723.639-.721.638-2.097 0-1.34-.638-2.062-.639-.722-1.58-.722t-1.585.722q-.641.721-.641 2.08m-2.467-.129q0-1.203.591-2.33a4.06 4.06 0 0 1 1.675-1.718q1.082-.593 2.418-.593 2.065 0 3.383 1.345 1.32 1.345 1.319 3.399 0 2.07-1.332 3.433t-3.352 1.362a5.26 5.26 0 0 1-2.385-.567 3.9 3.9 0 0 1-1.726-1.663q-.591-1.095-.591-2.668m19.104 4.692h-2.406v-4.658q0-1.478-.155-1.912a1.34 1.34 0 0 0-.5-.674 1.43 1.43 0 0 0-.835-.241q-.626 0-1.123.344a1.73 1.73 0 0 0-.68.91q-.184.568-.184 2.098v4.133h-2.407V9.64h2.236v1.34q1.19-1.545 2.997-1.545.796 0 1.456.287.659.288.998.735.337.445.471 1.014.131.568.132 1.624z",
  "clip-rule": "evenodd"
}, null, -1), E61 = [
  S61,
  C61,
  k61
];
function A61(t, e) {
  return T(), N("svg", x61, [...E61]);
}
const F61 = { render: A61 }, T61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, I61 = /* @__PURE__ */ U1('<path fill="#039" d="M.878.88h63.243v42.24H.878z"></path><path fill="#FC0" fill-rule="evenodd" d="m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.423 37.239V25.52h9.31v2.13H77.08v2.794h6.303v2.122H77.08v3.43h7.014v2.122zm13.066-4.564q0 1.358.642 2.08.644.722 1.585.722.942 0 1.58-.722t.638-2.097q0-1.34-.638-2.062-.639-.723-1.58-.723t-1.585.723q-.642.721-.642 2.08m-2.467-.13q0-1.203.591-2.329a4.07 4.07 0 0 1 1.676-1.718q1.082-.593 2.418-.593 2.065 0 3.384 1.344 1.32 1.345 1.319 3.4 0 2.07-1.332 3.432t-3.353 1.363q-1.251 0-2.385-.568a3.9 3.9 0 0 1-1.727-1.662q-.59-1.095-.59-2.668m13.136 4.692h-2.406v-9.127h2.235v1.298q.574-.92 1.031-1.212a1.9 1.9 0 0 1 1.041-.292q.823 0 1.585.455l-.745 2.106q-.609-.396-1.13-.396-.506 0-.858.28-.35.278-.552 1.01-.2.73-.2 3.059zm6.835-4.719q0 1.54.607 2.273.609.735 1.482.735.84 0 1.397-.675.555-.675.556-2.212 0-1.436-.574-2.131-.573-.697-1.422-.696-.882 0-1.464.683t-.582 2.024m-2.382-4.408h2.245v1.34q.437-.687 1.181-1.117a3.25 3.25 0 0 1 1.653-.43q1.584 0 2.69 1.247 1.104 1.246 1.104 3.471 0 2.288-1.113 3.554-1.114 1.269-2.697 1.268-.755 0-1.367-.301t-1.289-1.031v4.598h-2.407zm15.714 4.743q-.463.154-1.465.37-1.002.215-1.31.42-.471.336-.471.85 0 .51.377.877.377.37.959.37.651 0 1.242-.43.436-.326.574-.798.094-.31.094-1.178zm-3.22-1.96-2.184-.395q.368-1.323 1.267-1.96.9-.635 2.672-.635 1.612 0 2.398.383.788.382 1.109.97.321.59.321 2.161l-.025 2.82q0 1.203.116 1.774.116.572.432 1.224h-2.381a10 10 0 0 1-.231-.713 5 5 0 0 0-.085-.283q-.617.6-1.32.902-.703.3-1.498.3-1.405 0-2.214-.764-.81-.764-.809-1.934 0-.774.368-1.379a2.4 2.4 0 0 1 1.031-.928q.665-.323 1.915-.563 1.686-.318 2.338-.593v-.241q0-.696-.343-.992-.342-.296-1.293-.296-.643 0-1.002.253-.36.255-.582.889m15.448-.086-2.372.43q-.12-.713-.544-1.074-.423-.36-1.1-.361-.9 0-1.435.623-.535.624-.535 2.084 0 1.624.544 2.294.543.67 1.46.671.684 0 1.122-.392.437-.39.616-1.344l2.364.404q-.369 1.632-1.413 2.466t-2.801.834q-1.996 0-3.181-1.263-1.186-1.264-1.186-3.498 0-2.26 1.19-3.52 1.19-1.259 3.22-1.259 1.662 0 2.643.718t1.408 2.187m4.047-6.17v4.632q1.165-1.365 2.784-1.366.83 0 1.498.309.669.31 1.006.79.339.482.463 1.066t.124 1.813v5.354h-2.406v-4.82q0-1.436-.137-1.822a1.2 1.2 0 0 0-.484-.615q-.347-.227-.869-.227-.6-.001-1.071.292-.471.291-.69.88t-.218 1.74v4.572h-2.406V25.52zm-59.557-13.5 2.184.396q.222-.636.583-.89.36-.252 1.002-.253.95 0 1.293.297.343.296.343.992v.24q-.652.276-2.339.594-1.25.24-1.914.562a2.4 2.4 0 0 0-1.031.929 2.6 2.6 0 0 0-.369 1.378q0 1.17.81 1.935t2.213.765q.795 0 1.5-.302.701-.3 1.318-.901.026.068.085.283.138.472.232.713h2.38a5.2 5.2 0 0 1-.432-1.224q-.115-.572-.115-1.775l.025-2.819q0-1.572-.32-2.161-.322-.59-1.11-.97-.788-.384-2.398-.384-1.773 0-2.672.636-.9.637-1.268 1.96m3.94 2.725q1.002-.215 1.465-.37v.482q0 .868-.094 1.177a1.52 1.52 0 0 1-.575.8q-.591.429-1.242.429-.581 0-.958-.37a1.18 1.18 0 0 1-.377-.876q0-.516.47-.851.31-.207 1.31-.421" clip-rule="evenodd"></path><path fill="#fff" d="M93.412 18.758h-2.406V14.1q0-1.478-.155-1.912a1.34 1.34 0 0 0-.5-.674 1.43 1.43 0 0 0-.835-.241 1.93 1.93 0 0 0-1.123.344 1.73 1.73 0 0 0-.68.91q-.185.569-.185 2.098v4.133h-2.406V9.632h2.235v1.34q1.19-1.547 2.998-1.546.796 0 1.456.287.66.288.998.735t.47 1.014.133 1.624zm11.836-9.126v1.925h-1.645v3.678q0 1.117.048 1.302a.52.52 0 0 0 .214.304q.166.12.406.12.335 0 .968-.231l.206 1.873q-.84.36-1.901.36-.652 0-1.174-.218-.523-.219-.766-.567-.246-.348-.339-.94-.077-.422-.077-1.703v-3.978h-1.105V9.632h1.105V7.818l2.415-1.41v3.224z"></path><path fill="#fff" fill-rule="evenodd" d="M115.851 18.758h2.757L113.581 6.16H110.9l-4.89 12.598h2.689l1.036-2.862h5.019zM112.21 9.1l1.731 4.675h-3.426zm7.321 2.637a4.95 4.95 0 0 0-.591 2.33q0 1.571.591 2.668.592 1.095 1.726 1.662a5.26 5.26 0 0 0 2.385.567q2.022 0 3.353-1.362 1.333-1.362 1.332-3.433 0-2.053-1.319-3.4-1.318-1.344-3.383-1.344-1.336 0-2.419.593a4.07 4.07 0 0 0-1.675 1.719m2.518 4.537q-.642-.721-.642-2.08 0-1.357.642-2.079.643-.722 1.585-.722.941 0 1.58.722.638.723.638 2.062 0 1.375-.638 2.097-.639.723-1.58.723t-1.585-.723" clip-rule="evenodd"></path><path fill="#fff" d="M138.046 18.758h-2.406V14.1q0-1.478-.155-1.912a1.34 1.34 0 0 0-.501-.674 1.42 1.42 0 0 0-.834-.241q-.627 0-1.123.344a1.73 1.73 0 0 0-.681.91q-.184.569-.184 2.098v4.133h-2.406V9.632h2.235v1.34q1.19-1.547 2.998-1.546.795 0 1.456.287.659.288.998.735.337.447.471 1.014.131.567.132 1.624zm6.612-9.126v1.925h-1.644v3.678q0 1.117.047 1.302a.53.53 0 0 0 .214.304.67.67 0 0 0 .407.12q.334 0 .967-.231l.206 1.873q-.839.36-1.901.36-.651 0-1.173-.218-.524-.219-.767-.567-.245-.348-.339-.94-.077-.422-.077-1.703v-3.978h-1.105V9.632h1.105V7.818l2.416-1.41v3.224z"></path><path fill="#fff" fill-rule="evenodd" d="m146.118 12.02 2.184.396q.223-.636.582-.89.36-.252 1.003-.253.95 0 1.292.297.343.296.343.992v.24q-.65.276-2.338.594-1.25.24-1.914.562a2.4 2.4 0 0 0-1.032.929 2.6 2.6 0 0 0-.368 1.378q0 1.17.809 1.935.81.765 2.214.765.797 0 1.499-.302.702-.3 1.319-.901.025.068.085.283.138.472.231.713h2.382a5 5 0 0 1-.433-1.224q-.116-.572-.116-1.775l.026-2.819q0-1.572-.321-2.161-.321-.59-1.11-.97-.787-.384-2.397-.384-1.774 0-2.673.636-.898.637-1.267 1.96m3.94 2.725q1.002-.215 1.464-.37v.482q0 .868-.094 1.177-.138.471-.574.8-.591.429-1.242.429-.582 0-.958-.37a1.18 1.18 0 0 1-.378-.876q0-.516.471-.851.308-.207 1.311-.421" clip-rule="evenodd"></path><path fill="#fff" d="m155.411 16.154 2.415-.37q.154.705.625 1.07t1.319.366q.934 0 1.404-.344a.77.77 0 0 0 .318-.644.64.64 0 0 0-.172-.456q-.179-.172-.805-.318-2.912-.645-3.691-1.177-1.08-.74-1.079-2.054 0-1.186.933-1.994.934-.807 2.895-.807 1.867-.001 2.775.61.908.61 1.25 1.804l-2.269.421q-.145-.532-.553-.817-.407-.283-1.16-.283-.951 0-1.362.267-.274.19-.274.49 0 .258.24.438.325.24 2.248.679 1.924.438 2.685 1.074.754.645.754 1.796 0 1.254-1.045 2.157-1.046.903-3.092.902-1.859 0-2.942-.756a3.48 3.48 0 0 1-1.417-2.054"></path>', 8), O61 = [
  I61
];
function N61(t, e) {
  return T(), N("svg", T61, [...O61]);
}
const P61 = { render: N61 }, B61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, V61 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M94.336 8.99h-1.791v8.89h-3.05V8.99h-6.297V6.361h11.138zm5.146-2.628v11.519h-3.138V6.362zm13.7 11.518h-3.04v-6.046q0-1.51-.662-2.291-.662-.782-2.432-.782-.944 0-1.574.12v9h-3.05V6.59a25 25 0 0 1 4.244-.36q2.748 0 4.071.674 1.336.673 1.889 1.791.555 1.107.554 2.964zm6.079-11.518v6.427h-3.137V6.362zm10.683 6.622 3.474 4.897h-3.583l-4.027-5.69q-.76.75-.956 3.399l-.173 2.29h-2.953l.217-2.442q.217-2.486.847-3.572.628-1.085 1.596-1.682l-2.682-3.822h3.572l3.333 4.712q.846-.62 1.031-2.823l.152-1.889h2.822l-.13 1.4q-.228 2.444-.847 3.485a5.4 5.4 0 0 1-1.693 1.737M146 17.88h-3.04v-5.427q0-2.118-1.053-2.92-1.042-.816-3.148-.815-1.574 0-3.431.271l-.217-2.442q1.77-.315 4.18-.315 2.616 0 4.049.76 1.434.75 2.041 1.889.62 1.129.619 3.126zm-7.708-5.981v5.982h-3.05v-5.982zM82.46 26.076v6.427h-3.138v-6.427zm2.855.358a16 16 0 0 1 4.18-.553q3.027 0 4.82 1.596 1.8 1.585 1.801 4.114 0 2.941-1.954 4.56-1.954 1.617-5.113 1.617-1.986 0-4.028-.727l.597-2.052q1.65.63 3.138.63 1.9 0 3.04-.977 1.14-.99 1.14-2.92 0-1.77-.923-2.78t-2.595-1.01q-.608 0-1.237.12v1.335q0 1.585 1.27 1.585.174 0 .39-.022l.51 1.89a4.3 4.3 0 0 1-1.682.325 4.2 4.2 0 0 1-1.596-.304q-.738-.303-1.248-1.075-.51-.77-.51-2.66zm16.273-.358v11.518H98.45V26.076zm11.714 11.518h-3.04v-5.667q0-1.846-.923-2.638-.912-.792-2.909-.792-1.021 0-2.704.206l-.228-2.399q1.564-.358 3.605-.358 3.093 0 4.646 1.292 1.553 1.291 1.553 4.136zm5.959-11.518v6.427h-3.137v-6.427zm10.683 6.622 3.474 4.896h-3.583l-4.027-5.688q-.76.75-.956 3.398l-.173 2.29h-2.953l.217-2.442q.217-2.486.847-3.572.628-1.086 1.596-1.683l-2.682-3.821h3.572l3.333 4.712q.846-.62 1.031-2.823l.152-1.889h2.822l-.13 1.4q-.228 2.443-.847 3.485a5.4 5.4 0 0 1-1.693 1.737M146 37.594h-3.04v-5.428q0-2.116-1.053-2.92-1.042-.814-3.148-.814-1.574 0-3.431.271l-.217-2.442q1.77-.315 4.18-.315 2.616 0 4.049.76 1.434.75 2.041 1.889.62 1.129.619 3.126zm-7.708-5.981v5.981h-3.05v-5.981z"
}, null, -1), R61 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M154.878.88h63.243v42.24h-63.243z"
}, null, -1), H61 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m184.339 7.744 1.335.977-.509 1.593 1.335-.986 1.335.986-.509-1.593 1.335-.977h-1.652L186.5 6.16l-.509 1.584zm3.496 30.096-.509-1.584 1.335-.977h-1.652l-.509-1.593-.509 1.593h-1.652l1.335.977-.509 1.584 1.335-.977zM172.85 23.057l-1.335.985.509-1.584-1.335-.95h1.652l.509-1.584.509 1.584h1.661l-1.344.985.509 1.584-1.335-.985zm8.16-10.913-.509-1.584 1.335-.968h-1.652l-.509-1.584-.509 1.584h-1.652l1.335.977-.509 1.584 1.335-.977zm-6.807 2.482.509-1.584.518 1.584h1.608l-1.335.986.509 1.584-1.344-.986-1.344.986.51-1.584-1.335-.986zm0 13.763h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.509-1.584 1.335-.985h-1.608l-.518-1.584zm4.646 6.02-1.335-.969h1.652l.509-1.584.509 1.584h1.652l-1.335.968.509 1.584-1.335-.976-1.335.976zm22.636-10.332-.509-1.584 1.335-.985h-1.616l-.51-1.584-.509 1.584h-1.713l1.344.985-.51 1.584 1.353-.985zm-8.986-13.517-1.335-.968h1.652l.509-1.584.509 1.584h1.652l-1.335.968.509 1.584-1.335-.968-1.335.977.509-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.986-.51 1.584 1.344-.986 1.335.986-.509-1.584 1.3-.995h-1.652zm.553 15.356h1.608l-1.3.985.509 1.584-1.335-.976-1.344.976.51-1.584-1.327-.985h1.652l.518-1.584zm-4.69 6.02 1.335-.969h-1.652l-.509-1.584-.509 1.584h-1.652l1.335.968-.509 1.584 1.335-.976 1.335.976z",
  "clip-rule": "evenodd"
}, null, -1), D61 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M219 44h-65V0h65zM218.122.88h-63.244v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), $61 = [
  V61,
  R61,
  H61,
  D61
];
function U61(t, e) {
  return T(), N("svg", B61, [...$61]);
}
const j61 = { render: U61 }, G61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, W61 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Y61 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), X61 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zM80.76 37.845v-1.367a3.5 3.5 0 0 1-1.309 1.152q-.81.42-1.713.42-.918.001-1.648-.403a2.38 2.38 0 0 1-1.057-1.134q-.326-.73-.326-2.02v-5.775h2.413v4.195q0 1.925.133 2.358.132.436.485.687.352.255.893.255a1.9 1.9 0 0 0 1.108-.34q.49-.34.67-.842.18-.504.18-2.463v-3.85h2.413v9.127zm12.772 0H91.12v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.628 0-1.126.344t-.682.91q-.185.568-.185 2.098v4.133H85.22v-9.127h2.242v1.34q1.193-1.545 3.005-1.546.799 0 1.46.288t1 .735.473 1.014q.131.568.132 1.624zm2.272-.001h2.412v-9.126h-2.412zm0-10.363h2.412v-2.235h-2.412zm4.834-.001h2.413v-2.234h-2.413zm2.413 1.238v8.843q0 1.745-.228 2.462a2 2 0 0 1-.876 1.122q-.647.404-1.653.403-.361.001-.776-.064a9 9 0 0 1-.898-.193l.421-2.062q.171.034.322.055.15.022.279.022.369 0 .606-.16a.77.77 0 0 0 .313-.382q.078-.224.077-1.34v-8.706zm7.557 4.744q-.465.154-1.469.37-1.005.215-1.314.42-.471.336-.472.851 0 .508.378.877.378.37.961.37.654 0 1.246-.43.437-.327.575-.8.095-.309.095-1.177zm-3.229-1.96-2.19-.395q.37-1.323 1.271-1.959t2.679-.636q1.614 0 2.404.383.79.381 1.112.97.322.59.322 2.162l-.025 2.818q0 1.204.116 1.775.115.572.433 1.224h-2.387a9 9 0 0 1-.232-.712 5 5 0 0 0-.085-.284q-.619.601-1.323.902-.704.3-1.503.301-1.407 0-2.219-.765-.812-.764-.812-1.934 0-.773.37-1.379.369-.605 1.034-.928.666-.322 1.919-.562 1.691-.318 2.345-.593v-.242q0-.695-.344-.991t-1.296-.297q-.644 0-1.005.253-.361.255-.584.89M74.768 18.767V6.169h9.334v2.13H77.31v2.793h6.32v2.123h-6.32v3.43h7.033v2.122zm17.468 0V17.4a3.5 3.5 0 0 1-1.309 1.152 3.7 3.7 0 0 1-1.714.42q-.918.001-1.647-.403a2.38 2.38 0 0 1-1.057-1.135q-.327-.73-.327-2.02V9.64h2.413v4.194q0 1.925.134 2.359.132.435.484.687.353.254.894.254a1.9 1.9 0 0 0 1.108-.34q.49-.339.67-.841.18-.504.18-2.463V9.64h2.413v9.127zm6.787 0H96.61V9.64h2.241v1.298q.575-.92 1.034-1.212a1.9 1.9 0 0 1 1.044-.292q.825 0 1.589.455l-.747 2.106q-.61-.396-1.134-.396-.507 0-.859.28-.351.28-.554 1.01-.202.73-.201 3.06zm6.185-4.563q0 1.358.644 2.079t1.589.722q.944 0 1.584-.722t.639-2.097q0-1.34-.639-2.062-.64-.722-1.584-.722t-1.589.722-.644 2.08m-2.474-.129q0-1.203.593-2.33a4.07 4.07 0 0 1 1.68-1.718q1.085-.593 2.425-.593 2.07 0 3.392 1.345t1.323 3.399q0 2.07-1.336 3.433t-3.362 1.362q-1.253 0-2.391-.567a3.9 3.9 0 0 1-1.731-1.663q-.593-1.095-.593-2.668m13.321-.026q0 1.538.609 2.273.611.735 1.486.735.842 0 1.4-.675.557-.674.558-2.213 0-1.435-.575-2.131-.575-.697-1.426-.696a1.85 1.85 0 0 0-1.468.683q-.584.684-.584 2.024m-2.387-4.409h2.25v1.341q.438-.687 1.184-1.117a3.27 3.27 0 0 1 1.658-.43q1.588 0 2.697 1.246 1.106 1.245 1.107 3.472 0 2.286-1.116 3.553-1.117 1.268-2.705 1.268-.756 0-1.37-.3-.615-.302-1.292-1.032v4.598h-2.413zm9.785 6.523 2.421-.37q.155.705.627 1.07t1.323.366q.936 0 1.408-.345a.77.77 0 0 0 .318-.644.64.64 0 0 0-.172-.456q-.18-.171-.808-.317-2.918-.644-3.701-1.178-1.081-.738-1.081-2.054 0-1.185.935-1.994.937-.806 2.903-.807 1.872 0 2.782.61t1.254 1.805l-2.276.42a1.4 1.4 0 0 0-.554-.816q-.407-.283-1.163-.283-.953 0-1.366.266-.273.19-.274.49 0 .258.24.439.326.24 2.255.678 1.927.438 2.691 1.075.757.644.757 1.796 0 1.254-1.049 2.157-1.048.902-3.099.902-1.865 0-2.95-.756a3.48 3.48 0 0 1-1.421-2.054m10.193 2.604V6.169h2.412v6.685l2.826-3.214h2.971l-3.117 3.335 3.34 5.792h-2.602l-2.293-4.1-1.125 1.178v2.922zm14.898-4.383q-.463.154-1.468.37-1.005.215-1.314.42-.472.336-.472.851 0 .508.378.877.377.37.961.37.653 0 1.245-.43.438-.327.576-.8.094-.309.094-1.177zm-3.229-1.96-2.189-.395q.37-1.323 1.27-1.959.902-.636 2.68-.636 1.614 0 2.404.383.79.381 1.112.97.322.59.322 2.162l-.026 2.818q0 1.204.116 1.775.117.572.434 1.224h-2.387a9 9 0 0 1-.233-.712 4 4 0 0 0-.085-.284q-.618.601-1.322.902-.705.3-1.503.301-1.408 0-2.219-.765-.812-.765-.812-1.934 0-.774.369-1.379.369-.606 1.034-.928.667-.322 1.92-.562 1.691-.319 2.344-.594v-.24q0-.696-.344-.992-.343-.298-1.296-.297-.644 0-1.005.253-.36.255-.584.89",
  "clip-rule": "evenodd"
}, null, -1), K61 = [
  W61,
  Y61,
  X61
];
function Z61(t, e) {
  return T(), N("svg", G61, [...K61]);
}
const J61 = { render: Z61 }, Q61 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, en1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), tn1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), nn1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zM74.73 25.247h2.541v6.823q0 1.625.094 2.105.164.774.777 1.243.614.468 1.678.468 1.081 0 1.63-.443.55-.442.662-1.087t.112-2.14v-6.97h2.54v6.618q0 2.268-.205 3.205-.207.937-.76 1.582-.555.644-1.48 1.027-.927.382-2.421.382-1.803 0-2.734-.417t-1.472-1.083-.713-1.396q-.248-1.083-.249-3.197zm20.46 12.598h-2.41v-4.658q0-1.477-.155-1.912a1.34 1.34 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.627 0-1.125.344a1.73 1.73 0 0 0-.682.91q-.184.569-.184 2.098v4.133h-2.412V28.72h2.24v1.34q1.194-1.546 3.004-1.546.799 0 1.46.288.66.287 1 .734.338.447.472 1.014.132.567.133 1.625zm2.008 0h2.412V28.72h-2.412zm0-10.364h2.412v-2.235h-2.412zm7.371.121 1.185-2.57h2.704l-2.361 2.57zm-1.012 5.68q0 1.357.643 2.08.644.721 1.588.722.944 0 1.583-.723.641-.722.64-2.096.001-1.34-.64-2.063-.639-.721-1.583-.722-.944 0-1.588.722-.643.722-.643 2.08m-2.473-.129q0-1.203.592-2.329a4.07 4.07 0 0 1 1.678-1.719q1.086-.593 2.426-.593 2.068 0 3.39 1.345 1.322 1.346 1.322 3.4 0 2.07-1.335 3.432t-3.361 1.362q-1.253 0-2.39-.567a3.9 3.9 0 0 1-1.73-1.663q-.591-1.096-.592-2.668M74.74 18.767V6.169h9.33v2.13h-6.788v2.793h6.317v2.123h-6.317v3.43h7.03v2.122zm17.463 0V17.4a3.5 3.5 0 0 1-1.31 1.152q-.81.42-1.712.42-.918.001-1.648-.403a2.38 2.38 0 0 1-1.056-1.135q-.326-.73-.326-2.02V9.64h2.412v4.194q0 1.925.133 2.359.132.435.485.687.351.254.893.254.618 0 1.107-.34a1.73 1.73 0 0 0 .67-.842q.18-.503.18-2.462V9.64h2.412v9.127zm6.783 0h-2.412V9.64h2.24v1.298q.576-.92 1.035-1.212a1.9 1.9 0 0 1 1.043-.292q.824 0 1.588.455l-.747 2.106q-.61-.396-1.133-.396-.506 0-.859.28-.35.28-.553 1.01-.202.73-.202 3.059zm7.196-10.244 1.185-2.57h2.704l-2.361 2.57zm-1.013 5.68q0 1.358.644 2.08t1.588.722 1.583-.722.64-2.096q0-1.341-.64-2.063-.639-.723-1.583-.723t-1.588.723-.644 2.08m-2.472-.128q0-1.204.592-2.33a4.07 4.07 0 0 1 1.678-1.718q1.086-.593 2.425-.593 2.069 0 3.391 1.344 1.322 1.346 1.322 3.4 0 2.07-1.335 3.433t-3.361 1.362q-1.253 0-2.39-.568a3.9 3.9 0 0 1-1.73-1.662q-.591-1.096-.592-2.668m13.315-.027q0 1.538.609 2.273.61.735 1.486.735.841 0 1.399-.675.557-.675.558-2.213 0-1.435-.575-2.131-.575-.697-1.425-.696-.886 0-1.468.683-.584.683-.584 2.024m-2.386-4.41h2.249v1.342q.438-.687 1.184-1.118a3.26 3.26 0 0 1 1.657-.429q1.588 0 2.696 1.246 1.106 1.245 1.107 3.472 0 2.286-1.116 3.553-1.116 1.268-2.704 1.268-.756 0-1.369-.3-.615-.302-1.292-1.032v4.598h-2.412zm15.661 4.745q-.463.154-1.468.37-1.004.214-1.313.42-.472.336-.472.851 0 .508.378.877.377.37.961.37.653 0 1.244-.43.438-.326.576-.8.094-.309.094-1.177zm-3.228-1.96-2.188-.395q.37-1.323 1.27-1.959.901-.636 2.678-.636 1.615 0 2.403.383.79.381 1.112.97t.322 2.162l-.026 2.818q0 1.204.116 1.775.117.572.434 1.224h-2.387a10 10 0 0 1-.232-.712 4 4 0 0 0-.085-.284q-.618.6-1.322.902-.704.3-1.502.301-1.407 0-2.219-.765t-.811-1.934q0-.773.369-1.379.368-.606 1.034-.928t1.919-.562q1.69-.319 2.343-.594v-.24q0-.696-.344-.992-.343-.298-1.295-.297-.644 0-1.005.253-.36.254-.584.89m8.151 6.342h2.412V9.64h-2.412zm0-10.365h2.412V6.168h-2.412z",
  "clip-rule": "evenodd"
}, null, -1), in1 = [
  en1,
  tn1,
  nn1
];
function sn1(t, e) {
  return T(), N("svg", Q61, [...in1]);
}
const ln1 = { render: sn1 }, rn1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, an1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), on1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), cn1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), hn1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M77.31 19V6.115h9.553v2.18h-6.952v2.856h6.469v2.171h-6.47v3.507h7.198V19zm14.554 0-3.761-9.334h2.592l1.758 4.764.51 1.59q.203-.605.255-.8.123-.395.263-.79l1.776-4.764h2.54L94.087 19zm9.818 0h-2.47V9.666h2.294v1.327q.588-.94 1.055-1.24.474-.297 1.072-.298.843 0 1.626.466l-.765 2.153q-.624-.405-1.16-.404-.519 0-.879.29-.36.281-.571 1.028-.202.747-.202 3.13zm4.078-4.799q0-1.23.606-2.382a4.2 4.2 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.118 0 3.472 1.38 1.353 1.37 1.354 3.472 0 2.118-1.372 3.515-1.362 1.389-3.436 1.389a5.44 5.44 0 0 1-2.452-.58 4 4 0 0 1-1.767-1.696q-.606-1.125-.606-2.734m2.531.132q0 1.389.659 2.127.66.738 1.626.738.968 0 1.617-.738.66-.738.66-2.145 0-1.371-.66-2.109-.65-.738-1.617-.738-.966 0-1.626.738t-.659 2.127m1.037-5.81 1.213-2.627h2.769l-2.417 2.627zm7.937 1.143h2.302v1.371q.449-.704 1.213-1.142a3.34 3.34 0 0 1 1.697-.44q1.625 0 2.759 1.274t1.134 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.319-1.054v4.702h-2.469zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.86 0 1.432-.686.571-.694.571-2.267 0-1.468-.588-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066M134.482 19v-1.398q-.51.748-1.344 1.178a3.7 3.7 0 0 1-1.749.43 3.43 3.43 0 0 1-1.688-.412 2.44 2.44 0 0 1-1.081-1.16q-.334-.747-.334-2.066V9.666h2.47v4.29q0 1.968.132 2.416.14.44.501.703.36.255.914.255.633 0 1.134-.343a1.8 1.8 0 0 0 .685-.861q.185-.519.185-2.523V9.667h2.469V19zm3.991-2.663 2.478-.378q.159.72.642 1.099.483.369 1.353.369.958 0 1.442-.352a.79.79 0 0 0 .325-.659.65.65 0 0 0-.176-.466q-.184-.175-.826-.325-2.988-.659-3.788-1.204-1.108-.756-1.108-2.1 0-1.214.958-2.04.958-.825 2.971-.826 1.916 0 2.848.624t1.283 1.846l-2.329.43q-.15-.544-.571-.835-.413-.29-1.187-.29-.975 0-1.397.273-.282.194-.282.5 0 .265.246.45.335.245 2.303.694 1.978.448 2.76 1.098.773.66.773 1.837 0 1.282-1.072 2.206t-3.173.923q-1.907 0-3.023-.773a3.57 3.57 0 0 1-1.45-2.101m12.735-3.823-2.241-.405q.377-1.353 1.301-2.004.922-.65 2.742-.65 1.652 0 2.461.396.809.386 1.133.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.449 1.248h-2.444a9 9 0 0 1-.237-.73 4 4 0 0 0-.088-.29q-.633.615-1.353.923a3.9 3.9 0 0 1-1.539.308q-1.44 0-2.276-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.686-.333 1.968-.58 1.732-.324 2.4-.606v-.246q0-.712-.352-1.01-.352-.309-1.327-.308-.659 0-1.028.263-.37.255-.598.906m3.305 2.004q-.476.158-1.503.377-1.029.22-1.345.431-.483.343-.483.87 0 .519.386.897.387.378.985.378.668 0 1.274-.44.448-.334.589-.817.096-.316.097-1.204zm4.684-4.852h2.277v1.274q1.221-1.485 2.909-1.485.896 0 1.555.37.66.368 1.082 1.115.615-.747 1.327-1.116.711-.369 1.52-.369 1.029 0 1.74.422.713.413 1.064 1.222.255.598.255 1.933V19h-2.47v-5.335q0-1.388-.255-1.793-.342-.527-1.055-.527-.518 0-.975.316-.458.317-.659.932-.202.606-.202 1.925V19h-2.47v-5.115q0-1.362-.132-1.758t-.413-.589q-.273-.193-.747-.193-.572 0-1.028.307a1.7 1.7 0 0 0-.66.888q-.193.58-.193 1.925V19h-2.47zM77.187 38V25.115h2.47v4.64q1.141-1.3 2.706-1.3 1.705 0 2.822 1.24 1.116 1.23 1.116 3.541 0 2.391-1.143 3.683-1.134 1.292-2.76 1.292-.8 0-1.582-.396a3.8 3.8 0 0 1-1.335-1.186V38zm2.452-4.87q0 1.451.457 2.145.641.985 1.705.985.818 0 1.388-.695.58-.703.58-2.206 0-1.6-.58-2.302-.579-.712-1.485-.712-.888 0-1.476.694-.59.685-.59 2.092m10.504-1.617-2.242-.405q.378-1.353 1.301-2.004.923-.65 2.742-.65 1.653 0 2.461.396.81.386 1.134.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.237-.73 4 4 0 0 0-.088-.29q-.633.615-1.354.923-.72.308-1.538.308-1.441 0-2.276-.782-.826-.783-.826-1.978 0-.79.377-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.4-.606v-.246q0-.711-.352-1.01-.352-.309-1.327-.308-.66 0-1.029.263-.369.255-.597.906m3.304 2.004q-.474.158-1.503.377-1.028.22-1.344.431-.484.343-.484.87 0 .519.387.897t.984.378q.668 0 1.275-.44.448-.334.589-.817.096-.316.096-1.204zM106.806 38h-2.47v-4.764q0-1.512-.158-1.95a1.37 1.37 0 0 0-.519-.695q-.351-.246-.852-.246-.642 0-1.152.351-.51.352-.703.932-.184.58-.184 2.145V38h-2.47v-9.334h2.294v1.371q1.221-1.582 3.076-1.582.817 0 1.494.299.677.29 1.02.747.351.457.483 1.037.141.58.141 1.661zm11.074 0h-2.294v-1.371q-.571.8-1.354 1.195a3.46 3.46 0 0 1-1.564.387q-1.608 0-2.76-1.292-1.143-1.3-1.142-3.621 0-2.373 1.116-3.604 1.116-1.239 2.821-1.239 1.564 0 2.707 1.3v-4.64h2.47zm-6.592-4.87q0 1.496.413 2.163.598.967 1.67.967.853 0 1.45-.72.598-.73.598-2.172 0-1.608-.58-2.311-.58-.712-1.485-.712-.88 0-1.477.703-.59.694-.589 2.083m9.035-5.731v-2.285h2.47V27.4zm0 10.6v-9.334h2.47V38zm6.636-12.885h2.575q.502.387.958.783l1.591-.783.396.862-1.266.588q1.688 1.697 2.417 3.41.738 1.705.738 3.226 0 2.268-1.353 3.648-1.354 1.37-3.498 1.37-2.065 0-3.411-1.362-1.335-1.37-1.335-3.542 0-2.135 1.423-3.506 1.187-1.143 2.672-1.143.475 0 .958.14.353.106.993.466-.343-.615-.571-.957-.228-.344-.712-.95l-2.197 1.046-.378-.844 1.916-.905a20 20 0 0 0-1.916-1.547m.387 8.227q0 1.396.633 2.136.641.729 1.564.729.94 0 1.6-.738.659-.738.659-2.04 0-1.308-.677-2.065-.676-.756-1.6-.756-.905 0-1.546.721-.633.713-.633 2.013"
}, null, -1), un1 = [
  an1,
  on1,
  cn1,
  hn1
];
function dn1(t, e) {
  return T(), N("svg", rn1, [...un1]);
}
const fn1 = { render: dn1 }, vn1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, pn1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), mn1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), gn1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zM80.421 32.5q-.026-1.048-.542-1.595a1.67 1.67 0 0 0-1.258-.545q-.793 0-1.309.576-.517.576-.509 1.564zm-.138 2.44 2.412.404q-.465 1.325-1.469 2.015-1.004.692-2.51.693-2.385-.001-3.531-1.556-.905-1.245-.905-3.145 0-2.269 1.189-3.554 1.188-1.285 3.006-1.285 2.041 0 3.22 1.345t1.13 4.121H76.76q.025 1.074.586 1.671.559.598 1.395.598.567 0 .956-.31.387-.309.586-.997m10.27 2.905v-1.367a3.5 3.5 0 0 1-1.314 1.152 3.7 3.7 0 0 1-1.719.421q-.92 0-1.652-.404a2.38 2.38 0 0 1-1.06-1.134q-.328-.73-.328-2.02V28.72h2.42v4.194q0 1.925.134 2.358.134.436.486.687.354.255.897.255.62 0 1.11-.34.492-.34.673-.842.18-.503.18-2.462v-3.85h2.42v9.126zm6.807 0h-2.42V28.72h2.248v1.298q.576-.921 1.037-1.212a1.9 1.9 0 0 1 1.047-.292 3.1 3.1 0 0 1 1.594.455l-.75 2.105q-.611-.396-1.137-.396-.508 0-.862.28-.352.28-.555 1.01-.202.73-.202 3.06zm6.203-4.563q0 1.357.646 2.08.647.721 1.593.722.947 0 1.59-.723.64-.721.641-2.097 0-1.34-.641-2.062-.643-.721-1.59-.722-.947 0-1.593.722t-.646 2.08m-2.481-.129q0-1.203.594-2.329a4.1 4.1 0 0 1 1.685-1.719q1.09-.593 2.432-.593 2.077 0 3.403 1.345t1.327 3.4q0 2.07-1.34 3.432t-3.372 1.362q-1.258 0-2.399-.567a3.9 3.9 0 0 1-1.736-1.663q-.594-1.096-.594-2.668m13.361-.026q0 1.538.611 2.273.612.735 1.491.735.844 0 1.404-.675.558-.675.559-2.212.001-1.437-.577-2.132-.577-.696-1.429-.696-.888 0-1.473.683t-.586 2.024m-2.395-4.409h2.257v1.342q.44-.688 1.189-1.118t1.662-.43q1.593 0 2.705 1.247 1.11 1.246 1.111 3.471 0 2.286-1.12 3.554t-2.713 1.268q-.758 0-1.374-.301-.616-.3-1.296-1.032v4.598h-2.421zm16.103 3.782q-.027-1.048-.542-1.595a1.67 1.67 0 0 0-1.258-.545q-.793 0-1.309.576-.517.576-.509 1.564zm-.138 2.44 2.412.404q-.464 1.325-1.469 2.015-1.003.692-2.511.693-2.385-.001-3.53-1.556-.906-1.245-.905-3.145 0-2.269 1.189-3.554 1.188-1.285 3.005-1.285 2.043 0 3.221 1.345 1.181 1.345 1.129 4.121h-6.063q.025 1.074.585 1.671.56.598 1.396.598.567 0 .956-.31.387-.309.585-.997m9.561-1.478q-.466.154-1.473.37-1.008.215-1.318.42-.474.336-.474.851 0 .509.38.877.379.37.964.37.655 0 1.249-.43a1.52 1.52 0 0 0 .577-.799q.095-.31.095-1.177zm-3.239-1.96-2.196-.395q.37-1.321 1.274-1.959.905-.636 2.688-.636 1.62 0 2.411.383.793.381 1.116.97.323.59.323 2.162l-.026 2.819q0 1.203.116 1.775.117.57.435 1.224h-2.394a9 9 0 0 1-.233-.713 4 4 0 0 0-.086-.283q-.62.6-1.326.902a3.8 3.8 0 0 1-1.508.3q-1.411 0-2.226-.764-.814-.765-.814-1.934 0-.774.371-1.38a2.4 2.4 0 0 1 1.037-.928q.668-.322 1.925-.562 1.696-.318 2.352-.593v-.241q0-.696-.345-.992-.344-.297-1.3-.297-.647 0-1.008.254-.362.253-.586.889M74.978 6.168h2.55v6.824q0 1.623.095 2.105.163.773.78 1.242.614.469 1.683.468 1.084 0 1.636-.442.551-.443.663-1.087.112-.645.112-2.14v-6.97h2.55v6.618q0 2.267-.206 3.205-.208.937-.763 1.581-.555.645-1.485 1.027-.93.383-2.43.383-1.808 0-2.742-.417-.935-.418-1.478-1.084-.542-.664-.715-1.395-.25-1.084-.25-3.197zm20.531 12.599h-2.42v-4.658q0-1.478-.156-1.912a1.34 1.34 0 0 0-.503-.675 1.45 1.45 0 0 0-.84-.24q-.63 0-1.129.343a1.73 1.73 0 0 0-.684.911q-.186.569-.186 2.097v4.134h-2.42V9.64h2.248v1.34q1.198-1.546 3.015-1.546a3.6 3.6 0 0 1 1.464.288q.663.288 1.004.735.339.446.474 1.013.132.568.133 1.625zm2.013 0h2.42V9.64h-2.42zm0-10.365h2.42V6.168h-2.42zm6.381 5.801q0 1.358.646 2.08.647.722 1.593.722.947 0 1.59-.722.642-.722.641-2.097 0-1.34-.641-2.062-.643-.723-1.59-.723t-1.593.723-.646 2.08m-2.481-.13q0-1.202.594-2.329a4.1 4.1 0 0 1 1.685-1.718q1.089-.593 2.433-.593 2.076 0 3.402 1.344 1.327 1.346 1.327 3.4 0 2.07-1.34 3.433t-3.372 1.362q-1.258 0-2.399-.568a3.9 3.9 0 0 1-1.736-1.662q-.594-1.096-.594-2.668m19.215 4.692h-2.42v-4.658q0-1.478-.156-1.912a1.34 1.34 0 0 0-.503-.675 1.45 1.45 0 0 0-.84-.24q-.629 0-1.129.343a1.73 1.73 0 0 0-.684.911q-.186.569-.186 2.097v4.134h-2.42V9.64h2.249v1.34q1.197-1.546 3.014-1.546.801 0 1.464.288t1.004.735q.339.446.474 1.013.132.568.133 1.625zm7.889-5.346q-.026-1.048-.542-1.594a1.67 1.67 0 0 0-1.258-.546q-.792 0-1.309.576t-.509 1.564zm-.137 2.44 2.411.404q-.464 1.325-1.468 2.016-1.004.693-2.511.692-2.386 0-3.531-1.556-.905-1.245-.905-3.145 0-2.27 1.189-3.553 1.188-1.284 3.006-1.285 2.042 0 3.221 1.345t1.129 4.12h-6.064q.026 1.075.586 1.672t1.395.597q.568 0 .956-.31.388-.307.586-.997",
  "clip-rule": "evenodd"
}, null, -1), yn1 = [
  pn1,
  mn1,
  gn1
];
function _n1(t, e) {
  return T(), N("svg", vn1, [...yn1]);
}
const qn1 = { render: _n1 }, wn1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, zn1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), Mn1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.686l-.517 1.593h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.985-.517 1.584 1.364-.976 1.365.976-.517-1.584 1.355-.985h-1.632l-.526-1.584zm4.718 6.019-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.331-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.985.517 1.584-1.355-.976-1.365.976.517-1.584-1.346-.985h1.676l.527-1.584zm-4.763 6.019 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), bn1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), Ln1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M76.112 19.773c.936.864 1.92 1.872 2.856 2.904-.768 1.8-1.728 3.384-2.856 4.608zm13.848-1.32h2.472c-.24 1.464-.552 2.976-.888 4.08l1.632.888c.696-1.68 1.296-4.296 1.656-6.576l-1.512-.576-.36.144h-5.736c.288-1.272.528-2.592.72-3.912l-2.232-.36c-.48 3.792-1.344 7.512-2.904 9.84.552.288 1.464 1.056 1.824 1.416.84-1.32 1.512-3.024 2.064-4.944h1.08v3.096c.024 1.776-.576 5.928-3.576 9v-1.272h-8.088v-1.944c.456.336 1.296 1.008 1.608 1.392 1.032-1.2 1.92-2.664 2.688-4.296.864 1.056 1.56 2.064 2.04 2.928l1.416-1.656c-.552-.984-1.488-2.184-2.568-3.408.672-1.776 1.2-3.696 1.608-5.712l-2.04-.336a34 34 0 0 1-1.128 4.344 56 56 0 0 0-2.448-2.376l-1.176 1.296v-3.816h7.92v-2.064H74v19.464h2.112v-1.728h7.2c-.408.336-.84.648-1.32.936.408.408 1.032 1.368 1.296 1.824 3.72-2.304 5.256-6.456 5.568-8.496.312 1.968 1.656 6.312 4.944 8.496.336-.528.984-1.44 1.392-1.92-4.392-2.928-5.232-8.568-5.232-10.656zm11.712-5.88v7.44c0 4.272-.432 9-4.296 12.432.48.384 1.272 1.176 1.584 1.728 4.392-3.888 4.92-9.216 4.92-14.16v-7.44zm6.72.528v19.488h2.184V13.1zm6.96-.6v21.432h2.232V12.5zm-16.536 5.496c-.336 2.184-1.056 4.752-2.064 6.432l1.92.792c1.032-1.704 1.656-4.488 2.064-6.696zm5.232 1.128c.816 1.992 1.584 4.536 1.776 6.12l1.92-.864c-.216-1.56-1.032-4.032-1.896-5.952zm6.672-.048c1.056 1.872 2.112 4.392 2.472 5.976l1.824-1.008c-.36-1.536-1.512-3.96-2.616-5.832zm19.8 4.512v-1.584h3.144v1.584zm0-4.68h3.144v1.56h-3.144zm8.544 0v1.56h-3.24v-1.56zm0 4.68h-3.24v-1.584h3.24zm-5.4 7.368h2.16v-2.52h6.864v-1.824h-6.864v-1.416h5.376v-7.872h-5.376v-1.368h6.528v-1.848h-6.528v-1.944h-2.16v1.944h-6.24v1.848h6.24v1.368h-5.208v7.872h5.208v1.416h-6.576v1.824h6.576zm-6.816-14.352c-.72-1.176-2.4-2.76-3.792-3.84l-1.704 1.248c1.416 1.152 3.024 2.808 3.696 4.008zm-.648 4.872h-5.016v2.064h2.88v5.784a33 33 0 0 1-3.144 2.448l1.104 2.208a82 82 0 0 0 3.24-2.976c1.464 1.848 3.528 2.64 6.504 2.76 2.784.096 7.872.048 10.632-.072.12-.648.456-1.68.72-2.184-3.048.216-8.616.288-11.328.168-2.664-.12-4.56-.864-5.592-2.52zm35.016 5.112v4.704h-10.32v-4.704zm-12.504 7.632h2.184v-.936h10.32v.936h2.28v-9.648h-14.784zm1.848-14.352c2.256-1.728 4.176-3.696 5.4-5.472 1.344 1.848 3.408 3.792 5.664 5.472zm4.152-7.656c-1.824 3-5.76 6.6-9.864 8.688.456.456 1.104 1.248 1.368 1.776 1.32-.72 2.64-1.536 3.864-2.448v1.632h11.952v-1.704a31 31 0 0 0 3.888 2.424c.384-.672.912-1.44 1.464-1.992-3.768-1.632-7.824-4.8-10.392-8.376z"
}, null, -1), xn1 = [
  zn1,
  Mn1,
  bn1,
  Ln1
];
function Sn1(t, e) {
  return T(), N("svg", wn1, [...xn1]);
}
const Cn1 = { render: Sn1 }, kn1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, En1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M74.018 18.5V5.615h9.553v2.18H76.62v2.856h6.469v2.171H76.62v3.507h7.198V18.5zm18.132 0v-1.398q-.51.748-1.345 1.178-.826.43-1.75.43-.94 0-1.687-.412a2.44 2.44 0 0 1-1.08-1.16q-.335-.747-.335-2.066V9.166h2.47v4.29q0 1.968.132 2.416.14.44.5.703.36.255.915.255.633 0 1.133-.343.502-.351.686-.861.185-.518.185-2.522V9.166h2.47V18.5zm7.224 0h-2.47V9.166h2.294v1.327q.589-.94 1.055-1.24a1.97 1.97 0 0 1 1.072-.298q.844 0 1.626.466l-.764 2.153q-.624-.405-1.161-.404a1.36 1.36 0 0 0-.879.29q-.36.281-.57 1.028-.203.747-.203 3.13zm4.078-4.799q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.757q1.117-.607 2.488-.607 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.125-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m8.974-4.667h2.303v1.371q.448-.704 1.213-1.142a3.34 3.34 0 0 1 1.696-.44q1.626 0 2.76 1.274t1.133 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.318-1.054v4.702h-2.47zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.861 0 1.433-.686.57-.694.571-2.267 0-1.468-.589-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.597.695-.598 2.066m10.477-1.661-2.241-.405q.377-1.353 1.301-2.004.922-.65 2.742-.65 1.652 0 2.461.396.809.386 1.133.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.449 1.248H131.7a9 9 0 0 1-.237-.73 4 4 0 0 0-.088-.29 4.5 4.5 0 0 1-1.354.923q-.72.308-1.538.308-1.441 0-2.276-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.054-.95q.687-.333 1.969-.58 1.732-.324 2.4-.606v-.246q0-.712-.352-1.01-.352-.309-1.327-.308-.66 0-1.028.263-.37.255-.598.906m3.305 2.004q-.476.158-1.503.377-1.029.22-1.345.431-.483.344-.483.87 0 .519.386.897.387.378.985.378.668 0 1.274-.44.448-.334.589-.817.096-.316.097-1.204zm-4.369-6.504V5.396h2.119v2.118zm3.78 0V5.396h2.127v2.118zm10.863 8.016 2.461.412q-.474 1.354-1.503 2.066-1.02.703-2.558.703-2.435 0-3.603-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.067-1.318 2.084 0 3.287 1.38 1.204 1.37 1.152 4.21h-6.188q.027 1.098.598 1.714.571.606 1.424.606.58 0 .975-.316.396-.316.598-1.02m.141-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.809 0-1.336.589-.528.588-.519 1.6zm3.603 2.805 2.479-.378q.158.72.641 1.099.484.369 1.354.369.958 0 1.441-.352a.78.78 0 0 0 .325-.659.65.65 0 0 0-.175-.466q-.185-.175-.827-.325-2.987-.659-3.788-1.204-1.107-.756-1.107-2.1 0-1.214.958-2.04t2.971-.826q1.915 0 2.847.624t1.284 1.846l-2.33.43a1.43 1.43 0 0 0-.571-.835q-.413-.29-1.186-.29-.977 0-1.398.273-.28.194-.281.5 0 .265.246.45.334.245 2.303.694 1.977.448 2.76 1.098.773.66.773 1.837 0 1.282-1.072 2.206t-3.173.923q-1.907 0-3.024-.773a3.57 3.57 0 0 1-1.45-2.101m19.029-3.911-2.435.44q-.123-.73-.563-1.1-.43-.368-1.125-.368-.923 0-1.476.641-.545.632-.545 2.127 0 1.661.554 2.347.563.685 1.503.685.702 0 1.151-.395.448-.405.633-1.38l2.426.413q-.378 1.67-1.451 2.522-1.071.853-2.874.853-2.048 0-3.269-1.292-1.213-1.292-1.213-3.577 0-2.312 1.222-3.595 1.221-1.292 3.304-1.292 1.705 0 2.707.738 1.011.73 1.451 2.233m4.341-6.311v4.737q1.195-1.397 2.857-1.397.852 0 1.538.316.686.317 1.028.81.352.49.475 1.089.132.598.132 1.854V18.5h-2.47v-4.93q0-1.469-.141-1.864a1.2 1.2 0 0 0-.501-.624q-.351-.237-.887-.237-.616 0-1.099.299-.483.298-.712.905-.22.597-.22 1.775V18.5h-2.469V5.615zm-94.57 20h2.602v6.979q0 1.66.096 2.153.168.79.791 1.275.633.474 1.723.474 1.107 0 1.67-.448.562-.457.677-1.116.114-.66.114-2.189v-7.128h2.601v6.768q0 2.32-.21 3.278-.212.959-.783 1.617-.563.66-1.512 1.055-.949.387-2.478.387-1.845 0-2.804-.422-.948-.43-1.503-1.108-.553-.685-.73-1.432Q74 34.65 74 32.488zM95.498 38.5h-2.47v-4.764q0-1.512-.158-1.95a1.36 1.36 0 0 0-.518-.695 1.45 1.45 0 0 0-.853-.246 2 2 0 0 0-1.151.351q-.51.352-.704.932-.184.58-.184 2.145V38.5h-2.47v-9.334h2.294v1.371q1.222-1.582 3.076-1.582.817 0 1.495.299.675.29 1.019.747.351.457.483 1.037.141.58.141 1.661zm2.514-10.6v-2.285h2.469V27.9zm0 10.6v-9.334h2.469V38.5zm4.438-4.799q0-1.23.607-2.382a4.16 4.16 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m15.188 4.667v-1.398q-.51.748-1.345 1.178a3.7 3.7 0 0 1-1.749.43 3.4 3.4 0 0 1-1.687-.412 2.44 2.44 0 0 1-1.081-1.16q-.334-.747-.334-2.066v-5.906h2.469v4.29q0 1.968.132 2.416.141.44.501.703.36.255.914.255.633 0 1.134-.343.501-.351.686-.861.184-.518.184-2.523v-3.937h2.47V38.5zm13.351 0h-2.47v-4.764q0-1.512-.158-1.95a1.37 1.37 0 0 0-.519-.695 1.45 1.45 0 0 0-.852-.246q-.642 0-1.152.351-.51.352-.703.932-.185.58-.185 2.145V38.5h-2.469v-9.334h2.294v1.371q1.222-1.582 3.076-1.582.817 0 1.494.299.677.29 1.02.747.351.457.483 1.037.141.58.141 1.661z"
}, null, -1), An1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), Fn1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.686l-.517 1.593h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.985-.517 1.584 1.364-.976 1.365.976-.517-1.584 1.355-.985h-1.632l-.526-1.584zm4.718 6.019-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.331-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.985.517 1.584-1.355-.976-1.365.976.517-1.584-1.346-.985h1.676l.527-1.584zm-4.763 6.019 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), Tn1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), In1 = [
  En1,
  An1,
  Fn1,
  Tn1
];
function On1(t, e) {
  return T(), N("svg", kn1, [...In1]);
}
const Nn1 = { render: On1 }, Pn1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, Bn1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Vn1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Rn1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm9.903 32.866 2.47-.24q.222 1.245.905 1.83.681.585 1.838.584 1.227 0 1.849-.52t.621-1.216q0-.445-.261-.76t-.914-.546q-.445-.156-2.031-.55-2.042-.508-2.865-1.246-1.157-1.04-1.157-2.535 0-.963.544-1.8.544-.84 1.57-1.277 1.024-.438 2.473-.438 2.367 0 3.563 1.04t1.256 2.776l-2.538.111q-.163-.971-.699-1.396-.537-.426-1.607-.426-1.107 0-1.733.456a.92.92 0 0 0-.403.781q0 .448.378.766.48.405 2.332.842 1.85.438 2.74.907.887.468 1.388 1.28.503.812.503 2.006 0 1.084-.601 2.029-.6.946-1.698 1.405t-2.735.46q-2.384 0-3.662-1.105-1.276-1.103-1.526-3.218m19.529 4.099q-.163.12-.296.28-.132.157-.227.339a2 2 0 0 0-.146.365 1.3 1.3 0 0 0-.05.356q-.002.285.15.477.15.195.5.194.155 0 .347-.056.195-.056.365-.107v1.435q-.72.345-1.294.344-.48 0-.832-.129a1.7 1.7 0 0 1-.587-.353 1.4 1.4 0 0 1-.352-.52 1.7 1.7 0 0 1-.116-.63q0-.5.3-1.041t.806-.954zm-2.34-4.382q-.464.155-1.467.368-1.004.216-1.312.422-.471.336-.471.85 0 .508.377.877.377.37.96.37.651 0 1.243-.43.438-.327.575-.8.094-.308.094-1.177zm-3.225-1.96-2.186-.395q.369-1.324 1.269-1.96t2.675-.635q1.612 0 2.4.382.79.383 1.111.971.322.588.322 2.161l-.026 2.82q0 1.2.116 1.773.115.573.433 1.225h-2.384a9 9 0 0 1-.232-.714 5 5 0 0 0-.085-.283 4.4 4.4 0 0 1-1.32.903q-.705.3-1.501.3-1.406 0-2.216-.765t-.81-1.933q-.001-.773.368-1.379t1.033-.928q.665-.323 1.916-.564 1.69-.316 2.341-.593v-.24q0-.696-.343-.993-.343-.296-1.294-.296-.644 0-1.004.253-.36.255-.583.89m8.353-4.023h2.41v-2.234h-2.41zm2.41 1.239v8.843q0 1.743-.227 2.461a2 2 0 0 1-.875 1.122q-.646.404-1.65.404-.361 0-.776-.064a9 9 0 0 1-.896-.194l.42-2.062q.171.034.321.056t.28.021q.367 0 .603-.16a.77.77 0 0 0 .314-.381q.075-.225.076-1.341v-8.705zm8.076 9.126v-1.367a3.5 3.5 0 0 1-1.308 1.152q-.81.421-1.711.421-.917 0-1.645-.404a2.38 2.38 0 0 1-1.056-1.134q-.326-.73-.326-2.02V28.72h2.41v4.194q0 1.925.133 2.358.133.436.484.687.351.255.892.255a1.9 1.9 0 0 0 1.106-.34q.489-.34.669-.842.18-.503.18-2.462v-3.85h2.41v9.126zm12.577 0h-2.409v-4.658q0-1.477-.155-1.912a1.34 1.34 0 0 0-.501-.674 1.43 1.43 0 0 0-.836-.241q-.627 0-1.124.344a1.73 1.73 0 0 0-.681.91q-.185.569-.185 2.098v4.133h-2.409V28.72h2.238v1.34q1.192-1.547 3.001-1.546.797 0 1.458.287.66.288.999.735t.471 1.014q.133.568.133 1.624zm4.022-4.752q0 1.452.562 2.127.561.675 1.385.675.883 0 1.492-.693.609-.69.608-2.05 0-1.417-.583-2.104a1.85 1.85 0 0 0-1.474-.688q-.867 0-1.428.674-.562.675-.562 2.059m-2.152 5.354 2.753.335q.068.481.317.662.344.257 1.08.258.943 0 1.415-.285.318-.189.481-.61.111-.3.111-1.108v-1.332q-1.08 1.478-2.727 1.478-1.835 0-2.906-1.555-.841-1.23-.841-3.06 0-2.294 1.101-3.506 1.103-1.212 2.74-1.212 1.69 0 2.787 1.487v-1.28h2.256v8.19q0 1.616-.266 2.414-.266.8-.747 1.255-.479.456-1.282.713-.802.258-2.027.258-2.316 0-3.284-.795-.969-.795-.969-2.015 0-.12.008-.292m15.799-4.985q-.463.154-1.466.37-1.004.215-1.312.42-.471.336-.472.851 0 .509.378.877.377.37.96.37.651 0 1.243-.43.438-.327.575-.799.094-.31.094-1.177zm-3.224-1.96-2.186-.395q.369-1.321 1.268-1.959.9-.636 2.676-.636 1.612 0 2.4.383.79.381 1.111.97.321.59.321 2.162l-.025 2.819q0 1.203.116 1.775.115.57.433 1.224h-2.384a9 9 0 0 1-.232-.713 4 4 0 0 0-.085-.283 4.4 4.4 0 0 1-1.321.902q-.703.3-1.5.3-1.406 0-2.217-.764-.81-.765-.81-1.934 0-.774.369-1.38a2.4 2.4 0 0 1 1.032-.928q.666-.322 1.917-.562 1.689-.318 2.341-.593v-.241q0-.696-.343-.992t-1.294-.297q-.644 0-1.004.254-.36.253-.583.889M74.66 18.767V6.168h9.321v2.13h-6.782v2.794h6.31v2.123H77.2v3.429h7.023v2.123zm17.444 0V17.4a3.5 3.5 0 0 1-1.308 1.152q-.81.42-1.71.42-.918.001-1.646-.403a2.37 2.37 0 0 1-1.056-1.135q-.325-.73-.325-2.02V9.64h2.409v4.194q0 1.926.133 2.359.132.435.484.687.352.255.892.254.617 0 1.107-.34.487-.338.669-.842.18-.503.18-2.462V9.64h2.41v9.127zm6.776 0h-2.409V9.64h2.239v1.298q.574-.92 1.032-1.212a1.9 1.9 0 0 1 1.042-.292q.824 0 1.587.455l-.746 2.106q-.61-.395-1.132-.396-.506 0-.858.28-.35.28-.553 1.01-.202.73-.201 3.059zm6.177-4.564q0 1.358.643 2.08.644.722 1.586.722t1.583-.722q.638-.722.638-2.097 0-1.34-.638-2.062-.64-.723-1.583-.723-.942 0-1.586.723-.643.722-.643 2.08m-2.47-.13q0-1.202.592-2.328a4.06 4.06 0 0 1 1.677-1.72q1.084-.591 2.422-.592 2.066 0 3.387 1.344 1.321 1.346 1.321 3.4 0 2.07-1.334 3.433t-3.357 1.362q-1.252 0-2.388-.568a3.9 3.9 0 0 1-1.728-1.662q-.591-1.096-.592-2.668m13.302-.026q0 1.538.608 2.273.61.735 1.484.735.84 0 1.398-.675.555-.674.556-2.213.001-1.434-.574-2.131-.574-.697-1.423-.696-.884 0-1.466.683-.583.683-.583 2.024m-2.384-4.41h2.247v1.342q.436-.687 1.182-1.118a3.27 3.27 0 0 1 1.655-.43q1.587.001 2.693 1.247t1.106 3.472q0 2.286-1.114 3.553-1.116 1.268-2.701 1.268-.755 0-1.368-.3-.613-.302-1.291-1.032v4.598h-2.409zm12.532 4.564q0 1.358.642 2.08.644.722 1.587.722.942 0 1.582-.722.639-.722.639-2.097 0-1.34-.639-2.062-.64-.723-1.582-.723t-1.587.723q-.642.722-.642 2.08m-2.47-.13q0-1.202.591-2.328a4.07 4.07 0 0 1 1.678-1.72q1.084-.591 2.421-.592 2.067 0 3.388 1.344 1.32 1.346 1.32 3.4 0 2.07-1.333 3.433-1.335 1.362-3.357 1.362a5.3 5.3 0 0 1-2.389-.568 3.9 3.9 0 0 1-1.728-1.662q-.591-1.096-.591-2.668m10.436 2.088 2.418-.37q.153.705.626 1.07.471.365 1.32.365.936 0 1.406-.344a.76.76 0 0 0 .318-.644.64.64 0 0 0-.172-.456q-.18-.171-.806-.318-2.915-.643-3.696-1.177-1.08-.738-1.08-2.054 0-1.184.934-1.994.936-.807 2.899-.807 1.869 0 2.778.61.91.61 1.252 1.805l-2.272.42q-.145-.532-.554-.816-.406-.283-1.161-.284-.952 0-1.364.267-.274.19-.274.49 0 .258.24.438.326.24 2.251.679 1.926.438 2.688 1.075.755.644.755 1.796 0 1.253-1.047 2.156t-3.095.902q-1.86 0-2.946-.756a3.5 3.5 0 0 1-1.418-2.053",
  "clip-rule": "evenodd"
}, null, -1), Hn1 = [
  Bn1,
  Vn1,
  Rn1
];
function Dn1(t, e) {
  return T(), N("svg", Pn1, [...Hn1]);
}
const $n1 = { render: Dn1 }, Un1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, jn1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Gn1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Wn1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.01 32.866 2.473-.24q.222 1.245.906 1.83.682.584 1.841.584 1.228 0 1.851-.52t.623-1.216q0-.447-.262-.76-.263-.315-.915-.546-.447-.156-2.035-.55-2.044-.508-2.868-1.246-1.16-1.04-1.159-2.535 0-.963.545-1.8.544-.84 1.572-1.277 1.026-.438 2.477-.438 2.37 0 3.568 1.04t1.257 2.776l-2.541.111q-.163-.971-.7-1.396-.537-.426-1.61-.426-1.108 0-1.735.456a.92.92 0 0 0-.403.781q0 .447.378.766.48.404 2.335.842t2.744.906q.888.47 1.39 1.28.504.812.504 2.007 0 1.084-.602 2.029-.601.945-1.7 1.405-1.1.46-2.74.46-2.386 0-3.666-1.105t-1.528-3.218m16.948-.284q-.463.154-1.468.37-1.005.215-1.313.42-.473.336-.473.851 0 .508.378.877.378.37.962.37.652 0 1.245-.43a1.52 1.52 0 0 0 .576-.8q.093-.309.094-1.177zm-3.228-1.96-2.19-.395q.37-1.323 1.27-1.959.903-.636 2.68-.636 1.614 0 2.404.383.79.381 1.112.97.322.59.322 2.162l-.025 2.818q0 1.204.116 1.775.116.572.433 1.224h-2.387a9 9 0 0 1-.232-.712 4 4 0 0 0-.085-.284q-.619.601-1.323.902-.704.3-1.503.301-1.407 0-2.219-.765-.812-.764-.811-1.934 0-.773.369-1.379.368-.605 1.034-.928.666-.322 1.92-.562 1.69-.318 2.344-.594v-.24q0-.696-.344-.992t-1.296-.297q-.644 0-1.005.253-.361.255-.584.89m9.958 6.342-3.676-9.127h2.533l1.718 4.658.498 1.555q.197-.592.249-.781.12-.387.257-.774l1.735-4.658h2.482l-3.624 9.127zm7.008-.001h2.413v-9.126h-2.413zm0-10.363h2.413v-2.235h-2.413zm9.865 5.019q-.027-1.049-.541-1.595a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.305.577-.515.575-.507 1.563zm-.137 2.44 2.404.404q-.463 1.324-1.464 2.015t-2.504.692q-2.377 0-3.52-1.555-.902-1.247-.902-3.146 0-2.268 1.186-3.553 1.184-1.285 2.996-1.285 2.036 0 3.212 1.345t1.125 4.12h-6.045q.026 1.075.584 1.672.557.598 1.391.598.566 0 .953-.31.386-.31.584-.997m12.354 2.905h-2.412v-4.658q0-1.479-.155-1.912a1.35 1.35 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241 1.94 1.94 0 0 0-1.126.344 1.73 1.73 0 0 0-.682.91q-.185.568-.185 2.098v4.133h-2.413v-9.127h2.242v1.34q1.194-1.545 3.005-1.546.798 0 1.46.288t1.001.735q.338.446.472 1.014.132.568.132 1.624zm2.008-.001h2.413v-9.126h-2.413zm-1.588-10.63h5.53v-1.59h-5.53zm8.767 5.87q0 1.418.447 2.097.626.962 1.665.963.799 0 1.361-.684.563-.683.563-2.153 0-1.564-.567-2.256a1.8 1.8 0 0 0-1.451-.692q-.867 0-1.443.675-.575.675-.575 2.05m-2.396 4.76V25.248h2.414v4.537q1.114-1.272 2.644-1.272 1.665 0 2.756 1.208 1.09 1.206 1.091 3.467 0 2.338-1.112 3.6-1.112 1.264-2.701 1.264-.78 0-1.542-.391a3.7 3.7 0 0 1-1.309-1.156v1.34zm15.702-4.382q-.463.154-1.468.37-1.005.215-1.314.42-.472.336-.472.851 0 .508.378.877.379.37.961.37.653 0 1.245-.43.438-.327.576-.8.094-.309.094-1.177zm-3.228-1.96-2.19-.395q.37-1.323 1.271-1.959.902-.636 2.679-.636 1.614 0 2.404.383.79.381 1.112.97.322.59.322 2.162l-.025 2.818q0 1.204.116 1.775.115.572.433 1.224H149.9a9 9 0 0 1-.232-.712 4 4 0 0 0-.086-.284q-.618.601-1.322.902-.705.3-1.503.301-1.407 0-2.219-.765-.812-.764-.812-1.934-.001-.773.37-1.379.369-.605 1.034-.928.666-.322 1.919-.562 1.691-.318 2.344-.594v-.24q0-.696-.343-.992t-1.297-.297q-.644 0-1.005.253-.36.255-.583.89M74.768 18.767V6.169h9.334v2.13H77.31v2.793h6.32v2.123h-6.32v3.43h7.033v2.122zm11.466 0h2.413V9.64h-2.413zm0-10.365h2.413V6.168h-2.413zm7.372 10.365h-2.413V9.64h2.242v1.298q.575-.92 1.034-1.212a1.9 1.9 0 0 1 1.043-.292q.825 0 1.59.455l-.748 2.106q-.61-.396-1.133-.396-.507 0-.86.28-.35.28-.554 1.01-.2.73-.2 3.06zm6.185-4.564q0 1.359.644 2.08.645.722 1.589.722t1.584-.722.64-2.097q0-1.34-.64-2.062t-1.584-.723-1.589.723q-.644.721-.644 2.08m-2.473-.129q0-1.204.593-2.33a4.07 4.07 0 0 1 1.679-1.718q1.087-.593 2.425-.593 2.07 0 3.393 1.345t1.322 3.399q0 2.07-1.336 3.433t-3.361 1.362q-1.255 0-2.392-.568a3.9 3.9 0 0 1-1.73-1.662q-.593-1.095-.593-2.668m13.32-.026q0 1.538.61 2.273t1.486.735q.842 0 1.4-.675t.557-2.213q0-1.435-.575-2.131-.574-.697-1.425-.696-.885 0-1.469.683-.583.683-.584 2.024m-2.387-4.41h2.25v1.342q.438-.687 1.185-1.118a3.26 3.26 0 0 1 1.657-.429q1.588 0 2.697 1.246 1.107 1.245 1.107 3.472 0 2.286-1.116 3.553-1.117 1.268-2.705 1.268-.756 0-1.369-.3-.614-.302-1.293-1.032v4.598h-2.413zm15.667 4.745q-.463.154-1.468.37-1.005.214-1.314.42-.472.336-.472.851 0 .508.378.877.378.37.961.37.653 0 1.245-.43.438-.327.576-.8.094-.309.094-1.177zm-3.229-1.96-2.189-.395q.37-1.323 1.271-1.959t2.679-.636q1.615 0 2.404.383.79.381 1.112.97t.322 2.162l-.026 2.818q0 1.204.117 1.775.115.572.433 1.224h-2.387a9 9 0 0 1-.232-.713 4 4 0 0 0-.086-.283q-.618.6-1.322.902-.705.3-1.503.301-1.408 0-2.219-.765-.812-.764-.812-1.934 0-.773.369-1.379a2.4 2.4 0 0 1 1.034-.928q.667-.322 1.92-.563 1.691-.318 2.344-.593v-.24q0-.697-.344-.993t-1.296-.296q-.644 0-1.005.253-.36.254-.584.89m7.304 3.738 2.421-.37q.155.705.627 1.07t1.323.366q.936 0 1.408-.345a.77.77 0 0 0 .318-.644.64.64 0 0 0-.172-.456q-.18-.171-.808-.317-2.918-.644-3.701-1.178-1.081-.738-1.081-2.054 0-1.185.935-1.994.937-.806 2.903-.807 1.872 0 2.782.61.911.61 1.254 1.805l-2.276.42a1.4 1.4 0 0 0-.554-.816q-.407-.283-1.163-.283-.953 0-1.365.266-.275.19-.275.49 0 .258.24.439.326.24 2.255.678 1.927.438 2.691 1.075.756.644.757 1.796 0 1.254-1.049 2.157-1.048.902-3.099.902-1.865 0-2.95-.756a3.48 3.48 0 0 1-1.421-2.054",
  "clip-rule": "evenodd"
}, null, -1), Yn1 = [
  jn1,
  Gn1,
  Wn1
];
function Xn1(t, e) {
  return T(), N("svg", Un1, [...Yn1]);
}
const Kn1 = { render: Xn1 }, Zn1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, Jn1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Qn1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), ei1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm9.696 36.08V24.64h9.424v2.084h-6.857v2.73h6.38v2.077h-6.38v3.353h7.1v2.076zm13.343 0-2.797-8.8h2.273l1.657 5.767 1.523-5.767h2.258l1.473 5.767 1.69-5.767h2.308l-2.84 8.8h-2.249l-1.523-5.66-1.5 5.66zm14.654 0h-2.512v-9.466h2.334v1.346q.599-.954 1.076-1.257a2 2 0 0 1 1.087-.303q.859 0 1.655.472l-.779 2.184q-.634-.41-1.18-.41-.527 0-.894.29-.366.289-.577 1.047t-.21 3.173zm6.18-4.84q0 1.378.661 2.11.662.733 1.632.733t1.627-.733.657-2.128q0-1.36-.657-2.092-.657-.733-1.627-.733t-1.632.733q-.661.732-.661 2.11m-2.54-.13q0-1.222.608-2.364a4.16 4.16 0 0 1 1.725-1.744q1.115-.602 2.491-.602 2.126 0 3.484 1.364t1.358 3.45q0 2.101-1.372 3.484-1.371 1.382-3.452 1.382a5.5 5.5 0 0 1-2.456-.576 3.98 3.98 0 0 1-1.778-1.687q-.608-1.112-.608-2.707m12.903.047q0 1.586.602 2.343.603.758 1.468.758.832 0 1.383-.696.55-.696.551-2.28 0-1.481-.568-2.198-.568-.718-1.408-.717-.875 0-1.451.704-.576.705-.577 2.086M116 27.492h2.223v1.383a3.4 3.4 0 0 1 1.17-1.152 3.1 3.1 0 0 1 1.637-.443q1.57 0 2.664 1.285t1.094 3.578q0 2.357-1.102 3.663-1.103 1.308-2.672 1.308-.747 0-1.354-.31-.606-.312-1.276-1.064v4.74H116zm15.981 3.834q-.027-1.063-.558-1.618a1.73 1.73 0 0 0-1.293-.554q-.815 0-1.345.585-.532.584-.524 1.587zm-.141 2.476 2.479.41q-.477 1.344-1.51 2.045-1.031.703-2.582.703-2.452 0-3.63-1.579-.93-1.264-.93-3.191 0-2.303 1.222-3.606 1.222-1.304 3.091-1.304 2.1 0 3.312 1.364 1.214 1.365 1.16 4.182h-6.234q.026 1.09.602 1.696.575.607 1.435.607.584 0 .983-.315.398-.313.602-1.012m10.19-1.499q-.477.157-1.508.375-1.032.219-1.348.427-.485.34-.485.864 0 .515.388.889.388.375.987.375.669 0 1.278-.436.448-.33.591-.81.097-.315.097-1.195zm-3.315-1.989-2.247-.4q.378-1.343 1.304-1.988.925-.645 2.75-.646 1.658 0 2.468.389.811.387 1.142.984.33.598.33 2.194l-.026 2.86q0 1.22.119 1.801.119.58.445 1.242h-2.451a10 10 0 0 1-.238-.723 4 4 0 0 0-.087-.288 4.5 4.5 0 0 1-1.358.916 3.9 3.9 0 0 1-1.543.305q-1.445 0-2.278-.776-.834-.777-.833-1.963 0-.785.379-1.4.379-.613 1.062-.941.684-.327 1.97-.57 1.736-.324 2.407-.603v-.244q0-.707-.353-1.007t-1.331-.3q-.66 0-1.032.257-.37.256-.599.901M85.242 5.28h2.448v7.03q0 1.672.091 2.168.157.796.749 1.28.59.482 1.616.482 1.041 0 1.57-.456t.638-1.12.107-2.204V5.28h2.448v6.817q0 2.337-.198 3.302-.2.964-.733 1.629-.532.663-1.425 1.058-.894.394-2.332.394-1.737 0-2.634-.43-.897-.429-1.418-1.116a3.7 3.7 0 0 1-.687-1.437q-.24-1.117-.24-3.294zm20.213 13.2h-2.296v-4.831q0-1.533-.147-1.984a1.4 1.4 0 0 0-.478-.699 1.28 1.28 0 0 0-.797-.25q-.596 0-1.071.357a1.8 1.8 0 0 0-.649.944q-.176.59-.176 2.176v4.287h-2.295V9.014h2.132v1.39q1.135-1.604 2.86-1.604.76 0 1.389.298.629.299.952.763.322.463.449 1.051.126.589.127 1.685zm2.001-10.909h2.393V5.28h-2.393zm2.393 1.27v9.069q0 1.79-.226 2.525a2.04 2.04 0 0 1-.869 1.15q-.642.415-1.639.415-.357 0-.771-.067a8 8 0 0 1-.889-.197l.416-2.116q.17.035.32.057.149.023.277.023.367 0 .6-.164a.78.78 0 0 0 .311-.392q.077-.23.077-1.375V8.841zm4.297 4.799q0 1.378.662 2.11.662.733 1.631.733.97 0 1.628-.733.656-.732.656-2.128 0-1.36-.656-2.092-.658-.733-1.628-.733t-1.631.733q-.662.732-.662 2.11m-2.54-.13q0-1.222.609-2.364a4.15 4.15 0 0 1 1.725-1.744q1.115-.602 2.49-.602 2.127 0 3.484 1.364 1.359 1.365 1.359 3.45 0 2.101-1.372 3.484-1.372 1.382-3.453 1.382a5.5 5.5 0 0 1-2.456-.576 3.98 3.98 0 0 1-1.777-1.687q-.609-1.112-.609-2.707m19.333 4.97h-2.295v-4.831q0-1.533-.148-1.984a1.4 1.4 0 0 0-.477-.699 1.28 1.28 0 0 0-.797-.25q-.597 0-1.071.357a1.8 1.8 0 0 0-.649.944q-.176.59-.176 2.176v4.287h-2.296V9.014h2.133v1.39q1.135-1.604 2.86-1.604.76 0 1.389.298.629.299.952.763.322.463.449 1.051.126.589.126 1.685zm1.758-.88h2.636V8.676h-2.636zm0-10.135h2.636V5.28h-2.636zM73.818 5.28V17.6h2.495V5.28zm4.767 6.673v2.361h4.9v-2.361z",
  "clip-rule": "evenodd"
}, null, -1), ti1 = [
  Jn1,
  Qn1,
  ei1
];
function ni1(t, e) {
  return T(), N("svg", Zn1, [...ti1]);
}
const ii1 = { render: ni1 }, si1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, li1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), ri1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), ai1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.636 24.367H77.3v6.823q0 1.624.094 2.105.163.774.778 1.242.613.47 1.678.469 1.081 0 1.63-.443.551-.443.662-1.087.113-.645.112-2.14v-6.97h2.542v6.618q0 2.269-.206 3.205-.206.938-.76 1.581-.554.645-1.481 1.027-.927.383-2.422.383-1.803 0-2.734-.417-.932-.417-1.473-1.083a3.5 3.5 0 0 1-.713-1.396q-.249-1.083-.25-3.197zm20.468 12.598h-2.413v-4.658q0-1.478-.155-1.912a1.34 1.34 0 0 0-.501-.674 1.43 1.43 0 0 0-.838-.241q-.626 0-1.126.344-.497.343-.681.91-.186.568-.186 2.098v4.133h-2.412v-9.127h2.24v1.34q1.197-1.545 3.006-1.546.799 0 1.46.288.662.288 1.002.735.337.446.472 1.014.131.568.132 1.624zm2.007 0h2.413V28.72h-2.413zm0-10.364h2.413v-2.235h-2.413zm10.04 5.019q-.026-1.049-.541-1.595a1.66 1.66 0 0 0-1.253-.546q-.79 0-1.305.577-.515.575-.508 1.564zm-.137 2.44 2.404.404q-.464 1.324-1.463 2.015t-2.504.692q-2.377 0-3.52-1.555-.903-1.247-.902-3.145 0-2.27 1.185-3.554 1.185-1.285 2.997-1.285 2.035 0 3.211 1.345 1.177 1.345 1.125 4.121h-6.045q.026 1.074.584 1.671.558.598 1.391.598.566 0 .953-.31t.584-.997M74.768 18.767V6.169h9.334v2.13H77.31v2.793h6.32v2.123h-6.32v3.43h7.033v2.122zm17.469 0V17.4a3.5 3.5 0 0 1-1.31 1.152q-.81.42-1.713.42-.919.001-1.648-.403a2.38 2.38 0 0 1-1.057-1.135q-.326-.73-.326-2.02V9.64h2.412v4.194q0 1.925.134 2.359.132.435.485.687.351.254.893.254.618 0 1.108-.34.49-.339.67-.841.18-.504.18-2.463V9.64h2.413v9.127zm6.786 0H96.61V9.64h2.242v1.298q.574-.92 1.033-1.211a1.9 1.9 0 0 1 1.044-.293q.825 0 1.589.455l-.747 2.106q-.61-.396-1.134-.396-.506 0-.859.28-.35.28-.554 1.01-.201.73-.201 3.06zm6.185-4.563q0 1.358.644 2.079t1.589.722 1.584-.722q.64-.721.64-2.097 0-1.34-.64-2.062t-1.584-.722-1.589.722-.644 2.08m-2.473-.129q0-1.203.592-2.33a4.07 4.07 0 0 1 1.68-1.718q1.087-.593 2.425-.593 2.07 0 3.392 1.345t1.323 3.399q0 2.07-1.336 3.433t-3.361 1.362q-1.255 0-2.392-.567a3.9 3.9 0 0 1-1.731-1.663q-.592-1.095-.592-2.668m13.32-.026q0 1.538.61 2.273t1.486.735q.842 0 1.4-.675.557-.674.557-2.213 0-1.435-.575-2.131-.575-.697-1.425-.696-.885 0-1.469.683-.583.684-.584 2.024m-2.387-4.409h2.25v1.341q.438-.687 1.185-1.117a3.26 3.26 0 0 1 1.657-.43q1.588 0 2.697 1.246 1.107 1.245 1.107 3.472 0 2.286-1.116 3.553-1.117 1.268-2.705 1.268-.755 0-1.37-.3-.613-.302-1.292-1.032v4.598h-2.413zm16.054 3.782q-.027-1.049-.541-1.595a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.305.577-.516.574-.507 1.563zm-.138 2.44 2.404.404q-.462 1.324-1.464 2.015-1 .692-2.503.692-2.377 0-3.52-1.555-.902-1.247-.902-3.146 0-2.269 1.185-3.553t2.997-1.285q2.036 0 3.211 1.345 1.177 1.345 1.126 4.12h-6.046q.026 1.075.584 1.672.558.598 1.391.598.567 0 .953-.31.387-.31.584-.997m3.65.301 2.421-.37q.155.705.627 1.07t1.323.366q.936 0 1.407-.344a.77.77 0 0 0 .319-.645.63.63 0 0 0-.173-.455q-.179-.172-.807-.318-2.92-.645-3.701-1.178-1.081-.738-1.081-2.054 0-1.185.935-1.994.937-.806 2.903-.807 1.872 0 2.782.61t1.254 1.805l-2.276.42a1.4 1.4 0 0 0-.554-.816q-.407-.282-1.163-.283-.953 0-1.366.266a.57.57 0 0 0-.274.49q0 .258.24.439.326.24 2.255.678t2.691 1.075q.756.645.756 1.796 0 1.254-1.048 2.157-1.048.902-3.099.902-1.865 0-2.95-.756a3.48 3.48 0 0 1-1.421-2.054m15.785-2.741q-.026-1.049-.541-1.595a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.304.577-.516.574-.508 1.563zm-.137 2.44 2.404.404q-.464 1.324-1.464 2.015t-2.503.692q-2.379 0-3.52-1.555-.903-1.247-.903-3.146 0-2.269 1.186-3.553 1.184-1.284 2.996-1.285 2.036 0 3.212 1.345t1.125 4.12h-6.045q.026 1.075.584 1.672.558.598 1.391.598.566 0 .953-.31t.584-.997",
  "clip-rule": "evenodd"
}, null, -1), oi1 = [
  li1,
  ri1,
  ai1
];
function ci1(t, e) {
  return T(), N("svg", si1, [...oi1]);
}
const hi1 = { render: ci1 }, ui1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, di1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), fi1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), vi1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), pi1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "m82.697 16.03 2.461.412q-.474 1.354-1.503 2.066-1.02.703-2.557.703-2.435 0-3.604-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.068-1.318 2.082 0 3.287 1.38 1.203 1.37 1.151 4.21h-6.187q.025 1.098.597 1.714.572.606 1.424.606.58 0 .976-.316.395-.316.597-1.02m.14-2.497q-.025-1.073-.553-1.626a1.7 1.7 0 0 0-1.283-.562q-.809 0-1.336.589-.527.588-.519 1.6zM93.455 19v-1.398q-.51.748-1.345 1.178-.825.43-1.749.43a3.43 3.43 0 0 1-1.687-.412 2.44 2.44 0 0 1-1.081-1.16q-.334-.747-.334-2.066V9.666h2.47v4.29q0 1.968.131 2.416.141.44.501.703.36.255.914.255.633 0 1.134-.343.501-.351.686-.861.184-.519.184-2.523V9.667h2.47V19zm7.225 0h-2.47V9.666h2.294v1.327q.588-.94 1.055-1.24.474-.297 1.072-.298.843 0 1.626.466l-.765 2.153q-.624-.405-1.16-.404-.519 0-.879.29-.36.281-.571 1.028-.202.747-.202 3.13zm4.078-4.799q0-1.23.606-2.382a4.2 4.2 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.12 0 3.472 1.38 1.353 1.37 1.354 3.472 0 2.118-1.371 3.515-1.363 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.767-1.696q-.606-1.125-.606-2.734m2.531.132q0 1.389.659 2.127.66.738 1.626.738.967 0 1.617-.738.66-.738.66-2.145 0-1.371-.66-2.109-.65-.738-1.617-.738-.966 0-1.626.738t-.659 2.127m8.974-4.667h2.302v1.371q.449-.704 1.213-1.142a3.35 3.35 0 0 1 1.697-.44q1.626 0 2.759 1.274t1.134 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.319-1.054v4.702h-2.469zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.86 0 1.432-.686.571-.694.571-2.267 0-1.468-.588-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066m14.036 1.855 2.461.412q-.474 1.354-1.503 2.066-1.019.703-2.557.703-2.435 0-3.604-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.067-1.318 2.084 0 3.288 1.38 1.203 1.37 1.151 4.21h-6.188q.027 1.098.598 1.714.572.606 1.424.606.58 0 .976-.316.395-.316.597-1.02m.141-2.497q-.027-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.808 0-1.336.589-.527.588-.519 1.6zm4.473-5.132V6.115h2.47V8.4zm0 10.6V9.666h2.47V19zm4.14-2.663 2.479-.378q.158.72.641 1.099.484.369 1.354.369.958 0 1.441-.352a.78.78 0 0 0 .325-.659.65.65 0 0 0-.175-.466q-.185-.175-.827-.325-2.988-.659-3.788-1.204-1.107-.756-1.107-2.1 0-1.214.958-2.04.958-.825 2.971-.826 1.915 0 2.847.624t1.283 1.846l-2.329.43a1.43 1.43 0 0 0-.571-.835q-.413-.29-1.186-.29-.976 0-1.398.273-.28.194-.281.5 0 .265.246.45.334.245 2.303.694 1.977.448 2.759 1.098.774.66.774 1.837 0 1.282-1.072 2.206t-3.173.923q-1.908 0-3.024-.773a3.57 3.57 0 0 1-1.45-2.101M152.298 19V6.115h2.47v6.838l2.891-3.287h3.041l-3.19 3.41L160.929 19h-2.663l-2.347-4.192-1.151 1.204V19zm15.513-2.97 2.46.412q-.474 1.354-1.502 2.066-1.02.703-2.558.703-2.434 0-3.604-1.59-.922-1.275-.922-3.218 0-2.32 1.212-3.63 1.214-1.318 3.068-1.318 2.083 0 3.287 1.38 1.204 1.37 1.151 4.21h-6.187q.026 1.098.597 1.714.572.606 1.424.606.58 0 .976-.316t.598-1.02m.14-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.808 0-1.336.589-.527.588-.518 1.6zM83.436 38v-1.398q-.51.748-1.345 1.178-.826.43-1.75.43-.94 0-1.687-.412a2.44 2.44 0 0 1-1.08-1.16q-.335-.747-.335-2.066v-5.906h2.47v4.29q0 1.968.132 2.416.14.44.5.703.362.255.915.255.633 0 1.134-.343.5-.351.685-.861.185-.518.185-2.523v-3.937h2.47V38zm13.35 0h-2.47v-4.764q0-1.512-.158-1.95a1.36 1.36 0 0 0-.518-.695 1.45 1.45 0 0 0-.853-.246 2 2 0 0 0-1.151.351q-.51.352-.703.932-.185.58-.185 2.145V38h-2.47v-9.334h2.294v1.371q1.222-1.582 3.076-1.582.817 0 1.495.299.675.29 1.02.747.351.457.483 1.037.14.58.14 1.661zM99.3 27.4v-2.285h2.47V27.4zm0 10.6v-9.334h2.47V38zm4.438-4.799q0-1.23.607-2.382a4.16 4.16 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.118 0 3.472 1.38 1.353 1.37 1.353 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.532.132q0 1.389.659 2.127t1.626.738q.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.659 2.127M123.804 38h-2.47v-4.764q0-1.512-.158-1.95a1.37 1.37 0 0 0-.519-.695q-.351-.246-.852-.246-.642 0-1.152.351-.51.352-.703.932-.184.58-.184 2.145V38h-2.47v-9.334h2.294v1.371q1.221-1.582 3.076-1.582.817 0 1.494.299.676.29 1.02.747.351.457.483 1.037.141.58.141 1.661z"
}, null, -1), mi1 = [
  di1,
  fi1,
  vi1,
  pi1
];
function gi1(t, e) {
  return T(), N("svg", ui1, [...mi1]);
}
const yi1 = { render: gi1 }, _i1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, qi1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), wi1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), zi1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.622 36.965V25.247h9.33v2.13h-6.789v2.793h6.317v2.123h-6.317v3.43h7.03v2.122zm17.462 0v-1.367a3.5 3.5 0 0 1-1.309 1.152q-.81.42-1.713.42-.918.001-1.647-.403a2.38 2.38 0 0 1-1.057-1.134q-.326-.73-.326-2.02v-5.775h2.412v4.194q0 1.926.134 2.359.132.435.484.687.352.255.893.254.618 0 1.107-.34.49-.339.67-.841.18-.504.18-2.463v-3.85h2.412v9.127zm6.784 0h-2.413v-9.127h2.24v1.298q.576-.92 1.035-1.211a1.9 1.9 0 0 1 1.043-.293q.824 0 1.588.455l-.747 2.106q-.61-.396-1.133-.396-.507 0-.859.28-.35.28-.553 1.01-.202.73-.202 3.06zm6.182-4.563q0 1.358.643 2.079.645.722 1.588.722t1.584-.722q.64-.721.639-2.097 0-1.34-.639-2.062-.64-.722-1.584-.722-.943 0-1.588.722-.643.721-.643 2.08m-2.473-.129q0-1.204.593-2.33a4.06 4.06 0 0 1 1.679-1.718q1.085-.593 2.424-.593 2.069 0 3.391 1.345t1.322 3.399q0 2.07-1.336 3.433-1.335 1.362-3.36 1.362a5.3 5.3 0 0 1-2.39-.568 3.9 3.9 0 0 1-1.73-1.662q-.593-1.095-.593-2.668m13.316-.026q0 1.539.609 2.273t1.485.735q.842 0 1.399-.675t.558-2.212q0-1.436-.575-2.132-.574-.697-1.425-.696a1.85 1.85 0 0 0-1.468.683q-.582.683-.583 2.024m-2.387-4.409h2.249v1.341q.438-.687 1.184-1.117a3.26 3.26 0 0 1 1.657-.43q1.588 0 2.696 1.246 1.106 1.246 1.106 3.472 0 2.287-1.115 3.553-1.116 1.268-2.704 1.268-.755 0-1.369-.3-.614-.302-1.292-1.032v4.598h-2.412zm16.047 3.782q-.027-1.049-.541-1.595a1.66 1.66 0 0 0-1.253-.546q-.79 0-1.304.577-.516.575-.507 1.563zm-.137 2.44 2.403.404q-.463 1.324-1.463 2.015t-2.503.692q-2.377 0-3.518-1.555-.902-1.247-.902-3.146 0-2.268 1.185-3.553 1.184-1.285 2.995-1.285 2.035 0 3.21 1.345 1.176 1.345 1.125 4.12h-6.043q.026 1.075.584 1.672.557.598 1.391.598.566 0 .952-.31.387-.31.584-.997m4.446-7.46h2.412v-2.234h-2.412zm2.412 1.238v8.843q0 1.745-.228 2.462a2 2 0 0 1-.875 1.121q-.648.405-1.653.404-.36.001-.777-.064a9 9 0 0 1-.896-.193l.42-2.062q.171.034.323.055a2 2 0 0 0 .278.022q.37 0 .606-.16a.78.78 0 0 0 .313-.382q.077-.224.077-1.34v-8.706zm1.674 6.522 2.42-.369q.154.705.627 1.07.472.366 1.322.366.935 0 1.407-.345a.77.77 0 0 0 .318-.644.64.64 0 0 0-.172-.456q-.179-.171-.807-.317-2.918-.645-3.699-1.178-1.081-.739-1.081-2.053 0-1.186.935-1.995.936-.806 2.901-.807 1.871 0 2.781.61t1.254 1.805l-2.275.42q-.145-.532-.554-.816-.407-.282-1.163-.283-.952 0-1.365.266-.274.19-.274.49 0 .258.24.439.326.24 2.254.678t2.69 1.075q.756.645.756 1.796 0 1.254-1.048 2.157-1.047.902-3.098.902-1.864 0-2.949-.756a3.5 3.5 0 0 1-1.42-2.054m10.188 2.604V25.247h2.412v6.685l2.824-3.214h2.97l-3.116 3.335 3.339 5.792h-2.6l-2.293-4.1-1.124 1.178v2.922zm14.893-4.383q-.464.154-1.468.37-1.005.215-1.313.42-.472.336-.472.851 0 .508.378.877.377.37.96.37.652 0 1.245-.43.437-.327.576-.8.094-.309.094-1.177zm-3.228-1.96-2.188-.395q.369-1.323 1.27-1.959t2.678-.636q1.614 0 2.403.383.79.381 1.112.97.321.59.321 2.162l-.025 2.818q0 1.204.116 1.775.115.572.433 1.224h-2.386a9 9 0 0 1-.232-.712 5 5 0 0 0-.085-.284q-.619.601-1.322.902-.705.3-1.502.301-1.407 0-2.219-.765-.811-.764-.811-1.934 0-.773.369-1.379.369-.605 1.034-.928.666-.322 1.918-.562 1.691-.318 2.344-.594v-.24q0-.696-.344-.992t-1.296-.297q-.643 0-1.004.253-.36.255-.584.89M74.72 6.168h2.541v6.824q0 1.623.094 2.105.164.773.777 1.242.614.47 1.678.469 1.081 0 1.63-.443.55-.443.662-1.087.111-.645.111-2.14v-6.97h2.541v6.618q0 2.268-.205 3.205-.208.938-.76 1.581-.555.645-1.48 1.027-.928.383-2.421.383-1.803 0-2.734-.417t-1.472-1.083-.713-1.396q-.248-1.084-.249-3.197zm20.46 12.599h-2.412v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.501-.674 1.43 1.43 0 0 0-.837-.242q-.628 0-1.125.345a1.73 1.73 0 0 0-.682.91q-.185.568-.185 2.097v4.134h-2.412V9.64h2.24v1.34q1.194-1.545 3.005-1.546.798 0 1.459.288.66.288 1 .735.338.446.472 1.014.132.568.133 1.624zm2.007 0h2.412V9.64h-2.412zm0-10.365h2.412V6.168h-2.412zm9.649 5.982q-.463.154-1.468.37-1.004.214-1.313.42-.471.336-.472.851 0 .508.378.877.378.37.961.37.653 0 1.244-.43.438-.326.576-.8.094-.309.094-1.177zm-3.227-1.96-2.189-.395q.37-1.323 1.27-1.959.902-.636 2.678-.636 1.615 0 2.403.383.79.381 1.112.97t.322 2.162l-.026 2.818q0 1.204.116 1.775.117.572.434 1.224h-2.387a10 10 0 0 1-.232-.712 4 4 0 0 0-.085-.284 4.4 4.4 0 0 1-1.322.902q-.704.3-1.502.301-1.407 0-2.218-.765-.812-.764-.812-1.934 0-.773.37-1.379a2.4 2.4 0 0 1 1.033-.928q.666-.322 1.919-.563 1.69-.318 2.343-.593v-.24q0-.697-.343-.993t-1.296-.296q-.644 0-1.005.253-.36.254-.583.89",
  "clip-rule": "evenodd"
}, null, -1), Mi1 = [
  qi1,
  wi1,
  zi1
];
function bi1(t, e) {
  return T(), N("svg", _i1, [...Mi1]);
}
const Li1 = { render: bi1 }, xi1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, Si1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Ci1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), ki1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm10.793 36.965V25.247h9.352v2.13h-6.805v2.794h6.332v2.122h-6.332v3.43h7.046v2.122zm17.501 0v-1.367q-.499.731-1.311 1.152-.814.42-1.718.42-.919.001-1.65-.403a2.4 2.4 0 0 1-1.06-1.134q-.326-.73-.327-2.02v-5.775h2.418v4.195q0 1.925.135 2.358.132.436.484.687.354.255.895.255.62 0 1.11-.34t.671-.842q.18-.503.18-2.462v-3.85h2.418v9.126zm6.8 0h-2.418v-9.126h2.246v1.297q.576-.92 1.035-1.211a1.9 1.9 0 0 1 1.046-.292q.826 0 1.592.455l-.748 2.105q-.612-.396-1.136-.396a1.34 1.34 0 0 0-.86.28q-.353.28-.556 1.01-.202.73-.201 3.06zm6.195-4.563q0 1.357.645 2.08.647.721 1.592.722.947 0 1.589-.723.639-.721.639-2.097 0-1.34-.639-2.062-.642-.722-1.589-.722-.945 0-1.592.722-.645.722-.645 2.08m-2.478-.129q0-1.203.594-2.33a4.1 4.1 0 0 1 1.683-1.718q1.088-.593 2.429-.593 2.075 0 3.399 1.345 1.326 1.345 1.325 3.4 0 2.07-1.337 3.432-1.34 1.362-3.369 1.362-1.256 0-2.395-.567a3.9 3.9 0 0 1-1.735-1.663q-.593-1.096-.594-2.668m13.346-.026q0 1.539.61 2.273.612.735 1.489.735.844 0 1.403-.675.558-.675.558-2.212.001-1.436-.576-2.132-.575-.697-1.428-.696-.886 0-1.471.683-.584.684-.585 2.024m-2.392-4.409h2.254v1.341q.439-.687 1.187-1.117.75-.43 1.661-.43 1.592 0 2.702 1.246t1.109 3.472q0 2.287-1.118 3.553-1.119 1.268-2.71 1.268-.757 0-1.372-.3-.615-.302-1.296-1.032v4.598h-2.417zm16.084 3.782q-.026-1.048-.541-1.595a1.67 1.67 0 0 0-1.257-.545q-.791 0-1.307.576t-.508 1.564zm-.137 2.44 2.409.404q-.465 1.325-1.468 2.015-1.002.692-2.507.693-2.385-.001-3.527-1.556-.903-1.245-.904-3.145 0-2.269 1.188-3.554 1.186-1.285 3.002-1.285 2.04 0 3.217 1.345t1.128 4.121h-6.056q.024 1.074.584 1.671.558.598 1.394.598.567 0 .955-.31.386-.31.585-.997m4.42 2.905h2.417V28.72h-2.417zm0-10.364h2.417v-2.235h-2.417zm9.847 5.981q-.465.154-1.471.37-1.007.215-1.316.42-.473.336-.473.851 0 .509.378.877.38.37.963.37.655 0 1.248-.43a1.52 1.52 0 0 0 .577-.799q.094-.31.094-1.178zm-3.235-1.96-2.193-.395q.37-1.321 1.273-1.959.903-.636 2.684-.636 1.619 0 2.408.383.793.382 1.116.97.322.59.321 2.162l-.025 2.819q0 1.203.117 1.775.116.57.433 1.224h-2.391a10 10 0 0 1-.233-.713 4 4 0 0 0-.086-.284q-.619.601-1.324.902t-1.506.301q-1.41 0-2.223-.764-.814-.765-.814-1.935 0-.773.37-1.378a2.4 2.4 0 0 1 1.037-.929q.667-.322 1.922-.562 1.696-.318 2.349-.593v-.242q0-.695-.344-.991t-1.299-.297q-.645 0-1.007.254-.36.253-.585.888M74.89 6.168h2.547v6.824q0 1.624.094 2.105.164.774.78 1.243.615.468 1.681.468 1.083 0 1.634-.443t.663-1.087.111-2.14v-6.97h2.547v6.618q0 2.268-.206 3.205-.207.938-.762 1.581-.555.645-1.483 1.027-.93.384-2.426.383-1.807 0-2.74-.417t-1.476-1.083-.714-1.396q-.25-1.083-.25-3.197zm20.507 12.599h-2.418v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.503-.674 1.44 1.44 0 0 0-.838-.241q-.63 0-1.128.344-.499.343-.684.91-.185.568-.185 2.098v4.133H87.07V9.64h2.245v1.34q1.196-1.546 3.012-1.546.8 0 1.462.288t1.002.735q.34.445.474 1.014.133.568.133 1.624zm2.011 0h2.417V9.64h-2.417zm0-10.364h2.417V6.17h-2.417zm9.496 5.981q-.465.154-1.471.37-1.007.215-1.316.42-.474.336-.473.851 0 .508.378.877.379.37.963.37.654 0 1.248-.43.438-.326.577-.8.093-.309.094-1.177zm-3.252-5.973h-1.101a7 7 0 0 1-.009-.31q0-.9.439-1.387a1.46 1.46 0 0 1 1.127-.486q.302 0 .559.065.259.065.942.37.684.304 1.071.304a.65.65 0 0 0 .461-.171q.184-.172.236-.576h1.119q-.009 1.16-.435 1.658-.426.5-1.097.5-.292 0-.576-.062a14 14 0 0 1-.989-.352q-.791-.3-1.154-.3a.56.56 0 0 0-.43.168q-.154.166-.163.58m.017 4.013-2.193-.395q.37-1.323 1.273-1.959t2.684-.636q1.618 0 2.408.383.792.381 1.115.97.322.59.322 2.162l-.025 2.818q0 1.204.116 1.775.116.572.434 1.224h-2.392a9 9 0 0 1-.232-.712 4 4 0 0 0-.086-.284q-.62.601-1.324.902-.707.3-1.506.301-1.41 0-2.224-.764-.813-.765-.813-1.935 0-.773.37-1.379a2.4 2.4 0 0 1 1.036-.928q.668-.322 1.923-.562 1.695-.318 2.349-.593v-.242q0-.695-.344-.991t-1.299-.297q-.645 0-1.007.254-.36.253-.585.888m9.646 1.779q0 1.358.645 2.079.646.722 1.592.723.946 0 1.587-.723.641-.721.641-2.097 0-1.34-.641-2.062t-1.587-.722-1.592.722q-.645.721-.645 2.08m-2.478-.129q0-1.203.594-2.33a4.07 4.07 0 0 1 1.682-1.718q1.088-.593 2.43-.593 2.074 0 3.399 1.345t1.325 3.399q0 2.07-1.339 3.433t-3.367 1.362q-1.256 0-2.397-.567a3.9 3.9 0 0 1-1.733-1.663q-.594-1.095-.594-2.668",
  "clip-rule": "evenodd"
}, null, -1), Ei1 = [
  Si1,
  Ci1,
  ki1
];
function Ai1(t, e) {
  return T(), N("svg", xi1, [...Ei1]);
}
const Fi1 = { render: Ai1 }, Ti1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, Ii1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Oi1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Ni1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zM74.98 37.845V25.247h9.36v2.13h-6.81v2.793h6.337v2.123H77.53v3.43h7.052v2.122zm17.517 0v-1.367a3.5 3.5 0 0 1-1.313 1.152q-.813.42-1.718.42-.921.001-1.653-.403a2.38 2.38 0 0 1-1.06-1.134q-.326-.73-.327-2.02v-5.775h2.42v4.194q0 1.926.134 2.359.133.435.486.687.353.255.896.254.62 0 1.11-.34.492-.339.672-.841.18-.504.181-2.463v-3.85h2.42v9.127zm6.805 0h-2.42v-9.127h2.248v1.298q.577-.92 1.037-1.211a1.9 1.9 0 0 1 1.047-.293q.826 0 1.593.455l-.75 2.106q-.61-.396-1.136-.396-.508 0-.862.28-.352.28-.555 1.01-.202.73-.202 3.06zm6.202-4.563q0 1.358.646 2.079t1.593.723q.946 0 1.589-.723.64-.721.641-2.097 0-1.34-.641-2.062-.643-.722-1.589-.722-.947 0-1.593.722-.646.721-.646 2.08m-2.48-.129q0-1.203.594-2.33a4.1 4.1 0 0 1 1.684-1.718q1.09-.593 2.432-.593 2.075 0 3.402 1.345t1.326 3.4q0 2.07-1.34 3.432t-3.37 1.362q-1.258 0-2.399-.567a3.9 3.9 0 0 1-1.735-1.663q-.594-1.095-.594-2.668m13.357-.026q0 1.539.611 2.273t1.49.735q.844 0 1.404-.675t.559-2.212q0-1.436-.577-2.132-.576-.697-1.429-.696-.888 0-1.473.683-.584.683-.585 2.024m-2.394-4.409h2.256v1.341q.44-.687 1.188-1.117.75-.43 1.662-.43 1.593 0 2.704 1.246 1.11 1.246 1.11 3.472 0 2.287-1.118 3.553-1.12 1.268-2.713 1.268-.758 0-1.373-.3-.616-.302-1.296-1.032v4.598h-2.42zm16.098 3.782q-.027-1.049-.543-1.595a1.67 1.67 0 0 0-1.257-.546 1.68 1.68 0 0 0-1.308.577q-.517.575-.509 1.563zm-.138 2.44 2.411.404q-.465 1.324-1.468 2.015t-2.511.692q-2.383 0-3.529-1.555-.905-1.247-.905-3.146 0-2.268 1.189-3.553 1.188-1.285 3.005-1.285 2.04 0 3.22 1.345t1.128 4.12h-6.061q.025 1.075.585 1.672.56.598 1.395.598.567 0 .956-.31.387-.31.585-.997m9.558-1.478q-.466.154-1.473.37-1.008.215-1.317.42-.474.336-.474.851 0 .509.379.877.38.37.964.37.655 0 1.249-.43a1.52 1.52 0 0 0 .577-.8q.095-.308.095-1.177zm-3.238-1.96-2.196-.395q.37-1.322 1.275-1.959.904-.636 2.686-.636 1.619 0 2.411.383.792.382 1.115.97.323.59.323 2.162l-.026 2.818q0 1.204.117 1.775.116.572.434 1.224h-2.394a9 9 0 0 1-.232-.712 4 4 0 0 0-.086-.284q-.62.601-1.326.902t-1.507.301q-1.412 0-2.225-.764-.814-.765-.814-1.935-.001-.773.37-1.379a2.4 2.4 0 0 1 1.037-.928q.668-.322 1.925-.562 1.695-.318 2.351-.593v-.242q0-.695-.345-.991-.344-.297-1.3-.297-.646 0-1.008.253-.36.255-.585.89m16.211 6.342h-2.419v-4.658q0-1.479-.156-1.912a1.34 1.34 0 0 0-.503-.674 1.44 1.44 0 0 0-.839-.241q-.63 0-1.129.344a1.73 1.73 0 0 0-.684.91q-.185.568-.185 2.098v4.133h-2.42v-9.127h2.248v1.34q1.197-1.545 3.013-1.546.801 0 1.464.288t1.003.735.474 1.014q.132.568.133 1.624zm7.059-4.383q-.465.154-1.472.37-1.008.215-1.318.42-.473.336-.473.851 0 .509.379.877.379.37.964.37.654 0 1.248-.43.439-.327.578-.8.094-.308.094-1.177zm.086-8.43h1.18q-.103 1.168-.822 1.834-.72.666-1.864.667-1.147 0-1.865-.667-.72-.666-.822-1.834h1.18q.06.609.43.924.37.314 1.077.313.705 0 1.075-.313.371-.315.431-.924m-3.324 6.47-2.195-.395q.37-1.322 1.274-1.959.904-.636 2.687-.636 1.619 0 2.41.383.792.382 1.116.97.322.59.322 2.162l-.025 2.818q0 1.204.116 1.775.116.572.435 1.224h-2.394a9 9 0 0 1-.233-.712 5 5 0 0 0-.085-.284q-.621.601-1.326.902-.707.301-1.507.301-1.412 0-2.226-.764-.814-.765-.814-1.935 0-.773.371-1.379a2.4 2.4 0 0 1 1.037-.928q.668-.322 1.924-.562 1.697-.318 2.351-.593v-.242q0-.695-.345-.991-.344-.297-1.299-.297-.647 0-1.008.253-.362.255-.586.89M74.956 6.168h2.549v6.824q0 1.623.094 2.105.164.773.78 1.242.614.47 1.683.469 1.084 0 1.635-.443t.663-1.087.112-2.14v-6.97h2.55v6.618q0 2.268-.207 3.205t-.763 1.581q-.555.645-1.484 1.027-.93.383-2.429.383-1.808 0-2.742-.417t-1.477-1.083-.715-1.396q-.249-1.084-.25-3.197zM95.48 18.767h-2.42v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.503-.674 1.44 1.44 0 0 0-.84-.242q-.63 0-1.128.345-.5.343-.684.91-.186.568-.186 2.097v4.134h-2.42V9.64h2.248v1.34q1.197-1.545 3.014-1.546.801 0 1.464.288t1.003.735.474 1.014q.132.568.133 1.624zm2.013 0h2.42V9.64h-2.42zm0-10.365h2.42V6.168h-2.42zm10.477 10.365V17.4q-.499.73-1.313 1.152-.813.42-1.718.42-.921.001-1.653-.403a2.38 2.38 0 0 1-1.059-1.135q-.327-.73-.327-2.02V9.64h2.419v4.194q0 1.925.134 2.359.133.435.486.687.353.254.896.254.62 0 1.111-.34.49-.339.671-.841.18-.504.181-2.463V9.64h2.42v9.127zm12.806 0h-2.42v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.503-.674 1.44 1.44 0 0 0-.84-.242q-.629 0-1.128.345a1.72 1.72 0 0 0-.684.91q-.186.568-.186 2.097v4.134h-2.419V9.64h2.247v1.34q1.197-1.545 3.014-1.546.801 0 1.464.288t1.003.735.474 1.014q.132.568.133 1.624zm7.887-5.346q-.026-1.048-.542-1.594a1.67 1.67 0 0 0-1.257-.546q-.793 0-1.309.577-.517.575-.509 1.563zm-.137 2.44 2.41.405q-.464 1.324-1.468 2.015-1.003.691-2.51.692-2.385 0-3.53-1.555-.904-1.247-.904-3.146 0-2.269 1.188-3.553 1.188-1.285 3.005-1.285 2.042 0 3.22 1.345 1.18 1.345 1.129 4.12h-6.062q.025 1.075.585 1.672.56.598 1.395.597.569.001.956-.31.387-.308.586-.996m9.557-1.478q-.465.154-1.472.37-1.008.215-1.318.42-.473.336-.473.851 0 .508.379.877.379.37.964.37.654 0 1.248-.43.439-.327.578-.8.094-.309.094-1.177zm-3.238-1.96-2.195-.395q.37-1.323 1.274-1.959t2.687-.636q1.619 0 2.41.383.792.381 1.116.97.322.59.322 2.162l-.025 2.818q0 1.204.116 1.775.116.572.435 1.224h-2.394a9 9 0 0 1-.233-.712 5 5 0 0 0-.085-.284q-.621.601-1.326.902-.707.3-1.507.301-1.412 0-2.226-.765t-.814-1.934q0-.774.371-1.379a2.4 2.4 0 0 1 1.037-.928q.668-.322 1.924-.562 1.697-.319 2.351-.594v-.24q0-.696-.345-.992-.344-.298-1.299-.297-.647 0-1.008.253-.362.255-.586.89",
  "clip-rule": "evenodd"
}, null, -1), Pi1 = [
  Ii1,
  Oi1,
  Ni1
];
function Bi1(t, e) {
  return T(), N("svg", Ti1, [...Pi1]);
}
const Vi1 = { render: Bi1 }, Ri1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, Hi1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M74.563 18.5V5.615h9.553v2.18h-6.952v2.856h6.469v2.171h-6.469v3.507h7.198V18.5zm12.014-9.334h5.405q1.662 0 2.488.606.825.607.826 1.829 0 .781-.457 1.362a2.13 2.13 0 0 1-1.134.773q.967.238 1.442.888.474.65.474 1.424 0 1.09-.8 1.775-.8.677-2.364.677h-5.88zm2.487 3.876h1.591q1.152 0 1.661-.29.519-.29.519-.914 0-.59-.483-.835-.475-.255-1.697-.255h-1.59zm0 3.876h1.952q1.054 0 1.538-.255.483-.255.483-.914 0-.685-.554-.94-.554-.264-2.153-.264h-1.266zm8.491-7.752h2.302v1.371a3.45 3.45 0 0 1 1.213-1.142 3.35 3.35 0 0 1 1.697-.44q1.626 0 2.759 1.274t1.134 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.319-1.054v4.702h-2.47zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.86 0 1.432-.686.571-.694.571-2.267 0-1.468-.588-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066m8.06.026q0-1.23.606-2.382a4.17 4.17 0 0 1 1.714-1.757q1.116-.607 2.487-.607 2.118 0 3.472 1.38 1.353 1.37 1.353 3.472 0 2.118-1.371 3.515-1.362 1.389-3.436 1.389a5.44 5.44 0 0 1-2.452-.58 4 4 0 0 1-1.767-1.696q-.606-1.125-.606-2.734m2.531.132q0 1.389.659 2.127.66.738 1.626.738.968 0 1.617-.738.66-.738.659-2.145 0-1.371-.659-2.109-.65-.738-1.617-.738t-1.626.738-.659 2.127m8.947-4.667h8.288V18.5h-2.47v-7.339h-3.348V18.5h-2.47zm16.383 6.364 2.461.412q-.476 1.354-1.503 2.066-1.02.703-2.558.703-2.435 0-3.603-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.067-1.318 2.084 0 3.287 1.38 1.204 1.37 1.152 4.21h-6.188q.027 1.098.598 1.714.571.606 1.424.606.58 0 .975-.316.396-.316.598-1.02m.141-2.497q-.027-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.809 0-1.336.589-.528.588-.519 1.6zm4.412-3.866h2.373v5.862l3.797-5.862h2.425V18.5h-2.373v-5.968l-3.849 5.968h-2.373zm5.915-3.788h1.204q-.106 1.196-.844 1.88-.73.678-1.898.678-1.17 0-1.908-.677-.729-.686-.835-1.881h1.205q.061.624.439.95.378.316 1.099.316.72 0 1.098-.317.378-.325.44-.95m13.359 6.549-2.434.44q-.124-.73-.563-1.1-.43-.368-1.125-.368-.922 0-1.477.641-.544.632-.544 2.127 0 1.661.553 2.347.563.685 1.503.685.704 0 1.152-.395.447-.405.632-1.38l2.426.413q-.378 1.67-1.45 2.522-1.073.853-2.874.853-2.047 0-3.27-1.292-1.212-1.292-1.213-3.577 0-2.312 1.222-3.595 1.222-1.292 3.305-1.292 1.705 0 2.707.738 1.01.73 1.45 2.233m1.784-2.76h2.461v3.814q.615-.069.87-.378.255-.307.616-1.344.474-1.38 1.037-1.767t1.476-.387q.282 0 .976.044l.009 1.635q-.977 0-1.248.185-.273.193-.589 1.151-.43 1.292-1.24 1.591 1.17.325 1.978 2.03.044.088.097.185l1.38 2.575h-2.655l-1.23-2.698q-.378-.818-.659-1.046-.273-.237-.818-.237V18.5h-2.461zm9.053 0h2.373v5.862l3.797-5.862h2.426V18.5h-2.373v-5.968l-3.85 5.968h-2.373zm11.074 0h2.373v5.862l3.797-5.862h2.426V18.5h-2.373v-5.968l-3.85 5.968h-2.373zm5.915-3.788h1.204q-.105 1.196-.843 1.88-.73.678-1.899.678t-1.907-.677q-.73-.686-.835-1.881h1.204q.062.624.44.95.378.316 1.098.316t1.099-.317q.378-.325.439-.95M82.684 31.926l-2.435.44q-.123-.73-.562-1.1-.432-.368-1.126-.368-.922 0-1.476.641-.545.632-.545 2.127 0 1.661.554 2.347.563.685 1.503.685.702 0 1.151-.395.449-.405.633-1.38l2.426.413q-.379 1.67-1.45 2.522-1.072.853-2.875.853-2.047 0-3.27-1.292Q74 36.127 74 33.842q0-2.312 1.222-3.595 1.221-1.292 3.304-1.292 1.706 0 2.707.738 1.011.73 1.45 2.233m1.31 1.775q0-1.23.607-2.382a4.17 4.17 0 0 1 1.714-1.758q1.116-.606 2.487-.606 2.119 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.66-.738.659-2.145 0-1.371-.66-2.109-.65-.738-1.616-.738-.968 0-1.626.738-.66.738-.66 2.127m9.026-4.667h2.47v3.77h1.97q.192-1.793 1.353-2.882 1.168-1.1 3.12-1.099 1.969 0 3.225 1.275t1.257 3.673q0 1.407-.474 2.461a3.93 3.93 0 0 1-1.433 1.705q-.966.642-2.522.642-2.242 0-3.34-1.213-1.099-1.222-1.187-2.601H98.02V38.5h-2.47zm8.878 1.714q-1.029 0-1.503.66-.466.659-.466 2.1 0 1.845.501 2.496.51.64 1.538.641.949 0 1.424-.72.474-.73.474-2.18 0-1.776-.518-2.382-.51-.615-1.45-.615m9.035 3.788V33.06q.642 0 .932-.08.29-.087.544-.404a1.14 1.14 0 0 0 .264-.738q0-.44-.325-.809-.316-.378-.958-.378-.492 0-.879.211-.387.21-.703 1.002l-2.092-.448q.316-1.23 1.354-1.846 1.036-.615 2.364-.615 1.688 0 2.61.774.932.773.932 1.942 0 .729-.404 1.213-.396.474-1.257.888 1.037.28 1.547.852.518.57.518 1.424 0 1.09-1.019 1.88-1.02.783-2.936.783-3.34 0-4.087-2.61l2.259-.413q.545 1.37 1.802 1.37.695 0 1.107-.36.422-.369.422-.861a.98.98 0 0 0-.439-.853q-.431-.316-1.134-.316z"
}, null, -1), Di1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), $i1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.686l-.517 1.593h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.985-.517 1.584 1.364-.976 1.365.976-.517-1.584 1.355-.985h-1.632l-.526-1.584zm4.718 6.019-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.331-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.985.517 1.584-1.355-.976-1.365.976.517-1.584-1.346-.985h1.676l.527-1.584zm-4.763 6.019 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), Ui1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), ji1 = [
  Hi1,
  Di1,
  $i1,
  Ui1
];
function Gi1(t, e) {
  return T(), N("svg", Ri1, [...ji1]);
}
const Wi1 = { render: Gi1 }, Yi1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, Xi1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Ki1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Zi1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm13.513 26.721 1.185-2.57h2.705l-2.362 2.57zm3.126 10.244v-1.367a3.5 3.5 0 0 1-1.31 1.152q-.811.42-1.713.421a3.35 3.35 0 0 1-1.649-.404 2.38 2.38 0 0 1-1.056-1.134q-.326-.73-.326-2.02V28.72h2.413v4.193q0 1.925.132 2.36.135.432.486.687.353.252.893.253.619 0 1.108-.34a1.72 1.72 0 0 0 .67-.842q.18-.502.18-2.461v-3.85h2.413v9.126zm12.507 0h-2.412v-4.658q0-1.479-.155-1.912a1.34 1.34 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.627 0-1.126.344t-.682.91q-.185.568-.185 2.098v4.133h-2.413v-9.127h2.242v1.34q1.193-1.545 3.005-1.546.799 0 1.46.288t1 .735.473 1.014q.132.568.132 1.624zm2.008-.001h2.413v-9.126h-2.413zm0-10.363h2.413v-2.235h-2.413zm9.478 5.981q-.463.154-1.468.37-1.005.215-1.314.42-.471.336-.472.851 0 .508.378.877.378.37.961.37.654 0 1.245-.43.438-.327.576-.8.094-.309.094-1.177zm-3.228-1.96-2.19-.395q.37-1.323 1.271-1.959t2.679-.636q1.615 0 2.404.383.79.381 1.112.97.322.59.322 2.162l-.025 2.818q0 1.204.116 1.775.115.572.433 1.224h-2.387a9 9 0 0 1-.232-.712 4 4 0 0 0-.086-.284 4.4 4.4 0 0 1-1.322.902q-.705.3-1.503.301-1.407 0-2.22-.765-.81-.764-.81-1.934 0-.773.369-1.379.368-.605 1.034-.928.666-.322 1.919-.562 1.691-.318 2.344-.594v-.24q0-.696-.343-.992t-1.296-.297q-.645 0-1.006.253-.36.255-.583.89M74.768 18.767V6.169h9.334v2.13H77.31v2.793h6.32v2.123h-6.32v3.43h7.033v2.122zm17.469 0V17.4q-.5.73-1.31 1.152-.81.42-1.713.42-.92.001-1.648-.403a2.37 2.37 0 0 1-1.057-1.135q-.327-.73-.326-2.02V9.64h2.413v4.194q0 1.925.133 2.359.132.435.485.687.352.254.894.254.618 0 1.107-.34.49-.339.67-.841.18-.504.18-2.463V9.64h2.413v9.127zm6.786 0H96.61V9.64h2.241v1.298q.575-.92 1.035-1.212a1.9 1.9 0 0 1 1.043-.292q.825 0 1.589.455l-.748 2.106q-.608-.396-1.133-.396-.505 0-.86.28-.35.28-.552 1.01t-.202 3.06zm7.199-10.244 1.185-2.57h2.705l-2.362 2.57zm-1.013 5.68q0 1.358.644 2.08.643.722 1.589.722.943 0 1.583-.722.641-.723.64-2.096.001-1.341-.64-2.063-.64-.722-1.583-.723-.946 0-1.589.723-.644.721-.644 2.08m-2.474-.128q0-1.204.593-2.33a4.07 4.07 0 0 1 1.678-1.718q1.086-.593 2.427-.593 2.067 0 3.391 1.344 1.322 1.346 1.323 3.4 0 2.07-1.336 3.433-1.335 1.362-3.362 1.362-1.253 0-2.391-.568a3.9 3.9 0 0 1-1.73-1.662q-.593-1.096-.593-2.668m13.321-.027q0 1.538.609 2.273.61.735 1.486.735.84 0 1.4-.675.557-.675.558-2.213 0-1.435-.576-2.131-.575-.697-1.425-.696-.887 0-1.468.683-.584.684-.584 2.024m-2.388-4.409h2.251v1.341q.438-.687 1.184-1.118a3.26 3.26 0 0 1 1.658-.429q1.587 0 2.696 1.246 1.107 1.245 1.107 3.472 0 2.286-1.115 3.553-1.118 1.268-2.705 1.268c-.506 0-.96-.1-1.371-.3q-.614-.302-1.292-1.032v4.598h-2.413zm9.785 6.523 2.421-.37q.155.705.627 1.07.473.366 1.323.366.938 0 1.407-.345a.77.77 0 0 0 .319-.644.63.63 0 0 0-.173-.456q-.178-.171-.807-.317-2.918-.644-3.701-1.178-1.081-.738-1.081-2.054 0-1.185.935-1.994.938-.806 2.903-.807 1.872 0 2.782.61.911.61 1.254 1.805l-2.276.42a1.4 1.4 0 0 0-.553-.816q-.407-.283-1.164-.283-.953 0-1.366.266-.273.19-.274.49 0 .258.24.439.326.24 2.255.678t2.691 1.075q.757.644.756 1.796 0 1.254-1.048 2.157-1.046.902-3.099.902-1.864 0-2.95-.756a3.48 3.48 0 0 1-1.421-2.054m10.105 2.604V6.169h2.413v6.685l2.825-3.214h2.971l-3.117 3.335 3.34 5.792h-2.601l-2.294-4.1-1.124 1.178v2.922zm14.898-4.383q-.463.154-1.468.37-1.005.214-1.314.42-.471.336-.472.851 0 .508.378.877.379.37.961.37.653 0 1.245-.43.439-.327.576-.8.095-.309.094-1.177zm-3.228-1.96-2.19-.395q.37-1.323 1.271-1.959.902-.636 2.679-.636 1.616 0 2.404.383.792.381 1.113.97.322.59.321 2.162l-.025 2.818q0 1.204.117 1.775.115.572.432 1.224h-2.387a10 10 0 0 1-.232-.712 4 4 0 0 0-.086-.284q-.618.6-1.322.902-.704.3-1.503.301-1.407 0-2.218-.765-.813-.765-.813-1.934 0-.774.369-1.379a2.43 2.43 0 0 1 1.035-.928q.667-.322 1.919-.562 1.692-.319 2.344-.594v-.24q.001-.696-.343-.992-.343-.298-1.297-.297-.644 0-1.005.253-.36.255-.583.89",
  "clip-rule": "evenodd"
}, null, -1), Ji1 = [
  Xi1,
  Ki1,
  Zi1
];
function Qi1(t, e) {
  return T(), N("svg", Yi1, [...Ji1]);
}
const e81 = { render: Qi1 }, t81 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, n81 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), i81 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), s81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm16.575 36.965V36.48a3.5 3.5 0 0 1-1.309 1.151q-.81.421-1.712.421-.917 0-1.647-.404a2.38 2.38 0 0 1-1.056-1.134q-.326-.73-.326-2.02V28.72h2.411v4.194q0 1.925.134 2.358.132.435.484.688t.893.254q.617 0 1.107-.34.489-.34.67-.842.18-.503.18-2.462v-3.85h2.41v9.126zm12.761 0h-2.41v-4.658q0-1.477-.156-1.912a1.34 1.34 0 0 0-.501-.674 1.43 1.43 0 0 0-.837-.241q-.627 0-1.124.344a1.73 1.73 0 0 0-.682.91q-.185.569-.185 2.098v4.133h-2.41V28.72h2.239v1.34q1.193-1.546 3.003-1.546.798 0 1.459.288.66.287 1 .734.338.447.471 1.014t.133 1.625zm2.27 0h2.41V28.72h-2.41zm0-10.364h2.41v-2.235h-2.41zm4.83-.001h2.411v-2.234h-2.411zm2.411 1.239v8.843q0 1.743-.228 2.461a2 2 0 0 1-.875 1.122q-.647.405-1.651.404-.361 0-.776-.064a9 9 0 0 1-.897-.194l.42-2.062q.172.035.322.056t.279.021q.37 0 .605-.16a.77.77 0 0 0 .313-.381q.078-.224.077-1.341v-8.705zm7.551 4.743q-.464.154-1.468.37-1.004.215-1.312.42-.472.336-.472.852 0 .507.378.876.377.37.96.37.653 0 1.244-.43.437-.327.576-.799.094-.31.094-1.177zm-3.227-1.96-2.187-.394q.369-1.323 1.269-1.96.901-.636 2.677-.636 1.614 0 2.403.383.79.382 1.111.97.322.59.322 2.162l-.026 2.819q0 1.203.116 1.775.115.57.433 1.224h-2.385a9 9 0 0 1-.232-.713 5 5 0 0 0-.085-.283q-.618.6-1.322.902-.704.3-1.501.3-1.407 0-2.218-.764-.811-.765-.811-1.934 0-.773.369-1.38.369-.604 1.033-.928.666-.322 1.918-.562 1.69-.318 2.343-.593v-.241q0-.696-.344-.992t-1.295-.297q-.644 0-1.004.254-.36.253-.584.889M74.709 18.767V6.169h9.326v2.13h-6.786v2.793h6.314v2.123H77.25v3.43h7.027v2.122zm13.962 0L84.998 9.64h2.532l1.716 4.658.498 1.555q.196-.593.248-.781.12-.387.258-.774l1.733-4.658h2.48l-3.62 9.127zm9.752 0h-2.411V9.64h2.24v1.298q.574-.92 1.032-1.212a1.9 1.9 0 0 1 1.043-.292q.824 0 1.588.455l-.747 2.106q-.61-.396-1.132-.396-.507 0-.859.28-.35.28-.553 1.01-.202.73-.201 3.059zm6.18-4.564q0 1.359.643 2.08.645.722 1.588.722t1.583-.722.639-2.097q0-1.34-.639-2.062-.64-.722-1.583-.723-.943 0-1.588.723-.643.721-.643 2.08m-2.472-.13q0-1.203.593-2.328a4.07 4.07 0 0 1 1.678-1.72q1.085-.591 2.423-.592 2.068 0 3.39 1.344 1.321 1.345 1.321 3.4 0 2.07-1.335 3.433t-3.359 1.362a5.3 5.3 0 0 1-2.389-.568 3.9 3.9 0 0 1-1.729-1.662q-.593-1.095-.593-2.668m13.31-.026q0 1.538.609 2.273.61.735 1.485.735.841 0 1.399-.675.557-.675.557-2.213 0-1.435-.575-2.131-.574-.697-1.424-.696-.885 0-1.467.683-.584.683-.584 2.024m-2.385-4.41h2.248v1.342q.438-.687 1.184-1.118a3.26 3.26 0 0 1 1.656-.43q1.588 0 2.695 1.247 1.106 1.245 1.106 3.472 0 2.286-1.115 3.553-1.116 1.268-2.703 1.268-.755 0-1.369-.3-.613-.302-1.291-1.032v4.598h-2.411zm9.777 6.524 2.42-.37q.154.704.626 1.07.472.365 1.322.365.936 0 1.406-.344a.77.77 0 0 0 .319-.644.63.63 0 0 0-.173-.456q-.179-.171-.806-.317-2.917-.644-3.698-1.178-1.081-.739-1.081-2.054 0-1.185.935-1.994.936-.806 2.9-.807 1.87 0 2.78.61t1.253 1.805l-2.274.42q-.145-.533-.553-.816t-1.163-.283q-.952 0-1.364.266-.274.19-.274.49 0 .258.239.439.326.24 2.253.678t2.69 1.075q.755.643.755 1.796 0 1.254-1.047 2.156-1.048.903-3.097.902-1.863 0-2.948-.755a3.5 3.5 0 0 1-1.42-2.054m10.185 2.604V6.169h2.411v6.685l2.823-3.214h2.969l-3.115 3.335 3.338 5.792h-2.6l-2.291-4.1-1.124 1.178v2.922zm14.886-4.383q-.463.154-1.467.37-1.004.214-1.312.42-.472.336-.472.851 0 .508.378.877.377.37.96.37.652 0 1.244-.43.438-.326.575-.8.094-.309.094-1.177zm-3.226-1.96-2.188-.395q.37-1.323 1.27-1.959.901-.636 2.677-.636 1.614 0 2.402.383.79.381 1.112.97.321.589.321 2.162l-.025 2.818q0 1.204.116 1.775.115.572.433 1.224h-2.385a9 9 0 0 1-.232-.712 4 4 0 0 0-.086-.284 4.4 4.4 0 0 1-1.321.902q-.704.3-1.502.301-1.406 0-2.217-.765-.811-.764-.811-1.934 0-.773.369-1.379a2.4 2.4 0 0 1 1.033-.928q.666-.322 1.918-.563 1.69-.318 2.342-.593v-.24q0-.697-.343-.993t-1.295-.296q-.645 0-1.004.253-.36.254-.584.89",
  "clip-rule": "evenodd"
}, null, -1), l81 = [
  n81,
  i81,
  s81
];
function r81(t, e) {
  return T(), N("svg", t81, [...l81]);
}
const a81 = { render: r81 }, o81 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, c81 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), h81 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), u81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244zm16.605 36.965v-1.367a3.5 3.5 0 0 1-1.309 1.152q-.81.421-1.713.421-.917 0-1.647-.404a2.38 2.38 0 0 1-1.057-1.134q-.326-.73-.326-2.02V28.72h2.412v4.194q0 1.925.134 2.358.132.436.484.687.353.255.893.255.618 0 1.108-.34.489-.34.67-.842.18-.503.18-2.462v-3.85h2.411v9.126zm13.03 0h-2.412v-4.658q0-1.477-.155-1.912a1.34 1.34 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.627 0-1.124.344a1.73 1.73 0 0 0-.683.91q-.184.569-.184 2.098v4.133h-2.412V28.72h2.24v1.34q1.194-1.547 3.005-1.546.797 0 1.459.287.66.288 1 .735.338.447.472 1.014.132.568.133 1.624zm2.007 0h2.412V28.72h-2.412zm0-10.364h2.412v-2.235h-2.412zm6.358 5.801q0 1.357.644 2.08.643.721 1.588.722.943 0 1.584-.723.639-.721.639-2.097 0-1.34-.639-2.062-.641-.721-1.584-.722-.945 0-1.588.722t-.644 2.08m-2.472-.129q0-1.203.592-2.329a4.07 4.07 0 0 1 1.679-1.719q1.085-.593 2.424-.593 2.069 0 3.391 1.345t1.322 3.4q0 2.07-1.335 3.432-1.336 1.362-3.36 1.362-1.254 0-2.391-.567a3.9 3.9 0 0 1-1.73-1.663q-.592-1.096-.592-2.668m19.148 4.692h-2.412v-4.658q0-1.477-.154-1.912a1.35 1.35 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.627 0-1.125.344a1.73 1.73 0 0 0-.682.91q-.185.569-.185 2.098v4.133h-2.411V28.72h2.24v1.34q1.193-1.547 3.004-1.546a3.6 3.6 0 0 1 1.459.287q.662.288 1 .735.339.447.472 1.014.132.568.133 1.624zm7.863-5.345q-.027-1.048-.541-1.595a1.66 1.66 0 0 0-1.253-.545q-.79 0-1.305.576t-.507 1.564zm-.137 2.44 2.403.404q-.463 1.325-1.464 2.015-1 .692-2.502.693-2.377-.001-3.519-1.556-.901-1.245-.901-3.145 0-2.269 1.184-3.554 1.185-1.285 2.996-1.285 2.035 0 3.21 1.345 1.176 1.345 1.125 4.121h-6.043q.026 1.074.584 1.671a1.82 1.82 0 0 0 1.39.598q.566 0 .953-.31.386-.309.584-.997m12.525 2.905h-2.412v-4.658q0-1.477-.154-1.912a1.35 1.35 0 0 0-.502-.674 1.43 1.43 0 0 0-.837-.241q-.627 0-1.125.344a1.73 1.73 0 0 0-.682.91q-.185.569-.185 2.098v4.133h-2.412V28.72h2.241v1.34q1.192-1.547 3.004-1.546a3.6 3.6 0 0 1 1.459.287q.66.288 1 .735t.472 1.014q.132.568.133 1.624zM74.738 18.767V6.168h9.33v2.13h-6.79v2.794h6.318v2.123h-6.317v3.429h7.03v2.123zm17.461 0V17.4a3.5 3.5 0 0 1-1.309 1.152q-.81.42-1.713.42-.918.001-1.647-.404a2.38 2.38 0 0 1-1.057-1.134q-.326-.73-.326-2.02V9.64h2.412v4.194q0 1.926.134 2.358.132.436.484.688.353.255.893.254a1.9 1.9 0 0 0 1.108-.34q.489-.338.67-.842.18-.503.18-2.462V9.64h2.411v9.127zm6.783 0h-2.411V9.64h2.24v1.298q.575-.92 1.034-1.212a1.9 1.9 0 0 1 1.043-.292q.824 0 1.588.455l-.747 2.106q-.61-.395-1.133-.396-.506 0-.859.28-.35.28-.553 1.01-.202.73-.202 3.059zm6.183-4.564q0 1.358.643 2.08.645.722 1.589.722.943 0 1.583-.722t.639-2.097q0-1.34-.639-2.062-.64-.723-1.583-.723-.944 0-1.589.723-.643.722-.643 2.08m-2.472-.13q0-1.202.592-2.329a4.06 4.06 0 0 1 1.679-1.718q1.085-.593 2.424-.593 2.069 0 3.391 1.344 1.322 1.346 1.322 3.4 0 2.07-1.335 3.433-1.336 1.362-3.361 1.362a5.3 5.3 0 0 1-2.39-.568 3.9 3.9 0 0 1-1.73-1.662q-.592-1.096-.592-2.668m13.315-.026q0 1.538.609 2.273.61.734 1.485.734.842 0 1.399-.675.557-.672.558-2.212 0-1.435-.575-2.131-.574-.697-1.425-.696a1.85 1.85 0 0 0-1.468.683q-.582.683-.583 2.024m-2.387-4.41h2.25v1.342a3.36 3.36 0 0 1 1.184-1.118 3.27 3.27 0 0 1 1.656-.43q1.589.001 2.696 1.247 1.106 1.246 1.107 3.472 0 2.287-1.116 3.553-1.116 1.268-2.703 1.268-.756 0-1.37-.3-.613-.302-1.292-1.032v4.598h-2.412zm16.047 3.782q-.026-1.048-.54-1.594a1.66 1.66 0 0 0-1.254-.546q-.79 0-1.304.576-.515.576-.507 1.564zm-.137 2.44 2.403.404q-.462 1.325-1.463 2.016-1 .693-2.503.692-2.376 0-3.518-1.556-.902-1.245-.902-3.145 0-2.27 1.185-3.553 1.184-1.284 2.995-1.285 2.036 0 3.21 1.345 1.177 1.345 1.125 4.12h-6.042q.025 1.075.583 1.672t1.391.597q.566 0 .953-.31.385-.307.583-.997m4.41 2.906h2.412V9.64h-2.412zm0-10.365h2.412V6.168h-2.412zm3.683 7.761 2.42-.37q.154.705.627 1.07.472.365 1.322.365.935 0 1.407-.344a.76.76 0 0 0 .318-.644.64.64 0 0 0-.172-.456q-.18-.171-.807-.318-2.918-.643-3.699-1.177-1.082-.738-1.082-2.054 0-1.184.936-1.994.936-.807 2.901-.807 1.871 0 2.781.61t1.253 1.805l-2.274.42a1.4 1.4 0 0 0-.554-.816q-.407-.283-1.163-.284-.952 0-1.365.267-.274.19-.274.49 0 .258.24.438.326.24 2.253.679 1.927.438 2.691 1.075.756.644.756 1.796 0 1.253-1.048 2.156-1.047.903-3.098.902-1.864 0-2.949-.756a3.48 3.48 0 0 1-1.42-2.053m10.188 2.604V6.168h2.412v6.686l2.824-3.214h2.97l-3.116 3.334 3.339 5.793h-2.601l-2.292-4.1-1.124 1.178v2.922zm14.892-4.383q-.464.155-1.467.37-1.005.214-1.314.42-.472.336-.472.851 0 .507.378.877.379.37.961.37.653 0 1.245-.43.437-.326.575-.8.094-.309.094-1.177zm-3.227-1.96-2.189-.395q.37-1.323 1.27-1.959.902-.636 2.679-.636 1.613 0 2.403.383t1.111.97q.322.59.322 2.161l-.025 2.82q0 1.203.116 1.774.115.572.433 1.224h-2.386a9 9 0 0 1-.232-.713 5 5 0 0 0-.086-.283 4.3 4.3 0 0 1-1.322.902q-.704.301-1.502.301-1.407 0-2.218-.765-.812-.764-.811-1.934 0-.774.369-1.379a2.4 2.4 0 0 1 1.033-.928q.666-.322 1.919-.563 1.69-.318 2.343-.593v-.24q0-.698-.343-.993t-1.296-.296q-.644 0-1.005.253-.36.255-.583.889",
  "clip-rule": "evenodd"
}, null, -1), d81 = [
  c81,
  h81,
  u81
];
function f81(t, e) {
  return T(), N("svg", o81, [...d81]);
}
const v81 = { render: f81 }, p81 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, m81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M77.292 5.615h2.602v6.979q0 1.66.096 2.153.167.79.791 1.274.633.475 1.723.475 1.107 0 1.67-.448.562-.457.677-1.116.114-.66.114-2.189V5.615h2.601v6.768q0 2.32-.21 3.278-.212.958-.783 1.617-.563.66-1.511 1.055-.95.387-2.479.387-1.845 0-2.804-.422-.948-.43-1.503-1.108-.553-.685-.73-1.432-.254-1.107-.254-3.27zm12.823 3.551h2.277v1.274q1.221-1.485 2.909-1.485.896 0 1.555.37.66.368 1.082 1.115.615-.747 1.327-1.116.711-.369 1.52-.369 1.029 0 1.74.422.712.413 1.064 1.222.255.598.255 1.933V18.5h-2.47v-5.335q0-1.388-.255-1.793-.342-.527-1.055-.527-.518 0-.975.316-.458.317-.66.932-.201.606-.201 1.925V18.5h-2.47v-5.115q0-1.362-.132-1.758t-.413-.589q-.272-.193-.747-.193a1.8 1.8 0 0 0-1.028.307q-.458.307-.66.888-.193.58-.193 1.925V18.5h-2.47zm15.627 4.535q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.757q1.117-.607 2.488-.607 2.118 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.125-.607-2.734m2.531.132q0 1.389.66 2.127.658.738 1.626.738.966 0 1.617-.738.659-.738.659-2.145 0-1.371-.659-2.109-.651-.738-1.617-.738-.968 0-1.626.738-.66.738-.66 2.127m8.992-5.933V5.615h2.469V7.9zm2.469 1.266v9.044q0 1.784-.237 2.514a2.02 2.02 0 0 1-.896 1.151q-.66.413-1.688.413-.37 0-.8-.07a8 8 0 0 1-.914-.194l.431-2.109q.175.035.334.053.149.026.281.026.378 0 .615-.167a.76.76 0 0 0 .326-.387q.079-.228.079-1.37V9.165zm4.439 2.848-2.241-.405q.378-1.353 1.3-2.004.924-.65 2.743-.65 1.651 0 2.461.396.809.386 1.133.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.124.58.448 1.248h-2.443a9 9 0 0 1-.237-.73 5 5 0 0 0-.088-.29 4.5 4.5 0 0 1-1.354.923q-.72.308-1.538.308-1.441 0-2.276-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.054-.95q.686-.333 1.969-.58 1.731-.324 2.4-.606v-.246q0-.712-.352-1.01-.352-.309-1.327-.308-.66 0-1.028.263-.37.255-.598.906m3.305 2.004q-.475.158-1.503.377-1.029.22-1.345.431-.484.344-.484.87 0 .519.387.897t.985.378q.668 0 1.274-.44.448-.334.589-.817.096-.316.097-1.204zm11.619 4.482-2.953-9.334h2.399l1.749 6.117 1.608-6.117h2.382l1.556 6.117 1.784-6.117h2.435L147.06 18.5h-2.373l-1.609-6.003-1.582 6.003zm14.115-6.486-2.241-.405q.378-1.353 1.3-2.004.924-.65 2.743-.65 1.652 0 2.461.396.809.386 1.133.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.449 1.248h-2.444a9 9 0 0 1-.237-.73 4 4 0 0 0-.088-.29 4.5 4.5 0 0 1-1.354.923q-.72.308-1.538.308-1.441 0-2.276-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.054-.95q.686-.333 1.969-.58 1.731-.324 2.4-.606v-.246q0-.712-.352-1.01-.352-.309-1.327-.308-.66 0-1.028.263-.37.255-.598.906m3.305 2.004q-.476.158-1.503.377-1.029.22-1.345.431-.483.344-.483.87 0 .519.386.897.387.378.985.378.668 0 1.274-.44.448-.334.589-.817.096-.316.097-1.204zM77.292 25.615h2.602v6.979q0 1.66.096 2.153.167.79.791 1.275.633.474 1.723.474 1.107 0 1.67-.448.562-.457.677-1.116.114-.66.114-2.189v-7.128h2.601v6.768q0 2.32-.21 3.278-.212.959-.783 1.617-.563.66-1.511 1.055-.95.387-2.479.387-1.845 0-2.804-.422-.948-.43-1.503-1.108-.553-.685-.73-1.432-.254-1.108-.254-3.27zM90.3 38.5V25.615h2.47V38.5zm6.855-6.486-2.24-.405q.377-1.353 1.3-2.004.923-.65 2.742-.65 1.653 0 2.461.396.808.386 1.134.993.333.597.334 2.206l-.027 2.883q0 1.23.115 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.238-.73 4 4 0 0 0-.088-.29q-.633.615-1.353.923t-1.538.308q-1.442 0-2.277-.782-.826-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.399-.606v-.246q0-.711-.352-1.01-.35-.309-1.327-.308-.66 0-1.028.263-.369.255-.598.906m3.305 2.004q-.474.158-1.503.377-1.028.22-1.345.431-.483.343-.483.87 0 .519.387.897.386.378.984.378.668 0 1.274-.44.449-.334.589-.817.097-.316.097-1.204zm3.7-4.852h2.628l2.233 6.627 2.179-6.627h2.558l-3.296 8.982-.589 1.626q-.325.817-.624 1.249a2.6 2.6 0 0 1-.677.694 2.8 2.8 0 0 1-.94.422q-.553.15-1.257.15-.712 0-1.397-.15l-.22-1.934q.58.114 1.046.114.861 0 1.274-.51.413-.5.633-1.283zm13.034 2.848-2.241-.405q.378-1.353 1.301-2.004.922-.65 2.742-.65 1.653 0 2.461.396.808.386 1.134.993.333.597.334 2.206l-.027 2.883q0 1.23.115 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.238-.73 4 4 0 0 0-.088-.29q-.632.615-1.353.923a3.9 3.9 0 0 1-1.538.308q-1.442 0-2.277-.782-.825-.783-.826-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.399-.606v-.246q0-.711-.352-1.01-.35-.309-1.327-.308-.659 0-1.028.263-.369.255-.598.906m3.305 2.004q-.474.158-1.503.377-1.028.22-1.345.431-.483.343-.483.87 0 .519.387.897.386.378.984.378.668 0 1.274-.44.449-.334.589-.817.097-.316.097-1.204z"
}, null, -1), g81 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), y81 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.057l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.985.51 1.584-1.336-.985zm8.16-10.913-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.986.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.986zm0 13.763h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23l-.518-1.584zm4.646 6.02-1.335-.969h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.976-1.335.976zm22.636-10.332-.51-1.584 1.336-.985h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.985-.51 1.584 1.353-.985zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.995h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.02 1.335-.969h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.976 1.335.976z",
  "clip-rule": "evenodd"
}, null, -1), _81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), q81 = [
  m81,
  g81,
  y81,
  _81
];
function w81(t, e) {
  return T(), N("svg", p81, [...q81]);
}
const z81 = { render: w81 }, M81 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "219",
  height: "44",
  fill: "none",
  viewBox: "0 0 219 44"
}, b81 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), L81 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), x81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), S81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M88.929 19h-2.83l-1.125-2.927h-5.15L78.76 19H76l5.019-12.885h2.75zm-4.79-5.098-1.776-4.78-1.74 4.78zM92.198 19l-3.761-9.334h2.592l1.758 4.764.51 1.59q.203-.605.255-.8.123-.395.263-.79l1.776-4.764h2.54L94.42 19zm9.818 0h-2.47V9.666h2.294v1.327q.588-.94 1.055-1.24.474-.297 1.072-.298.843 0 1.626.466l-.765 2.153q-.624-.405-1.16-.404-.519 0-.879.29-.36.281-.571 1.028-.202.747-.202 3.13zm10.793 0v-1.398q-.51.748-1.345 1.178a3.7 3.7 0 0 1-1.749.43 3.43 3.43 0 0 1-1.688-.412 2.44 2.44 0 0 1-1.081-1.16q-.333-.747-.334-2.066V9.666h2.47v4.29q0 1.968.132 2.416.141.44.501.703.36.255.914.255.633 0 1.134-.343a1.8 1.8 0 0 0 .685-.861q.185-.519.185-2.523V9.667h2.47V19zm4.79-9.334h2.302v1.371q.448-.704 1.213-1.142a3.34 3.34 0 0 1 1.697-.44q1.626 0 2.759 1.274t1.134 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.319-1.054v4.702h-2.469zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.86 0 1.432-.686.571-.694.571-2.267 0-1.468-.588-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066m10.477-1.661-2.242-.405q.378-1.353 1.301-2.004.923-.65 2.742-.65 1.653 0 2.461.396.809.386 1.134.993.334.597.334 2.206l-.026 2.883q0 1.23.114 1.819.123.58.448 1.248h-2.443a9 9 0 0 1-.238-.73 5 5 0 0 0-.087-.29 4.5 4.5 0 0 1-1.354.923q-.72.308-1.538.308-1.442 0-2.276-.782-.827-.783-.827-1.978 0-.79.378-1.406a2.44 2.44 0 0 1 1.055-.95q.685-.333 1.969-.58 1.731-.324 2.399-.606v-.246q0-.712-.351-1.01-.352-.309-1.327-.308-.66 0-1.029.263-.369.255-.597.906m3.304 2.004q-.474.158-1.503.377-1.028.22-1.344.431-.484.343-.484.87 0 .519.387.897t.984.378q.668 0 1.275-.44.448-.334.589-.817.096-.316.096-1.204zM77.318 25.115h5.15q1.53 0 2.277.132a3.3 3.3 0 0 1 1.345.527q.598.405.993 1.081.395.669.395 1.503 0 .906-.492 1.662a3 3 0 0 1-1.318 1.133q1.178.343 1.81 1.17.633.825.633 1.942 0 .879-.413 1.713-.404.827-1.116 1.328-.704.492-1.74.606-.651.07-3.138.088h-4.386zm2.602 2.145v2.98h1.705q1.521 0 1.89-.045.668-.078 1.046-.457.386-.387.386-1.01 0-.598-.334-.967-.325-.379-.975-.457-.388-.044-2.224-.044zm0 5.124v3.445h2.408q1.407 0 1.784-.079.58-.105.94-.51.37-.412.37-1.098 0-.58-.281-.985t-.818-.589q-.527-.184-2.302-.184zM90.3 27.4v-2.285h2.47V27.4zm0 10.6v-9.334h2.47V38zm7.374 0h-2.47v-9.334h2.294v1.327q.589-.94 1.055-1.24a1.97 1.97 0 0 1 1.072-.298q.844 0 1.626.466l-.765 2.153q-.623-.405-1.16-.404-.518 0-.879.29-.36.282-.571 1.028-.202.747-.202 3.13zm4.649 0V25.115h2.47V38zm5.01-10.6v-2.285h2.47V27.4zm0 10.6v-9.334h2.47V38zm4.781.615 2.822.343q.07.492.325.677.351.263 1.107.263.967 0 1.45-.29.325-.192.493-.624.114-.308.114-1.133v-1.363Q117.318 38 115.63 38q-1.88 0-2.98-1.59-.861-1.258-.861-3.13 0-2.346 1.125-3.586 1.134-1.239 2.813-1.239 1.731 0 2.856 1.52v-1.309h2.312v8.376q0 1.653-.273 2.47-.272.817-.765 1.283-.492.466-1.318.73-.817.263-2.074.263-2.373 0-3.366-.817-.994-.81-.994-2.057 0-.123.009-.299m2.206-5.475q0 1.484.572 2.18.58.684 1.423.685.906 0 1.53-.703.624-.712.624-2.1 0-1.451-.598-2.154a1.9 1.9 0 0 0-1.512-.703q-.887 0-1.467.694-.572.686-.572 2.1m3.534-8.245h1.204q-.106 1.195-.844 1.881-.729.677-1.899.677t-1.907-.677q-.729-.686-.835-1.88h1.204q.062.623.44.949.378.316 1.098.316t1.099-.316q.377-.326.44-.95m5.493 2.506v-2.285h2.469V27.4zm0 10.6v-9.334h2.469V38z"
}, null, -1), C81 = [
  b81,
  L81,
  x81,
  S81
];
function k81(t, e) {
  return T(), N("svg", M81, [...C81]);
}
const E81 = { render: k81 }, A81 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, F81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M80.794 10.994v2.162H76.75q.22 1.731 1.028 2.55a2.7 2.7 0 0 0 1.969.808q1.186 0 1.96-.703.774-.712.95-2.04l2.61.81q-.45 1.923-1.811 3.031-1.362 1.108-3.542 1.108-2.232 0-3.524-1.055-1.284-1.055-1.837-2.434-.555-1.38-.554-3.103 0-3.024 1.59-4.878t4.378-1.854q2.152 0 3.498 1.019 1.353 1.02 1.766 2.76l-2.575.589q-.28-1.011-1.037-1.565a2.84 2.84 0 0 0-1.723-.553q-1.388 0-2.197.958-.8.949-.949 2.39zm6.566-1.828h5.405q1.66 0 2.487.606.825.607.826 1.829 0 .781-.457 1.362a2.13 2.13 0 0 1-1.134.773q.967.238 1.442.888.474.65.474 1.424 0 1.09-.8 1.775-.799.677-2.364.677h-5.88zm2.487 3.876h1.59q1.152 0 1.662-.29.518-.29.518-.914 0-.59-.483-.835-.475-.255-1.697-.255h-1.59zm0 3.876h1.95q1.056 0 1.539-.255t.483-.914q0-.685-.553-.94-.554-.264-2.154-.264h-1.265zm8.49-7.752h2.303v1.371q.448-.704 1.213-1.142a3.34 3.34 0 0 1 1.696-.44q1.626 0 2.76 1.274t1.133 3.551q0 2.339-1.142 3.639-1.143 1.292-2.769 1.292-.773 0-1.406-.308-.624-.307-1.318-1.054v4.702h-2.47zm2.443 4.509q0 1.573.624 2.329.624.747 1.521.747.861 0 1.432-.686.572-.694.572-2.267 0-1.468-.589-2.18-.59-.711-1.459-.712-.906 0-1.503.703-.598.695-.598 2.066m8.06.026q0-1.23.606-2.382a4.2 4.2 0 0 1 1.714-1.757q1.116-.607 2.487-.607 2.12 0 3.472 1.38 1.353 1.37 1.354 3.472 0 2.118-1.371 3.515-1.363 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.767-1.696q-.606-1.125-.606-2.734m2.531.132q0 1.389.659 2.127.66.738 1.626.738.967 0 1.617-.738.66-.738.66-2.145 0-1.371-.66-2.109-.65-.738-1.617-.738-.966 0-1.626.738t-.659 2.127m8.947-4.667h8.288V18.5h-2.469v-7.339h-3.349V18.5h-2.47zm16.383 6.364 2.461.412q-.474 1.354-1.503 2.066-1.02.703-2.557.703-2.435 0-3.604-1.59-.923-1.275-.923-3.218 0-2.32 1.213-3.63 1.213-1.318 3.067-1.318 2.083 0 3.288 1.38 1.203 1.37 1.151 4.21h-6.188q.027 1.098.598 1.714.572.606 1.424.606.58 0 .976-.316.394-.316.597-1.02m.141-2.497q-.026-1.073-.554-1.626a1.7 1.7 0 0 0-1.283-.562q-.808 0-1.336.589-.527.588-.519 1.6zm4.412-3.866h2.373v5.862l3.797-5.862h2.426V18.5h-2.373v-5.968l-3.85 5.968h-2.373zm5.915-3.788h1.204q-.106 1.196-.844 1.88-.73.678-1.898.678-1.169 0-1.907-.677-.73-.686-.835-1.881h1.204q.061.624.439.95.378.316 1.099.316.72 0 1.098-.317.378-.325.44-.95m13.359 6.549-2.434.44q-.123-.73-.563-1.1-.43-.368-1.125-.368-.923 0-1.476.641-.546.632-.545 2.127 0 1.661.553 2.347.563.685 1.503.685.704 0 1.152-.395.448-.405.633-1.38l2.425.413q-.378 1.67-1.45 2.522-1.073.853-2.874.853-2.048 0-3.269-1.292-1.213-1.292-1.213-3.577 0-2.312 1.221-3.595 1.222-1.292 3.305-1.292 1.705 0 2.707.738 1.01.73 1.45 2.233m1.934-2.76h2.47v3.876h2.478q1.46 0 2.241.21.783.212 1.301.915.519.695.519 1.617 0 1.353-.932 2.04-.923.675-2.777.676h-5.3zm2.47 7.77h2.302q1.082 0 1.38-.352.308-.352.308-.835 0-.677-.527-.932-.519-.255-1.855-.255h-1.608zm8.455-7.77h2.461v3.814q.615-.069.87-.378.255-.307.615-1.344.474-1.38 1.037-1.767t1.477-.387q.28 0 .975.044l.009 1.635q-.975 0-1.248.185-.273.193-.589 1.151-.43 1.292-1.239 1.591 1.168.325 1.977 2.03l.097.185 1.38 2.575h-2.654l-1.231-2.698q-.378-.818-.659-1.046-.273-.237-.817-.237V18.5h-2.461zm9.052 0h2.373v5.862l3.797-5.862h2.426V18.5h-2.373v-5.968l-3.85 5.968h-2.373zm11.075 0h2.373v5.862l3.797-5.862h2.425V18.5h-2.373v-5.968l-3.849 5.968h-2.373zm5.915-3.788h1.204q-.106 1.196-.844 1.88-.73.678-1.898.678-1.17 0-1.908-.677-.729-.686-.835-1.881h1.205q.061.624.439.95.378.316 1.099.316.72 0 1.098-.317.378-.325.44-.95M82.78 33.763l2.522.8q-.58 2.11-1.934 3.137-1.344 1.02-3.419 1.02-2.566 0-4.218-1.75-1.653-1.756-1.653-4.798 0-3.218 1.661-4.992 1.662-1.785 4.368-1.785 2.365 0 3.841 1.398.88.826 1.319 2.373l-2.576.615q-.228-1.002-.958-1.582-.72-.58-1.757-.58-1.434 0-2.33 1.029-.887 1.028-.887 3.33 0 2.445.879 3.481t2.285 1.037q1.037 0 1.784-.66.748-.658 1.072-2.073m4.175-.062q0-1.23.607-2.382a4.17 4.17 0 0 1 1.713-1.758q1.117-.606 2.488-.606 2.119 0 3.471 1.38 1.354 1.37 1.354 3.472 0 2.118-1.371 3.515-1.362 1.389-3.437 1.389a5.45 5.45 0 0 1-2.452-.58 4 4 0 0 1-1.766-1.696q-.607-1.126-.607-2.734m2.531.132q0 1.389.66 2.127.659.738 1.626.738t1.617-.738q.66-.738.659-2.145 0-1.371-.66-2.109-.65-.738-1.617-.738-.966 0-1.626.738t-.659 2.127m9.027-4.667h2.469v3.77h1.969q.193-1.793 1.354-2.882 1.169-1.1 3.12-1.099 1.969 0 3.225 1.275t1.257 3.673q0 1.407-.474 2.461a3.93 3.93 0 0 1-1.433 1.705q-.967.642-2.522.642-2.242 0-3.34-1.213-1.099-1.222-1.187-2.601h-1.969V38.5h-2.47zm8.877 1.714q-1.029 0-1.503.66-.466.659-.466 2.1 0 1.845.501 2.496.51.64 1.538.641.949 0 1.424-.72.474-.73.474-2.18 0-1.776-.518-2.382-.51-.615-1.45-.615m9.035 3.788V33.06q.642 0 .931-.08.29-.087.545-.404a1.14 1.14 0 0 0 .264-.738q0-.44-.325-.809-.316-.378-.958-.378-.492 0-.879.211-.387.21-.703 1.002l-2.092-.448q.316-1.23 1.354-1.846 1.036-.615 2.364-.615 1.687 0 2.61.774.932.773.932 1.942 0 .729-.405 1.213-.395.474-1.256.888 1.037.28 1.547.852.518.57.518 1.424 0 1.09-1.019 1.88-1.02.783-2.936.783-3.34 0-4.087-2.61l2.259-.413q.545 1.37 1.802 1.37.694 0 1.107-.36.422-.369.422-.861a.98.98 0 0 0-.44-.853q-.43-.316-1.133-.316z"
}, null, -1), T81 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), I81 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.686l-.517 1.593h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.985-.517 1.584 1.364-.976 1.365.976-.517-1.584 1.355-.985h-1.632l-.526-1.584zm4.718 6.019-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.331-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.985.517 1.584-1.355-.976-1.365.976.517-1.584-1.346-.985h1.676l.527-1.584zm-4.763 6.019 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), O81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), N81 = [
  F81,
  T81,
  I81,
  O81
];
function P81(t, e) {
  return T(), N("svg", A81, [...N81]);
}
const B81 = { render: P81 }, V81 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "211",
  height: "44",
  fill: "none",
  viewBox: "0 0 211 44"
}, R81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M103.183 14.804c-.888-.72-2.664-1.752-3.936-2.4l-1.296 1.608c1.296.744 3.024 1.848 3.84 2.592zm-.912 6.192c-.936-.648-2.76-1.632-4.056-2.256l-1.272 1.632c1.344.696 3.144 1.752 4.008 2.448zm-2.856 12.888c1.008-2.232 2.16-5.064 3.024-7.584l-1.824-1.176c-.96 2.736-2.256 5.76-3.216 7.608zm8.376-14.04V12.74h-2.112v8.136c0 1.032-.024 2.04-.072 3.072a32 32 0 0 0-1.512-4.68l-1.608.576c.672 1.752 1.368 4.104 1.536 5.64l1.488-.552c-.264 2.856-1.008 5.592-2.88 7.944.576.264 1.44.888 1.872 1.296 2.952-3.792 3.288-8.616 3.288-13.296v-.552c.624 1.608 1.2 3.576 1.416 4.872l1.608-.624c-.288-1.392-.96-3.576-1.68-5.232zm8.136-7.128v10.56c-.504-1.344-1.296-2.976-2.064-4.296l-.96.432V13.1h-2.064v20.496h2.064V20.732c.768 1.536 1.512 3.312 1.824 4.536l1.2-.576v9.48h2.136V12.716zm19.68 3.336c-.432-1.008-1.416-2.472-2.376-3.552l-1.8.84c.912 1.128 1.872 2.664 2.28 3.72zm-8.16 2.088h-3.192v-2.976h3.192zm-3.192 6.72h3.192v2.544c-1.08.192-2.184.36-3.192.528zm3.192-1.848h-3.192v-3.024h3.192zm2.976-7.848v-2.016h-9.216v2.016h1.128v13.08c-.576.072-1.08.144-1.56.216l.336 2.112c1.8-.36 4.056-.768 6.336-1.2v4.824h1.92V15.164zm12.48 10.032V23.18h-5.688c.072-.768.096-1.536.096-2.16v-1.896h4.992v-2.04h-3.192c.768-1.152 1.608-2.616 2.328-3.984l-2.28-.6c-.528 1.392-1.464 3.288-2.304 4.584h-6.048v2.04h4.248v1.848c0 .624 0 1.392-.072 2.208h-4.608v2.016h4.296c-.528 2.472-1.824 5.232-4.944 7.56.576.336 1.368 1.008 1.752 1.464 3.456-2.736 4.872-6.096 5.448-9.024zm-6.048 2.472c1.704 2.016 3.744 4.776 4.656 6.456l1.68-1.32c-.936-1.68-3.048-4.344-4.776-6.288zm26.448-13.008v1.8h-4.944v-1.8zm-5.064 5.208c.072-.624.12-1.248.12-1.824h4.944v1.824zm5.064 1.608v1.632c0 .312-.12.408-.456.408-.312 0-1.392.024-2.544-.024.312.504.696 1.296.816 1.872 1.56 0 2.688-.048 3.432-.36.72-.312.96-.84.96-1.896V12.884h-9.192v4.872c0 2.112-.264 4.68-2.616 6.456.456.288 1.248 1.032 1.56 1.464 1.464-1.128 2.256-2.664 2.664-4.2zm-11.112-6.456v2.184h-3.744V15.02zm-3.744 6.072v-2.184h3.744v2.184zm0 1.752h5.76v-9.576h-7.8v10.824h2.04zm1.488 4.896h2.688v3.84h-2.688zm7.44 0v3.84h-2.712v-3.84zm4.776 0v3.84h-2.736v-3.84zm2.16 3.84v-5.592h-16.464v5.592h-2.784v1.944h21.888V31.58zM76.112 19.472c.936.864 1.92 1.872 2.856 2.904-.768 1.8-1.728 3.384-2.856 4.608zm13.848-1.32h2.472c-.24 1.464-.552 2.976-.888 4.08l1.632.888c.696-1.68 1.296-4.296 1.656-6.576l-1.512-.576-.36.144h-5.736c.288-1.272.528-2.592.72-3.912l-2.232-.36c-.48 3.792-1.344 7.512-2.904 9.84.552.288 1.464 1.056 1.824 1.416.84-1.32 1.512-3.024 2.064-4.944h1.08v3.096c.024 1.776-.576 5.928-3.576 9v-1.272h-8.088v-1.944c.456.336 1.296 1.008 1.608 1.392 1.032-1.2 1.92-2.664 2.688-4.296.864 1.056 1.56 2.064 2.04 2.928l1.416-1.656c-.552-.984-1.488-2.184-2.568-3.408.672-1.776 1.2-3.696 1.608-5.712l-2.04-.336a34 34 0 0 1-1.128 4.344 56 56 0 0 0-2.448-2.376l-1.176 1.296v-3.816h7.92v-2.064H74v19.464h2.112v-1.728h7.2c-.408.336-.84.648-1.32.936.408.408 1.032 1.368 1.296 1.824 3.72-2.304 5.256-6.456 5.568-8.496.312 1.968 1.656 6.312 4.944 8.496.336-.528.984-1.44 1.392-1.92-4.392-2.928-5.232-8.568-5.232-10.656z"
}, null, -1), H81 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), D81 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.686l-.517 1.593h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.985-.517 1.584 1.364-.976 1.365.976-.517-1.584 1.355-.985h-1.632l-.526-1.584zm4.718 6.019-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.331-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.985.517 1.584-1.355-.976-1.365.976.517-1.584-1.346-.985h1.676l.527-1.584zm-4.763 6.019 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), $81 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), U81 = [
  R81,
  H81,
  D81,
  $81
];
function j81(t, e) {
  return T(), N("svg", V81, [...U81]);
}
const G81 = { render: j81 }, W81 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, Y81 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "m22.992 32.693.858-4.62q3.135.033 5.049-.165 1.947-.231 2.937-.825 1.023-.627 1.32-1.749.33-1.155.231-2.937l-.726-14.553h4.62l.726 14.784q.099 1.98.462 3.036t1.089 1.485q.726.396 1.914.396 1.221 0 1.749.66.561.627.561 1.584 0 1.023-.693 1.716-.693.66-1.947.66-1.452 0-2.607-.363a4.06 4.06 0 0 1-1.914-1.254q-.759-.924-1.023-2.475h1.485q-.759 1.617-2.079 2.574-1.287.957-3.102 1.386-1.782.462-4.026.561a69 69 0 0 1-4.884.099m-1.584-7.821-.858-3.267q1.155-.297 1.881-.528.759-.231 1.122-.462t.363-.462q0-.297-.297-.627t-.66-.759a6 6 0 0 1-.66-.957 2.45 2.45 0 0 1-.297-1.221q0-.825.462-1.551.462-.759 1.485-1.452 1.056-.726 2.772-1.419l1.419 2.937q-1.386.561-1.881.99-.462.396-.462.759 0 .297.297.693t.66.891q.396.462.693 1.056.297.561.297 1.221 0 .528-.231 1.089-.198.561-.858 1.089-.627.528-1.881 1.023t-3.366.957m1.584 7.821q-3.564 0-6.039-.561-2.442-.528-3.993-1.518-1.518-1.023-2.211-2.376t-.693-2.97q0-1.056.165-2.112.198-1.089.462-2.112.297-1.023.528-1.848l4.125.957a88 88 0 0 1-.297 1.287q-.165.693-.264 1.353a7.5 7.5 0 0 0-.099 1.155q0 1.221.858 2.178.891.924 2.904 1.452 2.013.495 5.412.495l.66 3.564z"
}, null, -1), X81 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "m41.13 32.165.33-4.62q1.98 0 3.036-.198t1.452-.726q.429-.561.429-1.584 0-.924-.264-2.211a27 27 0 0 0-.627-2.673 27 27 0 0 0-.792-2.541l4.554-1.254q.428 1.122.825 2.607t.66 3.069q.264 1.551.264 3.003 0 2.244-.726 3.663a5.2 5.2 0 0 1-2.046 2.145q-1.287.759-3.102 1.056-1.815.264-3.993.264m8.15 7.656a2.25 2.25 0 0 1-1.65-.693 2.16 2.16 0 0 1-.66-1.584q0-.957.66-1.65a2.25 2.25 0 0 1 1.65-.693q.925 0 1.585.693t.66 1.65a2.16 2.16 0 0 1-.66 1.584q-.66.693-1.584.693m-5.708 0a2.25 2.25 0 0 1-1.65-.693 2.16 2.16 0 0 1-.66-1.584q0-.957.66-1.65a2.25 2.25 0 0 1 1.65-.693q.924 0 1.584.693t.66 1.65a2.16 2.16 0 0 1-.66 1.584q-.66.693-1.584.693M55.63 32l-.694-24.156h4.62L60.25 32zm-.199 10.197-.56-2.31q1.155-.198 1.715-.33.594-.132 1.254-.297l-.33.825q-.858-.297-1.65-1.188a2.9 2.9 0 0 1-.759-1.98q0-1.188.528-1.914a3.04 3.04 0 0 1 1.353-1.056q.825-.33 1.716-.33.495 0 .924.066.462.066.825.198l-.264 2.376-.66-.132a3.7 3.7 0 0 0-.726-.066q-.429 0-.792.264-.33.297-.33.693 0 .561.396.99t.924.66q.561.264.924.297l-1.815.198a26 26 0 0 0 1.683-.495 20 20 0 0 0 1.485-.495l.66 2.211q-.825.297-1.947.627a31 31 0 0 1-2.277.66q-1.155.297-2.277.528"
}, null, -1), K81 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M71 0h66v44H71z"
}, null, -1), Z81 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m101.745 7.15 1.393 1.018-.531 1.659L104 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L104 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.018h-1.723l-.532-1.66-.532 1.66h-1.723l1.393 1.017-.531 1.65L104 37.482zM89.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.027.531 1.65-1.393-1.027zm8.516-11.367-.532-1.65 1.393-1.008H97.41l-.532-1.65-.531 1.65h-1.724l1.394 1.017-.532 1.65 1.394-1.017zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.403-1.027-1.402 1.027.532-1.65-1.394-1.027zm0 14.337h-1.779l1.394 1.026-.532 1.65 1.403-1.017 1.402 1.018-.532-1.65 1.394-1.027h-1.678l-.54-1.65zm4.849 6.27-1.394-1.008h1.724l.531-1.65.532 1.65h1.723l-1.393 1.008.532 1.65-1.394-1.018-1.393 1.018zm23.622-10.761-.531-1.65 1.393-1.027h-1.687l-.531-1.65-.532 1.65h-1.787l1.402 1.027-.532 1.65 1.412-1.027zm-9.377-14.08-1.393-1.01h1.723l.532-1.65.531 1.65h1.724l-1.394 1.01.532 1.65-1.393-1.01-1.394 1.018.532-1.65zm6.041 2.575-.541 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.577 15.996h1.678L117.2 29.68l.532 1.65-1.394-1.017-1.402 1.018.532-1.65-1.385-1.027h1.724l.541-1.65zm-4.895 6.27 1.394-1.008h-1.724l-.531-1.65-.532 1.65h-1.723l1.393 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), J81 = [
  Y81,
  X81,
  K81,
  Z81
];
function Q81(t, e) {
  return T(), N("svg", W81, [...J81]);
}
const es1 = { render: Q81 }, ts1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, ns1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 42V5.994h26.697v6.091H91.271v7.982h18.076v6.067H91.271v9.8h20.115V42zm62.631-11.003q-1.62 5.895-5.391 8.756t-9.566 2.862q-7.172 0-11.789-4.9-4.618-4.9-4.617-13.398 0-8.99 4.641-13.963 4.642-4.974 12.206-4.973 6.608-.001 10.734 3.904 2.455 2.31 3.684 6.632l-7.196 1.719q-.64-2.8-2.665-4.421-2.027-1.62-4.925-1.62-4.003 0-6.496 2.873t-2.493 9.308q0 6.829 2.456 9.726T131.6 36.4q2.897 0 4.986-1.843t2.996-5.796z"></path></g>', 1), is1 = [
  ns1
];
function ss1(t, e) {
  return T(), N("svg", ts1, [...is1]);
}
const ls1 = { render: ss1 }, rs1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, as1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), os1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), cs1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M76.3 5.072h6.65v17.834q0 4.245.246 5.503.427 2.021 2.022 3.257 1.617 1.213 4.402 1.213 2.83 0 4.268-1.146 1.437-1.168 1.73-2.852.291-1.684.291-5.593V5.072h6.649v17.295q0 5.93-.539 8.378-.54 2.448-1.999 4.133-1.439 1.684-3.864 2.695-2.425.99-6.334.989-4.716 0-7.165-1.079-2.426-1.1-3.84-2.83-1.415-1.752-1.865-3.66-.651-2.831-.651-8.356zM109.588 38V5.072h24.415v5.57h-17.767v7.3h16.532v5.548h-16.532v8.962h18.396V38z"
}, null, -1), hs1 = [
  as1,
  os1,
  cs1
];
function us1(t, e) {
  return T(), N("svg", rs1, [...hs1]);
}
const ds1 = { render: us1 }, fs1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "48",
  viewBox: "0 0 146 48"
}, vs1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 42V6h26.585v6.09H91.24v7.98h18v6.067h-18v9.798h20.03V42zm32.592-36h7.242v19.526q0 4.648.269 6.026.465 2.212 2.214 3.552 1.75 1.34 4.783 1.34 3.084.002 4.649-1.266 1.565-1.266 1.884-3.11.318-1.845.318-6.124V6h7.242v18.936q0 6.492-.587 9.173-.588 2.68-2.166 4.525c-1.05 1.23-2.46 2.208-4.22 2.938q-2.642 1.095-6.9 1.095-5.138 0-7.792-1.193t-4.196-3.099q-1.54-1.905-2.031-3.996-.71-3.099-.71-9.148z"></path></g>', 1), ps1 = [
  vs1
];
function ms1(t, e) {
  return T(), N("svg", fs1, [...ps1]);
}
const gs1 = { render: ms1 }, ys1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "48",
  viewBox: "0 0 146 48"
}, _s1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 42V6h26.585v6.09H91.24v7.98h18v6.067h-18v9.798h20.03V42zm32.592-36h7.242v19.526q0 4.648.269 6.026.465 2.212 2.214 3.552 1.75 1.34 4.783 1.34 3.084.002 4.649-1.266 1.565-1.266 1.884-3.11.318-1.845.318-6.124V6h7.242v18.936q0 6.492-.587 9.173-.588 2.68-2.166 4.525c-1.05 1.23-2.46 2.208-4.22 2.938q-2.642 1.095-6.9 1.095-5.138 0-7.792-1.193t-4.196-3.099q-1.54-1.905-2.031-3.996-.71-3.099-.71-9.148z"></path></g>', 1), qs1 = [
  _s1
];
function ws1(t, e) {
  return T(), N("svg", ys1, [...qs1]);
}
const zs1 = { render: ws1 }, Ms1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, bs1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 42V6h26.585v6.09H91.24v7.98h18v6.067h-18v9.798h20.03V42zm32.592-36h7.242v19.526q0 4.648.269 6.026.465 2.212 2.214 3.552 1.75 1.34 4.783 1.34 3.084.002 4.649-1.266 1.565-1.266 1.884-3.11.318-1.845.318-6.124V6h7.242v18.936q0 6.492-.587 9.173-.588 2.68-2.166 4.525c-1.05 1.23-2.46 2.208-4.22 2.938q-2.642 1.095-6.9 1.095-5.138 0-7.792-1.193t-4.196-3.099q-1.54-1.905-2.031-3.996-.71-3.099-.71-9.148z"></path></g>', 1), Ls1 = [
  bs1
];
function xs1(t, e) {
  return T(), N("svg", Ms1, [...Ls1]);
}
const Ss1 = { render: xs1 }, Cs1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "48",
  viewBox: "0 0 146 48"
}, ks1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 42V5.994h26.697v6.091H91.271v7.982h18.076v6.067H91.271v9.8h20.115V42zm34.052-36.006V42h27.386v-6.067h-20.115v-9.8H143.4v-6.066h-18.076v-7.982h19.427v-6.09z"></path></g>', 1), Es1 = [
  ks1
];
function As1(t, e) {
  return T(), N("svg", Cs1, [...Es1]);
}
const Fs1 = { render: As1 }, Ts1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "48",
  viewBox: "0 0 146 48"
}, Is1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 42V6h26.585v6.09H91.24v7.98h18v6.067h-18v9.798h20.03V42zm32.592-36h7.242v19.526q0 4.648.269 6.026.465 2.212 2.214 3.552 1.75 1.34 4.783 1.34 3.084.002 4.649-1.266 1.565-1.266 1.884-3.11.318-1.845.318-6.124V6h7.242v18.936q0 6.492-.587 9.173-.588 2.68-2.166 4.525c-1.05 1.23-2.46 2.208-4.22 2.938q-2.642 1.095-6.9 1.095-5.138 0-7.792-1.193t-4.196-3.099q-1.54-1.905-2.031-3.996-.71-3.099-.71-9.148z"></path></g>', 1), Os1 = [
  Is1
];
function Ns1(t, e) {
  return T(), N("svg", Ts1, [...Os1]);
}
const Ps1 = { render: Ns1 }, Bs1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, Vs1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M83.997 5.994h7.27v19.501q0 4.642.27 6.018.466 2.21 2.223 3.548 1.755 1.34 4.8 1.34 3.097 0 4.668-1.266 1.571-1.265 1.89-3.107.32-1.842.32-6.115V5.994h7.27v18.912q0 6.483-.59 9.161-.589 2.676-2.173 4.52c-1.055 1.227-2.47 2.205-4.236 2.934q-2.653 1.093-6.927 1.093-5.157 0-7.822-1.19-2.665-1.193-4.212-3.096t-2.04-3.99q-.711-3.096-.711-9.137zM119.365 42V5.994h26.697v6.091h-19.426v7.982h18.076v6.067h-18.076v9.8h20.115V42z"></path></g>', 1), Rs1 = [
  Vs1
];
function Hs1(t, e) {
  return T(), N("svg", Bs1, [...Rs1]);
}
const Ds1 = { render: Hs1 }, $s1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "144",
  height: "48",
  viewBox: "0 0 144 48"
}, Us1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M84 42V5.994h26.697v6.09H91.271v7.983h18.076v6.067H91.271v9.8h20.115V42zm34.25 0V6.289h7.27v29.645h18.076V42z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), js1 = [
  Us1
];
function Gs1(t, e) {
  return T(), N("svg", $s1, [...js1]);
}
const Ws1 = { render: Gs1 }, Ys1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "48",
  viewBox: "0 0 146 48"
}, Xs1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g><path fill="#515560" d="M84 42V6h26.585v6.09H91.24v7.98h18v6.067h-18v9.798h20.03V42zm32.592-36h7.242v19.526q0 4.648.269 6.026.465 2.212 2.214 3.552 1.75 1.34 4.783 1.34 3.084.002 4.649-1.266 1.565-1.266 1.884-3.11.318-1.845.318-6.124V6h7.242v18.936q0 6.492-.587 9.173-.588 2.68-2.166 4.525c-1.05 1.23-2.46 2.208-4.22 2.938q-2.642 1.095-6.9 1.095-5.138 0-7.792-1.193t-4.196-3.099q-1.54-1.905-2.031-3.996-.71-3.099-.71-9.148z"></path></g>', 1), Ks1 = [
  Xs1
];
function Zs1(t, e) {
  return T(), N("svg", Ys1, [...Ks1]);
}
const Js1 = { render: Zs1 }, Qs1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, el1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M83.997 5.994h7.27v19.501q0 4.642.27 6.018.466 2.21 2.223 3.548 1.755 1.34 4.8 1.34 3.097 0 4.668-1.266 1.571-1.265 1.89-3.107.32-1.842.32-6.115V5.994h7.27v18.912q0 6.483-.59 9.161-.589 2.676-2.173 4.52c-1.055 1.227-2.47 2.205-4.236 2.934q-2.653 1.093-6.927 1.093-5.157 0-7.822-1.19-2.665-1.193-4.212-3.096t-2.04-3.99q-.711-3.096-.711-9.137zM119.365 42V5.994h26.697v6.091h-19.426v7.982h18.076v6.067h-18.076v9.8h20.115V42z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), tl1 = [
  el1
];
function nl1(t, e) {
  return T(), N("svg", Qs1, [...tl1]);
}
const il1 = { render: nl1 }, sl1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "149",
  height: "48",
  viewBox: "0 0 149 48"
}, ll1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="m103.13 27.755-4.961-13.361-4.863 13.36zM116.516 42h-7.91l-3.143-8.18H91.07L88.099 42h-7.712L94.41 5.994h7.688zm4.358-36.006V42h27.386v-6.066h-20.115v-9.8h18.076v-6.066h-18.076v-7.982h19.427v-6.09z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), rl1 = [
  ll1
];
function al1(t, e) {
  return T(), N("svg", sl1, [...rl1]);
}
const ol1 = { render: al1 }, cl1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, hl1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  "fill-rule": "evenodd",
  d: "M0 38.234V5.154h24.475v5.595H6.665v7.334h16.572v5.574H6.666v9.004h18.44v5.573zM30.006 5.153h6.667v17.943q0 4.27.248 5.537.428 2.033 2.039 3.264 1.609 1.233 4.403 1.232 2.838 0 4.28-1.164 1.44-1.163 1.734-2.858.292-1.694.292-5.627V5.153h6.668v17.4q0 5.965-.54 8.43-.541 2.462-1.994 4.158-1.453 1.695-3.885 2.7t-6.353 1.006q-4.73 0-7.173-1.096-2.445-1.096-3.863-2.848-1.42-1.75-1.87-3.672-.654-2.847-.653-8.406z",
  "clip-rule": "evenodd"
}, null, -1), ul1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M64.337 0h66v44h-66z"
}, null, -1), dl1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m95.082 7.15 1.393 1.018-.531 1.659L97.337 8.8l1.393 1.027-.532-1.66 1.394-1.017h-1.724l-.531-1.65-.532 1.65zM98.73 38.5l-.532-1.65 1.394-1.018h-1.724l-.531-1.66-.532 1.66h-1.723l1.393 1.017-.531 1.65 1.393-1.017zM83.092 23.1l-1.394 1.027.532-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.027.531 1.65-1.393-1.027zm8.516-11.367-.532-1.65 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.017-.532 1.65 1.393-1.017zm-7.105 2.585.532-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.403-1.027-1.402 1.027.531-1.65-1.393-1.027zm0 14.337h-1.778l1.394 1.026-.532 1.65 1.402-1.017 1.403 1.018-.532-1.65 1.394-1.027h-1.678l-.54-1.65zm4.85 6.27-1.394-1.008h1.724l.531-1.65.532 1.65h1.723l-1.393 1.008.532 1.65-1.394-1.018-1.393 1.018zm23.622-10.761-.531-1.65 1.393-1.027h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.027-.532 1.65 1.412-1.027zm-9.377-14.08-1.394-1.01h1.724l.531-1.65.532 1.65h1.723l-1.393 1.01.532 1.65-1.394-1.01-1.393 1.018.532-1.65zm6.041 2.575-.541 1.65-1.678.01 1.384 1.026-.531 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.577 15.996h1.678l-1.357 1.026.532 1.65-1.394-1.017-1.402 1.018.531-1.65-1.384-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.393-1.018 1.394 1.018z",
  "clip-rule": "evenodd"
}, null, -1), fl1 = [
  hl1,
  ul1,
  dl1
];
function vl1(t, e) {
  return T(), N("svg", cl1, [...fl1]);
}
const pl1 = { render: vl1 }, ml1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "48",
  viewBox: "0 0 146 48"
}, gl1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M84 42V6h26.585v6.09H91.24v7.98h18v6.067h-18v9.798h20.03V42zm32.592-36h7.242v19.526q0 4.648.269 6.026.465 2.212 2.214 3.552 1.75 1.34 4.783 1.34 3.084.002 4.649-1.266 1.565-1.266 1.884-3.11.318-1.845.318-6.124V6h7.242v18.936q0 6.492-.587 9.173-.588 2.68-2.166 4.525c-1.05 1.23-2.46 2.208-4.22 2.938q-2.642 1.095-6.9 1.095-5.138 0-7.792-1.193t-4.196-3.099q-1.54-1.905-2.031-3.996-.71-3.099-.71-9.148z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), yl1 = [
  gl1
];
function _l1(t, e) {
  return T(), N("svg", ml1, [...yl1]);
}
const ql1 = { render: _l1 }, wl1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "48",
  viewBox: "0 0 146 48"
}, zl1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M84 42V6h26.585v6.09H91.24v7.98h18v6.067h-18v9.798h20.03V42zm32.592-36h7.242v19.526q0 4.648.269 6.026.465 2.212 2.214 3.552 1.75 1.34 4.783 1.34 3.084.002 4.649-1.266 1.565-1.266 1.884-3.11.318-1.845.318-6.124V6h7.242v18.936q0 6.492-.587 9.173-.588 2.68-2.166 4.525c-1.05 1.23-2.46 2.208-4.22 2.938q-2.642 1.095-6.9 1.095-5.138 0-7.792-1.193t-4.196-3.099q-1.54-1.905-2.031-3.996-.71-3.099-.71-9.148z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), Ml1 = [
  zl1
];
function bl1(t, e) {
  return T(), N("svg", wl1, [...Ml1]);
}
const Ll1 = { render: bl1 }, xl1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "138",
  height: "44",
  fill: "none",
  viewBox: "0 0 138 44"
}, Sl1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), Cl1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), kl1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M75.328 34V11.094h16.984v3.875H79.954v5.078h11.5v3.86h-11.5v6.234H92.75V34zM95.5 26.547l4.5-.438q.406 2.266 1.641 3.328Q102.891 30.5 105 30.5q2.234 0 3.359-.937 1.141-.953 1.141-2.22 0-.811-.484-1.374-.47-.579-1.657-1-.812-.282-3.703-1-3.719-.922-5.219-2.266-2.109-1.89-2.109-4.61 0-1.749.984-3.265 1-1.53 2.86-2.328 1.875-.797 4.516-.797 4.312 0 6.484 1.89 2.187 1.892 2.297 5.048l-4.625.203q-.297-1.766-1.282-2.532-.968-.78-2.921-.78-2.016 0-3.157.827-.734.532-.734 1.422 0 .814.688 1.39.875.734 4.25 1.532 3.375.797 4.984 1.656 1.625.845 2.531 2.328.922 1.47.922 3.641 0 1.97-1.094 3.688t-3.093 2.562q-2 .828-4.985.828-4.344 0-6.672-2-2.328-2.015-2.781-5.86m22.531-15.452h9.157q2.718 0 4.046.234a5.8 5.8 0 0 1 2.391.938q1.062.719 1.766 1.922.702 1.187.703 2.671a5.3 5.3 0 0 1-.875 2.953 5.3 5.3 0 0 1-2.344 2.016q2.094.61 3.219 2.078 1.125 1.47 1.125 3.453 0 1.563-.735 3.047-.718 1.47-1.984 2.36-1.25.874-3.094 1.078-1.156.124-5.578.156h-7.797zm4.625 3.812v5.297h3.032q2.703 0 3.359-.078 1.188-.141 1.859-.812.688-.688.688-1.797 0-1.063-.594-1.72-.578-.67-1.734-.812-.688-.078-3.954-.078zm0 9.11v6.125h4.282q2.499 0 3.171-.141 1.032-.187 1.672-.906.657-.734.657-1.953 0-1.032-.5-1.75-.5-.72-1.454-1.047-.937-.328-4.093-.328z"
}, null, -1), El1 = [
  Sl1,
  Cl1,
  kl1
];
function Al1(t, e) {
  return T(), N("svg", xl1, [...El1]);
}
const Fl1 = { render: Al1 }, Tl1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, Il1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M83.997 5.994h7.27v19.501q0 4.642.27 6.018.466 2.21 2.223 3.548 1.755 1.34 4.8 1.34 3.097 0 4.668-1.266 1.571-1.265 1.89-3.107.32-1.842.32-6.115V5.994h7.27v18.912q0 6.483-.59 9.161-.589 2.676-2.173 4.52c-1.055 1.227-2.47 2.205-4.236 2.934q-2.653 1.093-6.927 1.093-5.157 0-7.822-1.19-2.665-1.193-4.212-3.096t-2.04-3.99q-.711-3.096-.711-9.137zM119.365 42V5.994h26.697v6.091h-19.426v7.982h18.076v6.067h-18.076v9.8h20.115V42z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), Ol1 = [
  Il1
];
function Nl1(t, e) {
  return T(), N("svg", Tl1, [...Ol1]);
}
const Pl1 = { render: Nl1 }, Bl1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, Vl1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M78 38.152V6h23.84v5.439H84.492v7.128h16.141v5.417H84.492v8.75h17.962v5.418zM107.915 6h6.491v17.414q0 4.145.242 5.373.416 1.974 1.974 3.18 1.578 1.185 4.298 1.184 2.763 0 4.167-1.118 1.404-1.14 1.689-2.786.285-1.644.285-5.46V6h6.492v16.887q0 5.79-.527 8.18-.526 2.391-1.952 4.036-1.403 1.645-3.772 2.632-2.368.965-6.184.965-4.606 0-6.997-1.053-2.368-1.074-3.75-2.763-1.382-1.71-1.82-3.575-.636-2.764-.636-8.158z"
}, null, -1), Rl1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), Hl1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), Dl1 = [
  Vl1,
  Rl1,
  Hl1
];
function $l1(t, e) {
  return T(), N("svg", Bl1, [...Dl1]);
}
const Ul1 = { render: $l1 }, jl1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, Gl1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M78 38.107V5h24.548v5.6H84.685v7.34h16.621v5.578H84.685v9.01h18.495v5.579zM108.803 5h6.685v17.93q0 4.269.248 5.534.43 2.032 2.033 3.274 1.626 1.22 4.426 1.22 2.845 0 4.291-1.152 1.445-1.175 1.739-2.868.293-1.695.293-5.623V5h6.685v17.389q0 5.961-.542 8.423-.543 2.462-2.01 4.156-1.446 1.693-3.884 2.71-2.439.993-6.369.993-4.742 0-7.204-1.084-2.439-1.106-3.861-2.845-1.424-1.761-1.875-3.681-.655-2.846-.655-8.401z"
}, null, -1), Wl1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), Yl1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), Xl1 = [
  Gl1,
  Wl1,
  Yl1
];
function Kl1(t, e) {
  return T(), N("svg", jl1, [...Xl1]);
}
const Zl1 = { render: Kl1 }, Jl1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "145",
  height: "48",
  viewBox: "0 0 145 48"
}, Ql1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M84 42V5.994h26.697v6.09H91.271v7.983h18.076v6.067H91.271v9.8h20.115V42zm30.953-11.715 7.073-.689q.639 3.563 2.592 5.232t5.268 1.67q3.511 0 5.293-1.485 1.78-1.487 1.781-3.476 0-1.276-.75-2.174-.748-.897-2.615-1.558-1.278-.444-5.822-1.573-5.844-1.45-8.203-3.561-3.315-2.972-3.315-7.245 0-2.753 1.56-5.145 1.56-2.397 4.494-3.649 2.936-1.251 7.085-1.251 6.78 0 10.205 2.97 3.427 2.973 3.6 7.934l-7.27.32q-.468-2.775-2.003-3.992-1.535-1.215-4.605-1.215-3.168 0-4.96 1.302-1.155.834-1.155 2.234 0 1.277 1.08 2.186 1.376 1.154 6.681 2.407 5.304 1.252 7.846 2.59 2.543 1.34 3.98 3.66 1.436 2.323 1.436 5.735 0 3.096-1.719 5.797-1.719 2.703-4.863 4.016t-7.835 1.313q-6.827 0-10.487-3.155-3.66-3.156-4.372-9.198"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), er1 = [
  Ql1
];
function tr1(t, e) {
  return T(), N("svg", Jl1, [...er1]);
}
const nr1 = { render: tr1 }, ir1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "145",
  height: "48",
  viewBox: "0 0 145 48"
}, sr1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M84 42V5.994h26.697v6.09H91.271v7.983h18.076v6.067H91.271v9.8h20.115V42zm30.953-11.715 7.073-.689q.639 3.563 2.592 5.232t5.268 1.67q3.511 0 5.293-1.485 1.78-1.487 1.781-3.476 0-1.276-.75-2.174-.748-.897-2.615-1.558-1.278-.444-5.822-1.573-5.844-1.45-8.203-3.561-3.315-2.972-3.315-7.245 0-2.753 1.56-5.145 1.56-2.397 4.494-3.649 2.936-1.251 7.085-1.251 6.78 0 10.205 2.97 3.427 2.973 3.6 7.934l-7.27.32q-.468-2.775-2.003-3.992-1.535-1.215-4.605-1.215-3.168 0-4.96 1.302-1.155.834-1.155 2.234 0 1.277 1.08 2.186 1.376 1.154 6.681 2.407 5.304 1.252 7.846 2.59 2.543 1.34 3.98 3.66 1.436 2.323 1.436 5.735 0 3.096-1.719 5.797-1.719 2.703-4.863 4.016t-7.835 1.313q-6.827 0-10.487-3.155-3.66-3.156-4.372-9.198"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), lr1 = [
  sr1
];
function rr1(t, e) {
  return T(), N("svg", ir1, [...lr1]);
}
const ar1 = { render: rr1 }, or1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, cr1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M83.997 5.994h7.27v19.501q0 4.642.27 6.018.466 2.21 2.223 3.548 1.755 1.34 4.8 1.34 3.097 0 4.668-1.266 1.571-1.265 1.89-3.107.32-1.842.32-6.115V5.994h7.27v18.912q0 6.483-.59 9.161-.589 2.676-2.173 4.52c-1.055 1.227-2.47 2.205-4.236 2.934q-2.653 1.093-6.927 1.093-5.157 0-7.822-1.19-2.665-1.193-4.212-3.096t-2.04-3.99q-.711-3.096-.711-9.137zM119.365 42V5.994h26.697v6.091h-19.426v7.982h18.076v6.067h-18.076v9.8h20.115V42z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), hr1 = [
  cr1
];
function ur1(t, e) {
  return T(), N("svg", or1, [...hr1]);
}
const dr1 = { render: ur1 }, fr1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "48",
  viewBox: "0 0 146 48"
}, vr1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M84 42V6h26.585v6.09H91.24v7.98h18v6.067h-18v9.798h20.03V42zm32.592-36h7.242v19.526q0 4.648.269 6.026.465 2.212 2.214 3.552 1.75 1.34 4.783 1.34 3.084.002 4.649-1.266 1.565-1.266 1.884-3.11.318-1.845.318-6.124V6h7.242v18.936q0 6.492-.587 9.173-.588 2.68-2.166 4.525c-1.05 1.23-2.46 2.208-4.22 2.938q-2.642 1.095-6.9 1.095-5.138 0-7.792-1.193t-4.196-3.099q-1.54-1.905-2.031-3.996-.71-3.099-.71-9.148z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), pr1 = [
  vr1
];
function mr1(t, e) {
  return T(), N("svg", fr1, [...pr1]);
}
const gr1 = { render: mr1 }, yr1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, _r1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), qr1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), wr1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M76.348 38V5.072h24.415v5.57H82.996v7.3h16.531v5.548h-16.53v8.962h18.395V38zm30.636-32.928h6.649v17.834q0 4.245.247 5.503.426 2.021 2.021 3.257 1.617 1.213 4.403 1.213 2.83 0 4.267-1.146 1.438-1.168 1.73-2.852.291-1.684.292-5.593V5.072h6.648v17.295q0 5.93-.539 8.378t-1.999 4.133q-1.437 1.684-3.863 2.695-2.426.99-6.334.989-4.717 0-7.165-1.079-2.426-1.1-3.841-2.83-1.415-1.752-1.864-3.66-.652-2.831-.652-8.356z"
}, null, -1), zr1 = [
  _r1,
  qr1,
  wr1
];
function Mr1(t, e) {
  return T(), N("svg", yr1, [...zr1]);
}
const br1 = { render: Mr1 }, Lr1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, xr1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M83.997 5.994h7.27v19.501q0 4.642.27 6.018.466 2.21 2.223 3.548 1.755 1.34 4.8 1.34 3.097 0 4.668-1.266 1.571-1.265 1.89-3.107.32-1.842.32-6.115V5.994h7.27v18.912q0 6.483-.59 9.161-.589 2.676-2.173 4.52c-1.055 1.227-2.47 2.205-4.236 2.934q-2.653 1.093-6.927 1.093-5.157 0-7.822-1.19-2.665-1.193-4.212-3.096t-2.04-3.99q-.711-3.096-.711-9.137zM119.365 42V5.994h26.697v6.091h-19.426v7.982h18.076v6.067h-18.076v9.8h20.115V42z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), Sr1 = [
  xr1
];
function Cr1(t, e) {
  return T(), N("svg", Lr1, [...Sr1]);
}
const kr1 = { render: Cr1 }, Er1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, Ar1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M83.997 5.994h7.27v19.501q0 4.642.27 6.018.466 2.21 2.223 3.548 1.755 1.34 4.8 1.34 3.097 0 4.668-1.266 1.571-1.265 1.89-3.107.32-1.842.32-6.115V5.994h7.27v18.912q0 6.483-.59 9.161-.589 2.676-2.173 4.52c-1.055 1.227-2.47 2.205-4.236 2.934q-2.653 1.093-6.927 1.093-5.157 0-7.822-1.19-2.665-1.193-4.212-3.096t-2.04-3.99q-.711-3.096-.711-9.137zM119.365 42V5.994h26.697v6.091h-19.426v7.982h18.076v6.067h-18.076v9.8h20.115V42z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), Fr1 = [
  Ar1
];
function Tr1(t, e) {
  return T(), N("svg", Er1, [...Fr1]);
}
const Ir1 = { render: Tr1 }, Or1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "147",
  height: "48",
  viewBox: "0 0 147 48"
}, Nr1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M83.997 5.994h7.27v19.501q0 4.642.27 6.018.466 2.21 2.223 3.548 1.755 1.34 4.8 1.34 3.097 0 4.668-1.266 1.571-1.265 1.89-3.107.32-1.842.32-6.115V5.994h7.27v18.912q0 6.483-.59 9.161-.589 2.676-2.173 4.52c-1.055 1.227-2.47 2.205-4.236 2.934q-2.653 1.093-6.927 1.093-5.157 0-7.822-1.19-2.665-1.193-4.212-3.096t-2.04-3.99q-.711-3.096-.711-9.137zM119.365 42V5.994h26.697v6.091h-19.426v7.982h18.076v6.067h-18.076v9.8h20.115V42z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), Pr1 = [
  Nr1
];
function Br1(t, e) {
  return T(), N("svg", Or1, [...Pr1]);
}
const Vr1 = { render: Br1 }, Rr1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, Hr1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M78 38.16V6.54h23.447v5.349H84.385v7.01h15.875v5.328H84.385v8.606h17.665v5.328zm49.697-11.625 6.191 1.962q-1.424 5.177-4.746 7.7-3.3 2.503-8.39 2.503-6.299 0-10.354-4.292-4.055-4.314-4.055-11.778 0-7.895 4.077-12.251 4.076-4.38 10.72-4.379 5.802 0 9.426 3.43 2.157 2.027 3.235 5.824l-6.32 1.51q-.56-2.46-2.351-3.883-1.769-1.424-4.314-1.424-3.516 0-5.716 2.524-2.178 2.523-2.178 8.175 0 5.997 2.157 8.542t5.608 2.545q2.545 0 4.379-1.618 1.833-1.617 2.631-5.09"
}, null, -1), Dr1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), $r1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), Ur1 = [
  Hr1,
  Dr1,
  $r1
];
function jr1(t, e) {
  return T(), N("svg", Rr1, [...Ur1]);
}
const Gr1 = { render: jr1 }, Wr1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "146",
  height: "56",
  viewBox: "0 0 146 56"
}, Yr1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M84.045 46.003V9.997h26.697v6.09H91.316v7.983h18.076v6.067H91.316v9.8h20.115v6.066zm42.393-38.059L129.828.6h7.736l-6.754 7.344zm-9.897 2.063h7.269v19.501q0 4.642.27 6.018.466 2.21 2.223 3.548 1.756 1.34 4.802 1.339 3.094 0 4.667-1.265 1.571-1.265 1.89-3.107.32-1.842.32-6.115V10.007h7.269v18.912q0 6.483-.588 9.161-.592 2.676-2.174 4.519-1.585 1.842-4.237 2.935t-6.926 1.093q-5.159 0-7.823-1.191t-4.211-3.095-2.04-3.991q-.711-3.095-.711-9.136z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 4h72v48H0z"></path><path fill="#FC0" d="m35.06 12.91-1.52-1.11h1.88L36 10l.58 1.8h1.88l-1.52 1.11.58 1.81L36 13.6l-1.52 1.12zm1.88 31.29.58 1.8L36 44.89 34.48 46l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 27.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 15l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 19.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 22.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 38.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 41h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 30.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 15l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 15l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 19.62zM50 35.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 35.26h1.88l.59-1.8.58 1.8zM46.23 41l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), Xr1 = [
  Yr1
];
function Kr1(t, e) {
  return T(), N("svg", Wr1, [...Xr1]);
}
const Zr1 = { render: Kr1 }, Jr1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "145",
  height: "48",
  viewBox: "0 0 145 48"
}, Qr1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M83.807 42V6h26.585v6.09H91.048v7.98h18v6.067h-18v9.798h20.03V42zM116.4 6h7.241v19.526q0 4.648.27 6.026.463 2.212 2.214 3.552 1.749 1.34 4.782 1.34 3.083.002 4.65-1.266 1.563-1.266 1.883-3.11.318-1.845.318-6.124V6H145v18.936q0 6.492-.587 9.173t-2.165 4.525-4.22 2.938q-2.643 1.095-6.9 1.095-5.138 0-7.793-1.193-2.654-1.193-4.195-3.099-1.542-1.905-2.032-3.996-.71-3.099-.709-9.148z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), ea1 = [
  Qr1
];
function ta1(t, e) {
  return T(), N("svg", Jr1, [...ea1]);
}
const na1 = { render: ta1 }, ia1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "145",
  height: "48",
  viewBox: "0 0 145 48"
}, sa1 = /* @__PURE__ */ U1('<g fill="none" fill-rule="evenodd"><path fill="#515560" d="M83.807 42V6h26.585v6.09H91.048v7.98h18v6.067h-18v9.798h20.03V42zM116.4 6h7.241v19.526q0 4.648.27 6.026.463 2.212 2.214 3.552 1.749 1.34 4.782 1.34 3.083.002 4.65-1.266 1.563-1.266 1.883-3.11.318-1.845.318-6.124V6H145v18.936q0 6.492-.587 9.173t-2.165 4.525-4.22 2.938q-2.643 1.095-6.9 1.095-5.138 0-7.793-1.193-2.654-1.193-4.195-3.099-1.542-1.905-2.032-3.996-.71-3.099-.709-9.148z"></path><g fill-rule="nonzero"><path fill="#039" d="M0 0h72v48H0z"></path><path fill="#FC0" d="M35.06 8.91 33.54 7.8h1.88L36 6l.58 1.8h1.88l-1.52 1.11.58 1.81L36 9.6l-1.52 1.12zm1.88 31.29.58 1.8L36 40.89 34.48 42l.58-1.8-1.52-1.11h1.88l.58-1.81.58 1.81h1.88zm-16.48-15-1.52 1.12.58-1.8L18 23.44h1.88l.58-1.8.58 1.8h1.89l-1.53 1.12.58 1.8-1.52-1.12zM29.17 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8-1.52-1.11h1.88l.58-1.8.58 1.8h1.88zM22 15.62l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.12L21 18.54l.58-1.8-1.52-1.12zm-1.92 15.64H22l.58-1.8.59 1.8H25l-1.52 1.12.58 1.8-1.53-1.11L21 34.18l.58-1.8-1.52-1.12zm7.21 6.84L25.77 37h1.88l.58-1.8.58 1.8h1.88l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11zm25.19-13.54.58 1.8-1.52-1.12L50 26.36l.58-1.8-1.53-1.12H51l.58-1.8.58 1.8H54zM42.83 11l-1.52-1.1h1.88l.58-1.8.58 1.8h1.88L44.71 11l.58 1.8-1.52-1.1-1.52 1.11.58-1.8zm6 4.61.59-1.8.58 1.8h1.88l-1.48 1.13.58 1.8-1.52-1.12-1.53 1.12.58-1.8L47 15.62zM50 31.26h1.88l-1.48 1.12.58 1.8-1.52-1.11-1.53 1.11.58-1.8L47 31.26h1.88l.59-1.8.58 1.8zM46.23 37l-1.52 1.1.58 1.8-1.52-1.11-1.52 1.11.58-1.8-1.52-1.1h1.88l.58-1.8.58 1.8z"></path></g></g>', 1), la1 = [
  sa1
];
function ra1(t, e) {
  return T(), N("svg", ia1, [...la1]);
}
const aa1 = { render: ra1 }, oa1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, ca1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), ha1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.018h-1.723L33 34.172l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.482zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.027.531 1.65-1.393-1.027zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.017-.532 1.65 1.393-1.017zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm0 14.337h-1.779l1.394 1.026-.532 1.65 1.402-1.017 1.403 1.018-.532-1.65 1.394-1.027h-1.678l-.54-1.65zm4.849 6.27-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.761-.531-1.65 1.393-1.027h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.027-.532 1.65 1.412-1.027zm-9.377-14.08-1.394-1.01h1.724l.532-1.65.531 1.65h1.723l-1.393 1.01.532 1.65-1.393-1.01-1.394 1.018.532-1.65zm6.04 2.575-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.68l.532 1.65-1.394-1.017-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), ua1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  "fill-rule": "evenodd",
  d: "M78 38.081V5h24.475v5.596h-17.81v7.334h16.572v5.574H84.666v9.004h18.44v5.573zM108.006 5h6.667v17.943q0 4.27.248 5.537.428 2.033 2.039 3.264 1.61 1.232 4.403 1.232 2.838 0 4.28-1.164 1.44-1.163 1.734-2.858.293-1.694.293-5.627V5h6.667v17.4q0 5.965-.54 8.43-.542 2.462-1.994 4.158-1.453 1.695-3.885 2.7t-6.353 1.006q-4.73 0-7.173-1.096-2.445-1.095-3.863-2.848-1.419-1.75-1.87-3.672-.653-2.847-.653-8.406z",
  "clip-rule": "evenodd"
}, null, -1), da1 = [
  ca1,
  ha1,
  ua1
];
function fa1(t, e) {
  return T(), N("svg", oa1, [...da1]);
}
const va1 = { render: fa1 }, pa1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "138",
  height: "44",
  fill: "none",
  viewBox: "0 0 138 44"
}, ma1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), ga1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), ya1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M106.04 38h-7.232l-2.875-7.48H82.77L80.054 38H73L85.825 5.072h7.03zM93.799 24.973l-4.537-12.22-4.448 12.22zm15.812-19.901h13.162q3.909 0 5.818.337 1.932.315 3.436 1.348 1.529 1.034 2.538 2.763 1.011 1.707 1.011 3.84a7.6 7.6 0 0 1-1.258 4.246q-1.234 1.93-3.369 2.897 3.01.876 4.627 2.987t1.617 4.964q0 2.246-1.055 4.38-1.033 2.11-2.853 3.392-1.797 1.257-4.447 1.55-1.662.18-8.019.224h-11.208zm6.649 5.48v7.615h4.357q3.886 0 4.829-.112 1.707-.202 2.673-1.168.988-.99.988-2.583 0-1.527-.853-2.471-.831-.966-2.493-1.168-.988-.112-5.683-.112zm0 13.096v8.804h6.154q3.594 0 4.56-.202 1.482-.27 2.403-1.303.943-1.055.943-2.807 0-1.483-.718-2.516-.72-1.033-2.089-1.505-1.348-.471-5.885-.471z"
}, null, -1), _a1 = [
  ma1,
  ga1,
  ya1
];
function qa1(t, e) {
  return T(), N("svg", pa1, [..._a1]);
}
const wa1 = { render: qa1 }, za1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "138",
  height: "44",
  fill: "none",
  viewBox: "0 0 138 44"
}, Ma1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M94.674 19.74v5.306H84.75q.54 4.25 2.524 6.256 2.006 1.983 4.832 1.984 2.911 0 4.81-1.726 1.898-1.746 2.33-5.004l6.406 1.985q-1.1 4.724-4.444 7.441-3.343 2.718-8.692 2.718-5.48 0-8.65-2.588-3.15-2.59-4.508-5.975Q78 26.75 78 22.523q0-7.42 3.904-11.972T92.646 6q5.285 0 8.585 2.502 3.322 2.502 4.335 6.773l-6.32 1.445q-.69-2.48-2.545-3.84-1.855-1.358-4.228-1.358-3.409 0-5.392 2.351-1.963 2.33-2.33 5.867zm36.323 6.795 6.191 1.962q-1.423 5.177-4.746 7.7-3.3 2.503-8.39 2.503-6.298 0-10.354-4.292-4.055-4.314-4.055-11.778 0-7.895 4.077-12.251 4.077-4.38 10.72-4.379 5.802 0 9.426 3.43 2.157 2.027 3.236 5.824l-6.32 1.51q-.561-2.46-2.352-3.883-1.768-1.424-4.314-1.424-3.515 0-5.716 2.524-2.178 2.523-2.178 8.175 0 5.997 2.157 8.542t5.608 2.545q2.545 0 4.379-1.618 1.833-1.617 2.631-5.09"
}, null, -1), ba1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), La1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), xa1 = [
  Ma1,
  ba1,
  La1
];
function Sa1(t, e) {
  return T(), N("svg", za1, [...xa1]);
}
const Ca1 = { render: Sa1 }, ka1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, Ea1 = /* @__PURE__ */ C("path", {
  fill: "#515560",
  d: "M81.42 18.594c.938.9 1.906 1.89 2.814 2.91-.787 1.741-1.725 3.332-2.814 4.592zm17.492-2.01h2.149c-.242 1.68-.575 3.33-.939 4.59l2.603 1.501c.908-2.31 1.725-5.642 2.179-8.643l-2.451-.87-.545.18h-6.295c.363-1.56.636-3.181.878-4.832L92.859 8c-.514 4.682-1.634 9.333-3.57 12.184.816.51 2.3 1.741 2.904 2.371 1.03-1.62 1.877-3.661 2.573-5.972h.666v3.361c0 2.491-.848 7.323-4.298 10.924v-1.5H81.42v-2.341a20 20 0 0 1 2.088 1.86c1.15-1.29 2.179-2.88 3.057-4.681.938 1.17 1.725 2.28 2.239 3.24l2.24-2.67c-.666-1.17-1.756-2.55-3.027-3.961.787-2.161 1.392-4.442 1.877-6.843l-3.269-.54c-.303 1.62-.666 3.211-1.15 4.742a65 65 0 0 0-2.663-2.491l-1.392 1.53v-4.231h9.533V9.68H78v25.03h3.42v-2.041h7.566l-.545.36c.635.69 1.634 2.19 2.028 2.971 4.206-2.61 6.234-7.473 6.688-10.084.423 2.521 2.24 7.593 5.931 10.084.545-.9 1.574-2.34 2.179-3.121-5.145-3.511-6.355-9.964-6.355-12.935zm32.61-4.953v1.74h-5.144v-1.74zm-5.296 5.972c.091-.6.121-1.23.152-1.8h5.144v1.8zm5.296 2.461v1.38c0 .36-.121.481-.544.481-.394.03-1.725.06-2.936 0 .454.75 1.059 2.01 1.271 2.911 1.907 0 3.359-.06 4.388-.57 1.09-.48 1.392-1.26 1.392-2.791V8.87h-11.984v6.033c0 2.67-.302 5.852-3.178 8.072.697.42 1.998 1.62 2.512 2.251 1.786-1.38 2.754-3.241 3.299-5.162zm-13.951-7.953v2.161h-3.753v-2.16zm-3.753 6.933v-2.13h3.753v2.13zm0 2.76h7.021V9.32H110.55v13.956h3.268zm1.907 6.363h2.572v3.992h-2.572zm8.504 0v3.992h-2.633v-3.992zm5.901 0v3.992h-2.633v-3.992zm3.541 3.992v-6.753h-21.275v6.753h-3.541v3.06H137v-3.06z"
}, null, -1), Aa1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M0 0h66v44H0z"
}, null, -1), Fa1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.745 7.15 1.393 1.018-.531 1.659L33 8.8l1.393 1.027-.531-1.66 1.393-1.017h-1.723L33 5.5l-.532 1.65zm3.648 31.35-.531-1.65 1.393-1.017h-1.723L33 34.173l-.532 1.66h-1.723l1.393 1.017-.531 1.65L33 37.483zM18.755 23.1l-1.393 1.027.531-1.65-1.393-.99h1.723l.532-1.65.532 1.65h1.732l-1.402 1.026.531 1.65-1.393-1.026zm8.516-11.367-.532-1.65 1.393-1.008H26.41l-.531-1.65-.532 1.65h-1.724l1.394 1.018-.532 1.65 1.393-1.018zm-7.104 2.585.531-1.65.541 1.65h1.678l-1.394 1.027.532 1.65-1.402-1.027-1.403 1.027.532-1.65-1.394-1.027zm.531 12.687-.531 1.65h-1.779l1.394 1.027-.532 1.65 1.402-1.018 1.403 1.018-.532-1.65 1.394-1.027h-1.678zm4.318 7.92-1.393-1.008h1.723l.532-1.65.531 1.65h1.724l-1.394 1.008.532 1.65-1.393-1.018-1.394 1.018zm23.622-10.762-.531-1.65 1.393-1.026h-1.687l-.531-1.65-.532 1.65h-1.788l1.403 1.026-.532 1.65 1.412-1.026zm-9.377-14.08-1.394-1.008h1.724l.532-1.65.531 1.65h1.723l-1.393 1.008.532 1.65-1.393-1.008-1.394 1.018.532-1.65zm6.04 2.576-.54 1.65-1.678.01 1.385 1.026-.532 1.65 1.402-1.027 1.394 1.027-.532-1.65 1.357-1.036h-1.724zm.578 15.996h1.678L46.2 29.682l.532 1.65-1.394-1.018-1.402 1.018.532-1.65-1.385-1.027h1.724l.54-1.65zm-4.895 6.27 1.393-1.008h-1.723l-.532-1.65-.531 1.65h-1.724l1.394 1.008-.532 1.65 1.394-1.018 1.393 1.018z",
  "clip-rule": "evenodd"
}, null, -1), Ta1 = [
  Ea1,
  Aa1,
  Fa1
];
function Ia1(t, e) {
  return T(), N("svg", ka1, [...Ta1]);
}
const Oa1 = { render: Ia1 }, Na1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, Pa1 = /* @__PURE__ */ U1('<path fill="#fff" d="m23.992 32.693.858-4.62q3.135.033 5.049-.165 1.947-.231 2.937-.825 1.023-.627 1.32-1.749.33-1.155.231-2.937l-.726-14.553h4.62l.726 14.784q.099 1.98.462 3.036t1.089 1.485q.726.396 1.914.396 1.221 0 1.749.66.561.627.561 1.584 0 1.023-.693 1.716-.693.66-1.947.66-1.452 0-2.607-.363a4.06 4.06 0 0 1-1.914-1.254q-.759-.924-1.023-2.475h1.485q-.759 1.617-2.079 2.574-1.287.957-3.102 1.386-1.782.462-4.026.561a69 69 0 0 1-4.884.099m-1.584-7.821-.858-3.267q1.155-.297 1.881-.528.759-.231 1.122-.462t.363-.462q0-.297-.297-.627t-.66-.759a6 6 0 0 1-.66-.957 2.45 2.45 0 0 1-.297-1.221q0-.825.462-1.551.462-.759 1.485-1.452 1.056-.726 2.772-1.419l1.419 2.937q-1.386.561-1.881.99-.462.396-.462.759 0 .297.297.693t.66.891q.396.462.693 1.056.297.561.297 1.221 0 .528-.231 1.089-.198.561-.858 1.089-.627.528-1.881 1.023t-3.366.957m1.584 7.821q-3.564 0-6.039-.561-2.442-.528-3.993-1.518-1.518-1.023-2.211-2.376t-.693-2.97q0-1.056.165-2.112.198-1.089.462-2.112.297-1.023.528-1.848l4.125.957a88 88 0 0 1-.297 1.287q-.165.693-.264 1.353a7.5 7.5 0 0 0-.099 1.155q0 1.221.858 2.178.891.924 2.904 1.452 2.013.495 5.412.495l.66 3.564z"></path><path fill="#fff" d="m42.13 32.165.33-4.62q1.98 0 3.036-.198t1.452-.726q.429-.561.429-1.584 0-.924-.264-2.211a27 27 0 0 0-.627-2.673 27 27 0 0 0-.792-2.541l4.554-1.254q.428 1.122.825 2.607t.66 3.069q.264 1.551.264 3.003 0 2.244-.726 3.663a5.2 5.2 0 0 1-2.046 2.145q-1.287.759-3.102 1.056-1.815.264-3.993.264m8.15 7.656a2.25 2.25 0 0 1-1.65-.693 2.16 2.16 0 0 1-.66-1.584q0-.957.66-1.65a2.25 2.25 0 0 1 1.65-.693q.925 0 1.585.693t.66 1.65a2.16 2.16 0 0 1-.66 1.584q-.66.693-1.584.693m-5.708 0a2.25 2.25 0 0 1-1.65-.693 2.16 2.16 0 0 1-.66-1.584q0-.957.66-1.65a2.25 2.25 0 0 1 1.65-.693q.924 0 1.584.693t.66 1.65a2.16 2.16 0 0 1-.66 1.584q-.66.693-1.584.693M56.63 32l-.694-24.156h4.62L61.25 32zm-.199 10.197-.56-2.31q1.155-.198 1.715-.33.594-.132 1.254-.297l-.33.825q-.858-.297-1.65-1.188a2.9 2.9 0 0 1-.759-1.98q0-1.188.528-1.914a3.04 3.04 0 0 1 1.353-1.056q.825-.33 1.716-.33.495 0 .924.066.462.066.825.198l-.264 2.376-.66-.132a3.7 3.7 0 0 0-.726-.066q-.429 0-.792.264-.33.297-.33.693 0 .561.396.99t.924.66q.561.264.924.297l-1.815.198a26 26 0 0 0 1.683-.495 20 20 0 0 0 1.485-.495l.66 2.211q-.825.297-1.947.627a31 31 0 0 1-2.277.66q-1.155.297-2.277.528"></path><path fill="#039" d="M72.878.88h63.243v42.24H72.878z"></path><path fill="#FC0" fill-rule="evenodd" d="m102.339 7.744 1.335.977-.509 1.593 1.335-.986 1.335.986-.509-1.593 1.335-.977h-1.652L104.5 6.16l-.509 1.584zm3.496 30.096-.509-1.584 1.335-.977h-1.652l-.509-1.593-.509 1.593h-1.652l1.335.977-.509 1.584 1.335-.977zM90.85 23.057l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.985.51 1.584-1.336-.985zm8.16-10.913-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.986.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.986zm0 13.763h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H93.23l-.518-1.584zm4.646 6.02-1.335-.969h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.976-1.335.976zm22.636-10.332-.509-1.584 1.335-.985h-1.616l-.51-1.584-.509 1.584h-1.713l1.344.985-.51 1.584 1.353-.985zm-8.986-13.517-1.335-.968h1.652l.509-1.584.509 1.584h1.652l-1.335.968.509 1.584-1.335-.968-1.335.977.509-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.986-.51 1.584 1.344-.986 1.335.986-.509-1.584 1.3-.995h-1.652zm.553 15.356h1.608l-1.3.985.509 1.584-1.335-.976-1.344.976.51-1.584-1.327-.985h1.652l.518-1.584zm-4.69 6.02 1.335-.969h-1.652l-.509-1.584-.509 1.584h-1.652l1.335.968-.509 1.584 1.335-.976 1.335.976z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M137 44H72V0h65zM136.122.88H72.878v42.24h63.244z" clip-rule="evenodd"></path>', 5), Ba1 = [
  Pa1
];
function Va1(t, e) {
  return T(), N("svg", Na1, [...Ba1]);
}
const Ra1 = { render: Va1 }, Ha1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Da1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 37.108V5h23.209v5.432H81.194v7.117h15.714v5.41H81.194v8.74h17.487v5.41zM103.326 5h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.279-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), $a1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Ua1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), ja1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), Ga1 = [
  Da1,
  $a1,
  Ua1,
  ja1
];
function Wa1(t, e) {
  return T(), N("svg", Ha1, [...Ga1]);
}
const Ya1 = { render: Wa1 }, Xa1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, Ka1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Za1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Ja1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), Qa1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M76.302 5.072h6.648v17.834q0 4.245.247 5.503.427 2.021 2.022 3.257 1.617 1.213 4.402 1.213 2.83 0 4.268-1.146 1.437-1.168 1.73-2.852.291-1.684.291-5.593V5.072h6.649v17.295q0 5.93-.539 8.378-.54 2.448-1.999 4.133-1.439 1.684-3.864 2.695-2.425.99-6.334.989-4.716 0-7.165-1.079-2.425-1.1-3.84-2.83-1.416-1.752-1.865-3.66-.651-2.831-.651-8.356zM109.589 38V5.072h24.415v5.57h-17.767v7.3h16.532v5.548h-16.532v8.962h18.396V38z"
}, null, -1), e91 = [
  Ka1,
  Za1,
  Ja1,
  Qa1
];
function t91(t, e) {
  return T(), N("svg", Xa1, [...e91]);
}
const n91 = { render: t91 }, i91 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, s91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 38.108V6h23.209v5.432H81.194v7.117h15.714v5.41H81.194v8.74h17.487v5.41zM103.326 6h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.279-1.644.278-5.46V6h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), l91 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), r91 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), a91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), o91 = [
  s91,
  l91,
  r91,
  a91
];
function c91(t, e) {
  return T(), N("svg", i91, [...o91]);
}
const h91 = { render: c91 }, u91 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, d91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 37.108V5h23.209v5.432H81.194v7.117h15.714v5.41H81.194v8.74h17.487v5.41zM103.326 5h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.279-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), f91 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), v91 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), p91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), m91 = [
  d91,
  f91,
  v91,
  p91
];
function g91(t, e) {
  return T(), N("svg", u91, [...m91]);
}
const y91 = { render: g91 }, _91 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, q91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74 37.108V5h23.3v5.432H80.346v7.117h15.776v5.41H80.346v8.74h17.556v5.41zM102.328 5h6.5v17.573q0 4.185.242 5.423.416 1.992 1.988 3.198 1.57 1.206 4.292 1.206 2.768 0 4.173-1.14t1.691-2.8.285-5.51V5H128v17.043q0 5.841-.527 8.255-.526 2.412-1.944 4.072-1.416 1.66-3.787 2.645-2.373.984-6.194.985-4.612 0-6.994-1.073-2.382-1.074-3.766-2.79-1.383-1.714-1.823-3.596-.637-2.789-.637-8.233z",
  "clip-rule": "evenodd"
}, null, -1), w91 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), z91 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), M91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), b91 = [
  q91,
  w91,
  z91,
  M91
];
function L91(t, e) {
  return T(), N("svg", _91, [...b91]);
}
const x91 = { render: L91 }, S91 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, C91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 37V4.887H98.18v5.432H81.22v7.12h15.781v5.41h-15.78v8.741h17.56V37zm29.728-32.113V37h23.909v-5.41h-17.561v-8.741h15.781v-5.41h-15.781v-7.12h16.96V4.887z",
  "clip-rule": "evenodd"
}, null, -1), k91 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), E91 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), A91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), F91 = [
  C91,
  k91,
  E91,
  A91
];
function T91(t, e) {
  return T(), N("svg", S91, [...F91]);
}
const I91 = { render: T91 }, O91 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, N91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 37.108V5h23.209v5.432H81.194v7.117h15.714v5.41H81.194v8.74h17.487v5.41zM103.326 5h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.279-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), P91 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), B91 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.986.51-1.584-1.336-.95h1.652l.509-1.585.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.985.51 1.584-1.345-.985-1.344.985.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.985-.51 1.584 1.344-.985 1.335.985-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), V91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), R91 = [
  N91,
  P91,
  B91,
  V91
];
function H91(t, e) {
  return T(), N("svg", O91, [...R91]);
}
const D91 = { render: H91 }, $91 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, U91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.875 5.863h6.361v16.935q0 4.032.236 5.227.409 1.919 1.946 3.08 1.536 1.164 4.2 1.164 2.709 0 4.084-1.1 1.374-1.096 1.655-2.697.279-1.6.279-5.31v-17.3h6.361v16.424q0 5.63-.515 7.956-.516 2.324-1.903 3.924-1.386 1.6-3.706 2.549t-6.061.949q-4.513 0-6.844-1.034t-3.686-2.688q-1.353-1.653-1.784-3.466-.623-2.688-.623-7.934zm30.947 31.269V5.863h23.36v5.29h-16.998v6.932h15.817v5.268h-15.817v8.51h17.601v5.269z",
  "clip-rule": "evenodd"
}, null, -1), j91 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), G91 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), W91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), Y91 = [
  U91,
  j91,
  G91,
  W91
];
function X91(t, e) {
  return T(), N("svg", $91, [...Y91]);
}
const K91 = { render: X91 }, Z91 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "43",
  fill: "none",
  viewBox: "0 0 131 43"
}, J91 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M72 36.14V5h23.137v5.268H78.302v6.903h15.665v5.247H78.302v8.476h17.432v5.246zm29.683 0V5.255h6.301v25.639h15.666v5.246z",
  "clip-rule": "evenodd"
}, null, -1), Q91 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.865.86h62.27v41.28H.865z"
}, null, -1), e71 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m29.872 7.568 1.315.955-.502 1.556L32 9.116l1.315.963-.502-1.556 1.314-.955h-1.625L32 6.02l-.502 1.548zm3.443 29.412-.502-1.548 1.314-.955h-1.625L32 32.921l-.502 1.556h-1.626l1.315.955-.502 1.548L32 36.025zM18.56 22.532l-1.315.963.502-1.548-1.315-.929h1.626l.502-1.548.502 1.548h1.634l-1.323.964.502 1.548-1.315-.964zm8.035-10.664-.502-1.548 1.314-.946h-1.625l-.502-1.548-.502 1.548h-1.626l1.315.955-.502 1.548 1.315-.955zm-6.703 2.425.502-1.548.51 1.548h1.582l-1.314.963.502 1.548-1.324-.963-1.323.963.502-1.548-1.315-.963zm0 13.45h-1.678l1.315.964-.502 1.548 1.323-.955 1.323.955-.501-1.548 1.314-.963h-1.582l-.51-1.548zm4.575 5.883-1.315-.946h1.626l.502-1.548.502 1.548h1.625l-1.314.946.502 1.548-1.315-.955-1.315.955zM46.755 23.53l-.502-1.548 1.315-.964h-1.592l-.502-1.548-.501 1.548h-1.687l1.324.964-.502 1.548 1.332-.964zm-8.848-13.21-1.315-.946h1.626l.502-1.548.502 1.548h1.625l-1.314.946.502 1.548-1.315-.946-1.315.955.502-1.548zm5.7 2.417-.51 1.548-1.584.008 1.306.963-.501 1.548 1.323-.963 1.315.963-.502-1.548 1.28-.971h-1.626zm.544 15.007h1.583l-1.28.963.502 1.548-1.315-.955-1.323.955.501-1.548-1.306-.963h1.626l.51-1.548zm-4.618 5.882 1.314-.946h-1.625l-.502-1.548-.502 1.548h-1.626l1.315.946-.502 1.548 1.315-.955 1.315.955z",
  "clip-rule": "evenodd"
}, null, -1), t71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M64 43H0V0h64zM63.135.86H.865v41.28h62.27z",
  "clip-rule": "evenodd"
}, null, -1), n71 = [
  J91,
  Q91,
  e71,
  t71
];
function i71(t, e) {
  return T(), N("svg", Z91, [...n71]);
}
const s71 = { render: i71 }, l71 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, r71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 37.108V5h23.209v5.432H81.194v7.117h15.714v5.41H81.194v8.74h17.487v5.41zM103.326 5h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.279-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), a71 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), o71 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), c71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), h71 = [
  r71,
  a71,
  o71,
  c71
];
function u71(t, e) {
  return T(), N("svg", l71, [...h71]);
}
const d71 = { render: u71 }, f71 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, v71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.875 5.863h6.361v16.935q0 4.032.236 5.227.409 1.919 1.946 3.08 1.536 1.164 4.2 1.164 2.709 0 4.084-1.1 1.374-1.096 1.655-2.697.279-1.6.279-5.31v-17.3h6.361v16.424q0 5.63-.515 7.956-.516 2.324-1.903 3.924-1.386 1.6-3.706 2.549t-6.061.949q-4.513 0-6.844-1.034t-3.686-2.688q-1.353-1.653-1.784-3.466-.623-2.688-.623-7.934zm30.947 31.269V5.863h23.36v5.29h-16.998v6.932h15.817v5.268h-15.817v8.51h17.601v5.269z",
  "clip-rule": "evenodd"
}, null, -1), p71 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), m71 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), g71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), y71 = [
  v71,
  p71,
  m71,
  g71
];
function _71(t, e) {
  return T(), N("svg", f71, [...y71]);
}
const q71 = { render: _71 }, w71 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, z71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "m90.372 24.295-4.394-11.917-4.307 11.917zM102.228 37h-7.005l-2.784-7.295H79.69L77.059 37h-6.83l12.42-32.114h6.81zm3.86-32.113v32.112h24.256v-5.41h-17.816v-8.74h16.01v-5.41h-16.01v-7.12h17.207V4.887z",
  "clip-rule": "evenodd"
}, null, -1), M71 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), b71 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), L71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), x71 = [
  z71,
  M71,
  b71,
  L71
];
function S71(t, e) {
  return T(), N("svg", w71, [...x71]);
}
const C71 = { render: S71 }, k71 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "127",
  height: "44",
  fill: "none",
  viewBox: "0 0 127 44"
}, E71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M0 37.757V5.649h23.209v5.431H6.32v7.118h15.714v5.41H6.321v8.74h17.487v5.409zM28.453 5.649h6.323v17.415q0 4.146.234 5.374.405 1.973 1.934 3.168 1.527 1.196 4.175 1.196 2.692 0 4.059-1.13t1.644-2.774.278-5.461V5.649h6.322v16.889q0 5.79-.512 8.18-.513 2.391-1.89 4.036-1.378 1.645-3.685 2.621-2.306.975-6.024.976-4.486 0-6.802-1.063-2.318-1.064-3.663-2.764t-1.774-3.564q-.62-2.765-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), A71 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M62.3.88h63.243v42.24H62.3z"
}, null, -1), F71 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m91.761 7.744 1.336.977-.51 1.593 1.335-.986 1.335.986-.51-1.593 1.336-.977h-1.651l-.51-1.584-.51 1.584zm3.496 30.096-.51-1.584 1.336-.977h-1.651l-.51-1.593-.51 1.593h-1.65l1.335.977-.51 1.584 1.335-.977zM80.272 23.057l-1.335.985.51-1.584-1.336-.95h1.652l.51-1.584.509 1.584h1.66l-1.344.985.51 1.584-1.336-.985zm8.16-10.913-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.335.977-.51 1.584 1.335-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.986.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.986zm0 13.763H79.92l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985h-1.608l-.518-1.584zm4.647 6.02-1.336-.969h1.652l.51-1.584.509 1.584h1.65l-1.334.968.51 1.584-1.336-.976-1.335.976zm22.635-10.332-.509-1.584 1.335-.985h-1.616l-.51-1.584-.509 1.584h-1.713l1.344.985-.51 1.584 1.353-.985zM99.921 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.651l-1.335.968.509 1.584-1.335-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.986-.51 1.584 1.344-.986 1.335.986-.509-1.584 1.3-.995h-1.652zm.553 15.356h1.608l-1.3.985.509 1.584-1.335-.976-1.344.976.51-1.584-1.327-.985h1.652l.518-1.584zm-4.69 6.02 1.335-.969h-1.651l-.51-1.584-.509 1.584h-1.652l1.335.968-.509 1.584 1.335-.976 1.335.976z",
  "clip-rule": "evenodd"
}, null, -1), T71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M126.422 44h-65V0h65zM125.544.88H62.301v42.24h63.243z",
  "clip-rule": "evenodd"
}, null, -1), I71 = [
  E71,
  A71,
  F71,
  T71
];
function O71(t, e) {
  return T(), N("svg", k71, [...I71]);
}
const N71 = { render: O71 }, P71 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, B71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 37.108V5h23.209v5.432H81.194v7.117h15.714v5.41H81.194v8.74h17.487v5.41zM103.326 5h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.279-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), V71 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), R71 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), H71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), D71 = [
  B71,
  V71,
  R71,
  H71
];
function $71(t, e) {
  return T(), N("svg", P71, [...D71]);
}
const U71 = { render: $71 }, j71 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, G71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 37.108V5h23.209v5.432H81.194v7.117h15.714v5.41H81.194v8.74h17.487v5.41zM103.326 5h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.279-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), W71 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Y71 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), X71 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), K71 = [
  G71,
  W71,
  Y71,
  X71
];
function Z71(t, e) {
  return T(), N("svg", j71, [...K71]);
}
const J71 = { render: Z71 }, Q71 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "138",
  height: "44",
  fill: "none",
  viewBox: "0 0 138 44"
}, eo1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), to1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), no1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), io1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M75.328 34V11.094h16.984v3.875H79.954v5.078h11.5v3.86h-11.5v6.234H92.75V34zM95.5 26.547l4.5-.438q.406 2.266 1.641 3.328Q102.891 30.5 105 30.5q2.234 0 3.359-.937 1.141-.953 1.141-2.22 0-.811-.484-1.374-.47-.579-1.657-1-.812-.282-3.703-1-3.719-.922-5.219-2.266-2.109-1.89-2.109-4.61 0-1.749.984-3.265 1-1.53 2.86-2.328 1.875-.797 4.516-.797 4.312 0 6.484 1.89 2.187 1.892 2.297 5.048l-4.625.203q-.297-1.766-1.282-2.532-.968-.78-2.921-.78-2.016 0-3.157.827-.734.532-.734 1.422 0 .814.688 1.39.875.734 4.25 1.532 3.375.797 4.984 1.656 1.625.845 2.531 2.328.922 1.47.922 3.641 0 1.97-1.094 3.688t-3.093 2.562q-2 .828-4.985.828-4.344 0-6.672-2-2.328-2.015-2.781-5.86m22.531-15.452h9.157q2.718 0 4.046.234a5.8 5.8 0 0 1 2.391.938q1.062.719 1.766 1.922.702 1.187.703 2.671a5.3 5.3 0 0 1-.875 2.953 5.3 5.3 0 0 1-2.344 2.016q2.094.61 3.219 2.078 1.125 1.47 1.125 3.453 0 1.563-.735 3.047-.718 1.47-1.984 2.36-1.25.874-3.094 1.078-1.156.124-5.578.156h-7.797zm4.625 3.812v5.297h3.032q2.703 0 3.359-.078 1.188-.141 1.859-.812.688-.688.688-1.797 0-1.063-.594-1.72-.578-.67-1.734-.812-.688-.078-3.954-.078zm0 9.11v6.125h4.282q2.499 0 3.171-.141 1.032-.187 1.672-.906.657-.734.657-1.953 0-1.032-.5-1.75-.5-.72-1.454-1.047-.937-.328-4.093-.328z"
}, null, -1), so1 = [
  eo1,
  to1,
  no1,
  io1
];
function lo1(t, e) {
  return T(), N("svg", Q71, [...so1]);
}
const ro1 = { render: lo1 }, ao1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, oo1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.875 5.863h6.361v16.935q0 4.032.236 5.227.409 1.919 1.946 3.08 1.536 1.164 4.2 1.164 2.709 0 4.084-1.1 1.374-1.096 1.655-2.697.279-1.6.279-5.31v-17.3h6.361v16.424q0 5.63-.515 7.956-.516 2.324-1.903 3.924-1.386 1.6-3.706 2.549t-6.061.949q-4.513 0-6.844-1.034t-3.686-2.688q-1.353-1.653-1.784-3.466-.623-2.688-.623-7.934zm30.947 31.269V5.863h23.36v5.29h-16.998v6.932h15.817v5.268h-15.817v8.51h17.601v5.269z",
  "clip-rule": "evenodd"
}, null, -1), co1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), ho1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), uo1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), do1 = [
  oo1,
  co1,
  ho1,
  uo1
];
function fo1(t, e) {
  return T(), N("svg", ao1, [...do1]);
}
const vo1 = { render: fo1 }, po1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "132",
  height: "44",
  fill: "none",
  viewBox: "0 0 132 44"
}, mo1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M75.479 38.152V6h23.84v5.439H81.97v7.128h16.142v5.417H81.97v8.75h17.962v5.418zM105.393 6h6.492v17.414q0 4.145.241 5.373.417 1.974 1.974 3.18 1.58 1.185 4.299 1.184 2.763 0 4.167-1.118 1.403-1.14 1.688-2.786.285-1.644.285-5.46V6h6.492v16.887q0 5.79-.526 8.18-.527 2.391-1.952 4.036-1.404 1.645-3.772 2.632-2.369.965-6.185.965-4.605 0-6.996-1.053-2.368-1.074-3.75-2.763-1.382-1.71-1.821-3.575-.636-2.764-.636-8.158z"
}, null, -1), go1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.912.88h65.654v42.24H.912z"
}, null, -1), yo1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m31.496 7.744 1.386.977-.53 1.593 1.387-.986 1.386.986-.53-1.593 1.387-.977h-1.714l-.53-1.584-.528 1.584zm3.629 30.096-.53-1.584 1.387-.977h-1.714l-.53-1.592-.528 1.592h-1.714l1.386.977-.53 1.584 1.387-.977zM19.569 23.056l-1.386.986.528-1.584-1.386-.95h1.715l.529-1.585.528 1.584h1.724l-1.395.986.529 1.584-1.386-.986zm8.47-10.912-.528-1.584 1.386-.968h-1.714l-.53-1.584-.528 1.584H24.41l1.387.977-.53 1.584 1.387-.977zm-7.066 2.482.529-1.584.538 1.584h1.668l-1.386.985.53 1.584-1.396-.985-1.395.985.529-1.584-1.386-.985zm0 13.763h-1.769l1.386.986-.53 1.584 1.396-.977 1.395.977-.529-1.584 1.386-.986H22.04l-.538-1.584zm4.824 6.02-1.387-.969h1.715l.529-1.584.529 1.584h1.714l-1.386.968.529 1.584-1.386-.977-1.386.977zm23.498-10.332-.529-1.584 1.386-.986h-1.678l-.528-1.584-.53 1.584H45.64l1.395.986-.53 1.584 1.405-.986zM39.967 10.56l-1.386-.968h1.714l.529-1.584.529 1.584h1.714l-1.386.968.529 1.584-1.386-.968-1.386.977.529-1.584zm6.009 2.473-.538 1.584-1.669.009 1.377.985-.529 1.584 1.395-.985 1.386.985-.528-1.584 1.35-.994h-1.715zm.574 15.356h1.67l-1.35.986.528 1.584-1.386-.977-1.395.977.53-1.584-1.378-.986h1.715l.538-1.584zm-4.869 6.02 1.386-.969h-1.714l-.53-1.584-.528 1.584h-1.714l1.386.968-.53 1.584 1.387-.977 1.386.977z",
  "clip-rule": "evenodd"
}, null, -1), _o1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M67.478 44H0V0h67.478zM66.566.88H.912v42.24h65.654z",
  "clip-rule": "evenodd"
}, null, -1), qo1 = [
  mo1,
  go1,
  yo1,
  _o1
];
function wo1(t, e) {
  return T(), N("svg", po1, [...qo1]);
}
const zo1 = { render: wo1 }, Mo1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, bo1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M74 38.152V6h23.84v5.439H80.492v7.128h16.141v5.417H80.492v8.75h17.962v5.418zM103.915 6h6.491v17.414q0 4.145.242 5.373.416 1.974 1.974 3.18 1.578 1.185 4.298 1.184 2.763 0 4.167-1.118 1.404-1.14 1.689-2.786.285-1.644.285-5.46V6h6.492v16.887q0 5.79-.527 8.18-.526 2.391-1.952 4.036-1.403 1.645-3.772 2.632-2.368.965-6.184.965-4.606 0-6.997-1.053-2.368-1.074-3.75-2.763-1.382-1.71-1.82-3.575-.636-2.764-.636-8.158z"
}, null, -1), Lo1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), xo1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.687l-.517 1.592h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.986-.517 1.584 1.364-.977 1.365.977-.517-1.584 1.355-.986h-1.632l-.526-1.584zm4.718 6.02-1.356-.969h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.332-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.986.517 1.584-1.355-.977-1.365.977.517-1.584-1.346-.986h1.676l.527-1.584zm-4.763 6.02 1.356-.969h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), So1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), Co1 = [
  bo1,
  Lo1,
  xo1,
  So1
];
function ko1(t, e) {
  return T(), N("svg", Mo1, [...Co1]);
}
const Eo1 = { render: ko1 }, Ao1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Fo1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.871 37.131V5.863h23.252v5.29h-16.92v6.931h15.744v5.269H81.204v8.51h17.52v5.268zm26.959-10.173 6.16-.598q.557 3.093 2.258 4.543 1.7 1.45 4.588 1.45 3.059 0 4.61-1.29t1.551-3.018q0-1.11-.653-1.887-.652-.78-2.277-1.354-1.113-.384-5.071-1.366-5.09-1.26-7.145-3.093-2.887-2.58-2.887-6.291 0-2.39 1.358-4.468 1.358-2.08 3.915-3.168t6.171-1.088q5.904 0 8.888 2.58 2.984 2.583 3.135 6.89l-6.332.277q-.407-2.41-1.744-3.465-1.337-1.057-4.011-1.056-2.759 0-4.321 1.13-1.005.725-1.005 1.94 0 1.11.941 1.899 1.197 1.002 5.819 2.09 4.62 1.089 6.833 2.25 2.216 1.163 3.467 3.179t1.251 4.98q0 2.688-1.498 5.033-1.497 2.347-4.235 3.488-2.74 1.14-6.824 1.141-5.947 0-9.134-2.74-3.187-2.742-3.808-7.988",
  "clip-rule": "evenodd"
}, null, -1), To1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Io1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Oo1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), No1 = [
  Fo1,
  To1,
  Io1,
  Oo1
];
function Po1(t, e) {
  return T(), N("svg", Ao1, [...No1]);
}
const Bo1 = { render: Po1 }, Vo1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Ro1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.871 37.131V5.863h23.252v5.29h-16.92v6.931h15.744v5.269H81.204v8.51h17.52v5.268zm26.959-10.173 6.16-.598q.557 3.093 2.258 4.543 1.7 1.45 4.588 1.45 3.059 0 4.61-1.29t1.551-3.018q0-1.11-.653-1.887-.652-.78-2.277-1.354-1.113-.384-5.071-1.366-5.09-1.26-7.145-3.093-2.887-2.58-2.887-6.291 0-2.39 1.358-4.468 1.358-2.08 3.915-3.168t6.171-1.088q5.904 0 8.888 2.58 2.984 2.583 3.135 6.89l-6.332.277q-.407-2.41-1.744-3.465-1.337-1.057-4.011-1.056-2.759 0-4.321 1.13-1.005.725-1.005 1.94 0 1.11.941 1.899 1.197 1.002 5.819 2.09 4.62 1.089 6.833 2.25 2.216 1.163 3.467 3.179t1.251 4.98q0 2.688-1.498 5.033-1.497 2.347-4.235 3.488-2.74 1.14-6.824 1.141-5.947 0-9.134-2.74-3.187-2.742-3.808-7.988",
  "clip-rule": "evenodd"
}, null, -1), Ho1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Do1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), $o1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), Uo1 = [
  Ro1,
  Ho1,
  Do1,
  $o1
];
function jo1(t, e) {
  return T(), N("svg", Vo1, [...Uo1]);
}
const Go1 = { render: jo1 }, Wo1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Yo1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.875 5.863h6.361v16.935q0 4.032.236 5.227.409 1.919 1.946 3.08 1.536 1.164 4.2 1.164 2.709 0 4.084-1.1 1.374-1.096 1.655-2.697.279-1.6.279-5.31v-17.3h6.361v16.424q0 5.63-.515 7.956-.516 2.324-1.903 3.924-1.386 1.6-3.706 2.549t-6.061.949q-4.513 0-6.844-1.034t-3.686-2.688q-1.353-1.653-1.784-3.466-.623-2.688-.623-7.934zm30.947 31.269V5.863h23.36v5.29h-16.998v6.932h15.817v5.268h-15.817v8.51h17.601v5.269z",
  "clip-rule": "evenodd"
}, null, -1), Xo1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Ko1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Zo1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), Jo1 = [
  Yo1,
  Xo1,
  Ko1,
  Zo1
];
function Qo1(t, e) {
  return T(), N("svg", Wo1, [...Jo1]);
}
const ec1 = { render: Qo1 }, tc1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, nc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.873 37.108V5h23.209v5.432H81.194v7.117h15.714v5.41H81.194v8.74h17.487v5.41zM103.326 5h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.279-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), ic1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), sc1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), lc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), rc1 = [
  nc1,
  ic1,
  sc1,
  lc1
];
function ac1(t, e) {
  return T(), N("svg", tc1, [...rc1]);
}
const oc1 = { render: ac1 }, cc1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "137",
  height: "44",
  fill: "none",
  viewBox: "0 0 137 44"
}, hc1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), uc1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), dc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), fc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M76.347 38V5.072h24.415v5.57H82.995v7.3h16.531v5.548h-16.53v8.962h18.395V38zm30.636-32.928h6.649v17.834q0 4.245.247 5.503.426 2.021 2.021 3.257 1.618 1.213 4.403 1.213 2.83 0 4.267-1.146 1.438-1.168 1.73-2.852.291-1.684.292-5.593V5.072h6.648v17.295q0 5.93-.539 8.378t-1.999 4.133q-1.437 1.684-3.863 2.695-2.426.99-6.334.989-4.717 0-7.165-1.079-2.426-1.1-3.841-2.83-1.415-1.752-1.864-3.66-.651-2.831-.652-8.356z"
}, null, -1), vc1 = [
  hc1,
  uc1,
  dc1,
  fc1
];
function pc1(t, e) {
  return T(), N("svg", cc1, [...vc1]);
}
const mc1 = { render: pc1 }, gc1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, yc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.875 5.863h6.361v16.935q0 4.032.236 5.227.409 1.919 1.946 3.08 1.536 1.164 4.2 1.164 2.709 0 4.084-1.1 1.374-1.096 1.655-2.697.279-1.6.279-5.31v-17.3h6.361v16.424q0 5.63-.515 7.956-.516 2.324-1.903 3.924-1.386 1.6-3.706 2.549t-6.061.949q-4.513 0-6.844-1.034t-3.686-2.688q-1.353-1.653-1.784-3.466-.623-2.688-.623-7.934zm30.947 31.269V5.863h23.36v5.29h-16.998v6.932h15.817v5.268h-15.817v8.51h17.601v5.269z",
  "clip-rule": "evenodd"
}, null, -1), _c1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), qc1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), wc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), zc1 = [
  yc1,
  _c1,
  qc1,
  wc1
];
function Mc1(t, e) {
  return T(), N("svg", gc1, [...zc1]);
}
const bc1 = { render: Mc1 }, Lc1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, xc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.875 5.863h6.361v16.935q0 4.032.236 5.227.409 1.919 1.946 3.08 1.536 1.164 4.2 1.164 2.709 0 4.084-1.1 1.374-1.096 1.655-2.697.279-1.6.279-5.31v-17.3h6.361v16.424q0 5.63-.515 7.956-.516 2.324-1.903 3.924-1.386 1.6-3.706 2.549t-6.061.949q-4.513 0-6.844-1.034t-3.686-2.688q-1.353-1.653-1.784-3.466-.623-2.688-.623-7.934zm30.947 31.269V5.863h23.36v5.29h-16.998v6.932h15.817v5.268h-15.817v8.51h17.601v5.269z",
  "clip-rule": "evenodd"
}, null, -1), Sc1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Cc1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), kc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), Ec1 = [
  xc1,
  Sc1,
  Cc1,
  kc1
];
function Ac1(t, e) {
  return T(), N("svg", Lc1, [...Ec1]);
}
const Fc1 = { render: Ac1 }, Tc1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Ic1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74.875 5.863h6.361v16.935q0 4.032.236 5.227.409 1.919 1.946 3.08 1.536 1.164 4.2 1.164 2.709 0 4.084-1.1 1.374-1.096 1.655-2.697.279-1.6.279-5.31v-17.3h6.361v16.424q0 5.63-.515 7.956-.516 2.324-1.903 3.924-1.386 1.6-3.706 2.549t-6.061.949q-4.513 0-6.844-1.034t-3.686-2.688q-1.353-1.653-1.784-3.466-.623-2.688-.623-7.934zm30.947 31.269V5.863h23.36v5.29h-16.998v6.932h15.817v5.268h-15.817v8.51h17.601v5.269z",
  "clip-rule": "evenodd"
}, null, -1), Oc1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Nc1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Pc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), Bc1 = [
  Ic1,
  Oc1,
  Nc1,
  Pc1
];
function Vc1(t, e) {
  return T(), N("svg", Tc1, [...Bc1]);
}
const Rc1 = { render: Vc1 }, Hc1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Dc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M74 37.16V5.54h23.447v5.349H80.385v7.01H96.26v5.328H80.385v8.606H98.05v5.328zm49.697-11.625 6.191 1.962q-1.424 5.177-4.746 7.7-3.3 2.503-8.39 2.503-6.299 0-10.354-4.292-4.055-4.314-4.055-11.778 0-7.895 4.077-12.251 4.076-4.38 10.72-4.379 5.802 0 9.426 3.43 2.157 2.027 3.235 5.824l-6.32 1.51q-.56-2.46-2.351-3.883-1.769-1.424-4.314-1.424-3.516 0-5.716 2.524-2.178 2.523-2.178 8.175 0 5.997 2.157 8.542t5.608 2.545q2.545 0 4.379-1.618 1.833-1.617 2.631-5.09"
}, null, -1), $c1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), Uc1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.687l-.517 1.592h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.986-.517 1.584 1.364-.977 1.365.977-.517-1.584 1.355-.986h-1.632l-.526-1.584zm4.718 6.02-1.356-.969h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.332-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.986.517 1.584-1.355-.977-1.365.977.517-1.584-1.346-.986h1.676l.527-1.584zm-4.763 6.02 1.356-.969h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), jc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), Gc1 = [
  Dc1,
  $c1,
  Uc1,
  jc1
];
function Wc1(t, e) {
  return T(), N("svg", Hc1, [...Gc1]);
}
const Yc1 = { render: Wc1 }, Xc1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Kc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M74 39.615V8.205h23.252v5.314h-16.92v6.963h15.744v5.293H80.333v8.549h17.52v5.291zm36.922-33.209L113.875 0h6.738l-5.883 6.406zm-8.62 1.8h6.332v17.012q0 4.05.236 5.25.405 1.927 1.935 3.094 1.53 1.17 4.182 1.169 2.695 0 4.065-1.104 1.369-1.104 1.647-2.71.278-1.608.278-5.335V8.206h6.331v16.498q0 5.655-.512 7.991-.515 2.335-1.894 3.942t-3.69 2.56-6.032.954q-4.493 0-6.814-1.039t-3.667-2.7q-1.348-1.66-1.777-3.481-.62-2.7-.62-7.97z",
  "clip-rule": "evenodd"
}, null, -1), Zc1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), Jc1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Qc1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), eh1 = [
  Kc1,
  Zc1,
  Jc1,
  Qc1
];
function th1(t, e) {
  return T(), N("svg", Xc1, [...eh1]);
}
const nh1 = { render: th1 }, ih1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, sh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M73.705 37.108V5h23.209v5.432H80.026v7.117H95.74v5.41H80.026v8.74h17.487v5.41zM102.158 5h6.322v17.415q0 4.146.235 5.374.406 1.974 1.934 3.169 1.526 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.278-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.514 2.39-1.891 4.036t-3.684 2.62q-2.306.976-6.024.977-4.485 0-6.803-1.064-2.317-1.063-3.663-2.764-1.345-1.699-1.773-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), lh1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), rh1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), ah1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), oh1 = [
  sh1,
  lh1,
  rh1,
  ah1
];
function ch1(t, e) {
  return T(), N("svg", ih1, [...oh1]);
}
const hh1 = { render: ch1 }, uh1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, dh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M73.705 37.108V5h23.209v5.432H80.026v7.117H95.74v5.41H80.026v8.74h17.487v5.41zM102.158 5h6.322v17.415q0 4.146.235 5.374.406 1.974 1.934 3.169 1.526 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.278-1.644.278-5.46V5h6.322v16.889q0 5.79-.512 8.181-.514 2.39-1.891 4.036t-3.684 2.62q-2.306.976-6.024.977-4.485 0-6.803-1.064-2.317-1.063-3.663-2.764-1.345-1.699-1.773-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), fh1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), vh1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), ph1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), mh1 = [
  dh1,
  fh1,
  vh1,
  ph1
];
function gh1(t, e) {
  return T(), N("svg", uh1, [...mh1]);
}
const yh1 = { render: gh1 }, _h1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, qh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M73 38.108V6h23.209v5.432H79.32v7.117h15.714v5.41H79.321v8.74h17.487v5.41zM101.453 6h6.323v17.415q0 4.146.234 5.374.406 1.974 1.934 3.169 1.527 1.195 4.175 1.195 2.692.001 4.059-1.13 1.366-1.128 1.644-2.774.278-1.644.278-5.46V6h6.322v16.889q0 5.79-.512 8.181-.513 2.39-1.891 4.036-1.377 1.645-3.684 2.62-2.306.976-6.024.977-4.486 0-6.802-1.064-2.318-1.063-3.663-2.764-1.345-1.699-1.774-3.564-.62-2.763-.619-8.159z",
  "clip-rule": "evenodd"
}, null, -1), wh1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), zh1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.593 1.336-.986 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.057l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.985.51 1.584-1.336-.985zm8.16-10.913-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.584.517 1.584h1.608l-1.335.986.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.986zm0 13.763h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23l-.518-1.584zm4.646 6.02-1.335-.969h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.976-1.335.976zm22.636-10.332-.51-1.584 1.336-.985h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.985-.51 1.584 1.353-.985zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.009 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.995h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.02 1.335-.969h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.976 1.335.976z",
  "clip-rule": "evenodd"
}, null, -1), Mh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), bh1 = [
  qh1,
  wh1,
  zh1,
  Mh1
];
function Lh1(t, e) {
  return T(), N("svg", _h1, [...bh1]);
}
const xh1 = { render: Lh1 }, Sh1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "138",
  height: "44",
  fill: "none",
  viewBox: "0 0 138 44"
}, Ch1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.878.88h63.243v42.24H.878z"
}, null, -1), kh1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.34 7.744 1.334.977-.51 1.592 1.336-.985 1.335.986-.51-1.593 1.336-.977H33.01L32.5 6.16l-.51 1.584zm3.495 30.096-.51-1.584 1.336-.977H33.01l-.51-1.593-.51 1.593h-1.65l1.334.977-.51 1.584 1.336-.977zM18.85 23.056l-1.335.985.51-1.584-1.336-.95h1.652l.509-1.584.51 1.584h1.66l-1.344.986.51 1.584-1.336-.986zm8.16-10.912-.51-1.584 1.336-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.977-.51 1.584 1.336-.977zm-6.807 2.482.51-1.585.517 1.585h1.608l-1.335.985.51 1.584-1.345-.986-1.344.986.51-1.584-1.335-.985zm.51 12.179-.51 1.584h-1.704l1.335.985-.51 1.584 1.344-.976 1.344.976-.51-1.584 1.336-.985H21.23zm4.136 7.603-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.977-1.335.977zm22.636-10.331-.51-1.584 1.336-.986h-1.616l-.51-1.584-.51 1.584h-1.712l1.344.986-.51 1.584 1.353-.986zM38.5 10.56l-1.335-.968h1.652l.509-1.584.51 1.584h1.65l-1.334.968.51 1.584-1.336-.968-1.335.977.51-1.584zm5.789 2.473-.518 1.584-1.608.008 1.327.986-.51 1.584 1.344-.986 1.335.986-.51-1.584 1.3-.994h-1.65zm.553 15.356h1.608l-1.3.985.51 1.584-1.336-.976-1.344.976.51-1.584-1.327-.985h1.651l.519-1.584zm-4.69 6.019 1.335-.968h-1.651l-.51-1.584-.51 1.584h-1.65l1.334.968-.51 1.584 1.336-.977 1.335.977z",
  "clip-rule": "evenodd"
}, null, -1), Eh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M65 44H0V0h65zM64.122.88H.878v42.24h63.244z",
  "clip-rule": "evenodd"
}, null, -1), Ah1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M106.04 38h-7.232l-2.875-7.48H82.77L80.054 38H73L85.825 5.072h7.03zM93.799 24.973l-4.537-12.22-4.448 12.22zm15.812-19.901h13.162q3.909 0 5.818.337 1.932.315 3.436 1.348 1.529 1.034 2.538 2.763 1.011 1.707 1.011 3.84a7.6 7.6 0 0 1-1.258 4.246q-1.234 1.93-3.369 2.897 3.01.876 4.627 2.987t1.617 4.964q0 2.246-1.055 4.38-1.033 2.11-2.853 3.392-1.797 1.257-4.447 1.55-1.662.18-8.019.224h-11.208zm6.649 5.48v7.615h4.357q3.886 0 4.829-.112 1.707-.202 2.673-1.168.988-.99.988-2.583 0-1.527-.853-2.471-.831-.966-2.493-1.168-.988-.112-5.683-.112zm0 13.096v8.804h6.154q3.594 0 4.56-.202 1.482-.27 2.403-1.303.943-1.055.943-2.807 0-1.483-.718-2.516-.72-1.033-2.089-1.505-1.348-.471-5.885-.471z"
}, null, -1), Fh1 = [
  Ch1,
  kh1,
  Eh1,
  Ah1
];
function Th1(t, e) {
  return T(), N("svg", Sh1, [...Fh1]);
}
const Ih1 = { render: Th1 }, Oh1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Nh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M90.057 19.026v5.03h-9.555q.519 4.029 2.43 5.93 1.933 1.881 4.653 1.881 2.805 0 4.633-1.636 1.827-1.656 2.243-4.744l6.169 1.882q-1.059 4.478-4.279 7.054T87.98 37q-5.276 0-8.33-2.454-3.033-2.454-4.341-5.664-1.31-3.21-1.309-7.218 0-7.035 3.76-11.35T88.105 6q5.088 0 8.267 2.372 3.2 2.372 4.175 6.42l-6.086 1.37q-.665-2.35-2.451-3.639t-4.072-1.288q-3.282 0-5.193 2.229-1.89 2.208-2.243 5.562zm34.981 6.441 5.962 1.86q-1.37 4.909-4.57 7.301Q123.252 37 118.349 37q-6.065 0-9.97-4.07-3.906-4.089-3.906-11.164 0-7.485 3.926-11.615 3.927-4.15 10.324-4.151 5.588 0 9.078 3.251 2.077 1.923 3.116 5.521l-6.086 1.432q-.54-2.331-2.265-3.68-1.703-1.35-4.154-1.35-3.385 0-5.505 2.392-2.098 2.392-2.098 7.75 0 5.685 2.077 8.098 2.077 2.412 5.401 2.412 2.451 0 4.217-1.533 1.766-1.534 2.534-4.826"
}, null, -1), Ph1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), Bh1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.687l-.517 1.592h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.986-.517 1.584 1.364-.977 1.365.977-.517-1.584 1.355-.986h-1.632l-.526-1.584zm4.718 6.02-1.356-.969h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.332-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.986.517 1.584-1.355-.977-1.365.977.517-1.584-1.346-.986h1.676l.527-1.584zm-4.763 6.02 1.356-.969h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), Vh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), Rh1 = [
  Nh1,
  Ph1,
  Bh1,
  Vh1
];
function Hh1(t, e) {
  return T(), N("svg", Oh1, [...Rh1]);
}
const Dh1 = { render: Hh1 }, $h1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "131",
  height: "44",
  fill: "none",
  viewBox: "0 0 131 44"
}, Uh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  d: "M77.304 18.32a50 50 0 0 1 2.719 2.837c-.76 1.696-1.667 3.245-2.72 4.473zm16.9-1.958h2.075c-.234 1.637-.556 3.245-.906 4.473l2.514 1.462c.877-2.251 1.666-5.497 2.105-8.42l-2.368-.848-.526.175h-6.082c.351-1.52.614-3.099.848-4.707L88.356 8c-.497 4.561-1.58 9.093-3.45 11.87.789.497 2.222 1.696 2.806 2.31.994-1.579 1.813-3.567 2.486-5.818h.643v3.275c0 2.426-.819 7.133-4.152 10.642v-1.462h-9.385v-2.28a19 19 0 0 1 2.017 1.812c1.111-1.257 2.105-2.806 2.953-4.56.907 1.14 1.667 2.221 2.164 3.157l2.163-2.602c-.643-1.14-1.695-2.486-2.923-3.86.76-2.105 1.344-4.327 1.812-6.666l-3.157-.526c-.293 1.579-.644 3.128-1.111 4.62a63 63 0 0 0-2.573-2.427l-1.345 1.49v-4.122h9.21V9.637H74v24.384h3.304v-1.988h7.31l-.527.351c.614.672 1.579 2.134 1.959 2.895 4.064-2.544 6.023-7.28 6.461-9.824.41 2.456 2.164 7.397 5.73 9.824.527-.878 1.521-2.281 2.106-3.041-4.97-3.42-6.14-9.707-6.14-12.601zm31.504-4.824v1.695h-4.97v-1.695zm-5.117 5.818c.088-.585.117-1.199.147-1.754h4.97v1.754zm5.117 2.397v1.345c0 .351-.117.468-.526.468-.38.03-1.667.059-2.836 0 .438.731 1.023 1.96 1.228 2.836 1.842 0 3.245-.058 4.239-.555 1.053-.468 1.345-1.228 1.345-2.72V8.848H117.58v5.878c0 2.602-.292 5.7-3.07 7.865.673.409 1.93 1.578 2.427 2.192 1.725-1.345 2.66-3.157 3.187-5.029zm-13.478-7.748v2.106h-3.626v-2.106zm-3.626 6.754v-2.076h3.626v2.076zm0 2.69h6.783V9.286h-9.941v13.596h3.158zm1.842 6.199h2.485v3.888h-2.485zm8.216 0v3.888h-2.544v-3.888zm5.701 0v3.888h-2.544v-3.888zm3.421 3.888v-6.578H107.23v6.578h-3.421v2.982H131v-2.982z"
}, null, -1), jh1 = /* @__PURE__ */ C("path", {
  fill: "#039",
  d: "M.892.88h64.216v42.24H.892z"
}, null, -1), Gh1 = /* @__PURE__ */ C("path", {
  fill: "#FC0",
  "fill-rule": "evenodd",
  d: "m30.806 7.744 1.356.977-.518 1.593L33 9.328l1.356.986-.518-1.593 1.356-.977h-1.677L33 6.16l-.517 1.584zm3.55 30.096-.518-1.584 1.356-.977h-1.677L33 33.687l-.517 1.592h-1.677l1.356.977-.518 1.584L33 36.863zM19.14 23.056l-1.356.986.518-1.584-1.356-.95h1.677l.517-1.585.517 1.584h1.686l-1.365.986.518 1.584-1.356-.986zm8.286-10.912-.518-1.584 1.356-.968h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.977-.518 1.584 1.356-.977zm-6.912 2.482.517-1.584.526 1.584h1.632l-1.355.985.517 1.584-1.365-.985-1.364.985.517-1.584-1.356-.985zm0 13.763h-1.731l1.356.986-.517 1.584 1.364-.977 1.365.977-.517-1.584 1.355-.986h-1.632l-.526-1.584zm4.718 6.02-1.356-.969h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.977-1.356.977zm22.984-10.332-.518-1.584 1.356-.986h-1.641l-.517-1.584-.518 1.584H44.64l1.365.986-.517 1.584 1.373-.986zM39.092 10.56l-1.356-.968h1.677l.517-1.584.517 1.584h1.677l-1.356.968.518 1.584-1.356-.968-1.356.977.518-1.584zm5.877 2.473-.526 1.584-1.632.009 1.346.985-.517 1.584 1.365-.985 1.355.985-.517-1.584 1.32-.994h-1.676zm.562 15.356h1.632l-1.32.986.517 1.584-1.355-.977-1.365.977.517-1.584-1.346-.986h1.676l.527-1.584zm-4.763 6.02 1.356-.969h-1.677l-.517-1.584-.517 1.584h-1.677l1.356.968-.518 1.584 1.356-.977 1.356.977z",
  "clip-rule": "evenodd"
}, null, -1), Wh1 = /* @__PURE__ */ C("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M66 44H0V0h66zM65.108.88H.892v42.24h64.216z",
  "clip-rule": "evenodd"
}, null, -1), Yh1 = [
  Uh1,
  jh1,
  Gh1,
  Wh1
];
function Xh1(t, e) {
  return T(), N("svg", $h1, [...Yh1]);
}
const Kh1 = { render: Xh1 }, yL = () => ({
  ec: {
    mute: nZ,
    positive: {
      ar: aZ,
      bg: uZ,
      ca: mZ,
      cs: qZ,
      da: bZ,
      de: CZ,
      el: FZ,
      en: NZ,
      es: RZ,
      et: UZ,
      fi: YZ,
      fr: JZ,
      ga: nJ,
      he: aJ,
      hr: uJ,
      hu: pJ,
      is: qJ,
      it: bJ,
      jp: kJ,
      lb: IJ,
      lt: BJ,
      lv: DJ,
      mt: GJ,
      nl: KJ,
      no: tQ,
      pl: lQ,
      pt: cQ,
      ro: fQ,
      ru: yQ,
      sk: zQ,
      sl: xQ,
      sv: EQ,
      sw: OQ,
      tr: RQ,
      uk: jQ,
      zh: KQ
    },
    negative: {
      ar: t11,
      bg: r11,
      ca: u11,
      cs: m11,
      da: w11,
      de: x11,
      el: A11,
      en: N11,
      es: H11,
      et: G11,
      fi: Z11,
      fr: n21,
      ga: a21,
      he: d21,
      hr: g21,
      hu: z21,
      is: S21,
      it: F21,
      jp: P21,
      lb: D21,
      lt: W21,
      lv: J21,
      mt: i31,
      nl: o31,
      no: f31,
      pl: y31,
      pt: M31,
      ro: C31,
      ru: T31,
      sk: B31,
      sl: $31,
      sv: Y31,
      sw: Q31,
      tr: se1,
      uk: ce1,
      zh: ve1
    }
  },
  eu: {
    mute: _e1,
    standard: {
      positive: {
        ar: be1,
        bg: ke1,
        ca: Ne1,
        cs: He1,
        da: Ge1,
        de: Ze1,
        el: nt1,
        en: at1,
        es: dt1,
        et: gt1,
        fi: zt1,
        fr: St1,
        ga: Ft1,
        he: Vt1,
        hr: Ut1,
        hu: Xt1,
        is: n41,
        it: a41,
        jp: v41,
        lb: w41,
        lt: x41,
        lv: A41,
        mt: N41,
        nl: H41,
        no: Y41,
        pl: Q41,
        pt: s51,
        ro: c51,
        ru: m51,
        sk: w51,
        sl: x51,
        sv: A51,
        sw: B51,
        tr: j51,
        uk: J51,
        zh: l01
      },
      negative: {
        ar: h01,
        bg: g01,
        ca: L01,
        cs: F01,
        da: V01,
        de: G01,
        el: Q01,
        en: s61,
        es: u61,
        et: y61,
        fi: L61,
        fr: F61,
        ga: P61,
        he: j61,
        hr: J61,
        hu: ln1,
        is: fn1,
        it: qn1,
        jp: Cn1,
        lb: Nn1,
        lt: $n1,
        lv: Kn1,
        mt: ii1,
        nl: hi1,
        no: yi1,
        pl: Li1,
        pt: Fi1,
        ro: Vi1,
        ru: Wi1,
        sk: e81,
        sl: a81,
        sv: v81,
        sw: z81,
        tr: E81,
        uk: B81,
        zh: G81
      }
    },
    condensed: {
      positive: {
        ar: es1,
        bg: ls1,
        ca: ds1,
        cs: gs1,
        da: zs1,
        de: Ss1,
        el: Fs1,
        en: Ps1,
        es: Ds1,
        et: Ws1,
        fi: Js1,
        fr: il1,
        ga: ol1,
        he: pl1,
        hr: ql1,
        hu: Ll1,
        is: Fl1,
        it: Pl1,
        jp: Ul1,
        lb: Zl1,
        lt: nr1,
        lv: ar1,
        mt: dr1,
        nl: gr1,
        no: br1,
        pl: kr1,
        pt: Ir1,
        ro: Vr1,
        ru: Gr1,
        sk: Zr1,
        sl: na1,
        sv: aa1,
        sw: va1,
        tr: wa1,
        uk: Ca1,
        zh: Oa1
      },
      negative: {
        ar: Ra1,
        bg: Ya1,
        ca: n91,
        cs: h91,
        da: y91,
        de: x91,
        el: I91,
        en: D91,
        es: K91,
        et: s71,
        fi: d71,
        fr: q71,
        ga: C71,
        he: N71,
        hr: U71,
        hu: J71,
        is: ro1,
        it: vo1,
        jp: zo1,
        lb: Eo1,
        lt: Bo1,
        lv: Go1,
        mt: ec1,
        nl: oc1,
        no: mc1,
        pl: bc1,
        pt: Fc1,
        ro: Rc1,
        ru: Yc1,
        sk: nh1,
        sl: hh1,
        sv: yh1,
        sw: xh1,
        tr: Ih1,
        uk: Dh1,
        zh: Kh1
      }
    }
  }
}), Ow = yL(), Zh1 = {
  get: (t = "en", e = "negative", n = !1) => t && e !== "mute" ? Ow.ec[e][t] : Ow.ec.mute
}, Nw = yL(), Jh1 = {
  get: (t = "en", e = "negative", n = !1) => t ? Nw.eu[n ? "condensed" : "standard"][e][t] : Nw.eu.mute
}, Jn = g1(() => {
  var t, e;
  const n = t9();
  return (((e = (t = n == null ? void 0 : n.appContext.config.globalProperties) == null ? void 0 : t.$ecl) == null ? void 0 : e.theme) ?? "ec") === "ec" ? Zh1 : Jh1;
}), Qh1 = "/".replace(/\/$/, ""), eu1 = (t) => {
  const e = new URLSearchParams(t ?? window.location.search).entries();
  return Object.fromEntries(e);
}, tu1 = (t, e = !0, n) => {
  const i = {
    ...t,
    query: N1.assign(eu1(), t.query)
  };
  try {
    const s = (n ?? S8()).resolve(i).href;
    return e === !0 ? s.replace(Qh1, "") : s;
  } catch (s) {
    return console.error("@helper > makeUrl:", s), "";
  }
}, Pw = (t, e, n) => {
  let i = `/?lng=${t.code}`;
  if (!N1.isNil(e) && !N1.isNil(n == null ? void 0 : n.router) && (N1.isNil(t.urlToRoot) || !N1.isNil(t.urlToRoot) && t.urlToRoot === !1) && (i = tu1(
    N1.merge(e, {
      query: {
        lng: t.code
      }
    }),
    !1,
    n == null ? void 0 : n.router
  )), (n == null ? void 0 : n.performRedirect) !== !1)
    window.location.href = i;
  else
    return i;
}, li = () => Math.random().toString(36).substr(2, 9);
function nu1(t) {
  const { external: e, target: n, autoCheckExternal: i, to: s } = s3(t), l = g1(() => i ? pL(s.value) : H(e) ?? !1), a = g1(() => n9(n.value));
  return {
    isExternalLink: l,
    targetLink: a
  };
}
const iu1 = c2({
  name: "AppLink",
  props: {
    // @ts-ignore
    ...KA.props,
    external: {
      type: Boolean,
      required: !1,
      default: null
    },
    target: {
      type: String,
      required: !1,
      default: null
      // self, blank
    },
    autoCheckExternal: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(t) {
    const e = S8();
    return {
      ...nu1(t),
      finalUrl: ((n) => {
        const i = N1.find((e == null ? void 0 : e.getRoutes()) ?? [], (s) => s.name === n);
        return N1.isNil(i) ? t.to : e == null ? void 0 : e.resolve({ name: n }).href;
      })(t.to)
    };
  }
}), su1 = ["href", "target"];
function lu1(t, e, n, i, s, l) {
  const a = V2("router-link");
  return t.isExternalLink ? (T(), N("a", Ht({ key: 0 }, t.$attrs, {
    href: t.finalUrl,
    target: t.targetLink
  }), [
    J2(t.$slots, "default")
  ], 16, su1)) : (T(), v2(a, Ht({ key: 1 }, t.$props, { to: t.finalUrl }), {
    default: Q2(() => [
      J2(t.$slots, "default")
    ]),
    _: 3
  }, 16, ["to"]));
}
const f4 = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [i, s] of e)
    n[i] = s;
  return n;
}, ui = /* @__PURE__ */ f4(iu1, [["render", lu1]]);
var _L = /* @__PURE__ */ ((t) => (t.XS = "xs", t.S = "s", t.M = "m", t.L = "l", t.XL = "xl", t))(_L || {});
const ru1 = c2({
  name: "EclLoader",
  props: {
    size: {
      type: String,
      required: !1,
      default: "m",
      validator: (t) => Object.values(_L).includes(t)
    },
    /** Crea un backdrop */
    panel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** Posiziona in "fixed" il loader */
    fixed: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** Stretch dell'altezza alla full height del contenitore */
    stretch: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** Opacità del backdrop */
    opacity: {
      type: Number,
      required: !1,
      default: 0.8
    },
    /** Backdrop background color */
    background: {
      type: String,
      required: !1,
      default: "#ffffff"
    },
    /** Show label under the spinner */
    showLabel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** Label text */
    label: {
      type: String,
      required: !1,
      default: () => {
        const { t } = js();
        return t("ECLV3.LOADER.LABEL");
      }
    }
  },
  setup(t) {
    let e = "";
    const n = D1(t.label);
    return t.panel && (e += `background-color: ${t.background};`, e += `opacity: ${t.opacity};`), {
      loaderLabel: n,
      styles: e,
      classes: "" + t.size
    };
  }
}), Eu = (t) => ($s("data-v-c0b58c9f"), t = t(), Us(), t), au1 = { class: "ecl-loader__wrapper" }, ou1 = /* @__PURE__ */ Eu(() => /* @__PURE__ */ C("div", null, null, -1)), cu1 = /* @__PURE__ */ Eu(() => /* @__PURE__ */ C("div", null, null, -1)), hu1 = /* @__PURE__ */ Eu(() => /* @__PURE__ */ C("div", null, null, -1)), uu1 = /* @__PURE__ */ Eu(() => /* @__PURE__ */ C("div", null, null, -1)), du1 = [
  ou1,
  cu1,
  hu1,
  uu1
], fu1 = ["innerHTML"];
function vu1(t, e, n, i, s, l) {
  return T(), N("div", {
    class: f2(["ecl-loader", { "ecl-loader--panel": t.panel, "ecl-loader--fixed": t.fixed, "ecl-loader--stretch": t.stretch }]),
    style: Rt(t.styles)
  }, [
    C("div", au1, [
      C("div", {
        class: f2(["ecl-loader__icon", `ecl-loader__icon--size-${t.size}`])
      }, du1, 2),
      t.showLabel ? (T(), N("span", {
        key: 0,
        class: "ecl-loader__info-label ecl-u-mt-xs",
        innerHTML: t.loaderLabel
      }, null, 8, fu1)) : m2("", !0)
    ])
  ], 6);
}
const pu1 = /* @__PURE__ */ f4(ru1, [["render", vu1], ["__scopeId", "data-v-c0b58c9f"]]);
var qL = /* @__PURE__ */ ((t) => (t.XS = "xs", t.S = "s", t.M = "m", t.L = "l", t.XL = "xl", t))(qL || {});
c2({
  name: "EclLoader",
  props: {
    size: {
      type: String,
      required: !1,
      default: "m",
      validator: (t) => Object.values(qL).includes(t)
    },
    /** Crea un backdrop */
    panel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** Posiziona in "fixed" il loader */
    fixed: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** Stretch dell'altezza alla full height del contenitore */
    stretch: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** Opacità del backdrop */
    opacity: {
      type: Number,
      required: !1,
      default: 0.8
    },
    /** Backdrop background color */
    background: {
      type: String,
      required: !1,
      default: "#ffffff"
    },
    /** Show label under the spinner */
    showLabel: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** Label text */
    label: {
      type: String,
      required: !1,
      default: () => {
        const { t } = js();
        return t("ECLV3.LOADER.LABEL");
      }
    }
  },
  setup(t) {
    let e = "";
    const n = D1(t.label);
    return t.panel && (e += `background-color: ${t.background};`, e += `opacity: ${t.opacity};`), {
      loaderLabel: n,
      styles: e,
      classes: "" + t.size
    };
  }
});
const wL = [
  "arrow-left",
  "audio",
  "book",
  "brochure",
  "budget",
  "calendar",
  "camera",
  "chain",
  "check-filled",
  "check",
  "clock-filled",
  "clock",
  "close-filled",
  "close-outline",
  "close",
  "copy",
  "corner-arrow",
  "data",
  "digital",
  "document",
  "download",
  "edit",
  "email",
  "energy",
  "error-outline",
  "error",
  "euro",
  "event",
  "external-events",
  "external",
  "faq",
  "feedback",
  "file-blank",
  "file",
  "folder",
  "fullscreen",
  "global",
  "growth",
  "hamburger",
  "image",
  "infographic",
  "information-outline",
  "information-round",
  "information",
  "laco-filled",
  "laco",
  "list",
  "livestreaming",
  "location-filled",
  "location",
  "log-in-outline",
  "log-in",
  "logged-in",
  "minus-outline",
  "minus",
  "multiple-files",
  "organigram",
  "package",
  "pause-filled",
  "pause-outline",
  "pause",
  "play-filled",
  "play-outline",
  "play",
  "plus-filled",
  "plus-outline",
  "plus",
  "presentation",
  "print",
  "regulation",
  "rss",
  "search",
  "settings",
  "share-filled",
  "share",
  "shopping-bag",
  "solid-arrow",
  "sort-carets",
  "spinner",
  "spreadsheet",
  "star-filled",
  "star-outline",
  "tag",
  "trash",
  "upload",
  "warning-outline",
  "warning-round",
  "warning"
], zL = [
  "arrow-left",
  "audio",
  "book",
  "brochure",
  "budget",
  "calendar",
  "camera",
  "chain",
  "check-filled",
  "check",
  "clock-filled",
  "clock",
  "close-filled",
  "close-outline",
  "close",
  "copy",
  "corner-arrow",
  "data",
  "digital",
  "document",
  "download",
  "edit",
  "email",
  "energy",
  "error-outline",
  "error",
  "euro",
  "event",
  "external-events",
  "external",
  "faq",
  "feedback",
  "file-blank",
  "file",
  "folder",
  "fullscreen",
  "global",
  "growth",
  "hamburger",
  "image",
  "infographic",
  "information-outline",
  "information-round",
  "information",
  "laco-filled",
  "laco",
  "list",
  "livestreaming",
  "location-filled",
  "location",
  "log-in-outline",
  "log-in",
  "logged-in",
  "minus-outline",
  "minus",
  "multiple-files",
  "organigram",
  "package",
  "pause-filled",
  "pause-outline",
  "pause",
  "play-filled",
  "play-outline",
  "play",
  "plus-filled",
  "plus-outline",
  "plus",
  "presentation",
  "print",
  "regulation",
  "rss",
  "search",
  "settings",
  "share-filled",
  "share",
  "shopping-bag",
  "solid-arrow",
  "sort-carets",
  "spinner",
  "spreadsheet",
  "star-filled",
  "star-outline",
  "tag",
  "trash",
  "upload",
  "warning-outline",
  "warning-round",
  "warning"
], mu1 = N1.concat(wL, zL);
var ML = /* @__PURE__ */ ((t) => (t.XS2 = "2xs", t.XS = "xs", t.S = "s", t.M = "m", t.L = "l", t.XL = "xl", t.XL2 = "2xl", t.Fluid = "fluid", t))(ML || {}), bL = /* @__PURE__ */ ((t) => (t.None = "", t.Default = "default", t.Inverted = "inverted", t.Primary = "primary", t))(bL || {});
const gu1 = [0, 45, 90, 135, 180, 225, 270, 315], yu1 = {
  classes: {
    required: !1,
    type: Array
  },
  icon: {
    required: !0,
    type: String,
    validator: (t) => mu1.includes(t)
  },
  rotate: {
    required: !1,
    // type: Number,
    validator: (t) => gu1.includes(t)
  },
  size: {
    default: "xs",
    required: !1,
    type: String,
    validator: (t) => Object.values(ML).includes(t)
  },
  color: {
    required: !1,
    validator: (t) => Object.values(bL).includes(t)
  }
}, _u1 = c2({
  name: "EclIcon",
  props: yu1,
  setup(t) {
    const e = d4().theme, n = g1(() => "0 0 48 48"), i = gL(), s = g1(() => {
      const l = i[e][t.icon];
      if (N1.isNil(l))
        console.error(`Icon ${t.icon} not found!`);
      else
        return l;
    });
    return {
      viewBox: n,
      iconMetaCmp: s,
      svgClass: g1(() => {
        const l = t.classes ? [...t.classes] : [];
        return t.size && t.size !== "" && l.push(`ecl-icon--${t.size}`), t.color && t.color !== "" && l.push(`ecl-icon--${t.color}`), t.rotate && t.rotate !== "" && l.push(`ecl-icon--rotate-${t.rotate}`), l.unshift("ecl-icon"), l.join(" ");
      })
    };
  }
});
function qu1(t, e, n, i, s, l) {
  return T(), v2(be(t.iconMetaCmp), {
    "aria-hidden": "true",
    focusable: "false",
    viewBox: t.viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    class: f2(t.svgClass)
  }, null, 8, ["viewBox", "class"]);
}
const Ie = /* @__PURE__ */ f4(_u1, [["render", qu1], ["__scopeId", "data-v-d73fc6e0"]]), wu1 = N1.concat(wL, zL);
var ye = /* @__PURE__ */ ((t) => (t.XS2 = "2xs", t.XS = "xs", t.S = "s", t.M = "m", t.L = "l", t.XL = "xl", t.XL2 = "2xl", t.Fluid = "fluid", t))(ye || {}), LL = /* @__PURE__ */ ((t) => (t.None = "", t.Default = "default", t.Inverted = "inverted", t.Primary = "primary", t))(LL || {});
const zu1 = [0, 45, 90, 135, 180, 225, 270, 315], c0 = {
  classes: {
    required: !1,
    type: Array
  },
  icon: {
    required: !0,
    type: String,
    validator: (t) => wu1.includes(t)
  },
  rotate: {
    required: !1,
    // type: Number,
    validator: (t) => zu1.includes(t)
  },
  size: {
    default: "xs",
    required: !1,
    type: String,
    validator: (t) => Object.values(ye).includes(t)
  },
  color: {
    required: !1,
    validator: (t) => Object.values(LL).includes(t)
  }
};
c2({
  name: "EclIcon",
  props: c0,
  setup(t) {
    const e = d4().theme, n = g1(() => "0 0 48 48"), i = gL(), s = g1(() => {
      const l = i[e][t.icon];
      if (N1.isNil(l))
        console.error(`Icon ${t.icon} not found!`);
      else
        return l;
    });
    return {
      viewBox: n,
      iconMetaCmp: s,
      svgClass: g1(() => {
        const l = t.classes ? [...t.classes] : [];
        return t.size && t.size !== "" && l.push(`ecl-icon--${t.size}`), t.color && t.color !== "" && l.push(`ecl-icon--${t.color}`), t.rotate && t.rotate !== "" && l.push(`ecl-icon--rotate-${t.rotate}`), l.unshift("ecl-icon"), l.join(" ");
      })
    };
  }
});
const Mu1 = c2({
  name: "EclHeading",
  props: {
    level: {
      type: [String, Number],
      required: !0
    },
    class: {
      type: String,
      required: !1
    },
    widthFluid: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  render() {
    return typeof this.$slots.default == "function" ? w8(
      "h" + this.level,
      {
        class: this.classes()
      },
      this.$slots.default()
    ) : w8("h" + this.level, {
      class: this.classes(),
      domProps: this.$attrs.innerHTML
    });
  },
  methods: {
    classes() {
      const t = "ecl-u-type-heading-", e = [`${t}${this.level}`, this.class];
      return this.$props.widthFluid && e.push(`${t}-width-fluid`), e.join(" ");
    }
  }
}), xL = /* @__PURE__ */ f4(Mu1, [["__scopeId", "data-v-cbf61ceb"]]);
var SL = /* @__PURE__ */ ((t) => (t.LEAD = "lead", t.M = "m", t.S = "s", t.XS = "xs", t))(SL || {});
const bu1 = {
  class: {
    type: String,
    required: !1
  },
  type: {
    type: String,
    required: !1,
    default: "m",
    validator: (t) => Object.values(SL).includes(t)
  },
  widthFluid: {
    type: Boolean,
    required: !1,
    default: !0
  }
}, Lu1 = c2({
  name: "EclParagraph",
  props: bu1,
  render() {
    return typeof this.$slots.default == "function" ? w8(
      "p",
      {
        class: this.classes()
      },
      this.$slots.default()
    ) : w8("p", {
      class: this.classes(),
      domProps: this.$attrs.innerHTML
    });
  },
  methods: {
    classes() {
      const t = this.class ?? "", e = [`ecl-u-type-paragraph-${this.type}`, t];
      return this.$props.widthFluid && e.push("ecl-u-type-paragraph-width-fluid"), e.join(" ").trim();
    }
  }
}), zr = /* @__PURE__ */ f4(Lu1, [["__scopeId", "data-v-d214e3a9"]]);
var fa = /* @__PURE__ */ ((t) => (t.LEAD = "lead", t.M = "m", t.S = "s", t.XS = "xs", t))(fa || {});
const CL = {
  class: {
    type: String,
    required: !1
  },
  type: {
    type: String,
    required: !1,
    default: "m",
    validator: (t) => Object.values(fa).includes(t)
  },
  widthFluid: {
    type: Boolean,
    required: !1,
    default: !0
  }
};
c2({
  name: "EclParagraph",
  props: CL,
  render() {
    return typeof this.$slots.default == "function" ? w8(
      "p",
      {
        class: this.classes()
      },
      this.$slots.default()
    ) : w8("p", {
      class: this.classes(),
      domProps: this.$attrs.innerHTML
    });
  },
  methods: {
    classes() {
      const t = this.class ?? "", e = [`ecl-u-type-paragraph-${this.type}`, t];
      return this.$props.widthFluid && e.push("ecl-u-type-paragraph-width-fluid"), e.join(" ").trim();
    }
  }
});
var b_ = /* @__PURE__ */ ((t) => (t.Before = "before", t.After = "after", t))(b_ || {}), kL = /* @__PURE__ */ ((t) => (t.Primary = "primary", t.Secondary = "secondary", t.CallToAction = "cta", t.CTA = "cta", t.Tertiary = "tertiary", t.Text = "ghost", t.Ghost = "ghost", t.Icon = "icon", t))(kL || {});
const xu1 = {
  isDisabled: {
    required: !1,
    default: !1,
    type: Boolean
  },
  text: {
    required: !1,
    type: String
  },
  ariaLabel: {
    required: !1,
    type: String
  },
  type: {
    required: !1,
    default: "primary",
    type: String,
    validator: (t) => Object.values(kL).includes(t)
  },
  class: {
    required: !1,
    type: String
  },
  url: {
    required: !1,
    type: String,
    default: null
  },
  target: {
    required: !1,
    type: String,
    default: "_self"
  },
  size: {
    required: !1,
    type: String,
    default: "m"
    /* M */
  },
  iconOnly: {
    required: !1,
    type: Boolean
  },
  icon: {
    ...c0.icon,
    required: !1
  },
  iconPosition: {
    required: !1,
    type: String,
    default: "after",
    enum: Object.values(b_)
  },
  iconSize: {
    ...c0.size,
    default: (t) => {
      if (!N1.isNil(t == null ? void 0 : t.size) && N1.isNil(t == null ? void 0 : t.iconSize))
        switch (t.size) {
          case "xs":
          case "s":
            return "xs";
          case "m":
            return "s";
          case "l":
            return "l";
        }
      return "xs";
    }
  },
  iconRotate: c0.rotate,
  iconContainerClass: {
    default: "",
    required: !1,
    type: String
  }
}, Su1 = c2({
  name: "EclButton",
  components: { EclIcon: Ie, AppLink: ui },
  props: xu1,
  setup(t, { slots: e }) {
    const n = g1(() => {
      const d = "ecl-button", v = [d, `${d}--${t.type}`, t.class];
      return N1.isNil(t == null ? void 0 : t.size) || v.push(`${d}--size-${t.size}`), (N1.isNil(e == null ? void 0 : e.default) && N1.isNil(t.text) || t.iconOnly === !0) && v.push(`${d}--icon-only`), v.join(" ");
    }), i = g1(() => !N1.isNil(t.url) && !N1.isEmpty(t.url)), s = g1(() => n9(t.target)), l = g1(
      () => !N1.isNil(t.icon) && !N1.isEmpty(t.icon) && t.icon !== ""
    ), a = (d) => t.iconPosition ? t.iconPosition === d : !1, o = () => {
      const d = ["ecl-button__container"];
      return t.iconContainerClass && d.push(t.iconContainerClass), d.join(" ");
    }, h = (d) => {
      const v = ["ecl-button__icon"];
      return t.text && (d === "after" ? v.push("ecl-button__icon--after") : v.push("ecl-button__icon--before")), v.join(" ");
    }, u = g1(
      () => t.ariaLabel ? t.ariaLabel : t.text
    );
    return {
      className: n,
      iconInPosition: a,
      EclButtonIconPosition: b_,
      iconClassName: h,
      iconContainerAdditionalClass: o,
      ariaText: u,
      isLink: i,
      hasIcon: l,
      linkTarget: s
    };
  }
}), Cu1 = ["aria-label", "disabled"], ku1 = ["aria-label", "disabled"], Eu1 = ["innerHTML"], Au1 = ["innerHTML"];
function Fu1(t, e, n, i, s, l) {
  const a = V2("ecl-icon"), o = V2("app-link");
  return t.isLink === !1 && !t.hasIcon ? (T(), N("button", {
    key: 0,
    "aria-label": t.ariaText,
    class: f2(t.className),
    disabled: t.isDisabled
  }, [
    J2(t.$slots, "default", {}, () => [
      K3(pt(t.text), 1)
    ], !0)
  ], 10, Cu1)) : t.isLink === !1 && t.hasIcon ? (T(), N("button", {
    key: 1,
    "aria-label": t.ariaText,
    class: f2(t.className),
    disabled: t.isDisabled
  }, [
    C("span", {
      class: f2(t.iconContainerAdditionalClass())
    }, [
      t.icon && t.iconInPosition(t.EclButtonIconPosition.Before) ? (T(), v2(a, {
        key: 0,
        class: "ecl-button__icon",
        icon: t.icon,
        size: t.iconSize,
        rotate: t.iconRotate
      }, null, 8, ["icon", "size", "rotate"])) : m2("", !0),
      t.text ? (T(), N("span", {
        key: 1,
        class: "ecl-button__label",
        "data-ecl-label": "true",
        innerHTML: t.text
      }, null, 8, Eu1)) : m2("", !0),
      t.icon && t.iconInPosition(t.EclButtonIconPosition.After) ? (T(), v2(a, {
        key: 2,
        class: "ecl-button__icon",
        icon: t.icon,
        size: t.iconSize,
        rotate: t.iconRotate
      }, null, 8, ["icon", "size", "rotate"])) : m2("", !0)
    ], 2)
  ], 10, ku1)) : t.isLink === !0 && !t.hasIcon ? (T(), v2(o, {
    key: 2,
    to: t.url,
    target: t.linkTarget,
    "aria-label": t.ariaText,
    class: f2(t.className)
  }, {
    default: Q2(() => [
      J2(t.$slots, "default", {}, () => [
        K3(pt(t.text), 1)
      ], !0)
    ]),
    _: 3
  }, 8, ["to", "target", "aria-label", "class"])) : (T(), v2(o, {
    key: 3,
    to: t.url,
    target: t.linkTarget,
    "aria-label": t.ariaText,
    class: f2(t.className)
  }, {
    default: Q2(() => [
      C("span", {
        class: f2(t.iconContainerAdditionalClass())
      }, [
        t.icon && t.iconInPosition(t.EclButtonIconPosition.Before) ? (T(), v2(a, {
          key: 0,
          class: "ecl-button__icon",
          icon: t.icon,
          size: t.iconSize,
          rotate: t.iconRotate
        }, null, 8, ["icon", "size", "rotate"])) : m2("", !0),
        t.text ? (T(), N("span", {
          key: 1,
          class: "ecl-button__label",
          "data-ecl-label": "true",
          innerHTML: t.text
        }, null, 8, Au1)) : m2("", !0),
        t.icon && t.iconInPosition(t.EclButtonIconPosition.After) ? (T(), v2(a, {
          key: 2,
          class: "ecl-button__icon",
          icon: t.icon,
          size: t.iconSize,
          rotate: t.iconRotate
        }, null, 8, ["icon", "size", "rotate"])) : m2("", !0)
      ], 2)
    ]),
    _: 1
  }, 8, ["to", "target", "aria-label", "class"]));
}
const Lt = /* @__PURE__ */ f4(Su1, [["render", Fu1], ["__scopeId", "data-v-04ae7d4c"]]);
var di = /* @__PURE__ */ ((t) => (t.Before = "before", t.After = "after", t))(di || {}), I4 = /* @__PURE__ */ ((t) => (t.Primary = "primary", t.Secondary = "secondary", t.CallToAction = "cta", t.CTA = "cta", t.Tertiary = "tertiary", t.Text = "ghost", t.Ghost = "ghost", t.Icon = "icon", t))(I4 || {});
const EL = {
  isDisabled: {
    required: !1,
    default: !1,
    type: Boolean
  },
  text: {
    required: !1,
    type: String
  },
  ariaLabel: {
    required: !1,
    type: String
  },
  type: {
    required: !1,
    default: "primary",
    type: String,
    validator: (t) => Object.values(I4).includes(t)
  },
  class: {
    required: !1,
    type: String
  },
  url: {
    required: !1,
    type: String,
    default: null
  },
  target: {
    required: !1,
    type: String,
    default: "_self"
  },
  size: {
    required: !1,
    type: String,
    default: "m"
    /* M */
  },
  iconOnly: {
    required: !1,
    type: Boolean
  },
  icon: {
    ...c0.icon,
    required: !1
  },
  iconPosition: {
    required: !1,
    type: String,
    default: "after",
    enum: Object.values(di)
  },
  iconSize: {
    ...c0.size,
    default: (t) => {
      if (!N1.isNil(t == null ? void 0 : t.size) && N1.isNil(t == null ? void 0 : t.iconSize))
        switch (t.size) {
          case "xs":
          case "s":
            return "xs";
          case "m":
            return "s";
          case "l":
            return "l";
        }
      return "xs";
    }
  },
  iconRotate: c0.rotate,
  iconContainerClass: {
    default: "",
    required: !1,
    type: String
  }
};
c2({
  name: "EclButton",
  components: { EclIcon: Ie, AppLink: ui },
  props: EL,
  setup(t, { slots: e }) {
    const n = g1(() => {
      const d = "ecl-button", v = [d, `${d}--${t.type}`, t.class];
      return N1.isNil(t == null ? void 0 : t.size) || v.push(`${d}--size-${t.size}`), (N1.isNil(e == null ? void 0 : e.default) && N1.isNil(t.text) || t.iconOnly === !0) && v.push(`${d}--icon-only`), v.join(" ");
    }), i = g1(() => !N1.isNil(t.url) && !N1.isEmpty(t.url)), s = g1(() => n9(t.target)), l = g1(
      () => !N1.isNil(t.icon) && !N1.isEmpty(t.icon) && t.icon !== ""
    ), a = (d) => t.iconPosition ? t.iconPosition === d : !1, o = () => {
      const d = ["ecl-button__container"];
      return t.iconContainerClass && d.push(t.iconContainerClass), d.join(" ");
    }, h = (d) => {
      const v = ["ecl-button__icon"];
      return t.text && (d === "after" ? v.push("ecl-button__icon--after") : v.push("ecl-button__icon--before")), v.join(" ");
    }, u = g1(
      () => t.ariaLabel ? t.ariaLabel : t.text
    );
    return {
      className: n,
      iconInPosition: a,
      EclButtonIconPosition: di,
      iconClassName: h,
      iconContainerAdditionalClass: o,
      ariaText: u,
      isLink: i,
      hasIcon: l,
      linkTarget: s
    };
  }
});
var hy = /* @__PURE__ */ ((t) => (t.Before = "before", t.After = "after", t))(hy || {}), AL = /* @__PURE__ */ ((t) => (t.Default = "default", t.Standalone = "standalone", t.CallToAction = "cta", t.CTA = "cta", t.Primary = "primary", t.Secondary = "secondary", t))(AL || {});
const Tu1 = c2({
  name: "EclLink",
  components: {
    AppLink: ui,
    EclIcon: Ie
  },
  props: {
    type: {
      type: String,
      required: !1,
      default: "default",
      validator: (t) => Object.values(AL).includes(t)
    },
    url: {
      type: String,
      required: !1,
      default: "javascript:void(0)"
    },
    target: {
      type: String,
      required: !1,
      default: "_self"
    },
    label: {
      type: String,
      required: !1
    },
    ariaLabel: {
      type: String,
      required: !1
    },
    inverted: {
      type: Boolean,
      required: !1,
      default: !1
    },
    size: {
      required: !1,
      type: String,
      default: "m"
      /* M */
    },
    iconOnly: {
      required: !1,
      type: Boolean
    },
    iconPosition: {
      type: String,
      required: !1,
      default: "after",
      validator: (t) => Object.values(hy).includes(t)
    },
    icon: {
      ...c0.icon,
      required: !1
    },
    iconRotate: c0.rotate,
    iconSize: {
      ...c0.size,
      default: (t) => {
        if (!N1.isNil(t == null ? void 0 : t.size) && N1.isNil(t == null ? void 0 : t.iconSize))
          switch (t.size) {
            case "xs":
            case "s":
              return "xs";
            case "m":
              return "s";
            case "l":
              return "l";
          }
        return "xs";
      }
    }
  },
  setup(t, { slots: e }) {
    N1.isNil(t.ariaLabel) && N1.isNil(t.label) && console.error("EclLink: you must provide almost ariaLabel or label!");
    const n = function() {
      const s = "ecl-link", l = [s];
      return l.push("ecl-link--" + t.type), t.inverted && l.push(`${s}--inverted`), N1.isNil(t == null ? void 0 : t.size) || l.push(`${s}--size-${t.size}`), t.icon && (l.push(`${s}--icon`), l.push(`${s}--icon-${t.iconPosition}`)), (N1.isNil(e == null ? void 0 : e.default) && N1.isNil(t.label) || t.iconOnly === !0) && l.push(`${s}--icon-only`), l.join(" ");
    }, i = g1(() => n9(t.target));
    return {
      cAriaLabel: g1(() => t.ariaLabel ? t.ariaLabel : t == null ? void 0 : t.label),
      EclLinkIconPosition: hy,
      className: n,
      linkTarget: i
    };
  }
}), Iu1 = ["innerHTML"], Ou1 = ["innerHTML"];
function Nu1(t, e, n, i, s, l) {
  const a = V2("ecl-icon"), o = V2("app-link");
  return T(), v2(o, {
    to: t.url,
    target: t.linkTarget,
    "aria-label": t.cAriaLabel,
    class: f2(t.className())
  }, {
    default: Q2(() => [
      J2(t.$slots, "default", {}, () => [
        t.icon ? (T(), N(I3, { key: 1 }, [
          t.iconPosition === t.EclLinkIconPosition.Before ? (T(), v2(a, {
            key: 0,
            class: "ecl-link__icon",
            icon: t.icon,
            size: t.iconSize,
            rotate: t.iconRotate
          }, null, 8, ["icon", "size", "rotate"])) : m2("", !0),
          t.label ? (T(), N("span", {
            key: 1,
            class: "ecl-link__label",
            innerHTML: t.label
          }, null, 8, Ou1)) : m2("", !0),
          t.iconPosition === t.EclLinkIconPosition.After ? (T(), v2(a, {
            key: 2,
            class: "ecl-link__icon",
            icon: t.icon,
            size: t.iconSize,
            rotate: t.iconRotate
          }, null, 8, ["icon", "size", "rotate"])) : m2("", !0)
        ], 64)) : (T(), N("span", {
          key: 0,
          innerHTML: t.label
        }, null, 8, Iu1))
      ], !0)
    ]),
    _: 3
  }, 8, ["to", "target", "aria-label", "class"]);
}
const O4 = /* @__PURE__ */ f4(Tu1, [["render", Nu1], ["__scopeId", "data-v-3645f685"]]);
var dn = /* @__PURE__ */ ((t) => (t.Before = "before", t.After = "after", t))(dn || {}), f0 = /* @__PURE__ */ ((t) => (t.Default = "default", t.Standalone = "standalone", t.CallToAction = "cta", t.CTA = "cta", t.Primary = "primary", t.Secondary = "secondary", t))(f0 || {});
c2({
  name: "EclLink",
  components: {
    AppLink: ui,
    EclIcon: Ie
  },
  props: {
    type: {
      type: String,
      required: !1,
      default: "default",
      validator: (t) => Object.values(f0).includes(t)
    },
    url: {
      type: String,
      required: !1,
      default: "javascript:void(0)"
    },
    target: {
      type: String,
      required: !1,
      default: "_self"
    },
    label: {
      type: String,
      required: !1
    },
    ariaLabel: {
      type: String,
      required: !1
    },
    inverted: {
      type: Boolean,
      required: !1,
      default: !1
    },
    size: {
      required: !1,
      type: String,
      default: "m"
      /* M */
    },
    iconOnly: {
      required: !1,
      type: Boolean
    },
    iconPosition: {
      type: String,
      required: !1,
      default: "after",
      validator: (t) => Object.values(dn).includes(t)
    },
    icon: {
      ...c0.icon,
      required: !1
    },
    iconRotate: c0.rotate,
    iconSize: {
      ...c0.size,
      default: (t) => {
        if (!N1.isNil(t == null ? void 0 : t.size) && N1.isNil(t == null ? void 0 : t.iconSize))
          switch (t.size) {
            case "xs":
            case "s":
              return "xs";
            case "m":
              return "s";
            case "l":
              return "l";
          }
        return "xs";
      }
    }
  },
  setup(t, { slots: e }) {
    N1.isNil(t.ariaLabel) && N1.isNil(t.label) && console.error("EclLink: you must provide almost ariaLabel or label!");
    const n = function() {
      const s = "ecl-link", l = [s];
      return l.push("ecl-link--" + t.type), t.inverted && l.push(`${s}--inverted`), N1.isNil(t == null ? void 0 : t.size) || l.push(`${s}--size-${t.size}`), t.icon && (l.push(`${s}--icon`), l.push(`${s}--icon-${t.iconPosition}`)), (N1.isNil(e == null ? void 0 : e.default) && N1.isNil(t.label) || t.iconOnly === !0) && l.push(`${s}--icon-only`), l.join(" ");
    }, i = g1(() => n9(t.target));
    return {
      cAriaLabel: g1(() => t.ariaLabel ? t.ariaLabel : t == null ? void 0 : t.label),
      EclLinkIconPosition: dn,
      className: n,
      linkTarget: i
    };
  }
});
const Pu1 = c2({
  name: "EclBreadcrumb",
  components: {
    AppLink: ui,
    EclLink: O4,
    EclIcon: Ie,
    EclButton: Lt
  },
  props: {
    type: {
      type: String,
      required: !1,
      default: "core"
      /* Core */
    },
    breadcrumb: {
      type: Array,
      required: !1,
      default: () => []
    },
    ellipsisLimit: {
      type: Number,
      required: !1,
      default: 3
      // if "0" don't attach ellipsis
    }
  },
  setup(t) {
    const e = D1(!1), n = D1(!1), i = (a) => k6("ecl-breadcrumb", null, a), s = g1(
      () => {
        const a = t.breadcrumb.length, o = t.ellipsisLimit - 1;
        return N1.map(
          t.breadcrumb,
          (h, u) => {
            const d = a - o, v = t.ellipsisLimit !== 0 && u !== 0 && d >= u + 1 && !e.value && u >= 1 && u < d;
            return n.value === !1 && (n.value = v), N1.assign(
              {
                expandable: v,
                itemType: v ? "expandable" : "static"
              },
              h
            );
          }
        );
      }
    ), l = g1(() => ({
      role: "presentation",
      class: i("__icon"),
      icon: "corner-arrow",
      rotate: 90,
      size: ye.Fluid
    }));
    return {
      EclButtonType: I4,
      hasEllipsis: n,
      isNegative: g1(
        () => t.type === "core"
        /* Core */
      ),
      className: i,
      expandAll: () => {
        e.value = !0, n.value = !1;
      },
      linkedBreadcrumb: g1(() => s.value.slice(0, -1)),
      lastBreadcrumb: g1(
        () => s.value[s.value.length - 1]
      ),
      eclIconProps: l,
      EclIconSize: ye
    };
  }
}), Bu1 = ["aria-label"], Vu1 = ["data-ecl-breadcrumb-item", "ariaHidden"], Ru1 = ["aria-label", "innerHTML"];
function Hu1(t, e, n, i, s, l) {
  var a, o, h;
  const u = V2("ecl-button"), d = V2("ecl-icon"), v = V2("app-link");
  return T(), N("nav", {
    class: f2(t.className()),
    "aria-label": t.$t("ECLV3.BREADCRUMB.HERE")
  }, [
    J2(t.$slots, "breadcrumb_before_list", {
      class: f2(t.className("__segment"))
    }, void 0, !0),
    C("ol", {
      class: f2(t.className("__container"))
    }, [
      J2(t.$slots, "breadcrumb_before_item", {
        class: f2(t.className("__segment")),
        eclIconProps: t.eclIconProps
      }, void 0, !0),
      (T(!0), N(I3, null, Ve(t.linkedBreadcrumb, (m, p) => (T(), N(I3, {
        key: (m == null ? void 0 : m.title) ?? p
      }, [
        t.hasEllipsis && p === 1 ? (T(), N("li", {
          key: 0,
          class: f2([t.className("__segment"), t.className("__segment--ellipsis")]),
          "aria-hidden": "false",
          "data-ecl-breadcrumb-ellipsis": "true",
          onClick: e[0] || (e[0] = (..._) => t.expandAll && t.expandAll(..._))
        }, [
          _3(u, {
            class: f2(t.className("__ellipsis")),
            "aria-label": t.$t("ECLV3.BREADCRUMB.CLICK_TO_EXPAND"),
            "data-ecl-breadcrumb-ellipsis-button": "",
            type: t.EclButtonType.Ghost
          }, {
            default: Q2(() => [
              K3("…")
            ]),
            _: 1
          }, 8, ["class", "aria-label", "type"]),
          _3(d, Ht({ ref_for: !0 }, t.eclIconProps), null, 16)
        ], 2)) : m2("", !0),
        m ? (T(), N("li", {
          key: 1,
          class: f2(t.className("__segment")),
          "data-ecl-breadcrumb-item": m.itemType,
          ariaHidden: m.expandable
        }, [
          _3(v, {
            to: m.url,
            class: f2(`${t.className("__link")} ecl-link ecl-link--standalone ${m == null ? void 0 : m.classes}`),
            style: Rt(m == null ? void 0 : m.style),
            "aria-label": (m == null ? void 0 : m.label) ?? m.title,
            innerHTML: m.title
          }, null, 8, ["to", "class", "style", "aria-label", "innerHTML"]),
          _3(d, Ht({ ref_for: !0 }, t.eclIconProps), null, 16)
        ], 10, Vu1)) : m2("", !0)
      ], 64))), 128)),
      t.lastBreadcrumb ? (T(), N("li", {
        key: 0,
        class: f2([t.className("__segment"), t.className("__current-page"), (a = t.lastBreadcrumb) == null ? void 0 : a.classes]),
        "aria-current": "page",
        "data-ecl-breadcrumb-item": "static",
        "aria-hidden": "false",
        style: Rt((o = t.lastBreadcrumb) == null ? void 0 : o.style),
        "aria-label": ((h = t.lastBreadcrumb) == null ? void 0 : h.label) ?? t.lastBreadcrumb.title,
        innerHTML: t.lastBreadcrumb.title
      }, null, 14, Ru1)) : m2("", !0),
      J2(t.$slots, "breadcrumb_after_item", {
        class: f2(t.className("__segment")),
        eclIconProps: t.eclIconProps
      }, void 0, !0)
    ], 2),
    J2(t.$slots, "breadcrumb_after_list", {
      class: f2(t.className("__segment"))
    }, void 0, !0)
  ], 10, Bu1);
}
const Oh = /* @__PURE__ */ f4(Pu1, [["render", Hu1], ["__scopeId", "data-v-12ee0d6c"]]);
c2({
  name: "EclBreadcrumb",
  components: {
    AppLink: ui,
    EclLink: O4,
    EclIcon: Ie,
    EclButton: Lt
  },
  props: {
    type: {
      type: String,
      required: !1,
      default: "core"
      /* Core */
    },
    breadcrumb: {
      type: Array,
      required: !1,
      default: () => []
    },
    ellipsisLimit: {
      type: Number,
      required: !1,
      default: 3
      // if "0" don't attach ellipsis
    }
  },
  setup(t) {
    const e = D1(!1), n = D1(!1), i = (a) => k6("ecl-breadcrumb", null, a), s = g1(
      () => {
        const a = t.breadcrumb.length, o = t.ellipsisLimit - 1;
        return N1.map(
          t.breadcrumb,
          (h, u) => {
            const d = a - o, v = t.ellipsisLimit !== 0 && u !== 0 && d >= u + 1 && !e.value && u >= 1 && u < d;
            return n.value === !1 && (n.value = v), N1.assign(
              {
                expandable: v,
                itemType: v ? "expandable" : "static"
              },
              h
            );
          }
        );
      }
    ), l = g1(() => ({
      role: "presentation",
      class: i("__icon"),
      icon: "corner-arrow",
      rotate: 90,
      size: ye.Fluid
    }));
    return {
      EclButtonType: I4,
      hasEllipsis: n,
      isNegative: g1(
        () => t.type === "core"
        /* Core */
      ),
      className: i,
      expandAll: () => {
        e.value = !0, n.value = !1;
      },
      linkedBreadcrumb: g1(() => s.value.slice(0, -1)),
      lastBreadcrumb: g1(
        () => s.value[s.value.length - 1]
      ),
      eclIconProps: l,
      EclIconSize: ye
    };
  }
});
function FL(t) {
  const e = S8(), n = ZA(), { items: i } = s3(t), s = (a) => {
    var o, h;
    return (h = (o = H(a)) == null ? void 0 : o.split("?")[0]) == null ? void 0 : h.split("#")[0];
  }, l = (a) => {
    const o = e.getRoutes();
    if (!N1.isNil(a) && /((http(s?)):\/\/)/gi.test(a) === !1) {
      const h = a.split("?")[0], u = N1.find(o, (d) => d.name === h);
      if (N1.isNil(u)) {
        const d = `/${a}`.replace(/\/\/+/g, "/");
        return `${window.location.origin}${d}`;
      } else
        return e.resolve({ name: a }).href;
    }
    return a;
  };
  return {
    navItems: g1(() => {
      const a = n == null ? void 0 : n.path, o = (h) => {
        const u = N1.assign(
          {
            target: "self",
            current: !1,
            hasLink: !0,
            hasChildren: !1
          },
          h
        );
        let d = H(u.to);
        d && e != null && e.hasRoute(d) && (u.to = d = e.resolve({ name: d }).href), u.href = l(d), u.hasLink = !N1.isNil(u.to) && !N1.isEmpty(u.to) && u.to !== "javascript:void(0)", u.hasChildren = !N1.isNil(u.children) && N1.isArray(u.children), u.hasChildrenNullable = u.hasChildren ? !0 : null, u.current = N1.isNil(d) ? !1 : s(d) === a;
        let v = !1;
        return u.hasChildren && (u.children = N1.map(u.children, (m) => {
          const p = o(m);
          return v === !1 && p.current && (v = !0), p;
        })), v && (u.current = !0), u;
      };
      return N1.map(H(i), (h) => o(h));
    })
  };
}
function TL(t) {
  const e = t.useData.eclMenuInner, n = t.useData.navItemsElWrapper, i = t.router;
  return {
    navigateTo: (s, l = null) => {
      var a;
      let o = !1, h = !1;
      if (!N1.isNil(l)) {
        const v = n.value[l];
        o = v.classList.contains("ecl-menu__item--has-children"), h = v.getAttribute("aria-expanded") === "true";
      }
      const u = ((a = H(e)) == null ? void 0 : a.getAttribute("aria-hidden")) === "false", d = H(s.to);
      d && (u === !1 || o === !1 || h && o) && (N1.isString(d) && pL(d.toString()) ? window.open(d, n9(s.target)) : i.push(d));
    }
  };
}
function IL() {
  const t = D1(null), e = D1(null), n = D1([]);
  return {
    eclMenuRoot: t,
    eclMenuInner: e,
    navItemsElWrapper: n
  };
}
const Du1 = c2({
  name: "EclMenu",
  emits: ["open", "close"],
  components: {
    AppLink: ui,
    EclLink: O4,
    EclIcon: Ie,
    EclButton: Lt
  },
  props: {
    items: {
      type: Array,
      required: !0,
      default: null
    },
    attachSwipeListener: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t, { emit: e }) {
    const n = g1(() => d4().theme === "ec");
    let i;
    const s = S8(), l = IL(), a = FL(t), o = TL({
      useData: l,
      router: s
    }), h = g1(() => C8());
    return d0(() => {
      l3(l.eclMenuRoot, (u) => {
        u && (i = ECL.Menu.autoInit(H(l.eclMenuRoot)));
      }), l3(
        () => t.items,
        (u) => {
          u.length > 0 && (i && i.destroy(), i = ECL.Menu.autoInit(H(l.eclMenuRoot)));
        },
        { immediate: !0 }
      ), s == null || s.afterEach(() => {
        i == null || i.handleClickOnClose(), i == null || i.inner.setAttribute("aria-hidden", "false"), setTimeout(() => e("close"), 200);
      });
    }), mn(() => {
      i == null || i.destroy();
    }), {
      isEc: n,
      isMobileTablet: h,
      ...l,
      ...a,
      ...o,
      toggleMenu: () => {
        i != null && i.isOpen ? setTimeout(() => e("close"), 200) : e("open");
      },
      isExpanded: (u) => {
        const d = H(l.navItemsElWrapper)[u];
        return d ? d.getAttribute("aria-expanded") === "true" : !1;
      },
      EclLinkType: f0,
      EclButtonIconPosition: di,
      EclButtonType: I4,
      EclIconSize: ye
    };
  }
}), $u1 = {
  ref: "eclMenuRoot",
  class: "ecl-menu",
  "data-ecl-menu": "",
  "data-ecl-auto-init": "Menu",
  role: "navigation"
}, Uu1 = { class: "ecl-container ecl-menu__container" }, ju1 = { class: "ecl-link__label" }, Gu1 = {
  class: "ecl-menu__inner",
  "data-ecl-menu-inner": ""
}, Wu1 = ["aria-label"], Yu1 = { class: "ecl-menu__title" }, Xu1 = { class: "ecl-menu__list" }, Ku1 = ["data-ecl-has-children", "aria-expanded"], Zu1 = ["href", "onClick", "target", "innerHTML"], Ju1 = ["innerHTML"], Qu1 = {
  key: 3,
  class: "ecl-menu__mega",
  "data-ecl-menu-mega": ""
}, ed1 = { class: "ecl-menu__sublist" }, td1 = ["href", "onClick", "target", "innerHTML"];
function nd1(t, e, n, i, s, l) {
  const a = V2("ecl-icon"), o = V2("ecl-link"), h = V2("ecl-button");
  return T(), N("nav", $u1, [
    C("div", {
      class: "ecl-menu__overlay",
      "data-ecl-menu-overlay": "",
      onClick: e[0] || (e[0] = (...u) => t.toggleMenu && t.toggleMenu(...u))
    }),
    C("div", Uu1, [
      _3(o, {
        type: "standalone",
        class: "ecl-menu__open ecl-button ecl-button--tertiary ecl-link--icon-only",
        ariaLabel: t.$t("ECLV3.MENU.LABEL"),
        "data-ecl-menu-open": "",
        url: "javascript:void(0)",
        onClick: t.toggleMenu
      }, {
        default: Q2(() => [
          _3(a, {
            size: "m",
            icon: "hamburger"
          }),
          t.isEc ? (T(), v2(a, {
            key: 0,
            size: "m",
            icon: "close"
          })) : (T(), v2(a, {
            key: 1,
            size: "s",
            icon: "close-filled"
          })),
          C("span", ju1, pt(t.$t("ECLV3.MENU.LABEL")), 1)
        ]),
        _: 1
      }, 8, ["ariaLabel", "onClick"]),
      C("section", Gu1, [
        C("header", {
          "aria-label": t.$t("ECLV3.MENU.LABEL"),
          class: "ecl-menu__inner-header"
        }, [
          _3(h, {
            class: "ecl-menu__close",
            "data-ecl-menu-close": "",
            icon: "close-filled",
            iconPosition: t.EclButtonIconPosition.After,
            text: t.$t("ECLV3.GENERAL.CLOSE"),
            ariaLabel: t.$t("ECLV3.GENERAL.CLOSE"),
            type: t.EclButtonType.Text,
            onClick: t.toggleMenu
          }, null, 8, ["iconPosition", "text", "ariaLabel", "type", "onClick"]),
          C("div", Yu1, pt(t.$t("ECLV3.MENU.LABEL")), 1),
          _3(h, {
            "data-ecl-menu-back": "",
            class: "ecl-menu__back",
            icon: "corner-arrow",
            iconPosition: t.EclButtonIconPosition.Before,
            iconRotate: 270,
            text: t.$t("ECLV3.MENU.BACK"),
            ariaLabel: t.$t("ECLV3.MENU.BACK"),
            type: t.EclButtonType.Ghost
          }, null, 8, ["iconPosition", "text", "ariaLabel", "type"])
        ], 8, Wu1),
        _3(h, {
          "data-ecl-menu-items-previous": "",
          class: "ecl-menu__items-previous",
          icon: "corner-arrow",
          iconSize: "s",
          rotate: 270,
          ariaLabel: "Previous items",
          type: t.EclButtonType.Ghost,
          tabindex: "-1",
          style: { display: "none" }
        }, null, 8, ["type"]),
        _3(h, {
          "data-ecl-menu-items-next": "",
          class: "ecl-menu__items-next",
          icon: "corner-arrow",
          iconSize: "s",
          rotate: 90,
          ariaLabel: "Next items",
          type: t.EclButtonType.Ghost,
          tabindex: "-1",
          style: { display: "none" }
        }, null, 8, ["type"]),
        C("ul", Xu1, [
          J2(t.$slots, "menu-list-prefix", {}, void 0, !0),
          (T(!0), N(I3, null, Ve(t.navItems, (u, d) => (T(), N("li", {
            class: f2(["ecl-menu__item", {
              "ecl-menu__item--current": u.current,
              "ecl-menu__item--has-children": u.hasChildren,
              "ecl-menu__item--col1": u.hasChildren && u.children.length < 5,
              "ecl-menu__item--col2": u.hasChildren && u.children.length >= 5 && u.children.length < 9,
              "ecl-menu__item--col3": u.hasChildren && u.children.length >= 9 && u.children.length < 13,
              "ecl-menu__item--full": u.hasChildren && u.children.length >= 13
            }]),
            "data-ecl-has-children": u.hasChildrenNullable,
            "data-ecl-menu-item": "",
            "aria-haspopup": "",
            "aria-expanded": t.isExpanded(d),
            ref_for: !0,
            ref: (v) => {
              t.navItemsElWrapper[d] = v;
            }
          }, [
            u.hasLink ? (T(), N("a", {
              key: 0,
              href: u.href,
              onClick: Et((v) => t.navigateTo(u, d), ["prevent"]),
              target: u.target,
              class: "ecl-link ecl-link--standalone ecl-menu__link",
              "data-ecl-menu-link": "",
              innerHTML: u.label
            }, null, 8, Zu1)) : (T(), N("span", {
              key: 1,
              class: "ecl-menu__link",
              "data-ecl-menu-link": "",
              innerHTML: u.label
            }, null, 8, Ju1)),
            u.hasChildren ? (T(), v2(h, {
              key: 2,
              "data-ecl-menu-caret": "",
              class: "ecl-menu__button-caret",
              icon: "corner-arrow",
              iconSize: "xs",
              iconRotate: t.isMobileTablet ? 90 : 180,
              ariaLabel: t.$t("ECLV3.MENU.ARIA_LABEL_CHILDREN_ITEM"),
              type: t.EclButtonType.Ghost
            }, null, 8, ["iconRotate", "ariaLabel", "type"])) : m2("", !0),
            u.hasChildren ? (T(), N("div", Qu1, [
              C("ul", ed1, [
                (T(!0), N(I3, null, Ve(u.children, (v, m) => (T(), N("li", {
                  key: m,
                  class: f2(["ecl-menu__subitem", { "ecl-menu__subitem--current": v.current }]),
                  "data-ecl-menu-subitem": ""
                }, [
                  C("a", {
                    href: v.to,
                    onClick: Et((p) => t.navigateTo(v), ["prevent"]),
                    target: v.target,
                    class: "ecl-link--standalone ecl-menu__sublink",
                    "data-ecl-menu-link": "",
                    innerHTML: v.label
                  }, null, 8, td1)
                ], 2))), 128))
              ])
            ])) : m2("", !0)
          ], 10, Ku1))), 256)),
          J2(t.$slots, "menu-list-suffix", {}, void 0, !0)
        ])
      ])
    ])
  ], 512);
}
const OL = /* @__PURE__ */ f4(Du1, [["render", nd1], ["__scopeId", "data-v-6181d414"]]);
c2({
  name: "EclMenu",
  emits: ["open", "close"],
  components: {
    AppLink: ui,
    EclLink: O4,
    EclIcon: Ie,
    EclButton: Lt
  },
  props: {
    items: {
      type: Array,
      required: !0,
      default: null
    },
    attachSwipeListener: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t, { emit: e }) {
    const n = g1(() => d4().theme === "ec");
    let i;
    const s = S8(), l = IL(), a = FL(t), o = TL({
      useData: l,
      router: s
    }), h = g1(() => C8());
    return d0(() => {
      l3(l.eclMenuRoot, (u) => {
        u && (i = ECL.Menu.autoInit(H(l.eclMenuRoot)));
      }), l3(
        () => t.items,
        (u) => {
          u.length > 0 && (i && i.destroy(), i = ECL.Menu.autoInit(H(l.eclMenuRoot)));
        },
        { immediate: !0 }
      ), s == null || s.afterEach(() => {
        i == null || i.handleClickOnClose(), i == null || i.inner.setAttribute("aria-hidden", "false"), setTimeout(() => e("close"), 200);
      });
    }), mn(() => {
      i == null || i.destroy();
    }), {
      isEc: n,
      isMobileTablet: h,
      ...l,
      ...a,
      ...o,
      toggleMenu: () => {
        i != null && i.isOpen ? setTimeout(() => e("close"), 200) : e("open");
      },
      isExpanded: (u) => {
        const d = H(l.navItemsElWrapper)[u];
        return d ? d.getAttribute("aria-expanded") === "true" : !1;
      },
      EclLinkType: f0,
      EclButtonIconPosition: di,
      EclButtonType: I4,
      EclIconSize: ye
    };
  }
});
function ln() {
  const t = t9();
  return {
    t: (t == null ? void 0 : t.appContext.config.globalProperties.$t) ?? ((...e) => `${e}`)
  };
}
var NL = { exports: {} };
/*!
 * gumshoejs v5.1.2
 * A simple, framework-agnostic scrollspy script.
 * (c) 2019 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/gumshoe
 */
(function(t, e) {
  Element.prototype.closest || (Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest = function(n) {
    var i = this, s = this;
    if (!document.documentElement.contains(i))
      return null;
    do {
      if (s.matches(n))
        return s;
      s = s.parentElement;
    } while (s !== null);
    return null;
  }), function() {
    if (typeof window.CustomEvent == "function")
      return !1;
    function n(i, s) {
      s = s || { bubbles: !1, cancelable: !1, detail: void 0 };
      var l = document.createEvent("CustomEvent");
      return l.initCustomEvent(i, s.bubbles, s.cancelable, s.detail), l;
    }
    n.prototype = window.Event.prototype, window.CustomEvent = n;
  }(), function(n, i) {
    t.exports = i(n);
  }(typeof ys < "u" ? ys : typeof window < "u" ? window : ys, function(n) {
    var i = {
      // Active classes
      navClass: "active",
      contentClass: "active",
      // Nested navigation
      nested: !1,
      nestedClass: "active",
      // Offset & reflow
      offset: 0,
      reflow: !1,
      // Event support
      events: !0
    }, s = function() {
      var x = {};
      return Array.prototype.forEach.call(arguments, function(k) {
        for (var F in k) {
          if (!k.hasOwnProperty(F))
            return;
          x[F] = k[F];
        }
      }), x;
    }, l = function(x, k, F) {
      if (F.settings.events) {
        var D = new CustomEvent(x, {
          bubbles: !0,
          cancelable: !0,
          detail: F
        });
        k.dispatchEvent(D);
      }
    }, a = function(x) {
      var k = 0;
      if (x.offsetParent)
        for (; x; )
          k += x.offsetTop, x = x.offsetParent;
      return k >= 0 ? k : 0;
    }, o = function(x) {
      x && x.sort(function(k, F) {
        var D = a(k.content), R = a(F.content);
        return D < R ? -1 : 1;
      });
    }, h = function(x) {
      return typeof x.offset == "function" ? parseFloat(x.offset()) : parseFloat(x.offset);
    }, u = function() {
      return Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );
    }, d = function(x, k, F) {
      var D = x.getBoundingClientRect(), R = h(k);
      return F ? parseInt(D.bottom, 10) < (n.innerHeight || document.documentElement.clientHeight) : parseInt(D.top, 10) <= R;
    }, v = function() {
      return n.innerHeight + n.pageYOffset >= u();
    }, m = function(x, k) {
      return !!(v() && d(x.content, k, !0));
    }, p = function(x, k) {
      var F = x[x.length - 1];
      if (m(F, k))
        return F;
      for (var D = x.length - 1; D >= 0; D--)
        if (d(x[D].content, k))
          return x[D];
    }, _ = function(x, k) {
      if (!(!k.nested || !x.parentNode)) {
        var F = x.parentNode.closest("li");
        F && (F.classList.remove(k.nestedClass), _(F, k));
      }
    }, q = function(x, k) {
      if (x) {
        var F = x.nav.closest("li");
        F && (F.classList.remove(k.navClass), x.content.classList.remove(k.contentClass), _(F, k), l("gumshoeDeactivate", F, {
          link: x.nav,
          content: x.content,
          settings: k
        }));
      }
    }, M = function(x, k) {
      if (k.nested) {
        var F = x.parentNode.closest("li");
        F && (F.classList.add(k.nestedClass), M(F, k));
      }
    }, z = function(x, k) {
      if (x) {
        var F = x.nav.closest("li");
        F && (F.classList.add(k.navClass), x.content.classList.add(k.contentClass), M(F, k), l("gumshoeActivate", F, {
          link: x.nav,
          content: x.content,
          settings: k
        }));
      }
    }, b = function(x, k) {
      var F = {}, D, R, V, J, K;
      F.setup = function() {
        D = document.querySelectorAll(x), R = [], Array.prototype.forEach.call(D, function(j) {
          var Q = document.getElementById(decodeURIComponent(j.hash.substr(1)));
          Q && R.push({
            nav: j,
            content: Q
          });
        }), o(R);
      }, F.detect = function() {
        var j = p(R, K);
        if (!j) {
          V && (q(V, K), V = null);
          return;
        }
        V && j.content === V.content || (q(V, K), z(j, K), V = j);
      };
      var P = function(j) {
        J && n.cancelAnimationFrame(J), J = n.requestAnimationFrame(F.detect);
      }, O = function(j) {
        J && n.cancelAnimationFrame(J), J = n.requestAnimationFrame(function() {
          o(R), F.detect();
        });
      };
      F.destroy = function() {
        V && q(V, K), n.removeEventListener("scroll", P, !1), K.reflow && n.removeEventListener("resize", O, !1), R = null, D = null, V = null, J = null, K = null;
      };
      var G = function() {
        K = s(i, k || {}), F.setup(), F.detect(), n.addEventListener("scroll", P, !1), K.reflow && n.addEventListener("resize", O, !1);
      };
      return G(), F;
    };
    return b;
  });
})(NL);
var id1 = NL.exports;
const sd1 = /* @__PURE__ */ aL(id1);
class L_ {
  constructor(e, {
    stickySelector: n = "[data-ecl-inpage-navigation]",
    containerSelector: i = "[data-ecl-inpage-navigation-container]",
    inPageList: s = "[data-ecl-inpage-navigation-list]",
    spySelector: l = "[data-ecl-inpage-navigation-link]",
    toggleSelector: a = "[data-ecl-inpage-navigation-trigger]",
    linksSelector: o = "[data-ecl-inpage-navigation-link]",
    spyActiveContainer: h = "ecl-inpage-navigation--visible",
    spyOffset: u = 20,
    spyClass: d = "ecl-inpage-navigation__item--active",
    spyTrigger: v = "[data-ecl-inpage-navigation-trigger-current]",
    attachClickListener: m = !0,
    attachKeyListener: p = !0,
    contentClass: _ = "inpage-navigation__heading--active"
  } = {}) {
    if (AF(this, "supportedEvents", ["onToggle", "onClick"]), !e || e.nodeType !== Node.ELEMENT_NODE)
      throw new TypeError(
        "DOM element should be given to initialize this widget."
      );
    this.element = e, this.eventManager = new nF(), this.attachClickListener = m, this.attachKeyListener = p, this.stickySelector = n, this.containerSelector = i, this.toggleSelector = a, this.linksSelector = o, this.inPageList = s, this.spyActiveContainer = h, this.spySelector = l, this.spyOffset = u, this.spyClass = d, this.spyTrigger = v, this.contentClass = _, this.gumshoe = null, this.observer = null, this.stickyObserver = null, this.isExpanded = !1, this.handleClickOnToggler = this.handleClickOnToggler.bind(this), this.handleClickOnLink = this.handleClickOnLink.bind(this), this.handleKeyboard = this.handleKeyboard.bind(this), this.initScrollSpy = this.initScrollSpy.bind(this), this.initObserver = this.initObserver.bind(this), this.activateScrollSpy = this.activateScrollSpy.bind(this), this.deactivateScrollSpy = this.deactivateScrollSpy.bind(this), this.destroySticky = this.destroySticky.bind(this), this.destroyScrollSpy = this.destroyScrollSpy.bind(this), this.destroyObserver = this.destroyObserver.bind(this), this.openList = this.openList.bind(this), this.closeList = this.closeList.bind(this);
  }
  /**
   * @static
   * Shorthand for instance creation and initialisation.
   *
   * @param {HTMLElement} root DOM element for component instantiation and scope
   *
   * @return {InpageNavigation} An instance of InpageNavigation.
   */
  static autoInit(e, { INPAGE_NAVIGATION: n = {} } = {}) {
    const i = new L_(e, n);
    return i.init(), e.ECLInpageNavigation = i, i;
  }
  // ACTIONS
  /**
   * Initiate sticky behaviors.
   */
  initSticky() {
    this.stickyInstance = new tF.Sticky(this.element);
  }
  /**
   * Destroy sticky behaviors.
   */
  destroySticky() {
    this.stickyInstance && this.stickyInstance.remove();
  }
  /**
   * Initiate scroll spy behaviors.
   */
  initScrollSpy() {
    if (this.gumshoe = new sd1(this.spySelector, {
      navClass: this.spyClass,
      contentClass: this.contentClass,
      offset: this.spyOffset,
      reflow: !0
    }), document.addEventListener("gumshoeActivate", this.activateScrollSpy, !1), document.addEventListener(
      "gumshoeDeactivate",
      this.deactivateScrollSpy,
      !1
    ), "IntersectionObserver" in window) {
      const e = Q5(this.containerSelector);
      if (e) {
        let n = 0, i = 0, s = !1;
        this.stickyObserver = new IntersectionObserver(
          (l) => {
            if (l && l[0]) {
              const a = l[0], o = a.boundingClientRect.y, h = a.intersectionRatio, { isIntersecting: u } = a;
              if (!s) {
                s = !0, n = o, i = h;
                return;
              }
              o < n ? h > i && u || this.element.classList.remove(this.spyActiveContainer) : o > n && u && h > i && this.element.classList.add(this.spyActiveContainer), n = o, i = h;
            }
          },
          { root: null }
        ), this.stickyObserver.observe(e);
      }
    }
  }
  /**
   * Activate scroll spy behaviors.
   *
   * @param {Event} event
   */
  activateScrollSpy(e) {
    const n = Q5(this.spyTrigger);
    this.element.classList.add(this.spyActiveContainer), n.textContent = e.detail.content.textContent;
  }
  /**
   * Deactivate scroll spy behaviors.
   */
  deactivateScrollSpy() {
    const e = Q5(this.spyTrigger);
    this.element.classList.remove(this.spyActiveContainer), e.innerHTML = "";
  }
  /**
   * Destroy scroll spy behaviors.
   */
  destroyScrollSpy() {
    this.stickyObserver && this.stickyObserver.disconnect(), document.removeEventListener(
      "gumshoeActivate",
      this.activateScrollSpy,
      !1
    ), document.removeEventListener(
      "gumshoeDeactivate",
      this.deactivateScrollSpy,
      !1
    ), this.gumshoe.destroy();
  }
  /**
   * Initiate observer.
   */
  initObserver() {
    if ("MutationObserver" in window) {
      const e = this;
      this.observer = new MutationObserver((n) => {
        const i = Q5(".ecl-col-l-9"), s = Q5("[data-ecl-inpage-navigation-list]");
        n.forEach((l) => {
          l && l.target && l.target.classList && !l.target.classList.contains(
            "ecl-inpage-navigation__trigger-current"
          ) && (l.addedNodes.length > 0 && [].slice.call(l.addedNodes).forEach((a) => {
            if (a.tagName === "H2" && a.id) {
              const o = Cw("h2[id]", i).findIndex(
                (u) => u.id === a.id
              ), h = s.childNodes[o - 1].cloneNode(
                !0
              );
              h.childNodes[0].textContent = a.textContent, h.childNodes[0].href = `#${a.id}`, s.childNodes[o - 1].after(h);
            }
          }), l.removedNodes.length > 0 && [].slice.call(l.removedNodes).forEach((a) => {
            a.tagName === "H2" && a.id && s.childNodes.forEach((o) => {
              o.childNodes[0].href.indexOf(a.id) !== -1 && o.remove();
            });
          }), e.update());
        });
      }), this.observer.observe(document, {
        subtree: !0,
        childList: !0
      });
    }
  }
  /**
   * Destroy observer.
   */
  destroyObserver() {
    this.observer && this.observer.disconnect();
  }
  /**
   * Initialise component.
   */
  init() {
    if (!ECL)
      throw new TypeError("Called init but ECL is not present");
    ECL.components = ECL.components || /* @__PURE__ */ new Map();
    const e = Q5(this.toggleSelector, this.element), n = Cw(this.linksSelector, this.element);
    this.initSticky(this.element), this.initScrollSpy(), this.initObserver(), this.focusTrap = CF(this.element, {
      onActivate: () => this.openList(),
      onDeactivate: () => this.closeList()
    }), this.attachClickListener && e && e.addEventListener("click", this.handleClickOnToggler), this.attachClickListener && n && (n.forEach(
      (i) => i.addEventListener("click", this.handleClickOnLink)
    ), this.element.addEventListener("keydown", this.handleShiftTab), e.addEventListener("click", this.handleClickOnToggler)), document.addEventListener("keydown", this.handleKeyboard), this.element.setAttribute("data-ecl-auto-initialized", "true"), ECL.components.set(this.element, this);
  }
  /**
   * Register a callback function for a specific event.
   *
   * @param {string} eventName - The name of the event to listen for.
   * @param {Function} callback - The callback function to be invoked when the event occurs.
   * @returns {void}
   * @memberof InpageNavigation
   * @instance
   *
   * @example
   * // Registering a callback for the 'onToggle' event
   * inpage.on('onToggle', (event) => {
   *   console.log('Toggle event occurred!', event);
   * });
   */
  on(e, n) {
    this.eventManager.on(e, n);
  }
  /**
   * Trigger a component event.
   *
   * @param {string} eventName - The name of the event to trigger.
   * @param {any} eventData - Data associated with the event.
   * @memberof InpageNavigation
   */
  trigger(e, n) {
    this.eventManager.trigger(e, n);
  }
  /**
   * Update scroll spy instance.
   */
  update() {
    this.gumshoe.setup();
  }
  /**
   * Open mobile list link.
   */
  openList() {
    const e = Q5(this.inPageList, this.element), n = Q5(this.toggleSelector, this.element);
    e.classList.add("ecl-inpage-navigation__list--visible"), n.setAttribute("aria-expanded", "true");
  }
  /**
   * Close mobile list link.
   */
  closeList() {
    const e = Q5(this.inPageList, this.element), n = Q5(this.toggleSelector, this.element);
    e.classList.remove("ecl-inpage-navigation__list--visible"), n.setAttribute("aria-expanded", "false");
  }
  /**
   * Invoke event listeners on toggle click.
   *
   * @param {Event} e
   */
  handleClickOnToggler(e) {
    const n = Q5(this.toggleSelector, this.element);
    e.preventDefault(), this.isExpanded = n.getAttribute("aria-expanded") === "true", n.setAttribute(
      "aria-expanded",
      this.isExpanded ? "false" : "true"
    ), this.isExpanded ? this.focusTrap.deactivate() : this.focusTrap.activate(), this.trigger("onToggle", { isExpanded: this.isExpanded });
  }
  /**
   * Sets the necessary attributes to collapse inpage navigation list.
   *
   * @param {Event} e
   */
  handleClickOnLink(e) {
    const { href: n } = e.target;
    let i = null;
    if (n) {
      const l = n.split("#")[1];
      l && (i = Q5(`#${l}`, document));
    }
    this.focusTrap.deactivate();
    const s = { target: i || n, e };
    this.trigger("onClick", s);
  }
  /**
   * Handle keyboard
   *
   * @param {Event} e
   */
  handleKeyboard(e) {
    const n = e.target;
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const i = n.parentElement.previousSibling;
      if (i && i.classList.contains("ecl-inpage-navigation__item")) {
        const s = Q5(this.linksSelector, i);
        s && s.focus();
      }
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const i = n.parentElement.nextSibling;
      if (i && i.classList.contains("ecl-inpage-navigation__item")) {
        const s = Q5(this.linksSelector, i);
        s && s.focus();
      }
    }
  }
  /**
   * Destroy component instance.
   */
  destroy() {
    this.attachClickListener && this.toggleElement && this.toggleElement.removeEventListener(
      "click",
      this.handleClickOnToggler
    ), this.attachClickListener && this.navLinks && this.navLinks.forEach(
      (e) => e.removeEventListener("click", this.handleClickOnLink)
    ), this.attachKeyListener && document.removeEventListener("keydown", this.handleKeyboard), this.destroyScrollSpy(), this.destroySticky(), this.destroyObserver(), this.element && (this.element.removeAttribute("data-ecl-auto-initialized"), ECL.components.delete(this.element));
  }
}
c2({
  name: "EclInPageNavigation",
  components: {
    EclButton: Lt,
    EclIcon: Ie,
    EclLink: O4
  },
  props: {
    title: {
      type: String,
      required: !1,
      default: () => "ECLV3.IN_PAGE_NAVIGATION.TITLE"
    },
    items: {
      type: Array,
      required: !0
    }
  },
  setup(t) {
    const { t: e } = ln(), n = D1();
    let i;
    const s = g1(() => t.items.map((l) => ({
      ...l,
      label: e(l.label)
    })));
    return d0(() => {
      l3(
        s,
        (a) => {
          (a == null ? void 0 : a.length) > 0 && (i && i.destroy(), i = L_.autoInit(H(n)));
        },
        { immediate: !0 }
      );
      const l = window.location.hash.substring(1);
      if (l) {
        const a = document.getElementById(l);
        a && a.scrollIntoView();
      }
    }), {
      eclInPageRoot: n,
      extendedItemList: s
    };
  }
});
function PL(t, e) {
  const { t: n } = ln(), i = t.useData.accordion, s = t.useData.index, l = g1(() => i.itemActive.value.indexOf(s) >= 0), a = g1(() => H(l) ? n("ECLV3.GENERAL.CLOSE") : n("ECLV3.GENERAL.OPEN")), o = () => {
    l.value || (e("onOpen", i), i.activate(s));
  }, h = () => {
    l.value && (e("onClose", i), i.deactivate(s));
  };
  return {
    isExpanded: l,
    statusLabel: a,
    toggleActivation: () => {
      l.value ? h() : o();
    }
  };
}
function BL() {
  const t = HA("accordion");
  return {
    index: t.itemCount.value++,
    accordion: t
  };
}
const ld1 = c2({
  name: "EclAccordionItem",
  emits: ["onOpen", "onClose"],
  components: {
    EclIcon: Ie
  },
  setup(t, { emit: e }) {
    const n = d4().theme === "ec", i = N1.uniqueId(), s = BL(), l = PL(
      {
        useData: s
      },
      e
    );
    return {
      isEc: n,
      ...l,
      id: i,
      EclIconSize: ye
    };
  }
}), rd1 = { class: "ecl-accordion__item" }, ad1 = ["id"], od1 = ["aria-controls", "aria-expanded"], cd1 = { class: "ecl-accordion__toggle-flex" }, hd1 = { class: "ecl-accordion__toggle-title" }, ud1 = { class: "ecl-accordion__toggle-indicator" }, dd1 = ["id", "aria-labelledby"];
function fd1(t, e, n, i, s, l) {
  const a = V2("ecl-icon");
  return T(), N("div", rd1, [
    C("h3", {
      class: "ecl-accordion__title",
      id: `id__${t.id}`
    }, [
      C("button", {
        type: "button",
        class: f2(["ecl-accordion__toggle", { "ecl-accordion__toggle--active": t.isExpanded }]),
        "aria-controls": t.id,
        "aria-expanded": t.isExpanded,
        onClick: e[0] || (e[0] = Et((...o) => t.toggleActivation && t.toggleActivation(...o), ["prevent"]))
      }, [
        C("span", cd1, [
          C("span", hd1, [
            J2(t.$slots, "trigger", {}, void 0, !0)
          ]),
          C("span", ud1, [
            t.isExpanded ? (T(), v2(a, {
              key: 1,
              class: "ecl-accordion__toggle-icon",
              icon: "minus",
              size: t.EclIconSize.S
            }, null, 8, ["size"])) : (T(), v2(a, {
              key: 0,
              class: "ecl-accordion__toggle-icon",
              icon: "plus",
              size: t.EclIconSize.S
            }, null, 8, ["size"]))
          ])
        ])
      ], 10, od1)
    ], 8, ad1),
    C("div", Ht({
      class: "ecl-accordion__content",
      id: t.id
    }, { hidden: t.isExpanded === !1 }, {
      role: "region",
      "aria-labelledby": `id__${t.id}`
    }), [
      J2(t.$slots, "content", {}, void 0, !0)
    ], 16, dd1)
  ]);
}
const vd1 = /* @__PURE__ */ f4(ld1, [["render", fd1], ["__scopeId", "data-v-ba0b4c85"]]);
c2({
  name: "EclAccordionItem",
  emits: ["onOpen", "onClose"],
  components: {
    EclIcon: Ie
  },
  setup(t, { emit: e }) {
    const n = d4().theme === "ec", i = N1.uniqueId(), s = BL(), l = PL(
      {
        useData: s
      },
      e
    );
    return {
      isEc: n,
      ...l,
      id: i,
      EclIconSize: ye
    };
  }
});
const pd1 = c2({
  name: "EclAccordion",
  props: {
    onlyOneExpanded: {
      type: Boolean,
      required: !1,
      default: !0
    },
    fluid: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(t) {
    const e = {
      itemCount: D1(0),
      itemActive: D1([]),
      activate: (n) => {
        t.onlyOneExpanded && (e.itemActive.value = [n]), e.itemActive.value.push(n);
      },
      deactivate: (n) => {
        t.onlyOneExpanded && (e.itemActive.value = []), e.itemActive.value = e.itemActive.value.filter(
          (i) => i !== n
        );
      }
    };
    return Zb("accordion", e), {
      data: e
    };
  }
});
function md1(t, e, n, i, s, l) {
  return T(), N("div", {
    class: f2(["ecl-accordion", { "ecl-accordion--fluid": t.fluid }])
  }, [
    J2(t.$slots, "default", {}, void 0, !0)
  ], 2);
}
const gd1 = /* @__PURE__ */ f4(pd1, [["render", md1], ["__scopeId", "data-v-7920b740"]]);
c2({
  name: "EclAccordion",
  props: {
    onlyOneExpanded: {
      type: Boolean,
      required: !1,
      default: !0
    },
    fluid: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(t) {
    const e = {
      itemCount: D1(0),
      itemActive: D1([]),
      activate: (n) => {
        t.onlyOneExpanded && (e.itemActive.value = [n]), e.itemActive.value.push(n);
      },
      deactivate: (n) => {
        t.onlyOneExpanded && (e.itemActive.value = []), e.itemActive.value = e.itemActive.value.filter(
          (i) => i !== n
        );
      }
    };
    return Zb("accordion", e), {
      data: e
    };
  }
});
function VL(t) {
  return Qb() ? (eL(t), !0) : !1;
}
function _o(t) {
  return typeof t == "function" ? t() : H(t);
}
const RL = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const yd1 = Object.prototype.toString, _d1 = (t) => yd1.call(t) === "[object Object]", qo = () => {
}, uy = /* @__PURE__ */ qd1();
function qd1() {
  var t, e;
  return RL && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
const Bw = {
  mounted: "mounted",
  updated: "updated",
  unmounted: "unmounted"
};
function wd1(...t) {
  if (t.length !== 1)
    return DA(...t);
  const e = t[0];
  return typeof e == "function" ? $A(UA(() => ({ get: e, set: qo }))) : D1(e);
}
function ao(t) {
  var e;
  const n = _o(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
const HL = RL ? window : void 0;
function ph(...t) {
  let e, n, i, s;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, i, s] = t, e = HL) : [e, n, i, s] = t, !e)
    return qo;
  Array.isArray(n) || (n = [n]), Array.isArray(i) || (i = [i]);
  const l = [], a = () => {
    l.forEach((d) => d()), l.length = 0;
  }, o = (d, v, m, p) => (d.addEventListener(v, m, p), () => d.removeEventListener(v, m, p)), h = l3(
    () => [ao(e), _o(s)],
    ([d, v]) => {
      if (a(), !d)
        return;
      const m = _d1(v) ? { ...v } : v;
      l.push(
        ...n.flatMap((p) => i.map((_) => o(d, p, _, m)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    h(), a();
  };
  return VL(u), u;
}
let Vw = !1;
function Rw(t, e, n = {}) {
  const { window: i = HL, ignore: s = [], capture: l = !0, detectIframe: a = !1 } = n;
  if (!i)
    return qo;
  uy && !Vw && (Vw = !0, Array.from(i.document.body.children).forEach((d) => d.addEventListener("click", qo)), i.document.documentElement.addEventListener("click", qo));
  let o = !0;
  const h = (d) => s.some((v) => {
    if (typeof v == "string")
      return Array.from(i.document.querySelectorAll(v)).some((m) => m === d.target || d.composedPath().includes(m));
    {
      const m = ao(v);
      return m && (d.target === m || d.composedPath().includes(m));
    }
  }), u = [
    ph(i, "click", (d) => {
      const v = ao(t);
      if (!(!v || v === d.target || d.composedPath().includes(v))) {
        if (d.detail === 0 && (o = !h(d)), !o) {
          o = !0;
          return;
        }
        e(d);
      }
    }, { passive: !0, capture: l }),
    ph(i, "pointerdown", (d) => {
      const v = ao(t);
      o = !h(d) && !!(v && !d.composedPath().includes(v));
    }, { passive: !0 }),
    a && ph(i, "blur", (d) => {
      setTimeout(() => {
        var v;
        const m = ao(t);
        ((v = i.document.activeElement) == null ? void 0 : v.tagName) === "IFRAME" && !(m != null && m.contains(i.document.activeElement)) && e(d);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((d) => d());
}
const DL = {
  [Bw.mounted](t, e) {
    const n = !e.modifiers.bubble;
    if (typeof e.value == "function")
      t.__onClickOutside_stop = Rw(t, e.value, { capture: n });
    else {
      const [i, s] = e.value;
      t.__onClickOutside_stop = Rw(t, i, Object.assign({ capture: n }, s));
    }
  },
  [Bw.unmounted](t) {
    t.__onClickOutside_stop();
  }
};
function zg(t) {
  return typeof Window < "u" && t instanceof Window ? t.document.documentElement : typeof Document < "u" && t instanceof Document ? t.documentElement : t;
}
function $L(t) {
  const e = window.getComputedStyle(t);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && t.clientWidth < t.scrollWidth || e.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const n = t.parentNode;
    return !n || n.tagName === "BODY" ? !1 : $L(n);
  }
}
function zd1(t) {
  const e = t || window.event, n = e.target;
  return $L(n) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const Hc = /* @__PURE__ */ new WeakMap();
function Md1(t, e = !1) {
  const n = D1(e);
  let i = null;
  l3(wd1(t), (a) => {
    const o = zg(_o(a));
    if (o) {
      const h = o;
      Hc.get(h) || Hc.set(h, h.style.overflow), n.value && (h.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const s = () => {
    const a = zg(_o(t));
    !a || n.value || (uy && (i = ph(
      a,
      "touchmove",
      (o) => {
        zd1(o);
      },
      { passive: !1 }
    )), a.style.overflow = "hidden", n.value = !0);
  }, l = () => {
    var a;
    const o = zg(_o(t));
    !o || !n.value || (uy && (i == null || i()), o.style.overflow = (a = Hc.get(o)) != null ? a : "", Hc.delete(o), n.value = !1);
  };
  return VL(l), g1({
    get() {
      return n.value;
    },
    set(a) {
      a ? s() : l();
    }
  });
}
function bd1() {
  let t = !1;
  const e = D1(!1);
  return (n, i) => {
    if (e.value = i.value, t)
      return;
    t = !0;
    const s = Md1(n, i.value);
    l3(e, (l) => s.value = l);
  };
}
bd1();
function UL(t, e) {
  const { modelValue: n } = s3(t), i = D1(), s = D1(n == null ? void 0 : n.value), l = n;
  return l3(l, (a) => {
    s.value !== a && (s.value = a);
  }), l3(s, (a) => {
    l.value !== a && e.emit("update:modelValue", a);
  }), {
    elementClose: i,
    visible: s,
    externalValue: l
  };
}
function jL(t, e) {
  const n = e.useData.visible, i = g1(() => {
    var l;
    return !N1.isNil((l = t.slots) == null ? void 0 : l.bodyFixed);
  }), s = g1(() => {
    var l;
    return !N1.isNil((l = t.slots) == null ? void 0 : l.footer);
  });
  return {
    hasBodyFixed: i,
    hasFooter: s,
    modalHide: () => {
      n.value = !1, t.emit("hide");
    }
  };
}
function GL(t, e, n) {
  const { backdropClose: i } = s3(t), s = n.useModal.modalHide;
  return {
    onBackdropClick: () => {
      H(i) && (e.emit("close:backdrop"), s());
    },
    performClose: () => {
      e.emit("close"), s();
    }
  };
}
function WL(t, e) {
  const n = D1(), i = D1(), s = e.useData.elementClose;
  return {
    modalTransitionState: i,
    overlayTransitionState: n,
    beforeOverlayEnter: () => {
      n.value = "entering";
    },
    afterOverlayEnter: () => {
      n.value = "enter";
    },
    beforeOverlayLeave: () => {
      n.value = "leaving";
    },
    afterOverlayLeave: () => {
      n.value = "leave";
    },
    beforeModalEnter: () => {
      i.value = "entering";
    },
    afterModalEnter: () => {
      i.value = "enter";
      const l = H(s);
      l && l.$el.focus(), t.emit("onRendered");
    },
    beforeModalLeave: () => {
      i.value = "leaving";
    },
    afterModalLeave: () => {
      i.value = "leave", t.emit("onDestroyed");
    }
  };
}
var YL = /* @__PURE__ */ ((t) => (t.S = "s", t.L = "l", t.FLUID = "fluid", t))(YL || {});
const Ld1 = {
  modelValue: {
    type: Boolean,
    required: !0
  },
  backdropClose: {
    type: Boolean,
    required: !1,
    default: () => !0
  },
  title: {
    type: String,
    required: !1
  },
  body: {
    type: String,
    required: !1
  },
  showClose: {
    type: Boolean,
    required: !1,
    default: () => !0
  },
  size: {
    type: String,
    required: !1,
    default: () => "l",
    validator: (t) => Object.values(YL).includes(t)
  },
  gridContainer: {
    type: Boolean,
    required: !1,
    default: () => !0
  }
}, xd1 = c2({
  name: "EclModal",
  components: {
    EclButton: Lt,
    EclP: zr
  },
  directives: { onClickOutside: DL },
  emits: [
    "update:modelValue",
    "hide",
    "close",
    "close:backdrop",
    "onRendered",
    "onDestroyed"
  ],
  props: Ld1,
  setup(t, e) {
    const n = N1.uniqueId(), i = g1(() => d4().theme === "ec"), s = UL(t, e), l = WL(e, { useData: s }), a = jL(e, { useData: s }), o = GL(t, e, { useModal: a }), h = g1(() => t.size === "fluid" ? "ecl-col-12" : t.size === "s" ? "ecl-col-12 ecl-col-m-6 ecl-col-l-5" : "ecl-col-12 ecl-col-m-10 ecl-col-l-8");
    return {
      id: n,
      isEc: i,
      ...l,
      ...s,
      ...o,
      ...a,
      contentClass: h,
      EclButtonIconPosition: di,
      EclButtonType: I4,
      EclIconSize: ye
    };
  }
}), Sd1 = (t) => ($s("data-v-40e4631d"), t = t(), Us(), t), Cd1 = ["id", "aria-labelledby"], kd1 = { class: "ecl-modal__header" }, Ed1 = ["id"], Ad1 = { class: "ecl-modal__body" }, Fd1 = { class: "ecl-modal__body-scroll" }, Td1 = /* @__PURE__ */ Sd1(() => /* @__PURE__ */ C("div", {
  class: "ecl-modal__body-overflow",
  "aria-hidden": "true"
}, null, -1)), Id1 = {
  key: 0,
  class: "ecl-modal__body-fixed"
}, Od1 = {
  key: 0,
  class: "ecl-modal__footer"
}, Nd1 = { class: "ecl-modal__footer-content" };
function Pd1(t, e, n, i, s, l) {
  const a = V2("ecl-button"), o = V2("ecl-p"), h = ku("on-click-outside");
  return T(), v2(tL, {
    name: "fade",
    onBeforeEnter: t.beforeModalEnter,
    onAfterEnter: t.afterModalEnter,
    onBeforeLeave: t.beforeModalLeave,
    onAfterLeave: t.afterModalLeave
  }, {
    default: Q2(() => [
      t.visible ? (T(), N("dialog", {
        key: 0,
        style: { display: "block" },
        id: t.id,
        "aria-modal": "true",
        class: "ecl-modal ecl-modal--l",
        "aria-labelledby": `${t.id}-header`,
        onKeyup: [
          e[0] || (e[0] = P5((...u) => t.onBackdropClick && t.onBackdropClick(...u), ["delete"])),
          e[1] || (e[1] = P5((...u) => t.onBackdropClick && t.onBackdropClick(...u), ["esc"]))
        ]
      }, [
        b6((T(), N("div", {
          class: f2(["ecl-modal__container", { "ecl-container": t.gridContainer }])
        }, [
          C("div", {
            class: f2(["ecl-modal__content", t.contentClass])
          }, [
            C("header", kd1, [
              J2(t.$slots, "header", {}, () => [
                C("div", {
                  class: "ecl-modal__header-content",
                  id: `${t.id}-header`
                }, [
                  J2(t.$slots, "title", {}, () => [
                    K3(pt(t.title), 1)
                  ], !0)
                ], 8, Ed1),
                t.showClose ? (T(), v2(a, {
                  key: 0,
                  ref: "elementClose",
                  class: "ecl-modal__close",
                  icon: t.isEc ? "close" : "close-filled",
                  iconSize: (t.isEc, t.EclIconSize.M),
                  iconPosition: t.EclButtonIconPosition.Before,
                  ariaLabel: t.$t("ECLV3.GENERAL.CLOSE"),
                  type: t.EclButtonType.Tertiary,
                  onClick: Et(t.performClose, ["prevent"])
                }, null, 8, ["icon", "iconSize", "iconPosition", "ariaLabel", "type", "onClick"])) : m2("", !0)
              ], !0)
            ]),
            J2(t.$slots, "content", {}, () => [
              C("div", Ad1, [
                C("div", Fd1, [
                  J2(t.$slots, "body", {}, () => [
                    t.body ? (T(), v2(o, {
                      key: 0,
                      innerHTML: t.body,
                      widthFluid: !0
                    }, null, 8, ["innerHTML"])) : m2("", !0)
                  ], !0)
                ]),
                Td1,
                t.hasBodyFixed ? (T(), N("div", Id1, [
                  J2(t.$slots, "bodyFixed", {}, void 0, !0)
                ])) : m2("", !0)
              ]),
              t.hasFooter ? (T(), N("footer", Od1, [
                C("div", Nd1, [
                  J2(t.$slots, "footer", {
                    id: t.id,
                    onClickClose: t.performClose
                  }, void 0, !0)
                ])
              ])) : m2("", !0)
            ], !0)
          ], 2)
        ], 2)), [
          [h, t.onBackdropClick]
        ])
      ], 40, Cd1)) : m2("", !0)
    ]),
    _: 3
  }, 8, ["onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"]);
}
const Au = /* @__PURE__ */ f4(xd1, [["render", Pd1], ["__scopeId", "data-v-40e4631d"]]);
var XL = /* @__PURE__ */ ((t) => (t.S = "s", t.L = "l", t.FLUID = "fluid", t))(XL || {});
const Bd1 = {
  modelValue: {
    type: Boolean,
    required: !0
  },
  backdropClose: {
    type: Boolean,
    required: !1,
    default: () => !0
  },
  title: {
    type: String,
    required: !1
  },
  body: {
    type: String,
    required: !1
  },
  showClose: {
    type: Boolean,
    required: !1,
    default: () => !0
  },
  size: {
    type: String,
    required: !1,
    default: () => "l",
    validator: (t) => Object.values(XL).includes(t)
  },
  gridContainer: {
    type: Boolean,
    required: !1,
    default: () => !0
  }
};
c2({
  name: "EclModal",
  components: {
    EclButton: Lt,
    EclP: zr
  },
  directives: { onClickOutside: DL },
  emits: [
    "update:modelValue",
    "hide",
    "close",
    "close:backdrop",
    "onRendered",
    "onDestroyed"
  ],
  props: Bd1,
  setup(t, e) {
    const n = N1.uniqueId(), i = g1(() => d4().theme === "ec"), s = UL(t, e), l = WL(e, { useData: s }), a = jL(e, { useData: s }), o = GL(t, e, { useModal: a }), h = g1(() => t.size === "fluid" ? "ecl-col-12" : t.size === "s" ? "ecl-col-12 ecl-col-m-6 ecl-col-l-5" : "ecl-col-12 ecl-col-m-10 ecl-col-l-8");
    return {
      id: n,
      isEc: i,
      ...l,
      ...s,
      ...o,
      ...a,
      contentClass: h,
      EclButtonIconPosition: di,
      EclButtonType: I4,
      EclIconSize: ye
    };
  }
});
function KL(t) {
  const { checkboxes: e, valueProp: n, modelValue: i } = s3(t), s = (l) => `ecl-checkbox__checkbox-${(l == null ? void 0 : l.value) ?? N1.uniqueId()}`;
  return {
    extendedCheckboxes: g1(
      () => {
        const l = H(e), a = H(i);
        if (N1.isArray(l))
          return l.map((o) => {
            const h = N1.assign(
              {
                id: s(o),
                helpText: null,
                checked: null,
                disabled: null,
                [H(n)]: l
              },
              o
            );
            return N1.isArray(a) && a.includes(h.value) && (h.checked = !0), h;
          });
        {
          const o = N1.assign(
            {},
            {
              id: s(),
              [H(n)]: l,
              checked: H(i) === l,
              disabled: null
            }
          );
          return N1.isArray(a) && a.includes(o.value) ? o.checked = !0 : (N1.isNumber(a) || N1.isString(a)) && (o.checked = o.value === a), [o];
        }
      }
    )
  };
}
function ZL(t, e) {
  const { value: n, modelValue: i } = s3(t), s = D1([]), l = e.expose !== void 0 ? i : n;
  return {
    internalValue: s,
    externalValue: l
  };
}
function JL(t, e, n) {
  const { valueProp: i } = s3(t), s = n.useValue.internalValue, l = n.useCheckbox.extendedCheckboxes;
  s.value = l.value.filter(
    (u) => u.checked === !0
  );
  const a = g1(
    () => H(i)
  ), o = (u) => {
    if (N1.isNil(u))
      return u;
    if (H(l).length > 1)
      return u.map((v) => v[H(a)]);
    const d = N1.find(u, (v) => v.checked === !0);
    return d ? d[H(a)] : void 0;
  }, h = (u) => N1.isNil(u) ? [] : u;
  return {
    update: (u) => {
      s.value = h(u);
      const d = o(u);
      e.emit("change", d), e.emit("update:modelValue", d);
    }
  };
}
function QL(t, e, n) {
  const { valueProp: i } = s3(t), s = n.useCheckbox.extendedCheckboxes, l = n.useValue.internalValue, a = n.useData.update, o = g1(
    () => H(i)
  ), h = (M) => M.disabled === !0, u = () => l.value.length >= 1e3, d = (M) => {
    const z = H(l);
    return !N1.isNil(z) && z.map((b) => b[H(o)]).indexOf(M[H(o)]) !== -1;
  }, v = (M) => s.value[s.value.map((z) => String(z[H(o)])).indexOf(String(M))], m = (M) => M, p = (M) => {
    typeof M != "object" && (M = v(M)), M.checked = !0, a(H(l).concat(M)), e.emit("check", m(M));
  }, _ = (M) => {
    typeof M != "object" && (M = v(M)), M.checked = !1, a(
      N1.filter(
        H(l),
        (z) => z[H(o)] !== M[H(o)]
      )
    ), e.emit("uncheck", m(M));
  }, q = (M) => {
    if (!h(M)) {
      if (d(M)) {
        _(M);
        return;
      }
      u() || p(M);
    }
  };
  return {
    handleSpace: (M) => {
      q(M);
    },
    handleClick: q
  };
}
function ex(t) {
  const e = t.useCheck.handleClick;
  return {
    handleSpace: (n) => {
      e(n);
    },
    handleEnter: (n) => {
      e(n);
    }
  };
}
const Vd1 = c2({
  name: "EclCheckbox",
  components: {
    EclIcon: Ie
  },
  emits: ["update:modelValue", "change", "check", "uncheck"],
  props: {
    value: {
      required: !1
    },
    modelValue: {
      required: !1
    },
    checkboxes: {
      required: !0,
      type: [Array, String, Number, Boolean]
    },
    invalid: {
      required: !1,
      type: Boolean,
      default: !1
    },
    required: {
      required: !1,
      type: Boolean,
      default: !1
    },
    requiredText: {
      required: !1,
      type: String,
      default: "*"
    },
    showOptionalText: {
      required: !1,
      type: Boolean,
      default: !1
    },
    optionalText: {
      required: !1,
      type: String,
      default: " (optional)"
    },
    legend: {
      required: !1,
      type: String
    },
    helperText: {
      type: String,
      required: !1
    },
    errorText: {
      type: String,
      required: !1
    },
    valueProp: {
      type: String,
      required: !1,
      default: "value"
    }
  },
  setup(t, e) {
    const n = KL(t), i = ZL(t, e), s = JL(t, e, {
      useValue: i,
      useCheckbox: n
    }), l = QL(t, e, {
      useCheckbox: n,
      useValue: i,
      useData: s
    }), a = ex({
      useCheck: l
    });
    return {
      ...n,
      ...s,
      ...l,
      ...a,
      EclIconSize: ye
    };
  }
}), Rd1 = {
  "aria-describedby": "checkbox-default-helper",
  class: "ecl-form-group"
}, Hd1 = ["innerHTML"], Dd1 = ["innerHTML"], $d1 = ["innerHTML"], Ud1 = ["id", "name", "value", "checked", "disabled", "onKeydown", "onClick"], jd1 = ["for", "onClick"], Gd1 = ["innerHTML"];
function Wd1(t, e, n, i, s, l) {
  const a = V2("ecl-icon");
  return T(), N("fieldset", Rd1, [
    t.legend ? (T(), N("legend", {
      key: 0,
      class: f2(["ecl-form-label", { "ecl-form-label--invalid": t.invalid }]),
      id: "checkbox-default-label"
    }, [
      K3(pt(t.legend) + " ", 1),
      t.showOptionalText && !t.required ? (T(), N("span", {
        key: 0,
        class: "ecl-form-label__optional",
        innerHTML: t.optionalText
      }, null, 8, Hd1)) : m2("", !0)
    ], 2)) : m2("", !0),
    t.helperText ? (T(), N("div", {
      key: 1,
      id: "checkbox-default-helper",
      class: "ecl-help-block",
      innerHTML: t.helperText
    }, null, 8, Dd1)) : m2("", !0),
    t.invalid && t.errorText ? (T(), N("div", {
      key: 2,
      class: "ecl-feedback-message",
      innerHTML: t.errorText
    }, null, 8, $d1)) : m2("", !0),
    (T(!0), N(I3, null, Ve(t.extendedCheckboxes, (o, h) => (T(), N("div", {
      key: h,
      class: f2(["ecl-checkbox", { "ecl-checkbox--disabled": o.disabled, "ecl-checkbox--invalid": t.invalid }])
    }, [
      C("input", {
        type: "checkbox",
        class: "ecl-checkbox__input",
        id: o.id,
        name: o.name,
        value: o.value,
        checked: o.checked,
        disabled: o.disabled,
        onKeydown: [
          P5(Et((u) => t.handleSpace(o), ["prevent"]), ["space"]),
          P5(Et((u) => t.handleEnter(o), ["prevent"]), ["enter"])
        ],
        onClick: Et((u) => t.handleClick(o), ["stop", "prevent"])
      }, null, 40, Ud1),
      C("label", {
        class: "ecl-checkbox__label",
        for: o.id,
        onClick: Et((u) => t.handleClick(o), ["stop", "prevent"])
      }, [
        C("span", {
          class: f2(["ecl-checkbox__box", { "ecl-checkbox__box--disabled": o.disabled }])
        }, [
          _3(a, {
            class: "ecl-checkbox__icon",
            icon: "check",
            size: t.EclIconSize.S
          }, null, 8, ["size"])
        ], 2),
        K3(" " + pt(o.label), 1)
      ], 8, jd1),
      o.helpText ? (T(), N("div", {
        key: 0,
        class: f2(["ecl-checkbox__help", { "ecl-checkbox__help--disabled": o.disabled }]),
        innerHTML: o.helpText
      }, null, 10, Gd1)) : m2("", !0)
    ], 2))), 128))
  ]);
}
const tx = /* @__PURE__ */ f4(Vd1, [["render", Wd1], ["__scopeId", "data-v-7c32b51a"]]);
c2({
  name: "EclCheckbox",
  components: {
    EclIcon: Ie
  },
  emits: ["update:modelValue", "change", "check", "uncheck"],
  props: {
    value: {
      required: !1
    },
    modelValue: {
      required: !1
    },
    checkboxes: {
      required: !0,
      type: [Array, String, Number, Boolean]
    },
    invalid: {
      required: !1,
      type: Boolean,
      default: !1
    },
    required: {
      required: !1,
      type: Boolean,
      default: !1
    },
    requiredText: {
      required: !1,
      type: String,
      default: "*"
    },
    showOptionalText: {
      required: !1,
      type: Boolean,
      default: !1
    },
    optionalText: {
      required: !1,
      type: String,
      default: " (optional)"
    },
    legend: {
      required: !1,
      type: String
    },
    helperText: {
      type: String,
      required: !1
    },
    errorText: {
      type: String,
      required: !1
    },
    valueProp: {
      type: String,
      required: !1,
      default: "value"
    }
  },
  setup(t, e) {
    const n = KL(t), i = ZL(t, e), s = JL(t, e, {
      useValue: i,
      useCheckbox: n
    }), l = QL(t, e, {
      useCheckbox: n,
      useValue: i,
      useData: s
    }), a = ex({
      useCheck: l
    });
    return {
      ...n,
      ...s,
      ...l,
      ...a,
      EclIconSize: ye
    };
  }
});
c2({
  name: "EclFiles",
  components: {
    EclIcon: Ie,
    EclLink: O4,
    EclButton: Lt
  },
  props: {
    title: {
      required: !0,
      type: String
    },
    fileList: {
      required: !0,
      type: Array
    },
    metaList: {
      required: !1,
      type: Array
    },
    label: {
      required: !1,
      type: String
    },
    description: {
      required: !1,
      type: String
    }
  },
  setup(t) {
    const e = d4().theme === "ec", { fileList: n } = s3(t), i = D1(!1), s = g1(() => {
      const l = {
        main: [],
        translations: []
      }, a = H(n);
      if ((a == null ? void 0 : a.length) > 0)
        if (N1.some(a, (o) => o.main)) {
          const o = a.filter((h) => h.main);
          l.main.push(...o), l.translations.push(...N1.difference(a, o));
        } else
          l.main.push(N1.head(a)), l.translations.push(...a.slice(1, a.length));
      return l;
    });
    return {
      isEc: e,
      className: (l) => k6("ecl-file", null, l),
      id: N1.uniqueId(),
      EclIconSize: ye,
      EclLinkIconPosition: dn,
      EclLinkType: f0,
      EclButtonType: I4,
      fileListByType: s,
      translationExpanded: i
    };
  }
});
c2({
  name: "EclFiles",
  components: {
    EclIcon: Ie,
    EclLink: O4,
    EclButton: Lt
  },
  props: {
    title: {
      required: !0,
      type: String
    },
    fileList: {
      required: !0,
      type: Array
    },
    metaList: {
      required: !1,
      type: Array
    },
    label: {
      required: !1,
      type: String
    },
    description: {
      required: !1,
      type: String
    }
  },
  setup(t) {
    const e = d4().theme === "ec", { fileList: n } = s3(t), i = D1(!1), s = g1(() => {
      const l = {
        main: [],
        translations: []
      }, a = H(n);
      if ((a == null ? void 0 : a.length) > 0)
        if (N1.some(a, (o) => o.main)) {
          const o = a.filter((h) => h.main);
          l.main.push(...o), l.translations.push(...N1.difference(a, o));
        } else
          l.main.push(N1.head(a)), l.translations.push(...a.slice(1, a.length));
      return l;
    });
    return {
      isEc: e,
      className: (l) => k6("ecl-file", null, l),
      id: N1.uniqueId(),
      EclIconSize: ye,
      EclLinkIconPosition: dn,
      EclLinkType: f0,
      EclButtonType: I4,
      fileListByType: s,
      translationExpanded: i
    };
  }
});
c2({
  name: "EclFileUpload",
  emits: ["update:modelValue", "change"],
  props: {
    id: {
      type: String,
      default: `eclfileupload-${li()}`
    },
    required: {
      type: Boolean,
      default: !1
    },
    requiredText: {
      type: String,
      default: "*"
    },
    label: {
      type: String,
      default: null
    },
    buttonChooseLabel: {
      type: String,
      default: "Choose file"
    },
    buttonReplaceLabel: {
      type: String,
      default: "Replace file"
    },
    showHelperText: {
      type: Boolean,
      default: !1
    },
    helperText: {
      type: String,
      default: (
        // eslint-disable-next-line quotes
        "This is the input's helper text.<div class='ecl-u-mt-xs ecl-u-type-color-grey-75'>Only <strong>txt doc docx pdf odt rtf</strong> files. Maximum size is <strong>5 MB</strong>.<br />Encrypted documents and those containing macros are not accepted.</div>"
      )
    }
  },
  setup(t, { emit: e }) {
    const n = D1(), i = D1(t.buttonChooseLabel);
    return {
      inputEl: n,
      buttonLabel: i,
      fileChange: (s) => {
        const l = s.target;
        l != null && l.files && l.files.length > 0 && (e("update:modelValue", N1.head(l.files)), e("change", N1.head(l.files)), i.value = t.buttonReplaceLabel);
      },
      reset: () => {
        D0(() => {
          n.value = void 0, i.value = t.buttonChooseLabel;
        });
      }
    };
  }
});
c2({
  name: "EclFileUpload",
  emits: ["update:modelValue", "change"],
  props: {
    id: {
      type: String,
      default: `eclfileupload-${li()}`
    },
    required: {
      type: Boolean,
      default: !1
    },
    requiredText: {
      type: String,
      default: "*"
    },
    label: {
      type: String,
      default: null
    },
    buttonChooseLabel: {
      type: String,
      default: "Choose file"
    },
    buttonReplaceLabel: {
      type: String,
      default: "Replace file"
    },
    showHelperText: {
      type: Boolean,
      default: !1
    },
    helperText: {
      type: String,
      default: (
        // eslint-disable-next-line quotes
        "This is the input's helper text.<div class='ecl-u-mt-xs ecl-u-type-color-grey-75'>Only <strong>txt doc docx pdf odt rtf</strong> files. Maximum size is <strong>5 MB</strong>.<br />Encrypted documents and those containing macros are not accepted.</div>"
      )
    }
  },
  setup(t, { emit: e }) {
    const n = D1(), i = D1(t.buttonChooseLabel);
    return {
      inputEl: n,
      buttonLabel: i,
      fileChange: (s) => {
        const l = s.target;
        l != null && l.files && l.files.length > 0 && (e("update:modelValue", N1.head(l.files)), e("change", N1.head(l.files)), i.value = t.buttonReplaceLabel);
      },
      reset: () => {
        D0(() => {
          n.value = void 0, i.value = t.buttonChooseLabel;
        });
      }
    };
  }
});
function Yd1(t) {
  const { list: e, modelValue: n } = s3(t), i = (s) => `ecl-radio__radio-${(s == null ? void 0 : s.value) ?? N1.uniqueId()}`;
  return {
    extendedList: g1(() => H(e).map((s) => ({
      id: i(s),
      helpText: s == null ? void 0 : s.helpText,
      checked: (s == null ? void 0 : s.checked) ?? H(n) === s.value,
      disabled: s == null ? void 0 : s.disabled,
      value: s.value,
      label: s.label
    })))
  };
}
function Xd1(t, e) {
  return {
    internalValue: D1()
  };
}
function Kd1(t, e) {
  const n = e.useValue.internalValue, i = e.useRadio.extendedList;
  n.value = H(i).find(
    (a) => a.checked === !0
  );
  const s = (a) => {
    if (!N1.isNil(a))
      return a.checked ? a.value : void 0;
  }, l = (a) => {
    if (!N1.isNil(a))
      return a;
  };
  return {
    update: (a) => {
      n.value = l(a);
      const o = s(a);
      t.emit("change", o), t.emit("update:modelValue", o);
    }
  };
}
function Zd1(t, e, n) {
  const i = n.useRadio.extendedList, s = n.useValue.internalValue, l = n.useData.update, a = (m) => m.disabled === !0, o = (m) => {
    const p = H(s);
    return !N1.isNil(p) && m.value === p.value;
  }, h = (m) => i.value[i.value.map((p) => String(p.value)).indexOf(String(m))], u = (m) => m, d = (m) => {
    typeof m != "object" && (m = h(m)), m.checked = !0, l(m), e.emit("check", u(m));
  }, v = (m) => {
    a(m) || o(m) || d(m);
  };
  return {
    handleSpace: (m) => {
      v(m);
    },
    handleClick: v
  };
}
function Jd1(t) {
  const e = t.useCheck.handleClick;
  return {
    handleSpace: (n) => {
      e(n);
    },
    handleEnter: (n) => {
      e(n);
    }
  };
}
const Qd1 = c2({
  name: "EclRadio",
  components: {
    EclIcon: Ie
  },
  emits: ["update:modelValue", "change", "check", "uncheck"],
  props: {
    modelValue: {
      required: !1,
      type: [String, Number, Boolean]
    },
    list: {
      required: !0,
      type: Array
    },
    /**
     * Display inline
     */
    binary: {
      required: !1,
      type: Boolean,
      default: () => !1
    },
    invalid: {
      required: !1,
      type: Boolean,
      default: !1
    },
    required: {
      required: !1,
      type: Boolean,
      default: !1
    },
    requiredText: {
      required: !1,
      type: String,
      default: "*"
    },
    showOptionalText: {
      required: !1,
      type: Boolean,
      default: !1
    },
    optionalText: {
      required: !1,
      type: String,
      default: " (optional)"
    },
    legend: {
      required: !1,
      type: String
    },
    helperText: {
      type: String,
      required: !1
    },
    errorText: {
      type: String,
      required: !1
    }
  },
  setup(t, e) {
    const n = Yd1(t), i = Xd1(), s = Kd1(e, {
      useValue: i,
      useRadio: n
    }), l = Zd1(t, e, {
      useRadio: n,
      useValue: i,
      useData: s
    }), a = Jd1({
      useCheck: l
    });
    return {
      ...n,
      ...s,
      ...l,
      ...a,
      EclIconSize: ye
    };
  }
}), ef1 = (t) => ($s("data-v-88dc7a0c"), t = t(), Us(), t), tf1 = {
  "aria-describedby": "radio-default-helper",
  class: "ecl-form-group"
}, nf1 = ["innerHTML"], if1 = ["innerHTML"], sf1 = ["innerHTML"], lf1 = ["id", "name", "value", "checked", "disabled", "onKeydown", "onClick"], rf1 = ["for", "onClick"], af1 = /* @__PURE__ */ ef1(() => /* @__PURE__ */ C("span", { class: "ecl-radio__box-inner" }, null, -1)), of1 = [
  af1
], cf1 = ["innerHTML"];
function hf1(t, e, n, i, s, l) {
  return T(), N("fieldset", tf1, [
    t.legend ? (T(), N("legend", {
      key: 0,
      class: f2(["ecl-form-label", { "ecl-form-label--invalid": t.invalid }]),
      id: "radio-default-label"
    }, [
      K3(pt(t.legend) + " ", 1),
      t.showOptionalText && !t.required ? (T(), N("span", {
        key: 0,
        class: "ecl-form-label__optional",
        innerHTML: t.optionalText
      }, null, 8, nf1)) : m2("", !0)
    ], 2)) : m2("", !0),
    t.helperText ? (T(), N("div", {
      key: 1,
      id: "radio-default-helper",
      class: "ecl-help-block",
      innerHTML: t.helperText
    }, null, 8, if1)) : m2("", !0),
    t.invalid && t.errorText ? (T(), N("div", {
      key: 2,
      class: "ecl-feedback-message",
      innerHTML: t.errorText
    }, null, 8, sf1)) : m2("", !0),
    (T(!0), N(I3, null, Ve(t.extendedList, (a, o) => (T(), N("div", {
      key: o,
      class: f2(["ecl-radio", { "ecl-radio--binary": t.binary, "ecl-radio--disabled": a.disabled, "ecl-radio--invalid": t.invalid }])
    }, [
      C("input", {
        type: "radio",
        class: "ecl-radio__input",
        id: a.id,
        name: a.name,
        value: a.value,
        checked: a.checked,
        disabled: a.disabled,
        onKeydown: [
          P5(Et((h) => t.handleSpace(a), ["prevent"]), ["space"]),
          P5(Et((h) => t.handleEnter(a), ["prevent"]), ["enter"])
        ],
        onClick: Et((h) => t.handleClick(a), ["stop", "prevent"])
      }, null, 40, lf1),
      C("label", {
        class: "ecl-radio__label",
        for: a.id,
        onClick: Et((h) => t.handleClick(a), ["stop", "prevent"])
      }, [
        C("span", {
          class: f2(["ecl-radio__box", { "ecl-radio__box--disabled": a.disabled }])
        }, of1, 2),
        K3(" " + pt(a.label), 1)
      ], 8, rf1),
      a.helpText ? (T(), N("div", {
        key: 0,
        class: f2(["ecl-radio__help", { "ecl-radio__help--disabled": a.disabled }]),
        innerHTML: a.helpText
      }, null, 10, cf1)) : m2("", !0)
    ], 2))), 128))
  ]);
}
const nx = /* @__PURE__ */ f4(Qd1, [["render", hf1], ["__scopeId", "data-v-88dc7a0c"]]);
function ix(t, e) {
  const { searchable: n, mode: i, disabled: s, invalid: l, required: a } = s3(t), o = e.UUID, h = [], u = D1(null), d = D1(null), v = g1(() => C8()), m = g1(() => "eclselect-" + o), p = g1(() => H(n) ? -1 : 0), _ = g1(() => H(n) ?? !1), q = g1(() => H(i) === "multiple"), M = g1(() => H(s) ?? !1), z = g1(() => H(l) ?? !1), b = g1(() => H(a) ?? !1), x = g1(
    () => H(i) === "single"
  );
  return {
    useNative: v,
    addBlurElementRef: (k) => {
      k && N1.indexOf(h, k) < 0 && h.push(k);
    },
    eclSelectBlur: h,
    eclSelectSelect: u,
    eclSelectInput: d,
    selectId: m,
    tabindex: p,
    isSearchable: _,
    blurInput: () => {
      var k;
      const F = (k = H(u)) == null ? void 0 : k.querySelector("ecl-text-input");
      F && F.blur();
    },
    isMultiple: q,
    isDisabled: M,
    isInvalid: z,
    isRequired: b,
    modeSingle: x
  };
}
function sx(t, e, n) {
  const { disabled: i } = s3(t), s = n.useSelect.eclSelectBlur, l = D1(!1), a = () => {
    H(i) || (document.body.addEventListener("click", u), l.value = !0, e.emit("open"));
  }, o = () => {
    document.body.removeEventListener("click", u), l.value = !1, e.emit("close");
  }, h = () => {
    l.value ? o() : a();
  }, u = (d) => {
    N1.some(s, (v) => v === d.target || v.contains(d.target)) === !1 && o();
  };
  return {
    isOpen: l,
    toggleOpen: h,
    open: a,
    close: o,
    handleEnterComponent: () => {
      h();
    },
    handleInputMousedown: () => {
      h();
    },
    handleBlurComponent: () => {
      o();
    }
  };
}
function lx(t) {
  const e = t.useDropdown.close, n = t.useOptions.filteredOptions, i = t.useOptions.handleOptionClick, s = t.useOptions.handleOptionClickSelectAll, l = t.useOptions.handleOptionClickDeselectAll;
  return {
    handleEnter: i,
    handleSpace: i,
    handleSpaceSelectAll: s,
    handleEnterSelectAll: s,
    handleSpaceDeselectAll: l,
    handleEnterDeselectAll: l,
    handleOptionBlur: (a) => {
      N1.isEqual(a, N1.last(n.value)) && e();
    }
  };
}
function rx(t, e, n) {
  const { modelValue: i } = s3(t), s = n.UUID, l = n.useSelect.modeSingle, a = () => H(i) ? H(l) === !1 && !N1.isArray(H(i)) ? H(i) : H(i) : H(l) === !1 ? void 0 : [], o = D1(), h = D1({
    checked: !1,
    id: `optchbx_${s}_all`
  }), u = D1({
    checked: !1,
    id: `optchbx_${s}_deselect_all`
  }), d = e.expose !== void 0 ? i : D1(a());
  return {
    internalValue: o,
    externalValue: d,
    checkboxSelectAll: h,
    checkboxDeselectAll: u
  };
}
function ax(t, e, n) {
  const { valueProp: i, mode: s } = s3(t), l = n.useValue.internalValue, a = (h) => {
    if (N1.isNil(h))
      return H(s) === "single" ? void 0 : [];
    const u = H(i);
    return N1.isArray(h) ? N1.map(h, (d) => d[u]) : h[u];
  }, o = (h) => N1.isNil(h) ? H(s) === "single" ? void 0 : [] : h;
  return {
    update: (h) => {
      l.value = o(h);
      const u = a(h);
      e.emit("change", u), e.emit("input", u), e.emit("update:modelValue", u);
    }
  };
}
function ox(t, e, n) {
  const {
    modelValue: i,
    options: s,
    optionLabel: l,
    optionValue: a,
    mode: o,
    limit: h,
    clearOnSelect: u,
    multipleGroupLabel: d,
    multipleGroupLimit: v
  } = s3(t), { t: m } = ln(), p = n.UUID, _ = n.useValue.internalValue, q = n.useValue.externalValue, M = n.useValue.checkboxSelectAll, z = n.useData.update, b = n.useDropdown.close, x = n.useSearch.search, k = n.useSearch.clearSearch, F = t.valueProp, D = ($) => {
    const a1 = H(_), n1 = $[F];
    if (!N1.isNil(a1) && !N1.isEmpty(a1) && !N1.isNil(n1))
      switch (H(o)) {
        case "single":
          return a1[F] === n1;
        case "multiple":
          return a1.map((f1) => f1[F]).indexOf(n1) !== -1;
      }
    return !1;
  }, R = g1(
    () => {
      let $ = H(s) || [];
      const a1 = H(l), n1 = H(a);
      return $ = N1.map($, (f1) => ({
        ...f1,
        value: f1[n1],
        label: f1[a1]
      })), N1.map(
        $,
        (f1) => N1.assign(
          {
            id: `optchbx_${p}_${f1.value}`,
            checked: D(f1),
            disabled: !1
          },
          f1
        )
      );
    }
  ), V = g1(() => H(x) ? N1.filter(
    H(R),
    ($) => {
      var a1;
      const n1 = (a1 = H(x)) == null ? void 0 : a1.toLowerCase(), f1 = String($.label).toLowerCase().trim();
      return n1 ? f1.indexOf(n1) >= 0 : !1;
    }
  ) : H(R)), J = ($) => R.value[R.value.map((a1) => String(a1[F])).indexOf(String($))], K = g1(() => {
    const $ = H(_);
    if (!N1.isNil($) && !N1.isEmpty($)) {
      if (N1.isArray($)) {
        const a1 = H(v);
        return H(d) && !N1.isNil(a1) && $.length > a1 ? m("ECLV3.FORM.SELECT.GROUP_LABEL", [$.length]) : $.map((n1) => n1.label).join(", ");
      }
      return $.label;
    }
    return null;
  }), P = ($) => $[F], O = () => {
    z(null);
  }, G = ($) => {
    switch (typeof $ != "object" && ($ = J($)), H(o)) {
      case "single":
        z($), b(), H(u) && k();
        break;
      case "multiple": {
        const a1 = H(h);
        if (!N1.isNil(_.value) && !N1.isNil(a1)) {
          const n1 = H(_);
          (a1 === 0 || a1 > n1.length) && z(n1.concat($));
        }
        H(u) && k();
        break;
      }
    }
    e.emit("select", P($));
  }, j = () => {
    M.value.checked = !1, O();
  }, Q = ($) => {
    M.value.checked = !1;
    const a1 = typeof $ == "string" ? J($) : $;
    if (H(o) === "single")
      O();
    else {
      const n1 = H(_);
      n1 && N1.isArray(n1) && z(n1.filter((f1) => f1[F] !== a1[F]));
    }
    e.emit("deselect", P(a1));
  }, i1 = ($) => $.disabled === !0, h1 = ($) => {
    if (!i1($))
      switch (H(o)) {
        case "single":
          if (D($))
            return;
          G($);
          break;
        case "multiple":
          if (D($)) {
            Q($);
            return;
          }
          G($);
          break;
      }
  }, c1 = () => {
    M.value.checked = !M.value.checked, H(o) === "multiple" && N1.each(V.value, ($) => {
      i1($) || (M.value.checked ? D($) === !1 && G($) : D($) && Q($));
    });
  }, M1 = () => {
    j();
  }, y1 = ($) => {
    var a1;
    const n1 = N1.map(
      // @ts-ignore
      (a1 = $ == null ? void 0 : $.target) == null ? void 0 : a1.selectedOptions,
      (f1) => f1.value
    );
    H(o) === "single" && N1.head(n1) === "" && O(), N1.each(V.value, (f1) => {
      const w1 = N1.indexOf(n1, f1.value) >= 0;
      (N1.isNil(f1.checked) || f1.checked === !1) && w1 && G(f1), f1.checked && !w1 && Q(f1);
    });
  }, A1 = ($) => {
    if (N1.isNil($))
      return H(o) === "single" ? void 0 : [];
    if (H(o) === "single")
      return J($);
    if (N1.isArray($))
      return $.filter((a1) => !!J(a1)).map((a1) => J(a1));
  };
  return N1.isNil(q.value) || (_.value = A1(q.value)), l3(
    () => H(i),
    ($) => {
      _.value = A1($);
    },
    {
      immediate: !0
    }
  ), {
    extendedOptions: R,
    filteredOptions: V,
    multipleLabelText: K,
    handleOptionClick: h1,
    handleOptionClickSelectAll: c1,
    handleOptionClickDeselectAll: M1,
    handleOptionNativeChange: y1
  };
}
function cx(t) {
  const e = D1(null), n = D1(null), i = () => {
    e.value = "";
  }, s = () => {
    const l = H(n);
    l && l.blur();
  };
  return l3(e, (l) => {
    t.emit("search-change", l);
  }), {
    search: e,
    input: n,
    clearSearch: i,
    blurSearch: s
  };
}
function hx(t, e) {
  const { selectAll: n, deselectAll: i, limit: s } = s3(t), l = e.useValue.internalValue, a = e.useOptions.extendedOptions, o = e.useSelect.isMultiple, h = g1(() => {
    const _ = H(l);
    return N1.isArray(_) ? _.length > 0 : !N1.isEmpty(_);
  }), u = g1(() => {
    const _ = H(l);
    return N1.isArray(_) ? (_ == null ? void 0 : _.length) ?? 0 : 0;
  }), d = g1(() => {
    var _;
    const q = H(l);
    if (N1.isArray(q)) {
      const M = q.length, z = ((_ = H(a)) == null ? void 0 : _.length) || 0, b = H(s), x = !N1.isNil(b) && b !== 0 && z > b ? H(s) : z;
      return M === x;
    }
    return !N1.isEmpty(q);
  }), v = g1(() => H(d) ? !1 : H(n) ?? !1), m = g1(() => H(v) === !1 ? H(i) ?? !1 : !1), p = g1(() => H(o) && H(h));
  return {
    countSelected: u,
    showDeselectAll: m,
    showSelectAll: v,
    showMultipleToolbar: p
  };
}
var ux = /* @__PURE__ */ ((t) => (t.L = "l", t.M = "m", t.S = "s", t.XS = "xs", t.FLUID = "fluid", t))(ux || {}), dx = /* @__PURE__ */ ((t) => (t.XS = "xs", t.S = "s", t.M = "m", t.L = "l", t))(dx || {});
c2({
  name: "EclSelect",
  components: {
    EclIcon: Ie,
    EclButton: Lt
  },
  emits: [
    "open",
    "close",
    "change",
    "input",
    "update:modelValue",
    "select",
    "deselect",
    "search-change"
  ],
  props: {
    options: {
      type: Array,
      required: !0
    },
    id: {
      type: String,
      default: "",
      required: !1
    },
    modelValue: {
      type: [String, Array, Number],
      default: () => [],
      required: !1
    },
    label: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      required: !1,
      default: !1
    },
    requiredText: {
      required: !1,
      type: String,
      default: "*"
    },
    showOptionalText: {
      required: !1,
      type: Boolean,
      default: !1
    },
    optionalText: {
      required: !1,
      type: String,
      default: () => {
        const { t } = ln();
        return t("ECLV3.FORM.OPTIONAL");
      }
    },
    searchable: {
      required: !1,
      type: Boolean,
      default: !1
    },
    mode: {
      required: !1,
      type: String,
      default: "single"
      // single, multiple
    },
    // solo per mode = multiple
    limit: {
      required: !1,
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    helperText: {
      type: String,
      required: !1
    },
    size: {
      default: "m",
      required: !1,
      type: String,
      validator: (t) => Object.values(dx).includes(t)
    },
    width: {
      default: "fluid",
      required: !1,
      type: String,
      validator: (t) => Object.values(ux).includes(t)
    },
    invalid: {
      type: Boolean,
      required: !1,
      default: !1
    },
    invalidText: {
      required: !1,
      type: String
    },
    multiplePlaceholder: {
      required: !1,
      type: String
    },
    searchLabel: {
      required: !1,
      type: String,
      default: () => {
        const { t } = ln();
        return t("ECLV3.FORM.SELECT.SEARCH");
      }
    },
    selectAll: {
      required: !1,
      type: Boolean,
      default: !0
    },
    selectAllLabel: {
      required: !1,
      type: String,
      default: () => {
        const { t } = ln();
        return t("ECLV3.FORM.SELECT.ALL");
      }
    },
    deselectAll: {
      required: !1,
      type: Boolean,
      default: !0
    },
    deselectAllLabel: {
      required: !1,
      type: String,
      default: () => {
        const { t } = ln();
        return t("ECLV3.FORM.SELECT.DESELECT_ALL");
      }
    },
    // refactoring delle options interno
    optionLabel: {
      required: !1,
      type: String,
      default: "label"
    },
    // refactoring delle options interno
    optionValue: {
      required: !1,
      type: String,
      default: "value"
    },
    valueProp: {
      required: !1,
      type: String,
      default: "value"
    },
    clearOnSelect: {
      required: !1,
      type: Boolean,
      default: !0
    },
    multipleGroupLabel: {
      required: !1,
      type: Boolean,
      default: !0
    },
    multipleGroupLimit: {
      required: !1,
      type: Number,
      default: 9999
    }
  },
  setup(t, e) {
    if (t.modelValue && Jb(t.modelValue))
      throw new Error(
        "EclSelect: error on modelValue type. You must provide a reactive not a Ref!"
      );
    const n = g1(() => C8()), i = li(), s = ix(t, {
      UUID: i
    }), l = rx(t, e, {
      UUID: i,
      useSelect: s
    }), a = ax(t, e, {
      useValue: l
    }), o = sx(t, e, {
      useSelect: s
    }), h = cx(e), u = ox(t, e, {
      UUID: i,
      useData: a,
      useValue: l,
      useDropdown: o,
      useSearch: h
    }), d = lx({
      useDropdown: o,
      useOptions: u
    }), v = g1(
      () => `${t.selectAllLabel} (${H(u.extendedOptions).length})`
    ), m = hx(t, {
      useSelect: s,
      useValue: l,
      useOptions: u
    });
    return {
      isMobile: n,
      ...s,
      ...h,
      ...a,
      ...u,
      ...o,
      ...d,
      ...l,
      ...m,
      selectAllLabelWithCount: v,
      EclIconSize: ye,
      EclButtonIconPosition: di,
      EclButtonType: I4
    };
  }
});
var fx = /* @__PURE__ */ ((t) => (t.L = "l", t.M = "m", t.S = "s", t.XS = "xs", t.FLUID = "fluid", t))(fx || {}), vx = /* @__PURE__ */ ((t) => (t.XS = "xs", t.S = "s", t.M = "m", t.L = "l", t))(vx || {});
c2({
  name: "EclSelect",
  components: {
    EclIcon: Ie,
    EclButton: Lt
  },
  emits: [
    "open",
    "close",
    "change",
    "input",
    "update:modelValue",
    "select",
    "deselect",
    "search-change"
  ],
  props: {
    options: {
      type: Array,
      required: !0
    },
    id: {
      type: String,
      default: "",
      required: !1
    },
    modelValue: {
      type: [String, Array, Number],
      default: () => [],
      required: !1
    },
    label: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      required: !1,
      default: !1
    },
    requiredText: {
      required: !1,
      type: String,
      default: "*"
    },
    showOptionalText: {
      required: !1,
      type: Boolean,
      default: !1
    },
    optionalText: {
      required: !1,
      type: String,
      default: () => {
        const { t } = ln();
        return t("ECLV3.FORM.OPTIONAL");
      }
    },
    searchable: {
      required: !1,
      type: Boolean,
      default: !1
    },
    mode: {
      required: !1,
      type: String,
      default: "single"
      // single, multiple
    },
    // solo per mode = multiple
    limit: {
      required: !1,
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    helperText: {
      type: String,
      required: !1
    },
    size: {
      default: "m",
      required: !1,
      type: String,
      validator: (t) => Object.values(vx).includes(t)
    },
    width: {
      default: "fluid",
      required: !1,
      type: String,
      validator: (t) => Object.values(fx).includes(t)
    },
    invalid: {
      type: Boolean,
      required: !1,
      default: !1
    },
    invalidText: {
      required: !1,
      type: String
    },
    multiplePlaceholder: {
      required: !1,
      type: String
    },
    searchLabel: {
      required: !1,
      type: String,
      default: () => {
        const { t } = ln();
        return t("ECLV3.FORM.SELECT.SEARCH");
      }
    },
    selectAll: {
      required: !1,
      type: Boolean,
      default: !0
    },
    selectAllLabel: {
      required: !1,
      type: String,
      default: () => {
        const { t } = ln();
        return t("ECLV3.FORM.SELECT.ALL");
      }
    },
    deselectAll: {
      required: !1,
      type: Boolean,
      default: !0
    },
    deselectAllLabel: {
      required: !1,
      type: String,
      default: () => {
        const { t } = ln();
        return t("ECLV3.FORM.SELECT.DESELECT_ALL");
      }
    },
    // refactoring delle options interno
    optionLabel: {
      required: !1,
      type: String,
      default: "label"
    },
    // refactoring delle options interno
    optionValue: {
      required: !1,
      type: String,
      default: "value"
    },
    valueProp: {
      required: !1,
      type: String,
      default: "value"
    },
    clearOnSelect: {
      required: !1,
      type: Boolean,
      default: !0
    },
    multipleGroupLabel: {
      required: !1,
      type: Boolean,
      default: !0
    },
    multipleGroupLimit: {
      required: !1,
      type: Number,
      default: 9999
    }
  },
  setup(t, e) {
    if (t.modelValue && Jb(t.modelValue))
      throw new Error(
        "EclSelect: error on modelValue type. You must provide a reactive not a Ref!"
      );
    const n = g1(() => C8()), i = li(), s = ix(t, {
      UUID: i
    }), l = rx(t, e, {
      UUID: i,
      useSelect: s
    }), a = ax(t, e, {
      useValue: l
    }), o = sx(t, e, {
      useSelect: s
    }), h = cx(e), u = ox(t, e, {
      UUID: i,
      useData: a,
      useValue: l,
      useDropdown: o,
      useSearch: h
    }), d = lx({
      useDropdown: o,
      useOptions: u
    }), v = g1(
      () => `${t.selectAllLabel} (${H(u.extendedOptions).length})`
    ), m = hx(t, {
      useSelect: s,
      useValue: l,
      useOptions: u
    });
    return {
      isMobile: n,
      ...s,
      ...h,
      ...a,
      ...u,
      ...o,
      ...d,
      ...l,
      ...m,
      selectAllLabelWithCount: v,
      EclIconSize: ye,
      EclButtonIconPosition: di,
      EclButtonType: I4
    };
  }
});
function px(t, e, n = "modelValue") {
  return g1({
    get: () => t[n],
    set: (i) => e(`update:${n}`, i)
  });
}
var mx = /* @__PURE__ */ ((t) => (t.Text = "text", t.Password = "password", t))(mx || {}), gx = /* @__PURE__ */ ((t) => (t.L = "l", t.M = "m", t.S = "s", t.XS = "xs", t))(gx || {});
const uf1 = c2({
  name: "EclTextField",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: "",
      required: !0
    },
    type: {
      required: !1,
      type: String,
      default: "text",
      enum: Object.values(mx)
    },
    classes: {
      required: !1,
      type: Array
    },
    inputId: {
      required: !1,
      type: String
    },
    label: {
      required: !1,
      type: String
    },
    showLabel: {
      required: !1,
      type: Boolean,
      default: !0
    },
    helperText: {
      required: !1,
      type: String
    },
    invalid: {
      required: !1,
      type: Boolean,
      default: !1
    },
    invalidText: {
      required: !1,
      type: String
    },
    disabled: {
      required: !1,
      type: Boolean,
      default: !1
    },
    required: {
      required: !1,
      type: Boolean,
      default: !1
    },
    requiredText: {
      required: !1,
      type: String,
      default: "*"
    },
    optionalText: {
      required: !1,
      type: String,
      default: " (optional)"
    },
    showLabelType: {
      required: !1,
      type: Boolean,
      default: !0
    },
    size: {
      required: !1,
      type: String,
      default: "m",
      enum: Object.values(gx)
    },
    placeholder: {
      required: !1,
      type: String
    }
  },
  computed: {
    id() {
      return N1.isNil(this.inputId) ? "ecltxtfield-" + li() : this.inputId;
    },
    classInput() {
      const t = this.classes ? [...this.classes] : [];
      return this.size && this.size !== "" && t.push(`ecl-text-input--size-${this.size}`), this.invalid && t.push("ecl-text-input--invalid"), t.unshift("ecl-text-input"), t.join(" ");
    },
    classLabel() {
      const t = ["ecl-form-label"];
      return this.invalid && t.push("ecl-form-label--invalid"), t.join(" ");
    }
  },
  setup(t, { emit: e }) {
    return {
      value: px(t, e)
    };
  }
}), df1 = { class: "ecl-form-group" }, ff1 = ["for"], vf1 = {
  key: 0,
  class: "ecl-form-label__required"
}, pf1 = {
  key: 1,
  class: "ecl-form-label__optional"
}, mf1 = ["innerHTML"], gf1 = ["innerHTML"], yf1 = ["type", "id", "required", "placeholder"];
function _f1(t, e, n, i, s, l) {
  return T(), N("div", df1, [
    t.label && t.showLabel ? (T(), N("label", {
      key: 0,
      class: f2(t.classLabel),
      for: t.id
    }, [
      K3(pt(t.label) + " ", 1),
      t.showLabelType ? (T(), N(I3, { key: 0 }, [
        t.required ? (T(), N("span", vf1, pt(t.requiredText), 1)) : (T(), N("span", pf1, pt(t.optionalText), 1))
      ], 64)) : m2("", !0)
    ], 10, ff1)) : m2("", !0),
    t.helperText ? (T(), N("div", {
      key: 1,
      class: "ecl-help-block",
      innerHTML: t.helperText
    }, null, 8, mf1)) : m2("", !0),
    t.invalid ? (T(), N("div", {
      key: 2,
      class: "ecl-feedback-message",
      innerHTML: t.invalidText
    }, null, 8, gf1)) : m2("", !0),
    b6(C("input", {
      type: t.type,
      id: t.id,
      class: f2(t.classInput),
      required: t.required,
      "onUpdate:modelValue": e[0] || (e[0] = (a) => t.value = a),
      placeholder: t.placeholder
    }, null, 10, yf1), [
      [jA, t.value]
    ])
  ]);
}
const yx = /* @__PURE__ */ f4(uf1, [["render", _f1], ["__scopeId", "data-v-5e944a71"]]);
var _x = /* @__PURE__ */ ((t) => (t.Text = "text", t.Password = "password", t))(_x || {}), qx = /* @__PURE__ */ ((t) => (t.L = "l", t.M = "m", t.S = "s", t.XS = "xs", t))(qx || {});
c2({
  name: "EclTextField",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: "",
      required: !0
    },
    type: {
      required: !1,
      type: String,
      default: "text",
      enum: Object.values(_x)
    },
    classes: {
      required: !1,
      type: Array
    },
    inputId: {
      required: !1,
      type: String
    },
    label: {
      required: !1,
      type: String
    },
    showLabel: {
      required: !1,
      type: Boolean,
      default: !0
    },
    helperText: {
      required: !1,
      type: String
    },
    invalid: {
      required: !1,
      type: Boolean,
      default: !1
    },
    invalidText: {
      required: !1,
      type: String
    },
    disabled: {
      required: !1,
      type: Boolean,
      default: !1
    },
    required: {
      required: !1,
      type: Boolean,
      default: !1
    },
    requiredText: {
      required: !1,
      type: String,
      default: "*"
    },
    optionalText: {
      required: !1,
      type: String,
      default: " (optional)"
    },
    showLabelType: {
      required: !1,
      type: Boolean,
      default: !0
    },
    size: {
      required: !1,
      type: String,
      default: "m",
      enum: Object.values(qx)
    },
    placeholder: {
      required: !1,
      type: String
    }
  },
  computed: {
    id() {
      return N1.isNil(this.inputId) ? "ecltxtfield-" + li() : this.inputId;
    },
    classInput() {
      const t = this.classes ? [...this.classes] : [];
      return this.size && this.size !== "" && t.push(`ecl-text-input--size-${this.size}`), this.invalid && t.push("ecl-text-input--invalid"), t.unshift("ecl-text-input"), t.join(" ");
    },
    classLabel() {
      const t = ["ecl-form-label"];
      return this.invalid && t.push("ecl-form-label--invalid"), t.join(" ");
    }
  },
  setup(t, { emit: e }) {
    return {
      value: px(t, e)
    };
  }
});
const qf1 = c2({
  name: "EclPageHeader",
  components: {
    EclBreadcrumb: Oh
  },
  props: {
    type: {
      type: String,
      required: !1,
      default: "core"
      /* Core */
    },
    metaInfo: {
      type: String,
      required: !1
    },
    pageTitle: {
      type: String,
      required: !1
    },
    pageTitleReaderOnly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    description: {
      type: String,
      required: !1
    },
    backgroundImage: {
      type: String,
      required: !1
      // default: null
    },
    breadcrumbList: {
      type: Array,
      required: !1
    },
    breadcrumbEllipsisLimit: Oh.props.ellipsisLimit
  },
  setup(t) {
    const e = ["ecl-page-header"];
    t.backgroundImage && e.push("ecl-page-header--image");
    const n = g1(() => {
      const i = ["ecl-page-header__title"];
      return t.pageTitleReaderOnly && i.push("ecl-u-sr-only"), i.join(" ");
    });
    return {
      classes: e.join(" "),
      pageTitleClasses: n
    };
  }
}), wf1 = {
  key: 0,
  class: "ecl-page-header__background-container",
  "aria-hidden": "true"
}, zf1 = { class: "ecl-picture ecl-page-header__picture-background" }, Mf1 = ["src", "alt"], bf1 = { class: "ecl-container" }, Lf1 = ["innerHTML"], xf1 = ["innerHTML"], Sf1 = {
  key: 2,
  class: "ecl-page-header__description-container"
}, Cf1 = ["innerHTML"];
function kf1(t, e, n, i, s, l) {
  var a;
  const o = V2("ecl-breadcrumb");
  return T(), N("div", {
    class: f2(t.classes)
  }, [
    t.backgroundImage ? (T(), N("div", wf1, [
      C("picture", zf1, [
        C("img", {
          class: "ecl-page-header__background",
          src: t.backgroundImage,
          alt: t.pageTitle
        }, null, 8, Mf1)
      ])
    ])) : m2("", !0),
    C("div", bf1, [
      ((a = t.breadcrumbList) == null ? void 0 : a.length) > 0 ? (T(), v2(o, {
        key: 0,
        class: "ecl-page-header__breadcrumb",
        breadcrumb: t.breadcrumbList,
        ellipsisLimit: t.breadcrumbEllipsisLimit,
        type: t.type
      }, nL({ _: 2 }, [
        Ve(["breadcrumb_before_list", "breadcrumb_before_item", "breadcrumb_after_item", "breadcrumb_after_list"], (h) => ({
          name: h,
          fn: Q2((u) => [
            J2(t.$slots, h, on(v8(u)), void 0, !0)
          ])
        }))
      ]), 1032, ["breadcrumb", "ellipsisLimit", "type"])) : m2("", !0),
      t.metaInfo || t.pageTitle ? (T(), N("div", {
        key: 1,
        class: f2(["ecl-page-header__info", { "ecl-u-mt-none ecl-u-mb-xs ecl-u-pv-none ecl-u-mv-none": t.pageTitleReaderOnly }])
      }, [
        t.metaInfo ? (T(), N("div", {
          key: 0,
          class: "ecl-page-header__meta",
          innerHTML: t.metaInfo
        }, null, 8, Lf1)) : m2("", !0),
        C("h1", {
          class: f2(t.pageTitleClasses),
          innerHTML: t.pageTitle
        }, null, 10, xf1)
      ], 2)) : m2("", !0),
      t.description ? (T(), N("div", Sf1, [
        C("p", {
          class: "ecl-page-header__description",
          innerHTML: t.description
        }, null, 8, Cf1)
      ])) : m2("", !0)
    ])
  ], 2);
}
const ze = /* @__PURE__ */ f4(qf1, [["render", kf1], ["__scopeId", "data-v-67684c87"]]);
var mc = /* @__PURE__ */ ((t) => (t.Core = "core", t.Harmonised = "harmonised", t.Standardised = "standardised", t))(mc || {});
c2({
  name: "EclPageHeader",
  components: {
    EclBreadcrumb: Oh
  },
  props: {
    type: {
      type: String,
      required: !1,
      default: "core"
      /* Core */
    },
    metaInfo: {
      type: String,
      required: !1
    },
    pageTitle: {
      type: String,
      required: !1
    },
    pageTitleReaderOnly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    description: {
      type: String,
      required: !1
    },
    backgroundImage: {
      type: String,
      required: !1
      // default: null
    },
    breadcrumbList: {
      type: Array,
      required: !1
    },
    breadcrumbEllipsisLimit: Oh.props.ellipsisLimit
  },
  setup(t) {
    const e = ["ecl-page-header"];
    t.backgroundImage && e.push("ecl-page-header--image");
    const n = g1(() => {
      const i = ["ecl-page-header__title"];
      return t.pageTitleReaderOnly && i.push("ecl-u-sr-only"), i.join(" ");
    });
    return {
      classes: e.join(" "),
      pageTitleClasses: n
    };
  }
});
c2({
  name: "EclPageHeaderCore",
  components: {
    EclPageHeader: ze
  },
  props: {
    metaInfo: ze.props.metaInfo,
    pageTitle: ze.props.pageTitle,
    pageTitleReaderOnly: ze.props.pageTitleReaderOnly,
    description: ze.props.description,
    backgroundImage: ze.props.backgroundImage,
    breadcrumb: ze.props.breadcrumb,
    breadcrumbEllipsisLimit: ze.props.breadcrumbEllipsisLimit
  },
  setup() {
    return { EclPageHeaderType: mc };
  }
});
c2({
  name: "EclPageHeaderCore",
  components: {
    EclPageHeader: ze
  },
  props: {
    metaInfo: ze.props.metaInfo,
    pageTitle: ze.props.pageTitle,
    pageTitleReaderOnly: ze.props.pageTitleReaderOnly,
    description: ze.props.description,
    backgroundImage: ze.props.backgroundImage,
    breadcrumb: ze.props.breadcrumb,
    breadcrumbEllipsisLimit: ze.props.breadcrumbEllipsisLimit
  },
  setup() {
    return { EclPageHeaderType: mc };
  }
});
c2({
  name: "EclPageHeaderHarmonised",
  components: {
    EclPageHeader: ze
  },
  props: {
    metaInfo: ze.props.metaInfo,
    pageTitle: ze.props.pageTitle,
    pageTitleReaderOnly: ze.props.pageTitleReaderOnly,
    description: ze.props.description,
    backgroundImage: ze.props.backgroundImage,
    breadcrumb: ze.props.breadcrumb,
    breadcrumbEllipsisLimit: ze.props.breadcrumbEllipsisLimit
  },
  setup() {
    return { EclPageHeaderType: mc };
  }
});
c2({
  name: "EclPageHeaderHarmonised",
  components: {
    EclPageHeader: ze
  },
  props: {
    metaInfo: ze.props.metaInfo,
    pageTitle: ze.props.pageTitle,
    pageTitleReaderOnly: ze.props.pageTitleReaderOnly,
    description: ze.props.description,
    backgroundImage: ze.props.backgroundImage,
    breadcrumb: ze.props.breadcrumb,
    breadcrumbEllipsisLimit: ze.props.breadcrumbEllipsisLimit
  },
  setup() {
    return { EclPageHeaderType: mc };
  }
});
c2({
  name: "EclFooterHarmonised",
  components: {
    EclLink: O4
  },
  props: {
    siteName: {
      type: Object,
      required: !0
    },
    contentOwnerDetail: {
      type: String,
      required: !0
    },
    showLogo: {
      type: Boolean,
      default: !0,
      required: !1
    },
    overrides: {
      type: Object,
      required: !1
    },
    siteContentColumns: {
      type: Array,
      required: !1
    }
  },
  setup(t) {
    const { overrides: e } = s3(t), n = "ecl-footer-harmonised", i = g1(() => i9()), s = g1(() => d4().theme === "ec"), l = g1(() => {
      var h, u;
      const d = (u = (h = H(e)) == null ? void 0 : h.linkList) == null ? void 0 : u.accessibility;
      if (!N1.isNil(d))
        return d;
    }), a = g1(() => ({
      title: H(s) ? "ECLV3.FOOTER.EC.IDENTITY" : "ECLV3.FOOTER.EU.IDENTITY",
      url: H(s) ? `https://ec.europa.eu/info/index_${H(i)}` : `https://european-union.europa.eu/index_${H(i)}`,
      logo: H(Jn).get(
        H(i),
        H(s) ? "negative" : "positive"
      ),
      accessibility: {
        label: H(s) ? "ECLV3.FOOTER.EC.LEGAL.ACCESSIBILITY" : "ECLV3.FOOTER.EU.LEGAL.ACCESSIBILITY",
        link: H(l)
      }
    })), o = g1(() => {
      var h, u;
      const d = (u = (h = H(e)) == null ? void 0 : h.linkList) == null ? void 0 : u.cookies;
      return N1.isNil(d) ? H(s) ? `https://ec.europa.eu/info/cookies_${H(i)}` : `https://european-union.europa.eu/cookies_${H(i)}` : d;
    });
    return {
      identity: a,
      cookieLink: o,
      accessibilityLink: l,
      baseClass: n,
      isEc: s,
      elementClassName: (h) => k6(n, null, h),
      currentLocale: i,
      EclIconSize: ye,
      EclLinkType: f0,
      EclLinkIconPosition: dn
    };
  }
});
c2({
  name: "EclFooterHarmonised",
  components: {
    EclLink: O4
  },
  props: {
    siteName: {
      type: Object,
      required: !0
    },
    contentOwnerDetail: {
      type: String,
      required: !0
    },
    showLogo: {
      type: Boolean,
      default: !0,
      required: !1
    },
    overrides: {
      type: Object,
      required: !1
    },
    siteContentColumns: {
      type: Array,
      required: !1
    }
  },
  setup(t) {
    const { overrides: e } = s3(t), n = "ecl-footer-harmonised", i = g1(() => i9()), s = g1(() => d4().theme === "ec"), l = g1(() => {
      var h, u;
      const d = (u = (h = H(e)) == null ? void 0 : h.linkList) == null ? void 0 : u.accessibility;
      if (!N1.isNil(d))
        return d;
    }), a = g1(() => ({
      title: H(s) ? "ECLV3.FOOTER.EC.IDENTITY" : "ECLV3.FOOTER.EU.IDENTITY",
      url: H(s) ? `https://ec.europa.eu/info/index_${H(i)}` : `https://european-union.europa.eu/index_${H(i)}`,
      logo: H(Jn).get(
        H(i),
        H(s) ? "negative" : "positive"
      ),
      accessibility: {
        label: H(s) ? "ECLV3.FOOTER.EC.LEGAL.ACCESSIBILITY" : "ECLV3.FOOTER.EU.LEGAL.ACCESSIBILITY",
        link: H(l)
      }
    })), o = g1(() => {
      var h, u;
      const d = (u = (h = H(e)) == null ? void 0 : h.linkList) == null ? void 0 : u.cookies;
      return N1.isNil(d) ? H(s) ? `https://ec.europa.eu/info/cookies_${H(i)}` : `https://european-union.europa.eu/cookies_${H(i)}` : d;
    });
    return {
      identity: a,
      cookieLink: o,
      accessibilityLink: l,
      baseClass: n,
      isEc: s,
      elementClassName: (h) => k6(n, null, h),
      currentLocale: i,
      EclIconSize: ye,
      EclLinkType: f0,
      EclLinkIconPosition: dn
    };
  }
});
c2({
  name: "EclFooterStandardised",
  components: {
    EclLink: O4
  },
  props: {
    siteName: {
      type: Object,
      required: !0
    },
    contentOwnerDetail: {
      type: String,
      required: !0
    },
    showLogo: {
      type: Boolean,
      default: !0,
      required: !1
    },
    overrides: {
      type: Object,
      required: !1
    },
    siteContentColumns: {
      type: Array,
      required: !1
    }
  },
  setup(t) {
    const { overrides: e } = s3(t), n = "ecl-footer-standardised", i = g1(() => i9()), s = g1(() => d4().theme === "ec"), l = g1(() => ({
      title: H(s) ? "ECLV3.FOOTER.EC.IDENTITY" : "ECLV3.FOOTER.EU.IDENTITY",
      url: H(s) ? `https://ec.europa.eu/info/index_${H(i)}` : `https://european-union.europa.eu/index_${H(i)}`,
      logo: H(Jn).get(
        H(i),
        H(s) ? "negative" : "positive"
      )
    })), a = g1(() => {
      var h, u;
      const d = (u = (h = H(e)) == null ? void 0 : h.linkList) == null ? void 0 : u.cookies;
      return N1.isNil(d) ? H(s) ? `https://ec.europa.eu/info/cookies_${H(i)}` : `https://european-union.europa.eu/cookies_${H(i)}` : d;
    }), o = g1(() => {
      var h, u;
      const d = (u = (h = H(e)) == null ? void 0 : h.linkList) == null ? void 0 : u.accessibility;
      if (!N1.isNil(d))
        return d;
    });
    return {
      identity: l,
      cookieLink: a,
      accessibilityLink: o,
      baseClass: n,
      isEc: s,
      elementClassName: (h) => k6(n, null, h),
      currentLocale: i,
      EclIconSize: ye,
      EclLinkType: f0,
      EclLinkIconPosition: dn
    };
  }
});
c2({
  name: "EclFooterStandardised",
  components: {
    EclLink: O4
  },
  props: {
    siteName: {
      type: Object,
      required: !0
    },
    contentOwnerDetail: {
      type: String,
      required: !0
    },
    showLogo: {
      type: Boolean,
      default: !0,
      required: !1
    },
    overrides: {
      type: Object,
      required: !1
    },
    siteContentColumns: {
      type: Array,
      required: !1
    }
  },
  setup(t) {
    const { overrides: e } = s3(t), n = "ecl-footer-standardised", i = g1(() => i9()), s = g1(() => d4().theme === "ec"), l = g1(() => ({
      title: H(s) ? "ECLV3.FOOTER.EC.IDENTITY" : "ECLV3.FOOTER.EU.IDENTITY",
      url: H(s) ? `https://ec.europa.eu/info/index_${H(i)}` : `https://european-union.europa.eu/index_${H(i)}`,
      logo: H(Jn).get(
        H(i),
        H(s) ? "negative" : "positive"
      )
    })), a = g1(() => {
      var h, u;
      const d = (u = (h = H(e)) == null ? void 0 : h.linkList) == null ? void 0 : u.cookies;
      return N1.isNil(d) ? H(s) ? `https://ec.europa.eu/info/cookies_${H(i)}` : `https://european-union.europa.eu/cookies_${H(i)}` : d;
    }), o = g1(() => {
      var h, u;
      const d = (u = (h = H(e)) == null ? void 0 : h.linkList) == null ? void 0 : u.accessibility;
      if (!N1.isNil(d))
        return d;
    });
    return {
      identity: l,
      cookieLink: a,
      accessibilityLink: o,
      baseClass: n,
      isEc: s,
      elementClassName: (h) => k6(n, null, h),
      currentLocale: i,
      EclIconSize: ye,
      EclLinkType: f0,
      EclLinkIconPosition: dn
    };
  }
});
function wx(t) {
  const e = D1(!1);
  return {
    searchIsVisible: e,
    toggleSearch: () => {
      e.value = !e.value;
    },
    performSearch: (n, i) => {
      t.emit("performSearch", n, i);
    }
  };
}
function zx(t, e) {
  const n = D1(), i = S8(), s = D1(!1), l = g1(() => i9()), a = g1(() => YF()), o = g1(() => mL()), h = g1(() => XF()), u = g1(() => !N1.isNil(H(a))), d = (_ = "eu") => {
    const q = _ === "extra" ? H(h) : H(o), M = (q == null ? void 0 : q.length) ?? 1;
    return M > 16 ? 3 : M > 8 ? 2 : 1;
  }, v = (_) => _.code === H(l), m = (_) => {
    const q = H(i.currentRoute);
    return Pw(_, q, {
      performRedirect: !1,
      router: i
    });
  }, p = (_, q) => {
    _.preventDefault(), _.stopPropagation();
    const M = H(i.currentRoute);
    Pw(q, M, { router: i }), e.emit("close");
  };
  return l3(
    n,
    (_) => {
      const q = _ == null ? void 0 : _.$el;
      q && new MutationObserver(() => {
        s.value = q.getAttribute("aria-expanded") === "true";
      }).observe(q, {
        attributes: !0,
        attributeFilter: ["aria-expanded"],
        attributeOldValue: !0,
        subtree: !1,
        childList: !1
      });
    },
    { immediate: !0 }
  ), {
    languageButton: n,
    currentLocale: l,
    languagePanelIsVisible: s,
    currentLanguage: a,
    countColumnLanguageList: d,
    languageIsActive: v,
    urlLocaleChange: m,
    performLocaleChange: p,
    canShowLanguage: u,
    euLanguages: o,
    extraEuLanguages: h
  };
}
const Ef1 = c2({
  name: "EclSiteHeaderCore",
  emits: ["performSearch"],
  components: {
    EclLink: O4,
    EclIcon: Ie,
    EclButton: Lt
  },
  props: {
    type: {
      type: String,
      required: !1,
      default: "core"
      /* Core */
    },
    showSearch: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showLanguage: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showAuth: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasHeader: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(t, e) {
    const { hasHeader: n } = s3(t), i = D1();
    let s;
    const l = wx(e), a = zx(t, e), o = g1(() => d4().theme === "ec"), h = g1(() => C8()), u = g1(() => H(h) ? H(o) ? H(Jn).get(H(a.currentLocale), "mute") : H(Jn).get(H(a.currentLocale), "positive", !0) : H(Jn).get(H(a.currentLocale), "positive")), d = g1(() => ({
      title: H(o) ? "ECLV3.HEADER.EC.IDENTITY" : "ECLV3.HEADER.EU.IDENTITY",
      url: H(o) ? `https://ec.europa.eu/info/index_${H(a.currentLocale)}` : `https://european-union.europa.eu/index_${H(
        a.currentLocale
      )}`,
      logo: H(u)
    })), v = (p) => k6("ecl-site-header", null, p), m = g1(() => {
      const p = [v()];
      return H(n) && p.push(v("--has-menu")), p.join(" ");
    });
    return d0(() => {
      s = ECL.SiteHeader.autoInit(H(i));
    }), mn(() => {
      s == null || s.destroy();
    }), {
      isEc: o,
      eclHeaderRoot: i,
      ...l,
      ...a,
      identity: d,
      isMobileTablet: h,
      className: v,
      headerClasses: m,
      EclIconSize: ye,
      EclButtonType: I4,
      EclLinkType: f0,
      EclLinkIconPosition: dn
    };
  }
}), Af1 = ["data-language-panel-visible"], Ff1 = ["title"], Tf1 = ["innerHTML"], If1 = ["innerHTML"], Of1 = ["innerHTML"], Nf1 = ["innerHTML"], Pf1 = ["innerHTML"], Bf1 = ["innerHTML"], Vf1 = ["innerHTML"];
function Rf1(t, e, n, i, s, l) {
  var a;
  const o = V2("ecl-link"), h = V2("ecl-icon"), u = V2("ecl-button");
  return T(), N("header", {
    ref: "eclHeaderRoot",
    "aria-label": "Site header",
    class: f2(t.headerClasses),
    "data-language-panel-visible": t.languagePanelIsVisible
  }, [
    C("div", {
      class: f2(t.className("__background"))
    }, [
      C("div", {
        class: f2(t.className("__header"))
      }, [
        C("div", {
          class: f2(`${t.className("__container")} ecl-container`)
        }, [
          C("div", {
            class: f2(t.className("__top")),
            "data-ecl-site-header-top": ""
          }, [
            _3(o, {
              class: f2(t.className("__logo-link")),
              type: t.EclLinkType.Standalone,
              url: t.identity.url,
              ariaLabel: t.identity.title
            }, {
              default: Q2(() => [
                C("picture", {
                  class: "ecl-picture ecl-site-header__picture",
                  title: t.$t(t.identity.title)
                }, [
                  (T(), v2(be(t.identity.logo), { class: "ecl-site-header__logo-image ecl-site-header__logo-image--desktop" }))
                ], 8, Ff1)
              ]),
              _: 1
            }, 8, ["class", "type", "url", "ariaLabel"]),
            C("div", {
              class: f2(t.className("__action"))
            }, [
              t.canShowLanguage ? (T(), N("div", {
                key: 0,
                class: f2(`${t.className("__language")}`)
              }, [
                _3(u, {
                  ref: "languageButton",
                  type: t.EclButtonType.Tertiary,
                  class: f2(`ecl-button ecl-button--tertiary ${t.className("__language-selector")}`),
                  "data-ecl-language-selector": "",
                  "aria-label": "Change language",
                  "aria-controls": "language-list-overlay"
                }, {
                  default: Q2(() => [
                    C("span", {
                      class: f2(t.className("__language-icon"))
                    }, [
                      _3(h, {
                        class: f2(t.className("__icon")),
                        icon: "global",
                        size: "s",
                        role: "img"
                      }, null, 8, ["class"])
                    ], 2),
                    t.isEc ? (T(), N(I3, { key: 0 }, [
                      K3(pt(t.currentLanguage.code), 1)
                    ], 64)) : (T(), N(I3, { key: 1 }, [
                      K3(pt(t.currentLanguage.name), 1)
                    ], 64))
                  ]),
                  _: 1
                }, 8, ["type", "class"]),
                C("div", {
                  class: f2(t.className("__language-container")),
                  id: "language-list-overlay",
                  "data-ecl-language-list-overlay": "",
                  "aria-labelledby": "ecl-site-header__language-title",
                  role: "dialog",
                  hidden: ""
                }, [
                  C("div", {
                    class: f2(t.className("__language-header"))
                  }, [
                    C("div", {
                      class: f2(t.className("__language-title")),
                      id: "ecl-site-header__language-title",
                      innerHTML: t.$t("ECLV3.LANGUAGES.SELECT_LANGUAGE_LABEL")
                    }, null, 10, Tf1),
                    _3(u, {
                      class: f2(t.className("__language-close")),
                      icon: t.isEc ? "close" : "close-filled",
                      iconSize: t.EclIconSize.M,
                      type: t.EclButtonType.Tertiary,
                      ariaLabel: t.$t("ECLV3.GENERAL.CLOSE"),
                      "data-ecl-language-list-close": ""
                    }, null, 8, ["class", "icon", "iconSize", "type", "ariaLabel"])
                  ], 2),
                  C("div", {
                    class: f2(t.className("__language-content"))
                  }, [
                    C("div", {
                      class: f2(`${t.className("__language-category")} ${t.className(`__language-category--${t.countColumnLanguageList()}-col`)}`),
                      "data-ecl-language-list-eu": ""
                    }, [
                      C("div", {
                        class: f2(t.className("__language-category-title")),
                        innerHTML: t.$t("ECLV3.LANGUAGES.EU_LABEL")
                      }, null, 10, If1),
                      C("ul", {
                        class: f2(t.className("__language-list"))
                      }, [
                        (T(!0), N(I3, null, Ve(t.euLanguages, (d, v) => (T(), N("li", {
                          key: v,
                          class: f2(t.className("__language-item"))
                        }, [
                          _3(o, {
                            class: f2({
                              [t.className("__language-link")]: !0,
                              [t.className("__language-link--active")]: t.languageIsActive(d)
                            }),
                            type: t.EclLinkType.Standalone,
                            url: t.urlLocaleChange(d),
                            ariaLabel: d.name,
                            lang: d.code,
                            hrefLang: d.code,
                            rel: "alternate",
                            icon: t.languageIsActive(d) ? "check" : null,
                            onClick: (m) => t.performLocaleChange(m, d)
                          }, {
                            default: Q2(() => [
                              C("span", {
                                class: f2(t.className("__language-link-code")),
                                innerHTML: d.code
                              }, null, 10, Of1),
                              C("span", {
                                class: f2(t.className("__language-link-label")),
                                innerHTML: d.name
                              }, null, 10, Nf1)
                            ]),
                            _: 2
                          }, 1032, ["class", "type", "url", "ariaLabel", "lang", "hrefLang", "icon", "onClick"])
                        ], 2))), 128))
                      ], 2)
                    ], 2),
                    ((a = t.extraEuLanguages) == null ? void 0 : a.length) > 0 ? (T(), N("div", {
                      key: 0,
                      class: f2(`${t.className("__language-category")} ${t.className(`__language-category--${t.countColumnLanguageList("extra")}-col`)}`),
                      "data-ecl-language-list-non-eu": ""
                    }, [
                      C("div", {
                        class: f2(t.className("__language-category-title")),
                        innerHTML: t.$t("ECLV3.LANGUAGES.NON_EU_LABEL")
                      }, null, 10, Pf1),
                      C("ul", {
                        class: f2(t.className("__language-list"))
                      }, [
                        (T(!0), N(I3, null, Ve(t.extraEuLanguages, (d, v) => (T(), N("li", {
                          key: v,
                          class: f2(t.className("__language-item"))
                        }, [
                          _3(o, {
                            class: f2({
                              [t.className("__language-link")]: !0,
                              [t.className("__language-link--active")]: t.languageIsActive(d)
                            }),
                            type: t.EclLinkType.Standalone,
                            url: t.urlLocaleChange(d),
                            ariaLabel: d.name,
                            lang: d.code,
                            hrefLang: d.code,
                            rel: "alternate",
                            icon: t.languageIsActive(d) ? "check" : null,
                            onClick: Et((m) => t.performLocaleChange(d), ["prevent"])
                          }, {
                            default: Q2(() => [
                              C("span", {
                                class: f2(t.className("__language-link-code")),
                                innerHTML: d.code
                              }, null, 10, Bf1),
                              C("span", {
                                class: f2(t.className("__language-link-label")),
                                innerHTML: d.name
                              }, null, 10, Vf1)
                            ]),
                            _: 2
                          }, 1032, ["class", "type", "url", "ariaLabel", "lang", "hrefLang", "icon", "onClick"])
                        ], 2))), 128))
                      ], 2)
                    ], 2)) : m2("", !0)
                  ], 2)
                ], 2)
              ], 2)) : m2("", !0)
            ], 2)
          ], 2)
        ], 2)
      ], 2)
    ], 2),
    J2(t.$slots, "default", {}, void 0, !0)
  ], 10, Af1);
}
const _s = /* @__PURE__ */ f4(Ef1, [["render", Rf1], ["__scopeId", "data-v-bd404066"]]);
var x_ = /* @__PURE__ */ ((t) => (t.Core = "core", t.Harmonised = "harmonised", t))(x_ || {});
c2({
  name: "EclSiteHeaderCore",
  emits: ["performSearch"],
  components: {
    EclLink: O4,
    EclIcon: Ie,
    EclButton: Lt
  },
  props: {
    type: {
      type: String,
      required: !1,
      default: "core"
      /* Core */
    },
    showSearch: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showLanguage: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showAuth: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasHeader: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(t, e) {
    const { hasHeader: n } = s3(t), i = D1();
    let s;
    const l = wx(e), a = zx(t, e), o = g1(() => d4().theme === "ec"), h = g1(() => C8()), u = g1(() => H(h) ? H(o) ? H(Jn).get(H(a.currentLocale), "mute") : H(Jn).get(H(a.currentLocale), "positive", !0) : H(Jn).get(H(a.currentLocale), "positive")), d = g1(() => ({
      title: H(o) ? "ECLV3.HEADER.EC.IDENTITY" : "ECLV3.HEADER.EU.IDENTITY",
      url: H(o) ? `https://ec.europa.eu/info/index_${H(a.currentLocale)}` : `https://european-union.europa.eu/index_${H(
        a.currentLocale
      )}`,
      logo: H(u)
    })), v = (p) => k6("ecl-site-header", null, p), m = g1(() => {
      const p = [v()];
      return H(n) && p.push(v("--has-menu")), p.join(" ");
    });
    return d0(() => {
      s = ECL.SiteHeader.autoInit(H(i));
    }), mn(() => {
      s == null || s.destroy();
    }), {
      isEc: o,
      eclHeaderRoot: i,
      ...l,
      ...a,
      identity: d,
      isMobileTablet: h,
      className: v,
      headerClasses: m,
      EclIconSize: ye,
      EclButtonType: I4,
      EclLinkType: f0,
      EclLinkIconPosition: dn
    };
  }
});
c2({
  name: "EclSiteHeaderHarmonised",
  emits: ["performSearch"],
  components: {
    EclSiteHeaderCore: _s,
    EclLink: O4,
    EclMenu: OL
  },
  props: {
    className: {
      type: Object,
      required: !1,
      default: null
    },
    menuItems: {
      type: Array,
      required: !0
    },
    siteName: {
      type: String,
      required: !0
    },
    showAuth: _s.props.showAuth,
    showSearch: _s.props.showSearch,
    showLanguage: _s.props.showLanguage
  },
  setup(t, { emit: e }) {
    const n = D1(), i = g1(() => d4().theme === "ec"), s = D1(!1);
    return {
      refHeaderCore: n,
      isEc: i,
      menuIsOpen: s,
      performSearch: (l, a) => {
        e("performSearch", l, a);
      },
      classNameLabel: t.className && t.className.label ? t.className.label : null,
      classNameUrl: t.className && t.className.url ? t.className.url : null,
      elementClassName: (l) => k6("ecl-site-header", null, l),
      EclSiteHeaderType: x_,
      EclLinkType: f0
    };
  }
});
c2({
  name: "EclSiteHeaderHarmonised",
  emits: ["performSearch"],
  components: {
    EclSiteHeaderCore: _s,
    EclLink: O4,
    EclMenu: OL
  },
  props: {
    className: {
      type: Object,
      required: !1,
      default: null
    },
    menuItems: {
      type: Array,
      required: !0
    },
    siteName: {
      type: String,
      required: !0
    },
    showAuth: _s.props.showAuth,
    showSearch: _s.props.showSearch,
    showLanguage: _s.props.showLanguage
  },
  setup(t, { emit: e }) {
    const n = D1(), i = g1(() => d4().theme === "ec"), s = D1(!1);
    return {
      refHeaderCore: n,
      isEc: i,
      menuIsOpen: s,
      performSearch: (l, a) => {
        e("performSearch", l, a);
      },
      classNameLabel: t.className && t.className.label ? t.className.label : null,
      classNameUrl: t.className && t.className.url ? t.className.url : null,
      elementClassName: (l) => k6("ecl-site-header", null, l),
      EclSiteHeaderType: x_,
      EclLinkType: f0
    };
  }
});
const Hf1 = c2({
  name: "EclContainer"
}), Df1 = { class: "ecl-container" };
function $f1(t, e, n, i, s, l) {
  return T(), N("div", Df1, [
    J2(t.$slots, "default")
  ]);
}
const Uf1 = /* @__PURE__ */ f4(Hf1, [["render", $f1]]), jf1 = c2({
  name: "EclRow"
}), Gf1 = { class: "ecl-row" };
function Wf1(t, e, n, i, s, l) {
  return T(), N("div", Gf1, [
    J2(t.$slots, "default")
  ]);
}
const Yf1 = /* @__PURE__ */ f4(jf1, [["render", Wf1]]), Xf1 = c2({
  inheritAttrs: !1,
  name: "EclCol",
  props: {
    class: {
      type: String,
      required: !1
    },
    col: {
      type: [Number, String],
      required: !1
    },
    s: {
      type: [Number, String],
      required: !1
    },
    m: {
      type: [Number, String],
      required: !1
    },
    l: {
      type: [Number, String],
      required: !1
    },
    xl: {
      type: [Number, String],
      required: !1
    },
    offset: {
      type: [Number, String],
      required: !1
    },
    offsetS: {
      type: [Number, String],
      required: !1
    },
    offsetM: {
      type: [Number, String],
      required: !1
    },
    offsetL: {
      type: [Number, String],
      required: !1
    },
    offsetXl: {
      type: [Number, String],
      required: !1
    }
  },
  setup(t) {
    return {
      classes: (() => {
        const e = [];
        return N1.each(["col", "s", "m", "l", "xl"], (n) => {
          const i = t[n];
          if (!N1.isNil(i)) {
            const s = n.toLowerCase().split("col"), l = (s == null ? void 0 : s.length) > 1 ? s[1] : `-${n}`;
            e.push(`ecl-col${l}-${i}`);
          }
        }), e.length === 0 && e.push("ecl-col-fluid"), N1.each(
          ["offset", "offsetS", "offsetM", "offsetL", "offsetXl"],
          (n) => {
            const i = t[n];
            if (!N1.isNil(i)) {
              const s = n.toLowerCase().split("offset"), l = (s == null ? void 0 : s.length) > 1 ? s[1] : `-${n}`;
              e.push(`ecl-offset-${l}-${i}`);
            }
          }
        ), `${e.join(" ")} ${t.class ?? ""}`.trim();
      })()
    };
  }
});
function Kf1(t, e, n, i, s, l) {
  return T(), N("div", Ht({ class: t.classes }, t.$attrs), [
    J2(t.$slots, "default", {}, void 0, !0)
  ], 16);
}
const Zf1 = /* @__PURE__ */ f4(Xf1, [["render", Kf1], ["__scopeId", "data-v-d9faa33b"]]), S_ = WF.version;
window.$eclPlugin = { version: S_ };
function Jf1(t, e = { theme: "ec" }) {
  const n = (e == null ? void 0 : e.theme) ?? "ec";
  N1.isNil(t.config.globalProperties.$t) && (t.config.globalProperties.$t = (s) => s), t.config.globalProperties.$ecl = {
    theme: n,
    version: S_
  };
  const i = document.querySelector("body");
  i && i.classList.add(`ecl-theme-${n}`), t.component("EclContainer", Uf1), t.component("EclRow", Yf1), t.component("EclColumn", Zf1), t.component("EclH", xL), t.component("EclP", zr);
}
const Qf1 = {
  version: S_,
  install: Jf1,
  options: {}
}, ev1 = ["top", "right", "bottom", "left"], Hw = ["start", "end"], Dw = /* @__PURE__ */ ev1.reduce((t, e) => t.concat(e, e + "-" + Hw[0], e + "-" + Hw[1]), []), As = Math.min, B0 = Math.max, Nh = Math.round, Dc = Math.floor, Fs = (t) => ({
  x: t,
  y: t
}), tv1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, nv1 = {
  start: "end",
  end: "start"
};
function dy(t, e, n) {
  return B0(t, As(e, n));
}
function Mr(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ri(t) {
  return t.split("-")[0];
}
function cn(t) {
  return t.split("-")[1];
}
function Mx(t) {
  return t === "x" ? "y" : "x";
}
function C_(t) {
  return t === "y" ? "height" : "width";
}
function gc(t) {
  return ["top", "bottom"].includes(ri(t)) ? "y" : "x";
}
function k_(t) {
  return Mx(gc(t));
}
function bx(t, e, n) {
  n === void 0 && (n = !1);
  const i = cn(t), s = k_(t), l = C_(s);
  let a = s === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[l] > e.floating[l] && (a = Bh(a)), [a, Bh(a)];
}
function iv1(t) {
  const e = Bh(t);
  return [Ph(t), e, Ph(e)];
}
function Ph(t) {
  return t.replace(/start|end/g, (e) => nv1[e]);
}
function sv1(t, e, n) {
  const i = ["left", "right"], s = ["right", "left"], l = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? s : i : e ? i : s;
    case "left":
    case "right":
      return e ? l : a;
    default:
      return [];
  }
}
function lv1(t, e, n, i) {
  const s = cn(t);
  let l = sv1(ri(t), n === "start", i);
  return s && (l = l.map((a) => a + "-" + s), e && (l = l.concat(l.map(Ph)))), l;
}
function Bh(t) {
  return t.replace(/left|right|bottom|top/g, (e) => tv1[e]);
}
function rv1(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Lx(t) {
  return typeof t != "number" ? rv1(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function rr(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function $w(t, e, n) {
  let {
    reference: i,
    floating: s
  } = t;
  const l = gc(e), a = k_(e), o = C_(a), h = ri(e), u = l === "y", d = i.x + i.width / 2 - s.width / 2, v = i.y + i.height / 2 - s.height / 2, m = i[o] / 2 - s[o] / 2;
  let p;
  switch (h) {
    case "top":
      p = {
        x: d,
        y: i.y - s.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: i.y + i.height
      };
      break;
    case "right":
      p = {
        x: i.x + i.width,
        y: v
      };
      break;
    case "left":
      p = {
        x: i.x - s.width,
        y: v
      };
      break;
    default:
      p = {
        x: i.x,
        y: i.y
      };
  }
  switch (cn(e)) {
    case "start":
      p[a] -= m * (n && u ? -1 : 1);
      break;
    case "end":
      p[a] += m * (n && u ? -1 : 1);
      break;
  }
  return p;
}
const xx = async (t, e, n) => {
  const {
    placement: i = "bottom",
    strategy: s = "absolute",
    middleware: l = [],
    platform: a
  } = n, o = l.filter(Boolean), h = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let u = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: s
  }), {
    x: d,
    y: v
  } = $w(u, i, h), m = i, p = {}, _ = 0;
  for (let q = 0; q < o.length; q++) {
    const {
      name: M,
      fn: z
    } = o[q], {
      x: b,
      y: x,
      data: k,
      reset: F
    } = await z({
      x: d,
      y: v,
      initialPlacement: i,
      placement: m,
      strategy: s,
      middlewareData: p,
      rects: u,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (d = b ?? d, v = x ?? v, p = {
      ...p,
      [M]: {
        ...p[M],
        ...k
      }
    }, F && _ <= 50) {
      _++, typeof F == "object" && (F.placement && (m = F.placement), F.rects && (u = F.rects === !0 ? await a.getElementRects({
        reference: t,
        floating: e,
        strategy: s
      }) : F.rects), {
        x: d,
        y: v
      } = $w(u, m, h)), q = -1;
      continue;
    }
  }
  return {
    x: d,
    y: v,
    placement: m,
    strategy: s,
    middlewareData: p
  };
};
async function Fu(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: i,
    y: s,
    platform: l,
    rects: a,
    elements: o,
    strategy: h
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: v = "floating",
    altBoundary: m = !1,
    padding: p = 0
  } = Mr(e, t), _ = Lx(p), M = o[m ? v === "floating" ? "reference" : "floating" : v], z = rr(await l.getClippingRect({
    element: (n = await (l.isElement == null ? void 0 : l.isElement(M))) == null || n ? M : M.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(o.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: h
  })), b = v === "floating" ? {
    ...a.floating,
    x: i,
    y: s
  } : a.reference, x = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(o.floating)), k = await (l.isElement == null ? void 0 : l.isElement(x)) ? await (l.getScale == null ? void 0 : l.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, F = rr(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: b,
    offsetParent: x,
    strategy: h
  }) : b);
  return {
    top: (z.top - F.top + _.top) / k.y,
    bottom: (F.bottom - z.bottom + _.bottom) / k.y,
    left: (z.left - F.left + _.left) / k.x,
    right: (F.right - z.right + _.right) / k.x
  };
}
const av1 = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: i,
      placement: s,
      rects: l,
      platform: a,
      elements: o,
      middlewareData: h
    } = e, {
      element: u,
      padding: d = 0
    } = Mr(t, e) || {};
    if (u == null)
      return {};
    const v = Lx(d), m = {
      x: n,
      y: i
    }, p = k_(s), _ = C_(p), q = await a.getDimensions(u), M = p === "y", z = M ? "top" : "left", b = M ? "bottom" : "right", x = M ? "clientHeight" : "clientWidth", k = l.reference[_] + l.reference[p] - m[p] - l.floating[_], F = m[p] - l.reference[p], D = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let R = D ? D[x] : 0;
    (!R || !await (a.isElement == null ? void 0 : a.isElement(D))) && (R = o.floating[x] || l.floating[_]);
    const V = k / 2 - F / 2, J = R / 2 - q[_] / 2 - 1, K = As(v[z], J), P = As(v[b], J), O = K, G = R - q[_] - P, j = R / 2 - q[_] / 2 + V, Q = dy(O, j, G), i1 = !h.arrow && cn(s) != null && j != Q && l.reference[_] / 2 - (j < O ? K : P) - q[_] / 2 < 0, h1 = i1 ? j < O ? j - O : j - G : 0;
    return {
      [p]: m[p] + h1,
      data: {
        [p]: Q,
        centerOffset: j - Q - h1,
        ...i1 && {
          alignmentOffset: h1
        }
      },
      reset: i1
    };
  }
});
function ov1(t, e, n) {
  return (t ? [...n.filter((s) => cn(s) === t), ...n.filter((s) => cn(s) !== t)] : n.filter((s) => ri(s) === s)).filter((s) => t ? cn(s) === t || (e ? Ph(s) !== s : !1) : !0);
}
const E_ = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(e) {
      var n, i, s;
      const {
        rects: l,
        middlewareData: a,
        placement: o,
        platform: h,
        elements: u
      } = e, {
        crossAxis: d = !1,
        alignment: v,
        allowedPlacements: m = Dw,
        autoAlignment: p = !0,
        ..._
      } = Mr(t, e), q = v !== void 0 || m === Dw ? ov1(v || null, p, m) : m, M = await Fu(e, _), z = ((n = a.autoPlacement) == null ? void 0 : n.index) || 0, b = q[z];
      if (b == null)
        return {};
      const x = bx(b, l, await (h.isRTL == null ? void 0 : h.isRTL(u.floating)));
      if (o !== b)
        return {
          reset: {
            placement: q[0]
          }
        };
      const k = [M[ri(b)], M[x[0]], M[x[1]]], F = [...((i = a.autoPlacement) == null ? void 0 : i.overflows) || [], {
        placement: b,
        overflows: k
      }], D = q[z + 1];
      if (D)
        return {
          data: {
            index: z + 1,
            overflows: F
          },
          reset: {
            placement: D
          }
        };
      const R = F.map((K) => {
        const P = cn(K.placement);
        return [K.placement, P && d ? (
          // Check along the mainAxis and main crossAxis side.
          K.overflows.slice(0, 2).reduce((O, G) => O + G, 0)
        ) : (
          // Check only the mainAxis.
          K.overflows[0]
        ), K.overflows];
      }).sort((K, P) => K[1] - P[1]), J = ((s = R.filter((K) => K[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        cn(K[0]) ? 2 : 3
      ).every((P) => P <= 0))[0]) == null ? void 0 : s[0]) || R[0][0];
      return J !== o ? {
        data: {
          index: z + 1,
          overflows: F
        },
        reset: {
          placement: J
        }
      } : {};
    }
  };
}, cv1 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, i;
      const {
        placement: s,
        middlewareData: l,
        rects: a,
        initialPlacement: o,
        platform: h,
        elements: u
      } = e, {
        mainAxis: d = !0,
        crossAxis: v = !0,
        fallbackPlacements: m,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: _ = "none",
        flipAlignment: q = !0,
        ...M
      } = Mr(t, e);
      if ((n = l.arrow) != null && n.alignmentOffset)
        return {};
      const z = ri(s), b = ri(o) === o, x = await (h.isRTL == null ? void 0 : h.isRTL(u.floating)), k = m || (b || !q ? [Bh(o)] : iv1(o));
      !m && _ !== "none" && k.push(...lv1(o, q, _, x));
      const F = [o, ...k], D = await Fu(e, M), R = [];
      let V = ((i = l.flip) == null ? void 0 : i.overflows) || [];
      if (d && R.push(D[z]), v) {
        const O = bx(s, a, x);
        R.push(D[O[0]], D[O[1]]);
      }
      if (V = [...V, {
        placement: s,
        overflows: R
      }], !R.every((O) => O <= 0)) {
        var J, K;
        const O = (((J = l.flip) == null ? void 0 : J.index) || 0) + 1, G = F[O];
        if (G)
          return {
            data: {
              index: O,
              overflows: V
            },
            reset: {
              placement: G
            }
          };
        let j = (K = V.filter((Q) => Q.overflows[0] <= 0).sort((Q, i1) => Q.overflows[1] - i1.overflows[1])[0]) == null ? void 0 : K.placement;
        if (!j)
          switch (p) {
            case "bestFit": {
              var P;
              const Q = (P = V.map((i1) => [i1.placement, i1.overflows.filter((h1) => h1 > 0).reduce((h1, c1) => h1 + c1, 0)]).sort((i1, h1) => i1[1] - h1[1])[0]) == null ? void 0 : P[0];
              Q && (j = Q);
              break;
            }
            case "initialPlacement":
              j = o;
              break;
          }
        if (s !== j)
          return {
            reset: {
              placement: j
            }
          };
      }
      return {};
    }
  };
};
async function hv1(t, e) {
  const {
    placement: n,
    platform: i,
    elements: s
  } = t, l = await (i.isRTL == null ? void 0 : i.isRTL(s.floating)), a = ri(n), o = cn(n), h = gc(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, d = l && h ? -1 : 1, v = Mr(e, t);
  let {
    mainAxis: m,
    crossAxis: p,
    alignmentAxis: _
  } = typeof v == "number" ? {
    mainAxis: v,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...v
  };
  return o && typeof _ == "number" && (p = o === "end" ? _ * -1 : _), h ? {
    x: p * d,
    y: m * u
  } : {
    x: m * u,
    y: p * d
  };
}
const uv1 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: i
      } = e, s = await hv1(e, t);
      return {
        x: n + s.x,
        y: i + s.y,
        data: s
      };
    }
  };
}, A_ = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: i,
        placement: s
      } = e, {
        mainAxis: l = !0,
        crossAxis: a = !1,
        limiter: o = {
          fn: (M) => {
            let {
              x: z,
              y: b
            } = M;
            return {
              x: z,
              y: b
            };
          }
        },
        ...h
      } = Mr(t, e), u = {
        x: n,
        y: i
      }, d = await Fu(e, h), v = gc(ri(s)), m = Mx(v);
      let p = u[m], _ = u[v];
      if (l) {
        const M = m === "y" ? "top" : "left", z = m === "y" ? "bottom" : "right", b = p + d[M], x = p - d[z];
        p = dy(b, p, x);
      }
      if (a) {
        const M = v === "y" ? "top" : "left", z = v === "y" ? "bottom" : "right", b = _ + d[M], x = _ - d[z];
        _ = dy(b, _, x);
      }
      const q = o.fn({
        ...e,
        [m]: p,
        [v]: _
      });
      return {
        ...q,
        data: {
          x: q.x - n,
          y: q.y - i
        }
      };
    }
  };
}, dv1 = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: i,
        platform: s,
        elements: l
      } = e, {
        apply: a = () => {
        },
        ...o
      } = Mr(t, e), h = await Fu(e, o), u = ri(n), d = cn(n), v = gc(n) === "y", {
        width: m,
        height: p
      } = i.floating;
      let _, q;
      u === "top" || u === "bottom" ? (_ = u, q = d === (await (s.isRTL == null ? void 0 : s.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (q = u, _ = d === "end" ? "top" : "bottom");
      const M = p - h[_], z = m - h[q], b = !e.middlewareData.shift;
      let x = M, k = z;
      if (v) {
        const D = m - h.left - h.right;
        k = d || b ? As(z, D) : D;
      } else {
        const D = p - h.top - h.bottom;
        x = d || b ? As(M, D) : D;
      }
      if (b && !d) {
        const D = B0(h.left, 0), R = B0(h.right, 0), V = B0(h.top, 0), J = B0(h.bottom, 0);
        v ? k = m - 2 * (D !== 0 || R !== 0 ? D + R : B0(h.left, h.right)) : x = p - 2 * (V !== 0 || J !== 0 ? V + J : B0(h.top, h.bottom));
      }
      await a({
        ...e,
        availableWidth: k,
        availableHeight: x
      });
      const F = await s.getDimensions(l.floating);
      return m !== F.width || p !== F.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function q6(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Qn(t) {
  return q6(t).getComputedStyle(t);
}
const Uw = Math.min, wo = Math.max, Vh = Math.round;
function Sx(t) {
  const e = Qn(t);
  let n = parseFloat(e.width), i = parseFloat(e.height);
  const s = t.offsetWidth, l = t.offsetHeight, a = Vh(n) !== s || Vh(i) !== l;
  return a && (n = s, i = l), { width: n, height: i, fallback: a };
}
function Ts(t) {
  return kx(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $c;
function Cx() {
  if ($c)
    return $c;
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? ($c = t.brands.map((e) => e.brand + "/" + e.version).join(" "), $c) : navigator.userAgent;
}
function ei(t) {
  return t instanceof q6(t).HTMLElement;
}
function xs(t) {
  return t instanceof q6(t).Element;
}
function kx(t) {
  return t instanceof q6(t).Node;
}
function jw(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof q6(t).ShadowRoot || t instanceof ShadowRoot;
}
function Tu(t) {
  const { overflow: e, overflowX: n, overflowY: i, display: s } = Qn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && !["inline", "contents"].includes(s);
}
function fv1(t) {
  return ["table", "td", "th"].includes(Ts(t));
}
function fy(t) {
  const e = /firefox/i.test(Cx()), n = Qn(t), i = n.backdropFilter || n.WebkitBackdropFilter;
  return n.transform !== "none" || n.perspective !== "none" || !!i && i !== "none" || e && n.willChange === "filter" || e && !!n.filter && n.filter !== "none" || ["transform", "perspective"].some((s) => n.willChange.includes(s)) || ["paint", "layout", "strict", "content"].some((s) => {
    const l = n.contain;
    return l != null && l.includes(s);
  });
}
function Ex() {
  return !/^((?!chrome|android).)*safari/i.test(Cx());
}
function F_(t) {
  return ["html", "body", "#document"].includes(Ts(t));
}
function Ax(t) {
  return xs(t) ? t : t.contextElement;
}
const Fx = { x: 1, y: 1 };
function ba(t) {
  const e = Ax(t);
  if (!ei(e))
    return Fx;
  const n = e.getBoundingClientRect(), { width: i, height: s, fallback: l } = Sx(e);
  let a = (l ? Vh(n.width) : n.width) / i, o = (l ? Vh(n.height) : n.height) / s;
  return a && Number.isFinite(a) || (a = 1), o && Number.isFinite(o) || (o = 1), { x: a, y: o };
}
function Oo(t, e, n, i) {
  var s, l;
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const a = t.getBoundingClientRect(), o = Ax(t);
  let h = Fx;
  e && (i ? xs(i) && (h = ba(i)) : h = ba(t));
  const u = o ? q6(o) : window, d = !Ex() && n;
  let v = (a.left + (d && ((s = u.visualViewport) == null ? void 0 : s.offsetLeft) || 0)) / h.x, m = (a.top + (d && ((l = u.visualViewport) == null ? void 0 : l.offsetTop) || 0)) / h.y, p = a.width / h.x, _ = a.height / h.y;
  if (o) {
    const q = q6(o), M = i && xs(i) ? q6(i) : i;
    let z = q.frameElement;
    for (; z && i && M !== q; ) {
      const b = ba(z), x = z.getBoundingClientRect(), k = getComputedStyle(z);
      x.x += (z.clientLeft + parseFloat(k.paddingLeft)) * b.x, x.y += (z.clientTop + parseFloat(k.paddingTop)) * b.y, v *= b.x, m *= b.y, p *= b.x, _ *= b.y, v += x.x, m += x.y, z = q6(z).frameElement;
    }
  }
  return { width: p, height: _, top: m, right: v + p, bottom: m + _, left: v, x: v, y: m };
}
function Ss(t) {
  return ((kx(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function Iu(t) {
  return xs(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function Tx(t) {
  return Oo(Ss(t)).left + Iu(t).scrollLeft;
}
function No(t) {
  if (Ts(t) === "html")
    return t;
  const e = t.assignedSlot || t.parentNode || jw(t) && t.host || Ss(t);
  return jw(e) ? e.host : e;
}
function Ix(t) {
  const e = No(t);
  return F_(e) ? e.ownerDocument.body : ei(e) && Tu(e) ? e : Ix(e);
}
function Rh(t, e) {
  var n;
  e === void 0 && (e = []);
  const i = Ix(t), s = i === ((n = t.ownerDocument) == null ? void 0 : n.body), l = q6(i);
  return s ? e.concat(l, l.visualViewport || [], Tu(i) ? i : []) : e.concat(i, Rh(i));
}
function Gw(t, e, n) {
  return e === "viewport" ? rr(function(i, s) {
    const l = q6(i), a = Ss(i), o = l.visualViewport;
    let h = a.clientWidth, u = a.clientHeight, d = 0, v = 0;
    if (o) {
      h = o.width, u = o.height;
      const m = Ex();
      (m || !m && s === "fixed") && (d = o.offsetLeft, v = o.offsetTop);
    }
    return { width: h, height: u, x: d, y: v };
  }(t, n)) : xs(e) ? rr(function(i, s) {
    const l = Oo(i, !0, s === "fixed"), a = l.top + i.clientTop, o = l.left + i.clientLeft, h = ei(i) ? ba(i) : { x: 1, y: 1 };
    return { width: i.clientWidth * h.x, height: i.clientHeight * h.y, x: o * h.x, y: a * h.y };
  }(e, n)) : rr(function(i) {
    const s = Ss(i), l = Iu(i), a = i.ownerDocument.body, o = wo(s.scrollWidth, s.clientWidth, a.scrollWidth, a.clientWidth), h = wo(s.scrollHeight, s.clientHeight, a.scrollHeight, a.clientHeight);
    let u = -l.scrollLeft + Tx(i);
    const d = -l.scrollTop;
    return Qn(a).direction === "rtl" && (u += wo(s.clientWidth, a.clientWidth) - o), { width: o, height: h, x: u, y: d };
  }(Ss(t)));
}
function Ww(t) {
  return ei(t) && Qn(t).position !== "fixed" ? t.offsetParent : null;
}
function Yw(t) {
  const e = q6(t);
  let n = Ww(t);
  for (; n && fv1(n) && Qn(n).position === "static"; )
    n = Ww(n);
  return n && (Ts(n) === "html" || Ts(n) === "body" && Qn(n).position === "static" && !fy(n)) ? e : n || function(i) {
    let s = No(i);
    for (; ei(s) && !F_(s); ) {
      if (fy(s))
        return s;
      s = No(s);
    }
    return null;
  }(t) || e;
}
function vv1(t, e, n) {
  const i = ei(e), s = Ss(e), l = Oo(t, !0, n === "fixed", e);
  let a = { scrollLeft: 0, scrollTop: 0 };
  const o = { x: 0, y: 0 };
  if (i || !i && n !== "fixed")
    if ((Ts(e) !== "body" || Tu(s)) && (a = Iu(e)), ei(e)) {
      const h = Oo(e, !0);
      o.x = h.x + e.clientLeft, o.y = h.y + e.clientTop;
    } else
      s && (o.x = Tx(s));
  return { x: l.left + a.scrollLeft - o.x, y: l.top + a.scrollTop - o.y, width: l.width, height: l.height };
}
const pv1 = { getClippingRect: function(t) {
  let { element: e, boundary: n, rootBoundary: i, strategy: s } = t;
  const l = n === "clippingAncestors" ? function(u, d) {
    const v = d.get(u);
    if (v)
      return v;
    let m = Rh(u).filter((M) => xs(M) && Ts(M) !== "body"), p = null;
    const _ = Qn(u).position === "fixed";
    let q = _ ? No(u) : u;
    for (; xs(q) && !F_(q); ) {
      const M = Qn(q), z = fy(q);
      (_ ? z || p : z || M.position !== "static" || !p || !["absolute", "fixed"].includes(p.position)) ? p = M : m = m.filter((b) => b !== q), q = No(q);
    }
    return d.set(u, m), m;
  }(e, this._c) : [].concat(n), a = [...l, i], o = a[0], h = a.reduce((u, d) => {
    const v = Gw(e, d, s);
    return u.top = wo(v.top, u.top), u.right = Uw(v.right, u.right), u.bottom = Uw(v.bottom, u.bottom), u.left = wo(v.left, u.left), u;
  }, Gw(e, o, s));
  return { width: h.right - h.left, height: h.bottom - h.top, x: h.left, y: h.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: n, strategy: i } = t;
  const s = ei(n), l = Ss(n);
  if (n === l)
    return e;
  let a = { scrollLeft: 0, scrollTop: 0 }, o = { x: 1, y: 1 };
  const h = { x: 0, y: 0 };
  if ((s || !s && i !== "fixed") && ((Ts(n) !== "body" || Tu(l)) && (a = Iu(n)), ei(n))) {
    const u = Oo(n);
    o = ba(n), h.x = u.x + n.clientLeft, h.y = u.y + n.clientTop;
  }
  return { width: e.width * o.x, height: e.height * o.y, x: e.x * o.x - a.scrollLeft * o.x + h.x, y: e.y * o.y - a.scrollTop * o.y + h.y };
}, isElement: xs, getDimensions: function(t) {
  return ei(t) ? Sx(t) : t.getBoundingClientRect();
}, getOffsetParent: Yw, getDocumentElement: Ss, getScale: ba, async getElementRects(t) {
  let { reference: e, floating: n, strategy: i } = t;
  const s = this.getOffsetParent || Yw, l = this.getDimensions;
  return { reference: vv1(e, await s(n), i), floating: { x: 0, y: 0, ...await l(n) } };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => Qn(t).direction === "rtl" }, mv1 = (t, e, n) => {
  const i = /* @__PURE__ */ new Map(), s = { platform: pv1, ...n }, l = { ...s.platform, _c: i };
  return xx(t, e, { ...s, platform: l });
};
function Ox(t, e) {
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (typeof e[n] == "object" && t[n] ? Ox(t[n], e[n]) : t[n] = e[n]);
}
const p8 = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 5e3,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (t) => [...t, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function Po(t, e) {
  let n = p8.themes[t] || {}, i;
  do
    i = n[e], typeof i > "u" ? n.$extend ? n = p8.themes[n.$extend] || {} : (n = null, i = p8[e]) : n = null;
  while (n);
  return i;
}
function gv1(t) {
  const e = [t];
  let n = p8.themes[t] || {};
  do
    n.$extend && !n.$resetCss ? (e.push(n.$extend), n = p8.themes[n.$extend] || {}) : n = null;
  while (n);
  return e.map((i) => `v-popper--theme-${i}`);
}
function Xw(t) {
  const e = [t];
  let n = p8.themes[t] || {};
  do
    n.$extend ? (e.push(n.$extend), n = p8.themes[n.$extend] || {}) : n = null;
  while (n);
  return e;
}
let vr = !1;
if (typeof window < "u") {
  vr = !1;
  try {
    const t = Object.defineProperty({}, "passive", {
      get() {
        vr = !0;
      }
    });
    window.addEventListener("test", null, t);
  } catch {
  }
}
let Nx = !1;
typeof window < "u" && typeof navigator < "u" && (Nx = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Px = ["auto", "top", "bottom", "left", "right"].reduce((t, e) => t.concat([
  e,
  `${e}-start`,
  `${e}-end`
]), []), Kw = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, Zw = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function Jw(t, e) {
  const n = t.indexOf(e);
  n !== -1 && t.splice(n, 1);
}
function Mg() {
  return new Promise((t) => requestAnimationFrame(() => {
    requestAnimationFrame(t);
  }));
}
const tn = [];
let jl = null;
const Qw = {};
function ez(t) {
  let e = Qw[t];
  return e || (e = Qw[t] = []), e;
}
let vy = function() {
};
typeof window < "u" && (vy = window.Element);
function he(t) {
  return function(e) {
    return Po(e.theme, t);
  };
}
const bg = "__floating-vue__popper", Bx = () => c2({
  name: "VPopper",
  provide() {
    return {
      [bg]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [bg]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: he("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: he("positioningDisabled")
    },
    placement: {
      type: String,
      default: he("placement"),
      validator: (t) => Px.includes(t)
    },
    delay: {
      type: [String, Number, Object],
      default: he("delay")
    },
    distance: {
      type: [Number, String],
      default: he("distance")
    },
    skidding: {
      type: [Number, String],
      default: he("skidding")
    },
    triggers: {
      type: Array,
      default: he("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: he("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: he("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: he("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: he("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: he("popperHideTriggers")
    },
    container: {
      type: [String, Object, vy, Boolean],
      default: he("container")
    },
    boundary: {
      type: [String, vy],
      default: he("boundary")
    },
    strategy: {
      type: String,
      validator: (t) => ["absolute", "fixed"].includes(t),
      default: he("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: he("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: he("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: he("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: he("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: he("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: he("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: he("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: he("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: he("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: he("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: he("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: he("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: he("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: he("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: he("flip")
    },
    shift: {
      type: Boolean,
      default: he("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: he("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: he("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: he("disposeTimeout")
    }
  },
  emits: [
    "show",
    "hide",
    "update:shown",
    "apply-show",
    "apply-hide",
    "close-group",
    "close-directive",
    "auto-hide",
    "resize",
    "dispose"
  ],
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var t;
      return (t = this[bg]) == null ? void 0 : t.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var t, e;
      return ((t = this.popperTriggers) == null ? void 0 : t.includes("hover")) || ((e = this.popperShowTriggers) == null ? void 0 : e.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(t) {
      t ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    ...[
      "triggers",
      "positioningDisabled"
    ].reduce((t, e) => (t[e] = "$_refreshListeners", t), {}),
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((t, e) => (t[e] = "$_computePosition", t), {})
  },
  created() {
    this.$_isDisposed = !0, this.randomId = `popper_${[Math.random(), Date.now()].map((t) => t.toString(36).substring(2, 10)).join("_")}`, this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: t = null, skipDelay: e = !1, force: n = !1 } = {}) {
      var i, s;
      (i = this.parentPopper) != null && i.lockedChild && this.parentPopper.lockedChild !== this || (this.$_pendingHide = !1, (n || !this.disabled) && (((s = this.parentPopper) == null ? void 0 : s.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(t, e), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: t = null, skipDelay: e = !1 } = {}) {
      var n;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.$_pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: e }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((n = this.parentPopper) == null ? void 0 : n.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_pendingHide = !1, this.$_scheduleHide(t, e), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var t;
      this.$_isDisposed && (this.$_isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((t = this.referenceNode) == null ? void 0 : t.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((e) => e.nodeType === e.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.$_isDisposed || (this.$_isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"), this.$emit("dispose"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.$_isDisposed || this.positioningDisabled)
        return;
      const t = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && t.middleware.push(uv1({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const e = this.placement.startsWith("auto");
      if (e ? t.middleware.push(E_({
        alignment: this.placement.split("-")[1] ?? ""
      })) : t.placement = this.placement, this.preventOverflow && (this.shift && t.middleware.push(A_({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !e && this.flip && t.middleware.push(cv1({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), t.middleware.push(av1({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && t.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: i, rects: s, middlewareData: l }) => {
          let a;
          const { centerOffset: o } = l.arrow;
          return i.startsWith("top") || i.startsWith("bottom") ? a = Math.abs(o) > s.reference.width / 2 : a = Math.abs(o) > s.reference.height / 2, {
            data: {
              overflow: a
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const i = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        t.middleware.push({
          name: "autoSize",
          fn: ({ rects: s, placement: l, middlewareData: a }) => {
            var o;
            if ((o = a.autoSize) != null && o.skip)
              return {};
            let h, u;
            return l.startsWith("top") || l.startsWith("bottom") ? h = s.reference.width : u = s.reference.height, this.$_innerNode.style[i === "min" ? "minWidth" : i === "max" ? "maxWidth" : "width"] = h != null ? `${h}px` : null, this.$_innerNode.style[i === "min" ? "minHeight" : i === "max" ? "maxHeight" : "height"] = u != null ? `${u}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, t.middleware.push(dv1({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: i, availableHeight: s }) => {
          this.$_innerNode.style.maxWidth = i != null ? `${i}px` : null, this.$_innerNode.style.maxHeight = s != null ? `${s}px` : null;
        }
      })));
      const n = await mv1(this.$_referenceNode, this.$_popperNode, t);
      Object.assign(this.result, {
        x: n.x,
        y: n.y,
        placement: n.placement,
        strategy: n.strategy,
        arrow: {
          ...n.middlewareData.arrow,
          ...n.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(t = null, e = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), jl && this.instantMove && jl.instantMove && jl !== this.parentPopper) {
        jl.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      e ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(t = null, e = !1) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (jl = this), e ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(t) {
      const e = this.delay;
      return parseInt(e && e[t] || e || 0);
    },
    async $_applyShow(t = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = t, !this.isShown && (this.$_ensureTeleport(), await Mg(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...Rh(this.$_referenceNode),
        ...Rh(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const e = this.$_referenceNode.getBoundingClientRect(), n = this.$_popperNode.querySelector(".v-popper__wrapper"), i = n.parentNode.getBoundingClientRect(), s = e.x + e.width / 2 - (i.left + n.offsetLeft), l = e.y + e.height / 2 - (i.top + n.offsetTop);
        this.result.transformOrigin = `${s}px ${l}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const t = this.showGroup;
      if (t) {
        let e;
        for (let n = 0; n < tn.length; n++)
          e = tn[n], e.showGroup !== t && (e.hide(), e.$emit("close-group"));
      }
      tn.push(this), document.body.classList.add("v-popper--some-open");
      for (const e of Xw(this.theme))
        ez(e).push(this), document.body.classList.add(`v-popper--some-open--${e}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await Mg(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(t = !1) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = t, Jw(tn, this), tn.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const n of Xw(this.theme)) {
        const i = ez(n);
        Jw(i, this), i.length === 0 && document.body.classList.remove(`v-popper--some-open--${n}`);
      }
      jl === this && (jl = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const e = this.disposeTimeout;
      e !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, e)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await Mg(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.$_isDisposed)
        return;
      let t = this.container;
      if (typeof t == "string" ? t = window.document.querySelector(t) : t === !1 && (t = this.$_targetNodes[0].parentNode), !t)
        throw new Error("No container for popover: " + this.container);
      t.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const t = (n) => {
        this.isShown && !this.$_hideInProgress || (n.usedByTooltip = !0, !this.$_preventShow && this.show({ event: n }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Kw, this.triggers, this.showTriggers, t), this.$_registerTriggerListeners([this.$_popperNode], Kw, this.popperTriggers, this.popperShowTriggers, t);
      const e = (n) => {
        n.usedByTooltip || this.hide({ event: n });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Zw, this.triggers, this.hideTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], Zw, this.popperTriggers, this.popperHideTriggers, e);
    },
    $_registerEventListeners(t, e, n) {
      this.$_events.push({ targetNodes: t, eventType: e, handler: n }), t.forEach((i) => i.addEventListener(e, n, vr ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(t, e, n, i, s) {
      let l = n;
      i != null && (l = typeof i == "function" ? i(l) : i), l.forEach((a) => {
        const o = e[a];
        o && this.$_registerEventListeners(t, o, s);
      });
    },
    $_removeEventListeners(t) {
      const e = [];
      this.$_events.forEach((n) => {
        const { targetNodes: i, eventType: s, handler: l } = n;
        !t || t === s ? i.forEach((a) => a.removeEventListener(s, l)) : e.push(n);
      }), this.$_events = e;
    },
    $_refreshListeners() {
      this.$_isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(t, e = !1) {
      this.$_showFrameLocked || (this.hide({ event: t }), t.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), e && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(t, e) {
      for (const n of this.$_targetNodes) {
        const i = n.getAttribute(t);
        i && (n.removeAttribute(t), n.setAttribute(e, i));
      }
    },
    $_applyAttrsToTarget(t) {
      for (const e of this.$_targetNodes)
        for (const n in t) {
          const i = t[n];
          i == null ? e.removeAttribute(n) : e.setAttribute(n, i);
        }
    },
    $_updateParentShownChildren(t) {
      let e = this.parentPopper;
      for (; e; )
        t ? e.shownChildren.add(this.randomId) : (e.shownChildren.delete(this.randomId), e.$_pendingHide && e.hide()), e = e.parentPopper;
    },
    $_isAimingPopper() {
      const t = this.$_referenceNode.getBoundingClientRect();
      if (zo >= t.left && zo <= t.right && Mo >= t.top && Mo <= t.bottom) {
        const e = this.$_popperNode.getBoundingClientRect(), n = zo - fs, i = Mo - vs, s = e.left + e.width / 2 - fs + (e.top + e.height / 2) - vs + e.width + e.height, l = fs + n * s, a = vs + i * s;
        return Uc(fs, vs, l, a, e.left, e.top, e.left, e.bottom) || // Left edge
        Uc(fs, vs, l, a, e.left, e.top, e.right, e.top) || // Top edge
        Uc(fs, vs, l, a, e.right, e.top, e.right, e.bottom) || // Right edge
        Uc(fs, vs, l, a, e.left, e.bottom, e.right, e.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
typeof document < "u" && typeof window < "u" && (Nx ? (document.addEventListener("touchstart", tz, vr ? {
  passive: !0,
  capture: !0
} : !0), document.addEventListener("touchend", _v1, vr ? {
  passive: !0,
  capture: !0
} : !0)) : (window.addEventListener("mousedown", tz, !0), window.addEventListener("click", yv1, !0)), window.addEventListener("resize", zv1));
function tz(t) {
  for (let e = 0; e < tn.length; e++) {
    const n = tn[e];
    try {
      const i = n.popperNode();
      n.$_mouseDownContains = i.contains(t.target);
    } catch {
    }
  }
}
function yv1(t) {
  Vx(t);
}
function _v1(t) {
  Vx(t, !0);
}
function Vx(t, e = !1) {
  const n = {};
  for (let i = tn.length - 1; i >= 0; i--) {
    const s = tn[i];
    try {
      const l = s.$_containsGlobalTarget = qv1(s, t);
      s.$_pendingHide = !1, requestAnimationFrame(() => {
        if (s.$_pendingHide = !1, !n[s.randomId] && nz(s, l, t)) {
          if (s.$_handleGlobalClose(t, e), !t.closeAllPopover && t.closePopover && l) {
            let o = s.parentPopper;
            for (; o; )
              n[o.randomId] = !0, o = o.parentPopper;
            return;
          }
          let a = s.parentPopper;
          for (; a && nz(a, a.$_containsGlobalTarget, t); )
            a.$_handleGlobalClose(t, e), a = a.parentPopper;
        }
      });
    } catch {
    }
  }
}
function qv1(t, e) {
  const n = t.popperNode();
  return t.$_mouseDownContains || n.contains(e.target);
}
function nz(t, e, n) {
  return n.closeAllPopover || n.closePopover && e || wv1(t, n) && !e;
}
function wv1(t, e) {
  if (typeof t.autoHide == "function") {
    const n = t.autoHide(e);
    return t.lastAutoHide = n, n;
  }
  return t.autoHide;
}
function zv1(t) {
  for (let e = 0; e < tn.length; e++)
    tn[e].$_computePosition(t);
}
let fs = 0, vs = 0, zo = 0, Mo = 0;
typeof window < "u" && window.addEventListener("mousemove", (t) => {
  fs = zo, vs = Mo, zo = t.clientX, Mo = t.clientY;
}, vr ? {
  passive: !0
} : void 0);
function Uc(t, e, n, i, s, l, a, o) {
  const h = ((a - s) * (e - l) - (o - l) * (t - s)) / ((o - l) * (n - t) - (a - s) * (i - e)), u = ((n - t) * (e - l) - (i - e) * (t - s)) / ((o - l) * (n - t) - (a - s) * (i - e));
  return h >= 0 && h <= 1 && u >= 0 && u <= 1;
}
const Mv1 = {
  extends: Bx()
}, Ou = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [i, s] of e)
    n[i] = s;
  return n;
};
function bv1(t, e, n, i, s, l) {
  return T(), N("div", {
    ref: "reference",
    class: f2(["v-popper", {
      "v-popper--shown": t.slotData.isShown
    }])
  }, [
    J2(t.$slots, "default", on(v8(t.slotData)))
  ], 2);
}
const Lv1 = /* @__PURE__ */ Ou(Mv1, [["render", bv1]]);
function xv1() {
  var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
  if (e > 0)
    return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
  var n = t.indexOf("Trident/");
  if (n > 0) {
    var i = t.indexOf("rv:");
    return parseInt(t.substring(i + 3, t.indexOf(".", i)), 10);
  }
  var s = t.indexOf("Edge/");
  return s > 0 ? parseInt(t.substring(s + 5, t.indexOf(".", s)), 10) : -1;
}
let mh;
function py() {
  py.init || (py.init = !0, mh = xv1() !== -1);
}
var Nu = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    py(), D0(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const t = document.createElement("object");
    this._resizeObject = t, t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", -1), t.onload = this.addResizeHandlers, t.type = "text/html", mh && this.$el.appendChild(t), t.data = "about:blank", mh || this.$el.appendChild(t);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!mh && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const Sv1 = /* @__PURE__ */ GA("data-v-b329ee4c");
$s("data-v-b329ee4c");
const Cv1 = {
  class: "resize-observer",
  tabindex: "-1"
};
Us();
const kv1 = /* @__PURE__ */ Sv1((t, e, n, i, s, l) => (T(), v2("div", Cv1)));
Nu.render = kv1;
Nu.__scopeId = "data-v-b329ee4c";
Nu.__file = "src/components/ResizeObserver.vue";
const Rx = (t = "theme") => ({
  computed: {
    themeClass() {
      return gv1(this[t]);
    }
  }
}), Ev1 = c2({
  name: "VPopperContent",
  components: {
    ResizeObserver: Nu
  },
  mixins: [
    Rx()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(t) {
      return t != null && !isNaN(t) ? `${t}px` : null;
    }
  }
}), Av1 = ["id", "aria-hidden", "tabindex", "data-popper-placement"], Fv1 = {
  ref: "inner",
  class: "v-popper__inner"
}, Tv1 = /* @__PURE__ */ C("div", { class: "v-popper__arrow-outer" }, null, -1), Iv1 = /* @__PURE__ */ C("div", { class: "v-popper__arrow-inner" }, null, -1), Ov1 = [
  Tv1,
  Iv1
];
function Nv1(t, e, n, i, s, l) {
  const a = V2("ResizeObserver");
  return T(), N("div", {
    id: t.popperId,
    ref: "popover",
    class: f2(["v-popper__popper", [
      t.themeClass,
      t.classes.popperClass,
      {
        "v-popper__popper--shown": t.shown,
        "v-popper__popper--hidden": !t.shown,
        "v-popper__popper--show-from": t.classes.showFrom,
        "v-popper__popper--show-to": t.classes.showTo,
        "v-popper__popper--hide-from": t.classes.hideFrom,
        "v-popper__popper--hide-to": t.classes.hideTo,
        "v-popper__popper--skip-transition": t.skipTransition,
        "v-popper__popper--arrow-overflow": t.result && t.result.arrow.overflow,
        "v-popper__popper--no-positioning": !t.result
      }
    ]]),
    style: Rt(t.result ? {
      position: t.result.strategy,
      transform: `translate3d(${Math.round(t.result.x)}px,${Math.round(t.result.y)}px,0)`
    } : void 0),
    "aria-hidden": t.shown ? "false" : "true",
    tabindex: t.autoHide ? 0 : void 0,
    "data-popper-placement": t.result ? t.result.placement : void 0,
    onKeyup: e[2] || (e[2] = P5((o) => t.autoHide && t.$emit("hide"), ["esc"]))
  }, [
    C("div", {
      class: "v-popper__backdrop",
      onClick: e[0] || (e[0] = (o) => t.autoHide && t.$emit("hide"))
    }),
    C("div", {
      class: "v-popper__wrapper",
      style: Rt(t.result ? {
        transformOrigin: t.result.transformOrigin
      } : void 0)
    }, [
      C("div", Fv1, [
        t.mounted ? (T(), N(I3, { key: 0 }, [
          C("div", null, [
            J2(t.$slots, "default")
          ]),
          t.handleResize ? (T(), v2(a, {
            key: 0,
            onNotify: e[1] || (e[1] = (o) => t.$emit("resize", o))
          })) : m2("", !0)
        ], 64)) : m2("", !0)
      ], 512),
      C("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: Rt(t.result ? {
          left: t.toPx(t.result.arrow.x),
          top: t.toPx(t.result.arrow.y)
        } : void 0)
      }, Ov1, 4)
    ], 4)
  ], 46, Av1);
}
const Hx = /* @__PURE__ */ Ou(Ev1, [["render", Nv1]]), Dx = {
  methods: {
    show(...t) {
      return this.$refs.popper.show(...t);
    },
    hide(...t) {
      return this.$refs.popper.hide(...t);
    },
    dispose(...t) {
      return this.$refs.popper.dispose(...t);
    },
    onResize(...t) {
      return this.$refs.popper.onResize(...t);
    }
  }
}, Pv1 = c2({
  name: "VPopperWrapper",
  components: {
    Popper: Lv1,
    PopperContent: Hx
  },
  mixins: [
    Dx,
    Rx("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    }
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((t) => t !== this.$refs.popperContent.$el);
    }
  }
});
function Bv1(t, e, n, i, s, l) {
  const a = V2("PopperContent"), o = V2("Popper");
  return T(), v2(o, {
    ref: "popper",
    theme: t.finalTheme,
    "target-nodes": t.getTargetNodes,
    "popper-node": () => t.$refs.popperContent.$el,
    class: f2([
      t.themeClass
    ])
  }, {
    default: Q2(({
      popperId: h,
      isShown: u,
      shouldMountContent: d,
      skipTransition: v,
      autoHide: m,
      show: p,
      hide: _,
      handleResize: q,
      onResize: M,
      classes: z,
      result: b
    }) => [
      J2(t.$slots, "default", {
        shown: u,
        show: p,
        hide: _
      }),
      _3(a, {
        ref: "popperContent",
        "popper-id": h,
        theme: t.finalTheme,
        shown: u,
        mounted: d,
        "skip-transition": v,
        "auto-hide": m,
        "handle-resize": q,
        classes: z,
        result: b,
        onHide: _,
        onResize: M
      }, {
        default: Q2(() => [
          J2(t.$slots, "popper", {
            shown: u,
            hide: _
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 8, ["theme", "target-nodes", "popper-node", "class"]);
}
const T_ = /* @__PURE__ */ Ou(Pv1, [["render", Bv1]]), Vv1 = {
  ...T_,
  name: "VDropdown",
  vPopperTheme: "dropdown"
}, Rv1 = {
  ...T_,
  name: "VMenu",
  vPopperTheme: "menu"
}, Hv1 = {
  ...T_,
  name: "VTooltip",
  vPopperTheme: "tooltip"
}, Dv1 = c2({
  name: "VTooltipDirective",
  components: {
    Popper: Bx(),
    PopperContent: Hx
  },
  mixins: [
    Dx
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (t) => Po(t.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (t) => Po(t.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(t) {
      if (typeof this.content == "function" && this.$_isShown && (t || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const e = ++this.$_fetchId, n = this.content(this);
        n.then ? n.then((i) => this.onResult(e, i)) : this.onResult(e, n);
      }
    },
    onResult(t, e) {
      t === this.$_fetchId && (this.$_loading = !1, this.asyncContent = e);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
}), $v1 = ["innerHTML"], Uv1 = ["textContent"];
function jv1(t, e, n, i, s, l) {
  const a = V2("PopperContent"), o = V2("Popper");
  return T(), v2(o, Ht({ ref: "popper" }, t.$attrs, {
    theme: t.theme,
    "target-nodes": t.targetNodes,
    "popper-node": () => t.$refs.popperContent.$el,
    onApplyShow: t.onShow,
    onApplyHide: t.onHide
  }), {
    default: Q2(({
      popperId: h,
      isShown: u,
      shouldMountContent: d,
      skipTransition: v,
      autoHide: m,
      hide: p,
      handleResize: _,
      onResize: q,
      classes: M,
      result: z
    }) => [
      _3(a, {
        ref: "popperContent",
        class: f2({
          "v-popper--tooltip-loading": t.loading
        }),
        "popper-id": h,
        theme: t.theme,
        shown: u,
        mounted: d,
        "skip-transition": v,
        "auto-hide": m,
        "handle-resize": _,
        classes: M,
        result: z,
        onHide: p,
        onResize: q
      }, {
        default: Q2(() => [
          t.html ? (T(), N("div", {
            key: 0,
            innerHTML: t.finalContent
          }, null, 8, $v1)) : (T(), N("div", {
            key: 1,
            textContent: pt(t.finalContent)
          }, null, 8, Uv1))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "target-nodes", "popper-node", "onApplyShow", "onApplyHide"]);
}
const Gv1 = /* @__PURE__ */ Ou(Dv1, [["render", jv1]]), $x = "v-popper--has-tooltip";
function Wv1(t, e) {
  let n = t.placement;
  if (!n && e)
    for (const i of Px)
      e[i] && (n = i);
  return n || (n = Po(t.theme || "tooltip", "placement")), n;
}
function Ux(t, e, n) {
  let i;
  const s = typeof e;
  return s === "string" ? i = { content: e } : e && s === "object" ? i = e : i = { content: !1 }, i.placement = Wv1(i, n), i.targetNodes = () => [t], i.referenceNode = () => t, i;
}
let Lg, Bo, Yv1 = 0;
function Xv1() {
  if (Lg)
    return;
  Bo = D1([]), Lg = iL({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: Bo
      };
    },
    render() {
      return this.directives.map((e) => w8(Gv1, {
        ...e.options,
        shown: e.shown || e.options.shown,
        key: e.id
      }));
    },
    devtools: {
      hide: !0
    }
  });
  const t = document.createElement("div");
  document.body.appendChild(t), Lg.mount(t);
}
function Kv1(t, e, n) {
  Xv1();
  const i = D1(Ux(t, e, n)), s = D1(!1), l = {
    id: Yv1++,
    options: i,
    shown: s
  };
  return Bo.value.push(l), t.classList && t.classList.add($x), t.$_popper = {
    options: i,
    item: l,
    show() {
      s.value = !0;
    },
    hide() {
      s.value = !1;
    }
  };
}
function jx(t) {
  if (t.$_popper) {
    const e = Bo.value.indexOf(t.$_popper.item);
    e !== -1 && Bo.value.splice(e, 1), delete t.$_popper, delete t.$_popperOldShown, delete t.$_popperMountTarget;
  }
  t.classList && t.classList.remove($x);
}
function iz(t, { value: e, modifiers: n }) {
  const i = Ux(t, e, n);
  if (!i.content || Po(i.theme || "tooltip", "disabled"))
    jx(t);
  else {
    let s;
    t.$_popper ? (s = t.$_popper, s.options.value = i) : s = Kv1(t, e, n), typeof e.shown < "u" && e.shown !== t.$_popperOldShown && (t.$_popperOldShown = e.shown, e.shown ? s.show() : s.hide());
  }
}
const Zv1 = {
  beforeMount: iz,
  updated: iz,
  beforeUnmount(t) {
    jx(t);
  }
};
function sz(t) {
  t.addEventListener("click", Gx), t.addEventListener("touchstart", Wx, vr ? {
    passive: !0
  } : !1);
}
function lz(t) {
  t.removeEventListener("click", Gx), t.removeEventListener("touchstart", Wx), t.removeEventListener("touchend", Yx), t.removeEventListener("touchcancel", Xx);
}
function Gx(t) {
  const e = t.currentTarget;
  t.closePopover = !e.$_vclosepopover_touch, t.closeAllPopover = e.$_closePopoverModifiers && !!e.$_closePopoverModifiers.all;
}
function Wx(t) {
  if (t.changedTouches.length === 1) {
    const e = t.currentTarget;
    e.$_vclosepopover_touch = !0;
    const n = t.changedTouches[0];
    e.$_vclosepopover_touchPoint = n, e.addEventListener("touchend", Yx), e.addEventListener("touchcancel", Xx);
  }
}
function Yx(t) {
  const e = t.currentTarget;
  if (e.$_vclosepopover_touch = !1, t.changedTouches.length === 1) {
    const n = t.changedTouches[0], i = e.$_vclosepopover_touchPoint;
    t.closePopover = Math.abs(n.screenY - i.screenY) < 20 && Math.abs(n.screenX - i.screenX) < 20, t.closeAllPopover = e.$_closePopoverModifiers && !!e.$_closePopoverModifiers.all;
  }
}
function Xx(t) {
  const e = t.currentTarget;
  e.$_vclosepopover_touch = !1;
}
const Jv1 = {
  beforeMount(t, { value: e, modifiers: n }) {
    t.$_closePopoverModifiers = n, (typeof e > "u" || e) && sz(t);
  },
  updated(t, { value: e, oldValue: n, modifiers: i }) {
    t.$_closePopoverModifiers = i, e !== n && (typeof e > "u" || e ? sz(t) : lz(t));
  },
  beforeUnmount(t) {
    lz(t);
  }
};
function Qv1(t, e = {}) {
  t.$_vTooltipInstalled || (t.$_vTooltipInstalled = !0, Ox(p8, e), t.directive("tooltip", Zv1), t.directive("close-popper", Jv1), t.component("VTooltip", Hv1), t.component("VDropdown", Vv1), t.component("VMenu", Rv1));
}
const ep1 = {
  // eslint-disable-next-line no-undef
  version: "2.0.0-beta.24",
  install: Qv1,
  options: p8
};
var N5 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pu(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Hh = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Hh.exports;
(function(t, e) {
  (function() {
    var n, i = "4.17.21", s = 200, l = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", o = "Invalid `variable` option passed into `_.template`", h = "__lodash_hash_undefined__", u = 500, d = "__lodash_placeholder__", v = 1, m = 2, p = 4, _ = 1, q = 2, M = 1, z = 2, b = 4, x = 8, k = 16, F = 32, D = 64, R = 128, V = 256, J = 512, K = 30, P = "...", O = 800, G = 16, j = 1, Q = 2, i1 = 3, h1 = 1 / 0, c1 = 9007199254740991, M1 = 17976931348623157e292, y1 = 0 / 0, A1 = 4294967295, $ = A1 - 1, a1 = A1 >>> 1, n1 = [
      ["ary", R],
      ["bind", M],
      ["bindKey", z],
      ["curry", x],
      ["curryRight", k],
      ["flip", J],
      ["partial", F],
      ["partialRight", D],
      ["rearg", V]
    ], f1 = "[object Arguments]", w1 = "[object Array]", C1 = "[object AsyncFunction]", E1 = "[object Boolean]", T1 = "[object Date]", n2 = "[object DOMException]", X1 = "[object Error]", a2 = "[object Function]", d2 = "[object GeneratorFunction]", y2 = "[object Map]", B1 = "[object Number]", p1 = "[object Null]", _2 = "[object Object]", w2 = "[object Promise]", K1 = "[object Proxy]", e2 = "[object RegExp]", Z1 = "[object Set]", t2 = "[object String]", S2 = "[object Symbol]", W2 = "[object Undefined]", E2 = "[object WeakMap]", o3 = "[object WeakSet]", n3 = "[object ArrayBuffer]", c3 = "[object DataView]", G2 = "[object Float32Array]", u3 = "[object Float64Array]", g2 = "[object Int8Array]", Oe = "[object Int16Array]", q3 = "[object Int32Array]", ht = "[object Uint8Array]", E3 = "[object Uint8ClampedArray]", j3 = "[object Uint16Array]", z2 = "[object Uint32Array]", R2 = /\b__p \+= '';/g, w3 = /\b(__p \+=) '' \+/g, B3 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, G3 = /&(?:amp|lt|gt|quot|#39);/g, Se = /[&<>"']/g, _e = RegExp(G3.source), d3 = RegExp(Se.source), Z3 = /<%-([\s\S]+?)%>/g, yt = /<%([\s\S]+?)%>/g, Ce = /<%=([\s\S]+?)%>/g, tt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ut = /^\w*$/, D2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Re = /[\\^$.*+?()[\]{}|]/g, _t = RegExp(Re.source), L3 = /^\s+/, W3 = /\s/, oe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, v4 = /\{\n\/\* \[wrapped with (.+)\] \*/, wn = /,? & /, m0 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, _5 = /[()=,{}\[\]\/\s]/, q5 = /\\(\\)?/g, w5 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, X4 = /\w*$/, K4 = /^[-+]0x[0-9a-f]+$/i, H5 = /^0b[01]+$/i, F6 = /^\[object .+?Constructor\]$/, zn = /^0o[0-7]+$/i, Mn = /^(?:0|[1-9]\d*)$/, bn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Z4 = /($^)/, P8 = /['\n\r\u2028\u2029\\]/g, g0 = "\\ud800-\\udfff", Ys = "\\u0300-\\u036f", Ln = "\\ufe20-\\ufe2f", B8 = "\\u20d0-\\u20ff", mi = Ys + Ln + B8, T6 = "\\u2700-\\u27bf", gi = "a-z\\xdf-\\xf6\\xf8-\\xff", V8 = "\\xac\\xb1\\xd7\\xf7", Xs = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", xn = "\\u2000-\\u206f", Ks = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", nt = "A-Z\\xc0-\\xd6\\xd8-\\xde", Sn = "\\ufe0e\\ufe0f", Cn = V8 + Xs + xn + Ks, G0 = "['’]", yi = "[" + g0 + "]", _i = "[" + Cn + "]", Dt = "[" + mi + "]", W0 = "\\d+", S4 = "[" + T6 + "]", I6 = "[" + gi + "]", kn = "[^" + g0 + Cn + W0 + T6 + gi + nt + "]", O6 = "\\ud83c[\\udffb-\\udfff]", R8 = "(?:" + Dt + "|" + O6 + ")", qi = "[^" + g0 + "]", Y0 = "(?:\\ud83c[\\udde6-\\uddff]){2}", N6 = "[\\ud800-\\udbff][\\udc00-\\udfff]", p4 = "[" + nt + "]", wi = "\\u200d", zi = "(?:" + I6 + "|" + kn + ")", Zs = "(?:" + p4 + "|" + kn + ")", z5 = "(?:" + G0 + "(?:d|ll|m|re|s|t|ve))?", X0 = "(?:" + G0 + "(?:D|LL|M|RE|S|T|VE))?", K0 = R8 + "?", En = "[" + Sn + "]?", n4 = "(?:" + wi + "(?:" + [qi, Y0, N6].join("|") + ")" + En + K0 + ")*", Js = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", H8 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", f3 = En + K0 + n4, Qs = "(?:" + [S4, Y0, N6].join("|") + ")" + f3, el = "(?:" + [qi + Dt + "?", Dt, Y0, N6, yi].join("|") + ")", D5 = RegExp(G0, "g"), D8 = RegExp(Dt, "g"), Z0 = RegExp(O6 + "(?=" + O6 + ")|" + el + f3, "g"), An = RegExp([
      p4 + "?" + I6 + "+" + z5 + "(?=" + [_i, p4, "$"].join("|") + ")",
      Zs + "+" + X0 + "(?=" + [_i, p4 + zi, "$"].join("|") + ")",
      p4 + "?" + zi + "+" + z5,
      p4 + "+" + X0,
      H8,
      Js,
      W0,
      Qs
    ].join("|"), "g"), Mi = RegExp("[" + wi + g0 + mi + Sn + "]"), tl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, nl = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], il = -1, e3 = {};
    e3[G2] = e3[u3] = e3[g2] = e3[Oe] = e3[q3] = e3[ht] = e3[E3] = e3[j3] = e3[z2] = !0, e3[f1] = e3[w1] = e3[n3] = e3[E1] = e3[c3] = e3[T1] = e3[X1] = e3[a2] = e3[y2] = e3[B1] = e3[_2] = e3[e2] = e3[Z1] = e3[t2] = e3[E2] = !1;
    var X2 = {};
    X2[f1] = X2[w1] = X2[n3] = X2[c3] = X2[E1] = X2[T1] = X2[G2] = X2[u3] = X2[g2] = X2[Oe] = X2[q3] = X2[y2] = X2[B1] = X2[_2] = X2[e2] = X2[Z1] = X2[t2] = X2[S2] = X2[ht] = X2[E3] = X2[j3] = X2[z2] = !0, X2[X1] = X2[a2] = X2[E2] = !1;
    var J0 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, sl = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, P6 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, bi = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Fn = parseFloat, $8 = parseInt, Tn = typeof N5 == "object" && N5 && N5.Object === Object && N5, U8 = typeof self == "object" && self && self.Object === Object && self, D3 = Tn || U8 || Function("return this")(), P4 = e && !e.nodeType && e, qt = P4 && !0 && t && !t.nodeType && t, Li = qt && qt.exports === P4, J4 = Li && Tn.process, J3 = function() {
      try {
        var e1 = qt && qt.require && qt.require("util").types;
        return e1 || J4 && J4.binding && J4.binding("util");
      } catch {
      }
    }(), B6 = J3 && J3.isArrayBuffer, y0 = J3 && J3.isDate, xi = J3 && J3.isMap, Q0 = J3 && J3.isRegExp, Si = J3 && J3.isSet, V6 = J3 && J3.isTypedArray;
    function fe(e1, m1, u1) {
      switch (u1.length) {
        case 0:
          return e1.call(m1);
        case 1:
          return e1.call(m1, u1[0]);
        case 2:
          return e1.call(m1, u1[0], u1[1]);
        case 3:
          return e1.call(m1, u1[0], u1[1], u1[2]);
      }
      return e1.apply(m1, u1);
    }
    function j8(e1, m1, u1, R1) {
      for (var s2 = -1, N2 = e1 == null ? 0 : e1.length; ++s2 < N2; ) {
        var z3 = e1[s2];
        m1(R1, z3, u1(z3), e1);
      }
      return R1;
    }
    function qe(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length; ++u1 < R1 && m1(e1[u1], u1, e1) !== !1; )
        ;
      return e1;
    }
    function Ci(e1, m1) {
      for (var u1 = e1 == null ? 0 : e1.length; u1-- && m1(e1[u1], u1, e1) !== !1; )
        ;
      return e1;
    }
    function R6(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length; ++u1 < R1; )
        if (!m1(e1[u1], u1, e1))
          return !1;
      return !0;
    }
    function At(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length, s2 = 0, N2 = []; ++u1 < R1; ) {
        var z3 = e1[u1];
        m1(z3, u1, e1) && (N2[s2++] = z3);
      }
      return N2;
    }
    function _0(e1, m1) {
      var u1 = e1 == null ? 0 : e1.length;
      return !!u1 && J1(e1, m1, 0) > -1;
    }
    function $5(e1, m1, u1) {
      for (var R1 = -1, s2 = e1 == null ? 0 : e1.length; ++R1 < s2; )
        if (u1(m1, e1[R1]))
          return !0;
      return !1;
    }
    function t3(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length, s2 = Array(R1); ++u1 < R1; )
        s2[u1] = m1(e1[u1], u1, e1);
      return s2;
    }
    function xt(e1, m1) {
      for (var u1 = -1, R1 = m1.length, s2 = e1.length; ++u1 < R1; )
        e1[s2 + u1] = m1[u1];
      return e1;
    }
    function Q4(e1, m1, u1, R1) {
      var s2 = -1, N2 = e1 == null ? 0 : e1.length;
      for (R1 && N2 && (u1 = e1[++s2]); ++s2 < N2; )
        u1 = m1(u1, e1[s2], s2, e1);
      return u1;
    }
    function ki(e1, m1, u1, R1) {
      var s2 = e1 == null ? 0 : e1.length;
      for (R1 && s2 && (u1 = e1[--s2]); s2--; )
        u1 = m1(u1, e1[s2], s2, e1);
      return u1;
    }
    function S(e1, m1) {
      for (var u1 = -1, R1 = e1 == null ? 0 : e1.length; ++u1 < R1; )
        if (m1(e1[u1], u1, e1))
          return !0;
      return !1;
    }
    var X = y3("length");
    function v1(e1) {
      return e1.split("");
    }
    function z1(e1) {
      return e1.match(m0) || [];
    }
    function F1(e1, m1, u1) {
      var R1;
      return u1(e1, function(s2, N2, z3) {
        if (m1(s2, N2, z3))
          return R1 = N2, !1;
      }), R1;
    }
    function H1(e1, m1, u1, R1) {
      for (var s2 = e1.length, N2 = u1 + (R1 ? 1 : -1); R1 ? N2-- : ++N2 < s2; )
        if (m1(e1[N2], N2, e1))
          return N2;
      return -1;
    }
    function J1(e1, m1, u1) {
      return m1 === m1 ? b5(e1, m1, u1) : H1(e1, Z2, u1);
    }
    function F2(e1, m1, u1, R1) {
      for (var s2 = u1 - 1, N2 = e1.length; ++s2 < N2; )
        if (R1(e1[s2], m1))
          return s2;
      return -1;
    }
    function Z2(e1) {
      return e1 !== e1;
    }
    function v3(e1, m1) {
      var u1 = e1 == null ? 0 : e1.length;
      return u1 ? Xe(e1, m1) / u1 : y1;
    }
    function y3(e1) {
      return function(m1) {
        return m1 == null ? n : m1[e1];
      };
    }
    function P3(e1) {
      return function(m1) {
        return e1 == null ? n : e1[m1];
      };
    }
    function He(e1, m1, u1, R1, s2) {
      return s2(e1, function(N2, z3, Y2) {
        u1 = R1 ? (R1 = !1, N2) : m1(u1, N2, z3, Y2);
      }), u1;
    }
    function ot(e1, m1) {
      var u1 = e1.length;
      for (e1.sort(m1); u1--; )
        e1[u1] = e1[u1].value;
      return e1;
    }
    function Xe(e1, m1) {
      for (var u1, R1 = -1, s2 = e1.length; ++R1 < s2; ) {
        var N2 = m1(e1[R1]);
        N2 !== n && (u1 = u1 === n ? N2 : u1 + N2);
      }
      return u1;
    }
    function wt(e1, m1) {
      for (var u1 = -1, R1 = Array(e1); ++u1 < e1; )
        R1[u1] = m1(u1);
      return R1;
    }
    function Ft(e1, m1) {
      return t3(m1, function(u1) {
        return [u1, e1[u1]];
      });
    }
    function B4(e1) {
      return e1 && e1.slice(0, U5(e1) + 1).replace(L3, "");
    }
    function V3(e1) {
      return function(m1) {
        return e1(m1);
      };
    }
    function V4(e1, m1) {
      return t3(m1, function(u1) {
        return e1[u1];
      });
    }
    function e5(e1, m1) {
      return e1.has(m1);
    }
    function H6(e1, m1) {
      for (var u1 = -1, R1 = e1.length; ++u1 < R1 && J1(m1, e1[u1], 0) > -1; )
        ;
      return u1;
    }
    function D6(e1, m1) {
      for (var u1 = e1.length; u1-- && J1(m1, e1[u1], 0) > -1; )
        ;
      return u1;
    }
    function In(e1, m1) {
      for (var u1 = e1.length, R1 = 0; u1--; )
        e1[u1] === m1 && ++R1;
      return R1;
    }
    var Ei = P3(J0), Ai = P3(sl);
    function On(e1) {
      return "\\" + bi[e1];
    }
    function C4(e1, m1) {
      return e1 == null ? n : e1[m1];
    }
    function i4(e1) {
      return Mi.test(e1);
    }
    function Nn(e1) {
      return tl.test(e1);
    }
    function Pn(e1) {
      for (var m1, u1 = []; !(m1 = e1.next()).done; )
        u1.push(m1.value);
      return u1;
    }
    function q0(e1) {
      var m1 = -1, u1 = Array(e1.size);
      return e1.forEach(function(R1, s2) {
        u1[++m1] = [s2, R1];
      }), u1;
    }
    function s4(e1, m1) {
      return function(u1) {
        return e1(m1(u1));
      };
    }
    function $t(e1, m1) {
      for (var u1 = -1, R1 = e1.length, s2 = 0, N2 = []; ++u1 < R1; ) {
        var z3 = e1[u1];
        (z3 === m1 || z3 === d) && (e1[u1] = d, N2[s2++] = u1);
      }
      return N2;
    }
    function M5(e1) {
      var m1 = -1, u1 = Array(e1.size);
      return e1.forEach(function(R1) {
        u1[++m1] = R1;
      }), u1;
    }
    function G8(e1) {
      var m1 = -1, u1 = Array(e1.size);
      return e1.forEach(function(R1) {
        u1[++m1] = [R1, R1];
      }), u1;
    }
    function b5(e1, m1, u1) {
      for (var R1 = u1 - 1, s2 = e1.length; ++R1 < s2; )
        if (e1[R1] === m1)
          return R1;
      return -1;
    }
    function Fi(e1, m1, u1) {
      for (var R1 = u1 + 1; R1--; )
        if (e1[R1] === m1)
          return R1;
      return R1;
    }
    function R4(e1) {
      return i4(e1) ? L5(e1) : X(e1);
    }
    function it(e1) {
      return i4(e1) ? e6(e1) : v1(e1);
    }
    function U5(e1) {
      for (var m1 = e1.length; m1-- && W3.test(e1.charAt(m1)); )
        ;
      return m1;
    }
    var t5 = P3(P6);
    function L5(e1) {
      for (var m1 = Z0.lastIndex = 0; Z0.test(e1); )
        ++m1;
      return m1;
    }
    function e6(e1) {
      return e1.match(Z0) || [];
    }
    function j5(e1) {
      return e1.match(An) || [];
    }
    var w0 = function e1(m1) {
      m1 = m1 == null ? D3 : l4.defaults(D3.Object(), m1, l4.pick(D3, nl));
      var u1 = m1.Array, R1 = m1.Date, s2 = m1.Error, N2 = m1.Function, z3 = m1.Math, Y2 = m1.Object, x5 = m1.RegExp, t6 = m1.String, ke = m1.TypeError, Tt = u1.prototype, z0 = N2.prototype, $3 = Y2.prototype, te = m1["__core-js_shared__"], Ee = z0.toString, x2 = $3.hasOwnProperty, M0 = 0, G5 = function() {
        var r = /[^.]+$/.exec(te && te.keys && te.keys.IE_PROTO || "");
        return r ? "Symbol(src)_1." + r : "";
      }(), n5 = $3.toString, W8 = Ee.call(Y2), Fr = D3._, Tr = x5(
        "^" + Ee.call(x2).replace(Re, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), n6 = Li ? m1.Buffer : n, r4 = m1.Symbol, i6 = m1.Uint8Array, Y8 = n6 ? n6.allocUnsafe : n, b0 = s4(Y2.getPrototypeOf, Y2), Bn = Y2.create, m4 = $3.propertyIsEnumerable, It = Tt.splice, Vn = r4 ? r4.isConcatSpreadable : n, i5 = r4 ? r4.iterator : n, k4 = r4 ? r4.toStringTag : n, W5 = function() {
        try {
          var r = A5(Y2, "defineProperty");
          return r({}, "", {}), r;
        } catch {
        }
      }(), X8 = m1.clearTimeout !== D3.clearTimeout && m1.clearTimeout, ll = R1 && R1.now !== D3.Date.now && R1.now, Ir = m1.setTimeout !== D3.setTimeout && m1.setTimeout, L0 = z3.ceil, x0 = z3.floor, s6 = Y2.getOwnPropertySymbols, rl = n6 ? n6.isBuffer : n, al = m1.isFinite, q9 = Tt.join, Or = s4(Y2.keys, Y2), R3 = z3.max, ne = z3.min, w9 = R1.now, z9 = m1.parseInt, ol = z3.random, cl = Tt.reverse, $6 = A5(m1, "DataView"), H4 = A5(m1, "Map"), Ti = A5(m1, "Promise"), S5 = A5(m1, "Set"), Y5 = A5(m1, "WeakMap"), S0 = A5(Y2, "create"), U6 = Y5 && new Y5(), C5 = {}, M9 = F5($6), l6 = F5(H4), k5 = F5(Ti), C0 = F5(S5), b9 = F5(Y5), r6 = r4 ? r4.prototype : n, a4 = r6 ? r6.valueOf : n, E4 = r6 ? r6.toString : n;
      function A(r) {
        if (S3(r) && !p2(r) && !(r instanceof A2)) {
          if (r instanceof Ke)
            return r;
          if (x2.call(r, "__wrapped__"))
            return h7(r);
        }
        return new Ke(r);
      }
      var E5 = function() {
        function r() {
        }
        return function(c) {
          if (!M3(c))
            return {};
          if (Bn)
            return Bn(c);
          r.prototype = c;
          var f = new r();
          return r.prototype = n, f;
        };
      }();
      function a6() {
      }
      function Ke(r, c) {
        this.__wrapped__ = r, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = n;
      }
      A.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Z3,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: yt,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ce,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: A
        }
      }, A.prototype = a6.prototype, A.prototype.constructor = A, Ke.prototype = E5(a6.prototype), Ke.prototype.constructor = Ke;
      function A2(r) {
        this.__wrapped__ = r, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = A1, this.__views__ = [];
      }
      function Nr() {
        var r = new A2(this.__wrapped__);
        return r.__actions__ = $e(this.__actions__), r.__dir__ = this.__dir__, r.__filtered__ = this.__filtered__, r.__iteratees__ = $e(this.__iteratees__), r.__takeCount__ = this.__takeCount__, r.__views__ = $e(this.__views__), r;
      }
      function L9() {
        if (this.__filtered__) {
          var r = new A2(this);
          r.__dir__ = -1, r.__filtered__ = !0;
        } else
          r = this.clone(), r.__dir__ *= -1;
        return r;
      }
      function K8() {
        var r = this.__wrapped__.value(), c = this.__dir__, f = p2(r), y = c < 0, L = f ? r.length : 0, I = Wd(0, L, this.__views__), U = I.start, Y = I.end, l1 = Y - U, _1 = y ? Y : U - 1, q1 = this.__iteratees__, x1 = q1.length, P1 = 0, W1 = ne(l1, this.__takeCount__);
        if (!f || !y && L == l1 && W1 == l1)
          return Dn(r, this.__actions__);
        var l2 = [];
        e:
          for (; l1-- && P1 < W1; ) {
            _1 += c;
            for (var b2 = -1, r2 = r[_1]; ++b2 < x1; ) {
              var T2 = q1[b2], B2 = T2.iteratee, lt = T2.type, Fe = B2(r2);
              if (lt == Q)
                r2 = Fe;
              else if (!Fe) {
                if (lt == j)
                  continue e;
                break e;
              }
            }
            l2[P1++] = r2;
          }
        return l2;
      }
      A2.prototype = E5(a6.prototype), A2.prototype.constructor = A2;
      function o4(r) {
        var c = -1, f = r == null ? 0 : r.length;
        for (this.clear(); ++c < f; ) {
          var y = r[c];
          this.set(y[0], y[1]);
        }
      }
      function Ii() {
        this.__data__ = S0 ? S0(null) : {}, this.size = 0;
      }
      function hl(r) {
        var c = this.has(r) && delete this.__data__[r];
        return this.size -= c ? 1 : 0, c;
      }
      function Pr(r) {
        var c = this.__data__;
        if (S0) {
          var f = c[r];
          return f === h ? n : f;
        }
        return x2.call(c, r) ? c[r] : n;
      }
      function x9(r) {
        var c = this.__data__;
        return S0 ? c[r] !== n : x2.call(c, r);
      }
      function Br(r, c) {
        var f = this.__data__;
        return this.size += this.has(r) ? 0 : 1, f[r] = S0 && c === n ? h : c, this;
      }
      o4.prototype.clear = Ii, o4.prototype.delete = hl, o4.prototype.get = Pr, o4.prototype.has = x9, o4.prototype.set = Br;
      function Ut(r) {
        var c = -1, f = r == null ? 0 : r.length;
        for (this.clear(); ++c < f; ) {
          var y = r[c];
          this.set(y[0], y[1]);
        }
      }
      function S9() {
        this.__data__ = [], this.size = 0;
      }
      function C9(r) {
        var c = this.__data__, f = b1(c, r);
        if (f < 0)
          return !1;
        var y = c.length - 1;
        return f == y ? c.pop() : It.call(c, f, 1), --this.size, !0;
      }
      function k9(r) {
        var c = this.__data__, f = b1(c, r);
        return f < 0 ? n : c[f][1];
      }
      function E9(r) {
        return b1(this.__data__, r) > -1;
      }
      function A9(r, c) {
        var f = this.__data__, y = b1(f, r);
        return y < 0 ? (++this.size, f.push([r, c])) : f[y][1] = c, this;
      }
      Ut.prototype.clear = S9, Ut.prototype.delete = C9, Ut.prototype.get = k9, Ut.prototype.has = E9, Ut.prototype.set = A9;
      function Ot(r) {
        var c = -1, f = r == null ? 0 : r.length;
        for (this.clear(); ++c < f; ) {
          var y = r[c];
          this.set(y[0], y[1]);
        }
      }
      function Z8() {
        this.size = 0, this.__data__ = {
          hash: new o4(),
          map: new (H4 || Ut)(),
          string: new o4()
        };
      }
      function F9(r) {
        var c = Wi(this, r).delete(r);
        return this.size -= c ? 1 : 0, c;
      }
      function T9(r) {
        return Wi(this, r).get(r);
      }
      function Vr(r) {
        return Wi(this, r).has(r);
      }
      function g(r, c) {
        var f = Wi(this, r), y = f.size;
        return f.set(r, c), this.size += f.size == y ? 0 : 1, this;
      }
      Ot.prototype.clear = Z8, Ot.prototype.delete = F9, Ot.prototype.get = T9, Ot.prototype.has = Vr, Ot.prototype.set = g;
      function w(r) {
        var c = -1, f = r == null ? 0 : r.length;
        for (this.__data__ = new Ot(); ++c < f; )
          this.add(r[c]);
      }
      function E(r) {
        return this.__data__.set(r, h), this;
      }
      function B(r) {
        return this.__data__.has(r);
      }
      w.prototype.add = w.prototype.push = E, w.prototype.has = B;
      function W(r) {
        var c = this.__data__ = new Ut(r);
        this.size = c.size;
      }
      function Z() {
        this.__data__ = new Ut(), this.size = 0;
      }
      function t1(r) {
        var c = this.__data__, f = c.delete(r);
        return this.size = c.size, f;
      }
      function r1(r) {
        return this.__data__.get(r);
      }
      function o1(r) {
        return this.__data__.has(r);
      }
      function d1(r, c) {
        var f = this.__data__;
        if (f instanceof Ut) {
          var y = f.__data__;
          if (!H4 || y.length < s - 1)
            return y.push([r, c]), this.size = ++f.size, this;
          f = this.__data__ = new Ot(y);
        }
        return f.set(r, c), this.size = f.size, this;
      }
      W.prototype.clear = Z, W.prototype.delete = t1, W.prototype.get = r1, W.prototype.has = o1, W.prototype.set = d1;
      function L1(r, c) {
        var f = p2(r), y = !f && T5(r), L = !f && !y && $4(r), I = !f && !y && !L && N0(r), U = f || y || L || I, Y = U ? wt(r.length, t6) : [], l1 = Y.length;
        for (var _1 in r)
          (c || x2.call(r, _1)) && !(U && // Safari 9 has enumerable `arguments.length` in strict mode.
          (_1 == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          L && (_1 == "offset" || _1 == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          I && (_1 == "buffer" || _1 == "byteLength" || _1 == "byteOffset") || // Skip index properties.
          w4(_1, l1))) && Y.push(_1);
        return Y;
      }
      function I1(r) {
        var c = r.length;
        return c ? r[f6(0, c - 1)] : n;
      }
      function O1(r, c) {
        return Yi($e(r), o2(c, 0, r.length));
      }
      function k1(r) {
        return Yi($e(r));
      }
      function G1(r, c, f) {
        (f !== n && !St(r[c], f) || f === n && !(c in r)) && $1(r, c, f);
      }
      function V1(r, c, f) {
        var y = r[c];
        (!(x2.call(r, c) && St(y, f)) || f === n && !(c in r)) && $1(r, c, f);
      }
      function b1(r, c) {
        for (var f = r.length; f--; )
          if (St(r[f][0], c))
            return f;
        return -1;
      }
      function S1(r, c, f, y) {
        return a3(r, function(L, I, U) {
          c(y, L, f(L), U);
        }), y;
      }
      function j1(r, c) {
        return r && Yt(c, ee(c), r);
      }
      function Q1(r, c) {
        return r && Yt(c, je(c), r);
      }
      function $1(r, c, f) {
        c == "__proto__" && W5 ? W5(r, c, {
          configurable: !0,
          enumerable: !0,
          value: f,
          writable: !0
        }) : r[c] = f;
      }
      function C2(r, c) {
        for (var f = -1, y = c.length, L = u1(y), I = r == null; ++f < y; )
          L[f] = I ? n : Nl(r, c[f]);
        return L;
      }
      function o2(r, c, f) {
        return r === r && (f !== n && (r = r <= f ? r : f), c !== n && (r = r >= c ? r : c)), r;
      }
      function k2(r, c, f, y, L, I) {
        var U, Y = c & v, l1 = c & m, _1 = c & p;
        if (f && (U = L ? f(r, y, L, I) : f(r)), U !== n)
          return U;
        if (!M3(r))
          return r;
        var q1 = p2(r);
        if (q1) {
          if (U = Xd(r), !Y)
            return $e(r, U);
        } else {
          var x1 = me(r), P1 = x1 == a2 || x1 == d2;
          if ($4(r))
            return Ri(r, Y);
          if (x1 == _2 || x1 == f1 || P1 && !L) {
            if (U = l1 || P1 ? {} : t7(r), !Y)
              return l1 ? Bd(r, Q1(U, r)) : Pd(r, j1(U, r));
          } else {
            if (!X2[x1])
              return L ? r : {};
            U = Kd(r, x1, Y);
          }
        }
        I || (I = new W());
        var W1 = I.get(r);
        if (W1)
          return W1;
        I.set(r, U), E7(r) ? r.forEach(function(r2) {
          U.add(k2(r2, c, f, r2, r, I));
        }) : C7(r) && r.forEach(function(r2, T2) {
          U.set(T2, k2(r2, c, f, T2, r, I));
        });
        var l2 = _1 ? l1 ? zl : wl : l1 ? je : ee, b2 = q1 ? n : l2(r);
        return qe(b2 || r, function(r2, T2) {
          b2 && (T2 = r2, r2 = r[T2]), V1(U, T2, k2(r2, c, f, T2, r, I));
        }), U;
      }
      function L2(r) {
        var c = ee(r);
        return function(f) {
          return Q3(f, r, c);
        };
      }
      function Q3(r, c, f) {
        var y = f.length;
        if (r == null)
          return !y;
        for (r = Y2(r); y--; ) {
          var L = f[y], I = c[L], U = r[L];
          if (U === n && !(L in r) || !I(U))
            return !1;
        }
        return !0;
      }
      function ie(r, c, f) {
        if (typeof r != "function")
          throw new ke(a);
        return K6(function() {
          r.apply(n, f);
        }, c);
      }
      function x3(r, c, f, y) {
        var L = -1, I = _0, U = !0, Y = r.length, l1 = [], _1 = c.length;
        if (!Y)
          return l1;
        f && (c = t3(c, V3(f))), y ? (I = $5, U = !1) : c.length >= s && (I = e5, U = !1, c = new w(c));
        e:
          for (; ++L < Y; ) {
            var q1 = r[L], x1 = f == null ? q1 : f(q1);
            if (q1 = y || q1 !== 0 ? q1 : 0, U && x1 === x1) {
              for (var P1 = _1; P1--; )
                if (c[P1] === x1)
                  continue e;
              l1.push(q1);
            } else
              I(c, x1, y) || l1.push(q1);
          }
        return l1;
      }
      var a3 = H9(le), ve = H9(jt, !0);
      function we(r, c) {
        var f = !0;
        return a3(r, function(y, L, I) {
          return f = !!c(y, L, I), f;
        }), f;
      }
      function h3(r, c, f) {
        for (var y = -1, L = r.length; ++y < L; ) {
          var I = r[y], U = c(I);
          if (U != null && (Y === n ? U === U && !st(U) : f(U, Y)))
            var Y = U, l1 = I;
        }
        return l1;
      }
      function zt(r, c, f, y) {
        var L = r.length;
        for (f = q2(f), f < 0 && (f = -f > L ? 0 : L + f), y = y === n || y > L ? L : q2(y), y < 0 && (y += L), y = f > y ? 0 : F7(y); f < y; )
          r[f++] = c;
        return r;
      }
      function c4(r, c) {
        var f = [];
        return a3(r, function(y, L, I) {
          c(y, L, I) && f.push(y);
        }), f;
      }
      function i3(r, c, f, y, L) {
        var I = -1, U = r.length;
        for (f || (f = Jd), L || (L = []); ++I < U; ) {
          var Y = r[I];
          c > 0 && f(Y) ? c > 1 ? i3(Y, c - 1, f, y, L) : xt(L, Y) : y || (L[L.length] = Y);
        }
        return L;
      }
      var Nt = D9(), se = D9(!0);
      function le(r, c) {
        return r && Nt(r, c, ee);
      }
      function jt(r, c) {
        return r && se(r, c, ee);
      }
      function Ze(r, c) {
        return At(c, function(f) {
          return z4(r[f]);
        });
      }
      function pe(r, c) {
        c = Wt(c, r);
        for (var f = 0, y = c.length; r != null && f < y; )
          r = r[Xt(c[f++])];
        return f && f == y ? r : n;
      }
      function Gt(r, c, f) {
        var y = c(r);
        return p2(r) ? y : xt(y, f(r));
      }
      function A3(r) {
        return r == null ? r === n ? W2 : p1 : k4 && k4 in Y2(r) ? Gd(r) : rf(r);
      }
      function A4(r, c) {
        return r > c;
      }
      function Pt(r, c) {
        return r != null && x2.call(r, c);
      }
      function k0(r, c) {
        return r != null && c in Y2(r);
      }
      function j6(r, c, f) {
        return r >= ne(c, f) && r < R3(c, f);
      }
      function X5(r, c, f) {
        for (var y = f ? $5 : _0, L = r[0].length, I = r.length, U = I, Y = u1(I), l1 = 1 / 0, _1 = []; U--; ) {
          var q1 = r[U];
          U && c && (q1 = t3(q1, V3(c))), l1 = ne(q1.length, l1), Y[U] = !f && (c || L >= 120 && q1.length >= 120) ? new w(U && q1) : n;
        }
        q1 = r[0];
        var x1 = -1, P1 = Y[0];
        e:
          for (; ++x1 < L && _1.length < l1; ) {
            var W1 = q1[x1], l2 = c ? c(W1) : W1;
            if (W1 = f || W1 !== 0 ? W1 : 0, !(P1 ? e5(P1, l2) : y(_1, l2, f))) {
              for (U = I; --U; ) {
                var b2 = Y[U];
                if (!(b2 ? e5(b2, l2) : y(r[U], l2, f)))
                  continue e;
              }
              P1 && P1.push(l2), _1.push(W1);
            }
          }
        return _1;
      }
      function o6(r, c, f, y) {
        return le(r, function(L, I, U) {
          c(y, f(L), I, U);
        }), y;
      }
      function ce(r, c, f) {
        c = Wt(c, r), r = l7(r, c);
        var y = r == null ? r : r[Xt(dt(c))];
        return y == null ? n : fe(y, r, f);
      }
      function Oi(r) {
        return S3(r) && A3(r) == f1;
      }
      function Rr(r) {
        return S3(r) && A3(r) == n3;
      }
      function Hr(r) {
        return S3(r) && A3(r) == T1;
      }
      function s5(r, c, f, y, L) {
        return r === c ? !0 : r == null || c == null || !S3(r) && !S3(c) ? r !== r && c !== c : Ni(r, c, f, y, s5, L);
      }
      function Ni(r, c, f, y, L, I) {
        var U = p2(r), Y = p2(c), l1 = U ? w1 : me(r), _1 = Y ? w1 : me(c);
        l1 = l1 == f1 ? _2 : l1, _1 = _1 == f1 ? _2 : _1;
        var q1 = l1 == _2, x1 = _1 == _2, P1 = l1 == _1;
        if (P1 && $4(r)) {
          if (!$4(c))
            return !1;
          U = !0, q1 = !1;
        }
        if (P1 && !q1)
          return I || (I = new W()), U || N0(r) ? J9(r, c, f, y, L, I) : Ud(r, c, l1, f, y, L, I);
        if (!(f & _)) {
          var W1 = q1 && x2.call(r, "__wrapped__"), l2 = x1 && x2.call(c, "__wrapped__");
          if (W1 || l2) {
            var b2 = W1 ? r.value() : r, r2 = l2 ? c.value() : c;
            return I || (I = new W()), L(b2, r2, f, y, I);
          }
        }
        return P1 ? (I || (I = new W()), jd(r, c, f, y, L, I)) : !1;
      }
      function J8(r) {
        return S3(r) && me(r) == y2;
      }
      function g4(r, c, f, y) {
        var L = f.length, I = L, U = !y;
        if (r == null)
          return !I;
        for (r = Y2(r); L--; ) {
          var Y = f[L];
          if (U && Y[2] ? Y[1] !== r[Y[0]] : !(Y[0] in r))
            return !1;
        }
        for (; ++L < I; ) {
          Y = f[L];
          var l1 = Y[0], _1 = r[l1], q1 = Y[1];
          if (U && Y[2]) {
            if (_1 === n && !(l1 in r))
              return !1;
          } else {
            var x1 = new W();
            if (y)
              var P1 = y(_1, q1, l1, r, c, x1);
            if (!(P1 === n ? s5(q1, _1, _ | q, y, x1) : P1))
              return !1;
          }
        }
        return !0;
      }
      function c6(r) {
        if (!M3(r) || ef(r))
          return !1;
        var c = z4(r) ? Tr : F6;
        return c.test(F5(r));
      }
      function Rn(r) {
        return S3(r) && A3(r) == e2;
      }
      function Dr(r) {
        return S3(r) && me(r) == Z1;
      }
      function Q8(r) {
        return S3(r) && e8(r.length) && !!e3[A3(r)];
      }
      function es(r) {
        return typeof r == "function" ? r : r == null ? Ge : typeof r == "object" ? p2(r) ? fl(r[0], r[1]) : dl(r) : $7(r);
      }
      function h6(r) {
        if (!X6(r))
          return Or(r);
        var c = [];
        for (var f in Y2(r))
          x2.call(r, f) && f != "constructor" && c.push(f);
        return c;
      }
      function ul(r) {
        if (!M3(r))
          return lf(r);
        var c = X6(r), f = [];
        for (var y in r)
          y == "constructor" && (c || !x2.call(r, y)) || f.push(y);
        return f;
      }
      function u6(r, c) {
        return r < c;
      }
      function G6(r, c) {
        var f = -1, y = Ue(r) ? u1(r.length) : [];
        return a3(r, function(L, I, U) {
          y[++f] = c(L, I, U);
        }), y;
      }
      function dl(r) {
        var c = bl(r);
        return c.length == 1 && c[0][2] ? i7(c[0][0], c[0][1]) : function(f) {
          return f === r || g4(f, r, c);
        };
      }
      function fl(r, c) {
        return xl(r) && n7(c) ? i7(Xt(r), c) : function(f) {
          var y = Nl(f, r);
          return y === n && y === c ? Pl(f, r) : s5(c, y, _ | q);
        };
      }
      function E0(r, c, f, y, L) {
        r !== c && Nt(c, function(I, U) {
          if (L || (L = new W()), M3(I))
            d6(r, c, U, f, E0, y, L);
          else {
            var Y = y ? y(Cl(r, U), I, U + "", r, c, L) : n;
            Y === n && (Y = I), G1(r, U, Y);
          }
        }, je);
      }
      function d6(r, c, f, y, L, I, U) {
        var Y = Cl(r, f), l1 = Cl(c, f), _1 = U.get(l1);
        if (_1) {
          G1(r, f, _1);
          return;
        }
        var q1 = I ? I(Y, l1, f + "", r, c, U) : n, x1 = q1 === n;
        if (x1) {
          var P1 = p2(l1), W1 = !P1 && $4(l1), l2 = !P1 && !W1 && N0(l1);
          q1 = l1, P1 || W1 || l2 ? p2(Y) ? q1 = Y : O3(Y) ? q1 = $e(Y) : W1 ? (x1 = !1, q1 = Ri(l1, !0)) : l2 ? (x1 = !1, q1 = P9(l1, !0)) : q1 = [] : Z6(l1) || T5(l1) ? (q1 = Y, T5(Y) ? q1 = T7(Y) : (!M3(Y) || z4(Y)) && (q1 = t7(l1))) : x1 = !1;
        }
        x1 && (U.set(l1, q1), L(q1, l1, y, I, U), U.delete(l1)), G1(r, f, q1);
      }
      function vl(r, c) {
        var f = r.length;
        if (f)
          return c += c < 0 ? f : 0, w4(c, f) ? r[c] : n;
      }
      function pl(r, c, f) {
        c.length ? c = t3(c, function(I) {
          return p2(I) ? function(U) {
            return pe(U, I.length === 1 ? I[0] : I);
          } : I;
        }) : c = [Ge];
        var y = -1;
        c = t3(c, V3(i2()));
        var L = G6(r, function(I, U, Y) {
          var l1 = t3(c, function(_1) {
            return _1(I);
          });
          return { criteria: l1, index: ++y, value: I };
        });
        return ot(L, function(I, U) {
          return Nd(I, U, f);
        });
      }
      function I9(r, c) {
        return ts(r, c, function(f, y) {
          return Pl(r, y);
        });
      }
      function ts(r, c, f) {
        for (var y = -1, L = c.length, I = {}; ++y < L; ) {
          var U = c[y], Y = pe(r, U);
          f(Y, U) && K5(I, Wt(U, r), Y);
        }
        return I;
      }
      function ns(r) {
        return function(c) {
          return pe(c, r);
        };
      }
      function Hn(r, c, f, y) {
        var L = y ? F2 : J1, I = -1, U = c.length, Y = r;
        for (r === c && (c = $e(c)), f && (Y = t3(r, V3(f))); ++I < U; )
          for (var l1 = 0, _1 = c[I], q1 = f ? f(_1) : _1; (l1 = L(Y, q1, l1, y)) > -1; )
            Y !== r && It.call(Y, l1, 1), It.call(r, l1, 1);
        return r;
      }
      function is(r, c) {
        for (var f = r ? c.length : 0, y = f - 1; f--; ) {
          var L = c[f];
          if (f == y || L !== I) {
            var I = L;
            w4(L) ? It.call(r, L, 1) : Bi(r, L);
          }
        }
        return r;
      }
      function f6(r, c) {
        return r + x0(ol() * (c - r + 1));
      }
      function ml(r, c, f, y) {
        for (var L = -1, I = R3(L0((c - r) / (f || 1)), 0), U = u1(I); I--; )
          U[y ? I : ++L] = r, r += f;
        return U;
      }
      function A0(r, c) {
        var f = "";
        if (!r || c < 1 || c > c1)
          return f;
        do
          c % 2 && (f += r), c = x0(c / 2), c && (r += r);
        while (c);
        return f;
      }
      function M2(r, c) {
        return kl(s7(r, c, Ge), r + "");
      }
      function O9(r) {
        return I1(P0(r));
      }
      function ss(r, c) {
        var f = P0(r);
        return Yi(f, o2(c, 0, f.length));
      }
      function K5(r, c, f, y) {
        if (!M3(r))
          return r;
        c = Wt(c, r);
        for (var L = -1, I = c.length, U = I - 1, Y = r; Y != null && ++L < I; ) {
          var l1 = Xt(c[L]), _1 = f;
          if (l1 === "__proto__" || l1 === "constructor" || l1 === "prototype")
            return r;
          if (L != U) {
            var q1 = Y[l1];
            _1 = y ? y(q1, l1, Y) : n, _1 === n && (_1 = M3(q1) ? q1 : w4(c[L + 1]) ? [] : {});
          }
          V1(Y, l1, _1), Y = Y[l1];
        }
        return r;
      }
      var Pi = U6 ? function(r, c) {
        return U6.set(r, c), r;
      } : Ge, v6 = W5 ? function(r, c) {
        return W5(r, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Vl(c),
          writable: !0
        });
      } : Ge;
      function $r(r) {
        return Yi(P0(r));
      }
      function Je(r, c, f) {
        var y = -1, L = r.length;
        c < 0 && (c = -c > L ? 0 : L + c), f = f > L ? L : f, f < 0 && (f += L), L = c > f ? 0 : f - c >>> 0, c >>>= 0;
        for (var I = u1(L); ++y < L; )
          I[y] = r[y + c];
        return I;
      }
      function N9(r, c) {
        var f;
        return a3(r, function(y, L, I) {
          return f = c(y, L, I), !f;
        }), !!f;
      }
      function p6(r, c, f) {
        var y = 0, L = r == null ? y : r.length;
        if (typeof c == "number" && c === c && L <= a1) {
          for (; y < L; ) {
            var I = y + L >>> 1, U = r[I];
            U !== null && !st(U) && (f ? U <= c : U < c) ? y = I + 1 : L = I;
          }
          return L;
        }
        return Z5(r, c, Ge, f);
      }
      function Z5(r, c, f, y) {
        var L = 0, I = r == null ? 0 : r.length;
        if (I === 0)
          return 0;
        c = f(c);
        for (var U = c !== c, Y = c === null, l1 = st(c), _1 = c === n; L < I; ) {
          var q1 = x0((L + I) / 2), x1 = f(r[q1]), P1 = x1 !== n, W1 = x1 === null, l2 = x1 === x1, b2 = st(x1);
          if (U)
            var r2 = y || l2;
          else
            _1 ? r2 = l2 && (y || P1) : Y ? r2 = l2 && P1 && (y || !W1) : l1 ? r2 = l2 && P1 && !W1 && (y || !b2) : W1 || b2 ? r2 = !1 : r2 = y ? x1 <= c : x1 < c;
          r2 ? L = q1 + 1 : I = q1;
        }
        return ne(I, $);
      }
      function gl(r, c) {
        for (var f = -1, y = r.length, L = 0, I = []; ++f < y; ) {
          var U = r[f], Y = c ? c(U) : U;
          if (!f || !St(Y, l1)) {
            var l1 = Y;
            I[L++] = U === 0 ? 0 : U;
          }
        }
        return I;
      }
      function ls(r) {
        return typeof r == "number" ? r : st(r) ? y1 : +r;
      }
      function De(r) {
        if (typeof r == "string")
          return r;
        if (p2(r))
          return t3(r, De) + "";
        if (st(r))
          return E4 ? E4.call(r) : "";
        var c = r + "";
        return c == "0" && 1 / r == -h1 ? "-0" : c;
      }
      function h4(r, c, f) {
        var y = -1, L = _0, I = r.length, U = !0, Y = [], l1 = Y;
        if (f)
          U = !1, L = $5;
        else if (I >= s) {
          var _1 = c ? null : Dd(r);
          if (_1)
            return M5(_1);
          U = !1, L = e5, l1 = new w();
        } else
          l1 = c ? [] : Y;
        e:
          for (; ++y < I; ) {
            var q1 = r[y], x1 = c ? c(q1) : q1;
            if (q1 = f || q1 !== 0 ? q1 : 0, U && x1 === x1) {
              for (var P1 = l1.length; P1--; )
                if (l1[P1] === x1)
                  continue e;
              c && l1.push(x1), Y.push(q1);
            } else
              L(l1, x1, f) || (l1 !== Y && l1.push(x1), Y.push(q1));
          }
        return Y;
      }
      function Bi(r, c) {
        return c = Wt(c, r), r = l7(r, c), r == null || delete r[Xt(dt(c))];
      }
      function W6(r, c, f, y) {
        return K5(r, c, f(pe(r, c)), y);
      }
      function F0(r, c, f, y) {
        for (var L = r.length, I = y ? L : -1; (y ? I-- : ++I < L) && c(r[I], I, r); )
          ;
        return f ? Je(r, y ? 0 : I, y ? I + 1 : L) : Je(r, y ? I + 1 : 0, y ? L : I);
      }
      function Dn(r, c) {
        var f = r;
        return f instanceof A2 && (f = f.value()), Q4(c, function(y, L) {
          return L.func.apply(L.thisArg, xt([y], L.args));
        }, f);
      }
      function D4(r, c, f) {
        var y = r.length;
        if (y < 2)
          return y ? h4(r[0]) : [];
        for (var L = -1, I = u1(y); ++L < y; )
          for (var U = r[L], Y = -1; ++Y < y; )
            Y != L && (I[L] = x3(I[L] || U, r[Y], c, f));
        return h4(i3(I, 1), c, f);
      }
      function J5(r, c, f) {
        for (var y = -1, L = r.length, I = c.length, U = {}; ++y < L; ) {
          var Y = y < I ? c[y] : n;
          f(U, r[y], Y);
        }
        return U;
      }
      function l5(r) {
        return O3(r) ? r : [];
      }
      function m6(r) {
        return typeof r == "function" ? r : Ge;
      }
      function Wt(r, c) {
        return p2(r) ? r : xl(r, c) ? [r] : c7(K2(r));
      }
      var Ur = M2;
      function y4(r, c, f) {
        var y = r.length;
        return f = f === n ? y : f, !c && f >= y ? r : Je(r, c, f);
      }
      var Vi = X8 || function(r) {
        return D3.clearTimeout(r);
      };
      function Ri(r, c) {
        if (c)
          return r.slice();
        var f = r.length, y = Y8 ? Y8(f) : new r.constructor(f);
        return r.copy(y), y;
      }
      function yl(r) {
        var c = new r.constructor(r.byteLength);
        return new i6(c).set(new i6(r)), c;
      }
      function Td(r, c) {
        var f = c ? yl(r.buffer) : r.buffer;
        return new r.constructor(f, r.byteOffset, r.byteLength);
      }
      function Id(r) {
        var c = new r.constructor(r.source, X4.exec(r));
        return c.lastIndex = r.lastIndex, c;
      }
      function Od(r) {
        return a4 ? Y2(a4.call(r)) : {};
      }
      function P9(r, c) {
        var f = c ? yl(r.buffer) : r.buffer;
        return new r.constructor(f, r.byteOffset, r.length);
      }
      function B9(r, c) {
        if (r !== c) {
          var f = r !== n, y = r === null, L = r === r, I = st(r), U = c !== n, Y = c === null, l1 = c === c, _1 = st(c);
          if (!Y && !_1 && !I && r > c || I && U && l1 && !Y && !_1 || y && U && l1 || !f && l1 || !L)
            return 1;
          if (!y && !I && !_1 && r < c || _1 && f && L && !y && !I || Y && f && L || !U && L || !l1)
            return -1;
        }
        return 0;
      }
      function Nd(r, c, f) {
        for (var y = -1, L = r.criteria, I = c.criteria, U = L.length, Y = f.length; ++y < U; ) {
          var l1 = B9(L[y], I[y]);
          if (l1) {
            if (y >= Y)
              return l1;
            var _1 = f[y];
            return l1 * (_1 == "desc" ? -1 : 1);
          }
        }
        return r.index - c.index;
      }
      function V9(r, c, f, y) {
        for (var L = -1, I = r.length, U = f.length, Y = -1, l1 = c.length, _1 = R3(I - U, 0), q1 = u1(l1 + _1), x1 = !y; ++Y < l1; )
          q1[Y] = c[Y];
        for (; ++L < U; )
          (x1 || L < I) && (q1[f[L]] = r[L]);
        for (; _1--; )
          q1[Y++] = r[L++];
        return q1;
      }
      function R9(r, c, f, y) {
        for (var L = -1, I = r.length, U = -1, Y = f.length, l1 = -1, _1 = c.length, q1 = R3(I - Y, 0), x1 = u1(q1 + _1), P1 = !y; ++L < q1; )
          x1[L] = r[L];
        for (var W1 = L; ++l1 < _1; )
          x1[W1 + l1] = c[l1];
        for (; ++U < Y; )
          (P1 || L < I) && (x1[W1 + f[U]] = r[L++]);
        return x1;
      }
      function $e(r, c) {
        var f = -1, y = r.length;
        for (c || (c = u1(y)); ++f < y; )
          c[f] = r[f];
        return c;
      }
      function Yt(r, c, f, y) {
        var L = !f;
        f || (f = {});
        for (var I = -1, U = c.length; ++I < U; ) {
          var Y = c[I], l1 = y ? y(f[Y], r[Y], Y, f, r) : n;
          l1 === n && (l1 = r[Y]), L ? $1(f, Y, l1) : V1(f, Y, l1);
        }
        return f;
      }
      function Pd(r, c) {
        return Yt(r, Ll(r), c);
      }
      function Bd(r, c) {
        return Yt(r, Q9(r), c);
      }
      function Hi(r, c) {
        return function(f, y) {
          var L = p2(f) ? j8 : S1, I = c ? c() : {};
          return L(f, r, i2(y, 2), I);
        };
      }
      function T0(r) {
        return M2(function(c, f) {
          var y = -1, L = f.length, I = L > 1 ? f[L - 1] : n, U = L > 2 ? f[2] : n;
          for (I = r.length > 3 && typeof I == "function" ? (L--, I) : n, U && Ae(f[0], f[1], U) && (I = L < 3 ? n : I, L = 1), c = Y2(c); ++y < L; ) {
            var Y = f[y];
            Y && r(c, Y, y, I);
          }
          return c;
        });
      }
      function H9(r, c) {
        return function(f, y) {
          if (f == null)
            return f;
          if (!Ue(f))
            return r(f, y);
          for (var L = f.length, I = c ? L : -1, U = Y2(f); (c ? I-- : ++I < L) && y(U[I], I, U) !== !1; )
            ;
          return f;
        };
      }
      function D9(r) {
        return function(c, f, y) {
          for (var L = -1, I = Y2(c), U = y(c), Y = U.length; Y--; ) {
            var l1 = U[r ? Y : ++L];
            if (f(I[l1], l1, I) === !1)
              break;
          }
          return c;
        };
      }
      function Vd(r, c, f) {
        var y = c & M, L = Y6(r);
        function I() {
          var U = this && this !== D3 && this instanceof I ? L : r;
          return U.apply(y ? f : this, arguments);
        }
        return I;
      }
      function $9(r) {
        return function(c) {
          c = K2(c);
          var f = i4(c) ? it(c) : n, y = f ? f[0] : c.charAt(0), L = f ? y4(f, 1).join("") : c.slice(1);
          return y[r]() + L;
        };
      }
      function I0(r) {
        return function(c) {
          return Q4(H7(R7(c).replace(D5, "")), r, "");
        };
      }
      function Y6(r) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new r();
            case 1:
              return new r(c[0]);
            case 2:
              return new r(c[0], c[1]);
            case 3:
              return new r(c[0], c[1], c[2]);
            case 4:
              return new r(c[0], c[1], c[2], c[3]);
            case 5:
              return new r(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new r(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new r(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var f = E5(r.prototype), y = r.apply(f, c);
          return M3(y) ? y : f;
        };
      }
      function Rd(r, c, f) {
        var y = Y6(r);
        function L() {
          for (var I = arguments.length, U = u1(I), Y = I, l1 = O0(L); Y--; )
            U[Y] = arguments[Y];
          var _1 = I < 3 && U[0] !== l1 && U[I - 1] !== l1 ? [] : $t(U, l1);
          if (I -= _1.length, I < f)
            return Y9(
              r,
              c,
              Di,
              L.placeholder,
              n,
              U,
              _1,
              n,
              n,
              f - I
            );
          var q1 = this && this !== D3 && this instanceof L ? y : r;
          return fe(q1, this, U);
        }
        return L;
      }
      function U9(r) {
        return function(c, f, y) {
          var L = Y2(c);
          if (!Ue(c)) {
            var I = i2(f, 3);
            c = ee(c), f = function(Y) {
              return I(L[Y], Y, L);
            };
          }
          var U = r(c, f, y);
          return U > -1 ? L[I ? c[U] : U] : n;
        };
      }
      function j9(r) {
        return q4(function(c) {
          var f = c.length, y = f, L = Ke.prototype.thru;
          for (r && c.reverse(); y--; ) {
            var I = c[y];
            if (typeof I != "function")
              throw new ke(a);
            if (L && !U && Gi(I) == "wrapper")
              var U = new Ke([], !0);
          }
          for (y = U ? y : f; ++y < f; ) {
            I = c[y];
            var Y = Gi(I), l1 = Y == "wrapper" ? Ml(I) : n;
            l1 && Sl(l1[0]) && l1[1] == (R | x | F | V) && !l1[4].length && l1[9] == 1 ? U = U[Gi(l1[0])].apply(U, l1[3]) : U = I.length == 1 && Sl(I) ? U[Y]() : U.thru(I);
          }
          return function() {
            var _1 = arguments, q1 = _1[0];
            if (U && _1.length == 1 && p2(q1))
              return U.plant(q1).value();
            for (var x1 = 0, P1 = f ? c[x1].apply(this, _1) : q1; ++x1 < f; )
              P1 = c[x1].call(this, P1);
            return P1;
          };
        });
      }
      function Di(r, c, f, y, L, I, U, Y, l1, _1) {
        var q1 = c & R, x1 = c & M, P1 = c & z, W1 = c & (x | k), l2 = c & J, b2 = P1 ? n : Y6(r);
        function r2() {
          for (var T2 = arguments.length, B2 = u1(T2), lt = T2; lt--; )
            B2[lt] = arguments[lt];
          if (W1)
            var Fe = O0(r2), rt = In(B2, Fe);
          if (y && (B2 = V9(B2, y, L, W1)), I && (B2 = R9(B2, I, U, W1)), T2 -= rt, W1 && T2 < _1) {
            var N3 = $t(B2, Fe);
            return Y9(
              r,
              c,
              Di,
              r2.placeholder,
              f,
              B2,
              N3,
              Y,
              l1,
              _1 - T2
            );
          }
          var Ct = x1 ? f : this, b4 = P1 ? Ct[r] : r;
          return T2 = B2.length, Y ? B2 = af(B2, Y) : l2 && T2 > 1 && B2.reverse(), q1 && l1 < T2 && (B2.length = l1), this && this !== D3 && this instanceof r2 && (b4 = b2 || Y6(b4)), b4.apply(Ct, B2);
        }
        return r2;
      }
      function G9(r, c) {
        return function(f, y) {
          return o6(f, r, c(y), {});
        };
      }
      function $i(r, c) {
        return function(f, y) {
          var L;
          if (f === n && y === n)
            return c;
          if (f !== n && (L = f), y !== n) {
            if (L === n)
              return y;
            typeof f == "string" || typeof y == "string" ? (f = De(f), y = De(y)) : (f = ls(f), y = ls(y)), L = r(f, y);
          }
          return L;
        };
      }
      function _l(r) {
        return q4(function(c) {
          return c = t3(c, V3(i2())), M2(function(f) {
            var y = this;
            return r(c, function(L) {
              return fe(L, y, f);
            });
          });
        });
      }
      function Ui(r, c) {
        c = c === n ? " " : De(c);
        var f = c.length;
        if (f < 2)
          return f ? A0(c, r) : c;
        var y = A0(c, L0(r / R4(c)));
        return i4(c) ? y4(it(y), 0, r).join("") : y.slice(0, r);
      }
      function Hd(r, c, f, y) {
        var L = c & M, I = Y6(r);
        function U() {
          for (var Y = -1, l1 = arguments.length, _1 = -1, q1 = y.length, x1 = u1(q1 + l1), P1 = this && this !== D3 && this instanceof U ? I : r; ++_1 < q1; )
            x1[_1] = y[_1];
          for (; l1--; )
            x1[_1++] = arguments[++Y];
          return fe(P1, L ? f : this, x1);
        }
        return U;
      }
      function W9(r) {
        return function(c, f, y) {
          return y && typeof y != "number" && Ae(c, f, y) && (f = y = n), c = M4(c), f === n ? (f = c, c = 0) : f = M4(f), y = y === n ? c < f ? 1 : -1 : M4(y), ml(c, f, y, r);
        };
      }
      function ji(r) {
        return function(c, f) {
          return typeof c == "string" && typeof f == "string" || (c = ft(c), f = ft(f)), r(c, f);
        };
      }
      function Y9(r, c, f, y, L, I, U, Y, l1, _1) {
        var q1 = c & x, x1 = q1 ? U : n, P1 = q1 ? n : U, W1 = q1 ? I : n, l2 = q1 ? n : I;
        c |= q1 ? F : D, c &= ~(q1 ? D : F), c & b || (c &= ~(M | z));
        var b2 = [
          r,
          c,
          L,
          W1,
          x1,
          l2,
          P1,
          Y,
          l1,
          _1
        ], r2 = f.apply(n, b2);
        return Sl(r) && r7(r2, b2), r2.placeholder = y, a7(r2, r, c);
      }
      function ql(r) {
        var c = z3[r];
        return function(f, y) {
          if (f = ft(f), y = y == null ? 0 : ne(q2(y), 292), y && al(f)) {
            var L = (K2(f) + "e").split("e"), I = c(L[0] + "e" + (+L[1] + y));
            return L = (K2(I) + "e").split("e"), +(L[0] + "e" + (+L[1] - y));
          }
          return c(f);
        };
      }
      var Dd = S5 && 1 / M5(new S5([, -0]))[1] == h1 ? function(r) {
        return new S5(r);
      } : Dl;
      function X9(r) {
        return function(c) {
          var f = me(c);
          return f == y2 ? q0(c) : f == Z1 ? G8(c) : Ft(c, r(c));
        };
      }
      function _4(r, c, f, y, L, I, U, Y) {
        var l1 = c & z;
        if (!l1 && typeof r != "function")
          throw new ke(a);
        var _1 = y ? y.length : 0;
        if (_1 || (c &= ~(F | D), y = L = n), U = U === n ? U : R3(q2(U), 0), Y = Y === n ? Y : q2(Y), _1 -= L ? L.length : 0, c & D) {
          var q1 = y, x1 = L;
          y = L = n;
        }
        var P1 = l1 ? n : Ml(r), W1 = [
          r,
          c,
          f,
          y,
          L,
          q1,
          x1,
          I,
          U,
          Y
        ];
        if (P1 && sf(W1, P1), r = W1[0], c = W1[1], f = W1[2], y = W1[3], L = W1[4], Y = W1[9] = W1[9] === n ? l1 ? 0 : r.length : R3(W1[9] - _1, 0), !Y && c & (x | k) && (c &= ~(x | k)), !c || c == M)
          var l2 = Vd(r, c, f);
        else
          c == x || c == k ? l2 = Rd(r, c, Y) : (c == F || c == (M | F)) && !L.length ? l2 = Hd(r, c, f, y) : l2 = Di.apply(n, W1);
        var b2 = P1 ? Pi : r7;
        return a7(b2(l2, W1), r, c);
      }
      function K9(r, c, f, y) {
        return r === n || St(r, $3[f]) && !x2.call(y, f) ? c : r;
      }
      function Z9(r, c, f, y, L, I) {
        return M3(r) && M3(c) && (I.set(c, r), E0(r, c, n, Z9, I), I.delete(c)), r;
      }
      function $d(r) {
        return Z6(r) ? n : r;
      }
      function J9(r, c, f, y, L, I) {
        var U = f & _, Y = r.length, l1 = c.length;
        if (Y != l1 && !(U && l1 > Y))
          return !1;
        var _1 = I.get(r), q1 = I.get(c);
        if (_1 && q1)
          return _1 == c && q1 == r;
        var x1 = -1, P1 = !0, W1 = f & q ? new w() : n;
        for (I.set(r, c), I.set(c, r); ++x1 < Y; ) {
          var l2 = r[x1], b2 = c[x1];
          if (y)
            var r2 = U ? y(b2, l2, x1, c, r, I) : y(l2, b2, x1, r, c, I);
          if (r2 !== n) {
            if (r2)
              continue;
            P1 = !1;
            break;
          }
          if (W1) {
            if (!S(c, function(T2, B2) {
              if (!e5(W1, B2) && (l2 === T2 || L(l2, T2, f, y, I)))
                return W1.push(B2);
            })) {
              P1 = !1;
              break;
            }
          } else if (!(l2 === b2 || L(l2, b2, f, y, I))) {
            P1 = !1;
            break;
          }
        }
        return I.delete(r), I.delete(c), P1;
      }
      function Ud(r, c, f, y, L, I, U) {
        switch (f) {
          case c3:
            if (r.byteLength != c.byteLength || r.byteOffset != c.byteOffset)
              return !1;
            r = r.buffer, c = c.buffer;
          case n3:
            return !(r.byteLength != c.byteLength || !I(new i6(r), new i6(c)));
          case E1:
          case T1:
          case B1:
            return St(+r, +c);
          case X1:
            return r.name == c.name && r.message == c.message;
          case e2:
          case t2:
            return r == c + "";
          case y2:
            var Y = q0;
          case Z1:
            var l1 = y & _;
            if (Y || (Y = M5), r.size != c.size && !l1)
              return !1;
            var _1 = U.get(r);
            if (_1)
              return _1 == c;
            y |= q, U.set(r, c);
            var q1 = J9(Y(r), Y(c), y, L, I, U);
            return U.delete(r), q1;
          case S2:
            if (a4)
              return a4.call(r) == a4.call(c);
        }
        return !1;
      }
      function jd(r, c, f, y, L, I) {
        var U = f & _, Y = wl(r), l1 = Y.length, _1 = wl(c), q1 = _1.length;
        if (l1 != q1 && !U)
          return !1;
        for (var x1 = l1; x1--; ) {
          var P1 = Y[x1];
          if (!(U ? P1 in c : x2.call(c, P1)))
            return !1;
        }
        var W1 = I.get(r), l2 = I.get(c);
        if (W1 && l2)
          return W1 == c && l2 == r;
        var b2 = !0;
        I.set(r, c), I.set(c, r);
        for (var r2 = U; ++x1 < l1; ) {
          P1 = Y[x1];
          var T2 = r[P1], B2 = c[P1];
          if (y)
            var lt = U ? y(B2, T2, P1, c, r, I) : y(T2, B2, P1, r, c, I);
          if (!(lt === n ? T2 === B2 || L(T2, B2, f, y, I) : lt)) {
            b2 = !1;
            break;
          }
          r2 || (r2 = P1 == "constructor");
        }
        if (b2 && !r2) {
          var Fe = r.constructor, rt = c.constructor;
          Fe != rt && "constructor" in r && "constructor" in c && !(typeof Fe == "function" && Fe instanceof Fe && typeof rt == "function" && rt instanceof rt) && (b2 = !1);
        }
        return I.delete(r), I.delete(c), b2;
      }
      function q4(r) {
        return kl(s7(r, n, f7), r + "");
      }
      function wl(r) {
        return Gt(r, ee, Ll);
      }
      function zl(r) {
        return Gt(r, je, Q9);
      }
      var Ml = U6 ? function(r) {
        return U6.get(r);
      } : Dl;
      function Gi(r) {
        for (var c = r.name + "", f = C5[c], y = x2.call(C5, c) ? f.length : 0; y--; ) {
          var L = f[y], I = L.func;
          if (I == null || I == r)
            return L.name;
        }
        return c;
      }
      function O0(r) {
        var c = x2.call(A, "placeholder") ? A : r;
        return c.placeholder;
      }
      function i2() {
        var r = A.iteratee || Rl;
        return r = r === Rl ? es : r, arguments.length ? r(arguments[0], arguments[1]) : r;
      }
      function Wi(r, c) {
        var f = r.__data__;
        return Qd(c) ? f[typeof c == "string" ? "string" : "hash"] : f.map;
      }
      function bl(r) {
        for (var c = ee(r), f = c.length; f--; ) {
          var y = c[f], L = r[y];
          c[f] = [y, L, n7(L)];
        }
        return c;
      }
      function A5(r, c) {
        var f = C4(r, c);
        return c6(f) ? f : n;
      }
      function Gd(r) {
        var c = x2.call(r, k4), f = r[k4];
        try {
          r[k4] = n;
          var y = !0;
        } catch {
        }
        var L = n5.call(r);
        return y && (c ? r[k4] = f : delete r[k4]), L;
      }
      var Ll = s6 ? function(r) {
        return r == null ? [] : (r = Y2(r), At(s6(r), function(c) {
          return m4.call(r, c);
        }));
      } : $l, Q9 = s6 ? function(r) {
        for (var c = []; r; )
          xt(c, Ll(r)), r = b0(r);
        return c;
      } : $l, me = A3;
      ($6 && me(new $6(new ArrayBuffer(1))) != c3 || H4 && me(new H4()) != y2 || Ti && me(Ti.resolve()) != w2 || S5 && me(new S5()) != Z1 || Y5 && me(new Y5()) != E2) && (me = function(r) {
        var c = A3(r), f = c == _2 ? r.constructor : n, y = f ? F5(f) : "";
        if (y)
          switch (y) {
            case M9:
              return c3;
            case l6:
              return y2;
            case k5:
              return w2;
            case C0:
              return Z1;
            case b9:
              return E2;
          }
        return c;
      });
      function Wd(r, c, f) {
        for (var y = -1, L = f.length; ++y < L; ) {
          var I = f[y], U = I.size;
          switch (I.type) {
            case "drop":
              r += U;
              break;
            case "dropRight":
              c -= U;
              break;
            case "take":
              c = ne(c, r + U);
              break;
            case "takeRight":
              r = R3(r, c - U);
              break;
          }
        }
        return { start: r, end: c };
      }
      function Yd(r) {
        var c = r.match(v4);
        return c ? c[1].split(wn) : [];
      }
      function e7(r, c, f) {
        c = Wt(c, r);
        for (var y = -1, L = c.length, I = !1; ++y < L; ) {
          var U = Xt(c[y]);
          if (!(I = r != null && f(r, U)))
            break;
          r = r[U];
        }
        return I || ++y != L ? I : (L = r == null ? 0 : r.length, !!L && e8(L) && w4(U, L) && (p2(r) || T5(r)));
      }
      function Xd(r) {
        var c = r.length, f = new r.constructor(c);
        return c && typeof r[0] == "string" && x2.call(r, "index") && (f.index = r.index, f.input = r.input), f;
      }
      function t7(r) {
        return typeof r.constructor == "function" && !X6(r) ? E5(b0(r)) : {};
      }
      function Kd(r, c, f) {
        var y = r.constructor;
        switch (c) {
          case n3:
            return yl(r);
          case E1:
          case T1:
            return new y(+r);
          case c3:
            return Td(r, f);
          case G2:
          case u3:
          case g2:
          case Oe:
          case q3:
          case ht:
          case E3:
          case j3:
          case z2:
            return P9(r, f);
          case y2:
            return new y();
          case B1:
          case t2:
            return new y(r);
          case e2:
            return Id(r);
          case Z1:
            return new y();
          case S2:
            return Od(r);
        }
      }
      function Zd(r, c) {
        var f = c.length;
        if (!f)
          return r;
        var y = f - 1;
        return c[y] = (f > 1 ? "& " : "") + c[y], c = c.join(f > 2 ? ", " : " "), r.replace(oe, `{
/* [wrapped with ` + c + `] */
`);
      }
      function Jd(r) {
        return p2(r) || T5(r) || !!(Vn && r && r[Vn]);
      }
      function w4(r, c) {
        var f = typeof r;
        return c = c ?? c1, !!c && (f == "number" || f != "symbol" && Mn.test(r)) && r > -1 && r % 1 == 0 && r < c;
      }
      function Ae(r, c, f) {
        if (!M3(f))
          return !1;
        var y = typeof c;
        return (y == "number" ? Ue(f) && w4(c, f.length) : y == "string" && c in f) ? St(f[c], r) : !1;
      }
      function xl(r, c) {
        if (p2(r))
          return !1;
        var f = typeof r;
        return f == "number" || f == "symbol" || f == "boolean" || r == null || st(r) ? !0 : ut.test(r) || !tt.test(r) || c != null && r in Y2(c);
      }
      function Qd(r) {
        var c = typeof r;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? r !== "__proto__" : r === null;
      }
      function Sl(r) {
        var c = Gi(r), f = A[c];
        if (typeof f != "function" || !(c in A2.prototype))
          return !1;
        if (r === f)
          return !0;
        var y = Ml(f);
        return !!y && r === y[0];
      }
      function ef(r) {
        return !!G5 && G5 in r;
      }
      var tf = te ? z4 : Ul;
      function X6(r) {
        var c = r && r.constructor, f = typeof c == "function" && c.prototype || $3;
        return r === f;
      }
      function n7(r) {
        return r === r && !M3(r);
      }
      function i7(r, c) {
        return function(f) {
          return f == null ? !1 : f[r] === c && (c !== n || r in Y2(f));
        };
      }
      function nf(r) {
        var c = Ji(r, function(y) {
          return f.size === u && f.clear(), y;
        }), f = c.cache;
        return c;
      }
      function sf(r, c) {
        var f = r[1], y = c[1], L = f | y, I = L < (M | z | R), U = y == R && f == x || y == R && f == V && r[7].length <= c[8] || y == (R | V) && c[7].length <= c[8] && f == x;
        if (!(I || U))
          return r;
        y & M && (r[2] = c[2], L |= f & M ? 0 : b);
        var Y = c[3];
        if (Y) {
          var l1 = r[3];
          r[3] = l1 ? V9(l1, Y, c[4]) : Y, r[4] = l1 ? $t(r[3], d) : c[4];
        }
        return Y = c[5], Y && (l1 = r[5], r[5] = l1 ? R9(l1, Y, c[6]) : Y, r[6] = l1 ? $t(r[5], d) : c[6]), Y = c[7], Y && (r[7] = Y), y & R && (r[8] = r[8] == null ? c[8] : ne(r[8], c[8])), r[9] == null && (r[9] = c[9]), r[0] = c[0], r[1] = L, r;
      }
      function lf(r) {
        var c = [];
        if (r != null)
          for (var f in Y2(r))
            c.push(f);
        return c;
      }
      function rf(r) {
        return n5.call(r);
      }
      function s7(r, c, f) {
        return c = R3(c === n ? r.length - 1 : c, 0), function() {
          for (var y = arguments, L = -1, I = R3(y.length - c, 0), U = u1(I); ++L < I; )
            U[L] = y[c + L];
          L = -1;
          for (var Y = u1(c + 1); ++L < c; )
            Y[L] = y[L];
          return Y[c] = f(U), fe(r, this, Y);
        };
      }
      function l7(r, c) {
        return c.length < 2 ? r : pe(r, Je(c, 0, -1));
      }
      function af(r, c) {
        for (var f = r.length, y = ne(c.length, f), L = $e(r); y--; ) {
          var I = c[y];
          r[y] = w4(I, f) ? L[I] : n;
        }
        return r;
      }
      function Cl(r, c) {
        if (!(c === "constructor" && typeof r[c] == "function") && c != "__proto__")
          return r[c];
      }
      var r7 = o7(Pi), K6 = Ir || function(r, c) {
        return D3.setTimeout(r, c);
      }, kl = o7(v6);
      function a7(r, c, f) {
        var y = c + "";
        return kl(r, Zd(y, of(Yd(y), f)));
      }
      function o7(r) {
        var c = 0, f = 0;
        return function() {
          var y = w9(), L = G - (y - f);
          if (f = y, L > 0) {
            if (++c >= O)
              return arguments[0];
          } else
            c = 0;
          return r.apply(n, arguments);
        };
      }
      function Yi(r, c) {
        var f = -1, y = r.length, L = y - 1;
        for (c = c === n ? y : c; ++f < c; ) {
          var I = f6(f, L), U = r[I];
          r[I] = r[f], r[f] = U;
        }
        return r.length = c, r;
      }
      var c7 = nf(function(r) {
        var c = [];
        return r.charCodeAt(0) === 46 && c.push(""), r.replace(D2, function(f, y, L, I) {
          c.push(L ? I.replace(q5, "$1") : y || f);
        }), c;
      });
      function Xt(r) {
        if (typeof r == "string" || st(r))
          return r;
        var c = r + "";
        return c == "0" && 1 / r == -h1 ? "-0" : c;
      }
      function F5(r) {
        if (r != null) {
          try {
            return Ee.call(r);
          } catch {
          }
          try {
            return r + "";
          } catch {
          }
        }
        return "";
      }
      function of(r, c) {
        return qe(n1, function(f) {
          var y = "_." + f[0];
          c & f[1] && !_0(r, y) && r.push(y);
        }), r.sort();
      }
      function h7(r) {
        if (r instanceof A2)
          return r.clone();
        var c = new Ke(r.__wrapped__, r.__chain__);
        return c.__actions__ = $e(r.__actions__), c.__index__ = r.__index__, c.__values__ = r.__values__, c;
      }
      function cf(r, c, f) {
        (f ? Ae(r, c, f) : c === n) ? c = 1 : c = R3(q2(c), 0);
        var y = r == null ? 0 : r.length;
        if (!y || c < 1)
          return [];
        for (var L = 0, I = 0, U = u1(L0(y / c)); L < y; )
          U[I++] = Je(r, L, L += c);
        return U;
      }
      function hf(r) {
        for (var c = -1, f = r == null ? 0 : r.length, y = 0, L = []; ++c < f; ) {
          var I = r[c];
          I && (L[y++] = I);
        }
        return L;
      }
      function uf() {
        var r = arguments.length;
        if (!r)
          return [];
        for (var c = u1(r - 1), f = arguments[0], y = r; y--; )
          c[y - 1] = arguments[y];
        return xt(p2(f) ? $e(f) : [f], i3(c, 1));
      }
      var df = M2(function(r, c) {
        return O3(r) ? x3(r, i3(c, 1, O3, !0)) : [];
      }), ff = M2(function(r, c) {
        var f = dt(c);
        return O3(f) && (f = n), O3(r) ? x3(r, i3(c, 1, O3, !0), i2(f, 2)) : [];
      }), vf = M2(function(r, c) {
        var f = dt(c);
        return O3(f) && (f = n), O3(r) ? x3(r, i3(c, 1, O3, !0), n, f) : [];
      });
      function pf(r, c, f) {
        var y = r == null ? 0 : r.length;
        return y ? (c = f || c === n ? 1 : q2(c), Je(r, c < 0 ? 0 : c, y)) : [];
      }
      function mf(r, c, f) {
        var y = r == null ? 0 : r.length;
        return y ? (c = f || c === n ? 1 : q2(c), c = y - c, Je(r, 0, c < 0 ? 0 : c)) : [];
      }
      function gf(r, c) {
        return r && r.length ? F0(r, i2(c, 3), !0, !0) : [];
      }
      function yf(r, c) {
        return r && r.length ? F0(r, i2(c, 3), !0) : [];
      }
      function _f(r, c, f, y) {
        var L = r == null ? 0 : r.length;
        return L ? (f && typeof f != "number" && Ae(r, c, f) && (f = 0, y = L), zt(r, c, f, y)) : [];
      }
      function u7(r, c, f) {
        var y = r == null ? 0 : r.length;
        if (!y)
          return -1;
        var L = f == null ? 0 : q2(f);
        return L < 0 && (L = R3(y + L, 0)), H1(r, i2(c, 3), L);
      }
      function d7(r, c, f) {
        var y = r == null ? 0 : r.length;
        if (!y)
          return -1;
        var L = y - 1;
        return f !== n && (L = q2(f), L = f < 0 ? R3(y + L, 0) : ne(L, y - 1)), H1(r, i2(c, 3), L, !0);
      }
      function f7(r) {
        var c = r == null ? 0 : r.length;
        return c ? i3(r, 1) : [];
      }
      function qf(r) {
        var c = r == null ? 0 : r.length;
        return c ? i3(r, h1) : [];
      }
      function wf(r, c) {
        var f = r == null ? 0 : r.length;
        return f ? (c = c === n ? 1 : q2(c), i3(r, c)) : [];
      }
      function zf(r) {
        for (var c = -1, f = r == null ? 0 : r.length, y = {}; ++c < f; ) {
          var L = r[c];
          y[L[0]] = L[1];
        }
        return y;
      }
      function v7(r) {
        return r && r.length ? r[0] : n;
      }
      function Mf(r, c, f) {
        var y = r == null ? 0 : r.length;
        if (!y)
          return -1;
        var L = f == null ? 0 : q2(f);
        return L < 0 && (L = R3(y + L, 0)), J1(r, c, L);
      }
      function bf(r) {
        var c = r == null ? 0 : r.length;
        return c ? Je(r, 0, -1) : [];
      }
      var Lf = M2(function(r) {
        var c = t3(r, l5);
        return c.length && c[0] === r[0] ? X5(c) : [];
      }), xf = M2(function(r) {
        var c = dt(r), f = t3(r, l5);
        return c === dt(f) ? c = n : f.pop(), f.length && f[0] === r[0] ? X5(f, i2(c, 2)) : [];
      }), Sf = M2(function(r) {
        var c = dt(r), f = t3(r, l5);
        return c = typeof c == "function" ? c : n, c && f.pop(), f.length && f[0] === r[0] ? X5(f, n, c) : [];
      });
      function Cf(r, c) {
        return r == null ? "" : q9.call(r, c);
      }
      function dt(r) {
        var c = r == null ? 0 : r.length;
        return c ? r[c - 1] : n;
      }
      function kf(r, c, f) {
        var y = r == null ? 0 : r.length;
        if (!y)
          return -1;
        var L = y;
        return f !== n && (L = q2(f), L = L < 0 ? R3(y + L, 0) : ne(L, y - 1)), c === c ? Fi(r, c, L) : H1(r, Z2, L, !0);
      }
      function Ef(r, c) {
        return r && r.length ? vl(r, q2(c)) : n;
      }
      var Af = M2(p7);
      function p7(r, c) {
        return r && r.length && c && c.length ? Hn(r, c) : r;
      }
      function Ff(r, c, f) {
        return r && r.length && c && c.length ? Hn(r, c, i2(f, 2)) : r;
      }
      function Tf(r, c, f) {
        return r && r.length && c && c.length ? Hn(r, c, n, f) : r;
      }
      var If = q4(function(r, c) {
        var f = r == null ? 0 : r.length, y = C2(r, c);
        return is(r, t3(c, function(L) {
          return w4(L, f) ? +L : L;
        }).sort(B9)), y;
      });
      function Of(r, c) {
        var f = [];
        if (!(r && r.length))
          return f;
        var y = -1, L = [], I = r.length;
        for (c = i2(c, 3); ++y < I; ) {
          var U = r[y];
          c(U, y, r) && (f.push(U), L.push(y));
        }
        return is(r, L), f;
      }
      function El(r) {
        return r == null ? r : cl.call(r);
      }
      function Nf(r, c, f) {
        var y = r == null ? 0 : r.length;
        return y ? (f && typeof f != "number" && Ae(r, c, f) ? (c = 0, f = y) : (c = c == null ? 0 : q2(c), f = f === n ? y : q2(f)), Je(r, c, f)) : [];
      }
      function Pf(r, c) {
        return p6(r, c);
      }
      function Bf(r, c, f) {
        return Z5(r, c, i2(f, 2));
      }
      function Vf(r, c) {
        var f = r == null ? 0 : r.length;
        if (f) {
          var y = p6(r, c);
          if (y < f && St(r[y], c))
            return y;
        }
        return -1;
      }
      function Rf(r, c) {
        return p6(r, c, !0);
      }
      function Hf(r, c, f) {
        return Z5(r, c, i2(f, 2), !0);
      }
      function Df(r, c) {
        var f = r == null ? 0 : r.length;
        if (f) {
          var y = p6(r, c, !0) - 1;
          if (St(r[y], c))
            return y;
        }
        return -1;
      }
      function $f(r) {
        return r && r.length ? gl(r) : [];
      }
      function Uf(r, c) {
        return r && r.length ? gl(r, i2(c, 2)) : [];
      }
      function jf(r) {
        var c = r == null ? 0 : r.length;
        return c ? Je(r, 1, c) : [];
      }
      function Gf(r, c, f) {
        return r && r.length ? (c = f || c === n ? 1 : q2(c), Je(r, 0, c < 0 ? 0 : c)) : [];
      }
      function Wf(r, c, f) {
        var y = r == null ? 0 : r.length;
        return y ? (c = f || c === n ? 1 : q2(c), c = y - c, Je(r, c < 0 ? 0 : c, y)) : [];
      }
      function Yf(r, c) {
        return r && r.length ? F0(r, i2(c, 3), !1, !0) : [];
      }
      function Xf(r, c) {
        return r && r.length ? F0(r, i2(c, 3)) : [];
      }
      var Kf = M2(function(r) {
        return h4(i3(r, 1, O3, !0));
      }), Zf = M2(function(r) {
        var c = dt(r);
        return O3(c) && (c = n), h4(i3(r, 1, O3, !0), i2(c, 2));
      }), Jf = M2(function(r) {
        var c = dt(r);
        return c = typeof c == "function" ? c : n, h4(i3(r, 1, O3, !0), n, c);
      });
      function Qf(r) {
        return r && r.length ? h4(r) : [];
      }
      function ev(r, c) {
        return r && r.length ? h4(r, i2(c, 2)) : [];
      }
      function tv(r, c) {
        return c = typeof c == "function" ? c : n, r && r.length ? h4(r, n, c) : [];
      }
      function Al(r) {
        if (!(r && r.length))
          return [];
        var c = 0;
        return r = At(r, function(f) {
          if (O3(f))
            return c = R3(f.length, c), !0;
        }), wt(c, function(f) {
          return t3(r, y3(f));
        });
      }
      function m7(r, c) {
        if (!(r && r.length))
          return [];
        var f = Al(r);
        return c == null ? f : t3(f, function(y) {
          return fe(c, n, y);
        });
      }
      var nv = M2(function(r, c) {
        return O3(r) ? x3(r, c) : [];
      }), iv = M2(function(r) {
        return D4(At(r, O3));
      }), sv = M2(function(r) {
        var c = dt(r);
        return O3(c) && (c = n), D4(At(r, O3), i2(c, 2));
      }), lv = M2(function(r) {
        var c = dt(r);
        return c = typeof c == "function" ? c : n, D4(At(r, O3), n, c);
      }), rv = M2(Al);
      function av(r, c) {
        return J5(r || [], c || [], V1);
      }
      function ov(r, c) {
        return J5(r || [], c || [], K5);
      }
      var cv = M2(function(r) {
        var c = r.length, f = c > 1 ? r[c - 1] : n;
        return f = typeof f == "function" ? (r.pop(), f) : n, m7(r, f);
      });
      function g7(r) {
        var c = A(r);
        return c.__chain__ = !0, c;
      }
      function hv(r, c) {
        return c(r), r;
      }
      function Xi(r, c) {
        return c(r);
      }
      var uv = q4(function(r) {
        var c = r.length, f = c ? r[0] : 0, y = this.__wrapped__, L = function(I) {
          return C2(I, r);
        };
        return c > 1 || this.__actions__.length || !(y instanceof A2) || !w4(f) ? this.thru(L) : (y = y.slice(f, +f + (c ? 1 : 0)), y.__actions__.push({
          func: Xi,
          args: [L],
          thisArg: n
        }), new Ke(y, this.__chain__).thru(function(I) {
          return c && !I.length && I.push(n), I;
        }));
      });
      function dv() {
        return g7(this);
      }
      function fv() {
        return new Ke(this.value(), this.__chain__);
      }
      function vv() {
        this.__values__ === n && (this.__values__ = A7(this.value()));
        var r = this.__index__ >= this.__values__.length, c = r ? n : this.__values__[this.__index__++];
        return { done: r, value: c };
      }
      function pv() {
        return this;
      }
      function mv(r) {
        for (var c, f = this; f instanceof a6; ) {
          var y = h7(f);
          y.__index__ = 0, y.__values__ = n, c ? L.__wrapped__ = y : c = y;
          var L = y;
          f = f.__wrapped__;
        }
        return L.__wrapped__ = r, c;
      }
      function gv() {
        var r = this.__wrapped__;
        if (r instanceof A2) {
          var c = r;
          return this.__actions__.length && (c = new A2(this)), c = c.reverse(), c.__actions__.push({
            func: Xi,
            args: [El],
            thisArg: n
          }), new Ke(c, this.__chain__);
        }
        return this.thru(El);
      }
      function yv() {
        return Dn(this.__wrapped__, this.__actions__);
      }
      var _v = Hi(function(r, c, f) {
        x2.call(r, f) ? ++r[f] : $1(r, f, 1);
      });
      function qv(r, c, f) {
        var y = p2(r) ? R6 : we;
        return f && Ae(r, c, f) && (c = n), y(r, i2(c, 3));
      }
      function wv(r, c) {
        var f = p2(r) ? At : c4;
        return f(r, i2(c, 3));
      }
      var zv = U9(u7), Mv = U9(d7);
      function bv(r, c) {
        return i3(Ki(r, c), 1);
      }
      function Lv(r, c) {
        return i3(Ki(r, c), h1);
      }
      function xv(r, c, f) {
        return f = f === n ? 1 : q2(f), i3(Ki(r, c), f);
      }
      function y7(r, c) {
        var f = p2(r) ? qe : a3;
        return f(r, i2(c, 3));
      }
      function _7(r, c) {
        var f = p2(r) ? Ci : ve;
        return f(r, i2(c, 3));
      }
      var Sv = Hi(function(r, c, f) {
        x2.call(r, f) ? r[f].push(c) : $1(r, f, [c]);
      });
      function Cv(r, c, f, y) {
        r = Ue(r) ? r : P0(r), f = f && !y ? q2(f) : 0;
        var L = r.length;
        return f < 0 && (f = R3(L + f, 0)), t8(r) ? f <= L && r.indexOf(c, f) > -1 : !!L && J1(r, c, f) > -1;
      }
      var kv = M2(function(r, c, f) {
        var y = -1, L = typeof c == "function", I = Ue(r) ? u1(r.length) : [];
        return a3(r, function(U) {
          I[++y] = L ? fe(c, U, f) : ce(U, c, f);
        }), I;
      }), Ev = Hi(function(r, c, f) {
        $1(r, f, c);
      });
      function Ki(r, c) {
        var f = p2(r) ? t3 : G6;
        return f(r, i2(c, 3));
      }
      function Av(r, c, f, y) {
        return r == null ? [] : (p2(c) || (c = c == null ? [] : [c]), f = y ? n : f, p2(f) || (f = f == null ? [] : [f]), pl(r, c, f));
      }
      var Fv = Hi(function(r, c, f) {
        r[f ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      });
      function Tv(r, c, f) {
        var y = p2(r) ? Q4 : He, L = arguments.length < 3;
        return y(r, i2(c, 4), f, L, a3);
      }
      function Iv(r, c, f) {
        var y = p2(r) ? ki : He, L = arguments.length < 3;
        return y(r, i2(c, 4), f, L, ve);
      }
      function Ov(r, c) {
        var f = p2(r) ? At : c4;
        return f(r, Qi(i2(c, 3)));
      }
      function Nv(r) {
        var c = p2(r) ? I1 : O9;
        return c(r);
      }
      function Pv(r, c, f) {
        (f ? Ae(r, c, f) : c === n) ? c = 1 : c = q2(c);
        var y = p2(r) ? O1 : ss;
        return y(r, c);
      }
      function Bv(r) {
        var c = p2(r) ? k1 : $r;
        return c(r);
      }
      function Vv(r) {
        if (r == null)
          return 0;
        if (Ue(r))
          return t8(r) ? R4(r) : r.length;
        var c = me(r);
        return c == y2 || c == Z1 ? r.size : h6(r).length;
      }
      function Rv(r, c, f) {
        var y = p2(r) ? S : N9;
        return f && Ae(r, c, f) && (c = n), y(r, i2(c, 3));
      }
      var Hv = M2(function(r, c) {
        if (r == null)
          return [];
        var f = c.length;
        return f > 1 && Ae(r, c[0], c[1]) ? c = [] : f > 2 && Ae(c[0], c[1], c[2]) && (c = [c[0]]), pl(r, i3(c, 1), []);
      }), Zi = ll || function() {
        return D3.Date.now();
      };
      function Dv(r, c) {
        if (typeof c != "function")
          throw new ke(a);
        return r = q2(r), function() {
          if (--r < 1)
            return c.apply(this, arguments);
        };
      }
      function q7(r, c, f) {
        return c = f ? n : c, c = r && c == null ? r.length : c, _4(r, R, n, n, n, n, c);
      }
      function w7(r, c) {
        var f;
        if (typeof c != "function")
          throw new ke(a);
        return r = q2(r), function() {
          return --r > 0 && (f = c.apply(this, arguments)), r <= 1 && (c = n), f;
        };
      }
      var Fl = M2(function(r, c, f) {
        var y = M;
        if (f.length) {
          var L = $t(f, O0(Fl));
          y |= F;
        }
        return _4(r, y, c, f, L);
      }), z7 = M2(function(r, c, f) {
        var y = M | z;
        if (f.length) {
          var L = $t(f, O0(z7));
          y |= F;
        }
        return _4(c, y, r, f, L);
      });
      function M7(r, c, f) {
        c = f ? n : c;
        var y = _4(r, x, n, n, n, n, n, c);
        return y.placeholder = M7.placeholder, y;
      }
      function b7(r, c, f) {
        c = f ? n : c;
        var y = _4(r, k, n, n, n, n, n, c);
        return y.placeholder = b7.placeholder, y;
      }
      function L7(r, c, f) {
        var y, L, I, U, Y, l1, _1 = 0, q1 = !1, x1 = !1, P1 = !0;
        if (typeof r != "function")
          throw new ke(a);
        c = ft(c) || 0, M3(f) && (q1 = !!f.leading, x1 = "maxWait" in f, I = x1 ? R3(ft(f.maxWait) || 0, c) : I, P1 = "trailing" in f ? !!f.trailing : P1);
        function W1(N3) {
          var Ct = y, b4 = L;
          return y = L = n, _1 = N3, U = r.apply(b4, Ct), U;
        }
        function l2(N3) {
          return _1 = N3, Y = K6(T2, c), q1 ? W1(N3) : U;
        }
        function b2(N3) {
          var Ct = N3 - l1, b4 = N3 - _1, U7 = c - Ct;
          return x1 ? ne(U7, I - b4) : U7;
        }
        function r2(N3) {
          var Ct = N3 - l1, b4 = N3 - _1;
          return l1 === n || Ct >= c || Ct < 0 || x1 && b4 >= I;
        }
        function T2() {
          var N3 = Zi();
          if (r2(N3))
            return B2(N3);
          Y = K6(T2, b2(N3));
        }
        function B2(N3) {
          return Y = n, P1 && y ? W1(N3) : (y = L = n, U);
        }
        function lt() {
          Y !== n && Vi(Y), _1 = 0, y = l1 = L = Y = n;
        }
        function Fe() {
          return Y === n ? U : B2(Zi());
        }
        function rt() {
          var N3 = Zi(), Ct = r2(N3);
          if (y = arguments, L = this, l1 = N3, Ct) {
            if (Y === n)
              return l2(l1);
            if (x1)
              return Vi(Y), Y = K6(T2, c), W1(l1);
          }
          return Y === n && (Y = K6(T2, c)), U;
        }
        return rt.cancel = lt, rt.flush = Fe, rt;
      }
      var $v = M2(function(r, c) {
        return ie(r, 1, c);
      }), Uv = M2(function(r, c, f) {
        return ie(r, ft(c) || 0, f);
      });
      function jv(r) {
        return _4(r, J);
      }
      function Ji(r, c) {
        if (typeof r != "function" || c != null && typeof c != "function")
          throw new ke(a);
        var f = function() {
          var y = arguments, L = c ? c.apply(this, y) : y[0], I = f.cache;
          if (I.has(L))
            return I.get(L);
          var U = r.apply(this, y);
          return f.cache = I.set(L, U) || I, U;
        };
        return f.cache = new (Ji.Cache || Ot)(), f;
      }
      Ji.Cache = Ot;
      function Qi(r) {
        if (typeof r != "function")
          throw new ke(a);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !r.call(this);
            case 1:
              return !r.call(this, c[0]);
            case 2:
              return !r.call(this, c[0], c[1]);
            case 3:
              return !r.call(this, c[0], c[1], c[2]);
          }
          return !r.apply(this, c);
        };
      }
      function Gv(r) {
        return w7(2, r);
      }
      var Wv = Ur(function(r, c) {
        c = c.length == 1 && p2(c[0]) ? t3(c[0], V3(i2())) : t3(i3(c, 1), V3(i2()));
        var f = c.length;
        return M2(function(y) {
          for (var L = -1, I = ne(y.length, f); ++L < I; )
            y[L] = c[L].call(this, y[L]);
          return fe(r, this, y);
        });
      }), Tl = M2(function(r, c) {
        var f = $t(c, O0(Tl));
        return _4(r, F, n, c, f);
      }), x7 = M2(function(r, c) {
        var f = $t(c, O0(x7));
        return _4(r, D, n, c, f);
      }), Yv = q4(function(r, c) {
        return _4(r, V, n, n, n, c);
      });
      function Xv(r, c) {
        if (typeof r != "function")
          throw new ke(a);
        return c = c === n ? c : q2(c), M2(r, c);
      }
      function Kv(r, c) {
        if (typeof r != "function")
          throw new ke(a);
        return c = c == null ? 0 : R3(q2(c), 0), M2(function(f) {
          var y = f[c], L = y4(f, 0, c);
          return y && xt(L, y), fe(r, this, L);
        });
      }
      function Zv(r, c, f) {
        var y = !0, L = !0;
        if (typeof r != "function")
          throw new ke(a);
        return M3(f) && (y = "leading" in f ? !!f.leading : y, L = "trailing" in f ? !!f.trailing : L), L7(r, c, {
          leading: y,
          maxWait: c,
          trailing: L
        });
      }
      function Jv(r) {
        return q7(r, 1);
      }
      function Qv(r, c) {
        return Tl(m6(c), r);
      }
      function ep() {
        if (!arguments.length)
          return [];
        var r = arguments[0];
        return p2(r) ? r : [r];
      }
      function tp(r) {
        return k2(r, p);
      }
      function np(r, c) {
        return c = typeof c == "function" ? c : n, k2(r, p, c);
      }
      function ip(r) {
        return k2(r, v | p);
      }
      function sp(r, c) {
        return c = typeof c == "function" ? c : n, k2(r, v | p, c);
      }
      function lp(r, c) {
        return c == null || Q3(r, c, ee(c));
      }
      function St(r, c) {
        return r === c || r !== r && c !== c;
      }
      var rp = ji(A4), ap = ji(function(r, c) {
        return r >= c;
      }), T5 = Oi(function() {
        return arguments;
      }()) ? Oi : function(r) {
        return S3(r) && x2.call(r, "callee") && !m4.call(r, "callee");
      }, p2 = u1.isArray, op = B6 ? V3(B6) : Rr;
      function Ue(r) {
        return r != null && e8(r.length) && !z4(r);
      }
      function O3(r) {
        return S3(r) && Ue(r);
      }
      function cp(r) {
        return r === !0 || r === !1 || S3(r) && A3(r) == E1;
      }
      var $4 = rl || Ul, hp = y0 ? V3(y0) : Hr;
      function up(r) {
        return S3(r) && r.nodeType === 1 && !Z6(r);
      }
      function dp(r) {
        if (r == null)
          return !0;
        if (Ue(r) && (p2(r) || typeof r == "string" || typeof r.splice == "function" || $4(r) || N0(r) || T5(r)))
          return !r.length;
        var c = me(r);
        if (c == y2 || c == Z1)
          return !r.size;
        if (X6(r))
          return !h6(r).length;
        for (var f in r)
          if (x2.call(r, f))
            return !1;
        return !0;
      }
      function fp(r, c) {
        return s5(r, c);
      }
      function vp(r, c, f) {
        f = typeof f == "function" ? f : n;
        var y = f ? f(r, c) : n;
        return y === n ? s5(r, c, n, f) : !!y;
      }
      function Il(r) {
        if (!S3(r))
          return !1;
        var c = A3(r);
        return c == X1 || c == n2 || typeof r.message == "string" && typeof r.name == "string" && !Z6(r);
      }
      function pp(r) {
        return typeof r == "number" && al(r);
      }
      function z4(r) {
        if (!M3(r))
          return !1;
        var c = A3(r);
        return c == a2 || c == d2 || c == C1 || c == K1;
      }
      function S7(r) {
        return typeof r == "number" && r == q2(r);
      }
      function e8(r) {
        return typeof r == "number" && r > -1 && r % 1 == 0 && r <= c1;
      }
      function M3(r) {
        var c = typeof r;
        return r != null && (c == "object" || c == "function");
      }
      function S3(r) {
        return r != null && typeof r == "object";
      }
      var C7 = xi ? V3(xi) : J8;
      function mp(r, c) {
        return r === c || g4(r, c, bl(c));
      }
      function gp(r, c, f) {
        return f = typeof f == "function" ? f : n, g4(r, c, bl(c), f);
      }
      function yp(r) {
        return k7(r) && r != +r;
      }
      function _p(r) {
        if (tf(r))
          throw new s2(l);
        return c6(r);
      }
      function qp(r) {
        return r === null;
      }
      function wp(r) {
        return r == null;
      }
      function k7(r) {
        return typeof r == "number" || S3(r) && A3(r) == B1;
      }
      function Z6(r) {
        if (!S3(r) || A3(r) != _2)
          return !1;
        var c = b0(r);
        if (c === null)
          return !0;
        var f = x2.call(c, "constructor") && c.constructor;
        return typeof f == "function" && f instanceof f && Ee.call(f) == W8;
      }
      var Ol = Q0 ? V3(Q0) : Rn;
      function zp(r) {
        return S7(r) && r >= -c1 && r <= c1;
      }
      var E7 = Si ? V3(Si) : Dr;
      function t8(r) {
        return typeof r == "string" || !p2(r) && S3(r) && A3(r) == t2;
      }
      function st(r) {
        return typeof r == "symbol" || S3(r) && A3(r) == S2;
      }
      var N0 = V6 ? V3(V6) : Q8;
      function Mp(r) {
        return r === n;
      }
      function bp(r) {
        return S3(r) && me(r) == E2;
      }
      function Lp(r) {
        return S3(r) && A3(r) == o3;
      }
      var xp = ji(u6), Sp = ji(function(r, c) {
        return r <= c;
      });
      function A7(r) {
        if (!r)
          return [];
        if (Ue(r))
          return t8(r) ? it(r) : $e(r);
        if (i5 && r[i5])
          return Pn(r[i5]());
        var c = me(r), f = c == y2 ? q0 : c == Z1 ? M5 : P0;
        return f(r);
      }
      function M4(r) {
        if (!r)
          return r === 0 ? r : 0;
        if (r = ft(r), r === h1 || r === -h1) {
          var c = r < 0 ? -1 : 1;
          return c * M1;
        }
        return r === r ? r : 0;
      }
      function q2(r) {
        var c = M4(r), f = c % 1;
        return c === c ? f ? c - f : c : 0;
      }
      function F7(r) {
        return r ? o2(q2(r), 0, A1) : 0;
      }
      function ft(r) {
        if (typeof r == "number")
          return r;
        if (st(r))
          return y1;
        if (M3(r)) {
          var c = typeof r.valueOf == "function" ? r.valueOf() : r;
          r = M3(c) ? c + "" : c;
        }
        if (typeof r != "string")
          return r === 0 ? r : +r;
        r = B4(r);
        var f = H5.test(r);
        return f || zn.test(r) ? $8(r.slice(2), f ? 2 : 8) : K4.test(r) ? y1 : +r;
      }
      function T7(r) {
        return Yt(r, je(r));
      }
      function Cp(r) {
        return r ? o2(q2(r), -c1, c1) : r === 0 ? r : 0;
      }
      function K2(r) {
        return r == null ? "" : De(r);
      }
      var kp = T0(function(r, c) {
        if (X6(c) || Ue(c)) {
          Yt(c, ee(c), r);
          return;
        }
        for (var f in c)
          x2.call(c, f) && V1(r, f, c[f]);
      }), I7 = T0(function(r, c) {
        Yt(c, je(c), r);
      }), n8 = T0(function(r, c, f, y) {
        Yt(c, je(c), r, y);
      }), Ep = T0(function(r, c, f, y) {
        Yt(c, ee(c), r, y);
      }), Ap = q4(C2);
      function Fp(r, c) {
        var f = E5(r);
        return c == null ? f : j1(f, c);
      }
      var Tp = M2(function(r, c) {
        r = Y2(r);
        var f = -1, y = c.length, L = y > 2 ? c[2] : n;
        for (L && Ae(c[0], c[1], L) && (y = 1); ++f < y; )
          for (var I = c[f], U = je(I), Y = -1, l1 = U.length; ++Y < l1; ) {
            var _1 = U[Y], q1 = r[_1];
            (q1 === n || St(q1, $3[_1]) && !x2.call(r, _1)) && (r[_1] = I[_1]);
          }
        return r;
      }), Ip = M2(function(r) {
        return r.push(n, Z9), fe(O7, n, r);
      });
      function Op(r, c) {
        return F1(r, i2(c, 3), le);
      }
      function Np(r, c) {
        return F1(r, i2(c, 3), jt);
      }
      function Pp(r, c) {
        return r == null ? r : Nt(r, i2(c, 3), je);
      }
      function Bp(r, c) {
        return r == null ? r : se(r, i2(c, 3), je);
      }
      function Vp(r, c) {
        return r && le(r, i2(c, 3));
      }
      function Rp(r, c) {
        return r && jt(r, i2(c, 3));
      }
      function Hp(r) {
        return r == null ? [] : Ze(r, ee(r));
      }
      function Dp(r) {
        return r == null ? [] : Ze(r, je(r));
      }
      function Nl(r, c, f) {
        var y = r == null ? n : pe(r, c);
        return y === n ? f : y;
      }
      function $p(r, c) {
        return r != null && e7(r, c, Pt);
      }
      function Pl(r, c) {
        return r != null && e7(r, c, k0);
      }
      var Up = G9(function(r, c, f) {
        c != null && typeof c.toString != "function" && (c = n5.call(c)), r[c] = f;
      }, Vl(Ge)), jp = G9(function(r, c, f) {
        c != null && typeof c.toString != "function" && (c = n5.call(c)), x2.call(r, c) ? r[c].push(f) : r[c] = [f];
      }, i2), Gp = M2(ce);
      function ee(r) {
        return Ue(r) ? L1(r) : h6(r);
      }
      function je(r) {
        return Ue(r) ? L1(r, !0) : ul(r);
      }
      function Wp(r, c) {
        var f = {};
        return c = i2(c, 3), le(r, function(y, L, I) {
          $1(f, c(y, L, I), y);
        }), f;
      }
      function Yp(r, c) {
        var f = {};
        return c = i2(c, 3), le(r, function(y, L, I) {
          $1(f, L, c(y, L, I));
        }), f;
      }
      var Xp = T0(function(r, c, f) {
        E0(r, c, f);
      }), O7 = T0(function(r, c, f, y) {
        E0(r, c, f, y);
      }), Kp = q4(function(r, c) {
        var f = {};
        if (r == null)
          return f;
        var y = !1;
        c = t3(c, function(I) {
          return I = Wt(I, r), y || (y = I.length > 1), I;
        }), Yt(r, zl(r), f), y && (f = k2(f, v | m | p, $d));
        for (var L = c.length; L--; )
          Bi(f, c[L]);
        return f;
      });
      function Zp(r, c) {
        return N7(r, Qi(i2(c)));
      }
      var Jp = q4(function(r, c) {
        return r == null ? {} : I9(r, c);
      });
      function N7(r, c) {
        if (r == null)
          return {};
        var f = t3(zl(r), function(y) {
          return [y];
        });
        return c = i2(c), ts(r, f, function(y, L) {
          return c(y, L[0]);
        });
      }
      function Qp(r, c, f) {
        c = Wt(c, r);
        var y = -1, L = c.length;
        for (L || (L = 1, r = n); ++y < L; ) {
          var I = r == null ? n : r[Xt(c[y])];
          I === n && (y = L, I = f), r = z4(I) ? I.call(r) : I;
        }
        return r;
      }
      function em(r, c, f) {
        return r == null ? r : K5(r, c, f);
      }
      function tm(r, c, f, y) {
        return y = typeof y == "function" ? y : n, r == null ? r : K5(r, c, f, y);
      }
      var P7 = X9(ee), B7 = X9(je);
      function nm(r, c, f) {
        var y = p2(r), L = y || $4(r) || N0(r);
        if (c = i2(c, 4), f == null) {
          var I = r && r.constructor;
          L ? f = y ? new I() : [] : M3(r) ? f = z4(I) ? E5(b0(r)) : {} : f = {};
        }
        return (L ? qe : le)(r, function(U, Y, l1) {
          return c(f, U, Y, l1);
        }), f;
      }
      function im(r, c) {
        return r == null ? !0 : Bi(r, c);
      }
      function sm(r, c, f) {
        return r == null ? r : W6(r, c, m6(f));
      }
      function lm(r, c, f, y) {
        return y = typeof y == "function" ? y : n, r == null ? r : W6(r, c, m6(f), y);
      }
      function P0(r) {
        return r == null ? [] : V4(r, ee(r));
      }
      function rm(r) {
        return r == null ? [] : V4(r, je(r));
      }
      function am(r, c, f) {
        return f === n && (f = c, c = n), f !== n && (f = ft(f), f = f === f ? f : 0), c !== n && (c = ft(c), c = c === c ? c : 0), o2(ft(r), c, f);
      }
      function om(r, c, f) {
        return c = M4(c), f === n ? (f = c, c = 0) : f = M4(f), r = ft(r), j6(r, c, f);
      }
      function cm(r, c, f) {
        if (f && typeof f != "boolean" && Ae(r, c, f) && (c = f = n), f === n && (typeof c == "boolean" ? (f = c, c = n) : typeof r == "boolean" && (f = r, r = n)), r === n && c === n ? (r = 0, c = 1) : (r = M4(r), c === n ? (c = r, r = 0) : c = M4(c)), r > c) {
          var y = r;
          r = c, c = y;
        }
        if (f || r % 1 || c % 1) {
          var L = ol();
          return ne(r + L * (c - r + Fn("1e-" + ((L + "").length - 1))), c);
        }
        return f6(r, c);
      }
      var hm = I0(function(r, c, f) {
        return c = c.toLowerCase(), r + (f ? V7(c) : c);
      });
      function V7(r) {
        return Bl(K2(r).toLowerCase());
      }
      function R7(r) {
        return r = K2(r), r && r.replace(bn, Ei).replace(D8, "");
      }
      function um(r, c, f) {
        r = K2(r), c = De(c);
        var y = r.length;
        f = f === n ? y : o2(q2(f), 0, y);
        var L = f;
        return f -= c.length, f >= 0 && r.slice(f, L) == c;
      }
      function dm(r) {
        return r = K2(r), r && d3.test(r) ? r.replace(Se, Ai) : r;
      }
      function fm(r) {
        return r = K2(r), r && _t.test(r) ? r.replace(Re, "\\$&") : r;
      }
      var vm = I0(function(r, c, f) {
        return r + (f ? "-" : "") + c.toLowerCase();
      }), pm = I0(function(r, c, f) {
        return r + (f ? " " : "") + c.toLowerCase();
      }), mm = $9("toLowerCase");
      function gm(r, c, f) {
        r = K2(r), c = q2(c);
        var y = c ? R4(r) : 0;
        if (!c || y >= c)
          return r;
        var L = (c - y) / 2;
        return Ui(x0(L), f) + r + Ui(L0(L), f);
      }
      function ym(r, c, f) {
        r = K2(r), c = q2(c);
        var y = c ? R4(r) : 0;
        return c && y < c ? r + Ui(c - y, f) : r;
      }
      function _m(r, c, f) {
        r = K2(r), c = q2(c);
        var y = c ? R4(r) : 0;
        return c && y < c ? Ui(c - y, f) + r : r;
      }
      function qm(r, c, f) {
        return f || c == null ? c = 0 : c && (c = +c), z9(K2(r).replace(L3, ""), c || 0);
      }
      function wm(r, c, f) {
        return (f ? Ae(r, c, f) : c === n) ? c = 1 : c = q2(c), A0(K2(r), c);
      }
      function zm() {
        var r = arguments, c = K2(r[0]);
        return r.length < 3 ? c : c.replace(r[1], r[2]);
      }
      var Mm = I0(function(r, c, f) {
        return r + (f ? "_" : "") + c.toLowerCase();
      });
      function bm(r, c, f) {
        return f && typeof f != "number" && Ae(r, c, f) && (c = f = n), f = f === n ? A1 : f >>> 0, f ? (r = K2(r), r && (typeof c == "string" || c != null && !Ol(c)) && (c = De(c), !c && i4(r)) ? y4(it(r), 0, f) : r.split(c, f)) : [];
      }
      var Lm = I0(function(r, c, f) {
        return r + (f ? " " : "") + Bl(c);
      });
      function xm(r, c, f) {
        return r = K2(r), f = f == null ? 0 : o2(q2(f), 0, r.length), c = De(c), r.slice(f, f + c.length) == c;
      }
      function Sm(r, c, f) {
        var y = A.templateSettings;
        f && Ae(r, c, f) && (c = n), r = K2(r), c = n8({}, c, y, K9);
        var L = n8({}, c.imports, y.imports, K9), I = ee(L), U = V4(L, I), Y, l1, _1 = 0, q1 = c.interpolate || Z4, x1 = "__p += '", P1 = x5(
          (c.escape || Z4).source + "|" + q1.source + "|" + (q1 === Ce ? w5 : Z4).source + "|" + (c.evaluate || Z4).source + "|$",
          "g"
        ), W1 = "//# sourceURL=" + (x2.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++il + "]") + `
`;
        r.replace(P1, function(r2, T2, B2, lt, Fe, rt) {
          return B2 || (B2 = lt), x1 += r.slice(_1, rt).replace(P8, On), T2 && (Y = !0, x1 += `' +
__e(` + T2 + `) +
'`), Fe && (l1 = !0, x1 += `';
` + Fe + `;
__p += '`), B2 && (x1 += `' +
((__t = (` + B2 + `)) == null ? '' : __t) +
'`), _1 = rt + r2.length, r2;
        }), x1 += `';
`;
        var l2 = x2.call(c, "variable") && c.variable;
        if (!l2)
          x1 = `with (obj) {
` + x1 + `
}
`;
        else if (_5.test(l2))
          throw new s2(o);
        x1 = (l1 ? x1.replace(R2, "") : x1).replace(w3, "$1").replace(B3, "$1;"), x1 = "function(" + (l2 || "obj") + `) {
` + (l2 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Y ? ", __e = _.escape" : "") + (l1 ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + x1 + `return __p
}`;
        var b2 = D7(function() {
          return N2(I, W1 + "return " + x1).apply(n, U);
        });
        if (b2.source = x1, Il(b2))
          throw b2;
        return b2;
      }
      function Cm(r) {
        return K2(r).toLowerCase();
      }
      function km(r) {
        return K2(r).toUpperCase();
      }
      function Em(r, c, f) {
        if (r = K2(r), r && (f || c === n))
          return B4(r);
        if (!r || !(c = De(c)))
          return r;
        var y = it(r), L = it(c), I = H6(y, L), U = D6(y, L) + 1;
        return y4(y, I, U).join("");
      }
      function Am(r, c, f) {
        if (r = K2(r), r && (f || c === n))
          return r.slice(0, U5(r) + 1);
        if (!r || !(c = De(c)))
          return r;
        var y = it(r), L = D6(y, it(c)) + 1;
        return y4(y, 0, L).join("");
      }
      function Fm(r, c, f) {
        if (r = K2(r), r && (f || c === n))
          return r.replace(L3, "");
        if (!r || !(c = De(c)))
          return r;
        var y = it(r), L = H6(y, it(c));
        return y4(y, L).join("");
      }
      function Tm(r, c) {
        var f = K, y = P;
        if (M3(c)) {
          var L = "separator" in c ? c.separator : L;
          f = "length" in c ? q2(c.length) : f, y = "omission" in c ? De(c.omission) : y;
        }
        r = K2(r);
        var I = r.length;
        if (i4(r)) {
          var U = it(r);
          I = U.length;
        }
        if (f >= I)
          return r;
        var Y = f - R4(y);
        if (Y < 1)
          return y;
        var l1 = U ? y4(U, 0, Y).join("") : r.slice(0, Y);
        if (L === n)
          return l1 + y;
        if (U && (Y += l1.length - Y), Ol(L)) {
          if (r.slice(Y).search(L)) {
            var _1, q1 = l1;
            for (L.global || (L = x5(L.source, K2(X4.exec(L)) + "g")), L.lastIndex = 0; _1 = L.exec(q1); )
              var x1 = _1.index;
            l1 = l1.slice(0, x1 === n ? Y : x1);
          }
        } else if (r.indexOf(De(L), Y) != Y) {
          var P1 = l1.lastIndexOf(L);
          P1 > -1 && (l1 = l1.slice(0, P1));
        }
        return l1 + y;
      }
      function Im(r) {
        return r = K2(r), r && _e.test(r) ? r.replace(G3, t5) : r;
      }
      var Om = I0(function(r, c, f) {
        return r + (f ? " " : "") + c.toUpperCase();
      }), Bl = $9("toUpperCase");
      function H7(r, c, f) {
        return r = K2(r), c = f ? n : c, c === n ? Nn(r) ? j5(r) : z1(r) : r.match(c) || [];
      }
      var D7 = M2(function(r, c) {
        try {
          return fe(r, n, c);
        } catch (f) {
          return Il(f) ? f : new s2(f);
        }
      }), Nm = q4(function(r, c) {
        return qe(c, function(f) {
          f = Xt(f), $1(r, f, Fl(r[f], r));
        }), r;
      });
      function Pm(r) {
        var c = r == null ? 0 : r.length, f = i2();
        return r = c ? t3(r, function(y) {
          if (typeof y[1] != "function")
            throw new ke(a);
          return [f(y[0]), y[1]];
        }) : [], M2(function(y) {
          for (var L = -1; ++L < c; ) {
            var I = r[L];
            if (fe(I[0], this, y))
              return fe(I[1], this, y);
          }
        });
      }
      function Bm(r) {
        return L2(k2(r, v));
      }
      function Vl(r) {
        return function() {
          return r;
        };
      }
      function Vm(r, c) {
        return r == null || r !== r ? c : r;
      }
      var Rm = j9(), Hm = j9(!0);
      function Ge(r) {
        return r;
      }
      function Rl(r) {
        return es(typeof r == "function" ? r : k2(r, v));
      }
      function Dm(r) {
        return dl(k2(r, v));
      }
      function $m(r, c) {
        return fl(r, k2(c, v));
      }
      var Um = M2(function(r, c) {
        return function(f) {
          return ce(f, r, c);
        };
      }), jm = M2(function(r, c) {
        return function(f) {
          return ce(r, f, c);
        };
      });
      function Hl(r, c, f) {
        var y = ee(c), L = Ze(c, y);
        f == null && !(M3(c) && (L.length || !y.length)) && (f = c, c = r, r = this, L = Ze(c, ee(c)));
        var I = !(M3(f) && "chain" in f) || !!f.chain, U = z4(r);
        return qe(L, function(Y) {
          var l1 = c[Y];
          r[Y] = l1, U && (r.prototype[Y] = function() {
            var _1 = this.__chain__;
            if (I || _1) {
              var q1 = r(this.__wrapped__), x1 = q1.__actions__ = $e(this.__actions__);
              return x1.push({ func: l1, args: arguments, thisArg: r }), q1.__chain__ = _1, q1;
            }
            return l1.apply(r, xt([this.value()], arguments));
          });
        }), r;
      }
      function Gm() {
        return D3._ === this && (D3._ = Fr), this;
      }
      function Dl() {
      }
      function Wm(r) {
        return r = q2(r), M2(function(c) {
          return vl(c, r);
        });
      }
      var Ym = _l(t3), Xm = _l(R6), Km = _l(S);
      function $7(r) {
        return xl(r) ? y3(Xt(r)) : ns(r);
      }
      function Zm(r) {
        return function(c) {
          return r == null ? n : pe(r, c);
        };
      }
      var Jm = W9(), Qm = W9(!0);
      function $l() {
        return [];
      }
      function Ul() {
        return !1;
      }
      function eg() {
        return {};
      }
      function tg() {
        return "";
      }
      function ng() {
        return !0;
      }
      function ig(r, c) {
        if (r = q2(r), r < 1 || r > c1)
          return [];
        var f = A1, y = ne(r, A1);
        c = i2(c), r -= A1;
        for (var L = wt(y, c); ++f < r; )
          c(f);
        return L;
      }
      function sg(r) {
        return p2(r) ? t3(r, Xt) : st(r) ? [r] : $e(c7(K2(r)));
      }
      function lg(r) {
        var c = ++M0;
        return K2(r) + c;
      }
      var rg = $i(function(r, c) {
        return r + c;
      }, 0), ag = ql("ceil"), og = $i(function(r, c) {
        return r / c;
      }, 1), cg = ql("floor");
      function hg(r) {
        return r && r.length ? h3(r, Ge, A4) : n;
      }
      function ug(r, c) {
        return r && r.length ? h3(r, i2(c, 2), A4) : n;
      }
      function dg(r) {
        return v3(r, Ge);
      }
      function fg(r, c) {
        return v3(r, i2(c, 2));
      }
      function vg(r) {
        return r && r.length ? h3(r, Ge, u6) : n;
      }
      function pg(r, c) {
        return r && r.length ? h3(r, i2(c, 2), u6) : n;
      }
      var mg = $i(function(r, c) {
        return r * c;
      }, 1), gg = ql("round"), yg = $i(function(r, c) {
        return r - c;
      }, 0);
      function _g(r) {
        return r && r.length ? Xe(r, Ge) : 0;
      }
      function qg(r, c) {
        return r && r.length ? Xe(r, i2(c, 2)) : 0;
      }
      return A.after = Dv, A.ary = q7, A.assign = kp, A.assignIn = I7, A.assignInWith = n8, A.assignWith = Ep, A.at = Ap, A.before = w7, A.bind = Fl, A.bindAll = Nm, A.bindKey = z7, A.castArray = ep, A.chain = g7, A.chunk = cf, A.compact = hf, A.concat = uf, A.cond = Pm, A.conforms = Bm, A.constant = Vl, A.countBy = _v, A.create = Fp, A.curry = M7, A.curryRight = b7, A.debounce = L7, A.defaults = Tp, A.defaultsDeep = Ip, A.defer = $v, A.delay = Uv, A.difference = df, A.differenceBy = ff, A.differenceWith = vf, A.drop = pf, A.dropRight = mf, A.dropRightWhile = gf, A.dropWhile = yf, A.fill = _f, A.filter = wv, A.flatMap = bv, A.flatMapDeep = Lv, A.flatMapDepth = xv, A.flatten = f7, A.flattenDeep = qf, A.flattenDepth = wf, A.flip = jv, A.flow = Rm, A.flowRight = Hm, A.fromPairs = zf, A.functions = Hp, A.functionsIn = Dp, A.groupBy = Sv, A.initial = bf, A.intersection = Lf, A.intersectionBy = xf, A.intersectionWith = Sf, A.invert = Up, A.invertBy = jp, A.invokeMap = kv, A.iteratee = Rl, A.keyBy = Ev, A.keys = ee, A.keysIn = je, A.map = Ki, A.mapKeys = Wp, A.mapValues = Yp, A.matches = Dm, A.matchesProperty = $m, A.memoize = Ji, A.merge = Xp, A.mergeWith = O7, A.method = Um, A.methodOf = jm, A.mixin = Hl, A.negate = Qi, A.nthArg = Wm, A.omit = Kp, A.omitBy = Zp, A.once = Gv, A.orderBy = Av, A.over = Ym, A.overArgs = Wv, A.overEvery = Xm, A.overSome = Km, A.partial = Tl, A.partialRight = x7, A.partition = Fv, A.pick = Jp, A.pickBy = N7, A.property = $7, A.propertyOf = Zm, A.pull = Af, A.pullAll = p7, A.pullAllBy = Ff, A.pullAllWith = Tf, A.pullAt = If, A.range = Jm, A.rangeRight = Qm, A.rearg = Yv, A.reject = Ov, A.remove = Of, A.rest = Xv, A.reverse = El, A.sampleSize = Pv, A.set = em, A.setWith = tm, A.shuffle = Bv, A.slice = Nf, A.sortBy = Hv, A.sortedUniq = $f, A.sortedUniqBy = Uf, A.split = bm, A.spread = Kv, A.tail = jf, A.take = Gf, A.takeRight = Wf, A.takeRightWhile = Yf, A.takeWhile = Xf, A.tap = hv, A.throttle = Zv, A.thru = Xi, A.toArray = A7, A.toPairs = P7, A.toPairsIn = B7, A.toPath = sg, A.toPlainObject = T7, A.transform = nm, A.unary = Jv, A.union = Kf, A.unionBy = Zf, A.unionWith = Jf, A.uniq = Qf, A.uniqBy = ev, A.uniqWith = tv, A.unset = im, A.unzip = Al, A.unzipWith = m7, A.update = sm, A.updateWith = lm, A.values = P0, A.valuesIn = rm, A.without = nv, A.words = H7, A.wrap = Qv, A.xor = iv, A.xorBy = sv, A.xorWith = lv, A.zip = rv, A.zipObject = av, A.zipObjectDeep = ov, A.zipWith = cv, A.entries = P7, A.entriesIn = B7, A.extend = I7, A.extendWith = n8, Hl(A, A), A.add = rg, A.attempt = D7, A.camelCase = hm, A.capitalize = V7, A.ceil = ag, A.clamp = am, A.clone = tp, A.cloneDeep = ip, A.cloneDeepWith = sp, A.cloneWith = np, A.conformsTo = lp, A.deburr = R7, A.defaultTo = Vm, A.divide = og, A.endsWith = um, A.eq = St, A.escape = dm, A.escapeRegExp = fm, A.every = qv, A.find = zv, A.findIndex = u7, A.findKey = Op, A.findLast = Mv, A.findLastIndex = d7, A.findLastKey = Np, A.floor = cg, A.forEach = y7, A.forEachRight = _7, A.forIn = Pp, A.forInRight = Bp, A.forOwn = Vp, A.forOwnRight = Rp, A.get = Nl, A.gt = rp, A.gte = ap, A.has = $p, A.hasIn = Pl, A.head = v7, A.identity = Ge, A.includes = Cv, A.indexOf = Mf, A.inRange = om, A.invoke = Gp, A.isArguments = T5, A.isArray = p2, A.isArrayBuffer = op, A.isArrayLike = Ue, A.isArrayLikeObject = O3, A.isBoolean = cp, A.isBuffer = $4, A.isDate = hp, A.isElement = up, A.isEmpty = dp, A.isEqual = fp, A.isEqualWith = vp, A.isError = Il, A.isFinite = pp, A.isFunction = z4, A.isInteger = S7, A.isLength = e8, A.isMap = C7, A.isMatch = mp, A.isMatchWith = gp, A.isNaN = yp, A.isNative = _p, A.isNil = wp, A.isNull = qp, A.isNumber = k7, A.isObject = M3, A.isObjectLike = S3, A.isPlainObject = Z6, A.isRegExp = Ol, A.isSafeInteger = zp, A.isSet = E7, A.isString = t8, A.isSymbol = st, A.isTypedArray = N0, A.isUndefined = Mp, A.isWeakMap = bp, A.isWeakSet = Lp, A.join = Cf, A.kebabCase = vm, A.last = dt, A.lastIndexOf = kf, A.lowerCase = pm, A.lowerFirst = mm, A.lt = xp, A.lte = Sp, A.max = hg, A.maxBy = ug, A.mean = dg, A.meanBy = fg, A.min = vg, A.minBy = pg, A.stubArray = $l, A.stubFalse = Ul, A.stubObject = eg, A.stubString = tg, A.stubTrue = ng, A.multiply = mg, A.nth = Ef, A.noConflict = Gm, A.noop = Dl, A.now = Zi, A.pad = gm, A.padEnd = ym, A.padStart = _m, A.parseInt = qm, A.random = cm, A.reduce = Tv, A.reduceRight = Iv, A.repeat = wm, A.replace = zm, A.result = Qp, A.round = gg, A.runInContext = e1, A.sample = Nv, A.size = Vv, A.snakeCase = Mm, A.some = Rv, A.sortedIndex = Pf, A.sortedIndexBy = Bf, A.sortedIndexOf = Vf, A.sortedLastIndex = Rf, A.sortedLastIndexBy = Hf, A.sortedLastIndexOf = Df, A.startCase = Lm, A.startsWith = xm, A.subtract = yg, A.sum = _g, A.sumBy = qg, A.template = Sm, A.times = ig, A.toFinite = M4, A.toInteger = q2, A.toLength = F7, A.toLower = Cm, A.toNumber = ft, A.toSafeInteger = Cp, A.toString = K2, A.toUpper = km, A.trim = Em, A.trimEnd = Am, A.trimStart = Fm, A.truncate = Tm, A.unescape = Im, A.uniqueId = lg, A.upperCase = Om, A.upperFirst = Bl, A.each = y7, A.eachRight = _7, A.first = v7, Hl(A, function() {
        var r = {};
        return le(A, function(c, f) {
          x2.call(A.prototype, f) || (r[f] = c);
        }), r;
      }(), { chain: !1 }), A.VERSION = i, qe(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(r) {
        A[r].placeholder = A;
      }), qe(["drop", "take"], function(r, c) {
        A2.prototype[r] = function(f) {
          f = f === n ? 1 : R3(q2(f), 0);
          var y = this.__filtered__ && !c ? new A2(this) : this.clone();
          return y.__filtered__ ? y.__takeCount__ = ne(f, y.__takeCount__) : y.__views__.push({
            size: ne(f, A1),
            type: r + (y.__dir__ < 0 ? "Right" : "")
          }), y;
        }, A2.prototype[r + "Right"] = function(f) {
          return this.reverse()[r](f).reverse();
        };
      }), qe(["filter", "map", "takeWhile"], function(r, c) {
        var f = c + 1, y = f == j || f == i1;
        A2.prototype[r] = function(L) {
          var I = this.clone();
          return I.__iteratees__.push({
            iteratee: i2(L, 3),
            type: f
          }), I.__filtered__ = I.__filtered__ || y, I;
        };
      }), qe(["head", "last"], function(r, c) {
        var f = "take" + (c ? "Right" : "");
        A2.prototype[r] = function() {
          return this[f](1).value()[0];
        };
      }), qe(["initial", "tail"], function(r, c) {
        var f = "drop" + (c ? "" : "Right");
        A2.prototype[r] = function() {
          return this.__filtered__ ? new A2(this) : this[f](1);
        };
      }), A2.prototype.compact = function() {
        return this.filter(Ge);
      }, A2.prototype.find = function(r) {
        return this.filter(r).head();
      }, A2.prototype.findLast = function(r) {
        return this.reverse().find(r);
      }, A2.prototype.invokeMap = M2(function(r, c) {
        return typeof r == "function" ? new A2(this) : this.map(function(f) {
          return ce(f, r, c);
        });
      }), A2.prototype.reject = function(r) {
        return this.filter(Qi(i2(r)));
      }, A2.prototype.slice = function(r, c) {
        r = q2(r);
        var f = this;
        return f.__filtered__ && (r > 0 || c < 0) ? new A2(f) : (r < 0 ? f = f.takeRight(-r) : r && (f = f.drop(r)), c !== n && (c = q2(c), f = c < 0 ? f.dropRight(-c) : f.take(c - r)), f);
      }, A2.prototype.takeRightWhile = function(r) {
        return this.reverse().takeWhile(r).reverse();
      }, A2.prototype.toArray = function() {
        return this.take(A1);
      }, le(A2.prototype, function(r, c) {
        var f = /^(?:filter|find|map|reject)|While$/.test(c), y = /^(?:head|last)$/.test(c), L = A[y ? "take" + (c == "last" ? "Right" : "") : c], I = y || /^find/.test(c);
        L && (A.prototype[c] = function() {
          var U = this.__wrapped__, Y = y ? [1] : arguments, l1 = U instanceof A2, _1 = Y[0], q1 = l1 || p2(U), x1 = function(T2) {
            var B2 = L.apply(A, xt([T2], Y));
            return y && P1 ? B2[0] : B2;
          };
          q1 && f && typeof _1 == "function" && _1.length != 1 && (l1 = q1 = !1);
          var P1 = this.__chain__, W1 = !!this.__actions__.length, l2 = I && !P1, b2 = l1 && !W1;
          if (!I && q1) {
            U = b2 ? U : new A2(this);
            var r2 = r.apply(U, Y);
            return r2.__actions__.push({ func: Xi, args: [x1], thisArg: n }), new Ke(r2, P1);
          }
          return l2 && b2 ? r.apply(this, Y) : (r2 = this.thru(x1), l2 ? y ? r2.value()[0] : r2.value() : r2);
        });
      }), qe(["pop", "push", "shift", "sort", "splice", "unshift"], function(r) {
        var c = Tt[r], f = /^(?:push|sort|unshift)$/.test(r) ? "tap" : "thru", y = /^(?:pop|shift)$/.test(r);
        A.prototype[r] = function() {
          var L = arguments;
          if (y && !this.__chain__) {
            var I = this.value();
            return c.apply(p2(I) ? I : [], L);
          }
          return this[f](function(U) {
            return c.apply(p2(U) ? U : [], L);
          });
        };
      }), le(A2.prototype, function(r, c) {
        var f = A[c];
        if (f) {
          var y = f.name + "";
          x2.call(C5, y) || (C5[y] = []), C5[y].push({ name: c, func: f });
        }
      }), C5[Di(n, z).name] = [{
        name: "wrapper",
        func: n
      }], A2.prototype.clone = Nr, A2.prototype.reverse = L9, A2.prototype.value = K8, A.prototype.at = uv, A.prototype.chain = dv, A.prototype.commit = fv, A.prototype.next = vv, A.prototype.plant = mv, A.prototype.reverse = gv, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = yv, A.prototype.first = A.prototype.head, i5 && (A.prototype[i5] = pv), A;
    }, l4 = w0();
    qt ? ((qt.exports = l4)._ = l4, P4._ = l4) : D3._ = l4;
  }).call(N5);
})(Hh, Hh.exports);
var s1 = Hh.exports;
function JU1(t, e) {
  if (!(s1.isNil(t) || s1.isNil(e) || t.length === 0))
    return t.reduce((n, i) => Math.abs(i - e) < Math.abs(n - e) ? i : n);
}
const QU1 = (t) => typeof t == "string" && (t.startsWith("http") || t.startsWith("javascript:void(0)")), ej1 = (t) => !s1.isNil(t) && t.includes("self") ? "_self" : "_blank", I_ = (t) => /((http(s?)):\/\/)/gi.test(t), w6 = (t) => {
  if (s1.isString(t))
    try {
      return decodeURIComponent(t.replace(/\+/g, " "));
    } catch {
      return t;
    }
  return "";
}, tj1 = (t) => {
  if (s1.isString(t))
    try {
      return encodeURIComponent(t.replace(/\+/g, " "));
    } catch {
      return t;
    }
  return "";
}, nj1 = (t) => s1.isNil(t) || t === "null" || t === "undefined" ? "" : t, ij1 = (t) => t.replace(/<\/?[^>]+(>|$)/g, "");
function sj1(t, e) {
  return Math.random() * (e - t) + t;
}
function lj1(t = 0, e = 1e8) {
  return t = Math.ceil(t), e = Math.floor(e), Math.floor(Math.random() * (e - t + 1)) + t;
}
function rj1(t = 7) {
  return t = t < 30 ? t : 30, Math.random().toString(36).substr(2, t + 2);
}
const aj1 = (...t) => t.join(" ").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9 ]/g, "").replace(/\s+/g, "-"), tp1 = (t, e, n = !0) => {
  if (t.length <= e)
    return t;
  const i = t.substr(0, e - 1);
  return (n ? i.substr(0, i.lastIndexOf(" ")) : i) + "&hellip;";
};
class Kx {
  constructor() {
    O2(this, "componentInstance", D1());
    let e = this.element;
    e != null && e.parentNode && e.parentNode.removeChild(e), e = document.createElement("div"), this.element = e;
  }
  getComponent() {
    return H(this.componentInstance);
  }
  /**
   * Renderizza un componente Vue
   *
   * @returns {App<Element>}
   */
  render({ component: e, props: n, el: i, appContext: s, slots: l }) {
    const a = iL({
      render: () => {
        let o = w8(e, { ref: this.componentInstance, ...n });
        return l && (o = w8(e, { ref: this.componentInstance, ...n }, l)), o;
      }
    });
    return Object.assign(a._context, s), a.mount(i), a;
  }
  add(e, { id: n, className: i }) {
    const s = this.element;
    s.id = n ?? "", s.className = i ?? "", document.body.appendChild(s), this.instance = this.render(e);
  }
  destroy() {
    var e, n;
    this.instance.unmount(), (n = (e = this.element) == null ? void 0 : e.parentNode) == null || n.removeChild(this.element), this.element = void 0;
  }
}
function Zx(t, e) {
  const { disabled: n } = s3(t), i = e.UUID, s = [], l = D1(), a = C8(), o = D1(!1), h = D1(!1), u = g1(() => "autocomplete-" + H(i)), d = g1(() => -1), v = g1(() => (n == null ? void 0 : n.value) ?? !1), m = (q) => {
    q && s1.indexOf(s, q) < 0 && s.push(q);
  }, p = () => {
    o.value = !0;
  };
  return {
    skipGenericBlur: h,
    triggerFocus: () => {
      h.value = !0, p();
    },
    onFocus: p,
    focused: o,
    useNative: a,
    addBlurElementRef: m,
    autocompleteBlur: s,
    searchInputElement: l,
    searchId: u,
    tabindex: d,
    isDisabled: v
  };
}
var h0 = "top", x6 = "bottom", S6 = "right", u0 = "left", O_ = "auto", yc = [h0, x6, S6, u0], Pa = "start", Vo = "end", np1 = "clippingParents", Jx = "viewport", G7 = "popper", ip1 = "reference", rz = /* @__PURE__ */ yc.reduce(function(t, e) {
  return t.concat([e + "-" + Pa, e + "-" + Vo]);
}, []), Qx = /* @__PURE__ */ [].concat(yc, [O_]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Pa, e + "-" + Vo]);
}, []), sp1 = "beforeRead", lp1 = "read", rp1 = "afterRead", ap1 = "beforeMain", op1 = "main", cp1 = "afterMain", hp1 = "beforeWrite", up1 = "write", dp1 = "afterWrite", fp1 = [sp1, lp1, rp1, ap1, op1, cp1, hp1, up1, dp1];
function ai(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function $0(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function pr(t) {
  var e = $0(t).Element;
  return t instanceof e || t instanceof Element;
}
function L6(t) {
  var e = $0(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function N_(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = $0(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function vp1(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var i = e.styles[n] || {}, s = e.attributes[n] || {}, l = e.elements[n];
    !L6(l) || !ai(l) || (Object.assign(l.style, i), Object.keys(s).forEach(function(a) {
      var o = s[a];
      o === !1 ? l.removeAttribute(a) : l.setAttribute(a, o === !0 ? "" : o);
    }));
  });
}
function pp1(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(i) {
      var s = e.elements[i], l = e.attributes[i] || {}, a = Object.keys(e.styles.hasOwnProperty(i) ? e.styles[i] : n[i]), o = a.reduce(function(h, u) {
        return h[u] = "", h;
      }, {});
      !L6(s) || !ai(s) || (Object.assign(s.style, o), Object.keys(l).forEach(function(h) {
        s.removeAttribute(h);
      }));
    });
  };
}
const mp1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: vp1,
  effect: pp1,
  requires: ["computeStyles"]
};
function ti(t) {
  return t.split("-")[0];
}
var ar = Math.max, Dh = Math.min, Ba = Math.round;
function my() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function eS() {
  return !/^((?!chrome|android).)*safari/i.test(my());
}
function Va(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var i = t.getBoundingClientRect(), s = 1, l = 1;
  e && L6(t) && (s = t.offsetWidth > 0 && Ba(i.width) / t.offsetWidth || 1, l = t.offsetHeight > 0 && Ba(i.height) / t.offsetHeight || 1);
  var a = pr(t) ? $0(t) : window, o = a.visualViewport, h = !eS() && n, u = (i.left + (h && o ? o.offsetLeft : 0)) / s, d = (i.top + (h && o ? o.offsetTop : 0)) / l, v = i.width / s, m = i.height / l;
  return {
    width: v,
    height: m,
    top: d,
    right: u + v,
    bottom: d + m,
    left: u,
    x: u,
    y: d
  };
}
function P_(t) {
  var e = Va(t), n = t.offsetWidth, i = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - i) <= 1 && (i = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: i
  };
}
function tS(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && N_(n)) {
    var i = e;
    do {
      if (i && t.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function z8(t) {
  return $0(t).getComputedStyle(t);
}
function gp1(t) {
  return ["table", "td", "th"].indexOf(ai(t)) >= 0;
}
function Gs(t) {
  return ((pr(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function Bu(t) {
  return ai(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (N_(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Gs(t)
  );
}
function az(t) {
  return !L6(t) || // https://github.com/popperjs/popper-core/issues/837
  z8(t).position === "fixed" ? null : t.offsetParent;
}
function yp1(t) {
  var e = /firefox/i.test(my()), n = /Trident/i.test(my());
  if (n && L6(t)) {
    var i = z8(t);
    if (i.position === "fixed")
      return null;
  }
  var s = Bu(t);
  for (N_(s) && (s = s.host); L6(s) && ["html", "body"].indexOf(ai(s)) < 0; ) {
    var l = z8(s);
    if (l.transform !== "none" || l.perspective !== "none" || l.contain === "paint" || ["transform", "perspective"].indexOf(l.willChange) !== -1 || e && l.willChange === "filter" || e && l.filter && l.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function _c(t) {
  for (var e = $0(t), n = az(t); n && gp1(n) && z8(n).position === "static"; )
    n = az(n);
  return n && (ai(n) === "html" || ai(n) === "body" && z8(n).position === "static") ? e : n || yp1(t) || e;
}
function B_(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function bo(t, e, n) {
  return ar(t, Dh(e, n));
}
function _p1(t, e, n) {
  var i = bo(t, e, n);
  return i > n ? n : i;
}
function nS() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function iS(t) {
  return Object.assign({}, nS(), t);
}
function sS(t, e) {
  return e.reduce(function(n, i) {
    return n[i] = t, n;
  }, {});
}
var qp1 = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, iS(typeof e != "number" ? e : sS(e, yc));
};
function wp1(t) {
  var e, n = t.state, i = t.name, s = t.options, l = n.elements.arrow, a = n.modifiersData.popperOffsets, o = ti(n.placement), h = B_(o), u = [u0, S6].indexOf(o) >= 0, d = u ? "height" : "width";
  if (!(!l || !a)) {
    var v = qp1(s.padding, n), m = P_(l), p = h === "y" ? h0 : u0, _ = h === "y" ? x6 : S6, q = n.rects.reference[d] + n.rects.reference[h] - a[h] - n.rects.popper[d], M = a[h] - n.rects.reference[h], z = _c(l), b = z ? h === "y" ? z.clientHeight || 0 : z.clientWidth || 0 : 0, x = q / 2 - M / 2, k = v[p], F = b - m[d] - v[_], D = b / 2 - m[d] / 2 + x, R = bo(k, D, F), V = h;
    n.modifiersData[i] = (e = {}, e[V] = R, e.centerOffset = R - D, e);
  }
}
function zp1(t) {
  var e = t.state, n = t.options, i = n.element, s = i === void 0 ? "[data-popper-arrow]" : i;
  s != null && (typeof s == "string" && (s = e.elements.popper.querySelector(s), !s) || tS(e.elements.popper, s) && (e.elements.arrow = s));
}
const Mp1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: wp1,
  effect: zp1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ra(t) {
  return t.split("-")[1];
}
var bp1 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Lp1(t, e) {
  var n = t.x, i = t.y, s = e.devicePixelRatio || 1;
  return {
    x: Ba(n * s) / s || 0,
    y: Ba(i * s) / s || 0
  };
}
function oz(t) {
  var e, n = t.popper, i = t.popperRect, s = t.placement, l = t.variation, a = t.offsets, o = t.position, h = t.gpuAcceleration, u = t.adaptive, d = t.roundOffsets, v = t.isFixed, m = a.x, p = m === void 0 ? 0 : m, _ = a.y, q = _ === void 0 ? 0 : _, M = typeof d == "function" ? d({
    x: p,
    y: q
  }) : {
    x: p,
    y: q
  };
  p = M.x, q = M.y;
  var z = a.hasOwnProperty("x"), b = a.hasOwnProperty("y"), x = u0, k = h0, F = window;
  if (u) {
    var D = _c(n), R = "clientHeight", V = "clientWidth";
    if (D === $0(n) && (D = Gs(n), z8(D).position !== "static" && o === "absolute" && (R = "scrollHeight", V = "scrollWidth")), D = D, s === h0 || (s === u0 || s === S6) && l === Vo) {
      k = x6;
      var J = v && D === F && F.visualViewport ? F.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        D[R]
      );
      q -= J - i.height, q *= h ? 1 : -1;
    }
    if (s === u0 || (s === h0 || s === x6) && l === Vo) {
      x = S6;
      var K = v && D === F && F.visualViewport ? F.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        D[V]
      );
      p -= K - i.width, p *= h ? 1 : -1;
    }
  }
  var P = Object.assign({
    position: o
  }, u && bp1), O = d === !0 ? Lp1({
    x: p,
    y: q
  }, $0(n)) : {
    x: p,
    y: q
  };
  if (p = O.x, q = O.y, h) {
    var G;
    return Object.assign({}, P, (G = {}, G[k] = b ? "0" : "", G[x] = z ? "0" : "", G.transform = (F.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + q + "px)" : "translate3d(" + p + "px, " + q + "px, 0)", G));
  }
  return Object.assign({}, P, (e = {}, e[k] = b ? q + "px" : "", e[x] = z ? p + "px" : "", e.transform = "", e));
}
function xp1(t) {
  var e = t.state, n = t.options, i = n.gpuAcceleration, s = i === void 0 ? !0 : i, l = n.adaptive, a = l === void 0 ? !0 : l, o = n.roundOffsets, h = o === void 0 ? !0 : o, u = {
    placement: ti(e.placement),
    variation: Ra(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: s,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, oz(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a,
    roundOffsets: h
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, oz(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: h
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const Sp1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: xp1,
  data: {}
};
var jc = {
  passive: !0
};
function Cp1(t) {
  var e = t.state, n = t.instance, i = t.options, s = i.scroll, l = s === void 0 ? !0 : s, a = i.resize, o = a === void 0 ? !0 : a, h = $0(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return l && u.forEach(function(d) {
    d.addEventListener("scroll", n.update, jc);
  }), o && h.addEventListener("resize", n.update, jc), function() {
    l && u.forEach(function(d) {
      d.removeEventListener("scroll", n.update, jc);
    }), o && h.removeEventListener("resize", n.update, jc);
  };
}
const kp1 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Cp1,
  data: {}
};
var Ep1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function gh(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return Ep1[e];
  });
}
var Ap1 = {
  start: "end",
  end: "start"
};
function cz(t) {
  return t.replace(/start|end/g, function(e) {
    return Ap1[e];
  });
}
function V_(t) {
  var e = $0(t), n = e.pageXOffset, i = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: i
  };
}
function R_(t) {
  return Va(Gs(t)).left + V_(t).scrollLeft;
}
function Fp1(t, e) {
  var n = $0(t), i = Gs(t), s = n.visualViewport, l = i.clientWidth, a = i.clientHeight, o = 0, h = 0;
  if (s) {
    l = s.width, a = s.height;
    var u = eS();
    (u || !u && e === "fixed") && (o = s.offsetLeft, h = s.offsetTop);
  }
  return {
    width: l,
    height: a,
    x: o + R_(t),
    y: h
  };
}
function Tp1(t) {
  var e, n = Gs(t), i = V_(t), s = (e = t.ownerDocument) == null ? void 0 : e.body, l = ar(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), a = ar(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), o = -i.scrollLeft + R_(t), h = -i.scrollTop;
  return z8(s || n).direction === "rtl" && (o += ar(n.clientWidth, s ? s.clientWidth : 0) - l), {
    width: l,
    height: a,
    x: o,
    y: h
  };
}
function H_(t) {
  var e = z8(t), n = e.overflow, i = e.overflowX, s = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + s + i);
}
function lS(t) {
  return ["html", "body", "#document"].indexOf(ai(t)) >= 0 ? t.ownerDocument.body : L6(t) && H_(t) ? t : lS(Bu(t));
}
function Lo(t, e) {
  var n;
  e === void 0 && (e = []);
  var i = lS(t), s = i === ((n = t.ownerDocument) == null ? void 0 : n.body), l = $0(i), a = s ? [l].concat(l.visualViewport || [], H_(i) ? i : []) : i, o = e.concat(a);
  return s ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat(Lo(Bu(a)))
  );
}
function gy(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Ip1(t, e) {
  var n = Va(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function hz(t, e, n) {
  return e === Jx ? gy(Fp1(t, n)) : pr(e) ? Ip1(e, n) : gy(Tp1(Gs(t)));
}
function Op1(t) {
  var e = Lo(Bu(t)), n = ["absolute", "fixed"].indexOf(z8(t).position) >= 0, i = n && L6(t) ? _c(t) : t;
  return pr(i) ? e.filter(function(s) {
    return pr(s) && tS(s, i) && ai(s) !== "body";
  }) : [];
}
function Np1(t, e, n, i) {
  var s = e === "clippingParents" ? Op1(t) : [].concat(e), l = [].concat(s, [n]), a = l[0], o = l.reduce(function(h, u) {
    var d = hz(t, u, i);
    return h.top = ar(d.top, h.top), h.right = Dh(d.right, h.right), h.bottom = Dh(d.bottom, h.bottom), h.left = ar(d.left, h.left), h;
  }, hz(t, a, i));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function rS(t) {
  var e = t.reference, n = t.element, i = t.placement, s = i ? ti(i) : null, l = i ? Ra(i) : null, a = e.x + e.width / 2 - n.width / 2, o = e.y + e.height / 2 - n.height / 2, h;
  switch (s) {
    case h0:
      h = {
        x: a,
        y: e.y - n.height
      };
      break;
    case x6:
      h = {
        x: a,
        y: e.y + e.height
      };
      break;
    case S6:
      h = {
        x: e.x + e.width,
        y: o
      };
      break;
    case u0:
      h = {
        x: e.x - n.width,
        y: o
      };
      break;
    default:
      h = {
        x: e.x,
        y: e.y
      };
  }
  var u = s ? B_(s) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (l) {
      case Pa:
        h[u] = h[u] - (e[d] / 2 - n[d] / 2);
        break;
      case Vo:
        h[u] = h[u] + (e[d] / 2 - n[d] / 2);
        break;
    }
  }
  return h;
}
function Ro(t, e) {
  e === void 0 && (e = {});
  var n = e, i = n.placement, s = i === void 0 ? t.placement : i, l = n.strategy, a = l === void 0 ? t.strategy : l, o = n.boundary, h = o === void 0 ? np1 : o, u = n.rootBoundary, d = u === void 0 ? Jx : u, v = n.elementContext, m = v === void 0 ? G7 : v, p = n.altBoundary, _ = p === void 0 ? !1 : p, q = n.padding, M = q === void 0 ? 0 : q, z = iS(typeof M != "number" ? M : sS(M, yc)), b = m === G7 ? ip1 : G7, x = t.rects.popper, k = t.elements[_ ? b : m], F = Np1(pr(k) ? k : k.contextElement || Gs(t.elements.popper), h, d, a), D = Va(t.elements.reference), R = rS({
    reference: D,
    element: x,
    strategy: "absolute",
    placement: s
  }), V = gy(Object.assign({}, x, R)), J = m === G7 ? V : D, K = {
    top: F.top - J.top + z.top,
    bottom: J.bottom - F.bottom + z.bottom,
    left: F.left - J.left + z.left,
    right: J.right - F.right + z.right
  }, P = t.modifiersData.offset;
  if (m === G7 && P) {
    var O = P[s];
    Object.keys(K).forEach(function(G) {
      var j = [S6, x6].indexOf(G) >= 0 ? 1 : -1, Q = [h0, x6].indexOf(G) >= 0 ? "y" : "x";
      K[G] += O[Q] * j;
    });
  }
  return K;
}
function Pp1(t, e) {
  e === void 0 && (e = {});
  var n = e, i = n.placement, s = n.boundary, l = n.rootBoundary, a = n.padding, o = n.flipVariations, h = n.allowedAutoPlacements, u = h === void 0 ? Qx : h, d = Ra(i), v = d ? o ? rz : rz.filter(function(_) {
    return Ra(_) === d;
  }) : yc, m = v.filter(function(_) {
    return u.indexOf(_) >= 0;
  });
  m.length === 0 && (m = v);
  var p = m.reduce(function(_, q) {
    return _[q] = Ro(t, {
      placement: q,
      boundary: s,
      rootBoundary: l,
      padding: a
    })[ti(q)], _;
  }, {});
  return Object.keys(p).sort(function(_, q) {
    return p[_] - p[q];
  });
}
function Bp1(t) {
  if (ti(t) === O_)
    return [];
  var e = gh(t);
  return [cz(t), e, cz(e)];
}
function Vp1(t) {
  var e = t.state, n = t.options, i = t.name;
  if (!e.modifiersData[i]._skip) {
    for (var s = n.mainAxis, l = s === void 0 ? !0 : s, a = n.altAxis, o = a === void 0 ? !0 : a, h = n.fallbackPlacements, u = n.padding, d = n.boundary, v = n.rootBoundary, m = n.altBoundary, p = n.flipVariations, _ = p === void 0 ? !0 : p, q = n.allowedAutoPlacements, M = e.options.placement, z = ti(M), b = z === M, x = h || (b || !_ ? [gh(M)] : Bp1(M)), k = [M].concat(x).reduce(function(n1, f1) {
      return n1.concat(ti(f1) === O_ ? Pp1(e, {
        placement: f1,
        boundary: d,
        rootBoundary: v,
        padding: u,
        flipVariations: _,
        allowedAutoPlacements: q
      }) : f1);
    }, []), F = e.rects.reference, D = e.rects.popper, R = /* @__PURE__ */ new Map(), V = !0, J = k[0], K = 0; K < k.length; K++) {
      var P = k[K], O = ti(P), G = Ra(P) === Pa, j = [h0, x6].indexOf(O) >= 0, Q = j ? "width" : "height", i1 = Ro(e, {
        placement: P,
        boundary: d,
        rootBoundary: v,
        altBoundary: m,
        padding: u
      }), h1 = j ? G ? S6 : u0 : G ? x6 : h0;
      F[Q] > D[Q] && (h1 = gh(h1));
      var c1 = gh(h1), M1 = [];
      if (l && M1.push(i1[O] <= 0), o && M1.push(i1[h1] <= 0, i1[c1] <= 0), M1.every(function(n1) {
        return n1;
      })) {
        J = P, V = !1;
        break;
      }
      R.set(P, M1);
    }
    if (V)
      for (var y1 = _ ? 3 : 1, A1 = function(f1) {
        var w1 = k.find(function(C1) {
          var E1 = R.get(C1);
          if (E1)
            return E1.slice(0, f1).every(function(T1) {
              return T1;
            });
        });
        if (w1)
          return J = w1, "break";
      }, $ = y1; $ > 0; $--) {
        var a1 = A1($);
        if (a1 === "break")
          break;
      }
    e.placement !== J && (e.modifiersData[i]._skip = !0, e.placement = J, e.reset = !0);
  }
}
const Rp1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Vp1,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function uz(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function dz(t) {
  return [h0, S6, x6, u0].some(function(e) {
    return t[e] >= 0;
  });
}
function Hp1(t) {
  var e = t.state, n = t.name, i = e.rects.reference, s = e.rects.popper, l = e.modifiersData.preventOverflow, a = Ro(e, {
    elementContext: "reference"
  }), o = Ro(e, {
    altBoundary: !0
  }), h = uz(a, i), u = uz(o, s, l), d = dz(h), v = dz(u);
  e.modifiersData[n] = {
    referenceClippingOffsets: h,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: v
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": v
  });
}
const Dp1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Hp1
};
function $p1(t, e, n) {
  var i = ti(t), s = [u0, h0].indexOf(i) >= 0 ? -1 : 1, l = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, a = l[0], o = l[1];
  return a = a || 0, o = (o || 0) * s, [u0, S6].indexOf(i) >= 0 ? {
    x: o,
    y: a
  } : {
    x: a,
    y: o
  };
}
function Up1(t) {
  var e = t.state, n = t.options, i = t.name, s = n.offset, l = s === void 0 ? [0, 0] : s, a = Qx.reduce(function(d, v) {
    return d[v] = $p1(v, e.rects, l), d;
  }, {}), o = a[e.placement], h = o.x, u = o.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += h, e.modifiersData.popperOffsets.y += u), e.modifiersData[i] = a;
}
const jp1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Up1
};
function Gp1(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = rS({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const Wp1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Gp1,
  data: {}
};
function Yp1(t) {
  return t === "x" ? "y" : "x";
}
function Xp1(t) {
  var e = t.state, n = t.options, i = t.name, s = n.mainAxis, l = s === void 0 ? !0 : s, a = n.altAxis, o = a === void 0 ? !1 : a, h = n.boundary, u = n.rootBoundary, d = n.altBoundary, v = n.padding, m = n.tether, p = m === void 0 ? !0 : m, _ = n.tetherOffset, q = _ === void 0 ? 0 : _, M = Ro(e, {
    boundary: h,
    rootBoundary: u,
    padding: v,
    altBoundary: d
  }), z = ti(e.placement), b = Ra(e.placement), x = !b, k = B_(z), F = Yp1(k), D = e.modifiersData.popperOffsets, R = e.rects.reference, V = e.rects.popper, J = typeof q == "function" ? q(Object.assign({}, e.rects, {
    placement: e.placement
  })) : q, K = typeof J == "number" ? {
    mainAxis: J,
    altAxis: J
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, J), P = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, O = {
    x: 0,
    y: 0
  };
  if (D) {
    if (l) {
      var G, j = k === "y" ? h0 : u0, Q = k === "y" ? x6 : S6, i1 = k === "y" ? "height" : "width", h1 = D[k], c1 = h1 + M[j], M1 = h1 - M[Q], y1 = p ? -V[i1] / 2 : 0, A1 = b === Pa ? R[i1] : V[i1], $ = b === Pa ? -V[i1] : -R[i1], a1 = e.elements.arrow, n1 = p && a1 ? P_(a1) : {
        width: 0,
        height: 0
      }, f1 = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : nS(), w1 = f1[j], C1 = f1[Q], E1 = bo(0, R[i1], n1[i1]), T1 = x ? R[i1] / 2 - y1 - E1 - w1 - K.mainAxis : A1 - E1 - w1 - K.mainAxis, n2 = x ? -R[i1] / 2 + y1 + E1 + C1 + K.mainAxis : $ + E1 + C1 + K.mainAxis, X1 = e.elements.arrow && _c(e.elements.arrow), a2 = X1 ? k === "y" ? X1.clientTop || 0 : X1.clientLeft || 0 : 0, d2 = (G = P == null ? void 0 : P[k]) != null ? G : 0, y2 = h1 + T1 - d2 - a2, B1 = h1 + n2 - d2, p1 = bo(p ? Dh(c1, y2) : c1, h1, p ? ar(M1, B1) : M1);
      D[k] = p1, O[k] = p1 - h1;
    }
    if (o) {
      var _2, w2 = k === "x" ? h0 : u0, K1 = k === "x" ? x6 : S6, e2 = D[F], Z1 = F === "y" ? "height" : "width", t2 = e2 + M[w2], S2 = e2 - M[K1], W2 = [h0, u0].indexOf(z) !== -1, E2 = (_2 = P == null ? void 0 : P[F]) != null ? _2 : 0, o3 = W2 ? t2 : e2 - R[Z1] - V[Z1] - E2 + K.altAxis, n3 = W2 ? e2 + R[Z1] + V[Z1] - E2 - K.altAxis : S2, c3 = p && W2 ? _p1(o3, e2, n3) : bo(p ? o3 : t2, e2, p ? n3 : S2);
      D[F] = c3, O[F] = c3 - e2;
    }
    e.modifiersData[i] = O;
  }
}
const Kp1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Xp1,
  requiresIfExists: ["offset"]
};
function Zp1(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Jp1(t) {
  return t === $0(t) || !L6(t) ? V_(t) : Zp1(t);
}
function Qp1(t) {
  var e = t.getBoundingClientRect(), n = Ba(e.width) / t.offsetWidth || 1, i = Ba(e.height) / t.offsetHeight || 1;
  return n !== 1 || i !== 1;
}
function em1(t, e, n) {
  n === void 0 && (n = !1);
  var i = L6(e), s = L6(e) && Qp1(e), l = Gs(e), a = Va(t, s, n), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = {
    x: 0,
    y: 0
  };
  return (i || !i && !n) && ((ai(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  H_(l)) && (o = Jp1(e)), L6(e) ? (h = Va(e, !0), h.x += e.clientLeft, h.y += e.clientTop) : l && (h.x = R_(l))), {
    x: a.left + o.scrollLeft - h.x,
    y: a.top + o.scrollTop - h.y,
    width: a.width,
    height: a.height
  };
}
function tm1(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), i = [];
  t.forEach(function(l) {
    e.set(l.name, l);
  });
  function s(l) {
    n.add(l.name);
    var a = [].concat(l.requires || [], l.requiresIfExists || []);
    a.forEach(function(o) {
      if (!n.has(o)) {
        var h = e.get(o);
        h && s(h);
      }
    }), i.push(l);
  }
  return t.forEach(function(l) {
    n.has(l.name) || s(l);
  }), i;
}
function nm1(t) {
  var e = tm1(t);
  return fp1.reduce(function(n, i) {
    return n.concat(e.filter(function(s) {
      return s.phase === i;
    }));
  }, []);
}
function im1(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function sm1(t) {
  var e = t.reduce(function(n, i) {
    var s = n[i.name];
    return n[i.name] = s ? Object.assign({}, s, i, {
      options: Object.assign({}, s.options, i.options),
      data: Object.assign({}, s.data, i.data)
    }) : i, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var fz = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function vz() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function lm1(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, i = n === void 0 ? [] : n, s = e.defaultOptions, l = s === void 0 ? fz : s;
  return function(o, h, u) {
    u === void 0 && (u = l);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, fz, l),
      modifiersData: {},
      elements: {
        reference: o,
        popper: h
      },
      attributes: {},
      styles: {}
    }, v = [], m = !1, p = {
      state: d,
      setOptions: function(z) {
        var b = typeof z == "function" ? z(d.options) : z;
        q(), d.options = Object.assign({}, l, d.options, b), d.scrollParents = {
          reference: pr(o) ? Lo(o) : o.contextElement ? Lo(o.contextElement) : [],
          popper: Lo(h)
        };
        var x = nm1(sm1([].concat(i, d.options.modifiers)));
        return d.orderedModifiers = x.filter(function(k) {
          return k.enabled;
        }), _(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var z = d.elements, b = z.reference, x = z.popper;
          if (vz(b, x)) {
            d.rects = {
              reference: em1(b, _c(x), d.options.strategy === "fixed"),
              popper: P_(x)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(K) {
              return d.modifiersData[K.name] = Object.assign({}, K.data);
            });
            for (var k = 0; k < d.orderedModifiers.length; k++) {
              if (d.reset === !0) {
                d.reset = !1, k = -1;
                continue;
              }
              var F = d.orderedModifiers[k], D = F.fn, R = F.options, V = R === void 0 ? {} : R, J = F.name;
              typeof D == "function" && (d = D({
                state: d,
                options: V,
                name: J,
                instance: p
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: im1(function() {
        return new Promise(function(M) {
          p.forceUpdate(), M(d);
        });
      }),
      destroy: function() {
        q(), m = !0;
      }
    };
    if (!vz(o, h))
      return p;
    p.setOptions(u).then(function(M) {
      !m && u.onFirstUpdate && u.onFirstUpdate(M);
    });
    function _() {
      d.orderedModifiers.forEach(function(M) {
        var z = M.name, b = M.options, x = b === void 0 ? {} : b, k = M.effect;
        if (typeof k == "function") {
          var F = k({
            state: d,
            name: z,
            instance: p,
            options: x
          }), D = function() {
          };
          v.push(F || D);
        }
      });
    }
    function q() {
      v.forEach(function(M) {
        return M();
      }), v = [];
    }
    return p;
  };
}
var rm1 = [kp1, Wp1, Sp1, mp1, jp1, Rp1, Kp1, Mp1, Dp1], am1 = /* @__PURE__ */ lm1({
  defaultModifiers: rm1
});
function aS(t, e, n) {
  const { disabled: i, contentWrapper: s, dropdownPopperOptions: l } = s3(t), a = n.autocomplete.focused, o = n.autocomplete.autocompleteBlur, h = n.autocomplete.skipGenericBlur, u = D1(!1), d = D1(), v = g1(() => a.value);
  let m;
  const p = (z) => {
    const b = z instanceof FocusEvent ? z.relatedTarget : z.target, x = s1.some(H(o), (k) => H(k) === b || H(k).contains(b));
    H(h) ? h.value = !1 : x === !1 && (m && clearTimeout(m), m = setTimeout(() => {
      q();
    }, 120));
  }, _ = () => {
    i != null && i.value || (a.value = !0, document.body.addEventListener("click", p), e.emit("open"));
  }, q = () => {
    document.body.removeEventListener("click", p), a.value = !1, e.emit("close");
  }, M = () => {
    m && clearTimeout(m), m = setTimeout(() => {
      H(v) ? q() : _();
    }, 120);
  };
  return l3(a, (z) => {
    z === !0 && _();
  }), l3(v, () => {
    const z = H(s1.head(o));
    if (z) {
      const b = s1.head(z.getElementsByClassName("ecl-form-group")), x = s1.head(z.getElementsByClassName("jcl-autocomplete__dropdown")), k = H(s);
      D0(() => {
        if (k) {
          const D = k.getBoundingClientRect(), R = D.height - (x.getBoundingClientRect().top - D.top);
          x.style.maxHeight = `${R}px`;
        }
        const F = H(d);
        if (F)
          F.destroy(), d.value = void 0;
        else {
          const D = s1.assign({ placement: "bottom-start" }, H(l));
          d.value = am1(b, x, D);
        }
      });
    }
  }), {
    isOpen: v,
    open: _,
    close: q,
    toggleDropdown: M,
    focusedOnDropdown: u,
    globalBlurEvent: p,
    popperInstance: d
  };
}
function oS(t) {
  const e = t.list.extendedList, n = t.list.handleClickItem, i = t.dropdown.close;
  return {
    handleEnter: (u) => {
      n(u);
    },
    handleSpace: (u) => {
      n(u);
    },
    handleArrowUp: () => {
    },
    handleArrowDown: () => {
    },
    handleItemBlur: (u) => {
      s1.isEqual(u, s1.last(s1.last(e.value))) && i();
    }
  };
}
function cS(t, e) {
  const { modelValue: n, multipleModelKeyValue: i, multiple: s, tree: l, treeOnSearchOpen: a, treeForceOpen: o } = s3(t), h = D1(H(o) ?? !1), u = D1(null), d = D1(""), v = D1(), m = D1(), p = D1();
  (() => {
    H(s) === !0 ? (v.value = [], m.value = H(n) instanceof Array ? H(n) : [], p.value = m.value) : (v.value = null, m.value = H(n), p.value = m.value);
  })();
  const q = () => {
    H(s) === !0 ? v.value = [] : H(i) ? v.value = {} : v.value = null;
  }, M = () => {
    q(), H(s) === !0 ? p.value = [] : H(i) ? p.value = {} : p.value = "", e.emit("selected", null), e.emit("update:modelValue", null);
  };
  return {
    searchValue: d,
    internalValue: p,
    internalSelectedObject: v,
    externalValue: m,
    forceOpenOnTree: h,
    update: (x) => {
      if (s1.isNil(x))
        return M();
      h.value = !1;
      let k = !0;
      const F = p.value, D = v.value, R = H(i);
      H(s) === !0 ? (F instanceof Array && D instanceof Array ? F.includes(x.value) ? (p.value = s1.filter(F, (V) => V.toString() !== x.value.toString()), v.value = s1.filter(D, (V) => V.value.toString() !== x.value.toString()), k = !1) : (F.push(x.value), D.push(x)) : (p.value = [x.value], v.value = [x]), v.value = s1.uniqBy(H(v), "value")) : R ? x && (s1.assign(p.value, {
        // @ts-ignore
        [x._original[R]]: x.value
      }), s1.assign(v.value, {
        // @ts-ignore
        [x._original[R]]: x
      })) : (p.value = x.value, v.value = x), e.emit("update:modelValue", H(p)), k ? e.emit("selected", x._original) : e.emit("deselected", x._original);
    },
    clear: M,
    clearInternalSelectedObject: q,
    performInputChange: (x) => {
      const k = H(u);
      k && clearTimeout(k), u.value = setTimeout(() => {
        d.value = x.target.value;
        const F = H(d);
        H(l) && H(a) && (h.value = !s1.isNil(F) && !s1.isEmpty(F)), e.emit("search", F);
      }, 150);
    }
  };
}
function hS(t, e) {
  const { t: n } = js(), { hiddenPlaceholder: i, multiplePlaceholderLimit: s, multiplePlaceholder: l } = s3(t), a = e.autocomplete.focused, o = e.value.internalSelectedObject, h = g1(() => {
    const v = H(o);
    return s1.isArray(v) ? v.length > H(s) && H(s) !== -1 ? n(H(l), [v.length]) : s1.uniq(s1.map(v, (m) => m.label)).join(", ") : v && !s1.isNil(v == null ? void 0 : v.label) ? v.label : void 0;
  }), u = g1(() => {
    const v = H(o);
    return v ? s1.isArray(v) && (v == null ? void 0 : v.length) > 0 ? s1.map(v, (m) => m._original) : (v == null ? void 0 : v._original) ?? null : null;
  });
  return {
    placeholderShow: g1(() => i.value === !1 && a.value === !1 && !s1.isNil(H(u))),
    placeholderText: h,
    placeholderItemSelection: u
  };
}
function uS(t, e) {
  const { tree: n, calculateWidth: i, hiddenPlaceholder: s } = s3(t), l = D1(0), a = e.list.extendedList, o = e.list.extendedTreeList, h = e.autocomplete.autocompleteBlur, u = g1(() => H(l) ? `width: ${H(l)}px` : null), d = () => {
    const m = H(h);
    if (m) {
      const p = H(s1.head(m)), _ = s1.head(p == null ? void 0 : p.getElementsByClassName("jcl-autocomplete__placeholder"));
      if (_) {
        const q = _.cloneNode(!0);
        q.style.display = "block", q.style.position = "relative", q.style.width = "auto";
        const M = [];
        s1.each(
          s1.map(s1.flattenDeep(H(a)), (b) => b.label),
          (b) => {
            const x = q.cloneNode(!0);
            if (x != null && x.lastElementChild) {
              x.lastElementChild.innerHTML = `<span>${b}</span>`;
              const k = document.createElement("div");
              k.appendChild(x), M.push(k), p.appendChild(k);
            }
          }
        );
        let z = 0;
        D0(() => {
          s1.each(M, (b) => {
            const x = b.getBoundingClientRect().width + 4;
            z = x > z ? x : z, b.remove();
          }), l.value = z;
        });
      }
    }
  };
  d0(() => {
    H(i) && H(s) === !1 && d();
  });
  const v = (m) => s1.reduce(
    m == null ? void 0 : m.children,
    (p, _) => (p.push(_), _ != null && _.children && p.push(...v(_)), p),
    []
  );
  return l3(
    [a, o],
    () => {
      if (H(i)) {
        const m = H(n) ? v(H(o)) : s1.flattenDeep(H(a));
        (m == null ? void 0 : m.length) > 0 && H(i) && H(s) === !1 && d();
      }
    },
    {
      immediate: !0
    }
  ), {
    calculatedStyles: u
  };
}
function dS(t, e, n) {
  const {
    multipleModelKeyValue: i,
    list: s,
    valueKey: l,
    labelKey: a,
    treeChildrenKey: o,
    listGrouped: h,
    tree: u,
    disabled: d,
    clearSearchOnSelect: v,
    defaultSearchAction: m,
    multiple: p,
    closeOnSelection: _
  } = s3(t), q = n.dropdown.popperInstance, M = n.dropdown.close, z = n.value.internalValue, b = n.value.internalSelectedObject, x = n.value.update, k = n.value.searchValue, F = n.value.clearInternalSelectedObject, D = (Q) => {
    var c1, M1;
    const i1 = H(i), h1 = H(z);
    if (!s1.isNil(h1))
      if (H(u) === !0) {
        const y1 = H(o);
        y1 && !s1.isNil(Q[y1]) ? s1.isArray(Q[y1]) && s1.each(Q[y1], (A1) => D(A1)) : ((c1 = Q == null ? void 0 : Q.value) == null ? void 0 : c1.toString()) === h1.toString() && (b.value = Q);
      } else if (i1) {
        const y1 = Q._original[i1];
        y1 && !s1.isNil(h1 && h1[y1]) && s1.assign(b.value, {
          [i1]: Q
        });
      } else
        H(p) === !0 ? h1 instanceof Array && (h1 != null && h1.includes(Q == null ? void 0 : Q.value)) && b.value instanceof Array && (b.value.push(Q), b.value = s1.uniqBy(H(b), "value")) : !s1.isNil(h1) && ((M1 = Q == null ? void 0 : Q.value) == null ? void 0 : M1.toString()) === h1.toString() && (b.value = Q);
  }, R = (Q) => {
    const i1 = {
      value: Q[H(l)],
      label: Q[H(a)],
      _original: Q,
      type: Q == null ? void 0 : Q.itemType,
      disabled: s1.isBoolean(Q == null ? void 0 : Q.disabled) ? Q == null ? void 0 : Q.disabled : !1
    };
    if (!H(i)) {
      const c1 = H(o);
      H(u) === !0 && c1 && !s1.isNil(Q[c1]) && (i1[c1] = Q[c1].map((M1) => R(M1)));
    }
    return i1;
  }, V = (Q) => {
    if (H(m) && H(k) && Q.length > 0) {
      const i1 = H(k);
      return s1.map(Q, (h1) => s1.filter(
        h1,
        (c1) => c1.label.toString().toLowerCase().includes(i1.toString().toLowerCase())
      ));
    }
    return Q;
  }, J = (Q) => {
    const i1 = H(k);
    let h1 = Q;
    return H(m) && i1 && Q.length > 0 && (h1 = s1.filter(Q, (c1) => {
      let M1 = !1;
      return c1 != null && c1.children ? (c1.children = J(c1.children), M1 = c1.children.length > 0) : c1 != null && c1.label && (M1 = c1.label.toString().toLowerCase().includes(i1.toString().toLowerCase())), M1;
    })), h1;
  }, K = g1(
    () => {
      if (H(u) === !0) {
        F();
        const Q = s1.map(H(s), (i1) => R(i1));
        return {
          children: J(Q)
        };
      }
      return { children: [] };
    }
  ), P = g1(() => {
    var Q;
    if (H(u) === !1) {
      let i1 = [];
      const h1 = ((Q = s == null ? void 0 : s.value) == null ? void 0 : Q.length) ?? 0;
      return F(), h1 > 0 && ((h == null ? void 0 : h.value) === !0 ? i1 = s1.map(s == null ? void 0 : s.value, (c1) => s1.map(c1, (M1) => R(M1))) : i1 = [
        s1.map(s == null ? void 0 : s.value, (c1) => R(c1))
      ]), V(i1);
    }
    return [];
  }), O = g1(() => H(u) ? !s1.isNil(H(K)) && H(K).children.length > 0 : !s1.isNil(H(P)) && H(P).length > 0), G = (Q) => {
    if (H(p) && H(z) instanceof Array)
      return H(z).includes(Q.value);
    if (H(i)) {
      const i1 = Q.type, h1 = H(z);
      return !s1.isNil(h1[i1]) && h1[i1] === Q.value;
    }
    return z.value === Q.value;
  }, j = (Q) => {
    H(d) === !1 && (Q == null ? void 0 : Q.disabled) !== !0 && (H(v) && (k.value = "", e.emit("searchClear")), x(Q), H(_) && M());
  };
  return l3(s, (Q, i1) => {
    const h1 = (M1, y1) => s1.isNil(M1) && s1.isNil(y1) ? !0 : M1 === y1, c1 = s1.isEqualWith(Q, i1, h1);
    D0(() => {
      c1 && (b.value = null);
      const M1 = H(q);
      M1 && M1.update();
    });
  }), l3(
    [z, P, K],
    ([Q, i1, h1]) => {
      s1.isNil(Q) || (H(u) === !1 ? s1.each(s1.flatten(H(i1)), (c1) => D(c1)) : s1.each(H(h1).children, (c1) => D(c1)));
    },
    { immediate: !0, deep: !0 }
  ), {
    extendedList: P,
    extendedTreeList: K,
    hasList: O,
    isSelected: G,
    handleClickItem: j
  };
}
function fS(t) {
  const e = t.toggle, n = t.handleClickItem;
  return {
    handleEnter: n,
    handleSpace: n,
    handleSpaceWithChild: e,
    handleEnterWithChild: e
  };
}
const om1 = {
  item: {
    type: Object,
    required: !0
  },
  valueKey: {
    type: String,
    required: !1,
    default: "value"
  },
  labelKey: {
    type: String,
    required: !1,
    default: "label"
  },
  childrenKey: {
    type: String,
    required: !1,
    default: "children"
  },
  value: {
    type: [String, Number],
    required: !1,
    default: ""
  },
  openIfChildActive: {
    type: Boolean,
    required: !1,
    default: !0
  },
  count: {
    type: Number,
    required: !1,
    default: -1
  },
  inputType: {
    type: String,
    required: !1,
    default: "radio"
    // checkbox or radio
  },
  forceOpen: {
    type: Boolean,
    required: !1,
    default: !1
  }
}, cm1 = c2({
  name: "Tree",
  emits: ["selectItem"],
  components: {
    EclIcon: Ie
  },
  props: om1,
  setup(t, { emit: e }) {
    const { item: n, value: i, openIfChildActive: s, labelKey: l, valueKey: a, childrenKey: o, count: h, forceOpen: u } = s3(t), d = h.value + 1, v = D1(H(u) ?? !1), m = n.value, p = `_item[${a.value}]_${d}_${s1.uniqueId()}`, _ = m && m[l.value], q = m && m[a.value], M = s1.isNil(_) || s1.isNil(q), z = g1(
      () => !!q && !!H(i) && q.toString() === H(i).toString()
    ), b = g1(() => m && m[o.value] ? m[o.value] : null), x = g1(() => b.value ? b.value.length : 0), k = g1(() => x.value > 0), F = g1(() => v.value === !0 ? 180 : 90);
    if (s.value === !0 && k.value === !0 && z.value === !1) {
      const O = (j) => {
        let Q = [];
        return s1.each(j, (i1) => {
          if (i1[o.value]) {
            const h1 = O(i1[o.value]);
            Q = s1.concat(Q, h1);
          }
          Q.push(i1.value.toString());
        }), Q;
      }, G = H(b);
      if (G) {
        const j = O(G);
        !s1.isNil(H(i)) && j.indexOf(H(i).toString()) >= 0 && (v.value = !0);
      }
    }
    const D = () => {
      v.value = !v.value;
    }, R = () => {
      v.value = !0;
    }, V = () => {
      v.value = !1;
    }, J = () => {
      v.value = !1;
    }, K = (O) => {
      e("selectItem", O);
    }, P = fS({
      close: V,
      toggle: D,
      handleClickItem: K
    });
    return {
      internalCount: d,
      isMain: M,
      ...P,
      id: p,
      label: _,
      inputValue: q,
      isSelected: z,
      listChildren: b,
      iconRotation: F,
      isOpen: v,
      hasChildren: k,
      toggle: D,
      open: R,
      close: V,
      blur: J,
      handleClickItem: K,
      EclIconSize: ye
    };
  }
}), vS = (t) => ($s("data-v-53bf505d"), t = t(), Us(), t), hm1 = ["data-child-visible"], um1 = ["id", "value", "type"], dm1 = ["for"], fm1 = {
  key: 0,
  class: "tree__checkbox"
}, vm1 = {
  key: 1,
  class: "tree__radio"
}, pm1 = /* @__PURE__ */ vS(() => /* @__PURE__ */ C("span", { class: "ecl-radio__box" }, [
  /* @__PURE__ */ C("span", { class: "ecl-radio__box-inner" })
], -1)), mm1 = [
  pm1
], gm1 = ["innerHTML"], ym1 = ["id", "value", "checked"], _m1 = ["for"], qm1 = {
  key: 0,
  class: "tree__checkbox"
}, wm1 = {
  key: 1,
  class: "tree__radio"
}, zm1 = /* @__PURE__ */ vS(() => /* @__PURE__ */ C("span", { class: "ecl-radio__box" }, [
  /* @__PURE__ */ C("span", { class: "ecl-radio__box-inner" })
], -1)), Mm1 = [
  zm1
], bm1 = ["innerHTML"], Lm1 = ["data-child-visible"];
function xm1(t, e, n, i, s, l) {
  const a = V2("ecl-icon"), o = V2("tree");
  return T(), N("div", {
    class: f2(["tree", { [`tree--level-${t.internalCount}`]: !0, "tree--main": t.isMain, "tree--has-children": t.hasChildren, "tree--leaf": !t.hasChildren }]),
    "data-child-visible": t.isOpen
  }, [
    t.label ? (T(), N(I3, { key: 0 }, [
      t.hasChildren ? (T(), N(I3, { key: 0 }, [
        C("input", {
          class: "tree__input",
          id: t.id,
          value: t.inputValue,
          type: t.inputType,
          onKeydown: [
            e[0] || (e[0] = P5(Et((h) => t.handleSpaceWithChild(t.item), ["prevent"]), ["space"])),
            e[1] || (e[1] = P5(Et((h) => t.handleEnterWithChild(t.item), ["prevent"]), ["enter"]))
          ]
        }, null, 40, um1),
        t.label ? (T(), N("label", {
          key: 0,
          class: "tree__label",
          for: t.id,
          tabindex: "-1",
          onClick: e[2] || (e[2] = (...h) => t.toggle && t.toggle(...h))
        }, [
          t.inputType === "checkbox" ? (T(), N("span", fm1, [
            _3(a, {
              class: "ecl-checkbox__icon",
              icon: "check",
              size: t.EclIconSize.S
            }, null, 8, ["size"])
          ])) : (T(), N("span", vm1, mm1)),
          _3(a, {
            class: "label__indicator",
            icon: "corner-arrow",
            rotate: t.iconRotation,
            size: t.EclIconSize.XS2
          }, null, 8, ["rotate", "size"]),
          C("span", { innerHTML: t.label }, null, 8, gm1)
        ], 8, dm1)) : m2("", !0)
      ], 64)) : (T(), N(I3, { key: 1 }, [
        C("input", {
          class: "tree__input",
          id: t.id,
          value: t.inputValue,
          checked: t.isSelected,
          type: "checkbox",
          onKeydown: [
            e[3] || (e[3] = P5(Et((h) => t.handleClickItem(t.item), ["prevent"]), ["space"])),
            e[4] || (e[4] = P5(Et((h) => t.handleClickItem(t.item), ["prevent"]), ["enter"]))
          ]
        }, null, 40, ym1),
        t.label ? (T(), N("label", {
          key: 0,
          class: "tree__label tree__label--hover",
          for: t.id,
          tabindex: "-1",
          onClick: e[5] || (e[5] = (h) => t.handleClickItem(t.item))
        }, [
          t.inputType === "checkbox" ? (T(), N("span", qm1, [
            _3(a, {
              class: "ecl-checkbox__icon",
              icon: "check",
              size: t.EclIconSize.S
            }, null, 8, ["size"])
          ])) : (T(), N("span", wm1, Mm1)),
          C("span", { innerHTML: t.label }, null, 8, bm1)
        ], 8, _m1)) : m2("", !0)
      ], 64)),
      t.hasChildren ? b6((T(), N("div", {
        key: 2,
        class: "tree__children",
        "data-child-visible": t.isOpen
      }, [
        (T(!0), N(I3, null, Ve(t.listChildren, (h, u) => (T(), v2(o, {
          count: t.internalCount,
          value: t.value,
          onSelectItem: t.handleClickItem,
          key: u,
          item: h,
          forceOpen: t.forceOpen
        }, null, 8, ["count", "value", "onSelectItem", "item", "forceOpen"]))), 128))
      ], 8, Lm1)), [
        [Na, t.isOpen]
      ]) : m2("", !0)
    ], 64)) : (T(!0), N(I3, { key: 1 }, Ve(t.listChildren, (h, u) => (T(), v2(o, {
      count: t.internalCount,
      value: t.value,
      onSelectItem: t.handleClickItem,
      key: u,
      item: h,
      forceOpen: t.forceOpen
    }, null, 8, ["count", "value", "onSelectItem", "item", "forceOpen"]))), 128))
  ], 10, hm1);
}
const Le = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [i, s] of e)
    n[i] = s;
  return n;
}, pS = /* @__PURE__ */ Le(cm1, [["render", xm1], ["__scopeId", "data-v-53bf505d"]]), or = {
  item: {
    type: Object,
    required: !0
  },
  valueKey: {
    type: String,
    required: !1,
    default: "value"
  },
  labelKey: {
    type: String,
    required: !1,
    default: "label"
  },
  childrenKey: {
    type: String,
    required: !1,
    default: "children"
  },
  value: {
    type: [String, Number],
    required: !1,
    default: ""
  },
  openIfChildActive: {
    type: Boolean,
    required: !1,
    default: !0
  },
  count: {
    type: Number,
    required: !1,
    default: -1
  },
  inputType: {
    type: String,
    required: !1,
    default: "radio"
    // checkbox or radio
  },
  forceOpen: {
    type: Boolean,
    required: !1,
    default: !1
  }
};
c2({
  name: "Tree",
  emits: ["selectItem"],
  components: {
    EclIcon: Ie
  },
  props: or,
  setup(t, { emit: e }) {
    const { item: n, value: i, openIfChildActive: s, labelKey: l, valueKey: a, childrenKey: o, count: h, forceOpen: u } = s3(t), d = h.value + 1, v = D1(H(u) ?? !1), m = n.value, p = `_item[${a.value}]_${d}_${s1.uniqueId()}`, _ = m && m[l.value], q = m && m[a.value], M = s1.isNil(_) || s1.isNil(q), z = g1(
      () => !!q && !!H(i) && q.toString() === H(i).toString()
    ), b = g1(() => m && m[o.value] ? m[o.value] : null), x = g1(() => b.value ? b.value.length : 0), k = g1(() => x.value > 0), F = g1(() => v.value === !0 ? 180 : 90);
    if (s.value === !0 && k.value === !0 && z.value === !1) {
      const O = (j) => {
        let Q = [];
        return s1.each(j, (i1) => {
          if (i1[o.value]) {
            const h1 = O(i1[o.value]);
            Q = s1.concat(Q, h1);
          }
          Q.push(i1.value.toString());
        }), Q;
      }, G = H(b);
      if (G) {
        const j = O(G);
        !s1.isNil(H(i)) && j.indexOf(H(i).toString()) >= 0 && (v.value = !0);
      }
    }
    const D = () => {
      v.value = !v.value;
    }, R = () => {
      v.value = !0;
    }, V = () => {
      v.value = !1;
    }, J = () => {
      v.value = !1;
    }, K = (O) => {
      e("selectItem", O);
    }, P = fS({
      close: V,
      toggle: D,
      handleClickItem: K
    });
    return {
      internalCount: d,
      isMain: M,
      ...P,
      id: p,
      label: _,
      inputValue: q,
      isSelected: z,
      listChildren: b,
      iconRotation: F,
      isOpen: v,
      hasChildren: k,
      toggle: D,
      open: R,
      close: V,
      blur: J,
      handleClickItem: K,
      EclIconSize: ye
    };
  }
});
const Sm1 = c2({
  name: "JclAutocomplete",
  components: {
    Tree: pS,
    EclIcon: Ie
  },
  emits: ["search", "searchClear", "open", "close", "selected", "deselected", "update:modelValue"],
  props: {
    size: {
      type: String,
      required: !1,
      default: "m"
      // xs, s, m, l
    },
    tree: {
      type: Boolean,
      required: !1,
      default: !1
    },
    id: {
      type: String,
      required: !1
    },
    list: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: [String, Number, Object, Array],
      required: !1,
      default: null
    },
    /**
     * Usare solo se il modello necessita di due o più valori
     * Definisce la key da utilizzare per definire le value nel modello (vedi esempio)
     *
     * es:
     *
     * props: {
     *   multipleModelKeyValue: 'itemType'
     * }
     *
     * lista: [
     *  {
     *    itemType: 'TERRITORIAL_SCOPE',
     *    id: 'BORDER',
     *    name: 'Border regions'
     *  },
     *  {
     *    itemType: 'TERRITORIAL_SCOPE',
     *    id: 'ARDECO',
     *    name: 'ARDECO'
     *  },
     *  {
     *    itemType: 'INDICATOR_SCOPE',
     *    id: 'Default',
     *    name: 'EU (Default indicators)'
     *  }
     * ]
     *
     *
     * model: {
     *   TERRITORIAL_SCOPE: null,
     *   INDICATOR_SCOPE: null
     * }
     *
     *
     */
    multipleModelKeyValue: {
      type: String,
      required: !1,
      default: null
    },
    multiple: {
      type: Boolean,
      required: !1,
      default: !1
    },
    multiplePlaceholder: {
      required: !1,
      type: String,
      default: () => "ecl.form.select.group_label"
    },
    // only if multiple is active
    // if value is -1 the limit will be removed
    multiplePlaceholderLimit: {
      required: !1,
      type: Number,
      default: () => 2
    },
    listGrouped: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    valueKey: {
      type: String,
      required: !1,
      default: "value"
    },
    labelKey: {
      type: String,
      required: !1,
      default: "label"
    },
    searchPlaceholder: {
      type: String,
      required: !0
    },
    hiddenPlaceholder: {
      type: Boolean,
      required: !1,
      default: !1
    },
    clearSearchOnSelect: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Close Dropdown on select item
     */
    closeOnSelection: {
      type: Boolean,
      required: !1,
      default: () => !0
    },
    theme: {
      type: String,
      required: !1,
      default: "dark"
      // dark, light
    },
    // Calcola la larghezza della select in base alla option più lunga (conteggio dei caratteri)
    calculateWidth: {
      type: Boolean,
      required: !1,
      default: !1
    },
    // dropdownWidth: {
    //   type: [String, Number],
    //   required: false,
    //   default: '100%'
    // },
    showArrowIcon: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showClearButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    defaultSearchAction: {
      type: Boolean,
      required: !1,
      default: !0
    },
    treeOnSearchOpen: {
      type: Boolean,
      required: !1,
      default: !0
    },
    treeForceOpen: or.forceOpen,
    treeChildrenKey: or.childrenKey,
    treeOpenIfChildActive: or.openIfChildActive,
    // Il wrapper che conterrà la select
    // se passato, viene usato per determinare l'altezza massima della dropdown
    contentWrapper: {
      type: HTMLElement,
      required: !1,
      default: void 0
    },
    dropdownPopperOptions: {
      type: Object,
      required: !1,
      default: {
        placement: "bottom-start"
      }
    },
    DEBUG: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t, e) {
    const n = d4(), i = D1(li()), s = s1.isNil(t.id) ? `autocomplete__${H(i)}` : t.id, l = cS(t, e), a = Zx(t, {
      UUID: i
    }), o = aS(t, e, {
      autocomplete: a
    }), h = dS(t, e, {
      dropdown: o,
      value: l
    });
    l3([() => t.list, h.extendedTreeList, l.forceOpenOnTree], () => {
      i.value = li();
    });
    const u = hS(t, {
      autocomplete: a,
      value: l
    }), d = oS({
      list: h,
      dropdown: o
    }), v = uS(t, {
      list: h,
      autocomplete: a
    }), m = g1(() => t.size === "l" ? ye.M : (t.size === "s", ye.XS)), p = () => {
      o.focusedOnDropdown.value === !1 && o.close();
    }, _ = () => {
      l.clear();
    }, q = g1(() => {
      if (t.showClearButton === !1)
        return t.showClearButton;
      const M = l.internalValue.value;
      return t.multiple ? M instanceof Array && (M == null ? void 0 : M.length) > 0 : !s1.isNil(M);
    });
    return l3(
      () => t.modelValue,
      (M) => {
        M && (l.internalValue.value = H(M), s1.isNil(M) && (l.internalSelectedObject.value = null));
      }
    ), {
      eclTheme: n.theme,
      UUID: i,
      mainId: s,
      ...l,
      ...a,
      ...o,
      ...h,
      ...u,
      ...d,
      ...v,
      handleBlurComponent: p,
      performClearSelection: _,
      canClearSelection: q,
      iconSize: m
    };
  }
}), Cm1 = ["title"], km1 = { class: "jcl-autocomplete__placeholder ecl-select" }, Em1 = { class: "placeholder__wrapper" }, Am1 = ["innerHTML"], Fm1 = { class: "ecl-form-group" }, Tm1 = { class: "jcl-autocomplete__container" }, Im1 = { class: "jcl-autocomplete__icon" }, Om1 = ["for"], Nm1 = ["disabled", "id", "placeholder", "aria-controls", "data-expanded"], Pm1 = ["id", "tabindex", "aria-expanded", "aria-label"], Bm1 = { class: "jcl-autocomplete__dropdown_wrapper" }, Vm1 = ["id", "value", "checked", "onKeydown", "onBlur"], Rm1 = ["for", "onClick"], Hm1 = { class: "item__checkbox_box" }, Dm1 = ["innerHTML"];
function $m1(t, e, n, i, s, l) {
  const a = V2("ecl-icon"), o = V2("tree");
  return T(), N("div", {
    class: f2(["jcl-autocomplete ecl-select__multiple", {
      [`jcl-autocomplete--mode-${t.multiple ? "multiple" : "single"}`]: !0,
      [`jcl-autocomplete--ecl-theme-${t.eclTheme}`]: !0,
      [`jcl-autocomplete--theme-${t.theme}`]: !0,
      [`jcl-autocomplete--size-${t.size}`]: !0,
      "jcl-autocomplete--disabled": t.disabled,
      "jcl-autocomplete--without-arrow": t.showArrowIcon === !1,
      "jcl-autocomplete--with-clear-selection": t.canClearSelection,
      "jcl-autocomplete--calculate-width": t.calculateWidth
    }]),
    ref: t.addBlurElementRef,
    title: t.placeholderShow ? t.placeholderText : null
  }, [
    b6(C("div", km1, [
      C("div", Em1, [
        t.placeholderItemSelection ? (T(), N(I3, { key: 0 }, [
          J2(t.$slots, "placeholder_before", {}, void 0, !0),
          J2(t.$slots, "placeholder", {
            item: t.placeholderItemSelection,
            text: t.placeholderText
          }, () => [
            C("span", { innerHTML: t.placeholderText }, null, 8, Am1)
          ], !0),
          J2(t.$slots, "placeholder_after", {}, void 0, !0)
        ], 64)) : m2("", !0)
      ])
    ], 512), [
      [Na, t.placeholderShow]
    ]),
    C("div", Fm1, [
      J2(t.$slots, "default", {
        disabled: t.disabled,
        onFocus: t.onFocus,
        onBlur: t.globalBlurEvent,
        dropdownClose: t.close,
        dropdownOpen: t.open,
        dropdownIsOpen: t.isOpen,
        dropdownToggle: t.toggleDropdown,
        style: Rt(t.calculatedStyles),
        arias: {
          role: "textbox",
          "data-expanded": !t.isOpen,
          "aria-controls": t.mainId,
          "aria-haspopup": "listbox",
          "aria-autocomplete": "list"
        }
      }, () => [
        C("div", Tm1, [
          t.canClearSelection ? (T(), N("div", {
            key: 0,
            class: "jcl-autocomplete__clear",
            onClick: e[0] || (e[0] = (...h) => t.performClearSelection && t.performClearSelection(...h))
          }, [
            C("div", Im1, [
              _3(a, {
                class: "jcl-autocomplete__icon-shape",
                icon: "plus",
                size: "m"
              })
            ])
          ])) : m2("", !0),
          C("label", {
            hidden: "",
            class: "ecl-form-label",
            for: t.searchId
          }, pt(t.searchPlaceholder), 9, Om1),
          b6(C("input", {
            style: Rt(t.calculatedStyles),
            disabled: t.disabled,
            id: t.searchId,
            ref: "searchInputElement",
            class: "jcl-autocomplete__input ecl-select ecl-u-mt-none",
            placeholder: t.searchPlaceholder,
            autocomplete: "off",
            type: "text",
            "onUpdate:modelValue": e[1] || (e[1] = (h) => t.searchValue = h),
            onInput: e[2] || (e[2] = (...h) => t.performInputChange && t.performInputChange(...h)),
            onFocus: e[3] || (e[3] = (...h) => t.onFocus && t.onFocus(...h)),
            onBlur: e[4] || (e[4] = (...h) => t.globalBlurEvent && t.globalBlurEvent(...h)),
            "aria-controls": t.mainId,
            "aria-haspopup": "listbox",
            "data-expanded": !t.isOpen,
            "aria-autocomplete": "list"
          }, null, 44, Nm1), [
            [WA, t.searchValue]
          ]),
          t.showArrowIcon ? (T(), N("div", {
            key: 1,
            class: "jcl-autocomplete__icon",
            onClick: e[5] || (e[5] = (...h) => t.toggleDropdown && t.toggleDropdown(...h))
          }, [
            J2(t.$slots, "icon", {}, () => [
              _3(a, {
                class: "jcl-autocomplete__icon-shape",
                icon: "corner-arrow",
                rotate: t.isOpen ? 0 : 180,
                size: t.iconSize
              }, null, 8, ["rotate", "size"])
            ], !0)
          ])) : m2("", !0)
        ])
      ], !0)
    ]),
    C("div", {
      id: t.mainId,
      tabindex: t.tabindex,
      class: f2(["jcl-autocomplete__dropdown", { "jcl-autocomplete__dropdown--open ecl-select__multiple-dropdown": t.isOpen, "jcl-autocomplete__dropdown--has-list": t.hasList }]),
      "aria-expanded": !t.isOpen,
      "aria-label": `Dropdown ${t.searchPlaceholder}`,
      role: "listbox"
    }, [
      b6(C("div", Bm1, [
        t.hasList && t.isOpen ? (T(), N(I3, { key: 0 }, [
          t.tree ? (T(), N(I3, { key: 0 }, [
            t.list && t.list.length > 0 ? (T(), v2(o, {
              key: t.UUID,
              class: "tree",
              value: t.internalValue,
              item: t.extendedTreeList,
              valueKey: t.valueKey,
              labelKey: t.labelKey,
              childrenKey: t.treeChildrenKey,
              disabled: t.disabled,
              openIfChildActive: t.treeOpenIfChildActive,
              forceOpen: t.forceOpenOnTree,
              onSelectItem: t.handleClickItem
            }, null, 8, ["value", "item", "valueKey", "labelKey", "childrenKey", "disabled", "openIfChildActive", "forceOpen", "onSelectItem"])) : m2("", !0)
          ], 64)) : (T(!0), N(I3, { key: 1 }, Ve(t.extendedList, (h, u) => (T(), N("div", {
            class: "dropdown__group",
            key: u
          }, [
            J2(t.$slots, "group_name", { list: h }, void 0, !0),
            (T(!0), N(I3, null, Ve(h, (d, v) => (T(), N("div", {
              class: f2(["dropdown__item", { "dropdown__item--multiple": t.multiple, "dropdown__item--disabled": d == null ? void 0 : d.disabled }]),
              key: v
            }, [
              C("input", {
                class: "ecl-checkbox__input",
                type: "checkbox",
                id: `${t.mainId}__option-${d.value}`,
                value: d.value,
                checked: t.isSelected(d),
                disabled: "{{ item?.disabled ?? false }}",
                onKeydown: [
                  P5(Et((m) => t.handleSpace(d), ["prevent"]), ["space"]),
                  P5(Et((m) => t.handleEnter(d), ["prevent"]), ["enter"]),
                  P5(Et((m) => t.handleArrowUp(d), ["prevent"]), ["up"]),
                  P5(Et((m) => t.handleArrowDown(d), ["prevent"]), ["down"])
                ],
                onBlur: (m) => t.handleItemBlur(d)
              }, null, 40, Vm1),
              C("label", {
                class: "ecl-checkbox__label",
                for: `unit_level__option-${v}`,
                onClick: Et((m) => t.handleClickItem(d), ["stop", "prevent"])
              }, [
                t.multiple ? J2(t.$slots, "checkbox", {
                  key: 0,
                  checked: t.isSelected(d),
                  iconSize: "s"
                }, () => [
                  C("span", Hm1, [
                    _3(a, {
                      class: "checkbox__icon",
                      icon: "check",
                      size: "s"
                    })
                  ])
                ], !0) : m2("", !0),
                J2(t.$slots, "item", {
                  item: d._original
                }, () => [
                  C("span", {
                    class: "item__name",
                    innerHTML: d.label
                  }, null, 8, Dm1)
                ], !0)
              ], 8, Rm1)
            ], 2))), 128))
          ]))), 128))
        ], 64)) : m2("", !0)
      ], 512), [
        [Na, t.hasList && t.isOpen]
      ])
    ], 10, Pm1)
  ], 10, Cm1);
}
const Vu = /* @__PURE__ */ Le(Sm1, [["render", $m1], ["__scopeId", "data-v-3bce8d9f"]]);
c2({
  name: "JclAutocomplete",
  components: {
    Tree: pS,
    EclIcon: Ie
  },
  emits: ["search", "searchClear", "open", "close", "selected", "deselected", "update:modelValue"],
  props: {
    size: {
      type: String,
      required: !1,
      default: "m"
      // xs, s, m, l
    },
    tree: {
      type: Boolean,
      required: !1,
      default: !1
    },
    id: {
      type: String,
      required: !1
    },
    list: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: [String, Number, Object, Array],
      required: !1,
      default: null
    },
    /**
     * Usare solo se il modello necessita di due o più valori
     * Definisce la key da utilizzare per definire le value nel modello (vedi esempio)
     *
     * es:
     *
     * props: {
     *   multipleModelKeyValue: 'itemType'
     * }
     *
     * lista: [
     *  {
     *    itemType: 'TERRITORIAL_SCOPE',
     *    id: 'BORDER',
     *    name: 'Border regions'
     *  },
     *  {
     *    itemType: 'TERRITORIAL_SCOPE',
     *    id: 'ARDECO',
     *    name: 'ARDECO'
     *  },
     *  {
     *    itemType: 'INDICATOR_SCOPE',
     *    id: 'Default',
     *    name: 'EU (Default indicators)'
     *  }
     * ]
     *
     *
     * model: {
     *   TERRITORIAL_SCOPE: null,
     *   INDICATOR_SCOPE: null
     * }
     *
     *
     */
    multipleModelKeyValue: {
      type: String,
      required: !1,
      default: null
    },
    multiple: {
      type: Boolean,
      required: !1,
      default: !1
    },
    multiplePlaceholder: {
      required: !1,
      type: String,
      default: () => "ecl.form.select.group_label"
    },
    // only if multiple is active
    // if value is -1 the limit will be removed
    multiplePlaceholderLimit: {
      required: !1,
      type: Number,
      default: () => 2
    },
    listGrouped: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    valueKey: {
      type: String,
      required: !1,
      default: "value"
    },
    labelKey: {
      type: String,
      required: !1,
      default: "label"
    },
    searchPlaceholder: {
      type: String,
      required: !0
    },
    hiddenPlaceholder: {
      type: Boolean,
      required: !1,
      default: !1
    },
    clearSearchOnSelect: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Close Dropdown on select item
     */
    closeOnSelection: {
      type: Boolean,
      required: !1,
      default: () => !0
    },
    theme: {
      type: String,
      required: !1,
      default: "dark"
      // dark, light
    },
    // Calcola la larghezza della select in base alla option più lunga (conteggio dei caratteri)
    calculateWidth: {
      type: Boolean,
      required: !1,
      default: !1
    },
    // dropdownWidth: {
    //   type: [String, Number],
    //   required: false,
    //   default: '100%'
    // },
    showArrowIcon: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showClearButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    defaultSearchAction: {
      type: Boolean,
      required: !1,
      default: !0
    },
    treeOnSearchOpen: {
      type: Boolean,
      required: !1,
      default: !0
    },
    treeForceOpen: or.forceOpen,
    treeChildrenKey: or.childrenKey,
    treeOpenIfChildActive: or.openIfChildActive,
    // Il wrapper che conterrà la select
    // se passato, viene usato per determinare l'altezza massima della dropdown
    contentWrapper: {
      type: HTMLElement,
      required: !1,
      default: void 0
    },
    dropdownPopperOptions: {
      type: Object,
      required: !1,
      default: {
        placement: "bottom-start"
      }
    },
    DEBUG: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(t, e) {
    const n = d4(), i = D1(li()), s = s1.isNil(t.id) ? `autocomplete__${H(i)}` : t.id, l = cS(t, e), a = Zx(t, {
      UUID: i
    }), o = aS(t, e, {
      autocomplete: a
    }), h = dS(t, e, {
      dropdown: o,
      value: l
    });
    l3([() => t.list, h.extendedTreeList, l.forceOpenOnTree], () => {
      i.value = li();
    });
    const u = hS(t, {
      autocomplete: a,
      value: l
    }), d = oS({
      list: h,
      dropdown: o
    }), v = uS(t, {
      list: h,
      autocomplete: a
    }), m = g1(() => t.size === "l" ? ye.M : (t.size === "s", ye.XS)), p = () => {
      o.focusedOnDropdown.value === !1 && o.close();
    }, _ = () => {
      l.clear();
    }, q = g1(() => {
      if (t.showClearButton === !1)
        return t.showClearButton;
      const M = l.internalValue.value;
      return t.multiple ? M instanceof Array && (M == null ? void 0 : M.length) > 0 : !s1.isNil(M);
    });
    return l3(
      () => t.modelValue,
      (M) => {
        M && (l.internalValue.value = H(M), s1.isNil(M) && (l.internalSelectedObject.value = null));
      }
    ), {
      eclTheme: n.theme,
      UUID: i,
      mainId: s,
      ...l,
      ...a,
      ...o,
      ...h,
      ...u,
      ...d,
      ...v,
      handleBlurComponent: p,
      performClearSelection: _,
      canClearSelection: q,
      iconSize: m
    };
  }
});
const Um1 = c2({
  name: "JclHighcharts",
  emits: ["updated", "rendered", "destroyed"],
  props: {
    type: {
      type: String,
      default: "chart"
    },
    options: {
      type: Object,
      required: !0
    },
    series: {
      type: Object,
      required: !0
    },
    redrawOnUpdate: {
      type: Boolean,
      default: !1
    },
    oneToOneOnUpdate: {
      type: Boolean,
      default: !1
    },
    animateOnUpdate: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { emit: e }) {
    const n = D1(), i = D1(), { options: s, series: l } = s3(t), a = () => {
      var u;
      const o = window.Highcharts, h = (u = o == null ? void 0 : o.AST) == null ? void 0 : u.allowedAttributes;
      h && h.push("alt"), o && o[t.type] ? l3(
        [s, l],
        ([d, v]) => {
          const m = s1.assign(d, { series: v });
          i.value = o[t.type](n.value, m, () => {
            D0(() => {
              e("rendered");
            });
          });
        },
        {
          immediate: !0
        }
      ) : t.options ? console.warn(`${t.type} is not a valid highcharts type or has not been imported`) : console.warn('The "options" parameter is required.');
    };
    return mn(() => {
      const o = H(i);
      o && o.destroy(), D0(() => {
        e("destroyed");
      });
    }), d0(() => {
      new mS().load().then(
        () => {
          a();
        },
        (h) => {
          throw console.error("JclHighchartsLoader Error:", h), new Error("JclHighchartsLoader Error: " + h);
        }
      );
    }), {
      chartRef: n,
      chart: i
    };
  }
}), jm1 = {
  class: "jcl-highcharts",
  ref: "chartRef"
};
function Gm1(t, e, n, i, s, l) {
  return T(), N("div", jm1, null, 512);
}
const oj1 = /* @__PURE__ */ Le(Um1, [["render", Gm1]]);
c2({
  name: "JclHighcharts",
  emits: ["updated", "rendered", "destroyed"],
  props: {
    type: {
      type: String,
      default: "chart"
    },
    options: {
      type: Object,
      required: !0
    },
    series: {
      type: Object,
      required: !0
    },
    redrawOnUpdate: {
      type: Boolean,
      default: !1
    },
    oneToOneOnUpdate: {
      type: Boolean,
      default: !1
    },
    animateOnUpdate: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { emit: e }) {
    const n = D1(), i = D1(), { options: s, series: l } = s3(t), a = () => {
      var u;
      const o = window.Highcharts, h = (u = o == null ? void 0 : o.AST) == null ? void 0 : u.allowedAttributes;
      h && h.push("alt"), o && o[t.type] ? l3(
        [s, l],
        ([d, v]) => {
          const m = s1.assign(d, { series: v });
          i.value = o[t.type](n.value, m, () => {
            D0(() => {
              e("rendered");
            });
          });
        },
        {
          immediate: !0
        }
      ) : t.options ? console.warn(`${t.type} is not a valid highcharts type or has not been imported`) : console.warn('The "options" parameter is required.');
    };
    return mn(() => {
      const o = H(i);
      o && o.destroy(), D0(() => {
        e("destroyed");
      });
    }), d0(() => {
      new mS().load().then(
        () => {
          a();
        },
        (h) => {
          throw console.error("JclHighchartsLoader Error:", h), new Error("JclHighchartsLoader Error: " + h);
        }
      );
    }), {
      chartRef: n,
      chart: i
    };
  }
});
class mS {
  constructor() {
    O2(this, "tries", 0);
    O2(this, "totalTries", 5);
    O2(this, "_DEBUG", !1);
  }
  async load(e = []) {
    return new Promise((n, i) => {
      const s = window.$wt, l = () => {
        this._DEBUG;
        const a = window.$wt;
        this._DEBUG, a.load(
          [
            "https://europa.eu/webtools/webtools.charts.js?version=2.0&theme=eu&core=latest&plugins=highcharts-default-highcharts-stock,highcharts-boost,highcharts-more,highcharts-dumbbell,highcharts-more,highcharts-exporting,highcharts-offline-exporting,highcharts-export-data,highcharts-data,highcharts-accessibility,highcharts-init:formatted",
            ...e
          ],
          () => {
            this._DEBUG, this.init(n, i);
          }
        );
      };
      if (s1.isNil(s)) {
        this._DEBUG;
        const a = document.createElement("script");
        a.setAttribute("src", "//europa.eu/webtools/load.js"), a.onload = () => {
          l();
        }, document.head.appendChild(a);
      } else {
        const a = window.Highcharts;
        this._DEBUG, s1.isNil(a) ? (this._DEBUG, l()) : (this._DEBUG, this.init(n, i));
      }
    });
  }
  /**
   * Reale inizializzazione del componenete e di Highcharts
   */
  init(e, n) {
    window.Highcharts ? e(!0) : (this._DEBUG, this.tries <= this.totalTries ? (setTimeout(() => {
      this._DEBUG, this.load().then(
        () => e(!0),
        (s) => {
          this._DEBUG && console.error("Highcharts loading error", s), n(!1);
        }
      );
    }, 250 * this.tries), this.tries++) : (n(!1), this._DEBUG && console.warn("Highcharts has not been imported")));
  }
}
const Ho = {
  // use the radius of the Normal sphere
  radians: 6370997 / (2 * Math.PI),
  degrees: 2 * Math.PI * 6370997 / 360,
  ft: 0.3048,
  m: 1,
  "us-ft": 1200 / 3937
};
let Wm1 = class {
  /**
   * @param {Options} options Projection options.
   */
  constructor(e) {
    this.code_ = e.code, this.units_ = /** @type {import("./Units.js").Units} */
    e.units, this.extent_ = e.extent !== void 0 ? e.extent : null, this.worldExtent_ = e.worldExtent !== void 0 ? e.worldExtent : null, this.axisOrientation_ = e.axisOrientation !== void 0 ? e.axisOrientation : "enu", this.global_ = e.global !== void 0 ? e.global : !1, this.canWrapX_ = !!(this.global_ && this.extent_), this.getPointResolutionFunc_ = e.getPointResolution, this.defaultTileGrid_ = null, this.metersPerUnit_ = e.metersPerUnit;
  }
  /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */
  canWrapX() {
    return this.canWrapX_;
  }
  /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */
  getCode() {
    return this.code_;
  }
  /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getExtent() {
    return this.extent_;
  }
  /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */
  getUnits() {
    return this.units_;
  }
  /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */
  getMetersPerUnit() {
    return this.metersPerUnit_ || Ho[this.units_];
  }
  /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getWorldExtent() {
    return this.worldExtent_;
  }
  /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */
  getAxisOrientation() {
    return this.axisOrientation_;
  }
  /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */
  isGlobal() {
    return this.global_;
  }
  /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */
  setGlobal(e) {
    this.global_ = e, this.canWrapX_ = !!(e && this.extent_);
  }
  /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */
  getDefaultTileGrid() {
    return this.defaultTileGrid_;
  }
  /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */
  setDefaultTileGrid(e) {
    this.defaultTileGrid_ = e;
  }
  /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */
  setExtent(e) {
    this.extent_ = e, this.canWrapX_ = !!(this.global_ && e);
  }
  /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */
  setWorldExtent(e) {
    this.worldExtent_ = e;
  }
  /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */
  setGetPointResolution(e) {
    this.getPointResolutionFunc_ = e;
  }
  /**
   * Get the custom point resolution function for this projection (if set).
   * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
   * resolution function (if set).
   */
  getPointResolutionFunc() {
    return this.getPointResolutionFunc_;
  }
};
const D_ = Wm1, qc = 6378137, va = Math.PI * qc, Ym1 = [-va, -va, va, va], Xm1 = [-180, -85, 180, 85], Gc = qc * Math.log(Math.tan(Math.PI / 2));
class Wr extends D_ {
  /**
   * @param {string} code Code.
   */
  constructor(e) {
    super({
      code: e,
      units: "m",
      extent: Ym1,
      global: !0,
      worldExtent: Xm1,
      getPointResolution: function(n, i) {
        return n / Math.cosh(i[1] / qc);
      }
    });
  }
}
const pz = [
  new Wr("EPSG:3857"),
  new Wr("EPSG:102100"),
  new Wr("EPSG:102113"),
  new Wr("EPSG:900913"),
  new Wr("http://www.opengis.net/def/crs/EPSG/0/3857"),
  new Wr("http://www.opengis.net/gml/srs/epsg.xml#3857")
];
function Km1(t, e, n) {
  const i = t.length;
  n = n > 1 ? n : 2, e === void 0 && (n > 2 ? e = t.slice() : e = new Array(i));
  for (let s = 0; s < i; s += n) {
    e[s] = va * t[s] / 180;
    let l = qc * Math.log(Math.tan(Math.PI * (+t[s + 1] + 90) / 360));
    l > Gc ? l = Gc : l < -Gc && (l = -Gc), e[s + 1] = l;
  }
  return e;
}
function Zm1(t, e, n) {
  const i = t.length;
  n = n > 1 ? n : 2, e === void 0 && (n > 2 ? e = t.slice() : e = new Array(i));
  for (let s = 0; s < i; s += n)
    e[s] = 180 * t[s] / va, e[s + 1] = 360 * Math.atan(Math.exp(t[s + 1] / qc)) / Math.PI - 90;
  return e;
}
const Jm1 = 6378137, mz = [-180, -90, 180, 90], Qm1 = Math.PI * Jm1 / 180;
class Gl extends D_ {
  /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */
  constructor(e, n) {
    super({
      code: e,
      units: "degrees",
      extent: mz,
      axisOrientation: n,
      global: !0,
      metersPerUnit: Qm1,
      worldExtent: mz
    });
  }
}
const gz = [
  new Gl("CRS:84"),
  new Gl("EPSG:4326", "neu"),
  new Gl("urn:ogc:def:crs:OGC:1.3:CRS84"),
  new Gl("urn:ogc:def:crs:OGC:2:84"),
  new Gl("http://www.opengis.net/def/crs/OGC/1.3/CRS84"),
  new Gl("http://www.opengis.net/gml/srs/epsg.xml#4326", "neu"),
  new Gl("http://www.opengis.net/def/crs/EPSG/0/4326", "neu")
];
let yy = {};
function eg1(t) {
  return yy[t] || yy[t.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, "EPSG:$3")] || null;
}
function tg1(t, e) {
  yy[t] = e;
}
function wc(t) {
  for (const e in t)
    delete t[e];
}
function mr(t) {
  let e;
  for (e in t)
    return !1;
  return !e;
}
let La = {};
function Ha(t, e, n) {
  const i = t.getCode(), s = e.getCode();
  i in La || (La[i] = {}), La[i][s] = n;
}
function gS(t, e) {
  let n;
  return t in La && e in La[t] && (n = La[t][e]), n;
}
const F4 = {
  UNKNOWN: 0,
  INTERSECTING: 1,
  ABOVE: 2,
  RIGHT: 4,
  BELOW: 8,
  LEFT: 16
};
function _y(t) {
  const e = U0();
  for (let n = 0, i = t.length; n < i; ++n)
    xo(e, t[n]);
  return e;
}
function ng1(t, e, n) {
  const i = Math.min.apply(null, t), s = Math.min.apply(null, e), l = Math.max.apply(null, t), a = Math.max.apply(null, e);
  return M8(i, s, l, a, n);
}
function Do(t, e, n) {
  return n ? (n[0] = t[0] - e, n[1] = t[1] - e, n[2] = t[2] + e, n[3] = t[3] + e, n) : [
    t[0] - e,
    t[1] - e,
    t[2] + e,
    t[3] + e
  ];
}
function yS(t, e) {
  return e ? (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e) : t.slice();
}
function br(t, e, n) {
  let i, s;
  return e < t[0] ? i = t[0] - e : t[2] < e ? i = e - t[2] : i = 0, n < t[1] ? s = t[1] - n : t[3] < n ? s = n - t[3] : s = 0, i * i + s * s;
}
function Da(t, e) {
  return $_(t, e[0], e[1]);
}
function tr(t, e) {
  return t[0] <= e[0] && e[2] <= t[2] && t[1] <= e[1] && e[3] <= t[3];
}
function $_(t, e, n) {
  return t[0] <= e && e <= t[2] && t[1] <= n && n <= t[3];
}
function qy(t, e) {
  const n = t[0], i = t[1], s = t[2], l = t[3], a = e[0], o = e[1];
  let h = F4.UNKNOWN;
  return a < n ? h = h | F4.LEFT : a > s && (h = h | F4.RIGHT), o < i ? h = h | F4.BELOW : o > l && (h = h | F4.ABOVE), h === F4.UNKNOWN && (h = F4.INTERSECTING), h;
}
function U0() {
  return [1 / 0, 1 / 0, -1 / 0, -1 / 0];
}
function M8(t, e, n, i, s) {
  return s ? (s[0] = t, s[1] = e, s[2] = n, s[3] = i, s) : [t, e, n, i];
}
function s9(t) {
  return M8(1 / 0, 1 / 0, -1 / 0, -1 / 0, t);
}
function _S(t, e) {
  const n = t[0], i = t[1];
  return M8(n, i, n, i, e);
}
function U_(t, e, n, i, s) {
  const l = s9(s);
  return qS(l, t, e, n, i);
}
function $o(t, e) {
  return t[0] == e[0] && t[2] == e[2] && t[1] == e[1] && t[3] == e[3];
}
function j_(t, e) {
  return e[0] < t[0] && (t[0] = e[0]), e[2] > t[2] && (t[2] = e[2]), e[1] < t[1] && (t[1] = e[1]), e[3] > t[3] && (t[3] = e[3]), t;
}
function xo(t, e) {
  e[0] < t[0] && (t[0] = e[0]), e[0] > t[2] && (t[2] = e[0]), e[1] < t[1] && (t[1] = e[1]), e[1] > t[3] && (t[3] = e[1]);
}
function qS(t, e, n, i, s) {
  for (; n < i; n += s)
    ig1(t, e[n], e[n + 1]);
  return t;
}
function ig1(t, e, n) {
  t[0] = Math.min(t[0], e), t[1] = Math.min(t[1], n), t[2] = Math.max(t[2], e), t[3] = Math.max(t[3], n);
}
function wS(t, e) {
  let n;
  return n = e(Ru(t)), n || (n = e(Hu(t)), n) || (n = e(Du(t)), n) || (n = e(Lr(t)), n) ? n : !1;
}
function Uo(t) {
  let e = 0;
  return zc(t) || (e = ue(t) * G4(t)), e;
}
function Ru(t) {
  return [t[0], t[1]];
}
function Hu(t) {
  return [t[2], t[1]];
}
function Is(t) {
  return [(t[0] + t[2]) / 2, (t[1] + t[3]) / 2];
}
function sg1(t, e) {
  let n;
  if (e === "bottom-left")
    n = Ru(t);
  else if (e === "bottom-right")
    n = Hu(t);
  else if (e === "top-left")
    n = Lr(t);
  else if (e === "top-right")
    n = Du(t);
  else
    throw new Error("Invalid corner");
  return n;
}
function wy(t, e, n, i, s) {
  const [l, a, o, h, u, d, v, m] = lg1(
    t,
    e,
    n,
    i
  );
  return M8(
    Math.min(l, o, u, v),
    Math.min(a, h, d, m),
    Math.max(l, o, u, v),
    Math.max(a, h, d, m),
    s
  );
}
function lg1(t, e, n, i) {
  const s = e * i[0] / 2, l = e * i[1] / 2, a = Math.cos(n), o = Math.sin(n), h = s * a, u = s * o, d = l * a, v = l * o, m = t[0], p = t[1];
  return [
    m - h + v,
    p - u - d,
    m - h - v,
    p - u + d,
    m + h - v,
    p + u + d,
    m + h + v,
    p + u - d,
    m - h + v,
    p - u - d
  ];
}
function G4(t) {
  return t[3] - t[1];
}
function rn(t, e, n) {
  const i = n || U0();
  return r0(t, e) ? (t[0] > e[0] ? i[0] = t[0] : i[0] = e[0], t[1] > e[1] ? i[1] = t[1] : i[1] = e[1], t[2] < e[2] ? i[2] = t[2] : i[2] = e[2], t[3] < e[3] ? i[3] = t[3] : i[3] = e[3]) : s9(i), i;
}
function Lr(t) {
  return [t[0], t[3]];
}
function Du(t) {
  return [t[2], t[3]];
}
function ue(t) {
  return t[2] - t[0];
}
function r0(t, e) {
  return t[0] <= e[2] && t[2] >= e[0] && t[1] <= e[3] && t[3] >= e[1];
}
function zc(t) {
  return t[2] < t[0] || t[3] < t[1];
}
function rg1(t, e) {
  return e ? (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e) : t;
}
function ag1(t, e, n) {
  let i = !1;
  const s = qy(t, e), l = qy(t, n);
  if (s === F4.INTERSECTING || l === F4.INTERSECTING)
    i = !0;
  else {
    const a = t[0], o = t[1], h = t[2], u = t[3], d = e[0], v = e[1], m = n[0], p = n[1], _ = (p - v) / (m - d);
    let q, M;
    l & F4.ABOVE && !(s & F4.ABOVE) && (q = m - (p - u) / _, i = q >= a && q <= h), !i && l & F4.RIGHT && !(s & F4.RIGHT) && (M = p - (m - h) * _, i = M >= o && M <= u), !i && l & F4.BELOW && !(s & F4.BELOW) && (q = m - (p - o) / _, i = q >= a && q <= h), !i && l & F4.LEFT && !(s & F4.LEFT) && (M = p - (m - a) * _, i = M >= o && M <= u);
  }
  return i;
}
function og1(t, e, n, i) {
  if (zc(t))
    return s9(n);
  let s = [];
  if (i > 1) {
    const o = t[2] - t[0], h = t[3] - t[1];
    for (let u = 0; u < i; ++u)
      s.push(
        t[0] + o * u / i,
        t[1],
        t[2],
        t[1] + h * u / i,
        t[2] - o * u / i,
        t[3],
        t[0],
        t[3] - h * u / i
      );
  } else
    s = [
      t[0],
      t[1],
      t[2],
      t[1],
      t[2],
      t[3],
      t[0],
      t[3]
    ];
  e(s, s, 2);
  const l = [], a = [];
  for (let o = 0, h = s.length; o < h; o += 2)
    l.push(s[o]), a.push(s[o + 1]);
  return ng1(l, a, n);
}
function zS(t, e) {
  const n = e.getExtent(), i = Is(t);
  if (e.canWrapX() && (i[0] < n[0] || i[0] >= n[2])) {
    const s = ue(n), a = Math.floor(
      (i[0] - n[0]) / s
    ) * s;
    t[0] -= a, t[2] -= a;
  }
  return t;
}
function G_(t, e, n) {
  if (e.canWrapX()) {
    const i = e.getExtent();
    if (!isFinite(t[0]) || !isFinite(t[2]))
      return [[i[0], t[1], i[2], t[3]]];
    zS(t, e);
    const s = ue(i);
    if (ue(t) > s && !n)
      return [[i[0], t[1], i[2], t[3]]];
    if (t[0] < i[0])
      return [
        [t[0] + s, t[1], i[2], t[3]],
        [i[0], t[1], t[2], t[3]]
      ];
    if (t[2] > i[2])
      return [
        [t[0], t[1], i[2], t[3]],
        [i[0], t[1], t[2] - s, t[3]]
      ];
  }
  return [t];
}
function bt(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function cg1(t, e, n, i, s, l) {
  const a = s - n, o = l - i;
  if (a !== 0 || o !== 0) {
    const h = ((t - n) * a + (e - i) * o) / (a * a + o * o);
    h > 1 ? (n = s, i = l) : h > 0 && (n += a * h, i += o * h);
  }
  return cr(t, e, n, i);
}
function cr(t, e, n, i) {
  const s = n - t, l = i - e;
  return s * s + l * l;
}
function hg1(t) {
  const e = t.length;
  for (let i = 0; i < e; i++) {
    let s = i, l = Math.abs(t[i][i]);
    for (let o = i + 1; o < e; o++) {
      const h = Math.abs(t[o][i]);
      h > l && (l = h, s = o);
    }
    if (l === 0)
      return null;
    const a = t[s];
    t[s] = t[i], t[i] = a;
    for (let o = i + 1; o < e; o++) {
      const h = -t[o][i] / t[i][i];
      for (let u = i; u < e + 1; u++)
        i == u ? t[o][u] = 0 : t[o][u] += h * t[i][u];
    }
  }
  const n = new Array(e);
  for (let i = e - 1; i >= 0; i--) {
    n[i] = t[i][e] / t[i][i];
    for (let s = i - 1; s >= 0; s--)
      t[s][e] -= t[s][i] * n[i];
  }
  return n;
}
function yh(t) {
  return t * Math.PI / 180;
}
function hr(t, e) {
  const n = t % e;
  return n * e < 0 ? n + e : n;
}
function V0(t, e, n) {
  return t + n * (e - t);
}
function $u(t, e) {
  const n = Math.pow(10, e);
  return Math.round(t * n) / n;
}
function yz(t, e) {
  return Math.round($u(t, e));
}
function Wc(t, e) {
  return Math.floor($u(t, e));
}
function Yc(t, e) {
  return Math.ceil($u(t, e));
}
function MS(t, e) {
  const n = ("" + t).split("."), i = ("" + e).split(".");
  for (let s = 0; s < Math.max(n.length, i.length); s++) {
    const l = parseInt(n[s] || "0", 10), a = parseInt(i[s] || "0", 10);
    if (l > a)
      return 1;
    if (a > l)
      return -1;
  }
  return 0;
}
function ug1(t, e) {
  return t[0] += +e[0], t[1] += +e[1], t;
}
function $h(t, e) {
  let n = !0;
  for (let i = t.length - 1; i >= 0; --i)
    if (t[i] != e[i]) {
      n = !1;
      break;
    }
  return n;
}
function W_(t, e) {
  const n = Math.cos(e), i = Math.sin(e), s = t[0] * n - t[1] * i, l = t[1] * n + t[0] * i;
  return t[0] = s, t[1] = l, t;
}
function dg1(t, e) {
  return t[0] *= e, t[1] *= e, t;
}
function bS(t, e) {
  if (e.canWrapX()) {
    const n = ue(e.getExtent()), i = LS(t, e, n);
    i && (t[0] -= i * n);
  }
  return t;
}
function LS(t, e, n) {
  const i = e.getExtent();
  let s = 0;
  return e.canWrapX() && (t[0] < i[0] || t[0] > i[2]) && (n = n || ue(i), s = Math.floor(
    (t[0] - i[0]) / n
  )), s;
}
const fg1 = 63710088e-1;
function _z(t, e, n) {
  n = n || fg1;
  const i = yh(t[1]), s = yh(e[1]), l = (s - i) / 2, a = yh(e[0] - t[0]) / 2, o = Math.sin(l) * Math.sin(l) + Math.sin(a) * Math.sin(a) * Math.cos(i) * Math.cos(s);
  return 2 * n * Math.atan2(Math.sqrt(o), Math.sqrt(1 - o));
}
const xS = {
  info: 1,
  warn: 2,
  error: 3,
  none: 4
};
let vg1 = xS.info;
function SS(...t) {
  vg1 > xS.warn || console.warn(...t);
}
let zy = !0;
function CS(t) {
  zy = !(t === void 0 ? !0 : t);
}
function Y_(t, e) {
  if (e !== void 0) {
    for (let n = 0, i = t.length; n < i; ++n)
      e[n] = t[n];
    e = e;
  } else
    e = t.slice();
  return e;
}
function kS(t, e) {
  if (e !== void 0 && t !== e) {
    for (let n = 0, i = t.length; n < i; ++n)
      e[n] = t[n];
    t = e;
  }
  return t;
}
function ES(t) {
  tg1(t.getCode(), t), Ha(t, t, Y_);
}
function pg1(t) {
  t.forEach(ES);
}
function ct(t) {
  return typeof t == "string" ? eg1(
    /** @type {string} */
    t
  ) : (
    /** @type {Projection} */
    t || null
  );
}
function qz(t, e, n, i) {
  t = ct(t);
  let s;
  const l = t.getPointResolutionFunc();
  if (l) {
    if (s = l(e, n), i && i !== t.getUnits()) {
      const a = t.getMetersPerUnit();
      a && (s = s * a / Ho[i]);
    }
  } else {
    const a = t.getUnits();
    if (a == "degrees" && !i || i == "degrees")
      s = e;
    else {
      const o = Uu(
        t,
        ct("EPSG:4326")
      );
      if (o === kS && a !== "degrees")
        s = e * t.getMetersPerUnit();
      else {
        let u = [
          n[0] - e / 2,
          n[1],
          n[0] + e / 2,
          n[1],
          n[0],
          n[1] - e / 2,
          n[0],
          n[1] + e / 2
        ];
        u = o(u, u, 2);
        const d = _z(u.slice(0, 2), u.slice(2, 4)), v = _z(u.slice(4, 6), u.slice(6, 8));
        s = (d + v) / 2;
      }
      const h = i ? Ho[i] : t.getMetersPerUnit();
      h !== void 0 && (s /= h);
    }
  }
  return s;
}
function My(t) {
  pg1(t), t.forEach(function(e) {
    t.forEach(function(n) {
      e !== n && Ha(e, n, Y_);
    });
  });
}
function mg1(t, e, n, i) {
  t.forEach(function(s) {
    e.forEach(function(l) {
      Ha(s, l, n), Ha(l, s, i);
    });
  });
}
function X_(t, e) {
  return t ? typeof t == "string" ? ct(t) : (
    /** @type {Projection} */
    t
  ) : ct(e);
}
function wz(t) {
  return (
    /**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimension.
     * @return {Array<number>} Output.
     */
    function(e, n, i) {
      const s = e.length;
      i = i !== void 0 ? i : 2, n = n !== void 0 ? n : new Array(s);
      for (let l = 0; l < s; l += i) {
        const a = t(e.slice(l, l + i)), o = a.length;
        for (let h = 0, u = i; h < u; ++h)
          n[l + h] = h >= o ? e[l + h] : a[h];
      }
      return n;
    }
  );
}
function gg1(t, e, n, i) {
  const s = ct(t), l = ct(e);
  Ha(
    s,
    l,
    wz(n)
  ), Ha(
    l,
    s,
    wz(i)
  );
}
function jo(t, e) {
  return CS(), K_(
    t,
    "EPSG:4326",
    e !== void 0 ? e : "EPSG:3857"
  );
}
function pa(t, e) {
  if (t === e)
    return !0;
  const n = t.getUnits() === e.getUnits();
  return (t.getCode() === e.getCode() || Uu(t, e) === Y_) && n;
}
function Uu(t, e) {
  const n = t.getCode(), i = e.getCode();
  let s = gS(n, i);
  return s || (s = kS), s;
}
function $a(t, e) {
  const n = ct(t), i = ct(e);
  return Uu(n, i);
}
function K_(t, e, n) {
  return $a(e, n)(t, void 0, t.length);
}
function yg1(t, e, n, i) {
  const s = $a(e, n);
  return og1(t, s, void 0, i);
}
let _g1 = null;
function qg1() {
  return _g1;
}
function by(t, e) {
  return t;
}
function a8(t, e) {
  return zy && !$h(t, [0, 0]) && t[0] >= -180 && t[0] <= 180 && t[1] >= -90 && t[1] <= 90 && (zy = !1, SS(
    "Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates."
  )), t;
}
function Z_(t, e) {
  return t;
}
function qs(t, e) {
  return t;
}
function zz(t, e, n) {
  return function(i) {
    let s, l;
    if (t.canWrapX()) {
      const a = t.getExtent(), o = ue(a);
      i = i.slice(0), l = LS(i, t, o), l && (i[0] = i[0] - l * o), i[0] = bt(i[0], a[0], a[2]), i[1] = bt(i[1], a[1], a[3]), s = n(i);
    } else
      s = n(i);
    return l && e.canWrapX() && (s[0] += l * ue(e.getExtent())), s;
  };
}
function wg1() {
  My(pz), My(gz), mg1(
    gz,
    pz,
    Km1,
    Zm1
  );
}
wg1();
const Mz = (t) => {
  const e = ac(t), n = document.createElement("span");
  return e && (n.innerHTML = e), n;
};
function AS(t) {
  const { t: e } = js(), n = D1(), i = D1(), s = D1(), l = {
    tile: {
      url: "https://gisco-services.ec.europa.eu/maps/tiles/OSMBlossomComposite/EPSG3857/{z}/{x}/{y}.png"
    },
    attributions: [
      {
        content: e("APP.MAP.ATTRIBUTION_CONTENT"),
        disclaimer: {
          create: !0,
          label: e("APP.MAP.DISCLAIMER"),
          separator: "|",
          title: e("APP.MAP.DISCLAIMER"),
          content: e("APP.MAP.DISCLAIMER_CONTENT")
        }
      }
    ],
    WMS: {
      identifyOnOver: !1,
      tooltip: {
        formatting: (o) => {
          var h, u;
          if (!s1.isNil(o)) {
            const d = o == null ? void 0 : o.features;
            if (d && d.length > 0)
              return (u = (h = d[0]) == null ? void 0 : h.properties) == null ? void 0 : u.name_html;
          }
          return "";
        }
      },
      api: {
        basePath: {}.VUE_APP_MAP_GEO_URL,
        wms: "geoserver/geonode/wms?",
        wfs: "geoserver/geonode/wfs?"
      },
      defaultOptions: {
        service: "WMS",
        version: "1.1.1",
        request: "GetMap",
        format: "image/png",
        exceptions: "application/vnd.ogc.se_inimage",
        info_format: "application/json",
        transparent: !0
      },
      useLayer: "first",
      layers: []
    },
    olSettings: {
      interactions: {
        altShiftDragRotate: !1,
        shiftDragZoom: !1
      },
      controls: {
        rotate: !1,
        zoomOptions: {
          zoomInLabel: Mz("zoom-in"),
          zoomInTipLabel: e("APP.MAP.ZOOM_IN"),
          zoomOutLabel: Mz("zoom-out"),
          zoomOutTipLabel: e("APP.MAP.ZOOM_OUT")
        }
      }
    },
    view: {
      projection: "EPSG:4326",
      center: jo([-0.09, 51.505]),
      zoom: 3.6,
      animateTime: {
        center: 300,
        zoom: 300
      },
      minZoom: 3,
      maxZoom: 9
    },
    customInteraction: {
      mobile: {
        useDoubleTouch: !0,
        useDoubleTouchLabel: "APP.MAP.HINT_USE_TWO_FINGER"
      },
      desktop: {
        useWheelPlatformKey: !1,
        useWheelPlatformKeyLabel: "APP.MAP.HINT_WHEEL_CTRL_MODIFIER_KEY"
      }
    }
  }, a = g1(() => {
    var h;
    const o = s1.merge(s1.cloneDeep(l), t.settings);
    return "attributions" in t.settings && s1.isNil((h = t.settings) == null ? void 0 : h.attributions) && (o.attributions = void 0), o;
  });
  return {
    mapComponent: n,
    mapElement: i,
    mapInstance: s,
    settings: a
  };
}
class zg1 {
  /**
   * @param {string} type Type.
   */
  constructor(e) {
    this.propagationStopped, this.defaultPrevented, this.type = e, this.target = null;
  }
  /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */
  preventDefault() {
    this.defaultPrevented = !0;
  }
  /**
   * Stop event propagation.
   * @api
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
const k8 = zg1, Ua = {
  /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */
  PROPERTYCHANGE: "propertychange"
};
class Mg1 {
  constructor() {
    this.disposed = !1;
  }
  /**
   * Clean up.
   */
  dispose() {
    this.disposed || (this.disposed = !0, this.disposeInternal());
  }
  /**
   * Extension point for disposable objects.
   * @protected
   */
  disposeInternal() {
  }
}
const J_ = Mg1;
function bg1(t, e, n) {
  let i, s;
  n = n || m8;
  let l = 0, a = t.length, o = !1;
  for (; l < a; )
    i = l + (a - l >> 1), s = +n(t[i], e), s < 0 ? l = i + 1 : (a = i, o = !s);
  return o ? l : ~l;
}
function m8(t, e) {
  return t > e ? 1 : t < e ? -1 : 0;
}
function Q_(t, e, n) {
  if (t[0] <= e)
    return 0;
  const i = t.length;
  if (e <= t[i - 1])
    return i - 1;
  if (typeof n == "function") {
    for (let s = 1; s < i; ++s) {
      const l = t[s];
      if (l === e)
        return s;
      if (l < e)
        return n(e, t[s - 1], l) > 0 ? s - 1 : s;
    }
    return i - 1;
  }
  if (n > 0) {
    for (let s = 1; s < i; ++s)
      if (t[s] < e)
        return s - 1;
    return i - 1;
  }
  if (n < 0) {
    for (let s = 1; s < i; ++s)
      if (t[s] <= e)
        return s;
    return i - 1;
  }
  for (let s = 1; s < i; ++s) {
    if (t[s] == e)
      return s;
    if (t[s] < e)
      return t[s - 1] - e < e - t[s] ? s - 1 : s;
  }
  return i - 1;
}
function Lg1(t, e, n) {
  for (; e < n; ) {
    const i = t[e];
    t[e] = t[n], t[n] = i, ++e, --n;
  }
}
function ni(t, e) {
  const n = Array.isArray(e) ? e : [e], i = n.length;
  for (let s = 0; s < i; s++)
    t[t.length] = n[s];
}
function Ws(t, e) {
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let i = 0; i < n; i++)
    if (t[i] !== e[i])
      return !1;
  return !0;
}
function xg1(t, e, n) {
  const i = e || m8;
  return t.every(function(s, l) {
    if (l === 0)
      return !0;
    const a = i(t[l - 1], s);
    return !(a > 0 || n && a === 0);
  });
}
function Go() {
  return !0;
}
function ju() {
  return !1;
}
function ja() {
}
function FS(t) {
  let e, n, i;
  return function() {
    const s = Array.prototype.slice.call(arguments);
    return (!n || this !== i || !Ws(s, n)) && (i = this, n = s, e = t.apply(this, arguments)), e;
  };
}
function Sg1(t) {
  function e() {
    let n;
    try {
      n = t();
    } catch (i) {
      return Promise.reject(i);
    }
    return n instanceof Promise ? n : Promise.resolve(n);
  }
  return e();
}
class Cg1 extends J_ {
  /**
   * @param {*} [target] Default event target for dispatched events.
   */
  constructor(e) {
    super(), this.eventTarget_ = e, this.pendingRemovals_ = null, this.dispatching_ = null, this.listeners_ = null;
  }
  /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */
  addEventListener(e, n) {
    if (!e || !n)
      return;
    const i = this.listeners_ || (this.listeners_ = {}), s = i[e] || (i[e] = []);
    s.includes(n) || s.push(n);
  }
  /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */
  dispatchEvent(e) {
    const n = typeof e == "string", i = n ? e : e.type, s = this.listeners_ && this.listeners_[i];
    if (!s)
      return;
    const l = n ? new k8(e) : (
      /** @type {Event} */
      e
    );
    l.target || (l.target = this.eventTarget_ || this);
    const a = this.dispatching_ || (this.dispatching_ = {}), o = this.pendingRemovals_ || (this.pendingRemovals_ = {});
    i in a || (a[i] = 0, o[i] = 0), ++a[i];
    let h;
    for (let u = 0, d = s.length; u < d; ++u)
      if ("handleEvent" in s[u] ? h = /** @type {import("../events.js").ListenerObject} */
      s[u].handleEvent(l) : h = /** @type {import("../events.js").ListenerFunction} */
      s[u].call(this, l), h === !1 || l.propagationStopped) {
        h = !1;
        break;
      }
    if (--a[i] === 0) {
      let u = o[i];
      for (delete o[i]; u--; )
        this.removeEventListener(i, ja);
      delete a[i];
    }
    return h;
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    this.listeners_ && wc(this.listeners_);
  }
  /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */
  getListeners(e) {
    return this.listeners_ && this.listeners_[e] || void 0;
  }
  /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */
  hasListener(e) {
    return this.listeners_ ? e ? e in this.listeners_ : Object.keys(this.listeners_).length > 0 : !1;
  }
  /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */
  removeEventListener(e, n) {
    if (!this.listeners_)
      return;
    const i = this.listeners_[e];
    if (!i)
      return;
    const s = i.indexOf(n);
    s !== -1 && (this.pendingRemovals_ && e in this.pendingRemovals_ ? (i[s] = ja, ++this.pendingRemovals_[e]) : (i.splice(s, 1), i.length === 0 && delete this.listeners_[e]));
  }
}
const Gu = Cg1, T3 = {
  /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */
  CHANGE: "change",
  /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */
  ERROR: "error",
  BLUR: "blur",
  CLEAR: "clear",
  CONTEXTMENU: "contextmenu",
  CLICK: "click",
  DBLCLICK: "dblclick",
  DRAGENTER: "dragenter",
  DRAGOVER: "dragover",
  DROP: "drop",
  FOCUS: "focus",
  KEYDOWN: "keydown",
  KEYPRESS: "keypress",
  LOAD: "load",
  RESIZE: "resize",
  TOUCHMOVE: "touchmove",
  WHEEL: "wheel"
};
function ae(t, e, n, i, s) {
  if (s) {
    const a = n;
    n = function() {
      t.removeEventListener(e, n), a.apply(i ?? this, arguments);
    };
  } else
    i && i !== t && (n = n.bind(i));
  const l = {
    target: t,
    type: e,
    listener: n
  };
  return t.addEventListener(e, n), l;
}
function Uh(t, e, n, i) {
  return ae(t, e, n, i, !0);
}
function Qe(t) {
  t && t.target && (t.target.removeEventListener(t.type, t.listener), wc(t));
}
class Wu extends Gu {
  constructor() {
    super(), this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */
    this.onInternal, this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */
    this.onceInternal, this.un = /** @type {ObservableOnSignature<void>} */
    this.unInternal, this.revision_ = 0;
  }
  /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */
  changed() {
    ++this.revision_, this.dispatchEvent(T3.CHANGE);
  }
  /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */
  getRevision() {
    return this.revision_;
  }
  /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */
  onInternal(e, n) {
    if (Array.isArray(e)) {
      const i = e.length, s = new Array(i);
      for (let l = 0; l < i; ++l)
        s[l] = ae(this, e[l], n);
      return s;
    }
    return ae(
      this,
      /** @type {string} */
      e,
      n
    );
  }
  /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */
  onceInternal(e, n) {
    let i;
    if (Array.isArray(e)) {
      const s = e.length;
      i = new Array(s);
      for (let l = 0; l < s; ++l)
        i[l] = Uh(this, e[l], n);
    } else
      i = Uh(
        this,
        /** @type {string} */
        e,
        n
      );
    return n.ol_key = i, i;
  }
  /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */
  unInternal(e, n) {
    const i = (
      /** @type {Object} */
      n.ol_key
    );
    if (i)
      kg1(i);
    else if (Array.isArray(e))
      for (let s = 0, l = e.length; s < l; ++s)
        this.removeEventListener(e[s], n);
    else
      this.removeEventListener(e, n);
  }
}
Wu.prototype.on;
Wu.prototype.once;
Wu.prototype.un;
function kg1(t) {
  if (Array.isArray(t))
    for (let e = 0, n = t.length; e < n; ++e)
      Qe(t[e]);
  else
    Qe(
      /** @type {import("./events.js").EventsKey} */
      t
    );
}
const TS = Wu;
function b3() {
  throw new Error("Unimplemented abstract method.");
}
let Eg1 = 0;
function Be(t) {
  return t.ol_uid || (t.ol_uid = String(++Eg1));
}
class bz extends k8 {
  /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */
  constructor(e, n, i) {
    super(e), this.key = n, this.oldValue = i;
  }
}
class Ag1 extends TS {
  /**
   * @param {Object<string, *>} [values] An object with key-value pairs.
   */
  constructor(e) {
    super(), this.on, this.once, this.un, Be(this), this.values_ = null, e !== void 0 && this.setProperties(e);
  }
  /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */
  get(e) {
    let n;
    return this.values_ && this.values_.hasOwnProperty(e) && (n = this.values_[e]), n;
  }
  /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */
  getKeys() {
    return this.values_ && Object.keys(this.values_) || [];
  }
  /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */
  getProperties() {
    return this.values_ && Object.assign({}, this.values_) || {};
  }
  /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */
  getPropertiesInternal() {
    return this.values_;
  }
  /**
   * @return {boolean} The object has properties.
   */
  hasProperties() {
    return !!this.values_;
  }
  /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */
  notify(e, n) {
    let i;
    i = `change:${e}`, this.hasListener(i) && this.dispatchEvent(new bz(i, e, n)), i = Ua.PROPERTYCHANGE, this.hasListener(i) && this.dispatchEvent(new bz(i, e, n));
  }
  /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */
  addChangeListener(e, n) {
    this.addEventListener(`change:${e}`, n);
  }
  /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */
  removeChangeListener(e, n) {
    this.removeEventListener(`change:${e}`, n);
  }
  /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */
  set(e, n, i) {
    const s = this.values_ || (this.values_ = {});
    if (i)
      s[e] = n;
    else {
      const l = s[e];
      s[e] = n, l !== n && this.notify(e, l);
    }
  }
  /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */
  setProperties(e, n) {
    for (const i in e)
      this.set(i, e[i], n);
  }
  /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */
  applyProperties(e) {
    e.values_ && Object.assign(this.values_ || (this.values_ = {}), e.values_);
  }
  /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */
  unset(e, n) {
    if (this.values_ && e in this.values_) {
      const i = this.values_[e];
      delete this.values_[e], mr(this.values_) && (this.values_ = null), n || this.notify(e, i);
    }
  }
}
const gn = Ag1, i0 = {
  /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */
  ADD: "add",
  /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */
  REMOVE: "remove"
}, Lz = {
  LENGTH: "length"
};
class Xc extends k8 {
  /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */
  constructor(e, n, i) {
    super(e), this.element = n, this.index = i;
  }
}
class Fg1 extends gn {
  /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */
  constructor(e, n) {
    if (super(), this.on, this.once, this.un, n = n || {}, this.unique_ = !!n.unique, this.array_ = e || [], this.unique_)
      for (let i = 0, s = this.array_.length; i < s; ++i)
        this.assertUnique_(this.array_[i], i);
    this.updateLength_();
  }
  /**
   * Remove all elements from the collection.
   * @api
   */
  clear() {
    for (; this.getLength() > 0; )
      this.pop();
  }
  /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */
  extend(e) {
    for (let n = 0, i = e.length; n < i; ++n)
      this.push(e[n]);
    return this;
  }
  /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */
  forEach(e) {
    const n = this.array_;
    for (let i = 0, s = n.length; i < s; ++i)
      e(n[i], i, n);
  }
  /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */
  getArray() {
    return this.array_;
  }
  /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */
  item(e) {
    return this.array_[e];
  }
  /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */
  getLength() {
    return this.get(Lz.LENGTH);
  }
  /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */
  insertAt(e, n) {
    if (e < 0 || e > this.getLength())
      throw new Error("Index out of bounds: " + e);
    this.unique_ && this.assertUnique_(n), this.array_.splice(e, 0, n), this.updateLength_(), this.dispatchEvent(
      new Xc(i0.ADD, n, e)
    );
  }
  /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */
  pop() {
    return this.removeAt(this.getLength() - 1);
  }
  /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */
  push(e) {
    this.unique_ && this.assertUnique_(e);
    const n = this.getLength();
    return this.insertAt(n, e), this.getLength();
  }
  /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */
  remove(e) {
    const n = this.array_;
    for (let i = 0, s = n.length; i < s; ++i)
      if (n[i] === e)
        return this.removeAt(i);
  }
  /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */
  removeAt(e) {
    if (e < 0 || e >= this.getLength())
      return;
    const n = this.array_[e];
    return this.array_.splice(e, 1), this.updateLength_(), this.dispatchEvent(
      /** @type {CollectionEvent<T>} */
      new Xc(i0.REMOVE, n, e)
    ), n;
  }
  /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */
  setAt(e, n) {
    const i = this.getLength();
    if (e >= i) {
      this.insertAt(e, n);
      return;
    }
    if (e < 0)
      throw new Error("Index out of bounds: " + e);
    this.unique_ && this.assertUnique_(n, e);
    const s = this.array_[e];
    this.array_[e] = n, this.dispatchEvent(
      /** @type {CollectionEvent<T>} */
      new Xc(i0.REMOVE, s, e)
    ), this.dispatchEvent(
      /** @type {CollectionEvent<T>} */
      new Xc(i0.ADD, n, e)
    );
  }
  /**
   * @private
   */
  updateLength_() {
    this.set(Lz.LENGTH, this.array_.length);
  }
  /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */
  assertUnique_(e, n) {
    for (let i = 0, s = this.array_.length; i < s; ++i)
      if (this.array_[i] === e && i !== n)
        throw new Error("Duplicate item added to a unique collection");
  }
}
const z6 = Fg1;
function ge(t, e) {
  if (!t)
    throw new Error(e);
}
class eq extends gn {
  /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */
  constructor(e) {
    if (super(), this.on, this.once, this.un, this.id_ = void 0, this.geometryName_ = "geometry", this.style_ = null, this.styleFunction_ = void 0, this.geometryChangeKey_ = null, this.addChangeListener(this.geometryName_, this.handleGeometryChanged_), e)
      if (typeof /** @type {?} */
      e.getSimplifiedGeometry == "function") {
        const n = (
          /** @type {Geometry} */
          e
        );
        this.setGeometry(n);
      } else {
        const n = e;
        this.setProperties(n);
      }
  }
  /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */
  clone() {
    const e = (
      /** @type {Feature<Geometry>} */
      new eq(this.hasProperties() ? this.getProperties() : null)
    );
    e.setGeometryName(this.getGeometryName());
    const n = this.getGeometry();
    n && e.setGeometry(
      /** @type {Geometry} */
      n.clone()
    );
    const i = this.getStyle();
    return i && e.setStyle(i), e;
  }
  /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */
  getGeometry() {
    return (
      /** @type {Geometry|undefined} */
      this.get(this.geometryName_)
    );
  }
  /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */
  getId() {
    return this.id_;
  }
  /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */
  getGeometryName() {
    return this.geometryName_;
  }
  /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */
  getStyle() {
    return this.style_;
  }
  /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */
  getStyleFunction() {
    return this.styleFunction_;
  }
  /**
   * @private
   */
  handleGeometryChange_() {
    this.changed();
  }
  /**
   * @private
   */
  handleGeometryChanged_() {
    this.geometryChangeKey_ && (Qe(this.geometryChangeKey_), this.geometryChangeKey_ = null);
    const e = this.getGeometry();
    e && (this.geometryChangeKey_ = ae(
      e,
      T3.CHANGE,
      this.handleGeometryChange_,
      this
    )), this.changed();
  }
  /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */
  setGeometry(e) {
    this.set(this.geometryName_, e);
  }
  /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */
  setStyle(e) {
    this.style_ = e, this.styleFunction_ = e ? Tg1(e) : void 0, this.changed();
  }
  /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */
  setId(e) {
    this.id_ = e, this.changed();
  }
  /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */
  setGeometryName(e) {
    this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_), this.geometryName_ = e, this.addChangeListener(this.geometryName_, this.handleGeometryChanged_), this.handleGeometryChanged_();
  }
}
function Tg1(t) {
  if (typeof t == "function")
    return t;
  let e;
  return Array.isArray(t) ? e = t : (ge(
    typeof /** @type {?} */
    t.getZIndex == "function",
    "Expected an `ol/style/Style` or an array of `ol/style/Style.js`"
  ), e = [
    /** @type {import("./style/Style.js").default} */
    t
  ]), function() {
    return e;
  };
}
const Yu = eq;
new Array(6);
function hn() {
  return [1, 0, 0, 1, 0, 0];
}
function Ig1(t, e) {
  return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t;
}
function j4(t, e) {
  const n = e[0], i = e[1];
  return e[0] = t[0] * n + t[2] * i + t[4], e[1] = t[1] * n + t[3] * i + t[5], e;
}
function b8(t, e, n, i, s, l, a, o) {
  const h = Math.sin(l), u = Math.cos(l);
  return t[0] = i * u, t[1] = s * h, t[2] = -i * h, t[3] = s * u, t[4] = a * i * u - o * i * h + e, t[5] = a * s * h + o * s * u + n, t;
}
function IS(t, e) {
  const n = Og1(e);
  ge(n !== 0, "Transformation matrix cannot be inverted");
  const i = e[0], s = e[1], l = e[2], a = e[3], o = e[4], h = e[5];
  return t[0] = a / n, t[1] = -s / n, t[2] = -l / n, t[3] = i / n, t[4] = (l * h - a * o) / n, t[5] = -(i * h - s * o) / n, t;
}
function Og1(t) {
  return t[0] * t[3] - t[1] * t[2];
}
const xz = [1e6, 1e6, 1e6, 1e6, 2, 2];
function Ng1(t) {
  return "matrix(" + t.map(
    (n, i) => Math.round(n * xz[i]) / xz[i]
  ).join(", ") + ")";
}
function Cs(t, e, n, i, s, l) {
  l = l || [];
  let a = 0;
  for (let o = e; o < n; o += i) {
    const h = t[o], u = t[o + 1];
    l[a++] = s[0] * h + s[2] * u + s[4], l[a++] = s[1] * h + s[3] * u + s[5];
  }
  return l && l.length != a && (l.length = a), l;
}
function OS(t, e, n, i, s, l, a) {
  a = a || [];
  const o = Math.cos(s), h = Math.sin(s), u = l[0], d = l[1];
  let v = 0;
  for (let m = e; m < n; m += i) {
    const p = t[m] - u, _ = t[m + 1] - d;
    a[v++] = u + p * o - _ * h, a[v++] = d + p * h + _ * o;
    for (let q = m + 2; q < m + i; ++q)
      a[v++] = t[q];
  }
  return a && a.length != v && (a.length = v), a;
}
function Pg1(t, e, n, i, s, l, a, o) {
  o = o || [];
  const h = a[0], u = a[1];
  let d = 0;
  for (let v = e; v < n; v += i) {
    const m = t[v] - h, p = t[v + 1] - u;
    o[d++] = h + s * m, o[d++] = u + l * p;
    for (let _ = v + 2; _ < v + i; ++_)
      o[d++] = t[_];
  }
  return o && o.length != d && (o.length = d), o;
}
function Bg1(t, e, n, i, s, l, a) {
  a = a || [];
  let o = 0;
  for (let h = e; h < n; h += i) {
    a[o++] = t[h] + s, a[o++] = t[h + 1] + l;
    for (let u = h + 2; u < h + i; ++u)
      a[o++] = t[u];
  }
  return a && a.length != o && (a.length = o), a;
}
const Sz = hn();
class Vg1 extends gn {
  constructor() {
    super(), this.extent_ = U0(), this.extentRevision_ = -1, this.simplifiedGeometryMaxMinSquaredTolerance = 0, this.simplifiedGeometryRevision = 0, this.simplifyTransformedInternal = FS(
      (e, n, i) => {
        if (!i)
          return this.getSimplifiedGeometry(n);
        const s = this.clone();
        return s.applyTransform(i), s.getSimplifiedGeometry(n);
      }
    );
  }
  /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */
  simplifyTransformed(e, n) {
    return this.simplifyTransformedInternal(
      this.getRevision(),
      e,
      n
    );
  }
  /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */
  clone() {
    return b3();
  }
  /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */
  closestPointXY(e, n, i, s) {
    return b3();
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */
  containsXY(e, n) {
    const i = this.getClosestPoint([e, n]);
    return i[0] === e && i[1] === n;
  }
  /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */
  getClosestPoint(e, n) {
    return n = n || [NaN, NaN], this.closestPointXY(e[0], e[1], n, 1 / 0), n;
  }
  /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */
  intersectsCoordinate(e) {
    return this.containsXY(e[0], e[1]);
  }
  /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */
  computeExtent(e) {
    return b3();
  }
  /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */
  getExtent(e) {
    if (this.extentRevision_ != this.getRevision()) {
      const n = this.computeExtent(this.extent_);
      (isNaN(n[0]) || isNaN(n[1])) && s9(n), this.extentRevision_ = this.getRevision();
    }
    return rg1(this.extent_, e);
  }
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */
  rotate(e, n) {
    b3();
  }
  /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */
  scale(e, n, i) {
    b3();
  }
  /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */
  simplify(e) {
    return this.getSimplifiedGeometry(e * e);
  }
  /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */
  getSimplifiedGeometry(e) {
    return b3();
  }
  /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */
  getType() {
    return b3();
  }
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */
  applyTransform(e) {
    b3();
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */
  intersectsExtent(e) {
    return b3();
  }
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */
  translate(e, n) {
    b3();
  }
  /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */
  transform(e, n) {
    const i = ct(e), s = i.getUnits() == "tile-pixels" ? function(l, a, o) {
      const h = i.getExtent(), u = i.getWorldExtent(), d = G4(u) / G4(h);
      return b8(
        Sz,
        u[0],
        u[3],
        d,
        -d,
        0,
        0,
        0
      ), Cs(
        l,
        0,
        l.length,
        o,
        Sz,
        a
      ), $a(i, n)(
        l,
        a,
        o
      );
    } : $a(i, n);
    return this.applyTransform(s), this;
  }
}
const NS = Vg1;
class Rg1 extends NS {
  constructor() {
    super(), this.layout = "XY", this.stride = 2, this.flatCoordinates;
  }
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */
  computeExtent(e) {
    return U_(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      e
    );
  }
  /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */
  getCoordinates() {
    return b3();
  }
  /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */
  getFirstCoordinate() {
    return this.flatCoordinates.slice(0, this.stride);
  }
  /**
   * @return {Array<number>} Flat coordinates.
   */
  getFlatCoordinates() {
    return this.flatCoordinates;
  }
  /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */
  getLastCoordinate() {
    return this.flatCoordinates.slice(
      this.flatCoordinates.length - this.stride
    );
  }
  /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */
  getLayout() {
    return this.layout;
  }
  /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */
  getSimplifiedGeometry(e) {
    if (this.simplifiedGeometryRevision !== this.getRevision() && (this.simplifiedGeometryMaxMinSquaredTolerance = 0, this.simplifiedGeometryRevision = this.getRevision()), e < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && e <= this.simplifiedGeometryMaxMinSquaredTolerance)
      return this;
    const n = this.getSimplifiedGeometryInternal(e);
    return n.getFlatCoordinates().length < this.flatCoordinates.length ? n : (this.simplifiedGeometryMaxMinSquaredTolerance = e, this);
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */
  getSimplifiedGeometryInternal(e) {
    return this;
  }
  /**
   * @return {number} Stride.
   */
  getStride() {
    return this.stride;
  }
  /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */
  setFlatCoordinates(e, n) {
    this.stride = Cz(e), this.layout = e, this.flatCoordinates = n;
  }
  /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  setCoordinates(e, n) {
    b3();
  }
  /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */
  setLayout(e, n, i) {
    let s;
    if (e)
      s = Cz(e);
    else {
      for (let l = 0; l < i; ++l) {
        if (n.length === 0) {
          this.layout = "XY", this.stride = 2;
          return;
        }
        n = /** @type {Array<unknown>} */
        n[0];
      }
      s = n.length, e = xr(s);
    }
    this.layout = e, this.stride = s;
  }
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */
  applyTransform(e) {
    this.flatCoordinates && (e(this.flatCoordinates, this.flatCoordinates, this.stride), this.changed());
  }
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */
  rotate(e, n) {
    const i = this.getFlatCoordinates();
    if (i) {
      const s = this.getStride();
      OS(
        i,
        0,
        i.length,
        s,
        e,
        n,
        i
      ), this.changed();
    }
  }
  /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */
  scale(e, n, i) {
    n === void 0 && (n = e), i || (i = Is(this.getExtent()));
    const s = this.getFlatCoordinates();
    if (s) {
      const l = this.getStride();
      Pg1(
        s,
        0,
        s.length,
        l,
        e,
        n,
        i,
        s
      ), this.changed();
    }
  }
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */
  translate(e, n) {
    const i = this.getFlatCoordinates();
    if (i) {
      const s = this.getStride();
      Bg1(
        i,
        0,
        i.length,
        s,
        e,
        n,
        i
      ), this.changed();
    }
  }
}
function xr(t) {
  let e;
  return t == 2 ? e = "XY" : t == 3 ? e = "XYZ" : t == 4 && (e = "XYZM"), /** @type {import("./Geometry.js").GeometryLayout} */
  e;
}
function Cz(t) {
  let e;
  return t == "XY" ? e = 2 : t == "XYZ" || t == "XYM" ? e = 3 : t == "XYZM" && (e = 4), /** @type {number} */
  e;
}
function Hg1(t, e, n) {
  const i = t.getFlatCoordinates();
  if (!i)
    return null;
  const s = t.getStride();
  return Cs(
    i,
    0,
    i.length,
    s,
    e,
    n
  );
}
const Sr = Rg1;
function kz(t, e, n, i, s, l, a) {
  const o = t[e], h = t[e + 1], u = t[n] - o, d = t[n + 1] - h;
  let v;
  if (u === 0 && d === 0)
    v = e;
  else {
    const m = ((s - o) * u + (l - h) * d) / (u * u + d * d);
    if (m > 1)
      v = n;
    else if (m > 0) {
      for (let p = 0; p < i; ++p)
        a[p] = V0(
          t[e + p],
          t[n + p],
          m
        );
      a.length = i;
      return;
    } else
      v = e;
  }
  for (let m = 0; m < i; ++m)
    a[m] = t[v + m];
  a.length = i;
}
function tq(t, e, n, i, s) {
  let l = t[e], a = t[e + 1];
  for (e += i; e < n; e += i) {
    const o = t[e], h = t[e + 1], u = cr(l, a, o, h);
    u > s && (s = u), l = o, a = h;
  }
  return s;
}
function nq(t, e, n, i, s) {
  for (let l = 0, a = n.length; l < a; ++l) {
    const o = n[l];
    s = tq(t, e, o, i, s), e = o;
  }
  return s;
}
function Dg1(t, e, n, i, s) {
  for (let l = 0, a = n.length; l < a; ++l) {
    const o = n[l];
    s = nq(t, e, o, i, s), e = o[o.length - 1];
  }
  return s;
}
function iq(t, e, n, i, s, l, a, o, h, u, d) {
  if (e == n)
    return u;
  let v, m;
  if (s === 0) {
    if (m = cr(
      a,
      o,
      t[e],
      t[e + 1]
    ), m < u) {
      for (v = 0; v < i; ++v)
        h[v] = t[e + v];
      return h.length = i, m;
    }
    return u;
  }
  d = d || [NaN, NaN];
  let p = e + i;
  for (; p < n; )
    if (kz(
      t,
      p - i,
      p,
      i,
      a,
      o,
      d
    ), m = cr(a, o, d[0], d[1]), m < u) {
      for (u = m, v = 0; v < i; ++v)
        h[v] = d[v];
      h.length = i, p += i;
    } else
      p += i * Math.max(
        (Math.sqrt(m) - Math.sqrt(u)) / s | 0,
        1
      );
  if (l && (kz(
    t,
    n - i,
    e,
    i,
    a,
    o,
    d
  ), m = cr(a, o, d[0], d[1]), m < u)) {
    for (u = m, v = 0; v < i; ++v)
      h[v] = d[v];
    h.length = i;
  }
  return u;
}
function sq(t, e, n, i, s, l, a, o, h, u, d) {
  d = d || [NaN, NaN];
  for (let v = 0, m = n.length; v < m; ++v) {
    const p = n[v];
    u = iq(
      t,
      e,
      p,
      i,
      s,
      l,
      a,
      o,
      h,
      u,
      d
    ), e = p;
  }
  return u;
}
function $g1(t, e, n, i, s, l, a, o, h, u, d) {
  d = d || [NaN, NaN];
  for (let v = 0, m = n.length; v < m; ++v) {
    const p = n[v];
    u = sq(
      t,
      e,
      p,
      i,
      s,
      l,
      a,
      o,
      h,
      u,
      d
    ), e = p[p.length - 1];
  }
  return u;
}
function Ug1(t, e, n, i) {
  for (let s = 0, l = n.length; s < l; ++s)
    t[e++] = n[s];
  return e;
}
function Xu(t, e, n, i) {
  for (let s = 0, l = n.length; s < l; ++s) {
    const a = n[s];
    for (let o = 0; o < i; ++o)
      t[e++] = a[o];
  }
  return e;
}
function Mc(t, e, n, i, s) {
  s = s || [];
  let l = 0;
  for (let a = 0, o = n.length; a < o; ++a) {
    const h = Xu(
      t,
      e,
      n[a],
      i
    );
    s[l++] = h, e = h;
  }
  return s.length = l, s;
}
function PS(t, e, n, i, s) {
  s = s || [];
  let l = 0;
  for (let a = 0, o = n.length; a < o; ++a) {
    const h = Mc(
      t,
      e,
      n[a],
      i,
      s[l]
    );
    h.length === 0 && (h[0] = e), s[l++] = h, e = h[h.length - 1];
  }
  return s.length = l, s;
}
function Ku(t, e, n, i, s, l, a) {
  const o = (n - e) / i;
  if (o < 3) {
    for (; e < n; e += i)
      l[a++] = t[e], l[a++] = t[e + 1];
    return a;
  }
  const h = new Array(o);
  h[0] = 1, h[o - 1] = 1;
  const u = [e, n - i];
  let d = 0;
  for (; u.length > 0; ) {
    const v = u.pop(), m = u.pop();
    let p = 0;
    const _ = t[m], q = t[m + 1], M = t[v], z = t[v + 1];
    for (let b = m + i; b < v; b += i) {
      const x = t[b], k = t[b + 1], F = cg1(x, k, _, q, M, z);
      F > p && (d = b, p = F);
    }
    p > s && (h[(d - e) / i] = 1, m + i < d && u.push(m, d), d + i < v && u.push(d, v));
  }
  for (let v = 0; v < o; ++v)
    h[v] && (l[a++] = t[e + v * i], l[a++] = t[e + v * i + 1]);
  return a;
}
function BS(t, e, n, i, s, l, a, o) {
  for (let h = 0, u = n.length; h < u; ++h) {
    const d = n[h];
    a = Ku(
      t,
      e,
      d,
      i,
      s,
      l,
      a
    ), o.push(a), e = d;
  }
  return a;
}
function Xl(t, e) {
  return e * Math.round(t / e);
}
function jg1(t, e, n, i, s, l, a) {
  if (e == n)
    return a;
  let o = Xl(t[e], s), h = Xl(t[e + 1], s);
  e += i, l[a++] = o, l[a++] = h;
  let u, d;
  do
    if (u = Xl(t[e], s), d = Xl(t[e + 1], s), e += i, e == n)
      return l[a++] = u, l[a++] = d, a;
  while (u == o && d == h);
  for (; e < n; ) {
    const v = Xl(t[e], s), m = Xl(t[e + 1], s);
    if (e += i, v == u && m == d)
      continue;
    const p = u - o, _ = d - h, q = v - o, M = m - h;
    if (p * M == _ * q && (p < 0 && q < p || p == q || p > 0 && q > p) && (_ < 0 && M < _ || _ == M || _ > 0 && M > _)) {
      u = v, d = m;
      continue;
    }
    l[a++] = u, l[a++] = d, o = u, h = d, u = v, d = m;
  }
  return l[a++] = u, l[a++] = d, a;
}
function lq(t, e, n, i, s, l, a, o) {
  for (let h = 0, u = n.length; h < u; ++h) {
    const d = n[h];
    a = jg1(
      t,
      e,
      d,
      i,
      s,
      l,
      a
    ), o.push(a), e = d;
  }
  return a;
}
function Gg1(t, e, n, i, s, l, a, o) {
  for (let h = 0, u = n.length; h < u; ++h) {
    const d = n[h], v = [];
    a = lq(
      t,
      e,
      d,
      i,
      s,
      l,
      a,
      v
    ), o.push(v), e = d[d.length - 1];
  }
  return a;
}
function ws(t, e, n, i, s) {
  s = s !== void 0 ? s : [];
  let l = 0;
  for (let a = e; a < n; a += i)
    s[l++] = t.slice(a, a + i);
  return s.length = l, s;
}
function Wo(t, e, n, i, s) {
  s = s !== void 0 ? s : [];
  let l = 0;
  for (let a = 0, o = n.length; a < o; ++a) {
    const h = n[a];
    s[l++] = ws(
      t,
      e,
      h,
      i,
      s[l]
    ), e = h;
  }
  return s.length = l, s;
}
function Ly(t, e, n, i, s) {
  s = s !== void 0 ? s : [];
  let l = 0;
  for (let a = 0, o = n.length; a < o; ++a) {
    const h = n[a];
    s[l++] = h.length === 1 && h[0] === e ? [] : Wo(
      t,
      e,
      h,
      i,
      s[l]
    ), e = h[h.length - 1];
  }
  return s.length = l, s;
}
function VS(t, e, n, i) {
  let s = 0;
  const l = t[n - i], a = t[n - i + 1];
  let o = 0, h = 0;
  for (; e < n; e += i) {
    const u = t[e] - l, d = t[e + 1] - a;
    s += h * u - o * d, o = u, h = d;
  }
  return s / 2;
}
function RS(t, e, n, i) {
  let s = 0;
  for (let l = 0, a = n.length; l < a; ++l) {
    const o = n[l];
    s += VS(t, e, o, i), e = o;
  }
  return s;
}
function Wg1(t, e, n, i) {
  let s = 0;
  for (let l = 0, a = n.length; l < a; ++l) {
    const o = n[l];
    s += RS(t, e, o, i), e = o[o.length - 1];
  }
  return s;
}
class jh extends Sr {
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  constructor(e, n) {
    super(), this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, n !== void 0 && !Array.isArray(e[0]) ? this.setFlatCoordinates(
      n,
      /** @type {Array<number>} */
      e
    ) : this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      e,
      n
    );
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */
  clone() {
    return new jh(this.flatCoordinates.slice(), this.layout);
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */
  closestPointXY(e, n, i, s) {
    return s < br(this.getExtent(), e, n) ? s : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      tq(
        this.flatCoordinates,
        0,
        this.flatCoordinates.length,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), iq(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      this.maxDelta_,
      !0,
      e,
      n,
      i,
      s
    ));
  }
  /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */
  getArea() {
    return VS(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */
  getCoordinates() {
    return ws(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */
  getSimplifiedGeometryInternal(e) {
    const n = [];
    return n.length = Ku(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      e,
      n,
      0
    ), new jh(n, "XY");
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */
  getType() {
    return "LinearRing";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */
  intersectsExtent(e) {
    return !1;
  }
  /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */
  setCoordinates(e, n) {
    this.setLayout(n, e, 1), this.flatCoordinates || (this.flatCoordinates = []), this.flatCoordinates.length = Xu(
      this.flatCoordinates,
      0,
      e,
      this.stride
    ), this.changed();
  }
}
const Ez = jh;
let Yg1 = class HS extends Sr {
  /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  constructor(e, n) {
    super(), this.setCoordinates(e, n);
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */
  clone() {
    const e = new HS(this.flatCoordinates.slice(), this.layout);
    return e.applyProperties(this), e;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */
  closestPointXY(e, n, i, s) {
    const l = this.flatCoordinates, a = cr(
      e,
      n,
      l[0],
      l[1]
    );
    if (a < s) {
      const o = this.stride;
      for (let h = 0; h < o; ++h)
        i[h] = l[h];
      return i.length = o, a;
    }
    return s;
  }
  /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */
  getCoordinates() {
    return this.flatCoordinates.slice();
  }
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */
  computeExtent(e) {
    return _S(this.flatCoordinates, e);
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */
  getType() {
    return "Point";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */
  intersectsExtent(e) {
    return $_(e, this.flatCoordinates[0], this.flatCoordinates[1]);
  }
  /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */
  setCoordinates(e, n) {
    this.setLayout(n, e, 0), this.flatCoordinates || (this.flatCoordinates = []), this.flatCoordinates.length = Ug1(
      this.flatCoordinates,
      0,
      e,
      this.stride
    ), this.changed();
  }
};
const Yo = Yg1;
function Xg1(t, e, n, i, s) {
  return !wS(
    s,
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */
    function(a) {
      return !nr(
        t,
        e,
        n,
        i,
        a[0],
        a[1]
      );
    }
  );
}
function nr(t, e, n, i, s, l) {
  let a = 0, o = t[n - i], h = t[n - i + 1];
  for (; e < n; e += i) {
    const u = t[e], d = t[e + 1];
    h <= l ? d > l && (u - o) * (l - h) - (s - o) * (d - h) > 0 && a++ : d <= l && (u - o) * (l - h) - (s - o) * (d - h) < 0 && a--, o = u, h = d;
  }
  return a !== 0;
}
function rq(t, e, n, i, s, l) {
  if (n.length === 0 || !nr(t, e, n[0], i, s, l))
    return !1;
  for (let a = 1, o = n.length; a < o; ++a)
    if (nr(t, n[a - 1], n[a], i, s, l))
      return !1;
  return !0;
}
function Kg1(t, e, n, i, s, l) {
  if (n.length === 0)
    return !1;
  for (let a = 0, o = n.length; a < o; ++a) {
    const h = n[a];
    if (rq(t, e, h, i, s, l))
      return !0;
    e = h[h.length - 1];
  }
  return !1;
}
function aq(t, e, n, i, s, l, a) {
  let o, h, u, d, v, m, p;
  const _ = s[l + 1], q = [];
  for (let b = 0, x = n.length; b < x; ++b) {
    const k = n[b];
    for (d = t[k - i], m = t[k - i + 1], o = e; o < k; o += i)
      v = t[o], p = t[o + 1], (_ <= m && p <= _ || m <= _ && _ <= p) && (u = (_ - m) / (p - m) * (v - d) + d, q.push(u)), d = v, m = p;
  }
  let M = NaN, z = -1 / 0;
  for (q.sort(m8), d = q[0], o = 1, h = q.length; o < h; ++o) {
    v = q[o];
    const b = Math.abs(v - d);
    b > z && (u = (d + v) / 2, rq(t, e, n, i, u, _) && (M = u, z = b)), d = v;
  }
  return isNaN(M) && (M = s[l]), a ? (a.push(M, _, z), a) : [M, _, z];
}
function DS(t, e, n, i, s) {
  let l = [];
  for (let a = 0, o = n.length; a < o; ++a) {
    const h = n[a];
    l = aq(
      t,
      e,
      h,
      i,
      s,
      2 * a,
      l
    ), e = h[h.length - 1];
  }
  return l;
}
function $S(t, e, n, i, s) {
  let l;
  for (e += i; e < n; e += i)
    if (l = s(
      t.slice(e - i, e),
      t.slice(e, e + i)
    ), l)
      return l;
  return !1;
}
function Zu(t, e, n, i, s) {
  const l = qS(
    U0(),
    t,
    e,
    n,
    i
  );
  return r0(s, l) ? tr(s, l) || l[0] >= s[0] && l[2] <= s[2] || l[1] >= s[1] && l[3] <= s[3] ? !0 : $S(
    t,
    e,
    n,
    i,
    /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */
    function(a, o) {
      return ag1(s, a, o);
    }
  ) : !1;
}
function Zg1(t, e, n, i, s) {
  for (let l = 0, a = n.length; l < a; ++l) {
    if (Zu(t, e, n[l], i, s))
      return !0;
    e = n[l];
  }
  return !1;
}
function US(t, e, n, i, s) {
  return !!(Zu(t, e, n, i, s) || nr(
    t,
    e,
    n,
    i,
    s[0],
    s[1]
  ) || nr(
    t,
    e,
    n,
    i,
    s[0],
    s[3]
  ) || nr(
    t,
    e,
    n,
    i,
    s[2],
    s[1]
  ) || nr(
    t,
    e,
    n,
    i,
    s[2],
    s[3]
  ));
}
function jS(t, e, n, i, s) {
  if (!US(t, e, n[0], i, s))
    return !1;
  if (n.length === 1)
    return !0;
  for (let l = 1, a = n.length; l < a; ++l)
    if (Xg1(
      t,
      n[l - 1],
      n[l],
      i,
      s
    ) && !Zu(
      t,
      n[l - 1],
      n[l],
      i,
      s
    ))
      return !1;
  return !0;
}
function Jg1(t, e, n, i, s) {
  for (let l = 0, a = n.length; l < a; ++l) {
    const o = n[l];
    if (jS(t, e, o, i, s))
      return !0;
    e = o[o.length - 1];
  }
  return !1;
}
function Qg1(t, e, n, i) {
  for (; e < n - i; ) {
    for (let s = 0; s < i; ++s) {
      const l = t[e + s];
      t[e + s] = t[n - i + s], t[n - i + s] = l;
    }
    e += i, n -= i;
  }
}
function oq(t, e, n, i) {
  let s = 0, l = t[n - i], a = t[n - i + 1];
  for (; e < n; e += i) {
    const o = t[e], h = t[e + 1];
    s += (o - l) * (h + a), l = o, a = h;
  }
  return s === 0 ? void 0 : s > 0;
}
function cq(t, e, n, i, s) {
  s = s !== void 0 ? s : !1;
  for (let l = 0, a = n.length; l < a; ++l) {
    const o = n[l], h = oq(
      t,
      e,
      o,
      i
    );
    if (l === 0) {
      if (s && h || !s && !h)
        return !1;
    } else if (s && !h || !s && h)
      return !1;
    e = o;
  }
  return !0;
}
function GS(t, e, n, i, s) {
  for (let l = 0, a = n.length; l < a; ++l) {
    const o = n[l];
    if (!cq(t, e, o, i, s))
      return !1;
    o.length && (e = o[o.length - 1]);
  }
  return !0;
}
function Gh(t, e, n, i, s) {
  s = s !== void 0 ? s : !1;
  for (let l = 0, a = n.length; l < a; ++l) {
    const o = n[l], h = oq(
      t,
      e,
      o,
      i
    );
    (l === 0 ? s && h || !s && !h : s && !h || !s && h) && Qg1(t, e, o, i), e = o;
  }
  return e;
}
function xy(t, e, n, i, s) {
  for (let l = 0, a = n.length; l < a; ++l)
    e = Gh(
      t,
      e,
      n[l],
      i,
      s
    );
  return e;
}
function ey1(t, e) {
  const n = [];
  let i = 0, s = 0, l;
  for (let a = 0, o = e.length; a < o; ++a) {
    const h = e[a], u = oq(t, i, h, 2);
    if (l === void 0 && (l = u), u === l)
      n.push(e.slice(s, a + 1));
    else {
      if (n.length === 0)
        continue;
      n[n.length - 1].push(e[s]);
    }
    s = a + 1, i = h;
  }
  return n;
}
class Os extends Sr {
  /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */
  constructor(e, n, i) {
    super(), this.ends_ = [], this.flatInteriorPointRevision_ = -1, this.flatInteriorPoint_ = null, this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, this.orientedRevision_ = -1, this.orientedFlatCoordinates_ = null, n !== void 0 && i ? (this.setFlatCoordinates(
      n,
      /** @type {Array<number>} */
      e
    ), this.ends_ = i) : this.setCoordinates(
      /** @type {Array<Array<import("../coordinate.js").Coordinate>>} */
      e,
      n
    );
  }
  /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */
  appendLinearRing(e) {
    this.flatCoordinates ? ni(this.flatCoordinates, e.getFlatCoordinates()) : this.flatCoordinates = e.getFlatCoordinates().slice(), this.ends_.push(this.flatCoordinates.length), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */
  clone() {
    const e = new Os(
      this.flatCoordinates.slice(),
      this.layout,
      this.ends_.slice()
    );
    return e.applyProperties(this), e;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */
  closestPointXY(e, n, i, s) {
    return s < br(this.getExtent(), e, n) ? s : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      nq(
        this.flatCoordinates,
        0,
        this.ends_,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), sq(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      this.maxDelta_,
      !0,
      e,
      n,
      i,
      s
    ));
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */
  containsXY(e, n) {
    return rq(
      this.getOrientedFlatCoordinates(),
      0,
      this.ends_,
      this.stride,
      e,
      n
    );
  }
  /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */
  getArea() {
    return RS(
      this.getOrientedFlatCoordinates(),
      0,
      this.ends_,
      this.stride
    );
  }
  /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */
  getCoordinates(e) {
    let n;
    return e !== void 0 ? (n = this.getOrientedFlatCoordinates().slice(), Gh(n, 0, this.ends_, this.stride, e)) : n = this.flatCoordinates, Wo(n, 0, this.ends_, this.stride);
  }
  /**
   * @return {Array<number>} Ends.
   */
  getEnds() {
    return this.ends_;
  }
  /**
   * @return {Array<number>} Interior point.
   */
  getFlatInteriorPoint() {
    if (this.flatInteriorPointRevision_ != this.getRevision()) {
      const e = Is(this.getExtent());
      this.flatInteriorPoint_ = aq(
        this.getOrientedFlatCoordinates(),
        0,
        this.ends_,
        this.stride,
        e,
        0
      ), this.flatInteriorPointRevision_ = this.getRevision();
    }
    return (
      /** @type {import("../coordinate.js").Coordinate} */
      this.flatInteriorPoint_
    );
  }
  /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */
  getInteriorPoint() {
    return new Yo(this.getFlatInteriorPoint(), "XYM");
  }
  /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */
  getLinearRingCount() {
    return this.ends_.length;
  }
  /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */
  getLinearRing(e) {
    return e < 0 || this.ends_.length <= e ? null : new Ez(
      this.flatCoordinates.slice(
        e === 0 ? 0 : this.ends_[e - 1],
        this.ends_[e]
      ),
      this.layout
    );
  }
  /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */
  getLinearRings() {
    const e = this.layout, n = this.flatCoordinates, i = this.ends_, s = [];
    let l = 0;
    for (let a = 0, o = i.length; a < o; ++a) {
      const h = i[a], u = new Ez(
        n.slice(l, h),
        e
      );
      s.push(u), l = h;
    }
    return s;
  }
  /**
   * @return {Array<number>} Oriented flat coordinates.
   */
  getOrientedFlatCoordinates() {
    if (this.orientedRevision_ != this.getRevision()) {
      const e = this.flatCoordinates;
      cq(e, 0, this.ends_, this.stride) ? this.orientedFlatCoordinates_ = e : (this.orientedFlatCoordinates_ = e.slice(), this.orientedFlatCoordinates_.length = Gh(
        this.orientedFlatCoordinates_,
        0,
        this.ends_,
        this.stride
      )), this.orientedRevision_ = this.getRevision();
    }
    return (
      /** @type {Array<number>} */
      this.orientedFlatCoordinates_
    );
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */
  getSimplifiedGeometryInternal(e) {
    const n = [], i = [];
    return n.length = lq(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      Math.sqrt(e),
      n,
      0,
      i
    ), new Os(n, "XY", i);
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */
  getType() {
    return "Polygon";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */
  intersectsExtent(e) {
    return jS(
      this.getOrientedFlatCoordinates(),
      0,
      this.ends_,
      this.stride,
      e
    );
  }
  /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */
  setCoordinates(e, n) {
    this.setLayout(n, e, 2), this.flatCoordinates || (this.flatCoordinates = []);
    const i = Mc(
      this.flatCoordinates,
      0,
      e,
      this.stride,
      this.ends_
    );
    this.flatCoordinates.length = i.length === 0 ? 0 : i[i.length - 1], this.changed();
  }
}
function Az(t) {
  if (zc(t))
    throw new Error("Cannot create polygon from empty extent");
  const e = t[0], n = t[1], i = t[2], s = t[3], l = [
    e,
    n,
    e,
    s,
    i,
    s,
    i,
    n,
    e,
    n
  ];
  return new Os(l, "XY", [l.length]);
}
const M6 = {
  /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */
  PRERENDER: "prerender",
  /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */
  POSTRENDER: "postrender",
  /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */
  PRECOMPOSE: "precompose",
  /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */
  POSTCOMPOSE: "postcompose",
  /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */
  RENDERCOMPLETE: "rendercomplete"
}, Y3 = {
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
  EMPTY: 4
}, Xo = {
  name: "rgb",
  min: [0, 0, 0],
  max: [255, 255, 255],
  channel: ["red", "green", "blue"],
  alias: ["RGB"]
};
var W4 = {
  name: "xyz",
  min: [0, 0, 0],
  channel: ["X", "Y", "Z"],
  alias: ["XYZ", "ciexyz", "cie1931"]
};
W4.whitepoint = {
  //1931 2°
  2: {
    //incadescent
    A: [109.85, 100, 35.585],
    // B:[],
    C: [98.074, 100, 118.232],
    D50: [96.422, 100, 82.521],
    D55: [95.682, 100, 92.149],
    //daylight
    D65: [95.045592705167, 100, 108.9057750759878],
    D75: [94.972, 100, 122.638],
    //flourescent
    // F1: [],
    F2: [99.187, 100, 67.395],
    // F3: [],
    // F4: [],
    // F5: [],
    // F6:[],
    F7: [95.044, 100, 108.755],
    // F8: [],
    // F9: [],
    // F10: [],
    F11: [100.966, 100, 64.37],
    // F12: [],
    E: [100, 100, 100]
  },
  //1964  10°
  10: {
    //incadescent
    A: [111.144, 100, 35.2],
    C: [97.285, 100, 116.145],
    D50: [96.72, 100, 81.427],
    D55: [95.799, 100, 90.926],
    //daylight
    D65: [94.811, 100, 107.304],
    D75: [94.416, 100, 120.641],
    //flourescent
    F2: [103.28, 100, 69.026],
    F7: [95.792, 100, 107.687],
    F11: [103.866, 100, 65.627],
    E: [100, 100, 100]
  }
};
W4.max = W4.whitepoint[2].D65;
W4.rgb = function(t, e) {
  e = e || W4.whitepoint[2].E;
  var n = t[0] / e[0], i = t[1] / e[1], s = t[2] / e[2], l, a, o;
  return l = n * 3.240969941904521 + i * -1.537383177570093 + s * -0.498610760293, a = n * -0.96924363628087 + i * 1.87596750150772 + s * 0.041555057407175, o = n * 0.055630079696993 + i * -0.20397695888897 + s * 1.056971514242878, l = l > 31308e-7 ? 1.055 * Math.pow(l, 1 / 2.4) - 0.055 : l = l * 12.92, a = a > 31308e-7 ? 1.055 * Math.pow(a, 1 / 2.4) - 0.055 : a = a * 12.92, o = o > 31308e-7 ? 1.055 * Math.pow(o, 1 / 2.4) - 0.055 : o = o * 12.92, l = Math.min(Math.max(0, l), 1), a = Math.min(Math.max(0, a), 1), o = Math.min(Math.max(0, o), 1), [l * 255, a * 255, o * 255];
};
Xo.xyz = function(t, e) {
  var n = t[0] / 255, i = t[1] / 255, s = t[2] / 255;
  n = n > 0.04045 ? Math.pow((n + 0.055) / 1.055, 2.4) : n / 12.92, i = i > 0.04045 ? Math.pow((i + 0.055) / 1.055, 2.4) : i / 12.92, s = s > 0.04045 ? Math.pow((s + 0.055) / 1.055, 2.4) : s / 12.92;
  var l = n * 0.41239079926595 + i * 0.35758433938387 + s * 0.18048078840183, a = n * 0.21263900587151 + i * 0.71516867876775 + s * 0.072192315360733, o = n * 0.019330818715591 + i * 0.11919477979462 + s * 0.95053215224966;
  return e = e || W4.whitepoint[2].E, [l * e[0], a * e[1], o * e[2]];
};
const hq = {
  name: "luv",
  //NOTE: luv has no rigidly defined limits
  //easyrgb fails to get proper coords
  //boronine states no rigid limits
  //colorMine refers this ones:
  min: [0, -134, -140],
  max: [100, 224, 122],
  channel: ["lightness", "u", "v"],
  alias: ["LUV", "cieluv", "cie1976"],
  xyz: function(t, e, n) {
    var i, s, l, a, o, h, u, d, v, m, p, _, q;
    if (l = t[0], a = t[1], o = t[2], l === 0)
      return [0, 0, 0];
    var M = 0.0011070564598794539;
    return e = e || "D65", n = n || 2, v = W4.whitepoint[n][e][0], m = W4.whitepoint[n][e][1], p = W4.whitepoint[n][e][2], _ = 4 * v / (v + 15 * m + 3 * p), q = 9 * m / (v + 15 * m + 3 * p), i = a / (13 * l) + _ || 0, s = o / (13 * l) + q || 0, u = l > 8 ? m * Math.pow((l + 16) / 116, 3) : m * l * M, h = u * 9 * i / (4 * s) || 0, d = u * (12 - 3 * i - 20 * s) / (4 * s) || 0, [h, u, d];
  }
};
W4.luv = function(t, e, n) {
  var i, s, l, a, o, h, u, d, v, m, p, _, q, M = 0.008856451679035631, z = 903.2962962962961;
  e = e || "D65", n = n || 2, v = W4.whitepoint[n][e][0], m = W4.whitepoint[n][e][1], p = W4.whitepoint[n][e][2], _ = 4 * v / (v + 15 * m + 3 * p), q = 9 * m / (v + 15 * m + 3 * p), h = t[0], u = t[1], d = t[2], i = 4 * h / (h + 15 * u + 3 * d) || 0, s = 9 * u / (h + 15 * u + 3 * d) || 0;
  var b = u / m;
  return l = b <= M ? z * b : 116 * Math.pow(b, 1 / 3) - 16, a = 13 * l * (i - _), o = 13 * l * (s - q), [l, a, o];
};
var WS = {
  name: "lchuv",
  channel: ["lightness", "chroma", "hue"],
  alias: ["LCHuv", "cielchuv"],
  min: [0, 0, 0],
  max: [100, 100, 360],
  luv: function(t) {
    var e = t[0], n = t[1], i = t[2], s, l, a;
    return a = i / 360 * 2 * Math.PI, s = n * Math.cos(a), l = n * Math.sin(a), [e, s, l];
  },
  xyz: function(t) {
    return hq.xyz(WS.luv(t));
  }
};
hq.lchuv = function(t) {
  var e = t[0], n = t[1], i = t[2], s = Math.sqrt(n * n + i * i), l = Math.atan2(i, n), a = l * 360 / 2 / Math.PI;
  return a < 0 && (a += 360), [e, s, a];
};
W4.lchuv = function(t) {
  return hq.lchuv(W4.luv(t));
};
const Fz = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
};
var Tz = {
  red: 0,
  orange: 60,
  yellow: 120,
  green: 180,
  blue: 240,
  purple: 300
};
function ty1(t) {
  var d, v;
  var e, n = [], i = 1, s;
  if (typeof t == "number")
    return { space: "rgb", values: [t >>> 16, (t & 65280) >>> 8, t & 255], alpha: 1 };
  if (typeof t == "number")
    return { space: "rgb", values: [t >>> 16, (t & 65280) >>> 8, t & 255], alpha: 1 };
  if (t = String(t).toLowerCase(), Fz[t])
    n = Fz[t].slice(), s = "rgb";
  else if (t === "transparent")
    i = 0, s = "rgb", n = [0, 0, 0];
  else if (t[0] === "#") {
    var l = t.slice(1), a = l.length, o = a <= 4;
    i = 1, o ? (n = [
      parseInt(l[0] + l[0], 16),
      parseInt(l[1] + l[1], 16),
      parseInt(l[2] + l[2], 16)
    ], a === 4 && (i = parseInt(l[3] + l[3], 16) / 255)) : (n = [
      parseInt(l[0] + l[1], 16),
      parseInt(l[2] + l[3], 16),
      parseInt(l[4] + l[5], 16)
    ], a === 8 && (i = parseInt(l[6] + l[7], 16) / 255)), n[0] || (n[0] = 0), n[1] || (n[1] = 0), n[2] || (n[2] = 0), s = "rgb";
  } else if (e = /^((?:rgba?|hs[lvb]a?|hwba?|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms|oklch|oklab|color))\s*\(([^\)]*)\)/.exec(t)) {
    var h = e[1];
    s = h.replace(/a$/, "");
    var u = s === "cmyk" ? 4 : s === "gray" ? 1 : 3;
    n = e[2].trim().split(/\s*[,\/]\s*|\s+/), s === "color" && (s = n.shift()), n = n.map(function(m, p) {
      if (m[m.length - 1] === "%")
        return m = parseFloat(m) / 100, p === 3 ? m : s === "rgb" ? m * 255 : s[0] === "h" || s[0] === "l" && !p ? m * 100 : s === "lab" ? m * 125 : s === "lch" ? p < 2 ? m * 150 : m * 360 : s[0] === "o" && !p ? m : s === "oklab" ? m * 0.4 : s === "oklch" ? p < 2 ? m * 0.4 : m * 360 : m;
      if (s[p] === "h" || p === 2 && s[s.length - 1] === "h") {
        if (Tz[m] !== void 0)
          return Tz[m];
        if (m.endsWith("deg"))
          return parseFloat(m);
        if (m.endsWith("turn"))
          return parseFloat(m) * 360;
        if (m.endsWith("grad"))
          return parseFloat(m) * 360 / 400;
        if (m.endsWith("rad"))
          return parseFloat(m) * 180 / Math.PI;
      }
      return m === "none" ? 0 : parseFloat(m);
    }), i = n.length > u ? n.pop() : 1;
  } else
    /[0-9](?:\s|\/|,)/.test(t) && (n = t.match(/([0-9]+)/g).map(function(m) {
      return parseFloat(m);
    }), s = ((v = (d = t.match(/([a-z])/ig)) == null ? void 0 : d.join("")) == null ? void 0 : v.toLowerCase()) || "rgb");
  return {
    space: s,
    values: n,
    alpha: i
  };
}
const xg = {
  name: "hsl",
  min: [0, 0, 0],
  max: [360, 100, 100],
  channel: ["hue", "saturation", "lightness"],
  alias: ["HSL"],
  rgb: function(t) {
    var e = t[0] / 360, n = t[1] / 100, i = t[2] / 100, s, l, a, o, h, u = 0;
    if (n === 0)
      return h = i * 255, [h, h, h];
    for (l = i < 0.5 ? i * (1 + n) : i + n - i * n, s = 2 * i - l, o = [0, 0, 0]; u < 3; )
      a = e + 1 / 3 * -(u - 1), a < 0 ? a++ : a > 1 && a--, h = 6 * a < 1 ? s + (l - s) * 6 * a : 2 * a < 1 ? l : 3 * a < 2 ? s + (l - s) * (2 / 3 - a) * 6 : s, o[u++] = h * 255;
    return o;
  }
};
Xo.hsl = function(t) {
  var e = t[0] / 255, n = t[1] / 255, i = t[2] / 255, s = Math.min(e, n, i), l = Math.max(e, n, i), a = l - s, o, h, u;
  return l === s ? o = 0 : e === l ? o = (n - i) / a : n === l ? o = 2 + (i - e) / a : i === l && (o = 4 + (e - n) / a), o = Math.min(o * 60, 360), o < 0 && (o += 360), u = (s + l) / 2, l === s ? h = 0 : u <= 0.5 ? h = a / (l + s) : h = a / (2 - l - s), [o, h * 100, u * 100];
};
function ny1(t) {
  Array.isArray(t) && t.raw && (t = String.raw(...arguments)), t instanceof Number && (t = +t);
  var e, n = ty1(t);
  if (!n.space)
    return [];
  const i = n.space[0] === "h" ? xg.min : Xo.min, s = n.space[0] === "h" ? xg.max : Xo.max;
  return e = Array(3), e[0] = Math.min(Math.max(n.values[0], i[0]), s[0]), e[1] = Math.min(Math.max(n.values[1], i[1]), s[1]), e[2] = Math.min(Math.max(n.values[2], i[2]), s[2]), n.space[0] === "h" && (e = xg.rgb(e)), e.push(Math.min(Math.max(n.alpha, 0), 1)), e;
}
function iy1(t) {
  return typeof t == "string" ? t : dq(t);
}
const sy1 = 1024, W7 = {};
let Sg = 0;
function ly1(t) {
  if (t.length === 4)
    return t;
  const e = t.slice();
  return e[3] = 1, e;
}
function Iz(t) {
  const e = W4.lchuv(Xo.xyz(t));
  return e[3] = t[3], e;
}
function ry1(t) {
  const e = W4.rgb(WS.xyz(t));
  return e[3] = t[3], e;
}
function uq(t) {
  if (W7.hasOwnProperty(t))
    return W7[t];
  if (Sg >= sy1) {
    let n = 0;
    for (const i in W7)
      n++ & 3 || (delete W7[i], --Sg);
  }
  const e = ny1(t);
  if (e.length !== 4)
    throw new Error('failed to parse "' + t + '" as color');
  for (const n of e)
    if (isNaN(n))
      throw new Error('failed to parse "' + t + '" as color');
  return YS(e), W7[t] = e, ++Sg, e;
}
function Ko(t) {
  return Array.isArray(t) ? t : uq(t);
}
function YS(t) {
  return t[0] = bt(t[0] + 0.5 | 0, 0, 255), t[1] = bt(t[1] + 0.5 | 0, 0, 255), t[2] = bt(t[2] + 0.5 | 0, 0, 255), t[3] = bt(t[3], 0, 1), t;
}
function dq(t) {
  let e = t[0];
  e != (e | 0) && (e = e + 0.5 | 0);
  let n = t[1];
  n != (n | 0) && (n = n + 0.5 | 0);
  let i = t[2];
  i != (i | 0) && (i = i + 0.5 | 0);
  const s = t[3] === void 0 ? 1 : Math.round(t[3] * 1e3) / 1e3;
  return "rgba(" + e + "," + n + "," + i + "," + s + ")";
}
const Ns = typeof navigator < "u" && typeof navigator.userAgent < "u" ? navigator.userAgent.toLowerCase() : "", ay1 = Ns.includes("firefox"), oy1 = Ns.includes("safari") && !Ns.includes("chrom");
oy1 && (Ns.includes("version/15.4") || /cpu (os|iphone os) 15_4 like mac os x/.test(Ns));
const cy1 = Ns.includes("webkit") && !Ns.includes("edge"), fq = Ns.includes("macintosh"), XS = typeof devicePixelRatio < "u" ? devicePixelRatio : 1, KS = typeof WorkerGlobalScope < "u" && typeof OffscreenCanvas < "u" && self instanceof WorkerGlobalScope, ZS = typeof Image < "u" && Image.prototype.decode, JS = function() {
  let t = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get: function() {
        t = !0;
      }
    });
    window.addEventListener("_", null, e), window.removeEventListener("_", null, e);
  } catch {
  }
  return t;
}();
function u4(t, e, n, i) {
  let s;
  return n && n.length ? s = /** @type {HTMLCanvasElement} */
  n.shift() : KS ? s = new OffscreenCanvas(t || 300, e || 300) : s = document.createElement("canvas"), t && (s.width = t), e && (s.height = e), /** @type {CanvasRenderingContext2D} */
  s.getContext("2d", i);
}
let Cg;
function Wh() {
  return Cg || (Cg = u4(1, 1)), Cg;
}
function Ga(t) {
  const e = t.canvas;
  e.width = 1, e.height = 1, t.clearRect(0, 0, 1, 1);
}
function hy1(t) {
  let e = t.offsetWidth;
  const n = getComputedStyle(t);
  return e += parseInt(n.marginLeft, 10) + parseInt(n.marginRight, 10), e;
}
function uy1(t) {
  let e = t.offsetHeight;
  const n = getComputedStyle(t);
  return e += parseInt(n.marginTop, 10) + parseInt(n.marginBottom, 10), e;
}
function Oz(t, e) {
  const n = e.parentNode;
  n && n.replaceChild(t, e);
}
function QS(t) {
  for (; t.lastChild; )
    t.lastChild.remove();
}
function dy1(t, e) {
  const n = t.childNodes;
  for (let i = 0; ; ++i) {
    const s = n[i], l = e[i];
    if (!s && !l)
      break;
    if (s !== l) {
      if (!s) {
        t.appendChild(l);
        continue;
      }
      if (!l) {
        t.removeChild(s), --i;
        continue;
      }
      t.insertBefore(l, s);
    }
  }
}
function fy1(t, e, n) {
  const i = (
    /** @type {HTMLImageElement} */
    t
  );
  let s = !0, l = !1, a = !1;
  const o = [
    Uh(i, T3.LOAD, function() {
      a = !0, l || e();
    })
  ];
  return i.src && ZS ? (l = !0, i.decode().then(function() {
    s && e();
  }).catch(function(h) {
    s && (a ? e() : n());
  })) : o.push(Uh(i, T3.ERROR, n)), function() {
    s = !1, o.forEach(Qe);
  };
}
function vy1(t, e) {
  return new Promise((n, i) => {
    function s() {
      a(), n(t);
    }
    function l() {
      a(), i(new Error("Image load error"));
    }
    function a() {
      t.removeEventListener("load", s), t.removeEventListener("error", l);
    }
    t.addEventListener("load", s), t.addEventListener("error", l), e && (t.src = e);
  });
}
function py1(t, e) {
  return e && (t.src = e), t.src && ZS ? new Promise(
    (n, i) => t.decode().then(() => n(t)).catch(
      (s) => t.complete && t.width ? n(t) : i(s)
    )
  ) : vy1(t);
}
class my1 {
  constructor() {
    this.cache_ = {}, this.patternCache_ = {}, this.cacheSize_ = 0, this.maxCacheSize_ = 32;
  }
  /**
   * FIXME empty description for jsdoc
   */
  clear() {
    this.cache_ = {}, this.patternCache_ = {}, this.cacheSize_ = 0;
  }
  /**
   * @return {boolean} Can expire cache.
   */
  canExpireCache() {
    return this.cacheSize_ > this.maxCacheSize_;
  }
  /**
   * FIXME empty description for jsdoc
   */
  expire() {
    if (this.canExpireCache()) {
      let e = 0;
      for (const n in this.cache_) {
        const i = this.cache_[n];
        !(e++ & 3) && !i.hasListener() && (delete this.cache_[n], delete this.patternCache_[n], --this.cacheSize_);
      }
    }
  }
  /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */
  get(e, n, i) {
    const s = kg(e, n, i);
    return s in this.cache_ ? this.cache_[s] : null;
  }
  /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */
  getPattern(e, n, i) {
    const s = kg(e, n, i);
    return s in this.patternCache_ ? this.patternCache_[s] : null;
  }
  /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */
  set(e, n, i, s, l) {
    const a = kg(e, n, i), o = a in this.cache_;
    this.cache_[a] = s, l && (s.getImageState() === Y3.IDLE && s.load(), s.getImageState() === Y3.LOADING ? s.ready().then(() => {
      this.patternCache_[a] = Wh().createPattern(
        s.getImage(1),
        "repeat"
      );
    }) : this.patternCache_[a] = Wh().createPattern(
      s.getImage(1),
      "repeat"
    )), o || ++this.cacheSize_;
  }
  /**
   * Set the cache size of the icon cache. Default is `32`. Change this value when
   * your map uses more than 32 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */
  setSize(e) {
    this.maxCacheSize_ = e, this.expire();
  }
}
function kg(t, e, n) {
  const i = n ? Ko(n) : "null";
  return e + ":" + t + ":" + i;
}
const Yn = new my1();
let Y7 = null;
class gy1 extends Gu {
  /**
   * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */
  constructor(e, n, i, s, l) {
    super(), this.hitDetectionImage_ = null, this.image_ = e, this.crossOrigin_ = i, this.canvas_ = {}, this.color_ = l, this.imageState_ = s === void 0 ? Y3.IDLE : s, this.size_ = e && e.width && e.height ? [e.width, e.height] : null, this.src_ = n, this.tainted_, this.ready_ = null;
  }
  /**
   * @private
   */
  initializeImage_() {
    this.image_ = new Image(), this.crossOrigin_ !== null && (this.image_.crossOrigin = this.crossOrigin_);
  }
  /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */
  isTainted_() {
    if (this.tainted_ === void 0 && this.imageState_ === Y3.LOADED) {
      Y7 || (Y7 = u4(1, 1, void 0, {
        willReadFrequently: !0
      })), Y7.drawImage(this.image_, 0, 0);
      try {
        Y7.getImageData(0, 0, 1, 1), this.tainted_ = !1;
      } catch {
        Y7 = null, this.tainted_ = !0;
      }
    }
    return this.tainted_ === !0;
  }
  /**
   * @private
   */
  dispatchChangeEvent_() {
    this.dispatchEvent(T3.CHANGE);
  }
  /**
   * @private
   */
  handleImageError_() {
    this.imageState_ = Y3.ERROR, this.dispatchChangeEvent_();
  }
  /**
   * @private
   */
  handleImageLoad_() {
    this.imageState_ = Y3.LOADED, this.size_ = [this.image_.width, this.image_.height], this.dispatchChangeEvent_();
  }
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */
  getImage(e) {
    return this.image_ || this.initializeImage_(), this.replaceColor_(e), this.canvas_[e] ? this.canvas_[e] : this.image_;
  }
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */
  getPixelRatio(e) {
    return this.replaceColor_(e), this.canvas_[e] ? e : 1;
  }
  /**
   * @return {import("../ImageState.js").default} Image state.
   */
  getImageState() {
    return this.imageState_;
  }
  /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */
  getHitDetectionImage() {
    if (this.image_ || this.initializeImage_(), !this.hitDetectionImage_)
      if (this.isTainted_()) {
        const e = this.size_[0], n = this.size_[1], i = u4(e, n);
        i.fillRect(0, 0, e, n), this.hitDetectionImage_ = i.canvas;
      } else
        this.hitDetectionImage_ = this.image_;
    return this.hitDetectionImage_;
  }
  /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */
  getSize() {
    return this.size_;
  }
  /**
   * @return {string|undefined} Image src.
   */
  getSrc() {
    return this.src_;
  }
  /**
   * Load not yet loaded URI.
   */
  load() {
    if (this.imageState_ === Y3.IDLE) {
      this.image_ || this.initializeImage_(), this.imageState_ = Y3.LOADING;
      try {
        this.src_ !== void 0 && (this.image_.src = this.src_);
      } catch {
        this.handleImageError_();
      }
      this.image_ instanceof HTMLImageElement && py1(this.image_, this.src_).then((e) => {
        this.image_ = e, this.handleImageLoad_();
      }).catch(this.handleImageError_.bind(this));
    }
  }
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */
  replaceColor_(e) {
    if (!this.color_ || this.canvas_[e] || this.imageState_ !== Y3.LOADED)
      return;
    const n = this.image_, i = document.createElement("canvas");
    i.width = Math.ceil(n.width * e), i.height = Math.ceil(n.height * e);
    const s = i.getContext("2d");
    s.scale(e, e), s.drawImage(n, 0, 0), s.globalCompositeOperation = "multiply", s.fillStyle = iy1(this.color_), s.fillRect(0, 0, i.width / e, i.height / e), s.globalCompositeOperation = "destination-in", s.drawImage(n, 0, 0), this.canvas_[e] = i;
  }
  /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */
  ready() {
    return this.ready_ || (this.ready_ = new Promise((e) => {
      if (this.imageState_ === Y3.LOADED || this.imageState_ === Y3.ERROR)
        e();
      else {
        const n = () => {
          (this.imageState_ === Y3.LOADED || this.imageState_ === Y3.ERROR) && (this.removeEventListener(T3.CHANGE, n), e());
        };
        this.addEventListener(T3.CHANGE, n);
      }
    })), this.ready_;
  }
}
function vq(t, e, n, i, s, l) {
  let a = e === void 0 ? void 0 : Yn.get(e, n, s);
  return a || (a = new gy1(
    t,
    t && "src" in t ? t.src || void 0 : e,
    n,
    i,
    s
  ), Yn.set(e, n, s, a, l)), l && a && !Yn.getPattern(e, n, s) && Yn.set(e, n, s, a, l), a;
}
class pq {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {}, this.patternImage_ = null, this.color_ = null, e.color !== void 0 && this.setColor(e.color);
  }
  /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */
  clone() {
    const e = this.getColor();
    return new pq({
      color: Array.isArray(e) ? e.slice() : e || void 0
    });
  }
  /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */
  getColor() {
    return this.color_;
  }
  /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */
  setColor(e) {
    if (e !== null && typeof e == "object" && "src" in e) {
      const n = vq(
        null,
        e.src,
        "anonymous",
        void 0,
        e.offset ? null : e.color ? e.color : null,
        !(e.offset && e.size)
      );
      n.ready().then(() => {
        this.patternImage_ = null;
      }), n.getImageState() === Y3.IDLE && n.load(), n.getImageState() === Y3.LOADING && (this.patternImage_ = n);
    }
    this.color_ = e;
  }
  /**
   * @return {boolean} The fill style is loading an image pattern.
   */
  loading() {
    return !!this.patternImage_;
  }
  /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */
  ready() {
    return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
  }
}
const Ju = pq;
function Yh(t, e, n, i, s, l, a) {
  let o, h;
  const u = (n - e) / i;
  if (u === 1)
    o = e;
  else if (u === 2)
    o = e, h = s;
  else if (u !== 0) {
    let d = t[e], v = t[e + 1], m = 0;
    const p = [0];
    for (let M = e + i; M < n; M += i) {
      const z = t[M], b = t[M + 1];
      m += Math.sqrt((z - d) * (z - d) + (b - v) * (b - v)), p.push(m), d = z, v = b;
    }
    const _ = s * m, q = bg1(p, _);
    q < 0 ? (h = (_ - p[-q - 2]) / (p[-q - 1] - p[-q - 2]), o = e + (-q - 2) * i) : o = e + q * i;
  }
  a = a > 1 ? a : 2, l = l || new Array(a);
  for (let d = 0; d < a; ++d)
    l[d] = o === void 0 ? NaN : h === void 0 ? t[o + d] : V0(t[o + d], t[o + i + d], h);
  return l;
}
function Sy(t, e, n, i, s, l) {
  if (n == e)
    return null;
  let a;
  if (s < t[e + i - 1])
    return l ? (a = t.slice(e, e + i), a[i - 1] = s, a) : null;
  if (t[n - 1] < s)
    return l ? (a = t.slice(n - i, n), a[i - 1] = s, a) : null;
  if (s == t[e + i - 1])
    return t.slice(e, e + i);
  let o = e / i, h = n / i;
  for (; o < h; ) {
    const m = o + h >> 1;
    s < t[(m + 1) * i - 1] ? h = m : o = m + 1;
  }
  const u = t[o * i - 1];
  if (s == u)
    return t.slice((o - 1) * i, (o - 1) * i + i);
  const d = t[(o + 1) * i - 1], v = (s - u) / (d - u);
  a = [];
  for (let m = 0; m < i - 1; ++m)
    a.push(
      V0(
        t[(o - 1) * i + m],
        t[o * i + m],
        v
      )
    );
  return a.push(s), a;
}
function yy1(t, e, n, i, s, l, a) {
  if (a)
    return Sy(
      t,
      e,
      n[n.length - 1],
      i,
      s,
      l
    );
  let o;
  if (s < t[i - 1])
    return l ? (o = t.slice(0, i), o[i - 1] = s, o) : null;
  if (t[t.length - 1] < s)
    return l ? (o = t.slice(t.length - i), o[i - 1] = s, o) : null;
  for (let h = 0, u = n.length; h < u; ++h) {
    const d = n[h];
    if (e != d) {
      if (s < t[e + i - 1])
        return null;
      if (s <= t[d - 1])
        return Sy(
          t,
          e,
          d,
          i,
          s,
          !1
        );
      e = d;
    }
  }
  return null;
}
function eC(t, e, n, i) {
  let s = t[e], l = t[e + 1], a = 0;
  for (let o = e + i; o < n; o += i) {
    const h = t[o], u = t[o + 1];
    a += Math.sqrt((h - s) * (h - s) + (u - l) * (u - l)), s = h, l = u;
  }
  return a;
}
class Xh extends Sr {
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  constructor(e, n) {
    super(), this.flatMidpoint_ = null, this.flatMidpointRevision_ = -1, this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, n !== void 0 && !Array.isArray(e[0]) ? this.setFlatCoordinates(
      n,
      /** @type {Array<number>} */
      e
    ) : this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      e,
      n
    );
  }
  /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */
  appendCoordinate(e) {
    ni(this.flatCoordinates, e), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */
  clone() {
    const e = new Xh(
      this.flatCoordinates.slice(),
      this.layout
    );
    return e.applyProperties(this), e;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */
  closestPointXY(e, n, i, s) {
    return s < br(this.getExtent(), e, n) ? s : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      tq(
        this.flatCoordinates,
        0,
        this.flatCoordinates.length,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), iq(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      this.maxDelta_,
      !1,
      e,
      n,
      i,
      s
    ));
  }
  /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */
  forEachSegment(e) {
    return $S(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      e
    );
  }
  /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */
  getCoordinateAtM(e, n) {
    return this.layout != "XYM" && this.layout != "XYZM" ? null : (n = n !== void 0 ? n : !1, Sy(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      e,
      n
    ));
  }
  /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */
  getCoordinates() {
    return ws(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */
  getCoordinateAt(e, n) {
    return Yh(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      e,
      n,
      this.stride
    );
  }
  /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */
  getLength() {
    return eC(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * @return {Array<number>} Flat midpoint.
   */
  getFlatMidpoint() {
    return this.flatMidpointRevision_ != this.getRevision() && (this.flatMidpoint_ = this.getCoordinateAt(
      0.5,
      this.flatMidpoint_ ?? void 0
    ), this.flatMidpointRevision_ = this.getRevision()), /** @type {Array<number>} */
    this.flatMidpoint_;
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */
  getSimplifiedGeometryInternal(e) {
    const n = [];
    return n.length = Ku(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      e,
      n,
      0
    ), new Xh(n, "XY");
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */
  getType() {
    return "LineString";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */
  intersectsExtent(e) {
    return Zu(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride,
      e
    );
  }
  /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */
  setCoordinates(e, n) {
    this.setLayout(n, e, 1), this.flatCoordinates || (this.flatCoordinates = []), this.flatCoordinates.length = Xu(
      this.flatCoordinates,
      0,
      e,
      this.stride
    ), this.changed();
  }
}
const Cy = Xh;
class mq {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {}, this.color_ = e.color !== void 0 ? e.color : null, this.lineCap_ = e.lineCap, this.lineDash_ = e.lineDash !== void 0 ? e.lineDash : null, this.lineDashOffset_ = e.lineDashOffset, this.lineJoin_ = e.lineJoin, this.miterLimit_ = e.miterLimit, this.width_ = e.width;
  }
  /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */
  clone() {
    const e = this.getColor();
    return new mq({
      color: Array.isArray(e) ? e.slice() : e || void 0,
      lineCap: this.getLineCap(),
      lineDash: this.getLineDash() ? this.getLineDash().slice() : void 0,
      lineDashOffset: this.getLineDashOffset(),
      lineJoin: this.getLineJoin(),
      miterLimit: this.getMiterLimit(),
      width: this.getWidth()
    });
  }
  /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */
  getColor() {
    return this.color_;
  }
  /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */
  getLineCap() {
    return this.lineCap_;
  }
  /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */
  getLineDash() {
    return this.lineDash_;
  }
  /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */
  getLineDashOffset() {
    return this.lineDashOffset_;
  }
  /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */
  getLineJoin() {
    return this.lineJoin_;
  }
  /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */
  getMiterLimit() {
    return this.miterLimit_;
  }
  /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */
  getWidth() {
    return this.width_;
  }
  /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */
  setColor(e) {
    this.color_ = e;
  }
  /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */
  setLineCap(e) {
    this.lineCap_ = e;
  }
  /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */
  setLineDash(e) {
    this.lineDash_ = e;
  }
  /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */
  setLineDashOffset(e) {
    this.lineDashOffset_ = e;
  }
  /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */
  setLineJoin(e) {
    this.lineJoin_ = e;
  }
  /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */
  setMiterLimit(e) {
    this.miterLimit_ = e;
  }
  /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */
  setWidth(e) {
    this.width_ = e;
  }
}
const gq = mq;
function Nz(t) {
  return t[0] > 0 && t[1] > 0;
}
function _y1(t, e, n) {
  return n === void 0 && (n = [0, 0]), n[0] = t[0] * e + 0.5 | 0, n[1] = t[1] * e + 0.5 | 0, n;
}
function o0(t, e) {
  return Array.isArray(t) ? t : (e === void 0 ? e = [t, t] : (e[0] = t, e[1] = t), e);
}
class yq {
  /**
   * @param {Options} options Options.
   */
  constructor(e) {
    this.opacity_ = e.opacity, this.rotateWithView_ = e.rotateWithView, this.rotation_ = e.rotation, this.scale_ = e.scale, this.scaleArray_ = o0(e.scale), this.displacement_ = e.displacement, this.declutterMode_ = e.declutterMode;
  }
  /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */
  clone() {
    const e = this.getScale();
    return new yq({
      opacity: this.getOpacity(),
      scale: Array.isArray(e) ? e.slice() : e,
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      displacement: this.getDisplacement().slice(),
      declutterMode: this.getDeclutterMode()
    });
  }
  /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */
  getOpacity() {
    return this.opacity_;
  }
  /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */
  getRotateWithView() {
    return this.rotateWithView_;
  }
  /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */
  getRotation() {
    return this.rotation_;
  }
  /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */
  getScale() {
    return this.scale_;
  }
  /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */
  getScaleArray() {
    return this.scaleArray_;
  }
  /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */
  getDisplacement() {
    return this.displacement_;
  }
  /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */
  getDeclutterMode() {
    return this.declutterMode_;
  }
  /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */
  getAnchor() {
    return b3();
  }
  /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */
  getImage(e) {
    return b3();
  }
  /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */
  getHitDetectionImage() {
    return b3();
  }
  /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */
  getPixelRatio(e) {
    return 1;
  }
  /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */
  getImageState() {
    return b3();
  }
  /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */
  getImageSize() {
    return b3();
  }
  /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */
  getOrigin() {
    return b3();
  }
  /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */
  getSize() {
    return b3();
  }
  /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */
  setDisplacement(e) {
    this.displacement_ = e;
  }
  /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */
  setOpacity(e) {
    this.opacity_ = e;
  }
  /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */
  setRotateWithView(e) {
    this.rotateWithView_ = e;
  }
  /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */
  setRotation(e) {
    this.rotation_ = e;
  }
  /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */
  setScale(e) {
    this.scale_ = e, this.scaleArray_ = o0(e);
  }
  /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */
  listenImageChange(e) {
    b3();
  }
  /**
   * Load not yet loaded URI.
   * @abstract
   */
  load() {
    b3();
  }
  /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */
  unlistenImageChange(e) {
    b3();
  }
  /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */
  ready() {
    return Promise.resolve();
  }
}
const tC = yq;
function Xn(t) {
  return t ? Array.isArray(t) ? dq(t) : typeof t == "object" && "src" in t ? qy1(t) : t : null;
}
function qy1(t) {
  if (!t.offset || !t.size)
    return Yn.getPattern(t.src, "anonymous", t.color);
  const e = t.src + ":" + t.offset, n = Yn.getPattern(
    e,
    void 0,
    t.color
  );
  if (n)
    return n;
  const i = Yn.get(t.src, "anonymous", null);
  if (i.getImageState() !== Y3.LOADED)
    return null;
  const s = u4(
    t.size[0],
    t.size[1]
  );
  return s.drawImage(
    i.getImage(1),
    t.offset[0],
    t.offset[1],
    t.size[0],
    t.size[1],
    0,
    0,
    t.size[0],
    t.size[1]
  ), vq(
    s.canvas,
    e,
    void 0,
    Y3.LOADED,
    t.color,
    !0
  ), Yn.getPattern(e, void 0, t.color);
}
const Kc = "ol-hidden", wy1 = "ol-selectable", Qu = "ol-unselectable", _q = "ol-control", Pz = "ol-collapsed", zy1 = new RegExp(
  [
    "^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)",
    "(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?",
    "(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))",
    "(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))",
    `?\\s*([-,\\"\\'\\sa-z]+?)\\s*$`
  ].join(""),
  "i"
), Bz = [
  "style",
  "variant",
  "weight",
  "size",
  "lineHeight",
  "family"
], nC = function(t) {
  const e = t.match(zy1);
  if (!e)
    return null;
  const n = (
    /** @type {FontParameters} */
    {
      lineHeight: "normal",
      size: "1.2em",
      style: "normal",
      weight: "normal",
      variant: "normal"
    }
  );
  for (let i = 0, s = Bz.length; i < s; ++i) {
    const l = e[i + 1];
    l !== void 0 && (n[Bz[i]] = l);
  }
  return n.families = n.family.split(/,\s?/), n;
}, iC = "10px sans-serif", s0 = "#000", Wa = "round", g8 = [], y8 = 0, Ya = "round", Zo = 10, Jo = "#000", Qo = "center", Kh = "middle", ir = [0, 0, 0, 0], ec = 1, o8 = new gn();
let la = null, ky;
const Ey = {}, My1 = function() {
  const e = "32px ", n = ["monospace", "serif"], i = n.length, s = "wmytzilWMYTZIL@#/&?$%10";
  let l, a;
  function o(u, d, v) {
    let m = !0;
    for (let p = 0; p < i; ++p) {
      const _ = n[p];
      if (a = Zh(
        u + " " + d + " " + e + _,
        s
      ), v != _) {
        const q = Zh(
          u + " " + d + " " + e + v + "," + _,
          s
        );
        m = m && q != a;
      }
    }
    return !!m;
  }
  function h() {
    let u = !0;
    const d = o8.getKeys();
    for (let v = 0, m = d.length; v < m; ++v) {
      const p = d[v];
      if (o8.get(p) < 100) {
        const [_, q, M] = p.split(`
`);
        o(_, q, M) ? (wc(Ey), la = null, ky = void 0, o8.set(p, 100)) : (o8.set(p, o8.get(p) + 1, !0), u = !1);
      }
    }
    u && (clearInterval(l), l = void 0);
  }
  return function(u) {
    const d = nC(u);
    if (!d)
      return;
    const v = d.families;
    for (let m = 0, p = v.length; m < p; ++m) {
      const _ = v[m], q = d.style + `
` + d.weight + `
` + _;
      o8.get(q) === void 0 && (o8.set(q, 100, !0), o(d.style, d.weight, _) || (o8.set(q, 0, !0), l === void 0 && (l = setInterval(h, 32))));
    }
  };
}(), by1 = function() {
  let t;
  return function(e) {
    let n = Ey[e];
    if (n == null) {
      if (KS) {
        const i = nC(e), s = sC(e, "Žg");
        n = (isNaN(Number(i.lineHeight)) ? 1.2 : Number(i.lineHeight)) * (s.actualBoundingBoxAscent + s.actualBoundingBoxDescent);
      } else
        t || (t = document.createElement("div"), t.innerHTML = "M", t.style.minHeight = "0", t.style.maxHeight = "none", t.style.height = "auto", t.style.padding = "0", t.style.border = "none", t.style.position = "absolute", t.style.display = "block", t.style.left = "-99999px"), t.style.font = e, document.body.appendChild(t), n = t.offsetHeight, document.body.removeChild(t);
      Ey[e] = n;
    }
    return n;
  };
}();
function sC(t, e) {
  return la || (la = u4(1, 1)), t != ky && (la.font = t, ky = la.font), la.measureText(e);
}
function Zh(t, e) {
  return sC(t, e).width;
}
function Vz(t, e, n) {
  if (e in n)
    return n[e];
  const i = e.split(`
`).reduce((s, l) => Math.max(s, Zh(t, l)), 0);
  return n[e] = i, i;
}
function Ly1(t, e) {
  const n = [], i = [], s = [];
  let l = 0, a = 0, o = 0, h = 0;
  for (let u = 0, d = e.length; u <= d; u += 2) {
    const v = e[u];
    if (v === `
` || u === d) {
      l = Math.max(l, a), s.push(a), a = 0, o += h, h = 0;
      continue;
    }
    const m = e[u + 1] || t.font, p = Zh(m, v);
    n.push(p), a += p;
    const _ = by1(m);
    i.push(_), h = Math.max(h, _);
  }
  return { width: l, height: o, widths: n, heights: i, lineWidths: s };
}
function xy1(t, e, n, i, s, l, a, o, h, u, d) {
  t.save(), n !== 1 && (t.globalAlpha === void 0 ? t.globalAlpha = (v) => v.globalAlpha *= n : t.globalAlpha *= n), e && t.transform.apply(t, e), /** @type {*} */
  i.contextInstructions ? (t.translate(h, u), t.scale(d[0], d[1]), Sy1(
    /** @type {Label} */
    i,
    t
  )) : d[0] < 0 || d[1] < 0 ? (t.translate(h, u), t.scale(d[0], d[1]), t.drawImage(
    /** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */
    i,
    s,
    l,
    a,
    o,
    0,
    0,
    a,
    o
  )) : t.drawImage(
    /** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */
    i,
    s,
    l,
    a,
    o,
    h,
    u,
    a * d[0],
    o * d[1]
  ), t.restore();
}
function Sy1(t, e) {
  const n = t.contextInstructions;
  for (let i = 0, s = n.length; i < s; i += 2)
    Array.isArray(n[i + 1]) ? e[n[i]].apply(
      e,
      n[i + 1]
    ) : e[n[i]] = n[i + 1];
}
class qq extends tC {
  /**
   * @param {Options} options Options.
   */
  constructor(e) {
    super({
      opacity: 1,
      rotateWithView: e.rotateWithView !== void 0 ? e.rotateWithView : !1,
      rotation: e.rotation !== void 0 ? e.rotation : 0,
      scale: e.scale !== void 0 ? e.scale : 1,
      displacement: e.displacement !== void 0 ? e.displacement : [0, 0],
      declutterMode: e.declutterMode
    }), this.canvases_, this.hitDetectionCanvas_ = null, this.fill_ = e.fill !== void 0 ? e.fill : null, this.origin_ = [0, 0], this.points_ = e.points, this.radius = e.radius, this.radius2_ = e.radius2, this.angle_ = e.angle !== void 0 ? e.angle : 0, this.stroke_ = e.stroke !== void 0 ? e.stroke : null, this.size_, this.renderOptions_, this.imageState_ = this.fill_ && this.fill_.loading() ? Y3.LOADING : Y3.LOADED, this.imageState_ === Y3.LOADING && this.ready().then(() => this.imageState_ = Y3.LOADED), this.render();
  }
  /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */
  clone() {
    const e = this.getScale(), n = new qq({
      fill: this.getFill() ? this.getFill().clone() : void 0,
      points: this.getPoints(),
      radius: this.getRadius(),
      radius2: this.getRadius2(),
      angle: this.getAngle(),
      stroke: this.getStroke() ? this.getStroke().clone() : void 0,
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      scale: Array.isArray(e) ? e.slice() : e,
      displacement: this.getDisplacement().slice(),
      declutterMode: this.getDeclutterMode()
    });
    return n.setOpacity(this.getOpacity()), n;
  }
  /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */
  getAnchor() {
    const e = this.size_, n = this.getDisplacement(), i = this.getScaleArray();
    return [
      e[0] / 2 - n[0] / i[0],
      e[1] / 2 + n[1] / i[1]
    ];
  }
  /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */
  getAngle() {
    return this.angle_;
  }
  /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */
  getFill() {
    return this.fill_;
  }
  /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */
  setFill(e) {
    this.fill_ = e, this.render();
  }
  /**
   * @return {HTMLCanvasElement} Image element.
   * @override
   */
  getHitDetectionImage() {
    return this.hitDetectionCanvas_ || (this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(
      this.renderOptions_
    )), this.hitDetectionCanvas_;
  }
  /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   * @override
   */
  getImage(e) {
    let n = this.canvases_[e];
    if (!n) {
      const i = this.renderOptions_, s = u4(
        i.size * e,
        i.size * e
      );
      this.draw_(i, s, e), n = s.canvas, this.canvases_[e] = n;
    }
    return n;
  }
  /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */
  getPixelRatio(e) {
    return e;
  }
  /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */
  getImageSize() {
    return this.size_;
  }
  /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */
  getImageState() {
    return this.imageState_;
  }
  /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */
  getOrigin() {
    return this.origin_;
  }
  /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */
  getPoints() {
    return this.points_;
  }
  /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */
  getRadius() {
    return this.radius;
  }
  /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */
  getRadius2() {
    return this.radius2_;
  }
  /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */
  getSize() {
    return this.size_;
  }
  /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */
  getStroke() {
    return this.stroke_;
  }
  /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */
  setStroke(e) {
    this.stroke_ = e, this.render();
  }
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */
  listenImageChange(e) {
  }
  /**
   * Load not yet loaded URI.
   * @override
   */
  load() {
  }
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */
  unlistenImageChange(e) {
  }
  /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */
  calculateLineJoinSize_(e, n, i) {
    if (n === 0 || this.points_ === 1 / 0 || e !== "bevel" && e !== "miter")
      return n;
    let s = this.radius, l = this.radius2_ === void 0 ? s : this.radius2_;
    if (s < l) {
      const D = s;
      s = l, l = D;
    }
    const a = this.radius2_ === void 0 ? this.points_ : this.points_ * 2, o = 2 * Math.PI / a, h = l * Math.sin(o), u = Math.sqrt(l * l - h * h), d = s - u, v = Math.sqrt(h * h + d * d), m = v / h;
    if (e === "miter" && m <= i)
      return m * n;
    const p = n / 2 / m, _ = n / 2 * (d / v), M = Math.sqrt((s + p) * (s + p) + _ * _) - s;
    if (this.radius2_ === void 0 || e === "bevel")
      return M * 2;
    const z = s * Math.sin(o), b = Math.sqrt(s * s - z * z), x = l - b, F = Math.sqrt(z * z + x * x) / z;
    if (F <= i) {
      const D = F * n / 2 - l - s;
      return 2 * Math.max(M, D);
    }
    return M * 2;
  }
  /**
   * @return {RenderOptions}  The render options
   * @protected
   */
  createRenderOptions() {
    let e = Wa, n = Ya, i = 0, s = null, l = 0, a, o = 0;
    this.stroke_ && (a = Xn(this.stroke_.getColor() ?? Jo), o = this.stroke_.getWidth() ?? ec, s = this.stroke_.getLineDash(), l = this.stroke_.getLineDashOffset() ?? 0, n = this.stroke_.getLineJoin() ?? Ya, e = this.stroke_.getLineCap() ?? Wa, i = this.stroke_.getMiterLimit() ?? Zo);
    const h = this.calculateLineJoinSize_(n, o, i), u = Math.max(this.radius, this.radius2_ || 0), d = Math.ceil(2 * u + h);
    return {
      strokeStyle: a,
      strokeWidth: o,
      size: d,
      lineCap: e,
      lineDash: s,
      lineDashOffset: l,
      lineJoin: n,
      miterLimit: i
    };
  }
  /**
   * @protected
   */
  render() {
    this.renderOptions_ = this.createRenderOptions();
    const e = this.renderOptions_.size;
    this.canvases_ = {}, this.hitDetectionCanvas_ = null, this.size_ = [e, e];
  }
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */
  draw_(e, n, i) {
    if (n.scale(i, i), n.translate(e.size / 2, e.size / 2), this.createPath_(n), this.fill_) {
      let s = this.fill_.getColor();
      s === null && (s = s0), n.fillStyle = Xn(s), n.fill();
    }
    e.strokeStyle && (n.strokeStyle = e.strokeStyle, n.lineWidth = e.strokeWidth, e.lineDash && (n.setLineDash(e.lineDash), n.lineDashOffset = e.lineDashOffset), n.lineCap = e.lineCap, n.lineJoin = e.lineJoin, n.miterLimit = e.miterLimit, n.stroke());
  }
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement} Canvas containing the icon
   */
  createHitDetectionCanvas_(e) {
    let n;
    if (this.fill_) {
      let i = this.fill_.getColor(), s = 0;
      typeof i == "string" && (i = Ko(i)), i === null ? s = 1 : Array.isArray(i) && (s = i.length === 4 ? i[3] : 1), s === 0 && (n = u4(e.size, e.size), this.drawHitDetectionCanvas_(e, n));
    }
    return n ? n.canvas : this.getImage(1);
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */
  createPath_(e) {
    let n = this.points_;
    const i = this.radius;
    if (n === 1 / 0)
      e.arc(0, 0, i, 0, 2 * Math.PI);
    else {
      const s = this.radius2_ === void 0 ? i : this.radius2_;
      this.radius2_ !== void 0 && (n *= 2);
      const l = this.angle_ - Math.PI / 2, a = 2 * Math.PI / n;
      for (let o = 0; o < n; o++) {
        const h = l + o * a, u = o % 2 === 0 ? i : s;
        e.lineTo(u * Math.cos(h), u * Math.sin(h));
      }
      e.closePath();
    }
  }
  /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */
  drawHitDetectionCanvas_(e, n) {
    n.translate(e.size / 2, e.size / 2), this.createPath_(n), n.fillStyle = s0, n.fill(), e.strokeStyle && (n.strokeStyle = e.strokeStyle, n.lineWidth = e.strokeWidth, e.lineDash && (n.setLineDash(e.lineDash), n.lineDashOffset = e.lineDashOffset), n.lineJoin = e.lineJoin, n.miterLimit = e.miterLimit, n.stroke());
  }
  /**
   * @override
   */
  ready() {
    return this.fill_ ? this.fill_.ready() : Promise.resolve();
  }
}
const lC = qq;
class wq extends lC {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || { radius: 5 }, super({
      points: 1 / 0,
      fill: e.fill,
      radius: e.radius,
      stroke: e.stroke,
      scale: e.scale !== void 0 ? e.scale : 1,
      rotation: e.rotation !== void 0 ? e.rotation : 0,
      rotateWithView: e.rotateWithView !== void 0 ? e.rotateWithView : !1,
      displacement: e.displacement !== void 0 ? e.displacement : [0, 0],
      declutterMode: e.declutterMode
    });
  }
  /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */
  clone() {
    const e = this.getScale(), n = new wq({
      fill: this.getFill() ? this.getFill().clone() : void 0,
      stroke: this.getStroke() ? this.getStroke().clone() : void 0,
      radius: this.getRadius(),
      scale: Array.isArray(e) ? e.slice() : e,
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      displacement: this.getDisplacement().slice(),
      declutterMode: this.getDeclutterMode()
    });
    return n.setOpacity(this.getOpacity()), n;
  }
  /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */
  setRadius(e) {
    this.radius = e, this.render();
  }
}
const zq = wq;
class ed {
  /**
   * @param {Options} [options] Style options.
   */
  constructor(e) {
    e = e || {}, this.geometry_ = null, this.geometryFunction_ = Rz, e.geometry !== void 0 && this.setGeometry(e.geometry), this.fill_ = e.fill !== void 0 ? e.fill : null, this.image_ = e.image !== void 0 ? e.image : null, this.renderer_ = e.renderer !== void 0 ? e.renderer : null, this.hitDetectionRenderer_ = e.hitDetectionRenderer !== void 0 ? e.hitDetectionRenderer : null, this.stroke_ = e.stroke !== void 0 ? e.stroke : null, this.text_ = e.text !== void 0 ? e.text : null, this.zIndex_ = e.zIndex;
  }
  /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */
  clone() {
    let e = this.getGeometry();
    return e && typeof e == "object" && (e = /** @type {import("../geom/Geometry.js").default} */
    e.clone()), new ed({
      geometry: e ?? void 0,
      fill: this.getFill() ? this.getFill().clone() : void 0,
      image: this.getImage() ? this.getImage().clone() : void 0,
      renderer: this.getRenderer() ?? void 0,
      stroke: this.getStroke() ? this.getStroke().clone() : void 0,
      text: this.getText() ? this.getText().clone() : void 0,
      zIndex: this.getZIndex()
    });
  }
  /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */
  getRenderer() {
    return this.renderer_;
  }
  /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */
  setRenderer(e) {
    this.renderer_ = e;
  }
  /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */
  setHitDetectionRenderer(e) {
    this.hitDetectionRenderer_ = e;
  }
  /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */
  getHitDetectionRenderer() {
    return this.hitDetectionRenderer_;
  }
  /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */
  getGeometry() {
    return this.geometry_;
  }
  /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */
  getGeometryFunction() {
    return this.geometryFunction_;
  }
  /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */
  getFill() {
    return this.fill_;
  }
  /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */
  setFill(e) {
    this.fill_ = e;
  }
  /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */
  getImage() {
    return this.image_;
  }
  /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */
  setImage(e) {
    this.image_ = e;
  }
  /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */
  getStroke() {
    return this.stroke_;
  }
  /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */
  setStroke(e) {
    this.stroke_ = e;
  }
  /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */
  getText() {
    return this.text_;
  }
  /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */
  setText(e) {
    this.text_ = e;
  }
  /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */
  getZIndex() {
    return this.zIndex_;
  }
  /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */
  setGeometry(e) {
    typeof e == "function" ? this.geometryFunction_ = e : typeof e == "string" ? this.geometryFunction_ = function(n) {
      return (
        /** @type {import("../geom/Geometry.js").default} */
        n.get(e)
      );
    } : e ? e !== void 0 && (this.geometryFunction_ = function() {
      return (
        /** @type {import("../geom/Geometry.js").default} */
        e
      );
    }) : this.geometryFunction_ = Rz, this.geometry_ = e;
  }
  /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */
  setZIndex(e) {
    this.zIndex_ = e;
  }
}
function Cy1(t) {
  let e;
  if (typeof t == "function")
    e = t;
  else {
    let n;
    Array.isArray(t) ? n = t : (ge(
      typeof /** @type {?} */
      t.getZIndex == "function",
      "Expected an `Style` or an array of `Style`"
    ), n = [
      /** @type {Style} */
      t
    ]), e = function() {
      return n;
    };
  }
  return e;
}
let Eg = null;
function rC(t, e) {
  if (!Eg) {
    const n = new Ju({
      color: "rgba(255,255,255,0.4)"
    }), i = new gq({
      color: "#3399CC",
      width: 1.25
    });
    Eg = [
      new ed({
        image: new zq({
          fill: n,
          stroke: i,
          radius: 5
        }),
        fill: n,
        stroke: i
      })
    ];
  }
  return Eg;
}
function Rz(t) {
  return t.getGeometry();
}
const So = ed, ky1 = "#333";
class Mq {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {}, this.font_ = e.font, this.rotation_ = e.rotation, this.rotateWithView_ = e.rotateWithView, this.scale_ = e.scale, this.scaleArray_ = o0(e.scale !== void 0 ? e.scale : 1), this.text_ = e.text, this.textAlign_ = e.textAlign, this.justify_ = e.justify, this.repeat_ = e.repeat, this.textBaseline_ = e.textBaseline, this.fill_ = e.fill !== void 0 ? e.fill : new Ju({ color: ky1 }), this.maxAngle_ = e.maxAngle !== void 0 ? e.maxAngle : Math.PI / 4, this.placement_ = e.placement !== void 0 ? e.placement : "point", this.overflow_ = !!e.overflow, this.stroke_ = e.stroke !== void 0 ? e.stroke : null, this.offsetX_ = e.offsetX !== void 0 ? e.offsetX : 0, this.offsetY_ = e.offsetY !== void 0 ? e.offsetY : 0, this.backgroundFill_ = e.backgroundFill ? e.backgroundFill : null, this.backgroundStroke_ = e.backgroundStroke ? e.backgroundStroke : null, this.padding_ = e.padding === void 0 ? null : e.padding, this.declutterMode_ = e.declutterMode;
  }
  /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */
  clone() {
    const e = this.getScale();
    return new Mq({
      font: this.getFont(),
      placement: this.getPlacement(),
      repeat: this.getRepeat(),
      maxAngle: this.getMaxAngle(),
      overflow: this.getOverflow(),
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      scale: Array.isArray(e) ? e.slice() : e,
      text: this.getText(),
      textAlign: this.getTextAlign(),
      justify: this.getJustify(),
      textBaseline: this.getTextBaseline(),
      fill: this.getFill() ? this.getFill().clone() : void 0,
      stroke: this.getStroke() ? this.getStroke().clone() : void 0,
      offsetX: this.getOffsetX(),
      offsetY: this.getOffsetY(),
      backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : void 0,
      backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : void 0,
      padding: this.getPadding() || void 0,
      declutterMode: this.getDeclutterMode()
    });
  }
  /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */
  getOverflow() {
    return this.overflow_;
  }
  /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */
  getFont() {
    return this.font_;
  }
  /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */
  getMaxAngle() {
    return this.maxAngle_;
  }
  /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */
  getPlacement() {
    return this.placement_;
  }
  /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */
  getRepeat() {
    return this.repeat_;
  }
  /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */
  getOffsetX() {
    return this.offsetX_;
  }
  /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */
  getOffsetY() {
    return this.offsetY_;
  }
  /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */
  getFill() {
    return this.fill_;
  }
  /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */
  getRotateWithView() {
    return this.rotateWithView_;
  }
  /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */
  getRotation() {
    return this.rotation_;
  }
  /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */
  getScale() {
    return this.scale_;
  }
  /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */
  getScaleArray() {
    return this.scaleArray_;
  }
  /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */
  getStroke() {
    return this.stroke_;
  }
  /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */
  getText() {
    return this.text_;
  }
  /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */
  getTextAlign() {
    return this.textAlign_;
  }
  /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */
  getJustify() {
    return this.justify_;
  }
  /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */
  getTextBaseline() {
    return this.textBaseline_;
  }
  /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */
  getBackgroundFill() {
    return this.backgroundFill_;
  }
  /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */
  getBackgroundStroke() {
    return this.backgroundStroke_;
  }
  /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */
  getPadding() {
    return this.padding_;
  }
  /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */
  getDeclutterMode() {
    return this.declutterMode_;
  }
  /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */
  setOverflow(e) {
    this.overflow_ = e;
  }
  /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */
  setFont(e) {
    this.font_ = e;
  }
  /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */
  setMaxAngle(e) {
    this.maxAngle_ = e;
  }
  /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */
  setOffsetX(e) {
    this.offsetX_ = e;
  }
  /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */
  setOffsetY(e) {
    this.offsetY_ = e;
  }
  /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */
  setPlacement(e) {
    this.placement_ = e;
  }
  /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */
  setRepeat(e) {
    this.repeat_ = e;
  }
  /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */
  setRotateWithView(e) {
    this.rotateWithView_ = e;
  }
  /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */
  setFill(e) {
    this.fill_ = e;
  }
  /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */
  setRotation(e) {
    this.rotation_ = e;
  }
  /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */
  setScale(e) {
    this.scale_ = e, this.scaleArray_ = o0(e !== void 0 ? e : 1);
  }
  /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */
  setStroke(e) {
    this.stroke_ = e;
  }
  /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */
  setText(e) {
    this.text_ = e;
  }
  /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */
  setTextAlign(e) {
    this.textAlign_ = e;
  }
  /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */
  setJustify(e) {
    this.justify_ = e;
  }
  /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */
  setTextBaseline(e) {
    this.textBaseline_ = e;
  }
  /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */
  setBackgroundFill(e) {
    this.backgroundFill_ = e;
  }
  /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */
  setBackgroundStroke(e) {
    this.backgroundStroke_ = e;
  }
  /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */
  setPadding(e) {
    this.padding_ = e;
  }
}
const Ey1 = Mq, We = {
  OPACITY: "opacity",
  VISIBLE: "visible",
  EXTENT: "extent",
  Z_INDEX: "zIndex",
  MAX_RESOLUTION: "maxResolution",
  MIN_RESOLUTION: "minResolution",
  MAX_ZOOM: "maxZoom",
  MIN_ZOOM: "minZoom",
  SOURCE: "source",
  MAP: "map"
};
class Ay1 extends gn {
  /**
   * @param {Options} options Layer options.
   */
  constructor(e) {
    super(), this.on, this.once, this.un, this.background_ = e.background;
    const n = Object.assign({}, e);
    typeof e.properties == "object" && (delete n.properties, Object.assign(n, e.properties)), n[We.OPACITY] = e.opacity !== void 0 ? e.opacity : 1, ge(
      typeof n[We.OPACITY] == "number",
      "Layer opacity must be a number"
    ), n[We.VISIBLE] = e.visible !== void 0 ? e.visible : !0, n[We.Z_INDEX] = e.zIndex, n[We.MAX_RESOLUTION] = e.maxResolution !== void 0 ? e.maxResolution : 1 / 0, n[We.MIN_RESOLUTION] = e.minResolution !== void 0 ? e.minResolution : 0, n[We.MIN_ZOOM] = e.minZoom !== void 0 ? e.minZoom : -1 / 0, n[We.MAX_ZOOM] = e.maxZoom !== void 0 ? e.maxZoom : 1 / 0, this.className_ = n.className !== void 0 ? n.className : "ol-layer", delete n.className, this.setProperties(n), this.state_ = null;
  }
  /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */
  getBackground() {
    return this.background_;
  }
  /**
   * @return {string} CSS class name.
   */
  getClassName() {
    return this.className_;
  }
  /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */
  getLayerState(e) {
    const n = this.state_ || /** @type {?} */
    {
      layer: this,
      managed: e === void 0 ? !0 : e
    }, i = this.getZIndex();
    return n.opacity = bt(Math.round(this.getOpacity() * 100) / 100, 0, 1), n.visible = this.getVisible(), n.extent = this.getExtent(), n.zIndex = i === void 0 && !n.managed ? 1 / 0 : i, n.maxResolution = this.getMaxResolution(), n.minResolution = Math.max(this.getMinResolution(), 0), n.minZoom = this.getMinZoom(), n.maxZoom = this.getMaxZoom(), this.state_ = n, n;
  }
  /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */
  getLayersArray(e) {
    return b3();
  }
  /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */
  getLayerStatesArray(e) {
    return b3();
  }
  /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */
  getExtent() {
    return (
      /** @type {import("../extent.js").Extent|undefined} */
      this.get(We.EXTENT)
    );
  }
  /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */
  getMaxResolution() {
    return (
      /** @type {number} */
      this.get(We.MAX_RESOLUTION)
    );
  }
  /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */
  getMinResolution() {
    return (
      /** @type {number} */
      this.get(We.MIN_RESOLUTION)
    );
  }
  /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */
  getMinZoom() {
    return (
      /** @type {number} */
      this.get(We.MIN_ZOOM)
    );
  }
  /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */
  getMaxZoom() {
    return (
      /** @type {number} */
      this.get(We.MAX_ZOOM)
    );
  }
  /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */
  getOpacity() {
    return (
      /** @type {number} */
      this.get(We.OPACITY)
    );
  }
  /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */
  getSourceState() {
    return b3();
  }
  /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */
  getVisible() {
    return (
      /** @type {boolean} */
      this.get(We.VISIBLE)
    );
  }
  /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */
  getZIndex() {
    return (
      /** @type {number|undefined} */
      this.get(We.Z_INDEX)
    );
  }
  /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */
  setBackground(e) {
    this.background_ = e, this.changed();
  }
  /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */
  setExtent(e) {
    this.set(We.EXTENT, e);
  }
  /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */
  setMaxResolution(e) {
    this.set(We.MAX_RESOLUTION, e);
  }
  /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */
  setMinResolution(e) {
    this.set(We.MIN_RESOLUTION, e);
  }
  /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */
  setMaxZoom(e) {
    this.set(We.MAX_ZOOM, e);
  }
  /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */
  setMinZoom(e) {
    this.set(We.MIN_ZOOM, e);
  }
  /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */
  setOpacity(e) {
    ge(typeof e == "number", "Layer opacity must be a number"), this.set(We.OPACITY, e);
  }
  /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */
  setVisible(e) {
    this.set(We.VISIBLE, e);
  }
  /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */
  setZIndex(e) {
    this.set(We.Z_INDEX, e);
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    this.state_ && (this.state_.layer = null, this.state_ = null), super.disposeInternal();
  }
}
const aC = Ay1, f5 = {
  ANIMATING: 0,
  INTERACTING: 1
}, J6 = {
  CENTER: "center",
  RESOLUTION: "resolution",
  ROTATION: "rotation"
}, Fy1 = 42, bq = 256;
function Hz(t, e, n) {
  return (
    /**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */
    function(i, s, l, a, o) {
      if (!i)
        return;
      if (!s && !e)
        return i;
      const h = e ? 0 : l[0] * s, u = e ? 0 : l[1] * s, d = o ? o[0] : 0, v = o ? o[1] : 0;
      let m = t[0] + h / 2 + d, p = t[2] - h / 2 + d, _ = t[1] + u / 2 + v, q = t[3] - u / 2 + v;
      m > p && (m = (p + m) / 2, p = m), _ > q && (_ = (q + _) / 2, q = _);
      let M = bt(i[0], m, p), z = bt(i[1], _, q);
      if (a && n && s) {
        const b = 30 * s;
        M += -b * Math.log(1 + Math.max(0, m - i[0]) / b) + b * Math.log(1 + Math.max(0, i[0] - p) / b), z += -b * Math.log(1 + Math.max(0, _ - i[1]) / b) + b * Math.log(1 + Math.max(0, i[1] - q) / b);
      }
      return [M, z];
    }
  );
}
function Ty1(t) {
  return t;
}
function Lq(t, e, n, i) {
  const s = ue(e) / n[0], l = G4(e) / n[1];
  return i ? Math.min(t, Math.max(s, l)) : Math.min(t, Math.min(s, l));
}
function xq(t, e, n) {
  let i = Math.min(t, e);
  const s = 50;
  return i *= Math.log(1 + s * Math.max(0, t / e - 1)) / s + 1, n && (i = Math.max(i, n), i /= Math.log(1 + s * Math.max(0, n / t - 1)) / s + 1), bt(i, n / 2, e * 2);
}
function Iy1(t, e, n, i) {
  return e = e !== void 0 ? e : !0, /**
   * @param {number|undefined} resolution Resolution.
   * @param {number} direction Direction.
   * @param {import("./size.js").Size} size Viewport size.
   * @param {boolean} [isMoving] True if an interaction or animation is in progress.
   * @return {number|undefined} Resolution.
   */
  function(s, l, a, o) {
    if (s !== void 0) {
      const h = t[0], u = t[t.length - 1], d = n ? Lq(
        h,
        n,
        a,
        i
      ) : h;
      if (o)
        return e ? xq(
          s,
          d,
          u
        ) : bt(s, u, d);
      const v = Math.min(d, s), m = Math.floor(Q_(t, v, l));
      return t[m] > d && m < t.length - 1 ? t[m + 1] : t[m];
    }
  };
}
function Oy1(t, e, n, i, s, l) {
  return i = i !== void 0 ? i : !0, n = n !== void 0 ? n : 0, /**
   * @param {number|undefined} resolution Resolution.
   * @param {number} direction Direction.
   * @param {import("./size.js").Size} size Viewport size.
   * @param {boolean} [isMoving] True if an interaction or animation is in progress.
   * @return {number|undefined} Resolution.
   */
  function(a, o, h, u) {
    if (a !== void 0) {
      const d = s ? Lq(
        e,
        s,
        h,
        l
      ) : e;
      if (u)
        return i ? xq(
          a,
          d,
          n
        ) : bt(a, n, d);
      const v = 1e-9, m = Math.ceil(
        Math.log(e / d) / Math.log(t) - v
      ), p = -o * (0.5 - v) + 0.5, _ = Math.min(d, a), q = Math.floor(
        Math.log(e / _) / Math.log(t) + p
      ), M = Math.max(m, q), z = e / Math.pow(t, M);
      return bt(z, n, d);
    }
  };
}
function Dz(t, e, n, i, s) {
  return n = n !== void 0 ? n : !0, /**
   * @param {number|undefined} resolution Resolution.
   * @param {number} direction Direction.
   * @param {import("./size.js").Size} size Viewport size.
   * @param {boolean} [isMoving] True if an interaction or animation is in progress.
   * @return {number|undefined} Resolution.
   */
  function(l, a, o, h) {
    if (l !== void 0) {
      const u = i ? Lq(
        t,
        i,
        o,
        s
      ) : t;
      return !n || !h ? bt(l, e, u) : xq(
        l,
        u,
        e
      );
    }
  };
}
function Sq(t) {
  if (t !== void 0)
    return 0;
}
function $z(t) {
  if (t !== void 0)
    return t;
}
function Ny1(t) {
  const e = 2 * Math.PI / t;
  return (
    /**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */
    function(n, i) {
      if (i)
        return n;
      if (n !== void 0)
        return n = Math.floor(n / e + 0.5) * e, n;
    }
  );
}
function Py1(t) {
  const e = t === void 0 ? yh(5) : t;
  return (
    /**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */
    function(n, i) {
      return i || n === void 0 ? n : Math.abs(n) <= e ? 0 : n;
    }
  );
}
function oC(t) {
  return Math.pow(t, 3);
}
function l9(t) {
  return 1 - oC(1 - t);
}
function By1(t) {
  return 3 * t * t - 2 * t * t * t;
}
function Vy1(t) {
  return t;
}
const Ag = 0;
class Ry1 extends gn {
  /**
   * @param {ViewOptions} [options] View options.
   */
  constructor(e) {
    super(), this.on, this.once, this.un, e = Object.assign({}, e), this.hints_ = [0, 0], this.animations_ = [], this.updateAnimationKey_, this.projection_ = X_(e.projection, "EPSG:3857"), this.viewportSize_ = [100, 100], this.targetCenter_ = null, this.targetResolution_, this.targetRotation_, this.nextCenter_ = null, this.nextResolution_, this.nextRotation_, this.cancelAnchor_ = void 0, e.projection && CS(), e.center && (e.center = a8(e.center, this.projection_)), e.extent && (e.extent = qs(e.extent, this.projection_)), this.applyOptions_(e);
  }
  /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */
  applyOptions_(e) {
    const n = Object.assign({}, e);
    for (const o in J6)
      delete n[o];
    this.setProperties(n, !0);
    const i = Dy1(e);
    this.maxResolution_ = i.maxResolution, this.minResolution_ = i.minResolution, this.zoomFactor_ = i.zoomFactor, this.resolutions_ = e.resolutions, this.padding_ = e.padding, this.minZoom_ = i.minZoom;
    const s = Hy1(e), l = i.constraint, a = $y1(e);
    this.constraints_ = {
      center: s,
      resolution: l,
      rotation: a
    }, this.setRotation(e.rotation !== void 0 ? e.rotation : 0), this.setCenterInternal(
      e.center !== void 0 ? e.center : null
    ), e.resolution !== void 0 ? this.setResolution(e.resolution) : e.zoom !== void 0 && this.setZoom(e.zoom);
  }
  /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */
  get padding() {
    return this.padding_;
  }
  set padding(e) {
    let n = this.padding_;
    this.padding_ = e;
    const i = this.getCenterInternal();
    if (i) {
      const s = e || [0, 0, 0, 0];
      n = n || [0, 0, 0, 0];
      const l = this.getResolution(), a = l / 2 * (s[3] - n[3] + n[1] - s[1]), o = l / 2 * (s[0] - n[0] + n[2] - s[2]);
      this.setCenterInternal([i[0] + a, i[1] - o]);
    }
  }
  /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */
  getUpdatedOptions_(e) {
    const n = this.getProperties();
    return n.resolution !== void 0 ? n.resolution = this.getResolution() : n.zoom = this.getZoom(), n.center = this.getCenterInternal(), n.rotation = this.getRotation(), Object.assign({}, n, e);
  }
  /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */
  animate(e) {
    this.isDef() && !this.getAnimating() && this.resolveConstraints(0);
    const n = new Array(arguments.length);
    for (let i = 0; i < n.length; ++i) {
      let s = arguments[i];
      s.center && (s = Object.assign({}, s), s.center = a8(
        s.center,
        this.getProjection()
      )), s.anchor && (s = Object.assign({}, s), s.anchor = a8(
        s.anchor,
        this.getProjection()
      )), n[i] = s;
    }
    this.animateInternal.apply(this, n);
  }
  /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */
  animateInternal(e) {
    let n = arguments.length, i;
    n > 1 && typeof arguments[n - 1] == "function" && (i = arguments[n - 1], --n);
    let s = 0;
    for (; s < n && !this.isDef(); ++s) {
      const d = arguments[s];
      d.center && this.setCenterInternal(d.center), d.zoom !== void 0 ? this.setZoom(d.zoom) : d.resolution && this.setResolution(d.resolution), d.rotation !== void 0 && this.setRotation(d.rotation);
    }
    if (s === n) {
      i && Zc(i, !0);
      return;
    }
    let l = Date.now(), a = this.targetCenter_.slice(), o = this.targetResolution_, h = this.targetRotation_;
    const u = [];
    for (; s < n; ++s) {
      const d = (
        /** @type {AnimationOptions} */
        arguments[s]
      ), v = {
        start: l,
        complete: !1,
        anchor: d.anchor,
        duration: d.duration !== void 0 ? d.duration : 1e3,
        easing: d.easing || By1,
        callback: i
      };
      if (d.center && (v.sourceCenter = a, v.targetCenter = d.center.slice(), a = v.targetCenter), d.zoom !== void 0 ? (v.sourceResolution = o, v.targetResolution = this.getResolutionForZoom(d.zoom), o = v.targetResolution) : d.resolution && (v.sourceResolution = o, v.targetResolution = d.resolution, o = v.targetResolution), d.rotation !== void 0) {
        v.sourceRotation = h;
        const m = hr(d.rotation - h + Math.PI, 2 * Math.PI) - Math.PI;
        v.targetRotation = h + m, h = v.targetRotation;
      }
      Uy1(v) ? v.complete = !0 : l += v.duration, u.push(v);
    }
    this.animations_.push(u), this.setHint(f5.ANIMATING, 1), this.updateAnimations_();
  }
  /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */
  getAnimating() {
    return this.hints_[f5.ANIMATING] > 0;
  }
  /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */
  getInteracting() {
    return this.hints_[f5.INTERACTING] > 0;
  }
  /**
   * Cancel any ongoing animations.
   * @api
   */
  cancelAnimations() {
    this.setHint(f5.ANIMATING, -this.hints_[f5.ANIMATING]);
    let e;
    for (let n = 0, i = this.animations_.length; n < i; ++n) {
      const s = this.animations_[n];
      if (s[0].callback && Zc(s[0].callback, !1), !e)
        for (let l = 0, a = s.length; l < a; ++l) {
          const o = s[l];
          if (!o.complete) {
            e = o.anchor;
            break;
          }
        }
    }
    this.animations_.length = 0, this.cancelAnchor_ = e, this.nextCenter_ = null, this.nextResolution_ = NaN, this.nextRotation_ = NaN;
  }
  /**
   * Update all animations.
   */
  updateAnimations_() {
    if (this.updateAnimationKey_ !== void 0 && (cancelAnimationFrame(this.updateAnimationKey_), this.updateAnimationKey_ = void 0), !this.getAnimating())
      return;
    const e = Date.now();
    let n = !1;
    for (let i = this.animations_.length - 1; i >= 0; --i) {
      const s = this.animations_[i];
      let l = !0;
      for (let a = 0, o = s.length; a < o; ++a) {
        const h = s[a];
        if (h.complete)
          continue;
        const u = e - h.start;
        let d = h.duration > 0 ? u / h.duration : 1;
        d >= 1 ? (h.complete = !0, d = 1) : l = !1;
        const v = h.easing(d);
        if (h.sourceCenter) {
          const m = h.sourceCenter[0], p = h.sourceCenter[1], _ = h.targetCenter[0], q = h.targetCenter[1];
          this.nextCenter_ = h.targetCenter;
          const M = m + v * (_ - m), z = p + v * (q - p);
          this.targetCenter_ = [M, z];
        }
        if (h.sourceResolution && h.targetResolution) {
          const m = v === 1 ? h.targetResolution : h.sourceResolution + v * (h.targetResolution - h.sourceResolution);
          if (h.anchor) {
            const p = this.getViewportSize_(this.getRotation()), _ = this.constraints_.resolution(
              m,
              0,
              p,
              !0
            );
            this.targetCenter_ = this.calculateCenterZoom(
              _,
              h.anchor
            );
          }
          this.nextResolution_ = h.targetResolution, this.targetResolution_ = m, this.applyTargetState_(!0);
        }
        if (h.sourceRotation !== void 0 && h.targetRotation !== void 0) {
          const m = v === 1 ? hr(h.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : h.sourceRotation + v * (h.targetRotation - h.sourceRotation);
          if (h.anchor) {
            const p = this.constraints_.rotation(
              m,
              !0
            );
            this.targetCenter_ = this.calculateCenterRotate(
              p,
              h.anchor
            );
          }
          this.nextRotation_ = h.targetRotation, this.targetRotation_ = m;
        }
        if (this.applyTargetState_(!0), n = !0, !h.complete)
          break;
      }
      if (l) {
        this.animations_[i] = null, this.setHint(f5.ANIMATING, -1), this.nextCenter_ = null, this.nextResolution_ = NaN, this.nextRotation_ = NaN;
        const a = s[0].callback;
        a && Zc(a, !0);
      }
    }
    this.animations_ = this.animations_.filter(Boolean), n && this.updateAnimationKey_ === void 0 && (this.updateAnimationKey_ = requestAnimationFrame(
      this.updateAnimations_.bind(this)
    ));
  }
  /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */
  calculateCenterRotate(e, n) {
    let i;
    const s = this.getCenterInternal();
    return s !== void 0 && (i = [s[0] - n[0], s[1] - n[1]], W_(i, e - this.getRotation()), ug1(i, n)), i;
  }
  /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */
  calculateCenterZoom(e, n) {
    let i;
    const s = this.getCenterInternal(), l = this.getResolution();
    if (s !== void 0 && l !== void 0) {
      const a = n[0] - e * (n[0] - s[0]) / l, o = n[1] - e * (n[1] - s[1]) / l;
      i = [a, o];
    }
    return i;
  }
  /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */
  getViewportSize_(e) {
    const n = this.viewportSize_;
    if (e) {
      const i = n[0], s = n[1];
      return [
        Math.abs(i * Math.cos(e)) + Math.abs(s * Math.sin(e)),
        Math.abs(i * Math.sin(e)) + Math.abs(s * Math.cos(e))
      ];
    }
    return n;
  }
  /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */
  setViewportSize(e) {
    this.viewportSize_ = Array.isArray(e) ? e.slice() : [100, 100], this.getAnimating() || this.resolveConstraints(0);
  }
  /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */
  getCenter() {
    const e = this.getCenterInternal();
    return e && by(e, this.getProjection());
  }
  /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */
  getCenterInternal() {
    return (
      /** @type {import("./coordinate.js").Coordinate|undefined} */
      this.get(J6.CENTER)
    );
  }
  /**
   * @return {Constraints} Constraints.
   */
  getConstraints() {
    return this.constraints_;
  }
  /**
   * @return {boolean} Resolution constraint is set
   */
  getConstrainResolution() {
    return this.get("constrainResolution");
  }
  /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */
  getHints(e) {
    return e !== void 0 ? (e[0] = this.hints_[0], e[1] = this.hints_[1], e) : this.hints_.slice();
  }
  /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */
  calculateExtent(e) {
    const n = this.calculateExtentInternal(e);
    return Z_(n, this.getProjection());
  }
  /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */
  calculateExtentInternal(e) {
    e = e || this.getViewportSizeMinusPadding_();
    const n = (
      /** @type {!import("./coordinate.js").Coordinate} */
      this.getCenterInternal()
    );
    ge(n, "The view center is not defined");
    const i = (
      /** @type {!number} */
      this.getResolution()
    );
    ge(i !== void 0, "The view resolution is not defined");
    const s = (
      /** @type {!number} */
      this.getRotation()
    );
    return ge(s !== void 0, "The view rotation is not defined"), wy(n, i, s, e);
  }
  /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */
  getMaxResolution() {
    return this.maxResolution_;
  }
  /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */
  getMinResolution() {
    return this.minResolution_;
  }
  /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */
  getMaxZoom() {
    return (
      /** @type {number} */
      this.getZoomForResolution(this.minResolution_)
    );
  }
  /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */
  setMaxZoom(e) {
    this.applyOptions_(this.getUpdatedOptions_({ maxZoom: e }));
  }
  /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */
  getMinZoom() {
    return (
      /** @type {number} */
      this.getZoomForResolution(this.maxResolution_)
    );
  }
  /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */
  setMinZoom(e) {
    this.applyOptions_(this.getUpdatedOptions_({ minZoom: e }));
  }
  /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */
  setConstrainResolution(e) {
    this.applyOptions_(this.getUpdatedOptions_({ constrainResolution: e }));
  }
  /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */
  getProjection() {
    return this.projection_;
  }
  /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */
  getResolution() {
    return (
      /** @type {number|undefined} */
      this.get(J6.RESOLUTION)
    );
  }
  /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */
  getResolutions() {
    return this.resolutions_;
  }
  /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */
  getResolutionForExtent(e, n) {
    return this.getResolutionForExtentInternal(
      qs(e, this.getProjection()),
      n
    );
  }
  /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */
  getResolutionForExtentInternal(e, n) {
    n = n || this.getViewportSizeMinusPadding_();
    const i = ue(e) / n[0], s = G4(e) / n[1];
    return Math.max(i, s);
  }
  /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */
  getResolutionForValueFunction(e) {
    e = e || 2;
    const n = this.getConstrainedResolution(this.maxResolution_), i = this.minResolution_, s = Math.log(n / i) / Math.log(e);
    return (
      /**
       * @param {number} value Value.
       * @return {number} Resolution.
       */
      function(l) {
        return n / Math.pow(e, l * s);
      }
    );
  }
  /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */
  getRotation() {
    return (
      /** @type {number} */
      this.get(J6.ROTATION)
    );
  }
  /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */
  getValueForResolutionFunction(e) {
    const n = Math.log(e || 2), i = this.getConstrainedResolution(this.maxResolution_), s = this.minResolution_, l = Math.log(i / s) / n;
    return (
      /**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */
      function(a) {
        return Math.log(i / a) / n / l;
      }
    );
  }
  /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */
  getViewportSizeMinusPadding_(e) {
    let n = this.getViewportSize_(e);
    const i = this.padding_;
    return i && (n = [
      n[0] - i[1] - i[3],
      n[1] - i[0] - i[2]
    ]), n;
  }
  /**
   * @return {State} View state.
   */
  getState() {
    const e = this.getProjection(), n = this.getResolution(), i = this.getRotation();
    let s = (
      /** @type {import("./coordinate.js").Coordinate} */
      this.getCenterInternal()
    );
    const l = this.padding_;
    if (l) {
      const a = this.getViewportSizeMinusPadding_();
      s = Fg(
        s,
        this.getViewportSize_(),
        [a[0] / 2 + l[3], a[1] / 2 + l[0]],
        n,
        i
      );
    }
    return {
      center: s.slice(0),
      projection: e !== void 0 ? e : null,
      resolution: n,
      nextCenter: this.nextCenter_,
      nextResolution: this.nextResolution_,
      nextRotation: this.nextRotation_,
      rotation: i,
      zoom: this.getZoom()
    };
  }
  /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */
  getViewStateAndExtent() {
    return {
      viewState: this.getState(),
      extent: this.calculateExtent()
    };
  }
  /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */
  getZoom() {
    let e;
    const n = this.getResolution();
    return n !== void 0 && (e = this.getZoomForResolution(n)), e;
  }
  /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */
  getZoomForResolution(e) {
    let n = this.minZoom_ || 0, i, s;
    if (this.resolutions_) {
      const l = Q_(this.resolutions_, e, 1);
      n = l, i = this.resolutions_[l], l == this.resolutions_.length - 1 ? s = 2 : s = i / this.resolutions_[l + 1];
    } else
      i = this.maxResolution_, s = this.zoomFactor_;
    return n + Math.log(i / e) / Math.log(s);
  }
  /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */
  getResolutionForZoom(e) {
    if (this.resolutions_) {
      if (this.resolutions_.length <= 1)
        return 0;
      const n = bt(
        Math.floor(e),
        0,
        this.resolutions_.length - 2
      ), i = this.resolutions_[n] / this.resolutions_[n + 1];
      return this.resolutions_[n] / Math.pow(i, bt(e - n, 0, 1));
    }
    return this.maxResolution_ / Math.pow(this.zoomFactor_, e - this.minZoom_);
  }
  /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */
  fit(e, n) {
    let i;
    if (ge(
      Array.isArray(e) || typeof /** @type {?} */
      e.getSimplifiedGeometry == "function",
      "Invalid extent or geometry provided as `geometry`"
    ), Array.isArray(e)) {
      ge(
        !zc(e),
        "Cannot fit empty extent provided as `geometry`"
      );
      const s = qs(e, this.getProjection());
      i = Az(s);
    } else if (e.getType() === "Circle") {
      const s = qs(
        e.getExtent(),
        this.getProjection()
      );
      i = Az(s), i.rotate(this.getRotation(), Is(s));
    } else
      i = e;
    this.fitInternal(i, n);
  }
  /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */
  rotatedExtentForGeometry(e) {
    const n = this.getRotation(), i = Math.cos(n), s = Math.sin(-n), l = e.getFlatCoordinates(), a = e.getStride();
    let o = 1 / 0, h = 1 / 0, u = -1 / 0, d = -1 / 0;
    for (let v = 0, m = l.length; v < m; v += a) {
      const p = l[v] * i - l[v + 1] * s, _ = l[v] * s + l[v + 1] * i;
      o = Math.min(o, p), h = Math.min(h, _), u = Math.max(u, p), d = Math.max(d, _);
    }
    return [o, h, u, d];
  }
  /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */
  fitInternal(e, n) {
    n = n || {};
    let i = n.size;
    i || (i = this.getViewportSizeMinusPadding_());
    const s = n.padding !== void 0 ? n.padding : [0, 0, 0, 0], l = n.nearest !== void 0 ? n.nearest : !1;
    let a;
    n.minResolution !== void 0 ? a = n.minResolution : n.maxZoom !== void 0 ? a = this.getResolutionForZoom(n.maxZoom) : a = 0;
    const o = this.rotatedExtentForGeometry(e);
    let h = this.getResolutionForExtentInternal(o, [
      i[0] - s[1] - s[3],
      i[1] - s[0] - s[2]
    ]);
    h = isNaN(h) ? a : Math.max(h, a), h = this.getConstrainedResolution(h, l ? 0 : 1);
    const u = this.getRotation(), d = Math.sin(u), v = Math.cos(u), m = Is(o);
    m[0] += (s[1] - s[3]) / 2 * h, m[1] += (s[0] - s[2]) / 2 * h;
    const p = m[0] * v - m[1] * d, _ = m[1] * v + m[0] * d, q = this.getConstrainedCenter([p, _], h), M = n.callback ? n.callback : ja;
    n.duration !== void 0 ? this.animateInternal(
      {
        resolution: h,
        center: q,
        duration: n.duration,
        easing: n.easing
      },
      M
    ) : (this.targetResolution_ = h, this.targetCenter_ = q, this.applyTargetState_(!1, !0), Zc(M, !0));
  }
  /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */
  centerOn(e, n, i) {
    this.centerOnInternal(
      a8(e, this.getProjection()),
      n,
      i
    );
  }
  /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */
  centerOnInternal(e, n, i) {
    this.setCenterInternal(
      Fg(
        e,
        n,
        i,
        this.getResolution(),
        this.getRotation()
      )
    );
  }
  /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */
  calculateCenterShift(e, n, i, s) {
    let l;
    const a = this.padding_;
    if (a && e) {
      const o = this.getViewportSizeMinusPadding_(-i), h = Fg(
        e,
        s,
        [o[0] / 2 + a[3], o[1] / 2 + a[0]],
        n,
        i
      );
      l = [
        e[0] - h[0],
        e[1] - h[1]
      ];
    }
    return l;
  }
  /**
   * @return {boolean} Is defined.
   */
  isDef() {
    return !!this.getCenterInternal() && this.getResolution() !== void 0;
  }
  /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */
  adjustCenter(e) {
    const n = by(this.targetCenter_, this.getProjection());
    this.setCenter([
      n[0] + e[0],
      n[1] + e[1]
    ]);
  }
  /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */
  adjustCenterInternal(e) {
    const n = this.targetCenter_;
    this.setCenterInternal([
      n[0] + e[0],
      n[1] + e[1]
    ]);
  }
  /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */
  adjustResolution(e, n) {
    n = n && a8(n, this.getProjection()), this.adjustResolutionInternal(e, n);
  }
  /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */
  adjustResolutionInternal(e, n) {
    const i = this.getAnimating() || this.getInteracting(), s = this.getViewportSize_(this.getRotation()), l = this.constraints_.resolution(
      this.targetResolution_ * e,
      0,
      s,
      i
    );
    n && (this.targetCenter_ = this.calculateCenterZoom(l, n)), this.targetResolution_ *= e, this.applyTargetState_();
  }
  /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */
  adjustZoom(e, n) {
    this.adjustResolution(Math.pow(this.zoomFactor_, -e), n);
  }
  /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */
  adjustRotation(e, n) {
    n && (n = a8(n, this.getProjection())), this.adjustRotationInternal(e, n);
  }
  /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */
  adjustRotationInternal(e, n) {
    const i = this.getAnimating() || this.getInteracting(), s = this.constraints_.rotation(
      this.targetRotation_ + e,
      i
    );
    n && (this.targetCenter_ = this.calculateCenterRotate(s, n)), this.targetRotation_ += e, this.applyTargetState_();
  }
  /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */
  setCenter(e) {
    this.setCenterInternal(
      e && a8(e, this.getProjection())
    );
  }
  /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */
  setCenterInternal(e) {
    this.targetCenter_ = e, this.applyTargetState_();
  }
  /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */
  setHint(e, n) {
    return this.hints_[e] += n, this.changed(), this.hints_[e];
  }
  /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */
  setResolution(e) {
    this.targetResolution_ = e, this.applyTargetState_();
  }
  /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */
  setRotation(e) {
    this.targetRotation_ = e, this.applyTargetState_();
  }
  /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */
  setZoom(e) {
    this.setResolution(this.getResolutionForZoom(e));
  }
  /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */
  applyTargetState_(e, n) {
    const i = this.getAnimating() || this.getInteracting() || n, s = this.constraints_.rotation(
      this.targetRotation_,
      i
    ), l = this.getViewportSize_(s), a = this.constraints_.resolution(
      this.targetResolution_,
      0,
      l,
      i
    ), o = this.constraints_.center(
      this.targetCenter_,
      a,
      l,
      i,
      this.calculateCenterShift(
        this.targetCenter_,
        a,
        s,
        l
      )
    );
    this.get(J6.ROTATION) !== s && this.set(J6.ROTATION, s), this.get(J6.RESOLUTION) !== a && (this.set(J6.RESOLUTION, a), this.set("zoom", this.getZoom(), !0)), (!o || !this.get(J6.CENTER) || !$h(this.get(J6.CENTER), o)) && this.set(J6.CENTER, o), this.getAnimating() && !e && this.cancelAnimations(), this.cancelAnchor_ = void 0;
  }
  /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */
  resolveConstraints(e, n, i) {
    e = e !== void 0 ? e : 200;
    const s = n || 0, l = this.constraints_.rotation(this.targetRotation_), a = this.getViewportSize_(l), o = this.constraints_.resolution(
      this.targetResolution_,
      s,
      a
    ), h = this.constraints_.center(
      this.targetCenter_,
      o,
      a,
      !1,
      this.calculateCenterShift(
        this.targetCenter_,
        o,
        l,
        a
      )
    );
    if (e === 0 && !this.cancelAnchor_) {
      this.targetResolution_ = o, this.targetRotation_ = l, this.targetCenter_ = h, this.applyTargetState_();
      return;
    }
    i = i || (e === 0 ? this.cancelAnchor_ : void 0), this.cancelAnchor_ = void 0, (this.getResolution() !== o || this.getRotation() !== l || !this.getCenterInternal() || !$h(this.getCenterInternal(), h)) && (this.getAnimating() && this.cancelAnimations(), this.animateInternal({
      rotation: l,
      center: h,
      resolution: o,
      duration: e,
      easing: l9,
      anchor: i
    }));
  }
  /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */
  beginInteraction() {
    this.resolveConstraints(0), this.setHint(f5.INTERACTING, 1);
  }
  /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */
  endInteraction(e, n, i) {
    i = i && a8(i, this.getProjection()), this.endInteractionInternal(e, n, i);
  }
  /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */
  endInteractionInternal(e, n, i) {
    this.getInteracting() && (this.setHint(f5.INTERACTING, -1), this.resolveConstraints(e, n, i));
  }
  /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */
  getConstrainedCenter(e, n) {
    const i = this.getViewportSize_(this.getRotation());
    return this.constraints_.center(
      e,
      n || this.getResolution(),
      i
    );
  }
  /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */
  getConstrainedZoom(e, n) {
    const i = this.getResolutionForZoom(e);
    return this.getZoomForResolution(
      this.getConstrainedResolution(i, n)
    );
  }
  /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */
  getConstrainedResolution(e, n) {
    n = n || 0;
    const i = this.getViewportSize_(this.getRotation());
    return this.constraints_.resolution(e, n, i);
  }
}
function Zc(t, e) {
  setTimeout(function() {
    t(e);
  }, 0);
}
function Hy1(t) {
  if (t.extent !== void 0) {
    const n = t.smoothExtentConstraint !== void 0 ? t.smoothExtentConstraint : !0;
    return Hz(t.extent, t.constrainOnlyCenter, n);
  }
  const e = X_(t.projection, "EPSG:3857");
  if (t.multiWorld !== !0 && e.isGlobal()) {
    const n = e.getExtent().slice();
    return n[0] = -1 / 0, n[2] = 1 / 0, Hz(n, !1, !1);
  }
  return Ty1;
}
function Dy1(t) {
  let e, n, i, a = t.minZoom !== void 0 ? t.minZoom : Ag, o = t.maxZoom !== void 0 ? t.maxZoom : 28;
  const h = t.zoomFactor !== void 0 ? t.zoomFactor : 2, u = t.multiWorld !== void 0 ? t.multiWorld : !1, d = t.smoothResolutionConstraint !== void 0 ? t.smoothResolutionConstraint : !0, v = t.showFullExtent !== void 0 ? t.showFullExtent : !1, m = X_(t.projection, "EPSG:3857"), p = m.getExtent();
  let _ = t.constrainOnlyCenter, q = t.extent;
  if (!u && !q && m.isGlobal() && (_ = !1, q = p), t.resolutions !== void 0) {
    const M = t.resolutions;
    n = M[a], i = M[o] !== void 0 ? M[o] : M[M.length - 1], t.constrainResolution ? e = Iy1(
      M,
      d,
      !_ && q,
      v
    ) : e = Dz(
      n,
      i,
      d,
      !_ && q,
      v
    );
  } else {
    const z = (p ? Math.max(ue(p), G4(p)) : (
      // use an extent that can fit the whole world if need be
      360 * Ho.degrees / m.getMetersPerUnit()
    )) / bq / Math.pow(2, Ag), b = z / Math.pow(2, 28 - Ag);
    n = t.maxResolution, n !== void 0 ? a = 0 : n = z / Math.pow(h, a), i = t.minResolution, i === void 0 && (t.maxZoom !== void 0 ? t.maxResolution !== void 0 ? i = n / Math.pow(h, o) : i = z / Math.pow(h, o) : i = b), o = a + Math.floor(
      Math.log(n / i) / Math.log(h)
    ), i = n / Math.pow(h, o - a), t.constrainResolution ? e = Oy1(
      h,
      n,
      i,
      d,
      !_ && q,
      v
    ) : e = Dz(
      n,
      i,
      d,
      !_ && q,
      v
    );
  }
  return {
    constraint: e,
    maxResolution: n,
    minResolution: i,
    minZoom: a,
    zoomFactor: h
  };
}
function $y1(t) {
  if (t.enableRotation !== void 0 ? t.enableRotation : !0) {
    const n = t.constrainRotation;
    return n === void 0 || n === !0 ? Py1() : n === !1 ? $z : typeof n == "number" ? Ny1(n) : $z;
  }
  return Sq;
}
function Uy1(t) {
  return !(t.sourceCenter && t.targetCenter && !$h(t.sourceCenter, t.targetCenter) || t.sourceResolution !== t.targetResolution || t.sourceRotation !== t.targetRotation);
}
function Fg(t, e, n, i, s) {
  const l = Math.cos(-s);
  let a = Math.sin(-s), o = t[0] * l - t[1] * a, h = t[1] * l + t[0] * a;
  o += (e[0] / 2 - n[0]) * i, h += (n[1] - e[1] / 2) * i, a = -a;
  const u = o * l - h * a, d = h * l + o * a;
  return [u, d];
}
const jn = Ry1;
class jy1 extends aC {
  /**
   * @param {Options<SourceType>} options Layer options.
   */
  constructor(e) {
    const n = Object.assign({}, e);
    delete n.source, super(n), this.on, this.once, this.un, this.mapPrecomposeKey_ = null, this.mapRenderKey_ = null, this.sourceChangeKey_ = null, this.renderer_ = null, this.sourceReady_ = !1, this.rendered = !1, e.render && (this.render = e.render), e.map && this.setMap(e.map), this.addChangeListener(
      We.SOURCE,
      this.handleSourcePropertyChange_
    );
    const i = e.source ? (
      /** @type {SourceType} */
      e.source
    ) : null;
    this.setSource(i);
  }
  /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */
  getLayersArray(e) {
    return e = e || [], e.push(this), e;
  }
  /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */
  getLayerStatesArray(e) {
    return e = e || [], e.push(this.getLayerState()), e;
  }
  /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */
  getSource() {
    return (
      /** @type {SourceType} */
      this.get(We.SOURCE) || null
    );
  }
  /**
   * @return {SourceType|null} The source being rendered.
   */
  getRenderSource() {
    return this.getSource();
  }
  /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */
  getSourceState() {
    const e = this.getSource();
    return e ? e.getState() : "undefined";
  }
  /**
   * @private
   */
  handleSourceChange_() {
    this.changed(), !(this.sourceReady_ || this.getSource().getState() !== "ready") && (this.sourceReady_ = !0, this.dispatchEvent("sourceready"));
  }
  /**
   * @private
   */
  handleSourcePropertyChange_() {
    this.sourceChangeKey_ && (Qe(this.sourceChangeKey_), this.sourceChangeKey_ = null), this.sourceReady_ = !1;
    const e = this.getSource();
    e && (this.sourceChangeKey_ = ae(
      e,
      T3.CHANGE,
      this.handleSourceChange_,
      this
    ), e.getState() === "ready" && (this.sourceReady_ = !0, setTimeout(() => {
      this.dispatchEvent("sourceready");
    }, 0))), this.changed();
  }
  /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */
  getFeatures(e) {
    return this.renderer_ ? this.renderer_.getFeatures(e) : Promise.resolve([]);
  }
  /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */
  getData(e) {
    return !this.renderer_ || !this.rendered ? null : this.renderer_.getData(e);
  }
  /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */
  isVisible(e) {
    let n;
    const i = this.getMapInternal();
    !e && i && (e = i.getView()), e instanceof jn ? n = {
      viewState: e.getState(),
      extent: e.calculateExtent()
    } : n = e, !n.layerStatesArray && i && (n.layerStatesArray = i.getLayerGroup().getLayerStatesArray());
    let s;
    n.layerStatesArray ? s = n.layerStatesArray.find(
      (a) => a.layer === this
    ) : s = this.getLayerState();
    const l = this.getExtent();
    return Cq(s, n.viewState) && (!l || r0(l, n.extent));
  }
  /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */
  getAttributions(e) {
    var l;
    if (!this.isVisible(e))
      return [];
    const n = (l = this.getSource()) == null ? void 0 : l.getAttributions();
    if (!n)
      return [];
    const i = e instanceof jn ? e.getViewStateAndExtent() : e;
    let s = n(i);
    return Array.isArray(s) || (s = [s]), s;
  }
  /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */
  render(e, n) {
    const i = this.getRenderer();
    return i.prepareFrame(e) ? (this.rendered = !0, i.renderFrame(e, n)) : null;
  }
  /**
   * Called when a layer is not visible during a map render.
   */
  unrender() {
    this.rendered = !1;
  }
  /** @return {string} Declutter */
  getDeclutter() {
  }
  /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */
  renderDeclutter(e, n) {
  }
  /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */
  renderDeferred(e) {
    const n = this.getRenderer();
    n && n.renderDeferred(e);
  }
  /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */
  setMapInternal(e) {
    e || this.unrender(), this.set(We.MAP, e);
  }
  /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */
  getMapInternal() {
    return this.get(We.MAP);
  }
  /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */
  setMap(e) {
    this.mapPrecomposeKey_ && (Qe(this.mapPrecomposeKey_), this.mapPrecomposeKey_ = null), e || this.changed(), this.mapRenderKey_ && (Qe(this.mapRenderKey_), this.mapRenderKey_ = null), e && (this.mapPrecomposeKey_ = ae(
      e,
      M6.PRECOMPOSE,
      (n) => {
        const s = /** @type {import("../render/Event.js").default} */ n.frameState.layerStatesArray, l = this.getLayerState(!1);
        ge(
          !s.some(function(a) {
            return a.layer === l.layer;
          }),
          "A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both."
        ), s.push(l);
      }
    ), this.mapRenderKey_ = ae(this, T3.CHANGE, e.render, e), this.changed());
  }
  /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */
  setSource(e) {
    this.set(We.SOURCE, e);
  }
  /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */
  getRenderer() {
    return this.renderer_ || (this.renderer_ = this.createRenderer()), this.renderer_;
  }
  /**
   * @return {boolean} The layer has a renderer.
   */
  hasRenderer() {
    return !!this.renderer_;
  }
  /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */
  createRenderer() {
    return null;
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    this.renderer_ && (this.renderer_.dispose(), delete this.renderer_), this.setSource(null), super.disposeInternal();
  }
}
function Cq(t, e) {
  if (!t.visible)
    return !1;
  const n = e.resolution;
  if (n < t.minResolution || n >= t.maxResolution)
    return !1;
  const i = e.zoom;
  return i > t.minZoom && i <= t.maxZoom;
}
const td = jy1;
function Gy1(t, e, n, i, s) {
  cC(t, e, n || 0, i || t.length - 1, s || Wy1);
}
function cC(t, e, n, i, s) {
  for (; i > n; ) {
    if (i - n > 600) {
      var l = i - n + 1, a = e - n + 1, o = Math.log(l), h = 0.5 * Math.exp(2 * o / 3), u = 0.5 * Math.sqrt(o * h * (l - h) / l) * (a - l / 2 < 0 ? -1 : 1), d = Math.max(n, Math.floor(e - a * h / l + u)), v = Math.min(i, Math.floor(e + (l - a) * h / l + u));
      cC(t, e, d, v, s);
    }
    var m = t[e], p = n, _ = i;
    for (X7(t, n, e), s(t[i], m) > 0 && X7(t, n, i); p < _; ) {
      for (X7(t, p, _), p++, _--; s(t[p], m) < 0; )
        p++;
      for (; s(t[_], m) > 0; )
        _--;
    }
    s(t[n], m) === 0 ? X7(t, n, _) : (_++, X7(t, _, i)), _ <= e && (n = _ + 1), e <= _ && (i = _ - 1);
  }
}
function X7(t, e, n) {
  var i = t[e];
  t[e] = t[n], t[n] = i;
}
function Wy1(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
let hC = class {
  constructor(e = 9) {
    this._maxEntries = Math.max(4, e), this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4)), this.clear();
  }
  all() {
    return this._all(this.data, []);
  }
  search(e) {
    let n = this.data;
    const i = [];
    if (!Qc(e, n))
      return i;
    const s = this.toBBox, l = [];
    for (; n; ) {
      for (let a = 0; a < n.children.length; a++) {
        const o = n.children[a], h = n.leaf ? s(o) : o;
        Qc(e, h) && (n.leaf ? i.push(o) : Ig(e, h) ? this._all(o, i) : l.push(o));
      }
      n = l.pop();
    }
    return i;
  }
  collides(e) {
    let n = this.data;
    if (!Qc(e, n))
      return !1;
    const i = [];
    for (; n; ) {
      for (let s = 0; s < n.children.length; s++) {
        const l = n.children[s], a = n.leaf ? this.toBBox(l) : l;
        if (Qc(e, a)) {
          if (n.leaf || Ig(e, a))
            return !0;
          i.push(l);
        }
      }
      n = i.pop();
    }
    return !1;
  }
  load(e) {
    if (!(e && e.length))
      return this;
    if (e.length < this._minEntries) {
      for (let i = 0; i < e.length; i++)
        this.insert(e[i]);
      return this;
    }
    let n = this._build(e.slice(), 0, e.length - 1, 0);
    if (!this.data.children.length)
      this.data = n;
    else if (this.data.height === n.height)
      this._splitRoot(this.data, n);
    else {
      if (this.data.height < n.height) {
        const i = this.data;
        this.data = n, n = i;
      }
      this._insert(n, this.data.height - n.height - 1, !0);
    }
    return this;
  }
  insert(e) {
    return e && this._insert(e, this.data.height - 1), this;
  }
  clear() {
    return this.data = ra([]), this;
  }
  remove(e, n) {
    if (!e)
      return this;
    let i = this.data;
    const s = this.toBBox(e), l = [], a = [];
    let o, h, u;
    for (; i || l.length; ) {
      if (i || (i = l.pop(), h = l[l.length - 1], o = a.pop(), u = !0), i.leaf) {
        const d = Yy1(e, i.children, n);
        if (d !== -1)
          return i.children.splice(d, 1), l.push(i), this._condense(l), this;
      }
      !u && !i.leaf && Ig(i, s) ? (l.push(i), a.push(o), o = 0, h = i, i = i.children[0]) : h ? (o++, i = h.children[o], u = !1) : i = null;
    }
    return this;
  }
  toBBox(e) {
    return e;
  }
  compareMinX(e, n) {
    return e.minX - n.minX;
  }
  compareMinY(e, n) {
    return e.minY - n.minY;
  }
  toJSON() {
    return this.data;
  }
  fromJSON(e) {
    return this.data = e, this;
  }
  _all(e, n) {
    const i = [];
    for (; e; )
      e.leaf ? n.push(...e.children) : i.push(...e.children), e = i.pop();
    return n;
  }
  _build(e, n, i, s) {
    const l = i - n + 1;
    let a = this._maxEntries, o;
    if (l <= a)
      return o = ra(e.slice(n, i + 1)), Yr(o, this.toBBox), o;
    s || (s = Math.ceil(Math.log(l) / Math.log(a)), a = Math.ceil(l / Math.pow(a, s - 1))), o = ra([]), o.leaf = !1, o.height = s;
    const h = Math.ceil(l / a), u = h * Math.ceil(Math.sqrt(a));
    Uz(e, n, i, u, this.compareMinX);
    for (let d = n; d <= i; d += u) {
      const v = Math.min(d + u - 1, i);
      Uz(e, d, v, h, this.compareMinY);
      for (let m = d; m <= v; m += h) {
        const p = Math.min(m + h - 1, v);
        o.children.push(this._build(e, m, p, s - 1));
      }
    }
    return Yr(o, this.toBBox), o;
  }
  _chooseSubtree(e, n, i, s) {
    for (; s.push(n), !(n.leaf || s.length - 1 === i); ) {
      let l = 1 / 0, a = 1 / 0, o;
      for (let h = 0; h < n.children.length; h++) {
        const u = n.children[h], d = Tg(u), v = Zy1(e, u) - d;
        v < a ? (a = v, l = d < l ? d : l, o = u) : v === a && d < l && (l = d, o = u);
      }
      n = o || n.children[0];
    }
    return n;
  }
  _insert(e, n, i) {
    const s = i ? e : this.toBBox(e), l = [], a = this._chooseSubtree(s, this.data, n, l);
    for (a.children.push(e), co(a, s); n >= 0 && l[n].children.length > this._maxEntries; )
      this._split(l, n), n--;
    this._adjustParentBBoxes(s, l, n);
  }
  // split overflowed node into two
  _split(e, n) {
    const i = e[n], s = i.children.length, l = this._minEntries;
    this._chooseSplitAxis(i, l, s);
    const a = this._chooseSplitIndex(i, l, s), o = ra(i.children.splice(a, i.children.length - a));
    o.height = i.height, o.leaf = i.leaf, Yr(i, this.toBBox), Yr(o, this.toBBox), n ? e[n - 1].children.push(o) : this._splitRoot(i, o);
  }
  _splitRoot(e, n) {
    this.data = ra([e, n]), this.data.height = e.height + 1, this.data.leaf = !1, Yr(this.data, this.toBBox);
  }
  _chooseSplitIndex(e, n, i) {
    let s, l = 1 / 0, a = 1 / 0;
    for (let o = n; o <= i - n; o++) {
      const h = oo(e, 0, o, this.toBBox), u = oo(e, o, i, this.toBBox), d = Jy1(h, u), v = Tg(h) + Tg(u);
      d < l ? (l = d, s = o, a = v < a ? v : a) : d === l && v < a && (a = v, s = o);
    }
    return s || i - n;
  }
  // sorts node children by the best axis for split
  _chooseSplitAxis(e, n, i) {
    const s = e.leaf ? this.compareMinX : Xy1, l = e.leaf ? this.compareMinY : Ky1, a = this._allDistMargin(e, n, i, s), o = this._allDistMargin(e, n, i, l);
    a < o && e.children.sort(s);
  }
  // total margin of all possible split distributions where each node is at least m full
  _allDistMargin(e, n, i, s) {
    e.children.sort(s);
    const l = this.toBBox, a = oo(e, 0, n, l), o = oo(e, i - n, i, l);
    let h = Jc(a) + Jc(o);
    for (let u = n; u < i - n; u++) {
      const d = e.children[u];
      co(a, e.leaf ? l(d) : d), h += Jc(a);
    }
    for (let u = i - n - 1; u >= n; u--) {
      const d = e.children[u];
      co(o, e.leaf ? l(d) : d), h += Jc(o);
    }
    return h;
  }
  _adjustParentBBoxes(e, n, i) {
    for (let s = i; s >= 0; s--)
      co(n[s], e);
  }
  _condense(e) {
    for (let n = e.length - 1, i; n >= 0; n--)
      e[n].children.length === 0 ? n > 0 ? (i = e[n - 1].children, i.splice(i.indexOf(e[n]), 1)) : this.clear() : Yr(e[n], this.toBBox);
  }
};
function Yy1(t, e, n) {
  if (!n)
    return e.indexOf(t);
  for (let i = 0; i < e.length; i++)
    if (n(t, e[i]))
      return i;
  return -1;
}
function Yr(t, e) {
  oo(t, 0, t.children.length, e, t);
}
function oo(t, e, n, i, s) {
  s || (s = ra(null)), s.minX = 1 / 0, s.minY = 1 / 0, s.maxX = -1 / 0, s.maxY = -1 / 0;
  for (let l = e; l < n; l++) {
    const a = t.children[l];
    co(s, t.leaf ? i(a) : a);
  }
  return s;
}
function co(t, e) {
  return t.minX = Math.min(t.minX, e.minX), t.minY = Math.min(t.minY, e.minY), t.maxX = Math.max(t.maxX, e.maxX), t.maxY = Math.max(t.maxY, e.maxY), t;
}
function Xy1(t, e) {
  return t.minX - e.minX;
}
function Ky1(t, e) {
  return t.minY - e.minY;
}
function Tg(t) {
  return (t.maxX - t.minX) * (t.maxY - t.minY);
}
function Jc(t) {
  return t.maxX - t.minX + (t.maxY - t.minY);
}
function Zy1(t, e) {
  return (Math.max(e.maxX, t.maxX) - Math.min(e.minX, t.minX)) * (Math.max(e.maxY, t.maxY) - Math.min(e.minY, t.minY));
}
function Jy1(t, e) {
  const n = Math.max(t.minX, e.minX), i = Math.max(t.minY, e.minY), s = Math.min(t.maxX, e.maxX), l = Math.min(t.maxY, e.maxY);
  return Math.max(0, s - n) * Math.max(0, l - i);
}
function Ig(t, e) {
  return t.minX <= e.minX && t.minY <= e.minY && e.maxX <= t.maxX && e.maxY <= t.maxY;
}
function Qc(t, e) {
  return e.minX <= t.maxX && e.minY <= t.maxY && e.maxX >= t.minX && e.maxY >= t.minY;
}
function ra(t) {
  return {
    children: t,
    height: 1,
    leaf: !0,
    minX: 1 / 0,
    minY: 1 / 0,
    maxX: -1 / 0,
    maxY: -1 / 0
  };
}
function Uz(t, e, n, i, s) {
  const l = [e, n];
  for (; l.length; ) {
    if (n = l.pop(), e = l.pop(), n - e <= i)
      continue;
    const a = e + Math.ceil((n - e) / i / 2) * i;
    Gy1(t, a, e, n, s), l.push(e, a, a, n);
  }
}
function jz(t, e, n, i) {
  return n !== void 0 && i !== void 0 ? [n / t, i / e] : n !== void 0 ? n / t : i !== void 0 ? i / e : 1;
}
class kq extends tC {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {};
    const n = e.opacity !== void 0 ? e.opacity : 1, i = e.rotation !== void 0 ? e.rotation : 0, s = e.scale !== void 0 ? e.scale : 1, l = e.rotateWithView !== void 0 ? e.rotateWithView : !1;
    super({
      opacity: n,
      rotation: i,
      scale: s,
      displacement: e.displacement !== void 0 ? e.displacement : [0, 0],
      rotateWithView: l,
      declutterMode: e.declutterMode
    }), this.anchor_ = e.anchor !== void 0 ? e.anchor : [0.5, 0.5], this.normalizedAnchor_ = null, this.anchorOrigin_ = e.anchorOrigin !== void 0 ? e.anchorOrigin : "top-left", this.anchorXUnits_ = e.anchorXUnits !== void 0 ? e.anchorXUnits : "fraction", this.anchorYUnits_ = e.anchorYUnits !== void 0 ? e.anchorYUnits : "fraction", this.crossOrigin_ = e.crossOrigin !== void 0 ? e.crossOrigin : null;
    const a = e.img !== void 0 ? e.img : null;
    let o = e.src;
    ge(
      !(o !== void 0 && a),
      "`image` and `src` cannot be provided at the same time"
    ), (o === void 0 || o.length === 0) && a && (o = /** @type {HTMLImageElement} */
    a.src || Be(a)), ge(
      o !== void 0 && o.length > 0,
      "A defined and non-empty `src` or `image` must be provided"
    ), ge(
      !((e.width !== void 0 || e.height !== void 0) && e.scale !== void 0),
      "`width` or `height` cannot be provided together with `scale`"
    );
    let h;
    if (e.src !== void 0 ? h = Y3.IDLE : a !== void 0 && ("complete" in a ? a.complete ? h = a.src ? Y3.LOADED : Y3.IDLE : h = Y3.LOADING : h = Y3.LOADED), this.color_ = e.color !== void 0 ? Ko(e.color) : null, this.iconImage_ = vq(
      a,
      /** @type {string} */
      o,
      this.crossOrigin_,
      h,
      this.color_
    ), this.offset_ = e.offset !== void 0 ? e.offset : [0, 0], this.offsetOrigin_ = e.offsetOrigin !== void 0 ? e.offsetOrigin : "top-left", this.origin_ = null, this.size_ = e.size !== void 0 ? e.size : null, this.initialOptions_, e.width !== void 0 || e.height !== void 0) {
      let u, d;
      if (e.size)
        [u, d] = e.size;
      else {
        const v = this.getImage(1);
        if (v.width && v.height)
          u = v.width, d = v.height;
        else if (v instanceof HTMLImageElement) {
          this.initialOptions_ = e;
          const m = () => {
            if (this.unlistenImageChange(m), !this.initialOptions_)
              return;
            const p = this.iconImage_.getSize();
            this.setScale(
              jz(
                p[0],
                p[1],
                e.width,
                e.height
              )
            );
          };
          this.listenImageChange(m);
          return;
        }
      }
      u !== void 0 && this.setScale(
        jz(u, d, e.width, e.height)
      );
    }
  }
  /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */
  clone() {
    let e, n, i;
    return this.initialOptions_ ? (n = this.initialOptions_.width, i = this.initialOptions_.height) : (e = this.getScale(), e = Array.isArray(e) ? e.slice() : e), new kq({
      anchor: this.anchor_.slice(),
      anchorOrigin: this.anchorOrigin_,
      anchorXUnits: this.anchorXUnits_,
      anchorYUnits: this.anchorYUnits_,
      color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || void 0,
      crossOrigin: this.crossOrigin_,
      offset: this.offset_.slice(),
      offsetOrigin: this.offsetOrigin_,
      opacity: this.getOpacity(),
      rotateWithView: this.getRotateWithView(),
      rotation: this.getRotation(),
      scale: e,
      width: n,
      height: i,
      size: this.size_ !== null ? this.size_.slice() : void 0,
      src: this.getSrc(),
      displacement: this.getDisplacement().slice(),
      declutterMode: this.getDeclutterMode()
    });
  }
  /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */
  getAnchor() {
    let e = this.normalizedAnchor_;
    if (!e) {
      e = this.anchor_;
      const s = this.getSize();
      if (this.anchorXUnits_ == "fraction" || this.anchorYUnits_ == "fraction") {
        if (!s)
          return null;
        e = this.anchor_.slice(), this.anchorXUnits_ == "fraction" && (e[0] *= s[0]), this.anchorYUnits_ == "fraction" && (e[1] *= s[1]);
      }
      if (this.anchorOrigin_ != "top-left") {
        if (!s)
          return null;
        e === this.anchor_ && (e = this.anchor_.slice()), (this.anchorOrigin_ == "top-right" || this.anchorOrigin_ == "bottom-right") && (e[0] = -e[0] + s[0]), (this.anchorOrigin_ == "bottom-left" || this.anchorOrigin_ == "bottom-right") && (e[1] = -e[1] + s[1]);
      }
      this.normalizedAnchor_ = e;
    }
    const n = this.getDisplacement(), i = this.getScaleArray();
    return [
      e[0] - n[0] / i[0],
      e[1] + n[1] / i[1]
    ];
  }
  /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */
  setAnchor(e) {
    this.anchor_ = e, this.normalizedAnchor_ = null;
  }
  /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */
  getColor() {
    return this.color_;
  }
  /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */
  getImage(e) {
    return this.iconImage_.getImage(e);
  }
  /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */
  getPixelRatio(e) {
    return this.iconImage_.getPixelRatio(e);
  }
  /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */
  getImageSize() {
    return this.iconImage_.getSize();
  }
  /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */
  getImageState() {
    return this.iconImage_.getImageState();
  }
  /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   * @override
   */
  getHitDetectionImage() {
    return this.iconImage_.getHitDetectionImage();
  }
  /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */
  getOrigin() {
    if (this.origin_)
      return this.origin_;
    let e = this.offset_;
    if (this.offsetOrigin_ != "top-left") {
      const n = this.getSize(), i = this.iconImage_.getSize();
      if (!n || !i)
        return null;
      e = e.slice(), (this.offsetOrigin_ == "top-right" || this.offsetOrigin_ == "bottom-right") && (e[0] = i[0] - n[0] - e[0]), (this.offsetOrigin_ == "bottom-left" || this.offsetOrigin_ == "bottom-right") && (e[1] = i[1] - n[1] - e[1]);
    }
    return this.origin_ = e, this.origin_;
  }
  /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */
  getSrc() {
    return this.iconImage_.getSrc();
  }
  /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */
  getSize() {
    return this.size_ ? this.size_ : this.iconImage_.getSize();
  }
  /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */
  getWidth() {
    const e = this.getScaleArray();
    if (this.size_)
      return this.size_[0] * e[0];
    if (this.iconImage_.getImageState() == Y3.LOADED)
      return this.iconImage_.getSize()[0] * e[0];
  }
  /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */
  getHeight() {
    const e = this.getScaleArray();
    if (this.size_)
      return this.size_[1] * e[1];
    if (this.iconImage_.getImageState() == Y3.LOADED)
      return this.iconImage_.getSize()[1] * e[1];
  }
  /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */
  setScale(e) {
    delete this.initialOptions_, super.setScale(e);
  }
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */
  listenImageChange(e) {
    this.iconImage_.addEventListener(T3.CHANGE, e);
  }
  /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */
  load() {
    this.iconImage_.load();
  }
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */
  unlistenImageChange(e) {
    this.iconImage_.removeEventListener(T3.CHANGE, e);
  }
  /**
   * @override
   */
  ready() {
    return this.iconImage_.ready();
  }
}
const Eq = kq;
let Cr = 0;
const O5 = 1 << Cr++, re = 1 << Cr++, l0 = 1 << Cr++, nn = 1 << Cr++, gr = 1 << Cr++, ho = 1 << Cr++, eh = Math.pow(2, Cr) - 1, Aq = {
  [O5]: "boolean",
  [re]: "number",
  [l0]: "string",
  [nn]: "color",
  [gr]: "number[]",
  [ho]: "size"
}, Qy1 = Object.keys(Aq).map(Number).sort(m8);
function e_1(t) {
  return t in Aq;
}
function uo(t) {
  const e = [];
  for (const n of Qy1)
    fo(t, n) && e.push(Aq[n]);
  return e.length === 0 ? "untyped" : e.length < 3 ? e.join(" or ") : e.slice(0, -1).join(", ") + ", or " + e[e.length - 1];
}
function fo(t, e) {
  return (t & e) === e;
}
function rs(t, e) {
  return t === e;
}
class L4 {
  /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */
  constructor(e, n) {
    if (!e_1(e))
      throw new Error(
        `literal expressions must have a specific type, got ${uo(e)}`
      );
    this.type = e, this.value = n;
  }
}
class t_1 {
  /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */
  constructor(e, n, ...i) {
    this.type = e, this.operator = n, this.args = i;
  }
}
function uC() {
  return {
    variables: /* @__PURE__ */ new Set(),
    properties: /* @__PURE__ */ new Set(),
    featureId: !1,
    geometryType: !1
  };
}
function Y4(t, e, n) {
  switch (typeof t) {
    case "boolean": {
      if (rs(e, l0))
        return new L4(l0, t ? "true" : "false");
      if (!fo(e, O5))
        throw new Error(
          `got a boolean, but expected ${uo(e)}`
        );
      return new L4(O5, t);
    }
    case "number": {
      if (rs(e, ho))
        return new L4(ho, o0(t));
      if (rs(e, O5))
        return new L4(O5, !!t);
      if (rs(e, l0))
        return new L4(l0, t.toString());
      if (!fo(e, re))
        throw new Error(`got a number, but expected ${uo(e)}`);
      return new L4(re, t);
    }
    case "string": {
      if (rs(e, nn))
        return new L4(nn, uq(t));
      if (rs(e, O5))
        return new L4(O5, !!t);
      if (!fo(e, l0))
        throw new Error(`got a string, but expected ${uo(e)}`);
      return new L4(l0, t);
    }
  }
  if (!Array.isArray(t))
    throw new Error("expression must be an array or a primitive value");
  if (t.length === 0)
    throw new Error("empty expression");
  if (typeof t[0] == "string")
    return f_1(t, e, n);
  for (const i of t)
    if (typeof i != "number")
      throw new Error("expected an array of numbers");
  if (rs(e, ho)) {
    if (t.length !== 2)
      throw new Error(
        `expected an array of two values for a size, got ${t.length}`
      );
    return new L4(ho, t);
  }
  if (rs(e, nn)) {
    if (t.length === 3)
      return new L4(nn, [...t, 1]);
    if (t.length === 4)
      return new L4(nn, t);
    throw new Error(
      `expected an array of 3 or 4 values for a color, got ${t.length}`
    );
  }
  if (!fo(e, gr))
    throw new Error(
      `got an array of numbers, but expected ${uo(e)}`
    );
  return new L4(gr, t);
}
const Y1 = {
  Get: "get",
  Var: "var",
  Concat: "concat",
  GeometryType: "geometry-type",
  Any: "any",
  All: "all",
  Not: "!",
  Resolution: "resolution",
  Zoom: "zoom",
  Time: "time",
  Equal: "==",
  NotEqual: "!=",
  GreaterThan: ">",
  GreaterThanOrEqualTo: ">=",
  LessThan: "<",
  LessThanOrEqualTo: "<=",
  Multiply: "*",
  Divide: "/",
  Add: "+",
  Subtract: "-",
  Clamp: "clamp",
  Mod: "%",
  Pow: "^",
  Abs: "abs",
  Floor: "floor",
  Ceil: "ceil",
  Round: "round",
  Sin: "sin",
  Cos: "cos",
  Atan: "atan",
  Sqrt: "sqrt",
  Match: "match",
  Between: "between",
  Interpolate: "interpolate",
  Coalesce: "coalesce",
  Case: "case",
  In: "in",
  Number: "number",
  String: "string",
  Array: "array",
  Color: "color",
  Id: "id",
  Band: "band",
  Palette: "palette",
  ToString: "to-string"
}, n_1 = {
  [Y1.Get]: C3(U3(1, 1 / 0), i_1),
  [Y1.Var]: C3(U3(1, 1), s_1),
  [Y1.Id]: C3(l_1, K7),
  [Y1.Concat]: C3(
    U3(2, 1 / 0),
    Te(l0)
  ),
  [Y1.GeometryType]: C3(r_1, K7),
  [Y1.Resolution]: C3(K7),
  [Y1.Zoom]: C3(K7),
  [Y1.Time]: C3(K7),
  [Y1.Any]: C3(
    U3(2, 1 / 0),
    Te(O5)
  ),
  [Y1.All]: C3(
    U3(2, 1 / 0),
    Te(O5)
  ),
  [Y1.Not]: C3(
    U3(1, 1),
    Te(O5)
  ),
  [Y1.Equal]: C3(
    U3(2, 2),
    Te(eh)
  ),
  [Y1.NotEqual]: C3(
    U3(2, 2),
    Te(eh)
  ),
  [Y1.GreaterThan]: C3(
    U3(2, 2),
    Te(re)
  ),
  [Y1.GreaterThanOrEqualTo]: C3(
    U3(2, 2),
    Te(re)
  ),
  [Y1.LessThan]: C3(
    U3(2, 2),
    Te(re)
  ),
  [Y1.LessThanOrEqualTo]: C3(
    U3(2, 2),
    Te(re)
  ),
  [Y1.Multiply]: C3(
    U3(2, 1 / 0),
    Gz
  ),
  [Y1.Coalesce]: C3(
    U3(2, 1 / 0),
    Gz
  ),
  [Y1.Divide]: C3(
    U3(2, 2),
    Te(re)
  ),
  [Y1.Add]: C3(
    U3(2, 1 / 0),
    Te(re)
  ),
  [Y1.Subtract]: C3(
    U3(2, 2),
    Te(re)
  ),
  [Y1.Clamp]: C3(
    U3(3, 3),
    Te(re)
  ),
  [Y1.Mod]: C3(
    U3(2, 2),
    Te(re)
  ),
  [Y1.Pow]: C3(
    U3(2, 2),
    Te(re)
  ),
  [Y1.Abs]: C3(
    U3(1, 1),
    Te(re)
  ),
  [Y1.Floor]: C3(
    U3(1, 1),
    Te(re)
  ),
  [Y1.Ceil]: C3(
    U3(1, 1),
    Te(re)
  ),
  [Y1.Round]: C3(
    U3(1, 1),
    Te(re)
  ),
  [Y1.Sin]: C3(
    U3(1, 1),
    Te(re)
  ),
  [Y1.Cos]: C3(
    U3(1, 1),
    Te(re)
  ),
  [Y1.Atan]: C3(
    U3(1, 2),
    Te(re)
  ),
  [Y1.Sqrt]: C3(
    U3(1, 1),
    Te(re)
  ),
  [Y1.Match]: C3(
    U3(4, 1 / 0),
    Wz,
    o_1
  ),
  [Y1.Between]: C3(
    U3(3, 3),
    Te(re)
  ),
  [Y1.Interpolate]: C3(
    U3(6, 1 / 0),
    Wz,
    c_1
  ),
  [Y1.Case]: C3(
    U3(3, 1 / 0),
    a_1,
    h_1
  ),
  [Y1.In]: C3(U3(2, 2), u_1),
  [Y1.Number]: C3(
    U3(1, 1 / 0),
    Te(eh)
  ),
  [Y1.String]: C3(
    U3(1, 1 / 0),
    Te(eh)
  ),
  [Y1.Array]: C3(
    U3(1, 1 / 0),
    Te(re)
  ),
  [Y1.Color]: C3(
    U3(1, 4),
    Te(re)
  ),
  [Y1.Band]: C3(
    U3(1, 3),
    Te(re)
  ),
  [Y1.Palette]: C3(
    U3(2, 2),
    d_1
  ),
  [Y1.ToString]: C3(
    U3(1, 1),
    Te(O5 | re | l0 | nn)
  )
};
function i_1(t, e, n) {
  const i = t.length - 1, s = new Array(i);
  for (let l = 0; l < i; ++l) {
    const a = t[l + 1];
    switch (typeof a) {
      case "number": {
        s[l] = new L4(re, a);
        break;
      }
      case "string": {
        s[l] = new L4(l0, a);
        break;
      }
      default:
        throw new Error(
          `expected a string key or numeric array index for a get operation, got ${a}`
        );
    }
    l === 0 && n.properties.add(String(a));
  }
  return s;
}
function s_1(t, e, n) {
  const i = t[1];
  if (typeof i != "string")
    throw new Error("expected a string argument for var operation");
  return n.variables.add(i), [new L4(l0, i)];
}
function l_1(t, e, n) {
  n.featureId = !0;
}
function r_1(t, e, n) {
  n.geometryType = !0;
}
function K7(t, e, n) {
  const i = t[0];
  if (t.length !== 1)
    throw new Error(`expected no arguments for ${i} operation`);
  return [];
}
function U3(t, e) {
  return function(n, i, s) {
    const l = n[0], a = n.length - 1;
    if (t === e) {
      if (a !== t) {
        const o = t === 1 ? "" : "s";
        throw new Error(
          `expected ${t} argument${o} for ${l}, got ${a}`
        );
      }
    } else if (a < t || a > e) {
      const o = e === 1 / 0 ? `${t} or more` : `${t} to ${e}`;
      throw new Error(
        `expected ${o} arguments for ${l}, got ${a}`
      );
    }
  };
}
function Gz(t, e, n) {
  const i = t.length - 1, s = new Array(i);
  for (let l = 0; l < i; ++l) {
    const a = Y4(t[l + 1], e, n);
    s[l] = a;
  }
  return s;
}
function Te(t) {
  return function(e, n, i) {
    const s = e.length - 1, l = new Array(s);
    for (let a = 0; a < s; ++a) {
      const o = Y4(e[a + 1], t, i);
      l[a] = o;
    }
    return l;
  };
}
function a_1(t, e, n) {
  const i = t[0], s = t.length - 1;
  if (s % 2 === 0)
    throw new Error(
      `expected an odd number of arguments for ${i}, got ${s} instead`
    );
}
function Wz(t, e, n) {
  const i = t[0], s = t.length - 1;
  if (s % 2 === 1)
    throw new Error(
      `expected an even number of arguments for operation ${i}, got ${s} instead`
    );
}
function o_1(t, e, n) {
  const i = t.length - 1, s = l0 | re | O5, l = Y4(t[1], s, n), a = Y4(t[t.length - 1], e, n), o = new Array(i - 2);
  for (let h = 0; h < i - 2; h += 2) {
    try {
      const u = Y4(t[h + 2], l.type, n);
      o[h] = u;
    } catch (u) {
      throw new Error(
        `failed to parse argument ${h + 1} of match expression: ${u.message}`
      );
    }
    try {
      const u = Y4(t[h + 3], a.type, n);
      o[h + 1] = u;
    } catch (u) {
      throw new Error(
        `failed to parse argument ${h + 2} of match expression: ${u.message}`
      );
    }
  }
  return [l, ...o, a];
}
function c_1(t, e, n) {
  const i = t[1];
  let s;
  switch (i[0]) {
    case "linear":
      s = 1;
      break;
    case "exponential":
      const h = i[1];
      if (typeof h != "number" || h <= 0)
        throw new Error(
          `expected a number base for exponential interpolation, got ${JSON.stringify(h)} instead`
        );
      s = h;
      break;
    default:
      throw new Error(
        `invalid interpolation type: ${JSON.stringify(i)}`
      );
  }
  const l = new L4(re, s);
  let a;
  try {
    a = Y4(t[2], re, n);
  } catch (h) {
    throw new Error(
      `failed to parse argument 1 in interpolate expression: ${h.message}`
    );
  }
  const o = new Array(t.length - 3);
  for (let h = 0; h < o.length; h += 2) {
    try {
      const u = Y4(t[h + 3], re, n);
      o[h] = u;
    } catch (u) {
      throw new Error(
        `failed to parse argument ${h + 2} for interpolate expression: ${u.message}`
      );
    }
    try {
      const u = Y4(t[h + 4], e, n);
      o[h + 1] = u;
    } catch (u) {
      throw new Error(
        `failed to parse argument ${h + 3} for interpolate expression: ${u.message}`
      );
    }
  }
  return [l, a, ...o];
}
function h_1(t, e, n) {
  const i = Y4(t[t.length - 1], e, n), s = new Array(t.length - 1);
  for (let l = 0; l < s.length - 1; l += 2) {
    try {
      const a = Y4(t[l + 1], O5, n);
      s[l] = a;
    } catch (a) {
      throw new Error(
        `failed to parse argument ${l} of case expression: ${a.message}`
      );
    }
    try {
      const a = Y4(t[l + 2], i.type, n);
      s[l + 1] = a;
    } catch (a) {
      throw new Error(
        `failed to parse argument ${l + 1} of case expression: ${a.message}`
      );
    }
  }
  return s[s.length - 1] = i, s;
}
function u_1(t, e, n) {
  let i = t[2];
  if (!Array.isArray(i))
    throw new Error(
      'the second argument for the "in" operator must be an array'
    );
  let s;
  if (typeof i[0] == "string") {
    if (i[0] !== "literal")
      throw new Error(
        'for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions'
      );
    if (!Array.isArray(i[1]))
      throw new Error(
        'failed to parse "in" expression: the literal operator must be followed by an array'
      );
    i = i[1], s = l0;
  } else
    s = re;
  const l = new Array(i.length);
  for (let o = 0; o < l.length; o++)
    try {
      const h = Y4(i[o], s, n);
      l[o] = h;
    } catch (h) {
      throw new Error(
        `failed to parse haystack item ${o} for "in" expression: ${h.message}`
      );
    }
  return [Y4(t[1], s, n), ...l];
}
function d_1(t, e, n) {
  let i;
  try {
    i = Y4(t[1], re, n);
  } catch (a) {
    throw new Error(
      `failed to parse first argument in palette expression: ${a.message}`
    );
  }
  const s = t[2];
  if (!Array.isArray(s))
    throw new Error("the second argument of palette must be an array");
  const l = new Array(s.length);
  for (let a = 0; a < l.length; a++) {
    let o;
    try {
      o = Y4(s[a], nn, n);
    } catch (h) {
      throw new Error(
        `failed to parse color at index ${a} in palette expression: ${h.message}`
      );
    }
    if (!(o instanceof L4))
      throw new Error(
        `the palette color at index ${a} must be a literal value`
      );
    l[a] = o;
  }
  return [i, ...l];
}
function C3(...t) {
  return function(e, n, i) {
    const s = e[0];
    let l;
    for (let a = 0; a < t.length; a++) {
      const o = t[a](e, n, i);
      if (a == t.length - 1) {
        if (!o)
          throw new Error(
            "expected last argument validator to return the parsed args"
          );
        l = o;
      }
    }
    return new t_1(n, s, ...l);
  };
}
function f_1(t, e, n) {
  const i = t[0], s = n_1[i];
  if (!s)
    throw new Error(`unknown operator: ${i}`);
  return s(t, e, n);
}
function dC(t) {
  if (!t)
    return "";
  const e = t.getType();
  switch (e) {
    case "Point":
    case "LineString":
    case "Polygon":
      return e;
    case "MultiPoint":
    case "MultiLineString":
    case "MultiPolygon":
      return (
        /** @type {'Point'|'LineString'|'Polygon'} */
        e.substring(5)
      );
    case "Circle":
      return "Polygon";
    case "GeometryCollection":
      return dC(
        /** @type {import("../geom/GeometryCollection.js").default} */
        t.getGeometries()[0]
      );
    default:
      return "";
  }
}
function fC() {
  return {
    variables: {},
    properties: {},
    resolution: NaN,
    featureId: null,
    geometryType: ""
  };
}
function E8(t, e, n) {
  const i = Y4(t, e, n);
  return fn(i);
}
function fn(t, e) {
  if (t instanceof L4) {
    if (t.type === nn && typeof t.value == "string") {
      const i = uq(t.value);
      return function() {
        return i;
      };
    }
    return function() {
      return t.value;
    };
  }
  const n = t.operator;
  switch (n) {
    case Y1.Number:
    case Y1.String:
    case Y1.Coalesce:
      return v_1(t);
    case Y1.Get:
    case Y1.Var:
      return p_1(t);
    case Y1.Id:
      return (i) => i.featureId;
    case Y1.GeometryType:
      return (i) => i.geometryType;
    case Y1.Concat: {
      const i = t.args.map((s) => fn(s));
      return (s) => "".concat(...i.map((l) => l(s).toString()));
    }
    case Y1.Resolution:
      return (i) => i.resolution;
    case Y1.Any:
    case Y1.All:
    case Y1.Between:
    case Y1.In:
    case Y1.Not:
      return g_1(t);
    case Y1.Equal:
    case Y1.NotEqual:
    case Y1.LessThan:
    case Y1.LessThanOrEqualTo:
    case Y1.GreaterThan:
    case Y1.GreaterThanOrEqualTo:
      return m_1(t);
    case Y1.Multiply:
    case Y1.Divide:
    case Y1.Add:
    case Y1.Subtract:
    case Y1.Clamp:
    case Y1.Mod:
    case Y1.Pow:
    case Y1.Abs:
    case Y1.Floor:
    case Y1.Ceil:
    case Y1.Round:
    case Y1.Sin:
    case Y1.Cos:
    case Y1.Atan:
    case Y1.Sqrt:
      return y_1(t);
    case Y1.Case:
      return __1(t);
    case Y1.Match:
      return q_1(t);
    case Y1.Interpolate:
      return w_1(t);
    case Y1.ToString:
      return z_1(t);
    default:
      throw new Error(`Unsupported operator ${n}`);
  }
}
function v_1(t, e) {
  const n = t.operator, i = t.args.length, s = new Array(i);
  for (let l = 0; l < i; ++l)
    s[l] = fn(t.args[l]);
  switch (n) {
    case Y1.Coalesce:
      return (l) => {
        for (let a = 0; a < i; ++a) {
          const o = s[a](l);
          if (typeof o < "u" && o !== null)
            return o;
        }
        throw new Error("Expected one of the values to be non-null");
      };
    case Y1.Number:
    case Y1.String:
      return (l) => {
        for (let a = 0; a < i; ++a) {
          const o = s[a](l);
          if (typeof o === n)
            return o;
        }
        throw new Error(`Expected one of the values to be a ${n}`);
      };
    default:
      throw new Error(`Unsupported assertion operator ${n}`);
  }
}
function p_1(t, e) {
  const i = (
    /** @type {string} */
    /** @type {LiteralExpression} */
    t.args[0].value
  );
  switch (t.operator) {
    case Y1.Get:
      return (s) => {
        const l = t.args;
        let a = s.properties[i];
        for (let o = 1, h = l.length; o < h; ++o) {
          const d = (
            /** @type {string|number} */
            /** @type {LiteralExpression} */
            l[o].value
          );
          a = a[d];
        }
        return a;
      };
    case Y1.Var:
      return (s) => s.variables[i];
    default:
      throw new Error(`Unsupported accessor operator ${t.operator}`);
  }
}
function m_1(t, e) {
  const n = t.operator, i = fn(t.args[0]), s = fn(t.args[1]);
  switch (n) {
    case Y1.Equal:
      return (l) => i(l) === s(l);
    case Y1.NotEqual:
      return (l) => i(l) !== s(l);
    case Y1.LessThan:
      return (l) => i(l) < s(l);
    case Y1.LessThanOrEqualTo:
      return (l) => i(l) <= s(l);
    case Y1.GreaterThan:
      return (l) => i(l) > s(l);
    case Y1.GreaterThanOrEqualTo:
      return (l) => i(l) >= s(l);
    default:
      throw new Error(`Unsupported comparison operator ${n}`);
  }
}
function g_1(t, e) {
  const n = t.operator, i = t.args.length, s = new Array(i);
  for (let l = 0; l < i; ++l)
    s[l] = fn(t.args[l]);
  switch (n) {
    case Y1.Any:
      return (l) => {
        for (let a = 0; a < i; ++a)
          if (s[a](l))
            return !0;
        return !1;
      };
    case Y1.All:
      return (l) => {
        for (let a = 0; a < i; ++a)
          if (!s[a](l))
            return !1;
        return !0;
      };
    case Y1.Between:
      return (l) => {
        const a = s[0](l), o = s[1](l), h = s[2](l);
        return a >= o && a <= h;
      };
    case Y1.In:
      return (l) => {
        const a = s[0](l);
        for (let o = 1; o < i; ++o)
          if (a === s[o](l))
            return !0;
        return !1;
      };
    case Y1.Not:
      return (l) => !s[0](l);
    default:
      throw new Error(`Unsupported logical operator ${n}`);
  }
}
function y_1(t, e) {
  const n = t.operator, i = t.args.length, s = new Array(i);
  for (let l = 0; l < i; ++l)
    s[l] = fn(t.args[l]);
  switch (n) {
    case Y1.Multiply:
      return (l) => {
        let a = 1;
        for (let o = 0; o < i; ++o)
          a *= s[o](l);
        return a;
      };
    case Y1.Divide:
      return (l) => s[0](l) / s[1](l);
    case Y1.Add:
      return (l) => {
        let a = 0;
        for (let o = 0; o < i; ++o)
          a += s[o](l);
        return a;
      };
    case Y1.Subtract:
      return (l) => s[0](l) - s[1](l);
    case Y1.Clamp:
      return (l) => {
        const a = s[0](l), o = s[1](l);
        if (a < o)
          return o;
        const h = s[2](l);
        return a > h ? h : a;
      };
    case Y1.Mod:
      return (l) => s[0](l) % s[1](l);
    case Y1.Pow:
      return (l) => Math.pow(s[0](l), s[1](l));
    case Y1.Abs:
      return (l) => Math.abs(s[0](l));
    case Y1.Floor:
      return (l) => Math.floor(s[0](l));
    case Y1.Ceil:
      return (l) => Math.ceil(s[0](l));
    case Y1.Round:
      return (l) => Math.round(s[0](l));
    case Y1.Sin:
      return (l) => Math.sin(s[0](l));
    case Y1.Cos:
      return (l) => Math.cos(s[0](l));
    case Y1.Atan:
      return i === 2 ? (l) => Math.atan2(s[0](l), s[1](l)) : (l) => Math.atan(s[0](l));
    case Y1.Sqrt:
      return (l) => Math.sqrt(s[0](l));
    default:
      throw new Error(`Unsupported numeric operator ${n}`);
  }
}
function __1(t, e) {
  const n = t.args.length, i = new Array(n);
  for (let s = 0; s < n; ++s)
    i[s] = fn(t.args[s]);
  return (s) => {
    for (let l = 0; l < n - 1; l += 2)
      if (i[l](s))
        return i[l + 1](s);
    return i[n - 1](s);
  };
}
function q_1(t, e) {
  const n = t.args.length, i = new Array(n);
  for (let s = 0; s < n; ++s)
    i[s] = fn(t.args[s]);
  return (s) => {
    const l = i[0](s);
    for (let a = 1; a < n; a += 2)
      if (l === i[a](s))
        return i[a + 1](s);
    return i[n - 1](s);
  };
}
function w_1(t, e) {
  const n = t.args.length, i = new Array(n);
  for (let s = 0; s < n; ++s)
    i[s] = fn(t.args[s]);
  return (s) => {
    const l = i[0](s), a = i[1](s);
    let o, h;
    for (let u = 2; u < n; u += 2) {
      const d = i[u](s);
      let v = i[u + 1](s);
      const m = Array.isArray(v);
      if (m && (v = ly1(v)), d >= a)
        return u === 2 ? v : m ? M_1(
          l,
          a,
          o,
          h,
          d,
          v
        ) : vo(
          l,
          a,
          o,
          h,
          d,
          v
        );
      o = d, h = v;
    }
    return h;
  };
}
function z_1(t, e) {
  const n = t.operator, i = t.args.length, s = new Array(i);
  for (let l = 0; l < i; ++l)
    s[l] = fn(t.args[l]);
  switch (n) {
    case Y1.ToString:
      return (l) => {
        const a = s[0](l);
        return t.args[0].type === nn ? dq(a) : a.toString();
      };
    default:
      throw new Error(`Unsupported convert operator ${n}`);
  }
}
function vo(t, e, n, i, s, l) {
  const a = s - n;
  if (a === 0)
    return i;
  const o = e - n, h = t === 1 ? o / a : (Math.pow(t, o) - 1) / (Math.pow(t, a) - 1);
  return i + h * (l - i);
}
function M_1(t, e, n, i, s, l) {
  if (s - n === 0)
    return i;
  const o = Iz(i), h = Iz(l);
  let u = h[2] - o[2];
  u > 180 ? u -= 360 : u < -180 && (u += 360);
  const d = [
    vo(t, e, n, o[0], s, h[0]),
    vo(t, e, n, o[1], s, h[1]),
    o[2] + vo(t, e, n, 0, s, u),
    vo(t, e, n, i[3], s, l[3])
  ];
  return YS(ry1(d));
}
function b_1(t) {
  return !0;
}
function L_1(t) {
  const e = uC(), n = x_1(t, e), i = fC();
  return function(s, l) {
    if (i.properties = s.getPropertiesInternal(), i.resolution = l, e.featureId) {
      const a = s.getId();
      a !== void 0 ? i.featureId = a : i.featureId = null;
    }
    return e.geometryType && (i.geometryType = dC(
      s.getGeometry()
    )), n(i);
  };
}
function Yz(t) {
  const e = uC(), n = t.length, i = new Array(n);
  for (let a = 0; a < n; ++a)
    i[a] = Ay(t[a], e);
  const s = fC(), l = new Array(n);
  return function(a, o) {
    if (s.properties = a.getPropertiesInternal(), s.resolution = o, e.featureId) {
      const u = a.getId();
      u !== void 0 ? s.featureId = u : s.featureId = null;
    }
    let h = 0;
    for (let u = 0; u < n; ++u) {
      const d = i[u](s);
      d && (l[h] = d, h += 1);
    }
    return l.length = h, l;
  };
}
function x_1(t, e) {
  const n = t.length, i = new Array(n);
  for (let s = 0; s < n; ++s) {
    const l = t[s], a = "filter" in l ? E8(l.filter, O5, e) : b_1;
    let o;
    if (Array.isArray(l.style)) {
      const h = l.style.length;
      o = new Array(h);
      for (let u = 0; u < h; ++u)
        o[u] = Ay(l.style[u], e);
    } else
      o = [Ay(l.style, e)];
    i[s] = { filter: a, styles: o };
  }
  return function(s) {
    const l = [];
    let a = !1;
    for (let o = 0; o < n; ++o) {
      const h = i[o].filter;
      if (h(s) && !(t[o].else && a)) {
        a = !0;
        for (const u of i[o].styles) {
          const d = u(s);
          d && l.push(d);
        }
      }
    }
    return l;
  };
}
function Ay(t, e) {
  const n = tc(t, "", e), i = nc(t, "", e), s = S_1(t, e), l = C_1(t, e), a = a0(t, "z-index", e);
  if (!n && !i && !s && !l && !mr(t))
    throw new Error(
      "No fill, stroke, point, or text symbolizer properties in style: " + JSON.stringify(t)
    );
  const o = new So();
  return function(h) {
    let u = !0;
    if (n) {
      const d = n(h);
      d && (u = !1), o.setFill(d);
    }
    if (i) {
      const d = i(h);
      d && (u = !1), o.setStroke(d);
    }
    if (s) {
      const d = s(h);
      d && (u = !1), o.setText(d);
    }
    if (l) {
      const d = l(h);
      d && (u = !1), o.setImage(d);
    }
    return a && o.setZIndex(a(h)), u ? null : o;
  };
}
function tc(t, e, n) {
  let i;
  if (e + "fill-pattern-src" in t)
    i = F_1(t, e + "fill-", n);
  else {
    if (t[e + "fill-color"] === "none")
      return (l) => null;
    i = Fq(
      t,
      e + "fill-color",
      n
    );
  }
  if (!i)
    return null;
  const s = new Ju();
  return function(l) {
    const a = i(l);
    return a === "none" ? null : (s.setColor(a), s);
  };
}
function nc(t, e, n) {
  const i = a0(
    t,
    e + "stroke-width",
    n
  ), s = Fq(
    t,
    e + "stroke-color",
    n
  );
  if (!i && !s)
    return null;
  const l = u8(
    t,
    e + "stroke-line-cap",
    n
  ), a = u8(
    t,
    e + "stroke-line-join",
    n
  ), o = vC(
    t,
    e + "stroke-line-dash",
    n
  ), h = a0(
    t,
    e + "stroke-line-dash-offset",
    n
  ), u = a0(
    t,
    e + "stroke-miter-limit",
    n
  ), d = new gq();
  return function(v) {
    if (s) {
      const m = s(v);
      if (m === "none")
        return null;
      d.setColor(m);
    }
    if (i && d.setWidth(i(v)), l) {
      const m = l(v);
      if (m !== "butt" && m !== "round" && m !== "square")
        throw new Error("Expected butt, round, or square line cap");
      d.setLineCap(m);
    }
    if (a) {
      const m = a(v);
      if (m !== "bevel" && m !== "round" && m !== "miter")
        throw new Error("Expected bevel, round, or miter line join");
      d.setLineJoin(m);
    }
    return o && d.setLineDash(o(v)), h && d.setLineDashOffset(h(v)), u && d.setMiterLimit(u(v)), d;
  };
}
function S_1(t, e) {
  const n = "text-", i = u8(t, n + "value", e);
  if (!i)
    return null;
  const s = tc(t, n, e), l = tc(
    t,
    n + "background-",
    e
  ), a = nc(t, n, e), o = nc(
    t,
    n + "background-",
    e
  ), h = u8(t, n + "font", e), u = a0(
    t,
    n + "max-angle",
    e
  ), d = a0(
    t,
    n + "offset-x",
    e
  ), v = a0(
    t,
    n + "offset-y",
    e
  ), m = ic(
    t,
    n + "overflow",
    e
  ), p = u8(
    t,
    n + "placement",
    e
  ), _ = a0(t, n + "repeat", e), q = nd(t, n + "scale", e), M = ic(
    t,
    n + "rotate-with-view",
    e
  ), z = a0(
    t,
    n + "rotation",
    e
  ), b = u8(t, n + "align", e), x = u8(
    t,
    n + "justify",
    e
  ), k = u8(
    t,
    n + "baseline",
    e
  ), F = vC(
    t,
    n + "padding",
    e
  ), D = id(
    t,
    n + "declutter-mode"
  ), R = new Ey1({ declutterMode: D });
  return function(V) {
    if (R.setText(i(V)), s && R.setFill(s(V)), l && R.setBackgroundFill(l(V)), a && R.setStroke(a(V)), o && R.setBackgroundStroke(o(V)), h && R.setFont(h(V)), u && R.setMaxAngle(u(V)), d && R.setOffsetX(d(V)), v && R.setOffsetY(v(V)), m && R.setOverflow(m(V)), p) {
      const J = p(V);
      if (J !== "point" && J !== "line")
        throw new Error("Expected point or line for text-placement");
      R.setPlacement(J);
    }
    if (_ && R.setRepeat(_(V)), q && R.setScale(q(V)), M && R.setRotateWithView(M(V)), z && R.setRotation(z(V)), b) {
      const J = b(V);
      if (J !== "left" && J !== "center" && J !== "right" && J !== "end" && J !== "start")
        throw new Error(
          "Expected left, right, center, start, or end for text-align"
        );
      R.setTextAlign(J);
    }
    if (x) {
      const J = x(V);
      if (J !== "left" && J !== "right" && J !== "center")
        throw new Error("Expected left, right, or center for text-justify");
      R.setJustify(J);
    }
    if (k) {
      const J = k(V);
      if (J !== "bottom" && J !== "top" && J !== "middle" && J !== "alphabetic" && J !== "hanging")
        throw new Error(
          "Expected bottom, top, middle, alphabetic, or hanging for text-baseline"
        );
      R.setTextBaseline(J);
    }
    return F && R.setPadding(F(V)), R;
  };
}
function C_1(t, e) {
  return "icon-src" in t ? k_1(t, e) : "shape-points" in t ? E_1(t, e) : "circle-radius" in t ? A_1(t, e) : null;
}
function k_1(t, e) {
  const n = "icon-", i = n + "src", s = pC(t[i], i), l = Jh(
    t,
    n + "anchor",
    e
  ), a = nd(t, n + "scale", e), o = a0(
    t,
    n + "opacity",
    e
  ), h = Jh(
    t,
    n + "displacement",
    e
  ), u = a0(
    t,
    n + "rotation",
    e
  ), d = ic(
    t,
    n + "rotate-with-view",
    e
  ), v = Kz(t, n + "anchor-origin"), m = Zz(
    t,
    n + "anchor-x-units"
  ), p = Zz(
    t,
    n + "anchor-y-units"
  ), _ = N_1(t, n + "color"), q = I_1(t, n + "cross-origin"), M = O_1(t, n + "offset"), z = Kz(t, n + "offset-origin"), b = Qh(t, n + "width"), x = Qh(t, n + "height"), k = T_1(t, n + "size"), F = id(
    t,
    n + "declutter-mode"
  ), D = new Eq({
    src: s,
    anchorOrigin: v,
    anchorXUnits: m,
    anchorYUnits: p,
    color: _,
    crossOrigin: q,
    offset: M,
    offsetOrigin: z,
    height: x,
    width: b,
    size: k,
    declutterMode: F
  });
  return function(R) {
    return o && D.setOpacity(o(R)), h && D.setDisplacement(h(R)), u && D.setRotation(u(R)), d && D.setRotateWithView(d(R)), a && D.setScale(a(R)), l && D.setAnchor(l(R)), D;
  };
}
function E_1(t, e) {
  const n = "shape-", i = n + "points", s = n + "radius", l = Fy(t[i], i), a = Fy(t[s], s), o = tc(t, n, e), h = nc(t, n, e), u = nd(t, n + "scale", e), d = Jh(
    t,
    n + "displacement",
    e
  ), v = a0(
    t,
    n + "rotation",
    e
  ), m = ic(
    t,
    n + "rotate-with-view",
    e
  ), p = Qh(t, n + "radius2"), _ = Qh(t, n + "angle"), q = id(
    t,
    n + "declutter-mode"
  ), M = new lC({
    points: l,
    radius: a,
    radius2: p,
    angle: _,
    declutterMode: q
  });
  return function(z) {
    return o && M.setFill(o(z)), h && M.setStroke(h(z)), d && M.setDisplacement(d(z)), v && M.setRotation(v(z)), m && M.setRotateWithView(m(z)), u && M.setScale(u(z)), M;
  };
}
function A_1(t, e) {
  const n = "circle-", i = tc(t, n, e), s = nc(t, n, e), l = a0(t, n + "radius", e), a = nd(t, n + "scale", e), o = Jh(
    t,
    n + "displacement",
    e
  ), h = a0(
    t,
    n + "rotation",
    e
  ), u = ic(
    t,
    n + "rotate-with-view",
    e
  ), d = id(
    t,
    n + "declutter-mode"
  ), v = new zq({
    radius: 5,
    // this is arbitrary, but required - the evaluated radius is used below
    declutterMode: d
  });
  return function(m) {
    return l && v.setRadius(l(m)), i && v.setFill(i(m)), s && v.setStroke(s(m)), o && v.setDisplacement(o(m)), h && v.setRotation(h(m)), u && v.setRotateWithView(u(m)), a && v.setScale(a(m)), v;
  };
}
function a0(t, e, n) {
  if (!(e in t))
    return;
  const i = E8(t[e], re, n);
  return function(s) {
    return Fy(i(s), e);
  };
}
function u8(t, e, n) {
  if (!(e in t))
    return null;
  const i = E8(t[e], l0, n);
  return function(s) {
    return pC(i(s), e);
  };
}
function F_1(t, e, n) {
  const i = u8(
    t,
    e + "pattern-src",
    n
  ), s = Xz(
    t,
    e + "pattern-offset",
    n
  ), l = Xz(
    t,
    e + "pattern-size",
    n
  ), a = Fq(
    t,
    e + "color",
    n
  );
  return function(o) {
    return {
      src: i(o),
      offset: s && s(o),
      size: l && l(o),
      color: a && a(o)
    };
  };
}
function ic(t, e, n) {
  if (!(e in t))
    return null;
  const i = E8(t[e], O5, n);
  return function(s) {
    const l = i(s);
    if (typeof l != "boolean")
      throw new Error(`Expected a boolean for ${e}`);
    return l;
  };
}
function Fq(t, e, n) {
  if (!(e in t))
    return null;
  const i = E8(t[e], nn, n);
  return function(s) {
    return mC(i(s), e);
  };
}
function vC(t, e, n) {
  if (!(e in t))
    return null;
  const i = E8(t[e], gr, n);
  return function(s) {
    return bc(i(s), e);
  };
}
function Jh(t, e, n) {
  if (!(e in t))
    return null;
  const i = E8(t[e], gr, n);
  return function(s) {
    const l = bc(i(s), e);
    if (l.length !== 2)
      throw new Error(`Expected two numbers for ${e}`);
    return l;
  };
}
function Xz(t, e, n) {
  if (!(e in t))
    return null;
  const i = E8(t[e], gr, n);
  return function(s) {
    return gC(i(s), e);
  };
}
function nd(t, e, n) {
  if (!(e in t))
    return null;
  const i = E8(
    t[e],
    gr | re,
    n
  );
  return function(s) {
    return P_1(i(s), e);
  };
}
function Qh(t, e) {
  const n = t[e];
  if (n !== void 0) {
    if (typeof n != "number")
      throw new Error(`Expected a number for ${e}`);
    return n;
  }
}
function T_1(t, e) {
  const n = t[e];
  if (n !== void 0) {
    if (typeof n == "number")
      return o0(n);
    if (!Array.isArray(n))
      throw new Error(`Expected a number or size array for ${e}`);
    if (n.length !== 2 || typeof n[0] != "number" || typeof n[1] != "number")
      throw new Error(`Expected a number or size array for ${e}`);
    return n;
  }
}
function I_1(t, e) {
  const n = t[e];
  if (n !== void 0) {
    if (typeof n != "string")
      throw new Error(`Expected a string for ${e}`);
    return n;
  }
}
function Kz(t, e) {
  const n = t[e];
  if (n !== void 0) {
    if (n !== "bottom-left" && n !== "bottom-right" && n !== "top-left" && n !== "top-right")
      throw new Error(
        `Expected bottom-left, bottom-right, top-left, or top-right for ${e}`
      );
    return n;
  }
}
function Zz(t, e) {
  const n = t[e];
  if (n !== void 0) {
    if (n !== "pixels" && n !== "fraction")
      throw new Error(`Expected pixels or fraction for ${e}`);
    return n;
  }
}
function O_1(t, e) {
  const n = t[e];
  if (n !== void 0)
    return bc(n, e);
}
function id(t, e) {
  const n = t[e];
  if (n !== void 0) {
    if (typeof n != "string")
      throw new Error(`Expected a string for ${e}`);
    if (n !== "declutter" && n !== "obstacle" && n !== "none")
      throw new Error(`Expected declutter, obstacle, or none for ${e}`);
    return n;
  }
}
function N_1(t, e) {
  const n = t[e];
  if (n !== void 0)
    return mC(n, e);
}
function bc(t, e) {
  if (!Array.isArray(t))
    throw new Error(`Expected an array for ${e}`);
  const n = t.length;
  for (let i = 0; i < n; ++i)
    if (typeof t[i] != "number")
      throw new Error(`Expected an array of numbers for ${e}`);
  return t;
}
function pC(t, e) {
  if (typeof t != "string")
    throw new Error(`Expected a string for ${e}`);
  return t;
}
function Fy(t, e) {
  if (typeof t != "number")
    throw new Error(`Expected a number for ${e}`);
  return t;
}
function mC(t, e) {
  if (typeof t == "string")
    return t;
  const n = bc(t, e), i = n.length;
  if (i < 3 || i > 4)
    throw new Error(`Expected a color with 3 or 4 values for ${e}`);
  return n;
}
function gC(t, e) {
  const n = bc(t, e);
  if (n.length !== 2)
    throw new Error(`Expected an array of two numbers for ${e}`);
  return n;
}
function P_1(t, e) {
  return typeof t == "number" ? t : gC(t, e);
}
const Jz = {
  RENDER_ORDER: "renderOrder"
};
class B_1 extends td {
  /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */
  constructor(e) {
    e = e || {};
    const n = Object.assign({}, e);
    delete n.style, delete n.renderBuffer, delete n.updateWhileAnimating, delete n.updateWhileInteracting, super(n), this.declutter_ = e.declutter ? String(e.declutter) : void 0, this.renderBuffer_ = e.renderBuffer !== void 0 ? e.renderBuffer : 100, this.style_ = null, this.styleFunction_ = void 0, this.setStyle(e.style), this.updateWhileAnimating_ = e.updateWhileAnimating !== void 0 ? e.updateWhileAnimating : !1, this.updateWhileInteracting_ = e.updateWhileInteracting !== void 0 ? e.updateWhileInteracting : !1;
  }
  /**
   * @return {string} Declutter group.
   * @override
   */
  getDeclutter() {
    return this.declutter_;
  }
  /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */
  getFeatures(e) {
    return super.getFeatures(e);
  }
  /**
   * @return {number|undefined} Render buffer.
   */
  getRenderBuffer() {
    return this.renderBuffer_;
  }
  /**
   * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
   *     order.
   */
  getRenderOrder() {
    return (
      /** @type {import("../render.js").OrderFunction|null|undefined} */
      this.get(Jz.RENDER_ORDER)
    );
  }
  /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */
  getStyle() {
    return this.style_;
  }
  /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */
  getStyleFunction() {
    return this.styleFunction_;
  }
  /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */
  getUpdateWhileAnimating() {
    return this.updateWhileAnimating_;
  }
  /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */
  getUpdateWhileInteracting() {
    return this.updateWhileInteracting_;
  }
  /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */
  renderDeclutter(e, n) {
    const i = this.getDeclutter();
    i in e.declutter || (e.declutter[i] = new hC(9)), this.getRenderer().renderDeclutter(e, n);
  }
  /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */
  setRenderOrder(e) {
    this.set(Jz.RENDER_ORDER, e);
  }
  /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */
  setStyle(e) {
    this.style_ = e === void 0 ? rC : e;
    const n = V_1(e);
    this.styleFunction_ = e === null ? void 0 : Cy1(n), this.changed();
  }
}
function V_1(t) {
  if (t === void 0)
    return rC;
  if (!t)
    return null;
  if (typeof t == "function" || t instanceof So)
    return t;
  if (!Array.isArray(t))
    return Yz([t]);
  if (t.length === 0)
    return [];
  const e = t.length, n = t[0];
  if (n instanceof So) {
    const s = new Array(e);
    for (let l = 0; l < e; ++l) {
      const a = t[l];
      if (!(a instanceof So))
        throw new Error("Expected a list of style instances");
      s[l] = a;
    }
    return s;
  }
  if ("style" in n) {
    const s = new Array(e);
    for (let l = 0; l < e; ++l) {
      const a = t[l];
      if (!("style" in a))
        throw new Error("Expected a list of rules with a style property");
      s[l] = a;
    }
    return L_1(s);
  }
  return Yz(
    /** @type {Array<import("../style/flat.js").FlatStyle>} */
    t
  );
}
const yC = B_1, Lc = {
  BEGIN_GEOMETRY: 0,
  BEGIN_PATH: 1,
  CIRCLE: 2,
  CLOSE_PATH: 3,
  CUSTOM: 4,
  DRAW_CHARS: 5,
  DRAW_IMAGE: 6,
  END_GEOMETRY: 7,
  FILL: 8,
  MOVE_TO_LINE_TO: 9,
  SET_FILL_STYLE: 10,
  SET_STROKE_STYLE: 11,
  STROKE: 12
}, th = [Lc.FILL], zs = [Lc.STROKE], sr = [Lc.BEGIN_PATH], Qz = [Lc.CLOSE_PATH], p3 = Lc;
class R_1 {
  /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */
  drawCustom(e, n, i, s, l) {
  }
  /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */
  drawGeometry(e) {
  }
  /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */
  setStyle(e) {
  }
  /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawCircle(e, n, i) {
  }
  /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */
  drawFeature(e, n, i) {
  }
  /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawGeometryCollection(e, n, i) {
  }
  /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawLineString(e, n, i) {
  }
  /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawMultiLineString(e, n, i) {
  }
  /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawMultiPoint(e, n, i) {
  }
  /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawMultiPolygon(e, n, i) {
  }
  /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawPoint(e, n, i) {
  }
  /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawPolygon(e, n, i) {
  }
  /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */
  drawText(e, n, i) {
  }
  /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */
  setFillStrokeStyle(e, n) {
  }
  /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */
  setImageStyle(e, n) {
  }
  /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */
  setTextStyle(e, n) {
  }
}
const _C = R_1;
class H_1 extends _C {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(e, n, i, s) {
    super(), this.tolerance = e, this.maxExtent = n, this.pixelRatio = s, this.maxLineWidth = 0, this.resolution = i, this.beginGeometryInstruction1_ = null, this.beginGeometryInstruction2_ = null, this.bufferedMaxExtent_ = null, this.instructions = [], this.coordinates = [], this.tmpCoordinate_ = [], this.hitDetectionInstructions = [], this.state = /** @type {import("../canvas.js").FillStrokeState} */
    {};
  }
  /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */
  applyPixelRatio(e) {
    const n = this.pixelRatio;
    return n == 1 ? e : e.map(function(i) {
      return i * n;
    });
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */
  appendFlatPointCoordinates(e, n) {
    const i = this.getBufferedMaxExtent(), s = this.tmpCoordinate_, l = this.coordinates;
    let a = l.length;
    for (let o = 0, h = e.length; o < h; o += n)
      s[0] = e[o], s[1] = e[o + 1], Da(i, s) && (l[a++] = s[0], l[a++] = s[1]);
    return a;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */
  appendFlatLineCoordinates(e, n, i, s, l, a) {
    const o = this.coordinates;
    let h = o.length;
    const u = this.getBufferedMaxExtent();
    a && (n += s);
    let d = e[n], v = e[n + 1];
    const m = this.tmpCoordinate_;
    let p = !0, _, q, M;
    for (_ = n + s; _ < i; _ += s)
      m[0] = e[_], m[1] = e[_ + 1], M = qy(u, m), M !== q ? (p && (o[h++] = d, o[h++] = v, p = !1), o[h++] = m[0], o[h++] = m[1]) : M === F4.INTERSECTING ? (o[h++] = m[0], o[h++] = m[1], p = !1) : p = !0, d = m[0], v = m[1], q = M;
    return (l && p || _ === n + s) && (o[h++] = d, o[h++] = v), h;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */
  drawCustomCoordinates_(e, n, i, s, l) {
    for (let a = 0, o = i.length; a < o; ++a) {
      const h = i[a], u = this.appendFlatLineCoordinates(
        e,
        n,
        h,
        s,
        !1,
        !1
      );
      l.push(u), n = h;
    }
    return n;
  }
  /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */
  drawCustom(e, n, i, s, l) {
    this.beginGeometry(e, n, l);
    const a = e.getType(), o = e.getStride(), h = this.coordinates.length;
    let u, d, v, m, p;
    switch (a) {
      case "MultiPolygon":
        u = /** @type {import("../../geom/MultiPolygon.js").default} */
        e.getOrientedFlatCoordinates(), m = [];
        const _ = (
          /** @type {import("../../geom/MultiPolygon.js").default} */
          e.getEndss()
        );
        p = 0;
        for (let q = 0, M = _.length; q < M; ++q) {
          const z = [];
          p = this.drawCustomCoordinates_(
            u,
            p,
            _[q],
            o,
            z
          ), m.push(z);
        }
        this.instructions.push([
          p3.CUSTOM,
          h,
          m,
          e,
          i,
          Ly,
          l
        ]), this.hitDetectionInstructions.push([
          p3.CUSTOM,
          h,
          m,
          e,
          s || i,
          Ly,
          l
        ]);
        break;
      case "Polygon":
      case "MultiLineString":
        v = [], u = a == "Polygon" ? (
          /** @type {import("../../geom/Polygon.js").default} */
          e.getOrientedFlatCoordinates()
        ) : e.getFlatCoordinates(), p = this.drawCustomCoordinates_(
          u,
          0,
          /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */
          e.getEnds(),
          o,
          v
        ), this.instructions.push([
          p3.CUSTOM,
          h,
          v,
          e,
          i,
          Wo,
          l
        ]), this.hitDetectionInstructions.push([
          p3.CUSTOM,
          h,
          v,
          e,
          s || i,
          Wo,
          l
        ]);
        break;
      case "LineString":
      case "Circle":
        u = e.getFlatCoordinates(), d = this.appendFlatLineCoordinates(
          u,
          0,
          u.length,
          o,
          !1,
          !1
        ), this.instructions.push([
          p3.CUSTOM,
          h,
          d,
          e,
          i,
          ws,
          l
        ]), this.hitDetectionInstructions.push([
          p3.CUSTOM,
          h,
          d,
          e,
          s || i,
          ws,
          l
        ]);
        break;
      case "MultiPoint":
        u = e.getFlatCoordinates(), d = this.appendFlatPointCoordinates(u, o), d > h && (this.instructions.push([
          p3.CUSTOM,
          h,
          d,
          e,
          i,
          ws,
          l
        ]), this.hitDetectionInstructions.push([
          p3.CUSTOM,
          h,
          d,
          e,
          s || i,
          ws,
          l
        ]));
        break;
      case "Point":
        u = e.getFlatCoordinates(), this.coordinates.push(u[0], u[1]), d = this.coordinates.length, this.instructions.push([
          p3.CUSTOM,
          h,
          d,
          e,
          i,
          void 0,
          l
        ]), this.hitDetectionInstructions.push([
          p3.CUSTOM,
          h,
          d,
          e,
          s || i,
          void 0,
          l
        ]);
        break;
    }
    this.endGeometry(n);
  }
  /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */
  beginGeometry(e, n, i) {
    this.beginGeometryInstruction1_ = [
      p3.BEGIN_GEOMETRY,
      n,
      0,
      e,
      i
    ], this.instructions.push(this.beginGeometryInstruction1_), this.beginGeometryInstruction2_ = [
      p3.BEGIN_GEOMETRY,
      n,
      0,
      e,
      i
    ], this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */
  finish() {
    return {
      instructions: this.instructions,
      hitDetectionInstructions: this.hitDetectionInstructions,
      coordinates: this.coordinates
    };
  }
  /**
   * Reverse the hit detection instructions.
   */
  reverseHitDetectionInstructions() {
    const e = this.hitDetectionInstructions;
    e.reverse();
    let n;
    const i = e.length;
    let s, l, a = -1;
    for (n = 0; n < i; ++n)
      s = e[n], l = /** @type {import("./Instruction.js").default} */
      s[0], l == p3.END_GEOMETRY ? a = n : l == p3.BEGIN_GEOMETRY && (s[2] = n, Lg1(this.hitDetectionInstructions, a, n), a = -1);
  }
  /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */
  setFillStrokeStyle(e, n) {
    const i = this.state;
    if (e) {
      const s = e.getColor();
      i.fillPatternScale = s && typeof s == "object" && "src" in s ? this.pixelRatio : 1, i.fillStyle = Xn(
        s || s0
      );
    } else
      i.fillStyle = void 0;
    if (n) {
      const s = n.getColor();
      i.strokeStyle = Xn(
        s || Jo
      );
      const l = n.getLineCap();
      i.lineCap = l !== void 0 ? l : Wa;
      const a = n.getLineDash();
      i.lineDash = a ? a.slice() : g8;
      const o = n.getLineDashOffset();
      i.lineDashOffset = o || y8;
      const h = n.getLineJoin();
      i.lineJoin = h !== void 0 ? h : Ya;
      const u = n.getWidth();
      i.lineWidth = u !== void 0 ? u : ec;
      const d = n.getMiterLimit();
      i.miterLimit = d !== void 0 ? d : Zo, i.lineWidth > this.maxLineWidth && (this.maxLineWidth = i.lineWidth, this.bufferedMaxExtent_ = null);
    } else
      i.strokeStyle = void 0, i.lineCap = void 0, i.lineDash = null, i.lineDashOffset = void 0, i.lineJoin = void 0, i.lineWidth = void 0, i.miterLimit = void 0;
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */
  createFill(e) {
    const n = e.fillStyle, i = [p3.SET_FILL_STYLE, n];
    return typeof n != "string" && i.push(e.fillPatternScale), i;
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */
  applyStroke(e) {
    this.instructions.push(this.createStroke(e));
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */
  createStroke(e) {
    return [
      p3.SET_STROKE_STYLE,
      e.strokeStyle,
      e.lineWidth * this.pixelRatio,
      e.lineCap,
      e.lineJoin,
      e.miterLimit,
      this.applyPixelRatio(e.lineDash),
      e.lineDashOffset * this.pixelRatio
    ];
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */
  updateFillStyle(e, n) {
    const i = e.fillStyle;
    (typeof i != "string" || e.currentFillStyle != i) && (i !== void 0 && this.instructions.push(n.call(this, e)), e.currentFillStyle = i);
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */
  updateStrokeStyle(e, n) {
    const i = e.strokeStyle, s = e.lineCap, l = e.lineDash, a = e.lineDashOffset, o = e.lineJoin, h = e.lineWidth, u = e.miterLimit;
    (e.currentStrokeStyle != i || e.currentLineCap != s || l != e.currentLineDash && !Ws(e.currentLineDash, l) || e.currentLineDashOffset != a || e.currentLineJoin != o || e.currentLineWidth != h || e.currentMiterLimit != u) && (i !== void 0 && n.call(this, e), e.currentStrokeStyle = i, e.currentLineCap = s, e.currentLineDash = l, e.currentLineDashOffset = a, e.currentLineJoin = o, e.currentLineWidth = h, e.currentMiterLimit = u);
  }
  /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */
  endGeometry(e) {
    this.beginGeometryInstruction1_[2] = this.instructions.length, this.beginGeometryInstruction1_ = null, this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length, this.beginGeometryInstruction2_ = null;
    const n = [p3.END_GEOMETRY, e];
    this.instructions.push(n), this.hitDetectionInstructions.push(n);
  }
  /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */
  getBufferedMaxExtent() {
    if (!this.bufferedMaxExtent_ && (this.bufferedMaxExtent_ = yS(this.maxExtent), this.maxLineWidth > 0)) {
      const e = this.resolution * (this.maxLineWidth + 1) / 2;
      Do(this.bufferedMaxExtent_, e, this.bufferedMaxExtent_);
    }
    return this.bufferedMaxExtent_;
  }
}
const xc = H_1;
class D_1 extends xc {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(e, n, i, s) {
    super(e, n, i, s), this.hitDetectionImage_ = null, this.image_ = null, this.imagePixelRatio_ = void 0, this.anchorX_ = void 0, this.anchorY_ = void 0, this.height_ = void 0, this.opacity_ = void 0, this.originX_ = void 0, this.originY_ = void 0, this.rotateWithView_ = void 0, this.rotation_ = void 0, this.scale_ = void 0, this.width_ = void 0, this.declutterMode_ = void 0, this.declutterImageWithText_ = void 0;
  }
  /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */
  drawPoint(e, n, i) {
    if (!this.image_ || this.maxExtent && !Da(this.maxExtent, e.getFlatCoordinates()))
      return;
    this.beginGeometry(e, n, i);
    const s = e.getFlatCoordinates(), l = e.getStride(), a = this.coordinates.length, o = this.appendFlatPointCoordinates(s, l);
    this.instructions.push([
      p3.DRAW_IMAGE,
      a,
      o,
      this.image_,
      // Remaining arguments to DRAW_IMAGE are in alphabetical order
      this.anchorX_ * this.imagePixelRatio_,
      this.anchorY_ * this.imagePixelRatio_,
      Math.ceil(this.height_ * this.imagePixelRatio_),
      this.opacity_,
      this.originX_ * this.imagePixelRatio_,
      this.originY_ * this.imagePixelRatio_,
      this.rotateWithView_,
      this.rotation_,
      [
        this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
        this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
      ],
      Math.ceil(this.width_ * this.imagePixelRatio_),
      this.declutterMode_,
      this.declutterImageWithText_
    ]), this.hitDetectionInstructions.push([
      p3.DRAW_IMAGE,
      a,
      o,
      this.hitDetectionImage_,
      // Remaining arguments to DRAW_IMAGE are in alphabetical order
      this.anchorX_,
      this.anchorY_,
      this.height_,
      1,
      this.originX_,
      this.originY_,
      this.rotateWithView_,
      this.rotation_,
      this.scale_,
      this.width_,
      this.declutterMode_,
      this.declutterImageWithText_
    ]), this.endGeometry(n);
  }
  /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */
  drawMultiPoint(e, n, i) {
    if (!this.image_)
      return;
    this.beginGeometry(e, n, i);
    const s = e.getFlatCoordinates(), l = [];
    for (let h = 0, u = s.length; h < u; h += e.getStride())
      (!this.maxExtent || Da(this.maxExtent, s.slice(h, h + 2))) && l.push(
        s[h],
        s[h + 1]
      );
    const a = this.coordinates.length, o = this.appendFlatPointCoordinates(l, 2);
    this.instructions.push([
      p3.DRAW_IMAGE,
      a,
      o,
      this.image_,
      // Remaining arguments to DRAW_IMAGE are in alphabetical order
      this.anchorX_ * this.imagePixelRatio_,
      this.anchorY_ * this.imagePixelRatio_,
      Math.ceil(this.height_ * this.imagePixelRatio_),
      this.opacity_,
      this.originX_ * this.imagePixelRatio_,
      this.originY_ * this.imagePixelRatio_,
      this.rotateWithView_,
      this.rotation_,
      [
        this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
        this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
      ],
      Math.ceil(this.width_ * this.imagePixelRatio_),
      this.declutterMode_,
      this.declutterImageWithText_
    ]), this.hitDetectionInstructions.push([
      p3.DRAW_IMAGE,
      a,
      o,
      this.hitDetectionImage_,
      // Remaining arguments to DRAW_IMAGE are in alphabetical order
      this.anchorX_,
      this.anchorY_,
      this.height_,
      1,
      this.originX_,
      this.originY_,
      this.rotateWithView_,
      this.rotation_,
      this.scale_,
      this.width_,
      this.declutterMode_,
      this.declutterImageWithText_
    ]), this.endGeometry(n);
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */
  finish() {
    return this.reverseHitDetectionInstructions(), this.anchorX_ = void 0, this.anchorY_ = void 0, this.hitDetectionImage_ = null, this.image_ = null, this.imagePixelRatio_ = void 0, this.height_ = void 0, this.scale_ = void 0, this.opacity_ = void 0, this.originX_ = void 0, this.originY_ = void 0, this.rotateWithView_ = void 0, this.rotation_ = void 0, this.width_ = void 0, super.finish();
  }
  /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */
  setImageStyle(e, n) {
    const i = e.getAnchor(), s = e.getSize(), l = e.getOrigin();
    this.imagePixelRatio_ = e.getPixelRatio(this.pixelRatio), this.anchorX_ = i[0], this.anchorY_ = i[1], this.hitDetectionImage_ = e.getHitDetectionImage(), this.image_ = e.getImage(this.pixelRatio), this.height_ = s[1], this.opacity_ = e.getOpacity(), this.originX_ = l[0], this.originY_ = l[1], this.rotateWithView_ = e.getRotateWithView(), this.rotation_ = e.getRotation(), this.scale_ = e.getScaleArray(), this.width_ = s[0], this.declutterMode_ = e.getDeclutterMode(), this.declutterImageWithText_ = n;
  }
}
const $_1 = D_1;
class U_1 extends xc {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(e, n, i, s) {
    super(e, n, i, s);
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */
  drawFlatCoordinates_(e, n, i, s) {
    const l = this.coordinates.length, a = this.appendFlatLineCoordinates(
      e,
      n,
      i,
      s,
      !1,
      !1
    ), o = [
      p3.MOVE_TO_LINE_TO,
      l,
      a
    ];
    return this.instructions.push(o), this.hitDetectionInstructions.push(o), i;
  }
  /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */
  drawLineString(e, n, i) {
    const s = this.state, l = s.strokeStyle, a = s.lineWidth;
    if (l === void 0 || a === void 0)
      return;
    this.updateStrokeStyle(s, this.applyStroke), this.beginGeometry(e, n, i), this.hitDetectionInstructions.push(
      [
        p3.SET_STROKE_STYLE,
        s.strokeStyle,
        s.lineWidth,
        s.lineCap,
        s.lineJoin,
        s.miterLimit,
        g8,
        y8
      ],
      sr
    );
    const o = e.getFlatCoordinates(), h = e.getStride();
    this.drawFlatCoordinates_(
      o,
      0,
      o.length,
      h
    ), this.hitDetectionInstructions.push(zs), this.endGeometry(n);
  }
  /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */
  drawMultiLineString(e, n, i) {
    const s = this.state, l = s.strokeStyle, a = s.lineWidth;
    if (l === void 0 || a === void 0)
      return;
    this.updateStrokeStyle(s, this.applyStroke), this.beginGeometry(e, n, i), this.hitDetectionInstructions.push(
      [
        p3.SET_STROKE_STYLE,
        s.strokeStyle,
        s.lineWidth,
        s.lineCap,
        s.lineJoin,
        s.miterLimit,
        g8,
        y8
      ],
      sr
    );
    const o = e.getEnds(), h = e.getFlatCoordinates(), u = e.getStride();
    let d = 0;
    for (let v = 0, m = o.length; v < m; ++v)
      d = this.drawFlatCoordinates_(
        h,
        d,
        /** @type {number} */
        o[v],
        u
      );
    this.hitDetectionInstructions.push(zs), this.endGeometry(n);
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */
  finish() {
    const e = this.state;
    return e.lastStroke != null && e.lastStroke != this.coordinates.length && this.instructions.push(zs), this.reverseHitDetectionInstructions(), this.state = null, super.finish();
  }
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */
  applyStroke(e) {
    e.lastStroke != null && e.lastStroke != this.coordinates.length && (this.instructions.push(zs), e.lastStroke = this.coordinates.length), e.lastStroke = 0, super.applyStroke(e), this.instructions.push(sr);
  }
}
const j_1 = U_1;
class G_1 extends xc {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(e, n, i, s) {
    super(e, n, i, s);
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */
  drawFlatCoordinatess_(e, n, i, s) {
    const l = this.state, a = l.fillStyle !== void 0, o = l.strokeStyle !== void 0, h = i.length;
    this.instructions.push(sr), this.hitDetectionInstructions.push(sr);
    for (let u = 0; u < h; ++u) {
      const d = i[u], v = this.coordinates.length, m = this.appendFlatLineCoordinates(
        e,
        n,
        d,
        s,
        !0,
        !o
      ), p = [
        p3.MOVE_TO_LINE_TO,
        v,
        m
      ];
      this.instructions.push(p), this.hitDetectionInstructions.push(p), o && (this.instructions.push(Qz), this.hitDetectionInstructions.push(Qz)), n = d;
    }
    return a && (this.instructions.push(th), this.hitDetectionInstructions.push(th)), o && (this.instructions.push(zs), this.hitDetectionInstructions.push(zs)), n;
  }
  /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */
  drawCircle(e, n, i) {
    const s = this.state, l = s.fillStyle, a = s.strokeStyle;
    if (l === void 0 && a === void 0)
      return;
    this.setFillStrokeStyles_(), this.beginGeometry(e, n, i), s.fillStyle !== void 0 && this.hitDetectionInstructions.push([
      p3.SET_FILL_STYLE,
      s0
    ]), s.strokeStyle !== void 0 && this.hitDetectionInstructions.push([
      p3.SET_STROKE_STYLE,
      s.strokeStyle,
      s.lineWidth,
      s.lineCap,
      s.lineJoin,
      s.miterLimit,
      g8,
      y8
    ]);
    const o = e.getFlatCoordinates(), h = e.getStride(), u = this.coordinates.length;
    this.appendFlatLineCoordinates(
      o,
      0,
      o.length,
      h,
      !1,
      !1
    );
    const d = [p3.CIRCLE, u];
    this.instructions.push(sr, d), this.hitDetectionInstructions.push(sr, d), s.fillStyle !== void 0 && (this.instructions.push(th), this.hitDetectionInstructions.push(th)), s.strokeStyle !== void 0 && (this.instructions.push(zs), this.hitDetectionInstructions.push(zs)), this.endGeometry(n);
  }
  /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */
  drawPolygon(e, n, i) {
    const s = this.state, l = s.fillStyle, a = s.strokeStyle;
    if (l === void 0 && a === void 0)
      return;
    this.setFillStrokeStyles_(), this.beginGeometry(e, n, i), s.fillStyle !== void 0 && this.hitDetectionInstructions.push([
      p3.SET_FILL_STYLE,
      s0
    ]), s.strokeStyle !== void 0 && this.hitDetectionInstructions.push([
      p3.SET_STROKE_STYLE,
      s.strokeStyle,
      s.lineWidth,
      s.lineCap,
      s.lineJoin,
      s.miterLimit,
      g8,
      y8
    ]);
    const o = e.getEnds(), h = e.getOrientedFlatCoordinates(), u = e.getStride();
    this.drawFlatCoordinatess_(
      h,
      0,
      /** @type {Array<number>} */
      o,
      u
    ), this.endGeometry(n);
  }
  /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */
  drawMultiPolygon(e, n, i) {
    const s = this.state, l = s.fillStyle, a = s.strokeStyle;
    if (l === void 0 && a === void 0)
      return;
    this.setFillStrokeStyles_(), this.beginGeometry(e, n, i), s.fillStyle !== void 0 && this.hitDetectionInstructions.push([
      p3.SET_FILL_STYLE,
      s0
    ]), s.strokeStyle !== void 0 && this.hitDetectionInstructions.push([
      p3.SET_STROKE_STYLE,
      s.strokeStyle,
      s.lineWidth,
      s.lineCap,
      s.lineJoin,
      s.miterLimit,
      g8,
      y8
    ]);
    const o = e.getEndss(), h = e.getOrientedFlatCoordinates(), u = e.getStride();
    let d = 0;
    for (let v = 0, m = o.length; v < m; ++v)
      d = this.drawFlatCoordinatess_(
        h,
        d,
        o[v],
        u
      );
    this.endGeometry(n);
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */
  finish() {
    this.reverseHitDetectionInstructions(), this.state = null;
    const e = this.tolerance;
    if (e !== 0) {
      const n = this.coordinates;
      for (let i = 0, s = n.length; i < s; ++i)
        n[i] = Xl(n[i], e);
    }
    return super.finish();
  }
  /**
   * @private
   */
  setFillStrokeStyles_() {
    const e = this.state;
    e.fillStyle !== void 0 && this.updateFillStyle(e, this.createFill), e.strokeStyle !== void 0 && this.updateStrokeStyle(e, this.applyStroke);
  }
}
const eM = G_1;
function W_1(t, e, n, i, s) {
  const l = [];
  let a = n, o = 0, h = e.slice(n, 2);
  for (; o < t && a + s < i; ) {
    const [u, d] = h.slice(-2), v = e[a + s], m = e[a + s + 1], p = Math.sqrt(
      (v - u) * (v - u) + (m - d) * (m - d)
    );
    if (o += p, o >= t) {
      const _ = (t - o + p) / p, q = V0(u, v, _), M = V0(d, m, _);
      h.push(q, M), l.push(h), h = [q, M], o == t && (a += s), o = 0;
    } else if (o < t)
      h.push(
        e[a + s],
        e[a + s + 1]
      ), a += s;
    else {
      const _ = p - o, q = V0(u, v, _ / p), M = V0(d, m, _ / p);
      h.push(q, M), l.push(h), h = [q, M], o = 0, a += s;
    }
  }
  return o > 0 && l.push(h), l;
}
function Y_1(t, e, n, i, s) {
  let l = n, a = n, o = 0, h = 0, u = n, d, v, m, p, _, q, M, z, b, x;
  for (v = n; v < i; v += s) {
    const k = e[v], F = e[v + 1];
    _ !== void 0 && (b = k - _, x = F - q, p = Math.sqrt(b * b + x * x), M !== void 0 && (h += m, d = Math.acos((M * b + z * x) / (m * p)), d > t && (h > o && (o = h, l = u, a = v), h = 0, u = v - s)), m = p, M = b, z = x), _ = k, q = F;
  }
  return h += p, h > o ? [u, v] : [l, a];
}
const eu = {
  left: 0,
  center: 0.5,
  right: 1,
  top: 0,
  middle: 0.5,
  hanging: 0.2,
  alphabetic: 0.8,
  ideographic: 0.8,
  bottom: 1
};
class X_1 extends xc {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(e, n, i, s) {
    super(e, n, i, s), this.labels_ = null, this.text_ = "", this.textOffsetX_ = 0, this.textOffsetY_ = 0, this.textRotateWithView_ = void 0, this.textRotation_ = 0, this.textFillState_ = null, this.fillStates = {}, this.fillStates[s0] = { fillStyle: s0 }, this.textStrokeState_ = null, this.strokeStates = {}, this.textState_ = /** @type {import("../canvas.js").TextState} */
    {}, this.textStates = {}, this.textKey_ = "", this.fillKey_ = "", this.strokeKey_ = "", this.declutterMode_ = void 0, this.declutterImageWithText_ = void 0;
  }
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */
  finish() {
    const e = super.finish();
    return e.textStates = this.textStates, e.fillStates = this.fillStates, e.strokeStates = this.strokeStates, e;
  }
  /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */
  drawText(e, n, i) {
    const s = this.textFillState_, l = this.textStrokeState_, a = this.textState_;
    if (this.text_ === "" || !a || !s && !l)
      return;
    const o = this.coordinates;
    let h = o.length;
    const u = e.getType();
    let d = null, v = e.getStride();
    if (a.placement === "line" && (u == "LineString" || u == "MultiLineString" || u == "Polygon" || u == "MultiPolygon")) {
      if (!r0(this.maxExtent, e.getExtent()))
        return;
      let m;
      if (d = e.getFlatCoordinates(), u == "LineString")
        m = [d.length];
      else if (u == "MultiLineString")
        m = /** @type {import("../../geom/MultiLineString.js").default} */
        e.getEnds();
      else if (u == "Polygon")
        m = /** @type {import("../../geom/Polygon.js").default} */
        e.getEnds().slice(0, 1);
      else if (u == "MultiPolygon") {
        const M = (
          /** @type {import("../../geom/MultiPolygon.js").default} */
          e.getEndss()
        );
        m = [];
        for (let z = 0, b = M.length; z < b; ++z)
          m.push(M[z][0]);
      }
      this.beginGeometry(e, n, i);
      const p = a.repeat, _ = p ? void 0 : a.textAlign;
      let q = 0;
      for (let M = 0, z = m.length; M < z; ++M) {
        let b;
        p ? b = W_1(
          p * this.resolution,
          d,
          q,
          m[M],
          v
        ) : b = [d.slice(q, m[M])];
        for (let x = 0, k = b.length; x < k; ++x) {
          const F = b[x];
          let D = 0, R = F.length;
          if (_ == null) {
            const J = Y_1(
              a.maxAngle,
              F,
              0,
              F.length,
              2
            );
            D = J[0], R = J[1];
          }
          for (let J = D; J < R; J += v)
            o.push(F[J], F[J + 1]);
          const V = o.length;
          q = m[M], this.drawChars_(h, V), h = V;
        }
      }
      this.endGeometry(n);
    } else {
      let m = a.overflow ? null : [];
      switch (u) {
        case "Point":
        case "MultiPoint":
          d = /** @type {import("../../geom/MultiPoint.js").default} */
          e.getFlatCoordinates();
          break;
        case "LineString":
          d = /** @type {import("../../geom/LineString.js").default} */
          e.getFlatMidpoint();
          break;
        case "Circle":
          d = /** @type {import("../../geom/Circle.js").default} */
          e.getCenter();
          break;
        case "MultiLineString":
          d = /** @type {import("../../geom/MultiLineString.js").default} */
          e.getFlatMidpoints(), v = 2;
          break;
        case "Polygon":
          d = /** @type {import("../../geom/Polygon.js").default} */
          e.getFlatInteriorPoint(), a.overflow || m.push(d[2] / this.resolution), v = 3;
          break;
        case "MultiPolygon":
          const b = (
            /** @type {import("../../geom/MultiPolygon.js").default} */
            e.getFlatInteriorPoints()
          );
          d = [];
          for (let x = 0, k = b.length; x < k; x += 3)
            a.overflow || m.push(b[x + 2] / this.resolution), d.push(b[x], b[x + 1]);
          if (d.length === 0)
            return;
          v = 2;
          break;
      }
      const p = this.appendFlatPointCoordinates(d, v);
      if (p === h)
        return;
      if (m && (p - h) / 2 !== d.length / v) {
        let b = h / 2;
        m = m.filter((x, k) => {
          const F = o[(b + k) * 2] === d[k * v] && o[(b + k) * 2 + 1] === d[k * v + 1];
          return F || --b, F;
        });
      }
      this.saveTextStates_(), (a.backgroundFill || a.backgroundStroke) && (this.setFillStrokeStyle(
        a.backgroundFill,
        a.backgroundStroke
      ), a.backgroundFill && this.updateFillStyle(this.state, this.createFill), a.backgroundStroke && (this.updateStrokeStyle(this.state, this.applyStroke), this.hitDetectionInstructions.push(this.createStroke(this.state)))), this.beginGeometry(e, n, i);
      let _ = a.padding;
      if (_ != ir && (a.scale[0] < 0 || a.scale[1] < 0)) {
        let b = a.padding[0], x = a.padding[1], k = a.padding[2], F = a.padding[3];
        a.scale[0] < 0 && (x = -x, F = -F), a.scale[1] < 0 && (b = -b, k = -k), _ = [b, x, k, F];
      }
      const q = this.pixelRatio;
      this.instructions.push([
        p3.DRAW_IMAGE,
        h,
        p,
        null,
        NaN,
        NaN,
        NaN,
        1,
        0,
        0,
        this.textRotateWithView_,
        this.textRotation_,
        [1, 1],
        NaN,
        this.declutterMode_,
        this.declutterImageWithText_,
        _ == ir ? ir : _.map(function(b) {
          return b * q;
        }),
        !!a.backgroundFill,
        !!a.backgroundStroke,
        this.text_,
        this.textKey_,
        this.strokeKey_,
        this.fillKey_,
        this.textOffsetX_,
        this.textOffsetY_,
        m
      ]);
      const M = 1 / q, z = this.state.fillStyle;
      a.backgroundFill && (this.state.fillStyle = s0, this.hitDetectionInstructions.push(this.createFill(this.state))), this.hitDetectionInstructions.push([
        p3.DRAW_IMAGE,
        h,
        p,
        null,
        NaN,
        NaN,
        NaN,
        1,
        0,
        0,
        this.textRotateWithView_,
        this.textRotation_,
        [M, M],
        NaN,
        this.declutterMode_,
        this.declutterImageWithText_,
        _,
        !!a.backgroundFill,
        !!a.backgroundStroke,
        this.text_,
        this.textKey_,
        this.strokeKey_,
        this.fillKey_ ? s0 : this.fillKey_,
        this.textOffsetX_,
        this.textOffsetY_,
        m
      ]), a.backgroundFill && (this.state.fillStyle = z, this.hitDetectionInstructions.push(this.createFill(this.state))), this.endGeometry(n);
    }
  }
  /**
   * @private
   */
  saveTextStates_() {
    const e = this.textStrokeState_, n = this.textState_, i = this.textFillState_, s = this.strokeKey_;
    e && (s in this.strokeStates || (this.strokeStates[s] = {
      strokeStyle: e.strokeStyle,
      lineCap: e.lineCap,
      lineDashOffset: e.lineDashOffset,
      lineWidth: e.lineWidth,
      lineJoin: e.lineJoin,
      miterLimit: e.miterLimit,
      lineDash: e.lineDash
    }));
    const l = this.textKey_;
    l in this.textStates || (this.textStates[l] = {
      font: n.font,
      textAlign: n.textAlign || Qo,
      justify: n.justify,
      textBaseline: n.textBaseline || Kh,
      scale: n.scale
    });
    const a = this.fillKey_;
    i && (a in this.fillStates || (this.fillStates[a] = {
      fillStyle: i.fillStyle
    }));
  }
  /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */
  drawChars_(e, n) {
    const i = this.textStrokeState_, s = this.textState_, l = this.strokeKey_, a = this.textKey_, o = this.fillKey_;
    this.saveTextStates_();
    const h = this.pixelRatio, u = eu[s.textBaseline], d = this.textOffsetY_ * h, v = this.text_, m = i ? i.lineWidth * Math.abs(s.scale[0]) / 2 : 0;
    this.instructions.push([
      p3.DRAW_CHARS,
      e,
      n,
      u,
      s.overflow,
      o,
      s.maxAngle,
      h,
      d,
      l,
      m * h,
      v,
      a,
      1,
      this.declutterMode_
    ]), this.hitDetectionInstructions.push([
      p3.DRAW_CHARS,
      e,
      n,
      u,
      s.overflow,
      o && s0,
      s.maxAngle,
      h,
      d,
      l,
      m * h,
      v,
      a,
      1 / h,
      this.declutterMode_
    ]);
  }
  /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */
  setTextStyle(e, n) {
    let i, s, l;
    if (!e)
      this.text_ = "";
    else {
      const a = e.getFill();
      a ? (s = this.textFillState_, s || (s = /** @type {import("../canvas.js").FillState} */
      {}, this.textFillState_ = s), s.fillStyle = Xn(
        a.getColor() || s0
      )) : (s = null, this.textFillState_ = s);
      const o = e.getStroke();
      if (!o)
        l = null, this.textStrokeState_ = l;
      else {
        l = this.textStrokeState_, l || (l = /** @type {import("../canvas.js").StrokeState} */
        {}, this.textStrokeState_ = l);
        const _ = o.getLineDash(), q = o.getLineDashOffset(), M = o.getWidth(), z = o.getMiterLimit();
        l.lineCap = o.getLineCap() || Wa, l.lineDash = _ ? _.slice() : g8, l.lineDashOffset = q === void 0 ? y8 : q, l.lineJoin = o.getLineJoin() || Ya, l.lineWidth = M === void 0 ? ec : M, l.miterLimit = z === void 0 ? Zo : z, l.strokeStyle = Xn(
          o.getColor() || Jo
        );
      }
      i = this.textState_;
      const h = e.getFont() || iC;
      My1(h);
      const u = e.getScaleArray();
      i.overflow = e.getOverflow(), i.font = h, i.maxAngle = e.getMaxAngle(), i.placement = e.getPlacement(), i.textAlign = e.getTextAlign(), i.repeat = e.getRepeat(), i.justify = e.getJustify(), i.textBaseline = e.getTextBaseline() || Kh, i.backgroundFill = e.getBackgroundFill(), i.backgroundStroke = e.getBackgroundStroke(), i.padding = e.getPadding() || ir, i.scale = u === void 0 ? [1, 1] : u;
      const d = e.getOffsetX(), v = e.getOffsetY(), m = e.getRotateWithView(), p = e.getRotation();
      this.text_ = e.getText() || "", this.textOffsetX_ = d === void 0 ? 0 : d, this.textOffsetY_ = v === void 0 ? 0 : v, this.textRotateWithView_ = m === void 0 ? !1 : m, this.textRotation_ = p === void 0 ? 0 : p, this.strokeKey_ = l ? (typeof l.strokeStyle == "string" ? l.strokeStyle : Be(l.strokeStyle)) + l.lineCap + l.lineDashOffset + "|" + l.lineWidth + l.lineJoin + l.miterLimit + "[" + l.lineDash.join() + "]" : "", this.textKey_ = i.font + i.scale + (i.textAlign || "?") + (i.repeat || "?") + (i.justify || "?") + (i.textBaseline || "?"), this.fillKey_ = s && s.fillStyle ? typeof s.fillStyle == "string" ? s.fillStyle : "|" + Be(s.fillStyle) : "";
    }
    this.declutterMode_ = e.getDeclutterMode(), this.declutterImageWithText_ = n;
  }
}
const K_1 = {
  Circle: eM,
  Default: xc,
  Image: $_1,
  LineString: j_1,
  Polygon: eM,
  Text: X_1
};
class Z_1 {
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */
  constructor(e, n, i, s) {
    this.tolerance_ = e, this.maxExtent_ = n, this.pixelRatio_ = s, this.resolution_ = i, this.buildersByZIndex_ = {};
  }
  /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */
  finish() {
    const e = {};
    for (const n in this.buildersByZIndex_) {
      e[n] = e[n] || {};
      const i = this.buildersByZIndex_[n];
      for (const s in i) {
        const l = i[s].finish();
        e[n][s] = l;
      }
    }
    return e;
  }
  /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */
  getBuilder(e, n) {
    const i = e !== void 0 ? e.toString() : "0";
    let s = this.buildersByZIndex_[i];
    s === void 0 && (s = {}, this.buildersByZIndex_[i] = s);
    let l = s[n];
    if (l === void 0) {
      const a = K_1[n];
      l = new a(
        this.tolerance_,
        this.maxExtent_,
        this.resolution_,
        this.pixelRatio_
      ), s[n] = l;
    }
    return l;
  }
}
const J_1 = Z_1, Q_1 = 5;
class eq1 extends TS {
  /**
   * @param {LayerType} layer Layer.
   */
  constructor(e) {
    super(), this.ready = !0, this.boundHandleImageChange_ = this.handleImageChange_.bind(this), this.layer_ = e, this.staleKeys_ = new Array(), this.maxStaleKeys = Q_1;
  }
  /**
   * @return {Array<string>} Get the list of stale keys.
   */
  getStaleKeys() {
    return this.staleKeys_;
  }
  /**
   * @param {string} key The new stale key.
   */
  prependStaleKey(e) {
    this.staleKeys_.unshift(e), this.staleKeys_.length > this.maxStaleKeys && (this.staleKeys_.length = this.maxStaleKeys);
  }
  /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */
  getFeatures(e) {
    return b3();
  }
  /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */
  getData(e) {
    return null;
  }
  /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */
  prepareFrame(e) {
    return b3();
  }
  /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */
  renderFrame(e, n) {
    return b3();
  }
  /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */
  forEachFeatureAtCoordinate(e, n, i, s, l) {
  }
  /**
   * @return {LayerType} Layer.
   */
  getLayer() {
    return this.layer_;
  }
  /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */
  handleFontsChanged() {
  }
  /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */
  handleImageChange_(e) {
    const n = (
      /** @type {import("../Image.js").default} */
      e.target
    );
    (n.getState() === Y3.LOADED || n.getState() === Y3.ERROR) && this.renderIfReadyAndVisible();
  }
  /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */
  loadImage(e) {
    let n = e.getState();
    return n != Y3.LOADED && n != Y3.ERROR && e.addEventListener(T3.CHANGE, this.boundHandleImageChange_), n == Y3.IDLE && (e.load(), n = e.getState()), n == Y3.LOADED;
  }
  /**
   * @protected
   */
  renderIfReadyAndVisible() {
    const e = this.getLayer();
    e && e.getVisible() && e.getSourceState() === "ready" && e.changed();
  }
  /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  renderDeferred(e) {
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    delete this.layer_, super.disposeInternal();
  }
}
const tq1 = eq1;
class nq1 extends k8 {
  /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */
  constructor(e, n, i, s) {
    super(e), this.inversePixelTransform = n, this.frameState = i, this.context = s;
  }
}
const qC = nq1;
class iq1 {
  constructor() {
    /**
     * @private
     * @param {...*} args Args.
     * @return {ZIndexContext} This.
     */
    O2(this, "pushMethodArgs_", (...e) => (this.instructions_[this.zIndex + this.offset_].push(e), this));
    this.instructions_ = [], this.zIndex = 0, this.offset_ = 0, this.context_ = /** @type {ZIndexContextProxy} */
    new Proxy(Wh(), {
      get: (e, n) => {
        if (typeof /** @type {*} */
        Wh()[n] == "function")
          return this.instructions_[this.zIndex + this.offset_] || (this.instructions_[this.zIndex + this.offset_] = []), this.instructions_[this.zIndex + this.offset_].push(n), this.pushMethodArgs_;
      },
      set: (e, n, i) => (this.instructions_[this.zIndex + this.offset_] || (this.instructions_[this.zIndex + this.offset_] = []), this.instructions_[this.zIndex + this.offset_].push(n, i), !0)
    });
  }
  /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */
  pushFunction(e) {
    this.instructions_[this.zIndex + this.offset_].push(e);
  }
  /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */
  getContext() {
    return this.context_;
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   */
  draw(e) {
    this.instructions_.forEach((n) => {
      for (let i = 0, s = n.length; i < s; ++i) {
        const l = n[i];
        if (typeof l == "function") {
          l(e);
          continue;
        }
        const a = n[++i];
        if (typeof /** @type {*} */
        e[l] == "function")
          e[l](...a);
        else {
          if (typeof a == "function") {
            e[l] = a(e);
            continue;
          }
          e[l] = a;
        }
      }
    });
  }
  clear() {
    this.instructions_.length = 0, this.zIndex = 0, this.offset_ = 0;
  }
  /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */
  offset() {
    this.offset_ = this.instructions_.length, this.zIndex = 0;
  }
}
const wC = iq1, tM = [];
let aa = null;
function sq1() {
  aa = u4(1, 1, void 0, {
    willReadFrequently: !0
  });
}
class lq1 extends tq1 {
  /**
   * @param {LayerType} layer Layer.
   */
  constructor(e) {
    super(e), this.container = null, this.renderedResolution, this.tempTransform = hn(), this.pixelTransform = hn(), this.inversePixelTransform = hn(), this.context = null, this.deferredContext_ = null, this.containerReused = !1, this.frameState = null;
  }
  /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */
  getImageData(e, n, i) {
    aa || sq1(), aa.clearRect(0, 0, 1, 1);
    let s;
    try {
      aa.drawImage(e, n, i, 1, 1, 0, 0, 1, 1), s = aa.getImageData(0, 0, 1, 1).data;
    } catch {
      return aa = null, null;
    }
    return s;
  }
  /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */
  getBackground(e) {
    let i = this.getLayer().getBackground();
    return typeof i == "function" && (i = i(e.viewState.resolution)), i || void 0;
  }
  /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS Transform.
   * @param {string} [backgroundColor] Background color.
   */
  useContainer(e, n, i) {
    const s = this.getLayer().getClassName();
    let l, a;
    if (e && e.className === s && (!i || e && e.style.backgroundColor && Ws(
      Ko(e.style.backgroundColor),
      Ko(i)
    ))) {
      const o = e.firstElementChild;
      o instanceof HTMLCanvasElement && (a = o.getContext("2d"));
    }
    if (a && a.canvas.style.transform === n ? (this.container = e, this.context = a, this.containerReused = !0) : this.containerReused ? (this.container = null, this.context = null, this.containerReused = !1) : this.container && (this.container.style.backgroundColor = null), !this.container) {
      l = document.createElement("div"), l.className = s;
      let o = l.style;
      o.position = "absolute", o.width = "100%", o.height = "100%", a = u4();
      const h = a.canvas;
      l.appendChild(h), o = h.style, o.position = "absolute", o.left = "0", o.transformOrigin = "top left", this.container = l, this.context = a;
    }
    !this.containerReused && i && !this.container.style.backgroundColor && (this.container.style.backgroundColor = i);
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */
  clipUnrotated(e, n, i) {
    const s = Lr(i), l = Du(i), a = Hu(i), o = Ru(i);
    j4(n.coordinateToPixelTransform, s), j4(n.coordinateToPixelTransform, l), j4(n.coordinateToPixelTransform, a), j4(n.coordinateToPixelTransform, o);
    const h = this.inversePixelTransform;
    j4(h, s), j4(h, l), j4(h, a), j4(h, o), e.save(), e.beginPath(), e.moveTo(Math.round(s[0]), Math.round(s[1])), e.lineTo(Math.round(l[0]), Math.round(l[1])), e.lineTo(Math.round(a[0]), Math.round(a[1])), e.lineTo(Math.round(o[0]), Math.round(o[1])), e.clip();
  }
  /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */
  prepareContainer(e, n) {
    const i = e.extent, s = e.viewState.resolution, l = e.viewState.rotation, a = e.pixelRatio, o = Math.round(ue(i) / s * a), h = Math.round(G4(i) / s * a);
    b8(
      this.pixelTransform,
      e.size[0] / 2,
      e.size[1] / 2,
      1 / a,
      1 / a,
      l,
      -o / 2,
      -h / 2
    ), IS(this.inversePixelTransform, this.pixelTransform);
    const u = Ng1(this.pixelTransform);
    if (this.useContainer(n, u, this.getBackground(e)), !this.containerReused) {
      const d = this.context.canvas;
      d.width != o || d.height != h ? (d.width = o, d.height = h) : this.context.clearRect(0, 0, o, h), u !== d.style.transform && (d.style.transform = u);
    }
  }
  /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */
  dispatchRenderEvent_(e, n, i) {
    const s = this.getLayer();
    if (s.hasListener(e)) {
      const l = new qC(
        e,
        this.inversePixelTransform,
        i,
        n
      );
      s.dispatchEvent(l);
    }
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  preRender(e, n) {
    this.frameState = n, !n.declutter && this.dispatchRenderEvent_(M6.PRERENDER, e, n);
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  postRender(e, n) {
    n.declutter || this.dispatchRenderEvent_(M6.POSTRENDER, e, n);
  }
  /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */
  renderDeferredInternal(e) {
  }
  /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */
  getRenderContext(e) {
    return e.declutter && !this.deferredContext_ && (this.deferredContext_ = new wC()), e.declutter ? this.deferredContext_.getContext() : this.context;
  }
  /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */
  renderDeferred(e) {
    e.declutter && (this.dispatchRenderEvent_(
      M6.PRERENDER,
      this.context,
      e
    ), e.declutter && this.deferredContext_ && (this.deferredContext_.draw(this.context), this.deferredContext_.clear()), this.renderDeferredInternal(e), this.dispatchRenderEvent_(
      M6.POSTRENDER,
      this.context,
      e
    ));
  }
  /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */
  getRenderTransform(e, n, i, s, l, a, o) {
    const h = l / 2, u = a / 2, d = s / n, v = -d, m = -e[0] + o, p = -e[1];
    return b8(
      this.tempTransform,
      h,
      u,
      d,
      v,
      -i,
      m,
      p
    );
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    delete this.frameState, super.disposeInternal();
  }
}
const zC = lq1;
function rq1(t, e, n, i, s, l, a, o, h, u, d, v) {
  let m = t[e], p = t[e + 1], _ = 0, q = 0, M = 0, z = 0;
  function b() {
    _ = m, q = p, e += i, m = t[e], p = t[e + 1], z += M, M = Math.sqrt((m - _) * (m - _) + (p - q) * (p - q));
  }
  do
    b();
  while (e < n - i && z + M < l);
  let x = M === 0 ? 0 : (l - z) / M;
  const k = V0(_, m, x), F = V0(q, p, x), D = e - i, R = z, V = l + o * h(u, s, d);
  for (; e < n - i && z + M < V; )
    b();
  x = M === 0 ? 0 : (V - z) / M;
  const J = V0(_, m, x), K = V0(q, p, x);
  let P;
  if (v) {
    const i1 = [k, F, J, K];
    OS(i1, 0, 4, 2, v, i1, i1), P = i1[0] > i1[2];
  } else
    P = k > J;
  const O = Math.PI, G = [], j = D + i === e;
  e = D, M = 0, z = R, m = t[e], p = t[e + 1];
  let Q;
  if (j) {
    b(), Q = Math.atan2(p - q, m - _), P && (Q += Q > 0 ? -O : O);
    const i1 = (J + k) / 2, h1 = (K + F) / 2;
    return G[0] = [i1, h1, (V - l) / 2, Q, s], G;
  }
  s = s.replace(/\n/g, " ");
  for (let i1 = 0, h1 = s.length; i1 < h1; ) {
    b();
    let c1 = Math.atan2(p - q, m - _);
    if (P && (c1 += c1 > 0 ? -O : O), Q !== void 0) {
      let n1 = c1 - Q;
      if (n1 += n1 > O ? -2 * O : n1 < -O ? 2 * O : 0, Math.abs(n1) > a)
        return null;
    }
    Q = c1;
    const M1 = i1;
    let y1 = 0;
    for (; i1 < h1; ++i1) {
      const n1 = P ? h1 - i1 - 1 : i1, f1 = o * h(u, s[n1], d);
      if (e + i < n && z + M < l + y1 + f1 / 2)
        break;
      y1 += f1;
    }
    if (i1 === M1)
      continue;
    const A1 = P ? s.substring(h1 - M1, h1 - i1) : s.substring(M1, i1);
    x = M === 0 ? 0 : (l + y1 / 2 - z) / M;
    const $ = V0(_, m, x), a1 = V0(q, p, x);
    G.push([$, a1, y1 / 2, c1, A1]), l += y1;
  }
  return G;
}
const Xr = U0(), as = [], i8 = [], s8 = [], os = [];
function nM(t) {
  return t[3].declutterBox;
}
const iM = new RegExp(
  /* eslint-disable prettier/prettier */
  "[" + String.fromCharCode(1425) + "-" + String.fromCharCode(2303) + String.fromCharCode(64285) + "-" + String.fromCharCode(65023) + String.fromCharCode(65136) + "-" + String.fromCharCode(65276) + String.fromCharCode(67584) + "-" + String.fromCharCode(69631) + String.fromCharCode(124928) + "-" + String.fromCharCode(126975) + "]"
  /* eslint-enable prettier/prettier */
);
function Og(t, e) {
  return e === "start" ? e = iM.test(t) ? "right" : "left" : e === "end" && (e = iM.test(t) ? "left" : "right"), eu[e];
}
function aq1(t, e, n) {
  return n > 0 && t.push(`
`, ""), t.push(e, ""), t;
}
class oq1 {
  /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */
  constructor(e, n, i, s, l) {
    this.overlaps = i, this.pixelRatio = n, this.resolution = e, this.alignAndScaleFill_, this.instructions = s.instructions, this.coordinates = s.coordinates, this.coordinateCache_ = {}, this.renderedTransform_ = hn(), this.hitDetectionInstructions = s.hitDetectionInstructions, this.pixelCoordinates_ = null, this.viewRotation_ = 0, this.fillStates = s.fillStates || {}, this.strokeStates = s.strokeStates || {}, this.textStates = s.textStates || {}, this.widths_ = {}, this.labels_ = {}, this.zIndexContext_ = l ? new wC() : null;
  }
  /**
   * @return {ZIndexContext} ZIndex context.
   */
  getZIndexContext() {
    return this.zIndexContext_;
  }
  /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */
  createLabel(e, n, i, s) {
    const l = e + n + i + s;
    if (this.labels_[l])
      return this.labels_[l];
    const a = s ? this.strokeStates[s] : null, o = i ? this.fillStates[i] : null, h = this.textStates[n], u = this.pixelRatio, d = [
      h.scale[0] * u,
      h.scale[1] * u
    ], v = h.justify ? eu[h.justify] : Og(
      Array.isArray(e) ? e[0] : e,
      h.textAlign || Qo
    ), m = s && a.lineWidth ? a.lineWidth : 0, p = Array.isArray(e) ? e : String(e).split(`
`).reduce(aq1, []), { width: _, height: q, widths: M, heights: z, lineWidths: b } = Ly1(
      h,
      p
    ), x = _ + m, k = [], F = (x + 2) * d[0], D = (q + m) * d[1], R = {
      width: F < 0 ? Math.floor(F) : Math.ceil(F),
      height: D < 0 ? Math.floor(D) : Math.ceil(D),
      contextInstructions: k
    };
    (d[0] != 1 || d[1] != 1) && k.push("scale", d), s && (k.push("strokeStyle", a.strokeStyle), k.push("lineWidth", m), k.push("lineCap", a.lineCap), k.push("lineJoin", a.lineJoin), k.push("miterLimit", a.miterLimit), k.push("setLineDash", [a.lineDash]), k.push("lineDashOffset", a.lineDashOffset)), i && k.push("fillStyle", o.fillStyle), k.push("textBaseline", "middle"), k.push("textAlign", "center");
    const V = 0.5 - v;
    let J = v * x + V * m;
    const K = [], P = [];
    let O = 0, G = 0, j = 0, Q = 0, i1;
    for (let h1 = 0, c1 = p.length; h1 < c1; h1 += 2) {
      const M1 = p[h1];
      if (M1 === `
`) {
        G += O, O = 0, J = v * x + V * m, ++Q;
        continue;
      }
      const y1 = p[h1 + 1] || h.font;
      y1 !== i1 && (s && K.push("font", y1), i && P.push("font", y1), i1 = y1), O = Math.max(O, z[j]);
      const A1 = [
        M1,
        J + V * M[j] + v * (M[j] - b[Q]),
        0.5 * (m + O) + G
      ];
      J += M[j], s && K.push("strokeText", A1), i && P.push("fillText", A1), ++j;
    }
    return Array.prototype.push.apply(k, K), Array.prototype.push.apply(k, P), this.labels_[l] = R, R;
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */
  replayTextBackground_(e, n, i, s, l, a, o) {
    e.beginPath(), e.moveTo.apply(e, n), e.lineTo.apply(e, i), e.lineTo.apply(e, s), e.lineTo.apply(e, l), e.lineTo.apply(e, n), a && (this.alignAndScaleFill_ = /** @type {number} */
    a[2], this.fill_(e)), o && (this.setStrokeStyle_(
      e,
      /** @type {Array<*>} */
      o
    ), e.stroke());
  }
  /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */
  calculateImageOrLabelDimensions_(e, n, i, s, l, a, o, h, u, d, v, m, p, _, q, M) {
    o *= m[0], h *= m[1];
    let z = i - o, b = s - h;
    const x = l + u > e ? e - u : l, k = a + d > n ? n - d : a, F = _[3] + x * m[0] + _[1], D = _[0] + k * m[1] + _[2], R = z - _[3], V = b - _[0];
    (q || v !== 0) && (as[0] = R, os[0] = R, as[1] = V, i8[1] = V, i8[0] = R + F, s8[0] = i8[0], s8[1] = V + D, os[1] = s8[1]);
    let J;
    return v !== 0 ? (J = b8(
      hn(),
      i,
      s,
      1,
      1,
      v,
      -i,
      -s
    ), j4(J, as), j4(J, i8), j4(J, s8), j4(J, os), M8(
      Math.min(as[0], i8[0], s8[0], os[0]),
      Math.min(as[1], i8[1], s8[1], os[1]),
      Math.max(as[0], i8[0], s8[0], os[0]),
      Math.max(as[1], i8[1], s8[1], os[1]),
      Xr
    )) : M8(
      Math.min(R, R + F),
      Math.min(V, V + D),
      Math.max(R, R + F),
      Math.max(V, V + D),
      Xr
    ), p && (z = Math.round(z), b = Math.round(b)), {
      drawImageX: z,
      drawImageY: b,
      drawImageW: x,
      drawImageH: k,
      originX: u,
      originY: d,
      declutterBox: {
        minX: Xr[0],
        minY: Xr[1],
        maxX: Xr[2],
        maxY: Xr[3],
        value: M
      },
      canvasTransform: J,
      scale: m
    };
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */
  replayImageOrLabel_(e, n, i, s, l, a, o) {
    const h = !!(a || o), u = s.declutterBox, d = o ? o[2] * s.scale[0] / 2 : 0;
    return u.minX - d <= n[0] && u.maxX + d >= 0 && u.minY - d <= n[1] && u.maxY + d >= 0 && (h && this.replayTextBackground_(
      e,
      as,
      i8,
      s8,
      os,
      /** @type {Array<*>} */
      a,
      /** @type {Array<*>} */
      o
    ), xy1(
      e,
      s.canvasTransform,
      l,
      i,
      s.originX,
      s.originY,
      s.drawImageW,
      s.drawImageH,
      s.drawImageX,
      s.drawImageY,
      s.scale
    )), !0;
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */
  fill_(e) {
    const n = this.alignAndScaleFill_;
    if (n) {
      const i = j4(this.renderedTransform_, [0, 0]), s = 512 * this.pixelRatio;
      e.save(), e.translate(i[0] % s, i[1] % s), n !== 1 && e.scale(n, n), e.rotate(this.viewRotation_);
    }
    e.fill(), n && e.restore();
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */
  setStrokeStyle_(e, n) {
    e.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */
    n[1], e.lineWidth = /** @type {number} */
    n[2], e.lineCap = /** @type {CanvasLineCap} */
    n[3], e.lineJoin = /** @type {CanvasLineJoin} */
    n[4], e.miterLimit = /** @type {number} */
    n[5], e.lineDashOffset = /** @type {number} */
    n[7], e.setLineDash(
      /** @type {Array<number>} */
      n[6]
    );
  }
  /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */
  drawLabelWithPointPlacement_(e, n, i, s) {
    const l = this.textStates[n], a = this.createLabel(e, n, s, i), o = this.strokeStates[i], h = this.pixelRatio, u = Og(
      Array.isArray(e) ? e[0] : e,
      l.textAlign || Qo
    ), d = eu[l.textBaseline || Kh], v = o && o.lineWidth ? o.lineWidth : 0, m = a.width / h - 2 * l.scale[0], p = u * m + 2 * (0.5 - u) * v, _ = d * a.height / h + 2 * (0.5 - d) * v;
    return {
      label: a,
      anchorX: p,
      anchorY: _
    };
  }
  /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */
  execute_(e, n, i, s, l, a, o, h) {
    const u = this.zIndexContext_;
    let d;
    this.pixelCoordinates_ && Ws(i, this.renderedTransform_) ? d = this.pixelCoordinates_ : (this.pixelCoordinates_ || (this.pixelCoordinates_ = []), d = Cs(
      this.coordinates,
      0,
      this.coordinates.length,
      2,
      i,
      this.pixelCoordinates_
    ), Ig1(this.renderedTransform_, i));
    let v = 0;
    const m = s.length;
    let p = 0, _, q, M, z, b, x, k, F, D, R, V, J, K, P = 0, O = 0, G = null, j = null;
    const Q = this.coordinateCache_, i1 = this.viewRotation_, h1 = Math.round(Math.atan2(-i[1], i[0]) * 1e12) / 1e12, c1 = (
      /** @type {import("../../render.js").State} */
      {
        context: e,
        pixelRatio: this.pixelRatio,
        resolution: this.resolution,
        rotation: i1
      }
    ), M1 = this.instructions != s || this.overlaps ? 0 : 200;
    let y1, A1, $, a1;
    for (; v < m; ) {
      const n1 = s[v];
      switch (
        /** @type {import("./Instruction.js").default} */
        n1[0]
      ) {
        case p3.BEGIN_GEOMETRY:
          y1 = /** @type {import("../../Feature.js").FeatureLike} */
          n1[1], a1 = n1[3], y1.getGeometry() ? o !== void 0 && !r0(o, a1.getExtent()) ? v = /** @type {number} */
          n1[2] + 1 : ++v : v = /** @type {number} */
          n1[2], u && (u.zIndex = n1[4]);
          break;
        case p3.BEGIN_PATH:
          P > M1 && (this.fill_(e), P = 0), O > M1 && (e.stroke(), O = 0), !P && !O && (e.beginPath(), b = NaN, x = NaN), ++v;
          break;
        case p3.CIRCLE:
          p = /** @type {number} */
          n1[1];
          const w1 = d[p], C1 = d[p + 1], E1 = d[p + 2], T1 = d[p + 3], n2 = E1 - w1, X1 = T1 - C1, a2 = Math.sqrt(n2 * n2 + X1 * X1);
          e.moveTo(w1 + a2, C1), e.arc(w1, C1, a2, 0, 2 * Math.PI, !0), ++v;
          break;
        case p3.CLOSE_PATH:
          e.closePath(), ++v;
          break;
        case p3.CUSTOM:
          p = /** @type {number} */
          n1[1], _ = n1[2];
          const d2 = (
            /** @type {import("../../geom/SimpleGeometry.js").default} */
            n1[3]
          ), y2 = n1[4], B1 = n1[5];
          c1.geometry = d2, c1.feature = y1, v in Q || (Q[v] = []);
          const p1 = Q[v];
          B1 ? B1(d, p, _, 2, p1) : (p1[0] = d[p], p1[1] = d[p + 1], p1.length = 2), u && (u.zIndex = n1[6]), y2(p1, c1), ++v;
          break;
        case p3.DRAW_IMAGE:
          p = /** @type {number} */
          n1[1], _ = /** @type {number} */
          n1[2], D = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */
          n1[3], q = /** @type {number} */
          n1[4], M = /** @type {number} */
          n1[5];
          let _2 = (
            /** @type {number} */
            n1[6]
          );
          const w2 = (
            /** @type {number} */
            n1[7]
          ), K1 = (
            /** @type {number} */
            n1[8]
          ), e2 = (
            /** @type {number} */
            n1[9]
          ), Z1 = (
            /** @type {boolean} */
            n1[10]
          );
          let t2 = (
            /** @type {number} */
            n1[11]
          );
          const S2 = (
            /** @type {import("../../size.js").Size} */
            n1[12]
          );
          let W2 = (
            /** @type {number} */
            n1[13]
          );
          z = n1[14] || "declutter";
          const E2 = (
            /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */
            n1[15]
          );
          if (!D && n1.length >= 20) {
            R = /** @type {string} */
            n1[19], V = /** @type {string} */
            n1[20], J = /** @type {string} */
            n1[21], K = /** @type {string} */
            n1[22];
            const yt = this.drawLabelWithPointPlacement_(
              R,
              V,
              J,
              K
            );
            D = yt.label, n1[3] = D;
            const Ce = (
              /** @type {number} */
              n1[23]
            );
            q = (yt.anchorX - Ce) * this.pixelRatio, n1[4] = q;
            const tt = (
              /** @type {number} */
              n1[24]
            );
            M = (yt.anchorY - tt) * this.pixelRatio, n1[5] = M, _2 = D.height, n1[6] = _2, W2 = D.width, n1[13] = W2;
          }
          let o3;
          n1.length > 25 && (o3 = /** @type {number} */
          n1[25]);
          let n3, c3, G2;
          n1.length > 17 ? (n3 = /** @type {Array<number>} */
          n1[16], c3 = /** @type {boolean} */
          n1[17], G2 = /** @type {boolean} */
          n1[18]) : (n3 = ir, c3 = !1, G2 = !1), Z1 && h1 ? t2 += i1 : !Z1 && !h1 && (t2 -= i1);
          let u3 = 0;
          for (; p < _; p += 2) {
            if (o3 && o3[u3++] < W2 / this.pixelRatio)
              continue;
            const yt = this.calculateImageOrLabelDimensions_(
              D.width,
              D.height,
              d[p],
              d[p + 1],
              W2,
              _2,
              q,
              M,
              K1,
              e2,
              t2,
              S2,
              l,
              n3,
              c3 || G2,
              y1
            ), Ce = [
              e,
              n,
              D,
              yt,
              w2,
              c3 ? (
                /** @type {Array<*>} */
                G
              ) : null,
              G2 ? (
                /** @type {Array<*>} */
                j
              ) : null
            ];
            if (h) {
              let tt, ut, D2;
              if (E2) {
                const L3 = _ - p;
                if (!E2[L3]) {
                  E2[L3] = { args: Ce, declutterMode: z };
                  continue;
                }
                const W3 = E2[L3];
                tt = W3.args, ut = W3.declutterMode, delete E2[L3], D2 = nM(tt);
              }
              let Re, _t;
              if (tt && (ut !== "declutter" || !h.collides(D2)) && (Re = !0), (z !== "declutter" || !h.collides(yt.declutterBox)) && (_t = !0), ut === "declutter" && z === "declutter") {
                const L3 = Re && _t;
                Re = L3, _t = L3;
              }
              Re && (ut !== "none" && h.insert(D2), this.replayImageOrLabel_.apply(this, tt)), _t && (z !== "none" && h.insert(yt.declutterBox), this.replayImageOrLabel_.apply(this, Ce));
            } else
              this.replayImageOrLabel_.apply(this, Ce);
          }
          ++v;
          break;
        case p3.DRAW_CHARS:
          const g2 = (
            /** @type {number} */
            n1[1]
          ), Oe = (
            /** @type {number} */
            n1[2]
          ), q3 = (
            /** @type {number} */
            n1[3]
          ), ht = (
            /** @type {number} */
            n1[4]
          );
          K = /** @type {string} */
          n1[5];
          const E3 = (
            /** @type {number} */
            n1[6]
          ), j3 = (
            /** @type {number} */
            n1[7]
          ), z2 = (
            /** @type {number} */
            n1[8]
          );
          J = /** @type {string} */
          n1[9];
          const R2 = (
            /** @type {number} */
            n1[10]
          );
          R = /** @type {string} */
          n1[11], V = /** @type {string} */
          n1[12];
          const w3 = [
            /** @type {number} */
            n1[13],
            /** @type {number} */
            n1[13]
          ];
          z = n1[14] || "declutter";
          const B3 = this.textStates[V], G3 = B3.font, Se = [
            B3.scale[0] * j3,
            B3.scale[1] * j3
          ];
          let _e;
          G3 in this.widths_ ? _e = this.widths_[G3] : (_e = {}, this.widths_[G3] = _e);
          const d3 = eC(d, g2, Oe, 2), Z3 = Math.abs(Se[0]) * Vz(G3, R, _e);
          if (ht || Z3 <= d3) {
            const yt = this.textStates[V].textAlign, Ce = (d3 - Z3) * Og(R, yt), tt = rq1(
              d,
              g2,
              Oe,
              2,
              R,
              Ce,
              E3,
              Math.abs(Se[0]),
              Vz,
              G3,
              _e,
              h1 ? 0 : this.viewRotation_
            );
            e:
              if (tt) {
                const ut = [];
                let D2, Re, _t, L3, W3;
                if (J)
                  for (D2 = 0, Re = tt.length; D2 < Re; ++D2) {
                    W3 = tt[D2], _t = /** @type {string} */
                    W3[4], L3 = this.createLabel(_t, V, "", J), q = /** @type {number} */
                    W3[2] + (Se[0] < 0 ? -R2 : R2), M = q3 * L3.height + (0.5 - q3) * 2 * R2 * Se[1] / Se[0] - z2;
                    const oe = this.calculateImageOrLabelDimensions_(
                      L3.width,
                      L3.height,
                      W3[0],
                      W3[1],
                      L3.width,
                      L3.height,
                      q,
                      M,
                      0,
                      0,
                      W3[3],
                      w3,
                      !1,
                      ir,
                      !1,
                      y1
                    );
                    if (h && z === "declutter" && h.collides(oe.declutterBox))
                      break e;
                    ut.push([
                      e,
                      n,
                      L3,
                      oe,
                      1,
                      null,
                      null
                    ]);
                  }
                if (K)
                  for (D2 = 0, Re = tt.length; D2 < Re; ++D2) {
                    W3 = tt[D2], _t = /** @type {string} */
                    W3[4], L3 = this.createLabel(_t, V, K, ""), q = /** @type {number} */
                    W3[2], M = q3 * L3.height - z2;
                    const oe = this.calculateImageOrLabelDimensions_(
                      L3.width,
                      L3.height,
                      W3[0],
                      W3[1],
                      L3.width,
                      L3.height,
                      q,
                      M,
                      0,
                      0,
                      W3[3],
                      w3,
                      !1,
                      ir,
                      !1,
                      y1
                    );
                    if (h && z === "declutter" && h.collides(oe.declutterBox))
                      break e;
                    ut.push([
                      e,
                      n,
                      L3,
                      oe,
                      1,
                      null,
                      null
                    ]);
                  }
                h && z !== "none" && h.load(ut.map(nM));
                for (let oe = 0, v4 = ut.length; oe < v4; ++oe)
                  this.replayImageOrLabel_.apply(this, ut[oe]);
              }
          }
          ++v;
          break;
        case p3.END_GEOMETRY:
          if (a !== void 0) {
            y1 = /** @type {import("../../Feature.js").FeatureLike} */
            n1[1];
            const yt = a(
              y1,
              a1,
              z
            );
            if (yt)
              return yt;
          }
          ++v;
          break;
        case p3.FILL:
          M1 ? P++ : this.fill_(e), ++v;
          break;
        case p3.MOVE_TO_LINE_TO:
          for (p = /** @type {number} */
          n1[1], _ = /** @type {number} */
          n1[2], A1 = d[p], $ = d[p + 1], e.moveTo(A1, $), b = A1 + 0.5 | 0, x = $ + 0.5 | 0, p += 2; p < _; p += 2)
            A1 = d[p], $ = d[p + 1], k = A1 + 0.5 | 0, F = $ + 0.5 | 0, (p == _ - 2 || k !== b || F !== x) && (e.lineTo(A1, $), b = k, x = F);
          ++v;
          break;
        case p3.SET_FILL_STYLE:
          G = n1, this.alignAndScaleFill_ = n1[2], P && (this.fill_(e), P = 0, O && (e.stroke(), O = 0)), e.fillStyle = n1[1], ++v;
          break;
        case p3.SET_STROKE_STYLE:
          j = n1, O && (e.stroke(), O = 0), this.setStrokeStyle_(
            e,
            /** @type {Array<*>} */
            n1
          ), ++v;
          break;
        case p3.STROKE:
          M1 ? O++ : e.stroke(), ++v;
          break;
        default:
          ++v;
          break;
      }
    }
    P && this.fill_(e), O && e.stroke();
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */
  execute(e, n, i, s, l, a) {
    this.viewRotation_ = s, this.execute_(
      e,
      n,
      i,
      this.instructions,
      l,
      void 0,
      void 0,
      a
    );
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */
  executeHitDetection(e, n, i, s, l) {
    return this.viewRotation_ = i, this.execute_(
      e,
      [e.canvas.width, e.canvas.height],
      n,
      this.hitDetectionInstructions,
      !0,
      s,
      l
    );
  }
}
const cq1 = oq1, ma = [
  "Polygon",
  "Circle",
  "LineString",
  "Image",
  "Text",
  "Default"
], MC = ["Image", "Text"], hq1 = ma.filter(
  (t) => !MC.includes(t)
);
class uq1 {
  /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */
  constructor(e, n, i, s, l, a, o) {
    this.maxExtent_ = e, this.overlaps_ = s, this.pixelRatio_ = i, this.resolution_ = n, this.renderBuffer_ = a, this.executorsByZIndex_ = {}, this.hitDetectionContext_ = null, this.hitDetectionTransform_ = hn(), this.renderedContext_ = null, this.deferredZIndexContexts_ = {}, this.createExecutors_(l, o);
  }
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */
  clip(e, n) {
    const i = this.getClipCoords(n);
    e.beginPath(), e.moveTo(i[0], i[1]), e.lineTo(i[2], i[3]), e.lineTo(i[4], i[5]), e.lineTo(i[6], i[7]), e.clip();
  }
  /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */
  createExecutors_(e, n) {
    for (const i in e) {
      let s = this.executorsByZIndex_[i];
      s === void 0 && (s = {}, this.executorsByZIndex_[i] = s);
      const l = e[i];
      for (const a in l) {
        const o = l[a];
        s[a] = new cq1(
          this.resolution_,
          this.pixelRatio_,
          this.overlaps_,
          o,
          n
        );
      }
    }
  }
  /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */
  hasExecutors(e) {
    for (const n in this.executorsByZIndex_) {
      const i = this.executorsByZIndex_[n];
      for (let s = 0, l = e.length; s < l; ++s)
        if (e[s] in i)
          return !0;
    }
    return !1;
  }
  /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */
  forEachFeatureAtCoordinate(e, n, i, s, l, a) {
    s = Math.round(s);
    const o = s * 2 + 1, h = b8(
      this.hitDetectionTransform_,
      s + 0.5,
      s + 0.5,
      1 / n,
      -1 / n,
      -i,
      -e[0],
      -e[1]
    ), u = !this.hitDetectionContext_;
    u && (this.hitDetectionContext_ = u4(
      o,
      o,
      void 0,
      { willReadFrequently: !0 }
    ));
    const d = this.hitDetectionContext_;
    d.canvas.width !== o || d.canvas.height !== o ? (d.canvas.width = o, d.canvas.height = o) : u || d.clearRect(0, 0, o, o);
    let v;
    this.renderBuffer_ !== void 0 && (v = U0(), xo(v, e), Do(
      v,
      n * (this.renderBuffer_ + s),
      v
    ));
    const m = dq1(s);
    let p;
    function _(F, D, R) {
      const V = d.getImageData(
        0,
        0,
        o,
        o
      ).data;
      for (let J = 0, K = m.length; J < K; J++)
        if (V[m[J]] > 0) {
          if (!a || R === "none" || p !== "Image" && p !== "Text" || a.includes(F)) {
            const P = (m[J] - 3) / 4, O = s - P % o, G = s - (P / o | 0), j = l(F, D, O * O + G * G);
            if (j)
              return j;
          }
          d.clearRect(0, 0, o, o);
          break;
        }
    }
    const q = Object.keys(this.executorsByZIndex_).map(Number);
    q.sort(m8);
    let M, z, b, x, k;
    for (M = q.length - 1; M >= 0; --M) {
      const F = q[M].toString();
      for (b = this.executorsByZIndex_[F], z = ma.length - 1; z >= 0; --z)
        if (p = ma[z], x = b[p], x !== void 0 && (k = x.executeHitDetection(
          d,
          h,
          i,
          _,
          v
        ), k))
          return k;
    }
  }
  /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */
  getClipCoords(e) {
    const n = this.maxExtent_;
    if (!n)
      return null;
    const i = n[0], s = n[1], l = n[2], a = n[3], o = [i, s, i, a, l, a, l, s];
    return Cs(o, 0, 8, 2, e, o), o;
  }
  /**
   * @return {boolean} Is empty.
   */
  isEmpty() {
    return mr(this.executorsByZIndex_);
  }
  /**
   * @param {CanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */
  execute(e, n, i, s, l, a, o) {
    const h = Object.keys(this.executorsByZIndex_).map(Number);
    h.sort(m8), a = a || ma;
    const u = ma.length;
    let d, v, m, p, _;
    for (o && h.reverse(), d = 0, v = h.length; d < v; ++d) {
      const q = h[d].toString();
      for (_ = this.executorsByZIndex_[q], m = 0, p = a.length; m < p; ++m) {
        const M = a[m], z = _[M];
        if (z !== void 0) {
          const b = o === null ? void 0 : z.getZIndexContext(), x = b ? b.getContext() : e, k = this.maxExtent_ && M !== "Image" && M !== "Text";
          if (k && (x.save(), this.clip(x, i)), !b || M === "Text" || M === "Image" ? z.execute(
            x,
            n,
            i,
            s,
            l,
            o
          ) : b.pushFunction(
            (F) => z.execute(
              F,
              n,
              i,
              s,
              l,
              o
            )
          ), k && x.restore(), b) {
            b.offset();
            const F = h[d] * u + m;
            this.deferredZIndexContexts_[F] || (this.deferredZIndexContexts_[F] = []), this.deferredZIndexContexts_[F].push(b);
          }
        }
      }
    }
    this.renderedContext_ = e;
  }
  getDeferredZIndexContexts() {
    return this.deferredZIndexContexts_;
  }
  getRenderedContext() {
    return this.renderedContext_;
  }
  renderDeferred() {
    const e = this.deferredZIndexContexts_, n = Object.keys(e).map(Number).sort(m8);
    for (let i = 0, s = n.length; i < s; ++i)
      e[n[i]].forEach((l) => {
        l.draw(this.renderedContext_), l.clear();
      }), e[n[i]].length = 0;
  }
}
const Ng = {};
function dq1(t) {
  if (Ng[t] !== void 0)
    return Ng[t];
  const e = t * 2 + 1, n = t * t, i = new Array(n + 1);
  for (let l = 0; l <= t; ++l)
    for (let a = 0; a <= t; ++a) {
      const o = l * l + a * a;
      if (o > n)
        break;
      let h = i[o];
      h || (h = [], i[o] = h), h.push(((t + l) * e + (t + a)) * 4 + 3), l > 0 && h.push(((t - l) * e + (t + a)) * 4 + 3), a > 0 && (h.push(((t + l) * e + (t - a)) * 4 + 3), l > 0 && h.push(((t - l) * e + (t - a)) * 4 + 3));
    }
  const s = [];
  for (let l = 0, a = i.length; l < a; ++l)
    i[l] && s.push(...i[l]);
  return Ng[t] = s, s;
}
const fq1 = uq1;
class vq1 extends _C {
  /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */
  constructor(e, n, i, s, l, a, o) {
    super(), this.context_ = e, this.pixelRatio_ = n, this.extent_ = i, this.transform_ = s, this.transformRotation_ = s ? $u(Math.atan2(s[1], s[0]), 10) : 0, this.viewRotation_ = l, this.squaredTolerance_ = a, this.userTransform_ = o, this.contextFillState_ = null, this.contextStrokeState_ = null, this.contextTextState_ = null, this.fillState_ = null, this.strokeState_ = null, this.image_ = null, this.imageAnchorX_ = 0, this.imageAnchorY_ = 0, this.imageHeight_ = 0, this.imageOpacity_ = 0, this.imageOriginX_ = 0, this.imageOriginY_ = 0, this.imageRotateWithView_ = !1, this.imageRotation_ = 0, this.imageScale_ = [0, 0], this.imageWidth_ = 0, this.text_ = "", this.textOffsetX_ = 0, this.textOffsetY_ = 0, this.textRotateWithView_ = !1, this.textRotation_ = 0, this.textScale_ = [0, 0], this.textFillState_ = null, this.textStrokeState_ = null, this.textState_ = null, this.pixelCoordinates_ = [], this.tmpLocalTransform_ = hn();
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */
  drawImages_(e, n, i, s) {
    if (!this.image_)
      return;
    const l = Cs(
      e,
      n,
      i,
      s,
      this.transform_,
      this.pixelCoordinates_
    ), a = this.context_, o = this.tmpLocalTransform_, h = a.globalAlpha;
    this.imageOpacity_ != 1 && (a.globalAlpha = h * this.imageOpacity_);
    let u = this.imageRotation_;
    this.transformRotation_ === 0 && (u -= this.viewRotation_), this.imageRotateWithView_ && (u += this.viewRotation_);
    for (let d = 0, v = l.length; d < v; d += 2) {
      const m = l[d] - this.imageAnchorX_, p = l[d + 1] - this.imageAnchorY_;
      if (u !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
        const _ = m + this.imageAnchorX_, q = p + this.imageAnchorY_;
        b8(
          o,
          _,
          q,
          1,
          1,
          u,
          -_,
          -q
        ), a.save(), a.transform.apply(a, o), a.translate(_, q), a.scale(this.imageScale_[0], this.imageScale_[1]), a.drawImage(
          this.image_,
          this.imageOriginX_,
          this.imageOriginY_,
          this.imageWidth_,
          this.imageHeight_,
          -this.imageAnchorX_,
          -this.imageAnchorY_,
          this.imageWidth_,
          this.imageHeight_
        ), a.restore();
      } else
        a.drawImage(
          this.image_,
          this.imageOriginX_,
          this.imageOriginY_,
          this.imageWidth_,
          this.imageHeight_,
          m,
          p,
          this.imageWidth_,
          this.imageHeight_
        );
    }
    this.imageOpacity_ != 1 && (a.globalAlpha = h);
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */
  drawText_(e, n, i, s) {
    if (!this.textState_ || this.text_ === "")
      return;
    this.textFillState_ && this.setContextFillState_(this.textFillState_), this.textStrokeState_ && this.setContextStrokeState_(this.textStrokeState_), this.setContextTextState_(this.textState_);
    const l = Cs(
      e,
      n,
      i,
      s,
      this.transform_,
      this.pixelCoordinates_
    ), a = this.context_;
    let o = this.textRotation_;
    for (this.transformRotation_ === 0 && (o -= this.viewRotation_), this.textRotateWithView_ && (o += this.viewRotation_); n < i; n += s) {
      const h = l[n] + this.textOffsetX_, u = l[n + 1] + this.textOffsetY_;
      o !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1 ? (a.save(), a.translate(h - this.textOffsetX_, u - this.textOffsetY_), a.rotate(o), a.translate(this.textOffsetX_, this.textOffsetY_), a.scale(this.textScale_[0], this.textScale_[1]), this.textStrokeState_ && a.strokeText(this.text_, 0, 0), this.textFillState_ && a.fillText(this.text_, 0, 0), a.restore()) : (this.textStrokeState_ && a.strokeText(this.text_, h, u), this.textFillState_ && a.fillText(this.text_, h, u));
    }
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */
  moveToLineTo_(e, n, i, s, l) {
    const a = this.context_, o = Cs(
      e,
      n,
      i,
      s,
      this.transform_,
      this.pixelCoordinates_
    );
    a.moveTo(o[0], o[1]);
    let h = o.length;
    l && (h -= 2);
    for (let u = 2; u < h; u += 2)
      a.lineTo(o[u], o[u + 1]);
    return l && a.closePath(), i;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */
  drawRings_(e, n, i, s) {
    for (let l = 0, a = i.length; l < a; ++l)
      n = this.moveToLineTo_(
        e,
        n,
        i[l],
        s,
        !0
      );
    return n;
  }
  /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */
  drawCircle(e) {
    if (this.squaredTolerance_ && (e = /** @type {import("../../geom/Circle.js").default} */
    e.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    )), !!r0(this.extent_, e.getExtent())) {
      if (this.fillState_ || this.strokeState_) {
        this.fillState_ && this.setContextFillState_(this.fillState_), this.strokeState_ && this.setContextStrokeState_(this.strokeState_);
        const n = Hg1(
          e,
          this.transform_,
          this.pixelCoordinates_
        ), i = n[2] - n[0], s = n[3] - n[1], l = Math.sqrt(i * i + s * s), a = this.context_;
        a.beginPath(), a.arc(
          n[0],
          n[1],
          l,
          0,
          2 * Math.PI
        ), this.fillState_ && a.fill(), this.strokeState_ && a.stroke();
      }
      this.text_ !== "" && this.drawText_(e.getCenter(), 0, 2, 2);
    }
  }
  /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */
  setStyle(e) {
    this.setFillStrokeStyle(e.getFill(), e.getStroke()), this.setImageStyle(e.getImage()), this.setTextStyle(e.getText());
  }
  /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */
  setTransform(e) {
    this.transform_ = e;
  }
  /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */
  drawGeometry(e) {
    switch (e.getType()) {
      case "Point":
        this.drawPoint(
          /** @type {import("../../geom/Point.js").default} */
          e
        );
        break;
      case "LineString":
        this.drawLineString(
          /** @type {import("../../geom/LineString.js").default} */
          e
        );
        break;
      case "Polygon":
        this.drawPolygon(
          /** @type {import("../../geom/Polygon.js").default} */
          e
        );
        break;
      case "MultiPoint":
        this.drawMultiPoint(
          /** @type {import("../../geom/MultiPoint.js").default} */
          e
        );
        break;
      case "MultiLineString":
        this.drawMultiLineString(
          /** @type {import("../../geom/MultiLineString.js").default} */
          e
        );
        break;
      case "MultiPolygon":
        this.drawMultiPolygon(
          /** @type {import("../../geom/MultiPolygon.js").default} */
          e
        );
        break;
      case "GeometryCollection":
        this.drawGeometryCollection(
          /** @type {import("../../geom/GeometryCollection.js").default} */
          e
        );
        break;
      case "Circle":
        this.drawCircle(
          /** @type {import("../../geom/Circle.js").default} */
          e
        );
        break;
    }
  }
  /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */
  drawFeature(e, n) {
    const i = n.getGeometryFunction()(e);
    i && (this.setStyle(n), this.drawGeometry(i));
  }
  /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */
  drawGeometryCollection(e) {
    const n = e.getGeometriesArray();
    for (let i = 0, s = n.length; i < s; ++i)
      this.drawGeometry(n[i]);
  }
  /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */
  drawPoint(e) {
    this.squaredTolerance_ && (e = /** @type {import("../../geom/Point.js").default} */
    e.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    ));
    const n = e.getFlatCoordinates(), i = e.getStride();
    this.image_ && this.drawImages_(n, 0, n.length, i), this.text_ !== "" && this.drawText_(n, 0, n.length, i);
  }
  /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */
  drawMultiPoint(e) {
    this.squaredTolerance_ && (e = /** @type {import("../../geom/MultiPoint.js").default} */
    e.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    ));
    const n = e.getFlatCoordinates(), i = e.getStride();
    this.image_ && this.drawImages_(n, 0, n.length, i), this.text_ !== "" && this.drawText_(n, 0, n.length, i);
  }
  /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */
  drawLineString(e) {
    if (this.squaredTolerance_ && (e = /** @type {import("../../geom/LineString.js").default} */
    e.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    )), !!r0(this.extent_, e.getExtent())) {
      if (this.strokeState_) {
        this.setContextStrokeState_(this.strokeState_);
        const n = this.context_, i = e.getFlatCoordinates();
        n.beginPath(), this.moveToLineTo_(
          i,
          0,
          i.length,
          e.getStride(),
          !1
        ), n.stroke();
      }
      if (this.text_ !== "") {
        const n = e.getFlatMidpoint();
        this.drawText_(n, 0, 2, 2);
      }
    }
  }
  /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */
  drawMultiLineString(e) {
    this.squaredTolerance_ && (e = /** @type {import("../../geom/MultiLineString.js").default} */
    e.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    ));
    const n = e.getExtent();
    if (r0(this.extent_, n)) {
      if (this.strokeState_) {
        this.setContextStrokeState_(this.strokeState_);
        const i = this.context_, s = e.getFlatCoordinates();
        let l = 0;
        const a = (
          /** @type {Array<number>} */
          e.getEnds()
        ), o = e.getStride();
        i.beginPath();
        for (let h = 0, u = a.length; h < u; ++h)
          l = this.moveToLineTo_(
            s,
            l,
            a[h],
            o,
            !1
          );
        i.stroke();
      }
      if (this.text_ !== "") {
        const i = e.getFlatMidpoints();
        this.drawText_(i, 0, i.length, 2);
      }
    }
  }
  /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */
  drawPolygon(e) {
    if (this.squaredTolerance_ && (e = /** @type {import("../../geom/Polygon.js").default} */
    e.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    )), !!r0(this.extent_, e.getExtent())) {
      if (this.strokeState_ || this.fillState_) {
        this.fillState_ && this.setContextFillState_(this.fillState_), this.strokeState_ && this.setContextStrokeState_(this.strokeState_);
        const n = this.context_;
        n.beginPath(), this.drawRings_(
          e.getOrientedFlatCoordinates(),
          0,
          /** @type {Array<number>} */
          e.getEnds(),
          e.getStride()
        ), this.fillState_ && n.fill(), this.strokeState_ && n.stroke();
      }
      if (this.text_ !== "") {
        const n = e.getFlatInteriorPoint();
        this.drawText_(n, 0, 2, 2);
      }
    }
  }
  /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */
  drawMultiPolygon(e) {
    if (this.squaredTolerance_ && (e = /** @type {import("../../geom/MultiPolygon.js").default} */
    e.simplifyTransformed(
      this.squaredTolerance_,
      this.userTransform_
    )), !!r0(this.extent_, e.getExtent())) {
      if (this.strokeState_ || this.fillState_) {
        this.fillState_ && this.setContextFillState_(this.fillState_), this.strokeState_ && this.setContextStrokeState_(this.strokeState_);
        const n = this.context_, i = e.getOrientedFlatCoordinates();
        let s = 0;
        const l = e.getEndss(), a = e.getStride();
        n.beginPath();
        for (let o = 0, h = l.length; o < h; ++o) {
          const u = l[o];
          s = this.drawRings_(i, s, u, a);
        }
        this.fillState_ && n.fill(), this.strokeState_ && n.stroke();
      }
      if (this.text_ !== "") {
        const n = e.getFlatInteriorPoints();
        this.drawText_(n, 0, n.length, 2);
      }
    }
  }
  /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */
  setContextFillState_(e) {
    const n = this.context_, i = this.contextFillState_;
    i ? i.fillStyle != e.fillStyle && (i.fillStyle = e.fillStyle, n.fillStyle = e.fillStyle) : (n.fillStyle = e.fillStyle, this.contextFillState_ = {
      fillStyle: e.fillStyle
    });
  }
  /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */
  setContextStrokeState_(e) {
    const n = this.context_, i = this.contextStrokeState_;
    i ? (i.lineCap != e.lineCap && (i.lineCap = e.lineCap, n.lineCap = e.lineCap), Ws(i.lineDash, e.lineDash) || n.setLineDash(
      i.lineDash = e.lineDash
    ), i.lineDashOffset != e.lineDashOffset && (i.lineDashOffset = e.lineDashOffset, n.lineDashOffset = e.lineDashOffset), i.lineJoin != e.lineJoin && (i.lineJoin = e.lineJoin, n.lineJoin = e.lineJoin), i.lineWidth != e.lineWidth && (i.lineWidth = e.lineWidth, n.lineWidth = e.lineWidth), i.miterLimit != e.miterLimit && (i.miterLimit = e.miterLimit, n.miterLimit = e.miterLimit), i.strokeStyle != e.strokeStyle && (i.strokeStyle = e.strokeStyle, n.strokeStyle = e.strokeStyle)) : (n.lineCap = e.lineCap, n.setLineDash(e.lineDash), n.lineDashOffset = e.lineDashOffset, n.lineJoin = e.lineJoin, n.lineWidth = e.lineWidth, n.miterLimit = e.miterLimit, n.strokeStyle = e.strokeStyle, this.contextStrokeState_ = {
      lineCap: e.lineCap,
      lineDash: e.lineDash,
      lineDashOffset: e.lineDashOffset,
      lineJoin: e.lineJoin,
      lineWidth: e.lineWidth,
      miterLimit: e.miterLimit,
      strokeStyle: e.strokeStyle
    });
  }
  /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */
  setContextTextState_(e) {
    const n = this.context_, i = this.contextTextState_, s = e.textAlign ? e.textAlign : Qo;
    i ? (i.font != e.font && (i.font = e.font, n.font = e.font), i.textAlign != s && (i.textAlign = s, n.textAlign = s), i.textBaseline != e.textBaseline && (i.textBaseline = e.textBaseline, n.textBaseline = e.textBaseline)) : (n.font = e.font, n.textAlign = s, n.textBaseline = e.textBaseline, this.contextTextState_ = {
      font: e.font,
      textAlign: s,
      textBaseline: e.textBaseline
    });
  }
  /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */
  setFillStrokeStyle(e, n) {
    if (!e)
      this.fillState_ = null;
    else {
      const i = e.getColor();
      this.fillState_ = {
        fillStyle: Xn(
          i || s0
        )
      };
    }
    if (!n)
      this.strokeState_ = null;
    else {
      const i = n.getColor(), s = n.getLineCap(), l = n.getLineDash(), a = n.getLineDashOffset(), o = n.getLineJoin(), h = n.getWidth(), u = n.getMiterLimit(), d = l || g8;
      this.strokeState_ = {
        lineCap: s !== void 0 ? s : Wa,
        lineDash: this.pixelRatio_ === 1 ? d : d.map((v) => v * this.pixelRatio_),
        lineDashOffset: (a || y8) * this.pixelRatio_,
        lineJoin: o !== void 0 ? o : Ya,
        lineWidth: (h !== void 0 ? h : ec) * this.pixelRatio_,
        miterLimit: u !== void 0 ? u : Zo,
        strokeStyle: Xn(
          i || Jo
        )
      };
    }
  }
  /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */
  setImageStyle(e) {
    let n;
    if (!e || !(n = e.getSize())) {
      this.image_ = null;
      return;
    }
    const i = e.getPixelRatio(this.pixelRatio_), s = e.getAnchor(), l = e.getOrigin();
    this.image_ = e.getImage(this.pixelRatio_), this.imageAnchorX_ = s[0] * i, this.imageAnchorY_ = s[1] * i, this.imageHeight_ = n[1] * i, this.imageOpacity_ = e.getOpacity(), this.imageOriginX_ = l[0], this.imageOriginY_ = l[1], this.imageRotateWithView_ = e.getRotateWithView(), this.imageRotation_ = e.getRotation();
    const a = e.getScaleArray();
    this.imageScale_ = [
      a[0] * this.pixelRatio_ / i,
      a[1] * this.pixelRatio_ / i
    ], this.imageWidth_ = n[0] * i;
  }
  /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */
  setTextStyle(e) {
    if (!e)
      this.text_ = "";
    else {
      const n = e.getFill();
      if (!n)
        this.textFillState_ = null;
      else {
        const p = n.getColor();
        this.textFillState_ = {
          fillStyle: Xn(
            p || s0
          )
        };
      }
      const i = e.getStroke();
      if (!i)
        this.textStrokeState_ = null;
      else {
        const p = i.getColor(), _ = i.getLineCap(), q = i.getLineDash(), M = i.getLineDashOffset(), z = i.getLineJoin(), b = i.getWidth(), x = i.getMiterLimit();
        this.textStrokeState_ = {
          lineCap: _ !== void 0 ? _ : Wa,
          lineDash: q || g8,
          lineDashOffset: M || y8,
          lineJoin: z !== void 0 ? z : Ya,
          lineWidth: b !== void 0 ? b : ec,
          miterLimit: x !== void 0 ? x : Zo,
          strokeStyle: Xn(
            p || Jo
          )
        };
      }
      const s = e.getFont(), l = e.getOffsetX(), a = e.getOffsetY(), o = e.getRotateWithView(), h = e.getRotation(), u = e.getScaleArray(), d = e.getText(), v = e.getTextAlign(), m = e.getTextBaseline();
      this.textState_ = {
        font: s !== void 0 ? s : iC,
        textAlign: v !== void 0 ? v : Qo,
        textBaseline: m !== void 0 ? m : Kh
      }, this.text_ = d !== void 0 ? Array.isArray(d) ? d.reduce((p, _, q) => p += q % 2 ? " " : _, "") : d : "", this.textOffsetX_ = l !== void 0 ? this.pixelRatio_ * l : 0, this.textOffsetY_ = a !== void 0 ? this.pixelRatio_ * a : 0, this.textRotateWithView_ = o !== void 0 ? o : !1, this.textRotation_ = h !== void 0 ? h : 0, this.textScale_ = [
        this.pixelRatio_ * u[0],
        this.pixelRatio_ * u[1]
      ];
    }
  }
}
const pq1 = vq1, Gn = 0.5;
function mq1(t, e, n, i, s, l, a, o, h) {
  const u = h ? Z_(s) : s, d = t[0] * Gn, v = t[1] * Gn, m = u4(d, v);
  m.imageSmoothingEnabled = !1;
  const p = m.canvas, _ = new pq1(
    m,
    Gn,
    s,
    null,
    a,
    o,
    h ? Uu(qg1(), h) : null
  ), q = n.length, M = Math.floor((256 * 256 * 256 - 1) / q), z = {};
  for (let x = 1; x <= q; ++x) {
    const k = n[x - 1], F = k.getStyleFunction() || i;
    if (!F)
      continue;
    let D = F(k, l);
    if (!D)
      continue;
    Array.isArray(D) || (D = [D]);
    const V = (x * M).toString(16).padStart(7, "#00000");
    for (let J = 0, K = D.length; J < K; ++J) {
      const P = D[J], O = P.getGeometryFunction()(k);
      if (!O || !r0(u, O.getExtent()))
        continue;
      const G = P.clone(), j = G.getFill();
      j && j.setColor(V);
      const Q = G.getStroke();
      Q && (Q.setColor(V), Q.setLineDash(null)), G.setText(void 0);
      const i1 = P.getImage();
      if (i1) {
        const y1 = i1.getImageSize();
        if (!y1)
          continue;
        const A1 = u4(
          y1[0],
          y1[1],
          void 0,
          { alpha: !1 }
        ), $ = A1.canvas;
        A1.fillStyle = V, A1.fillRect(0, 0, $.width, $.height), G.setImage(
          new Eq({
            img: $,
            anchor: i1.getAnchor(),
            anchorXUnits: "pixels",
            anchorYUnits: "pixels",
            offset: i1.getOrigin(),
            opacity: 1,
            size: i1.getSize(),
            scale: i1.getScale(),
            rotation: i1.getRotation(),
            rotateWithView: i1.getRotateWithView()
          })
        );
      }
      const h1 = G.getZIndex() || 0;
      let c1 = z[h1];
      c1 || (c1 = {}, z[h1] = c1, c1.Polygon = [], c1.Circle = [], c1.LineString = [], c1.Point = []);
      const M1 = O.getType();
      if (M1 === "GeometryCollection") {
        const y1 = (
          /** @type {import("../../geom/GeometryCollection.js").default} */
          O.getGeometriesArrayRecursive()
        );
        for (let A1 = 0, $ = y1.length; A1 < $; ++A1) {
          const a1 = y1[A1];
          c1[a1.getType().replace("Multi", "")].push(
            a1,
            G
          );
        }
      } else
        c1[M1.replace("Multi", "")].push(O, G);
    }
  }
  const b = Object.keys(z).map(Number).sort(m8);
  for (let x = 0, k = b.length; x < k; ++x) {
    const F = z[b[x]];
    for (const D in F) {
      const R = F[D];
      for (let V = 0, J = R.length; V < J; V += 2) {
        _.setStyle(R[V + 1]);
        for (let K = 0, P = e.length; K < P; ++K)
          _.setTransform(e[K]), _.drawGeometry(R[V]);
      }
    }
  }
  return m.getImageData(0, 0, p.width, p.height);
}
function gq1(t, e, n) {
  const i = [];
  if (n) {
    const s = Math.floor(Math.round(t[0]) * Gn), l = Math.floor(Math.round(t[1]) * Gn), a = (bt(s, 0, n.width - 1) + bt(l, 0, n.height - 1) * n.width) * 4, o = n.data[a], h = n.data[a + 1], d = n.data[a + 2] + 256 * (h + 256 * o), v = Math.floor((256 * 256 * 256 - 1) / e.length);
    d && d % v === 0 && i.push(e[d / v - 1]);
  }
  return i;
}
const yq1 = 0.5, bC = {
  Point: xq1,
  LineString: Mq1,
  Polygon: Cq1,
  MultiPoint: Sq1,
  MultiLineString: bq1,
  MultiPolygon: Lq1,
  GeometryCollection: zq1,
  Circle: qq1
};
function _q1(t, e) {
  return parseInt(Be(t), 10) - parseInt(Be(e), 10);
}
function sM(t, e) {
  const n = LC(t, e);
  return n * n;
}
function LC(t, e) {
  return yq1 * t / e;
}
function qq1(t, e, n, i, s) {
  const l = n.getFill(), a = n.getStroke();
  if (l || a) {
    const h = t.getBuilder(n.getZIndex(), "Circle");
    h.setFillStrokeStyle(l, a), h.drawCircle(e, i, s);
  }
  const o = n.getText();
  if (o && o.getText()) {
    const h = t.getBuilder(n.getZIndex(), "Text");
    h.setTextStyle(o), h.drawText(e, i);
  }
}
function lM(t, e, n, i, s, l, a, o) {
  const h = [], u = n.getImage();
  if (u) {
    let m = !0;
    const p = u.getImageState();
    p == Y3.LOADED || p == Y3.ERROR ? m = !1 : p == Y3.IDLE && u.load(), m && h.push(u.ready());
  }
  const d = n.getFill();
  d && d.loading() && h.push(d.ready());
  const v = h.length > 0;
  return v && Promise.all(h).then(() => s(null)), wq1(
    t,
    e,
    n,
    i,
    l,
    a,
    o
  ), v;
}
function wq1(t, e, n, i, s, l, a) {
  const o = n.getGeometryFunction()(e);
  if (!o)
    return;
  const h = o.simplifyTransformed(
    i,
    s
  );
  if (n.getRenderer())
    xC(t, h, n, e, a);
  else {
    const d = bC[h.getType()];
    d(
      t,
      h,
      n,
      e,
      a,
      l
    );
  }
}
function xC(t, e, n, i, s) {
  if (e.getType() == "GeometryCollection") {
    const a = (
      /** @type {import("../geom/GeometryCollection.js").default} */
      e.getGeometries()
    );
    for (let o = 0, h = a.length; o < h; ++o)
      xC(t, a[o], n, i, s);
    return;
  }
  t.getBuilder(n.getZIndex(), "Default").drawCustom(
    /** @type {import("../geom/SimpleGeometry.js").default} */
    e,
    i,
    n.getRenderer(),
    n.getHitDetectionRenderer(),
    s
  );
}
function zq1(t, e, n, i, s, l) {
  const a = e.getGeometriesArray();
  let o, h;
  for (o = 0, h = a.length; o < h; ++o) {
    const u = bC[a[o].getType()];
    u(
      t,
      a[o],
      n,
      i,
      s,
      l
    );
  }
}
function Mq1(t, e, n, i, s) {
  const l = n.getStroke();
  if (l) {
    const o = t.getBuilder(
      n.getZIndex(),
      "LineString"
    );
    o.setFillStrokeStyle(null, l), o.drawLineString(e, i, s);
  }
  const a = n.getText();
  if (a && a.getText()) {
    const o = t.getBuilder(n.getZIndex(), "Text");
    o.setTextStyle(a), o.drawText(e, i, s);
  }
}
function bq1(t, e, n, i, s) {
  const l = n.getStroke();
  if (l) {
    const o = t.getBuilder(
      n.getZIndex(),
      "LineString"
    );
    o.setFillStrokeStyle(null, l), o.drawMultiLineString(e, i, s);
  }
  const a = n.getText();
  if (a && a.getText()) {
    const o = t.getBuilder(n.getZIndex(), "Text");
    o.setTextStyle(a), o.drawText(e, i, s);
  }
}
function Lq1(t, e, n, i, s) {
  const l = n.getFill(), a = n.getStroke();
  if (a || l) {
    const h = t.getBuilder(n.getZIndex(), "Polygon");
    h.setFillStrokeStyle(l, a), h.drawMultiPolygon(e, i, s);
  }
  const o = n.getText();
  if (o && o.getText()) {
    const h = t.getBuilder(n.getZIndex(), "Text");
    h.setTextStyle(o), h.drawText(e, i, s);
  }
}
function xq1(t, e, n, i, s, l) {
  const a = n.getImage(), o = n.getText(), h = o && o.getText(), u = l && a && h ? {} : void 0;
  if (a) {
    if (a.getImageState() != Y3.LOADED)
      return;
    const d = t.getBuilder(n.getZIndex(), "Image");
    d.setImageStyle(a, u), d.drawPoint(e, i, s);
  }
  if (h) {
    const d = t.getBuilder(n.getZIndex(), "Text");
    d.setTextStyle(o, u), d.drawText(e, i, s);
  }
}
function Sq1(t, e, n, i, s, l) {
  const a = n.getImage(), o = a && a.getOpacity() !== 0, h = n.getText(), u = h && h.getText(), d = l && o && u ? {} : void 0;
  if (o) {
    if (a.getImageState() != Y3.LOADED)
      return;
    const v = t.getBuilder(n.getZIndex(), "Image");
    v.setImageStyle(a, d), v.drawMultiPoint(e, i, s);
  }
  if (u) {
    const v = t.getBuilder(n.getZIndex(), "Text");
    v.setTextStyle(h, d), v.drawText(e, i, s);
  }
}
function Cq1(t, e, n, i, s) {
  const l = n.getFill(), a = n.getStroke();
  if (l || a) {
    const h = t.getBuilder(n.getZIndex(), "Polygon");
    h.setFillStrokeStyle(l, a), h.drawPolygon(e, i, s);
  }
  const o = n.getText();
  if (o && o.getText()) {
    const h = t.getBuilder(n.getZIndex(), "Text");
    h.setTextStyle(o), h.drawText(e, i, s);
  }
}
class kq1 extends zC {
  /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */
  constructor(e) {
    super(e), this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this), this.animatingOrInteracting_, this.hitDetectionImageData_ = null, this.clipped_ = !1, this.renderedFeatures_ = null, this.renderedRevision_ = -1, this.renderedResolution_ = NaN, this.renderedExtent_ = U0(), this.wrappedRenderedExtent_ = U0(), this.renderedRotation_, this.renderedCenter_ = null, this.renderedProjection_ = null, this.renderedPixelRatio_ = 1, this.renderedRenderOrder_ = null, this.renderedFrameDeclutter_, this.replayGroup_ = null, this.replayGroupChanged = !0, this.clipping = !0, this.targetContext_ = null, this.opacity_ = 1;
  }
  /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */
  renderWorlds(e, n, i) {
    const s = n.extent, l = n.viewState, a = l.center, o = l.resolution, h = l.projection, u = l.rotation, d = h.getExtent(), v = this.getLayer().getSource(), m = this.getLayer().getDeclutter(), p = n.pixelRatio, _ = n.viewHints, q = !(_[f5.ANIMATING] || _[f5.INTERACTING]), M = this.context, z = Math.round(ue(s) / o * p), b = Math.round(G4(s) / o * p), x = v.getWrapX() && h.canWrapX(), k = x ? ue(d) : null, F = x ? Math.ceil((s[2] - d[2]) / k) + 1 : 1;
    let D = x ? Math.floor((s[0] - d[0]) / k) : 0;
    do {
      let R = this.getRenderTransform(
        a,
        o,
        0,
        p,
        z,
        b,
        D * k
      );
      n.declutter && (R = R.slice(0)), e.execute(
        M,
        [M.canvas.width, M.canvas.height],
        R,
        u,
        q,
        i === void 0 ? ma : i ? MC : hq1,
        i ? m && n.declutter[m] : void 0
      );
    } while (++D < F);
  }
  /**
   * @private
   */
  setDrawContext_() {
    this.opacity_ !== 1 && (this.targetContext_ = this.context, this.context = u4(
      this.context.canvas.width,
      this.context.canvas.height,
      tM
    ));
  }
  /**
   * @private
   */
  resetDrawContext_() {
    if (this.opacity_ !== 1) {
      const e = this.targetContext_.globalAlpha;
      this.targetContext_.globalAlpha = this.opacity_, this.targetContext_.drawImage(this.context.canvas, 0, 0), this.targetContext_.globalAlpha = e, Ga(this.context), tM.push(this.context.canvas), this.context = this.targetContext_, this.targetContext_ = null;
    }
  }
  /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */
  renderDeclutter(e) {
    !this.replayGroup_ || !this.getLayer().getDeclutter() || this.renderWorlds(this.replayGroup_, e, !0);
  }
  /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */
  renderDeferredInternal(e) {
    this.replayGroup_ && (this.replayGroup_.renderDeferred(), this.clipped_ && this.context.restore(), this.resetDrawContext_());
  }
  /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   * @override
   */
  renderFrame(e, n) {
    const i = e.layerStatesArray[e.layerIndex];
    this.opacity_ = i.opacity;
    const s = e.viewState;
    this.prepareContainer(e, n);
    const l = this.context, a = this.replayGroup_;
    let o = a && !a.isEmpty();
    if (!o && !(this.getLayer().hasListener(M6.PRERENDER) || this.getLayer().hasListener(M6.POSTRENDER)))
      return null;
    if (this.setDrawContext_(), this.preRender(l, e), s.projection, this.clipped_ = !1, o && i.extent && this.clipping) {
      const h = qs(i.extent);
      o = r0(h, e.extent), this.clipped_ = o && !tr(h, e.extent), this.clipped_ && this.clipUnrotated(l, e, h);
    }
    return o && this.renderWorlds(
      a,
      e,
      this.getLayer().getDeclutter() ? !1 : void 0
    ), !e.declutter && this.clipped_ && l.restore(), this.postRender(l, e), this.renderedRotation_ !== s.rotation && (this.renderedRotation_ = s.rotation, this.hitDetectionImageData_ = null), e.declutter || this.resetDrawContext_(), this.container;
  }
  /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   * @override
   */
  getFeatures(e) {
    return new Promise((n) => {
      if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
        const i = this.frameState.size.slice(), s = this.renderedCenter_, l = this.renderedResolution_, a = this.renderedRotation_, o = this.renderedProjection_, h = this.wrappedRenderedExtent_, u = this.getLayer(), d = [], v = i[0] * Gn, m = i[1] * Gn;
        d.push(
          this.getRenderTransform(
            s,
            l,
            a,
            Gn,
            v,
            m,
            0
          ).slice()
        );
        const p = u.getSource(), _ = o.getExtent();
        if (p.getWrapX() && o.canWrapX() && !tr(_, h)) {
          let q = h[0];
          const M = ue(_);
          let z = 0, b;
          for (; q < _[0]; )
            --z, b = M * z, d.push(
              this.getRenderTransform(
                s,
                l,
                a,
                Gn,
                v,
                m,
                b
              ).slice()
            ), q += M;
          for (z = 0, q = h[2]; q > _[2]; )
            ++z, b = M * z, d.push(
              this.getRenderTransform(
                s,
                l,
                a,
                Gn,
                v,
                m,
                b
              ).slice()
            ), q -= M;
        }
        this.hitDetectionImageData_ = mq1(
          i,
          d,
          this.renderedFeatures_,
          u.getStyleFunction(),
          h,
          l,
          a,
          sM(l, this.renderedPixelRatio_),
          null
        );
      }
      n(
        gq1(e, this.renderedFeatures_, this.hitDetectionImageData_)
      );
    });
  }
  /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */
  forEachFeatureAtCoordinate(e, n, i, s, l) {
    if (!this.replayGroup_)
      return;
    const a = n.viewState.resolution, o = n.viewState.rotation, h = this.getLayer(), u = {}, d = function(_, q, M) {
      const z = Be(_), b = u[z];
      if (b) {
        if (b !== !0 && M < b.distanceSq) {
          if (M === 0)
            return u[z] = !0, l.splice(l.lastIndexOf(b), 1), s(_, h, q);
          b.geometry = q, b.distanceSq = M;
        }
      } else {
        if (M === 0)
          return u[z] = !0, s(_, h, q);
        l.push(
          u[z] = {
            feature: _,
            layer: h,
            geometry: q,
            distanceSq: M,
            callback: s
          }
        );
      }
    };
    let v;
    const m = [this.replayGroup_], p = this.getLayer().getDeclutter();
    return m.some((_) => v = _.forEachFeatureAtCoordinate(
      e,
      a,
      o,
      i,
      d,
      p && n.declutter[p] ? n.declutter[p].all().map((q) => q.value) : null
    )), v;
  }
  /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */
  handleFontsChanged() {
    const e = this.getLayer();
    e.getVisible() && this.replayGroup_ && e.changed();
  }
  /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */
  handleStyleImageChange_(e) {
    this.renderIfReadyAndVisible();
  }
  /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */
  prepareFrame(e) {
    const n = this.getLayer(), i = n.getSource();
    if (!i)
      return !1;
    const s = e.viewHints[f5.ANIMATING], l = e.viewHints[f5.INTERACTING], a = n.getUpdateWhileAnimating(), o = n.getUpdateWhileInteracting();
    if (this.ready && !a && s || !o && l)
      return this.animatingOrInteracting_ = !0, !0;
    this.animatingOrInteracting_ = !1;
    const h = e.extent, u = e.viewState, d = u.projection, v = u.resolution, m = e.pixelRatio, p = n.getRevision(), _ = n.getRenderBuffer();
    let q = n.getRenderOrder();
    q === void 0 && (q = _q1);
    const M = u.center.slice(), z = Do(
      h,
      _ * v
    ), b = z.slice(), x = [z.slice()], k = d.getExtent();
    if (i.getWrapX() && d.canWrapX() && !tr(k, e.extent)) {
      const j = ue(k), Q = Math.max(ue(z) / 2, j);
      z[0] = k[0] - Q, z[2] = k[2] + Q, bS(M, d);
      const i1 = zS(x[0], d);
      i1[0] < k[0] && i1[2] < k[2] ? x.push([
        i1[0] + j,
        i1[1],
        i1[2] + j,
        i1[3]
      ]) : i1[0] > k[0] && i1[2] > k[2] && x.push([
        i1[0] - j,
        i1[1],
        i1[2] - j,
        i1[3]
      ]);
    }
    if (this.ready && this.renderedResolution_ == v && this.renderedRevision_ == p && this.renderedRenderOrder_ == q && this.renderedFrameDeclutter_ === !!e.declutter && tr(this.wrappedRenderedExtent_, z))
      return Ws(this.renderedExtent_, b) || (this.hitDetectionImageData_ = null, this.renderedExtent_ = b), this.renderedCenter_ = M, this.replayGroupChanged = !1, !0;
    this.replayGroup_ = null;
    const F = new J_1(
      LC(v, m),
      z,
      v,
      m
    );
    let D;
    for (let j = 0, Q = x.length; j < Q; ++j)
      i.loadFeatures(x[j], v, d);
    const R = sM(v, m);
    let V = !0;
    const J = (
      /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */
      (j, Q) => {
        let i1;
        const h1 = j.getStyleFunction() || n.getStyleFunction();
        if (h1 && (i1 = h1(j, v)), i1) {
          const c1 = this.renderFeature(
            j,
            R,
            i1,
            F,
            D,
            this.getLayer().getDeclutter(),
            Q
          );
          V = V && !c1;
        }
      }
    ), K = Z_(z), P = i.getFeaturesInExtent(K);
    q && P.sort(q);
    for (let j = 0, Q = P.length; j < Q; ++j)
      J(P[j], j);
    this.renderedFeatures_ = P, this.ready = V;
    const O = F.finish(), G = new fq1(
      z,
      v,
      m,
      i.getOverlaps(),
      O,
      n.getRenderBuffer(),
      !!e.declutter
    );
    return this.renderedResolution_ = v, this.renderedRevision_ = p, this.renderedRenderOrder_ = q, this.renderedFrameDeclutter_ = !!e.declutter, this.renderedExtent_ = b, this.wrappedRenderedExtent_ = z, this.renderedCenter_ = M, this.renderedProjection_ = d, this.renderedPixelRatio_ = m, this.replayGroup_ = G, this.hitDetectionImageData_ = null, this.replayGroupChanged = !0, !0;
  }
  /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */
  renderFeature(e, n, i, s, l, a, o) {
    if (!i)
      return !1;
    let h = !1;
    if (Array.isArray(i))
      for (let u = 0, d = i.length; u < d; ++u)
        h = lM(
          s,
          e,
          i[u],
          n,
          this.boundHandleStyleImageChange_,
          l,
          a,
          o
        ) || h;
    else
      h = lM(
        s,
        e,
        i,
        n,
        this.boundHandleStyleImageChange_,
        l,
        a,
        o
      );
    return h;
  }
}
const Eq1 = kq1;
class Aq1 extends yC {
  /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */
  constructor(e) {
    super(e);
  }
  /**
   * @override
   */
  createRenderer() {
    return new Eq1(this);
  }
}
const Fq1 = Aq1;
class Tq1 {
  /**
   * @param {number} [maxEntries] Max entries.
   */
  constructor(e) {
    this.rbush_ = new hC(e), this.items_ = {};
  }
  /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */
  insert(e, n) {
    const i = {
      minX: e[0],
      minY: e[1],
      maxX: e[2],
      maxY: e[3],
      value: n
    };
    this.rbush_.insert(i), this.items_[Be(n)] = i;
  }
  /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */
  load(e, n) {
    const i = new Array(n.length);
    for (let s = 0, l = n.length; s < l; s++) {
      const a = e[s], o = n[s], h = {
        minX: a[0],
        minY: a[1],
        maxX: a[2],
        maxY: a[3],
        value: o
      };
      i[s] = h, this.items_[Be(o)] = h;
    }
    this.rbush_.load(i);
  }
  /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */
  remove(e) {
    const n = Be(e), i = this.items_[n];
    return delete this.items_[n], this.rbush_.remove(i) !== null;
  }
  /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */
  update(e, n) {
    const i = this.items_[Be(n)], s = [i.minX, i.minY, i.maxX, i.maxY];
    $o(s, e) || (this.remove(n), this.insert(e, n));
  }
  /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */
  getAll() {
    return this.rbush_.all().map(function(n) {
      return n.value;
    });
  }
  /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */
  getInExtent(e) {
    const n = {
      minX: e[0],
      minY: e[1],
      maxX: e[2],
      maxY: e[3]
    };
    return this.rbush_.search(n).map(function(s) {
      return s.value;
    });
  }
  /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */
  forEach(e) {
    return this.forEach_(this.getAll(), e);
  }
  /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */
  forEachInExtent(e, n) {
    return this.forEach_(this.getInExtent(e), n);
  }
  /**
   * @param {Array<T>} values Values.
   * @param {function(T): *} callback Callback.
   * @private
   * @return {*} Callback return value.
   */
  forEach_(e, n) {
    let i;
    for (let s = 0, l = e.length; s < l; s++)
      if (i = n(e[s]), i)
        return i;
    return i;
  }
  /**
   * @return {boolean} Is empty.
   */
  isEmpty() {
    return mr(this.items_);
  }
  /**
   * Remove all values from the RBush.
   */
  clear() {
    this.rbush_.clear(), this.items_ = {};
  }
  /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */
  getExtent(e) {
    const n = this.rbush_.toJSON();
    return M8(n.minX, n.minY, n.maxX, n.maxY, e);
  }
  /**
   * @param {RBush<T>} rbush R-Tree.
   */
  concat(e) {
    this.rbush_.load(e.rbush_.all());
    for (const n in e.items_)
      this.items_[n] = e.items_[n];
  }
}
const rM = Tq1;
class tu extends NS {
  /**
   * @param {Array<Geometry>} geometries Geometries.
   */
  constructor(e) {
    super(), this.geometries_ = e, this.changeEventsKeys_ = [], this.listenGeometriesChange_();
  }
  /**
   * @private
   */
  unlistenGeometriesChange_() {
    this.changeEventsKeys_.forEach(Qe), this.changeEventsKeys_.length = 0;
  }
  /**
   * @private
   */
  listenGeometriesChange_() {
    const e = this.geometries_;
    for (let n = 0, i = e.length; n < i; ++n)
      this.changeEventsKeys_.push(
        ae(e[n], T3.CHANGE, this.changed, this)
      );
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   * @override
   */
  clone() {
    const e = new tu(
      Pg(this.geometries_)
    );
    return e.applyProperties(this), e;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */
  closestPointXY(e, n, i, s) {
    if (s < br(this.getExtent(), e, n))
      return s;
    const l = this.geometries_;
    for (let a = 0, o = l.length; a < o; ++a)
      s = l[a].closestPointXY(
        e,
        n,
        i,
        s
      );
    return s;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */
  containsXY(e, n) {
    const i = this.geometries_;
    for (let s = 0, l = i.length; s < l; ++s)
      if (i[s].containsXY(e, n))
        return !0;
    return !1;
  }
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */
  computeExtent(e) {
    s9(e);
    const n = this.geometries_;
    for (let i = 0, s = n.length; i < s; ++i)
      j_(e, n[i].getExtent());
    return e;
  }
  /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */
  getGeometries() {
    return Pg(this.geometries_);
  }
  /**
   * @return {Array<Geometry>} Geometries.
   */
  getGeometriesArray() {
    return this.geometries_;
  }
  /**
   * @return {Array<Geometry>} Geometries.
   */
  getGeometriesArrayRecursive() {
    let e = [];
    const n = this.geometries_;
    for (let i = 0, s = n.length; i < s; ++i)
      n[i].getType() === this.getType() ? e = e.concat(
        /** @type {GeometryCollection} */
        n[i].getGeometriesArrayRecursive()
      ) : e.push(n[i]);
    return e;
  }
  /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   * @override
   */
  getSimplifiedGeometry(e) {
    if (this.simplifiedGeometryRevision !== this.getRevision() && (this.simplifiedGeometryMaxMinSquaredTolerance = 0, this.simplifiedGeometryRevision = this.getRevision()), e < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && e < this.simplifiedGeometryMaxMinSquaredTolerance)
      return this;
    const n = [], i = this.geometries_;
    let s = !1;
    for (let l = 0, a = i.length; l < a; ++l) {
      const o = i[l], h = o.getSimplifiedGeometry(e);
      n.push(h), h !== o && (s = !0);
    }
    return s ? new tu(
      n
    ) : (this.simplifiedGeometryMaxMinSquaredTolerance = e, this);
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */
  getType() {
    return "GeometryCollection";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */
  intersectsExtent(e) {
    const n = this.geometries_;
    for (let i = 0, s = n.length; i < s; ++i)
      if (n[i].intersectsExtent(e))
        return !0;
    return !1;
  }
  /**
   * @return {boolean} Is empty.
   */
  isEmpty() {
    return this.geometries_.length === 0;
  }
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */
  rotate(e, n) {
    const i = this.geometries_;
    for (let s = 0, l = i.length; s < l; ++s)
      i[s].rotate(e, n);
    this.changed();
  }
  /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */
  scale(e, n, i) {
    i || (i = Is(this.getExtent()));
    const s = this.geometries_;
    for (let l = 0, a = s.length; l < a; ++l)
      s[l].scale(e, n, i);
    this.changed();
  }
  /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */
  setGeometries(e) {
    this.setGeometriesArray(Pg(e));
  }
  /**
   * @param {Array<Geometry>} geometries Geometries.
   */
  setGeometriesArray(e) {
    this.unlistenGeometriesChange_(), this.geometries_ = e, this.listenGeometriesChange_(), this.changed();
  }
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */
  applyTransform(e) {
    const n = this.geometries_;
    for (let i = 0, s = n.length; i < s; ++i)
      n[i].applyTransform(e);
    this.changed();
  }
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */
  translate(e, n) {
    const i = this.geometries_;
    for (let s = 0, l = i.length; s < l; ++s)
      i[s].translate(e, n);
    this.changed();
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    this.unlistenGeometriesChange_(), super.disposeInternal();
  }
}
function Pg(t) {
  return t.map((e) => e.clone());
}
const Iq1 = tu;
class nu extends Sr {
  /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */
  constructor(e, n, i) {
    if (super(), this.ends_ = [], this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, Array.isArray(e[0]))
      this.setCoordinates(
        /** @type {Array<Array<import("../coordinate.js").Coordinate>>} */
        e,
        n
      );
    else if (n !== void 0 && i)
      this.setFlatCoordinates(
        n,
        /** @type {Array<number>} */
        e
      ), this.ends_ = i;
    else {
      const s = (
        /** @type {Array<LineString>} */
        e
      ), l = [], a = [];
      for (let h = 0, u = s.length; h < u; ++h) {
        const d = s[h];
        ni(l, d.getFlatCoordinates()), a.push(l.length);
      }
      const o = s.length === 0 ? this.getLayout() : s[0].getLayout();
      this.setFlatCoordinates(o, l), this.ends_ = a;
    }
  }
  /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */
  appendLineString(e) {
    ni(this.flatCoordinates, e.getFlatCoordinates().slice()), this.ends_.push(this.flatCoordinates.length), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */
  clone() {
    const e = new nu(
      this.flatCoordinates.slice(),
      this.layout,
      this.ends_.slice()
    );
    return e.applyProperties(this), e;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */
  closestPointXY(e, n, i, s) {
    return s < br(this.getExtent(), e, n) ? s : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      nq(
        this.flatCoordinates,
        0,
        this.ends_,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), sq(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      this.maxDelta_,
      !1,
      e,
      n,
      i,
      s
    ));
  }
  /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */
  getCoordinateAtM(e, n, i) {
    return this.layout != "XYM" && this.layout != "XYZM" || this.flatCoordinates.length === 0 ? null : (n = n !== void 0 ? n : !1, i = i !== void 0 ? i : !1, yy1(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      e,
      n,
      i
    ));
  }
  /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */
  getCoordinates() {
    return Wo(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride
    );
  }
  /**
   * @return {Array<number>} Ends.
   */
  getEnds() {
    return this.ends_;
  }
  /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */
  getLineString(e) {
    return e < 0 || this.ends_.length <= e ? null : new Cy(
      this.flatCoordinates.slice(
        e === 0 ? 0 : this.ends_[e - 1],
        this.ends_[e]
      ),
      this.layout
    );
  }
  /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */
  getLineStrings() {
    const e = this.flatCoordinates, n = this.ends_, i = this.layout, s = [];
    let l = 0;
    for (let a = 0, o = n.length; a < o; ++a) {
      const h = n[a], u = new Cy(
        e.slice(l, h),
        i
      );
      s.push(u), l = h;
    }
    return s;
  }
  /**
   * @return {Array<number>} Flat midpoints.
   */
  getFlatMidpoints() {
    const e = [], n = this.flatCoordinates;
    let i = 0;
    const s = this.ends_, l = this.stride;
    for (let a = 0, o = s.length; a < o; ++a) {
      const h = s[a], u = Yh(
        n,
        i,
        h,
        l,
        0.5
      );
      ni(e, u), i = h;
    }
    return e;
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */
  getSimplifiedGeometryInternal(e) {
    const n = [], i = [];
    return n.length = BS(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      e,
      n,
      0,
      i
    ), new nu(n, "XY", i);
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */
  getType() {
    return "MultiLineString";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */
  intersectsExtent(e) {
    return Zg1(
      this.flatCoordinates,
      0,
      this.ends_,
      this.stride,
      e
    );
  }
  /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */
  setCoordinates(e, n) {
    this.setLayout(n, e, 2), this.flatCoordinates || (this.flatCoordinates = []);
    const i = Mc(
      this.flatCoordinates,
      0,
      e,
      this.stride,
      this.ends_
    );
    this.flatCoordinates.length = i.length === 0 ? 0 : i[i.length - 1], this.changed();
  }
}
const Oq1 = nu;
class Tq extends Sr {
  /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */
  constructor(e, n) {
    super(), n && !Array.isArray(e[0]) ? this.setFlatCoordinates(
      n,
      /** @type {Array<number>} */
      e
    ) : this.setCoordinates(
      /** @type {Array<import("../coordinate.js").Coordinate>} */
      e,
      n
    );
  }
  /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */
  appendPoint(e) {
    ni(this.flatCoordinates, e.getFlatCoordinates()), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */
  clone() {
    const e = new Tq(
      this.flatCoordinates.slice(),
      this.layout
    );
    return e.applyProperties(this), e;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */
  closestPointXY(e, n, i, s) {
    if (s < br(this.getExtent(), e, n))
      return s;
    const l = this.flatCoordinates, a = this.stride;
    for (let o = 0, h = l.length; o < h; o += a) {
      const u = cr(
        e,
        n,
        l[o],
        l[o + 1]
      );
      if (u < s) {
        s = u;
        for (let d = 0; d < a; ++d)
          i[d] = l[o + d];
        i.length = a;
      }
    }
    return s;
  }
  /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */
  getCoordinates() {
    return ws(
      this.flatCoordinates,
      0,
      this.flatCoordinates.length,
      this.stride
    );
  }
  /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */
  getPoint(e) {
    const n = this.flatCoordinates.length / this.stride;
    return e < 0 || n <= e ? null : new Yo(
      this.flatCoordinates.slice(
        e * this.stride,
        (e + 1) * this.stride
      ),
      this.layout
    );
  }
  /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */
  getPoints() {
    const e = this.flatCoordinates, n = this.layout, i = this.stride, s = [];
    for (let l = 0, a = e.length; l < a; l += i) {
      const o = new Yo(e.slice(l, l + i), n);
      s.push(o);
    }
    return s;
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */
  getType() {
    return "MultiPoint";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */
  intersectsExtent(e) {
    const n = this.flatCoordinates, i = this.stride;
    for (let s = 0, l = n.length; s < l; s += i) {
      const a = n[s], o = n[s + 1];
      if ($_(e, a, o))
        return !0;
    }
    return !1;
  }
  /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */
  setCoordinates(e, n) {
    this.setLayout(n, e, 1), this.flatCoordinates || (this.flatCoordinates = []), this.flatCoordinates.length = Xu(
      this.flatCoordinates,
      0,
      e,
      this.stride
    ), this.changed();
  }
}
const SC = Tq;
function CC(t, e, n, i) {
  const s = [];
  let l = U0();
  for (let a = 0, o = n.length; a < o; ++a) {
    const h = n[a];
    l = U_(
      t,
      e,
      h[0],
      i
    ), s.push((l[0] + l[2]) / 2, (l[1] + l[3]) / 2), e = h[h.length - 1];
  }
  return s;
}
class iu extends Sr {
  /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */
  constructor(e, n, i) {
    if (super(), this.endss_ = [], this.flatInteriorPointsRevision_ = -1, this.flatInteriorPoints_ = null, this.maxDelta_ = -1, this.maxDeltaRevision_ = -1, this.orientedRevision_ = -1, this.orientedFlatCoordinates_ = null, !i && !Array.isArray(e[0])) {
      const s = (
        /** @type {Array<Polygon>} */
        e
      ), l = [], a = [];
      for (let o = 0, h = s.length; o < h; ++o) {
        const u = s[o], d = l.length, v = u.getEnds();
        for (let m = 0, p = v.length; m < p; ++m)
          v[m] += d;
        ni(l, u.getFlatCoordinates()), a.push(v);
      }
      n = s.length === 0 ? this.getLayout() : s[0].getLayout(), e = l, i = a;
    }
    n !== void 0 && i ? (this.setFlatCoordinates(
      n,
      /** @type {Array<number>} */
      e
    ), this.endss_ = i) : this.setCoordinates(
      /** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */
      e,
      n
    );
  }
  /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */
  appendPolygon(e) {
    let n;
    if (!this.flatCoordinates)
      this.flatCoordinates = e.getFlatCoordinates().slice(), n = e.getEnds().slice(), this.endss_.push();
    else {
      const i = this.flatCoordinates.length;
      ni(this.flatCoordinates, e.getFlatCoordinates()), n = e.getEnds().slice();
      for (let s = 0, l = n.length; s < l; ++s)
        n[s] += i;
    }
    this.endss_.push(n), this.changed();
  }
  /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */
  clone() {
    const e = this.endss_.length, n = new Array(e);
    for (let s = 0; s < e; ++s)
      n[s] = this.endss_[s].slice();
    const i = new iu(
      this.flatCoordinates.slice(),
      this.layout,
      n
    );
    return i.applyProperties(this), i;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */
  closestPointXY(e, n, i, s) {
    return s < br(this.getExtent(), e, n) ? s : (this.maxDeltaRevision_ != this.getRevision() && (this.maxDelta_ = Math.sqrt(
      Dg1(
        this.flatCoordinates,
        0,
        this.endss_,
        this.stride,
        0
      )
    ), this.maxDeltaRevision_ = this.getRevision()), $g1(
      this.getOrientedFlatCoordinates(),
      0,
      this.endss_,
      this.stride,
      this.maxDelta_,
      !0,
      e,
      n,
      i,
      s
    ));
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */
  containsXY(e, n) {
    return Kg1(
      this.getOrientedFlatCoordinates(),
      0,
      this.endss_,
      this.stride,
      e,
      n
    );
  }
  /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */
  getArea() {
    return Wg1(
      this.getOrientedFlatCoordinates(),
      0,
      this.endss_,
      this.stride
    );
  }
  /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */
  getCoordinates(e) {
    let n;
    return e !== void 0 ? (n = this.getOrientedFlatCoordinates().slice(), xy(
      n,
      0,
      this.endss_,
      this.stride,
      e
    )) : n = this.flatCoordinates, Ly(
      n,
      0,
      this.endss_,
      this.stride
    );
  }
  /**
   * @return {Array<Array<number>>} Endss.
   */
  getEndss() {
    return this.endss_;
  }
  /**
   * @return {Array<number>} Flat interior points.
   */
  getFlatInteriorPoints() {
    if (this.flatInteriorPointsRevision_ != this.getRevision()) {
      const e = CC(
        this.flatCoordinates,
        0,
        this.endss_,
        this.stride
      );
      this.flatInteriorPoints_ = DS(
        this.getOrientedFlatCoordinates(),
        0,
        this.endss_,
        this.stride,
        e
      ), this.flatInteriorPointsRevision_ = this.getRevision();
    }
    return (
      /** @type {Array<number>} */
      this.flatInteriorPoints_
    );
  }
  /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */
  getInteriorPoints() {
    return new SC(this.getFlatInteriorPoints().slice(), "XYM");
  }
  /**
   * @return {Array<number>} Oriented flat coordinates.
   */
  getOrientedFlatCoordinates() {
    if (this.orientedRevision_ != this.getRevision()) {
      const e = this.flatCoordinates;
      GS(e, 0, this.endss_, this.stride) ? this.orientedFlatCoordinates_ = e : (this.orientedFlatCoordinates_ = e.slice(), this.orientedFlatCoordinates_.length = xy(
        this.orientedFlatCoordinates_,
        0,
        this.endss_,
        this.stride
      )), this.orientedRevision_ = this.getRevision();
    }
    return (
      /** @type {Array<number>} */
      this.orientedFlatCoordinates_
    );
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */
  getSimplifiedGeometryInternal(e) {
    const n = [], i = [];
    return n.length = Gg1(
      this.flatCoordinates,
      0,
      this.endss_,
      this.stride,
      Math.sqrt(e),
      n,
      0,
      i
    ), new iu(n, "XY", i);
  }
  /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */
  getPolygon(e) {
    if (e < 0 || this.endss_.length <= e)
      return null;
    let n;
    if (e === 0)
      n = 0;
    else {
      const l = this.endss_[e - 1];
      n = l[l.length - 1];
    }
    const i = this.endss_[e].slice(), s = i[i.length - 1];
    if (n !== 0)
      for (let l = 0, a = i.length; l < a; ++l)
        i[l] -= n;
    return new Os(
      this.flatCoordinates.slice(n, s),
      this.layout,
      i
    );
  }
  /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */
  getPolygons() {
    const e = this.layout, n = this.flatCoordinates, i = this.endss_, s = [];
    let l = 0;
    for (let a = 0, o = i.length; a < o; ++a) {
      const h = i[a].slice(), u = h[h.length - 1];
      if (l !== 0)
        for (let v = 0, m = h.length; v < m; ++v)
          h[v] -= l;
      const d = new Os(
        n.slice(l, u),
        e,
        h
      );
      s.push(d), l = u;
    }
    return s;
  }
  /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */
  getType() {
    return "MultiPolygon";
  }
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */
  intersectsExtent(e) {
    return Jg1(
      this.getOrientedFlatCoordinates(),
      0,
      this.endss_,
      this.stride,
      e
    );
  }
  /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */
  setCoordinates(e, n) {
    this.setLayout(n, e, 3), this.flatCoordinates || (this.flatCoordinates = []);
    const i = PS(
      this.flatCoordinates,
      0,
      e,
      this.stride,
      this.endss_
    );
    if (i.length === 0)
      this.flatCoordinates.length = 0;
    else {
      const s = i[i.length - 1];
      this.flatCoordinates.length = s.length === 0 ? 0 : s[s.length - 1];
    }
    this.changed();
  }
}
const Nq1 = iu, aM = hn();
class Xa {
  /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */
  constructor(e, n, i, s, l, a) {
    this.styleFunction, this.extent_, this.id_ = a, this.type_ = e, this.flatCoordinates_ = n, this.flatInteriorPoints_ = null, this.flatMidpoints_ = null, this.ends_ = i || null, this.properties_ = l, this.squaredTolerance_, this.stride_ = s, this.simplifiedGeometry_;
  }
  /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */
  get(e) {
    return this.properties_[e];
  }
  /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getExtent() {
    return this.extent_ || (this.extent_ = this.type_ === "Point" ? _S(this.flatCoordinates_) : U_(
      this.flatCoordinates_,
      0,
      this.flatCoordinates_.length,
      2
    )), this.extent_;
  }
  /**
   * @return {Array<number>} Flat interior points.
   */
  getFlatInteriorPoint() {
    if (!this.flatInteriorPoints_) {
      const e = Is(this.getExtent());
      this.flatInteriorPoints_ = aq(
        this.flatCoordinates_,
        0,
        this.ends_,
        2,
        e,
        0
      );
    }
    return this.flatInteriorPoints_;
  }
  /**
   * @return {Array<number>} Flat interior points.
   */
  getFlatInteriorPoints() {
    if (!this.flatInteriorPoints_) {
      const e = ey1(this.flatCoordinates_, this.ends_), n = CC(this.flatCoordinates_, 0, e, 2);
      this.flatInteriorPoints_ = DS(
        this.flatCoordinates_,
        0,
        e,
        2,
        n
      );
    }
    return this.flatInteriorPoints_;
  }
  /**
   * @return {Array<number>} Flat midpoint.
   */
  getFlatMidpoint() {
    return this.flatMidpoints_ || (this.flatMidpoints_ = Yh(
      this.flatCoordinates_,
      0,
      this.flatCoordinates_.length,
      2,
      0.5
    )), this.flatMidpoints_;
  }
  /**
   * @return {Array<number>} Flat midpoints.
   */
  getFlatMidpoints() {
    if (!this.flatMidpoints_) {
      this.flatMidpoints_ = [];
      const e = this.flatCoordinates_;
      let n = 0;
      const i = (
        /** @type {Array<number>} */
        this.ends_
      );
      for (let s = 0, l = i.length; s < l; ++s) {
        const a = i[s], o = Yh(e, n, a, 2, 0.5);
        ni(this.flatMidpoints_, o), n = a;
      }
    }
    return this.flatMidpoints_;
  }
  /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */
  getId() {
    return this.id_;
  }
  /**
   * @return {Array<number>} Flat coordinates.
   */
  getOrientedFlatCoordinates() {
    return this.flatCoordinates_;
  }
  /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */
  getGeometry() {
    return this;
  }
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */
  getSimplifiedGeometry(e) {
    return this;
  }
  /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */
  simplifyTransformed(e, n) {
    return this;
  }
  /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */
  getProperties() {
    return this.properties_;
  }
  /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */
  getPropertiesInternal() {
    return this.properties_;
  }
  /**
   * @return {number} Stride.
   */
  getStride() {
    return this.stride_;
  }
  /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */
  getStyleFunction() {
    return this.styleFunction;
  }
  /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */
  getType() {
    return this.type_;
  }
  /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */
  transform(e) {
    e = ct(e);
    const n = e.getExtent(), i = e.getWorldExtent();
    if (n && i) {
      const s = G4(i) / G4(n);
      b8(
        aM,
        i[0],
        i[3],
        s,
        -s,
        0,
        0,
        0
      ), Cs(
        this.flatCoordinates_,
        0,
        this.flatCoordinates_.length,
        2,
        aM,
        this.flatCoordinates_
      );
    }
  }
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */
  applyTransform(e) {
    e(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
  }
  /**
   * @return {RenderFeature} A cloned render feature.
   */
  clone() {
    var e;
    return new Xa(
      this.type_,
      this.flatCoordinates_.slice(),
      (e = this.ends_) == null ? void 0 : e.slice(),
      this.stride_,
      Object.assign({}, this.properties_),
      this.id_
    );
  }
  /**
   * @return {Array<number>|null} Ends.
   */
  getEnds() {
    return this.ends_;
  }
  /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */
  enableSimplifyTransformed() {
    return this.simplifyTransformed = FS((e, n) => {
      if (e === this.squaredTolerance_)
        return this.simplifiedGeometry_;
      this.simplifiedGeometry_ = this.clone(), n && this.simplifiedGeometry_.applyTransform(n);
      const i = this.simplifiedGeometry_.getFlatCoordinates();
      let s;
      switch (this.type_) {
        case "LineString":
          i.length = Ku(
            i,
            0,
            this.simplifiedGeometry_.flatCoordinates_.length,
            this.simplifiedGeometry_.stride_,
            e,
            i,
            0
          ), s = [i.length];
          break;
        case "MultiLineString":
          s = [], i.length = BS(
            i,
            0,
            this.simplifiedGeometry_.ends_,
            this.simplifiedGeometry_.stride_,
            e,
            i,
            0,
            s
          );
          break;
        case "Polygon":
          s = [], i.length = lq(
            i,
            0,
            this.simplifiedGeometry_.ends_,
            this.simplifiedGeometry_.stride_,
            Math.sqrt(e),
            i,
            0,
            s
          );
          break;
      }
      return s && (this.simplifiedGeometry_ = new Xa(
        this.type_,
        i,
        s,
        2,
        this.properties_,
        this.id_
      )), this.squaredTolerance_ = e, this.simplifiedGeometry_;
    }), this;
  }
}
Xa.prototype.getFlatCoordinates = Xa.prototype.getOrientedFlatCoordinates;
const ms = Xa;
class Pq1 extends gn {
  /**
   * @param {Options} options Source options.
   */
  constructor(e) {
    super(), this.projection = ct(e.projection), this.attributions_ = oM(e.attributions), this.attributionsCollapsible_ = e.attributionsCollapsible ?? !0, this.loading = !1, this.state_ = e.state !== void 0 ? e.state : "ready", this.wrapX_ = e.wrapX !== void 0 ? e.wrapX : !1, this.interpolate_ = !!e.interpolate, this.viewResolver = null, this.viewRejector = null;
    const n = this;
    this.viewPromise_ = new Promise(function(i, s) {
      n.viewResolver = i, n.viewRejector = s;
    });
  }
  /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */
  getAttributions() {
    return this.attributions_;
  }
  /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */
  getAttributionsCollapsible() {
    return this.attributionsCollapsible_;
  }
  /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */
  getProjection() {
    return this.projection;
  }
  /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */
  getResolutions(e) {
    return null;
  }
  /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */
  getView() {
    return this.viewPromise_;
  }
  /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */
  getState() {
    return this.state_;
  }
  /**
   * @return {boolean|undefined} Wrap X.
   */
  getWrapX() {
    return this.wrapX_;
  }
  /**
   * @return {boolean} Use linear interpolation when resampling.
   */
  getInterpolate() {
    return this.interpolate_;
  }
  /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */
  refresh() {
    this.changed();
  }
  /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */
  setAttributions(e) {
    this.attributions_ = oM(e), this.changed();
  }
  /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */
  setState(e) {
    this.state_ = e, this.changed();
  }
}
function oM(t) {
  return t ? typeof t == "function" ? t : (Array.isArray(t) || (t = [t]), (e) => t) : null;
}
const kC = Pq1, g6 = {
  /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */
  ADDFEATURE: "addfeature",
  /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */
  CHANGEFEATURE: "changefeature",
  /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */
  CLEAR: "clear",
  /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */
  REMOVEFEATURE: "removefeature",
  /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */
  FEATURESLOADSTART: "featuresloadstart",
  /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */
  FEATURESLOADEND: "featuresloadend",
  /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */
  FEATURESLOADERROR: "featuresloaderror"
};
function Bq1(t, e) {
  return [[-1 / 0, -1 / 0, 1 / 0, 1 / 0]];
}
let Vq1 = !1;
function Rq1(t, e, n, i, s, l, a) {
  const o = new XMLHttpRequest();
  o.open(
    "GET",
    typeof t == "function" ? t(n, i, s) : t,
    !0
  ), e.getType() == "arraybuffer" && (o.responseType = "arraybuffer"), o.withCredentials = Vq1, o.onload = function(h) {
    if (!o.status || o.status >= 200 && o.status < 300) {
      const u = e.getType();
      try {
        let d;
        u == "text" || u == "json" ? d = o.responseText : u == "xml" ? d = o.responseXML || o.responseText : u == "arraybuffer" && (d = /** @type {ArrayBuffer} */
        o.response), d ? l(
          /** @type {Array<FeatureType>} */
          e.readFeatures(d, {
            extent: n,
            featureProjection: s
          }),
          e.readProjection(d)
        ) : a();
      } catch {
        a();
      }
    } else
      a();
  }, o.onerror = a, o.send();
}
function cM(t, e) {
  return function(n, i, s, l, a) {
    const o = (
      /** @type {import("./source/Vector").default<FeatureType>} */
      this
    );
    Rq1(
      t,
      e,
      n,
      i,
      s,
      /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */
      function(h, u) {
        o.addFeatures(h), l !== void 0 && l(h);
      },
      /* FIXME handle error */
      a || ja
    );
  };
}
class cs extends k8 {
  /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */
  constructor(e, n, i) {
    super(e), this.feature = n, this.features = i;
  }
}
class Hq1 extends kC {
  /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */
  constructor(e) {
    e = e || {}, super({
      attributions: e.attributions,
      interpolate: !0,
      projection: void 0,
      state: "ready",
      wrapX: e.wrapX !== void 0 ? e.wrapX : !0
    }), this.on, this.once, this.un, this.loader_ = ja, this.format_ = e.format || null, this.overlaps_ = e.overlaps === void 0 ? !0 : e.overlaps, this.url_ = e.url, e.loader !== void 0 ? this.loader_ = e.loader : this.url_ !== void 0 && (ge(this.format_, "`format` must be set when `url` is set"), this.loader_ = cM(this.url_, this.format_)), this.strategy_ = e.strategy !== void 0 ? e.strategy : Bq1;
    const n = e.useSpatialIndex !== void 0 ? e.useSpatialIndex : !0;
    this.featuresRtree_ = n ? new rM() : null, this.loadedExtentsRtree_ = new rM(), this.loadingExtentsCount_ = 0, this.nullGeometryFeatures_ = {}, this.idIndex_ = {}, this.uidIndex_ = {}, this.featureChangeKeys_ = {}, this.featuresCollection_ = null;
    let i, s;
    Array.isArray(e.features) ? s = e.features : e.features && (i = e.features, s = i.getArray()), !n && i === void 0 && (i = new z6(s)), s !== void 0 && this.addFeaturesInternal(s), i !== void 0 && this.bindFeaturesCollection_(i);
  }
  /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */
  addFeature(e) {
    this.addFeatureInternal(e), this.changed();
  }
  /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */
  addFeatureInternal(e) {
    const n = Be(e);
    if (!this.addToIndex_(n, e)) {
      this.featuresCollection_ && this.featuresCollection_.remove(e);
      return;
    }
    this.setupChangeEvents_(n, e);
    const i = e.getGeometry();
    if (i) {
      const s = i.getExtent();
      this.featuresRtree_ && this.featuresRtree_.insert(s, e);
    } else
      this.nullGeometryFeatures_[n] = e;
    this.dispatchEvent(
      new cs(g6.ADDFEATURE, e)
    );
  }
  /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */
  setupChangeEvents_(e, n) {
    n instanceof ms || (this.featureChangeKeys_[e] = [
      ae(n, T3.CHANGE, this.handleFeatureChange_, this),
      ae(
        n,
        Ua.PROPERTYCHANGE,
        this.handleFeatureChange_,
        this
      )
    ]);
  }
  /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */
  addToIndex_(e, n) {
    let i = !0;
    if (n.getId() !== void 0) {
      const s = String(n.getId());
      if (!(s in this.idIndex_))
        this.idIndex_[s] = n;
      else if (n instanceof ms) {
        const l = this.idIndex_[s];
        l instanceof ms ? Array.isArray(l) ? l.push(n) : this.idIndex_[s] = [l, n] : i = !1;
      } else
        i = !1;
    }
    return i && (ge(
      !(e in this.uidIndex_),
      "The passed `feature` was already added to the source"
    ), this.uidIndex_[e] = n), i;
  }
  /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */
  addFeatures(e) {
    this.addFeaturesInternal(e), this.changed();
  }
  /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */
  addFeaturesInternal(e) {
    const n = [], i = [], s = [];
    for (let l = 0, a = e.length; l < a; l++) {
      const o = e[l], h = Be(o);
      this.addToIndex_(h, o) && i.push(o);
    }
    for (let l = 0, a = i.length; l < a; l++) {
      const o = i[l], h = Be(o);
      this.setupChangeEvents_(h, o);
      const u = o.getGeometry();
      if (u) {
        const d = u.getExtent();
        n.push(d), s.push(o);
      } else
        this.nullGeometryFeatures_[h] = o;
    }
    if (this.featuresRtree_ && this.featuresRtree_.load(n, s), this.hasListener(g6.ADDFEATURE))
      for (let l = 0, a = i.length; l < a; l++)
        this.dispatchEvent(
          new cs(g6.ADDFEATURE, i[l])
        );
  }
  /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */
  bindFeaturesCollection_(e) {
    let n = !1;
    this.addEventListener(
      g6.ADDFEATURE,
      /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */
      function(i) {
        n || (n = !0, e.push(i.feature), n = !1);
      }
    ), this.addEventListener(
      g6.REMOVEFEATURE,
      /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */
      function(i) {
        n || (n = !0, e.remove(i.feature), n = !1);
      }
    ), e.addEventListener(
      i0.ADD,
      /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */
      (i) => {
        n || (n = !0, this.addFeature(i.element), n = !1);
      }
    ), e.addEventListener(
      i0.REMOVE,
      /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */
      (i) => {
        n || (n = !0, this.removeFeature(i.element), n = !1);
      }
    ), this.featuresCollection_ = e;
  }
  /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */
  clear(e) {
    if (e) {
      for (const i in this.featureChangeKeys_)
        this.featureChangeKeys_[i].forEach(Qe);
      this.featuresCollection_ || (this.featureChangeKeys_ = {}, this.idIndex_ = {}, this.uidIndex_ = {});
    } else if (this.featuresRtree_) {
      const i = (s) => {
        this.removeFeatureInternal(s);
      };
      this.featuresRtree_.forEach(i);
      for (const s in this.nullGeometryFeatures_)
        this.removeFeatureInternal(this.nullGeometryFeatures_[s]);
    }
    this.featuresCollection_ && this.featuresCollection_.clear(), this.featuresRtree_ && this.featuresRtree_.clear(), this.nullGeometryFeatures_ = {};
    const n = new cs(g6.CLEAR);
    this.dispatchEvent(n), this.changed();
  }
  /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */
  forEachFeature(e) {
    if (this.featuresRtree_)
      return this.featuresRtree_.forEach(e);
    this.featuresCollection_ && this.featuresCollection_.forEach(e);
  }
  /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */
  forEachFeatureAtCoordinateDirect(e, n) {
    const i = [e[0], e[1], e[0], e[1]];
    return this.forEachFeatureInExtent(i, function(s) {
      const l = s.getGeometry();
      if (l instanceof ms || l.intersectsCoordinate(e))
        return n(s);
    });
  }
  /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */
  forEachFeatureInExtent(e, n) {
    if (this.featuresRtree_)
      return this.featuresRtree_.forEachInExtent(e, n);
    this.featuresCollection_ && this.featuresCollection_.forEach(n);
  }
  /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */
  forEachFeatureIntersectingExtent(e, n) {
    return this.forEachFeatureInExtent(
      e,
      /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */
      function(i) {
        const s = i.getGeometry();
        if (s instanceof ms || s.intersectsExtent(e)) {
          const l = n(i);
          if (l)
            return l;
        }
      }
    );
  }
  /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */
  getFeaturesCollection() {
    return this.featuresCollection_;
  }
  /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */
  getFeatures() {
    let e;
    return this.featuresCollection_ ? e = this.featuresCollection_.getArray().slice(0) : this.featuresRtree_ && (e = this.featuresRtree_.getAll(), mr(this.nullGeometryFeatures_) || ni(e, Object.values(this.nullGeometryFeatures_))), e;
  }
  /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */
  getFeaturesAtCoordinate(e) {
    const n = [];
    return this.forEachFeatureAtCoordinateDirect(e, function(i) {
      n.push(i);
    }), n;
  }
  /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */
  getFeaturesInExtent(e, n) {
    if (this.featuresRtree_) {
      if (!(n && n.canWrapX() && this.getWrapX()))
        return this.featuresRtree_.getInExtent(e);
      const s = G_(e, n);
      return [].concat(
        ...s.map((l) => this.featuresRtree_.getInExtent(l))
      );
    }
    return this.featuresCollection_ ? this.featuresCollection_.getArray().slice(0) : [];
  }
  /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType} Closest feature.
   * @api
   */
  getClosestFeatureToCoordinate(e, n) {
    const i = e[0], s = e[1];
    let l = null;
    const a = [NaN, NaN];
    let o = 1 / 0;
    const h = [-1 / 0, -1 / 0, 1 / 0, 1 / 0];
    return n = n || Go, this.featuresRtree_.forEachInExtent(
      h,
      /**
       * @param {FeatureType} feature Feature.
       */
      function(u) {
        if (n(u)) {
          const d = u.getGeometry(), v = o;
          if (o = d instanceof ms ? 0 : d.closestPointXY(i, s, a, o), o < v) {
            l = u;
            const m = Math.sqrt(o);
            h[0] = i - m, h[1] = s - m, h[2] = i + m, h[3] = s + m;
          }
        }
      }
    ), l;
  }
  /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getExtent(e) {
    return this.featuresRtree_.getExtent(e);
  }
  /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */
  getFeatureById(e) {
    const n = this.idIndex_[e.toString()];
    return n !== void 0 ? (
      /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */
      n
    ) : null;
  }
  /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */
  getFeatureByUid(e) {
    const n = this.uidIndex_[e];
    return n !== void 0 ? n : null;
  }
  /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */
  getFormat() {
    return this.format_;
  }
  /**
   * @return {boolean} The source can have overlapping geometries.
   */
  getOverlaps() {
    return this.overlaps_;
  }
  /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */
  getUrl() {
    return this.url_;
  }
  /**
   * @param {Event} event Event.
   * @private
   */
  handleFeatureChange_(e) {
    const n = (
      /** @type {FeatureType} */
      e.target
    ), i = Be(n), s = n.getGeometry();
    if (!s)
      i in this.nullGeometryFeatures_ || (this.featuresRtree_ && this.featuresRtree_.remove(n), this.nullGeometryFeatures_[i] = n);
    else {
      const a = s.getExtent();
      i in this.nullGeometryFeatures_ ? (delete this.nullGeometryFeatures_[i], this.featuresRtree_ && this.featuresRtree_.insert(a, n)) : this.featuresRtree_ && this.featuresRtree_.update(a, n);
    }
    const l = n.getId();
    if (l !== void 0) {
      const a = l.toString();
      this.idIndex_[a] !== n && (this.removeFromIdIndex_(n), this.idIndex_[a] = n);
    } else
      this.removeFromIdIndex_(n), this.uidIndex_[i] = n;
    this.changed(), this.dispatchEvent(
      new cs(g6.CHANGEFEATURE, n)
    );
  }
  /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */
  hasFeature(e) {
    const n = e.getId();
    return n !== void 0 ? n in this.idIndex_ : Be(e) in this.uidIndex_;
  }
  /**
   * @return {boolean} Is empty.
   */
  isEmpty() {
    return this.featuresRtree_ ? this.featuresRtree_.isEmpty() && mr(this.nullGeometryFeatures_) : this.featuresCollection_ ? this.featuresCollection_.getLength() === 0 : !0;
  }
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */
  loadFeatures(e, n, i) {
    const s = this.loadedExtentsRtree_, l = this.strategy_(e, n, i);
    for (let a = 0, o = l.length; a < o; ++a) {
      const h = l[a];
      s.forEachInExtent(
        h,
        /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */
        function(d) {
          return tr(d.extent, h);
        }
      ) || (++this.loadingExtentsCount_, this.dispatchEvent(
        new cs(g6.FEATURESLOADSTART)
      ), this.loader_.call(
        this,
        h,
        n,
        i,
        (d) => {
          --this.loadingExtentsCount_, this.dispatchEvent(
            new cs(
              g6.FEATURESLOADEND,
              void 0,
              d
            )
          );
        },
        () => {
          --this.loadingExtentsCount_, this.dispatchEvent(
            new cs(g6.FEATURESLOADERROR)
          );
        }
      ), s.insert(h, { extent: h.slice() }));
    }
    this.loading = this.loader_.length < 4 ? !1 : this.loadingExtentsCount_ > 0;
  }
  /**
   * @override
   */
  refresh() {
    this.clear(!0), this.loadedExtentsRtree_.clear(), super.refresh();
  }
  /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */
  removeLoadedExtent(e) {
    const n = this.loadedExtentsRtree_;
    let i;
    n.forEachInExtent(e, function(s) {
      if ($o(s.extent, e))
        return i = s, !0;
    }), i && n.remove(i);
  }
  /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */
  removeFeatures(e) {
    let n = !1;
    for (let i = 0, s = e.length; i < s; ++i)
      n = this.removeFeatureInternal(e[i]) || n;
    n && this.changed();
  }
  /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */
  removeFeature(e) {
    if (!e)
      return;
    this.removeFeatureInternal(e) && this.changed();
  }
  /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */
  removeFeatureInternal(e) {
    const n = Be(e);
    if (!(n in this.uidIndex_))
      return !1;
    n in this.nullGeometryFeatures_ ? delete this.nullGeometryFeatures_[n] : this.featuresRtree_ && this.featuresRtree_.remove(e);
    const i = this.featureChangeKeys_[n];
    i == null || i.forEach(Qe), delete this.featureChangeKeys_[n];
    const s = e.getId();
    if (s !== void 0) {
      const l = s.toString(), a = this.idIndex_[l];
      a === e ? delete this.idIndex_[l] : Array.isArray(a) && (a.splice(a.indexOf(e), 1), a.length === 1 && (this.idIndex_[l] = a[0]));
    }
    return delete this.uidIndex_[n], this.hasListener(g6.REMOVEFEATURE) && this.dispatchEvent(
      new cs(g6.REMOVEFEATURE, e)
    ), !0;
  }
  /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */
  removeFromIdIndex_(e) {
    for (const n in this.idIndex_)
      if (this.idIndex_[n] === e) {
        delete this.idIndex_[n];
        break;
      }
  }
  /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader<FeatureType>} loader The loader to set.
   * @api
   */
  setLoader(e) {
    this.loader_ = e;
  }
  /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */
  setUrl(e) {
    ge(this.format_, "`format` must be set when `url` is set"), this.url_ = e, this.setLoader(cM(e, this.format_));
  }
}
const EC = Hq1, H2 = {
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  /**
   * Indicates that tile loading failed
   * @type {number}
   */
  ERROR: 3,
  EMPTY: 4
};
class Dq1 extends Gu {
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */
  constructor(e, n, i) {
    super(), i = i || {}, this.tileCoord = e, this.state = n, this.key = "", this.transition_ = i.transition === void 0 ? 250 : i.transition, this.transitionStarts_ = {}, this.interpolate = !!i.interpolate;
  }
  /**
   * @protected
   */
  changed() {
    this.dispatchEvent(T3.CHANGE);
  }
  /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */
  release() {
    this.state === H2.ERROR && this.setState(H2.EMPTY);
  }
  /**
   * @return {string} Key.
   */
  getKey() {
    return this.key + "/" + this.tileCoord;
  }
  /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */
  getTileCoord() {
    return this.tileCoord;
  }
  /**
   * @return {import("./TileState.js").default} State.
   */
  getState() {
    return this.state;
  }
  /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */
  setState(e) {
    if (this.state !== H2.ERROR && this.state > e)
      throw new Error("Tile load sequence violation");
    this.state = e, this.changed();
  }
  /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */
  load() {
    b3();
  }
  /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */
  getAlpha(e, n) {
    if (!this.transition_)
      return 1;
    let i = this.transitionStarts_[e];
    if (!i)
      i = n, this.transitionStarts_[e] = i;
    else if (i === -1)
      return 1;
    const s = n - i + 1e3 / 60;
    return s >= this.transition_ ? 1 : oC(s / this.transition_);
  }
  /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */
  inTransition(e) {
    return this.transition_ ? this.transitionStarts_[e] !== -1 : !1;
  }
  /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */
  endTransition(e) {
    this.transition_ && (this.transitionStarts_[e] = -1);
  }
}
const Iq = Dq1;
class $q1 extends Iq {
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */
  constructor(e, n, i, s, l, a) {
    super(e, n, a), this.crossOrigin_ = s, this.src_ = i, this.key = i, this.image_ = new Image(), s !== null && (this.image_.crossOrigin = s), this.unlisten_ = null, this.tileLoadFunction_ = l;
  }
  /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */
  getImage() {
    return this.image_;
  }
  /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */
  setImage(e) {
    this.image_ = e, this.state = H2.LOADED, this.unlistenImage_(), this.changed();
  }
  /**
   * Tracks loading or read errors.
   *
   * @private
   */
  handleImageError_() {
    this.state = H2.ERROR, this.unlistenImage_(), this.image_ = Uq1(), this.changed();
  }
  /**
   * Tracks successful image load.
   *
   * @private
   */
  handleImageLoad_() {
    const e = (
      /** @type {HTMLImageElement} */
      this.image_
    );
    e.naturalWidth && e.naturalHeight ? this.state = H2.LOADED : this.state = H2.EMPTY, this.unlistenImage_(), this.changed();
  }
  /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */
  load() {
    this.state == H2.ERROR && (this.state = H2.IDLE, this.image_ = new Image(), this.crossOrigin_ !== null && (this.image_.crossOrigin = this.crossOrigin_)), this.state == H2.IDLE && (this.state = H2.LOADING, this.changed(), this.tileLoadFunction_(this, this.src_), this.unlisten_ = fy1(
      this.image_,
      this.handleImageLoad_.bind(this),
      this.handleImageError_.bind(this)
    ));
  }
  /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */
  unlistenImage_() {
    this.unlisten_ && (this.unlisten_(), this.unlisten_ = null);
  }
}
function Uq1() {
  const t = u4(1, 1);
  return t.fillStyle = "rgba(0,0,0,0)", t.fillRect(0, 0, 1, 1), t.canvas;
}
const AC = $q1;
class jq1 {
  /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */
  constructor(e, n, i) {
    this.decay_ = e, this.minVelocity_ = n, this.delay_ = i, this.points_ = [], this.angle_ = 0, this.initialVelocity_ = 0;
  }
  /**
   * FIXME empty description for jsdoc
   */
  begin() {
    this.points_.length = 0, this.angle_ = 0, this.initialVelocity_ = 0;
  }
  /**
   * @param {number} x X.
   * @param {number} y Y.
   */
  update(e, n) {
    this.points_.push(e, n, Date.now());
  }
  /**
   * @return {boolean} Whether we should do kinetic animation.
   */
  end() {
    if (this.points_.length < 6)
      return !1;
    const e = Date.now() - this.delay_, n = this.points_.length - 3;
    if (this.points_[n + 2] < e)
      return !1;
    let i = n - 3;
    for (; i > 0 && this.points_[i + 2] > e; )
      i -= 3;
    const s = this.points_[n + 2] - this.points_[i + 2];
    if (s < 1e3 / 60)
      return !1;
    const l = this.points_[n] - this.points_[i], a = this.points_[n + 1] - this.points_[i + 1];
    return this.angle_ = Math.atan2(a, l), this.initialVelocity_ = Math.sqrt(l * l + a * a) / s, this.initialVelocity_ > this.minVelocity_;
  }
  /**
   * @return {number} Total distance travelled (pixels).
   */
  getDistance() {
    return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
  }
  /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */
  getAngle() {
    return this.angle_;
  }
}
const Gq1 = jq1;
class Wq1 extends J_ {
  /**
   * @param {import("../Map.js").default} map Map.
   */
  constructor(e) {
    super(), this.map_ = e;
  }
  /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */
  dispatchRenderEvent(e, n) {
    b3();
  }
  /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */
  calculateMatrices2D(e) {
    const n = e.viewState, i = e.coordinateToPixelTransform, s = e.pixelToCoordinateTransform;
    b8(
      i,
      e.size[0] / 2,
      e.size[1] / 2,
      1 / n.resolution,
      -1 / n.resolution,
      -n.rotation,
      -n.center[0],
      -n.center[1]
    ), IS(s, i);
  }
  /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */
  forEachFeatureAtCoordinate(e, n, i, s, l, a, o, h) {
    let u;
    const d = n.viewState;
    function v(k, F, D, R) {
      return l.call(a, F, k ? D : null, R);
    }
    const m = d.projection, p = bS(e.slice(), m), _ = [[0, 0]];
    if (m.canWrapX() && s) {
      const k = m.getExtent(), F = ue(k);
      _.push([-F, 0], [F, 0]);
    }
    const q = n.layerStatesArray, M = q.length, z = (
      /** @type {Array<HitMatch<T>>} */
      []
    ), b = [];
    for (let k = 0; k < _.length; k++)
      for (let F = M - 1; F >= 0; --F) {
        const D = q[F], R = D.layer;
        if (R.hasRenderer() && Cq(D, d) && o.call(h, R)) {
          const V = R.getRenderer(), J = R.getSource();
          if (V && J) {
            const K = J.getWrapX() ? p : e, P = v.bind(
              null,
              D.managed
            );
            b[0] = K[0] + _[k][0], b[1] = K[1] + _[k][1], u = V.forEachFeatureAtCoordinate(
              b,
              n,
              i,
              P,
              z
            );
          }
          if (u)
            return u;
        }
      }
    if (z.length === 0)
      return;
    const x = 1 / z.length;
    return z.forEach((k, F) => k.distanceSq += F * x), z.sort((k, F) => k.distanceSq - F.distanceSq), z.some((k) => u = k.callback(k.feature, k.layer, k.geometry)), u;
  }
  /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */
  hasFeatureAtCoordinate(e, n, i, s, l, a) {
    return this.forEachFeatureAtCoordinate(
      e,
      n,
      i,
      s,
      Go,
      this,
      l,
      a
    ) !== void 0;
  }
  /**
   * @return {import("../Map.js").default} Map.
   */
  getMap() {
    return this.map_;
  }
  /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */
  renderFrame(e) {
    b3();
  }
  /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */
  scheduleExpireIconCache(e) {
    Yn.canExpireCache() && e.postRenderFunctions.push(Yq1);
  }
}
function Yq1(t, e) {
  Yn.expire();
}
const Xq1 = Wq1;
class Kq1 extends Xq1 {
  /**
   * @param {import("../Map.js").default} map Map.
   */
  constructor(e) {
    super(e), this.fontChangeListenerKey_ = ae(
      o8,
      Ua.PROPERTYCHANGE,
      e.redrawText.bind(e)
    ), this.element_ = document.createElement("div");
    const n = this.element_.style;
    n.position = "absolute", n.width = "100%", n.height = "100%", n.zIndex = "0", this.element_.className = Qu + " ol-layers";
    const i = e.getViewport();
    i.insertBefore(this.element_, i.firstChild || null), this.children_ = [], this.renderedVisible_ = !0;
  }
  /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */
  dispatchRenderEvent(e, n) {
    const i = this.getMap();
    if (i.hasListener(e)) {
      const s = new qC(e, void 0, n);
      i.dispatchEvent(s);
    }
  }
  /**
   * @override
   */
  disposeInternal() {
    Qe(this.fontChangeListenerKey_), this.element_.remove(), super.disposeInternal();
  }
  /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */
  renderFrame(e) {
    if (!e) {
      this.renderedVisible_ && (this.element_.style.display = "none", this.renderedVisible_ = !1);
      return;
    }
    this.calculateMatrices2D(e), this.dispatchRenderEvent(M6.PRECOMPOSE, e);
    const n = e.layerStatesArray.sort(
      (o, h) => o.zIndex - h.zIndex
    );
    n.some(
      (o) => o.layer instanceof yC && o.layer.getDeclutter()
    ) && (e.declutter = {});
    const s = e.viewState;
    this.children_.length = 0;
    const l = [];
    let a = null;
    for (let o = 0, h = n.length; o < h; ++o) {
      const u = n[o];
      e.layerIndex = o;
      const d = u.layer, v = d.getSourceState();
      if (!Cq(u, s) || v != "ready" && v != "undefined") {
        d.unrender();
        continue;
      }
      const m = d.render(e, a);
      m && (m !== a && (this.children_.push(m), a = m), l.push(u));
    }
    this.declutter(e, l), dy1(this.element_, this.children_), this.dispatchRenderEvent(M6.POSTCOMPOSE, e), this.renderedVisible_ || (this.element_.style.display = "", this.renderedVisible_ = !0), this.scheduleExpireIconCache(e);
  }
  /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */
  declutter(e, n) {
    if (e.declutter) {
      for (let i = n.length - 1; i >= 0; --i) {
        const s = n[i], l = s.layer;
        l.getDeclutter() && l.renderDeclutter(e, s);
      }
      n.forEach(
        (i) => i.layer.renderDeferred(e)
      );
    }
  }
}
const Zq1 = Kq1;
class gs extends k8 {
  /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */
  constructor(e, n) {
    super(e), this.layer = n;
  }
}
const Bg = {
  LAYERS: "layers"
};
class Oq extends aC {
  /**
   * @param {Options} [options] Layer options.
   */
  constructor(e) {
    e = e || {};
    const n = (
      /** @type {Options} */
      Object.assign({}, e)
    );
    delete n.layers;
    let i = e.layers;
    super(n), this.on, this.once, this.un, this.layersListenerKeys_ = [], this.listenerKeys_ = {}, this.addChangeListener(Bg.LAYERS, this.handleLayersChanged_), i ? Array.isArray(i) ? i = new z6(i.slice(), { unique: !0 }) : ge(
      typeof /** @type {?} */
      i.getArray == "function",
      "Expected `layers` to be an array or a `Collection`"
    ) : i = new z6(void 0, { unique: !0 }), this.setLayers(i);
  }
  /**
   * @private
   */
  handleLayerChange_() {
    this.changed();
  }
  /**
   * @private
   */
  handleLayersChanged_() {
    this.layersListenerKeys_.forEach(Qe), this.layersListenerKeys_.length = 0;
    const e = this.getLayers();
    this.layersListenerKeys_.push(
      ae(e, i0.ADD, this.handleLayersAdd_, this),
      ae(
        e,
        i0.REMOVE,
        this.handleLayersRemove_,
        this
      )
    );
    for (const i in this.listenerKeys_)
      this.listenerKeys_[i].forEach(Qe);
    wc(this.listenerKeys_);
    const n = e.getArray();
    for (let i = 0, s = n.length; i < s; i++) {
      const l = n[i];
      this.registerLayerListeners_(l), this.dispatchEvent(new gs("addlayer", l));
    }
    this.changed();
  }
  /**
   * @param {BaseLayer} layer The layer.
   */
  registerLayerListeners_(e) {
    const n = [
      ae(
        e,
        Ua.PROPERTYCHANGE,
        this.handleLayerChange_,
        this
      ),
      ae(e, T3.CHANGE, this.handleLayerChange_, this)
    ];
    e instanceof Oq && n.push(
      ae(e, "addlayer", this.handleLayerGroupAdd_, this),
      ae(e, "removelayer", this.handleLayerGroupRemove_, this)
    ), this.listenerKeys_[Be(e)] = n;
  }
  /**
   * @param {GroupEvent} event The layer group event.
   */
  handleLayerGroupAdd_(e) {
    this.dispatchEvent(new gs("addlayer", e.layer));
  }
  /**
   * @param {GroupEvent} event The layer group event.
   */
  handleLayerGroupRemove_(e) {
    this.dispatchEvent(new gs("removelayer", e.layer));
  }
  /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */
  handleLayersAdd_(e) {
    const n = e.element;
    this.registerLayerListeners_(n), this.dispatchEvent(new gs("addlayer", n)), this.changed();
  }
  /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */
  handleLayersRemove_(e) {
    const n = e.element, i = Be(n);
    this.listenerKeys_[i].forEach(Qe), delete this.listenerKeys_[i], this.dispatchEvent(new gs("removelayer", n)), this.changed();
  }
  /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */
  getLayers() {
    return (
      /** @type {!Collection<import("./Base.js").default>} */
      this.get(Bg.LAYERS)
    );
  }
  /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */
  setLayers(e) {
    const n = this.getLayers();
    if (n) {
      const i = n.getArray();
      for (let s = 0, l = i.length; s < l; ++s)
        this.dispatchEvent(new gs("removelayer", i[s]));
    }
    this.set(Bg.LAYERS, e);
  }
  /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */
  getLayersArray(e) {
    return e = e !== void 0 ? e : [], this.getLayers().forEach(function(n) {
      n.getLayersArray(e);
    }), e;
  }
  /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */
  getLayerStatesArray(e) {
    const n = e !== void 0 ? e : [], i = n.length;
    this.getLayers().forEach(function(a) {
      a.getLayerStatesArray(n);
    });
    const s = this.getLayerState();
    let l = s.zIndex;
    !e && s.zIndex === void 0 && (l = 0);
    for (let a = i, o = n.length; a < o; a++) {
      const h = n[a];
      h.opacity *= s.opacity, h.visible = h.visible && s.visible, h.maxResolution = Math.min(
        h.maxResolution,
        s.maxResolution
      ), h.minResolution = Math.max(
        h.minResolution,
        s.minResolution
      ), h.minZoom = Math.max(h.minZoom, s.minZoom), h.maxZoom = Math.min(h.maxZoom, s.maxZoom), s.extent !== void 0 && (h.extent !== void 0 ? h.extent = rn(
        h.extent,
        s.extent
      ) : h.extent = s.extent), h.zIndex === void 0 && (h.zIndex = l);
    }
    return n;
  }
  /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */
  getSourceState() {
    return "ready";
  }
}
const sd = Oq;
class Jq1 extends k8 {
  /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */
  constructor(e, n, i) {
    super(e), this.map = n, this.frameState = i !== void 0 ? i : null;
  }
}
const oa = Jq1;
class Qq1 extends oa {
  /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */
  constructor(e, n, i, s, l, a) {
    super(e, n, l), this.originalEvent = i, this.pixel_ = null, this.coordinate_ = null, this.dragging = s !== void 0 ? s : !1, this.activePointers = a;
  }
  /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */
  get pixel() {
    return this.pixel_ || (this.pixel_ = this.map.getEventPixel(this.originalEvent)), this.pixel_;
  }
  set pixel(e) {
    this.pixel_ = e;
  }
  /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */
  get coordinate() {
    return this.coordinate_ || (this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel)), this.coordinate_;
  }
  set coordinate(e) {
    this.coordinate_ = e;
  }
  /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */
  preventDefault() {
    super.preventDefault(), "preventDefault" in this.originalEvent && this.originalEvent.preventDefault();
  }
  /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */
  stopPropagation() {
    super.stopPropagation(), "stopPropagation" in this.originalEvent && this.originalEvent.stopPropagation();
  }
}
const ps = Qq1, Bt = {
  /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */
  SINGLECLICK: "singleclick",
  /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */
  CLICK: T3.CLICK,
  /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */
  DBLCLICK: T3.DBLCLICK,
  /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */
  POINTERDRAG: "pointerdrag",
  /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */
  POINTERMOVE: "pointermove",
  POINTERDOWN: "pointerdown",
  POINTERUP: "pointerup",
  POINTEROVER: "pointerover",
  POINTEROUT: "pointerout",
  POINTERENTER: "pointerenter",
  POINTERLEAVE: "pointerleave",
  POINTERCANCEL: "pointercancel"
}, Ty = {
  POINTERMOVE: "pointermove",
  POINTERDOWN: "pointerdown",
  POINTERUP: "pointerup",
  POINTEROVER: "pointerover",
  POINTEROUT: "pointerout",
  POINTERENTER: "pointerenter",
  POINTERLEAVE: "pointerleave",
  POINTERCANCEL: "pointercancel"
};
class ew1 extends Gu {
  /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */
  constructor(e, n) {
    super(e), this.map_ = e, this.clickTimeoutId_, this.emulateClicks_ = !1, this.dragging_ = !1, this.dragListenerKeys_ = [], this.moveTolerance_ = n === void 0 ? 1 : n, this.down_ = null;
    const i = this.map_.getViewport();
    this.activePointers_ = [], this.trackedTouches_ = {}, this.element_ = i, this.pointerdownListenerKey_ = ae(
      i,
      Ty.POINTERDOWN,
      this.handlePointerDown_,
      this
    ), this.originalPointerMoveEvent_, this.relayedListenerKey_ = ae(
      i,
      Ty.POINTERMOVE,
      this.relayMoveEvent_,
      this
    ), this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this), this.element_.addEventListener(
      T3.TOUCHMOVE,
      this.boundHandleTouchMove_,
      JS ? { passive: !1 } : !1
    );
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  emulateClick_(e) {
    let n = new ps(
      Bt.CLICK,
      this.map_,
      e
    );
    this.dispatchEvent(n), this.clickTimeoutId_ !== void 0 ? (clearTimeout(this.clickTimeoutId_), this.clickTimeoutId_ = void 0, n = new ps(
      Bt.DBLCLICK,
      this.map_,
      e
    ), this.dispatchEvent(n)) : this.clickTimeoutId_ = setTimeout(() => {
      this.clickTimeoutId_ = void 0;
      const i = new ps(
        Bt.SINGLECLICK,
        this.map_,
        e
      );
      this.dispatchEvent(i);
    }, 250);
  }
  /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  updateActivePointers_(e) {
    const n = e, i = n.pointerId;
    if (n.type == Bt.POINTERUP || n.type == Bt.POINTERCANCEL) {
      delete this.trackedTouches_[i];
      for (const s in this.trackedTouches_)
        if (this.trackedTouches_[s].target !== n.target) {
          delete this.trackedTouches_[s];
          break;
        }
    } else
      (n.type == Bt.POINTERDOWN || n.type == Bt.POINTERMOVE) && (this.trackedTouches_[i] = n);
    this.activePointers_ = Object.values(this.trackedTouches_);
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  handlePointerUp_(e) {
    this.updateActivePointers_(e);
    const n = new ps(
      Bt.POINTERUP,
      this.map_,
      e,
      void 0,
      void 0,
      this.activePointers_
    );
    this.dispatchEvent(n), this.emulateClicks_ && !n.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(e) && this.emulateClick_(this.down_), this.activePointers_.length === 0 && (this.dragListenerKeys_.forEach(Qe), this.dragListenerKeys_.length = 0, this.dragging_ = !1, this.down_ = null);
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */
  isMouseActionButton_(e) {
    return e.button === 0;
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  handlePointerDown_(e) {
    this.emulateClicks_ = this.activePointers_.length === 0, this.updateActivePointers_(e);
    const n = new ps(
      Bt.POINTERDOWN,
      this.map_,
      e,
      void 0,
      void 0,
      this.activePointers_
    );
    if (this.dispatchEvent(n), this.down_ = new PointerEvent(e.type, e), Object.defineProperty(this.down_, "target", {
      writable: !1,
      value: e.target
    }), this.dragListenerKeys_.length === 0) {
      const i = this.map_.getOwnerDocument();
      this.dragListenerKeys_.push(
        ae(
          i,
          Bt.POINTERMOVE,
          this.handlePointerMove_,
          this
        ),
        ae(i, Bt.POINTERUP, this.handlePointerUp_, this),
        /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */
        ae(
          this.element_,
          Bt.POINTERCANCEL,
          this.handlePointerUp_,
          this
        )
      ), this.element_.getRootNode && this.element_.getRootNode() !== i && this.dragListenerKeys_.push(
        ae(
          this.element_.getRootNode(),
          Bt.POINTERUP,
          this.handlePointerUp_,
          this
        )
      );
    }
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  handlePointerMove_(e) {
    if (this.isMoving_(e)) {
      this.updateActivePointers_(e), this.dragging_ = !0;
      const n = new ps(
        Bt.POINTERDRAG,
        this.map_,
        e,
        this.dragging_,
        void 0,
        this.activePointers_
      );
      this.dispatchEvent(n);
    }
  }
  /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */
  relayMoveEvent_(e) {
    this.originalPointerMoveEvent_ = e;
    const n = !!(this.down_ && this.isMoving_(e));
    this.dispatchEvent(
      new ps(
        Bt.POINTERMOVE,
        this.map_,
        e,
        n
      )
    );
  }
  /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */
  handleTouchMove_(e) {
    const n = this.originalPointerMoveEvent_;
    (!n || n.defaultPrevented) && (typeof e.cancelable != "boolean" || e.cancelable === !0) && e.preventDefault();
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */
  isMoving_(e) {
    return this.dragging_ || Math.abs(e.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(e.clientY - this.down_.clientY) > this.moveTolerance_;
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    this.relayedListenerKey_ && (Qe(this.relayedListenerKey_), this.relayedListenerKey_ = null), this.element_.removeEventListener(
      T3.TOUCHMOVE,
      this.boundHandleTouchMove_
    ), this.pointerdownListenerKey_ && (Qe(this.pointerdownListenerKey_), this.pointerdownListenerKey_ = null), this.dragListenerKeys_.forEach(Qe), this.dragListenerKeys_.length = 0, this.element_ = null, super.disposeInternal();
  }
}
const tw1 = ew1, c8 = {
  /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */
  POSTRENDER: "postrender",
  /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */
  MOVESTART: "movestart",
  /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */
  MOVEEND: "moveend",
  /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */
  LOADSTART: "loadstart",
  /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */
  LOADEND: "loadend"
}, d5 = {
  LAYERGROUP: "layergroup",
  SIZE: "size",
  TARGET: "target",
  VIEW: "view"
}, su = 1 / 0;
class nw1 {
  /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */
  constructor(e, n) {
    this.priorityFunction_ = e, this.keyFunction_ = n, this.elements_ = [], this.priorities_ = [], this.queuedElements_ = {};
  }
  /**
   * FIXME empty description for jsdoc
   */
  clear() {
    this.elements_.length = 0, this.priorities_.length = 0, wc(this.queuedElements_);
  }
  /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */
  dequeue() {
    const e = this.elements_, n = this.priorities_, i = e[0];
    e.length == 1 ? (e.length = 0, n.length = 0) : (e[0] = /** @type {T} */
    e.pop(), n[0] = /** @type {number} */
    n.pop(), this.siftUp_(0));
    const s = this.keyFunction_(i);
    return delete this.queuedElements_[s], i;
  }
  /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */
  enqueue(e) {
    ge(
      !(this.keyFunction_(e) in this.queuedElements_),
      "Tried to enqueue an `element` that was already added to the queue"
    );
    const n = this.priorityFunction_(e);
    return n != su ? (this.elements_.push(e), this.priorities_.push(n), this.queuedElements_[this.keyFunction_(e)] = !0, this.siftDown_(0, this.elements_.length - 1), !0) : !1;
  }
  /**
   * @return {number} Count.
   */
  getCount() {
    return this.elements_.length;
  }
  /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */
  getLeftChildIndex_(e) {
    return e * 2 + 1;
  }
  /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */
  getRightChildIndex_(e) {
    return e * 2 + 2;
  }
  /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */
  getParentIndex_(e) {
    return e - 1 >> 1;
  }
  /**
   * Make this a heap. O(N).
   * @private
   */
  heapify_() {
    let e;
    for (e = (this.elements_.length >> 1) - 1; e >= 0; e--)
      this.siftUp_(e);
  }
  /**
   * @return {boolean} Is empty.
   */
  isEmpty() {
    return this.elements_.length === 0;
  }
  /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */
  isKeyQueued(e) {
    return e in this.queuedElements_;
  }
  /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */
  isQueued(e) {
    return this.isKeyQueued(this.keyFunction_(e));
  }
  /**
   * @param {number} index The index of the node to move down.
   * @private
   */
  siftUp_(e) {
    const n = this.elements_, i = this.priorities_, s = n.length, l = n[e], a = i[e], o = e;
    for (; e < s >> 1; ) {
      const h = this.getLeftChildIndex_(e), u = this.getRightChildIndex_(e), d = u < s && i[u] < i[h] ? u : h;
      n[e] = n[d], i[e] = i[d], e = d;
    }
    n[e] = l, i[e] = a, this.siftDown_(o, e);
  }
  /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */
  siftDown_(e, n) {
    const i = this.elements_, s = this.priorities_, l = i[n], a = s[n];
    for (; n > e; ) {
      const o = this.getParentIndex_(n);
      if (s[o] > a)
        i[n] = i[o], s[n] = s[o], n = o;
      else
        break;
    }
    i[n] = l, s[n] = a;
  }
  /**
   * FIXME empty description for jsdoc
   */
  reprioritize() {
    const e = this.priorityFunction_, n = this.elements_, i = this.priorities_;
    let s = 0;
    const l = n.length;
    let a, o, h;
    for (o = 0; o < l; ++o)
      a = n[o], h = e(a), h == su ? delete this.queuedElements_[this.keyFunction_(a)] : (i[s] = h, n[s++] = a);
    n.length = s, i.length = s, this.heapify_();
  }
}
const iw1 = nw1;
class sw1 extends iw1 {
  /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */
  constructor(e, n) {
    super(
      /**
       * @param {Array} element Element.
       * @return {number} Priority.
       */
      function(i) {
        return e.apply(null, i);
      },
      /**
       * @param {Array} element Element.
       * @return {string} Key.
       */
      function(i) {
        return (
          /** @type {import("./Tile.js").default} */
          i[0].getKey()
        );
      }
    ), this.boundHandleTileChange_ = this.handleTileChange.bind(this), this.tileChangeCallback_ = n, this.tilesLoading_ = 0, this.tilesLoadingKeys_ = {};
  }
  /**
   * @param {Array} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */
  enqueue(e) {
    const n = super.enqueue(e);
    return n && e[0].addEventListener(T3.CHANGE, this.boundHandleTileChange_), n;
  }
  /**
   * @return {number} Number of tiles loading.
   */
  getTilesLoading() {
    return this.tilesLoading_;
  }
  /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */
  handleTileChange(e) {
    const n = (
      /** @type {import("./Tile.js").default} */
      e.target
    ), i = n.getState();
    if (i === H2.LOADED || i === H2.ERROR || i === H2.EMPTY) {
      i !== H2.ERROR && n.removeEventListener(T3.CHANGE, this.boundHandleTileChange_);
      const s = n.getKey();
      s in this.tilesLoadingKeys_ && (delete this.tilesLoadingKeys_[s], --this.tilesLoading_), this.tileChangeCallback_();
    }
  }
  /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */
  loadMoreTiles(e, n) {
    let i = 0;
    for (; this.tilesLoading_ < e && i < n && this.getCount() > 0; ) {
      const s = this.dequeue()[0], l = s.getKey();
      s.getState() === H2.IDLE && !(l in this.tilesLoadingKeys_) && (this.tilesLoadingKeys_[l] = !0, ++this.tilesLoading_, ++i, s.load());
    }
  }
}
const lw1 = sw1;
function rw1(t, e, n, i, s) {
  if (!t || !(n in t.wantedTiles) || !t.wantedTiles[n][e.getKey()])
    return su;
  const l = t.viewState.center, a = i[0] - l[0], o = i[1] - l[1];
  return 65536 * Math.log(s) + Math.sqrt(a * a + o * o) / s;
}
class aw1 extends gn {
  /**
   * @param {Options} options Control options.
   */
  constructor(e) {
    super();
    const n = e.element;
    n && !e.target && !n.style.pointerEvents && (n.style.pointerEvents = "auto"), this.element = n || null, this.target_ = null, this.map_ = null, this.listenerKeys = [], e.render && (this.render = e.render), e.target && this.setTarget(e.target);
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    var e;
    (e = this.element) == null || e.remove(), super.disposeInternal();
  }
  /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */
  getMap() {
    return this.map_;
  }
  /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */
  setMap(e) {
    var n;
    this.map_ && ((n = this.element) == null || n.remove());
    for (let i = 0, s = this.listenerKeys.length; i < s; ++i)
      Qe(this.listenerKeys[i]);
    this.listenerKeys.length = 0, this.map_ = e, e && ((this.target_ ?? e.getOverlayContainerStopEvent()).appendChild(this.element), this.render !== ja && this.listenerKeys.push(
      ae(e, c8.POSTRENDER, this.render, this)
    ), e.render());
  }
  /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */
  render(e) {
  }
  /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */
  setTarget(e) {
    this.target_ = typeof e == "string" ? document.getElementById(e) : e;
  }
}
const r9 = aw1;
class ow1 extends r9 {
  /**
   * @param {Options} [options] Attribution options.
   */
  constructor(e) {
    e = e || {}, super({
      element: document.createElement("div"),
      render: e.render,
      target: e.target
    }), this.ulElement_ = document.createElement("ul"), this.collapsed_ = e.collapsed !== void 0 ? e.collapsed : !0, this.userCollapsed_ = this.collapsed_, this.overrideCollapsible_ = e.collapsible !== void 0, this.collapsible_ = e.collapsible !== void 0 ? e.collapsible : !0, this.collapsible_ || (this.collapsed_ = !1);
    const n = e.className !== void 0 ? e.className : "ol-attribution", i = e.tipLabel !== void 0 ? e.tipLabel : "Attributions", s = e.expandClassName !== void 0 ? e.expandClassName : n + "-expand", l = e.collapseLabel !== void 0 ? e.collapseLabel : "›", a = e.collapseClassName !== void 0 ? e.collapseClassName : n + "-collapse";
    typeof l == "string" ? (this.collapseLabel_ = document.createElement("span"), this.collapseLabel_.textContent = l, this.collapseLabel_.className = a) : this.collapseLabel_ = l;
    const o = e.label !== void 0 ? e.label : "i";
    typeof o == "string" ? (this.label_ = document.createElement("span"), this.label_.textContent = o, this.label_.className = s) : this.label_ = o;
    const h = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
    this.toggleButton_ = document.createElement("button"), this.toggleButton_.setAttribute("type", "button"), this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_)), this.toggleButton_.title = i, this.toggleButton_.appendChild(h), this.toggleButton_.addEventListener(
      T3.CLICK,
      this.handleClick_.bind(this),
      !1
    );
    const u = n + " " + Qu + " " + _q + (this.collapsed_ && this.collapsible_ ? " " + Pz : "") + (this.collapsible_ ? "" : " ol-uncollapsible"), d = this.element;
    d.className = u, d.appendChild(this.toggleButton_), d.appendChild(this.ulElement_), this.renderedAttributions_ = [], this.renderedVisible_ = !0;
  }
  /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */
  collectSourceAttributions_(e) {
    const n = this.getMap().getAllLayers(), i = Array.from(
      new Set(n.flatMap((s) => s.getAttributions(e)))
    );
    if (!this.overrideCollapsible_) {
      const s = !n.some(
        (l) => {
          var a;
          return ((a = l.getSource()) == null ? void 0 : a.getAttributionsCollapsible()) === !1;
        }
      );
      this.setCollapsible(s);
    }
    return i;
  }
  /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */
  async updateElement_(e) {
    if (!e) {
      this.renderedVisible_ && (this.element.style.display = "none", this.renderedVisible_ = !1);
      return;
    }
    const n = await Promise.all(
      this.collectSourceAttributions_(e).map(
        (s) => Sg1(() => s)
      )
    ), i = n.length > 0;
    if (this.renderedVisible_ != i && (this.element.style.display = i ? "" : "none", this.renderedVisible_ = i), !Ws(n, this.renderedAttributions_)) {
      QS(this.ulElement_);
      for (let s = 0, l = n.length; s < l; ++s) {
        const a = document.createElement("li");
        a.innerHTML = n[s], this.ulElement_.appendChild(a);
      }
      this.renderedAttributions_ = n;
    }
  }
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */
  handleClick_(e) {
    e.preventDefault(), this.handleToggle_(), this.userCollapsed_ = this.collapsed_;
  }
  /**
   * @private
   */
  handleToggle_() {
    this.element.classList.toggle(Pz), this.collapsed_ ? Oz(this.collapseLabel_, this.label_) : Oz(this.label_, this.collapseLabel_), this.collapsed_ = !this.collapsed_, this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
  }
  /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */
  getCollapsible() {
    return this.collapsible_;
  }
  /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */
  setCollapsible(e) {
    this.collapsible_ !== e && (this.collapsible_ = e, this.element.classList.toggle("ol-uncollapsible"), this.userCollapsed_ && this.handleToggle_());
  }
  /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */
  setCollapsed(e) {
    this.userCollapsed_ = e, !(!this.collapsible_ || this.collapsed_ === e) && this.handleToggle_();
  }
  /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */
  getCollapsed() {
    return this.collapsed_;
  }
  /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */
  render(e) {
    this.updateElement_(e.frameState);
  }
}
const cw1 = ow1;
class hw1 extends r9 {
  /**
   * @param {Options} [options] Rotate options.
   */
  constructor(e) {
    e = e || {}, super({
      element: document.createElement("div"),
      render: e.render,
      target: e.target
    });
    const n = e.className !== void 0 ? e.className : "ol-rotate", i = e.label !== void 0 ? e.label : "⇧", s = e.compassClassName !== void 0 ? e.compassClassName : "ol-compass";
    this.label_ = null, typeof i == "string" ? (this.label_ = document.createElement("span"), this.label_.className = s, this.label_.textContent = i) : (this.label_ = i, this.label_.classList.add(s));
    const l = e.tipLabel ? e.tipLabel : "Reset rotation", a = document.createElement("button");
    a.className = n + "-reset", a.setAttribute("type", "button"), a.title = l, a.appendChild(this.label_), a.addEventListener(
      T3.CLICK,
      this.handleClick_.bind(this),
      !1
    );
    const o = n + " " + Qu + " " + _q, h = this.element;
    h.className = o, h.appendChild(a), this.callResetNorth_ = e.resetNorth ? e.resetNorth : void 0, this.duration_ = e.duration !== void 0 ? e.duration : 250, this.autoHide_ = e.autoHide !== void 0 ? e.autoHide : !0, this.rotation_ = void 0, this.autoHide_ && this.element.classList.add(Kc);
  }
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */
  handleClick_(e) {
    e.preventDefault(), this.callResetNorth_ !== void 0 ? this.callResetNorth_() : this.resetNorth_();
  }
  /**
   * @private
   */
  resetNorth_() {
    const n = this.getMap().getView();
    if (!n)
      return;
    const i = n.getRotation();
    i !== void 0 && (this.duration_ > 0 && i % (2 * Math.PI) !== 0 ? n.animate({
      rotation: 0,
      duration: this.duration_,
      easing: l9
    }) : n.setRotation(0));
  }
  /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */
  render(e) {
    const n = e.frameState;
    if (!n)
      return;
    const i = n.viewState.rotation;
    if (i != this.rotation_) {
      const s = "rotate(" + i + "rad)";
      if (this.autoHide_) {
        const l = this.element.classList.contains(Kc);
        !l && i === 0 ? this.element.classList.add(Kc) : l && i !== 0 && this.element.classList.remove(Kc);
      }
      this.label_.style.transform = s;
    }
    this.rotation_ = i;
  }
}
const uw1 = hw1;
class dw1 extends r9 {
  /**
   * @param {Options} [options] Zoom options.
   */
  constructor(e) {
    e = e || {}, super({
      element: document.createElement("div"),
      target: e.target
    });
    const n = e.className !== void 0 ? e.className : "ol-zoom", i = e.delta !== void 0 ? e.delta : 1, s = e.zoomInClassName !== void 0 ? e.zoomInClassName : n + "-in", l = e.zoomOutClassName !== void 0 ? e.zoomOutClassName : n + "-out", a = e.zoomInLabel !== void 0 ? e.zoomInLabel : "+", o = e.zoomOutLabel !== void 0 ? e.zoomOutLabel : "–", h = e.zoomInTipLabel !== void 0 ? e.zoomInTipLabel : "Zoom in", u = e.zoomOutTipLabel !== void 0 ? e.zoomOutTipLabel : "Zoom out", d = document.createElement("button");
    d.className = s, d.setAttribute("type", "button"), d.title = h, d.appendChild(
      typeof a == "string" ? document.createTextNode(a) : a
    ), d.addEventListener(
      T3.CLICK,
      this.handleClick_.bind(this, i),
      !1
    );
    const v = document.createElement("button");
    v.className = l, v.setAttribute("type", "button"), v.title = u, v.appendChild(
      typeof o == "string" ? document.createTextNode(o) : o
    ), v.addEventListener(
      T3.CLICK,
      this.handleClick_.bind(this, -i),
      !1
    );
    const m = n + " " + Qu + " " + _q, p = this.element;
    p.className = m, p.appendChild(d), p.appendChild(v), this.duration_ = e.duration !== void 0 ? e.duration : 250;
  }
  /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */
  handleClick_(e, n) {
    n.preventDefault(), this.zoomByDelta_(e);
  }
  /**
   * @param {number} delta Zoom delta.
   * @private
   */
  zoomByDelta_(e) {
    const i = this.getMap().getView();
    if (!i)
      return;
    const s = i.getZoom();
    if (s !== void 0) {
      const l = i.getConstrainedZoom(s + e);
      this.duration_ > 0 ? (i.getAnimating() && i.cancelAnimations(), i.animate({
        zoom: l,
        duration: this.duration_,
        easing: l9
      })) : i.setZoom(l);
    }
  }
}
const fw1 = dw1;
function Iy(t) {
  t = t || {};
  const e = new z6();
  return (t.zoom !== void 0 ? t.zoom : !0) && e.push(new fw1(t.zoomOptions)), (t.rotate !== void 0 ? t.rotate : !0) && e.push(new uw1(t.rotateOptions)), (t.attribution !== void 0 ? t.attribution : !0) && e.push(new cw1(t.attributionOptions)), e;
}
const hM = {
  ACTIVE: "active"
};
class vw1 extends gn {
  /**
   * @param {InteractionOptions} [options] Options.
   */
  constructor(e) {
    super(), this.on, this.once, this.un, e && e.handleEvent && (this.handleEvent = e.handleEvent), this.map_ = null, this.setActive(!0);
  }
  /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */
  getActive() {
    return (
      /** @type {boolean} */
      this.get(hM.ACTIVE)
    );
  }
  /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */
  getMap() {
    return this.map_;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */
  handleEvent(e) {
    return !0;
  }
  /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */
  setActive(e) {
    this.set(hM.ACTIVE, e);
  }
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */
  setMap(e) {
    this.map_ = e;
  }
}
function pw1(t, e, n) {
  const i = t.getCenterInternal();
  if (i) {
    const s = [i[0] + e[0], i[1] + e[1]];
    t.animateInternal({
      duration: n !== void 0 ? n : 250,
      easing: Vy1,
      center: t.getConstrainedCenter(s)
    });
  }
}
function Nq(t, e, n, i) {
  const s = t.getZoom();
  if (s === void 0)
    return;
  const l = t.getConstrainedZoom(s + e), a = t.getResolutionForZoom(l);
  t.getAnimating() && t.cancelAnimations(), t.animate({
    resolution: a,
    anchor: n,
    duration: i !== void 0 ? i : 250,
    easing: l9
  });
}
const Sc = vw1;
class mw1 extends Sc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    super(), e = e || {}, this.delta_ = e.delta ? e.delta : 1, this.duration_ = e.duration !== void 0 ? e.duration : 250;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */
  handleEvent(e) {
    let n = !1;
    if (e.type == Bt.DBLCLICK) {
      const i = (
        /** @type {MouseEvent} */
        e.originalEvent
      ), s = e.map, l = e.coordinate, a = i.shiftKey ? -this.delta_ : this.delta_, o = s.getView();
      Nq(o, a, l, this.duration_), i.preventDefault(), n = !0;
    }
    return !n;
  }
}
const gw1 = mw1;
class yw1 extends Sc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {}, super(
      /** @type {import("./Interaction.js").InteractionOptions} */
      e
    ), e.handleDownEvent && (this.handleDownEvent = e.handleDownEvent), e.handleDragEvent && (this.handleDragEvent = e.handleDragEvent), e.handleMoveEvent && (this.handleMoveEvent = e.handleMoveEvent), e.handleUpEvent && (this.handleUpEvent = e.handleUpEvent), e.stopDown && (this.stopDown = e.stopDown), this.handlingDownUpSequence = !1, this.targetPointers = [];
  }
  /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */
  getPointerCount() {
    return this.targetPointers.length;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */
  handleDownEvent(e) {
    return !1;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */
  handleDragEvent(e) {
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */
  handleEvent(e) {
    if (!e.originalEvent)
      return !0;
    let n = !1;
    if (this.updateTrackedPointers_(e), this.handlingDownUpSequence) {
      if (e.type == Bt.POINTERDRAG)
        this.handleDragEvent(e), e.originalEvent.preventDefault();
      else if (e.type == Bt.POINTERUP) {
        const i = this.handleUpEvent(e);
        this.handlingDownUpSequence = i && this.targetPointers.length > 0;
      }
    } else if (e.type == Bt.POINTERDOWN) {
      const i = this.handleDownEvent(e);
      this.handlingDownUpSequence = i, n = this.stopDown(i);
    } else
      e.type == Bt.POINTERMOVE && this.handleMoveEvent(e);
    return !n;
  }
  /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */
  handleMoveEvent(e) {
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */
  handleUpEvent(e) {
    return !1;
  }
  /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */
  stopDown(e) {
    return e;
  }
  /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */
  updateTrackedPointers_(e) {
    e.activePointers && (this.targetPointers = e.activePointers);
  }
}
function Pq(t) {
  const e = t.length;
  let n = 0, i = 0;
  for (let s = 0; s < e; s++)
    n += t[s].clientX, i += t[s].clientY;
  return { clientX: n / e, clientY: i / e };
}
const Cc = yw1;
function Oy(t) {
  const e = arguments;
  return function(n) {
    let i = !0;
    for (let s = 0, l = e.length; s < l && (i = i && e[s](n), !!i); ++s)
      ;
    return i;
  };
}
const _w1 = function(t) {
  const e = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    t.originalEvent
  );
  return e.altKey && !(e.metaKey || e.ctrlKey) && e.shiftKey;
}, qw1 = function(t) {
  const e = t.map.getTargetElement(), n = t.map.getOwnerDocument().activeElement;
  return e.contains(n);
}, FC = function(t) {
  return t.map.getTargetElement().hasAttribute("tabindex") ? qw1(t) : !0;
}, ww1 = Go, TC = function(t) {
  const e = (
    /** @type {MouseEvent} */
    t.originalEvent
  );
  return e.button == 0 && !(cy1 && fq && e.ctrlKey);
}, IC = function(t) {
  const e = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    t.originalEvent
  );
  return !e.altKey && !(e.metaKey || e.ctrlKey) && !e.shiftKey;
}, zw1 = function(t) {
  const e = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    t.originalEvent
  );
  return !e.altKey && (fq ? e.metaKey : e.ctrlKey) && !e.shiftKey;
}, Mw1 = function(t) {
  const e = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    t.originalEvent
  );
  return fq ? e.metaKey : e.ctrlKey;
}, bw1 = function(t) {
  const e = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    t.originalEvent
  );
  return !e.altKey && !(e.metaKey || e.ctrlKey) && e.shiftKey;
}, OC = function(t) {
  const e = (
    /** @type {KeyboardEvent|MouseEvent|TouchEvent} */
    t.originalEvent
  ), n = (
    /** @type {Element} */
    e.target.tagName
  );
  return n !== "INPUT" && n !== "SELECT" && n !== "TEXTAREA" && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
  // different type like `SVGElement`.
  // @ts-ignore
  !e.target.isContentEditable;
}, Vg = function(t) {
  const e = (
    /** @type {import("../MapBrowserEvent").default} */
    t.originalEvent
  );
  return ge(
    e !== void 0,
    "mapBrowserEvent must originate from a pointer event"
  ), e.pointerType == "mouse";
}, Lw1 = function(t) {
  const e = (
    /** @type {import("../MapBrowserEvent").default} */
    t.originalEvent
  );
  return ge(
    e !== void 0,
    "mapBrowserEvent must originate from a pointer event"
  ), e.isPrimary && e.button === 0;
};
class xw1 extends Cc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    super({
      stopDown: ju
    }), e = e || {}, this.kinetic_ = e.kinetic, this.lastCentroid = null, this.lastPointersCount_, this.panning_ = !1;
    const n = e.condition ? e.condition : Oy(IC, Lw1);
    this.condition_ = e.onFocusOnly ? Oy(FC, n) : n, this.noKinetic_ = !1;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */
  handleDragEvent(e) {
    const n = e.map;
    this.panning_ || (this.panning_ = !0, n.getView().beginInteraction());
    const i = this.targetPointers, s = n.getEventPixel(Pq(i));
    if (i.length == this.lastPointersCount_) {
      if (this.kinetic_ && this.kinetic_.update(s[0], s[1]), this.lastCentroid) {
        const l = [
          this.lastCentroid[0] - s[0],
          s[1] - this.lastCentroid[1]
        ], o = e.map.getView();
        dg1(l, o.getResolution()), W_(l, o.getRotation()), o.adjustCenterInternal(l);
      }
    } else
      this.kinetic_ && this.kinetic_.begin();
    this.lastCentroid = s, this.lastPointersCount_ = i.length, e.originalEvent.preventDefault();
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleUpEvent(e) {
    const n = e.map, i = n.getView();
    if (this.targetPointers.length === 0) {
      if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
        const s = this.kinetic_.getDistance(), l = this.kinetic_.getAngle(), a = i.getCenterInternal(), o = n.getPixelFromCoordinateInternal(a), h = n.getCoordinateFromPixelInternal([
          o[0] - s * Math.cos(l),
          o[1] - s * Math.sin(l)
        ]);
        i.animateInternal({
          center: i.getConstrainedCenter(h),
          duration: 500,
          easing: l9
        });
      }
      return this.panning_ && (this.panning_ = !1, i.endInteraction()), !1;
    }
    return this.kinetic_ && this.kinetic_.begin(), this.lastCentroid = null, !0;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleDownEvent(e) {
    if (this.targetPointers.length > 0 && this.condition_(e)) {
      const i = e.map.getView();
      return this.lastCentroid = null, i.getAnimating() && i.cancelAnimations(), this.kinetic_ && this.kinetic_.begin(), this.noKinetic_ = this.targetPointers.length > 1, !0;
    }
    return !1;
  }
}
const NC = xw1;
class Sw1 extends Cc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {}, super({
      stopDown: ju
    }), this.condition_ = e.condition ? e.condition : _w1, this.lastAngle_ = void 0, this.duration_ = e.duration !== void 0 ? e.duration : 250;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */
  handleDragEvent(e) {
    if (!Vg(e))
      return;
    const n = e.map, i = n.getView();
    if (i.getConstraints().rotation === Sq)
      return;
    const s = n.getSize(), l = e.pixel, a = Math.atan2(s[1] / 2 - l[1], l[0] - s[0] / 2);
    if (this.lastAngle_ !== void 0) {
      const o = a - this.lastAngle_;
      i.adjustRotationInternal(-o);
    }
    this.lastAngle_ = a;
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleUpEvent(e) {
    return Vg(e) ? (e.map.getView().endInteraction(this.duration_), !1) : !0;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleDownEvent(e) {
    return Vg(e) && TC(e) && this.condition_(e) ? (e.map.getView().beginInteraction(), this.lastAngle_ = void 0, !0) : !1;
  }
}
const Cw1 = Sw1;
class kw1 extends J_ {
  /**
   * @param {string} className CSS class name.
   */
  constructor(e) {
    super(), this.geometry_ = null, this.element_ = document.createElement("div"), this.element_.style.position = "absolute", this.element_.style.pointerEvents = "auto", this.element_.className = "ol-box " + e, this.map_ = null, this.startPixel_ = null, this.endPixel_ = null;
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    this.setMap(null);
  }
  /**
   * @private
   */
  render_() {
    const e = this.startPixel_, n = this.endPixel_, i = "px", s = this.element_.style;
    s.left = Math.min(e[0], n[0]) + i, s.top = Math.min(e[1], n[1]) + i, s.width = Math.abs(n[0] - e[0]) + i, s.height = Math.abs(n[1] - e[1]) + i;
  }
  /**
   * @param {import("../Map.js").default|null} map Map.
   */
  setMap(e) {
    if (this.map_) {
      this.map_.getOverlayContainer().removeChild(this.element_);
      const n = this.element_.style;
      n.left = "inherit", n.top = "inherit", n.width = "inherit", n.height = "inherit";
    }
    this.map_ = e, this.map_ && this.map_.getOverlayContainer().appendChild(this.element_);
  }
  /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */
  setPixels(e, n) {
    this.startPixel_ = e, this.endPixel_ = n, this.createOrUpdateGeometry(), this.render_();
  }
  /**
   * Creates or updates the cached geometry.
   */
  createOrUpdateGeometry() {
    if (!this.map_)
      return;
    const e = this.startPixel_, n = this.endPixel_, s = [
      e,
      [e[0], n[1]],
      n,
      [n[0], e[1]]
    ].map(
      this.map_.getCoordinateFromPixelInternal,
      this.map_
    );
    s[4] = s[0].slice(), this.geometry_ ? this.geometry_.setCoordinates([s]) : this.geometry_ = new Os([s]);
  }
  /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */
  getGeometry() {
    return this.geometry_;
  }
}
const Ew1 = kw1, Z7 = {
  /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */
  BOXSTART: "boxstart",
  /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */
  BOXDRAG: "boxdrag",
  /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */
  BOXEND: "boxend",
  /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */
  BOXCANCEL: "boxcancel"
};
class nh extends k8 {
  /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */
  constructor(e, n, i) {
    super(e), this.coordinate = n, this.mapBrowserEvent = i;
  }
}
class Aw1 extends Cc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    super(), this.on, this.once, this.un, e = e || {}, this.box_ = new Ew1(e.className || "ol-dragbox"), this.minArea_ = e.minArea !== void 0 ? e.minArea : 64, e.onBoxEnd && (this.onBoxEnd = e.onBoxEnd), this.startPixel_ = null, this.condition_ = e.condition ? e.condition : TC, this.boxEndCondition_ = e.boxEndCondition ? e.boxEndCondition : this.defaultBoxEndCondition;
  }
  /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */
  defaultBoxEndCondition(e, n, i) {
    const s = i[0] - n[0], l = i[1] - n[1];
    return s * s + l * l >= this.minArea_;
  }
  /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */
  getGeometry() {
    return this.box_.getGeometry();
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */
  handleDragEvent(e) {
    this.startPixel_ && (this.box_.setPixels(this.startPixel_, e.pixel), this.dispatchEvent(
      new nh(
        Z7.BOXDRAG,
        e.coordinate,
        e
      )
    ));
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleUpEvent(e) {
    if (!this.startPixel_)
      return !1;
    this.box_.setMap(null);
    const n = this.boxEndCondition_(
      e,
      this.startPixel_,
      e.pixel
    );
    return n && this.onBoxEnd(e), this.dispatchEvent(
      new nh(
        n ? Z7.BOXEND : Z7.BOXCANCEL,
        e.coordinate,
        e
      )
    ), !1;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleDownEvent(e) {
    return this.condition_(e) ? (this.startPixel_ = e.pixel, this.box_.setMap(e.map), this.box_.setPixels(this.startPixel_, this.startPixel_), this.dispatchEvent(
      new nh(
        Z7.BOXSTART,
        e.coordinate,
        e
      )
    ), !0) : !1;
  }
  /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */
  onBoxEnd(e) {
  }
  /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */
  setActive(e) {
    e || (this.box_.setMap(null), this.startPixel_ && (this.dispatchEvent(
      new nh(Z7.BOXCANCEL, this.startPixel_, null)
    ), this.startPixel_ = null)), super.setActive(e);
  }
}
const Fw1 = Aw1;
class Tw1 extends Fw1 {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {};
    const n = e.condition ? e.condition : bw1;
    super({
      condition: n,
      className: e.className || "ol-dragzoom",
      minArea: e.minArea
    }), this.duration_ = e.duration !== void 0 ? e.duration : 200, this.out_ = e.out !== void 0 ? e.out : !1;
  }
  /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */
  onBoxEnd(e) {
    const i = (
      /** @type {!import("../View.js").default} */
      this.getMap().getView()
    );
    let s = this.getGeometry();
    if (this.out_) {
      const l = i.rotatedExtentForGeometry(s), a = i.getResolutionForExtentInternal(l), o = i.getResolution() / a;
      s = s.clone(), s.scale(o * o);
    }
    i.fitInternal(s, {
      duration: this.duration_,
      easing: l9
    });
  }
}
const Iw1 = Tw1, Wl = {
  LEFT: "ArrowLeft",
  UP: "ArrowUp",
  RIGHT: "ArrowRight",
  DOWN: "ArrowDown"
};
class Ow1 extends Sc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    super(), e = e || {}, this.defaultCondition_ = function(n) {
      return IC(n) && OC(n);
    }, this.condition_ = e.condition !== void 0 ? e.condition : this.defaultCondition_, this.duration_ = e.duration !== void 0 ? e.duration : 100, this.pixelDelta_ = e.pixelDelta !== void 0 ? e.pixelDelta : 128;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */
  handleEvent(e) {
    let n = !1;
    if (e.type == T3.KEYDOWN) {
      const i = (
        /** @type {KeyboardEvent} */
        e.originalEvent
      ), s = i.key;
      if (this.condition_(e) && (s == Wl.DOWN || s == Wl.LEFT || s == Wl.RIGHT || s == Wl.UP)) {
        const a = e.map.getView(), o = a.getResolution() * this.pixelDelta_;
        let h = 0, u = 0;
        s == Wl.DOWN ? u = -o : s == Wl.LEFT ? h = -o : s == Wl.RIGHT ? h = o : u = o;
        const d = [h, u];
        W_(d, a.getRotation()), pw1(a, d, this.duration_), i.preventDefault(), n = !0;
      }
    }
    return !n;
  }
}
const Nw1 = Ow1;
class Pw1 extends Sc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    super(), e = e || {}, this.condition_ = e.condition ? e.condition : function(n) {
      return !Mw1(n) && OC(n);
    }, this.delta_ = e.delta ? e.delta : 1, this.duration_ = e.duration !== void 0 ? e.duration : 100;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */
  handleEvent(e) {
    let n = !1;
    if (e.type == T3.KEYDOWN || e.type == T3.KEYPRESS) {
      const i = (
        /** @type {KeyboardEvent} */
        e.originalEvent
      ), s = i.key;
      if (this.condition_(e) && (s === "+" || s === "-")) {
        const l = e.map, a = s === "+" ? this.delta_ : -this.delta_, o = l.getView();
        Nq(o, a, void 0, this.duration_), i.preventDefault(), n = !0;
      }
    }
    return !n;
  }
}
const Bw1 = Pw1;
class Vw1 extends Sc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {}, super(
      /** @type {import("./Interaction.js").InteractionOptions} */
      e
    ), this.totalDelta_ = 0, this.lastDelta_ = 0, this.maxDelta_ = e.maxDelta !== void 0 ? e.maxDelta : 1, this.duration_ = e.duration !== void 0 ? e.duration : 250, this.timeout_ = e.timeout !== void 0 ? e.timeout : 80, this.useAnchor_ = e.useAnchor !== void 0 ? e.useAnchor : !0, this.constrainResolution_ = e.constrainResolution !== void 0 ? e.constrainResolution : !1;
    const n = e.condition ? e.condition : ww1;
    this.condition_ = e.onFocusOnly ? Oy(FC, n) : n, this.lastAnchor_ = null, this.startTime_ = void 0, this.timeoutId_, this.mode_ = void 0, this.trackpadEventGap_ = 400, this.trackpadTimeoutId_, this.deltaPerZoom_ = 300;
  }
  /**
   * @private
   */
  endInteraction_() {
    this.trackpadTimeoutId_ = void 0;
    const e = this.getMap();
    if (!e)
      return;
    e.getView().endInteraction(
      void 0,
      this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0,
      this.lastAnchor_
    );
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */
  handleEvent(e) {
    if (!this.condition_(e) || e.type !== T3.WHEEL)
      return !0;
    const i = e.map, s = (
      /** @type {WheelEvent} */
      e.originalEvent
    );
    s.preventDefault(), this.useAnchor_ && (this.lastAnchor_ = e.coordinate);
    let l;
    if (e.type == T3.WHEEL && (l = s.deltaY, ay1 && s.deltaMode === WheelEvent.DOM_DELTA_PIXEL && (l /= XS), s.deltaMode === WheelEvent.DOM_DELTA_LINE && (l *= 40)), l === 0)
      return !1;
    this.lastDelta_ = l;
    const a = Date.now();
    this.startTime_ === void 0 && (this.startTime_ = a), (!this.mode_ || a - this.startTime_ > this.trackpadEventGap_) && (this.mode_ = Math.abs(l) < 4 ? "trackpad" : "wheel");
    const o = i.getView();
    if (this.mode_ === "trackpad" && !(o.getConstrainResolution() || this.constrainResolution_))
      return this.trackpadTimeoutId_ ? clearTimeout(this.trackpadTimeoutId_) : (o.getAnimating() && o.cancelAnimations(), o.beginInteraction()), this.trackpadTimeoutId_ = setTimeout(
        this.endInteraction_.bind(this),
        this.timeout_
      ), o.adjustZoom(-l / this.deltaPerZoom_, this.lastAnchor_), this.startTime_ = a, !1;
    this.totalDelta_ += l;
    const h = Math.max(this.timeout_ - (a - this.startTime_), 0);
    return clearTimeout(this.timeoutId_), this.timeoutId_ = setTimeout(
      this.handleWheelZoom_.bind(this, i),
      h
    ), !1;
  }
  /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */
  handleWheelZoom_(e) {
    const n = e.getView();
    n.getAnimating() && n.cancelAnimations();
    let i = -bt(
      this.totalDelta_,
      -this.maxDelta_ * this.deltaPerZoom_,
      this.maxDelta_ * this.deltaPerZoom_
    ) / this.deltaPerZoom_;
    (n.getConstrainResolution() || this.constrainResolution_) && (i = i ? i > 0 ? 1 : -1 : 0), Nq(n, i, this.lastAnchor_, this.duration_), this.mode_ = void 0, this.totalDelta_ = 0, this.lastAnchor_ = null, this.startTime_ = void 0, this.timeoutId_ = void 0;
  }
  /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */
  setMouseAnchor(e) {
    this.useAnchor_ = e, e || (this.lastAnchor_ = null);
  }
}
const PC = Vw1;
class Rw1 extends Cc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {};
    const n = (
      /** @type {import("./Pointer.js").Options} */
      e
    );
    n.stopDown || (n.stopDown = ju), super(n), this.anchor_ = null, this.lastAngle_ = void 0, this.rotating_ = !1, this.rotationDelta_ = 0, this.threshold_ = e.threshold !== void 0 ? e.threshold : 0.3, this.duration_ = e.duration !== void 0 ? e.duration : 250;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */
  handleDragEvent(e) {
    let n = 0;
    const i = this.targetPointers[0], s = this.targetPointers[1], l = Math.atan2(
      s.clientY - i.clientY,
      s.clientX - i.clientX
    );
    if (this.lastAngle_ !== void 0) {
      const h = l - this.lastAngle_;
      this.rotationDelta_ += h, !this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_ && (this.rotating_ = !0), n = h;
    }
    this.lastAngle_ = l;
    const a = e.map, o = a.getView();
    o.getConstraints().rotation !== Sq && (this.anchor_ = a.getCoordinateFromPixelInternal(
      a.getEventPixel(Pq(this.targetPointers))
    ), this.rotating_ && (a.render(), o.adjustRotationInternal(n, this.anchor_)));
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleUpEvent(e) {
    return this.targetPointers.length < 2 ? (e.map.getView().endInteraction(this.duration_), !1) : !0;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleDownEvent(e) {
    if (this.targetPointers.length >= 2) {
      const n = e.map;
      return this.anchor_ = null, this.lastAngle_ = void 0, this.rotating_ = !1, this.rotationDelta_ = 0, this.handlingDownUpSequence || n.getView().beginInteraction(), !0;
    }
    return !1;
  }
}
const Hw1 = Rw1;
class Dw1 extends Cc {
  /**
   * @param {Options} [options] Options.
   */
  constructor(e) {
    e = e || {};
    const n = (
      /** @type {import("./Pointer.js").Options} */
      e
    );
    n.stopDown || (n.stopDown = ju), super(n), this.anchor_ = null, this.duration_ = e.duration !== void 0 ? e.duration : 400, this.lastDistance_ = void 0, this.lastScaleDelta_ = 1;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */
  handleDragEvent(e) {
    let n = 1;
    const i = this.targetPointers[0], s = this.targetPointers[1], l = i.clientX - s.clientX, a = i.clientY - s.clientY, o = Math.sqrt(l * l + a * a);
    this.lastDistance_ !== void 0 && (n = this.lastDistance_ / o), this.lastDistance_ = o;
    const h = e.map, u = h.getView();
    n != 1 && (this.lastScaleDelta_ = n), this.anchor_ = h.getCoordinateFromPixelInternal(
      h.getEventPixel(Pq(this.targetPointers))
    ), h.render(), u.adjustResolutionInternal(n, this.anchor_);
  }
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleUpEvent(e) {
    if (this.targetPointers.length < 2) {
      const i = e.map.getView(), s = this.lastScaleDelta_ > 1 ? 1 : -1;
      return i.endInteraction(this.duration_, s), !1;
    }
    return !0;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */
  handleDownEvent(e) {
    if (this.targetPointers.length >= 2) {
      const n = e.map;
      return this.anchor_ = null, this.lastDistance_ = void 0, this.lastScaleDelta_ = 1, this.handlingDownUpSequence || n.getView().beginInteraction(), !0;
    }
    return !1;
  }
}
const $w1 = Dw1;
function Ny(t) {
  t = t || {};
  const e = new z6(), n = new Gq1(-5e-3, 0.05, 100);
  return (t.altShiftDragRotate !== void 0 ? t.altShiftDragRotate : !0) && e.push(new Cw1()), (t.doubleClickZoom !== void 0 ? t.doubleClickZoom : !0) && e.push(
    new gw1({
      delta: t.zoomDelta,
      duration: t.zoomDuration
    })
  ), (t.dragPan !== void 0 ? t.dragPan : !0) && e.push(
    new NC({
      onFocusOnly: t.onFocusOnly,
      kinetic: n
    })
  ), (t.pinchRotate !== void 0 ? t.pinchRotate : !0) && e.push(new Hw1()), (t.pinchZoom !== void 0 ? t.pinchZoom : !0) && e.push(
    new $w1({
      duration: t.zoomDuration
    })
  ), (t.keyboard !== void 0 ? t.keyboard : !0) && (e.push(new Nw1()), e.push(
    new Bw1({
      delta: t.zoomDelta,
      duration: t.zoomDuration
    })
  )), (t.mouseWheelZoom !== void 0 ? t.mouseWheelZoom : !0) && e.push(
    new PC({
      onFocusOnly: t.onFocusOnly,
      duration: t.zoomDuration
    })
  ), (t.shiftDragZoom !== void 0 ? t.shiftDragZoom : !0) && e.push(
    new Iw1({
      duration: t.zoomDuration
    })
  ), e;
}
function BC(t) {
  if (t instanceof td) {
    t.setMapInternal(null);
    return;
  }
  t instanceof sd && t.getLayers().forEach(BC);
}
function VC(t, e) {
  if (t instanceof td) {
    t.setMapInternal(e);
    return;
  }
  if (t instanceof sd) {
    const n = t.getLayers().getArray();
    for (let i = 0, s = n.length; i < s; ++i)
      VC(n[i], e);
  }
}
let Uw1 = class extends gn {
  /**
   * @param {MapOptions} [options] Map options.
   */
  constructor(e) {
    super(), e = e || {}, this.on, this.once, this.un;
    const n = jw1(e);
    this.renderComplete_ = !1, this.loaded_ = !0, this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this), this.maxTilesLoading_ = e.maxTilesLoading !== void 0 ? e.maxTilesLoading : 16, this.pixelRatio_ = e.pixelRatio !== void 0 ? e.pixelRatio : XS, this.postRenderTimeoutHandle_, this.animationDelayKey_, this.animationDelay_ = this.animationDelay_.bind(this), this.coordinateToPixelTransform_ = hn(), this.pixelToCoordinateTransform_ = hn(), this.frameIndex_ = 0, this.frameState_ = null, this.previousExtent_ = null, this.viewPropertyListenerKey_ = null, this.viewChangeListenerKey_ = null, this.layerGroupPropertyListenerKeys_ = null, this.viewport_ = document.createElement("div"), this.viewport_.className = "ol-viewport" + ("ontouchstart" in window ? " ol-touch" : ""), this.viewport_.style.position = "relative", this.viewport_.style.overflow = "hidden", this.viewport_.style.width = "100%", this.viewport_.style.height = "100%", this.overlayContainer_ = document.createElement("div"), this.overlayContainer_.style.position = "absolute", this.overlayContainer_.style.zIndex = "0", this.overlayContainer_.style.width = "100%", this.overlayContainer_.style.height = "100%", this.overlayContainer_.style.pointerEvents = "none", this.overlayContainer_.className = "ol-overlaycontainer", this.viewport_.appendChild(this.overlayContainer_), this.overlayContainerStopEvent_ = document.createElement("div"), this.overlayContainerStopEvent_.style.position = "absolute", this.overlayContainerStopEvent_.style.zIndex = "0", this.overlayContainerStopEvent_.style.width = "100%", this.overlayContainerStopEvent_.style.height = "100%", this.overlayContainerStopEvent_.style.pointerEvents = "none", this.overlayContainerStopEvent_.className = "ol-overlaycontainer-stopevent", this.viewport_.appendChild(this.overlayContainerStopEvent_), this.mapBrowserEventHandler_ = null, this.moveTolerance_ = e.moveTolerance, this.keyboardEventTarget_ = n.keyboardEventTarget, this.targetChangeHandlerKeys_ = null, this.targetElement_ = null, this.resizeObserver_ = new ResizeObserver(() => this.updateSize()), this.controls = n.controls || Iy(), this.interactions = n.interactions || Ny({
      onFocusOnly: !0
    }), this.overlays_ = n.overlays, this.overlayIdIndex_ = {}, this.renderer_ = null, this.postRenderFunctions_ = [], this.tileQueue_ = new lw1(
      this.getTilePriority.bind(this),
      this.handleTileChange_.bind(this)
    ), this.addChangeListener(
      d5.LAYERGROUP,
      this.handleLayerGroupChanged_
    ), this.addChangeListener(d5.VIEW, this.handleViewChanged_), this.addChangeListener(d5.SIZE, this.handleSizeChanged_), this.addChangeListener(d5.TARGET, this.handleTargetChanged_), this.setProperties(n.values);
    const i = this;
    e.view && !(e.view instanceof jn) && e.view.then(function(s) {
      i.setView(new jn(s));
    }), this.controls.addEventListener(
      i0.ADD,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */
      (s) => {
        s.element.setMap(this);
      }
    ), this.controls.addEventListener(
      i0.REMOVE,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */
      (s) => {
        s.element.setMap(null);
      }
    ), this.interactions.addEventListener(
      i0.ADD,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */
      (s) => {
        s.element.setMap(this);
      }
    ), this.interactions.addEventListener(
      i0.REMOVE,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */
      (s) => {
        s.element.setMap(null);
      }
    ), this.overlays_.addEventListener(
      i0.ADD,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */
      (s) => {
        this.addOverlayInternal_(s.element);
      }
    ), this.overlays_.addEventListener(
      i0.REMOVE,
      /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */
      (s) => {
        const l = s.element.getId();
        l !== void 0 && delete this.overlayIdIndex_[l.toString()], s.element.setMap(null);
      }
    ), this.controls.forEach(
      /**
       * @param {import("./control/Control.js").default} control Control.
       */
      (s) => {
        s.setMap(this);
      }
    ), this.interactions.forEach(
      /**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */
      (s) => {
        s.setMap(this);
      }
    ), this.overlays_.forEach(this.addOverlayInternal_.bind(this));
  }
  /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */
  addControl(e) {
    this.getControls().push(e);
  }
  /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */
  addInteraction(e) {
    this.getInteractions().push(e);
  }
  /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */
  addLayer(e) {
    this.getLayerGroup().getLayers().push(e);
  }
  /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */
  handleLayerAdd_(e) {
    VC(e.layer, this);
  }
  /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */
  addOverlay(e) {
    this.getOverlays().push(e);
  }
  /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */
  addOverlayInternal_(e) {
    const n = e.getId();
    n !== void 0 && (this.overlayIdIndex_[n.toString()] = e), e.setMap(this);
  }
  /**
   *
   * Clean up.
   * @override
   */
  disposeInternal() {
    this.controls.clear(), this.interactions.clear(), this.overlays_.clear(), this.resizeObserver_.disconnect(), this.setTarget(null), super.disposeInternal();
  }
  /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */
  forEachFeatureAtPixel(e, n, i) {
    if (!this.frameState_ || !this.renderer_)
      return;
    const s = this.getCoordinateFromPixelInternal(e);
    i = i !== void 0 ? i : {};
    const l = i.hitTolerance !== void 0 ? i.hitTolerance : 0, a = i.layerFilter !== void 0 ? i.layerFilter : Go, o = i.checkWrapped !== !1;
    return this.renderer_.forEachFeatureAtCoordinate(
      s,
      this.frameState_,
      l,
      o,
      n,
      null,
      a,
      null
    );
  }
  /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */
  getFeaturesAtPixel(e, n) {
    const i = [];
    return this.forEachFeatureAtPixel(
      e,
      function(s) {
        i.push(s);
      },
      n
    ), i;
  }
  /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */
  getAllLayers() {
    const e = [];
    function n(i) {
      i.forEach(function(s) {
        s instanceof sd ? n(s.getLayers()) : e.push(s);
      });
    }
    return n(this.getLayers()), e;
  }
  /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */
  hasFeatureAtPixel(e, n) {
    if (!this.frameState_ || !this.renderer_)
      return !1;
    const i = this.getCoordinateFromPixelInternal(e);
    n = n !== void 0 ? n : {};
    const s = n.layerFilter !== void 0 ? n.layerFilter : Go, l = n.hitTolerance !== void 0 ? n.hitTolerance : 0, a = n.checkWrapped !== !1;
    return this.renderer_.hasFeatureAtCoordinate(
      i,
      this.frameState_,
      l,
      a,
      s,
      null
    );
  }
  /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */
  getEventCoordinate(e) {
    return this.getCoordinateFromPixel(this.getEventPixel(e));
  }
  /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */
  getEventCoordinateInternal(e) {
    return this.getCoordinateFromPixelInternal(this.getEventPixel(e));
  }
  /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */
  getEventPixel(e) {
    const i = this.viewport_.getBoundingClientRect(), s = this.getSize(), l = i.width / s[0], a = i.height / s[1], o = (
      //FIXME Are we really calling this with a TouchEvent anywhere?
      "changedTouches" in e ? (
        /** @type {TouchEvent} */
        e.changedTouches[0]
      ) : (
        /** @type {MouseEvent} */
        e
      )
    );
    return [
      (o.clientX - i.left) / l,
      (o.clientY - i.top) / a
    ];
  }
  /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */
  getTarget() {
    return (
      /** @type {HTMLElement|string|undefined} */
      this.get(d5.TARGET)
    );
  }
  /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */
  getTargetElement() {
    return this.targetElement_;
  }
  /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */
  getCoordinateFromPixel(e) {
    return by(
      this.getCoordinateFromPixelInternal(e),
      this.getView().getProjection()
    );
  }
  /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */
  getCoordinateFromPixelInternal(e) {
    const n = this.frameState_;
    return n ? j4(n.pixelToCoordinateTransform, e.slice()) : null;
  }
  /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */
  getControls() {
    return this.controls;
  }
  /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */
  getOverlays() {
    return this.overlays_;
  }
  /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */
  getOverlayById(e) {
    const n = this.overlayIdIndex_[e.toString()];
    return n !== void 0 ? n : null;
  }
  /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */
  getInteractions() {
    return this.interactions;
  }
  /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */
  getLayerGroup() {
    return (
      /** @type {LayerGroup} */
      this.get(d5.LAYERGROUP)
    );
  }
  /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */
  setLayers(e) {
    const n = this.getLayerGroup();
    if (e instanceof z6) {
      n.setLayers(e);
      return;
    }
    const i = n.getLayers();
    i.clear(), i.extend(e);
  }
  /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */
  getLayers() {
    return this.getLayerGroup().getLayers();
  }
  /**
   * @return {boolean} Layers have sources that are still loading.
   */
  getLoadingOrNotReady() {
    const e = this.getLayerGroup().getLayerStatesArray();
    for (let n = 0, i = e.length; n < i; ++n) {
      const s = e[n];
      if (!s.visible)
        continue;
      const l = s.layer.getRenderer();
      if (l && !l.ready)
        return !0;
      const a = s.layer.getSource();
      if (a && a.loading)
        return !0;
    }
    return !1;
  }
  /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */
  getPixelFromCoordinate(e) {
    const n = a8(
      e,
      this.getView().getProjection()
    );
    return this.getPixelFromCoordinateInternal(n);
  }
  /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */
  getPixelFromCoordinateInternal(e) {
    const n = this.frameState_;
    return n ? j4(
      n.coordinateToPixelTransform,
      e.slice(0, 2)
    ) : null;
  }
  /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */
  getRenderer() {
    return this.renderer_;
  }
  /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */
  getSize() {
    return (
      /** @type {import("./size.js").Size|undefined} */
      this.get(d5.SIZE)
    );
  }
  /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */
  getView() {
    return (
      /** @type {View} */
      this.get(d5.VIEW)
    );
  }
  /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */
  getViewport() {
    return this.viewport_;
  }
  /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */
  getOverlayContainer() {
    return this.overlayContainer_;
  }
  /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */
  getOverlayContainerStopEvent() {
    return this.overlayContainerStopEvent_;
  }
  /**
   * @return {!Document} The document where the map is displayed.
   */
  getOwnerDocument() {
    const e = this.getTargetElement();
    return e ? e.ownerDocument : document;
  }
  /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */
  getTilePriority(e, n, i, s) {
    return rw1(
      this.frameState_,
      e,
      n,
      i,
      s
    );
  }
  /**
   * @param {UIEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */
  handleBrowserEvent(e, n) {
    n = n || e.type;
    const i = new ps(n, this, e);
    this.handleMapBrowserEvent(i);
  }
  /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */
  handleMapBrowserEvent(e) {
    if (!this.frameState_)
      return;
    const n = (
      /** @type {PointerEvent} */
      e.originalEvent
    ), i = n.type;
    if (i === Ty.POINTERDOWN || i === T3.WHEEL || i === T3.KEYDOWN) {
      const s = this.getOwnerDocument(), l = this.viewport_.getRootNode ? this.viewport_.getRootNode() : s, a = (
        /** @type {Node} */
        n.target
      );
      if (
        // Abort if the target is a child of the container for elements whose events are not meant
        // to be handled by map interactions.
        this.overlayContainerStopEvent_.contains(a) || // Abort if the event target is a child of the container that is no longer in the page.
        // It's possible for the target to no longer be in the page if it has been removed in an
        // event listener, this might happen in a Control that recreates it's content based on
        // user interaction either manually or via a render in something like https://reactjs.org/
        !(l === s ? s.documentElement : l).contains(a)
      )
        return;
    }
    if (e.frameState = this.frameState_, this.dispatchEvent(e) !== !1) {
      const s = this.getInteractions().getArray().slice();
      for (let l = s.length - 1; l >= 0; l--) {
        const a = s[l];
        if (a.getMap() !== this || !a.getActive() || !this.getTargetElement())
          continue;
        if (!a.handleEvent(e) || e.propagationStopped)
          break;
      }
    }
  }
  /**
   * @protected
   */
  handlePostRender() {
    const e = this.frameState_, n = this.tileQueue_;
    if (!n.isEmpty()) {
      let s = this.maxTilesLoading_, l = s;
      if (e) {
        const a = e.viewHints;
        if (a[f5.ANIMATING] || a[f5.INTERACTING]) {
          const o = Date.now() - e.time > 8;
          s = o ? 0 : 8, l = o ? 0 : 2;
        }
      }
      n.getTilesLoading() < s && (n.reprioritize(), n.loadMoreTiles(s, l));
    }
    e && this.renderer_ && !e.animate && (this.renderComplete_ ? (this.hasListener(M6.RENDERCOMPLETE) && this.renderer_.dispatchRenderEvent(
      M6.RENDERCOMPLETE,
      e
    ), this.loaded_ === !1 && (this.loaded_ = !0, this.dispatchEvent(
      new oa(c8.LOADEND, this, e)
    ))) : this.loaded_ === !0 && (this.loaded_ = !1, this.dispatchEvent(
      new oa(c8.LOADSTART, this, e)
    )));
    const i = this.postRenderFunctions_;
    for (let s = 0, l = i.length; s < l; ++s)
      i[s](this, e);
    i.length = 0;
  }
  /**
   * @private
   */
  handleSizeChanged_() {
    this.getView() && !this.getView().getAnimating() && this.getView().resolveConstraints(0), this.render();
  }
  /**
   * @private
   */
  handleTargetChanged_() {
    if (this.mapBrowserEventHandler_) {
      for (let i = 0, s = this.targetChangeHandlerKeys_.length; i < s; ++i)
        Qe(this.targetChangeHandlerKeys_[i]);
      this.targetChangeHandlerKeys_ = null, this.viewport_.removeEventListener(
        T3.CONTEXTMENU,
        this.boundHandleBrowserEvent_
      ), this.viewport_.removeEventListener(
        T3.WHEEL,
        this.boundHandleBrowserEvent_
      ), this.mapBrowserEventHandler_.dispose(), this.mapBrowserEventHandler_ = null, this.viewport_.remove();
    }
    if (this.targetElement_) {
      this.resizeObserver_.unobserve(this.targetElement_);
      const i = this.targetElement_.getRootNode();
      i instanceof ShadowRoot && this.resizeObserver_.unobserve(i.host), this.setSize(void 0);
    }
    const e = this.getTarget(), n = typeof e == "string" ? document.getElementById(e) : e;
    if (this.targetElement_ = n, !n)
      this.renderer_ && (clearTimeout(this.postRenderTimeoutHandle_), this.postRenderTimeoutHandle_ = void 0, this.postRenderFunctions_.length = 0, this.renderer_.dispose(), this.renderer_ = null), this.animationDelayKey_ && (cancelAnimationFrame(this.animationDelayKey_), this.animationDelayKey_ = void 0);
    else {
      n.appendChild(this.viewport_), this.renderer_ || (this.renderer_ = new Zq1(this)), this.mapBrowserEventHandler_ = new tw1(
        this,
        this.moveTolerance_
      );
      for (const l in Bt)
        this.mapBrowserEventHandler_.addEventListener(
          Bt[l],
          this.handleMapBrowserEvent.bind(this)
        );
      this.viewport_.addEventListener(
        T3.CONTEXTMENU,
        this.boundHandleBrowserEvent_,
        !1
      ), this.viewport_.addEventListener(
        T3.WHEEL,
        this.boundHandleBrowserEvent_,
        JS ? { passive: !1 } : !1
      );
      const i = this.keyboardEventTarget_ ? this.keyboardEventTarget_ : n;
      this.targetChangeHandlerKeys_ = [
        ae(
          i,
          T3.KEYDOWN,
          this.handleBrowserEvent,
          this
        ),
        ae(
          i,
          T3.KEYPRESS,
          this.handleBrowserEvent,
          this
        )
      ];
      const s = n.getRootNode();
      s instanceof ShadowRoot && this.resizeObserver_.observe(s.host), this.resizeObserver_.observe(n);
    }
    this.updateSize();
  }
  /**
   * @private
   */
  handleTileChange_() {
    this.render();
  }
  /**
   * @private
   */
  handleViewPropertyChanged_() {
    this.render();
  }
  /**
   * @private
   */
  handleViewChanged_() {
    this.viewPropertyListenerKey_ && (Qe(this.viewPropertyListenerKey_), this.viewPropertyListenerKey_ = null), this.viewChangeListenerKey_ && (Qe(this.viewChangeListenerKey_), this.viewChangeListenerKey_ = null);
    const e = this.getView();
    e && (this.updateViewportSize_(this.getSize()), this.viewPropertyListenerKey_ = ae(
      e,
      Ua.PROPERTYCHANGE,
      this.handleViewPropertyChanged_,
      this
    ), this.viewChangeListenerKey_ = ae(
      e,
      T3.CHANGE,
      this.handleViewPropertyChanged_,
      this
    ), e.resolveConstraints(0)), this.render();
  }
  /**
   * @private
   */
  handleLayerGroupChanged_() {
    this.layerGroupPropertyListenerKeys_ && (this.layerGroupPropertyListenerKeys_.forEach(Qe), this.layerGroupPropertyListenerKeys_ = null);
    const e = this.getLayerGroup();
    e && (this.handleLayerAdd_(new gs("addlayer", e)), this.layerGroupPropertyListenerKeys_ = [
      ae(e, Ua.PROPERTYCHANGE, this.render, this),
      ae(e, T3.CHANGE, this.render, this),
      ae(e, "addlayer", this.handleLayerAdd_, this),
      ae(e, "removelayer", this.handleLayerRemove_, this)
    ]), this.render();
  }
  /**
   * @return {boolean} Is rendered.
   */
  isRendered() {
    return !!this.frameState_;
  }
  /**
   * @private
   */
  animationDelay_() {
    this.animationDelayKey_ = void 0, this.renderFrame_(Date.now());
  }
  /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */
  renderSync() {
    this.animationDelayKey_ && cancelAnimationFrame(this.animationDelayKey_), this.animationDelay_();
  }
  /**
   * Redraws all text after new fonts have loaded
   */
  redrawText() {
    const e = this.getLayerGroup().getLayerStatesArray();
    for (let n = 0, i = e.length; n < i; ++n) {
      const s = e[n].layer;
      s.hasRenderer() && s.getRenderer().handleFontsChanged();
    }
  }
  /**
   * Request a map rendering (at the next animation frame).
   * @api
   */
  render() {
    this.renderer_ && this.animationDelayKey_ === void 0 && (this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_));
  }
  /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */
  removeControl(e) {
    return this.getControls().remove(e);
  }
  /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */
  removeInteraction(e) {
    return this.getInteractions().remove(e);
  }
  /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */
  removeLayer(e) {
    return this.getLayerGroup().getLayers().remove(e);
  }
  /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */
  handleLayerRemove_(e) {
    BC(e.layer);
  }
  /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */
  removeOverlay(e) {
    return this.getOverlays().remove(e);
  }
  /**
   * @param {number} time Time.
   * @private
   */
  renderFrame_(e) {
    const n = this.getSize(), i = this.getView(), s = this.frameState_;
    let l = null;
    if (n !== void 0 && Nz(n) && i && i.isDef()) {
      const a = i.getHints(
        this.frameState_ ? this.frameState_.viewHints : void 0
      ), o = i.getState();
      if (l = {
        animate: !1,
        coordinateToPixelTransform: this.coordinateToPixelTransform_,
        declutter: null,
        extent: wy(
          o.center,
          o.resolution,
          o.rotation,
          n
        ),
        index: this.frameIndex_++,
        layerIndex: 0,
        layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
        pixelRatio: this.pixelRatio_,
        pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
        postRenderFunctions: [],
        size: n,
        tileQueue: this.tileQueue_,
        time: e,
        usedTiles: {},
        viewState: o,
        viewHints: a,
        wantedTiles: {},
        mapId: Be(this),
        renderTargets: {}
      }, o.nextCenter && o.nextResolution) {
        const h = isNaN(o.nextRotation) ? o.rotation : o.nextRotation;
        l.nextExtent = wy(
          o.nextCenter,
          o.nextResolution,
          h,
          n
        );
      }
    }
    this.frameState_ = l, this.renderer_.renderFrame(l), l && (l.animate && this.render(), Array.prototype.push.apply(
      this.postRenderFunctions_,
      l.postRenderFunctions
    ), s && (!this.previousExtent_ || !zc(this.previousExtent_) && !$o(l.extent, this.previousExtent_)) && (this.dispatchEvent(
      new oa(c8.MOVESTART, this, s)
    ), this.previousExtent_ = s9(this.previousExtent_)), this.previousExtent_ && !l.viewHints[f5.ANIMATING] && !l.viewHints[f5.INTERACTING] && !$o(l.extent, this.previousExtent_) && (this.dispatchEvent(
      new oa(c8.MOVEEND, this, l)
    ), yS(l.extent, this.previousExtent_))), this.dispatchEvent(new oa(c8.POSTRENDER, this, l)), this.renderComplete_ = (this.hasListener(c8.LOADSTART) || this.hasListener(c8.LOADEND) || this.hasListener(M6.RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady(), this.postRenderTimeoutHandle_ || (this.postRenderTimeoutHandle_ = setTimeout(() => {
      this.postRenderTimeoutHandle_ = void 0, this.handlePostRender();
    }, 0));
  }
  /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */
  setLayerGroup(e) {
    const n = this.getLayerGroup();
    n && this.handleLayerRemove_(new gs("removelayer", n)), this.set(d5.LAYERGROUP, e);
  }
  /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */
  setSize(e) {
    this.set(d5.SIZE, e);
  }
  /**
   * Set the target element to render this map into.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */
  setTarget(e) {
    this.set(d5.TARGET, e);
  }
  /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */
  setView(e) {
    if (!e || e instanceof jn) {
      this.set(d5.VIEW, e);
      return;
    }
    this.set(d5.VIEW, new jn());
    const n = this;
    e.then(function(i) {
      n.setView(new jn(i));
    });
  }
  /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */
  updateSize() {
    const e = this.getTargetElement();
    let n;
    if (e) {
      const s = getComputedStyle(e), l = e.offsetWidth - parseFloat(s.borderLeftWidth) - parseFloat(s.paddingLeft) - parseFloat(s.paddingRight) - parseFloat(s.borderRightWidth), a = e.offsetHeight - parseFloat(s.borderTopWidth) - parseFloat(s.paddingTop) - parseFloat(s.paddingBottom) - parseFloat(s.borderBottomWidth);
      !isNaN(l) && !isNaN(a) && (n = [Math.max(0, l), Math.max(0, a)], !Nz(n) && (e.offsetWidth || e.offsetHeight || e.getClientRects().length) && SS(
        "No map visible because the map container's width or height are 0."
      ));
    }
    const i = this.getSize();
    n && (!i || !Ws(n, i)) && (this.setSize(n), this.updateViewportSize_(n));
  }
  /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */
  updateViewportSize_(e) {
    const n = this.getView();
    n && n.setViewportSize(e);
  }
};
function jw1(t) {
  let e = null;
  t.keyboardEventTarget !== void 0 && (e = typeof t.keyboardEventTarget == "string" ? document.getElementById(t.keyboardEventTarget) : t.keyboardEventTarget);
  const n = {}, i = t.layers && typeof /** @type {?} */
  t.layers.getLayers == "function" ? (
    /** @type {LayerGroup} */
    t.layers
  ) : new sd({
    layers: (
      /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */
      t.layers
    )
  });
  n[d5.LAYERGROUP] = i, n[d5.TARGET] = t.target, n[d5.VIEW] = t.view instanceof jn ? t.view : new jn();
  let s;
  t.controls !== void 0 && (Array.isArray(t.controls) ? s = new z6(t.controls.slice()) : (ge(
    typeof /** @type {?} */
    t.controls.getArray == "function",
    "Expected `controls` to be an array or an `ol/Collection.js`"
  ), s = t.controls));
  let l;
  t.interactions !== void 0 && (Array.isArray(t.interactions) ? l = new z6(t.interactions.slice()) : (ge(
    typeof /** @type {?} */
    t.interactions.getArray == "function",
    "Expected `interactions` to be an array or an `ol/Collection.js`"
  ), l = t.interactions));
  let a;
  return t.overlays !== void 0 ? Array.isArray(t.overlays) ? a = new z6(t.overlays.slice()) : (ge(
    typeof /** @type {?} */
    t.overlays.getArray == "function",
    "Expected `overlays` to be an array or an `ol/Collection.js`"
  ), a = t.overlays) : a = new z6(), {
    controls: s,
    interactions: l,
    keyboardEventTarget: e,
    overlays: a,
    values: n
  };
}
const Gw1 = Uw1, a5 = {
  ELEMENT: "element",
  MAP: "map",
  OFFSET: "offset",
  POSITION: "position",
  POSITIONING: "positioning"
};
class Ww1 extends gn {
  /**
   * @param {Options} options Overlay options.
   */
  constructor(e) {
    super(), this.on, this.once, this.un, this.options = e, this.id = e.id, this.insertFirst = e.insertFirst !== void 0 ? e.insertFirst : !0, this.stopEvent = e.stopEvent !== void 0 ? e.stopEvent : !0, this.element = document.createElement("div"), this.element.className = e.className !== void 0 ? e.className : "ol-overlay-container " + wy1, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.autoPan = e.autoPan === !0 ? {} : e.autoPan || void 0, this.rendered = {
      transform_: "",
      visible: !0
    }, this.mapPostrenderListenerKey = null, this.addChangeListener(a5.ELEMENT, this.handleElementChanged), this.addChangeListener(a5.MAP, this.handleMapChanged), this.addChangeListener(a5.OFFSET, this.handleOffsetChanged), this.addChangeListener(a5.POSITION, this.handlePositionChanged), this.addChangeListener(a5.POSITIONING, this.handlePositioningChanged), e.element !== void 0 && this.setElement(e.element), this.setOffset(e.offset !== void 0 ? e.offset : [0, 0]), this.setPositioning(e.positioning || "top-left"), e.position !== void 0 && this.setPosition(e.position);
  }
  /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */
  getElement() {
    return (
      /** @type {HTMLElement|undefined} */
      this.get(a5.ELEMENT)
    );
  }
  /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */
  getId() {
    return this.id;
  }
  /**
   * Get the map associated with this overlay.
   * @return {import("./Map.js").default|null} The map that the
   * overlay is part of.
   * @observable
   * @api
   */
  getMap() {
    return (
      /** @type {import("./Map.js").default|null} */
      this.get(a5.MAP) || null
    );
  }
  /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */
  getOffset() {
    return (
      /** @type {Array<number>} */
      this.get(a5.OFFSET)
    );
  }
  /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */
  getPosition() {
    return (
      /** @type {import("./coordinate.js").Coordinate|undefined} */
      this.get(a5.POSITION)
    );
  }
  /**
   * Get the current positioning of this overlay.
   * @return {Positioning} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */
  getPositioning() {
    return (
      /** @type {Positioning} */
      this.get(a5.POSITIONING)
    );
  }
  /**
   * @protected
   */
  handleElementChanged() {
    QS(this.element);
    const e = this.getElement();
    e && this.element.appendChild(e);
  }
  /**
   * @protected
   */
  handleMapChanged() {
    var n;
    this.mapPostrenderListenerKey && ((n = this.element) == null || n.remove(), Qe(this.mapPostrenderListenerKey), this.mapPostrenderListenerKey = null);
    const e = this.getMap();
    if (e) {
      this.mapPostrenderListenerKey = ae(
        e,
        c8.POSTRENDER,
        this.render,
        this
      ), this.updatePixelPosition();
      const i = this.stopEvent ? e.getOverlayContainerStopEvent() : e.getOverlayContainer();
      this.insertFirst ? i.insertBefore(this.element, i.childNodes[0] || null) : i.appendChild(this.element), this.performAutoPan();
    }
  }
  /**
   * @protected
   */
  render() {
    this.updatePixelPosition();
  }
  /**
   * @protected
   */
  handleOffsetChanged() {
    this.updatePixelPosition();
  }
  /**
   * @protected
   */
  handlePositionChanged() {
    this.updatePixelPosition(), this.performAutoPan();
  }
  /**
   * @protected
   */
  handlePositioningChanged() {
    this.updatePixelPosition();
  }
  /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */
  setElement(e) {
    this.set(a5.ELEMENT, e);
  }
  /**
   * Set the map to be associated with this overlay.
   * @param {import("./Map.js").default|null} map The map that the
   * overlay is part of. Pass `null` to just remove the overlay from the current map.
   * @observable
   * @api
   */
  setMap(e) {
    this.set(a5.MAP, e);
  }
  /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */
  setOffset(e) {
    this.set(a5.OFFSET, e);
  }
  /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */
  setPosition(e) {
    this.set(a5.POSITION, e);
  }
  /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary) using the configured autoPan parameters
   * @protected
   */
  performAutoPan() {
    this.autoPan && this.panIntoView(this.autoPan);
  }
  /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @param {PanIntoViewOptions} [panIntoViewOptions] Options for the pan action
   * @api
   */
  panIntoView(e) {
    const n = this.getMap();
    if (!n || !n.getTargetElement() || !this.get(a5.POSITION))
      return;
    const i = this.getRect(n.getTargetElement(), n.getSize()), s = this.getElement(), l = this.getRect(s, [
      hy1(s),
      uy1(s)
    ]);
    e = e || {};
    const a = e.margin === void 0 ? 20 : e.margin;
    if (!tr(i, l)) {
      const o = l[0] - i[0], h = i[2] - l[2], u = l[1] - i[1], d = i[3] - l[3], v = [0, 0];
      if (o < 0 ? v[0] = o - a : h < 0 && (v[0] = Math.abs(h) + a), u < 0 ? v[1] = u - a : d < 0 && (v[1] = Math.abs(d) + a), v[0] !== 0 || v[1] !== 0) {
        const m = (
          /** @type {import("./coordinate.js").Coordinate} */
          n.getView().getCenterInternal()
        ), p = n.getPixelFromCoordinateInternal(m);
        if (!p)
          return;
        const _ = [p[0] + v[0], p[1] + v[1]], q = e.animation || {};
        n.getView().animateInternal({
          center: n.getCoordinateFromPixelInternal(_),
          duration: q.duration,
          easing: q.easing
        });
      }
    }
  }
  /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement} element The element.
   * @param {import("./size.js").Size} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */
  getRect(e, n) {
    const i = e.getBoundingClientRect(), s = i.left + window.pageXOffset, l = i.top + window.pageYOffset;
    return [s, l, s + n[0], l + n[1]];
  }
  /**
   * Set the positioning for this overlay.
   * @param {Positioning} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */
  setPositioning(e) {
    this.set(a5.POSITIONING, e);
  }
  /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */
  setVisible(e) {
    this.rendered.visible !== e && (this.element.style.display = e ? "" : "none", this.rendered.visible = e);
  }
  /**
   * Update pixel position.
   * @protected
   */
  updatePixelPosition() {
    const e = this.getMap(), n = this.getPosition();
    if (!e || !e.isRendered() || !n) {
      this.setVisible(!1);
      return;
    }
    const i = e.getPixelFromCoordinate(n), s = e.getSize();
    this.updateRenderedPosition(i, s);
  }
  /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */
  updateRenderedPosition(e, n) {
    const i = this.element.style, s = this.getOffset(), l = this.getPositioning();
    this.setVisible(!0);
    const a = Math.round(e[0] + s[0]) + "px", o = Math.round(e[1] + s[1]) + "px";
    let h = "0%", u = "0%";
    l == "bottom-right" || l == "center-right" || l == "top-right" ? h = "-100%" : (l == "bottom-center" || l == "center-center" || l == "top-center") && (h = "-50%"), l == "bottom-left" || l == "bottom-center" || l == "bottom-right" ? u = "-100%" : (l == "center-left" || l == "center-center" || l == "center-right") && (u = "-50%");
    const d = `translate(${h}, ${u}) translate(${a}, ${o})`;
    this.rendered.transform_ != d && (this.rendered.transform_ = d, i.transform = d);
  }
  /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */
  getOptions() {
    return this.options;
  }
}
const Yw1 = Ww1;
class Xw1 {
  /**
   * @param {number} [highWaterMark] High water mark.
   */
  constructor(e) {
    this.highWaterMark = e !== void 0 ? e : 2048, this.count_ = 0, this.entries_ = {}, this.oldest_ = null, this.newest_ = null;
  }
  /**
   * @return {boolean} Can expire cache.
   */
  canExpireCache() {
    return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
  }
  /**
   * Expire the cache.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */
  expireCache(e) {
    for (; this.canExpireCache(); )
      this.pop();
  }
  /**
   * FIXME empty description for jsdoc
   */
  clear() {
    this.count_ = 0, this.entries_ = {}, this.oldest_ = null, this.newest_ = null;
  }
  /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */
  containsKey(e) {
    return this.entries_.hasOwnProperty(e);
  }
  /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */
  forEach(e) {
    let n = this.oldest_;
    for (; n; )
      e(n.value_, n.key_, this), n = n.newer;
  }
  /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */
  get(e, n) {
    const i = this.entries_[e];
    return ge(
      i !== void 0,
      "Tried to get a value for a key that does not exist in the cache"
    ), i === this.newest_ || (i === this.oldest_ ? (this.oldest_ = /** @type {Entry} */
    this.oldest_.newer, this.oldest_.older = null) : (i.newer.older = i.older, i.older.newer = i.newer), i.newer = null, i.older = this.newest_, this.newest_.newer = i, this.newest_ = i), i.value_;
  }
  /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */
  remove(e) {
    const n = this.entries_[e];
    return ge(
      n !== void 0,
      "Tried to get a value for a key that does not exist in the cache"
    ), n === this.newest_ ? (this.newest_ = /** @type {Entry} */
    n.older, this.newest_ && (this.newest_.newer = null)) : n === this.oldest_ ? (this.oldest_ = /** @type {Entry} */
    n.newer, this.oldest_ && (this.oldest_.older = null)) : (n.newer.older = n.older, n.older.newer = n.newer), delete this.entries_[e], --this.count_, n.value_;
  }
  /**
   * @return {number} Count.
   */
  getCount() {
    return this.count_;
  }
  /**
   * @return {Array<string>} Keys.
   */
  getKeys() {
    const e = new Array(this.count_);
    let n = 0, i;
    for (i = this.newest_; i; i = i.older)
      e[n++] = i.key_;
    return e;
  }
  /**
   * @return {Array<T>} Values.
   */
  getValues() {
    const e = new Array(this.count_);
    let n = 0, i;
    for (i = this.newest_; i; i = i.older)
      e[n++] = i.value_;
    return e;
  }
  /**
   * @return {T} Last value.
   */
  peekLast() {
    return this.oldest_.value_;
  }
  /**
   * @return {string} Last key.
   */
  peekLastKey() {
    return this.oldest_.key_;
  }
  /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */
  peekFirstKey() {
    return this.newest_.key_;
  }
  /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */
  peek(e) {
    var n;
    return (n = this.entries_[e]) == null ? void 0 : n.value_;
  }
  /**
   * @return {T} value Value.
   */
  pop() {
    const e = this.oldest_;
    return delete this.entries_[e.key_], e.newer && (e.newer.older = null), this.oldest_ = /** @type {Entry} */
    e.newer, this.oldest_ || (this.newest_ = null), --this.count_, e.value_;
  }
  /**
   * @param {string} key Key.
   * @param {T} value Value.
   */
  replace(e, n) {
    this.get(e), this.entries_[e].value_ = n;
  }
  /**
   * @param {string} key Key.
   * @param {T} value Value.
   */
  set(e, n) {
    ge(
      !(e in this.entries_),
      "Tried to set a value for a key that is used already"
    );
    const i = {
      key_: e,
      newer: null,
      older: this.newest_,
      value_: n
    };
    this.newest_ ? this.newest_.newer = i : this.oldest_ = i, this.newest_ = i, this.entries_[e] = i, ++this.count_;
  }
  /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */
  setSize(e) {
    this.highWaterMark = e;
  }
}
const RC = Xw1;
function lu(t, e, n, i) {
  return i !== void 0 ? (i[0] = t, i[1] = e, i[2] = n, i) : [t, e, n];
}
function ld(t, e, n) {
  return t + "/" + e + "/" + n;
}
function HC(t) {
  return ld(t[0], t[1], t[2]);
}
function Kw1(t) {
  return t.split("/").map(Number);
}
function DC(t) {
  return Zw1(t[0], t[1], t[2]);
}
function Zw1(t, e, n) {
  return (e << t) + n;
}
function Jw1(t, e) {
  const n = t[0], i = t[1], s = t[2];
  if (e.getMinZoom() > n || n > e.getMaxZoom())
    return !1;
  const l = e.getFullTileRange(n);
  return l ? l.containsXY(i, s) : !0;
}
class Qw1 extends RC {
  /**
   * @override
   */
  clear() {
    for (; this.getCount() > 0; )
      this.pop().release();
    super.clear();
  }
  /**
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   * @override
   */
  expireCache(e) {
    for (; this.canExpireCache() && !(this.peekLast().getKey() in e); )
      this.pop().release();
  }
  /**
   * Prune all tiles from the cache that don't have the same z as the newest tile.
   */
  pruneExceptNewestZ() {
    if (this.getCount() === 0)
      return;
    const e = this.peekFirstKey(), i = Kw1(e)[0];
    this.forEach((s) => {
      s.tileCoord[0] !== i && (this.remove(HC(s.tileCoord)), s.release());
    });
  }
}
const $C = Qw1;
class UC {
  /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */
  constructor(e, n, i, s) {
    this.minX = e, this.maxX = n, this.minY = i, this.maxY = s;
  }
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */
  contains(e) {
    return this.containsXY(e[1], e[2]);
  }
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */
  containsTileRange(e) {
    return this.minX <= e.minX && e.maxX <= this.maxX && this.minY <= e.minY && e.maxY <= this.maxY;
  }
  /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */
  containsXY(e, n) {
    return this.minX <= e && e <= this.maxX && this.minY <= n && n <= this.maxY;
  }
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */
  equals(e) {
    return this.minX == e.minX && this.minY == e.minY && this.maxX == e.maxX && this.maxY == e.maxY;
  }
  /**
   * @param {TileRange} tileRange Tile range.
   */
  extend(e) {
    e.minX < this.minX && (this.minX = e.minX), e.maxX > this.maxX && (this.maxX = e.maxX), e.minY < this.minY && (this.minY = e.minY), e.maxY > this.maxY && (this.maxY = e.maxY);
  }
  /**
   * @return {number} Height.
   */
  getHeight() {
    return this.maxY - this.minY + 1;
  }
  /**
   * @return {import("./size.js").Size} Size.
   */
  getSize() {
    return [this.getWidth(), this.getHeight()];
  }
  /**
   * @return {number} Width.
   */
  getWidth() {
    return this.maxX - this.minX + 1;
  }
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */
  intersects(e) {
    return this.minX <= e.maxX && this.maxX >= e.minX && this.minY <= e.maxY && this.maxY >= e.minY;
  }
}
function Kr(t, e, n, i, s) {
  return s !== void 0 ? (s.minX = t, s.maxX = e, s.minY = n, s.maxY = i, s) : new UC(t, e, n, i);
}
const jC = UC, ih = {
  PRELOAD: "preload",
  USE_INTERIM_TILES_ON_ERROR: "useInterimTilesOnError"
};
class ez1 extends td {
  /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */
  constructor(e) {
    e = e || {};
    const n = Object.assign({}, e), i = e.cacheSize;
    delete e.cacheSize, delete n.preload, delete n.useInterimTilesOnError, super(n), this.on, this.once, this.un, this.cacheSize_ = i, this.setPreload(e.preload !== void 0 ? e.preload : 0), this.setUseInterimTilesOnError(
      e.useInterimTilesOnError !== void 0 ? e.useInterimTilesOnError : !0
    );
  }
  /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */
  getCacheSize() {
    return this.cacheSize_;
  }
  /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */
  getPreload() {
    return (
      /** @type {number} */
      this.get(ih.PRELOAD)
    );
  }
  /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */
  setPreload(e) {
    this.set(ih.PRELOAD, e);
  }
  /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */
  getUseInterimTilesOnError() {
    return (
      /** @type {boolean} */
      this.get(ih.USE_INTERIM_TILES_ON_ERROR)
    );
  }
  /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */
  setUseInterimTilesOnError(e) {
    this.set(ih.USE_INTERIM_TILES_ON_ERROR, e);
  }
  /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */
  getData(e) {
    return super.getData(e);
  }
}
const tz1 = ez1;
function ru(t) {
  return t instanceof Image || t instanceof HTMLCanvasElement || t instanceof HTMLVideoElement || t instanceof ImageBitmap ? t : null;
}
function nz1(t) {
  return t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Float32Array || t instanceof DataView ? t : null;
}
const iz1 = new Error("disposed");
let Zr = null;
function sz1(t) {
  Zr || (Zr = u4(
    t.width,
    t.height,
    void 0,
    { willReadFrequently: !0 }
  ));
  const e = Zr.canvas, n = t.width;
  e.width !== n && (e.width = n);
  const i = t.height;
  return e.height !== i && (e.height = i), Zr.clearRect(0, 0, n, i), Zr.drawImage(t, 0, 0), Zr.getImageData(0, 0, n, i).data;
}
const lz1 = [256, 256];
class rz1 extends Iq {
  /**
   * @param {Options} options Tile options.
   */
  constructor(e) {
    const n = H2.IDLE;
    super(e.tileCoord, n, {
      transition: e.transition,
      interpolate: e.interpolate
    }), this.loader_ = e.loader, this.data_ = null, this.error_ = null, this.size_ = e.size || null, this.controller_ = e.controller || null;
  }
  /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */
  getSize() {
    if (this.size_)
      return this.size_;
    const e = ru(this.data_);
    return e ? [e.width, e.height] : lz1;
  }
  /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */
  getData() {
    return this.data_;
  }
  /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */
  getError() {
    return this.error_;
  }
  /**
   * Load the tile data.
   * @api
   * @override
   */
  load() {
    if (this.state !== H2.IDLE && this.state !== H2.ERROR)
      return;
    this.state = H2.LOADING, this.changed();
    const e = this;
    this.loader_().then(function(n) {
      e.data_ = n, e.state = H2.LOADED, e.changed();
    }).catch(function(n) {
      e.error_ = n, e.state = H2.ERROR, e.changed();
    });
  }
  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    this.controller_ && (this.controller_.abort(iz1), this.controller_ = null), super.disposeInternal();
  }
}
const Py = rz1, GC = 0.5, az1 = 10, uM = 0.25;
class oz1 {
  /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   */
  constructor(e, n, i, s, l, a) {
    this.sourceProj_ = e, this.targetProj_ = n;
    let o = {};
    const h = $a(this.targetProj_, this.sourceProj_);
    this.transformInv_ = function(b) {
      const x = b[0] + "/" + b[1];
      return o[x] || (o[x] = h(b)), o[x];
    }, this.maxSourceExtent_ = s, this.errorThresholdSquared_ = l * l, this.triangles_ = [], this.wrapsXInSource_ = !1, this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!s && !!this.sourceProj_.getExtent() && ue(s) >= ue(this.sourceProj_.getExtent()), this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? ue(this.sourceProj_.getExtent()) : null, this.targetWorldWidth_ = this.targetProj_.getExtent() ? ue(this.targetProj_.getExtent()) : null;
    const u = Lr(i), d = Du(i), v = Hu(i), m = Ru(i), p = this.transformInv_(u), _ = this.transformInv_(d), q = this.transformInv_(v), M = this.transformInv_(m), z = az1 + (a ? Math.max(
      0,
      Math.ceil(
        Math.log2(
          Uo(i) / (a * a * 256 * 256)
        )
      )
    ) : 0);
    if (this.addQuad_(
      u,
      d,
      v,
      m,
      p,
      _,
      q,
      M,
      z
    ), this.wrapsXInSource_) {
      let b = 1 / 0;
      this.triangles_.forEach(function(x, k, F) {
        b = Math.min(
          b,
          x.source[0][0],
          x.source[1][0],
          x.source[2][0]
        );
      }), this.triangles_.forEach((x) => {
        if (Math.max(
          x.source[0][0],
          x.source[1][0],
          x.source[2][0]
        ) - b > this.sourceWorldWidth_ / 2) {
          const k = [
            [x.source[0][0], x.source[0][1]],
            [x.source[1][0], x.source[1][1]],
            [x.source[2][0], x.source[2][1]]
          ];
          k[0][0] - b > this.sourceWorldWidth_ / 2 && (k[0][0] -= this.sourceWorldWidth_), k[1][0] - b > this.sourceWorldWidth_ / 2 && (k[1][0] -= this.sourceWorldWidth_), k[2][0] - b > this.sourceWorldWidth_ / 2 && (k[2][0] -= this.sourceWorldWidth_);
          const F = Math.min(
            k[0][0],
            k[1][0],
            k[2][0]
          );
          Math.max(
            k[0][0],
            k[1][0],
            k[2][0]
          ) - F < this.sourceWorldWidth_ / 2 && (x.source = k);
        }
      });
    }
    o = {};
  }
  /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */
  addTriangle_(e, n, i, s, l, a) {
    this.triangles_.push({
      source: [s, l, a],
      target: [e, n, i]
    });
  }
  /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */
  addQuad_(e, n, i, s, l, a, o, h, u) {
    const d = _y([l, a, o, h]), v = this.sourceWorldWidth_ ? ue(d) / this.sourceWorldWidth_ : null, m = (
      /** @type {number} */
      this.sourceWorldWidth_
    ), p = this.sourceProj_.canWrapX() && v > 0.5 && v < 1;
    let _ = !1;
    if (u > 0) {
      if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
        const M = _y([e, n, i, s]);
        _ = ue(M) / this.targetWorldWidth_ > uM || _;
      }
      !p && this.sourceProj_.isGlobal() && v && (_ = v > uM || _);
    }
    if (!_ && this.maxSourceExtent_ && isFinite(d[0]) && isFinite(d[1]) && isFinite(d[2]) && isFinite(d[3]) && !r0(d, this.maxSourceExtent_))
      return;
    let q = 0;
    if (!_ && (!isFinite(l[0]) || !isFinite(l[1]) || !isFinite(a[0]) || !isFinite(a[1]) || !isFinite(o[0]) || !isFinite(o[1]) || !isFinite(h[0]) || !isFinite(h[1]))) {
      if (u > 0)
        _ = !0;
      else if (q = (!isFinite(l[0]) || !isFinite(l[1]) ? 8 : 0) + (!isFinite(a[0]) || !isFinite(a[1]) ? 4 : 0) + (!isFinite(o[0]) || !isFinite(o[1]) ? 2 : 0) + (!isFinite(h[0]) || !isFinite(h[1]) ? 1 : 0), q != 1 && q != 2 && q != 4 && q != 8)
        return;
    }
    if (u > 0) {
      if (!_) {
        const M = [(e[0] + i[0]) / 2, (e[1] + i[1]) / 2], z = this.transformInv_(M);
        let b;
        p ? b = (hr(l[0], m) + hr(o[0], m)) / 2 - hr(z[0], m) : b = (l[0] + o[0]) / 2 - z[0];
        const x = (l[1] + o[1]) / 2 - z[1];
        _ = b * b + x * x > this.errorThresholdSquared_;
      }
      if (_) {
        if (Math.abs(e[0] - i[0]) <= Math.abs(e[1] - i[1])) {
          const M = [(n[0] + i[0]) / 2, (n[1] + i[1]) / 2], z = this.transformInv_(M), b = [(s[0] + e[0]) / 2, (s[1] + e[1]) / 2], x = this.transformInv_(b);
          this.addQuad_(
            e,
            n,
            M,
            b,
            l,
            a,
            z,
            x,
            u - 1
          ), this.addQuad_(
            b,
            M,
            i,
            s,
            x,
            z,
            o,
            h,
            u - 1
          );
        } else {
          const M = [(e[0] + n[0]) / 2, (e[1] + n[1]) / 2], z = this.transformInv_(M), b = [(i[0] + s[0]) / 2, (i[1] + s[1]) / 2], x = this.transformInv_(b);
          this.addQuad_(
            e,
            M,
            b,
            s,
            l,
            z,
            x,
            h,
            u - 1
          ), this.addQuad_(
            M,
            n,
            i,
            b,
            z,
            a,
            o,
            x,
            u - 1
          );
        }
        return;
      }
    }
    if (p) {
      if (!this.canWrapXInSource_)
        return;
      this.wrapsXInSource_ = !0;
    }
    q & 11 || this.addTriangle_(e, i, s, l, o, h), q & 14 || this.addTriangle_(e, i, n, l, o, a), q && (q & 13 || this.addTriangle_(n, s, e, a, h, l), q & 7 || this.addTriangle_(n, s, i, a, h, o));
  }
  /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */
  calculateSourceExtent() {
    const e = U0();
    return this.triangles_.forEach(function(n, i, s) {
      const l = n.source;
      xo(e, l[0]), xo(e, l[1]), xo(e, l[2]);
    }), e;
  }
  /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */
  getTriangles() {
    return this.triangles_;
  }
}
const WC = oz1;
let Rg;
const _8 = [];
function dM(t, e, n, i, s) {
  t.beginPath(), t.moveTo(0, 0), t.lineTo(e, n), t.lineTo(i, s), t.closePath(), t.save(), t.clip(), t.fillRect(0, 0, Math.max(e, i) + 1, Math.max(n, s)), t.restore();
}
function Hg(t, e) {
  return Math.abs(t[e * 4] - 210) > 2 || Math.abs(t[e * 4 + 3] - 0.75 * 255) > 2;
}
function cz1() {
  if (Rg === void 0) {
    const t = u4(6, 6, _8);
    t.globalCompositeOperation = "lighter", t.fillStyle = "rgba(210, 0, 0, 0.75)", dM(t, 4, 5, 4, 0), dM(t, 4, 5, 0, 5);
    const e = t.getImageData(0, 0, 3, 3).data;
    Rg = Hg(e, 0) || Hg(e, 4) || Hg(e, 8), Ga(t), _8.push(t.canvas);
  }
  return Rg;
}
function By(t, e, n, i) {
  const s = K_(n, e, t);
  let l = qz(
    e,
    i,
    n
  );
  const a = e.getMetersPerUnit();
  a !== void 0 && (l *= a);
  const o = t.getMetersPerUnit();
  o !== void 0 && (l /= o);
  const h = t.getExtent();
  if (!h || Da(h, s)) {
    const u = qz(t, l, s) / l;
    isFinite(u) && u > 0 && (l /= u);
  }
  return l;
}
function YC(t, e, n, i) {
  const s = Is(n);
  let l = By(
    t,
    e,
    s,
    i
  );
  return (!isFinite(l) || l <= 0) && wS(n, function(a) {
    return l = By(
      t,
      e,
      a,
      i
    ), isFinite(l) && l > 0;
  }), l;
}
function XC(t, e, n, i, s, l, a, o, h, u, d, v, m, p) {
  const _ = u4(
    Math.round(n * t),
    Math.round(n * e),
    _8
  );
  if (v || (_.imageSmoothingEnabled = !1), h.length === 0)
    return _.canvas;
  _.scale(n, n);
  function q(F) {
    return Math.round(F * n) / n;
  }
  _.globalCompositeOperation = "lighter";
  const M = U0();
  h.forEach(function(F, D, R) {
    j_(M, F.extent);
  });
  let z;
  const b = n / i, x = (v ? 1 : 1 + Math.pow(2, -24)) / b;
  if (!m || h.length !== 1 || u !== 0) {
    if (z = u4(
      Math.round(ue(M) * b),
      Math.round(G4(M) * b),
      _8
    ), v || (z.imageSmoothingEnabled = !1), s && p) {
      const F = (s[0] - M[0]) * b, D = -(s[3] - M[3]) * b, R = ue(s) * b, V = G4(s) * b;
      z.rect(F, D, R, V), z.clip();
    }
    h.forEach(function(F, D, R) {
      if (F.image.width > 0 && F.image.height > 0) {
        if (F.clipExtent) {
          z.save();
          const O = (F.clipExtent[0] - M[0]) * b, G = -(F.clipExtent[3] - M[3]) * b, j = ue(F.clipExtent) * b, Q = G4(F.clipExtent) * b;
          z.rect(
            v ? O : Math.round(O),
            v ? G : Math.round(G),
            v ? j : Math.round(O + j) - Math.round(O),
            v ? Q : Math.round(G + Q) - Math.round(G)
          ), z.clip();
        }
        const V = (F.extent[0] - M[0]) * b, J = -(F.extent[3] - M[3]) * b, K = ue(F.extent) * b, P = G4(F.extent) * b;
        z.drawImage(
          F.image,
          u,
          u,
          F.image.width - 2 * u,
          F.image.height - 2 * u,
          v ? V : Math.round(V),
          v ? J : Math.round(J),
          v ? K : Math.round(V + K) - Math.round(V),
          v ? P : Math.round(J + P) - Math.round(J)
        ), F.clipExtent && z.restore();
      }
    });
  }
  const k = Lr(a);
  return o.getTriangles().forEach(function(F, D, R) {
    const V = F.source, J = F.target;
    let K = V[0][0], P = V[0][1], O = V[1][0], G = V[1][1], j = V[2][0], Q = V[2][1];
    const i1 = q((J[0][0] - k[0]) / l), h1 = q(
      -(J[0][1] - k[1]) / l
    ), c1 = q((J[1][0] - k[0]) / l), M1 = q(
      -(J[1][1] - k[1]) / l
    ), y1 = q((J[2][0] - k[0]) / l), A1 = q(
      -(J[2][1] - k[1]) / l
    ), $ = K, a1 = P;
    K = 0, P = 0, O -= $, G -= a1, j -= $, Q -= a1;
    const n1 = [
      [O, G, 0, 0, c1 - i1],
      [j, Q, 0, 0, y1 - i1],
      [0, 0, O, G, M1 - h1],
      [0, 0, j, Q, A1 - h1]
    ], f1 = hg1(n1);
    if (!f1)
      return;
    if (_.save(), _.beginPath(), cz1() || !v) {
      _.moveTo(c1, M1);
      const C1 = 4, E1 = i1 - c1, T1 = h1 - M1;
      for (let n2 = 0; n2 < C1; n2++)
        _.lineTo(
          c1 + q((n2 + 1) * E1 / C1),
          M1 + q(n2 * T1 / (C1 - 1))
        ), n2 != C1 - 1 && _.lineTo(
          c1 + q((n2 + 1) * E1 / C1),
          M1 + q((n2 + 1) * T1 / (C1 - 1))
        );
      _.lineTo(y1, A1);
    } else
      _.moveTo(c1, M1), _.lineTo(i1, h1), _.lineTo(y1, A1);
    _.clip(), _.transform(
      f1[0],
      f1[2],
      f1[1],
      f1[3],
      i1,
      h1
    ), _.translate(
      M[0] - $,
      M[3] - a1
    );
    let w1;
    if (z)
      w1 = z.canvas, _.scale(x, -x);
    else {
      const C1 = h[0], E1 = C1.extent;
      w1 = C1.image, _.scale(
        ue(E1) / w1.width,
        -G4(E1) / w1.height
      );
    }
    _.drawImage(w1, 0, 0), _.restore();
  }), z && (Ga(z), _8.push(z.canvas)), d && (_.save(), _.globalCompositeOperation = "source-over", _.strokeStyle = "black", _.lineWidth = 1, o.getTriangles().forEach(function(F, D, R) {
    const V = F.target, J = (V[0][0] - k[0]) / l, K = -(V[0][1] - k[1]) / l, P = (V[1][0] - k[0]) / l, O = -(V[1][1] - k[1]) / l, G = (V[2][0] - k[0]) / l, j = -(V[2][1] - k[1]) / l;
    _.beginPath(), _.moveTo(P, O), _.lineTo(J, K), _.lineTo(G, j), _.closePath(), _.stroke();
  }), _.restore()), _.canvas;
}
class hz1 extends Py {
  /**
   * @param {Options} options Tile options.
   */
  constructor(e) {
    super({
      tileCoord: e.tileCoord,
      loader: () => Promise.resolve(new Uint8ClampedArray(4)),
      interpolate: e.interpolate,
      transition: e.transition
    }), this.pixelRatio_ = e.pixelRatio, this.gutter_ = e.gutter, this.reprojData_ = null, this.reprojError_ = null, this.reprojSize_ = void 0, this.sourceTileGrid_ = e.sourceTileGrid, this.targetTileGrid_ = e.targetTileGrid, this.wrappedTileCoord_ = e.wrappedTileCoord || e.tileCoord, this.sourceTiles_ = [], this.sourcesListenerKeys_ = null, this.sourceZ_ = 0;
    const n = e.sourceProj, i = n.getExtent(), s = e.sourceTileGrid.getExtent();
    this.clipExtent_ = n.canWrapX() ? s ? rn(i, s) : i : s;
    const l = this.targetTileGrid_.getTileCoordExtent(
      this.wrappedTileCoord_
    ), a = this.targetTileGrid_.getExtent();
    let o = this.sourceTileGrid_.getExtent();
    const h = a ? rn(l, a) : l;
    if (Uo(h) === 0) {
      this.state = H2.EMPTY;
      return;
    }
    i && (o ? o = rn(o, i) : o = i);
    const u = this.targetTileGrid_.getResolution(
      this.wrappedTileCoord_[0]
    ), d = e.targetProj, v = YC(
      n,
      d,
      h,
      u
    );
    if (!isFinite(v) || v <= 0) {
      this.state = H2.EMPTY;
      return;
    }
    const m = e.errorThreshold !== void 0 ? e.errorThreshold : GC;
    if (this.triangulation_ = new WC(
      n,
      d,
      h,
      o,
      v * m,
      u
    ), this.triangulation_.getTriangles().length === 0) {
      this.state = H2.EMPTY;
      return;
    }
    this.sourceZ_ = this.sourceTileGrid_.getZForResolution(v);
    let p = this.triangulation_.calculateSourceExtent();
    if (o && (n.canWrapX() ? (p[1] = bt(
      p[1],
      o[1],
      o[3]
    ), p[3] = bt(
      p[3],
      o[1],
      o[3]
    )) : p = rn(p, o)), !Uo(p))
      this.state = H2.EMPTY;
    else {
      let _ = 0, q = 0;
      n.canWrapX() && (_ = ue(i), q = Math.floor(
        (p[0] - i[0]) / _
      )), G_(
        p.slice(),
        n,
        !0
      ).forEach((z) => {
        const b = this.sourceTileGrid_.getTileRangeForExtentAndZ(
          z,
          this.sourceZ_
        ), x = e.getTileFunction;
        for (let k = b.minX; k <= b.maxX; k++)
          for (let F = b.minY; F <= b.maxY; F++) {
            const D = x(this.sourceZ_, k, F, this.pixelRatio_);
            if (D) {
              const R = q * _;
              this.sourceTiles_.push({ tile: D, offset: R });
            }
          }
        ++q;
      }), this.sourceTiles_.length === 0 && (this.state = H2.EMPTY);
    }
  }
  /**
   * Get the tile size.
   * @return {import('../size.js').Size} Tile size.
   * @override
   */
  getSize() {
    return this.reprojSize_;
  }
  /**
   * Get the data for the tile.
   * @return {import("../DataTile.js").Data} Tile data.
   * @override
   */
  getData() {
    return this.reprojData_;
  }
  /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @override
   */
  getError() {
    return this.reprojError_;
  }
  /**
   * @private
   */
  reproject_() {
    const e = [];
    let n = !1;
    if (this.sourceTiles_.forEach((_) => {
      var h1;
      const q = _.tile;
      if (!q || q.getState() !== H2.LOADED)
        return;
      const M = q.getSize(), z = this.gutter_;
      let b;
      const x = nz1(q.getData());
      x ? b = x : (n = !0, b = sz1(ru(q.getData())));
      const k = [M[0] + 2 * z, M[1] + 2 * z], F = b instanceof Float32Array, D = k[0] * k[1], R = F ? Float32Array : Uint8ClampedArray, V = new R(b.buffer), J = R.BYTES_PER_ELEMENT, K = J * V.length / D, P = V.byteLength / k[1], O = Math.floor(
        P / J / k[0]
      ), G = D * O;
      let j = V;
      if (V.length !== G) {
        j = new R(G);
        let c1 = 0, M1 = 0;
        const y1 = k[0] * O;
        for (let A1 = 0; A1 < k[1]; ++A1) {
          for (let $ = 0; $ < y1; ++$)
            j[c1++] = V[M1 + $];
          M1 += P / J;
        }
      }
      const Q = this.sourceTileGrid_.getTileCoordExtent(q.tileCoord);
      Q[0] += _.offset, Q[2] += _.offset;
      const i1 = (h1 = this.clipExtent_) == null ? void 0 : h1.slice();
      i1 && (i1[0] += _.offset, i1[2] += _.offset), e.push({
        extent: Q,
        clipExtent: i1,
        data: new Uint8ClampedArray(j.buffer),
        dataType: R,
        bytesPerPixel: K,
        pixelSize: k
      });
    }), this.sourceTiles_.length = 0, e.length === 0) {
      this.state = H2.ERROR, this.changed();
      return;
    }
    const i = this.wrappedTileCoord_[0], s = this.targetTileGrid_.getTileSize(i), l = typeof s == "number" ? s : s[0], a = typeof s == "number" ? s : s[1], o = this.targetTileGrid_.getResolution(i), h = this.sourceTileGrid_.getResolution(this.sourceZ_), u = this.targetTileGrid_.getTileCoordExtent(
      this.wrappedTileCoord_
    );
    let d, v;
    const m = e[0].bytesPerPixel, p = Math.ceil(m / 3);
    for (let _ = p - 1; _ >= 0; --_) {
      const q = [];
      for (let F = 0, D = e.length; F < D; ++F) {
        const R = e[F], V = R.data, J = R.pixelSize, K = J[0], P = J[1], O = u4(K, P, _8), G = O.createImageData(K, P), j = G.data;
        let Q = _ * 3;
        for (let i1 = 0, h1 = j.length; i1 < h1; i1 += 4)
          j[i1] = V[Q], j[i1 + 1] = V[Q + 1], j[i1 + 2] = V[Q + 2], j[i1 + 3] = 255, Q += m;
        O.putImageData(G, 0, 0), q.push({
          extent: R.extent,
          clipExtent: R.clipExtent,
          image: O.canvas
        });
      }
      const M = XC(
        l,
        a,
        this.pixelRatio_,
        h,
        this.sourceTileGrid_.getExtent(),
        o,
        u,
        this.triangulation_,
        q,
        this.gutter_,
        !1,
        !1,
        !1
      );
      for (let F = 0, D = q.length; F < D; ++F) {
        const V = q[F].image.getContext("2d");
        Ga(V), _8.push(V.canvas);
      }
      const z = M.getContext("2d"), b = z.getImageData(0, 0, M.width, M.height);
      Ga(z), _8.push(M), d || (v = new Uint8ClampedArray(
        m * b.width * b.height
      ), d = new e[0].dataType(v.buffer));
      const x = b.data;
      let k = _ * 3;
      for (let F = 0, D = x.length; F < D; F += 4)
        x[F + 3] === 255 ? (v[k] = x[F], v[k + 1] = x[F + 1], v[k + 2] = x[F + 2]) : (v[k] = 0, v[k + 1] = 0, v[k + 2] = 0), k += m;
    }
    if (n) {
      const _ = u4(l, a), q = new ImageData(d, l);
      _.putImageData(q, 0, 0), this.reprojData_ = _.canvas;
    } else
      this.reprojData_ = d;
    this.reprojSize_ = [
      Math.round(l * this.pixelRatio_),
      Math.round(a * this.pixelRatio_)
    ], this.state = H2.LOADED, this.changed();
  }
  /**
   * Load not yet loaded URI.
   * @override
   */
  load() {
    if (this.state !== H2.IDLE && this.state !== H2.ERROR)
      return;
    this.state = H2.LOADING, this.changed();
    let e = 0;
    this.sourcesListenerKeys_ = [], this.sourceTiles_.forEach(({ tile: n }) => {
      const i = n.getState();
      if (i !== H2.IDLE && i !== H2.LOADING)
        return;
      e++;
      const s = ae(n, T3.CHANGE, () => {
        const l = n.getState();
        (l == H2.LOADED || l == H2.ERROR || l == H2.EMPTY) && (Qe(s), e--, e === 0 && (this.unlistenSources_(), this.reproject_()));
      });
      this.sourcesListenerKeys_.push(s);
    }), e === 0 ? setTimeout(this.reproject_.bind(this), 0) : this.sourceTiles_.forEach(function({ tile: n }) {
      n.getState() == H2.IDLE && n.load();
    });
  }
  /**
   * @private
   */
  unlistenSources_() {
    this.sourcesListenerKeys_.forEach(Qe), this.sourcesListenerKeys_ = null;
  }
}
const uz1 = hz1;
class dz1 extends Iq {
  /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */
  constructor(e, n, i, s, l, a, o, h, u, d, v, m) {
    super(l, H2.IDLE, m), this.renderEdges_ = v !== void 0 ? v : !1, this.pixelRatio_ = o, this.gutter_ = h, this.canvas_ = null, this.sourceTileGrid_ = n, this.targetTileGrid_ = s, this.wrappedTileCoord_ = a || l, this.sourceTiles_ = [], this.sourcesListenerKeys_ = null, this.sourceZ_ = 0, this.clipExtent_ = e.canWrapX() ? e.getExtent() : void 0;
    const p = s.getTileCoordExtent(
      this.wrappedTileCoord_
    ), _ = this.targetTileGrid_.getExtent();
    let q = this.sourceTileGrid_.getExtent();
    const M = _ ? rn(p, _) : p;
    if (Uo(M) === 0) {
      this.state = H2.EMPTY;
      return;
    }
    const z = e.getExtent();
    z && (q ? q = rn(q, z) : q = z);
    const b = s.getResolution(
      this.wrappedTileCoord_[0]
    ), x = YC(
      e,
      i,
      M,
      b
    );
    if (!isFinite(x) || x <= 0) {
      this.state = H2.EMPTY;
      return;
    }
    const k = d !== void 0 ? d : GC;
    if (this.triangulation_ = new WC(
      e,
      i,
      M,
      q,
      x * k,
      b
    ), this.triangulation_.getTriangles().length === 0) {
      this.state = H2.EMPTY;
      return;
    }
    this.sourceZ_ = n.getZForResolution(x);
    let F = this.triangulation_.calculateSourceExtent();
    if (q && (e.canWrapX() ? (F[1] = bt(
      F[1],
      q[1],
      q[3]
    ), F[3] = bt(
      F[3],
      q[1],
      q[3]
    )) : F = rn(F, q)), !Uo(F))
      this.state = H2.EMPTY;
    else {
      let D = 0, R = 0;
      e.canWrapX() && (D = ue(z), R = Math.floor(
        (F[0] - z[0]) / D
      )), G_(
        F.slice(),
        e,
        !0
      ).forEach((J) => {
        const K = n.getTileRangeForExtentAndZ(
          J,
          this.sourceZ_
        );
        for (let P = K.minX; P <= K.maxX; P++)
          for (let O = K.minY; O <= K.maxY; O++) {
            const G = u(this.sourceZ_, P, O, o);
            if (G) {
              const j = R * D;
              this.sourceTiles_.push({ tile: G, offset: j });
            }
          }
        ++R;
      }), this.sourceTiles_.length === 0 && (this.state = H2.EMPTY);
    }
  }
  /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */
  getImage() {
    return this.canvas_;
  }
  /**
   * @private
   */
  reproject_() {
    const e = [];
    if (this.sourceTiles_.forEach((n) => {
      var s;
      const i = n.tile;
      if (i && i.getState() == H2.LOADED) {
        const l = this.sourceTileGrid_.getTileCoordExtent(i.tileCoord);
        l[0] += n.offset, l[2] += n.offset;
        const a = (s = this.clipExtent_) == null ? void 0 : s.slice();
        a && (a[0] += n.offset, a[2] += n.offset), e.push({
          extent: l,
          clipExtent: a,
          image: i.getImage()
        });
      }
    }), this.sourceTiles_.length = 0, e.length === 0)
      this.state = H2.ERROR;
    else {
      const n = this.wrappedTileCoord_[0], i = this.targetTileGrid_.getTileSize(n), s = typeof i == "number" ? i : i[0], l = typeof i == "number" ? i : i[1], a = this.targetTileGrid_.getResolution(n), o = this.sourceTileGrid_.getResolution(
        this.sourceZ_
      ), h = this.targetTileGrid_.getTileCoordExtent(
        this.wrappedTileCoord_
      );
      this.canvas_ = XC(
        s,
        l,
        this.pixelRatio_,
        o,
        this.sourceTileGrid_.getExtent(),
        a,
        h,
        this.triangulation_,
        e,
        this.gutter_,
        this.renderEdges_,
        this.interpolate
      ), this.state = H2.LOADED;
    }
    this.changed();
  }
  /**
   * Load not yet loaded URI.
   * @override
   */
  load() {
    if (this.state == H2.IDLE) {
      this.state = H2.LOADING, this.changed();
      let e = 0;
      this.sourcesListenerKeys_ = [], this.sourceTiles_.forEach(({ tile: n }) => {
        const i = n.getState();
        if (i == H2.IDLE || i == H2.LOADING) {
          e++;
          const s = ae(n, T3.CHANGE, (l) => {
            const a = n.getState();
            (a == H2.LOADED || a == H2.ERROR || a == H2.EMPTY) && (Qe(s), e--, e === 0 && (this.unlistenSources_(), this.reproject_()));
          });
          this.sourcesListenerKeys_.push(s);
        }
      }), e === 0 ? setTimeout(this.reproject_.bind(this), 0) : this.sourceTiles_.forEach(function({ tile: n }, i, s) {
        n.getState() == H2.IDLE && n.load();
      });
    }
  }
  /**
   * @private
   */
  unlistenSources_() {
    this.sourcesListenerKeys_.forEach(Qe), this.sourcesListenerKeys_ = null;
  }
  /**
   * Remove from the cache due to expiry
   * @override
   */
  release() {
    this.canvas_ && (Ga(this.canvas_.getContext("2d")), _8.push(this.canvas_), this.canvas_ = null), super.release();
  }
}
const KC = dz1;
function Dg(t, e, n, i) {
  return `${t},${ld(e, n, i)}`;
}
function $g(t, e, n) {
  if (!(n in t))
    return t[n] = /* @__PURE__ */ new Set([e]), !0;
  const i = t[n], s = i.has(e);
  return s || i.add(e), !s;
}
function fz1(t, e, n) {
  const i = t[n];
  return i ? i.delete(e) : !1;
}
function fM(t, e) {
  const n = t.layerStatesArray[t.layerIndex];
  n.extent && (e = rn(
    e,
    qs(n.extent, t.viewState.projection)
  ));
  const i = (
    /** @type {import("../../source/Tile.js").default} */
    n.layer.getRenderSource()
  );
  if (!i.getWrapX()) {
    const s = i.getTileGridForProjection(t.viewState.projection).getExtent();
    s && (e = rn(e, s));
  }
  return e;
}
class vz1 extends zC {
  /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */
  constructor(e, n) {
    super(e), n = n || {}, this.extentChanged = !0, this.renderComplete = !1, this.renderedExtent_ = null, this.renderedPixelRatio, this.renderedProjection = null, this.renderedRevision, this.renderedTiles = [], this.renderedSourceKey_, this.renderedSourceRevision_, this.tempExtent = U0(), this.tempTileRange_ = new jC(0, 0, 0, 0), this.tempTileCoord_ = lu(0, 0, 0);
    const i = n.cacheSize !== void 0 ? n.cacheSize : 512;
    this.tileCache_ = new RC(i), this.maxStaleKeys = i * 0.5;
  }
  /**
   * @return {LRUCache} Tile cache.
   */
  getTileCache() {
    return this.tileCache_;
  }
  /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */
  getOrCreateTile(e, n, i, s) {
    const l = this.tileCache_, o = this.getLayer().getSource(), h = Dg(o.getKey(), e, n, i);
    let u;
    if (l.containsKey(h))
      u = l.get(h);
    else {
      if (u = o.getTile(
        e,
        n,
        i,
        s.pixelRatio,
        s.viewState.projection
      ), !u)
        return null;
      l.set(h, u);
    }
    return u;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */
  getTile(e, n, i, s) {
    const l = this.getOrCreateTile(e, n, i, s);
    return l || null;
  }
  /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */
  getData(e) {
    const n = this.frameState;
    if (!n)
      return null;
    const i = this.getLayer(), s = j4(
      n.pixelToCoordinateTransform,
      e.slice()
    ), l = i.getExtent();
    if (l && !Da(l, s))
      return null;
    const a = n.viewState, o = i.getRenderSource(), h = o.getTileGridForProjection(a.projection), u = o.getTilePixelRatio(n.pixelRatio);
    for (let d = h.getZForResolution(a.resolution); d >= h.getMinZoom(); --d) {
      const v = h.getTileCoordForCoordAndZ(s, d), m = this.getTile(d, v[1], v[2], n);
      if (!m || m.getState() !== H2.LOADED)
        continue;
      const p = h.getOrigin(d), _ = o0(h.getTileSize(d)), q = h.getResolution(d);
      let M;
      if (m instanceof AC)
        M = m.getImage();
      else if (m instanceof Py) {
        if (M = ru(m.getData()), !M)
          continue;
      } else
        continue;
      const z = Math.floor(
        u * ((s[0] - p[0]) / q - v[1] * _[0])
      ), b = Math.floor(
        u * ((p[1] - s[1]) / q - v[2] * _[1])
      ), x = Math.round(
        u * o.getGutterForProjection(a.projection)
      );
      return this.getImageData(M, z + x, b + x);
    }
    return null;
  }
  /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */
  prepareFrame(e) {
    const n = this.getLayer().getSource();
    if (!n)
      return !1;
    const i = this.getLayer().getSource().getRevision();
    return this.renderedRevision_ ? this.renderedRevision_ !== i && (this.renderedRevision_ = i, this.renderedSourceKey_ === n.getKey() && this.tileCache_.clear()) : this.renderedRevision_ = i, !0;
  }
  /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */
  enqueueTiles(e, n, i, s, l) {
    const a = e.viewState, o = this.getLayer(), h = o.getRenderSource(), u = h.getTileGridForProjection(a.projection), d = Be(h);
    d in e.wantedTiles || (e.wantedTiles[d] = {});
    const v = e.wantedTiles[d], m = o.getMapInternal(), p = Math.max(
      i - l,
      u.getMinZoom(),
      u.getZForResolution(
        Math.min(
          o.getMaxResolution(),
          m ? m.getView().getResolutionForZoom(Math.max(o.getMinZoom(), 0)) : u.getResolution(0)
        ),
        h.zDirection
      )
    );
    for (let _ = i; _ >= p; --_) {
      const q = u.getTileRangeForExtentAndZ(
        n,
        _,
        this.tempTileRange_
      ), M = u.getResolution(_);
      for (let z = q.minX; z <= q.maxX; ++z)
        for (let b = q.minY; b <= q.maxY; ++b) {
          const x = this.getTile(_, z, b, e);
          if (!x || !$g(s, x, _))
            continue;
          const F = x.getKey();
          if (v[F] = !0, x.getState() === H2.IDLE && !e.tileQueue.isKeyQueued(F)) {
            const D = lu(_, z, b, this.tempTileCoord_);
            e.tileQueue.enqueue([
              x,
              d,
              u.getTileCoordCenter(D),
              M
            ]);
          }
        }
    }
  }
  /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */
  findStaleTile_(e, n) {
    const i = this.tileCache_, s = e[0], l = e[1], a = e[2], o = this.getStaleKeys();
    for (let h = 0; h < o.length; ++h) {
      const u = Dg(o[h], s, l, a);
      if (i.containsKey(u)) {
        const d = i.get(u);
        if (d.getState() === H2.LOADED)
          return d.endTransition(Be(this)), $g(n, d, s), !0;
      }
    }
    return !1;
  }
  /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */
  findAltTiles_(e, n, i, s) {
    const l = e.getTileRangeForTileCoordAndZ(
      n,
      i,
      this.tempTileRange_
    );
    if (!l)
      return !1;
    let a = !0;
    const o = this.tileCache_, u = this.getLayer().getRenderSource().getKey();
    for (let d = l.minX; d <= l.maxX; ++d)
      for (let v = l.minY; v <= l.maxY; ++v) {
        const m = Dg(u, i, d, v);
        let p = !1;
        if (o.containsKey(m)) {
          const _ = o.get(m);
          _.getState() === H2.LOADED && ($g(s, _, i), p = !0);
        }
        p || (a = !1);
      }
    return a;
  }
  /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */
  renderFrame(e, n) {
    this.renderComplete = !0;
    const i = e.layerStatesArray[e.layerIndex], s = e.viewState, l = s.projection, a = s.resolution, o = s.center, h = e.pixelRatio, u = this.getLayer(), d = u.getSource(), v = d.getRevision(), m = d.getTileGridForProjection(l), p = m.getZForResolution(a, d.zDirection), _ = m.getResolution(p), q = d.getKey();
    this.renderedSourceKey_ ? this.renderedSourceKey_ !== q && (this.prependStaleKey(this.renderedSourceKey_), this.renderedSourceKey_ = q) : this.renderedSourceKey_ = q;
    let M = e.extent;
    const z = d.getTilePixelRatio(h);
    this.prepareContainer(e, n);
    const b = this.context.canvas.width, x = this.context.canvas.height, k = i.extent && qs(i.extent);
    k && (M = rn(
      M,
      qs(i.extent)
    ));
    const F = _ * b / 2 / z, D = _ * x / 2 / z, R = [
      o[0] - F,
      o[1] - D,
      o[0] + F,
      o[1] + D
    ], V = {}, J = u.getPreload();
    if (e.nextExtent) {
      const y1 = m.getZForResolution(
        s.nextResolution,
        d.zDirection
      ), A1 = fM(e, e.nextExtent);
      this.enqueueTiles(e, A1, y1, V, J);
    }
    const K = fM(e, M);
    this.enqueueTiles(e, K, p, V, 0), J > 0 && setTimeout(() => {
      this.enqueueTiles(
        e,
        K,
        p - 1,
        V,
        J - 1
      );
    }, 0);
    const P = Be(this), O = e.time;
    for (const y1 of V[p]) {
      const A1 = y1.getState();
      if ((y1 instanceof KC || y1 instanceof uz1) && A1 === H2.EMPTY)
        continue;
      const $ = y1.tileCoord;
      if (A1 === H2.LOADED && y1.getAlpha(P, O) === 1) {
        y1.endTransition(P);
        continue;
      }
      if (this.renderComplete = !1, this.findStaleTile_($, V)) {
        fz1(V, y1, p), e.animate = !0;
        continue;
      }
      if (this.findAltTiles_(
        m,
        $,
        p + 1,
        V
      ))
        continue;
      const f1 = m.getMinZoom();
      for (let w1 = p - 1; w1 >= f1 && !this.findAltTiles_(
        m,
        $,
        w1,
        V
      ); --w1)
        ;
    }
    const G = _ / a * h / z, j = this.getRenderContext(e);
    b8(
      this.tempTransform,
      b / 2,
      x / 2,
      G,
      G,
      0,
      -b / 2,
      -x / 2
    ), i.extent && this.clipUnrotated(j, e, k), d.getInterpolate() || (j.imageSmoothingEnabled = !1), this.preRender(j, e), this.renderedTiles.length = 0;
    const Q = Object.keys(V).map(Number);
    Q.sort(m8);
    let i1;
    const h1 = [], c1 = [];
    for (let y1 = Q.length - 1; y1 >= 0; --y1) {
      const A1 = Q[y1], $ = d.getTilePixelSize(
        A1,
        h,
        l
      ), n1 = m.getResolution(A1) / _, f1 = $[0] * n1 * G, w1 = $[1] * n1 * G, C1 = m.getTileCoordForCoordAndZ(
        Lr(R),
        A1
      ), E1 = m.getTileCoordExtent(C1), T1 = j4(this.tempTransform, [
        z * (E1[0] - R[0]) / _,
        z * (R[3] - E1[3]) / _
      ]), n2 = z * d.getGutterForProjection(l);
      for (const X1 of V[A1]) {
        if (X1.getState() !== H2.LOADED)
          continue;
        const a2 = X1.tileCoord, d2 = C1[1] - a2[1], y2 = Math.round(T1[0] - (d2 - 1) * f1), B1 = C1[2] - a2[2], p1 = Math.round(T1[1] - (B1 - 1) * w1), _2 = Math.round(T1[0] - d2 * f1), w2 = Math.round(T1[1] - B1 * w1), K1 = y2 - _2, e2 = p1 - w2, Z1 = Q.length === 1;
        let t2 = !1;
        i1 = [_2, w2, _2 + K1, w2, _2 + K1, w2 + e2, _2, w2 + e2];
        for (let S2 = 0, W2 = h1.length; S2 < W2; ++S2)
          if (!Z1 && A1 < c1[S2]) {
            const E2 = h1[S2];
            r0(
              [_2, w2, _2 + K1, w2 + e2],
              [E2[0], E2[3], E2[4], E2[7]]
            ) && (t2 || (j.save(), t2 = !0), j.beginPath(), j.moveTo(i1[0], i1[1]), j.lineTo(i1[2], i1[3]), j.lineTo(i1[4], i1[5]), j.lineTo(i1[6], i1[7]), j.moveTo(E2[6], E2[7]), j.lineTo(E2[4], E2[5]), j.lineTo(E2[2], E2[3]), j.lineTo(E2[0], E2[1]), j.clip());
          }
        h1.push(i1), c1.push(A1), this.drawTile(X1, e, _2, w2, K1, e2, n2, Z1), t2 && j.restore(), this.renderedTiles.unshift(X1), this.updateUsedTiles(e.usedTiles, d, X1);
      }
    }
    this.renderedRevision = v, this.renderedResolution = _, this.extentChanged = !this.renderedExtent_ || !$o(this.renderedExtent_, R), this.renderedExtent_ = R, this.renderedPixelRatio = h, this.renderedProjection = l, this.postRender(this.context, e), i.extent && j.restore(), j.imageSmoothingEnabled = !0;
    const M1 = (y1, A1) => {
      const $ = Be(d), a1 = A1.wantedTiles[$], n1 = a1 ? Object.keys(a1).length : 0;
      this.updateCacheSize(n1), this.tileCache_.expireCache();
    };
    return e.postRenderFunctions.push(M1), this.container;
  }
  /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */
  updateCacheSize(e) {
    this.tileCache_.highWaterMark = Math.max(
      this.tileCache_.highWaterMark,
      e * 2
    );
  }
  /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @protected
   */
  drawTile(e, n, i, s, l, a, o, h) {
    let u;
    if (e instanceof Py) {
      if (u = ru(e.getData()), !u)
        throw new Error("Rendering array data is not yet supported");
    } else
      u = this.getTileImage(
        /** @type {import("../../ImageTile.js").default} */
        e
      );
    if (!u)
      return;
    const d = this.getRenderContext(n), v = Be(this), m = n.layerStatesArray[n.layerIndex], p = m.opacity * (h ? e.getAlpha(v, n.time) : 1), _ = p !== d.globalAlpha;
    _ && (d.save(), d.globalAlpha = p), d.drawImage(
      u,
      o,
      o,
      u.width - 2 * o,
      u.height - 2 * o,
      i,
      s,
      l,
      a
    ), _ && d.restore(), p !== m.opacity ? n.animate = !0 : h && e.endTransition(v);
  }
  /**
   * @return {HTMLCanvasElement} Image
   */
  getImage() {
    const e = this.context;
    return e ? e.canvas : null;
  }
  /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */
  getTileImage(e) {
    return e.getImage();
  }
  /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */
  updateUsedTiles(e, n, i) {
    const s = Be(n);
    s in e || (e[s] = {}), e[s][i.getKey()] = !0;
  }
}
const pz1 = vz1;
class mz1 extends tz1 {
  /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */
  constructor(e) {
    super(e);
  }
  /**
   * @override
   */
  createRenderer() {
    return new pz1(this, {
      cacheSize: this.getCacheSize()
    });
  }
}
const ZC = mz1, Ug = {
  /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */
  TILELOADSTART: "tileloadstart",
  /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */
  TILELOADEND: "tileloadend",
  /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */
  TILELOADERROR: "tileloaderror"
}, Jr = [0, 0, 0], hs = 5;
class gz1 {
  /**
   * @param {Options} options Tile grid options.
   */
  constructor(e) {
    this.minZoom = e.minZoom !== void 0 ? e.minZoom : 0, this.resolutions_ = e.resolutions, ge(
      xg1(
        this.resolutions_,
        /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */
        (s, l) => l - s,
        !0
      ),
      "`resolutions` must be sorted in descending order"
    );
    let n;
    if (!e.origins) {
      for (let s = 0, l = this.resolutions_.length - 1; s < l; ++s)
        if (!n)
          n = this.resolutions_[s] / this.resolutions_[s + 1];
        else if (this.resolutions_[s] / this.resolutions_[s + 1] !== n) {
          n = void 0;
          break;
        }
    }
    this.zoomFactor_ = n, this.maxZoom = this.resolutions_.length - 1, this.origin_ = e.origin !== void 0 ? e.origin : null, this.origins_ = null, e.origins !== void 0 && (this.origins_ = e.origins, ge(
      this.origins_.length == this.resolutions_.length,
      "Number of `origins` and `resolutions` must be equal"
    ));
    const i = e.extent;
    i !== void 0 && !this.origin_ && !this.origins_ && (this.origin_ = Lr(i)), ge(
      !this.origin_ && this.origins_ || this.origin_ && !this.origins_,
      "Either `origin` or `origins` must be configured, never both"
    ), this.tileSizes_ = null, e.tileSizes !== void 0 && (this.tileSizes_ = e.tileSizes, ge(
      this.tileSizes_.length == this.resolutions_.length,
      "Number of `tileSizes` and `resolutions` must be equal"
    )), this.tileSize_ = e.tileSize !== void 0 ? e.tileSize : this.tileSizes_ ? null : bq, ge(
      !this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_,
      "Either `tileSize` or `tileSizes` must be configured, never both"
    ), this.extent_ = i !== void 0 ? i : null, this.fullTileRanges_ = null, this.tmpSize_ = [0, 0], this.tmpExtent_ = [0, 0, 0, 0], e.sizes !== void 0 ? this.fullTileRanges_ = e.sizes.map((s, l) => {
      const a = new jC(
        Math.min(0, s[0]),
        Math.max(s[0] - 1, -1),
        Math.min(0, s[1]),
        Math.max(s[1] - 1, -1)
      );
      if (i) {
        const o = this.getTileRangeForExtentAndZ(i, l);
        a.minX = Math.max(o.minX, a.minX), a.maxX = Math.min(o.maxX, a.maxX), a.minY = Math.max(o.minY, a.minY), a.maxY = Math.min(o.maxY, a.maxY);
      }
      return a;
    }) : i && this.calculateTileRanges_(i);
  }
  /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */
  forEachTileCoord(e, n, i) {
    const s = this.getTileRangeForExtentAndZ(e, n);
    for (let l = s.minX, a = s.maxX; l <= a; ++l)
      for (let o = s.minY, h = s.maxY; o <= h; ++o)
        i([n, l, o]);
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */
  forEachTileCoordParentTileRange(e, n, i, s) {
    let l, a, o, h = null, u = e[0] - 1;
    for (this.zoomFactor_ === 2 ? (a = e[1], o = e[2]) : h = this.getTileCoordExtent(e, s); u >= this.minZoom; ) {
      if (a !== void 0 && o !== void 0 ? (a = Math.floor(a / 2), o = Math.floor(o / 2), l = Kr(a, a, o, o, i)) : l = this.getTileRangeForExtentAndZ(
        h,
        u,
        i
      ), n(u, l))
        return !0;
      --u;
    }
    return !1;
  }
  /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getExtent() {
    return this.extent_;
  }
  /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */
  getMaxZoom() {
    return this.maxZoom;
  }
  /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */
  getMinZoom() {
    return this.minZoom;
  }
  /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */
  getOrigin(e) {
    return this.origin_ ? this.origin_ : this.origins_[e];
  }
  /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */
  getResolution(e) {
    return this.resolutions_[e];
  }
  /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */
  getResolutions() {
    return this.resolutions_;
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */
  getTileCoordChildTileRange(e, n, i) {
    if (e[0] < this.maxZoom) {
      if (this.zoomFactor_ === 2) {
        const l = e[1] * 2, a = e[2] * 2;
        return Kr(
          l,
          l + 1,
          a,
          a + 1,
          n
        );
      }
      const s = this.getTileCoordExtent(
        e,
        i || this.tmpExtent_
      );
      return this.getTileRangeForExtentAndZ(
        s,
        e[0] + 1,
        n
      );
    }
    return null;
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */
  getTileRangeForTileCoordAndZ(e, n, i) {
    if (n > this.maxZoom || n < this.minZoom)
      return null;
    const s = e[0], l = e[1], a = e[2];
    if (n === s)
      return Kr(
        l,
        a,
        l,
        a,
        i
      );
    if (this.zoomFactor_) {
      const h = Math.pow(this.zoomFactor_, n - s), u = Math.floor(l * h), d = Math.floor(a * h);
      if (n < s)
        return Kr(u, u, d, d, i);
      const v = Math.floor(h * (l + 1)) - 1, m = Math.floor(h * (a + 1)) - 1;
      return Kr(u, v, d, m, i);
    }
    const o = this.getTileCoordExtent(e, this.tmpExtent_);
    return this.getTileRangeForExtentAndZ(o, n, i);
  }
  /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */
  getTileRangeForExtentAndZ(e, n, i) {
    this.getTileCoordForXYAndZ_(e[0], e[3], n, !1, Jr);
    const s = Jr[1], l = Jr[2];
    this.getTileCoordForXYAndZ_(e[2], e[1], n, !0, Jr);
    const a = Jr[1], o = Jr[2];
    return Kr(s, a, l, o, i);
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */
  getTileCoordCenter(e) {
    const n = this.getOrigin(e[0]), i = this.getResolution(e[0]), s = o0(this.getTileSize(e[0]), this.tmpSize_);
    return [
      n[0] + (e[1] + 0.5) * s[0] * i,
      n[1] - (e[2] + 0.5) * s[1] * i
    ];
  }
  /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */
  getTileCoordExtent(e, n) {
    const i = this.getOrigin(e[0]), s = this.getResolution(e[0]), l = o0(this.getTileSize(e[0]), this.tmpSize_), a = i[0] + e[1] * l[0] * s, o = i[1] - (e[2] + 1) * l[1] * s, h = a + l[0] * s, u = o + l[1] * s;
    return M8(a, o, h, u, n);
  }
  /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */
  getTileCoordForCoordAndResolution(e, n, i) {
    return this.getTileCoordForXYAndResolution_(
      e[0],
      e[1],
      n,
      !1,
      i
    );
  }
  /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */
  getTileCoordForXYAndResolution_(e, n, i, s, l) {
    const a = this.getZForResolution(i), o = i / this.getResolution(a), h = this.getOrigin(a), u = o0(this.getTileSize(a), this.tmpSize_);
    let d = o * (e - h[0]) / i / u[0], v = o * (h[1] - n) / i / u[1];
    return s ? (d = Yc(d, hs) - 1, v = Yc(v, hs) - 1) : (d = Wc(d, hs), v = Wc(v, hs)), lu(a, d, v, l);
  }
  /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */
  getTileCoordForXYAndZ_(e, n, i, s, l) {
    const a = this.getOrigin(i), o = this.getResolution(i), h = o0(this.getTileSize(i), this.tmpSize_);
    let u = (e - a[0]) / o / h[0], d = (a[1] - n) / o / h[1];
    return s ? (u = Yc(u, hs) - 1, d = Yc(d, hs) - 1) : (u = Wc(u, hs), d = Wc(d, hs)), lu(i, u, d, l);
  }
  /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */
  getTileCoordForCoordAndZ(e, n, i) {
    return this.getTileCoordForXYAndZ_(
      e[0],
      e[1],
      n,
      !1,
      i
    );
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */
  getTileCoordResolution(e) {
    return this.resolutions_[e[0]];
  }
  /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */
  getTileSize(e) {
    return this.tileSize_ ? this.tileSize_ : this.tileSizes_[e];
  }
  /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */
  getFullTileRange(e) {
    return this.fullTileRanges_ ? this.fullTileRanges_[e] : this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, e) : null;
  }
  /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */
  getZForResolution(e, n) {
    const i = Q_(
      this.resolutions_,
      e,
      n || 0
    );
    return bt(i, this.minZoom, this.maxZoom);
  }
  /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */
  tileCoordIntersectsViewport(e, n) {
    return US(
      n,
      0,
      n.length,
      2,
      this.getTileCoordExtent(e)
    );
  }
  /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */
  calculateTileRanges_(e) {
    const n = this.resolutions_.length, i = new Array(n);
    for (let s = this.minZoom; s < n; ++s)
      i[s] = this.getTileRangeForExtentAndZ(e, s);
    this.fullTileRanges_ = i;
  }
}
const JC = gz1;
function QC(t) {
  let e = t.getDefaultTileGrid();
  return e || (e = wz1(t), t.setDefaultTileGrid(e)), e;
}
function yz1(t, e, n) {
  const i = e[0], s = t.getTileCoordCenter(e), l = Bq(n);
  if (!Da(l, s)) {
    const a = ue(l), o = Math.ceil(
      (l[0] - s[0]) / a
    );
    return s[0] += a * o, t.getTileCoordForCoordAndZ(s, i);
  }
  return e;
}
function _z1(t, e, n, i) {
  i = i !== void 0 ? i : "top-left";
  const s = ek(t, e, n);
  return new JC({
    extent: t,
    origin: sg1(t, i),
    resolutions: s,
    tileSize: n
  });
}
function qz1(t) {
  const e = t || {}, n = e.extent || ct("EPSG:3857").getExtent(), i = {
    extent: n,
    minZoom: e.minZoom,
    tileSize: e.tileSize,
    resolutions: ek(
      n,
      e.maxZoom,
      e.tileSize,
      e.maxResolution
    )
  };
  return new JC(i);
}
function ek(t, e, n, i) {
  e = e !== void 0 ? e : Fy1, n = o0(n !== void 0 ? n : bq);
  const s = G4(t), l = ue(t);
  i = i > 0 ? i : Math.max(l / n[0], s / n[1]);
  const a = e + 1, o = new Array(a);
  for (let h = 0; h < a; ++h)
    o[h] = i / Math.pow(2, h);
  return o;
}
function wz1(t, e, n, i) {
  const s = Bq(t);
  return _z1(s, e, n, i);
}
function Bq(t) {
  t = ct(t);
  let e = t.getExtent();
  if (!e) {
    const n = 180 * Ho.degrees / t.getMetersPerUnit();
    e = M8(-n, -n, n, n);
  }
  return e;
}
class zz1 extends kC {
  /**
   * @param {Options} options SourceTile source options.
   */
  constructor(e) {
    super({
      attributions: e.attributions,
      attributionsCollapsible: e.attributionsCollapsible,
      projection: e.projection,
      state: e.state,
      wrapX: e.wrapX,
      interpolate: e.interpolate
    }), this.on, this.once, this.un, this.tilePixelRatio_ = e.tilePixelRatio !== void 0 ? e.tilePixelRatio : 1, this.tileGrid = e.tileGrid !== void 0 ? e.tileGrid : null;
    const n = [256, 256];
    this.tileGrid && o0(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), n), this.tileCache = new $C(e.cacheSize || 0), this.tmpSize = [0, 0], this.key_ = e.key || "", this.tileOptions = {
      transition: e.transition,
      interpolate: e.interpolate
    }, this.zDirection = e.zDirection ? e.zDirection : 0;
  }
  /**
   * @return {boolean} Can expire cache.
   */
  canExpireCache() {
    return this.tileCache.canExpireCache();
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */
  expireCache(e, n) {
    const i = this.getTileCacheForProjection(e);
    i && i.expireCache(n);
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */
  getGutterForProjection(e) {
    return 0;
  }
  /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */
  getKey() {
    return this.key_;
  }
  /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */
  setKey(e) {
    this.key_ !== e && (this.key_ = e, this.changed());
  }
  /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */
  getResolutions(e) {
    const n = e ? this.getTileGridForProjection(e) : this.tileGrid;
    return n ? n.getResolutions() : null;
  }
  /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {TileType|null} Tile.
   */
  getTile(e, n, i, s, l) {
    return b3();
  }
  /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */
  getTileGrid() {
    return this.tileGrid;
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */
  getTileGridForProjection(e) {
    return this.tileGrid ? this.tileGrid : QC(e);
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @protected
   */
  getTileCacheForProjection(e) {
    const n = this.getProjection();
    return ge(
      n === null || pa(n, e),
      "A VectorTile source can only be rendered if it has a projection compatible with the view projection."
    ), this.tileCache;
  }
  /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */
  getTilePixelRatio(e) {
    return this.tilePixelRatio_;
  }
  /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */
  getTilePixelSize(e, n, i) {
    const s = this.getTileGridForProjection(i), l = this.getTilePixelRatio(n), a = o0(s.getTileSize(e), this.tmpSize);
    return l == 1 ? a : _y1(a, l, this.tmpSize);
  }
  /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */
  getTileCoordForTileUrlFunction(e, n) {
    n = n !== void 0 ? n : this.getProjection();
    const i = this.getTileGridForProjection(n);
    return this.getWrapX() && n.isGlobal() && (e = yz1(i, e, n)), Jw1(e, i) ? e : null;
  }
  /**
   * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
   * @api
   */
  clear() {
    this.tileCache.clear();
  }
  /**
   * @override
   */
  refresh() {
    this.clear(), super.refresh();
  }
  /**
   * Marks a tile coord as being used, without triggering a load.
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */
  useTile(e, n, i, s) {
  }
}
class Mz1 extends k8 {
  /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */
  constructor(e, n) {
    super(e), this.tile = n;
  }
}
const bz1 = zz1;
function tk(t, e) {
  const n = [];
  Object.keys(e).forEach(function(s) {
    e[s] !== null && e[s] !== void 0 && n.push(s + "=" + encodeURIComponent(e[s]));
  });
  const i = n.join("&");
  return t = t.replace(/[?&]$/, ""), t += t.includes("?") ? "&" : "?", t + i;
}
const Lz1 = /\{z\}/g, xz1 = /\{x\}/g, Sz1 = /\{y\}/g, Cz1 = /\{-y\}/g;
function kz1(t, e, n, i, s) {
  return t.replace(Lz1, e.toString()).replace(xz1, n.toString()).replace(Sz1, i.toString()).replace(Cz1, function() {
    if (s === void 0)
      throw new Error(
        "If the URL template has a {-y} placeholder, the grid extent must be known"
      );
    return (s - i).toString();
  });
}
function Ez1(t) {
  const e = [];
  let n = /\{([a-z])-([a-z])\}/.exec(t);
  if (n) {
    const i = n[1].charCodeAt(0), s = n[2].charCodeAt(0);
    let l;
    for (l = i; l <= s; ++l)
      e.push(t.replace(n[0], String.fromCharCode(l)));
    return e;
  }
  if (n = /\{(\d+)-(\d+)\}/.exec(t), n) {
    const i = parseInt(n[2], 10);
    for (let s = parseInt(n[1], 10); s <= i; s++)
      e.push(t.replace(n[0], s.toString()));
    return e;
  }
  return e.push(t), e;
}
function Az1(t, e) {
  return (
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */
    function(n, i, s) {
      if (!n)
        return;
      let l;
      const a = n[0];
      if (e) {
        const o = e.getFullTileRange(a);
        o && (l = o.getHeight() - 1);
      }
      return kz1(t, a, n[1], n[2], l);
    }
  );
}
function Fz1(t, e) {
  const n = t.length, i = new Array(n);
  for (let s = 0; s < n; ++s)
    i[s] = Az1(t[s], e);
  return Tz1(i);
}
function Tz1(t) {
  return t.length === 1 ? t[0] : (
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */
    function(e, n, i) {
      if (!e)
        return;
      const s = DC(e), l = hr(s, t.length);
      return t[l](e, n, i);
    }
  );
}
class Vq extends bz1 {
  /**
   * @param {Options} options Image tile options.
   */
  constructor(e) {
    super({
      attributions: e.attributions,
      cacheSize: e.cacheSize,
      projection: e.projection,
      state: e.state,
      tileGrid: e.tileGrid,
      tilePixelRatio: e.tilePixelRatio,
      wrapX: e.wrapX,
      transition: e.transition,
      interpolate: e.interpolate,
      key: e.key,
      attributionsCollapsible: e.attributionsCollapsible,
      zDirection: e.zDirection
    }), this.generateTileUrlFunction_ = this.tileUrlFunction === Vq.prototype.tileUrlFunction, this.tileLoadFunction = e.tileLoadFunction, e.tileUrlFunction && (this.tileUrlFunction = e.tileUrlFunction), this.urls = null, e.urls ? this.setUrls(e.urls) : e.url && this.setUrl(e.url), this.tileLoadingKeys_ = {};
  }
  /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */
  getTileLoadFunction() {
    return this.tileLoadFunction;
  }
  /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */
  getTileUrlFunction() {
    return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
  }
  /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */
  getUrls() {
    return this.urls;
  }
  /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */
  handleTileChange(e) {
    const n = (
      /** @type {import("../Tile.js").default} */
      e.target
    ), i = Be(n), s = n.getState();
    let l;
    s == H2.LOADING ? (this.tileLoadingKeys_[i] = !0, l = Ug.TILELOADSTART) : i in this.tileLoadingKeys_ && (delete this.tileLoadingKeys_[i], l = s == H2.ERROR ? Ug.TILELOADERROR : s == H2.LOADED ? Ug.TILELOADEND : void 0), l != null && this.dispatchEvent(new Mz1(l, n));
  }
  /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */
  setTileLoadFunction(e) {
    this.tileCache.clear(), this.tileLoadFunction = e, this.changed();
  }
  /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */
  setTileUrlFunction(e, n) {
    this.tileUrlFunction = e, this.tileCache.pruneExceptNewestZ(), typeof n < "u" ? this.setKey(n) : this.changed();
  }
  /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */
  setUrl(e) {
    const n = Ez1(e);
    this.urls = n, this.setUrls(n);
  }
  /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */
  setUrls(e) {
    this.urls = e;
    const n = e.join(`
`);
    this.generateTileUrlFunction_ ? this.setTileUrlFunction(Fz1(e, this.tileGrid), n) : this.setKey(n);
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */
  tileUrlFunction(e, n, i) {
  }
  /**
   * Marks a tile coord as being used, without triggering a load.
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @override
   */
  useTile(e, n, i) {
    const s = ld(e, n, i);
    this.tileCache.containsKey(s) && this.tileCache.get(s);
  }
}
const Iz1 = Vq;
class Oz1 extends Iz1 {
  /**
   * @param {!Options} options Image tile options.
   */
  constructor(e) {
    super({
      attributions: e.attributions,
      cacheSize: e.cacheSize,
      projection: e.projection,
      state: e.state,
      tileGrid: e.tileGrid,
      tileLoadFunction: e.tileLoadFunction ? e.tileLoadFunction : Nz1,
      tilePixelRatio: e.tilePixelRatio,
      tileUrlFunction: e.tileUrlFunction,
      url: e.url,
      urls: e.urls,
      wrapX: e.wrapX,
      transition: e.transition,
      interpolate: e.interpolate !== void 0 ? e.interpolate : !0,
      key: e.key,
      attributionsCollapsible: e.attributionsCollapsible,
      zDirection: e.zDirection
    }), this.crossOrigin = e.crossOrigin !== void 0 ? e.crossOrigin : null, this.tileClass = e.tileClass !== void 0 ? e.tileClass : AC, this.tileCacheForProjection = {}, this.tileGridForProjection = {}, this.reprojectionErrorThreshold_ = e.reprojectionErrorThreshold, this.renderReprojectionEdges_ = !1;
  }
  /**
   * @return {boolean} Can expire cache.
   * @override
   */
  canExpireCache() {
    if (this.tileCache.canExpireCache())
      return !0;
    for (const e in this.tileCacheForProjection)
      if (this.tileCacheForProjection[e].canExpireCache())
        return !0;
    return !1;
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   * @override
   */
  expireCache(e, n) {
    const i = this.getTileCacheForProjection(e);
    this.tileCache.expireCache(
      this.tileCache == i ? n : {}
    );
    for (const s in this.tileCacheForProjection) {
      const l = this.tileCacheForProjection[s];
      l.expireCache(l == i ? n : {});
    }
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */
  getGutterForProjection(e) {
    return this.getProjection() && e && !pa(this.getProjection(), e) ? 0 : this.getGutter();
  }
  /**
   * @return {number} Gutter.
   */
  getGutter() {
    return 0;
  }
  /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */
  getKey() {
    let e = super.getKey();
    return this.getInterpolate() || (e += ":disable-interpolation"), e;
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */
  getTileGridForProjection(e) {
    const n = this.getProjection();
    if (this.tileGrid && (!n || pa(n, e)))
      return this.tileGrid;
    const i = Be(e);
    return i in this.tileGridForProjection || (this.tileGridForProjection[i] = QC(e)), this.tileGridForProjection[i];
  }
  /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @override
   */
  getTileCacheForProjection(e) {
    const n = this.getProjection();
    if (!n || pa(n, e))
      return this.tileCache;
    const i = Be(e);
    return i in this.tileCacheForProjection || (this.tileCacheForProjection[i] = new $C(
      this.tileCache.highWaterMark
    )), this.tileCacheForProjection[i];
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */
  createTile_(e, n, i, s, l, a) {
    const o = [e, n, i], h = this.getTileCoordForTileUrlFunction(
      o,
      l
    ), u = h ? this.tileUrlFunction(h, s, l) : void 0, d = new this.tileClass(
      o,
      u !== void 0 ? H2.IDLE : H2.EMPTY,
      u !== void 0 ? u : "",
      this.crossOrigin,
      this.tileLoadFunction,
      this.tileOptions
    );
    return d.key = a, d.addEventListener(T3.CHANGE, this.handleTileChange.bind(this)), d;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */
  getTile(e, n, i, s, l) {
    const a = this.getProjection();
    if (!a || !l || pa(a, l))
      return this.getTileInternal(
        e,
        n,
        i,
        s,
        a || l
      );
    const o = this.getTileCacheForProjection(l), h = [e, n, i];
    let u;
    const d = HC(h);
    o.containsKey(d) && (u = o.get(d));
    const v = this.getKey();
    if (u && u.key == v)
      return u;
    const m = this.getTileGridForProjection(a), p = this.getTileGridForProjection(l), _ = this.getTileCoordForTileUrlFunction(
      h,
      l
    ), q = new KC(
      a,
      m,
      l,
      p,
      h,
      _,
      this.getTilePixelRatio(s),
      this.getGutter(),
      (M, z, b, x) => this.getTileInternal(M, z, b, x, a),
      this.reprojectionErrorThreshold_,
      this.renderReprojectionEdges_,
      this.tileOptions
    );
    return q.key = v, u ? o.replace(d, q) : o.set(d, q), q;
  }
  /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */
  getTileInternal(e, n, i, s, l) {
    const a = ld(e, n, i), o = this.getKey();
    if (!this.tileCache.containsKey(a)) {
      const u = this.createTile_(e, n, i, s, l, o);
      return this.tileCache.set(a, u), u;
    }
    let h = this.tileCache.get(a);
    return h.key != o && (h = this.createTile_(e, n, i, s, l, o), this.tileCache.replace(a, h)), h;
  }
  /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */
  setRenderReprojectionEdges(e) {
    if (this.renderReprojectionEdges_ != e) {
      this.renderReprojectionEdges_ = e;
      for (const n in this.tileCacheForProjection)
        this.tileCacheForProjection[n].clear();
      this.changed();
    }
  }
  /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */
  setTileGridForProjection(e, n) {
    const i = ct(e);
    if (i) {
      const s = Be(i);
      s in this.tileGridForProjection || (this.tileGridForProjection[s] = n);
    }
  }
  /**
   * @override
   */
  clear() {
    super.clear();
    for (const e in this.tileCacheForProjection)
      this.tileCacheForProjection[e].clear();
  }
}
function Nz1(t, e) {
  t.getImage().src = e;
}
const nk = Oz1;
class Pz1 extends nk {
  /**
   * @param {Options} [options] XYZ options.
   */
  constructor(e) {
    e = e || {};
    const n = e.projection !== void 0 ? e.projection : "EPSG:3857", i = e.tileGrid !== void 0 ? e.tileGrid : qz1({
      extent: Bq(n),
      maxResolution: e.maxResolution,
      maxZoom: e.maxZoom,
      minZoom: e.minZoom,
      tileSize: e.tileSize
    });
    super({
      attributions: e.attributions,
      cacheSize: e.cacheSize,
      crossOrigin: e.crossOrigin,
      interpolate: e.interpolate,
      projection: n,
      reprojectionErrorThreshold: e.reprojectionErrorThreshold,
      tileGrid: i,
      tileLoadFunction: e.tileLoadFunction,
      tilePixelRatio: e.tilePixelRatio,
      tileUrlFunction: e.tileUrlFunction,
      url: e.url,
      urls: e.urls,
      wrapX: e.wrapX !== void 0 ? e.wrapX : !0,
      transition: e.transition,
      attributionsCollapsible: e.attributionsCollapsible,
      zDirection: e.zDirection
    }), this.gutter_ = e.gutter !== void 0 ? e.gutter : 0;
  }
  /**
   * @return {number} Gutter.
   * @override
   */
  getGutter() {
    return this.gutter_;
  }
}
const vM = Pz1, pM = 4, Vy = "1.3.0";
function Bz1(t, e, n, i, s) {
  s.WIDTH = n[0], s.HEIGHT = n[1];
  const l = i.getAxisOrientation(), a = MS(s.VERSION, "1.3") >= 0;
  s[a ? "CRS" : "SRS"] = i.getCode();
  const o = a && l.startsWith("ne") ? [e[1], e[0], e[3], e[2]] : e;
  return s.BBOX = o.join(","), tk(t, s);
}
function Vz1(t, e, n, i, s, l, a) {
  l = Object.assign({ REQUEST: "GetMap" }, l);
  const o = e / n, h = [
    yz(ue(t) / o, pM),
    yz(G4(t) / o, pM)
  ];
  if (n != 1)
    switch (a) {
      case "geoserver":
        const d = 90 * n + 0.5 | 0;
        "FORMAT_OPTIONS" in l ? l.FORMAT_OPTIONS += ";dpi:" + d : l.FORMAT_OPTIONS = "dpi:" + d;
        break;
      case "mapserver":
        l.MAP_RESOLUTION = 90 * n;
        break;
      case "carmentaserver":
      case "qgis":
        l.DPI = 90 * n;
        break;
      default:
        throw new Error("Unknown `serverType` configured");
    }
  return Bz1(s, t, h, i, l);
}
function mM(t, e) {
  return Object.assign(
    {
      REQUEST: e,
      SERVICE: "WMS",
      VERSION: Vy,
      FORMAT: "image/png",
      STYLES: "",
      TRANSPARENT: !0
    },
    t
  );
}
class Rz1 extends nk {
  /**
   * @param {Options} [options] Tile WMS options.
   */
  constructor(e) {
    e = e || /** @type {Options} */
    {};
    const n = Object.assign({}, e.params);
    super({
      attributions: e.attributions,
      attributionsCollapsible: e.attributionsCollapsible,
      cacheSize: e.cacheSize,
      crossOrigin: e.crossOrigin,
      interpolate: e.interpolate,
      projection: e.projection,
      reprojectionErrorThreshold: e.reprojectionErrorThreshold,
      tileClass: e.tileClass,
      tileGrid: e.tileGrid,
      tileLoadFunction: e.tileLoadFunction,
      url: e.url,
      urls: e.urls,
      wrapX: e.wrapX !== void 0 ? e.wrapX : !0,
      transition: e.transition,
      zDirection: e.zDirection
    }), this.gutter_ = e.gutter !== void 0 ? e.gutter : 0, this.params_ = n, this.v13_ = !0, this.serverType_ = e.serverType, this.hidpi_ = e.hidpi !== void 0 ? e.hidpi : !0, this.tmpExtent_ = U0(), this.updateV13_(), this.setKey(this.getKeyForParams_());
  }
  /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */
  getFeatureInfoUrl(e, n, i, s) {
    const l = ct(i), a = this.getProjection() || l;
    let o = this.getTileGrid();
    o || (o = this.getTileGridForProjection(a));
    const h = K_(
      e,
      l,
      a
    ), u = By(
      a,
      l,
      e,
      n
    ), d = o.getZForResolution(u, this.zDirection), v = o.getResolution(d), m = o.getTileCoordForCoordAndZ(h, d);
    if (o.getResolutions().length <= m[0])
      return;
    let p = o.getTileCoordExtent(m, this.tmpExtent_);
    const _ = this.gutter_;
    _ !== 0 && (p = Do(p, v * _, p));
    const q = {
      QUERY_LAYERS: this.params_.LAYERS
    };
    Object.assign(
      q,
      mM(this.params_, "GetFeatureInfo"),
      s
    );
    const M = Math.floor((h[0] - p[0]) / v), z = Math.floor((p[3] - h[1]) / v);
    return q[this.v13_ ? "I" : "X"] = M, q[this.v13_ ? "J" : "Y"] = z, this.getRequestUrl_(
      m,
      p,
      1,
      a || l,
      q
    );
  }
  /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */
  getLegendUrl(e, n) {
    if (this.urls[0] === void 0)
      return;
    const i = {
      SERVICE: "WMS",
      VERSION: Vy,
      REQUEST: "GetLegendGraphic",
      FORMAT: "image/png"
    };
    if (n === void 0 || n.LAYER === void 0) {
      const s = this.params_.LAYERS;
      if (!(!Array.isArray(s) || s.length === 1))
        return;
      i.LAYER = s;
    }
    if (e !== void 0) {
      const s = this.getProjection() ? this.getProjection().getMetersPerUnit() : 1, l = 28e-5;
      i.SCALE = e * s / l;
    }
    return Object.assign(i, n), tk(
      /** @type {string} */
      this.urls[0],
      i
    );
  }
  /**
   * @return {number} Gutter.
   * @override
   */
  getGutter() {
    return this.gutter_;
  }
  /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */
  getParams() {
    return this.params_;
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} tileExtent Tile extent.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {Object} params Params.
   * @return {string|undefined} Request URL.
   * @private
   */
  getRequestUrl_(e, n, i, s, l) {
    const a = this.urls;
    if (!a)
      return;
    let o;
    if (a.length == 1)
      o = a[0];
    else {
      const h = hr(DC(e), a.length);
      o = a[h];
    }
    return Vz1(
      n,
      (this.tileGrid || this.getTileGridForProjection(s)).getResolution(e[0]),
      i,
      s,
      o,
      l,
      this.serverType_
    );
  }
  /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   * @override
   */
  getTilePixelRatio(e) {
    return !this.hidpi_ || this.serverType_ === void 0 ? 1 : e;
  }
  /**
   * @private
   * @return {string} The key for the current params.
   */
  getKeyForParams_() {
    let e = 0;
    const n = [];
    for (const i in this.params_)
      n[e++] = i + "-" + this.params_[i];
    return n.join("/");
  }
  /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */
  updateParams(e) {
    Object.assign(this.params_, e), this.updateV13_(), this.setKey(this.getKeyForParams_());
  }
  /**
   * @private
   */
  updateV13_() {
    const e = this.params_.VERSION || Vy;
    this.v13_ = MS(e, "1.3") >= 0;
  }
  /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
   * @param {number} pixelRatio The pixel ratio
   * @param {import("../proj/Projection.js").default} projection The projection
   * @return {string|undefined} The tile URL
   * @override
   */
  tileUrlFunction(e, n, i) {
    let s = this.getTileGrid();
    if (s || (s = this.getTileGridForProjection(i)), s.getResolutions().length <= e[0])
      return;
    n != 1 && (!this.hidpi_ || this.serverType_ === void 0) && (n = 1);
    const l = s.getResolution(e[0]);
    let a = s.getTileCoordExtent(e, this.tmpExtent_);
    const o = this.gutter_;
    o !== 0 && (a = Do(a, l * o, a));
    const h = Object.assign(
      {},
      mM(this.params_, "GetMap")
    );
    return this.getRequestUrl_(
      e,
      a,
      n,
      i,
      h
    );
  }
}
const Hz1 = Rz1;
class Dz1 {
  constructor() {
    this.dataProjection = void 0, this.defaultFeatureProjection = void 0, this.featureClass = /** @type {FeatureToFeatureClass<FeatureType>} */
    Yu, this.supportedMediaTypes = null;
  }
  /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */
  getReadOptions(e, n) {
    if (n) {
      let i = n.dataProjection ? ct(n.dataProjection) : this.readProjection(e);
      n.extent && i && i.getUnits() === "tile-pixels" && (i = ct(i), i.setWorldExtent(n.extent)), n = {
        dataProjection: i,
        featureProjection: n.featureProjection
      };
    }
    return this.adaptOptions(n);
  }
  /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */
  adaptOptions(e) {
    return Object.assign(
      {
        dataProjection: this.dataProjection,
        featureProjection: this.defaultFeatureProjection,
        featureClass: this.featureClass
      },
      e
    );
  }
  /**
   * @abstract
   * @return {Type} The format type.
   */
  getType() {
    return b3();
  }
  /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   */
  readFeature(e, n) {
    return b3();
  }
  /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   */
  readFeatures(e, n) {
    return b3();
  }
  /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */
  readGeometry(e, n) {
    return b3();
  }
  /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */
  readProjection(e) {
    return b3();
  }
  /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */
  writeFeature(e, n) {
    return b3();
  }
  /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */
  writeFeatures(e, n) {
    return b3();
  }
  /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */
  writeGeometry(e, n) {
    return b3();
  }
}
function Rq(t, e, n) {
  const i = n ? ct(n.featureProjection) : null, s = n ? ct(n.dataProjection) : null;
  let l = t;
  if (i && s && !pa(i, s)) {
    e && (l = /** @type {T} */
    t.clone());
    const a = e ? i : s, o = e ? s : i;
    a.getUnits() === "tile-pixels" ? l.transform(a, o) : l.applyTransform($a(a, o));
  }
  if (e && n && /** @type {WriteOptions} */
  n.decimals !== void 0) {
    const a = Math.pow(
      10,
      /** @type {WriteOptions} */
      n.decimals
    ), o = function(h) {
      for (let u = 0, d = h.length; u < d; ++u)
        h[u] = Math.round(h[u] * a) / a;
      return h;
    };
    l === t && (l = /** @type {T} */
    t.clone()), l.applyTransform(o);
  }
  return l;
}
const $z1 = {
  Point: Yo,
  LineString: Cy,
  Polygon: Os,
  MultiPoint: SC,
  MultiLineString: Oq1,
  MultiPolygon: Nq1
};
function Uz1(t, e, n) {
  return Array.isArray(e[0]) ? (GS(t, 0, e, n) || (t = t.slice(), xy(t, 0, e, n)), t) : (cq(t, 0, e, n) || (t = t.slice(), Gh(t, 0, e, n)), t);
}
function ik(t, e) {
  var l;
  const n = t.geometry;
  if (!n)
    return [];
  if (Array.isArray(n))
    return n.map((a) => ik({ ...t, geometry: a })).flat();
  const i = n.type === "MultiPolygon" ? "Polygon" : n.type;
  if (i === "GeometryCollection" || i === "Circle")
    throw new Error("Unsupported geometry type: " + i);
  const s = n.layout.length;
  return Rq(
    new ms(
      i,
      i === "Polygon" ? Uz1(n.flatCoordinates, n.ends, s) : n.flatCoordinates,
      (l = n.ends) == null ? void 0 : l.flat(),
      s,
      t.properties || {},
      t.id
    ).enableSimplifyTransformed(),
    !1,
    e
  );
}
function Hq(t, e) {
  if (!t)
    return null;
  if (Array.isArray(t)) {
    const i = t.map(
      (s) => Hq(s, e)
    );
    return new Iq1(i);
  }
  const n = $z1[t.type];
  return Rq(
    new n(t.flatCoordinates, t.layout, t.ends),
    !1,
    e
  );
}
class jz1 extends Dz1 {
  constructor() {
    super();
  }
  /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */
  getType() {
    return "json";
  }
  /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @api
   * @override
   */
  readFeature(e, n) {
    return this.readFeatureFromObject(
      sh(e),
      this.getReadOptions(e, n)
    );
  }
  /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */
  readFeatures(e, n) {
    return this.readFeaturesFromObject(
      sh(e),
      this.getReadOptions(e, n)
    );
  }
  /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   */
  readFeatureFromObject(e, n) {
    return b3();
  }
  /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   */
  readFeaturesFromObject(e, n) {
    return b3();
  }
  /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */
  readGeometry(e, n) {
    return this.readGeometryFromObject(
      sh(e),
      this.getReadOptions(e, n)
    );
  }
  /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */
  readGeometryFromObject(e, n) {
    return b3();
  }
  /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */
  readProjection(e) {
    return this.readProjectionFromObject(sh(e));
  }
  /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */
  readProjectionFromObject(e) {
    return b3();
  }
  /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */
  writeFeature(e, n) {
    return JSON.stringify(this.writeFeatureObject(e, n));
  }
  /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */
  writeFeatureObject(e, n) {
    return b3();
  }
  /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */
  writeFeatures(e, n) {
    return JSON.stringify(this.writeFeaturesObject(e, n));
  }
  /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */
  writeFeaturesObject(e, n) {
    return b3();
  }
  /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   * @override
   */
  writeGeometry(e, n) {
    return JSON.stringify(this.writeGeometryObject(e, n));
  }
  /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */
  writeGeometryObject(e, n) {
    return b3();
  }
}
function sh(t) {
  if (typeof t == "string") {
    const e = JSON.parse(t);
    return e || null;
  }
  return t !== null ? t : null;
}
const Gz1 = jz1;
class Wz1 extends Gz1 {
  /**
   * @param {Options<FeatureType>} [options] Options.
   */
  constructor(e) {
    e = e || {}, super(), this.dataProjection = ct(
      e.dataProjection ? e.dataProjection : "EPSG:4326"
    ), e.featureProjection && (this.defaultFeatureProjection = ct(e.featureProjection)), e.featureClass && (this.featureClass = e.featureClass), this.geometryName_ = e.geometryName, this.extractGeometryName_ = e.extractGeometryName, this.supportedMediaTypes = [
      "application/geo+json",
      "application/vnd.geo+json"
    ];
  }
  /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @override
   */
  readFeatureFromObject(e, n) {
    let i = null;
    e.type === "Feature" ? i = /** @type {GeoJSONFeature} */
    e : i = {
      type: "Feature",
      geometry: (
        /** @type {GeoJSONGeometry} */
        e
      ),
      properties: null
    };
    const s = Dq(i.geometry);
    if (this.featureClass === ms)
      return (
        /** @type {FeatureType|Array<FeatureType>} */
        ik(
          {
            geometry: s,
            id: i.id,
            properties: i.properties
          },
          n
        )
      );
    const l = new Yu();
    return this.geometryName_ ? l.setGeometryName(this.geometryName_) : this.extractGeometryName_ && i.geometry_name && l.setGeometryName(i.geometry_name), l.setGeometry(Hq(s, n)), "id" in i && l.setId(i.id), i.properties && l.setProperties(i.properties, !0), /** @type {FeatureType|Array<FeatureType>} */
    l;
  }
  /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   * @override
   */
  readFeaturesFromObject(e, n) {
    const i = (
      /** @type {GeoJSONObject} */
      e
    );
    let s = null;
    if (i.type === "FeatureCollection") {
      const l = (
        /** @type {GeoJSONFeatureCollection} */
        e
      );
      s = [];
      const a = l.features;
      for (let o = 0, h = a.length; o < h; ++o) {
        const u = this.readFeatureFromObject(
          a[o],
          n
        );
        u && s.push(u);
      }
    } else
      s = [this.readFeatureFromObject(e, n)];
    return (
      /** @type {Array<FeatureType>} */
      s.flat()
    );
  }
  /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */
  readGeometryFromObject(e, n) {
    return Yz1(e, n);
  }
  /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   * @override
   */
  readProjectionFromObject(e) {
    const n = e.crs;
    let i;
    if (n)
      if (n.type == "name")
        i = ct(n.properties.name);
      else if (n.type === "EPSG")
        i = ct("EPSG:" + n.properties.code);
      else
        throw new Error("Unknown SRS type");
    else
      i = this.dataProjection;
    return (
      /** @type {import("../proj/Projection.js").default} */
      i
    );
  }
  /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   * @override
   */
  writeFeatureObject(e, n) {
    n = this.adaptOptions(n);
    const i = {
      type: "Feature",
      geometry: null,
      properties: null
    }, s = e.getId();
    if (s !== void 0 && (i.id = s), !e.hasProperties())
      return i;
    const l = e.getProperties(), a = e.getGeometry();
    return a && (i.geometry = Ry(a, n), delete l[e.getGeometryName()]), mr(l) || (i.properties = l), i;
  }
  /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   * @override
   */
  writeFeaturesObject(e, n) {
    n = this.adaptOptions(n);
    const i = [];
    for (let s = 0, l = e.length; s < l; ++s)
      i.push(this.writeFeatureObject(e[s], n));
    return {
      type: "FeatureCollection",
      features: i
    };
  }
  /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   * @override
   */
  writeGeometryObject(e, n) {
    return Ry(e, this.adaptOptions(n));
  }
}
function Dq(t, e) {
  if (!t)
    return null;
  let n;
  switch (t.type) {
    case "Point": {
      n = Kz1(
        /** @type {GeoJSONPoint} */
        t
      );
      break;
    }
    case "LineString": {
      n = Zz1(
        /** @type {GeoJSONLineString} */
        t
      );
      break;
    }
    case "Polygon": {
      n = tM1(
        /** @type {GeoJSONPolygon} */
        t
      );
      break;
    }
    case "MultiPoint": {
      n = Qz1(
        /** @type {GeoJSONMultiPoint} */
        t
      );
      break;
    }
    case "MultiLineString": {
      n = Jz1(
        /** @type {GeoJSONMultiLineString} */
        t
      );
      break;
    }
    case "MultiPolygon": {
      n = eM1(
        /** @type {GeoJSONMultiPolygon} */
        t
      );
      break;
    }
    case "GeometryCollection": {
      n = Xz1(
        /** @type {GeoJSONGeometryCollection} */
        t
      );
      break;
    }
    default:
      throw new Error("Unsupported GeoJSON type: " + t.type);
  }
  return n;
}
function Yz1(t, e) {
  const n = Dq(t);
  return Hq(n, e);
}
function Xz1(t, e) {
  return t.geometries.map(
    /**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */
    function(i) {
      return Dq(i);
    }
  );
}
function Kz1(t) {
  const e = t.coordinates;
  return {
    type: "Point",
    flatCoordinates: e,
    layout: xr(e.length)
  };
}
function Zz1(t) {
  var i;
  const e = t.coordinates, n = e.flat();
  return {
    type: "LineString",
    flatCoordinates: n,
    ends: [n.length],
    layout: xr(((i = e[0]) == null ? void 0 : i.length) || 2)
  };
}
function Jz1(t) {
  var l, a;
  const e = t.coordinates, n = ((a = (l = e[0]) == null ? void 0 : l[0]) == null ? void 0 : a.length) || 2, i = [], s = Mc(i, 0, e, n);
  return {
    type: "MultiLineString",
    flatCoordinates: i,
    ends: s,
    layout: xr(n)
  };
}
function Qz1(t) {
  var n;
  const e = t.coordinates;
  return {
    type: "MultiPoint",
    flatCoordinates: e.flat(),
    layout: xr(((n = e[0]) == null ? void 0 : n.length) || 2)
  };
}
function eM1(t) {
  var l, a;
  const e = t.coordinates, n = [], i = ((a = (l = e[0]) == null ? void 0 : l[0]) == null ? void 0 : a[0].length) || 2, s = PS(
    n,
    0,
    e,
    i
  );
  return {
    type: "MultiPolygon",
    flatCoordinates: n,
    ends: s,
    layout: xr(i)
  };
}
function tM1(t) {
  var l, a;
  const e = t.coordinates, n = [], i = (a = (l = e[0]) == null ? void 0 : l[0]) == null ? void 0 : a.length, s = Mc(n, 0, e, i);
  return {
    type: "Polygon",
    flatCoordinates: n,
    ends: s,
    layout: xr(i)
  };
}
function Ry(t, e) {
  t = Rq(t, !0, e);
  const n = t.getType();
  let i;
  switch (n) {
    case "Point": {
      i = aM1(
        /** @type {import("../geom/Point.js").default} */
        t
      );
      break;
    }
    case "LineString": {
      i = iM1(
        /** @type {import("../geom/LineString.js").default} */
        t
      );
      break;
    }
    case "Polygon": {
      i = oM1(
        /** @type {import("../geom/Polygon.js").default} */
        t,
        e
      );
      break;
    }
    case "MultiPoint": {
      i = lM1(
        /** @type {import("../geom/MultiPoint.js").default} */
        t
      );
      break;
    }
    case "MultiLineString": {
      i = sM1(
        /** @type {import("../geom/MultiLineString.js").default} */
        t
      );
      break;
    }
    case "MultiPolygon": {
      i = rM1(
        /** @type {import("../geom/MultiPolygon.js").default} */
        t,
        e
      );
      break;
    }
    case "GeometryCollection": {
      i = nM1(
        /** @type {import("../geom/GeometryCollection.js").default} */
        t,
        e
      );
      break;
    }
    case "Circle": {
      i = {
        type: "GeometryCollection",
        geometries: []
      };
      break;
    }
    default:
      throw new Error("Unsupported geometry type: " + n);
  }
  return i;
}
function nM1(t, e) {
  return e = Object.assign({}, e), delete e.featureProjection, {
    type: "GeometryCollection",
    geometries: t.getGeometriesArray().map(function(i) {
      return Ry(i, e);
    })
  };
}
function iM1(t, e) {
  return {
    type: "LineString",
    coordinates: t.getCoordinates()
  };
}
function sM1(t, e) {
  return {
    type: "MultiLineString",
    coordinates: t.getCoordinates()
  };
}
function lM1(t, e) {
  return {
    type: "MultiPoint",
    coordinates: t.getCoordinates()
  };
}
function rM1(t, e) {
  let n;
  return e && (n = e.rightHanded), {
    type: "MultiPolygon",
    coordinates: t.getCoordinates(n)
  };
}
function aM1(t, e) {
  return {
    type: "Point",
    coordinates: t.getCoordinates()
  };
}
function oM1(t, e) {
  let n;
  return e && (n = e.rightHanded), {
    type: "Polygon",
    coordinates: t.getCoordinates(n)
  };
}
const sk = Wz1;
function cM1(t, e) {
  var z, b;
  const n = t.settings, i = t.mapInstance, s = t.tooltipData, l = D1([]), a = () => {
    s1.each(H(l), (x) => {
      var k;
      return (k = H(i)) == null ? void 0 : k.removeLayer(x);
    }), l.value = [];
  }, o = (x) => {
    const k = {};
    return s1.each(x, (F, D) => {
      k[D.toUpperCase()] = s1.isArray(F) ? F.join(",") : F;
    }), k;
  }, h = (x) => {
    var D, R;
    const k = s1.assign({}, (R = (D = H(n)) == null ? void 0 : D.WMS) == null ? void 0 : R.defaultOptions, x);
    return o(k);
  }, u = (x) => {
    var k;
    (k = H(i)) == null || k.addLayer(x);
  }, d = (x) => {
    var k;
    (k = H(i)) == null || k.removeLayer(x);
  }, v = (x) => {
    var R, V, J;
    const k = H(n), F = new Hz1({
      url: `${(V = (R = k == null ? void 0 : k.WMS) == null ? void 0 : R.api) == null ? void 0 : V.basePath}${(J = k == null ? void 0 : k.WMS) == null ? void 0 : J.api.wms}`,
      params: h(x.options),
      serverType: "geoserver"
      // crossOrigin: 'anonymous'
    });
    return new ZC({
      source: F
    });
  }, m = (x, k) => {
    const F = H(l)[x].getSource(), D = h(s1.assign({}, k.options));
    F.set("name", k.name || ""), F.set("extraParamsAPI", k.extraParamsAPI || {}), F.updateParams(D);
  }, p = () => {
    var F;
    const x = H(n), k = (F = x == null ? void 0 : x.WMS) != null && F.layers ? x.WMS.layers : [];
    if (k.length > 0) {
      const D = H(l).length - k.length;
      if (D > 0) {
        const R = H(l).slice(D * -1);
        s1.each(R, (V) => {
          d(V), H(l).pop();
        });
      }
      s1.each(k, (R, V) => {
        if (V > H(l).length - 1) {
          const J = v(R);
          J.set("name", R.name || ""), J.set("extraParamsAPI", R.extraParamsAPI || {}), H(l).push(J), u(J);
        } else
          m(V, R);
      });
    } else
      a();
    e.emit("wmsUpdatedLayers", H(l));
  }, _ = () => {
    const x = H(n), k = x == null ? void 0 : x.WMS, F = k == null ? void 0 : k.layers, D = s1.head(F);
    if (k != null && k.useLayer) {
      if (s1.isString(k == null ? void 0 : k.useLayer))
        return k.useLayer === "first" ? D : k.useLayer === "last" ? s1.last(F) : s1.find(F, (V) => V.name === k.useLayer) || D;
      if (k.useLayer <= F.length - 1)
        return F[k.useLayer];
    }
    return D;
  }, q = (x) => new sk().readFeatures(x), M = (x) => new Promise((k, F) => {
    if (!s1.isNil(x) && x !== "")
      fetch(x).then(
        (D) => D.json(),
        (D) => {
          const R = `Error to fetch url: ${x}. Error: ${D}`;
          F(R);
        }
      ).then((D) => k(D));
    else {
      const D = `Error on url: ${x}`;
      F(D);
    }
  });
  return (z = H(i)) == null || z.on("singleclick", (x) => {
    var D, R, V;
    const k = (D = H(i)) == null ? void 0 : D.getView().getResolution(), F = _();
    if (!s1.isNil(F)) {
      const J = s1.merge({}, F, { options: F.extraParamsAPI || {} }), K = v(J), P = s1.assign({
        REQUEST: "GetFeatureInfo"
      }), O = K.getSource().getFeatureInfoUrl(
        x.coordinate,
        k,
        (V = (R = H(n)) == null ? void 0 : R.WFS) == null ? void 0 : V.crs,
        P
      );
      O && M(O).then((G) => {
        e.emit("clickedTerritory", { response: G, event: x });
      });
    }
  }), (b = H(i)) == null || b.on("pointermove", (x) => {
    var D;
    const k = H(n);
    if (x.dragging || ((D = k == null ? void 0 : k.WMS) == null ? void 0 : D.identifyOnOver) === !1)
      return;
    const F = x.originalEvent;
    s.position = [F.x, F.y], s1.isNil(s.throttle) || window.clearTimeout(s.throttle), s.throttle = null, s.throttle = window.setTimeout(() => {
      var J, K;
      s.throttle = null;
      const R = (J = H(i)) == null ? void 0 : J.getView().getResolution(), V = _();
      if (!s1.isNil(V)) {
        const P = s1.merge({}, V, { options: V.extraParamsAPI || {} }), O = v(P), G = s1.assign({
          REQUEST: "GetFeatureInfo"
        }), j = O.getSource().getFeatureInfoUrl(
          x.coordinate,
          R,
          (K = k == null ? void 0 : k.WFS) == null ? void 0 : K.crs,
          G
        );
        j && M(j).then((Q) => {
          var i1;
          if (e.emit("hoverTerritory", { response: Q, event: x }), !s1.isNil(Q.features) && Q.features.length > 0) {
            const h1 = (i1 = k == null ? void 0 : k.WMS) == null ? void 0 : i1.tooltip;
            s.text = h1 && (h1 != null && h1.formatting) ? h1.formatting(Q) : null, s.dataObject = Q;
          } else
            s.text = null, s.dataObject = null;
        });
      }
    }, 100);
  }), l3(
    // @ts-ignore
    () => n.value.WMS.layers,
    (x) => {
      e.emit("wmsUpdatingLayers", x), p();
    },
    { deep: !0 }
  ), p(), {
    readGeoServerResponse: q,
    destroy: a,
    layers: l
  };
}
const lk = (t) => t.ok ? t : t.text().then((e) => {
  try {
    e = JSON.parse(e);
  } catch {
    console.error("JSON Parse failed for error");
  }
  throw {
    message: e,
    status: t.status
  };
}), rk = "", ak = "AUTH_TOKEN";
function hM1(t, e) {
  const n = localStorage.getItem(ak), i = {
    method: "GET",
    ...e
  };
  return n && (i.headers = {
    Authorization: `Bearer ${n}`,
    ...i.headers
  }), fetch(rk + t, i).then(lk).then((s) => s.json()).then((s) => s);
}
function uM1(t, e, n) {
  const i = localStorage.getItem(ak), s = {
    method: "POST",
    body: JSON.stringify(e),
    ...n
  };
  return s.headers = {
    "Content-Type": "application/json",
    ...s.headers
  }, i && (s.headers = {
    Authorization: `Bearer ${i}`,
    ...s.headers
  }), fetch(rk + t, s).then(lk).then((l) => l.json()).then((l) => l);
}
const dM1 = {
  get: hM1,
  post: uM1
};
function fM1(t) {
  const e = t.settings, n = (l) => new sk().readFeatures(l);
  return {
    request: (l) => {
      var d, v, m, p;
      const a = s1.assign(
        {
          service: "wfs",
          version: "2.0.0",
          request: "GetFeature",
          outputFormat: "application/json",
          srsName: (v = (d = H(e)) == null ? void 0 : d.WFS) == null ? void 0 : v.srs
        },
        l
      ), o = new URLSearchParams(a), h = (p = (m = H(e)) == null ? void 0 : m.WMS) == null ? void 0 : p.api, u = new URL(`${h == null ? void 0 : h.basePath}${h == null ? void 0 : h.wfs}?${o.toString()}`);
      return dM1.get(u.toString());
    },
    readGeoJson: n,
    getGeometry: (l) => {
      let a = l;
      return (!s1.isArray(l) || s1.isArray(l) && !(l[0] instanceof Yu)) && (a = n(l)), a[0].getGeometry();
    }
  };
}
function vM1(t) {
  const e = t.mapComponent, n = t.settings, i = [], s = [], l = t9(), a = g1(() => {
    const h = n.value.attributions;
    return s1.map(h, (u) => {
      var v;
      let d = u.content;
      if ((v = u.disclaimer) != null && v.create) {
        d += ` ${u.disclaimer.separator} `;
        const m = u.disclaimer.title.replace(/"/g, "&quot;") || "", p = u.disclaimer.content.replace(/"/g, "&quot;") || "";
        d += `<a class="perform-disclaimer" href="javascript:void(0)" data-disclaimer-title="${m}" data-disclaimer-content="${p}">${u.disclaimer.label}</a>`;
      }
      return d;
    });
  }), o = (h) => {
    const u = h.target;
    if (!s1.isNil(u)) {
      const d = document.createElement("div");
      d.className = `modal-wrapper modal-wrapper--${i.length}`, document.body.appendChild(d);
      const v = u.getAttribute("data-disclaimer-title"), m = u.getAttribute("data-disclaimer-content"), p = {
        component: Au,
        props: {
          // props
          modelValue: !0,
          title: v,
          body: m
        },
        el: d,
        appContext: l == null ? void 0 : l.appContext
      }, _ = new Kx();
      _.add(p, { id: "report-print-modal" }), i.push(_);
    }
  };
  return d0(() => {
    D0(() => {
      const h = H(e);
      s1.isNil(h) || h.addEventListener("click", (u) => {
        const d = u.target.classList;
        d && d.contains("perform-disclaimer") && o(u);
      });
    });
  }), mn(() => {
    s1.each(s, (h) => h()), s1.each(i, (h) => {
      h.destroy();
    });
  }), {
    attributionsContent: a
  };
}
function ok(t, e, n) {
  const { zoom: i, center: s } = s3(t), l = e.data.settings, a = e.data.mapElement, o = e.data.mapInstance, h = e.data.mapComponent, u = e.tooltip.tooltipData, d = e.helper, { t: v } = js(), m = fM1({ settings: l }), p = D1(), _ = {
    defaultSourceUrl: "",
    view: {}
  }, q = vM1({
    mapComponent: h,
    settings: l
  }), M = () => {
    var j, Q, i1, h1, c1, M1;
    const k = H(l).olSettings, F = H(l).customInteraction, D = ((j = H(o)) == null ? void 0 : j.getInteractions()) ?? new z6(), R = (k == null ? void 0 : k.interactions) ?? {}, V = ((Q = k == null ? void 0 : k.extra) == null ? void 0 : Q.interactions) ?? [];
    F && (C8() && ((i1 = F == null ? void 0 : F.mobile) != null && i1.useDoubleTouch) && (s1.assign(R, { dragPan: !1 }), V.push(
      new NC({
        condition: function() {
          var A1;
          const y1 = this.getPointerCount() === 2;
          return y1 ? d.helperHide() : d.helperShow(v(((A1 = F == null ? void 0 : F.mobile) == null ? void 0 : A1.useDoubleTouchLabel) ?? "")), y1;
        }
      })
    )), (h1 = F == null ? void 0 : F.desktop) != null && h1.useWheelPlatformKey && (s1.assign(R, { mouseWheelZoom: !1 }), V.push(
      new PC({
        condition: (y1) => {
          var A1;
          if (["wheel", "trackpad"].includes(y1.type)) {
            const $ = zw1(y1);
            return $ ? d.helperHide() : d.helperShow(
              v(((A1 = F == null ? void 0 : F.desktop) == null ? void 0 : A1.useWheelPlatformKeyLabel) ?? "", [d.platformModifierLabel()])
            ), $;
          }
          return !1;
        }
      })
    )));
    const J = s1.isEmpty(R) ? Ny() : Ny(R);
    s1.isNil(J) || (D.clear(), J.forEach((y1) => {
      D.push(y1);
    }), V.forEach((y1) => {
      D.push(y1);
    }));
    const K = ((c1 = H(o)) == null ? void 0 : c1.getControls()) ?? new z6(), P = (k == null ? void 0 : k.controls) ?? {}, O = ((M1 = k == null ? void 0 : k.extra) == null ? void 0 : M1.controls) ?? [], G = s1.isEmpty(R) ? Iy() : Iy(P);
    return s1.isNil(G) || (K.clear(), G.forEach((y1) => {
      K.push(y1);
    }), O.forEach((y1) => {
      K.push(y1);
    })), {
      interactions: D,
      controls: K
    };
  }, z = (k = !1) => {
    const F = l.value.view;
    return k === !0 && (_ != null && _.view) && (_.view = F), new jn(F);
  }, b = () => {
    let k = [];
    return l.value.attributions && (k = H(q.attributionsContent)), k;
  }, x = () => {
    var F, D;
    const k = (D = (F = H(l)) == null ? void 0 : F.tile) == null ? void 0 : D.url;
    if (k) {
      _.defaultSourceUrl = k;
      const R = new ZC({
        source: new vM({
          url: k,
          attributions: b()
        })
      });
      o.value = new Gw1({
        target: a.value,
        layers: [R],
        view: z(!0),
        ...M()
      });
    }
  };
  return d0(() => {
    x(), o && (p.value = cM1({ settings: l, mapInstance: o, tooltipData: u }, n)), n.emit("mounted");
  }), l3(
    () => {
      var k, F;
      return (F = (k = l == null ? void 0 : l.value) == null ? void 0 : k.tile) == null ? void 0 : F.url;
    },
    (k) => {
      var F;
      if (!s1.isNil(k) && !s1.isEqual(_.defaultSourceUrl, k)) {
        const D = (F = H(o)) == null ? void 0 : F.getLayers().getArray()[0], R = new vM({
          url: k,
          attributions: b()
        });
        D && D.set("source", R), _.defaultSourceUrl = k;
      }
    }
  ), l3(
    () => l.value.view,
    (k) => {
      var F;
      if (!s1.isEqual(_.view, k)) {
        const D = z(!0);
        (F = H(o)) == null || F.setView(D);
      }
    },
    {
      deep: !0
    }
  ), l3([() => l.value.olSettings, () => {
    var k;
    return (k = l.value) == null ? void 0 : k.customInteraction;
  }], () => {
    M();
  }), l3(
    () => H(i),
    (k) => {
      var D, R, V;
      const F = l.value;
      if (F && !s1.isNil(k)) {
        (D = F == null ? void 0 : F.view) != null && D.zoom && (F.view.zoom = k);
        const J = ((V = (R = F == null ? void 0 : F.view) == null ? void 0 : R.animateTime) == null ? void 0 : V.zoom) ?? 0, K = H(o);
        K && (J <= 0 ? K.getView().setZoom(k) : K.getView().animate({
          zoom: k,
          duration: J
        }));
      }
    }
  ), l3(
    () => H(s),
    (k) => {
      var D, R, V;
      const F = l.value;
      if (F && !s1.isNil(k)) {
        (D = F == null ? void 0 : F.view) != null && D.center && (F.view.center = jo(k));
        const J = ((V = (R = F.view) == null ? void 0 : R.animateTime) == null ? void 0 : V.center) ?? 0, K = H(o);
        K && (J <= 0 ? K.getView().setCenter(F.view.center) : K.getView().animate({
          center: F.view.center,
          duration: J
        }));
      }
    }
  ), {
    WFS: m,
    WMS: p
  };
}
function ck(t) {
  const e = D1(!1), n = pc({
    throttle: null,
    position: [],
    text: null,
    dataObject: null
  }), i = t.mapComponent, s = g1(
    () => e.value && !s1.isNil(n.text) && n.text !== ""
  ), l = g1(() => n.text), a = g1(() => `left: ${n.position[0]}px; top: ${n.position[1]}px;`), o = () => {
    e.value = !0;
  }, h = () => {
    e.value = !1;
  };
  return d0(() => {
    const u = H(i);
    s1.isNil(u) || (u.addEventListener("mouseleave", h.bind(this)), u.addEventListener("mouseenter", o.bind(this)));
  }), mn(() => {
    const u = H(i);
    s1.isNil(u) || (u.removeEventListener("mouseleave", h.bind(this)), u.removeEventListener("mouseenter", o.bind(this)));
  }), {
    tooltipData: n,
    tooltipShow: s,
    tooltipText: l,
    tooltipStyle: a
  };
}
function pM1(t) {
  t("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"), t("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"), t("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs"), t.WGS84 = t["EPSG:4326"], t["EPSG:3785"] = t["EPSG:3857"], t.GOOGLE = t["EPSG:3857"], t["EPSG:900913"] = t["EPSG:3857"], t["EPSG:102113"] = t["EPSG:3857"];
}
var yr = 1, _r = 2, xa = 3, mM1 = 4, Hy = 5, gM = 6378137, gM1 = 6356752314e-3, yM = 0.0066943799901413165, Co = 484813681109536e-20, h2 = Math.PI / 2, yM1 = 0.16666666666666666, _M1 = 0.04722222222222222, qM1 = 0.022156084656084655, I2 = 1e-10, U4 = 0.017453292519943295, Kn = 57.29577951308232, Ne = Math.PI / 4, sc = Math.PI * 2, Jt = 3.14159265359, v0 = {};
v0.greenwich = 0;
v0.lisbon = -9.131906111111;
v0.paris = 2.337229166667;
v0.bogota = -74.080916666667;
v0.madrid = -3.687938888889;
v0.rome = 12.452333333333;
v0.bern = 7.439583333333;
v0.jakarta = 106.807719444444;
v0.ferro = -17.666666666667;
v0.brussels = 4.367975;
v0.stockholm = 18.058277777778;
v0.athens = 23.7163375;
v0.oslo = 10.722916666667;
const wM1 = {
  ft: { to_meter: 0.3048 },
  "us-ft": { to_meter: 1200 / 3937 }
};
var _M = /[\s_\-\/\(\)]/g;
function Ps(t, e) {
  if (t[e])
    return t[e];
  for (var n = Object.keys(t), i = e.toLowerCase().replace(_M, ""), s = -1, l, a; ++s < n.length; )
    if (l = n[s], a = l.toLowerCase().replace(_M, ""), a === i)
      return t[l];
}
function Dy(t) {
  var e = {}, n = t.split("+").map(function(o) {
    return o.trim();
  }).filter(function(o) {
    return o;
  }).reduce(function(o, h) {
    var u = h.split("=");
    return u.push(!0), o[u[0].toLowerCase()] = u[1], o;
  }, {}), i, s, l, a = {
    proj: "projName",
    datum: "datumCode",
    rf: function(o) {
      e.rf = parseFloat(o);
    },
    lat_0: function(o) {
      e.lat0 = o * U4;
    },
    lat_1: function(o) {
      e.lat1 = o * U4;
    },
    lat_2: function(o) {
      e.lat2 = o * U4;
    },
    lat_ts: function(o) {
      e.lat_ts = o * U4;
    },
    lon_0: function(o) {
      e.long0 = o * U4;
    },
    lon_1: function(o) {
      e.long1 = o * U4;
    },
    lon_2: function(o) {
      e.long2 = o * U4;
    },
    alpha: function(o) {
      e.alpha = parseFloat(o) * U4;
    },
    gamma: function(o) {
      e.rectified_grid_angle = parseFloat(o);
    },
    lonc: function(o) {
      e.longc = o * U4;
    },
    x_0: function(o) {
      e.x0 = parseFloat(o);
    },
    y_0: function(o) {
      e.y0 = parseFloat(o);
    },
    k_0: function(o) {
      e.k0 = parseFloat(o);
    },
    k: function(o) {
      e.k0 = parseFloat(o);
    },
    a: function(o) {
      e.a = parseFloat(o);
    },
    b: function(o) {
      e.b = parseFloat(o);
    },
    r_a: function() {
      e.R_A = !0;
    },
    zone: function(o) {
      e.zone = parseInt(o, 10);
    },
    south: function() {
      e.utmSouth = !0;
    },
    towgs84: function(o) {
      e.datum_params = o.split(",").map(function(h) {
        return parseFloat(h);
      });
    },
    to_meter: function(o) {
      e.to_meter = parseFloat(o);
    },
    units: function(o) {
      e.units = o;
      var h = Ps(wM1, o);
      h && (e.to_meter = h.to_meter);
    },
    from_greenwich: function(o) {
      e.from_greenwich = o * U4;
    },
    pm: function(o) {
      var h = Ps(v0, o);
      e.from_greenwich = (h || parseFloat(o)) * U4;
    },
    nadgrids: function(o) {
      o === "@null" ? e.datumCode = "none" : e.nadgrids = o;
    },
    axis: function(o) {
      var h = "ewnsud";
      o.length === 3 && h.indexOf(o.substr(0, 1)) !== -1 && h.indexOf(o.substr(1, 1)) !== -1 && h.indexOf(o.substr(2, 1)) !== -1 && (e.axis = o);
    },
    approx: function() {
      e.approx = !0;
    }
  };
  for (i in n)
    s = n[i], i in a ? (l = a[i], typeof l == "function" ? l(s) : e[l] = s) : e[i] = s;
  return typeof e.datumCode == "string" && e.datumCode !== "WGS84" && (e.datumCode = e.datumCode.toLowerCase()), e;
}
var lc = 1, hk = 2, uk = 3, au = 4, dk = 5, $q = -1, zM1 = /\s/, MM1 = /[A-Za-z]/, bM1 = /[A-Za-z84_]/, rd = /[,\]]/, fk = /[\d\.E\-\+]/;
function A8(t) {
  if (typeof t != "string")
    throw new Error("not a string");
  this.text = t.trim(), this.level = 0, this.place = 0, this.root = null, this.stack = [], this.currentObject = null, this.state = lc;
}
A8.prototype.readCharicter = function() {
  var t = this.text[this.place++];
  if (this.state !== au)
    for (; zM1.test(t); ) {
      if (this.place >= this.text.length)
        return;
      t = this.text[this.place++];
    }
  switch (this.state) {
    case lc:
      return this.neutral(t);
    case hk:
      return this.keyword(t);
    case au:
      return this.quoted(t);
    case dk:
      return this.afterquote(t);
    case uk:
      return this.number(t);
    case $q:
      return;
  }
};
A8.prototype.afterquote = function(t) {
  if (t === '"') {
    this.word += '"', this.state = au;
    return;
  }
  if (rd.test(t)) {
    this.word = this.word.trim(), this.afterItem(t);
    return;
  }
  throw new Error(`havn't handled "` + t + '" in afterquote yet, index ' + this.place);
};
A8.prototype.afterItem = function(t) {
  if (t === ",") {
    this.word !== null && this.currentObject.push(this.word), this.word = null, this.state = lc;
    return;
  }
  if (t === "]") {
    this.level--, this.word !== null && (this.currentObject.push(this.word), this.word = null), this.state = lc, this.currentObject = this.stack.pop(), this.currentObject || (this.state = $q);
    return;
  }
};
A8.prototype.number = function(t) {
  if (fk.test(t)) {
    this.word += t;
    return;
  }
  if (rd.test(t)) {
    this.word = parseFloat(this.word), this.afterItem(t);
    return;
  }
  throw new Error(`havn't handled "` + t + '" in number yet, index ' + this.place);
};
A8.prototype.quoted = function(t) {
  if (t === '"') {
    this.state = dk;
    return;
  }
  this.word += t;
};
A8.prototype.keyword = function(t) {
  if (bM1.test(t)) {
    this.word += t;
    return;
  }
  if (t === "[") {
    var e = [];
    e.push(this.word), this.level++, this.root === null ? this.root = e : this.currentObject.push(e), this.stack.push(this.currentObject), this.currentObject = e, this.state = lc;
    return;
  }
  if (rd.test(t)) {
    this.afterItem(t);
    return;
  }
  throw new Error(`havn't handled "` + t + '" in keyword yet, index ' + this.place);
};
A8.prototype.neutral = function(t) {
  if (MM1.test(t)) {
    this.word = t, this.state = hk;
    return;
  }
  if (t === '"') {
    this.word = "", this.state = au;
    return;
  }
  if (fk.test(t)) {
    this.word = t, this.state = uk;
    return;
  }
  if (rd.test(t)) {
    this.afterItem(t);
    return;
  }
  throw new Error(`havn't handled "` + t + '" in neutral yet, index ' + this.place);
};
A8.prototype.output = function() {
  for (; this.place < this.text.length; )
    this.readCharicter();
  if (this.state === $q)
    return this.root;
  throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function LM1(t) {
  var e = new A8(t);
  return e.output();
}
function qM(t, e, n) {
  Array.isArray(e) && (n.unshift(e), e = null);
  var i = e ? {} : t, s = n.reduce(function(l, a) {
    return ga(a, l), l;
  }, i);
  e && (t[e] = s);
}
function ga(t, e) {
  if (!Array.isArray(t)) {
    e[t] = !0;
    return;
  }
  var n = t.shift();
  if (n === "PARAMETER" && (n = t.shift()), t.length === 1) {
    if (Array.isArray(t[0])) {
      e[n] = {}, ga(t[0], e[n]);
      return;
    }
    e[n] = t[0];
    return;
  }
  if (!t.length) {
    e[n] = !0;
    return;
  }
  if (n === "TOWGS84") {
    e[n] = t;
    return;
  }
  if (n === "AXIS") {
    n in e || (e[n] = []), e[n].push(t);
    return;
  }
  Array.isArray(n) || (e[n] = {});
  var i;
  switch (n) {
    case "UNIT":
    case "PRIMEM":
    case "VERT_DATUM":
      e[n] = {
        name: t[0].toLowerCase(),
        convert: t[1]
      }, t.length === 3 && ga(t[2], e[n]);
      return;
    case "SPHEROID":
    case "ELLIPSOID":
      e[n] = {
        name: t[0],
        a: t[1],
        rf: t[2]
      }, t.length === 4 && ga(t[3], e[n]);
      return;
    case "PROJECTEDCRS":
    case "PROJCRS":
    case "GEOGCS":
    case "GEOCCS":
    case "PROJCS":
    case "LOCAL_CS":
    case "GEODCRS":
    case "GEODETICCRS":
    case "GEODETICDATUM":
    case "EDATUM":
    case "ENGINEERINGDATUM":
    case "VERT_CS":
    case "VERTCRS":
    case "VERTICALCRS":
    case "COMPD_CS":
    case "COMPOUNDCRS":
    case "ENGINEERINGCRS":
    case "ENGCRS":
    case "FITTED_CS":
    case "LOCAL_DATUM":
    case "DATUM":
      t[0] = ["name", t[0]], qM(e, n, t);
      return;
    default:
      for (i = -1; ++i < t.length; )
        if (!Array.isArray(t[i]))
          return ga(t, e[n]);
      return qM(e, n, t);
  }
}
var xM1 = 0.017453292519943295;
function SM1(t, e) {
  var n = e[0], i = e[1];
  !(n in t) && i in t && (t[n] = t[i], e.length === 3 && (t[n] = e[2](t[n])));
}
function $n(t) {
  return t * xM1;
}
function CM1(t) {
  if (t.type === "GEOGCS" ? t.projName = "longlat" : t.type === "LOCAL_CS" ? (t.projName = "identity", t.local = !0) : typeof t.PROJECTION == "object" ? t.projName = Object.keys(t.PROJECTION)[0] : t.projName = t.PROJECTION, t.AXIS) {
    for (var e = "", n = 0, i = t.AXIS.length; n < i; ++n) {
      var s = [t.AXIS[n][0].toLowerCase(), t.AXIS[n][1].toLowerCase()];
      s[0].indexOf("north") !== -1 || (s[0] === "y" || s[0] === "lat") && s[1] === "north" ? e += "n" : s[0].indexOf("south") !== -1 || (s[0] === "y" || s[0] === "lat") && s[1] === "south" ? e += "s" : s[0].indexOf("east") !== -1 || (s[0] === "x" || s[0] === "lon") && s[1] === "east" ? e += "e" : (s[0].indexOf("west") !== -1 || (s[0] === "x" || s[0] === "lon") && s[1] === "west") && (e += "w");
    }
    e.length === 2 && (e += "u"), e.length === 3 && (t.axis = e);
  }
  t.UNIT && (t.units = t.UNIT.name.toLowerCase(), t.units === "metre" && (t.units = "meter"), t.UNIT.convert && (t.type === "GEOGCS" ? t.DATUM && t.DATUM.SPHEROID && (t.to_meter = t.UNIT.convert * t.DATUM.SPHEROID.a) : t.to_meter = t.UNIT.convert));
  var l = t.GEOGCS;
  t.type === "GEOGCS" && (l = t), l && (l.DATUM ? t.datumCode = l.DATUM.name.toLowerCase() : t.datumCode = l.name.toLowerCase(), t.datumCode.slice(0, 2) === "d_" && (t.datumCode = t.datumCode.slice(2)), (t.datumCode === "new_zealand_geodetic_datum_1949" || t.datumCode === "new_zealand_1949") && (t.datumCode = "nzgd49"), (t.datumCode === "wgs_1984" || t.datumCode === "world_geodetic_system_1984") && (t.PROJECTION === "Mercator_Auxiliary_Sphere" && (t.sphere = !0), t.datumCode = "wgs84"), t.datumCode.slice(-6) === "_ferro" && (t.datumCode = t.datumCode.slice(0, -6)), t.datumCode.slice(-8) === "_jakarta" && (t.datumCode = t.datumCode.slice(0, -8)), ~t.datumCode.indexOf("belge") && (t.datumCode = "rnb72"), l.DATUM && l.DATUM.SPHEROID && (t.ellps = l.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), t.ellps.toLowerCase().slice(0, 13) === "international" && (t.ellps = "intl"), t.a = l.DATUM.SPHEROID.a, t.rf = parseFloat(l.DATUM.SPHEROID.rf, 10)), l.DATUM && l.DATUM.TOWGS84 && (t.datum_params = l.DATUM.TOWGS84), ~t.datumCode.indexOf("osgb_1936") && (t.datumCode = "osgb36"), ~t.datumCode.indexOf("osni_1952") && (t.datumCode = "osni52"), (~t.datumCode.indexOf("tm65") || ~t.datumCode.indexOf("geodetic_datum_of_1965")) && (t.datumCode = "ire65"), t.datumCode === "ch1903+" && (t.datumCode = "ch1903"), ~t.datumCode.indexOf("israel") && (t.datumCode = "isr93")), t.b && !isFinite(t.b) && (t.b = t.a);
  function a(u) {
    var d = t.to_meter || 1;
    return u * d;
  }
  var o = function(u) {
    return SM1(t, u);
  }, h = [
    ["standard_parallel_1", "Standard_Parallel_1"],
    ["standard_parallel_1", "Latitude of 1st standard parallel"],
    ["standard_parallel_2", "Standard_Parallel_2"],
    ["standard_parallel_2", "Latitude of 2nd standard parallel"],
    ["false_easting", "False_Easting"],
    ["false_easting", "False easting"],
    ["false-easting", "Easting at false origin"],
    ["false_northing", "False_Northing"],
    ["false_northing", "False northing"],
    ["false_northing", "Northing at false origin"],
    ["central_meridian", "Central_Meridian"],
    ["central_meridian", "Longitude of natural origin"],
    ["central_meridian", "Longitude of false origin"],
    ["latitude_of_origin", "Latitude_Of_Origin"],
    ["latitude_of_origin", "Central_Parallel"],
    ["latitude_of_origin", "Latitude of natural origin"],
    ["latitude_of_origin", "Latitude of false origin"],
    ["scale_factor", "Scale_Factor"],
    ["k0", "scale_factor"],
    ["latitude_of_center", "Latitude_Of_Center"],
    ["latitude_of_center", "Latitude_of_center"],
    ["lat0", "latitude_of_center", $n],
    ["longitude_of_center", "Longitude_Of_Center"],
    ["longitude_of_center", "Longitude_of_center"],
    ["longc", "longitude_of_center", $n],
    ["x0", "false_easting", a],
    ["y0", "false_northing", a],
    ["long0", "central_meridian", $n],
    ["lat0", "latitude_of_origin", $n],
    ["lat0", "standard_parallel_1", $n],
    ["lat1", "standard_parallel_1", $n],
    ["lat2", "standard_parallel_2", $n],
    ["azimuth", "Azimuth"],
    ["alpha", "azimuth", $n],
    ["srsCode", "name"]
  ];
  h.forEach(o), !t.long0 && t.longc && (t.projName === "Albers_Conic_Equal_Area" || t.projName === "Lambert_Azimuthal_Equal_Area") && (t.long0 = t.longc), !t.lat_ts && t.lat1 && (t.projName === "Stereographic_South_Pole" || t.projName === "Polar Stereographic (variant B)") ? (t.lat0 = $n(t.lat1 > 0 ? 90 : -90), t.lat_ts = t.lat1) : !t.lat_ts && t.lat0 && t.projName === "Polar_Stereographic" && (t.lat_ts = t.lat0, t.lat0 = $n(t.lat0 > 0 ? 90 : -90));
}
function vk(t) {
  var e = LM1(t), n = e.shift(), i = e.shift();
  e.unshift(["name", i]), e.unshift(["type", n]);
  var s = {};
  return ga(e, s), CM1(s), s;
}
function I5(t) {
  var e = this;
  if (arguments.length === 2) {
    var n = arguments[1];
    typeof n == "string" ? n.charAt(0) === "+" ? I5[t] = Dy(arguments[1]) : I5[t] = vk(arguments[1]) : I5[t] = n;
  } else if (arguments.length === 1) {
    if (Array.isArray(t))
      return t.map(function(i) {
        Array.isArray(i) ? I5.apply(e, i) : I5(i);
      });
    if (typeof t == "string") {
      if (t in I5)
        return I5[t];
    } else
      "EPSG" in t ? I5["EPSG:" + t.EPSG] = t : "ESRI" in t ? I5["ESRI:" + t.ESRI] = t : "IAU2000" in t ? I5["IAU2000:" + t.IAU2000] = t : console.log(t);
    return;
  }
}
pM1(I5);
function kM1(t) {
  return typeof t == "string";
}
function EM1(t) {
  return t in I5;
}
var AM1 = ["PROJECTEDCRS", "PROJCRS", "GEOGCS", "GEOCCS", "PROJCS", "LOCAL_CS", "GEODCRS", "GEODETICCRS", "GEODETICDATUM", "ENGCRS", "ENGINEERINGCRS"];
function FM1(t) {
  return AM1.some(function(e) {
    return t.indexOf(e) > -1;
  });
}
var TM1 = ["3857", "900913", "3785", "102113"];
function IM1(t) {
  var e = Ps(t, "authority");
  if (e) {
    var n = Ps(e, "epsg");
    return n && TM1.indexOf(n) > -1;
  }
}
function OM1(t) {
  var e = Ps(t, "extension");
  if (e)
    return Ps(e, "proj4");
}
function NM1(t) {
  return t[0] === "+";
}
function PM1(t) {
  if (kM1(t)) {
    if (EM1(t))
      return I5[t];
    if (FM1(t)) {
      var e = vk(t);
      if (IM1(e))
        return I5["EPSG:3857"];
      var n = OM1(e);
      return n ? Dy(n) : e;
    }
    if (NM1(t))
      return Dy(t);
  } else
    return t;
}
function wM(t, e) {
  t = t || {};
  var n, i;
  if (!e)
    return t;
  for (i in e)
    n = e[i], n !== void 0 && (t[i] = n);
  return t;
}
function oi(t, e, n) {
  var i = t * e;
  return n / Math.sqrt(1 - i * i);
}
function kc(t) {
  return t < 0 ? -1 : 1;
}
function $2(t) {
  return Math.abs(t) <= Jt ? t : t - kc(t) * sc;
}
function un(t, e, n) {
  var i = t * n, s = 0.5 * t;
  return i = Math.pow((1 - i) / (1 + i), s), Math.tan(0.5 * (h2 - e)) / i;
}
function rc(t, e) {
  for (var n = 0.5 * t, i, s, l = h2 - 2 * Math.atan(e), a = 0; a <= 15; a++)
    if (i = t * Math.sin(l), s = h2 - 2 * Math.atan(e * Math.pow((1 - i) / (1 + i), n)) - l, l += s, Math.abs(s) <= 1e-10)
      return l;
  return -9999;
}
function BM1() {
  var t = this.b / this.a;
  this.es = 1 - t * t, "x0" in this || (this.x0 = 0), "y0" in this || (this.y0 = 0), this.e = Math.sqrt(this.es), this.lat_ts ? this.sphere ? this.k0 = Math.cos(this.lat_ts) : this.k0 = oi(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) : this.k0 || (this.k ? this.k0 = this.k : this.k0 = 1);
}
function VM1(t) {
  var e = t.x, n = t.y;
  if (n * Kn > 90 && n * Kn < -90 && e * Kn > 180 && e * Kn < -180)
    return null;
  var i, s;
  if (Math.abs(Math.abs(n) - h2) <= I2)
    return null;
  if (this.sphere)
    i = this.x0 + this.a * this.k0 * $2(e - this.long0), s = this.y0 + this.a * this.k0 * Math.log(Math.tan(Ne + 0.5 * n));
  else {
    var l = Math.sin(n), a = un(this.e, n, l);
    i = this.x0 + this.a * this.k0 * $2(e - this.long0), s = this.y0 - this.a * this.k0 * Math.log(a);
  }
  return t.x = i, t.y = s, t;
}
function RM1(t) {
  var e = t.x - this.x0, n = t.y - this.y0, i, s;
  if (this.sphere)
    s = h2 - 2 * Math.atan(Math.exp(-n / (this.a * this.k0)));
  else {
    var l = Math.exp(-n / (this.a * this.k0));
    if (s = rc(this.e, l), s === -9999)
      return null;
  }
  return i = $2(this.long0 + e / (this.a * this.k0)), t.x = i, t.y = s, t;
}
var HM1 = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
const DM1 = {
  init: BM1,
  forward: VM1,
  inverse: RM1,
  names: HM1
};
function $M1() {
}
function zM(t) {
  return t;
}
var UM1 = ["longlat", "identity"];
const jM1 = {
  init: $M1,
  forward: zM,
  inverse: zM,
  names: UM1
};
var GM1 = [DM1, jM1], _h = {}, ou = [];
function pk(t, e) {
  var n = ou.length;
  return t.names ? (ou[n] = t, t.names.forEach(function(i) {
    _h[i.toLowerCase()] = n;
  }), this) : (console.log(e), !0);
}
function WM1(t) {
  if (!t)
    return !1;
  var e = t.toLowerCase();
  if (typeof _h[e] < "u" && ou[_h[e]])
    return ou[_h[e]];
}
function YM1() {
  GM1.forEach(pk);
}
const XM1 = {
  start: YM1,
  add: pk,
  get: WM1
};
var k3 = {};
k3.MERIT = {
  a: 6378137,
  rf: 298.257,
  ellipseName: "MERIT 1983"
};
k3.SGS85 = {
  a: 6378136,
  rf: 298.257,
  ellipseName: "Soviet Geodetic System 85"
};
k3.GRS80 = {
  a: 6378137,
  rf: 298.257222101,
  ellipseName: "GRS 1980(IUGG, 1980)"
};
k3.IAU76 = {
  a: 6378140,
  rf: 298.257,
  ellipseName: "IAU 1976"
};
k3.airy = {
  a: 6377563396e-3,
  b: 635625691e-2,
  ellipseName: "Airy 1830"
};
k3.APL4 = {
  a: 6378137,
  rf: 298.25,
  ellipseName: "Appl. Physics. 1965"
};
k3.NWL9D = {
  a: 6378145,
  rf: 298.25,
  ellipseName: "Naval Weapons Lab., 1965"
};
k3.mod_airy = {
  a: 6377340189e-3,
  b: 6356034446e-3,
  ellipseName: "Modified Airy"
};
k3.andrae = {
  a: 637710443e-2,
  rf: 300,
  ellipseName: "Andrae 1876 (Den., Iclnd.)"
};
k3.aust_SA = {
  a: 6378160,
  rf: 298.25,
  ellipseName: "Australian Natl & S. Amer. 1969"
};
k3.GRS67 = {
  a: 6378160,
  rf: 298.247167427,
  ellipseName: "GRS 67(IUGG 1967)"
};
k3.bessel = {
  a: 6377397155e-3,
  rf: 299.1528128,
  ellipseName: "Bessel 1841"
};
k3.bess_nam = {
  a: 6377483865e-3,
  rf: 299.1528128,
  ellipseName: "Bessel 1841 (Namibia)"
};
k3.clrk66 = {
  a: 63782064e-1,
  b: 63565838e-1,
  ellipseName: "Clarke 1866"
};
k3.clrk80 = {
  a: 6378249145e-3,
  rf: 293.4663,
  ellipseName: "Clarke 1880 mod."
};
k3.clrk80ign = {
  a: 63782492e-1,
  b: 6356515,
  rf: 293.4660213,
  ellipseName: "Clarke 1880 (IGN)"
};
k3.clrk58 = {
  a: 6378293645208759e-9,
  rf: 294.2606763692654,
  ellipseName: "Clarke 1858"
};
k3.CPM = {
  a: 63757387e-1,
  rf: 334.29,
  ellipseName: "Comm. des Poids et Mesures 1799"
};
k3.delmbr = {
  a: 6376428,
  rf: 311.5,
  ellipseName: "Delambre 1810 (Belgium)"
};
k3.engelis = {
  a: 637813605e-2,
  rf: 298.2566,
  ellipseName: "Engelis 1985"
};
k3.evrst30 = {
  a: 6377276345e-3,
  rf: 300.8017,
  ellipseName: "Everest 1830"
};
k3.evrst48 = {
  a: 6377304063e-3,
  rf: 300.8017,
  ellipseName: "Everest 1948"
};
k3.evrst56 = {
  a: 6377301243e-3,
  rf: 300.8017,
  ellipseName: "Everest 1956"
};
k3.evrst69 = {
  a: 6377295664e-3,
  rf: 300.8017,
  ellipseName: "Everest 1969"
};
k3.evrstSS = {
  a: 6377298556e-3,
  rf: 300.8017,
  ellipseName: "Everest (Sabah & Sarawak)"
};
k3.fschr60 = {
  a: 6378166,
  rf: 298.3,
  ellipseName: "Fischer (Mercury Datum) 1960"
};
k3.fschr60m = {
  a: 6378155,
  rf: 298.3,
  ellipseName: "Fischer 1960"
};
k3.fschr68 = {
  a: 6378150,
  rf: 298.3,
  ellipseName: "Fischer 1968"
};
k3.helmert = {
  a: 6378200,
  rf: 298.3,
  ellipseName: "Helmert 1906"
};
k3.hough = {
  a: 6378270,
  rf: 297,
  ellipseName: "Hough"
};
k3.intl = {
  a: 6378388,
  rf: 297,
  ellipseName: "International 1909 (Hayford)"
};
k3.kaula = {
  a: 6378163,
  rf: 298.24,
  ellipseName: "Kaula 1961"
};
k3.lerch = {
  a: 6378139,
  rf: 298.257,
  ellipseName: "Lerch 1979"
};
k3.mprts = {
  a: 6397300,
  rf: 191,
  ellipseName: "Maupertius 1738"
};
k3.new_intl = {
  a: 63781575e-1,
  b: 63567722e-1,
  ellipseName: "New International 1967"
};
k3.plessis = {
  a: 6376523,
  rf: 6355863,
  ellipseName: "Plessis 1817 (France)"
};
k3.krass = {
  a: 6378245,
  rf: 298.3,
  ellipseName: "Krassovsky, 1942"
};
k3.SEasia = {
  a: 6378155,
  b: 63567733205e-4,
  ellipseName: "Southeast Asia"
};
k3.walbeck = {
  a: 6376896,
  b: 63558348467e-4,
  ellipseName: "Walbeck"
};
k3.WGS60 = {
  a: 6378165,
  rf: 298.3,
  ellipseName: "WGS 60"
};
k3.WGS66 = {
  a: 6378145,
  rf: 298.25,
  ellipseName: "WGS 66"
};
k3.WGS7 = {
  a: 6378135,
  rf: 298.26,
  ellipseName: "WGS 72"
};
var KM1 = k3.WGS84 = {
  a: 6378137,
  rf: 298.257223563,
  ellipseName: "WGS 84"
};
k3.sphere = {
  a: 6370997,
  b: 6370997,
  ellipseName: "Normal Sphere (r=6370997)"
};
function ZM1(t, e, n, i) {
  var s = t * t, l = e * e, a = (s - l) / s, o = 0;
  i ? (t *= 1 - a * (yM1 + a * (_M1 + a * qM1)), s = t * t, a = 0) : o = Math.sqrt(a);
  var h = (s - l) / l;
  return {
    es: a,
    e: o,
    ep2: h
  };
}
function JM1(t, e, n, i, s) {
  if (!t) {
    var l = Ps(k3, i);
    l || (l = KM1), t = l.a, e = l.b, n = l.rf;
  }
  return n && !e && (e = (1 - 1 / n) * t), (n === 0 || Math.abs(t - e) < I2) && (s = !0, e = t), {
    a: t,
    b: e,
    rf: n,
    sphere: s
  };
}
var N4 = {};
N4.wgs84 = {
  towgs84: "0,0,0",
  ellipse: "WGS84",
  datumName: "WGS84"
};
N4.ch1903 = {
  towgs84: "674.374,15.056,405.346",
  ellipse: "bessel",
  datumName: "swiss"
};
N4.ggrs87 = {
  towgs84: "-199.87,74.79,246.62",
  ellipse: "GRS80",
  datumName: "Greek_Geodetic_Reference_System_1987"
};
N4.nad83 = {
  towgs84: "0,0,0",
  ellipse: "GRS80",
  datumName: "North_American_Datum_1983"
};
N4.nad27 = {
  nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
  ellipse: "clrk66",
  datumName: "North_American_Datum_1927"
};
N4.potsdam = {
  towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
  ellipse: "bessel",
  datumName: "Potsdam Rauenberg 1950 DHDN"
};
N4.carthage = {
  towgs84: "-263.0,6.0,431.0",
  ellipse: "clark80",
  datumName: "Carthage 1934 Tunisia"
};
N4.hermannskogel = {
  towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
  ellipse: "bessel",
  datumName: "Hermannskogel"
};
N4.osni52 = {
  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
  ellipse: "airy",
  datumName: "Irish National"
};
N4.ire65 = {
  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
  ellipse: "mod_airy",
  datumName: "Ireland 1965"
};
N4.rassadiran = {
  towgs84: "-133.63,-157.5,-158.62",
  ellipse: "intl",
  datumName: "Rassadiran"
};
N4.nzgd49 = {
  towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
  ellipse: "intl",
  datumName: "New Zealand Geodetic Datum 1949"
};
N4.osgb36 = {
  towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
  ellipse: "airy",
  datumName: "Airy 1830"
};
N4.s_jtsk = {
  towgs84: "589,76,480",
  ellipse: "bessel",
  datumName: "S-JTSK (Ferro)"
};
N4.beduaram = {
  towgs84: "-106,-87,188",
  ellipse: "clrk80",
  datumName: "Beduaram"
};
N4.gunung_segara = {
  towgs84: "-403,684,41",
  ellipse: "bessel",
  datumName: "Gunung Segara Jakarta"
};
N4.rnb72 = {
  towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
  ellipse: "intl",
  datumName: "Reseau National Belge 1972"
};
function QM1(t, e, n, i, s, l, a) {
  var o = {};
  return t === void 0 || t === "none" ? o.datum_type = Hy : o.datum_type = mM1, e && (o.datum_params = e.map(parseFloat), (o.datum_params[0] !== 0 || o.datum_params[1] !== 0 || o.datum_params[2] !== 0) && (o.datum_type = yr), o.datum_params.length > 3 && (o.datum_params[3] !== 0 || o.datum_params[4] !== 0 || o.datum_params[5] !== 0 || o.datum_params[6] !== 0) && (o.datum_type = _r, o.datum_params[3] *= Co, o.datum_params[4] *= Co, o.datum_params[5] *= Co, o.datum_params[6] = o.datum_params[6] / 1e6 + 1)), a && (o.datum_type = xa, o.grids = a), o.a = n, o.b = i, o.es = s, o.ep2 = l, o;
}
var mk = {};
function eb1(t, e) {
  var n = new DataView(e), i = ib1(n), s = sb1(n, i), l = lb1(n, s, i), a = { header: s, subgrids: l };
  return mk[t] = a, a;
}
function tb1(t) {
  if (t === void 0)
    return null;
  var e = t.split(",");
  return e.map(nb1);
}
function nb1(t) {
  if (t.length === 0)
    return null;
  var e = t[0] === "@";
  return e && (t = t.slice(1)), t === "null" ? { name: "null", mandatory: !e, grid: null, isNull: !0 } : {
    name: t,
    mandatory: !e,
    grid: mk[t] || null,
    isNull: !1
  };
}
function ya(t) {
  return t / 3600 * Math.PI / 180;
}
function ib1(t) {
  var e = t.getInt32(8, !1);
  return e === 11 ? !1 : (e = t.getInt32(8, !0), e !== 11 && console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian"), !0);
}
function sb1(t, e) {
  return {
    nFields: t.getInt32(8, e),
    nSubgridFields: t.getInt32(24, e),
    nSubgrids: t.getInt32(40, e),
    shiftType: $y(t, 56, 56 + 8).trim(),
    fromSemiMajorAxis: t.getFloat64(120, e),
    fromSemiMinorAxis: t.getFloat64(136, e),
    toSemiMajorAxis: t.getFloat64(152, e),
    toSemiMinorAxis: t.getFloat64(168, e)
  };
}
function $y(t, e, n) {
  return String.fromCharCode.apply(null, new Uint8Array(t.buffer.slice(e, n)));
}
function lb1(t, e, n) {
  for (var i = 176, s = [], l = 0; l < e.nSubgrids; l++) {
    var a = ab1(t, i, n), o = ob1(t, i, a, n), h = Math.round(
      1 + (a.upperLongitude - a.lowerLongitude) / a.longitudeInterval
    ), u = Math.round(
      1 + (a.upperLatitude - a.lowerLatitude) / a.latitudeInterval
    );
    s.push({
      ll: [ya(a.lowerLongitude), ya(a.lowerLatitude)],
      del: [ya(a.longitudeInterval), ya(a.latitudeInterval)],
      lim: [h, u],
      count: a.gridNodeCount,
      cvs: rb1(o)
    }), i += 176 + a.gridNodeCount * 16;
  }
  return s;
}
function rb1(t) {
  return t.map(function(e) {
    return [ya(e.longitudeShift), ya(e.latitudeShift)];
  });
}
function ab1(t, e, n) {
  return {
    name: $y(t, e + 8, e + 16).trim(),
    parent: $y(t, e + 24, e + 24 + 8).trim(),
    lowerLatitude: t.getFloat64(e + 72, n),
    upperLatitude: t.getFloat64(e + 88, n),
    lowerLongitude: t.getFloat64(e + 104, n),
    upperLongitude: t.getFloat64(e + 120, n),
    latitudeInterval: t.getFloat64(e + 136, n),
    longitudeInterval: t.getFloat64(e + 152, n),
    gridNodeCount: t.getInt32(e + 168, n)
  };
}
function ob1(t, e, n, i) {
  for (var s = e + 176, l = 16, a = [], o = 0; o < n.gridNodeCount; o++) {
    var h = {
      latitudeShift: t.getFloat32(s + o * l, i),
      longitudeShift: t.getFloat32(s + o * l + 4, i),
      latitudeAccuracy: t.getFloat32(s + o * l + 8, i),
      longitudeAccuracy: t.getFloat32(s + o * l + 12, i)
    };
    a.push(h);
  }
  return a;
}
function ii(t, e) {
  if (!(this instanceof ii))
    return new ii(t);
  e = e || function(u) {
    if (u)
      throw u;
  };
  var n = PM1(t);
  if (typeof n != "object") {
    e(t);
    return;
  }
  var i = ii.projections.get(n.projName);
  if (!i) {
    e(t);
    return;
  }
  if (n.datumCode && n.datumCode !== "none") {
    var s = Ps(N4, n.datumCode);
    s && (n.datum_params = n.datum_params || (s.towgs84 ? s.towgs84.split(",") : null), n.ellps = s.ellipse, n.datumName = s.datumName ? s.datumName : n.datumCode);
  }
  n.k0 = n.k0 || 1, n.axis = n.axis || "enu", n.ellps = n.ellps || "wgs84", n.lat1 = n.lat1 || n.lat0;
  var l = JM1(n.a, n.b, n.rf, n.ellps, n.sphere), a = ZM1(l.a, l.b, l.rf, n.R_A), o = tb1(n.nadgrids), h = n.datum || QM1(
    n.datumCode,
    n.datum_params,
    l.a,
    l.b,
    a.es,
    a.ep2,
    o
  );
  wM(this, n), wM(this, i), this.a = l.a, this.b = l.b, this.rf = l.rf, this.sphere = l.sphere, this.es = a.es, this.e = a.e, this.ep2 = a.ep2, this.datum = h, this.init(), e(null, this);
}
ii.projections = XM1;
ii.projections.start();
function cb1(t, e) {
  return t.datum_type !== e.datum_type || t.a !== e.a || Math.abs(t.es - e.es) > 5e-11 ? !1 : t.datum_type === yr ? t.datum_params[0] === e.datum_params[0] && t.datum_params[1] === e.datum_params[1] && t.datum_params[2] === e.datum_params[2] : t.datum_type === _r ? t.datum_params[0] === e.datum_params[0] && t.datum_params[1] === e.datum_params[1] && t.datum_params[2] === e.datum_params[2] && t.datum_params[3] === e.datum_params[3] && t.datum_params[4] === e.datum_params[4] && t.datum_params[5] === e.datum_params[5] && t.datum_params[6] === e.datum_params[6] : !0;
}
function gk(t, e, n) {
  var i = t.x, s = t.y, l = t.z ? t.z : 0, a, o, h, u;
  if (s < -h2 && s > -1.001 * h2)
    s = -h2;
  else if (s > h2 && s < 1.001 * h2)
    s = h2;
  else {
    if (s < -h2)
      return { x: -1 / 0, y: -1 / 0, z: t.z };
    if (s > h2)
      return { x: 1 / 0, y: 1 / 0, z: t.z };
  }
  return i > Math.PI && (i -= 2 * Math.PI), o = Math.sin(s), u = Math.cos(s), h = o * o, a = n / Math.sqrt(1 - e * h), {
    x: (a + l) * u * Math.cos(i),
    y: (a + l) * u * Math.sin(i),
    z: (a * (1 - e) + l) * o
  };
}
function yk(t, e, n, i) {
  var s = 1e-12, l = s * s, a = 30, o, h, u, d, v, m, p, _, q, M, z, b, x, k = t.x, F = t.y, D = t.z ? t.z : 0, R, V, J;
  if (o = Math.sqrt(k * k + F * F), h = Math.sqrt(k * k + F * F + D * D), o / n < s) {
    if (R = 0, h / n < s)
      return V = h2, J = -i, {
        x: t.x,
        y: t.y,
        z: t.z
      };
  } else
    R = Math.atan2(F, k);
  u = D / h, d = o / h, v = 1 / Math.sqrt(1 - e * (2 - e) * d * d), _ = d * (1 - e) * v, q = u * v, x = 0;
  do
    x++, p = n / Math.sqrt(1 - e * q * q), J = o * _ + D * q - p * (1 - e * q * q), m = e * p / (p + J), v = 1 / Math.sqrt(1 - m * (2 - m) * d * d), M = d * (1 - m) * v, z = u * v, b = z * _ - M * q, _ = M, q = z;
  while (b * b > l && x < a);
  return V = Math.atan(z / Math.abs(M)), {
    x: R,
    y: V,
    z: J
  };
}
function hb1(t, e, n) {
  if (e === yr)
    return {
      x: t.x + n[0],
      y: t.y + n[1],
      z: t.z + n[2]
    };
  if (e === _r) {
    var i = n[0], s = n[1], l = n[2], a = n[3], o = n[4], h = n[5], u = n[6];
    return {
      x: u * (t.x - h * t.y + o * t.z) + i,
      y: u * (h * t.x + t.y - a * t.z) + s,
      z: u * (-o * t.x + a * t.y + t.z) + l
    };
  }
}
function ub1(t, e, n) {
  if (e === yr)
    return {
      x: t.x - n[0],
      y: t.y - n[1],
      z: t.z - n[2]
    };
  if (e === _r) {
    var i = n[0], s = n[1], l = n[2], a = n[3], o = n[4], h = n[5], u = n[6], d = (t.x - i) / u, v = (t.y - s) / u, m = (t.z - l) / u;
    return {
      x: d + h * v - o * m,
      y: -h * d + v + a * m,
      z: o * d - a * v + m
    };
  }
}
function lh(t) {
  return t === yr || t === _r;
}
function db1(t, e, n) {
  if (cb1(t, e) || t.datum_type === Hy || e.datum_type === Hy)
    return n;
  var i = t.a, s = t.es;
  if (t.datum_type === xa) {
    var l = MM(t, !1, n);
    if (l !== 0)
      return;
    i = gM, s = yM;
  }
  var a = e.a, o = e.b, h = e.es;
  if (e.datum_type === xa && (a = gM, o = gM1, h = yM), s === h && i === a && !lh(t.datum_type) && !lh(e.datum_type))
    return n;
  if (n = gk(n, s, i), lh(t.datum_type) && (n = hb1(n, t.datum_type, t.datum_params)), lh(e.datum_type) && (n = ub1(n, e.datum_type, e.datum_params)), n = yk(n, h, a, o), e.datum_type === xa) {
    var u = MM(e, !0, n);
    if (u !== 0)
      return;
  }
  return n;
}
function MM(t, e, n) {
  if (t.grids === null || t.grids.length === 0)
    return console.log("Grid shift grids not found"), -1;
  var i = { x: -n.x, y: n.y }, s = { x: Number.NaN, y: Number.NaN }, l = [];
  e:
    for (var a = 0; a < t.grids.length; a++) {
      var o = t.grids[a];
      if (l.push(o.name), o.isNull) {
        s = i;
        break;
      }
      if (o.mandatory, o.grid === null) {
        if (o.mandatory)
          return console.log("Unable to find mandatory grid '" + o.name + "'"), -1;
        continue;
      }
      for (var h = o.grid.subgrids, u = 0, d = h.length; u < d; u++) {
        var v = h[u], m = (Math.abs(v.del[1]) + Math.abs(v.del[0])) / 1e4, p = v.ll[0] - m, _ = v.ll[1] - m, q = v.ll[0] + (v.lim[0] - 1) * v.del[0] + m, M = v.ll[1] + (v.lim[1] - 1) * v.del[1] + m;
        if (!(_ > i.y || p > i.x || M < i.y || q < i.x) && (s = fb1(i, e, v), !isNaN(s.x)))
          break e;
      }
    }
  return isNaN(s.x) ? (console.log("Failed to find a grid shift table for location '" + -i.x * Kn + " " + i.y * Kn + " tried: '" + l + "'"), -1) : (n.x = -s.x, n.y = s.y, 0);
}
function fb1(t, e, n) {
  var i = { x: Number.NaN, y: Number.NaN };
  if (isNaN(t.x))
    return i;
  var s = { x: t.x, y: t.y };
  s.x -= n.ll[0], s.y -= n.ll[1], s.x = $2(s.x - Math.PI) + Math.PI;
  var l = bM(s, n);
  if (e) {
    if (isNaN(l.x))
      return i;
    l.x = s.x - l.x, l.y = s.y - l.y;
    var a = 9, o = 1e-12, h, u;
    do {
      if (u = bM(l, n), isNaN(u.x)) {
        console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
        break;
      }
      h = { x: s.x - (u.x + l.x), y: s.y - (u.y + l.y) }, l.x += h.x, l.y += h.y;
    } while (a-- && Math.abs(h.x) > o && Math.abs(h.y) > o);
    if (a < 0)
      return console.log("Inverse grid shift iterator failed to converge."), i;
    i.x = $2(l.x + n.ll[0]), i.y = l.y + n.ll[1];
  } else
    isNaN(l.x) || (i.x = t.x + l.x, i.y = t.y + l.y);
  return i;
}
function bM(t, e) {
  var n = { x: t.x / e.del[0], y: t.y / e.del[1] }, i = { x: Math.floor(n.x), y: Math.floor(n.y) }, s = { x: n.x - 1 * i.x, y: n.y - 1 * i.y }, l = { x: Number.NaN, y: Number.NaN }, a;
  if (i.x < 0 || i.x >= e.lim[0] || i.y < 0 || i.y >= e.lim[1])
    return l;
  a = i.y * e.lim[0] + i.x;
  var o = { x: e.cvs[a][0], y: e.cvs[a][1] };
  a++;
  var h = { x: e.cvs[a][0], y: e.cvs[a][1] };
  a += e.lim[0];
  var u = { x: e.cvs[a][0], y: e.cvs[a][1] };
  a--;
  var d = { x: e.cvs[a][0], y: e.cvs[a][1] }, v = s.x * s.y, m = s.x * (1 - s.y), p = (1 - s.x) * (1 - s.y), _ = (1 - s.x) * s.y;
  return l.x = p * o.x + m * h.x + _ * d.x + v * u.x, l.y = p * o.y + m * h.y + _ * d.y + v * u.y, l;
}
function LM(t, e, n) {
  var i = n.x, s = n.y, l = n.z || 0, a, o, h, u = {};
  for (h = 0; h < 3; h++)
    if (!(e && h === 2 && n.z === void 0))
      switch (h === 0 ? (a = i, "ew".indexOf(t.axis[h]) !== -1 ? o = "x" : o = "y") : h === 1 ? (a = s, "ns".indexOf(t.axis[h]) !== -1 ? o = "y" : o = "x") : (a = l, o = "z"), t.axis[h]) {
        case "e":
          u[o] = a;
          break;
        case "w":
          u[o] = -a;
          break;
        case "n":
          u[o] = a;
          break;
        case "s":
          u[o] = -a;
          break;
        case "u":
          n[o] !== void 0 && (u.z = a);
          break;
        case "d":
          n[o] !== void 0 && (u.z = -a);
          break;
        default:
          return null;
      }
  return u;
}
function _k(t) {
  var e = {
    x: t[0],
    y: t[1]
  };
  return t.length > 2 && (e.z = t[2]), t.length > 3 && (e.m = t[3]), e;
}
function vb1(t) {
  xM(t.x), xM(t.y);
}
function xM(t) {
  if (typeof Number.isFinite == "function") {
    if (Number.isFinite(t))
      return;
    throw new TypeError("coordinates must be finite numbers");
  }
  if (typeof t != "number" || t !== t || !isFinite(t))
    throw new TypeError("coordinates must be finite numbers");
}
function pb1(t, e) {
  return (t.datum.datum_type === yr || t.datum.datum_type === _r || t.datum.datum_type === xa) && e.datumCode !== "WGS84" || (e.datum.datum_type === yr || e.datum.datum_type === _r || e.datum.datum_type === xa) && t.datumCode !== "WGS84";
}
function cu(t, e, n, i) {
  var s;
  Array.isArray(n) ? n = _k(n) : n = {
    x: n.x,
    y: n.y,
    z: n.z,
    m: n.m
  };
  var l = n.z !== void 0;
  if (vb1(n), t.datum && e.datum && pb1(t, e) && (s = new ii("WGS84"), n = cu(t, s, n, i), t = s), i && t.axis !== "enu" && (n = LM(t, !1, n)), t.projName === "longlat")
    n = {
      x: n.x * U4,
      y: n.y * U4,
      z: n.z || 0
    };
  else if (t.to_meter && (n = {
    x: n.x * t.to_meter,
    y: n.y * t.to_meter,
    z: n.z || 0
  }), n = t.inverse(n), !n)
    return;
  if (t.from_greenwich && (n.x += t.from_greenwich), n = db1(t.datum, e.datum, n), !!n)
    return e.from_greenwich && (n = {
      x: n.x - e.from_greenwich,
      y: n.y,
      z: n.z || 0
    }), e.projName === "longlat" ? n = {
      x: n.x * Kn,
      y: n.y * Kn,
      z: n.z || 0
    } : (n = e.forward(n), e.to_meter && (n = {
      x: n.x / e.to_meter,
      y: n.y / e.to_meter,
      z: n.z || 0
    })), i && e.axis !== "enu" ? LM(e, !0, n) : (n && !l && delete n.z, n);
}
var SM = ii("WGS84");
function jg(t, e, n, i) {
  var s, l, a;
  return Array.isArray(n) ? (s = cu(t, e, n, i) || { x: NaN, y: NaN }, n.length > 2 ? typeof t.name < "u" && t.name === "geocent" || typeof e.name < "u" && e.name === "geocent" ? typeof s.z == "number" ? [s.x, s.y, s.z].concat(n.splice(3)) : [s.x, s.y, n[2]].concat(n.splice(3)) : [s.x, s.y].concat(n.splice(2)) : [s.x, s.y]) : (l = cu(t, e, n, i), a = Object.keys(n), a.length === 2 || a.forEach(function(o) {
    if (typeof t.name < "u" && t.name === "geocent" || typeof e.name < "u" && e.name === "geocent") {
      if (o === "x" || o === "y" || o === "z")
        return;
    } else if (o === "x" || o === "y")
      return;
    l[o] = n[o];
  }), l);
}
function CM(t) {
  return t instanceof ii ? t : t.oProj ? t.oProj : ii(t);
}
function m5(t, e, n) {
  t = CM(t);
  var i = !1, s;
  return typeof e > "u" ? (e = t, t = SM, i = !0) : (typeof e.x < "u" || Array.isArray(e)) && (n = e, e = t, t = SM, i = !0), e = CM(e), n ? jg(t, e, n) : (s = {
    forward: function(l, a) {
      return jg(t, e, l, a);
    },
    inverse: function(l, a) {
      return jg(e, t, l, a);
    }
  }, i && (s.oProj = e), s);
}
var kM = 6, qk = "AJSAJS", wk = "AFAFAF", _a = 65, t0 = 73, y6 = 79, po = 86, mo = 90;
const mb1 = {
  forward: zk,
  inverse: gb1,
  toPoint: Mk
};
function zk(t, e) {
  return e = e || 5, qb1(yb1({
    lat: t[1],
    lon: t[0]
  }), e);
}
function gb1(t) {
  var e = Uq(Lk(t.toUpperCase()));
  return e.lat && e.lon ? [e.lon, e.lat, e.lon, e.lat] : [e.left, e.bottom, e.right, e.top];
}
function Mk(t) {
  var e = Uq(Lk(t.toUpperCase()));
  return e.lat && e.lon ? [e.lon, e.lat] : [(e.left + e.right) / 2, (e.top + e.bottom) / 2];
}
function Gg(t) {
  return t * (Math.PI / 180);
}
function EM(t) {
  return 180 * (t / Math.PI);
}
function yb1(t) {
  var e = t.lat, n = t.lon, i = 6378137, s = 669438e-8, l = 0.9996, a, o, h, u, d, v, m, p = Gg(e), _ = Gg(n), q, M;
  M = Math.floor((n + 180) / 6) + 1, n === 180 && (M = 60), e >= 56 && e < 64 && n >= 3 && n < 12 && (M = 32), e >= 72 && e < 84 && (n >= 0 && n < 9 ? M = 31 : n >= 9 && n < 21 ? M = 33 : n >= 21 && n < 33 ? M = 35 : n >= 33 && n < 42 && (M = 37)), a = (M - 1) * 6 - 180 + 3, q = Gg(a), o = s / (1 - s), h = i / Math.sqrt(1 - s * Math.sin(p) * Math.sin(p)), u = Math.tan(p) * Math.tan(p), d = o * Math.cos(p) * Math.cos(p), v = Math.cos(p) * (_ - q), m = i * ((1 - s / 4 - 3 * s * s / 64 - 5 * s * s * s / 256) * p - (3 * s / 8 + 3 * s * s / 32 + 45 * s * s * s / 1024) * Math.sin(2 * p) + (15 * s * s / 256 + 45 * s * s * s / 1024) * Math.sin(4 * p) - 35 * s * s * s / 3072 * Math.sin(6 * p));
  var z = l * h * (v + (1 - u + d) * v * v * v / 6 + (5 - 18 * u + u * u + 72 * d - 58 * o) * v * v * v * v * v / 120) + 5e5, b = l * (m + h * Math.tan(p) * (v * v / 2 + (5 - u + 9 * d + 4 * d * d) * v * v * v * v / 24 + (61 - 58 * u + u * u + 600 * d - 330 * o) * v * v * v * v * v * v / 720));
  return e < 0 && (b += 1e7), {
    northing: Math.round(b),
    easting: Math.round(z),
    zoneNumber: M,
    zoneLetter: _b1(e)
  };
}
function Uq(t) {
  var e = t.northing, n = t.easting, i = t.zoneLetter, s = t.zoneNumber;
  if (s < 0 || s > 60)
    return null;
  var l = 0.9996, a = 6378137, o = 669438e-8, h, u = (1 - Math.sqrt(1 - o)) / (1 + Math.sqrt(1 - o)), d, v, m, p, _, q, M, z, b, x = n - 5e5, k = e;
  i < "N" && (k -= 1e7), M = (s - 1) * 6 - 180 + 3, h = o / (1 - o), q = k / l, z = q / (a * (1 - o / 4 - 3 * o * o / 64 - 5 * o * o * o / 256)), b = z + (3 * u / 2 - 27 * u * u * u / 32) * Math.sin(2 * z) + (21 * u * u / 16 - 55 * u * u * u * u / 32) * Math.sin(4 * z) + 151 * u * u * u / 96 * Math.sin(6 * z), d = a / Math.sqrt(1 - o * Math.sin(b) * Math.sin(b)), v = Math.tan(b) * Math.tan(b), m = h * Math.cos(b) * Math.cos(b), p = a * (1 - o) / Math.pow(1 - o * Math.sin(b) * Math.sin(b), 1.5), _ = x / (d * l);
  var F = b - d * Math.tan(b) / p * (_ * _ / 2 - (5 + 3 * v + 10 * m - 4 * m * m - 9 * h) * _ * _ * _ * _ / 24 + (61 + 90 * v + 298 * m + 45 * v * v - 252 * h - 3 * m * m) * _ * _ * _ * _ * _ * _ / 720);
  F = EM(F);
  var D = (_ - (1 + 2 * v + m) * _ * _ * _ / 6 + (5 - 2 * m + 28 * v - 3 * m * m + 8 * h + 24 * v * v) * _ * _ * _ * _ * _ / 120) / Math.cos(b);
  D = M + EM(D);
  var R;
  if (t.accuracy) {
    var V = Uq({
      northing: t.northing + t.accuracy,
      easting: t.easting + t.accuracy,
      zoneLetter: t.zoneLetter,
      zoneNumber: t.zoneNumber
    });
    R = {
      top: V.lat,
      right: V.lon,
      bottom: F,
      left: D
    };
  } else
    R = {
      lat: F,
      lon: D
    };
  return R;
}
function _b1(t) {
  var e = "Z";
  return 84 >= t && t >= 72 ? e = "X" : 72 > t && t >= 64 ? e = "W" : 64 > t && t >= 56 ? e = "V" : 56 > t && t >= 48 ? e = "U" : 48 > t && t >= 40 ? e = "T" : 40 > t && t >= 32 ? e = "S" : 32 > t && t >= 24 ? e = "R" : 24 > t && t >= 16 ? e = "Q" : 16 > t && t >= 8 ? e = "P" : 8 > t && t >= 0 ? e = "N" : 0 > t && t >= -8 ? e = "M" : -8 > t && t >= -16 ? e = "L" : -16 > t && t >= -24 ? e = "K" : -24 > t && t >= -32 ? e = "J" : -32 > t && t >= -40 ? e = "H" : -40 > t && t >= -48 ? e = "G" : -48 > t && t >= -56 ? e = "F" : -56 > t && t >= -64 ? e = "E" : -64 > t && t >= -72 ? e = "D" : -72 > t && t >= -80 && (e = "C"), e;
}
function qb1(t, e) {
  var n = "00000" + t.easting, i = "00000" + t.northing;
  return t.zoneNumber + t.zoneLetter + wb1(t.easting, t.northing, t.zoneNumber) + n.substr(n.length - 5, e) + i.substr(i.length - 5, e);
}
function wb1(t, e, n) {
  var i = bk(n), s = Math.floor(t / 1e5), l = Math.floor(e / 1e5) % 20;
  return zb1(s, l, i);
}
function bk(t) {
  var e = t % kM;
  return e === 0 && (e = kM), e;
}
function zb1(t, e, n) {
  var i = n - 1, s = qk.charCodeAt(i), l = wk.charCodeAt(i), a = s + t - 1, o = l + e, h = !1;
  a > mo && (a = a - mo + _a - 1, h = !0), (a === t0 || s < t0 && a > t0 || (a > t0 || s < t0) && h) && a++, (a === y6 || s < y6 && a > y6 || (a > y6 || s < y6) && h) && (a++, a === t0 && a++), a > mo && (a = a - mo + _a - 1), o > po ? (o = o - po + _a - 1, h = !0) : h = !1, (o === t0 || l < t0 && o > t0 || (o > t0 || l < t0) && h) && o++, (o === y6 || l < y6 && o > y6 || (o > y6 || l < y6) && h) && (o++, o === t0 && o++), o > po && (o = o - po + _a - 1);
  var u = String.fromCharCode(a) + String.fromCharCode(o);
  return u;
}
function Lk(t) {
  if (t && t.length === 0)
    throw "MGRSPoint coverting from nothing";
  for (var e = t.length, n = null, i = "", s, l = 0; !/[A-Z]/.test(s = t.charAt(l)); ) {
    if (l >= 2)
      throw "MGRSPoint bad conversion from: " + t;
    i += s, l++;
  }
  var a = parseInt(i, 10);
  if (l === 0 || l + 3 > e)
    throw "MGRSPoint bad conversion from: " + t;
  var o = t.charAt(l++);
  if (o <= "A" || o === "B" || o === "Y" || o >= "Z" || o === "I" || o === "O")
    throw "MGRSPoint zone letter " + o + " not handled: " + t;
  n = t.substring(l, l += 2);
  for (var h = bk(a), u = Mb1(n.charAt(0), h), d = bb1(n.charAt(1), h); d < Lb1(o); )
    d += 2e6;
  var v = e - l;
  if (v % 2 !== 0)
    throw `MGRSPoint has to have an even number 
of digits after the zone letter and two 100km letters - front 
half for easting meters, second half for 
northing meters` + t;
  var m = v / 2, p = 0, _ = 0, q, M, z, b, x;
  return m > 0 && (q = 1e5 / Math.pow(10, m), M = t.substring(l, l + m), p = parseFloat(M) * q, z = t.substring(l + m), _ = parseFloat(z) * q), b = p + u, x = _ + d, {
    easting: b,
    northing: x,
    zoneLetter: o,
    zoneNumber: a,
    accuracy: q
  };
}
function Mb1(t, e) {
  for (var n = qk.charCodeAt(e - 1), i = 1e5, s = !1; n !== t.charCodeAt(0); ) {
    if (n++, n === t0 && n++, n === y6 && n++, n > mo) {
      if (s)
        throw "Bad character: " + t;
      n = _a, s = !0;
    }
    i += 1e5;
  }
  return i;
}
function bb1(t, e) {
  if (t > "V")
    throw "MGRSPoint given invalid Northing " + t;
  for (var n = wk.charCodeAt(e - 1), i = 0, s = !1; n !== t.charCodeAt(0); ) {
    if (n++, n === t0 && n++, n === y6 && n++, n > po) {
      if (s)
        throw "Bad character: " + t;
      n = _a, s = !0;
    }
    i += 1e5;
  }
  return i;
}
function Lb1(t) {
  var e;
  switch (t) {
    case "C":
      e = 11e5;
      break;
    case "D":
      e = 2e6;
      break;
    case "E":
      e = 28e5;
      break;
    case "F":
      e = 37e5;
      break;
    case "G":
      e = 46e5;
      break;
    case "H":
      e = 55e5;
      break;
    case "J":
      e = 64e5;
      break;
    case "K":
      e = 73e5;
      break;
    case "L":
      e = 82e5;
      break;
    case "M":
      e = 91e5;
      break;
    case "N":
      e = 0;
      break;
    case "P":
      e = 8e5;
      break;
    case "Q":
      e = 17e5;
      break;
    case "R":
      e = 26e5;
      break;
    case "S":
      e = 35e5;
      break;
    case "T":
      e = 44e5;
      break;
    case "U":
      e = 53e5;
      break;
    case "V":
      e = 62e5;
      break;
    case "W":
      e = 7e6;
      break;
    case "X":
      e = 79e5;
      break;
    default:
      e = -1;
  }
  if (e >= 0)
    return e;
  throw "Invalid zone letter: " + t;
}
function Ka(t, e, n) {
  if (!(this instanceof Ka))
    return new Ka(t, e, n);
  if (Array.isArray(t))
    this.x = t[0], this.y = t[1], this.z = t[2] || 0;
  else if (typeof t == "object")
    this.x = t.x, this.y = t.y, this.z = t.z || 0;
  else if (typeof t == "string" && typeof e > "u") {
    var i = t.split(",");
    this.x = parseFloat(i[0], 10), this.y = parseFloat(i[1], 10), this.z = parseFloat(i[2], 10) || 0;
  } else
    this.x = t, this.y = e, this.z = n || 0;
  console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
}
Ka.fromMGRS = function(t) {
  return new Ka(Mk(t));
};
Ka.prototype.toMGRS = function(t) {
  return zk([this.x, this.y], t);
};
var xb1 = 1, Sb1 = 0.25, AM = 0.046875, FM = 0.01953125, TM = 0.01068115234375, Cb1 = 0.75, kb1 = 0.46875, Eb1 = 0.013020833333333334, Ab1 = 0.007120768229166667, Fb1 = 0.3645833333333333, Tb1 = 0.005696614583333333, Ib1 = 0.3076171875;
function xk(t) {
  var e = [];
  e[0] = xb1 - t * (Sb1 + t * (AM + t * (FM + t * TM))), e[1] = t * (Cb1 - t * (AM + t * (FM + t * TM)));
  var n = t * t;
  return e[2] = n * (kb1 - t * (Eb1 + t * Ab1)), n *= t, e[3] = n * (Fb1 - t * Tb1), e[4] = n * t * Ib1, e;
}
function ad(t, e, n, i) {
  return n *= e, e *= e, i[0] * t - n * (i[1] + e * (i[2] + e * (i[3] + e * i[4])));
}
var Ob1 = 20;
function Sk(t, e, n) {
  for (var i = 1 / (1 - e), s = t, l = Ob1; l; --l) {
    var a = Math.sin(s), o = 1 - e * a * a;
    if (o = (ad(s, a, Math.cos(s), n) - t) * (o * Math.sqrt(o)) * i, s -= o, Math.abs(o) < I2)
      return s;
  }
  return s;
}
function Nb1() {
  this.x0 = this.x0 !== void 0 ? this.x0 : 0, this.y0 = this.y0 !== void 0 ? this.y0 : 0, this.long0 = this.long0 !== void 0 ? this.long0 : 0, this.lat0 = this.lat0 !== void 0 ? this.lat0 : 0, this.es && (this.en = xk(this.es), this.ml0 = ad(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en));
}
function Pb1(t) {
  var e = t.x, n = t.y, i = $2(e - this.long0), s, l, a, o = Math.sin(n), h = Math.cos(n);
  if (this.es) {
    var d = h * i, v = Math.pow(d, 2), m = this.ep2 * Math.pow(h, 2), p = Math.pow(m, 2), _ = Math.abs(h) > I2 ? Math.tan(n) : 0, q = Math.pow(_, 2), M = Math.pow(q, 2);
    s = 1 - this.es * Math.pow(o, 2), d = d / Math.sqrt(s);
    var z = ad(n, o, h, this.en);
    l = this.a * (this.k0 * d * (1 + v / 6 * (1 - q + m + v / 20 * (5 - 18 * q + M + 14 * m - 58 * q * m + v / 42 * (61 + 179 * M - M * q - 479 * q))))) + this.x0, a = this.a * (this.k0 * (z - this.ml0 + o * i * d / 2 * (1 + v / 12 * (5 - q + 9 * m + 4 * p + v / 30 * (61 + M - 58 * q + 270 * m - 330 * q * m + v / 56 * (1385 + 543 * M - M * q - 3111 * q)))))) + this.y0;
  } else {
    var u = h * Math.sin(i);
    if (Math.abs(Math.abs(u) - 1) < I2)
      return 93;
    if (l = 0.5 * this.a * this.k0 * Math.log((1 + u) / (1 - u)) + this.x0, a = h * Math.cos(i) / Math.sqrt(1 - Math.pow(u, 2)), u = Math.abs(a), u >= 1) {
      if (u - 1 > I2)
        return 93;
      a = 0;
    } else
      a = Math.acos(a);
    n < 0 && (a = -a), a = this.a * this.k0 * (a - this.lat0) + this.y0;
  }
  return t.x = l, t.y = a, t;
}
function Bb1(t) {
  var e, n, i, s, l = (t.x - this.x0) * (1 / this.a), a = (t.y - this.y0) * (1 / this.a);
  if (this.es)
    if (e = this.ml0 + a / this.k0, n = Sk(e, this.es, this.en), Math.abs(n) < h2) {
      var v = Math.sin(n), m = Math.cos(n), p = Math.abs(m) > I2 ? Math.tan(n) : 0, _ = this.ep2 * Math.pow(m, 2), q = Math.pow(_, 2), M = Math.pow(p, 2), z = Math.pow(M, 2);
      e = 1 - this.es * Math.pow(v, 2);
      var b = l * Math.sqrt(e) / this.k0, x = Math.pow(b, 2);
      e = e * p, i = n - e * x / (1 - this.es) * 0.5 * (1 - x / 12 * (5 + 3 * M - 9 * _ * M + _ - 4 * q - x / 30 * (61 + 90 * M - 252 * _ * M + 45 * z + 46 * _ - x / 56 * (1385 + 3633 * M + 4095 * z + 1574 * z * M)))), s = $2(this.long0 + b * (1 - x / 6 * (1 + 2 * M + _ - x / 20 * (5 + 28 * M + 24 * z + 8 * _ * M + 6 * _ - x / 42 * (61 + 662 * M + 1320 * z + 720 * z * M)))) / m);
    } else
      i = h2 * kc(a), s = 0;
  else {
    var o = Math.exp(l / this.k0), h = 0.5 * (o - 1 / o), u = this.lat0 + a / this.k0, d = Math.cos(u);
    e = Math.sqrt((1 - Math.pow(d, 2)) / (1 + Math.pow(h, 2))), i = Math.asin(e), a < 0 && (i = -i), h === 0 && d === 0 ? s = 0 : s = $2(Math.atan2(h, d) + this.long0);
  }
  return t.x = s, t.y = i, t;
}
var Vb1 = ["Fast_Transverse_Mercator", "Fast Transverse Mercator"];
const qh = {
  init: Nb1,
  forward: Pb1,
  inverse: Bb1,
  names: Vb1
};
function Ck(t) {
  var e = Math.exp(t);
  return e = (e - 1 / e) / 2, e;
}
function sn(t, e) {
  t = Math.abs(t), e = Math.abs(e);
  var n = Math.max(t, e), i = Math.min(t, e) / (n || 1);
  return n * Math.sqrt(1 + Math.pow(i, 2));
}
function Rb1(t) {
  var e = 1 + t, n = e - 1;
  return n === 0 ? t : t * Math.log(e) / n;
}
function Hb1(t) {
  var e = Math.abs(t);
  return e = Rb1(e * (1 + e / (sn(1, e) + 1))), t < 0 ? -e : e;
}
function jq(t, e) {
  for (var n = 2 * Math.cos(2 * e), i = t.length - 1, s = t[i], l = 0, a; --i >= 0; )
    a = -l + n * s + t[i], l = s, s = a;
  return e + a * Math.sin(2 * e);
}
function Db1(t, e) {
  for (var n = 2 * Math.cos(e), i = t.length - 1, s = t[i], l = 0, a; --i >= 0; )
    a = -l + n * s + t[i], l = s, s = a;
  return Math.sin(e) * a;
}
function $b1(t) {
  var e = Math.exp(t);
  return e = (e + 1 / e) / 2, e;
}
function kk(t, e, n) {
  for (var i = Math.sin(e), s = Math.cos(e), l = Ck(n), a = $b1(n), o = 2 * s * a, h = -2 * i * l, u = t.length - 1, d = t[u], v = 0, m = 0, p = 0, _, q; --u >= 0; )
    _ = m, q = v, m = d, v = p, d = -_ + o * m - h * v + t[u], p = -q + h * m + o * v;
  return o = i * a, h = s * l, [o * d - h * p, o * p + h * d];
}
function Ub1() {
  if (!this.approx && (isNaN(this.es) || this.es <= 0))
    throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
  this.approx && (qh.init.apply(this), this.forward = qh.forward, this.inverse = qh.inverse), this.x0 = this.x0 !== void 0 ? this.x0 : 0, this.y0 = this.y0 !== void 0 ? this.y0 : 0, this.long0 = this.long0 !== void 0 ? this.long0 : 0, this.lat0 = this.lat0 !== void 0 ? this.lat0 : 0, this.cgb = [], this.cbg = [], this.utg = [], this.gtu = [];
  var t = this.es / (1 + Math.sqrt(1 - this.es)), e = t / (2 - t), n = e;
  this.cgb[0] = e * (2 + e * (-2 / 3 + e * (-2 + e * (116 / 45 + e * (26 / 45 + e * (-2854 / 675)))))), this.cbg[0] = e * (-2 + e * (2 / 3 + e * (4 / 3 + e * (-82 / 45 + e * (32 / 45 + e * (4642 / 4725)))))), n = n * e, this.cgb[1] = n * (7 / 3 + e * (-8 / 5 + e * (-227 / 45 + e * (2704 / 315 + e * (2323 / 945))))), this.cbg[1] = n * (5 / 3 + e * (-16 / 15 + e * (-13 / 9 + e * (904 / 315 + e * (-1522 / 945))))), n = n * e, this.cgb[2] = n * (56 / 15 + e * (-136 / 35 + e * (-1262 / 105 + e * (73814 / 2835)))), this.cbg[2] = n * (-26 / 15 + e * (34 / 21 + e * (8 / 5 + e * (-12686 / 2835)))), n = n * e, this.cgb[3] = n * (4279 / 630 + e * (-332 / 35 + e * (-399572 / 14175))), this.cbg[3] = n * (1237 / 630 + e * (-12 / 5 + e * (-24832 / 14175))), n = n * e, this.cgb[4] = n * (4174 / 315 + e * (-144838 / 6237)), this.cbg[4] = n * (-734 / 315 + e * (109598 / 31185)), n = n * e, this.cgb[5] = n * (601676 / 22275), this.cbg[5] = n * (444337 / 155925), n = Math.pow(e, 2), this.Qn = this.k0 / (1 + e) * (1 + n * (1 / 4 + n * (1 / 64 + n / 256))), this.utg[0] = e * (-0.5 + e * (2 / 3 + e * (-37 / 96 + e * (1 / 360 + e * (81 / 512 + e * (-96199 / 604800)))))), this.gtu[0] = e * (0.5 + e * (-2 / 3 + e * (5 / 16 + e * (41 / 180 + e * (-127 / 288 + e * (7891 / 37800)))))), this.utg[1] = n * (-1 / 48 + e * (-1 / 15 + e * (437 / 1440 + e * (-46 / 105 + e * (1118711 / 3870720))))), this.gtu[1] = n * (13 / 48 + e * (-3 / 5 + e * (557 / 1440 + e * (281 / 630 + e * (-1983433 / 1935360))))), n = n * e, this.utg[2] = n * (-17 / 480 + e * (37 / 840 + e * (209 / 4480 + e * (-5569 / 90720)))), this.gtu[2] = n * (61 / 240 + e * (-103 / 140 + e * (15061 / 26880 + e * (167603 / 181440)))), n = n * e, this.utg[3] = n * (-4397 / 161280 + e * (11 / 504 + e * (830251 / 7257600))), this.gtu[3] = n * (49561 / 161280 + e * (-179 / 168 + e * (6601661 / 7257600))), n = n * e, this.utg[4] = n * (-4583 / 161280 + e * (108847 / 3991680)), this.gtu[4] = n * (34729 / 80640 + e * (-3418889 / 1995840)), n = n * e, this.utg[5] = n * (-20648693 / 638668800), this.gtu[5] = n * (212378941 / 319334400);
  var i = jq(this.cbg, this.lat0);
  this.Zb = -this.Qn * (i + Db1(this.gtu, 2 * i));
}
function jb1(t) {
  var e = $2(t.x - this.long0), n = t.y;
  n = jq(this.cbg, n);
  var i = Math.sin(n), s = Math.cos(n), l = Math.sin(e), a = Math.cos(e);
  n = Math.atan2(i, a * s), e = Math.atan2(l * s, sn(i, s * a)), e = Hb1(Math.tan(e));
  var o = kk(this.gtu, 2 * n, 2 * e);
  n = n + o[0], e = e + o[1];
  var h, u;
  return Math.abs(e) <= 2.623395162778 ? (h = this.a * (this.Qn * e) + this.x0, u = this.a * (this.Qn * n + this.Zb) + this.y0) : (h = 1 / 0, u = 1 / 0), t.x = h, t.y = u, t;
}
function Gb1(t) {
  var e = (t.x - this.x0) * (1 / this.a), n = (t.y - this.y0) * (1 / this.a);
  n = (n - this.Zb) / this.Qn, e = e / this.Qn;
  var i, s;
  if (Math.abs(e) <= 2.623395162778) {
    var l = kk(this.utg, 2 * n, 2 * e);
    n = n + l[0], e = e + l[1], e = Math.atan(Ck(e));
    var a = Math.sin(n), o = Math.cos(n), h = Math.sin(e), u = Math.cos(e);
    n = Math.atan2(a * u, sn(h, u * o)), e = Math.atan2(h, u * o), i = $2(e + this.long0), s = jq(this.cgb, n);
  } else
    i = 1 / 0, s = 1 / 0;
  return t.x = i, t.y = s, t;
}
var Wb1 = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc", "Transverse_Mercator", "Transverse Mercator", "tmerc"];
const wh = {
  init: Ub1,
  forward: jb1,
  inverse: Gb1,
  names: Wb1
};
function Yb1(t, e) {
  if (t === void 0) {
    if (t = Math.floor(($2(e) + Math.PI) * 30 / Math.PI) + 1, t < 0)
      return 0;
    if (t > 60)
      return 60;
  }
  return t;
}
var Xb1 = "etmerc";
function Kb1() {
  var t = Yb1(this.zone, this.long0);
  if (t === void 0)
    throw new Error("unknown utm zone");
  this.lat0 = 0, this.long0 = (6 * Math.abs(t) - 183) * U4, this.x0 = 5e5, this.y0 = this.utmSouth ? 1e7 : 0, this.k0 = 0.9996, wh.init.apply(this), this.forward = wh.forward, this.inverse = wh.inverse;
}
var Zb1 = ["Universal Transverse Mercator System", "utm"];
const Jb1 = {
  init: Kb1,
  names: Zb1,
  dependsOn: Xb1
};
function Gq(t, e) {
  return Math.pow((1 - t) / (1 + t), e);
}
var Qb1 = 20;
function eL1() {
  var t = Math.sin(this.lat0), e = Math.cos(this.lat0);
  e *= e, this.rc = Math.sqrt(1 - this.es) / (1 - this.es * t * t), this.C = Math.sqrt(1 + this.es * e * e / (1 - this.es)), this.phic0 = Math.asin(t / this.C), this.ratexp = 0.5 * this.C * this.e, this.K = Math.tan(0.5 * this.phic0 + Ne) / (Math.pow(Math.tan(0.5 * this.lat0 + Ne), this.C) * Gq(this.e * t, this.ratexp));
}
function tL1(t) {
  var e = t.x, n = t.y;
  return t.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * n + Ne), this.C) * Gq(this.e * Math.sin(n), this.ratexp)) - h2, t.x = this.C * e, t;
}
function nL1(t) {
  for (var e = 1e-14, n = t.x / this.C, i = t.y, s = Math.pow(Math.tan(0.5 * i + Ne) / this.K, 1 / this.C), l = Qb1; l > 0 && (i = 2 * Math.atan(s * Gq(this.e * Math.sin(t.y), -0.5 * this.e)) - h2, !(Math.abs(i - t.y) < e)); --l)
    t.y = i;
  return l ? (t.x = n, t.y = i, t) : null;
}
var iL1 = ["gauss"];
const Wq = {
  init: eL1,
  forward: tL1,
  inverse: nL1,
  names: iL1
};
function sL1() {
  Wq.init.apply(this), this.rc && (this.sinc0 = Math.sin(this.phic0), this.cosc0 = Math.cos(this.phic0), this.R2 = 2 * this.rc, this.title || (this.title = "Oblique Stereographic Alternative"));
}
function lL1(t) {
  var e, n, i, s;
  return t.x = $2(t.x - this.long0), Wq.forward.apply(this, [t]), e = Math.sin(t.y), n = Math.cos(t.y), i = Math.cos(t.x), s = this.k0 * this.R2 / (1 + this.sinc0 * e + this.cosc0 * n * i), t.x = s * n * Math.sin(t.x), t.y = s * (this.cosc0 * e - this.sinc0 * n * i), t.x = this.a * t.x + this.x0, t.y = this.a * t.y + this.y0, t;
}
function rL1(t) {
  var e, n, i, s, l;
  if (t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, t.x /= this.k0, t.y /= this.k0, l = Math.sqrt(t.x * t.x + t.y * t.y)) {
    var a = 2 * Math.atan2(l, this.R2);
    e = Math.sin(a), n = Math.cos(a), s = Math.asin(n * this.sinc0 + t.y * e * this.cosc0 / l), i = Math.atan2(t.x * e, l * this.cosc0 * n - t.y * this.sinc0 * e);
  } else
    s = this.phic0, i = 0;
  return t.x = i, t.y = s, Wq.inverse.apply(this, [t]), t.x = $2(t.x + this.long0), t;
}
var aL1 = ["Stereographic_North_Pole", "Oblique_Stereographic", "sterea", "Oblique Stereographic Alternative", "Double_Stereographic"];
const oL1 = {
  init: sL1,
  forward: lL1,
  inverse: rL1,
  names: aL1
};
function cL1(t, e, n) {
  return e *= n, Math.tan(0.5 * (h2 + t)) * Math.pow((1 - e) / (1 + e), 0.5 * n);
}
function hL1() {
  this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.coslat0 = Math.cos(this.lat0), this.sinlat0 = Math.sin(this.lat0), this.sphere ? this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= I2 && (this.k0 = 0.5 * (1 + kc(this.lat0) * Math.sin(this.lat_ts))) : (Math.abs(this.coslat0) <= I2 && (this.lat0 > 0 ? this.con = 1 : this.con = -1), this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e)), this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= I2 && Math.abs(Math.cos(this.lat_ts)) > I2 && (this.k0 = 0.5 * this.cons * oi(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / un(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts))), this.ms1 = oi(this.e, this.sinlat0, this.coslat0), this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - h2, this.cosX0 = Math.cos(this.X0), this.sinX0 = Math.sin(this.X0));
}
function uL1(t) {
  var e = t.x, n = t.y, i = Math.sin(n), s = Math.cos(n), l, a, o, h, u, d, v = $2(e - this.long0);
  return Math.abs(Math.abs(e - this.long0) - Math.PI) <= I2 && Math.abs(n + this.lat0) <= I2 ? (t.x = NaN, t.y = NaN, t) : this.sphere ? (l = 2 * this.k0 / (1 + this.sinlat0 * i + this.coslat0 * s * Math.cos(v)), t.x = this.a * l * s * Math.sin(v) + this.x0, t.y = this.a * l * (this.coslat0 * i - this.sinlat0 * s * Math.cos(v)) + this.y0, t) : (a = 2 * Math.atan(this.ssfn_(n, i, this.e)) - h2, h = Math.cos(a), o = Math.sin(a), Math.abs(this.coslat0) <= I2 ? (u = un(this.e, n * this.con, this.con * i), d = 2 * this.a * this.k0 * u / this.cons, t.x = this.x0 + d * Math.sin(e - this.long0), t.y = this.y0 - this.con * d * Math.cos(e - this.long0), t) : (Math.abs(this.sinlat0) < I2 ? (l = 2 * this.a * this.k0 / (1 + h * Math.cos(v)), t.y = l * o) : (l = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * o + this.cosX0 * h * Math.cos(v))), t.y = l * (this.cosX0 * o - this.sinX0 * h * Math.cos(v)) + this.y0), t.x = l * h * Math.sin(v) + this.x0, t));
}
function dL1(t) {
  t.x -= this.x0, t.y -= this.y0;
  var e, n, i, s, l, a = Math.sqrt(t.x * t.x + t.y * t.y);
  if (this.sphere) {
    var o = 2 * Math.atan(a / (2 * this.a * this.k0));
    return e = this.long0, n = this.lat0, a <= I2 ? (t.x = e, t.y = n, t) : (n = Math.asin(Math.cos(o) * this.sinlat0 + t.y * Math.sin(o) * this.coslat0 / a), Math.abs(this.coslat0) < I2 ? this.lat0 > 0 ? e = $2(this.long0 + Math.atan2(t.x, -1 * t.y)) : e = $2(this.long0 + Math.atan2(t.x, t.y)) : e = $2(this.long0 + Math.atan2(t.x * Math.sin(o), a * this.coslat0 * Math.cos(o) - t.y * this.sinlat0 * Math.sin(o))), t.x = e, t.y = n, t);
  } else if (Math.abs(this.coslat0) <= I2) {
    if (a <= I2)
      return n = this.lat0, e = this.long0, t.x = e, t.y = n, t;
    t.x *= this.con, t.y *= this.con, i = a * this.cons / (2 * this.a * this.k0), n = this.con * rc(this.e, i), e = this.con * $2(this.con * this.long0 + Math.atan2(t.x, -1 * t.y));
  } else
    s = 2 * Math.atan(a * this.cosX0 / (2 * this.a * this.k0 * this.ms1)), e = this.long0, a <= I2 ? l = this.X0 : (l = Math.asin(Math.cos(s) * this.sinX0 + t.y * Math.sin(s) * this.cosX0 / a), e = $2(this.long0 + Math.atan2(t.x * Math.sin(s), a * this.cosX0 * Math.cos(s) - t.y * this.sinX0 * Math.sin(s)))), n = -1 * rc(this.e, Math.tan(0.5 * (h2 + l)));
  return t.x = e, t.y = n, t;
}
var fL1 = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)", "Polar_Stereographic"];
const vL1 = {
  init: hL1,
  forward: uL1,
  inverse: dL1,
  names: fL1,
  ssfn_: cL1
};
function pL1() {
  var t = this.lat0;
  this.lambda0 = this.long0;
  var e = Math.sin(t), n = this.a, i = this.rf, s = 1 / i, l = 2 * s - Math.pow(s, 2), a = this.e = Math.sqrt(l);
  this.R = this.k0 * n * Math.sqrt(1 - l) / (1 - l * Math.pow(e, 2)), this.alpha = Math.sqrt(1 + l / (1 - l) * Math.pow(Math.cos(t), 4)), this.b0 = Math.asin(e / this.alpha);
  var o = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2)), h = Math.log(Math.tan(Math.PI / 4 + t / 2)), u = Math.log((1 + a * e) / (1 - a * e));
  this.K = o - this.alpha * h + this.alpha * a / 2 * u;
}
function mL1(t) {
  var e = Math.log(Math.tan(Math.PI / 4 - t.y / 2)), n = this.e / 2 * Math.log((1 + this.e * Math.sin(t.y)) / (1 - this.e * Math.sin(t.y))), i = -this.alpha * (e + n) + this.K, s = 2 * (Math.atan(Math.exp(i)) - Math.PI / 4), l = this.alpha * (t.x - this.lambda0), a = Math.atan(Math.sin(l) / (Math.sin(this.b0) * Math.tan(s) + Math.cos(this.b0) * Math.cos(l))), o = Math.asin(Math.cos(this.b0) * Math.sin(s) - Math.sin(this.b0) * Math.cos(s) * Math.cos(l));
  return t.y = this.R / 2 * Math.log((1 + Math.sin(o)) / (1 - Math.sin(o))) + this.y0, t.x = this.R * a + this.x0, t;
}
function gL1(t) {
  for (var e = t.x - this.x0, n = t.y - this.y0, i = e / this.R, s = 2 * (Math.atan(Math.exp(n / this.R)) - Math.PI / 4), l = Math.asin(Math.cos(this.b0) * Math.sin(s) + Math.sin(this.b0) * Math.cos(s) * Math.cos(i)), a = Math.atan(Math.sin(i) / (Math.cos(this.b0) * Math.cos(i) - Math.sin(this.b0) * Math.tan(s))), o = this.lambda0 + a / this.alpha, h = 0, u = l, d = -1e3, v = 0; Math.abs(u - d) > 1e-7; ) {
    if (++v > 20)
      return;
    h = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + l / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(u)) / 2)), d = u, u = 2 * Math.atan(Math.exp(h)) - Math.PI / 2;
  }
  return t.x = o, t.y = u, t;
}
var yL1 = ["somerc"];
const _L1 = {
  init: pL1,
  forward: mL1,
  inverse: gL1,
  names: yL1
};
var ca = 1e-7;
function qL1(t) {
  var e = ["Hotine_Oblique_Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin"], n = typeof t.PROJECTION == "object" ? Object.keys(t.PROJECTION)[0] : t.PROJECTION;
  return "no_uoff" in t || "no_off" in t || e.indexOf(n) !== -1;
}
function wL1() {
  var t, e, n, i, s, l, a, o, h, u, d = 0, v, m = 0, p = 0, _ = 0, q = 0, M = 0, z = 0;
  this.no_off = qL1(this), this.no_rot = "no_rot" in this;
  var b = !1;
  "alpha" in this && (b = !0);
  var x = !1;
  if ("rectified_grid_angle" in this && (x = !0), b && (z = this.alpha), x && (d = this.rectified_grid_angle * U4), b || x)
    m = this.longc;
  else if (p = this.long1, q = this.lat1, _ = this.long2, M = this.lat2, Math.abs(q - M) <= ca || (t = Math.abs(q)) <= ca || Math.abs(t - h2) <= ca || Math.abs(Math.abs(this.lat0) - h2) <= ca || Math.abs(Math.abs(M) - h2) <= ca)
    throw new Error();
  var k = 1 - this.es;
  e = Math.sqrt(k), Math.abs(this.lat0) > I2 ? (o = Math.sin(this.lat0), n = Math.cos(this.lat0), t = 1 - this.es * o * o, this.B = n * n, this.B = Math.sqrt(1 + this.es * this.B * this.B / k), this.A = this.B * this.k0 * e / t, i = this.B * e / (n * Math.sqrt(t)), s = i * i - 1, s <= 0 ? s = 0 : (s = Math.sqrt(s), this.lat0 < 0 && (s = -s)), this.E = s += i, this.E *= Math.pow(un(this.e, this.lat0, o), this.B)) : (this.B = 1 / e, this.A = this.k0, this.E = i = s = 1), b || x ? (b ? (v = Math.asin(Math.sin(z) / i), x || (d = z)) : (v = d, z = Math.asin(i * Math.sin(v))), this.lam0 = m - Math.asin(0.5 * (s - 1 / s) * Math.tan(v)) / this.B) : (l = Math.pow(un(this.e, q, Math.sin(q)), this.B), a = Math.pow(un(this.e, M, Math.sin(M)), this.B), s = this.E / l, h = (a - l) / (a + l), u = this.E * this.E, u = (u - a * l) / (u + a * l), t = p - _, t < -Math.pi ? _ -= sc : t > Math.pi && (_ += sc), this.lam0 = $2(0.5 * (p + _) - Math.atan(u * Math.tan(0.5 * this.B * (p - _)) / h) / this.B), v = Math.atan(2 * Math.sin(this.B * $2(p - this.lam0)) / (s - 1 / s)), d = z = Math.asin(i * Math.sin(v))), this.singam = Math.sin(v), this.cosgam = Math.cos(v), this.sinrot = Math.sin(d), this.cosrot = Math.cos(d), this.rB = 1 / this.B, this.ArB = this.A * this.rB, this.BrA = 1 / this.ArB, this.A * this.B, this.no_off ? this.u_0 = 0 : (this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(i * i - 1) / Math.cos(z))), this.lat0 < 0 && (this.u_0 = -this.u_0)), s = 0.5 * v, this.v_pole_n = this.ArB * Math.log(Math.tan(Ne - s)), this.v_pole_s = this.ArB * Math.log(Math.tan(Ne + s));
}
function zL1(t) {
  var e = {}, n, i, s, l, a, o, h, u;
  if (t.x = t.x - this.lam0, Math.abs(Math.abs(t.y) - h2) > I2) {
    if (a = this.E / Math.pow(un(this.e, t.y, Math.sin(t.y)), this.B), o = 1 / a, n = 0.5 * (a - o), i = 0.5 * (a + o), l = Math.sin(this.B * t.x), s = (n * this.singam - l * this.cosgam) / i, Math.abs(Math.abs(s) - 1) < I2)
      throw new Error();
    u = 0.5 * this.ArB * Math.log((1 - s) / (1 + s)), o = Math.cos(this.B * t.x), Math.abs(o) < ca ? h = this.A * t.x : h = this.ArB * Math.atan2(n * this.cosgam + l * this.singam, o);
  } else
    u = t.y > 0 ? this.v_pole_n : this.v_pole_s, h = this.ArB * t.y;
  return this.no_rot ? (e.x = h, e.y = u) : (h -= this.u_0, e.x = u * this.cosrot + h * this.sinrot, e.y = h * this.cosrot - u * this.sinrot), e.x = this.a * e.x + this.x0, e.y = this.a * e.y + this.y0, e;
}
function ML1(t) {
  var e, n, i, s, l, a, o, h = {};
  if (t.x = (t.x - this.x0) * (1 / this.a), t.y = (t.y - this.y0) * (1 / this.a), this.no_rot ? (n = t.y, e = t.x) : (n = t.x * this.cosrot - t.y * this.sinrot, e = t.y * this.cosrot + t.x * this.sinrot + this.u_0), i = Math.exp(-this.BrA * n), s = 0.5 * (i - 1 / i), l = 0.5 * (i + 1 / i), a = Math.sin(this.BrA * e), o = (a * this.cosgam + s * this.singam) / l, Math.abs(Math.abs(o) - 1) < I2)
    h.x = 0, h.y = o < 0 ? -h2 : h2;
  else {
    if (h.y = this.E / Math.sqrt((1 + o) / (1 - o)), h.y = rc(this.e, Math.pow(h.y, 1 / this.B)), h.y === 1 / 0)
      throw new Error();
    h.x = -this.rB * Math.atan2(s * this.cosgam - a * this.singam, Math.cos(this.BrA * e));
  }
  return h.x += this.lam0, h;
}
var bL1 = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Two_Point_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "Oblique_Mercator", "omerc"];
const LL1 = {
  init: wL1,
  forward: zL1,
  inverse: ML1,
  names: bL1
};
function xL1() {
  if (this.lat2 || (this.lat2 = this.lat1), this.k0 || (this.k0 = 1), this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, !(Math.abs(this.lat1 + this.lat2) < I2)) {
    var t = this.b / this.a;
    this.e = Math.sqrt(1 - t * t);
    var e = Math.sin(this.lat1), n = Math.cos(this.lat1), i = oi(this.e, e, n), s = un(this.e, this.lat1, e), l = Math.sin(this.lat2), a = Math.cos(this.lat2), o = oi(this.e, l, a), h = un(this.e, this.lat2, l), u = un(this.e, this.lat0, Math.sin(this.lat0));
    Math.abs(this.lat1 - this.lat2) > I2 ? this.ns = Math.log(i / o) / Math.log(s / h) : this.ns = e, isNaN(this.ns) && (this.ns = e), this.f0 = i / (this.ns * Math.pow(s, this.ns)), this.rh = this.a * this.f0 * Math.pow(u, this.ns), this.title || (this.title = "Lambert Conformal Conic");
  }
}
function SL1(t) {
  var e = t.x, n = t.y;
  Math.abs(2 * Math.abs(n) - Math.PI) <= I2 && (n = kc(n) * (h2 - 2 * I2));
  var i = Math.abs(Math.abs(n) - h2), s, l;
  if (i > I2)
    s = un(this.e, n, Math.sin(n)), l = this.a * this.f0 * Math.pow(s, this.ns);
  else {
    if (i = n * this.ns, i <= 0)
      return null;
    l = 0;
  }
  var a = this.ns * $2(e - this.long0);
  return t.x = this.k0 * (l * Math.sin(a)) + this.x0, t.y = this.k0 * (this.rh - l * Math.cos(a)) + this.y0, t;
}
function CL1(t) {
  var e, n, i, s, l, a = (t.x - this.x0) / this.k0, o = this.rh - (t.y - this.y0) / this.k0;
  this.ns > 0 ? (e = Math.sqrt(a * a + o * o), n = 1) : (e = -Math.sqrt(a * a + o * o), n = -1);
  var h = 0;
  if (e !== 0 && (h = Math.atan2(n * a, n * o)), e !== 0 || this.ns > 0) {
    if (n = 1 / this.ns, i = Math.pow(e / (this.a * this.f0), n), s = rc(this.e, i), s === -9999)
      return null;
  } else
    s = -h2;
  return l = $2(h / this.ns + this.long0), t.x = l, t.y = s, t;
}
var kL1 = [
  "Lambert Tangential Conformal Conic Projection",
  "Lambert_Conformal_Conic",
  "Lambert_Conformal_Conic_1SP",
  "Lambert_Conformal_Conic_2SP",
  "lcc",
  "Lambert Conic Conformal (1SP)",
  "Lambert Conic Conformal (2SP)"
];
const EL1 = {
  init: xL1,
  forward: SL1,
  inverse: CL1,
  names: kL1
};
function AL1() {
  this.a = 6377397155e-3, this.es = 0.006674372230614, this.e = Math.sqrt(this.es), this.lat0 || (this.lat0 = 0.863937979737193), this.long0 || (this.long0 = 0.7417649320975901 - 0.308341501185665), this.k0 || (this.k0 = 0.9999), this.s45 = 0.785398163397448, this.s90 = 2 * this.s45, this.fi0 = this.lat0, this.e2 = this.es, this.e = Math.sqrt(this.e2), this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2)), this.uq = 1.04216856380474, this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa), this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2), this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g, this.k1 = this.k0, this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2)), this.s0 = 1.37008346281555, this.n = Math.sin(this.s0), this.ro0 = this.k1 * this.n0 / Math.tan(this.s0), this.ad = this.s90 - this.uq;
}
function FL1(t) {
  var e, n, i, s, l, a, o, h = t.x, u = t.y, d = $2(h - this.long0);
  return e = Math.pow((1 + this.e * Math.sin(u)) / (1 - this.e * Math.sin(u)), this.alfa * this.e / 2), n = 2 * (Math.atan(this.k * Math.pow(Math.tan(u / 2 + this.s45), this.alfa) / e) - this.s45), i = -d * this.alfa, s = Math.asin(Math.cos(this.ad) * Math.sin(n) + Math.sin(this.ad) * Math.cos(n) * Math.cos(i)), l = Math.asin(Math.cos(n) * Math.sin(i) / Math.cos(s)), a = this.n * l, o = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n), t.y = o * Math.cos(a) / 1, t.x = o * Math.sin(a) / 1, this.czech || (t.y *= -1, t.x *= -1), t;
}
function TL1(t) {
  var e, n, i, s, l, a, o, h, u = t.x;
  t.x = t.y, t.y = u, this.czech || (t.y *= -1, t.x *= -1), a = Math.sqrt(t.x * t.x + t.y * t.y), l = Math.atan2(t.y, t.x), s = l / Math.sin(this.s0), i = 2 * (Math.atan(Math.pow(this.ro0 / a, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45), e = Math.asin(Math.cos(this.ad) * Math.sin(i) - Math.sin(this.ad) * Math.cos(i) * Math.cos(s)), n = Math.asin(Math.cos(i) * Math.sin(s) / Math.cos(e)), t.x = this.long0 - n / this.alfa, o = e, h = 0;
  var d = 0;
  do
    t.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(e / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(o)) / (1 - this.e * Math.sin(o)), this.e / 2)) - this.s45), Math.abs(o - t.y) < 1e-10 && (h = 1), o = t.y, d += 1;
  while (h === 0 && d < 15);
  return d >= 15 ? null : t;
}
var IL1 = ["Krovak", "krovak"];
const OL1 = {
  init: AL1,
  forward: FL1,
  inverse: TL1,
  names: IL1
};
function B5(t, e, n, i, s) {
  return t * s - e * Math.sin(2 * s) + n * Math.sin(4 * s) - i * Math.sin(6 * s);
}
function Ec(t) {
  return 1 - 0.25 * t * (1 + t / 16 * (3 + 1.25 * t));
}
function Ac(t) {
  return 0.375 * t * (1 + 0.25 * t * (1 + 0.46875 * t));
}
function Fc(t) {
  return 0.05859375 * t * t * (1 + 0.75 * t);
}
function Tc(t) {
  return t * t * t * (35 / 3072);
}
function Za(t, e, n) {
  var i = e * n;
  return t / Math.sqrt(1 - i * i);
}
function a9(t) {
  return Math.abs(t) < h2 ? t : t - kc(t) * Math.PI;
}
function hu(t, e, n, i, s) {
  var l, a;
  l = t / e;
  for (var o = 0; o < 15; o++)
    if (a = (t - (e * l - n * Math.sin(2 * l) + i * Math.sin(4 * l) - s * Math.sin(6 * l))) / (e - 2 * n * Math.cos(2 * l) + 4 * i * Math.cos(4 * l) - 6 * s * Math.cos(6 * l)), l += a, Math.abs(a) <= 1e-10)
      return l;
  return NaN;
}
function NL1() {
  this.sphere || (this.e0 = Ec(this.es), this.e1 = Ac(this.es), this.e2 = Fc(this.es), this.e3 = Tc(this.es), this.ml0 = this.a * B5(this.e0, this.e1, this.e2, this.e3, this.lat0));
}
function PL1(t) {
  var e, n, i = t.x, s = t.y;
  if (i = $2(i - this.long0), this.sphere)
    e = this.a * Math.asin(Math.cos(s) * Math.sin(i)), n = this.a * (Math.atan2(Math.tan(s), Math.cos(i)) - this.lat0);
  else {
    var l = Math.sin(s), a = Math.cos(s), o = Za(this.a, this.e, l), h = Math.tan(s) * Math.tan(s), u = i * Math.cos(s), d = u * u, v = this.es * a * a / (1 - this.es), m = this.a * B5(this.e0, this.e1, this.e2, this.e3, s);
    e = o * u * (1 - d * h * (1 / 6 - (8 - h + 8 * v) * d / 120)), n = m - this.ml0 + o * l / a * d * (0.5 + (5 - h + 6 * v) * d / 24);
  }
  return t.x = e + this.x0, t.y = n + this.y0, t;
}
function BL1(t) {
  t.x -= this.x0, t.y -= this.y0;
  var e = t.x / this.a, n = t.y / this.a, i, s;
  if (this.sphere) {
    var l = n + this.lat0;
    i = Math.asin(Math.sin(l) * Math.cos(e)), s = Math.atan2(Math.tan(e), Math.cos(l));
  } else {
    var a = this.ml0 / this.a + n, o = hu(a, this.e0, this.e1, this.e2, this.e3);
    if (Math.abs(Math.abs(o) - h2) <= I2)
      return t.x = this.long0, t.y = h2, n < 0 && (t.y *= -1), t;
    var h = Za(this.a, this.e, Math.sin(o)), u = h * h * h / this.a / this.a * (1 - this.es), d = Math.pow(Math.tan(o), 2), v = e * this.a / h, m = v * v;
    i = o - h * Math.tan(o) / u * v * v * (0.5 - (1 + 3 * d) * v * v / 24), s = v * (1 - m * (d / 3 + (1 + 3 * d) * d * m / 15)) / Math.cos(o);
  }
  return t.x = $2(s + this.long0), t.y = a9(i), t;
}
var VL1 = ["Cassini", "Cassini_Soldner", "cass"];
const RL1 = {
  init: NL1,
  forward: PL1,
  inverse: BL1,
  names: VL1
};
function ks(t, e) {
  var n;
  return t > 1e-7 ? (n = t * e, (1 - t * t) * (e / (1 - n * n) - 0.5 / t * Math.log((1 - n) / (1 + n)))) : 2 * e;
}
var HL1 = 1, DL1 = 2, $L1 = 3, UL1 = 4;
function jL1() {
  var t = Math.abs(this.lat0);
  if (Math.abs(t - h2) < I2 ? this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE : Math.abs(t) < I2 ? this.mode = this.EQUIT : this.mode = this.OBLIQ, this.es > 0) {
    var e;
    switch (this.qp = ks(this.e, 1), this.mmf = 0.5 / (1 - this.es), this.apa = ex1(this.es), this.mode) {
      case this.N_POLE:
        this.dd = 1;
        break;
      case this.S_POLE:
        this.dd = 1;
        break;
      case this.EQUIT:
        this.rq = Math.sqrt(0.5 * this.qp), this.dd = 1 / this.rq, this.xmf = 1, this.ymf = 0.5 * this.qp;
        break;
      case this.OBLIQ:
        this.rq = Math.sqrt(0.5 * this.qp), e = Math.sin(this.lat0), this.sinb1 = ks(this.e, e) / this.qp, this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1), this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * e * e) * this.rq * this.cosb1), this.ymf = (this.xmf = this.rq) / this.dd, this.xmf *= this.dd;
        break;
    }
  } else
    this.mode === this.OBLIQ && (this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0));
}
function GL1(t) {
  var e, n, i, s, l, a, o, h, u, d, v = t.x, m = t.y;
  if (v = $2(v - this.long0), this.sphere) {
    if (l = Math.sin(m), d = Math.cos(m), i = Math.cos(v), this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      if (n = this.mode === this.EQUIT ? 1 + d * i : 1 + this.sinph0 * l + this.cosph0 * d * i, n <= I2)
        return null;
      n = Math.sqrt(2 / n), e = n * d * Math.sin(v), n *= this.mode === this.EQUIT ? l : this.cosph0 * l - this.sinph0 * d * i;
    } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE && (i = -i), Math.abs(m + this.lat0) < I2)
        return null;
      n = Ne - m * 0.5, n = 2 * (this.mode === this.S_POLE ? Math.cos(n) : Math.sin(n)), e = n * Math.sin(v), n *= i;
    }
  } else {
    switch (o = 0, h = 0, u = 0, i = Math.cos(v), s = Math.sin(v), l = Math.sin(m), a = ks(this.e, l), (this.mode === this.OBLIQ || this.mode === this.EQUIT) && (o = a / this.qp, h = Math.sqrt(1 - o * o)), this.mode) {
      case this.OBLIQ:
        u = 1 + this.sinb1 * o + this.cosb1 * h * i;
        break;
      case this.EQUIT:
        u = 1 + h * i;
        break;
      case this.N_POLE:
        u = h2 + m, a = this.qp - a;
        break;
      case this.S_POLE:
        u = m - h2, a = this.qp + a;
        break;
    }
    if (Math.abs(u) < I2)
      return null;
    switch (this.mode) {
      case this.OBLIQ:
      case this.EQUIT:
        u = Math.sqrt(2 / u), this.mode === this.OBLIQ ? n = this.ymf * u * (this.cosb1 * o - this.sinb1 * h * i) : n = (u = Math.sqrt(2 / (1 + h * i))) * o * this.ymf, e = this.xmf * u * h * s;
        break;
      case this.N_POLE:
      case this.S_POLE:
        a >= 0 ? (e = (u = Math.sqrt(a)) * s, n = i * (this.mode === this.S_POLE ? u : -u)) : e = n = 0;
        break;
    }
  }
  return t.x = this.a * e + this.x0, t.y = this.a * n + this.y0, t;
}
function WL1(t) {
  t.x -= this.x0, t.y -= this.y0;
  var e = t.x / this.a, n = t.y / this.a, i, s, l, a, o, h, u;
  if (this.sphere) {
    var d = 0, v, m = 0;
    if (v = Math.sqrt(e * e + n * n), s = v * 0.5, s > 1)
      return null;
    switch (s = 2 * Math.asin(s), (this.mode === this.OBLIQ || this.mode === this.EQUIT) && (m = Math.sin(s), d = Math.cos(s)), this.mode) {
      case this.EQUIT:
        s = Math.abs(v) <= I2 ? 0 : Math.asin(n * m / v), e *= m, n = d * v;
        break;
      case this.OBLIQ:
        s = Math.abs(v) <= I2 ? this.lat0 : Math.asin(d * this.sinph0 + n * m * this.cosph0 / v), e *= m * this.cosph0, n = (d - Math.sin(s) * this.sinph0) * v;
        break;
      case this.N_POLE:
        n = -n, s = h2 - s;
        break;
      case this.S_POLE:
        s -= h2;
        break;
    }
    i = n === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(e, n);
  } else {
    if (u = 0, this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      if (e /= this.dd, n *= this.dd, h = Math.sqrt(e * e + n * n), h < I2)
        return t.x = this.long0, t.y = this.lat0, t;
      a = 2 * Math.asin(0.5 * h / this.rq), l = Math.cos(a), e *= a = Math.sin(a), this.mode === this.OBLIQ ? (u = l * this.sinb1 + n * a * this.cosb1 / h, o = this.qp * u, n = h * this.cosb1 * l - n * this.sinb1 * a) : (u = n * a / h, o = this.qp * u, n = h * l);
    } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE && (n = -n), o = e * e + n * n, !o)
        return t.x = this.long0, t.y = this.lat0, t;
      u = 1 - o / this.qp, this.mode === this.S_POLE && (u = -u);
    }
    i = Math.atan2(e, n), s = tx1(Math.asin(u), this.apa);
  }
  return t.x = $2(this.long0 + i), t.y = s, t;
}
var YL1 = 0.3333333333333333, XL1 = 0.17222222222222222, KL1 = 0.10257936507936508, ZL1 = 0.06388888888888888, JL1 = 0.0664021164021164, QL1 = 0.016415012942191543;
function ex1(t) {
  var e, n = [];
  return n[0] = t * YL1, e = t * t, n[0] += e * XL1, n[1] = e * ZL1, e *= t, n[0] += e * KL1, n[1] += e * JL1, n[2] = e * QL1, n;
}
function tx1(t, e) {
  var n = t + t;
  return t + e[0] * Math.sin(n) + e[1] * Math.sin(n + n) + e[2] * Math.sin(n + n + n);
}
var nx1 = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
const ix1 = {
  init: jL1,
  forward: GL1,
  inverse: WL1,
  names: nx1,
  S_POLE: HL1,
  N_POLE: DL1,
  EQUIT: $L1,
  OBLIQ: UL1
};
function Bs(t) {
  return Math.abs(t) > 1 && (t = t > 1 ? 1 : -1), Math.asin(t);
}
function sx1() {
  Math.abs(this.lat1 + this.lat2) < I2 || (this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e3 = Math.sqrt(this.es), this.sin_po = Math.sin(this.lat1), this.cos_po = Math.cos(this.lat1), this.t1 = this.sin_po, this.con = this.sin_po, this.ms1 = oi(this.e3, this.sin_po, this.cos_po), this.qs1 = ks(this.e3, this.sin_po), this.sin_po = Math.sin(this.lat2), this.cos_po = Math.cos(this.lat2), this.t2 = this.sin_po, this.ms2 = oi(this.e3, this.sin_po, this.cos_po), this.qs2 = ks(this.e3, this.sin_po), this.sin_po = Math.sin(this.lat0), this.cos_po = Math.cos(this.lat0), this.t3 = this.sin_po, this.qs0 = ks(this.e3, this.sin_po), Math.abs(this.lat1 - this.lat2) > I2 ? this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1) : this.ns0 = this.con, this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1, this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0);
}
function lx1(t) {
  var e = t.x, n = t.y;
  this.sin_phi = Math.sin(n), this.cos_phi = Math.cos(n);
  var i = ks(this.e3, this.sin_phi), s = this.a * Math.sqrt(this.c - this.ns0 * i) / this.ns0, l = this.ns0 * $2(e - this.long0), a = s * Math.sin(l) + this.x0, o = this.rh - s * Math.cos(l) + this.y0;
  return t.x = a, t.y = o, t;
}
function rx1(t) {
  var e, n, i, s, l, a;
  return t.x -= this.x0, t.y = this.rh - t.y + this.y0, this.ns0 >= 0 ? (e = Math.sqrt(t.x * t.x + t.y * t.y), i = 1) : (e = -Math.sqrt(t.x * t.x + t.y * t.y), i = -1), s = 0, e !== 0 && (s = Math.atan2(i * t.x, i * t.y)), i = e * this.ns0 / this.a, this.sphere ? a = Math.asin((this.c - i * i) / (2 * this.ns0)) : (n = (this.c - i * i) / this.ns0, a = this.phi1z(this.e3, n)), l = $2(s / this.ns0 + this.long0), t.x = l, t.y = a, t;
}
function ax1(t, e) {
  var n, i, s, l, a, o = Bs(0.5 * e);
  if (t < I2)
    return o;
  for (var h = t * t, u = 1; u <= 25; u++)
    if (n = Math.sin(o), i = Math.cos(o), s = t * n, l = 1 - s * s, a = 0.5 * l * l / i * (e / (1 - h) - n / l + 0.5 / t * Math.log((1 - s) / (1 + s))), o = o + a, Math.abs(a) <= 1e-7)
      return o;
  return null;
}
var ox1 = ["Albers_Conic_Equal_Area", "Albers", "aea"];
const cx1 = {
  init: sx1,
  forward: lx1,
  inverse: rx1,
  names: ox1,
  phi1z: ax1
};
function hx1() {
  this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0), this.infinity_dist = 1e3 * this.a, this.rc = 1;
}
function ux1(t) {
  var e, n, i, s, l, a, o, h, u = t.x, d = t.y;
  return i = $2(u - this.long0), e = Math.sin(d), n = Math.cos(d), s = Math.cos(i), a = this.sin_p14 * e + this.cos_p14 * n * s, l = 1, a > 0 || Math.abs(a) <= I2 ? (o = this.x0 + this.a * l * n * Math.sin(i) / a, h = this.y0 + this.a * l * (this.cos_p14 * e - this.sin_p14 * n * s) / a) : (o = this.x0 + this.infinity_dist * n * Math.sin(i), h = this.y0 + this.infinity_dist * (this.cos_p14 * e - this.sin_p14 * n * s)), t.x = o, t.y = h, t;
}
function dx1(t) {
  var e, n, i, s, l, a;
  return t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, t.x /= this.k0, t.y /= this.k0, (e = Math.sqrt(t.x * t.x + t.y * t.y)) ? (s = Math.atan2(e, this.rc), n = Math.sin(s), i = Math.cos(s), a = Bs(i * this.sin_p14 + t.y * n * this.cos_p14 / e), l = Math.atan2(t.x * n, e * this.cos_p14 * i - t.y * this.sin_p14 * n), l = $2(this.long0 + l)) : (a = this.phic0, l = 0), t.x = l, t.y = a, t;
}
var fx1 = ["gnom"];
const vx1 = {
  init: hx1,
  forward: ux1,
  inverse: dx1,
  names: fx1
};
function px1(t, e) {
  var n = 1 - (1 - t * t) / (2 * t) * Math.log((1 - t) / (1 + t));
  if (Math.abs(Math.abs(e) - n) < 1e-6)
    return e < 0 ? -1 * h2 : h2;
  for (var i = Math.asin(0.5 * e), s, l, a, o, h = 0; h < 30; h++)
    if (l = Math.sin(i), a = Math.cos(i), o = t * l, s = Math.pow(1 - o * o, 2) / (2 * a) * (e / (1 - t * t) - l / (1 - o * o) + 0.5 / t * Math.log((1 - o) / (1 + o))), i += s, Math.abs(s) <= 1e-10)
      return i;
  return NaN;
}
function mx1() {
  this.sphere || (this.k0 = oi(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)));
}
function gx1(t) {
  var e = t.x, n = t.y, i, s, l = $2(e - this.long0);
  if (this.sphere)
    i = this.x0 + this.a * l * Math.cos(this.lat_ts), s = this.y0 + this.a * Math.sin(n) / Math.cos(this.lat_ts);
  else {
    var a = ks(this.e, Math.sin(n));
    i = this.x0 + this.a * this.k0 * l, s = this.y0 + this.a * a * 0.5 / this.k0;
  }
  return t.x = i, t.y = s, t;
}
function yx1(t) {
  t.x -= this.x0, t.y -= this.y0;
  var e, n;
  return this.sphere ? (e = $2(this.long0 + t.x / this.a / Math.cos(this.lat_ts)), n = Math.asin(t.y / this.a * Math.cos(this.lat_ts))) : (n = px1(this.e, 2 * t.y * this.k0 / this.a), e = $2(this.long0 + t.x / (this.a * this.k0))), t.x = e, t.y = n, t;
}
var _x1 = ["cea"];
const qx1 = {
  init: mx1,
  forward: gx1,
  inverse: yx1,
  names: _x1
};
function wx1() {
  this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Equidistant Cylindrical (Plate Carre)", this.rc = Math.cos(this.lat_ts);
}
function zx1(t) {
  var e = t.x, n = t.y, i = $2(e - this.long0), s = a9(n - this.lat0);
  return t.x = this.x0 + this.a * i * this.rc, t.y = this.y0 + this.a * s, t;
}
function Mx1(t) {
  var e = t.x, n = t.y;
  return t.x = $2(this.long0 + (e - this.x0) / (this.a * this.rc)), t.y = a9(this.lat0 + (n - this.y0) / this.a), t;
}
var bx1 = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
const Lx1 = {
  init: wx1,
  forward: zx1,
  inverse: Mx1,
  names: bx1
};
var IM = 20;
function xx1() {
  this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = Ec(this.es), this.e1 = Ac(this.es), this.e2 = Fc(this.es), this.e3 = Tc(this.es), this.ml0 = this.a * B5(this.e0, this.e1, this.e2, this.e3, this.lat0);
}
function Sx1(t) {
  var e = t.x, n = t.y, i, s, l, a = $2(e - this.long0);
  if (l = a * Math.sin(n), this.sphere)
    Math.abs(n) <= I2 ? (i = this.a * a, s = -1 * this.a * this.lat0) : (i = this.a * Math.sin(l) / Math.tan(n), s = this.a * (a9(n - this.lat0) + (1 - Math.cos(l)) / Math.tan(n)));
  else if (Math.abs(n) <= I2)
    i = this.a * a, s = -1 * this.ml0;
  else {
    var o = Za(this.a, this.e, Math.sin(n)) / Math.tan(n);
    i = o * Math.sin(l), s = this.a * B5(this.e0, this.e1, this.e2, this.e3, n) - this.ml0 + o * (1 - Math.cos(l));
  }
  return t.x = i + this.x0, t.y = s + this.y0, t;
}
function Cx1(t) {
  var e, n, i, s, l, a, o, h, u;
  if (i = t.x - this.x0, s = t.y - this.y0, this.sphere)
    if (Math.abs(s + this.a * this.lat0) <= I2)
      e = $2(i / this.a + this.long0), n = 0;
    else {
      a = this.lat0 + s / this.a, o = i * i / this.a / this.a + a * a, h = a;
      var d;
      for (l = IM; l; --l)
        if (d = Math.tan(h), u = -1 * (a * (h * d + 1) - h - 0.5 * (h * h + o) * d) / ((h - a) / d - 1), h += u, Math.abs(u) <= I2) {
          n = h;
          break;
        }
      e = $2(this.long0 + Math.asin(i * Math.tan(h) / this.a) / Math.sin(n));
    }
  else if (Math.abs(s + this.ml0) <= I2)
    n = 0, e = $2(this.long0 + i / this.a);
  else {
    a = (this.ml0 + s) / this.a, o = i * i / this.a / this.a + a * a, h = a;
    var v, m, p, _, q;
    for (l = IM; l; --l)
      if (q = this.e * Math.sin(h), v = Math.sqrt(1 - q * q) * Math.tan(h), m = this.a * B5(this.e0, this.e1, this.e2, this.e3, h), p = this.e0 - 2 * this.e1 * Math.cos(2 * h) + 4 * this.e2 * Math.cos(4 * h) - 6 * this.e3 * Math.cos(6 * h), _ = m / this.a, u = (a * (v * _ + 1) - _ - 0.5 * v * (_ * _ + o)) / (this.es * Math.sin(2 * h) * (_ * _ + o - 2 * a * _) / (4 * v) + (a - _) * (v * p - 2 / Math.sin(2 * h)) - p), h -= u, Math.abs(u) <= I2) {
        n = h;
        break;
      }
    v = Math.sqrt(1 - this.es * Math.pow(Math.sin(n), 2)) * Math.tan(n), e = $2(this.long0 + Math.asin(i * v / this.a) / Math.sin(n));
  }
  return t.x = e, t.y = n, t;
}
var kx1 = ["Polyconic", "poly"];
const Ex1 = {
  init: xx1,
  forward: Sx1,
  inverse: Cx1,
  names: kx1
};
function Ax1() {
  this.A = [], this.A[1] = 0.6399175073, this.A[2] = -0.1358797613, this.A[3] = 0.063294409, this.A[4] = -0.02526853, this.A[5] = 0.0117879, this.A[6] = -55161e-7, this.A[7] = 26906e-7, this.A[8] = -1333e-6, this.A[9] = 67e-5, this.A[10] = -34e-5, this.B_re = [], this.B_im = [], this.B_re[1] = 0.7557853228, this.B_im[1] = 0, this.B_re[2] = 0.249204646, this.B_im[2] = 3371507e-9, this.B_re[3] = -1541739e-9, this.B_im[3] = 0.04105856, this.B_re[4] = -0.10162907, this.B_im[4] = 0.01727609, this.B_re[5] = -0.26623489, this.B_im[5] = -0.36249218, this.B_re[6] = -0.6870983, this.B_im[6] = -1.1651967, this.C_re = [], this.C_im = [], this.C_re[1] = 1.3231270439, this.C_im[1] = 0, this.C_re[2] = -0.577245789, this.C_im[2] = -7809598e-9, this.C_re[3] = 0.508307513, this.C_im[3] = -0.112208952, this.C_re[4] = -0.15094762, this.C_im[4] = 0.18200602, this.C_re[5] = 1.01418179, this.C_im[5] = 1.64497696, this.C_re[6] = 1.9660549, this.C_im[6] = 2.5127645, this.D = [], this.D[1] = 1.5627014243, this.D[2] = 0.5185406398, this.D[3] = -0.03333098, this.D[4] = -0.1052906, this.D[5] = -0.0368594, this.D[6] = 7317e-6, this.D[7] = 0.0122, this.D[8] = 394e-5, this.D[9] = -13e-4;
}
function Fx1(t) {
  var e, n = t.x, i = t.y, s = i - this.lat0, l = n - this.long0, a = s / Co * 1e-5, o = l, h = 1, u = 0;
  for (e = 1; e <= 10; e++)
    h = h * a, u = u + this.A[e] * h;
  var d = u, v = o, m = 1, p = 0, _, q, M = 0, z = 0;
  for (e = 1; e <= 6; e++)
    _ = m * d - p * v, q = p * d + m * v, m = _, p = q, M = M + this.B_re[e] * m - this.B_im[e] * p, z = z + this.B_im[e] * m + this.B_re[e] * p;
  return t.x = z * this.a + this.x0, t.y = M * this.a + this.y0, t;
}
function Tx1(t) {
  var e, n = t.x, i = t.y, s = n - this.x0, l = i - this.y0, a = l / this.a, o = s / this.a, h = 1, u = 0, d, v, m = 0, p = 0;
  for (e = 1; e <= 6; e++)
    d = h * a - u * o, v = u * a + h * o, h = d, u = v, m = m + this.C_re[e] * h - this.C_im[e] * u, p = p + this.C_im[e] * h + this.C_re[e] * u;
  for (var _ = 0; _ < this.iterations; _++) {
    var q = m, M = p, z, b, x = a, k = o;
    for (e = 2; e <= 6; e++)
      z = q * m - M * p, b = M * m + q * p, q = z, M = b, x = x + (e - 1) * (this.B_re[e] * q - this.B_im[e] * M), k = k + (e - 1) * (this.B_im[e] * q + this.B_re[e] * M);
    q = 1, M = 0;
    var F = this.B_re[1], D = this.B_im[1];
    for (e = 2; e <= 6; e++)
      z = q * m - M * p, b = M * m + q * p, q = z, M = b, F = F + e * (this.B_re[e] * q - this.B_im[e] * M), D = D + e * (this.B_im[e] * q + this.B_re[e] * M);
    var R = F * F + D * D;
    m = (x * F + k * D) / R, p = (k * F - x * D) / R;
  }
  var V = m, J = p, K = 1, P = 0;
  for (e = 1; e <= 9; e++)
    K = K * V, P = P + this.D[e] * K;
  var O = this.lat0 + P * Co * 1e5, G = this.long0 + J;
  return t.x = G, t.y = O, t;
}
var Ix1 = ["New_Zealand_Map_Grid", "nzmg"];
const Ox1 = {
  init: Ax1,
  forward: Fx1,
  inverse: Tx1,
  names: Ix1
};
function Nx1() {
}
function Px1(t) {
  var e = t.x, n = t.y, i = $2(e - this.long0), s = this.x0 + this.a * i, l = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + n / 2.5)) * 1.25;
  return t.x = s, t.y = l, t;
}
function Bx1(t) {
  t.x -= this.x0, t.y -= this.y0;
  var e = $2(this.long0 + t.x / this.a), n = 2.5 * (Math.atan(Math.exp(0.8 * t.y / this.a)) - Math.PI / 4);
  return t.x = e, t.y = n, t;
}
var Vx1 = ["Miller_Cylindrical", "mill"];
const Rx1 = {
  init: Nx1,
  forward: Px1,
  inverse: Bx1,
  names: Vx1
};
var Hx1 = 20;
function Dx1() {
  this.sphere ? (this.n = 1, this.m = 0, this.es = 0, this.C_y = Math.sqrt((this.m + 1) / this.n), this.C_x = this.C_y / (this.m + 1)) : this.en = xk(this.es);
}
function $x1(t) {
  var e, n, i = t.x, s = t.y;
  if (i = $2(i - this.long0), this.sphere) {
    if (!this.m)
      s = this.n !== 1 ? Math.asin(this.n * Math.sin(s)) : s;
    else
      for (var l = this.n * Math.sin(s), a = Hx1; a; --a) {
        var o = (this.m * s + Math.sin(s) - l) / (this.m + Math.cos(s));
        if (s -= o, Math.abs(o) < I2)
          break;
      }
    e = this.a * this.C_x * i * (this.m + Math.cos(s)), n = this.a * this.C_y * s;
  } else {
    var h = Math.sin(s), u = Math.cos(s);
    n = this.a * ad(s, h, u, this.en), e = this.a * i * u / Math.sqrt(1 - this.es * h * h);
  }
  return t.x = e, t.y = n, t;
}
function Ux1(t) {
  var e, n, i, s;
  return t.x -= this.x0, i = t.x / this.a, t.y -= this.y0, e = t.y / this.a, this.sphere ? (e /= this.C_y, i = i / (this.C_x * (this.m + Math.cos(e))), this.m ? e = Bs((this.m * e + Math.sin(e)) / this.n) : this.n !== 1 && (e = Bs(Math.sin(e) / this.n)), i = $2(i + this.long0), e = a9(e)) : (e = Sk(t.y / this.a, this.es, this.en), s = Math.abs(e), s < h2 ? (s = Math.sin(e), n = this.long0 + t.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(e)), i = $2(n)) : s - I2 < h2 && (i = this.long0)), t.x = i, t.y = e, t;
}
var jx1 = ["Sinusoidal", "sinu"];
const Gx1 = {
  init: Dx1,
  forward: $x1,
  inverse: Ux1,
  names: jx1
};
function Wx1() {
}
function Yx1(t) {
  for (var e = t.x, n = t.y, i = $2(e - this.long0), s = n, l = Math.PI * Math.sin(n); ; ) {
    var a = -(s + Math.sin(s) - l) / (1 + Math.cos(s));
    if (s += a, Math.abs(a) < I2)
      break;
  }
  s /= 2, Math.PI / 2 - Math.abs(n) < I2 && (i = 0);
  var o = 0.900316316158 * this.a * i * Math.cos(s) + this.x0, h = 1.4142135623731 * this.a * Math.sin(s) + this.y0;
  return t.x = o, t.y = h, t;
}
function Xx1(t) {
  var e, n;
  t.x -= this.x0, t.y -= this.y0, n = t.y / (1.4142135623731 * this.a), Math.abs(n) > 0.999999999999 && (n = 0.999999999999), e = Math.asin(n);
  var i = $2(this.long0 + t.x / (0.900316316158 * this.a * Math.cos(e)));
  i < -Math.PI && (i = -Math.PI), i > Math.PI && (i = Math.PI), n = (2 * e + Math.sin(2 * e)) / Math.PI, Math.abs(n) > 1 && (n = 1);
  var s = Math.asin(n);
  return t.x = i, t.y = s, t;
}
var Kx1 = ["Mollweide", "moll"];
const Zx1 = {
  init: Wx1,
  forward: Yx1,
  inverse: Xx1,
  names: Kx1
};
function Jx1() {
  Math.abs(this.lat1 + this.lat2) < I2 || (this.lat2 = this.lat2 || this.lat1, this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = Ec(this.es), this.e1 = Ac(this.es), this.e2 = Fc(this.es), this.e3 = Tc(this.es), this.sinphi = Math.sin(this.lat1), this.cosphi = Math.cos(this.lat1), this.ms1 = oi(this.e, this.sinphi, this.cosphi), this.ml1 = B5(this.e0, this.e1, this.e2, this.e3, this.lat1), Math.abs(this.lat1 - this.lat2) < I2 ? this.ns = this.sinphi : (this.sinphi = Math.sin(this.lat2), this.cosphi = Math.cos(this.lat2), this.ms2 = oi(this.e, this.sinphi, this.cosphi), this.ml2 = B5(this.e0, this.e1, this.e2, this.e3, this.lat2), this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1)), this.g = this.ml1 + this.ms1 / this.ns, this.ml0 = B5(this.e0, this.e1, this.e2, this.e3, this.lat0), this.rh = this.a * (this.g - this.ml0));
}
function Qx1(t) {
  var e = t.x, n = t.y, i;
  if (this.sphere)
    i = this.a * (this.g - n);
  else {
    var s = B5(this.e0, this.e1, this.e2, this.e3, n);
    i = this.a * (this.g - s);
  }
  var l = this.ns * $2(e - this.long0), a = this.x0 + i * Math.sin(l), o = this.y0 + this.rh - i * Math.cos(l);
  return t.x = a, t.y = o, t;
}
function eS1(t) {
  t.x -= this.x0, t.y = this.rh - t.y + this.y0;
  var e, n, i, s;
  this.ns >= 0 ? (n = Math.sqrt(t.x * t.x + t.y * t.y), e = 1) : (n = -Math.sqrt(t.x * t.x + t.y * t.y), e = -1);
  var l = 0;
  if (n !== 0 && (l = Math.atan2(e * t.x, e * t.y)), this.sphere)
    return s = $2(this.long0 + l / this.ns), i = a9(this.g - n / this.a), t.x = s, t.y = i, t;
  var a = this.g - n / this.a;
  return i = hu(a, this.e0, this.e1, this.e2, this.e3), s = $2(this.long0 + l / this.ns), t.x = s, t.y = i, t;
}
var tS1 = ["Equidistant_Conic", "eqdc"];
const nS1 = {
  init: Jx1,
  forward: Qx1,
  inverse: eS1,
  names: tS1
};
function iS1() {
  this.R = this.a;
}
function sS1(t) {
  var e = t.x, n = t.y, i = $2(e - this.long0), s, l;
  Math.abs(n) <= I2 && (s = this.x0 + this.R * i, l = this.y0);
  var a = Bs(2 * Math.abs(n / Math.PI));
  (Math.abs(i) <= I2 || Math.abs(Math.abs(n) - h2) <= I2) && (s = this.x0, n >= 0 ? l = this.y0 + Math.PI * this.R * Math.tan(0.5 * a) : l = this.y0 + Math.PI * this.R * -Math.tan(0.5 * a));
  var o = 0.5 * Math.abs(Math.PI / i - i / Math.PI), h = o * o, u = Math.sin(a), d = Math.cos(a), v = d / (u + d - 1), m = v * v, p = v * (2 / u - 1), _ = p * p, q = Math.PI * this.R * (o * (v - _) + Math.sqrt(h * (v - _) * (v - _) - (_ + h) * (m - _))) / (_ + h);
  i < 0 && (q = -q), s = this.x0 + q;
  var M = h + v;
  return q = Math.PI * this.R * (p * M - o * Math.sqrt((_ + h) * (h + 1) - M * M)) / (_ + h), n >= 0 ? l = this.y0 + q : l = this.y0 - q, t.x = s, t.y = l, t;
}
function lS1(t) {
  var e, n, i, s, l, a, o, h, u, d, v, m, p;
  return t.x -= this.x0, t.y -= this.y0, v = Math.PI * this.R, i = t.x / v, s = t.y / v, l = i * i + s * s, a = -Math.abs(s) * (1 + l), o = a - 2 * s * s + i * i, h = -2 * a + 1 + 2 * s * s + l * l, p = s * s / h + (2 * o * o * o / h / h / h - 9 * a * o / h / h) / 27, u = (a - o * o / 3 / h) / h, d = 2 * Math.sqrt(-u / 3), v = 3 * p / u / d, Math.abs(v) > 1 && (v >= 0 ? v = 1 : v = -1), m = Math.acos(v) / 3, t.y >= 0 ? n = (-d * Math.cos(m + Math.PI / 3) - o / 3 / h) * Math.PI : n = -(-d * Math.cos(m + Math.PI / 3) - o / 3 / h) * Math.PI, Math.abs(i) < I2 ? e = this.long0 : e = $2(this.long0 + Math.PI * (l - 1 + Math.sqrt(1 + 2 * (i * i - s * s) + l * l)) / 2 / i), t.x = e, t.y = n, t;
}
var rS1 = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
const aS1 = {
  init: iS1,
  forward: sS1,
  inverse: lS1,
  names: rS1
};
function oS1() {
  this.sin_p12 = Math.sin(this.lat0), this.cos_p12 = Math.cos(this.lat0);
}
function cS1(t) {
  var e = t.x, n = t.y, i = Math.sin(t.y), s = Math.cos(t.y), l = $2(e - this.long0), a, o, h, u, d, v, m, p, _, q, M, z, b, x, k, F, D, R, V, J, K, P, O;
  return this.sphere ? Math.abs(this.sin_p12 - 1) <= I2 ? (t.x = this.x0 + this.a * (h2 - n) * Math.sin(l), t.y = this.y0 - this.a * (h2 - n) * Math.cos(l), t) : Math.abs(this.sin_p12 + 1) <= I2 ? (t.x = this.x0 + this.a * (h2 + n) * Math.sin(l), t.y = this.y0 + this.a * (h2 + n) * Math.cos(l), t) : (R = this.sin_p12 * i + this.cos_p12 * s * Math.cos(l), F = Math.acos(R), D = F ? F / Math.sin(F) : 1, t.x = this.x0 + this.a * D * s * Math.sin(l), t.y = this.y0 + this.a * D * (this.cos_p12 * i - this.sin_p12 * s * Math.cos(l)), t) : (a = Ec(this.es), o = Ac(this.es), h = Fc(this.es), u = Tc(this.es), Math.abs(this.sin_p12 - 1) <= I2 ? (d = this.a * B5(a, o, h, u, h2), v = this.a * B5(a, o, h, u, n), t.x = this.x0 + (d - v) * Math.sin(l), t.y = this.y0 - (d - v) * Math.cos(l), t) : Math.abs(this.sin_p12 + 1) <= I2 ? (d = this.a * B5(a, o, h, u, h2), v = this.a * B5(a, o, h, u, n), t.x = this.x0 + (d + v) * Math.sin(l), t.y = this.y0 + (d + v) * Math.cos(l), t) : (m = i / s, p = Za(this.a, this.e, this.sin_p12), _ = Za(this.a, this.e, i), q = Math.atan((1 - this.es) * m + this.es * p * this.sin_p12 / (_ * s)), M = Math.atan2(Math.sin(l), this.cos_p12 * Math.tan(q) - this.sin_p12 * Math.cos(l)), M === 0 ? V = Math.asin(this.cos_p12 * Math.sin(q) - this.sin_p12 * Math.cos(q)) : Math.abs(Math.abs(M) - Math.PI) <= I2 ? V = -Math.asin(this.cos_p12 * Math.sin(q) - this.sin_p12 * Math.cos(q)) : V = Math.asin(Math.sin(l) * Math.cos(q) / Math.sin(M)), z = this.e * this.sin_p12 / Math.sqrt(1 - this.es), b = this.e * this.cos_p12 * Math.cos(M) / Math.sqrt(1 - this.es), x = z * b, k = b * b, J = V * V, K = J * V, P = K * V, O = P * V, F = p * V * (1 - J * k * (1 - k) / 6 + K / 8 * x * (1 - 2 * k) + P / 120 * (k * (4 - 7 * k) - 3 * z * z * (1 - 7 * k)) - O / 48 * x), t.x = this.x0 + F * Math.sin(M), t.y = this.y0 + F * Math.cos(M), t));
}
function hS1(t) {
  t.x -= this.x0, t.y -= this.y0;
  var e, n, i, s, l, a, o, h, u, d, v, m, p, _, q, M, z, b, x, k, F, D, R, V;
  return this.sphere ? (e = Math.sqrt(t.x * t.x + t.y * t.y), e > 2 * h2 * this.a ? void 0 : (n = e / this.a, i = Math.sin(n), s = Math.cos(n), l = this.long0, Math.abs(e) <= I2 ? a = this.lat0 : (a = Bs(s * this.sin_p12 + t.y * i * this.cos_p12 / e), o = Math.abs(this.lat0) - h2, Math.abs(o) <= I2 ? this.lat0 >= 0 ? l = $2(this.long0 + Math.atan2(t.x, -t.y)) : l = $2(this.long0 - Math.atan2(-t.x, t.y)) : l = $2(this.long0 + Math.atan2(t.x * i, e * this.cos_p12 * s - t.y * this.sin_p12 * i))), t.x = l, t.y = a, t)) : (h = Ec(this.es), u = Ac(this.es), d = Fc(this.es), v = Tc(this.es), Math.abs(this.sin_p12 - 1) <= I2 ? (m = this.a * B5(h, u, d, v, h2), e = Math.sqrt(t.x * t.x + t.y * t.y), p = m - e, a = hu(p / this.a, h, u, d, v), l = $2(this.long0 + Math.atan2(t.x, -1 * t.y)), t.x = l, t.y = a, t) : Math.abs(this.sin_p12 + 1) <= I2 ? (m = this.a * B5(h, u, d, v, h2), e = Math.sqrt(t.x * t.x + t.y * t.y), p = e - m, a = hu(p / this.a, h, u, d, v), l = $2(this.long0 + Math.atan2(t.x, t.y)), t.x = l, t.y = a, t) : (e = Math.sqrt(t.x * t.x + t.y * t.y), M = Math.atan2(t.x, t.y), _ = Za(this.a, this.e, this.sin_p12), z = Math.cos(M), b = this.e * this.cos_p12 * z, x = -b * b / (1 - this.es), k = 3 * this.es * (1 - x) * this.sin_p12 * this.cos_p12 * z / (1 - this.es), F = e / _, D = F - x * (1 + x) * Math.pow(F, 3) / 6 - k * (1 + 3 * x) * Math.pow(F, 4) / 24, R = 1 - x * D * D / 2 - F * D * D * D / 6, q = Math.asin(this.sin_p12 * Math.cos(D) + this.cos_p12 * Math.sin(D) * z), l = $2(this.long0 + Math.asin(Math.sin(M) * Math.sin(D) / Math.cos(q))), V = Math.sin(q), a = Math.atan2((V - this.es * R * this.sin_p12) * Math.tan(q), V * (1 - this.es)), t.x = l, t.y = a, t));
}
var uS1 = ["Azimuthal_Equidistant", "aeqd"];
const dS1 = {
  init: oS1,
  forward: cS1,
  inverse: hS1,
  names: uS1
};
function fS1() {
  this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0);
}
function vS1(t) {
  var e, n, i, s, l, a, o, h, u = t.x, d = t.y;
  return i = $2(u - this.long0), e = Math.sin(d), n = Math.cos(d), s = Math.cos(i), a = this.sin_p14 * e + this.cos_p14 * n * s, l = 1, (a > 0 || Math.abs(a) <= I2) && (o = this.a * l * n * Math.sin(i), h = this.y0 + this.a * l * (this.cos_p14 * e - this.sin_p14 * n * s)), t.x = o, t.y = h, t;
}
function pS1(t) {
  var e, n, i, s, l, a, o;
  return t.x -= this.x0, t.y -= this.y0, e = Math.sqrt(t.x * t.x + t.y * t.y), n = Bs(e / this.a), i = Math.sin(n), s = Math.cos(n), a = this.long0, Math.abs(e) <= I2 ? (o = this.lat0, t.x = a, t.y = o, t) : (o = Bs(s * this.sin_p14 + t.y * i * this.cos_p14 / e), l = Math.abs(this.lat0) - h2, Math.abs(l) <= I2 ? (this.lat0 >= 0 ? a = $2(this.long0 + Math.atan2(t.x, -t.y)) : a = $2(this.long0 - Math.atan2(-t.x, t.y)), t.x = a, t.y = o, t) : (a = $2(this.long0 + Math.atan2(t.x * i, e * this.cos_p14 * s - t.y * this.sin_p14 * i)), t.x = a, t.y = o, t));
}
var mS1 = ["ortho"];
const gS1 = {
  init: fS1,
  forward: vS1,
  inverse: pS1,
  names: mS1
};
var kt = {
  FRONT: 1,
  RIGHT: 2,
  BACK: 3,
  LEFT: 4,
  TOP: 5,
  BOTTOM: 6
}, Pe = {
  AREA_0: 1,
  AREA_1: 2,
  AREA_2: 3,
  AREA_3: 4
};
function yS1() {
  this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Quadrilateralized Spherical Cube", this.lat0 >= h2 - Ne / 2 ? this.face = kt.TOP : this.lat0 <= -(h2 - Ne / 2) ? this.face = kt.BOTTOM : Math.abs(this.long0) <= Ne ? this.face = kt.FRONT : Math.abs(this.long0) <= h2 + Ne ? this.face = this.long0 > 0 ? kt.RIGHT : kt.LEFT : this.face = kt.BACK, this.es !== 0 && (this.one_minus_f = 1 - (this.a - this.b) / this.a, this.one_minus_f_squared = this.one_minus_f * this.one_minus_f);
}
function _S1(t) {
  var e = { x: 0, y: 0 }, n, i, s, l, a, o, h = { value: 0 };
  if (t.x -= this.long0, this.es !== 0 ? n = Math.atan(this.one_minus_f_squared * Math.tan(t.y)) : n = t.y, i = t.x, this.face === kt.TOP)
    l = h2 - n, i >= Ne && i <= h2 + Ne ? (h.value = Pe.AREA_0, s = i - h2) : i > h2 + Ne || i <= -(h2 + Ne) ? (h.value = Pe.AREA_1, s = i > 0 ? i - Jt : i + Jt) : i > -(h2 + Ne) && i <= -Ne ? (h.value = Pe.AREA_2, s = i + h2) : (h.value = Pe.AREA_3, s = i);
  else if (this.face === kt.BOTTOM)
    l = h2 + n, i >= Ne && i <= h2 + Ne ? (h.value = Pe.AREA_0, s = -i + h2) : i < Ne && i >= -Ne ? (h.value = Pe.AREA_1, s = -i) : i < -Ne && i >= -(h2 + Ne) ? (h.value = Pe.AREA_2, s = -i - h2) : (h.value = Pe.AREA_3, s = i > 0 ? -i + Jt : -i - Jt);
  else {
    var u, d, v, m, p, _, q;
    this.face === kt.RIGHT ? i = Sa(i, +h2) : this.face === kt.BACK ? i = Sa(i, +Jt) : this.face === kt.LEFT && (i = Sa(i, -h2)), m = Math.sin(n), p = Math.cos(n), _ = Math.sin(i), q = Math.cos(i), u = p * q, d = p * _, v = m, this.face === kt.FRONT ? (l = Math.acos(u), s = rh(l, v, d, h)) : this.face === kt.RIGHT ? (l = Math.acos(d), s = rh(l, v, -u, h)) : this.face === kt.BACK ? (l = Math.acos(-u), s = rh(l, v, -d, h)) : this.face === kt.LEFT ? (l = Math.acos(-d), s = rh(l, v, u, h)) : (l = s = 0, h.value = Pe.AREA_0);
  }
  return o = Math.atan(12 / Jt * (s + Math.acos(Math.sin(s) * Math.cos(Ne)) - h2)), a = Math.sqrt((1 - Math.cos(l)) / (Math.cos(o) * Math.cos(o)) / (1 - Math.cos(Math.atan(1 / Math.cos(s))))), h.value === Pe.AREA_1 ? o += h2 : h.value === Pe.AREA_2 ? o += Jt : h.value === Pe.AREA_3 && (o += 1.5 * Jt), e.x = a * Math.cos(o), e.y = a * Math.sin(o), e.x = e.x * this.a + this.x0, e.y = e.y * this.a + this.y0, t.x = e.x, t.y = e.y, t;
}
function qS1(t) {
  var e = { lam: 0, phi: 0 }, n, i, s, l, a, o, h, u, d, v = { value: 0 };
  if (t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, i = Math.atan(Math.sqrt(t.x * t.x + t.y * t.y)), n = Math.atan2(t.y, t.x), t.x >= 0 && t.x >= Math.abs(t.y) ? v.value = Pe.AREA_0 : t.y >= 0 && t.y >= Math.abs(t.x) ? (v.value = Pe.AREA_1, n -= h2) : t.x < 0 && -t.x >= Math.abs(t.y) ? (v.value = Pe.AREA_2, n = n < 0 ? n + Jt : n - Jt) : (v.value = Pe.AREA_3, n += h2), d = Jt / 12 * Math.tan(n), a = Math.sin(d) / (Math.cos(d) - 1 / Math.sqrt(2)), o = Math.atan(a), s = Math.cos(n), l = Math.tan(i), h = 1 - s * s * l * l * (1 - Math.cos(Math.atan(1 / Math.cos(o)))), h < -1 ? h = -1 : h > 1 && (h = 1), this.face === kt.TOP)
    u = Math.acos(h), e.phi = h2 - u, v.value === Pe.AREA_0 ? e.lam = o + h2 : v.value === Pe.AREA_1 ? e.lam = o < 0 ? o + Jt : o - Jt : v.value === Pe.AREA_2 ? e.lam = o - h2 : e.lam = o;
  else if (this.face === kt.BOTTOM)
    u = Math.acos(h), e.phi = u - h2, v.value === Pe.AREA_0 ? e.lam = -o + h2 : v.value === Pe.AREA_1 ? e.lam = -o : v.value === Pe.AREA_2 ? e.lam = -o - h2 : e.lam = o < 0 ? -o - Jt : -o + Jt;
  else {
    var m, p, _;
    m = h, d = m * m, d >= 1 ? _ = 0 : _ = Math.sqrt(1 - d) * Math.sin(o), d += _ * _, d >= 1 ? p = 0 : p = Math.sqrt(1 - d), v.value === Pe.AREA_1 ? (d = p, p = -_, _ = d) : v.value === Pe.AREA_2 ? (p = -p, _ = -_) : v.value === Pe.AREA_3 && (d = p, p = _, _ = -d), this.face === kt.RIGHT ? (d = m, m = -p, p = d) : this.face === kt.BACK ? (m = -m, p = -p) : this.face === kt.LEFT && (d = m, m = p, p = -d), e.phi = Math.acos(-_) - h2, e.lam = Math.atan2(p, m), this.face === kt.RIGHT ? e.lam = Sa(e.lam, -h2) : this.face === kt.BACK ? e.lam = Sa(e.lam, -Jt) : this.face === kt.LEFT && (e.lam = Sa(e.lam, +h2));
  }
  if (this.es !== 0) {
    var q, M, z;
    q = e.phi < 0 ? 1 : 0, M = Math.tan(e.phi), z = this.b / Math.sqrt(M * M + this.one_minus_f_squared), e.phi = Math.atan(Math.sqrt(this.a * this.a - z * z) / (this.one_minus_f * z)), q && (e.phi = -e.phi);
  }
  return e.lam += this.long0, t.x = e.lam, t.y = e.phi, t;
}
function rh(t, e, n, i) {
  var s;
  return t < I2 ? (i.value = Pe.AREA_0, s = 0) : (s = Math.atan2(e, n), Math.abs(s) <= Ne ? i.value = Pe.AREA_0 : s > Ne && s <= h2 + Ne ? (i.value = Pe.AREA_1, s -= h2) : s > h2 + Ne || s <= -(h2 + Ne) ? (i.value = Pe.AREA_2, s = s >= 0 ? s - Jt : s + Jt) : (i.value = Pe.AREA_3, s += h2)), s;
}
function Sa(t, e) {
  var n = t + e;
  return n < -Jt ? n += sc : n > +Jt && (n -= sc), n;
}
var wS1 = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
const zS1 = {
  init: yS1,
  forward: _S1,
  inverse: qS1,
  names: wS1
};
var Uy = [
  [1, 22199e-21, -715515e-10, 31103e-10],
  [0.9986, -482243e-9, -24897e-9, -13309e-10],
  [0.9954, -83103e-8, -448605e-10, -986701e-12],
  [0.99, -135364e-8, -59661e-9, 36777e-10],
  [0.9822, -167442e-8, -449547e-11, -572411e-11],
  [0.973, -214868e-8, -903571e-10, 18736e-12],
  [0.96, -305085e-8, -900761e-10, 164917e-11],
  [0.9427, -382792e-8, -653386e-10, -26154e-10],
  [0.9216, -467746e-8, -10457e-8, 481243e-11],
  [0.8962, -536223e-8, -323831e-10, -543432e-11],
  [0.8679, -609363e-8, -113898e-9, 332484e-11],
  [0.835, -698325e-8, -640253e-10, 934959e-12],
  [0.7986, -755338e-8, -500009e-10, 935324e-12],
  [0.7597, -798324e-8, -35971e-9, -227626e-11],
  [0.7186, -851367e-8, -701149e-10, -86303e-10],
  [0.6732, -986209e-8, -199569e-9, 191974e-10],
  [0.6213, -0.010418, 883923e-10, 624051e-11],
  [0.5722, -906601e-8, 182e-6, 624051e-11],
  [0.5322, -677797e-8, 275608e-9, 624051e-11]
], go = [
  [-520417e-23, 0.0124, 121431e-23, -845284e-16],
  [0.062, 0.0124, -126793e-14, 422642e-15],
  [0.124, 0.0124, 507171e-14, -160604e-14],
  [0.186, 0.0123999, -190189e-13, 600152e-14],
  [0.248, 0.0124002, 710039e-13, -224e-10],
  [0.31, 0.0123992, -264997e-12, 835986e-13],
  [0.372, 0.0124029, 988983e-12, -311994e-12],
  [0.434, 0.0123893, -369093e-11, -435621e-12],
  [0.4958, 0.0123198, -102252e-10, -345523e-12],
  [0.5571, 0.0121916, -154081e-10, -582288e-12],
  [0.6176, 0.0119938, -241424e-10, -525327e-12],
  [0.6769, 0.011713, -320223e-10, -516405e-12],
  [0.7346, 0.0113541, -397684e-10, -609052e-12],
  [0.7903, 0.0109107, -489042e-10, -104739e-11],
  [0.8435, 0.0103431, -64615e-9, -140374e-14],
  [0.8936, 969686e-8, -64636e-9, -8547e-9],
  [0.9394, 840947e-8, -192841e-9, -42106e-10],
  [0.9761, 616527e-8, -256e-6, -42106e-10],
  [1, 328947e-8, -319159e-9, -42106e-10]
], Ek = 0.8487, Ak = 1.3523, Fk = Kn / 5, MS1 = 1 / Fk, qa = 18, uu = function(t, e) {
  return t[0] + e * (t[1] + e * (t[2] + e * t[3]));
}, bS1 = function(t, e) {
  return t[1] + e * (2 * t[2] + e * 3 * t[3]);
};
function LS1(t, e, n, i) {
  for (var s = e; i; --i) {
    var l = t(s);
    if (s -= l, Math.abs(l) < n)
      break;
  }
  return s;
}
function xS1() {
  this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.long0 = this.long0 || 0, this.es = 0, this.title = this.title || "Robinson";
}
function SS1(t) {
  var e = $2(t.x - this.long0), n = Math.abs(t.y), i = Math.floor(n * Fk);
  i < 0 ? i = 0 : i >= qa && (i = qa - 1), n = Kn * (n - MS1 * i);
  var s = {
    x: uu(Uy[i], n) * e,
    y: uu(go[i], n)
  };
  return t.y < 0 && (s.y = -s.y), s.x = s.x * this.a * Ek + this.x0, s.y = s.y * this.a * Ak + this.y0, s;
}
function CS1(t) {
  var e = {
    x: (t.x - this.x0) / (this.a * Ek),
    y: Math.abs(t.y - this.y0) / (this.a * Ak)
  };
  if (e.y >= 1)
    e.x /= Uy[qa][0], e.y = t.y < 0 ? -h2 : h2;
  else {
    var n = Math.floor(e.y * qa);
    for (n < 0 ? n = 0 : n >= qa && (n = qa - 1); ; )
      if (go[n][0] > e.y)
        --n;
      else if (go[n + 1][0] <= e.y)
        ++n;
      else
        break;
    var i = go[n], s = 5 * (e.y - i[0]) / (go[n + 1][0] - i[0]);
    s = LS1(function(l) {
      return (uu(i, l) - e.y) / bS1(i, l);
    }, s, I2, 100), e.x /= uu(Uy[n], s), e.y = (5 * n + s) * U4, t.y < 0 && (e.y = -e.y);
  }
  return e.x = $2(e.x + this.long0), e;
}
var kS1 = ["Robinson", "robin"];
const ES1 = {
  init: xS1,
  forward: SS1,
  inverse: CS1,
  names: kS1
};
function AS1() {
  this.name = "geocent";
}
function FS1(t) {
  var e = gk(t, this.es, this.a);
  return e;
}
function TS1(t) {
  var e = yk(t, this.es, this.a, this.b);
  return e;
}
var IS1 = ["Geocentric", "geocentric", "geocent", "Geocent"];
const OS1 = {
  init: AS1,
  forward: FS1,
  inverse: TS1,
  names: IS1
};
var v5 = {
  N_POLE: 0,
  S_POLE: 1,
  EQUIT: 2,
  OBLIQ: 3
}, J7 = {
  h: { def: 1e5, num: !0 },
  // default is Karman line, no default in PROJ.7
  azi: { def: 0, num: !0, degrees: !0 },
  // default is North
  tilt: { def: 0, num: !0, degrees: !0 },
  // default is Nadir
  long0: { def: 0, num: !0 },
  // default is Greenwich, conversion to rad is automatic
  lat0: { def: 0, num: !0 }
  // default is Equator, conversion to rad is automatic
};
function NS1() {
  if (Object.keys(J7).forEach((function(n) {
    if (typeof this[n] > "u")
      this[n] = J7[n].def;
    else {
      if (J7[n].num && isNaN(this[n]))
        throw new Error("Invalid parameter value, must be numeric " + n + " = " + this[n]);
      J7[n].num && (this[n] = parseFloat(this[n]));
    }
    J7[n].degrees && (this[n] = this[n] * U4);
  }).bind(this)), Math.abs(Math.abs(this.lat0) - h2) < I2 ? this.mode = this.lat0 < 0 ? v5.S_POLE : v5.N_POLE : Math.abs(this.lat0) < I2 ? this.mode = v5.EQUIT : (this.mode = v5.OBLIQ, this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0)), this.pn1 = this.h / this.a, this.pn1 <= 0 || this.pn1 > 1e10)
    throw new Error("Invalid height");
  this.p = 1 + this.pn1, this.rp = 1 / this.p, this.h1 = 1 / this.pn1, this.pfact = (this.p + 1) * this.h1, this.es = 0;
  var t = this.tilt, e = this.azi;
  this.cg = Math.cos(e), this.sg = Math.sin(e), this.cw = Math.cos(t), this.sw = Math.sin(t);
}
function PS1(t) {
  t.x -= this.long0;
  var e = Math.sin(t.y), n = Math.cos(t.y), i = Math.cos(t.x), s, l;
  switch (this.mode) {
    case v5.OBLIQ:
      l = this.sinph0 * e + this.cosph0 * n * i;
      break;
    case v5.EQUIT:
      l = n * i;
      break;
    case v5.S_POLE:
      l = -e;
      break;
    case v5.N_POLE:
      l = e;
      break;
  }
  switch (l = this.pn1 / (this.p - l), s = l * n * Math.sin(t.x), this.mode) {
    case v5.OBLIQ:
      l *= this.cosph0 * e - this.sinph0 * n * i;
      break;
    case v5.EQUIT:
      l *= e;
      break;
    case v5.N_POLE:
      l *= -(n * i);
      break;
    case v5.S_POLE:
      l *= n * i;
      break;
  }
  var a, o;
  return a = l * this.cg + s * this.sg, o = 1 / (a * this.sw * this.h1 + this.cw), s = (s * this.cg - l * this.sg) * this.cw * o, l = a * o, t.x = s * this.a, t.y = l * this.a, t;
}
function BS1(t) {
  t.x /= this.a, t.y /= this.a;
  var e = { x: t.x, y: t.y }, n, i, s;
  s = 1 / (this.pn1 - t.y * this.sw), n = this.pn1 * t.x * s, i = this.pn1 * t.y * this.cw * s, t.x = n * this.cg + i * this.sg, t.y = i * this.cg - n * this.sg;
  var l = sn(t.x, t.y);
  if (Math.abs(l) < I2)
    e.x = 0, e.y = t.y;
  else {
    var a, o;
    switch (o = 1 - l * l * this.pfact, o = (this.p - Math.sqrt(o)) / (this.pn1 / l + l / this.pn1), a = Math.sqrt(1 - o * o), this.mode) {
      case v5.OBLIQ:
        e.y = Math.asin(a * this.sinph0 + t.y * o * this.cosph0 / l), t.y = (a - this.sinph0 * Math.sin(e.y)) * l, t.x *= o * this.cosph0;
        break;
      case v5.EQUIT:
        e.y = Math.asin(t.y * o / l), t.y = a * l, t.x *= o;
        break;
      case v5.N_POLE:
        e.y = Math.asin(a), t.y = -t.y;
        break;
      case v5.S_POLE:
        e.y = -Math.asin(a);
        break;
    }
    e.x = Math.atan2(t.x, t.y);
  }
  return t.x = e.x + this.long0, t.y = e.y, t;
}
var VS1 = ["Tilted_Perspective", "tpers"];
const RS1 = {
  init: NS1,
  forward: PS1,
  inverse: BS1,
  names: VS1
};
function HS1() {
  if (this.flip_axis = this.sweep === "x" ? 1 : 0, this.h = Number(this.h), this.radius_g_1 = this.h / this.a, this.radius_g_1 <= 0 || this.radius_g_1 > 1e10)
    throw new Error();
  if (this.radius_g = 1 + this.radius_g_1, this.C = this.radius_g * this.radius_g - 1, this.es !== 0) {
    var t = 1 - this.es, e = 1 / t;
    this.radius_p = Math.sqrt(t), this.radius_p2 = t, this.radius_p_inv2 = e, this.shape = "ellipse";
  } else
    this.radius_p = 1, this.radius_p2 = 1, this.radius_p_inv2 = 1, this.shape = "sphere";
  this.title || (this.title = "Geostationary Satellite View");
}
function DS1(t) {
  var e = t.x, n = t.y, i, s, l, a;
  if (e = e - this.long0, this.shape === "ellipse") {
    n = Math.atan(this.radius_p2 * Math.tan(n));
    var o = this.radius_p / sn(this.radius_p * Math.cos(n), Math.sin(n));
    if (s = o * Math.cos(e) * Math.cos(n), l = o * Math.sin(e) * Math.cos(n), a = o * Math.sin(n), (this.radius_g - s) * s - l * l - a * a * this.radius_p_inv2 < 0)
      return t.x = Number.NaN, t.y = Number.NaN, t;
    i = this.radius_g - s, this.flip_axis ? (t.x = this.radius_g_1 * Math.atan(l / sn(a, i)), t.y = this.radius_g_1 * Math.atan(a / i)) : (t.x = this.radius_g_1 * Math.atan(l / i), t.y = this.radius_g_1 * Math.atan(a / sn(l, i)));
  } else
    this.shape === "sphere" && (i = Math.cos(n), s = Math.cos(e) * i, l = Math.sin(e) * i, a = Math.sin(n), i = this.radius_g - s, this.flip_axis ? (t.x = this.radius_g_1 * Math.atan(l / sn(a, i)), t.y = this.radius_g_1 * Math.atan(a / i)) : (t.x = this.radius_g_1 * Math.atan(l / i), t.y = this.radius_g_1 * Math.atan(a / sn(l, i))));
  return t.x = t.x * this.a, t.y = t.y * this.a, t;
}
function $S1(t) {
  var e = -1, n = 0, i = 0, s, l, a, o;
  if (t.x = t.x / this.a, t.y = t.y / this.a, this.shape === "ellipse") {
    this.flip_axis ? (i = Math.tan(t.y / this.radius_g_1), n = Math.tan(t.x / this.radius_g_1) * sn(1, i)) : (n = Math.tan(t.x / this.radius_g_1), i = Math.tan(t.y / this.radius_g_1) * sn(1, n));
    var h = i / this.radius_p;
    if (s = n * n + h * h + e * e, l = 2 * this.radius_g * e, a = l * l - 4 * s * this.C, a < 0)
      return t.x = Number.NaN, t.y = Number.NaN, t;
    o = (-l - Math.sqrt(a)) / (2 * s), e = this.radius_g + o * e, n *= o, i *= o, t.x = Math.atan2(n, e), t.y = Math.atan(i * Math.cos(t.x) / e), t.y = Math.atan(this.radius_p_inv2 * Math.tan(t.y));
  } else if (this.shape === "sphere") {
    if (this.flip_axis ? (i = Math.tan(t.y / this.radius_g_1), n = Math.tan(t.x / this.radius_g_1) * Math.sqrt(1 + i * i)) : (n = Math.tan(t.x / this.radius_g_1), i = Math.tan(t.y / this.radius_g_1) * Math.sqrt(1 + n * n)), s = n * n + i * i + e * e, l = 2 * this.radius_g * e, a = l * l - 4 * s * this.C, a < 0)
      return t.x = Number.NaN, t.y = Number.NaN, t;
    o = (-l - Math.sqrt(a)) / (2 * s), e = this.radius_g + o * e, n *= o, i *= o, t.x = Math.atan2(n, e), t.y = Math.atan(i * Math.cos(t.x) / e);
  }
  return t.x = t.x + this.long0, t;
}
var US1 = ["Geostationary Satellite View", "Geostationary_Satellite", "geos"];
const jS1 = {
  init: HS1,
  forward: DS1,
  inverse: $S1,
  names: US1
};
function GS1(t) {
  t.Proj.projections.add(qh), t.Proj.projections.add(wh), t.Proj.projections.add(Jb1), t.Proj.projections.add(oL1), t.Proj.projections.add(vL1), t.Proj.projections.add(_L1), t.Proj.projections.add(LL1), t.Proj.projections.add(EL1), t.Proj.projections.add(OL1), t.Proj.projections.add(RL1), t.Proj.projections.add(ix1), t.Proj.projections.add(cx1), t.Proj.projections.add(vx1), t.Proj.projections.add(qx1), t.Proj.projections.add(Lx1), t.Proj.projections.add(Ex1), t.Proj.projections.add(Ox1), t.Proj.projections.add(Rx1), t.Proj.projections.add(Gx1), t.Proj.projections.add(Zx1), t.Proj.projections.add(nS1), t.Proj.projections.add(aS1), t.Proj.projections.add(dS1), t.Proj.projections.add(gS1), t.Proj.projections.add(zS1), t.Proj.projections.add(ES1), t.Proj.projections.add(OS1), t.Proj.projections.add(RS1), t.Proj.projections.add(jS1);
}
m5.defaultDatum = "WGS84";
m5.Proj = ii;
m5.WGS84 = new m5.Proj("WGS84");
m5.Point = Ka;
m5.toPoint = _k;
m5.defs = I5;
m5.nadgrid = eb1;
m5.transform = cu;
m5.mgrs = mb1;
m5.version = "__VERSION__";
GS1(m5);
let WS1 = null;
function Tk(t) {
  WS1 = t;
  const e = Object.keys(t.defs), n = e.length;
  let i, s;
  for (i = 0; i < n; ++i) {
    const l = e[i];
    if (!ct(l)) {
      const a = t.defs(l);
      let o = (
        /** @type {import("./Units.js").Units} */
        a.units
      );
      !o && a.projName === "longlat" && (o = "degrees"), ES(
        new D_({
          code: l,
          axisOrientation: a.axis,
          metersPerUnit: a.to_meter,
          units: o
        })
      );
    }
  }
  for (i = 0; i < n; ++i) {
    const l = e[i], a = ct(l);
    for (s = 0; s < n; ++s) {
      const o = e[s], h = ct(o);
      if (!gS(l, o))
        if (t.defs[l] === t.defs[o])
          My([a, h]);
        else {
          const u = t(l, o);
          gg1(
            a,
            h,
            zz(a, h, u.forward),
            zz(h, a, u.inverse)
          );
        }
    }
  }
}
function Ik() {
  const t = D1(!1), e = D1(void 0);
  let n;
  const i = g1(() => H(t) && !s1.isNil(e)), s = g1(() => H(e)), l = () => /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ? "⌘" : "CTRL", a = () => {
    n = setTimeout(() => {
      t.value = !1;
    }, 1e3);
  };
  return {
    helperVisible: i,
    helperMessage: s,
    helperShow: (u) => {
      t.value = !1, clearTimeout(n), u && (e.value = u), s1.isNil(H(e)) ? console.error("JclMap: @useHelper > message is undefined or null!") : (t.value = !0, a());
    },
    helperHide: () => {
      clearTimeout(n), t.value = !1;
    },
    platformModifierLabel: l
  };
}
m5.defs(
  "EPSG:3035",
  "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
);
Tk(m5);
const YS1 = c2({
  name: "JclOlMap",
  emits: ["mounted", "hoverTerritory", "clickedTerritory", "wmsUpdatingLayers", "wmsUpdatedLayers"],
  components: {
    EclModal: Au,
    EclP: zr
  },
  props: {
    settings: {
      type: Object,
      required: !0
    },
    center: {
      type: Array,
      required: !1
    },
    zoom: {
      type: Number,
      required: !1
    }
  },
  setup(t, e) {
    const n = AS(t), i = ck({
      mapComponent: n.mapComponent
    }), s = Ik(), l = ok(
      t,
      {
        helper: s,
        data: n,
        tooltip: i
      },
      e
    );
    return {
      ...s,
      ...n,
      ...i,
      ...l,
      helpers: {
        WFS: {
          request: l.WFS.request,
          readGeoJson: l.WFS.readGeoJson,
          getGeometry: l.WFS.getGeometry
        }
      }
    };
  }
}), XS1 = {
  class: "ecl-map",
  ref: "mapComponent"
}, KS1 = ["data-finger-alert"], ZS1 = ["innerHTML"], JS1 = ["aria-hidden"], QS1 = ["innerHTML"];
function eC1(t, e, n, i, s, l) {
  var a;
  return T(), N("div", XS1, [
    C("div", {
      class: "ecl-map__map",
      ref: "mapElement",
      "data-finger-alert": (a = t.settings) == null ? void 0 : a.useDoubleTouchLabel
    }, null, 8, KS1),
    t.tooltipShow ? J2(t.$slots, "tooltip", {
      key: 0,
      data: t.tooltipData.dataObject,
      text: t.tooltipData.text,
      style: Rt(t.tooltipStyle)
    }, () => [
      C("div", {
        class: "ecl-map__tooltip",
        style: Rt(t.tooltipStyle),
        innerHTML: t.tooltipData.text
      }, null, 12, ZS1)
    ]) : m2("", !0),
    J2(t.$slots, "helper", {
      visible: t.helperVisible,
      message: t.helperMessage
    }, () => [
      C("div", {
        class: "ecl-map__helper",
        "aria-hidden": !t.helperVisible
      }, [
        C("span", { innerHTML: t.helperMessage }, null, 8, QS1)
      ], 8, JS1)
    ])
  ], 512);
}
const Ok = /* @__PURE__ */ Le(YS1, [["render", eC1]]);
m5.defs(
  "EPSG:3035",
  "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
);
Tk(m5);
c2({
  name: "JclOlMap",
  emits: ["mounted", "hoverTerritory", "clickedTerritory", "wmsUpdatingLayers", "wmsUpdatedLayers"],
  components: {
    EclModal: Au,
    EclP: zr
  },
  props: {
    settings: {
      type: Object,
      required: !0
    },
    center: {
      type: Array,
      required: !1
    },
    zoom: {
      type: Number,
      required: !1
    }
  },
  setup(t, e) {
    const n = AS(t), i = ck({
      mapComponent: n.mapComponent
    }), s = Ik(), l = ok(
      t,
      {
        helper: s,
        data: n,
        tooltip: i
      },
      e
    );
    return {
      ...s,
      ...n,
      ...i,
      ...l,
      helpers: {
        WFS: {
          request: l.WFS.request,
          readGeoJson: l.WFS.readGeoJson,
          getGeometry: l.WFS.getGeometry
        }
      }
    };
  }
});
const tC1 = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
  <path d="M12 21l-8-9h6v-12h4v12h6l-8 9zm9-1v2h-18v-2h-2v4h22v-4h-2z"/>
</svg>
`, nC1 = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
  <path d="M20.1041,20.9039H16.1178a.8.8,0,1,1,0-1.6h3.1865V16.1178a.8.8,0,0,1,1.6,0v3.9863A.8.8,0,0,1,20.1041,20.9039Z"/>
  <path d="M20.1041,8.6822a.8.8,0,0,1-.8-.8V4.6959H16.1178a.8.8,0,0,1,0-1.6h3.9863a.8.8,0,0,1,.8.8V7.8824A.8.8,0,0,1,20.1041,8.6822Z"/>
  <path d="M3.8961,8.6822a.8.8,0,0,1-.8-.8V3.8961a.8.8,0,0,1,.8-.8H7.8824a.8.8,0,0,1,0,1.6H4.6959V7.8824A.8.8,0,0,1,3.8961,8.6822Z"/>
  <path d="M7.8824,20.9039H3.8961a.8.8,0,0,1-.8-.8V16.1178a.8.8,0,0,1,1.6,0v3.1865H7.8824a.8.8,0,1,1,0,1.6Z"/>
  <path d="M15.6694,16.47H8.3306a.8.8,0,0,1-.8-.8V8.33a.8.8,0,0,1,.8-.8h7.3388a.8.8,0,0,1,.8.8V15.67A.8.8,0,0,1,15.6694,16.47ZM9.13,14.87H14.87V9.13H9.13Z"/>
</svg>
`, iC1 = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
  <path d="M5 8.5a1.5 1.5 0 113.001.001A1.5 1.5 0 015 8.5zm9 .5l-2.519 4L9 11.04 5 17h14l-5-8zm8-4v14H2V5h20zm2-2H0v18h24V3z"/>
</svg>
`, sC1 = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
  <path d="M12,2.8107A9.1895,9.1895,0,1,0,21.19,12,9.1994,9.1994,0,0,0,12,2.8107Zm7.5089,8.1417-.1563.2626-.7481-1.3985a.5928.5928,0,0,0-.6572-.3027l-2.2969.5024L14.61,8.3092a.6036.6036,0,0,0-.2461-.2251l-2.7-1.3394a.6018.6018,0,0,0-.5527.01l-1.8232.9912L8.98,7.3341l.7-.72,1.9082-1.1016a.5845.5845,0,0,0,.11-.0815l.8115-.76a.5843.5843,0,0,0,.1458-.227A7.5955,7.5955,0,0,1,19.5091,10.9524ZM4.5483,13.4194A10.5441,10.5441,0,0,1,4.41,12a7.5957,7.5957,0,0,1,6.5345-7.5077l-.0159.015L9.0081,5.6163a.5991.5991,0,0,0-.1309.1016L7.7629,6.8644a.6.6,0,0,0-.0507.7763l.9228,1.24a.6026.6026,0,0,0,.7676.1689l2.0068-1.0908,2.2657,1.1235,1.1728,1.9244a.5992.5992,0,0,0,.6406.2734l2.2715-.4971,1.0352,1.9346a.6007.6007,0,0,0,.5156.3164l.0137.0005a.5834.5834,0,0,0,.1945-.0515A7.5963,7.5963,0,0,1,12,19.59,8.1245,8.1245,0,0,1,7.079,17.7671a8.1875,8.1875,0,0,1-.85-.8505A7.6,7.6,0,0,1,5.05,15.0385,10.2709,10.2709,0,0,1,4.5483,13.4194Z"/>
  <path d="M14.7219,11.3307,13.6672,9.9835a.5651.5651,0,0,0-.4941-.2295l-1.2979.0469-.6406-.5127a.5982.5982,0,0,0-.375-.1318H9.1223a.5993.5993,0,0,0-.5078.2807L7.5823,11.0807a.601.601,0,0,0-.0869.4023l.2187,1.56a.5971.5971,0,0,0,.3428.4619l1.416.6519a.593.593,0,0,0,.1631.0483l1.0742.16.33,1.2138-.3535.8409a.5983.5983,0,0,0,.0224.5131l.9746,1.8462a.5986.5986,0,0,0,.4483.314.58.58,0,0,0,.082.0058.6011.6011,0,0,0,.4346-.1865l2.501-2.6289a.5982.5982,0,0,0,.165-.4136V14.5309l1.06-1.3a.5993.5993,0,0,0-.13-.877ZM14.25,13.9386a.5958.5958,0,0,0-.1347.3789V15.63l-1.7608,1.85-.4521-.8564.3242-.77a.5971.5971,0,0,0,.0264-.3906l-.4883-1.792a.6009.6009,0,0,0-.4912-.436l-1.377-.2041-1.04-.4785-.1426-1.0186.74-1.1772h1.1944l.65.52a.5791.5791,0,0,0,.3965.1313l1.2148-.0434.9248,1.1811a.6245.6245,0,0,0,.1377.128l1.0557.7089Z"/>
</svg>
`, lC1 = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
  <path d="M11.363 2C15.518 2 14 8 14 8s6-1.65 6 2.457V22H4V2h7.363zm.826-2H2v24h20V9.614C22 7.223 15.352 0 12.189 0zM17 13h-2.628v3.686h.907v-1.472h1.49v-.732h-1.49v-.698H17V13zm-4.9 0h-1.599v3.686H12.1c.537 0 .961-.181 1.262-.535.555-.658.587-2.034-.062-2.692-.298-.3-.712-.459-1.2-.459zm-.692.783h.496c.473 0 .802.173.915.644.064.267.077.679-.021.948-.128.351-.381.528-.754.528h-.637v-2.12zM8.668 13H7v3.686h.907v-1.277h.761c.619 0 1.064-.277 1.224-.763a1.41 1.41 0 000-.885c-.16-.484-.606-.761-1.224-.761zm-.761.732h.546c.235 0 .467.028.576.228a.62.62 0 010 .489c-.109.199-.341.227-.576.227h-.546v-.944z"/>
</svg>
`, rC1 = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <symbol id="download">
    <path d="M12 21l-8-9h6v-12h4v12h6l-8 9zm9-1v2h-18v-2h-2v4h22v-4h-2z"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="zoom-in">
    <path d="M18.279,10.95H13.0505V5.7213a1.05,1.05,0,0,0-2.1,0V10.95H5.7209a1.05,1.05,0,0,0,0,2.1h5.23v5.229a1.05,1.05,0,0,0,2.1,0V13.05H18.279a1.05,1.05,0,0,0,0-2.1Z"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="zoom-out">
    <path d="M18.2792,10.95H5.7216a1.05,1.05,0,1,0,0,2.1H18.2792a1.05,1.05,0,0,0,0-2.1Z"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="outermost-region">
    <path d="M12,2.8107A9.1895,9.1895,0,1,0,21.19,12,9.1994,9.1994,0,0,0,12,2.8107Zm7.5089,8.1417-.1563.2626-.7481-1.3985a.5928.5928,0,0,0-.6572-.3027l-2.2969.5024L14.61,8.3092a.6036.6036,0,0,0-.2461-.2251l-2.7-1.3394a.6018.6018,0,0,0-.5527.01l-1.8232.9912L8.98,7.3341l.7-.72,1.9082-1.1016a.5845.5845,0,0,0,.11-.0815l.8115-.76a.5843.5843,0,0,0,.1458-.227A7.5955,7.5955,0,0,1,19.5091,10.9524ZM4.5483,13.4194A10.5441,10.5441,0,0,1,4.41,12a7.5957,7.5957,0,0,1,6.5345-7.5077l-.0159.015L9.0081,5.6163a.5991.5991,0,0,0-.1309.1016L7.7629,6.8644a.6.6,0,0,0-.0507.7763l.9228,1.24a.6026.6026,0,0,0,.7676.1689l2.0068-1.0908,2.2657,1.1235,1.1728,1.9244a.5992.5992,0,0,0,.6406.2734l2.2715-.4971,1.0352,1.9346a.6007.6007,0,0,0,.5156.3164l.0137.0005a.5834.5834,0,0,0,.1945-.0515A7.5963,7.5963,0,0,1,12,19.59,8.1245,8.1245,0,0,1,7.079,17.7671a8.1875,8.1875,0,0,1-.85-.8505A7.6,7.6,0,0,1,5.05,15.0385,10.2709,10.2709,0,0,1,4.5483,13.4194Z"/>
    <path d="M14.7219,11.3307,13.6672,9.9835a.5651.5651,0,0,0-.4941-.2295l-1.2979.0469-.6406-.5127a.5982.5982,0,0,0-.375-.1318H9.1223a.5993.5993,0,0,0-.5078.2807L7.5823,11.0807a.601.601,0,0,0-.0869.4023l.2187,1.56a.5971.5971,0,0,0,.3428.4619l1.416.6519a.593.593,0,0,0,.1631.0483l1.0742.16.33,1.2138-.3535.8409a.5983.5983,0,0,0,.0224.5131l.9746,1.8462a.5986.5986,0,0,0,.4483.314.58.58,0,0,0,.082.0058.6011.6011,0,0,0,.4346-.1865l2.501-2.6289a.5982.5982,0,0,0,.165-.4136V14.5309l1.06-1.3a.5993.5993,0,0,0-.13-.877ZM14.25,13.9386a.5958.5958,0,0,0-.1347.3789V15.63l-1.7608,1.85-.4521-.8564.3242-.77a.5971.5971,0,0,0,.0264-.3906l-.4883-1.792a.6009.6009,0,0,0-.4912-.436l-1.377-.2041-1.04-.4785-.1426-1.0186.74-1.1772h1.1944l.65.52a.5791.5791,0,0,0,.3965.1313l1.2148-.0434.9248,1.1811a.6245.6245,0,0,0,.1377.128l1.0557.7089Z"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="home">
    <path d="M20.1041,20.9039H16.1178a.8.8,0,1,1,0-1.6h3.1865V16.1178a.8.8,0,0,1,1.6,0v3.9863A.8.8,0,0,1,20.1041,20.9039Z"/>
    <path d="M20.1041,8.6822a.8.8,0,0,1-.8-.8V4.6959H16.1178a.8.8,0,0,1,0-1.6h3.9863a.8.8,0,0,1,.8.8V7.8824A.8.8,0,0,1,20.1041,8.6822Z"/>
    <path d="M3.8961,8.6822a.8.8,0,0,1-.8-.8V3.8961a.8.8,0,0,1,.8-.8H7.8824a.8.8,0,0,1,0,1.6H4.6959V7.8824A.8.8,0,0,1,3.8961,8.6822Z"/>
    <path d="M7.8824,20.9039H3.8961a.8.8,0,0,1-.8-.8V16.1178a.8.8,0,0,1,1.6,0v3.1865H7.8824a.8.8,0,1,1,0,1.6Z"/>
    <path d="M15.6694,16.47H8.3306a.8.8,0,0,1-.8-.8V8.33a.8.8,0,0,1,.8-.8h7.3388a.8.8,0,0,1,.8.8V15.67A.8.8,0,0,1,15.6694,16.47ZM9.13,14.87H14.87V9.13H9.13Z"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="pdf">
    <path d="M11.363 2C15.518 2 14 8 14 8s6-1.65 6 2.457V22H4V2h7.363zm.826-2H2v24h20V9.614C22 7.223 15.352 0 12.189 0zM17 13h-2.628v3.686h.907v-1.472h1.49v-.732h-1.49v-.698H17V13zm-4.9 0h-1.599v3.686H12.1c.537 0 .961-.181 1.262-.535.555-.658.587-2.034-.062-2.692-.298-.3-.712-.459-1.2-.459zm-.692.783h.496c.473 0 .802.173.915.644.064.267.077.679-.021.948-.128.351-.381.528-.754.528h-.637v-2.12zM8.668 13H7v3.686h.907v-1.277h.761c.619 0 1.064-.277 1.224-.763a1.41 1.41 0 000-.885c-.16-.484-.606-.761-1.224-.761zm-.761.732h.546c.235 0 .467.028.576.228a.62.62 0 010 .489c-.109.199-.341.227-.576.227h-.546v-.944z"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="jpeg">
    <path d="M5 8.5a1.5 1.5 0 113.001.001A1.5 1.5 0 015 8.5zm9 .5l-2.519 4L9 11.04 5 17h14l-5-8zm8-4v14H2V5h20zm2-2H0v18h24V3z"/>
  </symbol>
</svg>
`, aC1 = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
  <path d="M18.279,10.95H13.0505V5.7213a1.05,1.05,0,0,0-2.1,0V10.95H5.7209a1.05,1.05,0,0,0,0,2.1h5.23v5.229a1.05,1.05,0,0,0,2.1,0V13.05H18.279a1.05,1.05,0,0,0,0-2.1Z"/>
</svg>
`, oC1 = `<?xml version="1.0" encoding="utf-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
  <path d="M18.2792,10.95H5.7216a1.05,1.05,0,1,0,0,2.1H18.2792a1.05,1.05,0,0,0,0-2.1Z"/>
</svg>
`;
class dj1 extends r9 {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(e) {
    const n = e, i = document.createElement("button");
    i.innerHTML = ac("download");
    const s = document.createElement("div");
    s.className = "ol-download ol-unselectable ol-control", s.appendChild(i), super({
      element: s,
      target: n == null ? void 0 : n.target
    });
    const l = [
      {
        id: "pdf",
        label: "PDF",
        icon: "pdf"
      },
      { id: "jpeg", label: "JPEG", icon: "jpeg" }
    ], a = (o) => {
      const h = this.getMap(), u = o.currentTarget.parentNode, d = u.getElementsByTagName("ul");
      if (d.length > 0)
        s1.each(d, (m) => {
          m.remove();
        });
      else {
        const m = document.createElement("ul");
        m.setAttribute("style", "margin: 0; padding: 0; list-style: none;"), s1.each(l, (p) => {
          const _ = document.createElement("li"), q = document.createElement("button");
          q.title = p.label, q.innerHTML = ac(p.icon), _.appendChild(q), _.setAttribute("data-type", p.id), _.onclick = () => {
            s1.isNil(h) || ck1(h, p.id, q);
          }, m.appendChild(_);
        }), u.appendChild(m);
      }
    };
    s1.isNil(n == null ? void 0 : n.callback) ? i.addEventListener(
      "click",
      (o) => {
        const h = this.getMap();
        s1.isNil(h) || a(o);
      },
      !1
    ) : i.addEventListener("click", n.callback.bind(this), !1);
  }
}
class cC1 extends r9 {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(n, i) {
    const s = i || {}, l = document.createElement("button");
    l.title = "Go to home map view", l.innerHTML = ac("home");
    const a = document.createElement("div");
    a.className = "ol-home ol-unselectable ol-control", a.appendChild(l);
    super({
      element: a,
      target: s.target
    });
    O2(this, "alreadyRendered");
    s1.isNil(n) ? console.error(new Error("HomeControl (OpenLayer Custom Control) require a callback function!")) : l.addEventListener("click", n.bind(this), !1);
  }
  render() {
    if (this.alreadyRendered === void 0) {
      const n = this.getMap();
      n && (n.getTargetElement().classList.add("ecl-map--has-control-home"), this.alreadyRendered = !0);
    }
  }
}
class fj1 extends r9 {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(n, i) {
    const s = i || {}, l = document.createElement("button");
    l.title = "Toggle outermost regions", l.innerHTML = ac("outermost-region");
    const a = document.createElement("div");
    a.className = "ol-outermost-regions ol-unselectable ol-control", a.appendChild(l);
    super({
      element: a,
      target: s == null ? void 0 : s.target
    });
    O2(this, "alreadyRendered");
    s1.isNil(n) ? console.error(new Error("ToggleOutermostRegionsControl (OpenLayer Custom Control) require a callback function!")) : l.addEventListener("click", n.bind(this), !1);
  }
  render() {
    if (this.alreadyRendered === void 0) {
      const n = this.getMap();
      n && (n.getTargetElement().classList.add("ecl-map--has-control-outermost"), this.alreadyRendered = !0);
    }
  }
}
const hC1 = /* @__PURE__ */ Object.assign({
  "../../icons/download.svg": tC1,
  "../../icons/home.svg": nC1,
  "../../icons/jpeg.svg": iC1,
  "../../icons/outermost-region.svg": sC1,
  "../../icons/pdf.svg": lC1,
  "../../icons/sprite-controls.svg": rC1,
  "../../icons/zoom-in.svg": aC1,
  "../../icons/zoom-out.svg": oC1
}), ac = (t) => hC1[`../../icons/${t}.svg`];
class uC1 {
  constructor(e) {
    if (!s1.isNil(e)) {
      const n = e.positions, i = (s) => {
        let l = "";
        return s1.each(s, (a, o) => {
          const h = a + `${typeof a == "string" ? "" : "px"}`;
          l += `${o}:${h};`;
        }), l;
      };
      this.list = s1.map(e.entities, (s) => ({
        id: s.id,
        name: s.name,
        bbox: s.bbox,
        parentCode: s.parent.code,
        // positions: positions[region.id],
        styles: i(n[s.id])
      })), this.listByGroup = s1.chain(this.list).groupBy("parentCode").map((s, l) => ({
        parentCode: l,
        regions: s,
        // positions: positions[value.id],
        styles: i(n[s.id])
      })).value();
    }
  }
}
function Ye(t) {
  "@babel/helpers - typeof";
  return Ye = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ye(t);
}
var V5 = Uint8Array, R5 = Uint16Array, oc = Uint32Array, od = new V5([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), cd = new V5([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), jy = new V5([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Nk = function(t, e) {
  for (var n = new R5(31), i = 0; i < 31; ++i)
    n[i] = e += 1 << t[i - 1];
  for (var s = new oc(n[30]), i = 1; i < 30; ++i)
    for (var l = n[i]; l < n[i + 1]; ++l)
      s[l] = l - n[i] << 5 | i;
  return [n, s];
}, Pk = Nk(od, 2), Bk = Pk[0], Gy = Pk[1];
Bk[28] = 258, Gy[258] = 28;
var Vk = Nk(cd, 0), dC1 = Vk[0], OM = Vk[1], Wy = new R5(32768);
for (var vt = 0; vt < 32768; ++vt) {
  var us = (vt & 43690) >>> 1 | (vt & 21845) << 1;
  us = (us & 52428) >>> 2 | (us & 13107) << 2, us = (us & 61680) >>> 4 | (us & 3855) << 4, Wy[vt] = ((us & 65280) >>> 8 | (us & 255) << 8) >>> 1;
}
var si = function(t, e, n) {
  for (var i = t.length, s = 0, l = new R5(e); s < i; ++s)
    ++l[t[s] - 1];
  var a = new R5(e);
  for (s = 0; s < e; ++s)
    a[s] = a[s - 1] + l[s - 1] << 1;
  var o;
  if (n) {
    o = new R5(1 << e);
    var h = 15 - e;
    for (s = 0; s < i; ++s)
      if (t[s])
        for (var u = s << 4 | t[s], d = e - t[s], v = a[t[s] - 1]++ << d, m = v | (1 << d) - 1; v <= m; ++v)
          o[Wy[v] >>> h] = u;
  } else
    for (o = new R5(i), s = 0; s < i; ++s)
      o[s] = Wy[a[t[s] - 1]++] >>> 15 - t[s];
  return o;
}, Vs = new V5(288);
for (var vt = 0; vt < 144; ++vt)
  Vs[vt] = 8;
for (var vt = 144; vt < 256; ++vt)
  Vs[vt] = 9;
for (var vt = 256; vt < 280; ++vt)
  Vs[vt] = 7;
for (var vt = 280; vt < 288; ++vt)
  Vs[vt] = 8;
var cc = new V5(32);
for (var vt = 0; vt < 32; ++vt)
  cc[vt] = 5;
var fC1 = /* @__PURE__ */ si(Vs, 9, 0), vC1 = /* @__PURE__ */ si(Vs, 9, 1), pC1 = /* @__PURE__ */ si(cc, 5, 0), mC1 = /* @__PURE__ */ si(cc, 5, 1), Wg = function(t) {
  for (var e = t[0], n = 1; n < t.length; ++n)
    t[n] > e && (e = t[n]);
  return e;
}, Q6 = function(t, e, n) {
  var i = e / 8 >> 0;
  return (t[i] | t[i + 1] << 8) >>> (e & 7) & n;
}, Yg = function(t, e) {
  var n = e / 8 >> 0;
  return (t[n] | t[n + 1] << 8 | t[n + 2] << 16) >>> (e & 7);
}, Yq = function(t) {
  return (t / 8 >> 0) + (t & 7 && 1);
}, Rk = function(t, e, n) {
  (e == null || e < 0) && (e = 0), (n == null || n > t.length) && (n = t.length);
  var i = new (t instanceof R5 ? R5 : t instanceof oc ? oc : V5)(n - e);
  return i.set(t.subarray(e, n)), i;
}, gC1 = function(t, e, n) {
  var i = t.length, s = !e || n, l = !n || n.i;
  n || (n = {}), e || (e = new V5(i * 3));
  var a = function(w1) {
    var C1 = e.length;
    if (w1 > C1) {
      var E1 = new V5(Math.max(C1 * 2, w1));
      E1.set(e), e = E1;
    }
  }, o = n.f || 0, h = n.p || 0, u = n.b || 0, d = n.l, v = n.d, m = n.m, p = n.n, _ = i * 8;
  do {
    if (!d) {
      n.f = o = Q6(t, h, 1);
      var q = Q6(t, h + 1, 3);
      if (h += 3, q)
        if (q == 1)
          d = vC1, v = mC1, m = 9, p = 5;
        else if (q == 2) {
          var x = Q6(t, h, 31) + 257, k = Q6(t, h + 10, 15) + 4, F = x + Q6(t, h + 5, 31) + 1;
          h += 14;
          for (var D = new V5(F), R = new V5(19), V = 0; V < k; ++V)
            R[jy[V]] = Q6(t, h + V * 3, 7);
          h += k * 3;
          var J = Wg(R), K = (1 << J) - 1;
          if (!l && h + F * (J + 7) > _)
            break;
          for (var P = si(R, J, 1), V = 0; V < F; ) {
            var O = P[Q6(t, h, K)];
            h += O & 15;
            var M = O >>> 4;
            if (M < 16)
              D[V++] = M;
            else {
              var G = 0, j = 0;
              for (M == 16 ? (j = 3 + Q6(t, h, 3), h += 2, G = D[V - 1]) : M == 17 ? (j = 3 + Q6(t, h, 7), h += 3) : M == 18 && (j = 11 + Q6(t, h, 127), h += 7); j--; )
                D[V++] = G;
            }
          }
          var Q = D.subarray(0, x), i1 = D.subarray(x);
          m = Wg(Q), p = Wg(i1), d = si(Q, m, 1), v = si(i1, p, 1);
        } else
          throw "invalid block type";
      else {
        var M = Yq(h) + 4, z = t[M - 4] | t[M - 3] << 8, b = M + z;
        if (b > i) {
          if (l)
            throw "unexpected EOF";
          break;
        }
        s && a(u + z), e.set(t.subarray(M, b), u), n.b = u += z, n.p = h = b * 8;
        continue;
      }
      if (h > _)
        throw "unexpected EOF";
    }
    s && a(u + 131072);
    for (var h1 = (1 << m) - 1, c1 = (1 << p) - 1, M1 = m + p + 18; l || h + M1 < _; ) {
      var G = d[Yg(t, h) & h1], y1 = G >>> 4;
      if (h += G & 15, h > _)
        throw "unexpected EOF";
      if (!G)
        throw "invalid length/literal";
      if (y1 < 256)
        e[u++] = y1;
      else if (y1 == 256) {
        d = null;
        break;
      } else {
        var A1 = y1 - 254;
        if (y1 > 264) {
          var V = y1 - 257, $ = od[V];
          A1 = Q6(t, h, (1 << $) - 1) + Bk[V], h += $;
        }
        var a1 = v[Yg(t, h) & c1], n1 = a1 >>> 4;
        if (!a1)
          throw "invalid distance";
        h += a1 & 15;
        var i1 = dC1[n1];
        if (n1 > 3) {
          var $ = cd[n1];
          i1 += Yg(t, h) & (1 << $) - 1, h += $;
        }
        if (h > _)
          throw "unexpected EOF";
        s && a(u + 131072);
        for (var f1 = u + A1; u < f1; u += 4)
          e[u] = e[u - i1], e[u + 1] = e[u + 1 - i1], e[u + 2] = e[u + 2 - i1], e[u + 3] = e[u + 3 - i1];
        u = f1;
      }
    }
    n.l = d, n.p = h, n.b = u, d && (o = 1, n.m = m, n.d = v, n.n = p);
  } while (!o);
  return u == e.length ? e : Rk(e, 0, u);
}, l8 = function(t, e, n) {
  n <<= e & 7;
  var i = e / 8 >> 0;
  t[i] |= n, t[i + 1] |= n >>> 8;
}, Q7 = function(t, e, n) {
  n <<= e & 7;
  var i = e / 8 >> 0;
  t[i] |= n, t[i + 1] |= n >>> 8, t[i + 2] |= n >>> 16;
}, Xg = function(t, e) {
  for (var n = [], i = 0; i < t.length; ++i)
    t[i] && n.push({ s: i, f: t[i] });
  var s = n.length, l = n.slice();
  if (!s)
    return [new V5(0), 0];
  if (s == 1) {
    var a = new V5(n[0].s + 1);
    return a[n[0].s] = 1, [a, 1];
  }
  n.sort(function(F, D) {
    return F.f - D.f;
  }), n.push({ s: -1, f: 25001 });
  var o = n[0], h = n[1], u = 0, d = 1, v = 2;
  for (n[0] = { s: -1, f: o.f + h.f, l: o, r: h }; d != s - 1; )
    o = n[n[u].f < n[v].f ? u++ : v++], h = n[u != d && n[u].f < n[v].f ? u++ : v++], n[d++] = { s: -1, f: o.f + h.f, l: o, r: h };
  for (var m = l[0].s, i = 1; i < s; ++i)
    l[i].s > m && (m = l[i].s);
  var p = new R5(m + 1), _ = Yy(n[d - 1], p, 0);
  if (_ > e) {
    var i = 0, q = 0, M = _ - e, z = 1 << M;
    for (l.sort(function(D, R) {
      return p[R.s] - p[D.s] || D.f - R.f;
    }); i < s; ++i) {
      var b = l[i].s;
      if (p[b] > e)
        q += z - (1 << _ - p[b]), p[b] = e;
      else
        break;
    }
    for (q >>>= M; q > 0; ) {
      var x = l[i].s;
      p[x] < e ? q -= 1 << e - p[x]++ - 1 : ++i;
    }
    for (; i >= 0 && q; --i) {
      var k = l[i].s;
      p[k] == e && (--p[k], ++q);
    }
    _ = e;
  }
  return [new V5(p), _];
}, Yy = function(t, e, n) {
  return t.s == -1 ? Math.max(Yy(t.l, e, n + 1), Yy(t.r, e, n + 1)) : e[t.s] = n;
}, NM = function(t) {
  for (var e = t.length; e && !t[--e]; )
    ;
  for (var n = new R5(++e), i = 0, s = t[0], l = 1, a = function(h) {
    n[i++] = h;
  }, o = 1; o <= e; ++o)
    if (t[o] == s && o != e)
      ++l;
    else {
      if (!s && l > 2) {
        for (; l > 138; l -= 138)
          a(32754);
        l > 2 && (a(l > 10 ? l - 11 << 5 | 28690 : l - 3 << 5 | 12305), l = 0);
      } else if (l > 3) {
        for (a(s), --l; l > 6; l -= 6)
          a(8304);
        l > 2 && (a(l - 3 << 5 | 8208), l = 0);
      }
      for (; l--; )
        a(s);
      l = 1, s = t[o];
    }
  return [n.subarray(0, i), e];
}, eo = function(t, e) {
  for (var n = 0, i = 0; i < e.length; ++i)
    n += t[i] * e[i];
  return n;
}, zh = function(t, e, n) {
  var i = n.length, s = Yq(e + 2);
  t[s] = i & 255, t[s + 1] = i >>> 8, t[s + 2] = t[s] ^ 255, t[s + 3] = t[s + 1] ^ 255;
  for (var l = 0; l < i; ++l)
    t[s + l + 4] = n[l];
  return (s + 4 + i) * 8;
}, PM = function(t, e, n, i, s, l, a, o, h, u, d) {
  l8(e, d++, n), ++s[256];
  for (var v = Xg(s, 15), m = v[0], p = v[1], _ = Xg(l, 15), q = _[0], M = _[1], z = NM(m), b = z[0], x = z[1], k = NM(q), F = k[0], D = k[1], R = new R5(19), V = 0; V < b.length; ++V)
    R[b[V] & 31]++;
  for (var V = 0; V < F.length; ++V)
    R[F[V] & 31]++;
  for (var J = Xg(R, 7), K = J[0], P = J[1], O = 19; O > 4 && !K[jy[O - 1]]; --O)
    ;
  var G = u + 5 << 3, j = eo(s, Vs) + eo(l, cc) + a, Q = eo(s, m) + eo(l, q) + a + 14 + 3 * O + eo(R, K) + (2 * R[16] + 3 * R[17] + 7 * R[18]);
  if (G <= j && G <= Q)
    return zh(e, d, t.subarray(h, h + u));
  var i1, h1, c1, M1;
  if (l8(e, d, 1 + (Q < j)), d += 2, Q < j) {
    i1 = si(m, p, 0), h1 = m, c1 = si(q, M, 0), M1 = q;
    var y1 = si(K, P, 0);
    l8(e, d, x - 257), l8(e, d + 5, D - 1), l8(e, d + 10, O - 4), d += 14;
    for (var V = 0; V < O; ++V)
      l8(e, d + 3 * V, K[jy[V]]);
    d += 3 * O;
    for (var A1 = [b, F], $ = 0; $ < 2; ++$)
      for (var a1 = A1[$], V = 0; V < a1.length; ++V) {
        var n1 = a1[V] & 31;
        l8(e, d, y1[n1]), d += K[n1], n1 > 15 && (l8(e, d, a1[V] >>> 5 & 127), d += a1[V] >>> 12);
      }
  } else
    i1 = fC1, h1 = Vs, c1 = pC1, M1 = cc;
  for (var V = 0; V < o; ++V)
    if (i[V] > 255) {
      var n1 = i[V] >>> 18 & 31;
      Q7(e, d, i1[n1 + 257]), d += h1[n1 + 257], n1 > 7 && (l8(e, d, i[V] >>> 23 & 31), d += od[n1]);
      var f1 = i[V] & 31;
      Q7(e, d, c1[f1]), d += M1[f1], f1 > 3 && (Q7(e, d, i[V] >>> 5 & 8191), d += cd[f1]);
    } else
      Q7(e, d, i1[i[V]]), d += h1[i[V]];
  return Q7(e, d, i1[256]), d + h1[256];
}, yC1 = /* @__PURE__ */ new oc([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), _C1 = /* @__PURE__ */ new V5(0), qC1 = function(t, e, n, i, s, l) {
  var a = t.length, o = new V5(i + a + 5 * (1 + Math.floor(a / 7e3)) + s), h = o.subarray(i, o.length - s), u = 0;
  if (!e || a < 8)
    for (var d = 0; d <= a; d += 65535) {
      var v = d + 65535;
      v < a ? u = zh(h, u, t.subarray(d, v)) : (h[d] = l, u = zh(h, u, t.subarray(d, a)));
    }
  else {
    for (var m = yC1[e - 1], p = m >>> 13, _ = m & 8191, q = (1 << n) - 1, M = new R5(32768), z = new R5(q + 1), b = Math.ceil(n / 3), x = 2 * b, k = function(y2) {
      return (t[y2] ^ t[y2 + 1] << b ^ t[y2 + 2] << x) & q;
    }, F = new oc(25e3), D = new R5(288), R = new R5(32), V = 0, J = 0, d = 0, K = 0, P = 0, O = 0; d < a; ++d) {
      var G = k(d), j = d & 32767, Q = z[G];
      if (M[j] = Q, z[G] = j, P <= d) {
        var i1 = a - d;
        if ((V > 7e3 || K > 24576) && i1 > 423) {
          u = PM(t, h, 0, F, D, R, J, K, O, d - O, u), K = V = J = 0, O = d;
          for (var h1 = 0; h1 < 286; ++h1)
            D[h1] = 0;
          for (var h1 = 0; h1 < 30; ++h1)
            R[h1] = 0;
        }
        var c1 = 2, M1 = 0, y1 = _, A1 = j - Q & 32767;
        if (i1 > 2 && G == k(d - A1))
          for (var $ = Math.min(p, i1) - 1, a1 = Math.min(32767, d), n1 = Math.min(258, i1); A1 <= a1 && --y1 && j != Q; ) {
            if (t[d + c1] == t[d + c1 - A1]) {
              for (var f1 = 0; f1 < n1 && t[d + f1] == t[d + f1 - A1]; ++f1)
                ;
              if (f1 > c1) {
                if (c1 = f1, M1 = A1, f1 > $)
                  break;
                for (var w1 = Math.min(A1, f1 - 2), C1 = 0, h1 = 0; h1 < w1; ++h1) {
                  var E1 = d - A1 + h1 + 32768 & 32767, T1 = M[E1], n2 = E1 - T1 + 32768 & 32767;
                  n2 > C1 && (C1 = n2, Q = E1);
                }
              }
            }
            j = Q, Q = M[j], A1 += j - Q + 32768 & 32767;
          }
        if (M1) {
          F[K++] = 268435456 | Gy[c1] << 18 | OM[M1];
          var X1 = Gy[c1] & 31, a2 = OM[M1] & 31;
          J += od[X1] + cd[a2], ++D[257 + X1], ++R[a2], P = d + c1, ++V;
        } else
          F[K++] = t[d], ++D[t[d]];
      }
    }
    u = PM(t, h, l, F, D, R, J, K, O, d - O, u), l || (u = zh(h, u, _C1));
  }
  return Rk(o, 0, i + Yq(u) + s);
}, wC1 = function() {
  var t = 1, e = 0;
  return {
    p: function(n) {
      for (var i = t, s = e, l = n.length, a = 0; a != l; ) {
        for (var o = Math.min(a + 5552, l); a < o; ++a)
          i += n[a], s += i;
        i %= 65521, s %= 65521;
      }
      t = i, e = s;
    },
    d: function() {
      return (t >>> 8 << 16 | (e & 255) << 8 | e >>> 8) + ((t & 255) << 23) * 2;
    }
  };
}, zC1 = function(t, e, n, i, s) {
  return qC1(t, e.level == null ? 6 : e.level, e.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(t.length))) * 1.5) : 12 + e.mem, n, i, !s);
}, MC1 = function(t, e, n) {
  for (; n; ++e)
    t[e] = n, n >>>= 8;
}, bC1 = function(t, e) {
  var n = e.level, i = n == 0 ? 0 : n < 6 ? 1 : n == 9 ? 3 : 2;
  t[0] = 120, t[1] = i << 6 | (i ? 32 - 2 * i : 1);
}, LC1 = function(t) {
  if ((t[0] & 15) != 8 || t[0] >>> 4 > 7 || (t[0] << 8 | t[1]) % 31)
    throw "invalid zlib data";
  if (t[1] & 32)
    throw "invalid zlib data: preset dictionaries not supported";
};
function Xy(t, e) {
  e === void 0 && (e = {});
  var n = wC1();
  n.p(t);
  var i = zC1(t, e, 2, 4);
  return bC1(i, e), MC1(i, i.length - 4, n.d()), i;
}
function xC1(t, e) {
  return gC1((LC1(t), t.subarray(2, -4)), e);
}
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.1 Built on 2022-01-28T15:37:57.791Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
var g3 = function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
}();
function Kg() {
  g3.console && typeof g3.console.log == "function" && g3.console.log.apply(g3.console, arguments);
}
var at = { log: Kg, warn: function(t) {
  g3.console && (typeof g3.console.warn == "function" ? g3.console.warn.apply(g3.console, arguments) : Kg.call(null, arguments));
}, error: function(t) {
  g3.console && (typeof g3.console.error == "function" ? g3.console.error.apply(g3.console, arguments) : Kg(t));
} };
function Zg(t, e, n) {
  var i = new XMLHttpRequest();
  i.open("GET", t), i.responseType = "blob", i.onload = function() {
    Kl(i.response, e, n);
  }, i.onerror = function() {
    at.error("could not download file");
  }, i.send();
}
function BM(t) {
  var e = new XMLHttpRequest();
  e.open("HEAD", t, !1);
  try {
    e.send();
  } catch {
  }
  return e.status >= 200 && e.status <= 299;
}
function ah(t) {
  try {
    t.dispatchEvent(new MouseEvent("click"));
  } catch {
    var e = document.createEvent("MouseEvents");
    e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
  }
}
var ko, Ky, Kl = g3.saveAs || ((typeof window > "u" ? "undefined" : Ye(window)) !== "object" || window !== g3 ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(t, e, n) {
  var i = g3.URL || g3.webkitURL, s = document.createElement("a");
  e = e || t.name || "download", s.download = e, s.rel = "noopener", typeof t == "string" ? (s.href = t, s.origin !== location.origin ? BM(s.href) ? Zg(t, e, n) : ah(s, s.target = "_blank") : ah(s)) : (s.href = i.createObjectURL(t), setTimeout(function() {
    i.revokeObjectURL(s.href);
  }, 4e4), setTimeout(function() {
    ah(s);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(t, e, n) {
  if (e = e || t.name || "download", typeof t == "string")
    if (BM(t))
      Zg(t, e, n);
    else {
      var i = document.createElement("a");
      i.href = t, i.target = "_blank", setTimeout(function() {
        ah(i);
      });
    }
  else
    navigator.msSaveOrOpenBlob(function(s, l) {
      return l === void 0 ? l = { autoBom: !1 } : Ye(l) !== "object" && (at.warn("Deprecated: Expected third argument to be a object"), l = { autoBom: !l }), l.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(s.type) ? new Blob([String.fromCharCode(65279), s], { type: s.type }) : s;
    }(t, n), e);
} : function(t, e, n, i) {
  if ((i = i || open("", "_blank")) && (i.document.title = i.document.body.innerText = "downloading..."), typeof t == "string")
    return Zg(t, e, n);
  var s = t.type === "application/octet-stream", l = /constructor/i.test(g3.HTMLElement) || g3.safari, a = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((a || s && l) && (typeof FileReader > "u" ? "undefined" : Ye(FileReader)) === "object") {
    var o = new FileReader();
    o.onloadend = function() {
      var d = o.result;
      d = a ? d : d.replace(/^data:[^;]*;/, "data:attachment/file;"), i ? i.location.href = d : location = d, i = null;
    }, o.readAsDataURL(t);
  } else {
    var h = g3.URL || g3.webkitURL, u = h.createObjectURL(t);
    i ? i.location = u : location.href = u, i = null, setTimeout(function() {
      h.revokeObjectURL(u);
    }, 4e4);
  }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */
function Hk(t) {
  var e;
  t = t || "", this.ok = !1, t.charAt(0) == "#" && (t = t.substr(1, 6)), t = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
  for (var n = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(o) {
    return [parseInt(o[1]), parseInt(o[2]), parseInt(o[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(o) {
    return [parseInt(o[1], 16), parseInt(o[2], 16), parseInt(o[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(o) {
    return [parseInt(o[1] + o[1], 16), parseInt(o[2] + o[2], 16), parseInt(o[3] + o[3], 16)];
  } }], i = 0; i < n.length; i++) {
    var s = n[i].re, l = n[i].process, a = s.exec(t);
    a && (e = l(a), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var o = this.r.toString(16), h = this.g.toString(16), u = this.b.toString(16);
    return o.length == 1 && (o = "0" + o), h.length == 1 && (h = "0" + h), u.length == 1 && (u = "0" + u), "#" + o + h + u;
  };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function Jg(t, e) {
  var n = t[0], i = t[1], s = t[2], l = t[3];
  n = o5(n, i, s, l, e[0], 7, -680876936), l = o5(l, n, i, s, e[1], 12, -389564586), s = o5(s, l, n, i, e[2], 17, 606105819), i = o5(i, s, l, n, e[3], 22, -1044525330), n = o5(n, i, s, l, e[4], 7, -176418897), l = o5(l, n, i, s, e[5], 12, 1200080426), s = o5(s, l, n, i, e[6], 17, -1473231341), i = o5(i, s, l, n, e[7], 22, -45705983), n = o5(n, i, s, l, e[8], 7, 1770035416), l = o5(l, n, i, s, e[9], 12, -1958414417), s = o5(s, l, n, i, e[10], 17, -42063), i = o5(i, s, l, n, e[11], 22, -1990404162), n = o5(n, i, s, l, e[12], 7, 1804603682), l = o5(l, n, i, s, e[13], 12, -40341101), s = o5(s, l, n, i, e[14], 17, -1502002290), n = c5(n, i = o5(i, s, l, n, e[15], 22, 1236535329), s, l, e[1], 5, -165796510), l = c5(l, n, i, s, e[6], 9, -1069501632), s = c5(s, l, n, i, e[11], 14, 643717713), i = c5(i, s, l, n, e[0], 20, -373897302), n = c5(n, i, s, l, e[5], 5, -701558691), l = c5(l, n, i, s, e[10], 9, 38016083), s = c5(s, l, n, i, e[15], 14, -660478335), i = c5(i, s, l, n, e[4], 20, -405537848), n = c5(n, i, s, l, e[9], 5, 568446438), l = c5(l, n, i, s, e[14], 9, -1019803690), s = c5(s, l, n, i, e[3], 14, -187363961), i = c5(i, s, l, n, e[8], 20, 1163531501), n = c5(n, i, s, l, e[13], 5, -1444681467), l = c5(l, n, i, s, e[2], 9, -51403784), s = c5(s, l, n, i, e[7], 14, 1735328473), n = h5(n, i = c5(i, s, l, n, e[12], 20, -1926607734), s, l, e[5], 4, -378558), l = h5(l, n, i, s, e[8], 11, -2022574463), s = h5(s, l, n, i, e[11], 16, 1839030562), i = h5(i, s, l, n, e[14], 23, -35309556), n = h5(n, i, s, l, e[1], 4, -1530992060), l = h5(l, n, i, s, e[4], 11, 1272893353), s = h5(s, l, n, i, e[7], 16, -155497632), i = h5(i, s, l, n, e[10], 23, -1094730640), n = h5(n, i, s, l, e[13], 4, 681279174), l = h5(l, n, i, s, e[0], 11, -358537222), s = h5(s, l, n, i, e[3], 16, -722521979), i = h5(i, s, l, n, e[6], 23, 76029189), n = h5(n, i, s, l, e[9], 4, -640364487), l = h5(l, n, i, s, e[12], 11, -421815835), s = h5(s, l, n, i, e[15], 16, 530742520), n = u5(n, i = h5(i, s, l, n, e[2], 23, -995338651), s, l, e[0], 6, -198630844), l = u5(l, n, i, s, e[7], 10, 1126891415), s = u5(s, l, n, i, e[14], 15, -1416354905), i = u5(i, s, l, n, e[5], 21, -57434055), n = u5(n, i, s, l, e[12], 6, 1700485571), l = u5(l, n, i, s, e[3], 10, -1894986606), s = u5(s, l, n, i, e[10], 15, -1051523), i = u5(i, s, l, n, e[1], 21, -2054922799), n = u5(n, i, s, l, e[8], 6, 1873313359), l = u5(l, n, i, s, e[15], 10, -30611744), s = u5(s, l, n, i, e[6], 15, -1560198380), i = u5(i, s, l, n, e[13], 21, 1309151649), n = u5(n, i, s, l, e[4], 6, -145523070), l = u5(l, n, i, s, e[11], 10, -1120210379), s = u5(s, l, n, i, e[2], 15, 718787259), i = u5(i, s, l, n, e[9], 21, -343485551), t[0] = Ms(n, t[0]), t[1] = Ms(i, t[1]), t[2] = Ms(s, t[2]), t[3] = Ms(l, t[3]);
}
function hd(t, e, n, i, s, l) {
  return e = Ms(Ms(e, t), Ms(i, l)), Ms(e << s | e >>> 32 - s, n);
}
function o5(t, e, n, i, s, l, a) {
  return hd(e & n | ~e & i, t, e, s, l, a);
}
function c5(t, e, n, i, s, l, a) {
  return hd(e & i | n & ~i, t, e, s, l, a);
}
function h5(t, e, n, i, s, l, a) {
  return hd(e ^ n ^ i, t, e, s, l, a);
}
function u5(t, e, n, i, s, l, a) {
  return hd(n ^ (e | ~i), t, e, s, l, a);
}
function Dk(t) {
  var e, n = t.length, i = [1732584193, -271733879, -1732584194, 271733878];
  for (e = 64; e <= t.length; e += 64)
    Jg(i, SC1(t.substring(e - 64, e)));
  t = t.substring(e - 64);
  var s = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (e = 0; e < t.length; e++)
    s[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
  if (s[e >> 2] |= 128 << (e % 4 << 3), e > 55)
    for (Jg(i, s), e = 0; e < 16; e++)
      s[e] = 0;
  return s[14] = 8 * n, Jg(i, s), i;
}
function SC1(t) {
  var e, n = [];
  for (e = 0; e < 64; e += 4)
    n[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
  return n;
}
ko = g3.atob.bind(g3), Ky = g3.btoa.bind(g3);
var VM = "0123456789abcdef".split("");
function CC1(t) {
  for (var e = "", n = 0; n < 4; n++)
    e += VM[t >> 8 * n + 4 & 15] + VM[t >> 8 * n & 15];
  return e;
}
function kC1(t) {
  return String.fromCharCode((255 & t) >> 0, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function Zy(t) {
  return Dk(t).map(kC1).join("");
}
var EC1 = function(t) {
  for (var e = 0; e < t.length; e++)
    t[e] = CC1(t[e]);
  return t.join("");
}(Dk("hello")) != "5d41402abc4b2a76b9719d911017c592";
function Ms(t, e) {
  if (EC1) {
    var n = (65535 & t) + (65535 & e);
    return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
  }
  return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */
function Jy(t, e) {
  var n, i, s, l;
  if (t !== n) {
    for (var a = (s = t, l = 1 + (256 / t.length >> 0), new Array(l + 1).join(s)), o = [], h = 0; h < 256; h++)
      o[h] = h;
    var u = 0;
    for (h = 0; h < 256; h++) {
      var d = o[h];
      u = (u + d + a.charCodeAt(h)) % 256, o[h] = o[u], o[u] = d;
    }
    n = t, i = o;
  } else
    o = i;
  var v = e.length, m = 0, p = 0, _ = "";
  for (h = 0; h < v; h++)
    p = (p + (d = o[m = (m + 1) % 256])) % 256, o[m] = o[p], o[p] = d, a = o[(o[m] + o[p]) % 256], _ += String.fromCharCode(e.charCodeAt(h) ^ a);
  return _;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */
var RM = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function ha(t, e, n, i) {
  this.v = 1, this.r = 2;
  var s = 192;
  t.forEach(function(o) {
    if (RM.perm !== void 0)
      throw new Error("Invalid permission: " + o);
    s += RM[o];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var l = (e + this.padding).substr(0, 32), a = (n + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(l, a), this.P = -(1 + (255 ^ s)), this.encryptionKey = Zy(l + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(i)).substr(0, 5), this.U = Jy(this.encryptionKey, this.padding);
}
function ua(t) {
  if (/[^\u0000-\u00ff]/.test(t))
    throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
  for (var e = "", n = t.length, i = 0; i < n; i++) {
    var s = t.charCodeAt(i);
    s < 33 || s === 35 || s === 37 || s === 40 || s === 41 || s === 47 || s === 60 || s === 62 || s === 91 || s === 93 || s === 123 || s === 125 || s > 126 ? e += "#" + ("0" + s.toString(16)).slice(-2) : e += t[i];
  }
  return e;
}
function HM(t) {
  if (Ye(t) !== "object")
    throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var e = {};
  this.subscribe = function(n, i, s) {
    if (s = s || !1, typeof n != "string" || typeof i != "function" || typeof s != "boolean")
      throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    e.hasOwnProperty(n) || (e[n] = {});
    var l = Math.random().toString(35);
    return e[n][l] = [i, !!s], l;
  }, this.unsubscribe = function(n) {
    for (var i in e)
      if (e[i][n])
        return delete e[i][n], Object.keys(e[i]).length === 0 && delete e[i], !0;
    return !1;
  }, this.publish = function(n) {
    if (e.hasOwnProperty(n)) {
      var i = Array.prototype.slice.call(arguments, 1), s = [];
      for (var l in e[n]) {
        var a = e[n][l];
        try {
          a[0].apply(t, i);
        } catch (o) {
          g3.console && at.error("jsPDF PubSub Error", o.message, o);
        }
        a[1] && s.push(l);
      }
      s.length && s.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return e;
  };
}
function du(t) {
  if (!(this instanceof du))
    return new du(t);
  var e = "opacity,stroke-opacity".split(",");
  for (var n in t)
    t.hasOwnProperty(n) && e.indexOf(n) >= 0 && (this[n] = t[n]);
  this.id = "", this.objectNumber = -1;
}
function $k(t, e) {
  this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function Jl(t, e, n, i, s) {
  if (!(this instanceof Jl))
    return new Jl(t, e, n, i, s);
  this.type = t === "axial" ? 2 : 3, this.coords = e, this.colors = n, $k.call(this, i, s);
}
function wa(t, e, n, i, s) {
  if (!(this instanceof wa))
    return new wa(t, e, n, i, s);
  this.boundingBox = t, this.xStep = e, this.yStep = n, this.stream = "", this.cloneIndex = 0, $k.call(this, i, s);
}
function m3(t) {
  var e, n = typeof arguments[0] == "string" ? arguments[0] : "p", i = arguments[1], s = arguments[2], l = arguments[3], a = [], o = 1, h = 16, u = "S", d = null;
  Ye(t = t || {}) === "object" && (n = t.orientation, i = t.unit || i, s = t.format || s, l = t.compress || t.compressPdf || l, (d = t.encryption || null) !== null && (d.userPassword = d.userPassword || "", d.ownerPassword = d.ownerPassword || "", d.userPermissions = d.userPermissions || []), o = typeof t.userUnit == "number" ? Math.abs(t.userUnit) : 1, t.precision !== void 0 && (e = t.precision), t.floatPrecision !== void 0 && (h = t.floatPrecision), u = t.defaultPathOperation || "S"), a = t.filters || (l === !0 ? ["FlateEncode"] : a), i = i || "mm", n = ("" + (n || "P")).toLowerCase();
  var v = t.putOnlyUsedFonts || !1, m = {}, p = { internal: {}, __private__: {} };
  p.__private__.PubSub = HM;
  var _ = "1.3", q = p.__private__.getPdfVersion = function() {
    return _;
  };
  p.__private__.setPdfVersion = function(S) {
    _ = S;
  };
  var M = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  p.__private__.getPageFormats = function() {
    return M;
  };
  var z = p.__private__.getPageFormat = function(S) {
    return M[S];
  };
  s = s || "a4";
  var b = { COMPAT: "compat", ADVANCED: "advanced" }, x = b.COMPAT;
  function k() {
    this.saveGraphicsState(), p1(new D2(g2, 0, 0, -g2, 0, Q4() * g2).toString() + " cm"), this.setFontSize(this.getFontSize() / g2), u = "n", x = b.ADVANCED;
  }
  function F() {
    this.restoreGraphicsState(), u = "S", x = b.COMPAT;
  }
  var D = p.__private__.combineFontStyleAndFontWeight = function(S, X) {
    if (S == "bold" && X == "normal" || S == "bold" && X == 400 || S == "normal" && X == "italic" || S == "bold" && X == "italic")
      throw new Error("Invalid Combination of fontweight and fontstyle");
    return X && (S = X == 400 || X === "normal" ? S === "italic" ? "italic" : "normal" : X != 700 && X !== "bold" || S !== "normal" ? (X == 700 ? "bold" : X) + "" + S : "bold"), S;
  };
  p.advancedAPI = function(S) {
    var X = x === b.COMPAT;
    return X && k.call(this), typeof S != "function" || (S(this), X && F.call(this)), this;
  }, p.compatAPI = function(S) {
    var X = x === b.ADVANCED;
    return X && F.call(this), typeof S != "function" || (S(this), X && k.call(this)), this;
  }, p.isAdvancedAPI = function() {
    return x === b.ADVANCED;
  };
  var R, V = function(S) {
    if (x !== b.ADVANCED)
      throw new Error(S + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, J = p.roundToPrecision = p.__private__.roundToPrecision = function(S, X) {
    var v1 = e || X;
    if (isNaN(S) || isNaN(v1))
      throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return S.toFixed(v1).replace(/0+$/, "");
  };
  R = p.hpf = p.__private__.hpf = typeof h == "number" ? function(S) {
    if (isNaN(S))
      throw new Error("Invalid argument passed to jsPDF.hpf");
    return J(S, h);
  } : h === "smart" ? function(S) {
    if (isNaN(S))
      throw new Error("Invalid argument passed to jsPDF.hpf");
    return J(S, S > -1 && S < 1 ? 16 : 5);
  } : function(S) {
    if (isNaN(S))
      throw new Error("Invalid argument passed to jsPDF.hpf");
    return J(S, 16);
  };
  var K = p.f2 = p.__private__.f2 = function(S) {
    if (isNaN(S))
      throw new Error("Invalid argument passed to jsPDF.f2");
    return J(S, 2);
  }, P = p.__private__.f3 = function(S) {
    if (isNaN(S))
      throw new Error("Invalid argument passed to jsPDF.f3");
    return J(S, 3);
  }, O = p.scale = p.__private__.scale = function(S) {
    if (isNaN(S))
      throw new Error("Invalid argument passed to jsPDF.scale");
    return x === b.COMPAT ? S * g2 : x === b.ADVANCED ? S : void 0;
  }, G = function(S) {
    return x === b.COMPAT ? Q4() - S : x === b.ADVANCED ? S : void 0;
  }, j = function(S) {
    return O(G(S));
  };
  p.__private__.setPrecision = p.setPrecision = function(S) {
    typeof parseInt(S, 10) == "number" && (e = parseInt(S, 10));
  };
  var Q, i1 = "00000000000000000000000000000000", h1 = p.__private__.getFileId = function() {
    return i1;
  }, c1 = p.__private__.setFileId = function(S) {
    return i1 = S !== void 0 && /^[a-fA-F0-9]{32}$/.test(S) ? S.toUpperCase() : i1.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), d !== null && (n4 = new ha(d.userPermissions, d.userPassword, d.ownerPassword, i1)), i1;
  };
  p.setFileId = function(S) {
    return c1(S), this;
  }, p.getFileId = function() {
    return h1();
  };
  var M1 = p.__private__.convertDateToPDFDate = function(S) {
    var X = S.getTimezoneOffset(), v1 = X < 0 ? "+" : "-", z1 = Math.floor(Math.abs(X / 60)), F1 = Math.abs(X % 60), H1 = [v1, n1(z1), "'", n1(F1), "'"].join("");
    return ["D:", S.getFullYear(), n1(S.getMonth() + 1), n1(S.getDate()), n1(S.getHours()), n1(S.getMinutes()), n1(S.getSeconds()), H1].join("");
  }, y1 = p.__private__.convertPDFDateToDate = function(S) {
    var X = parseInt(S.substr(2, 4), 10), v1 = parseInt(S.substr(6, 2), 10) - 1, z1 = parseInt(S.substr(8, 2), 10), F1 = parseInt(S.substr(10, 2), 10), H1 = parseInt(S.substr(12, 2), 10), J1 = parseInt(S.substr(14, 2), 10);
    return new Date(X, v1, z1, F1, H1, J1, 0);
  }, A1 = p.__private__.setCreationDate = function(S) {
    var X;
    if (S === void 0 && (S = /* @__PURE__ */ new Date()), S instanceof Date)
      X = M1(S);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(S))
        throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      X = S;
    }
    return Q = X;
  }, $ = p.__private__.getCreationDate = function(S) {
    var X = Q;
    return S === "jsDate" && (X = y1(Q)), X;
  };
  p.setCreationDate = function(S) {
    return A1(S), this;
  }, p.getCreationDate = function(S) {
    return $(S);
  };
  var a1, n1 = p.__private__.padd2 = function(S) {
    return ("0" + parseInt(S)).slice(-2);
  }, f1 = p.__private__.padd2Hex = function(S) {
    return ("00" + (S = S.toString())).substr(S.length);
  }, w1 = 0, C1 = [], E1 = [], T1 = 0, n2 = [], X1 = [], a2 = !1, d2 = E1, y2 = function() {
    w1 = 0, T1 = 0, E1 = [], C1 = [], n2 = [], m0 = oe(), _5 = oe();
  };
  p.__private__.setCustomOutputDestination = function(S) {
    a2 = !0, d2 = S;
  };
  var B1 = function(S) {
    a2 || (d2 = S);
  };
  p.__private__.resetCustomOutputDestination = function() {
    a2 = !1, d2 = E1;
  };
  var p1 = p.__private__.out = function(S) {
    return S = S.toString(), T1 += S.length + 1, d2.push(S), d2;
  }, _2 = p.__private__.write = function(S) {
    return p1(arguments.length === 1 ? S.toString() : Array.prototype.join.call(arguments, " "));
  }, w2 = p.__private__.getArrayBuffer = function(S) {
    for (var X = S.length, v1 = new ArrayBuffer(X), z1 = new Uint8Array(v1); X--; )
      z1[X] = S.charCodeAt(X);
    return v1;
  }, K1 = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  p.__private__.getStandardFonts = function() {
    return K1;
  };
  var e2 = t.fontSize || 16;
  p.__private__.setFontSize = p.setFontSize = function(S) {
    return e2 = x === b.ADVANCED ? S / g2 : S, this;
  };
  var Z1, t2 = p.__private__.getFontSize = p.getFontSize = function() {
    return x === b.COMPAT ? e2 : e2 * g2;
  }, S2 = t.R2L || !1;
  p.__private__.setR2L = p.setR2L = function(S) {
    return S2 = S, this;
  }, p.__private__.getR2L = p.getR2L = function() {
    return S2;
  };
  var W2, E2 = p.__private__.setZoomMode = function(S) {
    var X = [void 0, null, "fullwidth", "fullheight", "fullpage", "original"];
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(S))
      Z1 = S;
    else if (isNaN(S)) {
      if (X.indexOf(S) === -1)
        throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + S + '" is not recognized.');
      Z1 = S;
    } else
      Z1 = parseInt(S, 10);
  };
  p.__private__.getZoomMode = function() {
    return Z1;
  };
  var o3, n3 = p.__private__.setPageMode = function(S) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(S) == -1)
      throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + S + '" is not recognized.');
    W2 = S;
  };
  p.__private__.getPageMode = function() {
    return W2;
  };
  var c3 = p.__private__.setLayoutMode = function(S) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(S) == -1)
      throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + S + '" is not recognized.');
    o3 = S;
  };
  p.__private__.getLayoutMode = function() {
    return o3;
  }, p.__private__.setDisplayMode = p.setDisplayMode = function(S, X, v1) {
    return E2(S), c3(X), n3(v1), this;
  };
  var G2 = { title: "", subject: "", author: "", keywords: "", creator: "" };
  p.__private__.getDocumentProperty = function(S) {
    if (Object.keys(G2).indexOf(S) === -1)
      throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return G2[S];
  }, p.__private__.getDocumentProperties = function() {
    return G2;
  }, p.__private__.setDocumentProperties = p.setProperties = p.setDocumentProperties = function(S) {
    for (var X in G2)
      G2.hasOwnProperty(X) && S[X] && (G2[X] = S[X]);
    return this;
  }, p.__private__.setDocumentProperty = function(S, X) {
    if (Object.keys(G2).indexOf(S) === -1)
      throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return G2[S] = X;
  };
  var u3, g2, Oe, q3, ht, E3 = {}, j3 = {}, z2 = [], R2 = {}, w3 = {}, B3 = {}, G3 = {}, Se = null, _e = 0, d3 = [], Z3 = new HM(p), yt = t.hotfixes || [], Ce = {}, tt = {}, ut = [], D2 = function S(X, v1, z1, F1, H1, J1) {
    if (!(this instanceof S))
      return new S(X, v1, z1, F1, H1, J1);
    isNaN(X) && (X = 1), isNaN(v1) && (v1 = 0), isNaN(z1) && (z1 = 0), isNaN(F1) && (F1 = 1), isNaN(H1) && (H1 = 0), isNaN(J1) && (J1 = 0), this._matrix = [X, v1, z1, F1, H1, J1];
  };
  Object.defineProperty(D2.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(S) {
    this._matrix[0] = S;
  } }), Object.defineProperty(D2.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(S) {
    this._matrix[1] = S;
  } }), Object.defineProperty(D2.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(S) {
    this._matrix[2] = S;
  } }), Object.defineProperty(D2.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(S) {
    this._matrix[3] = S;
  } }), Object.defineProperty(D2.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(S) {
    this._matrix[4] = S;
  } }), Object.defineProperty(D2.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(S) {
    this._matrix[5] = S;
  } }), Object.defineProperty(D2.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(S) {
    this._matrix[0] = S;
  } }), Object.defineProperty(D2.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(S) {
    this._matrix[1] = S;
  } }), Object.defineProperty(D2.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(S) {
    this._matrix[2] = S;
  } }), Object.defineProperty(D2.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(S) {
    this._matrix[3] = S;
  } }), Object.defineProperty(D2.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(S) {
    this._matrix[4] = S;
  } }), Object.defineProperty(D2.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(S) {
    this._matrix[5] = S;
  } }), Object.defineProperty(D2.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(D2.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(D2.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(D2.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), D2.prototype.join = function(S) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(R).join(S);
  }, D2.prototype.multiply = function(S) {
    var X = S.sx * this.sx + S.shy * this.shx, v1 = S.sx * this.shy + S.shy * this.sy, z1 = S.shx * this.sx + S.sy * this.shx, F1 = S.shx * this.shy + S.sy * this.sy, H1 = S.tx * this.sx + S.ty * this.shx + this.tx, J1 = S.tx * this.shy + S.ty * this.sy + this.ty;
    return new D2(X, v1, z1, F1, H1, J1);
  }, D2.prototype.decompose = function() {
    var S = this.sx, X = this.shy, v1 = this.shx, z1 = this.sy, F1 = this.tx, H1 = this.ty, J1 = Math.sqrt(S * S + X * X), F2 = (S /= J1) * v1 + (X /= J1) * z1;
    v1 -= S * F2, z1 -= X * F2;
    var Z2 = Math.sqrt(v1 * v1 + z1 * z1);
    return F2 /= Z2, S * (z1 /= Z2) < X * (v1 /= Z2) && (S = -S, X = -X, F2 = -F2, J1 = -J1), { scale: new D2(J1, 0, 0, Z2, 0, 0), translate: new D2(1, 0, 0, 1, F1, H1), rotate: new D2(S, X, -X, S, 0, 0), skew: new D2(1, 0, F2, 1, 0, 0) };
  }, D2.prototype.toString = function(S) {
    return this.join(" ");
  }, D2.prototype.inversed = function() {
    var S = this.sx, X = this.shy, v1 = this.shx, z1 = this.sy, F1 = this.tx, H1 = this.ty, J1 = 1 / (S * z1 - X * v1), F2 = z1 * J1, Z2 = -X * J1, v3 = -v1 * J1, y3 = S * J1;
    return new D2(F2, Z2, v3, y3, -F2 * F1 - v3 * H1, -Z2 * F1 - y3 * H1);
  }, D2.prototype.applyToPoint = function(S) {
    var X = S.x * this.sx + S.y * this.shx + this.tx, v1 = S.x * this.shy + S.y * this.sy + this.ty;
    return new qe(X, v1);
  }, D2.prototype.applyToRectangle = function(S) {
    var X = this.applyToPoint(S), v1 = this.applyToPoint(new qe(S.x + S.w, S.y + S.h));
    return new Ci(X.x, X.y, v1.x - X.x, v1.y - X.y);
  }, D2.prototype.clone = function() {
    var S = this.sx, X = this.shy, v1 = this.shx, z1 = this.sy, F1 = this.tx, H1 = this.ty;
    return new D2(S, X, v1, z1, F1, H1);
  }, p.Matrix = D2;
  var Re = p.matrixMult = function(S, X) {
    return X.multiply(S);
  }, _t = new D2(1, 0, 0, 1, 0, 0);
  p.unitMatrix = p.identityMatrix = _t;
  var L3 = function(S, X) {
    if (!w3[S]) {
      var v1 = (X instanceof Jl ? "Sh" : "P") + (Object.keys(R2).length + 1).toString(10);
      X.id = v1, w3[S] = v1, R2[v1] = X, Z3.publish("addPattern", X);
    }
  };
  p.ShadingPattern = Jl, p.TilingPattern = wa, p.addShadingPattern = function(S, X) {
    return V("addShadingPattern()"), L3(S, X), this;
  }, p.beginTilingPattern = function(S) {
    V("beginTilingPattern()"), At(S.boundingBox[0], S.boundingBox[1], S.boundingBox[2] - S.boundingBox[0], S.boundingBox[3] - S.boundingBox[1], S.matrix);
  }, p.endTilingPattern = function(S, X) {
    V("endTilingPattern()"), X.stream = X1[a1].join(`
`), L3(S, X), Z3.publish("endTilingPattern", X), ut.pop().restore();
  };
  var W3 = p.__private__.newObject = function() {
    var S = oe();
    return v4(S, !0), S;
  }, oe = p.__private__.newObjectDeferred = function() {
    return w1++, C1[w1] = function() {
      return T1;
    }, w1;
  }, v4 = function(S, X) {
    return X = typeof X == "boolean" && X, C1[S] = T1, X && p1(S + " 0 obj"), S;
  }, wn = p.__private__.newAdditionalObject = function() {
    var S = { objId: oe(), content: "" };
    return n2.push(S), S;
  }, m0 = oe(), _5 = oe(), q5 = p.__private__.decodeColorString = function(S) {
    var X = S.split(" ");
    if (X.length !== 2 || X[1] !== "g" && X[1] !== "G")
      X.length === 5 && (X[4] === "k" || X[4] === "K") && (X = [(1 - X[0]) * (1 - X[3]), (1 - X[1]) * (1 - X[3]), (1 - X[2]) * (1 - X[3]), "r"]);
    else {
      var v1 = parseFloat(X[0]);
      X = [v1, v1, v1, "r"];
    }
    for (var z1 = "#", F1 = 0; F1 < 3; F1++)
      z1 += ("0" + Math.floor(255 * parseFloat(X[F1])).toString(16)).slice(-2);
    return z1;
  }, w5 = p.__private__.encodeColorString = function(S) {
    var X;
    typeof S == "string" && (S = { ch1: S });
    var v1 = S.ch1, z1 = S.ch2, F1 = S.ch3, H1 = S.ch4, J1 = S.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof v1 == "string" && v1.charAt(0) !== "#") {
      var F2 = new Hk(v1);
      if (F2.ok)
        v1 = F2.toHex();
      else if (!/^\d*\.?\d*$/.test(v1))
        throw new Error('Invalid color "' + v1 + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof v1 == "string" && /^#[0-9A-Fa-f]{3}$/.test(v1) && (v1 = "#" + v1[1] + v1[1] + v1[2] + v1[2] + v1[3] + v1[3]), typeof v1 == "string" && /^#[0-9A-Fa-f]{6}$/.test(v1)) {
      var Z2 = parseInt(v1.substr(1), 16);
      v1 = Z2 >> 16 & 255, z1 = Z2 >> 8 & 255, F1 = 255 & Z2;
    }
    if (z1 === void 0 || H1 === void 0 && v1 === z1 && z1 === F1)
      if (typeof v1 == "string")
        X = v1 + " " + J1[0];
      else
        switch (S.precision) {
          case 2:
            X = K(v1 / 255) + " " + J1[0];
            break;
          case 3:
          default:
            X = P(v1 / 255) + " " + J1[0];
        }
    else if (H1 === void 0 || Ye(H1) === "object") {
      if (H1 && !isNaN(H1.a) && H1.a === 0)
        return X = ["1.", "1.", "1.", J1[1]].join(" ");
      if (typeof v1 == "string")
        X = [v1, z1, F1, J1[1]].join(" ");
      else
        switch (S.precision) {
          case 2:
            X = [K(v1 / 255), K(z1 / 255), K(F1 / 255), J1[1]].join(" ");
            break;
          default:
          case 3:
            X = [P(v1 / 255), P(z1 / 255), P(F1 / 255), J1[1]].join(" ");
        }
    } else if (typeof v1 == "string")
      X = [v1, z1, F1, H1, J1[2]].join(" ");
    else
      switch (S.precision) {
        case 2:
          X = [K(v1), K(z1), K(F1), K(H1), J1[2]].join(" ");
          break;
        case 3:
        default:
          X = [P(v1), P(z1), P(F1), P(H1), J1[2]].join(" ");
      }
    return X;
  }, X4 = p.__private__.getFilters = function() {
    return a;
  }, K4 = p.__private__.putStream = function(S) {
    var X = (S = S || {}).data || "", v1 = S.filters || X4(), z1 = S.alreadyAppliedFilters || [], F1 = S.addLength1 || !1, H1 = X.length, J1 = S.objectId, F2 = function(wt) {
      return wt;
    };
    if (d !== null && J1 === void 0)
      throw new Error("ObjectId must be passed to putStream for file encryption");
    d !== null && (F2 = n4.encryptor(J1, 0));
    var Z2 = {};
    v1 === !0 && (v1 = ["FlateEncode"]);
    var v3 = S.additionalKeyValues || [], y3 = (Z2 = m3.API.processDataByFilters !== void 0 ? m3.API.processDataByFilters(X, v1) : { data: X, reverseChain: [] }).reverseChain + (Array.isArray(z1) ? z1.join(" ") : z1.toString());
    if (Z2.data.length !== 0 && (v3.push({ key: "Length", value: Z2.data.length }), F1 === !0 && v3.push({ key: "Length1", value: H1 })), y3.length != 0)
      if (y3.split("/").length - 1 == 1)
        v3.push({ key: "Filter", value: y3 });
      else {
        v3.push({ key: "Filter", value: "[" + y3 + "]" });
        for (var P3 = 0; P3 < v3.length; P3 += 1)
          if (v3[P3].key === "DecodeParms") {
            for (var He = [], ot = 0; ot < Z2.reverseChain.split("/").length - 1; ot += 1)
              He.push("null");
            He.push(v3[P3].value), v3[P3].value = "[" + He.join(" ") + "]";
          }
      }
    p1("<<");
    for (var Xe = 0; Xe < v3.length; Xe++)
      p1("/" + v3[Xe].key + " " + v3[Xe].value);
    p1(">>"), Z2.data.length !== 0 && (p1("stream"), p1(F2(Z2.data)), p1("endstream"));
  }, H5 = p.__private__.putPage = function(S) {
    var X = S.number, v1 = S.data, z1 = S.objId, F1 = S.contentsObjId;
    v4(z1, !0), p1("<</Type /Page"), p1("/Parent " + S.rootDictionaryObjId + " 0 R"), p1("/Resources " + S.resourceDictionaryObjId + " 0 R"), p1("/MediaBox [" + parseFloat(R(S.mediaBox.bottomLeftX)) + " " + parseFloat(R(S.mediaBox.bottomLeftY)) + " " + R(S.mediaBox.topRightX) + " " + R(S.mediaBox.topRightY) + "]"), S.cropBox !== null && p1("/CropBox [" + R(S.cropBox.bottomLeftX) + " " + R(S.cropBox.bottomLeftY) + " " + R(S.cropBox.topRightX) + " " + R(S.cropBox.topRightY) + "]"), S.bleedBox !== null && p1("/BleedBox [" + R(S.bleedBox.bottomLeftX) + " " + R(S.bleedBox.bottomLeftY) + " " + R(S.bleedBox.topRightX) + " " + R(S.bleedBox.topRightY) + "]"), S.trimBox !== null && p1("/TrimBox [" + R(S.trimBox.bottomLeftX) + " " + R(S.trimBox.bottomLeftY) + " " + R(S.trimBox.topRightX) + " " + R(S.trimBox.topRightY) + "]"), S.artBox !== null && p1("/ArtBox [" + R(S.artBox.bottomLeftX) + " " + R(S.artBox.bottomLeftY) + " " + R(S.artBox.topRightX) + " " + R(S.artBox.topRightY) + "]"), typeof S.userUnit == "number" && S.userUnit !== 1 && p1("/UserUnit " + S.userUnit), Z3.publish("putPage", { objId: z1, pageContext: d3[X], pageNumber: X, page: v1 }), p1("/Contents " + F1 + " 0 R"), p1(">>"), p1("endobj");
    var H1 = v1.join(`
`);
    return x === b.ADVANCED && (H1 += `
Q`), v4(F1, !0), K4({ data: H1, filters: X4(), objectId: F1 }), p1("endobj"), z1;
  }, F6 = p.__private__.putPages = function() {
    var S, X, v1 = [];
    for (S = 1; S <= _e; S++)
      d3[S].objId = oe(), d3[S].contentsObjId = oe();
    for (S = 1; S <= _e; S++)
      v1.push(H5({ number: S, data: X1[S], objId: d3[S].objId, contentsObjId: d3[S].contentsObjId, mediaBox: d3[S].mediaBox, cropBox: d3[S].cropBox, bleedBox: d3[S].bleedBox, trimBox: d3[S].trimBox, artBox: d3[S].artBox, userUnit: d3[S].userUnit, rootDictionaryObjId: m0, resourceDictionaryObjId: _5 }));
    v4(m0, !0), p1("<</Type /Pages");
    var z1 = "/Kids [";
    for (X = 0; X < _e; X++)
      z1 += v1[X] + " 0 R ";
    p1(z1 + "]"), p1("/Count " + _e), p1(">>"), p1("endobj"), Z3.publish("postPutPages");
  }, zn = function(S) {
    Z3.publish("putFont", { font: S, out: p1, newObject: W3, putStream: K4 }), S.isAlreadyPutted !== !0 && (S.objectNumber = W3(), p1("<<"), p1("/Type /Font"), p1("/BaseFont /" + ua(S.postScriptName)), p1("/Subtype /Type1"), typeof S.encoding == "string" && p1("/Encoding /" + S.encoding), p1("/FirstChar 32"), p1("/LastChar 255"), p1(">>"), p1("endobj"));
  }, Mn = function() {
    for (var S in E3)
      E3.hasOwnProperty(S) && (v === !1 || v === !0 && m.hasOwnProperty(S)) && zn(E3[S]);
  }, bn = function(S) {
    S.objectNumber = W3();
    var X = [];
    X.push({ key: "Type", value: "/XObject" }), X.push({ key: "Subtype", value: "/Form" }), X.push({ key: "BBox", value: "[" + [R(S.x), R(S.y), R(S.x + S.width), R(S.y + S.height)].join(" ") + "]" }), X.push({ key: "Matrix", value: "[" + S.matrix.toString() + "]" });
    var v1 = S.pages[1].join(`
`);
    K4({ data: v1, additionalKeyValues: X, objectId: S.objectNumber }), p1("endobj");
  }, Z4 = function() {
    for (var S in Ce)
      Ce.hasOwnProperty(S) && bn(Ce[S]);
  }, P8 = function(S, X) {
    var v1, z1 = [], F1 = 1 / (X - 1);
    for (v1 = 0; v1 < 1; v1 += F1)
      z1.push(v1);
    if (z1.push(1), S[0].offset != 0) {
      var H1 = { offset: 0, color: S[0].color };
      S.unshift(H1);
    }
    if (S[S.length - 1].offset != 1) {
      var J1 = { offset: 1, color: S[S.length - 1].color };
      S.push(J1);
    }
    for (var F2 = "", Z2 = 0, v3 = 0; v3 < z1.length; v3++) {
      for (v1 = z1[v3]; v1 > S[Z2 + 1].offset; )
        Z2++;
      var y3 = S[Z2].offset, P3 = (v1 - y3) / (S[Z2 + 1].offset - y3), He = S[Z2].color, ot = S[Z2 + 1].color;
      F2 += f1(Math.round((1 - P3) * He[0] + P3 * ot[0]).toString(16)) + f1(Math.round((1 - P3) * He[1] + P3 * ot[1]).toString(16)) + f1(Math.round((1 - P3) * He[2] + P3 * ot[2]).toString(16));
    }
    return F2.trim();
  }, g0 = function(S, X) {
    X || (X = 21);
    var v1 = W3(), z1 = P8(S.colors, X), F1 = [];
    F1.push({ key: "FunctionType", value: "0" }), F1.push({ key: "Domain", value: "[0.0 1.0]" }), F1.push({ key: "Size", value: "[" + X + "]" }), F1.push({ key: "BitsPerSample", value: "8" }), F1.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), F1.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), K4({ data: z1, additionalKeyValues: F1, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: v1 }), p1("endobj"), S.objectNumber = W3(), p1("<< /ShadingType " + S.type), p1("/ColorSpace /DeviceRGB");
    var H1 = "/Coords [" + R(parseFloat(S.coords[0])) + " " + R(parseFloat(S.coords[1])) + " ";
    S.type === 2 ? H1 += R(parseFloat(S.coords[2])) + " " + R(parseFloat(S.coords[3])) : H1 += R(parseFloat(S.coords[2])) + " " + R(parseFloat(S.coords[3])) + " " + R(parseFloat(S.coords[4])) + " " + R(parseFloat(S.coords[5])), p1(H1 += "]"), S.matrix && p1("/Matrix [" + S.matrix.toString() + "]"), p1("/Function " + v1 + " 0 R"), p1("/Extend [true true]"), p1(">>"), p1("endobj");
  }, Ys = function(S, X) {
    var v1 = oe(), z1 = W3();
    X.push({ resourcesOid: v1, objectOid: z1 }), S.objectNumber = z1;
    var F1 = [];
    F1.push({ key: "Type", value: "/Pattern" }), F1.push({ key: "PatternType", value: "1" }), F1.push({ key: "PaintType", value: "1" }), F1.push({ key: "TilingType", value: "1" }), F1.push({ key: "BBox", value: "[" + S.boundingBox.map(R).join(" ") + "]" }), F1.push({ key: "XStep", value: R(S.xStep) }), F1.push({ key: "YStep", value: R(S.yStep) }), F1.push({ key: "Resources", value: v1 + " 0 R" }), S.matrix && F1.push({ key: "Matrix", value: "[" + S.matrix.toString() + "]" }), K4({ data: S.stream, additionalKeyValues: F1, objectId: S.objectNumber }), p1("endobj");
  }, Ln = function(S) {
    var X;
    for (X in R2)
      R2.hasOwnProperty(X) && (R2[X] instanceof Jl ? g0(R2[X]) : R2[X] instanceof wa && Ys(R2[X], S));
  }, B8 = function(S) {
    for (var X in S.objectNumber = W3(), p1("<<"), S)
      switch (X) {
        case "opacity":
          p1("/ca " + K(S[X]));
          break;
        case "stroke-opacity":
          p1("/CA " + K(S[X]));
      }
    p1(">>"), p1("endobj");
  }, mi = function() {
    var S;
    for (S in B3)
      B3.hasOwnProperty(S) && B8(B3[S]);
  }, T6 = function() {
    for (var S in p1("/XObject <<"), Ce)
      Ce.hasOwnProperty(S) && Ce[S].objectNumber >= 0 && p1("/" + S + " " + Ce[S].objectNumber + " 0 R");
    Z3.publish("putXobjectDict"), p1(">>");
  }, gi = function() {
    n4.oid = W3(), p1("<<"), p1("/Filter /Standard"), p1("/V " + n4.v), p1("/R " + n4.r), p1("/U <" + n4.toHexString(n4.U) + ">"), p1("/O <" + n4.toHexString(n4.O) + ">"), p1("/P " + n4.P), p1(">>"), p1("endobj");
  }, V8 = function() {
    for (var S in p1("/Font <<"), E3)
      E3.hasOwnProperty(S) && (v === !1 || v === !0 && m.hasOwnProperty(S)) && p1("/" + S + " " + E3[S].objectNumber + " 0 R");
    p1(">>");
  }, Xs = function() {
    if (Object.keys(R2).length > 0) {
      for (var S in p1("/Shading <<"), R2)
        R2.hasOwnProperty(S) && R2[S] instanceof Jl && R2[S].objectNumber >= 0 && p1("/" + S + " " + R2[S].objectNumber + " 0 R");
      Z3.publish("putShadingPatternDict"), p1(">>");
    }
  }, xn = function(S) {
    if (Object.keys(R2).length > 0) {
      for (var X in p1("/Pattern <<"), R2)
        R2.hasOwnProperty(X) && R2[X] instanceof p.TilingPattern && R2[X].objectNumber >= 0 && R2[X].objectNumber < S && p1("/" + X + " " + R2[X].objectNumber + " 0 R");
      Z3.publish("putTilingPatternDict"), p1(">>");
    }
  }, Ks = function() {
    if (Object.keys(B3).length > 0) {
      var S;
      for (S in p1("/ExtGState <<"), B3)
        B3.hasOwnProperty(S) && B3[S].objectNumber >= 0 && p1("/" + S + " " + B3[S].objectNumber + " 0 R");
      Z3.publish("putGStateDict"), p1(">>");
    }
  }, nt = function(S) {
    v4(S.resourcesOid, !0), p1("<<"), p1("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), V8(), Xs(), xn(S.objectOid), Ks(), T6(), p1(">>"), p1("endobj");
  }, Sn = function() {
    var S = [];
    Mn(), mi(), Z4(), Ln(S), Z3.publish("putResources"), S.forEach(nt), nt({ resourcesOid: _5, objectOid: Number.MAX_SAFE_INTEGER }), Z3.publish("postPutResources");
  }, Cn = function() {
    Z3.publish("putAdditionalObjects");
    for (var S = 0; S < n2.length; S++) {
      var X = n2[S];
      v4(X.objId, !0), p1(X.content), p1("endobj");
    }
    Z3.publish("postPutAdditionalObjects");
  }, G0 = function(S) {
    j3[S.fontName] = j3[S.fontName] || {}, j3[S.fontName][S.fontStyle] = S.id;
  }, yi = function(S, X, v1, z1, F1) {
    var H1 = { id: "F" + (Object.keys(E3).length + 1).toString(10), postScriptName: S, fontName: X, fontStyle: v1, encoding: z1, isStandardFont: F1 || !1, metadata: {} };
    return Z3.publish("addFont", { font: H1, instance: this }), E3[H1.id] = H1, G0(H1), H1.id;
  }, _i = function(S) {
    for (var X = 0, v1 = K1.length; X < v1; X++) {
      var z1 = yi.call(this, S[X][0], S[X][1], S[X][2], K1[X][3], !0);
      v === !1 && (m[z1] = !0);
      var F1 = S[X][0].split("-");
      G0({ id: z1, fontName: F1[0], fontStyle: F1[1] || "" });
    }
    Z3.publish("addFonts", { fonts: E3, dictionary: j3 });
  }, Dt = function(S) {
    return S.foo = function() {
      try {
        return S.apply(this, arguments);
      } catch (z1) {
        var X = z1.stack || "";
        ~X.indexOf(" at ") && (X = X.split(" at ")[1]);
        var v1 = "Error in function " + X.split(`
`)[0].split("<")[0] + ": " + z1.message;
        if (!g3.console)
          throw new Error(v1);
        g3.console.error(v1, z1), g3.alert && alert(v1);
      }
    }, S.foo.bar = S, S.foo;
  }, W0 = function(S, X) {
    var v1, z1, F1, H1, J1, F2, Z2, v3, y3;
    if (F1 = (X = X || {}).sourceEncoding || "Unicode", J1 = X.outputEncoding, (X.autoencode || J1) && E3[u3].metadata && E3[u3].metadata[F1] && E3[u3].metadata[F1].encoding && (H1 = E3[u3].metadata[F1].encoding, !J1 && E3[u3].encoding && (J1 = E3[u3].encoding), !J1 && H1.codePages && (J1 = H1.codePages[0]), typeof J1 == "string" && (J1 = H1[J1]), J1)) {
      for (Z2 = !1, F2 = [], v1 = 0, z1 = S.length; v1 < z1; v1++)
        (v3 = J1[S.charCodeAt(v1)]) ? F2.push(String.fromCharCode(v3)) : F2.push(S[v1]), F2[v1].charCodeAt(0) >> 8 && (Z2 = !0);
      S = F2.join("");
    }
    for (v1 = S.length; Z2 === void 0 && v1 !== 0; )
      S.charCodeAt(v1 - 1) >> 8 && (Z2 = !0), v1--;
    if (!Z2)
      return S;
    for (F2 = X.noBOM ? [] : [254, 255], v1 = 0, z1 = S.length; v1 < z1; v1++) {
      if ((y3 = (v3 = S.charCodeAt(v1)) >> 8) >> 8)
        throw new Error("Character at position " + v1 + " of string '" + S + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
      F2.push(y3), F2.push(v3 - (y3 << 8));
    }
    return String.fromCharCode.apply(void 0, F2);
  }, S4 = p.__private__.pdfEscape = p.pdfEscape = function(S, X) {
    return W0(S, X).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, I6 = p.__private__.beginPage = function(S) {
    X1[++_e] = [], d3[_e] = { objId: 0, contentsObjId: 0, userUnit: Number(o), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(S[0]), topRightY: Number(S[1]) } }, R8(_e), B1(X1[a1]);
  }, kn = function(S, X) {
    var v1, z1, F1;
    switch (n = X || n, typeof S == "string" && (v1 = z(S.toLowerCase()), Array.isArray(v1) && (z1 = v1[0], F1 = v1[1])), Array.isArray(S) && (z1 = S[0] * g2, F1 = S[1] * g2), isNaN(z1) && (z1 = s[0], F1 = s[1]), (z1 > 14400 || F1 > 14400) && (at.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), z1 = Math.min(14400, z1), F1 = Math.min(14400, F1)), s = [z1, F1], n.substr(0, 1)) {
      case "l":
        F1 > z1 && (s = [F1, z1]);
        break;
      case "p":
        z1 > F1 && (s = [F1, z1]);
    }
    I6(s), $8(bi), p1(J3), V6 !== 0 && p1(V6 + " J"), fe !== 0 && p1(fe + " j"), Z3.publish("addPage", { pageNumber: _e });
  }, O6 = function(S) {
    S > 0 && S <= _e && (X1.splice(S, 1), d3.splice(S, 1), _e--, a1 > _e && (a1 = _e), this.setPage(a1));
  }, R8 = function(S) {
    S > 0 && S <= _e && (a1 = S);
  }, qi = p.__private__.getNumberOfPages = p.getNumberOfPages = function() {
    return X1.length - 1;
  }, Y0 = function(S, X, v1) {
    var z1, F1 = void 0;
    return v1 = v1 || {}, S = S !== void 0 ? S : E3[u3].fontName, X = X !== void 0 ? X : E3[u3].fontStyle, z1 = S.toLowerCase(), j3[z1] !== void 0 && j3[z1][X] !== void 0 ? F1 = j3[z1][X] : j3[S] !== void 0 && j3[S][X] !== void 0 ? F1 = j3[S][X] : v1.disableWarning === !1 && at.warn("Unable to look up font label for font '" + S + "', '" + X + "'. Refer to getFontList() for available fonts."), F1 || v1.noFallback || (F1 = j3.times[X]) == null && (F1 = j3.times.normal), F1;
  }, N6 = p.__private__.putInfo = function() {
    var S = W3(), X = function(z1) {
      return z1;
    };
    for (var v1 in d !== null && (X = n4.encryptor(S, 0)), p1("<<"), p1("/Producer (" + S4(X("jsPDF " + m3.version)) + ")"), G2)
      G2.hasOwnProperty(v1) && G2[v1] && p1("/" + v1.substr(0, 1).toUpperCase() + v1.substr(1) + " (" + S4(X(G2[v1])) + ")");
    p1("/CreationDate (" + S4(X(Q)) + ")"), p1(">>"), p1("endobj");
  }, p4 = p.__private__.putCatalog = function(S) {
    var X = (S = S || {}).rootDictionaryObjId || m0;
    switch (W3(), p1("<<"), p1("/Type /Catalog"), p1("/Pages " + X + " 0 R"), Z1 || (Z1 = "fullwidth"), Z1) {
      case "fullwidth":
        p1("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        p1("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        p1("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        p1("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var v1 = "" + Z1;
        v1.substr(v1.length - 1) === "%" && (Z1 = parseInt(Z1) / 100), typeof Z1 == "number" && p1("/OpenAction [3 0 R /XYZ null null " + K(Z1) + "]");
    }
    switch (o3 || (o3 = "continuous"), o3) {
      case "continuous":
        p1("/PageLayout /OneColumn");
        break;
      case "single":
        p1("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        p1("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        p1("/PageLayout /TwoColumnRight");
    }
    W2 && p1("/PageMode /" + W2), Z3.publish("putCatalog"), p1(">>"), p1("endobj");
  }, wi = p.__private__.putTrailer = function() {
    p1("trailer"), p1("<<"), p1("/Size " + (w1 + 1)), p1("/Root " + w1 + " 0 R"), p1("/Info " + (w1 - 1) + " 0 R"), d !== null && p1("/Encrypt " + n4.oid + " 0 R"), p1("/ID [ <" + i1 + "> <" + i1 + "> ]"), p1(">>");
  }, zi = p.__private__.putHeader = function() {
    p1("%PDF-" + _), p1("%ºß¬à");
  }, Zs = p.__private__.putXRef = function() {
    var S = "0000000000";
    p1("xref"), p1("0 " + (w1 + 1)), p1("0000000000 65535 f ");
    for (var X = 1; X <= w1; X++)
      typeof C1[X] == "function" ? p1((S + C1[X]()).slice(-10) + " 00000 n ") : C1[X] !== void 0 ? p1((S + C1[X]).slice(-10) + " 00000 n ") : p1("0000000000 00000 n ");
  }, z5 = p.__private__.buildDocument = function() {
    y2(), B1(E1), Z3.publish("buildDocument"), zi(), F6(), Cn(), Sn(), d !== null && gi(), N6(), p4();
    var S = T1;
    return Zs(), wi(), p1("startxref"), p1("" + S), p1("%%EOF"), B1(X1[a1]), E1.join(`
`);
  }, X0 = p.__private__.getBlob = function(S) {
    return new Blob([w2(S)], { type: "application/pdf" });
  }, K0 = p.output = p.__private__.output = Dt(function(S, X) {
    switch (typeof (X = X || {}) == "string" ? X = { filename: X } : X.filename = X.filename || "generated.pdf", S) {
      case void 0:
        return z5();
      case "save":
        p.save(X.filename);
        break;
      case "arraybuffer":
        return w2(z5());
      case "blob":
        return X0(z5());
      case "bloburi":
      case "bloburl":
        if (g3.URL !== void 0 && typeof g3.URL.createObjectURL == "function")
          return g3.URL && g3.URL.createObjectURL(X0(z5())) || void 0;
        at.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var v1 = "", z1 = z5();
        try {
          v1 = Ky(z1);
        } catch {
          v1 = Ky(unescape(encodeURIComponent(z1)));
        }
        return "data:application/pdf;filename=" + X.filename + ";base64," + v1;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(g3) === "[object Window]") {
          var F1 = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", H1 = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
          X.pdfObjectUrl && (F1 = X.pdfObjectUrl, H1 = "");
          var J1 = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + F1 + '"' + H1 + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(X) + ");<\/script></body></html>", F2 = g3.open();
          return F2 !== null && F2.document.write(J1), F2;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(g3) === "[object Window]") {
          var Z2 = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (X.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + X.filename + '" width="500px" height="400px" /></body></html>', v3 = g3.open();
          if (v3 !== null) {
            v3.document.write(Z2);
            var y3 = this;
            v3.document.documentElement.querySelector("#pdfViewer").onload = function() {
              v3.document.title = X.filename, v3.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(y3.output("bloburl"));
            };
          }
          return v3;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(g3) !== "[object Window]")
          throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var P3 = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", X) + '"></iframe></body></html>', He = g3.open();
        if (He !== null && (He.document.write(P3), He.document.title = X.filename), He || typeof safari > "u")
          return He;
        break;
      case "datauri":
      case "dataurl":
        return g3.document.location.href = this.output("datauristring", X);
      default:
        return null;
    }
  }), En = function(S) {
    return Array.isArray(yt) === !0 && yt.indexOf(S) > -1;
  };
  switch (i) {
    case "pt":
      g2 = 1;
      break;
    case "mm":
      g2 = 72 / 25.4;
      break;
    case "cm":
      g2 = 72 / 2.54;
      break;
    case "in":
      g2 = 72;
      break;
    case "px":
      g2 = En("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      g2 = 12;
      break;
    case "ex":
      g2 = 6;
      break;
    default:
      if (typeof i != "number")
        throw new Error("Invalid unit: " + i);
      g2 = i;
  }
  var n4 = null;
  A1(), c1();
  var Js = function(S) {
    return d !== null ? n4.encryptor(S, 0) : function(X) {
      return X;
    };
  }, H8 = p.__private__.getPageInfo = p.getPageInfo = function(S) {
    if (isNaN(S) || S % 1 != 0)
      throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: d3[S].objId, pageNumber: S, pageContext: d3[S] };
  }, f3 = p.__private__.getPageInfoByObjId = function(S) {
    if (isNaN(S) || S % 1 != 0)
      throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var X in d3)
      if (d3[X].objId === S)
        break;
    return H8(X);
  }, Qs = p.__private__.getCurrentPageInfo = p.getCurrentPageInfo = function() {
    return { objId: d3[a1].objId, pageNumber: a1, pageContext: d3[a1] };
  };
  p.addPage = function() {
    return kn.apply(this, arguments), this;
  }, p.setPage = function() {
    return R8.apply(this, arguments), B1.call(this, X1[a1]), this;
  }, p.insertPage = function(S) {
    return this.addPage(), this.movePage(a1, S), this;
  }, p.movePage = function(S, X) {
    var v1, z1;
    if (S > X) {
      v1 = X1[S], z1 = d3[S];
      for (var F1 = S; F1 > X; F1--)
        X1[F1] = X1[F1 - 1], d3[F1] = d3[F1 - 1];
      X1[X] = v1, d3[X] = z1, this.setPage(X);
    } else if (S < X) {
      v1 = X1[S], z1 = d3[S];
      for (var H1 = S; H1 < X; H1++)
        X1[H1] = X1[H1 + 1], d3[H1] = d3[H1 + 1];
      X1[X] = v1, d3[X] = z1, this.setPage(X);
    }
    return this;
  }, p.deletePage = function() {
    return O6.apply(this, arguments), this;
  }, p.__private__.text = p.text = function(S, X, v1, z1, F1) {
    var H1, J1, F2, Z2, v3, y3, P3, He, ot, Xe = (z1 = z1 || {}).scope || this;
    if (typeof S == "number" && typeof X == "number" && (typeof v1 == "string" || Array.isArray(v1))) {
      var wt = v1;
      v1 = X, X = S, S = wt;
    }
    if (arguments[3] instanceof D2 ? (V("The transform parameter of text() with a Matrix value"), ot = F1) : (F2 = arguments[4], Z2 = arguments[5], Ye(P3 = arguments[3]) === "object" && P3 !== null || (typeof F2 == "string" && (Z2 = F2, F2 = null), typeof P3 == "string" && (Z2 = P3, P3 = null), typeof P3 == "number" && (F2 = P3, P3 = null), z1 = { flags: P3, angle: F2, align: Z2 })), isNaN(X) || isNaN(v1) || S == null)
      throw new Error("Invalid arguments passed to jsPDF.text");
    if (S.length === 0)
      return Xe;
    var Ft = "", B4 = !1, V3 = typeof z1.lineHeightFactor == "number" ? z1.lineHeightFactor : P6, V4 = Xe.internal.scaleFactor;
    function e5($3) {
      return $3 = $3.split("	").join(Array(z1.TabLen || 9).join(" ")), S4($3, P3);
    }
    function H6($3) {
      for (var te, Ee = $3.concat(), x2 = [], M0 = Ee.length; M0--; )
        typeof (te = Ee.shift()) == "string" ? x2.push(te) : Array.isArray($3) && (te.length === 1 || te[1] === void 0 && te[2] === void 0) ? x2.push(te[0]) : x2.push([te[0], te[1], te[2]]);
      return x2;
    }
    function D6($3, te) {
      var Ee;
      if (typeof $3 == "string")
        Ee = te($3)[0];
      else if (Array.isArray($3)) {
        for (var x2, M0, G5 = $3.concat(), n5 = [], W8 = G5.length; W8--; )
          typeof (x2 = G5.shift()) == "string" ? n5.push(te(x2)[0]) : Array.isArray(x2) && typeof x2[0] == "string" && (M0 = te(x2[0], x2[1], x2[2]), n5.push([M0[0], M0[1], M0[2]]));
        Ee = n5;
      }
      return Ee;
    }
    var In = !1, Ei = !0;
    if (typeof S == "string")
      In = !0;
    else if (Array.isArray(S)) {
      var Ai = S.concat();
      J1 = [];
      for (var On, C4 = Ai.length; C4--; )
        (typeof (On = Ai.shift()) != "string" || Array.isArray(On) && typeof On[0] != "string") && (Ei = !1);
      In = Ei;
    }
    if (In === !1)
      throw new Error('Type of text must be string or Array. "' + S + '" is not recognized.');
    typeof S == "string" && (S = S.match(/[\r?\n]/) ? S.split(/\r\n|\r|\n/g) : [S]);
    var i4 = e2 / Xe.internal.scaleFactor, Nn = i4 * (V3 - 1);
    switch (z1.baseline) {
      case "bottom":
        v1 -= Nn;
        break;
      case "top":
        v1 += i4 - Nn;
        break;
      case "hanging":
        v1 += i4 - 2 * Nn;
        break;
      case "middle":
        v1 += i4 / 2 - Nn;
    }
    if ((y3 = z1.maxWidth || 0) > 0 && (typeof S == "string" ? S = Xe.splitTextToSize(S, y3) : Object.prototype.toString.call(S) === "[object Array]" && (S = S.reduce(function($3, te) {
      return $3.concat(Xe.splitTextToSize(te, y3));
    }, []))), H1 = { text: S, x: X, y: v1, options: z1, mutex: { pdfEscape: S4, activeFontKey: u3, fonts: E3, activeFontSize: e2 } }, Z3.publish("preProcessText", H1), S = H1.text, F2 = (z1 = H1.options).angle, !(ot instanceof D2) && F2 && typeof F2 == "number") {
      F2 *= Math.PI / 180, z1.rotationDirection === 0 && (F2 = -F2), x === b.ADVANCED && (F2 = -F2);
      var Pn = Math.cos(F2), q0 = Math.sin(F2);
      ot = new D2(Pn, q0, -q0, Pn, 0, 0);
    } else
      F2 && F2 instanceof D2 && (ot = F2);
    x !== b.ADVANCED || ot || (ot = _t), (v3 = z1.charSpace || Q0) !== void 0 && (Ft += R(O(v3)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (He = z1.horizontalScale) !== void 0 && (Ft += R(100 * He) + ` Tz
`), z1.lang;
    var s4 = -1, $t = z1.renderingMode !== void 0 ? z1.renderingMode : z1.stroke, M5 = Xe.internal.getCurrentPageInfo().pageContext;
    switch ($t) {
      case 0:
      case !1:
      case "fill":
        s4 = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        s4 = 1;
        break;
      case 2:
      case "fillThenStroke":
        s4 = 2;
        break;
      case 3:
      case "invisible":
        s4 = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        s4 = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        s4 = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        s4 = 6;
        break;
      case 7:
      case "addToPathForClipping":
        s4 = 7;
    }
    var G8 = M5.usedRenderingMode !== void 0 ? M5.usedRenderingMode : -1;
    s4 !== -1 ? Ft += s4 + ` Tr
` : G8 !== -1 && (Ft += `0 Tr
`), s4 !== -1 && (M5.usedRenderingMode = s4), Z2 = z1.align || "left";
    var b5, Fi = e2 * V3, R4 = Xe.internal.pageSize.getWidth(), it = E3[u3];
    v3 = z1.charSpace || Q0, y3 = z1.maxWidth || 0, P3 = Object.assign({ autoencode: !0, noBOM: !0 }, z1.flags);
    var U5 = [];
    if (Object.prototype.toString.call(S) === "[object Array]") {
      var t5;
      J1 = H6(S), Z2 !== "left" && (b5 = J1.map(function($3) {
        return Xe.getStringUnitWidth($3, { font: it, charSpace: v3, fontSize: e2, doKerning: !1 }) * e2 / V4;
      }));
      var L5, e6 = 0;
      if (Z2 === "right") {
        X -= b5[0], S = [], C4 = J1.length;
        for (var j5 = 0; j5 < C4; j5++)
          j5 === 0 ? (L5 = P4(X), t5 = qt(v1)) : (L5 = O(e6 - b5[j5]), t5 = -Fi), S.push([J1[j5], L5, t5]), e6 = b5[j5];
      } else if (Z2 === "center") {
        X -= b5[0] / 2, S = [], C4 = J1.length;
        for (var w0 = 0; w0 < C4; w0++)
          w0 === 0 ? (L5 = P4(X), t5 = qt(v1)) : (L5 = O((e6 - b5[w0]) / 2), t5 = -Fi), S.push([J1[w0], L5, t5]), e6 = b5[w0];
      } else if (Z2 === "left") {
        S = [], C4 = J1.length;
        for (var l4 = 0; l4 < C4; l4++)
          S.push(J1[l4]);
      } else {
        if (Z2 !== "justify")
          throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        S = [], C4 = J1.length, y3 = y3 !== 0 ? y3 : R4;
        for (var e1 = 0; e1 < C4; e1++)
          t5 = e1 === 0 ? qt(v1) : -Fi, L5 = e1 === 0 ? P4(X) : 0, e1 < C4 - 1 ? U5.push(R(O((y3 - b5[e1]) / (J1[e1].split(" ").length - 1)))) : U5.push(0), S.push([J1[e1], L5, t5]);
      }
    }
    var m1 = typeof z1.R2L == "boolean" ? z1.R2L : S2;
    m1 === !0 && (S = D6(S, function($3, te, Ee) {
      return [$3.split("").reverse().join(""), te, Ee];
    })), H1 = { text: S, x: X, y: v1, options: z1, mutex: { pdfEscape: S4, activeFontKey: u3, fonts: E3, activeFontSize: e2 } }, Z3.publish("postProcessText", H1), S = H1.text, B4 = H1.mutex.isHex || !1;
    var u1 = E3[u3].encoding;
    u1 !== "WinAnsiEncoding" && u1 !== "StandardEncoding" || (S = D6(S, function($3, te, Ee) {
      return [e5($3), te, Ee];
    })), J1 = H6(S), S = [];
    for (var R1, s2, N2, z3 = 0, Y2 = 1, x5 = Array.isArray(J1[0]) ? Y2 : z3, t6 = "", ke = function($3, te, Ee) {
      var x2 = "";
      return Ee instanceof D2 ? (Ee = typeof z1.angle == "number" ? Re(Ee, new D2(1, 0, 0, 1, $3, te)) : Re(new D2(1, 0, 0, 1, $3, te), Ee), x === b.ADVANCED && (Ee = Re(new D2(1, 0, 0, -1, 0, 0), Ee)), x2 = Ee.join(" ") + ` Tm
`) : x2 = R($3) + " " + R(te) + ` Td
`, x2;
    }, Tt = 0; Tt < J1.length; Tt++) {
      switch (t6 = "", x5) {
        case Y2:
          N2 = (B4 ? "<" : "(") + J1[Tt][0] + (B4 ? ">" : ")"), R1 = parseFloat(J1[Tt][1]), s2 = parseFloat(J1[Tt][2]);
          break;
        case z3:
          N2 = (B4 ? "<" : "(") + J1[Tt] + (B4 ? ">" : ")"), R1 = P4(X), s2 = qt(v1);
      }
      U5 !== void 0 && U5[Tt] !== void 0 && (t6 = U5[Tt] + ` Tw
`), Tt === 0 ? S.push(t6 + ke(R1, s2, ot) + N2) : x5 === z3 ? S.push(t6 + N2) : x5 === Y2 && S.push(t6 + ke(R1, s2, ot) + N2);
    }
    S = x5 === z3 ? S.join(` Tj
T* `) : S.join(` Tj
`), S += ` Tj
`;
    var z0 = `BT
/`;
    return z0 += u3 + " " + e2 + ` Tf
`, z0 += R(e2 * V3) + ` TL
`, z0 += y0 + `
`, z0 += Ft, z0 += S, p1(z0 += "ET"), m[u3] = !0, Xe;
  };
  var el = p.__private__.clip = p.clip = function(S) {
    return p1(S === "evenodd" ? "W*" : "W"), this;
  };
  p.clipEvenOdd = function() {
    return el("evenodd");
  }, p.__private__.discardPath = p.discardPath = function() {
    return p1("n"), this;
  };
  var D5 = p.__private__.isValidStyle = function(S) {
    var X = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(S) !== -1 && (X = !0), X;
  };
  p.__private__.setDefaultPathOperation = p.setDefaultPathOperation = function(S) {
    return D5(S) && (u = S), this;
  };
  var D8 = p.__private__.getStyle = p.getStyle = function(S) {
    var X = u;
    switch (S) {
      case "D":
      case "S":
        X = "S";
        break;
      case "F":
        X = "f";
        break;
      case "FD":
      case "DF":
        X = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        X = S;
    }
    return X;
  }, Z0 = p.close = function() {
    return p1("h"), this;
  };
  p.stroke = function() {
    return p1("S"), this;
  }, p.fill = function(S) {
    return An("f", S), this;
  }, p.fillEvenOdd = function(S) {
    return An("f*", S), this;
  }, p.fillStroke = function(S) {
    return An("B", S), this;
  }, p.fillStrokeEvenOdd = function(S) {
    return An("B*", S), this;
  };
  var An = function(S, X) {
    Ye(X) === "object" ? nl(X, S) : p1(S);
  }, Mi = function(S) {
    S === null || x === b.ADVANCED && S === void 0 || (S = D8(S), p1(S));
  };
  function tl(S, X, v1, z1, F1) {
    var H1 = new wa(X || this.boundingBox, v1 || this.xStep, z1 || this.yStep, this.gState, F1 || this.matrix);
    H1.stream = this.stream;
    var J1 = S + "$$" + this.cloneIndex++ + "$$";
    return L3(J1, H1), H1;
  }
  var nl = function(S, X) {
    var v1 = w3[S.key], z1 = R2[v1];
    if (z1 instanceof Jl)
      p1("q"), p1(il(X)), z1.gState && p.setGState(z1.gState), p1(S.matrix.toString() + " cm"), p1("/" + v1 + " sh"), p1("Q");
    else if (z1 instanceof wa) {
      var F1 = new D2(1, 0, 0, -1, 0, Q4());
      S.matrix && (F1 = F1.multiply(S.matrix || _t), v1 = tl.call(z1, S.key, S.boundingBox, S.xStep, S.yStep, F1).id), p1("q"), p1("/Pattern cs"), p1("/" + v1 + " scn"), z1.gState && p.setGState(z1.gState), p1(X), p1("Q");
    }
  }, il = function(S) {
    switch (S) {
      case "f":
      case "F":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
        return "W S";
      case "B*":
        return "W* S";
      case "S":
        return "W S";
      case "n":
        return "W n";
    }
  }, e3 = p.moveTo = function(S, X) {
    return p1(R(O(S)) + " " + R(j(X)) + " m"), this;
  }, X2 = p.lineTo = function(S, X) {
    return p1(R(O(S)) + " " + R(j(X)) + " l"), this;
  }, J0 = p.curveTo = function(S, X, v1, z1, F1, H1) {
    return p1([R(O(S)), R(j(X)), R(O(v1)), R(j(z1)), R(O(F1)), R(j(H1)), "c"].join(" ")), this;
  };
  p.__private__.line = p.line = function(S, X, v1, z1, F1) {
    if (isNaN(S) || isNaN(X) || isNaN(v1) || isNaN(z1) || !D5(F1))
      throw new Error("Invalid arguments passed to jsPDF.line");
    return x === b.COMPAT ? this.lines([[v1 - S, z1 - X]], S, X, [1, 1], F1 || "S") : this.lines([[v1 - S, z1 - X]], S, X, [1, 1]).stroke();
  }, p.__private__.lines = p.lines = function(S, X, v1, z1, F1, H1) {
    var J1, F2, Z2, v3, y3, P3, He, ot, Xe, wt, Ft, B4;
    if (typeof S == "number" && (B4 = v1, v1 = X, X = S, S = B4), z1 = z1 || [1, 1], H1 = H1 || !1, isNaN(X) || isNaN(v1) || !Array.isArray(S) || !Array.isArray(z1) || !D5(F1) || typeof H1 != "boolean")
      throw new Error("Invalid arguments passed to jsPDF.lines");
    for (e3(X, v1), J1 = z1[0], F2 = z1[1], v3 = S.length, wt = X, Ft = v1, Z2 = 0; Z2 < v3; Z2++)
      (y3 = S[Z2]).length === 2 ? (wt = y3[0] * J1 + wt, Ft = y3[1] * F2 + Ft, X2(wt, Ft)) : (P3 = y3[0] * J1 + wt, He = y3[1] * F2 + Ft, ot = y3[2] * J1 + wt, Xe = y3[3] * F2 + Ft, wt = y3[4] * J1 + wt, Ft = y3[5] * F2 + Ft, J0(P3, He, ot, Xe, wt, Ft));
    return H1 && Z0(), Mi(F1), this;
  }, p.path = function(S) {
    for (var X = 0; X < S.length; X++) {
      var v1 = S[X], z1 = v1.c;
      switch (v1.op) {
        case "m":
          e3(z1[0], z1[1]);
          break;
        case "l":
          X2(z1[0], z1[1]);
          break;
        case "c":
          J0.apply(this, z1);
          break;
        case "h":
          Z0();
      }
    }
    return this;
  }, p.__private__.rect = p.rect = function(S, X, v1, z1, F1) {
    if (isNaN(S) || isNaN(X) || isNaN(v1) || isNaN(z1) || !D5(F1))
      throw new Error("Invalid arguments passed to jsPDF.rect");
    return x === b.COMPAT && (z1 = -z1), p1([R(O(S)), R(j(X)), R(O(v1)), R(O(z1)), "re"].join(" ")), Mi(F1), this;
  }, p.__private__.triangle = p.triangle = function(S, X, v1, z1, F1, H1, J1) {
    if (isNaN(S) || isNaN(X) || isNaN(v1) || isNaN(z1) || isNaN(F1) || isNaN(H1) || !D5(J1))
      throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[v1 - S, z1 - X], [F1 - v1, H1 - z1], [S - F1, X - H1]], S, X, [1, 1], J1, !0), this;
  }, p.__private__.roundedRect = p.roundedRect = function(S, X, v1, z1, F1, H1, J1) {
    if (isNaN(S) || isNaN(X) || isNaN(v1) || isNaN(z1) || isNaN(F1) || isNaN(H1) || !D5(J1))
      throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var F2 = 4 / 3 * (Math.SQRT2 - 1);
    return F1 = Math.min(F1, 0.5 * v1), H1 = Math.min(H1, 0.5 * z1), this.lines([[v1 - 2 * F1, 0], [F1 * F2, 0, F1, H1 - H1 * F2, F1, H1], [0, z1 - 2 * H1], [0, H1 * F2, -F1 * F2, H1, -F1, H1], [2 * F1 - v1, 0], [-F1 * F2, 0, -F1, -H1 * F2, -F1, -H1], [0, 2 * H1 - z1], [0, -H1 * F2, F1 * F2, -H1, F1, -H1]], S + F1, X, [1, 1], J1, !0), this;
  }, p.__private__.ellipse = p.ellipse = function(S, X, v1, z1, F1) {
    if (isNaN(S) || isNaN(X) || isNaN(v1) || isNaN(z1) || !D5(F1))
      throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var H1 = 4 / 3 * (Math.SQRT2 - 1) * v1, J1 = 4 / 3 * (Math.SQRT2 - 1) * z1;
    return e3(S + v1, X), J0(S + v1, X - J1, S + H1, X - z1, S, X - z1), J0(S - H1, X - z1, S - v1, X - J1, S - v1, X), J0(S - v1, X + J1, S - H1, X + z1, S, X + z1), J0(S + H1, X + z1, S + v1, X + J1, S + v1, X), Mi(F1), this;
  }, p.__private__.circle = p.circle = function(S, X, v1, z1) {
    if (isNaN(S) || isNaN(X) || isNaN(v1) || !D5(z1))
      throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(S, X, v1, v1, z1);
  }, p.setFont = function(S, X, v1) {
    return v1 && (X = D(X, v1)), u3 = Y0(S, X, { disableWarning: !1 }), this;
  };
  var sl = p.__private__.getFont = p.getFont = function() {
    return E3[Y0.apply(p, arguments)];
  };
  p.__private__.getFontList = p.getFontList = function() {
    var S, X, v1 = {};
    for (S in j3)
      if (j3.hasOwnProperty(S))
        for (X in v1[S] = [], j3[S])
          j3[S].hasOwnProperty(X) && v1[S].push(X);
    return v1;
  }, p.addFont = function(S, X, v1, z1, F1) {
    var H1 = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && H1.indexOf(arguments[3]) !== -1 ? F1 = arguments[3] : arguments[3] && H1.indexOf(arguments[3]) == -1 && (v1 = D(v1, z1)), F1 = F1 || "Identity-H", yi.call(this, S, X, v1, F1);
  };
  var P6, bi = t.lineWidth || 0.200025, Fn = p.__private__.getLineWidth = p.getLineWidth = function() {
    return bi;
  }, $8 = p.__private__.setLineWidth = p.setLineWidth = function(S) {
    return bi = S, p1(R(O(S)) + " w"), this;
  };
  p.__private__.setLineDash = m3.API.setLineDash = m3.API.setLineDashPattern = function(S, X) {
    if (S = S || [], X = X || 0, isNaN(X) || !Array.isArray(S))
      throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return S = S.map(function(v1) {
      return R(O(v1));
    }).join(" "), X = R(O(X)), p1("[" + S + "] " + X + " d"), this;
  };
  var Tn = p.__private__.getLineHeight = p.getLineHeight = function() {
    return e2 * P6;
  };
  p.__private__.getLineHeight = p.getLineHeight = function() {
    return e2 * P6;
  };
  var U8 = p.__private__.setLineHeightFactor = p.setLineHeightFactor = function(S) {
    return typeof (S = S || 1.15) == "number" && (P6 = S), this;
  }, D3 = p.__private__.getLineHeightFactor = p.getLineHeightFactor = function() {
    return P6;
  };
  U8(t.lineHeight);
  var P4 = p.__private__.getHorizontalCoordinate = function(S) {
    return O(S);
  }, qt = p.__private__.getVerticalCoordinate = function(S) {
    return x === b.ADVANCED ? S : d3[a1].mediaBox.topRightY - d3[a1].mediaBox.bottomLeftY - O(S);
  }, Li = p.__private__.getHorizontalCoordinateString = p.getHorizontalCoordinateString = function(S) {
    return R(P4(S));
  }, J4 = p.__private__.getVerticalCoordinateString = p.getVerticalCoordinateString = function(S) {
    return R(qt(S));
  }, J3 = t.strokeColor || "0 G";
  p.__private__.getStrokeColor = p.getDrawColor = function() {
    return q5(J3);
  }, p.__private__.setStrokeColor = p.setDrawColor = function(S, X, v1, z1) {
    return J3 = w5({ ch1: S, ch2: X, ch3: v1, ch4: z1, pdfColorType: "draw", precision: 2 }), p1(J3), this;
  };
  var B6 = t.fillColor || "0 g";
  p.__private__.getFillColor = p.getFillColor = function() {
    return q5(B6);
  }, p.__private__.setFillColor = p.setFillColor = function(S, X, v1, z1) {
    return B6 = w5({ ch1: S, ch2: X, ch3: v1, ch4: z1, pdfColorType: "fill", precision: 2 }), p1(B6), this;
  };
  var y0 = t.textColor || "0 g", xi = p.__private__.getTextColor = p.getTextColor = function() {
    return q5(y0);
  };
  p.__private__.setTextColor = p.setTextColor = function(S, X, v1, z1) {
    return y0 = w5({ ch1: S, ch2: X, ch3: v1, ch4: z1, pdfColorType: "text", precision: 3 }), this;
  };
  var Q0 = t.charSpace, Si = p.__private__.getCharSpace = p.getCharSpace = function() {
    return parseFloat(Q0 || 0);
  };
  p.__private__.setCharSpace = p.setCharSpace = function(S) {
    if (isNaN(S))
      throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return Q0 = S, this;
  };
  var V6 = 0;
  p.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, p.__private__.setLineCap = p.setLineCap = function(S) {
    var X = p.CapJoinStyles[S];
    if (X === void 0)
      throw new Error("Line cap style of '" + S + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return V6 = X, p1(X + " J"), this;
  };
  var fe = 0;
  p.__private__.setLineJoin = p.setLineJoin = function(S) {
    var X = p.CapJoinStyles[S];
    if (X === void 0)
      throw new Error("Line join style of '" + S + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return fe = X, p1(X + " j"), this;
  }, p.__private__.setLineMiterLimit = p.__private__.setMiterLimit = p.setLineMiterLimit = p.setMiterLimit = function(S) {
    if (S = S || 0, isNaN(S))
      throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return p1(R(O(S)) + " M"), this;
  }, p.GState = du, p.setGState = function(S) {
    (S = typeof S == "string" ? B3[G3[S]] : j8(null, S)).equals(Se) || (p1("/" + S.id + " gs"), Se = S);
  };
  var j8 = function(S, X) {
    if (!S || !G3[S]) {
      var v1 = !1;
      for (var z1 in B3)
        if (B3.hasOwnProperty(z1) && B3[z1].equals(X)) {
          v1 = !0;
          break;
        }
      if (v1)
        X = B3[z1];
      else {
        var F1 = "GS" + (Object.keys(B3).length + 1).toString(10);
        B3[F1] = X, X.id = F1;
      }
      return S && (G3[S] = X.id), Z3.publish("addGState", X), X;
    }
  };
  p.addGState = function(S, X) {
    return j8(S, X), this;
  }, p.saveGraphicsState = function() {
    return p1("q"), z2.push({ key: u3, size: e2, color: y0 }), this;
  }, p.restoreGraphicsState = function() {
    p1("Q");
    var S = z2.pop();
    return u3 = S.key, e2 = S.size, y0 = S.color, Se = null, this;
  }, p.setCurrentTransformationMatrix = function(S) {
    return p1(S.toString() + " cm"), this;
  }, p.comment = function(S) {
    return p1("#" + S), this;
  };
  var qe = function(S, X) {
    var v1 = S || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return v1;
    }, set: function(H1) {
      isNaN(H1) || (v1 = parseFloat(H1));
    } });
    var z1 = X || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return z1;
    }, set: function(H1) {
      isNaN(H1) || (z1 = parseFloat(H1));
    } });
    var F1 = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return F1;
    }, set: function(H1) {
      F1 = H1.toString();
    } }), this;
  }, Ci = function(S, X, v1, z1) {
    qe.call(this, S, X), this.type = "rect";
    var F1 = v1 || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return F1;
    }, set: function(J1) {
      isNaN(J1) || (F1 = parseFloat(J1));
    } });
    var H1 = z1 || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return H1;
    }, set: function(J1) {
      isNaN(J1) || (H1 = parseFloat(J1));
    } }), this;
  }, R6 = function() {
    this.page = _e, this.currentPage = a1, this.pages = X1.slice(0), this.pagesContext = d3.slice(0), this.x = Oe, this.y = q3, this.matrix = ht, this.width = t3(a1), this.height = Q4(a1), this.outputDestination = d2, this.id = "", this.objectNumber = -1;
  };
  R6.prototype.restore = function() {
    _e = this.page, a1 = this.currentPage, d3 = this.pagesContext, X1 = this.pages, Oe = this.x, q3 = this.y, ht = this.matrix, xt(a1, this.width), ki(a1, this.height), d2 = this.outputDestination;
  };
  var At = function(S, X, v1, z1, F1) {
    ut.push(new R6()), _e = a1 = 0, X1 = [], Oe = S, q3 = X, ht = F1, I6([v1, z1]);
  }, _0 = function(S) {
    if (tt[S])
      ut.pop().restore();
    else {
      var X = new R6(), v1 = "Xo" + (Object.keys(Ce).length + 1).toString(10);
      X.id = v1, tt[S] = v1, Ce[v1] = X, Z3.publish("addFormObject", X), ut.pop().restore();
    }
  };
  for (var $5 in p.beginFormObject = function(S, X, v1, z1, F1) {
    return At(S, X, v1, z1, F1), this;
  }, p.endFormObject = function(S) {
    return _0(S), this;
  }, p.doFormObject = function(S, X) {
    var v1 = Ce[tt[S]];
    return p1("q"), p1(X.toString() + " cm"), p1("/" + v1.id + " Do"), p1("Q"), this;
  }, p.getFormObject = function(S) {
    var X = Ce[tt[S]];
    return { x: X.x, y: X.y, width: X.width, height: X.height, matrix: X.matrix };
  }, p.save = function(S, X) {
    return S = S || "generated.pdf", (X = X || {}).returnPromise = X.returnPromise || !1, X.returnPromise === !1 ? (Kl(X0(z5()), S), typeof Kl.unload == "function" && g3.setTimeout && setTimeout(Kl.unload, 911), this) : new Promise(function(v1, z1) {
      try {
        var F1 = Kl(X0(z5()), S);
        typeof Kl.unload == "function" && g3.setTimeout && setTimeout(Kl.unload, 911), v1(F1);
      } catch (H1) {
        z1(H1.message);
      }
    });
  }, m3.API)
    m3.API.hasOwnProperty($5) && ($5 === "events" && m3.API.events.length ? function(S, X) {
      var v1, z1, F1;
      for (F1 = X.length - 1; F1 !== -1; F1--)
        v1 = X[F1][0], z1 = X[F1][1], S.subscribe.apply(S, [v1].concat(typeof z1 == "function" ? [z1] : z1));
    }(Z3, m3.API.events) : p[$5] = m3.API[$5]);
  var t3 = p.getPageWidth = function(S) {
    return (d3[S = S || a1].mediaBox.topRightX - d3[S].mediaBox.bottomLeftX) / g2;
  }, xt = p.setPageWidth = function(S, X) {
    d3[S].mediaBox.topRightX = X * g2 + d3[S].mediaBox.bottomLeftX;
  }, Q4 = p.getPageHeight = function(S) {
    return (d3[S = S || a1].mediaBox.topRightY - d3[S].mediaBox.bottomLeftY) / g2;
  }, ki = p.setPageHeight = function(S, X) {
    d3[S].mediaBox.topRightY = X * g2 + d3[S].mediaBox.bottomLeftY;
  };
  return p.internal = { pdfEscape: S4, getStyle: D8, getFont: sl, getFontSize: t2, getCharSpace: Si, getTextColor: xi, getLineHeight: Tn, getLineHeightFactor: D3, getLineWidth: Fn, write: _2, getHorizontalCoordinate: P4, getVerticalCoordinate: qt, getCoordinateString: Li, getVerticalCoordinateString: J4, collections: {}, newObject: W3, newAdditionalObject: wn, newObjectDeferred: oe, newObjectDeferredBegin: v4, getFilters: X4, putStream: K4, events: Z3, scaleFactor: g2, pageSize: { getWidth: function() {
    return t3(a1);
  }, setWidth: function(S) {
    xt(a1, S);
  }, getHeight: function() {
    return Q4(a1);
  }, setHeight: function(S) {
    ki(a1, S);
  } }, encryptionOptions: d, encryption: n4, getEncryptor: Js, output: K0, getNumberOfPages: qi, pages: X1, out: p1, f2: K, f3: P, getPageInfo: H8, getPageInfoByObjId: f3, getCurrentPageInfo: Qs, getPDFVersion: q, Point: qe, Rectangle: Ci, Matrix: D2, hasHotfix: En }, Object.defineProperty(p.internal.pageSize, "width", { get: function() {
    return t3(a1);
  }, set: function(S) {
    xt(a1, S);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(p.internal.pageSize, "height", { get: function() {
    return Q4(a1);
  }, set: function(S) {
    ki(a1, S);
  }, enumerable: !0, configurable: !0 }), _i.call(p, K1), u3 = "F1", kn(s, n), Z3.publish("initialized"), p;
}
ha.prototype.lsbFirstWord = function(t) {
  return String.fromCharCode(t >> 0 & 255, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, ha.prototype.toHexString = function(t) {
  return t.split("").map(function(e) {
    return ("0" + (255 & e.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, ha.prototype.hexToBytes = function(t) {
  for (var e = [], n = 0; n < t.length; n += 2)
    e.push(String.fromCharCode(parseInt(t.substr(n, 2), 16)));
  return e.join("");
}, ha.prototype.processOwnerPassword = function(t, e) {
  return Jy(Zy(e).substr(0, 5), t);
}, ha.prototype.encryptor = function(t, e) {
  var n = Zy(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
  return function(i) {
    return Jy(n, i);
  };
}, du.prototype.equals = function(t) {
  var e, n = "id,objectNumber,equals";
  if (!t || Ye(t) !== Ye(this))
    return !1;
  var i = 0;
  for (e in this)
    if (!(n.indexOf(e) >= 0)) {
      if (this.hasOwnProperty(e) && !t.hasOwnProperty(e) || this[e] !== t[e])
        return !1;
      i++;
    }
  for (e in t)
    t.hasOwnProperty(e) && n.indexOf(e) < 0 && i--;
  return i === 0;
}, m3.API = { events: [] }, m3.version = "2.5.1";
var Vt = m3.API, Xq = 1, kr = function(t) {
  return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, Qr = function(t) {
  return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, F3 = function(t) {
  return t.toFixed(2);
}, ds = function(t) {
  return t.toFixed(5);
};
Vt.__acroform__ = {};
var p0 = function(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, DM = function(t) {
  return t * Xq;
}, Un = function(t) {
  var e = new jk(), n = j2.internal.getHeight(t) || 0, i = j2.internal.getWidth(t) || 0;
  return e.BBox = [0, 0, Number(F3(i)), Number(F3(n))], e;
}, AC1 = Vt.__acroform__.setBit = function(t, e) {
  if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return t |= 1 << e;
}, FC1 = Vt.__acroform__.clearBit = function(t, e) {
  if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return t &= ~(1 << e);
}, TC1 = Vt.__acroform__.getBit = function(t, e) {
  if (isNaN(t) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return t & 1 << e ? 1 : 0;
}, Qt = Vt.__acroform__.getBitForPdf = function(t, e) {
  if (isNaN(t) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return TC1(t, e - 1);
}, e4 = Vt.__acroform__.setBitForPdf = function(t, e) {
  if (isNaN(t) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return AC1(t, e - 1);
}, t4 = Vt.__acroform__.clearBitForPdf = function(t, e) {
  if (isNaN(t) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return FC1(t, e - 1);
}, IC1 = Vt.__acroform__.calculateCoordinates = function(t, e) {
  var n = e.internal.getHorizontalCoordinate, i = e.internal.getVerticalCoordinate, s = t[0], l = t[1], a = t[2], o = t[3], h = {};
  return h.lowerLeft_X = n(s) || 0, h.lowerLeft_Y = i(l + o) || 0, h.upperRight_X = n(s + a) || 0, h.upperRight_Y = i(l) || 0, [Number(F3(h.lowerLeft_X)), Number(F3(h.lowerLeft_Y)), Number(F3(h.upperRight_X)), Number(F3(h.upperRight_Y))];
}, OC1 = function(t) {
  if (t.appearanceStreamContent)
    return t.appearanceStreamContent;
  if (t.V || t.DV) {
    var e = [], n = t._V || t.DV, i = Qy(t, n), s = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
    e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + s + " " + F3(i.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(i.text), e.push("ET"), e.push("Q"), e.push("EMC");
    var l = Un(t);
    return l.scope = t.scope, l.stream = e.join(`
`), l;
  }
}, Qy = function(t, e) {
  var n = t.fontSize === 0 ? t.maxFontSize : t.fontSize, i = { text: "", fontSize: "" }, s = (e = (e = e.substr(0, 1) == "(" ? e.substr(1) : e).substr(e.length - 1) == ")" ? e.substr(0, e.length - 1) : e).split(" ");
  s = t.multiline ? s.map(function(P) {
    return P.split(`
`);
  }) : s.map(function(P) {
    return [P];
  });
  var l = n, a = j2.internal.getHeight(t) || 0;
  a = a < 0 ? -a : a;
  var o = j2.internal.getWidth(t) || 0;
  o = o < 0 ? -o : o;
  var h = function(P, O, G) {
    if (P + 1 < s.length) {
      var j = O + " " + s[P + 1][0];
      return oh(j, t, G).width <= o - 4;
    }
    return !1;
  };
  l++;
  e:
    for (; l > 0; ) {
      e = "", l--;
      var u, d, v = oh("3", t, l).height, m = t.multiline ? a - l : (a - v) / 2, p = m += 2, _ = 0, q = 0, M = 0;
      if (l <= 0) {
        e = `(...) Tj
`, e += "% Width of Text: " + oh(e, t, l = 12).width + ", FieldWidth:" + o + `
`;
        break;
      }
      for (var z = "", b = 0, x = 0; x < s.length; x++)
        if (s.hasOwnProperty(x)) {
          var k = !1;
          if (s[x].length !== 1 && M !== s[x].length - 1) {
            if ((v + 2) * (b + 2) + 2 > a)
              continue e;
            z += s[x][M], k = !0, q = x, x--;
          } else {
            z = (z += s[x][M] + " ").substr(z.length - 1) == " " ? z.substr(0, z.length - 1) : z;
            var F = parseInt(x), D = h(F, z, l), R = x >= s.length - 1;
            if (D && !R) {
              z += " ", M = 0;
              continue;
            }
            if (D || R) {
              if (R)
                q = F;
              else if (t.multiline && (v + 2) * (b + 2) + 2 > a)
                continue e;
            } else {
              if (!t.multiline || (v + 2) * (b + 2) + 2 > a)
                continue e;
              q = F;
            }
          }
          for (var V = "", J = _; J <= q; J++) {
            var K = s[J];
            if (t.multiline) {
              if (J === q) {
                V += K[M] + " ", M = (M + 1) % K.length;
                continue;
              }
              if (J === _) {
                V += K[K.length - 1] + " ";
                continue;
              }
            }
            V += K[0] + " ";
          }
          switch (V = V.substr(V.length - 1) == " " ? V.substr(0, V.length - 1) : V, d = oh(V, t, l).width, t.textAlign) {
            case "right":
              u = o - d - 2;
              break;
            case "center":
              u = (o - d) / 2;
              break;
            case "left":
            default:
              u = 2;
          }
          e += F3(u) + " " + F3(p) + ` Td
`, e += "(" + kr(V) + `) Tj
`, e += -F3(u) + ` 0 Td
`, p = -(l + 2), d = 0, _ = k ? q : q + 1, b++, z = "";
        }
      break;
    }
  return i.text = e, i.fontSize = l, i;
}, oh = function(t, e, n) {
  var i = e.scope.internal.getFont(e.fontName, e.fontStyle), s = e.scope.getStringUnitWidth(t, { font: i, fontSize: parseFloat(n), charSpace: 0 }) * parseFloat(n);
  return { height: e.scope.getStringUnitWidth("3", { font: i, fontSize: parseFloat(n), charSpace: 0 }) * parseFloat(n) * 1.5, width: s };
}, NC1 = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, PC1 = function(t, e) {
  var n = { type: "reference", object: t };
  e.internal.getPageInfo(t.page).pageContext.annotations.find(function(i) {
    return i.type === n.type && i.object === n.object;
  }) === void 0 && e.internal.getPageInfo(t.page).pageContext.annotations.push(n);
}, BC1 = function(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n)) {
      var i = n, s = t[n];
      e.internal.newObjectDeferredBegin(s.objId, !0), Ye(s) === "object" && typeof s.putStream == "function" && s.putStream(), delete t[i];
    }
}, VC1 = function(t, e) {
  if (e.scope = t, t.internal !== void 0 && (t.internal.acroformPlugin === void 0 || t.internal.acroformPlugin.isInitialized === !1)) {
    if (yn.FieldNum = 0, t.internal.acroformPlugin = JSON.parse(JSON.stringify(NC1)), t.internal.acroformPlugin.acroFormDictionaryRoot)
      throw new Error("Exception while creating AcroformDictionary");
    Xq = t.internal.scaleFactor, t.internal.acroformPlugin.acroFormDictionaryRoot = new Gk(), t.internal.acroformPlugin.acroFormDictionaryRoot.scope = t, t.internal.acroformPlugin.acroFormDictionaryRoot._eventID = t.internal.events.subscribe("postPutResources", function() {
      (function(n) {
        n.internal.events.unsubscribe(n.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete n.internal.acroformPlugin.acroFormDictionaryRoot._eventID, n.internal.acroformPlugin.printedOut = !0;
      })(t);
    }), t.internal.events.subscribe("buildDocument", function() {
      (function(n) {
        n.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var i = n.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var s in i)
          if (i.hasOwnProperty(s)) {
            var l = i[s];
            l.objId = void 0, l.hasAnnotation && PC1(l, n);
          }
      })(t);
    }), t.internal.events.subscribe("putCatalog", function() {
      (function(n) {
        if (n.internal.acroformPlugin.acroFormDictionaryRoot === void 0)
          throw new Error("putCatalogCallback: Root missing.");
        n.internal.write("/AcroForm " + n.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(t);
    }), t.internal.events.subscribe("postPutPages", function(n) {
      (function(i, s) {
        var l = !i;
        for (var a in i || (s.internal.newObjectDeferredBegin(s.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), s.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), i = i || s.internal.acroformPlugin.acroFormDictionaryRoot.Kids)
          if (i.hasOwnProperty(a)) {
            var o = i[a], h = [], u = o.Rect;
            if (o.Rect && (o.Rect = IC1(o.Rect, s)), s.internal.newObjectDeferredBegin(o.objId, !0), o.DA = j2.createDefaultAppearanceStream(o), Ye(o) === "object" && typeof o.getKeyValueListForStream == "function" && (h = o.getKeyValueListForStream()), o.Rect = u, o.hasAppearanceStream && !o.appearanceStreamContent) {
              var d = OC1(o);
              h.push({ key: "AP", value: "<</N " + d + ">>" }), s.internal.acroformPlugin.xForms.push(d);
            }
            if (o.appearanceStreamContent) {
              var v = "";
              for (var m in o.appearanceStreamContent)
                if (o.appearanceStreamContent.hasOwnProperty(m)) {
                  var p = o.appearanceStreamContent[m];
                  if (v += "/" + m + " ", v += "<<", Object.keys(p).length >= 1 || Array.isArray(p)) {
                    for (var a in p)
                      if (p.hasOwnProperty(a)) {
                        var _ = p[a];
                        typeof _ == "function" && (_ = _.call(s, o)), v += "/" + a + " " + _ + " ", s.internal.acroformPlugin.xForms.indexOf(_) >= 0 || s.internal.acroformPlugin.xForms.push(_);
                      }
                  } else
                    typeof (_ = p) == "function" && (_ = _.call(s, o)), v += "/" + a + " " + _, s.internal.acroformPlugin.xForms.indexOf(_) >= 0 || s.internal.acroformPlugin.xForms.push(_);
                  v += ">>";
                }
              h.push({ key: "AP", value: `<<
` + v + ">>" });
            }
            s.internal.putStream({ additionalKeyValues: h, objectId: o.objId }), s.internal.out("endobj");
          }
        l && BC1(s.internal.acroformPlugin.xForms, s);
      })(n, t);
    }), t.internal.acroformPlugin.isInitialized = !0;
  }
}, Uk = Vt.__acroform__.arrayToPdfArray = function(t, e, n) {
  var i = function(a) {
    return a;
  };
  if (Array.isArray(t)) {
    for (var s = "[", l = 0; l < t.length; l++)
      switch (l !== 0 && (s += " "), Ye(t[l])) {
        case "boolean":
        case "number":
        case "object":
          s += t[l].toString();
          break;
        case "string":
          t[l].substr(0, 1) !== "/" ? (e !== void 0 && n && (i = n.internal.getEncryptor(e)), s += "(" + kr(i(t[l].toString())) + ")") : s += t[l].toString();
      }
    return s += "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, Qg = function(t, e, n) {
  var i = function(s) {
    return s;
  };
  return e !== void 0 && n && (i = n.internal.getEncryptor(e)), (t = t || "").toString(), t = "(" + kr(i(t)) + ")";
}, Zn = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0)
        return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(t) {
    this._objId = t;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
Zn.prototype.toString = function() {
  return this.objId + " 0 R";
}, Zn.prototype.putStream = function() {
  var t = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: t, objectId: this.objId }), this.scope.internal.out("endobj");
}, Zn.prototype.getKeyValueListForStream = function() {
  var t = [], e = Object.getOwnPropertyNames(this).filter(function(l) {
    return l != "content" && l != "appearanceStreamContent" && l != "scope" && l != "objId" && l.substring(0, 1) != "_";
  });
  for (var n in e)
    if (Object.getOwnPropertyDescriptor(this, e[n]).configurable === !1) {
      var i = e[n], s = this[i];
      s && (Array.isArray(s) ? t.push({ key: i, value: Uk(s, this.objId, this.scope) }) : s instanceof Zn ? (s.scope = this.scope, t.push({ key: i, value: s.objId + " 0 R" })) : typeof s != "function" && t.push({ key: i, value: s }));
    }
  return t;
};
var jk = function() {
  Zn.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var t, e = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(n) {
    t = n.trim();
  }, get: function() {
    return t || null;
  } });
};
p0(jk, Zn);
var Gk = function() {
  Zn.call(this);
  var t, e = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return e.length > 0 ? e : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return e;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (t) {
      var n = function(i) {
        return i;
      };
      return this.scope && (n = this.scope.internal.getEncryptor(this.objId)), "(" + kr(n(t)) + ")";
    }
  }, set: function(n) {
    t = n;
  } });
};
p0(Gk, Zn);
var yn = function t() {
  Zn.call(this);
  var e = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(z) {
    if (isNaN(z))
      throw new Error('Invalid value "' + z + '" for attribute F supplied.');
    e = z;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(e, 3);
  }, set: function(z) {
    z ? this.F = e4(e, 3) : this.F = t4(e, 3);
  } });
  var n = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return n;
  }, set: function(z) {
    if (isNaN(z))
      throw new Error('Invalid value "' + z + '" for attribute Ff supplied.');
    n = z;
  } });
  var i = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (i.length !== 0)
      return i;
  }, set: function(z) {
    i = z !== void 0 ? z : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !i || isNaN(i[0]) ? 0 : i[0];
  }, set: function(z) {
    i[0] = z;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !i || isNaN(i[1]) ? 0 : i[1];
  }, set: function(z) {
    i[1] = z;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !i || isNaN(i[2]) ? 0 : i[2];
  }, set: function(z) {
    i[2] = z;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !i || isNaN(i[3]) ? 0 : i[3];
  }, set: function(z) {
    i[3] = z;
  } });
  var s = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return s;
  }, set: function(z) {
    switch (z) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        s = z;
        break;
      default:
        throw new Error('Invalid value "' + z + '" for attribute FT supplied.');
    }
  } });
  var l = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!l || l.length < 1) {
      if (this instanceof fu)
        return;
      l = "FieldObject" + t.FieldNum++;
    }
    var z = function(b) {
      return b;
    };
    return this.scope && (z = this.scope.internal.getEncryptor(this.objId)), "(" + kr(z(l)) + ")";
  }, set: function(z) {
    l = z.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return l;
  }, set: function(z) {
    l = z;
  } });
  var a = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return a;
  }, set: function(z) {
    a = z;
  } });
  var o = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return o;
  }, set: function(z) {
    o = z;
  } });
  var h = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return h;
  }, set: function(z) {
    h = z;
  } });
  var u = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return u === void 0 ? 50 / Xq : u;
  }, set: function(z) {
    u = z;
  } });
  var d = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return d;
  }, set: function(z) {
    d = z;
  } });
  var v = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!v || this instanceof fu || this instanceof ur))
      return Qg(v, this.objId, this.scope);
  }, set: function(z) {
    z = z.toString(), v = z;
  } });
  var m = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (m)
      return this instanceof T4 ? m : Qg(m, this.objId, this.scope);
  }, set: function(z) {
    z = z.toString(), m = this instanceof T4 ? z : z.substr(0, 1) === "(" ? Qr(z.substr(1, z.length - 2)) : Qr(z);
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof T4 ? Qr(m.substr(1, m.length - 1)) : m;
  }, set: function(z) {
    z = z.toString(), m = this instanceof T4 ? "/" + z : z;
  } });
  var p = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (p)
      return p;
  }, set: function(z) {
    this.V = z;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (p)
      return this instanceof T4 ? p : Qg(p, this.objId, this.scope);
  }, set: function(z) {
    z = z.toString(), p = this instanceof T4 ? z : z.substr(0, 1) === "(" ? Qr(z.substr(1, z.length - 2)) : Qr(z);
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof T4 ? Qr(p.substr(1, p.length - 1)) : p;
  }, set: function(z) {
    z = z.toString(), p = this instanceof T4 ? "/" + z : z;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var _, q = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return q;
  }, set: function(z) {
    z = !!z, q = z;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (_)
      return _;
  }, set: function(z) {
    _ = z;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 1);
  }, set: function(z) {
    z ? this.Ff = e4(this.Ff, 1) : this.Ff = t4(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 2);
  }, set: function(z) {
    z ? this.Ff = e4(this.Ff, 2) : this.Ff = t4(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 3);
  }, set: function(z) {
    z ? this.Ff = e4(this.Ff, 3) : this.Ff = t4(this.Ff, 3);
  } });
  var M = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (M !== null)
      return M;
  }, set: function(z) {
    if ([0, 1, 2].indexOf(z) === -1)
      throw new Error('Invalid value "' + z + '" for attribute Q supplied.');
    M = z;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var z;
    switch (M) {
      case 0:
      default:
        z = "left";
        break;
      case 1:
        z = "center";
        break;
      case 2:
        z = "right";
    }
    return z;
  }, configurable: !0, enumerable: !0, set: function(z) {
    switch (z) {
      case "right":
      case 2:
        M = 2;
        break;
      case "center":
      case 1:
        M = 1;
        break;
      case "left":
      case 0:
      default:
        M = 0;
    }
  } });
};
p0(yn, Zn);
var Ca = function() {
  yn.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var t = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(n) {
    t = n;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return t;
  }, set: function(n) {
    t = n;
  } });
  var e = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return Uk(e, this.objId, this.scope);
  }, set: function(n) {
    var i, s;
    s = [], typeof (i = n) == "string" && (s = function(l, a, o) {
      o || (o = 1);
      for (var h, u = []; h = a.exec(l); )
        u.push(h[o]);
      return u;
    }(i, /\((.*?)\)/g)), e = s;
  } }), this.getOptions = function() {
    return e;
  }, this.setOptions = function(n) {
    e = n, this.sort && e.sort();
  }, this.addOption = function(n) {
    n = (n = n || "").toString(), e.push(n), this.sort && e.sort();
  }, this.removeOption = function(n, i) {
    for (i = i || !1, n = (n = n || "").toString(); e.indexOf(n) !== -1 && (e.splice(e.indexOf(n), 1), i !== !1); )
      ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 18);
  }, set: function(n) {
    n ? this.Ff = e4(this.Ff, 18) : this.Ff = t4(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 19);
  }, set: function(n) {
    this.combo === !0 && (n ? this.Ff = e4(this.Ff, 19) : this.Ff = t4(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 20);
  }, set: function(n) {
    n ? (this.Ff = e4(this.Ff, 20), e.sort()) : this.Ff = t4(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 22);
  }, set: function(n) {
    n ? this.Ff = e4(this.Ff, 22) : this.Ff = t4(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 23);
  }, set: function(n) {
    n ? this.Ff = e4(this.Ff, 23) : this.Ff = t4(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 27);
  }, set: function(n) {
    n ? this.Ff = e4(this.Ff, 27) : this.Ff = t4(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
p0(Ca, yn);
var ka = function() {
  Ca.call(this), this.fontName = "helvetica", this.combo = !1;
};
p0(ka, Ca);
var Ea = function() {
  ka.call(this), this.combo = !0;
};
p0(Ea, ka);
var Mh = function() {
  Ea.call(this), this.edit = !0;
};
p0(Mh, Ea);
var T4 = function() {
  yn.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 15);
  }, set: function(n) {
    n ? this.Ff = e4(this.Ff, 15) : this.Ff = t4(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 16);
  }, set: function(n) {
    n ? this.Ff = e4(this.Ff, 16) : this.Ff = t4(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 17);
  }, set: function(n) {
    n ? this.Ff = e4(this.Ff, 17) : this.Ff = t4(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 26);
  }, set: function(n) {
    n ? this.Ff = e4(this.Ff, 26) : this.Ff = t4(this.Ff, 26);
  } });
  var t, e = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var n = function(l) {
      return l;
    };
    if (this.scope && (n = this.scope.internal.getEncryptor(this.objId)), Object.keys(e).length !== 0) {
      var i, s = [];
      for (i in s.push("<<"), e)
        s.push("/" + i + " (" + kr(n(e[i])) + ")");
      return s.push(">>"), s.join(`
`);
    }
  }, set: function(n) {
    Ye(n) === "object" && (e = n);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return e.CA || "";
  }, set: function(n) {
    typeof n == "string" && (e.CA = n);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(n) {
    t = n;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return t.substr(1, t.length - 1);
  }, set: function(n) {
    t = "/" + n;
  } });
};
p0(T4, yn);
var bh = function() {
  T4.call(this), this.pushButton = !0;
};
p0(bh, T4);
var Aa = function() {
  T4.call(this), this.radio = !0, this.pushButton = !1;
  var t = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(e) {
    t = e !== void 0 ? e : [];
  } });
};
p0(Aa, T4);
var fu = function() {
  var t, e;
  yn.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(s) {
    t = s;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return e;
  }, set: function(s) {
    e = s;
  } });
  var n, i = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var s = function(o) {
      return o;
    };
    this.scope && (s = this.scope.internal.getEncryptor(this.objId));
    var l, a = [];
    for (l in a.push("<<"), i)
      a.push("/" + l + " (" + kr(s(i[l])) + ")");
    return a.push(">>"), a.join(`
`);
  }, set: function(s) {
    Ye(s) === "object" && (i = s);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return i.CA || "";
  }, set: function(s) {
    typeof s == "string" && (i.CA = s);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return n;
  }, set: function(s) {
    n = s;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return n.substr(1, n.length - 1);
  }, set: function(s) {
    n = "/" + s;
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = j2.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
p0(fu, yn), Aa.prototype.setAppearance = function(t) {
  if (!("createAppearanceStream" in t) || !("getCA" in t))
    throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var e in this.Kids)
    if (this.Kids.hasOwnProperty(e)) {
      var n = this.Kids[e];
      n.appearanceStreamContent = t.createAppearanceStream(n.optionName), n.caption = t.getCA();
    }
}, Aa.prototype.createOption = function(t) {
  var e = new fu();
  return e.Parent = this, e.optionName = t, this.Kids.push(e), RC1.call(this.scope, e), e;
};
var Lh = function() {
  T4.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = j2.CheckBox.createAppearanceStream();
};
p0(Lh, T4);
var ur = function() {
  yn.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 13);
  }, set: function(e) {
    e ? this.Ff = e4(this.Ff, 13) : this.Ff = t4(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 21);
  }, set: function(e) {
    e ? this.Ff = e4(this.Ff, 21) : this.Ff = t4(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 23);
  }, set: function(e) {
    e ? this.Ff = e4(this.Ff, 23) : this.Ff = t4(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 24);
  }, set: function(e) {
    e ? this.Ff = e4(this.Ff, 24) : this.Ff = t4(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 25);
  }, set: function(e) {
    e ? this.Ff = e4(this.Ff, 25) : this.Ff = t4(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 26);
  }, set: function(e) {
    e ? this.Ff = e4(this.Ff, 26) : this.Ff = t4(this.Ff, 26);
  } });
  var t = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(e) {
    t = e;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return t;
  }, set: function(e) {
    Number.isInteger(e) && (t = e);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
p0(ur, yn);
var xh = function() {
  ur.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!Qt(this.Ff, 14);
  }, set: function(t) {
    t ? this.Ff = e4(this.Ff, 14) : this.Ff = t4(this.Ff, 14);
  } }), this.password = !0;
};
p0(xh, ur);
var j2 = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: j2.CheckBox.YesNormal }, D: { On: j2.CheckBox.YesPushDown, Off: j2.CheckBox.OffPushDown } };
}, YesPushDown: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = [], i = t.scope.internal.getFont(t.fontName, t.fontStyle).id, s = t.scope.__private__.encodeColorString(t.color), l = Qy(t, t.caption);
  return n.push("0.749023 g"), n.push("0 0 " + F3(j2.internal.getWidth(t)) + " " + F3(j2.internal.getHeight(t)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + i + " " + F3(l.fontSize) + " Tf " + s), n.push("BT"), n.push(l.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join(`
`), e;
}, YesNormal: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), s = [], l = j2.internal.getHeight(t), a = j2.internal.getWidth(t), o = Qy(t, t.caption);
  return s.push("1 g"), s.push("0 0 " + F3(a) + " " + F3(l) + " re"), s.push("f"), s.push("q"), s.push("0 0 1 rg"), s.push("0 0 " + F3(a - 1) + " " + F3(l - 1) + " re"), s.push("W"), s.push("n"), s.push("0 g"), s.push("BT"), s.push("/" + n + " " + F3(o.fontSize) + " Tf " + i), s.push(o.text), s.push("ET"), s.push("Q"), e.stream = s.join(`
`), e;
}, OffPushDown: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = [];
  return n.push("0.749023 g"), n.push("0 0 " + F3(j2.internal.getWidth(t)) + " " + F3(j2.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join(`
`), e;
} }, RadioButton: { Circle: { createAppearanceStream: function(t) {
  var e = { D: { Off: j2.RadioButton.Circle.OffPushDown }, N: {} };
  return e.N[t] = j2.RadioButton.Circle.YesNormal, e.D[t] = j2.RadioButton.Circle.YesPushDown, e;
}, getCA: function() {
  return "l";
}, YesNormal: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = [], i = j2.internal.getWidth(t) <= j2.internal.getHeight(t) ? j2.internal.getWidth(t) / 4 : j2.internal.getHeight(t) / 4;
  i = Number((0.9 * i).toFixed(5));
  var s = j2.internal.Bezier_C, l = Number((i * s).toFixed(5));
  return n.push("q"), n.push("1 0 0 1 " + ds(j2.internal.getWidth(t) / 2) + " " + ds(j2.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + l + " " + l + " " + i + " 0 " + i + " c"), n.push("-" + l + " " + i + " -" + i + " " + l + " -" + i + " 0 c"), n.push("-" + i + " -" + l + " -" + l + " -" + i + " 0 -" + i + " c"), n.push(l + " -" + i + " " + i + " -" + l + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join(`
`), e;
}, YesPushDown: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = [], i = j2.internal.getWidth(t) <= j2.internal.getHeight(t) ? j2.internal.getWidth(t) / 4 : j2.internal.getHeight(t) / 4;
  i = Number((0.9 * i).toFixed(5));
  var s = Number((2 * i).toFixed(5)), l = Number((s * j2.internal.Bezier_C).toFixed(5)), a = Number((i * j2.internal.Bezier_C).toFixed(5));
  return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + ds(j2.internal.getWidth(t) / 2) + " " + ds(j2.internal.getHeight(t) / 2) + " cm"), n.push(s + " 0 m"), n.push(s + " " + l + " " + l + " " + s + " 0 " + s + " c"), n.push("-" + l + " " + s + " -" + s + " " + l + " -" + s + " 0 c"), n.push("-" + s + " -" + l + " -" + l + " -" + s + " 0 -" + s + " c"), n.push(l + " -" + s + " " + s + " -" + l + " " + s + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + ds(j2.internal.getWidth(t) / 2) + " " + ds(j2.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join(`
`), e;
}, OffPushDown: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = [], i = j2.internal.getWidth(t) <= j2.internal.getHeight(t) ? j2.internal.getWidth(t) / 4 : j2.internal.getHeight(t) / 4;
  i = Number((0.9 * i).toFixed(5));
  var s = Number((2 * i).toFixed(5)), l = Number((s * j2.internal.Bezier_C).toFixed(5));
  return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + ds(j2.internal.getWidth(t) / 2) + " " + ds(j2.internal.getHeight(t) / 2) + " cm"), n.push(s + " 0 m"), n.push(s + " " + l + " " + l + " " + s + " 0 " + s + " c"), n.push("-" + l + " " + s + " -" + s + " " + l + " -" + s + " 0 c"), n.push("-" + s + " -" + l + " -" + l + " -" + s + " 0 -" + s + " c"), n.push(l + " -" + s + " " + s + " -" + l + " " + s + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join(`
`), e;
} }, Cross: { createAppearanceStream: function(t) {
  var e = { D: { Off: j2.RadioButton.Cross.OffPushDown }, N: {} };
  return e.N[t] = j2.RadioButton.Cross.YesNormal, e.D[t] = j2.RadioButton.Cross.YesPushDown, e;
}, getCA: function() {
  return "8";
}, YesNormal: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = [], i = j2.internal.calculateCross(t);
  return n.push("q"), n.push("1 1 " + F3(j2.internal.getWidth(t) - 2) + " " + F3(j2.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push(F3(i.x1.x) + " " + F3(i.x1.y) + " m"), n.push(F3(i.x2.x) + " " + F3(i.x2.y) + " l"), n.push(F3(i.x4.x) + " " + F3(i.x4.y) + " m"), n.push(F3(i.x3.x) + " " + F3(i.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join(`
`), e;
}, YesPushDown: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = j2.internal.calculateCross(t), i = [];
  return i.push("0.749023 g"), i.push("0 0 " + F3(j2.internal.getWidth(t)) + " " + F3(j2.internal.getHeight(t)) + " re"), i.push("f"), i.push("q"), i.push("1 1 " + F3(j2.internal.getWidth(t) - 2) + " " + F3(j2.internal.getHeight(t) - 2) + " re"), i.push("W"), i.push("n"), i.push(F3(n.x1.x) + " " + F3(n.x1.y) + " m"), i.push(F3(n.x2.x) + " " + F3(n.x2.y) + " l"), i.push(F3(n.x4.x) + " " + F3(n.x4.y) + " m"), i.push(F3(n.x3.x) + " " + F3(n.x3.y) + " l"), i.push("s"), i.push("Q"), e.stream = i.join(`
`), e;
}, OffPushDown: function(t) {
  var e = Un(t);
  e.scope = t.scope;
  var n = [];
  return n.push("0.749023 g"), n.push("0 0 " + F3(j2.internal.getWidth(t)) + " " + F3(j2.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join(`
`), e;
} } }, createDefaultAppearanceStream: function(t) {
  var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color);
  return "/" + e + " " + t.fontSize + " Tf " + n;
} };
j2.internal = { Bezier_C: 0.551915024494, calculateCross: function(t) {
  var e = j2.internal.getWidth(t), n = j2.internal.getHeight(t), i = Math.min(e, n);
  return { x1: { x: (e - i) / 2, y: (n - i) / 2 + i }, x2: { x: (e - i) / 2 + i, y: (n - i) / 2 }, x3: { x: (e - i) / 2, y: (n - i) / 2 }, x4: { x: (e - i) / 2 + i, y: (n - i) / 2 + i } };
} }, j2.internal.getWidth = function(t) {
  var e = 0;
  return Ye(t) === "object" && (e = DM(t.Rect[2])), e;
}, j2.internal.getHeight = function(t) {
  var e = 0;
  return Ye(t) === "object" && (e = DM(t.Rect[3])), e;
};
var RC1 = Vt.addField = function(t) {
  if (VC1(this, t), !(t instanceof yn))
    throw new Error("Invalid argument passed to jsPDF.addField.");
  var e;
  return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
Vt.AcroFormChoiceField = Ca, Vt.AcroFormListBox = ka, Vt.AcroFormComboBox = Ea, Vt.AcroFormEditBox = Mh, Vt.AcroFormButton = T4, Vt.AcroFormPushButton = bh, Vt.AcroFormRadioButton = Aa, Vt.AcroFormCheckBox = Lh, Vt.AcroFormTextField = ur, Vt.AcroFormPasswordField = xh, Vt.AcroFormAppearance = j2, Vt.AcroForm = { ChoiceField: Ca, ListBox: ka, ComboBox: Ea, EditBox: Mh, Button: T4, PushButton: bh, RadioButton: Aa, CheckBox: Lh, TextField: ur, PasswordField: xh, Appearance: j2 }, m3.AcroForm = { ChoiceField: Ca, ListBox: ka, ComboBox: Ea, EditBox: Mh, Button: T4, PushButton: bh, RadioButton: Aa, CheckBox: Lh, TextField: ur, PasswordField: xh, Appearance: j2 };
function Wk(t) {
  return t.reduce(function(e, n, i) {
    return e[n] = i, e;
  }, {});
}
(function(t) {
  t.__addimage__ = {};
  var e = "UNKNOWN", n = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, i = t.__addimage__.getImageFileTypeByImageData = function(P, O) {
    var G, j, Q, i1, h1, c1 = e;
    if ((O = O || e) === "RGBA" || P.data !== void 0 && P.data instanceof Uint8ClampedArray && "height" in P && "width" in P)
      return "RGBA";
    if (D(P))
      for (h1 in n)
        for (Q = n[h1], G = 0; G < Q.length; G += 1) {
          for (i1 = !0, j = 0; j < Q[G].length; j += 1)
            if (Q[G][j] !== void 0 && Q[G][j] !== P[j]) {
              i1 = !1;
              break;
            }
          if (i1 === !0) {
            c1 = h1;
            break;
          }
        }
    else
      for (h1 in n)
        for (Q = n[h1], G = 0; G < Q.length; G += 1) {
          for (i1 = !0, j = 0; j < Q[G].length; j += 1)
            if (Q[G][j] !== void 0 && Q[G][j] !== P.charCodeAt(j)) {
              i1 = !1;
              break;
            }
          if (i1 === !0) {
            c1 = h1;
            break;
          }
        }
    return c1 === e && O !== e && (c1 = O), c1;
  }, s = function P(O) {
    for (var G = this.internal.write, j = this.internal.putStream, Q = (0, this.internal.getFilters)(); Q.indexOf("FlateEncode") !== -1; )
      Q.splice(Q.indexOf("FlateEncode"), 1);
    O.objectId = this.internal.newObject();
    var i1 = [];
    if (i1.push({ key: "Type", value: "/XObject" }), i1.push({ key: "Subtype", value: "/Image" }), i1.push({ key: "Width", value: O.width }), i1.push({ key: "Height", value: O.height }), O.colorSpace === M.INDEXED ? i1.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (O.palette.length / 3 - 1) + " " + ("sMask" in O && O.sMask !== void 0 ? O.objectId + 2 : O.objectId + 1) + " 0 R]" }) : (i1.push({ key: "ColorSpace", value: "/" + O.colorSpace }), O.colorSpace === M.DEVICE_CMYK && i1.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), i1.push({ key: "BitsPerComponent", value: O.bitsPerComponent }), "decodeParameters" in O && O.decodeParameters !== void 0 && i1.push({ key: "DecodeParms", value: "<<" + O.decodeParameters + ">>" }), "transparency" in O && Array.isArray(O.transparency)) {
      for (var h1 = "", c1 = 0, M1 = O.transparency.length; c1 < M1; c1++)
        h1 += O.transparency[c1] + " " + O.transparency[c1] + " ";
      i1.push({ key: "Mask", value: "[" + h1 + "]" });
    }
    O.sMask !== void 0 && i1.push({ key: "SMask", value: O.objectId + 1 + " 0 R" });
    var y1 = O.filter !== void 0 ? ["/" + O.filter] : void 0;
    if (j({ data: O.data, additionalKeyValues: i1, alreadyAppliedFilters: y1, objectId: O.objectId }), G("endobj"), "sMask" in O && O.sMask !== void 0) {
      var A1 = "/Predictor " + O.predictor + " /Colors 1 /BitsPerComponent " + O.bitsPerComponent + " /Columns " + O.width, $ = { width: O.width, height: O.height, colorSpace: "DeviceGray", bitsPerComponent: O.bitsPerComponent, decodeParameters: A1, data: O.sMask };
      "filter" in O && ($.filter = O.filter), P.call(this, $);
    }
    if (O.colorSpace === M.INDEXED) {
      var a1 = this.internal.newObject();
      j({ data: V(new Uint8Array(O.palette)), objectId: a1 }), G("endobj");
    }
  }, l = function() {
    var P = this.internal.collections.addImage_images;
    for (var O in P)
      s.call(this, P[O]);
  }, a = function() {
    var P, O = this.internal.collections.addImage_images, G = this.internal.write;
    for (var j in O)
      G("/I" + (P = O[j]).index, P.objectId, "0", "R");
  }, o = function() {
    this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", l), this.internal.events.subscribe("putXobjectDict", a));
  }, h = function() {
    var P = this.internal.collections.addImage_images;
    return o.call(this), P;
  }, u = function() {
    return Object.keys(this.internal.collections.addImage_images).length;
  }, d = function(P) {
    return typeof t["process" + P.toUpperCase()] == "function";
  }, v = function(P) {
    return Ye(P) === "object" && P.nodeType === 1;
  }, m = function(P, O) {
    if (P.nodeName === "IMG" && P.hasAttribute("src")) {
      var G = "" + P.getAttribute("src");
      if (G.indexOf("data:image/") === 0)
        return ko(unescape(G).split("base64,").pop());
      var j = t.loadFile(G, !0);
      if (j !== void 0)
        return j;
    }
    if (P.nodeName === "CANVAS") {
      if (P.width === 0 || P.height === 0)
        throw new Error("Given canvas must have data. Canvas width: " + P.width + ", height: " + P.height);
      var Q;
      switch (O) {
        case "PNG":
          Q = "image/png";
          break;
        case "WEBP":
          Q = "image/webp";
          break;
        case "JPEG":
        case "JPG":
        default:
          Q = "image/jpeg";
      }
      return ko(P.toDataURL(Q, 1).split("base64,").pop());
    }
  }, p = function(P) {
    var O = this.internal.collections.addImage_images;
    if (O) {
      for (var G in O)
        if (P === O[G].alias)
          return O[G];
    }
  }, _ = function(P, O, G) {
    return P || O || (P = -96, O = -96), P < 0 && (P = -1 * G.width * 72 / P / this.internal.scaleFactor), O < 0 && (O = -1 * G.height * 72 / O / this.internal.scaleFactor), P === 0 && (P = O * G.width / G.height), O === 0 && (O = P * G.height / G.width), [P, O];
  }, q = function(P, O, G, j, Q, i1) {
    var h1 = _.call(this, G, j, Q), c1 = this.internal.getCoordinateString, M1 = this.internal.getVerticalCoordinateString, y1 = h.call(this);
    if (G = h1[0], j = h1[1], y1[Q.index] = Q, i1) {
      i1 *= Math.PI / 180;
      var A1 = Math.cos(i1), $ = Math.sin(i1), a1 = function(f1) {
        return f1.toFixed(4);
      }, n1 = [a1(A1), a1($), a1(-1 * $), a1(A1), 0, 0, "cm"];
    }
    this.internal.write("q"), i1 ? (this.internal.write([1, "0", "0", 1, c1(P), M1(O + j), "cm"].join(" ")), this.internal.write(n1.join(" ")), this.internal.write([c1(G), "0", "0", c1(j), "0", "0", "cm"].join(" "))) : this.internal.write([c1(G), "0", "0", c1(j), c1(P), M1(O + j), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + Q.index + " Do"), this.internal.write("Q");
  }, M = t.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  t.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var z = t.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, b = t.__addimage__.sHashCode = function(P) {
    var O, G, j = 0;
    if (typeof P == "string")
      for (G = P.length, O = 0; O < G; O++)
        j = (j << 5) - j + P.charCodeAt(O), j |= 0;
    else if (D(P))
      for (G = P.byteLength / 2, O = 0; O < G; O++)
        j = (j << 5) - j + P[O], j |= 0;
    return j;
  }, x = t.__addimage__.validateStringAsBase64 = function(P) {
    (P = P || "").toString().trim();
    var O = !0;
    return P.length === 0 && (O = !1), P.length % 4 != 0 && (O = !1), /^[A-Za-z0-9+/]+$/.test(P.substr(0, P.length - 2)) === !1 && (O = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(P.substr(-2)) === !1 && (O = !1), O;
  }, k = t.__addimage__.extractImageFromDataUrl = function(P) {
    var O = (P = P || "").split("base64,"), G = null;
    if (O.length === 2) {
      var j = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(O[0]);
      Array.isArray(j) && (G = { mimeType: j[1], charset: j[2], data: O[1] });
    }
    return G;
  }, F = t.__addimage__.supportsArrayBuffer = function() {
    return typeof ArrayBuffer < "u" && typeof Uint8Array < "u";
  };
  t.__addimage__.isArrayBuffer = function(P) {
    return F() && P instanceof ArrayBuffer;
  };
  var D = t.__addimage__.isArrayBufferView = function(P) {
    return F() && typeof Uint32Array < "u" && (P instanceof Int8Array || P instanceof Uint8Array || typeof Uint8ClampedArray < "u" && P instanceof Uint8ClampedArray || P instanceof Int16Array || P instanceof Uint16Array || P instanceof Int32Array || P instanceof Uint32Array || P instanceof Float32Array || P instanceof Float64Array);
  }, R = t.__addimage__.binaryStringToUint8Array = function(P) {
    for (var O = P.length, G = new Uint8Array(O), j = 0; j < O; j++)
      G[j] = P.charCodeAt(j);
    return G;
  }, V = t.__addimage__.arrayBufferToBinaryString = function(P) {
    for (var O = "", G = D(P) ? P : new Uint8Array(P), j = 0; j < G.length; j += 8192)
      O += String.fromCharCode.apply(null, G.subarray(j, j + 8192));
    return O;
  };
  t.addImage = function() {
    var P, O, G, j, Q, i1, h1, c1, M1;
    if (typeof arguments[1] == "number" ? (O = e, G = arguments[1], j = arguments[2], Q = arguments[3], i1 = arguments[4], h1 = arguments[5], c1 = arguments[6], M1 = arguments[7]) : (O = arguments[1], G = arguments[2], j = arguments[3], Q = arguments[4], i1 = arguments[5], h1 = arguments[6], c1 = arguments[7], M1 = arguments[8]), Ye(P = arguments[0]) === "object" && !v(P) && "imageData" in P) {
      var y1 = P;
      P = y1.imageData, O = y1.format || O || e, G = y1.x || G || 0, j = y1.y || j || 0, Q = y1.w || y1.width || Q, i1 = y1.h || y1.height || i1, h1 = y1.alias || h1, c1 = y1.compression || c1, M1 = y1.rotation || y1.angle || M1;
    }
    var A1 = this.internal.getFilters();
    if (c1 === void 0 && A1.indexOf("FlateEncode") !== -1 && (c1 = "SLOW"), isNaN(G) || isNaN(j))
      throw new Error("Invalid coordinates passed to jsPDF.addImage");
    o.call(this);
    var $ = J.call(this, P, O, h1, c1);
    return q.call(this, G, j, Q, i1, $, M1), this;
  };
  var J = function(P, O, G, j) {
    var Q, i1, h1;
    if (typeof P == "string" && i(P) === e) {
      P = unescape(P);
      var c1 = K(P, !1);
      (c1 !== "" || (c1 = t.loadFile(P, !0)) !== void 0) && (P = c1);
    }
    if (v(P) && (P = m(P, O)), O = i(P, O), !d(O))
      throw new Error("addImage does not support files of type '" + O + "', please ensure that a plugin for '" + O + "' support is added.");
    if (((h1 = G) == null || h1.length === 0) && (G = function(M1) {
      return typeof M1 == "string" || D(M1) ? b(M1) : D(M1.data) ? b(M1.data) : null;
    }(P)), (Q = p.call(this, G)) || (F() && (P instanceof Uint8Array || O === "RGBA" || (i1 = P, P = R(P))), Q = this["process" + O.toUpperCase()](P, u.call(this), G, function(M1) {
      return M1 && typeof M1 == "string" && (M1 = M1.toUpperCase()), M1 in t.image_compression ? M1 : z.NONE;
    }(j), i1)), !Q)
      throw new Error("An unknown error occurred whilst processing the image.");
    return Q;
  }, K = t.__addimage__.convertBase64ToBinaryString = function(P, O) {
    var G;
    O = typeof O != "boolean" || O;
    var j, Q = "";
    if (typeof P == "string") {
      j = (G = k(P)) !== null ? G.data : P;
      try {
        Q = ko(j);
      } catch (i1) {
        if (O)
          throw x(j) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + i1.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return Q;
  };
  t.getImageProperties = function(P) {
    var O, G, j = "";
    if (v(P) && (P = m(P)), typeof P == "string" && i(P) === e && ((j = K(P, !1)) === "" && (j = t.loadFile(P) || ""), P = j), G = i(P), !d(G))
      throw new Error("addImage does not support files of type '" + G + "', please ensure that a plugin for '" + G + "' support is added.");
    if (!F() || P instanceof Uint8Array || (P = R(P)), !(O = this["process" + G.toUpperCase()](P)))
      throw new Error("An unknown error occurred whilst processing the image");
    return O.fileType = G, O;
  };
})(m3.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var e = function(n) {
    if (n !== void 0 && n != "")
      return !0;
  };
  m3.API.events.push(["addPage", function(n) {
    this.internal.getPageInfo(n.pageNumber).pageContext.annotations = [];
  }]), t.events.push(["putPage", function(n) {
    for (var i, s, l, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, h = this.internal.getPageInfoByObjId(n.objId), u = n.pageContext.annotations, d = !1, v = 0; v < u.length && !d; v++)
      switch ((i = u[v]).type) {
        case "link":
          (e(i.options.url) || e(i.options.pageNumber)) && (d = !0);
          break;
        case "reference":
        case "text":
        case "freetext":
          d = !0;
      }
    if (d != 0) {
      this.internal.write("/Annots [");
      for (var m = 0; m < u.length; m++) {
        i = u[m];
        var p = this.internal.pdfEscape, _ = this.internal.getEncryptor(n.objId);
        switch (i.type) {
          case "reference":
            this.internal.write(" " + i.object.objId + " 0 R ");
            break;
          case "text":
            var q = this.internal.newAdditionalObject(), M = this.internal.newAdditionalObject(), z = this.internal.getEncryptor(q.objId), b = i.title || "Note";
            l = "<</Type /Annot /Subtype /Text " + (s = "/Rect [" + a(i.bounds.x) + " " + o(i.bounds.y + i.bounds.h) + " " + a(i.bounds.x + i.bounds.w) + " " + o(i.bounds.y) + "] ") + "/Contents (" + p(z(i.contents)) + ")", l += " /Popup " + M.objId + " 0 R", l += " /P " + h.objId + " 0 R", l += " /T (" + p(z(b)) + ") >>", q.content = l;
            var x = q.objId + " 0 R";
            l = "<</Type /Annot /Subtype /Popup " + (s = "/Rect [" + a(i.bounds.x + 30) + " " + o(i.bounds.y + i.bounds.h) + " " + a(i.bounds.x + i.bounds.w + 30) + " " + o(i.bounds.y) + "] ") + " /Parent " + x, i.open && (l += " /Open true"), l += " >>", M.content = l, this.internal.write(q.objId, "0 R", M.objId, "0 R");
            break;
          case "freetext":
            s = "/Rect [" + a(i.bounds.x) + " " + o(i.bounds.y) + " " + a(i.bounds.x + i.bounds.w) + " " + o(i.bounds.y + i.bounds.h) + "] ";
            var k = i.color || "#000000";
            l = "<</Type /Annot /Subtype /FreeText " + s + "/Contents (" + p(_(i.contents)) + ")", l += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + k + ")", l += " /Border [0 0 0]", l += " >>", this.internal.write(l);
            break;
          case "link":
            if (i.options.name) {
              var F = this.annotations._nameMap[i.options.name];
              i.options.pageNumber = F.page, i.options.top = F.y;
            } else
              i.options.top || (i.options.top = 0);
            if (s = "/Rect [" + i.finalBounds.x + " " + i.finalBounds.y + " " + i.finalBounds.w + " " + i.finalBounds.h + "] ", l = "", i.options.url)
              l = "<</Type /Annot /Subtype /Link " + s + "/Border [0 0 0] /A <</S /URI /URI (" + p(_(i.options.url)) + ") >>";
            else if (i.options.pageNumber)
              switch (l = "<</Type /Annot /Subtype /Link " + s + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(i.options.pageNumber).objId + " 0 R", i.options.magFactor = i.options.magFactor || "XYZ", i.options.magFactor) {
                case "Fit":
                  l += " /Fit]";
                  break;
                case "FitH":
                  l += " /FitH " + i.options.top + "]";
                  break;
                case "FitV":
                  i.options.left = i.options.left || 0, l += " /FitV " + i.options.left + "]";
                  break;
                case "XYZ":
                default:
                  var D = o(i.options.top);
                  i.options.left = i.options.left || 0, i.options.zoom === void 0 && (i.options.zoom = 0), l += " /XYZ " + i.options.left + " " + D + " " + i.options.zoom + "]";
              }
            l != "" && (l += " >>", this.internal.write(l));
        }
      }
      this.internal.write("]");
    }
  }]), t.createAnnotation = function(n) {
    var i = this.internal.getCurrentPageInfo();
    switch (n.type) {
      case "link":
        this.link(n.bounds.x, n.bounds.y, n.bounds.w, n.bounds.h, n);
        break;
      case "text":
      case "freetext":
        i.pageContext.annotations.push(n);
    }
  }, t.link = function(n, i, s, l, a) {
    var o = this.internal.getCurrentPageInfo(), h = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString;
    o.pageContext.annotations.push({ finalBounds: { x: h(n), y: u(i), w: h(n + s), h: u(i + l) }, options: a, type: "link" });
  }, t.textWithLink = function(n, i, s, l) {
    var a, o, h = this.getTextWidth(n), u = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (l.maxWidth !== void 0) {
      o = l.maxWidth;
      var d = this.splitTextToSize(n, o).length;
      a = Math.ceil(u * d);
    } else
      o = h, a = u;
    return this.text(n, i, s, l), s += 0.2 * u, l.align === "center" && (i -= h / 2), l.align === "right" && (i -= h), this.link(i, s - u, o, a, l), h;
  }, t.getTextWidth = function(n) {
    var i = this.internal.getFontSize();
    return this.getStringUnitWidth(n) * i / this.internal.scaleFactor;
  };
}(m3.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var e = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, n = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, i = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, s = [1570, 1571, 1573, 1575];
  t.__arabicParser__ = {};
  var l = t.__arabicParser__.isInArabicSubstitutionA = function(q) {
    return e[q.charCodeAt(0)] !== void 0;
  }, a = t.__arabicParser__.isArabicLetter = function(q) {
    return typeof q == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(q);
  }, o = t.__arabicParser__.isArabicEndLetter = function(q) {
    return a(q) && l(q) && e[q.charCodeAt(0)].length <= 2;
  }, h = t.__arabicParser__.isArabicAlfLetter = function(q) {
    return a(q) && s.indexOf(q.charCodeAt(0)) >= 0;
  };
  t.__arabicParser__.arabicLetterHasIsolatedForm = function(q) {
    return a(q) && l(q) && e[q.charCodeAt(0)].length >= 1;
  };
  var u = t.__arabicParser__.arabicLetterHasFinalForm = function(q) {
    return a(q) && l(q) && e[q.charCodeAt(0)].length >= 2;
  };
  t.__arabicParser__.arabicLetterHasInitialForm = function(q) {
    return a(q) && l(q) && e[q.charCodeAt(0)].length >= 3;
  };
  var d = t.__arabicParser__.arabicLetterHasMedialForm = function(q) {
    return a(q) && l(q) && e[q.charCodeAt(0)].length == 4;
  }, v = t.__arabicParser__.resolveLigatures = function(q) {
    var M = 0, z = n, b = "", x = 0;
    for (M = 0; M < q.length; M += 1)
      z[q.charCodeAt(M)] !== void 0 ? (x++, typeof (z = z[q.charCodeAt(M)]) == "number" && (b += String.fromCharCode(z), z = n, x = 0), M === q.length - 1 && (z = n, b += q.charAt(M - (x - 1)), M -= x - 1, x = 0)) : (z = n, b += q.charAt(M - x), M -= x, x = 0);
    return b;
  };
  t.__arabicParser__.isArabicDiacritic = function(q) {
    return q !== void 0 && i[q.charCodeAt(0)] !== void 0;
  };
  var m = t.__arabicParser__.getCorrectForm = function(q, M, z) {
    return a(q) ? l(q) === !1 ? -1 : !u(q) || !a(M) && !a(z) || !a(z) && o(M) || o(q) && !a(M) || o(q) && h(M) || o(q) && o(M) ? 0 : d(q) && a(M) && !o(M) && a(z) && u(z) ? 3 : o(q) || !a(z) ? 1 : 2 : -1;
  }, p = function(q) {
    var M = 0, z = 0, b = 0, x = "", k = "", F = "", D = (q = q || "").split("\\s+"), R = [];
    for (M = 0; M < D.length; M += 1) {
      for (R.push(""), z = 0; z < D[M].length; z += 1)
        x = D[M][z], k = D[M][z - 1], F = D[M][z + 1], a(x) ? (b = m(x, k, F), R[M] += b !== -1 ? String.fromCharCode(e[x.charCodeAt(0)][b]) : x) : R[M] += x;
      R[M] = v(R[M]);
    }
    return R.join(" ");
  }, _ = t.__arabicParser__.processArabic = t.processArabic = function() {
    var q, M = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, z = [];
    if (Array.isArray(M)) {
      var b = 0;
      for (z = [], b = 0; b < M.length; b += 1)
        Array.isArray(M[b]) ? z.push([p(M[b][0]), M[b][1], M[b][2]]) : z.push([p(M[b])]);
      q = z;
    } else
      q = p(M);
    return typeof arguments[0] == "string" ? q : (arguments[0].text = q, arguments[0]);
  };
  t.events.push(["preProcessText", _]);
}(m3.API), m3.API.autoPrint = function(t) {
  var e;
  switch ((t = t || {}).variant = t.variant || "non-conform", t.variant) {
    case "javascript":
      this.addJS("print({});");
      break;
    case "non-conform":
    default:
      this.internal.events.subscribe("postPutResources", function() {
        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
      }), this.internal.events.subscribe("putCatalog", function() {
        this.internal.out("/OpenAction " + e + " 0 R");
      });
  }
  return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var e = function() {
    var n = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return n;
    }, set: function(o) {
      n = o;
    } });
    var i = 150;
    Object.defineProperty(this, "width", { get: function() {
      return i;
    }, set: function(o) {
      i = isNaN(o) || Number.isInteger(o) === !1 || o < 0 ? 150 : o, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = i + 1);
    } });
    var s = 300;
    Object.defineProperty(this, "height", { get: function() {
      return s;
    }, set: function(o) {
      s = isNaN(o) || Number.isInteger(o) === !1 || o < 0 ? 300 : o, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = s + 1);
    } });
    var l = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return l;
    }, set: function(o) {
      l = o;
    } });
    var a = {};
    Object.defineProperty(this, "style", { get: function() {
      return a;
    }, set: function(o) {
      a = o;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  e.prototype.getContext = function(n, i) {
    var s;
    if ((n = n || "2d") !== "2d")
      return null;
    for (s in i)
      this.pdf.context2d.hasOwnProperty(s) && (this.pdf.context2d[s] = i[s]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, e.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, t.events.push(["initialized", function() {
    this.canvas = new e(), this.canvas.pdf = this;
  }]);
}(m3.API), function(t) {
  var e = { left: 0, top: 0, bottom: 0, right: 0 }, n = !1, i = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, e), this.internal.__cell__.margins.width = this.getPageWidth(), s.call(this));
  }, s = function() {
    this.internal.__cell__.lastCell = new l(), this.internal.__cell__.pages = 1;
  }, l = function() {
    var h = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return h;
    }, set: function(q) {
      h = q;
    } });
    var u = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return u;
    }, set: function(q) {
      u = q;
    } });
    var d = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return d;
    }, set: function(q) {
      d = q;
    } });
    var v = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return v;
    }, set: function(q) {
      v = q;
    } });
    var m = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return m;
    }, set: function(q) {
      m = q;
    } });
    var p = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return p;
    }, set: function(q) {
      p = q;
    } });
    var _ = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return _;
    }, set: function(q) {
      _ = q;
    } }), this;
  };
  l.prototype.clone = function() {
    return new l(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, l.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, t.setHeaderFunction = function(h) {
    return i.call(this), this.internal.__cell__.headerFunction = typeof h == "function" ? h : void 0, this;
  }, t.getTextDimensions = function(h, u) {
    i.call(this);
    var d = (u = u || {}).fontSize || this.getFontSize(), v = u.font || this.getFont(), m = u.scaleFactor || this.internal.scaleFactor, p = 0, _ = 0, q = 0, M = this;
    if (!Array.isArray(h) && typeof h != "string") {
      if (typeof h != "number")
        throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      h = String(h);
    }
    var z = u.maxWidth;
    z > 0 ? typeof h == "string" ? h = this.splitTextToSize(h, z) : Object.prototype.toString.call(h) === "[object Array]" && (h = h.reduce(function(x, k) {
      return x.concat(M.splitTextToSize(k, z));
    }, [])) : h = Array.isArray(h) ? h : [h];
    for (var b = 0; b < h.length; b++)
      p < (q = this.getStringUnitWidth(h[b], { font: v }) * d) && (p = q);
    return p !== 0 && (_ = h.length), { w: p /= m, h: Math.max((_ * d * this.getLineHeightFactor() - d * (this.getLineHeightFactor() - 1)) / m, 0) };
  }, t.cellAddPage = function() {
    i.call(this), this.addPage();
    var h = this.internal.__cell__.margins || e;
    return this.internal.__cell__.lastCell = new l(h.left, h.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var a = t.cell = function() {
    var h;
    h = arguments[0] instanceof l ? arguments[0] : new l(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i.call(this);
    var u = this.internal.__cell__.lastCell, d = this.internal.__cell__.padding, v = this.internal.__cell__.margins || e, m = this.internal.__cell__.tableHeaderRow, p = this.internal.__cell__.printHeaders;
    return u.lineNumber !== void 0 && (u.lineNumber === h.lineNumber ? (h.x = (u.x || 0) + (u.width || 0), h.y = u.y || 0) : u.y + u.height + h.height + v.bottom > this.getPageHeight() ? (this.cellAddPage(), h.y = v.top, p && m && (this.printHeaderRow(h.lineNumber, !0), h.y += m[0].height)) : h.y = u.y + u.height || h.y), h.text[0] !== void 0 && (this.rect(h.x, h.y, h.width, h.height, n === !0 ? "FD" : void 0), h.align === "right" ? this.text(h.text, h.x + h.width - d, h.y + d, { align: "right", baseline: "top" }) : h.align === "center" ? this.text(h.text, h.x + h.width / 2, h.y + d, { align: "center", baseline: "top", maxWidth: h.width - d - d }) : this.text(h.text, h.x + d, h.y + d, { align: "left", baseline: "top", maxWidth: h.width - d - d })), this.internal.__cell__.lastCell = h, this;
  };
  t.table = function(h, u, d, v, m) {
    if (i.call(this), !d)
      throw new Error("No data for PDF table.");
    var p, _, q, M, z = [], b = [], x = [], k = {}, F = {}, D = [], R = [], V = (m = m || {}).autoSize || !1, J = m.printHeaders !== !1, K = m.css && m.css["font-size"] !== void 0 ? 16 * m.css["font-size"] : m.fontSize || 12, P = m.margins || Object.assign({ width: this.getPageWidth() }, e), O = typeof m.padding == "number" ? m.padding : 3, G = m.headerBackgroundColor || "#c8c8c8", j = m.headerTextColor || "#000";
    if (s.call(this), this.internal.__cell__.printHeaders = J, this.internal.__cell__.margins = P, this.internal.__cell__.table_font_size = K, this.internal.__cell__.padding = O, this.internal.__cell__.headerBackgroundColor = G, this.internal.__cell__.headerTextColor = j, this.setFontSize(K), v == null)
      b = z = Object.keys(d[0]), x = z.map(function() {
        return "left";
      });
    else if (Array.isArray(v) && Ye(v[0]) === "object")
      for (z = v.map(function(y1) {
        return y1.name;
      }), b = v.map(function(y1) {
        return y1.prompt || y1.name || "";
      }), x = v.map(function(y1) {
        return y1.align || "left";
      }), p = 0; p < v.length; p += 1)
        F[v[p].name] = v[p].width * (19.049976 / 25.4);
    else
      Array.isArray(v) && typeof v[0] == "string" && (b = z = v, x = z.map(function() {
        return "left";
      }));
    if (V || Array.isArray(v) && typeof v[0] == "string")
      for (p = 0; p < z.length; p += 1) {
        for (k[M = z[p]] = d.map(function(y1) {
          return y1[M];
        }), this.setFont(void 0, "bold"), D.push(this.getTextDimensions(b[p], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), _ = k[M], this.setFont(void 0, "normal"), q = 0; q < _.length; q += 1)
          D.push(this.getTextDimensions(_[q], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
        F[M] = Math.max.apply(null, D) + O + O, D = [];
      }
    if (J) {
      var Q = {};
      for (p = 0; p < z.length; p += 1)
        Q[z[p]] = {}, Q[z[p]].text = b[p], Q[z[p]].align = x[p];
      var i1 = o.call(this, Q, F);
      R = z.map(function(y1) {
        return new l(h, u, F[y1], i1, Q[y1].text, void 0, Q[y1].align);
      }), this.setTableHeaderRow(R), this.printHeaderRow(1, !1);
    }
    var h1 = v.reduce(function(y1, A1) {
      return y1[A1.name] = A1.align, y1;
    }, {});
    for (p = 0; p < d.length; p += 1) {
      "rowStart" in m && m.rowStart instanceof Function && m.rowStart({ row: p, data: d[p] }, this);
      var c1 = o.call(this, d[p], F);
      for (q = 0; q < z.length; q += 1) {
        var M1 = d[p][z[q]];
        "cellStart" in m && m.cellStart instanceof Function && m.cellStart({ row: p, col: q, data: M1 }, this), a.call(this, new l(h, u, F[z[q]], c1, M1, p + 2, h1[z[q]]));
      }
    }
    return this.internal.__cell__.table_x = h, this.internal.__cell__.table_y = u, this;
  };
  var o = function(h, u) {
    var d = this.internal.__cell__.padding, v = this.internal.__cell__.table_font_size, m = this.internal.scaleFactor;
    return Object.keys(h).map(function(p) {
      var _ = h[p];
      return this.splitTextToSize(_.hasOwnProperty("text") ? _.text : _, u[p] - d - d);
    }, this).map(function(p) {
      return this.getLineHeightFactor() * p.length * v / m + d + d;
    }, this).reduce(function(p, _) {
      return Math.max(p, _);
    }, 0);
  };
  t.setTableHeaderRow = function(h) {
    i.call(this), this.internal.__cell__.tableHeaderRow = h;
  }, t.printHeaderRow = function(h, u) {
    if (i.call(this), !this.internal.__cell__.tableHeaderRow)
      throw new Error("Property tableHeaderRow does not exist.");
    var d;
    if (n = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var v = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new l(v[0], v[1], v[2], v[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var m = [], p = 0; p < this.internal.__cell__.tableHeaderRow.length; p += 1) {
      d = this.internal.__cell__.tableHeaderRow[p].clone(), u && (d.y = this.internal.__cell__.margins.top || 0, m.push(d)), d.lineNumber = h;
      var _ = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), a.call(this, d), this.setTextColor(_);
    }
    m.length > 0 && this.setTableHeaderRow(m), this.setFont(void 0, "normal"), n = !1;
  };
}(m3.API);
var Yk = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, Xk = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], e_ = Wk(Xk), Kk = [100, 200, 300, 400, 500, 600, 700, 800, 900], HC1 = Wk(Kk);
function t_(t) {
  var e = t.family.replace(/"|'/g, "").toLowerCase(), n = function(l) {
    return Yk[l = l || "normal"] ? l : "normal";
  }(t.style), i = function(l) {
    if (!l)
      return 400;
    if (typeof l == "number")
      return l >= 100 && l <= 900 && l % 100 == 0 ? l : 400;
    if (/^\d00$/.test(l))
      return parseInt(l);
    switch (l) {
      case "bold":
        return 700;
      case "normal":
      default:
        return 400;
    }
  }(t.weight), s = function(l) {
    return typeof e_[l = l || "normal"] == "number" ? l : "normal";
  }(t.stretch);
  return { family: e, style: n, weight: i, stretch: s, src: t.src || [], ref: t.ref || { name: e, style: [s, n, i].join(" ") } };
}
function $M(t, e, n, i) {
  var s;
  for (s = n; s >= 0 && s < e.length; s += i)
    if (t[e[s]])
      return t[e[s]];
  for (s = n; s >= 0 && s < e.length; s -= i)
    if (t[e[s]])
      return t[e[s]];
}
var DC1 = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, UM = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function jM(t) {
  return [t.stretch, t.style, t.weight, t.family].join(" ");
}
function $C1(t, e, n) {
  for (var i = (n = n || {}).defaultFontFamily || "times", s = Object.assign({}, DC1, n.genericFontFamilies || {}), l = null, a = null, o = 0; o < e.length; ++o)
    if (s[(l = t_(e[o])).family] && (l.family = s[l.family]), t.hasOwnProperty(l.family)) {
      a = t[l.family];
      break;
    }
  if (!(a = a || t[i]))
    throw new Error("Could not find a font-family for the rule '" + jM(l) + "' and default family '" + i + "'.");
  if (a = function(h, u) {
    if (u[h])
      return u[h];
    var d = e_[h], v = d <= e_.normal ? -1 : 1, m = $M(u, Xk, d, v);
    if (!m)
      throw new Error("Could not find a matching font-stretch value for " + h);
    return m;
  }(l.stretch, a), a = function(h, u) {
    if (u[h])
      return u[h];
    for (var d = Yk[h], v = 0; v < d.length; ++v)
      if (u[d[v]])
        return u[d[v]];
    throw new Error("Could not find a matching font-style for " + h);
  }(l.style, a), !(a = function(h, u) {
    if (u[h])
      return u[h];
    if (h === 400 && u[500])
      return u[500];
    if (h === 500 && u[400])
      return u[400];
    var d = HC1[h], v = $M(u, Kk, d, h < 400 ? -1 : 1);
    if (!v)
      throw new Error("Could not find a matching font-weight for value " + h);
    return v;
  }(l.weight, a)))
    throw new Error("Failed to resolve a font for the rule '" + jM(l) + "'.");
  return a;
}
function GM(t) {
  return t.trimLeft();
}
function UC1(t, e) {
  for (var n = 0; n < t.length; ) {
    if (t.charAt(n) === e)
      return [t.substring(0, n), t.substring(n + 1)];
    n += 1;
  }
  return null;
}
function jC1(t) {
  var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return e === null ? null : [e[0], t.substring(e[0].length)];
}
var ch, WM, YM, ey = ["times"];
(function(t) {
  var e, n, i, s, l, a, o, h, u, d = function($) {
    return $ = $ || {}, this.isStrokeTransparent = $.isStrokeTransparent || !1, this.strokeOpacity = $.strokeOpacity || 1, this.strokeStyle = $.strokeStyle || "#000000", this.fillStyle = $.fillStyle || "#000000", this.isFillTransparent = $.isFillTransparent || !1, this.fillOpacity = $.fillOpacity || 1, this.font = $.font || "10px sans-serif", this.textBaseline = $.textBaseline || "alphabetic", this.textAlign = $.textAlign || "left", this.lineWidth = $.lineWidth || 1, this.lineJoin = $.lineJoin || "miter", this.lineCap = $.lineCap || "butt", this.path = $.path || [], this.transform = $.transform !== void 0 ? $.transform.clone() : new h(), this.globalCompositeOperation = $.globalCompositeOperation || "normal", this.globalAlpha = $.globalAlpha || 1, this.clip_path = $.clip_path || [], this.currentPoint = $.currentPoint || new a(), this.miterLimit = $.miterLimit || 10, this.lastPoint = $.lastPoint || new a(), this.lineDashOffset = $.lineDashOffset || 0, this.lineDash = $.lineDash || [], this.margin = $.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = $.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof $.ignoreClearRect != "boolean" || $.ignoreClearRect, this;
  };
  t.events.push(["initialized", function() {
    this.context2d = new v(this), e = this.internal.f2, n = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, s = this.internal.getHorizontalCoordinate, l = this.internal.getVerticalCoordinate, a = this.internal.Point, o = this.internal.Rectangle, h = this.internal.Matrix, u = new d();
  }]);
  var v = function($) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var a1 = $;
    Object.defineProperty(this, "pdf", { get: function() {
      return a1;
    } });
    var n1 = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return n1;
    }, set: function(B1) {
      n1 = !!B1;
    } });
    var f1 = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return f1;
    }, set: function(B1) {
      f1 = !!B1;
    } });
    var w1 = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return w1;
    }, set: function(B1) {
      isNaN(B1) || (w1 = B1);
    } });
    var C1 = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return C1;
    }, set: function(B1) {
      isNaN(B1) || (C1 = B1);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return u.margin;
    }, set: function(B1) {
      var p1;
      typeof B1 == "number" ? p1 = [B1, B1, B1, B1] : ((p1 = new Array(4))[0] = B1[0], p1[1] = B1.length >= 2 ? B1[1] : p1[0], p1[2] = B1.length >= 3 ? B1[2] : p1[0], p1[3] = B1.length >= 4 ? B1[3] : p1[1]), u.margin = p1;
    } });
    var E1 = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return E1;
    }, set: function(B1) {
      E1 = B1;
    } });
    var T1 = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return T1;
    }, set: function(B1) {
      T1 = B1;
    } });
    var n2 = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return n2;
    }, set: function(B1) {
      n2 = B1;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return u;
    }, set: function(B1) {
      B1 instanceof d && (u = B1);
    } }), Object.defineProperty(this, "path", { get: function() {
      return u.path;
    }, set: function(B1) {
      u.path = B1;
    } });
    var X1 = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return X1;
    }, set: function(B1) {
      X1 = B1;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(B1) {
      var p1;
      p1 = m(B1), this.ctx.fillStyle = p1.style, this.ctx.isFillTransparent = p1.a === 0, this.ctx.fillOpacity = p1.a, this.pdf.setFillColor(p1.r, p1.g, p1.b, { a: p1.a }), this.pdf.setTextColor(p1.r, p1.g, p1.b, { a: p1.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(B1) {
      var p1 = m(B1);
      this.ctx.strokeStyle = p1.style, this.ctx.isStrokeTransparent = p1.a === 0, this.ctx.strokeOpacity = p1.a, p1.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (p1.a, this.pdf.setDrawColor(p1.r, p1.g, p1.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(B1) {
      ["butt", "round", "square"].indexOf(B1) !== -1 && (this.ctx.lineCap = B1, this.pdf.setLineCap(B1));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(B1) {
      isNaN(B1) || (this.ctx.lineWidth = B1, this.pdf.setLineWidth(B1));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(B1) {
      ["bevel", "round", "miter"].indexOf(B1) !== -1 && (this.ctx.lineJoin = B1, this.pdf.setLineJoin(B1));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(B1) {
      isNaN(B1) || (this.ctx.miterLimit = B1, this.pdf.setMiterLimit(B1));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(B1) {
      this.ctx.textBaseline = B1;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(B1) {
      ["right", "end", "center", "left", "start"].indexOf(B1) !== -1 && (this.ctx.textAlign = B1);
    } });
    var a2 = null;
    function d2(B1, p1) {
      if (a2 === null) {
        var _2 = function(w2) {
          var K1 = [];
          return Object.keys(w2).forEach(function(e2) {
            w2[e2].forEach(function(Z1) {
              var t2 = null;
              switch (Z1) {
                case "bold":
                  t2 = { family: e2, weight: "bold" };
                  break;
                case "italic":
                  t2 = { family: e2, style: "italic" };
                  break;
                case "bolditalic":
                  t2 = { family: e2, weight: "bold", style: "italic" };
                  break;
                case "":
                case "normal":
                  t2 = { family: e2 };
              }
              t2 !== null && (t2.ref = { name: e2, style: Z1 }, K1.push(t2));
            });
          }), K1;
        }(B1.getFontList());
        a2 = function(w2) {
          for (var K1 = {}, e2 = 0; e2 < w2.length; ++e2) {
            var Z1 = t_(w2[e2]), t2 = Z1.family, S2 = Z1.stretch, W2 = Z1.style, E2 = Z1.weight;
            K1[t2] = K1[t2] || {}, K1[t2][S2] = K1[t2][S2] || {}, K1[t2][S2][W2] = K1[t2][S2][W2] || {}, K1[t2][S2][W2][E2] = Z1;
          }
          return K1;
        }(_2.concat(p1));
      }
      return a2;
    }
    var y2 = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return y2;
    }, set: function(B1) {
      a2 = null, y2 = B1;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(B1) {
      var p1;
      if (this.ctx.font = B1, (p1 = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(B1)) !== null) {
        var _2 = p1[1], w2 = (p1[2], p1[3]), K1 = p1[4], e2 = (p1[5], p1[6]), Z1 = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(K1)[2];
        K1 = Math.floor(Z1 === "px" ? parseFloat(K1) * this.pdf.internal.scaleFactor : Z1 === "em" ? parseFloat(K1) * this.pdf.getFontSize() : parseFloat(K1) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(K1);
        var t2 = function(G2) {
          var u3, g2, Oe = [], q3 = G2.trim();
          if (q3 === "")
            return ey;
          if (q3 in UM)
            return [UM[q3]];
          for (; q3 !== ""; ) {
            switch (g2 = null, u3 = (q3 = GM(q3)).charAt(0)) {
              case '"':
              case "'":
                g2 = UC1(q3.substring(1), u3);
                break;
              default:
                g2 = jC1(q3);
            }
            if (g2 === null || (Oe.push(g2[0]), (q3 = GM(g2[1])) !== "" && q3.charAt(0) !== ","))
              return ey;
            q3 = q3.replace(/^,/, "");
          }
          return Oe;
        }(e2);
        if (this.fontFaces) {
          var S2 = $C1(d2(this.pdf, this.fontFaces), t2.map(function(G2) {
            return { family: G2, stretch: "normal", weight: w2, style: _2 };
          }));
          this.pdf.setFont(S2.ref.name, S2.ref.style);
        } else {
          var W2 = "";
          (w2 === "bold" || parseInt(w2, 10) >= 700 || _2 === "bold") && (W2 = "bold"), _2 === "italic" && (W2 += "italic"), W2.length === 0 && (W2 = "normal");
          for (var E2 = "", o3 = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, n3 = 0; n3 < t2.length; n3++) {
            if (this.pdf.internal.getFont(t2[n3], W2, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              E2 = t2[n3];
              break;
            }
            if (W2 === "bolditalic" && this.pdf.internal.getFont(t2[n3], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0)
              E2 = t2[n3], W2 = "bold";
            else if (this.pdf.internal.getFont(t2[n3], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              E2 = t2[n3], W2 = "normal";
              break;
            }
          }
          if (E2 === "") {
            for (var c3 = 0; c3 < t2.length; c3++)
              if (o3[t2[c3]]) {
                E2 = o3[t2[c3]];
                break;
              }
          }
          E2 = E2 === "" ? "Times" : E2, this.pdf.setFont(E2, W2);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(B1) {
      this.ctx.globalCompositeOperation = B1;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(B1) {
      this.ctx.globalAlpha = B1;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(B1) {
      this.ctx.lineDashOffset = B1, A1.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(B1) {
      this.ctx.lineDash = B1, A1.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(B1) {
      this.ctx.ignoreClearRect = !!B1;
    } });
  };
  v.prototype.setLineDash = function($) {
    this.lineDash = $;
  }, v.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, v.prototype.fill = function() {
    k.call(this, "fill", !1);
  }, v.prototype.stroke = function() {
    k.call(this, "stroke", !1);
  }, v.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, v.prototype.moveTo = function($, a1) {
    if (isNaN($) || isNaN(a1))
      throw at.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var n1 = this.ctx.transform.applyToPoint(new a($, a1));
    this.path.push({ type: "mt", x: n1.x, y: n1.y }), this.ctx.lastPoint = new a($, a1);
  }, v.prototype.closePath = function() {
    var $ = new a(0, 0), a1 = 0;
    for (a1 = this.path.length - 1; a1 !== -1; a1--)
      if (this.path[a1].type === "begin" && Ye(this.path[a1 + 1]) === "object" && typeof this.path[a1 + 1].x == "number") {
        $ = new a(this.path[a1 + 1].x, this.path[a1 + 1].y);
        break;
      }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new a($.x, $.y);
  }, v.prototype.lineTo = function($, a1) {
    if (isNaN($) || isNaN(a1))
      throw at.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var n1 = this.ctx.transform.applyToPoint(new a($, a1));
    this.path.push({ type: "lt", x: n1.x, y: n1.y }), this.ctx.lastPoint = new a(n1.x, n1.y);
  }, v.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), k.call(this, null, !0);
  }, v.prototype.quadraticCurveTo = function($, a1, n1, f1) {
    if (isNaN(n1) || isNaN(f1) || isNaN($) || isNaN(a1))
      throw at.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var w1 = this.ctx.transform.applyToPoint(new a(n1, f1)), C1 = this.ctx.transform.applyToPoint(new a($, a1));
    this.path.push({ type: "qct", x1: C1.x, y1: C1.y, x: w1.x, y: w1.y }), this.ctx.lastPoint = new a(w1.x, w1.y);
  }, v.prototype.bezierCurveTo = function($, a1, n1, f1, w1, C1) {
    if (isNaN(w1) || isNaN(C1) || isNaN($) || isNaN(a1) || isNaN(n1) || isNaN(f1))
      throw at.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var E1 = this.ctx.transform.applyToPoint(new a(w1, C1)), T1 = this.ctx.transform.applyToPoint(new a($, a1)), n2 = this.ctx.transform.applyToPoint(new a(n1, f1));
    this.path.push({ type: "bct", x1: T1.x, y1: T1.y, x2: n2.x, y2: n2.y, x: E1.x, y: E1.y }), this.ctx.lastPoint = new a(E1.x, E1.y);
  }, v.prototype.arc = function($, a1, n1, f1, w1, C1) {
    if (isNaN($) || isNaN(a1) || isNaN(n1) || isNaN(f1) || isNaN(w1))
      throw at.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (C1 = !!C1, !this.ctx.transform.isIdentity) {
      var E1 = this.ctx.transform.applyToPoint(new a($, a1));
      $ = E1.x, a1 = E1.y;
      var T1 = this.ctx.transform.applyToPoint(new a(0, n1)), n2 = this.ctx.transform.applyToPoint(new a(0, 0));
      n1 = Math.sqrt(Math.pow(T1.x - n2.x, 2) + Math.pow(T1.y - n2.y, 2));
    }
    Math.abs(w1 - f1) >= 2 * Math.PI && (f1 = 0, w1 = 2 * Math.PI), this.path.push({ type: "arc", x: $, y: a1, radius: n1, startAngle: f1, endAngle: w1, counterclockwise: C1 });
  }, v.prototype.arcTo = function($, a1, n1, f1, w1) {
    throw new Error("arcTo not implemented.");
  }, v.prototype.rect = function($, a1, n1, f1) {
    if (isNaN($) || isNaN(a1) || isNaN(n1) || isNaN(f1))
      throw at.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo($, a1), this.lineTo($ + n1, a1), this.lineTo($ + n1, a1 + f1), this.lineTo($, a1 + f1), this.lineTo($, a1), this.lineTo($ + n1, a1), this.lineTo($, a1);
  }, v.prototype.fillRect = function($, a1, n1, f1) {
    if (isNaN($) || isNaN(a1) || isNaN(n1) || isNaN(f1))
      throw at.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!p.call(this)) {
      var w1 = {};
      this.lineCap !== "butt" && (w1.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (w1.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect($, a1, n1, f1), this.fill(), w1.hasOwnProperty("lineCap") && (this.lineCap = w1.lineCap), w1.hasOwnProperty("lineJoin") && (this.lineJoin = w1.lineJoin);
    }
  }, v.prototype.strokeRect = function($, a1, n1, f1) {
    if (isNaN($) || isNaN(a1) || isNaN(n1) || isNaN(f1))
      throw at.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    _.call(this) || (this.beginPath(), this.rect($, a1, n1, f1), this.stroke());
  }, v.prototype.clearRect = function($, a1, n1, f1) {
    if (isNaN($) || isNaN(a1) || isNaN(n1) || isNaN(f1))
      throw at.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect($, a1, n1, f1));
  }, v.prototype.save = function($) {
    $ = typeof $ != "boolean" || $;
    for (var a1 = this.pdf.internal.getCurrentPageInfo().pageNumber, n1 = 0; n1 < this.pdf.internal.getNumberOfPages(); n1++)
      this.pdf.setPage(n1 + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(a1), $) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var f1 = new d(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = f1;
    }
  }, v.prototype.restore = function($) {
    $ = typeof $ != "boolean" || $;
    for (var a1 = this.pdf.internal.getCurrentPageInfo().pageNumber, n1 = 0; n1 < this.pdf.internal.getNumberOfPages(); n1++)
      this.pdf.setPage(n1 + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(a1), $ && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, v.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var m = function($) {
    var a1, n1, f1, w1;
    if ($.isCanvasGradient === !0 && ($ = $.getColor()), !$)
      return { r: 0, g: 0, b: 0, a: 0, style: $ };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test($))
      a1 = 0, n1 = 0, f1 = 0, w1 = 0;
    else {
      var C1 = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec($);
      if (C1 !== null)
        a1 = parseInt(C1[1]), n1 = parseInt(C1[2]), f1 = parseInt(C1[3]), w1 = 1;
      else if ((C1 = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec($)) !== null)
        a1 = parseInt(C1[1]), n1 = parseInt(C1[2]), f1 = parseInt(C1[3]), w1 = parseFloat(C1[4]);
      else {
        if (w1 = 1, typeof $ == "string" && $.charAt(0) !== "#") {
          var E1 = new Hk($);
          $ = E1.ok ? E1.toHex() : "#000000";
        }
        $.length === 4 ? (a1 = $.substring(1, 2), a1 += a1, n1 = $.substring(2, 3), n1 += n1, f1 = $.substring(3, 4), f1 += f1) : (a1 = $.substring(1, 3), n1 = $.substring(3, 5), f1 = $.substring(5, 7)), a1 = parseInt(a1, 16), n1 = parseInt(n1, 16), f1 = parseInt(f1, 16);
      }
    }
    return { r: a1, g: n1, b: f1, a: w1, style: $ };
  }, p = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, _ = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  v.prototype.fillText = function($, a1, n1, f1) {
    if (isNaN(a1) || isNaN(n1) || typeof $ != "string")
      throw at.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (f1 = isNaN(f1) ? void 0 : f1, !p.call(this)) {
      var w1 = c1(this.ctx.transform.rotation), C1 = this.ctx.transform.scaleX;
      O.call(this, { text: $, x: a1, y: n1, scale: C1, angle: w1, align: this.textAlign, maxWidth: f1 });
    }
  }, v.prototype.strokeText = function($, a1, n1, f1) {
    if (isNaN(a1) || isNaN(n1) || typeof $ != "string")
      throw at.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!_.call(this)) {
      f1 = isNaN(f1) ? void 0 : f1;
      var w1 = c1(this.ctx.transform.rotation), C1 = this.ctx.transform.scaleX;
      O.call(this, { text: $, x: a1, y: n1, scale: C1, renderingMode: "stroke", angle: w1, align: this.textAlign, maxWidth: f1 });
    }
  }, v.prototype.measureText = function($) {
    if (typeof $ != "string")
      throw at.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var a1 = this.pdf, n1 = this.pdf.internal.scaleFactor, f1 = a1.internal.getFontSize(), w1 = a1.getStringUnitWidth($) * f1 / a1.internal.scaleFactor, C1 = function(E1) {
      var T1 = (E1 = E1 || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return T1;
      } }), this;
    };
    return new C1({ width: w1 *= Math.round(96 * n1 / 72 * 1e4) / 1e4 });
  }, v.prototype.scale = function($, a1) {
    if (isNaN($) || isNaN(a1))
      throw at.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var n1 = new h($, 0, 0, a1, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(n1);
  }, v.prototype.rotate = function($) {
    if (isNaN($))
      throw at.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var a1 = new h(Math.cos($), Math.sin($), -Math.sin($), Math.cos($), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(a1);
  }, v.prototype.translate = function($, a1) {
    if (isNaN($) || isNaN(a1))
      throw at.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var n1 = new h(1, 0, 0, 1, $, a1);
    this.ctx.transform = this.ctx.transform.multiply(n1);
  }, v.prototype.transform = function($, a1, n1, f1, w1, C1) {
    if (isNaN($) || isNaN(a1) || isNaN(n1) || isNaN(f1) || isNaN(w1) || isNaN(C1))
      throw at.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var E1 = new h($, a1, n1, f1, w1, C1);
    this.ctx.transform = this.ctx.transform.multiply(E1);
  }, v.prototype.setTransform = function($, a1, n1, f1, w1, C1) {
    $ = isNaN($) ? 1 : $, a1 = isNaN(a1) ? 0 : a1, n1 = isNaN(n1) ? 0 : n1, f1 = isNaN(f1) ? 1 : f1, w1 = isNaN(w1) ? 0 : w1, C1 = isNaN(C1) ? 0 : C1, this.ctx.transform = new h($, a1, n1, f1, w1, C1);
  };
  var q = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  v.prototype.drawImage = function($, a1, n1, f1, w1, C1, E1, T1, n2) {
    var X1 = this.pdf.getImageProperties($), a2 = 1, d2 = 1, y2 = 1, B1 = 1;
    f1 !== void 0 && T1 !== void 0 && (y2 = T1 / f1, B1 = n2 / w1, a2 = X1.width / f1 * T1 / f1, d2 = X1.height / w1 * n2 / w1), C1 === void 0 && (C1 = a1, E1 = n1, a1 = 0, n1 = 0), f1 !== void 0 && T1 === void 0 && (T1 = f1, n2 = w1), f1 === void 0 && T1 === void 0 && (T1 = X1.width, n2 = X1.height);
    for (var p1, _2 = this.ctx.transform.decompose(), w2 = c1(_2.rotate.shx), K1 = new h(), e2 = (K1 = (K1 = (K1 = K1.multiply(_2.translate)).multiply(_2.skew)).multiply(_2.scale)).applyToRectangle(new o(C1 - a1 * y2, E1 - n1 * B1, f1 * a2, w1 * d2)), Z1 = M.call(this, e2), t2 = [], S2 = 0; S2 < Z1.length; S2 += 1)
      t2.indexOf(Z1[S2]) === -1 && t2.push(Z1[S2]);
    if (x(t2), this.autoPaging)
      for (var W2 = t2[0], E2 = t2[t2.length - 1], o3 = W2; o3 < E2 + 1; o3++) {
        this.pdf.setPage(o3);
        var n3 = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], c3 = o3 === 1 ? this.posY + this.margin[0] : this.margin[0], G2 = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], u3 = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], g2 = o3 === 1 ? 0 : G2 + (o3 - 2) * u3;
        if (this.ctx.clip_path.length !== 0) {
          var Oe = this.path;
          p1 = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = b(p1, this.posX + this.margin[3], -g2 + c3 + this.ctx.prevPageLastElemOffset), F.call(this, "fill", !0), this.path = Oe;
        }
        var q3 = JSON.parse(JSON.stringify(e2));
        q3 = b([q3], this.posX + this.margin[3], -g2 + c3 + this.ctx.prevPageLastElemOffset)[0];
        var ht = (o3 > W2 || o3 < E2) && q.call(this);
        ht && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], n3, u3, null).clip().discardPath()), this.pdf.addImage($, "JPEG", q3.x, q3.y, q3.w, q3.h, null, null, w2), ht && this.pdf.restoreGraphicsState();
      }
    else
      this.pdf.addImage($, "JPEG", e2.x, e2.y, e2.w, e2.h, null, null, w2);
  };
  var M = function($, a1, n1) {
    var f1 = [];
    a1 = a1 || this.pdf.internal.pageSize.width, n1 = n1 || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var w1 = this.posY + this.ctx.prevPageLastElemOffset;
    switch ($.type) {
      default:
      case "mt":
      case "lt":
        f1.push(Math.floor(($.y + w1) / n1) + 1);
        break;
      case "arc":
        f1.push(Math.floor(($.y + w1 - $.radius) / n1) + 1), f1.push(Math.floor(($.y + w1 + $.radius) / n1) + 1);
        break;
      case "qct":
        var C1 = M1(this.ctx.lastPoint.x, this.ctx.lastPoint.y, $.x1, $.y1, $.x, $.y);
        f1.push(Math.floor((C1.y + w1) / n1) + 1), f1.push(Math.floor((C1.y + C1.h + w1) / n1) + 1);
        break;
      case "bct":
        var E1 = y1(this.ctx.lastPoint.x, this.ctx.lastPoint.y, $.x1, $.y1, $.x2, $.y2, $.x, $.y);
        f1.push(Math.floor((E1.y + w1) / n1) + 1), f1.push(Math.floor((E1.y + E1.h + w1) / n1) + 1);
        break;
      case "rect":
        f1.push(Math.floor(($.y + w1) / n1) + 1), f1.push(Math.floor(($.y + $.h + w1) / n1) + 1);
    }
    for (var T1 = 0; T1 < f1.length; T1 += 1)
      for (; this.pdf.internal.getNumberOfPages() < f1[T1]; )
        z.call(this);
    return f1;
  }, z = function() {
    var $ = this.fillStyle, a1 = this.strokeStyle, n1 = this.font, f1 = this.lineCap, w1 = this.lineWidth, C1 = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = $, this.strokeStyle = a1, this.font = n1, this.lineCap = f1, this.lineWidth = w1, this.lineJoin = C1;
  }, b = function($, a1, n1) {
    for (var f1 = 0; f1 < $.length; f1++)
      switch ($[f1].type) {
        case "bct":
          $[f1].x2 += a1, $[f1].y2 += n1;
        case "qct":
          $[f1].x1 += a1, $[f1].y1 += n1;
        case "mt":
        case "lt":
        case "arc":
        default:
          $[f1].x += a1, $[f1].y += n1;
      }
    return $;
  }, x = function($) {
    return $.sort(function(a1, n1) {
      return a1 - n1;
    });
  }, k = function($, a1) {
    for (var n1, f1, w1 = this.fillStyle, C1 = this.strokeStyle, E1 = this.lineCap, T1 = this.lineWidth, n2 = Math.abs(T1 * this.ctx.transform.scaleX), X1 = this.lineJoin, a2 = JSON.parse(JSON.stringify(this.path)), d2 = JSON.parse(JSON.stringify(this.path)), y2 = [], B1 = 0; B1 < d2.length; B1++)
      if (d2[B1].x !== void 0)
        for (var p1 = M.call(this, d2[B1]), _2 = 0; _2 < p1.length; _2 += 1)
          y2.indexOf(p1[_2]) === -1 && y2.push(p1[_2]);
    for (var w2 = 0; w2 < y2.length; w2++)
      for (; this.pdf.internal.getNumberOfPages() < y2[w2]; )
        z.call(this);
    if (x(y2), this.autoPaging)
      for (var K1 = y2[0], e2 = y2[y2.length - 1], Z1 = K1; Z1 < e2 + 1; Z1++) {
        this.pdf.setPage(Z1), this.fillStyle = w1, this.strokeStyle = C1, this.lineCap = E1, this.lineWidth = n2, this.lineJoin = X1;
        var t2 = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], S2 = Z1 === 1 ? this.posY + this.margin[0] : this.margin[0], W2 = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], E2 = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], o3 = Z1 === 1 ? 0 : W2 + (Z1 - 2) * E2;
        if (this.ctx.clip_path.length !== 0) {
          var n3 = this.path;
          n1 = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = b(n1, this.posX + this.margin[3], -o3 + S2 + this.ctx.prevPageLastElemOffset), F.call(this, $, !0), this.path = n3;
        }
        if (f1 = JSON.parse(JSON.stringify(a2)), this.path = b(f1, this.posX + this.margin[3], -o3 + S2 + this.ctx.prevPageLastElemOffset), a1 === !1 || Z1 === 0) {
          var c3 = (Z1 > K1 || Z1 < e2) && q.call(this);
          c3 && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], t2, E2, null).clip().discardPath()), F.call(this, $, a1), c3 && this.pdf.restoreGraphicsState();
        }
        this.lineWidth = T1;
      }
    else
      this.lineWidth = n2, F.call(this, $, a1), this.lineWidth = T1;
    this.path = a2;
  }, F = function($, a1) {
    if (($ !== "stroke" || a1 || !_.call(this)) && ($ === "stroke" || a1 || !p.call(this))) {
      for (var n1, f1, w1 = [], C1 = this.path, E1 = 0; E1 < C1.length; E1++) {
        var T1 = C1[E1];
        switch (T1.type) {
          case "begin":
            w1.push({ begin: !0 });
            break;
          case "close":
            w1.push({ close: !0 });
            break;
          case "mt":
            w1.push({ start: T1, deltas: [], abs: [] });
            break;
          case "lt":
            var n2 = w1.length;
            if (C1[E1 - 1] && !isNaN(C1[E1 - 1].x) && (n1 = [T1.x - C1[E1 - 1].x, T1.y - C1[E1 - 1].y], n2 > 0)) {
              for (; n2 >= 0; n2--)
                if (w1[n2 - 1].close !== !0 && w1[n2 - 1].begin !== !0) {
                  w1[n2 - 1].deltas.push(n1), w1[n2 - 1].abs.push(T1);
                  break;
                }
            }
            break;
          case "bct":
            n1 = [T1.x1 - C1[E1 - 1].x, T1.y1 - C1[E1 - 1].y, T1.x2 - C1[E1 - 1].x, T1.y2 - C1[E1 - 1].y, T1.x - C1[E1 - 1].x, T1.y - C1[E1 - 1].y], w1[w1.length - 1].deltas.push(n1);
            break;
          case "qct":
            var X1 = C1[E1 - 1].x + 2 / 3 * (T1.x1 - C1[E1 - 1].x), a2 = C1[E1 - 1].y + 2 / 3 * (T1.y1 - C1[E1 - 1].y), d2 = T1.x + 2 / 3 * (T1.x1 - T1.x), y2 = T1.y + 2 / 3 * (T1.y1 - T1.y), B1 = T1.x, p1 = T1.y;
            n1 = [X1 - C1[E1 - 1].x, a2 - C1[E1 - 1].y, d2 - C1[E1 - 1].x, y2 - C1[E1 - 1].y, B1 - C1[E1 - 1].x, p1 - C1[E1 - 1].y], w1[w1.length - 1].deltas.push(n1);
            break;
          case "arc":
            w1.push({ deltas: [], abs: [], arc: !0 }), Array.isArray(w1[w1.length - 1].abs) && w1[w1.length - 1].abs.push(T1);
        }
      }
      f1 = a1 ? null : $ === "stroke" ? "stroke" : "fill";
      for (var _2 = !1, w2 = 0; w2 < w1.length; w2++)
        if (w1[w2].arc)
          for (var K1 = w1[w2].abs, e2 = 0; e2 < K1.length; e2++) {
            var Z1 = K1[e2];
            Z1.type === "arc" ? V.call(this, Z1.x, Z1.y, Z1.radius, Z1.startAngle, Z1.endAngle, Z1.counterclockwise, void 0, a1, !_2) : G.call(this, Z1.x, Z1.y), _2 = !0;
          }
        else if (w1[w2].close === !0)
          this.pdf.internal.out("h"), _2 = !1;
        else if (w1[w2].begin !== !0) {
          var t2 = w1[w2].start.x, S2 = w1[w2].start.y;
          j.call(this, w1[w2].deltas, t2, S2), _2 = !0;
        }
      f1 && J.call(this, f1), a1 && K.call(this);
    }
  }, D = function($) {
    var a1 = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, n1 = a1 * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return $ - n1;
      case "top":
        return $ + a1 - n1;
      case "hanging":
        return $ + a1 - 2 * n1;
      case "middle":
        return $ + a1 / 2 - n1;
      case "ideographic":
        return $;
      case "alphabetic":
      default:
        return $;
    }
  }, R = function($) {
    return $ + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  v.prototype.createLinearGradient = function() {
    var $ = function() {
    };
    return $.colorStops = [], $.addColorStop = function(a1, n1) {
      this.colorStops.push([a1, n1]);
    }, $.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, $.isCanvasGradient = !0, $;
  }, v.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, v.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var V = function($, a1, n1, f1, w1, C1, E1, T1, n2) {
    for (var X1 = i1.call(this, n1, f1, w1, C1), a2 = 0; a2 < X1.length; a2++) {
      var d2 = X1[a2];
      a2 === 0 && (n2 ? P.call(this, d2.x1 + $, d2.y1 + a1) : G.call(this, d2.x1 + $, d2.y1 + a1)), Q.call(this, $, a1, d2.x2, d2.y2, d2.x3, d2.y3, d2.x4, d2.y4);
    }
    T1 ? K.call(this) : J.call(this, E1);
  }, J = function($) {
    switch ($) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, K = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, P = function($, a1) {
    this.pdf.internal.out(n($) + " " + i(a1) + " m");
  }, O = function($) {
    var a1;
    switch ($.align) {
      case "right":
      case "end":
        a1 = "right";
        break;
      case "center":
        a1 = "center";
        break;
      case "left":
      case "start":
      default:
        a1 = "left";
    }
    var n1 = this.pdf.getTextDimensions($.text), f1 = D.call(this, $.y), w1 = R.call(this, f1) - n1.h, C1 = this.ctx.transform.applyToPoint(new a($.x, f1)), E1 = this.ctx.transform.decompose(), T1 = new h();
    T1 = (T1 = (T1 = T1.multiply(E1.translate)).multiply(E1.skew)).multiply(E1.scale);
    for (var n2, X1, a2, d2 = this.ctx.transform.applyToRectangle(new o($.x, f1, n1.w, n1.h)), y2 = T1.applyToRectangle(new o($.x, w1, n1.w, n1.h)), B1 = M.call(this, y2), p1 = [], _2 = 0; _2 < B1.length; _2 += 1)
      p1.indexOf(B1[_2]) === -1 && p1.push(B1[_2]);
    if (x(p1), this.autoPaging)
      for (var w2 = p1[0], K1 = p1[p1.length - 1], e2 = w2; e2 < K1 + 1; e2++) {
        this.pdf.setPage(e2);
        var Z1 = e2 === 1 ? this.posY + this.margin[0] : this.margin[0], t2 = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], S2 = this.pdf.internal.pageSize.height - this.margin[2], W2 = S2 - this.margin[0], E2 = this.pdf.internal.pageSize.width - this.margin[1], o3 = E2 - this.margin[3], n3 = e2 === 1 ? 0 : t2 + (e2 - 2) * W2;
        if (this.ctx.clip_path.length !== 0) {
          var c3 = this.path;
          n2 = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = b(n2, this.posX + this.margin[3], -1 * n3 + Z1), F.call(this, "fill", !0), this.path = c3;
        }
        var G2 = b([JSON.parse(JSON.stringify(y2))], this.posX + this.margin[3], -n3 + Z1 + this.ctx.prevPageLastElemOffset)[0];
        $.scale >= 0.01 && (X1 = this.pdf.internal.getFontSize(), this.pdf.setFontSize(X1 * $.scale), a2 = this.lineWidth, this.lineWidth = a2 * $.scale);
        var u3 = this.autoPaging !== "text";
        if (u3 || G2.y + G2.h <= S2) {
          if (u3 || G2.y >= Z1 && G2.x <= E2) {
            var g2 = u3 ? $.text : this.pdf.splitTextToSize($.text, $.maxWidth || E2 - G2.x)[0], Oe = b([JSON.parse(JSON.stringify(d2))], this.posX + this.margin[3], -n3 + Z1 + this.ctx.prevPageLastElemOffset)[0], q3 = u3 && (e2 > w2 || e2 < K1) && q.call(this);
            q3 && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], o3, W2, null).clip().discardPath()), this.pdf.text(g2, Oe.x, Oe.y, { angle: $.angle, align: a1, renderingMode: $.renderingMode }), q3 && this.pdf.restoreGraphicsState();
          }
        } else
          G2.y < S2 && (this.ctx.prevPageLastElemOffset += S2 - G2.y);
        $.scale >= 0.01 && (this.pdf.setFontSize(X1), this.lineWidth = a2);
      }
    else
      $.scale >= 0.01 && (X1 = this.pdf.internal.getFontSize(), this.pdf.setFontSize(X1 * $.scale), a2 = this.lineWidth, this.lineWidth = a2 * $.scale), this.pdf.text($.text, C1.x + this.posX, C1.y + this.posY, { angle: $.angle, align: a1, renderingMode: $.renderingMode, maxWidth: $.maxWidth }), $.scale >= 0.01 && (this.pdf.setFontSize(X1), this.lineWidth = a2);
  }, G = function($, a1, n1, f1) {
    n1 = n1 || 0, f1 = f1 || 0, this.pdf.internal.out(n($ + n1) + " " + i(a1 + f1) + " l");
  }, j = function($, a1, n1) {
    return this.pdf.lines($, a1, n1, null, null);
  }, Q = function($, a1, n1, f1, w1, C1, E1, T1) {
    this.pdf.internal.out([e(s(n1 + $)), e(l(f1 + a1)), e(s(w1 + $)), e(l(C1 + a1)), e(s(E1 + $)), e(l(T1 + a1)), "c"].join(" "));
  }, i1 = function($, a1, n1, f1) {
    for (var w1 = 2 * Math.PI, C1 = Math.PI / 2; a1 > n1; )
      a1 -= w1;
    var E1 = Math.abs(n1 - a1);
    E1 < w1 && f1 && (E1 = w1 - E1);
    for (var T1 = [], n2 = f1 ? -1 : 1, X1 = a1; E1 > 1e-5; ) {
      var a2 = X1 + n2 * Math.min(E1, C1);
      T1.push(h1.call(this, $, X1, a2)), E1 -= Math.abs(a2 - X1), X1 = a2;
    }
    return T1;
  }, h1 = function($, a1, n1) {
    var f1 = (n1 - a1) / 2, w1 = $ * Math.cos(f1), C1 = $ * Math.sin(f1), E1 = w1, T1 = -C1, n2 = E1 * E1 + T1 * T1, X1 = n2 + E1 * w1 + T1 * C1, a2 = 4 / 3 * (Math.sqrt(2 * n2 * X1) - X1) / (E1 * C1 - T1 * w1), d2 = E1 - a2 * T1, y2 = T1 + a2 * E1, B1 = d2, p1 = -y2, _2 = f1 + a1, w2 = Math.cos(_2), K1 = Math.sin(_2);
    return { x1: $ * Math.cos(a1), y1: $ * Math.sin(a1), x2: d2 * w2 - y2 * K1, y2: d2 * K1 + y2 * w2, x3: B1 * w2 - p1 * K1, y3: B1 * K1 + p1 * w2, x4: $ * Math.cos(n1), y4: $ * Math.sin(n1) };
  }, c1 = function($) {
    return 180 * $ / Math.PI;
  }, M1 = function($, a1, n1, f1, w1, C1) {
    var E1 = $ + 0.5 * (n1 - $), T1 = a1 + 0.5 * (f1 - a1), n2 = w1 + 0.5 * (n1 - w1), X1 = C1 + 0.5 * (f1 - C1), a2 = Math.min($, w1, E1, n2), d2 = Math.max($, w1, E1, n2), y2 = Math.min(a1, C1, T1, X1), B1 = Math.max(a1, C1, T1, X1);
    return new o(a2, y2, d2 - a2, B1 - y2);
  }, y1 = function($, a1, n1, f1, w1, C1, E1, T1) {
    var n2, X1, a2, d2, y2, B1, p1, _2, w2, K1, e2, Z1, t2, S2, W2 = n1 - $, E2 = f1 - a1, o3 = w1 - n1, n3 = C1 - f1, c3 = E1 - w1, G2 = T1 - C1;
    for (X1 = 0; X1 < 41; X1++)
      w2 = (p1 = (a2 = $ + (n2 = X1 / 40) * W2) + n2 * ((y2 = n1 + n2 * o3) - a2)) + n2 * (y2 + n2 * (w1 + n2 * c3 - y2) - p1), K1 = (_2 = (d2 = a1 + n2 * E2) + n2 * ((B1 = f1 + n2 * n3) - d2)) + n2 * (B1 + n2 * (C1 + n2 * G2 - B1) - _2), X1 == 0 ? (e2 = w2, Z1 = K1, t2 = w2, S2 = K1) : (e2 = Math.min(e2, w2), Z1 = Math.min(Z1, K1), t2 = Math.max(t2, w2), S2 = Math.max(S2, K1));
    return new o(Math.round(e2), Math.round(Z1), Math.round(t2 - e2), Math.round(S2 - Z1));
  }, A1 = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var $, a1, n1 = ($ = this.ctx.lineDash, a1 = this.ctx.lineDashOffset, JSON.stringify({ lineDash: $, lineDashOffset: a1 }));
      this.prevLineDash !== n1 && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = n1);
    }
  };
})(m3.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var e = function(l) {
    var a, o, h, u, d, v, m, p, _, q;
    for (o = [], h = 0, u = (l += a = "\0\0\0\0".slice(l.length % 4 || 4)).length; u > h; h += 4)
      (d = (l.charCodeAt(h) << 24) + (l.charCodeAt(h + 1) << 16) + (l.charCodeAt(h + 2) << 8) + l.charCodeAt(h + 3)) !== 0 ? (v = (d = ((d = ((d = ((d = (d - (q = d % 85)) / 85) - (_ = d % 85)) / 85) - (p = d % 85)) / 85) - (m = d % 85)) / 85) % 85, o.push(v + 33, m + 33, p + 33, _ + 33, q + 33)) : o.push(122);
    return function(M, z) {
      for (var b = z; b > 0; b--)
        M.pop();
    }(o, a.length), String.fromCharCode.apply(String, o) + "~>";
  }, n = function(l) {
    var a, o, h, u, d, v = String, m = "length", p = 255, _ = "charCodeAt", q = "slice", M = "replace";
    for (l[q](-2), l = l[q](0, -2)[M](/\s/g, "")[M]("z", "!!!!!"), h = [], u = 0, d = (l += a = "uuuuu"[q](l[m] % 5 || 5))[m]; d > u; u += 5)
      o = 52200625 * (l[_](u) - 33) + 614125 * (l[_](u + 1) - 33) + 7225 * (l[_](u + 2) - 33) + 85 * (l[_](u + 3) - 33) + (l[_](u + 4) - 33), h.push(p & o >> 24, p & o >> 16, p & o >> 8, p & o);
    return function(z, b) {
      for (var x = b; x > 0; x--)
        z.pop();
    }(h, a[m]), v.fromCharCode.apply(v, h);
  }, i = function(l) {
    var a = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((l = l.replace(/\s/g, "")).indexOf(">") !== -1 && (l = l.substr(0, l.indexOf(">"))), l.length % 2 && (l += "0"), a.test(l) === !1)
      return "";
    for (var o = "", h = 0; h < l.length; h += 2)
      o += String.fromCharCode("0x" + (l[h] + l[h + 1]));
    return o;
  }, s = function(l) {
    for (var a = new Uint8Array(l.length), o = l.length; o--; )
      a[o] = l.charCodeAt(o);
    return l = (a = Xy(a)).reduce(function(h, u) {
      return h + String.fromCharCode(u);
    }, "");
  };
  t.processDataByFilters = function(l, a) {
    var o = 0, h = l || "", u = [];
    for (typeof (a = a || []) == "string" && (a = [a]), o = 0; o < a.length; o += 1)
      switch (a[o]) {
        case "ASCII85Decode":
        case "/ASCII85Decode":
          h = n(h), u.push("/ASCII85Encode");
          break;
        case "ASCII85Encode":
        case "/ASCII85Encode":
          h = e(h), u.push("/ASCII85Decode");
          break;
        case "ASCIIHexDecode":
        case "/ASCIIHexDecode":
          h = i(h), u.push("/ASCIIHexEncode");
          break;
        case "ASCIIHexEncode":
        case "/ASCIIHexEncode":
          h = h.split("").map(function(d) {
            return ("0" + d.charCodeAt().toString(16)).slice(-2);
          }).join("") + ">", u.push("/ASCIIHexDecode");
          break;
        case "FlateEncode":
        case "/FlateEncode":
          h = s(h), u.push("/FlateDecode");
          break;
        default:
          throw new Error('The filter: "' + a[o] + '" is not implemented');
      }
    return { data: h, reverseChain: u.reverse().join(" ") };
  };
}(m3.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  t.loadFile = function(e, n, i) {
    return function(s, l, a) {
      l = l !== !1, a = typeof a == "function" ? a : function() {
      };
      var o = void 0;
      try {
        o = function(h, u, d) {
          var v = new XMLHttpRequest(), m = 0, p = function(_) {
            var q = _.length, M = [], z = String.fromCharCode;
            for (m = 0; m < q; m += 1)
              M.push(z(255 & _.charCodeAt(m)));
            return M.join("");
          };
          if (v.open("GET", h, !u), v.overrideMimeType("text/plain; charset=x-user-defined"), u === !1 && (v.onload = function() {
            v.status === 200 ? d(p(this.responseText)) : d(void 0);
          }), v.send(null), u && v.status === 200)
            return p(v.responseText);
        }(s, l, a);
      } catch {
      }
      return o;
    }(e, n, i);
  }, t.loadImageFile = t.loadFile;
}(m3.API), function(t) {
  function e() {
    return (g3.html2canvas ? Promise.resolve(g3.html2canvas) : import("./html2canvas.esm-1a1724a1.js")).catch(function(a) {
      return Promise.reject(new Error("Could not load html2canvas: " + a));
    }).then(function(a) {
      return a.default ? a.default : a;
    });
  }
  function n() {
    return (g3.DOMPurify ? Promise.resolve(g3.DOMPurify) : import("./purify.es-8b0afffa.js")).catch(function(a) {
      return Promise.reject(new Error("Could not load dompurify: " + a));
    }).then(function(a) {
      return a.default ? a.default : a;
    });
  }
  var i = function(a) {
    var o = Ye(a);
    return o === "undefined" ? "undefined" : o === "string" || a instanceof String ? "string" : o === "number" || a instanceof Number ? "number" : o === "function" || a instanceof Function ? "function" : a && a.constructor === Array ? "array" : a && a.nodeType === 1 ? "element" : o === "object" ? "object" : "unknown";
  }, s = function(a, o) {
    var h = document.createElement(a);
    for (var u in o.className && (h.className = o.className), o.innerHTML && o.dompurify && (h.innerHTML = o.dompurify.sanitize(o.innerHTML)), o.style)
      h.style[u] = o.style[u];
    return h;
  }, l = function a(o) {
    var h = Object.assign(a.convert(Promise.resolve()), JSON.parse(JSON.stringify(a.template))), u = a.convert(Promise.resolve(), h);
    return u = (u = u.setProgress(1, a, 1, [a])).set(o);
  };
  (l.prototype = Object.create(Promise.prototype)).constructor = l, l.convert = function(a, o) {
    return a.__proto__ = o || l.prototype, a;
  }, l.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, l.prototype.from = function(a, o) {
    return this.then(function() {
      switch (o = o || function(h) {
        switch (i(h)) {
          case "string":
            return "string";
          case "element":
            return h.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      }(a)) {
        case "string":
          return this.then(n).then(function(h) {
            return this.set({ src: s("div", { innerHTML: a, dompurify: h }) });
          });
        case "element":
          return this.set({ src: a });
        case "canvas":
          return this.set({ canvas: a });
        case "img":
          return this.set({ img: a });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, l.prototype.to = function(a) {
    switch (a) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, l.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var a = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, o = function h(u, d) {
        for (var v = u.nodeType === 3 ? document.createTextNode(u.nodeValue) : u.cloneNode(!1), m = u.firstChild; m; m = m.nextSibling)
          d !== !0 && m.nodeType === 1 && m.nodeName === "SCRIPT" || v.appendChild(h(m, d));
        return u.nodeType === 1 && (u.nodeName === "CANVAS" ? (v.width = u.width, v.height = u.height, v.getContext("2d").drawImage(u, 0, 0)) : u.nodeName !== "TEXTAREA" && u.nodeName !== "SELECT" || (v.value = u.value), v.addEventListener("load", function() {
          v.scrollTop = u.scrollTop, v.scrollLeft = u.scrollLeft;
        }, !0)), v;
      }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      o.tagName === "BODY" && (a.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = s("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = s("div", { className: "html2pdf__container", style: a }), this.prop.container.appendChild(o), this.prop.container.firstChild.appendChild(s("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, l.prototype.toCanvas = function() {
    var a = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(a).then(e).then(function(o) {
      var h = Object.assign({}, this.opt.html2canvas);
      return delete h.onrendered, o(this.prop.container, h);
    }).then(function(o) {
      (this.opt.html2canvas.onrendered || function() {
      })(o), this.prop.canvas = o, document.body.removeChild(this.prop.overlay);
    });
  }, l.prototype.toContext2d = function() {
    var a = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(a).then(e).then(function(o) {
      var h = this.opt.jsPDF, u = this.opt.fontFaces, d = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, v = Object.assign({ async: !0, allowTaint: !0, scale: d, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete v.onrendered, h.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, h.context2d.posX = this.opt.x, h.context2d.posY = this.opt.y, h.context2d.margin = this.opt.margin, h.context2d.fontFaces = u, u)
        for (var m = 0; m < u.length; ++m) {
          var p = u[m], _ = p.src.find(function(q) {
            return q.format === "truetype";
          });
          _ && h.addFont(_.url, p.ref.name, p.ref.style);
        }
      return v.windowHeight = v.windowHeight || 0, v.windowHeight = v.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : v.windowHeight, h.context2d.save(!0), o(this.prop.container, v);
    }).then(function(o) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(o), this.prop.canvas = o, document.body.removeChild(this.prop.overlay);
    });
  }, l.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var a = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = a;
    });
  }, l.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, l.prototype.output = function(a, o, h) {
    return (h = h || "pdf").toLowerCase() === "img" || h.toLowerCase() === "image" ? this.outputImg(a, o) : this.outputPdf(a, o);
  }, l.prototype.outputPdf = function(a, o) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(a, o);
    });
  }, l.prototype.outputImg = function(a) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (a) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + a + '" is not supported.';
      }
    });
  }, l.prototype.save = function(a) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(a ? { filename: a } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, l.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, l.prototype.set = function(a) {
    if (i(a) !== "object")
      return this;
    var o = Object.keys(a || {}).map(function(h) {
      if (h in l.template.prop)
        return function() {
          this.prop[h] = a[h];
        };
      switch (h) {
        case "margin":
          return this.setMargin.bind(this, a.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = a.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, a.pageSize);
        default:
          return function() {
            this.opt[h] = a[h];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(o);
    });
  }, l.prototype.get = function(a, o) {
    return this.then(function() {
      var h = a in l.template.prop ? this.prop[a] : this.opt[a];
      return o ? o(h) : h;
    });
  }, l.prototype.setMargin = function(a) {
    return this.then(function() {
      switch (i(a)) {
        case "number":
          a = [a, a, a, a];
        case "array":
          if (a.length === 2 && (a = [a[0], a[1], a[0], a[1]]), a.length === 4)
            break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = a;
    }).then(this.setPageSize);
  }, l.prototype.setPageSize = function(a) {
    function o(h, u) {
      return Math.floor(h * u / 72 * 96);
    }
    return this.then(function() {
      (a = a || m3.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (a.inner = { width: a.width - this.opt.margin[1] - this.opt.margin[3], height: a.height - this.opt.margin[0] - this.opt.margin[2] }, a.inner.px = { width: o(a.inner.width, a.k), height: o(a.inner.height, a.k) }, a.inner.ratio = a.inner.height / a.inner.width), this.prop.pageSize = a;
    });
  }, l.prototype.setProgress = function(a, o, h, u) {
    return a != null && (this.progress.val = a), o != null && (this.progress.state = o), h != null && (this.progress.n = h), u != null && (this.progress.stack = u), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, l.prototype.updateProgress = function(a, o, h, u) {
    return this.setProgress(a ? this.progress.val + a : null, o || null, h ? this.progress.n + h : null, u ? this.progress.stack.concat(u) : null);
  }, l.prototype.then = function(a, o) {
    var h = this;
    return this.thenCore(a, o, function(u, d) {
      return h.updateProgress(null, null, 1, [u]), Promise.prototype.then.call(this, function(v) {
        return h.updateProgress(null, u), v;
      }).then(u, d).then(function(v) {
        return h.updateProgress(1), v;
      });
    });
  }, l.prototype.thenCore = function(a, o, h) {
    h = h || Promise.prototype.then, a && (a = a.bind(this)), o && (o = o.bind(this));
    var u = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? this : l.convert(Object.assign({}, this), Promise.prototype), d = h.call(u, a, o);
    return l.convert(d, this.__proto__);
  }, l.prototype.thenExternal = function(a, o) {
    return Promise.prototype.then.call(this, a, o);
  }, l.prototype.thenList = function(a) {
    var o = this;
    return a.forEach(function(h) {
      o = o.thenCore(h);
    }), o;
  }, l.prototype.catch = function(a) {
    a && (a = a.bind(this));
    var o = Promise.prototype.catch.call(this, a);
    return l.convert(o, this);
  }, l.prototype.catchExternal = function(a) {
    return Promise.prototype.catch.call(this, a);
  }, l.prototype.error = function(a) {
    return this.then(function() {
      throw new Error(a);
    });
  }, l.prototype.using = l.prototype.set, l.prototype.saveAs = l.prototype.save, l.prototype.export = l.prototype.output, l.prototype.run = l.prototype.then, m3.getPageSize = function(a, o, h) {
    if (Ye(a) === "object") {
      var u = a;
      a = u.orientation, o = u.unit || o, h = u.format || h;
    }
    o = o || "mm", h = h || "a4", a = ("" + (a || "P")).toLowerCase();
    var d, v = ("" + h).toLowerCase(), m = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (o) {
      case "pt":
        d = 1;
        break;
      case "mm":
        d = 72 / 25.4;
        break;
      case "cm":
        d = 72 / 2.54;
        break;
      case "in":
        d = 72;
        break;
      case "px":
        d = 0.75;
        break;
      case "pc":
      case "em":
        d = 12;
        break;
      case "ex":
        d = 6;
        break;
      default:
        throw "Invalid unit: " + o;
    }
    var p, _ = 0, q = 0;
    if (m.hasOwnProperty(v))
      _ = m[v][1] / d, q = m[v][0] / d;
    else
      try {
        _ = h[1], q = h[0];
      } catch {
        throw new Error("Invalid format: " + h);
      }
    if (a === "p" || a === "portrait")
      a = "p", q > _ && (p = q, q = _, _ = p);
    else {
      if (a !== "l" && a !== "landscape")
        throw "Invalid orientation: " + a;
      a = "l", _ > q && (p = q, q = _, _ = p);
    }
    return { width: q, height: _, unit: o, k: d, orientation: a };
  }, t.html = function(a, o) {
    (o = o || {}).callback = o.callback || function() {
    }, o.html2canvas = o.html2canvas || {}, o.html2canvas.canvas = o.html2canvas.canvas || this.canvas, o.jsPDF = o.jsPDF || this, o.fontFaces = o.fontFaces ? o.fontFaces.map(t_) : null;
    var h = new l(o);
    return o.worker ? h : h.from(a).doCallback();
  };
}(m3.API), m3.API.addJS = function(t) {
  return YM = t, this.internal.events.subscribe("postPutResources", function() {
    ch = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (ch + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), WM = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + YM + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    ch !== void 0 && WM !== void 0 && this.internal.out("/Names <</JavaScript " + ch + " 0 R>>");
  }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var e;
  t.events.push(["postPutResources", function() {
    var n = this, i = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0)
      for (var s = n.outline.render().split(/\r\n/), l = 0; l < s.length; l++) {
        var a = s[l], o = i.exec(a);
        if (o != null) {
          var h = o[1];
          n.internal.newObjectDeferredBegin(h, !1);
        }
        n.internal.write(a);
      }
    if (this.outline.createNamedDestinations) {
      var u = this.internal.pages.length, d = [];
      for (l = 0; l < u; l++) {
        var v = n.internal.newObject();
        d.push(v);
        var m = n.internal.getPageInfo(l + 1);
        n.internal.write("<< /D[" + m.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var p = n.internal.newObject();
      for (n.internal.write("<< /Names [ "), l = 0; l < d.length; l++)
        n.internal.write("(page_" + (l + 1) + ")" + d[l] + " 0 R");
      n.internal.write(" ] >>", "endobj"), e = n.internal.newObject(), n.internal.write("<< /Dests " + p + " 0 R"), n.internal.write(">>", "endobj");
    }
  }]), t.events.push(["putCatalog", function() {
    this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
  }]), t.events.push(["initialized", function() {
    var n = this;
    n.outline = { createNamedDestinations: !1, root: { children: [] } }, n.outline.add = function(i, s, l) {
      var a = { title: s, options: l, children: [] };
      return i == null && (i = this.root), i.children.push(a), a;
    }, n.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = n, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, n.outline.genIds_r = function(i) {
      i.id = n.internal.newObjectDeferred();
      for (var s = 0; s < i.children.length; s++)
        this.genIds_r(i.children[s]);
    }, n.outline.renderRoot = function(i) {
      this.objStart(i), this.line("/Type /Outlines"), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, i)), this.objEnd();
    }, n.outline.renderItems = function(i) {
      for (var s = this.ctx.pdf.internal.getVerticalCoordinateString, l = 0; l < i.children.length; l++) {
        var a = i.children[l];
        this.objStart(a), this.line("/Title " + this.makeString(a.title)), this.line("/Parent " + this.makeRef(i)), l > 0 && this.line("/Prev " + this.makeRef(i.children[l - 1])), l < i.children.length - 1 && this.line("/Next " + this.makeRef(i.children[l + 1])), a.children.length > 0 && (this.line("/First " + this.makeRef(a.children[0])), this.line("/Last " + this.makeRef(a.children[a.children.length - 1])));
        var o = this.count = this.count_r({ count: 0 }, a);
        if (o > 0 && this.line("/Count " + o), a.options && a.options.pageNumber) {
          var h = n.internal.getPageInfo(a.options.pageNumber);
          this.line("/Dest [" + h.objId + " 0 R /XYZ 0 " + s(0) + " 0]");
        }
        this.objEnd();
      }
      for (var u = 0; u < i.children.length; u++)
        this.renderItems(i.children[u]);
    }, n.outline.line = function(i) {
      this.ctx.val += i + `\r
`;
    }, n.outline.makeRef = function(i) {
      return i.id + " 0 R";
    }, n.outline.makeString = function(i) {
      return "(" + n.internal.pdfEscape(i) + ")";
    }, n.outline.objStart = function(i) {
      this.ctx.val += `\r
` + i.id + ` 0 obj\r
<<\r
`;
    }, n.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, n.outline.count_r = function(i, s) {
      for (var l = 0; l < s.children.length; l++)
        i.count++, this.count_r(i, s.children[l]);
      return i.count;
    };
  }]);
}(m3.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var e = [192, 193, 194, 195, 196, 197, 198, 199];
  t.processJPEG = function(n, i, s, l, a, o) {
    var h, u = this.decode.DCT_DECODE, d = null;
    if (typeof n == "string" || this.__addimage__.isArrayBuffer(n) || this.__addimage__.isArrayBufferView(n)) {
      switch (n = a || n, n = this.__addimage__.isArrayBuffer(n) ? new Uint8Array(n) : n, (h = function(v) {
        for (var m, p = 256 * v.charCodeAt(4) + v.charCodeAt(5), _ = v.length, q = { width: 0, height: 0, numcomponents: 1 }, M = 4; M < _; M += 2) {
          if (M += p, e.indexOf(v.charCodeAt(M + 1)) !== -1) {
            m = 256 * v.charCodeAt(M + 5) + v.charCodeAt(M + 6), q = { width: 256 * v.charCodeAt(M + 7) + v.charCodeAt(M + 8), height: m, numcomponents: v.charCodeAt(M + 9) };
            break;
          }
          p = 256 * v.charCodeAt(M + 2) + v.charCodeAt(M + 3);
        }
        return q;
      }(n = this.__addimage__.isArrayBufferView(n) ? this.__addimage__.arrayBufferToBinaryString(n) : n)).numcomponents) {
        case 1:
          o = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          o = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          o = this.color_spaces.DEVICE_RGB;
      }
      d = { data: n, width: h.width, height: h.height, colorSpace: o, bitsPerComponent: 8, filter: u, index: i, alias: s };
    }
    return d;
  };
}(m3.API);
var ea, hh, XM, KM, ZM, GC1 = function() {
  var t, e, n;
  function i(l) {
    var a, o, h, u, d, v, m, p, _, q, M, z, b, x;
    for (this.data = l, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, v = null; ; ) {
      switch (a = this.readUInt32(), _ = (function() {
        var k, F;
        for (F = [], k = 0; k < 4; ++k)
          F.push(String.fromCharCode(this.data[this.pos++]));
        return F;
      }).call(this).join("")) {
        case "IHDR":
          this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
          break;
        case "acTL":
          this.animation = { numFrames: this.readUInt32(), numPlays: this.readUInt32() || 1 / 0, frames: [] };
          break;
        case "PLTE":
          this.palette = this.read(a);
          break;
        case "fcTL":
          v && this.animation.frames.push(v), this.pos += 4, v = { width: this.readUInt32(), height: this.readUInt32(), xOffset: this.readUInt32(), yOffset: this.readUInt32() }, d = this.readUInt16(), u = this.readUInt16() || 100, v.delay = 1e3 * d / u, v.disposeOp = this.data[this.pos++], v.blendOp = this.data[this.pos++], v.data = [];
          break;
        case "IDAT":
        case "fdAT":
          for (_ === "fdAT" && (this.pos += 4, a -= 4), l = (v != null ? v.data : void 0) || this.imgData, z = 0; 0 <= a ? z < a : z > a; 0 <= a ? ++z : --z)
            l.push(this.data[this.pos++]);
          break;
        case "tRNS":
          switch (this.transparency = {}, this.colorType) {
            case 3:
              if (h = this.palette.length / 3, this.transparency.indexed = this.read(a), this.transparency.indexed.length > h)
                throw new Error("More transparent colors than palette size");
              if ((q = h - this.transparency.indexed.length) > 0)
                for (b = 0; 0 <= q ? b < q : b > q; 0 <= q ? ++b : --b)
                  this.transparency.indexed.push(255);
              break;
            case 0:
              this.transparency.grayscale = this.read(a)[0];
              break;
            case 2:
              this.transparency.rgb = this.read(a);
          }
          break;
        case "tEXt":
          m = (M = this.read(a)).indexOf(0), p = String.fromCharCode.apply(String, M.slice(0, m)), this.text[p] = String.fromCharCode.apply(String, M.slice(m + 1));
          break;
        case "IEND":
          return v && this.animation.frames.push(v), this.colors = (function() {
            switch (this.colorType) {
              case 0:
              case 3:
              case 4:
                return 1;
              case 2:
              case 6:
                return 3;
            }
          }).call(this), this.hasAlphaChannel = (x = this.colorType) === 4 || x === 6, o = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * o, this.colorSpace = (function() {
            switch (this.colors) {
              case 1:
                return "DeviceGray";
              case 3:
                return "DeviceRGB";
            }
          }).call(this), void (this.imgData = new Uint8Array(this.imgData));
        default:
          this.pos += a;
      }
      if (this.pos += 4, this.pos > this.data.length)
        throw new Error("Incomplete or corrupt PNG file");
    }
  }
  i.prototype.read = function(l) {
    var a, o;
    for (o = [], a = 0; 0 <= l ? a < l : a > l; 0 <= l ? ++a : --a)
      o.push(this.data[this.pos++]);
    return o;
  }, i.prototype.readUInt32 = function() {
    return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
  }, i.prototype.readUInt16 = function() {
    return this.data[this.pos++] << 8 | this.data[this.pos++];
  }, i.prototype.decodePixels = function(l) {
    var a = this.pixelBitlength / 8, o = new Uint8Array(this.width * this.height * a), h = 0, u = this;
    if (l == null && (l = this.imgData), l.length === 0)
      return new Uint8Array(0);
    function d(v, m, p, _) {
      var q, M, z, b, x, k, F, D, R, V, J, K, P, O, G, j, Q, i1, h1, c1, M1, y1 = Math.ceil((u.width - v) / p), A1 = Math.ceil((u.height - m) / _), $ = u.width == y1 && u.height == A1;
      for (O = a * y1, K = $ ? o : new Uint8Array(O * A1), k = l.length, P = 0, M = 0; P < A1 && h < k; ) {
        switch (l[h++]) {
          case 0:
            for (b = Q = 0; Q < O; b = Q += 1)
              K[M++] = l[h++];
            break;
          case 1:
            for (b = i1 = 0; i1 < O; b = i1 += 1)
              q = l[h++], x = b < a ? 0 : K[M - a], K[M++] = (q + x) % 256;
            break;
          case 2:
            for (b = h1 = 0; h1 < O; b = h1 += 1)
              q = l[h++], z = (b - b % a) / a, G = P && K[(P - 1) * O + z * a + b % a], K[M++] = (G + q) % 256;
            break;
          case 3:
            for (b = c1 = 0; c1 < O; b = c1 += 1)
              q = l[h++], z = (b - b % a) / a, x = b < a ? 0 : K[M - a], G = P && K[(P - 1) * O + z * a + b % a], K[M++] = (q + Math.floor((x + G) / 2)) % 256;
            break;
          case 4:
            for (b = M1 = 0; M1 < O; b = M1 += 1)
              q = l[h++], z = (b - b % a) / a, x = b < a ? 0 : K[M - a], P === 0 ? G = j = 0 : (G = K[(P - 1) * O + z * a + b % a], j = z && K[(P - 1) * O + (z - 1) * a + b % a]), F = x + G - j, D = Math.abs(F - x), V = Math.abs(F - G), J = Math.abs(F - j), R = D <= V && D <= J ? x : V <= J ? G : j, K[M++] = (q + R) % 256;
            break;
          default:
            throw new Error("Invalid filter algorithm: " + l[h - 1]);
        }
        if (!$) {
          var a1 = ((m + P * _) * u.width + v) * a, n1 = P * O;
          for (b = 0; b < y1; b += 1) {
            for (var f1 = 0; f1 < a; f1 += 1)
              o[a1++] = K[n1++];
            a1 += (p - 1) * a;
          }
        }
        P++;
      }
    }
    return l = xC1(l), u.interlaceMethod == 1 ? (d(0, 0, 8, 8), d(4, 0, 8, 8), d(0, 4, 4, 8), d(2, 0, 4, 4), d(0, 2, 2, 4), d(1, 0, 2, 2), d(0, 1, 1, 2)) : d(0, 0, 1, 1), o;
  }, i.prototype.decodePalette = function() {
    var l, a, o, h, u, d, v, m, p;
    for (o = this.palette, d = this.transparency.indexed || [], u = new Uint8Array((d.length || 0) + o.length), h = 0, l = 0, a = v = 0, m = o.length; v < m; a = v += 3)
      u[h++] = o[a], u[h++] = o[a + 1], u[h++] = o[a + 2], u[h++] = (p = d[l++]) != null ? p : 255;
    return u;
  }, i.prototype.copyToImageData = function(l, a) {
    var o, h, u, d, v, m, p, _, q, M, z;
    if (h = this.colors, q = null, o = this.hasAlphaChannel, this.palette.length && (q = (z = this._decodedPalette) != null ? z : this._decodedPalette = this.decodePalette(), h = 4, o = !0), _ = (u = l.data || l).length, v = q || a, d = m = 0, h === 1)
      for (; d < _; )
        p = q ? 4 * a[d / 4] : m, M = v[p++], u[d++] = M, u[d++] = M, u[d++] = M, u[d++] = o ? v[p++] : 255, m = p;
    else
      for (; d < _; )
        p = q ? 4 * a[d / 4] : m, u[d++] = v[p++], u[d++] = v[p++], u[d++] = v[p++], u[d++] = o ? v[p++] : 255, m = p;
  }, i.prototype.decode = function() {
    var l;
    return l = new Uint8Array(this.width * this.height * 4), this.copyToImageData(l, this.decodePixels()), l;
  };
  var s = function() {
    if (Object.prototype.toString.call(g3) === "[object Window]") {
      try {
        e = g3.document.createElement("canvas"), n = e.getContext("2d");
      } catch {
        return !1;
      }
      return !0;
    }
    return !1;
  };
  return s(), t = function(l) {
    var a;
    if (s() === !0)
      return n.width = l.width, n.height = l.height, n.clearRect(0, 0, l.width, l.height), n.putImageData(l, 0, 0), (a = new Image()).src = e.toDataURL(), a;
    throw new Error("This method requires a Browser with Canvas-capability.");
  }, i.prototype.decodeFrames = function(l) {
    var a, o, h, u, d, v, m, p;
    if (this.animation) {
      for (p = [], o = d = 0, v = (m = this.animation.frames).length; d < v; o = ++d)
        a = m[o], h = l.createImageData(a.width, a.height), u = this.decodePixels(new Uint8Array(a.data)), this.copyToImageData(h, u), a.imageData = h, p.push(a.image = t(h));
      return p;
    }
  }, i.prototype.renderFrame = function(l, a) {
    var o, h, u;
    return o = (h = this.animation.frames)[a], u = h[a - 1], a === 0 && l.clearRect(0, 0, this.width, this.height), (u != null ? u.disposeOp : void 0) === 1 ? l.clearRect(u.xOffset, u.yOffset, u.width, u.height) : (u != null ? u.disposeOp : void 0) === 2 && l.putImageData(u.imageData, u.xOffset, u.yOffset), o.blendOp === 0 && l.clearRect(o.xOffset, o.yOffset, o.width, o.height), l.drawImage(o.image, o.xOffset, o.yOffset);
  }, i.prototype.animate = function(l) {
    var a, o, h, u, d, v, m = this;
    return o = 0, v = this.animation, u = v.numFrames, h = v.frames, d = v.numPlays, (a = function() {
      var p, _;
      if (p = o++ % u, _ = h[p], m.renderFrame(l, p), u > 1 && o / u < d)
        return m.animation._timeout = setTimeout(a, _.delay);
    })();
  }, i.prototype.stopAnimation = function() {
    var l;
    return clearTimeout((l = this.animation) != null ? l._timeout : void 0);
  }, i.prototype.render = function(l) {
    var a, o;
    return l._png && l._png.stopAnimation(), l._png = this, l.width = this.width, l.height = this.height, a = l.getContext("2d"), this.animation ? (this.decodeFrames(a), this.animate(a)) : (o = a.createImageData(this.width, this.height), this.copyToImageData(o, this.decodePixels()), a.putImageData(o, 0, 0));
  }, i;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function WC1(t) {
  var e = 0;
  if (t[e++] !== 71 || t[e++] !== 73 || t[e++] !== 70 || t[e++] !== 56 || (t[e++] + 1 & 253) != 56 || t[e++] !== 97)
    throw new Error("Invalid GIF 87a/89a header.");
  var n = t[e++] | t[e++] << 8, i = t[e++] | t[e++] << 8, s = t[e++], l = s >> 7, a = 1 << (7 & s) + 1;
  t[e++], t[e++];
  var o = null, h = null;
  l && (o = e, h = a, e += 3 * a);
  var u = !0, d = [], v = 0, m = null, p = 0, _ = null;
  for (this.width = n, this.height = i; u && e < t.length; )
    switch (t[e++]) {
      case 33:
        switch (t[e++]) {
          case 255:
            if (t[e] !== 11 || t[e + 1] == 78 && t[e + 2] == 69 && t[e + 3] == 84 && t[e + 4] == 83 && t[e + 5] == 67 && t[e + 6] == 65 && t[e + 7] == 80 && t[e + 8] == 69 && t[e + 9] == 50 && t[e + 10] == 46 && t[e + 11] == 48 && t[e + 12] == 3 && t[e + 13] == 1 && t[e + 16] == 0)
              e += 14, _ = t[e++] | t[e++] << 8, e++;
            else
              for (e += 12; ; ) {
                if (!((P = t[e++]) >= 0))
                  throw Error("Invalid block size");
                if (P === 0)
                  break;
                e += P;
              }
            break;
          case 249:
            if (t[e++] !== 4 || t[e + 4] !== 0)
              throw new Error("Invalid graphics extension block.");
            var q = t[e++];
            v = t[e++] | t[e++] << 8, m = t[e++], !(1 & q) && (m = null), p = q >> 2 & 7, e++;
            break;
          case 254:
            for (; ; ) {
              if (!((P = t[e++]) >= 0))
                throw Error("Invalid block size");
              if (P === 0)
                break;
              e += P;
            }
            break;
          default:
            throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
        }
        break;
      case 44:
        var M = t[e++] | t[e++] << 8, z = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, x = t[e++] | t[e++] << 8, k = t[e++], F = k >> 6 & 1, D = 1 << (7 & k) + 1, R = o, V = h, J = !1;
        k >> 7 && (J = !0, R = e, V = D, e += 3 * D);
        var K = e;
        for (e++; ; ) {
          var P;
          if (!((P = t[e++]) >= 0))
            throw Error("Invalid block size");
          if (P === 0)
            break;
          e += P;
        }
        d.push({ x: M, y: z, width: b, height: x, has_local_palette: J, palette_offset: R, palette_size: V, data_offset: K, data_length: e - K, transparent_index: m, interlaced: !!F, delay: v, disposal: p });
        break;
      case 59:
        u = !1;
        break;
      default:
        throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
  this.numFrames = function() {
    return d.length;
  }, this.loopCount = function() {
    return _;
  }, this.frameInfo = function(O) {
    if (O < 0 || O >= d.length)
      throw new Error("Frame index out of range.");
    return d[O];
  }, this.decodeAndBlitFrameBGRA = function(O, G) {
    var j = this.frameInfo(O), Q = j.width * j.height, i1 = new Uint8Array(Q);
    JM(t, j.data_offset, i1, Q);
    var h1 = j.palette_offset, c1 = j.transparent_index;
    c1 === null && (c1 = 256);
    var M1 = j.width, y1 = n - M1, A1 = M1, $ = 4 * (j.y * n + j.x), a1 = 4 * ((j.y + j.height) * n + j.x), n1 = $, f1 = 4 * y1;
    j.interlaced === !0 && (f1 += 4 * n * 7);
    for (var w1 = 8, C1 = 0, E1 = i1.length; C1 < E1; ++C1) {
      var T1 = i1[C1];
      if (A1 === 0 && (A1 = M1, (n1 += f1) >= a1 && (f1 = 4 * y1 + 4 * n * (w1 - 1), n1 = $ + (M1 + y1) * (w1 << 1), w1 >>= 1)), T1 === c1)
        n1 += 4;
      else {
        var n2 = t[h1 + 3 * T1], X1 = t[h1 + 3 * T1 + 1], a2 = t[h1 + 3 * T1 + 2];
        G[n1++] = a2, G[n1++] = X1, G[n1++] = n2, G[n1++] = 255;
      }
      --A1;
    }
  }, this.decodeAndBlitFrameRGBA = function(O, G) {
    var j = this.frameInfo(O), Q = j.width * j.height, i1 = new Uint8Array(Q);
    JM(t, j.data_offset, i1, Q);
    var h1 = j.palette_offset, c1 = j.transparent_index;
    c1 === null && (c1 = 256);
    var M1 = j.width, y1 = n - M1, A1 = M1, $ = 4 * (j.y * n + j.x), a1 = 4 * ((j.y + j.height) * n + j.x), n1 = $, f1 = 4 * y1;
    j.interlaced === !0 && (f1 += 4 * n * 7);
    for (var w1 = 8, C1 = 0, E1 = i1.length; C1 < E1; ++C1) {
      var T1 = i1[C1];
      if (A1 === 0 && (A1 = M1, (n1 += f1) >= a1 && (f1 = 4 * y1 + 4 * n * (w1 - 1), n1 = $ + (M1 + y1) * (w1 << 1), w1 >>= 1)), T1 === c1)
        n1 += 4;
      else {
        var n2 = t[h1 + 3 * T1], X1 = t[h1 + 3 * T1 + 1], a2 = t[h1 + 3 * T1 + 2];
        G[n1++] = n2, G[n1++] = X1, G[n1++] = a2, G[n1++] = 255;
      }
      --A1;
    }
  };
}
function JM(t, e, n, i) {
  for (var s = t[e++], l = 1 << s, a = l + 1, o = a + 1, h = s + 1, u = (1 << h) - 1, d = 0, v = 0, m = 0, p = t[e++], _ = new Int32Array(4096), q = null; ; ) {
    for (; d < 16 && p !== 0; )
      v |= t[e++] << d, d += 8, p === 1 ? p = t[e++] : --p;
    if (d < h)
      break;
    var M = v & u;
    if (v >>= h, d -= h, M !== l) {
      if (M === a)
        break;
      for (var z = M < o ? M : q, b = 0, x = z; x > l; )
        x = _[x] >> 8, ++b;
      var k = x;
      if (m + b + (z !== M ? 1 : 0) > i)
        return void at.log("Warning, gif stream longer than expected.");
      n[m++] = k;
      var F = m += b;
      for (z !== M && (n[m++] = k), x = z; b--; )
        x = _[x], n[--F] = 255 & x, x >>= 8;
      q !== null && o < 4096 && (_[o++] = q << 8 | k, o >= u + 1 && h < 12 && (++h, u = u << 1 | 1)), q = M;
    } else
      o = a + 1, u = (1 << (h = s + 1)) - 1, q = null;
  }
  return m !== i && at.log("Warning, gif stream shorter than expected."), n;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function ty(t) {
  var e, n, i, s, l, a = Math.floor, o = new Array(64), h = new Array(64), u = new Array(64), d = new Array(64), v = new Array(65535), m = new Array(65535), p = new Array(64), _ = new Array(64), q = [], M = 0, z = 7, b = new Array(64), x = new Array(64), k = new Array(64), F = new Array(256), D = new Array(2048), R = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], V = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], J = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], K = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], P = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], O = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], G = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], j = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], Q = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function i1($, a1) {
    for (var n1 = 0, f1 = 0, w1 = new Array(), C1 = 1; C1 <= 16; C1++) {
      for (var E1 = 1; E1 <= $[C1]; E1++)
        w1[a1[f1]] = [], w1[a1[f1]][0] = n1, w1[a1[f1]][1] = C1, f1++, n1++;
      n1 *= 2;
    }
    return w1;
  }
  function h1($) {
    for (var a1 = $[0], n1 = $[1] - 1; n1 >= 0; )
      a1 & 1 << n1 && (M |= 1 << z), n1--, --z < 0 && (M == 255 ? (c1(255), c1(0)) : c1(M), z = 7, M = 0);
  }
  function c1($) {
    q.push($);
  }
  function M1($) {
    c1($ >> 8 & 255), c1(255 & $);
  }
  function y1($, a1, n1, f1, w1) {
    for (var C1, E1 = w1[0], T1 = w1[240], n2 = function(K1, e2) {
      var Z1, t2, S2, W2, E2, o3, n3, c3, G2, u3, g2 = 0;
      for (G2 = 0; G2 < 8; ++G2) {
        Z1 = K1[g2], t2 = K1[g2 + 1], S2 = K1[g2 + 2], W2 = K1[g2 + 3], E2 = K1[g2 + 4], o3 = K1[g2 + 5], n3 = K1[g2 + 6];
        var Oe = Z1 + (c3 = K1[g2 + 7]), q3 = Z1 - c3, ht = t2 + n3, E3 = t2 - n3, j3 = S2 + o3, z2 = S2 - o3, R2 = W2 + E2, w3 = W2 - E2, B3 = Oe + R2, G3 = Oe - R2, Se = ht + j3, _e = ht - j3;
        K1[g2] = B3 + Se, K1[g2 + 4] = B3 - Se;
        var d3 = 0.707106781 * (_e + G3);
        K1[g2 + 2] = G3 + d3, K1[g2 + 6] = G3 - d3;
        var Z3 = 0.382683433 * ((B3 = w3 + z2) - (_e = E3 + q3)), yt = 0.5411961 * B3 + Z3, Ce = 1.306562965 * _e + Z3, tt = 0.707106781 * (Se = z2 + E3), ut = q3 + tt, D2 = q3 - tt;
        K1[g2 + 5] = D2 + yt, K1[g2 + 3] = D2 - yt, K1[g2 + 1] = ut + Ce, K1[g2 + 7] = ut - Ce, g2 += 8;
      }
      for (g2 = 0, G2 = 0; G2 < 8; ++G2) {
        Z1 = K1[g2], t2 = K1[g2 + 8], S2 = K1[g2 + 16], W2 = K1[g2 + 24], E2 = K1[g2 + 32], o3 = K1[g2 + 40], n3 = K1[g2 + 48];
        var Re = Z1 + (c3 = K1[g2 + 56]), _t = Z1 - c3, L3 = t2 + n3, W3 = t2 - n3, oe = S2 + o3, v4 = S2 - o3, wn = W2 + E2, m0 = W2 - E2, _5 = Re + wn, q5 = Re - wn, w5 = L3 + oe, X4 = L3 - oe;
        K1[g2] = _5 + w5, K1[g2 + 32] = _5 - w5;
        var K4 = 0.707106781 * (X4 + q5);
        K1[g2 + 16] = q5 + K4, K1[g2 + 48] = q5 - K4;
        var H5 = 0.382683433 * ((_5 = m0 + v4) - (X4 = W3 + _t)), F6 = 0.5411961 * _5 + H5, zn = 1.306562965 * X4 + H5, Mn = 0.707106781 * (w5 = v4 + W3), bn = _t + Mn, Z4 = _t - Mn;
        K1[g2 + 40] = Z4 + F6, K1[g2 + 24] = Z4 - F6, K1[g2 + 8] = bn + zn, K1[g2 + 56] = bn - zn, g2++;
      }
      for (G2 = 0; G2 < 64; ++G2)
        u3 = K1[G2] * e2[G2], p[G2] = u3 > 0 ? u3 + 0.5 | 0 : u3 - 0.5 | 0;
      return p;
    }($, a1), X1 = 0; X1 < 64; ++X1)
      _[R[X1]] = n2[X1];
    var a2 = _[0] - n1;
    n1 = _[0], a2 == 0 ? h1(f1[0]) : (h1(f1[m[C1 = 32767 + a2]]), h1(v[C1]));
    for (var d2 = 63; d2 > 0 && _[d2] == 0; )
      d2--;
    if (d2 == 0)
      return h1(E1), n1;
    for (var y2, B1 = 1; B1 <= d2; ) {
      for (var p1 = B1; _[B1] == 0 && B1 <= d2; )
        ++B1;
      var _2 = B1 - p1;
      if (_2 >= 16) {
        y2 = _2 >> 4;
        for (var w2 = 1; w2 <= y2; ++w2)
          h1(T1);
        _2 &= 15;
      }
      C1 = 32767 + _[B1], h1(w1[(_2 << 4) + m[C1]]), h1(v[C1]), B1++;
    }
    return d2 != 63 && h1(E1), n1;
  }
  function A1($) {
    $ = Math.min(Math.max($, 1), 100), l != $ && (function(a1) {
      for (var n1 = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], f1 = 0; f1 < 64; f1++) {
        var w1 = a((n1[f1] * a1 + 50) / 100);
        w1 = Math.min(Math.max(w1, 1), 255), o[R[f1]] = w1;
      }
      for (var C1 = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], E1 = 0; E1 < 64; E1++) {
        var T1 = a((C1[E1] * a1 + 50) / 100);
        T1 = Math.min(Math.max(T1, 1), 255), h[R[E1]] = T1;
      }
      for (var n2 = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], X1 = 0, a2 = 0; a2 < 8; a2++)
        for (var d2 = 0; d2 < 8; d2++)
          u[X1] = 1 / (o[R[X1]] * n2[a2] * n2[d2] * 8), d[X1] = 1 / (h[R[X1]] * n2[a2] * n2[d2] * 8), X1++;
    }($ < 50 ? Math.floor(5e3 / $) : Math.floor(200 - 2 * $)), l = $);
  }
  this.encode = function($, a1) {
    a1 && A1(a1), q = new Array(), M = 0, z = 7, M1(65496), M1(65504), M1(16), c1(74), c1(70), c1(73), c1(70), c1(0), c1(1), c1(1), c1(0), M1(1), M1(1), c1(0), c1(0), function() {
      M1(65499), M1(132), c1(0);
      for (var t2 = 0; t2 < 64; t2++)
        c1(o[t2]);
      c1(1);
      for (var S2 = 0; S2 < 64; S2++)
        c1(h[S2]);
    }(), function(t2, S2) {
      M1(65472), M1(17), c1(8), M1(S2), M1(t2), c1(3), c1(1), c1(17), c1(0), c1(2), c1(17), c1(1), c1(3), c1(17), c1(1);
    }($.width, $.height), function() {
      M1(65476), M1(418), c1(0);
      for (var t2 = 0; t2 < 16; t2++)
        c1(V[t2 + 1]);
      for (var S2 = 0; S2 <= 11; S2++)
        c1(J[S2]);
      c1(16);
      for (var W2 = 0; W2 < 16; W2++)
        c1(K[W2 + 1]);
      for (var E2 = 0; E2 <= 161; E2++)
        c1(P[E2]);
      c1(1);
      for (var o3 = 0; o3 < 16; o3++)
        c1(O[o3 + 1]);
      for (var n3 = 0; n3 <= 11; n3++)
        c1(G[n3]);
      c1(17);
      for (var c3 = 0; c3 < 16; c3++)
        c1(j[c3 + 1]);
      for (var G2 = 0; G2 <= 161; G2++)
        c1(Q[G2]);
    }(), M1(65498), M1(12), c1(3), c1(1), c1(0), c1(2), c1(17), c1(3), c1(17), c1(0), c1(63), c1(0);
    var n1 = 0, f1 = 0, w1 = 0;
    M = 0, z = 7, this.encode.displayName = "_encode_";
    for (var C1, E1, T1, n2, X1, a2, d2, y2, B1, p1 = $.data, _2 = $.width, w2 = $.height, K1 = 4 * _2, e2 = 0; e2 < w2; ) {
      for (C1 = 0; C1 < K1; ) {
        for (X1 = K1 * e2 + C1, d2 = -1, y2 = 0, B1 = 0; B1 < 64; B1++)
          a2 = X1 + (y2 = B1 >> 3) * K1 + (d2 = 4 * (7 & B1)), e2 + y2 >= w2 && (a2 -= K1 * (e2 + 1 + y2 - w2)), C1 + d2 >= K1 && (a2 -= C1 + d2 - K1 + 4), E1 = p1[a2++], T1 = p1[a2++], n2 = p1[a2++], b[B1] = (D[E1] + D[T1 + 256 >> 0] + D[n2 + 512 >> 0] >> 16) - 128, x[B1] = (D[E1 + 768 >> 0] + D[T1 + 1024 >> 0] + D[n2 + 1280 >> 0] >> 16) - 128, k[B1] = (D[E1 + 1280 >> 0] + D[T1 + 1536 >> 0] + D[n2 + 1792 >> 0] >> 16) - 128;
        n1 = y1(b, u, n1, e, i), f1 = y1(x, d, f1, n, s), w1 = y1(k, d, w1, n, s), C1 += 32;
      }
      e2 += 8;
    }
    if (z >= 0) {
      var Z1 = [];
      Z1[1] = z + 1, Z1[0] = (1 << z + 1) - 1, h1(Z1);
    }
    return M1(65497), new Uint8Array(q);
  }, t = t || 50, function() {
    for (var $ = String.fromCharCode, a1 = 0; a1 < 256; a1++)
      F[a1] = $(a1);
  }(), e = i1(V, J), n = i1(O, G), i = i1(K, P), s = i1(j, Q), function() {
    for (var $ = 1, a1 = 2, n1 = 1; n1 <= 15; n1++) {
      for (var f1 = $; f1 < a1; f1++)
        m[32767 + f1] = n1, v[32767 + f1] = [], v[32767 + f1][1] = n1, v[32767 + f1][0] = f1;
      for (var w1 = -(a1 - 1); w1 <= -$; w1++)
        m[32767 + w1] = n1, v[32767 + w1] = [], v[32767 + w1][1] = n1, v[32767 + w1][0] = a1 - 1 + w1;
      $ <<= 1, a1 <<= 1;
    }
  }(), function() {
    for (var $ = 0; $ < 256; $++)
      D[$] = 19595 * $, D[$ + 256 >> 0] = 38470 * $, D[$ + 512 >> 0] = 7471 * $ + 32768, D[$ + 768 >> 0] = -11059 * $, D[$ + 1024 >> 0] = -21709 * $, D[$ + 1280 >> 0] = 32768 * $ + 8421375, D[$ + 1536 >> 0] = -27439 * $, D[$ + 1792 >> 0] = -5329 * $;
  }(), A1(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function en(t, e) {
  if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1)
    throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function QM(t) {
  function e(V) {
    if (!V)
      throw Error("assert :P");
  }
  function n(V, J, K) {
    for (var P = 0; 4 > P; P++)
      if (V[J + P] != K.charCodeAt(P))
        return !0;
    return !1;
  }
  function i(V, J, K, P, O) {
    for (var G = 0; G < O; G++)
      V[J + G] = K[P + G];
  }
  function s(V, J, K, P) {
    for (var O = 0; O < P; O++)
      V[J + O] = K;
  }
  function l(V) {
    return new Int32Array(V);
  }
  function a(V, J) {
    for (var K = [], P = 0; P < V; P++)
      K.push(new J());
    return K;
  }
  function o(V, J) {
    var K = [];
    return function P(O, G, j) {
      for (var Q = j[G], i1 = 0; i1 < Q && (O.push(j.length > G + 1 ? [] : new J()), !(j.length < G + 1)); i1++)
        P(O[i1], G + 1, j);
    }(K, 0, V), K;
  }
  var h = function() {
    var V = this;
    function J(g, w) {
      for (var E = 1 << w - 1 >>> 0; g & E; )
        E >>>= 1;
      return E ? (g & E - 1) + E : g;
    }
    function K(g, w, E, B, W) {
      e(!(B % E));
      do
        g[w + (B -= E)] = W;
      while (0 < B);
    }
    function P(g, w, E, B, W) {
      if (e(2328 >= W), 512 >= W)
        var Z = l(512);
      else if ((Z = l(W)) == null)
        return 0;
      return function(t1, r1, o1, d1, L1, I1) {
        var O1, k1, G1 = r1, V1 = 1 << o1, b1 = l(16), S1 = l(16);
        for (e(L1 != 0), e(d1 != null), e(t1 != null), e(0 < o1), k1 = 0; k1 < L1; ++k1) {
          if (15 < d1[k1])
            return 0;
          ++b1[d1[k1]];
        }
        if (b1[0] == L1)
          return 0;
        for (S1[1] = 0, O1 = 1; 15 > O1; ++O1) {
          if (b1[O1] > 1 << O1)
            return 0;
          S1[O1 + 1] = S1[O1] + b1[O1];
        }
        for (k1 = 0; k1 < L1; ++k1)
          O1 = d1[k1], 0 < d1[k1] && (I1[S1[O1]++] = k1);
        if (S1[15] == 1)
          return (d1 = new O()).g = 0, d1.value = I1[0], K(t1, G1, 1, V1, d1), V1;
        var j1, Q1 = -1, $1 = V1 - 1, C2 = 0, o2 = 1, k2 = 1, L2 = 1 << o1;
        for (k1 = 0, O1 = 1, L1 = 2; O1 <= o1; ++O1, L1 <<= 1) {
          if (o2 += k2 <<= 1, 0 > (k2 -= b1[O1]))
            return 0;
          for (; 0 < b1[O1]; --b1[O1])
            (d1 = new O()).g = O1, d1.value = I1[k1++], K(t1, G1 + C2, L1, L2, d1), C2 = J(C2, O1);
        }
        for (O1 = o1 + 1, L1 = 2; 15 >= O1; ++O1, L1 <<= 1) {
          if (o2 += k2 <<= 1, 0 > (k2 -= b1[O1]))
            return 0;
          for (; 0 < b1[O1]; --b1[O1]) {
            if (d1 = new O(), (C2 & $1) != Q1) {
              for (G1 += L2, j1 = 1 << (Q1 = O1) - o1; 15 > Q1 && !(0 >= (j1 -= b1[Q1])); )
                ++Q1, j1 <<= 1;
              V1 += L2 = 1 << (j1 = Q1 - o1), t1[r1 + (Q1 = C2 & $1)].g = j1 + o1, t1[r1 + Q1].value = G1 - r1 - Q1;
            }
            d1.g = O1 - o1, d1.value = I1[k1++], K(t1, G1 + (C2 >> o1), L1, L2, d1), C2 = J(C2, O1);
          }
        }
        return o2 != 2 * S1[15] - 1 ? 0 : V1;
      }(g, w, E, B, W, Z);
    }
    function O() {
      this.value = this.g = 0;
    }
    function G() {
      this.value = this.g = 0;
    }
    function j() {
      this.G = a(5, O), this.H = l(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = a(C4, G);
    }
    function Q(g, w, E, B) {
      e(g != null), e(w != null), e(2147483648 > B), g.Ca = 254, g.I = 0, g.b = -8, g.Ka = 0, g.oa = w, g.pa = E, g.Jd = w, g.Yc = E + B, g.Zc = 4 <= B ? E + B - 4 + 1 : E, C1(g);
    }
    function i1(g, w) {
      for (var E = 0; 0 < w--; )
        E |= T1(g, 128) << w;
      return E;
    }
    function h1(g, w) {
      var E = i1(g, w);
      return E1(g) ? -E : E;
    }
    function c1(g, w, E, B) {
      var W, Z = 0;
      for (e(g != null), e(w != null), e(4294967288 > B), g.Sb = B, g.Ra = 0, g.u = 0, g.h = 0, 4 < B && (B = 4), W = 0; W < B; ++W)
        Z += w[E + W] << 8 * W;
      g.Ra = Z, g.bb = B, g.oa = w, g.pa = E;
    }
    function M1(g) {
      for (; 8 <= g.u && g.bb < g.Sb; )
        g.Ra >>>= 8, g.Ra += g.oa[g.pa + g.bb] << Pn - 8 >>> 0, ++g.bb, g.u -= 8;
      n1(g) && (g.h = 1, g.u = 0);
    }
    function y1(g, w) {
      if (e(0 <= w), !g.h && w <= Nn) {
        var E = a1(g) & i4[w];
        return g.u += w, M1(g), E;
      }
      return g.h = 1, g.u = 0;
    }
    function A1() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function $() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function a1(g) {
      return g.Ra >>> (g.u & Pn - 1) >>> 0;
    }
    function n1(g) {
      return e(g.bb <= g.Sb), g.h || g.bb == g.Sb && g.u > Pn;
    }
    function f1(g, w) {
      g.u = w, g.h = n1(g);
    }
    function w1(g) {
      g.u >= q0 && (e(g.u >= q0), M1(g));
    }
    function C1(g) {
      e(g != null && g.oa != null), g.pa < g.Zc ? (g.I = (g.oa[g.pa++] | g.I << 8) >>> 0, g.b += 8) : (e(g != null && g.oa != null), g.pa < g.Yc ? (g.b += 8, g.I = g.oa[g.pa++] | g.I << 8) : g.Ka ? g.b = 0 : (g.I <<= 8, g.b += 8, g.Ka = 1));
    }
    function E1(g) {
      return i1(g, 1);
    }
    function T1(g, w) {
      var E = g.Ca;
      0 > g.b && C1(g);
      var B = g.b, W = E * w >>> 8, Z = (g.I >>> B > W) + 0;
      for (Z ? (E -= W, g.I -= W + 1 << B >>> 0) : E = W + 1, B = E, W = 0; 256 <= B; )
        W += 8, B >>= 8;
      return B = 7 ^ W + s4[B], g.b -= B, g.Ca = (E << B) - 1, Z;
    }
    function n2(g, w, E) {
      g[w + 0] = E >> 24 & 255, g[w + 1] = E >> 16 & 255, g[w + 2] = E >> 8 & 255, g[w + 3] = E >> 0 & 255;
    }
    function X1(g, w) {
      return g[w + 0] << 0 | g[w + 1] << 8;
    }
    function a2(g, w) {
      return X1(g, w) | g[w + 2] << 16;
    }
    function d2(g, w) {
      return X1(g, w) | X1(g, w + 2) << 16;
    }
    function y2(g, w) {
      var E = 1 << w;
      return e(g != null), e(0 < w), g.X = l(E), g.X == null ? 0 : (g.Mb = 32 - w, g.Xa = w, 1);
    }
    function B1(g, w) {
      e(g != null), e(w != null), e(g.Xa == w.Xa), i(w.X, 0, g.X, 0, 1 << w.Xa);
    }
    function p1() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function _2(g, w, E, B) {
      e(E != null), e(B != null);
      var W = E[0], Z = B[0];
      return W == 0 && (W = (g * Z + w / 2) / w), Z == 0 && (Z = (w * W + g / 2) / g), 0 >= W || 0 >= Z ? 0 : (E[0] = W, B[0] = Z, 1);
    }
    function w2(g, w) {
      return g + (1 << w) - 1 >>> w;
    }
    function K1(g, w) {
      return ((4278255360 & g) + (4278255360 & w) >>> 0 & 4278255360) + ((16711935 & g) + (16711935 & w) >>> 0 & 16711935) >>> 0;
    }
    function e2(g, w) {
      V[w] = function(E, B, W, Z, t1, r1, o1) {
        var d1;
        for (d1 = 0; d1 < t1; ++d1) {
          var L1 = V[g](r1[o1 + d1 - 1], W, Z + d1);
          r1[o1 + d1] = K1(E[B + d1], L1);
        }
      };
    }
    function Z1() {
      this.ud = this.hd = this.jd = 0;
    }
    function t2(g, w) {
      return ((4278124286 & (g ^ w)) >>> 1) + (g & w) >>> 0;
    }
    function S2(g) {
      return 0 <= g && 256 > g ? g : 0 > g ? 0 : 255 < g ? 255 : void 0;
    }
    function W2(g, w) {
      return S2(g + (g - w + 0.5 >> 1));
    }
    function E2(g, w, E) {
      return Math.abs(w - E) - Math.abs(g - E);
    }
    function o3(g, w, E, B, W, Z, t1) {
      for (B = Z[t1 - 1], E = 0; E < W; ++E)
        Z[t1 + E] = B = K1(g[w + E], B);
    }
    function n3(g, w, E, B, W) {
      var Z;
      for (Z = 0; Z < E; ++Z) {
        var t1 = g[w + Z], r1 = t1 >> 8 & 255, o1 = 16711935 & (o1 = (o1 = 16711935 & t1) + ((r1 << 16) + r1));
        B[W + Z] = (4278255360 & t1) + o1 >>> 0;
      }
    }
    function c3(g, w) {
      w.jd = g >> 0 & 255, w.hd = g >> 8 & 255, w.ud = g >> 16 & 255;
    }
    function G2(g, w, E, B, W, Z) {
      var t1;
      for (t1 = 0; t1 < B; ++t1) {
        var r1 = w[E + t1], o1 = r1 >>> 8, d1 = r1, L1 = 255 & (L1 = (L1 = r1 >>> 16) + ((g.jd << 24 >> 24) * (o1 << 24 >> 24) >>> 5));
        d1 = 255 & (d1 = (d1 = d1 + ((g.hd << 24 >> 24) * (o1 << 24 >> 24) >>> 5)) + ((g.ud << 24 >> 24) * (L1 << 24 >> 24) >>> 5)), W[Z + t1] = (4278255360 & r1) + (L1 << 16) + d1;
      }
    }
    function u3(g, w, E, B, W) {
      V[w] = function(Z, t1, r1, o1, d1, L1, I1, O1, k1) {
        for (o1 = I1; o1 < O1; ++o1)
          for (I1 = 0; I1 < k1; ++I1)
            d1[L1++] = W(r1[B(Z[t1++])]);
      }, V[g] = function(Z, t1, r1, o1, d1, L1, I1) {
        var O1 = 8 >> Z.b, k1 = Z.Ea, G1 = Z.K[0], V1 = Z.w;
        if (8 > O1)
          for (Z = (1 << Z.b) - 1, V1 = (1 << O1) - 1; t1 < r1; ++t1) {
            var b1, S1 = 0;
            for (b1 = 0; b1 < k1; ++b1)
              b1 & Z || (S1 = B(o1[d1++])), L1[I1++] = W(G1[S1 & V1]), S1 >>= O1;
          }
        else
          V["VP8LMapColor" + E](o1, d1, G1, V1, L1, I1, t1, r1, k1);
      };
    }
    function g2(g, w, E, B, W) {
      for (E = w + E; w < E; ) {
        var Z = g[w++];
        B[W++] = Z >> 16 & 255, B[W++] = Z >> 8 & 255, B[W++] = Z >> 0 & 255;
      }
    }
    function Oe(g, w, E, B, W) {
      for (E = w + E; w < E; ) {
        var Z = g[w++];
        B[W++] = Z >> 16 & 255, B[W++] = Z >> 8 & 255, B[W++] = Z >> 0 & 255, B[W++] = Z >> 24 & 255;
      }
    }
    function q3(g, w, E, B, W) {
      for (E = w + E; w < E; ) {
        var Z = (t1 = g[w++]) >> 16 & 240 | t1 >> 12 & 15, t1 = t1 >> 0 & 240 | t1 >> 28 & 15;
        B[W++] = Z, B[W++] = t1;
      }
    }
    function ht(g, w, E, B, W) {
      for (E = w + E; w < E; ) {
        var Z = (t1 = g[w++]) >> 16 & 248 | t1 >> 13 & 7, t1 = t1 >> 5 & 224 | t1 >> 3 & 31;
        B[W++] = Z, B[W++] = t1;
      }
    }
    function E3(g, w, E, B, W) {
      for (E = w + E; w < E; ) {
        var Z = g[w++];
        B[W++] = Z >> 0 & 255, B[W++] = Z >> 8 & 255, B[W++] = Z >> 16 & 255;
      }
    }
    function j3(g, w, E, B, W, Z) {
      if (Z == 0)
        for (E = w + E; w < E; )
          n2(B, ((Z = g[w++])[0] >> 24 | Z[1] >> 8 & 65280 | Z[2] << 8 & 16711680 | Z[3] << 24) >>> 0), W += 32;
      else
        i(B, W, g, w, E);
    }
    function z2(g, w) {
      V[w][0] = V[g + "0"], V[w][1] = V[g + "1"], V[w][2] = V[g + "2"], V[w][3] = V[g + "3"], V[w][4] = V[g + "4"], V[w][5] = V[g + "5"], V[w][6] = V[g + "6"], V[w][7] = V[g + "7"], V[w][8] = V[g + "8"], V[w][9] = V[g + "9"], V[w][10] = V[g + "10"], V[w][11] = V[g + "11"], V[w][12] = V[g + "12"], V[w][13] = V[g + "13"], V[w][14] = V[g + "0"], V[w][15] = V[g + "0"];
    }
    function R2(g) {
      return g == L0 || g == x0 || g == s6 || g == rl;
    }
    function w3() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function B3() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function G3() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new w3(), this.f.kb = new B3(), this.sd = null;
    }
    function Se() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function _e() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function d3(g) {
      return alert("todo:WebPSamplerProcessPlane"), g.T;
    }
    function Z3(g, w) {
      var E = g.T, B = w.ba.f.RGBA, W = B.eb, Z = B.fb + g.ka * B.A, t1 = E4[w.ba.S], r1 = g.y, o1 = g.O, d1 = g.f, L1 = g.N, I1 = g.ea, O1 = g.W, k1 = w.cc, G1 = w.dc, V1 = w.Mc, b1 = w.Nc, S1 = g.ka, j1 = g.ka + g.T, Q1 = g.U, $1 = Q1 + 1 >> 1;
      for (S1 == 0 ? t1(r1, o1, null, null, d1, L1, I1, O1, d1, L1, I1, O1, W, Z, null, null, Q1) : (t1(w.ec, w.fc, r1, o1, k1, G1, V1, b1, d1, L1, I1, O1, W, Z - B.A, W, Z, Q1), ++E); S1 + 2 < j1; S1 += 2)
        k1 = d1, G1 = L1, V1 = I1, b1 = O1, L1 += g.Rc, O1 += g.Rc, Z += 2 * B.A, t1(r1, (o1 += 2 * g.fa) - g.fa, r1, o1, k1, G1, V1, b1, d1, L1, I1, O1, W, Z - B.A, W, Z, Q1);
      return o1 += g.fa, g.j + j1 < g.o ? (i(w.ec, w.fc, r1, o1, Q1), i(w.cc, w.dc, d1, L1, $1), i(w.Mc, w.Nc, I1, O1, $1), E--) : 1 & j1 || t1(r1, o1, null, null, d1, L1, I1, O1, d1, L1, I1, O1, W, Z + B.A, null, null, Q1), E;
    }
    function yt(g, w, E) {
      var B = g.F, W = [g.J];
      if (B != null) {
        var Z = g.U, t1 = w.ba.S, r1 = t1 == X8 || t1 == s6;
        w = w.ba.f.RGBA;
        var o1 = [0], d1 = g.ka;
        o1[0] = g.T, g.Kb && (d1 == 0 ? --o1[0] : (--d1, W[0] -= g.width), g.j + g.ka + g.T == g.o && (o1[0] = g.o - g.j - d1));
        var L1 = w.eb;
        d1 = w.fb + d1 * w.A, g = W8(B, W[0], g.width, Z, o1, L1, d1 + (r1 ? 0 : 3), w.A), e(E == o1), g && R2(t1) && G5(L1, d1, r1, Z, o1, w.A);
      }
      return 0;
    }
    function Ce(g) {
      var w = g.ma, E = w.ba.S, B = 11 > E, W = E == i5 || E == W5 || E == X8 || E == ll || E == 12 || R2(E);
      if (w.memory = null, w.Ib = null, w.Jb = null, w.Nd = null, !Ei(w.Oa, g, W ? 11 : 12))
        return 0;
      if (W && R2(E) && J1(), g.da)
        alert("todo:use_scaling");
      else {
        if (B) {
          if (w.Ib = d3, g.Kb) {
            if (E = g.U + 1 >> 1, w.memory = l(g.U + 2 * E), w.memory == null)
              return 0;
            w.ec = w.memory, w.fc = 0, w.cc = w.ec, w.dc = w.fc + g.U, w.Mc = w.cc, w.Nc = w.dc + E, w.Ib = Z3, J1();
          }
        } else
          alert("todo:EmitYUV");
        W && (w.Jb = yt, B && F1());
      }
      if (B && !Br) {
        for (g = 0; 256 > g; ++g)
          Ut[g] = 89858 * (g - 128) + o4 >> K8, k9[g] = -22014 * (g - 128) + o4, C9[g] = -45773 * (g - 128), S9[g] = 113618 * (g - 128) + o4 >> K8;
        for (g = Ii; g < hl; ++g)
          w = 76283 * (g - 16) + o4 >> K8, E9[g - Ii] = V3(w, 255), A9[g - Ii] = V3(w + 8 >> 4, 15);
        Br = 1;
      }
      return 1;
    }
    function tt(g) {
      var w = g.ma, E = g.U, B = g.T;
      return e(!(1 & g.ka)), 0 >= E || 0 >= B ? 0 : (E = w.Ib(g, w), w.Jb != null && w.Jb(g, w, E), w.Dc += E, 1);
    }
    function ut(g) {
      g.ma.memory = null;
    }
    function D2(g, w, E, B) {
      return y1(g, 8) != 47 ? 0 : (w[0] = y1(g, 14) + 1, E[0] = y1(g, 14) + 1, B[0] = y1(g, 1), y1(g, 3) != 0 ? 0 : !g.h);
    }
    function Re(g, w) {
      if (4 > g)
        return g + 1;
      var E = g - 2 >> 1;
      return (2 + (1 & g) << E) + y1(w, E) + 1;
    }
    function _t(g, w) {
      return 120 < w ? w - 120 : 1 <= (E = ((E = w9[w - 1]) >> 4) * g + (8 - (15 & E))) ? E : 1;
      var E;
    }
    function L3(g, w, E) {
      var B = a1(E), W = g[w += 255 & B].g - 8;
      return 0 < W && (f1(E, E.u + 8), B = a1(E), w += g[w].value, w += B & (1 << W) - 1), f1(E, E.u + g[w].g), g[w].value;
    }
    function W3(g, w, E) {
      return E.g += g.g, E.value += g.value << w >>> 0, e(8 >= E.g), g.g;
    }
    function oe(g, w, E) {
      var B = g.xc;
      return e((w = B == 0 ? 0 : g.vc[g.md * (E >> B) + (w >> B)]) < g.Wb), g.Ya[w];
    }
    function v4(g, w, E, B) {
      var W = g.ab, Z = g.c * w, t1 = g.C;
      w = t1 + w;
      var r1 = E, o1 = B;
      for (B = g.Ta, E = g.Ua; 0 < W--; ) {
        var d1 = g.gc[W], L1 = t1, I1 = w, O1 = r1, k1 = o1, G1 = (o1 = B, r1 = E, d1.Ea);
        switch (e(L1 < I1), e(I1 <= d1.nc), d1.hc) {
          case 2:
            G8(O1, k1, (I1 - L1) * G1, o1, r1);
            break;
          case 0:
            var V1 = L1, b1 = I1, S1 = o1, j1 = r1, Q1 = (L2 = d1).Ea;
            V1 == 0 && ($t(O1, k1, null, null, 1, S1, j1), o3(O1, k1 + 1, 0, 0, Q1 - 1, S1, j1 + 1), k1 += Q1, j1 += Q1, ++V1);
            for (var $1 = 1 << L2.b, C2 = $1 - 1, o2 = w2(Q1, L2.b), k2 = L2.K, L2 = L2.w + (V1 >> L2.b) * o2; V1 < b1; ) {
              var Q3 = k2, ie = L2, x3 = 1;
              for (M5(O1, k1, S1, j1 - Q1, 1, S1, j1); x3 < Q1; ) {
                var a3 = (x3 & ~C2) + $1;
                a3 > Q1 && (a3 = Q1), (0, U5[Q3[ie++] >> 8 & 15])(O1, k1 + +x3, S1, j1 + x3 - Q1, a3 - x3, S1, j1 + x3), x3 = a3;
              }
              k1 += Q1, j1 += Q1, ++V1 & C2 || (L2 += o2);
            }
            I1 != d1.nc && i(o1, r1 - G1, o1, r1 + (I1 - L1 - 1) * G1, G1);
            break;
          case 1:
            for (G1 = O1, b1 = k1, Q1 = (O1 = d1.Ea) - (j1 = O1 & ~(S1 = (k1 = 1 << d1.b) - 1)), V1 = w2(O1, d1.b), $1 = d1.K, d1 = d1.w + (L1 >> d1.b) * V1; L1 < I1; ) {
              for (C2 = $1, o2 = d1, k2 = new Z1(), L2 = b1 + j1, Q3 = b1 + O1; b1 < L2; )
                c3(C2[o2++], k2), t5(k2, G1, b1, k1, o1, r1), b1 += k1, r1 += k1;
              b1 < Q3 && (c3(C2[o2++], k2), t5(k2, G1, b1, Q1, o1, r1), b1 += Q1, r1 += Q1), ++L1 & S1 || (d1 += V1);
            }
            break;
          case 3:
            if (O1 == o1 && k1 == r1 && 0 < d1.b) {
              for (b1 = o1, O1 = G1 = r1 + (I1 - L1) * G1 - (j1 = (I1 - L1) * w2(d1.Ea, d1.b)), k1 = o1, S1 = r1, V1 = [], j1 = (Q1 = j1) - 1; 0 <= j1; --j1)
                V1[j1] = k1[S1 + j1];
              for (j1 = Q1 - 1; 0 <= j1; --j1)
                b1[O1 + j1] = V1[j1];
              b5(d1, L1, I1, o1, G1, o1, r1);
            } else
              b5(d1, L1, I1, O1, k1, o1, r1);
        }
        r1 = B, o1 = E;
      }
      o1 != E && i(B, E, r1, o1, Z);
    }
    function wn(g, w) {
      var E = g.V, B = g.Ba + g.c * g.C, W = w - g.C;
      if (e(w <= g.l.o), e(16 >= W), 0 < W) {
        var Z = g.l, t1 = g.Ta, r1 = g.Ua, o1 = Z.width;
        if (v4(g, W, E, B), W = r1 = [r1], e((E = g.C) < (B = w)), e(Z.v < Z.va), B > Z.o && (B = Z.o), E < Z.j) {
          var d1 = Z.j - E;
          E = Z.j, W[0] += d1 * o1;
        }
        if (E >= B ? E = 0 : (W[0] += 4 * Z.v, Z.ka = E - Z.j, Z.U = Z.va - Z.v, Z.T = B - E, E = 1), E) {
          if (r1 = r1[0], 11 > (E = g.ca).S) {
            var L1 = E.f.RGBA, I1 = (B = E.S, W = Z.U, Z = Z.T, d1 = L1.eb, L1.A), O1 = Z;
            for (L1 = L1.fb + g.Ma * L1.A; 0 < O1--; ) {
              var k1 = t1, G1 = r1, V1 = W, b1 = d1, S1 = L1;
              switch (B) {
                case Vn:
                  L5(k1, G1, V1, b1, S1);
                  break;
                case i5:
                  e6(k1, G1, V1, b1, S1);
                  break;
                case L0:
                  e6(k1, G1, V1, b1, S1), G5(b1, S1, 0, V1, 1, 0);
                  break;
                case k4:
                  l4(k1, G1, V1, b1, S1);
                  break;
                case W5:
                  j3(k1, G1, V1, b1, S1, 1);
                  break;
                case x0:
                  j3(k1, G1, V1, b1, S1, 1), G5(b1, S1, 0, V1, 1, 0);
                  break;
                case X8:
                  j3(k1, G1, V1, b1, S1, 0);
                  break;
                case s6:
                  j3(k1, G1, V1, b1, S1, 0), G5(b1, S1, 1, V1, 1, 0);
                  break;
                case ll:
                  j5(k1, G1, V1, b1, S1);
                  break;
                case rl:
                  j5(k1, G1, V1, b1, S1), n5(b1, S1, V1, 1, 0);
                  break;
                case Ir:
                  w0(k1, G1, V1, b1, S1);
                  break;
                default:
                  e(0);
              }
              r1 += o1, L1 += I1;
            }
            g.Ma += Z;
          } else
            alert("todo:EmitRescaledRowsYUVA");
          e(g.Ma <= E.height);
        }
      }
      g.C = w, e(g.C <= g.i);
    }
    function m0(g) {
      var w;
      if (0 < g.ua)
        return 0;
      for (w = 0; w < g.Wb; ++w) {
        var E = g.Ya[w].G, B = g.Ya[w].H;
        if (0 < E[1][B[1] + 0].g || 0 < E[2][B[2] + 0].g || 0 < E[3][B[3] + 0].g)
          return 0;
      }
      return 1;
    }
    function _5(g, w, E, B, W, Z) {
      if (g.Z != 0) {
        var t1 = g.qd, r1 = g.rd;
        for (e(a4[g.Z] != null); w < E; ++w)
          a4[g.Z](t1, r1, B, W, B, W, Z), t1 = B, r1 = W, W += Z;
        g.qd = t1, g.rd = r1;
      }
    }
    function q5(g, w) {
      var E = g.l.ma, B = E.Z == 0 || E.Z == 1 ? g.l.j : g.C;
      if (B = g.C < B ? B : g.C, e(w <= g.l.o), w > B) {
        var W = g.l.width, Z = E.ca, t1 = E.tb + W * B, r1 = g.V, o1 = g.Ba + g.c * B, d1 = g.gc;
        e(g.ab == 1), e(d1[0].hc == 3), R4(d1[0], B, w, r1, o1, Z, t1), _5(E, B, w, Z, t1, W);
      }
      g.C = g.Ma = w;
    }
    function w5(g, w, E, B, W, Z, t1) {
      var r1 = g.$ / B, o1 = g.$ % B, d1 = g.m, L1 = g.s, I1 = E + g.$, O1 = I1;
      W = E + B * W;
      var k1 = E + B * Z, G1 = 280 + L1.ua, V1 = g.Pb ? r1 : 16777216, b1 = 0 < L1.ua ? L1.Wa : null, S1 = L1.wc, j1 = I1 < k1 ? oe(L1, o1, r1) : null;
      e(g.C < Z), e(k1 <= W);
      var Q1 = !1;
      e:
        for (; ; ) {
          for (; Q1 || I1 < k1; ) {
            var $1 = 0;
            if (r1 >= V1) {
              var C2 = I1 - E;
              e((V1 = g).Pb), V1.wd = V1.m, V1.xd = C2, 0 < V1.s.ua && B1(V1.s.Wa, V1.s.vb), V1 = r1 + ol;
            }
            if (o1 & S1 || (j1 = oe(L1, o1, r1)), e(j1 != null), j1.Qb && (w[I1] = j1.qb, Q1 = !0), !Q1)
              if (w1(d1), j1.jc) {
                $1 = d1, C2 = w;
                var o2 = I1, k2 = j1.pd[a1($1) & C4 - 1];
                e(j1.jc), 256 > k2.g ? (f1($1, $1.u + k2.g), C2[o2] = k2.value, $1 = 0) : (f1($1, $1.u + k2.g - 256), e(256 <= k2.value), $1 = k2.value), $1 == 0 && (Q1 = !0);
              } else
                $1 = L3(j1.G[0], j1.H[0], d1);
            if (d1.h)
              break;
            if (Q1 || 256 > $1) {
              if (!Q1)
                if (j1.nd)
                  w[I1] = (j1.qb | $1 << 8) >>> 0;
                else {
                  if (w1(d1), Q1 = L3(j1.G[1], j1.H[1], d1), w1(d1), C2 = L3(j1.G[2], j1.H[2], d1), o2 = L3(j1.G[3], j1.H[3], d1), d1.h)
                    break;
                  w[I1] = (o2 << 24 | Q1 << 16 | $1 << 8 | C2) >>> 0;
                }
              if (Q1 = !1, ++I1, ++o1 >= B && (o1 = 0, ++r1, t1 != null && r1 <= Z && !(r1 % 16) && t1(g, r1), b1 != null))
                for (; O1 < I1; )
                  $1 = w[O1++], b1.X[(506832829 * $1 & 4294967295) >>> b1.Mb] = $1;
            } else if (280 > $1) {
              if ($1 = Re($1 - 256, d1), C2 = L3(j1.G[4], j1.H[4], d1), w1(d1), C2 = _t(B, C2 = Re(C2, d1)), d1.h)
                break;
              if (I1 - E < C2 || W - I1 < $1)
                break e;
              for (o2 = 0; o2 < $1; ++o2)
                w[I1 + o2] = w[I1 + o2 - C2];
              for (I1 += $1, o1 += $1; o1 >= B; )
                o1 -= B, ++r1, t1 != null && r1 <= Z && !(r1 % 16) && t1(g, r1);
              if (e(I1 <= W), o1 & S1 && (j1 = oe(L1, o1, r1)), b1 != null)
                for (; O1 < I1; )
                  $1 = w[O1++], b1.X[(506832829 * $1 & 4294967295) >>> b1.Mb] = $1;
            } else {
              if (!($1 < G1))
                break e;
              for (Q1 = $1 - 280, e(b1 != null); O1 < I1; )
                $1 = w[O1++], b1.X[(506832829 * $1 & 4294967295) >>> b1.Mb] = $1;
              $1 = I1, e(!(Q1 >>> (C2 = b1).Xa)), w[$1] = C2.X[Q1], Q1 = !0;
            }
            Q1 || e(d1.h == n1(d1));
          }
          if (g.Pb && d1.h && I1 < W)
            e(g.m.h), g.a = 5, g.m = g.wd, g.$ = g.xd, 0 < g.s.ua && B1(g.s.vb, g.s.Wa);
          else {
            if (d1.h)
              break e;
            t1 != null && t1(g, r1 > Z ? Z : r1), g.a = 0, g.$ = I1 - E;
          }
          return 1;
        }
      return g.a = 3, 0;
    }
    function X4(g) {
      e(g != null), g.vc = null, g.yc = null, g.Ya = null;
      var w = g.Wa;
      w != null && (w.X = null), g.vb = null, e(g != null);
    }
    function K4() {
      var g = new _0();
      return g == null ? null : (g.a = 0, g.xb = r6, z2("Predictor", "VP8LPredictors"), z2("Predictor", "VP8LPredictors_C"), z2("PredictorAdd", "VP8LPredictorsAdd"), z2("PredictorAdd", "VP8LPredictorsAdd_C"), G8 = n3, t5 = G2, L5 = g2, e6 = Oe, j5 = q3, w0 = ht, l4 = E3, V.VP8LMapColor32b = Fi, V.VP8LMapColor8b = it, g);
    }
    function H5(g, w, E, B, W) {
      var Z = 1, t1 = [g], r1 = [w], o1 = B.m, d1 = B.s, L1 = null, I1 = 0;
      e:
        for (; ; ) {
          if (E)
            for (; Z && y1(o1, 1); ) {
              var O1 = t1, k1 = r1, G1 = B, V1 = 1, b1 = G1.m, S1 = G1.gc[G1.ab], j1 = y1(b1, 2);
              if (G1.Oc & 1 << j1)
                Z = 0;
              else {
                switch (G1.Oc |= 1 << j1, S1.hc = j1, S1.Ea = O1[0], S1.nc = k1[0], S1.K = [null], ++G1.ab, e(4 >= G1.ab), j1) {
                  case 0:
                  case 1:
                    S1.b = y1(b1, 3) + 2, V1 = H5(w2(S1.Ea, S1.b), w2(S1.nc, S1.b), 0, G1, S1.K), S1.K = S1.K[0];
                    break;
                  case 3:
                    var Q1, $1 = y1(b1, 8) + 1, C2 = 16 < $1 ? 0 : 4 < $1 ? 1 : 2 < $1 ? 2 : 3;
                    if (O1[0] = w2(S1.Ea, C2), S1.b = C2, Q1 = V1 = H5($1, 1, 0, G1, S1.K)) {
                      var o2, k2 = $1, L2 = S1, Q3 = 1 << (8 >> L2.b), ie = l(Q3);
                      if (ie == null)
                        Q1 = 0;
                      else {
                        var x3 = L2.K[0], a3 = L2.w;
                        for (ie[0] = L2.K[0][0], o2 = 1; o2 < 1 * k2; ++o2)
                          ie[o2] = K1(x3[a3 + o2], ie[o2 - 1]);
                        for (; o2 < 4 * Q3; ++o2)
                          ie[o2] = 0;
                        L2.K[0] = null, L2.K[0] = ie, Q1 = 1;
                      }
                    }
                    V1 = Q1;
                    break;
                  case 2:
                    break;
                  default:
                    e(0);
                }
                Z = V1;
              }
            }
          if (t1 = t1[0], r1 = r1[0], Z && y1(o1, 1) && !(Z = 1 <= (I1 = y1(o1, 4)) && 11 >= I1)) {
            B.a = 3;
            break e;
          }
          var ve;
          if (ve = Z)
            t: {
              var we, h3, zt, c4 = B, i3 = t1, Nt = r1, se = I1, le = E, jt = c4.m, Ze = c4.s, pe = [null], Gt = 1, A3 = 0, A4 = z9[se];
              n:
                for (; ; ) {
                  if (le && y1(jt, 1)) {
                    var Pt = y1(jt, 3) + 2, k0 = w2(i3, Pt), j6 = w2(Nt, Pt), X5 = k0 * j6;
                    if (!H5(k0, j6, 0, c4, pe))
                      break n;
                    for (pe = pe[0], Ze.xc = Pt, we = 0; we < X5; ++we) {
                      var o6 = pe[we] >> 8 & 65535;
                      pe[we] = o6, o6 >= Gt && (Gt = o6 + 1);
                    }
                  }
                  if (jt.h)
                    break n;
                  for (h3 = 0; 5 > h3; ++h3) {
                    var ce = Or[h3];
                    !h3 && 0 < se && (ce += 1 << se), A3 < ce && (A3 = ce);
                  }
                  var Oi = a(Gt * A4, O), Rr = Gt, Hr = a(Rr, j);
                  if (Hr == null)
                    var s5 = null;
                  else
                    e(65536 >= Rr), s5 = Hr;
                  var Ni = l(A3);
                  if (s5 == null || Ni == null || Oi == null) {
                    c4.a = 1;
                    break n;
                  }
                  var J8 = Oi;
                  for (we = zt = 0; we < Gt; ++we) {
                    var g4 = s5[we], c6 = g4.G, Rn = g4.H, Dr = 0, Q8 = 1, es = 0;
                    for (h3 = 0; 5 > h3; ++h3) {
                      ce = Or[h3], c6[h3] = J8, Rn[h3] = zt, !h3 && 0 < se && (ce += 1 << se);
                      s: {
                        var h6, ul = ce, u6 = c4, G6 = Ni, dl = J8, fl = zt, E0 = 0, d6 = u6.m, vl = y1(d6, 1);
                        if (s(G6, 0, 0, ul), vl) {
                          var pl = y1(d6, 1) + 1, I9 = y1(d6, 1), ts = y1(d6, I9 == 0 ? 1 : 8);
                          G6[ts] = 1, pl == 2 && (G6[ts = y1(d6, 8)] = 1);
                          var ns = 1;
                        } else {
                          var Hn = l(19), is = y1(d6, 4) + 4;
                          if (19 < is) {
                            u6.a = 3;
                            var f6 = 0;
                            break s;
                          }
                          for (h6 = 0; h6 < is; ++h6)
                            Hn[ne[h6]] = y1(d6, 3);
                          var ml = void 0, A0 = void 0, M2 = u6, O9 = Hn, ss = ul, K5 = G6, Pi = 0, v6 = M2.m, $r = 8, Je = a(128, O);
                          i:
                            for (; P(Je, 0, 7, O9, 19); ) {
                              if (y1(v6, 1)) {
                                var N9 = 2 + 2 * y1(v6, 3);
                                if ((ml = 2 + y1(v6, N9)) > ss)
                                  break i;
                              } else
                                ml = ss;
                              for (A0 = 0; A0 < ss && ml--; ) {
                                w1(v6);
                                var p6 = Je[0 + (127 & a1(v6))];
                                f1(v6, v6.u + p6.g);
                                var Z5 = p6.value;
                                if (16 > Z5)
                                  K5[A0++] = Z5, Z5 != 0 && ($r = Z5);
                                else {
                                  var gl = Z5 == 16, ls = Z5 - 16, De = q9[ls], h4 = y1(v6, al[ls]) + De;
                                  if (A0 + h4 > ss)
                                    break i;
                                  for (var Bi = gl ? $r : 0; 0 < h4--; )
                                    K5[A0++] = Bi;
                                }
                              }
                              Pi = 1;
                              break i;
                            }
                          Pi || (M2.a = 3), ns = Pi;
                        }
                        (ns = ns && !d6.h) && (E0 = P(dl, fl, 8, G6, ul)), ns && E0 != 0 ? f6 = E0 : (u6.a = 3, f6 = 0);
                      }
                      if (f6 == 0)
                        break n;
                      if (Q8 && R3[h3] == 1 && (Q8 = J8[zt].g == 0), Dr += J8[zt].g, zt += f6, 3 >= h3) {
                        var W6, F0 = Ni[0];
                        for (W6 = 1; W6 < ce; ++W6)
                          Ni[W6] > F0 && (F0 = Ni[W6]);
                        es += F0;
                      }
                    }
                    if (g4.nd = Q8, g4.Qb = 0, Q8 && (g4.qb = (c6[3][Rn[3] + 0].value << 24 | c6[1][Rn[1] + 0].value << 16 | c6[2][Rn[2] + 0].value) >>> 0, Dr == 0 && 256 > c6[0][Rn[0] + 0].value && (g4.Qb = 1, g4.qb += c6[0][Rn[0] + 0].value << 8)), g4.jc = !g4.Qb && 6 > es, g4.jc) {
                      var Dn, D4 = g4;
                      for (Dn = 0; Dn < C4; ++Dn) {
                        var J5 = Dn, l5 = D4.pd[J5], m6 = D4.G[0][D4.H[0] + J5];
                        256 <= m6.value ? (l5.g = m6.g + 256, l5.value = m6.value) : (l5.g = 0, l5.value = 0, J5 >>= W3(m6, 8, l5), J5 >>= W3(D4.G[1][D4.H[1] + J5], 16, l5), J5 >>= W3(D4.G[2][D4.H[2] + J5], 0, l5), W3(D4.G[3][D4.H[3] + J5], 24, l5));
                      }
                    }
                  }
                  Ze.vc = pe, Ze.Wb = Gt, Ze.Ya = s5, Ze.yc = Oi, ve = 1;
                  break t;
                }
              ve = 0;
            }
          if (!(Z = ve)) {
            B.a = 3;
            break e;
          }
          if (0 < I1) {
            if (d1.ua = 1 << I1, !y2(d1.Wa, I1)) {
              B.a = 1, Z = 0;
              break e;
            }
          } else
            d1.ua = 0;
          var Wt = B, Ur = t1, y4 = r1, Vi = Wt.s, Ri = Vi.xc;
          if (Wt.c = Ur, Wt.i = y4, Vi.md = w2(Ur, Ri), Vi.wc = Ri == 0 ? -1 : (1 << Ri) - 1, E) {
            B.xb = b9;
            break e;
          }
          if ((L1 = l(t1 * r1)) == null) {
            B.a = 1, Z = 0;
            break e;
          }
          Z = (Z = w5(B, L1, 0, t1, r1, r1, null)) && !o1.h;
          break e;
        }
      return Z ? (W != null ? W[0] = L1 : (e(L1 == null), e(E)), B.$ = 0, E || X4(d1)) : X4(d1), Z;
    }
    function F6(g, w) {
      var E = g.c * g.i, B = E + w + 16 * w;
      return e(g.c <= w), g.V = l(B), g.V == null ? (g.Ta = null, g.Ua = 0, g.a = 1, 0) : (g.Ta = g.V, g.Ua = g.Ba + E + w, 1);
    }
    function zn(g, w) {
      var E = g.C, B = w - E, W = g.V, Z = g.Ba + g.c * E;
      for (e(w <= g.l.o); 0 < B; ) {
        var t1 = 16 < B ? 16 : B, r1 = g.l.ma, o1 = g.l.width, d1 = o1 * t1, L1 = r1.ca, I1 = r1.tb + o1 * E, O1 = g.Ta, k1 = g.Ua;
        v4(g, t1, W, Z), Fr(O1, k1, L1, I1, d1), _5(r1, E, E + t1, L1, I1, o1), B -= t1, W += t1 * g.c, E += t1;
      }
      e(E == w), g.C = g.Ma = w;
    }
    function Mn() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function bn() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function Z4() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = l(4), this.Lb = l(4);
    }
    function P8() {
      this.Yb = function() {
        var g = [];
        return function w(E, B, W) {
          for (var Z = W[B], t1 = 0; t1 < Z && (E.push(W.length > B + 1 ? [] : 0), !(W.length < B + 1)); t1++)
            w(E[t1], B + 1, W);
        }(g, 0, [3, 11]), g;
      }();
    }
    function g0() {
      this.jb = l(3), this.Wc = o([4, 8], P8), this.Xc = o([4, 17], P8);
    }
    function Ys() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new l(4), this.od = new l(4);
    }
    function Ln() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function B8() {
      this.Na = this.la = 0;
    }
    function mi() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function T6() {
      this.ad = l(384), this.Za = 0, this.Ob = l(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function gi() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new Ln()), this.Y = 0, this.ya = Array(new T6()), this.aa = 0, this.l = new xn();
    }
    function V8() {
      this.y = l(16), this.f = l(8), this.ea = l(8);
    }
    function Xs() {
      this.cb = this.a = 0, this.sc = "", this.m = new A1(), this.Od = new Mn(), this.Kc = new bn(), this.ed = new Ys(), this.Qa = new Z4(), this.Ic = this.$c = this.Aa = 0, this.D = new gi(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = a(8, A1), this.ia = 0, this.pb = a(4, mi), this.Pa = new g0(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new V8()), this.Hd = 0, this.rb = Array(new B8()), this.sb = 0, this.wa = Array(new Ln()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new T6()), this.L = this.aa = 0, this.gd = o([4, 2], Ln), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function xn() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function Ks() {
      var g = new Xs();
      return g != null && (g.a = 0, g.sc = "OK", g.cb = 0, g.Xb = 0, H4 || (H4 = G0)), g;
    }
    function nt(g, w, E) {
      return g.a == 0 && (g.a = w, g.sc = E, g.cb = 0), 0;
    }
    function Sn(g, w, E) {
      return 3 <= E && g[w + 0] == 157 && g[w + 1] == 1 && g[w + 2] == 42;
    }
    function Cn(g, w) {
      if (g == null)
        return 0;
      if (g.a = 0, g.sc = "OK", w == null)
        return nt(g, 2, "null VP8Io passed to VP8GetHeaders()");
      var E = w.data, B = w.w, W = w.ha;
      if (4 > W)
        return nt(g, 7, "Truncated header.");
      var Z = E[B + 0] | E[B + 1] << 8 | E[B + 2] << 16, t1 = g.Od;
      if (t1.Rb = !(1 & Z), t1.td = Z >> 1 & 7, t1.yd = Z >> 4 & 1, t1.ub = Z >> 5, 3 < t1.td)
        return nt(g, 3, "Incorrect keyframe parameters.");
      if (!t1.yd)
        return nt(g, 4, "Frame not displayable.");
      B += 3, W -= 3;
      var r1 = g.Kc;
      if (t1.Rb) {
        if (7 > W)
          return nt(g, 7, "cannot parse picture header");
        if (!Sn(E, B, W))
          return nt(g, 3, "Bad code word");
        r1.c = 16383 & (E[B + 4] << 8 | E[B + 3]), r1.Td = E[B + 4] >> 6, r1.i = 16383 & (E[B + 6] << 8 | E[B + 5]), r1.Ud = E[B + 6] >> 6, B += 7, W -= 7, g.za = r1.c + 15 >> 4, g.Ub = r1.i + 15 >> 4, w.width = r1.c, w.height = r1.i, w.Da = 0, w.j = 0, w.v = 0, w.va = w.width, w.o = w.height, w.da = 0, w.ib = w.width, w.hb = w.height, w.U = w.width, w.T = w.height, s((Z = g.Pa).jb, 0, 255, Z.jb.length), e((Z = g.Qa) != null), Z.Cb = 0, Z.Bb = 0, Z.Fb = 1, s(Z.Zb, 0, 0, Z.Zb.length), s(Z.Lb, 0, 0, Z.Lb);
      }
      if (t1.ub > W)
        return nt(g, 7, "bad partition length");
      Q(Z = g.m, E, B, t1.ub), B += t1.ub, W -= t1.ub, t1.Rb && (r1.Ld = E1(Z), r1.Kd = E1(Z)), r1 = g.Qa;
      var o1, d1 = g.Pa;
      if (e(Z != null), e(r1 != null), r1.Cb = E1(Z), r1.Cb) {
        if (r1.Bb = E1(Z), E1(Z)) {
          for (r1.Fb = E1(Z), o1 = 0; 4 > o1; ++o1)
            r1.Zb[o1] = E1(Z) ? h1(Z, 7) : 0;
          for (o1 = 0; 4 > o1; ++o1)
            r1.Lb[o1] = E1(Z) ? h1(Z, 6) : 0;
        }
        if (r1.Bb)
          for (o1 = 0; 3 > o1; ++o1)
            d1.jb[o1] = E1(Z) ? i1(Z, 8) : 255;
      } else
        r1.Bb = 0;
      if (Z.Ka)
        return nt(g, 3, "cannot parse segment header");
      if ((r1 = g.ed).zd = E1(Z), r1.Tb = i1(Z, 6), r1.wb = i1(Z, 3), r1.Pc = E1(Z), r1.Pc && E1(Z)) {
        for (d1 = 0; 4 > d1; ++d1)
          E1(Z) && (r1.vd[d1] = h1(Z, 6));
        for (d1 = 0; 4 > d1; ++d1)
          E1(Z) && (r1.od[d1] = h1(Z, 6));
      }
      if (g.L = r1.Tb == 0 ? 0 : r1.zd ? 1 : 2, Z.Ka)
        return nt(g, 3, "cannot parse filter header");
      var L1 = W;
      if (W = o1 = B, B = o1 + L1, r1 = L1, g.Xb = (1 << i1(g.m, 2)) - 1, L1 < 3 * (d1 = g.Xb))
        E = 7;
      else {
        for (o1 += 3 * d1, r1 -= 3 * d1, L1 = 0; L1 < d1; ++L1) {
          var I1 = E[W + 0] | E[W + 1] << 8 | E[W + 2] << 16;
          I1 > r1 && (I1 = r1), Q(g.Jc[+L1], E, o1, I1), o1 += I1, r1 -= I1, W += 3;
        }
        Q(g.Jc[+d1], E, o1, r1), E = o1 < B ? 0 : 5;
      }
      if (E != 0)
        return nt(g, E, "cannot parse partitions");
      for (E = i1(o1 = g.m, 7), W = E1(o1) ? h1(o1, 4) : 0, B = E1(o1) ? h1(o1, 4) : 0, r1 = E1(o1) ? h1(o1, 4) : 0, d1 = E1(o1) ? h1(o1, 4) : 0, o1 = E1(o1) ? h1(o1, 4) : 0, L1 = g.Qa, I1 = 0; 4 > I1; ++I1) {
        if (L1.Cb) {
          var O1 = L1.Zb[I1];
          L1.Fb || (O1 += E);
        } else {
          if (0 < I1) {
            g.pb[I1] = g.pb[0];
            continue;
          }
          O1 = E;
        }
        var k1 = g.pb[I1];
        k1.Sc[0] = cl[V3(O1 + W, 127)], k1.Sc[1] = $6[V3(O1 + 0, 127)], k1.Eb[0] = 2 * cl[V3(O1 + B, 127)], k1.Eb[1] = 101581 * $6[V3(O1 + r1, 127)] >> 16, 8 > k1.Eb[1] && (k1.Eb[1] = 8), k1.Qc[0] = cl[V3(O1 + d1, 117)], k1.Qc[1] = $6[V3(O1 + o1, 127)], k1.lc = O1 + o1;
      }
      if (!t1.Rb)
        return nt(g, 4, "Not a key frame.");
      for (E1(Z), t1 = g.Pa, E = 0; 4 > E; ++E) {
        for (W = 0; 8 > W; ++W)
          for (B = 0; 3 > B; ++B)
            for (r1 = 0; 11 > r1; ++r1)
              d1 = T1(Z, C5[E][W][B][r1]) ? i1(Z, 8) : S0[E][W][B][r1], t1.Wc[E][W].Yb[B][r1] = d1;
        for (W = 0; 17 > W; ++W)
          t1.Xc[E][W] = t1.Wc[E][M9[W]];
      }
      return g.kc = E1(Z), g.kc && (g.Bd = i1(Z, 8)), g.cb = 1;
    }
    function G0(g, w, E, B, W, Z, t1) {
      var r1 = w[W].Yb[E];
      for (E = 0; 16 > W; ++W) {
        if (!T1(g, r1[E + 0]))
          return W;
        for (; !T1(g, r1[E + 1]); )
          if (r1 = w[++W].Yb[0], E = 0, W == 16)
            return 16;
        var o1 = w[W + 1].Yb;
        if (T1(g, r1[E + 2])) {
          var d1 = g, L1 = 0;
          if (T1(d1, (O1 = r1)[(I1 = E) + 3]))
            if (T1(d1, O1[I1 + 6])) {
              for (r1 = 0, I1 = 2 * (L1 = T1(d1, O1[I1 + 8])) + (O1 = T1(d1, O1[I1 + 9 + L1])), L1 = 0, O1 = Ti[I1]; O1[r1]; ++r1)
                L1 += L1 + T1(d1, O1[r1]);
              L1 += 3 + (8 << I1);
            } else
              T1(d1, O1[I1 + 7]) ? (L1 = 7 + 2 * T1(d1, 165), L1 += T1(d1, 145)) : L1 = 5 + T1(d1, 159);
          else
            L1 = T1(d1, O1[I1 + 4]) ? 3 + T1(d1, O1[I1 + 5]) : 2;
          r1 = o1[2];
        } else
          L1 = 1, r1 = o1[1];
        o1 = t1 + S5[W], 0 > (d1 = g).b && C1(d1);
        var I1, O1 = d1.b, k1 = (I1 = d1.Ca >> 1) - (d1.I >> O1) >> 31;
        --d1.b, d1.Ca += k1, d1.Ca |= 1, d1.I -= (I1 + 1 & k1) << O1, Z[o1] = ((L1 ^ k1) - k1) * B[(0 < W) + 0];
      }
      return 16;
    }
    function yi(g) {
      var w = g.rb[g.sb - 1];
      w.la = 0, w.Na = 0, s(g.zc, 0, 0, g.zc.length), g.ja = 0;
    }
    function _i(g, w) {
      if (g == null)
        return 0;
      if (w == null)
        return nt(g, 2, "NULL VP8Io parameter in VP8Decode().");
      if (!g.cb && !Cn(g, w))
        return 0;
      if (e(g.cb), w.ac == null || w.ac(w)) {
        w.ob && (g.L = 0);
        var E = Z8[g.L];
        if (g.L == 2 ? (g.yb = 0, g.zb = 0) : (g.yb = w.v - E >> 4, g.zb = w.j - E >> 4, 0 > g.yb && (g.yb = 0), 0 > g.zb && (g.zb = 0)), g.Va = w.o + 15 + E >> 4, g.Hb = w.va + 15 + E >> 4, g.Hb > g.za && (g.Hb = g.za), g.Va > g.Ub && (g.Va = g.Ub), 0 < g.L) {
          var B = g.ed;
          for (E = 0; 4 > E; ++E) {
            var W;
            if (g.Qa.Cb) {
              var Z = g.Qa.Lb[E];
              g.Qa.Fb || (Z += B.Tb);
            } else
              Z = B.Tb;
            for (W = 0; 1 >= W; ++W) {
              var t1 = g.gd[E][W], r1 = Z;
              if (B.Pc && (r1 += B.vd[0], W && (r1 += B.od[0])), 0 < (r1 = 0 > r1 ? 0 : 63 < r1 ? 63 : r1)) {
                var o1 = r1;
                0 < B.wb && (o1 = 4 < B.wb ? o1 >> 2 : o1 >> 1) > 9 - B.wb && (o1 = 9 - B.wb), 1 > o1 && (o1 = 1), t1.dd = o1, t1.tc = 2 * r1 + o1, t1.ld = 40 <= r1 ? 2 : 15 <= r1 ? 1 : 0;
              } else
                t1.tc = 0;
              t1.La = W;
            }
          }
        }
        E = 0;
      } else
        nt(g, 6, "Frame setup failed"), E = g.a;
      if (E = E == 0) {
        if (E) {
          g.$c = 0, 0 < g.Aa || (g.Ic = T9);
          e: {
            E = g.Ic, B = 4 * (o1 = g.za);
            var d1 = 32 * o1, L1 = o1 + 1, I1 = 0 < g.L ? o1 * (0 < g.Aa ? 2 : 1) : 0, O1 = (g.Aa == 2 ? 2 : 1) * o1;
            if ((t1 = B + 832 + (W = 3 * (16 * E + Z8[g.L]) / 2 * d1) + (Z = g.Fa != null && 0 < g.Fa.length ? g.Kc.c * g.Kc.i : 0)) != t1)
              E = 0;
            else {
              if (t1 > g.Vb) {
                if (g.Vb = 0, g.Ec = l(t1), g.Fc = 0, g.Ec == null) {
                  E = nt(g, 1, "no memory during frame initialization.");
                  break e;
                }
                g.Vb = t1;
              }
              t1 = g.Ec, r1 = g.Fc, g.Ac = t1, g.Bc = r1, r1 += B, g.Gd = a(d1, V8), g.Hd = 0, g.rb = a(L1 + 1, B8), g.sb = 1, g.wa = I1 ? a(I1, Ln) : null, g.Y = 0, g.D.Nb = 0, g.D.wa = g.wa, g.D.Y = g.Y, 0 < g.Aa && (g.D.Y += o1), e(!0), g.oc = t1, g.pc = r1, r1 += 832, g.ya = a(O1, T6), g.aa = 0, g.D.ya = g.ya, g.D.aa = g.aa, g.Aa == 2 && (g.D.aa += o1), g.R = 16 * o1, g.B = 8 * o1, o1 = (d1 = Z8[g.L]) * g.R, d1 = d1 / 2 * g.B, g.sa = t1, g.ta = r1 + o1, g.qa = g.sa, g.ra = g.ta + 16 * E * g.R + d1, g.Ha = g.qa, g.Ia = g.ra + 8 * E * g.B + d1, g.$c = 0, r1 += W, g.mb = Z ? t1 : null, g.nb = Z ? r1 : null, e(r1 + Z <= g.Fc + g.Vb), yi(g), s(g.Ac, g.Bc, 0, B), E = 1;
            }
          }
          if (E) {
            if (w.ka = 0, w.y = g.sa, w.O = g.ta, w.f = g.qa, w.N = g.ra, w.ea = g.Ha, w.Vd = g.Ia, w.fa = g.R, w.Rc = g.B, w.F = null, w.J = 0, !Y8) {
              for (E = -255; 255 >= E; ++E)
                Tr[255 + E] = 0 > E ? -E : E;
              for (E = -1020; 1020 >= E; ++E)
                n6[1020 + E] = -128 > E ? -128 : 127 < E ? 127 : E;
              for (E = -112; 112 >= E; ++E)
                r4[112 + E] = -16 > E ? -16 : 15 < E ? 15 : E;
              for (E = -255; 510 >= E; ++E)
                i6[255 + E] = 0 > E ? 0 : 255 < E ? 255 : E;
              Y8 = 1;
            }
            e1 = N6, m1 = O6, R1 = R8, s2 = qi, N2 = Y0, u1 = kn, z3 = B6, Y2 = y0, x5 = Si, t6 = V6, ke = xi, Tt = Q0, z0 = fe, $3 = j8, te = D3, Ee = P4, x2 = qt, M0 = Li, k5[0] = D5, k5[1] = wi, k5[2] = Qs, k5[3] = el, k5[4] = D8, k5[5] = An, k5[6] = Z0, k5[7] = Mi, k5[8] = nl, k5[9] = tl, l6[0] = En, l6[1] = Zs, l6[2] = z5, l6[3] = X0, l6[4] = n4, l6[5] = Js, l6[6] = H8, C0[0] = J0, C0[1] = zi, C0[2] = il, C0[3] = e3, C0[4] = P6, C0[5] = sl, C0[6] = bi, E = 1;
          } else
            E = 0;
        }
        E && (E = function(k1, G1) {
          for (k1.M = 0; k1.M < k1.Va; ++k1.M) {
            var V1, b1 = k1.Jc[k1.M & k1.Xb], S1 = k1.m, j1 = k1;
            for (V1 = 0; V1 < j1.za; ++V1) {
              var Q1 = S1, $1 = j1, C2 = $1.Ac, o2 = $1.Bc + 4 * V1, k2 = $1.zc, L2 = $1.ya[$1.aa + V1];
              if ($1.Qa.Bb ? L2.$b = T1(Q1, $1.Pa.jb[0]) ? 2 + T1(Q1, $1.Pa.jb[2]) : T1(Q1, $1.Pa.jb[1]) : L2.$b = 0, $1.kc && (L2.Ad = T1(Q1, $1.Bd)), L2.Za = !T1(Q1, 145) + 0, L2.Za) {
                var Q3 = L2.Ob, ie = 0;
                for ($1 = 0; 4 > $1; ++$1) {
                  var x3, a3 = k2[0 + $1];
                  for (x3 = 0; 4 > x3; ++x3) {
                    a3 = U6[C2[o2 + x3]][a3];
                    for (var ve = Y5[T1(Q1, a3[0])]; 0 < ve; )
                      ve = Y5[2 * ve + T1(Q1, a3[ve])];
                    a3 = -ve, C2[o2 + x3] = a3;
                  }
                  i(Q3, ie, C2, o2, 4), ie += 4, k2[0 + $1] = a3;
                }
              } else
                a3 = T1(Q1, 156) ? T1(Q1, 128) ? 1 : 3 : T1(Q1, 163) ? 2 : 0, L2.Ob[0] = a3, s(C2, o2, a3, 4), s(k2, 0, a3, 4);
              L2.Dd = T1(Q1, 142) ? T1(Q1, 114) ? T1(Q1, 183) ? 1 : 3 : 2 : 0;
            }
            if (j1.m.Ka)
              return nt(k1, 7, "Premature end-of-partition0 encountered.");
            for (; k1.ja < k1.za; ++k1.ja) {
              if (j1 = b1, Q1 = (S1 = k1).rb[S1.sb - 1], C2 = S1.rb[S1.sb + S1.ja], V1 = S1.ya[S1.aa + S1.ja], o2 = S1.kc ? V1.Ad : 0)
                Q1.la = C2.la = 0, V1.Za || (Q1.Na = C2.Na = 0), V1.Hc = 0, V1.Gc = 0, V1.ia = 0;
              else {
                var we, h3;
                if (Q1 = C2, C2 = j1, o2 = S1.Pa.Xc, k2 = S1.ya[S1.aa + S1.ja], L2 = S1.pb[k2.$b], $1 = k2.ad, Q3 = 0, ie = S1.rb[S1.sb - 1], a3 = x3 = 0, s($1, Q3, 0, 384), k2.Za)
                  var zt = 0, c4 = o2[3];
                else {
                  ve = l(16);
                  var i3 = Q1.Na + ie.Na;
                  if (i3 = H4(C2, o2[1], i3, L2.Eb, 0, ve, 0), Q1.Na = ie.Na = (0 < i3) + 0, 1 < i3)
                    e1(ve, 0, $1, Q3);
                  else {
                    var Nt = ve[0] + 3 >> 3;
                    for (ve = 0; 256 > ve; ve += 16)
                      $1[Q3 + ve] = Nt;
                  }
                  zt = 1, c4 = o2[0];
                }
                var se = 15 & Q1.la, le = 15 & ie.la;
                for (ve = 0; 4 > ve; ++ve) {
                  var jt = 1 & le;
                  for (Nt = h3 = 0; 4 > Nt; ++Nt)
                    se = se >> 1 | (jt = (i3 = H4(C2, c4, i3 = jt + (1 & se), L2.Sc, zt, $1, Q3)) > zt) << 7, h3 = h3 << 2 | (3 < i3 ? 3 : 1 < i3 ? 2 : $1[Q3 + 0] != 0), Q3 += 16;
                  se >>= 4, le = le >> 1 | jt << 7, x3 = (x3 << 8 | h3) >>> 0;
                }
                for (c4 = se, zt = le >> 4, we = 0; 4 > we; we += 2) {
                  for (h3 = 0, se = Q1.la >> 4 + we, le = ie.la >> 4 + we, ve = 0; 2 > ve; ++ve) {
                    for (jt = 1 & le, Nt = 0; 2 > Nt; ++Nt)
                      i3 = jt + (1 & se), se = se >> 1 | (jt = 0 < (i3 = H4(C2, o2[2], i3, L2.Qc, 0, $1, Q3))) << 3, h3 = h3 << 2 | (3 < i3 ? 3 : 1 < i3 ? 2 : $1[Q3 + 0] != 0), Q3 += 16;
                    se >>= 2, le = le >> 1 | jt << 5;
                  }
                  a3 |= h3 << 4 * we, c4 |= se << 4 << we, zt |= (240 & le) << we;
                }
                Q1.la = c4, ie.la = zt, k2.Hc = x3, k2.Gc = a3, k2.ia = 43690 & a3 ? 0 : L2.ia, o2 = !(x3 | a3);
              }
              if (0 < S1.L && (S1.wa[S1.Y + S1.ja] = S1.gd[V1.$b][V1.Za], S1.wa[S1.Y + S1.ja].La |= !o2), j1.Ka)
                return nt(k1, 7, "Premature end-of-file encountered.");
            }
            if (yi(k1), S1 = G1, j1 = 1, V1 = (b1 = k1).D, Q1 = 0 < b1.L && b1.M >= b1.zb && b1.M <= b1.Va, b1.Aa == 0)
              e: {
                if (V1.M = b1.M, V1.uc = Q1, D6(b1, V1), j1 = 1, V1 = (h3 = b1.D).Nb, Q1 = (a3 = Z8[b1.L]) * b1.R, C2 = a3 / 2 * b1.B, ve = 16 * V1 * b1.R, Nt = 8 * V1 * b1.B, o2 = b1.sa, k2 = b1.ta - Q1 + ve, L2 = b1.qa, $1 = b1.ra - C2 + Nt, Q3 = b1.Ha, ie = b1.Ia - C2 + Nt, le = (se = h3.M) == 0, x3 = se >= b1.Va - 1, b1.Aa == 2 && D6(b1, h3), h3.uc)
                  for (jt = (i3 = b1).D.M, e(i3.D.uc), h3 = i3.yb; h3 < i3.Hb; ++h3) {
                    zt = h3, c4 = jt;
                    var Ze = (pe = (ce = i3).D).Nb;
                    we = ce.R;
                    var pe = pe.wa[pe.Y + zt], Gt = ce.sa, A3 = ce.ta + 16 * Ze * we + 16 * zt, A4 = pe.dd, Pt = pe.tc;
                    if (Pt != 0)
                      if (e(3 <= Pt), ce.L == 1)
                        0 < zt && Ee(Gt, A3, we, Pt + 4), pe.La && M0(Gt, A3, we, Pt), 0 < c4 && te(Gt, A3, we, Pt + 4), pe.La && x2(Gt, A3, we, Pt);
                      else {
                        var k0 = ce.B, j6 = ce.qa, X5 = ce.ra + 8 * Ze * k0 + 8 * zt, o6 = ce.Ha, ce = ce.Ia + 8 * Ze * k0 + 8 * zt;
                        Ze = pe.ld, 0 < zt && (Y2(Gt, A3, we, Pt + 4, A4, Ze), t6(j6, X5, o6, ce, k0, Pt + 4, A4, Ze)), pe.La && (Tt(Gt, A3, we, Pt, A4, Ze), $3(j6, X5, o6, ce, k0, Pt, A4, Ze)), 0 < c4 && (z3(Gt, A3, we, Pt + 4, A4, Ze), x5(j6, X5, o6, ce, k0, Pt + 4, A4, Ze)), pe.La && (ke(Gt, A3, we, Pt, A4, Ze), z0(j6, X5, o6, ce, k0, Pt, A4, Ze));
                      }
                  }
                if (b1.ia && alert("todo:DitherRow"), S1.put != null) {
                  if (h3 = 16 * se, se = 16 * (se + 1), le ? (S1.y = b1.sa, S1.O = b1.ta + ve, S1.f = b1.qa, S1.N = b1.ra + Nt, S1.ea = b1.Ha, S1.W = b1.Ia + Nt) : (h3 -= a3, S1.y = o2, S1.O = k2, S1.f = L2, S1.N = $1, S1.ea = Q3, S1.W = ie), x3 || (se -= a3), se > S1.o && (se = S1.o), S1.F = null, S1.J = null, b1.Fa != null && 0 < b1.Fa.length && h3 < se && (S1.J = ki(b1, S1, h3, se - h3), S1.F = b1.mb, S1.F == null && S1.F.length == 0)) {
                    j1 = nt(b1, 3, "Could not decode alpha data.");
                    break e;
                  }
                  h3 < S1.j && (a3 = S1.j - h3, h3 = S1.j, e(!(1 & a3)), S1.O += b1.R * a3, S1.N += b1.B * (a3 >> 1), S1.W += b1.B * (a3 >> 1), S1.F != null && (S1.J += S1.width * a3)), h3 < se && (S1.O += S1.v, S1.N += S1.v >> 1, S1.W += S1.v >> 1, S1.F != null && (S1.J += S1.v), S1.ka = h3 - S1.j, S1.U = S1.va - S1.v, S1.T = se - h3, j1 = S1.put(S1));
                }
                V1 + 1 != b1.Ic || x3 || (i(b1.sa, b1.ta - Q1, o2, k2 + 16 * b1.R, Q1), i(b1.qa, b1.ra - C2, L2, $1 + 8 * b1.B, C2), i(b1.Ha, b1.Ia - C2, Q3, ie + 8 * b1.B, C2));
              }
            if (!j1)
              return nt(k1, 6, "Output aborted.");
          }
          return 1;
        }(g, w)), w.bc != null && w.bc(w), E &= 1;
      }
      return E ? (g.cb = 0, E) : 0;
    }
    function Dt(g, w, E, B, W) {
      W = g[w + E + 32 * B] + (W >> 3), g[w + E + 32 * B] = -256 & W ? 0 > W ? 0 : 255 : W;
    }
    function W0(g, w, E, B, W, Z) {
      Dt(g, w, 0, E, B + W), Dt(g, w, 1, E, B + Z), Dt(g, w, 2, E, B - Z), Dt(g, w, 3, E, B - W);
    }
    function S4(g) {
      return (20091 * g >> 16) + g;
    }
    function I6(g, w, E, B) {
      var W, Z = 0, t1 = l(16);
      for (W = 0; 4 > W; ++W) {
        var r1 = g[w + 0] + g[w + 8], o1 = g[w + 0] - g[w + 8], d1 = (35468 * g[w + 4] >> 16) - S4(g[w + 12]), L1 = S4(g[w + 4]) + (35468 * g[w + 12] >> 16);
        t1[Z + 0] = r1 + L1, t1[Z + 1] = o1 + d1, t1[Z + 2] = o1 - d1, t1[Z + 3] = r1 - L1, Z += 4, w++;
      }
      for (W = Z = 0; 4 > W; ++W)
        r1 = (g = t1[Z + 0] + 4) + t1[Z + 8], o1 = g - t1[Z + 8], d1 = (35468 * t1[Z + 4] >> 16) - S4(t1[Z + 12]), Dt(E, B, 0, 0, r1 + (L1 = S4(t1[Z + 4]) + (35468 * t1[Z + 12] >> 16))), Dt(E, B, 1, 0, o1 + d1), Dt(E, B, 2, 0, o1 - d1), Dt(E, B, 3, 0, r1 - L1), Z++, B += 32;
    }
    function kn(g, w, E, B) {
      var W = g[w + 0] + 4, Z = 35468 * g[w + 4] >> 16, t1 = S4(g[w + 4]), r1 = 35468 * g[w + 1] >> 16;
      W0(E, B, 0, W + t1, g = S4(g[w + 1]), r1), W0(E, B, 1, W + Z, g, r1), W0(E, B, 2, W - Z, g, r1), W0(E, B, 3, W - t1, g, r1);
    }
    function O6(g, w, E, B, W) {
      I6(g, w, E, B), W && I6(g, w + 16, E, B + 4);
    }
    function R8(g, w, E, B) {
      m1(g, w + 0, E, B, 1), m1(g, w + 32, E, B + 128, 1);
    }
    function qi(g, w, E, B) {
      var W;
      for (g = g[w + 0] + 4, W = 0; 4 > W; ++W)
        for (w = 0; 4 > w; ++w)
          Dt(E, B, w, W, g);
    }
    function Y0(g, w, E, B) {
      g[w + 0] && s2(g, w + 0, E, B), g[w + 16] && s2(g, w + 16, E, B + 4), g[w + 32] && s2(g, w + 32, E, B + 128), g[w + 48] && s2(g, w + 48, E, B + 128 + 4);
    }
    function N6(g, w, E, B) {
      var W, Z = l(16);
      for (W = 0; 4 > W; ++W) {
        var t1 = g[w + 0 + W] + g[w + 12 + W], r1 = g[w + 4 + W] + g[w + 8 + W], o1 = g[w + 4 + W] - g[w + 8 + W], d1 = g[w + 0 + W] - g[w + 12 + W];
        Z[0 + W] = t1 + r1, Z[8 + W] = t1 - r1, Z[4 + W] = d1 + o1, Z[12 + W] = d1 - o1;
      }
      for (W = 0; 4 > W; ++W)
        t1 = (g = Z[0 + 4 * W] + 3) + Z[3 + 4 * W], r1 = Z[1 + 4 * W] + Z[2 + 4 * W], o1 = Z[1 + 4 * W] - Z[2 + 4 * W], d1 = g - Z[3 + 4 * W], E[B + 0] = t1 + r1 >> 3, E[B + 16] = d1 + o1 >> 3, E[B + 32] = t1 - r1 >> 3, E[B + 48] = d1 - o1 >> 3, B += 64;
    }
    function p4(g, w, E) {
      var B, W = w - 32, Z = m4, t1 = 255 - g[W - 1];
      for (B = 0; B < E; ++B) {
        var r1, o1 = Z, d1 = t1 + g[w - 1];
        for (r1 = 0; r1 < E; ++r1)
          g[w + r1] = o1[d1 + g[W + r1]];
        w += 32;
      }
    }
    function wi(g, w) {
      p4(g, w, 4);
    }
    function zi(g, w) {
      p4(g, w, 8);
    }
    function Zs(g, w) {
      p4(g, w, 16);
    }
    function z5(g, w) {
      var E;
      for (E = 0; 16 > E; ++E)
        i(g, w + 32 * E, g, w - 32, 16);
    }
    function X0(g, w) {
      var E;
      for (E = 16; 0 < E; --E)
        s(g, w, g[w - 1], 16), w += 32;
    }
    function K0(g, w, E) {
      var B;
      for (B = 0; 16 > B; ++B)
        s(w, E + 32 * B, g, 16);
    }
    function En(g, w) {
      var E, B = 16;
      for (E = 0; 16 > E; ++E)
        B += g[w - 1 + 32 * E] + g[w + E - 32];
      K0(B >> 5, g, w);
    }
    function n4(g, w) {
      var E, B = 8;
      for (E = 0; 16 > E; ++E)
        B += g[w - 1 + 32 * E];
      K0(B >> 4, g, w);
    }
    function Js(g, w) {
      var E, B = 8;
      for (E = 0; 16 > E; ++E)
        B += g[w + E - 32];
      K0(B >> 4, g, w);
    }
    function H8(g, w) {
      K0(128, g, w);
    }
    function f3(g, w, E) {
      return g + 2 * w + E + 2 >> 2;
    }
    function Qs(g, w) {
      var E, B = w - 32;
      for (B = new Uint8Array([f3(g[B - 1], g[B + 0], g[B + 1]), f3(g[B + 0], g[B + 1], g[B + 2]), f3(g[B + 1], g[B + 2], g[B + 3]), f3(g[B + 2], g[B + 3], g[B + 4])]), E = 0; 4 > E; ++E)
        i(g, w + 32 * E, B, 0, B.length);
    }
    function el(g, w) {
      var E = g[w - 1], B = g[w - 1 + 32], W = g[w - 1 + 64], Z = g[w - 1 + 96];
      n2(g, w + 0, 16843009 * f3(g[w - 1 - 32], E, B)), n2(g, w + 32, 16843009 * f3(E, B, W)), n2(g, w + 64, 16843009 * f3(B, W, Z)), n2(g, w + 96, 16843009 * f3(W, Z, Z));
    }
    function D5(g, w) {
      var E, B = 4;
      for (E = 0; 4 > E; ++E)
        B += g[w + E - 32] + g[w - 1 + 32 * E];
      for (B >>= 3, E = 0; 4 > E; ++E)
        s(g, w + 32 * E, B, 4);
    }
    function D8(g, w) {
      var E = g[w - 1 + 0], B = g[w - 1 + 32], W = g[w - 1 + 64], Z = g[w - 1 - 32], t1 = g[w + 0 - 32], r1 = g[w + 1 - 32], o1 = g[w + 2 - 32], d1 = g[w + 3 - 32];
      g[w + 0 + 96] = f3(B, W, g[w - 1 + 96]), g[w + 1 + 96] = g[w + 0 + 64] = f3(E, B, W), g[w + 2 + 96] = g[w + 1 + 64] = g[w + 0 + 32] = f3(Z, E, B), g[w + 3 + 96] = g[w + 2 + 64] = g[w + 1 + 32] = g[w + 0 + 0] = f3(t1, Z, E), g[w + 3 + 64] = g[w + 2 + 32] = g[w + 1 + 0] = f3(r1, t1, Z), g[w + 3 + 32] = g[w + 2 + 0] = f3(o1, r1, t1), g[w + 3 + 0] = f3(d1, o1, r1);
    }
    function Z0(g, w) {
      var E = g[w + 1 - 32], B = g[w + 2 - 32], W = g[w + 3 - 32], Z = g[w + 4 - 32], t1 = g[w + 5 - 32], r1 = g[w + 6 - 32], o1 = g[w + 7 - 32];
      g[w + 0 + 0] = f3(g[w + 0 - 32], E, B), g[w + 1 + 0] = g[w + 0 + 32] = f3(E, B, W), g[w + 2 + 0] = g[w + 1 + 32] = g[w + 0 + 64] = f3(B, W, Z), g[w + 3 + 0] = g[w + 2 + 32] = g[w + 1 + 64] = g[w + 0 + 96] = f3(W, Z, t1), g[w + 3 + 32] = g[w + 2 + 64] = g[w + 1 + 96] = f3(Z, t1, r1), g[w + 3 + 64] = g[w + 2 + 96] = f3(t1, r1, o1), g[w + 3 + 96] = f3(r1, o1, o1);
    }
    function An(g, w) {
      var E = g[w - 1 + 0], B = g[w - 1 + 32], W = g[w - 1 + 64], Z = g[w - 1 - 32], t1 = g[w + 0 - 32], r1 = g[w + 1 - 32], o1 = g[w + 2 - 32], d1 = g[w + 3 - 32];
      g[w + 0 + 0] = g[w + 1 + 64] = Z + t1 + 1 >> 1, g[w + 1 + 0] = g[w + 2 + 64] = t1 + r1 + 1 >> 1, g[w + 2 + 0] = g[w + 3 + 64] = r1 + o1 + 1 >> 1, g[w + 3 + 0] = o1 + d1 + 1 >> 1, g[w + 0 + 96] = f3(W, B, E), g[w + 0 + 64] = f3(B, E, Z), g[w + 0 + 32] = g[w + 1 + 96] = f3(E, Z, t1), g[w + 1 + 32] = g[w + 2 + 96] = f3(Z, t1, r1), g[w + 2 + 32] = g[w + 3 + 96] = f3(t1, r1, o1), g[w + 3 + 32] = f3(r1, o1, d1);
    }
    function Mi(g, w) {
      var E = g[w + 0 - 32], B = g[w + 1 - 32], W = g[w + 2 - 32], Z = g[w + 3 - 32], t1 = g[w + 4 - 32], r1 = g[w + 5 - 32], o1 = g[w + 6 - 32], d1 = g[w + 7 - 32];
      g[w + 0 + 0] = E + B + 1 >> 1, g[w + 1 + 0] = g[w + 0 + 64] = B + W + 1 >> 1, g[w + 2 + 0] = g[w + 1 + 64] = W + Z + 1 >> 1, g[w + 3 + 0] = g[w + 2 + 64] = Z + t1 + 1 >> 1, g[w + 0 + 32] = f3(E, B, W), g[w + 1 + 32] = g[w + 0 + 96] = f3(B, W, Z), g[w + 2 + 32] = g[w + 1 + 96] = f3(W, Z, t1), g[w + 3 + 32] = g[w + 2 + 96] = f3(Z, t1, r1), g[w + 3 + 64] = f3(t1, r1, o1), g[w + 3 + 96] = f3(r1, o1, d1);
    }
    function tl(g, w) {
      var E = g[w - 1 + 0], B = g[w - 1 + 32], W = g[w - 1 + 64], Z = g[w - 1 + 96];
      g[w + 0 + 0] = E + B + 1 >> 1, g[w + 2 + 0] = g[w + 0 + 32] = B + W + 1 >> 1, g[w + 2 + 32] = g[w + 0 + 64] = W + Z + 1 >> 1, g[w + 1 + 0] = f3(E, B, W), g[w + 3 + 0] = g[w + 1 + 32] = f3(B, W, Z), g[w + 3 + 32] = g[w + 1 + 64] = f3(W, Z, Z), g[w + 3 + 64] = g[w + 2 + 64] = g[w + 0 + 96] = g[w + 1 + 96] = g[w + 2 + 96] = g[w + 3 + 96] = Z;
    }
    function nl(g, w) {
      var E = g[w - 1 + 0], B = g[w - 1 + 32], W = g[w - 1 + 64], Z = g[w - 1 + 96], t1 = g[w - 1 - 32], r1 = g[w + 0 - 32], o1 = g[w + 1 - 32], d1 = g[w + 2 - 32];
      g[w + 0 + 0] = g[w + 2 + 32] = E + t1 + 1 >> 1, g[w + 0 + 32] = g[w + 2 + 64] = B + E + 1 >> 1, g[w + 0 + 64] = g[w + 2 + 96] = W + B + 1 >> 1, g[w + 0 + 96] = Z + W + 1 >> 1, g[w + 3 + 0] = f3(r1, o1, d1), g[w + 2 + 0] = f3(t1, r1, o1), g[w + 1 + 0] = g[w + 3 + 32] = f3(E, t1, r1), g[w + 1 + 32] = g[w + 3 + 64] = f3(B, E, t1), g[w + 1 + 64] = g[w + 3 + 96] = f3(W, B, E), g[w + 1 + 96] = f3(Z, W, B);
    }
    function il(g, w) {
      var E;
      for (E = 0; 8 > E; ++E)
        i(g, w + 32 * E, g, w - 32, 8);
    }
    function e3(g, w) {
      var E;
      for (E = 0; 8 > E; ++E)
        s(g, w, g[w - 1], 8), w += 32;
    }
    function X2(g, w, E) {
      var B;
      for (B = 0; 8 > B; ++B)
        s(w, E + 32 * B, g, 8);
    }
    function J0(g, w) {
      var E, B = 8;
      for (E = 0; 8 > E; ++E)
        B += g[w + E - 32] + g[w - 1 + 32 * E];
      X2(B >> 4, g, w);
    }
    function sl(g, w) {
      var E, B = 4;
      for (E = 0; 8 > E; ++E)
        B += g[w + E - 32];
      X2(B >> 3, g, w);
    }
    function P6(g, w) {
      var E, B = 4;
      for (E = 0; 8 > E; ++E)
        B += g[w - 1 + 32 * E];
      X2(B >> 3, g, w);
    }
    function bi(g, w) {
      X2(128, g, w);
    }
    function Fn(g, w, E) {
      var B = g[w - E], W = g[w + 0], Z = 3 * (W - B) + b0[1020 + g[w - 2 * E] - g[w + E]], t1 = Bn[112 + (Z + 4 >> 3)];
      g[w - E] = m4[255 + B + Bn[112 + (Z + 3 >> 3)]], g[w + 0] = m4[255 + W - t1];
    }
    function $8(g, w, E, B) {
      var W = g[w + 0], Z = g[w + E];
      return It[255 + g[w - 2 * E] - g[w - E]] > B || It[255 + Z - W] > B;
    }
    function Tn(g, w, E, B) {
      return 4 * It[255 + g[w - E] - g[w + 0]] + It[255 + g[w - 2 * E] - g[w + E]] <= B;
    }
    function U8(g, w, E, B, W) {
      var Z = g[w - 3 * E], t1 = g[w - 2 * E], r1 = g[w - E], o1 = g[w + 0], d1 = g[w + E], L1 = g[w + 2 * E], I1 = g[w + 3 * E];
      return 4 * It[255 + r1 - o1] + It[255 + t1 - d1] > B ? 0 : It[255 + g[w - 4 * E] - Z] <= W && It[255 + Z - t1] <= W && It[255 + t1 - r1] <= W && It[255 + I1 - L1] <= W && It[255 + L1 - d1] <= W && It[255 + d1 - o1] <= W;
    }
    function D3(g, w, E, B) {
      var W = 2 * B + 1;
      for (B = 0; 16 > B; ++B)
        Tn(g, w + B, E, W) && Fn(g, w + B, E);
    }
    function P4(g, w, E, B) {
      var W = 2 * B + 1;
      for (B = 0; 16 > B; ++B)
        Tn(g, w + B * E, 1, W) && Fn(g, w + B * E, 1);
    }
    function qt(g, w, E, B) {
      var W;
      for (W = 3; 0 < W; --W)
        D3(g, w += 4 * E, E, B);
    }
    function Li(g, w, E, B) {
      var W;
      for (W = 3; 0 < W; --W)
        P4(g, w += 4, E, B);
    }
    function J4(g, w, E, B, W, Z, t1, r1) {
      for (Z = 2 * Z + 1; 0 < W--; ) {
        if (U8(g, w, E, Z, t1))
          if ($8(g, w, E, r1))
            Fn(g, w, E);
          else {
            var o1 = g, d1 = w, L1 = E, I1 = o1[d1 - 2 * L1], O1 = o1[d1 - L1], k1 = o1[d1 + 0], G1 = o1[d1 + L1], V1 = o1[d1 + 2 * L1], b1 = 27 * (j1 = b0[1020 + 3 * (k1 - O1) + b0[1020 + I1 - G1]]) + 63 >> 7, S1 = 18 * j1 + 63 >> 7, j1 = 9 * j1 + 63 >> 7;
            o1[d1 - 3 * L1] = m4[255 + o1[d1 - 3 * L1] + j1], o1[d1 - 2 * L1] = m4[255 + I1 + S1], o1[d1 - L1] = m4[255 + O1 + b1], o1[d1 + 0] = m4[255 + k1 - b1], o1[d1 + L1] = m4[255 + G1 - S1], o1[d1 + 2 * L1] = m4[255 + V1 - j1];
          }
        w += B;
      }
    }
    function J3(g, w, E, B, W, Z, t1, r1) {
      for (Z = 2 * Z + 1; 0 < W--; ) {
        if (U8(g, w, E, Z, t1))
          if ($8(g, w, E, r1))
            Fn(g, w, E);
          else {
            var o1 = g, d1 = w, L1 = E, I1 = o1[d1 - L1], O1 = o1[d1 + 0], k1 = o1[d1 + L1], G1 = Bn[112 + ((V1 = 3 * (O1 - I1)) + 4 >> 3)], V1 = Bn[112 + (V1 + 3 >> 3)], b1 = G1 + 1 >> 1;
            o1[d1 - 2 * L1] = m4[255 + o1[d1 - 2 * L1] + b1], o1[d1 - L1] = m4[255 + I1 + V1], o1[d1 + 0] = m4[255 + O1 - G1], o1[d1 + L1] = m4[255 + k1 - b1];
          }
        w += B;
      }
    }
    function B6(g, w, E, B, W, Z) {
      J4(g, w, E, 1, 16, B, W, Z);
    }
    function y0(g, w, E, B, W, Z) {
      J4(g, w, 1, E, 16, B, W, Z);
    }
    function xi(g, w, E, B, W, Z) {
      var t1;
      for (t1 = 3; 0 < t1; --t1)
        J3(g, w += 4 * E, E, 1, 16, B, W, Z);
    }
    function Q0(g, w, E, B, W, Z) {
      var t1;
      for (t1 = 3; 0 < t1; --t1)
        J3(g, w += 4, 1, E, 16, B, W, Z);
    }
    function Si(g, w, E, B, W, Z, t1, r1) {
      J4(g, w, W, 1, 8, Z, t1, r1), J4(E, B, W, 1, 8, Z, t1, r1);
    }
    function V6(g, w, E, B, W, Z, t1, r1) {
      J4(g, w, 1, W, 8, Z, t1, r1), J4(E, B, 1, W, 8, Z, t1, r1);
    }
    function fe(g, w, E, B, W, Z, t1, r1) {
      J3(g, w + 4 * W, W, 1, 8, Z, t1, r1), J3(E, B + 4 * W, W, 1, 8, Z, t1, r1);
    }
    function j8(g, w, E, B, W, Z, t1, r1) {
      J3(g, w + 4, 1, W, 8, Z, t1, r1), J3(E, B + 4, 1, W, 8, Z, t1, r1);
    }
    function qe() {
      this.ba = new G3(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new _e(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function Ci() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function R6() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function At() {
      this.ua = 0, this.Wa = new p1(), this.vb = new p1(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new j(), this.yc = new O();
    }
    function _0() {
      this.xb = this.a = 0, this.l = new xn(), this.ca = new G3(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new $(), this.Pb = 0, this.wd = new $(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new At(), this.ab = 0, this.gc = a(4, R6), this.Oc = 0;
    }
    function $5() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new xn(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function t3(g, w, E, B, W, Z, t1) {
      for (g = g == null ? 0 : g[w + 0], w = 0; w < t1; ++w)
        W[Z + w] = g + E[B + w] & 255, g = W[Z + w];
    }
    function xt(g, w, E, B, W, Z, t1) {
      var r1;
      if (g == null)
        t3(null, null, E, B, W, Z, t1);
      else
        for (r1 = 0; r1 < t1; ++r1)
          W[Z + r1] = g[w + r1] + E[B + r1] & 255;
    }
    function Q4(g, w, E, B, W, Z, t1) {
      if (g == null)
        t3(null, null, E, B, W, Z, t1);
      else {
        var r1, o1 = g[w + 0], d1 = o1, L1 = o1;
        for (r1 = 0; r1 < t1; ++r1)
          d1 = L1 + (o1 = g[w + r1]) - d1, L1 = E[B + r1] + (-256 & d1 ? 0 > d1 ? 0 : 255 : d1) & 255, d1 = o1, W[Z + r1] = L1;
      }
    }
    function ki(g, w, E, B) {
      var W = w.width, Z = w.o;
      if (e(g != null && w != null), 0 > E || 0 >= B || E + B > Z)
        return null;
      if (!g.Cc) {
        if (g.ga == null) {
          var t1;
          if (g.ga = new $5(), (t1 = g.ga == null) || (t1 = w.width * w.o, e(g.Gb.length == 0), g.Gb = l(t1), g.Uc = 0, g.Gb == null ? t1 = 0 : (g.mb = g.Gb, g.nb = g.Uc, g.rc = null, t1 = 1), t1 = !t1), !t1) {
            t1 = g.ga;
            var r1 = g.Fa, o1 = g.P, d1 = g.qc, L1 = g.mb, I1 = g.nb, O1 = o1 + 1, k1 = d1 - 1, G1 = t1.l;
            if (e(r1 != null && L1 != null && w != null), a4[0] = null, a4[1] = t3, a4[2] = xt, a4[3] = Q4, t1.ca = L1, t1.tb = I1, t1.c = w.width, t1.i = w.height, e(0 < t1.c && 0 < t1.i), 1 >= d1)
              w = 0;
            else if (t1.$a = r1[o1 + 0] >> 0 & 3, t1.Z = r1[o1 + 0] >> 2 & 3, t1.Lc = r1[o1 + 0] >> 4 & 3, o1 = r1[o1 + 0] >> 6 & 3, 0 > t1.$a || 1 < t1.$a || 4 <= t1.Z || 1 < t1.Lc || o1)
              w = 0;
            else if (G1.put = tt, G1.ac = Ce, G1.bc = ut, G1.ma = t1, G1.width = w.width, G1.height = w.height, G1.Da = w.Da, G1.v = w.v, G1.va = w.va, G1.j = w.j, G1.o = w.o, t1.$a)
              e: {
                e(t1.$a == 1), w = K4();
                t:
                  for (; ; ) {
                    if (w == null) {
                      w = 0;
                      break e;
                    }
                    if (e(t1 != null), t1.mc = w, w.c = t1.c, w.i = t1.i, w.l = t1.l, w.l.ma = t1, w.l.width = t1.c, w.l.height = t1.i, w.a = 0, c1(w.m, r1, O1, k1), !H5(t1.c, t1.i, 1, w, null) || (w.ab == 1 && w.gc[0].hc == 3 && m0(w.s) ? (t1.ic = 1, r1 = w.c * w.i, w.Ta = null, w.Ua = 0, w.V = l(r1), w.Ba = 0, w.V == null ? (w.a = 1, w = 0) : w = 1) : (t1.ic = 0, w = F6(w, t1.c)), !w))
                      break t;
                    w = 1;
                    break e;
                  }
                t1.mc = null, w = 0;
              }
            else
              w = k1 >= t1.c * t1.i;
            t1 = !w;
          }
          if (t1)
            return null;
          g.ga.Lc != 1 ? g.Ga = 0 : B = Z - E;
        }
        e(g.ga != null), e(E + B <= Z);
        e: {
          if (w = (r1 = g.ga).c, Z = r1.l.o, r1.$a == 0) {
            if (O1 = g.rc, k1 = g.Vc, G1 = g.Fa, o1 = g.P + 1 + E * w, d1 = g.mb, L1 = g.nb + E * w, e(o1 <= g.P + g.qc), r1.Z != 0)
              for (e(a4[r1.Z] != null), t1 = 0; t1 < B; ++t1)
                a4[r1.Z](O1, k1, G1, o1, d1, L1, w), O1 = d1, k1 = L1, L1 += w, o1 += w;
            else
              for (t1 = 0; t1 < B; ++t1)
                i(d1, L1, G1, o1, w), O1 = d1, k1 = L1, L1 += w, o1 += w;
            g.rc = O1, g.Vc = k1;
          } else {
            if (e(r1.mc != null), w = E + B, e((t1 = r1.mc) != null), e(w <= t1.i), t1.C >= w)
              w = 1;
            else if (r1.ic || F1(), r1.ic) {
              r1 = t1.V, O1 = t1.Ba, k1 = t1.c;
              var V1 = t1.i, b1 = (G1 = 1, o1 = t1.$ / k1, d1 = t1.$ % k1, L1 = t1.m, I1 = t1.s, t1.$), S1 = k1 * V1, j1 = k1 * w, Q1 = I1.wc, $1 = b1 < j1 ? oe(I1, d1, o1) : null;
              e(b1 <= S1), e(w <= V1), e(m0(I1));
              t:
                for (; ; ) {
                  for (; !L1.h && b1 < j1; ) {
                    if (d1 & Q1 || ($1 = oe(I1, d1, o1)), e($1 != null), w1(L1), 256 > (V1 = L3($1.G[0], $1.H[0], L1)))
                      r1[O1 + b1] = V1, ++b1, ++d1 >= k1 && (d1 = 0, ++o1 <= w && !(o1 % 16) && q5(t1, o1));
                    else {
                      if (!(280 > V1)) {
                        G1 = 0;
                        break t;
                      }
                      V1 = Re(V1 - 256, L1);
                      var C2, o2 = L3($1.G[4], $1.H[4], L1);
                      if (w1(L1), !(b1 >= (o2 = _t(k1, o2 = Re(o2, L1))) && S1 - b1 >= V1)) {
                        G1 = 0;
                        break t;
                      }
                      for (C2 = 0; C2 < V1; ++C2)
                        r1[O1 + b1 + C2] = r1[O1 + b1 + C2 - o2];
                      for (b1 += V1, d1 += V1; d1 >= k1; )
                        d1 -= k1, ++o1 <= w && !(o1 % 16) && q5(t1, o1);
                      b1 < j1 && d1 & Q1 && ($1 = oe(I1, d1, o1));
                    }
                    e(L1.h == n1(L1));
                  }
                  q5(t1, o1 > w ? w : o1);
                  break t;
                }
              !G1 || L1.h && b1 < S1 ? (G1 = 0, t1.a = L1.h ? 5 : 3) : t1.$ = b1, w = G1;
            } else
              w = w5(t1, t1.V, t1.Ba, t1.c, t1.i, w, zn);
            if (!w) {
              B = 0;
              break e;
            }
          }
          E + B >= Z && (g.Cc = 1), B = 1;
        }
        if (!B)
          return null;
        if (g.Cc && ((B = g.ga) != null && (B.mc = null), g.ga = null, 0 < g.Ga))
          return alert("todo:WebPDequantizeLevels"), null;
      }
      return g.nb + E * W;
    }
    function S(g, w, E, B, W, Z) {
      for (; 0 < W--; ) {
        var t1, r1 = g, o1 = w + (E ? 1 : 0), d1 = g, L1 = w + (E ? 0 : 3);
        for (t1 = 0; t1 < B; ++t1) {
          var I1 = d1[L1 + 4 * t1];
          I1 != 255 && (I1 *= 32897, r1[o1 + 4 * t1 + 0] = r1[o1 + 4 * t1 + 0] * I1 >> 23, r1[o1 + 4 * t1 + 1] = r1[o1 + 4 * t1 + 1] * I1 >> 23, r1[o1 + 4 * t1 + 2] = r1[o1 + 4 * t1 + 2] * I1 >> 23);
        }
        w += Z;
      }
    }
    function X(g, w, E, B, W) {
      for (; 0 < B--; ) {
        var Z;
        for (Z = 0; Z < E; ++Z) {
          var t1 = g[w + 2 * Z + 0], r1 = 15 & (d1 = g[w + 2 * Z + 1]), o1 = 4369 * r1, d1 = (240 & d1 | d1 >> 4) * o1 >> 16;
          g[w + 2 * Z + 0] = (240 & t1 | t1 >> 4) * o1 >> 16 & 240 | (15 & t1 | t1 << 4) * o1 >> 16 >> 4 & 15, g[w + 2 * Z + 1] = 240 & d1 | r1;
        }
        w += W;
      }
    }
    function v1(g, w, E, B, W, Z, t1, r1) {
      var o1, d1, L1 = 255;
      for (d1 = 0; d1 < W; ++d1) {
        for (o1 = 0; o1 < B; ++o1) {
          var I1 = g[w + o1];
          Z[t1 + 4 * o1] = I1, L1 &= I1;
        }
        w += E, t1 += r1;
      }
      return L1 != 255;
    }
    function z1(g, w, E, B, W) {
      var Z;
      for (Z = 0; Z < W; ++Z)
        E[B + Z] = g[w + Z] >> 8;
    }
    function F1() {
      G5 = S, n5 = X, W8 = v1, Fr = z1;
    }
    function H1(g, w, E) {
      V[g] = function(B, W, Z, t1, r1, o1, d1, L1, I1, O1, k1, G1, V1, b1, S1, j1, Q1) {
        var $1, C2 = Q1 - 1 >> 1, o2 = r1[o1 + 0] | d1[L1 + 0] << 16, k2 = I1[O1 + 0] | k1[G1 + 0] << 16;
        e(B != null);
        var L2 = 3 * o2 + k2 + 131074 >> 2;
        for (w(B[W + 0], 255 & L2, L2 >> 16, V1, b1), Z != null && (L2 = 3 * k2 + o2 + 131074 >> 2, w(Z[t1 + 0], 255 & L2, L2 >> 16, S1, j1)), $1 = 1; $1 <= C2; ++$1) {
          var Q3 = r1[o1 + $1] | d1[L1 + $1] << 16, ie = I1[O1 + $1] | k1[G1 + $1] << 16, x3 = o2 + Q3 + k2 + ie + 524296, a3 = x3 + 2 * (Q3 + k2) >> 3;
          L2 = a3 + o2 >> 1, o2 = (x3 = x3 + 2 * (o2 + ie) >> 3) + Q3 >> 1, w(B[W + 2 * $1 - 1], 255 & L2, L2 >> 16, V1, b1 + (2 * $1 - 1) * E), w(B[W + 2 * $1 - 0], 255 & o2, o2 >> 16, V1, b1 + (2 * $1 - 0) * E), Z != null && (L2 = x3 + k2 >> 1, o2 = a3 + ie >> 1, w(Z[t1 + 2 * $1 - 1], 255 & L2, L2 >> 16, S1, j1 + (2 * $1 - 1) * E), w(Z[t1 + 2 * $1 + 0], 255 & o2, o2 >> 16, S1, j1 + (2 * $1 + 0) * E)), o2 = Q3, k2 = ie;
        }
        1 & Q1 || (L2 = 3 * o2 + k2 + 131074 >> 2, w(B[W + Q1 - 1], 255 & L2, L2 >> 16, V1, b1 + (Q1 - 1) * E), Z != null && (L2 = 3 * k2 + o2 + 131074 >> 2, w(Z[t1 + Q1 - 1], 255 & L2, L2 >> 16, S1, j1 + (Q1 - 1) * E)));
      };
    }
    function J1() {
      E4[Vn] = A, E4[i5] = a6, E4[k4] = E5, E4[W5] = Ke, E4[X8] = A2, E4[ll] = Nr, E4[Ir] = L9, E4[L0] = a6, E4[x0] = Ke, E4[s6] = A2, E4[rl] = Nr;
    }
    function F2(g) {
      return g & ~x9 ? 0 > g ? 0 : 255 : g >> Pr;
    }
    function Z2(g, w) {
      return F2((19077 * g >> 8) + (26149 * w >> 8) - 14234);
    }
    function v3(g, w, E) {
      return F2((19077 * g >> 8) - (6419 * w >> 8) - (13320 * E >> 8) + 8708);
    }
    function y3(g, w) {
      return F2((19077 * g >> 8) + (33050 * w >> 8) - 17685);
    }
    function P3(g, w, E, B, W) {
      B[W + 0] = Z2(g, E), B[W + 1] = v3(g, w, E), B[W + 2] = y3(g, w);
    }
    function He(g, w, E, B, W) {
      B[W + 0] = y3(g, w), B[W + 1] = v3(g, w, E), B[W + 2] = Z2(g, E);
    }
    function ot(g, w, E, B, W) {
      var Z = v3(g, w, E);
      w = Z << 3 & 224 | y3(g, w) >> 3, B[W + 0] = 248 & Z2(g, E) | Z >> 5, B[W + 1] = w;
    }
    function Xe(g, w, E, B, W) {
      var Z = 240 & y3(g, w) | 15;
      B[W + 0] = 240 & Z2(g, E) | v3(g, w, E) >> 4, B[W + 1] = Z;
    }
    function wt(g, w, E, B, W) {
      B[W + 0] = 255, P3(g, w, E, B, W + 1);
    }
    function Ft(g, w, E, B, W) {
      He(g, w, E, B, W), B[W + 3] = 255;
    }
    function B4(g, w, E, B, W) {
      P3(g, w, E, B, W), B[W + 3] = 255;
    }
    function V3(g, w) {
      return 0 > g ? 0 : g > w ? w : g;
    }
    function V4(g, w, E) {
      V[g] = function(B, W, Z, t1, r1, o1, d1, L1, I1) {
        for (var O1 = L1 + (-2 & I1) * E; L1 != O1; )
          w(B[W + 0], Z[t1 + 0], r1[o1 + 0], d1, L1), w(B[W + 1], Z[t1 + 0], r1[o1 + 0], d1, L1 + E), W += 2, ++t1, ++o1, L1 += 2 * E;
        1 & I1 && w(B[W + 0], Z[t1 + 0], r1[o1 + 0], d1, L1);
      };
    }
    function e5(g, w, E) {
      return E == 0 ? g == 0 ? w == 0 ? 6 : 5 : w == 0 ? 4 : 0 : E;
    }
    function H6(g, w, E, B, W) {
      switch (g >>> 30) {
        case 3:
          m1(w, E, B, W, 0);
          break;
        case 2:
          u1(w, E, B, W);
          break;
        case 1:
          s2(w, E, B, W);
      }
    }
    function D6(g, w) {
      var E, B, W = w.M, Z = w.Nb, t1 = g.oc, r1 = g.pc + 40, o1 = g.oc, d1 = g.pc + 584, L1 = g.oc, I1 = g.pc + 600;
      for (E = 0; 16 > E; ++E)
        t1[r1 + 32 * E - 1] = 129;
      for (E = 0; 8 > E; ++E)
        o1[d1 + 32 * E - 1] = 129, L1[I1 + 32 * E - 1] = 129;
      for (0 < W ? t1[r1 - 1 - 32] = o1[d1 - 1 - 32] = L1[I1 - 1 - 32] = 129 : (s(t1, r1 - 32 - 1, 127, 21), s(o1, d1 - 32 - 1, 127, 9), s(L1, I1 - 32 - 1, 127, 9)), B = 0; B < g.za; ++B) {
        var O1 = w.ya[w.aa + B];
        if (0 < B) {
          for (E = -1; 16 > E; ++E)
            i(t1, r1 + 32 * E - 4, t1, r1 + 32 * E + 12, 4);
          for (E = -1; 8 > E; ++E)
            i(o1, d1 + 32 * E - 4, o1, d1 + 32 * E + 4, 4), i(L1, I1 + 32 * E - 4, L1, I1 + 32 * E + 4, 4);
        }
        var k1 = g.Gd, G1 = g.Hd + B, V1 = O1.ad, b1 = O1.Hc;
        if (0 < W && (i(t1, r1 - 32, k1[G1].y, 0, 16), i(o1, d1 - 32, k1[G1].f, 0, 8), i(L1, I1 - 32, k1[G1].ea, 0, 8)), O1.Za) {
          var S1 = t1, j1 = r1 - 32 + 16;
          for (0 < W && (B >= g.za - 1 ? s(S1, j1, k1[G1].y[15], 4) : i(S1, j1, k1[G1 + 1].y, 0, 4)), E = 0; 4 > E; E++)
            S1[j1 + 128 + E] = S1[j1 + 256 + E] = S1[j1 + 384 + E] = S1[j1 + 0 + E];
          for (E = 0; 16 > E; ++E, b1 <<= 2)
            S1 = t1, j1 = r1 + Ot[E], k5[O1.Ob[E]](S1, j1), H6(b1, V1, 16 * +E, S1, j1);
        } else if (S1 = e5(B, W, O1.Ob[0]), l6[S1](t1, r1), b1 != 0)
          for (E = 0; 16 > E; ++E, b1 <<= 2)
            H6(b1, V1, 16 * +E, t1, r1 + Ot[E]);
        for (E = O1.Gc, S1 = e5(B, W, O1.Dd), C0[S1](o1, d1), C0[S1](L1, I1), b1 = V1, S1 = o1, j1 = d1, 255 & (O1 = E >> 0) && (170 & O1 ? R1(b1, 256, S1, j1) : N2(b1, 256, S1, j1)), O1 = L1, b1 = I1, 255 & (E >>= 8) && (170 & E ? R1(V1, 320, O1, b1) : N2(V1, 320, O1, b1)), W < g.Ub - 1 && (i(k1[G1].y, 0, t1, r1 + 480, 16), i(k1[G1].f, 0, o1, d1 + 224, 8), i(k1[G1].ea, 0, L1, I1 + 224, 8)), E = 8 * Z * g.B, k1 = g.sa, G1 = g.ta + 16 * B + 16 * Z * g.R, V1 = g.qa, O1 = g.ra + 8 * B + E, b1 = g.Ha, S1 = g.Ia + 8 * B + E, E = 0; 16 > E; ++E)
          i(k1, G1 + E * g.R, t1, r1 + 32 * E, 16);
        for (E = 0; 8 > E; ++E)
          i(V1, O1 + E * g.B, o1, d1 + 32 * E, 8), i(b1, S1 + E * g.B, L1, I1 + 32 * E, 8);
      }
    }
    function In(g, w, E, B, W, Z, t1, r1, o1) {
      var d1 = [0], L1 = [0], I1 = 0, O1 = o1 != null ? o1.kd : 0, k1 = o1 ?? new Ci();
      if (g == null || 12 > E)
        return 7;
      k1.data = g, k1.w = w, k1.ha = E, w = [w], E = [E], k1.gb = [k1.gb];
      e: {
        var G1 = w, V1 = E, b1 = k1.gb;
        if (e(g != null), e(V1 != null), e(b1 != null), b1[0] = 0, 12 <= V1[0] && !n(g, G1[0], "RIFF")) {
          if (n(g, G1[0] + 8, "WEBP")) {
            b1 = 3;
            break e;
          }
          var S1 = d2(g, G1[0] + 4);
          if (12 > S1 || 4294967286 < S1) {
            b1 = 3;
            break e;
          }
          if (O1 && S1 > V1[0] - 8) {
            b1 = 7;
            break e;
          }
          b1[0] = S1, G1[0] += 12, V1[0] -= 12;
        }
        b1 = 0;
      }
      if (b1 != 0)
        return b1;
      for (S1 = 0 < k1.gb[0], E = E[0]; ; ) {
        e: {
          var j1 = g;
          V1 = w, b1 = E;
          var Q1 = d1, $1 = L1, C2 = G1 = [0];
          if ((L2 = I1 = [I1])[0] = 0, 8 > b1[0])
            b1 = 7;
          else {
            if (!n(j1, V1[0], "VP8X")) {
              if (d2(j1, V1[0] + 4) != 10) {
                b1 = 3;
                break e;
              }
              if (18 > b1[0]) {
                b1 = 7;
                break e;
              }
              var o2 = d2(j1, V1[0] + 8), k2 = 1 + a2(j1, V1[0] + 12);
              if (2147483648 <= k2 * (j1 = 1 + a2(j1, V1[0] + 15))) {
                b1 = 3;
                break e;
              }
              C2 != null && (C2[0] = o2), Q1 != null && (Q1[0] = k2), $1 != null && ($1[0] = j1), V1[0] += 18, b1[0] -= 18, L2[0] = 1;
            }
            b1 = 0;
          }
        }
        if (I1 = I1[0], G1 = G1[0], b1 != 0)
          return b1;
        if (V1 = !!(2 & G1), !S1 && I1)
          return 3;
        if (Z != null && (Z[0] = !!(16 & G1)), t1 != null && (t1[0] = V1), r1 != null && (r1[0] = 0), t1 = d1[0], G1 = L1[0], I1 && V1 && o1 == null) {
          b1 = 0;
          break;
        }
        if (4 > E) {
          b1 = 7;
          break;
        }
        if (S1 && I1 || !S1 && !I1 && !n(g, w[0], "ALPH")) {
          E = [E], k1.na = [k1.na], k1.P = [k1.P], k1.Sa = [k1.Sa];
          e: {
            o2 = g, b1 = w, S1 = E;
            var L2 = k1.gb;
            Q1 = k1.na, $1 = k1.P, C2 = k1.Sa, k2 = 22, e(o2 != null), e(S1 != null), j1 = b1[0];
            var Q3 = S1[0];
            for (e(Q1 != null), e(C2 != null), Q1[0] = null, $1[0] = null, C2[0] = 0; ; ) {
              if (b1[0] = j1, S1[0] = Q3, 8 > Q3) {
                b1 = 7;
                break e;
              }
              var ie = d2(o2, j1 + 4);
              if (4294967286 < ie) {
                b1 = 3;
                break e;
              }
              var x3 = 8 + ie + 1 & -2;
              if (k2 += x3, 0 < L2 && k2 > L2) {
                b1 = 3;
                break e;
              }
              if (!n(o2, j1, "VP8 ") || !n(o2, j1, "VP8L")) {
                b1 = 0;
                break e;
              }
              if (Q3[0] < x3) {
                b1 = 7;
                break e;
              }
              n(o2, j1, "ALPH") || (Q1[0] = o2, $1[0] = j1 + 8, C2[0] = ie), j1 += x3, Q3 -= x3;
            }
          }
          if (E = E[0], k1.na = k1.na[0], k1.P = k1.P[0], k1.Sa = k1.Sa[0], b1 != 0)
            break;
        }
        E = [E], k1.Ja = [k1.Ja], k1.xa = [k1.xa];
        e:
          if (L2 = g, b1 = w, S1 = E, Q1 = k1.gb[0], $1 = k1.Ja, C2 = k1.xa, o2 = b1[0], j1 = !n(L2, o2, "VP8 "), k2 = !n(L2, o2, "VP8L"), e(L2 != null), e(S1 != null), e($1 != null), e(C2 != null), 8 > S1[0])
            b1 = 7;
          else {
            if (j1 || k2) {
              if (L2 = d2(L2, o2 + 4), 12 <= Q1 && L2 > Q1 - 12) {
                b1 = 3;
                break e;
              }
              if (O1 && L2 > S1[0] - 8) {
                b1 = 7;
                break e;
              }
              $1[0] = L2, b1[0] += 8, S1[0] -= 8, C2[0] = k2;
            } else
              C2[0] = 5 <= S1[0] && L2[o2 + 0] == 47 && !(L2[o2 + 4] >> 5), $1[0] = S1[0];
            b1 = 0;
          }
        if (E = E[0], k1.Ja = k1.Ja[0], k1.xa = k1.xa[0], w = w[0], b1 != 0)
          break;
        if (4294967286 < k1.Ja)
          return 3;
        if (r1 == null || V1 || (r1[0] = k1.xa ? 2 : 1), t1 = [t1], G1 = [G1], k1.xa) {
          if (5 > E) {
            b1 = 7;
            break;
          }
          r1 = t1, O1 = G1, V1 = Z, g == null || 5 > E ? g = 0 : 5 <= E && g[w + 0] == 47 && !(g[w + 4] >> 5) ? (S1 = [0], L2 = [0], Q1 = [0], c1($1 = new $(), g, w, E), D2($1, S1, L2, Q1) ? (r1 != null && (r1[0] = S1[0]), O1 != null && (O1[0] = L2[0]), V1 != null && (V1[0] = Q1[0]), g = 1) : g = 0) : g = 0;
        } else {
          if (10 > E) {
            b1 = 7;
            break;
          }
          r1 = G1, g == null || 10 > E || !Sn(g, w + 3, E - 3) ? g = 0 : (O1 = g[w + 0] | g[w + 1] << 8 | g[w + 2] << 16, V1 = 16383 & (g[w + 7] << 8 | g[w + 6]), g = 16383 & (g[w + 9] << 8 | g[w + 8]), 1 & O1 || 3 < (O1 >> 1 & 7) || !(O1 >> 4 & 1) || O1 >> 5 >= k1.Ja || !V1 || !g ? g = 0 : (t1 && (t1[0] = V1), r1 && (r1[0] = g), g = 1));
        }
        if (!g || (t1 = t1[0], G1 = G1[0], I1 && (d1[0] != t1 || L1[0] != G1)))
          return 3;
        o1 != null && (o1[0] = k1, o1.offset = w - o1.w, e(4294967286 > w - o1.w), e(o1.offset == o1.ha - E));
        break;
      }
      return b1 == 0 || b1 == 7 && I1 && o1 == null ? (Z != null && (Z[0] |= k1.na != null && 0 < k1.na.length), B != null && (B[0] = t1), W != null && (W[0] = G1), 0) : b1;
    }
    function Ei(g, w, E) {
      var B = w.width, W = w.height, Z = 0, t1 = 0, r1 = B, o1 = W;
      if (w.Da = g != null && 0 < g.Da, w.Da && (r1 = g.cd, o1 = g.bd, Z = g.v, t1 = g.j, 11 > E || (Z &= -2, t1 &= -2), 0 > Z || 0 > t1 || 0 >= r1 || 0 >= o1 || Z + r1 > B || t1 + o1 > W))
        return 0;
      if (w.v = Z, w.j = t1, w.va = Z + r1, w.o = t1 + o1, w.U = r1, w.T = o1, w.da = g != null && 0 < g.da, w.da) {
        if (!_2(r1, o1, E = [g.ib], Z = [g.hb]))
          return 0;
        w.ib = E[0], w.hb = Z[0];
      }
      return w.ob = g != null && g.ob, w.Kb = g == null || !g.Sd, w.da && (w.ob = w.ib < 3 * B / 4 && w.hb < 3 * W / 4, w.Kb = 0), 1;
    }
    function Ai(g) {
      if (g == null)
        return 2;
      if (11 > g.S) {
        var w = g.f.RGBA;
        w.fb += (g.height - 1) * w.A, w.A = -w.A;
      } else
        w = g.f.kb, g = g.height, w.O += (g - 1) * w.fa, w.fa = -w.fa, w.N += (g - 1 >> 1) * w.Ab, w.Ab = -w.Ab, w.W += (g - 1 >> 1) * w.Db, w.Db = -w.Db, w.F != null && (w.J += (g - 1) * w.lb, w.lb = -w.lb);
      return 0;
    }
    function On(g, w, E, B) {
      if (B == null || 0 >= g || 0 >= w)
        return 2;
      if (E != null) {
        if (E.Da) {
          var W = E.cd, Z = E.bd, t1 = -2 & E.v, r1 = -2 & E.j;
          if (0 > t1 || 0 > r1 || 0 >= W || 0 >= Z || t1 + W > g || r1 + Z > w)
            return 2;
          g = W, w = Z;
        }
        if (E.da) {
          if (!_2(g, w, W = [E.ib], Z = [E.hb]))
            return 2;
          g = W[0], w = Z[0];
        }
      }
      B.width = g, B.height = w;
      e: {
        var o1 = B.width, d1 = B.height;
        if (g = B.S, 0 >= o1 || 0 >= d1 || !(g >= Vn && 13 > g))
          g = 2;
        else {
          if (0 >= B.Rd && B.sd == null) {
            t1 = Z = W = w = 0;
            var L1 = (r1 = o1 * Vr[g]) * d1;
            if (11 > g || (Z = (d1 + 1) / 2 * (w = (o1 + 1) / 2), g == 12 && (t1 = (W = o1) * d1)), (d1 = l(L1 + 2 * Z + t1)) == null) {
              g = 1;
              break e;
            }
            B.sd = d1, 11 > g ? ((o1 = B.f.RGBA).eb = d1, o1.fb = 0, o1.A = r1, o1.size = L1) : ((o1 = B.f.kb).y = d1, o1.O = 0, o1.fa = r1, o1.Fd = L1, o1.f = d1, o1.N = 0 + L1, o1.Ab = w, o1.Cd = Z, o1.ea = d1, o1.W = 0 + L1 + Z, o1.Db = w, o1.Ed = Z, g == 12 && (o1.F = d1, o1.J = 0 + L1 + 2 * Z), o1.Tc = t1, o1.lb = W);
          }
          if (w = 1, W = B.S, Z = B.width, t1 = B.height, W >= Vn && 13 > W)
            if (11 > W)
              g = B.f.RGBA, w &= (r1 = Math.abs(g.A)) * (t1 - 1) + Z <= g.size, w &= r1 >= Z * Vr[W], w &= g.eb != null;
            else {
              g = B.f.kb, r1 = (Z + 1) / 2, L1 = (t1 + 1) / 2, o1 = Math.abs(g.fa), d1 = Math.abs(g.Ab);
              var I1 = Math.abs(g.Db), O1 = Math.abs(g.lb), k1 = O1 * (t1 - 1) + Z;
              w &= o1 * (t1 - 1) + Z <= g.Fd, w &= d1 * (L1 - 1) + r1 <= g.Cd, w = (w &= I1 * (L1 - 1) + r1 <= g.Ed) & o1 >= Z & d1 >= r1 & I1 >= r1, w &= g.y != null, w &= g.f != null, w &= g.ea != null, W == 12 && (w &= O1 >= Z, w &= k1 <= g.Tc, w &= g.F != null);
            }
          else
            w = 0;
          g = w ? 0 : 2;
        }
      }
      return g != 0 || E != null && E.fd && (g = Ai(B)), g;
    }
    var C4 = 64, i4 = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], Nn = 24, Pn = 32, q0 = 8, s4 = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    e2("Predictor0", "PredictorAdd0"), V.Predictor0 = function() {
      return 4278190080;
    }, V.Predictor1 = function(g) {
      return g;
    }, V.Predictor2 = function(g, w, E) {
      return w[E + 0];
    }, V.Predictor3 = function(g, w, E) {
      return w[E + 1];
    }, V.Predictor4 = function(g, w, E) {
      return w[E - 1];
    }, V.Predictor5 = function(g, w, E) {
      return t2(t2(g, w[E + 1]), w[E + 0]);
    }, V.Predictor6 = function(g, w, E) {
      return t2(g, w[E - 1]);
    }, V.Predictor7 = function(g, w, E) {
      return t2(g, w[E + 0]);
    }, V.Predictor8 = function(g, w, E) {
      return t2(w[E - 1], w[E + 0]);
    }, V.Predictor9 = function(g, w, E) {
      return t2(w[E + 0], w[E + 1]);
    }, V.Predictor10 = function(g, w, E) {
      return t2(t2(g, w[E - 1]), t2(w[E + 0], w[E + 1]));
    }, V.Predictor11 = function(g, w, E) {
      var B = w[E + 0];
      return 0 >= E2(B >> 24 & 255, g >> 24 & 255, (w = w[E - 1]) >> 24 & 255) + E2(B >> 16 & 255, g >> 16 & 255, w >> 16 & 255) + E2(B >> 8 & 255, g >> 8 & 255, w >> 8 & 255) + E2(255 & B, 255 & g, 255 & w) ? B : g;
    }, V.Predictor12 = function(g, w, E) {
      var B = w[E + 0];
      return (S2((g >> 24 & 255) + (B >> 24 & 255) - ((w = w[E - 1]) >> 24 & 255)) << 24 | S2((g >> 16 & 255) + (B >> 16 & 255) - (w >> 16 & 255)) << 16 | S2((g >> 8 & 255) + (B >> 8 & 255) - (w >> 8 & 255)) << 8 | S2((255 & g) + (255 & B) - (255 & w))) >>> 0;
    }, V.Predictor13 = function(g, w, E) {
      var B = w[E - 1];
      return (W2((g = t2(g, w[E + 0])) >> 24 & 255, B >> 24 & 255) << 24 | W2(g >> 16 & 255, B >> 16 & 255) << 16 | W2(g >> 8 & 255, B >> 8 & 255) << 8 | W2(g >> 0 & 255, B >> 0 & 255)) >>> 0;
    };
    var $t = V.PredictorAdd0;
    V.PredictorAdd1 = o3, e2("Predictor2", "PredictorAdd2"), e2("Predictor3", "PredictorAdd3"), e2("Predictor4", "PredictorAdd4"), e2("Predictor5", "PredictorAdd5"), e2("Predictor6", "PredictorAdd6"), e2("Predictor7", "PredictorAdd7"), e2("Predictor8", "PredictorAdd8"), e2("Predictor9", "PredictorAdd9"), e2("Predictor10", "PredictorAdd10"), e2("Predictor11", "PredictorAdd11"), e2("Predictor12", "PredictorAdd12"), e2("Predictor13", "PredictorAdd13");
    var M5 = V.PredictorAdd2;
    u3("ColorIndexInverseTransform", "MapARGB", "32b", function(g) {
      return g >> 8 & 255;
    }, function(g) {
      return g;
    }), u3("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(g) {
      return g;
    }, function(g) {
      return g >> 8 & 255;
    });
    var G8, b5 = V.ColorIndexInverseTransform, Fi = V.MapARGB, R4 = V.VP8LColorIndexInverseTransformAlpha, it = V.MapAlpha, U5 = V.VP8LPredictorsAdd = [];
    U5.length = 16, (V.VP8LPredictors = []).length = 16, (V.VP8LPredictorsAdd_C = []).length = 16, (V.VP8LPredictors_C = []).length = 16;
    var t5, L5, e6, j5, w0, l4, e1, m1, u1, R1, s2, N2, z3, Y2, x5, t6, ke, Tt, z0, $3, te, Ee, x2, M0, G5, n5, W8, Fr, Tr = l(511), n6 = l(2041), r4 = l(225), i6 = l(767), Y8 = 0, b0 = n6, Bn = r4, m4 = i6, It = Tr, Vn = 0, i5 = 1, k4 = 2, W5 = 3, X8 = 4, ll = 5, Ir = 6, L0 = 7, x0 = 8, s6 = 9, rl = 10, al = [2, 3, 7], q9 = [3, 3, 11], Or = [280, 256, 256, 256, 40], R3 = [0, 1, 1, 1, 0], ne = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], w9 = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], z9 = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], ol = 8, cl = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], $6 = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], H4 = null, Ti = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], S5 = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], Y5 = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], S0 = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], U6 = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], C5 = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], M9 = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], l6 = [], k5 = [], C0 = [], b9 = 1, r6 = 2, a4 = [], E4 = [];
    H1("UpsampleRgbLinePair", P3, 3), H1("UpsampleBgrLinePair", He, 3), H1("UpsampleRgbaLinePair", B4, 4), H1("UpsampleBgraLinePair", Ft, 4), H1("UpsampleArgbLinePair", wt, 4), H1("UpsampleRgba4444LinePair", Xe, 2), H1("UpsampleRgb565LinePair", ot, 2);
    var A = V.UpsampleRgbLinePair, E5 = V.UpsampleBgrLinePair, a6 = V.UpsampleRgbaLinePair, Ke = V.UpsampleBgraLinePair, A2 = V.UpsampleArgbLinePair, Nr = V.UpsampleRgba4444LinePair, L9 = V.UpsampleRgb565LinePair, K8 = 16, o4 = 1 << K8 - 1, Ii = -227, hl = 482, Pr = 6, x9 = (256 << Pr) - 1, Br = 0, Ut = l(256), S9 = l(256), C9 = l(256), k9 = l(256), E9 = l(hl - Ii), A9 = l(hl - Ii);
    V4("YuvToRgbRow", P3, 3), V4("YuvToBgrRow", He, 3), V4("YuvToRgbaRow", B4, 4), V4("YuvToBgraRow", Ft, 4), V4("YuvToArgbRow", wt, 4), V4("YuvToRgba4444Row", Xe, 2), V4("YuvToRgb565Row", ot, 2);
    var Ot = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], Z8 = [0, 2, 8], F9 = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], T9 = 1;
    this.WebPDecodeRGBA = function(g, w, E, B, W) {
      var Z = i5, t1 = new qe(), r1 = new G3();
      t1.ba = r1, r1.S = Z, r1.width = [r1.width], r1.height = [r1.height];
      var o1 = r1.width, d1 = r1.height, L1 = new Se();
      if (L1 == null || g == null)
        var I1 = 2;
      else
        e(L1 != null), I1 = In(g, w, E, L1.width, L1.height, L1.Pd, L1.Qd, L1.format, null);
      if (I1 != 0 ? o1 = 0 : (o1 != null && (o1[0] = L1.width[0]), d1 != null && (d1[0] = L1.height[0]), o1 = 1), o1) {
        r1.width = r1.width[0], r1.height = r1.height[0], B != null && (B[0] = r1.width), W != null && (W[0] = r1.height);
        e: {
          if (B = new xn(), (W = new Ci()).data = g, W.w = w, W.ha = E, W.kd = 1, w = [0], e(W != null), ((g = In(W.data, W.w, W.ha, null, null, null, w, null, W)) == 0 || g == 7) && w[0] && (g = 4), (w = g) == 0) {
            if (e(t1 != null), B.data = W.data, B.w = W.w + W.offset, B.ha = W.ha - W.offset, B.put = tt, B.ac = Ce, B.bc = ut, B.ma = t1, W.xa) {
              if ((g = K4()) == null) {
                t1 = 1;
                break e;
              }
              if (function(O1, k1) {
                var G1 = [0], V1 = [0], b1 = [0];
                t:
                  for (; ; ) {
                    if (O1 == null)
                      return 0;
                    if (k1 == null)
                      return O1.a = 2, 0;
                    if (O1.l = k1, O1.a = 0, c1(O1.m, k1.data, k1.w, k1.ha), !D2(O1.m, G1, V1, b1)) {
                      O1.a = 3;
                      break t;
                    }
                    if (O1.xb = r6, k1.width = G1[0], k1.height = V1[0], !H5(G1[0], V1[0], 1, O1, null))
                      break t;
                    return 1;
                  }
                return e(O1.a != 0), 0;
              }(g, B)) {
                if (B = (w = On(B.width, B.height, t1.Oa, t1.ba)) == 0) {
                  t: {
                    B = g;
                    n:
                      for (; ; ) {
                        if (B == null) {
                          B = 0;
                          break t;
                        }
                        if (e(B.s.yc != null), e(B.s.Ya != null), e(0 < B.s.Wb), e((E = B.l) != null), e((W = E.ma) != null), B.xb != 0) {
                          if (B.ca = W.ba, B.tb = W.tb, e(B.ca != null), !Ei(W.Oa, E, W5)) {
                            B.a = 2;
                            break n;
                          }
                          if (!F6(B, E.width) || E.da)
                            break n;
                          if ((E.da || R2(B.ca.S)) && F1(), 11 > B.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), B.ca.f.kb.F != null && F1()), B.Pb && 0 < B.s.ua && B.s.vb.X == null && !y2(B.s.vb, B.s.Wa.Xa)) {
                            B.a = 1;
                            break n;
                          }
                          B.xb = 0;
                        }
                        if (!w5(B, B.V, B.Ba, B.c, B.i, E.o, wn))
                          break n;
                        W.Dc = B.Ma, B = 1;
                        break t;
                      }
                    e(B.a != 0), B = 0;
                  }
                  B = !B;
                }
                B && (w = g.a);
              } else
                w = g.a;
            } else {
              if ((g = new Ks()) == null) {
                t1 = 1;
                break e;
              }
              if (g.Fa = W.na, g.P = W.P, g.qc = W.Sa, Cn(g, B)) {
                if ((w = On(B.width, B.height, t1.Oa, t1.ba)) == 0) {
                  if (g.Aa = 0, E = t1.Oa, e((W = g) != null), E != null) {
                    if (0 < (o1 = 0 > (o1 = E.Md) ? 0 : 100 < o1 ? 255 : 255 * o1 / 100)) {
                      for (d1 = L1 = 0; 4 > d1; ++d1)
                        12 > (I1 = W.pb[d1]).lc && (I1.ia = o1 * F9[0 > I1.lc ? 0 : I1.lc] >> 3), L1 |= I1.ia;
                      L1 && (alert("todo:VP8InitRandom"), W.ia = 1);
                    }
                    W.Ga = E.Id, 100 < W.Ga ? W.Ga = 100 : 0 > W.Ga && (W.Ga = 0);
                  }
                  _i(g, B) || (w = g.a);
                }
              } else
                w = g.a;
            }
            w == 0 && t1.Oa != null && t1.Oa.fd && (w = Ai(t1.ba));
          }
          t1 = w;
        }
        Z = t1 != 0 ? null : 11 > Z ? r1.f.RGBA.eb : r1.f.kb.y;
      } else
        Z = null;
      return Z;
    };
    var Vr = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function u(V, J) {
    for (var K = "", P = 0; P < 4; P++)
      K += String.fromCharCode(V[J++]);
    return K;
  }
  function d(V, J) {
    return (V[J + 0] << 0 | V[J + 1] << 8 | V[J + 2] << 16) >>> 0;
  }
  function v(V, J) {
    return (V[J + 0] << 0 | V[J + 1] << 8 | V[J + 2] << 16 | V[J + 3] << 24) >>> 0;
  }
  new h();
  var m = [0], p = [0], _ = [], q = new h(), M = t, z = function(V, J) {
    var K = {}, P = 0, O = !1, G = 0, j = 0;
    if (K.frames = [], !/** @license
       * Copyright (c) 2017 Dominik Homberger
      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      https://webpjs.appspot.com
      WebPRiffParser dominikhlbg@gmail.com
      */
    function(a1, n1, f1, w1) {
      for (var C1 = 0; C1 < w1; C1++)
        if (a1[n1 + C1] != f1.charCodeAt(C1))
          return !0;
      return !1;
    }(V, J, "RIFF", 4)) {
      var Q, i1;
      for (v(V, J += 4), J += 8; J < V.length; ) {
        var h1 = u(V, J), c1 = v(V, J += 4);
        J += 4;
        var M1 = c1 + (1 & c1);
        switch (h1) {
          case "VP8 ":
          case "VP8L":
            K.frames[P] === void 0 && (K.frames[P] = {}), ($ = K.frames[P]).src_off = O ? j : J - 8, $.src_size = G + c1 + 8, P++, O && (O = !1, G = 0, j = 0);
            break;
          case "VP8X":
            ($ = K.header = {}).feature_flags = V[J];
            var y1 = J + 4;
            $.canvas_width = 1 + d(V, y1), y1 += 3, $.canvas_height = 1 + d(V, y1), y1 += 3;
            break;
          case "ALPH":
            O = !0, G = M1 + 8, j = J - 8;
            break;
          case "ANIM":
            ($ = K.header).bgcolor = v(V, J), y1 = J + 4, $.loop_count = (Q = V)[(i1 = y1) + 0] << 0 | Q[i1 + 1] << 8, y1 += 2;
            break;
          case "ANMF":
            var A1, $;
            ($ = K.frames[P] = {}).offset_x = 2 * d(V, J), J += 3, $.offset_y = 2 * d(V, J), J += 3, $.width = 1 + d(V, J), J += 3, $.height = 1 + d(V, J), J += 3, $.duration = d(V, J), J += 3, A1 = V[J++], $.dispose = 1 & A1, $.blend = A1 >> 1 & 1;
        }
        h1 != "ANMF" && (J += M1);
      }
      return K;
    }
  }(M, 0);
  z.response = M, z.rgbaoutput = !0, z.dataurl = !1;
  var b = z.header ? z.header : null, x = z.frames ? z.frames : null;
  if (b) {
    b.loop_counter = b.loop_count, m = [b.canvas_height], p = [b.canvas_width];
    for (var k = 0; k < x.length && x[k].blend != 0; k++)
      ;
  }
  var F = x[0], D = q.WebPDecodeRGBA(M, F.src_off, F.src_size, p, m);
  F.rgba = D, F.imgwidth = p[0], F.imgheight = m[0];
  for (var R = 0; R < p[0] * m[0] * 4; R++)
    _[R] = D[R];
  return this.width = p, this.height = m, this.data = _, this;
}
(function(t) {
  var e = function() {
    return typeof Xy == "function";
  }, n = function(m, p, _, q) {
    var M = 4, z = a;
    switch (q) {
      case t.image_compression.FAST:
        M = 1, z = l;
        break;
      case t.image_compression.MEDIUM:
        M = 6, z = o;
        break;
      case t.image_compression.SLOW:
        M = 9, z = h;
    }
    m = i(m, p, _, z);
    var b = Xy(m, { level: M });
    return t.__addimage__.arrayBufferToBinaryString(b);
  }, i = function(m, p, _, q) {
    for (var M, z, b, x = m.length / p, k = new Uint8Array(m.length + x), F = d(), D = 0; D < x; D += 1) {
      if (b = D * p, M = m.subarray(b, b + p), q)
        k.set(q(M, _, z), b + D);
      else {
        for (var R, V = F.length, J = []; R < V; R += 1)
          J[R] = F[R](M, _, z);
        var K = v(J.concat());
        k.set(J[K], b + D);
      }
      z = M;
    }
    return k;
  }, s = function(m) {
    var p = Array.apply([], m);
    return p.unshift(0), p;
  }, l = function(m, p) {
    var _, q = [], M = m.length;
    q[0] = 1;
    for (var z = 0; z < M; z += 1)
      _ = m[z - p] || 0, q[z + 1] = m[z] - _ + 256 & 255;
    return q;
  }, a = function(m, p, _) {
    var q, M = [], z = m.length;
    M[0] = 2;
    for (var b = 0; b < z; b += 1)
      q = _ && _[b] || 0, M[b + 1] = m[b] - q + 256 & 255;
    return M;
  }, o = function(m, p, _) {
    var q, M, z = [], b = m.length;
    z[0] = 3;
    for (var x = 0; x < b; x += 1)
      q = m[x - p] || 0, M = _ && _[x] || 0, z[x + 1] = m[x] + 256 - (q + M >>> 1) & 255;
    return z;
  }, h = function(m, p, _) {
    var q, M, z, b, x = [], k = m.length;
    x[0] = 4;
    for (var F = 0; F < k; F += 1)
      q = m[F - p] || 0, M = _ && _[F] || 0, z = _ && _[F - p] || 0, b = u(q, M, z), x[F + 1] = m[F] - b + 256 & 255;
    return x;
  }, u = function(m, p, _) {
    if (m === p && p === _)
      return m;
    var q = Math.abs(p - _), M = Math.abs(m - _), z = Math.abs(m + p - _ - _);
    return q <= M && q <= z ? m : M <= z ? p : _;
  }, d = function() {
    return [s, l, a, o, h];
  }, v = function(m) {
    var p = m.map(function(_) {
      return _.reduce(function(q, M) {
        return q + Math.abs(M);
      }, 0);
    });
    return p.indexOf(Math.min.apply(null, p));
  };
  t.processPNG = function(m, p, _, q) {
    var M, z, b, x, k, F, D, R, V, J, K, P, O, G, j, Q = this.decode.FLATE_DECODE, i1 = "";
    if (this.__addimage__.isArrayBuffer(m) && (m = new Uint8Array(m)), this.__addimage__.isArrayBufferView(m)) {
      if (m = (b = new GC1(m)).imgData, z = b.bits, M = b.colorSpace, k = b.colors, [4, 6].indexOf(b.colorType) !== -1) {
        if (b.bits === 8) {
          V = (R = b.pixelBitlength == 32 ? new Uint32Array(b.decodePixels().buffer) : b.pixelBitlength == 16 ? new Uint16Array(b.decodePixels().buffer) : new Uint8Array(b.decodePixels().buffer)).length, K = new Uint8Array(V * b.colors), J = new Uint8Array(V);
          var h1, c1 = b.pixelBitlength - b.bits;
          for (G = 0, j = 0; G < V; G++) {
            for (O = R[G], h1 = 0; h1 < c1; )
              K[j++] = O >>> h1 & 255, h1 += b.bits;
            J[G] = O >>> h1 & 255;
          }
        }
        if (b.bits === 16) {
          V = (R = new Uint32Array(b.decodePixels().buffer)).length, K = new Uint8Array(V * (32 / b.pixelBitlength) * b.colors), J = new Uint8Array(V * (32 / b.pixelBitlength)), P = b.colors > 1, G = 0, j = 0;
          for (var M1 = 0; G < V; )
            O = R[G++], K[j++] = O >>> 0 & 255, P && (K[j++] = O >>> 16 & 255, O = R[G++], K[j++] = O >>> 0 & 255), J[M1++] = O >>> 16 & 255;
          z = 8;
        }
        q !== t.image_compression.NONE && e() ? (m = n(K, b.width * b.colors, b.colors, q), D = n(J, b.width, 1, q)) : (m = K, D = J, Q = void 0);
      }
      if (b.colorType === 3 && (M = this.color_spaces.INDEXED, F = b.palette, b.transparency.indexed)) {
        var y1 = b.transparency.indexed, A1 = 0;
        for (G = 0, V = y1.length; G < V; ++G)
          A1 += y1[G];
        if ((A1 /= 255) === V - 1 && y1.indexOf(0) !== -1)
          x = [y1.indexOf(0)];
        else if (A1 !== V) {
          for (R = b.decodePixels(), J = new Uint8Array(R.length), G = 0, V = R.length; G < V; G++)
            J[G] = y1[R[G]];
          D = n(J, b.width, 1);
        }
      }
      var $ = function(a1) {
        var n1;
        switch (a1) {
          case t.image_compression.FAST:
            n1 = 11;
            break;
          case t.image_compression.MEDIUM:
            n1 = 13;
            break;
          case t.image_compression.SLOW:
            n1 = 14;
            break;
          default:
            n1 = 12;
        }
        return n1;
      }(q);
      return Q === this.decode.FLATE_DECODE && (i1 = "/Predictor " + $ + " "), i1 += "/Colors " + k + " /BitsPerComponent " + z + " /Columns " + b.width, (this.__addimage__.isArrayBuffer(m) || this.__addimage__.isArrayBufferView(m)) && (m = this.__addimage__.arrayBufferToBinaryString(m)), (D && this.__addimage__.isArrayBuffer(D) || this.__addimage__.isArrayBufferView(D)) && (D = this.__addimage__.arrayBufferToBinaryString(D)), { alias: _, data: m, index: p, filter: Q, decodeParameters: i1, transparency: x, palette: F, sMask: D, predictor: $, width: b.width, height: b.height, bitsPerComponent: z, colorSpace: M };
    }
  };
})(m3.API), function(t) {
  t.processGIF89A = function(e, n, i, s) {
    var l = new WC1(e), a = l.width, o = l.height, h = [];
    l.decodeAndBlitFrameRGBA(0, h);
    var u = { data: h, width: a, height: o }, d = new ty(100).encode(u, 100);
    return t.processJPEG.call(this, d, n, i, s);
  }, t.processGIF87A = t.processGIF89A;
}(m3.API), en.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var t = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(t);
    for (var e = 0; e < t; e++) {
      var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), l = this.datav.getUint8(this.pos++, !0);
      this.palette[e] = { red: s, green: i, blue: n, quad: l };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, en.prototype.parseBGR = function() {
  this.pos = this.offset;
  try {
    var t = "bit" + this.bitPP, e = this.width * this.height * 4;
    this.data = new Uint8Array(e), this[t]();
  } catch (n) {
    at.log("bit decode error:" + n);
  }
}, en.prototype.bit1 = function() {
  var t, e = Math.ceil(this.width / 8), n = e % 4;
  for (t = this.height - 1; t >= 0; t--) {
    for (var i = this.bottom_up ? t : this.height - 1 - t, s = 0; s < e; s++)
      for (var l = this.datav.getUint8(this.pos++, !0), a = i * this.width * 4 + 8 * s * 4, o = 0; o < 8 && 8 * s + o < this.width; o++) {
        var h = this.palette[l >> 7 - o & 1];
        this.data[a + 4 * o] = h.blue, this.data[a + 4 * o + 1] = h.green, this.data[a + 4 * o + 2] = h.red, this.data[a + 4 * o + 3] = 255;
      }
    n !== 0 && (this.pos += 4 - n);
  }
}, en.prototype.bit4 = function() {
  for (var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; n >= 0; n--) {
    for (var i = this.bottom_up ? n : this.height - 1 - n, s = 0; s < t; s++) {
      var l = this.datav.getUint8(this.pos++, !0), a = i * this.width * 4 + 2 * s * 4, o = l >> 4, h = 15 & l, u = this.palette[o];
      if (this.data[a] = u.blue, this.data[a + 1] = u.green, this.data[a + 2] = u.red, this.data[a + 3] = 255, 2 * s + 1 >= this.width)
        break;
      u = this.palette[h], this.data[a + 4] = u.blue, this.data[a + 4 + 1] = u.green, this.data[a + 4 + 2] = u.red, this.data[a + 4 + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, en.prototype.bit8 = function() {
  for (var t = this.width % 4, e = this.height - 1; e >= 0; e--) {
    for (var n = this.bottom_up ? e : this.height - 1 - e, i = 0; i < this.width; i++) {
      var s = this.datav.getUint8(this.pos++, !0), l = n * this.width * 4 + 4 * i;
      if (s < this.palette.length) {
        var a = this.palette[s];
        this.data[l] = a.red, this.data[l + 1] = a.green, this.data[l + 2] = a.blue, this.data[l + 3] = 255;
      } else
        this.data[l] = 255, this.data[l + 1] = 255, this.data[l + 2] = 255, this.data[l + 3] = 255;
    }
    t !== 0 && (this.pos += 4 - t);
  }
}, en.prototype.bit15 = function() {
  for (var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; n >= 0; n--) {
    for (var i = this.bottom_up ? n : this.height - 1 - n, s = 0; s < this.width; s++) {
      var l = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var a = (l & e) / e * 255 | 0, o = (l >> 5 & e) / e * 255 | 0, h = (l >> 10 & e) / e * 255 | 0, u = l >> 15 ? 255 : 0, d = i * this.width * 4 + 4 * s;
      this.data[d] = h, this.data[d + 1] = o, this.data[d + 2] = a, this.data[d + 3] = u;
    }
    this.pos += t;
  }
}, en.prototype.bit16 = function() {
  for (var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), i = this.height - 1; i >= 0; i--) {
    for (var s = this.bottom_up ? i : this.height - 1 - i, l = 0; l < this.width; l++) {
      var a = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var o = (a & e) / e * 255 | 0, h = (a >> 5 & n) / n * 255 | 0, u = (a >> 11) / e * 255 | 0, d = s * this.width * 4 + 4 * l;
      this.data[d] = u, this.data[d + 1] = h, this.data[d + 2] = o, this.data[d + 3] = 255;
    }
    this.pos += t;
  }
}, en.prototype.bit24 = function() {
  for (var t = this.height - 1; t >= 0; t--) {
    for (var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++) {
      var i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), l = this.datav.getUint8(this.pos++, !0), a = e * this.width * 4 + 4 * n;
      this.data[a] = l, this.data[a + 1] = s, this.data[a + 2] = i, this.data[a + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, en.prototype.bit32 = function() {
  for (var t = this.height - 1; t >= 0; t--)
    for (var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++) {
      var i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), l = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * n;
      this.data[o] = l, this.data[o + 1] = s, this.data[o + 2] = i, this.data[o + 3] = a;
    }
}, en.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  t.processBMP = function(e, n, i, s) {
    var l = new en(e, !1), a = l.width, o = l.height, h = { data: l.getData(), width: a, height: o }, u = new ty(100).encode(h, 100);
    return t.processJPEG.call(this, u, n, i, s);
  };
}(m3.API), QM.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  t.processWEBP = function(e, n, i, s) {
    var l = new QM(e), a = l.width, o = l.height, h = { data: l.getData(), width: a, height: o }, u = new ty(100).encode(h, 100);
    return t.processJPEG.call(this, u, n, i, s);
  };
}(m3.API), m3.API.processRGBA = function(t, e, n) {
  for (var i = t.data, s = i.length, l = new Uint8Array(s / 4 * 3), a = new Uint8Array(s / 4), o = 0, h = 0, u = 0; u < s; u += 4) {
    var d = i[u], v = i[u + 1], m = i[u + 2], p = i[u + 3];
    l[o++] = d, l[o++] = v, l[o++] = m, a[h++] = p;
  }
  var _ = this.__addimage__.arrayBufferToBinaryString(l);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(a), data: _, index: e, alias: n, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: t.width, height: t.height };
}, m3.API.setLanguage = function(t) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[t] !== void 0 && (this.internal.languageSettings.languageCode = t, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, ea = m3.API, hh = ea.getCharWidthsArray = function(t, e) {
  var n, i, s = (e = e || {}).font || this.internal.getFont(), l = e.fontSize || this.internal.getFontSize(), a = e.charSpace || this.internal.getCharSpace(), o = e.widths ? e.widths : s.metadata.Unicode.widths, h = o.fof ? o.fof : 1, u = e.kerning ? e.kerning : s.metadata.Unicode.kerning, d = u.fof ? u.fof : 1, v = e.doKerning !== !1, m = 0, p = t.length, _ = 0, q = o[0] || h, M = [];
  for (n = 0; n < p; n++)
    i = t.charCodeAt(n), typeof s.metadata.widthOfString == "function" ? M.push((s.metadata.widthOfGlyph(s.metadata.characterToGlyph(i)) + a * (1e3 / l) || 0) / 1e3) : (m = v && Ye(u[i]) === "object" && !isNaN(parseInt(u[i][_], 10)) ? u[i][_] / d : 0, M.push((o[i] || q) / h + m)), _ = i;
  return M;
}, XM = ea.getStringUnitWidth = function(t, e) {
  var n = (e = e || {}).fontSize || this.internal.getFontSize(), i = e.font || this.internal.getFont(), s = e.charSpace || this.internal.getCharSpace();
  return ea.processArabic && (t = ea.processArabic(t)), typeof i.metadata.widthOfString == "function" ? i.metadata.widthOfString(t, n, s) / n : hh.apply(this, arguments).reduce(function(l, a) {
    return l + a;
  }, 0);
}, KM = function(t, e, n, i) {
  for (var s = [], l = 0, a = t.length, o = 0; l !== a && o + e[l] < n; )
    o += e[l], l++;
  s.push(t.slice(0, l));
  var h = l;
  for (o = 0; l !== a; )
    o + e[l] > i && (s.push(t.slice(h, l)), o = 0, h = l), o += e[l], l++;
  return h !== l && s.push(t.slice(h, l)), s;
}, ZM = function(t, e, n) {
  n || (n = {});
  var i, s, l, a, o, h, u, d = [], v = [d], m = n.textIndent || 0, p = 0, _ = 0, q = t.split(" "), M = hh.apply(this, [" ", n])[0];
  if (h = n.lineIndent === -1 ? q[0].length + 2 : n.lineIndent || 0) {
    var z = Array(h).join(" "), b = [];
    q.map(function(k) {
      (k = k.split(/\s*\n/)).length > 1 ? b = b.concat(k.map(function(F, D) {
        return (D && F.length ? `
` : "") + F;
      })) : b.push(k[0]);
    }), q = b, h = XM.apply(this, [z, n]);
  }
  for (l = 0, a = q.length; l < a; l++) {
    var x = 0;
    if (i = q[l], h && i[0] == `
` && (i = i.substr(1), x = 1), m + p + (_ = (s = hh.apply(this, [i, n])).reduce(function(k, F) {
      return k + F;
    }, 0)) > e || x) {
      if (_ > e) {
        for (o = KM.apply(this, [i, s, e - (m + p), e]), d.push(o.shift()), d = [o.pop()]; o.length; )
          v.push([o.shift()]);
        _ = s.slice(i.length - (d[0] ? d[0].length : 0)).reduce(function(k, F) {
          return k + F;
        }, 0);
      } else
        d = [i];
      v.push(d), m = _ + h, p = M;
    } else
      d.push(i), m += p + _, p = M;
  }
  return u = h ? function(k, F) {
    return (F ? z : "") + k.join(" ");
  } : function(k) {
    return k.join(" ");
  }, v.map(u);
}, ea.splitTextToSize = function(t, e, n) {
  var i, s = (n = n || {}).fontSize || this.internal.getFontSize(), l = (function(d) {
    if (d.widths && d.kerning)
      return { widths: d.widths, kerning: d.kerning };
    var v = this.internal.getFont(d.fontName, d.fontStyle);
    return v.metadata.Unicode ? { widths: v.metadata.Unicode.widths || { 0: 1 }, kerning: v.metadata.Unicode.kerning || {} } : { font: v.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, n);
  i = Array.isArray(t) ? t : String(t).split(/\r?\n/);
  var a = 1 * this.internal.scaleFactor * e / s;
  l.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / s : 0, l.lineIndent = n.lineIndent;
  var o, h, u = [];
  for (o = 0, h = i.length; o < h; o++)
    u = u.concat(ZM.apply(this, [i[o], a, l]));
  return u;
}, function(t) {
  t.__fontmetrics__ = t.__fontmetrics__ || {};
  for (var e = "klmnopqrstuvwxyz", n = {}, i = {}, s = 0; s < e.length; s++)
    n[e[s]] = "0123456789abcdef"[s], i["0123456789abcdef"[s]] = e[s];
  var l = function(v) {
    return "0x" + parseInt(v, 10).toString(16);
  }, a = t.__fontmetrics__.compress = function(v) {
    var m, p, _, q, M = ["{"];
    for (var z in v) {
      if (m = v[z], isNaN(parseInt(z, 10)) ? p = "'" + z + "'" : (z = parseInt(z, 10), p = (p = l(z).slice(2)).slice(0, -1) + i[p.slice(-1)]), typeof m == "number")
        m < 0 ? (_ = l(m).slice(3), q = "-") : (_ = l(m).slice(2), q = ""), _ = q + _.slice(0, -1) + i[_.slice(-1)];
      else {
        if (Ye(m) !== "object")
          throw new Error("Don't know what to do with value type " + Ye(m) + ".");
        _ = a(m);
      }
      M.push(p + _);
    }
    return M.push("}"), M.join("");
  }, o = t.__fontmetrics__.uncompress = function(v) {
    if (typeof v != "string")
      throw new Error("Invalid argument passed to uncompress.");
    for (var m, p, _, q, M = {}, z = 1, b = M, x = [], k = "", F = "", D = v.length - 1, R = 1; R < D; R += 1)
      (q = v[R]) == "'" ? m ? (_ = m.join(""), m = void 0) : m = [] : m ? m.push(q) : q == "{" ? (x.push([b, _]), b = {}, _ = void 0) : q == "}" ? ((p = x.pop())[0][p[1]] = b, _ = void 0, b = p[0]) : q == "-" ? z = -1 : _ === void 0 ? n.hasOwnProperty(q) ? (k += n[q], _ = parseInt(k, 16) * z, z = 1, k = "") : k += q : n.hasOwnProperty(q) ? (F += n[q], b[_] = parseInt(F, 16) * z, z = 1, _ = void 0, F = "") : F += q;
    return M;
  }, h = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: o("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, u = { Unicode: { Courier: h, "Courier-Bold": h, "Courier-BoldOblique": h, "Courier-Oblique": h, Helvetica: h, "Helvetica-Bold": h, "Helvetica-BoldOblique": h, "Helvetica-Oblique": h, "Times-Roman": h, "Times-Bold": h, "Times-BoldItalic": h, "Times-Italic": h } }, d = { Unicode: { "Courier-Oblique": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": o("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": o("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": o("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: o("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: o("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": o("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: o("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": o("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": o("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": o("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": o("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  t.events.push(["addFont", function(v) {
    var m = v.font, p = d.Unicode[m.postScriptName];
    p && (m.metadata.Unicode = {}, m.metadata.Unicode.widths = p.widths, m.metadata.Unicode.kerning = p.kerning);
    var _ = u.Unicode[m.postScriptName];
    _ && (m.metadata.Unicode.encoding = _, m.encoding = _.codePages[0]);
  }]);
}(m3.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var e = function(n) {
    for (var i = n.length, s = new Uint8Array(i), l = 0; l < i; l++)
      s[l] = n.charCodeAt(l);
    return s;
  };
  t.API.events.push(["addFont", function(n) {
    var i = void 0, s = n.font, l = n.instance;
    if (!s.isStandardFont) {
      if (l === void 0)
        throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + s.postScriptName + "').");
      if (typeof (i = l.existsFileInVFS(s.postScriptName) === !1 ? l.loadFile(s.postScriptName) : l.getFileFromVFS(s.postScriptName)) != "string")
        throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + s.postScriptName + "').");
      (function(a, o) {
        o = /^\x00\x01\x00\x00/.test(o) ? e(o) : e(ko(o)), a.metadata = t.API.TTFFont.open(o), a.metadata.Unicode = a.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, a.metadata.glyIdsUsed = [0];
      })(s, i);
    }
  }]);
}(m3), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t) {
  function e() {
    return (g3.canvg ? Promise.resolve(g3.canvg) : import("./index.es-b2086460.js")).catch(function(n) {
      return Promise.reject(new Error("Could not load canvg: " + n));
    }).then(function(n) {
      return n.default ? n.default : n;
    });
  }
  m3.API.addSvgAsImage = function(n, i, s, l, a, o, h, u) {
    if (isNaN(i) || isNaN(s))
      throw at.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
    if (isNaN(l) || isNaN(a))
      throw at.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
    var d = document.createElement("canvas");
    d.width = l, d.height = a;
    var v = d.getContext("2d");
    v.fillStyle = "#fff", v.fillRect(0, 0, d.width, d.height);
    var m = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, p = this;
    return e().then(function(_) {
      return _.fromString(v, n, m);
    }, function() {
      return Promise.reject(new Error("Could not load canvg."));
    }).then(function(_) {
      return _.render(m);
    }).then(function() {
      p.addImage(d.toDataURL("image/jpeg", 1), i, s, l, a, h, u);
    });
  };
}(), m3.API.putTotalPages = function(t) {
  var e, n = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), n = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var i = 1; i <= this.internal.getNumberOfPages(); i++)
    for (var s = 0; s < this.internal.pages[i].length; s++)
      this.internal.pages[i][s] = this.internal.pages[i][s].replace(e, n);
  return this;
}, m3.API.viewerPreferences = function(t, e) {
  var n;
  t = t || {}, e = e || !1;
  var i, s, l, a = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, o = Object.keys(a), h = [], u = 0, d = 0, v = 0;
  function m(_, q) {
    var M, z = !1;
    for (M = 0; M < _.length; M += 1)
      _[M] === q && (z = !0);
    return z;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(a)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, t === "reset" || e === !0) {
    var p = o.length;
    for (v = 0; v < p; v += 1)
      n[o[v]].value = n[o[v]].defaultValue, n[o[v]].explicitSet = !1;
  }
  if (Ye(t) === "object") {
    for (s in t)
      if (l = t[s], m(o, s) && l !== void 0) {
        if (n[s].type === "boolean" && typeof l == "boolean")
          n[s].value = l;
        else if (n[s].type === "name" && m(n[s].valueSet, l))
          n[s].value = l;
        else if (n[s].type === "integer" && Number.isInteger(l))
          n[s].value = l;
        else if (n[s].type === "array") {
          for (u = 0; u < l.length; u += 1)
            if (i = !0, l[u].length === 1 && typeof l[u][0] == "number")
              h.push(String(l[u] - 1));
            else if (l[u].length > 1) {
              for (d = 0; d < l[u].length; d += 1)
                typeof l[u][d] != "number" && (i = !1);
              i === !0 && h.push([l[u][0] - 1, l[u][1] - 1].join(" "));
            }
          n[s].value = "[" + h.join(" ") + "]";
        } else
          n[s].value = n[s].defaultValue;
        n[s].explicitSet = !0;
      }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var _, q = [];
    for (_ in n)
      n[_].explicitSet === !0 && (n[_].type === "name" ? q.push("/" + _ + " /" + n[_].value) : q.push("/" + _ + " " + n[_].value));
    q.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + q.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t) {
  var e = function() {
    var i = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', s = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), l = unescape(encodeURIComponent(i)), a = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), o = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), h = unescape(encodeURIComponent("</x:xmpmeta>")), u = l.length + a.length + o.length + s.length + h.length;
    this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + u + " >>"), this.internal.write("stream"), this.internal.write(s + l + a + o + h), this.internal.write("endstream"), this.internal.write("endobj");
  }, n = function() {
    this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
  };
  t.addMetadata = function(i, s) {
    return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: i, namespaceuri: s || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", n), this.internal.events.subscribe("postPutResources", e)), this;
  };
}(m3.API), function(t) {
  var e = t.API, n = e.pdfEscape16 = function(l, a) {
    for (var o, h = a.metadata.Unicode.widths, u = ["", "0", "00", "000", "0000"], d = [""], v = 0, m = l.length; v < m; ++v) {
      if (o = a.metadata.characterToGlyph(l.charCodeAt(v)), a.metadata.glyIdsUsed.push(o), a.metadata.toUnicode[o] = l.charCodeAt(v), h.indexOf(o) == -1 && (h.push(o), h.push([parseInt(a.metadata.widthOfGlyph(o), 10)])), o == "0")
        return d.join("");
      o = o.toString(16), d.push(u[4 - o.length], o);
    }
    return d.join("");
  }, i = function(l) {
    var a, o, h, u, d, v, m;
    for (d = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, h = [], v = 0, m = (o = Object.keys(l).sort(function(p, _) {
      return p - _;
    })).length; v < m; v++)
      a = o[v], h.length >= 100 && (d += `
` + h.length + ` beginbfchar
` + h.join(`
`) + `
endbfchar`, h = []), l[a] !== void 0 && l[a] !== null && typeof l[a].toString == "function" && (u = ("0000" + l[a].toString(16)).slice(-4), a = ("0000" + (+a).toString(16)).slice(-4), h.push("<" + a + "><" + u + ">"));
    return h.length && (d += `
` + h.length + ` beginbfchar
` + h.join(`
`) + `
endbfchar
`), d += `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  e.events.push(["putFont", function(l) {
    (function(a) {
      var o = a.font, h = a.out, u = a.newObject, d = a.putStream;
      if (o.metadata instanceof t.API.TTFFont && o.encoding === "Identity-H") {
        for (var v = o.metadata.Unicode.widths, m = o.metadata.subset.encode(o.metadata.glyIdsUsed, 1), p = "", _ = 0; _ < m.length; _++)
          p += String.fromCharCode(m[_]);
        var q = u();
        d({ data: p, addLength1: !0, objectId: q }), h("endobj");
        var M = u();
        d({ data: i(o.metadata.toUnicode), addLength1: !0, objectId: M }), h("endobj");
        var z = u();
        h("<<"), h("/Type /FontDescriptor"), h("/FontName /" + ua(o.fontName)), h("/FontFile2 " + q + " 0 R"), h("/FontBBox " + t.API.PDFObject.convert(o.metadata.bbox)), h("/Flags " + o.metadata.flags), h("/StemV " + o.metadata.stemV), h("/ItalicAngle " + o.metadata.italicAngle), h("/Ascent " + o.metadata.ascender), h("/Descent " + o.metadata.decender), h("/CapHeight " + o.metadata.capHeight), h(">>"), h("endobj");
        var b = u();
        h("<<"), h("/Type /Font"), h("/BaseFont /" + ua(o.fontName)), h("/FontDescriptor " + z + " 0 R"), h("/W " + t.API.PDFObject.convert(v)), h("/CIDToGIDMap /Identity"), h("/DW 1000"), h("/Subtype /CIDFontType2"), h("/CIDSystemInfo"), h("<<"), h("/Supplement 0"), h("/Registry (Adobe)"), h("/Ordering (" + o.encoding + ")"), h(">>"), h(">>"), h("endobj"), o.objectNumber = u(), h("<<"), h("/Type /Font"), h("/Subtype /Type0"), h("/ToUnicode " + M + " 0 R"), h("/BaseFont /" + ua(o.fontName)), h("/Encoding /" + o.encoding), h("/DescendantFonts [" + b + " 0 R]"), h(">>"), h("endobj"), o.isAlreadyPutted = !0;
      }
    })(l);
  }]), e.events.push(["putFont", function(l) {
    (function(a) {
      var o = a.font, h = a.out, u = a.newObject, d = a.putStream;
      if (o.metadata instanceof t.API.TTFFont && o.encoding === "WinAnsiEncoding") {
        for (var v = o.metadata.rawData, m = "", p = 0; p < v.length; p++)
          m += String.fromCharCode(v[p]);
        var _ = u();
        d({ data: m, addLength1: !0, objectId: _ }), h("endobj");
        var q = u();
        d({ data: i(o.metadata.toUnicode), addLength1: !0, objectId: q }), h("endobj");
        var M = u();
        h("<<"), h("/Descent " + o.metadata.decender), h("/CapHeight " + o.metadata.capHeight), h("/StemV " + o.metadata.stemV), h("/Type /FontDescriptor"), h("/FontFile2 " + _ + " 0 R"), h("/Flags 96"), h("/FontBBox " + t.API.PDFObject.convert(o.metadata.bbox)), h("/FontName /" + ua(o.fontName)), h("/ItalicAngle " + o.metadata.italicAngle), h("/Ascent " + o.metadata.ascender), h(">>"), h("endobj"), o.objectNumber = u();
        for (var z = 0; z < o.metadata.hmtx.widths.length; z++)
          o.metadata.hmtx.widths[z] = parseInt(o.metadata.hmtx.widths[z] * (1e3 / o.metadata.head.unitsPerEm));
        h("<</Subtype/TrueType/Type/Font/ToUnicode " + q + " 0 R/BaseFont/" + ua(o.fontName) + "/FontDescriptor " + M + " 0 R/Encoding/" + o.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(o.metadata.hmtx.widths) + ">>"), h("endobj"), o.isAlreadyPutted = !0;
      }
    })(l);
  }]);
  var s = function(l) {
    var a, o = l.text || "", h = l.x, u = l.y, d = l.options || {}, v = l.mutex || {}, m = v.pdfEscape, p = v.activeFontKey, _ = v.fonts, q = p, M = "", z = 0, b = "", x = _[q].encoding;
    if (_[q].encoding !== "Identity-H")
      return { text: o, x: h, y: u, options: d, mutex: v };
    for (b = o, q = p, Array.isArray(o) && (b = o[0]), z = 0; z < b.length; z += 1)
      _[q].metadata.hasOwnProperty("cmap") && (a = _[q].metadata.cmap.unicode.codeMap[b[z].charCodeAt(0)]), a || b[z].charCodeAt(0) < 256 && _[q].metadata.hasOwnProperty("Unicode") ? M += b[z] : M += "";
    var k = "";
    return parseInt(q.slice(1)) < 14 || x === "WinAnsiEncoding" ? k = m(M, q).split("").map(function(F) {
      return F.charCodeAt(0).toString(16);
    }).join("") : x === "Identity-H" && (k = n(M, _[q])), v.isHex = !0, { text: k, x: h, y: u, options: d, mutex: v };
  };
  e.events.push(["postProcessText", function(l) {
    var a = l.text || "", o = [], h = { text: a, x: l.x, y: l.y, options: l.options, mutex: l.mutex };
    if (Array.isArray(a)) {
      var u = 0;
      for (u = 0; u < a.length; u += 1)
        Array.isArray(a[u]) && a[u].length === 3 ? o.push([s(Object.assign({}, h, { text: a[u][0] })).text, a[u][1], a[u][2]]) : o.push(s(Object.assign({}, h, { text: a[u] })).text);
      l.text = o;
    } else
      l.text = s(Object.assign({}, h, { text: a })).text;
  }]);
}(m3), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var e = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  t.existsFileInVFS = function(n) {
    return e.call(this), this.internal.vFS[n] !== void 0;
  }, t.addFileToVFS = function(n, i) {
    return e.call(this), this.internal.vFS[n] = i, this;
  }, t.getFileFromVFS = function(n) {
    return e.call(this), this.internal.vFS[n] !== void 0 ? this.internal.vFS[n] : null;
  };
}(m3.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
function(t) {
  t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(i) {
    var s, l, a, o, h, u, d, v = e, m = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], p = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], _ = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, q = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, M = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], z = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), b = !1, x = 0;
    this.__bidiEngine__ = {};
    var k = function(P) {
      var O = P.charCodeAt(), G = O >> 8, j = q[G];
      return j !== void 0 ? v[256 * j + (255 & O)] : G === 252 || G === 253 ? "AL" : z.test(G) ? "L" : G === 8 ? "R" : "N";
    }, F = function(P) {
      for (var O, G = 0; G < P.length; G++) {
        if ((O = k(P.charAt(G))) === "L")
          return !1;
        if (O === "R")
          return !0;
      }
      return !1;
    }, D = function(P, O, G, j) {
      var Q, i1, h1, c1, M1 = O[j];
      switch (M1) {
        case "L":
        case "R":
          b = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          b && (M1 = "AN");
          break;
        case "AL":
          b = !0, M1 = "R";
          break;
        case "WS":
          M1 = "N";
          break;
        case "CS":
          j < 1 || j + 1 >= O.length || (Q = G[j - 1]) !== "EN" && Q !== "AN" || (i1 = O[j + 1]) !== "EN" && i1 !== "AN" ? M1 = "N" : b && (i1 = "AN"), M1 = i1 === Q ? i1 : "N";
          break;
        case "ES":
          M1 = (Q = j > 0 ? G[j - 1] : "B") === "EN" && j + 1 < O.length && O[j + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if (j > 0 && G[j - 1] === "EN") {
            M1 = "EN";
            break;
          }
          if (b) {
            M1 = "N";
            break;
          }
          for (h1 = j + 1, c1 = O.length; h1 < c1 && O[h1] === "ET"; )
            h1++;
          M1 = h1 < c1 && O[h1] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (a && !o) {
            for (c1 = O.length, h1 = j + 1; h1 < c1 && O[h1] === "NSM"; )
              h1++;
            if (h1 < c1) {
              var y1 = P[j], A1 = y1 >= 1425 && y1 <= 2303 || y1 === 64286;
              if (Q = O[h1], A1 && (Q === "R" || Q === "AL")) {
                M1 = "R";
                break;
              }
            }
          }
          M1 = j < 1 || (Q = O[j - 1]) === "B" ? "N" : G[j - 1];
          break;
        case "B":
          b = !1, s = !0, M1 = x;
          break;
        case "S":
          l = !0, M1 = "N";
          break;
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          b = !1;
          break;
        case "BN":
          M1 = "N";
      }
      return M1;
    }, R = function(P, O, G) {
      var j = P.split("");
      return G && V(j, G, { hiLevel: x }), j.reverse(), O && O.reverse(), j.join("");
    }, V = function(P, O, G) {
      var j, Q, i1, h1, c1, M1 = -1, y1 = P.length, A1 = 0, $ = [], a1 = x ? p : m, n1 = [];
      for (b = !1, s = !1, l = !1, Q = 0; Q < y1; Q++)
        n1[Q] = k(P[Q]);
      for (i1 = 0; i1 < y1; i1++) {
        if (c1 = A1, $[i1] = D(P, n1, $, i1), j = 240 & (A1 = a1[c1][_[$[i1]]]), A1 &= 15, O[i1] = h1 = a1[A1][5], j > 0)
          if (j === 16) {
            for (Q = M1; Q < i1; Q++)
              O[Q] = 1;
            M1 = -1;
          } else
            M1 = -1;
        if (a1[A1][6])
          M1 === -1 && (M1 = i1);
        else if (M1 > -1) {
          for (Q = M1; Q < i1; Q++)
            O[Q] = h1;
          M1 = -1;
        }
        n1[i1] === "B" && (O[i1] = 0), G.hiLevel |= h1;
      }
      l && function(f1, w1, C1) {
        for (var E1 = 0; E1 < C1; E1++)
          if (f1[E1] === "S") {
            w1[E1] = x;
            for (var T1 = E1 - 1; T1 >= 0 && f1[T1] === "WS"; T1--)
              w1[T1] = x;
          }
      }(n1, O, y1);
    }, J = function(P, O, G, j, Q) {
      if (!(Q.hiLevel < P)) {
        if (P === 1 && x === 1 && !s)
          return O.reverse(), void (G && G.reverse());
        for (var i1, h1, c1, M1, y1 = O.length, A1 = 0; A1 < y1; ) {
          if (j[A1] >= P) {
            for (c1 = A1 + 1; c1 < y1 && j[c1] >= P; )
              c1++;
            for (M1 = A1, h1 = c1 - 1; M1 < h1; M1++, h1--)
              i1 = O[M1], O[M1] = O[h1], O[h1] = i1, G && (i1 = G[M1], G[M1] = G[h1], G[h1] = i1);
            A1 = c1;
          }
          A1++;
        }
      }
    }, K = function(P, O, G) {
      var j = P.split(""), Q = { hiLevel: x };
      return G || (G = []), V(j, G, Q), function(i1, h1, c1) {
        if (c1.hiLevel !== 0 && d)
          for (var M1, y1 = 0; y1 < i1.length; y1++)
            h1[y1] === 1 && (M1 = M.indexOf(i1[y1])) >= 0 && (i1[y1] = M[M1 + 1]);
      }(j, G, Q), J(2, j, O, G, Q), J(1, j, O, G, Q), j.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(P, O, G) {
      if (function(Q, i1) {
        if (i1)
          for (var h1 = 0; h1 < Q.length; h1++)
            i1[h1] = h1;
        o === void 0 && (o = F(Q)), u === void 0 && (u = F(Q));
      }(P, O), a || !h || u)
        if (a && h && o ^ u)
          x = o ? 1 : 0, P = R(P, O, G);
        else if (!a && h && u)
          x = o ? 1 : 0, P = K(P, O, G), P = R(P, O);
        else if (!a || o || h || u) {
          if (a && !h && o ^ u)
            P = R(P, O), o ? (x = 0, P = K(P, O, G)) : (x = 1, P = K(P, O, G), P = R(P, O));
          else if (a && o && !h && u)
            x = 1, P = K(P, O, G), P = R(P, O);
          else if (!a && !h && o ^ u) {
            var j = d;
            o ? (x = 1, P = K(P, O, G), x = 0, d = !1, P = K(P, O, G), d = j) : (x = 0, P = K(P, O, G), P = R(P, O), x = 1, d = !1, P = K(P, O, G), d = j, P = R(P, O));
          }
        } else
          x = 0, P = K(P, O, G);
      else
        x = o ? 1 : 0, P = K(P, O, G);
      return P;
    }, this.__bidiEngine__.setOptions = function(P) {
      P && (a = P.isInputVisual, h = P.isOutputVisual, o = P.isInputRtl, u = P.isOutputRtl, d = P.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(i), this.__bidiEngine__;
  };
  var e = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], n = new t.__bidiEngine__({ isInputVisual: !0 });
  t.API.events.push(["postProcessText", function(i) {
    var s = i.text, l = (i.x, i.y, i.options || {}), a = (i.mutex, l.lang, []);
    if (l.isInputVisual = typeof l.isInputVisual != "boolean" || l.isInputVisual, n.setOptions(l), Object.prototype.toString.call(s) === "[object Array]") {
      var o = 0;
      for (a = [], o = 0; o < s.length; o += 1)
        Object.prototype.toString.call(s[o]) === "[object Array]" ? a.push([n.doBidiReorder(s[o][0]), s[o][1], s[o][2]]) : a.push([n.doBidiReorder(s[o])]);
      i.text = a;
    } else
      i.text = n.doBidiReorder(s);
    n.setOptions({ isInputVisual: !0 });
  }]);
}(m3), m3.API.TTFFont = function() {
  function t(e) {
    var n;
    if (this.rawData = e, n = this.contents = new Rs(e), this.contents.pos = 4, n.readString(4) === "ttcf")
      throw new Error("TTCF not supported.");
    n.pos = 0, this.parse(), this.subset = new ok1(this), this.registerTTF();
  }
  return t.open = function(e) {
    return new t(e);
  }, t.prototype.parse = function() {
    return this.directory = new YC1(this.contents), this.head = new KC1(this), this.name = new tk1(this), this.cmap = new Zk(this), this.toUnicode = {}, this.hhea = new ZC1(this), this.maxp = new nk1(this), this.hmtx = new ik1(this), this.post = new QC1(this), this.os2 = new JC1(this), this.loca = new ak1(this), this.glyf = new sk1(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, t.prototype.registerTTF = function() {
    var e, n, i, s, l;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var a, o, h, u;
      for (u = [], a = 0, o = (h = this.bbox).length; a < o; a++)
        e = h[a], u.push(Math.round(e * this.scaleFactor));
      return u;
    }).call(this), this.stemV = 0, this.post.exists ? (i = 255 & (s = this.post.italic_angle), 32768 & (n = s >> 16) && (n = -(1 + (65535 ^ n))), this.italicAngle = +(n + "." + i)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (l = this.familyClass) === 1 || l === 2 || l === 3 || l === 4 || l === 5 || l === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode)
      throw new Error("No unicode cmap for font");
  }, t.prototype.characterToGlyph = function(e) {
    var n;
    return ((n = this.cmap.unicode) != null ? n.codeMap[e] : void 0) || 0;
  }, t.prototype.widthOfGlyph = function(e) {
    var n;
    return n = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(e).advance * n;
  }, t.prototype.widthOfString = function(e, n, i) {
    var s, l, a, o;
    for (a = 0, l = 0, o = (e = "" + e).length; 0 <= o ? l < o : l > o; l = 0 <= o ? ++l : --l)
      s = e.charCodeAt(l), a += this.widthOfGlyph(this.characterToGlyph(s)) + i * (1e3 / n) || 0;
    return a * (n / 1e3);
  }, t.prototype.lineHeight = function(e, n) {
    var i;
    return n == null && (n = !1), i = n ? this.lineGap : 0, (this.ascender + i - this.decender) / 1e3 * e;
  }, t;
}();
var _n, Rs = function() {
  function t(e) {
    this.data = e ?? [], this.pos = 0, this.length = this.data.length;
  }
  return t.prototype.readByte = function() {
    return this.data[this.pos++];
  }, t.prototype.writeByte = function(e) {
    return this.data[this.pos++] = e;
  }, t.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, t.prototype.writeUInt32 = function(e) {
    return this.writeByte(e >>> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
  }, t.prototype.readInt32 = function() {
    var e;
    return (e = this.readUInt32()) >= 2147483648 ? e - 4294967296 : e;
  }, t.prototype.writeInt32 = function(e) {
    return e < 0 && (e += 4294967296), this.writeUInt32(e);
  }, t.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, t.prototype.writeUInt16 = function(e) {
    return this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
  }, t.prototype.readInt16 = function() {
    var e;
    return (e = this.readUInt16()) >= 32768 ? e - 65536 : e;
  }, t.prototype.writeInt16 = function(e) {
    return e < 0 && (e += 65536), this.writeUInt16(e);
  }, t.prototype.readString = function(e) {
    var n, i;
    for (i = [], n = 0; 0 <= e ? n < e : n > e; n = 0 <= e ? ++n : --n)
      i[n] = String.fromCharCode(this.readByte());
    return i.join("");
  }, t.prototype.writeString = function(e) {
    var n, i, s;
    for (s = [], n = 0, i = e.length; 0 <= i ? n < i : n > i; n = 0 <= i ? ++n : --n)
      s.push(this.writeByte(e.charCodeAt(n)));
    return s;
  }, t.prototype.readShort = function() {
    return this.readInt16();
  }, t.prototype.writeShort = function(e) {
    return this.writeInt16(e);
  }, t.prototype.readLongLong = function() {
    var e, n, i, s, l, a, o, h;
    return e = this.readByte(), n = this.readByte(), i = this.readByte(), s = this.readByte(), l = this.readByte(), a = this.readByte(), o = this.readByte(), h = this.readByte(), 128 & e ? -1 * (72057594037927940 * (255 ^ e) + 281474976710656 * (255 ^ n) + 1099511627776 * (255 ^ i) + 4294967296 * (255 ^ s) + 16777216 * (255 ^ l) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ h) + 1) : 72057594037927940 * e + 281474976710656 * n + 1099511627776 * i + 4294967296 * s + 16777216 * l + 65536 * a + 256 * o + h;
  }, t.prototype.writeLongLong = function(e) {
    var n, i;
    return n = Math.floor(e / 4294967296), i = 4294967295 & e, this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n), this.writeByte(i >> 24 & 255), this.writeByte(i >> 16 & 255), this.writeByte(i >> 8 & 255), this.writeByte(255 & i);
  }, t.prototype.readInt = function() {
    return this.readInt32();
  }, t.prototype.writeInt = function(e) {
    return this.writeInt32(e);
  }, t.prototype.read = function(e) {
    var n, i;
    for (n = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)
      n.push(this.readByte());
    return n;
  }, t.prototype.write = function(e) {
    var n, i, s, l;
    for (l = [], i = 0, s = e.length; i < s; i++)
      n = e[i], l.push(this.writeByte(n));
    return l;
  }, t;
}(), YC1 = function() {
  var t;
  function e(n) {
    var i, s, l;
    for (this.scalarType = n.readInt(), this.tableCount = n.readShort(), this.searchRange = n.readShort(), this.entrySelector = n.readShort(), this.rangeShift = n.readShort(), this.tables = {}, s = 0, l = this.tableCount; 0 <= l ? s < l : s > l; s = 0 <= l ? ++s : --s)
      i = { tag: n.readString(4), checksum: n.readInt(), offset: n.readInt(), length: n.readInt() }, this.tables[i.tag] = i;
  }
  return e.prototype.encode = function(n) {
    var i, s, l, a, o, h, u, d, v, m, p, _, q;
    for (q in p = Object.keys(n).length, h = Math.log(2), v = 16 * Math.floor(Math.log(p) / h), a = Math.floor(v / h), d = 16 * p - v, (s = new Rs()).writeInt(this.scalarType), s.writeShort(p), s.writeShort(v), s.writeShort(a), s.writeShort(d), l = 16 * p, u = s.pos + l, o = null, _ = [], n)
      for (m = n[q], s.writeString(q), s.writeInt(t(m)), s.writeInt(u), s.writeInt(m.length), _ = _.concat(m), q === "head" && (o = u), u += m.length; u % 4; )
        _.push(0), u++;
    return s.write(_), i = 2981146554 - t(s.data), s.pos = o + 8, s.writeUInt32(i), s.data;
  }, t = function(n) {
    var i, s, l, a;
    for (n = Jk.call(n); n.length % 4; )
      n.push(0);
    for (l = new Rs(n), s = 0, i = 0, a = n.length; i < a; i = i += 4)
      s += l.readUInt32();
    return 4294967295 & s;
  }, e;
}(), XC1 = {}.hasOwnProperty, fi = function(t, e) {
  for (var n in e)
    XC1.call(e, n) && (t[n] = e[n]);
  function i() {
    this.constructor = t;
  }
  return i.prototype = e.prototype, t.prototype = new i(), t.__super__ = e.prototype, t;
};
_n = function() {
  function t(e) {
    var n;
    this.file = e, n = this.file.directory.tables[this.tag], this.exists = !!n, n && (this.offset = n.offset, this.length = n.length, this.parse(this.file.contents));
  }
  return t.prototype.parse = function() {
  }, t.prototype.encode = function() {
  }, t.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, t;
}();
var KC1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "head", e.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.revision = n.readInt(), this.checkSumAdjustment = n.readInt(), this.magicNumber = n.readInt(), this.flags = n.readShort(), this.unitsPerEm = n.readShort(), this.created = n.readLongLong(), this.modified = n.readLongLong(), this.xMin = n.readShort(), this.yMin = n.readShort(), this.xMax = n.readShort(), this.yMax = n.readShort(), this.macStyle = n.readShort(), this.lowestRecPPEM = n.readShort(), this.fontDirectionHint = n.readShort(), this.indexToLocFormat = n.readShort(), this.glyphDataFormat = n.readShort();
  }, e.prototype.encode = function(n) {
    var i;
    return (i = new Rs()).writeInt(this.version), i.writeInt(this.revision), i.writeInt(this.checkSumAdjustment), i.writeInt(this.magicNumber), i.writeShort(this.flags), i.writeShort(this.unitsPerEm), i.writeLongLong(this.created), i.writeLongLong(this.modified), i.writeShort(this.xMin), i.writeShort(this.yMin), i.writeShort(this.xMax), i.writeShort(this.yMax), i.writeShort(this.macStyle), i.writeShort(this.lowestRecPPEM), i.writeShort(this.fontDirectionHint), i.writeShort(n), i.writeShort(this.glyphDataFormat), i.data;
  }, e;
}(), eb = function() {
  function t(e, n) {
    var i, s, l, a, o, h, u, d, v, m, p, _, q, M, z, b, x;
    switch (this.platformID = e.readUInt16(), this.encodingID = e.readShort(), this.offset = n + e.readInt(), v = e.pos, e.pos = this.offset, this.format = e.readUInt16(), this.length = e.readUInt16(), this.language = e.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (h = 0; h < 256; ++h)
          this.codeMap[h] = e.readByte();
        break;
      case 4:
        for (p = e.readUInt16(), m = p / 2, e.pos += 6, l = function() {
          var k, F;
          for (F = [], h = k = 0; 0 <= m ? k < m : k > m; h = 0 <= m ? ++k : --k)
            F.push(e.readUInt16());
          return F;
        }(), e.pos += 2, q = function() {
          var k, F;
          for (F = [], h = k = 0; 0 <= m ? k < m : k > m; h = 0 <= m ? ++k : --k)
            F.push(e.readUInt16());
          return F;
        }(), u = function() {
          var k, F;
          for (F = [], h = k = 0; 0 <= m ? k < m : k > m; h = 0 <= m ? ++k : --k)
            F.push(e.readUInt16());
          return F;
        }(), d = function() {
          var k, F;
          for (F = [], h = k = 0; 0 <= m ? k < m : k > m; h = 0 <= m ? ++k : --k)
            F.push(e.readUInt16());
          return F;
        }(), s = (this.length - e.pos + this.offset) / 2, o = function() {
          var k, F;
          for (F = [], h = k = 0; 0 <= s ? k < s : k > s; h = 0 <= s ? ++k : --k)
            F.push(e.readUInt16());
          return F;
        }(), h = z = 0, x = l.length; z < x; h = ++z)
          for (M = l[h], i = b = _ = q[h]; _ <= M ? b <= M : b >= M; i = _ <= M ? ++b : --b)
            d[h] === 0 ? a = i + u[h] : (a = o[d[h] / 2 + (i - _) - (m - h)] || 0) !== 0 && (a += u[h]), this.codeMap[i] = 65535 & a;
    }
    e.pos = v;
  }
  return t.encode = function(e, n) {
    var i, s, l, a, o, h, u, d, v, m, p, _, q, M, z, b, x, k, F, D, R, V, J, K, P, O, G, j, Q, i1, h1, c1, M1, y1, A1, $, a1, n1, f1, w1, C1, E1, T1, n2, X1, a2;
    switch (j = new Rs(), a = Object.keys(e).sort(function(d2, y2) {
      return d2 - y2;
    }), n) {
      case "macroman":
        for (q = 0, M = function() {
          var d2 = [];
          for (_ = 0; _ < 256; ++_)
            d2.push(0);
          return d2;
        }(), b = { 0: 0 }, l = {}, Q = 0, M1 = a.length; Q < M1; Q++)
          b[T1 = e[s = a[Q]]] == null && (b[T1] = ++q), l[s] = { old: e[s], new: b[e[s]] }, M[s] = b[e[s]];
        return j.writeUInt16(1), j.writeUInt16(0), j.writeUInt32(12), j.writeUInt16(0), j.writeUInt16(262), j.writeUInt16(0), j.write(M), { charMap: l, subtable: j.data, maxGlyphID: q + 1 };
      case "unicode":
        for (O = [], v = [], x = 0, b = {}, i = {}, z = u = null, i1 = 0, y1 = a.length; i1 < y1; i1++)
          b[F = e[s = a[i1]]] == null && (b[F] = ++x), i[s] = { old: F, new: b[F] }, o = b[F] - s, z != null && o === u || (z && v.push(z), O.push(s), u = o), z = s;
        for (z && v.push(z), v.push(65535), O.push(65535), K = 2 * (J = O.length), V = 2 * Math.pow(Math.log(J) / Math.LN2, 2), m = Math.log(V / 2) / Math.LN2, R = 2 * J - V, h = [], D = [], p = [], _ = h1 = 0, A1 = O.length; h1 < A1; _ = ++h1) {
          if (P = O[_], d = v[_], P === 65535) {
            h.push(0), D.push(0);
            break;
          }
          if (P - (G = i[P].new) >= 32768)
            for (h.push(0), D.push(2 * (p.length + J - _)), s = c1 = P; P <= d ? c1 <= d : c1 >= d; s = P <= d ? ++c1 : --c1)
              p.push(i[s].new);
          else
            h.push(G - P), D.push(0);
        }
        for (j.writeUInt16(3), j.writeUInt16(1), j.writeUInt32(12), j.writeUInt16(4), j.writeUInt16(16 + 8 * J + 2 * p.length), j.writeUInt16(0), j.writeUInt16(K), j.writeUInt16(V), j.writeUInt16(m), j.writeUInt16(R), C1 = 0, $ = v.length; C1 < $; C1++)
          s = v[C1], j.writeUInt16(s);
        for (j.writeUInt16(0), E1 = 0, a1 = O.length; E1 < a1; E1++)
          s = O[E1], j.writeUInt16(s);
        for (n2 = 0, n1 = h.length; n2 < n1; n2++)
          o = h[n2], j.writeUInt16(o);
        for (X1 = 0, f1 = D.length; X1 < f1; X1++)
          k = D[X1], j.writeUInt16(k);
        for (a2 = 0, w1 = p.length; a2 < w1; a2++)
          q = p[a2], j.writeUInt16(q);
        return { charMap: i, subtable: j.data, maxGlyphID: x + 1 };
    }
  }, t;
}(), Zk = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "cmap", e.prototype.parse = function(n) {
    var i, s, l;
    for (n.pos = this.offset, this.version = n.readUInt16(), l = n.readUInt16(), this.tables = [], this.unicode = null, s = 0; 0 <= l ? s < l : s > l; s = 0 <= l ? ++s : --s)
      i = new eb(n, this.offset), this.tables.push(i), i.isUnicode && this.unicode == null && (this.unicode = i);
    return !0;
  }, e.encode = function(n, i) {
    var s, l;
    return i == null && (i = "macroman"), s = eb.encode(n, i), (l = new Rs()).writeUInt16(0), l.writeUInt16(1), s.table = l.data.concat(s.subtable), s;
  }, e;
}(), ZC1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "hhea", e.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.ascender = n.readShort(), this.decender = n.readShort(), this.lineGap = n.readShort(), this.advanceWidthMax = n.readShort(), this.minLeftSideBearing = n.readShort(), this.minRightSideBearing = n.readShort(), this.xMaxExtent = n.readShort(), this.caretSlopeRise = n.readShort(), this.caretSlopeRun = n.readShort(), this.caretOffset = n.readShort(), n.pos += 8, this.metricDataFormat = n.readShort(), this.numberOfMetrics = n.readUInt16();
  }, e;
}(), JC1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "OS/2", e.prototype.parse = function(n) {
    if (n.pos = this.offset, this.version = n.readUInt16(), this.averageCharWidth = n.readShort(), this.weightClass = n.readUInt16(), this.widthClass = n.readUInt16(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort(), this.ySubscriptYSize = n.readShort(), this.ySubscriptXOffset = n.readShort(), this.ySubscriptYOffset = n.readShort(), this.ySuperscriptXSize = n.readShort(), this.ySuperscriptYSize = n.readShort(), this.ySuperscriptXOffset = n.readShort(), this.ySuperscriptYOffset = n.readShort(), this.yStrikeoutSize = n.readShort(), this.yStrikeoutPosition = n.readShort(), this.familyClass = n.readShort(), this.panose = function() {
      var i, s;
      for (s = [], i = 0; i < 10; ++i)
        s.push(n.readByte());
      return s;
    }(), this.charRange = function() {
      var i, s;
      for (s = [], i = 0; i < 4; ++i)
        s.push(n.readInt());
      return s;
    }(), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), this.version > 0 && (this.ascent = n.readShort(), this.descent = n.readShort(), this.lineGap = n.readShort(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = function() {
      var i, s;
      for (s = [], i = 0; i < 2; i = ++i)
        s.push(n.readInt());
      return s;
    }(), this.version > 1))
      return this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort();
  }, e;
}(), QC1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "post", e.prototype.parse = function(n) {
    var i, s, l;
    switch (n.pos = this.offset, this.format = n.readInt(), this.italicAngle = n.readInt(), this.underlinePosition = n.readShort(), this.underlineThickness = n.readShort(), this.isFixedPitch = n.readInt(), this.minMemType42 = n.readInt(), this.maxMemType42 = n.readInt(), this.minMemType1 = n.readInt(), this.maxMemType1 = n.readInt(), this.format) {
      case 65536:
        break;
      case 131072:
        var a;
        for (s = n.readUInt16(), this.glyphNameIndex = [], a = 0; 0 <= s ? a < s : a > s; a = 0 <= s ? ++a : --a)
          this.glyphNameIndex.push(n.readUInt16());
        for (this.names = [], l = []; n.pos < this.offset + this.length; )
          i = n.readByte(), l.push(this.names.push(n.readString(i)));
        return l;
      case 151552:
        return s = n.readUInt16(), this.offsets = n.read(s);
      case 196608:
        break;
      case 262144:
        return this.map = (function() {
          var o, h, u;
          for (u = [], a = o = 0, h = this.file.maxp.numGlyphs; 0 <= h ? o < h : o > h; a = 0 <= h ? ++o : --o)
            u.push(n.readUInt32());
          return u;
        }).call(this);
    }
  }, e;
}(), ek1 = function(t, e) {
  this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, tk1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "name", e.prototype.parse = function(n) {
    var i, s, l, a, o, h, u, d, v, m, p;
    for (n.pos = this.offset, n.readShort(), i = n.readShort(), h = n.readShort(), s = [], a = 0; 0 <= i ? a < i : a > i; a = 0 <= i ? ++a : --a)
      s.push({ platformID: n.readShort(), encodingID: n.readShort(), languageID: n.readShort(), nameID: n.readShort(), length: n.readShort(), offset: this.offset + h + n.readShort() });
    for (u = {}, a = v = 0, m = s.length; v < m; a = ++v)
      l = s[a], n.pos = l.offset, d = n.readString(l.length), o = new ek1(d, l), u[p = l.nameID] == null && (u[p] = []), u[l.nameID].push(o);
    this.strings = u, this.copyright = u[0], this.fontFamily = u[1], this.fontSubfamily = u[2], this.uniqueSubfamily = u[3], this.fontName = u[4], this.version = u[5];
    try {
      this.postscriptName = u[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = u[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = u[7], this.manufacturer = u[8], this.designer = u[9], this.description = u[10], this.vendorUrl = u[11], this.designerUrl = u[12], this.license = u[13], this.licenseUrl = u[14], this.preferredFamily = u[15], this.preferredSubfamily = u[17], this.compatibleFull = u[18], this.sampleText = u[19];
  }, e;
}(), nk1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "maxp", e.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.numGlyphs = n.readUInt16(), this.maxPoints = n.readUInt16(), this.maxContours = n.readUInt16(), this.maxCompositePoints = n.readUInt16(), this.maxComponentContours = n.readUInt16(), this.maxZones = n.readUInt16(), this.maxTwilightPoints = n.readUInt16(), this.maxStorage = n.readUInt16(), this.maxFunctionDefs = n.readUInt16(), this.maxInstructionDefs = n.readUInt16(), this.maxStackElements = n.readUInt16(), this.maxSizeOfInstructions = n.readUInt16(), this.maxComponentElements = n.readUInt16(), this.maxComponentDepth = n.readUInt16();
  }, e;
}(), ik1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "hmtx", e.prototype.parse = function(n) {
    var i, s, l, a, o, h, u;
    for (n.pos = this.offset, this.metrics = [], i = 0, h = this.file.hhea.numberOfMetrics; 0 <= h ? i < h : i > h; i = 0 <= h ? ++i : --i)
      this.metrics.push({ advance: n.readUInt16(), lsb: n.readInt16() });
    for (l = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
      var d, v;
      for (v = [], i = d = 0; 0 <= l ? d < l : d > l; i = 0 <= l ? ++d : --d)
        v.push(n.readInt16());
      return v;
    }(), this.widths = (function() {
      var d, v, m, p;
      for (p = [], d = 0, v = (m = this.metrics).length; d < v; d++)
        a = m[d], p.push(a.advance);
      return p;
    }).call(this), s = this.widths[this.widths.length - 1], u = [], i = o = 0; 0 <= l ? o < l : o > l; i = 0 <= l ? ++o : --o)
      u.push(this.widths.push(s));
    return u;
  }, e.prototype.forGlyph = function(n) {
    return n in this.metrics ? this.metrics[n] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[n - this.metrics.length] };
  }, e;
}(), Jk = [].slice, sk1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "glyf", e.prototype.parse = function() {
    return this.cache = {};
  }, e.prototype.glyphFor = function(n) {
    var i, s, l, a, o, h, u, d, v, m;
    return n in this.cache ? this.cache[n] : (a = this.file.loca, i = this.file.contents, s = a.indexOf(n), (l = a.lengthOf(n)) === 0 ? this.cache[n] = null : (i.pos = this.offset + s, o = (h = new Rs(i.read(l))).readShort(), d = h.readShort(), m = h.readShort(), u = h.readShort(), v = h.readShort(), this.cache[n] = o === -1 ? new rk1(h, d, m, u, v) : new lk1(h, o, d, m, u, v), this.cache[n]));
  }, e.prototype.encode = function(n, i, s) {
    var l, a, o, h, u;
    for (o = [], a = [], h = 0, u = i.length; h < u; h++)
      l = n[i[h]], a.push(o.length), l && (o = o.concat(l.encode(s)));
    return a.push(o.length), { table: o, offsets: a };
  }, e;
}(), lk1 = function() {
  function t(e, n, i, s, l, a) {
    this.raw = e, this.numberOfContours = n, this.xMin = i, this.yMin = s, this.xMax = l, this.yMax = a, this.compound = !1;
  }
  return t.prototype.encode = function() {
    return this.raw.data;
  }, t;
}(), rk1 = function() {
  function t(e, n, i, s, l) {
    var a, o;
    for (this.raw = e, this.xMin = n, this.yMin = i, this.xMax = s, this.yMax = l, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o; )
      a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
  }
  return t.prototype.encode = function() {
    var e, n, i;
    for (n = new Rs(Jk.call(this.raw.data)), e = 0, i = this.glyphIDs.length; e < i; ++e)
      n.pos = this.glyphOffsets[e];
    return n.data;
  }, t;
}(), ak1 = function(t) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return fi(e, _n), e.prototype.tag = "loca", e.prototype.parse = function(n) {
    var i, s;
    return n.pos = this.offset, i = this.file.head.indexToLocFormat, this.offsets = i === 0 ? (function() {
      var l, a;
      for (a = [], s = 0, l = this.length; s < l; s += 2)
        a.push(2 * n.readUInt16());
      return a;
    }).call(this) : (function() {
      var l, a;
      for (a = [], s = 0, l = this.length; s < l; s += 4)
        a.push(n.readUInt32());
      return a;
    }).call(this);
  }, e.prototype.indexOf = function(n) {
    return this.offsets[n];
  }, e.prototype.lengthOf = function(n) {
    return this.offsets[n + 1] - this.offsets[n];
  }, e.prototype.encode = function(n, i) {
    for (var s = new Uint32Array(this.offsets.length), l = 0, a = 0, o = 0; o < s.length; ++o)
      if (s[o] = l, a < i.length && i[a] == o) {
        ++a, s[o] = l;
        var h = this.offsets[o], u = this.offsets[o + 1] - h;
        u > 0 && (l += u);
      }
    for (var d = new Array(4 * s.length), v = 0; v < s.length; ++v)
      d[4 * v + 3] = 255 & s[v], d[4 * v + 2] = (65280 & s[v]) >> 8, d[4 * v + 1] = (16711680 & s[v]) >> 16, d[4 * v] = (4278190080 & s[v]) >> 24;
    return d;
  }, e;
}(), ok1 = function() {
  function t(e) {
    this.font = e, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return t.prototype.generateCmap = function() {
    var e, n, i, s, l;
    for (n in s = this.font.cmap.tables[0].codeMap, e = {}, l = this.subset)
      i = l[n], e[n] = s[i];
    return e;
  }, t.prototype.glyphsFor = function(e) {
    var n, i, s, l, a, o, h;
    for (s = {}, a = 0, o = e.length; a < o; a++)
      s[l = e[a]] = this.font.glyf.glyphFor(l);
    for (l in n = [], s)
      (i = s[l]) != null && i.compound && n.push.apply(n, i.glyphIDs);
    if (n.length > 0)
      for (l in h = this.glyphsFor(n))
        i = h[l], s[l] = i;
    return s;
  }, t.prototype.encode = function(e, n) {
    var i, s, l, a, o, h, u, d, v, m, p, _, q, M, z;
    for (s in i = Zk.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(e), p = { 0: 0 }, z = i.charMap)
      p[(h = z[s]).old] = h.new;
    for (_ in m = i.maxGlyphID, a)
      _ in p || (p[_] = m++);
    return d = function(b) {
      var x, k;
      for (x in k = {}, b)
        k[b[x]] = x;
      return k;
    }(p), v = Object.keys(d).sort(function(b, x) {
      return b - x;
    }), q = function() {
      var b, x, k;
      for (k = [], b = 0, x = v.length; b < x; b++)
        o = v[b], k.push(d[o]);
      return k;
    }(), l = this.font.glyf.encode(a, q, p), u = this.font.loca.encode(l.offsets, q), M = { cmap: this.font.cmap.raw(), glyf: l.table, loca: u, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(n) }, this.font.os2.exists && (M["OS/2"] = this.font.os2.raw()), this.font.directory.encode(M);
  }, t;
}();
m3.API.PDFObject = function() {
  var t;
  function e() {
  }
  return t = function(n, i) {
    return (Array(i + 1).join("0") + n).slice(-i);
  }, e.convert = function(n) {
    var i, s, l, a;
    if (Array.isArray(n))
      return "[" + function() {
        var o, h, u;
        for (u = [], o = 0, h = n.length; o < h; o++)
          i = n[o], u.push(e.convert(i));
        return u;
      }().join(" ") + "]";
    if (typeof n == "string")
      return "/" + n;
    if (n != null && n.isString)
      return "(" + n + ")";
    if (n instanceof Date)
      return "(D:" + t(n.getUTCFullYear(), 4) + t(n.getUTCMonth(), 2) + t(n.getUTCDate(), 2) + t(n.getUTCHours(), 2) + t(n.getUTCMinutes(), 2) + t(n.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(n) === "[object Object]") {
      for (s in l = ["<<"], n)
        a = n[s], l.push("/" + s + " " + e.convert(a));
      return l.push(">>"), l.join(`
`);
    }
    return "" + n;
  }, e;
}();
function ck1(t, e, n) {
  const i = "a4", l = [297, 210], a = Math.round(l[0] * 150 / 25.4), o = Math.round(l[1] * 150 / 25.4), h = t.getSize(), u = t.getView().getResolution();
  t.once("rendercomplete", function() {
    const m = document.createElement("canvas");
    m.width = a, m.height = o;
    const p = m.getContext("2d");
    if (p) {
      if (Array.prototype.forEach.call(document.querySelectorAll(".ol-layer canvas"), function(_) {
        if (_.width > 0) {
          const q = _.parentNode.style.opacity;
          p.globalAlpha = q === "" ? 1 : Number(q);
          const z = _.style.transform.match(/^matrix\(([^(]*)\)$/)[1].split(",").map(Number);
          CanvasRenderingContext2D.prototype.setTransform.apply(p, z);
        }
      }), e === "pdf") {
        const _ = new m3("landscape", void 0, i);
        _.addImage(m.toDataURL("image/jpeg"), "JPEG", 0, 0, l[0], l[1]), _.save("map.pdf"), t.setSize(h), t.getView().setResolution(u);
      } else {
        const _ = document.createElement("a");
        _.download = "filename.png", _.href = m.toDataURL(), _.click();
      }
      n.click();
    }
  });
  const d = [a, o];
  t.setSize(d);
  const v = Math.min(a / h[0], o / h[1]);
  t.getView().setResolution(u / v);
}
const hk1 = [
  {
    id: "ES7",
    name: "Canarias (ES)",
    bbox: [
      [
        -18.158,
        27.638
      ],
      [
        -13.42,
        29.218
      ]
    ],
    parent: {
      code: "ES"
    }
  },
  {
    id: "FRY1",
    name: "Guadeloupe (FR)",
    bbox: [
      [
        -61.801,
        15.875
      ],
      [
        -61.198,
        16.51
      ]
    ],
    parent: {
      code: "FR"
    }
  },
  {
    id: "FRY2",
    name: "Martinique (FR)",
    bbox: [
      [
        -61.229,
        14.397
      ],
      [
        -60.825,
        14.878
      ]
    ],
    parent: {
      code: "FR"
    }
  },
  {
    id: "FRY3",
    name: "Guyane (FR)",
    bbox: [
      [
        -54.541,
        2.128
      ],
      [
        -51.625,
        5.744
      ]
    ],
    parent: {
      code: "FR"
    }
  },
  {
    id: "FRY4",
    name: "Réunion (FR)",
    bbox: [
      [
        55.219,
        -21.387
      ],
      [
        55.835,
        -20.882
      ]
    ],
    parent: {
      code: "FR"
    }
  },
  {
    id: "FRY5",
    name: "Mayotte (FR)",
    bbox: [
      [
        45.044,
        -12.994
      ],
      [
        45.236,
        -12.669
      ]
    ],
    parent: {
      code: "FR"
    }
  },
  {
    id: "PT2",
    name: "Açores (PT)",
    bbox: [
      [
        -31.268,
        36.945
      ],
      [
        -25.02,
        39.524
      ]
    ],
    parent: {
      code: "PT"
    }
  },
  {
    id: "PT3",
    name: "Madeira (PT)",
    bbox: [
      [
        -17.265,
        32.633
      ],
      [
        -16.745,
        32.87
      ]
    ],
    parent: {
      code: "PT"
    }
  }
], uk1 = {
  ES7: {
    top: 0,
    left: 0,
    height: "100%",
    width: "100%"
  },
  FRY1: {
    top: 0,
    left: 0,
    height: "50%",
    width: "50%"
  },
  FRY3: {
    top: "50%",
    left: 0,
    height: "50%",
    width: "50%"
  },
  FRY2: {
    top: 0,
    left: "50%",
    height: "33.33333%",
    width: "50%"
  },
  FRY4: {
    top: "33.33333%",
    left: "50%",
    height: "33.33333%",
    width: "50%"
  },
  FRY5: {
    top: "66.66666%",
    left: "50%",
    height: "33.33333%",
    width: "50%"
  },
  PT2: {
    top: 0,
    left: 0,
    height: "50%",
    width: "100%"
  },
  PT3: {
    top: "50%",
    left: 0,
    height: "50%",
    width: "100%"
  }
}, dk1 = {
  entities: hk1,
  positions: uk1
};
function vj1(t, e, n) {
  const i = s1.merge(
    {
      vueEvents: {},
      listType: "masonry"
    },
    n ?? {}
  ), s = new uC1(dk1), l = t9(), a = `outermost-region-group-list ${i.listType}`, o = D1(0), h = [], u = D1(!1), d = pc({}), v = () => {
    let x = typeof t == "string" ? document.getElementById(t) : t;
    if (s1.isNil(x)) {
      const k = document.getElementsByClassName("ecl-map");
      (k == null ? void 0 : k.length) > 0 && (x = k[0]);
    }
    return x;
  }, m = () => {
    const x = v().getElementsByClassName("ol-control");
    let k = 0;
    return s1.each(x, (F) => {
      if (F.classList.contains("ol-attribution") === !1) {
        const R = window.getComputedStyle(F), V = parseFloat(R.top) + parseFloat(R.marginTop) + parseFloat(R.paddingTop) + parseFloat(R.height) + 16;
        V > k && (k = V);
      }
    }), k;
  }, p = () => {
    const x = document.createElement("div");
    x.setAttribute("class", a), x.setAttribute("style", `top: ${m()}px`), s1.each(s.listByGroup, (k) => {
      const F = document.createElement("div");
      F.className = `outermost-regions-group orgroup--${k.parentCode}`, s1.each(k.regions, (D) => {
        const R = document.createElement("div");
        R.setAttribute("style", D.styles), R.className = `outermost-region orregion-${D.id}`, R.setAttribute("title", D.name);
        const V = document.createElement("span");
        V.className = "title", V.innerHTML = `<span>${D.name}</span>`;
        const J = document.createElement("div");
        J.className = "map", R.appendChild(V), R.appendChild(J), F.appendChild(R);
        const K = () => {
          const G = {};
          return s1.each(i.vueEvents, (j, Q) => {
            const i1 = "on" + Q[0].toUpperCase() + Q.slice(1);
            G[i1] = j;
          }), G;
        }, P = new Kx(), O = {
          component: Ok,
          props: {
            settings: d,
            ...K()
          },
          el: J,
          appContext: l == null ? void 0 : l.appContext
        };
        P.add(O, {}), D0(() => {
          setTimeout(() => {
            var Q, i1, h1;
            const G = ((Q = d.view) == null ? void 0 : Q.projection) ?? "EPSG:3857", j = yg1(_y(D.bbox), "EPSG:4326", G);
            (h1 = (i1 = P.getComponent()) == null ? void 0 : i1.mapInstance) == null || h1.getView().fit(j, { padding: [18, 3, 3, 3] });
          }, 60);
        }), h.push({ element: R, instance: P });
      }), x.appendChild(F);
    }), v().appendChild(x);
  }, _ = () => {
    s1.each(h, (k) => {
      k.instance.destroy();
    });
    const x = document.getElementsByClassName(a);
    s1.each(x, (k) => k.remove());
  }, q = () => {
    u.value = !u.value, H(u) ? p() : _();
  }, M = () => {
    var k;
    const x = s1.cloneDeep(H(e));
    return (k = x == null ? void 0 : x.view) != null && k.extent && (x.view.extent = void 0), s1.merge(x, {
      view: { projection: "EPSG:3857" },
      WMS: {
        defaultOptions: {
          srs: "EPSG:3857",
          crs: "EPSG:3857"
        }
      },
      olSettings: {
        extra: null,
        controls: {
          zoom: !1
        },
        interactions: {
          altShiftDragRotate: !1,
          doubleClickZoom: !1,
          keyboard: !1,
          mouseWheelZoom: !1,
          shiftDragZoom: !1,
          dragPan: !1,
          pinchRotate: !1,
          pinchZoom: !1
        }
      },
      customInteraction: null
    }), x;
  }, z = l3(
    () => H(e),
    () => {
      s1.assign(d, M()), d.attributions = void 0;
    }
  ), b = l3(
    () => u.value,
    (x) => {
      if (x) {
        const k = document.getElementsByClassName(a);
        !s1.isNil(k) && k.length > 0 && (o.value = k[0].getBoundingClientRect().width);
      } else
        o.value = 0;
    },
    {
      immediate: !0
    }
  );
  return mn(() => {
    z(), b();
  }), {
    orElementClass: a,
    orElementWidth: o,
    orShow: u,
    performToggleOR: q
  };
}
var Qk = { exports: {} };
(function(t, e) {
  (function(n, i) {
    t.exports = i();
  })(N5, function() {
    var n = "__v-click-outside", i = typeof window < "u", s = typeof navigator < "u", l = i && ("ontouchstart" in window || s && navigator.msMaxTouchPoints > 0) ? ["touchstart"] : ["click"], a = function(d) {
      var v = d.event, m = d.handler;
      (0, d.middleware)(v) && m(v);
    }, o = function(d, v) {
      var m = function(b) {
        var x = typeof b == "function";
        if (!x && typeof b != "object")
          throw new Error("v-click-outside: Binding value must be a function or an object");
        return { handler: x ? b : b.handler, middleware: b.middleware || function(k) {
          return k;
        }, events: b.events || l, isActive: b.isActive !== !1, detectIframe: b.detectIframe !== !1, capture: !!b.capture };
      }(v.value), p = m.handler, _ = m.middleware, q = m.detectIframe, M = m.capture;
      if (m.isActive) {
        if (d[n] = m.events.map(function(b) {
          return { event: b, srcTarget: document.documentElement, handler: function(x) {
            return function(k) {
              var F = k.el, D = k.event, R = k.handler, V = k.middleware, J = D.path || D.composedPath && D.composedPath();
              (J ? J.indexOf(F) < 0 : !F.contains(D.target)) && a({ event: D, handler: R, middleware: V });
            }({ el: d, event: x, handler: p, middleware: _ });
          }, capture: M };
        }), q) {
          var z = { event: "blur", srcTarget: window, handler: function(b) {
            return function(x) {
              var k = x.el, F = x.event, D = x.handler, R = x.middleware;
              setTimeout(function() {
                var V = document.activeElement;
                V && V.tagName === "IFRAME" && !k.contains(V) && a({ event: F, handler: D, middleware: R });
              }, 0);
            }({ el: d, event: b, handler: p, middleware: _ });
          }, capture: M };
          d[n] = [].concat(d[n], [z]);
        }
        d[n].forEach(function(b) {
          var x = b.event, k = b.srcTarget, F = b.handler;
          return setTimeout(function() {
            d[n] && k.addEventListener(x, F, M);
          }, 0);
        });
      }
    }, h = function(d) {
      (d[n] || []).forEach(function(v) {
        return v.srcTarget.removeEventListener(v.event, v.handler, v.capture);
      }), delete d[n];
    }, u = i ? { beforeMount: o, updated: function(d, v) {
      var m = v.value, p = v.oldValue;
      JSON.stringify(m) !== JSON.stringify(p) && (h(d), o(d, { value: m }));
    }, unmounted: h } : {};
    return { install: function(d) {
      d.directive("click-outside", u);
    }, directive: u };
  });
})(Qk);
var fk1 = Qk.exports;
const vk1 = /* @__PURE__ */ Pu(fk1);
class eE {
  constructor() {
    O2(this, "_map");
    this._map = /* @__PURE__ */ new Map();
  }
  get size() {
    return this._map.size;
  }
  get(e) {
    return this._map.get(JSON.stringify(e));
  }
  has(e) {
    return this._map.has(JSON.stringify(e));
  }
  set(e, n) {
    return this._map.set(JSON.stringify(e), n), this;
  }
  clear() {
    this._map.clear();
  }
  delete(e) {
    return this._map.delete(JSON.stringify(e));
  }
  forEach(e, n) {
    this._map.forEach((i, s) => {
      e.call(n, i, JSON.parse(s), this);
    });
  }
}
class pk1 extends eE {
  // Stora la lunghezza della value organizzandola per anno
  // private valueLngByYear = new JclDataViewerJsonMap<number, number>();
  // /**
  //  * Recupera la lunghezza (numero caratteri) della value e la salva per anno
  //  * solo se è maggiore della vecchia lughezza salvata
  //  *
  //  * @param (Number) year
  //  * @param (String) value
  //  */
  // private addLength(year: JclDataViewerCell['year'], value: string | null): void {
  //   const _storedLength = this.valueLngByYear.get(year);
  //   let length = `${value}`?.length ?? 0;
  //   if (!isNil(_storedLength) && _storedLength > length) {
  //     length = _storedLength;
  //   }
  //   this.valueLngByYear.set(year, length);
  // }
  // public getMaxLng(year: JclDataViewerCell['year']) {
  //   return this.valueLngByYear.get(year);
  // }
  add(e) {
    return this.set([e.nuts.code, e.year], e);
  }
  get(e, n = !1) {
    if (this.has(e))
      return super.get(e);
    if (n) {
      const i = e[0], s = e[1];
      return Ja.Empty(i, "", s);
    }
  }
}
class mk1 extends eE {
  add(e) {
    return this.set([e.code], e);
  }
  get(e) {
    if (this.has(e))
      return super.get(e);
  }
  /**
   * Returns a sorted list of `NutsItem` objects based on their code, with
   * items starting with 'EU' appearing first.
   * @returns {JclDataViewerNutsItem[]} - array of `NutsItem` objects.
   */
  getKeyList() {
    return s1.orderBy(
      [...this._map.values()],
      [(e) => e.code.indexOf("EU") === 0, (e) => e.code],
      ["desc", "asc"]
    );
  }
}
class Ja {
  constructor(e, n) {
    O2(this, "valueRef", D1(null));
    O2(this, "valueFormatted");
    O2(this, "year");
    O2(this, "nuts");
    O2(this, "annotation");
    O2(this, "annotationId");
    O2(this, "classificationId");
    O2(this, "classification");
    O2(this, "extra");
    O2(this, "isEditedRef", D1(!1));
    var l, a;
    const i = this;
    this.valueRef = D1(Ja.parseValue(e.value).value);
    const s = {};
    if (s1.isNil(n == null ? void 0 : n.formatNumberOptions) || Object.assign(s, n.formatNumberOptions), this.valueFormatted = g1(() => xT1(H(i.valueRef), s)), this.year = e.year, this.nuts = e.nuts, this.annotationId = e == null ? void 0 : e.annotationId, this.classificationId = e == null ? void 0 : e.classificationId, this.extra = s1.omit(e, ["value", "year", "nuts", "annotationId", "classificationId"]), n) {
      const o = n == null ? void 0 : n.cellClassification;
      !s1.isNil(this.classificationId) && ((l = o ?? []) == null ? void 0 : l.length) > 0 && (this.classification = s1.find(o, (u) => u.id === this.classificationId));
      const h = n == null ? void 0 : n.annotationClassification;
      !s1.isNil(this.annotationId) && ((a = h ?? []) == null ? void 0 : a.length) > 0 && (this.annotation = s1.find(h, (u) => u.id === this.annotationId));
    }
  }
  static Empty(e, n, i) {
    return new Ja({ nuts: { code: e, label: n }, year: i });
  }
  set value(e) {
    this.isEditedRef.value = !0, this.valueRef.value = s1.isNil(e) ? null : e;
  }
  get value() {
    return H(this.valueRef);
  }
  get isEdited() {
    return H(this.isEditedRef);
  }
  static parseValue(e) {
    if (s1.isNil(e) || e === "" || e === "null" || e === void 0)
      return { valid: !0, value: null };
    if (s1.isNumber(e))
      return { valid: !0, value: e };
    const n = `${e}`;
    let i;
    const s = s1.lastIndexOf(n, ","), l = s1.lastIndexOf(n, ".");
    if (s > l) {
      const a = n.replace(/\./g, "").replace(/,/g, ".");
      i = parseFloat(a);
    } else {
      const a = n.replace(/,/g, "");
      i = parseFloat(a);
    }
    return isNaN(i) ? { valid: !1, value: i } : { valid: !0, value: i };
  }
}
class gk1 {
  constructor(e) {
    O2(this, "id");
    O2(this, "code");
    O2(this, "name");
    O2(this, "description");
    O2(this, "styles");
    O2(this, "stylesComputed", {});
    this.id = e == null ? void 0 : e.id, this.code = e == null ? void 0 : e.code, this.name = e == null ? void 0 : e.name, this.description = (e == null ? void 0 : e.description) ?? void 0;
    const n = (e == null ? void 0 : e.styles) ?? void 0;
    this.styles = n, n && (n != null && n.bold && s1.assign(this.stylesComputed, { "font-weight": "bold" }), n != null && n.italic && s1.assign(this.stylesComputed, { "font-style": "italic" }), n != null && n.underlined && s1.assign(this.stylesComputed, { "text-decoration": "underline" }), n != null && n.color && s1.assign(this.stylesComputed, { color: `${n.color}` }), n != null && n.backgroundColor && s1.assign(this.stylesComputed, { "background-color": `${n.backgroundColor}` }));
  }
  get textStyles() {
    return s1.reduce(
      this.stylesComputed,
      (e, n, i) => (i !== "background-color" && e.push(`${i}: ${n}`), e),
      []
    ).join("; ");
  }
  get backgroundStyles() {
    return s1.reduce(
      this.stylesComputed,
      (e, n, i) => (i === "background-color" && e.push(`${i}: ${n}`), e),
      []
    ).join("; ");
  }
}
class yk1 {
  constructor(e) {
    O2(this, "id");
    O2(this, "code");
    O2(this, "description");
    O2(this, "styles");
    O2(this, "stylesComputed", {});
    this.id = e.id, this.code = e == null ? void 0 : e.code, this.description = e == null ? void 0 : e.description;
    const n = (e == null ? void 0 : e.styles) ?? void 0;
    this.styles = n, n && n != null && n.boxShadowColor && s1.assign(this.stylesComputed, { "box-shadow": `${n.boxShadowColor} 0px 0px 4px .5px inset` });
  }
  get textStyles() {
    return s1.reduce(
      this.stylesComputed,
      (e, n, i) => (i !== "box-shadow" && e.push(`${i}: ${n}`), e),
      []
    ).join("; ");
  }
  get backgroundStyles() {
    return s1.reduce(
      this.stylesComputed,
      (e, n, i) => (i === "box-shadow" && e.push(`${i}: ${n}`), e),
      []
    ).join("; ");
  }
}
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var tE;
function P2() {
  return tE.apply(null, arguments);
}
function _k1(t) {
  tE = t;
}
function vn(t) {
  return t instanceof Array || Object.prototype.toString.call(t) === "[object Array]";
}
function dr(t) {
  return t != null && Object.prototype.toString.call(t) === "[object Object]";
}
function Me(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Kq(t) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(t).length === 0;
  var e;
  for (e in t)
    if (Me(t, e))
      return !1;
  return !0;
}
function n0(t) {
  return t === void 0;
}
function L8(t) {
  return typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]";
}
function Ic(t) {
  return t instanceof Date || Object.prototype.toString.call(t) === "[object Date]";
}
function nE(t, e) {
  var n = [], i, s = t.length;
  for (i = 0; i < s; ++i)
    n.push(e(t[i], i));
  return n;
}
function bs(t, e) {
  for (var n in e)
    Me(e, n) && (t[n] = e[n]);
  return Me(e, "toString") && (t.toString = e.toString), Me(e, "valueOf") && (t.valueOf = e.valueOf), t;
}
function vi(t, e, n, i) {
  return xE(t, e, n, i, !0).utc();
}
function qk1() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function H3(t) {
  return t._pf == null && (t._pf = qk1()), t._pf;
}
var n_;
Array.prototype.some ? n_ = Array.prototype.some : n_ = function(t) {
  var e = Object(this), n = e.length >>> 0, i;
  for (i = 0; i < n; i++)
    if (i in e && t.call(this, e[i], i, e))
      return !0;
  return !1;
};
function Zq(t) {
  if (t._isValid == null) {
    var e = H3(t), n = n_.call(e.parsedDateParts, function(s) {
      return s != null;
    }), i = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && n);
    if (t._strict && (i = i && e.charsLeftOver === 0 && e.unusedTokens.length === 0 && e.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(t))
      t._isValid = i;
    else
      return i;
  }
  return t._isValid;
}
function ud(t) {
  var e = vi(NaN);
  return t != null ? bs(H3(e), t) : H3(e).userInvalidated = !0, e;
}
var tb = P2.momentProperties = [], ny = !1;
function Jq(t, e) {
  var n, i, s, l = tb.length;
  if (n0(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), n0(e._i) || (t._i = e._i), n0(e._f) || (t._f = e._f), n0(e._l) || (t._l = e._l), n0(e._strict) || (t._strict = e._strict), n0(e._tzm) || (t._tzm = e._tzm), n0(e._isUTC) || (t._isUTC = e._isUTC), n0(e._offset) || (t._offset = e._offset), n0(e._pf) || (t._pf = H3(e)), n0(e._locale) || (t._locale = e._locale), l > 0)
    for (n = 0; n < l; n++)
      i = tb[n], s = e[i], n0(s) || (t[i] = s);
  return t;
}
function Oc(t) {
  Jq(this, t), this._d = new Date(t._d != null ? t._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), ny === !1 && (ny = !0, P2.updateOffset(this), ny = !1);
}
function pn(t) {
  return t instanceof Oc || t != null && t._isAMomentObject != null;
}
function iE(t) {
  P2.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + t);
}
function E6(t, e) {
  var n = !0;
  return bs(function() {
    if (P2.deprecationHandler != null && P2.deprecationHandler(null, t), n) {
      var i = [], s, l, a, o = arguments.length;
      for (l = 0; l < o; l++) {
        if (s = "", typeof arguments[l] == "object") {
          s += `
[` + l + "] ";
          for (a in arguments[0])
            Me(arguments[0], a) && (s += a + ": " + arguments[0][a] + ", ");
          s = s.slice(0, -2);
        } else
          s = arguments[l];
        i.push(s);
      }
      iE(
        t + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return e.apply(this, arguments);
  }, e);
}
var nb = {};
function sE(t, e) {
  P2.deprecationHandler != null && P2.deprecationHandler(t, e), nb[t] || (iE(e), nb[t] = !0);
}
P2.suppressDeprecationWarnings = !1;
P2.deprecationHandler = null;
function pi(t) {
  return typeof Function < "u" && t instanceof Function || Object.prototype.toString.call(t) === "[object Function]";
}
function wk1(t) {
  var e, n;
  for (n in t)
    Me(t, n) && (e = t[n], pi(e) ? this[n] = e : this["_" + n] = e);
  this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function i_(t, e) {
  var n = bs({}, t), i;
  for (i in e)
    Me(e, i) && (dr(t[i]) && dr(e[i]) ? (n[i] = {}, bs(n[i], t[i]), bs(n[i], e[i])) : e[i] != null ? n[i] = e[i] : delete n[i]);
  for (i in t)
    Me(t, i) && !Me(e, i) && dr(t[i]) && (n[i] = bs({}, n[i]));
  return n;
}
function Qq(t) {
  t != null && this.set(t);
}
var s_;
Object.keys ? s_ = Object.keys : s_ = function(t) {
  var e, n = [];
  for (e in t)
    Me(t, e) && n.push(e);
  return n;
};
var zk1 = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Mk1(t, e, n) {
  var i = this._calendar[t] || this._calendar.sameElse;
  return pi(i) ? i.call(e, n) : i;
}
function ci(t, e, n) {
  var i = "" + Math.abs(t), s = e - i.length, l = t >= 0;
  return (l ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + i;
}
var ew = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, uh = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, iy = {}, Fa = {};
function r3(t, e, n, i) {
  var s = i;
  typeof i == "string" && (s = function() {
    return this[i]();
  }), t && (Fa[t] = s), e && (Fa[e[0]] = function() {
    return ci(s.apply(this, arguments), e[1], e[2]);
  }), n && (Fa[n] = function() {
    return this.localeData().ordinal(
      s.apply(this, arguments),
      t
    );
  });
}
function bk1(t) {
  return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
}
function Lk1(t) {
  var e = t.match(ew), n, i;
  for (n = 0, i = e.length; n < i; n++)
    Fa[e[n]] ? e[n] = Fa[e[n]] : e[n] = bk1(e[n]);
  return function(s) {
    var l = "", a;
    for (a = 0; a < i; a++)
      l += pi(e[a]) ? e[a].call(s, t) : e[a];
    return l;
  };
}
function Sh(t, e) {
  return t.isValid() ? (e = lE(e, t.localeData()), iy[e] = iy[e] || Lk1(e), iy[e](t)) : t.localeData().invalidDate();
}
function lE(t, e) {
  var n = 5;
  function i(s) {
    return e.longDateFormat(s) || s;
  }
  for (uh.lastIndex = 0; n >= 0 && uh.test(t); )
    t = t.replace(
      uh,
      i
    ), uh.lastIndex = 0, n -= 1;
  return t;
}
var xk1 = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Sk1(t) {
  var e = this._longDateFormat[t], n = this._longDateFormat[t.toUpperCase()];
  return e || !n ? e : (this._longDateFormat[t] = n.match(ew).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[t]);
}
var Ck1 = "Invalid date";
function kk1() {
  return this._invalidDate;
}
var Ek1 = "%d", Ak1 = /\d{1,2}/;
function Fk1(t) {
  return this._ordinal.replace("%d", t);
}
var Tk1 = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Ik1(t, e, n, i) {
  var s = this._relativeTime[n];
  return pi(s) ? s(t, e, n, i) : s.replace(/%d/i, t);
}
function Ok1(t, e) {
  var n = this._relativeTime[t > 0 ? "future" : "past"];
  return pi(n) ? n(e) : n.replace(/%s/i, e);
}
var Eo = {};
function g5(t, e) {
  var n = t.toLowerCase();
  Eo[n] = Eo[n + "s"] = Eo[e] = t;
}
function A6(t) {
  return typeof t == "string" ? Eo[t] || Eo[t.toLowerCase()] : void 0;
}
function tw(t) {
  var e = {}, n, i;
  for (i in t)
    Me(t, i) && (n = A6(i), n && (e[n] = t[i]));
  return e;
}
var rE = {};
function y5(t, e) {
  rE[t] = e;
}
function Nk1(t) {
  var e = [], n;
  for (n in t)
    Me(t, n) && e.push({ unit: n, priority: rE[n] });
  return e.sort(function(i, s) {
    return i.priority - s.priority;
  }), e;
}
function dd(t) {
  return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
}
function _6(t) {
  return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
}
function X3(t) {
  var e = +t, n = 0;
  return e !== 0 && isFinite(e) && (n = _6(e)), n;
}
function o9(t, e) {
  return function(n) {
    return n != null ? (aE(this, t, n), P2.updateOffset(this, e), this) : vu(this, t);
  };
}
function vu(t, e) {
  return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN;
}
function aE(t, e, n) {
  t.isValid() && !isNaN(n) && (e === "FullYear" && dd(t.year()) && t.month() === 1 && t.date() === 29 ? (n = X3(n), t._d["set" + (t._isUTC ? "UTC" : "") + e](
    n,
    t.month(),
    yd(n, t.month())
  )) : t._d["set" + (t._isUTC ? "UTC" : "") + e](n));
}
function Pk1(t) {
  return t = A6(t), pi(this[t]) ? this[t]() : this;
}
function Bk1(t, e) {
  if (typeof t == "object") {
    t = tw(t);
    var n = Nk1(t), i, s = n.length;
    for (i = 0; i < s; i++)
      this[n[i].unit](t[n[i].unit]);
  } else if (t = A6(t), pi(this[t]))
    return this[t](e);
  return this;
}
var oE = /\d/, j0 = /\d\d/, cE = /\d{3}/, nw = /\d{4}/, fd = /[+-]?\d{6}/, gt = /\d\d?/, hE = /\d\d\d\d?/, uE = /\d\d\d\d\d\d?/, vd = /\d{1,3}/, iw = /\d{1,4}/, pd = /[+-]?\d{1,6}/, c9 = /\d+/, md = /[+-]?\d+/, Vk1 = /Z|[+-]\d\d:?\d\d/gi, gd = /Z|[+-]\d\d(?::?\d\d)?/gi, Rk1 = /[+-]?\d+(\.\d{1,3})?/, Nc = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, pu;
pu = {};
function U2(t, e, n) {
  pu[t] = pi(e) ? e : function(i, s) {
    return i && n ? n : e;
  };
}
function Hk1(t, e) {
  return Me(pu, t) ? pu[t](e._strict, e._locale) : new RegExp(Dk1(t));
}
function Dk1(t) {
  return R0(
    t.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(e, n, i, s, l) {
        return n || i || s || l;
      }
    )
  );
}
function R0(t) {
  return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var l_ = {};
function et(t, e) {
  var n, i = e, s;
  for (typeof t == "string" && (t = [t]), L8(e) && (i = function(l, a) {
    a[e] = X3(l);
  }), s = t.length, n = 0; n < s; n++)
    l_[t[n]] = i;
}
function Pc(t, e) {
  et(t, function(n, i, s, l) {
    s._w = s._w || {}, e(n, s._w, s, l);
  });
}
function $k1(t, e, n) {
  e != null && Me(l_, t) && l_[t](e, n._a, n, t);
}
var p5 = 0, d8 = 1, Wn = 2, x4 = 3, an = 4, f8 = 5, lr = 6, Uk1 = 7, jk1 = 8;
function Gk1(t, e) {
  return (t % e + e) % e;
}
var Zt;
Array.prototype.indexOf ? Zt = Array.prototype.indexOf : Zt = function(t) {
  var e;
  for (e = 0; e < this.length; ++e)
    if (this[e] === t)
      return e;
  return -1;
};
function yd(t, e) {
  if (isNaN(t) || isNaN(e))
    return NaN;
  var n = Gk1(e, 12);
  return t += (e - n) / 12, n === 1 ? dd(t) ? 29 : 28 : 31 - n % 7 % 2;
}
r3("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
r3("MMM", 0, 0, function(t) {
  return this.localeData().monthsShort(this, t);
});
r3("MMMM", 0, 0, function(t) {
  return this.localeData().months(this, t);
});
g5("month", "M");
y5("month", 8);
U2("M", gt);
U2("MM", gt, j0);
U2("MMM", function(t, e) {
  return e.monthsShortRegex(t);
});
U2("MMMM", function(t, e) {
  return e.monthsRegex(t);
});
et(["M", "MM"], function(t, e) {
  e[d8] = X3(t) - 1;
});
et(["MMM", "MMMM"], function(t, e, n, i) {
  var s = n._locale.monthsParse(t, i, n._strict);
  s != null ? e[d8] = s : H3(n).invalidMonth = t;
});
var Wk1 = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), dE = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), fE = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Yk1 = Nc, Xk1 = Nc;
function Kk1(t, e) {
  return t ? vn(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || fE).test(e) ? "format" : "standalone"][t.month()] : vn(this._months) ? this._months : this._months.standalone;
}
function Zk1(t, e) {
  return t ? vn(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[fE.test(e) ? "format" : "standalone"][t.month()] : vn(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Jk1(t, e, n) {
  var i, s, l, a = t.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      l = vi([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        l,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(l, "").toLocaleLowerCase();
  return n ? e === "MMM" ? (s = Zt.call(this._shortMonthsParse, a), s !== -1 ? s : null) : (s = Zt.call(this._longMonthsParse, a), s !== -1 ? s : null) : e === "MMM" ? (s = Zt.call(this._shortMonthsParse, a), s !== -1 ? s : (s = Zt.call(this._longMonthsParse, a), s !== -1 ? s : null)) : (s = Zt.call(this._longMonthsParse, a), s !== -1 ? s : (s = Zt.call(this._shortMonthsParse, a), s !== -1 ? s : null));
}
function Qk1(t, e, n) {
  var i, s, l;
  if (this._monthsParseExact)
    return Jk1.call(this, t, e, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++) {
    if (s = vi([2e3, i]), n && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(s, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(s, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[i] && (l = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[i] = new RegExp(l.replace(".", ""), "i")), n && e === "MMMM" && this._longMonthsParse[i].test(t))
      return i;
    if (n && e === "MMM" && this._shortMonthsParse[i].test(t))
      return i;
    if (!n && this._monthsParse[i].test(t))
      return i;
  }
}
function vE(t, e) {
  var n;
  if (!t.isValid())
    return t;
  if (typeof e == "string") {
    if (/^\d+$/.test(e))
      e = X3(e);
    else if (e = t.localeData().monthsParse(e), !L8(e))
      return t;
  }
  return n = Math.min(t.date(), yd(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, n), t;
}
function pE(t) {
  return t != null ? (vE(this, t), P2.updateOffset(this, !0), this) : vu(this, "Month");
}
function eE1() {
  return yd(this.year(), this.month());
}
function tE1(t) {
  return this._monthsParseExact ? (Me(this, "_monthsRegex") || mE.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Me(this, "_monthsShortRegex") || (this._monthsShortRegex = Yk1), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function nE1(t) {
  return this._monthsParseExact ? (Me(this, "_monthsRegex") || mE.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (Me(this, "_monthsRegex") || (this._monthsRegex = Xk1), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
}
function mE() {
  function t(a, o) {
    return o.length - a.length;
  }
  var e = [], n = [], i = [], s, l;
  for (s = 0; s < 12; s++)
    l = vi([2e3, s]), e.push(this.monthsShort(l, "")), n.push(this.months(l, "")), i.push(this.months(l, "")), i.push(this.monthsShort(l, ""));
  for (e.sort(t), n.sort(t), i.sort(t), s = 0; s < 12; s++)
    e[s] = R0(e[s]), n[s] = R0(n[s]);
  for (s = 0; s < 24; s++)
    i[s] = R0(i[s]);
  this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
r3("Y", 0, 0, function() {
  var t = this.year();
  return t <= 9999 ? ci(t, 4) : "+" + t;
});
r3(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
r3(0, ["YYYY", 4], 0, "year");
r3(0, ["YYYYY", 5], 0, "year");
r3(0, ["YYYYYY", 6, !0], 0, "year");
g5("year", "y");
y5("year", 1);
U2("Y", md);
U2("YY", gt, j0);
U2("YYYY", iw, nw);
U2("YYYYY", pd, fd);
U2("YYYYYY", pd, fd);
et(["YYYYY", "YYYYYY"], p5);
et("YYYY", function(t, e) {
  e[p5] = t.length === 2 ? P2.parseTwoDigitYear(t) : X3(t);
});
et("YY", function(t, e) {
  e[p5] = P2.parseTwoDigitYear(t);
});
et("Y", function(t, e) {
  e[p5] = parseInt(t, 10);
});
function Ao(t) {
  return dd(t) ? 366 : 365;
}
P2.parseTwoDigitYear = function(t) {
  return X3(t) + (X3(t) > 68 ? 1900 : 2e3);
};
var gE = o9("FullYear", !0);
function iE1() {
  return dd(this.year());
}
function sE1(t, e, n, i, s, l, a) {
  var o;
  return t < 100 && t >= 0 ? (o = new Date(t + 400, e, n, i, s, l, a), isFinite(o.getFullYear()) && o.setFullYear(t)) : o = new Date(t, e, n, i, s, l, a), o;
}
function hc(t) {
  var e, n;
  return t < 100 && t >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = t + 400, e = new Date(Date.UTC.apply(null, n)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t)) : e = new Date(Date.UTC.apply(null, arguments)), e;
}
function mu(t, e, n) {
  var i = 7 + e - n, s = (7 + hc(t, 0, i).getUTCDay() - e) % 7;
  return -s + i - 1;
}
function yE(t, e, n, i, s) {
  var l = (7 + n - i) % 7, a = mu(t, i, s), o = 1 + 7 * (e - 1) + l + a, h, u;
  return o <= 0 ? (h = t - 1, u = Ao(h) + o) : o > Ao(t) ? (h = t + 1, u = o - Ao(t)) : (h = t, u = o), {
    year: h,
    dayOfYear: u
  };
}
function uc(t, e, n) {
  var i = mu(t.year(), e, n), s = Math.floor((t.dayOfYear() - i - 1) / 7) + 1, l, a;
  return s < 1 ? (a = t.year() - 1, l = s + q8(a, e, n)) : s > q8(t.year(), e, n) ? (l = s - q8(t.year(), e, n), a = t.year() + 1) : (a = t.year(), l = s), {
    week: l,
    year: a
  };
}
function q8(t, e, n) {
  var i = mu(t, e, n), s = mu(t + 1, e, n);
  return (Ao(t) - i + s) / 7;
}
r3("w", ["ww", 2], "wo", "week");
r3("W", ["WW", 2], "Wo", "isoWeek");
g5("week", "w");
g5("isoWeek", "W");
y5("week", 5);
y5("isoWeek", 5);
U2("w", gt);
U2("ww", gt, j0);
U2("W", gt);
U2("WW", gt, j0);
Pc(
  ["w", "ww", "W", "WW"],
  function(t, e, n, i) {
    e[i.substr(0, 1)] = X3(t);
  }
);
function lE1(t) {
  return uc(t, this._week.dow, this._week.doy).week;
}
var rE1 = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function aE1() {
  return this._week.dow;
}
function oE1() {
  return this._week.doy;
}
function cE1(t) {
  var e = this.localeData().week(this);
  return t == null ? e : this.add((t - e) * 7, "d");
}
function hE1(t) {
  var e = uc(this, 1, 4).week;
  return t == null ? e : this.add((t - e) * 7, "d");
}
r3("d", 0, "do", "day");
r3("dd", 0, 0, function(t) {
  return this.localeData().weekdaysMin(this, t);
});
r3("ddd", 0, 0, function(t) {
  return this.localeData().weekdaysShort(this, t);
});
r3("dddd", 0, 0, function(t) {
  return this.localeData().weekdays(this, t);
});
r3("e", 0, 0, "weekday");
r3("E", 0, 0, "isoWeekday");
g5("day", "d");
g5("weekday", "e");
g5("isoWeekday", "E");
y5("day", 11);
y5("weekday", 11);
y5("isoWeekday", 11);
U2("d", gt);
U2("e", gt);
U2("E", gt);
U2("dd", function(t, e) {
  return e.weekdaysMinRegex(t);
});
U2("ddd", function(t, e) {
  return e.weekdaysShortRegex(t);
});
U2("dddd", function(t, e) {
  return e.weekdaysRegex(t);
});
Pc(["dd", "ddd", "dddd"], function(t, e, n, i) {
  var s = n._locale.weekdaysParse(t, i, n._strict);
  s != null ? e.d = s : H3(n).invalidWeekday = t;
});
Pc(["d", "e", "E"], function(t, e, n, i) {
  e[i] = X3(t);
});
function uE1(t, e) {
  return typeof t != "string" ? t : isNaN(t) ? (t = e.weekdaysParse(t), typeof t == "number" ? t : null) : parseInt(t, 10);
}
function dE1(t, e) {
  return typeof t == "string" ? e.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t;
}
function sw(t, e) {
  return t.slice(e, 7).concat(t.slice(0, e));
}
var fE1 = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), _E = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), vE1 = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), pE1 = Nc, mE1 = Nc, gE1 = Nc;
function yE1(t, e) {
  var n = vn(this._weekdays) ? this._weekdays : this._weekdays[t && t !== !0 && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
  return t === !0 ? sw(n, this._week.dow) : t ? n[t.day()] : n;
}
function _E1(t) {
  return t === !0 ? sw(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
}
function qE1(t) {
  return t === !0 ? sw(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
}
function wE1(t, e, n) {
  var i, s, l, a = t.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      l = vi([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        l,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        l,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(l, "").toLocaleLowerCase();
  return n ? e === "dddd" ? (s = Zt.call(this._weekdaysParse, a), s !== -1 ? s : null) : e === "ddd" ? (s = Zt.call(this._shortWeekdaysParse, a), s !== -1 ? s : null) : (s = Zt.call(this._minWeekdaysParse, a), s !== -1 ? s : null) : e === "dddd" ? (s = Zt.call(this._weekdaysParse, a), s !== -1 || (s = Zt.call(this._shortWeekdaysParse, a), s !== -1) ? s : (s = Zt.call(this._minWeekdaysParse, a), s !== -1 ? s : null)) : e === "ddd" ? (s = Zt.call(this._shortWeekdaysParse, a), s !== -1 || (s = Zt.call(this._weekdaysParse, a), s !== -1) ? s : (s = Zt.call(this._minWeekdaysParse, a), s !== -1 ? s : null)) : (s = Zt.call(this._minWeekdaysParse, a), s !== -1 || (s = Zt.call(this._weekdaysParse, a), s !== -1) ? s : (s = Zt.call(this._shortWeekdaysParse, a), s !== -1 ? s : null));
}
function zE1(t, e, n) {
  var i, s, l;
  if (this._weekdaysParseExact)
    return wE1.call(this, t, e, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++) {
    if (s = vi([2e3, 1]).day(i), n && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (l = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[i] = new RegExp(l.replace(".", ""), "i")), n && e === "dddd" && this._fullWeekdaysParse[i].test(t))
      return i;
    if (n && e === "ddd" && this._shortWeekdaysParse[i].test(t))
      return i;
    if (n && e === "dd" && this._minWeekdaysParse[i].test(t))
      return i;
    if (!n && this._weekdaysParse[i].test(t))
      return i;
  }
}
function ME1(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var e = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return t != null ? (t = uE1(t, this.localeData()), this.add(t - e, "d")) : e;
}
function bE1(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return t == null ? e : this.add(t - e, "d");
}
function LE1(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    var e = dE1(t, this.localeData());
    return this.day(this.day() % 7 ? e : e - 7);
  } else
    return this.day() || 7;
}
function xE1(t) {
  return this._weekdaysParseExact ? (Me(this, "_weekdaysRegex") || lw.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Me(this, "_weekdaysRegex") || (this._weekdaysRegex = pE1), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function SE1(t) {
  return this._weekdaysParseExact ? (Me(this, "_weekdaysRegex") || lw.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Me(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = mE1), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function CE1(t) {
  return this._weekdaysParseExact ? (Me(this, "_weekdaysRegex") || lw.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Me(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = gE1), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function lw() {
  function t(d, v) {
    return v.length - d.length;
  }
  var e = [], n = [], i = [], s = [], l, a, o, h, u;
  for (l = 0; l < 7; l++)
    a = vi([2e3, 1]).day(l), o = R0(this.weekdaysMin(a, "")), h = R0(this.weekdaysShort(a, "")), u = R0(this.weekdays(a, "")), e.push(o), n.push(h), i.push(u), s.push(o), s.push(h), s.push(u);
  e.sort(t), n.sort(t), i.sort(t), s.sort(t), this._weekdaysRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
function rw() {
  return this.hours() % 12 || 12;
}
function kE1() {
  return this.hours() || 24;
}
r3("H", ["HH", 2], 0, "hour");
r3("h", ["hh", 2], 0, rw);
r3("k", ["kk", 2], 0, kE1);
r3("hmm", 0, 0, function() {
  return "" + rw.apply(this) + ci(this.minutes(), 2);
});
r3("hmmss", 0, 0, function() {
  return "" + rw.apply(this) + ci(this.minutes(), 2) + ci(this.seconds(), 2);
});
r3("Hmm", 0, 0, function() {
  return "" + this.hours() + ci(this.minutes(), 2);
});
r3("Hmmss", 0, 0, function() {
  return "" + this.hours() + ci(this.minutes(), 2) + ci(this.seconds(), 2);
});
function qE(t, e) {
  r3(t, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      e
    );
  });
}
qE("a", !0);
qE("A", !1);
g5("hour", "h");
y5("hour", 13);
function wE(t, e) {
  return e._meridiemParse;
}
U2("a", wE);
U2("A", wE);
U2("H", gt);
U2("h", gt);
U2("k", gt);
U2("HH", gt, j0);
U2("hh", gt, j0);
U2("kk", gt, j0);
U2("hmm", hE);
U2("hmmss", uE);
U2("Hmm", hE);
U2("Hmmss", uE);
et(["H", "HH"], x4);
et(["k", "kk"], function(t, e, n) {
  var i = X3(t);
  e[x4] = i === 24 ? 0 : i;
});
et(["a", "A"], function(t, e, n) {
  n._isPm = n._locale.isPM(t), n._meridiem = t;
});
et(["h", "hh"], function(t, e, n) {
  e[x4] = X3(t), H3(n).bigHour = !0;
});
et("hmm", function(t, e, n) {
  var i = t.length - 2;
  e[x4] = X3(t.substr(0, i)), e[an] = X3(t.substr(i)), H3(n).bigHour = !0;
});
et("hmmss", function(t, e, n) {
  var i = t.length - 4, s = t.length - 2;
  e[x4] = X3(t.substr(0, i)), e[an] = X3(t.substr(i, 2)), e[f8] = X3(t.substr(s)), H3(n).bigHour = !0;
});
et("Hmm", function(t, e, n) {
  var i = t.length - 2;
  e[x4] = X3(t.substr(0, i)), e[an] = X3(t.substr(i));
});
et("Hmmss", function(t, e, n) {
  var i = t.length - 4, s = t.length - 2;
  e[x4] = X3(t.substr(0, i)), e[an] = X3(t.substr(i, 2)), e[f8] = X3(t.substr(s));
});
function EE1(t) {
  return (t + "").toLowerCase().charAt(0) === "p";
}
var AE1 = /[ap]\.?m?\.?/i, FE1 = o9("Hours", !0);
function TE1(t, e, n) {
  return t > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var zE = {
  calendar: zk1,
  longDateFormat: xk1,
  invalidDate: Ck1,
  ordinal: Ek1,
  dayOfMonthOrdinalParse: Ak1,
  relativeTime: Tk1,
  months: Wk1,
  monthsShort: dE,
  week: rE1,
  weekdays: fE1,
  weekdaysMin: vE1,
  weekdaysShort: _E,
  meridiemParse: AE1
}, Mt = {}, to = {}, dc;
function IE1(t, e) {
  var n, i = Math.min(t.length, e.length);
  for (n = 0; n < i; n += 1)
    if (t[n] !== e[n])
      return n;
  return i;
}
function ib(t) {
  return t && t.toLowerCase().replace("_", "-");
}
function OE1(t) {
  for (var e = 0, n, i, s, l; e < t.length; ) {
    for (l = ib(t[e]).split("-"), n = l.length, i = ib(t[e + 1]), i = i ? i.split("-") : null; n > 0; ) {
      if (s = _d(l.slice(0, n).join("-")), s)
        return s;
      if (i && i.length >= n && IE1(l, i) >= n - 1)
        break;
      n--;
    }
    e++;
  }
  return dc;
}
function NE1(t) {
  return t.match("^[^/\\\\]*$") != null;
}
function _d(t) {
  var e = null, n;
  if (Mt[t] === void 0 && typeof module < "u" && module && module.exports && NE1(t))
    try {
      e = dc._abbr, n = require, n("./locale/" + t), Es(e);
    } catch {
      Mt[t] = null;
    }
  return Mt[t];
}
function Es(t, e) {
  var n;
  return t && (n0(e) ? n = F8(t) : n = aw(t, e), n ? dc = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + t + " not found. Did you forget to load it?"
  )), dc._abbr;
}
function aw(t, e) {
  if (e !== null) {
    var n, i = zE;
    if (e.abbr = t, Mt[t] != null)
      sE(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = Mt[t]._config;
    else if (e.parentLocale != null)
      if (Mt[e.parentLocale] != null)
        i = Mt[e.parentLocale]._config;
      else if (n = _d(e.parentLocale), n != null)
        i = n._config;
      else
        return to[e.parentLocale] || (to[e.parentLocale] = []), to[e.parentLocale].push({
          name: t,
          config: e
        }), null;
    return Mt[t] = new Qq(i_(i, e)), to[t] && to[t].forEach(function(s) {
      aw(s.name, s.config);
    }), Es(t), Mt[t];
  } else
    return delete Mt[t], null;
}
function PE1(t, e) {
  if (e != null) {
    var n, i, s = zE;
    Mt[t] != null && Mt[t].parentLocale != null ? Mt[t].set(i_(Mt[t]._config, e)) : (i = _d(t), i != null && (s = i._config), e = i_(s, e), i == null && (e.abbr = t), n = new Qq(e), n.parentLocale = Mt[t], Mt[t] = n), Es(t);
  } else
    Mt[t] != null && (Mt[t].parentLocale != null ? (Mt[t] = Mt[t].parentLocale, t === Es() && Es(t)) : Mt[t] != null && delete Mt[t]);
  return Mt[t];
}
function F8(t) {
  var e;
  if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t)
    return dc;
  if (!vn(t)) {
    if (e = _d(t), e)
      return e;
    t = [t];
  }
  return OE1(t);
}
function BE1() {
  return s_(Mt);
}
function ow(t) {
  var e, n = t._a;
  return n && H3(t).overflow === -2 && (e = n[d8] < 0 || n[d8] > 11 ? d8 : n[Wn] < 1 || n[Wn] > yd(n[p5], n[d8]) ? Wn : n[x4] < 0 || n[x4] > 24 || n[x4] === 24 && (n[an] !== 0 || n[f8] !== 0 || n[lr] !== 0) ? x4 : n[an] < 0 || n[an] > 59 ? an : n[f8] < 0 || n[f8] > 59 ? f8 : n[lr] < 0 || n[lr] > 999 ? lr : -1, H3(t)._overflowDayOfYear && (e < p5 || e > Wn) && (e = Wn), H3(t)._overflowWeeks && e === -1 && (e = Uk1), H3(t)._overflowWeekday && e === -1 && (e = jk1), H3(t).overflow = e), t;
}
var VE1 = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, RE1 = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, HE1 = /Z|[+-]\d\d(?::?\d\d)?/, dh = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], sy = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], DE1 = /^\/?Date\((-?\d+)/i, $E1 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, UE1 = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function ME(t) {
  var e, n, i = t._i, s = VE1.exec(i) || RE1.exec(i), l, a, o, h, u = dh.length, d = sy.length;
  if (s) {
    for (H3(t).iso = !0, e = 0, n = u; e < n; e++)
      if (dh[e][1].exec(s[1])) {
        a = dh[e][0], l = dh[e][2] !== !1;
        break;
      }
    if (a == null) {
      t._isValid = !1;
      return;
    }
    if (s[3]) {
      for (e = 0, n = d; e < n; e++)
        if (sy[e][1].exec(s[3])) {
          o = (s[2] || " ") + sy[e][0];
          break;
        }
      if (o == null) {
        t._isValid = !1;
        return;
      }
    }
    if (!l && o != null) {
      t._isValid = !1;
      return;
    }
    if (s[4])
      if (HE1.exec(s[4]))
        h = "Z";
      else {
        t._isValid = !1;
        return;
      }
    t._f = a + (o || "") + (h || ""), hw(t);
  } else
    t._isValid = !1;
}
function jE1(t, e, n, i, s, l) {
  var a = [
    GE1(t),
    dE.indexOf(e),
    parseInt(n, 10),
    parseInt(i, 10),
    parseInt(s, 10)
  ];
  return l && a.push(parseInt(l, 10)), a;
}
function GE1(t) {
  var e = parseInt(t, 10);
  return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
}
function WE1(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function YE1(t, e, n) {
  if (t) {
    var i = _E.indexOf(t), s = new Date(
      e[0],
      e[1],
      e[2]
    ).getDay();
    if (i !== s)
      return H3(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function XE1(t, e, n) {
  if (t)
    return UE1[t];
  if (e)
    return 0;
  var i = parseInt(n, 10), s = i % 100, l = (i - s) / 100;
  return l * 60 + s;
}
function bE(t) {
  var e = $E1.exec(WE1(t._i)), n;
  if (e) {
    if (n = jE1(
      e[4],
      e[3],
      e[2],
      e[5],
      e[6],
      e[7]
    ), !YE1(e[1], n, t))
      return;
    t._a = n, t._tzm = XE1(e[8], e[9], e[10]), t._d = hc.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), H3(t).rfc2822 = !0;
  } else
    t._isValid = !1;
}
function KE1(t) {
  var e = DE1.exec(t._i);
  if (e !== null) {
    t._d = /* @__PURE__ */ new Date(+e[1]);
    return;
  }
  if (ME(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  if (bE(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  t._strict ? t._isValid = !1 : P2.createFromInputFallback(t);
}
P2.createFromInputFallback = E6(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(t) {
    t._d = /* @__PURE__ */ new Date(t._i + (t._useUTC ? " UTC" : ""));
  }
);
function da(t, e, n) {
  return t ?? e ?? n;
}
function ZE1(t) {
  var e = new Date(P2.now());
  return t._useUTC ? [
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate()
  ] : [e.getFullYear(), e.getMonth(), e.getDate()];
}
function cw(t) {
  var e, n, i = [], s, l, a;
  if (!t._d) {
    for (s = ZE1(t), t._w && t._a[Wn] == null && t._a[d8] == null && JE1(t), t._dayOfYear != null && (a = da(t._a[p5], s[p5]), (t._dayOfYear > Ao(a) || t._dayOfYear === 0) && (H3(t)._overflowDayOfYear = !0), n = hc(a, 0, t._dayOfYear), t._a[d8] = n.getUTCMonth(), t._a[Wn] = n.getUTCDate()), e = 0; e < 3 && t._a[e] == null; ++e)
      t._a[e] = i[e] = s[e];
    for (; e < 7; e++)
      t._a[e] = i[e] = t._a[e] == null ? e === 2 ? 1 : 0 : t._a[e];
    t._a[x4] === 24 && t._a[an] === 0 && t._a[f8] === 0 && t._a[lr] === 0 && (t._nextDay = !0, t._a[x4] = 0), t._d = (t._useUTC ? hc : sE1).apply(
      null,
      i
    ), l = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), t._tzm != null && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[x4] = 24), t._w && typeof t._w.d < "u" && t._w.d !== l && (H3(t).weekdayMismatch = !0);
  }
}
function JE1(t) {
  var e, n, i, s, l, a, o, h, u;
  e = t._w, e.GG != null || e.W != null || e.E != null ? (l = 1, a = 4, n = da(
    e.GG,
    t._a[p5],
    uc(mt(), 1, 4).year
  ), i = da(e.W, 1), s = da(e.E, 1), (s < 1 || s > 7) && (h = !0)) : (l = t._locale._week.dow, a = t._locale._week.doy, u = uc(mt(), l, a), n = da(e.gg, t._a[p5], u.year), i = da(e.w, u.week), e.d != null ? (s = e.d, (s < 0 || s > 6) && (h = !0)) : e.e != null ? (s = e.e + l, (e.e < 0 || e.e > 6) && (h = !0)) : s = l), i < 1 || i > q8(n, l, a) ? H3(t)._overflowWeeks = !0 : h != null ? H3(t)._overflowWeekday = !0 : (o = yE(n, i, s, l, a), t._a[p5] = o.year, t._dayOfYear = o.dayOfYear);
}
P2.ISO_8601 = function() {
};
P2.RFC_2822 = function() {
};
function hw(t) {
  if (t._f === P2.ISO_8601) {
    ME(t);
    return;
  }
  if (t._f === P2.RFC_2822) {
    bE(t);
    return;
  }
  t._a = [], H3(t).empty = !0;
  var e = "" + t._i, n, i, s, l, a, o = e.length, h = 0, u, d;
  for (s = lE(t._f, t._locale).match(ew) || [], d = s.length, n = 0; n < d; n++)
    l = s[n], i = (e.match(Hk1(l, t)) || [])[0], i && (a = e.substr(0, e.indexOf(i)), a.length > 0 && H3(t).unusedInput.push(a), e = e.slice(
      e.indexOf(i) + i.length
    ), h += i.length), Fa[l] ? (i ? H3(t).empty = !1 : H3(t).unusedTokens.push(l), $k1(l, i, t)) : t._strict && !i && H3(t).unusedTokens.push(l);
  H3(t).charsLeftOver = o - h, e.length > 0 && H3(t).unusedInput.push(e), t._a[x4] <= 12 && H3(t).bigHour === !0 && t._a[x4] > 0 && (H3(t).bigHour = void 0), H3(t).parsedDateParts = t._a.slice(0), H3(t).meridiem = t._meridiem, t._a[x4] = QE1(
    t._locale,
    t._a[x4],
    t._meridiem
  ), u = H3(t).era, u !== null && (t._a[p5] = t._locale.erasConvertYear(u, t._a[p5])), cw(t), ow(t);
}
function QE1(t, e, n) {
  var i;
  return n == null ? e : t.meridiemHour != null ? t.meridiemHour(e, n) : (t.isPM != null && (i = t.isPM(n), i && e < 12 && (e += 12), !i && e === 12 && (e = 0)), e);
}
function eA1(t) {
  var e, n, i, s, l, a, o = !1, h = t._f.length;
  if (h === 0) {
    H3(t).invalidFormat = !0, t._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (s = 0; s < h; s++)
    l = 0, a = !1, e = Jq({}, t), t._useUTC != null && (e._useUTC = t._useUTC), e._f = t._f[s], hw(e), Zq(e) && (a = !0), l += H3(e).charsLeftOver, l += H3(e).unusedTokens.length * 10, H3(e).score = l, o ? l < i && (i = l, n = e) : (i == null || l < i || a) && (i = l, n = e, a && (o = !0));
  bs(t, n || e);
}
function tA1(t) {
  if (!t._d) {
    var e = tw(t._i), n = e.day === void 0 ? e.date : e.day;
    t._a = nE(
      [e.year, e.month, n, e.hour, e.minute, e.second, e.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), cw(t);
  }
}
function nA1(t) {
  var e = new Oc(ow(LE(t)));
  return e._nextDay && (e.add(1, "d"), e._nextDay = void 0), e;
}
function LE(t) {
  var e = t._i, n = t._f;
  return t._locale = t._locale || F8(t._l), e === null || n === void 0 && e === "" ? ud({ nullInput: !0 }) : (typeof e == "string" && (t._i = e = t._locale.preparse(e)), pn(e) ? new Oc(ow(e)) : (Ic(e) ? t._d = e : vn(n) ? eA1(t) : n ? hw(t) : iA1(t), Zq(t) || (t._d = null), t));
}
function iA1(t) {
  var e = t._i;
  n0(e) ? t._d = new Date(P2.now()) : Ic(e) ? t._d = new Date(e.valueOf()) : typeof e == "string" ? KE1(t) : vn(e) ? (t._a = nE(e.slice(0), function(n) {
    return parseInt(n, 10);
  }), cw(t)) : dr(e) ? tA1(t) : L8(e) ? t._d = new Date(e) : P2.createFromInputFallback(t);
}
function xE(t, e, n, i, s) {
  var l = {};
  return (e === !0 || e === !1) && (i = e, e = void 0), (n === !0 || n === !1) && (i = n, n = void 0), (dr(t) && Kq(t) || vn(t) && t.length === 0) && (t = void 0), l._isAMomentObject = !0, l._useUTC = l._isUTC = s, l._l = n, l._i = t, l._f = e, l._strict = i, nA1(l);
}
function mt(t, e, n, i) {
  return xE(t, e, n, i, !1);
}
var sA1 = E6(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = mt.apply(null, arguments);
    return this.isValid() && t.isValid() ? t < this ? this : t : ud();
  }
), lA1 = E6(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = mt.apply(null, arguments);
    return this.isValid() && t.isValid() ? t > this ? this : t : ud();
  }
);
function SE(t, e) {
  var n, i;
  if (e.length === 1 && vn(e[0]) && (e = e[0]), !e.length)
    return mt();
  for (n = e[0], i = 1; i < e.length; ++i)
    (!e[i].isValid() || e[i][t](n)) && (n = e[i]);
  return n;
}
function rA1() {
  var t = [].slice.call(arguments, 0);
  return SE("isBefore", t);
}
function aA1() {
  var t = [].slice.call(arguments, 0);
  return SE("isAfter", t);
}
var oA1 = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, no = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function cA1(t) {
  var e, n = !1, i, s = no.length;
  for (e in t)
    if (Me(t, e) && !(Zt.call(no, e) !== -1 && (t[e] == null || !isNaN(t[e]))))
      return !1;
  for (i = 0; i < s; ++i)
    if (t[no[i]]) {
      if (n)
        return !1;
      parseFloat(t[no[i]]) !== X3(t[no[i]]) && (n = !0);
    }
  return !0;
}
function hA1() {
  return this._isValid;
}
function uA1() {
  return qn(NaN);
}
function qd(t) {
  var e = tw(t), n = e.year || 0, i = e.quarter || 0, s = e.month || 0, l = e.week || e.isoWeek || 0, a = e.day || 0, o = e.hour || 0, h = e.minute || 0, u = e.second || 0, d = e.millisecond || 0;
  this._isValid = cA1(e), this._milliseconds = +d + u * 1e3 + // 1000
  h * 6e4 + // 1000 * 60
  o * 1e3 * 60 * 60, this._days = +a + l * 7, this._months = +s + i * 3 + n * 12, this._data = {}, this._locale = F8(), this._bubble();
}
function Ch(t) {
  return t instanceof qd;
}
function r_(t) {
  return t < 0 ? Math.round(-1 * t) * -1 : Math.round(t);
}
function dA1(t, e, n) {
  var i = Math.min(t.length, e.length), s = Math.abs(t.length - e.length), l = 0, a;
  for (a = 0; a < i; a++)
    (n && t[a] !== e[a] || !n && X3(t[a]) !== X3(e[a])) && l++;
  return l + s;
}
function CE(t, e) {
  r3(t, 0, 0, function() {
    var n = this.utcOffset(), i = "+";
    return n < 0 && (n = -n, i = "-"), i + ci(~~(n / 60), 2) + e + ci(~~n % 60, 2);
  });
}
CE("Z", ":");
CE("ZZ", "");
U2("Z", gd);
U2("ZZ", gd);
et(["Z", "ZZ"], function(t, e, n) {
  n._useUTC = !0, n._tzm = uw(gd, t);
});
var fA1 = /([\+\-]|\d\d)/gi;
function uw(t, e) {
  var n = (e || "").match(t), i, s, l;
  return n === null ? null : (i = n[n.length - 1] || [], s = (i + "").match(fA1) || ["-", 0, 0], l = +(s[1] * 60) + X3(s[2]), l === 0 ? 0 : s[0] === "+" ? l : -l);
}
function dw(t, e) {
  var n, i;
  return e._isUTC ? (n = e.clone(), i = (pn(t) || Ic(t) ? t.valueOf() : mt(t).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + i), P2.updateOffset(n, !1), n) : mt(t).local();
}
function a_(t) {
  return -Math.round(t._d.getTimezoneOffset());
}
P2.updateOffset = function() {
};
function vA1(t, e, n) {
  var i = this._offset || 0, s;
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    if (typeof t == "string") {
      if (t = uw(gd, t), t === null)
        return this;
    } else
      Math.abs(t) < 16 && !n && (t = t * 60);
    return !this._isUTC && e && (s = a_(this)), this._offset = t, this._isUTC = !0, s != null && this.add(s, "m"), i !== t && (!e || this._changeInProgress ? AE(
      this,
      qn(t - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, P2.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : a_(this);
}
function pA1(t, e) {
  return t != null ? (typeof t != "string" && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset();
}
function mA1(t) {
  return this.utcOffset(0, t);
}
function gA1(t) {
  return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(a_(this), "m")), this;
}
function yA1() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var t = uw(Vk1, this._i);
    t != null ? this.utcOffset(t) : this.utcOffset(0, !0);
  }
  return this;
}
function _A1(t) {
  return this.isValid() ? (t = t ? mt(t).utcOffset() : 0, (this.utcOffset() - t) % 60 === 0) : !1;
}
function qA1() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function wA1() {
  if (!n0(this._isDSTShifted))
    return this._isDSTShifted;
  var t = {}, e;
  return Jq(t, this), t = LE(t), t._a ? (e = t._isUTC ? vi(t._a) : mt(t._a), this._isDSTShifted = this.isValid() && dA1(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function zA1() {
  return this.isValid() ? !this._isUTC : !1;
}
function MA1() {
  return this.isValid() ? this._isUTC : !1;
}
function kE() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var bA1 = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, LA1 = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function qn(t, e) {
  var n = t, i = null, s, l, a;
  return Ch(t) ? n = {
    ms: t._milliseconds,
    d: t._days,
    M: t._months
  } : L8(t) || !isNaN(+t) ? (n = {}, e ? n[e] = +t : n.milliseconds = +t) : (i = bA1.exec(t)) ? (s = i[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: X3(i[Wn]) * s,
    h: X3(i[x4]) * s,
    m: X3(i[an]) * s,
    s: X3(i[f8]) * s,
    ms: X3(r_(i[lr] * 1e3)) * s
    // the millisecond decimal point is included in the match
  }) : (i = LA1.exec(t)) ? (s = i[1] === "-" ? -1 : 1, n = {
    y: Yl(i[2], s),
    M: Yl(i[3], s),
    w: Yl(i[4], s),
    d: Yl(i[5], s),
    h: Yl(i[6], s),
    m: Yl(i[7], s),
    s: Yl(i[8], s)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (a = xA1(
    mt(n.from),
    mt(n.to)
  ), n = {}, n.ms = a.milliseconds, n.M = a.months), l = new qd(n), Ch(t) && Me(t, "_locale") && (l._locale = t._locale), Ch(t) && Me(t, "_isValid") && (l._isValid = t._isValid), l;
}
qn.fn = qd.prototype;
qn.invalid = uA1;
function Yl(t, e) {
  var n = t && parseFloat(t.replace(",", "."));
  return (isNaN(n) ? 0 : n) * e;
}
function sb(t, e) {
  var n = {};
  return n.months = e.month() - t.month() + (e.year() - t.year()) * 12, t.clone().add(n.months, "M").isAfter(e) && --n.months, n.milliseconds = +e - +t.clone().add(n.months, "M"), n;
}
function xA1(t, e) {
  var n;
  return t.isValid() && e.isValid() ? (e = dw(e, t), t.isBefore(e) ? n = sb(t, e) : (n = sb(e, t), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function EE(t, e) {
  return function(n, i) {
    var s, l;
    return i !== null && !isNaN(+i) && (sE(
      e,
      "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), l = n, n = i, i = l), s = qn(n, i), AE(this, s, t), this;
  };
}
function AE(t, e, n, i) {
  var s = e._milliseconds, l = r_(e._days), a = r_(e._months);
  t.isValid() && (i = i ?? !0, a && vE(t, vu(t, "Month") + a * n), l && aE(t, "Date", vu(t, "Date") + l * n), s && t._d.setTime(t._d.valueOf() + s * n), i && P2.updateOffset(t, l || a));
}
var SA1 = EE(1, "add"), CA1 = EE(-1, "subtract");
function FE(t) {
  return typeof t == "string" || t instanceof String;
}
function kA1(t) {
  return pn(t) || Ic(t) || FE(t) || L8(t) || AA1(t) || EA1(t) || t === null || t === void 0;
}
function EA1(t) {
  var e = dr(t) && !Kq(t), n = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], s, l, a = i.length;
  for (s = 0; s < a; s += 1)
    l = i[s], n = n || Me(t, l);
  return e && n;
}
function AA1(t) {
  var e = vn(t), n = !1;
  return e && (n = t.filter(function(i) {
    return !L8(i) && FE(t);
  }).length === 0), e && n;
}
function FA1(t) {
  var e = dr(t) && !Kq(t), n = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], s, l;
  for (s = 0; s < i.length; s += 1)
    l = i[s], n = n || Me(t, l);
  return e && n;
}
function TA1(t, e) {
  var n = t.diff(e, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function IA1(t, e) {
  arguments.length === 1 && (arguments[0] ? kA1(arguments[0]) ? (t = arguments[0], e = void 0) : FA1(arguments[0]) && (e = arguments[0], t = void 0) : (t = void 0, e = void 0));
  var n = t || mt(), i = dw(n, this).startOf("day"), s = P2.calendarFormat(this, i) || "sameElse", l = e && (pi(e[s]) ? e[s].call(this, n) : e[s]);
  return this.format(
    l || this.localeData().calendar(s, this, mt(n))
  );
}
function OA1() {
  return new Oc(this);
}
function NA1(t, e) {
  var n = pn(t) ? t : mt(t);
  return this.isValid() && n.isValid() ? (e = A6(e) || "millisecond", e === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(e).valueOf()) : !1;
}
function PA1(t, e) {
  var n = pn(t) ? t : mt(t);
  return this.isValid() && n.isValid() ? (e = A6(e) || "millisecond", e === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(e).valueOf() < n.valueOf()) : !1;
}
function BA1(t, e, n, i) {
  var s = pn(t) ? t : mt(t), l = pn(e) ? e : mt(e);
  return this.isValid() && s.isValid() && l.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(s, n) : !this.isBefore(s, n)) && (i[1] === ")" ? this.isBefore(l, n) : !this.isAfter(l, n))) : !1;
}
function VA1(t, e) {
  var n = pn(t) ? t : mt(t), i;
  return this.isValid() && n.isValid() ? (e = A6(e) || "millisecond", e === "millisecond" ? this.valueOf() === n.valueOf() : (i = n.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf())) : !1;
}
function RA1(t, e) {
  return this.isSame(t, e) || this.isAfter(t, e);
}
function HA1(t, e) {
  return this.isSame(t, e) || this.isBefore(t, e);
}
function DA1(t, e, n) {
  var i, s, l;
  if (!this.isValid())
    return NaN;
  if (i = dw(t, this), !i.isValid())
    return NaN;
  switch (s = (i.utcOffset() - this.utcOffset()) * 6e4, e = A6(e), e) {
    case "year":
      l = kh(this, i) / 12;
      break;
    case "month":
      l = kh(this, i);
      break;
    case "quarter":
      l = kh(this, i) / 3;
      break;
    case "second":
      l = (this - i) / 1e3;
      break;
    case "minute":
      l = (this - i) / 6e4;
      break;
    case "hour":
      l = (this - i) / 36e5;
      break;
    case "day":
      l = (this - i - s) / 864e5;
      break;
    case "week":
      l = (this - i - s) / 6048e5;
      break;
    default:
      l = this - i;
  }
  return n ? l : _6(l);
}
function kh(t, e) {
  if (t.date() < e.date())
    return -kh(e, t);
  var n = (e.year() - t.year()) * 12 + (e.month() - t.month()), i = t.clone().add(n, "months"), s, l;
  return e - i < 0 ? (s = t.clone().add(n - 1, "months"), l = (e - i) / (i - s)) : (s = t.clone().add(n + 1, "months"), l = (e - i) / (s - i)), -(n + l) || 0;
}
P2.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
P2.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function $A1() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function UA1(t) {
  if (!this.isValid())
    return null;
  var e = t !== !0, n = e ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? Sh(
    n,
    e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : pi(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Sh(n, "Z")) : Sh(
    n,
    e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function jA1() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var t = "moment", e = "", n, i, s, l;
  return this.isLocal() || (t = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", e = "Z"), n = "[" + t + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", s = "-MM-DD[T]HH:mm:ss.SSS", l = e + '[")]', this.format(n + i + s + l);
}
function GA1(t) {
  t || (t = this.isUtc() ? P2.defaultFormatUtc : P2.defaultFormat);
  var e = Sh(this, t);
  return this.localeData().postformat(e);
}
function WA1(t, e) {
  return this.isValid() && (pn(t) && t.isValid() || mt(t).isValid()) ? qn({ to: this, from: t }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function YA1(t) {
  return this.from(mt(), t);
}
function XA1(t, e) {
  return this.isValid() && (pn(t) && t.isValid() || mt(t).isValid()) ? qn({ from: this, to: t }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function KA1(t) {
  return this.to(mt(), t);
}
function TE(t) {
  var e;
  return t === void 0 ? this._locale._abbr : (e = F8(t), e != null && (this._locale = e), this);
}
var IE = E6(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(t) {
    return t === void 0 ? this.localeData() : this.locale(t);
  }
);
function OE() {
  return this._locale;
}
var gu = 1e3, Ta = 60 * gu, yu = 60 * Ta, NE = (365 * 400 + 97) * 24 * yu;
function Ia(t, e) {
  return (t % e + e) % e;
}
function PE(t, e, n) {
  return t < 100 && t >= 0 ? new Date(t + 400, e, n) - NE : new Date(t, e, n).valueOf();
}
function BE(t, e, n) {
  return t < 100 && t >= 0 ? Date.UTC(t + 400, e, n) - NE : Date.UTC(t, e, n);
}
function ZA1(t) {
  var e, n;
  if (t = A6(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? BE : PE, t) {
    case "year":
      e = n(this.year(), 0, 1);
      break;
    case "quarter":
      e = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      e = n(this.year(), this.month(), 1);
      break;
    case "week":
      e = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      e = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      e = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      e = this._d.valueOf(), e -= Ia(
        e + (this._isUTC ? 0 : this.utcOffset() * Ta),
        yu
      );
      break;
    case "minute":
      e = this._d.valueOf(), e -= Ia(e, Ta);
      break;
    case "second":
      e = this._d.valueOf(), e -= Ia(e, gu);
      break;
  }
  return this._d.setTime(e), P2.updateOffset(this, !0), this;
}
function JA1(t) {
  var e, n;
  if (t = A6(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? BE : PE, t) {
    case "year":
      e = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      e = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      e = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      e = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      e = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      e = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      e = this._d.valueOf(), e += yu - Ia(
        e + (this._isUTC ? 0 : this.utcOffset() * Ta),
        yu
      ) - 1;
      break;
    case "minute":
      e = this._d.valueOf(), e += Ta - Ia(e, Ta) - 1;
      break;
    case "second":
      e = this._d.valueOf(), e += gu - Ia(e, gu) - 1;
      break;
  }
  return this._d.setTime(e), P2.updateOffset(this, !0), this;
}
function QA1() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function eF1() {
  return Math.floor(this.valueOf() / 1e3);
}
function tF1() {
  return new Date(this.valueOf());
}
function nF1() {
  var t = this;
  return [
    t.year(),
    t.month(),
    t.date(),
    t.hour(),
    t.minute(),
    t.second(),
    t.millisecond()
  ];
}
function iF1() {
  var t = this;
  return {
    years: t.year(),
    months: t.month(),
    date: t.date(),
    hours: t.hours(),
    minutes: t.minutes(),
    seconds: t.seconds(),
    milliseconds: t.milliseconds()
  };
}
function sF1() {
  return this.isValid() ? this.toISOString() : null;
}
function lF1() {
  return Zq(this);
}
function rF1() {
  return bs({}, H3(this));
}
function aF1() {
  return H3(this).overflow;
}
function oF1() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
r3("N", 0, 0, "eraAbbr");
r3("NN", 0, 0, "eraAbbr");
r3("NNN", 0, 0, "eraAbbr");
r3("NNNN", 0, 0, "eraName");
r3("NNNNN", 0, 0, "eraNarrow");
r3("y", ["y", 1], "yo", "eraYear");
r3("y", ["yy", 2], 0, "eraYear");
r3("y", ["yyy", 3], 0, "eraYear");
r3("y", ["yyyy", 4], 0, "eraYear");
U2("N", fw);
U2("NN", fw);
U2("NNN", fw);
U2("NNNN", _F1);
U2("NNNNN", qF1);
et(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(t, e, n, i) {
    var s = n._locale.erasParse(t, i, n._strict);
    s ? H3(n).era = s : H3(n).invalidEra = t;
  }
);
U2("y", c9);
U2("yy", c9);
U2("yyy", c9);
U2("yyyy", c9);
U2("yo", wF1);
et(["y", "yy", "yyy", "yyyy"], p5);
et(["yo"], function(t, e, n, i) {
  var s;
  n._locale._eraYearOrdinalRegex && (s = t.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? e[p5] = n._locale.eraYearOrdinalParse(t, s) : e[p5] = parseInt(t, 10);
});
function cF1(t, e) {
  var n, i, s, l = this._eras || F8("en")._eras;
  for (n = 0, i = l.length; n < i; ++n) {
    switch (typeof l[n].since) {
      case "string":
        s = P2(l[n].since).startOf("day"), l[n].since = s.valueOf();
        break;
    }
    switch (typeof l[n].until) {
      case "undefined":
        l[n].until = 1 / 0;
        break;
      case "string":
        s = P2(l[n].until).startOf("day").valueOf(), l[n].until = s.valueOf();
        break;
    }
  }
  return l;
}
function hF1(t, e, n) {
  var i, s, l = this.eras(), a, o, h;
  for (t = t.toUpperCase(), i = 0, s = l.length; i < s; ++i)
    if (a = l[i].name.toUpperCase(), o = l[i].abbr.toUpperCase(), h = l[i].narrow.toUpperCase(), n)
      switch (e) {
        case "N":
        case "NN":
        case "NNN":
          if (o === t)
            return l[i];
          break;
        case "NNNN":
          if (a === t)
            return l[i];
          break;
        case "NNNNN":
          if (h === t)
            return l[i];
          break;
      }
    else if ([a, o, h].indexOf(t) >= 0)
      return l[i];
}
function uF1(t, e) {
  var n = t.since <= t.until ? 1 : -1;
  return e === void 0 ? P2(t.since).year() : P2(t.since).year() + (e - t.offset) * n;
}
function dF1() {
  var t, e, n, i = this.localeData().eras();
  for (t = 0, e = i.length; t < e; ++t)
    if (n = this.clone().startOf("day").valueOf(), i[t].since <= n && n <= i[t].until || i[t].until <= n && n <= i[t].since)
      return i[t].name;
  return "";
}
function fF1() {
  var t, e, n, i = this.localeData().eras();
  for (t = 0, e = i.length; t < e; ++t)
    if (n = this.clone().startOf("day").valueOf(), i[t].since <= n && n <= i[t].until || i[t].until <= n && n <= i[t].since)
      return i[t].narrow;
  return "";
}
function vF1() {
  var t, e, n, i = this.localeData().eras();
  for (t = 0, e = i.length; t < e; ++t)
    if (n = this.clone().startOf("day").valueOf(), i[t].since <= n && n <= i[t].until || i[t].until <= n && n <= i[t].since)
      return i[t].abbr;
  return "";
}
function pF1() {
  var t, e, n, i, s = this.localeData().eras();
  for (t = 0, e = s.length; t < e; ++t)
    if (n = s[t].since <= s[t].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), s[t].since <= i && i <= s[t].until || s[t].until <= i && i <= s[t].since)
      return (this.year() - P2(s[t].since).year()) * n + s[t].offset;
  return this.year();
}
function mF1(t) {
  return Me(this, "_erasNameRegex") || vw.call(this), t ? this._erasNameRegex : this._erasRegex;
}
function gF1(t) {
  return Me(this, "_erasAbbrRegex") || vw.call(this), t ? this._erasAbbrRegex : this._erasRegex;
}
function yF1(t) {
  return Me(this, "_erasNarrowRegex") || vw.call(this), t ? this._erasNarrowRegex : this._erasRegex;
}
function fw(t, e) {
  return e.erasAbbrRegex(t);
}
function _F1(t, e) {
  return e.erasNameRegex(t);
}
function qF1(t, e) {
  return e.erasNarrowRegex(t);
}
function wF1(t, e) {
  return e._eraYearOrdinalRegex || c9;
}
function vw() {
  var t = [], e = [], n = [], i = [], s, l, a = this.eras();
  for (s = 0, l = a.length; s < l; ++s)
    e.push(R0(a[s].name)), t.push(R0(a[s].abbr)), n.push(R0(a[s].narrow)), i.push(R0(a[s].name)), i.push(R0(a[s].abbr)), i.push(R0(a[s].narrow));
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
r3(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
r3(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function wd(t, e) {
  r3(0, [t, t.length], 0, e);
}
wd("gggg", "weekYear");
wd("ggggg", "weekYear");
wd("GGGG", "isoWeekYear");
wd("GGGGG", "isoWeekYear");
g5("weekYear", "gg");
g5("isoWeekYear", "GG");
y5("weekYear", 1);
y5("isoWeekYear", 1);
U2("G", md);
U2("g", md);
U2("GG", gt, j0);
U2("gg", gt, j0);
U2("GGGG", iw, nw);
U2("gggg", iw, nw);
U2("GGGGG", pd, fd);
U2("ggggg", pd, fd);
Pc(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(t, e, n, i) {
    e[i.substr(0, 2)] = X3(t);
  }
);
Pc(["gg", "GG"], function(t, e, n, i) {
  e[i] = P2.parseTwoDigitYear(t);
});
function zF1(t) {
  return VE.call(
    this,
    t,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function MF1(t) {
  return VE.call(
    this,
    t,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function bF1() {
  return q8(this.year(), 1, 4);
}
function LF1() {
  return q8(this.isoWeekYear(), 1, 4);
}
function xF1() {
  var t = this.localeData()._week;
  return q8(this.year(), t.dow, t.doy);
}
function SF1() {
  var t = this.localeData()._week;
  return q8(this.weekYear(), t.dow, t.doy);
}
function VE(t, e, n, i, s) {
  var l;
  return t == null ? uc(this, i, s).year : (l = q8(t, i, s), e > l && (e = l), CF1.call(this, t, e, n, i, s));
}
function CF1(t, e, n, i, s) {
  var l = yE(t, e, n, i, s), a = hc(l.year, 0, l.dayOfYear);
  return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
}
r3("Q", 0, "Qo", "quarter");
g5("quarter", "Q");
y5("quarter", 7);
U2("Q", oE);
et("Q", function(t, e) {
  e[d8] = (X3(t) - 1) * 3;
});
function kF1(t) {
  return t == null ? Math.ceil((this.month() + 1) / 3) : this.month((t - 1) * 3 + this.month() % 3);
}
r3("D", ["DD", 2], "Do", "date");
g5("date", "D");
y5("date", 9);
U2("D", gt);
U2("DD", gt, j0);
U2("Do", function(t, e) {
  return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient;
});
et(["D", "DD"], Wn);
et("Do", function(t, e) {
  e[Wn] = X3(t.match(gt)[0]);
});
var RE = o9("Date", !0);
r3("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
g5("dayOfYear", "DDD");
y5("dayOfYear", 4);
U2("DDD", vd);
U2("DDDD", cE);
et(["DDD", "DDDD"], function(t, e, n) {
  n._dayOfYear = X3(t);
});
function EF1(t) {
  var e = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return t == null ? e : this.add(t - e, "d");
}
r3("m", ["mm", 2], 0, "minute");
g5("minute", "m");
y5("minute", 14);
U2("m", gt);
U2("mm", gt, j0);
et(["m", "mm"], an);
var AF1 = o9("Minutes", !1);
r3("s", ["ss", 2], 0, "second");
g5("second", "s");
y5("second", 15);
U2("s", gt);
U2("ss", gt, j0);
et(["s", "ss"], f8);
var FF1 = o9("Seconds", !1);
r3("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
r3(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
r3(0, ["SSS", 3], 0, "millisecond");
r3(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
r3(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
r3(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
r3(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
r3(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
r3(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
g5("millisecond", "ms");
y5("millisecond", 16);
U2("S", vd, oE);
U2("SS", vd, j0);
U2("SSS", vd, cE);
var Ls, HE;
for (Ls = "SSSS"; Ls.length <= 9; Ls += "S")
  U2(Ls, c9);
function TF1(t, e) {
  e[lr] = X3(("0." + t) * 1e3);
}
for (Ls = "S"; Ls.length <= 9; Ls += "S")
  et(Ls, TF1);
HE = o9("Milliseconds", !1);
r3("z", 0, 0, "zoneAbbr");
r3("zz", 0, 0, "zoneName");
function IF1() {
  return this._isUTC ? "UTC" : "";
}
function OF1() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var u2 = Oc.prototype;
u2.add = SA1;
u2.calendar = IA1;
u2.clone = OA1;
u2.diff = DA1;
u2.endOf = JA1;
u2.format = GA1;
u2.from = WA1;
u2.fromNow = YA1;
u2.to = XA1;
u2.toNow = KA1;
u2.get = Pk1;
u2.invalidAt = aF1;
u2.isAfter = NA1;
u2.isBefore = PA1;
u2.isBetween = BA1;
u2.isSame = VA1;
u2.isSameOrAfter = RA1;
u2.isSameOrBefore = HA1;
u2.isValid = lF1;
u2.lang = IE;
u2.locale = TE;
u2.localeData = OE;
u2.max = lA1;
u2.min = sA1;
u2.parsingFlags = rF1;
u2.set = Bk1;
u2.startOf = ZA1;
u2.subtract = CA1;
u2.toArray = nF1;
u2.toObject = iF1;
u2.toDate = tF1;
u2.toISOString = UA1;
u2.inspect = jA1;
typeof Symbol < "u" && Symbol.for != null && (u2[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
u2.toJSON = sF1;
u2.toString = $A1;
u2.unix = eF1;
u2.valueOf = QA1;
u2.creationData = oF1;
u2.eraName = dF1;
u2.eraNarrow = fF1;
u2.eraAbbr = vF1;
u2.eraYear = pF1;
u2.year = gE;
u2.isLeapYear = iE1;
u2.weekYear = zF1;
u2.isoWeekYear = MF1;
u2.quarter = u2.quarters = kF1;
u2.month = pE;
u2.daysInMonth = eE1;
u2.week = u2.weeks = cE1;
u2.isoWeek = u2.isoWeeks = hE1;
u2.weeksInYear = xF1;
u2.weeksInWeekYear = SF1;
u2.isoWeeksInYear = bF1;
u2.isoWeeksInISOWeekYear = LF1;
u2.date = RE;
u2.day = u2.days = ME1;
u2.weekday = bE1;
u2.isoWeekday = LE1;
u2.dayOfYear = EF1;
u2.hour = u2.hours = FE1;
u2.minute = u2.minutes = AF1;
u2.second = u2.seconds = FF1;
u2.millisecond = u2.milliseconds = HE;
u2.utcOffset = vA1;
u2.utc = mA1;
u2.local = gA1;
u2.parseZone = yA1;
u2.hasAlignedHourOffset = _A1;
u2.isDST = qA1;
u2.isLocal = zA1;
u2.isUtcOffset = MA1;
u2.isUtc = kE;
u2.isUTC = kE;
u2.zoneAbbr = IF1;
u2.zoneName = OF1;
u2.dates = E6(
  "dates accessor is deprecated. Use date instead.",
  RE
);
u2.months = E6(
  "months accessor is deprecated. Use month instead",
  pE
);
u2.years = E6(
  "years accessor is deprecated. Use year instead",
  gE
);
u2.zone = E6(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  pA1
);
u2.isDSTShifted = E6(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  wA1
);
function NF1(t) {
  return mt(t * 1e3);
}
function PF1() {
  return mt.apply(null, arguments).parseZone();
}
function DE(t) {
  return t;
}
var xe = Qq.prototype;
xe.calendar = Mk1;
xe.longDateFormat = Sk1;
xe.invalidDate = kk1;
xe.ordinal = Fk1;
xe.preparse = DE;
xe.postformat = DE;
xe.relativeTime = Ik1;
xe.pastFuture = Ok1;
xe.set = wk1;
xe.eras = cF1;
xe.erasParse = hF1;
xe.erasConvertYear = uF1;
xe.erasAbbrRegex = gF1;
xe.erasNameRegex = mF1;
xe.erasNarrowRegex = yF1;
xe.months = Kk1;
xe.monthsShort = Zk1;
xe.monthsParse = Qk1;
xe.monthsRegex = nE1;
xe.monthsShortRegex = tE1;
xe.week = lE1;
xe.firstDayOfYear = oE1;
xe.firstDayOfWeek = aE1;
xe.weekdays = yE1;
xe.weekdaysMin = qE1;
xe.weekdaysShort = _E1;
xe.weekdaysParse = zE1;
xe.weekdaysRegex = xE1;
xe.weekdaysShortRegex = SE1;
xe.weekdaysMinRegex = CE1;
xe.isPM = EE1;
xe.meridiem = TE1;
function _u(t, e, n, i) {
  var s = F8(), l = vi().set(i, e);
  return s[n](l, t);
}
function $E(t, e, n) {
  if (L8(t) && (e = t, t = void 0), t = t || "", e != null)
    return _u(t, e, n, "month");
  var i, s = [];
  for (i = 0; i < 12; i++)
    s[i] = _u(t, i, n, "month");
  return s;
}
function pw(t, e, n, i) {
  typeof t == "boolean" ? (L8(e) && (n = e, e = void 0), e = e || "") : (e = t, n = e, t = !1, L8(e) && (n = e, e = void 0), e = e || "");
  var s = F8(), l = t ? s._week.dow : 0, a, o = [];
  if (n != null)
    return _u(e, (n + l) % 7, i, "day");
  for (a = 0; a < 7; a++)
    o[a] = _u(e, (a + l) % 7, i, "day");
  return o;
}
function BF1(t, e) {
  return $E(t, e, "months");
}
function VF1(t, e) {
  return $E(t, e, "monthsShort");
}
function RF1(t, e, n) {
  return pw(t, e, n, "weekdays");
}
function HF1(t, e, n) {
  return pw(t, e, n, "weekdaysShort");
}
function DF1(t, e, n) {
  return pw(t, e, n, "weekdaysMin");
}
Es("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(t) {
    var e = t % 10, n = X3(t % 100 / 10) === 1 ? "th" : e === 1 ? "st" : e === 2 ? "nd" : e === 3 ? "rd" : "th";
    return t + n;
  }
});
P2.lang = E6(
  "moment.lang is deprecated. Use moment.locale instead.",
  Es
);
P2.langData = E6(
  "moment.langData is deprecated. Use moment.localeData instead.",
  F8
);
var r8 = Math.abs;
function $F1() {
  var t = this._data;
  return this._milliseconds = r8(this._milliseconds), this._days = r8(this._days), this._months = r8(this._months), t.milliseconds = r8(t.milliseconds), t.seconds = r8(t.seconds), t.minutes = r8(t.minutes), t.hours = r8(t.hours), t.months = r8(t.months), t.years = r8(t.years), this;
}
function UE(t, e, n, i) {
  var s = qn(e, n);
  return t._milliseconds += i * s._milliseconds, t._days += i * s._days, t._months += i * s._months, t._bubble();
}
function UF1(t, e) {
  return UE(this, t, e, 1);
}
function jF1(t, e) {
  return UE(this, t, e, -1);
}
function lb(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function GF1() {
  var t = this._milliseconds, e = this._days, n = this._months, i = this._data, s, l, a, o, h;
  return t >= 0 && e >= 0 && n >= 0 || t <= 0 && e <= 0 && n <= 0 || (t += lb(o_(n) + e) * 864e5, e = 0, n = 0), i.milliseconds = t % 1e3, s = _6(t / 1e3), i.seconds = s % 60, l = _6(s / 60), i.minutes = l % 60, a = _6(l / 60), i.hours = a % 24, e += _6(a / 24), h = _6(jE(e)), n += h, e -= lb(o_(h)), o = _6(n / 12), n %= 12, i.days = e, i.months = n, i.years = o, this;
}
function jE(t) {
  return t * 4800 / 146097;
}
function o_(t) {
  return t * 146097 / 4800;
}
function WF1(t) {
  if (!this.isValid())
    return NaN;
  var e, n, i = this._milliseconds;
  if (t = A6(t), t === "month" || t === "quarter" || t === "year")
    switch (e = this._days + i / 864e5, n = this._months + jE(e), t) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (e = this._days + Math.round(o_(this._months)), t) {
      case "week":
        return e / 7 + i / 6048e5;
      case "day":
        return e + i / 864e5;
      case "hour":
        return e * 24 + i / 36e5;
      case "minute":
        return e * 1440 + i / 6e4;
      case "second":
        return e * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(e * 864e5) + i;
      default:
        throw new Error("Unknown unit " + t);
    }
}
function YF1() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + X3(this._months / 12) * 31536e6 : NaN;
}
function T8(t) {
  return function() {
    return this.as(t);
  };
}
var XF1 = T8("ms"), KF1 = T8("s"), ZF1 = T8("m"), JF1 = T8("h"), QF1 = T8("d"), eT1 = T8("w"), tT1 = T8("M"), nT1 = T8("Q"), iT1 = T8("y");
function sT1() {
  return qn(this);
}
function lT1(t) {
  return t = A6(t), this.isValid() ? this[t + "s"]() : NaN;
}
function Er(t) {
  return function() {
    return this.isValid() ? this._data[t] : NaN;
  };
}
var rT1 = Er("milliseconds"), aT1 = Er("seconds"), oT1 = Er("minutes"), cT1 = Er("hours"), hT1 = Er("days"), uT1 = Er("months"), dT1 = Er("years");
function fT1() {
  return _6(this.days() / 7);
}
var h8 = Math.round, za = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function vT1(t, e, n, i, s) {
  return s.relativeTime(e || 1, !!n, t, i);
}
function pT1(t, e, n, i) {
  var s = qn(t).abs(), l = h8(s.as("s")), a = h8(s.as("m")), o = h8(s.as("h")), h = h8(s.as("d")), u = h8(s.as("M")), d = h8(s.as("w")), v = h8(s.as("y")), m = l <= n.ss && ["s", l] || l < n.s && ["ss", l] || a <= 1 && ["m"] || a < n.m && ["mm", a] || o <= 1 && ["h"] || o < n.h && ["hh", o] || h <= 1 && ["d"] || h < n.d && ["dd", h];
  return n.w != null && (m = m || d <= 1 && ["w"] || d < n.w && ["ww", d]), m = m || u <= 1 && ["M"] || u < n.M && ["MM", u] || v <= 1 && ["y"] || ["yy", v], m[2] = e, m[3] = +t > 0, m[4] = i, vT1.apply(null, m);
}
function mT1(t) {
  return t === void 0 ? h8 : typeof t == "function" ? (h8 = t, !0) : !1;
}
function gT1(t, e) {
  return za[t] === void 0 ? !1 : e === void 0 ? za[t] : (za[t] = e, t === "s" && (za.ss = e - 1), !0);
}
function yT1(t, e) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, i = za, s, l;
  return typeof t == "object" && (e = t, t = !1), typeof t == "boolean" && (n = t), typeof e == "object" && (i = Object.assign({}, za, e), e.s != null && e.ss == null && (i.ss = e.s - 1)), s = this.localeData(), l = pT1(this, !n, i, s), n && (l = s.pastFuture(+this, l)), s.postformat(l);
}
var ly = Math.abs;
function ta(t) {
  return (t > 0) - (t < 0) || +t;
}
function zd() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = ly(this._milliseconds) / 1e3, e = ly(this._days), n = ly(this._months), i, s, l, a, o = this.asSeconds(), h, u, d, v;
  return o ? (i = _6(t / 60), s = _6(i / 60), t %= 60, i %= 60, l = _6(n / 12), n %= 12, a = t ? t.toFixed(3).replace(/\.?0+$/, "") : "", h = o < 0 ? "-" : "", u = ta(this._months) !== ta(o) ? "-" : "", d = ta(this._days) !== ta(o) ? "-" : "", v = ta(this._milliseconds) !== ta(o) ? "-" : "", h + "P" + (l ? u + l + "Y" : "") + (n ? u + n + "M" : "") + (e ? d + e + "D" : "") + (s || i || t ? "T" : "") + (s ? v + s + "H" : "") + (i ? v + i + "M" : "") + (t ? v + a + "S" : "")) : "P0D";
}
var de = qd.prototype;
de.isValid = hA1;
de.abs = $F1;
de.add = UF1;
de.subtract = jF1;
de.as = WF1;
de.asMilliseconds = XF1;
de.asSeconds = KF1;
de.asMinutes = ZF1;
de.asHours = JF1;
de.asDays = QF1;
de.asWeeks = eT1;
de.asMonths = tT1;
de.asQuarters = nT1;
de.asYears = iT1;
de.valueOf = YF1;
de._bubble = GF1;
de.clone = sT1;
de.get = lT1;
de.milliseconds = rT1;
de.seconds = aT1;
de.minutes = oT1;
de.hours = cT1;
de.days = hT1;
de.weeks = fT1;
de.months = uT1;
de.years = dT1;
de.humanize = yT1;
de.toISOString = zd;
de.toString = zd;
de.toJSON = zd;
de.locale = TE;
de.localeData = OE;
de.toIsoString = E6(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  zd
);
de.lang = IE;
r3("X", 0, 0, "unix");
r3("x", 0, 0, "valueOf");
U2("x", md);
U2("X", Rk1);
et("X", function(t, e, n) {
  n._d = new Date(parseFloat(t) * 1e3);
});
et("x", function(t, e, n) {
  n._d = new Date(X3(t));
});
//! moment.js
P2.version = "2.29.4";
_k1(mt);
P2.fn = u2;
P2.min = rA1;
P2.max = aA1;
P2.now = oA1;
P2.utc = vi;
P2.unix = NF1;
P2.months = BF1;
P2.isDate = Ic;
P2.locale = Es;
P2.invalid = ud;
P2.duration = qn;
P2.isMoment = pn;
P2.weekdays = RF1;
P2.parseZone = PF1;
P2.localeData = F8;
P2.isDuration = Ch;
P2.monthsShort = VF1;
P2.weekdaysMin = DF1;
P2.defineLocale = aw;
P2.updateLocale = PE1;
P2.locales = BE1;
P2.weekdaysShort = HF1;
P2.normalizeUnits = A6;
P2.relativeTimeRounding = mT1;
P2.relativeTimeThreshold = gT1;
P2.calendarFormat = TA1;
P2.prototype = u2;
P2.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
class _T1 {
  constructor(e) {
    O2(this, "code");
    O2(this, "name");
    O2(this, "nutsLevel");
    O2(this, "nutsVersion");
    O2(this, "lastUpdate");
    O2(this, "releaseDate");
    O2(this, "release");
    O2(this, "dimensions");
    this.name = e == null ? void 0 : e.name, this.code = e == null ? void 0 : e.code, this.nutsLevel = e == null ? void 0 : e.nutsLevel, this.nutsVersion = e == null ? void 0 : e.nutsVersion;
    const n = e == null ? void 0 : e.lastUpdate;
    n && (this.lastUpdate = P2(n).format("DD/MM/YYYY"));
    const i = e == null ? void 0 : e.releaseDate;
    i && (this.releaseDate = P2(i).format("DD/MM/YYYY")), this.release = e == null ? void 0 : e.release, this.dimensions = e == null ? void 0 : e.dimensions;
  }
  get dimensionObject() {
    const e = this.dimensions;
    if (e)
      return s1.reduce(e, (n, i) => ({ ...n, [i.key]: i.value }), {});
  }
}
class qT1 extends Error {
  constructor(e, n) {
    super(e), n && (n instanceof Error ? this.stack += `
Caused by: ${n.stack}` : this.stack += `
Caused by: ${n}`);
  }
}
class rb extends qT1 {
}
const Fo = {
  euCountryCode: [
    "EU",
    "AT",
    "EE",
    "IT",
    "PT",
    "BE",
    "FI",
    "LV",
    "RO",
    "BG",
    "FR",
    "LT",
    "SK",
    "HR",
    "DE",
    "LU",
    "SI",
    "CY",
    "EL",
    "MT",
    "ES",
    "CZ",
    "HU",
    "NL",
    "SE",
    "DK",
    "IE",
    "PL"
  ],
  check: (t) => {
    let e = Fo.euCountryCode, n = [], i = !0, s = !0;
    const l = s1.isArray(t) ? t : [t];
    if (l) {
      const a = l.includes("all");
      i = l.includes("eu") || a || (l == null ? void 0 : l.length) === 0, s = a, s && (i ? (e = [], n = []) : (e = [], n = Fo.euCountryCode));
    }
    return {
      include: e,
      exclude: n,
      withEu: i,
      withExtraEu: s
    };
  },
  isInList: (t, e = Fo.euCountryCode) => {
    const n = t.slice(0, 2);
    return e.includes(n);
  }
};
var GE = { exports: {} }, c_ = { exports: {} };
(function(t, e) {
  var n = function() {
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof N5 < "u")
      return N5;
    throw new Error("unable to locate global object");
  }, i = n();
  t.exports = e = i.fetch, i.fetch && (e.default = i.fetch.bind(i)), e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response;
})(c_, c_.exports);
var wT1 = c_.exports, io, ab = (io = wT1) && typeof io == "object" && "default" in io ? io.default : io;
function Kt(t, e) {
  var n, i, s, l, a = function(Q, i1, h1) {
    var c1, M1 = [];
    if (h1 && !WE(h1.name) && (h1 = null), typeof Q == "string" && (Q = [Q]), Array.isArray(Q) || h_(Q)) {
      if (Q.length === i1)
        return h1 && Q.findIndex(function(A1) {
          return A1 == null;
        }) === -1 ? h1.from(Q) : Q;
      if (Q.length === 1) {
        for (c1 = 0; c1 < i1; c1++)
          M1.push(Q[0]);
        return M1;
      }
    }
    for (c1 = 0; c1 < i1; c1++) {
      var y1 = Q[c1] === void 0 ? null : Q[c1];
      M1.push(y1);
    }
    return M1;
  };
  if (this.length = 0, this.id = [], t != null)
    switch (this.class = t.class || "bundle", this.class) {
      case "bundle":
        var o = [], h = 0;
        if (this.error = null, this.length = 0, t === null || typeof t != "object")
          return void (this.class = null);
        if (t.hasOwnProperty("error"))
          return void (this.error = t.error);
        if (t.class === "dataset" || t.class === "collection" || t.class === "dimension")
          return new Kt(t);
        for (i in t)
          h++, o.push(i);
        this.__tree__ = t, this.length = h, this.id = o;
        break;
      case "dataset":
        t.hasOwnProperty("__tree__") ? this.__tree__ = n = t.__tree__ : this.__tree__ = n = t, this.label = n.label || null, this.note = n.note || null, this.link = n.link || null, this.href = n.href || null, this.updated = n.updated || null, this.source = n.source || null, this.extension = n.extension || null;
        var u, d = 0, v = n.size || n.dimension && n.dimension.size;
        if (this.size = v, this.value = n.hasOwnProperty("value") && n.value !== null && n.value.length !== 0 ? n.value : {}, Array.isArray(this.value) || h_(this.value))
          d = this.value.length;
        else {
          var m = 1;
          for (u = v.length; u--; )
            m *= v[u];
          d = m;
        }
        if (this.value = a(this.value, d, e), this.status = n.hasOwnProperty("status") ? a(n.status, d) : null, n.hasOwnProperty("dimension")) {
          var p = n.dimension, _ = n.role || !n.version && p.role || null, q = n.id || p.id, M = v.length, z = function(Q) {
            _.hasOwnProperty(Q) || (_[Q] = null);
          };
          if (!Array.isArray(q) || !Array.isArray(v) || q.length != M)
            return;
          if (this.length = M, this.id = q, _ && (z("time"), z("geo"), z("metric"), z("classification")), _ && _.classification === null) {
            var b = [], x = ["time", "geo", "metric"], k = function(Q, i1) {
              for (var h1 = i1.length; h1--; )
                if (Q === i1[h1])
                  return !0;
              return !1;
            };
            for (u = 0; u < 3; u++) {
              var F = _[x[u]];
              F !== null && (b = b.concat(F));
            }
            for (_.classification = [], u = 0; u < M; u++)
              k(q[u], b) || _.classification.push(q[u]);
            _.classification.length === 0 && (_.classification = null);
          }
          this.role = _, this.n = d;
          for (var D = 0, R = this.length; D < R; D++)
            if (p[q[D]].category.hasOwnProperty("index")) {
              if (Array.isArray(p[q[D]].category.index)) {
                var V = {}, J = p[q[D]].category.index;
                for (s = J.length, l = 0; l < s; l++)
                  V[J[l]] = l;
                p[q[D]].category.index = V;
              }
            } else {
              var K = 0;
              for (i in p[q[D]].category.index = {}, p[q[D]].category.label)
                p[q[D]].category.index[i] = K++;
            }
        } else
          this.length = 0;
        break;
      case "dimension":
        if (!t.hasOwnProperty("__tree__"))
          return new Kt({ version: "2.0", class: "dataset", dimension: { d: t }, id: ["d"], size: [function(Q) {
            var i1 = Q.index === void 0 ? Q.label : Q.index;
            return Array.isArray(i1) ? i1.length : Object.keys(i1).length;
          }(t.category)], value: [null] }).Dimension(0);
        var P = [], O = (n = t.__tree__).category;
        if (!n.hasOwnProperty("category"))
          return;
        if (!O.hasOwnProperty("label"))
          for (i in O.label = {}, O.index)
            O.label[i] = i;
        for (i in O.index)
          P[O.index[i]] = i;
        this.__tree__ = n, this.label = n.label || null, this.note = n.note || null, this.link = n.link || null, this.href = n.href || null, this.id = P, this.length = P.length, this.role = t.role, this.hierarchy = O.hasOwnProperty("child"), this.extension = n.extension || null;
        break;
      case "category":
        var G = t.child;
        this.id = G, this.length = G === null ? 0 : G.length, this.index = t.index, this.label = t.label, this.note = t.note || null, this.unit = t.unit, this.coordinates = t.coord;
        break;
      case "collection":
        if (this.length = 0, this.label = t.label || null, this.note = t.note || null, this.link = t.link || null, this.href = t.href || null, this.updated = t.updated || null, this.source = t.source || null, this.extension = t.extension || null, this.link !== null && t.link.item) {
          var j = t.link.item;
          if (this.length = Array.isArray(j) ? j.length : 0, this.length)
            for (l = 0; l < this.length; l++)
              this.id[l] = j[l].href;
        }
    }
}
function h_(t) {
  return Object.prototype.toString.call(t.buffer) === "[object ArrayBuffer]";
}
function WE(t) {
  return ["Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Uint16Array", "Int32Array", "Uint32Array", "Float32Array", "Float64Array", "BigInt64Array", "BigUint64Array"].indexOf(t) !== -1;
}
function zT1(t) {
  if (!t.ok)
    throw new Error(t.status + " " + t.statusText);
  return t.json();
}
Kt.prototype.Item = function(t) {
  if (this === null || this.class !== "collection" || !this.length)
    return null;
  if (typeof t == "number")
    return t > this.length || t < 0 ? null : this.link.item[t];
  var e, n = [];
  if (typeof t == "object") {
    if (!t.class && !t.follow)
      return null;
    t.class && (e = t.class === "dataset" && typeof t.embedded == "boolean" ? t.embedded === !0 ? function(s, l, a) {
      var o = s.link.item[l];
      a.class === o.class && o.id && o.size && o.dimension && n.push(o);
    } : function(s, l, a) {
      var o = s.link.item[l];
      a.class !== o.class || o.id && o.size && o.dimension || n.push(o);
    } : function(s, l, a) {
      a.class === s.link.item[l].class && n.push(s.link.item[l]);
    });
  } else
    e = function(s, l) {
      n.push(s.link.item[l]);
    };
  for (var i = 0; i < this.length; i++)
    e(this, i, t);
  return n;
}, Kt.prototype.Dataset = function(t) {
  if (this === null)
    return null;
  if (this.class === "dataset")
    return t !== void 0 ? this : [this];
  var e, n = [], i = 0;
  if (this.class === "collection") {
    var s = this.Item({ class: "dataset", embedded: !0 });
    if (t === void 0) {
      for (e = s.length; i < e; i++)
        n.push(new Kt(s[i]));
      return n;
    }
    if (typeof t == "number" && t >= 0 && t < s.length)
      return new Kt(s[t]);
    if (typeof t == "string") {
      for (e = s.length; i < e; i++)
        if (s[i].href === t)
          return new Kt(s[i]);
    }
    return null;
  }
  if (this.class !== "bundle")
    return null;
  if (t === void 0) {
    for (e = this.id.length; i < e; i++)
      n.push(this.Dataset(this.id[i]));
    return n;
  }
  if (typeof t == "number") {
    var l = this.id[t];
    return l !== void 0 ? this.Dataset(l) : null;
  }
  var a = this.__tree__[t];
  return a === void 0 ? null : new Kt({ class: "dataset", __tree__: a });
}, Kt.prototype.Dimension = function(t, e) {
  e = typeof e != "boolean" || e;
  var n, i = [], s = this.id.length, l = function(v, m) {
    if (v !== null) {
      for (var p in v)
        for (var _ = v[p] !== null ? v[p].length : 0; _--; )
          if (v[p][_] === m)
            return p;
    }
    return null;
  };
  if (this === null || this.class !== "dataset")
    return null;
  if (t === void 0) {
    for (n = 0; n < s; n++)
      i.push(this.Dimension(this.id[n]));
    return i;
  }
  if (typeof t == "number") {
    var a = this.id[t];
    return a !== void 0 ? this.Dimension(a, e) : null;
  }
  var o = this.role;
  if (typeof t == "object") {
    if (t.hasOwnProperty("role")) {
      for (n = 0; n < s; n++) {
        var h = this.id[n];
        l(o, h) === t.role && i.push(this.Dimension(h, e));
      }
      return i[0] === void 0 ? null : i;
    }
    return null;
  }
  var u = this.__tree__.dimension;
  if (u === void 0)
    return null;
  var d = u[t];
  return d === void 0 ? null : e ? new Kt({ class: "dimension", __tree__: d, role: l(o, t) }) : function(v, m) {
    var p = [];
    for (var _ in v)
      p[v[_]] = m[_];
    return p;
  }(d.category.index, d.category.label);
}, Kt.prototype.Category = function(t) {
  if (this === null || this.class !== "dimension")
    return null;
  if (t === void 0) {
    for (var e = [], n = 0, i = this.id.length; n < i; n++)
      e.push(this.Category(this.id[n]));
    return e;
  }
  if (typeof t == "number") {
    var s = this.id[t];
    return s !== void 0 ? this.Category(s) : null;
  }
  var l = this.__tree__.category;
  if (l === void 0)
    return null;
  var a = l.index[t];
  if (a === void 0)
    return null;
  var o = l.unit && l.unit[t] || null, h = l.coordinates && l.coordinates[t] || null, u = l.child && l.child[t] || null, d = l.note && l.note[t] || null;
  return new Kt({ class: "category", index: a, label: l.label[t], note: d, child: u, unit: o, coord: h });
}, Kt.prototype.Dice = function(t, e, n) {
  var i, s, l, a, o = function(M, z) {
    return M.hasOwnProperty(z) && !!M[z];
  };
  if (this === null || this.class !== "dataset")
    return null;
  if (typeof t != "object")
    return this;
  typeof e != "object" ? (typeof e == "boolean" && e === !0 && (i = !0), typeof n == "boolean" && n === !0 || (n = !1)) : (i = o(e, "clone"), n = o(e, "drop"), s = o(e, "stringify"), l = o(e, "ovalue"), a = o(e, "ostatus"));
  var h, u = this.value, d = i ? new Kt(JSON.parse(JSON.stringify(this))) : this, v = d.status, m = [], p = [], _ = function(M, z) {
    var b, x, k, F = (b = M, x = z, k = {}, Array.isArray(b[x]) ? (b[x].forEach(function(D, R) {
      D !== null && (k[String(R)] = D);
    }), k) : b[x]);
    delete M[z], M[z] = F;
  };
  Array.isArray(t) && (t = function(M) {
    var z = {};
    return M.forEach(function(b) {
      z[b[0]] = b[1];
    }), z;
  }(t)), t === null && (t = {});
  var q = Object.keys(t);
  return q.length > 0 && (q.forEach(function(M) {
    var z = t[M];
    Array.isArray(z) || (t[M] = [z]), t[M].length === 0 && delete t[M];
  }), n && (t = function(M) {
    var z = {};
    return Object.keys(M).forEach(function(b) {
      z[b] = d.Dimension(b).id.filter(function(x) {
        return M[b].indexOf(x) === -1;
      });
    }), z;
  }(t)), d.toTable({ type: "arrobj", content: "id", status: !0 }).forEach(function(M, z) {
    var b = [];
    q.forEach(function(x) {
      var k = t[x], F = [];
      k.forEach(function(D) {
        F.push(M[x] === D);
      }), b.push(F.indexOf(!0) !== -1);
    }), b.indexOf(!1) === -1 && (m.push(M.value), p.push(M.status));
  }), q.forEach(function(M) {
    var z = d.Dimension(M).id, b = 0, x = {};
    d.size[d.id.indexOf(M)] = t[M].length, z.forEach(function(k) {
      t[M].indexOf(k) !== -1 && (x[k] = b, b++);
    }), d.__tree__.dimension[M].category.index = x;
  }), d.n = m.length, d.value = d.__tree__.value = h_(u) ? function(M, z) {
    return z.from(M);
  }(m, u.constructor) : m, d.status = d.__tree__.status = v !== null ? p : null), s ? ((h = d.__tree__).hasOwnProperty("id") || (h.version = "2.0", h.hasOwnProperty("class") || (h.class = "dataset"), h.id = h.dimension.id, h.size = h.dimension.size, delete h.dimension.id, delete h.dimension.size, h.dimension.hasOwnProperty("role") && (h.role = h.dimension.role, delete h.dimension.role)), h.hasOwnProperty("status") && ["null", "{}", "[]"].indexOf(JSON.stringify(h.status)) !== -1 && delete h.status, h.hasOwnProperty("role") && (delete h.role.classification, ["geo", "time", "metric"].forEach(function(M) {
    h.role[M] === null && delete h.role[M];
  })), l && _(h, "value"), a && h.hasOwnProperty("status") && _(h, "status"), JSON.stringify(h)) : d;
}, Kt.prototype.Slice = function(t) {
  if (this === null || this.class !== "dataset")
    return null;
  if (t === void 0)
    return this;
  if (!Array.isArray(t)) {
    var e, n = [];
    for (e in t)
      n.push([e, t[e]]);
    t = n;
  }
  return this.Dice(t.map(function(i) {
    return [i[0], [i[1]]];
  }));
}, Kt.prototype.Data = function(t, e) {
  var n, i, s = [], l = function(D) {
    for (var R in D)
      if (D.hasOwnProperty(R))
        return R;
  };
  if (this === null || this.class !== "dataset")
    return null;
  if (t === void 0) {
    for (i = this.value.length, n = 0; n < i; n++)
      s.push(this.Data(n));
    return s;
  }
  if (typeof e != "boolean" && (e = !0), typeof t == "number") {
    var a = this.value[t];
    return a === void 0 ? null : e ? { value: a, status: this.status ? this.status[t] : null } : a;
  }
  var o = "object", h = this.__tree__, u = h.size || h.dimension && h.dimension.size, d = u.length;
  if (Array.isArray(t)) {
    if (!Array.isArray(t[0])) {
      if (this.length !== t.length)
        return null;
      var v = 1, m = 0, p = [], _ = [];
      for (n = 0; n < d; n++)
        if (t[n] !== void 0) {
          if (typeof t[n] != "number" || t[n] >= u[n])
            return null;
          m += (v *= n > 0 ? u[d - n] : 1) * t[d - n - 1];
        } else
          p.push(n), _.push(u[n]);
      if (p.length > 1)
        return null;
      if (p.length === 1) {
        for (var q = 0, M = _[0]; q < M; q++) {
          var z = [];
          for (n = 0; n < d; n++)
            n !== p[0] ? z.push(t[n]) : z.push(q);
          s.push(this.Data(z, e));
        }
        return s;
      }
      return e ? { value: this.value[m], status: this.status ? this.status[m] : null } : this.value[m];
    }
    o = "array";
  }
  var b = function(D, R, V) {
    var J, K = [], P = {}, O = D.dimension, G = D.id || O.id, j = D.size || O && O.size;
    if (V === "array") {
      for (J = R.length; J--; )
        P[R[J][0]] = R[J][1];
      R = P;
    }
    for (var Q = 0, i1 = G.length; Q < i1; Q++) {
      var h1 = G[Q], c1 = R[h1];
      K.push(typeof c1 == "string" ? c1 : j[Q] === 1 ? l(O[h1].category.index) : null);
    }
    return K;
  }(h, t, o), x = [], k = h.dimension, F = h.id || k.id;
  for (n = 0, i = b.length; n < i; n++)
    x.push(k[F[n]].category.index[b[n]]);
  return this.Data(x, e);
}, Kt.prototype.toTable = function(t, e) {
  if (this === null || this.class !== "dataset")
    return null;
  arguments.length == 1 && typeof t == "function" && (e = t, t = null), (t = t || { field: "label", content: "label", vlabel: "Value", slabel: "Status", type: "array", status: !1, unit: !1, by: null, prefix: "", drop: [], meta: !1, comma: !1, bylabel: !1 }).type !== "arrobj" && t.type !== "objarr" || t.field !== void 0 || (t.field = "id");
  var n, i, s, l, a, o, h, u, d, v = t.field === "id", m = function(z2) {
    return (v ? "value" : z2) || "Value";
  }, p = function(z2) {
    return (v ? "status" : z2) || "Status";
  }, _ = this.__tree__, q = t.status === !0;
  if (typeof e == "function") {
    n = this.toTable(t);
    var M = [], z = t.type !== "array" ? 0 : 1;
    for (a = (a1 = t.type !== "object" ? n.slice(z) : n.rows.slice(0)).length, i = 0; i < a; i++) {
      var b = e.call(this, a1[i], i);
      b !== void 0 && M.push(b);
    }
    return t.type === "object" ? { cols: n.cols, rows: M } : (t.type === "array" && M.unshift(n[0]), M);
  }
  if (t.type === "arrobj" || t.type === "objarr") {
    var x = [], k = _.role && _.role.metric, F = function() {
    }, D = {}, R = this, V = R.id, J = t.by && V.indexOf(t.by) !== -1 ? t.by : null, K = t.meta === !0, P = t.drop !== void 0 && Array.isArray(t.drop) ? t.drop : [], O = t.comma === !0, G = t.bylabel === !0, j = R.value.constructor, Q = function(z2) {
      var R2, w3 = {}, B3 = m(t.vlabel);
      return t.type === "objarr" && (R2 = J === null && WE(j.name) ? function(G3) {
        w3[G3] = G3 === B3 ? j.from(z2, function(Se) {
          return Se[G3];
        }) : z2.map(function(Se) {
          return Se[G3];
        });
      } : function(G3) {
        w3[G3] = z2.map(function(Se) {
          return Se[G3];
        });
      }, Object.keys(z2[0]).forEach(R2), z2 = w3), K ? (w3 = {}, V.forEach(function(G3) {
        var Se = R.Dimension(G3);
        w3[G3] = { label: Se.label, role: Se.role, categories: { id: Se.id, label: R.Dimension(G3, !1) } };
      }), { meta: { label: R.label, source: R.source, updated: R.updated, id: V, status: q, unit: t.unit, by: J, bylabel: G, drop: J !== null && P.length > 0 ? P : null, prefix: J !== null ? f1 || "" : null, comma: O, dimensions: w3 }, data: z2 }) : z2;
    };
    J && (t.field = "id");
    var i1 = (n = this.toTable({ field: t.field, vlabel: t.vlabel, slabel: t.slabel, content: t.content, status: q })).shift();
    if (J === null && t.unit && k) {
      if (t.content !== "id")
        for (var h1 = k.length; h1--; ) {
          var c1 = this.Dimension(k[h1]);
          D[k[h1]] = {};
          for (var M1 = c1.length; M1--; )
            D[k[h1]][c1.Category(M1).label] = c1.id[M1];
        }
      F = function(z2, R2) {
        if (k.indexOf(z2) !== -1) {
          var w3 = _.dimension[z2].category;
          w3.unit ? y1.unit = w3.unit[t.content !== "id" ? D[z2][R2] : R2] : y1.unit = null;
        }
      }, t.unit = !0;
    } else
      t.unit = !1;
    for (a = n.length, i = 0; i < a; i++) {
      var y1 = {};
      for (s = n[i].length; s--; )
        y1[i1[s]] = n[i][s], F(i1[s], n[i][s]);
      x.push(y1);
    }
    if (O && x.forEach(function(z2) {
      z2.value !== null && (z2.value = ("" + z2.value).replace(".", ","));
    }), J !== null) {
      var A1, $ = {}, a1 = [], n1 = {}, f1 = t.prefix !== void 0 ? t.prefix : "";
      P.forEach(function(z2, R2) {
        (!R.Dimension(z2) || R.Dimension(z2).length > 1) && (P[R2] = "");
      });
      var w1 = V.filter(function(z2) {
        return z2 !== J && P.indexOf(z2) === -1;
      }), C1 = R.Dimension(J), E1 = function(z2, R2) {
        var w3 = [];
        return R2.forEach(function(B3) {
          w3.push(z2[B3]);
        }), w3.join("	");
      }, T1 = function(z2, R2) {
        var w3 = {};
        return R2.forEach(function(B3) {
          w3[B3] = z2[B3];
        }), w3;
      };
      for (var n2 in t.content !== "id" ? G ? A1 = function(z2, R2, w3) {
        z2[R2][f1 + w3[J]] = w3.value;
      } : (C1.Category().forEach(function(z2, R2) {
        n1[z2.label] = C1.id[R2];
      }), A1 = function(z2, R2, w3) {
        z2[R2][f1 + n1[w3[J]]] = w3.value;
      }) : A1 = function(z2, R2, w3) {
        z2[R2][f1 + w3[J]] = w3.value;
      }, x.forEach(function(z2) {
        var R2 = E1(z2, w1);
        $[R2] === void 0 && ($[R2] = T1(z2, w1)), A1($, R2, z2, J);
      }), $)
        a1.push($[n2]);
      return q = !1, Q(a1);
    }
    return Q(x);
  }
  if (t.type === "object") {
    var X1 = typeof this.value[0] == "number" || this.value[0] === null ? "number" : "string";
    o = function(z2, R2) {
      var w3 = v && z2 || R2 || z2;
      t2.push({ id: z2, label: w3, type: "string" });
    }, h = function(z2, R2, w3) {
      var B3 = m(z2), G3 = p(R2);
      w3 && t2.push({ id: "status", label: G3, type: "string" }), t2.push({ id: "value", label: B3, type: X1 });
    }, u = function(z2) {
      E3.push({ v: z2 });
    }, d = function(z2) {
      E3.push({ v: z2 }), S2.push({ c: E3 });
    };
  } else
    o = function(z2, R2) {
      var w3 = v && z2 || R2 || z2;
      t2.push(w3);
    }, h = function(z2, R2, w3) {
      var B3 = m(z2), G3 = p(R2);
      w3 && t2.push(G3), t2.push(B3), Z1.push(t2);
    }, u = function(z2) {
      E3.push(z2);
    }, d = function(z2) {
      E3.push(z2), Z1.push(E3);
    };
  var a2 = _.dimension, d2 = _.id || a2.id, y2 = _.size || a2.size, B1 = d2.length;
  if (B1 != y2.length)
    return !1;
  var p1 = [], _2 = 1, w2 = (h1 = 1, []), K1 = [], e2 = [], Z1 = [], t2 = [], S2 = [];
  for (i = 0; i < B1; i++) {
    var W2 = d2[i], E2 = a2[W2].label;
    o(W2, E2), _2 *= y2[i], h1 *= y2[i];
    var o3 = [];
    for (s = 0; s < y2[i]; s++)
      for (var n3 in a2[d2[i]].category.index)
        if (a2[d2[i]].category.index[n3] === s) {
          var c3 = t.content !== "id" && a2[d2[i]].category.label ? a2[d2[i]].category.label[n3] : n3;
          o3.push(c3);
        }
    p1.push(o3), w2.push(h1);
  }
  for (h(t.vlabel, t.slabel, q), a = p1.length, i = 0; i < a; i++) {
    for (var G2 = [], u3 = 0, g2 = p1[i].length; u3 < g2; u3++)
      for (var Oe = 0; Oe < _2 / w2[i]; Oe++)
        G2.push(p1[i][u3]);
    K1.push(G2);
  }
  for (a = K1.length, i = 0; i < a; i++) {
    var q3 = [], ht = 0;
    for (l = 0; l < _2; l++)
      q3.push(K1[i][ht]), ++ht === K1[i].length && (ht = 0);
    e2.push(q3);
  }
  for (l = 0; l < _2; l++) {
    var E3 = [];
    a = K1.length;
    for (var j3 = 0; j3 < a; j3++)
      u(e2[j3][l]);
    q && u(this.status ? this.status[l] : null), d(this.value[l]);
  }
  return t.type === "object" ? { cols: t2, rows: S2 } : Z1;
}, Kt.prototype.node = function() {
  return this.__tree__;
}, Kt.prototype.toString = function() {
  return this.class;
}, GE.exports = function(t, e, n) {
  var i = typeof e == "object" ? e : { method: "GET" };
  return typeof n != "function" && (n = null), n || typeof e != "function" || (n = e), typeof t == "object" ? new Kt(t, n) : t === "version" ? "1.4.2" : ab ? ab(t, i).then(zT1).then(function(s) {
    return new Kt(s, n);
  }) : void 0;
};
var MT1 = GE.exports;
const bT1 = /* @__PURE__ */ Pu(MT1);
class LT1 {
  constructor(e, n = {}) {
    O2(this, "jsonstat");
    O2(this, "cellList", []);
    O2(this, "config", {});
    O2(this, "mapping", {
      year: "time",
      nuts: "geo",
      unit: "unit",
      sector: "sector"
    });
    this.config = s1.assign(this.config, n), this.jsonstat = bT1(e);
  }
  splitNumberFromString(e) {
    return e.match(/[a-z]+|[^a-z]+/gi);
  }
  /**
   * Converte i dati della jsonstat nel type CellSource
   * da dare in pasto all'DataViewer
   *
   * @retuns {Promise<Cell[]>}
   */
  processData(e) {
    return e && (this.mapping = e), new Promise((n) => {
      const i = this.nutsList;
      let s = [];
      s1.each(this.yearList, (l) => {
        const a = this.jsonstat.Data({ [this.mapping.year]: l.value }), o = s1.map(a, (h, u) => {
          const d = i[u];
          let v = {};
          if (h != null && h.status) {
            const m = this.splitNumberFromString(h.status);
            for (let p = 0; p < m.length; p += 2) {
              const _ = m[p], q = m[p + 1], M = _ === "a" ? "annotation" : _ === "c" ? "classification" : void 0;
              M && (v[M] = +q);
            }
          }
          return {
            value: h.value,
            year: +l.value,
            nuts: d,
            annotationId: v == null ? void 0 : v.annotation,
            classificationId: v == null ? void 0 : v.classification
          };
        });
        s = s.concat(o);
      }), this.cellList = s, n(s);
    });
  }
  getDimensionList(e, n = "string") {
    const i = this.jsonstat.Dimension(e), s = i.id;
    return s1.map(s, (l) => {
      var u;
      const a = i.Category(l), o = n === "string" ? l : +l, h = {
        label: a.label
      };
      if (e === this.mapping.nuts) {
        const d = a.note, v = s1.reduce(
          d,
          (m, p) => {
            const _ = p.startsWith("eu"), q = p.startsWith("l"), M = this.splitNumberFromString(p);
            return _ ? s1.assign(m, { eu: !!+M[1] }) : q && s1.assign(m, { level: +M[1] }), m;
          },
          {}
        );
        s1.isNil(v == null ? void 0 : v.eu) && s1.assign(v, { eu: Fo.isInList(o, (u = this.config) == null ? void 0 : u.euCountryCodeList) }), s1.assign(h, { code: o }, v);
      } else
        s1.assign(h, { value: o });
      return h;
    });
  }
  /**
   * Lista di tutti i nuts
   *
   * @returns {JclDataViewerDimensionItem[]}
   */
  get nutsList() {
    return this.getDimensionList(this.mapping.nuts);
  }
  /**
   * Lista di tutte le unit
   *
   * @returns {JclDataViewerDimensionItem[]}
   */
  get unitList() {
    return this.getDimensionList(this.mapping.unit);
  }
  /**
   * Lista di tutti i settori
   *
   * @returns {JclDataViewerDimensionItem[]}
   */
  get sectorList() {
    return this.getDimensionList(this.mapping.sector);
  }
  /**
   * Lista di tutti gli anni
   *
   * @returns {JclDataViewerDimensionItem[]}
   */
  get yearList() {
    return this.getDimensionList(this.mapping.year);
  }
}
const xT1 = (t, e) => !s1.isNil(t) && s1.isNumber(t) ? t.toLocaleString("it-IT", e ?? {}) : null;
var ST1 = typeof N5 == "object" && N5 && N5.Object === Object && N5, YE = ST1, CT1 = YE, kT1 = typeof self == "object" && self && self.Object === Object && self, ET1 = CT1 || kT1 || Function("return this")(), I8 = ET1, AT1 = I8, FT1 = AT1.Symbol, Md = FT1, ob = Md, XE = Object.prototype, TT1 = XE.hasOwnProperty, IT1 = XE.toString, so = ob ? ob.toStringTag : void 0;
function OT1(t) {
  var e = TT1.call(t, so), n = t[so];
  try {
    t[so] = void 0;
    var i = !0;
  } catch {
  }
  var s = IT1.call(t);
  return i && (e ? t[so] = n : delete t[so]), s;
}
var NT1 = OT1, PT1 = Object.prototype, BT1 = PT1.toString;
function VT1(t) {
  return BT1.call(t);
}
var RT1 = VT1, cb = Md, HT1 = NT1, DT1 = RT1, $T1 = "[object Null]", UT1 = "[object Undefined]", hb = cb ? cb.toStringTag : void 0;
function jT1(t) {
  return t == null ? t === void 0 ? UT1 : $T1 : hb && hb in Object(t) ? HT1(t) : DT1(t);
}
var mw = jT1;
function GT1(t) {
  return t != null && typeof t == "object";
}
var KE = GT1, WT1 = mw, YT1 = KE, XT1 = "[object Arguments]";
function KT1(t) {
  return YT1(t) && WT1(t) == XT1;
}
var ZT1 = KT1, ub = ZT1, JT1 = KE, ZE = Object.prototype, QT1 = ZE.hasOwnProperty, eI1 = ZE.propertyIsEnumerable;
ub(function() {
  return arguments;
}());
var qu = { exports: {} };
function tI1() {
  return !1;
}
var nI1 = tI1;
qu.exports;
(function(t, e) {
  var n = I8, i = nI1, s = e && !e.nodeType && e, l = s && !0 && t && !t.nodeType && t, a = l && l.exports === s, o = a ? n.Buffer : void 0, h = o ? o.isBuffer : void 0, u = h || i;
  t.exports = u;
})(qu, qu.exports);
qu.exports;
var wu = { exports: {} };
wu.exports;
(function(t, e) {
  var n = YE, i = e && !e.nodeType && e, s = i && !0 && t && !t.nodeType && t, l = s && s.exports === i, a = l && n.process, o = function() {
    try {
      var h = s && s.require && s.require("util").types;
      return h || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  t.exports = o;
})(wu, wu.exports);
var iI1 = wu.exports, db = iI1;
db && db.isTypedArray;
function sI1(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var JE = sI1, lI1 = mw, rI1 = JE, aI1 = "[object AsyncFunction]", oI1 = "[object Function]", cI1 = "[object GeneratorFunction]", hI1 = "[object Proxy]";
function uI1(t) {
  if (!rI1(t))
    return !1;
  var e = lI1(t);
  return e == oI1 || e == cI1 || e == aI1 || e == hI1;
}
var dI1 = uI1;
function fI1() {
  this.__data__ = [], this.size = 0;
}
var vI1 = fI1;
function pI1(t, e) {
  return t === e || t !== t && e !== e;
}
var mI1 = pI1, gI1 = mI1;
function yI1(t, e) {
  for (var n = t.length; n--; )
    if (gI1(t[n][0], e))
      return n;
  return -1;
}
var bd = yI1, _I1 = bd, qI1 = Array.prototype, wI1 = qI1.splice;
function zI1(t) {
  var e = this.__data__, n = _I1(e, t);
  if (n < 0)
    return !1;
  var i = e.length - 1;
  return n == i ? e.pop() : wI1.call(e, n, 1), --this.size, !0;
}
var MI1 = zI1, bI1 = bd;
function LI1(t) {
  var e = this.__data__, n = bI1(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var xI1 = LI1, SI1 = bd;
function CI1(t) {
  return SI1(this.__data__, t) > -1;
}
var kI1 = CI1, EI1 = bd;
function AI1(t, e) {
  var n = this.__data__, i = EI1(n, t);
  return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
}
var FI1 = AI1, TI1 = vI1, II1 = MI1, OI1 = xI1, NI1 = kI1, PI1 = FI1;
function h9(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
h9.prototype.clear = TI1;
h9.prototype.delete = II1;
h9.prototype.get = OI1;
h9.prototype.has = NI1;
h9.prototype.set = PI1;
var Ld = h9, BI1 = Ld;
function VI1() {
  this.__data__ = new BI1(), this.size = 0;
}
var RI1 = VI1;
function HI1(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var DI1 = HI1;
function $I1(t) {
  return this.__data__.get(t);
}
var UI1 = $I1;
function jI1(t) {
  return this.__data__.has(t);
}
var GI1 = jI1, WI1 = I8, YI1 = WI1["__core-js_shared__"], XI1 = YI1, ry = XI1, fb = function() {
  var t = /[^.]+$/.exec(ry && ry.keys && ry.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function KI1(t) {
  return !!fb && fb in t;
}
var ZI1 = KI1, JI1 = Function.prototype, QI1 = JI1.toString;
function eO1(t) {
  if (t != null) {
    try {
      return QI1.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var QE = eO1, tO1 = dI1, nO1 = ZI1, iO1 = JE, sO1 = QE, lO1 = /[\\^$.*+?()[\]{}|]/g, rO1 = /^\[object .+?Constructor\]$/, aO1 = Function.prototype, oO1 = Object.prototype, cO1 = aO1.toString, hO1 = oO1.hasOwnProperty, uO1 = RegExp(
  "^" + cO1.call(hO1).replace(lO1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function dO1(t) {
  if (!iO1(t) || nO1(t))
    return !1;
  var e = tO1(t) ? uO1 : rO1;
  return e.test(sO1(t));
}
var fO1 = dO1;
function vO1(t, e) {
  return t == null ? void 0 : t[e];
}
var pO1 = vO1, mO1 = fO1, gO1 = pO1;
function yO1(t, e) {
  var n = gO1(t, e);
  return mO1(n) ? n : void 0;
}
var u9 = yO1, _O1 = u9, qO1 = I8, wO1 = _O1(qO1, "Map"), gw = wO1, zO1 = u9, MO1 = zO1(Object, "create"), xd = MO1, vb = xd;
function bO1() {
  this.__data__ = vb ? vb(null) : {}, this.size = 0;
}
var LO1 = bO1;
function xO1(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var SO1 = xO1, CO1 = xd, kO1 = "__lodash_hash_undefined__", EO1 = Object.prototype, AO1 = EO1.hasOwnProperty;
function FO1(t) {
  var e = this.__data__;
  if (CO1) {
    var n = e[t];
    return n === kO1 ? void 0 : n;
  }
  return AO1.call(e, t) ? e[t] : void 0;
}
var TO1 = FO1, IO1 = xd, OO1 = Object.prototype, NO1 = OO1.hasOwnProperty;
function PO1(t) {
  var e = this.__data__;
  return IO1 ? e[t] !== void 0 : NO1.call(e, t);
}
var BO1 = PO1, VO1 = xd, RO1 = "__lodash_hash_undefined__";
function HO1(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = VO1 && e === void 0 ? RO1 : e, this;
}
var DO1 = HO1, $O1 = LO1, UO1 = SO1, jO1 = TO1, GO1 = BO1, WO1 = DO1;
function d9(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
d9.prototype.clear = $O1;
d9.prototype.delete = UO1;
d9.prototype.get = jO1;
d9.prototype.has = GO1;
d9.prototype.set = WO1;
var YO1 = d9, pb = YO1, XO1 = Ld, KO1 = gw;
function ZO1() {
  this.size = 0, this.__data__ = {
    hash: new pb(),
    map: new (KO1 || XO1)(),
    string: new pb()
  };
}
var JO1 = ZO1;
function QO1(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var eN1 = QO1, tN1 = eN1;
function nN1(t, e) {
  var n = t.__data__;
  return tN1(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Sd = nN1, iN1 = Sd;
function sN1(t) {
  var e = iN1(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var lN1 = sN1, rN1 = Sd;
function aN1(t) {
  return rN1(this, t).get(t);
}
var oN1 = aN1, cN1 = Sd;
function hN1(t) {
  return cN1(this, t).has(t);
}
var uN1 = hN1, dN1 = Sd;
function fN1(t, e) {
  var n = dN1(this, t), i = n.size;
  return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
}
var vN1 = fN1, pN1 = JO1, mN1 = lN1, gN1 = oN1, yN1 = uN1, _N1 = vN1;
function f9(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
f9.prototype.clear = pN1;
f9.prototype.delete = mN1;
f9.prototype.get = gN1;
f9.prototype.has = yN1;
f9.prototype.set = _N1;
var yw = f9, qN1 = Ld, wN1 = gw, zN1 = yw, MN1 = 200;
function bN1(t, e) {
  var n = this.__data__;
  if (n instanceof qN1) {
    var i = n.__data__;
    if (!wN1 || i.length < MN1 - 1)
      return i.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new zN1(i);
  }
  return n.set(t, e), this.size = n.size, this;
}
var LN1 = bN1, xN1 = Ld, SN1 = RI1, CN1 = DI1, kN1 = UI1, EN1 = GI1, AN1 = LN1;
function Bc(t) {
  var e = this.__data__ = new xN1(t);
  this.size = e.size;
}
Bc.prototype.clear = SN1;
Bc.prototype.delete = CN1;
Bc.prototype.get = kN1;
Bc.prototype.has = EN1;
Bc.prototype.set = AN1;
var FN1 = "__lodash_hash_undefined__";
function TN1(t) {
  return this.__data__.set(t, FN1), this;
}
var IN1 = TN1;
function ON1(t) {
  return this.__data__.has(t);
}
var NN1 = ON1, PN1 = yw, BN1 = IN1, VN1 = NN1;
function u_(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new PN1(); ++e < n; )
    this.add(t[e]);
}
u_.prototype.add = u_.prototype.push = BN1;
u_.prototype.has = VN1;
var RN1 = I8;
RN1.Uint8Array;
var mb = Md, gb = mb ? mb.prototype : void 0;
gb && gb.valueOf;
var HN1 = u9, DN1 = I8, $N1 = HN1(DN1, "DataView"), UN1 = $N1, jN1 = u9, GN1 = I8, WN1 = jN1(GN1, "Promise"), YN1 = WN1, XN1 = u9, KN1 = I8, ZN1 = XN1(KN1, "Set"), JN1 = ZN1, QN1 = u9, eP1 = I8, tP1 = QN1(eP1, "WeakMap"), nP1 = tP1, d_ = UN1, f_ = gw, v_ = YN1, p_ = JN1, m_ = nP1, eA = mw, v9 = QE, yb = "[object Map]", iP1 = "[object Object]", _b = "[object Promise]", qb = "[object Set]", wb = "[object WeakMap]", zb = "[object DataView]", sP1 = v9(d_), lP1 = v9(f_), rP1 = v9(v_), aP1 = v9(p_), oP1 = v9(m_), na = eA;
(d_ && na(new d_(new ArrayBuffer(1))) != zb || f_ && na(new f_()) != yb || v_ && na(v_.resolve()) != _b || p_ && na(new p_()) != qb || m_ && na(new m_()) != wb) && (na = function(t) {
  var e = eA(t), n = e == iP1 ? t.constructor : void 0, i = n ? v9(n) : "";
  if (i)
    switch (i) {
      case sP1:
        return zb;
      case lP1:
        return yb;
      case rP1:
        return _b;
      case aP1:
        return qb;
      case oP1:
        return wb;
    }
  return e;
});
var tA = yw, cP1 = "Expected a function";
function _w(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(cP1);
  var n = function() {
    var i = arguments, s = e ? e.apply(this, i) : i[0], l = n.cache;
    if (l.has(s))
      return l.get(s);
    var a = t.apply(this, i);
    return n.cache = l.set(s, a) || l, a;
  };
  return n.cache = new (_w.Cache || tA)(), n;
}
_w.Cache = tA;
var hP1 = _w, uP1 = hP1, dP1 = 500;
function fP1(t) {
  var e = uP1(t, function(i) {
    return n.size === dP1 && n.clear(), i;
  }), n = e.cache;
  return e;
}
var vP1 = fP1, pP1 = vP1, mP1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, gP1 = /\\(\\)?/g;
pP1(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(mP1, function(n, i, s, l) {
    e.push(s ? l.replace(gP1, "$1") : i || n);
  }), e;
});
var Mb = Md, bb = Mb ? Mb.prototype : void 0;
bb && bb.toString;
/*!
 * Built by Revolist OU
 */
async function yP1(t = 0) {
  await new Promise((e) => {
    setTimeout(() => e(), t);
  });
}
const _P1 = {
  mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  // mime: 'text/csv',
  fileKind: "xlsx",
  encoding: "",
  cellFormat: {
    number: { default: "#,##0", decimal: 2 }
  },
  sourceTab: !0,
  sourceStyles: !0
}, qP1 = String.fromCharCode(13), wP1 = String.fromCharCode(10), zP1 = String.fromCharCode(34), MP1 = new RegExp('"', "g");
class bP1 {
  constructor(e = {}, n) {
    O2(this, "options");
    this.sheet = n, this.options = { ..._P1, ...e };
  }
  /**
   * Get the types of columns based on the data provided.
   * If a column contains at least one numeric value, it's considered a boolean column (true).
   * Otherwise, it's considered a string column (false).
   *
   * @param {object} options - Options object.
   * @param {JclDataViewerDataInputCustom['data']} options.data - Array of objects containing the data.
   * @param {JclDataViewerDataInputCustom['props']} options.props - Array of strings representing the properties to consider as columns.
   * @returns {Array<boolean|string>} An array indicating the types of columns.
   *                                 True for boolean columns (if contains at least one numeric value),
   *                                 False for string columns.
   * @protected
   */
  getColumnTypes({ data: e, props: n }) {
    const i = [];
    for (let s = 0; s < n.length; s++) {
      const l = n[s], o = e.map((h) => h[l]).some((h) => typeof h == "number" && !isNaN(h));
      i.push(o);
    }
    return i;
  }
  getNumberFormat() {
    var l;
    const e = (l = this.options.cellFormat) == null ? void 0 : l.number, n = (e == null ? void 0 : e.default) ?? "#,##0", i = e == null ? void 0 : e.format, s = e == null ? void 0 : e.decimal;
    return i || (!s1.isNil(s) && s1.isNumber(s) ? `${n}${s > 0 ? "." + "0".repeat(s) : ""}` : n);
  }
  parseCell(e, n = !1) {
    let i = e;
    if (typeof e != "string")
      return i;
    const s = [qP1, zP1, wP1];
    return typeof i > "u" || s1.isNil(i) || i === null ? "" : i !== "" && (n || s.some((l) => i.indexOf(l) >= 0)) ? `"${i.replace(MP1, '""')}"` : i;
  }
  async doExport(e) {
  }
}
class LP1 extends bP1 {
  /**
   * Retrieves cell data, value, and styles based on a given NUTS code and year.
   *
   * @param {string} nutsCode - string that represents a code used in the NUTSsystem.
   * It is used to classify regions within the European Union for statistical purposes.
   *
   * @param {number} year - used to specify the year for which you want to retrieve data
   *
   * @returns {Object} with the following properties:
   * - `cell`: Cell object
   * - `value`: name of the classification, with an additional description if an annotation exists.
   * - `styles`: An object containing styles for the cell, such as `fontWeight`, `fontStyle
   */
  getCellSourceData(e, n) {
    var s, l, a, o, h;
    const i = {
      cell: void 0,
      value: null,
      styles: {}
    };
    if (e && n) {
      const u = this.sheet.getCell(e, n);
      let d = ((s = u == null ? void 0 : u.classification) == null ? void 0 : s.name) ?? null;
      const v = (l = u == null ? void 0 : u.classification) == null ? void 0 : l.styles, m = {};
      v && Object.assign(m, {
        fontWeight: v != null && v.bold ? "bold" : void 0,
        fontStyle: v != null && v.italic ? "italic" : void 0,
        backgroundColor: (v == null ? void 0 : v.backgroundColor) ?? void 0,
        color: (v == null ? void 0 : v.color) ?? void 0
      }), (a = u == null ? void 0 : u.annotation) != null && a.description && (h = (o = u == null ? void 0 : u.annotation) == null ? void 0 : o.styles) != null && h.boxShadowColor && (Object.assign(m, {
        borderColor: u.annotation.styles.boxShadowColor,
        borderStyle: "medium"
      }), d += ` (${u.annotation.description})`), Object.assign(i, {
        cell: u,
        value: d,
        styles: m
      });
    }
    return i;
  }
  async doExport({ data: e, headers: n, props: i, headersPinned: s }) {
    var q, M;
    const l = s1.first(n), a = this.getColumnTypes({ data: e, props: i }), o = [], h = s1.chain(e).map((z) => s1.reduce(i, (b, x, k) => {
      const D = z[x];
      if (s1.isNil(o[k])) {
        const P = l[k];
        o.push({
          value: P,
          backgroundColor: "#FCFCFC",
          color: "#3860ED",
          fontWeight: "bold",
          align: "left"
        });
      }
      const R = a[k] ? Number : String, V = this.parseCell(D);
      let J = R === String ? `${V}` : +V;
      s1.isNull(V) && (J = V);
      let K = {};
      if (this.options.sourceStyles && "nutsCode" in z && R === Number) {
        const P = +l[k], O = this.getCellSourceData(z.nutsCode, P);
        K = O == null ? void 0 : O.styles;
      }
      return b.push({
        value: J,
        wrap: !1,
        type: R,
        format: R === Number ? this.getNumberFormat() : void 0,
        ...K
      }), b;
    }, [])).value();
    let u = [];
    this.options.sourceTab && this.sheet && (u = s1.chain(e).map((z) => s1.reduce(i, (b, x, k) => {
      const F = {};
      if ("nutsCode" in z) {
        const D = this.getCellSourceData(z.nutsCode, +l[k]);
        if (D != null && D.value) {
          const R = (D == null ? void 0 : D.value) ?? null, V = this.options.sourceStyles ? D == null ? void 0 : D.styles : {};
          Object.assign(F, { value: R, ...V });
        }
      }
      return s1.isEmpty(F) && (x in z ? Object.assign(F, { value: z[x] }) : Object.assign(F, { value: null })), b.push(F), b;
    }, [])).value());
    const d = H(this.options.filename), v = H((q = this.options) == null ? void 0 : q.filenameAppend) ?? "", m = H((M = this.options) == null ? void 0 : M.filenamePrepend) ?? "", p = [[o, ...h]], _ = ["Data"];
    return !s1.isNil(u) && !s1.isEmpty(u) && (p.push([o, ...u]), _.push("Sources")), await QA(p, {
      fileName: `${H(m)}${H(d)}${H(v)}.xlsx`,
      stickyRowsCount: 1,
      stickyColumnsCount: s == null ? void 0 : s.length,
      sheets: _
    });
  }
}
/*!
 * Built by Revolist OU
 */
const xP1 = "__rvgr";
/*!
 * Built by Revolist OU
 */
const nA = `${xP1}-name`;
/*!
 * Built by Revolist OU
 */
function SP1(t) {
  return t && t[nA];
}
function CP1(t) {
  return t && typeof t[nA] < "u";
}
const kP1 = {
  mime: "text/csv",
  fileKind: "csv",
  // BOM signature
  bom: !0,
  columnDelimiter: ",",
  rowDelimiter: `\r
`,
  encoding: ""
}, EP1 = String.fromCharCode(13), AP1 = String.fromCharCode(10), FP1 = String.fromCharCode(34), TP1 = String.fromCharCode(65279), IP1 = new RegExp('"', "g");
class OP1 {
  constructor(e = {}) {
    O2(this, "options");
    this.options = { ...kP1, ...e };
  }
  async doExport({ data: e, headers: n, props: i }) {
    return new Promise((s) => {
      let l = this.options.bom ? TP1 : "";
      (n == null ? void 0 : n.length) > 0 && n.forEach((a) => {
        a.length && (l += this.prepareHeader(a, this.options.columnDelimiter), l += this.options.rowDelimiter);
      }), e.forEach((a, o) => {
        if (o > 0 && (l += this.options.rowDelimiter), CP1(a)) {
          l += this.parseCell(SP1(a), this.options.columnDelimiter);
          return;
        }
        l += i.map((h) => this.parseCell(a[h], this.options.columnDelimiter)).join(this.options.columnDelimiter);
      }), s(l);
    });
  }
  prepareHeader(e, n) {
    let i = "";
    const s = e.map((l) => this.parseCell(l, n, !0));
    return i += s.join(n), i;
  }
  parseCell(e, n, i = !1) {
    let s = e;
    typeof e != "string" && (s = JSON.stringify(e));
    const l = [EP1, FP1, AP1, n];
    return typeof s > "u" || s1.isNil(s) || s === null || s === "null" ? "" : s !== "" && (i || l.some((a) => s.indexOf(a) >= 0)) ? `"${s.replace(IP1, '""')}"` : s;
  }
}
/*!
 * Built by Revolist OU
 */
class NP1 {
  constructor(e, n) {
    this.revogrid = e, this.providers = n, this.subscriptions = {};
  }
  /**
   *
   * @param eventName - event name to subscribe to in revo-grid component (e.g. 'initialHeaderClick')
   * @param callback - callback function for event
   */
  addEventListener(e, n) {
    this.revogrid.addEventListener(e, n), this.subscriptions[e] = n;
  }
  /**
   * Subscribe to property change in revo-grid component
   * You can return false in callback to prevent default value set
   *
   * @param prop - property name
   * @param callback - callback function
   * @param immediate - trigger callback immediately with current value
   */
  watch(e, n, { immediate: i } = { immediate: !1 }) {
    const s = Object.getOwnPropertyDescriptor(this.revogrid, e) || Object.getOwnPropertyDescriptor(this.revogrid.constructor.prototype, e);
    Object.defineProperty(this.revogrid, e, {
      set(l) {
        var a;
        if (n(l) !== !1)
          return (a = s == null ? void 0 : s.set) === null || a === void 0 ? void 0 : a.call(this, l);
      },
      get() {
        var l;
        return (l = s == null ? void 0 : s.get) === null || l === void 0 ? void 0 : l.call(this);
      }
    }), i && n(s == null ? void 0 : s.value);
  }
  /**
   * Remove event listener
   * @param eventName
   */
  removeEventListener(e) {
    this.revogrid.removeEventListener(e, this.subscriptions[e]), delete this.subscriptions[e];
  }
  /**
   * Emit event from revo-grid component
   * Event can be cancelled by calling event.preventDefault() in callback
   */
  emit(e, n) {
    const i = new CustomEvent(e, { detail: n, cancelable: !0 });
    return this.revogrid.dispatchEvent(i), i;
  }
  /**
   * Clear all subscriptions
   */
  clearSubscriptions() {
    for (let e in this.subscriptions)
      this.removeEventListener(e);
  }
  /**
   * Destroy plugin and clear all subscriptions
   */
  destroy() {
    this.clearSubscriptions();
  }
}
const PP1 = ["rowPinStart", "rgRow", "rowPinEnd"], BP1 = [
  "colPinStart",
  "rgCol",
  "colPinEnd"
];
/*!
 * Built by Revolist OU
 */
var fh = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function iA(t, e, n) {
  return n = {
    path: e,
    exports: {},
    require: function(i, s) {
      return VP1();
    }
  }, t(n, n.exports), n.exports;
}
function VP1() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var RP1 = typeof fh == "object" && fh && fh.Object === Object && fh, sA = RP1, HP1 = typeof self == "object" && self && self.Object === Object && self, DP1 = sA || HP1 || Function("return this")(), O8 = DP1, $P1 = O8.Symbol, Hs = $P1, lA = Object.prototype, UP1 = lA.hasOwnProperty, jP1 = lA.toString, lo = Hs ? Hs.toStringTag : void 0;
function GP1(t) {
  var e = UP1.call(t, lo), n = t[lo];
  try {
    t[lo] = void 0;
    var i = !0;
  } catch {
  }
  var s = jP1.call(t);
  return i && (e ? t[lo] = n : delete t[lo]), s;
}
var WP1 = GP1, YP1 = Object.prototype, XP1 = YP1.toString;
function KP1(t) {
  return XP1.call(t);
}
var ZP1 = KP1, JP1 = "[object Null]", QP1 = "[object Undefined]", Lb = Hs ? Hs.toStringTag : void 0;
function eB1(t) {
  return t == null ? t === void 0 ? QP1 : JP1 : Lb && Lb in Object(t) ? WP1(t) : ZP1(t);
}
var Cd = eB1;
function tB1(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var rA = tB1;
function nB1(t) {
  return t != null && typeof t == "object";
}
var aA = nB1;
/*!
 * Built by Revolist OU
 */
function iB1() {
  this.__data__ = [], this.size = 0;
}
var sB1 = iB1;
function lB1(t, e) {
  return t === e || t !== t && e !== e;
}
var rB1 = lB1;
function aB1(t, e) {
  for (var n = t.length; n--; )
    if (rB1(t[n][0], e))
      return n;
  return -1;
}
var kd = aB1, oB1 = Array.prototype, cB1 = oB1.splice;
function hB1(t) {
  var e = this.__data__, n = kd(e, t);
  if (n < 0)
    return !1;
  var i = e.length - 1;
  return n == i ? e.pop() : cB1.call(e, n, 1), --this.size, !0;
}
var uB1 = hB1;
function dB1(t) {
  var e = this.__data__, n = kd(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var fB1 = dB1;
function vB1(t) {
  return kd(this.__data__, t) > -1;
}
var pB1 = vB1;
function mB1(t, e) {
  var n = this.__data__, i = kd(n, t);
  return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
}
var gB1 = mB1;
function p9(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
p9.prototype.clear = sB1;
p9.prototype.delete = uB1;
p9.prototype.get = fB1;
p9.prototype.has = pB1;
p9.prototype.set = gB1;
var yB1 = p9, _B1 = "[object AsyncFunction]", qB1 = "[object Function]", wB1 = "[object GeneratorFunction]", zB1 = "[object Proxy]";
function MB1(t) {
  if (!rA(t))
    return !1;
  var e = Cd(t);
  return e == qB1 || e == wB1 || e == _B1 || e == zB1;
}
var bB1 = MB1, LB1 = O8["__core-js_shared__"], ay = LB1, xb = function() {
  var t = /[^.]+$/.exec(ay && ay.keys && ay.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function xB1(t) {
  return !!xb && xb in t;
}
var SB1 = xB1, CB1 = Function.prototype, kB1 = CB1.toString;
function EB1(t) {
  if (t != null) {
    try {
      return kB1.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Ar = EB1, AB1 = /[\\^$.*+?()[\]{}|]/g, FB1 = /^\[object .+?Constructor\]$/, TB1 = Function.prototype, IB1 = Object.prototype, OB1 = TB1.toString, NB1 = IB1.hasOwnProperty, PB1 = RegExp(
  "^" + OB1.call(NB1).replace(AB1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function BB1(t) {
  if (!rA(t) || SB1(t))
    return !1;
  var e = bB1(t) ? PB1 : FB1;
  return e.test(Ar(t));
}
var VB1 = BB1;
function RB1(t, e) {
  return t == null ? void 0 : t[e];
}
var HB1 = RB1;
function DB1(t, e) {
  var n = HB1(t, e);
  return VB1(n) ? n : void 0;
}
var m9 = DB1, $B1 = m9(O8, "Map"), zu = $B1, UB1 = m9(Object, "create"), fc = UB1;
function jB1() {
  this.__data__ = fc ? fc(null) : {}, this.size = 0;
}
var GB1 = jB1;
function WB1(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var YB1 = WB1, XB1 = "__lodash_hash_undefined__", KB1 = Object.prototype, ZB1 = KB1.hasOwnProperty;
function JB1(t) {
  var e = this.__data__;
  if (fc) {
    var n = e[t];
    return n === XB1 ? void 0 : n;
  }
  return ZB1.call(e, t) ? e[t] : void 0;
}
var QB1 = JB1, eV1 = Object.prototype, tV1 = eV1.hasOwnProperty;
function nV1(t) {
  var e = this.__data__;
  return fc ? e[t] !== void 0 : tV1.call(e, t);
}
var iV1 = nV1, sV1 = "__lodash_hash_undefined__";
function lV1(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = fc && e === void 0 ? sV1 : e, this;
}
var rV1 = lV1;
function g9(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
g9.prototype.clear = GB1;
g9.prototype.delete = YB1;
g9.prototype.get = QB1;
g9.prototype.has = iV1;
g9.prototype.set = rV1;
var Sb = g9;
function aV1() {
  this.size = 0, this.__data__ = {
    hash: new Sb(),
    map: new (zu || yB1)(),
    string: new Sb()
  };
}
var oV1 = aV1;
function cV1(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var hV1 = cV1;
function uV1(t, e) {
  var n = t.__data__;
  return hV1(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Ed = uV1;
function dV1(t) {
  var e = Ed(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var fV1 = dV1;
function vV1(t) {
  return Ed(this, t).get(t);
}
var pV1 = vV1;
function mV1(t) {
  return Ed(this, t).has(t);
}
var gV1 = mV1;
function yV1(t, e) {
  var n = Ed(this, t), i = n.size;
  return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
}
var _V1 = yV1;
function y9(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
y9.prototype.clear = oV1;
y9.prototype.delete = fV1;
y9.prototype.get = pV1;
y9.prototype.has = gV1;
y9.prototype.set = _V1;
var oA = y9;
O8.Uint8Array;
var Cb = Hs ? Hs.prototype : void 0;
Cb && Cb.valueOf;
var qV1 = "[object Arguments]";
function wV1(t) {
  return aA(t) && Cd(t) == qV1;
}
var kb = wV1, cA = Object.prototype, zV1 = cA.hasOwnProperty, MV1 = cA.propertyIsEnumerable;
kb(function() {
  return arguments;
}());
function bV1() {
  return !1;
}
var LV1 = bV1;
iA(function(t, e) {
  var n = e && !e.nodeType && e, i = n && !0 && t && !t.nodeType && t, s = i && i.exports === n, l = s ? O8.Buffer : void 0, a = l ? l.isBuffer : void 0, o = a || LV1;
  t.exports = o;
});
var Eb = iA(function(t, e) {
  var n = e && !e.nodeType && e, i = n && !0 && t && !t.nodeType && t, s = i && i.exports === n, l = s && sA.process, a = function() {
    try {
      var o = i && i.require && i.require("util").types;
      return o || l && l.binding && l.binding("util");
    } catch {
    }
  }();
  t.exports = a;
});
Eb && Eb.isTypedArray;
var xV1 = m9(O8, "DataView"), g_ = xV1, SV1 = m9(O8, "Promise"), y_ = SV1, CV1 = m9(O8, "Set"), __ = CV1, kV1 = m9(O8, "WeakMap"), q_ = kV1, Ab = "[object Map]", EV1 = "[object Object]", Fb = "[object Promise]", Tb = "[object Set]", Ib = "[object WeakMap]", Ob = "[object DataView]", AV1 = Ar(g_), FV1 = Ar(zu), TV1 = Ar(y_), IV1 = Ar(__), OV1 = Ar(q_), ia = Cd;
(g_ && ia(new g_(new ArrayBuffer(1))) != Ob || zu && ia(new zu()) != Ab || y_ && ia(y_.resolve()) != Fb || __ && ia(new __()) != Tb || q_ && ia(new q_()) != Ib) && (ia = function(t) {
  var e = Cd(t), n = e == EV1 ? t.constructor : void 0, i = n ? Ar(n) : "";
  if (i)
    switch (i) {
      case AV1:
        return Ob;
      case FV1:
        return Ab;
      case TV1:
        return Fb;
      case IV1:
        return Tb;
      case OV1:
        return Ib;
    }
  return e;
});
var NV1 = "Expected a function";
function qw(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(NV1);
  var n = function() {
    var i = arguments, s = e ? e.apply(this, i) : i[0], l = n.cache;
    if (l.has(s))
      return l.get(s);
    var a = t.apply(this, i);
    return n.cache = l.set(s, a) || l, a;
  };
  return n.cache = new (qw.Cache || oA)(), n;
}
qw.Cache = oA;
var PV1 = qw, BV1 = 500;
function VV1(t) {
  var e = PV1(t, function(i) {
    return n.size === BV1 && n.clear(), i;
  }), n = e.cache;
  return e;
}
var RV1 = VV1, HV1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, DV1 = /\\(\\)?/g;
RV1(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(HV1, function(n, i, s, l) {
    e.push(s ? l.replace(DV1, "$1") : i || n);
  }), e;
});
var Nb = Hs ? Hs.prototype : void 0;
Nb && Nb.toString;
var ww = /* @__PURE__ */ ((t) => (t.csv = "csv", t.xlsx = "xlsx", t.custom = "custom", t))(ww || {});
class hA extends NP1 {
  // private sheet: typeof Sheet | undefined;
  constructor(n, i) {
    super(n, []);
    O2(this, "customExportClass");
    this.sheet = i;
  }
  /** Export file */
  async exportFile(n = {}, i = "csv", s) {
    let l = i;
    switch (s1.isNil(s) || (this.customExportClass = s, l = "custom"), l) {
      case "csv":
        {
          const a = this.customFormatter(l, n), o = await this.getBlob(a), h = window.URL || window.webkitURL, u = document.createElement("a"), { filename: d, filenameAppend: v, filenamePrepend: m, fileKind: p } = a.options, _ = H(v) ?? "", q = H(m) ?? "", M = `${H(q)}${H(d)}${H(_)}.${p}`, z = h.createObjectURL(o);
          u.style.display = "none", u.setAttribute("href", z), u.setAttribute("download", M), this.revogrid.appendChild(u), u.dispatchEvent(new MouseEvent("click")), this.revogrid.removeChild(u), await yP1(120), h.revokeObjectURL(z);
        }
        break;
      case "xlsx":
        {
          const a = this.customFormatter(l, n);
          await this.getBlob(a);
        }
        break;
      case "custom":
        {
          const a = this.customFormatter(l, n);
          await this.getBlob(a);
        }
        break;
    }
  }
  /** Blob object */
  async getBlob(n) {
    const i = `${n.options.mime};charset=${n.options.encoding}`;
    if (typeof Blob < "u") {
      const s = await this.beforeexport();
      if (!s)
        return null;
      const l = await n.doExport(s);
      return new Blob([l], { type: i });
    }
    return null;
  }
  // before event
  async beforeexport() {
    let n = await this.getData();
    const i = this.emit("beforeexport", { data: n });
    return i.defaultPrevented ? null : i.detail.data;
  }
  async getData() {
    var a;
    const n = await this.getSource(), i = [], s = [];
    BP1.forEach((o, h) => {
      s.push(this.getColPerSource(o).then((u) => i[h] = u));
    }), await Promise.all(s);
    const l = {
      headers: [],
      headersPinned: [],
      // Contains the pinned columns
      props: []
    };
    for (let o of i)
      o.headers.forEach((h, u) => {
        l.headers[u] || (l.headers[u] = []), l.headers[u].push(...h);
      }), o != null && o.headersPinned && ((a = l.headersPinned) == null || a.push(...o.headersPinned)), l.props.push(...o.props);
    return {
      data: n,
      ...l
    };
  }
  async getColPerSource(n) {
    const i = await this.revogrid.getColumnStore(n), s = i.get("source"), l = i.get("items"), a = i.get("groupingDepth"), o = i.get("groups"), h = [], u = [], d = [], v = l.reduce((p, _, q) => {
      var z;
      const M = s[_].prop;
      return h.push(s[_].name || ""), s1.isNil((z = s[_]) == null ? void 0 : z.pin) || u.push(s[_].name || ""), d.push(M), p[M] = q, p;
    }, {}), m = this.getGroupHeaders(a, o, l, v);
    return m.push(h), {
      headers: m,
      props: d,
      headersPinned: u
    };
  }
  getGroupHeaders(n, i, s, l) {
    const a = [], o = s1.fill(new Array(s.length), "");
    for (let h = 0; h < n; h++) {
      const u = [...o];
      if (a.push(u), !i[h])
        continue;
      i[h].forEach((v) => {
        const m = this.findGroupStartIndex(v.ids, l);
        typeof m == "number" && (u[m] = v.name);
      });
    }
    return a;
  }
  findGroupStartIndex(n, i) {
    let s;
    return n.forEach((l) => {
      const a = i[l];
      typeof a == "number" && (typeof s != "number" || s > a) && (s = a);
    }), s;
  }
  async getSource() {
    const n = [], i = [];
    return PP1.forEach((s) => {
      const l = [];
      n.push(l);
      const a = this.revogrid.getVisibleSource(s).then((o) => l.push(...o));
      i.push(a);
    }), await Promise.all(i), n.reduce((s, l) => (s.push(...l), s), []);
  }
  // // before event
  // private async beforeexport() {
  //   let data = await this.getData();
  //   const event: CustomEvent<{ data: DataInput }> = this.emit('beforeexport', { data });
  //   if (event.defaultPrevented) {
  //     return null;
  //   }
  //   return event.detail.data;
  // }
  // /** Blob object */
  // async getCustomBlob(formatter: Formatter) {
  //   const type = `${formatter.options.mime};charset=${formatter.options.encoding}`;
  //   if (typeof Blob !== 'undefined') {
  //     // const data = await this.beforeexport();
  //     // if (!data) {
  //     //   return null;
  //     // }
  //     const _d = await formatter.doExport(data);
  //     return new Blob([formatter.doExport(data)], { type });
  //   }
  //   return null;
  // }
  // get correct class for future multiple types support
  customFormatter(n, i = {}) {
    switch (n) {
      case "csv":
        return new OP1(i);
      case "xlsx":
        return new LP1(i, this.sheet);
      case "custom":
        try {
          if (this.customExportClass)
            return new this.customExportClass(i, this.sheet);
        } catch (s) {
          throw new Error(s);
        }
        break;
      default:
        throw new Error("Unknown format");
    }
  }
}
const Cu = class Cu {
  constructor(e) {
    O2(this, "isInitialized", !1);
    O2(this, "isFiltering", !1);
    O2(this, "_options");
    O2(this, "_variable");
    O2(this, "_subscribers");
    O2(this, "_cellMap", new pk1());
    O2(this, "_nutsMap", new mk1());
    O2(this, "_nutsList", []);
    O2(this, "_yearList", []);
    O2(this, "_filters", /* @__PURE__ */ new Map());
    O2(this, "hasEditedData", D1(!1));
    O2(this, "CELL_INFO", {
      padding: 24,
      // left + right
      baseFont: 7,
      // width of char (approximately)
      minSize: 50
      // min width of a cell
    });
    O2(this, "cellList", []);
    O2(this, "columnList", D1([]));
    O2(this, "rowList", D1([]));
    O2(this, "_defaultCellTemplate", (e, n) => e(
      "span",
      {
        class: n.prop
      },
      n.model[n.prop]
    ));
    O2(this, "cellEditErrorThrottle");
    O2(this, "cellEditErrorList", []);
    O2(this, "cellEditErrorAdd", (e) => {
      e && this.cellEditErrorList.push(e);
    });
    O2(this, "cellEditErrorShow", () => {
      this.cellEditErrorThrottle && clearTimeout(this.cellEditErrorThrottle), this.cellEditErrorThrottle = setTimeout(() => {
        const e = s1.map(this.cellEditErrorList, (i) => `${i.nuts.code} - ${i.year}`), n = `The value entered for ${this.cellEditErrorList.length} cells is not a number.
All invalid values were restored to their original value.

Cells with invalid value are:
${e.join(
          `
`
        )}`;
        alert(n), console.error(n), this.cellEditErrorList = [];
      }, 60);
    });
    /**
     * Add all behaviour to the component
     */
    O2(this, "addBehaviours", () => {
      var i, s;
      const e = (s = (i = this._options) == null ? void 0 : i.behaviour) == null ? void 0 : s.scrollToNearestYear;
      let n = {
        enabled: !1,
        waitTime: 75
      };
      if (s1.isNil(e) || (s1.isBoolean(e) ? n.enabled = e : n = s1.merge(n, e)), n && !s1.isNil(n == null ? void 0 : n.enabled) && n.enabled !== !1) {
        const l = this.getInstance();
        if (l) {
          let a;
          const o = () => {
            a && clearTimeout(a);
            const h = s1.chain(H(this.columnList)).map((v) => v.name).filter((v) => s1.isNumber(v)).value(), u = s1.isNumber(n == null ? void 0 : n.enabled) ? n.enabled : (/* @__PURE__ */ new Date()).getFullYear(), d = s1.reduce(h, (v, m) => Math.abs(m - u) < Math.abs(v - u) ? m : v);
            a = setTimeout(() => {
              l.scrollToColumnProp(`y${d}`), l.removeEventListener("aftersourceset", o);
            }, n.waitTime), this._options.behaviour.scrollToNearestYear = !1;
          };
          l.addEventListener("aftersourceset", o);
        }
      }
    });
    this._options = { ...Cu.DEFAULT_OPTIONS, ...e }, this._subscribers = {
      beforeLoad: [],
      afterLoad: [],
      afterInitBaseColumns: [],
      beforeInitData: [],
      afterInitData: [],
      beforeFilterApply: [],
      afterFilterApply: [],
      select: [],
      filter: [],
      dataEmpty: [],
      dataFilled: []
    }, this.isInitialized = !1;
  }
  /**
   * The `initWithData` function initializes the data for a sheet by creating cells, adding them to a
   * cell map, and populating lists of NUTS codes and years.
   * @param {JclDataViewerCellSource[]} source - An array of objects representing the source data for the cells.
   * Each object in the array should have the following properties:
   * @param [options] - The `options` parameter is an optional object that can contain the following
   * property:
   */
  initWithData(e, n) {
    var i, s;
    this._variable = n == null ? void 0 : n.variable, this._emitEvent("beforeLoad"), this._cellMap.clear(), this._nutsMap.clear(), this._yearList = [], this.cellList = s1.map(e, (l) => {
      var h, u, d, v;
      const a = new Ja(l, {
        cellClassification: n == null ? void 0 : n.cellClassification,
        annotationClassification: n == null ? void 0 : n.annotationClassification,
        formatNumberOptions: (u = (h = this._options.data) == null ? void 0 : h.cellFormat) == null ? void 0 : u.number
      });
      this._cellMap.add(a);
      const o = { code: a.nuts.code, label: a.nuts.label, level: (d = a.nuts) == null ? void 0 : d.level, eu: (v = a.nuts) == null ? void 0 : v.eu };
      return this._nutsMap.add(o), this._yearList.push(a.year), a;
    }), this._nutsList = this._nutsMap.getKeyList(), this._yearList = s1.uniq(this._yearList).sort(), ((i = this._nutsList) == null ? void 0 : i.length) <= 0 && console.error("@Sheet: non sono presenti dati per NUTS!"), ((s = this._yearList) == null ? void 0 : s.length) <= 0 && console.error("@Sheet: non sono presenti dati per Year!"), this.isInitialized = !0, this._setSort(), this._initData();
  }
  /**
   * Initializes data for a sheet by setting column and row lists based on filters and cell values.
   */
  _initData() {
    var s;
    if (this.columnList.value = [
      {
        prop: "nuts",
        name: "NUTS",
        pin: "colPinStart",
        resize: !1,
        readonly: !0,
        cellTemplate: (l, a) => {
          const o = this._nutsMap.get([a.model.nuts]);
          return l(
            "span",
            { class: "nuts-code text-left", "nuts-code": o == null ? void 0 : o.code, title: o == null ? void 0 : o.label },
            a.model[a.prop]
          );
        }
      }
    ], this._emitEvent("afterInitBaseColumns"), s1.map(this._yearList, (l) => {
      s1.remove(this.columnList.value, (a) => a.prop === `y${l}`);
    }), this._emitEvent("beforeInitData"), this.isInitialized === !1)
      return;
    this.isFiltering && this._emitEvent("beforeFilterApply");
    const e = (s = this._options) == null ? void 0 : s.extraColumns;
    e && s1.each(e, (l) => {
      s1.keys(l).includes("cellTemplate") ? this.addColumn(l, !0) : this.addColumn({ ...l, cellTemplate: this._defaultCellTemplate }, !0);
    }), this.rowList.value = [];
    const n = Array.from(this._filters.values()), i = 14 * this.CELL_INFO.baseFont + this.CELL_INFO.padding;
    this._forEachRow((l, a, o) => {
      var u;
      if (n.map((d) => d(l, a, o)).every((d) => !!d)) {
        const d = this;
        this.columnList.value = s1.unionBy(
          H(this.columnList),
          l.map((m) => ({
            prop: `y${m.year}`,
            name: m.year,
            size: i,
            cellTemplate: (p, _) => {
              var k, F, D;
              let q = this.getCell(_.model.nuts, +_.column.name);
              const M = _.model[_.prop], z = Ja.parseValue(M);
              let b = z.value;
              z.valid === !1 && (this.cellEditErrorAdd(q), this.cellEditErrorShow(), b = (q == null ? void 0 : q.value) ?? null), M !== b && (_.model[_.prop] = b), (q == null ? void 0 : q.value) !== b && (this.hasEditedData.value = !0, q.value = s1.isNil(b) ? null : +b, this.setCell(q));
              const x = H(q == null ? void 0 : q.valueFormatted);
              return p(
                "span",
                {
                  class: "year",
                  year: q == null ? void 0 : q.year,
                  "nuts-code": q == null ? void 0 : q.nuts.code,
                  classification: (k = q == null ? void 0 : q.classification) == null ? void 0 : k.code,
                  annotation: q == null ? void 0 : q.annotationId,
                  edited: q == null ? void 0 : q.isEdited,
                  title: `${(q == null ? void 0 : q.nuts.label) ?? (q == null ? void 0 : q.nuts.code)} (${q == null ? void 0 : q.nuts.code}) | ${q == null ? void 0 : q.year}`,
                  style: s1.merge(
                    {},
                    (F = q == null ? void 0 : q.classification) == null ? void 0 : F.stylesComputed,
                    (D = q == null ? void 0 : q.annotation) == null ? void 0 : D.stylesComputed
                  ),
                  onClick() {
                    const R = this.parentNode.getBoundingClientRect(), V = d.getCell(_.model.nuts, +_.prop.substring(1)), J = {
                      cellBounding: {
                        clientX: R.x,
                        clientY: R.y,
                        width: R.width,
                        height: R.height
                      },
                      props: _.model,
                      cell: V,
                      sheet: d
                    };
                    d._emitEvent("select", J);
                  }
                },
                // @ts-ignore
                x
              );
            }
          })),
          "prop"
        );
        const v = (m, p) => {
          const _ = s1.keys(p);
          return s1.reduce(
            _,
            (q, M) => {
              if (!s1.isNil(M) && s1.isString(M)) {
                const z = p[M], b = `${m}${M.charAt(0).toUpperCase() + M.slice(1)}`;
                return s1.isArray(z) ? s1.assign(q, { [b]: z }) : s1.assign(q, { [b]: z });
              }
              return q;
            },
            {}
          );
        };
        this.rowList.value.push({
          ...v("nuts", o),
          ...v("variable", this._variable),
          ...v("variableDimension", (u = this._variable) == null ? void 0 : u.dimensionObject),
          nuts: o.code,
          ...s1.reduce(
            l,
            (m, p) => s1.assign(m, { [`y${p.year}`]: p.value, ...p.extra, classification: p == null ? void 0 : p.classification, annotation: p == null ? void 0 : p.annotation }),
            {}
          )
        });
      }
    }), this._emitEvent("afterInitData"), this.isInitialized && this.isFiltering ? (this._emitEvent("afterFilterApply"), this.isFiltering = !1) : this._emitEvent("afterLoad"), H(this.rowList).length <= 0 ? (this.columnList.value = [], this._emitEvent("dataEmpty")) : this._emitEvent("dataFilled"), this.addBehaviours();
  }
  /** Iterating over each NUTS code in the `_nutsList` array.
   * For each NUTS code, it retrieves the corresponding cells from the `_cellMap` using the NUTS code and each
   * year in the `_yearList`. It then calls the `callbackFn` function, passing the array of cells, the
   * index of the NUTS code in the `_nutsList`, and the NUTS code itself as arguments. This allows the
   * callback function to perform operations on each row of cells in the sheet.
   *
   * @param {(cell: JclDataViewerCell[], _index: number, nuts: (typeof this._nutsList)[number]) => void} callbackFn
   */
  _forEachRow(e) {
    this._nutsList.forEach((n, i) => {
      const s = this._yearList.map((l) => this.getCell(n.code, l));
      e.call(this, s, i, n);
    });
  }
  /* The `getCell` method is used to retrieve a specific cell from the sheet based on its NUTS code and
  year. */
  getCell(e, n) {
    return this._cellMap.get([e, n]);
  }
  /* The `getCell` method is used to retrieve a specific cell from the sheet based on its NUTS code and
  year. */
  setCell(e) {
    this._cellMap.add(e);
  }
  /**
   * Send event
   *
   * @param {keyof JclDataViewerSubsribers} name
   * @param {any} data
   */
  _emitEvent(e, n) {
    for (const i of this._subscribers[e])
      i(n);
  }
  /**
   * Add event
   *
   * @param {keyof JclDataViewerSubsribers} event
   * @param {Subscriber} eventCallback
   */
  subscribe(e, n) {
    if (!(e in this._subscribers))
      throw new rb(`You cannot subscribe to the event named "${e}". It doesn't exist.`);
    this._subscribers[e].push(n);
  }
  /**
   * Remove event
   *
   * @param {keyof JclDataViewerSubsribers} event
   * @param {Subscriber} eventCallback
   */
  unsubscribe(e, n) {
    const i = (s, l) => {
      const a = s.indexOf(l);
      a > -1 && s.splice(a, 1);
    };
    if (!(e in this._subscribers))
      throw new rb(`You cannot unsubscribe to the event named "${e}". It doesn't exist.`);
    i(this._subscribers[e], n);
  }
  /**
   * Aggiorna la cardinalità del sort e aggiorna la lista degli anni
   */
  _setSort() {
    this._yearList.sort(), this._options.sort.cardinality === "desc" && this._yearList.reverse();
  }
  /**
   * Imposta la cardinalità del sort
   *
   * @param {JclDataViewerSortCardinality} cardinality - cardinalità del sort
   */
  updateSort(e) {
    this._options.sort.cardinality = e, this._setSort(), this._initData();
  }
  /**
   * Aggiunge un filtro
   *
   * @param {ValueOf<FiltersMap>} name - nome del filtro
   * @param {JclDataViewerFilterPredicate} predicate - funzione di filtro
   */
  addFilter(e, n) {
    this._filters.set(e, n);
  }
  /**
   * Rimuove un filtro
   *
   * @param {ValueOf<FiltersMap>} name - nome del filtro
   */
  removeFilter(e) {
    this._filters.delete(e);
  }
  /**
   * Applica i filtri aggiornando i dati
   */
  applyFilters() {
    this.isFiltering = this.isInitialized && !0, this._initData();
  }
  /**
   * Restituisce i livelli esistenti dei nuts
   *
   * @returns {number[]}
   */
  getNutsLevel() {
    return s1.chain(this._nutsList).map((e) => e.level).uniq().value();
  }
  /**
   * Clears the filters and resets the subscribers to empty arrays.
   */
  destroy() {
    s1.each(this._filters.entries, (e) => this._filters.delete(e)), this._subscribers = {
      beforeLoad: [],
      afterLoad: [],
      afterInitBaseColumns: [],
      beforeInitData: [],
      afterInitData: [],
      beforeFilterApply: [],
      afterFilterApply: [],
      select: [],
      filter: [],
      dataEmpty: [],
      dataFilled: []
    };
  }
  getInstance() {
    return document.querySelector("revo-grid");
  }
  isInit() {
    return this.isInitialized;
  }
  get nutsMap() {
    return this._nutsMap;
  }
  get variable() {
    return this._variable;
  }
  /**
   * Add a new column to the column list, either at the last pinned column
   * index or at the end of the list, and then initializes the data if the function is not called from
   * an event.
   * @param {JclDataViewerColumnRegular} column - it represents the column that needs to be added to the column list.
   * @param [fromEvent=false] - is a boolean flag that indicates whether the
   * `addColumn` method is being called from an event or not. If `fromEvent` is `true` skip the initialization Data function
   */
  addColumn(e, n = !1) {
    const i = H(this.columnList), s = s1.findLastIndex(i, (l) => !s1.isNil(l.pin)) + 1;
    s1.isNil(s) ? i.push({ readonly: !0, ...e }) : i.splice(s, 0, { readonly: !0, ...e }), this.columnList.value = i, n === !1 && this._initData();
  }
  removeColumn(e) {
    const n = H(this.columnList), i = s1.findIndex(n, (s) => s.prop === e);
    s1.isNil(i) || this.columnList.value.splice(i, 1), this._initData();
  }
};
O2(Cu, "DEFAULT_OPTIONS", { editable: !1, sort: { cardinality: "asc" } });
let Mu = Cu;
function Ds(t) {
  return uA(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function H0(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function N8(t) {
  var e;
  return (e = (uA(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function uA(t) {
  return t instanceof Node || t instanceof H0(t).Node;
}
function x8(t) {
  return t instanceof Element || t instanceof H0(t).Element;
}
function hi(t) {
  return t instanceof HTMLElement || t instanceof H0(t).HTMLElement;
}
function Pb(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof H0(t).ShadowRoot;
}
function Vc(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: i,
    display: s
  } = C6(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && !["inline", "contents"].includes(s);
}
function $V1(t) {
  return ["table", "td", "th"].includes(Ds(t));
}
function zw(t) {
  const e = Mw(), n = C6(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (n.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (n.contain || "").includes(i));
}
function UV1(t) {
  let e = Qa(t);
  for (; hi(e) && !Ad(e); ) {
    if (zw(e))
      return e;
    e = Qa(e);
  }
  return null;
}
function Mw() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ad(t) {
  return ["html", "body", "#document"].includes(Ds(t));
}
function C6(t) {
  return H0(t).getComputedStyle(t);
}
function Fd(t) {
  return x8(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function Qa(t) {
  if (Ds(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Pb(t) && t.host || // Fallback.
    N8(t)
  );
  return Pb(e) ? e.host : e;
}
function dA(t) {
  const e = Qa(t);
  return Ad(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : hi(e) && Vc(e) ? e : dA(e);
}
function vc(t, e, n) {
  var i;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const s = dA(t), l = s === ((i = t.ownerDocument) == null ? void 0 : i.body), a = H0(s);
  return l ? e.concat(a, a.visualViewport || [], Vc(s) ? s : [], a.frameElement && n ? vc(a.frameElement) : []) : e.concat(s, vc(s, [], n));
}
function fA(t) {
  const e = C6(t);
  let n = parseFloat(e.width) || 0, i = parseFloat(e.height) || 0;
  const s = hi(t), l = s ? t.offsetWidth : n, a = s ? t.offsetHeight : i, o = Nh(n) !== l || Nh(i) !== a;
  return o && (n = l, i = a), {
    width: n,
    height: i,
    $: o
  };
}
function bw(t) {
  return x8(t) ? t : t.contextElement;
}
function Oa(t) {
  const e = bw(t);
  if (!hi(e))
    return Fs(1);
  const n = e.getBoundingClientRect(), {
    width: i,
    height: s,
    $: l
  } = fA(e);
  let a = (l ? Nh(n.width) : n.width) / i, o = (l ? Nh(n.height) : n.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const jV1 = /* @__PURE__ */ Fs(0);
function vA(t) {
  const e = H0(t);
  return !Mw() || !e.visualViewport ? jV1 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function GV1(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== H0(t) ? !1 : e;
}
function qr(t, e, n, i) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const s = t.getBoundingClientRect(), l = bw(t);
  let a = Fs(1);
  e && (i ? x8(i) && (a = Oa(i)) : a = Oa(t));
  const o = GV1(l, n, i) ? vA(l) : Fs(0);
  let h = (s.left + o.x) / a.x, u = (s.top + o.y) / a.y, d = s.width / a.x, v = s.height / a.y;
  if (l) {
    const m = H0(l), p = i && x8(i) ? H0(i) : i;
    let _ = m.frameElement;
    for (; _ && i && p !== m; ) {
      const q = Oa(_), M = _.getBoundingClientRect(), z = C6(_), b = M.left + (_.clientLeft + parseFloat(z.paddingLeft)) * q.x, x = M.top + (_.clientTop + parseFloat(z.paddingTop)) * q.y;
      h *= q.x, u *= q.y, d *= q.x, v *= q.y, h += b, u += x, _ = H0(_).frameElement;
    }
  }
  return rr({
    width: d,
    height: v,
    x: h,
    y: u
  });
}
function WV1(t) {
  let {
    rect: e,
    offsetParent: n,
    strategy: i
  } = t;
  const s = hi(n), l = N8(n);
  if (n === l)
    return e;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = Fs(1);
  const h = Fs(0);
  if ((s || !s && i !== "fixed") && ((Ds(n) !== "body" || Vc(l)) && (a = Fd(n)), hi(n))) {
    const u = qr(n);
    o = Oa(n), h.x = u.x + n.clientLeft, h.y = u.y + n.clientTop;
  }
  return {
    width: e.width * o.x,
    height: e.height * o.y,
    x: e.x * o.x - a.scrollLeft * o.x + h.x,
    y: e.y * o.y - a.scrollTop * o.y + h.y
  };
}
function YV1(t) {
  return Array.from(t.getClientRects());
}
function pA(t) {
  return qr(N8(t)).left + Fd(t).scrollLeft;
}
function XV1(t) {
  const e = N8(t), n = Fd(t), i = t.ownerDocument.body, s = B0(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = B0(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
  let a = -n.scrollLeft + pA(t);
  const o = -n.scrollTop;
  return C6(i).direction === "rtl" && (a += B0(e.clientWidth, i.clientWidth) - s), {
    width: s,
    height: l,
    x: a,
    y: o
  };
}
function KV1(t, e) {
  const n = H0(t), i = N8(t), s = n.visualViewport;
  let l = i.clientWidth, a = i.clientHeight, o = 0, h = 0;
  if (s) {
    l = s.width, a = s.height;
    const u = Mw();
    (!u || u && e === "fixed") && (o = s.offsetLeft, h = s.offsetTop);
  }
  return {
    width: l,
    height: a,
    x: o,
    y: h
  };
}
function ZV1(t, e) {
  const n = qr(t, !0, e === "fixed"), i = n.top + t.clientTop, s = n.left + t.clientLeft, l = hi(t) ? Oa(t) : Fs(1), a = t.clientWidth * l.x, o = t.clientHeight * l.y, h = s * l.x, u = i * l.y;
  return {
    width: a,
    height: o,
    x: h,
    y: u
  };
}
function Bb(t, e, n) {
  let i;
  if (e === "viewport")
    i = KV1(t, n);
  else if (e === "document")
    i = XV1(N8(t));
  else if (x8(e))
    i = ZV1(e, n);
  else {
    const s = vA(t);
    i = {
      ...e,
      x: e.x - s.x,
      y: e.y - s.y
    };
  }
  return rr(i);
}
function mA(t, e) {
  const n = Qa(t);
  return n === e || !x8(n) || Ad(n) ? !1 : C6(n).position === "fixed" || mA(n, e);
}
function JV1(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let i = vc(t, [], !1).filter((o) => x8(o) && Ds(o) !== "body"), s = null;
  const l = C6(t).position === "fixed";
  let a = l ? Qa(t) : t;
  for (; x8(a) && !Ad(a); ) {
    const o = C6(a), h = zw(a);
    !h && o.position === "fixed" && (s = null), (l ? !h && !s : !h && o.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || Vc(a) && !h && mA(t, a)) ? i = i.filter((d) => d !== a) : s = o, a = Qa(a);
  }
  return e.set(t, i), i;
}
function QV1(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: i,
    strategy: s
  } = t;
  const a = [...n === "clippingAncestors" ? JV1(e, this._c) : [].concat(n), i], o = a[0], h = a.reduce((u, d) => {
    const v = Bb(e, d, s);
    return u.top = B0(v.top, u.top), u.right = As(v.right, u.right), u.bottom = As(v.bottom, u.bottom), u.left = B0(v.left, u.left), u;
  }, Bb(e, o, s));
  return {
    width: h.right - h.left,
    height: h.bottom - h.top,
    x: h.left,
    y: h.top
  };
}
function eR1(t) {
  return fA(t);
}
function tR1(t, e, n) {
  const i = hi(e), s = N8(e), l = n === "fixed", a = qr(t, !0, l, e);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const h = Fs(0);
  if (i || !i && !l)
    if ((Ds(e) !== "body" || Vc(s)) && (o = Fd(e)), i) {
      const u = qr(e, !0, l, e);
      h.x = u.x + e.clientLeft, h.y = u.y + e.clientTop;
    } else
      s && (h.x = pA(s));
  return {
    x: a.left + o.scrollLeft - h.x,
    y: a.top + o.scrollTop - h.y,
    width: a.width,
    height: a.height
  };
}
function Vb(t, e) {
  return !hi(t) || C6(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function gA(t, e) {
  const n = H0(t);
  if (!hi(t))
    return n;
  let i = Vb(t, e);
  for (; i && $V1(i) && C6(i).position === "static"; )
    i = Vb(i, e);
  return i && (Ds(i) === "html" || Ds(i) === "body" && C6(i).position === "static" && !zw(i)) ? n : i || UV1(t) || n;
}
const nR1 = async function(t) {
  let {
    reference: e,
    floating: n,
    strategy: i
  } = t;
  const s = this.getOffsetParent || gA, l = this.getDimensions;
  return {
    reference: tR1(e, await s(n), i),
    floating: {
      x: 0,
      y: 0,
      ...await l(n)
    }
  };
};
function iR1(t) {
  return C6(t).direction === "rtl";
}
const sR1 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: WV1,
  getDocumentElement: N8,
  getClippingRect: QV1,
  getOffsetParent: gA,
  getElementRects: nR1,
  getClientRects: YV1,
  getDimensions: eR1,
  getScale: Oa,
  isElement: x8,
  isRTL: iR1
};
function lR1(t, e) {
  let n = null, i;
  const s = N8(t);
  function l() {
    clearTimeout(i), n && n.disconnect(), n = null;
  }
  function a(o, h) {
    o === void 0 && (o = !1), h === void 0 && (h = 1), l();
    const {
      left: u,
      top: d,
      width: v,
      height: m
    } = t.getBoundingClientRect();
    if (o || e(), !v || !m)
      return;
    const p = Dc(d), _ = Dc(s.clientWidth - (u + v)), q = Dc(s.clientHeight - (d + m)), M = Dc(u), b = {
      rootMargin: -p + "px " + -_ + "px " + -q + "px " + -M + "px",
      threshold: B0(0, As(1, h)) || 1
    };
    let x = !0;
    function k(F) {
      const D = F[0].intersectionRatio;
      if (D !== h) {
        if (!x)
          return a();
        D ? a(!1, D) : i = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(k, {
        ...b,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(k, b);
    }
    n.observe(t);
  }
  return a(!0), l;
}
function yA(t, e, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: l = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: h = !1
  } = i, u = bw(t), d = s || l ? [...u ? vc(u) : [], ...vc(e)] : [];
  d.forEach((z) => {
    s && z.addEventListener("scroll", n, {
      passive: !0
    }), l && z.addEventListener("resize", n);
  });
  const v = u && o ? lR1(u, n) : null;
  let m = -1, p = null;
  a && (p = new ResizeObserver((z) => {
    let [b] = z;
    b && b.target === u && p && (p.unobserve(e), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      p && p.observe(e);
    })), n();
  }), u && !h && p.observe(u), p.observe(e));
  let _, q = h ? qr(t) : null;
  h && M();
  function M() {
    const z = qr(t);
    q && (z.x !== q.x || z.y !== q.y || z.width !== q.width || z.height !== q.height) && n(), q = z, _ = requestAnimationFrame(M);
  }
  return n(), () => {
    d.forEach((z) => {
      s && z.removeEventListener("scroll", n), l && z.removeEventListener("resize", n);
    }), v && v(), p && p.disconnect(), p = null, h && cancelAnimationFrame(_);
  };
}
const rR1 = (t, e, n) => {
  const i = /* @__PURE__ */ new Map(), s = {
    platform: sR1,
    ...n
  }, l = {
    ...s.platform,
    _c: i
  };
  return xx(t, e, {
    ...s,
    platform: l
  });
};
function Rb(t) {
  var e;
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
function _A(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Hb(t, e) {
  const n = _A(t);
  return Math.round(e * n) / n;
}
function qA(t, e, n) {
  n === void 0 && (n = {});
  const i = n.whileElementsMounted, s = g1(() => {
    var R;
    return (R = H(n.open)) != null ? R : !0;
  }), l = g1(() => H(n.middleware)), a = g1(() => {
    var R;
    return (R = H(n.placement)) != null ? R : "bottom";
  }), o = g1(() => {
    var R;
    return (R = H(n.strategy)) != null ? R : "absolute";
  }), h = g1(() => {
    var R;
    return (R = H(n.transform)) != null ? R : !0;
  }), u = g1(() => Rb(t.value)), d = g1(() => Rb(e.value)), v = D1(0), m = D1(0), p = D1(o.value), _ = D1(a.value), q = YA({}), M = D1(!1), z = g1(() => {
    const R = {
      position: p.value,
      left: "0",
      top: "0"
    };
    if (!d.value)
      return R;
    const V = Hb(d.value, v.value), J = Hb(d.value, m.value);
    return h.value ? {
      ...R,
      transform: "translate(" + V + "px, " + J + "px)",
      ..._A(d.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: p.value,
      left: V + "px",
      top: J + "px"
    };
  });
  let b;
  function x() {
    u.value == null || d.value == null || rR1(u.value, d.value, {
      middleware: l.value,
      placement: a.value,
      strategy: o.value
    }).then((R) => {
      v.value = R.x, m.value = R.y, p.value = R.strategy, _.value = R.placement, q.value = R.middlewareData, M.value = !0;
    });
  }
  function k() {
    typeof b == "function" && (b(), b = void 0);
  }
  function F() {
    if (k(), i === void 0) {
      x();
      return;
    }
    if (u.value != null && d.value != null) {
      b = i(u.value, d.value, x);
      return;
    }
  }
  function D() {
    s.value || (M.value = !1);
  }
  return l3([l, a, o], x, {
    flush: "sync"
  }), l3([u, d], F, {
    flush: "sync"
  }), l3(s, D, {
    flush: "sync"
  }), Qb() && eL(k), {
    x: jr(v),
    y: jr(m),
    strategy: jr(p),
    placement: jr(_),
    middlewareData: jr(q),
    isPositioned: jr(M),
    floatingStyles: z,
    update: x
  };
}
function wA(t) {
  const e = D1(), n = t.useI18n, i = g1(() => {
    var o;
    const a = H(e);
    return `${a == null ? void 0 : a.nuts.label} (${(o = a == null ? void 0 : a.nuts) == null ? void 0 : o.code})`;
  }), s = g1(() => {
    const a = H(e);
    return `${n.t("year")} ${a == null ? void 0 : a.year}`;
  }), l = g1(() => {
    const a = H(e);
    return a == null ? void 0 : a.classification;
  });
  return {
    contentProps: e,
    cmpTitle: i,
    cmpYear: s,
    cmpClassification: l
  };
}
function _9(t, e) {
  const n = g1(() => s1.merge({}, t, H(e)));
  return {
    t: (s) => {
      const l = H(n);
      return l && s && s1.isObject(l) ? s1.get(l, s) ?? s : s;
    }
  };
}
c2({
  name: "CellDetail",
  props: {
    boundariesElement: {
      type: [String, HTMLElement],
      default: () => "body"
    },
    config: {
      type: Object,
      required: !0
    }
  },
  components: {
    EclButton: Lt
  },
  setup(t) {
    var m;
    const e = _9(
      {
        year: "Year:",
        value: "Value"
      },
      (m = t == null ? void 0 : t.config) == null ? void 0 : m.i18n
    ), n = wA({ useI18n: e }), i = D1(), s = D1(!1), l = D1(), { isPositioned: a, floatingStyles: o, update: h } = qA(i, l, {
      open: s,
      placement: "right-start",
      whileElementsMounted: yA,
      middleware: [
        E_({
          allowedPlacements: ["right-start", "left-start", "bottom-start", "top-start", "top-end", "bottom-end"],
          padding: 5
        }),
        A_()
      ]
    }), u = (p) => ({
      getBoundingClientRect: () => {
        const _ = p instanceof MouseEvent ? 0 : p == null ? void 0 : p.width, q = p instanceof MouseEvent ? 0 : p == null ? void 0 : p.height;
        return new DOMRect(p.clientX, p.clientY, _, q);
      }
    }), d = () => {
      n.contentProps.value = void 0, s.value = !1;
    }, v = (p, _) => {
      i.value = u(p), s.value = !0, n.contentProps.value = _;
    };
    return l3(a, (p) => {
      var _;
      p && ((_ = H(l)) == null || _.focus());
    }), {
      updateFloatingPosition: () => {
        h();
      },
      floatingStyles: o,
      ...e,
      ...n,
      EclButtonType: I4,
      floatingElement: l,
      isOpen: s,
      onClose: d,
      open: v
    };
  }
});
const aR1 = c2({
  name: "CellDetail",
  props: {
    boundariesElement: {
      type: [String, HTMLElement],
      default: () => "body"
    },
    config: {
      type: Object,
      required: !0
    }
  },
  components: {
    EclButton: Lt
  },
  setup(t) {
    var m;
    const e = _9(
      {
        year: "Year:",
        value: "Value"
      },
      (m = t == null ? void 0 : t.config) == null ? void 0 : m.i18n
    ), n = wA({ useI18n: e }), i = D1(), s = D1(!1), l = D1(), { isPositioned: a, floatingStyles: o, update: h } = qA(i, l, {
      open: s,
      placement: "right-start",
      whileElementsMounted: yA,
      middleware: [
        E_({
          allowedPlacements: ["right-start", "left-start", "bottom-start", "top-start", "top-end", "bottom-end"],
          padding: 5
        }),
        A_()
      ]
    }), u = (p) => ({
      getBoundingClientRect: () => {
        const _ = p instanceof MouseEvent ? 0 : p == null ? void 0 : p.width, q = p instanceof MouseEvent ? 0 : p == null ? void 0 : p.height;
        return new DOMRect(p.clientX, p.clientY, _, q);
      }
    }), d = () => {
      n.contentProps.value = void 0, s.value = !1;
    }, v = (p, _) => {
      i.value = u(p), s.value = !0, n.contentProps.value = _;
    };
    return l3(a, (p) => {
      var _;
      p && ((_ = H(l)) == null || _.focus());
    }), {
      updateFloatingPosition: () => {
        h();
      },
      floatingStyles: o,
      ...e,
      ...n,
      EclButtonType: I4,
      floatingElement: l,
      isOpen: s,
      onClose: d,
      open: v
    };
  }
}), oR1 = { class: "cell-detail__header" }, cR1 = ["innerHTML"], hR1 = ["innerHTML"], uR1 = { class: "cell-detail__content" }, dR1 = { class: "wrapper" }, fR1 = {
  key: 0,
  class: "ecl-table table-data"
}, vR1 = { class: "ecl-table__body" }, pR1 = { class: "ecl-table__row" }, mR1 = ["innerHTML"], gR1 = ["innerHTML"], yR1 = ["data-classification-id"], _R1 = { class: "cell-detail__content_after" };
function qR1(t, e, n, i, s, l) {
  const a = V2("EclButton");
  return b6((T(), N("article", {
    class: "cell-detail",
    ref: "floatingElement",
    style: Rt(t.floatingStyles)
  }, [
    C("div", oR1, [
      J2(t.$slots, "header", {
        cell: t.contentProps,
        onClose: t.onClose,
        isOpen: t.isOpen,
        data: t.contentProps,
        cmpTitle: t.cmpTitle,
        cmpYear: t.cmpYear
      }, () => [
        C("h1", { innerHTML: t.cmpTitle }, null, 8, cR1),
        C("span", {
          class: "year",
          innerHTML: t.cmpYear
        }, null, 8, hR1),
        _3(a, {
          icon: "plus",
          iconRotate: 45,
          iconSize: "s",
          type: t.EclButtonType.Primary,
          onClick: t.onClose
        }, null, 8, ["type", "onClick"])
      ], !0)
    ]),
    C("div", uR1, [
      J2(t.$slots, "content", {
        cell: t.contentProps,
        onClose: t.onClose,
        isOpen: t.isOpen,
        data: t.contentProps,
        cmpTitle: t.cmpTitle,
        cmpYear: t.cmpYear,
        updateFloatingPosition: t.updateFloatingPosition
      }, () => {
        var o, h, u;
        return [
          C("div", dR1, [
            ((o = t.contentProps) == null ? void 0 : o.value) != null ? (T(), N("table", fR1, [
              C("tbody", vR1, [
                C("tr", pR1, [
                  t.cmpClassification ? (T(), N("td", {
                    key: 0,
                    class: "ecl-table__cell",
                    style: Rt(t.cmpClassification.stylesComputed),
                    innerHTML: t.cmpClassification.name
                  }, null, 12, mR1)) : (T(), N("td", {
                    key: 1,
                    class: "ecl-table__cell",
                    innerHTML: t.t("value")
                  }, null, 8, gR1)),
                  C("td", {
                    "data-classification-id": (h = t.cmpClassification) == null ? void 0 : h.id,
                    style: Rt((u = t.cmpClassification) == null ? void 0 : u.stylesComputed),
                    class: "ecl-table__cell value"
                  }, pt(t.contentProps.valueFormatted), 13, yR1)
                ])
              ])
            ])) : m2("", !0)
          ]),
          C("div", _R1, [
            J2(t.$slots, "content_after", {
              onClose: t.onClose,
              isOpen: t.isOpen,
              data: t.contentProps,
              cmpTitle: t.cmpTitle,
              cmpYear: t.cmpYear
            }, void 0, !0)
          ])
        ];
      }, !0)
    ])
  ], 4)), [
    [Na, t.isOpen]
  ]);
}
const wR1 = /* @__PURE__ */ Le(aR1, [["render", qR1], ["__scopeId", "data-v-d636105f"]]);
var zA = /* @__PURE__ */ ((t) => (t.INIT = "onInit", t.SORT = "onUpdateSort", t.COVERAGE = "onUpdateCoverage", t.NUTS_LEVEL = "onUpdateNutsLevel", t.SEARCH = "onUpdateSearch", t))(zA || {});
const MA = s1.values(zA);
function bA(t, e) {
  const n = t.useFilters, i = t.useModels, s = t.useUrlParams, l = () => {
    if (H(n.showSort) || H(i.skipVisibilityCheck)) {
      const v = H(i.sortModel);
      e("onUpdateSort", v), i.skipVisibilityCheck.value = !1, s.setParams("yearSort", v);
    }
  }, a = () => {
    if (H(n.showCoverage) || H(i.skipVisibilityCheck)) {
      const v = H(i.coverageModel);
      e("onUpdateCoverage", H(i.coverageModel)), i.skipVisibilityCheck.value = !1, s.setParams("coverage", v);
    }
  }, o = () => {
    if (H(n.showNutsLevel) || H(i.skipVisibilityCheck)) {
      const v = H(i.nutsLevelListModel);
      e("onUpdateNutsLevel", H(i.nutsLevelListModel)), i.skipVisibilityCheck.value = !1, s.setParams("nutsLevelList", v);
    }
  };
  let h;
  const u = () => {
    (H(n.showSearch) || H(i.skipVisibilityCheck)) && (h && clearTimeout(h), h = setTimeout(() => {
      const v = H(i.searchModel);
      e("onUpdateSearch", H(i.searchModel)), i.skipVisibilityCheck.value = !1, s.setParams("search", v);
    }, 220));
  }, d = () => {
    i.searchModel.value = "";
  };
  return l3(
    i.sortModel,
    (v, m) => {
      v && !s1.isEqual(v, m) && l();
    },
    { immediate: !0 }
  ), l3(
    i.coverageModel,
    (v, m) => {
      s1.isEqual(v, m) || a();
    },
    { immediate: !0 }
  ), l3(
    [i.nutsLevelListModel, n.showNutsLevel],
    () => {
      o();
    },
    { immediate: !0, deep: !0 }
  ), l3(
    i.searchModel,
    (v, m) => {
      s1.isEqual(v, m) || u();
    },
    { immediate: !0 }
  ), d0(() => e(
    "onInit"
    /* INIT */
  )), {
    performUpdateSearch: u,
    searchClear: d
  };
}
function LA(t, e) {
  const { config: n } = s3(t), i = e.useUrlParams, s = D1(!1), l = D1(i.getParams("search") ?? void 0), a = D1(
    i.getParams("yearSort") ?? Mu.DEFAULT_OPTIONS.sort.cardinality ?? "asc"
  ), o = D1(i.getParams("coverage") ?? "eu"), h = D1(
    i.getParams("nutsLevelList", { isNumber: !0, isArray: !0 }) ?? []
  ), u = g1(() => {
    const d = l.value;
    return d ? (d == null ? void 0 : d.length) <= 0 : !0;
  });
  return l3(
    n,
    (d, v) => {
      const m = (d == null ? void 0 : d.show) ?? [], p = (v == null ? void 0 : v.show) ?? [], _ = s1.difference(p, m);
      s.value = (_ == null ? void 0 : _.length) > 0, s1.each(_, (q) => {
        switch (q) {
          case "coverage":
            o.value = void 0;
            break;
          case "nuts_level":
            h.value = [];
            break;
          case "search":
            l.value = void 0;
            break;
        }
      }), s1.each(["coverage", "nutsLevel", "search", "sort"], (q) => {
        if (q in d) {
          const M = d[q];
          if (M && "value" in M) {
            const z = M.value;
            switch (q) {
              case "coverage":
                o.value = z;
                break;
              case "nutsLevel":
                h.value = z;
                break;
              case "search":
                l.value = z;
                break;
              case "sort":
                a.value = z;
                break;
            }
          }
        }
      });
    },
    { deep: !0, immediate: !0 }
  ), {
    searchModel: l,
    sortModel: a,
    coverageModel: o,
    nutsLevelListModel: h,
    skipVisibilityCheck: s,
    nutsClearDisabled: u
  };
}
function xA(t, e) {
  const { config: n } = s3(t), i = e.useI18n, s = e.useModels, l = D1(!1), a = [
    { value: "asc", label: i.t("yearAscending") },
    { value: "desc", label: i.t("yearDescending") }
  ], o = [
    { value: "all", label: i.t("coverageAll") },
    { value: "eu", label: i.t("coverageEu") }
  ], h = g1(() => {
    var d, v;
    return s1.chain((v = (d = H(n)) == null ? void 0 : d.nutsLevel) == null ? void 0 : v.list).map((m) => {
      let p = i.t(`nuts${m}`);
      return s1.isNil(p) && (p = `${i.t("nutsPrefix")} ${m}${i.t("nutsSuffix")}`), {
        value: m,
        label: p
      };
    }).uniqBy("value").orderBy("value").orderBy((m) => m.value === 9 ? 0 : 1).value();
  }), u = g1(() => {
    const d = H(s.nutsLevelListModel);
    return (d == null ? void 0 : d.length) > 0 ? s1.chain(H(h)).filter((m) => s1.includes(d, m.value)).map((m) => m.label.replace("NUTS", "").trim()).value().join(", ") : i.t("territorialLevelAll");
  });
  return {
    sortList: a,
    coverageList: o,
    nutsLevelList: h,
    nutsLevelListLabel: u,
    skipVisibilityCheck: l
  };
}
function SA(t, e) {
  const { config: n } = s3(t), i = e.useList, s = g1(() => H(n).show.includes("sort")), l = g1(() => H(n).show.includes("coverage")), a = g1(() => {
    var u;
    return H(n).show.includes("nuts_level") && ((u = H(i.nutsLevelList)) == null ? void 0 : u.length) > 0;
  }), o = g1(() => H(n).show.includes("search")), h = g1(() => !0);
  return {
    showSort: s,
    showCoverage: l,
    showNutsLevel: a,
    showSearch: o,
    showExtraColumns: h
  };
}
const Db = ",";
function Lw(t, e, n) {
  const i = g1(() => s1.merge({}, e, H(n) ?? {})), s = () => {
    if (H(t)) {
      const o = new URLSearchParams(window.location.search);
      return Object.fromEntries(o.entries());
    }
    return {};
  };
  return {
    getParams: (o, h = {
      isNumber: !1,
      isArray: !1
    }) => {
      if (H(t)) {
        const u = H(i)[o].key, d = s();
        if (u in d) {
          const v = d[u];
          return h.isArray ? v.split(Db).map((m) => h.isNumber ? +m : m) : h.isNumber ? +v : v;
        }
      }
    },
    setParams: (o, h) => {
      if (H(t) && o in H(i)) {
        let u;
        h instanceof Array ? u = h.join(Db) : u = h;
        const d = new URL(window.location.toString()), v = H(i)[o].key;
        s1.isNil(u) || s1.isEmpty(u) ? d.searchParams.delete(v) : d.searchParams.set(v, `${u}`), window.history.replaceState(u, "", d);
      }
    }
  };
}
c2({
  name: "Filters",
  emits: MA,
  components: {
    EclRadio: nx,
    EclCheckbox: tx,
    EclTextField: yx,
    EclButton: Lt,
    JclAutocomplete: Vu
  },
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  setup(t, { emit: e }) {
    var v;
    const { config: n } = s3(t), i = _9(
      {
        year: "Year:",
        yearAscending: "Ascending",
        yearDescending: "Descending",
        coverage: "Coverage",
        coverageAll: "All available countries",
        coverageEu: "European Union",
        territorialLevelAll: "All territorial levels",
        nuts: "Filter by NUTS code",
        nutsClear: "Clear search",
        nuts0: "NUTS 0",
        nuts1: "NUTS 1",
        nuts2: "NUTS 2",
        nuts3: "NUTS 3",
        nuts4: "Metro regions (METRO)",
        nuts5: "FUAs (FUA)",
        nuts6: "Cities (CITY)",
        nuts7: "Municipalities (LAU)",
        nuts9: "EU Aggregate",
        nutsPrefix: "NUTS",
        nutsSuffix: "",
        sectionSort: "Sort",
        sectionDisplay: "Display",
        sectionFilters: "Filters"
      },
      (v = t == null ? void 0 : t.config) == null ? void 0 : v.i18n
    ), s = {
      search: {
        key: "jdvfs"
      },
      yearSort: {
        key: "jdvfys"
      },
      coverage: {
        key: "jdvfc"
      },
      nutsLevelList: {
        key: "jdvfnl"
      }
    }, l = Lw(
      g1(() => {
        var m;
        return ((m = H(n)) == null ? void 0 : m.useUrlParams) ?? !1;
      }),
      s,
      g1(() => {
        var m;
        return ((m = H(n)) == null ? void 0 : m.mappingUrlParams) ?? {};
      })
    ), a = LA(t, { useUrlParams: l }), o = xA(t, { useI18n: i, useModels: a }), h = SA(t, { useList: o }), u = bA({ useFilters: h, useModels: a, useUrlParams: l }, e);
    return { filterSize: g1(() => {
      var m;
      return ((m = H(n)) == null ? void 0 : m.size) ?? "xs";
    }), ...i, ...h, ...a, ...o, ...u };
  }
});
const zR1 = c2({
  name: "Filters",
  emits: MA,
  components: {
    EclRadio: nx,
    EclCheckbox: tx,
    EclTextField: yx,
    EclButton: Lt,
    JclAutocomplete: Vu
  },
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  setup(t, { emit: e }) {
    var v;
    const { config: n } = s3(t), i = _9(
      {
        year: "Year:",
        yearAscending: "Ascending",
        yearDescending: "Descending",
        coverage: "Coverage",
        coverageAll: "All available countries",
        coverageEu: "European Union",
        territorialLevelAll: "All territorial levels",
        nuts: "Filter by NUTS code",
        nutsClear: "Clear search",
        nuts0: "NUTS 0",
        nuts1: "NUTS 1",
        nuts2: "NUTS 2",
        nuts3: "NUTS 3",
        nuts4: "Metro regions (METRO)",
        nuts5: "FUAs (FUA)",
        nuts6: "Cities (CITY)",
        nuts7: "Municipalities (LAU)",
        nuts9: "EU Aggregate",
        nutsPrefix: "NUTS",
        nutsSuffix: "",
        sectionSort: "Sort",
        sectionDisplay: "Display",
        sectionFilters: "Filters"
      },
      (v = t == null ? void 0 : t.config) == null ? void 0 : v.i18n
    ), s = {
      search: {
        key: "jdvfs"
      },
      yearSort: {
        key: "jdvfys"
      },
      coverage: {
        key: "jdvfc"
      },
      nutsLevelList: {
        key: "jdvfnl"
      }
    }, l = Lw(
      g1(() => {
        var m;
        return ((m = H(n)) == null ? void 0 : m.useUrlParams) ?? !1;
      }),
      s,
      g1(() => {
        var m;
        return ((m = H(n)) == null ? void 0 : m.mappingUrlParams) ?? {};
      })
    ), a = LA(t, { useUrlParams: l }), o = xA(t, { useI18n: i, useModels: a }), h = SA(t, { useList: o }), u = bA({ useFilters: h, useModels: a, useUrlParams: l }, e);
    return { filterSize: g1(() => {
      var m;
      return ((m = H(n)) == null ? void 0 : m.size) ?? "xs";
    }), ...i, ...h, ...a, ...o, ...u };
  }
}), MR1 = { class: "filters" }, bR1 = {
  key: 0,
  class: "filter-section filter-section--sort"
}, LR1 = { class: "filter-list" }, xR1 = { class: "filter filter__sort" }, SR1 = ["innerHTML"], CR1 = {
  key: 1,
  class: "filter-section filter-section--display"
}, kR1 = { class: "filter-list" }, ER1 = ["innerHTML"], AR1 = {
  key: 2,
  class: "filter-section filter-section--filters"
}, FR1 = { class: "filter-list" }, TR1 = {
  key: 0,
  class: "filter filter__coverage"
}, IR1 = {
  key: 1,
  class: "filter filter__nuts"
}, OR1 = {
  key: 2,
  class: "filter filter__search"
}, NR1 = ["innerHTML"];
function PR1(t, e, n, i, s, l) {
  var u;
  const a = V2("JclAutocomplete"), o = V2("EclTextField"), h = V2("EclButton");
  return T(), N("div", MR1, [
    t.showSort ? (T(), N("div", bR1, [
      C("div", LR1, [
        C("div", xR1, [
          _3(a, {
            list: t.sortList,
            searchPlaceholder: t.t("year"),
            modelValue: t.sortModel,
            "onUpdate:modelValue": e[0] || (e[0] = (d) => t.sortModel = d),
            size: t.filterSize,
            calculateWidth: !0
          }, null, 8, ["list", "searchPlaceholder", "modelValue", "size"])
        ])
      ]),
      C("span", {
        class: "name",
        innerHTML: t.t("sectionSort")
      }, null, 8, SR1)
    ])) : m2("", !0),
    (u = t.config) != null && u.extraFilters ? (T(), N("div", CR1, [
      C("div", kR1, [
        (T(!0), N(I3, null, Ve(t.config.extraFilters, (d, v) => {
          var m;
          return T(), N("div", {
            key: v,
            class: f2(`filter filter__extra ${(m = d == null ? void 0 : d.wrapper) == null ? void 0 : m.class}`)
          }, [
            _3(a, Ht({ size: t.filterSize }, d.props, Io(d == null ? void 0 : d.on)), null, 16, ["size"])
          ], 2);
        }), 128))
      ]),
      C("span", {
        class: "name",
        innerHTML: t.t("sectionDisplay")
      }, null, 8, ER1)
    ])) : m2("", !0),
    t.showCoverage || t.showNutsLevel || t.showSearch ? (T(), N("div", AR1, [
      C("div", FR1, [
        t.showCoverage ? (T(), N("div", TR1, [
          _3(a, {
            list: t.coverageList,
            searchPlaceholder: t.t("coverage"),
            modelValue: t.coverageModel,
            "onUpdate:modelValue": e[1] || (e[1] = (d) => t.coverageModel = d),
            size: t.filterSize,
            calculateWidth: !0
          }, null, 8, ["list", "searchPlaceholder", "modelValue", "size"])
        ])) : m2("", !0),
        t.showNutsLevel ? (T(), N("div", IR1, [
          _3(a, {
            list: t.nutsLevelList,
            multiple: !0,
            searchPlaceholder: t.nutsLevelListLabel,
            modelValue: t.nutsLevelListModel,
            "onUpdate:modelValue": e[2] || (e[2] = (d) => t.nutsLevelListModel = d),
            multiplePlaceholder: t.nutsLevelListLabel,
            multiplePlaceholderLimit: 0,
            calculateWidth: !1,
            size: t.filterSize,
            closeOnSelection: !1
          }, null, 8, ["list", "searchPlaceholder", "modelValue", "multiplePlaceholder", "size"])
        ])) : m2("", !0),
        t.showSearch ? (T(), N("div", OR1, [
          _3(o, {
            modelValue: t.searchModel,
            "onUpdate:modelValue": e[3] || (e[3] = (d) => t.searchModel = d),
            placeholder: t.t("nuts"),
            label: t.t("nuts"),
            showLabel: !1,
            size: t.filterSize
          }, null, 8, ["modelValue", "placeholder", "label", "size"]),
          _3(h, {
            disabled: t.nutsClearDisabled,
            icon: "plus",
            "icon-rotate": 45,
            "aria-label": t.t("nutsClear"),
            onClick: t.searchClear,
            size: t.filterSize
          }, null, 8, ["disabled", "aria-label", "onClick", "size"])
        ])) : m2("", !0)
      ]),
      C("span", {
        class: "name",
        innerHTML: t.t("sectionFilters")
      }, null, 8, NR1)
    ])) : m2("", !0)
  ]);
}
const BR1 = /* @__PURE__ */ Le(zR1, [["render", PR1], ["__scopeId", "data-v-a792c882"]]);
c2({
  name: "Info",
  components: {
    JclAutocomplete: Vu,
    EclButton: Lt
  },
  props: {
    variable: {
      type: Object,
      required: !1
    },
    config: {
      type: Object,
      required: !1
    },
    sheet: {
      type: Object,
      required: !1
    }
  },
  setup(t) {
    var u;
    const e = _9(
      {
        nuts: "Nuts:",
        lastUpdate: "Last update:",
        releaseDate: "Release date:",
        export: "Export"
      },
      (u = t == null ? void 0 : t.config) == null ? void 0 : u.i18n
    ), n = g1(() => {
      var m, p;
      const v = s1.compact([(m = t.variable) == null ? void 0 : m.name, (p = t.variable) == null ? void 0 : p.code]).join("<br />");
      return s1.isEmpty(v) ? void 0 : v;
    }), i = g1(() => {
      var d;
      return (d = t.variable) == null ? void 0 : d.nutsVersion;
    }), s = g1(() => {
      var d;
      return (d = t.variable) == null ? void 0 : d.lastUpdate;
    }), l = g1(() => {
      var d;
      return (d = t.variable) == null ? void 0 : d.release;
    }), a = g1(() => {
      var d;
      return (d = t.variable) == null ? void 0 : d.releaseDate;
    }), o = g1(() => {
      var d, v;
      return ((v = (d = t.config) == null ? void 0 : d.export) == null ? void 0 : v.enabled) ?? !0;
    });
    return {
      ...e,
      name: n,
      nutsVersion: i,
      lastUpdate: s,
      isRelease: l,
      releaseDate: a,
      canExportFile: o,
      exportFile: () => {
        var v, m;
        const d = document.querySelector("revo-grid");
        if (d) {
          const p = (m = (v = t.config) == null ? void 0 : v.export) == null ? void 0 : m.action;
          p ? p.call(this, d, t.variable, t == null ? void 0 : t.sheet) : d.getPlugins().then((_) => {
            _.forEach((q) => {
              var M, z, b, x, k, F, D, R, V;
              if (q.exportFile) {
                const J = s1.compact([
                  (M = t.variable) == null ? void 0 : M.code,
                  ...s1.values((z = t.variable) == null ? void 0 : z.dimensionObject),
                  (b = t.variable) == null ? void 0 : b.name
                ]), K = new hA(d, t == null ? void 0 : t.sheet), P = ((k = (x = t.config) == null ? void 0 : x.export) == null ? void 0 : k.format) ?? "xlsx", O = ((D = (F = t.config) == null ? void 0 : F.export) == null ? void 0 : D.customExportClass) ?? void 0, G = ((V = (R = t.config) == null ? void 0 : R.export) == null ? void 0 : V.formatOptions) ?? {};
                K.exportFile(
                  { fileKind: P, filename: J.join(" - "), ...G },
                  ww[P],
                  O
                );
              }
            });
          });
        }
      }
    };
  }
});
const VR1 = c2({
  name: "Info",
  components: {
    JclAutocomplete: Vu,
    EclButton: Lt
  },
  props: {
    variable: {
      type: Object,
      required: !1
    },
    config: {
      type: Object,
      required: !1
    },
    sheet: {
      type: Object,
      required: !1
    }
  },
  setup(t) {
    var u;
    const e = _9(
      {
        nuts: "Nuts:",
        lastUpdate: "Last update:",
        releaseDate: "Release date:",
        export: "Export"
      },
      (u = t == null ? void 0 : t.config) == null ? void 0 : u.i18n
    ), n = g1(() => {
      var m, p;
      const v = s1.compact([(m = t.variable) == null ? void 0 : m.name, (p = t.variable) == null ? void 0 : p.code]).join("<br />");
      return s1.isEmpty(v) ? void 0 : v;
    }), i = g1(() => {
      var d;
      return (d = t.variable) == null ? void 0 : d.nutsVersion;
    }), s = g1(() => {
      var d;
      return (d = t.variable) == null ? void 0 : d.lastUpdate;
    }), l = g1(() => {
      var d;
      return (d = t.variable) == null ? void 0 : d.release;
    }), a = g1(() => {
      var d;
      return (d = t.variable) == null ? void 0 : d.releaseDate;
    }), o = g1(() => {
      var d, v;
      return ((v = (d = t.config) == null ? void 0 : d.export) == null ? void 0 : v.enabled) ?? !0;
    });
    return {
      ...e,
      name: n,
      nutsVersion: i,
      lastUpdate: s,
      isRelease: l,
      releaseDate: a,
      canExportFile: o,
      exportFile: () => {
        var v, m;
        const d = document.querySelector("revo-grid");
        if (d) {
          const p = (m = (v = t.config) == null ? void 0 : v.export) == null ? void 0 : m.action;
          p ? p.call(this, d, t.variable, t == null ? void 0 : t.sheet) : d.getPlugins().then((_) => {
            _.forEach((q) => {
              var M, z, b, x, k, F, D, R, V;
              if (q.exportFile) {
                const J = s1.compact([
                  (M = t.variable) == null ? void 0 : M.code,
                  ...s1.values((z = t.variable) == null ? void 0 : z.dimensionObject),
                  (b = t.variable) == null ? void 0 : b.name
                ]), K = new hA(d, t == null ? void 0 : t.sheet), P = ((k = (x = t.config) == null ? void 0 : x.export) == null ? void 0 : k.format) ?? "xlsx", O = ((D = (F = t.config) == null ? void 0 : F.export) == null ? void 0 : D.customExportClass) ?? void 0, G = ((V = (R = t.config) == null ? void 0 : R.export) == null ? void 0 : V.formatOptions) ?? {};
                K.exportFile(
                  { fileKind: P, filename: J.join(" - "), ...G },
                  ww[P],
                  O
                );
              }
            });
          });
        }
      }
    };
  }
}), RR1 = { class: "info" }, HR1 = { class: "info--left" }, DR1 = {
  key: 0,
  class: "item item--variable"
}, $R1 = ["innerHTML"], UR1 = {
  key: 1,
  class: "item item--nuts-version"
}, jR1 = { class: "wrapper" }, GR1 = ["innerHTML"], WR1 = ["innerHTML"], YR1 = {
  key: 2,
  class: "item item--date"
}, XR1 = { class: "wrapper" }, KR1 = ["innerHTML"], ZR1 = ["innerHTML"], JR1 = {
  key: 3,
  class: "item item--date"
}, QR1 = { class: "wrapper" }, eH1 = ["innerHTML"], tH1 = ["innerHTML"], nH1 = { class: "info--center" }, iH1 = { class: "info--right" }, sH1 = {
  key: 0,
  class: "item item--export"
};
function lH1(t, e, n, i, s, l) {
  const a = V2("ecl-button");
  return T(), N("div", RR1, [
    C("div", HR1, [
      t.name ? (T(), N("div", DR1, [
        C("div", {
          class: "wrapper",
          innerHTML: t.name
        }, null, 8, $R1)
      ])) : m2("", !0),
      t.nutsVersion ? (T(), N("div", UR1, [
        C("div", jR1, [
          C("span", {
            innerHTML: t.t("nuts")
          }, null, 8, GR1),
          C("strong", { innerHTML: t.nutsVersion }, null, 8, WR1)
        ])
      ])) : m2("", !0),
      t.isRelease && t.releaseDate ? (T(), N("div", YR1, [
        C("div", XR1, [
          C("span", {
            innerHTML: t.t("releaseDate")
          }, null, 8, KR1),
          C("strong", { innerHTML: t.releaseDate }, null, 8, ZR1)
        ])
      ])) : t.lastUpdate ? (T(), N("div", JR1, [
        C("div", QR1, [
          C("span", {
            innerHTML: t.t("lastUpdate")
          }, null, 8, eH1),
          C("strong", { innerHTML: t.lastUpdate }, null, 8, tH1)
        ])
      ])) : m2("", !0),
      J2(t.$slots, "info_left", {}, void 0, !0)
    ]),
    C("div", nH1, [
      J2(t.$slots, "info_center", {}, void 0, !0)
    ]),
    C("div", iH1, [
      t.canExportFile ? (T(), N("div", sH1, [
        _3(a, {
          onClick: t.exportFile,
          icon: "download",
          iconPosition: "before",
          iconSize: "xs",
          text: t.t("export"),
          type: "ghost"
        }, null, 8, ["onClick", "text"])
      ])) : m2("", !0),
      J2(t.$slots, "info_right", {}, void 0, !0)
    ])
  ]);
}
const rH1 = /* @__PURE__ */ Le(VR1, [["render", lH1], ["__scopeId", "data-v-bcc75a22"]]), aH1 = c2({
  name: "Tabs",
  components: {
    EclIcon: Ie
  },
  props: {
    config: {
      type: Object,
      required: !0
    },
    entityList: {
      type: Array,
      required: !0
    },
    current: {
      type: String,
      required: !1
    },
    /* The property is used to determine whether there must be at least one active tab */
    atLeastOneActive: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  setup(t) {
    const { config: e } = s3(t), n = {
      currentTab: {
        key: "jdvtc"
      }
    }, i = Lw(
      g1(() => {
        var p;
        return ((p = H(e)) == null ? void 0 : p.useUrlParams) ?? !1;
      }),
      n,
      g1(() => {
        var p;
        return ((p = H(e)) == null ? void 0 : p.mappingUrlParams) ?? {};
      })
    ), s = i.getParams("currentTab"), l = D1(s ?? t.current), a = g1(() => s1.map(t.entityList, (p) => s1.isNil(p == null ? void 0 : p.id) ? {
      id: (p == null ? void 0 : p.id) ?? s1.kebabCase(p.label),
      ...p
    } : p)), o = g1(() => s1.find(
      H(a),
      (p) => {
        var _;
        return p.id.toString() === ((_ = H(l)) == null ? void 0 : _.toString());
      }
    )), h = g1(() => {
      var p;
      return (p = H(o)) == null ? void 0 : p.component;
    }), u = g1(() => {
      var p;
      return (p = H(o)) == null ? void 0 : p.props;
    }), d = g1(() => {
      var p;
      return (p = H(o)) == null ? void 0 : p.events;
    }), v = (p) => {
      var _, q;
      ((_ = H(l)) == null ? void 0 : _.toString()) !== ((q = p.id) == null ? void 0 : q.toString()) ? l.value = p.id : t.atLeastOneActive === !1 && (l.value = void 0), i.setParams("currentTab", H(l));
    }, m = (p) => {
      var _, q;
      return ((_ = H(l)) == null ? void 0 : _.toString()) === ((q = p.id) == null ? void 0 : q.toString());
    };
    return l3(
      () => t.current,
      (p) => {
        t.atLeastOneActive && s1.isNil(p) ? l.value = H(a)[0].id : l.value = p;
      }
    ), { entityListExtended: a, currentTab: l, changeTab: v, isActive: m, componentName: h, componentProps: u, componentEvents: d };
  }
}), oH1 = { class: "tab-list" }, cH1 = { class: "wrapper" }, hH1 = ["onClick"], uH1 = ["innerHTML"], dH1 = {
  key: 0,
  class: "content"
};
function fH1(t, e, n, i, s, l) {
  const a = V2("EclIcon");
  return T(), N("div", {
    class: f2(["tabs", { "tabs--open": t.currentTab }])
  }, [
    C("div", oH1, [
      C("div", cH1, [
        (T(!0), N(I3, null, Ve(t.entityListExtended, (o) => (T(), N("div", {
          key: o.id,
          class: f2(["item", { active: t.isActive(o) }]),
          onClick: (h) => t.changeTab(o)
        }, [
          C("span", {
            class: "name",
            innerHTML: o.label
          }, null, 8, uH1),
          _3(a, {
            icon: "corner-arrow",
            size: "xs",
            rotate: t.isActive(o) ? 180 : 0
          }, null, 8, ["rotate"])
        ], 10, hH1))), 128))
      ])
    ]),
    t.componentName ? (T(), N("div", dH1, [
      (T(), v2(be(t.componentName), Ht({ key: t.componentName }, t.componentProps, Io(t.componentEvents)), null, 16))
    ])) : m2("", !0)
  ], 2);
}
const vH1 = /* @__PURE__ */ Le(aH1, [["render", fH1], ["__scopeId", "data-v-2691d953"]]);
c2({
  name: "AsideEntityList",
  emits: ["onItemClick", "onItemNavigationClick"],
  components: {
    EclLink: O4,
    EclIcon: Ie
  },
  props: {
    list: {
      type: Array,
      required: !0
    },
    showIndex: {
      type: Boolean,
      required: !1,
      default: () => !0
    },
    iconItem: {
      type: String,
      required: !1
    }
  },
  setup(t, { emit: e }) {
    return {
      entityListExtended: g1(() => s1.map(t.list, (l) => {
        const a = l == null ? void 0 : l.classification;
        return {
          stylesItem: a == null ? void 0 : a.backgroundStyles,
          stylesName: a == null ? void 0 : a.textStyles,
          ...l,
          hasItemClick: !s1.isNil(l.hasItemClick) && l.hasItemClick,
          hasLink: !s1.isNil(H(l.linkUrl))
        };
      })),
      itemClick: (l) => {
        l.hasItemClick && e("onItemClick", l);
      },
      itemNavigationClick: (l) => {
        l.hasLink && e("onItemNavigationClick", l);
      }
    };
  }
});
const pH1 = c2({
  name: "AsideEntityList",
  emits: ["onItemClick", "onItemNavigationClick"],
  components: {
    EclLink: O4,
    EclIcon: Ie
  },
  props: {
    list: {
      type: Array,
      required: !0
    },
    showIndex: {
      type: Boolean,
      required: !1,
      default: () => !0
    },
    iconItem: {
      type: String,
      required: !1
    }
  },
  setup(t, { emit: e }) {
    return {
      entityListExtended: g1(() => s1.map(t.list, (l) => {
        const a = l == null ? void 0 : l.classification;
        return {
          stylesItem: a == null ? void 0 : a.backgroundStyles,
          stylesName: a == null ? void 0 : a.textStyles,
          ...l,
          hasItemClick: !s1.isNil(l.hasItemClick) && l.hasItemClick,
          hasLink: !s1.isNil(H(l.linkUrl))
        };
      })),
      itemClick: (l) => {
        l.hasItemClick && e("onItemClick", l);
      },
      itemNavigationClick: (l) => {
        l.hasLink && e("onItemNavigationClick", l);
      }
    };
  }
}), mH1 = { class: "aside-entity-list" }, gH1 = ["onClick"], yH1 = {
  key: 0,
  class: "index"
}, _H1 = {
  key: 2,
  class: "icon-empty"
}, qH1 = ["innerHTML"];
function wH1(t, e, n, i, s, l) {
  const a = V2("EclIcon"), o = V2("EclLink"), h = ku("tooltip");
  return T(), N("div", mH1, [
    (T(!0), N(I3, null, Ve(t.entityListExtended, (u, d) => {
      var v;
      return T(), N("div", {
        key: d + (u == null ? void 0 : u.linkUrl),
        class: f2(["item", { itemClick: u.hasItemClick }]),
        style: Rt(u == null ? void 0 : u.stylesItem),
        onClick: (m) => t.itemClick(u)
      }, [
        t.showIndex ? (T(), N("span", yH1, "#" + pt(d + 1), 1)) : m2("", !0),
        t.iconItem && u.hasItemClick ? (T(), v2(a, {
          key: 1,
          icon: t.iconItem,
          size: "s"
        }, null, 8, ["icon"])) : t.iconItem ? (T(), N("span", _H1)) : m2("", !0),
        C("span", {
          class: "name",
          style: Rt(u == null ? void 0 : u.stylesName),
          innerHTML: u.name
        }, null, 12, qH1),
        u.hasLink ? b6((T(), v2(o, {
          key: 3,
          class: "link",
          url: ((v = u == null ? void 0 : u.linkUrl) == null ? void 0 : v.value) ?? "javascript:void(0)",
          label: (u == null ? void 0 : u.linkLabel) ?? void 0,
          "aria-label": u == null ? void 0 : u.linkAriaLabel,
          icon: "external",
          iconSize: "s",
          onClick: Et((m) => t.itemNavigationClick(u), ["stop"])
        }, null, 8, ["url", "label", "aria-label", "onClick"])), [
          [
            h,
            (u == null ? void 0 : u.linkTooltip) ?? void 0,
            void 0,
            { left: !0 }
          ]
        ]) : m2("", !0)
      ], 14, gH1);
    }), 128))
  ]);
}
const zH1 = /* @__PURE__ */ Le(pH1, [["render", wH1], ["__scopeId", "data-v-9800a07e"]]);
function MH1(t) {
  const { cellClassification: e } = s3(t);
  return {
    cellClassificationList: g1(() => s1.map(H(e), (i) => new gk1(i)))
  };
}
function bH1(t) {
  const { annotationClassification: e } = s3(t);
  return {
    annotationClassificationList: g1(() => s1.map(H(e), (i) => new yk1(i)))
  };
}
function LH1(t) {
  const { config: e } = s3(t), n = {
    appName: void 0,
    showLoader: !0,
    empty: {
      show: !0,
      title: "No results match your search criteria",
      message: "Try modifying your filters."
    },
    filters: {
      useUrlParams: !0,
      show: ["sort", "coverage", "nuts_level", "search"],
      nutsLevel: {
        list: []
      },
      coverage: {
        showFilter: !0
      }
    },
    info: {
      show: !0,
      export: {
        enabled: !0
      }
    },
    aside: {
      show: !0
    },
    cellDetail: {
      show: !1
    },
    sheet: {
      editable: !1
    }
  }, i = D1(n), s = g1(() => {
    var l;
    return (l = H(i)) == null ? void 0 : l.appName;
  });
  return l3(
    () => e == null ? void 0 : e.value,
    (l) => {
      l && (i.value = s1.assign({ ...n }, l));
    },
    { immediate: !0, deep: !0 }
  ), {
    currentConfig: i,
    appName: s
  };
}
function xH1(t, e) {
  const { variable: n } = s3(t), i = e.useConfig, s = g1(() => {
    var o;
    return (o = H(i.currentConfig)) == null ? void 0 : o.info;
  }), l = g1(() => {
    const o = H(n);
    if (!s1.isNil(o))
      return new _T1(o);
  }), a = g1(() => {
    var h;
    const o = (h = H(i.currentConfig)) == null ? void 0 : h.info;
    return !!(o != null && o.show && (!s1.isNil(H(l)) || o != null && o.export));
  });
  return {
    currentConfigInfo: s,
    showInfo: a,
    variableData: l
  };
}
function SH1(t, e) {
  const { t: n } = js(), { source: i } = s3(t), s = D1(!0), l = e.useConfig.currentConfig, a = e.sheet, o = g1(() => H(s)), h = g1(() => H(l).showLoader ? H(o) : !1), u = g1(() => a != null && a.isInit() ? n("ARDECO_VIEWER.LOADING") : n("ARDECO_VIEWER.APPLY_FILTERS"));
  return l3(i, () => {
    s.value = !0;
  }, { deep: !0 }), {
    loading: s,
    showLoader: h,
    loaderLabel: u
  };
}
var Ma = /* @__PURE__ */ ((t) => (t.EVENT = "onEvent", t.BEFORE_LOAD = "onBeforeLoad", t.AFTER_LOAD = "onAfterLoad", t.BEFORE_FILTER_APPLY = "onBeforeFilterApply", t.AFTER_FILTER_APPLY = "onAfterFilterApply", t.SELECT_CELL = "onSelectCell", t.UNSELECT_CELL = "onUnselectCell", t.CLICK_OUTSIDE_SHEET = "onClickOutside", t.DATA_EMPTY = "onDataEmpty", t.DATA_FILLED = "onDataFilled", t.FILTER_SORT = "onUpdateSort", t.FILTER_COVERAGE = "onUpdateCoverage", t.FILTER_NUTS_LEVEL = "onUpdateNutsLevel", t.FILTER_SEARCH = "onUpdateSearch", t.BEFORE_EDIT = "onBeforeEdit", t.AFTER_EDIT = "onAfterEdit", t.BEFORE_EDIT_START = "onBeforeEditStart", t))(Ma || {});
const CA = s1.values(Ma);
function CH1(t, e) {
  const n = D1(!1), i = t.useLoader, s = t.useCellDetail, l = t.sheet, a = (q, M) => {
    if (CA.includes(q)) {
      const z = {
        name: q,
        data: M
      };
      e(q, z), e("onEvent", z);
    } else
      throw new Error(`Event with name: ${q} not exist!`);
  }, o = () => {
    i.loading.value = !0;
  }, h = (q) => {
  }, u = (q) => {
    q.preventDefault();
  }, d = () => {
    s.closeCellDetail();
  }, v = (q) => {
    if (!s.elementInsideCellDetail(q.target)) {
      const z = l.getInstance();
      z && z.clearFocus(), s.closeCellDetail(), a(
        "onClickOutside"
        /* CLICK_OUTSIDE_SHEET */
      );
    }
  }, m = (q) => {
    a("onBeforeEdit", q);
  }, p = (q) => {
    a("onAfterEdit", q);
  }, _ = (q) => {
    a("onBeforeEditStart", q);
  };
  return l.subscribe("beforeLoad", () => {
    i.loading.value = !0, a(
      "onBeforeLoad"
      /* BEFORE_LOAD */
    );
  }), l.subscribe("afterLoad", () => {
    i.loading.value = !1, a(
      "onAfterLoad"
      /* AFTER_LOAD */
    );
  }), l.subscribe("beforeFilterApply", () => {
    i.loading.value = !0, n.value = !1, a(
      "onBeforeFilterApply"
      /* BEFORE_FILTER_APPLY */
    );
  }), l.subscribe("afterFilterApply", () => {
    i.loading.value = !1, a(
      "onAfterFilterApply"
      /* AFTER_FILTER_APPLY */
    );
  }), l.subscribe("select", (q) => {
    H(s.showCellDetail) && (s.openCellDetail(q.cellBounding, q.cell), a(
      "onSelectCell"
      /* SELECT_CELL */
    ));
  }), l.subscribe("dataEmpty", () => {
    n.value = !0, a(
      "onDataEmpty"
      /* DATA_EMPTY */
    );
  }), l.subscribe("dataFilled", () => {
    n.value = !1, a(
      "onDataFilled"
      /* DATA_FILLED */
    );
  }), {
    emptyData: n,
    onViewportScroll: d,
    onBeforeUpdateSource: o,
    onBeforeCellFocus: h,
    onBeforeCellFocusLost: u,
    emitEvent: a,
    onClickOutside: v,
    onBeforeEdit: m,
    onAfterEdit: p,
    onBeforeEditStart: _
  };
}
function kH1(t) {
  const e = t.useConfig, n = t.useLoader, i = t.useEvents, s = t.sheet, l = g1(() => {
    var p;
    const m = H(e.currentConfig);
    return m ? ((p = m == null ? void 0 : m.filters.show) == null ? void 0 : p.length) > 0 : !1;
  }), a = g1(() => {
    var m;
    return (m = H(e.currentConfig)) == null ? void 0 : m.filters;
  }), o = () => {
    let m = 0;
    return s.isInit() && (m = 120, n.loading.value = !0), m;
  }, h = (m) => {
    i.emitEvent(Ma.FILTER_SORT, m), s.updateSort(m);
  }, u = (m) => {
    m ? s.addFilter("coverage", (_, q, M) => !s1.isNil(M == null ? void 0 : M.eu) && m === "eu" ? M.eu : !0) : s.removeFilter("coverage"), i.emitEvent(Ma.FILTER_COVERAGE, m);
    const p = o();
    s1.debounce(() => s.applyFilters(), p)();
  }, d = (m) => {
    (m == null ? void 0 : m.length) > 0 ? s.addFilter("nutsLevel", (_, q, M) => s1.isNil(M.level) ? !1 : m.includes(M.level)) : s.removeFilter("nutsLevel"), i.emitEvent(Ma.FILTER_NUTS_LEVEL, m);
    const p = o();
    s1.debounce(() => s.applyFilters(), p)();
  }, v = (m) => {
    !s1.isNil(m) && !s1.isEmpty(m) ? s.addFilter("search", (_, q, M) => M.code.toLowerCase().startsWith(m.toLowerCase())) : s.removeFilter("search"), i.emitEvent(Ma.FILTER_SEARCH, m);
    const p = o();
    s1.debounce(() => s.applyFilters(), p)();
  };
  return XA(() => {
    if (H(n.loading) === !1) {
      const m = s.getNutsLevel(), p = H(e.currentConfig) ?? {}, _ = s1.get(p, "filters.nutsLevel.list");
      s1.isEqual(_, m) || (e.currentConfig.value = s1.update({ ...p }, "filters.nutsLevel.list", () => s.getNutsLevel()));
      const q = s1.get(p, "filters.nutsLevel.value");
      s1.isEmpty(q) && (e.currentConfig.value = s1.update({ ...p }, "filters.nutsLevel.value", () => s.getNutsLevel()));
    }
  }), sL(() => {
    s.destroy();
  }), {
    updateSort: h,
    updateCoverage: u,
    updateNutsLevel: d,
    updateSearch: v,
    showFilters: l,
    currentConfigFilters: a
  };
}
function EH1(t, e) {
  const { source: n, sourceType: i, sourceMappingData: s } = s3(t), l = D1(), a = e.sheet, o = e.useConfig, h = e.useEvents, u = e.useCellClassification, d = e.useAnnotationClassification, v = e.useInfo, m = g1(() => {
    var b, x;
    return ((b = H(a.cellList)) == null ? void 0 : b.length) > 0 && ((x = H(a.rowList)) == null ? void 0 : x.length) > 0;
  }), p = g1(() => {
    var x, k;
    const b = (k = (x = H(o.currentConfig)) == null ? void 0 : x.sheet) == null ? void 0 : k.editable;
    return s1.isNil(b) ? !0 : !b;
  }), _ = async () => {
    var k, F, D;
    const b = H(n), x = (D = (F = (k = H(o.currentConfig)) == null ? void 0 : k.filters) == null ? void 0 : F.coverage) == null ? void 0 : D.euCountryCodeList;
    return H(i) === "jsonstat" ? await new LT1(b, { euCountryCodeList: x }).processData(H(s)) : x && s1.some(b, (V) => !s1.isNil(V.nuts.eu)) === !1 ? s1.map(b, (V) => s1.merge({}, V, { nuts: { eu: Fo.isInList(V.nuts.code, x) } })) : b;
  }, q = async () => {
    const b = await _();
    a.initWithData(b, {
      cellClassification: H(u.cellClassificationList),
      annotationClassification: H(d.annotationClassificationList),
      variable: H(v.variableData)
    });
  }, M = [], z = l3(
    [n, u.cellClassificationList],
    ([b, x]) => {
      s1.isNil(b) || (h.onBeforeUpdateSource(), setTimeout(() => {
        q();
      }, 25));
    },
    {
      immediate: !0
    }
  );
  return M.push(z), sL(() => {
    s1.each(M, (b) => b());
  }), {
    sheetWrapperElement: l,
    sheet: a,
    hasData: m,
    isReadonly: p
  };
}
function AH1(t) {
  const e = D1(), n = t.useConfig, i = g1(
    () => {
      var h;
      return ((h = H(n.currentConfig)) == null ? void 0 : h.cellDetail.show) ?? !1;
    }
  ), s = g1(() => {
    var h;
    return (h = H(n.currentConfig)) == null ? void 0 : h.aside;
  });
  return {
    showCellDetail: i,
    cellDetailPanel: e,
    elementInsideCellDetail: (h) => {
      var v;
      const u = H(e);
      let d = !1;
      return u && (d = (h && ((v = u.floatingElement) == null ? void 0 : v.contains(h))) ?? !1), d;
    },
    openCellDetail: (h, u) => {
      if (H(i)) {
        const d = H(e);
        d && d.open(h, u);
      }
    },
    closeCellDetail: () => {
      const h = H(e);
      h && h.onClose();
    },
    currentConfigCellDetail: s
  };
}
function FH1(t, e) {
  const { tabList: n } = s3(t), i = e.useConfig, s = e.useCellClassification, l = g1(() => {
    var h;
    return (h = H(i.currentConfig)) == null ? void 0 : h.aside;
  }), a = g1(() => {
    const h = {
      label: "Tab $index$",
      component: zH1,
      events: {
        onItemClick: (u) => {
        },
        onItemNavigationClick: (u) => {
        }
      }
    };
    return s1.map(H(n), (u, d) => {
      const v = { ...u }, m = H(s.cellClassificationList);
      if (m) {
        const _ = v == null ? void 0 : v.props;
        _ != null && _.list && (v.props = {
          ..._,
          list: s1.map(_.list, (q) => {
            const M = q == null ? void 0 : q.classificationId;
            return s1.isNil(M) || s1.assign(q, {
              classification: s1.find(m, (z) => z.id === M)
            }), q;
          })
        });
      }
      if (v.component)
        return u;
      const p = s1.merge({}, h, v);
      return p.label = p.label.replace("$index$", `${d}`), p;
    });
  });
  return {
    showAside: g1(() => {
      var h;
      return ((h = H(i.currentConfig)) == null ? void 0 : h.aside.show) ?? !1;
    }),
    currentConfigTabs: l,
    asideTabListExtended: a
  };
}
const TH1 = c2({
  name: "JclDataViewer",
  emits: CA,
  components: {
    EclLoader: pu1,
    EclIcon: Ie,
    EclParagraph: zr,
    JclDataViewerInfo: rH1,
    JclDataViewerFilters: BR1,
    JclDataViewerTabs: vH1,
    JclDataViewerCellDetail: wR1
  },
  directives: {
    clickOutside: vk1.directive
  },
  props: {
    config: {
      type: Object,
      required: !1
    },
    sourceType: {
      type: String,
      required: !1,
      default: () => "jsonstat"
    },
    source: {
      type: [Array, Object],
      required: !0
    },
    sourceMappingData: {
      type: Object,
      required: !1
    },
    cellClassification: {
      type: Array,
      required: !1
    },
    annotationClassification: {
      type: Array,
      required: !1
    },
    variable: {
      type: Object,
      required: !1
    },
    tabList: {
      type: Array,
      required: !1
    }
  },
  setup(t, { emit: e }) {
    var q;
    const n = D1(), i = D1(), s = new Mu((q = t == null ? void 0 : t.config) == null ? void 0 : q.sheet), l = MH1(t), a = bH1(t), o = LH1(t), h = xH1(t, { useConfig: o }), u = SH1(t, { useConfig: o, sheet: s }), d = AH1({ useConfig: o }), v = CH1({ useLoader: u, useCellDetail: d, sheet: s }, e), m = kH1({
      useConfig: o,
      useLoader: u,
      useEvents: v,
      sheet: s
    }), p = FH1(t, { useConfig: o, useCellClassification: l }), _ = EH1(t, {
      sheet: s,
      useConfig: o,
      useEvents: v,
      useCellClassification: l,
      useAnnotationClassification: a,
      useInfo: h
    });
    return {
      dataViewerMainElement: n,
      dataViewerGridInstance: i,
      sheetComponent: s,
      ...o,
      ...h,
      ...u,
      ...d,
      ...v,
      ...m,
      ...p,
      ..._
    };
  }
}), IH1 = {
  id: "data-viewer",
  ref: "dataViewerMainElement"
}, OH1 = { class: "data-viewer__header" }, NH1 = {
  key: 0,
  class: "header__info"
}, PH1 = ["innerHTML"], BH1 = {
  key: 1,
  class: "header__filters"
}, VH1 = { class: "data-viewer__body" }, RH1 = {
  key: 0,
  class: "empty"
}, HH1 = {
  class: "data-viewer__sheet",
  ref: "sheetWrapperElement"
}, DH1 = {
  key: 1,
  class: "data-viewer__panel"
};
function $H1(t, e, n, i, s, l) {
  var q, M, z, b;
  const a = V2("EclLoader"), o = V2("JclDataViewerInfo"), h = V2("JclDataViewerFilters"), u = V2("EclIcon"), d = V2("EclParagraph"), v = V2("vue-data-grid"), m = V2("JclDataViewerCellDetail"), p = V2("JclDataViewerTabs"), _ = ku("click-outside");
  return T(), N("section", IH1, [
    J2(t.$slots, "loader", {
      show: t.showLoader,
      label: t.loaderLabel
    }, () => [
      b6(_3(a, {
        background: "#393d44",
        opacity: 0.7,
        panel: !0,
        stretch: !0,
        showLabel: !0,
        label: t.loaderLabel
      }, null, 8, ["label"]), [
        [Na, t.showLoader]
      ])
    ], !0),
    C("div", OH1, [
      t.showInfo || t.appName ? (T(), N("div", NH1, [
        t.appName ? J2(t.$slots, "appName", {
          key: 0,
          appName: t.appName
        }, () => [
          C("div", {
            class: "app-name",
            innerHTML: t.appName
          }, null, 8, PH1)
        ], !0) : m2("", !0),
        t.showInfo ? J2(t.$slots, "info", {
          key: 1,
          showInfo: t.showInfo,
          variableData: t.variableData,
          config: t.currentConfigInfo
        }, () => [
          _3(o, {
            variable: t.variableData,
            config: t.currentConfigInfo,
            sheet: t.sheetComponent
          }, {
            info_left: Q2((x) => [
              J2(t.$slots, "info_left", on(v8({ ...x, sheet: t.sheetComponent, dataViewer: t.dataViewerMainElement, dataViewerGridInstance: t.dataViewerGridInstance })), void 0, !0)
            ]),
            info_center: Q2((x) => [
              J2(t.$slots, "info_center", on(v8({ ...x, sheet: t.sheetComponent, dataViewer: t.dataViewerMainElement, dataViewerGridInstance: t.dataViewerGridInstance })), void 0, !0)
            ]),
            info_right: Q2((x) => [
              J2(t.$slots, "info_right", on(v8({ ...x, sheet: t.sheetComponent, dataViewer: t.dataViewerMainElement, dataViewerGridInstance: t.dataViewerGridInstance })), void 0, !0)
            ]),
            _: 3
          }, 8, ["variable", "config", "sheet"])
        ], !0) : m2("", !0)
      ])) : m2("", !0),
      t.showFilters ? (T(), N("div", BH1, [
        J2(t.$slots, "filters", {
          show: t.showFilters,
          config: t.currentConfigFilters,
          onUpdateSort: t.updateSort,
          onUpdateCoverage: t.updateCoverage,
          onUpdateNutsLevel: t.updateNutsLevel,
          onUpdateSearch: t.updateSearch
        }, () => [
          _3(h, {
            config: t.currentConfigFilters,
            onOnUpdateSort: t.updateSort,
            onOnUpdateCoverage: t.updateCoverage,
            onOnUpdateNutsLevel: t.updateNutsLevel,
            onOnUpdateSearch: t.updateSearch
          }, null, 8, ["config", "onOnUpdateSort", "onOnUpdateCoverage", "onOnUpdateNutsLevel", "onOnUpdateSearch"])
        ], !0)
      ])) : m2("", !0)
    ]),
    C("div", VH1, [
      t.emptyData && ((q = t.currentConfig.empty) != null && q.show) ? (T(), N("div", RH1, [
        (M = t.currentConfig.empty) != null && M.icon ? (T(), v2(u, {
          key: 0,
          icon: t.currentConfig.empty.icon,
          size: "xl"
        }, null, 8, ["icon"])) : m2("", !0),
        (z = t.currentConfig.empty) != null && z.title ? (T(), v2(d, {
          key: 1,
          type: "lead",
          innerHTML: t.currentConfig.empty.title
        }, null, 8, ["innerHTML"])) : m2("", !0),
        (b = t.currentConfig.empty) != null && b.message ? (T(), v2(d, {
          key: 2,
          type: "m",
          innerHTML: t.currentConfig.empty.message
        }, null, 8, ["innerHTML"])) : m2("", !0)
      ])) : m2("", !0),
      C("div", HH1, [
        b6(_3(v, {
          ref: "dataViewerGridInstance",
          readonly: t.isReadonly,
          "row-size": "26",
          theme: "default",
          resize: !1,
          autoSizeColumn: !0,
          exporting: !0,
          range: !0,
          stretch: !1,
          source: t.sheet.rowList.value,
          columns: t.sheet.columnList.value,
          onViewportscroll: t.onViewportScroll,
          onBeforecellfocus: t.onBeforeCellFocus,
          onBeforefocuslost: t.onBeforeCellFocusLost,
          onBeforeedit: t.onBeforeEdit,
          onAfteredit: t.onAfterEdit,
          onBeforeeditstart: t.onBeforeEditStart
        }, null, 8, ["readonly", "source", "columns", "onViewportscroll", "onBeforecellfocus", "onBeforefocuslost", "onBeforeedit", "onAfteredit", "onBeforeeditstart"]), [
          [_, t.onClickOutside]
        ]),
        t.showCellDetail ? (T(), v2(m, {
          key: 0,
          ref: "cellDetailPanel",
          config: t.currentConfigCellDetail,
          boundariesElement: t.sheetWrapperElement
        }, {
          header: Q2((x) => [
            J2(t.$slots, "cell_detail_header", { props: x }, void 0, !0)
          ]),
          content: Q2((x) => [
            J2(t.$slots, "cell_detail_content", { props: x }, void 0, !0)
          ]),
          content_after: Q2((x) => [
            J2(t.$slots, "cell_detail_content_after", { props: x }, void 0, !0)
          ]),
          _: 3
        }, 8, ["config", "boundariesElement"])) : m2("", !0)
      ], 512),
      t.showAside ? (T(), N("div", DH1, [
        _3(p, {
          config: t.currentConfigTabs,
          entityList: t.asideTabListExtended
        }, null, 8, ["config", "entityList"])
      ])) : m2("", !0)
    ])
  ], 512);
}
const pj1 = /* @__PURE__ */ Le(TH1, [["render", $H1], ["__scopeId", "data-v-86b39551"]]), UH1 = c2({
  name: "JclParagraphMoreLess",
  emits: ["toggleCollapse"],
  components: {
    EclButton: Lt
  },
  props: {
    abstract: {
      type: String,
      required: !0
    },
    descriptions: {
      type: [String, Array],
      required: !1
    },
    labels: {
      type: Object,
      required: !1,
      default: {
        more: "APP.GENERAL.MORE",
        less: "APP.GENERAL.LESS"
      }
    },
    initCollapsed: {
      type: Boolean,
      required: !1,
      default: !0
    },
    // attiva l'ellipsis sull'abstract (solo se non ci sono descriptions impostate)
    breakAbstract: {
      type: Boolean,
      required: !1,
      default: !1
    },
    // numero di battute per l'ellipsis sull'abstract
    breakAbstractCount: {
      type: Number,
      required: !1,
      default: 250
    }
  },
  setup(t, { emit: e }) {
    const { breakAbstractCount: n, abstract: i } = s3(t), l = D1(`long-description-${((z = 7) => (z = z < 30 ? z : 30, Math.random().toString(36).substr(2, z + 2)))()}`), a = "...", o = D1(!0), h = D1(t.initCollapsed), u = g1(() => H(h) === !1), d = g1(() => {
      const z = t.descriptions;
      return s1.isArray(z) && z.length > 0 ? !1 : t.breakAbstract === !0 && t.abstract.length > t.breakAbstractCount;
    }), v = g1(() => {
      const z = t.abstract;
      return H(d) ? z.substr(0, t.breakAbstractCount) + (h.value ? a : "") : z;
    }), m = g1(() => {
      if (H(d))
        return [t.abstract.substr(t.breakAbstractCount)];
      {
        const z = t.descriptions;
        if (s1.isArray(z) && z.length > 0)
          return z;
        if (typeof z == "string")
          return [z];
      }
    }), p = g1(() => H(h) ? t.labels.more : t.labels.less), _ = () => {
      h.value = !H(h), e("toggleCollapse", H(h));
    }, q = g1(() => H(u)), M = g1(() => H(h));
    return l3(
      [n, i],
      () => {
        const z = H(n), b = H(i);
        b && !s1.isNil(z) && (o.value = b.length > z);
      },
      { immediate: !0 }
    ), {
      id: l,
      isEnabled: o,
      abstractText: v,
      splitAbstract: d,
      showExpand: q,
      showCollapsed: M,
      isCollapsed: h,
      isExpanded: u,
      buttonLabel: p,
      paragraphList: m,
      toggleCollapse: _,
      EclButtonType: I4
    };
  }
}), jH1 = ["id"];
function GH1(t, e, n, i, s, l) {
  const a = V2("ecl-p"), o = V2("ecl-button");
  return T(), N("div", {
    class: f2(["paragraph-more-less", { "break-abscract": t.splitAbstract, "is-collapsed": t.isCollapsed, "is-expanded": t.isExpanded }])
  }, [
    t.abstractText ? (T(), v2(a, {
      key: 0,
      class: "paragraph__abstract",
      innerHTML: t.$filters.decodeString(t.abstractText)
    }, null, 8, ["innerHTML"])) : m2("", !0),
    t.paragraphList ? (T(), N(I3, { key: 1 }, [
      _3(tL, { name: "fade" }, {
        default: Q2(() => [
          b6(C("div", Ht({
            class: "paragraph__list",
            id: t.id
          }, { hidden: t.showCollapsed }), [
            (T(!0), N(I3, null, Ve(t.paragraphList, (h, u) => (T(), v2(a, {
              class: "paragraph_list__item",
              key: u,
              innerHTML: t.$filters.decodeString(h)
            }, null, 8, ["innerHTML"]))), 128)),
            t.showExpand && t.isEnabled ? (T(), v2(o, {
              key: 0,
              class: "ecl-button ecl-button--more",
              text: t.$t(t.$filters.decodeString(t.buttonLabel)),
              ariaLabel: t.$t(t.$filters.decodeString(t.buttonLabel)),
              "aria-controls": t.id,
              "aria-expanded": t.isExpanded,
              type: t.EclButtonType.Ghost,
              size: "s",
              onClick: t.toggleCollapse
            }, null, 8, ["text", "ariaLabel", "aria-controls", "aria-expanded", "type", "onClick"])) : m2("", !0)
          ], 16, jH1), [
            [Na, t.isExpanded]
          ])
        ]),
        _: 1
      }),
      t.showCollapsed && t.isEnabled ? (T(), v2(o, {
        key: 0,
        class: "ecl-button ecl-button--more",
        text: t.$t(t.$filters.decodeString(t.buttonLabel)),
        ariaLabel: t.$t(t.$filters.decodeString(t.buttonLabel)),
        "aria-controls": t.id,
        "aria-expanded": t.isExpanded,
        type: t.EclButtonType.Ghost,
        size: "s",
        onClick: t.toggleCollapse
      }, null, 8, ["text", "ariaLabel", "aria-controls", "aria-expanded", "type", "onClick"])) : m2("", !0)
    ], 64)) : m2("", !0)
  ], 2);
}
const $b = /* @__PURE__ */ Le(UH1, [["render", GH1], ["__scopeId", "data-v-558f8122"]]), WH1 = c2({
  name: "TitlePageBuilder",
  components: {
    EclHeading: xL
  },
  props: {
    value: {
      type: String,
      required: !0
    },
    style: {
      required: !1,
      type: [String, Object]
    }
  },
  setup(t) {
    return {
      binds: g1(() => {
        const n = s1.merge({ level: "2" }, { ...t });
        return delete n.value, n.level = n.level.toString(), n;
      })
    };
  }
});
function YH1(t, e, n, i, s, l) {
  const a = V2("ecl-h");
  return T(), v2(a, Ht({ style: t.style }, t.binds, {
    innerHTML: t.$filters.decodeString(t.value)
  }), null, 16, ["style", "innerHTML"]);
}
const XH1 = /* @__PURE__ */ Le(WH1, [["render", YH1]]), KH1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: XH1
}, Symbol.toStringTag, { value: "Module" })), ZH1 = () => Promise.resolve().then(() => KH1);
function kA() {
  const t = S8();
  return {
    rewriteLinkTag: (n) => {
      const i = /<a[^>]*toRouteName=(["\'])[^>]*>/gi;
      let s = n;
      if (s && (s != null && s.match(i))) {
        const l = s == null ? void 0 : s.match(i);
        s1.each(l, (a) => {
          const o = a.match(new RegExp('(?<=\\btoRouteName=")[^"]*', "g"));
          if ((o == null ? void 0 : o.length) > 0) {
            const h = o[0];
            if (t.hasRoute(h)) {
              const u = t.resolve({ name: h });
              s = s.replace(a, a.replace(">", `href="${u.path}">`));
            }
          }
        });
      }
      return s;
    }
  };
}
const JH1 = c2({
  name: "TextPageBuilder",
  components: {
    EclParagraph: zr
  },
  props: {
    value: {
      type: String,
      required: !0
    },
    ...CL,
    type: {
      type: String,
      required: !1,
      default: fa.M,
      validator: (t) => [...Object.values(fa), "small", "medium"].includes(t)
    }
  },
  setup(t) {
    const { value: e } = s3(t), n = g1(() => kA().rewriteLinkTag(w6(H(e))));
    return {
      binds: g1(() => {
        const s = s1.omit(s1.cloneDeep(t), "value");
        return s.type === "small" && s1.assign(s, { type: fa.S }), s.type === "medium" && s1.assign(s, { type: fa.M }), s;
      }),
      textValue: n
    };
  }
});
function QH1(t, e, n, i, s, l) {
  const a = V2("ecl-p");
  return T(), v2(a, Ht(t.binds, {
    innerHTML: t.$filters.decodeString(t.textValue)
  }), null, 16, ["innerHTML"]);
}
const eD1 = /* @__PURE__ */ Le(JH1, [["render", QH1]]), tD1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eD1
}, Symbol.toStringTag, { value: "Module" })), nD1 = () => Promise.resolve().then(() => tD1), iD1 = c2({
  name: "IconPageBuilder",
  components: {
    EclIcon: Ie
  },
  props: {
    ...c0
  },
  setup(t) {
    return {
      binds: g1(() => t)
    };
  }
});
function sD1(t, e, n, i, s, l) {
  const a = V2("ecl-icon");
  return T(), v2(a, on(v8(t.binds)), null, 16);
}
const lD1 = /* @__PURE__ */ Le(iD1, [["render", sD1]]), rD1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lD1
}, Symbol.toStringTag, { value: "Module" })), aD1 = () => Promise.resolve().then(() => rD1), oD1 = c2({
  name: "IframePageBuilder",
  props: {
    url: {
      type: String,
      required: !0
    },
    selectorElementListToRemove: {
      type: Array,
      required: !1,
      default: ["#ecgloban", "#eccck", ".ecl-site-header", ".ecl-page-header", ".footer"]
    },
    selectorElementAutoHeight: {
      type: String,
      required: !1
    },
    wrapperStyles: {
      type: String,
      required: !1,
      default: "width: 100%; height: 700px;"
    },
    iframeStyles: {
      type: String,
      required: !1,
      default: "width: 100%; height: 100%;"
    },
    injectCss: {
      type: String,
      required: !1
    }
  },
  setup(t) {
    const e = D1(), n = D1(), i = D1(!0), s = D1(), l = new MutationObserver(() => a()), a = () => {
      var d;
      const h = H(s), u = t.selectorElementAutoHeight;
      if (h && u) {
        const v = (h == null ? void 0 : h.contentDocument) || ((d = h == null ? void 0 : h.contentWindow) == null ? void 0 : d.document);
        if (v && u) {
          let m = function(p, _) {
            const q = v.querySelectorAll(_);
            if ((q == null ? void 0 : q.length) > 0) {
              const M = q[0];
              p.parentElement && (p.parentElement.style.minHeight = `${M.getBoundingClientRect().height + 10}px`);
            } else
              console.error(`Iframe > the element with selector "${u}" was not found!`);
          };
          clearTimeout(H(n)), n.value = setTimeout(() => {
            m(h, u);
          }, 200);
        }
      }
    }, o = (h) => new Promise((u) => {
      let d = [...t.selectorElementListToRemove];
      const v = 30, m = {};
      function p() {
        d.forEach((_) => {
          const q = h.querySelectorAll(_);
          q.length > 0 ? (q.forEach((M) => M.remove()), d = d.filter((M) => M !== _), s1.unset(m, s1.kebabCase(_))) : s1.update(m, s1.kebabCase(_), function(M) {
            return M ? M + 1 : 1;
          });
        }), s1.every(s1.values(m), (_) => _ >= v), (d.length === 0 || s1.every(s1.values(m), (_) => _ >= v)) && (clearInterval(H(e)), i.value = !1, u(!0));
      }
      if (e.value = setInterval(p, 500), t.injectCss) {
        const _ = document.createElement("style");
        h.head.append(_), _.appendChild(document.createTextNode(t.injectCss));
      }
    });
    return l3(s, (h) => {
      h && (h.onload = function() {
        var d;
        const u = h.contentDocument || ((d = h.contentWindow) == null ? void 0 : d.document);
        u && (window.addEventListener("resize", a), o(u).then(() => {
          a();
          const v = {
            childList: !0,
            subtree: !0,
            attributes: !1,
            characterData: !1
          };
          l.observe(u.body, v);
        }));
      });
    }, { immediate: !0 }), mn(() => {
      clearInterval(H(e)), clearTimeout(H(n)), l && l.disconnect();
    }), {
      showIframeLoader: i,
      iframeEl: s
    };
  }
}), cD1 = ["src"];
function hD1(t, e, n, i, s, l) {
  const a = V2("EclLoader");
  return T(), N("div", {
    style: Rt(`position: relative; ${t.wrapperStyles}`)
  }, [
    t.showIframeLoader ? (T(), v2(a, {
      key: 0,
      opacity: 1,
      panel: !0
    })) : m2("", !0),
    C("iframe", {
      style: Rt(`border: none; ${t.iframeStyles}`),
      ref: "iframeEl",
      src: t.url
    }, null, 12, cD1)
  ], 4);
}
const uD1 = /* @__PURE__ */ Le(oD1, [["render", hD1]]), dD1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uD1
}, Symbol.toStringTag, { value: "Module" })), fD1 = () => Promise.resolve().then(() => dD1), vD1 = c2({
  name: "ImagePageBuilder",
  props: {
    src: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      required: !1
    }
  },
  setup(t) {
    const { src: e } = s3(t), n = e9.getConfig("image"), i = n == null ? void 0 : n.urlBasePath, s = g1(() => {
      const a = { ...t, alt: w6(t == null ? void 0 : t.alt) };
      return delete a.src, a;
    });
    return {
      urlImage: g1(() => {
        const a = H(e);
        return I_(a) ? a : `${i}${a}`;
      }),
      binds: s
    };
  }
}), pD1 = ["src"];
function mD1(t, e, n, i, s, l) {
  return T(), N("img", Ht(t.binds, {
    src: `${t.urlImage}`
  }), null, 16, pD1);
}
const gD1 = /* @__PURE__ */ Le(vD1, [["render", mD1], ["__scopeId", "data-v-ed1ef54d"]]), yD1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gD1
}, Symbol.toStringTag, { value: "Module" })), _D1 = () => Promise.resolve().then(() => yD1), qD1 = c2({
  name: "SpanPageBuilder",
  props: {
    value: {
      type: String,
      required: !1
    },
    class: String
  },
  setup(t) {
    return {
      binds: g1(() => {
        const n = { ...t };
        return delete n.value, n;
      })
    };
  }
}), wD1 = ["innerHTML"];
function zD1(t, e, n, i, s, l) {
  return T(), N("span", Ht(t.binds, {
    innerHTML: t.$filters.decodeString(t.value)
  }), null, 16, wD1);
}
const MD1 = /* @__PURE__ */ Le(qD1, [["render", zD1], ["__scopeId", "data-v-2ff3c6fb"]]), bD1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MD1
}, Symbol.toStringTag, { value: "Module" })), LD1 = () => Promise.resolve().then(() => bD1), xD1 = c2({
  name: "HtmlPageBuilder",
  props: {
    value: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    return {
      decodedValue: g1(() => kA().rewriteLinkTag(w6(t.value)))
    };
  }
}), SD1 = ["innerHTML"];
function CD1(t, e, n, i, s, l) {
  return T(), N("div", { innerHTML: t.decodedValue }, null, 8, SD1);
}
const kD1 = /* @__PURE__ */ Le(xD1, [["render", CD1]]), ED1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kD1
}, Symbol.toStringTag, { value: "Module" })), AD1 = () => Promise.resolve().then(() => ED1);
function FD1(t) {
  const { modal: e } = s3(t), n = g1(() => {
    const a = H(e);
    return (a == null ? void 0 : a.id) ?? `modal-${s1.uniqueId()}`;
  }), i = g1(() => {
    const a = H(e);
    return `ecl-modal-from-button ${a == null ? void 0 : a.class}`;
  }), s = g1(() => {
    const a = H(e);
    if (a != null && a.width)
      return `#${H(n)} .ecl-modal__wrapper { max-width: none; width: ${a.width}; }`;
  }), l = g1(() => {
    let a = {};
    const o = H(e);
    return o && (a = {
      title: w6(o.title),
      body: w6(o.body),
      links: s1.map(o.links, (h) => ({
        ...h,
        label: w6((h == null ? void 0 : h.label) ?? ""),
        ariaLabel: w6((h == null ? void 0 : h.ariaLabel) ?? (h == null ? void 0 : h.label) ?? "")
      }))
    }), a;
  });
  return {
    modalId: n,
    modalClass: i,
    modalData: l,
    modalSize: s
  };
}
const TD1 = c2({
  name: "ButtonPageBuilder",
  components: {
    EclButton: Lt,
    EclModal: Au,
    EclLink: O4
  },
  props: {
    modal: {
      required: !1,
      type: Object
    },
    tooltip: {
      required: !1,
      type: String
    },
    style: {
      required: !1,
      type: String
    },
    ...EL
  },
  setup(t) {
    const e = S8(), n = js().t, i = D1(!1), s = FD1(t), l = () => {
      var u;
      const h = H(t.url);
      if (h) {
        if (I_(h) === !1 && h.startsWith("/") === !1) {
          let d = h, v = "";
          if (h.includes("?")) {
            const p = h.split("?");
            d = p[0], v = "?" + p[1];
          }
          const m = e.resolve({ name: d });
          if (((u = m == null ? void 0 : m.matched) == null ? void 0 : u.length) > 0)
            return `${m.fullPath}${v}`;
        }
        return h;
      }
    }, a = g1(() => {
      const h = (t == null ? void 0 : t.ariaLabel) ?? (t == null ? void 0 : t.text), u = s1.assign({}, t, {
        text: t != null && t.text ? w6(n(t == null ? void 0 : t.text)) : void 0,
        ariaLabel: h ? w6(n(h)) : void 0
      });
      return t != null && t.icon && s1.assign(u, { icon: s1.last(t.icon.split("--")) }), t.url && s1.assign(u, { url: l() }), s1.omit(u, "modal");
    }), o = g1(() => {
      let h = {};
      return t.modal && (h = {
        click: (u) => {
          u.preventDefault(), u.stopPropagation(), i.value = !0;
        }
      }), h;
    });
    return {
      binds: a,
      events: o,
      modalShow: i,
      ...s
    };
  }
}), ID1 = ["id"];
function OD1(t, e, n, i, s, l) {
  var v;
  const a = V2("ecl-button"), o = V2("ecl-p"), h = V2("ecl-link"), u = V2("ecl-modal"), d = ku("tooltip");
  return T(), N(I3, null, [
    b6(_3(a, Ht({ style: t.style }, t.binds, Io(t.events)), null, 16, ["style"]), [
      [d, t.tooltip]
    ]),
    t.modal ? (T(), v2(lL, {
      key: 0,
      to: "body"
    }, [
      C("div", {
        id: t.modalId,
        class: f2(t.modalClass)
      }, [
        _3(u, {
          modelValue: t.modalShow,
          "onUpdate:modelValue": e[0] || (e[0] = (m) => t.modalShow = m)
        }, nL({
          body: Q2(() => {
            var m;
            return [
              _3(o, {
                class: "ecl-u-mt-none ecl-u-mb-none",
                innerHTML: t.modalData.body
              }, null, 8, ["innerHTML"]),
              (m = t.modalData) != null && m.links ? (T(!0), N(I3, { key: 0 }, Ve(t.modalData.links, (p, _) => (T(), N("div", {
                key: _,
                class: "ecl-u-mt-l ecl-u-d-flex ecl-u-justify-content-center"
              }, [
                _3(h, {
                  class: f2({ "ecl-u-mt-s": _ > 0 }),
                  type: p.type,
                  url: p.url,
                  target: p.target,
                  label: p.label,
                  ariaLabel: p.aria,
                  icon: "external",
                  iconSize: "xs"
                }, null, 8, ["class", "type", "url", "target", "label", "ariaLabel"])
              ]))), 128)) : m2("", !0)
            ];
          }),
          _: 2
        }, [
          (v = t.modalData) != null && v.title ? {
            name: "title",
            fn: Q2(() => [
              K3(pt(t.modalData.title), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue"]),
        (T(), v2(be("style"), null, {
          default: Q2(() => [
            K3(pt(t.modalSize), 1)
          ]),
          _: 1
        }))
      ], 10, ID1)
    ])) : m2("", !0)
  ], 64);
}
const ND1 = /* @__PURE__ */ Le(TD1, [["render", OD1], ["__scopeId", "data-v-e4cf4379"]]), PD1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ND1
}, Symbol.toStringTag, { value: "Module" })), BD1 = () => Promise.resolve().then(() => PD1), VD1 = c2({
  name: "ParagraphMoreLessPageBuilder",
  components: {
    JclParagraphMoreLess: $b
  },
  props: {
    ...$b.props
  },
  setup(t) {
    return {
      binds: g1(() => ({ ...t, abstract: w6(t == null ? void 0 : t.abstract), descriptions: w6(t == null ? void 0 : t.descriptions) }))
    };
  }
});
function RD1(t, e, n, i, s, l) {
  const a = V2("JclParagraphMoreLess");
  return T(), v2(a, on(v8(t.binds)), null, 16);
}
const HD1 = /* @__PURE__ */ Le(VD1, [["render", RD1], ["__scopeId", "data-v-3c61710a"]]), DD1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HD1
}, Symbol.toStringTag, { value: "Module" })), $D1 = () => Promise.resolve().then(() => DD1), UD1 = c2({
  name: "Column",
  props: {
    column: {
      required: !0,
      type: Object
    }
  },
  setup() {
    return { autoMigration: (n) => {
      const i = s1.cloneDeep(n);
      return s1.isEmpty(i) ? { col: 12 } : (i.sm && (s1.assign(i, { s: i.sm }), delete i.sm), i.md && (s1.assign(i, { m: i.md }), delete i.md), i.lg && (s1.assign(i, { m: i.lg }), delete i.lg), i);
    }, resolveComponent: (n) => e9.getComponent(n) };
  }
});
function jD1(t, e, n, i, s, l) {
  const a = V2("ecl-column");
  return T(), v2(a, on(v8(t.autoMigration(t.column.props))), {
    default: Q2(() => [
      (T(!0), N(I3, null, Ve(t.column.components, (o, h) => (T(), v2(be(t.resolveComponent(o.type)), on(Ht({
        key: `${o.type}-${h}`
      }, o.props)), null, 16))), 128))
    ]),
    _: 1
  }, 16);
}
const GD1 = /* @__PURE__ */ Le(UD1, [["render", jD1]]), WD1 = c2({
  name: "Row",
  components: {
    Column: GD1
  },
  props: {
    row: {
      required: !0,
      type: Object
    }
  },
  setup(t) {
    return {
      binds: g1(() => {
        const n = s1.cloneDeep(t == null ? void 0 : t.row);
        return "columns" in n && delete n.columns, n;
      })
    };
  }
});
function YD1(t, e, n, i, s, l) {
  const a = V2("column"), o = V2("ecl-row");
  return T(), v2(o, on(v8(t.binds)), {
    default: Q2(() => [
      (T(!0), N(I3, null, Ve(t.row.columns, (h, u) => (T(), v2(a, {
        key: u,
        column: h
      }, null, 8, ["column"]))), 128))
    ]),
    _: 1
  }, 16);
}
const xw = /* @__PURE__ */ Le(WD1, [["render", YD1]]), XD1 = c2({
  name: "CollapseListPageBuilder",
  components: {
    Row: xw,
    EclAccordion: gd1,
    EclAccordionItem: vd1
  },
  props: {
    list: {
      type: Array,
      required: !0
    }
  }
});
function KD1(t, e, n, i, s, l) {
  const a = V2("Row"), o = V2("EclAccordionItem"), h = V2("ecl-accordion");
  return T(), v2(h, null, {
    default: Q2(() => [
      (T(!0), N(I3, null, Ve(t.list, (u, d) => (T(), v2(o, { key: d }, {
        trigger: Q2(() => [
          K3(pt(t.$filters.decodeString(u.label)), 1)
        ]),
        content: Q2(() => [
          (T(!0), N(I3, null, Ve(u.rows, (v, m) => (T(), v2(a, {
            key: m,
            row: v
          }, null, 8, ["row"]))), 128))
        ]),
        _: 2
      }, 1024))), 128))
    ]),
    _: 1
  });
}
const ZD1 = /* @__PURE__ */ Le(XD1, [["render", KD1], ["__scopeId", "data-v-2d73e7ac"]]), JD1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ZD1
}, Symbol.toStringTag, { value: "Module" })), QD1 = () => Promise.resolve().then(() => JD1), e$1 = c2({
  name: "ComponentCollectionPageBuilder",
  props: {
    list: {
      type: Array,
      required: !0
    }
  },
  components: {
    Row: xw
  },
  setup() {
    return {
      getNodeType: (e) => {
        var s;
        const n = (s = e == null ? void 0 : e.tagName) == null ? void 0 : s.toLowerCase();
        return n && [
          "article",
          "aside",
          "blockquote",
          "div",
          "footer",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "header",
          "nav",
          "p",
          "section",
          "span"
        ].includes(n) ? n : "div";
      }
    };
  }
});
function t$1(t, e, n, i, s, l) {
  const a = V2("Row");
  return T(!0), N(I3, null, Ve(t.list, (o, h) => (T(), v2(be(t.getNodeType(o)), {
    key: h,
    class: f2(o == null ? void 0 : o.class),
    style: Rt(o == null ? void 0 : o.style)
  }, {
    default: Q2(() => [
      (T(!0), N(I3, null, Ve(o.rows, (u, d) => (T(), v2(a, {
        key: d,
        row: u
      }, null, 8, ["row"]))), 128))
    ]),
    _: 2
  }, 1032, ["class", "style"]))), 128);
}
const n$1 = /* @__PURE__ */ Le(e$1, [["render", t$1], ["__scopeId", "data-v-ce599abd"]]), i$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n$1
}, Symbol.toStringTag, { value: "Module" })), s$1 = () => Promise.resolve().then(() => i$1), EA = {
  label: {
    type: String,
    required: !0
  },
  targetId: {
    type: String,
    required: !0
  }
}, l$1 = c2({
  name: "EclExpandable",
  components: {
    EclButton: Lt
  },
  props: EA,
  setup(t) {
    const e = D1(!1);
    return {
      isExpanded: e,
      toggleClick: () => {
        const i = document.querySelector(`#${t.targetId}`);
        i ? (e.value = !H(e), i.hidden = !H(e)) : console.error("EclExpandable: No target found!");
      }
    };
  }
}), r$1 = { class: "ecl-expandable" };
function a$1(t, e, n, i, s, l) {
  const a = V2("EclButton");
  return T(), N("div", r$1, [
    _3(a, {
      type: "secondary",
      class: "ecl-expandable__toggle",
      "aria-controls": t.targetId,
      "aria-expanded": "false",
      text: t.label,
      icon: "corner-arrow",
      iconRotate: t.isExpanded ? 0 : 180,
      onClick: t.toggleClick
    }, null, 8, ["aria-controls", "text", "iconRotate", "onClick"])
  ]);
}
const o$1 = /* @__PURE__ */ Le(l$1, [["render", a$1]]), c$1 = c2({
  name: "ExpandablePageBuilder",
  components: {
    EclExpandable: o$1
  },
  props: {
    ...EA
  },
  setup(t) {
    return {
      binds: g1(() => t)
    };
  }
});
function h$1(t, e, n, i, s, l) {
  var o;
  const a = V2("EclExpandable");
  return T(), v2(a, Ht({
    key: (o = t.binds) == null ? void 0 : o.label
  }, t.binds), null, 16);
}
const u$1 = /* @__PURE__ */ Le(c$1, [["render", h$1]]), d$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u$1
}, Symbol.toStringTag, { value: "Module" })), f$1 = () => Promise.resolve().then(() => d$1), v$1 = c2({
  name: "WrapperComponentPageBuilder",
  props: {
    tagName: {
      type: String,
      required: !0
    },
    class: {
      type: String,
      required: !1
    },
    style: {
      type: String,
      required: !1
    },
    components: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    return { getNodeType: g1(() => {
      var o;
      const l = (o = t == null ? void 0 : t.tagName) == null ? void 0 : o.toLowerCase();
      return [
        "article",
        "aside",
        "blockquote",
        "div",
        "footer",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "nav",
        "p",
        "section",
        "span"
      ].includes(l) ? l : "div";
    }), childCmpExist: (l) => e9.componentExist(l.type), childCmpName: (l) => e9.getComponent(l.type), childCmpBind: (l) => l.props };
  }
});
function p$1(t, e, n, i, s, l) {
  return T(), v2(be(t.getNodeType), {
    class: f2(t.class),
    style: Rt(t.style)
  }, {
    default: Q2(() => [
      (T(!0), N(I3, null, Ve(t.components, (a, o) => (T(), N(I3, { key: o }, [
        t.childCmpExist(a) ? (T(), v2(be(t.childCmpName(a)), on(Ht({ key: 0 }, t.childCmpBind(a))), null, 16)) : m2("", !0)
      ], 64))), 128))
    ]),
    _: 1
  }, 8, ["class", "style"]);
}
const m$1 = /* @__PURE__ */ Le(v$1, [["render", p$1], ["__scopeId", "data-v-d22ccfde"]]), g$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: m$1
}, Symbol.toStringTag, { value: "Module" })), y$1 = () => Promise.resolve().then(() => g$1);
var AA = { exports: {} };
/*!
  * Stickyfill – `position: sticky` polyfill
  * v. 2.1.0 | https://github.com/wilddeer/stickyfill
  * MIT License
  */
(function(t) {
  (function(e, n) {
    var i = function() {
      function z(b, x) {
        for (var k = 0; k < x.length; k++) {
          var F = x[k];
          F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(b, F.key, F);
        }
      }
      return function(b, x, k) {
        return x && z(b.prototype, x), k && z(b, k), b;
      };
    }();
    function s(z, b) {
      if (!(z instanceof b))
        throw new TypeError("Cannot call a class as a function");
    }
    var l = !1, a = typeof e < "u";
    !a || !e.getComputedStyle ? l = !0 : function() {
      var z = n.createElement("div");
      ["", "-webkit-", "-moz-", "-ms-"].some(function(b) {
        try {
          z.style.position = b + "sticky";
        } catch {
        }
        return z.style.position != "";
      }) && (l = !0);
    }();
    var o = !1, h = typeof ShadowRoot < "u", u = {
      top: null,
      left: null
    }, d = [];
    function v(z, b) {
      for (var x in b)
        b.hasOwnProperty(x) && (z[x] = b[x]);
    }
    function m(z) {
      return parseFloat(z) || 0;
    }
    function p(z) {
      for (var b = 0; z; )
        b += z.offsetTop, z = z.offsetParent;
      return b;
    }
    var _ = function() {
      function z(b) {
        if (s(this, z), !(b instanceof HTMLElement))
          throw new Error("First argument must be HTMLElement");
        if (d.some(function(x) {
          return x._node === b;
        }))
          throw new Error("Stickyfill is already applied to this node");
        this._node = b, this._stickyMode = null, this._active = !1, d.push(this), this.refresh();
      }
      return i(z, [{
        key: "refresh",
        value: function() {
          if (!(l || this._removed)) {
            this._active && this._deactivate();
            var x = this._node, k = getComputedStyle(x), F = {
              position: k.position,
              top: k.top,
              display: k.display,
              marginTop: k.marginTop,
              marginBottom: k.marginBottom,
              marginLeft: k.marginLeft,
              marginRight: k.marginRight,
              cssFloat: k.cssFloat
            };
            if (!(isNaN(parseFloat(F.top)) || F.display == "table-cell" || F.display == "none")) {
              this._active = !0;
              var D = x.style.position;
              (k.position == "sticky" || k.position == "-webkit-sticky") && (x.style.position = "static");
              var R = x.parentNode, V = h && R instanceof ShadowRoot ? R.host : R, J = x.getBoundingClientRect(), K = V.getBoundingClientRect(), P = getComputedStyle(V);
              this._parent = {
                node: V,
                styles: {
                  position: V.style.position
                },
                offsetHeight: V.offsetHeight
              }, this._offsetToWindow = {
                left: J.left,
                right: n.documentElement.clientWidth - J.right
              }, this._offsetToParent = {
                top: J.top - K.top - m(P.borderTopWidth),
                left: J.left - K.left - m(P.borderLeftWidth),
                right: -J.right + K.right - m(P.borderRightWidth)
              }, this._styles = {
                position: D,
                top: x.style.top,
                bottom: x.style.bottom,
                left: x.style.left,
                right: x.style.right,
                width: x.style.width,
                marginTop: x.style.marginTop,
                marginLeft: x.style.marginLeft,
                marginRight: x.style.marginRight
              };
              var O = m(F.top);
              this._limits = {
                start: J.top + e.pageYOffset - O,
                end: K.top + e.pageYOffset + V.offsetHeight - m(P.borderBottomWidth) - x.offsetHeight - O - m(F.marginBottom)
              };
              var G = P.position;
              G != "absolute" && G != "relative" && (V.style.position = "relative"), this._recalcPosition();
              var j = this._clone = {};
              j.node = n.createElement("div"), v(j.node.style, {
                width: J.right - J.left + "px",
                height: J.bottom - J.top + "px",
                marginTop: F.marginTop,
                marginBottom: F.marginBottom,
                marginLeft: F.marginLeft,
                marginRight: F.marginRight,
                cssFloat: F.cssFloat,
                padding: 0,
                border: 0,
                borderSpacing: 0,
                fontSize: "1em",
                position: "static"
              }), R.insertBefore(j.node, x), j.docOffsetTop = p(j.node);
            }
          }
        }
      }, {
        key: "_recalcPosition",
        value: function() {
          if (!(!this._active || this._removed)) {
            var x = u.top <= this._limits.start ? "start" : u.top >= this._limits.end ? "end" : "middle";
            if (this._stickyMode != x) {
              switch (x) {
                case "start":
                  v(this._node.style, {
                    position: "absolute",
                    left: this._offsetToParent.left + "px",
                    right: this._offsetToParent.right + "px",
                    top: this._offsetToParent.top + "px",
                    bottom: "auto",
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0
                  });
                  break;
                case "middle":
                  v(this._node.style, {
                    position: "fixed",
                    left: this._offsetToWindow.left + "px",
                    right: this._offsetToWindow.right + "px",
                    top: this._styles.top,
                    bottom: "auto",
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0
                  });
                  break;
                case "end":
                  v(this._node.style, {
                    position: "absolute",
                    left: this._offsetToParent.left + "px",
                    right: this._offsetToParent.right + "px",
                    top: "auto",
                    bottom: 0,
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0
                  });
                  break;
              }
              this._stickyMode = x;
            }
          }
        }
      }, {
        key: "_fastCheck",
        value: function() {
          !this._active || this._removed || (Math.abs(p(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) && this.refresh();
        }
      }, {
        key: "_deactivate",
        value: function() {
          var x = this;
          !this._active || this._removed || (this._clone.node.parentNode.removeChild(this._clone.node), delete this._clone, v(this._node.style, this._styles), delete this._styles, d.some(function(k) {
            return k !== x && k._parent && k._parent.node === x._parent.node;
          }) || v(this._parent.node.style, this._parent.styles), delete this._parent, this._stickyMode = null, this._active = !1, delete this._offsetToWindow, delete this._offsetToParent, delete this._limits);
        }
      }, {
        key: "remove",
        value: function() {
          var x = this;
          this._deactivate(), d.some(function(k, F) {
            if (k._node === x._node)
              return d.splice(F, 1), !0;
          }), this._removed = !0;
        }
      }]), z;
    }(), q = {
      stickies: d,
      Sticky: _,
      forceSticky: function() {
        l = !1, M(), this.refreshAll();
      },
      addOne: function(b) {
        if (!(b instanceof HTMLElement))
          if (b.length && b[0])
            b = b[0];
          else
            return;
        for (var x = 0; x < d.length; x++)
          if (d[x]._node === b)
            return d[x];
        return new _(b);
      },
      add: function(b) {
        if (b instanceof HTMLElement && (b = [b]), !!b.length) {
          for (var x = [], k = function(V) {
            var J = b[V];
            if (!(J instanceof HTMLElement))
              return x.push(void 0), "continue";
            if (d.some(function(K) {
              if (K._node === J)
                return x.push(K), !0;
            }))
              return "continue";
            x.push(new _(J));
          }, F = 0; F < b.length; F++)
            var D = k(F);
          return x;
        }
      },
      refreshAll: function() {
        d.forEach(function(b) {
          return b.refresh();
        });
      },
      removeOne: function(b) {
        if (!(b instanceof HTMLElement))
          if (b.length && b[0])
            b = b[0];
          else
            return;
        d.some(function(x) {
          if (x._node === b)
            return x.remove(), !0;
        });
      },
      remove: function(b) {
        if (b instanceof HTMLElement && (b = [b]), !!b.length)
          for (var x = function(D) {
            var R = b[D];
            d.some(function(V) {
              if (V._node === R)
                return V.remove(), !0;
            });
          }, k = 0; k < b.length; k++)
            x(k);
      },
      removeAll: function() {
        for (; d.length; )
          d[0].remove();
      }
    };
    function M() {
      if (o)
        return;
      o = !0;
      function z() {
        e.pageXOffset != u.left ? (u.top = e.pageYOffset, u.left = e.pageXOffset, q.refreshAll()) : e.pageYOffset != u.top && (u.top = e.pageYOffset, u.left = e.pageXOffset, d.forEach(function(R) {
          return R._recalcPosition();
        }));
      }
      z(), e.addEventListener("scroll", z), e.addEventListener("resize", q.refreshAll), e.addEventListener("orientationchange", q.refreshAll);
      var b = void 0;
      function x() {
        b = setInterval(function() {
          d.forEach(function(R) {
            return R._fastCheck();
          });
        }, 500);
      }
      function k() {
        clearInterval(b);
      }
      var F = void 0, D = void 0;
      "hidden" in n ? (F = "hidden", D = "visibilitychange") : "webkitHidden" in n && (F = "webkitHidden", D = "webkitvisibilitychange"), D ? (n[F] || x(), n.addEventListener(D, function() {
        n[F] ? k() : x();
      })) : x();
    }
    l || M(), t.exports ? t.exports = q : a && (e.Stickyfill = q);
  })(window, document);
})(AA);
var _$1 = AA.exports;
const q$1 = /* @__PURE__ */ Pu(_$1);
var FA = { exports: {} };
/*!
 * gumshoejs v5.1.2
 * A simple, framework-agnostic scrollspy script.
 * (c) 2019 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/gumshoe
 */
(function(t, e) {
  Element.prototype.closest || (Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest = function(n) {
    var i = this, s = this;
    if (!document.documentElement.contains(i))
      return null;
    do {
      if (s.matches(n))
        return s;
      s = s.parentElement;
    } while (s !== null);
    return null;
  }), function() {
    if (typeof window.CustomEvent == "function")
      return !1;
    function n(i, s) {
      s = s || { bubbles: !1, cancelable: !1, detail: void 0 };
      var l = document.createEvent("CustomEvent");
      return l.initCustomEvent(i, s.bubbles, s.cancelable, s.detail), l;
    }
    n.prototype = window.Event.prototype, window.CustomEvent = n;
  }(), function(n, i) {
    t.exports = i(n);
  }(typeof N5 < "u" ? N5 : typeof window < "u" ? window : N5, function(n) {
    var i = {
      // Active classes
      navClass: "active",
      contentClass: "active",
      // Nested navigation
      nested: !1,
      nestedClass: "active",
      // Offset & reflow
      offset: 0,
      reflow: !1,
      // Event support
      events: !0
    }, s = function() {
      var x = {};
      return Array.prototype.forEach.call(arguments, function(k) {
        for (var F in k) {
          if (!k.hasOwnProperty(F))
            return;
          x[F] = k[F];
        }
      }), x;
    }, l = function(x, k, F) {
      if (F.settings.events) {
        var D = new CustomEvent(x, {
          bubbles: !0,
          cancelable: !0,
          detail: F
        });
        k.dispatchEvent(D);
      }
    }, a = function(x) {
      var k = 0;
      if (x.offsetParent)
        for (; x; )
          k += x.offsetTop, x = x.offsetParent;
      return k >= 0 ? k : 0;
    }, o = function(x) {
      x && x.sort(function(k, F) {
        var D = a(k.content), R = a(F.content);
        return D < R ? -1 : 1;
      });
    }, h = function(x) {
      return typeof x.offset == "function" ? parseFloat(x.offset()) : parseFloat(x.offset);
    }, u = function() {
      return Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );
    }, d = function(x, k, F) {
      var D = x.getBoundingClientRect(), R = h(k);
      return F ? parseInt(D.bottom, 10) < (n.innerHeight || document.documentElement.clientHeight) : parseInt(D.top, 10) <= R;
    }, v = function() {
      return n.innerHeight + n.pageYOffset >= u();
    }, m = function(x, k) {
      return !!(v() && d(x.content, k, !0));
    }, p = function(x, k) {
      var F = x[x.length - 1];
      if (m(F, k))
        return F;
      for (var D = x.length - 1; D >= 0; D--)
        if (d(x[D].content, k))
          return x[D];
    }, _ = function(x, k) {
      if (!(!k.nested || !x.parentNode)) {
        var F = x.parentNode.closest("li");
        F && (F.classList.remove(k.nestedClass), _(F, k));
      }
    }, q = function(x, k) {
      if (x) {
        var F = x.nav.closest("li");
        F && (F.classList.remove(k.navClass), x.content.classList.remove(k.contentClass), _(F, k), l("gumshoeDeactivate", F, {
          link: x.nav,
          content: x.content,
          settings: k
        }));
      }
    }, M = function(x, k) {
      if (k.nested) {
        var F = x.parentNode.closest("li");
        F && (F.classList.add(k.nestedClass), M(F, k));
      }
    }, z = function(x, k) {
      if (x) {
        var F = x.nav.closest("li");
        F && (F.classList.add(k.navClass), x.content.classList.add(k.contentClass), M(F, k), l("gumshoeActivate", F, {
          link: x.nav,
          content: x.content,
          settings: k
        }));
      }
    }, b = function(x, k) {
      var F = {}, D, R, V, J, K;
      F.setup = function() {
        D = document.querySelectorAll(x), R = [], Array.prototype.forEach.call(D, function(j) {
          var Q = document.getElementById(decodeURIComponent(j.hash.substr(1)));
          Q && R.push({
            nav: j,
            content: Q
          });
        }), o(R);
      }, F.detect = function() {
        var j = p(R, K);
        if (!j) {
          V && (q(V, K), V = null);
          return;
        }
        V && j.content === V.content || (q(V, K), z(j, K), V = j);
      };
      var P = function(j) {
        J && n.cancelAnimationFrame(J), J = n.requestAnimationFrame(F.detect);
      }, O = function(j) {
        J && n.cancelAnimationFrame(J), J = n.requestAnimationFrame(function() {
          o(R), F.detect();
        });
      };
      F.destroy = function() {
        V && q(V, K), n.removeEventListener("scroll", P, !1), K.reflow && n.removeEventListener("resize", O, !1), R = null, D = null, V = null, J = null, K = null;
      };
      var G = function() {
        K = s(i, k || {}), F.setup(), F.detect(), n.addEventListener("scroll", P, !1), K.reflow && n.addEventListener("resize", O, !1);
      };
      return G(), F;
    };
    return b;
  });
})(FA);
var w$1 = FA.exports;
const z$1 = /* @__PURE__ */ Pu(w$1), Ub = (t, e = document) => [].slice.call(e.querySelectorAll(t)), e0 = (t, e = document) => e.querySelector(t);
class M$1 {
  /**
   * Constructs a new EventManager.
   */
  constructor() {
    this.events = /* @__PURE__ */ new Map();
  }
  /**
   * Register a callback for a specific event.
   * @param {string} eventName - The name of the event.
   * @param {Function} callback - The callback function to be executed when the event is triggered.
   */
  on(e, n) {
    this.events.has(e) || this.events.set(e, []), this.events.get(e).push(n);
  }
  /**
   * Trigger an event, executing all registered callbacks for that event.
   * @param {string} eventName - The name of the event to trigger.
   * @param {any} eventData - Additional data to pass to the callbacks.
   */
  trigger(e, n) {
    const i = this.events.get(e);
    i && i.forEach((s) => {
      s(n);
    });
  }
  /**
   * Retrieve the most recently registered callback for a specific event.
   * @param {string} eventName - The name of the event.
   * @returns {Function|null} - The most recently registered callback, or null if none is registered.
   */
  getCallback(e) {
    return this.events.get(e) || [];
  }
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var TA = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], bu = /* @__PURE__ */ TA.join(","), IA = typeof Element > "u", wr = IA ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Lu = !IA && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, xu = function t(e, n) {
  var i;
  n === void 0 && (n = !0);
  var s = e == null || (i = e.getAttribute) === null || i === void 0 ? void 0 : i.call(e, "inert"), l = s === "" || s === "true", a = l || n && e && t(e.parentNode);
  return a;
}, b$1 = function(e) {
  var n, i = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return i === "" || i === "true";
}, OA = function(e, n, i) {
  if (xu(e))
    return [];
  var s = Array.prototype.slice.apply(e.querySelectorAll(bu));
  return n && wr.call(e, bu) && s.unshift(e), s = s.filter(i), s;
}, NA = function t(e, n, i) {
  for (var s = [], l = Array.from(e); l.length; ) {
    var a = l.shift();
    if (!xu(a, !1))
      if (a.tagName === "SLOT") {
        var o = a.assignedElements(), h = o.length ? o : a.children, u = t(h, !0, i);
        i.flatten ? s.push.apply(s, u) : s.push({
          scopeParent: a,
          candidates: u
        });
      } else {
        var d = wr.call(a, bu);
        d && i.filter(a) && (n || !e.includes(a)) && s.push(a);
        var v = a.shadowRoot || // check for an undisclosed shadow
        typeof i.getShadowRoot == "function" && i.getShadowRoot(a), m = !xu(v, !1) && (!i.shadowRootFilter || i.shadowRootFilter(a));
        if (v && m) {
          var p = t(v === !0 ? a.children : v.children, !0, i);
          i.flatten ? s.push.apply(s, p) : s.push({
            scopeParent: a,
            candidates: p
          });
        } else
          l.unshift.apply(l, a.children);
      }
  }
  return s;
}, PA = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, Ql = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || b$1(e)) && !PA(e) ? 0 : e.tabIndex;
}, L$1 = function(e, n) {
  var i = Ql(e);
  return i < 0 && n && !PA(e) ? 0 : i;
}, x$1 = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, BA = function(e) {
  return e.tagName === "INPUT";
}, S$1 = function(e) {
  return BA(e) && e.type === "hidden";
}, C$1 = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(i) {
    return i.tagName === "SUMMARY";
  });
  return n;
}, k$1 = function(e, n) {
  for (var i = 0; i < e.length; i++)
    if (e[i].checked && e[i].form === n)
      return e[i];
}, E$1 = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || Lu(e), i = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = i(window.CSS.escape(e.name));
  else
    try {
      s = i(e.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var l = k$1(s, e.form);
  return !l || l === e;
}, A$1 = function(e) {
  return BA(e) && e.type === "radio";
}, F$1 = function(e) {
  return A$1(e) && !E$1(e);
}, T$1 = function(e) {
  var n, i = e && Lu(e), s = (n = i) === null || n === void 0 ? void 0 : n.host, l = !1;
  if (i && i !== e) {
    var a, o, h;
    for (l = !!((a = s) !== null && a !== void 0 && (o = a.ownerDocument) !== null && o !== void 0 && o.contains(s) || e != null && (h = e.ownerDocument) !== null && h !== void 0 && h.contains(e)); !l && s; ) {
      var u, d, v;
      i = Lu(s), s = (u = i) === null || u === void 0 ? void 0 : u.host, l = !!((d = s) !== null && d !== void 0 && (v = d.ownerDocument) !== null && v !== void 0 && v.contains(s));
    }
  }
  return l;
}, jb = function(e) {
  var n = e.getBoundingClientRect(), i = n.width, s = n.height;
  return i === 0 && s === 0;
}, I$1 = function(e, n) {
  var i = n.displayCheck, s = n.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var l = wr.call(e, "details>summary:first-of-type"), a = l ? e.parentElement : e;
  if (wr.call(a, "details:not([open]) *"))
    return !0;
  if (!i || i === "full" || i === "legacy-full") {
    if (typeof s == "function") {
      for (var o = e; e; ) {
        var h = e.parentElement, u = Lu(e);
        if (h && !h.shadowRoot && s(h) === !0)
          return jb(e);
        e.assignedSlot ? e = e.assignedSlot : !h && u !== e.ownerDocument ? e = u.host : e = h;
      }
      e = o;
    }
    if (T$1(e))
      return !e.getClientRects().length;
    if (i !== "legacy-full")
      return !0;
  } else if (i === "non-zero-area")
    return jb(e);
  return !1;
}, O$1 = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var i = 0; i < n.children.length; i++) {
          var s = n.children.item(i);
          if (s.tagName === "LEGEND")
            return wr.call(n, "fieldset[disabled] *") ? !0 : !s.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Su = function(e, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  xu(n) || S$1(n) || I$1(n, e) || // For a details element with a summary, the summary element gets the focus
  C$1(n) || O$1(n));
}, w_ = function(e, n) {
  return !(F$1(n) || Ql(n) < 0 || !Su(e, n));
}, N$1 = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, P$1 = function t(e) {
  var n = [], i = [];
  return e.forEach(function(s, l) {
    var a = !!s.scopeParent, o = a ? s.scopeParent : s, h = L$1(o, a), u = a ? t(s.candidates) : o;
    h === 0 ? a ? n.push.apply(n, u) : n.push(o) : i.push({
      documentOrder: l,
      tabIndex: h,
      item: s,
      isScope: a,
      content: u
    });
  }), i.sort(x$1).reduce(function(s, l) {
    return l.isScope ? s.push.apply(s, l.content) : s.push(l.content), s;
  }, []).concat(n);
}, B$1 = function(e, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = NA([e], n.includeContainer, {
    filter: w_.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: N$1
  }) : i = OA(e, n.includeContainer, w_.bind(null, n)), P$1(i);
}, V$1 = function(e, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = NA([e], n.includeContainer, {
    filter: Su.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : i = OA(e, n.includeContainer, Su.bind(null, n)), i;
}, sa = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return wr.call(e, bu) === !1 ? !1 : w_(n, e);
}, R$1 = /* @__PURE__ */ TA.concat("iframe").join(","), oy = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return wr.call(e, R$1) === !1 ? !1 : Su(n, e);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Gb(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Wb(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Gb(Object(n), !0).forEach(function(i) {
      H$1(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Gb(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function H$1(t, e, n) {
  return e = $$1(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function D$1(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e || "default");
    if (typeof i != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function $$1(t) {
  var e = D$1(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
var Yb = {
  activateTrap: function(e, n) {
    if (e.length > 0) {
      var i = e[e.length - 1];
      i !== n && i.pause();
    }
    var s = e.indexOf(n);
    s === -1 || e.splice(s, 1), e.push(n);
  },
  deactivateTrap: function(e, n) {
    var i = e.indexOf(n);
    i !== -1 && e.splice(i, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, U$1 = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, j$1 = function(e) {
  return (e == null ? void 0 : e.key) === "Escape" || (e == null ? void 0 : e.key) === "Esc" || (e == null ? void 0 : e.keyCode) === 27;
}, To = function(e) {
  return (e == null ? void 0 : e.key) === "Tab" || (e == null ? void 0 : e.keyCode) === 9;
}, G$1 = function(e) {
  return To(e) && !e.shiftKey;
}, W$1 = function(e) {
  return To(e) && e.shiftKey;
}, Xb = function(e) {
  return setTimeout(e, 0);
}, Kb = function(e, n) {
  var i = -1;
  return e.every(function(s, l) {
    return n(s) ? (i = l, !1) : !0;
  }), i;
}, ro = function(e) {
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    i[s - 1] = arguments[s];
  return typeof e == "function" ? e.apply(void 0, i) : e;
}, vh = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, Y$1 = [], X$1 = function(e, n) {
  var i = (n == null ? void 0 : n.document) || document, s = (n == null ? void 0 : n.trapStack) || Y$1, l = Wb({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: G$1,
    isKeyBackward: W$1
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, o, h = function(O, G, j) {
    return O && O[G] !== void 0 ? O[G] : l[j || G];
  }, u = function(O, G) {
    var j = typeof (G == null ? void 0 : G.composedPath) == "function" ? G.composedPath() : void 0;
    return a.containerGroups.findIndex(function(Q) {
      var i1 = Q.container, h1 = Q.tabbableNodes;
      return i1.contains(O) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (j == null ? void 0 : j.includes(i1)) || h1.find(function(c1) {
        return c1 === O;
      });
    });
  }, d = function(O) {
    var G = l[O];
    if (typeof G == "function") {
      for (var j = arguments.length, Q = new Array(j > 1 ? j - 1 : 0), i1 = 1; i1 < j; i1++)
        Q[i1 - 1] = arguments[i1];
      G = G.apply(void 0, Q);
    }
    if (G === !0 && (G = void 0), !G) {
      if (G === void 0 || G === !1)
        return G;
      throw new Error("`".concat(O, "` was specified but was not a node, or did not return a node"));
    }
    var h1 = G;
    if (typeof G == "string" && (h1 = i.querySelector(G), !h1))
      throw new Error("`".concat(O, "` as selector refers to no known node"));
    return h1;
  }, v = function() {
    var O = d("initialFocus");
    if (O === !1)
      return !1;
    if (O === void 0 || !oy(O, l.tabbableOptions))
      if (u(i.activeElement) >= 0)
        O = i.activeElement;
      else {
        var G = a.tabbableGroups[0], j = G && G.firstTabbableNode;
        O = j || d("fallbackFocus");
      }
    if (!O)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return O;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(O) {
      var G = B$1(O, l.tabbableOptions), j = V$1(O, l.tabbableOptions), Q = G.length > 0 ? G[0] : void 0, i1 = G.length > 0 ? G[G.length - 1] : void 0, h1 = j.find(function(y1) {
        return sa(y1);
      }), c1 = j.slice().reverse().find(function(y1) {
        return sa(y1);
      }), M1 = !!G.find(function(y1) {
        return Ql(y1) > 0;
      });
      return {
        container: O,
        tabbableNodes: G,
        focusableNodes: j,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: M1,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: Q,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: i1,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: h1,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: c1,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(A1) {
          var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, a1 = G.indexOf(A1);
          return a1 < 0 ? $ ? j.slice(j.indexOf(A1) + 1).find(function(n1) {
            return sa(n1);
          }) : j.slice(0, j.indexOf(A1)).reverse().find(function(n1) {
            return sa(n1);
          }) : G[a1 + ($ ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(O) {
      return O.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !d("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(O) {
      return O.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, p = function P(O) {
    var G = O.activeElement;
    if (G)
      return G.shadowRoot && G.shadowRoot.activeElement !== null ? P(G.shadowRoot) : G;
  }, _ = function P(O) {
    if (O !== !1 && O !== p(document)) {
      if (!O || !O.focus) {
        P(v());
        return;
      }
      O.focus({
        preventScroll: !!l.preventScroll
      }), a.mostRecentlyFocusedNode = O, U$1(O) && O.select();
    }
  }, q = function(O) {
    var G = d("setReturnFocus", O);
    return G || (G === !1 ? !1 : O);
  }, M = function(O) {
    var G = O.target, j = O.event, Q = O.isBackward, i1 = Q === void 0 ? !1 : Q;
    G = G || vh(j), m();
    var h1 = null;
    if (a.tabbableGroups.length > 0) {
      var c1 = u(G, j), M1 = c1 >= 0 ? a.containerGroups[c1] : void 0;
      if (c1 < 0)
        i1 ? h1 = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : h1 = a.tabbableGroups[0].firstTabbableNode;
      else if (i1) {
        var y1 = Kb(a.tabbableGroups, function(w1) {
          var C1 = w1.firstTabbableNode;
          return G === C1;
        });
        if (y1 < 0 && (M1.container === G || oy(G, l.tabbableOptions) && !sa(G, l.tabbableOptions) && !M1.nextTabbableNode(G, !1)) && (y1 = c1), y1 >= 0) {
          var A1 = y1 === 0 ? a.tabbableGroups.length - 1 : y1 - 1, $ = a.tabbableGroups[A1];
          h1 = Ql(G) >= 0 ? $.lastTabbableNode : $.lastDomTabbableNode;
        } else
          To(j) || (h1 = M1.nextTabbableNode(G, !1));
      } else {
        var a1 = Kb(a.tabbableGroups, function(w1) {
          var C1 = w1.lastTabbableNode;
          return G === C1;
        });
        if (a1 < 0 && (M1.container === G || oy(G, l.tabbableOptions) && !sa(G, l.tabbableOptions) && !M1.nextTabbableNode(G)) && (a1 = c1), a1 >= 0) {
          var n1 = a1 === a.tabbableGroups.length - 1 ? 0 : a1 + 1, f1 = a.tabbableGroups[n1];
          h1 = Ql(G) >= 0 ? f1.firstTabbableNode : f1.firstDomTabbableNode;
        } else
          To(j) || (h1 = M1.nextTabbableNode(G));
      }
    } else
      h1 = d("fallbackFocus");
    return h1;
  }, z = function(O) {
    var G = vh(O);
    if (!(u(G, O) >= 0)) {
      if (ro(l.clickOutsideDeactivates, O)) {
        o.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: l.returnFocusOnDeactivate
        });
        return;
      }
      ro(l.allowOutsideClick, O) || O.preventDefault();
    }
  }, b = function(O) {
    var G = vh(O), j = u(G, O) >= 0;
    if (j || G instanceof Document)
      j && (a.mostRecentlyFocusedNode = G);
    else {
      O.stopImmediatePropagation();
      var Q, i1 = !0;
      if (a.mostRecentlyFocusedNode)
        if (Ql(a.mostRecentlyFocusedNode) > 0) {
          var h1 = u(a.mostRecentlyFocusedNode), c1 = a.containerGroups[h1].tabbableNodes;
          if (c1.length > 0) {
            var M1 = c1.findIndex(function(y1) {
              return y1 === a.mostRecentlyFocusedNode;
            });
            M1 >= 0 && (l.isKeyForward(a.recentNavEvent) ? M1 + 1 < c1.length && (Q = c1[M1 + 1], i1 = !1) : M1 - 1 >= 0 && (Q = c1[M1 - 1], i1 = !1));
          }
        } else
          a.containerGroups.some(function(y1) {
            return y1.tabbableNodes.some(function(A1) {
              return Ql(A1) > 0;
            });
          }) || (i1 = !1);
      else
        i1 = !1;
      i1 && (Q = M({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: l.isKeyBackward(a.recentNavEvent)
      })), _(Q || a.mostRecentlyFocusedNode || v());
    }
    a.recentNavEvent = void 0;
  }, x = function(O) {
    var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = O;
    var j = M({
      event: O,
      isBackward: G
    });
    j && (To(O) && O.preventDefault(), _(j));
  }, k = function(O) {
    if (j$1(O) && ro(l.escapeDeactivates, O) !== !1) {
      O.preventDefault(), o.deactivate();
      return;
    }
    (l.isKeyForward(O) || l.isKeyBackward(O)) && x(O, l.isKeyBackward(O));
  }, F = function(O) {
    var G = vh(O);
    u(G, O) >= 0 || ro(l.clickOutsideDeactivates, O) || ro(l.allowOutsideClick, O) || (O.preventDefault(), O.stopImmediatePropagation());
  }, D = function() {
    if (a.active)
      return Yb.activateTrap(s, o), a.delayInitialFocusTimer = l.delayInitialFocus ? Xb(function() {
        _(v());
      }) : _(v()), i.addEventListener("focusin", b, !0), i.addEventListener("mousedown", z, {
        capture: !0,
        passive: !1
      }), i.addEventListener("touchstart", z, {
        capture: !0,
        passive: !1
      }), i.addEventListener("click", F, {
        capture: !0,
        passive: !1
      }), i.addEventListener("keydown", k, {
        capture: !0,
        passive: !1
      }), o;
  }, R = function() {
    if (a.active)
      return i.removeEventListener("focusin", b, !0), i.removeEventListener("mousedown", z, !0), i.removeEventListener("touchstart", z, !0), i.removeEventListener("click", F, !0), i.removeEventListener("keydown", k, !0), o;
  }, V = function(O) {
    var G = O.some(function(j) {
      var Q = Array.from(j.removedNodes);
      return Q.some(function(i1) {
        return i1 === a.mostRecentlyFocusedNode;
      });
    });
    G && _(v());
  }, J = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(V) : void 0, K = function() {
    J && (J.disconnect(), a.active && !a.paused && a.containers.map(function(O) {
      J.observe(O, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(O) {
      if (a.active)
        return this;
      var G = h(O, "onActivate"), j = h(O, "onPostActivate"), Q = h(O, "checkCanFocusTrap");
      Q || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = i.activeElement, G == null || G();
      var i1 = function() {
        Q && m(), D(), K(), j == null || j();
      };
      return Q ? (Q(a.containers.concat()).then(i1, i1), this) : (i1(), this);
    },
    deactivate: function(O) {
      if (!a.active)
        return this;
      var G = Wb({
        onDeactivate: l.onDeactivate,
        onPostDeactivate: l.onPostDeactivate,
        checkCanReturnFocus: l.checkCanReturnFocus
      }, O);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, R(), a.active = !1, a.paused = !1, K(), Yb.deactivateTrap(s, o);
      var j = h(G, "onDeactivate"), Q = h(G, "onPostDeactivate"), i1 = h(G, "checkCanReturnFocus"), h1 = h(G, "returnFocus", "returnFocusOnDeactivate");
      j == null || j();
      var c1 = function() {
        Xb(function() {
          h1 && _(q(a.nodeFocusedBeforeActivation)), Q == null || Q();
        });
      };
      return h1 && i1 ? (i1(q(a.nodeFocusedBeforeActivation)).then(c1, c1), this) : (c1(), this);
    },
    pause: function(O) {
      if (a.paused || !a.active)
        return this;
      var G = h(O, "onPause"), j = h(O, "onPostPause");
      return a.paused = !0, G == null || G(), R(), K(), j == null || j(), this;
    },
    unpause: function(O) {
      if (!a.paused || !a.active)
        return this;
      var G = h(O, "onUnpause"), j = h(O, "onPostUnpause");
      return a.paused = !1, G == null || G(), m(), D(), K(), j == null || j(), this;
    },
    updateContainerElements: function(O) {
      var G = [].concat(O).filter(Boolean);
      return a.containers = G.map(function(j) {
        return typeof j == "string" ? i.querySelector(j) : j;
      }), a.active && m(), K(), this;
    }
  }, o.updateContainerElements(e), o;
};
class Sw {
  constructor(e, {
    stickySelector: n = "[data-ecl-inpage-navigation]",
    containerSelector: i = "[data-ecl-inpage-navigation-container]",
    inPageList: s = "[data-ecl-inpage-navigation-list]",
    spySelector: l = "[data-ecl-inpage-navigation-link]",
    toggleSelector: a = "[data-ecl-inpage-navigation-trigger]",
    linksSelector: o = "[data-ecl-inpage-navigation-link]",
    spyActiveContainer: h = "ecl-inpage-navigation--visible",
    spyOffset: u = 20,
    spyClass: d = "ecl-inpage-navigation__item--active",
    spyTrigger: v = "[data-ecl-inpage-navigation-trigger-current]",
    attachClickListener: m = !0,
    attachKeyListener: p = !0,
    contentClass: _ = "inpage-navigation__heading--active"
  } = {}) {
    /**
     * An array of supported events for this component.
     *
     * @type {Array<string>}
     * @event onToggle
     *   Triggered when the list is toggled in mobile
     * @event onClick
     *   Triggered when an item is clicked
     * @memberof InpageNavigation
     */
    O2(this, "supportedEvents", ["onToggle", "onClick"]);
    if (!e || e.nodeType !== Node.ELEMENT_NODE)
      throw new TypeError(
        "DOM element should be given to initialize this widget."
      );
    this.element = e, this.eventManager = new M$1(), this.attachClickListener = m, this.attachKeyListener = p, this.stickySelector = n, this.containerSelector = i, this.toggleSelector = a, this.linksSelector = o, this.inPageList = s, this.spyActiveContainer = h, this.spySelector = l, this.spyOffset = u, this.spyClass = d, this.spyTrigger = v, this.contentClass = _, this.gumshoe = null, this.observer = null, this.stickyObserver = null, this.isExpanded = !1, this.handleClickOnToggler = this.handleClickOnToggler.bind(this), this.handleClickOnLink = this.handleClickOnLink.bind(this), this.handleKeyboard = this.handleKeyboard.bind(this), this.initScrollSpy = this.initScrollSpy.bind(this), this.initObserver = this.initObserver.bind(this), this.activateScrollSpy = this.activateScrollSpy.bind(this), this.deactivateScrollSpy = this.deactivateScrollSpy.bind(this), this.destroySticky = this.destroySticky.bind(this), this.destroyScrollSpy = this.destroyScrollSpy.bind(this), this.destroyObserver = this.destroyObserver.bind(this), this.openList = this.openList.bind(this), this.closeList = this.closeList.bind(this);
  }
  /**
   * @static
   * Shorthand for instance creation and initialisation.
   *
   * @param {HTMLElement} root DOM element for component instantiation and scope
   *
   * @return {InpageNavigation} An instance of InpageNavigation.
   */
  static autoInit(e, { INPAGE_NAVIGATION: n = {} } = {}) {
    const i = new Sw(e, n);
    return i.init(), e.ECLInpageNavigation = i, i;
  }
  // ACTIONS
  /**
   * Initiate sticky behaviors.
   */
  initSticky() {
    this.stickyInstance = new q$1.Sticky(this.element);
  }
  /**
   * Destroy sticky behaviors.
   */
  destroySticky() {
    this.stickyInstance && this.stickyInstance.remove();
  }
  /**
   * Initiate scroll spy behaviors.
   */
  initScrollSpy() {
    if (this.gumshoe = new z$1(this.spySelector, {
      navClass: this.spyClass,
      contentClass: this.contentClass,
      offset: this.spyOffset,
      reflow: !0
    }), document.addEventListener("gumshoeActivate", this.activateScrollSpy, !1), document.addEventListener(
      "gumshoeDeactivate",
      this.deactivateScrollSpy,
      !1
    ), "IntersectionObserver" in window) {
      const e = e0(this.containerSelector);
      if (e) {
        let n = 0, i = 0, s = !1;
        this.stickyObserver = new IntersectionObserver(
          (l) => {
            if (l && l[0]) {
              const a = l[0], o = a.boundingClientRect.y, h = a.intersectionRatio, { isIntersecting: u } = a;
              if (!s) {
                s = !0, n = o, i = h;
                return;
              }
              o < n ? h > i && u || this.element.classList.remove(this.spyActiveContainer) : o > n && u && h > i && this.element.classList.add(this.spyActiveContainer), n = o, i = h;
            }
          },
          { root: null }
        ), this.stickyObserver.observe(e);
      }
    }
  }
  /**
   * Activate scroll spy behaviors.
   *
   * @param {Event} event
   */
  activateScrollSpy(e) {
    const n = e0(this.spyTrigger);
    this.element.classList.add(this.spyActiveContainer), n.textContent = e.detail.content.textContent;
  }
  /**
   * Deactivate scroll spy behaviors.
   */
  deactivateScrollSpy() {
    const e = e0(this.spyTrigger);
    this.element.classList.remove(this.spyActiveContainer), e.innerHTML = "";
  }
  /**
   * Destroy scroll spy behaviors.
   */
  destroyScrollSpy() {
    this.stickyObserver && this.stickyObserver.disconnect(), document.removeEventListener(
      "gumshoeActivate",
      this.activateScrollSpy,
      !1
    ), document.removeEventListener(
      "gumshoeDeactivate",
      this.deactivateScrollSpy,
      !1
    ), this.gumshoe.destroy();
  }
  /**
   * Initiate observer.
   */
  initObserver() {
    if ("MutationObserver" in window) {
      const e = this;
      this.observer = new MutationObserver((n) => {
        const i = e0(".ecl-col-l-9"), s = e0("[data-ecl-inpage-navigation-list]");
        n.forEach((l) => {
          l && l.target && l.target.classList && !l.target.classList.contains(
            "ecl-inpage-navigation__trigger-current"
          ) && (l.addedNodes.length > 0 && [].slice.call(l.addedNodes).forEach((a) => {
            if (a.tagName === "H2" && a.id) {
              const h = Ub("h2[id]", i).findIndex(
                (d) => d.id === a.id
              ), u = s.childNodes[h - 1].cloneNode(
                !0
              );
              u.childNodes[0].textContent = a.textContent, u.childNodes[0].href = `#${a.id}`, s.childNodes[h - 1].after(u);
            }
          }), l.removedNodes.length > 0 && [].slice.call(l.removedNodes).forEach((a) => {
            a.tagName === "H2" && a.id && s.childNodes.forEach((o) => {
              o.childNodes[0].href.indexOf(a.id) !== -1 && o.remove();
            });
          }), e.update());
        });
      }), this.observer.observe(document, {
        subtree: !0,
        childList: !0
      });
    }
  }
  /**
   * Destroy observer.
   */
  destroyObserver() {
    this.observer && this.observer.disconnect();
  }
  /**
   * Initialise component.
   */
  init() {
    if (!ECL)
      throw new TypeError("Called init but ECL is not present");
    ECL.components = ECL.components || /* @__PURE__ */ new Map();
    const e = e0(this.toggleSelector, this.element), n = Ub(this.linksSelector, this.element);
    this.initSticky(this.element), this.initScrollSpy(), this.initObserver(), this.focusTrap = X$1(this.element, {
      onActivate: () => this.openList(),
      onDeactivate: () => this.closeList()
    }), this.attachClickListener && e && e.addEventListener("click", this.handleClickOnToggler), this.attachClickListener && n && (n.forEach(
      (i) => i.addEventListener("click", this.handleClickOnLink)
    ), this.element.addEventListener("keydown", this.handleShiftTab), e.addEventListener("click", this.handleClickOnToggler)), document.addEventListener("keydown", this.handleKeyboard), this.element.setAttribute("data-ecl-auto-initialized", "true"), ECL.components.set(this.element, this);
  }
  /**
   * Register a callback function for a specific event.
   *
   * @param {string} eventName - The name of the event to listen for.
   * @param {Function} callback - The callback function to be invoked when the event occurs.
   * @returns {void}
   * @memberof InpageNavigation
   * @instance
   *
   * @example
   * // Registering a callback for the 'onToggle' event
   * inpage.on('onToggle', (event) => {
   *   console.log('Toggle event occurred!', event);
   * });
   */
  on(e, n) {
    this.eventManager.on(e, n);
  }
  /**
   * Trigger a component event.
   *
   * @param {string} eventName - The name of the event to trigger.
   * @param {any} eventData - Data associated with the event.
   * @memberof InpageNavigation
   */
  trigger(e, n) {
    this.eventManager.trigger(e, n);
  }
  /**
   * Update scroll spy instance.
   */
  update() {
    this.gumshoe.setup();
  }
  /**
   * Open mobile list link.
   */
  openList() {
    const e = e0(this.inPageList, this.element), n = e0(this.toggleSelector, this.element);
    e.classList.add("ecl-inpage-navigation__list--visible"), n.setAttribute("aria-expanded", "true");
  }
  /**
   * Close mobile list link.
   */
  closeList() {
    const e = e0(this.inPageList, this.element), n = e0(this.toggleSelector, this.element);
    e.classList.remove("ecl-inpage-navigation__list--visible"), n.setAttribute("aria-expanded", "false");
  }
  /**
   * Invoke event listeners on toggle click.
   *
   * @param {Event} e
   */
  handleClickOnToggler(e) {
    const n = e0(this.toggleSelector, this.element);
    e.preventDefault(), this.isExpanded = n.getAttribute("aria-expanded") === "true", n.setAttribute(
      "aria-expanded",
      this.isExpanded ? "false" : "true"
    ), this.isExpanded ? this.focusTrap.deactivate() : this.focusTrap.activate(), this.trigger("onToggle", { isExpanded: this.isExpanded });
  }
  /**
   * Sets the necessary attributes to collapse inpage navigation list.
   *
   * @param {Event} e
   */
  handleClickOnLink(e) {
    const { href: n } = e.target;
    let i = null;
    if (n) {
      const l = n.split("#")[1];
      l && (i = e0(`#${l}`, document));
    }
    this.focusTrap.deactivate();
    const s = { target: i || n, e };
    this.trigger("onClick", s);
  }
  /**
   * Handle keyboard
   *
   * @param {Event} e
   */
  handleKeyboard(e) {
    const n = e.target;
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const i = n.parentElement.previousSibling;
      if (i && i.classList.contains("ecl-inpage-navigation__item")) {
        const s = e0(this.linksSelector, i);
        s && s.focus();
      }
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const i = n.parentElement.nextSibling;
      if (i && i.classList.contains("ecl-inpage-navigation__item")) {
        const s = e0(this.linksSelector, i);
        s && s.focus();
      }
    }
  }
  /**
   * Destroy component instance.
   */
  destroy() {
    this.attachClickListener && this.toggleElement && this.toggleElement.removeEventListener(
      "click",
      this.handleClickOnToggler
    ), this.attachClickListener && this.navLinks && this.navLinks.forEach(
      (e) => e.removeEventListener("click", this.handleClickOnLink)
    ), this.attachKeyListener && document.removeEventListener("keydown", this.handleKeyboard), this.destroyScrollSpy(), this.destroySticky(), this.destroyObserver(), this.element && (this.element.removeAttribute("data-ecl-auto-initialized"), ECL.components.delete(this.element));
  }
}
const K$1 = c2({
  name: "InPageNavigationPageBuilder",
  components: {
    EclIcon: Ie
  },
  props: {
    title: {
      type: String,
      required: !1,
      default: () => "ECLV3.IN_PAGE_NAVIGATION.TITLE"
    },
    items: {
      type: Array,
      required: !0
    }
  },
  setup(t) {
    const { t: e } = js(), n = D1();
    let i;
    const s = g1(() => t.items.map((l) => {
      let a = H(l.url);
      const o = window.location.pathname;
      return a != null && a.startsWith("#") && !a.includes(o) && (a = `${window.location.pathname}${window.location.search}${a}`), {
        ...l,
        url: a,
        label: e(l.label)
      };
    }));
    return d0(() => {
      l3(
        s,
        (a) => {
          (a == null ? void 0 : a.length) > 0 && (i && i.destroy(), i = Sw.autoInit(H(n)));
        },
        { immediate: !0 }
      );
      const l = window.location.hash.substring(1);
      if (l) {
        const a = document.getElementById(l);
        a && a.scrollIntoView();
      }
    }), {
      eclInPageRoot: n,
      extendedItemList: s
    };
  }
}), Z$1 = (t) => ($s("data-v-b057022e"), t = t(), Us(), t), J$1 = {
  class: "ecl-inpage-navigation",
  ref: "eclInPageRoot",
  "aria-labelledby": "ecl-inpage-navigation-default"
}, Q$1 = ["innerHTML"], eU1 = { class: "ecl-inpage-navigation__body" }, tU1 = { class: "ecl-inpage-navigation__trigger-wrapper" }, nU1 = {
  type: "button",
  class: "ecl-inpage-navigation__trigger",
  id: "ecl-inpage-navigation-default-trigger",
  "data-ecl-inpage-navigation-trigger": "true",
  "aria-controls": "ecl-inpage-navigation-list",
  "aria-expanded": "false"
}, iU1 = /* @__PURE__ */ Z$1(() => /* @__PURE__ */ C("span", {
  class: "ecl-inpage-navigation__trigger-current",
  "data-ecl-inpage-navigation-trigger-current": "true"
}, null, -1)), sU1 = {
  class: "ecl-inpage-navigation__list",
  "data-ecl-inpage-navigation-list": "true",
  id: "ecl-inpage-navigation-default-list"
}, lU1 = ["href", "aria-label"];
function rU1(t, e, n, i, s, l) {
  const a = V2("EclIcon");
  return T(), N("nav", J$1, [
    C("div", {
      class: "ecl-inpage-navigation__title",
      id: "ecl-inpage-navigation-default",
      innerHTML: t.$t(t.title)
    }, null, 8, Q$1),
    C("div", eU1, [
      C("div", tU1, [
        C("button", nU1, [
          iU1,
          _3(a, {
            rotate: 180,
            class: "ecl-inpage-navigation__trigger-icon",
            icon: "corner-arrow",
            focusable: "false",
            "aria-hidden": "false",
            role: "img"
          })
        ])
      ]),
      C("ul", sU1, [
        (T(!0), N(I3, null, Ve(t.extendedItemList, (o, h) => (T(), N("li", {
          class: "ecl-inpage-navigation__item",
          key: h
        }, [
          C("a", {
            href: o.url,
            class: "ecl-link ecl-inpage-navigation__link",
            target: "_self",
            "aria-label": o.label,
            "data-ecl-inpage-navigation-link": ""
          }, [
            C("span", null, pt(o.label), 1)
          ], 8, lU1)
        ]))), 128))
      ])
    ])
  ], 512);
}
const aU1 = /* @__PURE__ */ Le(K$1, [["render", rU1], ["__scopeId", "data-v-b057022e"]]), oU1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: aU1
}, Symbol.toStringTag, { value: "Module" })), cU1 = () => Promise.resolve().then(() => oU1);
function hU1(t) {
  const { mapSettings: e } = s3(t), n = D1(), i = D1({}), s = D1([]), l = {
    center: jo([-0.09, 51.505]),
    zoom: 3.6
  }, a = pc({
    view: {
      minZoom: 0,
      maxZoom: 12,
      ...l,
      projection: "EPSG:3857",
      padding: [30, 30, 30, 30]
    },
    customInteraction: {
      desktop: {
        useWheelPlatformKey: !0
      }
    }
  }), o = g1(() => s1.merge({}, H(a), u(), H(i))), h = () => {
    var m, p, _, q, M, z, b;
    const d = H(e), v = H(n);
    if (v) {
      const x = v.mapInstance;
      if (((m = d == null ? void 0 : d.extra) == null ? void 0 : m.fitMode) === "features") {
        let k;
        x.getLayers().forEach(function(F) {
          const D = F.getSource();
          if (D instanceof EC) {
            const R = D.getExtent();
            s1.isNil(k) && (k = R), j_(k, R);
          }
        }), k && x.getView().fit(k, {
          size: x.getSize(),
          // @ts-ignore
          padding: ((_ = (p = H(o)) == null ? void 0 : p.view) == null ? void 0 : _.padding) ?? 0
        });
      } else
        x.getView().setCenter(((M = (q = H(o)) == null ? void 0 : q.view) == null ? void 0 : M.center) ?? l.center), x.getView().setZoom(((b = (z = H(o)) == null ? void 0 : z.view) == null ? void 0 : b.zoom) ?? l.zoom);
    }
  }, u = () => {
    var m, p, _, q, M;
    const d = H(e);
    (m = d == null ? void 0 : d.view) != null && m.center && (d.view.center = jo(d.view.center));
    const v = {
      ...d
    };
    if ((_ = (p = d == null ? void 0 : d.olSettings) == null ? void 0 : p.homeControl) != null && _.enabled) {
      const z = ((M = (q = v == null ? void 0 : v.olSettings) == null ? void 0 : q.extra) == null ? void 0 : M.controls) ?? [];
      z.push(new cC1(h)), s1.merge(v, { olSettings: { extra: { controls: z } } });
    }
    return v;
  };
  return {
    mapElement: n,
    currentMapSettings: o,
    coordinateOfFeatures: s,
    fitMap: h
  };
}
class uU1 {
  constructor(e, n) {
    O2(this, "markerLayerList", {});
    this.props = e, this.mapElement = n, this.makeLayer();
  }
  /**
   * Genera il layer Circle
   *
   * @param {MarkerStyleCircle} item
   * @returns {Object}
   */
  makeCircleLayer(e) {
    const n = new Ju({
      color: e.fill
    }), i = new gq({
      color: e.stroke,
      width: 1.25
    });
    return {
      image: new zq({
        fill: n,
        stroke: i,
        radius: 10
      }),
      fill: n,
      stroke: i
    };
  }
  /**
   * Genera il layer Image
   *
   * @param {MarkerStyleCircle} item
   * @returns {Object}
   */
  makeImageLayer(e) {
    return {
      image: new Eq({
        anchor: e.anchor,
        src: e.src
      })
    };
  }
  /**
   * Genera i layer in base alle tipologie degli stili
   */
  makeLayer() {
    var n, i;
    const e = s1.uniqBy((i = (n = this == null ? void 0 : this.props) == null ? void 0 : n.markers) == null ? void 0 : i.styles, "featureType");
    s1.each(e, (s) => {
      var o, h;
      let l;
      switch (s.type) {
        case "circle":
          l = this.makeCircleLayer(s);
          break;
        case "image":
          l = this.makeImageLayer(s);
          break;
      }
      const a = new Fq1({
        source: new EC(),
        style: new So(l)
      });
      (h = (o = H(this.mapElement)) == null ? void 0 : o.mapInstance) == null || h.addLayer(a), s1.assign(this.markerLayerList, { [s.featureType]: a });
    });
  }
  /**
   * Restituisce il layer in base alla tipologia passata
   *
   * @param {string} featuretype
   * @returns {VectorLayer<VectorSource>}
   */
  getLayer(e) {
    return this.markerLayerList[e];
  }
}
function dU1(t, e) {
  const n = D1([]), i = t.markers, s = e.mapInit, l = e.mapSettings, a = l.mapElement, o = l.coordinateOfFeatures, h = () => {
    const d = e9.getConfig("map");
    return new Promise((v, m) => {
      var _;
      let p = i.request.url;
      I_(p) === !1 && (p = `${d == null ? void 0 : d.urlBasePath}/${i.request.url}`), fetch(p, ((_ = i.request) == null ? void 0 : _.options) ?? {}).then(
        (q) => v(q.json()),
        (q) => {
          const M = `Error to fetch url: ${p}. Error: ${q}`;
          m(M);
        }
      );
    });
  }, u = async () => {
    const d = await h();
    n.value = d.features;
    const v = new uU1(t, a);
    s1.each(H(n), (m) => {
      var q, M;
      const p = new Yu({
        ...m.properties,
        geometry: new Yo(jo(m.geometry.coordinates))
      }), _ = p.getGeometry();
      _ && o.value.push(_.getExtent()), (M = (q = v.getLayer(m.properties.type)) == null ? void 0 : q.getSource()) == null || M.addFeature(p);
    }), l.fitMap();
  };
  return l3(
    [s, a],
    ([d, v]) => {
      d && v && u();
    },
    { immediate: !0 }
  ), {};
}
function fU1(t, e) {
  const n = D1();
  let i;
  const s = e.mapSettings.mapElement, l = e.mapInit, a = () => {
    i.setPosition(void 0);
  }, o = () => {
    var u;
    const h = H(n);
    if (h) {
      const d = h.querySelector("[overlay-close]"), v = document.querySelector("[overlay-content]");
      i = new Yw1({
        element: h,
        autoPan: {
          animation: {
            duration: 250
          }
        }
      }), d.addEventListener("click", () => (a(), d.blur(), !1));
      const m = (u = H(s)) == null ? void 0 : u.mapInstance;
      m && (m.on("pointermove", function(p) {
        const _ = m.getEventPixel(p.originalEvent), q = m.hasFeatureAtPixel(_);
        m.getTarget().style.cursor = q ? "pointer" : "";
      }), m.on("singleclick", (p) => {
        var M, z;
        const _ = p.coordinate, q = m.forEachFeatureAtPixel(p.pixel, (b) => b);
        if (q) {
          const x = s1.template((z = (M = t.markers) == null ? void 0 : M.overlay) == null ? void 0 : z.content)(q.getProperties());
          v.innerHTML = x, i.setPosition(_);
        } else
          a();
      }), m.addOverlay(i));
    }
  };
  return l3(
    [l, s, n],
    ([h, u, d]) => {
      var v, m, p, _;
      h && u && d && (m = (v = t.markers) == null ? void 0 : v.overlay) != null && m.enabled && (_ = (p = t.markers) == null ? void 0 : p.overlay) != null && _.content && o();
    },
    { immediate: !0 }
  ), {
    mapElementOverlay: n
  };
}
const vU1 = c2({
  name: "MapPageBuilder",
  components: { JclMap: Ok, EclButton: Lt },
  props: {
    height: {
      required: !1,
      type: String,
      default: "600px"
    },
    markers: {
      required: !1,
      type: Object
    },
    mapSettings: {
      required: !1,
      type: Object
    }
  },
  setup(t) {
    const e = D1(!1), n = hU1(t);
    t.markers && dU1(t, { mapInit: e, mapSettings: n });
    const i = fU1(t, {
      mapInit: e,
      mapSettings: n
    });
    return {
      EclButtonType: I4,
      EclButtonIconPosition: di,
      onMapMounted: () => {
        e.value = !0;
      },
      ...n,
      ...i
    };
  }
}), pU1 = (t) => ($s("data-v-57b25da2"), t = t(), Us(), t), mU1 = {
  class: "map-page-builder__overlay",
  ref: "mapElementOverlay"
}, gU1 = /* @__PURE__ */ pU1(() => /* @__PURE__ */ C("div", { "overlay-content": "" }, null, -1));
function yU1(t, e, n, i, s, l) {
  const a = V2("jcl-map"), o = V2("ecl-button");
  return T(), N("div", {
    class: "map-page-builder",
    style: Rt(`height: ${t.height};`)
  }, [
    _3(a, {
      ref: "mapElement",
      settings: t.currentMapSettings,
      onMounted: t.onMapMounted
    }, null, 8, ["settings", "onMounted"]),
    C("div", mU1, [
      _3(o, {
        "overlay-close": "",
        icon: "close-filled",
        iconPosition: t.EclButtonIconPosition.Before,
        iconContainerClass: "ecl-modal__close-container",
        ariaLabel: t.$t("ecl.general.close"),
        type: t.EclButtonType.Text
      }, null, 8, ["iconPosition", "ariaLabel", "type"]),
      gU1
    ], 512)
  ], 4);
}
const _U1 = /* @__PURE__ */ Le(vU1, [["render", yU1], ["__scopeId", "data-v-57b25da2"]]), qU1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _U1
}, Symbol.toStringTag, { value: "Module" })), wU1 = () => Promise.resolve().then(() => qU1), zU1 = c2({
  name: "TabsNavigationPageBuilder",
  components: {
    EclIcon: Ie,
    EclButton: Lt,
    AppLink: ui
  },
  props: {
    id: {
      type: Number,
      required: !0
    }
  },
  setup(t) {
    const { id: e } = s3(t), n = e9.getConfig("tabsNavigation"), i = D1([]), s = (a) => {
      const o = n.urlApi, h = `{
        contextMenu(contextId: ${a}) {
          items
          context {
            name
          }
        }
      }`, u = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          query: h
        })
      };
      return fetch(o, u).then((d) => {
        if (!d.ok)
          throw new Error(`@TabsNavigationPageBuilder an error has occured: ${d.status}`);
        return d.json();
      }).catch((d) => {
        throw new Error(d);
      });
    }, l = async () => {
      const a = await s(H(e));
      i.value = s1.map(a.data.contextMenu.items, (o) => ({
        label: o.label,
        to: o.to
      }));
    };
    return l3(
      e,
      () => {
        l();
      },
      { immediate: !0 }
    ), {
      items: i
    };
  }
}), MU1 = {
  class: "ecl-tabs",
  "data-ecl-tabs": "true",
  "data-ecl-auto-init": "Tabs"
}, bU1 = { class: "ecl-tabs__container" }, LU1 = {
  class: "ecl-tabs__list",
  role: "tablist"
};
function xU1(t, e, n, i, s, l) {
  const a = V2("AppLink");
  return T(), N("nav", MU1, [
    C("div", bU1, [
      C("ul", LU1, [
        (T(!0), N(I3, null, Ve(t.items, (o, h) => (T(), N("li", {
          class: "ecl-tabs__item",
          role: "presentation",
          key: o.to
        }, [
          (T(), v2(a, {
            key: h,
            class: "ecl-link ecl-tabs__link",
            "active-class": "ecl-tabs__link--active",
            to: o.to,
            isExternalLink: !1,
            innerHTML: o.label
          }, null, 8, ["to", "innerHTML"]))
        ]))), 128))
      ])
    ])
  ]);
}
const SU1 = /* @__PURE__ */ Le(zU1, [["render", xU1], ["__scopeId", "data-v-f6a727b1"]]), CU1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SU1
}, Symbol.toStringTag, { value: "Module" })), kU1 = () => Promise.resolve().then(() => CU1), er = class er {
  /**
   * Creates an instance of JclPageBuilderManager.
   *
   * @private
   * @param {JclPageBuilderManagerConfig} [config] - Initial configuration settings.
   * @throws Will throw an error if the constructor is called more than once.
   */
  constructor(e) {
    /**
     * Tracks whether the page has already been processed.
     *
     * @type {Ref<boolean>}
     */
    O2(this, "alreadyProcessed", D1(!1));
    /**
     * Holds the current configuration settings.
     *
     * @private
     * @type {JclPageBuilderManagerConfig}
     */
    O2(this, "config", {
      image: {
        urlBasePath: "https://urban.jrc.ec.europa.eu/static/sites"
      },
      map: {
        urlBasePath: "https://urban.jrc.ec.europa.eu/static/"
      },
      tabsNavigation: {
        urlApi: "https://urban.jrc.ec.europa.eu/api/private"
      }
    });
    /**
     * Default components provided by the manager.
     *
     * @private
     * @type {JclPageBuilderManagerComponents}
     */
    O2(this, "defaultComponent", {
      Title: r5(ZH1),
      Text: r5(nD1),
      Icon: r5(aD1),
      Iframe: r5(fD1),
      Image: r5(_D1),
      Span: r5(LD1),
      Html: r5(AD1),
      Button: r5(BD1),
      ParagraphMoreLess: r5($D1),
      CollapseList: r5(QD1),
      ComponentCollection: r5(s$1),
      Expandable: r5(f$1),
      WrapperComponent: r5(y$1),
      InPageNavigation: r5(cU1),
      Map: r5(wU1),
      TabsNavigation: r5(kU1)
    });
    /**
    * Custom components added by the user.
    *
    * @private
    * @type {JclPageBuilderManagerComponents}
    */
    O2(this, "customComponents", {});
    if (this.updateConfig(e ?? {}), er._instance)
      throw new Error("Error: Instantiation failed: Use JclPageBuilderManager.getInstance() instead of new.");
    er._instance = this;
  }
  /**
  * Retrieves the singleton instance of the JclPageBuilderManager.
  *
  * @returns {JclPageBuilderManager} The singleton instance.
  */
  static getInstance() {
    return er._instance;
  }
  /**
   * Updates the configuration settings.
   *
   * @param {JclPageBuilderManagerConfig} config - New configuration settings.
   */
  updateConfig(e) {
    this.config = s1.defaultsDeep(e, this.config);
  }
  /**
   * Get the configuration settings by key name.
   *
   * @param {keyof JclPageBuilderManagerConfig} name - New configuration settings.
   */
  getConfig(e) {
    if (e in this.config)
      return this.config[e];
  }
  /**
   * Registers a custom component.
   *
   * @param {string} name - The name of the component.
   * @param {Component} cmp - The Vue component to register.
   */
  registerCustomComponent(e, n) {
    e in this.defaultComponent, e in this.customComponents || Object.assign(this.customComponents, { [e]: n });
  }
  /**
   * Registers multiple custom components.
   *
   * @param {JclPageBuilderManagerComponents} data - An object containing custom components to register.
   */
  registerCustomComponents(e) {
    Object.assign(this.customComponents, e);
  }
  /**
   * Retrieves a component by its name.
   *
   * @param {string} name - The name of the component.
   * @returns {Component | null} The Vue component if found, otherwise null.
   */
  getComponent(e) {
    return e in this.customComponents ? this.customComponents[e] : e in this.defaultComponent ? this.defaultComponent[e] : null;
  }
  /**
   * Check if a component exist by its name.
   *
   * @param {string} name - The name of the component.
   * @returns {boolean}
   */
  componentExist(e) {
    return e in this.defaultComponent || e in this.customComponents;
  }
};
/**
 * The singleton instance of the JclPageBuilderManager.
 *
 * @private
 */
O2(er, "_instance", new er());
let z_ = er;
const e9 = z_.getInstance(), EU1 = c2({
  name: "PageBuilderComponent",
  components: {
    Row: xw
  },
  props: {
    sections: {
      required: !0
    }
  }
});
function AU1(t, e, n, i, s, l) {
  const a = V2("row"), o = V2("ecl-container");
  return T(!0), N(I3, null, Ve(t.sections, (h, u) => (T(), N("section", Ht({
    class: "section",
    key: u
  }, h.props), [
    h.container ? (T(), v2(o, { key: 0 }, {
      default: Q2(() => [
        (T(!0), N(I3, null, Ve(h.rows, (d, v) => (T(), v2(a, Ht({
          key: v,
          row: d
        }, d.props), null, 16, ["row"]))), 128))
      ]),
      _: 2
    }, 1024)) : (T(!0), N(I3, { key: 1 }, Ve(h.rows, (d, v) => (T(), v2(a, {
      key: v,
      row: d
    }, null, 8, ["row"]))), 128))
  ], 16))), 128);
}
const mj1 = /* @__PURE__ */ Le(EU1, [["render", AU1], ["__scopeId", "data-v-86798b1c"]]);
function FU1(t, e) {
  const { teleportSettings: n, strategy: i } = s3(t), s = e.isMobile, l = {
    when: g1(() => H(s) && H(i) === "sticky"),
    where: "body"
  }, a = pc({});
  return l3(n, (o) => {
    Object.assign(a, s1.defaults(o, l));
  }, {
    immediate: !0,
    deep: !0
  }), {
    teleportOpts: a
  };
}
function TU1(t) {
  const { navItems: e } = s3(t), n = pc([]), i = S8(), s = () => {
    s1.map(n, (h) => h.current = !1);
  }, l = () => {
    const h = [];
    s1.each(H(e), (u) => {
      h.push({
        label: u.label,
        icon: u.icon,
        current: (u == null ? void 0 : u.current) ?? !1,
        to: a(u),
        on: {
          click: u == null ? void 0 : u.click
        }
      });
    }), Object.assign(n, h);
  }, a = (h) => {
    var d;
    const u = H(h.to);
    if (u) {
      const v = i.resolve(u);
      return ((d = v == null ? void 0 : v.matched) == null ? void 0 : d.length) > 0 ? v.fullPath : u;
    }
  }, o = (h, u) => {
    s(), u.current = !0;
  };
  return l3(e, () => {
    l();
  }, { immediate: !0, deep: !0 }), {
    navItemExtendedList: n,
    itemClick: o
  };
}
const IU1 = c2({
  name: "JclDynamicNavigator",
  components: {
    AppLink: ui
  },
  props: {
    /**
     * The name of the component.
     * @type {string|null}
     */
    name: {
      type: String,
      required: !1,
      default: null
    },
    /**
     * An array of navigation items.
     * @type {Array<JclDynamicNavigatorItem>}
     */
    navItems: {
      type: Object,
      required: !0,
      default: []
    },
    /**
     * Strategy used for positioning the component.
     * @type {string}
     * @default 'sticky'
     */
    strategy: {
      type: String,
      required: !1,
      default: () => "sticky"
    },
    /**
     * The breakpoint for mobile devices.
     * @type {number}
     * @default 768
     */
    mobileBreakpoint: {
      type: Number,
      required: !1,
      default: () => 768
    },
    /**
     * Settings for teleport functionality.
     * @type {JclDynamicNavigatorTeleportSettings}
     */
    teleportSettings: {
      type: Object,
      required: !1
    },
    /**
     * The theme of the component.
     * @type {string}
     * @default 'dark'
     */
    theme: {
      type: String,
      required: !1,
      default: "dark"
    },
    /**
     * Define if need to generate an internal navigation and automatic check for the current item
     * @type {boolean}
     * @default true
     */
    isNavigation: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(t) {
    const { strategy: e } = s3(t), n = D1(), i = D1(), s = D1(), l = D1(), a = D1(!1), o = FU1(t, { isMobile: a }), h = TU1(t), u = g1(() => H(a) ? "mobile" : "desktop"), d = g1(() => {
      const m = H(i), p = H(s);
      return m && p && (p == null ? void 0 : p.children.length) > 0 && H(a) === !1 && H(e) === "sticky" ? `min-height: ${m.getBoundingClientRect().height + p.children[0].getBoundingClientRect().height + 30}px` : "";
    }), v = () => {
      const m = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      a.value = m <= t.mobileBreakpoint;
    };
    return l3([l, d, e], () => {
      const m = H(l), p = H(n);
      m && p && D0(() => {
        p != null && p.parentElement && (H(a) === !1 && H(e) === "sticky" ? p.parentElement.style.setProperty("min-height", `${m.getBoundingClientRect().height}px`) : p.parentElement.style.removeProperty("min-height"));
      });
    }), d0(() => {
      window.addEventListener("resize", v), v();
    }), mn(() => {
      window.removeEventListener("resize", v);
    }), {
      dynamicNavigatorEl: n,
      dynamicNavigatorElNav: i,
      dynamicNavigatorElName: s,
      dynamicNavigatorWrapperEl: l,
      isMobile: a,
      responsiveType: u,
      styles: d,
      ...o,
      ...h
    };
  }
}), OU1 = (t) => ($s("data-v-3e5117ec"), t = t(), Us(), t), NU1 = { class: "dynamic-navigator__navigation_wrapper" }, PU1 = {
  class: "dynamic-navigator__navigation",
  ref: "dynamicNavigatorElNav",
  role: "tablist"
}, BU1 = ["innerHTML"], VU1 = { class: "dynamic-navigator__link-label" }, RU1 = ["href", "onClick"], HU1 = ["innerHTML"], DU1 = { class: "dynamic-navigator__link-label" }, $U1 = {
  key: 0,
  class: "dynamic-navigator__name",
  ref: "dynamicNavigatorElName"
}, UU1 = /* @__PURE__ */ OU1(() => /* @__PURE__ */ C("div", { class: "dynamic-navigator--padder" }, null, -1));
function jU1(t, e, n, i, s, l) {
  const a = V2("app-link");
  return T(), v2(lL, {
    to: t.teleportOpts.where,
    disabled: !t.teleportOpts.when
  }, [
    C("div", {
      ref: "dynamicNavigatorEl",
      class: f2(["dynamic-navigator", {
        [`dynamic-navigator--device-type-${t.responsiveType}`]: !0,
        [`dynamic-navigator--theme-${t.theme}`]: !0,
        [`dynamic-navigator--strategy-${t.strategy}`]: !0,
        "dynamic-navigator--teleported": t.teleportOpts.when
      }]),
      style: Rt(t.styles)
    }, [
      C("div", {
        ref: "dynamicNavigatorWrapperEl",
        class: "dynamic-navigator__wrapper",
        style: Rt(t.styles)
      }, [
        C("div", NU1, [
          C("ul", PU1, [
            (T(!0), N(I3, null, Ve(t.navItemExtendedList, (o, h) => (T(), N("li", {
              class: "dynamic-navigator__item",
              key: h
            }, [
              o.to && t.isNavigation ? (T(), v2(a, Ht({
                role: "tab",
                key: h,
                class: "dynamic-navigator__link",
                "active-class": "current",
                isExternalLink: !1,
                to: o.to
              }, Io(o == null ? void 0 : o.on)), {
                default: Q2(() => [
                  J2(t.$slots, "icon", { slotProps: o }, () => [
                    C("span", {
                      class: "dynamic-navigator__link-icon",
                      innerHTML: o.icon
                    }, null, 8, BU1)
                  ], !0),
                  J2(t.$slots, "label", { slotProps: o }, () => [
                    C("span", VU1, pt(o.label), 1)
                  ], !0)
                ]),
                _: 2
              }, 1040, ["to"])) : (T(), N("a", Ht({
                href: (o == null ? void 0 : o.to) ?? "javascript:void(0)",
                role: "tab",
                key: h,
                class: ["dynamic-navigator__link", { current: o.current }],
                onClick: (u) => t.itemClick(u, o)
              }, Io(o == null ? void 0 : o.on, !0)), [
                J2(t.$slots, "icon", { slotProps: o }, () => [
                  C("span", {
                    class: "dynamic-navigator__link-icon",
                    innerHTML: o.icon
                  }, null, 8, HU1)
                ], !0),
                J2(t.$slots, "label", { slotProps: o }, () => [
                  C("span", DU1, pt(o.label), 1)
                ], !0)
              ], 16, RU1))
            ]))), 128))
          ], 512)
        ]),
        t.name ? (T(), N("div", $U1, [
          C("span", null, pt(t.name), 1)
        ], 512)) : m2("", !0)
      ], 4)
    ], 6),
    UU1
  ], 8, ["to", "disabled"]);
}
const gj1 = /* @__PURE__ */ Le(IU1, [["render", jU1], ["__scopeId", "data-v-3e5117ec"]]);
window.$jclPlugin = { version: rL };
const yj1 = {
  install(t, e) {
    t.config.globalProperties.$jclPlugin = {
      version: rL
    }, t.config.globalProperties.$filters = {
      truncate: tp1,
      decodeString: w6
    }, t.use(JA), t.use(ep1), t.use(Qf1, e == null ? void 0 : e.ecl);
  }
};
export {
  gD1 as $,
  yk1 as A,
  _T1 as B,
  rb as C,
  Fo as D,
  zA as E,
  LT1 as F,
  xT1 as G,
  hA as H,
  ww as I,
  yj1 as J,
  bP1 as K,
  $b as L,
  e9 as M,
  mj1 as N,
  vj1 as O,
  GD1 as P,
  XH1 as Q,
  xw as R,
  nD1 as S,
  ZH1 as T,
  eD1 as U,
  aD1 as V,
  lD1 as W,
  fD1 as X,
  uD1 as Y,
  _D1 as Z,
  Ye as _,
  Vu as a,
  LD1 as a0,
  MD1 as a1,
  AD1 as a2,
  kD1 as a3,
  BD1 as a4,
  ND1 as a5,
  $D1 as a6,
  HD1 as a7,
  QD1 as a8,
  ZD1 as a9,
  Kx as aA,
  s$1 as aa,
  n$1 as ab,
  f$1 as ac,
  u$1 as ad,
  y$1 as ae,
  m$1 as af,
  cU1 as ag,
  aU1 as ah,
  wU1 as ai,
  _U1 as aj,
  kU1 as ak,
  SU1 as al,
  gj1 as am,
  JU1 as an,
  QU1 as ao,
  ej1 as ap,
  I_ as aq,
  w6 as ar,
  tj1 as as,
  nj1 as at,
  ij1 as au,
  sj1 as av,
  lj1 as aw,
  rj1 as ax,
  aj1 as ay,
  tp1 as az,
  oj1 as b,
  N5 as c,
  mS as d,
  Ok as e,
  dj1 as f,
  Pu as g,
  cC1 as h,
  hC1 as i,
  ac as j,
  fj1 as k,
  uC1 as l,
  ck1 as m,
  pj1 as n,
  Mu as o,
  wR1 as p,
  BR1 as q,
  MA as r,
  rH1 as s,
  vH1 as t,
  zH1 as u,
  eE as v,
  pk1 as w,
  mk1 as x,
  Ja as y,
  gk1 as z
};
